
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree8ef"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree8ef"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lKnNn", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $fd505a23984a6132$export$ffb0004e005737fa; }, function (v) { return $fd505a23984a6132$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $fd505a23984a6132$export$34b9dba7ce09269b; }, function (v) { return $fd505a23984a6132$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $fd505a23984a6132$export$25062201e9e25d76; }, function (v) { return $fd505a23984a6132$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fd505a23984a6132$export$ffb0004e005737fa;
var $fd505a23984a6132$export$34b9dba7ce09269b;
var $fd505a23984a6132$export$25062201e9e25d76;
'use strict';

var $7UyaH = parcelRequire("7UyaH");
var $fd505a23984a6132$var$k = Symbol.for("react.element"), $fd505a23984a6132$var$l = Symbol.for("react.fragment"), $fd505a23984a6132$var$m = Object.prototype.hasOwnProperty, $fd505a23984a6132$var$n = $7UyaH.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $fd505a23984a6132$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $fd505a23984a6132$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$fd505a23984a6132$var$m.call(a, b) && !$fd505a23984a6132$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $fd505a23984a6132$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $fd505a23984a6132$var$n.current
    };
}
$fd505a23984a6132$export$ffb0004e005737fa = $fd505a23984a6132$var$l;
$fd505a23984a6132$export$34b9dba7ce09269b = $fd505a23984a6132$var$q;
$fd505a23984a6132$export$25062201e9e25d76 = $fd505a23984a6132$var$q;

});
parcelRegister("7UyaH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("l7rRQ"));

});
parcelRegister("l7rRQ", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $f5ffde4d77a8840b$export$dca3b0875bd9a954; }, function (v) { return $f5ffde4d77a8840b$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $f5ffde4d77a8840b$export$16fa2f45be04daa8; }, function (v) { return $f5ffde4d77a8840b$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $f5ffde4d77a8840b$export$ffb0004e005737fa; }, function (v) { return $f5ffde4d77a8840b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $f5ffde4d77a8840b$export$e2c29f18771995cb; }, function (v) { return $f5ffde4d77a8840b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $f5ffde4d77a8840b$export$221d75b3f55bb0bd; }, function (v) { return $f5ffde4d77a8840b$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f5ffde4d77a8840b$export$5f8d39834fd61797; }, function (v) { return $f5ffde4d77a8840b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $f5ffde4d77a8840b$export$74bf444e3cd11ea5; }, function (v) { return $f5ffde4d77a8840b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $f5ffde4d77a8840b$export$ae55be85d98224ed; }, function (v) { return $f5ffde4d77a8840b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $f5ffde4d77a8840b$export$3ba232387fd5d6dd; }, function (v) { return $f5ffde4d77a8840b$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $f5ffde4d77a8840b$export$e530037191fcd5d7; }, function (v) { return $f5ffde4d77a8840b$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $f5ffde4d77a8840b$export$fd42f52fd3ae1109; }, function (v) { return $f5ffde4d77a8840b$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $f5ffde4d77a8840b$export$c8a8987d4410bf2d; }, function (v) { return $f5ffde4d77a8840b$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $f5ffde4d77a8840b$export$d38cd72104c1f0e9; }, function (v) { return $f5ffde4d77a8840b$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $f5ffde4d77a8840b$export$7d1e3a5e95ceca43; }, function (v) { return $f5ffde4d77a8840b$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $f5ffde4d77a8840b$export$257a8862b851cb5b; }, function (v) { return $f5ffde4d77a8840b$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $f5ffde4d77a8840b$export$a8257692ac88316c; }, function (v) { return $f5ffde4d77a8840b$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $f5ffde4d77a8840b$export$488013bae63b21da; }, function (v) { return $f5ffde4d77a8840b$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $f5ffde4d77a8840b$export$7c73462e0d25e514; }, function (v) { return $f5ffde4d77a8840b$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $f5ffde4d77a8840b$export$7568632d0d33d16d; }, function (v) { return $f5ffde4d77a8840b$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $f5ffde4d77a8840b$export$88948ce120ea2619; }, function (v) { return $f5ffde4d77a8840b$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $f5ffde4d77a8840b$export$35808ee640e87ca7; }, function (v) { return $f5ffde4d77a8840b$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $f5ffde4d77a8840b$export$fae74005e78b1a27; }, function (v) { return $f5ffde4d77a8840b$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $f5ffde4d77a8840b$export$dc8fbce3eb94dc1e; }, function (v) { return $f5ffde4d77a8840b$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $f5ffde4d77a8840b$export$6a7bc4e911dc01cf; }, function (v) { return $f5ffde4d77a8840b$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $f5ffde4d77a8840b$export$6d9c69b0de29b591; }, function (v) { return $f5ffde4d77a8840b$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $f5ffde4d77a8840b$export$f680877a34711e37; }, function (v) { return $f5ffde4d77a8840b$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $f5ffde4d77a8840b$export$d5a552a76deda3c2; }, function (v) { return $f5ffde4d77a8840b$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $f5ffde4d77a8840b$export$aaabe4eda9ed9969; }, function (v) { return $f5ffde4d77a8840b$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $f5ffde4d77a8840b$export$e5c5a5f917a5871c; }, function (v) { return $f5ffde4d77a8840b$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $f5ffde4d77a8840b$export$1538c33de8887b59; }, function (v) { return $f5ffde4d77a8840b$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $f5ffde4d77a8840b$export$13e3392192263954; }, function (v) { return $f5ffde4d77a8840b$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $f5ffde4d77a8840b$export$b8f5890fc79d6aca; }, function (v) { return $f5ffde4d77a8840b$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $f5ffde4d77a8840b$export$60241385465d0a34; }, function (v) { return $f5ffde4d77a8840b$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $f5ffde4d77a8840b$export$306c0aa65ff9ec16; }, function (v) { return $f5ffde4d77a8840b$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $f5ffde4d77a8840b$export$7b286972b8d8ccbf; }, function (v) { return $f5ffde4d77a8840b$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $f5ffde4d77a8840b$export$83d89fbfd8236492; }, function (v) { return $f5ffde4d77a8840b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f5ffde4d77a8840b$export$dca3b0875bd9a954;
var $f5ffde4d77a8840b$export$16fa2f45be04daa8;
var $f5ffde4d77a8840b$export$ffb0004e005737fa;
var $f5ffde4d77a8840b$export$e2c29f18771995cb;
var $f5ffde4d77a8840b$export$221d75b3f55bb0bd;
var $f5ffde4d77a8840b$export$5f8d39834fd61797;
var $f5ffde4d77a8840b$export$74bf444e3cd11ea5;
var $f5ffde4d77a8840b$export$ae55be85d98224ed;
var $f5ffde4d77a8840b$export$3ba232387fd5d6dd;
var $f5ffde4d77a8840b$export$e530037191fcd5d7;
var $f5ffde4d77a8840b$export$fd42f52fd3ae1109;
var $f5ffde4d77a8840b$export$c8a8987d4410bf2d;
var $f5ffde4d77a8840b$export$d38cd72104c1f0e9;
var $f5ffde4d77a8840b$export$7d1e3a5e95ceca43;
var $f5ffde4d77a8840b$export$257a8862b851cb5b;
var $f5ffde4d77a8840b$export$a8257692ac88316c;
var $f5ffde4d77a8840b$export$488013bae63b21da;
var $f5ffde4d77a8840b$export$7c73462e0d25e514;
var $f5ffde4d77a8840b$export$7568632d0d33d16d;
var $f5ffde4d77a8840b$export$88948ce120ea2619;
var $f5ffde4d77a8840b$export$35808ee640e87ca7;
var $f5ffde4d77a8840b$export$fae74005e78b1a27;
var $f5ffde4d77a8840b$export$dc8fbce3eb94dc1e;
var $f5ffde4d77a8840b$export$6a7bc4e911dc01cf;
var $f5ffde4d77a8840b$export$6d9c69b0de29b591;
var $f5ffde4d77a8840b$export$f680877a34711e37;
var $f5ffde4d77a8840b$export$d5a552a76deda3c2;
var $f5ffde4d77a8840b$export$aaabe4eda9ed9969;
var $f5ffde4d77a8840b$export$e5c5a5f917a5871c;
var $f5ffde4d77a8840b$export$1538c33de8887b59;
var $f5ffde4d77a8840b$export$13e3392192263954;
var $f5ffde4d77a8840b$export$b8f5890fc79d6aca;
var $f5ffde4d77a8840b$export$60241385465d0a34;
var $f5ffde4d77a8840b$export$306c0aa65ff9ec16;
var $f5ffde4d77a8840b$export$7b286972b8d8ccbf;
var $f5ffde4d77a8840b$export$83d89fbfd8236492;
'use strict';
var $f5ffde4d77a8840b$var$l = Symbol.for("react.element"), $f5ffde4d77a8840b$var$n = Symbol.for("react.portal"), $f5ffde4d77a8840b$var$p = Symbol.for("react.fragment"), $f5ffde4d77a8840b$var$q = Symbol.for("react.strict_mode"), $f5ffde4d77a8840b$var$r = Symbol.for("react.profiler"), $f5ffde4d77a8840b$var$t = Symbol.for("react.provider"), $f5ffde4d77a8840b$var$u = Symbol.for("react.context"), $f5ffde4d77a8840b$var$v = Symbol.for("react.forward_ref"), $f5ffde4d77a8840b$var$w = Symbol.for("react.suspense"), $f5ffde4d77a8840b$var$x = Symbol.for("react.memo"), $f5ffde4d77a8840b$var$y = Symbol.for("react.lazy"), $f5ffde4d77a8840b$var$z = Symbol.iterator;
function $f5ffde4d77a8840b$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f5ffde4d77a8840b$var$z && a[$f5ffde4d77a8840b$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f5ffde4d77a8840b$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $f5ffde4d77a8840b$var$C = Object.assign, $f5ffde4d77a8840b$var$D = {};
function $f5ffde4d77a8840b$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $f5ffde4d77a8840b$var$D;
    this.updater = e || $f5ffde4d77a8840b$var$B;
}
$f5ffde4d77a8840b$var$E.prototype.isReactComponent = {};
$f5ffde4d77a8840b$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$f5ffde4d77a8840b$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $f5ffde4d77a8840b$var$F() {}
$f5ffde4d77a8840b$var$F.prototype = $f5ffde4d77a8840b$var$E.prototype;
function $f5ffde4d77a8840b$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $f5ffde4d77a8840b$var$D;
    this.updater = e || $f5ffde4d77a8840b$var$B;
}
var $f5ffde4d77a8840b$var$H = $f5ffde4d77a8840b$var$G.prototype = new $f5ffde4d77a8840b$var$F;
$f5ffde4d77a8840b$var$H.constructor = $f5ffde4d77a8840b$var$G;
$f5ffde4d77a8840b$var$C($f5ffde4d77a8840b$var$H, $f5ffde4d77a8840b$var$E.prototype);
$f5ffde4d77a8840b$var$H.isPureReactComponent = !0;
var $f5ffde4d77a8840b$var$I = Array.isArray, $f5ffde4d77a8840b$var$J = Object.prototype.hasOwnProperty, $f5ffde4d77a8840b$var$K = {
    current: null
}, $f5ffde4d77a8840b$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $f5ffde4d77a8840b$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$f5ffde4d77a8840b$var$J.call(b, d) && !$f5ffde4d77a8840b$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $f5ffde4d77a8840b$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $f5ffde4d77a8840b$var$K.current
    };
}
function $f5ffde4d77a8840b$var$N(a, b) {
    return {
        $$typeof: $f5ffde4d77a8840b$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $f5ffde4d77a8840b$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f5ffde4d77a8840b$var$l;
}
function $f5ffde4d77a8840b$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $f5ffde4d77a8840b$var$P = /\/+/g;
function $f5ffde4d77a8840b$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $f5ffde4d77a8840b$var$escape("" + a.key) : b.toString(36);
}
function $f5ffde4d77a8840b$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $f5ffde4d77a8840b$var$l:
                case $f5ffde4d77a8840b$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $f5ffde4d77a8840b$var$Q(h, 0) : d, $f5ffde4d77a8840b$var$I(c) ? (e = "", null != a && (e = a.replace($f5ffde4d77a8840b$var$P, "$&/") + "/"), $f5ffde4d77a8840b$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($f5ffde4d77a8840b$var$O(c) && (c = $f5ffde4d77a8840b$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($f5ffde4d77a8840b$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($f5ffde4d77a8840b$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $f5ffde4d77a8840b$var$Q(k, g);
        h += $f5ffde4d77a8840b$var$R(k, b, e, f, c);
    }
    else if (f = $f5ffde4d77a8840b$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $f5ffde4d77a8840b$var$Q(k, g++), h += $f5ffde4d77a8840b$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $f5ffde4d77a8840b$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $f5ffde4d77a8840b$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $f5ffde4d77a8840b$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $f5ffde4d77a8840b$var$U = {
    current: null
}, $f5ffde4d77a8840b$var$V = {
    transition: null
}, $f5ffde4d77a8840b$var$W = {
    ReactCurrentDispatcher: $f5ffde4d77a8840b$var$U,
    ReactCurrentBatchConfig: $f5ffde4d77a8840b$var$V,
    ReactCurrentOwner: $f5ffde4d77a8840b$var$K
};
function $f5ffde4d77a8840b$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$f5ffde4d77a8840b$export$dca3b0875bd9a954 = {
    map: $f5ffde4d77a8840b$var$S,
    forEach: function(a, b, e) {
        $f5ffde4d77a8840b$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $f5ffde4d77a8840b$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $f5ffde4d77a8840b$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$f5ffde4d77a8840b$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$f5ffde4d77a8840b$export$16fa2f45be04daa8 = $f5ffde4d77a8840b$var$E;
$f5ffde4d77a8840b$export$ffb0004e005737fa = $f5ffde4d77a8840b$var$p;
$f5ffde4d77a8840b$export$e2c29f18771995cb = $f5ffde4d77a8840b$var$r;
$f5ffde4d77a8840b$export$221d75b3f55bb0bd = $f5ffde4d77a8840b$var$G;
$f5ffde4d77a8840b$export$5f8d39834fd61797 = $f5ffde4d77a8840b$var$q;
$f5ffde4d77a8840b$export$74bf444e3cd11ea5 = $f5ffde4d77a8840b$var$w;
$f5ffde4d77a8840b$export$ae55be85d98224ed = $f5ffde4d77a8840b$var$W;
$f5ffde4d77a8840b$export$3ba232387fd5d6dd = $f5ffde4d77a8840b$var$X;
$f5ffde4d77a8840b$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $f5ffde4d77a8840b$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $f5ffde4d77a8840b$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$f5ffde4d77a8840b$var$J.call(b, f) && !$f5ffde4d77a8840b$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $f5ffde4d77a8840b$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$f5ffde4d77a8840b$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $f5ffde4d77a8840b$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $f5ffde4d77a8840b$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$f5ffde4d77a8840b$export$c8a8987d4410bf2d = $f5ffde4d77a8840b$var$M;
$f5ffde4d77a8840b$export$d38cd72104c1f0e9 = function(a) {
    var b = $f5ffde4d77a8840b$var$M.bind(null, a);
    b.type = a;
    return b;
};
$f5ffde4d77a8840b$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$f5ffde4d77a8840b$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $f5ffde4d77a8840b$var$v,
        render: a
    };
};
$f5ffde4d77a8840b$export$a8257692ac88316c = $f5ffde4d77a8840b$var$O;
$f5ffde4d77a8840b$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $f5ffde4d77a8840b$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $f5ffde4d77a8840b$var$T
    };
};
$f5ffde4d77a8840b$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $f5ffde4d77a8840b$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$f5ffde4d77a8840b$export$7568632d0d33d16d = function(a) {
    var b = $f5ffde4d77a8840b$var$V.transition;
    $f5ffde4d77a8840b$var$V.transition = {};
    try {
        a();
    } finally{
        $f5ffde4d77a8840b$var$V.transition = b;
    }
};
$f5ffde4d77a8840b$export$88948ce120ea2619 = $f5ffde4d77a8840b$var$X;
$f5ffde4d77a8840b$export$35808ee640e87ca7 = function(a, b) {
    return $f5ffde4d77a8840b$var$U.current.useCallback(a, b);
};
$f5ffde4d77a8840b$export$fae74005e78b1a27 = function(a) {
    return $f5ffde4d77a8840b$var$U.current.useContext(a);
};
$f5ffde4d77a8840b$export$dc8fbce3eb94dc1e = function() {};
$f5ffde4d77a8840b$export$6a7bc4e911dc01cf = function(a) {
    return $f5ffde4d77a8840b$var$U.current.useDeferredValue(a);
};
$f5ffde4d77a8840b$export$6d9c69b0de29b591 = function(a, b) {
    return $f5ffde4d77a8840b$var$U.current.useEffect(a, b);
};
$f5ffde4d77a8840b$export$f680877a34711e37 = function() {
    return $f5ffde4d77a8840b$var$U.current.useId();
};
$f5ffde4d77a8840b$export$d5a552a76deda3c2 = function(a, b, e) {
    return $f5ffde4d77a8840b$var$U.current.useImperativeHandle(a, b, e);
};
$f5ffde4d77a8840b$export$aaabe4eda9ed9969 = function(a, b) {
    return $f5ffde4d77a8840b$var$U.current.useInsertionEffect(a, b);
};
$f5ffde4d77a8840b$export$e5c5a5f917a5871c = function(a, b) {
    return $f5ffde4d77a8840b$var$U.current.useLayoutEffect(a, b);
};
$f5ffde4d77a8840b$export$1538c33de8887b59 = function(a, b) {
    return $f5ffde4d77a8840b$var$U.current.useMemo(a, b);
};
$f5ffde4d77a8840b$export$13e3392192263954 = function(a, b, e) {
    return $f5ffde4d77a8840b$var$U.current.useReducer(a, b, e);
};
$f5ffde4d77a8840b$export$b8f5890fc79d6aca = function(a) {
    return $f5ffde4d77a8840b$var$U.current.useRef(a);
};
$f5ffde4d77a8840b$export$60241385465d0a34 = function(a) {
    return $f5ffde4d77a8840b$var$U.current.useState(a);
};
$f5ffde4d77a8840b$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $f5ffde4d77a8840b$var$U.current.useSyncExternalStore(a, b, e);
};
$f5ffde4d77a8840b$export$7b286972b8d8ccbf = function() {
    return $f5ffde4d77a8840b$var$U.current.useTransition();
};
$f5ffde4d77a8840b$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("jUQRJ", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e7fc41517b66781c$export$ae55be85d98224ed; }, function (v) { return $e7fc41517b66781c$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $e7fc41517b66781c$export$d39a5bbd09211389; }, function (v) { return $e7fc41517b66781c$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $e7fc41517b66781c$export$882461b6382ed46c; }, function (v) { return $e7fc41517b66781c$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $e7fc41517b66781c$export$466bfc07425424d5; }, function (v) { return $e7fc41517b66781c$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $e7fc41517b66781c$export$cd75ccfd720a3cd4; }, function (v) { return $e7fc41517b66781c$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $e7fc41517b66781c$export$fa8d919ba61d84db; }, function (v) { return $e7fc41517b66781c$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e7fc41517b66781c$export$757ceba2d55c277e; }, function (v) { return $e7fc41517b66781c$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $e7fc41517b66781c$export$b3890eb0ae9dca99; }, function (v) { return $e7fc41517b66781c$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $e7fc41517b66781c$export$502457920280e6be; }, function (v) { return $e7fc41517b66781c$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $e7fc41517b66781c$export$c78a37762a8d58e1; }, function (v) { return $e7fc41517b66781c$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $e7fc41517b66781c$export$dc54d992c10e8a18; }, function (v) { return $e7fc41517b66781c$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $e7fc41517b66781c$export$83d89fbfd8236492; }, function (v) { return $e7fc41517b66781c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e7fc41517b66781c$export$ae55be85d98224ed;
var $e7fc41517b66781c$export$d39a5bbd09211389;
var $e7fc41517b66781c$export$882461b6382ed46c;
var $e7fc41517b66781c$export$466bfc07425424d5;
var $e7fc41517b66781c$export$cd75ccfd720a3cd4;
var $e7fc41517b66781c$export$fa8d919ba61d84db;
var $e7fc41517b66781c$export$757ceba2d55c277e;
var $e7fc41517b66781c$export$b3890eb0ae9dca99;
var $e7fc41517b66781c$export$502457920280e6be;
var $e7fc41517b66781c$export$c78a37762a8d58e1;
var $e7fc41517b66781c$export$dc54d992c10e8a18;
var $e7fc41517b66781c$export$83d89fbfd8236492;
'use strict';

var $7UyaH = parcelRequire("7UyaH");

var $HuxiW = parcelRequire("HuxiW");
function $e7fc41517b66781c$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e7fc41517b66781c$var$da = new Set, $e7fc41517b66781c$var$ea = {};
function $e7fc41517b66781c$var$fa(a, b) {
    $e7fc41517b66781c$var$ha(a, b);
    $e7fc41517b66781c$var$ha(a + "Capture", b);
}
function $e7fc41517b66781c$var$ha(a, b) {
    $e7fc41517b66781c$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e7fc41517b66781c$var$da.add(b[a]);
}
var $e7fc41517b66781c$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e7fc41517b66781c$var$ja = Object.prototype.hasOwnProperty, $e7fc41517b66781c$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e7fc41517b66781c$var$la = {}, $e7fc41517b66781c$var$ma = {};
function $e7fc41517b66781c$var$oa(a) {
    if ($e7fc41517b66781c$var$ja.call($e7fc41517b66781c$var$ma, a)) return !0;
    if ($e7fc41517b66781c$var$ja.call($e7fc41517b66781c$var$la, a)) return !1;
    if ($e7fc41517b66781c$var$ka.test(a)) return $e7fc41517b66781c$var$ma[a] = !0;
    $e7fc41517b66781c$var$la[a] = !0;
    return !1;
}
function $e7fc41517b66781c$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e7fc41517b66781c$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e7fc41517b66781c$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e7fc41517b66781c$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e7fc41517b66781c$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e7fc41517b66781c$var$z[a] = new $e7fc41517b66781c$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e7fc41517b66781c$var$z[b] = new $e7fc41517b66781c$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e7fc41517b66781c$var$z[a] = new $e7fc41517b66781c$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e7fc41517b66781c$var$z[a] = new $e7fc41517b66781c$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e7fc41517b66781c$var$z[a] = new $e7fc41517b66781c$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e7fc41517b66781c$var$z[a] = new $e7fc41517b66781c$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e7fc41517b66781c$var$z[a] = new $e7fc41517b66781c$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e7fc41517b66781c$var$z[a] = new $e7fc41517b66781c$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e7fc41517b66781c$var$z[a] = new $e7fc41517b66781c$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e7fc41517b66781c$var$ra = /[\-:]([a-z])/g;
function $e7fc41517b66781c$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e7fc41517b66781c$var$ra, $e7fc41517b66781c$var$sa);
    $e7fc41517b66781c$var$z[b] = new $e7fc41517b66781c$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e7fc41517b66781c$var$ra, $e7fc41517b66781c$var$sa);
    $e7fc41517b66781c$var$z[b] = new $e7fc41517b66781c$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e7fc41517b66781c$var$ra, $e7fc41517b66781c$var$sa);
    $e7fc41517b66781c$var$z[b] = new $e7fc41517b66781c$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e7fc41517b66781c$var$z[a] = new $e7fc41517b66781c$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e7fc41517b66781c$var$z.xlinkHref = new $e7fc41517b66781c$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e7fc41517b66781c$var$z[a] = new $e7fc41517b66781c$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e7fc41517b66781c$var$ta(a, b, c, d) {
    var e = $e7fc41517b66781c$var$z.hasOwnProperty(b) ? $e7fc41517b66781c$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e7fc41517b66781c$var$qa(b, c, e, d) && (c = null), d || null === e ? $e7fc41517b66781c$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e7fc41517b66781c$var$ua = $7UyaH.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e7fc41517b66781c$var$va = Symbol.for("react.element"), $e7fc41517b66781c$var$wa = Symbol.for("react.portal"), $e7fc41517b66781c$var$ya = Symbol.for("react.fragment"), $e7fc41517b66781c$var$za = Symbol.for("react.strict_mode"), $e7fc41517b66781c$var$Aa = Symbol.for("react.profiler"), $e7fc41517b66781c$var$Ba = Symbol.for("react.provider"), $e7fc41517b66781c$var$Ca = Symbol.for("react.context"), $e7fc41517b66781c$var$Da = Symbol.for("react.forward_ref"), $e7fc41517b66781c$var$Ea = Symbol.for("react.suspense"), $e7fc41517b66781c$var$Fa = Symbol.for("react.suspense_list"), $e7fc41517b66781c$var$Ga = Symbol.for("react.memo"), $e7fc41517b66781c$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e7fc41517b66781c$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e7fc41517b66781c$var$Ja = Symbol.iterator;
function $e7fc41517b66781c$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e7fc41517b66781c$var$Ja && a[$e7fc41517b66781c$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e7fc41517b66781c$var$A = Object.assign, $e7fc41517b66781c$var$La;
function $e7fc41517b66781c$var$Ma(a) {
    if (void 0 === $e7fc41517b66781c$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e7fc41517b66781c$var$La = b && b[1] || "";
    }
    return "\n" + $e7fc41517b66781c$var$La + a;
}
var $e7fc41517b66781c$var$Na = !1;
function $e7fc41517b66781c$var$Oa(a, b) {
    if (!a || $e7fc41517b66781c$var$Na) return "";
    $e7fc41517b66781c$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e7fc41517b66781c$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e7fc41517b66781c$var$Ma(a) : "";
}
function $e7fc41517b66781c$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e7fc41517b66781c$var$Ma(a.type);
        case 16:
            return $e7fc41517b66781c$var$Ma("Lazy");
        case 13:
            return $e7fc41517b66781c$var$Ma("Suspense");
        case 19:
            return $e7fc41517b66781c$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e7fc41517b66781c$var$Oa(a.type, !1), a;
        case 11:
            return a = $e7fc41517b66781c$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e7fc41517b66781c$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e7fc41517b66781c$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e7fc41517b66781c$var$ya:
            return "Fragment";
        case $e7fc41517b66781c$var$wa:
            return "Portal";
        case $e7fc41517b66781c$var$Aa:
            return "Profiler";
        case $e7fc41517b66781c$var$za:
            return "StrictMode";
        case $e7fc41517b66781c$var$Ea:
            return "Suspense";
        case $e7fc41517b66781c$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e7fc41517b66781c$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e7fc41517b66781c$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e7fc41517b66781c$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e7fc41517b66781c$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e7fc41517b66781c$var$Qa(a.type) || "Memo";
        case $e7fc41517b66781c$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e7fc41517b66781c$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e7fc41517b66781c$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e7fc41517b66781c$var$Qa(b);
        case 8:
            return b === $e7fc41517b66781c$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e7fc41517b66781c$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e7fc41517b66781c$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e7fc41517b66781c$var$Ua(a) {
    var b = $e7fc41517b66781c$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e7fc41517b66781c$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e7fc41517b66781c$var$Ua(a));
}
function $e7fc41517b66781c$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e7fc41517b66781c$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e7fc41517b66781c$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e7fc41517b66781c$var$Ya(a, b) {
    var c = b.checked;
    return $e7fc41517b66781c$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e7fc41517b66781c$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e7fc41517b66781c$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e7fc41517b66781c$var$ab(a, b) {
    b = b.checked;
    null != b && $e7fc41517b66781c$var$ta(a, "checked", b, !1);
}
function $e7fc41517b66781c$var$bb(a, b) {
    $e7fc41517b66781c$var$ab(a, b);
    var c = $e7fc41517b66781c$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e7fc41517b66781c$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e7fc41517b66781c$var$cb(a, b.type, $e7fc41517b66781c$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e7fc41517b66781c$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e7fc41517b66781c$var$cb(a, b, c) {
    if ("number" !== b || $e7fc41517b66781c$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e7fc41517b66781c$var$eb = Array.isArray;
function $e7fc41517b66781c$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e7fc41517b66781c$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e7fc41517b66781c$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e7fc41517b66781c$var$p(91));
    return $e7fc41517b66781c$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e7fc41517b66781c$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e7fc41517b66781c$var$p(92));
            if ($e7fc41517b66781c$var$eb(c)) {
                if (1 < c.length) throw Error($e7fc41517b66781c$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e7fc41517b66781c$var$Sa(c)
    };
}
function $e7fc41517b66781c$var$ib(a, b) {
    var c = $e7fc41517b66781c$var$Sa(b.value), d = $e7fc41517b66781c$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e7fc41517b66781c$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e7fc41517b66781c$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e7fc41517b66781c$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e7fc41517b66781c$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e7fc41517b66781c$var$mb, $e7fc41517b66781c$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e7fc41517b66781c$var$mb = $e7fc41517b66781c$var$mb || document.createElement("div");
        $e7fc41517b66781c$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e7fc41517b66781c$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e7fc41517b66781c$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e7fc41517b66781c$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e7fc41517b66781c$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e7fc41517b66781c$var$pb).forEach(function(a) {
    $e7fc41517b66781c$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e7fc41517b66781c$var$pb[b] = $e7fc41517b66781c$var$pb[a];
    });
});
function $e7fc41517b66781c$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e7fc41517b66781c$var$pb.hasOwnProperty(a) && $e7fc41517b66781c$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e7fc41517b66781c$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e7fc41517b66781c$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e7fc41517b66781c$var$tb = $e7fc41517b66781c$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e7fc41517b66781c$var$ub(a, b) {
    if (b) {
        if ($e7fc41517b66781c$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e7fc41517b66781c$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e7fc41517b66781c$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e7fc41517b66781c$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e7fc41517b66781c$var$p(62));
    }
}
function $e7fc41517b66781c$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e7fc41517b66781c$var$wb = null;
function $e7fc41517b66781c$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e7fc41517b66781c$var$yb = null, $e7fc41517b66781c$var$zb = null, $e7fc41517b66781c$var$Ab = null;
function $e7fc41517b66781c$var$Bb(a) {
    if (a = $e7fc41517b66781c$var$Cb(a)) {
        if ("function" !== typeof $e7fc41517b66781c$var$yb) throw Error($e7fc41517b66781c$var$p(280));
        var b = a.stateNode;
        b && (b = $e7fc41517b66781c$var$Db(b), $e7fc41517b66781c$var$yb(a.stateNode, a.type, b));
    }
}
function $e7fc41517b66781c$var$Eb(a) {
    $e7fc41517b66781c$var$zb ? $e7fc41517b66781c$var$Ab ? $e7fc41517b66781c$var$Ab.push(a) : $e7fc41517b66781c$var$Ab = [
        a
    ] : $e7fc41517b66781c$var$zb = a;
}
function $e7fc41517b66781c$var$Fb() {
    if ($e7fc41517b66781c$var$zb) {
        var a = $e7fc41517b66781c$var$zb, b = $e7fc41517b66781c$var$Ab;
        $e7fc41517b66781c$var$Ab = $e7fc41517b66781c$var$zb = null;
        $e7fc41517b66781c$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e7fc41517b66781c$var$Bb(b[a]);
    }
}
function $e7fc41517b66781c$var$Gb(a, b) {
    return a(b);
}
function $e7fc41517b66781c$var$Hb() {}
var $e7fc41517b66781c$var$Ib = !1;
function $e7fc41517b66781c$var$Jb(a, b, c) {
    if ($e7fc41517b66781c$var$Ib) return a(b, c);
    $e7fc41517b66781c$var$Ib = !0;
    try {
        return $e7fc41517b66781c$var$Gb(a, b, c);
    } finally{
        if ($e7fc41517b66781c$var$Ib = !1, null !== $e7fc41517b66781c$var$zb || null !== $e7fc41517b66781c$var$Ab) $e7fc41517b66781c$var$Hb(), $e7fc41517b66781c$var$Fb();
    }
}
function $e7fc41517b66781c$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e7fc41517b66781c$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e7fc41517b66781c$var$p(231, b, typeof c));
    return c;
}
var $e7fc41517b66781c$var$Lb = !1;
if ($e7fc41517b66781c$var$ia) try {
    var $e7fc41517b66781c$var$Mb = {};
    Object.defineProperty($e7fc41517b66781c$var$Mb, "passive", {
        get: function() {
            $e7fc41517b66781c$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e7fc41517b66781c$var$Mb, $e7fc41517b66781c$var$Mb);
    window.removeEventListener("test", $e7fc41517b66781c$var$Mb, $e7fc41517b66781c$var$Mb);
} catch (a) {
    $e7fc41517b66781c$var$Lb = !1;
}
function $e7fc41517b66781c$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e7fc41517b66781c$var$Ob = !1, $e7fc41517b66781c$var$Pb = null, $e7fc41517b66781c$var$Qb = !1, $e7fc41517b66781c$var$Rb = null, $e7fc41517b66781c$var$Sb = {
    onError: function(a) {
        $e7fc41517b66781c$var$Ob = !0;
        $e7fc41517b66781c$var$Pb = a;
    }
};
function $e7fc41517b66781c$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e7fc41517b66781c$var$Ob = !1;
    $e7fc41517b66781c$var$Pb = null;
    $e7fc41517b66781c$var$Nb.apply($e7fc41517b66781c$var$Sb, arguments);
}
function $e7fc41517b66781c$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e7fc41517b66781c$var$Tb.apply(this, arguments);
    if ($e7fc41517b66781c$var$Ob) {
        if ($e7fc41517b66781c$var$Ob) {
            var l = $e7fc41517b66781c$var$Pb;
            $e7fc41517b66781c$var$Ob = !1;
            $e7fc41517b66781c$var$Pb = null;
        } else throw Error($e7fc41517b66781c$var$p(198));
        $e7fc41517b66781c$var$Qb || ($e7fc41517b66781c$var$Qb = !0, $e7fc41517b66781c$var$Rb = l);
    }
}
function $e7fc41517b66781c$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e7fc41517b66781c$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e7fc41517b66781c$var$Xb(a) {
    if ($e7fc41517b66781c$var$Vb(a) !== a) throw Error($e7fc41517b66781c$var$p(188));
}
function $e7fc41517b66781c$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e7fc41517b66781c$var$Vb(a);
        if (null === b) throw Error($e7fc41517b66781c$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e7fc41517b66781c$var$Xb(e), a;
                if (f === d) return $e7fc41517b66781c$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e7fc41517b66781c$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e7fc41517b66781c$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e7fc41517b66781c$var$p(190));
    }
    if (3 !== c.tag) throw Error($e7fc41517b66781c$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e7fc41517b66781c$var$Zb(a) {
    a = $e7fc41517b66781c$var$Yb(a);
    return null !== a ? $e7fc41517b66781c$var$$b(a) : null;
}
function $e7fc41517b66781c$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e7fc41517b66781c$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e7fc41517b66781c$var$ac = $HuxiW.unstable_scheduleCallback, $e7fc41517b66781c$var$bc = $HuxiW.unstable_cancelCallback, $e7fc41517b66781c$var$cc = $HuxiW.unstable_shouldYield, $e7fc41517b66781c$var$dc = $HuxiW.unstable_requestPaint, $e7fc41517b66781c$var$B = $HuxiW.unstable_now, $e7fc41517b66781c$var$ec = $HuxiW.unstable_getCurrentPriorityLevel, $e7fc41517b66781c$var$fc = $HuxiW.unstable_ImmediatePriority, $e7fc41517b66781c$var$gc = $HuxiW.unstable_UserBlockingPriority, $e7fc41517b66781c$var$hc = $HuxiW.unstable_NormalPriority, $e7fc41517b66781c$var$ic = $HuxiW.unstable_LowPriority, $e7fc41517b66781c$var$jc = $HuxiW.unstable_IdlePriority, $e7fc41517b66781c$var$kc = null, $e7fc41517b66781c$var$lc = null;
function $e7fc41517b66781c$var$mc(a) {
    if ($e7fc41517b66781c$var$lc && "function" === typeof $e7fc41517b66781c$var$lc.onCommitFiberRoot) try {
        $e7fc41517b66781c$var$lc.onCommitFiberRoot($e7fc41517b66781c$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e7fc41517b66781c$var$oc = Math.clz32 ? Math.clz32 : $e7fc41517b66781c$var$nc, $e7fc41517b66781c$var$pc = Math.log, $e7fc41517b66781c$var$qc = Math.LN2;
function $e7fc41517b66781c$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e7fc41517b66781c$var$pc(a) / $e7fc41517b66781c$var$qc | 0) | 0;
}
var $e7fc41517b66781c$var$rc = 64, $e7fc41517b66781c$var$sc = 4194304;
function $e7fc41517b66781c$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e7fc41517b66781c$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e7fc41517b66781c$var$tc(h) : (f &= g, 0 !== f && (d = $e7fc41517b66781c$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e7fc41517b66781c$var$tc(g) : 0 !== f && (d = $e7fc41517b66781c$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e7fc41517b66781c$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e7fc41517b66781c$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e7fc41517b66781c$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e7fc41517b66781c$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e7fc41517b66781c$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e7fc41517b66781c$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e7fc41517b66781c$var$yc() {
    var a = $e7fc41517b66781c$var$rc;
    $e7fc41517b66781c$var$rc <<= 1;
    0 === ($e7fc41517b66781c$var$rc & 4194240) && ($e7fc41517b66781c$var$rc = 64);
    return a;
}
function $e7fc41517b66781c$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e7fc41517b66781c$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e7fc41517b66781c$var$oc(b);
    a[b] = c;
}
function $e7fc41517b66781c$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e7fc41517b66781c$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e7fc41517b66781c$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e7fc41517b66781c$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e7fc41517b66781c$var$C = 0;
function $e7fc41517b66781c$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e7fc41517b66781c$var$Ec, $e7fc41517b66781c$var$Fc, $e7fc41517b66781c$var$Gc, $e7fc41517b66781c$var$Hc, $e7fc41517b66781c$var$Ic, $e7fc41517b66781c$var$Jc = !1, $e7fc41517b66781c$var$Kc = [], $e7fc41517b66781c$var$Lc = null, $e7fc41517b66781c$var$Mc = null, $e7fc41517b66781c$var$Nc = null, $e7fc41517b66781c$var$Oc = new Map, $e7fc41517b66781c$var$Pc = new Map, $e7fc41517b66781c$var$Qc = [], $e7fc41517b66781c$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e7fc41517b66781c$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e7fc41517b66781c$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e7fc41517b66781c$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e7fc41517b66781c$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e7fc41517b66781c$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e7fc41517b66781c$var$Pc.delete(b.pointerId);
    }
}
function $e7fc41517b66781c$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e7fc41517b66781c$var$Cb(b), null !== b && $e7fc41517b66781c$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e7fc41517b66781c$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e7fc41517b66781c$var$Lc = $e7fc41517b66781c$var$Tc($e7fc41517b66781c$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e7fc41517b66781c$var$Mc = $e7fc41517b66781c$var$Tc($e7fc41517b66781c$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e7fc41517b66781c$var$Nc = $e7fc41517b66781c$var$Tc($e7fc41517b66781c$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e7fc41517b66781c$var$Oc.set(f, $e7fc41517b66781c$var$Tc($e7fc41517b66781c$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e7fc41517b66781c$var$Pc.set(f, $e7fc41517b66781c$var$Tc($e7fc41517b66781c$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e7fc41517b66781c$var$Vc(a) {
    var b = $e7fc41517b66781c$var$Wc(a.target);
    if (null !== b) {
        var c = $e7fc41517b66781c$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e7fc41517b66781c$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e7fc41517b66781c$var$Ic(a.priority, function() {
                        $e7fc41517b66781c$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e7fc41517b66781c$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e7fc41517b66781c$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e7fc41517b66781c$var$wb = d;
            c.target.dispatchEvent(d);
            $e7fc41517b66781c$var$wb = null;
        } else return b = $e7fc41517b66781c$var$Cb(c), null !== b && $e7fc41517b66781c$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e7fc41517b66781c$var$Zc(a, b, c) {
    $e7fc41517b66781c$var$Xc(a) && c.delete(b);
}
function $e7fc41517b66781c$var$$c() {
    $e7fc41517b66781c$var$Jc = !1;
    null !== $e7fc41517b66781c$var$Lc && $e7fc41517b66781c$var$Xc($e7fc41517b66781c$var$Lc) && ($e7fc41517b66781c$var$Lc = null);
    null !== $e7fc41517b66781c$var$Mc && $e7fc41517b66781c$var$Xc($e7fc41517b66781c$var$Mc) && ($e7fc41517b66781c$var$Mc = null);
    null !== $e7fc41517b66781c$var$Nc && $e7fc41517b66781c$var$Xc($e7fc41517b66781c$var$Nc) && ($e7fc41517b66781c$var$Nc = null);
    $e7fc41517b66781c$var$Oc.forEach($e7fc41517b66781c$var$Zc);
    $e7fc41517b66781c$var$Pc.forEach($e7fc41517b66781c$var$Zc);
}
function $e7fc41517b66781c$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e7fc41517b66781c$var$Jc || ($e7fc41517b66781c$var$Jc = !0, $HuxiW.unstable_scheduleCallback($HuxiW.unstable_NormalPriority, $e7fc41517b66781c$var$$c)));
}
function $e7fc41517b66781c$var$bd(a) {
    function b(b) {
        return $e7fc41517b66781c$var$ad(b, a);
    }
    if (0 < $e7fc41517b66781c$var$Kc.length) {
        $e7fc41517b66781c$var$ad($e7fc41517b66781c$var$Kc[0], a);
        for(var c = 1; c < $e7fc41517b66781c$var$Kc.length; c++){
            var d = $e7fc41517b66781c$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e7fc41517b66781c$var$Lc && $e7fc41517b66781c$var$ad($e7fc41517b66781c$var$Lc, a);
    null !== $e7fc41517b66781c$var$Mc && $e7fc41517b66781c$var$ad($e7fc41517b66781c$var$Mc, a);
    null !== $e7fc41517b66781c$var$Nc && $e7fc41517b66781c$var$ad($e7fc41517b66781c$var$Nc, a);
    $e7fc41517b66781c$var$Oc.forEach(b);
    $e7fc41517b66781c$var$Pc.forEach(b);
    for(c = 0; c < $e7fc41517b66781c$var$Qc.length; c++)d = $e7fc41517b66781c$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e7fc41517b66781c$var$Qc.length && (c = $e7fc41517b66781c$var$Qc[0], null === c.blockedOn);)$e7fc41517b66781c$var$Vc(c), null === c.blockedOn && $e7fc41517b66781c$var$Qc.shift();
}
var $e7fc41517b66781c$var$cd = $e7fc41517b66781c$var$ua.ReactCurrentBatchConfig, $e7fc41517b66781c$var$dd = !0;
function $e7fc41517b66781c$var$ed(a, b, c, d) {
    var e = $e7fc41517b66781c$var$C, f = $e7fc41517b66781c$var$cd.transition;
    $e7fc41517b66781c$var$cd.transition = null;
    try {
        $e7fc41517b66781c$var$C = 1, $e7fc41517b66781c$var$fd(a, b, c, d);
    } finally{
        $e7fc41517b66781c$var$C = e, $e7fc41517b66781c$var$cd.transition = f;
    }
}
function $e7fc41517b66781c$var$gd(a, b, c, d) {
    var e = $e7fc41517b66781c$var$C, f = $e7fc41517b66781c$var$cd.transition;
    $e7fc41517b66781c$var$cd.transition = null;
    try {
        $e7fc41517b66781c$var$C = 4, $e7fc41517b66781c$var$fd(a, b, c, d);
    } finally{
        $e7fc41517b66781c$var$C = e, $e7fc41517b66781c$var$cd.transition = f;
    }
}
function $e7fc41517b66781c$var$fd(a, b, c, d) {
    if ($e7fc41517b66781c$var$dd) {
        var e = $e7fc41517b66781c$var$Yc(a, b, c, d);
        if (null === e) $e7fc41517b66781c$var$hd(a, b, d, $e7fc41517b66781c$var$id, c), $e7fc41517b66781c$var$Sc(a, d);
        else if ($e7fc41517b66781c$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e7fc41517b66781c$var$Sc(a, d), b & 4 && -1 < $e7fc41517b66781c$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e7fc41517b66781c$var$Cb(e);
                null !== f && $e7fc41517b66781c$var$Ec(f);
                f = $e7fc41517b66781c$var$Yc(a, b, c, d);
                null === f && $e7fc41517b66781c$var$hd(a, b, d, $e7fc41517b66781c$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e7fc41517b66781c$var$hd(a, b, d, null, c);
    }
}
var $e7fc41517b66781c$var$id = null;
function $e7fc41517b66781c$var$Yc(a, b, c, d) {
    $e7fc41517b66781c$var$id = null;
    a = $e7fc41517b66781c$var$xb(d);
    a = $e7fc41517b66781c$var$Wc(a);
    if (null !== a) {
        if (b = $e7fc41517b66781c$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e7fc41517b66781c$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e7fc41517b66781c$var$id = a;
    return null;
}
function $e7fc41517b66781c$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e7fc41517b66781c$var$ec()){
                case $e7fc41517b66781c$var$fc:
                    return 1;
                case $e7fc41517b66781c$var$gc:
                    return 4;
                case $e7fc41517b66781c$var$hc:
                case $e7fc41517b66781c$var$ic:
                    return 16;
                case $e7fc41517b66781c$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e7fc41517b66781c$var$kd = null, $e7fc41517b66781c$var$ld = null, $e7fc41517b66781c$var$md = null;
function $e7fc41517b66781c$var$nd() {
    if ($e7fc41517b66781c$var$md) return $e7fc41517b66781c$var$md;
    var a, b = $e7fc41517b66781c$var$ld, c = b.length, d, e = "value" in $e7fc41517b66781c$var$kd ? $e7fc41517b66781c$var$kd.value : $e7fc41517b66781c$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e7fc41517b66781c$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e7fc41517b66781c$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e7fc41517b66781c$var$pd() {
    return !0;
}
function $e7fc41517b66781c$var$qd() {
    return !1;
}
function $e7fc41517b66781c$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e7fc41517b66781c$var$pd : $e7fc41517b66781c$var$qd;
        this.isPropagationStopped = $e7fc41517b66781c$var$qd;
        return this;
    }
    $e7fc41517b66781c$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e7fc41517b66781c$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e7fc41517b66781c$var$pd);
        },
        persist: function() {},
        isPersistent: $e7fc41517b66781c$var$pd
    });
    return b;
}
var $e7fc41517b66781c$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e7fc41517b66781c$var$td = $e7fc41517b66781c$var$rd($e7fc41517b66781c$var$sd), $e7fc41517b66781c$var$ud = $e7fc41517b66781c$var$A({}, $e7fc41517b66781c$var$sd, {
    view: 0,
    detail: 0
}), $e7fc41517b66781c$var$vd = $e7fc41517b66781c$var$rd($e7fc41517b66781c$var$ud), $e7fc41517b66781c$var$wd, $e7fc41517b66781c$var$xd, $e7fc41517b66781c$var$yd, $e7fc41517b66781c$var$Ad = $e7fc41517b66781c$var$A({}, $e7fc41517b66781c$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e7fc41517b66781c$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e7fc41517b66781c$var$yd && ($e7fc41517b66781c$var$yd && "mousemove" === a.type ? ($e7fc41517b66781c$var$wd = a.screenX - $e7fc41517b66781c$var$yd.screenX, $e7fc41517b66781c$var$xd = a.screenY - $e7fc41517b66781c$var$yd.screenY) : $e7fc41517b66781c$var$xd = $e7fc41517b66781c$var$wd = 0, $e7fc41517b66781c$var$yd = a);
        return $e7fc41517b66781c$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e7fc41517b66781c$var$xd;
    }
}), $e7fc41517b66781c$var$Bd = $e7fc41517b66781c$var$rd($e7fc41517b66781c$var$Ad), $e7fc41517b66781c$var$Cd = $e7fc41517b66781c$var$A({}, $e7fc41517b66781c$var$Ad, {
    dataTransfer: 0
}), $e7fc41517b66781c$var$Dd = $e7fc41517b66781c$var$rd($e7fc41517b66781c$var$Cd), $e7fc41517b66781c$var$Ed = $e7fc41517b66781c$var$A({}, $e7fc41517b66781c$var$ud, {
    relatedTarget: 0
}), $e7fc41517b66781c$var$Fd = $e7fc41517b66781c$var$rd($e7fc41517b66781c$var$Ed), $e7fc41517b66781c$var$Gd = $e7fc41517b66781c$var$A({}, $e7fc41517b66781c$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e7fc41517b66781c$var$Hd = $e7fc41517b66781c$var$rd($e7fc41517b66781c$var$Gd), $e7fc41517b66781c$var$Id = $e7fc41517b66781c$var$A({}, $e7fc41517b66781c$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e7fc41517b66781c$var$Jd = $e7fc41517b66781c$var$rd($e7fc41517b66781c$var$Id), $e7fc41517b66781c$var$Kd = $e7fc41517b66781c$var$A({}, $e7fc41517b66781c$var$sd, {
    data: 0
}), $e7fc41517b66781c$var$Ld = $e7fc41517b66781c$var$rd($e7fc41517b66781c$var$Kd), $e7fc41517b66781c$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e7fc41517b66781c$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e7fc41517b66781c$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e7fc41517b66781c$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e7fc41517b66781c$var$Od[a]) ? !!b[a] : !1;
}
function $e7fc41517b66781c$var$zd() {
    return $e7fc41517b66781c$var$Pd;
}
var $e7fc41517b66781c$var$Qd = $e7fc41517b66781c$var$A({}, $e7fc41517b66781c$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $e7fc41517b66781c$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e7fc41517b66781c$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e7fc41517b66781c$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e7fc41517b66781c$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $e7fc41517b66781c$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e7fc41517b66781c$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e7fc41517b66781c$var$Rd = $e7fc41517b66781c$var$rd($e7fc41517b66781c$var$Qd), $e7fc41517b66781c$var$Sd = $e7fc41517b66781c$var$A({}, $e7fc41517b66781c$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e7fc41517b66781c$var$Td = $e7fc41517b66781c$var$rd($e7fc41517b66781c$var$Sd), $e7fc41517b66781c$var$Ud = $e7fc41517b66781c$var$A({}, $e7fc41517b66781c$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e7fc41517b66781c$var$zd
}), $e7fc41517b66781c$var$Vd = $e7fc41517b66781c$var$rd($e7fc41517b66781c$var$Ud), $e7fc41517b66781c$var$Wd = $e7fc41517b66781c$var$A({}, $e7fc41517b66781c$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e7fc41517b66781c$var$Xd = $e7fc41517b66781c$var$rd($e7fc41517b66781c$var$Wd), $e7fc41517b66781c$var$Yd = $e7fc41517b66781c$var$A({}, $e7fc41517b66781c$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e7fc41517b66781c$var$Zd = $e7fc41517b66781c$var$rd($e7fc41517b66781c$var$Yd), $e7fc41517b66781c$var$$d = [
    9,
    13,
    27,
    32
], $e7fc41517b66781c$var$ae = $e7fc41517b66781c$var$ia && "CompositionEvent" in window, $e7fc41517b66781c$var$be = null;
$e7fc41517b66781c$var$ia && "documentMode" in document && ($e7fc41517b66781c$var$be = document.documentMode);
var $e7fc41517b66781c$var$ce = $e7fc41517b66781c$var$ia && "TextEvent" in window && !$e7fc41517b66781c$var$be, $e7fc41517b66781c$var$de = $e7fc41517b66781c$var$ia && (!$e7fc41517b66781c$var$ae || $e7fc41517b66781c$var$be && 8 < $e7fc41517b66781c$var$be && 11 >= $e7fc41517b66781c$var$be), $e7fc41517b66781c$var$ee = String.fromCharCode(32), $e7fc41517b66781c$var$fe = !1;
function $e7fc41517b66781c$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e7fc41517b66781c$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e7fc41517b66781c$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e7fc41517b66781c$var$ie = !1;
function $e7fc41517b66781c$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e7fc41517b66781c$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e7fc41517b66781c$var$fe = !0;
            return $e7fc41517b66781c$var$ee;
        case "textInput":
            return a = b.data, a === $e7fc41517b66781c$var$ee && $e7fc41517b66781c$var$fe ? null : a;
        default:
            return null;
    }
}
function $e7fc41517b66781c$var$ke(a, b) {
    if ($e7fc41517b66781c$var$ie) return "compositionend" === a || !$e7fc41517b66781c$var$ae && $e7fc41517b66781c$var$ge(a, b) ? (a = $e7fc41517b66781c$var$nd(), $e7fc41517b66781c$var$md = $e7fc41517b66781c$var$ld = $e7fc41517b66781c$var$kd = null, $e7fc41517b66781c$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e7fc41517b66781c$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e7fc41517b66781c$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e7fc41517b66781c$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e7fc41517b66781c$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e7fc41517b66781c$var$ne(a, b, c, d) {
    $e7fc41517b66781c$var$Eb(d);
    b = $e7fc41517b66781c$var$oe(b, "onChange");
    0 < b.length && (c = new $e7fc41517b66781c$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e7fc41517b66781c$var$pe = null, $e7fc41517b66781c$var$qe = null;
function $e7fc41517b66781c$var$re(a) {
    $e7fc41517b66781c$var$se(a, 0);
}
function $e7fc41517b66781c$var$te(a) {
    var b = $e7fc41517b66781c$var$ue(a);
    if ($e7fc41517b66781c$var$Wa(b)) return a;
}
function $e7fc41517b66781c$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e7fc41517b66781c$var$we = !1;
if ($e7fc41517b66781c$var$ia) {
    var $e7fc41517b66781c$var$xe;
    if ($e7fc41517b66781c$var$ia) {
        var $e7fc41517b66781c$var$ye = "oninput" in document;
        if (!$e7fc41517b66781c$var$ye) {
            var $e7fc41517b66781c$var$ze = document.createElement("div");
            $e7fc41517b66781c$var$ze.setAttribute("oninput", "return;");
            $e7fc41517b66781c$var$ye = "function" === typeof $e7fc41517b66781c$var$ze.oninput;
        }
        $e7fc41517b66781c$var$xe = $e7fc41517b66781c$var$ye;
    } else $e7fc41517b66781c$var$xe = !1;
    $e7fc41517b66781c$var$we = $e7fc41517b66781c$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e7fc41517b66781c$var$Ae() {
    $e7fc41517b66781c$var$pe && ($e7fc41517b66781c$var$pe.detachEvent("onpropertychange", $e7fc41517b66781c$var$Be), $e7fc41517b66781c$var$qe = $e7fc41517b66781c$var$pe = null);
}
function $e7fc41517b66781c$var$Be(a) {
    if ("value" === a.propertyName && $e7fc41517b66781c$var$te($e7fc41517b66781c$var$qe)) {
        var b = [];
        $e7fc41517b66781c$var$ne(b, $e7fc41517b66781c$var$qe, a, $e7fc41517b66781c$var$xb(a));
        $e7fc41517b66781c$var$Jb($e7fc41517b66781c$var$re, b);
    }
}
function $e7fc41517b66781c$var$Ce(a, b, c) {
    "focusin" === a ? ($e7fc41517b66781c$var$Ae(), $e7fc41517b66781c$var$pe = b, $e7fc41517b66781c$var$qe = c, $e7fc41517b66781c$var$pe.attachEvent("onpropertychange", $e7fc41517b66781c$var$Be)) : "focusout" === a && $e7fc41517b66781c$var$Ae();
}
function $e7fc41517b66781c$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e7fc41517b66781c$var$te($e7fc41517b66781c$var$qe);
}
function $e7fc41517b66781c$var$Ee(a, b) {
    if ("click" === a) return $e7fc41517b66781c$var$te(b);
}
function $e7fc41517b66781c$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e7fc41517b66781c$var$te(b);
}
function $e7fc41517b66781c$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e7fc41517b66781c$var$He = "function" === typeof Object.is ? Object.is : $e7fc41517b66781c$var$Ge;
function $e7fc41517b66781c$var$Ie(a, b) {
    if ($e7fc41517b66781c$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e7fc41517b66781c$var$ja.call(b, e) || !$e7fc41517b66781c$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e7fc41517b66781c$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e7fc41517b66781c$var$Ke(a, b) {
    var c = $e7fc41517b66781c$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e7fc41517b66781c$var$Je(c);
    }
}
function $e7fc41517b66781c$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e7fc41517b66781c$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e7fc41517b66781c$var$Me() {
    for(var a = window, b = $e7fc41517b66781c$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e7fc41517b66781c$var$Xa(a.document);
    }
    return b;
}
function $e7fc41517b66781c$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e7fc41517b66781c$var$Oe(a) {
    var b = $e7fc41517b66781c$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e7fc41517b66781c$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e7fc41517b66781c$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e7fc41517b66781c$var$Ke(c, f);
                var g = $e7fc41517b66781c$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e7fc41517b66781c$var$Pe = $e7fc41517b66781c$var$ia && "documentMode" in document && 11 >= document.documentMode, $e7fc41517b66781c$var$Qe = null, $e7fc41517b66781c$var$Re = null, $e7fc41517b66781c$var$Se = null, $e7fc41517b66781c$var$Te = !1;
function $e7fc41517b66781c$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e7fc41517b66781c$var$Te || null == $e7fc41517b66781c$var$Qe || $e7fc41517b66781c$var$Qe !== $e7fc41517b66781c$var$Xa(d) || (d = $e7fc41517b66781c$var$Qe, "selectionStart" in d && $e7fc41517b66781c$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e7fc41517b66781c$var$Se && $e7fc41517b66781c$var$Ie($e7fc41517b66781c$var$Se, d) || ($e7fc41517b66781c$var$Se = d, d = $e7fc41517b66781c$var$oe($e7fc41517b66781c$var$Re, "onSelect"), 0 < d.length && (b = new $e7fc41517b66781c$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e7fc41517b66781c$var$Qe)));
}
function $e7fc41517b66781c$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e7fc41517b66781c$var$We = {
    animationend: $e7fc41517b66781c$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e7fc41517b66781c$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e7fc41517b66781c$var$Ve("Animation", "AnimationStart"),
    transitionend: $e7fc41517b66781c$var$Ve("Transition", "TransitionEnd")
}, $e7fc41517b66781c$var$Xe = {}, $e7fc41517b66781c$var$Ye = {};
$e7fc41517b66781c$var$ia && ($e7fc41517b66781c$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e7fc41517b66781c$var$We.animationend.animation, delete $e7fc41517b66781c$var$We.animationiteration.animation, delete $e7fc41517b66781c$var$We.animationstart.animation), "TransitionEvent" in window || delete $e7fc41517b66781c$var$We.transitionend.transition);
function $e7fc41517b66781c$var$Ze(a) {
    if ($e7fc41517b66781c$var$Xe[a]) return $e7fc41517b66781c$var$Xe[a];
    if (!$e7fc41517b66781c$var$We[a]) return a;
    var b = $e7fc41517b66781c$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e7fc41517b66781c$var$Ye) return $e7fc41517b66781c$var$Xe[a] = b[c];
    return a;
}
var $e7fc41517b66781c$var$$e = $e7fc41517b66781c$var$Ze("animationend"), $e7fc41517b66781c$var$af = $e7fc41517b66781c$var$Ze("animationiteration"), $e7fc41517b66781c$var$bf = $e7fc41517b66781c$var$Ze("animationstart"), $e7fc41517b66781c$var$cf = $e7fc41517b66781c$var$Ze("transitionend"), $e7fc41517b66781c$var$df = new Map, $e7fc41517b66781c$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e7fc41517b66781c$var$ff(a, b) {
    $e7fc41517b66781c$var$df.set(a, b);
    $e7fc41517b66781c$var$fa(b, [
        a
    ]);
}
for(var $e7fc41517b66781c$var$gf = 0; $e7fc41517b66781c$var$gf < $e7fc41517b66781c$var$ef.length; $e7fc41517b66781c$var$gf++){
    var $e7fc41517b66781c$var$hf = $e7fc41517b66781c$var$ef[$e7fc41517b66781c$var$gf], $e7fc41517b66781c$var$jf = $e7fc41517b66781c$var$hf.toLowerCase(), $e7fc41517b66781c$var$kf = $e7fc41517b66781c$var$hf[0].toUpperCase() + $e7fc41517b66781c$var$hf.slice(1);
    $e7fc41517b66781c$var$ff($e7fc41517b66781c$var$jf, "on" + $e7fc41517b66781c$var$kf);
}
$e7fc41517b66781c$var$ff($e7fc41517b66781c$var$$e, "onAnimationEnd");
$e7fc41517b66781c$var$ff($e7fc41517b66781c$var$af, "onAnimationIteration");
$e7fc41517b66781c$var$ff($e7fc41517b66781c$var$bf, "onAnimationStart");
$e7fc41517b66781c$var$ff("dblclick", "onDoubleClick");
$e7fc41517b66781c$var$ff("focusin", "onFocus");
$e7fc41517b66781c$var$ff("focusout", "onBlur");
$e7fc41517b66781c$var$ff($e7fc41517b66781c$var$cf, "onTransitionEnd");
$e7fc41517b66781c$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e7fc41517b66781c$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e7fc41517b66781c$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e7fc41517b66781c$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e7fc41517b66781c$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e7fc41517b66781c$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e7fc41517b66781c$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e7fc41517b66781c$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e7fc41517b66781c$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e7fc41517b66781c$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e7fc41517b66781c$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e7fc41517b66781c$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e7fc41517b66781c$var$lf));
function $e7fc41517b66781c$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e7fc41517b66781c$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e7fc41517b66781c$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e7fc41517b66781c$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e7fc41517b66781c$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e7fc41517b66781c$var$Qb) throw a = $e7fc41517b66781c$var$Rb, $e7fc41517b66781c$var$Qb = !1, $e7fc41517b66781c$var$Rb = null, a;
}
function $e7fc41517b66781c$var$D(a, b) {
    var c = b[$e7fc41517b66781c$var$of];
    void 0 === c && (c = b[$e7fc41517b66781c$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e7fc41517b66781c$var$pf(b, a, 2, !1), c.add(d));
}
function $e7fc41517b66781c$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e7fc41517b66781c$var$pf(c, a, d, b);
}
var $e7fc41517b66781c$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e7fc41517b66781c$var$sf(a) {
    if (!a[$e7fc41517b66781c$var$rf]) {
        a[$e7fc41517b66781c$var$rf] = !0;
        $e7fc41517b66781c$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e7fc41517b66781c$var$mf.has(b) || $e7fc41517b66781c$var$qf(b, !1, a), $e7fc41517b66781c$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e7fc41517b66781c$var$rf] || (b[$e7fc41517b66781c$var$rf] = !0, $e7fc41517b66781c$var$qf("selectionchange", !1, b));
    }
}
function $e7fc41517b66781c$var$pf(a, b, c, d) {
    switch($e7fc41517b66781c$var$jd(b)){
        case 1:
            var e = $e7fc41517b66781c$var$ed;
            break;
        case 4:
            e = $e7fc41517b66781c$var$gd;
            break;
        default:
            e = $e7fc41517b66781c$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e7fc41517b66781c$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e7fc41517b66781c$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e7fc41517b66781c$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e7fc41517b66781c$var$Jb(function() {
        var d = f, e = $e7fc41517b66781c$var$xb(c), g = [];
        a: {
            var h = $e7fc41517b66781c$var$df.get(a);
            if (void 0 !== h) {
                var k = $e7fc41517b66781c$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e7fc41517b66781c$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e7fc41517b66781c$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e7fc41517b66781c$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e7fc41517b66781c$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e7fc41517b66781c$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e7fc41517b66781c$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e7fc41517b66781c$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e7fc41517b66781c$var$Vd;
                        break;
                    case $e7fc41517b66781c$var$$e:
                    case $e7fc41517b66781c$var$af:
                    case $e7fc41517b66781c$var$bf:
                        k = $e7fc41517b66781c$var$Hd;
                        break;
                    case $e7fc41517b66781c$var$cf:
                        k = $e7fc41517b66781c$var$Xd;
                        break;
                    case "scroll":
                        k = $e7fc41517b66781c$var$vd;
                        break;
                    case "wheel":
                        k = $e7fc41517b66781c$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e7fc41517b66781c$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e7fc41517b66781c$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e7fc41517b66781c$var$Kb(w, x), null != F && t.push($e7fc41517b66781c$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e7fc41517b66781c$var$wb && (n = c.relatedTarget || c.fromElement) && ($e7fc41517b66781c$var$Wc(n) || n[$e7fc41517b66781c$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $e7fc41517b66781c$var$Wc(n) : null, null !== n && (J = $e7fc41517b66781c$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $e7fc41517b66781c$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e7fc41517b66781c$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e7fc41517b66781c$var$ue(k);
                        u = null == n ? h : $e7fc41517b66781c$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e7fc41517b66781c$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e7fc41517b66781c$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e7fc41517b66781c$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e7fc41517b66781c$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e7fc41517b66781c$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e7fc41517b66781c$var$vf(t);
                                x = $e7fc41517b66781c$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e7fc41517b66781c$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e7fc41517b66781c$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $e7fc41517b66781c$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e7fc41517b66781c$var$ve;
                else if ($e7fc41517b66781c$var$me(h)) {
                    if ($e7fc41517b66781c$var$we) na = $e7fc41517b66781c$var$Fe;
                    else {
                        na = $e7fc41517b66781c$var$De;
                        var xa = $e7fc41517b66781c$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e7fc41517b66781c$var$Ee);
                if (na && (na = na(a, d))) {
                    $e7fc41517b66781c$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e7fc41517b66781c$var$cb(h, "number", h.value);
            }
            xa = d ? $e7fc41517b66781c$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($e7fc41517b66781c$var$me(xa) || "true" === xa.contentEditable) $e7fc41517b66781c$var$Qe = xa, $e7fc41517b66781c$var$Re = d, $e7fc41517b66781c$var$Se = null;
                    break;
                case "focusout":
                    $e7fc41517b66781c$var$Se = $e7fc41517b66781c$var$Re = $e7fc41517b66781c$var$Qe = null;
                    break;
                case "mousedown":
                    $e7fc41517b66781c$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e7fc41517b66781c$var$Te = !1;
                    $e7fc41517b66781c$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($e7fc41517b66781c$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e7fc41517b66781c$var$Ue(g, c, e);
            }
            var $a;
            if ($e7fc41517b66781c$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e7fc41517b66781c$var$ie ? $e7fc41517b66781c$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e7fc41517b66781c$var$de && "ko" !== c.locale && ($e7fc41517b66781c$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e7fc41517b66781c$var$ie && ($a = $e7fc41517b66781c$var$nd()) : ($e7fc41517b66781c$var$kd = e, $e7fc41517b66781c$var$ld = "value" in $e7fc41517b66781c$var$kd ? $e7fc41517b66781c$var$kd.value : $e7fc41517b66781c$var$kd.textContent, $e7fc41517b66781c$var$ie = !0)), xa = $e7fc41517b66781c$var$oe(d, ba), 0 < xa.length && (ba = new $e7fc41517b66781c$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e7fc41517b66781c$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e7fc41517b66781c$var$ce ? $e7fc41517b66781c$var$je(a, c) : $e7fc41517b66781c$var$ke(a, c)) d = $e7fc41517b66781c$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $e7fc41517b66781c$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $e7fc41517b66781c$var$se(g, b);
    });
}
function $e7fc41517b66781c$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e7fc41517b66781c$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e7fc41517b66781c$var$Kb(a, c), null != f && d.unshift($e7fc41517b66781c$var$tf(a, f, e)), f = $e7fc41517b66781c$var$Kb(a, b), null != f && d.push($e7fc41517b66781c$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e7fc41517b66781c$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e7fc41517b66781c$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e7fc41517b66781c$var$Kb(c, f), null != k && g.unshift($e7fc41517b66781c$var$tf(c, k, h))) : e || (k = $e7fc41517b66781c$var$Kb(c, f), null != k && g.push($e7fc41517b66781c$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e7fc41517b66781c$var$xf = /\r\n?/g, $e7fc41517b66781c$var$yf = /\u0000|\uFFFD/g;
function $e7fc41517b66781c$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e7fc41517b66781c$var$xf, "\n").replace($e7fc41517b66781c$var$yf, "");
}
function $e7fc41517b66781c$var$Af(a, b, c) {
    b = $e7fc41517b66781c$var$zf(b);
    if ($e7fc41517b66781c$var$zf(a) !== b && c) throw Error($e7fc41517b66781c$var$p(425));
}
function $e7fc41517b66781c$var$Bf() {}
var $e7fc41517b66781c$var$Cf = null, $e7fc41517b66781c$var$Df = null;
function $e7fc41517b66781c$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e7fc41517b66781c$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e7fc41517b66781c$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e7fc41517b66781c$var$Hf = "function" === typeof Promise ? Promise : void 0, $e7fc41517b66781c$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e7fc41517b66781c$var$Hf ? function(a) {
    return $e7fc41517b66781c$var$Hf.resolve(null).then(a).catch($e7fc41517b66781c$var$If);
} : $e7fc41517b66781c$var$Ff;
function $e7fc41517b66781c$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e7fc41517b66781c$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e7fc41517b66781c$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e7fc41517b66781c$var$bd(b);
}
function $e7fc41517b66781c$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e7fc41517b66781c$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e7fc41517b66781c$var$Nf = Math.random().toString(36).slice(2), $e7fc41517b66781c$var$Of = "__reactFiber$" + $e7fc41517b66781c$var$Nf, $e7fc41517b66781c$var$Pf = "__reactProps$" + $e7fc41517b66781c$var$Nf, $e7fc41517b66781c$var$uf = "__reactContainer$" + $e7fc41517b66781c$var$Nf, $e7fc41517b66781c$var$of = "__reactEvents$" + $e7fc41517b66781c$var$Nf, $e7fc41517b66781c$var$Qf = "__reactListeners$" + $e7fc41517b66781c$var$Nf, $e7fc41517b66781c$var$Rf = "__reactHandles$" + $e7fc41517b66781c$var$Nf;
function $e7fc41517b66781c$var$Wc(a) {
    var b = a[$e7fc41517b66781c$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e7fc41517b66781c$var$uf] || c[$e7fc41517b66781c$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e7fc41517b66781c$var$Mf(a); null !== a;){
                if (c = a[$e7fc41517b66781c$var$Of]) return c;
                a = $e7fc41517b66781c$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e7fc41517b66781c$var$Cb(a) {
    a = a[$e7fc41517b66781c$var$Of] || a[$e7fc41517b66781c$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e7fc41517b66781c$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e7fc41517b66781c$var$p(33));
}
function $e7fc41517b66781c$var$Db(a) {
    return a[$e7fc41517b66781c$var$Pf] || null;
}
var $e7fc41517b66781c$var$Sf = [], $e7fc41517b66781c$var$Tf = -1;
function $e7fc41517b66781c$var$Uf(a) {
    return {
        current: a
    };
}
function $e7fc41517b66781c$var$E(a) {
    0 > $e7fc41517b66781c$var$Tf || (a.current = $e7fc41517b66781c$var$Sf[$e7fc41517b66781c$var$Tf], $e7fc41517b66781c$var$Sf[$e7fc41517b66781c$var$Tf] = null, $e7fc41517b66781c$var$Tf--);
}
function $e7fc41517b66781c$var$G(a, b) {
    $e7fc41517b66781c$var$Tf++;
    $e7fc41517b66781c$var$Sf[$e7fc41517b66781c$var$Tf] = a.current;
    a.current = b;
}
var $e7fc41517b66781c$var$Vf = {}, $e7fc41517b66781c$var$H = $e7fc41517b66781c$var$Uf($e7fc41517b66781c$var$Vf), $e7fc41517b66781c$var$Wf = $e7fc41517b66781c$var$Uf(!1), $e7fc41517b66781c$var$Xf = $e7fc41517b66781c$var$Vf;
function $e7fc41517b66781c$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e7fc41517b66781c$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e7fc41517b66781c$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e7fc41517b66781c$var$$f() {
    $e7fc41517b66781c$var$E($e7fc41517b66781c$var$Wf);
    $e7fc41517b66781c$var$E($e7fc41517b66781c$var$H);
}
function $e7fc41517b66781c$var$ag(a, b, c) {
    if ($e7fc41517b66781c$var$H.current !== $e7fc41517b66781c$var$Vf) throw Error($e7fc41517b66781c$var$p(168));
    $e7fc41517b66781c$var$G($e7fc41517b66781c$var$H, b);
    $e7fc41517b66781c$var$G($e7fc41517b66781c$var$Wf, c);
}
function $e7fc41517b66781c$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e7fc41517b66781c$var$p(108, $e7fc41517b66781c$var$Ra(a) || "Unknown", e));
    return $e7fc41517b66781c$var$A({}, c, d);
}
function $e7fc41517b66781c$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e7fc41517b66781c$var$Vf;
    $e7fc41517b66781c$var$Xf = $e7fc41517b66781c$var$H.current;
    $e7fc41517b66781c$var$G($e7fc41517b66781c$var$H, a);
    $e7fc41517b66781c$var$G($e7fc41517b66781c$var$Wf, $e7fc41517b66781c$var$Wf.current);
    return !0;
}
function $e7fc41517b66781c$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e7fc41517b66781c$var$p(169));
    c ? (a = $e7fc41517b66781c$var$bg(a, b, $e7fc41517b66781c$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e7fc41517b66781c$var$E($e7fc41517b66781c$var$Wf), $e7fc41517b66781c$var$E($e7fc41517b66781c$var$H), $e7fc41517b66781c$var$G($e7fc41517b66781c$var$H, a)) : $e7fc41517b66781c$var$E($e7fc41517b66781c$var$Wf);
    $e7fc41517b66781c$var$G($e7fc41517b66781c$var$Wf, c);
}
var $e7fc41517b66781c$var$eg = null, $e7fc41517b66781c$var$fg = !1, $e7fc41517b66781c$var$gg = !1;
function $e7fc41517b66781c$var$hg(a) {
    null === $e7fc41517b66781c$var$eg ? $e7fc41517b66781c$var$eg = [
        a
    ] : $e7fc41517b66781c$var$eg.push(a);
}
function $e7fc41517b66781c$var$ig(a) {
    $e7fc41517b66781c$var$fg = !0;
    $e7fc41517b66781c$var$hg(a);
}
function $e7fc41517b66781c$var$jg() {
    if (!$e7fc41517b66781c$var$gg && null !== $e7fc41517b66781c$var$eg) {
        $e7fc41517b66781c$var$gg = !0;
        var a = 0, b = $e7fc41517b66781c$var$C;
        try {
            var c = $e7fc41517b66781c$var$eg;
            for($e7fc41517b66781c$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e7fc41517b66781c$var$eg = null;
            $e7fc41517b66781c$var$fg = !1;
        } catch (e) {
            throw null !== $e7fc41517b66781c$var$eg && ($e7fc41517b66781c$var$eg = $e7fc41517b66781c$var$eg.slice(a + 1)), $e7fc41517b66781c$var$ac($e7fc41517b66781c$var$fc, $e7fc41517b66781c$var$jg), e;
        } finally{
            $e7fc41517b66781c$var$C = b, $e7fc41517b66781c$var$gg = !1;
        }
    }
    return null;
}
var $e7fc41517b66781c$var$kg = [], $e7fc41517b66781c$var$lg = 0, $e7fc41517b66781c$var$mg = null, $e7fc41517b66781c$var$ng = 0, $e7fc41517b66781c$var$og = [], $e7fc41517b66781c$var$pg = 0, $e7fc41517b66781c$var$qg = null, $e7fc41517b66781c$var$rg = 1, $e7fc41517b66781c$var$sg = "";
function $e7fc41517b66781c$var$tg(a, b) {
    $e7fc41517b66781c$var$kg[$e7fc41517b66781c$var$lg++] = $e7fc41517b66781c$var$ng;
    $e7fc41517b66781c$var$kg[$e7fc41517b66781c$var$lg++] = $e7fc41517b66781c$var$mg;
    $e7fc41517b66781c$var$mg = a;
    $e7fc41517b66781c$var$ng = b;
}
function $e7fc41517b66781c$var$ug(a, b, c) {
    $e7fc41517b66781c$var$og[$e7fc41517b66781c$var$pg++] = $e7fc41517b66781c$var$rg;
    $e7fc41517b66781c$var$og[$e7fc41517b66781c$var$pg++] = $e7fc41517b66781c$var$sg;
    $e7fc41517b66781c$var$og[$e7fc41517b66781c$var$pg++] = $e7fc41517b66781c$var$qg;
    $e7fc41517b66781c$var$qg = a;
    var d = $e7fc41517b66781c$var$rg;
    a = $e7fc41517b66781c$var$sg;
    var e = 32 - $e7fc41517b66781c$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e7fc41517b66781c$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e7fc41517b66781c$var$rg = 1 << 32 - $e7fc41517b66781c$var$oc(b) + e | c << e | d;
        $e7fc41517b66781c$var$sg = f + a;
    } else $e7fc41517b66781c$var$rg = 1 << f | c << e | d, $e7fc41517b66781c$var$sg = a;
}
function $e7fc41517b66781c$var$vg(a) {
    null !== a.return && ($e7fc41517b66781c$var$tg(a, 1), $e7fc41517b66781c$var$ug(a, 1, 0));
}
function $e7fc41517b66781c$var$wg(a) {
    for(; a === $e7fc41517b66781c$var$mg;)$e7fc41517b66781c$var$mg = $e7fc41517b66781c$var$kg[--$e7fc41517b66781c$var$lg], $e7fc41517b66781c$var$kg[$e7fc41517b66781c$var$lg] = null, $e7fc41517b66781c$var$ng = $e7fc41517b66781c$var$kg[--$e7fc41517b66781c$var$lg], $e7fc41517b66781c$var$kg[$e7fc41517b66781c$var$lg] = null;
    for(; a === $e7fc41517b66781c$var$qg;)$e7fc41517b66781c$var$qg = $e7fc41517b66781c$var$og[--$e7fc41517b66781c$var$pg], $e7fc41517b66781c$var$og[$e7fc41517b66781c$var$pg] = null, $e7fc41517b66781c$var$sg = $e7fc41517b66781c$var$og[--$e7fc41517b66781c$var$pg], $e7fc41517b66781c$var$og[$e7fc41517b66781c$var$pg] = null, $e7fc41517b66781c$var$rg = $e7fc41517b66781c$var$og[--$e7fc41517b66781c$var$pg], $e7fc41517b66781c$var$og[$e7fc41517b66781c$var$pg] = null;
}
var $e7fc41517b66781c$var$xg = null, $e7fc41517b66781c$var$yg = null, $e7fc41517b66781c$var$I = !1, $e7fc41517b66781c$var$zg = null;
function $e7fc41517b66781c$var$Ag(a, b) {
    var c = $e7fc41517b66781c$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e7fc41517b66781c$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e7fc41517b66781c$var$xg = a, $e7fc41517b66781c$var$yg = $e7fc41517b66781c$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e7fc41517b66781c$var$xg = a, $e7fc41517b66781c$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e7fc41517b66781c$var$qg ? {
                id: $e7fc41517b66781c$var$rg,
                overflow: $e7fc41517b66781c$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e7fc41517b66781c$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e7fc41517b66781c$var$xg = a, $e7fc41517b66781c$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e7fc41517b66781c$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e7fc41517b66781c$var$Eg(a) {
    if ($e7fc41517b66781c$var$I) {
        var b = $e7fc41517b66781c$var$yg;
        if (b) {
            var c = b;
            if (!$e7fc41517b66781c$var$Cg(a, b)) {
                if ($e7fc41517b66781c$var$Dg(a)) throw Error($e7fc41517b66781c$var$p(418));
                b = $e7fc41517b66781c$var$Lf(c.nextSibling);
                var d = $e7fc41517b66781c$var$xg;
                b && $e7fc41517b66781c$var$Cg(a, b) ? $e7fc41517b66781c$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e7fc41517b66781c$var$I = !1, $e7fc41517b66781c$var$xg = a);
            }
        } else {
            if ($e7fc41517b66781c$var$Dg(a)) throw Error($e7fc41517b66781c$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e7fc41517b66781c$var$I = !1;
            $e7fc41517b66781c$var$xg = a;
        }
    }
}
function $e7fc41517b66781c$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e7fc41517b66781c$var$xg = a;
}
function $e7fc41517b66781c$var$Gg(a) {
    if (a !== $e7fc41517b66781c$var$xg) return !1;
    if (!$e7fc41517b66781c$var$I) return $e7fc41517b66781c$var$Fg(a), $e7fc41517b66781c$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e7fc41517b66781c$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e7fc41517b66781c$var$yg)) {
        if ($e7fc41517b66781c$var$Dg(a)) throw $e7fc41517b66781c$var$Hg(), Error($e7fc41517b66781c$var$p(418));
        for(; b;)$e7fc41517b66781c$var$Ag(a, b), b = $e7fc41517b66781c$var$Lf(b.nextSibling);
    }
    $e7fc41517b66781c$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e7fc41517b66781c$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e7fc41517b66781c$var$yg = $e7fc41517b66781c$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e7fc41517b66781c$var$yg = null;
        }
    } else $e7fc41517b66781c$var$yg = $e7fc41517b66781c$var$xg ? $e7fc41517b66781c$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e7fc41517b66781c$var$Hg() {
    for(var a = $e7fc41517b66781c$var$yg; a;)a = $e7fc41517b66781c$var$Lf(a.nextSibling);
}
function $e7fc41517b66781c$var$Ig() {
    $e7fc41517b66781c$var$yg = $e7fc41517b66781c$var$xg = null;
    $e7fc41517b66781c$var$I = !1;
}
function $e7fc41517b66781c$var$Jg(a) {
    null === $e7fc41517b66781c$var$zg ? $e7fc41517b66781c$var$zg = [
        a
    ] : $e7fc41517b66781c$var$zg.push(a);
}
var $e7fc41517b66781c$var$Kg = $e7fc41517b66781c$var$ua.ReactCurrentBatchConfig;
function $e7fc41517b66781c$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e7fc41517b66781c$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e7fc41517b66781c$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e7fc41517b66781c$var$p(284));
        if (!c._owner) throw Error($e7fc41517b66781c$var$p(290, a));
    }
    return a;
}
function $e7fc41517b66781c$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e7fc41517b66781c$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e7fc41517b66781c$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $e7fc41517b66781c$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e7fc41517b66781c$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e7fc41517b66781c$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $e7fc41517b66781c$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e7fc41517b66781c$var$Ha && $e7fc41517b66781c$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $e7fc41517b66781c$var$Lg(a, b, c), d.return = a, d;
        d = $e7fc41517b66781c$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e7fc41517b66781c$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e7fc41517b66781c$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e7fc41517b66781c$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e7fc41517b66781c$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e7fc41517b66781c$var$va:
                    return c = $e7fc41517b66781c$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $e7fc41517b66781c$var$Lg(a, null, b), c.return = a, c;
                case $e7fc41517b66781c$var$wa:
                    return b = $e7fc41517b66781c$var$Sg(b, a.mode, c), b.return = a, b;
                case $e7fc41517b66781c$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e7fc41517b66781c$var$eb(b) || $e7fc41517b66781c$var$Ka(b)) return b = $e7fc41517b66781c$var$Tg(b, a.mode, c, null), b.return = a, b;
            $e7fc41517b66781c$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e7fc41517b66781c$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e7fc41517b66781c$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e7fc41517b66781c$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e7fc41517b66781c$var$eb(c) || $e7fc41517b66781c$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e7fc41517b66781c$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e7fc41517b66781c$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e7fc41517b66781c$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e7fc41517b66781c$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e7fc41517b66781c$var$eb(d) || $e7fc41517b66781c$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e7fc41517b66781c$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e7fc41517b66781c$var$I && $e7fc41517b66781c$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e7fc41517b66781c$var$I && $e7fc41517b66781c$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e7fc41517b66781c$var$I && $e7fc41517b66781c$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $e7fc41517b66781c$var$Ka(h);
        if ("function" !== typeof l) throw Error($e7fc41517b66781c$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e7fc41517b66781c$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e7fc41517b66781c$var$I && $e7fc41517b66781c$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e7fc41517b66781c$var$I && $e7fc41517b66781c$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e7fc41517b66781c$var$I && $e7fc41517b66781c$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e7fc41517b66781c$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e7fc41517b66781c$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e7fc41517b66781c$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e7fc41517b66781c$var$Ha && $e7fc41517b66781c$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e7fc41517b66781c$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e7fc41517b66781c$var$ya ? (d = $e7fc41517b66781c$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e7fc41517b66781c$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $e7fc41517b66781c$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e7fc41517b66781c$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e7fc41517b66781c$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e7fc41517b66781c$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e7fc41517b66781c$var$eb(f)) return n(a, d, f, h);
            if ($e7fc41517b66781c$var$Ka(f)) return t(a, d, f, h);
            $e7fc41517b66781c$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e7fc41517b66781c$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e7fc41517b66781c$var$Ug = $e7fc41517b66781c$var$Og(!0), $e7fc41517b66781c$var$Vg = $e7fc41517b66781c$var$Og(!1), $e7fc41517b66781c$var$Wg = $e7fc41517b66781c$var$Uf(null), $e7fc41517b66781c$var$Xg = null, $e7fc41517b66781c$var$Yg = null, $e7fc41517b66781c$var$Zg = null;
function $e7fc41517b66781c$var$$g() {
    $e7fc41517b66781c$var$Zg = $e7fc41517b66781c$var$Yg = $e7fc41517b66781c$var$Xg = null;
}
function $e7fc41517b66781c$var$ah(a) {
    var b = $e7fc41517b66781c$var$Wg.current;
    $e7fc41517b66781c$var$E($e7fc41517b66781c$var$Wg);
    a._currentValue = b;
}
function $e7fc41517b66781c$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e7fc41517b66781c$var$ch(a, b) {
    $e7fc41517b66781c$var$Xg = a;
    $e7fc41517b66781c$var$Zg = $e7fc41517b66781c$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e7fc41517b66781c$var$dh = !0), a.firstContext = null);
}
function $e7fc41517b66781c$var$eh(a) {
    var b = a._currentValue;
    if ($e7fc41517b66781c$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e7fc41517b66781c$var$Yg) {
            if (null === $e7fc41517b66781c$var$Xg) throw Error($e7fc41517b66781c$var$p(308));
            $e7fc41517b66781c$var$Yg = a;
            $e7fc41517b66781c$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e7fc41517b66781c$var$Yg = $e7fc41517b66781c$var$Yg.next = a;
    }
    return b;
}
var $e7fc41517b66781c$var$fh = null;
function $e7fc41517b66781c$var$gh(a) {
    null === $e7fc41517b66781c$var$fh ? $e7fc41517b66781c$var$fh = [
        a
    ] : $e7fc41517b66781c$var$fh.push(a);
}
function $e7fc41517b66781c$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e7fc41517b66781c$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e7fc41517b66781c$var$ih(a, d);
}
function $e7fc41517b66781c$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e7fc41517b66781c$var$jh = !1;
function $e7fc41517b66781c$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e7fc41517b66781c$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e7fc41517b66781c$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e7fc41517b66781c$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e7fc41517b66781c$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e7fc41517b66781c$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e7fc41517b66781c$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e7fc41517b66781c$var$ih(a, c);
}
function $e7fc41517b66781c$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e7fc41517b66781c$var$Cc(a, c);
    }
}
function $e7fc41517b66781c$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e7fc41517b66781c$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $e7fc41517b66781c$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e7fc41517b66781c$var$A({}, q, r);
                            break a;
                        case 2:
                            $e7fc41517b66781c$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e7fc41517b66781c$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e7fc41517b66781c$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e7fc41517b66781c$var$p(191, e));
            e.call(d);
        }
    }
}
var $e7fc41517b66781c$var$th = {}, $e7fc41517b66781c$var$uh = $e7fc41517b66781c$var$Uf($e7fc41517b66781c$var$th), $e7fc41517b66781c$var$vh = $e7fc41517b66781c$var$Uf($e7fc41517b66781c$var$th), $e7fc41517b66781c$var$wh = $e7fc41517b66781c$var$Uf($e7fc41517b66781c$var$th);
function $e7fc41517b66781c$var$xh(a) {
    if (a === $e7fc41517b66781c$var$th) throw Error($e7fc41517b66781c$var$p(174));
    return a;
}
function $e7fc41517b66781c$var$yh(a, b) {
    $e7fc41517b66781c$var$G($e7fc41517b66781c$var$wh, b);
    $e7fc41517b66781c$var$G($e7fc41517b66781c$var$vh, a);
    $e7fc41517b66781c$var$G($e7fc41517b66781c$var$uh, $e7fc41517b66781c$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e7fc41517b66781c$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e7fc41517b66781c$var$lb(b, a);
    }
    $e7fc41517b66781c$var$E($e7fc41517b66781c$var$uh);
    $e7fc41517b66781c$var$G($e7fc41517b66781c$var$uh, b);
}
function $e7fc41517b66781c$var$zh() {
    $e7fc41517b66781c$var$E($e7fc41517b66781c$var$uh);
    $e7fc41517b66781c$var$E($e7fc41517b66781c$var$vh);
    $e7fc41517b66781c$var$E($e7fc41517b66781c$var$wh);
}
function $e7fc41517b66781c$var$Ah(a) {
    $e7fc41517b66781c$var$xh($e7fc41517b66781c$var$wh.current);
    var b = $e7fc41517b66781c$var$xh($e7fc41517b66781c$var$uh.current);
    var c = $e7fc41517b66781c$var$lb(b, a.type);
    b !== c && ($e7fc41517b66781c$var$G($e7fc41517b66781c$var$vh, a), $e7fc41517b66781c$var$G($e7fc41517b66781c$var$uh, c));
}
function $e7fc41517b66781c$var$Bh(a) {
    $e7fc41517b66781c$var$vh.current === a && ($e7fc41517b66781c$var$E($e7fc41517b66781c$var$uh), $e7fc41517b66781c$var$E($e7fc41517b66781c$var$vh));
}
var $e7fc41517b66781c$var$L = $e7fc41517b66781c$var$Uf(0);
function $e7fc41517b66781c$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e7fc41517b66781c$var$Dh = [];
function $e7fc41517b66781c$var$Eh() {
    for(var a = 0; a < $e7fc41517b66781c$var$Dh.length; a++)$e7fc41517b66781c$var$Dh[a]._workInProgressVersionPrimary = null;
    $e7fc41517b66781c$var$Dh.length = 0;
}
var $e7fc41517b66781c$var$Fh = $e7fc41517b66781c$var$ua.ReactCurrentDispatcher, $e7fc41517b66781c$var$Gh = $e7fc41517b66781c$var$ua.ReactCurrentBatchConfig, $e7fc41517b66781c$var$Hh = 0, $e7fc41517b66781c$var$M = null, $e7fc41517b66781c$var$N = null, $e7fc41517b66781c$var$O = null, $e7fc41517b66781c$var$Ih = !1, $e7fc41517b66781c$var$Jh = !1, $e7fc41517b66781c$var$Kh = 0, $e7fc41517b66781c$var$Lh = 0;
function $e7fc41517b66781c$var$P() {
    throw Error($e7fc41517b66781c$var$p(321));
}
function $e7fc41517b66781c$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e7fc41517b66781c$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e7fc41517b66781c$var$Nh(a, b, c, d, e, f) {
    $e7fc41517b66781c$var$Hh = f;
    $e7fc41517b66781c$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e7fc41517b66781c$var$Fh.current = null === a || null === a.memoizedState ? $e7fc41517b66781c$var$Oh : $e7fc41517b66781c$var$Ph;
    a = c(d, e);
    if ($e7fc41517b66781c$var$Jh) {
        f = 0;
        do {
            $e7fc41517b66781c$var$Jh = !1;
            $e7fc41517b66781c$var$Kh = 0;
            if (25 <= f) throw Error($e7fc41517b66781c$var$p(301));
            f += 1;
            $e7fc41517b66781c$var$O = $e7fc41517b66781c$var$N = null;
            b.updateQueue = null;
            $e7fc41517b66781c$var$Fh.current = $e7fc41517b66781c$var$Qh;
            a = c(d, e);
        }while ($e7fc41517b66781c$var$Jh);
    }
    $e7fc41517b66781c$var$Fh.current = $e7fc41517b66781c$var$Rh;
    b = null !== $e7fc41517b66781c$var$N && null !== $e7fc41517b66781c$var$N.next;
    $e7fc41517b66781c$var$Hh = 0;
    $e7fc41517b66781c$var$O = $e7fc41517b66781c$var$N = $e7fc41517b66781c$var$M = null;
    $e7fc41517b66781c$var$Ih = !1;
    if (b) throw Error($e7fc41517b66781c$var$p(300));
    return a;
}
function $e7fc41517b66781c$var$Sh() {
    var a = 0 !== $e7fc41517b66781c$var$Kh;
    $e7fc41517b66781c$var$Kh = 0;
    return a;
}
function $e7fc41517b66781c$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e7fc41517b66781c$var$O ? $e7fc41517b66781c$var$M.memoizedState = $e7fc41517b66781c$var$O = a : $e7fc41517b66781c$var$O = $e7fc41517b66781c$var$O.next = a;
    return $e7fc41517b66781c$var$O;
}
function $e7fc41517b66781c$var$Uh() {
    if (null === $e7fc41517b66781c$var$N) {
        var a = $e7fc41517b66781c$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e7fc41517b66781c$var$N.next;
    var b = null === $e7fc41517b66781c$var$O ? $e7fc41517b66781c$var$M.memoizedState : $e7fc41517b66781c$var$O.next;
    if (null !== b) $e7fc41517b66781c$var$O = b, $e7fc41517b66781c$var$N = a;
    else {
        if (null === a) throw Error($e7fc41517b66781c$var$p(310));
        $e7fc41517b66781c$var$N = a;
        a = {
            memoizedState: $e7fc41517b66781c$var$N.memoizedState,
            baseState: $e7fc41517b66781c$var$N.baseState,
            baseQueue: $e7fc41517b66781c$var$N.baseQueue,
            queue: $e7fc41517b66781c$var$N.queue,
            next: null
        };
        null === $e7fc41517b66781c$var$O ? $e7fc41517b66781c$var$M.memoizedState = $e7fc41517b66781c$var$O = a : $e7fc41517b66781c$var$O = $e7fc41517b66781c$var$O.next = a;
    }
    return $e7fc41517b66781c$var$O;
}
function $e7fc41517b66781c$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e7fc41517b66781c$var$Wh(a) {
    var b = $e7fc41517b66781c$var$Uh(), c = b.queue;
    if (null === c) throw Error($e7fc41517b66781c$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e7fc41517b66781c$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e7fc41517b66781c$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e7fc41517b66781c$var$M.lanes |= m;
                $e7fc41517b66781c$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e7fc41517b66781c$var$He(d, b.memoizedState) || ($e7fc41517b66781c$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e7fc41517b66781c$var$M.lanes |= f, $e7fc41517b66781c$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e7fc41517b66781c$var$Xh(a) {
    var b = $e7fc41517b66781c$var$Uh(), c = b.queue;
    if (null === c) throw Error($e7fc41517b66781c$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e7fc41517b66781c$var$He(f, b.memoizedState) || ($e7fc41517b66781c$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e7fc41517b66781c$var$Yh() {}
function $e7fc41517b66781c$var$Zh(a, b) {
    var c = $e7fc41517b66781c$var$M, d = $e7fc41517b66781c$var$Uh(), e = b(), f = !$e7fc41517b66781c$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e7fc41517b66781c$var$dh = !0);
    d = d.queue;
    $e7fc41517b66781c$var$$h($e7fc41517b66781c$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e7fc41517b66781c$var$O && $e7fc41517b66781c$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e7fc41517b66781c$var$bi(9, $e7fc41517b66781c$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $e7fc41517b66781c$var$Q) throw Error($e7fc41517b66781c$var$p(349));
        0 !== ($e7fc41517b66781c$var$Hh & 30) || $e7fc41517b66781c$var$di(c, b, e);
    }
    return e;
}
function $e7fc41517b66781c$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e7fc41517b66781c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e7fc41517b66781c$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e7fc41517b66781c$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e7fc41517b66781c$var$ei(b) && $e7fc41517b66781c$var$fi(a);
}
function $e7fc41517b66781c$var$ai(a, b, c) {
    return c(function() {
        $e7fc41517b66781c$var$ei(b) && $e7fc41517b66781c$var$fi(a);
    });
}
function $e7fc41517b66781c$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e7fc41517b66781c$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e7fc41517b66781c$var$fi(a) {
    var b = $e7fc41517b66781c$var$ih(a, 1);
    null !== b && $e7fc41517b66781c$var$gi(b, a, 1, -1);
}
function $e7fc41517b66781c$var$hi(a) {
    var b = $e7fc41517b66781c$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e7fc41517b66781c$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e7fc41517b66781c$var$ii.bind(null, $e7fc41517b66781c$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e7fc41517b66781c$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e7fc41517b66781c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e7fc41517b66781c$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e7fc41517b66781c$var$ji() {
    return $e7fc41517b66781c$var$Uh().memoizedState;
}
function $e7fc41517b66781c$var$ki(a, b, c, d) {
    var e = $e7fc41517b66781c$var$Th();
    $e7fc41517b66781c$var$M.flags |= a;
    e.memoizedState = $e7fc41517b66781c$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e7fc41517b66781c$var$li(a, b, c, d) {
    var e = $e7fc41517b66781c$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e7fc41517b66781c$var$N) {
        var g = $e7fc41517b66781c$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $e7fc41517b66781c$var$Mh(d, g.deps)) {
            e.memoizedState = $e7fc41517b66781c$var$bi(b, c, f, d);
            return;
        }
    }
    $e7fc41517b66781c$var$M.flags |= a;
    e.memoizedState = $e7fc41517b66781c$var$bi(1 | b, c, f, d);
}
function $e7fc41517b66781c$var$mi(a, b) {
    return $e7fc41517b66781c$var$ki(8390656, 8, a, b);
}
function $e7fc41517b66781c$var$$h(a, b) {
    return $e7fc41517b66781c$var$li(2048, 8, a, b);
}
function $e7fc41517b66781c$var$ni(a, b) {
    return $e7fc41517b66781c$var$li(4, 2, a, b);
}
function $e7fc41517b66781c$var$oi(a, b) {
    return $e7fc41517b66781c$var$li(4, 4, a, b);
}
function $e7fc41517b66781c$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e7fc41517b66781c$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e7fc41517b66781c$var$li(4, 4, $e7fc41517b66781c$var$pi.bind(null, b, a), c);
}
function $e7fc41517b66781c$var$ri() {}
function $e7fc41517b66781c$var$si(a, b) {
    var c = $e7fc41517b66781c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e7fc41517b66781c$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e7fc41517b66781c$var$ti(a, b) {
    var c = $e7fc41517b66781c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e7fc41517b66781c$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e7fc41517b66781c$var$ui(a, b, c) {
    if (0 === ($e7fc41517b66781c$var$Hh & 21)) return a.baseState && (a.baseState = !1, $e7fc41517b66781c$var$dh = !0), a.memoizedState = c;
    $e7fc41517b66781c$var$He(c, b) || (c = $e7fc41517b66781c$var$yc(), $e7fc41517b66781c$var$M.lanes |= c, $e7fc41517b66781c$var$rh |= c, a.baseState = !0);
    return b;
}
function $e7fc41517b66781c$var$vi(a, b) {
    var c = $e7fc41517b66781c$var$C;
    $e7fc41517b66781c$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e7fc41517b66781c$var$Gh.transition;
    $e7fc41517b66781c$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e7fc41517b66781c$var$C = c, $e7fc41517b66781c$var$Gh.transition = d;
    }
}
function $e7fc41517b66781c$var$wi() {
    return $e7fc41517b66781c$var$Uh().memoizedState;
}
function $e7fc41517b66781c$var$xi(a, b, c) {
    var d = $e7fc41517b66781c$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e7fc41517b66781c$var$zi(a)) $e7fc41517b66781c$var$Ai(b, c);
    else if (c = $e7fc41517b66781c$var$hh(a, b, c, d), null !== c) {
        var e = $e7fc41517b66781c$var$R();
        $e7fc41517b66781c$var$gi(c, a, d, e);
        $e7fc41517b66781c$var$Bi(c, b, d);
    }
}
function $e7fc41517b66781c$var$ii(a, b, c) {
    var d = $e7fc41517b66781c$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e7fc41517b66781c$var$zi(a)) $e7fc41517b66781c$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e7fc41517b66781c$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e7fc41517b66781c$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e7fc41517b66781c$var$hh(a, b, e, d);
        null !== c && (e = $e7fc41517b66781c$var$R(), $e7fc41517b66781c$var$gi(c, a, d, e), $e7fc41517b66781c$var$Bi(c, b, d));
    }
}
function $e7fc41517b66781c$var$zi(a) {
    var b = a.alternate;
    return a === $e7fc41517b66781c$var$M || null !== b && b === $e7fc41517b66781c$var$M;
}
function $e7fc41517b66781c$var$Ai(a, b) {
    $e7fc41517b66781c$var$Jh = $e7fc41517b66781c$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e7fc41517b66781c$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e7fc41517b66781c$var$Cc(a, c);
    }
}
var $e7fc41517b66781c$var$Rh = {
    readContext: $e7fc41517b66781c$var$eh,
    useCallback: $e7fc41517b66781c$var$P,
    useContext: $e7fc41517b66781c$var$P,
    useEffect: $e7fc41517b66781c$var$P,
    useImperativeHandle: $e7fc41517b66781c$var$P,
    useInsertionEffect: $e7fc41517b66781c$var$P,
    useLayoutEffect: $e7fc41517b66781c$var$P,
    useMemo: $e7fc41517b66781c$var$P,
    useReducer: $e7fc41517b66781c$var$P,
    useRef: $e7fc41517b66781c$var$P,
    useState: $e7fc41517b66781c$var$P,
    useDebugValue: $e7fc41517b66781c$var$P,
    useDeferredValue: $e7fc41517b66781c$var$P,
    useTransition: $e7fc41517b66781c$var$P,
    useMutableSource: $e7fc41517b66781c$var$P,
    useSyncExternalStore: $e7fc41517b66781c$var$P,
    useId: $e7fc41517b66781c$var$P,
    unstable_isNewReconciler: !1
}, $e7fc41517b66781c$var$Oh = {
    readContext: $e7fc41517b66781c$var$eh,
    useCallback: function(a, b) {
        $e7fc41517b66781c$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e7fc41517b66781c$var$eh,
    useEffect: $e7fc41517b66781c$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e7fc41517b66781c$var$ki(4194308, 4, $e7fc41517b66781c$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e7fc41517b66781c$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $e7fc41517b66781c$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e7fc41517b66781c$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e7fc41517b66781c$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e7fc41517b66781c$var$xi.bind(null, $e7fc41517b66781c$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $e7fc41517b66781c$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e7fc41517b66781c$var$hi,
    useDebugValue: $e7fc41517b66781c$var$ri,
    useDeferredValue: function(a) {
        return $e7fc41517b66781c$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $e7fc41517b66781c$var$hi(!1), b = a[0];
        a = $e7fc41517b66781c$var$vi.bind(null, a[1]);
        $e7fc41517b66781c$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $e7fc41517b66781c$var$M, e = $e7fc41517b66781c$var$Th();
        if ($e7fc41517b66781c$var$I) {
            if (void 0 === c) throw Error($e7fc41517b66781c$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e7fc41517b66781c$var$Q) throw Error($e7fc41517b66781c$var$p(349));
            0 !== ($e7fc41517b66781c$var$Hh & 30) || $e7fc41517b66781c$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e7fc41517b66781c$var$mi($e7fc41517b66781c$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e7fc41517b66781c$var$bi(9, $e7fc41517b66781c$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $e7fc41517b66781c$var$Th(), b = $e7fc41517b66781c$var$Q.identifierPrefix;
        if ($e7fc41517b66781c$var$I) {
            var c = $e7fc41517b66781c$var$sg;
            var d = $e7fc41517b66781c$var$rg;
            c = (d & ~(1 << 32 - $e7fc41517b66781c$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e7fc41517b66781c$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e7fc41517b66781c$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e7fc41517b66781c$var$Ph = {
    readContext: $e7fc41517b66781c$var$eh,
    useCallback: $e7fc41517b66781c$var$si,
    useContext: $e7fc41517b66781c$var$eh,
    useEffect: $e7fc41517b66781c$var$$h,
    useImperativeHandle: $e7fc41517b66781c$var$qi,
    useInsertionEffect: $e7fc41517b66781c$var$ni,
    useLayoutEffect: $e7fc41517b66781c$var$oi,
    useMemo: $e7fc41517b66781c$var$ti,
    useReducer: $e7fc41517b66781c$var$Wh,
    useRef: $e7fc41517b66781c$var$ji,
    useState: function() {
        return $e7fc41517b66781c$var$Wh($e7fc41517b66781c$var$Vh);
    },
    useDebugValue: $e7fc41517b66781c$var$ri,
    useDeferredValue: function(a) {
        var b = $e7fc41517b66781c$var$Uh();
        return $e7fc41517b66781c$var$ui(b, $e7fc41517b66781c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $e7fc41517b66781c$var$Wh($e7fc41517b66781c$var$Vh)[0], b = $e7fc41517b66781c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e7fc41517b66781c$var$Yh,
    useSyncExternalStore: $e7fc41517b66781c$var$Zh,
    useId: $e7fc41517b66781c$var$wi,
    unstable_isNewReconciler: !1
}, $e7fc41517b66781c$var$Qh = {
    readContext: $e7fc41517b66781c$var$eh,
    useCallback: $e7fc41517b66781c$var$si,
    useContext: $e7fc41517b66781c$var$eh,
    useEffect: $e7fc41517b66781c$var$$h,
    useImperativeHandle: $e7fc41517b66781c$var$qi,
    useInsertionEffect: $e7fc41517b66781c$var$ni,
    useLayoutEffect: $e7fc41517b66781c$var$oi,
    useMemo: $e7fc41517b66781c$var$ti,
    useReducer: $e7fc41517b66781c$var$Xh,
    useRef: $e7fc41517b66781c$var$ji,
    useState: function() {
        return $e7fc41517b66781c$var$Xh($e7fc41517b66781c$var$Vh);
    },
    useDebugValue: $e7fc41517b66781c$var$ri,
    useDeferredValue: function(a) {
        var b = $e7fc41517b66781c$var$Uh();
        return null === $e7fc41517b66781c$var$N ? b.memoizedState = a : $e7fc41517b66781c$var$ui(b, $e7fc41517b66781c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $e7fc41517b66781c$var$Xh($e7fc41517b66781c$var$Vh)[0], b = $e7fc41517b66781c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e7fc41517b66781c$var$Yh,
    useSyncExternalStore: $e7fc41517b66781c$var$Zh,
    useId: $e7fc41517b66781c$var$wi,
    unstable_isNewReconciler: !1
};
function $e7fc41517b66781c$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $e7fc41517b66781c$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $e7fc41517b66781c$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e7fc41517b66781c$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e7fc41517b66781c$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e7fc41517b66781c$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e7fc41517b66781c$var$R(), e = $e7fc41517b66781c$var$yi(a), f = $e7fc41517b66781c$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e7fc41517b66781c$var$nh(a, f, e);
        null !== b && ($e7fc41517b66781c$var$gi(b, a, e, d), $e7fc41517b66781c$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e7fc41517b66781c$var$R(), e = $e7fc41517b66781c$var$yi(a), f = $e7fc41517b66781c$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e7fc41517b66781c$var$nh(a, f, e);
        null !== b && ($e7fc41517b66781c$var$gi(b, a, e, d), $e7fc41517b66781c$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e7fc41517b66781c$var$R(), d = $e7fc41517b66781c$var$yi(a), e = $e7fc41517b66781c$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e7fc41517b66781c$var$nh(a, e, d);
        null !== b && ($e7fc41517b66781c$var$gi(b, a, d, c), $e7fc41517b66781c$var$oh(b, a, d));
    }
};
function $e7fc41517b66781c$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e7fc41517b66781c$var$Ie(c, d) || !$e7fc41517b66781c$var$Ie(e, f) : !0;
}
function $e7fc41517b66781c$var$Gi(a, b, c) {
    var d = !1, e = $e7fc41517b66781c$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e7fc41517b66781c$var$eh(f) : (e = $e7fc41517b66781c$var$Zf(b) ? $e7fc41517b66781c$var$Xf : $e7fc41517b66781c$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e7fc41517b66781c$var$Yf(a, e) : $e7fc41517b66781c$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e7fc41517b66781c$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e7fc41517b66781c$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e7fc41517b66781c$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $e7fc41517b66781c$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $e7fc41517b66781c$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e7fc41517b66781c$var$eh(f) : (f = $e7fc41517b66781c$var$Zf(b) ? $e7fc41517b66781c$var$Xf : $e7fc41517b66781c$var$H.current, e.context = $e7fc41517b66781c$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e7fc41517b66781c$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e7fc41517b66781c$var$Ei.enqueueReplaceState(e, e.state, null), $e7fc41517b66781c$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e7fc41517b66781c$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $e7fc41517b66781c$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e7fc41517b66781c$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e7fc41517b66781c$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e7fc41517b66781c$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $e7fc41517b66781c$var$Ni(a, b, c) {
    c = $e7fc41517b66781c$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e7fc41517b66781c$var$Oi || ($e7fc41517b66781c$var$Oi = !0, $e7fc41517b66781c$var$Pi = d);
        $e7fc41517b66781c$var$Li(a, b);
    };
    return c;
}
function $e7fc41517b66781c$var$Qi(a, b, c) {
    c = $e7fc41517b66781c$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e7fc41517b66781c$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e7fc41517b66781c$var$Li(a, b);
        "function" !== typeof d && (null === $e7fc41517b66781c$var$Ri ? $e7fc41517b66781c$var$Ri = new Set([
            this
        ]) : $e7fc41517b66781c$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $e7fc41517b66781c$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e7fc41517b66781c$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e7fc41517b66781c$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $e7fc41517b66781c$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e7fc41517b66781c$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e7fc41517b66781c$var$mh(-1, 1), b.tag = 2, $e7fc41517b66781c$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e7fc41517b66781c$var$Wi = $e7fc41517b66781c$var$ua.ReactCurrentOwner, $e7fc41517b66781c$var$dh = !1;
function $e7fc41517b66781c$var$Xi(a, b, c, d) {
    b.child = null === a ? $e7fc41517b66781c$var$Vg(b, null, c, d) : $e7fc41517b66781c$var$Ug(b, a.child, c, d);
}
function $e7fc41517b66781c$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e7fc41517b66781c$var$ch(b, e);
    d = $e7fc41517b66781c$var$Nh(a, b, c, d, f, e);
    c = $e7fc41517b66781c$var$Sh();
    if (null !== a && !$e7fc41517b66781c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e7fc41517b66781c$var$Zi(a, b, e);
    $e7fc41517b66781c$var$I && c && $e7fc41517b66781c$var$vg(b);
    b.flags |= 1;
    $e7fc41517b66781c$var$Xi(a, b, d, e);
    return b.child;
}
function $e7fc41517b66781c$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e7fc41517b66781c$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e7fc41517b66781c$var$bj(a, b, f, d, e);
        a = $e7fc41517b66781c$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e7fc41517b66781c$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e7fc41517b66781c$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $e7fc41517b66781c$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e7fc41517b66781c$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e7fc41517b66781c$var$Ie(f, d) && a.ref === b.ref) {
            if ($e7fc41517b66781c$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e7fc41517b66781c$var$dh = !0);
            else return b.lanes = a.lanes, $e7fc41517b66781c$var$Zi(a, b, e);
        }
    }
    return $e7fc41517b66781c$var$cj(a, b, c, d, e);
}
function $e7fc41517b66781c$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e7fc41517b66781c$var$G($e7fc41517b66781c$var$ej, $e7fc41517b66781c$var$fj), $e7fc41517b66781c$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e7fc41517b66781c$var$G($e7fc41517b66781c$var$ej, $e7fc41517b66781c$var$fj), $e7fc41517b66781c$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e7fc41517b66781c$var$G($e7fc41517b66781c$var$ej, $e7fc41517b66781c$var$fj);
            $e7fc41517b66781c$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e7fc41517b66781c$var$G($e7fc41517b66781c$var$ej, $e7fc41517b66781c$var$fj), $e7fc41517b66781c$var$fj |= d;
    $e7fc41517b66781c$var$Xi(a, b, e, c);
    return b.child;
}
function $e7fc41517b66781c$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e7fc41517b66781c$var$cj(a, b, c, d, e) {
    var f = $e7fc41517b66781c$var$Zf(c) ? $e7fc41517b66781c$var$Xf : $e7fc41517b66781c$var$H.current;
    f = $e7fc41517b66781c$var$Yf(b, f);
    $e7fc41517b66781c$var$ch(b, e);
    c = $e7fc41517b66781c$var$Nh(a, b, c, d, f, e);
    d = $e7fc41517b66781c$var$Sh();
    if (null !== a && !$e7fc41517b66781c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e7fc41517b66781c$var$Zi(a, b, e);
    $e7fc41517b66781c$var$I && d && $e7fc41517b66781c$var$vg(b);
    b.flags |= 1;
    $e7fc41517b66781c$var$Xi(a, b, c, e);
    return b.child;
}
function $e7fc41517b66781c$var$hj(a, b, c, d, e) {
    if ($e7fc41517b66781c$var$Zf(c)) {
        var f = !0;
        $e7fc41517b66781c$var$cg(b);
    } else f = !1;
    $e7fc41517b66781c$var$ch(b, e);
    if (null === b.stateNode) $e7fc41517b66781c$var$ij(a, b), $e7fc41517b66781c$var$Gi(b, c, d), $e7fc41517b66781c$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e7fc41517b66781c$var$eh(l) : (l = $e7fc41517b66781c$var$Zf(c) ? $e7fc41517b66781c$var$Xf : $e7fc41517b66781c$var$H.current, l = $e7fc41517b66781c$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e7fc41517b66781c$var$Hi(b, g, d, l);
        $e7fc41517b66781c$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $e7fc41517b66781c$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e7fc41517b66781c$var$Wf.current || $e7fc41517b66781c$var$jh ? ("function" === typeof m && ($e7fc41517b66781c$var$Di(b, c, m, d), k = b.memoizedState), (h = $e7fc41517b66781c$var$jh || $e7fc41517b66781c$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e7fc41517b66781c$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e7fc41517b66781c$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e7fc41517b66781c$var$eh(k) : (k = $e7fc41517b66781c$var$Zf(c) ? $e7fc41517b66781c$var$Xf : $e7fc41517b66781c$var$H.current, k = $e7fc41517b66781c$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e7fc41517b66781c$var$Hi(b, g, d, k);
        $e7fc41517b66781c$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $e7fc41517b66781c$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e7fc41517b66781c$var$Wf.current || $e7fc41517b66781c$var$jh ? ("function" === typeof y && ($e7fc41517b66781c$var$Di(b, c, y, d), n = b.memoizedState), (l = $e7fc41517b66781c$var$jh || $e7fc41517b66781c$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e7fc41517b66781c$var$jj(a, b, c, d, f, e);
}
function $e7fc41517b66781c$var$jj(a, b, c, d, e, f) {
    $e7fc41517b66781c$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e7fc41517b66781c$var$dg(b, c, !1), $e7fc41517b66781c$var$Zi(a, b, f);
    d = b.stateNode;
    $e7fc41517b66781c$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e7fc41517b66781c$var$Ug(b, a.child, null, f), b.child = $e7fc41517b66781c$var$Ug(b, null, h, f)) : $e7fc41517b66781c$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e7fc41517b66781c$var$dg(b, c, !0);
    return b.child;
}
function $e7fc41517b66781c$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e7fc41517b66781c$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e7fc41517b66781c$var$ag(a, b.context, !1);
    $e7fc41517b66781c$var$yh(a, b.containerInfo);
}
function $e7fc41517b66781c$var$lj(a, b, c, d, e) {
    $e7fc41517b66781c$var$Ig();
    $e7fc41517b66781c$var$Jg(e);
    b.flags |= 256;
    $e7fc41517b66781c$var$Xi(a, b, c, d);
    return b.child;
}
var $e7fc41517b66781c$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e7fc41517b66781c$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e7fc41517b66781c$var$oj(a, b, c) {
    var d = b.pendingProps, e = $e7fc41517b66781c$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e7fc41517b66781c$var$G($e7fc41517b66781c$var$L, e & 1);
    if (null === a) {
        $e7fc41517b66781c$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e7fc41517b66781c$var$pj(g, d, 0, null), a = $e7fc41517b66781c$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e7fc41517b66781c$var$nj(c), b.memoizedState = $e7fc41517b66781c$var$mj, a) : $e7fc41517b66781c$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e7fc41517b66781c$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e7fc41517b66781c$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e7fc41517b66781c$var$Pg(h, f) : (f = $e7fc41517b66781c$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e7fc41517b66781c$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e7fc41517b66781c$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e7fc41517b66781c$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e7fc41517b66781c$var$qj(a, b) {
    b = $e7fc41517b66781c$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e7fc41517b66781c$var$sj(a, b, c, d) {
    null !== d && $e7fc41517b66781c$var$Jg(d);
    $e7fc41517b66781c$var$Ug(b, a.child, null, c);
    a = $e7fc41517b66781c$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e7fc41517b66781c$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e7fc41517b66781c$var$Ki(Error($e7fc41517b66781c$var$p(422))), $e7fc41517b66781c$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e7fc41517b66781c$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e7fc41517b66781c$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e7fc41517b66781c$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $e7fc41517b66781c$var$nj(g);
        b.memoizedState = $e7fc41517b66781c$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e7fc41517b66781c$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e7fc41517b66781c$var$p(419));
        d = $e7fc41517b66781c$var$Ki(f, d, void 0);
        return $e7fc41517b66781c$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e7fc41517b66781c$var$dh || h) {
        d = $e7fc41517b66781c$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e7fc41517b66781c$var$ih(a, e), $e7fc41517b66781c$var$gi(d, a, e, -1));
        }
        $e7fc41517b66781c$var$tj();
        d = $e7fc41517b66781c$var$Ki(Error($e7fc41517b66781c$var$p(421)));
        return $e7fc41517b66781c$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e7fc41517b66781c$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e7fc41517b66781c$var$yg = $e7fc41517b66781c$var$Lf(e.nextSibling);
    $e7fc41517b66781c$var$xg = b;
    $e7fc41517b66781c$var$I = !0;
    $e7fc41517b66781c$var$zg = null;
    null !== a && ($e7fc41517b66781c$var$og[$e7fc41517b66781c$var$pg++] = $e7fc41517b66781c$var$rg, $e7fc41517b66781c$var$og[$e7fc41517b66781c$var$pg++] = $e7fc41517b66781c$var$sg, $e7fc41517b66781c$var$og[$e7fc41517b66781c$var$pg++] = $e7fc41517b66781c$var$qg, $e7fc41517b66781c$var$rg = a.id, $e7fc41517b66781c$var$sg = a.overflow, $e7fc41517b66781c$var$qg = b);
    b = $e7fc41517b66781c$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e7fc41517b66781c$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e7fc41517b66781c$var$bh(a.return, b, c);
}
function $e7fc41517b66781c$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e7fc41517b66781c$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e7fc41517b66781c$var$Xi(a, b, d.children, c);
    d = $e7fc41517b66781c$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e7fc41517b66781c$var$vj(a, c, b);
            else if (19 === a.tag) $e7fc41517b66781c$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e7fc41517b66781c$var$G($e7fc41517b66781c$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e7fc41517b66781c$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e7fc41517b66781c$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e7fc41517b66781c$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e7fc41517b66781c$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $e7fc41517b66781c$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e7fc41517b66781c$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e7fc41517b66781c$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e7fc41517b66781c$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e7fc41517b66781c$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e7fc41517b66781c$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e7fc41517b66781c$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e7fc41517b66781c$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $e7fc41517b66781c$var$kj(b);
            $e7fc41517b66781c$var$Ig();
            break;
        case 5:
            $e7fc41517b66781c$var$Ah(b);
            break;
        case 1:
            $e7fc41517b66781c$var$Zf(b.type) && $e7fc41517b66781c$var$cg(b);
            break;
        case 4:
            $e7fc41517b66781c$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e7fc41517b66781c$var$G($e7fc41517b66781c$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e7fc41517b66781c$var$G($e7fc41517b66781c$var$L, $e7fc41517b66781c$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e7fc41517b66781c$var$oj(a, b, c);
                $e7fc41517b66781c$var$G($e7fc41517b66781c$var$L, $e7fc41517b66781c$var$L.current & 1);
                a = $e7fc41517b66781c$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e7fc41517b66781c$var$G($e7fc41517b66781c$var$L, $e7fc41517b66781c$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e7fc41517b66781c$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e7fc41517b66781c$var$G($e7fc41517b66781c$var$L, $e7fc41517b66781c$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e7fc41517b66781c$var$dj(a, b, c);
    }
    return $e7fc41517b66781c$var$Zi(a, b, c);
}
var $e7fc41517b66781c$var$zj, $e7fc41517b66781c$var$Aj, $e7fc41517b66781c$var$Bj, $e7fc41517b66781c$var$Cj;
$e7fc41517b66781c$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e7fc41517b66781c$var$Aj = function() {};
$e7fc41517b66781c$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e7fc41517b66781c$var$xh($e7fc41517b66781c$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e7fc41517b66781c$var$Ya(a, e);
                d = $e7fc41517b66781c$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e7fc41517b66781c$var$A({}, e, {
                    value: void 0
                });
                d = $e7fc41517b66781c$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e7fc41517b66781c$var$gb(a, e);
                d = $e7fc41517b66781c$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e7fc41517b66781c$var$Bf);
        }
        $e7fc41517b66781c$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e7fc41517b66781c$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e7fc41517b66781c$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e7fc41517b66781c$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e7fc41517b66781c$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e7fc41517b66781c$var$Dj(a, b) {
    if (!$e7fc41517b66781c$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e7fc41517b66781c$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e7fc41517b66781c$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $e7fc41517b66781c$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e7fc41517b66781c$var$S(b), null;
        case 1:
            return $e7fc41517b66781c$var$Zf(b.type) && $e7fc41517b66781c$var$$f(), $e7fc41517b66781c$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e7fc41517b66781c$var$zh();
            $e7fc41517b66781c$var$E($e7fc41517b66781c$var$Wf);
            $e7fc41517b66781c$var$E($e7fc41517b66781c$var$H);
            $e7fc41517b66781c$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e7fc41517b66781c$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e7fc41517b66781c$var$zg && ($e7fc41517b66781c$var$Fj($e7fc41517b66781c$var$zg), $e7fc41517b66781c$var$zg = null));
            $e7fc41517b66781c$var$Aj(a, b);
            $e7fc41517b66781c$var$S(b);
            return null;
        case 5:
            $e7fc41517b66781c$var$Bh(b);
            var e = $e7fc41517b66781c$var$xh($e7fc41517b66781c$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e7fc41517b66781c$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e7fc41517b66781c$var$p(166));
                    $e7fc41517b66781c$var$S(b);
                    return null;
                }
                a = $e7fc41517b66781c$var$xh($e7fc41517b66781c$var$uh.current);
                if ($e7fc41517b66781c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e7fc41517b66781c$var$Of] = b;
                    d[$e7fc41517b66781c$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e7fc41517b66781c$var$D("cancel", d);
                            $e7fc41517b66781c$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e7fc41517b66781c$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e7fc41517b66781c$var$lf.length; e++)$e7fc41517b66781c$var$D($e7fc41517b66781c$var$lf[e], d);
                            break;
                        case "source":
                            $e7fc41517b66781c$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e7fc41517b66781c$var$D("error", d);
                            $e7fc41517b66781c$var$D("load", d);
                            break;
                        case "details":
                            $e7fc41517b66781c$var$D("toggle", d);
                            break;
                        case "input":
                            $e7fc41517b66781c$var$Za(d, f);
                            $e7fc41517b66781c$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e7fc41517b66781c$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e7fc41517b66781c$var$hb(d, f), $e7fc41517b66781c$var$D("invalid", d);
                    }
                    $e7fc41517b66781c$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e7fc41517b66781c$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e7fc41517b66781c$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e7fc41517b66781c$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e7fc41517b66781c$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e7fc41517b66781c$var$Va(d);
                            $e7fc41517b66781c$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e7fc41517b66781c$var$Va(d);
                            $e7fc41517b66781c$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e7fc41517b66781c$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e7fc41517b66781c$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e7fc41517b66781c$var$Of] = b;
                    a[$e7fc41517b66781c$var$Pf] = d;
                    $e7fc41517b66781c$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e7fc41517b66781c$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e7fc41517b66781c$var$D("cancel", a);
                                $e7fc41517b66781c$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e7fc41517b66781c$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e7fc41517b66781c$var$lf.length; e++)$e7fc41517b66781c$var$D($e7fc41517b66781c$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e7fc41517b66781c$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e7fc41517b66781c$var$D("error", a);
                                $e7fc41517b66781c$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e7fc41517b66781c$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e7fc41517b66781c$var$Za(a, d);
                                e = $e7fc41517b66781c$var$Ya(a, d);
                                $e7fc41517b66781c$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e7fc41517b66781c$var$A({}, d, {
                                    value: void 0
                                });
                                $e7fc41517b66781c$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e7fc41517b66781c$var$hb(a, d);
                                e = $e7fc41517b66781c$var$gb(a, d);
                                $e7fc41517b66781c$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e7fc41517b66781c$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e7fc41517b66781c$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e7fc41517b66781c$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e7fc41517b66781c$var$ob(a, k) : "number" === typeof k && $e7fc41517b66781c$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e7fc41517b66781c$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e7fc41517b66781c$var$D("scroll", a) : null != k && $e7fc41517b66781c$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e7fc41517b66781c$var$Va(a);
                                $e7fc41517b66781c$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e7fc41517b66781c$var$Va(a);
                                $e7fc41517b66781c$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e7fc41517b66781c$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e7fc41517b66781c$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e7fc41517b66781c$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e7fc41517b66781c$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e7fc41517b66781c$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e7fc41517b66781c$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e7fc41517b66781c$var$p(166));
                c = $e7fc41517b66781c$var$xh($e7fc41517b66781c$var$wh.current);
                $e7fc41517b66781c$var$xh($e7fc41517b66781c$var$uh.current);
                if ($e7fc41517b66781c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e7fc41517b66781c$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e7fc41517b66781c$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e7fc41517b66781c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e7fc41517b66781c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e7fc41517b66781c$var$Of] = b, b.stateNode = d;
            }
            $e7fc41517b66781c$var$S(b);
            return null;
        case 13:
            $e7fc41517b66781c$var$E($e7fc41517b66781c$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e7fc41517b66781c$var$I && null !== $e7fc41517b66781c$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e7fc41517b66781c$var$Hg(), $e7fc41517b66781c$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e7fc41517b66781c$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e7fc41517b66781c$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e7fc41517b66781c$var$p(317));
                        f[$e7fc41517b66781c$var$Of] = b;
                    } else $e7fc41517b66781c$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e7fc41517b66781c$var$S(b);
                    f = !1;
                } else null !== $e7fc41517b66781c$var$zg && ($e7fc41517b66781c$var$Fj($e7fc41517b66781c$var$zg), $e7fc41517b66781c$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e7fc41517b66781c$var$L.current & 1) ? 0 === $e7fc41517b66781c$var$T && ($e7fc41517b66781c$var$T = 3) : $e7fc41517b66781c$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e7fc41517b66781c$var$S(b);
            return null;
        case 4:
            return $e7fc41517b66781c$var$zh(), $e7fc41517b66781c$var$Aj(a, b), null === a && $e7fc41517b66781c$var$sf(b.stateNode.containerInfo), $e7fc41517b66781c$var$S(b), null;
        case 10:
            return $e7fc41517b66781c$var$ah(b.type._context), $e7fc41517b66781c$var$S(b), null;
        case 17:
            return $e7fc41517b66781c$var$Zf(b.type) && $e7fc41517b66781c$var$$f(), $e7fc41517b66781c$var$S(b), null;
        case 19:
            $e7fc41517b66781c$var$E($e7fc41517b66781c$var$L);
            f = b.memoizedState;
            if (null === f) return $e7fc41517b66781c$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e7fc41517b66781c$var$Dj(f, !1);
                else {
                    if (0 !== $e7fc41517b66781c$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e7fc41517b66781c$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e7fc41517b66781c$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e7fc41517b66781c$var$G($e7fc41517b66781c$var$L, $e7fc41517b66781c$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e7fc41517b66781c$var$B() > $e7fc41517b66781c$var$Gj && (b.flags |= 128, d = !0, $e7fc41517b66781c$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e7fc41517b66781c$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e7fc41517b66781c$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e7fc41517b66781c$var$I) return $e7fc41517b66781c$var$S(b), null;
                    } else 2 * $e7fc41517b66781c$var$B() - f.renderingStartTime > $e7fc41517b66781c$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $e7fc41517b66781c$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e7fc41517b66781c$var$B(), b.sibling = null, c = $e7fc41517b66781c$var$L.current, $e7fc41517b66781c$var$G($e7fc41517b66781c$var$L, d ? c & 1 | 2 : c & 1), b;
            $e7fc41517b66781c$var$S(b);
            return null;
        case 22:
        case 23:
            return $e7fc41517b66781c$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e7fc41517b66781c$var$fj & 1073741824) && ($e7fc41517b66781c$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e7fc41517b66781c$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e7fc41517b66781c$var$p(156, b.tag));
}
function $e7fc41517b66781c$var$Ij(a, b) {
    $e7fc41517b66781c$var$wg(b);
    switch(b.tag){
        case 1:
            return $e7fc41517b66781c$var$Zf(b.type) && $e7fc41517b66781c$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e7fc41517b66781c$var$zh(), $e7fc41517b66781c$var$E($e7fc41517b66781c$var$Wf), $e7fc41517b66781c$var$E($e7fc41517b66781c$var$H), $e7fc41517b66781c$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e7fc41517b66781c$var$Bh(b), null;
        case 13:
            $e7fc41517b66781c$var$E($e7fc41517b66781c$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e7fc41517b66781c$var$p(340));
                $e7fc41517b66781c$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e7fc41517b66781c$var$E($e7fc41517b66781c$var$L), null;
        case 4:
            return $e7fc41517b66781c$var$zh(), null;
        case 10:
            return $e7fc41517b66781c$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $e7fc41517b66781c$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e7fc41517b66781c$var$Jj = !1, $e7fc41517b66781c$var$U = !1, $e7fc41517b66781c$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $e7fc41517b66781c$var$V = null;
function $e7fc41517b66781c$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e7fc41517b66781c$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e7fc41517b66781c$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e7fc41517b66781c$var$W(a, b, d);
    }
}
var $e7fc41517b66781c$var$Nj = !1;
function $e7fc41517b66781c$var$Oj(a, b) {
    $e7fc41517b66781c$var$Cf = $e7fc41517b66781c$var$dd;
    a = $e7fc41517b66781c$var$Me();
    if ($e7fc41517b66781c$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e7fc41517b66781c$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e7fc41517b66781c$var$dd = !1;
    for($e7fc41517b66781c$var$V = b; null !== $e7fc41517b66781c$var$V;)if (b = $e7fc41517b66781c$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e7fc41517b66781c$var$V = a;
    else for(; null !== $e7fc41517b66781c$var$V;){
        b = $e7fc41517b66781c$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e7fc41517b66781c$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e7fc41517b66781c$var$p(163));
            }
        } catch (F) {
            $e7fc41517b66781c$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e7fc41517b66781c$var$V = a;
            break;
        }
        $e7fc41517b66781c$var$V = b.return;
    }
    n = $e7fc41517b66781c$var$Nj;
    $e7fc41517b66781c$var$Nj = !1;
    return n;
}
function $e7fc41517b66781c$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e7fc41517b66781c$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e7fc41517b66781c$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e7fc41517b66781c$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e7fc41517b66781c$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e7fc41517b66781c$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e7fc41517b66781c$var$Of], delete b[$e7fc41517b66781c$var$Pf], delete b[$e7fc41517b66781c$var$of], delete b[$e7fc41517b66781c$var$Qf], delete b[$e7fc41517b66781c$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e7fc41517b66781c$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e7fc41517b66781c$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e7fc41517b66781c$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e7fc41517b66781c$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e7fc41517b66781c$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e7fc41517b66781c$var$Vj(a, b, c), a = a.sibling; null !== a;)$e7fc41517b66781c$var$Vj(a, b, c), a = a.sibling;
}
function $e7fc41517b66781c$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e7fc41517b66781c$var$Wj(a, b, c), a = a.sibling; null !== a;)$e7fc41517b66781c$var$Wj(a, b, c), a = a.sibling;
}
var $e7fc41517b66781c$var$X = null, $e7fc41517b66781c$var$Xj = !1;
function $e7fc41517b66781c$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$e7fc41517b66781c$var$Zj(a, b, c), c = c.sibling;
}
function $e7fc41517b66781c$var$Zj(a, b, c) {
    if ($e7fc41517b66781c$var$lc && "function" === typeof $e7fc41517b66781c$var$lc.onCommitFiberUnmount) try {
        $e7fc41517b66781c$var$lc.onCommitFiberUnmount($e7fc41517b66781c$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e7fc41517b66781c$var$U || $e7fc41517b66781c$var$Lj(c, b);
        case 6:
            var d = $e7fc41517b66781c$var$X, e = $e7fc41517b66781c$var$Xj;
            $e7fc41517b66781c$var$X = null;
            $e7fc41517b66781c$var$Yj(a, b, c);
            $e7fc41517b66781c$var$X = d;
            $e7fc41517b66781c$var$Xj = e;
            null !== $e7fc41517b66781c$var$X && ($e7fc41517b66781c$var$Xj ? (a = $e7fc41517b66781c$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e7fc41517b66781c$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e7fc41517b66781c$var$X && ($e7fc41517b66781c$var$Xj ? (a = $e7fc41517b66781c$var$X, c = c.stateNode, 8 === a.nodeType ? $e7fc41517b66781c$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e7fc41517b66781c$var$Kf(a, c), $e7fc41517b66781c$var$bd(a)) : $e7fc41517b66781c$var$Kf($e7fc41517b66781c$var$X, c.stateNode));
            break;
        case 4:
            d = $e7fc41517b66781c$var$X;
            e = $e7fc41517b66781c$var$Xj;
            $e7fc41517b66781c$var$X = c.stateNode.containerInfo;
            $e7fc41517b66781c$var$Xj = !0;
            $e7fc41517b66781c$var$Yj(a, b, c);
            $e7fc41517b66781c$var$X = d;
            $e7fc41517b66781c$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e7fc41517b66781c$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e7fc41517b66781c$var$Mj(c, b, g) : 0 !== (f & 4) && $e7fc41517b66781c$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e7fc41517b66781c$var$Yj(a, b, c);
            break;
        case 1:
            if (!$e7fc41517b66781c$var$U && ($e7fc41517b66781c$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e7fc41517b66781c$var$W(c, b, h);
            }
            $e7fc41517b66781c$var$Yj(a, b, c);
            break;
        case 21:
            $e7fc41517b66781c$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e7fc41517b66781c$var$U = (d = $e7fc41517b66781c$var$U) || null !== c.memoizedState, $e7fc41517b66781c$var$Yj(a, b, c), $e7fc41517b66781c$var$U = d) : $e7fc41517b66781c$var$Yj(a, b, c);
            break;
        default:
            $e7fc41517b66781c$var$Yj(a, b, c);
    }
}
function $e7fc41517b66781c$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e7fc41517b66781c$var$Kj);
        b.forEach(function(b) {
            var d = $e7fc41517b66781c$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e7fc41517b66781c$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e7fc41517b66781c$var$X = h.stateNode;
                        $e7fc41517b66781c$var$Xj = !1;
                        break a;
                    case 3:
                        $e7fc41517b66781c$var$X = h.stateNode.containerInfo;
                        $e7fc41517b66781c$var$Xj = !0;
                        break a;
                    case 4:
                        $e7fc41517b66781c$var$X = h.stateNode.containerInfo;
                        $e7fc41517b66781c$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e7fc41517b66781c$var$X) throw Error($e7fc41517b66781c$var$p(160));
            $e7fc41517b66781c$var$Zj(f, g, e);
            $e7fc41517b66781c$var$X = null;
            $e7fc41517b66781c$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e7fc41517b66781c$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e7fc41517b66781c$var$dk(b, a), b = b.sibling;
}
function $e7fc41517b66781c$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e7fc41517b66781c$var$ck(b, a);
            $e7fc41517b66781c$var$ek(a);
            if (d & 4) {
                try {
                    $e7fc41517b66781c$var$Pj(3, a, a.return), $e7fc41517b66781c$var$Qj(3, a);
                } catch (t) {
                    $e7fc41517b66781c$var$W(a, a.return, t);
                }
                try {
                    $e7fc41517b66781c$var$Pj(5, a, a.return);
                } catch (t) {
                    $e7fc41517b66781c$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e7fc41517b66781c$var$ck(b, a);
            $e7fc41517b66781c$var$ek(a);
            d & 512 && null !== c && $e7fc41517b66781c$var$Lj(c, c.return);
            break;
        case 5:
            $e7fc41517b66781c$var$ck(b, a);
            $e7fc41517b66781c$var$ek(a);
            d & 512 && null !== c && $e7fc41517b66781c$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e7fc41517b66781c$var$ob(e, "");
                } catch (t) {
                    $e7fc41517b66781c$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e7fc41517b66781c$var$ab(e, f);
                    $e7fc41517b66781c$var$vb(h, g);
                    var l = $e7fc41517b66781c$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e7fc41517b66781c$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e7fc41517b66781c$var$nb(e, q) : "children" === m ? $e7fc41517b66781c$var$ob(e, q) : $e7fc41517b66781c$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e7fc41517b66781c$var$bb(e, f);
                            break;
                        case "textarea":
                            $e7fc41517b66781c$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e7fc41517b66781c$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e7fc41517b66781c$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e7fc41517b66781c$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e7fc41517b66781c$var$Pf] = f;
                } catch (t) {
                    $e7fc41517b66781c$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e7fc41517b66781c$var$ck(b, a);
            $e7fc41517b66781c$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e7fc41517b66781c$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e7fc41517b66781c$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e7fc41517b66781c$var$ck(b, a);
            $e7fc41517b66781c$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e7fc41517b66781c$var$bd(b.containerInfo);
            } catch (t) {
                $e7fc41517b66781c$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e7fc41517b66781c$var$ck(b, a);
            $e7fc41517b66781c$var$ek(a);
            break;
        case 13:
            $e7fc41517b66781c$var$ck(b, a);
            $e7fc41517b66781c$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e7fc41517b66781c$var$fk = $e7fc41517b66781c$var$B()));
            d & 4 && $e7fc41517b66781c$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e7fc41517b66781c$var$U = (l = $e7fc41517b66781c$var$U) || m, $e7fc41517b66781c$var$ck(b, a), $e7fc41517b66781c$var$U = l) : $e7fc41517b66781c$var$ck(b, a);
            $e7fc41517b66781c$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e7fc41517b66781c$var$V = a, m = a.child; null !== m;){
                    for(q = $e7fc41517b66781c$var$V = m; null !== $e7fc41517b66781c$var$V;){
                        r = $e7fc41517b66781c$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e7fc41517b66781c$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $e7fc41517b66781c$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e7fc41517b66781c$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e7fc41517b66781c$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e7fc41517b66781c$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e7fc41517b66781c$var$V = y) : $e7fc41517b66781c$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e7fc41517b66781c$var$rb("display", g));
                            } catch (t) {
                                $e7fc41517b66781c$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e7fc41517b66781c$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e7fc41517b66781c$var$ck(b, a);
            $e7fc41517b66781c$var$ek(a);
            d & 4 && $e7fc41517b66781c$var$ak(a);
            break;
        case 21:
            break;
        default:
            $e7fc41517b66781c$var$ck(b, a), $e7fc41517b66781c$var$ek(a);
    }
}
function $e7fc41517b66781c$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e7fc41517b66781c$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e7fc41517b66781c$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e7fc41517b66781c$var$ob(e, ""), d.flags &= -33);
                    var f = $e7fc41517b66781c$var$Uj(a);
                    $e7fc41517b66781c$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e7fc41517b66781c$var$Uj(a);
                    $e7fc41517b66781c$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($e7fc41517b66781c$var$p(161));
            }
        } catch (k) {
            $e7fc41517b66781c$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e7fc41517b66781c$var$hk(a, b, c) {
    $e7fc41517b66781c$var$V = a;
    $e7fc41517b66781c$var$ik(a, b, c);
}
function $e7fc41517b66781c$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e7fc41517b66781c$var$V;){
        var e = $e7fc41517b66781c$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e7fc41517b66781c$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e7fc41517b66781c$var$U;
                h = $e7fc41517b66781c$var$Jj;
                var l = $e7fc41517b66781c$var$U;
                $e7fc41517b66781c$var$Jj = g;
                if (($e7fc41517b66781c$var$U = k) && !l) for($e7fc41517b66781c$var$V = e; null !== $e7fc41517b66781c$var$V;)g = $e7fc41517b66781c$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e7fc41517b66781c$var$jk(e) : null !== k ? (k.return = g, $e7fc41517b66781c$var$V = k) : $e7fc41517b66781c$var$jk(e);
                for(; null !== f;)$e7fc41517b66781c$var$V = f, $e7fc41517b66781c$var$ik(f, b, c), f = f.sibling;
                $e7fc41517b66781c$var$V = e;
                $e7fc41517b66781c$var$Jj = h;
                $e7fc41517b66781c$var$U = l;
            }
            $e7fc41517b66781c$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e7fc41517b66781c$var$V = f) : $e7fc41517b66781c$var$kk(a, b, c);
    }
}
function $e7fc41517b66781c$var$kk(a) {
    for(; null !== $e7fc41517b66781c$var$V;){
        var b = $e7fc41517b66781c$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e7fc41517b66781c$var$U || $e7fc41517b66781c$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e7fc41517b66781c$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e7fc41517b66781c$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e7fc41517b66781c$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e7fc41517b66781c$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e7fc41517b66781c$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e7fc41517b66781c$var$p(163));
                }
                $e7fc41517b66781c$var$U || b.flags & 512 && $e7fc41517b66781c$var$Rj(b);
            } catch (r) {
                $e7fc41517b66781c$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e7fc41517b66781c$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e7fc41517b66781c$var$V = c;
            break;
        }
        $e7fc41517b66781c$var$V = b.return;
    }
}
function $e7fc41517b66781c$var$gk(a) {
    for(; null !== $e7fc41517b66781c$var$V;){
        var b = $e7fc41517b66781c$var$V;
        if (b === a) {
            $e7fc41517b66781c$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e7fc41517b66781c$var$V = c;
            break;
        }
        $e7fc41517b66781c$var$V = b.return;
    }
}
function $e7fc41517b66781c$var$jk(a) {
    for(; null !== $e7fc41517b66781c$var$V;){
        var b = $e7fc41517b66781c$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e7fc41517b66781c$var$Qj(4, b);
                    } catch (k) {
                        $e7fc41517b66781c$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e7fc41517b66781c$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e7fc41517b66781c$var$Rj(b);
                    } catch (k) {
                        $e7fc41517b66781c$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e7fc41517b66781c$var$Rj(b);
                    } catch (k) {
                        $e7fc41517b66781c$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e7fc41517b66781c$var$W(b, b.return, k);
        }
        if (b === a) {
            $e7fc41517b66781c$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e7fc41517b66781c$var$V = h;
            break;
        }
        $e7fc41517b66781c$var$V = b.return;
    }
}
var $e7fc41517b66781c$var$lk = Math.ceil, $e7fc41517b66781c$var$mk = $e7fc41517b66781c$var$ua.ReactCurrentDispatcher, $e7fc41517b66781c$var$nk = $e7fc41517b66781c$var$ua.ReactCurrentOwner, $e7fc41517b66781c$var$ok = $e7fc41517b66781c$var$ua.ReactCurrentBatchConfig, $e7fc41517b66781c$var$K = 0, $e7fc41517b66781c$var$Q = null, $e7fc41517b66781c$var$Y = null, $e7fc41517b66781c$var$Z = 0, $e7fc41517b66781c$var$fj = 0, $e7fc41517b66781c$var$ej = $e7fc41517b66781c$var$Uf(0), $e7fc41517b66781c$var$T = 0, $e7fc41517b66781c$var$pk = null, $e7fc41517b66781c$var$rh = 0, $e7fc41517b66781c$var$qk = 0, $e7fc41517b66781c$var$rk = 0, $e7fc41517b66781c$var$sk = null, $e7fc41517b66781c$var$tk = null, $e7fc41517b66781c$var$fk = 0, $e7fc41517b66781c$var$Gj = Infinity, $e7fc41517b66781c$var$uk = null, $e7fc41517b66781c$var$Oi = !1, $e7fc41517b66781c$var$Pi = null, $e7fc41517b66781c$var$Ri = null, $e7fc41517b66781c$var$vk = !1, $e7fc41517b66781c$var$wk = null, $e7fc41517b66781c$var$xk = 0, $e7fc41517b66781c$var$yk = 0, $e7fc41517b66781c$var$zk = null, $e7fc41517b66781c$var$Ak = -1, $e7fc41517b66781c$var$Bk = 0;
function $e7fc41517b66781c$var$R() {
    return 0 !== ($e7fc41517b66781c$var$K & 6) ? $e7fc41517b66781c$var$B() : -1 !== $e7fc41517b66781c$var$Ak ? $e7fc41517b66781c$var$Ak : $e7fc41517b66781c$var$Ak = $e7fc41517b66781c$var$B();
}
function $e7fc41517b66781c$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e7fc41517b66781c$var$K & 2) && 0 !== $e7fc41517b66781c$var$Z) return $e7fc41517b66781c$var$Z & -$e7fc41517b66781c$var$Z;
    if (null !== $e7fc41517b66781c$var$Kg.transition) return 0 === $e7fc41517b66781c$var$Bk && ($e7fc41517b66781c$var$Bk = $e7fc41517b66781c$var$yc()), $e7fc41517b66781c$var$Bk;
    a = $e7fc41517b66781c$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e7fc41517b66781c$var$jd(a.type);
    return a;
}
function $e7fc41517b66781c$var$gi(a, b, c, d) {
    if (50 < $e7fc41517b66781c$var$yk) throw $e7fc41517b66781c$var$yk = 0, $e7fc41517b66781c$var$zk = null, Error($e7fc41517b66781c$var$p(185));
    $e7fc41517b66781c$var$Ac(a, c, d);
    if (0 === ($e7fc41517b66781c$var$K & 2) || a !== $e7fc41517b66781c$var$Q) a === $e7fc41517b66781c$var$Q && (0 === ($e7fc41517b66781c$var$K & 2) && ($e7fc41517b66781c$var$qk |= c), 4 === $e7fc41517b66781c$var$T && $e7fc41517b66781c$var$Ck(a, $e7fc41517b66781c$var$Z)), $e7fc41517b66781c$var$Dk(a, d), 1 === c && 0 === $e7fc41517b66781c$var$K && 0 === (b.mode & 1) && ($e7fc41517b66781c$var$Gj = $e7fc41517b66781c$var$B() + 500, $e7fc41517b66781c$var$fg && $e7fc41517b66781c$var$jg());
}
function $e7fc41517b66781c$var$Dk(a, b) {
    var c = a.callbackNode;
    $e7fc41517b66781c$var$wc(a, b);
    var d = $e7fc41517b66781c$var$uc(a, a === $e7fc41517b66781c$var$Q ? $e7fc41517b66781c$var$Z : 0);
    if (0 === d) null !== c && $e7fc41517b66781c$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e7fc41517b66781c$var$bc(c);
        if (1 === b) 0 === a.tag ? $e7fc41517b66781c$var$ig($e7fc41517b66781c$var$Ek.bind(null, a)) : $e7fc41517b66781c$var$hg($e7fc41517b66781c$var$Ek.bind(null, a)), $e7fc41517b66781c$var$Jf(function() {
            0 === ($e7fc41517b66781c$var$K & 6) && $e7fc41517b66781c$var$jg();
        }), c = null;
        else {
            switch($e7fc41517b66781c$var$Dc(d)){
                case 1:
                    c = $e7fc41517b66781c$var$fc;
                    break;
                case 4:
                    c = $e7fc41517b66781c$var$gc;
                    break;
                case 16:
                    c = $e7fc41517b66781c$var$hc;
                    break;
                case 536870912:
                    c = $e7fc41517b66781c$var$jc;
                    break;
                default:
                    c = $e7fc41517b66781c$var$hc;
            }
            c = $e7fc41517b66781c$var$Fk(c, $e7fc41517b66781c$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e7fc41517b66781c$var$Gk(a, b) {
    $e7fc41517b66781c$var$Ak = -1;
    $e7fc41517b66781c$var$Bk = 0;
    if (0 !== ($e7fc41517b66781c$var$K & 6)) throw Error($e7fc41517b66781c$var$p(327));
    var c = a.callbackNode;
    if ($e7fc41517b66781c$var$Hk() && a.callbackNode !== c) return null;
    var d = $e7fc41517b66781c$var$uc(a, a === $e7fc41517b66781c$var$Q ? $e7fc41517b66781c$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e7fc41517b66781c$var$Ik(a, d);
    else {
        b = d;
        var e = $e7fc41517b66781c$var$K;
        $e7fc41517b66781c$var$K |= 2;
        var f = $e7fc41517b66781c$var$Jk();
        if ($e7fc41517b66781c$var$Q !== a || $e7fc41517b66781c$var$Z !== b) $e7fc41517b66781c$var$uk = null, $e7fc41517b66781c$var$Gj = $e7fc41517b66781c$var$B() + 500, $e7fc41517b66781c$var$Kk(a, b);
        for(;;)try {
            $e7fc41517b66781c$var$Lk();
            break;
        } catch (h) {
            $e7fc41517b66781c$var$Mk(a, h);
        }
        $e7fc41517b66781c$var$$g();
        $e7fc41517b66781c$var$mk.current = f;
        $e7fc41517b66781c$var$K = e;
        null !== $e7fc41517b66781c$var$Y ? b = 0 : ($e7fc41517b66781c$var$Q = null, $e7fc41517b66781c$var$Z = 0, b = $e7fc41517b66781c$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e7fc41517b66781c$var$xc(a), 0 !== e && (d = e, b = $e7fc41517b66781c$var$Nk(a, e)));
        if (1 === b) throw c = $e7fc41517b66781c$var$pk, $e7fc41517b66781c$var$Kk(a, 0), $e7fc41517b66781c$var$Ck(a, d), $e7fc41517b66781c$var$Dk(a, $e7fc41517b66781c$var$B()), c;
        if (6 === b) $e7fc41517b66781c$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e7fc41517b66781c$var$Ok(e) && (b = $e7fc41517b66781c$var$Ik(a, d), 2 === b && (f = $e7fc41517b66781c$var$xc(a), 0 !== f && (d = f, b = $e7fc41517b66781c$var$Nk(a, f))), 1 === b)) throw c = $e7fc41517b66781c$var$pk, $e7fc41517b66781c$var$Kk(a, 0), $e7fc41517b66781c$var$Ck(a, d), $e7fc41517b66781c$var$Dk(a, $e7fc41517b66781c$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e7fc41517b66781c$var$p(345));
                case 2:
                    $e7fc41517b66781c$var$Pk(a, $e7fc41517b66781c$var$tk, $e7fc41517b66781c$var$uk);
                    break;
                case 3:
                    $e7fc41517b66781c$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $e7fc41517b66781c$var$fk + 500 - $e7fc41517b66781c$var$B(), 10 < b)) {
                        if (0 !== $e7fc41517b66781c$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e7fc41517b66781c$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e7fc41517b66781c$var$Ff($e7fc41517b66781c$var$Pk.bind(null, a, $e7fc41517b66781c$var$tk, $e7fc41517b66781c$var$uk), b);
                        break;
                    }
                    $e7fc41517b66781c$var$Pk(a, $e7fc41517b66781c$var$tk, $e7fc41517b66781c$var$uk);
                    break;
                case 4:
                    $e7fc41517b66781c$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e7fc41517b66781c$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e7fc41517b66781c$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e7fc41517b66781c$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e7fc41517b66781c$var$Ff($e7fc41517b66781c$var$Pk.bind(null, a, $e7fc41517b66781c$var$tk, $e7fc41517b66781c$var$uk), d);
                        break;
                    }
                    $e7fc41517b66781c$var$Pk(a, $e7fc41517b66781c$var$tk, $e7fc41517b66781c$var$uk);
                    break;
                case 5:
                    $e7fc41517b66781c$var$Pk(a, $e7fc41517b66781c$var$tk, $e7fc41517b66781c$var$uk);
                    break;
                default:
                    throw Error($e7fc41517b66781c$var$p(329));
            }
        }
    }
    $e7fc41517b66781c$var$Dk(a, $e7fc41517b66781c$var$B());
    return a.callbackNode === c ? $e7fc41517b66781c$var$Gk.bind(null, a) : null;
}
function $e7fc41517b66781c$var$Nk(a, b) {
    var c = $e7fc41517b66781c$var$sk;
    a.current.memoizedState.isDehydrated && ($e7fc41517b66781c$var$Kk(a, b).flags |= 256);
    a = $e7fc41517b66781c$var$Ik(a, b);
    2 !== a && (b = $e7fc41517b66781c$var$tk, $e7fc41517b66781c$var$tk = c, null !== b && $e7fc41517b66781c$var$Fj(b));
    return a;
}
function $e7fc41517b66781c$var$Fj(a) {
    null === $e7fc41517b66781c$var$tk ? $e7fc41517b66781c$var$tk = a : $e7fc41517b66781c$var$tk.push.apply($e7fc41517b66781c$var$tk, a);
}
function $e7fc41517b66781c$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e7fc41517b66781c$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e7fc41517b66781c$var$Ck(a, b) {
    b &= ~$e7fc41517b66781c$var$rk;
    b &= ~$e7fc41517b66781c$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e7fc41517b66781c$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e7fc41517b66781c$var$Ek(a) {
    if (0 !== ($e7fc41517b66781c$var$K & 6)) throw Error($e7fc41517b66781c$var$p(327));
    $e7fc41517b66781c$var$Hk();
    var b = $e7fc41517b66781c$var$uc(a, 0);
    if (0 === (b & 1)) return $e7fc41517b66781c$var$Dk(a, $e7fc41517b66781c$var$B()), null;
    var c = $e7fc41517b66781c$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e7fc41517b66781c$var$xc(a);
        0 !== d && (b = d, c = $e7fc41517b66781c$var$Nk(a, d));
    }
    if (1 === c) throw c = $e7fc41517b66781c$var$pk, $e7fc41517b66781c$var$Kk(a, 0), $e7fc41517b66781c$var$Ck(a, b), $e7fc41517b66781c$var$Dk(a, $e7fc41517b66781c$var$B()), c;
    if (6 === c) throw Error($e7fc41517b66781c$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e7fc41517b66781c$var$Pk(a, $e7fc41517b66781c$var$tk, $e7fc41517b66781c$var$uk);
    $e7fc41517b66781c$var$Dk(a, $e7fc41517b66781c$var$B());
    return null;
}
function $e7fc41517b66781c$var$Qk(a, b) {
    var c = $e7fc41517b66781c$var$K;
    $e7fc41517b66781c$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e7fc41517b66781c$var$K = c, 0 === $e7fc41517b66781c$var$K && ($e7fc41517b66781c$var$Gj = $e7fc41517b66781c$var$B() + 500, $e7fc41517b66781c$var$fg && $e7fc41517b66781c$var$jg());
    }
}
function $e7fc41517b66781c$var$Rk(a) {
    null !== $e7fc41517b66781c$var$wk && 0 === $e7fc41517b66781c$var$wk.tag && 0 === ($e7fc41517b66781c$var$K & 6) && $e7fc41517b66781c$var$Hk();
    var b = $e7fc41517b66781c$var$K;
    $e7fc41517b66781c$var$K |= 1;
    var c = $e7fc41517b66781c$var$ok.transition, d = $e7fc41517b66781c$var$C;
    try {
        if ($e7fc41517b66781c$var$ok.transition = null, $e7fc41517b66781c$var$C = 1, a) return a();
    } finally{
        $e7fc41517b66781c$var$C = d, $e7fc41517b66781c$var$ok.transition = c, $e7fc41517b66781c$var$K = b, 0 === ($e7fc41517b66781c$var$K & 6) && $e7fc41517b66781c$var$jg();
    }
}
function $e7fc41517b66781c$var$Hj() {
    $e7fc41517b66781c$var$fj = $e7fc41517b66781c$var$ej.current;
    $e7fc41517b66781c$var$E($e7fc41517b66781c$var$ej);
}
function $e7fc41517b66781c$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e7fc41517b66781c$var$Gf(c));
    if (null !== $e7fc41517b66781c$var$Y) for(c = $e7fc41517b66781c$var$Y.return; null !== c;){
        var d = c;
        $e7fc41517b66781c$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e7fc41517b66781c$var$$f();
                break;
            case 3:
                $e7fc41517b66781c$var$zh();
                $e7fc41517b66781c$var$E($e7fc41517b66781c$var$Wf);
                $e7fc41517b66781c$var$E($e7fc41517b66781c$var$H);
                $e7fc41517b66781c$var$Eh();
                break;
            case 5:
                $e7fc41517b66781c$var$Bh(d);
                break;
            case 4:
                $e7fc41517b66781c$var$zh();
                break;
            case 13:
                $e7fc41517b66781c$var$E($e7fc41517b66781c$var$L);
                break;
            case 19:
                $e7fc41517b66781c$var$E($e7fc41517b66781c$var$L);
                break;
            case 10:
                $e7fc41517b66781c$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $e7fc41517b66781c$var$Hj();
        }
        c = c.return;
    }
    $e7fc41517b66781c$var$Q = a;
    $e7fc41517b66781c$var$Y = a = $e7fc41517b66781c$var$Pg(a.current, null);
    $e7fc41517b66781c$var$Z = $e7fc41517b66781c$var$fj = b;
    $e7fc41517b66781c$var$T = 0;
    $e7fc41517b66781c$var$pk = null;
    $e7fc41517b66781c$var$rk = $e7fc41517b66781c$var$qk = $e7fc41517b66781c$var$rh = 0;
    $e7fc41517b66781c$var$tk = $e7fc41517b66781c$var$sk = null;
    if (null !== $e7fc41517b66781c$var$fh) {
        for(b = 0; b < $e7fc41517b66781c$var$fh.length; b++)if (c = $e7fc41517b66781c$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e7fc41517b66781c$var$fh = null;
    }
    return a;
}
function $e7fc41517b66781c$var$Mk(a, b) {
    do {
        var c = $e7fc41517b66781c$var$Y;
        try {
            $e7fc41517b66781c$var$$g();
            $e7fc41517b66781c$var$Fh.current = $e7fc41517b66781c$var$Rh;
            if ($e7fc41517b66781c$var$Ih) {
                for(var d = $e7fc41517b66781c$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e7fc41517b66781c$var$Ih = !1;
            }
            $e7fc41517b66781c$var$Hh = 0;
            $e7fc41517b66781c$var$O = $e7fc41517b66781c$var$N = $e7fc41517b66781c$var$M = null;
            $e7fc41517b66781c$var$Jh = !1;
            $e7fc41517b66781c$var$Kh = 0;
            $e7fc41517b66781c$var$nk.current = null;
            if (null === c || null === c.return) {
                $e7fc41517b66781c$var$T = 1;
                $e7fc41517b66781c$var$pk = b;
                $e7fc41517b66781c$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e7fc41517b66781c$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e7fc41517b66781c$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e7fc41517b66781c$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $e7fc41517b66781c$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e7fc41517b66781c$var$Si(f, l, b);
                            $e7fc41517b66781c$var$tj();
                            break a;
                        }
                        k = Error($e7fc41517b66781c$var$p(426));
                    }
                } else if ($e7fc41517b66781c$var$I && h.mode & 1) {
                    var J = $e7fc41517b66781c$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e7fc41517b66781c$var$Vi(J, g, h, f, b);
                        $e7fc41517b66781c$var$Jg($e7fc41517b66781c$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $e7fc41517b66781c$var$Ji(k, h);
                4 !== $e7fc41517b66781c$var$T && ($e7fc41517b66781c$var$T = 2);
                null === $e7fc41517b66781c$var$sk ? $e7fc41517b66781c$var$sk = [
                    f
                ] : $e7fc41517b66781c$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e7fc41517b66781c$var$Ni(f, k, b);
                            $e7fc41517b66781c$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e7fc41517b66781c$var$Ri || !$e7fc41517b66781c$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e7fc41517b66781c$var$Qi(f, h, b);
                                $e7fc41517b66781c$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e7fc41517b66781c$var$Sk(c);
        } catch (na) {
            b = na;
            $e7fc41517b66781c$var$Y === c && null !== c && ($e7fc41517b66781c$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e7fc41517b66781c$var$Jk() {
    var a = $e7fc41517b66781c$var$mk.current;
    $e7fc41517b66781c$var$mk.current = $e7fc41517b66781c$var$Rh;
    return null === a ? $e7fc41517b66781c$var$Rh : a;
}
function $e7fc41517b66781c$var$tj() {
    if (0 === $e7fc41517b66781c$var$T || 3 === $e7fc41517b66781c$var$T || 2 === $e7fc41517b66781c$var$T) $e7fc41517b66781c$var$T = 4;
    null === $e7fc41517b66781c$var$Q || 0 === ($e7fc41517b66781c$var$rh & 268435455) && 0 === ($e7fc41517b66781c$var$qk & 268435455) || $e7fc41517b66781c$var$Ck($e7fc41517b66781c$var$Q, $e7fc41517b66781c$var$Z);
}
function $e7fc41517b66781c$var$Ik(a, b) {
    var c = $e7fc41517b66781c$var$K;
    $e7fc41517b66781c$var$K |= 2;
    var d = $e7fc41517b66781c$var$Jk();
    if ($e7fc41517b66781c$var$Q !== a || $e7fc41517b66781c$var$Z !== b) $e7fc41517b66781c$var$uk = null, $e7fc41517b66781c$var$Kk(a, b);
    for(;;)try {
        $e7fc41517b66781c$var$Tk();
        break;
    } catch (e) {
        $e7fc41517b66781c$var$Mk(a, e);
    }
    $e7fc41517b66781c$var$$g();
    $e7fc41517b66781c$var$K = c;
    $e7fc41517b66781c$var$mk.current = d;
    if (null !== $e7fc41517b66781c$var$Y) throw Error($e7fc41517b66781c$var$p(261));
    $e7fc41517b66781c$var$Q = null;
    $e7fc41517b66781c$var$Z = 0;
    return $e7fc41517b66781c$var$T;
}
function $e7fc41517b66781c$var$Tk() {
    for(; null !== $e7fc41517b66781c$var$Y;)$e7fc41517b66781c$var$Uk($e7fc41517b66781c$var$Y);
}
function $e7fc41517b66781c$var$Lk() {
    for(; null !== $e7fc41517b66781c$var$Y && !$e7fc41517b66781c$var$cc();)$e7fc41517b66781c$var$Uk($e7fc41517b66781c$var$Y);
}
function $e7fc41517b66781c$var$Uk(a) {
    var b = $e7fc41517b66781c$var$Vk(a.alternate, a, $e7fc41517b66781c$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e7fc41517b66781c$var$Sk(a) : $e7fc41517b66781c$var$Y = b;
    $e7fc41517b66781c$var$nk.current = null;
}
function $e7fc41517b66781c$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e7fc41517b66781c$var$Ej(c, b, $e7fc41517b66781c$var$fj), null !== c) {
                $e7fc41517b66781c$var$Y = c;
                return;
            }
        } else {
            c = $e7fc41517b66781c$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e7fc41517b66781c$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e7fc41517b66781c$var$T = 6;
                $e7fc41517b66781c$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e7fc41517b66781c$var$Y = b;
            return;
        }
        $e7fc41517b66781c$var$Y = b = a;
    }while (null !== b);
    0 === $e7fc41517b66781c$var$T && ($e7fc41517b66781c$var$T = 5);
}
function $e7fc41517b66781c$var$Pk(a, b, c) {
    var d = $e7fc41517b66781c$var$C, e = $e7fc41517b66781c$var$ok.transition;
    try {
        $e7fc41517b66781c$var$ok.transition = null, $e7fc41517b66781c$var$C = 1, $e7fc41517b66781c$var$Wk(a, b, c, d);
    } finally{
        $e7fc41517b66781c$var$ok.transition = e, $e7fc41517b66781c$var$C = d;
    }
    return null;
}
function $e7fc41517b66781c$var$Wk(a, b, c, d) {
    do $e7fc41517b66781c$var$Hk();
    while (null !== $e7fc41517b66781c$var$wk);
    if (0 !== ($e7fc41517b66781c$var$K & 6)) throw Error($e7fc41517b66781c$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e7fc41517b66781c$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e7fc41517b66781c$var$Bc(a, f);
    a === $e7fc41517b66781c$var$Q && ($e7fc41517b66781c$var$Y = $e7fc41517b66781c$var$Q = null, $e7fc41517b66781c$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e7fc41517b66781c$var$vk || ($e7fc41517b66781c$var$vk = !0, $e7fc41517b66781c$var$Fk($e7fc41517b66781c$var$hc, function() {
        $e7fc41517b66781c$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e7fc41517b66781c$var$ok.transition;
        $e7fc41517b66781c$var$ok.transition = null;
        var g = $e7fc41517b66781c$var$C;
        $e7fc41517b66781c$var$C = 1;
        var h = $e7fc41517b66781c$var$K;
        $e7fc41517b66781c$var$K |= 4;
        $e7fc41517b66781c$var$nk.current = null;
        $e7fc41517b66781c$var$Oj(a, c);
        $e7fc41517b66781c$var$dk(c, a);
        $e7fc41517b66781c$var$Oe($e7fc41517b66781c$var$Df);
        $e7fc41517b66781c$var$dd = !!$e7fc41517b66781c$var$Cf;
        $e7fc41517b66781c$var$Df = $e7fc41517b66781c$var$Cf = null;
        a.current = c;
        $e7fc41517b66781c$var$hk(c, a, e);
        $e7fc41517b66781c$var$dc();
        $e7fc41517b66781c$var$K = h;
        $e7fc41517b66781c$var$C = g;
        $e7fc41517b66781c$var$ok.transition = f;
    } else a.current = c;
    $e7fc41517b66781c$var$vk && ($e7fc41517b66781c$var$vk = !1, $e7fc41517b66781c$var$wk = a, $e7fc41517b66781c$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($e7fc41517b66781c$var$Ri = null);
    $e7fc41517b66781c$var$mc(c.stateNode, d);
    $e7fc41517b66781c$var$Dk(a, $e7fc41517b66781c$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e7fc41517b66781c$var$Oi) throw $e7fc41517b66781c$var$Oi = !1, a = $e7fc41517b66781c$var$Pi, $e7fc41517b66781c$var$Pi = null, a;
    0 !== ($e7fc41517b66781c$var$xk & 1) && 0 !== a.tag && $e7fc41517b66781c$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e7fc41517b66781c$var$zk ? $e7fc41517b66781c$var$yk++ : ($e7fc41517b66781c$var$yk = 0, $e7fc41517b66781c$var$zk = a) : $e7fc41517b66781c$var$yk = 0;
    $e7fc41517b66781c$var$jg();
    return null;
}
function $e7fc41517b66781c$var$Hk() {
    if (null !== $e7fc41517b66781c$var$wk) {
        var a = $e7fc41517b66781c$var$Dc($e7fc41517b66781c$var$xk), b = $e7fc41517b66781c$var$ok.transition, c = $e7fc41517b66781c$var$C;
        try {
            $e7fc41517b66781c$var$ok.transition = null;
            $e7fc41517b66781c$var$C = 16 > a ? 16 : a;
            if (null === $e7fc41517b66781c$var$wk) var d = !1;
            else {
                a = $e7fc41517b66781c$var$wk;
                $e7fc41517b66781c$var$wk = null;
                $e7fc41517b66781c$var$xk = 0;
                if (0 !== ($e7fc41517b66781c$var$K & 6)) throw Error($e7fc41517b66781c$var$p(331));
                var e = $e7fc41517b66781c$var$K;
                $e7fc41517b66781c$var$K |= 4;
                for($e7fc41517b66781c$var$V = a.current; null !== $e7fc41517b66781c$var$V;){
                    var f = $e7fc41517b66781c$var$V, g = f.child;
                    if (0 !== ($e7fc41517b66781c$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e7fc41517b66781c$var$V = l; null !== $e7fc41517b66781c$var$V;){
                                    var m = $e7fc41517b66781c$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e7fc41517b66781c$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e7fc41517b66781c$var$V = q;
                                    else for(; null !== $e7fc41517b66781c$var$V;){
                                        m = $e7fc41517b66781c$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e7fc41517b66781c$var$Sj(m);
                                        if (m === l) {
                                            $e7fc41517b66781c$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e7fc41517b66781c$var$V = r;
                                            break;
                                        }
                                        $e7fc41517b66781c$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e7fc41517b66781c$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e7fc41517b66781c$var$V = g;
                    else b: for(; null !== $e7fc41517b66781c$var$V;){
                        f = $e7fc41517b66781c$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e7fc41517b66781c$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e7fc41517b66781c$var$V = x;
                            break b;
                        }
                        $e7fc41517b66781c$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e7fc41517b66781c$var$V = w; null !== $e7fc41517b66781c$var$V;){
                    g = $e7fc41517b66781c$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e7fc41517b66781c$var$V = u;
                    else b: for(g = w; null !== $e7fc41517b66781c$var$V;){
                        h = $e7fc41517b66781c$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e7fc41517b66781c$var$Qj(9, h);
                            }
                        } catch (na) {
                            $e7fc41517b66781c$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e7fc41517b66781c$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e7fc41517b66781c$var$V = F;
                            break b;
                        }
                        $e7fc41517b66781c$var$V = h.return;
                    }
                }
                $e7fc41517b66781c$var$K = e;
                $e7fc41517b66781c$var$jg();
                if ($e7fc41517b66781c$var$lc && "function" === typeof $e7fc41517b66781c$var$lc.onPostCommitFiberRoot) try {
                    $e7fc41517b66781c$var$lc.onPostCommitFiberRoot($e7fc41517b66781c$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e7fc41517b66781c$var$C = c, $e7fc41517b66781c$var$ok.transition = b;
        }
    }
    return !1;
}
function $e7fc41517b66781c$var$Xk(a, b, c) {
    b = $e7fc41517b66781c$var$Ji(c, b);
    b = $e7fc41517b66781c$var$Ni(a, b, 1);
    a = $e7fc41517b66781c$var$nh(a, b, 1);
    b = $e7fc41517b66781c$var$R();
    null !== a && ($e7fc41517b66781c$var$Ac(a, 1, b), $e7fc41517b66781c$var$Dk(a, b));
}
function $e7fc41517b66781c$var$W(a, b, c) {
    if (3 === a.tag) $e7fc41517b66781c$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e7fc41517b66781c$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e7fc41517b66781c$var$Ri || !$e7fc41517b66781c$var$Ri.has(d))) {
                a = $e7fc41517b66781c$var$Ji(c, a);
                a = $e7fc41517b66781c$var$Qi(b, a, 1);
                b = $e7fc41517b66781c$var$nh(b, a, 1);
                a = $e7fc41517b66781c$var$R();
                null !== b && ($e7fc41517b66781c$var$Ac(b, 1, a), $e7fc41517b66781c$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e7fc41517b66781c$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e7fc41517b66781c$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $e7fc41517b66781c$var$Q === a && ($e7fc41517b66781c$var$Z & c) === c && (4 === $e7fc41517b66781c$var$T || 3 === $e7fc41517b66781c$var$T && ($e7fc41517b66781c$var$Z & 130023424) === $e7fc41517b66781c$var$Z && 500 > $e7fc41517b66781c$var$B() - $e7fc41517b66781c$var$fk ? $e7fc41517b66781c$var$Kk(a, 0) : $e7fc41517b66781c$var$rk |= c);
    $e7fc41517b66781c$var$Dk(a, b);
}
function $e7fc41517b66781c$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e7fc41517b66781c$var$sc, $e7fc41517b66781c$var$sc <<= 1, 0 === ($e7fc41517b66781c$var$sc & 130023424) && ($e7fc41517b66781c$var$sc = 4194304)));
    var c = $e7fc41517b66781c$var$R();
    a = $e7fc41517b66781c$var$ih(a, b);
    null !== a && ($e7fc41517b66781c$var$Ac(a, b, c), $e7fc41517b66781c$var$Dk(a, c));
}
function $e7fc41517b66781c$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e7fc41517b66781c$var$Yk(a, c);
}
function $e7fc41517b66781c$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e7fc41517b66781c$var$p(314));
    }
    null !== d && d.delete(b);
    $e7fc41517b66781c$var$Yk(a, c);
}
var $e7fc41517b66781c$var$Vk;
$e7fc41517b66781c$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e7fc41517b66781c$var$Wf.current) $e7fc41517b66781c$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e7fc41517b66781c$var$dh = !1, $e7fc41517b66781c$var$yj(a, b, c);
            $e7fc41517b66781c$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e7fc41517b66781c$var$dh = !1, $e7fc41517b66781c$var$I && 0 !== (b.flags & 1048576) && $e7fc41517b66781c$var$ug(b, $e7fc41517b66781c$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e7fc41517b66781c$var$ij(a, b);
            a = b.pendingProps;
            var e = $e7fc41517b66781c$var$Yf(b, $e7fc41517b66781c$var$H.current);
            $e7fc41517b66781c$var$ch(b, c);
            e = $e7fc41517b66781c$var$Nh(null, b, d, a, e, c);
            var f = $e7fc41517b66781c$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e7fc41517b66781c$var$Zf(d) ? (f = !0, $e7fc41517b66781c$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e7fc41517b66781c$var$kh(b), e.updater = $e7fc41517b66781c$var$Ei, b.stateNode = e, e._reactInternals = b, $e7fc41517b66781c$var$Ii(b, d, a, c), b = $e7fc41517b66781c$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $e7fc41517b66781c$var$I && f && $e7fc41517b66781c$var$vg(b), $e7fc41517b66781c$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e7fc41517b66781c$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e7fc41517b66781c$var$Zk(d);
                a = $e7fc41517b66781c$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $e7fc41517b66781c$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e7fc41517b66781c$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e7fc41517b66781c$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e7fc41517b66781c$var$$i(null, b, d, $e7fc41517b66781c$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($e7fc41517b66781c$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e7fc41517b66781c$var$Ci(d, e), $e7fc41517b66781c$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e7fc41517b66781c$var$Ci(d, e), $e7fc41517b66781c$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $e7fc41517b66781c$var$kj(b);
                if (null === a) throw Error($e7fc41517b66781c$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e7fc41517b66781c$var$lh(a, b);
                $e7fc41517b66781c$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e7fc41517b66781c$var$Ji(Error($e7fc41517b66781c$var$p(423)), b);
                        b = $e7fc41517b66781c$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e7fc41517b66781c$var$Ji(Error($e7fc41517b66781c$var$p(424)), b);
                        b = $e7fc41517b66781c$var$lj(a, b, d, c, e);
                        break a;
                    } else for($e7fc41517b66781c$var$yg = $e7fc41517b66781c$var$Lf(b.stateNode.containerInfo.firstChild), $e7fc41517b66781c$var$xg = b, $e7fc41517b66781c$var$I = !0, $e7fc41517b66781c$var$zg = null, c = $e7fc41517b66781c$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e7fc41517b66781c$var$Ig();
                    if (d === e) {
                        b = $e7fc41517b66781c$var$Zi(a, b, c);
                        break a;
                    }
                    $e7fc41517b66781c$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e7fc41517b66781c$var$Ah(b), null === a && $e7fc41517b66781c$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e7fc41517b66781c$var$Ef(d, e) ? g = null : null !== f && $e7fc41517b66781c$var$Ef(d, f) && (b.flags |= 32), $e7fc41517b66781c$var$gj(a, b), $e7fc41517b66781c$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $e7fc41517b66781c$var$Eg(b), null;
        case 13:
            return $e7fc41517b66781c$var$oj(a, b, c);
        case 4:
            return $e7fc41517b66781c$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e7fc41517b66781c$var$Ug(b, null, d, c) : $e7fc41517b66781c$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e7fc41517b66781c$var$Ci(d, e), $e7fc41517b66781c$var$Yi(a, b, d, e, c);
        case 7:
            return $e7fc41517b66781c$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e7fc41517b66781c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e7fc41517b66781c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e7fc41517b66781c$var$G($e7fc41517b66781c$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e7fc41517b66781c$var$He(f.value, g)) {
                        if (f.children === e.children && !$e7fc41517b66781c$var$Wf.current) {
                            b = $e7fc41517b66781c$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e7fc41517b66781c$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e7fc41517b66781c$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e7fc41517b66781c$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e7fc41517b66781c$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e7fc41517b66781c$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e7fc41517b66781c$var$ch(b, c), e = $e7fc41517b66781c$var$eh(e), d = d(e), b.flags |= 1, $e7fc41517b66781c$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e7fc41517b66781c$var$Ci(d, b.pendingProps), e = $e7fc41517b66781c$var$Ci(d.type, e), $e7fc41517b66781c$var$$i(a, b, d, e, c);
        case 15:
            return $e7fc41517b66781c$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e7fc41517b66781c$var$Ci(d, e), $e7fc41517b66781c$var$ij(a, b), b.tag = 1, $e7fc41517b66781c$var$Zf(d) ? (a = !0, $e7fc41517b66781c$var$cg(b)) : a = !1, $e7fc41517b66781c$var$ch(b, c), $e7fc41517b66781c$var$Gi(b, d, e), $e7fc41517b66781c$var$Ii(b, d, e, c), $e7fc41517b66781c$var$jj(null, b, d, !0, a, c);
        case 19:
            return $e7fc41517b66781c$var$xj(a, b, c);
        case 22:
            return $e7fc41517b66781c$var$dj(a, b, c);
    }
    throw Error($e7fc41517b66781c$var$p(156, b.tag));
};
function $e7fc41517b66781c$var$Fk(a, b) {
    return $e7fc41517b66781c$var$ac(a, b);
}
function $e7fc41517b66781c$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e7fc41517b66781c$var$Bg(a, b, c, d) {
    return new $e7fc41517b66781c$var$$k(a, b, c, d);
}
function $e7fc41517b66781c$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e7fc41517b66781c$var$Zk(a) {
    if ("function" === typeof a) return $e7fc41517b66781c$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e7fc41517b66781c$var$Da) return 11;
        if (a === $e7fc41517b66781c$var$Ga) return 14;
    }
    return 2;
}
function $e7fc41517b66781c$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $e7fc41517b66781c$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e7fc41517b66781c$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e7fc41517b66781c$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e7fc41517b66781c$var$ya:
            return $e7fc41517b66781c$var$Tg(c.children, e, f, b);
        case $e7fc41517b66781c$var$za:
            g = 8;
            e |= 8;
            break;
        case $e7fc41517b66781c$var$Aa:
            return a = $e7fc41517b66781c$var$Bg(12, c, b, e | 2), a.elementType = $e7fc41517b66781c$var$Aa, a.lanes = f, a;
        case $e7fc41517b66781c$var$Ea:
            return a = $e7fc41517b66781c$var$Bg(13, c, b, e), a.elementType = $e7fc41517b66781c$var$Ea, a.lanes = f, a;
        case $e7fc41517b66781c$var$Fa:
            return a = $e7fc41517b66781c$var$Bg(19, c, b, e), a.elementType = $e7fc41517b66781c$var$Fa, a.lanes = f, a;
        case $e7fc41517b66781c$var$Ia:
            return $e7fc41517b66781c$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e7fc41517b66781c$var$Ba:
                    g = 10;
                    break a;
                case $e7fc41517b66781c$var$Ca:
                    g = 9;
                    break a;
                case $e7fc41517b66781c$var$Da:
                    g = 11;
                    break a;
                case $e7fc41517b66781c$var$Ga:
                    g = 14;
                    break a;
                case $e7fc41517b66781c$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e7fc41517b66781c$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $e7fc41517b66781c$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e7fc41517b66781c$var$Tg(a, b, c, d) {
    a = $e7fc41517b66781c$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e7fc41517b66781c$var$pj(a, b, c, d) {
    a = $e7fc41517b66781c$var$Bg(22, a, d, b);
    a.elementType = $e7fc41517b66781c$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e7fc41517b66781c$var$Qg(a, b, c) {
    a = $e7fc41517b66781c$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e7fc41517b66781c$var$Sg(a, b, c) {
    b = $e7fc41517b66781c$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e7fc41517b66781c$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e7fc41517b66781c$var$zc(0);
    this.expirationTimes = $e7fc41517b66781c$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e7fc41517b66781c$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e7fc41517b66781c$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $e7fc41517b66781c$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e7fc41517b66781c$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e7fc41517b66781c$var$kh(f);
    return a;
}
function $e7fc41517b66781c$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e7fc41517b66781c$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e7fc41517b66781c$var$dl(a) {
    if (!a) return $e7fc41517b66781c$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e7fc41517b66781c$var$Vb(a) !== a || 1 !== a.tag) throw Error($e7fc41517b66781c$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e7fc41517b66781c$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e7fc41517b66781c$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e7fc41517b66781c$var$Zf(c)) return $e7fc41517b66781c$var$bg(a, c, b);
    }
    return b;
}
function $e7fc41517b66781c$var$el(a, b, c, d, e, f, g, h, k) {
    a = $e7fc41517b66781c$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $e7fc41517b66781c$var$dl(null);
    c = a.current;
    d = $e7fc41517b66781c$var$R();
    e = $e7fc41517b66781c$var$yi(c);
    f = $e7fc41517b66781c$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e7fc41517b66781c$var$nh(c, f, e);
    a.current.lanes = e;
    $e7fc41517b66781c$var$Ac(a, e, d);
    $e7fc41517b66781c$var$Dk(a, d);
    return a;
}
function $e7fc41517b66781c$var$fl(a, b, c, d) {
    var e = b.current, f = $e7fc41517b66781c$var$R(), g = $e7fc41517b66781c$var$yi(e);
    c = $e7fc41517b66781c$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e7fc41517b66781c$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e7fc41517b66781c$var$nh(e, b, g);
    null !== a && ($e7fc41517b66781c$var$gi(a, e, g, f), $e7fc41517b66781c$var$oh(a, e, g));
    return g;
}
function $e7fc41517b66781c$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e7fc41517b66781c$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e7fc41517b66781c$var$il(a, b) {
    $e7fc41517b66781c$var$hl(a, b);
    (a = a.alternate) && $e7fc41517b66781c$var$hl(a, b);
}
function $e7fc41517b66781c$var$jl() {
    return null;
}
var $e7fc41517b66781c$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $e7fc41517b66781c$var$ll(a) {
    this._internalRoot = a;
}
$e7fc41517b66781c$var$ml.prototype.render = $e7fc41517b66781c$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e7fc41517b66781c$var$p(409));
    $e7fc41517b66781c$var$fl(a, b, null, null);
};
$e7fc41517b66781c$var$ml.prototype.unmount = $e7fc41517b66781c$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e7fc41517b66781c$var$Rk(function() {
            $e7fc41517b66781c$var$fl(null, a, null, null);
        });
        b[$e7fc41517b66781c$var$uf] = null;
    }
};
function $e7fc41517b66781c$var$ml(a) {
    this._internalRoot = a;
}
$e7fc41517b66781c$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e7fc41517b66781c$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e7fc41517b66781c$var$Qc.length && 0 !== b && b < $e7fc41517b66781c$var$Qc[c].priority; c++);
        $e7fc41517b66781c$var$Qc.splice(c, 0, a);
        0 === c && $e7fc41517b66781c$var$Vc(a);
    }
};
function $e7fc41517b66781c$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e7fc41517b66781c$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e7fc41517b66781c$var$pl() {}
function $e7fc41517b66781c$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $e7fc41517b66781c$var$gl(g);
                f.call(a);
            };
        }
        var g = $e7fc41517b66781c$var$el(b, d, a, 0, null, !1, !1, "", $e7fc41517b66781c$var$pl);
        a._reactRootContainer = g;
        a[$e7fc41517b66781c$var$uf] = g.current;
        $e7fc41517b66781c$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e7fc41517b66781c$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $e7fc41517b66781c$var$gl(k);
            h.call(a);
        };
    }
    var k = $e7fc41517b66781c$var$bl(a, 0, !1, null, null, !1, !1, "", $e7fc41517b66781c$var$pl);
    a._reactRootContainer = k;
    a[$e7fc41517b66781c$var$uf] = k.current;
    $e7fc41517b66781c$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e7fc41517b66781c$var$Rk(function() {
        $e7fc41517b66781c$var$fl(b, k, c, d);
    });
    return k;
}
function $e7fc41517b66781c$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e7fc41517b66781c$var$gl(g);
                h.call(a);
            };
        }
        $e7fc41517b66781c$var$fl(b, g, a, e);
    } else g = $e7fc41517b66781c$var$ql(c, b, a, e, d);
    return $e7fc41517b66781c$var$gl(g);
}
$e7fc41517b66781c$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e7fc41517b66781c$var$tc(b.pendingLanes);
                0 !== c && ($e7fc41517b66781c$var$Cc(b, c | 1), $e7fc41517b66781c$var$Dk(b, $e7fc41517b66781c$var$B()), 0 === ($e7fc41517b66781c$var$K & 6) && ($e7fc41517b66781c$var$Gj = $e7fc41517b66781c$var$B() + 500, $e7fc41517b66781c$var$jg()));
            }
            break;
        case 13:
            $e7fc41517b66781c$var$Rk(function() {
                var b = $e7fc41517b66781c$var$ih(a, 1);
                if (null !== b) {
                    var c = $e7fc41517b66781c$var$R();
                    $e7fc41517b66781c$var$gi(b, a, 1, c);
                }
            }), $e7fc41517b66781c$var$il(a, 1);
    }
};
$e7fc41517b66781c$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $e7fc41517b66781c$var$ih(a, 134217728);
        if (null !== b) {
            var c = $e7fc41517b66781c$var$R();
            $e7fc41517b66781c$var$gi(b, a, 134217728, c);
        }
        $e7fc41517b66781c$var$il(a, 134217728);
    }
};
$e7fc41517b66781c$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $e7fc41517b66781c$var$yi(a), c = $e7fc41517b66781c$var$ih(a, b);
        if (null !== c) {
            var d = $e7fc41517b66781c$var$R();
            $e7fc41517b66781c$var$gi(c, a, b, d);
        }
        $e7fc41517b66781c$var$il(a, b);
    }
};
$e7fc41517b66781c$var$Hc = function() {
    return $e7fc41517b66781c$var$C;
};
$e7fc41517b66781c$var$Ic = function(a, b) {
    var c = $e7fc41517b66781c$var$C;
    try {
        return $e7fc41517b66781c$var$C = a, b();
    } finally{
        $e7fc41517b66781c$var$C = c;
    }
};
$e7fc41517b66781c$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e7fc41517b66781c$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e7fc41517b66781c$var$Db(d);
                        if (!e) throw Error($e7fc41517b66781c$var$p(90));
                        $e7fc41517b66781c$var$Wa(d);
                        $e7fc41517b66781c$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e7fc41517b66781c$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e7fc41517b66781c$var$fb(a, !!c.multiple, b, !1);
    }
};
$e7fc41517b66781c$var$Gb = $e7fc41517b66781c$var$Qk;
$e7fc41517b66781c$var$Hb = $e7fc41517b66781c$var$Rk;
var $e7fc41517b66781c$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $e7fc41517b66781c$var$Cb,
        $e7fc41517b66781c$var$ue,
        $e7fc41517b66781c$var$Db,
        $e7fc41517b66781c$var$Eb,
        $e7fc41517b66781c$var$Fb,
        $e7fc41517b66781c$var$Qk
    ]
}, $e7fc41517b66781c$var$tl = {
    findFiberByHostInstance: $e7fc41517b66781c$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $e7fc41517b66781c$var$ul = {
    bundleType: $e7fc41517b66781c$var$tl.bundleType,
    version: $e7fc41517b66781c$var$tl.version,
    rendererPackageName: $e7fc41517b66781c$var$tl.rendererPackageName,
    rendererConfig: $e7fc41517b66781c$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e7fc41517b66781c$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e7fc41517b66781c$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e7fc41517b66781c$var$tl.findFiberByHostInstance || $e7fc41517b66781c$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e7fc41517b66781c$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e7fc41517b66781c$var$vl.isDisabled && $e7fc41517b66781c$var$vl.supportsFiber) try {
        $e7fc41517b66781c$var$kc = $e7fc41517b66781c$var$vl.inject($e7fc41517b66781c$var$ul), $e7fc41517b66781c$var$lc = $e7fc41517b66781c$var$vl;
    } catch (a) {}
}
$e7fc41517b66781c$export$ae55be85d98224ed = $e7fc41517b66781c$var$sl;
$e7fc41517b66781c$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e7fc41517b66781c$var$nl(b)) throw Error($e7fc41517b66781c$var$p(200));
    return $e7fc41517b66781c$var$cl(a, b, null, c);
};
$e7fc41517b66781c$export$882461b6382ed46c = function(a, b) {
    if (!$e7fc41517b66781c$var$nl(a)) throw Error($e7fc41517b66781c$var$p(299));
    var c = !1, d = "", e = $e7fc41517b66781c$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e7fc41517b66781c$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$e7fc41517b66781c$var$uf] = b.current;
    $e7fc41517b66781c$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e7fc41517b66781c$var$ll(b);
};
$e7fc41517b66781c$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e7fc41517b66781c$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e7fc41517b66781c$var$p(268, a));
    }
    a = $e7fc41517b66781c$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e7fc41517b66781c$export$cd75ccfd720a3cd4 = function(a) {
    return $e7fc41517b66781c$var$Rk(a);
};
$e7fc41517b66781c$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e7fc41517b66781c$var$ol(b)) throw Error($e7fc41517b66781c$var$p(200));
    return $e7fc41517b66781c$var$rl(null, a, b, !0, c);
};
$e7fc41517b66781c$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e7fc41517b66781c$var$nl(a)) throw Error($e7fc41517b66781c$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e7fc41517b66781c$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e7fc41517b66781c$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e7fc41517b66781c$var$uf] = b.current;
    $e7fc41517b66781c$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e7fc41517b66781c$var$ml(b);
};
$e7fc41517b66781c$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e7fc41517b66781c$var$ol(b)) throw Error($e7fc41517b66781c$var$p(200));
    return $e7fc41517b66781c$var$rl(null, a, b, !1, c);
};
$e7fc41517b66781c$export$502457920280e6be = function(a) {
    if (!$e7fc41517b66781c$var$ol(a)) throw Error($e7fc41517b66781c$var$p(40));
    return a._reactRootContainer ? ($e7fc41517b66781c$var$Rk(function() {
        $e7fc41517b66781c$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e7fc41517b66781c$var$uf] = null;
        });
    }), !0) : !1;
};
$e7fc41517b66781c$export$c78a37762a8d58e1 = $e7fc41517b66781c$var$Qk;
$e7fc41517b66781c$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e7fc41517b66781c$var$ol(c)) throw Error($e7fc41517b66781c$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e7fc41517b66781c$var$p(38));
    return $e7fc41517b66781c$var$rl(a, b, c, !1, d);
};
$e7fc41517b66781c$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("HuxiW", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9uGBu"));

});
parcelRegister("9uGBu", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6e97f694ff79f571$export$c4744153514ff05d; }, function (v) { return $6e97f694ff79f571$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6e97f694ff79f571$export$3e506c1ccc9cc1a7; }, function (v) { return $6e97f694ff79f571$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6e97f694ff79f571$export$e26fe2ed2fa76875; }, function (v) { return $6e97f694ff79f571$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6e97f694ff79f571$export$502329bbf4b505b1; }, function (v) { return $6e97f694ff79f571$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6e97f694ff79f571$export$6e3807111c4874c4; }, function (v) { return $6e97f694ff79f571$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6e97f694ff79f571$export$c27134553091fb3a; }, function (v) { return $6e97f694ff79f571$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6e97f694ff79f571$export$33ee1acdc04fd2a2; }, function (v) { return $6e97f694ff79f571$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6e97f694ff79f571$export$b00a404bbd5edef2; }, function (v) { return $6e97f694ff79f571$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6e97f694ff79f571$export$8352ce38b91d0c62; }, function (v) { return $6e97f694ff79f571$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6e97f694ff79f571$export$d66a1c1c77bd778b; }, function (v) { return $6e97f694ff79f571$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6e97f694ff79f571$export$d3dfb8e4810cb555; }, function (v) { return $6e97f694ff79f571$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6e97f694ff79f571$export$839f9183b0465a69; }, function (v) { return $6e97f694ff79f571$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6e97f694ff79f571$export$72fdf0e06517287b; }, function (v) { return $6e97f694ff79f571$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6e97f694ff79f571$export$4b844e58a3e414b4; }, function (v) { return $6e97f694ff79f571$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6e97f694ff79f571$export$816d2913ae6b83b1; }, function (v) { return $6e97f694ff79f571$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6e97f694ff79f571$export$61bcfe829111a1d0; }, function (v) { return $6e97f694ff79f571$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6e97f694ff79f571$export$7ee8c9beb337bc3f; }, function (v) { return $6e97f694ff79f571$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6e97f694ff79f571$export$b5836b71941fa3ed; }, function (v) { return $6e97f694ff79f571$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6e97f694ff79f571$export$cf845f2c119da08a; }, function (v) { return $6e97f694ff79f571$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6e97f694ff79f571$export$c4744153514ff05d;
var $6e97f694ff79f571$export$3e506c1ccc9cc1a7;
var $6e97f694ff79f571$export$e26fe2ed2fa76875;
var $6e97f694ff79f571$export$502329bbf4b505b1;
var $6e97f694ff79f571$export$6e3807111c4874c4;
var $6e97f694ff79f571$export$c27134553091fb3a;
var $6e97f694ff79f571$export$33ee1acdc04fd2a2;
var $6e97f694ff79f571$export$b00a404bbd5edef2;
var $6e97f694ff79f571$export$8352ce38b91d0c62;
var $6e97f694ff79f571$export$d66a1c1c77bd778b;
var $6e97f694ff79f571$export$d3dfb8e4810cb555;
var $6e97f694ff79f571$export$839f9183b0465a69;
var $6e97f694ff79f571$export$72fdf0e06517287b;
var $6e97f694ff79f571$export$4b844e58a3e414b4;
var $6e97f694ff79f571$export$816d2913ae6b83b1;
var $6e97f694ff79f571$export$61bcfe829111a1d0;
var $6e97f694ff79f571$export$7ee8c9beb337bc3f;
var $6e97f694ff79f571$export$b5836b71941fa3ed;
var $6e97f694ff79f571$export$cf845f2c119da08a;
'use strict';
function $6e97f694ff79f571$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6e97f694ff79f571$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6e97f694ff79f571$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6e97f694ff79f571$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6e97f694ff79f571$var$g(C, c)) n < e && 0 > $6e97f694ff79f571$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6e97f694ff79f571$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6e97f694ff79f571$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6e97f694ff79f571$var$l = performance;
    $6e97f694ff79f571$export$c4744153514ff05d = function() {
        return $6e97f694ff79f571$var$l.now();
    };
} else {
    var $6e97f694ff79f571$var$p = Date, $6e97f694ff79f571$var$q = $6e97f694ff79f571$var$p.now();
    $6e97f694ff79f571$export$c4744153514ff05d = function() {
        return $6e97f694ff79f571$var$p.now() - $6e97f694ff79f571$var$q;
    };
}
var $6e97f694ff79f571$var$r = [], $6e97f694ff79f571$var$t = [], $6e97f694ff79f571$var$u = 1, $6e97f694ff79f571$var$v = null, $6e97f694ff79f571$var$y = 3, $6e97f694ff79f571$var$z = !1, $6e97f694ff79f571$var$A = !1, $6e97f694ff79f571$var$B = !1, $6e97f694ff79f571$var$D = "function" === typeof setTimeout ? setTimeout : null, $6e97f694ff79f571$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6e97f694ff79f571$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6e97f694ff79f571$var$G(a) {
    for(var b = $6e97f694ff79f571$var$h($6e97f694ff79f571$var$t); null !== b;){
        if (null === b.callback) $6e97f694ff79f571$var$k($6e97f694ff79f571$var$t);
        else if (b.startTime <= a) $6e97f694ff79f571$var$k($6e97f694ff79f571$var$t), b.sortIndex = b.expirationTime, $6e97f694ff79f571$var$f($6e97f694ff79f571$var$r, b);
        else break;
        b = $6e97f694ff79f571$var$h($6e97f694ff79f571$var$t);
    }
}
function $6e97f694ff79f571$var$H(a) {
    $6e97f694ff79f571$var$B = !1;
    $6e97f694ff79f571$var$G(a);
    if (!$6e97f694ff79f571$var$A) {
        if (null !== $6e97f694ff79f571$var$h($6e97f694ff79f571$var$r)) $6e97f694ff79f571$var$A = !0, $6e97f694ff79f571$var$I($6e97f694ff79f571$var$J);
        else {
            var b = $6e97f694ff79f571$var$h($6e97f694ff79f571$var$t);
            null !== b && $6e97f694ff79f571$var$K($6e97f694ff79f571$var$H, b.startTime - a);
        }
    }
}
function $6e97f694ff79f571$var$J(a, b) {
    $6e97f694ff79f571$var$A = !1;
    $6e97f694ff79f571$var$B && ($6e97f694ff79f571$var$B = !1, $6e97f694ff79f571$var$E($6e97f694ff79f571$var$L), $6e97f694ff79f571$var$L = -1);
    $6e97f694ff79f571$var$z = !0;
    var c = $6e97f694ff79f571$var$y;
    try {
        $6e97f694ff79f571$var$G(b);
        for($6e97f694ff79f571$var$v = $6e97f694ff79f571$var$h($6e97f694ff79f571$var$r); null !== $6e97f694ff79f571$var$v && (!($6e97f694ff79f571$var$v.expirationTime > b) || a && !$6e97f694ff79f571$var$M());){
            var d = $6e97f694ff79f571$var$v.callback;
            if ("function" === typeof d) {
                $6e97f694ff79f571$var$v.callback = null;
                $6e97f694ff79f571$var$y = $6e97f694ff79f571$var$v.priorityLevel;
                var e = d($6e97f694ff79f571$var$v.expirationTime <= b);
                b = $6e97f694ff79f571$export$c4744153514ff05d();
                "function" === typeof e ? $6e97f694ff79f571$var$v.callback = e : $6e97f694ff79f571$var$v === $6e97f694ff79f571$var$h($6e97f694ff79f571$var$r) && $6e97f694ff79f571$var$k($6e97f694ff79f571$var$r);
                $6e97f694ff79f571$var$G(b);
            } else $6e97f694ff79f571$var$k($6e97f694ff79f571$var$r);
            $6e97f694ff79f571$var$v = $6e97f694ff79f571$var$h($6e97f694ff79f571$var$r);
        }
        if (null !== $6e97f694ff79f571$var$v) var w = !0;
        else {
            var m = $6e97f694ff79f571$var$h($6e97f694ff79f571$var$t);
            null !== m && $6e97f694ff79f571$var$K($6e97f694ff79f571$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6e97f694ff79f571$var$v = null, $6e97f694ff79f571$var$y = c, $6e97f694ff79f571$var$z = !1;
    }
}
var $6e97f694ff79f571$var$N = !1, $6e97f694ff79f571$var$O = null, $6e97f694ff79f571$var$L = -1, $6e97f694ff79f571$var$P = 5, $6e97f694ff79f571$var$Q = -1;
function $6e97f694ff79f571$var$M() {
    return $6e97f694ff79f571$export$c4744153514ff05d() - $6e97f694ff79f571$var$Q < $6e97f694ff79f571$var$P ? !1 : !0;
}
function $6e97f694ff79f571$var$R() {
    if (null !== $6e97f694ff79f571$var$O) {
        var a = $6e97f694ff79f571$export$c4744153514ff05d();
        $6e97f694ff79f571$var$Q = a;
        var b = !0;
        try {
            b = $6e97f694ff79f571$var$O(!0, a);
        } finally{
            b ? $6e97f694ff79f571$var$S() : ($6e97f694ff79f571$var$N = !1, $6e97f694ff79f571$var$O = null);
        }
    } else $6e97f694ff79f571$var$N = !1;
}
var $6e97f694ff79f571$var$S;
if ("function" === typeof $6e97f694ff79f571$var$F) $6e97f694ff79f571$var$S = function() {
    $6e97f694ff79f571$var$F($6e97f694ff79f571$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6e97f694ff79f571$var$T = new MessageChannel, $6e97f694ff79f571$var$U = $6e97f694ff79f571$var$T.port2;
    $6e97f694ff79f571$var$T.port1.onmessage = $6e97f694ff79f571$var$R;
    $6e97f694ff79f571$var$S = function() {
        $6e97f694ff79f571$var$U.postMessage(null);
    };
} else $6e97f694ff79f571$var$S = function() {
    $6e97f694ff79f571$var$D($6e97f694ff79f571$var$R, 0);
};
function $6e97f694ff79f571$var$I(a) {
    $6e97f694ff79f571$var$O = a;
    $6e97f694ff79f571$var$N || ($6e97f694ff79f571$var$N = !0, $6e97f694ff79f571$var$S());
}
function $6e97f694ff79f571$var$K(a, b) {
    $6e97f694ff79f571$var$L = $6e97f694ff79f571$var$D(function() {
        a($6e97f694ff79f571$export$c4744153514ff05d());
    }, b);
}
$6e97f694ff79f571$export$3e506c1ccc9cc1a7 = 5;
$6e97f694ff79f571$export$e26fe2ed2fa76875 = 1;
$6e97f694ff79f571$export$502329bbf4b505b1 = 4;
$6e97f694ff79f571$export$6e3807111c4874c4 = 3;
$6e97f694ff79f571$export$c27134553091fb3a = null;
$6e97f694ff79f571$export$33ee1acdc04fd2a2 = 2;
$6e97f694ff79f571$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6e97f694ff79f571$export$8352ce38b91d0c62 = function() {
    $6e97f694ff79f571$var$A || $6e97f694ff79f571$var$z || ($6e97f694ff79f571$var$A = !0, $6e97f694ff79f571$var$I($6e97f694ff79f571$var$J));
};
$6e97f694ff79f571$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6e97f694ff79f571$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6e97f694ff79f571$export$d3dfb8e4810cb555 = function() {
    return $6e97f694ff79f571$var$y;
};
$6e97f694ff79f571$export$839f9183b0465a69 = function() {
    return $6e97f694ff79f571$var$h($6e97f694ff79f571$var$r);
};
$6e97f694ff79f571$export$72fdf0e06517287b = function(a) {
    switch($6e97f694ff79f571$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6e97f694ff79f571$var$y;
    }
    var c = $6e97f694ff79f571$var$y;
    $6e97f694ff79f571$var$y = b;
    try {
        return a();
    } finally{
        $6e97f694ff79f571$var$y = c;
    }
};
$6e97f694ff79f571$export$4b844e58a3e414b4 = function() {};
$6e97f694ff79f571$export$816d2913ae6b83b1 = function() {};
$6e97f694ff79f571$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6e97f694ff79f571$var$y;
    $6e97f694ff79f571$var$y = a;
    try {
        return b();
    } finally{
        $6e97f694ff79f571$var$y = c;
    }
};
$6e97f694ff79f571$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6e97f694ff79f571$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6e97f694ff79f571$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6e97f694ff79f571$var$f($6e97f694ff79f571$var$t, a), null === $6e97f694ff79f571$var$h($6e97f694ff79f571$var$r) && a === $6e97f694ff79f571$var$h($6e97f694ff79f571$var$t) && ($6e97f694ff79f571$var$B ? ($6e97f694ff79f571$var$E($6e97f694ff79f571$var$L), $6e97f694ff79f571$var$L = -1) : $6e97f694ff79f571$var$B = !0, $6e97f694ff79f571$var$K($6e97f694ff79f571$var$H, c - d))) : (a.sortIndex = e, $6e97f694ff79f571$var$f($6e97f694ff79f571$var$r, a), $6e97f694ff79f571$var$A || $6e97f694ff79f571$var$z || ($6e97f694ff79f571$var$A = !0, $6e97f694ff79f571$var$I($6e97f694ff79f571$var$J)));
    return a;
};
$6e97f694ff79f571$export$b5836b71941fa3ed = $6e97f694ff79f571$var$M;
$6e97f694ff79f571$export$cf845f2c119da08a = function(a) {
    var b = $6e97f694ff79f571$var$y;
    return function() {
        var c = $6e97f694ff79f571$var$y;
        $6e97f694ff79f571$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6e97f694ff79f571$var$y = c;
        }
    };
};

});



parcelRegister("49yFe", function(module, exports) {
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = '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';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ':before');
                var styleAfter = window1.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});

});

parcelRegister("dvdsW", function(module, exports) {

$parcel$export(module.exports, "NonFullScreenPageMode", function () { return NonFullScreenPageMode; });
$parcel$export(module.exports, "ReadingDirection", function () { return ReadingDirection; });
$parcel$export(module.exports, "PrintScaling", function () { return PrintScaling; });
$parcel$export(module.exports, "Duplex", function () { return Duplex; });
$parcel$export(module.exports, "default", function () { return $9d489d9f1790be4a$export$2e2bcd8739ae039; });

var $dj8f2 = parcelRequire("dj8f2");

var $63sxC = parcelRequire("63sxC");

var $alPcq = parcelRequire("alPcq");

var $4MKjy = parcelRequire("4MKjy");
parcelRequire("5bpFt");
var $8EKPA = parcelRequire("8EKPA");
var asEnum = function(rawValue, enumType) {
    if (rawValue === undefined) return undefined;
    return enumType[rawValue];
};
var NonFullScreenPageMode;
(function(NonFullScreenPageMode) {
    /**
     * After exiting FullScreen mode, neither the document outline nor thumbnail
     * images should be visible.
     */ NonFullScreenPageMode["UseNone"] = "UseNone";
    /** After exiting FullScreen mode, the document outline should be visible. */ NonFullScreenPageMode["UseOutlines"] = "UseOutlines";
    /** After exiting FullScreen mode, thumbnail images should be visible. */ NonFullScreenPageMode["UseThumbs"] = "UseThumbs";
    /**
     * After exiting FullScreen mode, the optional content group panel should be
     * visible.
     */ NonFullScreenPageMode["UseOC"] = "UseOC";
})(NonFullScreenPageMode || (NonFullScreenPageMode = {}));
var ReadingDirection;
(function(ReadingDirection) {
    /** The predominant reading order is Left to Right. */ ReadingDirection["L2R"] = "L2R";
    /**
     * The predominant reading order is Right to left (including vertical writing
     * systems, such as Chinese, Japanese and Korean).
     */ ReadingDirection["R2L"] = "R2L";
})(ReadingDirection || (ReadingDirection = {}));
var PrintScaling;
(function(PrintScaling) {
    /** No page scaling. */ PrintScaling["None"] = "None";
    /* Use the PDF reader's default print scaling. */ PrintScaling["AppDefault"] = "AppDefault";
})(PrintScaling || (PrintScaling = {}));
var Duplex;
(function(Duplex) {
    /** The PDF reader should print single-sided. */ Duplex["Simplex"] = "Simplex";
    /**
     * The PDF reader should print double sided and flip on the short edge of the
     * sheet.
     */ Duplex["DuplexFlipShortEdge"] = "DuplexFlipShortEdge";
    /**
     * The PDF reader should print double sided and flip on the long edge of the
     * sheet.
     */ Duplex["DuplexFlipLongEdge"] = "DuplexFlipLongEdge";
})(Duplex || (Duplex = {}));
var ViewerPreferences = /** @class */ function() {
    /** @ignore */ function ViewerPreferences(dict) {
        this.dict = dict;
    }
    ViewerPreferences.prototype.lookupBool = function(key) {
        var returnObj = this.dict.lookup((0, $alPcq.default).of(key));
        if (returnObj instanceof (0, $63sxC.default)) return returnObj;
        return undefined;
    };
    ViewerPreferences.prototype.lookupName = function(key) {
        var returnObj = this.dict.lookup((0, $alPcq.default).of(key));
        if (returnObj instanceof (0, $alPcq.default)) return returnObj;
        return undefined;
    };
    /** @ignore */ ViewerPreferences.prototype.HideToolbar = function() {
        return this.lookupBool('HideToolbar');
    };
    /** @ignore */ ViewerPreferences.prototype.HideMenubar = function() {
        return this.lookupBool('HideMenubar');
    };
    /** @ignore */ ViewerPreferences.prototype.HideWindowUI = function() {
        return this.lookupBool('HideWindowUI');
    };
    /** @ignore */ ViewerPreferences.prototype.FitWindow = function() {
        return this.lookupBool('FitWindow');
    };
    /** @ignore */ ViewerPreferences.prototype.CenterWindow = function() {
        return this.lookupBool('CenterWindow');
    };
    /** @ignore */ ViewerPreferences.prototype.DisplayDocTitle = function() {
        return this.lookupBool('DisplayDocTitle');
    };
    /** @ignore */ ViewerPreferences.prototype.NonFullScreenPageMode = function() {
        return this.lookupName('NonFullScreenPageMode');
    };
    /** @ignore */ ViewerPreferences.prototype.Direction = function() {
        return this.lookupName('Direction');
    };
    /** @ignore */ ViewerPreferences.prototype.PrintScaling = function() {
        return this.lookupName('PrintScaling');
    };
    /** @ignore */ ViewerPreferences.prototype.Duplex = function() {
        return this.lookupName('Duplex');
    };
    /** @ignore */ ViewerPreferences.prototype.PickTrayByPDFSize = function() {
        return this.lookupBool('PickTrayByPDFSize');
    };
    /** @ignore */ ViewerPreferences.prototype.PrintPageRange = function() {
        var PrintPageRange = this.dict.lookup((0, $alPcq.default).of('PrintPageRange'));
        if (PrintPageRange instanceof (0, $dj8f2.default)) return PrintPageRange;
        return undefined;
    };
    /** @ignore */ ViewerPreferences.prototype.NumCopies = function() {
        var NumCopies = this.dict.lookup((0, $alPcq.default).of('NumCopies'));
        if (NumCopies instanceof (0, $4MKjy.default)) return NumCopies;
        return undefined;
    };
    /**
     * Returns `true` if PDF readers should hide the toolbar menus when displaying
     * this document.
     * @returns Whether or not toolbars should be hidden.
     */ ViewerPreferences.prototype.getHideToolbar = function() {
        var _a, _b;
        return (_b = (_a = this.HideToolbar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should hide the menu bar when displaying this
     * document.
     * @returns Whether or not the menu bar should be hidden.
     */ ViewerPreferences.prototype.getHideMenubar = function() {
        var _a, _b;
        return (_b = (_a = this.HideMenubar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should hide the user interface elements in
     * the document's window (such as scroll bars and navigation controls),
     * leaving only the document's contents displayed.
     * @returns Whether or not user interface elements should be hidden.
     */ ViewerPreferences.prototype.getHideWindowUI = function() {
        var _a, _b;
        return (_b = (_a = this.HideWindowUI()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should resize the document's window to fit
     * the size of the first displayed page.
     * @returns Whether or not the window should be resized to fit.
     */ ViewerPreferences.prototype.getFitWindow = function() {
        var _a, _b;
        return (_b = (_a = this.FitWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should position the document's window in the
     * center of the screen.
     * @returns Whether or not to center the document window.
     */ ViewerPreferences.prototype.getCenterWindow = function() {
        var _a, _b;
        return (_b = (_a = this.CenterWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if the window's title bar should display the document
     * `Title`, taken from the document metadata (see [[PDFDocument.getTitle]]).
     * Returns `false` if the title bar should instead display the filename of the
     * PDF file.
     * @returns Whether to display the document title.
     */ ViewerPreferences.prototype.getDisplayDocTitle = function() {
        var _a, _b;
        return (_b = (_a = this.DisplayDocTitle()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns the page mode, which tells the PDF reader how to display the
     * document after exiting full-screen mode.
     * @returns The page mode after exiting full-screen mode.
     */ ViewerPreferences.prototype.getNonFullScreenPageMode = function() {
        var _a, _b;
        var mode = (_a = this.NonFullScreenPageMode()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(mode, NonFullScreenPageMode)) !== null && _b !== void 0 ? _b : NonFullScreenPageMode.UseNone;
    };
    /**
     * Returns the predominant reading order for text.
     * @returns The text reading order.
     */ ViewerPreferences.prototype.getReadingDirection = function() {
        var _a, _b;
        var direction = (_a = this.Direction()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(direction, ReadingDirection)) !== null && _b !== void 0 ? _b : ReadingDirection.L2R;
    };
    /**
     * Returns the page scaling option that the PDF reader should select when the
     * print dialog is displayed.
     * @returns The page scaling option.
     */ ViewerPreferences.prototype.getPrintScaling = function() {
        var _a, _b;
        var scaling = (_a = this.PrintScaling()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(scaling, PrintScaling)) !== null && _b !== void 0 ? _b : PrintScaling.AppDefault;
    };
    /**
     * Returns the paper handling option that should be used when printing the
     * file from the print dialog.
     * @returns The paper handling option.
     */ ViewerPreferences.prototype.getDuplex = function() {
        var _a;
        var duplex = (_a = this.Duplex()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return asEnum(duplex, Duplex);
    };
    /**
     * Returns `true` if the PDF page size should be used to select the input
     * paper tray.
     * @returns Whether or not the PDF page size should be used to select the
     *          input paper tray.
     */ ViewerPreferences.prototype.getPickTrayByPDFSize = function() {
        var _a;
        return (_a = this.PickTrayByPDFSize()) === null || _a === void 0 ? void 0 : _a.asBoolean();
    };
    /**
     * Returns an array of page number ranges, which are the values used to
     * initialize the print dialog box when the file is printed. Each range
     * specifies the first (`start`) and last (`end`) pages in a sub-range of
     * pages to be printed. The first page of the PDF file is denoted by 0.
     * For example:
     * ```js
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * const includesPage3 = viewerPrefs
     *   .getPrintRanges()
     *   .some(pr => pr.start =< 2 && pr.end >= 2)
     * if (includesPage3) console.log('printRange includes page 3')
     * ```
     * @returns An array of objects, each with the properties `start` and `end`,
     *          denoting page indices. If not, specified an empty array is
     *          returned.
     */ ViewerPreferences.prototype.getPrintPageRange = function() {
        var rng = this.PrintPageRange();
        if (!rng) return [];
        var pageRanges = [];
        for(var i = 0; i < rng.size(); i += 2){
            // Despite the spec clearly stating that "The first page of the PDF file
            // shall be donoted by 1", several test PDFs (spec 1.7) created in
            // Acrobat XI 11.0 and also read with Reader DC 2020.013 indicate this is
            // actually a 0 based index.
            var start = rng.lookup(i, (0, $4MKjy.default)).asNumber();
            var end = rng.lookup(i + 1, (0, $4MKjy.default)).asNumber();
            pageRanges.push({
                start: start,
                end: end
            });
        }
        return pageRanges;
    };
    /**
     * Returns the number of copies to be printed when the print dialog is opened
     * for this document.
     * @returns The default number of copies to be printed.
     */ ViewerPreferences.prototype.getNumCopies = function() {
        var _a, _b;
        return (_b = (_a = this.NumCopies()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
    };
    /**
     * Choose whether the PDF reader's toolbars should be hidden while the
     * document is active.
     * @param hideToolbar `true` if the toolbar should be hidden.
     */ ViewerPreferences.prototype.setHideToolbar = function(hideToolbar) {
        var HideToolbar = this.dict.context.obj(hideToolbar);
        this.dict.set((0, $alPcq.default).of('HideToolbar'), HideToolbar);
    };
    /**
     * Choose whether the PDF reader's menu bar should be hidden while the
     * document is active.
     * @param hideMenubar `true` if the menu bar should be hidden.
     */ ViewerPreferences.prototype.setHideMenubar = function(hideMenubar) {
        var HideMenubar = this.dict.context.obj(hideMenubar);
        this.dict.set((0, $alPcq.default).of('HideMenubar'), HideMenubar);
    };
    /**
     * Choose whether the PDF reader should hide user interface elements in the
     * document's window (such as scroll bars and navigation controls), leaving
     * only the document's contents displayed.
     * @param hideWindowUI `true` if the user interface elements should be hidden.
     */ ViewerPreferences.prototype.setHideWindowUI = function(hideWindowUI) {
        var HideWindowUI = this.dict.context.obj(hideWindowUI);
        this.dict.set((0, $alPcq.default).of('HideWindowUI'), HideWindowUI);
    };
    /**
     * Choose whether the PDF reader should resize the document's window to fit
     * the size of the first displayed page.
     * @param fitWindow `true` if the window should be resized.
     */ ViewerPreferences.prototype.setFitWindow = function(fitWindow) {
        var FitWindow = this.dict.context.obj(fitWindow);
        this.dict.set((0, $alPcq.default).of('FitWindow'), FitWindow);
    };
    /**
     * Choose whether the PDF reader should position the document's window in the
     * center of the screen.
     * @param centerWindow `true` if the window should be centered.
     */ ViewerPreferences.prototype.setCenterWindow = function(centerWindow) {
        var CenterWindow = this.dict.context.obj(centerWindow);
        this.dict.set((0, $alPcq.default).of('CenterWindow'), CenterWindow);
    };
    /**
     * Choose whether the window's title bar should display the document `Title`
     * taken from the document metadata (see [[PDFDocument.setTitle]]). If
     * `false`, the title bar should instead display the PDF filename.
     * @param displayTitle `true` if the document title should be displayed.
     */ ViewerPreferences.prototype.setDisplayDocTitle = function(displayTitle) {
        var DisplayDocTitle = this.dict.context.obj(displayTitle);
        this.dict.set((0, $alPcq.default).of('DisplayDocTitle'), DisplayDocTitle);
    };
    /**
     * Choose how the PDF reader should display the document upon exiting
     * full-screen mode. This entry is meaningful only if the value of the
     * `PageMode` entry in the document's [[PDFCatalog]] is `FullScreen`.
     *
     * For example:
     * ```js
     * import { PDFDocument, NonFullScreenPageMode, PDFName } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     *
     * // Set the PageMode
     * pdfDoc.catalog.set(PDFName.of('PageMode'),PDFName.of('FullScreen'))
     *
     * // Set what happens when full-screen is closed
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setNonFullScreenPageMode(NonFullScreenPageMode.UseOutlines)
     * ```
     *
     * @param nonFullScreenPageMode How the document should be displayed upon
     *                              exiting full screen mode.
     */ ViewerPreferences.prototype.setNonFullScreenPageMode = function(nonFullScreenPageMode) {
        (0, $8EKPA.assertIsOneOf)(nonFullScreenPageMode, 'nonFullScreenPageMode', NonFullScreenPageMode);
        var mode = (0, $alPcq.default).of(nonFullScreenPageMode);
        this.dict.set((0, $alPcq.default).of('NonFullScreenPageMode'), mode);
    };
    /**
     * Choose the predominant reading order for text.
     *
     * This entry has no direct effect on the document's contents or page
     * numbering, but may be used to determine the relative positioning of pages
     * when displayed side by side or printed n-up.
     *
     * For example:
     * ```js
     * import { PDFDocument, ReadingDirection } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setReadingDirection(ReadingDirection.R2L)
     * ```
     *
     * @param readingDirection The reading order for text.
     */ ViewerPreferences.prototype.setReadingDirection = function(readingDirection) {
        (0, $8EKPA.assertIsOneOf)(readingDirection, 'readingDirection', ReadingDirection);
        var direction = (0, $alPcq.default).of(readingDirection);
        this.dict.set((0, $alPcq.default).of('Direction'), direction);
    };
    /**
     * Choose the page scaling option that should be selected when a print dialog
     * is displayed for this document.
     *
     * For example:
     * ```js
     * import { PDFDocument, PrintScaling } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setPrintScaling(PrintScaling.None)
     * ```
     *
     * @param printScaling The print scaling option.
     */ ViewerPreferences.prototype.setPrintScaling = function(printScaling) {
        (0, $8EKPA.assertIsOneOf)(printScaling, 'printScaling', PrintScaling);
        var scaling = (0, $alPcq.default).of(printScaling);
        this.dict.set((0, $alPcq.default).of('PrintScaling'), scaling);
    };
    /**
     * Choose the paper handling option that should be selected by default in the
     * print dialog.
     *
     * For example:
     * ```js
     * import { PDFDocument, Duplex } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setDuplex(Duplex.DuplexFlipShortEdge)
     * ```
     *
     * @param duplex The double or single sided printing option.
     */ ViewerPreferences.prototype.setDuplex = function(duplex) {
        (0, $8EKPA.assertIsOneOf)(duplex, 'duplex', Duplex);
        var dup = (0, $alPcq.default).of(duplex);
        this.dict.set((0, $alPcq.default).of('Duplex'), dup);
    };
    /**
     * Choose whether the PDF document's page size should be used to select the
     * input paper tray when printing. This setting influences only the preset
     * values used to populate the print dialog presented by a PDF reader.
     *
     * If PickTrayByPDFSize is true, the check box in the print dialog associated
     * with input paper tray should be checked. This setting has no effect on
     * operating systems that do not provide the ability to pick the input tray
     * by size.
     *
     * @param pickTrayByPDFSize `true` if the document's page size should be used
     *                          to select the input paper tray.
     */ ViewerPreferences.prototype.setPickTrayByPDFSize = function(pickTrayByPDFSize) {
        var PickTrayByPDFSize = this.dict.context.obj(pickTrayByPDFSize);
        this.dict.set((0, $alPcq.default).of('PickTrayByPDFSize'), PickTrayByPDFSize);
    };
    /**
     * Choose the page numbers used to initialize the print dialog box when the
     * file is printed. The first page of the PDF file is denoted by 0.
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     *
     * // We can set the default print range to only the first page
     * viewerPrefs.setPrintPageRange({ start: 0, end: 0 })
     *
     * // Or we can supply noncontiguous ranges (e.g. pages 1, 3, and 5-7)
     * viewerPrefs.setPrintPageRange([
     *   { start: 0, end: 0 },
     *   { start: 2, end: 2 },
     *   { start: 4, end: 6 },
     * ])
     * ```
     *
     * @param printPageRange An object or array of objects, each with the
     *                       properties `start` and `end`, denoting a range of
     *                       page indices.
     */ ViewerPreferences.prototype.setPrintPageRange = function(printPageRange) {
        if (!Array.isArray(printPageRange)) printPageRange = [
            printPageRange
        ];
        var flatRange = [];
        for(var idx = 0, len = printPageRange.length; idx < len; idx++){
            flatRange.push(printPageRange[idx].start);
            flatRange.push(printPageRange[idx].end);
        }
        (0, $8EKPA.assertEachIs)(flatRange, 'printPageRange', [
            'number'
        ]);
        var pageRanges = this.dict.context.obj(flatRange);
        this.dict.set((0, $alPcq.default).of('PrintPageRange'), pageRanges);
    };
    /**
     * Choose the default number of copies to be printed when the print dialog is
     * opened for this file.
     * @param numCopies The default number of copies.
     */ ViewerPreferences.prototype.setNumCopies = function(numCopies) {
        (0, $8EKPA.assertRange)(numCopies, 'numCopies', 1, Number.MAX_VALUE);
        (0, $8EKPA.assertInteger)(numCopies, 'numCopies');
        var NumCopies = this.dict.context.obj(numCopies);
        this.dict.set((0, $alPcq.default).of('NumCopies'), NumCopies);
    };
    /** @ignore */ ViewerPreferences.fromDict = function(dict) {
        return new ViewerPreferences(dict);
    };
    /** @ignore */ ViewerPreferences.create = function(context) {
        var dict = context.obj({});
        return new ViewerPreferences(dict);
    };
    return ViewerPreferences;
}();
var $9d489d9f1790be4a$export$2e2bcd8739ae039 = ViewerPreferences;

});
parcelRegister("dj8f2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b03714b39d27359$export$2e2bcd8739ae039; });

var $273XO = parcelRequire("273XO");

var $4MKjy = parcelRequire("4MKjy");

var $eKLLF = parcelRequire("eKLLF");

var $8KH3B = parcelRequire("8KH3B");

var $iMObG = parcelRequire("iMObG");
var $9b03714b39d27359$var$PDFArray = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFArray, _super);
    function PDFArray(context) {
        var _this = _super.call(this) || this;
        _this.array = [];
        _this.context = context;
        return _this;
    }
    PDFArray.prototype.size = function() {
        return this.array.length;
    };
    PDFArray.prototype.push = function(object) {
        this.array.push(object);
    };
    PDFArray.prototype.insert = function(index, object) {
        this.array.splice(index, 0, object);
    };
    PDFArray.prototype.indexOf = function(object) {
        var index = this.array.indexOf(object);
        return index === -1 ? undefined : index;
    };
    PDFArray.prototype.remove = function(index) {
        this.array.splice(index, 1);
    };
    PDFArray.prototype.set = function(idx, object) {
        this.array[idx] = object;
    };
    PDFArray.prototype.get = function(index) {
        return this.array[index];
    };
    PDFArray.prototype.lookupMaybe = function(index) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        return (_a = this.context).lookupMaybe.apply(_a, (0, $273XO.__spreadArrays)([
            this.get(index)
        ], types));
    };
    PDFArray.prototype.lookup = function(index) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        return (_a = this.context).lookup.apply(_a, (0, $273XO.__spreadArrays)([
            this.get(index)
        ], types));
    };
    PDFArray.prototype.asRectangle = function() {
        if (this.size() !== 4) throw new (0, $iMObG.PDFArrayIsNotRectangleError)(this.size());
        var lowerLeftX = this.lookup(0, (0, $4MKjy.default)).asNumber();
        var lowerLeftY = this.lookup(1, (0, $4MKjy.default)).asNumber();
        var upperRightX = this.lookup(2, (0, $4MKjy.default)).asNumber();
        var upperRightY = this.lookup(3, (0, $4MKjy.default)).asNumber();
        var x = lowerLeftX;
        var y = lowerLeftY;
        var width = upperRightX - lowerLeftX;
        var height = upperRightY - lowerLeftY;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    };
    PDFArray.prototype.asArray = function() {
        return this.array.slice();
    };
    PDFArray.prototype.clone = function(context) {
        var clone = PDFArray.withContext(context || this.context);
        for(var idx = 0, len = this.size(); idx < len; idx++)clone.push(this.array[idx]);
        return clone;
    };
    PDFArray.prototype.toString = function() {
        var arrayString = '[ ';
        for(var idx = 0, len = this.size(); idx < len; idx++){
            arrayString += this.get(idx).toString();
            arrayString += ' ';
        }
        arrayString += ']';
        return arrayString;
    };
    PDFArray.prototype.sizeInBytes = function() {
        var size = 3;
        for(var idx = 0, len = this.size(); idx < len; idx++)size += this.get(idx).sizeInBytes() + 1;
        return size;
    };
    PDFArray.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8KH3B.default).LeftSquareBracket;
        buffer[offset++] = (0, $8KH3B.default).Space;
        for(var idx = 0, len = this.size(); idx < len; idx++){
            offset += this.get(idx).copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8KH3B.default).Space;
        }
        buffer[offset++] = (0, $8KH3B.default).RightSquareBracket;
        return offset - initialOffset;
    };
    PDFArray.prototype.scalePDFNumbers = function(x, y) {
        for(var idx = 0, len = this.size(); idx < len; idx++){
            var el = this.lookup(idx);
            if (el instanceof (0, $4MKjy.default)) {
                var factor = idx % 2 === 0 ? x : y;
                this.set(idx, (0, $4MKjy.default).of(el.asNumber() * factor));
            }
        }
    };
    PDFArray.withContext = function(context) {
        return new PDFArray(context);
    };
    return PDFArray;
}((0, $eKLLF.default));
var $9b03714b39d27359$export$2e2bcd8739ae039 = $9b03714b39d27359$var$PDFArray;

});
parcelRegister("273XO", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $189f4f5ac104c4ae$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $189f4f5ac104c4ae$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $189f4f5ac104c4ae$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $189f4f5ac104c4ae$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $189f4f5ac104c4ae$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__spreadArrays", function () { return $189f4f5ac104c4ae$export$6388937ca91ccae8; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $189f4f5ac104c4ae$var$extendStatics = function(d, b) {
    $189f4f5ac104c4ae$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $189f4f5ac104c4ae$var$extendStatics(d, b);
};
function $189f4f5ac104c4ae$export$a8ba968b8961cb8a(d, b) {
    $189f4f5ac104c4ae$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $189f4f5ac104c4ae$export$18ce0697a983be9b = function() {
    $189f4f5ac104c4ae$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $189f4f5ac104c4ae$export$18ce0697a983be9b.apply(this, arguments);
};
function $189f4f5ac104c4ae$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $189f4f5ac104c4ae$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $189f4f5ac104c4ae$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $189f4f5ac104c4ae$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $189f4f5ac104c4ae$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $189f4f5ac104c4ae$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $189f4f5ac104c4ae$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $189f4f5ac104c4ae$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $189f4f5ac104c4ae$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $189f4f5ac104c4ae$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $189f4f5ac104c4ae$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($189f4f5ac104c4ae$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $189f4f5ac104c4ae$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $189f4f5ac104c4ae$export$10c90e4f7922046c(v) {
    return this instanceof $189f4f5ac104c4ae$export$10c90e4f7922046c ? (this.v = v, this) : new $189f4f5ac104c4ae$export$10c90e4f7922046c(v);
}
function $189f4f5ac104c4ae$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $189f4f5ac104c4ae$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $189f4f5ac104c4ae$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $189f4f5ac104c4ae$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $189f4f5ac104c4ae$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $189f4f5ac104c4ae$export$19a8beecd37a4c45 === "function" ? $189f4f5ac104c4ae$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $189f4f5ac104c4ae$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $189f4f5ac104c4ae$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $189f4f5ac104c4ae$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $189f4f5ac104c4ae$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $189f4f5ac104c4ae$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("4MKjy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37bf922c37748fa6$export$2e2bcd8739ae039; });

var $273XO = parcelRequire("273XO");
parcelRequire("5bpFt");
var $8hWZH = parcelRequire("8hWZH");
var $lAEMS = parcelRequire("lAEMS");

var $eKLLF = parcelRequire("eKLLF");
var $37bf922c37748fa6$var$PDFNumber = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFNumber, _super);
    function PDFNumber(value) {
        var _this = _super.call(this) || this;
        _this.numberValue = value;
        _this.stringValue = (0, $lAEMS.numberToString)(value);
        return _this;
    }
    PDFNumber.prototype.asNumber = function() {
        return this.numberValue;
    };
    /** @deprecated in favor of [[PDFNumber.asNumber]] */ PDFNumber.prototype.value = function() {
        return this.numberValue;
    };
    PDFNumber.prototype.clone = function() {
        return PDFNumber.of(this.numberValue);
    };
    PDFNumber.prototype.toString = function() {
        return this.stringValue;
    };
    PDFNumber.prototype.sizeInBytes = function() {
        return this.stringValue.length;
    };
    PDFNumber.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $8hWZH.copyStringIntoBuffer)(this.stringValue, buffer, offset);
        return this.stringValue.length;
    };
    PDFNumber.of = function(value) {
        return new PDFNumber(value);
    };
    return PDFNumber;
}((0, $eKLLF.default));
var $37bf922c37748fa6$export$2e2bcd8739ae039 = $37bf922c37748fa6$var$PDFNumber;

});
parcelRegister("5bpFt", function(module, exports) {
$parcel$export(module.exports, "arrayAsString", function () { return (parcelRequire("a9yd5")).arrayAsString; });
$parcel$export(module.exports, "byAscendingId", function () { return (parcelRequire("a9yd5")).byAscendingId; });
$parcel$export(module.exports, "canBeConvertedToUint8Array", function () { return (parcelRequire("a9yd5")).canBeConvertedToUint8Array; });
$parcel$export(module.exports, "last", function () { return (parcelRequire("a9yd5")).last; });
$parcel$export(module.exports, "mergeIntoTypedArray", function () { return (parcelRequire("a9yd5")).mergeIntoTypedArray; });
$parcel$export(module.exports, "mergeUint8Arrays", function () { return (parcelRequire("a9yd5")).mergeUint8Arrays; });
$parcel$export(module.exports, "pluckIndices", function () { return (parcelRequire("a9yd5")).pluckIndices; });
$parcel$export(module.exports, "range", function () { return (parcelRequire("a9yd5")).range; });
$parcel$export(module.exports, "reverseArray", function () { return (parcelRequire("a9yd5")).reverseArray; });
$parcel$export(module.exports, "sortedUniq", function () { return (parcelRequire("a9yd5")).sortedUniq; });
$parcel$export(module.exports, "sum", function () { return (parcelRequire("a9yd5")).sum; });
$parcel$export(module.exports, "toUint8Array", function () { return (parcelRequire("a9yd5")).toUint8Array; });
$parcel$export(module.exports, "typedArrayFor", function () { return (parcelRequire("a9yd5")).typedArrayFor; });
$parcel$export(module.exports, "waitForTick", function () { return (parcelRequire("42Fix")).waitForTick; });
$parcel$export(module.exports, "breakTextIntoLines", function () { return (parcelRequire("8hWZH")).breakTextIntoLines; });
$parcel$export(module.exports, "charAtIndex", function () { return (parcelRequire("8hWZH")).charAtIndex; });
$parcel$export(module.exports, "charFromCode", function () { return (parcelRequire("8hWZH")).charFromCode; });
$parcel$export(module.exports, "charFromHexCode", function () { return (parcelRequire("8hWZH")).charFromHexCode; });
$parcel$export(module.exports, "charSplit", function () { return (parcelRequire("8hWZH")).charSplit; });
$parcel$export(module.exports, "cleanText", function () { return (parcelRequire("8hWZH")).cleanText; });
$parcel$export(module.exports, "copyStringIntoBuffer", function () { return (parcelRequire("8hWZH")).copyStringIntoBuffer; });
$parcel$export(module.exports, "findLastMatch", function () { return (parcelRequire("8hWZH")).findLastMatch; });
$parcel$export(module.exports, "lineSplit", function () { return (parcelRequire("8hWZH")).lineSplit; });
$parcel$export(module.exports, "mergeLines", function () { return (parcelRequire("8hWZH")).mergeLines; });
$parcel$export(module.exports, "padStart", function () { return (parcelRequire("8hWZH")).padStart; });
$parcel$export(module.exports, "parseDate", function () { return (parcelRequire("8hWZH")).parseDate; });
$parcel$export(module.exports, "toCharCode", function () { return (parcelRequire("8hWZH")).toCharCode; });
$parcel$export(module.exports, "toCodePoint", function () { return (parcelRequire("8hWZH")).toCodePoint; });
$parcel$export(module.exports, "toHexString", function () { return (parcelRequire("8hWZH")).toHexString; });
$parcel$export(module.exports, "toHexStringOfMinLength", function () { return (parcelRequire("8hWZH")).toHexStringOfMinLength; });
$parcel$export(module.exports, "hasUtf16BOM", function () { return (parcelRequire("67HjY")).hasUtf16BOM; });
$parcel$export(module.exports, "utf16Decode", function () { return (parcelRequire("67HjY")).utf16Decode; });
$parcel$export(module.exports, "utf16Encode", function () { return (parcelRequire("67HjY")).utf16Encode; });
$parcel$export(module.exports, "bytesFor", function () { return (parcelRequire("lAEMS")).bytesFor; });
$parcel$export(module.exports, "numberToString", function () { return (parcelRequire("lAEMS")).numberToString; });
$parcel$export(module.exports, "sizeInBytes", function () { return (parcelRequire("lAEMS")).sizeInBytes; });
$parcel$export(module.exports, "error", function () { return (parcelRequire("kug8p")).error; });
$parcel$export(module.exports, "encodeToBase64", function () { return (parcelRequire("cMViw")).encodeToBase64; });
$parcel$export(module.exports, "isStandardFont", function () { return (parcelRequire("lxE62")).isStandardFont; });
$parcel$export(module.exports, "rectanglesAreEqual", function () { return (parcelRequire("lxE62")).rectanglesAreEqual; });
$parcel$export(module.exports, "assertEachIs", function () { return (parcelRequire("8EKPA")).assertEachIs; });
$parcel$export(module.exports, "assertInteger", function () { return (parcelRequire("8EKPA")).assertInteger; });
$parcel$export(module.exports, "assertIs", function () { return (parcelRequire("8EKPA")).assertIs; });
$parcel$export(module.exports, "assertIsOneOf", function () { return (parcelRequire("8EKPA")).assertIsOneOf; });
$parcel$export(module.exports, "assertIsOneOfOrUndefined", function () { return (parcelRequire("8EKPA")).assertIsOneOfOrUndefined; });
$parcel$export(module.exports, "assertIsSubset", function () { return (parcelRequire("8EKPA")).assertIsSubset; });
$parcel$export(module.exports, "assertMultiple", function () { return (parcelRequire("8EKPA")).assertMultiple; });
$parcel$export(module.exports, "assertOrUndefined", function () { return (parcelRequire("8EKPA")).assertOrUndefined; });
$parcel$export(module.exports, "assertPositive", function () { return (parcelRequire("8EKPA")).assertPositive; });
$parcel$export(module.exports, "assertRange", function () { return (parcelRequire("8EKPA")).assertRange; });
$parcel$export(module.exports, "assertRangeOrUndefined", function () { return (parcelRequire("8EKPA")).assertRangeOrUndefined; });
$parcel$export(module.exports, "pdfDocEncodingDecode", function () { return (parcelRequire("kUYxV")).pdfDocEncodingDecode; });

$parcel$export(module.exports, "Cache", function () { return (parcelRequire("hGYOY")).default; });
parcelRequire("a9yd5");
parcelRequire("42Fix");
parcelRequire("8hWZH");
parcelRequire("67HjY");
parcelRequire("lAEMS");
parcelRequire("kug8p");
parcelRequire("cMViw");
parcelRequire("lxE62");
parcelRequire("8EKPA");
parcelRequire("kUYxV");

var $hGYOY = parcelRequire("hGYOY");

});
parcelRegister("a9yd5", function(module, exports) {

$parcel$export(module.exports, "last", function () { return $76454810d5a75d2f$export$4c7897fafd92b108; });
$parcel$export(module.exports, "typedArrayFor", function () { return $76454810d5a75d2f$export$98b44e66722b6f4d; });
$parcel$export(module.exports, "mergeIntoTypedArray", function () { return $76454810d5a75d2f$export$8907b5381cbcd9a7; });
$parcel$export(module.exports, "mergeUint8Arrays", function () { return $76454810d5a75d2f$export$99cee7ee2de7e6e4; });
$parcel$export(module.exports, "arrayAsString", function () { return $76454810d5a75d2f$export$5f8f9664fe5c5f14; });
$parcel$export(module.exports, "byAscendingId", function () { return $76454810d5a75d2f$export$55b6b1f56c6e1ba5; });
$parcel$export(module.exports, "sortedUniq", function () { return $76454810d5a75d2f$export$720e3b5aefb27114; });
$parcel$export(module.exports, "reverseArray", function () { return $76454810d5a75d2f$export$c9b97e771c4a8302; });
$parcel$export(module.exports, "sum", function () { return $76454810d5a75d2f$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "range", function () { return $76454810d5a75d2f$export$d02631cccf789723; });
$parcel$export(module.exports, "pluckIndices", function () { return $76454810d5a75d2f$export$279d041ff3481d88; });
$parcel$export(module.exports, "canBeConvertedToUint8Array", function () { return $76454810d5a75d2f$export$20e9c5ed92218c4b; });
$parcel$export(module.exports, "toUint8Array", function () { return $76454810d5a75d2f$export$73470fd2221e6aef; });

var $cMViw = parcelRequire("cMViw");

var $8hWZH = parcelRequire("8hWZH");
var $76454810d5a75d2f$export$4c7897fafd92b108 = function(array) {
    return array[array.length - 1];
};
var $76454810d5a75d2f$export$98b44e66722b6f4d = function(value) {
    if (value instanceof Uint8Array) return value;
    var length = value.length;
    var typedArray = new Uint8Array(length);
    for(var idx = 0; idx < length; idx++)typedArray[idx] = value.charCodeAt(idx);
    return typedArray;
};
var $76454810d5a75d2f$export$8907b5381cbcd9a7 = function() {
    var arrays = [];
    for(var _i = 0; _i < arguments.length; _i++)arrays[_i] = arguments[_i];
    var arrayCount = arrays.length;
    var typedArrays = [];
    for(var idx = 0; idx < arrayCount; idx++){
        var element = arrays[idx];
        typedArrays[idx] = element instanceof Uint8Array ? element : $76454810d5a75d2f$export$98b44e66722b6f4d(element);
    }
    var totalSize = 0;
    for(var idx = 0; idx < arrayCount; idx++)totalSize += arrays[idx].length;
    var merged = new Uint8Array(totalSize);
    var offset = 0;
    for(var arrIdx = 0; arrIdx < arrayCount; arrIdx++){
        var arr = typedArrays[arrIdx];
        for(var byteIdx = 0, arrLen = arr.length; byteIdx < arrLen; byteIdx++)merged[offset++] = arr[byteIdx];
    }
    return merged;
};
var $76454810d5a75d2f$export$99cee7ee2de7e6e4 = function(arrays) {
    var totalSize = 0;
    for(var idx = 0, len = arrays.length; idx < len; idx++)totalSize += arrays[idx].length;
    var mergedBuffer = new Uint8Array(totalSize);
    var offset = 0;
    for(var idx = 0, len = arrays.length; idx < len; idx++){
        var array = arrays[idx];
        mergedBuffer.set(array, offset);
        offset += array.length;
    }
    return mergedBuffer;
};
var $76454810d5a75d2f$export$5f8f9664fe5c5f14 = function(array) {
    var str = '';
    for(var idx = 0, len = array.length; idx < len; idx++)str += (0, $8hWZH.charFromCode)(array[idx]);
    return str;
};
var $76454810d5a75d2f$export$55b6b1f56c6e1ba5 = function(a, b) {
    return a.id - b.id;
};
var $76454810d5a75d2f$export$720e3b5aefb27114 = function(array, indexer) {
    var uniq = [];
    for(var idx = 0, len = array.length; idx < len; idx++){
        var curr = array[idx];
        var prev = array[idx - 1];
        if (idx === 0 || indexer(curr) !== indexer(prev)) uniq.push(curr);
    }
    return uniq;
};
var $76454810d5a75d2f$export$c9b97e771c4a8302 = function(array) {
    var arrayLen = array.length;
    for(var idx = 0, len = Math.floor(arrayLen / 2); idx < len; idx++){
        var leftIdx = idx;
        var rightIdx = arrayLen - idx - 1;
        var temp = array[idx];
        array[leftIdx] = array[rightIdx];
        array[rightIdx] = temp;
    }
    return array;
};
var $76454810d5a75d2f$export$8a63f25cc62965f1 = function(array) {
    var total = 0;
    for(var idx = 0, len = array.length; idx < len; idx++)total += array[idx];
    return total;
};
var $76454810d5a75d2f$export$d02631cccf789723 = function(start, end) {
    var arr = new Array(end - start);
    for(var idx = 0, len = arr.length; idx < len; idx++)arr[idx] = start + idx;
    return arr;
};
var $76454810d5a75d2f$export$279d041ff3481d88 = function(arr, indices) {
    var plucked = new Array(indices.length);
    for(var idx = 0, len = indices.length; idx < len; idx++)plucked[idx] = arr[indices[idx]];
    return plucked;
};
var $76454810d5a75d2f$export$20e9c5ed92218c4b = function(input) {
    return input instanceof Uint8Array || input instanceof ArrayBuffer || typeof input === 'string';
};
var $76454810d5a75d2f$export$73470fd2221e6aef = function(input) {
    if (typeof input === 'string') return (0, $cMViw.decodeFromBase64DataUri)(input);
    else if (input instanceof ArrayBuffer) return new Uint8Array(input);
    else if (input instanceof Uint8Array) return input;
    else throw new TypeError('`input` must be one of `string | ArrayBuffer | Uint8Array`');
};

});
parcelRegister("cMViw", function(module, exports) {

$parcel$export(module.exports, "encodeToBase64", function () { return $94f669ddeca7cc32$export$373f4c3083978ffd; });
$parcel$export(module.exports, "decodeFromBase64DataUri", function () { return $94f669ddeca7cc32$export$f6810f5086699d73; });
/*
 * The `chars`, `lookup`, `encode`, and `decode` members of this file are
 * licensed under the following:
 *
 *     base64-arraybuffer
 *     https://github.com/niklasvh/base64-arraybuffer
 *
 *     Copyright (c) 2012 Niklas von Hertzen
 *     Licensed under the MIT license.
 *
 */ var $94f669ddeca7cc32$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $94f669ddeca7cc32$var$lookup = new Uint8Array(256);
for(var $94f669ddeca7cc32$var$i = 0; $94f669ddeca7cc32$var$i < $94f669ddeca7cc32$var$chars.length; $94f669ddeca7cc32$var$i++)$94f669ddeca7cc32$var$lookup[$94f669ddeca7cc32$var$chars.charCodeAt($94f669ddeca7cc32$var$i)] = $94f669ddeca7cc32$var$i;
var $94f669ddeca7cc32$export$373f4c3083978ffd = function(bytes) {
    var base64 = '';
    var len = bytes.length;
    for(var i = 0; i < len; i += 3){
        base64 += $94f669ddeca7cc32$var$chars[bytes[i] >> 2];
        base64 += $94f669ddeca7cc32$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $94f669ddeca7cc32$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $94f669ddeca7cc32$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
var $94f669ddeca7cc32$export$83edfd8fcc66ec17 = function(base64) {
    var bufferLength = base64.length * 0.75;
    var len = base64.length;
    var i;
    var p = 0;
    var encoded1;
    var encoded2;
    var encoded3;
    var encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    var bytes = new Uint8Array(bufferLength);
    for(i = 0; i < len; i += 4){
        encoded1 = $94f669ddeca7cc32$var$lookup[base64.charCodeAt(i)];
        encoded2 = $94f669ddeca7cc32$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $94f669ddeca7cc32$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $94f669ddeca7cc32$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
};
// This regex is designed to be as flexible as possible. It will parse certain
// invalid data URIs.
var $94f669ddeca7cc32$var$DATA_URI_PREFIX_REGEX = /^(data)?:?([\w\/\+]+)?;?(charset=[\w-]+|base64)?.*,/i;
var $94f669ddeca7cc32$export$f6810f5086699d73 = function(dataUri) {
    var trimmedUri = dataUri.trim();
    var prefix = trimmedUri.substring(0, 100);
    var res = prefix.match($94f669ddeca7cc32$var$DATA_URI_PREFIX_REGEX);
    // Assume it's not a data URI - just a plain base64 string
    if (!res) return $94f669ddeca7cc32$export$83edfd8fcc66ec17(trimmedUri);
    // Remove the data URI prefix and parse the remainder as a base64 string
    var fullMatch = res[0];
    var data = trimmedUri.substring(fullMatch.length);
    return $94f669ddeca7cc32$export$83edfd8fcc66ec17(data);
};

});

parcelRegister("8hWZH", function(module, exports) {

$parcel$export(module.exports, "toCharCode", function () { return $608dac473c546c26$export$d90166409dd04e85; });
$parcel$export(module.exports, "toCodePoint", function () { return $608dac473c546c26$export$93bf578f015d73f0; });
$parcel$export(module.exports, "toHexStringOfMinLength", function () { return $608dac473c546c26$export$6ac97d2d1bf41f39; });
$parcel$export(module.exports, "padStart", function () { return $608dac473c546c26$export$36cf564d487b5178; });
$parcel$export(module.exports, "toHexString", function () { return $608dac473c546c26$export$f4915efbb94d4d01; });
$parcel$export(module.exports, "charFromCode", function () { return $608dac473c546c26$export$207031940e6950ad; });
$parcel$export(module.exports, "charFromHexCode", function () { return $608dac473c546c26$export$ceedd1b69dcde7a5; });
$parcel$export(module.exports, "copyStringIntoBuffer", function () { return $608dac473c546c26$export$c41a03555c37a984; });
$parcel$export(module.exports, "cleanText", function () { return $608dac473c546c26$export$6b5e57d20078142b; });
$parcel$export(module.exports, "lineSplit", function () { return $608dac473c546c26$export$4f60280859794d8c; });
$parcel$export(module.exports, "mergeLines", function () { return $608dac473c546c26$export$b5bf5e120f07cbe; });
$parcel$export(module.exports, "charAtIndex", function () { return $608dac473c546c26$export$1a93fc5af577aa5c; });
$parcel$export(module.exports, "charSplit", function () { return $608dac473c546c26$export$78f5a8ab9b5e7f1e; });
$parcel$export(module.exports, "breakTextIntoLines", function () { return $608dac473c546c26$export$38936f7739928807; });
$parcel$export(module.exports, "parseDate", function () { return $608dac473c546c26$export$6b862160d295c8e; });
$parcel$export(module.exports, "findLastMatch", function () { return $608dac473c546c26$export$dc1d7d42f51764e3; });
var $608dac473c546c26$export$d90166409dd04e85 = function(character) {
    return character.charCodeAt(0);
};
var $608dac473c546c26$export$93bf578f015d73f0 = function(character) {
    return character.codePointAt(0);
};
var $608dac473c546c26$export$6ac97d2d1bf41f39 = function(num, minLength) {
    return $608dac473c546c26$export$36cf564d487b5178(num.toString(16), minLength, '0').toUpperCase();
};
var $608dac473c546c26$export$f4915efbb94d4d01 = function(num) {
    return $608dac473c546c26$export$6ac97d2d1bf41f39(num, 2);
};
var $608dac473c546c26$export$207031940e6950ad = function(code) {
    return String.fromCharCode(code);
};
var $608dac473c546c26$export$ceedd1b69dcde7a5 = function(hex) {
    return $608dac473c546c26$export$207031940e6950ad(parseInt(hex, 16));
};
var $608dac473c546c26$export$36cf564d487b5178 = function(value, length, padChar) {
    var padding = '';
    for(var idx = 0, len = length - value.length; idx < len; idx++)padding += padChar;
    return padding + value;
};
var $608dac473c546c26$export$c41a03555c37a984 = function(str, buffer, offset) {
    var length = str.length;
    for(var idx = 0; idx < length; idx++)buffer[offset++] = str.charCodeAt(idx);
    return length;
};
var $608dac473c546c26$export$505d8f7c00d806ca = function(prefix, suffixLength) {
    if (suffixLength === void 0) suffixLength = 4;
    return prefix + "-" + Math.floor(Math.random() * Math.pow(10, suffixLength));
};
var $608dac473c546c26$export$7c57da42ce8e346f = function(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
var $608dac473c546c26$export$6b5e57d20078142b = function(text) {
    return text.replace(/\t|\u0085|\u2028|\u2029/g, '    ').replace(/[\b\v]/g, '');
};
var $608dac473c546c26$export$60bd2eb6e5a75df0 = [
    '\\n',
    '\\f',
    '\\r',
    '\\u000B'
];
var $608dac473c546c26$export$634cc0013ed0f624 = [
    '\n',
    '\f',
    '\r',
    '\u000B'
];
var $608dac473c546c26$export$3fc8feceeed3beb0 = function(text) {
    return /^[\n\f\r\u000B]$/.test(text);
};
var $608dac473c546c26$export$4f60280859794d8c = function(text) {
    return text.split(/[\n\f\r\u000B]/);
};
var $608dac473c546c26$export$b5bf5e120f07cbe = function(text) {
    return text.replace(/[\n\f\r\u000B]/g, ' ');
};
var $608dac473c546c26$export$1a93fc5af577aa5c = function(text, index) {
    // Get the first code unit and code unit value
    var cuFirst = text.charCodeAt(index);
    var cuSecond;
    var nextIndex = index + 1;
    var length = 1;
    if (// Check if it's the start of a surrogate pair.
    cuFirst >= 0xd800 && cuFirst <= 0xdbff && // high surrogate
    text.length > nextIndex // there is a next code unit
    ) {
        cuSecond = text.charCodeAt(nextIndex);
        if (cuSecond >= 0xdc00 && cuSecond <= 0xdfff) length = 2; // low surrogate
    }
    return [
        text.slice(index, index + length),
        length
    ];
};
var $608dac473c546c26$export$78f5a8ab9b5e7f1e = function(text) {
    var chars = [];
    for(var idx = 0, len = text.length; idx < len;){
        var _a = $608dac473c546c26$export$1a93fc5af577aa5c(text, idx), c = _a[0], cLen = _a[1];
        chars.push(c);
        idx += cLen;
    }
    return chars;
};
var $608dac473c546c26$var$buildWordBreakRegex = function(wordBreaks) {
    var newlineCharUnion = $608dac473c546c26$export$60bd2eb6e5a75df0.join('|');
    var escapedRules = [
        '$'
    ];
    for(var idx = 0, len = wordBreaks.length; idx < len; idx++){
        var wordBreak = wordBreaks[idx];
        if ($608dac473c546c26$export$3fc8feceeed3beb0(wordBreak)) throw new TypeError("`wordBreak` must not include " + newlineCharUnion);
        escapedRules.push(wordBreak === '' ? '.' : $608dac473c546c26$export$7c57da42ce8e346f(wordBreak));
    }
    var breakRules = escapedRules.join('|');
    return new RegExp("(" + newlineCharUnion + ")|((.*?)(" + breakRules + "))", 'gm');
};
var $608dac473c546c26$export$38936f7739928807 = function(text, wordBreaks, maxWidth, computeWidthOfText) {
    var regex = $608dac473c546c26$var$buildWordBreakRegex(wordBreaks);
    var words = $608dac473c546c26$export$6b5e57d20078142b(text).match(regex);
    var currLine = '';
    var currWidth = 0;
    var lines = [];
    var pushCurrLine = function() {
        if (currLine !== '') lines.push(currLine);
        currLine = '';
        currWidth = 0;
    };
    for(var idx = 0, len = words.length; idx < len; idx++){
        var word = words[idx];
        if ($608dac473c546c26$export$3fc8feceeed3beb0(word)) pushCurrLine();
        else {
            var width = computeWidthOfText(word);
            if (currWidth + width > maxWidth) pushCurrLine();
            currLine += word;
            currWidth += width;
        }
    }
    pushCurrLine();
    return lines;
};
// See section "7.9.4 Dates" of the PDF specification
var $608dac473c546c26$var$dateRegex = /^D:(\d\d\d\d)(\d\d)?(\d\d)?(\d\d)?(\d\d)?(\d\d)?([+\-Z])?(\d\d)?'?(\d\d)?'?$/;
var $608dac473c546c26$export$6b862160d295c8e = function(dateStr) {
    var match = dateStr.match($608dac473c546c26$var$dateRegex);
    if (!match) return undefined;
    var year = match[1], _a = match[2], month = _a === void 0 ? '01' : _a, _b = match[3], day = _b === void 0 ? '01' : _b, _c = match[4], hours = _c === void 0 ? '00' : _c, _d = match[5], mins = _d === void 0 ? '00' : _d, _e = match[6], secs = _e === void 0 ? '00' : _e, _f = match[7], offsetSign = _f === void 0 ? 'Z' : _f, _g = match[8], offsetHours = _g === void 0 ? '00' : _g, _h = match[9], offsetMins = _h === void 0 ? '00' : _h;
    // http://www.ecma-international.org/ecma-262/5.1/#sec-15.9.1.15
    var tzOffset = offsetSign === 'Z' ? 'Z' : "" + offsetSign + offsetHours + ":" + offsetMins;
    var date = new Date(year + "-" + month + "-" + day + "T" + hours + ":" + mins + ":" + secs + tzOffset);
    return date;
};
var $608dac473c546c26$export$dc1d7d42f51764e3 = function(value, regex) {
    var _a;
    var position = 0;
    var lastMatch;
    while(position < value.length){
        var match = value.substring(position).match(regex);
        if (!match) return {
            match: lastMatch,
            pos: position
        };
        lastMatch = match;
        position += ((_a = match.index) !== null && _a !== void 0 ? _a : 0) + match[0].length;
    }
    return {
        match: lastMatch,
        pos: position
    };
};

});


parcelRegister("42Fix", function(module, exports) {

$parcel$export(module.exports, "waitForTick", function () { return $2f17623a2b6018db$export$3b7198a3beef1a5f; });
/**
 * Returns a Promise that resolves after at least one tick of the
 * Macro Task Queue occurs.
 */ var $2f17623a2b6018db$export$3b7198a3beef1a5f = function() {
    return new Promise(function(resolve) {
        setTimeout(function() {
            return resolve();
        }, 0);
    });
};

});

parcelRegister("67HjY", function(module, exports) {

$parcel$export(module.exports, "utf16Encode", function () { return $4755002ef894fc8a$export$73704d2337848c8e; });
$parcel$export(module.exports, "highSurrogate", function () { return $4755002ef894fc8a$export$8d3bd4086f36eaeb; });
$parcel$export(module.exports, "lowSurrogate", function () { return $4755002ef894fc8a$export$382051c72943492d; });
$parcel$export(module.exports, "isWithinBMP", function () { return $4755002ef894fc8a$export$919ae47c3852aa15; });
$parcel$export(module.exports, "hasSurrogates", function () { return $4755002ef894fc8a$export$d5ab89e7561b44ab; });
$parcel$export(module.exports, "utf16Decode", function () { return $4755002ef894fc8a$export$b89f54f9db637f79; });
$parcel$export(module.exports, "hasUtf16BOM", function () { return $4755002ef894fc8a$export$41e7c15c75b1b24d; });

var $8hWZH = parcelRequire("8hWZH");
var $4755002ef894fc8a$export$e1b32e613f230dc6 = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    var encoded = [];
    if (byteOrderMark) encoded.push(0xef, 0xbb, 0xbf);
    for(var idx = 0, len = input.length; idx < len;){
        var codePoint = input.codePointAt(idx);
        // One byte encoding
        if (codePoint < 0x80) {
            var byte1 = codePoint & 0x7f;
            encoded.push(byte1);
            idx += 1;
        } else if (codePoint < 0x0800) {
            var byte1 = codePoint >> 6 & 0x1f | 0xc0;
            var byte2 = codePoint & 0x3f | 0x80;
            encoded.push(byte1, byte2);
            idx += 1;
        } else if (codePoint < 0x010000) {
            var byte1 = codePoint >> 12 & 0x0f | 0xe0;
            var byte2 = codePoint >> 6 & 0x3f | 0x80;
            var byte3 = codePoint & 0x3f | 0x80;
            encoded.push(byte1, byte2, byte3);
            idx += 1;
        } else if (codePoint < 0x110000) {
            var byte1 = codePoint >> 18 & 0x07 | 0xf0;
            var byte2 = codePoint >> 12 & 0x3f | 0x80;
            var byte3 = codePoint >> 6 & 0x3f | 0x80;
            var byte4 = codePoint >> 0 & 0x3f | 0x80;
            encoded.push(byte1, byte2, byte3, byte4);
            idx += 2;
        } else throw new Error("Invalid code point: 0x" + (0, $8hWZH.toHexString)(codePoint));
    }
    return new Uint8Array(encoded);
};
var $4755002ef894fc8a$export$73704d2337848c8e = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    var encoded = [];
    if (byteOrderMark) encoded.push(0xfeff);
    for(var idx = 0, len = input.length; idx < len;){
        var codePoint = input.codePointAt(idx);
        // Two byte encoding
        if (codePoint < 0x010000) {
            encoded.push(codePoint);
            idx += 1;
        } else if (codePoint < 0x110000) {
            encoded.push($4755002ef894fc8a$export$8d3bd4086f36eaeb(codePoint), $4755002ef894fc8a$export$382051c72943492d(codePoint));
            idx += 2;
        } else throw new Error("Invalid code point: 0x" + (0, $8hWZH.toHexString)(codePoint));
    }
    return new Uint16Array(encoded);
};
var $4755002ef894fc8a$export$919ae47c3852aa15 = function(codePoint) {
    return codePoint >= 0 && codePoint <= 0xffff;
};
var $4755002ef894fc8a$export$d5ab89e7561b44ab = function(codePoint) {
    return codePoint >= 0x010000 && codePoint <= 0x10ffff;
};
var $4755002ef894fc8a$export$8d3bd4086f36eaeb = function(codePoint) {
    return Math.floor((codePoint - 0x10000) / 0x400) + 0xd800;
};
var $4755002ef894fc8a$export$382051c72943492d = function(codePoint) {
    return (codePoint - 0x10000) % 0x400 + 0xdc00;
};
var $4755002ef894fc8a$var$ByteOrder;
(function(ByteOrder) {
    ByteOrder["BigEndian"] = "BigEndian";
    ByteOrder["LittleEndian"] = "LittleEndian";
})($4755002ef894fc8a$var$ByteOrder || ($4755002ef894fc8a$var$ByteOrder = {}));
var $4755002ef894fc8a$var$REPLACEMENT = "\uFFFD".codePointAt(0);
var $4755002ef894fc8a$export$b89f54f9db637f79 = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    // Need at least 2 bytes of data in UTF-16 encodings
    if (input.length <= 1) return String.fromCodePoint($4755002ef894fc8a$var$REPLACEMENT);
    var byteOrder = byteOrderMark ? $4755002ef894fc8a$var$readBOM(input) : $4755002ef894fc8a$var$ByteOrder.BigEndian;
    // Skip byte order mark if needed
    var idx = byteOrderMark ? 2 : 0;
    var codePoints = [];
    while(input.length - idx >= 2){
        var first = $4755002ef894fc8a$var$decodeValues(input[idx++], input[idx++], byteOrder);
        if ($4755002ef894fc8a$var$isHighSurrogate(first)) {
            if (input.length - idx < 2) // Need at least 2 bytes left for the low surrogate that is required
            codePoints.push($4755002ef894fc8a$var$REPLACEMENT);
            else {
                var second = $4755002ef894fc8a$var$decodeValues(input[idx++], input[idx++], byteOrder);
                if ($4755002ef894fc8a$var$isLowSurrogate(second)) codePoints.push(first, second);
                else // Low surrogates should always follow high surrogates
                codePoints.push($4755002ef894fc8a$var$REPLACEMENT);
            }
        } else if ($4755002ef894fc8a$var$isLowSurrogate(first)) {
            // High surrogates should always come first since `decodeValues()`
            // accounts for the byte ordering
            idx += 2;
            codePoints.push($4755002ef894fc8a$var$REPLACEMENT);
        } else codePoints.push(first);
    }
    // There shouldn't be extra byte(s) left over
    if (idx < input.length) codePoints.push($4755002ef894fc8a$var$REPLACEMENT);
    return String.fromCodePoint.apply(String, codePoints);
};
/**
 * Returns `true` if the given `codePoint` is a high surrogate.
 * @param codePoint The code point to be evaluated.
 *
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Description
 */ var $4755002ef894fc8a$var$isHighSurrogate = function(codePoint) {
    return codePoint >= 0xd800 && codePoint <= 0xdbff;
};
/**
 * Returns `true` if the given `codePoint` is a low surrogate.
 * @param codePoint The code point to be evaluated.
 *
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Description
 */ var $4755002ef894fc8a$var$isLowSurrogate = function(codePoint) {
    return codePoint >= 0xdc00 && codePoint <= 0xdfff;
};
/**
 * Decodes the given utf-16 values first and second using the specified
 * byte order.
 * @param first The first byte of the encoding.
 * @param second The second byte of the encoding.
 * @param byteOrder The byte order of the encoding.
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Examples
 */ var $4755002ef894fc8a$var$decodeValues = function(first, second, byteOrder) {
    // Append the binary representation of the preceding byte by shifting the
    // first one 8 to the left and than applying a bitwise or-operator to append
    // the second one.
    if (byteOrder === $4755002ef894fc8a$var$ByteOrder.LittleEndian) return second << 8 | first;
    if (byteOrder === $4755002ef894fc8a$var$ByteOrder.BigEndian) return first << 8 | second;
    throw new Error("Invalid byteOrder: " + byteOrder);
};
/**
 * Returns whether the given array contains a byte order mark for the
 * UTF-16BE or UTF-16LE encoding. If it has neither, BigEndian is assumed.
 *
 * Reference: https://en.wikipedia.org/wiki/Byte_order_mark#UTF-16
 *
 * @param bytes The byte array to be evaluated.
 */ // prettier-ignore
var $4755002ef894fc8a$var$readBOM = function(bytes) {
    return $4755002ef894fc8a$var$hasUtf16BigEndianBOM(bytes) ? $4755002ef894fc8a$var$ByteOrder.BigEndian : $4755002ef894fc8a$var$hasUtf16LittleEndianBOM(bytes) ? $4755002ef894fc8a$var$ByteOrder.LittleEndian : $4755002ef894fc8a$var$ByteOrder.BigEndian;
};
var $4755002ef894fc8a$var$hasUtf16BigEndianBOM = function(bytes) {
    return bytes[0] === 0xfe && bytes[1] === 0xff;
};
var $4755002ef894fc8a$var$hasUtf16LittleEndianBOM = function(bytes) {
    return bytes[0] === 0xff && bytes[1] === 0xfe;
};
var $4755002ef894fc8a$export$41e7c15c75b1b24d = function(bytes) {
    return $4755002ef894fc8a$var$hasUtf16BigEndianBOM(bytes) || $4755002ef894fc8a$var$hasUtf16LittleEndianBOM(bytes);
};

});

parcelRegister("lAEMS", function(module, exports) {

$parcel$export(module.exports, "numberToString", function () { return $fb7c9949627067fd$export$f67be9d9b0e25d7b; });
$parcel$export(module.exports, "sizeInBytes", function () { return $fb7c9949627067fd$export$cc6acfd7a782614d; });
$parcel$export(module.exports, "bytesFor", function () { return $fb7c9949627067fd$export$3c7962b7d5fa4e42; });
// tslint:disable radix
/**
 * Converts a number to its string representation in decimal. This function
 * differs from simply converting a number to a string with `.toString()`
 * because this function's output string will **not** contain exponential
 * notation.
 *
 * Credit: https://stackoverflow.com/a/46545519
 */ var $fb7c9949627067fd$export$f67be9d9b0e25d7b = function(num) {
    var numStr = String(num);
    if (Math.abs(num) < 1.0) {
        var e = parseInt(num.toString().split('e-')[1]);
        if (e) {
            var negative = num < 0;
            if (negative) num *= -1;
            num *= Math.pow(10, e - 1);
            numStr = '0.' + new Array(e).join('0') + num.toString().substring(2);
            if (negative) numStr = '-' + numStr;
        }
    } else {
        var e = parseInt(num.toString().split('+')[1]);
        if (e > 20) {
            e -= 20;
            num /= Math.pow(10, e);
            numStr = num.toString() + new Array(e + 1).join('0');
        }
    }
    return numStr;
};
var $fb7c9949627067fd$export$cc6acfd7a782614d = function(n) {
    return Math.ceil(n.toString(2).length / 8);
};
var $fb7c9949627067fd$export$3c7962b7d5fa4e42 = function(n) {
    var bytes = new Uint8Array($fb7c9949627067fd$export$cc6acfd7a782614d(n));
    for(var i = 1; i <= bytes.length; i++)bytes[i - 1] = n >> (bytes.length - i) * 8;
    return bytes;
};

});

parcelRegister("kug8p", function(module, exports) {

$parcel$export(module.exports, "error", function () { return $eea31ffe19541f16$export$a3bc9b8ed74fc; });
var $eea31ffe19541f16$export$a3bc9b8ed74fc = function(msg) {
    throw new Error(msg);
};

});

parcelRegister("lxE62", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $faebc852fedc380b$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "isStandardFont", function () { return $faebc852fedc380b$export$f2950432a4491977; });
$parcel$export(module.exports, "rectanglesAreEqual", function () { return $faebc852fedc380b$export$93263d7e9f52c023; });
parcelRequire("X7kVn");
var $bv6ba = parcelRequire("bv6ba");
var $faebc852fedc380b$export$68c286be0e7e55b7 = function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $faebc852fedc380b$export$59252e21bbb61725 = $faebc852fedc380b$export$68c286be0e7e55b7((0, $bv6ba.FontNames));
var $faebc852fedc380b$export$f2950432a4491977 = function(input) {
    return $faebc852fedc380b$export$59252e21bbb61725.includes(input);
};
var $faebc852fedc380b$export$93263d7e9f52c023 = function(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
};

});
parcelRegister("X7kVn", function(module, exports) {
$parcel$export(module.exports, "Font", function () { return (parcelRequire("bv6ba")).Font; });
$parcel$export(module.exports, "FontNames", function () { return (parcelRequire("bv6ba")).FontNames; });
$parcel$export(module.exports, "Encodings", function () { return (parcelRequire("kErbs")).Encodings; });
parcelRequire("bv6ba");
parcelRequire("kErbs");

});
parcelRegister("bv6ba", function(module, exports) {

$parcel$export(module.exports, "FontNames", function () { return $85f7620529655dd4$export$a1e7b970f5a14844; });
$parcel$export(module.exports, "Font", function () { return $85f7620529655dd4$export$89abf52a030e56ee; });

var $gLKUe = parcelRequire("gLKUe");

var $hRNK7 = parcelRequire("hRNK7");

var $dg1HZ = parcelRequire("dg1HZ");

var $fiOEo = parcelRequire("fiOEo");

var $6vTMX = parcelRequire("6vTMX");

var $3QLDc = parcelRequire("3QLDc");

var $1JYAJ = parcelRequire("1JYAJ");

var $4Fxf2 = parcelRequire("4Fxf2");

var $c2mly = parcelRequire("c2mly");

var $57yAe = parcelRequire("57yAe");

var $hz5ax = parcelRequire("hz5ax");

var $k3qSE = parcelRequire("k3qSE");

var $6BRZ8 = parcelRequire("6BRZ8");

var $2f8qy = parcelRequire("2f8qy");

var $fReCA = parcelRequire("fReCA");
// prettier-ignore
var $85f7620529655dd4$var$compressedJsonForFontName = {
    'Courier': (0, (/*@__PURE__*/$parcel$interopDefault($6vTMX))),
    'Courier-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($hRNK7))),
    'Courier-Oblique': (0, (/*@__PURE__*/$parcel$interopDefault($fiOEo))),
    'Courier-BoldOblique': (0, (/*@__PURE__*/$parcel$interopDefault($dg1HZ))),
    'Helvetica': (0, (/*@__PURE__*/$parcel$interopDefault($c2mly))),
    'Helvetica-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($3QLDc))),
    'Helvetica-Oblique': (0, (/*@__PURE__*/$parcel$interopDefault($4Fxf2))),
    'Helvetica-BoldOblique': (0, (/*@__PURE__*/$parcel$interopDefault($1JYAJ))),
    'Times-Roman': (0, (/*@__PURE__*/$parcel$interopDefault($6BRZ8))),
    'Times-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($57yAe))),
    'Times-Italic': (0, (/*@__PURE__*/$parcel$interopDefault($k3qSE))),
    'Times-BoldItalic': (0, (/*@__PURE__*/$parcel$interopDefault($hz5ax))),
    'Symbol': (0, (/*@__PURE__*/$parcel$interopDefault($2f8qy))),
    'ZapfDingbats': (0, (/*@__PURE__*/$parcel$interopDefault($fReCA)))
};
var $85f7620529655dd4$export$a1e7b970f5a14844;
(function(FontNames) {
    FontNames["Courier"] = "Courier";
    FontNames["CourierBold"] = "Courier-Bold";
    FontNames["CourierOblique"] = "Courier-Oblique";
    FontNames["CourierBoldOblique"] = "Courier-BoldOblique";
    FontNames["Helvetica"] = "Helvetica";
    FontNames["HelveticaBold"] = "Helvetica-Bold";
    FontNames["HelveticaOblique"] = "Helvetica-Oblique";
    FontNames["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    FontNames["TimesRoman"] = "Times-Roman";
    FontNames["TimesRomanBold"] = "Times-Bold";
    FontNames["TimesRomanItalic"] = "Times-Italic";
    FontNames["TimesRomanBoldItalic"] = "Times-BoldItalic";
    FontNames["Symbol"] = "Symbol";
    FontNames["ZapfDingbats"] = "ZapfDingbats";
})($85f7620529655dd4$export$a1e7b970f5a14844 || ($85f7620529655dd4$export$a1e7b970f5a14844 = {}));
var $85f7620529655dd4$var$fontCache = {};
var $85f7620529655dd4$export$89abf52a030e56ee = /** @class */ function() {
    function Font() {
        var _this = this;
        this.getWidthOfGlyph = function(glyphName) {
            return _this.CharWidths[glyphName];
        };
        this.getXAxisKerningForPair = function(leftGlyphName, rightGlyphName) {
            return (_this.KernPairXAmounts[leftGlyphName] || {})[rightGlyphName];
        };
    }
    Font.load = function(fontName) {
        var cachedFont = $85f7620529655dd4$var$fontCache[fontName];
        if (cachedFont) return cachedFont;
        var json = (0, $gLKUe.decompressJson)($85f7620529655dd4$var$compressedJsonForFontName[fontName]);
        var font = Object.assign(new Font(), JSON.parse(json));
        font.CharWidths = font.CharMetrics.reduce(function(acc, metric) {
            acc[metric.N] = metric.WX;
            return acc;
        }, {});
        font.KernPairXAmounts = font.KernPairs.reduce(function(acc, _a) {
            var name1 = _a[0], name2 = _a[1], width = _a[2];
            if (!acc[name1]) acc[name1] = {};
            acc[name1][name2] = width;
            return acc;
        }, {});
        $85f7620529655dd4$var$fontCache[fontName] = font;
        return font;
    };
    return Font;
}();

});
parcelRegister("gLKUe", function(module, exports) {

$parcel$export(module.exports, "decompressJson", function () { return $c3556bac4de0efaf$export$134b8d792d6efd14; });
$parcel$export(module.exports, "padStart", function () { return $c3556bac4de0efaf$export$36cf564d487b5178; });
/*
 * The `chars`, `lookup`, and `decodeFromBase64` members of this file are
 * licensed under the following:
 *
 *     base64-arraybuffer
 *     https://github.com/niklasvh/base64-arraybuffer
 *
 *     Copyright (c) 2012 Niklas von Hertzen
 *     Licensed under the MIT license.
 *
 */ 
var $299jN = parcelRequire("299jN");
var $c3556bac4de0efaf$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $c3556bac4de0efaf$var$lookup = new Uint8Array(256);
for(var $c3556bac4de0efaf$var$i = 0; $c3556bac4de0efaf$var$i < $c3556bac4de0efaf$var$chars.length; $c3556bac4de0efaf$var$i++)$c3556bac4de0efaf$var$lookup[$c3556bac4de0efaf$var$chars.charCodeAt($c3556bac4de0efaf$var$i)] = $c3556bac4de0efaf$var$i;
var $c3556bac4de0efaf$export$83edfd8fcc66ec17 = function(base64) {
    var bufferLength = base64.length * 0.75;
    var len = base64.length;
    var i;
    var p = 0;
    var encoded1;
    var encoded2;
    var encoded3;
    var encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    var bytes = new Uint8Array(bufferLength);
    for(i = 0; i < len; i += 4){
        encoded1 = $c3556bac4de0efaf$var$lookup[base64.charCodeAt(i)];
        encoded2 = $c3556bac4de0efaf$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $c3556bac4de0efaf$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $c3556bac4de0efaf$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
};
var $c3556bac4de0efaf$var$arrayToString = function(array) {
    var str = '';
    for(var i = 0; i < array.length; i++)str += String.fromCharCode(array[i]);
    return str;
};
var $c3556bac4de0efaf$export$134b8d792d6efd14 = function(compressedJson) {
    return $c3556bac4de0efaf$var$arrayToString((0, (/*@__PURE__*/$parcel$interopDefault($299jN))).inflate($c3556bac4de0efaf$export$83edfd8fcc66ec17(compressedJson)));
};
var $c3556bac4de0efaf$export$36cf564d487b5178 = function(value, length, padChar) {
    var padding = '';
    for(var idx = 0, len = length - value.length; idx < len; idx++)padding += padChar;
    return padding + value;
};

});
parcelRegister("299jN", function(module, exports) {
// Top level file is just a mixin of submodules & constants
'use strict';

var $ex3eo = parcelRequire("ex3eo");
var $1903a6779c29f053$require$assign = $ex3eo.assign;

var $5IIGZ = parcelRequire("5IIGZ");

var $1jzAe = parcelRequire("1jzAe");

var $gOJnx = parcelRequire("gOJnx");
var $1903a6779c29f053$var$pako = {};
$1903a6779c29f053$require$assign($1903a6779c29f053$var$pako, $5IIGZ, $1jzAe, $gOJnx);
module.exports = $1903a6779c29f053$var$pako;

});
parcelRegister("ex3eo", function(module, exports) {
'use strict';
var $a946a76361339ebc$var$TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
function $a946a76361339ebc$var$_has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
module.exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(var p in source)if ($a946a76361339ebc$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
module.exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var $a946a76361339ebc$var$fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var $a946a76361339ebc$var$fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
module.exports.setTyped = function(on) {
    if (on) {
        module.exports.Buf8 = Uint8Array;
        module.exports.Buf16 = Uint16Array;
        module.exports.Buf32 = Int32Array;
        module.exports.assign(module.exports, $a946a76361339ebc$var$fnTyped);
    } else {
        module.exports.Buf8 = Array;
        module.exports.Buf16 = Array;
        module.exports.Buf32 = Array;
        module.exports.assign(module.exports, $a946a76361339ebc$var$fnUntyped);
    }
};
module.exports.setTyped($a946a76361339ebc$var$TYPED_OK);

});

parcelRegister("5IIGZ", function(module, exports) {

$parcel$export(module.exports, "Deflate", function () { return $42a3bac6e98a5936$export$ae157b6234afe138; }, function (v) { return $42a3bac6e98a5936$export$ae157b6234afe138 = v; });
$parcel$export(module.exports, "deflate", function () { return $42a3bac6e98a5936$export$2316623ecd1285ab; }, function (v) { return $42a3bac6e98a5936$export$2316623ecd1285ab = v; });
$parcel$export(module.exports, "deflateRaw", function () { return $42a3bac6e98a5936$export$e95d6a8f69fb340a; }, function (v) { return $42a3bac6e98a5936$export$e95d6a8f69fb340a = v; });
$parcel$export(module.exports, "gzip", function () { return $42a3bac6e98a5936$export$69f0ea7cf3a331a8; }, function (v) { return $42a3bac6e98a5936$export$69f0ea7cf3a331a8 = v; });
var $42a3bac6e98a5936$export$ae157b6234afe138;
var $42a3bac6e98a5936$export$2316623ecd1285ab;
var $42a3bac6e98a5936$export$e95d6a8f69fb340a;
var $42a3bac6e98a5936$export$69f0ea7cf3a331a8;
'use strict';

var $7lEfg = parcelRequire("7lEfg");

var $ex3eo = parcelRequire("ex3eo");

var $5XqLJ = parcelRequire("5XqLJ");

var $9shtE = parcelRequire("9shtE");

var $iGnPn = parcelRequire("iGnPn");
var $42a3bac6e98a5936$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $42a3bac6e98a5936$var$Z_NO_FLUSH = 0;
var $42a3bac6e98a5936$var$Z_FINISH = 4;
var $42a3bac6e98a5936$var$Z_OK = 0;
var $42a3bac6e98a5936$var$Z_STREAM_END = 1;
var $42a3bac6e98a5936$var$Z_SYNC_FLUSH = 2;
var $42a3bac6e98a5936$var$Z_DEFAULT_COMPRESSION = -1;
var $42a3bac6e98a5936$var$Z_DEFAULT_STRATEGY = 0;
var $42a3bac6e98a5936$var$Z_DEFLATED = 8;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $42a3bac6e98a5936$var$Deflate(options) {
    if (!(this instanceof $42a3bac6e98a5936$var$Deflate)) return new $42a3bac6e98a5936$var$Deflate(options);
    this.options = $ex3eo.assign({
        level: $42a3bac6e98a5936$var$Z_DEFAULT_COMPRESSION,
        method: $42a3bac6e98a5936$var$Z_DEFLATED,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $42a3bac6e98a5936$var$Z_DEFAULT_STRATEGY,
        to: ''
    }, options || {});
    var opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $iGnPn();
    this.strm.avail_out = 0;
    var status = $7lEfg.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $42a3bac6e98a5936$var$Z_OK) throw new Error($9shtE[status]);
    if (opt.header) $7lEfg.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        var dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
        dict = $5XqLJ.string2buf(opt.dictionary);
        else if ($42a3bac6e98a5936$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $7lEfg.deflateSetDictionary(this.strm, dict);
        if (status !== $42a3bac6e98a5936$var$Z_OK) throw new Error($9shtE[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $42a3bac6e98a5936$var$Deflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var status, _mode;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $42a3bac6e98a5936$var$Z_FINISH : $42a3bac6e98a5936$var$Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
    strm.input = $5XqLJ.string2buf(data);
    else if ($42a3bac6e98a5936$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $ex3eo.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $7lEfg.deflate(strm, _mode); /* no bad return value */ 
        if (status !== $42a3bac6e98a5936$var$Z_STREAM_END && status !== $42a3bac6e98a5936$var$Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === $42a3bac6e98a5936$var$Z_FINISH || _mode === $42a3bac6e98a5936$var$Z_SYNC_FLUSH)) {
            if (this.options.to === 'string') this.onData($5XqLJ.buf2binstring($ex3eo.shrinkBuf(strm.output, strm.next_out)));
            else this.onData($ex3eo.shrinkBuf(strm.output, strm.next_out));
        }
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $42a3bac6e98a5936$var$Z_STREAM_END);
    // Finalize on the last chunk.
    if (_mode === $42a3bac6e98a5936$var$Z_FINISH) {
        status = $7lEfg.deflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $42a3bac6e98a5936$var$Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $42a3bac6e98a5936$var$Z_SYNC_FLUSH) {
        this.onEnd($42a3bac6e98a5936$var$Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $42a3bac6e98a5936$var$Deflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $42a3bac6e98a5936$var$Deflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $42a3bac6e98a5936$var$Z_OK) {
        if (this.options.to === 'string') this.result = this.chunks.join('');
        else this.result = $ex3eo.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $42a3bac6e98a5936$var$deflate(input, options) {
    var deflator = new $42a3bac6e98a5936$var$Deflate(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $9shtE[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $42a3bac6e98a5936$var$deflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $42a3bac6e98a5936$var$deflate(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $42a3bac6e98a5936$var$gzip(input, options) {
    options = options || {};
    options.gzip = true;
    return $42a3bac6e98a5936$var$deflate(input, options);
}
$42a3bac6e98a5936$export$ae157b6234afe138 = $42a3bac6e98a5936$var$Deflate;
$42a3bac6e98a5936$export$2316623ecd1285ab = $42a3bac6e98a5936$var$deflate;
$42a3bac6e98a5936$export$e95d6a8f69fb340a = $42a3bac6e98a5936$var$deflateRaw;
$42a3bac6e98a5936$export$69f0ea7cf3a331a8 = $42a3bac6e98a5936$var$gzip;

});
parcelRegister("7lEfg", function(module, exports) {

$parcel$export(module.exports, "deflateInit2", function () { return $5599b666b2efdd0d$export$a65c7b2bde87cb70; }, function (v) { return $5599b666b2efdd0d$export$a65c7b2bde87cb70 = v; });
$parcel$export(module.exports, "deflateSetHeader", function () { return $5599b666b2efdd0d$export$1cd50f7b2515ba19; }, function (v) { return $5599b666b2efdd0d$export$1cd50f7b2515ba19 = v; });
$parcel$export(module.exports, "deflate", function () { return $5599b666b2efdd0d$export$2316623ecd1285ab; }, function (v) { return $5599b666b2efdd0d$export$2316623ecd1285ab = v; });
$parcel$export(module.exports, "deflateEnd", function () { return $5599b666b2efdd0d$export$599854fa319a815f; }, function (v) { return $5599b666b2efdd0d$export$599854fa319a815f = v; });
$parcel$export(module.exports, "deflateSetDictionary", function () { return $5599b666b2efdd0d$export$f55e0b3ab66b5d46; }, function (v) { return $5599b666b2efdd0d$export$f55e0b3ab66b5d46 = v; });
var $5599b666b2efdd0d$export$72b35d618fb8ad9b;
var $5599b666b2efdd0d$export$a65c7b2bde87cb70;
var $5599b666b2efdd0d$export$8f99f0e30bc7dd53;
var $5599b666b2efdd0d$export$e78fab288549509;
var $5599b666b2efdd0d$export$1cd50f7b2515ba19;
var $5599b666b2efdd0d$export$2316623ecd1285ab;
var $5599b666b2efdd0d$export$599854fa319a815f;
var $5599b666b2efdd0d$export$f55e0b3ab66b5d46;
var $5599b666b2efdd0d$export$12b6e1fcadea22f9;
'use strict';

var $ex3eo = parcelRequire("ex3eo");

var $5jTNs = parcelRequire("5jTNs");

var $13N4W = parcelRequire("13N4W");

var $55lL1 = parcelRequire("55lL1");

var $9shtE = parcelRequire("9shtE");
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $5599b666b2efdd0d$var$Z_NO_FLUSH = 0;
var $5599b666b2efdd0d$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $5599b666b2efdd0d$var$Z_FULL_FLUSH = 3;
var $5599b666b2efdd0d$var$Z_FINISH = 4;
var $5599b666b2efdd0d$var$Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $5599b666b2efdd0d$var$Z_OK = 0;
var $5599b666b2efdd0d$var$Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $5599b666b2efdd0d$var$Z_STREAM_ERROR = -2;
var $5599b666b2efdd0d$var$Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var $5599b666b2efdd0d$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $5599b666b2efdd0d$var$Z_DEFAULT_COMPRESSION = -1;
var $5599b666b2efdd0d$var$Z_FILTERED = 1;
var $5599b666b2efdd0d$var$Z_HUFFMAN_ONLY = 2;
var $5599b666b2efdd0d$var$Z_RLE = 3;
var $5599b666b2efdd0d$var$Z_FIXED = 4;
var $5599b666b2efdd0d$var$Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $5599b666b2efdd0d$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $5599b666b2efdd0d$var$Z_DEFLATED = 8;
/*============================================================================*/ var $5599b666b2efdd0d$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $5599b666b2efdd0d$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $5599b666b2efdd0d$var$DEF_MEM_LEVEL = 8;
var $5599b666b2efdd0d$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $5599b666b2efdd0d$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $5599b666b2efdd0d$var$L_CODES = $5599b666b2efdd0d$var$LITERALS + 1 + $5599b666b2efdd0d$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $5599b666b2efdd0d$var$D_CODES = 30;
/* number of distance codes */ var $5599b666b2efdd0d$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $5599b666b2efdd0d$var$HEAP_SIZE = 2 * $5599b666b2efdd0d$var$L_CODES + 1;
/* maximum heap size */ var $5599b666b2efdd0d$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $5599b666b2efdd0d$var$MIN_MATCH = 3;
var $5599b666b2efdd0d$var$MAX_MATCH = 258;
var $5599b666b2efdd0d$var$MIN_LOOKAHEAD = $5599b666b2efdd0d$var$MAX_MATCH + $5599b666b2efdd0d$var$MIN_MATCH + 1;
var $5599b666b2efdd0d$var$PRESET_DICT = 0x20;
var $5599b666b2efdd0d$var$INIT_STATE = 42;
var $5599b666b2efdd0d$var$EXTRA_STATE = 69;
var $5599b666b2efdd0d$var$NAME_STATE = 73;
var $5599b666b2efdd0d$var$COMMENT_STATE = 91;
var $5599b666b2efdd0d$var$HCRC_STATE = 103;
var $5599b666b2efdd0d$var$BUSY_STATE = 113;
var $5599b666b2efdd0d$var$FINISH_STATE = 666;
var $5599b666b2efdd0d$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $5599b666b2efdd0d$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $5599b666b2efdd0d$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $5599b666b2efdd0d$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $5599b666b2efdd0d$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $5599b666b2efdd0d$var$err(strm, errorCode) {
    strm.msg = $9shtE[errorCode];
    return errorCode;
}
function $5599b666b2efdd0d$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $5599b666b2efdd0d$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $5599b666b2efdd0d$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $ex3eo.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $5599b666b2efdd0d$var$flush_block_only(s, last) {
    $5jTNs._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $5599b666b2efdd0d$var$flush_pending(s.strm);
}
function $5599b666b2efdd0d$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $5599b666b2efdd0d$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $5599b666b2efdd0d$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $ex3eo.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $13N4W(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $55lL1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $5599b666b2efdd0d$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $5599b666b2efdd0d$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $5599b666b2efdd0d$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $5599b666b2efdd0d$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $5599b666b2efdd0d$var$MAX_MATCH - (strend - scan);
        scan = strend - $5599b666b2efdd0d$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $5599b666b2efdd0d$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $5599b666b2efdd0d$var$MIN_LOOKAHEAD)) {
            $ex3eo.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $5599b666b2efdd0d$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $5599b666b2efdd0d$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $5599b666b2efdd0d$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $5599b666b2efdd0d$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $5599b666b2efdd0d$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $5599b666b2efdd0d$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $5599b666b2efdd0d$var$fill_window(s);
            if (s.lookahead === 0 && flush === $5599b666b2efdd0d$var$Z_NO_FLUSH) return $5599b666b2efdd0d$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $5599b666b2efdd0d$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $5599b666b2efdd0d$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $5599b666b2efdd0d$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $5599b666b2efdd0d$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $5599b666b2efdd0d$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $5599b666b2efdd0d$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $5599b666b2efdd0d$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $5599b666b2efdd0d$var$BS_FINISH_STARTED;
        /***/ return $5599b666b2efdd0d$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $5599b666b2efdd0d$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $5599b666b2efdd0d$var$BS_NEED_MORE;
    /***/ }
    return $5599b666b2efdd0d$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $5599b666b2efdd0d$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $5599b666b2efdd0d$var$MIN_LOOKAHEAD) {
            $5599b666b2efdd0d$var$fill_window(s);
            if (s.lookahead < $5599b666b2efdd0d$var$MIN_LOOKAHEAD && flush === $5599b666b2efdd0d$var$Z_NO_FLUSH) return $5599b666b2efdd0d$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $5599b666b2efdd0d$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $5599b666b2efdd0d$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $5599b666b2efdd0d$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $5599b666b2efdd0d$var$longest_match(s, hash_head);
        if (s.match_length >= $5599b666b2efdd0d$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $5jTNs._tr_tally(s, s.strstart - s.match_start, s.match_length - $5599b666b2efdd0d$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $5599b666b2efdd0d$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $5599b666b2efdd0d$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $5jTNs._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $5599b666b2efdd0d$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $5599b666b2efdd0d$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $5599b666b2efdd0d$var$MIN_MATCH - 1 ? s.strstart : $5599b666b2efdd0d$var$MIN_MATCH - 1;
    if (flush === $5599b666b2efdd0d$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $5599b666b2efdd0d$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $5599b666b2efdd0d$var$BS_FINISH_STARTED;
        /***/ return $5599b666b2efdd0d$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $5599b666b2efdd0d$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $5599b666b2efdd0d$var$BS_NEED_MORE;
    /***/ }
    return $5599b666b2efdd0d$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $5599b666b2efdd0d$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $5599b666b2efdd0d$var$MIN_LOOKAHEAD) {
            $5599b666b2efdd0d$var$fill_window(s);
            if (s.lookahead < $5599b666b2efdd0d$var$MIN_LOOKAHEAD && flush === $5599b666b2efdd0d$var$Z_NO_FLUSH) return $5599b666b2efdd0d$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $5599b666b2efdd0d$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $5599b666b2efdd0d$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $5599b666b2efdd0d$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $5599b666b2efdd0d$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $5599b666b2efdd0d$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $5599b666b2efdd0d$var$Z_FILTERED || s.match_length === $5599b666b2efdd0d$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $5599b666b2efdd0d$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $5599b666b2efdd0d$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $5599b666b2efdd0d$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $5jTNs._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $5599b666b2efdd0d$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $5599b666b2efdd0d$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $5599b666b2efdd0d$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $5599b666b2efdd0d$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $5599b666b2efdd0d$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $5jTNs._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $5599b666b2efdd0d$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $5599b666b2efdd0d$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $5jTNs._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $5599b666b2efdd0d$var$MIN_MATCH - 1 ? s.strstart : $5599b666b2efdd0d$var$MIN_MATCH - 1;
    if (flush === $5599b666b2efdd0d$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $5599b666b2efdd0d$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $5599b666b2efdd0d$var$BS_FINISH_STARTED;
        /***/ return $5599b666b2efdd0d$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $5599b666b2efdd0d$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $5599b666b2efdd0d$var$BS_NEED_MORE;
    /***/ }
    return $5599b666b2efdd0d$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $5599b666b2efdd0d$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $5599b666b2efdd0d$var$MAX_MATCH) {
            $5599b666b2efdd0d$var$fill_window(s);
            if (s.lookahead <= $5599b666b2efdd0d$var$MAX_MATCH && flush === $5599b666b2efdd0d$var$Z_NO_FLUSH) return $5599b666b2efdd0d$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $5599b666b2efdd0d$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $5599b666b2efdd0d$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $5599b666b2efdd0d$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $5599b666b2efdd0d$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $5jTNs._tr_tally(s, 1, s.match_length - $5599b666b2efdd0d$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $5jTNs._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $5599b666b2efdd0d$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $5599b666b2efdd0d$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $5599b666b2efdd0d$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $5599b666b2efdd0d$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $5599b666b2efdd0d$var$BS_FINISH_STARTED;
        /***/ return $5599b666b2efdd0d$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $5599b666b2efdd0d$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $5599b666b2efdd0d$var$BS_NEED_MORE;
    /***/ }
    return $5599b666b2efdd0d$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $5599b666b2efdd0d$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $5599b666b2efdd0d$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $5599b666b2efdd0d$var$Z_NO_FLUSH) return $5599b666b2efdd0d$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $5jTNs._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $5599b666b2efdd0d$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $5599b666b2efdd0d$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $5599b666b2efdd0d$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $5599b666b2efdd0d$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $5599b666b2efdd0d$var$BS_FINISH_STARTED;
        /***/ return $5599b666b2efdd0d$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $5599b666b2efdd0d$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $5599b666b2efdd0d$var$BS_NEED_MORE;
    /***/ }
    return $5599b666b2efdd0d$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $5599b666b2efdd0d$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $5599b666b2efdd0d$var$configuration_table;
$5599b666b2efdd0d$var$configuration_table = [
    /*      good lazy nice chain */ new $5599b666b2efdd0d$var$Config(0, 0, 0, 0, $5599b666b2efdd0d$var$deflate_stored),
    /* 0 store only */ new $5599b666b2efdd0d$var$Config(4, 4, 8, 4, $5599b666b2efdd0d$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $5599b666b2efdd0d$var$Config(4, 5, 16, 8, $5599b666b2efdd0d$var$deflate_fast),
    /* 2 */ new $5599b666b2efdd0d$var$Config(4, 6, 32, 32, $5599b666b2efdd0d$var$deflate_fast),
    /* 3 */ new $5599b666b2efdd0d$var$Config(4, 4, 16, 16, $5599b666b2efdd0d$var$deflate_slow),
    /* 4 lazy matches */ new $5599b666b2efdd0d$var$Config(8, 16, 32, 32, $5599b666b2efdd0d$var$deflate_slow),
    /* 5 */ new $5599b666b2efdd0d$var$Config(8, 16, 128, 128, $5599b666b2efdd0d$var$deflate_slow),
    /* 6 */ new $5599b666b2efdd0d$var$Config(8, 32, 128, 256, $5599b666b2efdd0d$var$deflate_slow),
    /* 7 */ new $5599b666b2efdd0d$var$Config(32, 128, 258, 1024, $5599b666b2efdd0d$var$deflate_slow),
    /* 8 */ new $5599b666b2efdd0d$var$Config(32, 258, 258, 4096, $5599b666b2efdd0d$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $5599b666b2efdd0d$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $5599b666b2efdd0d$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $5599b666b2efdd0d$var$configuration_table[s.level].max_lazy;
    s.good_match = $5599b666b2efdd0d$var$configuration_table[s.level].good_length;
    s.nice_match = $5599b666b2efdd0d$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $5599b666b2efdd0d$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $5599b666b2efdd0d$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $5599b666b2efdd0d$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $5599b666b2efdd0d$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $ex3eo.Buf16($5599b666b2efdd0d$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $ex3eo.Buf16((2 * $5599b666b2efdd0d$var$D_CODES + 1) * 2);
    this.bl_tree = new $ex3eo.Buf16((2 * $5599b666b2efdd0d$var$BL_CODES + 1) * 2);
    $5599b666b2efdd0d$var$zero(this.dyn_ltree);
    $5599b666b2efdd0d$var$zero(this.dyn_dtree);
    $5599b666b2efdd0d$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $ex3eo.Buf16($5599b666b2efdd0d$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $ex3eo.Buf16(2 * $5599b666b2efdd0d$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $5599b666b2efdd0d$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $ex3eo.Buf16(2 * $5599b666b2efdd0d$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $5599b666b2efdd0d$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $5599b666b2efdd0d$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $5599b666b2efdd0d$var$err(strm, $5599b666b2efdd0d$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $5599b666b2efdd0d$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $5599b666b2efdd0d$var$INIT_STATE : $5599b666b2efdd0d$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $5599b666b2efdd0d$var$Z_NO_FLUSH;
    $5jTNs._tr_init(s);
    return $5599b666b2efdd0d$var$Z_OK;
}
function $5599b666b2efdd0d$var$deflateReset(strm) {
    var ret = $5599b666b2efdd0d$var$deflateResetKeep(strm);
    if (ret === $5599b666b2efdd0d$var$Z_OK) $5599b666b2efdd0d$var$lm_init(strm.state);
    return ret;
}
function $5599b666b2efdd0d$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $5599b666b2efdd0d$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $5599b666b2efdd0d$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $5599b666b2efdd0d$var$Z_OK;
}
function $5599b666b2efdd0d$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $5599b666b2efdd0d$var$Z_STREAM_ERROR;
    var wrap = 1;
    if (level === $5599b666b2efdd0d$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $5599b666b2efdd0d$var$MAX_MEM_LEVEL || method !== $5599b666b2efdd0d$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $5599b666b2efdd0d$var$Z_FIXED) return $5599b666b2efdd0d$var$err(strm, $5599b666b2efdd0d$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $5599b666b2efdd0d$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $5599b666b2efdd0d$var$MIN_MATCH - 1) / $5599b666b2efdd0d$var$MIN_MATCH);
    s.window = new $ex3eo.Buf8(s.w_size * 2);
    s.head = new $ex3eo.Buf16(s.hash_size);
    s.prev = new $ex3eo.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $ex3eo.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $5599b666b2efdd0d$var$deflateReset(strm);
}
function $5599b666b2efdd0d$var$deflateInit(strm, level) {
    return $5599b666b2efdd0d$var$deflateInit2(strm, level, $5599b666b2efdd0d$var$Z_DEFLATED, $5599b666b2efdd0d$var$MAX_WBITS, $5599b666b2efdd0d$var$DEF_MEM_LEVEL, $5599b666b2efdd0d$var$Z_DEFAULT_STRATEGY);
}
function $5599b666b2efdd0d$var$deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $5599b666b2efdd0d$var$Z_BLOCK || flush < 0) return strm ? $5599b666b2efdd0d$var$err(strm, $5599b666b2efdd0d$var$Z_STREAM_ERROR) : $5599b666b2efdd0d$var$Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $5599b666b2efdd0d$var$FINISH_STATE && flush !== $5599b666b2efdd0d$var$Z_FINISH) return $5599b666b2efdd0d$var$err(strm, strm.avail_out === 0 ? $5599b666b2efdd0d$var$Z_BUF_ERROR : $5599b666b2efdd0d$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $5599b666b2efdd0d$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $5599b666b2efdd0d$var$put_byte(s, 31);
            $5599b666b2efdd0d$var$put_byte(s, 139);
            $5599b666b2efdd0d$var$put_byte(s, 8);
            if (!s.gzhead) {
                $5599b666b2efdd0d$var$put_byte(s, 0);
                $5599b666b2efdd0d$var$put_byte(s, 0);
                $5599b666b2efdd0d$var$put_byte(s, 0);
                $5599b666b2efdd0d$var$put_byte(s, 0);
                $5599b666b2efdd0d$var$put_byte(s, 0);
                $5599b666b2efdd0d$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $5599b666b2efdd0d$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $5599b666b2efdd0d$var$put_byte(s, $5599b666b2efdd0d$var$OS_CODE);
                s.status = $5599b666b2efdd0d$var$BUSY_STATE;
            } else {
                $5599b666b2efdd0d$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $5599b666b2efdd0d$var$put_byte(s, s.gzhead.time & 0xff);
                $5599b666b2efdd0d$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $5599b666b2efdd0d$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $5599b666b2efdd0d$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $5599b666b2efdd0d$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $5599b666b2efdd0d$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $5599b666b2efdd0d$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $5599b666b2efdd0d$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $5599b666b2efdd0d$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $55lL1(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $5599b666b2efdd0d$var$EXTRA_STATE;
            }
        } else {
            var header = $5599b666b2efdd0d$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $5599b666b2efdd0d$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $5599b666b2efdd0d$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $5599b666b2efdd0d$var$BUSY_STATE;
            $5599b666b2efdd0d$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $5599b666b2efdd0d$var$putShortMSB(s, strm.adler >>> 16);
                $5599b666b2efdd0d$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $5599b666b2efdd0d$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $55lL1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $5599b666b2efdd0d$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $5599b666b2efdd0d$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $55lL1(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $5599b666b2efdd0d$var$NAME_STATE;
            }
        } else s.status = $5599b666b2efdd0d$var$NAME_STATE;
    }
    if (s.status === $5599b666b2efdd0d$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $55lL1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $5599b666b2efdd0d$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $5599b666b2efdd0d$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $55lL1(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $5599b666b2efdd0d$var$COMMENT_STATE;
            }
        } else s.status = $5599b666b2efdd0d$var$COMMENT_STATE;
    }
    if (s.status === $5599b666b2efdd0d$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $55lL1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $5599b666b2efdd0d$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $5599b666b2efdd0d$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $55lL1(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $5599b666b2efdd0d$var$HCRC_STATE;
        } else s.status = $5599b666b2efdd0d$var$HCRC_STATE;
    }
    if (s.status === $5599b666b2efdd0d$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $5599b666b2efdd0d$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $5599b666b2efdd0d$var$put_byte(s, strm.adler & 0xff);
                $5599b666b2efdd0d$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $5599b666b2efdd0d$var$BUSY_STATE;
            }
        } else s.status = $5599b666b2efdd0d$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $5599b666b2efdd0d$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $5599b666b2efdd0d$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $5599b666b2efdd0d$var$rank(flush) <= $5599b666b2efdd0d$var$rank(old_flush) && flush !== $5599b666b2efdd0d$var$Z_FINISH) return $5599b666b2efdd0d$var$err(strm, $5599b666b2efdd0d$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $5599b666b2efdd0d$var$FINISH_STATE && strm.avail_in !== 0) return $5599b666b2efdd0d$var$err(strm, $5599b666b2efdd0d$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $5599b666b2efdd0d$var$Z_NO_FLUSH && s.status !== $5599b666b2efdd0d$var$FINISH_STATE) {
        var bstate = s.strategy === $5599b666b2efdd0d$var$Z_HUFFMAN_ONLY ? $5599b666b2efdd0d$var$deflate_huff(s, flush) : s.strategy === $5599b666b2efdd0d$var$Z_RLE ? $5599b666b2efdd0d$var$deflate_rle(s, flush) : $5599b666b2efdd0d$var$configuration_table[s.level].func(s, flush);
        if (bstate === $5599b666b2efdd0d$var$BS_FINISH_STARTED || bstate === $5599b666b2efdd0d$var$BS_FINISH_DONE) s.status = $5599b666b2efdd0d$var$FINISH_STATE;
        if (bstate === $5599b666b2efdd0d$var$BS_NEED_MORE || bstate === $5599b666b2efdd0d$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $5599b666b2efdd0d$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $5599b666b2efdd0d$var$BS_BLOCK_DONE) {
            if (flush === $5599b666b2efdd0d$var$Z_PARTIAL_FLUSH) $5jTNs._tr_align(s);
            else if (flush !== $5599b666b2efdd0d$var$Z_BLOCK) {
                $5jTNs._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $5599b666b2efdd0d$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $5599b666b2efdd0d$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $5599b666b2efdd0d$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $5599b666b2efdd0d$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $5599b666b2efdd0d$var$Z_FINISH) return $5599b666b2efdd0d$var$Z_OK;
    if (s.wrap <= 0) return $5599b666b2efdd0d$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $5599b666b2efdd0d$var$put_byte(s, strm.adler & 0xff);
        $5599b666b2efdd0d$var$put_byte(s, strm.adler >> 8 & 0xff);
        $5599b666b2efdd0d$var$put_byte(s, strm.adler >> 16 & 0xff);
        $5599b666b2efdd0d$var$put_byte(s, strm.adler >> 24 & 0xff);
        $5599b666b2efdd0d$var$put_byte(s, strm.total_in & 0xff);
        $5599b666b2efdd0d$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $5599b666b2efdd0d$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $5599b666b2efdd0d$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $5599b666b2efdd0d$var$putShortMSB(s, strm.adler >>> 16);
        $5599b666b2efdd0d$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $5599b666b2efdd0d$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $5599b666b2efdd0d$var$Z_OK : $5599b666b2efdd0d$var$Z_STREAM_END;
}
function $5599b666b2efdd0d$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $5599b666b2efdd0d$var$Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== $5599b666b2efdd0d$var$INIT_STATE && status !== $5599b666b2efdd0d$var$EXTRA_STATE && status !== $5599b666b2efdd0d$var$NAME_STATE && status !== $5599b666b2efdd0d$var$COMMENT_STATE && status !== $5599b666b2efdd0d$var$HCRC_STATE && status !== $5599b666b2efdd0d$var$BUSY_STATE && status !== $5599b666b2efdd0d$var$FINISH_STATE) return $5599b666b2efdd0d$var$err(strm, $5599b666b2efdd0d$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $5599b666b2efdd0d$var$BUSY_STATE ? $5599b666b2efdd0d$var$err(strm, $5599b666b2efdd0d$var$Z_DATA_ERROR) : $5599b666b2efdd0d$var$Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $5599b666b2efdd0d$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $5599b666b2efdd0d$var$Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $5599b666b2efdd0d$var$INIT_STATE || s.lookahead) return $5599b666b2efdd0d$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $13N4W(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $5599b666b2efdd0d$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $ex3eo.Buf8(s.w_size);
        $ex3eo.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $5599b666b2efdd0d$var$fill_window(s);
    while(s.lookahead >= $5599b666b2efdd0d$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($5599b666b2efdd0d$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $5599b666b2efdd0d$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $5599b666b2efdd0d$var$MIN_MATCH - 1;
        $5599b666b2efdd0d$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $5599b666b2efdd0d$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $5599b666b2efdd0d$var$Z_OK;
}
$5599b666b2efdd0d$export$72b35d618fb8ad9b = $5599b666b2efdd0d$var$deflateInit;
$5599b666b2efdd0d$export$a65c7b2bde87cb70 = $5599b666b2efdd0d$var$deflateInit2;
$5599b666b2efdd0d$export$8f99f0e30bc7dd53 = $5599b666b2efdd0d$var$deflateReset;
$5599b666b2efdd0d$export$e78fab288549509 = $5599b666b2efdd0d$var$deflateResetKeep;
$5599b666b2efdd0d$export$1cd50f7b2515ba19 = $5599b666b2efdd0d$var$deflateSetHeader;
$5599b666b2efdd0d$export$2316623ecd1285ab = $5599b666b2efdd0d$var$deflate;
$5599b666b2efdd0d$export$599854fa319a815f = $5599b666b2efdd0d$var$deflateEnd;
$5599b666b2efdd0d$export$f55e0b3ab66b5d46 = $5599b666b2efdd0d$var$deflateSetDictionary;
$5599b666b2efdd0d$export$12b6e1fcadea22f9 = 'pako deflate (from Nodeca project)'; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 

});
parcelRegister("5jTNs", function(module, exports) {

$parcel$export(module.exports, "_tr_init", function () { return $3dfa022360e360e9$export$4e4fc0157c3cd14d; }, function (v) { return $3dfa022360e360e9$export$4e4fc0157c3cd14d = v; });
$parcel$export(module.exports, "_tr_stored_block", function () { return $3dfa022360e360e9$export$8959e34c5e020172; }, function (v) { return $3dfa022360e360e9$export$8959e34c5e020172 = v; });
$parcel$export(module.exports, "_tr_flush_block", function () { return $3dfa022360e360e9$export$44f15b52eef0cf41; }, function (v) { return $3dfa022360e360e9$export$44f15b52eef0cf41 = v; });
$parcel$export(module.exports, "_tr_tally", function () { return $3dfa022360e360e9$export$b3cbce147289408f; }, function (v) { return $3dfa022360e360e9$export$b3cbce147289408f = v; });
$parcel$export(module.exports, "_tr_align", function () { return $3dfa022360e360e9$export$bfb360e02ee9b403; }, function (v) { return $3dfa022360e360e9$export$bfb360e02ee9b403 = v; });
var $3dfa022360e360e9$export$4e4fc0157c3cd14d;
var $3dfa022360e360e9$export$8959e34c5e020172;
var $3dfa022360e360e9$export$44f15b52eef0cf41;
var $3dfa022360e360e9$export$b3cbce147289408f;
var $3dfa022360e360e9$export$bfb360e02ee9b403;
'use strict';

var $ex3eo = parcelRequire("ex3eo");
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $3dfa022360e360e9$var$Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $3dfa022360e360e9$var$Z_BINARY = 0;
var $3dfa022360e360e9$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $3dfa022360e360e9$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $3dfa022360e360e9$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $3dfa022360e360e9$var$STORED_BLOCK = 0;
var $3dfa022360e360e9$var$STATIC_TREES = 1;
var $3dfa022360e360e9$var$DYN_TREES = 2;
/* The three kinds of block type */ var $3dfa022360e360e9$var$MIN_MATCH = 3;
var $3dfa022360e360e9$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $3dfa022360e360e9$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $3dfa022360e360e9$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $3dfa022360e360e9$var$L_CODES = $3dfa022360e360e9$var$LITERALS + 1 + $3dfa022360e360e9$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $3dfa022360e360e9$var$D_CODES = 30;
/* number of distance codes */ var $3dfa022360e360e9$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $3dfa022360e360e9$var$HEAP_SIZE = 2 * $3dfa022360e360e9$var$L_CODES + 1;
/* maximum heap size */ var $3dfa022360e360e9$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $3dfa022360e360e9$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $3dfa022360e360e9$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $3dfa022360e360e9$var$END_BLOCK = 256;
/* end of block literal code */ var $3dfa022360e360e9$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $3dfa022360e360e9$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $3dfa022360e360e9$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $3dfa022360e360e9$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $3dfa022360e360e9$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $3dfa022360e360e9$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $3dfa022360e360e9$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $3dfa022360e360e9$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $3dfa022360e360e9$var$static_ltree = new Array(($3dfa022360e360e9$var$L_CODES + 2) * 2);
$3dfa022360e360e9$var$zero($3dfa022360e360e9$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $3dfa022360e360e9$var$static_dtree = new Array($3dfa022360e360e9$var$D_CODES * 2);
$3dfa022360e360e9$var$zero($3dfa022360e360e9$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $3dfa022360e360e9$var$_dist_code = new Array($3dfa022360e360e9$var$DIST_CODE_LEN);
$3dfa022360e360e9$var$zero($3dfa022360e360e9$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $3dfa022360e360e9$var$_length_code = new Array($3dfa022360e360e9$var$MAX_MATCH - $3dfa022360e360e9$var$MIN_MATCH + 1);
$3dfa022360e360e9$var$zero($3dfa022360e360e9$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $3dfa022360e360e9$var$base_length = new Array($3dfa022360e360e9$var$LENGTH_CODES);
$3dfa022360e360e9$var$zero($3dfa022360e360e9$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $3dfa022360e360e9$var$base_dist = new Array($3dfa022360e360e9$var$D_CODES);
$3dfa022360e360e9$var$zero($3dfa022360e360e9$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $3dfa022360e360e9$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $3dfa022360e360e9$var$static_l_desc;
var $3dfa022360e360e9$var$static_d_desc;
var $3dfa022360e360e9$var$static_bl_desc;
function $3dfa022360e360e9$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $3dfa022360e360e9$var$d_code(dist) {
    return dist < 256 ? $3dfa022360e360e9$var$_dist_code[dist] : $3dfa022360e360e9$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $3dfa022360e360e9$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $3dfa022360e360e9$var$send_bits(s, value, length) {
    if (s.bi_valid > $3dfa022360e360e9$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $3dfa022360e360e9$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $3dfa022360e360e9$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $3dfa022360e360e9$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $3dfa022360e360e9$var$send_code(s, c, tree) {
    $3dfa022360e360e9$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $3dfa022360e360e9$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $3dfa022360e360e9$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $3dfa022360e360e9$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $3dfa022360e360e9$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $3dfa022360e360e9$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $3dfa022360e360e9$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $3dfa022360e360e9$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($3dfa022360e360e9$var$MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $3dfa022360e360e9$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $3dfa022360e360e9$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $3dfa022360e360e9$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($3dfa022360e360e9$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $3dfa022360e360e9$var$LENGTH_CODES - 1; code++){
        $3dfa022360e360e9$var$base_length[code] = length;
        for(n = 0; n < 1 << $3dfa022360e360e9$var$extra_lbits[code]; n++)$3dfa022360e360e9$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $3dfa022360e360e9$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $3dfa022360e360e9$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $3dfa022360e360e9$var$extra_dbits[code]; n++)$3dfa022360e360e9$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $3dfa022360e360e9$var$D_CODES; code++){
        $3dfa022360e360e9$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $3dfa022360e360e9$var$extra_dbits[code] - 7; n++)$3dfa022360e360e9$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $3dfa022360e360e9$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $3dfa022360e360e9$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $3dfa022360e360e9$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $3dfa022360e360e9$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $3dfa022360e360e9$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $3dfa022360e360e9$var$gen_codes($3dfa022360e360e9$var$static_ltree, $3dfa022360e360e9$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $3dfa022360e360e9$var$D_CODES; n++){
        $3dfa022360e360e9$var$static_dtree[n * 2 + 1] = 5;
        $3dfa022360e360e9$var$static_dtree[n * 2] = $3dfa022360e360e9$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $3dfa022360e360e9$var$static_l_desc = new $3dfa022360e360e9$var$StaticTreeDesc($3dfa022360e360e9$var$static_ltree, $3dfa022360e360e9$var$extra_lbits, $3dfa022360e360e9$var$LITERALS + 1, $3dfa022360e360e9$var$L_CODES, $3dfa022360e360e9$var$MAX_BITS);
    $3dfa022360e360e9$var$static_d_desc = new $3dfa022360e360e9$var$StaticTreeDesc($3dfa022360e360e9$var$static_dtree, $3dfa022360e360e9$var$extra_dbits, 0, $3dfa022360e360e9$var$D_CODES, $3dfa022360e360e9$var$MAX_BITS);
    $3dfa022360e360e9$var$static_bl_desc = new $3dfa022360e360e9$var$StaticTreeDesc(new Array(0), $3dfa022360e360e9$var$extra_blbits, 0, $3dfa022360e360e9$var$BL_CODES, $3dfa022360e360e9$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $3dfa022360e360e9$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $3dfa022360e360e9$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $3dfa022360e360e9$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $3dfa022360e360e9$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$3dfa022360e360e9$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $3dfa022360e360e9$var$bi_windup(s) {
    if (s.bi_valid > 8) $3dfa022360e360e9$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $3dfa022360e360e9$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $3dfa022360e360e9$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $3dfa022360e360e9$var$put_short(s, len);
        $3dfa022360e360e9$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $ex3eo.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $3dfa022360e360e9$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $3dfa022360e360e9$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $3dfa022360e360e9$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($3dfa022360e360e9$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $3dfa022360e360e9$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $3dfa022360e360e9$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $3dfa022360e360e9$var$_length_code[lc];
            $3dfa022360e360e9$var$send_code(s, code + $3dfa022360e360e9$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $3dfa022360e360e9$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $3dfa022360e360e9$var$base_length[code];
                $3dfa022360e360e9$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $3dfa022360e360e9$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $3dfa022360e360e9$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $3dfa022360e360e9$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $3dfa022360e360e9$var$base_dist[code];
                $3dfa022360e360e9$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $3dfa022360e360e9$var$send_code(s, $3dfa022360e360e9$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $3dfa022360e360e9$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $3dfa022360e360e9$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$3dfa022360e360e9$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $3dfa022360e360e9$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $3dfa022360e360e9$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $3dfa022360e360e9$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $3dfa022360e360e9$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $3dfa022360e360e9$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$3dfa022360e360e9$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$3dfa022360e360e9$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$3dfa022360e360e9$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $3dfa022360e360e9$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $3dfa022360e360e9$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $3dfa022360e360e9$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $3dfa022360e360e9$var$send_code(s, $3dfa022360e360e9$var$REP_3_6, s.bl_tree);
            $3dfa022360e360e9$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $3dfa022360e360e9$var$send_code(s, $3dfa022360e360e9$var$REPZ_3_10, s.bl_tree);
            $3dfa022360e360e9$var$send_bits(s, count - 3, 3);
        } else {
            $3dfa022360e360e9$var$send_code(s, $3dfa022360e360e9$var$REPZ_11_138, s.bl_tree);
            $3dfa022360e360e9$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $3dfa022360e360e9$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $3dfa022360e360e9$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $3dfa022360e360e9$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $3dfa022360e360e9$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $3dfa022360e360e9$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$3dfa022360e360e9$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $3dfa022360e360e9$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $3dfa022360e360e9$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $3dfa022360e360e9$var$send_bits(s, dcodes - 1, 5);
    $3dfa022360e360e9$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $3dfa022360e360e9$var$send_bits(s, s.bl_tree[$3dfa022360e360e9$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $3dfa022360e360e9$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $3dfa022360e360e9$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $3dfa022360e360e9$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $3dfa022360e360e9$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $3dfa022360e360e9$var$Z_TEXT;
    for(n = 32; n < $3dfa022360e360e9$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $3dfa022360e360e9$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $3dfa022360e360e9$var$Z_BINARY;
}
var $3dfa022360e360e9$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $3dfa022360e360e9$var$_tr_init(s) {
    if (!$3dfa022360e360e9$var$static_init_done) {
        $3dfa022360e360e9$var$tr_static_init();
        $3dfa022360e360e9$var$static_init_done = true;
    }
    s.l_desc = new $3dfa022360e360e9$var$TreeDesc(s.dyn_ltree, $3dfa022360e360e9$var$static_l_desc);
    s.d_desc = new $3dfa022360e360e9$var$TreeDesc(s.dyn_dtree, $3dfa022360e360e9$var$static_d_desc);
    s.bl_desc = new $3dfa022360e360e9$var$TreeDesc(s.bl_tree, $3dfa022360e360e9$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $3dfa022360e360e9$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $3dfa022360e360e9$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $3dfa022360e360e9$var$send_bits(s, ($3dfa022360e360e9$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $3dfa022360e360e9$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $3dfa022360e360e9$var$_tr_align(s) {
    $3dfa022360e360e9$var$send_bits(s, $3dfa022360e360e9$var$STATIC_TREES << 1, 3);
    $3dfa022360e360e9$var$send_code(s, $3dfa022360e360e9$var$END_BLOCK, $3dfa022360e360e9$var$static_ltree);
    $3dfa022360e360e9$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $3dfa022360e360e9$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $3dfa022360e360e9$var$Z_UNKNOWN) s.strm.data_type = $3dfa022360e360e9$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $3dfa022360e360e9$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $3dfa022360e360e9$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $3dfa022360e360e9$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $3dfa022360e360e9$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $3dfa022360e360e9$var$Z_FIXED || static_lenb === opt_lenb) {
        $3dfa022360e360e9$var$send_bits(s, ($3dfa022360e360e9$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $3dfa022360e360e9$var$compress_block(s, $3dfa022360e360e9$var$static_ltree, $3dfa022360e360e9$var$static_dtree);
    } else {
        $3dfa022360e360e9$var$send_bits(s, ($3dfa022360e360e9$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $3dfa022360e360e9$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $3dfa022360e360e9$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $3dfa022360e360e9$var$init_block(s);
    if (last) $3dfa022360e360e9$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $3dfa022360e360e9$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($3dfa022360e360e9$var$_length_code[lc] + $3dfa022360e360e9$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$3dfa022360e360e9$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$3dfa022360e360e9$export$4e4fc0157c3cd14d = $3dfa022360e360e9$var$_tr_init;
$3dfa022360e360e9$export$8959e34c5e020172 = $3dfa022360e360e9$var$_tr_stored_block;
$3dfa022360e360e9$export$44f15b52eef0cf41 = $3dfa022360e360e9$var$_tr_flush_block;
$3dfa022360e360e9$export$b3cbce147289408f = $3dfa022360e360e9$var$_tr_tally;
$3dfa022360e360e9$export$bfb360e02ee9b403 = $3dfa022360e360e9$var$_tr_align;

});

parcelRegister("13N4W", function(module, exports) {
'use strict';
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $0c5c2443c55d2a3e$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
module.exports = $0c5c2443c55d2a3e$var$adler32;

});

parcelRegister("55lL1", function(module, exports) {
'use strict';
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $3b3e4bedb0180b78$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $3b3e4bedb0180b78$var$crcTable = $3b3e4bedb0180b78$var$makeTable();
function $3b3e4bedb0180b78$var$crc32(crc, buf, len, pos) {
    var t = $3b3e4bedb0180b78$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
module.exports = $3b3e4bedb0180b78$var$crc32;

});

parcelRegister("9shtE", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};

});


parcelRegister("5XqLJ", function(module, exports) {

$parcel$export(module.exports, "string2buf", function () { return $45673a28f0818787$export$7a4c1b2f775b5a9f; }, function (v) { return $45673a28f0818787$export$7a4c1b2f775b5a9f = v; });
$parcel$export(module.exports, "buf2binstring", function () { return $45673a28f0818787$export$a751fe64af8a9a51; }, function (v) { return $45673a28f0818787$export$a751fe64af8a9a51 = v; });
$parcel$export(module.exports, "binstring2buf", function () { return $45673a28f0818787$export$1d1a7119601ff18c; }, function (v) { return $45673a28f0818787$export$1d1a7119601ff18c = v; });
$parcel$export(module.exports, "buf2string", function () { return $45673a28f0818787$export$49a50563f377746; }, function (v) { return $45673a28f0818787$export$49a50563f377746 = v; });
$parcel$export(module.exports, "utf8border", function () { return $45673a28f0818787$export$53dee3f58a714214; }, function (v) { return $45673a28f0818787$export$53dee3f58a714214 = v; });
// String encode/decode helpers
// convert string to array (typed, when possible)
var $45673a28f0818787$export$7a4c1b2f775b5a9f;
// Convert byte array to binary string
var $45673a28f0818787$export$a751fe64af8a9a51;
// Convert binary string (typed, when possible)
var $45673a28f0818787$export$1d1a7119601ff18c;
// convert array to string
var $45673a28f0818787$export$49a50563f377746;
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $45673a28f0818787$export$53dee3f58a714214;
'use strict';

var $ex3eo = parcelRequire("ex3eo");
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var $45673a28f0818787$var$STR_APPLY_OK = true;
var $45673a28f0818787$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, [
        0
    ]);
} catch (__) {
    $45673a28f0818787$var$STR_APPLY_OK = false;
}
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $45673a28f0818787$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var $45673a28f0818787$var$_utf8len = new $ex3eo.Buf8(256);
for(var $45673a28f0818787$var$q = 0; $45673a28f0818787$var$q < 256; $45673a28f0818787$var$q++)$45673a28f0818787$var$_utf8len[$45673a28f0818787$var$q] = $45673a28f0818787$var$q >= 252 ? 6 : $45673a28f0818787$var$q >= 248 ? 5 : $45673a28f0818787$var$q >= 240 ? 4 : $45673a28f0818787$var$q >= 224 ? 3 : $45673a28f0818787$var$q >= 192 ? 2 : 1;
$45673a28f0818787$var$_utf8len[254] = $45673a28f0818787$var$_utf8len[254] = 1; // Invalid sequence start
$45673a28f0818787$export$7a4c1b2f775b5a9f = function(str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new $ex3eo.Buf8(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper (used in 2 places)
function $45673a28f0818787$var$buf2binstring(buf, len) {
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $45673a28f0818787$var$STR_APPLY_UIA_OK || !buf.subarray && $45673a28f0818787$var$STR_APPLY_OK) return String.fromCharCode.apply(null, $ex3eo.shrinkBuf(buf, len));
    }
    var result = '';
    for(var i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
}
$45673a28f0818787$export$a751fe64af8a9a51 = function(buf) {
    return $45673a28f0818787$var$buf2binstring(buf, buf.length);
};
$45673a28f0818787$export$1d1a7119601ff18c = function(str) {
    var buf = new $ex3eo.Buf8(str.length);
    for(var i = 0, len = buf.length; i < len; i++)buf[i] = str.charCodeAt(i);
    return buf;
};
$45673a28f0818787$export$49a50563f377746 = function(buf, max) {
    var i, out, c, c_len;
    var len = max || buf.length;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        c_len = $45673a28f0818787$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $45673a28f0818787$var$buf2binstring(utf16buf, out);
};
$45673a28f0818787$export$53dee3f58a714214 = function(buf, max) {
    var pos;
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $45673a28f0818787$var$_utf8len[buf[pos]] > max ? pos : max;
};

});

parcelRegister("iGnPn", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $d99ea1e9422858c7$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = $d99ea1e9422858c7$var$ZStream;

});


parcelRegister("1jzAe", function(module, exports) {

$parcel$export(module.exports, "Inflate", function () { return $0f532ae30de026fd$export$d1de70a877d6e43c; }, function (v) { return $0f532ae30de026fd$export$d1de70a877d6e43c = v; });
$parcel$export(module.exports, "inflate", function () { return $0f532ae30de026fd$export$cae1ce83fe4a1782; }, function (v) { return $0f532ae30de026fd$export$cae1ce83fe4a1782 = v; });
$parcel$export(module.exports, "inflateRaw", function () { return $0f532ae30de026fd$export$d0f0aa2d05c905c5; }, function (v) { return $0f532ae30de026fd$export$d0f0aa2d05c905c5 = v; });
$parcel$export(module.exports, "ungzip", function () { return $0f532ae30de026fd$export$95adf9d270383091; }, function (v) { return $0f532ae30de026fd$export$95adf9d270383091 = v; });
/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $0f532ae30de026fd$export$d1de70a877d6e43c;
var $0f532ae30de026fd$export$cae1ce83fe4a1782;
var $0f532ae30de026fd$export$d0f0aa2d05c905c5;
var $0f532ae30de026fd$export$95adf9d270383091;
'use strict';

var $60qhq = parcelRequire("60qhq");

var $ex3eo = parcelRequire("ex3eo");

var $5XqLJ = parcelRequire("5XqLJ");

var $gOJnx = parcelRequire("gOJnx");

var $9shtE = parcelRequire("9shtE");

var $iGnPn = parcelRequire("iGnPn");

var $9bxjv = parcelRequire("9bxjv");
var $0f532ae30de026fd$var$toString = Object.prototype.toString;
/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $0f532ae30de026fd$var$Inflate(options) {
    if (!(this instanceof $0f532ae30de026fd$var$Inflate)) return new $0f532ae30de026fd$var$Inflate(options);
    this.options = $ex3eo.assign({
        chunkSize: 16384,
        windowBits: 0,
        to: ''
    }, options || {});
    var opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $iGnPn();
    this.strm.avail_out = 0;
    var status = $60qhq.inflateInit2(this.strm, opt.windowBits);
    if (status !== $gOJnx.Z_OK) throw new Error($9shtE[status]);
    this.header = new $9bxjv();
    $60qhq.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') opt.dictionary = $5XqLJ.string2buf(opt.dictionary);
        else if ($0f532ae30de026fd$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $60qhq.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $gOJnx.Z_OK) throw new Error($9shtE[status]);
        }
    }
}
/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $0f532ae30de026fd$var$Inflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var dictionary = this.options.dictionary;
    var status, _mode;
    var next_out_utf8, tail, utf8str;
    // Flag to properly process Z_BUF_ERROR on testing inflate call
    // when we check that all output data was flushed.
    var allowBufError = false;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $gOJnx.Z_FINISH : $gOJnx.Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // Only binary strings can be decompressed on practice
    strm.input = $5XqLJ.binstring2buf(data);
    else if ($0f532ae30de026fd$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $ex3eo.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $60qhq.inflate(strm, $gOJnx.Z_NO_FLUSH); /* no bad return value */ 
        if (status === $gOJnx.Z_NEED_DICT && dictionary) status = $60qhq.inflateSetDictionary(this.strm, dictionary);
        if (status === $gOJnx.Z_BUF_ERROR && allowBufError === true) {
            status = $gOJnx.Z_OK;
            allowBufError = false;
        }
        if (status !== $gOJnx.Z_STREAM_END && status !== $gOJnx.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $gOJnx.Z_STREAM_END || strm.avail_in === 0 && (_mode === $gOJnx.Z_FINISH || _mode === $gOJnx.Z_SYNC_FLUSH)) {
                if (this.options.to === 'string') {
                    next_out_utf8 = $5XqLJ.utf8border(strm.output, strm.next_out);
                    tail = strm.next_out - next_out_utf8;
                    utf8str = $5XqLJ.buf2string(strm.output, next_out_utf8);
                    // move tail
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) $ex3eo.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                    this.onData(utf8str);
                } else this.onData($ex3eo.shrinkBuf(strm.output, strm.next_out));
            }
        }
        // When no more input data, we should check that internal inflate buffers
        // are flushed. The only way to do it when avail_out = 0 - run one more
        // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
        // Here we set flag to process this error properly.
        //
        // NOTE. Deflate does not return error in this case and does not needs such
        // logic.
        if (strm.avail_in === 0 && strm.avail_out === 0) allowBufError = true;
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $gOJnx.Z_STREAM_END);
    if (status === $gOJnx.Z_STREAM_END) _mode = $gOJnx.Z_FINISH;
    // Finalize on the last chunk.
    if (_mode === $gOJnx.Z_FINISH) {
        status = $60qhq.inflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $gOJnx.Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $gOJnx.Z_SYNC_FLUSH) {
        this.onEnd($gOJnx.Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $0f532ae30de026fd$var$Inflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $0f532ae30de026fd$var$Inflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $gOJnx.Z_OK) {
        if (this.options.to === 'string') // Glue & convert here, until we teach pako to send
        // utf8 aligned strings to onData
        this.result = this.chunks.join('');
        else this.result = $ex3eo.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/ function $0f532ae30de026fd$var$inflate(input, options) {
    var inflator = new $0f532ae30de026fd$var$Inflate(options);
    inflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $9shtE[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $0f532ae30de026fd$var$inflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $0f532ae30de026fd$var$inflate(input, options);
}
$0f532ae30de026fd$export$d1de70a877d6e43c = $0f532ae30de026fd$var$Inflate;
$0f532ae30de026fd$export$cae1ce83fe4a1782 = $0f532ae30de026fd$var$inflate;
$0f532ae30de026fd$export$d0f0aa2d05c905c5 = $0f532ae30de026fd$var$inflateRaw;
$0f532ae30de026fd$export$95adf9d270383091 = $0f532ae30de026fd$var$inflate;

});
parcelRegister("60qhq", function(module, exports) {

$parcel$export(module.exports, "inflateInit2", function () { return $45f720d5598ce78a$export$6792d92addc5c8a0; }, function (v) { return $45f720d5598ce78a$export$6792d92addc5c8a0 = v; });
$parcel$export(module.exports, "inflate", function () { return $45f720d5598ce78a$export$cae1ce83fe4a1782; }, function (v) { return $45f720d5598ce78a$export$cae1ce83fe4a1782 = v; });
$parcel$export(module.exports, "inflateEnd", function () { return $45f720d5598ce78a$export$224e1a443c3fba76; }, function (v) { return $45f720d5598ce78a$export$224e1a443c3fba76 = v; });
$parcel$export(module.exports, "inflateGetHeader", function () { return $45f720d5598ce78a$export$6d4647cb9e1c75fc; }, function (v) { return $45f720d5598ce78a$export$6d4647cb9e1c75fc = v; });
$parcel$export(module.exports, "inflateSetDictionary", function () { return $45f720d5598ce78a$export$60da749bed98ccf8; }, function (v) { return $45f720d5598ce78a$export$60da749bed98ccf8 = v; });
var $45f720d5598ce78a$export$42de45683a92ba94;
var $45f720d5598ce78a$export$7633ac2cd30f9650;
var $45f720d5598ce78a$export$6710ea52c4ec9d6a;
var $45f720d5598ce78a$export$9c140b25e26874f9;
var $45f720d5598ce78a$export$6792d92addc5c8a0;
var $45f720d5598ce78a$export$cae1ce83fe4a1782;
var $45f720d5598ce78a$export$224e1a443c3fba76;
var $45f720d5598ce78a$export$6d4647cb9e1c75fc;
var $45f720d5598ce78a$export$60da749bed98ccf8;
var $45f720d5598ce78a$export$220f6291ca35fd71;
'use strict';

var $ex3eo = parcelRequire("ex3eo");

var $13N4W = parcelRequire("13N4W");

var $55lL1 = parcelRequire("55lL1");

var $fzrIm = parcelRequire("fzrIm");

var $5AGLU = parcelRequire("5AGLU");
var $45f720d5598ce78a$var$CODES = 0;
var $45f720d5598ce78a$var$LENS = 1;
var $45f720d5598ce78a$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $45f720d5598ce78a$var$Z_FINISH = 4;
var $45f720d5598ce78a$var$Z_BLOCK = 5;
var $45f720d5598ce78a$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $45f720d5598ce78a$var$Z_OK = 0;
var $45f720d5598ce78a$var$Z_STREAM_END = 1;
var $45f720d5598ce78a$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $45f720d5598ce78a$var$Z_STREAM_ERROR = -2;
var $45f720d5598ce78a$var$Z_DATA_ERROR = -3;
var $45f720d5598ce78a$var$Z_MEM_ERROR = -4;
var $45f720d5598ce78a$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $45f720d5598ce78a$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $45f720d5598ce78a$var$HEAD = 1; /* i: waiting for magic header */ 
var $45f720d5598ce78a$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $45f720d5598ce78a$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $45f720d5598ce78a$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $45f720d5598ce78a$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $45f720d5598ce78a$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $45f720d5598ce78a$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $45f720d5598ce78a$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $45f720d5598ce78a$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $45f720d5598ce78a$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $45f720d5598ce78a$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $45f720d5598ce78a$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $45f720d5598ce78a$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $45f720d5598ce78a$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $45f720d5598ce78a$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $45f720d5598ce78a$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $45f720d5598ce78a$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $45f720d5598ce78a$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $45f720d5598ce78a$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $45f720d5598ce78a$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $45f720d5598ce78a$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $45f720d5598ce78a$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $45f720d5598ce78a$var$DIST = 23; /* i: waiting for distance code */ 
var $45f720d5598ce78a$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $45f720d5598ce78a$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $45f720d5598ce78a$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $45f720d5598ce78a$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $45f720d5598ce78a$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $45f720d5598ce78a$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $45f720d5598ce78a$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $45f720d5598ce78a$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $45f720d5598ce78a$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $45f720d5598ce78a$var$ENOUGH_LENS = 852;
var $45f720d5598ce78a$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $45f720d5598ce78a$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $45f720d5598ce78a$var$DEF_WBITS = $45f720d5598ce78a$var$MAX_WBITS;
function $45f720d5598ce78a$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $45f720d5598ce78a$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $ex3eo.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $ex3eo.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $45f720d5598ce78a$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $45f720d5598ce78a$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $45f720d5598ce78a$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $ex3eo.Buf32($45f720d5598ce78a$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $ex3eo.Buf32($45f720d5598ce78a$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $45f720d5598ce78a$var$Z_OK;
}
function $45f720d5598ce78a$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $45f720d5598ce78a$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $45f720d5598ce78a$var$inflateResetKeep(strm);
}
function $45f720d5598ce78a$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $45f720d5598ce78a$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $45f720d5598ce78a$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $45f720d5598ce78a$var$inflateReset(strm);
}
function $45f720d5598ce78a$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $45f720d5598ce78a$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $45f720d5598ce78a$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $45f720d5598ce78a$var$inflateReset2(strm, windowBits);
    if (ret !== $45f720d5598ce78a$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $45f720d5598ce78a$var$inflateInit(strm) {
    return $45f720d5598ce78a$var$inflateInit2(strm, $45f720d5598ce78a$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $45f720d5598ce78a$var$virgin = true;
var $45f720d5598ce78a$var$lenfix, $45f720d5598ce78a$var$distfix; // We have no pointers in JS, so keep tables separate
function $45f720d5598ce78a$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($45f720d5598ce78a$var$virgin) {
        var sym;
        $45f720d5598ce78a$var$lenfix = new $ex3eo.Buf32(512);
        $45f720d5598ce78a$var$distfix = new $ex3eo.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $5AGLU($45f720d5598ce78a$var$LENS, state.lens, 0, 288, $45f720d5598ce78a$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $5AGLU($45f720d5598ce78a$var$DISTS, state.lens, 0, 32, $45f720d5598ce78a$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $45f720d5598ce78a$var$virgin = false;
    }
    state.lencode = $45f720d5598ce78a$var$lenfix;
    state.lenbits = 9;
    state.distcode = $45f720d5598ce78a$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $45f720d5598ce78a$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $ex3eo.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $ex3eo.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $ex3eo.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $ex3eo.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $45f720d5598ce78a$var$inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $ex3eo.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $45f720d5598ce78a$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $45f720d5598ce78a$var$TYPE) state.mode = $45f720d5598ce78a$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $45f720d5598ce78a$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $45f720d5598ce78a$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $45f720d5598ce78a$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $55lL1(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $45f720d5598ce78a$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $45f720d5598ce78a$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $45f720d5598ce78a$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $45f720d5598ce78a$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $45f720d5598ce78a$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $45f720d5598ce78a$var$DICTID : $45f720d5598ce78a$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $45f720d5598ce78a$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $45f720d5598ce78a$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $45f720d5598ce78a$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $45f720d5598ce78a$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $55lL1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $45f720d5598ce78a$var$TIME;
        /* falls through */ case $45f720d5598ce78a$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $55lL1(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $45f720d5598ce78a$var$OS;
        /* falls through */ case $45f720d5598ce78a$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $55lL1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $45f720d5598ce78a$var$EXLEN;
        /* falls through */ case $45f720d5598ce78a$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $55lL1(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $45f720d5598ce78a$var$EXTRA;
        /* falls through */ case $45f720d5598ce78a$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $ex3eo.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $55lL1(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $45f720d5598ce78a$var$NAME;
        /* falls through */ case $45f720d5598ce78a$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $55lL1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $45f720d5598ce78a$var$COMMENT;
        /* falls through */ case $45f720d5598ce78a$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $55lL1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $45f720d5598ce78a$var$HCRC;
        /* falls through */ case $45f720d5598ce78a$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $45f720d5598ce78a$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $45f720d5598ce78a$var$TYPE;
            break;
        case $45f720d5598ce78a$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $45f720d5598ce78a$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $45f720d5598ce78a$var$DICT;
        /* falls through */ case $45f720d5598ce78a$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $45f720d5598ce78a$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $45f720d5598ce78a$var$TYPE;
        /* falls through */ case $45f720d5598ce78a$var$TYPE:
            if (flush === $45f720d5598ce78a$var$Z_BLOCK || flush === $45f720d5598ce78a$var$Z_TREES) break inf_leave;
        /* falls through */ case $45f720d5598ce78a$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $45f720d5598ce78a$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $45f720d5598ce78a$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $45f720d5598ce78a$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $45f720d5598ce78a$var$LEN_; /* decode codes */ 
                    if (flush === $45f720d5598ce78a$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $45f720d5598ce78a$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $45f720d5598ce78a$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $45f720d5598ce78a$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $45f720d5598ce78a$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $45f720d5598ce78a$var$COPY_;
            if (flush === $45f720d5598ce78a$var$Z_TREES) break inf_leave;
        /* falls through */ case $45f720d5598ce78a$var$COPY_:
            state.mode = $45f720d5598ce78a$var$COPY;
        /* falls through */ case $45f720d5598ce78a$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $ex3eo.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $45f720d5598ce78a$var$TYPE;
            break;
        case $45f720d5598ce78a$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $45f720d5598ce78a$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $45f720d5598ce78a$var$LENLENS;
        /* falls through */ case $45f720d5598ce78a$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $5AGLU($45f720d5598ce78a$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $45f720d5598ce78a$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $45f720d5598ce78a$var$CODELENS;
        /* falls through */ case $45f720d5598ce78a$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $45f720d5598ce78a$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $45f720d5598ce78a$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $45f720d5598ce78a$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $45f720d5598ce78a$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $5AGLU($45f720d5598ce78a$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $45f720d5598ce78a$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $5AGLU($45f720d5598ce78a$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $45f720d5598ce78a$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $45f720d5598ce78a$var$LEN_;
            if (flush === $45f720d5598ce78a$var$Z_TREES) break inf_leave;
        /* falls through */ case $45f720d5598ce78a$var$LEN_:
            state.mode = $45f720d5598ce78a$var$LEN;
        /* falls through */ case $45f720d5598ce78a$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $fzrIm(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $45f720d5598ce78a$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $45f720d5598ce78a$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $45f720d5598ce78a$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $45f720d5598ce78a$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $45f720d5598ce78a$var$LENEXT;
        /* falls through */ case $45f720d5598ce78a$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $45f720d5598ce78a$var$DIST;
        /* falls through */ case $45f720d5598ce78a$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $45f720d5598ce78a$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $45f720d5598ce78a$var$DISTEXT;
        /* falls through */ case $45f720d5598ce78a$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $45f720d5598ce78a$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $45f720d5598ce78a$var$MATCH;
        /* falls through */ case $45f720d5598ce78a$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $45f720d5598ce78a$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $45f720d5598ce78a$var$LEN;
            break;
        case $45f720d5598ce78a$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $45f720d5598ce78a$var$LEN;
            break;
        case $45f720d5598ce78a$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $55lL1(state.check, output, _out, put - _out) : $13N4W(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $45f720d5598ce78a$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $45f720d5598ce78a$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $45f720d5598ce78a$var$LENGTH;
        /* falls through */ case $45f720d5598ce78a$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $45f720d5598ce78a$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $45f720d5598ce78a$var$DONE;
        /* falls through */ case $45f720d5598ce78a$var$DONE:
            ret = $45f720d5598ce78a$var$Z_STREAM_END;
            break inf_leave;
        case $45f720d5598ce78a$var$BAD:
            ret = $45f720d5598ce78a$var$Z_DATA_ERROR;
            break inf_leave;
        case $45f720d5598ce78a$var$MEM:
            return $45f720d5598ce78a$var$Z_MEM_ERROR;
        case $45f720d5598ce78a$var$SYNC:
        /* falls through */ default:
            return $45f720d5598ce78a$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $45f720d5598ce78a$var$BAD && (state.mode < $45f720d5598ce78a$var$CHECK || flush !== $45f720d5598ce78a$var$Z_FINISH)) {
        if ($45f720d5598ce78a$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $45f720d5598ce78a$var$MEM;
            return $45f720d5598ce78a$var$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $55lL1(state.check, output, _out, strm.next_out - _out) : $13N4W(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $45f720d5598ce78a$var$TYPE ? 128 : 0) + (state.mode === $45f720d5598ce78a$var$LEN_ || state.mode === $45f720d5598ce78a$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $45f720d5598ce78a$var$Z_FINISH) && ret === $45f720d5598ce78a$var$Z_OK) ret = $45f720d5598ce78a$var$Z_BUF_ERROR;
    return ret;
}
function $45f720d5598ce78a$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $45f720d5598ce78a$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $45f720d5598ce78a$var$Z_OK;
}
function $45f720d5598ce78a$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $45f720d5598ce78a$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $45f720d5598ce78a$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $45f720d5598ce78a$var$Z_OK;
}
function $45f720d5598ce78a$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $45f720d5598ce78a$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $45f720d5598ce78a$var$DICT) return $45f720d5598ce78a$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $45f720d5598ce78a$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $13N4W(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $45f720d5598ce78a$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $45f720d5598ce78a$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $45f720d5598ce78a$var$MEM;
        return $45f720d5598ce78a$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $45f720d5598ce78a$var$Z_OK;
}
$45f720d5598ce78a$export$42de45683a92ba94 = $45f720d5598ce78a$var$inflateReset;
$45f720d5598ce78a$export$7633ac2cd30f9650 = $45f720d5598ce78a$var$inflateReset2;
$45f720d5598ce78a$export$6710ea52c4ec9d6a = $45f720d5598ce78a$var$inflateResetKeep;
$45f720d5598ce78a$export$9c140b25e26874f9 = $45f720d5598ce78a$var$inflateInit;
$45f720d5598ce78a$export$6792d92addc5c8a0 = $45f720d5598ce78a$var$inflateInit2;
$45f720d5598ce78a$export$cae1ce83fe4a1782 = $45f720d5598ce78a$var$inflate;
$45f720d5598ce78a$export$224e1a443c3fba76 = $45f720d5598ce78a$var$inflateEnd;
$45f720d5598ce78a$export$6d4647cb9e1c75fc = $45f720d5598ce78a$var$inflateGetHeader;
$45f720d5598ce78a$export$60da749bed98ccf8 = $45f720d5598ce78a$var$inflateSetDictionary;
$45f720d5598ce78a$export$220f6291ca35fd71 = 'pako inflate (from Nodeca project)'; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 

});
parcelRegister("fzrIm", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $b55f9f6d06c7b1ba$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $b55f9f6d06c7b1ba$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $b55f9f6d06c7b1ba$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $b55f9f6d06c7b1ba$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $b55f9f6d06c7b1ba$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $b55f9f6d06c7b1ba$var$TYPE;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $b55f9f6d06c7b1ba$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

});

parcelRegister("5AGLU", function(module, exports) {
'use strict';

var $ex3eo = parcelRequire("ex3eo");
var $41217e1be6235ce1$var$MAXBITS = 15;
var $41217e1be6235ce1$var$ENOUGH_LENS = 852;
var $41217e1be6235ce1$var$ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $41217e1be6235ce1$var$CODES = 0;
var $41217e1be6235ce1$var$LENS = 1;
var $41217e1be6235ce1$var$DISTS = 2;
var $41217e1be6235ce1$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $41217e1be6235ce1$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $41217e1be6235ce1$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $41217e1be6235ce1$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $ex3eo.Buf16($41217e1be6235ce1$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $ex3eo.Buf16($41217e1be6235ce1$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $41217e1be6235ce1$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $41217e1be6235ce1$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $41217e1be6235ce1$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $41217e1be6235ce1$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $41217e1be6235ce1$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $41217e1be6235ce1$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $41217e1be6235ce1$var$LENS) {
        base = $41217e1be6235ce1$var$lbase;
        base_index -= 257;
        extra = $41217e1be6235ce1$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $41217e1be6235ce1$var$dbase;
        extra = $41217e1be6235ce1$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $41217e1be6235ce1$var$LENS && used > $41217e1be6235ce1$var$ENOUGH_LENS || type === $41217e1be6235ce1$var$DISTS && used > $41217e1be6235ce1$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $41217e1be6235ce1$var$LENS && used > $41217e1be6235ce1$var$ENOUGH_LENS || type === $41217e1be6235ce1$var$DISTS && used > $41217e1be6235ce1$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};

});


parcelRegister("gOJnx", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

});

parcelRegister("9bxjv", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $6afefb8084f6d482$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
module.exports = $6afefb8084f6d482$var$GZheader;

});




parcelRegister("hRNK7", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("dg1HZ", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("fiOEo", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("6vTMX", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("3QLDc", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("1JYAJ", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("4Fxf2", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("c2mly", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("57yAe", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("hz5ax", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("k3qSE", function(module, exports) {
module.exports = JSON.parse("\"eJyNnV1320aWtf+KF6/mXcvpsWTJsnPnTtLdsdNx7ESGMb36gpZgmSNKcEhRCjNr/vsLgqhz9tlnFz03XsaziwDqVNWuDxSg/5l919/cdLd3s29n7/+5Wc+vukcnZ2fHZ49On5+dHs8ez/7W3979PL/phgS/LW669Tc/3s2Xi4udslkuUXnkyvxmsdyiNsCmW1x93l3nn93lYnMzkH36l7dXyyHdN0enfzkd2Ppviz+6y18WdxefZ9/erTbd49l3n+er+cVdt/q12/3+hz/uutvL7vJdfzO/ne7wr3/t/5h9+69vjp69ePzN8dHZ46MnR08eP3/+9N+PZ+dD4tVycdv90q8Xd4v+dnexJ09A+O3z4uL6tluvZ9+eDvx9t1qPyWZPnhz/5cmTJ8NFfu7vFhe77HzXf9mudjl59B8X/+/R0Yvnp493/56N/77Y/fviyfjv0/Hfs0cvL/uP3aNft+u77maI0e1Fv/rSr+Z33eVfHj16uVw+erc72/rRu27dre4Hug/mYv1o/uhuNb/sbuar60f9p0c/LW77u+2X7pt/dMOvXv790fz28j/71aPF8OP15uN6cbmYrxbd+i/D7f4wXOZycXv168XnbiyF8S5+vRt+Ml9dFnVI+N38yz+mgnl2+vTx7EM5Ojk5ejx7ub7YhXo1iM8H8fvOjscgz369u/xHM/v26fH43/fDf8+e7cvrn93danExBPRf/zNrPsy+Pd4F9ufhRtZf5kMc//fxHj99+nSPuz8ulvMb4yfHU/LfN/0QqY9LU06fTMrt5ubjrqCubrN22S+X85Xx5+UqX7rVxa6yF+Hs7PlemN8M0nqITr6z8Q7GEs/al/mqu112n2pS/Jnd3ny9O+P62pRnZ6fTr5abtVGL2cXQRuf5Ep+3Xz53tzn5kJVF7zk5LplcL+frz/lu/uxWfab9bZfh3YNIefd51Ym0n/rNStDFvUi7XvwhYHffibLtdExvF7eiWl30y/4243V3s4iSlcByZwOJdr9v5suMr1bd0JBFNn/fdOvRaoryolToud/7s6OjPXuZ0V8dPTvbo++82h4f79H3+Yc/ZPS3/MO/Z/SPHKYfvT2enOzRq3xfrz37p8/26Kfc9P6Zf/hzvok3+e5/yane5lTvchn8mu/rt3yu83yu9/num5zqQz59m9F/eVSH3mFEH4fO7Lq7C7ZhbfTjoMV2yr+LnnJS8jFfXywWF4vVxeYmh2KzM+310POIJjL6W7gZ96mMPuYqcSH8N6fqcl4/5R9eZfQ5/3CR0X/nK17nVMtc/iJawnSE7X0RrT4X2iqjdb4vEftNztB9bkIPOdUfGW3zTfzpqaxoh/rVUa08LbVyVUlPPdzJEdTGu8XyssuX3nf1l/2DiHPonb0nuBvHaV45jkr+P+0Ghuiz9put6js+LfvVQvB1VznLxWY1dOMXHsDjoxNoNuvFOHhNrb6MWnSzutosBuWmv9Mjh508nvgrcmVw8Wmh8i360WEoqIYDl/OrK9Wl7TkOxWjAsSu7btV52z899rHQ/Go1/wKmVn76cZhEdCKXHt6P8/WBCB9WKyGyAoj6c6uhy+Xiy3rhDXWYLnhW7z73mzBUTL1+qNtecKv5vfDf+cXmTo1cRiv/tOz+yBo1rIJv5hcrNdr5uOrUhS/7u/lFaHAuLYaCxACYssJm6Dc7TOmGEbcYom5ur+arzc1yvhGX6a+GUea1ON0c8+HFchNqrPGXPuY5PptqQL+6/DQM8sKo0IcnsYf10UfkL4p/vvELPD16Yhe4GVxus8QrmC/PRXd3uWvw67XovJaVkXkfuZ29F0PooW0O0+GhzotC+zGVp3fLsfp51x8rjXdLskT9dLHofGSU7sDG0JeL+8WlKKQ23pkPlkXL8NuOP/JRnviRd4/UBK2jHudd1EYgq/mUfr3QThynMPidU2Pw31RKaEM/8BlAuojPFwaDgAlInGBSRs+emTiteIhLkeX4mJDqgeUyxMVnAuoGvHnU6mh0VB/lq7P5NKp2tuiqEM7sk15DQjaBkyH60DVe/eRsusqy/7O7vRKXfxcv4TM4lUmvHAcbiRC9eXEvYiPZeCNQ1JRXn/vkyNllfvvcr0Su3tDVPQyVUvuVeLmry0rYzukCHrHYs4XFjfVmHOGsxP3GKuhRrPFoq2aCN5vl3eLLcivuizLolTwWR+n4hrHW3WK+vFx8+pTLaptt2JpgvI5X2EOV5YeD1exAr1OXLioFfVuzQa4x7ilzORr6kfoVXHobBgy4/mbTn1V/3d3iJMjMcdVdLdZx2OtNtDLw+lG0C5uJbIZWHeYiHmwaQFrDrESm56pu7bJSpf6LTPvkRRm4jqtccQ3McvnDnRihfFc1wKXyLW9uFZPpqr1jrRd8WRs+HKiVlQD/WWsatZt6UyuRWtdT89x17cr1Lv7NwWEJ21IZF3TLO7HYcxdM2gvpoT/giPUhzs1G5IT6cAuVHGd6W6DQ+yw1jnDOTtHHhwq8GiqyuLVf0wymKMtYI33VU/a/NsOIBffiebmN8kBHeWJ9PvZjZe74Y627/Im6vxKGIWif50tYeCttfDcziQ3ci+KQyd/GUZPXtK+UHw2DLAi17vkqeilmaCpVVah6EPqrHO5aBdYzHKtgg0uoxx09NS13Qn0Tm5j+5LRMsIdu80L57PeVsebq4Gj351g+fruV0e67w9VaXsustXLOl1WP1rOkN5WFwz8PjCd/qPX2dG1fHZZZsfFYGAj42Q42hXgLvrh78ErL/mpX3re9GMX3dS/dZKk05eFUlZZ8dXDO0N2Jhw5/Vqrv7cFufAh56iHc8mtt/IfN7kHkvx/PXner21/mi9Xu8fG/Zi93j6lnj795+uTfj6ejvXsEtL/PiCZPR/j33dGpHe1dJSDMGApvhqMTO8+bcguAoHIEbkUV6L79BxScJyhTyALbLw4FtG84iN6Go992OTqzI4sZoJh7E86Ho1M7z3nJPaCQe+CQe6Al94Ao96BY7oFN7Tqw0U6QvB+Ojp5YETbD4Qs7andJ/ciy5Ahv3SjsB8AAbYajY7vwppwNUAgQcLgK0BIgQBQgUCxAwCxAwKYAObkPWXsIR9t4lOOzzfGZEmF7NUSN1ji1XOfcfIsCbdgQNWTjsjUXFZq0IWrXxlXjNjG3cJOomRvXbd1kbvAmUKs3Tk2/8LcZgQkYIidwruygqOAJhsgYjCt3MDFbhEnkE8a1WZjMjmEC24YJ0TsKRgMpDFykoDa3APYT4/VGo5ylaGAvhshjjCujMTG7jUlkOca175jM5mMCO5AJ0YYKvs8RechoK1Al1MKfJptAfzJE/mSc/Mk5+1NRwJ8MkT8Zl/5UVPAnQ+RPxpU/mZj9ySTyJ+Pan0xmfzKB/Mk4+VPhbzMCfzJE/uRc+VNRwZ8MkT8ZV/5kYvYnk8ifjGt/Mpn9yQT2JxOiPxWM/lQY+FNBbW4B7E/G641G+VPRwJ8MkT8ZV/5kYvYnk8ifjGt/Mpn9yQT2JxOiPxV8nyPykNFWoEqohT9haNCkIieniiLZFYnsWUEG44qc3CuK0sJCEvCxyMnMoqgcLabIthZ18rYoaoOLadjlokpWF0XyuyC+rXBwvsjJ/khUHhiSgBFGTm4YRWWJMUX2xaiTOUZRO2RMwzYZVfbKqEbDDBq6ZhDAOgNvKy2UTTSKX2neyk5DAvDUyMlYo6jcNabIFht18tkoarONadhxo8q2G9XovUG7rwTyocK3NX6o1IQpO0FLRkqGjBLZcZDYjEEEK0ZKRoyStGFIACaMlCwYJWXAqGf7RZXMFyVtvZiCjRc1sl2UyHRBeispGC5SstsgKbOFBGC1SMloUVI2i3o2WVTJYlHSBosp2F5RY3NFLVorKGisgMFWgbayhbGlonSwaSo7BRnMFClZKUrKSFHPNooqmShK2kIxBRsoamyfqEXzBOVehuxB0q2m9XIRljnlHv3SEJmlcXJK52yTRQGPNEQGaVy6Y1HBGg2RLxpXpmhidkSTyA6Nay80mY3QBHJB42SBhb/NCMzPEDmfc2V7RQXPM0SGZ1y5nYnZ6kwinzOuTc5kdjgT2N5MiN5WMBpbYeBqBbW5BbCfGa83GuVkRQMbM0QeZlwZmInZvUwi6zKufctkNi0T2LFMiHZV8H2OyENGW4EqoRb+VO4VDcoZOZQLZFEgsEeZBCbljFzKBWlTJoNPOSOjckE5lavZqlwjr3JBm5Xr7FaukF25QH5lwlvBwLGckWWBoDzLZDAtZ+RaLijbcjX7lmtkXC5o53KdrcsV9i5XonkZR/cyCPZlrBUthA3MhQPNSlmYieBhzsjEXFAu5mq2MdfIx1zQRuY6O5krbGWuRC8zfi+C8yDYVrFa5IWhlRtDQ3NGhuYCGRoIbGgmgaE5I0NzQRqayWBozsjQXFCG5mo2NNfI0FzQhuY6G5orZGgukKGZ8FYwMDRnZGggKEMzGQzNGRmaC8rQXM2G5hoZmgva0FxnQ3OFDc2VaGjG0dAMgqEZa0ULYUNz4UCzUoZmIhiaMzI0F5ShuZoNzTUyNBe0obnOhuYKG5or0dCM34vgPAi2VawWeWFoq+n7JO5AhZCZFUxWZpiNbBLAxgohEytYWtgkgoEVQvZVsDKvomXrKgoZV8HatorKplU4WVbBZFgTfpsImFUhZFWGlVFNIthUIWRSBSuLKlo2qKKQPRWszamobE2FszEVHm1pomhKEwJLmkibajjbUcHVJqGsaJLAiAohGypYmVDRsgUVhQyoYG0/RWXzKZytp/BoPBO9T2F4SGSbiY6tsJupEaDfGCLDMU6O45wtpyjgOYbIdIxL1ykq2I4h8h3jynhMzM5jElmPce09JrP5mEDuY5zsp/C3GYEBGSIHcq4sqKjgQYbIhIwrFzIx25BJ5EPGtRGZzE5kAluRCdGLCkYzKgzcqKA2twD2I+P1RqMcqWhgSYbIk4wrUzIxu5JJZEvGtS+ZzMZkAjuTCdGaCr7PEXnIaCtQJdTZn/460Je7K/uRBdFR8RJAMaTOMZpOLZCOPEjOPD7OSmiclIbt6HyslHZUcgAo3C5wuF2g5XYBUZGDYhkBZhkBNmVkT76f4r733+8x7oCih3+f4g4cMgK0ZASQ3S4wu11g0+0CKXF39N689PvJBvyojUexF/me2v1EJ9PFyBii8BinGBlXgTIxR8skCplxjpsJHDwTYgQNUxgLf5/D0GTUCkShNS7iO77DGONbEMe3cI5v4TK+RRTxLRLHt/AU3yKk+BaB4lswx3fi73MYmoxagTi+haf4/m0K7dHRqR2aFwErIUUWDQoEdCjAZlHA3IkAuhUBLF4EqIQN2G6keeZHJSuASk4AhYwAh3wALdkAZLkAZpkANuUBSMmCo/0HLodMPTUUE3Q5U10Z+iHSmepkpuCF24BzXjuR107kdbGrYn5kFdJRHIw7xzrq1Ibgjnx47czuxFnvw7/x0LtaZ9TXuhA6W8fe2zpL3a1L0N86LJMAZFajnU1fMA0VYmWDofEoDp1GVCoEojAN2Auvpua/N4NX2PoBlSYDSMykXlHTBxrnT69CwwfmhedsajJA4iTp1dTon1p+5rFbeIWNHpDoDF5Rowcau4BXodEDI+N/BY0eSLT7V9Doj4108SiOcF9hm0eUR7ivqM0jhTYPOA58X4U2D4wGvq+mlgZH+Z77yg328gb7fCfcyEAR92hNDFAcib/CBuZoEwpnkyvUplJ7NrL2bHLt4fkYKKJebUS92oR69Xq2XwnZT33HoziLH5GYwI88zd1HGqftI5Iz9lGhyfrISvgBlfA76kIeuhjr11jREeXwv6aKjhQqOuBYKq9DRQdGsX89VfQTy0EfLfN1qujAkz++xooOSC4tvQ4VHVhcUHqNFd3RJh7lu95U7noj73qT75prNSjirjfk96+hVjvZxqN819t8d6Grw3ZBAjURUlVroSS54VACakOk6uZEibhlkUyNjFRqb1GFyk8CtUJSqUGyKtomJcnNlBPkFkspqPGSyu2YZG7SUe5rFYkbOqmq9VCSr1VVdgJSdfOiRNzSSCarIJVcI6qbqnAwMNJWKMnXAsNmQ+r/JTDJgkhmNyI5GlMUt1XhYGCyc/002y/tH/uRDfMAhZG8C7v1gv24fnfUhKM2pGzjsvOI0qLyjorl7J+mDD+1RJZLQNjE9xTfuT8mRJmsvHNPKmQX30cn1OYfcu7V++gkqTjga9iUR46Ieg17kmKVgOCQQCFiVQUqpoFwRaGpCW3tVBxAUnMYYwIVzNygZHw4sPUGNSWY7A4Da4hC6lwFs6gQxoKajNr8Qw6a8RyuIqlAFW2b88jBMZ7C8vNseoZyZkd2d47sGYqjOIFzjnlwahM4Rz5Nc+ZTSWflGYoTm7ntUWlSLwWivBinDBlXuTIxZ80kyp9xzqQJnFMTYnYNU57xYQMjynN62MBc5Vk9bGCJ8pwfNrDAeeaHDYw5z6GFv6wKnP+ochSiKmMRk4iIxAQcl6im6EQ5xSjKFKkoUrzKg9OXAlGMjFN0jKu4mJgjYhLFwjhHwQTOvwkx54Zjnt9M2d178BvMKaCSSUBxhuc8PXN+g7kC5HMzZ747wVnZmODEJmaGfrNR4BvsnBCFfsmFsUuyoyYcfQgp26D59gZHaUb7Bo12uttktMwp1tpoWcxRT0bLnOOfjZaFWBLJaIlDmaSxauKqdMJYNaImow/5h21OxcWmhq+TFF7nhgKMnEoxilSUUVTlGVPkQo06lWwUuXijymUc1VjQUaPSTh+eOBHR43I/9OEJleR9pVSaCv9QOU9bSc+1ov79hb0OL61CxUBK1QIlqhQoqSqBeq4QqFJ1QIkrA2pcFVCLFQEVqgb0MvxJihNXgfrL8DnBexn5RtIP8gytTMvFXntHfK+W1wChxA1RcRunsjauCtrEXMomUREb5/I1gQvXhFiyhqlY8R3fkxgGLtDKO76kvs/xbDL6kH/Y5lRcfPKV2L0U17iwCFmhkmSZCpRlVa6cJhcvp6BSZpkLm3Uuc9Zj0bNKNYBkqAisUH1IsqoWlOh9tcSaqvKhera2+huuOSznCmTvzEHVcUaVxgWqLi6oiuJqriKuUeVwgauFK1whXIlVwTlVgvDm7AlFhAu+9uYsy+9FdBvBPojftiIdF6p+wXSvldUdKE1DVJjGqSyNq6I0MZekSVSQxrkcTeBiNCGWomEqRFzNO4lh4CKsrOaR+j7Hs8noQ/5hm1Nx4akFvknCSfqUtTRJZ05lpyfpLOayS5N05lx2eZLOQiy7NEknDmWXXl1IXJUd7uuneDYZfcg/bHMqLju503+UfpmK7YUfld8CKoUFKJQTcLgC0FI6gKxggFmZAJuKA0gpCUe7zUbP/ajkAFDJAaCQA+CQA6AlB4AsB8AsB8CmHAApOXBE+yR3KCbocqbsyTUinalOZio8mAac89qJvHYir308yvfcV26wlzfY5zvhp8agiHu058OAcvB5U+LbGb7RMB7FNxpGJN5oGHl6o2Gk8Y2GEck3GkaF3mgYGb3RMLLwRsO7Gb4+Nh7F57UjEk+vR54e3o40PqcekXw4PSr0RHpk8fn8iOJD+XdTrOEo3/V55a7P5V2f57vmWIMi7vqcHp6/g1g7GV/Eel6OmnDUxiOrPY6wluxpWfiCMjREITGu4mJiDo5JFCHjOkwmc6xMoGI2TmVd+LlAlSzKojexnkWuBMYPZzFVBxO4TpgQKwYukVLBNhm1AlFlUeuhk1QeMkGNMUThNK7CaWIOp0kUTuM6nCZzOE2gGmOcakzh5wJVsihrjIn1LHKNMX44i6nGmMA1xoRYY/D9IyrYJqNWIKox6v2jIqWthOUm9FZCrcoAV7cS6gQc7INbCXWiFHi9lVCrXM+Cel4VDgZG17yY5GuBSbUwqv+XwOQaGeVUL6NMtTPtupFVqakJbVXgWlvddbNPMEy09hPMJ3YUZzkjsmmlI7HxdeRpLjTSuMV1RLRldWT00vbIwvvaI4n7VX+bmpzn502MwW+pcQGXAbFmBIiHla74sNKZvbfjyF7bMbSbmbw4tiObITqyGaKjOEN0jjNEpzZDdOQzRGc+Q3RWZohObIZo6KJfwirAnuxnXGcnhcRfdDmXNuFCFGqXc6xdQGHCBSexSufIK50zkfnP2y+fu9uQjUXIpr2rBoiWPnasD2ftc977SnH2sjj7XJw8cQNFFLRN3ADlUrWJm+d+FbK1yrmnl8n2SLxMthPW3c2i1JxnRjchzSZfYiMWsUae1q9GGpeuRsRb6V2h9ayRifLchFWsHXkIYdrGo5IHQLjLbk9xv9bkaGm/FnPyY71fi8XszGm/FnP26Lxfi4Xo1mm/FnHw7TTEZq4cXA2xWSIvrw2xWWZXT0Ns5uTvhYPJGyIfME52b1yZhInZKUwiuzDOzmACW6EJsTMwTN5ROHULjkPfULA4AfcSxqmrcC76CxNzp+FS7jlMo+7DOPchJtSix71J4YscIu5XjLMZFaHPl+NuxvihaiQ6HJMq1ajS9Zhcq2XcCRmv1Cbujgpf5Whwx2SceifnqosqquinirTJqbnHMq66LRNz32USdWDGdS9mMndlJtSqEHVqBT/kiG8Foj7OuOjo0ibd0hvoTbpa5a7vwCZdnUR0g3qTrlZTl1jZpKtl6h71Jl2pYlepVxW0KrvN6qqCTsBd6MFVBZ0odad6VUGr3LUGFTvYKLAPRpU726hKr4xJhGPGBOybUU32GOXUmUSZOuQospEGlTtnEmMXnV4FladM3bV+FbSiqq67+ipoJYHoxvWroPr3qUuvvAoqz52696AuaqFOXX1Uk1vHdzBrN5M6/6h+vVqrgUBMcLBa1wYFMdHhup8GCFE9WLvTYCGoq1o808Ahqjx8IFUOIkIaNZSIr47WfpmGFVGVg4uYRAwxYgIeaES1MtyIidKgI8qHKzMPQIL4UCvLbVXgIUn99b8xwfk0GtkvzZ7jEARQ/L7NeRpsAE+L0ec4rABEK8rnYQABLKwdn+NQwVFx7v0HSs5n6ZslZZEd85re0WBOudbvaLCY85/e0WDOkcjvaLAQY5Le0SBO0SmYQ5RehZhOo1+FkCJF7MCrEDJFjp1+FUKKHMXKqxBSjfHUr0IokSIbNA4vvU4wnU69TiAkCmz1dQKh56Cq1wmExAGVrxMILQZTvU6QJQokKBxG3KA/nSdt0GdO0dMb9FnMcUsb9JlzxPIGfRZirNIGfeIUpYI5RGIf/HSi2j74ikxxO7gPvpImR7G2D74ic0yr++AreoxwbR+8linepHLYw+7x6YR593gSKMiV3eNJzYHNu8eTwMEUu8eTEgOYd4+zQEEzzuGyv+cA4XJG4XKBwuWCCperOVyuUbhc4HC5wuFyJYbLOYXLBAqXcQ7X9DV6CFYhFKqCKVAFqzAVLQepKBSigjlAhXN4Co/BKZRCM2EKzEQpLO+nkDx7YkclHIBKKACFMACHEAAt2QdkWQdm2QY2ZRlIya6j3fLWUz8qOQAUPxnlPH23YqT26SdH/DU9V/xLUM7KHBSQfZLR0Li3+OjIDm0pDph/FdcZfRXXBVyKA+xfxXUGX8V1CF/FdWhfxXXkX8U1Fqen76H6HR2/KIh+04kM23JPYJUMhy/NAoX1HExtn5p15J+adaaiYKs0p5a/3dLMfo44HsVp44hinXOe5pAjtTrnyGuWM/8QrrE+3msvwtrXQtjrOtOLOpM+PwuSqk7++Vlgour4Tm+vKbji4RndxKMc8rigARwrilOrEI4oj6B4VXEmCqMsR+xJE+y1yfbaZHttKvbaSHttsr02wl4bYa9Nstcm22sz2eu+u2jQXgGJr642ZK9A41dXG2GvoNBXVxu0V0Dxq6vNDJf2m1laz29maRG/Sd4KPK1rNrO0Rt/M8sJ8M8ur8c2Ml+CbWVp3b5KpNmCqnib+osu5pAX0Jhkq8LRU3rCfQuK4KN7M8kp4M8vL3w266f6DU80MF7qbWVrdbmZ5SbuZ4Tp2M0uL102yPeCyOPtcnHpBupnlVehmlpaem1lab27Q7xzlBd5mhqu6zSwt5TbJ7oCnRdtmllZqG2F3oNCabDPLC7HNjFdfd2RcWTXr8OVUR2jGI21n+ES3RZcEFJ/dtsklgaentC26JCB6HtsGlwQWnry26JKOxmesp3ZkvbCj2Ak7xz7YqXXBjrgHdsU7YGfW/zqy7teQu0mbXbLNLtlWXLKVLtlml2yFS7bCJdvkkm12yTa5ZJtcsg0u2WaXbLNLthWXbKVLttol2+ySrXDJVrhkO0tPBtsZjjnbWRpzjkiMOUeexpwjjWPOEdGYs53lMWcbrLfN1ttWrLeV1ttm622r1tsK622z9bbZettsva203nayXk+zydnbVLK3kdnb5Oyx9YIisrcR9WMTGwc+oJlMKT2gYU6Wqh/QsJjNNT2gYc42mx/QsBANNz2gIQ7Wm17PY65MWL2exxLZce31PJbZmNPreczJoguf55JmszZOjm1c1VkTc8U1iWqvca6oJnBtNUFXWTZ1f+4W2iU/jqPU4gRs9MbJ7Z0fiJDwfZey+ZtGPYBx7gZMqEWPO4TCFwJR12Bc9Q8m5k7CJOopjHN3YQL3GUXoc7649zB+qDREP2JSpb5WehSTa9WZ+xbjlWrLvUzhoqsp0ian5k7H+KGoiO7HpEpUKh2RybWopC7JhNjI+StwTxKl3kl+BS5Lqo+qfQUuq9RT6a/AZY37K/UVuKxQrwUSdFxIqe9CSXVfqOceDFXqxFDS/Rim4K4MNerNUKIODaS5rCXcraFEPRtKqlmgnlsGqtQ4UOIGgBq3AdSqzYC7u/AYP9iDeMCff6PPxF0fStT7BelwFEUfGNTcDaJMPSFK3BmidiDI3CWCtNCUOkaUVN+Ieu4eUaUeEiXuJFHjfhK0XmaZe0uUvlJ6os9Etd4GKj0npjjQSrj/RKneFLgXBUl0pKBu5G+4O0XpK2ETnSqq9bBVulZMcSBsqYNFLZjL4Asz/+bMeGTPDR3FjaaTUDrtK4HoHMbliabEeCJDdCLj8kRhD9hVjdMpoyjPC9G70pTOiZI8Y9k+dCUQncu4PJFt8bhSjE7lgjyX7X+4UozO5YI817Rl4CoTOk/B8izlQ2dXAtF5jKsTfURTODHkf/L8IzZzQPHhlHN8OOXUHk45kn/Z/GNovsDo75l/hOa6Jxe7jssGRLuj66Bdx9xPgs0C/ZcFXedU+hz2TqGfo6DrnKpyjmEMsFzO6SwGr1VKfab9iGb/J0guPy7LXyE5OskyabgKcGTEd8aEugUo3oYL/gj6tKD7cPQQjrwe7Y78z6SMR3HzyYjSJpMyOONMoBufEKLsVNyYVM5Y4fcZPWQE+Sxom/PAOTaes83v8h5FDNk2RNk2LrOdXvqcMlT4fUYPGUG28d1FygNnW767OElqy/OR0DAAsruTog6F3EpdcorifYU/VDiGB/m2kuEUqCDmaIlJz1FSIFKqCxeSjJIab055Bule0gdJITpAtzJ7HBmURFx8cpUCAxJGBjGHBjUdG0iRggPavcYPGmN8AG91PlOEUMsh4n3eRxFDaNJAjbkMSdowPmWw8PuMHjKCEBS0zXngrBvP2U5bh4+IQ8bzuDIJMut5G/KUKxPuBXsQDLJvbCsywwFwIUcg7QY+Ig4RyKPhJMgI5J3FU85MuBfsQTCIgLGtyAxHwIUUgU8p7zsyNJdlt17vlkKeGfw0K+9C744Wdi/jEQ1eP+XsfqIx2X4KepWuvyNdPLJlTUe23RNQ/obryHFlEyhu9nQcP+06IvqA68joA65xtiNmOtVZzlUOVPkpx6XgTiCKkHEKk3MRKxNzwFzKUTONQmec42cCBzEvBVxVlgKuDi4FmMqB1W+dTz/Kb51rgUJdeeu8ooqw1986ryTIRVB561yrXBy1t86lfFUVqIBIlcVUeYd6X1jXoRCuc+Svc7ivKzG+loG91tG8ziG8FnG7FsHasT4e5XvuKzfYyxvs852k/dSuiHv03dSO7MmKoW08yne9zXdXazAs0MkONpikilh9rcGkBLmIDzYYVjmohxsMyX1VOBgWWUnqn0zQCQ5mq1KLap9M0DLVrconE6S6rQoHA5PrYRlC7kdbt7hSMSGcxRcUTgpCWUl01Afb67PX9TWD68vQbn+Ul8z7tEjDXJ42LMbsUWXxuz+0+N1/ffG7zxP+PZeL4r2aUQtJXomnzXual8r7ylJ5f3CpvA8zrT2it0qv6gpdiWV5QUoE1xWr9n1t1b4/vGrfx0nUnpU/7nIlEJ3duDx5UeHceU2+r6zJ9wfX5HtsZ3tU+v/aum7USRzZsvt0V/T9/8vrQviTmb/EGPEQyfmd1uIlxTlX+nf2gRellZ5PanHdO6dYmz9FXC6otHJBqZU1d62KeW1M8WV+0VVis/vJ0/yTu3hSkcLrxhDe/VuPp3YUt7qMyCqgI7HrZeRpt8tI4y6XEdHelZF5j++svO3oJG5f2aGLWXlzZTyySbqjUkKIrGAAlpnLPtqrqVJ7AqvLjuKVunzxLl88Dr+A4zICUBhoAbYNDo58Y4Mzi6qzq3hUyhcQ1SETbH/HsdWf3UjsxMrChl+A4hvaziG3QO3NbEf8QXdX/H1tZ/ZNe0f2QrYhnxV5Wf8esuojoRUaAKA4xF7F5o5QGHVxMGx+aR8xc2qIeh8xi7lJpn3EzLlx5n3ELMRmmvYRE4cGa4gajnFqPc65/aZHeFPBFn6Zk3Jzxp3LjCr3x61b71xmMbdzuXOZNWrxeecyC9z2cajMiFygMlQmlf0AdxWfxEJnZ9C7ilnMHpF2FTPXbpF3FbNAvpF2FRNPDlKE33OYwEsMkaEYJ1dxztbiivIX/GL11PzSF6uZk7/oL1azmP0lfbGaOftL/mI1C9Ff0heriYO/GKL2a5zar3P2l/SsfCr2wi9zUvYX/EY2o8r9sb/ob2SzmP1FfiObNfKX/I1sFthfcOMAI/KXysYBUtlf8EPZJ7HQ2V/0h7JZzP6SPpTNXPtL/lA2C+Qv6UPZxJO/FOH3HCbwF0PkL8bJX5yzv7gi/SWs9KDLRIG9JqrsOFGVvhOTCPeJCdiDopqcKMrJj6JMrhRF9qb4jATKMArsA1FlNyA1eZZ+MFMqVFAvaz9LLpbWp7VwMCfJ1w6sT+skwuPq69M6BftdZX1ay8n70gMdLbAPHnqgI9MkT0wL4yeqyiV/PLAwrpMIr9QL41qt+GZlYVzL7KF6YVyq2U+D/Hst3OitUWCHjSr7LKnJbUkXnjstBo2vbe03DBixW4nY7DVi8RV509BQoxK/G2+YvgVv3L0z8mKakcaPwhf8WyYWVsIxXkHc/UG2/R+tLWT3l9hOQkx3f4LtLKSxv71GGAK0V+7BWvcvjdxjddujh5ToISfaQqL9Bzy2mGhCPNElzMnF9r2s4I/+/b//H63X5Vs=\"");

});

parcelRegister("6BRZ8", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("2f8qy", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("fReCA", function(module, exports) {
module.exports = JSON.parse("\"eJxtmNtu20YQhl+F4FULyMGeD7pz3AY1ChtG7NpFA18w1NomIlECSRcxgrx7SVk7+wOdG8H5OJydf2Z2d5gf9cV+t0v9VK/r+6vXsXlOlbHe28paq229qj/t++m62aXZ4J/m8PRb1z9/baZxefK63Z6eXN5dVMvTCh83u277xr/6kLrnl2XNq7TpXnczuZyabdee98/b2VzM/x4/dd/T5qab2pd6PQ2vaVVfvDRD005puE3Lu7eH1HbN9hTjx4/77/X6y5lcnUmjVzHIVVDicVX/1W/SsO36dLMfu6nb9/X6TAoBD+5euvZbn8axXtuZ36dhPJrVQqgPQoh5hev91LWLkIv94W1Ygq9+aX+tZAx2tfz64284/sblN/rqfLP/mqrbt3FKu7G67Nv9cNgPzZQ2H6rz7bb6vLgZq89pTMO/M/xfEqturJpqSM/d7GJIm2oamk3aNcO3av80O5xh3yyKmm1193ZIT02bqovTKjP+MAf++7zsZvZ3276kYyWWXB0z99S18/PbafPHQ71W4fjn/fxnFO+ZvkrT0LVzTr78qB/+nk38bHM9exgP8zr1z9U7jt6840YW5uSJKcZOCaBBnKgm5mU8MVNYyMwWFvO7Ukagkmgg6sDWQ5yFFqjzUrLEaQ3BEmiwNsMSaZS0vgWfOkPHWQowNeTUc0kumnxZvsgPxlGai6VTGUqAVCTQ6QkWnc77DKEiLktSUBJKqHIQZ86d8gCpHYoiEzMsb1ubYy8vW50DChB5ZhGqrijD0EqUIeiaEHIfCg5Kpuu0ApiToaGPSY0uaQsyr65L2oKi1yFt1PLaQ3lzfXTgXodGoJYzglndSLDMPg1sTPJpQJHJigw0QrGERqD9YhyTOgONQDUyuF1zaxuokc/BW2ztXCMrGZ9WMW1oQZHIXWNBkSCfRZEL5BMUiZw6CzVSFCfUSGZFNjIldoKDkonTKQiJIGzWmFd3BizJJ9SINoLDriOfUCOZS+zg+KGD1qGiLNMLxtJD1/ns00ON6EzyUCM6vbxhoBKaqbG3DFQCNiL1iHccBPV0DHhQH/JW8EW90dkyFKGywCJU0WkVSvSGeiSUODWFFD0HYdPQVoiRgfPMA+/nnRgiAyNYSjpWNQcNSMrtFCUH4ZIRpSCWocFCSuhCEY6hoUClc0WC52BJlCYYLQdhN+hygRRRlo5BKRRLS6oihSqh+ZzzRGG1Mo4Iz1LoP0qsxDGFzk0JE42ji0jCPejomJKCuwil4m5CiRMEUMVSzVLDUstSx1Juc0oVWMpqY295qVltmtWmWW2a1aZZbZrVplltmtWmWW2G1WZYbYbVZlhthtVmWG2G1WZYbYbVZlhtltVmWW2W1WZZbZbVZlltltVmWW2W1QYjQCh7E2aAQHeGhCFgPoNoy8KNb2wxBhmGKBxoUZXlLGsLI6AsftEDHV0wIURVbANLcTKlGGBIKPOAxCmhePCKUwFzAmpDFRQvjA9R06Hq8TONvshgKDCuRAZTXigUxjxNFfKRo3CLhnIJBMFRvMZpqpNBMlQJzGT5WFQMVQI/AikPMIhEU1aDjqJvQwmjSHB05cC9jbYwc5UtAHNLhDw41ha+lEqF4JaH3gmB61SYcqInxTDmQK8v08vjqv4zDf1N0w3Lf4A8/vwPpfK11w==\"");

});


parcelRegister("kErbs", function(module, exports) {

$parcel$export(module.exports, "Encodings", function () { return $f08ca13abba6886b$export$c85030bb86979d84; });
/* tslint:disable max-classes-per-file */ 
var $gLKUe = parcelRequire("gLKUe");

var $YfUub = parcelRequire("YfUub");
var $f08ca13abba6886b$var$decompressedEncodings = (0, $gLKUe.decompressJson)((0, (/*@__PURE__*/$parcel$interopDefault($YfUub))));
var $f08ca13abba6886b$var$allUnicodeMappings = JSON.parse($f08ca13abba6886b$var$decompressedEncodings);
var $f08ca13abba6886b$var$Encoding = /** @class */ function() {
    function Encoding(name, unicodeMappings) {
        var _this = this;
        this.canEncodeUnicodeCodePoint = function(codePoint) {
            return codePoint in _this.unicodeMappings;
        };
        this.encodeUnicodeCodePoint = function(codePoint) {
            var mapped = _this.unicodeMappings[codePoint];
            if (!mapped) {
                var str = String.fromCharCode(codePoint);
                var hexCode = "0x" + (0, $gLKUe.padStart)(codePoint.toString(16), 4, '0');
                var msg = _this.name + " cannot encode \"" + str + "\" (" + hexCode + ")";
                throw new Error(msg);
            }
            return {
                code: mapped[0],
                name: mapped[1]
            };
        };
        this.name = name;
        this.supportedCodePoints = Object.keys(unicodeMappings).map(Number).sort(function(a, b) {
            return a - b;
        });
        this.unicodeMappings = unicodeMappings;
    }
    return Encoding;
}();
var $f08ca13abba6886b$export$c85030bb86979d84 = {
    Symbol: new $f08ca13abba6886b$var$Encoding('Symbol', $f08ca13abba6886b$var$allUnicodeMappings.symbol),
    ZapfDingbats: new $f08ca13abba6886b$var$Encoding('ZapfDingbats', $f08ca13abba6886b$var$allUnicodeMappings.zapfdingbats),
    WinAnsi: new $f08ca13abba6886b$var$Encoding('WinAnsi', $f08ca13abba6886b$var$allUnicodeMappings.win1252)
};

});
parcelRegister("YfUub", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});




parcelRegister("8EKPA", function(module, exports) {

$parcel$export(module.exports, "assertIsOneOf", function () { return $64d662d8fd3f0e0f$export$8883a3014ee46cd1; });
$parcel$export(module.exports, "assertIsOneOfOrUndefined", function () { return $64d662d8fd3f0e0f$export$846079600c50354e; });
$parcel$export(module.exports, "assertIsSubset", function () { return $64d662d8fd3f0e0f$export$dce66947695c582f; });
$parcel$export(module.exports, "assertIs", function () { return $64d662d8fd3f0e0f$export$6fee1f82edcf4a03; });
$parcel$export(module.exports, "assertOrUndefined", function () { return $64d662d8fd3f0e0f$export$92143017cb173fb0; });
$parcel$export(module.exports, "assertEachIs", function () { return $64d662d8fd3f0e0f$export$47fbce961905bcd0; });
$parcel$export(module.exports, "assertRange", function () { return $64d662d8fd3f0e0f$export$6698b6d148bc9b0c; });
$parcel$export(module.exports, "assertRangeOrUndefined", function () { return $64d662d8fd3f0e0f$export$bce4080186be486; });
$parcel$export(module.exports, "assertMultiple", function () { return $64d662d8fd3f0e0f$export$c9f5acf8e31d1a2e; });
$parcel$export(module.exports, "assertInteger", function () { return $64d662d8fd3f0e0f$export$a59e49f1e2708383; });
$parcel$export(module.exports, "assertPositive", function () { return $64d662d8fd3f0e0f$export$2cad8b74f3cf13dd; });
/* tslint:disable:ban-types */ 
var $lxE62 = parcelRequire("lxE62");
var $64d662d8fd3f0e0f$export$c7ce26e85cccb3a8 = function(val) {
    return "`" + val + "`";
};
var $64d662d8fd3f0e0f$export$1909b7b8a28995a9 = function(val) {
    return "'" + val + "'";
};
// prettier-ignore
var $64d662d8fd3f0e0f$var$formatValue = function(value) {
    var type = typeof value;
    if (type === 'string') return $64d662d8fd3f0e0f$export$1909b7b8a28995a9(value);
    else if (type === 'undefined') return $64d662d8fd3f0e0f$export$c7ce26e85cccb3a8(value);
    else return value;
};
var $64d662d8fd3f0e0f$export$2ac73c5d250d45a9 = function(value, valueName, values) {
    var allowedValues = new Array(values.length);
    for(var idx = 0, len = values.length; idx < len; idx++){
        var v = values[idx];
        allowedValues[idx] = $64d662d8fd3f0e0f$var$formatValue(v);
    }
    var joinedValues = allowedValues.join(' or ');
    // prettier-ignore
    return $64d662d8fd3f0e0f$export$c7ce26e85cccb3a8(valueName) + " must be one of " + joinedValues + ", but was actually " + $64d662d8fd3f0e0f$var$formatValue(value);
};
var $64d662d8fd3f0e0f$export$8883a3014ee46cd1 = function(value, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $lxE62.values)(allowedValues);
    for(var idx = 0, len = allowedValues.length; idx < len; idx++){
        if (value === allowedValues[idx]) return;
    }
    throw new TypeError($64d662d8fd3f0e0f$export$2ac73c5d250d45a9(value, valueName, allowedValues));
};
var $64d662d8fd3f0e0f$export$846079600c50354e = function(value, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $lxE62.values)(allowedValues);
    $64d662d8fd3f0e0f$export$8883a3014ee46cd1(value, valueName, allowedValues.concat(undefined));
};
var $64d662d8fd3f0e0f$export$dce66947695c582f = function(values, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $lxE62.values)(allowedValues);
    for(var idx = 0, len = values.length; idx < len; idx++)$64d662d8fd3f0e0f$export$8883a3014ee46cd1(values[idx], valueName, allowedValues);
};
var $64d662d8fd3f0e0f$export$e2b5c5db9e2009fd = function(val) {
    if (val === null) return 'null';
    if (val === undefined) return 'undefined';
    if (typeof val === 'string') return 'string';
    if (isNaN(val)) return 'NaN';
    if (typeof val === 'number') return 'number';
    if (typeof val === 'boolean') return 'boolean';
    if (typeof val === 'symbol') return 'symbol';
    if (typeof val === 'bigint') return 'bigint';
    if (val.constructor && val.constructor.name) return val.constructor.name;
    if (val.name) return val.name;
    if (val.constructor) return String(val.constructor);
    return String(val);
};
var $64d662d8fd3f0e0f$export$26b9f946b448f23e = function(value, type) {
    if (type === 'null') return value === null;
    if (type === 'undefined') return value === undefined;
    if (type === 'string') return typeof value === 'string';
    if (type === 'number') return typeof value === 'number' && !isNaN(value);
    if (type === 'boolean') return typeof value === 'boolean';
    if (type === 'symbol') return typeof value === 'symbol';
    if (type === 'bigint') return typeof value === 'bigint';
    if (type === Date) return value instanceof Date;
    if (type === Array) return value instanceof Array;
    if (type === Uint8Array) return value instanceof Uint8Array;
    if (type === ArrayBuffer) return value instanceof ArrayBuffer;
    if (type === Function) return value instanceof Function;
    return value instanceof type[0];
};
var $64d662d8fd3f0e0f$export$6e3e1e6304e79984 = function(value, valueName, types) {
    var allowedTypes = new Array(types.length);
    for(var idx = 0, len = types.length; idx < len; idx++){
        var type = types[idx];
        if (type === 'null') allowedTypes[idx] = $64d662d8fd3f0e0f$export$c7ce26e85cccb3a8('null');
        if (type === 'undefined') allowedTypes[idx] = $64d662d8fd3f0e0f$export$c7ce26e85cccb3a8('undefined');
        if (type === 'string') allowedTypes[idx] = $64d662d8fd3f0e0f$export$c7ce26e85cccb3a8('string');
        else if (type === 'number') allowedTypes[idx] = $64d662d8fd3f0e0f$export$c7ce26e85cccb3a8('number');
        else if (type === 'boolean') allowedTypes[idx] = $64d662d8fd3f0e0f$export$c7ce26e85cccb3a8('boolean');
        else if (type === 'symbol') allowedTypes[idx] = $64d662d8fd3f0e0f$export$c7ce26e85cccb3a8('symbol');
        else if (type === 'bigint') allowedTypes[idx] = $64d662d8fd3f0e0f$export$c7ce26e85cccb3a8('bigint');
        else if (type === Array) allowedTypes[idx] = $64d662d8fd3f0e0f$export$c7ce26e85cccb3a8('Array');
        else if (type === Uint8Array) allowedTypes[idx] = $64d662d8fd3f0e0f$export$c7ce26e85cccb3a8('Uint8Array');
        else if (type === ArrayBuffer) allowedTypes[idx] = $64d662d8fd3f0e0f$export$c7ce26e85cccb3a8('ArrayBuffer');
        else allowedTypes[idx] = $64d662d8fd3f0e0f$export$c7ce26e85cccb3a8(type[1]);
    }
    var joinedTypes = allowedTypes.join(' or ');
    // prettier-ignore
    return $64d662d8fd3f0e0f$export$c7ce26e85cccb3a8(valueName) + " must be of type " + joinedTypes + ", but was actually of type " + $64d662d8fd3f0e0f$export$c7ce26e85cccb3a8($64d662d8fd3f0e0f$export$e2b5c5db9e2009fd(value));
};
var $64d662d8fd3f0e0f$export$6fee1f82edcf4a03 = function(value, valueName, types) {
    for(var idx = 0, len = types.length; idx < len; idx++){
        if ($64d662d8fd3f0e0f$export$26b9f946b448f23e(value, types[idx])) return;
    }
    throw new TypeError($64d662d8fd3f0e0f$export$6e3e1e6304e79984(value, valueName, types));
};
var $64d662d8fd3f0e0f$export$92143017cb173fb0 = function(value, valueName, types) {
    $64d662d8fd3f0e0f$export$6fee1f82edcf4a03(value, valueName, types.concat('undefined'));
};
var $64d662d8fd3f0e0f$export$47fbce961905bcd0 = function(values, valueName, types) {
    for(var idx = 0, len = values.length; idx < len; idx++)$64d662d8fd3f0e0f$export$6fee1f82edcf4a03(values[idx], valueName, types);
};
var $64d662d8fd3f0e0f$export$6698b6d148bc9b0c = function(value, valueName, min, max) {
    $64d662d8fd3f0e0f$export$6fee1f82edcf4a03(value, valueName, [
        'number'
    ]);
    $64d662d8fd3f0e0f$export$6fee1f82edcf4a03(min, 'min', [
        'number'
    ]);
    $64d662d8fd3f0e0f$export$6fee1f82edcf4a03(max, 'max', [
        'number'
    ]);
    max = Math.max(min, max);
    if (value < min || value > max) // prettier-ignore
    throw new Error($64d662d8fd3f0e0f$export$c7ce26e85cccb3a8(valueName) + " must be at least " + min + " and at most " + max + ", but was actually " + value);
};
var $64d662d8fd3f0e0f$export$bce4080186be486 = function(value, valueName, min, max) {
    $64d662d8fd3f0e0f$export$6fee1f82edcf4a03(value, valueName, [
        'number',
        'undefined'
    ]);
    if (typeof value === 'number') $64d662d8fd3f0e0f$export$6698b6d148bc9b0c(value, valueName, min, max);
};
var $64d662d8fd3f0e0f$export$c9f5acf8e31d1a2e = function(value, valueName, multiplier) {
    $64d662d8fd3f0e0f$export$6fee1f82edcf4a03(value, valueName, [
        'number'
    ]);
    if (value % multiplier !== 0) // prettier-ignore
    throw new Error($64d662d8fd3f0e0f$export$c7ce26e85cccb3a8(valueName) + " must be a multiple of " + multiplier + ", but was actually " + value);
};
var $64d662d8fd3f0e0f$export$a59e49f1e2708383 = function(value, valueName) {
    if (!Number.isInteger(value)) throw new Error($64d662d8fd3f0e0f$export$c7ce26e85cccb3a8(valueName) + " must be an integer, but was actually " + value);
};
var $64d662d8fd3f0e0f$export$2cad8b74f3cf13dd = function(value, valueName) {
    if (![
        1,
        0
    ].includes(Math.sign(value))) // prettier-ignore
    throw new Error($64d662d8fd3f0e0f$export$c7ce26e85cccb3a8(valueName) + " must be a positive number or 0, but was actually " + value);
};

});

parcelRegister("kUYxV", function(module, exports) {

$parcel$export(module.exports, "pdfDocEncodingDecode", function () { return $f3a800cc42fe71cc$export$ea426b9c784ba215; });

var $8hWZH = parcelRequire("8hWZH");
// Mapping from PDFDocEncoding to Unicode code point
var $f3a800cc42fe71cc$var$pdfDocEncodingToUnicode = new Uint16Array(256);
// Initialize the code points which are the same
for(var $f3a800cc42fe71cc$var$idx = 0; $f3a800cc42fe71cc$var$idx < 256; $f3a800cc42fe71cc$var$idx++)$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[$f3a800cc42fe71cc$var$idx] = $f3a800cc42fe71cc$var$idx;
// Set differences (see "Table D.2 – PDFDocEncoding Character Set" of the PDF spec)
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x16] = (0, $8hWZH.toCharCode)('\u0017'); // SYNCRONOUS IDLE
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x18] = (0, $8hWZH.toCharCode)('\u02D8'); // BREVE
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x19] = (0, $8hWZH.toCharCode)('\u02C7'); // CARON
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x1a] = (0, $8hWZH.toCharCode)('\u02C6'); // MODIFIER LETTER CIRCUMFLEX ACCENT
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x1b] = (0, $8hWZH.toCharCode)('\u02D9'); // DOT ABOVE
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x1c] = (0, $8hWZH.toCharCode)('\u02DD'); // DOUBLE ACUTE ACCENT
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x1d] = (0, $8hWZH.toCharCode)('\u02DB'); // OGONEK
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x1e] = (0, $8hWZH.toCharCode)('\u02DA'); // RING ABOVE
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x1f] = (0, $8hWZH.toCharCode)('\u02DC'); // SMALL TILDE
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x7f] = (0, $8hWZH.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x80] = (0, $8hWZH.toCharCode)('\u2022'); // BULLET
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x81] = (0, $8hWZH.toCharCode)('\u2020'); // DAGGER
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x82] = (0, $8hWZH.toCharCode)('\u2021'); // DOUBLE DAGGER
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x83] = (0, $8hWZH.toCharCode)('\u2026'); // HORIZONTAL ELLIPSIS
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x84] = (0, $8hWZH.toCharCode)('\u2014'); // EM DASH
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x85] = (0, $8hWZH.toCharCode)('\u2013'); // EN DASH
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x86] = (0, $8hWZH.toCharCode)('\u0192'); // LATIN SMALL LETTER SCRIPT F
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x87] = (0, $8hWZH.toCharCode)('\u2044'); // FRACTION SLASH (solidus)
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x88] = (0, $8hWZH.toCharCode)('\u2039'); // SINGLE LEFT-POINTING ANGLE QUOTATION MARK
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x89] = (0, $8hWZH.toCharCode)('\u203A'); // SINGLE RIGHT-POINTING ANGLE QUOTATION MARK
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x8a] = (0, $8hWZH.toCharCode)('\u2212'); // MINUS SIGN
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x8b] = (0, $8hWZH.toCharCode)('\u2030'); // PER MILLE SIGN
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x8c] = (0, $8hWZH.toCharCode)('\u201E'); // DOUBLE LOW-9 QUOTATION MARK (quotedblbase)
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x8d] = (0, $8hWZH.toCharCode)('\u201C'); // LEFT DOUBLE QUOTATION MARK (quotedblleft)
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x8e] = (0, $8hWZH.toCharCode)('\u201D'); // RIGHT DOUBLE QUOTATION MARK (quotedblright)
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x8f] = (0, $8hWZH.toCharCode)('\u2018'); // LEFT SINGLE QUOTATION MARK (quoteleft)
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x90] = (0, $8hWZH.toCharCode)('\u2019'); // RIGHT SINGLE QUOTATION MARK (quoteright)
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x91] = (0, $8hWZH.toCharCode)('\u201A'); // SINGLE LOW-9 QUOTATION MARK (quotesinglbase)
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x92] = (0, $8hWZH.toCharCode)('\u2122'); // TRADE MARK SIGN
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x93] = (0, $8hWZH.toCharCode)('\uFB01'); // LATIN SMALL LIGATURE FI
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x94] = (0, $8hWZH.toCharCode)('\uFB02'); // LATIN SMALL LIGATURE FL
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x95] = (0, $8hWZH.toCharCode)('\u0141'); // LATIN CAPITAL LETTER L WITH STROKE
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x96] = (0, $8hWZH.toCharCode)('\u0152'); // LATIN CAPITAL LIGATURE OE
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x97] = (0, $8hWZH.toCharCode)('\u0160'); // LATIN CAPITAL LETTER S WITH CARON
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x98] = (0, $8hWZH.toCharCode)('\u0178'); // LATIN CAPITAL LETTER Y WITH DIAERESIS
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x99] = (0, $8hWZH.toCharCode)('\u017D'); // LATIN CAPITAL LETTER Z WITH CARON
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x9a] = (0, $8hWZH.toCharCode)('\u0131'); // LATIN SMALL LETTER DOTLESS I
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x9b] = (0, $8hWZH.toCharCode)('\u0142'); // LATIN SMALL LETTER L WITH STROKE
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x9c] = (0, $8hWZH.toCharCode)('\u0153'); // LATIN SMALL LIGATURE OE
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x9d] = (0, $8hWZH.toCharCode)('\u0161'); // LATIN SMALL LETTER S WITH CARON
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x9e] = (0, $8hWZH.toCharCode)('\u017E'); // LATIN SMALL LETTER Z WITH CARON
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0x9f] = (0, $8hWZH.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0xa0] = (0, $8hWZH.toCharCode)('\u20AC'); // EURO SIGN
$f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[0xad] = (0, $8hWZH.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
var $f3a800cc42fe71cc$export$ea426b9c784ba215 = function(bytes) {
    var codePoints = new Array(bytes.length);
    for(var idx = 0, len = bytes.length; idx < len; idx++)codePoints[idx] = $f3a800cc42fe71cc$var$pdfDocEncodingToUnicode[bytes[idx]];
    return String.fromCodePoint.apply(String, codePoints);
};

});

parcelRegister("hGYOY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce1589bc263c4d43$export$2e2bcd8739ae039; });
var $ce1589bc263c4d43$var$Cache = /** @class */ function() {
    function Cache(populate) {
        this.populate = populate;
        this.value = undefined;
    }
    Cache.prototype.getValue = function() {
        return this.value;
    };
    Cache.prototype.access = function() {
        if (!this.value) this.value = this.populate();
        return this.value;
    };
    Cache.prototype.invalidate = function() {
        this.value = undefined;
    };
    Cache.populatedBy = function(populate) {
        return new Cache(populate);
    };
    return Cache;
}();
var $ce1589bc263c4d43$export$2e2bcd8739ae039 = $ce1589bc263c4d43$var$Cache;

});


parcelRegister("eKLLF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abda6a4397288a28$export$2e2bcd8739ae039; });

var $iMObG = parcelRequire("iMObG");
var $abda6a4397288a28$var$PDFObject = /** @class */ function() {
    function PDFObject() {}
    PDFObject.prototype.clone = function(_context) {
        throw new (0, $iMObG.MethodNotImplementedError)(this.constructor.name, 'clone');
    };
    PDFObject.prototype.toString = function() {
        throw new (0, $iMObG.MethodNotImplementedError)(this.constructor.name, 'toString');
    };
    PDFObject.prototype.sizeInBytes = function() {
        throw new (0, $iMObG.MethodNotImplementedError)(this.constructor.name, 'sizeInBytes');
    };
    PDFObject.prototype.copyBytesInto = function(_buffer, _offset) {
        throw new (0, $iMObG.MethodNotImplementedError)(this.constructor.name, 'copyBytesInto');
    };
    return PDFObject;
}();
var $abda6a4397288a28$export$2e2bcd8739ae039 = $abda6a4397288a28$var$PDFObject;

});
parcelRegister("iMObG", function(module, exports) {

$parcel$export(module.exports, "MethodNotImplementedError", function () { return $dad3a3e003f446df$export$b549a6777be1bc17; });
$parcel$export(module.exports, "PrivateConstructorError", function () { return $dad3a3e003f446df$export$20e18464cd4b43a; });
$parcel$export(module.exports, "UnexpectedObjectTypeError", function () { return $dad3a3e003f446df$export$ab03f98a62c22159; });
$parcel$export(module.exports, "UnsupportedEncodingError", function () { return $dad3a3e003f446df$export$5de8fe8a6031fb92; });
$parcel$export(module.exports, "ReparseError", function () { return $dad3a3e003f446df$export$df523155c7c35e23; });
$parcel$export(module.exports, "MissingPageContentsEmbeddingError", function () { return $dad3a3e003f446df$export$48e9be38307e3c37; });
$parcel$export(module.exports, "UnrecognizedStreamTypeError", function () { return $dad3a3e003f446df$export$f8343077e7fd3a86; });
$parcel$export(module.exports, "PageEmbeddingMismatchedContextError", function () { return $dad3a3e003f446df$export$22c55e00f6509a2c; });
$parcel$export(module.exports, "PDFArrayIsNotRectangleError", function () { return $dad3a3e003f446df$export$a76bae7761f3d760; });
$parcel$export(module.exports, "InvalidPDFDateStringError", function () { return $dad3a3e003f446df$export$8638e3ad1edceac8; });
$parcel$export(module.exports, "InvalidTargetIndexError", function () { return $dad3a3e003f446df$export$845c01ec1ddb8877; });
$parcel$export(module.exports, "CorruptPageTreeError", function () { return $dad3a3e003f446df$export$1012d63cae1523f8; });
$parcel$export(module.exports, "IndexOutOfBoundsError", function () { return $dad3a3e003f446df$export$19a77d83c7473130; });
$parcel$export(module.exports, "InvalidAcroFieldValueError", function () { return $dad3a3e003f446df$export$d39c49ea9be644ec; });
$parcel$export(module.exports, "MultiSelectValueError", function () { return $dad3a3e003f446df$export$6606fe23b6c4542c; });
$parcel$export(module.exports, "MissingDAEntryError", function () { return $dad3a3e003f446df$export$dfa101de065b3cc2; });
$parcel$export(module.exports, "MissingTfOperatorError", function () { return $dad3a3e003f446df$export$b5ee390f1267b133; });
$parcel$export(module.exports, "NumberParsingError", function () { return $dad3a3e003f446df$export$81adf4c464255546; });
$parcel$export(module.exports, "NextByteAssertionError", function () { return $dad3a3e003f446df$export$fda6cb3cf0fe0c76; });
$parcel$export(module.exports, "PDFObjectParsingError", function () { return $dad3a3e003f446df$export$b8907968b8d7f502; });
$parcel$export(module.exports, "PDFInvalidObjectParsingError", function () { return $dad3a3e003f446df$export$72474f06fb3a1c6b; });
$parcel$export(module.exports, "PDFStreamParsingError", function () { return $dad3a3e003f446df$export$b1a91b84397f50d6; });
$parcel$export(module.exports, "UnbalancedParenthesisError", function () { return $dad3a3e003f446df$export$92803ff0e03167f9; });
$parcel$export(module.exports, "StalledParserError", function () { return $dad3a3e003f446df$export$b934c61834236c8; });
$parcel$export(module.exports, "MissingPDFHeaderError", function () { return $dad3a3e003f446df$export$cf6bd1b11dd05d74; });
$parcel$export(module.exports, "MissingKeywordError", function () { return $dad3a3e003f446df$export$bc024c15c94be864; });

var $273XO = parcelRequire("273XO");
parcelRequire("5bpFt");
var $a9yd5 = parcelRequire("a9yd5");
var $dad3a3e003f446df$export$b549a6777be1bc17 = /** @class */ function(_super) {
    (0, $273XO.__extends)(MethodNotImplementedError, _super);
    function MethodNotImplementedError(className, methodName) {
        var _this = this;
        var msg = "Method " + className + "." + methodName + "() not implemented";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MethodNotImplementedError;
}(Error);
var $dad3a3e003f446df$export$20e18464cd4b43a = /** @class */ function(_super) {
    (0, $273XO.__extends)(PrivateConstructorError, _super);
    function PrivateConstructorError(className) {
        var _this = this;
        var msg = "Cannot construct " + className + " - it has a private constructor";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PrivateConstructorError;
}(Error);
var $dad3a3e003f446df$export$ab03f98a62c22159 = /** @class */ function(_super) {
    (0, $273XO.__extends)(UnexpectedObjectTypeError, _super);
    function UnexpectedObjectTypeError(expected, actual) {
        var _this = this;
        var name = function(t) {
            var _a, _b;
            return (_a = t === null || t === void 0 ? void 0 : t.name) !== null && _a !== void 0 ? _a : (_b = t === null || t === void 0 ? void 0 : t.constructor) === null || _b === void 0 ? void 0 : _b.name;
        };
        var expectedTypes = Array.isArray(expected) ? expected.map(name) : [
            name(expected)
        ];
        var msg = "Expected instance of " + expectedTypes.join(' or ') + ", " + ("but got instance of " + (actual ? name(actual) : actual));
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnexpectedObjectTypeError;
}(Error);
var $dad3a3e003f446df$export$5de8fe8a6031fb92 = /** @class */ function(_super) {
    (0, $273XO.__extends)(UnsupportedEncodingError, _super);
    function UnsupportedEncodingError(encoding) {
        var _this = this;
        var msg = encoding + " stream encoding not supported";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnsupportedEncodingError;
}(Error);
var $dad3a3e003f446df$export$df523155c7c35e23 = /** @class */ function(_super) {
    (0, $273XO.__extends)(ReparseError, _super);
    function ReparseError(className, methodName) {
        var _this = this;
        var msg = "Cannot call " + className + "." + methodName + "() more than once";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ReparseError;
}(Error);
var $dad3a3e003f446df$export$3afc9350d4666214 = /** @class */ function(_super) {
    (0, $273XO.__extends)(MissingCatalogError, _super);
    function MissingCatalogError(ref) {
        var _this = this;
        var msg = "Missing catalog (ref=" + ref + ")";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingCatalogError;
}(Error);
var $dad3a3e003f446df$export$48e9be38307e3c37 = /** @class */ function(_super) {
    (0, $273XO.__extends)(MissingPageContentsEmbeddingError, _super);
    function MissingPageContentsEmbeddingError() {
        var _this = this;
        var msg = "Can't embed page with missing Contents";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingPageContentsEmbeddingError;
}(Error);
var $dad3a3e003f446df$export$f8343077e7fd3a86 = /** @class */ function(_super) {
    (0, $273XO.__extends)(UnrecognizedStreamTypeError, _super);
    function UnrecognizedStreamTypeError(stream) {
        var _a, _b, _c;
        var _this = this;
        var streamType = (_c = (_b = (_a = stream === null || stream === void 0 ? void 0 : stream.contructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : stream === null || stream === void 0 ? void 0 : stream.name) !== null && _c !== void 0 ? _c : stream;
        var msg = "Unrecognized stream type: " + streamType;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnrecognizedStreamTypeError;
}(Error);
var $dad3a3e003f446df$export$22c55e00f6509a2c = /** @class */ function(_super) {
    (0, $273XO.__extends)(PageEmbeddingMismatchedContextError, _super);
    function PageEmbeddingMismatchedContextError() {
        var _this = this;
        var msg = "Found mismatched contexts while embedding pages. All pages in the array passed to `PDFDocument.embedPages()` must be from the same document.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PageEmbeddingMismatchedContextError;
}(Error);
var $dad3a3e003f446df$export$a76bae7761f3d760 = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFArrayIsNotRectangleError, _super);
    function PDFArrayIsNotRectangleError(size) {
        var _this = this;
        var msg = "Attempted to convert PDFArray with " + size + " elements to rectangle, but must have exactly 4 elements.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PDFArrayIsNotRectangleError;
}(Error);
var $dad3a3e003f446df$export$8638e3ad1edceac8 = /** @class */ function(_super) {
    (0, $273XO.__extends)(InvalidPDFDateStringError, _super);
    function InvalidPDFDateStringError(value) {
        var _this = this;
        var msg = "Attempted to convert \"" + value + "\" to a date, but it does not match the PDF date string format.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidPDFDateStringError;
}(Error);
var $dad3a3e003f446df$export$845c01ec1ddb8877 = /** @class */ function(_super) {
    (0, $273XO.__extends)(InvalidTargetIndexError, _super);
    function InvalidTargetIndexError(targetIndex, Count) {
        var _this = this;
        var msg = "Invalid targetIndex specified: targetIndex=" + targetIndex + " must be less than Count=" + Count;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidTargetIndexError;
}(Error);
var $dad3a3e003f446df$export$1012d63cae1523f8 = /** @class */ function(_super) {
    (0, $273XO.__extends)(CorruptPageTreeError, _super);
    function CorruptPageTreeError(targetIndex, operation) {
        var _this = this;
        var msg = "Failed to " + operation + " at targetIndex=" + targetIndex + " due to corrupt page tree: It is likely that one or more 'Count' entries are invalid";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return CorruptPageTreeError;
}(Error);
var $dad3a3e003f446df$export$19a77d83c7473130 = /** @class */ function(_super) {
    (0, $273XO.__extends)(IndexOutOfBoundsError, _super);
    function IndexOutOfBoundsError(index, min, max) {
        var _this = this;
        var msg = "index should be at least " + min + " and at most " + max + ", but was actually " + index;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return IndexOutOfBoundsError;
}(Error);
var $dad3a3e003f446df$export$d39c49ea9be644ec = /** @class */ function(_super) {
    (0, $273XO.__extends)(InvalidAcroFieldValueError, _super);
    function InvalidAcroFieldValueError() {
        var _this = this;
        var msg = "Attempted to set invalid field value";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidAcroFieldValueError;
}(Error);
var $dad3a3e003f446df$export$6606fe23b6c4542c = /** @class */ function(_super) {
    (0, $273XO.__extends)(MultiSelectValueError, _super);
    function MultiSelectValueError() {
        var _this = this;
        var msg = "Attempted to select multiple values for single-select field";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MultiSelectValueError;
}(Error);
var $dad3a3e003f446df$export$dfa101de065b3cc2 = /** @class */ function(_super) {
    (0, $273XO.__extends)(MissingDAEntryError, _super);
    function MissingDAEntryError(fieldName) {
        var _this = this;
        var msg = "No /DA (default appearance) entry found for field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingDAEntryError;
}(Error);
var $dad3a3e003f446df$export$b5ee390f1267b133 = /** @class */ function(_super) {
    (0, $273XO.__extends)(MissingTfOperatorError, _super);
    function MissingTfOperatorError(fieldName) {
        var _this = this;
        var msg = "No Tf operator found for DA of field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingTfOperatorError;
}(Error);
var $dad3a3e003f446df$export$81adf4c464255546 = /** @class */ function(_super) {
    (0, $273XO.__extends)(NumberParsingError, _super);
    function NumberParsingError(pos, value) {
        var _this = this;
        var msg = "Failed to parse number " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + "): \"" + value + "\"");
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return NumberParsingError;
}(Error);
var $dad3a3e003f446df$export$fd202455a19cb700 = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFParsingError, _super);
    function PDFParsingError(pos, details) {
        var _this = this;
        var msg = "Failed to parse PDF document " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + "): " + details);
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PDFParsingError;
}(Error);
var $dad3a3e003f446df$export$fda6cb3cf0fe0c76 = /** @class */ function(_super) {
    (0, $273XO.__extends)(NextByteAssertionError, _super);
    function NextByteAssertionError(pos, expectedByte, actualByte) {
        var _this = this;
        var msg = "Expected next byte to be " + expectedByte + " but it was actually " + actualByte;
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return NextByteAssertionError;
}($dad3a3e003f446df$export$fd202455a19cb700);
var $dad3a3e003f446df$export$b8907968b8d7f502 = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFObjectParsingError, _super);
    function PDFObjectParsingError(pos, byte) {
        var _this = this;
        var msg = "Failed to parse PDF object starting with the following byte: " + byte;
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFObjectParsingError;
}($dad3a3e003f446df$export$fd202455a19cb700);
var $dad3a3e003f446df$export$72474f06fb3a1c6b = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFInvalidObjectParsingError, _super);
    function PDFInvalidObjectParsingError(pos) {
        var _this = this;
        var msg = "Failed to parse invalid PDF object";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFInvalidObjectParsingError;
}($dad3a3e003f446df$export$fd202455a19cb700);
var $dad3a3e003f446df$export$b1a91b84397f50d6 = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFStreamParsingError, _super);
    function PDFStreamParsingError(pos) {
        var _this = this;
        var msg = "Failed to parse PDF stream";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFStreamParsingError;
}($dad3a3e003f446df$export$fd202455a19cb700);
var $dad3a3e003f446df$export$92803ff0e03167f9 = /** @class */ function(_super) {
    (0, $273XO.__extends)(UnbalancedParenthesisError, _super);
    function UnbalancedParenthesisError(pos) {
        var _this = this;
        var msg = "Failed to parse PDF literal string due to unbalanced parenthesis";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return UnbalancedParenthesisError;
}($dad3a3e003f446df$export$fd202455a19cb700);
var $dad3a3e003f446df$export$b934c61834236c8 = /** @class */ function(_super) {
    (0, $273XO.__extends)(StalledParserError, _super);
    function StalledParserError(pos) {
        var _this = this;
        var msg = "Parser stalled";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return StalledParserError;
}($dad3a3e003f446df$export$fd202455a19cb700);
var $dad3a3e003f446df$export$cf6bd1b11dd05d74 = /** @class */ function(_super) {
    (0, $273XO.__extends)(MissingPDFHeaderError, _super);
    function MissingPDFHeaderError(pos) {
        var _this = this;
        var msg = "No PDF header found";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return MissingPDFHeaderError;
}($dad3a3e003f446df$export$fd202455a19cb700);
var $dad3a3e003f446df$export$bc024c15c94be864 = /** @class */ function(_super) {
    (0, $273XO.__extends)(MissingKeywordError, _super);
    function MissingKeywordError(pos, keyword) {
        var _this = this;
        var msg = "Did not find expected keyword '" + (0, $a9yd5.arrayAsString)(keyword) + "'";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return MissingKeywordError;
}($dad3a3e003f446df$export$fd202455a19cb700);

});



parcelRegister("8KH3B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65f404dab6ecee35$export$2e2bcd8739ae039; });
var $65f404dab6ecee35$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Null"] = 0] = "Null";
    CharCodes[CharCodes["Backspace"] = 8] = "Backspace";
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["Newline"] = 10] = "Newline";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationPoint"] = 33] = "ExclamationPoint";
    CharCodes[CharCodes["Hash"] = 35] = "Hash";
    CharCodes[CharCodes["Percent"] = 37] = "Percent";
    CharCodes[CharCodes["LeftParen"] = 40] = "LeftParen";
    CharCodes[CharCodes["RightParen"] = 41] = "RightParen";
    CharCodes[CharCodes["Plus"] = 43] = "Plus";
    CharCodes[CharCodes["Minus"] = 45] = "Minus";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Period"] = 46] = "Period";
    CharCodes[CharCodes["ForwardSlash"] = 47] = "ForwardSlash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["One"] = 49] = "One";
    CharCodes[CharCodes["Two"] = 50] = "Two";
    CharCodes[CharCodes["Three"] = 51] = "Three";
    CharCodes[CharCodes["Four"] = 52] = "Four";
    CharCodes[CharCodes["Five"] = 53] = "Five";
    CharCodes[CharCodes["Six"] = 54] = "Six";
    CharCodes[CharCodes["Seven"] = 55] = "Seven";
    CharCodes[CharCodes["Eight"] = 56] = "Eight";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["LessThan"] = 60] = "LessThan";
    CharCodes[CharCodes["GreaterThan"] = 62] = "GreaterThan";
    CharCodes[CharCodes["A"] = 65] = "A";
    CharCodes[CharCodes["D"] = 68] = "D";
    CharCodes[CharCodes["E"] = 69] = "E";
    CharCodes[CharCodes["F"] = 70] = "F";
    CharCodes[CharCodes["O"] = 79] = "O";
    CharCodes[CharCodes["P"] = 80] = "P";
    CharCodes[CharCodes["R"] = 82] = "R";
    CharCodes[CharCodes["LeftSquareBracket"] = 91] = "LeftSquareBracket";
    CharCodes[CharCodes["BackSlash"] = 92] = "BackSlash";
    CharCodes[CharCodes["RightSquareBracket"] = 93] = "RightSquareBracket";
    CharCodes[CharCodes["a"] = 97] = "a";
    CharCodes[CharCodes["b"] = 98] = "b";
    CharCodes[CharCodes["d"] = 100] = "d";
    CharCodes[CharCodes["e"] = 101] = "e";
    CharCodes[CharCodes["f"] = 102] = "f";
    CharCodes[CharCodes["i"] = 105] = "i";
    CharCodes[CharCodes["j"] = 106] = "j";
    CharCodes[CharCodes["l"] = 108] = "l";
    CharCodes[CharCodes["m"] = 109] = "m";
    CharCodes[CharCodes["n"] = 110] = "n";
    CharCodes[CharCodes["o"] = 111] = "o";
    CharCodes[CharCodes["r"] = 114] = "r";
    CharCodes[CharCodes["s"] = 115] = "s";
    CharCodes[CharCodes["t"] = 116] = "t";
    CharCodes[CharCodes["u"] = 117] = "u";
    CharCodes[CharCodes["x"] = 120] = "x";
    CharCodes[CharCodes["LeftCurly"] = 123] = "LeftCurly";
    CharCodes[CharCodes["RightCurly"] = 125] = "RightCurly";
    CharCodes[CharCodes["Tilde"] = 126] = "Tilde";
})($65f404dab6ecee35$var$CharCodes || ($65f404dab6ecee35$var$CharCodes = {}));
var $65f404dab6ecee35$export$2e2bcd8739ae039 = $65f404dab6ecee35$var$CharCodes;

});


parcelRegister("63sxC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4689299ba38986eb$export$2e2bcd8739ae039; });

var $273XO = parcelRequire("273XO");

var $iMObG = parcelRequire("iMObG");

var $eKLLF = parcelRequire("eKLLF");

var $8KH3B = parcelRequire("8KH3B");
var $4689299ba38986eb$var$ENFORCER = {};
var $4689299ba38986eb$var$PDFBool = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFBool, _super);
    function PDFBool(enforcer, value) {
        var _this = this;
        if (enforcer !== $4689299ba38986eb$var$ENFORCER) throw new (0, $iMObG.PrivateConstructorError)('PDFBool');
        _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFBool.prototype.asBoolean = function() {
        return this.value;
    };
    PDFBool.prototype.clone = function() {
        return this;
    };
    PDFBool.prototype.toString = function() {
        return String(this.value);
    };
    PDFBool.prototype.sizeInBytes = function() {
        return this.value ? 4 : 5;
    };
    PDFBool.prototype.copyBytesInto = function(buffer, offset) {
        if (this.value) {
            buffer[offset++] = (0, $8KH3B.default).t;
            buffer[offset++] = (0, $8KH3B.default).r;
            buffer[offset++] = (0, $8KH3B.default).u;
            buffer[offset++] = (0, $8KH3B.default).e;
            return 4;
        } else {
            buffer[offset++] = (0, $8KH3B.default).f;
            buffer[offset++] = (0, $8KH3B.default).a;
            buffer[offset++] = (0, $8KH3B.default).l;
            buffer[offset++] = (0, $8KH3B.default).s;
            buffer[offset++] = (0, $8KH3B.default).e;
            return 5;
        }
    };
    PDFBool.True = new PDFBool($4689299ba38986eb$var$ENFORCER, true);
    PDFBool.False = new PDFBool($4689299ba38986eb$var$ENFORCER, false);
    return PDFBool;
}((0, $eKLLF.default));
var $4689299ba38986eb$export$2e2bcd8739ae039 = $4689299ba38986eb$var$PDFBool;

});

parcelRegister("alPcq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $789394af60e07388$export$2e2bcd8739ae039; });

var $273XO = parcelRequire("273XO");

var $iMObG = parcelRequire("iMObG");

var $eKLLF = parcelRequire("eKLLF");

var $8KH3B = parcelRequire("8KH3B");

var $gR9D3 = parcelRequire("gR9D3");
parcelRequire("5bpFt");
var $8hWZH = parcelRequire("8hWZH");
var $789394af60e07388$var$decodeName = function(name) {
    return name.replace(/#([\dABCDEF]{2})/g, function(_, hex) {
        return (0, $8hWZH.charFromHexCode)(hex);
    });
};
var $789394af60e07388$var$isRegularChar = function(charCode) {
    return charCode >= (0, $8KH3B.default).ExclamationPoint && charCode <= (0, $8KH3B.default).Tilde && !(0, $gR9D3.IsIrregular)[charCode];
};
var $789394af60e07388$var$ENFORCER = {};
var $789394af60e07388$var$pool = new Map();
var $789394af60e07388$var$PDFName = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFName, _super);
    function PDFName(enforcer, name) {
        var _this = this;
        if (enforcer !== $789394af60e07388$var$ENFORCER) throw new (0, $iMObG.PrivateConstructorError)('PDFName');
        _this = _super.call(this) || this;
        var encodedName = '/';
        for(var idx = 0, len = name.length; idx < len; idx++){
            var character = name[idx];
            var code = (0, $8hWZH.toCharCode)(character);
            encodedName += $789394af60e07388$var$isRegularChar(code) ? character : "#" + (0, $8hWZH.toHexString)(code);
        }
        _this.encodedName = encodedName;
        return _this;
    }
    PDFName.prototype.asBytes = function() {
        var bytes = [];
        var hex = '';
        var escaped = false;
        var pushByte = function(byte) {
            if (byte !== undefined) bytes.push(byte);
            escaped = false;
        };
        for(var idx = 1, len = this.encodedName.length; idx < len; idx++){
            var char = this.encodedName[idx];
            var byte = (0, $8hWZH.toCharCode)(char);
            var nextChar = this.encodedName[idx + 1];
            if (!escaped) {
                if (byte === (0, $8KH3B.default).Hash) escaped = true;
                else pushByte(byte);
            } else if (byte >= (0, $8KH3B.default).Zero && byte <= (0, $8KH3B.default).Nine || byte >= (0, $8KH3B.default).a && byte <= (0, $8KH3B.default).f || byte >= (0, $8KH3B.default).A && byte <= (0, $8KH3B.default).F) {
                hex += char;
                if (hex.length === 2 || !(nextChar >= '0' && nextChar <= '9' || nextChar >= 'a' && nextChar <= 'f' || nextChar >= 'A' && nextChar <= 'F')) {
                    pushByte(parseInt(hex, 16));
                    hex = '';
                }
            } else pushByte(byte);
        }
        return new Uint8Array(bytes);
    };
    // TODO: This should probably use `utf8Decode()`
    // TODO: Polyfill Array.from?
    PDFName.prototype.decodeText = function() {
        var bytes = this.asBytes();
        return String.fromCharCode.apply(String, Array.from(bytes));
    };
    PDFName.prototype.asString = function() {
        return this.encodedName;
    };
    /** @deprecated in favor of [[PDFName.asString]] */ PDFName.prototype.value = function() {
        return this.encodedName;
    };
    PDFName.prototype.clone = function() {
        return this;
    };
    PDFName.prototype.toString = function() {
        return this.encodedName;
    };
    PDFName.prototype.sizeInBytes = function() {
        return this.encodedName.length;
    };
    PDFName.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $8hWZH.copyStringIntoBuffer)(this.encodedName, buffer, offset);
        return this.encodedName.length;
    };
    PDFName.of = function(name) {
        var decodedValue = $789394af60e07388$var$decodeName(name);
        var instance = $789394af60e07388$var$pool.get(decodedValue);
        if (!instance) {
            instance = new PDFName($789394af60e07388$var$ENFORCER, decodedValue);
            $789394af60e07388$var$pool.set(decodedValue, instance);
        }
        return instance;
    };
    /* tslint:disable member-ordering */ PDFName.Length = PDFName.of('Length');
    PDFName.FlateDecode = PDFName.of('FlateDecode');
    PDFName.Resources = PDFName.of('Resources');
    PDFName.Font = PDFName.of('Font');
    PDFName.XObject = PDFName.of('XObject');
    PDFName.ExtGState = PDFName.of('ExtGState');
    PDFName.Contents = PDFName.of('Contents');
    PDFName.Type = PDFName.of('Type');
    PDFName.Parent = PDFName.of('Parent');
    PDFName.MediaBox = PDFName.of('MediaBox');
    PDFName.Page = PDFName.of('Page');
    PDFName.Annots = PDFName.of('Annots');
    PDFName.TrimBox = PDFName.of('TrimBox');
    PDFName.ArtBox = PDFName.of('ArtBox');
    PDFName.BleedBox = PDFName.of('BleedBox');
    PDFName.CropBox = PDFName.of('CropBox');
    PDFName.Rotate = PDFName.of('Rotate');
    PDFName.Title = PDFName.of('Title');
    PDFName.Author = PDFName.of('Author');
    PDFName.Subject = PDFName.of('Subject');
    PDFName.Creator = PDFName.of('Creator');
    PDFName.Keywords = PDFName.of('Keywords');
    PDFName.Producer = PDFName.of('Producer');
    PDFName.CreationDate = PDFName.of('CreationDate');
    PDFName.ModDate = PDFName.of('ModDate');
    return PDFName;
}((0, $eKLLF.default));
var $789394af60e07388$export$2e2bcd8739ae039 = $789394af60e07388$var$PDFName;

});
parcelRegister("gR9D3", function(module, exports) {

$parcel$export(module.exports, "IsIrregular", function () { return $c45910a874ef6ba0$export$5a447e10c710a69b; });

var $8KH3B = parcelRequire("8KH3B");

var $cgSZS = parcelRequire("cgSZS");

var $igTLl = parcelRequire("igTLl");
var $c45910a874ef6ba0$export$5a447e10c710a69b = new Uint8Array(256);
for(var $c45910a874ef6ba0$var$idx = 0, $c45910a874ef6ba0$var$len = 256; $c45910a874ef6ba0$var$idx < $c45910a874ef6ba0$var$len; $c45910a874ef6ba0$var$idx++)$c45910a874ef6ba0$export$5a447e10c710a69b[$c45910a874ef6ba0$var$idx] = (0, $igTLl.IsWhitespace)[$c45910a874ef6ba0$var$idx] || (0, $cgSZS.IsDelimiter)[$c45910a874ef6ba0$var$idx] ? 1 : 0;
$c45910a874ef6ba0$export$5a447e10c710a69b[(0, $8KH3B.default).Hash] = 1;

});
parcelRegister("cgSZS", function(module, exports) {

$parcel$export(module.exports, "IsDelimiter", function () { return $8ef1a3eab2f2dee8$export$30620680eaa3becd; });

var $8KH3B = parcelRequire("8KH3B");
var $8ef1a3eab2f2dee8$export$30620680eaa3becd = new Uint8Array(256);
$8ef1a3eab2f2dee8$export$30620680eaa3becd[(0, $8KH3B.default).LeftParen] = 1;
$8ef1a3eab2f2dee8$export$30620680eaa3becd[(0, $8KH3B.default).RightParen] = 1;
$8ef1a3eab2f2dee8$export$30620680eaa3becd[(0, $8KH3B.default).LessThan] = 1;
$8ef1a3eab2f2dee8$export$30620680eaa3becd[(0, $8KH3B.default).GreaterThan] = 1;
$8ef1a3eab2f2dee8$export$30620680eaa3becd[(0, $8KH3B.default).LeftSquareBracket] = 1;
$8ef1a3eab2f2dee8$export$30620680eaa3becd[(0, $8KH3B.default).RightSquareBracket] = 1;
$8ef1a3eab2f2dee8$export$30620680eaa3becd[(0, $8KH3B.default).LeftCurly] = 1;
$8ef1a3eab2f2dee8$export$30620680eaa3becd[(0, $8KH3B.default).RightCurly] = 1;
$8ef1a3eab2f2dee8$export$30620680eaa3becd[(0, $8KH3B.default).ForwardSlash] = 1;
$8ef1a3eab2f2dee8$export$30620680eaa3becd[(0, $8KH3B.default).Percent] = 1;

});

parcelRegister("igTLl", function(module, exports) {

$parcel$export(module.exports, "IsWhitespace", function () { return $d4d4f9e41b4eab9f$export$38c4de915d0e2c37; });

var $8KH3B = parcelRequire("8KH3B");
var $d4d4f9e41b4eab9f$export$38c4de915d0e2c37 = new Uint8Array(256);
$d4d4f9e41b4eab9f$export$38c4de915d0e2c37[(0, $8KH3B.default).Null] = 1;
$d4d4f9e41b4eab9f$export$38c4de915d0e2c37[(0, $8KH3B.default).Tab] = 1;
$d4d4f9e41b4eab9f$export$38c4de915d0e2c37[(0, $8KH3B.default).Newline] = 1;
$d4d4f9e41b4eab9f$export$38c4de915d0e2c37[(0, $8KH3B.default).FormFeed] = 1;
$d4d4f9e41b4eab9f$export$38c4de915d0e2c37[(0, $8KH3B.default).CarriageReturn] = 1;
$d4d4f9e41b4eab9f$export$38c4de915d0e2c37[(0, $8KH3B.default).Space] = 1;

});




parcelRegister("jObBy", function(module, exports) {
function $e6bbb04b7bff1a75$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $e6bbb04b7bff1a75$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $e6bbb04b7bff1a75$var$_typeof(o);
}
module.exports = $e6bbb04b7bff1a75$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9roVb", function(module, exports) {
module.exports = $parcel$import("j0xdP").then(()=>parcelRequire('iQqps'));

});

parcelRegister("ks967", function(module, exports) {
module.exports = $parcel$import("lP4nv").then(()=>parcelRequire('3PTlf'));

});

var $b600457cf2380924$exports = {};
$parcel$extendImportMap({
    "j0xdP": "purify.12c8ffd9.js",
    "lP4nv": "index.es.9546e946.js",
    "jfJdG": "developed_by.6bef5724.png",
    "kB6wt": "indiramma_indlu_logo1.fd572f59.png",
    "kLv6d": "leads-import-template.76b48d27.xlsx",
    "35mrC": "telangana-state-map.3df264fc.png",
    "kAIR8": "Telangana-LOGO.8bceaa8e.png",
    "c5sf6": "rising_telangana.69fa1f85.png",
    "c7y0Q": "indiramma_3d.a182d4ea.jpeg"
});

var $64174c7064b10992$exports = {};
'use strict';

$64174c7064b10992$exports = (parcelRequire("lKnNn"));



var $7UyaH = parcelRequire("7UyaH");
var $8878dcfc7f5ecb45$exports = {};

$parcel$export($8878dcfc7f5ecb45$exports, "createRoot", function () { return $8878dcfc7f5ecb45$export$882461b6382ed46c; }, function (v) { return $8878dcfc7f5ecb45$export$882461b6382ed46c = v; });
$parcel$export($8878dcfc7f5ecb45$exports, "hydrateRoot", function () { return $8878dcfc7f5ecb45$export$757ceba2d55c277e; }, function (v) { return $8878dcfc7f5ecb45$export$757ceba2d55c277e = v; });
var $8878dcfc7f5ecb45$export$882461b6382ed46c;
var $8878dcfc7f5ecb45$export$757ceba2d55c277e;
'use strict';
var $32e03ff3f068d28e$exports = {};
'use strict';
function $32e03ff3f068d28e$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($32e03ff3f068d28e$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$32e03ff3f068d28e$var$checkDCE();

$32e03ff3f068d28e$exports = (parcelRequire("jUQRJ"));


var $8878dcfc7f5ecb45$var$i;
$8878dcfc7f5ecb45$export$882461b6382ed46c = $32e03ff3f068d28e$exports.createRoot;
$8878dcfc7f5ecb45$export$757ceba2d55c277e = $32e03ff3f068d28e$exports.hydrateRoot;


/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7UyaH = parcelRequire("7UyaH");

/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $e7f1cbe29cd8e6fc$var$_extends() {
    $e7f1cbe29cd8e6fc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e7f1cbe29cd8e6fc$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee || ($e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee = {}));
const $e7f1cbe29cd8e6fc$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $e7f1cbe29cd8e6fc$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $e7f1cbe29cd8e6fc$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $e7f1cbe29cd8e6fc$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $e7f1cbe29cd8e6fc$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $e7f1cbe29cd8e6fc$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $e7f1cbe29cd8e6fc$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $e7f1cbe29cd8e6fc$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $e7f1cbe29cd8e6fc$export$fe53371bee54353d(to);
    }
    return $e7f1cbe29cd8e6fc$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $e7f1cbe29cd8e6fc$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $e7f1cbe29cd8e6fc$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $e7f1cbe29cd8e6fc$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $e7f1cbe29cd8e6fc$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $e7f1cbe29cd8e6fc$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $e7f1cbe29cd8e6fc$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $e7f1cbe29cd8e6fc$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $e7f1cbe29cd8e6fc$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $e7f1cbe29cd8e6fc$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $e7f1cbe29cd8e6fc$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $e7f1cbe29cd8e6fc$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $e7f1cbe29cd8e6fc$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $e7f1cbe29cd8e6fc$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $e7f1cbe29cd8e6fc$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $e7f1cbe29cd8e6fc$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $e7f1cbe29cd8e6fc$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($e7f1cbe29cd8e6fc$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Push;
        let location = $e7f1cbe29cd8e6fc$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $e7f1cbe29cd8e6fc$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Replace;
        let location = $e7f1cbe29cd8e6fc$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $e7f1cbe29cd8e6fc$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $e7f1cbe29cd8e6fc$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($e7f1cbe29cd8e6fc$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($e7f1cbe29cd8e6fc$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $e7f1cbe29cd8e6fc$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($e7f1cbe29cd8e6fc$var$ResultType || ($e7f1cbe29cd8e6fc$var$ResultType = {}));
const $e7f1cbe29cd8e6fc$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $e7f1cbe29cd8e6fc$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $e7f1cbe29cd8e6fc$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($e7f1cbe29cd8e6fc$var$isIndexRoute(route)) {
            let indexRoute = $e7f1cbe29cd8e6fc$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $e7f1cbe29cd8e6fc$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $e7f1cbe29cd8e6fc$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $e7f1cbe29cd8e6fc$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $e7f1cbe29cd8e6fc$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $e7f1cbe29cd8e6fc$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $e7f1cbe29cd8e6fc$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $e7f1cbe29cd8e6fc$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $e7f1cbe29cd8e6fc$var$flattenRoutes(routes);
    $e7f1cbe29cd8e6fc$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $e7f1cbe29cd8e6fc$export$30d21fd6d7295f52(pathname);
        matches = $e7f1cbe29cd8e6fc$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $e7f1cbe29cd8e6fc$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $e7f1cbe29cd8e6fc$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $e7f1cbe29cd8e6fc$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $e7f1cbe29cd8e6fc$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $e7f1cbe29cd8e6fc$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $e7f1cbe29cd8e6fc$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $e7f1cbe29cd8e6fc$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $e7f1cbe29cd8e6fc$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $e7f1cbe29cd8e6fc$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $e7f1cbe29cd8e6fc$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $e7f1cbe29cd8e6fc$var$paramRe = /^:[\w-]+$/;
const $e7f1cbe29cd8e6fc$var$dynamicSegmentValue = 3;
const $e7f1cbe29cd8e6fc$var$indexRouteValue = 2;
const $e7f1cbe29cd8e6fc$var$emptySegmentValue = 1;
const $e7f1cbe29cd8e6fc$var$staticSegmentValue = 10;
const $e7f1cbe29cd8e6fc$var$splatPenalty = -2;
const $e7f1cbe29cd8e6fc$var$isSplat = (s)=>s === "*";
function $e7f1cbe29cd8e6fc$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($e7f1cbe29cd8e6fc$var$isSplat)) initialScore += $e7f1cbe29cd8e6fc$var$splatPenalty;
    if (index) initialScore += $e7f1cbe29cd8e6fc$var$indexRouteValue;
    return segments.filter((s)=>!$e7f1cbe29cd8e6fc$var$isSplat(s)).reduce((score, segment)=>score + ($e7f1cbe29cd8e6fc$var$paramRe.test(segment) ? $e7f1cbe29cd8e6fc$var$dynamicSegmentValue : segment === "" ? $e7f1cbe29cd8e6fc$var$emptySegmentValue : $e7f1cbe29cd8e6fc$var$staticSegmentValue), initialScore);
}
function $e7f1cbe29cd8e6fc$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $e7f1cbe29cd8e6fc$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $e7f1cbe29cd8e6fc$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $e7f1cbe29cd8e6fc$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $e7f1cbe29cd8e6fc$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $e7f1cbe29cd8e6fc$export$a5c6d149b50c1d86($e7f1cbe29cd8e6fc$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $e7f1cbe29cd8e6fc$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $e7f1cbe29cd8e6fc$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $e7f1cbe29cd8e6fc$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $e7f1cbe29cd8e6fc$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $e7f1cbe29cd8e6fc$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $e7f1cbe29cd8e6fc$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $e7f1cbe29cd8e6fc$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $e7f1cbe29cd8e6fc$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $e7f1cbe29cd8e6fc$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $e7f1cbe29cd8e6fc$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $e7f1cbe29cd8e6fc$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $e7f1cbe29cd8e6fc$var$isAbsoluteUrl = (url)=>$e7f1cbe29cd8e6fc$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $e7f1cbe29cd8e6fc$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $e7f1cbe29cd8e6fc$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($e7f1cbe29cd8e6fc$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $e7f1cbe29cd8e6fc$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $e7f1cbe29cd8e6fc$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $e7f1cbe29cd8e6fc$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $e7f1cbe29cd8e6fc$var$normalizeSearch(search),
        hash: $e7f1cbe29cd8e6fc$var$normalizeHash(hash)
    };
}
function $e7f1cbe29cd8e6fc$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $e7f1cbe29cd8e6fc$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $e7f1cbe29cd8e6fc$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $e7f1cbe29cd8e6fc$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $e7f1cbe29cd8e6fc$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $e7f1cbe29cd8e6fc$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $e7f1cbe29cd8e6fc$export$8ccf933b0513f8d0(toArg);
    else {
        to = $e7f1cbe29cd8e6fc$var$_extends({}, toArg);
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $e7f1cbe29cd8e6fc$var$getInvalidPathError("?", "pathname", "search", to));
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $e7f1cbe29cd8e6fc$var$getInvalidPathError("#", "pathname", "hash", to));
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $e7f1cbe29cd8e6fc$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $e7f1cbe29cd8e6fc$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $e7f1cbe29cd8e6fc$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $e7f1cbe29cd8e6fc$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $e7f1cbe29cd8e6fc$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $e7f1cbe29cd8e6fc$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $e7f1cbe29cd8e6fc$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $e7f1cbe29cd8e6fc$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $e7f1cbe29cd8e6fc$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $e7f1cbe29cd8e6fc$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $e7f1cbe29cd8e6fc$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $e7f1cbe29cd8e6fc$export$4051a07651545597(data, init) {
    return new $e7f1cbe29cd8e6fc$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $e7f1cbe29cd8e6fc$export$42a99a7a4bc0e76a extends Error {
}
class $e7f1cbe29cd8e6fc$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $e7f1cbe29cd8e6fc$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $e7f1cbe29cd8e6fc$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $e7f1cbe29cd8e6fc$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $e7f1cbe29cd8e6fc$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $e7f1cbe29cd8e6fc$var$unwrapTrackedPromise(value) {
    if (!$e7f1cbe29cd8e6fc$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $e7f1cbe29cd8e6fc$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $e7f1cbe29cd8e6fc$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e7f1cbe29cd8e6fc$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $e7f1cbe29cd8e6fc$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e7f1cbe29cd8e6fc$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $e7f1cbe29cd8e6fc$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e7f1cbe29cd8e6fc$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $e7f1cbe29cd8e6fc$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $e7f1cbe29cd8e6fc$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $e7f1cbe29cd8e6fc$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $e7f1cbe29cd8e6fc$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $e7f1cbe29cd8e6fc$var$validMutationMethods = new Set($e7f1cbe29cd8e6fc$var$validMutationMethodsArr);
const $e7f1cbe29cd8e6fc$var$validRequestMethodsArr = [
    "get",
    ...$e7f1cbe29cd8e6fc$var$validMutationMethodsArr
];
const $e7f1cbe29cd8e6fc$var$validRequestMethods = new Set($e7f1cbe29cd8e6fc$var$validRequestMethodsArr);
const $e7f1cbe29cd8e6fc$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $e7f1cbe29cd8e6fc$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $e7f1cbe29cd8e6fc$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $e7f1cbe29cd8e6fc$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $e7f1cbe29cd8e6fc$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $e7f1cbe29cd8e6fc$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $e7f1cbe29cd8e6fc$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $e7f1cbe29cd8e6fc$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $e7f1cbe29cd8e6fc$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $e7f1cbe29cd8e6fc$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $e7f1cbe29cd8e6fc$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $e7f1cbe29cd8e6fc$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $e7f1cbe29cd8e6fc$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $e7f1cbe29cd8e6fc$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $e7f1cbe29cd8e6fc$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $e7f1cbe29cd8e6fc$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$e7f1cbe29cd8e6fc$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$e7f1cbe29cd8e6fc$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $e7f1cbe29cd8e6fc$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $e7f1cbe29cd8e6fc$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $e7f1cbe29cd8e6fc$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $e7f1cbe29cd8e6fc$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$e7f1cbe29cd8e6fc$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $e7f1cbe29cd8e6fc$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $e7f1cbe29cd8e6fc$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $e7f1cbe29cd8e6fc$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $e7f1cbe29cd8e6fc$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $e7f1cbe29cd8e6fc$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($e7f1cbe29cd8e6fc$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $e7f1cbe29cd8e6fc$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $e7f1cbe29cd8e6fc$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $e7f1cbe29cd8e6fc$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $e7f1cbe29cd8e6fc$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $e7f1cbe29cd8e6fc$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $e7f1cbe29cd8e6fc$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $e7f1cbe29cd8e6fc$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $e7f1cbe29cd8e6fc$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $e7f1cbe29cd8e6fc$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $e7f1cbe29cd8e6fc$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $e7f1cbe29cd8e6fc$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $e7f1cbe29cd8e6fc$var$findNearestBoundary(matches).route.id,
            {
                type: $e7f1cbe29cd8e6fc$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $e7f1cbe29cd8e6fc$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($e7f1cbe29cd8e6fc$var$isErrorResult(result) && $e7f1cbe29cd8e6fc$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $e7f1cbe29cd8e6fc$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $e7f1cbe29cd8e6fc$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $e7f1cbe29cd8e6fc$var$_extends({
            matches: updatedMatches || matches
        }, $e7f1cbe29cd8e6fc$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $e7f1cbe29cd8e6fc$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $e7f1cbe29cd8e6fc$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $e7f1cbe29cd8e6fc$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $e7f1cbe29cd8e6fc$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $e7f1cbe29cd8e6fc$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $e7f1cbe29cd8e6fc$var$ResultType.error,
            error: $e7f1cbe29cd8e6fc$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($e7f1cbe29cd8e6fc$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $e7f1cbe29cd8e6fc$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($e7f1cbe29cd8e6fc$var$isDeferredResult(result)) throw $e7f1cbe29cd8e6fc$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($e7f1cbe29cd8e6fc$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $e7f1cbe29cd8e6fc$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $e7f1cbe29cd8e6fc$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $e7f1cbe29cd8e6fc$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($e7f1cbe29cd8e6fc$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $e7f1cbe29cd8e6fc$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $e7f1cbe29cd8e6fc$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $e7f1cbe29cd8e6fc$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $e7f1cbe29cd8e6fc$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $e7f1cbe29cd8e6fc$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $e7f1cbe29cd8e6fc$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $e7f1cbe29cd8e6fc$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $e7f1cbe29cd8e6fc$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $e7f1cbe29cd8e6fc$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $e7f1cbe29cd8e6fc$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$e7f1cbe29cd8e6fc$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $e7f1cbe29cd8e6fc$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $e7f1cbe29cd8e6fc$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $e7f1cbe29cd8e6fc$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $e7f1cbe29cd8e6fc$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $e7f1cbe29cd8e6fc$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $e7f1cbe29cd8e6fc$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $e7f1cbe29cd8e6fc$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $e7f1cbe29cd8e6fc$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e7f1cbe29cd8e6fc$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $e7f1cbe29cd8e6fc$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $e7f1cbe29cd8e6fc$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $e7f1cbe29cd8e6fc$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($e7f1cbe29cd8e6fc$var$isRedirectResult(actionResult) || $e7f1cbe29cd8e6fc$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $e7f1cbe29cd8e6fc$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($e7f1cbe29cd8e6fc$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $e7f1cbe29cd8e6fc$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $e7f1cbe29cd8e6fc$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($e7f1cbe29cd8e6fc$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($e7f1cbe29cd8e6fc$var$isDeferredResult(actionResult)) throw $e7f1cbe29cd8e6fc$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $e7f1cbe29cd8e6fc$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $e7f1cbe29cd8e6fc$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $e7f1cbe29cd8e6fc$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $e7f1cbe29cd8e6fc$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $e7f1cbe29cd8e6fc$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $e7f1cbe29cd8e6fc$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $e7f1cbe29cd8e6fc$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $e7f1cbe29cd8e6fc$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $e7f1cbe29cd8e6fc$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $e7f1cbe29cd8e6fc$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e7f1cbe29cd8e6fc$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $e7f1cbe29cd8e6fc$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $e7f1cbe29cd8e6fc$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $e7f1cbe29cd8e6fc$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($e7f1cbe29cd8e6fc$var$isDeferredResult(result)) result = await $e7f1cbe29cd8e6fc$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $e7f1cbe29cd8e6fc$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($e7f1cbe29cd8e6fc$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $e7f1cbe29cd8e6fc$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($e7f1cbe29cd8e6fc$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(!$e7f1cbe29cd8e6fc$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $e7f1cbe29cd8e6fc$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $e7f1cbe29cd8e6fc$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $e7f1cbe29cd8e6fc$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($e7f1cbe29cd8e6fc$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $e7f1cbe29cd8e6fc$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Replace : $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $e7f1cbe29cd8e6fc$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($e7f1cbe29cd8e6fc$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $e7f1cbe29cd8e6fc$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $e7f1cbe29cd8e6fc$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $e7f1cbe29cd8e6fc$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $e7f1cbe29cd8e6fc$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $e7f1cbe29cd8e6fc$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($e7f1cbe29cd8e6fc$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $e7f1cbe29cd8e6fc$var$ResultType.redirect,
                response: $e7f1cbe29cd8e6fc$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $e7f1cbe29cd8e6fc$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $e7f1cbe29cd8e6fc$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $e7f1cbe29cd8e6fc$var$ResultType.error,
                    error: $e7f1cbe29cd8e6fc$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $e7f1cbe29cd8e6fc$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $e7f1cbe29cd8e6fc$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $e7f1cbe29cd8e6fc$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $e7f1cbe29cd8e6fc$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $e7f1cbe29cd8e6fc$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $e7f1cbe29cd8e6fc$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $e7f1cbe29cd8e6fc$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $e7f1cbe29cd8e6fc$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $e7f1cbe29cd8e6fc$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $e7f1cbe29cd8e6fc$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $e7f1cbe29cd8e6fc$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$e7f1cbe29cd8e6fc$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $e7f1cbe29cd8e6fc$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $e7f1cbe29cd8e6fc$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $e7f1cbe29cd8e6fc$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $e7f1cbe29cd8e6fc$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $e7f1cbe29cd8e6fc$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $e7f1cbe29cd8e6fc$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $e7f1cbe29cd8e6fc$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $e7f1cbe29cd8e6fc$export$4d0306f8f6a4585b = Symbol("deferred");
function $e7f1cbe29cd8e6fc$export$3336b097a6fbc59a(routes, opts) {
    $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $e7f1cbe29cd8e6fc$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $e7f1cbe29cd8e6fc$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $e7f1cbe29cd8e6fc$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $e7f1cbe29cd8e6fc$var$createLocation("", $e7f1cbe29cd8e6fc$export$fe53371bee54353d(url), null, "default");
        let matches = $e7f1cbe29cd8e6fc$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$e7f1cbe29cd8e6fc$var$isValidMethod(method) && method !== "HEAD") {
            let error = $e7f1cbe29cd8e6fc$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $e7f1cbe29cd8e6fc$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $e7f1cbe29cd8e6fc$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $e7f1cbe29cd8e6fc$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($e7f1cbe29cd8e6fc$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $e7f1cbe29cd8e6fc$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $e7f1cbe29cd8e6fc$var$createLocation("", $e7f1cbe29cd8e6fc$export$fe53371bee54353d(url), null, "default");
        let matches = $e7f1cbe29cd8e6fc$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$e7f1cbe29cd8e6fc$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $e7f1cbe29cd8e6fc$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $e7f1cbe29cd8e6fc$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $e7f1cbe29cd8e6fc$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $e7f1cbe29cd8e6fc$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $e7f1cbe29cd8e6fc$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($e7f1cbe29cd8e6fc$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$e7f1cbe29cd8e6fc$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($e7f1cbe29cd8e6fc$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $e7f1cbe29cd8e6fc$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $e7f1cbe29cd8e6fc$var$isResponse(result) ? result : $e7f1cbe29cd8e6fc$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($e7f1cbe29cd8e6fc$var$isDataStrategyResult(e) && $e7f1cbe29cd8e6fc$var$isResponse(e.result)) {
                if (e.type === $e7f1cbe29cd8e6fc$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($e7f1cbe29cd8e6fc$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $e7f1cbe29cd8e6fc$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $e7f1cbe29cd8e6fc$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $e7f1cbe29cd8e6fc$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($e7f1cbe29cd8e6fc$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($e7f1cbe29cd8e6fc$var$isDeferredResult(result)) {
            let error = $e7f1cbe29cd8e6fc$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $e7f1cbe29cd8e6fc$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($e7f1cbe29cd8e6fc$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($e7f1cbe29cd8e6fc$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $e7f1cbe29cd8e6fc$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $e7f1cbe29cd8e6fc$var$_extends({}, context, {
                statusCode: $e7f1cbe29cd8e6fc$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $e7f1cbe29cd8e6fc$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $e7f1cbe29cd8e6fc$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $e7f1cbe29cd8e6fc$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $e7f1cbe29cd8e6fc$var$isErrorResult(pendingActionResult[1]) ? $e7f1cbe29cd8e6fc$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $e7f1cbe29cd8e6fc$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $e7f1cbe29cd8e6fc$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $e7f1cbe29cd8e6fc$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $e7f1cbe29cd8e6fc$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $e7f1cbe29cd8e6fc$var$callDataStrategyImpl(dataStrategy || $e7f1cbe29cd8e6fc$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($e7f1cbe29cd8e6fc$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $e7f1cbe29cd8e6fc$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($e7f1cbe29cd8e6fc$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $e7f1cbe29cd8e6fc$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $e7f1cbe29cd8e6fc$export$fec11da027c70692(routes, context, error) {
    let newContext = $e7f1cbe29cd8e6fc$var$_extends({}, context, {
        statusCode: $e7f1cbe29cd8e6fc$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $e7f1cbe29cd8e6fc$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $e7f1cbe29cd8e6fc$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $e7f1cbe29cd8e6fc$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $e7f1cbe29cd8e6fc$export$cae722b0cc860f13(to ? to : ".", $e7f1cbe29cd8e6fc$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $e7f1cbe29cd8e6fc$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $e7f1cbe29cd8e6fc$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $e7f1cbe29cd8e6fc$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $e7f1cbe29cd8e6fc$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $e7f1cbe29cd8e6fc$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$e7f1cbe29cd8e6fc$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$e7f1cbe29cd8e6fc$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $e7f1cbe29cd8e6fc$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $e7f1cbe29cd8e6fc$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $e7f1cbe29cd8e6fc$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$e7f1cbe29cd8e6fc$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$e7f1cbe29cd8e6fc$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $e7f1cbe29cd8e6fc$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $e7f1cbe29cd8e6fc$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $e7f1cbe29cd8e6fc$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $e7f1cbe29cd8e6fc$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($e7f1cbe29cd8e6fc$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $e7f1cbe29cd8e6fc$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $e7f1cbe29cd8e6fc$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $e7f1cbe29cd8e6fc$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $e7f1cbe29cd8e6fc$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $e7f1cbe29cd8e6fc$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $e7f1cbe29cd8e6fc$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $e7f1cbe29cd8e6fc$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $e7f1cbe29cd8e6fc$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $e7f1cbe29cd8e6fc$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $e7f1cbe29cd8e6fc$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($e7f1cbe29cd8e6fc$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $e7f1cbe29cd8e6fc$var$shouldRevalidateLoader(match, $e7f1cbe29cd8e6fc$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $e7f1cbe29cd8e6fc$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $e7f1cbe29cd8e6fc$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $e7f1cbe29cd8e6fc$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $e7f1cbe29cd8e6fc$var$shouldRevalidateLoader(fetcherMatch, $e7f1cbe29cd8e6fc$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $e7f1cbe29cd8e6fc$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $e7f1cbe29cd8e6fc$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $e7f1cbe29cd8e6fc$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $e7f1cbe29cd8e6fc$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $e7f1cbe29cd8e6fc$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$e7f1cbe29cd8e6fc$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $e7f1cbe29cd8e6fc$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $e7f1cbe29cd8e6fc$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$e7f1cbe29cd8e6fc$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $e7f1cbe29cd8e6fc$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $e7f1cbe29cd8e6fc$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$e7f1cbe29cd8e6fc$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $e7f1cbe29cd8e6fc$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $e7f1cbe29cd8e6fc$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $e7f1cbe29cd8e6fc$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $e7f1cbe29cd8e6fc$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $e7f1cbe29cd8e6fc$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $e7f1cbe29cd8e6fc$var$ResultType.data,
                result: undefined
            });
        };
        return $e7f1cbe29cd8e6fc$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $e7f1cbe29cd8e6fc$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $e7f1cbe29cd8e6fc$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $e7f1cbe29cd8e6fc$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $e7f1cbe29cd8e6fc$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $e7f1cbe29cd8e6fc$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $e7f1cbe29cd8e6fc$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($e7f1cbe29cd8e6fc$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $e7f1cbe29cd8e6fc$var$ResultType.error,
                error: e
            };
        }
        if (type === $e7f1cbe29cd8e6fc$var$ResultType.error) return {
            type: $e7f1cbe29cd8e6fc$var$ResultType.error,
            error: new $e7f1cbe29cd8e6fc$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $e7f1cbe29cd8e6fc$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $e7f1cbe29cd8e6fc$var$ResultType.error) {
        if ($e7f1cbe29cd8e6fc$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $e7f1cbe29cd8e6fc$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $e7f1cbe29cd8e6fc$var$ResultType.error,
                error: new $e7f1cbe29cd8e6fc$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $e7f1cbe29cd8e6fc$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $e7f1cbe29cd8e6fc$var$ResultType.error,
            error: result,
            statusCode: $e7f1cbe29cd8e6fc$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($e7f1cbe29cd8e6fc$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $e7f1cbe29cd8e6fc$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($e7f1cbe29cd8e6fc$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $e7f1cbe29cd8e6fc$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $e7f1cbe29cd8e6fc$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $e7f1cbe29cd8e6fc$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$e7f1cbe29cd8e6fc$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $e7f1cbe29cd8e6fc$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $e7f1cbe29cd8e6fc$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($e7f1cbe29cd8e6fc$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $e7f1cbe29cd8e6fc$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $e7f1cbe29cd8e6fc$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($e7f1cbe29cd8e6fc$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $e7f1cbe29cd8e6fc$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $e7f1cbe29cd8e6fc$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $e7f1cbe29cd8e6fc$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $e7f1cbe29cd8e6fc$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $e7f1cbe29cd8e6fc$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $e7f1cbe29cd8e6fc$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(!$e7f1cbe29cd8e6fc$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($e7f1cbe29cd8e6fc$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $e7f1cbe29cd8e6fc$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $e7f1cbe29cd8e6fc$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($e7f1cbe29cd8e6fc$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $e7f1cbe29cd8e6fc$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $e7f1cbe29cd8e6fc$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($e7f1cbe29cd8e6fc$var$isErrorResult(result)) {
            let boundaryMatch = $e7f1cbe29cd8e6fc$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $e7f1cbe29cd8e6fc$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($e7f1cbe29cd8e6fc$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($e7f1cbe29cd8e6fc$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $e7f1cbe29cd8e6fc$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $e7f1cbe29cd8e6fc$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $e7f1cbe29cd8e6fc$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $e7f1cbe29cd8e6fc$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $e7f1cbe29cd8e6fc$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $e7f1cbe29cd8e6fc$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $e7f1cbe29cd8e6fc$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $e7f1cbe29cd8e6fc$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $e7f1cbe29cd8e6fc$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $e7f1cbe29cd8e6fc$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($e7f1cbe29cd8e6fc$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $e7f1cbe29cd8e6fc$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $e7f1cbe29cd8e6fc$export$8ccf933b0513f8d0(path) : path;
    return $e7f1cbe29cd8e6fc$export$fe53371bee54353d($e7f1cbe29cd8e6fc$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $e7f1cbe29cd8e6fc$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $e7f1cbe29cd8e6fc$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $e7f1cbe29cd8e6fc$var$ResultType.data || result.type === $e7f1cbe29cd8e6fc$var$ResultType.error);
}
function $e7f1cbe29cd8e6fc$var$isRedirectDataStrategyResultResult(result) {
    return $e7f1cbe29cd8e6fc$var$isResponse(result.result) && $e7f1cbe29cd8e6fc$var$redirectStatusCodes.has(result.result.status);
}
function $e7f1cbe29cd8e6fc$var$isDeferredResult(result) {
    return result.type === $e7f1cbe29cd8e6fc$var$ResultType.deferred;
}
function $e7f1cbe29cd8e6fc$var$isErrorResult(result) {
    return result.type === $e7f1cbe29cd8e6fc$var$ResultType.error;
}
function $e7f1cbe29cd8e6fc$var$isRedirectResult(result) {
    return (result && result.type) === $e7f1cbe29cd8e6fc$var$ResultType.redirect;
}
function $e7f1cbe29cd8e6fc$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $e7f1cbe29cd8e6fc$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $e7f1cbe29cd8e6fc$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $e7f1cbe29cd8e6fc$var$isRedirectResponse(result) {
    if (!$e7f1cbe29cd8e6fc$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $e7f1cbe29cd8e6fc$var$isValidMethod(method) {
    return $e7f1cbe29cd8e6fc$var$validRequestMethods.has(method.toLowerCase());
}
function $e7f1cbe29cd8e6fc$var$isMutationMethod(method) {
    return $e7f1cbe29cd8e6fc$var$validMutationMethods.has(method.toLowerCase());
}
async function $e7f1cbe29cd8e6fc$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$e7f1cbe29cd8e6fc$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($e7f1cbe29cd8e6fc$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $e7f1cbe29cd8e6fc$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $e7f1cbe29cd8e6fc$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($e7f1cbe29cd8e6fc$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $e7f1cbe29cd8e6fc$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $e7f1cbe29cd8e6fc$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $e7f1cbe29cd8e6fc$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $e7f1cbe29cd8e6fc$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $e7f1cbe29cd8e6fc$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $e7f1cbe29cd8e6fc$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $e7f1cbe29cd8e6fc$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $e7f1cbe29cd8e6fc$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $e7f1cbe29cd8e6fc$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $e7f1cbe29cd8e6fc$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $e7f1cbe29cd8e6fc$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $e7f1cbe29cd8e6fc$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $e7f1cbe29cd8e6fc$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $e7f1cbe29cd8e6fc$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $e7f1cbe29cd8e6fc$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $e7f1cbe29cd8e6fc$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $e7f1cbe29cd8e6fc$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $e7f1cbe29cd8e6fc$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($e7f1cbe29cd8e6fc$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $e7f1cbe29cd8e6fc$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($e7f1cbe29cd8e6fc$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $e7f1cbe29cd8e6fc$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7UyaH = parcelRequire("7UyaH");

function $265aeae2597a9f58$var$_extends() {
    $265aeae2597a9f58$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $265aeae2597a9f58$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $265aeae2597a9f58$export$3add0d5dce533e2e = /*#__PURE__*/ $7UyaH.createContext(null);
const $265aeae2597a9f58$export$145dfa71566a64dc = /*#__PURE__*/ $7UyaH.createContext(null);
const $265aeae2597a9f58$var$AwaitContext = /*#__PURE__*/ $7UyaH.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $265aeae2597a9f58$export$26749e8557646306 = /*#__PURE__*/ $7UyaH.createContext(null);
const $265aeae2597a9f58$export$c7914228fb69b0f5 = /*#__PURE__*/ $7UyaH.createContext(null);
const $265aeae2597a9f58$export$9072aa6dd1f93057 = /*#__PURE__*/ $7UyaH.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $265aeae2597a9f58$var$RouteErrorContext = /*#__PURE__*/ $7UyaH.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $265aeae2597a9f58$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$265aeae2597a9f58$export$9c954a9d03d32f4a() && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $7UyaH.useContext($265aeae2597a9f58$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $265aeae2597a9f58$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $e7f1cbe29cd8e6fc$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $265aeae2597a9f58$export$9c954a9d03d32f4a() {
    return $7UyaH.useContext($265aeae2597a9f58$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $265aeae2597a9f58$export$45d76561a5302f2b() {
    !$265aeae2597a9f58$export$9c954a9d03d32f4a() && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
    return $7UyaH.useContext($265aeae2597a9f58$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $265aeae2597a9f58$export$1b3f31771c5d07c() {
    return $7UyaH.useContext($265aeae2597a9f58$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $265aeae2597a9f58$export$6c330e8992e8a295(pattern) {
    !$265aeae2597a9f58$export$9c954a9d03d32f4a() && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $265aeae2597a9f58$export$45d76561a5302f2b();
    return $7UyaH.useMemo(()=>(0, $e7f1cbe29cd8e6fc$export$81336c211d5ff295)(pattern, (0, $e7f1cbe29cd8e6fc$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $265aeae2597a9f58$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $265aeae2597a9f58$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7UyaH.useContext($265aeae2597a9f58$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $7UyaH.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $265aeae2597a9f58$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7UyaH.useContext($265aeae2597a9f58$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $265aeae2597a9f58$var$useNavigateStable() : $265aeae2597a9f58$var$useNavigateUnstable();
}
function $265aeae2597a9f58$var$useNavigateUnstable() {
    !$265aeae2597a9f58$export$9c954a9d03d32f4a() && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
    let dataRouterContext = $7UyaH.useContext($265aeae2597a9f58$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $7UyaH.useContext($265aeae2597a9f58$export$26749e8557646306);
    let { matches: matches } = $7UyaH.useContext($265aeae2597a9f58$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $265aeae2597a9f58$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $e7f1cbe29cd8e6fc$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $7UyaH.useRef(false);
    $265aeae2597a9f58$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7UyaH.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $e7f1cbe29cd8e6fc$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $e7f1cbe29cd8e6fc$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $265aeae2597a9f58$var$OutletContext = /*#__PURE__*/ $7UyaH.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $265aeae2597a9f58$export$4138103a3ae699cc() {
    return $7UyaH.useContext($265aeae2597a9f58$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $265aeae2597a9f58$export$a3be3530d8e40d0b(context) {
    let outlet = $7UyaH.useContext($265aeae2597a9f58$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $265aeae2597a9f58$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7UyaH.useContext($265aeae2597a9f58$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $265aeae2597a9f58$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $7UyaH.useContext($265aeae2597a9f58$export$26749e8557646306);
    let { matches: matches } = $7UyaH.useContext($265aeae2597a9f58$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $265aeae2597a9f58$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $e7f1cbe29cd8e6fc$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $7UyaH.useMemo(()=>(0, $e7f1cbe29cd8e6fc$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $265aeae2597a9f58$export$5d3fca4a98652595(routes, locationArg) {
    return $265aeae2597a9f58$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $265aeae2597a9f58$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$265aeae2597a9f58$export$9c954a9d03d32f4a() && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $7UyaH.useContext($265aeae2597a9f58$export$26749e8557646306);
    let { matches: parentMatches } = $7UyaH.useContext($265aeae2597a9f58$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $265aeae2597a9f58$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $e7f1cbe29cd8e6fc$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $e7f1cbe29cd8e6fc$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $265aeae2597a9f58$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $e7f1cbe29cd8e6fc$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $e7f1cbe29cd8e6fc$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $265aeae2597a9f58$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $265aeae2597a9f58$var$DefaultErrorComponent() {
    let error = $265aeae2597a9f58$export$ed527bf60f6e05f2();
    let message = (0, $e7f1cbe29cd8e6fc$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $7UyaH.createElement($7UyaH.Fragment, null, /*#__PURE__*/ $7UyaH.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $7UyaH.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $7UyaH.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $265aeae2597a9f58$var$defaultErrorElement = /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$var$DefaultErrorComponent, null);
class $265aeae2597a9f58$var$RenderErrorBoundary extends $7UyaH.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $265aeae2597a9f58$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $7UyaH.useContext($265aeae2597a9f58$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $265aeae2597a9f58$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $265aeae2597a9f58$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $265aeae2597a9f58$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $7UyaH.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $265aeae2597a9f58$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($265aeae2597a9f58$var$DataRouterHook || {});
var $265aeae2597a9f58$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($265aeae2597a9f58$var$DataRouterStateHook || {});
function $265aeae2597a9f58$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $265aeae2597a9f58$var$useDataRouterContext(hookName) {
    let ctx = $7UyaH.useContext($265aeae2597a9f58$export$3add0d5dce533e2e);
    !ctx && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
    return ctx;
}
function $265aeae2597a9f58$var$useDataRouterState(hookName) {
    let state = $7UyaH.useContext($265aeae2597a9f58$export$145dfa71566a64dc);
    !state && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
    return state;
}
function $265aeae2597a9f58$var$useRouteContext(hookName) {
    let route = $7UyaH.useContext($265aeae2597a9f58$export$9072aa6dd1f93057);
    !route && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $265aeae2597a9f58$var$useCurrentRouteId(hookName) {
    let route = $265aeae2597a9f58$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $265aeae2597a9f58$export$5fc8298006ad9e58() {
    return $265aeae2597a9f58$var$useCurrentRouteId($265aeae2597a9f58$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $265aeae2597a9f58$export$d0fd4b7106de2769() {
    let state = $265aeae2597a9f58$var$useDataRouterState($265aeae2597a9f58$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $265aeae2597a9f58$export$600dc272ed516c15() {
    let dataRouterContext = $265aeae2597a9f58$var$useDataRouterContext($265aeae2597a9f58$var$DataRouterHook.UseRevalidator);
    let state = $265aeae2597a9f58$var$useDataRouterState($265aeae2597a9f58$var$DataRouterStateHook.UseRevalidator);
    return $7UyaH.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $265aeae2597a9f58$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $265aeae2597a9f58$var$useDataRouterState($265aeae2597a9f58$var$DataRouterStateHook.UseMatches);
    return $7UyaH.useMemo(()=>matches.map((m)=>(0, $e7f1cbe29cd8e6fc$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $265aeae2597a9f58$export$1448a5050d252c4d() {
    let state = $265aeae2597a9f58$var$useDataRouterState($265aeae2597a9f58$var$DataRouterStateHook.UseLoaderData);
    let routeId = $265aeae2597a9f58$var$useCurrentRouteId($265aeae2597a9f58$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $265aeae2597a9f58$export$fd5d37484eab868d(routeId) {
    let state = $265aeae2597a9f58$var$useDataRouterState($265aeae2597a9f58$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $265aeae2597a9f58$export$fdc00f3f26066d5e() {
    let state = $265aeae2597a9f58$var$useDataRouterState($265aeae2597a9f58$var$DataRouterStateHook.UseActionData);
    let routeId = $265aeae2597a9f58$var$useCurrentRouteId($265aeae2597a9f58$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $265aeae2597a9f58$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $7UyaH.useContext($265aeae2597a9f58$var$RouteErrorContext);
    let state = $265aeae2597a9f58$var$useDataRouterState($265aeae2597a9f58$var$DataRouterStateHook.UseRouteError);
    let routeId = $265aeae2597a9f58$var$useCurrentRouteId($265aeae2597a9f58$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $265aeae2597a9f58$export$78a72ddb39bdd145() {
    let value = $7UyaH.useContext($265aeae2597a9f58$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $265aeae2597a9f58$export$17f53340677d5831() {
    let value = $7UyaH.useContext($265aeae2597a9f58$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $265aeae2597a9f58$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $265aeae2597a9f58$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $265aeae2597a9f58$var$useDataRouterContext($265aeae2597a9f58$var$DataRouterHook.UseBlocker);
    let state = $265aeae2597a9f58$var$useDataRouterState($265aeae2597a9f58$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $7UyaH.useState("");
    let blockerFunction = $7UyaH.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $265aeae2597a9f58$var$_extends({}, currentLocation, {
                pathname: (0, $e7f1cbe29cd8e6fc$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $265aeae2597a9f58$var$_extends({}, nextLocation, {
                pathname: (0, $e7f1cbe29cd8e6fc$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $7UyaH.useEffect(()=>{
        let key = String(++$265aeae2597a9f58$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $7UyaH.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $e7f1cbe29cd8e6fc$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $265aeae2597a9f58$var$useNavigateStable() {
    let { router: router } = $265aeae2597a9f58$var$useDataRouterContext($265aeae2597a9f58$var$DataRouterHook.UseNavigateStable);
    let id = $265aeae2597a9f58$var$useCurrentRouteId($265aeae2597a9f58$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $7UyaH.useRef(false);
    $265aeae2597a9f58$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7UyaH.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $265aeae2597a9f58$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $265aeae2597a9f58$var$alreadyWarned$1 = {};
function $265aeae2597a9f58$var$warningOnce(key, cond, message) {
    if (!cond && !$265aeae2597a9f58$var$alreadyWarned$1[key]) $265aeae2597a9f58$var$alreadyWarned$1[key] = true;
}
const $265aeae2597a9f58$var$alreadyWarned = {};
function $265aeae2597a9f58$var$warnOnce(key, message) {}
const $265aeae2597a9f58$var$logDeprecation = (flag, msg, link)=>$265aeae2597a9f58$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $265aeae2597a9f58$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $265aeae2597a9f58$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $265aeae2597a9f58$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $265aeae2597a9f58$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $265aeae2597a9f58$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $265aeae2597a9f58$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $265aeae2597a9f58$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $265aeae2597a9f58$var$START_TRANSITION = "startTransition";
const $265aeae2597a9f58$var$startTransitionImpl = $7UyaH[$265aeae2597a9f58$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $265aeae2597a9f58$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7UyaH.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7UyaH.useCallback((newState)=>{
        if (v7_startTransition && $265aeae2597a9f58$var$startTransitionImpl) $265aeae2597a9f58$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7UyaH.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7UyaH.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7UyaH.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7UyaH.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $7UyaH.useEffect(()=>$265aeae2597a9f58$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7UyaH.createElement($7UyaH.Fragment, null, /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $265aeae2597a9f58$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $265aeae2597a9f58$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $265aeae2597a9f58$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $7UyaH.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e7f1cbe29cd8e6fc$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7UyaH.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7UyaH.useCallback((newState)=>{
        v7_startTransition && $265aeae2597a9f58$var$startTransitionImpl ? $265aeae2597a9f58$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7UyaH.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7UyaH.useEffect(()=>$265aeae2597a9f58$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $265aeae2597a9f58$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$265aeae2597a9f58$export$9c954a9d03d32f4a() && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $7UyaH.useContext($265aeae2597a9f58$export$26749e8557646306);
    let { matches: matches } = $7UyaH.useContext($265aeae2597a9f58$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $265aeae2597a9f58$export$45d76561a5302f2b();
    let navigate = $265aeae2597a9f58$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $e7f1cbe29cd8e6fc$export$cae722b0cc860f13)(to, (0, $e7f1cbe29cd8e6fc$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7UyaH.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $265aeae2597a9f58$export$910ae8079b2c2852(props) {
    return $265aeae2597a9f58$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $265aeae2597a9f58$export$e7b0ac011bb776c6(_props) {
    (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $265aeae2597a9f58$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $e7f1cbe29cd8e6fc$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$265aeae2597a9f58$export$9c954a9d03d32f4a() && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7UyaH.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $265aeae2597a9f58$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $e7f1cbe29cd8e6fc$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $7UyaH.useMemo(()=>{
        let trailingPathname = (0, $e7f1cbe29cd8e6fc$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $265aeae2597a9f58$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $265aeae2597a9f58$export$5d3fca4a98652595($265aeae2597a9f58$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $265aeae2597a9f58$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$var$ResolveAwait, null, children));
}
var $265aeae2597a9f58$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($265aeae2597a9f58$var$AwaitRenderStatus || {});
const $265aeae2597a9f58$var$neverSettledPromise = new Promise(()=>{});
class $265aeae2597a9f58$var$AwaitErrorBoundary extends $7UyaH.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $265aeae2597a9f58$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $265aeae2597a9f58$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $265aeae2597a9f58$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $265aeae2597a9f58$var$AwaitRenderStatus.error : "_data" in promise ? $265aeae2597a9f58$var$AwaitRenderStatus.success : $265aeae2597a9f58$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $265aeae2597a9f58$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $265aeae2597a9f58$var$AwaitRenderStatus.error && promise._error instanceof (0, $e7f1cbe29cd8e6fc$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $265aeae2597a9f58$var$neverSettledPromise;
        if (status === $265aeae2597a9f58$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $265aeae2597a9f58$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $265aeae2597a9f58$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $7UyaH.createElement($265aeae2597a9f58$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $265aeae2597a9f58$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $265aeae2597a9f58$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $7UyaH.createElement($7UyaH.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $265aeae2597a9f58$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $7UyaH.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $7UyaH.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7UyaH.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $265aeae2597a9f58$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $265aeae2597a9f58$export$e7b0ac011bb776c6) && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $265aeae2597a9f58$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $265aeae2597a9f58$export$daf73786167a7f72(matches) {
    return $265aeae2597a9f58$var$_renderMatches(matches);
}
function $265aeae2597a9f58$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $7UyaH.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $7UyaH.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $7UyaH.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $265aeae2597a9f58$export$f30f7e456d254e83(routes, opts) {
    return (0, $e7f1cbe29cd8e6fc$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $265aeae2597a9f58$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e7f1cbe29cd8e6fc$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $265aeae2597a9f58$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $e651fdaba0d48e3d$var$_extends() {
    $e651fdaba0d48e3d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e651fdaba0d48e3d$var$_extends.apply(this, arguments);
}
function $e651fdaba0d48e3d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $e651fdaba0d48e3d$var$defaultMethod = "get";
const $e651fdaba0d48e3d$var$defaultEncType = "application/x-www-form-urlencoded";
function $e651fdaba0d48e3d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $e651fdaba0d48e3d$var$isButtonElement(object) {
    return $e651fdaba0d48e3d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $e651fdaba0d48e3d$var$isFormElement(object) {
    return $e651fdaba0d48e3d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $e651fdaba0d48e3d$var$isInputElement(object) {
    return $e651fdaba0d48e3d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $e651fdaba0d48e3d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $e651fdaba0d48e3d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$e651fdaba0d48e3d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $e651fdaba0d48e3d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $e651fdaba0d48e3d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $e651fdaba0d48e3d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $e651fdaba0d48e3d$var$_formDataSupportsSubmitter = null;
function $e651fdaba0d48e3d$var$isFormDataSubmitterSupported() {
    if ($e651fdaba0d48e3d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $e651fdaba0d48e3d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $e651fdaba0d48e3d$var$_formDataSupportsSubmitter = true;
    }
    return $e651fdaba0d48e3d$var$_formDataSupportsSubmitter;
}
const $e651fdaba0d48e3d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $e651fdaba0d48e3d$var$getFormEncType(encType) {
    if (encType != null && !$e651fdaba0d48e3d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $e651fdaba0d48e3d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($e651fdaba0d48e3d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $e7f1cbe29cd8e6fc$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $e651fdaba0d48e3d$var$defaultMethod;
        encType = $e651fdaba0d48e3d$var$getFormEncType(target.getAttribute("enctype")) || $e651fdaba0d48e3d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($e651fdaba0d48e3d$var$isButtonElement(target) || $e651fdaba0d48e3d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $e7f1cbe29cd8e6fc$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $e651fdaba0d48e3d$var$defaultMethod;
        encType = $e651fdaba0d48e3d$var$getFormEncType(target.getAttribute("formenctype")) || $e651fdaba0d48e3d$var$getFormEncType(form.getAttribute("enctype")) || $e651fdaba0d48e3d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$e651fdaba0d48e3d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($e651fdaba0d48e3d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $e651fdaba0d48e3d$var$defaultMethod;
        action = null;
        encType = $e651fdaba0d48e3d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $e651fdaba0d48e3d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $e651fdaba0d48e3d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $e651fdaba0d48e3d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $e651fdaba0d48e3d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $e651fdaba0d48e3d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $e651fdaba0d48e3d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $e7f1cbe29cd8e6fc$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $e651fdaba0d48e3d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e7f1cbe29cd8e6fc$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $e651fdaba0d48e3d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $265aeae2597a9f58$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $e651fdaba0d48e3d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $e7f1cbe29cd8e6fc$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $e651fdaba0d48e3d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e7f1cbe29cd8e6fc$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $e651fdaba0d48e3d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $265aeae2597a9f58$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $e651fdaba0d48e3d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $e651fdaba0d48e3d$var$_extends({}, state, {
        errors: $e651fdaba0d48e3d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $e651fdaba0d48e3d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $e7f1cbe29cd8e6fc$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $e651fdaba0d48e3d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $7UyaH.createContext({
    isTransitioning: false
});
const $e651fdaba0d48e3d$export$148fd98d095596d4 = /*#__PURE__*/ $7UyaH.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $e651fdaba0d48e3d$var$START_TRANSITION = "startTransition";
const $e651fdaba0d48e3d$var$startTransitionImpl = $7UyaH[$e651fdaba0d48e3d$var$START_TRANSITION];
const $e651fdaba0d48e3d$var$FLUSH_SYNC = "flushSync";
const $e651fdaba0d48e3d$var$flushSyncImpl = $32e03ff3f068d28e$exports[$e651fdaba0d48e3d$var$FLUSH_SYNC];
const $e651fdaba0d48e3d$var$USE_ID = "useId";
const $e651fdaba0d48e3d$var$useIdImpl = $7UyaH[$e651fdaba0d48e3d$var$USE_ID];
function $e651fdaba0d48e3d$var$startTransitionSafe(cb) {
    if ($e651fdaba0d48e3d$var$startTransitionImpl) $e651fdaba0d48e3d$var$startTransitionImpl(cb);
    else cb();
}
function $e651fdaba0d48e3d$var$flushSyncSafe(cb) {
    if ($e651fdaba0d48e3d$var$flushSyncImpl) $e651fdaba0d48e3d$var$flushSyncImpl(cb);
    else cb();
}
class $e651fdaba0d48e3d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $e651fdaba0d48e3d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7UyaH.useState(router.state);
    let [pendingState, setPendingState] = $7UyaH.useState();
    let [vtContext, setVtContext] = $7UyaH.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7UyaH.useState();
    let [transition, setTransition] = $7UyaH.useState();
    let [interruption, setInterruption] = $7UyaH.useState();
    let fetcherData = $7UyaH.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $7UyaH.useCallback((cb)=>{
        if (v7_startTransition) $e651fdaba0d48e3d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $7UyaH.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $e651fdaba0d48e3d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $e651fdaba0d48e3d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $e651fdaba0d48e3d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $e651fdaba0d48e3d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $e651fdaba0d48e3d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7UyaH.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $7UyaH.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $e651fdaba0d48e3d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $7UyaH.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $7UyaH.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $7UyaH.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $7UyaH.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7UyaH.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7UyaH.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $7UyaH.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $7UyaH.useEffect(()=>(0, $265aeae2597a9f58$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7UyaH.createElement($7UyaH.Fragment, null, /*#__PURE__*/ $7UyaH.createElement((0, $265aeae2597a9f58$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7UyaH.createElement((0, $265aeae2597a9f58$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $7UyaH.createElement($e651fdaba0d48e3d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $7UyaH.createElement($e651fdaba0d48e3d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $7UyaH.createElement((0, $265aeae2597a9f58$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7UyaH.createElement($e651fdaba0d48e3d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $e651fdaba0d48e3d$var$MemoizedDataRoutes = /*#__PURE__*/ $7UyaH.memo($e651fdaba0d48e3d$var$DataRoutes);
function $e651fdaba0d48e3d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $265aeae2597a9f58$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $e651fdaba0d48e3d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $7UyaH.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e7f1cbe29cd8e6fc$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7UyaH.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7UyaH.useCallback((newState)=>{
        v7_startTransition && $e651fdaba0d48e3d$var$startTransitionImpl ? $e651fdaba0d48e3d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7UyaH.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7UyaH.useEffect(()=>(0, $265aeae2597a9f58$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7UyaH.createElement((0, $265aeae2597a9f58$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $e651fdaba0d48e3d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $7UyaH.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e7f1cbe29cd8e6fc$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7UyaH.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7UyaH.useCallback((newState)=>{
        v7_startTransition && $e651fdaba0d48e3d$var$startTransitionImpl ? $e651fdaba0d48e3d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7UyaH.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7UyaH.useEffect(()=>(0, $265aeae2597a9f58$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7UyaH.createElement((0, $265aeae2597a9f58$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $e651fdaba0d48e3d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $7UyaH.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7UyaH.useCallback((newState)=>{
        v7_startTransition && $e651fdaba0d48e3d$var$startTransitionImpl ? $e651fdaba0d48e3d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7UyaH.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7UyaH.useEffect(()=>(0, $265aeae2597a9f58$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7UyaH.createElement((0, $265aeae2597a9f58$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $e651fdaba0d48e3d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $e651fdaba0d48e3d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $e651fdaba0d48e3d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $7UyaH.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $e651fdaba0d48e3d$var$_objectWithoutPropertiesLoose(_ref7, $e651fdaba0d48e3d$var$_excluded);
    let { basename: basename } = $7UyaH.useContext((0, $265aeae2597a9f58$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $e651fdaba0d48e3d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($e651fdaba0d48e3d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $e7f1cbe29cd8e6fc$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $265aeae2597a9f58$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $e651fdaba0d48e3d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $7UyaH.createElement("a", $e651fdaba0d48e3d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $e651fdaba0d48e3d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $7UyaH.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $e651fdaba0d48e3d$var$_objectWithoutPropertiesLoose(_ref8, $e651fdaba0d48e3d$var$_excluded2);
    let path = (0, $265aeae2597a9f58$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $265aeae2597a9f58$export$45d76561a5302f2b)();
    let routerState = $7UyaH.useContext((0, $265aeae2597a9f58$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $7UyaH.useContext((0, $265aeae2597a9f58$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $e651fdaba0d48e3d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $e7f1cbe29cd8e6fc$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $7UyaH.createElement($e651fdaba0d48e3d$export$a6c7ac8248d6e38a, $e651fdaba0d48e3d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $e651fdaba0d48e3d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $7UyaH.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $e651fdaba0d48e3d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $e651fdaba0d48e3d$var$_objectWithoutPropertiesLoose(_ref9, $e651fdaba0d48e3d$var$_excluded3);
    let submit = $e651fdaba0d48e3d$export$47c85c6e3a081d3();
    let formAction = $e651fdaba0d48e3d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $7UyaH.createElement("form", $e651fdaba0d48e3d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $e651fdaba0d48e3d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $e651fdaba0d48e3d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $e651fdaba0d48e3d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($e651fdaba0d48e3d$var$DataRouterHook || ($e651fdaba0d48e3d$var$DataRouterHook = {}));
var $e651fdaba0d48e3d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($e651fdaba0d48e3d$var$DataRouterStateHook || ($e651fdaba0d48e3d$var$DataRouterStateHook = {}));
// Internal hooks
function $e651fdaba0d48e3d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $e651fdaba0d48e3d$var$useDataRouterContext(hookName) {
    let ctx = $7UyaH.useContext((0, $265aeae2597a9f58$export$3add0d5dce533e2e));
    !ctx && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
    return ctx;
}
function $e651fdaba0d48e3d$var$useDataRouterState(hookName) {
    let state = $7UyaH.useContext((0, $265aeae2597a9f58$export$145dfa71566a64dc));
    !state && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $e651fdaba0d48e3d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $265aeae2597a9f58$export$9770f232ac06a008)();
    let location = (0, $265aeae2597a9f58$export$45d76561a5302f2b)();
    let path = (0, $265aeae2597a9f58$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $7UyaH.useCallback((event)=>{
        if ($e651fdaba0d48e3d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $e7f1cbe29cd8e6fc$export$fe53371bee54353d)(location) === (0, $e7f1cbe29cd8e6fc$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $e651fdaba0d48e3d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $7UyaH.useRef($e651fdaba0d48e3d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7UyaH.useRef(false);
    let location = (0, $265aeae2597a9f58$export$45d76561a5302f2b)();
    let searchParams = $7UyaH.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $e651fdaba0d48e3d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $265aeae2597a9f58$export$9770f232ac06a008)();
    let setSearchParams = $7UyaH.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $e651fdaba0d48e3d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $e651fdaba0d48e3d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $e651fdaba0d48e3d$var$fetcherId = 0;
let $e651fdaba0d48e3d$var$getUniqueFetcherId = ()=>"__" + String(++$e651fdaba0d48e3d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $e651fdaba0d48e3d$export$47c85c6e3a081d3() {
    let { router: router } = $e651fdaba0d48e3d$var$useDataRouterContext($e651fdaba0d48e3d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $7UyaH.useContext((0, $265aeae2597a9f58$export$26749e8557646306));
    let currentRouteId = (0, $265aeae2597a9f58$export$5fc8298006ad9e58)();
    return $7UyaH.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $e651fdaba0d48e3d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $e651fdaba0d48e3d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $e651fdaba0d48e3d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $e651fdaba0d48e3d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $7UyaH.useContext((0, $265aeae2597a9f58$export$26749e8557646306));
    let routeContext = $7UyaH.useContext((0, $265aeae2597a9f58$export$9072aa6dd1f93057));
    !routeContext && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $e651fdaba0d48e3d$var$_extends({}, (0, $265aeae2597a9f58$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $265aeae2597a9f58$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $e7f1cbe29cd8e6fc$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $e7f1cbe29cd8e6fc$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $e651fdaba0d48e3d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $e651fdaba0d48e3d$var$useDataRouterContext($e651fdaba0d48e3d$var$DataRouterHook.UseFetcher);
    let state = $e651fdaba0d48e3d$var$useDataRouterState($e651fdaba0d48e3d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $7UyaH.useContext($e651fdaba0d48e3d$export$148fd98d095596d4);
    let route = $7UyaH.useContext((0, $265aeae2597a9f58$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
    !route && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $e651fdaba0d48e3d$var$useIdImpl ? $e651fdaba0d48e3d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $7UyaH.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($e651fdaba0d48e3d$var$getUniqueFetcherId());
    // Registration/cleanup
    $7UyaH.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $7UyaH.useCallback((href, opts)=>{
        !routeId && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $e651fdaba0d48e3d$export$47c85c6e3a081d3();
    let submit = $7UyaH.useCallback((target, opts)=>{
        submitImpl(target, $e651fdaba0d48e3d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $7UyaH.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $7UyaH.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $7UyaH.createElement($e651fdaba0d48e3d$export$a7fed597f4b8afd8, $e651fdaba0d48e3d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $e7f1cbe29cd8e6fc$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7UyaH.useMemo(()=>$e651fdaba0d48e3d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $e651fdaba0d48e3d$export$fa996778a3a31087() {
    let state = $e651fdaba0d48e3d$var$useDataRouterState($e651fdaba0d48e3d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $e651fdaba0d48e3d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $e651fdaba0d48e3d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $e651fdaba0d48e3d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $e651fdaba0d48e3d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $e651fdaba0d48e3d$var$useDataRouterContext($e651fdaba0d48e3d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $e651fdaba0d48e3d$var$useDataRouterState($e651fdaba0d48e3d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $7UyaH.useContext((0, $265aeae2597a9f58$export$26749e8557646306));
    let location = (0, $265aeae2597a9f58$export$45d76561a5302f2b)();
    let matches = (0, $265aeae2597a9f58$export$2378eb7f5ff86053)();
    let navigation = (0, $265aeae2597a9f58$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $7UyaH.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $e651fdaba0d48e3d$var$usePageHide($7UyaH.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $e651fdaba0d48e3d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $e651fdaba0d48e3d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($e651fdaba0d48e3d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7UyaH.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $e651fdaba0d48e3d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $e651fdaba0d48e3d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7UyaH.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($e651fdaba0d48e3d$var$_extends({}, location, {
                    pathname: (0, $e7f1cbe29cd8e6fc$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($e651fdaba0d48e3d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7UyaH.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $e651fdaba0d48e3d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7UyaH.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $e651fdaba0d48e3d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7UyaH.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $e651fdaba0d48e3d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $265aeae2597a9f58$export$b273b3273281a049)(when);
    $7UyaH.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7UyaH.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $e651fdaba0d48e3d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $7UyaH.useContext($e651fdaba0d48e3d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $e7f1cbe29cd8e6fc$export$3e9cee6b33872309)(false);
    let { basename: basename } = $e651fdaba0d48e3d$var$useDataRouterContext($e651fdaba0d48e3d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $265aeae2597a9f58$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $e7f1cbe29cd8e6fc$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $e7f1cbe29cd8e6fc$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $e7f1cbe29cd8e6fc$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $e7f1cbe29cd8e6fc$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}







var $7UyaH = parcelRequire("7UyaH");


function $33a10e4dd89b1f49$var$iconProps(props) {
    return {
        width: 20,
        height: 20,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 1.75,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": true,
        ...props
    };
}
function $33a10e4dd89b1f49$export$bbf803f6a2a59274(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M3 10.5 12 3l9 7.5"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M5 9.5V20h14V9.5"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M9 20v-6h6v6"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$d4152af13dc9f56e(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M3 3v18h18"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M7 16V9"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M12 16V5"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M17 16v-4"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$8617ab0e4aa15e01(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M8 7h8M8 11h8M8 15h5"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$a757f1a0a0906316(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("rect", {
                x: "3",
                y: "3",
                width: "7",
                height: "9",
                rx: "1"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("rect", {
                x: "14",
                y: "3",
                width: "7",
                height: "5",
                rx: "1"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("rect", {
                x: "14",
                y: "12",
                width: "7",
                height: "9",
                rx: "1"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("rect", {
                x: "3",
                y: "16",
                width: "7",
                height: "5",
                rx: "1"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$3ea9951b43b19b95(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
            d: "M3 7v11a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-7l-2-2H5a2 2 0 0 0-2 2z"
        })
    });
}
function $33a10e4dd89b1f49$export$bdcbb206cb33984b(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("circle", {
                cx: "9",
                cy: "7",
                r: "4"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("line", {
                x1: "19",
                y1: "8",
                x2: "19",
                y2: "14"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("line", {
                x1: "22",
                y1: "11",
                x2: "16",
                y2: "11"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$3f284407ead563ae(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        width: 16,
        height: 16,
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
            d: "m9 18 6-6-6-6"
        })
    });
}
function $33a10e4dd89b1f49$export$59f995884fc5e26a(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
            d: "m6 9 6 6 6-6"
        })
    });
}
function $33a10e4dd89b1f49$export$99dbb1228c102a2c(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M6 12h12"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M6 16h12"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M10 6h4"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M10 10h4"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$d7cfde09abbb52ee(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("rect", {
                x: "3",
                y: "3",
                width: "7",
                height: "7",
                rx: "1"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("rect", {
                x: "14",
                y: "3",
                width: "7",
                height: "4",
                rx: "1"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("rect", {
                x: "14",
                y: "10",
                width: "7",
                height: "11",
                rx: "1"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("rect", {
                x: "3",
                y: "13",
                width: "7",
                height: "8",
                rx: "1"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$e3c036464abb30f5(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("rect", {
                x: "8",
                y: "2",
                width: "8",
                height: "4",
                rx: "1"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M12 11h4M12 16h4M8 11h.01M8 16h.01"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$207fc5b9a0494333(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "m9 12 2 2 4-4"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$996a671af5cb17c2(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("line", {
                x1: "3",
                y1: "22",
                x2: "21",
                y2: "22"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("line", {
                x1: "6",
                y1: "18",
                x2: "6",
                y2: "11"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("line", {
                x1: "10",
                y1: "18",
                x2: "10",
                y2: "11"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("line", {
                x1: "14",
                y1: "18",
                x2: "14",
                y2: "11"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("line", {
                x1: "18",
                y1: "18",
                x2: "18",
                y2: "11"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("polygon", {
                points: "12 2 20 7 4 7"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$ff497d20f87197ae(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M16 8H8M16 12H8M10 16H8"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$ca978cd35363e096(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("rect", {
                x: "2",
                y: "7",
                width: "20",
                height: "14",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$8dbe4c747de8c5e2(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M12 21c-4-3.2-7-6.8-7-10a7 7 0 1 1 14 0c0 3.2-3 6.8-7 10z"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("circle", {
                cx: "12",
                cy: "11",
                r: "2.5",
                fill: "currentColor",
                stroke: "none"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$1888ff721e893d0e(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        fill: "currentColor",
        stroke: "none",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("rect", {
                x: "4",
                y: "5",
                width: "16",
                height: "3.5",
                rx: "0.75"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("rect", {
                x: "4",
                y: "11",
                width: "11",
                height: "3.5",
                rx: "0.75"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("rect", {
                x: "4",
                y: "17",
                width: "14",
                height: "3.5",
                rx: "0.75"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$9ea67044193f5b74(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M4 10.5V19a1 1 0 0 0 1 1h5v-8H4z"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M14 20h5a1 1 0 0 0 1-1v-8.5l-6-3.5v12z"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M12 2 4 6.5 12 11l8-4.5L12 2z"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$b0c934bdae14c9ef(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83z"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M22 12.65l-9.05 4.13a2 2 0 0 1-1.9 0L2 12.65"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "m2 17 9.05 4.13a2 2 0 0 0 1.9 0L22 17"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$60b42ba963c1b0af(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        width: 18,
        height: 18,
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
            d: "m15 18-6-6 6-6M21 12H9"
        })
    });
}
function $33a10e4dd89b1f49$export$96bab9f815fe7c91(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M12 4v10"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "m8 10 4 4 4-4"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M5 20h14"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$a6e57fbaa96aaaf9(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M12 20V10"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "m8 14 4-4 4 4"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M5 4h14"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$1075a81d4806599f(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("circle", {
                cx: "12",
                cy: "8",
                r: "3.5"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M5 20v-1.5a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5V20"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$94155298424a8522(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
            d: "M4 6h16M4 12h16M4 18h16"
        })
    });
}
function $33a10e4dd89b1f49$export$e04bcc6127e699bf(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
            d: "M18 6 6 18M6 6l12 12"
        })
    });
}
function $33a10e4dd89b1f49$export$ae118f79ed05e2c0(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
            d: "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2M9 12h6M9 16h4"
        })
    });
}
function $33a10e4dd89b1f49$export$625671e92c10ce58(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("polygon", {
            points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
        })
    });
}
function $33a10e4dd89b1f49$export$a53026e91890dfa1(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("polyline", {
                points: "14 2 14 8 20 8"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("line", {
                x1: "16",
                y1: "13",
                x2: "8",
                y2: "13"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("line", {
                x1: "16",
                y1: "17",
                x2: "8",
                y2: "17"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("polyline", {
                points: "10 9 9 9 8 9"
            })
        ]
    });
}
function $33a10e4dd89b1f49$export$1aeec9750ae9fdbe(props) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
        ...$33a10e4dd89b1f49$var$iconProps(props),
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("polyline", {
                points: "7 10 12 15 17 10"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("line", {
                x1: "12",
                y1: "15",
                x2: "12",
                y2: "3"
            })
        ]
    });
}





function $59972e6b0bfdceeb$export$53f1cd6809577fc5({ breadcrumb: breadcrumb, title: title, subtitle: subtitle, badge: badge, actions: actions }) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("header", {
        className: "page-header",
        children: [
            breadcrumb && breadcrumb.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("nav", {
                className: "page-header__crumb",
                "aria-label": "Breadcrumb",
                children: breadcrumb.map((c, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                        className: "page-header__crumb-item",
                        children: [
                            i > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$3f284407ead563ae), {
                                className: "page-header__crumb-sep"
                            }) : null,
                            c.to ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: c.to,
                                children: c.label
                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "page-header__crumb-current",
                                children: c.label
                            })
                        ]
                    }, i))
            }) : null,
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "page-header__row",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h1", {
                                className: "page-header__title",
                                children: title
                            }),
                            subtitle ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "page-header__subtitle",
                                children: subtitle
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "page-header__aside",
                        children: [
                            badge,
                            actions
                        ]
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");
/** Base URL for the Express API (geo directory, applicants, masters, inventory). */ function $3007f8decf026d71$export$4d28219d42798a75() {
    if (typeof window !== "undefined") {
        const { protocol: protocol, hostname: hostname, port: port } = window.location;
        const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";
        if (isLocalhost) return `${protocol}//${hostname}:4000`;
        // Dev UI (Parcel) and API run on different ports; support LAN/IP access too.
        if (port === "3000" || port === "3001" || port === "5173" || port === "1234") return `${protocol}//${hostname}:4000`;
        return `${protocol}//${hostname}${port ? `:${port}` : ""}`;
    }
    return "http://localhost:4000";
}


const $ef26d4be1347a164$var$TOKEN_KEY = "indiramma_console_token";
function $ef26d4be1347a164$export$460d9df55d49597b() {
    try {
        return sessionStorage.getItem($ef26d4be1347a164$var$TOKEN_KEY);
    } catch  {
        return null;
    }
}
function $ef26d4be1347a164$export$12777b2a2d9ad4c8(token) {
    try {
        if (token) sessionStorage.setItem($ef26d4be1347a164$var$TOKEN_KEY, token);
        else sessionStorage.removeItem($ef26d4be1347a164$var$TOKEN_KEY);
    } catch  {
    /* ignore */ }
}
function $ef26d4be1347a164$export$5341712c39afc62d(input, init) {
    const headers = new Headers(init?.headers);
    const t = $ef26d4be1347a164$export$460d9df55d49597b();
    if (t) headers.set("Authorization", `Bearer ${t}`);
    return fetch(input, {
        ...init,
        headers: headers
    });
}




function $33b81a08b9616b5e$var$queryString(filters) {
    const q = new URLSearchParams();
    if (filters.limit != null) q.set("limit", String(filters.limit));
    if (filters.offset != null) q.set("offset", String(filters.offset));
    if (filters.action?.trim()) q.set("action", filters.action.trim());
    if (filters.module?.trim()) q.set("module", filters.module.trim());
    if (filters.userId?.trim()) q.set("userId", filters.userId.trim());
    if (filters.search?.trim()) q.set("search", filters.search.trim());
    if (filters.dateFrom?.trim()) q.set("dateFrom", filters.dateFrom.trim());
    if (filters.dateTo?.trim()) q.set("dateTo", filters.dateTo.trim());
    const s = q.toString();
    return s ? `?${s}` : "";
}
async function $33b81a08b9616b5e$var$parseError(res) {
    const j = await res.json().catch(()=>({}));
    return j.error || `Request failed (${res.status})`;
}
async function $33b81a08b9616b5e$export$4c211303ab974432(filters = {}) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/audit-log${$33b81a08b9616b5e$var$queryString(filters)}`);
    if (!res.ok) throw new Error(await $33b81a08b9616b5e$var$parseError(res));
    return res.json();
}
async function $33b81a08b9616b5e$export$24ad360e9081eb86() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/audit-log/filters`);
    if (!res.ok) throw new Error(await $33b81a08b9616b5e$var$parseError(res));
    return res.json();
}
async function $33b81a08b9616b5e$export$5a253531fa7ab065() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/auth/logout`, {
        method: "POST"
    });
    if (!res.ok) throw new Error(await $33b81a08b9616b5e$var$parseError(res));
}
async function $33b81a08b9616b5e$export$2ca5ef4560722a5a(payload) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/audit-log/client-event`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
    });
    if (!res.ok) throw new Error(await $33b81a08b9616b5e$var$parseError(res));
}
const $33b81a08b9616b5e$export$dab3a70ac2b18cc6 = {
    login: "Sign in",
    login_failed: "Sign in failed",
    logout: "Sign out",
    password_change: "Password change",
    page_view: "Page opened",
    client_action: "UI action",
    view: "View",
    create: "Create",
    update: "Update",
    delete: "Delete",
    export: "Export",
    import: "Import",
    other: "Other"
};


function $a4dc0d923ddf5b19$var$normalizeConsoleRole(role) {
    return String(role ?? "").trim().toLowerCase() === "superadmin" ? "superadmin" : "admin";
}
function $a4dc0d923ddf5b19$var$normalizeConsoleUser(u) {
    return {
        ...u,
        role: $a4dc0d923ddf5b19$var$normalizeConsoleRole(u.role)
    };
}
const $a4dc0d923ddf5b19$var$AuthContext = /*#__PURE__*/ (0, $7UyaH.createContext)(null);
function $a4dc0d923ddf5b19$export$87091915187a1a85({ children: children }) {
    const [loading, setLoading] = (0, $7UyaH.useState)(true);
    const [authRequired, setAuthRequired] = (0, $7UyaH.useState)(false);
    const [user, setUser] = (0, $7UyaH.useState)(null);
    const refresh = (0, $7UyaH.useCallback)(async ()=>{
        const base = (0, $3007f8decf026d71$export$4d28219d42798a75)();
        const cfgRes = await fetch(`${base}/api/auth/config`);
        const cfg = await cfgRes.json();
        const required = Boolean(cfg.authRequired);
        setAuthRequired(required);
        if (!required) {
            setUser({
                id: "local-bypass",
                email: "",
                displayName: "Console user",
                role: "superadmin",
                permissions: [],
                inventoryStoreYardIds: null
            });
            setLoading(false);
            return;
        }
        const token = (0, $ef26d4be1347a164$export$460d9df55d49597b)();
        if (!token) {
            setUser(null);
            setLoading(false);
            return;
        }
        const meRes = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${base}/api/auth/me`);
        if (!meRes.ok) {
            (0, $ef26d4be1347a164$export$12777b2a2d9ad4c8)(null);
            setUser(null);
            setLoading(false);
            return;
        }
        const me = await meRes.json();
        setUser(me.user ? $a4dc0d923ddf5b19$var$normalizeConsoleUser(me.user) : null);
        setLoading(false);
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        refresh();
    }, [
        refresh
    ]);
    const login = (0, $7UyaH.useCallback)(async (email, password)=>{
        const base = (0, $3007f8decf026d71$export$4d28219d42798a75)();
        const res = await fetch(`${base}/api/auth/login`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email,
                password: password
            })
        });
        const j = await res.json().catch(()=>({}));
        if (!res.ok) throw new Error(j.error || `Sign-in failed (${res.status})`);
        if (!j.token || !j.user) throw new Error("Invalid server response");
        (0, $ef26d4be1347a164$export$12777b2a2d9ad4c8)(j.token);
        await refresh();
        return $a4dc0d923ddf5b19$var$normalizeConsoleUser(j.user);
    }, [
        refresh
    ]);
    const logout = (0, $7UyaH.useCallback)(()=>{
        (0, $33b81a08b9616b5e$export$5a253531fa7ab065)().catch(()=>{});
        (0, $ef26d4be1347a164$export$12777b2a2d9ad4c8)(null);
        setUser(null);
    }, []);
    const can = (0, $7UyaH.useCallback)((permission)=>{
        if (!authRequired) return true;
        const u = user;
        if (!u) return false;
        if ($a4dc0d923ddf5b19$var$normalizeConsoleRole(u.role) === "superadmin") return true;
        return u.permissions.includes(permission);
    }, [
        authRequired,
        user
    ]);
    const value = (0, $7UyaH.useMemo)(()=>({
            loading: loading,
            authRequired: authRequired,
            user: user,
            refresh: refresh,
            login: login,
            logout: logout,
            can: can
        }), [
        loading,
        authRequired,
        user,
        refresh,
        login,
        logout,
        can
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($a4dc0d923ddf5b19$var$AuthContext.Provider, {
        value: value,
        children: children
    });
}
function $a4dc0d923ddf5b19$export$1d39dc5b47e56ff0() {
    const ctx = (0, $7UyaH.useContext)($a4dc0d923ddf5b19$var$AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}




var $7UyaH = parcelRequire("7UyaH");
const $ce780ac49d598440$export$c13712588543892c = [];


const $bd4ee692b2cc7ffa$export$6925b7841b550cf7 = [
    {
        id: "mt-1",
        title: "Phase 1 \u2014 Substructure & materials",
        notes: "Standard checks before slab: materials on site and statutory receipts.",
        sortOrder: 1,
        createdAt: "2026-03-01T09:00:00",
        linkedConstructionTimelinePhaseIds: [
            "1",
            "2"
        ],
        linkedResourceIds: [
            "sr-cement",
            "sr-steel",
            "sr-bricks",
            "sr-sand",
            "sr-aggregate"
        ],
        items: [
            {
                id: "mti-1-1",
                kind: "material",
                label: "Cement & steel \u2014 supplier challan verified on site"
            },
            {
                id: "mti-1-2",
                kind: "govt_bill",
                label: "Treasury / departmental receipt as per scheme circular"
            }
        ]
    },
    {
        id: "mt-2",
        title: "Phase 2 \u2014 Work execution & bills",
        notes: "Work-done bill on dossier; subcontractor invoice for the phase.",
        sortOrder: 2,
        createdAt: "2026-03-01T09:00:00",
        linkedConstructionTimelinePhaseIds: [
            "5"
        ],
        linkedResourceIds: [
            "sr-flooring",
            "sr-windows",
            "sr-doors"
        ],
        items: [
            {
                id: "mti-2-1",
                kind: "work_done_bill",
                label: "Work-done bill on Bills tab \u2014 site seeding re-verification completed"
            },
            {
                id: "mti-2-2",
                kind: "subcontractor_bill",
                label: "Subcontractor / vendor invoice for this construction phase"
            }
        ]
    },
    {
        id: "mt-3",
        title: "Phase 3 \u2014 Completion & handover",
        notes: "Close work order and obtain GP / local body certificate.",
        sortOrder: 3,
        createdAt: "2026-03-01T09:00:00",
        linkedConstructionTimelinePhaseIds: [
            "10"
        ],
        linkedResourceIds: [
            "sr-painting",
            "sr-sanitary",
            "sr-kitchen",
            "sr-electrical"
        ],
        items: [
            {
                id: "mti-3-1",
                kind: "subcontractor_bill",
                label: "Subcontractor work order on file matches executed work"
            },
            {
                id: "mti-3-2",
                kind: "govt_bill",
                label: "GP / local body final inspection certificate"
            }
        ]
    }
];


const $c3c3290151cc5467$export$521b1267ae5a2cd5 = [
    {
        id: "zone-001",
        name: "Greater Hyderabad \u2014 demo",
        notes: "Example zone covering two full districts. Add mandals or villages below for finer splits.",
        districtKeys: [
            "hyderabad",
            "rangareddy"
        ],
        mandalRefs: [],
        villageRefs: [],
        sortOrder: 0,
        createdAt: new Date().toISOString()
    }
];


const $b7582ef8fb24080c$export$62a8b921bc681945 = [
    {
        id: "1",
        title: "Home Design & Approval",
        approxDays: 46,
        sortOrder: 1,
        createdAt: "2025-01-01T00:00:00.000Z"
    },
    {
        id: "2",
        title: "Excavation",
        approxDays: 14,
        sortOrder: 2,
        createdAt: "2025-01-01T00:00:00.000Z"
    },
    {
        id: "3",
        title: "Footing & Foundation",
        approxDays: 41,
        sortOrder: 3,
        createdAt: "2025-01-01T00:00:00.000Z"
    },
    {
        id: "4",
        title: "RCC Work - Columns & Slabs",
        approxDays: 17,
        sortOrder: 4,
        createdAt: "2025-01-01T00:00:00.000Z"
    },
    {
        id: "5",
        title: "Roof Slab",
        approxDays: 37,
        sortOrder: 5,
        createdAt: "2025-01-01T00:00:00.000Z"
    },
    {
        id: "6",
        title: "Brickwork and Plastering",
        approxDays: 8,
        sortOrder: 6,
        createdAt: "2025-01-01T00:00:00.000Z"
    },
    {
        id: "7",
        title: "Flooring & Tiling",
        approxDays: 25,
        sortOrder: 7,
        createdAt: "2025-01-01T00:00:00.000Z"
    },
    {
        id: "8",
        title: "Electric Wiring",
        approxDays: 14,
        sortOrder: 8,
        createdAt: "2025-01-01T00:00:00.000Z"
    },
    {
        id: "9",
        title: "Water Supply & Plumbing",
        approxDays: 30,
        sortOrder: 9,
        createdAt: "2025-01-01T00:00:00.000Z"
    },
    {
        id: "10",
        title: "Door",
        approxDays: 15,
        sortOrder: 10,
        createdAt: "2025-01-01T00:00:00.000Z"
    }
];


function $1bdde9dc3a5c5f66$var$line(id, label, quantity, unit) {
    return {
        id: id,
        label: label,
        quantity: quantity,
        unit: unit,
        rate: 0,
        hsnCode: ""
    };
}
const $1bdde9dc3a5c5f66$export$55f73812d18df7d2 = [
    {
        id: "sr-cement",
        title: "Cement",
        notes: "",
        sortOrder: 1,
        createdAt: "2026-01-01T00:00:00.000Z",
        items: [
            $1bdde9dc3a5c5f66$var$line("sri-cement-1", "Bags", 180, "Bag")
        ]
    },
    {
        id: "sr-steel",
        title: "Steel",
        notes: "",
        sortOrder: 2,
        createdAt: "2026-01-01T00:00:00.000Z",
        items: [
            $1bdde9dc3a5c5f66$var$line("sri-steel-1", "Reinforcement", 1400, "KG")
        ]
    },
    {
        id: "sr-bricks",
        title: "Bricks",
        notes: "",
        sortOrder: 3,
        createdAt: "2026-01-01T00:00:00.000Z",
        items: [
            $1bdde9dc3a5c5f66$var$line("sri-bricks-1", "Bricks", 7600, "Nos")
        ]
    },
    {
        id: "sr-aggregate",
        title: "Aggregate",
        notes: "",
        sortOrder: 4,
        createdAt: "2026-01-01T00:00:00.000Z",
        items: [
            $1bdde9dc3a5c5f66$var$line("sri-aggregate-1", "Coarse aggregate", 760, "Cu.ft")
        ]
    },
    {
        id: "sr-sand",
        title: "Sand",
        notes: "",
        sortOrder: 5,
        createdAt: "2026-01-01T00:00:00.000Z",
        items: [
            $1bdde9dc3a5c5f66$var$line("sri-sand-1", "Fine aggregate", 800, "Cu.ft")
        ]
    },
    {
        id: "sr-flooring",
        title: "Flooring",
        notes: "",
        sortOrder: 6,
        createdAt: "2026-01-01T00:00:00.000Z",
        items: [
            $1bdde9dc3a5c5f66$var$line("sri-flooring-1", "Flooring area", 400, "Sq.ft")
        ]
    },
    {
        id: "sr-windows",
        title: "Windows",
        notes: "",
        sortOrder: 7,
        createdAt: "2026-01-01T00:00:00.000Z",
        items: [
            $1bdde9dc3a5c5f66$var$line("sri-windows-1", "Glazing", 68, "Sq.ft")
        ]
    },
    {
        id: "sr-doors",
        title: "Doors",
        notes: "",
        sortOrder: 8,
        createdAt: "2026-01-01T00:00:00.000Z",
        items: [
            $1bdde9dc3a5c5f66$var$line("sri-doors-1", "Door openings / shutters", 72, "Sq.ft")
        ]
    },
    {
        id: "sr-electrical",
        title: "Electrical fittings",
        notes: "",
        sortOrder: 9,
        createdAt: "2026-01-01T00:00:00.000Z",
        items: [
            $1bdde9dc3a5c5f66$var$line("sri-electrical-1", "Points / area basis", 60, "Sq.ft")
        ]
    },
    {
        id: "sr-painting",
        title: "Painting",
        notes: "",
        sortOrder: 10,
        createdAt: "2026-01-01T00:00:00.000Z",
        items: [
            $1bdde9dc3a5c5f66$var$line("sri-painting-1", "Painted surface", 2400, "Sq.ft")
        ]
    },
    {
        id: "sr-sanitary",
        title: "Sanitary fittings",
        notes: "",
        sortOrder: 11,
        createdAt: "2026-01-01T00:00:00.000Z",
        items: [
            $1bdde9dc3a5c5f66$var$line("sri-sanitary-1", "Bath / WC fittings", 400, "Sq.ft")
        ]
    },
    {
        id: "sr-kitchen",
        title: "Kitchen work",
        notes: "",
        sortOrder: 12,
        createdAt: "2026-01-01T00:00:00.000Z",
        items: [
            $1bdde9dc3a5c5f66$var$line("sri-kitchen-1", "Platform / units", 22, "Sq.ft")
        ]
    }
];


const $1f0de4d313af0047$export$54634ec24677b433 = [];


const $55c7b7811dd972f9$export$eb0be9ca29aee85 = [];


function $75ee0f08bbd50d82$export$a6798fb462b4557(resources) {
    return [
        ...resources
    ].sort((a, b)=>a.sortOrder - b.sortOrder || a.createdAt.localeCompare(b.createdAt));
}


function $e4e128b49dc9c33a$export$5f86a86b0e7bc44c(resources, requested) {
    if (!requested?.length) return [];
    const sorted = (0, $75ee0f08bbd50d82$export$a6798fb462b4557)(resources);
    const valid = new Set(sorted.map((r)=>r.id));
    const kept = [
        ...new Set(requested.filter((id)=>valid.has(id)))
    ];
    const orderIndex = new Map(sorted.map((r, i)=>[
            r.id,
            i
        ]));
    kept.sort((a, b)=>(orderIndex.get(a) ?? 999) - (orderIndex.get(b) ?? 999));
    return kept;
}


function $d0dce9c7337efc65$export$107c6562c1e7acbf(phases) {
    return [
        ...phases
    ].sort((a, b)=>a.sortOrder - b.sortOrder || a.createdAt.localeCompare(b.createdAt));
}
function $d0dce9c7337efc65$export$4ef55ade8bc0483f(phases) {
    return phases.reduce((s, p)=>s + Math.max(0, Math.floor(Number(p.approxDays)) || 0), 0);
}
/** Integer “nice” step for day axis labels (1, 2, 5, 10, 20, …). */ function $d0dce9c7337efc65$var$pickNiceStepDays(rough) {
    const r = Math.max(1, rough);
    const exp = Math.floor(Math.log10(r));
    const f = r / 10 ** exp;
    const nf = f <= 1 ? 1 : f <= 2 ? 2 : f <= 5 ? 5 : 10;
    return Math.max(1, Math.round(nf * 10 ** exp));
}
function $d0dce9c7337efc65$export$df32fb333183f243(planTotalDays, opts) {
    const plan = Math.max(0, Math.floor(Number(planTotalDays)) || 0);
    const loggedRaw = opts?.loggedTotalDays;
    const logged = typeof loggedRaw === "number" && Number.isFinite(loggedRaw) ? Math.max(0, Math.floor(loggedRaw)) : 0;
    const content = Math.max(1, plan, logged);
    const padded = content + Math.max(1, Math.ceil(content * 0.05));
    const divisions = 5;
    let step = $d0dce9c7337efc65$var$pickNiceStepDays(padded / divisions);
    let axisMax = Math.max(step, Math.ceil(padded / step) * step);
    while(step > 1 && axisMax / step > 10){
        step = $d0dce9c7337efc65$var$pickNiceStepDays(step * 2);
        axisMax = Math.max(step, Math.ceil(padded / step) * step);
    }
    const ticks = [];
    for(let d = 0; d <= axisMax + 1e-6; d += step)ticks.push(Math.round(d));
    if (ticks.length === 0) return {
        axisMax: 1,
        ticks: [
            0,
            1
        ]
    };
    if (ticks[ticks.length - 1] !== axisMax) ticks.push(axisMax);
    return {
        axisMax: axisMax,
        ticks: ticks
    };
}


function $3f88d14095f8d1ef$export$b04e1fe63c3eed32(phases, requested) {
    if (!requested?.length) return [];
    const valid = new Set(phases.map((p)=>p.id));
    const kept = [
        ...new Set(requested.filter((id)=>valid.has(id)))
    ];
    const sorted = (0, $d0dce9c7337efc65$export$107c6562c1e7acbf)(phases.filter((p)=>kept.includes(p.id)));
    return sorted.map((p)=>p.id);
}


function $4e76812a1de0ff51$export$5da2424f5db665c1(applications, templates) {
    const sorted = [
        ...templates
    ].sort((a, b)=>a.sortOrder - b.sortOrder);
    return applications.map((app)=>{
        const existing = new Map(app.milestoneProgress.map((p)=>[
                p.templateId,
                p
            ]));
        const next = [];
        for (const t of sorted){
            const prev = existing.get(t.id);
            const byItem = prev ? new Map(prev.itemProgress.map((ip)=>[
                    ip.templateItemId,
                    ip
                ])) : new Map();
            const itemProgress = t.items.map((it)=>{
                const old = byItem.get(it.id);
                return {
                    templateItemId: it.id,
                    completedAt: old?.completedAt ?? null,
                    workDoneBillId: old?.workDoneBillId ?? null
                };
            });
            next.push({
                templateId: t.id,
                itemProgress: itemProgress,
                milestoneCompletedAt: prev?.milestoneCompletedAt ?? null
            });
        }
        return {
            ...app,
            milestoneProgress: next
        };
    });
}


function $3655432918d5e89d$export$563fe0138d49a54b(w) {
    return w === true || w === "need_to_apply";
}


function $85279307e2bde4bc$export$37638785e8c5d933() {
    return {
        subcontractorMasterId: null,
        workOrderFileName: null,
        linkedAt: undefined
    };
}
function $85279307e2bde4bc$export$fddc63ff7a5a0fb3() {
    return {
        contactPersonName: "",
        firmName: "",
        registeredAddress: "",
        firmRegistrationId: "",
        gstNumber: "",
        contactPhone: "",
        contactEmail: "",
        aadhaarNumber: "",
        bankAccountNumber: "",
        bankIfsc: "",
        bankBranchName: "",
        bankName: "",
        bankAccountName: "",
        cancelChequeFileName: null,
        cancelChequeStored: false,
        aadharDocFileName: null,
        aadharDocStored: false,
        gstCertFileName: null,
        gstCertStored: false,
        udyamMsmeFileName: null,
        udyamMsmeStored: false,
        labourLicenseFileName: null,
        labourLicenseStored: false
    };
}
function $85279307e2bde4bc$export$d8ac17f31f15df5a(s) {
    return String(s ?? "").replace(/\D/g, "").slice(0, 12);
}
function $85279307e2bde4bc$export$5bf1a55ea00136f3(ifsc) {
    return /^[A-Z]{4}0[A-Z0-9]{6}$/.test(String(ifsc ?? "").trim().toUpperCase());
}
function $85279307e2bde4bc$export$e7b029b2733ccf32(m) {
    if (!m) return false;
    const gst = m.gstNumber.trim().toUpperCase();
    if (gst.length > 0 && !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gst)) return false;
    const aadhaar = $85279307e2bde4bc$export$d8ac17f31f15df5a(m.aadhaarNumber);
    return Boolean(m.contactPersonName.trim() && m.firmName.trim() && m.contactPhone.trim() && /^[0-9]{12}$/.test(aadhaar) && m.bankAccountName.trim() && m.bankBranchName.trim() && m.bankName.trim() && m.bankAccountNumber.trim() && $85279307e2bde4bc$export$5bf1a55ea00136f3(m.bankIfsc) && m.cancelChequeStored && m.aadharDocStored && m.udyamMsmeStored && m.labourLicenseStored);
}
function $85279307e2bde4bc$export$87d4bc3ee3ec5ea2(masters, id) {
    if (!id) return undefined;
    return masters.find((x)=>x.id === id);
}
function $85279307e2bde4bc$export$148e14a666d94fa1(link, master) {
    if (!link.subcontractorMasterId || !$85279307e2bde4bc$export$e7b029b2733ccf32(master)) return false;
    return true;
}
function $85279307e2bde4bc$export$988e90fdcfd433ba(a, _masters) {
    if (a.holdReasons.length > 0) return "on_hold";
    const v = a.validations;
    const coreOk = v.nameMatchAcrossSources === true && v.aadhaarVerified === true && v.bankAccountVerified === true && (0, $3655432918d5e89d$export$563fe0138d49a54b)(v.workmanCardAcceptable);
    if (!coreOk) return "pending_validation";
    if (!v.aadhaarSeedingConfirmed) return "pending_validation";
    const iciciFieldsComplete = Boolean(a.ho.iciciAccountNumber.trim()) && Boolean(a.ho.iciciIfsc.trim()) && Boolean(a.ho.iciciBranch.trim());
    if (!iciciFieldsComplete) return "ready_for_icici";
    const hasMou = Boolean(a.ho.mouFileName) || Boolean(a.ho.mouFileStored) || Array.isArray(a.ho.mouAttachments) && a.ho.mouAttachments.length > 0;
    if (!hasMou) return "ready_for_mou";
    // Linkage is confirmed once the officer clicked "Record subcontractor" (linkedAt set).
    // Do not re-check master completeness here — the completeness gate is enforced at save time
    // in finalizeSubcontractor; re-checking it on every derive would clear a valid linked status
    // whenever a master field is temporarily incomplete.
    if (a.subcontractor.subcontractorMasterId && a.subcontractor.linkedAt) return "subcontractor_linked";
    return "icici_recorded";
}
function $85279307e2bde4bc$export$df42b932a5162b49(a, masters) {
    const cleared = a.holdReasons.length > 0 ? {
        ...a,
        holdReasons: []
    } : a;
    return $85279307e2bde4bc$export$988e90fdcfd433ba(cleared, masters);
}
function $85279307e2bde4bc$export$3cda207770a484f5(app) {
    if (app.holdReasons.length > 0) return false;
    const v = app.validations;
    const coreOk = v.nameMatchAcrossSources === true && v.aadhaarVerified === true && v.bankAccountVerified === true && (0, $3655432918d5e89d$export$563fe0138d49a54b)(v.workmanCardAcceptable) && v.aadhaarSeedingConfirmed;
    const hoComplete = Boolean(app.ho.iciciAccountNumber.trim()) && Boolean(app.ho.iciciIfsc.trim()) && Boolean(app.ho.iciciBranch.trim()) && Boolean(app.ho.mouFileName || app.ho.mouFileStored || Array.isArray(app.ho.mouAttachments) && app.ho.mouAttachments.length > 0);
    if (!coreOk || !hoComplete) return false;
    if (app.workDoneBills.some((b)=>!b.seedingReVerified)) return false;
    return true;
}



function $f34886e55d1cc894$export$a8d188a5e3c35f58() {
    return {
        engineerMasterId: null,
        linkedAt: undefined
    };
}
function $f34886e55d1cc894$export$2a0dc13f7a78d8d8(masters, id) {
    const sid = String(id ?? "").trim();
    if (!sid) return undefined;
    return masters.find((x)=>String(x.id ?? "").trim() === sid);
}
function $f34886e55d1cc894$export$f0f2b8010c8b5f80(m) {
    if (!m) return false;
    const name = String(m.fullName ?? "").trim();
    const phone = String(m.phone ?? "").trim();
    return Boolean(name && phone);
}
function $f34886e55d1cc894$export$2654cb00f18a4c7(link, master) {
    const mid = String(link.engineerMasterId ?? "").trim();
    if (!mid || !$f34886e55d1cc894$export$f0f2b8010c8b5f80(master)) return false;
    return true;
}
function $f34886e55d1cc894$export$4ec30dfd1501cd30(app) {
    return (0, $85279307e2bde4bc$export$3cda207770a484f5)(app);
}


/** Must match server `consolePermissionMap.js` assignable keys (except superadmin). */ const $ce83db1d656d565a$export$86f7433f72a3b447 = [
    "milestone_templates",
    "construction_timeline",
    "standard_resources",
    "standard_item_catalogue"
];
const $ce83db1d656d565a$export$46b620a78cd4a58c = [
    "inventory_issue_po",
    "inventory_issue_material",
    "inventory_inward",
    "inventory_goods_receipts",
    "inventory_store_stocks",
    "inventory_stores_yards",
    "inventory_outward"
];
function $ce83db1d656d565a$export$761e56307d10af4(can) {
    return $ce83db1d656d565a$export$86f7433f72a3b447.some((k)=>can(k));
}
function $ce83db1d656d565a$export$f1c8f55ee0acd164(can) {
    return $ce83db1d656d565a$export$46b620a78cd4a58c.some((k)=>can(k));
}




var $7UyaH = parcelRequire("7UyaH");
const $62ce12c72c1ea784$var$ToastContext = /*#__PURE__*/ (0, $7UyaH.createContext)(null);
const $62ce12c72c1ea784$var$TOAST_MS = 5200;
const $62ce12c72c1ea784$var$TOAST_MS_ERROR_LONG = 14000;
function $62ce12c72c1ea784$export$f5d03d415824e0e({ children: children }) {
    const [toasts, setToasts] = (0, $7UyaH.useState)([]);
    const dismissToast = (0, $7UyaH.useCallback)((id)=>{
        setToasts((t)=>t.filter((x)=>x.id !== id));
    }, []);
    const showToast = (0, $7UyaH.useCallback)((message, variant = "info", durationMs)=>{
        const id = `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
        setToasts((t)=>[
                ...t,
                {
                    id: id,
                    message: message,
                    variant: variant
                }
            ]);
        const ms = durationMs ?? (variant === "error" && message.length > 120 ? $62ce12c72c1ea784$var$TOAST_MS_ERROR_LONG : $62ce12c72c1ea784$var$TOAST_MS);
        window.setTimeout(()=>dismissToast(id), ms);
    }, [
        dismissToast
    ]);
    const toastValue = (0, $7UyaH.useMemo)(()=>({
            showToast: showToast,
            dismissToast: dismissToast
        }), [
        showToast,
        dismissToast
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)($62ce12c72c1ea784$var$ToastContext.Provider, {
        value: toastValue,
        children: [
            children,
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "toast-viewport",
                "aria-live": "polite",
                "aria-relevant": "additions text",
                children: toasts.map((t)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("button", {
                        type: "button",
                        className: `toast toast--${t.variant}`,
                        onClick: ()=>dismissToast(t.id),
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "toast__message",
                                children: t.message
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "toast__dismiss",
                                "aria-hidden": true,
                                children: "\xd7"
                            })
                        ]
                    }, t.id))
            })
        ]
    });
}
function $62ce12c72c1ea784$export$a407b657d3044108() {
    const ctx = (0, $7UyaH.useContext)($62ce12c72c1ea784$var$ToastContext);
    if (!ctx) throw new Error("useToast must be used within ToastProvider");
    return ctx;
}


const $4aabdb75dcf6b773$export$789d16b94f94ef4f = [
    "dossier_tab_overview",
    "dossier_tab_beneficiary",
    "dossier_tab_validation",
    "dossier_tab_banking",
    "dossier_tab_subcontractor",
    "dossier_tab_engineer",
    "dossier_tab_work_progress",
    "dossier_tab_po_register",
    "dossier_tab_milestones",
    "dossier_tab_bills"
];
const $4aabdb75dcf6b773$export$1499c2a217c417d1 = [
    "applications",
    ...$4aabdb75dcf6b773$export$789d16b94f94ef4f
];
const $4aabdb75dcf6b773$export$b8157996bdb9c190 = {
    overview: "dossier_tab_overview",
    beneficiary: "dossier_tab_beneficiary",
    validation: "dossier_tab_validation",
    banking: "dossier_tab_banking",
    subcontractor: "dossier_tab_subcontractor",
    engineer: "dossier_tab_engineer",
    "work-progress": "dossier_tab_work_progress",
    "po-register": "dossier_tab_po_register",
    milestones: "dossier_tab_milestones",
    bills: "dossier_tab_bills"
};
function $4aabdb75dcf6b773$export$8f84a4e698ab11e9(can) {
    return can("applications") || $4aabdb75dcf6b773$export$789d16b94f94ef4f.some((k)=>can(k));
}
const $4aabdb75dcf6b773$export$927907d58b89b755 = "applications_no_edit";
function $4aabdb75dcf6b773$export$6e313773bb334ada(can) {
    return $4aabdb75dcf6b773$export$8f84a4e698ab11e9(can) && !can($4aabdb75dcf6b773$export$927907d58b89b755);
}
function $4aabdb75dcf6b773$export$96e9d18fd02a12c4(can) {
    return can("milestone_templates") && (can("applications") || can("dossier_tab_milestones"));
}


const $18b0587275e330a6$export$46656e56d2945c2c = [
    "inventory_inward",
    "inventory_outward",
    "inventory_store_stocks",
    "inventory_goods_receipts",
    "inventory_issue_po",
    "inventory_issue_material"
];
function $18b0587275e330a6$export$d1ee338f4fd08fe6(perm) {
    return $18b0587275e330a6$export$46656e56d2945c2c.some((k)=>Boolean(perm[k]));
}
function $18b0587275e330a6$export$18bc13b6ea552914(yards, user, authRequired) {
    if (!authRequired || !user || user.role === "superadmin") return yards;
    const scoped = user.inventoryStoreYardIds;
    if (!Array.isArray(scoped) || scoped.length === 0) return yards;
    const allow = new Set(scoped);
    return yards.filter((y)=>allow.has(y.id));
}





async function $e532bc2b6b908ae9$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
async function $e532bc2b6b908ae9$export$7db166ab3be0794() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/construction-timeline/phases`);
    if (!res.ok) throw new Error(await $e532bc2b6b908ae9$var$parseError(res));
    return res.json();
}
async function $e532bc2b6b908ae9$export$767f900e3e8a8f5a(input) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/construction-timeline/phases`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(input)
    });
    if (!res.ok) throw new Error(await $e532bc2b6b908ae9$var$parseError(res));
    return res.json();
}
async function $e532bc2b6b908ae9$export$dc5661b07d07312e(id, patch) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/construction-timeline/phases/${encodeURIComponent(id)}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(patch)
    });
    if (!res.ok) throw new Error(await $e532bc2b6b908ae9$var$parseError(res));
    return res.json();
}
async function $e532bc2b6b908ae9$export$b70f8654c359f8e9(id) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/construction-timeline/phases/${encodeURIComponent(id)}`, {
        method: "DELETE"
    });
    if (!res.ok && res.status !== 204) throw new Error(await $e532bc2b6b908ae9$var$parseError(res));
}
async function $e532bc2b6b908ae9$export$d4b524073f2183c1(orderedIds) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/construction-timeline/phases/reorder`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            orderedIds: orderedIds
        })
    });
    if (!res.ok) throw new Error(await $e532bc2b6b908ae9$var$parseError(res));
    return res.json();
}




async function $770fd32f52113801$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
async function $770fd32f52113801$export$6aa64b79d921e94c() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/standard-resources`);
    if (!res.ok) throw new Error(await $770fd32f52113801$var$parseError(res));
    return res.json();
}
async function $770fd32f52113801$export$e4768a598e556f55(input) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/standard-resources`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            title: input.title,
            notes: input.notes ?? ""
        })
    });
    if (!res.ok) throw new Error(await $770fd32f52113801$var$parseError(res));
    return res.json();
}
async function $770fd32f52113801$export$81c1f409299664de(id, patch) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/standard-resources/${encodeURIComponent(id)}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(patch)
    });
    if (!res.ok) throw new Error(await $770fd32f52113801$var$parseError(res));
    return res.json();
}
async function $770fd32f52113801$export$e8724159a682356b(id) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/standard-resources/${encodeURIComponent(id)}`, {
        method: "DELETE"
    });
    if (!res.ok && res.status !== 204) throw new Error(await $770fd32f52113801$var$parseError(res));
}
async function $770fd32f52113801$export$9f48b439795ba993(orderedIds) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/standard-resources/reorder`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            orderedIds: orderedIds
        })
    });
    if (!res.ok) throw new Error(await $770fd32f52113801$var$parseError(res));
    return res.json();
}
async function $770fd32f52113801$export$e69e3efefa3377c9(resourceId, item) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/standard-resources/${encodeURIComponent(resourceId)}/items`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(item)
    });
    if (!res.ok) throw new Error(await $770fd32f52113801$var$parseError(res));
    return res.json();
}
async function $770fd32f52113801$export$343b389b20705f71(resourceId, itemId, patch) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/standard-resources/${encodeURIComponent(resourceId)}/items/${encodeURIComponent(itemId)}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(patch)
    });
    if (!res.ok) throw new Error(await $770fd32f52113801$var$parseError(res));
    return res.json();
}
async function $770fd32f52113801$export$984ae53fbee4dfd(resourceId, itemId) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/standard-resources/${encodeURIComponent(resourceId)}/items/${encodeURIComponent(itemId)}`, {
        method: "DELETE"
    });
    if (!res.ok && res.status !== 204) throw new Error(await $770fd32f52113801$var$parseError(res));
}




async function $dd06e1778646a9b0$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
async function $dd06e1778646a9b0$export$8703e8025bc3c32() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/subcontractor-masters`);
    if (!res.ok) throw new Error(await $dd06e1778646a9b0$var$parseError(res));
    return res.json();
}
async function $dd06e1778646a9b0$export$3e853eff120673b4(row) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/subcontractor-masters`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(row)
    });
    if (!res.ok) throw new Error(await $dd06e1778646a9b0$var$parseError(res));
    return res.json();
}
async function $dd06e1778646a9b0$export$84bb4ed868e69465(id, patch) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/subcontractor-masters/${encodeURIComponent(id)}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(patch)
    });
    if (!res.ok) throw new Error(await $dd06e1778646a9b0$var$parseError(res));
    return res.json();
}
async function $dd06e1778646a9b0$export$f690c37bcd62cd34(id) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/subcontractor-masters/${encodeURIComponent(id)}`, {
        method: "DELETE"
    });
    if (!res.ok) throw new Error(await $dd06e1778646a9b0$var$parseError(res));
}




async function $1d8c0bf20c21a404$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
async function $1d8c0bf20c21a404$export$536b9d2fdec42e3a() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/engineer-masters`);
    if (!res.ok) throw new Error(await $1d8c0bf20c21a404$var$parseError(res));
    return res.json();
}
async function $1d8c0bf20c21a404$export$1d921fca6d3f74a5(row) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/engineer-masters`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(row)
    });
    if (!res.ok) throw new Error(await $1d8c0bf20c21a404$var$parseError(res));
    return res.json();
}
async function $1d8c0bf20c21a404$export$b02c53faca2bf40(id, patch) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/engineer-masters/${encodeURIComponent(id)}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(patch)
    });
    if (!res.ok) throw new Error(await $1d8c0bf20c21a404$var$parseError(res));
    return res.json();
}
async function $1d8c0bf20c21a404$export$78aa1e536cf07750(id) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/engineer-masters/${encodeURIComponent(id)}`, {
        method: "DELETE"
    });
    if (!res.ok) throw new Error(await $1d8c0bf20c21a404$var$parseError(res));
}




async function $709afcad7b3e6a59$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
async function $709afcad7b3e6a59$export$dca04a7c35bb5d56() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/geo/zones`);
    if (!res.ok) throw new Error(await $709afcad7b3e6a59$var$parseError(res));
    return res.json();
}
async function $709afcad7b3e6a59$export$ec723fc9d9feee97(input) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/geo/zones`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            name: input.name,
            notes: input.notes ?? ""
        })
    });
    if (!res.ok) throw new Error(await $709afcad7b3e6a59$var$parseError(res));
    return res.json();
}
async function $709afcad7b3e6a59$export$db34b3fc61ba961b(id, patch) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/geo/zones/${encodeURIComponent(id)}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(patch)
    });
    if (!res.ok) throw new Error(await $709afcad7b3e6a59$var$parseError(res));
    return res.json();
}
async function $709afcad7b3e6a59$export$457572f016dcc4eb(id) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/geo/zones/${encodeURIComponent(id)}`, {
        method: "DELETE"
    });
    if (!res.ok && res.status !== 204) throw new Error(await $709afcad7b3e6a59$var$parseError(res));
}
async function $709afcad7b3e6a59$export$d3fc6a04f0462aef(orderedIds) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/geo/zones/reorder`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            orderedIds: orderedIds
        })
    });
    if (!res.ok) throw new Error(await $709afcad7b3e6a59$var$parseError(res));
    return res.json();
}




async function $1b8cd287af9bc7a7$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
async function $1b8cd287af9bc7a7$export$f973e7570430619() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/store-yards`);
    if (!res.ok) throw new Error(await $1b8cd287af9bc7a7$var$parseError(res));
    return res.json();
}
async function $1b8cd287af9bc7a7$export$96c375325f004035(input) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/store-yards`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            name: input.name,
            notes: input.notes ?? "",
            address: input.address ?? ""
        })
    });
    if (!res.ok) throw new Error(await $1b8cd287af9bc7a7$var$parseError(res));
    return res.json();
}
async function $1b8cd287af9bc7a7$export$2bf9a048f41d1cc7(id, patch) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/store-yards/${encodeURIComponent(id)}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(patch)
    });
    if (!res.ok) throw new Error(await $1b8cd287af9bc7a7$var$parseError(res));
    return res.json();
}
async function $1b8cd287af9bc7a7$export$1d45872999e4c0da(id) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/store-yards/${encodeURIComponent(id)}`, {
        method: "DELETE"
    });
    if (!res.ok && res.status !== 204) throw new Error(await $1b8cd287af9bc7a7$var$parseError(res));
}
async function $1b8cd287af9bc7a7$export$7a55a23ea3ac9dcc(orderedIds) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/store-yards/reorder`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            orderedIds: orderedIds
        })
    });
    if (!res.ok) throw new Error(await $1b8cd287af9bc7a7$var$parseError(res));
    return res.json();
}




async function $e48301f2885073ff$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
async function $e48301f2885073ff$export$7ed8424b05ae1c89() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/milestone-templates`);
    if (!res.ok) throw new Error(await $e48301f2885073ff$var$parseError(res));
    return res.json();
}
async function $e48301f2885073ff$export$520daa0695ee3a88(input) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/milestone-templates`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            title: input.title,
            notes: input.notes ?? "",
            items: input.items ?? [],
            linkedConstructionTimelinePhaseIds: input.linkedConstructionTimelinePhaseIds ?? [],
            linkedResourceIds: input.linkedResourceIds ?? []
        })
    });
    if (!res.ok) throw new Error(await $e48301f2885073ff$var$parseError(res));
    return res.json();
}
async function $e48301f2885073ff$export$2d529dfacda6da2b(id, patch) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/milestone-templates/${encodeURIComponent(id)}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(patch)
    });
    if (!res.ok) throw new Error(await $e48301f2885073ff$var$parseError(res));
    return res.json();
}
async function $e48301f2885073ff$export$2568cdce944557d7(id) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/milestone-templates/${encodeURIComponent(id)}`, {
        method: "DELETE"
    });
    if (!res.ok && res.status !== 204) throw new Error(await $e48301f2885073ff$var$parseError(res));
}
async function $e48301f2885073ff$export$4dd0a50804b980f0(templateId, item) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/milestone-templates/${encodeURIComponent(templateId)}/items`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(item)
    });
    if (!res.ok) throw new Error(await $e48301f2885073ff$var$parseError(res));
    return res.json();
}
async function $e48301f2885073ff$export$632f0fc5fc984f66(templateId, itemId) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/milestone-templates/${encodeURIComponent(templateId)}/items/${encodeURIComponent(itemId)}`, {
        method: "DELETE"
    });
    if (!res.ok && res.status !== 204) throw new Error(await $e48301f2885073ff$var$parseError(res));
}




/**
 * Telangana district metadata aligned to map positions on
 * India_Telangana_numbered_district_map_2022.svg (Wikimedia Commons, CC BY-SA 4.0).
 * Serial 1–33 follows the conventional ordered list of all 33 districts; map label (cx, cy) matches the former number placement.
 */ const $72c1e8625e9e63b5$export$c213a939d88ef2f8 = [
    {
        key: "adilabad",
        label: "Adilabad",
        lines: [
            "Adilabad"
        ],
        cx: 236.4134,
        cy: 72.3352,
        hitR: 42
    },
    {
        key: "bhadradri_kothagudem",
        label: "Bhadradri Kothagudem",
        lines: [
            "Bhadradri",
            "Kothagudem"
        ],
        cx: 558.2391,
        cy: 366.2438,
        hitR: 44
    },
    {
        key: "hanumakonda",
        label: "Hanumakonda",
        lines: [
            "Hanumakonda"
        ],
        cx: 378.083,
        cy: 314.0141,
        hitR: 40
    },
    {
        key: "hyderabad",
        label: "Hyderabad",
        lines: [
            "Hyderabad"
        ],
        cx: 218.5193,
        cy: 410.9556,
        hitR: 36
    },
    {
        key: "jagtial",
        label: "Jagtial",
        lines: [
            "Jagtial"
        ],
        cx: 280.8983,
        cy: 185.9191,
        hitR: 38
    },
    {
        key: "jangaon",
        label: "Jangaon",
        lines: [
            "Jangaon"
        ],
        cx: 349.3649,
        cy: 355.5349,
        hitR: 36
    },
    {
        key: "jayashankar_bhupalpally",
        label: "Jayashankar Bhupalpally",
        lines: [
            "Jayashankar",
            "Bhupalpally"
        ],
        cx: 453.5519,
        cy: 236.6391,
        hitR: 44
    },
    {
        key: "jogulamba_gadwal",
        label: "Jogulamba Gadwal",
        lines: [
            "Jogulamba",
            "Gadwal"
        ],
        cx: 106.3024,
        cy: 622.0767,
        hitR: 40
    },
    {
        key: "kamareddy",
        label: "Kamareddy",
        lines: [
            "Kamareddy"
        ],
        cx: 153.9897,
        cy: 272.4937,
        hitR: 40
    },
    {
        key: "karimnagar",
        label: "Karimnagar",
        lines: [
            "Karimnagar"
        ],
        cx: 337.138,
        cy: 268.9941,
        hitR: 40
    },
    {
        key: "khammam",
        label: "Khammam",
        lines: [
            "Khammam"
        ],
        cx: 500.2237,
        cy: 441.5693,
        hitR: 40
    },
    {
        key: "komaram_bheem_asifabad",
        label: "Komaram Bheem Asifabad",
        lines: [
            "Komaram Bheem",
            "Asifabad"
        ],
        cx: 350.5885,
        cy: 101.7327,
        hitR: 44
    },
    {
        key: "mahabubabad",
        label: "Mahabubabad",
        lines: [
            "Mahabubabad"
        ],
        cx: 453.5519,
        cy: 375.676,
        hitR: 38
    },
    {
        key: "mahbubnagar",
        label: "Mahbubnagar",
        lines: [
            "Mahbubnagar"
        ],
        cx: 130.5874,
        cy: 508.3188,
        hitR: 42
    },
    {
        key: "mancherial",
        label: "Mancherial",
        lines: [
            "Mancherial"
        ],
        cx: 385.6154,
        cy: 162.5191,
        hitR: 38
    },
    {
        key: "medak",
        label: "Medak",
        lines: [
            "Medak"
        ],
        cx: 190.3444,
        cy: 330.7502,
        hitR: 38
    },
    {
        key: "medchal_malkajgiri",
        label: "Medchal-Malkajgiri",
        lines: [
            "Medchal-",
            "Malkajgiri"
        ],
        cx: 221.3775,
        cy: 382.817,
        hitR: 42
    },
    {
        key: "mulugu",
        label: "Mulugu",
        lines: [
            "Mulugu"
        ],
        cx: 490.2574,
        cy: 283.1202,
        hitR: 36
    },
    {
        key: "nagarkurnool",
        label: "Nagarkurnool",
        lines: [
            "Nagarkurnool"
        ],
        cx: 217.0592,
        cy: 573.554,
        hitR: 42
    },
    {
        key: "nalgonda",
        label: "Nalgonda",
        lines: [
            "Nalgonda"
        ],
        cx: 322.0491,
        cy: 484.9188,
        hitR: 40
    },
    {
        key: "narayanpet",
        label: "Narayanpet",
        lines: [
            "Narayanpet"
        ],
        cx: 74.8841,
        cy: 533.0955,
        hitR: 38
    },
    {
        key: "nirmal",
        label: "Nirmal",
        lines: [
            "Nirmal"
        ],
        cx: 206.6451,
        cy: 146.5177,
        hitR: 36
    },
    {
        key: "nizamabad",
        label: "Nizamabad",
        lines: [
            "Nizamabad"
        ],
        cx: 170.4087,
        cy: 206.9296,
        hitR: 40
    },
    {
        key: "peddapalli",
        label: "Peddapalli",
        lines: [
            "Peddapalli"
        ],
        cx: 359.9121,
        cy: 220.9658,
        hitR: 38
    },
    {
        key: "rajanna_sircilla",
        label: "Rajanna Sircilla",
        lines: [
            "Rajanna",
            "Sircilla"
        ],
        cx: 252.7345,
        cy: 248.0744,
        hitR: 40
    },
    {
        key: "rangareddy",
        label: "Rangareddy",
        lines: [
            "Rangareddy"
        ],
        cx: 199.9049,
        cy: 453.4451,
        hitR: 44
    },
    {
        key: "sangareddy",
        label: "Sangareddy",
        lines: [
            "Sangareddy"
        ],
        cx: 95.9394,
        cy: 359.417,
        hitR: 42
    },
    {
        key: "siddipet",
        label: "Siddipet",
        lines: [
            "Siddipet"
        ],
        cx: 275.3379,
        cy: 308.8431,
        hitR: 38
    },
    {
        key: "suryapet",
        label: "Suryapet",
        lines: [
            "Suryapet"
        ],
        cx: 410.7895,
        cy: 461.1227,
        hitR: 38
    },
    {
        key: "vikarabad",
        label: "Vikarabad",
        lines: [
            "Vikarabad"
        ],
        cx: 93.2685,
        cy: 432.8825,
        hitR: 36
    },
    {
        key: "wanaparthy",
        label: "Wanaparthy",
        lines: [
            "Wanaparthy"
        ],
        cx: 140.315,
        cy: 580.4847,
        hitR: 38
    },
    {
        key: "warangal",
        label: "Warangal",
        lines: [
            "Warangal"
        ],
        cx: 420.1388,
        cy: 325.9092,
        hitR: 38
    },
    {
        key: "yadadri_bhuvanagiri",
        label: "Yadadri Bhuvanagiri",
        lines: [
            "Yadadri",
            "Bhuvanagiri"
        ],
        cx: 292.7619,
        cy: 400.313,
        hitR: 44
    }
];
const $72c1e8625e9e63b5$export$8a4d68ea789d4a21 = $72c1e8625e9e63b5$export$c213a939d88ef2f8.map((d)=>d.key);
function $72c1e8625e9e63b5$export$15dbe5472819b55d(v) {
    return $72c1e8625e9e63b5$export$8a4d68ea789d4a21.includes(v);
}
function $72c1e8625e9e63b5$export$768d2fc1615cd5ac(raw) {
    const s = String(raw ?? "").trim();
    if (!s) return null;
    if ($72c1e8625e9e63b5$export$15dbe5472819b55d(s)) return s;
    const lower = s.toLowerCase();
    if ($72c1e8625e9e63b5$export$15dbe5472819b55d(lower)) return lower;
    const underscored = lower.replace(/[\s\-/]+/g, "_");
    if ($72c1e8625e9e63b5$export$15dbe5472819b55d(underscored)) return underscored;
    const normLabel = lower.replace(/\s+/g, " ").trim();
    const byLabel = $72c1e8625e9e63b5$export$c213a939d88ef2f8.find((d)=>d.label.toLowerCase() === normLabel);
    if (byLabel) return byLabel.key;
    const compact = normLabel.replace(/[^a-z0-9]/g, "");
    const byCompact = $72c1e8625e9e63b5$export$c213a939d88ef2f8.find((d)=>d.label.toLowerCase().replace(/[^a-z0-9]/g, "") === compact);
    return byCompact?.key ?? null;
}
function $72c1e8625e9e63b5$export$5e94242fadb30a0e(key) {
    return $72c1e8625e9e63b5$export$c213a939d88ef2f8.find((d)=>d.key === key)?.label ?? key;
}



function $afb7b21c21651d62$var$normalizeApplicationFromApi(a) {
    const raw = a.mobile?.photosFromMobile;
    const photos = Array.isArray(raw) ? raw.filter((p)=>p && typeof p.url === "string").map((p)=>{
        const x = p;
        const url = String(x.url).trim();
        const label = String(x.label ?? "").trim() || url || "Photo";
        return {
            label: label,
            url: url
        };
    }) : [];
    const districtKey = (0, $72c1e8625e9e63b5$export$768d2fc1615cd5ac)(a.district);
    return {
        ...a,
        district: districtKey ?? a.district,
        engineer: a.engineer ?? (0, $f34886e55d1cc894$export$a8d188a5e3c35f58)(),
        mobile: {
            ...a.mobile,
            photosFromMobile: photos
        }
    };
}
async function $afb7b21c21651d62$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
async function $afb7b21c21651d62$export$70a1c87d000b9dea() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/applications`, {
        cache: "no-store"
    });
    if (!res.ok) throw new Error(await $afb7b21c21651d62$var$parseError(res));
    const raw = await res.json();
    return Array.isArray(raw) ? raw.map($afb7b21c21651d62$var$normalizeApplicationFromApi) : [];
}
async function $afb7b21c21651d62$export$7a1e37cc1c533e06(applicationId, templateId, done, completedAt) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/applications/${encodeURIComponent(applicationId)}/milestone-complete`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        cache: "no-store",
        body: JSON.stringify({
            templateId: templateId,
            done: done,
            completedAt: completedAt ?? undefined
        })
    });
    if (!res.ok) throw new Error(await $afb7b21c21651d62$var$parseError(res));
}
async function $afb7b21c21651d62$export$e1f2e587b36c29e1(applications) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/applications`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        cache: "no-store",
        body: JSON.stringify({
            applications: applications
        })
    });
    if (!res.ok) throw new Error(await $afb7b21c21651d62$var$parseError(res));
    const j = await res.json();
    if (!Array.isArray(j.applications)) throw new Error("Invalid server response: missing applications array");
    return j.applications.map($afb7b21c21651d62$var$normalizeApplicationFromApi);
}
async function $afb7b21c21651d62$export$c491b6283682d61f(applicationId, patch) {
    const id = String(applicationId ?? "").trim();
    if (!id) throw new Error("applicationId is required");
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/applications/${encodeURIComponent(id)}/dossier`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        cache: "no-store",
        body: JSON.stringify(patch)
    });
    if (!res.ok) throw new Error(await $afb7b21c21651d62$var$parseError(res));
    const j = await res.json();
    if (!j.application || String(j.application.id ?? "").trim() !== id) throw new Error("Invalid server response: missing application");
    return $afb7b21c21651d62$var$normalizeApplicationFromApi(j.application);
}
async function $afb7b21c21651d62$export$1bbeb09694780737(applicationId, patch) {
    const id = String(applicationId ?? "").trim();
    if (!id) throw new Error("applicationId is required");
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/applications/${encodeURIComponent(id)}/validations`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        cache: "no-store",
        body: JSON.stringify(patch)
    });
    if (!res.ok) throw new Error(await $afb7b21c21651d62$var$parseError(res));
    const j = await res.json();
    if (!j.application || String(j.application.id ?? "").trim() !== id) throw new Error("Invalid server response: missing application");
    return $afb7b21c21651d62$var$normalizeApplicationFromApi(j.application);
}
async function $afb7b21c21651d62$export$6ee45454327c5bc3(applicationId, patch) {
    const id = String(applicationId ?? "").trim();
    if (!id) throw new Error("applicationId is required");
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/applications/${encodeURIComponent(id)}/ho-banking`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        cache: "no-store",
        body: JSON.stringify(patch)
    });
    if (!res.ok) throw new Error(await $afb7b21c21651d62$var$parseError(res));
    const j = await res.json();
    if (!j.application || String(j.application.id ?? "").trim() !== id) throw new Error("Invalid server response: missing application");
    return $afb7b21c21651d62$var$normalizeApplicationFromApi(j.application);
}
async function $afb7b21c21651d62$export$352f2e5a9f3efd49(applicationId, application) {
    const id = String(applicationId ?? "").trim();
    if (!id || String(application.id ?? "").trim() !== id) throw new Error("saveApplicationById: application.id must match applicationId");
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/applications/${encodeURIComponent(id)}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        cache: "no-store",
        body: JSON.stringify({
            application: application
        })
    });
    if (!res.ok) throw new Error(await $afb7b21c21651d62$var$parseError(res));
    const j = await res.json();
    if (!Array.isArray(j.applications)) throw new Error("Invalid server response: missing applications array");
    return j.applications.map($afb7b21c21651d62$var$normalizeApplicationFromApi);
}


/** Deterministic JSON for “did this application change?” comparisons across debounced persist. */ function $02e4dc1fc052758c$var$stableStringify(value) {
    if (value === null) return "null";
    const t = typeof value;
    if (t === "string" || t === "number" || t === "boolean") return JSON.stringify(value);
    if (t === "bigint") return JSON.stringify(String(value));
    if (value === undefined) return "undefined";
    if (Array.isArray(value)) return `[${value.map((v)=>$02e4dc1fc052758c$var$stableStringify(v)).join(",")}]`;
    if (t === "object") {
        const rec = value;
        const keys = Object.keys(rec).sort();
        return `{${keys.map((k)=>`${JSON.stringify(k)}:${$02e4dc1fc052758c$var$stableStringify(rec[k])}`).join(",")}}`;
    }
    return JSON.stringify(String(value));
}
function $02e4dc1fc052758c$export$94fc96c149c0ec7d(app) {
    return $02e4dc1fc052758c$var$stableStringify(app);
}




async function $1485bf7ae89e47c2$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
function $1485bf7ae89e47c2$var$normalizeAgent(row) {
    const pm = row.passwordMode === "custom" ? "custom" : "random";
    return {
        ...row,
        hasPassword: Boolean(row.hasPassword),
        passwordMode: pm,
        onboardingEmailSentAt: row.onboardingEmailSentAt ?? null
    };
}
async function $1485bf7ae89e47c2$export$fd2b4b5a84c59b7e() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/agents`);
    if (!res.ok) throw new Error(await $1485bf7ae89e47c2$var$parseError(res));
    const rows = await res.json();
    return rows.map($1485bf7ae89e47c2$var$normalizeAgent);
}
async function $1485bf7ae89e47c2$export$af683a070286e4a8(row) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/agents`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(row)
    });
    if (!res.ok) throw new Error(await $1485bf7ae89e47c2$var$parseError(res));
    const created = await res.json();
    return $1485bf7ae89e47c2$var$normalizeAgent(created);
}
async function $1485bf7ae89e47c2$export$ba9326e94e67a5d0(id, patch) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/agents/${encodeURIComponent(id)}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(patch)
    });
    if (!res.ok) throw new Error(await $1485bf7ae89e47c2$var$parseError(res));
    const updated = await res.json();
    return $1485bf7ae89e47c2$var$normalizeAgent(updated);
}
async function $1485bf7ae89e47c2$export$d87759626a82948e(id) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/agents/${encodeURIComponent(id)}`, {
        method: "DELETE"
    });
    if (!res.ok) throw new Error(await $1485bf7ae89e47c2$var$parseError(res));
}
async function $1485bf7ae89e47c2$export$5f723f76a5785bfe(id, options) {
    const body = {};
    if (options?.customPasswordForEmail !== undefined && options.customPasswordForEmail !== "") body.customPasswordForEmail = options.customPasswordForEmail;
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/agents/${encodeURIComponent(id)}/send-onboarding-email`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $1485bf7ae89e47c2$var$parseError(res));
    const agent = await res.json();
    return $1485bf7ae89e47c2$var$normalizeAgent(agent);
}


function $5f16f4b9f1d6ad44$var$phaseFromTimelineDto(d) {
    return {
        id: String(d.id),
        title: d.title,
        approxDays: d.approxDays,
        sortOrder: d.sortOrder,
        createdAt: d.createdAt
    };
}
function $5f16f4b9f1d6ad44$var$withDerivedStatuses(apps, masters) {
    return apps.map((a)=>({
            ...a,
            status: (0, $85279307e2bde4bc$export$988e90fdcfd433ba)(a, masters)
        }));
}
function $5f16f4b9f1d6ad44$var$finalizeDraft(draft) {
    const synced = (0, $4e76812a1de0ff51$export$5da2424f5db665c1)(draft.applications, draft.milestoneTemplates);
    const applications = $5f16f4b9f1d6ad44$var$withDerivedStatuses(synced, draft.subcontractorMasters);
    return {
        milestoneTemplates: draft.milestoneTemplates,
        subcontractorMasters: draft.subcontractorMasters,
        engineerMasters: draft.engineerMasters,
        agentMasters: draft.agentMasters,
        geoZones: draft.geoZones,
        storeYards: draft.storeYards,
        constructionTimelinePhases: draft.constructionTimelinePhases,
        standardResources: draft.standardResources,
        applications: applications
    };
}
function $5f16f4b9f1d6ad44$var$initialRoot() {
    return $5f16f4b9f1d6ad44$var$finalizeDraft({
        applications: [
            ...(0, $ce780ac49d598440$export$c13712588543892c)
        ],
        subcontractorMasters: [
            ...(0, $55c7b7811dd972f9$export$eb0be9ca29aee85)
        ],
        engineerMasters: [],
        agentMasters: [],
        milestoneTemplates: [
            ...(0, $bd4ee692b2cc7ffa$export$6925b7841b550cf7)
        ],
        geoZones: [
            ...(0, $c3c3290151cc5467$export$521b1267ae5a2cd5)
        ],
        storeYards: [
            ...(0, $1f0de4d313af0047$export$54634ec24677b433)
        ],
        constructionTimelinePhases: [
            ...(0, $b7582ef8fb24080c$export$62a8b921bc681945)
        ],
        standardResources: [
            ...(0, $1bdde9dc3a5c5f66$export$55f73812d18df7d2)
        ]
    });
}
const $5f16f4b9f1d6ad44$var$AppStateContext = /*#__PURE__*/ (0, $7UyaH.createContext)(null);
function $5f16f4b9f1d6ad44$export$d56d5432daeb70cb({ children: children }) {
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const { can: can, loading: authLoading, user: user, authRequired: authRequired } = (0, $a4dc0d923ddf5b19$export$1d39dc5b47e56ff0)();
    const requireApplicantDossierMutation = (0, $7UyaH.useCallback)(()=>{
        if (!(0, $4aabdb75dcf6b773$export$6e313773bb334ada)(can)) {
            showToast("You do not have permission to save applicant dossier changes.", "error");
            return false;
        }
        return true;
    }, [
        can,
        showToast
    ]);
    const [root, setRoot] = (0, $7UyaH.useState)($5f16f4b9f1d6ad44$var$initialRoot);
    const timelineApiActiveRef = (0, $7UyaH.useRef)(false);
    const standardResourcesApiActiveRef = (0, $7UyaH.useRef)(false);
    const subcontractorMastersApiActiveRef = (0, $7UyaH.useRef)(false);
    const engineerMastersApiActiveRef = (0, $7UyaH.useRef)(false);
    const agentMastersApiActiveRef = (0, $7UyaH.useRef)(false);
    const geoZonesApiActiveRef = (0, $7UyaH.useRef)(false);
    const storeYardsApiActiveRef = (0, $7UyaH.useRef)(false);
    const milestoneTemplatesApiActiveRef = (0, $7UyaH.useRef)(false);
    const applicationsApiActiveRef = (0, $7UyaH.useRef)(false);
    const applicationsHydratedRef = (0, $7UyaH.useRef)(false);
    const applicationsSkipNextPersistRef = (0, $7UyaH.useRef)(false);
    /** Last persisted fingerprints per application id — used to send single-row PUT when only one dossier changed. */ const lastApplicationFingerprintByIdRef = (0, $7UyaH.useRef)(new Map());
    const rootRef = (0, $7UyaH.useRef)(root);
    (0, $7UyaH.useLayoutEffect)(()=>{
        rootRef.current = root;
    }, [
        root
    ]);
    /** Full-table PUT must run strictly one-at-a-time; overlapping responses could otherwise restore stale `validations` (e.g. seeding cleared after ICICI save). */ const applicationsPersistChainRef = (0, $7UyaH.useRef)(Promise.resolve());
    const enqueueApplicationsPersist = (0, $7UyaH.useCallback)((snapshot)=>{
        applicationsPersistChainRef.current = applicationsPersistChainRef.current.catch(()=>{
        /* keep queue alive after a failed save */ }).then(async ()=>{
            if (!applicationsApiActiveRef.current) return;
            if (!(0, $4aabdb75dcf6b773$export$6e313773bb334ada)(can)) return;
            const apps = snapshot ?? rootRef.current.applications;
            const prevFp = lastApplicationFingerprintByIdRef.current;
            const changed = apps.filter((a)=>prevFp.get(a.id) !== (0, $02e4dc1fc052758c$export$94fc96c149c0ec7d)(a));
            if (changed.length === 0) return;
            const saved = changed.length === 1 ? await (0, $afb7b21c21651d62$export$352f2e5a9f3efd49)(changed[0].id, changed[0]) : await (0, $afb7b21c21651d62$export$e1f2e587b36c29e1)(apps);
            /** Same as after GET hydrate: skip one persist cycle so `root.applications` update does not re-queue PUT forever. */ applicationsSkipNextPersistRef.current = true;
            lastApplicationFingerprintByIdRef.current = new Map(saved.map((a)=>[
                    a.id,
                    (0, $02e4dc1fc052758c$export$94fc96c149c0ec7d)(a)
                ]));
            setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                    ...prev,
                    applications: saved
                }));
        }).catch((err)=>{
            showToast(err instanceof Error ? err.message : "Could not save applicants to the database.", "error");
        });
    }, [
        showToast,
        can
    ]);
    const refreshTimelineFromApi = (0, $7UyaH.useCallback)(async ()=>{
        if (authLoading || !can("construction_timeline")) return;
        const rows = await (0, $e532bc2b6b908ae9$export$7db166ab3be0794)();
        setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                ...prev,
                constructionTimelinePhases: rows.map($5f16f4b9f1d6ad44$var$phaseFromTimelineDto)
            }));
    }, [
        authLoading,
        can
    ]);
    const refreshStandardResourcesFromApi = (0, $7UyaH.useCallback)(async ()=>{
        if (authLoading || !can("standard_resources")) return;
        const list = await (0, $770fd32f52113801$export$6aa64b79d921e94c)();
        setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                ...prev,
                standardResources: list
            }));
    }, [
        authLoading,
        can
    ]);
    const refreshSubcontractorMastersFromApi = (0, $7UyaH.useCallback)(async ()=>{
        if (authLoading || !can("subcontractor_masters")) return;
        const list = await (0, $dd06e1778646a9b0$export$8703e8025bc3c32)();
        setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                ...prev,
                subcontractorMasters: list
            }));
    }, [
        authLoading,
        can
    ]);
    const refreshEngineerMastersFromApi = (0, $7UyaH.useCallback)(async ()=>{
        if (authLoading || !can("engineer_masters") && !(0, $4aabdb75dcf6b773$export$8f84a4e698ab11e9)(can)) return;
        const list = await (0, $1d8c0bf20c21a404$export$536b9d2fdec42e3a)();
        setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                ...prev,
                engineerMasters: list
            }));
    }, [
        authLoading,
        can
    ]);
    const refreshAgentsFromApi = (0, $7UyaH.useCallback)(async ()=>{
        if (authLoading || !can("agents")) return;
        const list = await (0, $1485bf7ae89e47c2$export$fd2b4b5a84c59b7e)();
        setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                ...prev,
                agentMasters: list
            }));
    }, [
        authLoading,
        can
    ]);
    const refreshGeoZonesFromApi = (0, $7UyaH.useCallback)(async ()=>{
        if (authLoading || !can("geo_zones")) return;
        const list = await (0, $709afcad7b3e6a59$export$dca04a7c35bb5d56)();
        setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                ...prev,
                geoZones: list
            }));
    }, [
        authLoading,
        can
    ]);
    const refreshStoreYardsFromApi = (0, $7UyaH.useCallback)(async ()=>{
        if (authLoading || !(0, $ce83db1d656d565a$export$f1c8f55ee0acd164)(can)) return;
        const list = await (0, $1b8cd287af9bc7a7$export$f973e7570430619)();
        setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                ...prev,
                storeYards: list
            }));
    }, [
        authLoading,
        can
    ]);
    const refreshMilestoneTemplatesFromApi = (0, $7UyaH.useCallback)(async ()=>{
        if (authLoading || !can("milestone_templates")) return;
        const list = await (0, $e48301f2885073ff$export$7ed8424b05ae1c89)();
        setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                ...prev,
                milestoneTemplates: list
            }));
    }, [
        authLoading,
        can
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (authLoading) return;
        if (!can("construction_timeline")) {
            timelineApiActiveRef.current = false;
            setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                    ...prev,
                    constructionTimelinePhases: []
                }));
            return;
        }
        let cancelled = false;
        (async ()=>{
            try {
                const rows = await (0, $e532bc2b6b908ae9$export$7db166ab3be0794)();
                if (cancelled) return;
                timelineApiActiveRef.current = true;
                setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                        ...prev,
                        constructionTimelinePhases: rows.map($5f16f4b9f1d6ad44$var$phaseFromTimelineDto)
                    }));
            } catch (e) {
                timelineApiActiveRef.current = false;
                showToast(e instanceof Error ? e.message : "Could not load construction timeline from the server.", "error");
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        showToast,
        authLoading,
        can
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (authLoading) return;
        if (!can("standard_resources")) {
            standardResourcesApiActiveRef.current = false;
            setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                    ...prev,
                    standardResources: []
                }));
            return;
        }
        let cancelled = false;
        (async ()=>{
            try {
                const list = await (0, $770fd32f52113801$export$6aa64b79d921e94c)();
                if (cancelled) return;
                standardResourcesApiActiveRef.current = true;
                setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                        ...prev,
                        standardResources: list
                    }));
            } catch (e) {
                standardResourcesApiActiveRef.current = false;
                showToast(e instanceof Error ? e.message : "Could not load standard resources from the server.", "error");
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        showToast,
        authLoading,
        can
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (authLoading) return;
        if (!can("subcontractor_masters")) {
            subcontractorMastersApiActiveRef.current = false;
            setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                    ...prev,
                    subcontractorMasters: []
                }));
            return;
        }
        let cancelled = false;
        (async ()=>{
            try {
                const list = await (0, $dd06e1778646a9b0$export$8703e8025bc3c32)();
                if (cancelled) return;
                subcontractorMastersApiActiveRef.current = true;
                setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                        ...prev,
                        subcontractorMasters: list
                    }));
            } catch (e) {
                subcontractorMastersApiActiveRef.current = false;
                showToast(e instanceof Error ? e.message : "Could not load subcontractor masters from the server.", "error");
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        showToast,
        authLoading,
        can
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (authLoading) return;
        /** Keep roster in memory for assignment UX whenever user can open the applicant hub (not only Engineer onboarding). */ if (!can("engineer_masters") && !(0, $4aabdb75dcf6b773$export$8f84a4e698ab11e9)(can)) {
            engineerMastersApiActiveRef.current = false;
            setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                    ...prev,
                    engineerMasters: []
                }));
            return;
        }
        let cancelled = false;
        (async ()=>{
            try {
                const list = await (0, $1d8c0bf20c21a404$export$536b9d2fdec42e3a)();
                if (cancelled) return;
                engineerMastersApiActiveRef.current = true;
                setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                        ...prev,
                        engineerMasters: list
                    }));
            } catch (e) {
                engineerMastersApiActiveRef.current = false;
                showToast(e instanceof Error ? e.message : "Could not load engineer masters from the server.", "error");
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        showToast,
        authLoading,
        can
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (authLoading) return;
        if (!can("agents")) {
            agentMastersApiActiveRef.current = false;
            setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                    ...prev,
                    agentMasters: []
                }));
            return;
        }
        let cancelled = false;
        (async ()=>{
            try {
                const list = await (0, $1485bf7ae89e47c2$export$fd2b4b5a84c59b7e)();
                if (cancelled) return;
                agentMastersApiActiveRef.current = true;
                setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                        ...prev,
                        agentMasters: list
                    }));
            } catch (e) {
                agentMastersApiActiveRef.current = false;
                showToast(e instanceof Error ? e.message : "Could not load agents from the server.", "error");
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        showToast,
        authLoading,
        can
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (authLoading) return;
        if (!can("geo_zones")) {
            geoZonesApiActiveRef.current = false;
            setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                    ...prev,
                    geoZones: []
                }));
            return;
        }
        let cancelled = false;
        (async ()=>{
            try {
                const list = await (0, $709afcad7b3e6a59$export$dca04a7c35bb5d56)();
                if (cancelled) return;
                geoZonesApiActiveRef.current = true;
                setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                        ...prev,
                        geoZones: list
                    }));
            } catch (e) {
                geoZonesApiActiveRef.current = false;
                showToast(e instanceof Error ? e.message : "Could not load geo zones from the server.", "error");
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        showToast,
        authLoading,
        can
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (authLoading) return;
        if (!(0, $ce83db1d656d565a$export$f1c8f55ee0acd164)(can)) {
            storeYardsApiActiveRef.current = false;
            setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                    ...prev,
                    storeYards: []
                }));
            return;
        }
        let cancelled = false;
        (async ()=>{
            try {
                const list = await (0, $1b8cd287af9bc7a7$export$f973e7570430619)();
                if (cancelled) return;
                storeYardsApiActiveRef.current = can("inventory_stores_yards");
                const scoped = (0, $18b0587275e330a6$export$18bc13b6ea552914)(list, user, authRequired);
                setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                        ...prev,
                        storeYards: scoped
                    }));
            } catch (e) {
                storeYardsApiActiveRef.current = false;
                showToast(e instanceof Error ? e.message : "Could not load store yards from the server.", "error");
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        showToast,
        authLoading,
        can,
        user,
        authRequired
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (authLoading) return;
        if (!can("milestone_templates")) {
            milestoneTemplatesApiActiveRef.current = false;
            setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                    ...prev,
                    milestoneTemplates: []
                }));
            return;
        }
        let cancelled = false;
        (async ()=>{
            try {
                const list = await (0, $e48301f2885073ff$export$7ed8424b05ae1c89)();
                if (cancelled) return;
                milestoneTemplatesApiActiveRef.current = true;
                setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                        ...prev,
                        milestoneTemplates: list
                    }));
            } catch (e) {
                milestoneTemplatesApiActiveRef.current = false;
                showToast(e instanceof Error ? e.message : "Could not load milestone templates from the server.", "error");
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        showToast,
        authLoading,
        can
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (authLoading) return;
        if (!(0, $4aabdb75dcf6b773$export$8f84a4e698ab11e9)(can)) {
            applicationsApiActiveRef.current = false;
            applicationsHydratedRef.current = true;
            lastApplicationFingerprintByIdRef.current = new Map();
            setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                    ...prev,
                    applications: []
                }));
            return;
        }
        let cancelled = false;
        (async ()=>{
            try {
                const apps = await (0, $afb7b21c21651d62$export$70a1c87d000b9dea)();
                if (cancelled) return;
                applicationsApiActiveRef.current = true;
                applicationsSkipNextPersistRef.current = true;
                const nextApps = [
                    ...apps
                ];
                setRoot((prev)=>{
                    const next = $5f16f4b9f1d6ad44$var$finalizeDraft({
                        ...prev,
                        applications: nextApps
                    });
                    lastApplicationFingerprintByIdRef.current = new Map(next.applications.map((a)=>[
                            a.id,
                            (0, $02e4dc1fc052758c$export$94fc96c149c0ec7d)(a)
                        ]));
                    return next;
                });
                applicationsHydratedRef.current = true;
            } catch (e) {
                applicationsApiActiveRef.current = false;
                applicationsHydratedRef.current = true;
                showToast(e instanceof Error ? e.message : "Could not load applicants from the server. They stay in the browser until MySQL is configured.", "error");
                setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                        ...prev
                    }));
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        showToast,
        authLoading,
        can
    ]);
    const refreshApplicationsFromApi = (0, $7UyaH.useCallback)(async ()=>{
        if (authLoading) return;
        if (!(0, $4aabdb75dcf6b773$export$8f84a4e698ab11e9)(can)) return;
        if (!applicationsApiActiveRef.current) return;
        try {
            applicationsSkipNextPersistRef.current = true;
            const apps = await (0, $afb7b21c21651d62$export$70a1c87d000b9dea)();
            setRoot((prev)=>{
                const next = $5f16f4b9f1d6ad44$var$finalizeDraft({
                    ...prev,
                    applications: [
                        ...apps
                    ]
                });
                lastApplicationFingerprintByIdRef.current = new Map(next.applications.map((a)=>[
                        a.id,
                        (0, $02e4dc1fc052758c$export$94fc96c149c0ec7d)(a)
                    ]));
                return next;
            });
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not refresh applicants from the server.", "error");
        }
    }, [
        authLoading,
        can,
        showToast
    ]);
    /** Dossier edits use PATCH `/dossier`, `/validations`, `/ho-banking`, etc. — not a debounced full PUT. */ const getById = (0, $7UyaH.useCallback)((id)=>root.applications.find((a)=>a.id === id), [
        root.applications
    ]);
    const getSubcontractorMaster = (0, $7UyaH.useCallback)((id)=>root.subcontractorMasters.find((m)=>m.id === id), [
        root.subcontractorMasters
    ]);
    const getEngineerMaster = (0, $7UyaH.useCallback)((id)=>root.engineerMasters.find((m)=>m.id === id), [
        root.engineerMasters
    ]);
    const getAgentMaster = (0, $7UyaH.useCallback)((id)=>root.agentMasters.find((m)=>m.id === id), [
        root.agentMasters
    ]);
    const getMilestoneTemplate = (0, $7UyaH.useCallback)((id)=>root.milestoneTemplates.find((t)=>t.id === id), [
        root.milestoneTemplates
    ]);
    const getStandardResource = (0, $7UyaH.useCallback)((id)=>root.standardResources.find((r)=>r.id === id), [
        root.standardResources
    ]);
    const patchRoot = (0, $7UyaH.useCallback)((fn)=>{
        setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                ...prev,
                ...fn(prev)
            }));
    }, []);
    const updateHo = (0, $7UyaH.useCallback)((id, ho)=>{
        if (!requireApplicantDossierMutation()) return;
        patchRoot((prev)=>({
                subcontractorMasters: prev.subcontractorMasters,
                applications: prev.applications.map((a)=>a.id !== id ? a : {
                        ...a,
                        ho: {
                            ...a.ho,
                            ...ho
                        }
                    })
            }));
    }, [
        patchRoot,
        requireApplicantDossierMutation
    ]);
    const mergeApplicationFromServer = (0, $7UyaH.useCallback)((id, updated)=>{
        applicationsSkipNextPersistRef.current = true;
        lastApplicationFingerprintByIdRef.current.set(id, (0, $02e4dc1fc052758c$export$94fc96c149c0ec7d)(updated));
        setRoot((prev)=>{
            const applications = prev.applications.map((a)=>a.id !== id ? a : updated);
            return $5f16f4b9f1d6ad44$var$finalizeDraft({
                ...prev,
                applications: applications
            });
        });
    }, []);
    const partialApplicationToDossierPatch = (patch)=>{
        const out = {};
        if (Object.prototype.hasOwnProperty.call(patch, "district")) out.district = patch.district;
        if (Object.prototype.hasOwnProperty.call(patch, "mandal")) out.mandal = patch.mandal;
        if (Object.prototype.hasOwnProperty.call(patch, "village")) out.village = patch.village;
        if (Object.prototype.hasOwnProperty.call(patch, "status")) out.status = patch.status;
        if (Object.prototype.hasOwnProperty.call(patch, "receivedAt")) out.receivedAt = patch.receivedAt;
        if (Object.prototype.hasOwnProperty.call(patch, "leadId")) out.leadId = patch.leadId;
        if (Object.prototype.hasOwnProperty.call(patch, "holdReasons")) out.holdReasons = patch.holdReasons;
        if (patch.mobile) out.mobile = patch.mobile;
        if (patch.validations) out.validations = patch.validations;
        if (patch.ho) out.ho = patch.ho;
        if (patch.subcontractor) out.subcontractor = patch.subcontractor;
        if (patch.engineer) out.engineer = patch.engineer;
        return out;
    };
    const persistDossierPatch = (0, $7UyaH.useCallback)(async (id, patch)=>{
        if (!requireApplicantDossierMutation()) return;
        const updated = await (0, $afb7b21c21651d62$export$c491b6283682d61f)(id, patch);
        mergeApplicationFromServer(id, updated);
        return updated;
    }, [
        requireApplicantDossierMutation,
        mergeApplicationFromServer
    ]);
    const updateApplication = (0, $7UyaH.useCallback)(async (id, patch)=>{
        const dossierPatch = partialApplicationToDossierPatch(patch);
        if (Object.keys(dossierPatch).length === 0) return;
        try {
            await persistDossierPatch(id, dossierPatch);
            showToast("Application updated.", "success");
        } catch (err) {
            showToast(err instanceof Error ? err.message : "Could not save application.", "error");
            throw err;
        }
    }, [
        persistDossierPatch,
        showToast
    ]);
    const updateValidations = (0, $7UyaH.useCallback)(async (id, partial)=>{
        if (!requireApplicantDossierMutation()) return;
        const patch = {};
        if (Object.prototype.hasOwnProperty.call(partial, "nameMatchAcrossSources")) patch.nameMatchAcrossSources = partial.nameMatchAcrossSources;
        if (Object.prototype.hasOwnProperty.call(partial, "aadhaarVerified")) patch.aadhaarVerified = partial.aadhaarVerified;
        if (Object.prototype.hasOwnProperty.call(partial, "bankAccountVerified")) patch.bankAccountVerified = partial.bankAccountVerified;
        if (Object.prototype.hasOwnProperty.call(partial, "workmanCardAcceptable")) patch.workmanCardAcceptable = partial.workmanCardAcceptable;
        if (Object.prototype.hasOwnProperty.call(partial, "aadhaarSeedingConfirmed")) patch.aadhaarSeedingConfirmed = partial.aadhaarSeedingConfirmed;
        if (Object.keys(patch).length === 0) return;
        try {
            const updated = await (0, $afb7b21c21651d62$export$1bbeb09694780737)(id, patch);
            mergeApplicationFromServer(id, updated);
            showToast("Verification details saved.", "success");
        } catch (err) {
            showToast(err instanceof Error ? err.message : "Could not save verification details.", "error");
            throw err;
        }
    }, [
        showToast,
        requireApplicantDossierMutation,
        mergeApplicationFromServer
    ]);
    const setHoldReasons = (0, $7UyaH.useCallback)(async (id, reasons)=>{
        if (!requireApplicantDossierMutation()) return;
        try {
            const updated = await (0, $afb7b21c21651d62$export$1bbeb09694780737)(id, {
                holdReasons: reasons
            });
            mergeApplicationFromServer(id, updated);
            showToast("Hold reasons updated.", "success");
        } catch (err) {
            showToast(err instanceof Error ? err.message : "Could not update hold reasons.", "error");
            throw err;
        }
    }, [
        showToast,
        requireApplicantDossierMutation,
        mergeApplicationFromServer
    ]);
    const confirmSeeding = (0, $7UyaH.useCallback)(async (id)=>{
        if (!requireApplicantDossierMutation()) return;
        try {
            const updated = await (0, $afb7b21c21651d62$export$1bbeb09694780737)(id, {
                aadhaarSeedingConfirmed: true
            });
            mergeApplicationFromServer(id, updated);
            showToast("Aadhaar seeding confirmed.", "success");
        } catch (err) {
            showToast(err instanceof Error ? err.message : "Could not confirm Aadhaar seeding.", "error");
            throw err;
        }
    }, [
        showToast,
        requireApplicantDossierMutation,
        mergeApplicationFromServer
    ]);
    const saveIciciDetails = (0, $7UyaH.useCallback)(async (id, patch)=>{
        if (!requireApplicantDossierMutation()) return;
        try {
            const updated = await (0, $afb7b21c21651d62$export$6ee45454327c5bc3)(id, patch);
            mergeApplicationFromServer(id, updated);
            showToast("Banking details saved.", "success");
        } catch (err) {
            showToast(err instanceof Error ? err.message : "Could not save banking details.", "error");
            throw err;
        }
    }, [
        showToast,
        requireApplicantDossierMutation,
        mergeApplicationFromServer
    ]);
    const addWorkDoneBill = (0, $7UyaH.useCallback)(async (id, fileName)=>{
        if (!requireApplicantDossierMutation()) return;
        const billId = `bill-${Date.now()}`;
        try {
            await persistDossierPatch(id, {
                workDoneBillAppend: {
                    id: billId,
                    fileName: fileName
                }
            });
            showToast("Work-done bill added.", "success");
        } catch (err) {
            showToast(err instanceof Error ? err.message : "Could not add work-done bill.", "error");
            throw err;
        }
    }, [
        persistDossierPatch,
        showToast,
        requireApplicantDossierMutation
    ]);
    const confirmBillSeeding = (0, $7UyaH.useCallback)(async (id, billId)=>{
        if (!requireApplicantDossierMutation()) return;
        try {
            await persistDossierPatch(id, {
                workDoneBillConfirmSeeding: {
                    billId: billId
                }
            });
            showToast("Seeding re-verified for this bill.", "success");
        } catch (err) {
            showToast(err instanceof Error ? err.message : "Could not confirm bill seeding.", "error");
            throw err;
        }
    }, [
        persistDossierPatch,
        showToast,
        requireApplicantDossierMutation
    ]);
    const updateSubcontractor = (0, $7UyaH.useCallback)(async (id, partial)=>{
        if (!requireApplicantDossierMutation()) return;
        const app = rootRef.current.applications.find((a)=>a.id === id);
        if (!app) return;
        let sub = {
            ...app.subcontractor,
            ...partial
        };
        const master = (0, $85279307e2bde4bc$export$87d4bc3ee3ec5ea2)(rootRef.current.subcontractorMasters, sub.subcontractorMasterId);
        if (!(0, $85279307e2bde4bc$export$148e14a666d94fa1)(sub, master)) sub = {
            ...sub,
            linkedAt: undefined
        };
        const patch = {};
        if (Object.prototype.hasOwnProperty.call(partial, "subcontractorMasterId")) patch.subcontractorMasterId = sub.subcontractorMasterId;
        if (Object.prototype.hasOwnProperty.call(partial, "workOrderFileName")) patch.workOrderFileName = sub.workOrderFileName;
        if (!(0, $85279307e2bde4bc$export$148e14a666d94fa1)(sub, master)) patch.linkedAt = undefined;
        else if (Object.prototype.hasOwnProperty.call(partial, "linkedAt")) patch.linkedAt = sub.linkedAt;
        if (Object.keys(patch).length === 0) return;
        try {
            await persistDossierPatch(id, {
                subcontractor: patch
            });
            showToast("Subcontractor selection updated.", "success");
        } catch (err) {
            showToast(err instanceof Error ? err.message : "Could not update subcontractor.", "error");
            throw err;
        }
    }, [
        persistDossierPatch,
        showToast,
        requireApplicantDossierMutation
    ]);
    const finalizeSubcontractor = (0, $7UyaH.useCallback)(async (id, filePayload)=>{
        if (!requireApplicantDossierMutation()) return false;
        const app = rootRef.current.applications.find((a)=>a.id === id);
        if (!app) return false;
        let sub = {
            ...app.subcontractor
        };
        if (filePayload?.workOrderFileBase64) sub = {
            ...sub,
            workOrderFileBase64: filePayload.workOrderFileBase64,
            workOrderMimeType: filePayload.workOrderMimeType
        };
        const master = (0, $85279307e2bde4bc$export$87d4bc3ee3ec5ea2)(rootRef.current.subcontractorMasters, sub.subcontractorMasterId);
        if (!(0, $85279307e2bde4bc$export$148e14a666d94fa1)(sub, master)) {
            showToast("Choose an onboarded firm with full KYC (Aadhaar, bank details, cancelled cheque, Aadhaar doc, Udyam/MSME, labour licence) before finalising linkage.", "error");
            return false;
        }
        const linkedAt = sub.linkedAt ?? new Date().toISOString();
        try {
            await persistDossierPatch(id, {
                subcontractor: {
                    subcontractorMasterId: sub.subcontractorMasterId,
                    workOrderFileName: sub.workOrderFileName,
                    linkedAt: linkedAt,
                    ...filePayload?.workOrderFileBase64 ? {
                        workOrderFileBase64: filePayload.workOrderFileBase64,
                        workOrderMimeType: filePayload.workOrderMimeType
                    } : {}
                }
            });
            showToast("Subcontractor linkage finalised.", "success");
            return true;
        } catch (err) {
            showToast(err instanceof Error ? err.message : "Could not finalise subcontractor linkage.", "error");
            return false;
        }
    }, [
        persistDossierPatch,
        showToast,
        requireApplicantDossierMutation
    ]);
    const updateEngineer = (0, $7UyaH.useCallback)(async (id, partial)=>{
        if (!requireApplicantDossierMutation()) return;
        const app = rootRef.current.applications.find((a)=>a.id === id);
        if (!app) return;
        const base = app.engineer ?? (0, $f34886e55d1cc894$export$a8d188a5e3c35f58)();
        let eng = {
            ...base,
            ...partial
        };
        const master = (0, $f34886e55d1cc894$export$2a0dc13f7a78d8d8)(rootRef.current.engineerMasters, eng.engineerMasterId);
        if (!(0, $f34886e55d1cc894$export$2654cb00f18a4c7)(eng, master)) eng = {
            ...eng,
            linkedAt: undefined
        };
        const patch = {};
        if (Object.prototype.hasOwnProperty.call(partial, "engineerMasterId")) patch.engineerMasterId = eng.engineerMasterId;
        if (!(0, $f34886e55d1cc894$export$2654cb00f18a4c7)(eng, master)) patch.linkedAt = undefined;
        else if (Object.prototype.hasOwnProperty.call(partial, "linkedAt")) patch.linkedAt = eng.linkedAt;
        if (Object.keys(patch).length === 0) return;
        try {
            await persistDossierPatch(id, {
                engineer: patch
            });
            showToast("Engineer selection updated.", "success");
        } catch (err) {
            showToast(err instanceof Error ? err.message : "Could not update engineer.", "error");
            throw err;
        }
    }, [
        persistDossierPatch,
        showToast,
        requireApplicantDossierMutation
    ]);
    const finalizeEngineer = (0, $7UyaH.useCallback)(async (id)=>{
        if (!requireApplicantDossierMutation()) return false;
        const app = rootRef.current.applications.find((a)=>a.id === id);
        if (!app) return false;
        const eng = {
            ...app.engineer ?? (0, $f34886e55d1cc894$export$a8d188a5e3c35f58)()
        };
        const master = (0, $f34886e55d1cc894$export$2a0dc13f7a78d8d8)(rootRef.current.engineerMasters, eng.engineerMasterId);
        if (!(0, $f34886e55d1cc894$export$2654cb00f18a4c7)(eng, master)) {
            showToast("Choose an engineer from the master list (name and phone required) before recording assignment.", "error");
            return false;
        }
        const linkedAt = eng.linkedAt ?? new Date().toISOString();
        try {
            await persistDossierPatch(id, {
                engineer: {
                    engineerMasterId: eng.engineerMasterId,
                    linkedAt: linkedAt
                }
            });
            showToast("Engineer assignment recorded.", "success");
            return true;
        } catch (err) {
            showToast(err instanceof Error ? err.message : "Could not record engineer assignment.", "error");
            return false;
        }
    }, [
        persistDossierPatch,
        showToast,
        requireApplicantDossierMutation
    ]);
    const addSubcontractorMaster = (0, $7UyaH.useCallback)(async (row)=>{
        if (subcontractorMastersApiActiveRef.current) try {
            const created = await (0, $dd06e1778646a9b0$export$3e853eff120673b4)(row);
            await refreshSubcontractorMastersFromApi();
            showToast("Firm registered in master list.", "success");
            return created.id;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not register firm.", "error");
            return "";
        }
        const newId = `subm-${Date.now()}`;
        const { cancelChequeBase64: _ccb, cancelChequeMimeType: _ccm, aadharDocBase64: _adb, aadharDocMimeType: _adm, gstCertBase64: _gcb, gstCertMimeType: _gcm, udyamMsmeBase64: _um, udyamMsmeMimeType: _umm, labourLicenseBase64: _ll, labourLicenseMimeType: _llm, ...restRow } = row;
        const created = {
            ...restRow,
            cancelChequeStored: Boolean(_ccb?.trim()) || Boolean(row.cancelChequeStored),
            aadharDocStored: Boolean(_adb?.trim()) || Boolean(row.aadharDocStored),
            gstCertStored: Boolean(_gcb?.trim()) || Boolean(row.gstCertStored),
            udyamMsmeStored: Boolean(_um?.trim()) || Boolean(row.udyamMsmeStored),
            labourLicenseStored: Boolean(_ll?.trim()) || Boolean(row.labourLicenseStored),
            id: newId,
            createdAt: new Date().toISOString()
        };
        patchRoot((prev)=>({
                applications: prev.applications,
                subcontractorMasters: [
                    ...prev.subcontractorMasters,
                    created
                ]
            }));
        showToast("Firm registered in master list.", "success");
        return newId;
    }, [
        patchRoot,
        refreshSubcontractorMastersFromApi,
        showToast
    ]);
    const updateSubcontractorMaster = (0, $7UyaH.useCallback)(async (id, patch)=>{
        if (subcontractorMastersApiActiveRef.current) try {
            await (0, $dd06e1778646a9b0$export$84bb4ed868e69465)(id, patch);
            await refreshSubcontractorMastersFromApi();
            showToast("Firm details updated.", "success");
            return true;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not update firm.", "error");
            return false;
        }
        patchRoot((prev)=>{
            const { cancelChequeBase64: _ccb, cancelChequeMimeType: _ccm, aadharDocBase64: _adb, aadharDocMimeType: _adm, gstCertBase64: _gcb, gstCertMimeType: _gcm, udyamMsmeBase64: _um, udyamMsmeMimeType: _umm, labourLicenseBase64: _ll, labourLicenseMimeType: _llm, ...patchRest } = patch;
            const mergedPatch = {
                ...patchRest
            };
            if (typeof _ccb === "string" && _ccb.trim()) mergedPatch.cancelChequeStored = true;
            if (typeof _adb === "string" && _adb.trim()) mergedPatch.aadharDocStored = true;
            if (typeof _gcb === "string" && _gcb.trim()) mergedPatch.gstCertStored = true;
            if (typeof _um === "string" && _um.trim()) mergedPatch.udyamMsmeStored = true;
            if (typeof _ll === "string" && _ll.trim()) mergedPatch.labourLicenseStored = true;
            const nextMasters = prev.subcontractorMasters.map((m)=>m.id === id ? {
                    ...m,
                    ...mergedPatch
                } : m);
            const updatedMaster = nextMasters.find((m)=>m.id === id);
            const applications = prev.applications.map((a)=>{
                if (a.subcontractor.subcontractorMasterId !== id) return a;
                let sub = a.subcontractor;
                if (!(0, $85279307e2bde4bc$export$148e14a666d94fa1)(sub, updatedMaster)) sub = {
                    ...sub,
                    linkedAt: undefined
                };
                return {
                    ...a,
                    subcontractor: sub
                };
            });
            return {
                subcontractorMasters: nextMasters,
                engineerMasters: prev.engineerMasters,
                applications: applications
            };
        });
        showToast("Firm details updated.", "success");
        return true;
    }, [
        patchRoot,
        refreshSubcontractorMastersFromApi,
        showToast
    ]);
    const deleteSubcontractorMaster = (0, $7UyaH.useCallback)(async (id)=>{
        if (subcontractorMastersApiActiveRef.current) try {
            await (0, $dd06e1778646a9b0$export$f690c37bcd62cd34)(id);
            const list = await (0, $dd06e1778646a9b0$export$8703e8025bc3c32)();
            if (applicationsApiActiveRef.current && (0, $4aabdb75dcf6b773$export$8f84a4e698ab11e9)(can)) try {
                applicationsSkipNextPersistRef.current = true;
                const apps = await (0, $afb7b21c21651d62$export$70a1c87d000b9dea)();
                setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                        ...prev,
                        subcontractorMasters: list,
                        applications: apps
                    }));
            } catch (e) {
                setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                        ...prev,
                        subcontractorMasters: list
                    }));
                showToast(e instanceof Error ? e.message : "Applicants list could not be refreshed; reload the page if needed.", "error");
                return true;
            }
            else setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                    ...prev,
                    subcontractorMasters: list
                }));
            showToast("Firm removed from master list.", "success");
            return true;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not delete firm.", "error");
            return false;
        }
        patchRoot((prev)=>({
                subcontractorMasters: prev.subcontractorMasters.filter((m)=>m.id !== id),
                engineerMasters: prev.engineerMasters,
                applications: prev.applications.map((a)=>a.subcontractor.subcontractorMasterId === id ? {
                        ...a,
                        subcontractor: {
                            ...a.subcontractor,
                            subcontractorMasterId: null,
                            linkedAt: undefined
                        }
                    } : a)
            }));
        showToast("Firm removed from master list.", "success");
        return true;
    }, [
        patchRoot,
        showToast,
        can
    ]);
    const addEngineerMaster = (0, $7UyaH.useCallback)(async (row)=>{
        if (engineerMastersApiActiveRef.current) try {
            const created = await (0, $1d8c0bf20c21a404$export$1d921fca6d3f74a5)(row);
            await refreshEngineerMastersFromApi();
            showToast("Engineer registered in master list.", "success");
            return created.id;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not register engineer.", "error");
            return "";
        }
        const newId = `eng-${Date.now()}`;
        const created = {
            fullName: row.fullName.trim(),
            phone: row.phone.trim(),
            email: row.email.trim(),
            employeeCode: row.employeeCode.trim(),
            notes: row.notes.trim(),
            id: newId,
            createdAt: new Date().toISOString()
        };
        patchRoot((prev)=>({
                engineerMasters: [
                    ...prev.engineerMasters,
                    created
                ]
            }));
        showToast("Engineer registered in master list.", "success");
        return newId;
    }, [
        patchRoot,
        refreshEngineerMastersFromApi,
        showToast
    ]);
    const updateEngineerMaster = (0, $7UyaH.useCallback)(async (id, patch)=>{
        if (engineerMastersApiActiveRef.current) try {
            await (0, $1d8c0bf20c21a404$export$b02c53faca2bf40)(id, patch);
            await refreshEngineerMastersFromApi();
            showToast("Engineer details updated.", "success");
            return true;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not update engineer.", "error");
            return false;
        }
        patchRoot((prev)=>{
            const nextMasters = prev.engineerMasters.map((m)=>m.id === id ? {
                    ...m,
                    ...patch
                } : m);
            const updatedMaster = nextMasters.find((m)=>m.id === id);
            const applications = prev.applications.map((a)=>{
                if (a.engineer?.engineerMasterId !== id) return a;
                const eng = a.engineer ?? (0, $f34886e55d1cc894$export$a8d188a5e3c35f58)();
                if (!(0, $f34886e55d1cc894$export$2654cb00f18a4c7)(eng, updatedMaster)) return {
                    ...a,
                    engineer: {
                        ...eng,
                        linkedAt: undefined
                    }
                };
                return a;
            });
            return {
                engineerMasters: nextMasters,
                applications: applications
            };
        });
        showToast("Engineer details updated.", "success");
        return true;
    }, [
        patchRoot,
        refreshEngineerMastersFromApi,
        showToast
    ]);
    const deleteEngineerMaster = (0, $7UyaH.useCallback)(async (id)=>{
        if (engineerMastersApiActiveRef.current) try {
            await (0, $1d8c0bf20c21a404$export$78aa1e536cf07750)(id);
            const list = await (0, $1d8c0bf20c21a404$export$536b9d2fdec42e3a)();
            if (applicationsApiActiveRef.current && (0, $4aabdb75dcf6b773$export$8f84a4e698ab11e9)(can)) try {
                applicationsSkipNextPersistRef.current = true;
                const apps = await (0, $afb7b21c21651d62$export$70a1c87d000b9dea)();
                setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                        ...prev,
                        engineerMasters: list,
                        applications: apps
                    }));
            } catch (e) {
                setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                        ...prev,
                        engineerMasters: list
                    }));
                showToast(e instanceof Error ? e.message : "Applicants list could not be refreshed; reload the page if needed.", "error");
                return true;
            }
            else setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                    ...prev,
                    engineerMasters: list
                }));
            showToast("Engineer removed from master list.", "success");
            return true;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not delete engineer.", "error");
            return false;
        }
        patchRoot((prev)=>({
                engineerMasters: prev.engineerMasters.filter((m)=>m.id !== id),
                applications: prev.applications.map((a)=>a.engineer?.engineerMasterId === id ? {
                        ...a,
                        engineer: {
                            engineerMasterId: null,
                            linkedAt: undefined
                        }
                    } : a)
            }));
        showToast("Engineer removed from master list.", "success");
        return true;
    }, [
        patchRoot,
        showToast,
        can
    ]);
    const addAgentMaster = (0, $7UyaH.useCallback)(async (row)=>{
        if (agentMastersApiActiveRef.current) try {
            const created = await (0, $1485bf7ae89e47c2$export$af683a070286e4a8)(row);
            await refreshAgentsFromApi();
            showToast("Agent saved.", "success");
            return created.id;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not save agent.", "error");
            return "";
        }
        const newId = `agent-${Date.now()}`;
        const { newPassword: _np, clearPassword: _cp, ...profile } = row;
        const created = {
            ...profile,
            id: newId,
            hasPassword: Boolean(row.newPassword?.trim()),
            passwordMode: row.passwordMode ?? "random",
            onboardingEmailSentAt: null,
            createdAt: new Date().toISOString()
        };
        patchRoot((prev)=>({
                applications: prev.applications,
                subcontractorMasters: prev.subcontractorMasters,
                agentMasters: [
                    ...prev.agentMasters,
                    created
                ]
            }));
        showToast("Agent saved.", "success");
        return newId;
    }, [
        patchRoot,
        refreshAgentsFromApi,
        showToast
    ]);
    const updateAgentMaster = (0, $7UyaH.useCallback)(async (id, patch)=>{
        if (agentMastersApiActiveRef.current) try {
            await (0, $1485bf7ae89e47c2$export$ba9326e94e67a5d0)(id, patch);
            await refreshAgentsFromApi();
            showToast("Agent updated.", "success");
            return true;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not update agent.", "error");
            return false;
        }
        const { newPassword: newPassword, clearPassword: clearPassword, ...profile } = patch;
        patchRoot((prev)=>({
                applications: prev.applications,
                subcontractorMasters: prev.subcontractorMasters,
                agentMasters: prev.agentMasters.map((m)=>{
                    if (m.id !== id) return m;
                    let hasPassword = m.hasPassword;
                    if (clearPassword === true && (newPassword === undefined || String(newPassword).trim() === "")) hasPassword = false;
                    else if (newPassword !== undefined && String(newPassword).trim() !== "") hasPassword = true;
                    if (profile.passwordMode === "random" && m.passwordMode === "custom") hasPassword = false;
                    return {
                        ...m,
                        ...profile,
                        hasPassword: hasPassword
                    };
                })
            }));
        showToast("Agent updated.", "success");
        return true;
    }, [
        patchRoot,
        refreshAgentsFromApi,
        showToast
    ]);
    const deleteAgentMaster = (0, $7UyaH.useCallback)(async (id)=>{
        if (agentMastersApiActiveRef.current) try {
            await (0, $1485bf7ae89e47c2$export$d87759626a82948e)(id);
            await refreshAgentsFromApi();
            showToast("Agent removed.", "success");
            return true;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not delete agent.", "error");
            return false;
        }
        patchRoot((prev)=>({
                applications: prev.applications,
                subcontractorMasters: prev.subcontractorMasters,
                agentMasters: prev.agentMasters.filter((m)=>m.id !== id)
            }));
        showToast("Agent removed.", "success");
        return true;
    }, [
        patchRoot,
        refreshAgentsFromApi,
        showToast
    ]);
    const sendAgentOnboardingEmail = (0, $7UyaH.useCallback)(async (id, options)=>{
        if (!agentMastersApiActiveRef.current) {
            showToast("Connect to the server to send onboarding email.", "error");
            return false;
        }
        try {
            await (0, $1485bf7ae89e47c2$export$5f723f76a5785bfe)(id, options);
            await refreshAgentsFromApi();
            showToast("Onboarding email sent.", "success");
            return true;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not send onboarding email.", "error");
            return false;
        }
    }, [
        refreshAgentsFromApi,
        showToast
    ]);
    const addMilestoneTemplate = (0, $7UyaH.useCallback)(async (input)=>{
        const title = input.title.trim();
        if (!title) {
            showToast("Enter a milestone title.", "error");
            return false;
        }
        if (milestoneTemplatesApiActiveRef.current) try {
            const prev = rootRef.current;
            const linkedConstructionTimelinePhaseIds = (0, $3f88d14095f8d1ef$export$b04e1fe63c3eed32)(prev.constructionTimelinePhases, input.linkedConstructionTimelinePhaseIds);
            const linkedResourceIds = (0, $e4e128b49dc9c33a$export$5f86a86b0e7bc44c)(prev.standardResources, input.linkedResourceIds);
            const items = input.items.map((it)=>({
                    kind: it.kind,
                    label: it.label.trim()
                })).filter((it)=>it.label);
            await (0, $e48301f2885073ff$export$520daa0695ee3a88)({
                title: title,
                notes: (input.notes ?? "").trim(),
                items: items,
                linkedConstructionTimelinePhaseIds: linkedConstructionTimelinePhaseIds,
                linkedResourceIds: linkedResourceIds
            });
            await refreshMilestoneTemplatesFromApi();
            showToast("Milestone template created.", "success");
            return true;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not create milestone template.", "error");
            return false;
        }
        patchRoot((prev)=>{
            const sortOrder = prev.milestoneTemplates.reduce((m, t)=>Math.max(m, t.sortOrder), 0) + 1;
            const ts = Date.now();
            const items = input.items.map((it)=>({
                    id: `mti-${ts}-${Math.random().toString(36).slice(2, 9)}`,
                    kind: it.kind,
                    label: it.label.trim()
                })).filter((it)=>it.label);
            const linkedConstructionTimelinePhaseIds = (0, $3f88d14095f8d1ef$export$b04e1fe63c3eed32)(prev.constructionTimelinePhases, input.linkedConstructionTimelinePhaseIds);
            const linkedResourceIds = (0, $e4e128b49dc9c33a$export$5f86a86b0e7bc44c)(prev.standardResources, input.linkedResourceIds);
            const t = {
                id: `mt-${ts}`,
                title: title,
                notes: (input.notes ?? "").trim(),
                sortOrder: sortOrder,
                createdAt: new Date().toISOString(),
                items: items,
                linkedConstructionTimelinePhaseIds: linkedConstructionTimelinePhaseIds,
                linkedResourceIds: linkedResourceIds
            };
            return {
                milestoneTemplates: [
                    ...prev.milestoneTemplates,
                    t
                ]
            };
        });
        showToast("Milestone template created.", "success");
        return true;
    }, [
        patchRoot,
        refreshMilestoneTemplatesFromApi,
        showToast
    ]);
    const updateMilestoneTemplate = (0, $7UyaH.useCallback)(async (id, patch)=>{
        if (milestoneTemplatesApiActiveRef.current) {
            try {
                const prev = rootRef.current;
                const curTpl = prev.milestoneTemplates.find((x)=>x.id === id);
                if (!curTpl) {
                    showToast("Milestone template not found.", "error");
                    return;
                }
                const body = {};
                if (patch.title !== undefined) body.title = patch.title.trim() || curTpl.title;
                if (patch.notes !== undefined) body.notes = patch.notes.trim();
                if (patch.sortOrder !== undefined) body.sortOrder = patch.sortOrder;
                if (patch.linkedConstructionTimelinePhaseIds !== undefined) body.linkedConstructionTimelinePhaseIds = (0, $3f88d14095f8d1ef$export$b04e1fe63c3eed32)(prev.constructionTimelinePhases, patch.linkedConstructionTimelinePhaseIds);
                if (patch.linkedResourceIds !== undefined) body.linkedResourceIds = (0, $e4e128b49dc9c33a$export$5f86a86b0e7bc44c)(prev.standardResources, patch.linkedResourceIds);
                if (Object.keys(body).length === 0) return;
                await (0, $e48301f2885073ff$export$2d529dfacda6da2b)(id, body);
                await refreshMilestoneTemplatesFromApi();
                showToast("Milestone master saved.", "success");
            } catch (e) {
                showToast(e instanceof Error ? e.message : "Could not save milestone template.", "error");
            }
            return;
        }
        patchRoot((prev)=>({
                milestoneTemplates: prev.milestoneTemplates.map((t)=>{
                    if (t.id !== id) return t;
                    const nextTitle = patch.title !== undefined ? patch.title.trim() || t.title : t.title;
                    const nextNotes = patch.notes !== undefined ? patch.notes.trim() : t.notes;
                    let linkedConstructionTimelinePhaseIds = t.linkedConstructionTimelinePhaseIds;
                    if (patch.linkedConstructionTimelinePhaseIds !== undefined) linkedConstructionTimelinePhaseIds = (0, $3f88d14095f8d1ef$export$b04e1fe63c3eed32)(prev.constructionTimelinePhases, patch.linkedConstructionTimelinePhaseIds);
                    let linkedResourceIds = t.linkedResourceIds;
                    if (patch.linkedResourceIds !== undefined) linkedResourceIds = (0, $e4e128b49dc9c33a$export$5f86a86b0e7bc44c)(prev.standardResources, patch.linkedResourceIds);
                    return {
                        ...t,
                        ...patch,
                        title: nextTitle,
                        notes: nextNotes,
                        linkedConstructionTimelinePhaseIds: linkedConstructionTimelinePhaseIds,
                        linkedResourceIds: linkedResourceIds
                    };
                })
            }));
        showToast("Milestone master saved.", "success");
    }, [
        patchRoot,
        refreshMilestoneTemplatesFromApi,
        showToast
    ]);
    const removeMilestoneTemplate = (0, $7UyaH.useCallback)(async (id)=>{
        if (milestoneTemplatesApiActiveRef.current) try {
            await (0, $e48301f2885073ff$export$2568cdce944557d7)(id);
            await refreshMilestoneTemplatesFromApi();
            showToast("Milestone template removed.", "success");
            return true;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not remove milestone template.", "error");
            return false;
        }
        patchRoot((prev)=>({
                milestoneTemplates: prev.milestoneTemplates.filter((t)=>t.id !== id)
            }));
        showToast("Milestone template removed.", "success");
        return true;
    }, [
        patchRoot,
        refreshMilestoneTemplatesFromApi,
        showToast
    ]);
    const addMilestoneTemplateItem = (0, $7UyaH.useCallback)(async (templateId, item)=>{
        const label = item.label.trim();
        if (!label) {
            showToast("Enter an item label.", "error");
            return false;
        }
        if (milestoneTemplatesApiActiveRef.current) try {
            await (0, $e48301f2885073ff$export$4dd0a50804b980f0)(templateId, {
                kind: item.kind,
                label: label
            });
            await refreshMilestoneTemplatesFromApi();
            showToast("Checklist item added.", "success");
            return true;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not add checklist item.", "error");
            return false;
        }
        let added = false;
        patchRoot((prev)=>{
            if (!prev.milestoneTemplates.some((t)=>t.id === templateId)) return {};
            added = true;
            const newItem = {
                id: `mti-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
                kind: item.kind,
                label: label
            };
            return {
                milestoneTemplates: prev.milestoneTemplates.map((t)=>t.id === templateId ? {
                        ...t,
                        items: [
                            ...t.items,
                            newItem
                        ]
                    } : t)
            };
        });
        if (added) showToast("Checklist item added.", "success");
        else showToast("Milestone template not found.", "error");
        return added;
    }, [
        patchRoot,
        refreshMilestoneTemplatesFromApi,
        showToast
    ]);
    const removeMilestoneTemplateItem = (0, $7UyaH.useCallback)(async (templateId, itemId)=>{
        if (milestoneTemplatesApiActiveRef.current) {
            try {
                await (0, $e48301f2885073ff$export$632f0fc5fc984f66)(templateId, itemId);
                await refreshMilestoneTemplatesFromApi();
                showToast("Checklist item removed.", "success");
            } catch (e) {
                showToast(e instanceof Error ? e.message : "Could not remove checklist item.", "error");
            }
            return;
        }
        patchRoot((prev)=>({
                milestoneTemplates: prev.milestoneTemplates.map((t)=>t.id === templateId ? {
                        ...t,
                        items: t.items.filter((i)=>i.id !== itemId)
                    } : t)
            }));
        showToast("Checklist item removed.", "success");
    }, [
        patchRoot,
        refreshMilestoneTemplatesFromApi,
        showToast
    ]);
    const setMilestonePhaseComplete = (0, $7UyaH.useCallback)((applicationId, templateId, done)=>{
        if (!requireApplicantDossierMutation()) return;
        const at = new Date().toISOString();
        // Optimistic local update
        patchRoot((prev)=>({
                applications: prev.applications.map((a)=>{
                    if (a.id !== applicationId) return a;
                    return {
                        ...a,
                        milestoneProgress: a.milestoneProgress.map((p)=>p.templateId !== templateId ? p : {
                                ...p,
                                milestoneCompletedAt: done ? p.milestoneCompletedAt ?? at : null
                            })
                    };
                })
            }));
        // Persist to server — use existing completedAt if already set, otherwise the new timestamp
        const existingCompletedAt = rootRef.current.applications.find((a)=>a.id === applicationId)?.milestoneProgress.find((p)=>p.templateId === templateId)?.milestoneCompletedAt ?? null;
        const completedAt = done ? existingCompletedAt ?? at : null;
        (0, $afb7b21c21651d62$export$7a1e37cc1c533e06)(applicationId, templateId, done, completedAt).catch((err)=>{
            showToast(err instanceof Error ? err.message : "Could not save milestone status.", "error");
        });
        showToast(done ? "Milestone marked complete." : "Milestone completion cleared.", "success");
    }, [
        patchRoot,
        showToast,
        requireApplicantDossierMutation
    ]);
    const setMilestoneItemBillLink = (0, $7UyaH.useCallback)(async (applicationId, templateId, templateItemId, workDoneBillId)=>{
        if (!requireApplicantDossierMutation()) return;
        const app = rootRef.current.applications.find((a)=>a.id === applicationId);
        if (!app) {
            showToast("Application not found.", "error");
            return;
        }
        const bid = workDoneBillId?.trim() || null;
        if (bid && !app.workDoneBills.some((b)=>b.id === bid)) {
            showToast("That bill is not on this file. Add the bill on the Bills tab first.", "error");
            return;
        }
        try {
            await persistDossierPatch(applicationId, {
                milestoneItem: {
                    templateId: templateId,
                    templateItemId: templateItemId,
                    workDoneBillId: bid
                }
            });
            showToast("Bill link updated.", "success");
        } catch (err) {
            showToast(err instanceof Error ? err.message : "Could not update bill link.", "error");
            throw err;
        }
    }, [
        persistDossierPatch,
        showToast,
        requireApplicantDossierMutation
    ]);
    const setMilestoneItemDone = (0, $7UyaH.useCallback)(async (applicationId, templateId, templateItemId, done, workDoneBillId)=>{
        if (!requireApplicantDossierMutation()) return;
        const at = new Date().toISOString();
        const tpl = rootRef.current.milestoneTemplates.find((t)=>t.id === templateId);
        const itemDef = tpl?.items.find((i)=>i.id === templateItemId);
        if (!itemDef) {
            showToast("Milestone item not found.", "error");
            return;
        }
        const app = rootRef.current.applications.find((a)=>a.id === applicationId);
        if (!app) {
            showToast("Application not found.", "error");
            return;
        }
        const progress = app.milestoneProgress.find((p)=>p.templateId === templateId);
        const itemProgress = progress?.itemProgress.find((ip)=>ip.templateItemId === templateItemId);
        let billId = null;
        if (done && itemDef.kind === "work_done_bill") {
            billId = (workDoneBillId ?? itemProgress?.workDoneBillId)?.trim() || null;
            if (!billId || !app.workDoneBills.some((b)=>b.id === billId)) {
                showToast("Choose a valid work-done bill for this item.", "error");
                return;
            }
        }
        const completedAt = done ? itemProgress?.completedAt ?? at : null;
        try {
            await persistDossierPatch(applicationId, {
                milestoneItem: {
                    templateId: templateId,
                    templateItemId: templateItemId,
                    completedAt: completedAt,
                    ...done && itemDef.kind === "work_done_bill" ? {
                        workDoneBillId: billId
                    } : {},
                    ...!done && itemDef.kind === "work_done_bill" ? {
                        workDoneBillId: null
                    } : {}
                }
            });
            showToast(done ? "Checklist item marked done." : "Checklist item cleared.", "success");
        } catch (err) {
            showToast(err instanceof Error ? err.message : "Could not update checklist item.", "error");
            throw err;
        }
    }, [
        persistDossierPatch,
        showToast,
        requireApplicantDossierMutation
    ]);
    const addGeoZone = (0, $7UyaH.useCallback)(async (input)=>{
        const name = input.name.trim();
        if (!name) {
            showToast("Enter a zone name.", "error");
            return "";
        }
        if (geoZonesApiActiveRef.current) try {
            const row = await (0, $709afcad7b3e6a59$export$ec723fc9d9feee97)({
                name: name,
                notes: (input.notes ?? "").trim()
            });
            await refreshGeoZonesFromApi();
            showToast("Geographic zone created.", "success");
            return row.id;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not create zone.", "error");
            return "";
        }
        const id = `zone-${Date.now()}`;
        patchRoot((prev)=>{
            const sortOrder = prev.geoZones.reduce((m, z)=>Math.max(m, z.sortOrder), 0) + 1;
            const z = {
                id: id,
                name: name,
                notes: (input.notes ?? "").trim(),
                districtKeys: [],
                mandalRefs: [],
                villageRefs: [],
                sortOrder: sortOrder,
                createdAt: new Date().toISOString()
            };
            return {
                geoZones: [
                    ...prev.geoZones,
                    z
                ]
            };
        });
        showToast("Geographic zone created.", "success");
        return id;
    }, [
        patchRoot,
        refreshGeoZonesFromApi,
        showToast
    ]);
    const updateGeoZone = (0, $7UyaH.useCallback)(async (id, patch)=>{
        if (geoZonesApiActiveRef.current) {
            try {
                const current = rootRef.current.geoZones.find((z)=>z.id === id);
                if (!current) {
                    showToast("Zone not found.", "error");
                    return;
                }
                const body = {};
                if (patch.name !== undefined) body.name = patch.name.trim() || current.name;
                if (patch.notes !== undefined) body.notes = patch.notes.trim();
                if (patch.districtKeys !== undefined) body.districtKeys = patch.districtKeys;
                if (patch.mandalRefs !== undefined) body.mandalRefs = patch.mandalRefs;
                if (patch.villageRefs !== undefined) body.villageRefs = patch.villageRefs;
                if (patch.sortOrder !== undefined) body.sortOrder = patch.sortOrder;
                if (Object.keys(body).length === 0) return;
                await (0, $709afcad7b3e6a59$export$db34b3fc61ba961b)(id, body);
                await refreshGeoZonesFromApi();
                showToast("Zone updated.", "success");
            } catch (e) {
                showToast(e instanceof Error ? e.message : "Could not update zone.", "error");
            }
            return;
        }
        patchRoot((prev)=>({
                geoZones: prev.geoZones.map((z)=>{
                    if (z.id !== id) return z;
                    return {
                        ...z,
                        ...patch,
                        name: patch.name !== undefined ? patch.name.trim() || z.name : z.name,
                        notes: patch.notes !== undefined ? patch.notes.trim() : z.notes,
                        districtKeys: patch.districtKeys ?? z.districtKeys,
                        mandalRefs: patch.mandalRefs ?? z.mandalRefs,
                        villageRefs: patch.villageRefs ?? z.villageRefs
                    };
                })
            }));
        showToast("Zone updated.", "success");
    }, [
        patchRoot,
        refreshGeoZonesFromApi,
        showToast
    ]);
    const removeGeoZone = (0, $7UyaH.useCallback)(async (id)=>{
        if (geoZonesApiActiveRef.current) {
            try {
                await (0, $709afcad7b3e6a59$export$457572f016dcc4eb)(id);
                await refreshGeoZonesFromApi();
                showToast("Zone removed.", "success");
            } catch (e) {
                showToast(e instanceof Error ? e.message : "Could not remove zone.", "error");
            }
            return;
        }
        patchRoot((prev)=>({
                geoZones: prev.geoZones.filter((z)=>z.id !== id)
            }));
        showToast("Zone removed.", "success");
    }, [
        patchRoot,
        refreshGeoZonesFromApi,
        showToast
    ]);
    const addStoreYard = (0, $7UyaH.useCallback)(async (input)=>{
        const name = input.name.trim();
        if (!name) {
            showToast("Enter a store or yard name.", "error");
            return "";
        }
        if (storeYardsApiActiveRef.current) try {
            const row = await (0, $1b8cd287af9bc7a7$export$96c375325f004035)({
                name: name,
                notes: (input.notes ?? "").trim(),
                address: (input.address ?? "").trim()
            });
            await refreshStoreYardsFromApi();
            showToast("Store / yard created.", "success");
            return row.id;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not create store yard.", "error");
            return "";
        }
        const id = `store-${Date.now()}`;
        patchRoot((prev)=>{
            const sortOrder = prev.storeYards.reduce((m, s)=>Math.max(m, s.sortOrder), 0) + 1;
            const s = {
                id: id,
                name: name,
                notes: (input.notes ?? "").trim(),
                address: (input.address ?? "").trim(),
                scopeType: "district",
                districtKeys: [],
                mandalRefs: [],
                villageRefs: [],
                zoneIds: [],
                sortOrder: sortOrder,
                createdAt: new Date().toISOString()
            };
            return {
                storeYards: [
                    ...prev.storeYards,
                    s
                ]
            };
        });
        showToast("Store / yard created.", "success");
        return id;
    }, [
        patchRoot,
        refreshStoreYardsFromApi,
        showToast
    ]);
    const updateStoreYard = (0, $7UyaH.useCallback)(async (id, patch)=>{
        if (storeYardsApiActiveRef.current) {
            try {
                const current = rootRef.current.storeYards.find((s)=>s.id === id);
                const body = {};
                if (patch.name !== undefined) {
                    const nextName = patch.name.trim() || current?.name;
                    if (!nextName) {
                        showToast("Name cannot be empty.", "error");
                        return;
                    }
                    body.name = nextName;
                }
                if (patch.notes !== undefined) body.notes = patch.notes.trim();
                if (patch.address !== undefined) body.address = patch.address.trim();
                if (patch.scopeType !== undefined) body.scopeType = patch.scopeType;
                if (patch.districtKeys !== undefined) body.districtKeys = patch.districtKeys;
                if (patch.mandalRefs !== undefined) body.mandalRefs = patch.mandalRefs;
                if (patch.villageRefs !== undefined) body.villageRefs = patch.villageRefs;
                if (patch.zoneIds !== undefined) body.zoneIds = patch.zoneIds;
                if (patch.sortOrder !== undefined) body.sortOrder = patch.sortOrder;
                if (Object.keys(body).length === 0) return;
                await (0, $1b8cd287af9bc7a7$export$2bf9a048f41d1cc7)(id, body);
                await refreshStoreYardsFromApi();
                showToast("Store / yard updated.", "success");
            } catch (e) {
                showToast(e instanceof Error ? e.message : "Could not update store yard.", "error");
            }
            return;
        }
        patchRoot((prev)=>({
                storeYards: prev.storeYards.map((s)=>{
                    if (s.id !== id) return s;
                    return {
                        ...s,
                        ...patch,
                        name: patch.name !== undefined ? patch.name.trim() || s.name : s.name,
                        notes: patch.notes !== undefined ? patch.notes.trim() : s.notes,
                        address: patch.address !== undefined ? patch.address.trim() : s.address,
                        scopeType: patch.scopeType ?? s.scopeType,
                        districtKeys: patch.districtKeys ?? s.districtKeys,
                        mandalRefs: patch.mandalRefs ?? s.mandalRefs,
                        villageRefs: patch.villageRefs ?? s.villageRefs,
                        zoneIds: patch.zoneIds ?? s.zoneIds
                    };
                })
            }));
        showToast("Store / yard updated.", "success");
    }, [
        patchRoot,
        refreshStoreYardsFromApi,
        showToast
    ]);
    const removeStoreYard = (0, $7UyaH.useCallback)(async (id)=>{
        if (storeYardsApiActiveRef.current) try {
            await (0, $1b8cd287af9bc7a7$export$1d45872999e4c0da)(id);
            await refreshStoreYardsFromApi();
            showToast("Store / yard removed.", "success");
            return true;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not remove store yard.", "error");
            return false;
        }
        patchRoot((prev)=>({
                storeYards: prev.storeYards.filter((s)=>s.id !== id)
            }));
        showToast("Store / yard removed.", "success");
        return true;
    }, [
        patchRoot,
        refreshStoreYardsFromApi,
        showToast
    ]);
    const moveStoreYard = (0, $7UyaH.useCallback)(async (id, direction)=>{
        if (storeYardsApiActiveRef.current) {
            try {
                const prev = rootRef.current;
                const sorted = [
                    ...prev.storeYards
                ].sort((a, b)=>a.sortOrder - b.sortOrder);
                const idx = sorted.findIndex((s)=>s.id === id);
                if (idx < 0) {
                    showToast("Store yard not found.", "error");
                    return;
                }
                const j = direction === "up" ? idx - 1 : idx + 1;
                if (j < 0 || j >= sorted.length) {
                    showToast("Cannot move this store further.", "error");
                    return;
                }
                const reordered = [
                    ...sorted
                ];
                [reordered[idx], reordered[j]] = [
                    reordered[j],
                    reordered[idx]
                ];
                const orderedIds = reordered.map((s)=>s.id);
                const list = await (0, $1b8cd287af9bc7a7$export$7a55a23ea3ac9dcc)(orderedIds);
                setRoot((p)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                        ...p,
                        storeYards: list
                    }));
                showToast("Store order updated.", "success");
            } catch (e) {
                showToast(e instanceof Error ? e.message : "Could not reorder stores.", "error");
            }
            return;
        }
        let moved = false;
        patchRoot((prev)=>{
            const sorted = [
                ...prev.storeYards
            ].sort((a, b)=>a.sortOrder - b.sortOrder);
            const idx = sorted.findIndex((s)=>s.id === id);
            if (idx < 0) return {};
            const j = direction === "up" ? idx - 1 : idx + 1;
            if (j < 0 || j >= sorted.length) return {};
            moved = true;
            const reordered = [
                ...sorted
            ];
            [reordered[idx], reordered[j]] = [
                reordered[j],
                reordered[idx]
            ];
            const withOrder = reordered.map((s, i)=>({
                    ...s,
                    sortOrder: i + 1
                }));
            const byId = new Map(withOrder.map((s)=>[
                    s.id,
                    s
                ]));
            return {
                storeYards: prev.storeYards.map((s)=>byId.get(s.id) ?? s)
            };
        });
        showToast(moved ? "Store order updated." : "Cannot move this store further.", moved ? "success" : "error");
    }, [
        patchRoot,
        showToast
    ]);
    const addConstructionTimelinePhase = (0, $7UyaH.useCallback)(async (input)=>{
        const title = input.title.trim();
        if (!title) {
            showToast("Enter a level name.", "error");
            return "";
        }
        const approxDays = Math.max(0, Math.floor(Number(input.approxDays)) || 0);
        if (timelineApiActiveRef.current) try {
            const row = await (0, $e532bc2b6b908ae9$export$767f900e3e8a8f5a)({
                title: title,
                approxDays: approxDays
            });
            await refreshTimelineFromApi();
            showToast("Timeline level added.", "success");
            return String(row.id);
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not add timeline level.", "error");
            return "";
        }
        const id = `ctp-${Date.now()}`;
        patchRoot((prev)=>{
            const sortOrder = prev.constructionTimelinePhases.reduce((m, p)=>Math.max(m, p.sortOrder), 0) + 1;
            const row = {
                id: id,
                title: title,
                approxDays: approxDays,
                sortOrder: sortOrder,
                createdAt: new Date().toISOString()
            };
            return {
                constructionTimelinePhases: [
                    ...prev.constructionTimelinePhases,
                    row
                ]
            };
        });
        showToast("Timeline level added (offline).", "success");
        return id;
    }, [
        patchRoot,
        refreshTimelineFromApi,
        showToast
    ]);
    const updateConstructionTimelinePhase = (0, $7UyaH.useCallback)(async (id, patch)=>{
        if (timelineApiActiveRef.current) {
            try {
                const current = rootRef.current.constructionTimelinePhases.find((p)=>p.id === id);
                if (!current) {
                    showToast("Timeline level not found.", "error");
                    return;
                }
                const title = patch.title !== undefined ? patch.title.trim() || current.title : current.title;
                const approxDays = patch.approxDays !== undefined ? Math.max(0, Math.floor(Number(patch.approxDays)) || 0) : current.approxDays;
                const sortOrder = patch.sortOrder !== undefined ? patch.sortOrder : current.sortOrder;
                await (0, $e532bc2b6b908ae9$export$dc5661b07d07312e)(id, {
                    title: title,
                    approxDays: approxDays,
                    sortOrder: sortOrder
                });
                await refreshTimelineFromApi();
                showToast("Timeline level saved.", "success");
            } catch (e) {
                showToast(e instanceof Error ? e.message : "Could not save timeline level.", "error");
            }
            return;
        }
        patchRoot((prev)=>({
                constructionTimelinePhases: prev.constructionTimelinePhases.map((p)=>{
                    if (p.id !== id) return p;
                    const title = patch.title !== undefined ? patch.title.trim() || p.title : p.title;
                    const approxDays = patch.approxDays !== undefined ? Math.max(0, Math.floor(Number(patch.approxDays)) || 0) : p.approxDays;
                    return {
                        ...p,
                        ...patch,
                        title: title,
                        approxDays: approxDays
                    };
                })
            }));
        showToast("Timeline level saved (offline).", "success");
    }, [
        patchRoot,
        refreshTimelineFromApi,
        showToast
    ]);
    const removeConstructionTimelinePhase = (0, $7UyaH.useCallback)(async (id)=>{
        if (timelineApiActiveRef.current) try {
            await (0, $e532bc2b6b908ae9$export$b70f8654c359f8e9)(id);
            await refreshTimelineFromApi();
            patchRoot((prev)=>({
                    milestoneTemplates: prev.milestoneTemplates.map((t)=>({
                            ...t,
                            linkedConstructionTimelinePhaseIds: t.linkedConstructionTimelinePhaseIds.filter((x)=>x !== id)
                        })),
                    applications: prev.applications.map((a)=>{
                        const map = a.constructionTimelineActualDays;
                        if (!map || !(id in map)) return a;
                        const { [id]: _removed, ...rest } = map;
                        return {
                            ...a,
                            constructionTimelineActualDays: Object.keys(rest).length ? rest : undefined
                        };
                    })
                }));
            showToast("Timeline level removed.", "success");
            return true;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not remove timeline level.", "error");
            return false;
        }
        patchRoot((prev)=>({
                constructionTimelinePhases: prev.constructionTimelinePhases.filter((p)=>p.id !== id),
                milestoneTemplates: prev.milestoneTemplates.map((t)=>({
                        ...t,
                        linkedConstructionTimelinePhaseIds: t.linkedConstructionTimelinePhaseIds.filter((x)=>x !== id)
                    })),
                applications: prev.applications.map((a)=>{
                    const map = a.constructionTimelineActualDays;
                    if (!map || !(id in map)) return a;
                    const { [id]: _removed, ...rest } = map;
                    return {
                        ...a,
                        constructionTimelineActualDays: Object.keys(rest).length ? rest : undefined
                    };
                })
            }));
        showToast("Timeline level removed (offline).", "success");
        return true;
    }, [
        patchRoot,
        refreshTimelineFromApi,
        showToast
    ]);
    const moveConstructionTimelinePhase = (0, $7UyaH.useCallback)(async (id, direction)=>{
        if (timelineApiActiveRef.current) {
            try {
                const prev = rootRef.current;
                const sorted = [
                    ...prev.constructionTimelinePhases
                ].sort((a, b)=>a.sortOrder - b.sortOrder);
                const idx = sorted.findIndex((p)=>p.id === id);
                if (idx < 0) {
                    showToast("Timeline level not found.", "error");
                    return;
                }
                const j = direction === "up" ? idx - 1 : idx + 1;
                if (j < 0 || j >= sorted.length) {
                    showToast("Cannot move this level further.", "error");
                    return;
                }
                const reordered = [
                    ...sorted
                ];
                [reordered[idx], reordered[j]] = [
                    reordered[j],
                    reordered[idx]
                ];
                const orderedIds = reordered.map((p)=>Number(p.id));
                await (0, $e532bc2b6b908ae9$export$d4b524073f2183c1)(orderedIds);
                await refreshTimelineFromApi();
                showToast("Timeline order updated.", "success");
            } catch (e) {
                showToast(e instanceof Error ? e.message : "Could not reorder timeline.", "error");
            }
            return;
        }
        let moved = false;
        patchRoot((prev)=>{
            const sorted = [
                ...prev.constructionTimelinePhases
            ].sort((a, b)=>a.sortOrder - b.sortOrder);
            const idx = sorted.findIndex((p)=>p.id === id);
            if (idx < 0) return {};
            const j = direction === "up" ? idx - 1 : idx + 1;
            if (j < 0 || j >= sorted.length) return {};
            moved = true;
            const reordered = [
                ...sorted
            ];
            [reordered[idx], reordered[j]] = [
                reordered[j],
                reordered[idx]
            ];
            const withOrder = reordered.map((p, i)=>({
                    ...p,
                    sortOrder: i + 1
                }));
            const byId = new Map(withOrder.map((p)=>[
                    p.id,
                    p
                ]));
            return {
                constructionTimelinePhases: prev.constructionTimelinePhases.map((p)=>byId.get(p.id) ?? p)
            };
        });
        showToast(moved ? "Timeline order updated (offline)." : "Cannot move this level further.", moved ? "success" : "error");
    }, [
        patchRoot,
        refreshTimelineFromApi,
        showToast
    ]);
    const addStandardResource = (0, $7UyaH.useCallback)(async (input)=>{
        const title = input.title.trim();
        if (!title) {
            showToast("Enter a resource title.", "error");
            return "";
        }
        if (standardResourcesApiActiveRef.current) try {
            const row = await (0, $770fd32f52113801$export$e4768a598e556f55)({
                title: title,
                notes: (input.notes ?? "").trim()
            });
            await refreshStandardResourcesFromApi();
            showToast("Standard resource created.", "success");
            return row.id;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not create resource.", "error");
            return "";
        }
        const id = `sr-${Date.now()}`;
        patchRoot((prev)=>{
            const sortOrder = prev.standardResources.reduce((m, r)=>Math.max(m, r.sortOrder), 0) + 1;
            const row = {
                id: id,
                title: title,
                notes: (input.notes ?? "").trim(),
                sortOrder: sortOrder,
                items: [],
                createdAt: new Date().toISOString()
            };
            return {
                standardResources: [
                    ...prev.standardResources,
                    row
                ]
            };
        });
        showToast("Standard resource created.", "success");
        return id;
    }, [
        patchRoot,
        refreshStandardResourcesFromApi,
        showToast
    ]);
    const updateStandardResource = (0, $7UyaH.useCallback)(async (id, patch)=>{
        if (standardResourcesApiActiveRef.current) {
            try {
                const current = rootRef.current.standardResources.find((r)=>r.id === id);
                if (!current) {
                    showToast("Standard resource not found.", "error");
                    return;
                }
                const title = patch.title !== undefined ? patch.title.trim() || current.title : current.title;
                const notes = patch.notes !== undefined ? patch.notes.trim() : current.notes;
                const sortOrder = patch.sortOrder !== undefined ? patch.sortOrder : current.sortOrder;
                await (0, $770fd32f52113801$export$81c1f409299664de)(id, {
                    title: title,
                    notes: notes,
                    sortOrder: sortOrder
                });
                await refreshStandardResourcesFromApi();
                showToast("Standard resource saved.", "success");
            } catch (e) {
                showToast(e instanceof Error ? e.message : "Could not save resource.", "error");
            }
            return;
        }
        patchRoot((prev)=>({
                standardResources: prev.standardResources.map((r)=>{
                    if (r.id !== id) return r;
                    return {
                        ...r,
                        ...patch,
                        title: patch.title !== undefined ? patch.title.trim() || r.title : r.title,
                        notes: patch.notes !== undefined ? patch.notes.trim() : r.notes
                    };
                })
            }));
        showToast("Standard resource saved.", "success");
    }, [
        patchRoot,
        refreshStandardResourcesFromApi,
        showToast
    ]);
    const removeStandardResource = (0, $7UyaH.useCallback)(async (id)=>{
        if (standardResourcesApiActiveRef.current) try {
            await (0, $770fd32f52113801$export$e8724159a682356b)(id);
            const list = await (0, $770fd32f52113801$export$6aa64b79d921e94c)();
            setRoot((prev)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                    ...prev,
                    standardResources: list,
                    milestoneTemplates: prev.milestoneTemplates.map((t)=>({
                            ...t,
                            linkedResourceIds: t.linkedResourceIds.filter((x)=>x !== id)
                        }))
                }));
            showToast("Standard resource removed.", "success");
            return true;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not remove resource.", "error");
            return false;
        }
        patchRoot((prev)=>({
                standardResources: prev.standardResources.filter((r)=>r.id !== id),
                milestoneTemplates: prev.milestoneTemplates.map((t)=>({
                        ...t,
                        linkedResourceIds: t.linkedResourceIds.filter((x)=>x !== id)
                    }))
            }));
        showToast("Standard resource removed.", "success");
        return true;
    }, [
        patchRoot,
        refreshStandardResourcesFromApi,
        showToast
    ]);
    const moveStandardResource = (0, $7UyaH.useCallback)(async (id, direction)=>{
        if (standardResourcesApiActiveRef.current) {
            try {
                const prev = rootRef.current;
                const sorted = [
                    ...prev.standardResources
                ].sort((a, b)=>a.sortOrder - b.sortOrder);
                const idx = sorted.findIndex((r)=>r.id === id);
                if (idx < 0) {
                    showToast("Standard resource not found.", "error");
                    return;
                }
                const j = direction === "up" ? idx - 1 : idx + 1;
                if (j < 0 || j >= sorted.length) {
                    showToast("Cannot move this resource further.", "error");
                    return;
                }
                const reordered = [
                    ...sorted
                ];
                [reordered[idx], reordered[j]] = [
                    reordered[j],
                    reordered[idx]
                ];
                const orderedIds = reordered.map((r)=>r.id);
                const list = await (0, $770fd32f52113801$export$9f48b439795ba993)(orderedIds);
                setRoot((p)=>$5f16f4b9f1d6ad44$var$finalizeDraft({
                        ...p,
                        standardResources: list
                    }));
                showToast("Resource order updated.", "success");
            } catch (e) {
                showToast(e instanceof Error ? e.message : "Could not reorder resources.", "error");
            }
            return;
        }
        let moved = false;
        patchRoot((prev)=>{
            const sorted = [
                ...prev.standardResources
            ].sort((a, b)=>a.sortOrder - b.sortOrder);
            const idx = sorted.findIndex((r)=>r.id === id);
            if (idx < 0) return {};
            const j = direction === "up" ? idx - 1 : idx + 1;
            if (j < 0 || j >= sorted.length) return {};
            moved = true;
            const reordered = [
                ...sorted
            ];
            [reordered[idx], reordered[j]] = [
                reordered[j],
                reordered[idx]
            ];
            const withOrder = reordered.map((r, i)=>({
                    ...r,
                    sortOrder: i + 1
                }));
            const byId = new Map(withOrder.map((r)=>[
                    r.id,
                    r
                ]));
            return {
                standardResources: prev.standardResources.map((r)=>byId.get(r.id) ?? r)
            };
        });
        showToast(moved ? "Resource order updated." : "Cannot move this resource further.", moved ? "success" : "error");
    }, [
        patchRoot,
        showToast
    ]);
    const addStandardResourceItem = (0, $7UyaH.useCallback)(async (resourceId, item)=>{
        const label = item.label.trim();
        const unit = item.unit.trim();
        if (!label || !unit) {
            showToast("Enter label and unit for the line item.", "error");
            return false;
        }
        const quantity = Math.max(0, Number(item.quantity)) || 0;
        const lineRate = Math.max(0, Number(item.rate)) || 0;
        const lineHsn = String(item.hsnCode ?? "").trim().replace(/\s+/g, "").slice(0, 40);
        const catalogStandardItemId = item.catalogStandardItemId?.trim() || null;
        const res = rootRef.current.standardResources.find((r)=>r.id === resourceId);
        if (catalogStandardItemId && res?.items.some((x)=>x.catalogStandardItemId === catalogStandardItemId)) {
            showToast("This catalogue item is already on the resource.", "error");
            return false;
        }
        if (standardResourcesApiActiveRef.current) try {
            await (0, $770fd32f52113801$export$e69e3efefa3377c9)(resourceId, {
                label: label,
                quantity: quantity,
                unit: unit,
                rate: lineRate,
                hsnCode: lineHsn,
                catalogStandardItemId: catalogStandardItemId
            });
            await refreshStandardResourcesFromApi();
            showToast("Line item added.", "success");
            return true;
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not add line item.", "error");
            return false;
        }
        let added = false;
        patchRoot((prev)=>({
                standardResources: prev.standardResources.map((r)=>{
                    if (r.id !== resourceId) return r;
                    added = true;
                    const newItem = {
                        id: `sri-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
                        label: label,
                        quantity: quantity,
                        unit: unit,
                        rate: lineRate,
                        hsnCode: lineHsn,
                        catalogStandardItemId: catalogStandardItemId
                    };
                    return {
                        ...r,
                        items: [
                            ...r.items,
                            newItem
                        ]
                    };
                })
            }));
        if (added) showToast("Line item added.", "success");
        else showToast("Standard resource not found.", "error");
        return added;
    }, [
        patchRoot,
        refreshStandardResourcesFromApi,
        showToast
    ]);
    const updateStandardResourceItem = (0, $7UyaH.useCallback)(async (resourceId, itemId, patch)=>{
        if (standardResourcesApiActiveRef.current) {
            try {
                const res = rootRef.current.standardResources.find((r)=>r.id === resourceId);
                const it = res?.items.find((x)=>x.id === itemId);
                if (!res || !it) {
                    showToast("Line item not found.", "error");
                    return;
                }
                const label = patch.label !== undefined ? patch.label.trim() || it.label : it.label;
                const unit = patch.unit !== undefined ? patch.unit.trim() || it.unit : it.unit;
                const quantity = patch.quantity !== undefined ? Math.max(0, Number(patch.quantity)) || 0 : it.quantity;
                const rate = patch.rate !== undefined ? Math.max(0, Number(patch.rate)) || 0 : it.rate ?? 0;
                const hsnCode = patch.hsnCode !== undefined ? String(patch.hsnCode).trim().replace(/\s+/g, "").slice(0, 40) : it.hsnCode ?? "";
                await (0, $770fd32f52113801$export$343b389b20705f71)(resourceId, itemId, {
                    label: label,
                    unit: unit,
                    quantity: quantity,
                    rate: rate,
                    hsnCode: hsnCode
                });
                await refreshStandardResourcesFromApi();
                showToast("Line item saved.", "success");
            } catch (e) {
                showToast(e instanceof Error ? e.message : "Could not save line item.", "error");
            }
            return;
        }
        patchRoot((prev)=>({
                standardResources: prev.standardResources.map((r)=>{
                    if (r.id !== resourceId) return r;
                    return {
                        ...r,
                        items: r.items.map((item)=>{
                            if (item.id !== itemId) return item;
                            const label = patch.label !== undefined ? patch.label.trim() || item.label : item.label;
                            const u = patch.unit !== undefined ? patch.unit.trim() || item.unit : item.unit;
                            const quantity = patch.quantity !== undefined ? Math.max(0, Number(patch.quantity)) || 0 : item.quantity;
                            const rateVal = patch.rate !== undefined ? Math.max(0, Number(patch.rate)) || 0 : item.rate ?? 0;
                            const hsnCode = patch.hsnCode !== undefined ? String(patch.hsnCode).trim().replace(/\s+/g, "").slice(0, 40) : item.hsnCode ?? "";
                            return {
                                ...item,
                                ...patch,
                                label: label,
                                unit: u,
                                quantity: quantity,
                                rate: rateVal,
                                hsnCode: hsnCode
                            };
                        })
                    };
                })
            }));
        showToast("Line item saved.", "success");
    }, [
        patchRoot,
        refreshStandardResourcesFromApi,
        showToast
    ]);
    const removeStandardResourceItem = (0, $7UyaH.useCallback)(async (resourceId, itemId)=>{
        if (standardResourcesApiActiveRef.current) {
            try {
                await (0, $770fd32f52113801$export$984ae53fbee4dfd)(resourceId, itemId);
                await refreshStandardResourcesFromApi();
                showToast("Line item removed.", "success");
            } catch (e) {
                showToast(e instanceof Error ? e.message : "Could not remove line item.", "error");
            }
            return;
        }
        patchRoot((prev)=>({
                standardResources: prev.standardResources.map((r)=>r.id === resourceId ? {
                        ...r,
                        items: r.items.filter((it)=>it.id !== itemId)
                    } : r)
            }));
        showToast("Line item removed.", "success");
    }, [
        patchRoot,
        refreshStandardResourcesFromApi,
        showToast
    ]);
    const value = (0, $7UyaH.useMemo)(()=>({
            applications: root.applications,
            subcontractorMasters: root.subcontractorMasters,
            engineerMasters: root.engineerMasters,
            agentMasters: root.agentMasters,
            milestoneTemplates: root.milestoneTemplates,
            geoZones: root.geoZones,
            storeYards: root.storeYards,
            constructionTimelinePhases: root.constructionTimelinePhases,
            standardResources: root.standardResources,
            getById: getById,
            getSubcontractorMaster: getSubcontractorMaster,
            getEngineerMaster: getEngineerMaster,
            getAgentMaster: getAgentMaster,
            getMilestoneTemplate: getMilestoneTemplate,
            getStandardResource: getStandardResource,
            updateApplication: updateApplication,
            updateHo: updateHo,
            updateValidations: updateValidations,
            setHoldReasons: setHoldReasons,
            confirmSeeding: confirmSeeding,
            saveIciciDetails: saveIciciDetails,
            addWorkDoneBill: addWorkDoneBill,
            confirmBillSeeding: confirmBillSeeding,
            updateSubcontractor: updateSubcontractor,
            finalizeSubcontractor: finalizeSubcontractor,
            updateEngineer: updateEngineer,
            finalizeEngineer: finalizeEngineer,
            addSubcontractorMaster: addSubcontractorMaster,
            updateSubcontractorMaster: updateSubcontractorMaster,
            deleteSubcontractorMaster: deleteSubcontractorMaster,
            addEngineerMaster: addEngineerMaster,
            updateEngineerMaster: updateEngineerMaster,
            deleteEngineerMaster: deleteEngineerMaster,
            addAgentMaster: addAgentMaster,
            updateAgentMaster: updateAgentMaster,
            deleteAgentMaster: deleteAgentMaster,
            sendAgentOnboardingEmail: sendAgentOnboardingEmail,
            addMilestoneTemplate: addMilestoneTemplate,
            updateMilestoneTemplate: updateMilestoneTemplate,
            removeMilestoneTemplate: removeMilestoneTemplate,
            addMilestoneTemplateItem: addMilestoneTemplateItem,
            removeMilestoneTemplateItem: removeMilestoneTemplateItem,
            setMilestonePhaseComplete: setMilestonePhaseComplete,
            setMilestoneItemBillLink: setMilestoneItemBillLink,
            setMilestoneItemDone: setMilestoneItemDone,
            addGeoZone: addGeoZone,
            updateGeoZone: updateGeoZone,
            removeGeoZone: removeGeoZone,
            addStoreYard: addStoreYard,
            updateStoreYard: updateStoreYard,
            removeStoreYard: removeStoreYard,
            moveStoreYard: moveStoreYard,
            addConstructionTimelinePhase: addConstructionTimelinePhase,
            updateConstructionTimelinePhase: updateConstructionTimelinePhase,
            removeConstructionTimelinePhase: removeConstructionTimelinePhase,
            moveConstructionTimelinePhase: moveConstructionTimelinePhase,
            addStandardResource: addStandardResource,
            updateStandardResource: updateStandardResource,
            removeStandardResource: removeStandardResource,
            moveStandardResource: moveStandardResource,
            addStandardResourceItem: addStandardResourceItem,
            updateStandardResourceItem: updateStandardResourceItem,
            removeStandardResourceItem: removeStandardResourceItem,
            refreshApplicationsFromApi: refreshApplicationsFromApi
        }), [
        root.applications,
        root.subcontractorMasters,
        root.engineerMasters,
        root.agentMasters,
        root.milestoneTemplates,
        root.geoZones,
        root.storeYards,
        root.constructionTimelinePhases,
        root.standardResources,
        getById,
        getSubcontractorMaster,
        getEngineerMaster,
        getAgentMaster,
        getMilestoneTemplate,
        getStandardResource,
        updateApplication,
        updateHo,
        updateValidations,
        setHoldReasons,
        confirmSeeding,
        saveIciciDetails,
        addWorkDoneBill,
        confirmBillSeeding,
        updateSubcontractor,
        finalizeSubcontractor,
        updateEngineer,
        finalizeEngineer,
        addSubcontractorMaster,
        updateSubcontractorMaster,
        deleteSubcontractorMaster,
        addEngineerMaster,
        updateEngineerMaster,
        deleteEngineerMaster,
        addAgentMaster,
        updateAgentMaster,
        deleteAgentMaster,
        sendAgentOnboardingEmail,
        addMilestoneTemplate,
        updateMilestoneTemplate,
        removeMilestoneTemplate,
        addMilestoneTemplateItem,
        removeMilestoneTemplateItem,
        setMilestonePhaseComplete,
        setMilestoneItemBillLink,
        setMilestoneItemDone,
        addGeoZone,
        updateGeoZone,
        removeGeoZone,
        addStoreYard,
        updateStoreYard,
        removeStoreYard,
        moveStoreYard,
        addConstructionTimelinePhase,
        updateConstructionTimelinePhase,
        removeConstructionTimelinePhase,
        moveConstructionTimelinePhase,
        addStandardResource,
        updateStandardResource,
        removeStandardResource,
        moveStandardResource,
        addStandardResourceItem,
        updateStandardResourceItem,
        removeStandardResourceItem,
        refreshApplicationsFromApi
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5f16f4b9f1d6ad44$var$AppStateContext.Provider, {
        value: value,
        children: children
    });
}
function $5f16f4b9f1d6ad44$export$9973955de2bf96cf() {
    const ctx = (0, $7UyaH.useContext)($5f16f4b9f1d6ad44$var$AppStateContext);
    if (!ctx) throw new Error("useAppState must be used within AppStateProvider");
    return ctx;
}



/** Dossier sections — `userHint` is plain-language help for officers */ const $e84bf4288d5796f2$export$66ddc5af3dc06a46 = [
    {
        path: "overview",
        label: "Overview",
        desc: "Summary of this file and quick links",
        userHint: "See where this case stands and jump to the right section in one click."
    },
    {
        path: "beneficiary",
        label: "Beneficiary & documents",
        desc: "What the citizen submitted from the mobile app",
        userHint: "Read-only: name, IDs, bank details, and document list from the field."
    },
    {
        path: "validation",
        label: "Verification & Aadhaar seeding",
        desc: "Office checks before banking",
        userHint: "Mark each check, apply holds if needed, then confirm seeding before ICICI."
    },
    {
        path: "banking",
        label: "ICICI & MOU",
        desc: "Account details and signed MOU",
        userHint: "Unlocked after seeding is confirmed. Save when account number, IFSC, and MOU file are ready."
    },
    {
        path: "subcontractor",
        label: "Subcontractor",
        desc: "Pick firm from master (optional work order)",
        userHint: "After prior steps are done, select the firm from the onboarded list. You may attach this beneficiary\u2019s work order or engagement letter when available. Register new firms under Subcontractor Onboarding in the main menu."
    },
    {
        path: "engineer",
        label: "Engineer",
        desc: "Assign site engineer from master roster",
        userHint: "Pick the engineer responsible for this beneficiary from the Engineer master list. Register engineers under Engineer onboarding in the Masters menu if needed."
    },
    {
        path: "work-progress",
        label: "Work Progress",
        desc: "Gantt chart, materials, and bills for this beneficiary",
        userHint: "Track construction timeline progress, view material allocations, and monitor bill status for this file."
    },
    {
        path: "po-register",
        label: "PO Register",
        desc: "Purchase order history for this beneficiary",
        userHint: "All POs raised for this beneficiary \u2014 milestone, resource, items, quantities, and issue status."
    },
    {
        path: "milestones",
        label: "Milestones",
        desc: "Progress against global milestone master (per beneficiary)",
        userHint: "Checklist comes from Milestone master. Mark each required material or bill done for this file; link work-done bills from the Bills tab where needed."
    },
    {
        path: "bills",
        label: "Bills",
        desc: "Work-done bills and site re-check of seeding",
        userHint: "Upload a bill reference, then ask the site officer to confirm seeding again for each bill."
    }
];


function $656ff0cd812bb926$export$cc5055592eec1498(_app) {
    return false;
}


/** Scroll the app shell content region (not the window) back to the top. */ function $f3386ba944d30bc0$export$bcc5e3e94a66a83b() {
    const scrollEl = document.querySelector(".main__scroll");
    if (scrollEl instanceof HTMLElement) {
        scrollEl.scrollTop = 0;
        return;
    }
    window.scrollTo(0, 0);
}



function $dcd2d56cbb41ba43$export$40d4c787f5d14e8d(app) {
    if (app.status === "subcontractor_linked") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "status-chip status-chip--done",
        children: "Subcontractor linked"
    });
    if (app.status === "icici_recorded") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "status-chip status-chip--progress",
        children: "Awaiting subcontractor"
    });
    if (app.status === "on_hold") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "status-chip status-chip--hold",
        children: "On hold"
    });
    if (app.status === "ready_for_mou") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "status-chip status-chip--progress",
        children: "Ready for MOU"
    });
    if (app.status === "ready_for_icici") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "status-chip status-chip--progress",
        children: "Ready for ICICI"
    });
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "status-chip",
        children: "HO review"
    });
}


const $c32045b0952ded9f$var$TAB_ICONS = {
    overview: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$d7cfde09abbb52ee), {
        className: "tab-nav__ico"
    }),
    beneficiary: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$e3c036464abb30f5), {
        className: "tab-nav__ico"
    }),
    validation: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$207fc5b9a0494333), {
        className: "tab-nav__ico"
    }),
    banking: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$996a671af5cb17c2), {
        className: "tab-nav__ico"
    }),
    subcontractor: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$ca978cd35363e096), {
        className: "tab-nav__ico"
    }),
    engineer: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$bdcbb206cb33984b), {
        className: "tab-nav__ico"
    }),
    "work-progress": /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$1888ff721e893d0e), {
        className: "tab-nav__ico"
    }),
    "po-register": /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$ae118f79ed05e2c0), {
        className: "tab-nav__ico"
    }),
    milestones: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$8dbe4c747de8c5e2), {
        className: "tab-nav__ico"
    }),
    bills: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$ff497d20f87197ae), {
        className: "tab-nav__ico"
    })
};
function $c32045b0952ded9f$var$tabClass({ isActive: isActive }) {
    return "tab-nav__link" + (isActive ? " tab-nav__link--active" : "");
}
function $c32045b0952ded9f$export$e4eeea04c135882f() {
    const { id: id } = (0, $265aeae2597a9f58$export$99eaa27ddbbb95ef)();
    const location = (0, $265aeae2597a9f58$export$45d76561a5302f2b)();
    const { can: can } = (0, $a4dc0d923ddf5b19$export$1d39dc5b47e56ff0)();
    const { getById: getById } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const app = id ? getById(id) : undefined;
    const tabSeg = location.pathname.split("/").pop() ?? "overview";
    const activeTab = (0, $e84bf4288d5796f2$export$66ddc5af3dc06a46).find((t)=>t.path === tabSeg) ?? (0, $e84bf4288d5796f2$export$66ddc5af3dc06a46)[0];
    (0, $7UyaH.useEffect)(()=>{
        (0, $f3386ba944d30bc0$export$bcc5e3e94a66a83b)();
        const frame = requestAnimationFrame(()=>(0, $f3386ba944d30bc0$export$bcc5e3e94a66a83b)());
        return ()=>cancelAnimationFrame(frame);
    }, [
        id,
        location.pathname
    ]);
    if (!app) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "workspace workspace--empty",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Applicants",
                        to: "/applications"
                    },
                    {
                        label: "Not found"
                    }
                ],
                title: "We could not open this file",
                subtitle: "The link may be wrong or this reference was removed. Go back to the list and choose another application."
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                to: "/applications",
                className: "btn btn--primary btn--tg",
                children: "Back to applicants"
            })
        ]
    });
    const from = location.state?.from;
    const base = `/applications/${app.id}`;
    const hideMilestonesBills = (0, $656ff0cd812bb926$export$cc5055592eec1498)(app);
    const milestonesTabAllowed = (0, $4aabdb75dcf6b773$export$96e9d18fd02a12c4)(can);
    const fullApplicantAccess = can("applications");
    const dossierReadOnly = !(0, $4aabdb75dcf6b773$export$6e313773bb334ada)(can);
    const APPLICANT_TABS = new Set([
        "overview",
        "beneficiary",
        "validation",
        "banking"
    ]);
    const BENEFICIARY_TABS = new Set([
        "subcontractor",
        "engineer",
        "work-progress",
        "po-register",
        "milestones",
        "bills"
    ]);
    const sidebarTabs = (0, $e84bf4288d5796f2$export$66ddc5af3dc06a46).filter((t)=>{
        if (from === "applicants" && !APPLICANT_TABS.has(t.path)) return false;
        if (from === "beneficiaries" && !BENEFICIARY_TABS.has(t.path)) return false;
        if (hideMilestonesBills && (t.path === "milestones" || t.path === "bills")) return false;
        if (!milestonesTabAllowed && t.path === "milestones") return false;
        if (!fullApplicantAccess) {
            const pk = (0, $4aabdb75dcf6b773$export$b8157996bdb9c190)[t.path];
            if (!can(pk)) return false;
        }
        return true;
    });
    const backTo = from === "beneficiaries" ? "/subcontractor-to-beneficiary" : "/applications";
    const backLabel = from === "beneficiaries" ? "Beneficiaries" : "Applicants";
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "workspace",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("aside", {
                className: "workspace__sidebar",
                "aria-label": "Dossier sections",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: backTo,
                        className: "workspace__back",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$60b42ba963c1b0af), {}),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                children: backLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "workspace__dossier",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "workspace__dossier-label",
                                children: "Beneficiary dossier"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "workspace__dossier-name",
                                children: app.mobile.beneficiaryName
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "workspace__dossier-id mono",
                                children: app.mobile.applicationId
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                className: "workspace__dossier-sanction mono",
                                children: [
                                    "Sanction: ",
                                    app.mobile.houseSanctionNumber
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "workspace__nav-title",
                        children: "Sections \u2014 pick one"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "workspace__nav-help",
                        children: "Only one section shows at a time. Use the links below; the current page is highlighted in green."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("nav", {
                        className: "tab-nav",
                        "aria-label": "Dossier sections",
                        children: sidebarTabs.map((tab)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                                to: `${base}/${tab.path}`,
                                state: location.state,
                                className: $c32045b0952ded9f$var$tabClass,
                                end: tab.path === "overview",
                                title: tab.userHint,
                                children: [
                                    $c32045b0952ded9f$var$TAB_ICONS[tab.path],
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "tab-nav__label",
                                        children: tab.label
                                    })
                                ]
                            }, tab.path))
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "workspace__current-tip",
                        role: "status",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "workspace__current-tip-label",
                                children: "Tip for this screen"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                children: activeTab.userHint
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "workspace__sidebar-foot",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                            children: "Telangana State \u2014 Chief Minister's Office (CMO). Official use only. Data shown is mock until backend integration."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "workspace__main",
                children: [
                    dossierReadOnly ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "workspace__readonly-banner",
                        role: "status",
                        children: "View only \u2014 this account cannot save changes to applicant dossiers. Ask an administrator if you need edit access."
                    }) : null,
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                        breadcrumb: [
                            {
                                label: "Home",
                                to: "/"
                            },
                            {
                                label: backLabel,
                                to: backTo
                            },
                            {
                                label: app.mobile.applicationId,
                                to: `${base}/overview`
                            },
                            {
                                label: activeTab.label
                            }
                        ],
                        title: activeTab.label,
                        subtitle: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                    className: "mono text-muted page-header__id-line",
                                    children: [
                                        app.mobile.applicationId,
                                        " \xb7 Sanction ",
                                        app.mobile.houseSanctionNumber
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "page-header__tab-desc",
                                    children: activeTab.desc
                                })
                            ]
                        }),
                        badge: (0, $dcd2d56cbb41ba43$export$40d4c787f5d14e8d)(app)
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$910ae8079b2c2852), {})
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");



var $7UyaH = parcelRequire("7UyaH");


var $7UyaH = parcelRequire("7UyaH");

function $d5572ca9b91316d6$export$6037a18d4e29dfa9({ id: id, value: value, onChange: onChange, options: options, disabled: disabled = false, placeholder: placeholder = "Select\u2026", className: className = "", variant: variant = "form" }) {
    const listId = (0, $7UyaH.useId)();
    const triggerRef = (0, $7UyaH.useRef)(null);
    const panelRef = (0, $7UyaH.useRef)(null);
    const searchRef = (0, $7UyaH.useRef)(null);
    const [open, setOpen] = (0, $7UyaH.useState)(false);
    const [filter, setFilter] = (0, $7UyaH.useState)("");
    const [activeIndex, setActiveIndex] = (0, $7UyaH.useState)(0);
    const [panelBox, setPanelBox] = (0, $7UyaH.useState)(null);
    const selectedLabel = (0, $7UyaH.useMemo)(()=>{
        const hit = options.find((o)=>o.value === value);
        if (hit) return hit.label;
        if (value === "" && placeholder) return placeholder;
        return value || placeholder;
    }, [
        options,
        value,
        placeholder
    ]);
    const filtered = (0, $7UyaH.useMemo)(()=>{
        const q = filter.trim().toLowerCase();
        if (!q) return options;
        return options.filter((o)=>o.label.toLowerCase().includes(q));
    }, [
        options,
        filter
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!open) return;
        setActiveIndex(filtered.length > 0 ? 0 : -1);
    }, [
        filter,
        open,
        filtered.length
    ]);
    const updatePanelPosition = (0, $7UyaH.useCallback)(()=>{
        const el = triggerRef.current;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const gap = 4;
        const margin = 8;
        const searchApprox = 42;
        let width = rect.width;
        let left = rect.left;
        if (left + width > window.innerWidth - margin) left = Math.max(margin, window.innerWidth - width - margin);
        const spaceBelow = window.innerHeight - rect.bottom - gap - searchApprox - margin;
        const listMaxHeight = Math.max(100, Math.min(240, spaceBelow, window.innerHeight * 0.38));
        setPanelBox({
            top: rect.bottom + gap,
            left: left,
            width: width,
            listMaxHeight: listMaxHeight
        });
    }, []);
    (0, $7UyaH.useLayoutEffect)(()=>{
        if (!open) {
            setPanelBox(null);
            return;
        }
        updatePanelPosition();
    }, [
        open,
        updatePanelPosition
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!open) return;
        const ro = new ResizeObserver(()=>updatePanelPosition());
        if (triggerRef.current) ro.observe(triggerRef.current);
        window.addEventListener("scroll", updatePanelPosition, true);
        window.addEventListener("resize", updatePanelPosition);
        return ()=>{
            ro.disconnect();
            window.removeEventListener("scroll", updatePanelPosition, true);
            window.removeEventListener("resize", updatePanelPosition);
        };
    }, [
        open,
        updatePanelPosition
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (open && panelBox && searchRef.current) {
            searchRef.current.focus();
            searchRef.current.select();
        }
    }, [
        open,
        panelBox
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!open) return;
        function onDoc(e) {
            const t = e.target;
            if (triggerRef.current?.contains(t)) return;
            if (panelRef.current?.contains(t)) return;
            setOpen(false);
            setFilter("");
        }
        document.addEventListener("mousedown", onDoc);
        return ()=>document.removeEventListener("mousedown", onDoc);
    }, [
        open
    ]);
    const close = (0, $7UyaH.useCallback)(()=>{
        setOpen(false);
        setFilter("");
    }, []);
    const pick = (0, $7UyaH.useCallback)((v)=>{
        onChange(v);
        close();
    }, [
        onChange,
        close
    ]);
    function onTriggerKeyDown(e) {
        if (disabled) return;
        if (e.key === "ArrowDown" || e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setOpen(true);
        }
    }
    function onSearchKeyDown(e) {
        if (e.key === "Escape") {
            e.preventDefault();
            close();
            return;
        }
        if (e.key === "ArrowDown") {
            e.preventDefault();
            setActiveIndex((i)=>Math.min(i + 1, Math.max(filtered.length - 1, 0)));
            return;
        }
        if (e.key === "ArrowUp") {
            e.preventDefault();
            setActiveIndex((i)=>Math.max(i - 1, 0));
            return;
        }
        if (e.key === "Enter") {
            e.preventDefault();
            if (activeIndex >= 0 && filtered[activeIndex]) pick(filtered[activeIndex].value);
        }
    }
    const variantClass = variant === "dash" ? " searchable-select--dash" : "";
    const panel = open && panelBox ? /*#__PURE__*/ (0, $32e03ff3f068d28e$exports.createPortal)(/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        ref: panelRef,
        className: `searchable-select__panel searchable-select__panel--portal${variantClass}`,
        role: "presentation",
        style: {
            position: "fixed",
            top: panelBox.top,
            left: panelBox.left,
            width: panelBox.width,
            zIndex: 10050
        },
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                ref: searchRef,
                type: "search",
                className: "searchable-select__search",
                placeholder: "Type to filter\u2026",
                value: filter,
                onChange: (e)=>setFilter(e.target.value),
                onKeyDown: onSearchKeyDown,
                "aria-autocomplete": "list",
                "aria-controls": listId,
                autoComplete: "off"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                id: listId,
                className: "searchable-select__list",
                role: "listbox",
                style: {
                    maxHeight: panelBox.listMaxHeight
                },
                children: filtered.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                    className: "searchable-select__empty",
                    role: "presentation",
                    children: "No matches"
                }) : filtered.map((o, idx)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                        role: "presentation",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            role: "option",
                            "aria-selected": o.value === value,
                            className: "searchable-select__option" + (idx === activeIndex ? " searchable-select__option--active" : ""),
                            onMouseEnter: ()=>setActiveIndex(idx),
                            onClick: ()=>pick(o.value),
                            children: o.label
                        })
                    }, o.rowKey ?? (o.value === "" ? "__empty__" : o.value || `opt-${idx}`)))
            })
        ]
    }), document.body) : null;
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: `searchable-select${variantClass} ${className}`.trim(),
        "data-open": open ? "true" : undefined,
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("button", {
                ref: triggerRef,
                id: id,
                type: "button",
                className: "searchable-select__trigger",
                disabled: disabled,
                "aria-haspopup": "listbox",
                "aria-expanded": open,
                "aria-controls": listId,
                onClick: ()=>!disabled && setOpen((o)=>!o),
                onKeyDown: onTriggerKeyDown,
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "searchable-select__trigger-text",
                        children: selectedLabel
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "searchable-select__chevron",
                        "aria-hidden": true,
                        children: "\u25BE"
                    })
                ]
            }),
            panel
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");


async function $ede95d5ea387352a$export$bc937d06acaf044f() {
    const base = (0, $3007f8decf026d71$export$4d28219d42798a75)();
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${base}/api/geo/directory`);
    if (res.ok) return res.json();
    let detail = `status ${res.status}`;
    try {
        const text = await res.text();
        const j = JSON.parse(text);
        if (j.error) detail = j.error;
        if (j.hint) detail += `. ${j.hint}`;
    } catch  {
    /* ignore */ }
    throw new Error(`Geo directory API unavailable (${detail}). Ensure geo_directory tables are seeded in the database.`);
}



/** Normalise labels for matching portal names to applicant mandal / village strings. */ function $aa684f3df92b98e8$export$61bc427a5262ca9c(s) {
    return s.trim().toLowerCase().replace(/\s+/g, " ");
}


function $77f9294c77fbab2e$export$2bf115fe882c633(data) {
    const raw = data;
    function tgRegistrationDistricts() {
        return raw.districts.filter((d)=>!d.error && Array.isArray(d.mandals));
    }
    /**
   * API/DB `districtKey` can differ in case or (rarely) from the canonical slug; registration name
   * may still match the map label. Prefer rows that actually have mandal data.
   */ function pickDistrictRow(rows) {
        if (rows.length === 0) return undefined;
        if (rows.length === 1) return rows[0];
        return [
            ...rows
        ].sort((a, b)=>b.mandals.length - a.mandals.length)[0];
    }
    function resolveDirectoryDistrict(k) {
        const list = tgRegistrationDistricts();
        const key = String(k).trim();
        if (!key) return undefined;
        const exactMatches = list.filter((x)=>String(x.districtKey ?? "").trim() === key);
        const exact = pickDistrictRow(exactMatches);
        if (exact) return exact;
        const ciMatches = list.filter((x)=>String(x.districtKey ?? "").trim().toLowerCase() === key.toLowerCase());
        const ci = pickDistrictRow(ciMatches);
        if (ci) return ci;
        const wantName = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(key);
        const nameHits = list.filter((x)=>(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(x.registrationDistrictName) === wantName);
        if (nameHits.length === 1) return nameHits[0];
        if (nameHits.length > 1) return [
            ...nameHits
        ].sort((a, b)=>b.mandals.length - a.mandals.length)[0];
        const slug = (0, $72c1e8625e9e63b5$export$768d2fc1615cd5ac)(key);
        const label = slug ? (0, $72c1e8625e9e63b5$export$c213a939d88ef2f8).find((d)=>d.key === slug)?.label : undefined;
        if (label) {
            const want = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(label);
            const labelHits = list.filter((x)=>(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(x.registrationDistrictName) === want);
            if (labelHits.length === 1) return labelHits[0];
            if (labelHits.length > 1) return [
                ...labelHits
            ].sort((a, b)=>b.mandals.length - a.mandals.length)[0];
        }
        return undefined;
    }
    function tgMandalsForDistrict(key) {
        const d = resolveDirectoryDistrict(key);
        if (!d?.mandals || d.error) return [];
        return d.mandals;
    }
    function tgVillagesForMandal(districtKey, mandalName) {
        const nm = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(mandalName);
        const m = tgMandalsForDistrict(districtKey).find((x)=>(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(x.mandalName) === nm);
        return m?.villages ?? [];
    }
    function tgDirectoryAggregateCounts() {
        const districts = tgRegistrationDistricts();
        let mandals = 0;
        let villages = 0;
        for (const d of districts){
            mandals += d.mandals.length;
            for (const m of d.mandals)villages += m.villages.length;
        }
        return {
            districts: districts.length,
            mandals: mandals,
            villages: villages
        };
    }
    function tgDirectoryCountsForDistrict(districtKey) {
        const mandals = tgMandalsForDistrict(districtKey);
        let villages = 0;
        for (const m of mandals)villages += m.villages.length;
        return {
            mandals: mandals.length,
            villages: villages
        };
    }
    function tgVillageCountForMandal(districtKey, mandalName) {
        return tgVillagesForMandal(districtKey, mandalName).length;
    }
    function tgResolveVillageDbIdInDistrict(districtKey, mandalName, villageName) {
        const vn = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(villageName);
        const fromMandal = tgVillagesForMandal(districtKey, mandalName);
        const hit = fromMandal.find((x)=>(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(x.name) === vn);
        if (hit) return hit.id;
        for (const m of tgMandalsForDistrict(districtKey)){
            const h = m.villages.find((x)=>(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(x.name) === vn);
            if (h) return h.id;
        }
        return undefined;
    }
    return {
        raw: raw,
        tgRegistrationDistricts: tgRegistrationDistricts,
        tgMandalsForDistrict: tgMandalsForDistrict,
        tgVillagesForMandal: tgVillagesForMandal,
        tgResolveVillageDbIdInDistrict: tgResolveVillageDbIdInDistrict,
        tgDirectoryAggregateCounts: tgDirectoryAggregateCounts,
        tgDirectoryCountsForDistrict: tgDirectoryCountsForDistrict,
        tgVillageCountForMandal: tgVillageCountForMandal,
        findDistrict: resolveDirectoryDistrict
    };
}
function $77f9294c77fbab2e$export$bf463aeed8846c53(store, directoryKey, storedDistrict) {
    const stored = String(storedDistrict ?? "").trim();
    if (!stored) return false;
    const row = store.findDistrict(directoryKey);
    if (row) {
        if ((0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(row.districtKey) === (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(stored)) return true;
        if ((0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(row.registrationDistrictName) === (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(stored)) return true;
    }
    const fromStored = (0, $72c1e8625e9e63b5$export$768d2fc1615cd5ac)(stored);
    const fromFilter = (0, $72c1e8625e9e63b5$export$768d2fc1615cd5ac)(directoryKey);
    if (fromStored && fromFilter && fromStored === fromFilter) return true;
    return (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(directoryKey) === (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(stored);
}
const $77f9294c77fbab2e$export$e71a6953fdf130a5 = (payload)=>payload.source;
const $77f9294c77fbab2e$export$fd545f1832aa4adc = (payload)=>payload.generatedAt;




const $60dd8507bac67e50$var$GeoDirectoryContext = /*#__PURE__*/ (0, $7UyaH.createContext)(null);
function $60dd8507bac67e50$export$5bd7d0871a0924fa({ children: children }) {
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const { can: can, loading: authLoading } = (0, $a4dc0d923ddf5b19$export$1d39dc5b47e56ff0)();
    const [store, setStore] = (0, $7UyaH.useState)(null);
    const [loading, setLoading] = (0, $7UyaH.useState)(true);
    const [error, setError] = (0, $7UyaH.useState)(null);
    const canGeo = can("geo_directory") || can("geo_directory_admin");
    /** Leads import matches mandals/villages; users may have leads rights without geo_directory — `fetchGeoDirectory` falls back to bundled JSON when the API is forbidden or unavailable. */ const needsDirectoryForLeads = can("leads") || can("leads_import");
    const load = (0, $7UyaH.useCallback)(async ()=>{
        setError(null);
        if (authLoading) return;
        setLoading(true);
        if (!canGeo && !needsDirectoryForLeads) {
            setStore(null);
            setLoading(false);
            return;
        }
        try {
            const data = await (0, $ede95d5ea387352a$export$bc937d06acaf044f)();
            setStore((0, $77f9294c77fbab2e$export$2bf115fe882c633)(data));
        } catch (e) {
            setStore(null);
            const msg = e instanceof Error ? e.message : String(e);
            setError(msg);
            showToast(msg, "error");
        } finally{
            setLoading(false);
        }
    }, [
        showToast,
        authLoading,
        canGeo,
        needsDirectoryForLeads
    ]);
    (0, $7UyaH.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const value = (0, $7UyaH.useMemo)(()=>({
            store: store,
            loading: loading,
            error: error,
            refetch: load
        }), [
        store,
        loading,
        error,
        load
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($60dd8507bac67e50$var$GeoDirectoryContext.Provider, {
        value: value,
        children: children
    });
}
function $60dd8507bac67e50$export$5ec0231075ddedf1() {
    const ctx = (0, $7UyaH.useContext)($60dd8507bac67e50$var$GeoDirectoryContext);
    if (!ctx) throw new Error("useGeoDirectory must be used within GeoDirectoryProvider");
    return ctx;
}


function $458840b99c021cb6$export$bb1029bec19025fd(value) {
    const raw = String(value ?? "").trim();
    if (!raw) return "";
    return raw.toLowerCase().split(/(\s+|\/|-|_|\.)/g).map((part)=>{
        if (!part || /^\s+$/.test(part) || /^[\/\-_.]$/.test(part)) return part;
        return part.charAt(0).toUpperCase() + part.slice(1);
    }).join("");
}





function $65d82a3223f822b8$export$ebb9edc449c9191c(store) {
    if (!store) return [];
    return [
        ...store.tgRegistrationDistricts()
    ].sort((a, b)=>a.registrationDistrictName.localeCompare(b.registrationDistrictName, undefined, {
            sensitivity: "base"
        })).map((d)=>({
            value: d.districtKey,
            label: (0, $458840b99c021cb6$export$bb1029bec19025fd)(d.registrationDistrictName),
            rowKey: d.registrationDistrictCode
        }));
}
function $65d82a3223f822b8$export$92a1b4b7233300e5(store, districtKey) {
    if (!store || !districtKey) return [];
    return [
        ...store.tgMandalsForDistrict(districtKey)
    ].sort((a, b)=>a.mandalName.localeCompare(b.mandalName, undefined, {
            sensitivity: "base"
        })).map((m)=>({
            value: m.mandalName,
            label: (0, $458840b99c021cb6$export$bb1029bec19025fd)(m.mandalName),
            rowKey: m.mandalCode
        }));
}
function $65d82a3223f822b8$export$b4f94b88b15ef2d1(store, districtKey, mandalName, embedVillageDbIdInValue = false) {
    if (!store || !districtKey || !mandalName) return [];
    return [
        ...store.tgVillagesForMandal(districtKey, mandalName)
    ].sort((a, b)=>a.name.localeCompare(b.name, undefined, {
            sensitivity: "base"
        })).map((v)=>{
        const useId = embedVillageDbIdInValue && typeof v.id === "number" && v.id > 0;
        const value = useId ? `${v.id}\t${v.name}` : v.name;
        return {
            value: value,
            label: (0, $458840b99c021cb6$export$bb1029bec19025fd)(v.name),
            rowKey: `v-${v.id ?? v.code}`
        };
    });
}
function $65d82a3223f822b8$export$16b9f92e753bd4d0(geo, stored, filter) {
    const { district: district, mandal: mandal, village: village } = filter;
    if (district) {
        if (geo) {
            if (!(0, $77f9294c77fbab2e$export$bf463aeed8846c53)(geo, district, stored.district)) return false;
        } else if ((0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(stored.district ?? "") !== (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(district)) return false;
    }
    if (mandal && (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(stored.mandal ?? "") !== (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(mandal)) return false;
    if (village && (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(stored.village ?? "") !== (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(village)) return false;
    return true;
}
function $65d82a3223f822b8$export$1592aa82ad273940(geo, district) {
    const raw = String(district ?? "").trim();
    if (!raw) return "\u2014";
    const row = geo?.findDistrict(raw);
    if (row) return (0, $458840b99c021cb6$export$bb1029bec19025fd)(row.registrationDistrictName);
    return (0, $458840b99c021cb6$export$bb1029bec19025fd)(raw);
}


function $0377fbce5921ee00$export$b3eb1a6c17723c14({ district: district, mandal: mandal, village: village, onDistrictChange: onDistrictChange, onMandalChange: onMandalChange, onVillageChange: onVillageChange, idPrefix: idPrefix, embedVillageDbIdInValue: embedVillageDbIdInValue = false, purpose: purpose = "filter" }) {
    const { store: store, loading: geoLoading } = (0, $60dd8507bac67e50$export$5ec0231075ddedf1)();
    const geoReady = Boolean(store) && !geoLoading;
    const districtOptions = (0, $7UyaH.useMemo)(()=>{
        const fromDir = (0, $65d82a3223f822b8$export$ebb9edc449c9191c)(store);
        const inDir = fromDir.some((o)=>o.value === district);
        const prefix = purpose === "applicant" && district && !inDir ? [
            {
                value: district,
                label: (0, $458840b99c021cb6$export$bb1029bec19025fd)(district),
                rowKey: "current-district"
            }
        ] : [];
        if (purpose === "applicant") return [
            ...prefix,
            ...fromDir
        ];
        return [
            {
                value: "",
                label: "All districts",
                rowKey: "all-districts"
            },
            ...fromDir
        ];
    }, [
        store,
        purpose,
        district
    ]);
    const mandalOptions = (0, $7UyaH.useMemo)(()=>{
        const fromDir = (0, $65d82a3223f822b8$export$92a1b4b7233300e5)(store, district);
        const inDir = fromDir.some((o)=>o.value === mandal);
        const prefix = purpose === "applicant" && mandal && !inDir ? [
            {
                value: mandal,
                label: (0, $458840b99c021cb6$export$bb1029bec19025fd)(mandal),
                rowKey: "current-mandal"
            }
        ] : [];
        if (purpose === "applicant") return [
            ...prefix,
            ...fromDir
        ];
        return [
            {
                value: "",
                label: "All mandals",
                rowKey: "all-mandals"
            },
            ...fromDir
        ];
    }, [
        store,
        district,
        mandal,
        purpose
    ]);
    const villageOptions = (0, $7UyaH.useMemo)(()=>{
        const fromDir = (0, $65d82a3223f822b8$export$b4f94b88b15ef2d1)(store, district, mandal, embedVillageDbIdInValue);
        const inDir = fromDir.some((o)=>o.value === village);
        const prefix = purpose === "applicant" && village && !inDir ? [
            {
                value: village,
                label: (0, $458840b99c021cb6$export$bb1029bec19025fd)(village),
                rowKey: "current-village"
            }
        ] : [];
        if (purpose === "applicant") return [
            ...prefix,
            ...fromDir
        ];
        return [
            {
                value: "",
                label: "All villages",
                rowKey: "all-villages"
            },
            ...fromDir
        ];
    }, [
        store,
        district,
        mandal,
        village,
        embedVillageDbIdInValue,
        purpose
    ]);
    const districtPlaceholder = !geoReady ? "Loading\u2026" : purpose === "applicant" ? "Select district" : "All districts";
    const mandalPlaceholder = !geoReady ? "Loading\u2026" : purpose === "applicant" ? "Select mandal" : "All mandals";
    const villagePlaceholder = !geoReady ? "Loading\u2026" : purpose === "applicant" ? "Select village" : "All villages";
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field table-filters__field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: `${idPrefix}-district`,
                        children: "District"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                        id: `${idPrefix}-district`,
                        value: district,
                        onChange: (v)=>{
                            if (v === "" && purpose === "filter") {
                                onDistrictChange("");
                                return;
                            }
                            if (v !== "") onDistrictChange(v);
                        },
                        options: districtOptions,
                        disabled: !geoReady,
                        placeholder: districtPlaceholder
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field table-filters__field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: `${idPrefix}-mandal`,
                        children: "Mandal"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                        id: `${idPrefix}-mandal`,
                        value: mandal,
                        onChange: onMandalChange,
                        options: mandalOptions,
                        disabled: !district || !geoReady,
                        placeholder: mandalPlaceholder
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field table-filters__field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: `${idPrefix}-village`,
                        children: "Village"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                        id: `${idPrefix}-village`,
                        value: village,
                        onChange: onVillageChange,
                        options: villageOptions,
                        disabled: !district || !mandal || !geoReady,
                        placeholder: villagePlaceholder
                    })
                ]
            })
        ]
    });
}





function $4155f5d8f4fed208$var$cloneMobile(m) {
    return {
        ...m,
        documentsFromMobile: [
            ...m.documentsFromMobile
        ],
        photosFromMobile: m.photosFromMobile.map((p)=>({
                ...p
            }))
    };
}
function $4155f5d8f4fed208$var$isHttpUrlForImage(u) {
    try {
        const x = new URL(u);
        return x.protocol === "http:" || x.protocol === "https:";
    } catch  {
        return false;
    }
}
function $4155f5d8f4fed208$var$sanitizePhotosForSave(photos) {
    return photos.map((p)=>({
            label: String(p.label ?? "").trim() || String(p.url ?? "").trim() || "Photo",
            url: String(p.url ?? "").trim()
        })).filter((p)=>p.url);
}
function $4155f5d8f4fed208$export$ea21143fc08cf080() {
    const { id: id } = (0, $265aeae2597a9f58$export$99eaa27ddbbb95ef)();
    const { getById: getById, updateApplication: updateApplication } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const { store: geoStore } = (0, $60dd8507bac67e50$export$5ec0231075ddedf1)();
    const app = id ? getById(id) : undefined;
    const [mobileDraft, setMobileDraft] = (0, $7UyaH.useState)(null);
    const [districtDraft, setDistrictDraft] = (0, $7UyaH.useState)("");
    const [mandalDraft, setMandalDraft] = (0, $7UyaH.useState)("");
    const [villageDraft, setVillageDraft] = (0, $7UyaH.useState)("");
    (0, $7UyaH.useEffect)(()=>{
        if (!app) return;
        setMobileDraft($4155f5d8f4fed208$var$cloneMobile(app.mobile));
        const districtKey = geoStore?.findDistrict(app.district)?.districtKey ?? app.district;
        setDistrictDraft(districtKey);
        setMandalDraft(app.mandal);
        setVillageDraft(app.village);
    }, [
        app?.id,
        app?.district,
        app?.mandal,
        app?.village,
        geoStore
    ]);
    const dirty = (0, $7UyaH.useMemo)(()=>{
        if (!app || !mobileDraft) return false;
        const m = mobileDraft;
        const o = app.mobile;
        const mobileChanged = m.beneficiaryName !== o.beneficiaryName || m.fatherOrHusbandName !== o.fatherOrHusbandName || m.aadhaarNumber !== o.aadhaarNumber || m.applicationId !== o.applicationId || m.houseSanctionNumber !== o.houseSanctionNumber || m.bankName !== o.bankName || m.bankAccountNumber !== o.bankAccountNumber || m.ifscCode !== o.ifscCode;
        const geoChanged = districtDraft !== app.district || mandalDraft !== app.mandal || villageDraft !== app.village;
        return mobileChanged || geoChanged;
    }, [
        app,
        mobileDraft,
        districtDraft,
        mandalDraft,
        villageDraft
    ]);
    const discard = (0, $7UyaH.useCallback)(()=>{
        if (!app) return;
        setMobileDraft($4155f5d8f4fed208$var$cloneMobile(app.mobile));
        setDistrictDraft(geoStore?.findDistrict(app.district)?.districtKey ?? app.district);
        setMandalDraft(app.mandal);
        setVillageDraft(app.village);
    }, [
        app,
        geoStore
    ]);
    const save = (0, $7UyaH.useCallback)(()=>{
        if (!app || !mobileDraft) return;
        const districtRow = geoStore?.findDistrict(districtDraft);
        if (!districtRow) {
            showToast("Choose a valid district from the geo directory.", "error");
            return;
        }
        const cleanedPhotos = $4155f5d8f4fed208$var$sanitizePhotosForSave(mobileDraft.photosFromMobile);
        (async ()=>{
            try {
                await updateApplication(app.id, {
                    district: districtRow.districtKey,
                    mandal: mandalDraft.trim(),
                    village: villageDraft.trim(),
                    mobile: {
                        ...mobileDraft,
                        documentsFromMobile: app.mobile.documentsFromMobile,
                        photosFromMobile: cleanedPhotos
                    }
                });
                setMobileDraft((prev)=>prev ? {
                        ...prev,
                        photosFromMobile: cleanedPhotos.map((p)=>({
                                ...p
                            }))
                    } : prev);
            } catch  {
            /* updateApplication shows error toast */ }
        })();
    }, [
        app,
        mobileDraft,
        districtDraft,
        mandalDraft,
        villageDraft,
        updateApplication,
        showToast,
        geoStore
    ]);
    if (!app || !mobileDraft) return null;
    const setField = (key, value)=>{
        setMobileDraft((prev)=>prev ? {
                ...prev,
                [key]: value
            } : prev);
    };
    const previewPhotos = mobileDraft.photosFromMobile.filter((p)=>p.url.trim());
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "tab-intro",
                children: "Edit beneficiary particulars, bank details, and registration location. Changes save to the console database with the rest of the dossier (debounced sync). The mobile document checklist stays read-only. Photos from the mobile app appear at the bottom of this tab when sync has stored them."
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        children: "Registration location"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "section-lead section-lead--tight text-muted",
                        children: "District / mandal / village drive maps, zones, and reports. Pick names from the geo directory when possible."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "table-filters table-filters--geo-row",
                        "aria-label": "Applicant location",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $0377fbce5921ee00$export$b3eb1a6c17723c14), {
                            idPrefix: "ben-tab-geo",
                            purpose: "applicant",
                            district: districtDraft,
                            mandal: mandalDraft,
                            village: villageDraft,
                            onDistrictChange: (d)=>{
                                setDistrictDraft(d);
                                setMandalDraft("");
                                setVillageDraft("");
                            },
                            onMandalChange: (m)=>{
                                setMandalDraft(m);
                                setVillageDraft("");
                            },
                            onVillageChange: setVillageDraft
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        children: "Beneficiary particulars"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field-grid",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        children: "Beneficiary name"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control",
                                        value: mobileDraft.beneficiaryName,
                                        onChange: (e)=>setField("beneficiaryName", e.target.value),
                                        autoComplete: "off"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        children: "Father\u2019s / husband\u2019s name"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control",
                                        value: mobileDraft.fatherOrHusbandName,
                                        onChange: (e)=>setField("fatherOrHusbandName", e.target.value),
                                        autoComplete: "off"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        children: "Aadhaar number"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control mono",
                                        value: mobileDraft.aadhaarNumber,
                                        onChange: (e)=>setField("aadhaarNumber", e.target.value),
                                        autoComplete: "off"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        children: "Application ID (mobile)"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control mono",
                                        value: mobileDraft.applicationId,
                                        onChange: (e)=>setField("applicationId", e.target.value),
                                        autoComplete: "off"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        children: "House sanction number"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control mono",
                                        value: mobileDraft.houseSanctionNumber,
                                        onChange: (e)=>setField("houseSanctionNumber", e.target.value),
                                        autoComplete: "off"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        children: "Bank details (as submitted)"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field-grid",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        children: "Bank name"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control",
                                        value: mobileDraft.bankName,
                                        onChange: (e)=>setField("bankName", e.target.value),
                                        autoComplete: "off"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        children: "Bank account number"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control mono",
                                        value: mobileDraft.bankAccountNumber,
                                        onChange: (e)=>setField("bankAccountNumber", e.target.value),
                                        autoComplete: "off"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        children: "IFSC"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control mono",
                                        value: mobileDraft.ifscCode,
                                        onChange: (e)=>setField("ifscCode", e.target.value),
                                        autoComplete: "off"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "beneficiary-tab-actions",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--secondary btn--tg",
                        disabled: !dirty,
                        onClick: discard,
                        children: "Discard changes"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--primary btn--tg",
                        disabled: !dirty,
                        onClick: save,
                        children: "Save applicant details"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        children: "Photos from mobile"
                    }),
                    previewPhotos.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted section-lead section-lead--tight",
                        children: "No photos from mobile yet."
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "mobile-photo-grid",
                        role: "list",
                        children: previewPhotos.map((p, i)=>{
                            const showImg = $4155f5d8f4fed208$var$isHttpUrlForImage(p.url);
                            return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "mobile-photo-grid__item",
                                role: "listitem",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "mobile-photo-grid__label",
                                        children: p.label
                                    }),
                                    showImg ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("a", {
                                        href: p.url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "mobile-photo-grid__link",
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                                            src: p.url,
                                            alt: "",
                                            className: "mobile-photo-grid__img",
                                            loading: "lazy"
                                        })
                                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "text-muted mobile-photo-grid__no-preview",
                                        children: "Image preview is not available for this item."
                                    })
                                ]
                            }, `${p.url}-${i}`);
                        })
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");




var $7UyaH = parcelRequire("7UyaH");


function $db01b5682ff23c7d$var$extractFileName(contentDisposition) {
    if (!contentDisposition) return null;
    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match?.[1]) try {
        return decodeURIComponent(utf8Match[1].trim());
    } catch  {
        return utf8Match[1].trim();
    }
    const plainMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
    if (plainMatch?.[1]) return plainMatch[1].trim();
    return null;
}
async function $db01b5682ff23c7d$export$8df1e9a3cadf38a9(url) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(url, {
        cache: "no-store"
    });
    if (!res.ok) {
        let detail = `HTTP ${res.status}`;
        try {
            const body = await res.json();
            if (body?.error) detail = String(body.error);
        } catch  {
        /* no-op */ }
        throw new Error(`Could not fetch document: ${detail}`);
    }
    return {
        blob: await res.blob(),
        fileName: $db01b5682ff23c7d$var$extractFileName(res.headers.get("content-disposition"))
    };
}
async function $db01b5682ff23c7d$export$1b9c2b61375fba3f(url) {
    const popup = window.open("about:blank", "_blank", "noopener,noreferrer");
    try {
        const { blob: blob } = await $db01b5682ff23c7d$export$8df1e9a3cadf38a9(url);
        const objectUrl = URL.createObjectURL(blob);
        if (popup && !popup.closed) popup.location.href = objectUrl;
        else window.open(objectUrl, "_blank", "noopener,noreferrer");
        window.setTimeout(()=>URL.revokeObjectURL(objectUrl), 60000);
    } catch (error) {
        if (popup && !popup.closed) popup.close();
        throw error;
    }
}
async function $db01b5682ff23c7d$export$c84e8f333e417f22(url, fallbackFileName = "document") {
    const { blob: blob, fileName: fileName } = await $db01b5682ff23c7d$export$8df1e9a3cadf38a9(url);
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = fileName || fallbackFileName;
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.setTimeout(()=>URL.revokeObjectURL(objectUrl), 0);
}


const $d3365114b8e87556$var$LINK_BUTTON_STYLE = {
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    font: "inherit"
};
function $d3365114b8e87556$var$withDisposition(fileUrlBase, disposition) {
    const separator = fileUrlBase.includes("?") ? "&" : "?";
    return `${fileUrlBase}${separator}disposition=${disposition}`;
}
function $d3365114b8e87556$var$getErrorMessage(error) {
    return error instanceof Error ? error.message : "Could not open document.";
}
function $d3365114b8e87556$export$91ad24bb00ba0809({ fileUrlBase: fileUrlBase, fallbackFileName: fallbackFileName }) {
    const titleId = (0, $7UyaH.useId)();
    const [downloading, setDownloading] = (0, $7UyaH.useState)(false);
    const [loadingPreview, setLoadingPreview] = (0, $7UyaH.useState)(false);
    const [previewOpen, setPreviewOpen] = (0, $7UyaH.useState)(false);
    const [previewMimeType, setPreviewMimeType] = (0, $7UyaH.useState)("");
    const [previewFileName, setPreviewFileName] = (0, $7UyaH.useState)(fallbackFileName ?? "document");
    /** Bumped when a new blob URL is ready so the viewer mounts once per open (avoids iframe reload flicker). */ const [previewGeneration, setPreviewGeneration] = (0, $7UyaH.useState)(0);
    const previewUrlRef = (0, $7UyaH.useRef)(null);
    const previewUrl = previewUrlRef.current;
    const revokePreviewUrl = (0, $7UyaH.useCallback)(()=>{
        if (previewUrlRef.current) {
            URL.revokeObjectURL(previewUrlRef.current);
            previewUrlRef.current = null;
        }
    }, []);
    const closePreview = (0, $7UyaH.useCallback)(()=>{
        setPreviewOpen(false);
        revokePreviewUrl();
        setPreviewGeneration((g)=>g + 1);
    }, [
        revokePreviewUrl
    ]);
    (0, $7UyaH.useEffect)(()=>{
        return ()=>revokePreviewUrl();
    }, [
        revokePreviewUrl
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!previewOpen) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        const onKeyDown = (event)=>{
            if (event.key === "Escape") closePreview();
        };
        window.addEventListener("keydown", onKeyDown);
        return ()=>{
            document.body.style.overflow = prev;
            window.removeEventListener("keydown", onKeyDown);
        };
    }, [
        previewOpen,
        closePreview
    ]);
    const isImagePreview = previewMimeType.startsWith("image/");
    const isPdfPreview = previewMimeType === "application/pdf" || previewMimeType.endsWith("+pdf") || previewFileName.toLowerCase().endsWith(".pdf");
    const openPreview = (0, $7UyaH.useCallback)(()=>{
        setLoadingPreview(true);
        (0, $db01b5682ff23c7d$export$8df1e9a3cadf38a9)($d3365114b8e87556$var$withDisposition(fileUrlBase, "inline")).then(({ blob: blob, fileName: fileName })=>{
            revokePreviewUrl();
            const typedBlob = blob.type && blob.type !== "application/octet-stream" ? blob : new Blob([
                blob
            ], {
                type: fileName?.toLowerCase().endsWith(".pdf") ? "application/pdf" : fileName?.match(/\.(jpe?g|png|gif|webp)$/i) ? `image/${fileName.split(".").pop().toLowerCase().replace("jpg", "jpeg")}` : blob.type || "application/octet-stream"
            });
            previewUrlRef.current = URL.createObjectURL(typedBlob);
            setPreviewMimeType(typedBlob.type || "");
            setPreviewFileName(fileName || fallbackFileName || "document");
            setPreviewGeneration((g)=>g + 1);
            setPreviewOpen(true);
        }).catch((error)=>{
            window.alert($d3365114b8e87556$var$getErrorMessage(error));
        }).finally(()=>setLoadingPreview(false));
    }, [
        fileUrlBase,
        fallbackFileName,
        revokePreviewUrl
    ]);
    const previewModal = previewOpen && previewUrl ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
        className: "modal-backdrop modal-backdrop--doc-preview",
        role: "presentation",
        onClick: closePreview,
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
            className: "modal modal--doc-preview",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": titleId,
            onClick: (event)=>event.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "modal--doc-preview__header",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                            id: titleId,
                            className: "modal--doc-preview__title",
                            children: "Document preview"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            className: "btn btn--sm",
                            onClick: closePreview,
                            children: "Close"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                    className: "text-muted modal--doc-preview__filename",
                    children: previewFileName
                }),
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                    className: "modal--doc-preview__body",
                    children: isImagePreview ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                        src: previewUrl,
                        alt: previewFileName,
                        className: "modal--doc-preview__image"
                    }, `img-${previewGeneration}`) : isPdfPreview ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("object", {
                        className: "modal--doc-preview__pdf",
                        data: `${previewUrl}#toolbar=1&navpanes=0`,
                        type: "application/pdf",
                        "aria-label": previewFileName,
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("iframe", {
                            title: previewFileName,
                            className: "modal--doc-preview__pdf",
                            src: `${previewUrl}#toolbar=1`
                        })
                    }, `pdf-${previewGeneration}`) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "Preview is not available for this file type. Please use Download."
                    })
                })
            ]
        })
    }) : null;
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                type: "button",
                className: "summary-card__link",
                style: $d3365114b8e87556$var$LINK_BUTTON_STYLE,
                onClick: ()=>{
                    setDownloading(true);
                    (0, $db01b5682ff23c7d$export$c84e8f333e417f22)($d3365114b8e87556$var$withDisposition(fileUrlBase, "attachment"), fallbackFileName).catch((error)=>{
                        window.alert($d3365114b8e87556$var$getErrorMessage(error));
                    }).finally(()=>setDownloading(false));
                },
                disabled: downloading || loadingPreview,
                children: downloading ? "Downloading..." : "Download"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                className: "text-muted",
                children: " \xb7 "
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                type: "button",
                className: "summary-card__link",
                style: $d3365114b8e87556$var$LINK_BUTTON_STYLE,
                onClick: openPreview,
                disabled: downloading || loadingPreview,
                children: loadingPreview ? "Opening..." : "View"
            }),
            previewModal ? /*#__PURE__*/ (0, $32e03ff3f068d28e$exports.createPortal)(previewModal, document.body) : null
        ]
    });
}



function $061b372afdec2b67$export$2dd8a0472fc8dd3f({ open: open, title: title, body: body, confirmLabel: confirmLabel, onConfirm: onConfirm, onCancel: onCancel }) {
    if (!open) return null;
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
        className: "modal-backdrop",
        role: "presentation",
        onClick: onCancel,
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
            className: "modal",
            role: "dialog",
            "aria-modal": "true",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                    children: title
                }),
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                    children: body
                }),
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "modal__actions",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            className: "btn",
                            onClick: onCancel,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            className: "btn btn--primary",
                            onClick: onConfirm,
                            children: confirmLabel ?? "I confirm"
                        })
                    ]
                })
            ]
        })
    });
}




/** Read a file as raw base64 (no `data:` prefix) plus MIME from the file or data URL. */ function $b5ec052719425bb9$export$ff9a6fde0c58ad20(file) {
    return new Promise((resolve, reject)=>{
        const fr = new FileReader();
        fr.onload = ()=>{
            const t = String(fr.result ?? "");
            const m = /^data:([^;]*);base64,(.*)$/s.exec(t);
            if (m) resolve({
                base64: m[2].replace(/\s/g, ""),
                mimeType: (m[1] || file.type || "").trim() || null
            });
            else {
                const idx = t.indexOf("base64,");
                const rawB64 = idx >= 0 ? t.slice(idx + 7).replace(/\s/g, "") : t.replace(/\s/g, "");
                resolve({
                    base64: rawB64,
                    mimeType: file.type || null
                });
            }
        };
        fr.onerror = ()=>reject(fr.error ?? new Error("Could not read file"));
        fr.readAsDataURL(file);
    });
}


function $d555c9b5026a95a0$export$b640f40052a8a900(patch) {
    return Object.prototype.hasOwnProperty.call(patch, "iciciAccountNumber") || Object.prototype.hasOwnProperty.call(patch, "iciciIfsc") || Object.prototype.hasOwnProperty.call(patch, "iciciBranch") || Array.isArray(patch.mouFilesUpload) && patch.mouFilesUpload.length > 0 || Array.isArray(patch.mouRemovedAttachmentIds) && patch.mouRemovedAttachmentIds.length > 0;
}
function $d555c9b5026a95a0$export$3ef1b84986ce58a7(ho) {
    const iciciAccount = Boolean(ho.iciciAccountNumber.trim());
    const iciciIfsc = Boolean(ho.iciciIfsc.trim());
    const iciciBranch = Boolean(ho.iciciBranch.trim());
    const mouAttached = Boolean(ho.mouFileName) || Boolean(ho.mouFileStored) || Array.isArray(ho.mouAttachments) && ho.mouAttachments.length > 0 || Array.isArray(ho.mouFilesUpload) && ho.mouFilesUpload.length > 0;
    return {
        iciciAccount: iciciAccount,
        iciciIfsc: iciciIfsc,
        iciciBranch: iciciBranch,
        iciciComplete: iciciAccount && iciciIfsc && iciciBranch,
        mouAttached: mouAttached
    };
}
function $d555c9b5026a95a0$export$185348e84c44c173(app) {
    if (app.status !== "ready_for_icici" && app.status !== "ready_for_mou") return null;
    const c = $d555c9b5026a95a0$export$3ef1b84986ce58a7(app.ho);
    if (app.status === "ready_for_icici") {
        const missing = [];
        if (!c.iciciAccount) missing.push("ICICI account number");
        if (!c.iciciIfsc) missing.push("ICICI IFSC");
        if (!c.iciciBranch) missing.push("ICICI branch");
        if (!missing.length) return null;
        return `Still needed for this step: ${missing.join(", ")}. MOU can be added in the same tab but does not replace these fields.`;
    }
    if (!c.mouAttached) return "ICICI account, IFSC, and branch are saved. Upload the signed MOU and press Save banking & MOU.";
    return null;
}


function $abc550f721019dc4$var$mouFileUrl(applicationId, att) {
    const base = `${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/applications/${encodeURIComponent(applicationId)}/mou-file`;
    if (att?.id) return `${base}/${encodeURIComponent(att.id)}`;
    return base;
}
function $abc550f721019dc4$export$a354b9e186a39f3b() {
    const { id: id } = (0, $265aeae2597a9f58$export$99eaa27ddbbb95ef)();
    const { getById: getById, updateHo: updateHo, saveIciciDetails: saveIciciDetails, confirmSeeding: confirmSeeding } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const app = id ? getById(id) : undefined;
    const [beforeIciciModal, setBeforeIciciModal] = (0, $7UyaH.useState)(false);
    const fileInputRef = (0, $7UyaH.useRef)(null);
    const [pendingFiles, setPendingFiles] = (0, $7UyaH.useState)([]);
    const [removedAttachmentIds, setRemovedAttachmentIds] = (0, $7UyaH.useState)([]);
    const iciciBaselineRef = (0, $7UyaH.useRef)({
        account: "",
        ifsc: "",
        branch: ""
    });
    (0, $7UyaH.useEffect)(()=>{
        setPendingFiles([]);
        setRemovedAttachmentIds([]);
        if (!app) return;
        iciciBaselineRef.current = {
            account: app.ho.iciciAccountNumber.trim(),
            ifsc: app.ho.iciciIfsc.trim(),
            branch: app.ho.iciciBranch.trim()
        };
    }, [
        app?.id
    ]);
    if (!app) return null;
    const ho = app.ho;
    const v = app.validations;
    const banking = (0, $d555c9b5026a95a0$export$3ef1b84986ce58a7)({
        ...ho,
        mouFilesUpload: pendingFiles.length > 0 ? pendingFiles.map((f)=>({
                fileName: f.name,
                mouFileBase64: "",
                mouMimeType: null
            })) : ho.mouFilesUpload
    });
    const statusHint = (0, $d555c9b5026a95a0$export$185348e84c44c173)({
        ...app,
        ho: {
            ...ho,
            mouFilesUpload: pendingFiles.length > 0 ? pendingFiles.map((f)=>({
                    fileName: f.name,
                    mouFileBase64: "",
                    mouMimeType: null
                })) : ho.mouFilesUpload
        }
    });
    const storedAttachments = (ho.mouAttachments ?? []).filter((a)=>!removedAttachmentIds.includes(a.id));
    const buildHoBankingPatch = async ()=>{
        const latest = id ? getById(id) : undefined;
        if (!latest) throw new Error("Application not found");
        const patch = {};
        const base = iciciBaselineRef.current;
        const account = latest.ho.iciciAccountNumber.trim();
        const ifsc = latest.ho.iciciIfsc.trim();
        const branch = latest.ho.iciciBranch.trim();
        if (account !== base.account) patch.iciciAccountNumber = account;
        if (ifsc !== base.ifsc) patch.iciciIfsc = ifsc;
        if (branch !== base.branch) patch.iciciBranch = branch;
        if (pendingFiles.length > 0) patch.mouFilesUpload = await Promise.all(pendingFiles.map(async (f)=>{
            const { base64: base64, mimeType: mimeType } = await (0, $b5ec052719425bb9$export$ff9a6fde0c58ad20)(f);
            return {
                fileName: f.name,
                mouFileBase64: base64,
                mouMimeType: mimeType
            };
        }));
        if (removedAttachmentIds.length) patch.mouRemovedAttachmentIds = [
            ...removedAttachmentIds
        ];
        return patch;
    };
    const syncIciciBaselineFromApp = (applicationId)=>{
        const saved = getById(applicationId);
        if (!saved) return;
        iciciBaselineRef.current = {
            account: saved.ho.iciciAccountNumber.trim(),
            ifsc: saved.ho.iciciIfsc.trim(),
            branch: saved.ho.iciciBranch.trim()
        };
    };
    const openSave = async ()=>{
        const current = id ? getById(id) : undefined;
        if (!current) return;
        if (!current.validations.aadhaarSeedingConfirmed) {
            setBeforeIciciModal(true);
            return;
        }
        try {
            const patch = await buildHoBankingPatch();
            if (!(0, $d555c9b5026a95a0$export$b640f40052a8a900)(patch)) {
                showToast("No changes to save.", "info");
                return;
            }
            await saveIciciDetails(current.id, patch);
            syncIciciBaselineFromApp(current.id);
            setPendingFiles([]);
            setRemovedAttachmentIds([]);
            if (fileInputRef.current) fileInputRef.current.value = "";
        } catch  {
        /* saveIciciDetails shows error toast */ }
    };
    const selectionHint = (()=>{
        const parts = [];
        if (storedAttachments.length) parts.push(storedAttachments.map((a)=>a.fileName).join(", "));
        if (pendingFiles.length) parts.push(pendingFiles.map((f)=>f.name).join(", "));
        return parts.filter(Boolean).join(" \xb7 ");
    })();
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "tab-intro",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "What you do here:"
                    }),
                    " Type the ICICI account number, IFSC, and branch, then attach the signed MOU file. This tab stays ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "greyed out"
                    }),
                    " until Aadhaar seeding is confirmed on the ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Verification"
                    }),
                    " ",
                    "tab. Use ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Save banking & MOU"
                    }),
                    " below when you are finished \u2014 changes are not saved until you press it."
                ]
            }),
            !v.aadhaarSeedingConfirmed ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "alert alert--info",
                children: "Seeding confirmation is required before these fields can be used."
            }) : null,
            v.aadhaarSeedingConfirmed && (app.status === "ready_for_icici" || app.status === "ready_for_mou") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "alert alert--info",
                role: "status",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        style: {
                            margin: "0 0 0.5rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Pipeline checklist"
                            }),
                            " (all must be complete before status moves forward):"
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("ul", {
                        style: {
                            margin: 0,
                            paddingLeft: "1.25rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                children: banking.iciciAccount ? "ICICI account number \u2014 done" : "ICICI account number \u2014 missing"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                children: banking.iciciIfsc ? "ICICI IFSC \u2014 done" : "ICICI IFSC \u2014 missing"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                children: banking.iciciBranch ? "ICICI branch \u2014 done" : "ICICI branch \u2014 missing"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                children: banking.mouAttached ? "MOU file \u2014 attached" : "MOU file \u2014 not attached yet"
                            })
                        ]
                    }),
                    statusHint ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted section-lead--tight",
                        style: {
                            marginTop: "0.65rem",
                            marginBottom: 0
                        },
                        children: statusHint
                    }) : null
                ]
            }) : null,
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        children: "ICICI account & branch"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field-grid",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        children: "ICICI account number"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "mono",
                                        value: ho.iciciAccountNumber,
                                        disabled: !v.aadhaarSeedingConfirmed,
                                        onChange: (e)=>updateHo(app.id, {
                                                iciciAccountNumber: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        children: "ICICI IFSC"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "mono",
                                        value: ho.iciciIfsc,
                                        disabled: !v.aadhaarSeedingConfirmed,
                                        onChange: (e)=>updateHo(app.id, {
                                                iciciIfsc: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        children: "ICICI branch"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        value: ho.iciciBranch,
                                        disabled: !v.aadhaarSeedingConfirmed,
                                        onChange: (e)=>updateHo(app.id, {
                                                iciciBranch: e.target.value
                                            })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        children: "MOU scan (signed copy)"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field field--full",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                children: "Upload MOU (one or more files)"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                ref: fileInputRef,
                                type: "file",
                                multiple: true,
                                accept: ".pdf,image/*",
                                disabled: !v.aadhaarSeedingConfirmed,
                                onChange: (e)=>{
                                    const picked = [
                                        ...e.target.files ?? []
                                    ];
                                    if (!picked.length) return;
                                    const merged = [
                                        ...pendingFiles,
                                        ...picked
                                    ];
                                    setPendingFiles(merged);
                                    updateHo(app.id, {
                                        mouFileName: merged.map((f)=>f.name).join(", ") || null
                                    });
                                    e.target.value = "";
                                }
                            }),
                            selectionHint ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                className: "text-muted file-hint",
                                children: [
                                    "Selected: ",
                                    selectionHint
                                ]
                            }) : null,
                            storedAttachments.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                                className: "file-hint",
                                style: {
                                    marginTop: "0.75rem",
                                    paddingLeft: "1.25rem"
                                },
                                children: storedAttachments.map((att)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                        style: {
                                            marginBottom: "0.35rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "text-muted",
                                                children: att.fileName
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "text-muted",
                                                children: " \u2014 "
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d3365114b8e87556$export$91ad24bb00ba0809), {
                                                fileUrlBase: $abc550f721019dc4$var$mouFileUrl(app.id, att),
                                                fallbackFileName: att.fileName
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "text-muted",
                                                children: " \xb7 "
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                type: "button",
                                                className: "summary-card__link",
                                                style: {
                                                    background: "none",
                                                    border: "none",
                                                    padding: 0,
                                                    cursor: "pointer",
                                                    font: "inherit"
                                                },
                                                onClick: ()=>{
                                                    const nextIds = [
                                                        ...removedAttachmentIds,
                                                        att.id
                                                    ];
                                                    setRemovedAttachmentIds(nextIds);
                                                    const still = (ho.mouAttachments ?? []).filter((a)=>!nextIds.includes(a.id));
                                                    const names = [
                                                        ...still.map((a)=>a.fileName),
                                                        ...pendingFiles.map((f)=>f.name)
                                                    ].join(", ");
                                                    updateHo(app.id, {
                                                        mouFileName: names || null
                                                    });
                                                },
                                                children: "Remove"
                                            })
                                        ]
                                    }, att.id))
                            }) : null,
                            ho.mouFileStored && !storedAttachments.length && !ho.mouAttachments?.length ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "text-muted file-hint",
                                style: {
                                    marginTop: "0.5rem"
                                },
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d3365114b8e87556$export$91ad24bb00ba0809), {
                                    fileUrlBase: $abc550f721019dc4$var$mouFileUrl(app.id),
                                    fallbackFileName: ho.mouFileName ?? "mou-file"
                                })
                            }) : null,
                            pendingFiles.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                                className: "file-hint",
                                style: {
                                    marginTop: "0.5rem",
                                    paddingLeft: "1.25rem"
                                },
                                children: pendingFiles.map((f, idx)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                className: "text-muted",
                                                children: [
                                                    f.name,
                                                    " (not saved yet)"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "text-muted",
                                                children: " \xb7 "
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                type: "button",
                                                className: "summary-card__link",
                                                style: {
                                                    background: "none",
                                                    border: "none",
                                                    padding: 0,
                                                    cursor: "pointer",
                                                    font: "inherit"
                                                },
                                                onClick: ()=>{
                                                    const next = pendingFiles.filter((_, i)=>i !== idx);
                                                    setPendingFiles(next);
                                                    const label = [
                                                        ...storedAttachments.map((a)=>a.fileName),
                                                        ...next.map((f)=>f.name)
                                                    ].join(", ");
                                                    updateHo(app.id, {
                                                        mouFileName: label || null
                                                    });
                                                },
                                                children: "Remove"
                                            })
                                        ]
                                    }, `${f.name}-${idx}`))
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "toolbar-row",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                    type: "button",
                    className: "btn btn--primary btn--tg",
                    onClick: ()=>void openSave(),
                    disabled: !v.aadhaarSeedingConfirmed,
                    children: "Save banking & MOU"
                })
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $061b372afdec2b67$export$2dd8a0472fc8dd3f), {
                open: beforeIciciModal,
                title: "Aadhaar seeding required",
                body: "Seeding must be confirmed before saving ICICI details. Confirm seeding now to continue, or cancel to return.",
                confirmLabel: "Confirm seeding and save",
                onCancel: ()=>setBeforeIciciModal(false),
                onConfirm: ()=>{
                    (async ()=>{
                        try {
                            await confirmSeeding(app.id);
                            const current = id ? getById(id) : undefined;
                            if (!current) return;
                            const patch = await buildHoBankingPatch();
                            if (!(0, $d555c9b5026a95a0$export$b640f40052a8a900)(patch)) {
                                showToast("No changes to save.", "info");
                                return;
                            }
                            await saveIciciDetails(current.id, patch);
                            syncIciciBaselineFromApp(current.id);
                            setPendingFiles([]);
                            setRemovedAttachmentIds([]);
                            if (fileInputRef.current) fileInputRef.current.value = "";
                        } catch  {
                        /* confirmSeeding / saveIciciDetails show error toast */ } finally{
                            setBeforeIciciModal(false);
                        }
                    })();
                }
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");




function $f538fcabd282bc5f$export$e8861bab8171d8fe({ title: title, appId: appId, body: body }) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "card card--gov card--elevated coming-soon-tab",
        "aria-live": "polite",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                className: "card__title card__title--gov",
                children: title
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "tab-intro",
                children: body
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                to: `/applications/${appId}/overview`,
                className: "btn btn--primary btn--tg",
                children: "Back to Overview"
            })
        ]
    });
}



function $29954f24db05ed49$export$128d59be05bb2760() {
    const { id: id } = (0, $265aeae2597a9f58$export$99eaa27ddbbb95ef)();
    const { getById: getById, addWorkDoneBill: addWorkDoneBill, confirmBillSeeding: confirmBillSeeding } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const app = id ? getById(id) : undefined;
    const [billDraft, setBillDraft] = (0, $7UyaH.useState)("");
    if (!app) return null;
    if ((0, $656ff0cd812bb926$export$cc5055592eec1498)(app)) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $f538fcabd282bc5f$export$e8861bab8171d8fe), {
        title: "Bills \u2014 coming soon",
        appId: app.id,
        body: "Work-done bills and seeding confirmation are not available in this console yet \u2014 before or after subcontractor linkage. Your office will enable this step when the workflow is ready."
    });
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "tab-intro",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Simple flow:"
                    }),
                    " (1) Attach a bill file as a reference. (2) For each row, the ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "site officer"
                    }),
                    " ",
                    "must press confirm when seeding has been checked again. Nothing else is needed from HO for that row after confirm."
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        children: "Register work-done bill"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "toolbar-row",
                        style: {
                            alignItems: "flex-end"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field-inline",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        children: "Upload bill (reference)"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        type: "file",
                                        accept: ".pdf,image/*",
                                        onChange: (e)=>setBillDraft(e.target.files?.[0]?.name ?? "")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--tg-secondary",
                                disabled: !billDraft,
                                onClick: ()=>{
                                    (async ()=>{
                                        try {
                                            await addWorkDoneBill(app.id, billDraft);
                                            setBillDraft("");
                                        } catch  {
                                        /* addWorkDoneBill shows error toast */ }
                                    })();
                                },
                                children: "Add to dossier"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        children: "Bills on file"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "table-wrap",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                            className: "data-table",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "File reference"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Uploaded"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Seeding re-verified"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Action"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                    children: app.workDoneBills.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                            colSpan: 4,
                                            className: "empty-cell",
                                            children: "No bills registered for this beneficiary."
                                        })
                                    }) : app.workDoneBills.map((b)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "mono",
                                                    children: b.fileName
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "mono",
                                                    children: b.uploadedAt.slice(0, 16).replace("T", " ")
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: b.seedingReVerified ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "badge badge--ok",
                                                        children: "Yes"
                                                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "badge badge--pending",
                                                        children: "Pending"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "btn btn--primary btn--tg btn--sm",
                                                        disabled: b.seedingReVerified,
                                                        onClick: ()=>void confirmBillSeeding(app.id, b.id),
                                                        children: "Site officer confirms re-verify"
                                                    })
                                                })
                                            ]
                                        }, b.id))
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");



function $1b3404e28c16b77d$export$80471bd65e30ac2f() {
    const { id: id } = (0, $265aeae2597a9f58$export$99eaa27ddbbb95ef)();
    const { getById: getById, engineerMasters: engineerMasters, updateEngineer: updateEngineer, finalizeEngineer: finalizeEngineer } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const app = id ? getById(id) : undefined;
    const [linkError, setLinkError] = (0, $7UyaH.useState)(null);
    if (!app) return null;
    const link = app.engineer ?? {
        engineerMasterId: null
    };
    const gate = (0, $f34886e55d1cc894$export$4ec30dfd1501cd30)(app);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "tab-intro",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Engineer assignment."
                    }),
                    " Engineers are registered under",
                    " ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                        to: "/engineer-onboarding",
                        children: "Engineer onboarding"
                    }),
                    ". Here you select who covers this beneficiary and record the assignment. Same upstream checks as subcontractor assignment apply when this section is locked."
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated card--subcontractor",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        children: "Engineer"
                    }),
                    !gate ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "panel-locked",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "panel-locked__title",
                                children: "This section is locked"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("ul", {
                                className: "panel-locked__list",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                        children: "Complete HO validation, Aadhaar seeding, and ICICI + MOU on the respective tabs."
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                        children: "Resolve any active hold on the file."
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                        children: "When Bills is enabled, confirm seeding re-verification for each work-done bill there."
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            link.linkedAt ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                className: "alert alert--success",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                        children: "On record."
                                    }),
                                    " Engineer assigned at ",
                                    link.linkedAt.slice(0, 16).replace("T", " "),
                                    ". You may change the selected engineer; use ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                        children: "Record engineer"
                                    }),
                                    " again after changes."
                                ]
                            }) : null,
                            linkError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "alert alert--danger",
                                role: "alert",
                                children: linkError
                            }) : null,
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                className: "form-section-title",
                                children: "Registered engineer"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field--full",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: "eng-master-select",
                                        children: "Engineer"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                                        id: "eng-master-select",
                                        value: link.engineerMasterId ?? "",
                                        onChange: (e)=>{
                                            setLinkError(null);
                                            const v = e.target.value;
                                            updateEngineer(app.id, {
                                                engineerMasterId: v === "" ? null : v
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                value: "",
                                                children: "\u2014 Select an engineer \u2014"
                                            }),
                                            engineerMasters.map((m)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("option", {
                                                    value: m.id,
                                                    children: [
                                                        m.fullName,
                                                        m.phone ? ` \xb7 ${m.phone}` : ""
                                                    ]
                                                }, m.id))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                        className: "text-muted",
                                        style: {
                                            marginTop: "0.35rem",
                                            fontSize: "0.8125rem"
                                        },
                                        children: [
                                            "Missing someone?",
                                            " ",
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                                to: "/engineer-onboarding",
                                                className: "btn btn--link btn--sm",
                                                style: {
                                                    padding: 0,
                                                    verticalAlign: "baseline"
                                                },
                                                children: "Open Engineer onboarding"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "section-lead section-lead--tight",
                                children: "Required: an engineer with full name and phone on file. Click below to record the assignment in the database."
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "toolbar-row",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--primary btn--tg btn--lg",
                                    onClick: ()=>{
                                        (async ()=>{
                                            setLinkError(null);
                                            const master = (0, $f34886e55d1cc894$export$2a0dc13f7a78d8d8)(engineerMasters, link.engineerMasterId);
                                            if (!(0, $f34886e55d1cc894$export$2654cb00f18a4c7)(link, master)) {
                                                setLinkError("Choose an engineer from the master list. Register them under Engineer onboarding first if they are not listed.");
                                                return;
                                            }
                                            await finalizeEngineer(app.id);
                                        })();
                                    },
                                    children: link.linkedAt ? "Update engineer assignment" : "Record engineer against beneficiary"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");



async function $63ae46da6580a2c7$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
async function $63ae46da6580a2c7$export$e8ee2447241c4638(token) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/subcontractor-portal/${encodeURIComponent(token)}/beneficiaries`);
    if (!res.ok) throw new Error(await $63ae46da6580a2c7$var$parseError(res));
    return res.json();
}
async function $63ae46da6580a2c7$export$c58350d01b43b8b8(token, applicationId, timelinePhaseId, actualStartDate) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/subcontractor-portal/${encodeURIComponent(token)}/set-phase-start`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            applicationId: applicationId,
            timelinePhaseId: timelinePhaseId,
            actualStartDate: actualStartDate
        })
    });
    if (!res.ok) throw new Error(await $63ae46da6580a2c7$var$parseError(res));
    return res.json();
}
async function $63ae46da6580a2c7$export$f75a17bdf31e16db(token, applicationId, timelinePhaseId, photoData, opts) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/subcontractor-portal/${encodeURIComponent(token)}/submit-phase`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            applicationId: applicationId,
            timelinePhaseId: timelinePhaseId,
            photoData: photoData,
            photoData2: opts?.photoData2,
            photoData3: opts?.photoData3,
            videoData: opts?.videoData
        })
    });
    if (!res.ok) throw new Error(await $63ae46da6580a2c7$var$parseError(res));
    return res.json();
}
async function $63ae46da6580a2c7$export$f02b737d3e61a2d5(status = "Submitted") {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/timeline-approvals?status=${encodeURIComponent(status)}`);
    if (!res.ok) throw new Error(await $63ae46da6580a2c7$var$parseError(res));
    return res.json();
}
async function $63ae46da6580a2c7$export$13372f0d18e6464a() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/timeline-approvals/counts`);
    if (!res.ok) throw new Error(await $63ae46da6580a2c7$var$parseError(res));
    return res.json();
}
async function $63ae46da6580a2c7$export$ec8b69963c5a7eb2(id, status, notes) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/timeline-approvals/${encodeURIComponent(id)}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            status: status,
            notes: notes
        })
    });
    if (!res.ok) throw new Error(await $63ae46da6580a2c7$var$parseError(res));
    return res.json();
}
async function $63ae46da6580a2c7$export$1a54a9a56e65f53e(applicationId) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/timeline-progress/${encodeURIComponent(applicationId)}`);
    if (!res.ok) throw new Error(await $63ae46da6580a2c7$var$parseError(res));
    return res.json();
}





function $3ac7a48441ad9014$var$sortedTemplates(templates) {
    return [
        ...templates
    ].sort((a, b)=>a.sortOrder - b.sortOrder);
}
function $3ac7a48441ad9014$var$buildMilestoneSteps(templates, app) {
    const rows = [];
    for (const tpl of templates){
        const prog = app.milestoneProgress.find((p)=>p.templateId === tpl.id);
        if (!prog) continue;
        rows.push({
            tpl: tpl,
            prog: prog
        });
    }
    const currentIdx = rows.findIndex((r)=>!r.prog.milestoneCompletedAt);
    return rows.map((r, i)=>{
        let status;
        let hint;
        if (r.prog.milestoneCompletedAt) {
            status = "complete";
            hint = "Completed";
        } else if (i === currentIdx) {
            status = "current";
            hint = "Track subcontractor site updates in the timeline";
        } else {
            status = "upcoming";
            hint = "Not started";
        }
        return {
            ...r,
            status: status,
            hint: hint
        };
    });
}
function $3ac7a48441ad9014$var$maxIsoTimestamps(dates) {
    const clean = dates.filter((d)=>Boolean(d && String(d).trim()));
    if (!clean.length) return null;
    return clean.reduce((a, b)=>a > b ? a : b);
}
function $3ac7a48441ad9014$var$lastChecklistActivityIso(app) {
    const acc = [];
    for (const mp of app.milestoneProgress){
        if (mp.milestoneCompletedAt) acc.push(mp.milestoneCompletedAt);
        for (const ip of mp.itemProgress)if (ip.completedAt) acc.push(ip.completedAt);
    }
    return $3ac7a48441ad9014$var$maxIsoTimestamps(acc);
}
function $3ac7a48441ad9014$var$formatTrackerDate(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleDateString("en-IN", {
        weekday: "short",
        day: "numeric",
        month: "short",
        year: "2-digit"
    });
}
function $3ac7a48441ad9014$var$formatTrackerDateTime(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    const datePart = $3ac7a48441ad9014$var$formatTrackerDate(iso);
    const timePart = d.toLocaleTimeString("en-IN", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true
    });
    return `${datePart} \u{2014} ${timePart}`;
}
function $3ac7a48441ad9014$var$actualDaysForPhase(app, phaseId) {
    const raw = app.constructionTimelineActualDays?.[phaseId];
    return typeof raw === "number" && Number.isFinite(raw) && raw >= 0 ? raw : null;
}
/**
 * Map portal enum to officer-friendly label.
 * Work-progress only advances on `Approved`; `Submitted` is shown as
 * "Pending approval" so the Milestones tab matches the Work Progress Gantt.
 */ function $3ac7a48441ad9014$var$portalStatusDisplay(status) {
    switch(status){
        case "Approved":
            return {
                label: "Approved",
                badgeClass: "badge badge--ok",
                title: "Portal: approved by office \u2014 counted in Work Progress"
            };
        case "Submitted":
            return {
                label: "Pending approval",
                badgeClass: "badge badge--pending",
                title: "Portal: subcontractor submitted \u2014 awaiting office approval. Work Progress will not advance until approved."
            };
        case "Rejected":
            return {
                label: "Rejected",
                badgeClass: "badge badge--hold",
                title: "Portal: rejected"
            };
        case "Hold":
            return {
                label: "Hold",
                badgeClass: "badge badge--pending",
                title: "Portal: on hold"
            };
        default:
            return {
                label: "Pending",
                badgeClass: "badge badge--outline",
                title: "No subcontractor submission yet"
            };
    }
}
/** Build image src from portal LONGTEXT (data URL or raw base64). */ function $3ac7a48441ad9014$var$portalPhotoSrc(raw) {
    if (raw == null) return null;
    const s = String(raw).trim();
    if (!s) return null;
    if (s.startsWith("data:image/") || s.startsWith("data:application/octet-stream")) return s;
    if (s.startsWith("http://") || s.startsWith("https://")) return s;
    const compact = s.replace(/\s/g, "");
    if (compact.length < 32) return null;
    return `data:image/jpeg;base64,${compact}`;
}
function $3ac7a48441ad9014$var$MilestoneTimelinePlanRow({ phase: phase, app: app, portalStatus: portalStatus, submittedAt: submittedAt, photoData: photoData }) {
    const [open, setOpen] = (0, $7UyaH.useState)(false);
    const actual = $3ac7a48441ad9014$var$actualDaysForPhase(app, phase.id);
    const badge = $3ac7a48441ad9014$var$portalStatusDisplay(portalStatus);
    const imgSrc = $3ac7a48441ad9014$var$portalPhotoSrc(photoData);
    const hasSiteDetails = Boolean(submittedAt || imgSrc);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
        className: "milestone-vtimeline__plan-row",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "milestone-vtimeline__plan-cell milestone-vtimeline__plan-cell--main",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-vtimeline__plan-title",
                        children: phase.title
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "milestone-vtimeline__plan-metrics",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                className: "milestone-vtimeline__plan-plan",
                                children: [
                                    "~",
                                    phase.approxDays,
                                    " d plan"
                                ]
                            }),
                            actual != null ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                className: "milestone-vtimeline__plan-actual",
                                children: [
                                    " \xb7 Logged ",
                                    actual,
                                    " d (site)"
                                ]
                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                className: "milestone-vtimeline__plan-actual milestone-vtimeline__plan-actual--muted",
                                children: [
                                    " ",
                                    "\xb7 No site log yet"
                                ]
                            })
                        ]
                    }),
                    hasSiteDetails ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "milestone-vtimeline__plan-actions",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            className: "btn btn--link btn--sm milestone-vtimeline__view-btn",
                            onClick: ()=>setOpen((v)=>!v),
                            "aria-expanded": open,
                            children: open ? "Hide" : "View"
                        })
                    }) : null,
                    open && hasSiteDetails ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "milestone-vtimeline__plan-details",
                        children: [
                            submittedAt ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                className: "milestone-vtimeline__plan-submitted text-muted",
                                children: [
                                    "Subcontractor update: ",
                                    $3ac7a48441ad9014$var$formatTrackerDateTime(submittedAt)
                                ]
                            }) : null,
                            imgSrc ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "milestone-vtimeline__plan-photo-wrap",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                                    src: imgSrc,
                                    alt: `Site photo submitted for ${phase.title}`,
                                    className: "milestone-vtimeline__plan-photo",
                                    loading: "lazy"
                                })
                            }) : null
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "milestone-vtimeline__plan-cell milestone-vtimeline__plan-cell--status",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                    className: badge.badgeClass,
                    title: badge.title,
                    children: badge.label
                })
            })
        ]
    });
}
/** Flipkart-style summary card + expandable vertical “all updates” timeline. */ function $3ac7a48441ad9014$var$resolveLinkedTimelines(tpl, constructionTimelinePhases) {
    return (tpl.linkedConstructionTimelinePhaseIds ?? []).map((pid)=>constructionTimelinePhases.find((p)=>p.id === pid)).filter((p)=>Boolean(p));
}
function $3ac7a48441ad9014$var$MilestoneFlipkartTracker({ templates: templates, app: app, constructionTimelinePhases: constructionTimelinePhases }) {
    const { refreshApplicationsFromApi: refreshApplicationsFromApi } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const [showAllUpdates, setShowAllUpdates] = (0, $7UyaH.useState)(false);
    const [portalByPhaseId, setPortalByPhaseId] = (0, $7UyaH.useState)({});
    const updatesRef = (0, $7UyaH.useRef)(null);
    (0, $7UyaH.useEffect)(()=>{
        if (!showAllUpdates) return;
        refreshApplicationsFromApi();
    }, [
        showAllUpdates,
        refreshApplicationsFromApi
    ]);
    (0, $7UyaH.useEffect)(()=>{
        let cancelled = false;
        (async ()=>{
            try {
                const rows = await (0, $63ae46da6580a2c7$export$1a54a9a56e65f53e)(app.id);
                if (cancelled) return;
                const m = {};
                for (const r of rows)m[String(r.timeline_phase_id)] = {
                    status: r.status,
                    submitted_at: r.submitted_at,
                    photo_data: r.photo_data
                };
                setPortalByPhaseId(m);
            } catch  {
                if (!cancelled) setPortalByPhaseId({});
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        app.id,
        showAllUpdates
    ]);
    const steps = (0, $7UyaH.useMemo)(()=>$3ac7a48441ad9014$var$buildMilestoneSteps(templates, app), [
        templates,
        app
    ]);
    const current = steps.find((s)=>s.status === "current");
    const allDone = steps.length > 0 && steps.every((s)=>s.status === "complete");
    const lastActivity = $3ac7a48441ad9014$var$lastChecklistActivityIso(app);
    const completionStamp = $3ac7a48441ad9014$var$maxIsoTimestamps(steps.map((s)=>s.prog.milestoneCompletedAt));
    const toggleUpdates = ()=>{
        setShowAllUpdates((prev)=>{
            const next = !prev;
            if (next) window.requestAnimationFrame(()=>{
                updatesRef.current?.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            });
            return next;
        });
    };
    if (steps.length === 0) return null;
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "milestone-flipkart-tracker",
        role: "region",
        "aria-label": "Milestone status",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "milestone-track-hero card card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "milestone-track-hero__top",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "milestone-track-hero__copy",
                                children: [
                                    allDone ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                        className: "milestone-track-hero__status",
                                        children: [
                                            "Completed",
                                            completionStamp ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                                children: [
                                                    ", ",
                                                    $3ac7a48441ad9014$var$formatTrackerDate(completionStamp)
                                                ]
                                            }) : null
                                        ]
                                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                        className: "milestone-track-hero__status",
                                        children: [
                                            "In progress",
                                            current ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                                children: [
                                                    ", ",
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "milestone-track-hero__status-phase",
                                                        children: current.tpl.title
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "milestone-track-hero__sub",
                                        children: allDone ? "All milestone phases are complete for this beneficiary." : current ? current.hint : null
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                        className: "milestone-track-hero__meta",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "milestone-track-hero__info",
                                                "aria-hidden": true,
                                                title: "Information",
                                                children: "\u24D8"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                children: lastActivity ? `Last recorded update: ${$3ac7a48441ad9014$var$formatTrackerDateTime(lastActivity)}` : "No officer milestone timestamps recorded for this file yet."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "milestone-track-hero__badge" + (allDone ? " milestone-track-hero__badge--done" : " milestone-track-hero__badge--active"),
                                "aria-hidden": true,
                                children: allDone ? "\u2713" : "\u25CF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("hr", {
                        className: "milestone-track-hero__rule"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "milestone-track-hero__updates-btn",
                        onClick: toggleUpdates,
                        children: showAllUpdates ? "Hide all updates" : "See all updates"
                    })
                ]
            }),
            showAllUpdates ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                ref: updatesRef,
                id: "milestone-all-updates",
                className: "milestone-vtimeline-wrap card card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "milestone-vtimeline-wrap__title",
                        children: "Milestone timeline"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "milestone-vtimeline-wrap__lead text-muted",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Plan"
                            }),
                            " comes from Timeline master. ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Logged days"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "status"
                            }),
                            ", and photos follow the subcontractor portal (same source as the Work Progress Gantt). Use",
                            " ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: `/applications/${app.id}/bills`,
                                children: "Bills"
                            }),
                            " and",
                            " ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: `/applications/${app.id}/subcontractor`,
                                children: "Subcontractor"
                            }),
                            " in the dossier for documents."
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ol", {
                        className: "milestone-vtimeline",
                        children: steps.map((s, i)=>{
                            const linkedTimelines = $3ac7a48441ad9014$var$resolveLinkedTimelines(s.tpl, constructionTimelinePhases);
                            return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                className: "milestone-vtimeline__row",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "milestone-vtimeline__rail",
                                        "aria-hidden": true,
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "milestone-vtimeline__dot milestone-vtimeline__dot--" + s.status
                                            }),
                                            i < steps.length - 1 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "milestone-vtimeline__stem" + (s.status === "complete" ? " milestone-vtimeline__stem--done" : "")
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "milestone-vtimeline__body",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "milestone-vtimeline__head",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                        className: "milestone-vtimeline__phase-title",
                                                        children: s.tpl.title
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "milestone-vtimeline__phase-date",
                                                        children: s.status === "complete" && s.prog.milestoneCompletedAt ? $3ac7a48441ad9014$var$formatTrackerDate(s.prog.milestoneCompletedAt) : s.status === "current" ? "In progress" : "Pending"
                                                    })
                                                ]
                                            }),
                                            linkedTimelines.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                                                className: "milestone-vtimeline__plans",
                                                "aria-label": "Construction timeline \u2014 plan vs site",
                                                children: linkedTimelines.map((p)=>{
                                                    const portal = portalByPhaseId[String(p.id)];
                                                    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($3ac7a48441ad9014$var$MilestoneTimelinePlanRow, {
                                                        phase: p,
                                                        app: app,
                                                        portalStatus: portal?.status ?? "Pending",
                                                        submittedAt: portal?.submitted_at ?? null,
                                                        photoData: portal?.photo_data ?? null
                                                    }, p.id);
                                                })
                                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                className: "milestone-vtimeline__plans-empty text-muted",
                                                children: [
                                                    "No timeline levels linked for this milestone \u2014 edit links in",
                                                    " ",
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                                        to: "/milestone-master",
                                                        children: "Milestone master"
                                                    }),
                                                    "."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, s.tpl.id);
                        })
                    })
                ]
            }) : null
        ]
    });
}
function $3ac7a48441ad9014$export$c9202ba29b1b038c() {
    const { id: id } = (0, $265aeae2597a9f58$export$99eaa27ddbbb95ef)();
    const { getById: getById, milestoneTemplates: milestoneTemplates, constructionTimelinePhases: constructionTimelinePhases, refreshApplicationsFromApi: refreshApplicationsFromApi } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const app = id ? getById(id) : undefined;
    const orderedTemplates = (0, $7UyaH.useMemo)(()=>$3ac7a48441ad9014$var$sortedTemplates(milestoneTemplates), [
        milestoneTemplates
    ]);
    (0, $7UyaH.useEffect)(()=>{
        refreshApplicationsFromApi();
    }, [
        id,
        refreshApplicationsFromApi
    ]);
    if (!app) return null;
    if ((0, $656ff0cd812bb926$export$cc5055592eec1498)(app)) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $f538fcabd282bc5f$export$e8861bab8171d8fe), {
        title: "Milestones \u2014 coming soon",
        appId: app.id,
        body: "Per-beneficiary milestone tracking is not available in this console yet \u2014 before or after subcontractor linkage. Your office will enable this step when the workflow is ready."
    });
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "tab-intro",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Milestone phases"
                    }),
                    " come from ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Milestone master"
                    }),
                    ". This tab shows status at a glance and the ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "construction timeline"
                    }),
                    " tied to each phase, driven by",
                    " ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "subcontractor portal"
                    }),
                    " updates (same feed as Work Progress)."
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "help-banner help-banner--info",
                style: {
                    marginBottom: "1rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Milestone & timeline setup"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        style: {
                            margin: "0.35rem 0 0"
                        },
                        children: [
                            "Edit milestone phases and which construction levels they link to under",
                            " ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/milestone-master",
                                children: "Milestone master"
                            }),
                            ". Planned days come from",
                            " ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/construction-timeline-master",
                                children: "Timeline master"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($3ac7a48441ad9014$var$MilestoneFlipkartTracker, {
                templates: orderedTemplates,
                app: app,
                constructionTimelinePhases: constructionTimelinePhases
            })
        ]
    });
}






function $b49b969a82bb744b$var$hoComplete(status) {
    return status === "ready_for_icici" || status === "ready_for_mou" || status === "icici_recorded" || status === "subcontractor_linked";
}
function $b49b969a82bb744b$var$stepStates(status) {
    const s1 = "done";
    let s2;
    if ($b49b969a82bb744b$var$hoComplete(status)) s2 = "done";
    else s2 = "current";
    let s3;
    if (status === "subcontractor_linked" || status === "icici_recorded") s3 = "done";
    else if (status === "ready_for_mou") s3 = "current-mou";
    else if (status === "ready_for_icici") s3 = "current";
    else s3 = "upcoming";
    let s4;
    if (status === "subcontractor_linked") s4 = "done";
    else if (status === "icici_recorded") s4 = "current";
    else s4 = "upcoming";
    return [
        s1,
        s2,
        s3,
        s4
    ];
}
function $b49b969a82bb744b$var$buildSteps(pipeStatus, states) {
    const title3 = pipeStatus === "ready_for_mou" ? "MOU to attach" : "ICICI account & MOU";
    return [
        {
            key: "a",
            state: states[0],
            title: "Field intake"
        },
        {
            key: "b",
            state: states[1],
            title: "HO verification"
        },
        {
            key: "c",
            state: states[2],
            title: title3
        },
        {
            key: "d",
            state: states[3],
            title: "Subcontractor"
        }
    ];
}
function $b49b969a82bb744b$var$lineTone(st) {
    return st === "done" ? "complete" : "pending";
}
function $b49b969a82bb744b$export$bf13bb119b9de1e4({ application: application, masters: masters }) {
    const pipeStatus = (0, $85279307e2bde4bc$export$df42b932a5162b49)(application, masters);
    const states = $b49b969a82bb744b$var$stepStates(pipeStatus);
    const steps = $b49b969a82bb744b$var$buildSteps(pipeStatus, states);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
        className: "case-progress",
        role: "list",
        "aria-label": "Case pipeline",
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
            className: "case-progress__steps",
            children: steps.map((step, i)=>{
                const leftDone = i > 0 && $b49b969a82bb744b$var$lineTone(steps[i - 1].state) === "complete";
                const rightDone = $b49b969a82bb744b$var$lineTone(step.state) === "complete";
                return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: `case-progress__step case-progress__step--${step.state}`,
                    role: "listitem",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "case-progress__track",
                            children: [
                                i > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: `case-progress__line case-progress__line--${leftDone ? "complete" : "pending"}`,
                                    "aria-hidden": true
                                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "case-progress__line case-progress__line--spacer",
                                    "aria-hidden": true
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "case-progress__dot"
                                }),
                                i < steps.length - 1 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: `case-progress__line case-progress__line--${rightDone ? "complete" : "pending"}`,
                                    "aria-hidden": true
                                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "case-progress__line case-progress__line--spacer",
                                    "aria-hidden": true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "case-progress__text",
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "case-progress__title",
                                children: step.title
                            })
                        })
                    ]
                }, step.key);
            })
        })
    });
}








function $20115b285d433205$export$8db5ce53996c7d0e(app) {
    const base = `/applications/${app.id}`;
    const v = app.validations;
    if (app.holdReasons.length > 0) return {
        title: "This file is on hold",
        body: "Review the reasons on this page, fix the issues in the field or with documents, then update the checklist on the Validation tab.",
        to: `${base}/validation`,
        cta: "Go to Validation"
    };
    if (app.status === "icici_recorded") return {
        title: "Next: link the subcontractor",
        body: "Banking and MOU are saved. Open the Subcontractor tab, pick the firm from the onboarded list, then save. You may attach this beneficiary\u2019s work order if you have it. Register new firms under Subcontractor Onboarding in the main menu if needed.",
        to: `${base}/subcontractor`,
        cta: "Go to Subcontractor"
    };
    if (app.status === "subcontractor_linked") return {
        title: "Subcontractor on record",
        body: "The firm is linked for this beneficiary. Milestones and Bills stay coming soon for now; open other sections from the menu to review or update details.",
        to: `${base}/beneficiary`,
        cta: "Review beneficiary details"
    };
    if (app.status === "ready_for_icici") return {
        title: "Next: enter ICICI banking details",
        body: "Checks and Aadhaar seeding are done. Open the ICICI & MOU tab and enter the ICICI account number, IFSC, and branch, then save. You can attach the MOU scan in the same visit or after.",
        to: `${base}/banking`,
        cta: "Go to ICICI & MOU"
    };
    if (app.status === "ready_for_mou") return {
        title: "Next: attach the signed MOU",
        body: "ICICI account details are saved. On the ICICI & MOU tab, upload the signed MOU scan and press save to move this file to awaiting subcontractor.",
        to: `${base}/banking`,
        cta: "Go to ICICI & MOU"
    };
    if (!v.aadhaarSeedingConfirmed) {
        const checksDone = v.nameMatchAcrossSources === true && v.aadhaarVerified === true && v.bankAccountVerified === true && (0, $3655432918d5e89d$export$563fe0138d49a54b)(v.workmanCardAcceptable);
        if (!checksDone) return {
            title: "Next: finish the verification checklist",
            body: "Use the dropdowns to record each check. When everything is marked OK, you can confirm Aadhaar seeding on the same tab.",
            to: `${base}/validation`,
            cta: "Go to Validation"
        };
        return {
            title: "Next: confirm Aadhaar seeding",
            body: "All checklist items are OK. Press \u201CConfirm Aadhaar seeding\u201D and complete the popup. After that, the ICICI tab will unlock.",
            to: `${base}/validation`,
            cta: "Go to Validation"
        };
    }
    if (app.status === "pending_validation") return {
        title: "Next: complete verification",
        body: "Work through the Validation tab: name match, Aadhaar, bank account, workman card, then seeding confirmation.",
        to: `${base}/validation`,
        cta: "Go to Validation"
    };
    return {
        title: "Continue from Overview",
        body: "Use the coloured steps above to see where this file is. Pick a section on the left when you are ready to enter or review data.",
        to: `${base}/beneficiary`,
        cta: "View beneficiary & documents"
    };
}


function $fa46e63be9c20beb$export$6f4392fd3b9b5804() {
    const { id: id } = (0, $265aeae2597a9f58$export$99eaa27ddbbb95ef)();
    const { can: can } = (0, $a4dc0d923ddf5b19$export$1d39dc5b47e56ff0)();
    const { getById: getById, getSubcontractorMaster: getSubcontractorMaster, milestoneTemplates: milestoneTemplates, subcontractorMasters: subcontractorMasters } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const app = id ? getById(id) : undefined;
    if (!app) return null;
    const base = `/applications/${app.id}`;
    const linkedSubName = app.subcontractor.subcontractorMasterId ? getSubcontractorMaster(app.subcontractor.subcontractorMasterId)?.firmName : undefined;
    const v = app.validations;
    const next = (0, $20115b285d433205$export$8db5ce53996c7d0e)(app);
    const milestonesBillsLocked = (0, $656ff0cd812bb926$export$cc5055592eec1498)(app);
    const milestonesTabAllowed = (0, $4aabdb75dcf6b773$export$96e9d18fd02a12c4)(can);
    const fullApplicantAccess = can("applications");
    const tabReachable = (path)=>fullApplicantAccess || can((0, $4aabdb75dcf6b773$export$b8157996bdb9c190)[path]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "help-banner help-banner--welcome",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "How this page works"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        children: [
                            "This is the ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "summary"
                            }),
                            " for one beneficiary. The coloured bar shows how far the case has moved. Below you can open any section from the cards, or use the ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "green links on the left"
                            }),
                            " \u2014 they stay visible on every screen."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "help-banner help-banner--next",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "help-banner__badge",
                        children: "Suggested next step"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "help-banner__title",
                        children: next.title
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "help-banner__body",
                        children: next.body
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: next.to,
                        className: "btn btn--primary btn--tg help-banner__btn",
                        children: next.cta
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        children: "Progress for this case"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "section-lead",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Green"
                            }),
                            " steps are finished; ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "blue"
                            }),
                            " is the step that needs you now. Lines between steps turn green as each stage is completed."
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $b49b969a82bb744b$export$bf13bb119b9de1e4), {
                        application: app,
                        masters: subcontractorMasters
                    })
                ]
            }),
            app.holdReasons.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "alert alert--hold",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Action needed \u2014 file is on hold."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "alert__lead",
                        children: "Please fix the issues below, then update the checklist on the Validation tab."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                        children: app.holdReasons.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                children: r
                            }, r))
                    })
                ]
            }) : null,
            !v.aadhaarSeedingConfirmed && app.holdReasons.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "alert alert--info",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Banking is locked until seeding is confirmed."
                    }),
                    " Open",
                    " ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: `${base}/validation`,
                        children: "Verification & Aadhaar seeding"
                    }),
                    " and complete the steps there first."
                ]
            }) : null,
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                className: "section-heading section-heading--inset",
                children: "Key details at a glance"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "section-sub section-sub--tight",
                children: "Tap a card link to see the full section."
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "summary-grid",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "summary-card",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                className: "summary-card__title",
                                children: "Beneficiary"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("dl", {
                                className: "summary-dl",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                        children: app.mobile.beneficiaryName
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                        children: "Father / husband"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                        children: app.mobile.fatherOrHusbandName
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                        children: "Aadhaar"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                        className: "mono",
                                        children: app.mobile.aadhaarNumber
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                                to: `${base}/beneficiary`,
                                className: "summary-card__link",
                                children: "See all beneficiary fields & documents"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "summary-card",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                className: "summary-card__title",
                                children: "Verification"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("dl", {
                                className: "summary-dl",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                        children: "Name match"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                        children: v.nameMatchAcrossSources === true ? "OK" : v.nameMatchAcrossSources === false ? "Issue" : "Not set"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                        children: "Aadhaar checked"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                        children: v.aadhaarVerified === true ? "OK" : v.aadhaarVerified === false ? "Issue" : "Not set"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                        children: "Seeding"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                        children: v.aadhaarSeedingConfirmed ? "Done" : "Not yet"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                                to: `${base}/validation`,
                                className: "summary-card__link",
                                children: "Open verification & seeding"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "summary-card",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                className: "summary-card__title",
                                children: "ICICI & MOU"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("dl", {
                                className: "summary-dl",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                        children: "Account entered"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                        children: app.ho.iciciAccountNumber ? "Yes" : "No"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                        children: "MOU file"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                        children: app.ho.mouFileName || app.ho.mouFileStored || (app.ho.mouAttachments?.length ?? 0) > 0 ? "Attached" : "Not yet"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                                to: `${base}/banking`,
                                className: "summary-card__link",
                                children: "Open ICICI & MOU"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "summary-card",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                className: "summary-card__title",
                                children: "Milestones"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("dl", {
                                className: "summary-dl",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                        children: "Open phases"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                        children: app.milestoneProgress.filter((p)=>!p.milestoneCompletedAt).length
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                        children: "Items pending"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                        children: app.milestoneProgress.reduce((n, p)=>{
                                            const t = milestoneTemplates.find((x)=>x.id === p.templateId);
                                            if (!t) return n;
                                            return n + t.items.filter((it)=>{
                                                const ip = p.itemProgress.find((i)=>i.templateItemId === it.id);
                                                return !ip?.completedAt;
                                            }).length;
                                        }, 0)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                        children: "Phases complete"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                        children: app.milestoneProgress.filter((p)=>p.milestoneCompletedAt).length
                                    })
                                ]
                            }),
                            milestonesBillsLocked ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "summary-card__link summary-card__link--muted",
                                "aria-disabled": "true",
                                children: "Milestones \u2014 coming soon"
                            }) : milestonesTabAllowed && tabReachable("milestones") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                                to: `${base}/milestones`,
                                className: "summary-card__link",
                                children: "Complete master checklist for this file"
                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "summary-card__link summary-card__link--muted",
                                "aria-disabled": "true",
                                children: "Milestones \u2014 permission required (milestone master + dossier milestones tab or full applicant access)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "summary-card",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                className: "summary-card__title",
                                children: "Bills & subcontractor"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("dl", {
                                className: "summary-dl",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                        children: "Work bills"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                        children: app.workDoneBills.length
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                        children: "Awaiting site confirm"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                        children: app.workDoneBills.filter((b)=>!b.seedingReVerified).length
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                        children: "Subcontractor"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                        children: app.status === "subcontractor_linked" ? linkedSubName ?? "Linked (master)" : "Not linked"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "summary-card__links",
                                children: [
                                    milestonesBillsLocked ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "summary-card__link summary-card__link--muted",
                                        "aria-disabled": "true",
                                        children: "Bills \u2014 coming soon"
                                    }) : tabReachable("bills") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                                        to: `${base}/bills`,
                                        className: "summary-card__link",
                                        children: "Bills"
                                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "summary-card__link summary-card__link--muted",
                                        "aria-disabled": "true",
                                        children: "Bills \u2014 no access"
                                    }),
                                    tabReachable("subcontractor") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                                        to: `${base}/subcontractor`,
                                        className: "summary-card__link",
                                        children: "Subcontractor"
                                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "summary-card__link summary-card__link--muted",
                                        "aria-disabled": "true",
                                        children: "Subcontractor \u2014 no access"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        children: "All sections (same as left menu)"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "section-lead section-lead--tight",
                        children: "Choose a row to go straight to that part of the file."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                        className: "section-index",
                        children: (0, $e84bf4288d5796f2$export$66ddc5af3dc06a46).filter((t)=>t.path !== "overview").map((t)=>{
                            const lockedBySubStage = milestonesBillsLocked && (t.path === "milestones" || t.path === "bills");
                            const lockedMilestonesNoMaster = t.path === "milestones" && !milestonesTabAllowed;
                            const lockedNoTabScope = !fullApplicantAccess && !can((0, $4aabdb75dcf6b773$export$b8157996bdb9c190)[t.path]);
                            const lockedHere = lockedBySubStage || lockedMilestonesNoMaster || lockedNoTabScope;
                            return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                children: lockedHere ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "section-index__row section-index__row--muted",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                            className: "section-index__en",
                                            children: [
                                                t.label,
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                    className: "section-index__badge",
                                                    children: lockedNoTabScope && !lockedBySubStage ? "No access" : lockedMilestonesNoMaster && !lockedBySubStage ? "No access" : "Coming soon"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "section-index__desc",
                                            children: lockedNoTabScope && !lockedBySubStage ? "Your role does not include this dossier section. Ask an administrator to grant the matching tab permission." : lockedMilestonesNoMaster && !lockedBySubStage ? "Milestone master (templates) plus dossier milestones access is required for milestone checklists." : "Not available in this console yet (before or after subcontractor). Your office will enable this when ready."
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                                    to: `${base}/${t.path}`,
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "section-index__en",
                                            children: t.label
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "section-index__desc",
                                            children: t.userHint
                                        })
                                    ]
                                })
                            }, t.path);
                        })
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");




/** Official GST — search taxpayer by GSTIN / PAN (public) */ const $4e5a01c53c04eac9$export$419cac9f2beb55a3 = "https://services.gst.gov.in/services/quicklinks/searchtxp";
const $4e5a01c53c04eac9$export$5142f53e44d136be = "https://www.gst.gov.in/";
const $4e5a01c53c04eac9$export$cfb945196ddd15c1 = "https://www.mca.gov.in/content/mca/global/en/mca/master-data/MDS/company-master-info.html";




function $7c02e20ae23ac506$export$abca29eec3bdbd9d(props = {}) {
    const { embedded: embedded } = props;
    const { id: id } = (0, $265aeae2597a9f58$export$99eaa27ddbbb95ef)();
    const { getById: getById, subcontractorMasters: subcontractorMasters, updateSubcontractor: updateSubcontractor, finalizeSubcontractor: finalizeSubcontractor } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const app = id ? getById(id) : undefined;
    const [linkError, setLinkError] = (0, $7UyaH.useState)(null);
    const fileInputRef = (0, $7UyaH.useRef)(null);
    if (!app) return null;
    const link = app.subcontractor;
    const subGate = (0, $85279307e2bde4bc$export$3cda207770a484f5)(app);
    const workOrderFileApiBase = `${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/applications/${encodeURIComponent(app.id)}/work-order-file`;
    const dedicated = embedded === "dedicated";
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            !dedicated ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "tab-intro",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Subcontractor linkage."
                    }),
                    " Firm identity, contact, and bank details are registered under",
                    " ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                        to: "/subcontractor-onboarding",
                        children: "Subcontractor Onboarding"
                    }),
                    ". Here you only choose which registered firm is engaged for this beneficiary; you may optionally attach a work order or engagement letter for this unit. Use that screen first if the firm is not yet listed. If this section is locked, the grey box lists what is still missing upstream.",
                    " ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                        className: "text-muted",
                        children: [
                            "Official checks:",
                            " ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("a", {
                                href: (0, $4e5a01c53c04eac9$export$419cac9f2beb55a3),
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "GST taxpayer search"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("a", {
                                href: (0, $4e5a01c53c04eac9$export$5142f53e44d136be),
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "GST home"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("a", {
                                href: (0, $4e5a01c53c04eac9$export$cfb945196ddd15c1),
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "MCA company / LLP master"
                            }),
                            "."
                        ]
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: dedicated ? "card card--gov card--elevated card--subcontractor card--subcontractor-dedicated" : "card card--gov card--elevated card--subcontractor",
                children: [
                    !dedicated ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        children: "Subcontractor linkage"
                    }) : null,
                    !subGate ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "panel-locked",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "panel-locked__title",
                                children: "This section is locked"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("ul", {
                                className: "panel-locked__list",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                        children: "Complete HO validation, Aadhaar seeding, and ICICI + MOU on the respective tabs."
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                        children: "Resolve any active hold on the file."
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                        children: "When Bills is enabled for your office, confirm seeding re-verification for each work-done bill there."
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            app.status === "subcontractor_linked" && link.linkedAt ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                className: "alert alert--success",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                        children: "On record."
                                    }),
                                    " Subcontractor linked at ",
                                    link.linkedAt.slice(0, 16).replace("T", " "),
                                    ". You may change the selected firm or replace the work order; clearing the selected firm will remove linked status until you save again."
                                ]
                            }) : null,
                            linkError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "alert alert--danger",
                                role: "alert",
                                children: linkError
                            }) : null,
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                className: "form-section-title",
                                children: "Registered subcontractor"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field--full",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: "sub-master-select",
                                        children: "Registered firm"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                                        id: "sub-master-select",
                                        value: link.subcontractorMasterId ?? "",
                                        onChange: (e)=>{
                                            setLinkError(null);
                                            const v = e.target.value;
                                            updateSubcontractor(app.id, {
                                                subcontractorMasterId: v === "" ? null : v
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                value: "",
                                                children: "\u2014 Select an onboarded firm \u2014"
                                            }),
                                            subcontractorMasters.map((m)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("option", {
                                                    value: m.id,
                                                    children: [
                                                        m.firmName,
                                                        m.contactPhone ? ` \xb7 ${m.contactPhone}` : ""
                                                    ]
                                                }, m.id))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                        className: "text-muted",
                                        style: {
                                            marginTop: "0.35rem",
                                            fontSize: "0.8125rem"
                                        },
                                        children: [
                                            "Missing a firm?",
                                            " ",
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                                to: "/subcontractor-onboarding",
                                                className: "btn btn--link btn--sm",
                                                style: {
                                                    padding: 0,
                                                    verticalAlign: "baseline"
                                                },
                                                children: "Open Subcontractor Onboarding"
                                            }),
                                            " ",
                                            "to register it, then return here."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                className: "form-section-title",
                                children: "Engagement for this beneficiary"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field--full",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        children: "Work order / engagement letter (scan)"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        ref: fileInputRef,
                                        type: "file",
                                        accept: ".pdf,image/*",
                                        onChange: (e)=>{
                                            setLinkError(null);
                                            const f = e.target.files?.[0];
                                            updateSubcontractor(app.id, {
                                                workOrderFileName: f?.name ?? null
                                            });
                                        }
                                    }),
                                    link.workOrderFileName ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                        className: "text-muted file-hint",
                                        children: [
                                            "On file: ",
                                            link.workOrderFileName
                                        ]
                                    }) : null,
                                    link.workOrderFileStored ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "text-muted file-hint",
                                        style: {
                                            marginTop: "0.5rem"
                                        },
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d3365114b8e87556$export$91ad24bb00ba0809), {
                                            fileUrlBase: workOrderFileApiBase,
                                            fallbackFileName: link.workOrderFileName ?? "work-order"
                                        })
                                    }) : null
                                ]
                            }),
                            link.workOrderFileStored ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted section-lead section-lead--tight",
                                children: "Work order is stored on the server. Use Download or View above, or choose a new file to replace it. Firm details stay under Subcontractor Onboarding."
                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "section-lead section-lead--tight",
                                children: "Required: a firm selected from the onboarded list (firm must have full KYC on file \u2014 Aadhaar, bank, and documents \u2014 under Subcontractor Onboarding). Work order upload is optional."
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "toolbar-row",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--primary btn--tg btn--lg",
                                    onClick: ()=>{
                                        (async ()=>{
                                            setLinkError(null);
                                            const master = (0, $85279307e2bde4bc$export$87d4bc3ee3ec5ea2)(subcontractorMasters, link.subcontractorMasterId);
                                            let filePayload;
                                            const f = fileInputRef.current?.files?.[0];
                                            if (f) try {
                                                const r = await (0, $b5ec052719425bb9$export$ff9a6fde0c58ad20)(f);
                                                filePayload = {
                                                    workOrderFileBase64: r.base64,
                                                    workOrderMimeType: r.mimeType
                                                };
                                            } catch  {
                                                setLinkError("Could not read the selected file.");
                                                return;
                                            }
                                            const effective = filePayload ? {
                                                ...link,
                                                ...filePayload
                                            } : link;
                                            if (!(0, $85279307e2bde4bc$export$148e14a666d94fa1)(effective, master)) {
                                                setLinkError("Choose a subcontractor from the onboarded list. Register the firm under Subcontractor Onboarding first if it is not listed.");
                                                return;
                                            }
                                            await finalizeSubcontractor(app.id, filePayload);
                                        })();
                                    },
                                    children: app.status === "subcontractor_linked" ? "Update subcontractor linkage" : "Record subcontractor against beneficiary"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");




function $b52528b2eb87f947$export$66d223550253d428(value, onChange, id) {
    const s = value === null ? "" : value ? "yes" : "no";
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
        id: id,
        value: s,
        onChange: (e)=>{
            const v = e.target.value;
            onChange(v === "" ? null : v === "yes");
        },
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                value: "",
                children: "Not checked"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                value: "yes",
                children: "Verified / OK"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                value: "no",
                children: "Issue / mismatch"
            })
        ]
    });
}
function $b52528b2eb87f947$export$8c495cec71eb46c7(value, onChange, id) {
    const s = value === null ? "" : value === "need_to_apply" ? "need_apply" : value ? "yes" : "no";
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
        id: id,
        value: s,
        onChange: (e)=>{
            const v = e.target.value;
            if (v === "") onChange(null);
            else if (v === "yes") onChange(true);
            else if (v === "need_apply") onChange("need_to_apply");
            else onChange(false);
        },
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                value: "",
                children: "Not checked"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                value: "yes",
                children: "Verified / OK"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                value: "need_apply",
                children: "Need to Be Applied"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                value: "no",
                children: "Issue / mismatch"
            })
        ]
    });
}



function $e8008bc9950c8a77$export$e2083a0aff1d7813() {
    const { id: id } = (0, $265aeae2597a9f58$export$99eaa27ddbbb95ef)();
    const { getById: getById, updateValidations: updateValidations, setHoldReasons: setHoldReasons, confirmSeeding: confirmSeeding } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const app = id ? getById(id) : undefined;
    const [seedingModal, setSeedingModal] = (0, $7UyaH.useState)(false);
    if (!app) return null;
    const v = app.validations;
    const coreBlocking = v.nameMatchAcrossSources !== true || v.aadhaarVerified !== true || v.bankAccountVerified !== true || !(0, $3655432918d5e89d$export$563fe0138d49a54b)(v.workmanCardAcceptable);
    const syncHoldFromRules = ()=>{
        const reasons = [];
        if (v.nameMatchAcrossSources === false) reasons.push("Beneficiary name does not match exactly across Aadhaar, bank records, and sanction copy \u2014 on hold until rectified.");
        if (v.workmanCardAcceptable === false) reasons.push("Workman card not acceptable or missing \u2014 on hold until a valid card is received.");
        setHoldReasons(app.id, reasons);
    };
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "tab-intro",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "What you do here:"
                    }),
                    " Record each check using the dropdowns. If something is wrong, choose \u201CIssue / mismatch\u201D and use the button to put the file on hold with a clear reason. When everything is OK, confirm Aadhaar seeding \u2014 then you can open the ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "ICICI & MOU"
                    }),
                    " tab."
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        children: "Checklist (mark each item)"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("ul", {
                        className: "checklist",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "checklist__body",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                children: "Name match"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                className: "checklist__hint",
                                                children: "Must match exactly across Aadhaar, bank, and sanction copy."
                                            })
                                        ]
                                    }),
                                    (0, $b52528b2eb87f947$export$66d223550253d428)(v.nameMatchAcrossSources, (nv)=>void updateValidations(app.id, {
                                            nameMatchAcrossSources: nv
                                        }), "name")
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "checklist__body",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                children: "Aadhaar number"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                className: "checklist__hint",
                                                children: "Verify and correct through official process if wrong."
                                            })
                                        ]
                                    }),
                                    (0, $b52528b2eb87f947$export$66d223550253d428)(v.aadhaarVerified, (nv)=>void updateValidations(app.id, {
                                            aadhaarVerified: nv
                                        }), "aadhaar")
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "checklist__body",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                children: "Bank account number"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                className: "checklist__hint",
                                                children: "Verify against passbook / bank records."
                                            })
                                        ]
                                    }),
                                    (0, $b52528b2eb87f947$export$66d223550253d428)(v.bankAccountVerified, (nv)=>void updateValidations(app.id, {
                                            bankAccountVerified: nv
                                        }), "bank")
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "checklist__body",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                children: "Workman card"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                className: "checklist__hint",
                                                children: "If not available, place file on hold until received."
                                            })
                                        ]
                                    }),
                                    (0, $b52528b2eb87f947$export$8c495cec71eb46c7)(v.workmanCardAcceptable, (nv)=>void updateValidations(app.id, {
                                            workmanCardAcceptable: nv
                                        }), "wm")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "toolbar-row",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--primary btn--tg",
                                onClick: syncHoldFromRules,
                                children: "Set \u201Con hold\u201D from checklist (if any item is \u201CIssue\u201D)"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--tg-secondary",
                                onClick: ()=>void setHoldReasons(app.id, []),
                                disabled: app.holdReasons.length === 0,
                                children: "Remove all hold reasons"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        children: "Aadhaar seeding \u2014 final OK before banking"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "section-lead",
                        children: "Only tick this after the checklist above is complete. A short confirmation window will open; after you confirm, the ICICI tab unlocks."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "page-meta",
                        children: [
                            "Status:",
                            " ",
                            v.aadhaarSeedingConfirmed ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "badge badge--ok",
                                children: "Confirmed"
                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "badge badge--pending",
                                children: "Not confirmed"
                            }),
                            v.seedingConfirmedAt ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "mono text-muted",
                                style: {
                                    marginLeft: "0.5rem",
                                    fontSize: "0.8125rem"
                                },
                                children: v.seedingConfirmedAt
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--primary btn--tg",
                        onClick: ()=>setSeedingModal(true),
                        disabled: v.aadhaarSeedingConfirmed || coreBlocking,
                        children: "I confirm Aadhaar seeding (opens confirmation)"
                    }),
                    coreBlocking ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-warning",
                        style: {
                            fontSize: "0.8125rem",
                            marginTop: "0.75rem"
                        },
                        children: "Complete all checkpoints positively before seeding confirmation."
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $061b372afdec2b67$export$2dd8a0472fc8dd3f), {
                open: seedingModal,
                title: "Confirm Aadhaar seeding",
                body: "I confirm that Aadhaar seeding has been verified for this beneficiary as per programme rules. ICICI banking details shall not be entered until this confirmation is recorded.",
                confirmLabel: "Record confirmation",
                onCancel: ()=>setSeedingModal(false),
                onConfirm: ()=>{
                    (async ()=>{
                        try {
                            await confirmSeeding(app.id);
                        } catch  {
                        /* confirmSeeding shows error toast */ } finally{
                            setSeedingModal(false);
                        }
                    })();
                }
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");





var $7UyaH = parcelRequire("7UyaH");



function $6e0ebd679bab8d2f$var$xmlEscape(s) {
    return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;");
}
function $6e0ebd679bab8d2f$var$svgPlaceholder(phaseTitle, slot, rowHue) {
    const slotShift = slot === 1 ? 0 : slot === 2 ? 18 : -14;
    const h = ((rowHue + slotShift) % 360 + 360) % 360;
    const title = $6e0ebd679bab8d2f$var$xmlEscape(phaseTitle.trim().slice(0, 28) || "Phase");
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="140" viewBox="0 0 200 140">
<rect fill="hsl(${h} 48% 88%)" width="200" height="140"/>
<rect x="12" y="12" width="176" height="116" rx="6" fill="hsl(${h} 42% 96%)" stroke="hsl(${h} 35% 70%)" stroke-width="1.5"/>
<text x="100" y="58" text-anchor="middle" font-family="system-ui,Segoe UI,sans-serif" font-size="12" font-weight="700" fill="#0f172a">${title}</text>
<text x="100" y="82" text-anchor="middle" font-family="system-ui,Segoe UI,sans-serif" font-size="11" fill="#475569">Sample portal photo ${slot}</text>
<text x="100" y="104" text-anchor="middle" font-family="system-ui,Segoe UI,sans-serif" font-size="9.5" fill="#64748b">Timeline master preview only</text>
</svg>`;
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
function $6e0ebd679bab8d2f$export$3f36d6d90c29dfc3(phases) {
    const out = {};
    for(let i = 0; i < phases.length; i += 1){
        const p = phases[i];
        const hue = i * 47 % 360;
        out[p.id] = {
            photo1: $6e0ebd679bab8d2f$var$svgPlaceholder(p.title, 1, hue),
            photo2: $6e0ebd679bab8d2f$var$svgPlaceholder(p.title, 2, hue),
            photo3: $6e0ebd679bab8d2f$var$svgPlaceholder(p.title, 3, hue)
        };
    }
    return out;
}
function $6e0ebd679bab8d2f$export$298cc1398c0182cb(b) {
    if (!b) return false;
    return Boolean(b.photo1 && b.photo1.length > 12 || b.photo2 && b.photo2.length > 12 || b.photo3 && b.photo3.length > 12);
}


function $9fd373c1f367b8f0$var$formatApproxDays(days) {
    const n = days < 10 ? String(days).padStart(2, "0") : String(days);
    return `Approx ${n} days`;
}
function $9fd373c1f367b8f0$var$GanttPortalThumbStrip({ bundle: bundle }) {
    if (!bundle) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "beneficiary-gantt__portal-dash",
        "aria-hidden": true,
        children: "\u2014"
    });
    const urls = [
        bundle.photo1,
        bundle.photo2,
        bundle.photo3
    ].filter((u)=>typeof u === "string" && u.length > 12);
    if (urls.length === 0) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "beneficiary-gantt__portal-dash",
        "aria-hidden": true,
        children: "\u2014"
    });
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
        className: "beneficiary-gantt__portal-thumb-strip",
        children: urls.map((src, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("a", {
                href: src,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "beneficiary-gantt__portal-thumb",
                title: `Open subcontractor portal photo ${i + 1}`,
                "aria-label": `Open subcontractor portal photo ${i + 1} full size`,
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                    src: src,
                    alt: ""
                })
            }, i))
    });
}
function $9fd373c1f367b8f0$export$2d757ab5570a0ed6({ phases: phases, actualDays: actualDays, preview: preview, phasePortalPhotos: phasePortalPhotos }) {
    const sorted = (0, $7UyaH.useMemo)(()=>(0, $d0dce9c7337efc65$export$107c6562c1e7acbf)(phases), [
        phases
    ]);
    const planTotal = (0, $d0dce9c7337efc65$export$4ef55ade8bc0483f)(sorted);
    const loggedTotalForAxis = (0, $7UyaH.useMemo)(()=>{
        let sum = 0;
        let any = false;
        for (const p of sorted){
            const raw = actualDays[p.id];
            if (typeof raw === "number" && Number.isFinite(raw) && raw >= 0) {
                sum += raw;
                any = true;
            }
        }
        return any ? sum : undefined;
    }, [
        sorted,
        actualDays
    ]);
    const { axisMax: axisMax, ticks: ticks } = (0, $7UyaH.useMemo)(()=>(0, $d0dce9c7337efc65$export$df32fb333183f243)(planTotal, {
            loggedTotalDays: loggedTotalForAxis
        }), [
        planTotal,
        loggedTotalForAxis
    ]);
    const rows = (0, $7UyaH.useMemo)(()=>{
        let cum = 0;
        return sorted.map((p)=>{
            const approx = Math.max(0, Math.floor(Number(p.approxDays)) || 0);
            const leftPct = axisMax > 0 ? cum / axisMax * 100 : 0;
            const widthPct = axisMax > 0 ? approx / axisMax * 100 : 0;
            cum += approx;
            const raw = actualDays[p.id];
            const actual = typeof raw === "number" && Number.isFinite(raw) && raw >= 0 ? raw : null;
            return {
                ...p,
                approxDays: approx,
                leftPct: leftPct,
                widthPct: widthPct,
                actual: actual
            };
        });
    }, [
        sorted,
        actualDays,
        axisMax
    ]);
    let actualSum = 0;
    let approxSumComparable = 0;
    let phasesWithActual = 0;
    for (const r of rows)if (r.actual != null) {
        actualSum += r.actual;
        approxSumComparable += r.approxDays;
        phasesWithActual += 1;
    }
    const varianceRecorded = phasesWithActual > 0 ? actualSum - approxSumComparable : null;
    const phaseCount = sorted.length;
    const hasPortalPhotoColumn = (0, $7UyaH.useMemo)(()=>{
        if (!phasePortalPhotos) return false;
        for (const b of Object.values(phasePortalPhotos)){
            if ((0, $6e0ebd679bab8d2f$export$298cc1398c0182cb)(b)) return true;
        }
        return false;
    }, [
        phasePortalPhotos
    ]);
    if (phaseCount === 0) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "beneficiary-gantt beneficiary-gantt--empty",
        role: "status",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "beneficiary-gantt__chart-title",
                children: "Timeline tracking: Approx vs actual (days)"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "text-muted section-lead section-lead--tight",
                children: [
                    "No construction levels defined yet. Add levels and approximate days under",
                    " ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Projects \u2192 Timeline master"
                    }),
                    " to build the Gantt chart."
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "beneficiary-gantt",
        role: "img",
        "aria-label": `Construction timeline approx ${planTotal} days total plan`,
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "beneficiary-gantt__chart-title",
                children: "Timeline tracking: Approx vs actual (days)"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "beneficiary-gantt__duration",
                children: [
                    "Approx plan duration: ",
                    planTotal,
                    " days"
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "beneficiary-gantt__metrics",
                role: "region",
                "aria-label": "Approx versus actual summary",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "beneficiary-gantt__metric",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "beneficiary-gantt__metric-label",
                                children: "Approx total (plan)"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                className: "beneficiary-gantt__metric-value",
                                children: [
                                    planTotal,
                                    " d"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "beneficiary-gantt__metric",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "beneficiary-gantt__metric-label",
                                children: "Actual total (logged)"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                className: "beneficiary-gantt__metric-value",
                                children: [
                                    phasesWithActual > 0 ? `${actualSum} d` : "\u2014",
                                    phasesWithActual > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                        className: "beneficiary-gantt__metric-sub",
                                        children: [
                                            " ",
                                            "(",
                                            phasesWithActual,
                                            "/",
                                            phaseCount,
                                            " phases)"
                                        ]
                                    }) : preview ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "beneficiary-gantt__metric-sub",
                                        children: " Plan preview"
                                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "beneficiary-gantt__metric-sub",
                                        children: " No site data yet"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "beneficiary-gantt__metric",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "beneficiary-gantt__metric-label",
                                children: "Variance (on logged phases)"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "beneficiary-gantt__metric-value" + (varianceRecorded == null ? "" : varianceRecorded > 0 ? " beneficiary-gantt__metric-value--behind" : varianceRecorded < 0 ? " beneficiary-gantt__metric-value--ahead" : " beneficiary-gantt__metric-value--neutral"),
                                children: varianceRecorded == null ? "\u2014" : `${varianceRecorded > 0 ? "+" : ""}${varianceRecorded} d ${varianceRecorded > 0 ? "(slower)" : varianceRecorded < 0 ? "(faster)" : "(on plan)"}`
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "beneficiary-gantt__scroll",
                role: "region",
                "aria-label": "Timeline chart \u2014 scroll horizontally to see the full axis and labels",
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "beneficiary-gantt__body" + (hasPortalPhotoColumn ? " beneficiary-gantt__body--with-portal-photos" : ""),
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "beneficiary-gantt__labels",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "beneficiary-gantt__corner",
                                    "aria-hidden": true
                                }),
                                rows.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "beneficiary-gantt__label",
                                        children: r.title
                                    }, r.id))
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "beneficiary-gantt__tracks",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "beneficiary-gantt__axis",
                                    children: ticks.map((d)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "beneficiary-gantt__tick",
                                            style: {
                                                left: `${axisMax > 0 ? d / axisMax * 100 : 0}%`
                                            },
                                            children: d
                                        }, d))
                                }),
                                rows.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "beneficiary-gantt__track",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                className: "beneficiary-gantt__bar" + (r.actual != null ? " beneficiary-gantt__bar--has-actual" : ""),
                                                style: {
                                                    left: `${r.leftPct}%`,
                                                    width: `${r.widthPct}%`
                                                },
                                                "aria-hidden": true
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                className: "beneficiary-gantt__caption",
                                                style: {
                                                    left: `calc(${r.leftPct}% + ${r.widthPct}% + 0.35rem)`
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "beneficiary-gantt__cap-approx",
                                                        children: $9fd373c1f367b8f0$var$formatApproxDays(r.approxDays)
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "beneficiary-gantt__cap-sep",
                                                        "aria-hidden": true,
                                                        children: " \xb7 "
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                        className: "beneficiary-gantt__cap-actual",
                                                        children: [
                                                            "Actual ",
                                                            r.actual == null ? "\u2014" : `${r.actual} d`
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, r.id))
                            ]
                        }),
                        hasPortalPhotoColumn ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "beneficiary-gantt__portal-photos",
                            "aria-label": "Subcontractor portal photos by phase",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "beneficiary-gantt__corner beneficiary-gantt__portal-photos__corner",
                                    "aria-hidden": true
                                }),
                                rows.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "beneficiary-gantt__photo-cell",
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($9fd373c1f367b8f0$var$GanttPortalThumbStrip, {
                                            bundle: phasePortalPhotos?.[r.id]
                                        })
                                    }, r.id))
                            ]
                        }) : null
                    ]
                })
            })
        ]
    });
}
function $9fd373c1f367b8f0$export$68caba599735c292({ app: app }) {
    const { constructionTimelinePhases: constructionTimelinePhases } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const sorted = (0, $7UyaH.useMemo)(()=>(0, $d0dce9c7337efc65$export$107c6562c1e7acbf)(constructionTimelinePhases), [
        constructionTimelinePhases
    ]);
    const [phasePortalPhotos, setPhasePortalPhotos] = (0, $7UyaH.useState)({});
    (0, $7UyaH.useEffect)(()=>{
        let cancelled = false;
        (0, $63ae46da6580a2c7$export$1a54a9a56e65f53e)(app.id).then((rows)=>{
            if (cancelled) return;
            const m = {};
            for (const r of rows)if (r.photo_data || r.photo_data_2 || r.photo_data_3) m[r.timeline_phase_id] = {
                photo1: r.photo_data,
                photo2: r.photo_data_2,
                photo3: r.photo_data_3
            };
            setPhasePortalPhotos(m);
        }).catch(()=>{
            if (!cancelled) setPhasePortalPhotos({});
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        app.id
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($9fd373c1f367b8f0$export$2d757ab5570a0ed6, {
        phases: sorted,
        actualDays: app.constructionTimelineActualDays ?? {},
        phasePortalPhotos: phasePortalPhotos
    });
}



/** Add `days` calendar days to a YYYY-MM-DD string and return formatted date. */ function $c7240461df7259b1$var$addDays(dateStr, days) {
    const d = new Date(dateStr + "T00:00:00");
    d.setDate(d.getDate() + days);
    return d.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric"
    });
}
function $c7240461df7259b1$var$fmtDate(d) {
    return new Date(d + "T00:00:00").toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric"
    });
}
function $c7240461df7259b1$export$d395bb482f7c143f() {
    const { id: id } = (0, $265aeae2597a9f58$export$99eaa27ddbbb95ef)();
    const { getById: getById, constructionTimelinePhases: constructionTimelinePhases, refreshApplicationsFromApi: refreshApplicationsFromApi } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const app = id ? getById(id) : undefined;
    (0, $7UyaH.useEffect)(()=>{
        refreshApplicationsFromApi();
    }, [
        id,
        refreshApplicationsFromApi
    ]);
    const sortedPhases = (0, $7UyaH.useMemo)(()=>(0, $d0dce9c7337efc65$export$107c6562c1e7acbf)(constructionTimelinePhases), [
        constructionTimelinePhases
    ]);
    const [phasePortalPhotos, setPhasePortalPhotos] = (0, $7UyaH.useState)({});
    (0, $7UyaH.useEffect)(()=>{
        if (!app?.id) {
            setPhasePortalPhotos({});
            return;
        }
        let cancelled = false;
        (0, $63ae46da6580a2c7$export$1a54a9a56e65f53e)(app.id).then((rows)=>{
            if (cancelled) return;
            const m = {};
            for (const r of rows)if (r.photo_data || r.photo_data_2 || r.photo_data_3) m[r.timeline_phase_id] = {
                photo1: r.photo_data,
                photo2: r.photo_data_2,
                photo3: r.photo_data_3
            };
            setPhasePortalPhotos(m);
        }).catch(()=>{
            if (!cancelled) setPhasePortalPhotos({});
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        app?.id
    ]);
    if (!app) return null;
    const actualDays = app.constructionTimelineActualDays ?? {};
    const actualDates = app.constructionTimelineActualDates ?? {};
    const actualStartDates = app.constructionTimelineActualStartDates ?? {};
    const plannedStart = app.plannedStartDate ?? null;
    // Build phase calendar schedule with planned + actual start/end dates
    let cumulativeDays = 0;
    const phaseSchedule = plannedStart ? sortedPhases.map((p)=>{
        const approx = Math.max(0, Math.floor(Number(p.approxDays)) || 0);
        const plannedStartDate = $c7240461df7259b1$var$addDays(plannedStart, cumulativeDays);
        cumulativeDays += approx;
        const plannedEndDate = $c7240461df7259b1$var$addDays(plannedStart, cumulativeDays);
        const rawActual = actualDays[p.id];
        const actual = typeof rawActual === "number" && rawActual >= 0 ? rawActual : null;
        // Actual end = approval date stored from timeline approval
        const actualEndRaw = actualDates[p.id] ?? null;
        const actualEndDate = actualEndRaw ? $c7240461df7259b1$var$fmtDate(actualEndRaw) : null;
        // Actual start = date saved by subcontractor via set-phase-start (authoritative)
        const actualStartRaw = actualStartDates[p.id] ?? null;
        const actualStartDate = actualStartRaw ? $c7240461df7259b1$var$fmtDate(actualStartRaw) : null;
        return {
            phase: p,
            plannedStartDate: plannedStartDate,
            plannedEndDate: plannedEndDate,
            approx: approx,
            actual: actual,
            actualStartDate: actualStartDate,
            actualEndDate: actualEndDate
        };
    }) : [];
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "tab-intro",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Construction work progress"
                    }),
                    " for this beneficiary \u2014 tracked against the master construction timeline. The Gantt chart below shows planned vs. actual progress for each phase."
                ]
            }),
            plannedStart ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "wp-start-banner",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "wp-start-banner__icon",
                        children: "\uD83D\uDCC5"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "wp-start-banner__label",
                                children: "Project start date"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "wp-start-banner__date",
                                children: $c7240461df7259b1$var$fmtDate(plannedStart)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "wp-start-banner__note",
                        children: "Phase dates below are calculated from this anchor."
                    })
                ]
            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "wp-start-banner wp-start-banner--unset",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "wp-start-banner__icon",
                        children: "\u26A0\uFE0F"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "wp-start-banner__label",
                                children: "No planned start date set"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                className: "wp-start-banner__note",
                                children: [
                                    "Set a start date on the",
                                    " ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                        to: "/project-initiation",
                                        className: "link",
                                        children: "Project Initiation"
                                    }),
                                    " ",
                                    "page to unlock calendar-based phase tracking."
                                ]
                            })
                        ]
                    })
                ]
            }),
            plannedStart && phaseSchedule.length > 0 && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--elevated",
                style: {
                    marginBottom: "1.5rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        style: {
                            marginBottom: "0.75rem"
                        },
                        children: "\uD83D\uDCC6 Phase Calendar Schedule"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "table-wrap",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                            className: "data-table",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "#"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Phase"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                className: "geo-reports__num",
                                                children: "Planned Days"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Planned Start"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Planned End"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Actual Start"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Actual End"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                className: "geo-reports__num",
                                                children: "Actual Days"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Variance"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                    children: phaseSchedule.map(({ phase: phase, plannedStartDate: plannedStartDate, plannedEndDate: plannedEndDate, approx: approx, actual: actual, actualStartDate: actualStartDate, actualEndDate: actualEndDate }, idx)=>{
                                        const variance = actual !== null ? actual - approx : null;
                                        return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "text-muted",
                                                    children: idx + 1
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    style: {
                                                        fontWeight: 500
                                                    },
                                                    children: phase.title
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "geo-reports__num",
                                                    children: approx
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    style: {
                                                        fontSize: "0.8125rem"
                                                    },
                                                    children: plannedStartDate
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    style: {
                                                        fontSize: "0.8125rem",
                                                        color: "#64748b"
                                                    },
                                                    children: plannedEndDate
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    style: {
                                                        fontSize: "0.8125rem",
                                                        color: actualStartDate ? "#0f172a" : undefined
                                                    },
                                                    children: actualStartDate ?? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "text-muted",
                                                        children: "\u2014"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    style: {
                                                        fontSize: "0.8125rem",
                                                        color: actualEndDate ? "#0891b2" : undefined
                                                    },
                                                    children: actualEndDate ?? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "text-muted",
                                                        children: "\u2014"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "geo-reports__num",
                                                    children: actual !== null ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        style: {
                                                            fontWeight: 600,
                                                            color: "#0891b2"
                                                        },
                                                        children: actual
                                                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "text-muted",
                                                        children: "\u2014"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: variance !== null ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                        style: {
                                                            fontWeight: 600,
                                                            color: variance > 0 ? "#dc2626" : variance < 0 ? "#16a34a" : "#64748b"
                                                        },
                                                        children: [
                                                            variance > 0 ? `+${variance}` : variance,
                                                            " days"
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "text-muted",
                                                        children: "\u2014"
                                                    })
                                                })
                                            ]
                                        }, phase.id);
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--elevated beneficiary-dedicated-hub__panel beneficiary-dedicated-hub__panel--gantt",
                style: {
                    marginBottom: "1.5rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        style: {
                            marginBottom: "0.5rem"
                        },
                        children: "\uD83D\uDCCA Construction Timeline \u2014 Gantt Chart"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $9fd373c1f367b8f0$export$2d757ab5570a0ed6), {
                        phases: sortedPhases,
                        actualDays: actualDays,
                        phasePortalPhotos: phasePortalPhotos
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");




async function $f5510818538731b9$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        const parts = [];
        if (j.error) parts.push(j.error);
        if (j.message && j.message !== j.error) parts.push(j.message);
        if (j.details) parts.push(j.details);
        if (parts.length) return parts.join("\n\n");
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
async function $f5510818538731b9$export$d79967131f9910f3(limit = 250) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/mrr/po-completed?limit=${encodeURIComponent(String(limit))}`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$4c771fbbb79c5d4(mrrId) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/mrr/${encodeURIComponent(String(mrrId))}`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$abe2a11dadd4d940(mrrId, body) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/mrr/${encodeURIComponent(String(mrrId))}/goods-receipt`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$c8944828706cd19f(query = {}) {
    const q = typeof query === "number" ? {
        limit: query
    } : query;
    const params = new URLSearchParams();
    const lim = Math.min(2000, Math.max(1, q.limit ?? 1500));
    params.set("limit", String(lim));
    if (q.storeYardId?.trim()) params.set("storeYardId", q.storeYardId.trim());
    if (q.search?.trim()) params.set("search", q.search.trim());
    if (q.from?.trim()) params.set("from", q.from.trim());
    if (q.to?.trim()) params.set("to", q.to.trim());
    if (q.sort === "asc" || q.sort === "desc") params.set("sort", q.sort);
    if (typeof q.mrrId === "number" && Number.isFinite(q.mrrId) && q.mrrId > 0) params.set("mrrId", String(Math.floor(q.mrrId)));
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/mrr-goods-receipts?${params.toString()}`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$36c62f76a556253(receiptId) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/mrr-goods-receipts/${encodeURIComponent(receiptId)}`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$684057024fdd9083(storeYardId) {
    const q = storeYardId && storeYardId.trim() ? `?storeYardId=${encodeURIComponent(storeYardId.trim())}` : "";
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/store-stocks${q}`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$8fe1afdbf49dcb49(storeYardId) {
    const q = storeYardId && storeYardId.trim() ? `?storeYardId=${encodeURIComponent(storeYardId.trim())}` : "";
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/store-audit-worksheet${q}`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$baa128ccfbdcbc9f(payload) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/store-audit-worksheet`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            storeYardId: payload.storeYardId?.trim() || "",
            physicalByRow: payload.physicalByRow,
            remarkByRow: payload.remarkByRow
        })
    });
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$36d59bdb7dee965(q = {}) {
    const params = new URLSearchParams();
    const lim = Math.min(2000, Math.max(1, q.limit ?? 800));
    params.set("limit", String(lim));
    if (q.storeYardId?.trim()) params.set("storeYardId", q.storeYardId.trim());
    if (q.subcontractorMasterId?.trim()) params.set("subcontractorMasterId", q.subcontractorMasterId.trim());
    if (q.search?.trim()) params.set("search", q.search.trim());
    if (q.sort === "asc" || q.sort === "desc") params.set("sort", q.sort);
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/store-outward?${params.toString()}`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$197c5a0b9398f99a() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/store-outward/analytics`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$8ae7398780b7bae5(q = {}) {
    const params = new URLSearchParams();
    const lim = Math.min(2000, Math.max(1, q.limit ?? 800));
    params.set("limit", String(lim));
    if (q.applicationId?.trim()) params.set("applicationId", q.applicationId.trim());
    if (q.milestoneTemplateId?.trim()) params.set("milestoneTemplateId", q.milestoneTemplateId.trim());
    if (q.subcontractorMasterId?.trim()) params.set("subcontractorMasterId", q.subcontractorMasterId.trim());
    if (q.status === "pending" || q.status === "partial" || q.status === "completed") params.set("status", q.status);
    if (q.search?.trim()) params.set("search", q.search.trim());
    if (q.sort === "asc" || q.sort === "desc") params.set("sort", q.sort);
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/issue-material?${params.toString()}`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$3e57dfaa18cba007(q = {}) {
    const params = new URLSearchParams();
    const lim = Math.min(3000, Math.max(1, q.limit ?? 1500));
    params.set("limit", String(lim));
    if (q.applicationId?.trim()) params.set("applicationId", q.applicationId.trim());
    if (q.subcontractorMasterId?.trim()) params.set("subcontractorMasterId", q.subcontractorMasterId.trim());
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/issue-material/pending-outward?${params.toString()}`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$9e1eaee4574c732d(body) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/issue-material/generate`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$3a7b1232eff56131(body) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/issue-material/generate-from-po`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$58fee83dffed35e8(issueId, body) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/issue-material/${encodeURIComponent(issueId)}/dispatch`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$18d330c1cfaace8d(body) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/issue-material/dispatch-otp/send`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$87339d226f8794b1(body) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/issue-material/dispatch-otp/confirm`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$a0f770912cdc0acb(body) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/issue-po/generate`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$c31671a30009576(poId) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/issue-po/${encodeURIComponent(poId)}/cancel`, {
        method: "POST"
    });
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$66d2f4464228f385(poId) {
    const result = await $f5510818538731b9$export$c31671a30009576(poId);
    return {
        ok: true,
        deletedIssueMaterialRows: result.removedIssueMaterialRows
    };
}
async function $f5510818538731b9$export$c07542c0e6c2ce3d(applicationIds) {
    const ids = [
        ...new Set(applicationIds.map((x)=>String(x).trim()).filter(Boolean))
    ];
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/issue-po/blocked-milestones`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            applicationIds: ids
        })
    });
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$c174743d83e21f46(q) {
    const applicationIds = [
        ...new Set(q.applicationIds.map((x)=>String(x).trim()).filter(Boolean))
    ];
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/issue-po/remaining-qty-by-item`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            milestoneTemplateId: q.milestoneTemplateId.trim(),
            applicationIds: applicationIds
        })
    });
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$199cc1209b09073e(q = {}) {
    const params = new URLSearchParams();
    const lim = Math.min(2000, Math.max(1, q.limit ?? 500));
    params.set("limit", String(lim));
    if (q.subcontractorMasterId?.trim()) params.set("subcontractorMasterId", q.subcontractorMasterId.trim());
    if (q.milestoneTemplateId?.trim()) params.set("milestoneTemplateId", q.milestoneTemplateId.trim());
    if (q.search?.trim()) params.set("search", q.search.trim());
    if (q.sort === "asc" || q.sort === "desc") params.set("sort", q.sort);
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/issue-po?${params.toString()}`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$ac344e3ef6210f97() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/issue-po/analytics`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$104fbd1210c34e9d() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/issue-material/analytics`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$49a2b5a16b830ea4(poId) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/issue-po/${encodeURIComponent(poId)}/items`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$25b6d24a4efb2b0b(body) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/store-outward`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$f3dca58bae5bbc47(body) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/store-inward`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$e1c899c5a3ced486() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/store-inward/open-po-ids`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    const data = await res.json();
    return Array.isArray(data.poIds) ? data.poIds : [];
}
async function $f5510818538731b9$export$3a64cece2dbaba22(poId) {
    const pid = poId.trim();
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/store-inward/po-receipt-balance/${encodeURIComponent(pid)}`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$3d876b601a2feeb() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/issue-material/open-po-ids-for-issue`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    const data = await res.json();
    return Array.isArray(data.poIds) ? data.poIds : [];
}
async function $f5510818538731b9$export$54291f157608c7ce(poId) {
    const pid = poId.trim();
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/issue-material/po-issue-balance/${encodeURIComponent(pid)}`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}
async function $f5510818538731b9$export$4661dba8bff6ca9(q = {}) {
    const params = new URLSearchParams();
    const lim = Math.min(2000, Math.max(1, q.limit ?? 1500));
    params.set("limit", String(lim));
    if (q.storeYardId?.trim()) params.set("storeYardId", q.storeYardId.trim());
    if (q.search?.trim()) params.set("search", q.search.trim());
    if (q.from?.trim()) params.set("from", q.from.trim());
    if (q.to?.trim()) params.set("to", q.to.trim());
    if (q.sort === "asc" || q.sort === "desc") params.set("sort", q.sort);
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/store-inward?${params.toString()}`);
    if (!res.ok) throw new Error(await $f5510818538731b9$var$parseError(res));
    return res.json();
}


function $386b0bb84b222876$export$f64179ddc9de5087(items) {
    const map = new Map();
    for (const it of items){
        const key = `${it.standardResourceItemId}::${it.catalogStandardItemId}`;
        const cur = map.get(key);
        if (cur) cur.totalQty += it.plannedQty;
        else map.set(key, {
            key: key,
            resourceItemLabel: it.resourceItemLabel,
            standardResourceTitle: it.standardResourceTitle,
            catalogStandardItemId: it.catalogStandardItemId,
            resourceItemUnit: it.resourceItemUnit,
            totalQty: it.plannedQty,
            rate: it.resourceItemRate ?? 0,
            hsnCode: (it.hsnCode ?? "").trim()
        });
    }
    return [
        ...map.values()
    ].sort((a, b)=>a.resourceItemLabel.localeCompare(b.resourceItemLabel));
}
function $386b0bb84b222876$export$50b7d8ff82608f41(items) {
    return [
        ...items
    ].sort((a, b)=>{
        const bn = (a.beneficiaryName ?? "").localeCompare(b.beneficiaryName ?? "");
        if (bn !== 0) return bn;
        return a.resourceItemLabel.localeCompare(b.resourceItemLabel);
    }).map((it)=>({
            key: it.id,
            resourceItemLabel: it.resourceItemLabel,
            standardResourceTitle: it.standardResourceTitle,
            beneficiaryName: it.beneficiaryName ?? it.applicationId,
            catalogStandardItemId: it.catalogStandardItemId,
            resourceItemUnit: it.resourceItemUnit,
            totalQty: it.plannedQty,
            rate: it.resourceItemRate ?? 0,
            hsnCode: (it.hsnCode ?? "").trim()
        }));
}
function $386b0bb84b222876$export$b78eba57c6f719ba(items, geoByApplicationId) {
    const map = new Map();
    for (const it of items){
        const appKey = String(it.applicationId ?? "").trim() || `name::${(it.beneficiaryName ?? "").trim()}`;
        if (!map.has(appKey)) {
            const geo = geoByApplicationId?.get(String(it.applicationId ?? "").trim());
            map.set(appKey, {
                beneficiaryName: (it.beneficiaryName ?? "").trim() || "\u2014",
                applicationId: geo?.displayApplicationId ?? ((it.beneficiaryMobileApplicationId ?? "").trim() || appKey),
                district: geo?.district?.trim() || "\u2014",
                mandal: geo?.mandal?.trim() || "\u2014",
                village: geo?.village?.trim() || "\u2014",
                itemsMap: new Map()
            });
        }
        const row = map.get(appKey);
        const itemKey = `${it.standardResourceItemId}::${it.catalogStandardItemId}`;
        if (!row.itemsMap.has(itemKey)) row.itemsMap.set(itemKey, {
            label: it.resourceItemLabel,
            qty: 0,
            unit: it.resourceItemUnit
        });
        row.itemsMap.get(itemKey).qty += it.plannedQty;
    }
    return [
        ...map.values()
    ].map((row)=>({
            beneficiaryName: row.beneficiaryName,
            applicationId: row.applicationId,
            district: row.district,
            mandal: row.mandal,
            village: row.village,
            items: [
                ...row.itemsMap.values()
            ].sort((a, b)=>a.label.localeCompare(b.label))
        })).sort((a, b)=>a.beneficiaryName.localeCompare(b.beneficiaryName));
}
function $386b0bb84b222876$var$escHtml(s) {
    return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function $386b0bb84b222876$var$fmtInr(n) {
    if (!Number.isFinite(n)) return "0.00";
    return n.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
/** Resolve public paths to absolute URLs so logos render inside the PDF iframe. */ function $386b0bb84b222876$var$resolveAssetUrl(url) {
    const t = url.trim();
    if (!t) return "";
    if (/^https?:\/\//i.test(t) || t.startsWith("data:")) return t;
    if (typeof window !== "undefined" && window.location?.origin) return `${window.location.origin}${t.startsWith("/") ? t : `/${t}`}`;
    return t.startsWith("/") ? t : `/${t}`;
}
function $386b0bb84b222876$var$poAccentSafe(hex) {
    const t = hex.trim();
    if (/^#[0-9A-Fa-f]{6}$/.test(t)) return t;
    return "#16365f";
}
const $386b0bb84b222876$var$LEGACY_MISSING_LOGO_PATH = "/branding/Telangana-LOGO.png";
function $386b0bb84b222876$export$d24624a1ee66e259(url) {
    const t = url.trim();
    if (!t || t === $386b0bb84b222876$var$LEGACY_MISSING_LOGO_PATH) return "";
    return t;
}
function $386b0bb84b222876$var$logoCellHtml(url, heightPx) {
    const resolved = $386b0bb84b222876$var$resolveAssetUrl($386b0bb84b222876$export$d24624a1ee66e259(url));
    if (!resolved) return ``;
    const h = Math.min(160, Math.max(24, Math.round(heightPx)));
    return `<img src="${$386b0bb84b222876$var$escHtml(resolved)}" alt="" style="height:${h}px;max-width:100%;width:auto;object-fit:contain;display:inline-block;vertical-align:middle;" onerror="this.remove()" />`;
}
const $386b0bb84b222876$export$3bbfdff9b331a42f = {
    documentSubtitle: "Official purchase order",
    documentNumberLabel: "PO number",
    documentDateLabel: "PO date",
    vendorBlockTitle: "Vendor (supplier / subcontractor)",
    buyerBlockTitle: "Purchaser / company",
    shipToBlockTitle: "Ship to / site / delivery",
    signatoryLeftTitle: "Purchaser",
    signatoryRightTitle: "Vendor acknowledgement"
};
const $386b0bb84b222876$export$12f7be8231520394 = {
    documentSubtitle: "Tax invoice",
    documentNumberLabel: "Invoice number",
    documentDateLabel: "Invoice date",
    vendorBlockTitle: "Bill from (supplier / subcontractor)",
    buyerBlockTitle: "Bill to / company",
    shipToBlockTitle: "Reference / milestone / notes",
    signatoryLeftTitle: "For company",
    signatoryRightTitle: "Supplier signature"
};
const $386b0bb84b222876$export$9da41ad8ba909c87 = "This is a computer-generated purchase order and is valid without a physical signature. Amounts and GST are as per the details recorded at the time of generation.";
function $386b0bb84b222876$export$4ddeb3921011e5d3(params) {
    const pdfCap = Boolean(params.forPdfCapture);
    const labels = {
        ...$386b0bb84b222876$export$3bbfdff9b331a42f,
        ...params.labels
    };
    const accent = $386b0bb84b222876$var$poAccentSafe(params.accentColorHex);
    const logoLeft = $386b0bb84b222876$var$logoCellHtml(params.logoPrimaryUrl, params.logoPrimaryHeightPx);
    const logoRight = $386b0bb84b222876$var$logoCellHtml(params.logoSecondaryUrl, params.logoSecondaryHeightPx);
    const taglineBlock = params.letterheadTagline.trim() ? `<p class="po-tagline">${$386b0bb84b222876$var$escHtml(params.letterheadTagline.trim())}</p>` : "";
    const rows = params.lines.map((ln)=>`
    <tr class="po-line">
      <td class="c">${ln.sno}</td>
      <td class="l">
        <div class="desc">${$386b0bb84b222876$var$escHtml(ln.description)}</div>
        ${ln.subDescription.trim() ? `<div class="sub">${$386b0bb84b222876$var$escHtml(ln.subDescription)}</div>` : ""}
      </td>
      <td class="c mono">${$386b0bb84b222876$var$escHtml(ln.hsn || "\u2014")}</td>
      <td class="r mono">${$386b0bb84b222876$var$fmtInr(ln.qty)}</td>
      <td class="c">${$386b0bb84b222876$var$escHtml(ln.unit)}</td>
      <td class="r mono">${$386b0bb84b222876$var$fmtInr(ln.rate)}</td>
      <td class="r mono">${$386b0bb84b222876$var$fmtInr(ln.amount)}</td>
    </tr>`).join("");
    const gstRows = params.gstLines.map((g)=>`
    <tr class="po-total-band">
      <td colspan="6" class="r lbl">${$386b0bb84b222876$var$escHtml(g.label)} (${Number.isFinite(g.ratePercent) ? g.ratePercent : 0}%)</td>
      <td class="r mono">${$386b0bb84b222876$var$fmtInr(g.amount)}</td>
    </tr>`).join("");
    const footDefault = params.defaultFooterNote?.trim() || "This document was generated from the console. Amounts follow rates and GST entered at download.";
    const showSignatures = params.showSignatures !== false;
    return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="utf-8"/>
  <meta name="viewport" content="width=device-width, initial-scale=1"/>
  <title>${$386b0bb84b222876$var$escHtml(params.documentTitle)} ${$386b0bb84b222876$var$escHtml(params.poNumber)}</title>
  <style>
    ${pdfCap ? `/* PDF capture: system fonts only \u{2014} avoids blocking @import in hidden iframe */` : `@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Outfit:wght@500;600;700&display=swap');`}
    * { box-sizing: border-box; }
    :root {
      --po-accent: ${accent};
      --po-text: #0f172a;
      --po-text-light: #334155;
      --po-muted: #64748b;
      --po-border: #e2e8f0;
      --po-fill: #f8fafc;
      --po-fill2: #f1f5f9;
      --radius-sm: 6px;
      --radius-md: 10px;
    }
    body {
      font-family: ${pdfCap ? `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif` : `'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`};
      margin: 0;
      padding: 32px 40px 48px;
      color: var(--po-text);
      font-size: 12.5px;
      line-height: 1.5;
      background: #fff;
    }
    .po-accent-bar { 
      height: 6px; 
      background: ${pdfCap ? "var(--po-accent)" : "linear-gradient(90deg, var(--po-accent), #3b82f6)"}; 
      border-radius: 3px; 
      margin-bottom: 20px; 
    }
    table.po-brand-row {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 24px;
    }
    table.po-brand-row td {
      vertical-align: middle;
      border: none;
      padding: 0;
    }
    .po-title-stack { text-align: center; padding: 0 16px; }
    .po-tagline {
      margin: 0 0 10px;
      font-size: 11.5px;
      font-weight: 700;
      letter-spacing: 0.2em;
      text-transform: uppercase;
      color: var(--po-muted);
    }
    .po-doc-title {
      font-family: ${pdfCap ? `inherit` : `'Outfit', sans-serif`};
      margin: 0;
      font-size: 28px;
      font-weight: 700;
      letter-spacing: 0.08em;
      color: var(--po-accent);
      line-height: 1;
      white-space: nowrap;
    }
    .po-doc-sub {
      margin: 22px 0 0;
      font-size: 11px;
      letter-spacing: 0.1em;
      color: var(--po-text-light);
      text-transform: uppercase;
      font-weight: 600;
      background: var(--po-fill);
      display: inline-block;
      padding: 4px 12px;
      border-radius: 20px;
      border: 1px solid var(--po-border);
    }
    .po-meta-grid {
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      margin-bottom: 24px;
      font-size: 12.5px;
      border: 1px solid var(--po-border);
      border-radius: var(--radius-md);
      overflow: hidden;
      box-shadow: 0 2px 6px rgba(15, 23, 42, 0.02);
    }
    .po-meta-grid th {
      text-align: left;
      padding: 12px 16px;
      background: var(--po-fill);
      font-weight: 600;
      color: #475569;
      width: 140px;
      border-bottom: 1px solid var(--po-border);
      border-right: 1px solid var(--po-border);
      vertical-align: top;
      font-size: 11px;
      letter-spacing: 0.08em;
      text-transform: uppercase;
    }
    .po-meta-grid td {
      padding: 12px 16px;
      border-bottom: 1px solid var(--po-border);
      vertical-align: top;
      color: var(--po-text);
      font-weight: 500;
    }
    .po-meta-grid tr:last-child th,
    .po-meta-grid tr:last-child td { border-bottom: none; }
    .po-meta-grid th:last-child,
    .po-meta-grid td:last-child { border-right: none; }
    .po-two-col { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 20px; }
    .po-card {
      border: 1px solid var(--po-border);
      border-radius: var(--radius-md);
      padding: 18px 20px;
      background: #fff;
      box-shadow: 0 4px 12px rgba(15, 23, 42, 0.03);
    }
    .po-card h3 {
      margin: 0 0 14px;
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      color: var(--po-accent);
      border-bottom: 2px solid var(--po-fill2);
      padding-bottom: 8px;
    }
    .po-card .po-lead { font-size: 14px; font-weight: 700; margin-bottom: 8px; color: var(--po-text); }
    .po-card .po-block { white-space: pre-wrap; color: var(--po-text-light); margin-bottom: 8px; font-size: 12.5px; line-height: 1.6; }
    .po-card .po-gst { font-size: 12px; margin-top: 12px; color: var(--po-text); background: var(--po-fill); padding: 6px 10px; border-radius: var(--radius-sm); border: 1px solid var(--po-border); display: inline-block; }
    .po-full { margin-bottom: 20px; }
    table.po {
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      font-size: 12px;
      margin-top: 12px;
      border: 1px solid var(--po-border);
      border-radius: var(--radius-md);
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(15, 23, 42, 0.03);
    }
    table.po th {
      background: var(--po-fill);
      color: #475569;
      font-weight: 600;
      font-size: 10.5px;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      padding: 14px 12px;
      border-bottom: 1px solid var(--po-border);
      text-align: center;
    }
    table.po td {
      border-bottom: 1px solid var(--po-border);
      padding: 12px;
      vertical-align: top;
    }
    table.po th:not(:last-child), table.po td:not(:last-child) {
      border-right: 1px solid var(--po-border);
    }
    table.po tbody tr:last-child td { border-bottom: none; }
    table.po tbody tr.po-line:nth-child(even) { background: #fafbfc; }
    table.po td.l { text-align: left; }
    table.po td.c { text-align: center; }
    table.po td.r { text-align: right; }
    table.po .desc { font-weight: 600; color: var(--po-text); font-size: 12.5px; }
    table.po .sub { font-size: 11px; color: var(--po-muted); margin-top: 4px; line-height: 1.4; }
    table.po td.lbl { font-weight: 600; color: #475569; }
    table.po .mono { font-variant-numeric: tabular-nums; font-family: ui-monospace, Consolas, monospace; }
    table.po tr.po-total-band td { background: var(--po-fill); font-weight: 600; color: var(--po-text); }
    table.po tr.po-grand-total td {
      background: var(--po-accent);
      color: #fff;
      font-size: 14px;
      font-weight: 700;
      border: none;
    }
    table.po tr.po-grand-total td:not(:last-child) { border-right: 1px solid rgba(255,255,255,0.2); }
    table.po tr.po-grand-total td.lbl { color: rgba(255,255,255,0.9); }
    .po-signatures {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 60px;
      margin-top: 40px;
      page-break-inside: avoid;
    }
    .po-signatures .sig-block { font-size: 11.5px; color: var(--po-muted); text-align: center; }
    .po-signatures .sig-line {
      border-top: 1px dashed #cbd5e1;
      margin-top: 60px;
      padding-top: 12px;
      font-weight: 600;
      color: var(--po-text);
    }
    .foot {
      margin-top: 32px;
      padding-top: 16px;
      border-top: 1px solid var(--po-border);
      font-size: 11px;
      color: var(--po-muted);
      text-align: center;
      line-height: 1.6;
    }
    @media print {
      body { padding: 16px 20px 24px; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      .no-print { display: none !important; }
      tr, .po-card { 
        page-break-inside: avoid; 
        break-inside: avoid;
      }
      table, .po-meta-grid, table.po {
        overflow: visible !important;
      }
    }
    ${pdfCap ? `
    /* Less compositing for raster capture (html2canvas) */
    .po-meta-grid, table.po, .po-card {
      box-shadow: none !important;
      border-radius: 0 !important;
    }
    table.po { overflow: visible !important; }
    .po-doc-sub {
      background: transparent !important;
      border: none !important;
      padding: 0 !important;
    }
    ` : ""}
  </style>
</head>
<body>
  <div class="po-accent-bar"></div>
  <table class="po-brand-row">
    <tr>
      <td style="width: 33%; text-align: left; vertical-align: middle;">
        ${logoLeft}
      </td>
      <td style="width: 42%; text-align: center; vertical-align: middle;">
        <div class="po-title-stack">
          ${taglineBlock}
          <h1 class="po-doc-title">${$386b0bb84b222876$var$escHtml(params.documentTitle)}</h1>
          <div class="po-doc-sub">${$386b0bb84b222876$var$escHtml(labels.documentSubtitle)}</div>
        </div>
      </td>
      <td style="width: 25%; text-align: right; vertical-align: middle; padding-right: 12px;">
        ${logoRight}
      </td>
    </tr>
  </table>

  <table class="po-meta-grid">
    <tbody>
      <tr>
        <th scope="row">${$386b0bb84b222876$var$escHtml(labels.documentNumberLabel)}</th>
        <td class="mono">${$386b0bb84b222876$var$escHtml(params.poNumber)}</td>
        <th scope="row">${$386b0bb84b222876$var$escHtml(labels.documentDateLabel)}</th>
        <td>${$386b0bb84b222876$var$escHtml(params.poDate)}</td>
      </tr>
    </tbody>
  </table>

  <div class="po-two-col">
    <div class="po-card">
      <h3>${$386b0bb84b222876$var$escHtml(labels.vendorBlockTitle)}</h3>
      <div class="po-lead">${$386b0bb84b222876$var$escHtml(params.vendorName || "\u2014")}</div>
      <div class="po-block">${$386b0bb84b222876$var$escHtml(params.vendorAddress || "")}</div>
      <div class="po-gst"><strong>GSTIN:</strong> ${$386b0bb84b222876$var$escHtml(params.vendorGstin || "\u2014")}</div>
    </div>
    <div class="po-card">
      <h3>${$386b0bb84b222876$var$escHtml(labels.buyerBlockTitle)}</h3>
      <div class="po-lead">${$386b0bb84b222876$var$escHtml(params.buyerName || "\u2014")}</div>
      <div class="po-block">${$386b0bb84b222876$var$escHtml(params.buyerAddress || "")}</div>
      <div class="po-gst"><strong>GSTIN:</strong> ${$386b0bb84b222876$var$escHtml(params.buyerGstin || "\u2014")}</div>
    </div>
  </div>

  <div class="po-full po-card">
    <h3>${$386b0bb84b222876$var$escHtml(labels.shipToBlockTitle)}</h3>
    <div class="po-block">${$386b0bb84b222876$var$escHtml(params.shipTo || "\u2014")}</div>
  </div>

  <div class="po-full po-card">
    <h3>Payment &amp; commercial terms</h3>
    <div class="po-block">${$386b0bb84b222876$var$escHtml(params.paymentTerms || "\u2014")}</div>
  </div>

  <table class="po">
    <thead>
      <tr>
        <th style="width:38px">S.No</th>
        <th>Description of material / work</th>
        <th style="width:84px">HSN/SAC</th>
        <th style="width:72px">Qty</th>
        <th style="width:52px">Unit</th>
        <th style="width:88px">Rate (\u{20B9})</th>
        <th style="width:102px">Amount (\u{20B9})</th>
      </tr>
    </thead>
    <tbody>
      ${rows}
      <tr class="po-total-band">
        <td colspan="6" class="r lbl">Taxable value (before tax)</td>
        <td class="r mono">${$386b0bb84b222876$var$fmtInr(params.taxableTotal)}</td>
      </tr>
      ${gstRows}
      <tr class="po-grand-total">
        <td colspan="6" class="r lbl">Grand total (\u{20B9})</td>
        <td class="r mono">${$386b0bb84b222876$var$fmtInr(params.grandTotal)}</td>
      </tr>
    </tbody>
  </table>

  ${showSignatures ? `<div class="po-signatures">
    <div class="sig-block">
      <div class="sig-line">Authorised signatory \u{2014} ${$386b0bb84b222876$var$escHtml(labels.signatoryLeftTitle)}</div>
    </div>
    <div class="sig-block">
      <div class="sig-line">${$386b0bb84b222876$var$escHtml(labels.signatoryRightTitle)} &amp; acceptance</div>
    </div>
  </div>` : ""}

  <p class="foot">${params.footerNote.trim() ? $386b0bb84b222876$var$escHtml(params.footerNote) : $386b0bb84b222876$var$escHtml(footDefault)}</p>
</body>
</html>`;
}
function $386b0bb84b222876$export$df40be970a3bd4d5(params) {
    if (!params.allocations.length) return "";
    const pdfCap = Boolean(params.forPdfCapture);
    const accent = $386b0bb84b222876$var$poAccentSafe(params.accentColorHex ?? "#1e40af");
    let annexureRows = "";
    let groupNo = 1;
    for (const alloc of params.allocations){
        const span = alloc.items.length;
        for(let i = 0; i < span; i++){
            const item = alloc.items[i];
            const snoCell = i === 0 ? `<td rowspan="${span}" class="meta sno-cell">${groupNo}</td>` : "";
            const benCell = i === 0 ? `<td rowspan="${span}" class="meta benef"><strong>${$386b0bb84b222876$var$escHtml(alloc.beneficiaryName)}</strong></td>` : "";
            const appCell = i === 0 ? `<td rowspan="${span}" class="meta mono appid">${$386b0bb84b222876$var$escHtml(alloc.applicationId)}</td>` : "";
            const distCell = i === 0 ? `<td rowspan="${span}" class="meta geo">${$386b0bb84b222876$var$escHtml(alloc.district)}</td>` : "";
            const mandalCell = i === 0 ? `<td rowspan="${span}" class="meta geo">${$386b0bb84b222876$var$escHtml(alloc.mandal)}</td>` : "";
            const villageCell = i === 0 ? `<td rowspan="${span}" class="meta geo">${$386b0bb84b222876$var$escHtml(alloc.village)}</td>` : "";
            annexureRows += `
        <tr>
          ${snoCell}
          ${benCell}
          ${appCell}
          ${distCell}
          ${mandalCell}
          ${villageCell}
          <td class="mat">${$386b0bb84b222876$var$escHtml(item.label)}</td>
          <td class="r mono qty">${$386b0bb84b222876$var$fmtInr(item.qty)} ${$386b0bb84b222876$var$escHtml(item.unit)}</td>
        </tr>`;
        }
        groupNo += 1;
    }
    const foot = params.footerNote?.trim() ? $386b0bb84b222876$var$escHtml(params.footerNote) : $386b0bb84b222876$var$escHtml("This document was generated from the console. Amounts follow rates and GST entered at download.");
    return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="utf-8"/>
  <title>Annexure \u{2014} Beneficiary allocation</title>
  <style>
    ${pdfCap ? `/* PDF capture: system fonts only */` : `@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');`}
    * { box-sizing: border-box; }
    body {
      font-family: ${pdfCap ? `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif` : `'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`};
      margin: 0;
      padding: 18px 22px 28px;
      color: #0f172a;
      font-size: 11px;
      line-height: 1.45;
      background: #fff;
      width: 1040px;
    }
    h1 {
      margin: 0 0 18px;
      font-size: 1.05rem;
      font-weight: 700;
      color: ${accent};
      letter-spacing: 0.06em;
      text-transform: uppercase;
    }
    .annex-card {
      border-radius: 14px;
      overflow: hidden;
      background: #fff;
      box-shadow: 0 8px 32px rgba(15, 23, 42, 0.07), 0 0 0 1px rgba(148, 163, 184, 0.35);
    }
    table.po.annex-po {
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      font-size: 11px;
      line-height: 1.45;
    }
    table.po.annex-po thead th {
      background: ${accent};
      color: #fff;
      font-size: 9.5px;
      font-weight: 600;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      padding: 12px 10px;
      text-align: left;
      border: none;
      border-bottom: 1px solid rgba(255, 255, 255, 0.18);
      white-space: nowrap;
    }
    table.po.annex-po thead th:not(:last-child) {
      border-right: 1px solid rgba(255, 255, 255, 0.18);
    }
    table.po.annex-po tbody td {
      padding: 10px 10px;
      vertical-align: middle;
      border-bottom: 1px solid #e8edf4;
      border-right: 1px solid #eef2f7;
      background: #fff;
      color: #0f172a;
    }
    table.po.annex-po tbody td:last-child {
      border-right: none;
    }
    table.po.annex-po tbody tr:last-child td {
      border-bottom: none;
    }
    table.po.annex-po tbody tr:hover td.mat,
    table.po.annex-po tbody tr:hover td.qty {
      background: #f8fafc;
    }
    table.po.annex-po td.sno-cell {
      text-align: center;
      font-weight: 700;
      font-size: 12px;
      color: ${accent};
      background: #f8fafc;
      width: 44px;
      min-width: 44px;
    }
    table.po.annex-po td.benef { min-width: 120px; max-width: 180px; font-weight: 500; }
    table.po.annex-po td.appid { font-size: 10px; max-width: 110px; word-break: break-word; color: #334155; }
    table.po.annex-po td.geo { font-size: 10px; max-width: 92px; word-break: break-word; color: #475569; }
    table.po.annex-po td.mat { font-weight: 500; color: #0f172a; }
    table.po.annex-po td.qty { font-variant-numeric: tabular-nums; }
    .mono { font-family: ui-monospace, Consolas, monospace; font-size: 10px; }
    .foot {
      margin-top: 20px;
      font-size: 10px;
      color: #64748b;
      text-align: center;
      font-style: italic;
    }
  </style>
</head>
<body>
  <h1>Annexure: Beneficiary allocation</h1>
  <div class="annex-card">
  <table class="po annex-po">
    <thead>
      <tr>
        <th style="width: 48px;">S.No</th>
        <th style="min-width: 120px;">Beneficiary name</th>
        <th style="min-width: 96px;">Application ID</th>
        <th style="min-width: 88px;">District</th>
        <th style="min-width: 88px;">Mandal</th>
        <th style="min-width: 88px;">Village</th>
        <th>Material</th>
        <th style="width: 112px;">Allocated qty</th>
      </tr>
    </thead>
    <tbody>
      ${annexureRows}
    </tbody>
  </table>
  </div>
  <p class="foot">${foot}</p>
</body>
</html>`;
}
const $386b0bb84b222876$var$SAMPLE_PO_ALLOCATIONS = [
    {
        beneficiaryName: "G. Venkateswarlu",
        applicationId: "APP-SAMPLE-001",
        district: "Nagarkurnool",
        mandal: "Amrabad",
        village: "Mannanur",
        items: [
            {
                label: "Cement \u2014 PPC grade",
                qty: 450,
                unit: "Bag"
            },
            {
                label: "Steel reinforcement \u2014 Fe 500",
                qty: 1.2,
                unit: "MT"
            },
            {
                label: "River sand \u2014 fine grade",
                qty: 15,
                unit: "Cum"
            }
        ]
    },
    {
        beneficiaryName: "K. Lakshmi",
        applicationId: "APP-SAMPLE-002",
        district: "Nagarkurnool",
        mandal: "Achampet",
        village: "Uppununthala",
        items: [
            {
                label: "Cement \u2014 PPC grade",
                qty: 400,
                unit: "Bag"
            },
            {
                label: "Steel reinforcement \u2014 Fe 500",
                qty: 1.2,
                unit: "MT"
            },
            {
                label: "Machine-made bricks",
                qty: 12000,
                unit: "Nos"
            },
            {
                label: "CPVC pipes \u2014 1\u2033",
                qty: 100,
                unit: "Mtr"
            }
        ]
    },
    {
        beneficiaryName: "M. Ramesh",
        applicationId: "APP-SAMPLE-003",
        district: "Nagarkurnool",
        mandal: "Kollapur",
        village: "Kollapur",
        items: [
            {
                label: "Coarse aggregate \u2014 20mm",
                qty: 12,
                unit: "Cum"
            },
            {
                label: "MS door frame \u2014 4\u2033 \xd7 2.5\u2033",
                qty: 3,
                unit: "Nos"
            },
            {
                label: "Plywood \u2014 BWR grade 18mm",
                qty: 8,
                unit: "Sht"
            }
        ]
    },
    {
        beneficiaryName: "P. Sravani",
        applicationId: "APP-SAMPLE-004",
        district: "Nagarkurnool",
        mandal: "Nagarkurnool",
        village: "Nagarkurnool",
        items: [
            {
                label: "Exterior emulsion paint",
                qty: 20,
                unit: "Ltr"
            },
            {
                label: "Electrical wiring \u2014 FR PVC",
                qty: 250,
                unit: "Mtr"
            },
            {
                label: "Coarse aggregate \u2014 20mm",
                qty: 13,
                unit: "Cum"
            },
            {
                label: "River sand \u2014 fine grade",
                qty: 15,
                unit: "Cum"
            }
        ]
    }
];
function $386b0bb84b222876$var$samplePoPreviewLines() {
    return [
        {
            sno: 1,
            description: "Cement \u2014 PPC grade (sample line)",
            subDescription: "Standard packing \xb7 Illustrative qty & rate only",
            hsn: "25232990",
            qty: 850,
            unit: "Bag",
            rate: 385,
            amount: 327250
        },
        {
            sno: 2,
            description: "Steel reinforcement \u2014 Fe 500 (sample line)",
            subDescription: "As per structural drawing \xb7 Illustrative only",
            hsn: "72142090",
            qty: 2.4,
            unit: "MT",
            rate: 62000,
            amount: 148800
        },
        {
            sno: 3,
            description: "Machine-made bricks (sample line)",
            subDescription: "9\u2033 \xd7 4\xbd\u2033 \xd7 3\u2033 \xb7 Illustrative only",
            hsn: "69041000",
            qty: 12000,
            unit: "Nos",
            rate: 9.5,
            amount: 114000
        },
        {
            sno: 4,
            description: "River sand \u2014 fine grade (sample line)",
            subDescription: "Washed & sieved \xb7 Illustrative only",
            hsn: "25051000",
            qty: 30,
            unit: "Cum",
            rate: 3200,
            amount: 96000
        },
        {
            sno: 5,
            description: "Coarse aggregate \u2014 20mm (sample line)",
            subDescription: "Crushed granite \xb7 Illustrative only",
            hsn: "25171010",
            qty: 25,
            unit: "Cum",
            rate: 2800,
            amount: 70000
        },
        {
            sno: 6,
            description: "Electrical wiring \u2014 FR PVC (sample line)",
            subDescription: "1.5 sq mm copper \xb7 Illustrative only",
            hsn: "85444999",
            qty: 500,
            unit: "Mtr",
            rate: 18,
            amount: 9000
        },
        {
            sno: 7,
            description: "CPVC pipes \u2014 1\u2033 (sample line)",
            subDescription: "SDR 11 \xb7 Plumbing \xb7 Illustrative only",
            hsn: "39172990",
            qty: 200,
            unit: "Mtr",
            rate: 85,
            amount: 17000
        },
        {
            sno: 8,
            description: "MS door frame \u2014 4\u2033 \xd7 2.5\u2033 (sample line)",
            subDescription: "Hot rolled \xb7 Illustrative only",
            hsn: "73083090",
            qty: 6,
            unit: "Nos",
            rate: 3500,
            amount: 21000
        },
        {
            sno: 9,
            description: "Plywood \u2014 BWR grade 18mm (sample line)",
            subDescription: "Commercial grade \xb7 Illustrative only",
            hsn: "44123900",
            qty: 15,
            unit: "Sht",
            rate: 1450,
            amount: 21750
        },
        {
            sno: 10,
            description: "Exterior emulsion paint (sample line)",
            subDescription: "Weathercoat \xb7 Illustrative only",
            hsn: "32091000",
            qty: 40,
            unit: "Ltr",
            rate: 320,
            amount: 12800
        }
    ];
}
function $386b0bb84b222876$var$samplePoPreviewTotals(params, lines) {
    const taxableTotal = lines.reduce((s, ln)=>s + ln.amount, 0);
    const gstLines = params.gstRows.map((g)=>({
            label: g.label.trim() || "Tax",
            ratePercent: Number.isFinite(g.ratePercent) ? g.ratePercent : 0,
            amount: taxableTotal * ((Number.isFinite(g.ratePercent) ? g.ratePercent : 0) / 100)
        }));
    const grandTotal = taxableTotal + gstLines.reduce((s, x)=>s + x.amount, 0);
    return {
        taxableTotal: taxableTotal,
        gstLines: gstLines,
        grandTotal: grandTotal
    };
}
function $386b0bb84b222876$var$samplePoPreviewDate() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
function $386b0bb84b222876$export$bd69534d3059bb5a(params) {
    const lines = $386b0bb84b222876$var$samplePoPreviewLines();
    const { taxableTotal: taxableTotal, gstLines: gstLines, grandTotal: grandTotal } = $386b0bb84b222876$var$samplePoPreviewTotals(params, lines);
    return {
        documentTitle: params.documentTitle.trim() || "PURCHASE ORDER",
        letterheadTagline: params.letterheadTagline.trim(),
        accentColorHex: params.accentColorHex,
        footerNote: params.footerNote.trim(),
        poNumber: "PO-SAMPLE-PREVIEW",
        poDate: $386b0bb84b222876$var$samplePoPreviewDate(),
        buyerName: params.buyerName.trim() || "(Add purchaser name in PO format settings)",
        buyerAddress: params.buyerAddress.trim() || "Purchaser address will appear here.",
        buyerGstin: params.buyerGstin.trim() || "\u2014",
        vendorName: params.defaultVendorName.trim() || "Sample vendor name (set \u201CDefault vendor name\u201D in PO format, or live PO uses subcontractor)",
        vendorAddress: params.defaultVendorAddress.trim() || "Default vendor address will appear here.",
        vendorGstin: params.defaultVendorGstin.trim() || "\u2014",
        shipTo: params.defaultShipTo.trim() || "Ship-to / site details will appear here.",
        paymentTerms: params.paymentTerms.trim() || "\u2014",
        lines: lines,
        taxableTotal: taxableTotal,
        gstLines: gstLines,
        grandTotal: grandTotal,
        allocations: $386b0bb84b222876$var$SAMPLE_PO_ALLOCATIONS
    };
}
function $386b0bb84b222876$export$73af7d68fa0aa7a6(params, opts) {
    const lines = $386b0bb84b222876$var$samplePoPreviewLines();
    const { taxableTotal: taxableTotal, gstLines: gstLines, grandTotal: grandTotal } = $386b0bb84b222876$var$samplePoPreviewTotals(params, lines);
    const poDate = $386b0bb84b222876$var$samplePoPreviewDate();
    return $386b0bb84b222876$export$4ddeb3921011e5d3({
        documentTitle: params.documentTitle.trim() || "PURCHASE ORDER",
        letterheadTagline: params.letterheadTagline,
        logoPrimaryUrl: params.logoPrimaryUrl,
        logoSecondaryUrl: params.logoSecondaryUrl,
        logoPrimaryHeightPx: params.logoPrimaryHeightPx,
        logoSecondaryHeightPx: params.logoSecondaryHeightPx,
        accentColorHex: params.accentColorHex,
        footerNote: params.footerNote.trim() || $386b0bb84b222876$export$9da41ad8ba909c87,
        defaultFooterNote: $386b0bb84b222876$export$9da41ad8ba909c87,
        showSignatures: false,
        poNumber: "PO-SAMPLE-PREVIEW",
        poDate: poDate,
        buyerName: params.buyerName.trim() || "(Add purchaser name in PO format settings)",
        buyerAddress: params.buyerAddress.trim() || "Purchaser address will appear here.",
        buyerGstin: params.buyerGstin.trim() || "\u2014",
        vendorName: params.defaultVendorName.trim() || "Sample vendor name (set \u201CDefault vendor name\u201D in PO format, or live PO uses subcontractor)",
        vendorAddress: params.defaultVendorAddress.trim() || "Default vendor address will appear here.",
        vendorGstin: params.defaultVendorGstin.trim() || "\u2014",
        shipTo: params.defaultShipTo.trim() || "Ship-to / site details will appear here.",
        paymentTerms: params.paymentTerms.trim() || "\u2014",
        lines: lines,
        taxableTotal: taxableTotal,
        gstLines: gstLines,
        grandTotal: grandTotal,
        forPdfCapture: opts?.forPdfCapture
    });
}
function $386b0bb84b222876$export$fb217d25a26e3cfc(params, opts) {
    return $386b0bb84b222876$export$df40be970a3bd4d5({
        accentColorHex: params.accentColorHex,
        footerNote: params.footerNote,
        allocations: $386b0bb84b222876$var$SAMPLE_PO_ALLOCATIONS,
        forPdfCapture: opts?.forPdfCapture
    });
}



var $49yFe = parcelRequire("49yFe");
var $7b4f31ece5bced4b$exports = {};
$parcel$export($7b4f31ece5bced4b$exports, "PDFDocument", function () { return $6767bf97ac5b9b71$export$2e2bcd8739ae039; });

var $273XO = parcelRequire("273XO");

var $273XO = parcelRequire("273XO");
parcelRequire("iMObG");

var $8KH3B = parcelRequire("8KH3B");

var $273XO = parcelRequire("273XO");
var $f68f50851d9a8a51$exports = {};
// Top level file is just a mixin of submodules & constants
'use strict';
var $e86641f1e3ca0827$exports = {};
'use strict';
var $e86641f1e3ca0827$var$TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
function $e86641f1e3ca0827$var$_has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
$e86641f1e3ca0827$exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(var p in source)if ($e86641f1e3ca0827$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
$e86641f1e3ca0827$exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var $e86641f1e3ca0827$var$fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var $e86641f1e3ca0827$var$fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
$e86641f1e3ca0827$exports.setTyped = function(on) {
    if (on) {
        $e86641f1e3ca0827$exports.Buf8 = Uint8Array;
        $e86641f1e3ca0827$exports.Buf16 = Uint16Array;
        $e86641f1e3ca0827$exports.Buf32 = Int32Array;
        $e86641f1e3ca0827$exports.assign($e86641f1e3ca0827$exports, $e86641f1e3ca0827$var$fnTyped);
    } else {
        $e86641f1e3ca0827$exports.Buf8 = Array;
        $e86641f1e3ca0827$exports.Buf16 = Array;
        $e86641f1e3ca0827$exports.Buf32 = Array;
        $e86641f1e3ca0827$exports.assign($e86641f1e3ca0827$exports, $e86641f1e3ca0827$var$fnUntyped);
    }
};
$e86641f1e3ca0827$exports.setTyped($e86641f1e3ca0827$var$TYPED_OK);


var $f68f50851d9a8a51$require$assign = $e86641f1e3ca0827$exports.assign;
var $3c01dc77ae4a7667$exports = {};

$parcel$export($3c01dc77ae4a7667$exports, "Deflate", function () { return $3c01dc77ae4a7667$export$ae157b6234afe138; }, function (v) { return $3c01dc77ae4a7667$export$ae157b6234afe138 = v; });
$parcel$export($3c01dc77ae4a7667$exports, "deflate", function () { return $3c01dc77ae4a7667$export$2316623ecd1285ab; }, function (v) { return $3c01dc77ae4a7667$export$2316623ecd1285ab = v; });
$parcel$export($3c01dc77ae4a7667$exports, "deflateRaw", function () { return $3c01dc77ae4a7667$export$e95d6a8f69fb340a; }, function (v) { return $3c01dc77ae4a7667$export$e95d6a8f69fb340a = v; });
$parcel$export($3c01dc77ae4a7667$exports, "gzip", function () { return $3c01dc77ae4a7667$export$69f0ea7cf3a331a8; }, function (v) { return $3c01dc77ae4a7667$export$69f0ea7cf3a331a8 = v; });
var $3c01dc77ae4a7667$export$ae157b6234afe138;
var $3c01dc77ae4a7667$export$2316623ecd1285ab;
var $3c01dc77ae4a7667$export$e95d6a8f69fb340a;
var $3c01dc77ae4a7667$export$69f0ea7cf3a331a8;
'use strict';
var $e495bef284cd7570$export$72b35d618fb8ad9b;
var $e495bef284cd7570$export$a65c7b2bde87cb70;
var $e495bef284cd7570$export$8f99f0e30bc7dd53;
var $e495bef284cd7570$export$e78fab288549509;
var $e495bef284cd7570$export$1cd50f7b2515ba19;
var $e495bef284cd7570$export$2316623ecd1285ab;
var $e495bef284cd7570$export$599854fa319a815f;
var $e495bef284cd7570$export$f55e0b3ab66b5d46;
var $e495bef284cd7570$export$12b6e1fcadea22f9;
'use strict';

var $13e89365d5815482$export$4e4fc0157c3cd14d;
var $13e89365d5815482$export$8959e34c5e020172;
var $13e89365d5815482$export$44f15b52eef0cf41;
var $13e89365d5815482$export$b3cbce147289408f;
var $13e89365d5815482$export$bfb360e02ee9b403;
'use strict';

/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $13e89365d5815482$var$Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $13e89365d5815482$var$Z_BINARY = 0;
var $13e89365d5815482$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $13e89365d5815482$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $13e89365d5815482$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $13e89365d5815482$var$STORED_BLOCK = 0;
var $13e89365d5815482$var$STATIC_TREES = 1;
var $13e89365d5815482$var$DYN_TREES = 2;
/* The three kinds of block type */ var $13e89365d5815482$var$MIN_MATCH = 3;
var $13e89365d5815482$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $13e89365d5815482$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $13e89365d5815482$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $13e89365d5815482$var$L_CODES = $13e89365d5815482$var$LITERALS + 1 + $13e89365d5815482$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $13e89365d5815482$var$D_CODES = 30;
/* number of distance codes */ var $13e89365d5815482$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $13e89365d5815482$var$HEAP_SIZE = 2 * $13e89365d5815482$var$L_CODES + 1;
/* maximum heap size */ var $13e89365d5815482$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $13e89365d5815482$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $13e89365d5815482$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $13e89365d5815482$var$END_BLOCK = 256;
/* end of block literal code */ var $13e89365d5815482$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $13e89365d5815482$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $13e89365d5815482$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $13e89365d5815482$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $13e89365d5815482$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $13e89365d5815482$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $13e89365d5815482$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $13e89365d5815482$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $13e89365d5815482$var$static_ltree = new Array(($13e89365d5815482$var$L_CODES + 2) * 2);
$13e89365d5815482$var$zero($13e89365d5815482$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $13e89365d5815482$var$static_dtree = new Array($13e89365d5815482$var$D_CODES * 2);
$13e89365d5815482$var$zero($13e89365d5815482$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $13e89365d5815482$var$_dist_code = new Array($13e89365d5815482$var$DIST_CODE_LEN);
$13e89365d5815482$var$zero($13e89365d5815482$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $13e89365d5815482$var$_length_code = new Array($13e89365d5815482$var$MAX_MATCH - $13e89365d5815482$var$MIN_MATCH + 1);
$13e89365d5815482$var$zero($13e89365d5815482$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $13e89365d5815482$var$base_length = new Array($13e89365d5815482$var$LENGTH_CODES);
$13e89365d5815482$var$zero($13e89365d5815482$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $13e89365d5815482$var$base_dist = new Array($13e89365d5815482$var$D_CODES);
$13e89365d5815482$var$zero($13e89365d5815482$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $13e89365d5815482$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $13e89365d5815482$var$static_l_desc;
var $13e89365d5815482$var$static_d_desc;
var $13e89365d5815482$var$static_bl_desc;
function $13e89365d5815482$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $13e89365d5815482$var$d_code(dist) {
    return dist < 256 ? $13e89365d5815482$var$_dist_code[dist] : $13e89365d5815482$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $13e89365d5815482$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $13e89365d5815482$var$send_bits(s, value, length) {
    if (s.bi_valid > $13e89365d5815482$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $13e89365d5815482$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $13e89365d5815482$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $13e89365d5815482$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $13e89365d5815482$var$send_code(s, c, tree) {
    $13e89365d5815482$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $13e89365d5815482$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $13e89365d5815482$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $13e89365d5815482$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $13e89365d5815482$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $13e89365d5815482$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $13e89365d5815482$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $13e89365d5815482$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($13e89365d5815482$var$MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $13e89365d5815482$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $13e89365d5815482$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $13e89365d5815482$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($13e89365d5815482$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $13e89365d5815482$var$LENGTH_CODES - 1; code++){
        $13e89365d5815482$var$base_length[code] = length;
        for(n = 0; n < 1 << $13e89365d5815482$var$extra_lbits[code]; n++)$13e89365d5815482$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $13e89365d5815482$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $13e89365d5815482$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $13e89365d5815482$var$extra_dbits[code]; n++)$13e89365d5815482$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $13e89365d5815482$var$D_CODES; code++){
        $13e89365d5815482$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $13e89365d5815482$var$extra_dbits[code] - 7; n++)$13e89365d5815482$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $13e89365d5815482$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $13e89365d5815482$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $13e89365d5815482$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $13e89365d5815482$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $13e89365d5815482$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $13e89365d5815482$var$gen_codes($13e89365d5815482$var$static_ltree, $13e89365d5815482$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $13e89365d5815482$var$D_CODES; n++){
        $13e89365d5815482$var$static_dtree[n * 2 + 1] = 5;
        $13e89365d5815482$var$static_dtree[n * 2] = $13e89365d5815482$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $13e89365d5815482$var$static_l_desc = new $13e89365d5815482$var$StaticTreeDesc($13e89365d5815482$var$static_ltree, $13e89365d5815482$var$extra_lbits, $13e89365d5815482$var$LITERALS + 1, $13e89365d5815482$var$L_CODES, $13e89365d5815482$var$MAX_BITS);
    $13e89365d5815482$var$static_d_desc = new $13e89365d5815482$var$StaticTreeDesc($13e89365d5815482$var$static_dtree, $13e89365d5815482$var$extra_dbits, 0, $13e89365d5815482$var$D_CODES, $13e89365d5815482$var$MAX_BITS);
    $13e89365d5815482$var$static_bl_desc = new $13e89365d5815482$var$StaticTreeDesc(new Array(0), $13e89365d5815482$var$extra_blbits, 0, $13e89365d5815482$var$BL_CODES, $13e89365d5815482$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $13e89365d5815482$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $13e89365d5815482$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $13e89365d5815482$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $13e89365d5815482$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$13e89365d5815482$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $13e89365d5815482$var$bi_windup(s) {
    if (s.bi_valid > 8) $13e89365d5815482$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $13e89365d5815482$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $13e89365d5815482$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $13e89365d5815482$var$put_short(s, len);
        $13e89365d5815482$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $e86641f1e3ca0827$exports.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $13e89365d5815482$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $13e89365d5815482$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $13e89365d5815482$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($13e89365d5815482$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $13e89365d5815482$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $13e89365d5815482$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $13e89365d5815482$var$_length_code[lc];
            $13e89365d5815482$var$send_code(s, code + $13e89365d5815482$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $13e89365d5815482$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $13e89365d5815482$var$base_length[code];
                $13e89365d5815482$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $13e89365d5815482$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $13e89365d5815482$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $13e89365d5815482$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $13e89365d5815482$var$base_dist[code];
                $13e89365d5815482$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $13e89365d5815482$var$send_code(s, $13e89365d5815482$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $13e89365d5815482$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $13e89365d5815482$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$13e89365d5815482$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $13e89365d5815482$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $13e89365d5815482$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $13e89365d5815482$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $13e89365d5815482$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $13e89365d5815482$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$13e89365d5815482$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$13e89365d5815482$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$13e89365d5815482$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $13e89365d5815482$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $13e89365d5815482$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $13e89365d5815482$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $13e89365d5815482$var$send_code(s, $13e89365d5815482$var$REP_3_6, s.bl_tree);
            $13e89365d5815482$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $13e89365d5815482$var$send_code(s, $13e89365d5815482$var$REPZ_3_10, s.bl_tree);
            $13e89365d5815482$var$send_bits(s, count - 3, 3);
        } else {
            $13e89365d5815482$var$send_code(s, $13e89365d5815482$var$REPZ_11_138, s.bl_tree);
            $13e89365d5815482$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $13e89365d5815482$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $13e89365d5815482$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $13e89365d5815482$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $13e89365d5815482$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $13e89365d5815482$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$13e89365d5815482$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $13e89365d5815482$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $13e89365d5815482$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $13e89365d5815482$var$send_bits(s, dcodes - 1, 5);
    $13e89365d5815482$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $13e89365d5815482$var$send_bits(s, s.bl_tree[$13e89365d5815482$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $13e89365d5815482$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $13e89365d5815482$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $13e89365d5815482$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $13e89365d5815482$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $13e89365d5815482$var$Z_TEXT;
    for(n = 32; n < $13e89365d5815482$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $13e89365d5815482$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $13e89365d5815482$var$Z_BINARY;
}
var $13e89365d5815482$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $13e89365d5815482$var$_tr_init(s) {
    if (!$13e89365d5815482$var$static_init_done) {
        $13e89365d5815482$var$tr_static_init();
        $13e89365d5815482$var$static_init_done = true;
    }
    s.l_desc = new $13e89365d5815482$var$TreeDesc(s.dyn_ltree, $13e89365d5815482$var$static_l_desc);
    s.d_desc = new $13e89365d5815482$var$TreeDesc(s.dyn_dtree, $13e89365d5815482$var$static_d_desc);
    s.bl_desc = new $13e89365d5815482$var$TreeDesc(s.bl_tree, $13e89365d5815482$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $13e89365d5815482$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $13e89365d5815482$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $13e89365d5815482$var$send_bits(s, ($13e89365d5815482$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $13e89365d5815482$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $13e89365d5815482$var$_tr_align(s) {
    $13e89365d5815482$var$send_bits(s, $13e89365d5815482$var$STATIC_TREES << 1, 3);
    $13e89365d5815482$var$send_code(s, $13e89365d5815482$var$END_BLOCK, $13e89365d5815482$var$static_ltree);
    $13e89365d5815482$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $13e89365d5815482$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $13e89365d5815482$var$Z_UNKNOWN) s.strm.data_type = $13e89365d5815482$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $13e89365d5815482$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $13e89365d5815482$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $13e89365d5815482$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $13e89365d5815482$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $13e89365d5815482$var$Z_FIXED || static_lenb === opt_lenb) {
        $13e89365d5815482$var$send_bits(s, ($13e89365d5815482$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $13e89365d5815482$var$compress_block(s, $13e89365d5815482$var$static_ltree, $13e89365d5815482$var$static_dtree);
    } else {
        $13e89365d5815482$var$send_bits(s, ($13e89365d5815482$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $13e89365d5815482$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $13e89365d5815482$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $13e89365d5815482$var$init_block(s);
    if (last) $13e89365d5815482$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $13e89365d5815482$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($13e89365d5815482$var$_length_code[lc] + $13e89365d5815482$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$13e89365d5815482$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$13e89365d5815482$export$4e4fc0157c3cd14d = $13e89365d5815482$var$_tr_init;
$13e89365d5815482$export$8959e34c5e020172 = $13e89365d5815482$var$_tr_stored_block;
$13e89365d5815482$export$44f15b52eef0cf41 = $13e89365d5815482$var$_tr_flush_block;
$13e89365d5815482$export$b3cbce147289408f = $13e89365d5815482$var$_tr_tally;
$13e89365d5815482$export$bfb360e02ee9b403 = $13e89365d5815482$var$_tr_align;


var $5cc01a61bf102ed9$exports = {};
'use strict';
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $5cc01a61bf102ed9$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
$5cc01a61bf102ed9$exports = $5cc01a61bf102ed9$var$adler32;


var $e5fbe17305865443$exports = {};
'use strict';
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $e5fbe17305865443$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $e5fbe17305865443$var$crcTable = $e5fbe17305865443$var$makeTable();
function $e5fbe17305865443$var$crc32(crc, buf, len, pos) {
    var t = $e5fbe17305865443$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
$e5fbe17305865443$exports = $e5fbe17305865443$var$crc32;


var $846829610f0eaf86$exports = {};
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
$846829610f0eaf86$exports = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};


/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $e495bef284cd7570$var$Z_NO_FLUSH = 0;
var $e495bef284cd7570$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $e495bef284cd7570$var$Z_FULL_FLUSH = 3;
var $e495bef284cd7570$var$Z_FINISH = 4;
var $e495bef284cd7570$var$Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $e495bef284cd7570$var$Z_OK = 0;
var $e495bef284cd7570$var$Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $e495bef284cd7570$var$Z_STREAM_ERROR = -2;
var $e495bef284cd7570$var$Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var $e495bef284cd7570$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $e495bef284cd7570$var$Z_DEFAULT_COMPRESSION = -1;
var $e495bef284cd7570$var$Z_FILTERED = 1;
var $e495bef284cd7570$var$Z_HUFFMAN_ONLY = 2;
var $e495bef284cd7570$var$Z_RLE = 3;
var $e495bef284cd7570$var$Z_FIXED = 4;
var $e495bef284cd7570$var$Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $e495bef284cd7570$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $e495bef284cd7570$var$Z_DEFLATED = 8;
/*============================================================================*/ var $e495bef284cd7570$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $e495bef284cd7570$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $e495bef284cd7570$var$DEF_MEM_LEVEL = 8;
var $e495bef284cd7570$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $e495bef284cd7570$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $e495bef284cd7570$var$L_CODES = $e495bef284cd7570$var$LITERALS + 1 + $e495bef284cd7570$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $e495bef284cd7570$var$D_CODES = 30;
/* number of distance codes */ var $e495bef284cd7570$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $e495bef284cd7570$var$HEAP_SIZE = 2 * $e495bef284cd7570$var$L_CODES + 1;
/* maximum heap size */ var $e495bef284cd7570$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $e495bef284cd7570$var$MIN_MATCH = 3;
var $e495bef284cd7570$var$MAX_MATCH = 258;
var $e495bef284cd7570$var$MIN_LOOKAHEAD = $e495bef284cd7570$var$MAX_MATCH + $e495bef284cd7570$var$MIN_MATCH + 1;
var $e495bef284cd7570$var$PRESET_DICT = 0x20;
var $e495bef284cd7570$var$INIT_STATE = 42;
var $e495bef284cd7570$var$EXTRA_STATE = 69;
var $e495bef284cd7570$var$NAME_STATE = 73;
var $e495bef284cd7570$var$COMMENT_STATE = 91;
var $e495bef284cd7570$var$HCRC_STATE = 103;
var $e495bef284cd7570$var$BUSY_STATE = 113;
var $e495bef284cd7570$var$FINISH_STATE = 666;
var $e495bef284cd7570$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $e495bef284cd7570$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $e495bef284cd7570$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $e495bef284cd7570$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $e495bef284cd7570$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $e495bef284cd7570$var$err(strm, errorCode) {
    strm.msg = $846829610f0eaf86$exports[errorCode];
    return errorCode;
}
function $e495bef284cd7570$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $e495bef284cd7570$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $e495bef284cd7570$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $e86641f1e3ca0827$exports.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $e495bef284cd7570$var$flush_block_only(s, last) {
    $13e89365d5815482$export$44f15b52eef0cf41(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $e495bef284cd7570$var$flush_pending(s.strm);
}
function $e495bef284cd7570$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $e495bef284cd7570$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $e495bef284cd7570$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $e86641f1e3ca0827$exports.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $5cc01a61bf102ed9$exports(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $e5fbe17305865443$exports(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $e495bef284cd7570$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $e495bef284cd7570$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $e495bef284cd7570$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $e495bef284cd7570$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $e495bef284cd7570$var$MAX_MATCH - (strend - scan);
        scan = strend - $e495bef284cd7570$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $e495bef284cd7570$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $e495bef284cd7570$var$MIN_LOOKAHEAD)) {
            $e86641f1e3ca0827$exports.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $e495bef284cd7570$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $e495bef284cd7570$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $e495bef284cd7570$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $e495bef284cd7570$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $e495bef284cd7570$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $e495bef284cd7570$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $e495bef284cd7570$var$fill_window(s);
            if (s.lookahead === 0 && flush === $e495bef284cd7570$var$Z_NO_FLUSH) return $e495bef284cd7570$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $e495bef284cd7570$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $e495bef284cd7570$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $e495bef284cd7570$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $e495bef284cd7570$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $e495bef284cd7570$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $e495bef284cd7570$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $e495bef284cd7570$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $e495bef284cd7570$var$BS_FINISH_STARTED;
        /***/ return $e495bef284cd7570$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $e495bef284cd7570$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $e495bef284cd7570$var$BS_NEED_MORE;
    /***/ }
    return $e495bef284cd7570$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $e495bef284cd7570$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $e495bef284cd7570$var$MIN_LOOKAHEAD) {
            $e495bef284cd7570$var$fill_window(s);
            if (s.lookahead < $e495bef284cd7570$var$MIN_LOOKAHEAD && flush === $e495bef284cd7570$var$Z_NO_FLUSH) return $e495bef284cd7570$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $e495bef284cd7570$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $e495bef284cd7570$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $e495bef284cd7570$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $e495bef284cd7570$var$longest_match(s, hash_head);
        if (s.match_length >= $e495bef284cd7570$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $13e89365d5815482$export$b3cbce147289408f(s, s.strstart - s.match_start, s.match_length - $e495bef284cd7570$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $e495bef284cd7570$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $e495bef284cd7570$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $13e89365d5815482$export$b3cbce147289408f(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $e495bef284cd7570$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $e495bef284cd7570$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $e495bef284cd7570$var$MIN_MATCH - 1 ? s.strstart : $e495bef284cd7570$var$MIN_MATCH - 1;
    if (flush === $e495bef284cd7570$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $e495bef284cd7570$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $e495bef284cd7570$var$BS_FINISH_STARTED;
        /***/ return $e495bef284cd7570$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $e495bef284cd7570$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $e495bef284cd7570$var$BS_NEED_MORE;
    /***/ }
    return $e495bef284cd7570$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $e495bef284cd7570$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $e495bef284cd7570$var$MIN_LOOKAHEAD) {
            $e495bef284cd7570$var$fill_window(s);
            if (s.lookahead < $e495bef284cd7570$var$MIN_LOOKAHEAD && flush === $e495bef284cd7570$var$Z_NO_FLUSH) return $e495bef284cd7570$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $e495bef284cd7570$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $e495bef284cd7570$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $e495bef284cd7570$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $e495bef284cd7570$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $e495bef284cd7570$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $e495bef284cd7570$var$Z_FILTERED || s.match_length === $e495bef284cd7570$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $e495bef284cd7570$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $e495bef284cd7570$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $e495bef284cd7570$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $13e89365d5815482$export$b3cbce147289408f(s, s.strstart - 1 - s.prev_match, s.prev_length - $e495bef284cd7570$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $e495bef284cd7570$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $e495bef284cd7570$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $e495bef284cd7570$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $e495bef284cd7570$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $13e89365d5815482$export$b3cbce147289408f(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $e495bef284cd7570$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $e495bef284cd7570$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $13e89365d5815482$export$b3cbce147289408f(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $e495bef284cd7570$var$MIN_MATCH - 1 ? s.strstart : $e495bef284cd7570$var$MIN_MATCH - 1;
    if (flush === $e495bef284cd7570$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $e495bef284cd7570$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $e495bef284cd7570$var$BS_FINISH_STARTED;
        /***/ return $e495bef284cd7570$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $e495bef284cd7570$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $e495bef284cd7570$var$BS_NEED_MORE;
    /***/ }
    return $e495bef284cd7570$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $e495bef284cd7570$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $e495bef284cd7570$var$MAX_MATCH) {
            $e495bef284cd7570$var$fill_window(s);
            if (s.lookahead <= $e495bef284cd7570$var$MAX_MATCH && flush === $e495bef284cd7570$var$Z_NO_FLUSH) return $e495bef284cd7570$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $e495bef284cd7570$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $e495bef284cd7570$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $e495bef284cd7570$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $e495bef284cd7570$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $13e89365d5815482$export$b3cbce147289408f(s, 1, s.match_length - $e495bef284cd7570$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $13e89365d5815482$export$b3cbce147289408f(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $e495bef284cd7570$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $e495bef284cd7570$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $e495bef284cd7570$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $e495bef284cd7570$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $e495bef284cd7570$var$BS_FINISH_STARTED;
        /***/ return $e495bef284cd7570$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $e495bef284cd7570$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $e495bef284cd7570$var$BS_NEED_MORE;
    /***/ }
    return $e495bef284cd7570$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $e495bef284cd7570$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $e495bef284cd7570$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $e495bef284cd7570$var$Z_NO_FLUSH) return $e495bef284cd7570$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $13e89365d5815482$export$b3cbce147289408f(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $e495bef284cd7570$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $e495bef284cd7570$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $e495bef284cd7570$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $e495bef284cd7570$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $e495bef284cd7570$var$BS_FINISH_STARTED;
        /***/ return $e495bef284cd7570$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $e495bef284cd7570$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $e495bef284cd7570$var$BS_NEED_MORE;
    /***/ }
    return $e495bef284cd7570$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $e495bef284cd7570$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $e495bef284cd7570$var$configuration_table;
$e495bef284cd7570$var$configuration_table = [
    /*      good lazy nice chain */ new $e495bef284cd7570$var$Config(0, 0, 0, 0, $e495bef284cd7570$var$deflate_stored),
    /* 0 store only */ new $e495bef284cd7570$var$Config(4, 4, 8, 4, $e495bef284cd7570$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $e495bef284cd7570$var$Config(4, 5, 16, 8, $e495bef284cd7570$var$deflate_fast),
    /* 2 */ new $e495bef284cd7570$var$Config(4, 6, 32, 32, $e495bef284cd7570$var$deflate_fast),
    /* 3 */ new $e495bef284cd7570$var$Config(4, 4, 16, 16, $e495bef284cd7570$var$deflate_slow),
    /* 4 lazy matches */ new $e495bef284cd7570$var$Config(8, 16, 32, 32, $e495bef284cd7570$var$deflate_slow),
    /* 5 */ new $e495bef284cd7570$var$Config(8, 16, 128, 128, $e495bef284cd7570$var$deflate_slow),
    /* 6 */ new $e495bef284cd7570$var$Config(8, 32, 128, 256, $e495bef284cd7570$var$deflate_slow),
    /* 7 */ new $e495bef284cd7570$var$Config(32, 128, 258, 1024, $e495bef284cd7570$var$deflate_slow),
    /* 8 */ new $e495bef284cd7570$var$Config(32, 258, 258, 4096, $e495bef284cd7570$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $e495bef284cd7570$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $e495bef284cd7570$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $e495bef284cd7570$var$configuration_table[s.level].max_lazy;
    s.good_match = $e495bef284cd7570$var$configuration_table[s.level].good_length;
    s.nice_match = $e495bef284cd7570$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $e495bef284cd7570$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $e495bef284cd7570$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $e495bef284cd7570$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $e495bef284cd7570$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $e86641f1e3ca0827$exports.Buf16($e495bef284cd7570$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $e86641f1e3ca0827$exports.Buf16((2 * $e495bef284cd7570$var$D_CODES + 1) * 2);
    this.bl_tree = new $e86641f1e3ca0827$exports.Buf16((2 * $e495bef284cd7570$var$BL_CODES + 1) * 2);
    $e495bef284cd7570$var$zero(this.dyn_ltree);
    $e495bef284cd7570$var$zero(this.dyn_dtree);
    $e495bef284cd7570$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $e86641f1e3ca0827$exports.Buf16($e495bef284cd7570$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $e86641f1e3ca0827$exports.Buf16(2 * $e495bef284cd7570$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $e495bef284cd7570$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $e86641f1e3ca0827$exports.Buf16(2 * $e495bef284cd7570$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $e495bef284cd7570$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $e495bef284cd7570$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $e495bef284cd7570$var$err(strm, $e495bef284cd7570$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $e495bef284cd7570$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $e495bef284cd7570$var$INIT_STATE : $e495bef284cd7570$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $e495bef284cd7570$var$Z_NO_FLUSH;
    $13e89365d5815482$export$4e4fc0157c3cd14d(s);
    return $e495bef284cd7570$var$Z_OK;
}
function $e495bef284cd7570$var$deflateReset(strm) {
    var ret = $e495bef284cd7570$var$deflateResetKeep(strm);
    if (ret === $e495bef284cd7570$var$Z_OK) $e495bef284cd7570$var$lm_init(strm.state);
    return ret;
}
function $e495bef284cd7570$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $e495bef284cd7570$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $e495bef284cd7570$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $e495bef284cd7570$var$Z_OK;
}
function $e495bef284cd7570$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $e495bef284cd7570$var$Z_STREAM_ERROR;
    var wrap = 1;
    if (level === $e495bef284cd7570$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $e495bef284cd7570$var$MAX_MEM_LEVEL || method !== $e495bef284cd7570$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $e495bef284cd7570$var$Z_FIXED) return $e495bef284cd7570$var$err(strm, $e495bef284cd7570$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $e495bef284cd7570$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $e495bef284cd7570$var$MIN_MATCH - 1) / $e495bef284cd7570$var$MIN_MATCH);
    s.window = new $e86641f1e3ca0827$exports.Buf8(s.w_size * 2);
    s.head = new $e86641f1e3ca0827$exports.Buf16(s.hash_size);
    s.prev = new $e86641f1e3ca0827$exports.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $e86641f1e3ca0827$exports.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $e495bef284cd7570$var$deflateReset(strm);
}
function $e495bef284cd7570$var$deflateInit(strm, level) {
    return $e495bef284cd7570$var$deflateInit2(strm, level, $e495bef284cd7570$var$Z_DEFLATED, $e495bef284cd7570$var$MAX_WBITS, $e495bef284cd7570$var$DEF_MEM_LEVEL, $e495bef284cd7570$var$Z_DEFAULT_STRATEGY);
}
function $e495bef284cd7570$var$deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $e495bef284cd7570$var$Z_BLOCK || flush < 0) return strm ? $e495bef284cd7570$var$err(strm, $e495bef284cd7570$var$Z_STREAM_ERROR) : $e495bef284cd7570$var$Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $e495bef284cd7570$var$FINISH_STATE && flush !== $e495bef284cd7570$var$Z_FINISH) return $e495bef284cd7570$var$err(strm, strm.avail_out === 0 ? $e495bef284cd7570$var$Z_BUF_ERROR : $e495bef284cd7570$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $e495bef284cd7570$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $e495bef284cd7570$var$put_byte(s, 31);
            $e495bef284cd7570$var$put_byte(s, 139);
            $e495bef284cd7570$var$put_byte(s, 8);
            if (!s.gzhead) {
                $e495bef284cd7570$var$put_byte(s, 0);
                $e495bef284cd7570$var$put_byte(s, 0);
                $e495bef284cd7570$var$put_byte(s, 0);
                $e495bef284cd7570$var$put_byte(s, 0);
                $e495bef284cd7570$var$put_byte(s, 0);
                $e495bef284cd7570$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $e495bef284cd7570$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $e495bef284cd7570$var$put_byte(s, $e495bef284cd7570$var$OS_CODE);
                s.status = $e495bef284cd7570$var$BUSY_STATE;
            } else {
                $e495bef284cd7570$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $e495bef284cd7570$var$put_byte(s, s.gzhead.time & 0xff);
                $e495bef284cd7570$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $e495bef284cd7570$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $e495bef284cd7570$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $e495bef284cd7570$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $e495bef284cd7570$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $e495bef284cd7570$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $e495bef284cd7570$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $e495bef284cd7570$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $e5fbe17305865443$exports(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $e495bef284cd7570$var$EXTRA_STATE;
            }
        } else {
            var header = $e495bef284cd7570$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $e495bef284cd7570$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $e495bef284cd7570$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $e495bef284cd7570$var$BUSY_STATE;
            $e495bef284cd7570$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $e495bef284cd7570$var$putShortMSB(s, strm.adler >>> 16);
                $e495bef284cd7570$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $e495bef284cd7570$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $e5fbe17305865443$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $e495bef284cd7570$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $e495bef284cd7570$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $e5fbe17305865443$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $e495bef284cd7570$var$NAME_STATE;
            }
        } else s.status = $e495bef284cd7570$var$NAME_STATE;
    }
    if (s.status === $e495bef284cd7570$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $e5fbe17305865443$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $e495bef284cd7570$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $e495bef284cd7570$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $e5fbe17305865443$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $e495bef284cd7570$var$COMMENT_STATE;
            }
        } else s.status = $e495bef284cd7570$var$COMMENT_STATE;
    }
    if (s.status === $e495bef284cd7570$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $e5fbe17305865443$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $e495bef284cd7570$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $e495bef284cd7570$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $e5fbe17305865443$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $e495bef284cd7570$var$HCRC_STATE;
        } else s.status = $e495bef284cd7570$var$HCRC_STATE;
    }
    if (s.status === $e495bef284cd7570$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $e495bef284cd7570$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $e495bef284cd7570$var$put_byte(s, strm.adler & 0xff);
                $e495bef284cd7570$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $e495bef284cd7570$var$BUSY_STATE;
            }
        } else s.status = $e495bef284cd7570$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $e495bef284cd7570$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $e495bef284cd7570$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $e495bef284cd7570$var$rank(flush) <= $e495bef284cd7570$var$rank(old_flush) && flush !== $e495bef284cd7570$var$Z_FINISH) return $e495bef284cd7570$var$err(strm, $e495bef284cd7570$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $e495bef284cd7570$var$FINISH_STATE && strm.avail_in !== 0) return $e495bef284cd7570$var$err(strm, $e495bef284cd7570$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $e495bef284cd7570$var$Z_NO_FLUSH && s.status !== $e495bef284cd7570$var$FINISH_STATE) {
        var bstate = s.strategy === $e495bef284cd7570$var$Z_HUFFMAN_ONLY ? $e495bef284cd7570$var$deflate_huff(s, flush) : s.strategy === $e495bef284cd7570$var$Z_RLE ? $e495bef284cd7570$var$deflate_rle(s, flush) : $e495bef284cd7570$var$configuration_table[s.level].func(s, flush);
        if (bstate === $e495bef284cd7570$var$BS_FINISH_STARTED || bstate === $e495bef284cd7570$var$BS_FINISH_DONE) s.status = $e495bef284cd7570$var$FINISH_STATE;
        if (bstate === $e495bef284cd7570$var$BS_NEED_MORE || bstate === $e495bef284cd7570$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $e495bef284cd7570$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $e495bef284cd7570$var$BS_BLOCK_DONE) {
            if (flush === $e495bef284cd7570$var$Z_PARTIAL_FLUSH) $13e89365d5815482$export$bfb360e02ee9b403(s);
            else if (flush !== $e495bef284cd7570$var$Z_BLOCK) {
                $13e89365d5815482$export$8959e34c5e020172(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $e495bef284cd7570$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $e495bef284cd7570$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $e495bef284cd7570$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $e495bef284cd7570$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $e495bef284cd7570$var$Z_FINISH) return $e495bef284cd7570$var$Z_OK;
    if (s.wrap <= 0) return $e495bef284cd7570$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $e495bef284cd7570$var$put_byte(s, strm.adler & 0xff);
        $e495bef284cd7570$var$put_byte(s, strm.adler >> 8 & 0xff);
        $e495bef284cd7570$var$put_byte(s, strm.adler >> 16 & 0xff);
        $e495bef284cd7570$var$put_byte(s, strm.adler >> 24 & 0xff);
        $e495bef284cd7570$var$put_byte(s, strm.total_in & 0xff);
        $e495bef284cd7570$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $e495bef284cd7570$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $e495bef284cd7570$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $e495bef284cd7570$var$putShortMSB(s, strm.adler >>> 16);
        $e495bef284cd7570$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $e495bef284cd7570$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $e495bef284cd7570$var$Z_OK : $e495bef284cd7570$var$Z_STREAM_END;
}
function $e495bef284cd7570$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $e495bef284cd7570$var$Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== $e495bef284cd7570$var$INIT_STATE && status !== $e495bef284cd7570$var$EXTRA_STATE && status !== $e495bef284cd7570$var$NAME_STATE && status !== $e495bef284cd7570$var$COMMENT_STATE && status !== $e495bef284cd7570$var$HCRC_STATE && status !== $e495bef284cd7570$var$BUSY_STATE && status !== $e495bef284cd7570$var$FINISH_STATE) return $e495bef284cd7570$var$err(strm, $e495bef284cd7570$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $e495bef284cd7570$var$BUSY_STATE ? $e495bef284cd7570$var$err(strm, $e495bef284cd7570$var$Z_DATA_ERROR) : $e495bef284cd7570$var$Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $e495bef284cd7570$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $e495bef284cd7570$var$Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $e495bef284cd7570$var$INIT_STATE || s.lookahead) return $e495bef284cd7570$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $5cc01a61bf102ed9$exports(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $e495bef284cd7570$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $e86641f1e3ca0827$exports.Buf8(s.w_size);
        $e86641f1e3ca0827$exports.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $e495bef284cd7570$var$fill_window(s);
    while(s.lookahead >= $e495bef284cd7570$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($e495bef284cd7570$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $e495bef284cd7570$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $e495bef284cd7570$var$MIN_MATCH - 1;
        $e495bef284cd7570$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $e495bef284cd7570$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $e495bef284cd7570$var$Z_OK;
}
$e495bef284cd7570$export$72b35d618fb8ad9b = $e495bef284cd7570$var$deflateInit;
$e495bef284cd7570$export$a65c7b2bde87cb70 = $e495bef284cd7570$var$deflateInit2;
$e495bef284cd7570$export$8f99f0e30bc7dd53 = $e495bef284cd7570$var$deflateReset;
$e495bef284cd7570$export$e78fab288549509 = $e495bef284cd7570$var$deflateResetKeep;
$e495bef284cd7570$export$1cd50f7b2515ba19 = $e495bef284cd7570$var$deflateSetHeader;
$e495bef284cd7570$export$2316623ecd1285ab = $e495bef284cd7570$var$deflate;
$e495bef284cd7570$export$599854fa319a815f = $e495bef284cd7570$var$deflateEnd;
$e495bef284cd7570$export$f55e0b3ab66b5d46 = $e495bef284cd7570$var$deflateSetDictionary;
$e495bef284cd7570$export$12b6e1fcadea22f9 = 'pako deflate (from Nodeca project)'; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 



// String encode/decode helpers
// convert string to array (typed, when possible)
var $a59532d6e7e4c5fe$export$7a4c1b2f775b5a9f;
// Convert byte array to binary string
var $a59532d6e7e4c5fe$export$a751fe64af8a9a51;
// Convert binary string (typed, when possible)
var $a59532d6e7e4c5fe$export$1d1a7119601ff18c;
// convert array to string
var $a59532d6e7e4c5fe$export$49a50563f377746;
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $a59532d6e7e4c5fe$export$53dee3f58a714214;
'use strict';

// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var $a59532d6e7e4c5fe$var$STR_APPLY_OK = true;
var $a59532d6e7e4c5fe$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, [
        0
    ]);
} catch (__) {
    $a59532d6e7e4c5fe$var$STR_APPLY_OK = false;
}
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $a59532d6e7e4c5fe$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var $a59532d6e7e4c5fe$var$_utf8len = new $e86641f1e3ca0827$exports.Buf8(256);
for(var $a59532d6e7e4c5fe$var$q = 0; $a59532d6e7e4c5fe$var$q < 256; $a59532d6e7e4c5fe$var$q++)$a59532d6e7e4c5fe$var$_utf8len[$a59532d6e7e4c5fe$var$q] = $a59532d6e7e4c5fe$var$q >= 252 ? 6 : $a59532d6e7e4c5fe$var$q >= 248 ? 5 : $a59532d6e7e4c5fe$var$q >= 240 ? 4 : $a59532d6e7e4c5fe$var$q >= 224 ? 3 : $a59532d6e7e4c5fe$var$q >= 192 ? 2 : 1;
$a59532d6e7e4c5fe$var$_utf8len[254] = $a59532d6e7e4c5fe$var$_utf8len[254] = 1; // Invalid sequence start
$a59532d6e7e4c5fe$export$7a4c1b2f775b5a9f = function(str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new $e86641f1e3ca0827$exports.Buf8(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper (used in 2 places)
function $a59532d6e7e4c5fe$var$buf2binstring(buf, len) {
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $a59532d6e7e4c5fe$var$STR_APPLY_UIA_OK || !buf.subarray && $a59532d6e7e4c5fe$var$STR_APPLY_OK) return String.fromCharCode.apply(null, $e86641f1e3ca0827$exports.shrinkBuf(buf, len));
    }
    var result = '';
    for(var i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
}
$a59532d6e7e4c5fe$export$a751fe64af8a9a51 = function(buf) {
    return $a59532d6e7e4c5fe$var$buf2binstring(buf, buf.length);
};
$a59532d6e7e4c5fe$export$1d1a7119601ff18c = function(str) {
    var buf = new $e86641f1e3ca0827$exports.Buf8(str.length);
    for(var i = 0, len = buf.length; i < len; i++)buf[i] = str.charCodeAt(i);
    return buf;
};
$a59532d6e7e4c5fe$export$49a50563f377746 = function(buf, max) {
    var i, out, c, c_len;
    var len = max || buf.length;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        c_len = $a59532d6e7e4c5fe$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $a59532d6e7e4c5fe$var$buf2binstring(utf16buf, out);
};
$a59532d6e7e4c5fe$export$53dee3f58a714214 = function(buf, max) {
    var pos;
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $a59532d6e7e4c5fe$var$_utf8len[buf[pos]] > max ? pos : max;
};



var $76a04ab8bd5fb26d$exports = {};
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $76a04ab8bd5fb26d$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
$76a04ab8bd5fb26d$exports = $76a04ab8bd5fb26d$var$ZStream;


var $3c01dc77ae4a7667$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $3c01dc77ae4a7667$var$Z_NO_FLUSH = 0;
var $3c01dc77ae4a7667$var$Z_FINISH = 4;
var $3c01dc77ae4a7667$var$Z_OK = 0;
var $3c01dc77ae4a7667$var$Z_STREAM_END = 1;
var $3c01dc77ae4a7667$var$Z_SYNC_FLUSH = 2;
var $3c01dc77ae4a7667$var$Z_DEFAULT_COMPRESSION = -1;
var $3c01dc77ae4a7667$var$Z_DEFAULT_STRATEGY = 0;
var $3c01dc77ae4a7667$var$Z_DEFLATED = 8;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $3c01dc77ae4a7667$var$Deflate(options) {
    if (!(this instanceof $3c01dc77ae4a7667$var$Deflate)) return new $3c01dc77ae4a7667$var$Deflate(options);
    this.options = $e86641f1e3ca0827$exports.assign({
        level: $3c01dc77ae4a7667$var$Z_DEFAULT_COMPRESSION,
        method: $3c01dc77ae4a7667$var$Z_DEFLATED,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $3c01dc77ae4a7667$var$Z_DEFAULT_STRATEGY,
        to: ''
    }, options || {});
    var opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $76a04ab8bd5fb26d$exports();
    this.strm.avail_out = 0;
    var status = $e495bef284cd7570$export$a65c7b2bde87cb70(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $3c01dc77ae4a7667$var$Z_OK) throw new Error($846829610f0eaf86$exports[status]);
    if (opt.header) $e495bef284cd7570$export$1cd50f7b2515ba19(this.strm, opt.header);
    if (opt.dictionary) {
        var dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
        dict = $a59532d6e7e4c5fe$export$7a4c1b2f775b5a9f(opt.dictionary);
        else if ($3c01dc77ae4a7667$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $e495bef284cd7570$export$f55e0b3ab66b5d46(this.strm, dict);
        if (status !== $3c01dc77ae4a7667$var$Z_OK) throw new Error($846829610f0eaf86$exports[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $3c01dc77ae4a7667$var$Deflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var status, _mode;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $3c01dc77ae4a7667$var$Z_FINISH : $3c01dc77ae4a7667$var$Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
    strm.input = $a59532d6e7e4c5fe$export$7a4c1b2f775b5a9f(data);
    else if ($3c01dc77ae4a7667$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $e86641f1e3ca0827$exports.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $e495bef284cd7570$export$2316623ecd1285ab(strm, _mode); /* no bad return value */ 
        if (status !== $3c01dc77ae4a7667$var$Z_STREAM_END && status !== $3c01dc77ae4a7667$var$Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === $3c01dc77ae4a7667$var$Z_FINISH || _mode === $3c01dc77ae4a7667$var$Z_SYNC_FLUSH)) {
            if (this.options.to === 'string') this.onData($a59532d6e7e4c5fe$export$a751fe64af8a9a51($e86641f1e3ca0827$exports.shrinkBuf(strm.output, strm.next_out)));
            else this.onData($e86641f1e3ca0827$exports.shrinkBuf(strm.output, strm.next_out));
        }
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $3c01dc77ae4a7667$var$Z_STREAM_END);
    // Finalize on the last chunk.
    if (_mode === $3c01dc77ae4a7667$var$Z_FINISH) {
        status = $e495bef284cd7570$export$599854fa319a815f(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $3c01dc77ae4a7667$var$Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $3c01dc77ae4a7667$var$Z_SYNC_FLUSH) {
        this.onEnd($3c01dc77ae4a7667$var$Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $3c01dc77ae4a7667$var$Deflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $3c01dc77ae4a7667$var$Deflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $3c01dc77ae4a7667$var$Z_OK) {
        if (this.options.to === 'string') this.result = this.chunks.join('');
        else this.result = $e86641f1e3ca0827$exports.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $3c01dc77ae4a7667$var$deflate(input, options) {
    var deflator = new $3c01dc77ae4a7667$var$Deflate(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $846829610f0eaf86$exports[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $3c01dc77ae4a7667$var$deflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $3c01dc77ae4a7667$var$deflate(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $3c01dc77ae4a7667$var$gzip(input, options) {
    options = options || {};
    options.gzip = true;
    return $3c01dc77ae4a7667$var$deflate(input, options);
}
$3c01dc77ae4a7667$export$ae157b6234afe138 = $3c01dc77ae4a7667$var$Deflate;
$3c01dc77ae4a7667$export$2316623ecd1285ab = $3c01dc77ae4a7667$var$deflate;
$3c01dc77ae4a7667$export$e95d6a8f69fb340a = $3c01dc77ae4a7667$var$deflateRaw;
$3c01dc77ae4a7667$export$69f0ea7cf3a331a8 = $3c01dc77ae4a7667$var$gzip;


var $cf945df51e8a74d6$exports = {};

$parcel$export($cf945df51e8a74d6$exports, "Inflate", function () { return $cf945df51e8a74d6$export$d1de70a877d6e43c; }, function (v) { return $cf945df51e8a74d6$export$d1de70a877d6e43c = v; });
$parcel$export($cf945df51e8a74d6$exports, "inflate", function () { return $cf945df51e8a74d6$export$cae1ce83fe4a1782; }, function (v) { return $cf945df51e8a74d6$export$cae1ce83fe4a1782 = v; });
$parcel$export($cf945df51e8a74d6$exports, "inflateRaw", function () { return $cf945df51e8a74d6$export$d0f0aa2d05c905c5; }, function (v) { return $cf945df51e8a74d6$export$d0f0aa2d05c905c5 = v; });
$parcel$export($cf945df51e8a74d6$exports, "ungzip", function () { return $cf945df51e8a74d6$export$95adf9d270383091; }, function (v) { return $cf945df51e8a74d6$export$95adf9d270383091 = v; });
/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $cf945df51e8a74d6$export$d1de70a877d6e43c;
var $cf945df51e8a74d6$export$cae1ce83fe4a1782;
var $cf945df51e8a74d6$export$d0f0aa2d05c905c5;
var $cf945df51e8a74d6$export$95adf9d270383091;
'use strict';
var $5529404c20db1eb4$export$42de45683a92ba94;
var $5529404c20db1eb4$export$7633ac2cd30f9650;
var $5529404c20db1eb4$export$6710ea52c4ec9d6a;
var $5529404c20db1eb4$export$9c140b25e26874f9;
var $5529404c20db1eb4$export$6792d92addc5c8a0;
var $5529404c20db1eb4$export$cae1ce83fe4a1782;
var $5529404c20db1eb4$export$224e1a443c3fba76;
var $5529404c20db1eb4$export$6d4647cb9e1c75fc;
var $5529404c20db1eb4$export$60da749bed98ccf8;
var $5529404c20db1eb4$export$220f6291ca35fd71;
'use strict';



var $72c02aaaa2fe0102$exports = {};
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $72c02aaaa2fe0102$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $72c02aaaa2fe0102$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ $72c02aaaa2fe0102$exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $72c02aaaa2fe0102$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $72c02aaaa2fe0102$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $72c02aaaa2fe0102$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $72c02aaaa2fe0102$var$TYPE;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $72c02aaaa2fe0102$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};


var $342aadb006748e20$exports = {};
'use strict';

var $342aadb006748e20$var$MAXBITS = 15;
var $342aadb006748e20$var$ENOUGH_LENS = 852;
var $342aadb006748e20$var$ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $342aadb006748e20$var$CODES = 0;
var $342aadb006748e20$var$LENS = 1;
var $342aadb006748e20$var$DISTS = 2;
var $342aadb006748e20$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $342aadb006748e20$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $342aadb006748e20$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $342aadb006748e20$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
$342aadb006748e20$exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $e86641f1e3ca0827$exports.Buf16($342aadb006748e20$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $e86641f1e3ca0827$exports.Buf16($342aadb006748e20$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $342aadb006748e20$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $342aadb006748e20$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $342aadb006748e20$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $342aadb006748e20$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $342aadb006748e20$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $342aadb006748e20$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $342aadb006748e20$var$LENS) {
        base = $342aadb006748e20$var$lbase;
        base_index -= 257;
        extra = $342aadb006748e20$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $342aadb006748e20$var$dbase;
        extra = $342aadb006748e20$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $342aadb006748e20$var$LENS && used > $342aadb006748e20$var$ENOUGH_LENS || type === $342aadb006748e20$var$DISTS && used > $342aadb006748e20$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $342aadb006748e20$var$LENS && used > $342aadb006748e20$var$ENOUGH_LENS || type === $342aadb006748e20$var$DISTS && used > $342aadb006748e20$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};


var $5529404c20db1eb4$var$CODES = 0;
var $5529404c20db1eb4$var$LENS = 1;
var $5529404c20db1eb4$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $5529404c20db1eb4$var$Z_FINISH = 4;
var $5529404c20db1eb4$var$Z_BLOCK = 5;
var $5529404c20db1eb4$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $5529404c20db1eb4$var$Z_OK = 0;
var $5529404c20db1eb4$var$Z_STREAM_END = 1;
var $5529404c20db1eb4$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $5529404c20db1eb4$var$Z_STREAM_ERROR = -2;
var $5529404c20db1eb4$var$Z_DATA_ERROR = -3;
var $5529404c20db1eb4$var$Z_MEM_ERROR = -4;
var $5529404c20db1eb4$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $5529404c20db1eb4$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $5529404c20db1eb4$var$HEAD = 1; /* i: waiting for magic header */ 
var $5529404c20db1eb4$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $5529404c20db1eb4$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $5529404c20db1eb4$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $5529404c20db1eb4$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $5529404c20db1eb4$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $5529404c20db1eb4$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $5529404c20db1eb4$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $5529404c20db1eb4$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $5529404c20db1eb4$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $5529404c20db1eb4$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $5529404c20db1eb4$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $5529404c20db1eb4$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $5529404c20db1eb4$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $5529404c20db1eb4$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $5529404c20db1eb4$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $5529404c20db1eb4$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $5529404c20db1eb4$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $5529404c20db1eb4$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $5529404c20db1eb4$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $5529404c20db1eb4$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $5529404c20db1eb4$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $5529404c20db1eb4$var$DIST = 23; /* i: waiting for distance code */ 
var $5529404c20db1eb4$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $5529404c20db1eb4$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $5529404c20db1eb4$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $5529404c20db1eb4$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $5529404c20db1eb4$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $5529404c20db1eb4$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $5529404c20db1eb4$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $5529404c20db1eb4$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $5529404c20db1eb4$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $5529404c20db1eb4$var$ENOUGH_LENS = 852;
var $5529404c20db1eb4$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $5529404c20db1eb4$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $5529404c20db1eb4$var$DEF_WBITS = $5529404c20db1eb4$var$MAX_WBITS;
function $5529404c20db1eb4$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $5529404c20db1eb4$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $e86641f1e3ca0827$exports.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $e86641f1e3ca0827$exports.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $5529404c20db1eb4$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $5529404c20db1eb4$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $5529404c20db1eb4$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $e86641f1e3ca0827$exports.Buf32($5529404c20db1eb4$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $e86641f1e3ca0827$exports.Buf32($5529404c20db1eb4$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $5529404c20db1eb4$var$Z_OK;
}
function $5529404c20db1eb4$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $5529404c20db1eb4$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $5529404c20db1eb4$var$inflateResetKeep(strm);
}
function $5529404c20db1eb4$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $5529404c20db1eb4$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $5529404c20db1eb4$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $5529404c20db1eb4$var$inflateReset(strm);
}
function $5529404c20db1eb4$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $5529404c20db1eb4$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $5529404c20db1eb4$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $5529404c20db1eb4$var$inflateReset2(strm, windowBits);
    if (ret !== $5529404c20db1eb4$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $5529404c20db1eb4$var$inflateInit(strm) {
    return $5529404c20db1eb4$var$inflateInit2(strm, $5529404c20db1eb4$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $5529404c20db1eb4$var$virgin = true;
var $5529404c20db1eb4$var$lenfix, $5529404c20db1eb4$var$distfix; // We have no pointers in JS, so keep tables separate
function $5529404c20db1eb4$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($5529404c20db1eb4$var$virgin) {
        var sym;
        $5529404c20db1eb4$var$lenfix = new $e86641f1e3ca0827$exports.Buf32(512);
        $5529404c20db1eb4$var$distfix = new $e86641f1e3ca0827$exports.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $342aadb006748e20$exports($5529404c20db1eb4$var$LENS, state.lens, 0, 288, $5529404c20db1eb4$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $342aadb006748e20$exports($5529404c20db1eb4$var$DISTS, state.lens, 0, 32, $5529404c20db1eb4$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $5529404c20db1eb4$var$virgin = false;
    }
    state.lencode = $5529404c20db1eb4$var$lenfix;
    state.lenbits = 9;
    state.distcode = $5529404c20db1eb4$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $5529404c20db1eb4$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $e86641f1e3ca0827$exports.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $e86641f1e3ca0827$exports.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $e86641f1e3ca0827$exports.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $e86641f1e3ca0827$exports.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $5529404c20db1eb4$var$inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $e86641f1e3ca0827$exports.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $5529404c20db1eb4$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $5529404c20db1eb4$var$TYPE) state.mode = $5529404c20db1eb4$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $5529404c20db1eb4$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $5529404c20db1eb4$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $5529404c20db1eb4$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $e5fbe17305865443$exports(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $5529404c20db1eb4$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $5529404c20db1eb4$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $5529404c20db1eb4$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $5529404c20db1eb4$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $5529404c20db1eb4$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $5529404c20db1eb4$var$DICTID : $5529404c20db1eb4$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $5529404c20db1eb4$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $5529404c20db1eb4$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $5529404c20db1eb4$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $5529404c20db1eb4$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $e5fbe17305865443$exports(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $5529404c20db1eb4$var$TIME;
        /* falls through */ case $5529404c20db1eb4$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $e5fbe17305865443$exports(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $5529404c20db1eb4$var$OS;
        /* falls through */ case $5529404c20db1eb4$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $e5fbe17305865443$exports(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $5529404c20db1eb4$var$EXLEN;
        /* falls through */ case $5529404c20db1eb4$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $e5fbe17305865443$exports(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $5529404c20db1eb4$var$EXTRA;
        /* falls through */ case $5529404c20db1eb4$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $e86641f1e3ca0827$exports.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $e5fbe17305865443$exports(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $5529404c20db1eb4$var$NAME;
        /* falls through */ case $5529404c20db1eb4$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $e5fbe17305865443$exports(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $5529404c20db1eb4$var$COMMENT;
        /* falls through */ case $5529404c20db1eb4$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $e5fbe17305865443$exports(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $5529404c20db1eb4$var$HCRC;
        /* falls through */ case $5529404c20db1eb4$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $5529404c20db1eb4$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $5529404c20db1eb4$var$TYPE;
            break;
        case $5529404c20db1eb4$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $5529404c20db1eb4$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $5529404c20db1eb4$var$DICT;
        /* falls through */ case $5529404c20db1eb4$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $5529404c20db1eb4$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $5529404c20db1eb4$var$TYPE;
        /* falls through */ case $5529404c20db1eb4$var$TYPE:
            if (flush === $5529404c20db1eb4$var$Z_BLOCK || flush === $5529404c20db1eb4$var$Z_TREES) break inf_leave;
        /* falls through */ case $5529404c20db1eb4$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $5529404c20db1eb4$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $5529404c20db1eb4$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $5529404c20db1eb4$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $5529404c20db1eb4$var$LEN_; /* decode codes */ 
                    if (flush === $5529404c20db1eb4$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $5529404c20db1eb4$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $5529404c20db1eb4$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $5529404c20db1eb4$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $5529404c20db1eb4$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $5529404c20db1eb4$var$COPY_;
            if (flush === $5529404c20db1eb4$var$Z_TREES) break inf_leave;
        /* falls through */ case $5529404c20db1eb4$var$COPY_:
            state.mode = $5529404c20db1eb4$var$COPY;
        /* falls through */ case $5529404c20db1eb4$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $e86641f1e3ca0827$exports.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $5529404c20db1eb4$var$TYPE;
            break;
        case $5529404c20db1eb4$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $5529404c20db1eb4$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $5529404c20db1eb4$var$LENLENS;
        /* falls through */ case $5529404c20db1eb4$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $342aadb006748e20$exports($5529404c20db1eb4$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $5529404c20db1eb4$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $5529404c20db1eb4$var$CODELENS;
        /* falls through */ case $5529404c20db1eb4$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $5529404c20db1eb4$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $5529404c20db1eb4$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $5529404c20db1eb4$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $5529404c20db1eb4$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $342aadb006748e20$exports($5529404c20db1eb4$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $5529404c20db1eb4$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $342aadb006748e20$exports($5529404c20db1eb4$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $5529404c20db1eb4$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $5529404c20db1eb4$var$LEN_;
            if (flush === $5529404c20db1eb4$var$Z_TREES) break inf_leave;
        /* falls through */ case $5529404c20db1eb4$var$LEN_:
            state.mode = $5529404c20db1eb4$var$LEN;
        /* falls through */ case $5529404c20db1eb4$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $72c02aaaa2fe0102$exports(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $5529404c20db1eb4$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $5529404c20db1eb4$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $5529404c20db1eb4$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $5529404c20db1eb4$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $5529404c20db1eb4$var$LENEXT;
        /* falls through */ case $5529404c20db1eb4$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $5529404c20db1eb4$var$DIST;
        /* falls through */ case $5529404c20db1eb4$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $5529404c20db1eb4$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $5529404c20db1eb4$var$DISTEXT;
        /* falls through */ case $5529404c20db1eb4$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $5529404c20db1eb4$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $5529404c20db1eb4$var$MATCH;
        /* falls through */ case $5529404c20db1eb4$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $5529404c20db1eb4$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $5529404c20db1eb4$var$LEN;
            break;
        case $5529404c20db1eb4$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $5529404c20db1eb4$var$LEN;
            break;
        case $5529404c20db1eb4$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $e5fbe17305865443$exports(state.check, output, _out, put - _out) : $5cc01a61bf102ed9$exports(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $5529404c20db1eb4$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $5529404c20db1eb4$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $5529404c20db1eb4$var$LENGTH;
        /* falls through */ case $5529404c20db1eb4$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $5529404c20db1eb4$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $5529404c20db1eb4$var$DONE;
        /* falls through */ case $5529404c20db1eb4$var$DONE:
            ret = $5529404c20db1eb4$var$Z_STREAM_END;
            break inf_leave;
        case $5529404c20db1eb4$var$BAD:
            ret = $5529404c20db1eb4$var$Z_DATA_ERROR;
            break inf_leave;
        case $5529404c20db1eb4$var$MEM:
            return $5529404c20db1eb4$var$Z_MEM_ERROR;
        case $5529404c20db1eb4$var$SYNC:
        /* falls through */ default:
            return $5529404c20db1eb4$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $5529404c20db1eb4$var$BAD && (state.mode < $5529404c20db1eb4$var$CHECK || flush !== $5529404c20db1eb4$var$Z_FINISH)) {
        if ($5529404c20db1eb4$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $5529404c20db1eb4$var$MEM;
            return $5529404c20db1eb4$var$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $e5fbe17305865443$exports(state.check, output, _out, strm.next_out - _out) : $5cc01a61bf102ed9$exports(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $5529404c20db1eb4$var$TYPE ? 128 : 0) + (state.mode === $5529404c20db1eb4$var$LEN_ || state.mode === $5529404c20db1eb4$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $5529404c20db1eb4$var$Z_FINISH) && ret === $5529404c20db1eb4$var$Z_OK) ret = $5529404c20db1eb4$var$Z_BUF_ERROR;
    return ret;
}
function $5529404c20db1eb4$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $5529404c20db1eb4$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $5529404c20db1eb4$var$Z_OK;
}
function $5529404c20db1eb4$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $5529404c20db1eb4$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $5529404c20db1eb4$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $5529404c20db1eb4$var$Z_OK;
}
function $5529404c20db1eb4$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $5529404c20db1eb4$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $5529404c20db1eb4$var$DICT) return $5529404c20db1eb4$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $5529404c20db1eb4$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $5cc01a61bf102ed9$exports(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $5529404c20db1eb4$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $5529404c20db1eb4$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $5529404c20db1eb4$var$MEM;
        return $5529404c20db1eb4$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $5529404c20db1eb4$var$Z_OK;
}
$5529404c20db1eb4$export$42de45683a92ba94 = $5529404c20db1eb4$var$inflateReset;
$5529404c20db1eb4$export$7633ac2cd30f9650 = $5529404c20db1eb4$var$inflateReset2;
$5529404c20db1eb4$export$6710ea52c4ec9d6a = $5529404c20db1eb4$var$inflateResetKeep;
$5529404c20db1eb4$export$9c140b25e26874f9 = $5529404c20db1eb4$var$inflateInit;
$5529404c20db1eb4$export$6792d92addc5c8a0 = $5529404c20db1eb4$var$inflateInit2;
$5529404c20db1eb4$export$cae1ce83fe4a1782 = $5529404c20db1eb4$var$inflate;
$5529404c20db1eb4$export$224e1a443c3fba76 = $5529404c20db1eb4$var$inflateEnd;
$5529404c20db1eb4$export$6d4647cb9e1c75fc = $5529404c20db1eb4$var$inflateGetHeader;
$5529404c20db1eb4$export$60da749bed98ccf8 = $5529404c20db1eb4$var$inflateSetDictionary;
$5529404c20db1eb4$export$220f6291ca35fd71 = 'pako inflate (from Nodeca project)'; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 




var $3585379d4cb8e602$exports = {};
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
$3585379d4cb8e602$exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};




var $8c3e632180ef8115$exports = {};
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $8c3e632180ef8115$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
$8c3e632180ef8115$exports = $8c3e632180ef8115$var$GZheader;


var $cf945df51e8a74d6$var$toString = Object.prototype.toString;
/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $cf945df51e8a74d6$var$Inflate(options) {
    if (!(this instanceof $cf945df51e8a74d6$var$Inflate)) return new $cf945df51e8a74d6$var$Inflate(options);
    this.options = $e86641f1e3ca0827$exports.assign({
        chunkSize: 16384,
        windowBits: 0,
        to: ''
    }, options || {});
    var opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $76a04ab8bd5fb26d$exports();
    this.strm.avail_out = 0;
    var status = $5529404c20db1eb4$export$6792d92addc5c8a0(this.strm, opt.windowBits);
    if (status !== $3585379d4cb8e602$exports.Z_OK) throw new Error($846829610f0eaf86$exports[status]);
    this.header = new $8c3e632180ef8115$exports();
    $5529404c20db1eb4$export$6d4647cb9e1c75fc(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') opt.dictionary = $a59532d6e7e4c5fe$export$7a4c1b2f775b5a9f(opt.dictionary);
        else if ($cf945df51e8a74d6$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $5529404c20db1eb4$export$60da749bed98ccf8(this.strm, opt.dictionary);
            if (status !== $3585379d4cb8e602$exports.Z_OK) throw new Error($846829610f0eaf86$exports[status]);
        }
    }
}
/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $cf945df51e8a74d6$var$Inflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var dictionary = this.options.dictionary;
    var status, _mode;
    var next_out_utf8, tail, utf8str;
    // Flag to properly process Z_BUF_ERROR on testing inflate call
    // when we check that all output data was flushed.
    var allowBufError = false;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $3585379d4cb8e602$exports.Z_FINISH : $3585379d4cb8e602$exports.Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // Only binary strings can be decompressed on practice
    strm.input = $a59532d6e7e4c5fe$export$1d1a7119601ff18c(data);
    else if ($cf945df51e8a74d6$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $e86641f1e3ca0827$exports.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $5529404c20db1eb4$export$cae1ce83fe4a1782(strm, $3585379d4cb8e602$exports.Z_NO_FLUSH); /* no bad return value */ 
        if (status === $3585379d4cb8e602$exports.Z_NEED_DICT && dictionary) status = $5529404c20db1eb4$export$60da749bed98ccf8(this.strm, dictionary);
        if (status === $3585379d4cb8e602$exports.Z_BUF_ERROR && allowBufError === true) {
            status = $3585379d4cb8e602$exports.Z_OK;
            allowBufError = false;
        }
        if (status !== $3585379d4cb8e602$exports.Z_STREAM_END && status !== $3585379d4cb8e602$exports.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $3585379d4cb8e602$exports.Z_STREAM_END || strm.avail_in === 0 && (_mode === $3585379d4cb8e602$exports.Z_FINISH || _mode === $3585379d4cb8e602$exports.Z_SYNC_FLUSH)) {
                if (this.options.to === 'string') {
                    next_out_utf8 = $a59532d6e7e4c5fe$export$53dee3f58a714214(strm.output, strm.next_out);
                    tail = strm.next_out - next_out_utf8;
                    utf8str = $a59532d6e7e4c5fe$export$49a50563f377746(strm.output, next_out_utf8);
                    // move tail
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) $e86641f1e3ca0827$exports.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                    this.onData(utf8str);
                } else this.onData($e86641f1e3ca0827$exports.shrinkBuf(strm.output, strm.next_out));
            }
        }
        // When no more input data, we should check that internal inflate buffers
        // are flushed. The only way to do it when avail_out = 0 - run one more
        // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
        // Here we set flag to process this error properly.
        //
        // NOTE. Deflate does not return error in this case and does not needs such
        // logic.
        if (strm.avail_in === 0 && strm.avail_out === 0) allowBufError = true;
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $3585379d4cb8e602$exports.Z_STREAM_END);
    if (status === $3585379d4cb8e602$exports.Z_STREAM_END) _mode = $3585379d4cb8e602$exports.Z_FINISH;
    // Finalize on the last chunk.
    if (_mode === $3585379d4cb8e602$exports.Z_FINISH) {
        status = $5529404c20db1eb4$export$224e1a443c3fba76(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $3585379d4cb8e602$exports.Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $3585379d4cb8e602$exports.Z_SYNC_FLUSH) {
        this.onEnd($3585379d4cb8e602$exports.Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $cf945df51e8a74d6$var$Inflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $cf945df51e8a74d6$var$Inflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $3585379d4cb8e602$exports.Z_OK) {
        if (this.options.to === 'string') // Glue & convert here, until we teach pako to send
        // utf8 aligned strings to onData
        this.result = this.chunks.join('');
        else this.result = $e86641f1e3ca0827$exports.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/ function $cf945df51e8a74d6$var$inflate(input, options) {
    var inflator = new $cf945df51e8a74d6$var$Inflate(options);
    inflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $846829610f0eaf86$exports[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $cf945df51e8a74d6$var$inflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $cf945df51e8a74d6$var$inflate(input, options);
}
$cf945df51e8a74d6$export$d1de70a877d6e43c = $cf945df51e8a74d6$var$Inflate;
$cf945df51e8a74d6$export$cae1ce83fe4a1782 = $cf945df51e8a74d6$var$inflate;
$cf945df51e8a74d6$export$d0f0aa2d05c905c5 = $cf945df51e8a74d6$var$inflateRaw;
$cf945df51e8a74d6$export$95adf9d270383091 = $cf945df51e8a74d6$var$inflate;



var $f68f50851d9a8a51$var$pako = {};
$f68f50851d9a8a51$require$assign($f68f50851d9a8a51$var$pako, $3c01dc77ae4a7667$exports, $cf945df51e8a74d6$exports, $3585379d4cb8e602$exports);
$f68f50851d9a8a51$exports = $f68f50851d9a8a51$var$pako;



var $8KH3B = parcelRequire("8KH3B");
parcelRequire("5bpFt");
var $8hWZH = parcelRequire("8hWZH");
var $526f381db166a209$var$PDFHeader = /** @class */ function() {
    function PDFHeader(major, minor) {
        this.major = String(major);
        this.minor = String(minor);
    }
    PDFHeader.prototype.toString = function() {
        var bc = (0, $8hWZH.charFromCode)(129);
        return "%PDF-" + this.major + "." + this.minor + "\n%" + bc + bc + bc + bc;
    };
    PDFHeader.prototype.sizeInBytes = function() {
        return 12 + this.major.length + this.minor.length;
    };
    PDFHeader.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8KH3B.default).Percent;
        buffer[offset++] = (0, $8KH3B.default).P;
        buffer[offset++] = (0, $8KH3B.default).D;
        buffer[offset++] = (0, $8KH3B.default).F;
        buffer[offset++] = (0, $8KH3B.default).Dash;
        offset += (0, $8hWZH.copyStringIntoBuffer)(this.major, buffer, offset);
        buffer[offset++] = (0, $8KH3B.default).Period;
        offset += (0, $8hWZH.copyStringIntoBuffer)(this.minor, buffer, offset);
        buffer[offset++] = (0, $8KH3B.default).Newline;
        buffer[offset++] = (0, $8KH3B.default).Percent;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        return offset - initialOffset;
    };
    PDFHeader.forVersion = function(major, minor) {
        return new PDFHeader(major, minor);
    };
    return PDFHeader;
}();
var $526f381db166a209$export$2e2bcd8739ae039 = $526f381db166a209$var$PDFHeader;



var $iMObG = parcelRequire("iMObG");

var $dj8f2 = parcelRequire("dj8f2");

var $63sxC = parcelRequire("63sxC");

var $273XO = parcelRequire("273XO");

var $alPcq = parcelRequire("alPcq");

var $273XO = parcelRequire("273XO");

var $eKLLF = parcelRequire("eKLLF");

var $8KH3B = parcelRequire("8KH3B");
var $634bbd76d2b867c9$var$PDFNull = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFNull, _super);
    function PDFNull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFNull.prototype.asNull = function() {
        return null;
    };
    PDFNull.prototype.clone = function() {
        return this;
    };
    PDFNull.prototype.toString = function() {
        return 'null';
    };
    PDFNull.prototype.sizeInBytes = function() {
        return 4;
    };
    PDFNull.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $8KH3B.default).n;
        buffer[offset++] = (0, $8KH3B.default).u;
        buffer[offset++] = (0, $8KH3B.default).l;
        buffer[offset++] = (0, $8KH3B.default).l;
        return 4;
    };
    return PDFNull;
}((0, $eKLLF.default));
var $634bbd76d2b867c9$export$2e2bcd8739ae039 = new $634bbd76d2b867c9$var$PDFNull();



var $eKLLF = parcelRequire("eKLLF");

var $8KH3B = parcelRequire("8KH3B");
var $b7e75d63d5628aec$var$PDFDict = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFDict, _super);
    function PDFDict(map, context) {
        var _this = _super.call(this) || this;
        _this.dict = map;
        _this.context = context;
        return _this;
    }
    PDFDict.prototype.keys = function() {
        return Array.from(this.dict.keys());
    };
    PDFDict.prototype.values = function() {
        return Array.from(this.dict.values());
    };
    PDFDict.prototype.entries = function() {
        return Array.from(this.dict.entries());
    };
    PDFDict.prototype.set = function(key, value) {
        this.dict.set(key, value);
    };
    PDFDict.prototype.get = function(key, // TODO: `preservePDFNull` is for backwards compatibility. Should be
    // removed in next breaking API change.
    preservePDFNull) {
        if (preservePDFNull === void 0) preservePDFNull = false;
        var value = this.dict.get(key);
        if (value === (0, $634bbd76d2b867c9$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.has = function(key) {
        var value = this.dict.get(key);
        return value !== undefined && value !== (0, $634bbd76d2b867c9$export$2e2bcd8739ae039);
    };
    PDFDict.prototype.lookupMaybe = function(key) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $634bbd76d2b867c9$export$2e2bcd8739ae039));
        var value = (_a = this.context).lookupMaybe.apply(_a, (0, $273XO.__spreadArrays)([
            this.get(key, preservePDFNull)
        ], types));
        if (value === (0, $634bbd76d2b867c9$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.lookup = function(key) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $634bbd76d2b867c9$export$2e2bcd8739ae039));
        var value = (_a = this.context).lookup.apply(_a, (0, $273XO.__spreadArrays)([
            this.get(key, preservePDFNull)
        ], types));
        if (value === (0, $634bbd76d2b867c9$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.delete = function(key) {
        return this.dict.delete(key);
    };
    PDFDict.prototype.asMap = function() {
        return new Map(this.dict);
    };
    /** Generate a random key that doesn't exist in current key set */ PDFDict.prototype.uniqueKey = function(tag) {
        if (tag === void 0) tag = '';
        var existingKeys = this.keys();
        var key = (0, $alPcq.default).of(this.context.addRandomSuffix(tag, 10));
        while(existingKeys.includes(key))key = (0, $alPcq.default).of(this.context.addRandomSuffix(tag, 10));
        return key;
    };
    PDFDict.prototype.clone = function(context) {
        var clone = PDFDict.withContext(context || this.context);
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            clone.set(key, value);
        }
        return clone;
    };
    PDFDict.prototype.toString = function() {
        var dictString = '<<\n';
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            dictString += key.toString() + ' ' + value.toString() + '\n';
        }
        dictString += '>>';
        return dictString;
    };
    PDFDict.prototype.sizeInBytes = function() {
        var size = 5;
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            size += key.sizeInBytes() + value.sizeInBytes() + 2;
        }
        return size;
    };
    PDFDict.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8KH3B.default).LessThan;
        buffer[offset++] = (0, $8KH3B.default).LessThan;
        buffer[offset++] = (0, $8KH3B.default).Newline;
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            offset += key.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8KH3B.default).Space;
            offset += value.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8KH3B.default).Newline;
        }
        buffer[offset++] = (0, $8KH3B.default).GreaterThan;
        buffer[offset++] = (0, $8KH3B.default).GreaterThan;
        return offset - initialOffset;
    };
    PDFDict.withContext = function(context) {
        return new PDFDict(new Map(), context);
    };
    PDFDict.fromMapWithContext = function(map, context) {
        return new PDFDict(map, context);
    };
    return PDFDict;
}((0, $eKLLF.default));
var $b7e75d63d5628aec$export$2e2bcd8739ae039 = $b7e75d63d5628aec$var$PDFDict;



var $alPcq = parcelRequire("alPcq");


var $4MKjy = parcelRequire("4MKjy");

var $eKLLF = parcelRequire("eKLLF");

var $273XO = parcelRequire("273XO");

var $273XO = parcelRequire("273XO");

var $iMObG = parcelRequire("iMObG");

var $alPcq = parcelRequire("alPcq");

var $4MKjy = parcelRequire("4MKjy");

var $eKLLF = parcelRequire("eKLLF");

var $8KH3B = parcelRequire("8KH3B");
var $c444ed3a6bfbd846$var$PDFStream = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFStream, _super);
    function PDFStream(dict) {
        var _this = _super.call(this) || this;
        _this.dict = dict;
        return _this;
    }
    PDFStream.prototype.clone = function(_context) {
        throw new (0, $iMObG.MethodNotImplementedError)(this.constructor.name, 'clone');
    };
    PDFStream.prototype.getContentsString = function() {
        throw new (0, $iMObG.MethodNotImplementedError)(this.constructor.name, 'getContentsString');
    };
    PDFStream.prototype.getContents = function() {
        throw new (0, $iMObG.MethodNotImplementedError)(this.constructor.name, 'getContents');
    };
    PDFStream.prototype.getContentsSize = function() {
        throw new (0, $iMObG.MethodNotImplementedError)(this.constructor.name, 'getContentsSize');
    };
    PDFStream.prototype.updateDict = function() {
        var contentsSize = this.getContentsSize();
        this.dict.set((0, $alPcq.default).Length, (0, $4MKjy.default).of(contentsSize));
    };
    PDFStream.prototype.sizeInBytes = function() {
        this.updateDict();
        return this.dict.sizeInBytes() + this.getContentsSize() + 18;
    };
    PDFStream.prototype.toString = function() {
        this.updateDict();
        var streamString = this.dict.toString();
        streamString += '\nstream\n';
        streamString += this.getContentsString();
        streamString += '\nendstream';
        return streamString;
    };
    PDFStream.prototype.copyBytesInto = function(buffer, offset) {
        this.updateDict();
        var initialOffset = offset;
        offset += this.dict.copyBytesInto(buffer, offset);
        buffer[offset++] = (0, $8KH3B.default).Newline;
        buffer[offset++] = (0, $8KH3B.default).s;
        buffer[offset++] = (0, $8KH3B.default).t;
        buffer[offset++] = (0, $8KH3B.default).r;
        buffer[offset++] = (0, $8KH3B.default).e;
        buffer[offset++] = (0, $8KH3B.default).a;
        buffer[offset++] = (0, $8KH3B.default).m;
        buffer[offset++] = (0, $8KH3B.default).Newline;
        var contents = this.getContents();
        for(var idx = 0, len = contents.length; idx < len; idx++)buffer[offset++] = contents[idx];
        buffer[offset++] = (0, $8KH3B.default).Newline;
        buffer[offset++] = (0, $8KH3B.default).e;
        buffer[offset++] = (0, $8KH3B.default).n;
        buffer[offset++] = (0, $8KH3B.default).d;
        buffer[offset++] = (0, $8KH3B.default).s;
        buffer[offset++] = (0, $8KH3B.default).t;
        buffer[offset++] = (0, $8KH3B.default).r;
        buffer[offset++] = (0, $8KH3B.default).e;
        buffer[offset++] = (0, $8KH3B.default).a;
        buffer[offset++] = (0, $8KH3B.default).m;
        return offset - initialOffset;
    };
    return PDFStream;
}((0, $eKLLF.default));
var $c444ed3a6bfbd846$export$2e2bcd8739ae039 = $c444ed3a6bfbd846$var$PDFStream;


parcelRequire("5bpFt");
var $a9yd5 = parcelRequire("a9yd5");
var $2f4afe25c4da346a$var$PDFRawStream = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFRawStream, _super);
    function PDFRawStream(dict, contents) {
        var _this = _super.call(this, dict) || this;
        _this.contents = contents;
        return _this;
    }
    PDFRawStream.prototype.asUint8Array = function() {
        return this.contents.slice();
    };
    PDFRawStream.prototype.clone = function(context) {
        return PDFRawStream.of(this.dict.clone(context), this.contents.slice());
    };
    PDFRawStream.prototype.getContentsString = function() {
        return (0, $a9yd5.arrayAsString)(this.contents);
    };
    PDFRawStream.prototype.getContents = function() {
        return this.contents;
    };
    PDFRawStream.prototype.getContentsSize = function() {
        return this.contents.length;
    };
    PDFRawStream.of = function(dict, contents) {
        return new PDFRawStream(dict, contents);
    };
    return PDFRawStream;
}((0, $c444ed3a6bfbd846$export$2e2bcd8739ae039));
var $2f4afe25c4da346a$export$2e2bcd8739ae039 = $2f4afe25c4da346a$var$PDFRawStream;



var $273XO = parcelRequire("273XO");

var $iMObG = parcelRequire("iMObG");

var $eKLLF = parcelRequire("eKLLF");
parcelRequire("5bpFt");
var $8hWZH = parcelRequire("8hWZH");
var $69d09480b29248e9$var$ENFORCER = {};
var $69d09480b29248e9$var$pool = new Map();
var $69d09480b29248e9$var$PDFRef = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFRef, _super);
    function PDFRef(enforcer, objectNumber, generationNumber) {
        var _this = this;
        if (enforcer !== $69d09480b29248e9$var$ENFORCER) throw new (0, $iMObG.PrivateConstructorError)('PDFRef');
        _this = _super.call(this) || this;
        _this.objectNumber = objectNumber;
        _this.generationNumber = generationNumber;
        _this.tag = objectNumber + " " + generationNumber + " R";
        return _this;
    }
    PDFRef.prototype.clone = function() {
        return this;
    };
    PDFRef.prototype.toString = function() {
        return this.tag;
    };
    PDFRef.prototype.sizeInBytes = function() {
        return this.tag.length;
    };
    PDFRef.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $8hWZH.copyStringIntoBuffer)(this.tag, buffer, offset);
        return this.tag.length;
    };
    PDFRef.of = function(objectNumber, generationNumber) {
        if (generationNumber === void 0) generationNumber = 0;
        var tag = objectNumber + " " + generationNumber + " R";
        var instance = $69d09480b29248e9$var$pool.get(tag);
        if (!instance) {
            instance = new PDFRef($69d09480b29248e9$var$ENFORCER, objectNumber, generationNumber);
            $69d09480b29248e9$var$pool.set(tag, instance);
        }
        return instance;
    };
    return PDFRef;
}((0, $eKLLF.default));
var $69d09480b29248e9$export$2e2bcd8739ae039 = $69d09480b29248e9$var$PDFRef;



var $eKLLF = parcelRequire("eKLLF");

var $8KH3B = parcelRequire("8KH3B");
parcelRequire("5bpFt");
var $8hWZH = parcelRequire("8hWZH");
var $7df3d1b72d21cb6b$var$PDFOperator = /** @class */ function() {
    function PDFOperator(name, args) {
        this.name = name;
        this.args = args || [];
    }
    PDFOperator.prototype.clone = function(context) {
        var args = new Array(this.args.length);
        for(var idx = 0, len = args.length; idx < len; idx++){
            var arg = this.args[idx];
            args[idx] = arg instanceof (0, $eKLLF.default) ? arg.clone(context) : arg;
        }
        return PDFOperator.of(this.name, args);
    };
    PDFOperator.prototype.toString = function() {
        var value = '';
        for(var idx = 0, len = this.args.length; idx < len; idx++)value += String(this.args[idx]) + ' ';
        value += this.name;
        return value;
    };
    PDFOperator.prototype.sizeInBytes = function() {
        var size = 0;
        for(var idx = 0, len = this.args.length; idx < len; idx++){
            var arg = this.args[idx];
            size += (arg instanceof (0, $eKLLF.default) ? arg.sizeInBytes() : arg.length) + 1;
        }
        size += this.name.length;
        return size;
    };
    PDFOperator.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        for(var idx = 0, len = this.args.length; idx < len; idx++){
            var arg = this.args[idx];
            if (arg instanceof (0, $eKLLF.default)) offset += arg.copyBytesInto(buffer, offset);
            else offset += (0, $8hWZH.copyStringIntoBuffer)(arg, buffer, offset);
            buffer[offset++] = (0, $8KH3B.default).Space;
        }
        offset += (0, $8hWZH.copyStringIntoBuffer)(this.name, buffer, offset);
        return offset - initialOffset;
    };
    PDFOperator.of = function(name, args) {
        return new PDFOperator(name, args);
    };
    return PDFOperator;
}();
var $7df3d1b72d21cb6b$export$2e2bcd8739ae039 = $7df3d1b72d21cb6b$var$PDFOperator;


var $711a5af78c053e90$var$PDFOperatorNames;
(function(PDFOperatorNames) {
    // Non Stroking Color Operators
    PDFOperatorNames["NonStrokingColor"] = "sc";
    PDFOperatorNames["NonStrokingColorN"] = "scn";
    PDFOperatorNames["NonStrokingColorRgb"] = "rg";
    PDFOperatorNames["NonStrokingColorGray"] = "g";
    PDFOperatorNames["NonStrokingColorCmyk"] = "k";
    PDFOperatorNames["NonStrokingColorspace"] = "cs";
    // Stroking Color Operators
    PDFOperatorNames["StrokingColor"] = "SC";
    PDFOperatorNames["StrokingColorN"] = "SCN";
    PDFOperatorNames["StrokingColorRgb"] = "RG";
    PDFOperatorNames["StrokingColorGray"] = "G";
    PDFOperatorNames["StrokingColorCmyk"] = "K";
    PDFOperatorNames["StrokingColorspace"] = "CS";
    // Marked Content Operators
    PDFOperatorNames["BeginMarkedContentSequence"] = "BDC";
    PDFOperatorNames["BeginMarkedContent"] = "BMC";
    PDFOperatorNames["EndMarkedContent"] = "EMC";
    PDFOperatorNames["MarkedContentPointWithProps"] = "DP";
    PDFOperatorNames["MarkedContentPoint"] = "MP";
    PDFOperatorNames["DrawObject"] = "Do";
    // Graphics State Operators
    PDFOperatorNames["ConcatTransformationMatrix"] = "cm";
    PDFOperatorNames["PopGraphicsState"] = "Q";
    PDFOperatorNames["PushGraphicsState"] = "q";
    PDFOperatorNames["SetFlatness"] = "i";
    PDFOperatorNames["SetGraphicsStateParams"] = "gs";
    PDFOperatorNames["SetLineCapStyle"] = "J";
    PDFOperatorNames["SetLineDashPattern"] = "d";
    PDFOperatorNames["SetLineJoinStyle"] = "j";
    PDFOperatorNames["SetLineMiterLimit"] = "M";
    PDFOperatorNames["SetLineWidth"] = "w";
    PDFOperatorNames["SetTextMatrix"] = "Tm";
    PDFOperatorNames["SetRenderingIntent"] = "ri";
    // Graphics Operators
    PDFOperatorNames["AppendRectangle"] = "re";
    PDFOperatorNames["BeginInlineImage"] = "BI";
    PDFOperatorNames["BeginInlineImageData"] = "ID";
    PDFOperatorNames["EndInlineImage"] = "EI";
    PDFOperatorNames["ClipEvenOdd"] = "W*";
    PDFOperatorNames["ClipNonZero"] = "W";
    PDFOperatorNames["CloseAndStroke"] = "s";
    PDFOperatorNames["CloseFillEvenOddAndStroke"] = "b*";
    PDFOperatorNames["CloseFillNonZeroAndStroke"] = "b";
    PDFOperatorNames["ClosePath"] = "h";
    PDFOperatorNames["AppendBezierCurve"] = "c";
    PDFOperatorNames["CurveToReplicateFinalPoint"] = "y";
    PDFOperatorNames["CurveToReplicateInitialPoint"] = "v";
    PDFOperatorNames["EndPath"] = "n";
    PDFOperatorNames["FillEvenOddAndStroke"] = "B*";
    PDFOperatorNames["FillEvenOdd"] = "f*";
    PDFOperatorNames["FillNonZeroAndStroke"] = "B";
    PDFOperatorNames["FillNonZero"] = "f";
    PDFOperatorNames["LegacyFillNonZero"] = "F";
    PDFOperatorNames["LineTo"] = "l";
    PDFOperatorNames["MoveTo"] = "m";
    PDFOperatorNames["ShadingFill"] = "sh";
    PDFOperatorNames["StrokePath"] = "S";
    // Text Operators
    PDFOperatorNames["BeginText"] = "BT";
    PDFOperatorNames["EndText"] = "ET";
    PDFOperatorNames["MoveText"] = "Td";
    PDFOperatorNames["MoveTextSetLeading"] = "TD";
    PDFOperatorNames["NextLine"] = "T*";
    PDFOperatorNames["SetCharacterSpacing"] = "Tc";
    PDFOperatorNames["SetFontAndSize"] = "Tf";
    PDFOperatorNames["SetTextHorizontalScaling"] = "Tz";
    PDFOperatorNames["SetTextLineHeight"] = "TL";
    PDFOperatorNames["SetTextRenderingMode"] = "Tr";
    PDFOperatorNames["SetTextRise"] = "Ts";
    PDFOperatorNames["SetWordSpacing"] = "Tw";
    PDFOperatorNames["ShowText"] = "Tj";
    PDFOperatorNames["ShowTextAdjusted"] = "TJ";
    PDFOperatorNames["ShowTextLine"] = "'";
    PDFOperatorNames["ShowTextLineAndSpace"] = "\"";
    // Type3 Font Operators
    PDFOperatorNames["Type3D0"] = "d0";
    PDFOperatorNames["Type3D1"] = "d1";
    // Compatibility Section Operators
    PDFOperatorNames["BeginCompatibilitySection"] = "BX";
    PDFOperatorNames["EndCompatibilitySection"] = "EX";
})($711a5af78c053e90$var$PDFOperatorNames || ($711a5af78c053e90$var$PDFOperatorNames = {}));
var $711a5af78c053e90$export$2e2bcd8739ae039 = $711a5af78c053e90$var$PDFOperatorNames;



var $273XO = parcelRequire("273XO");

var $273XO = parcelRequire("273XO");


var $iMObG = parcelRequire("iMObG");

var $alPcq = parcelRequire("alPcq");

parcelRequire("5bpFt");
var $hGYOY = parcelRequire("hGYOY");
var $beb440d1eb2e8cc9$var$PDFFlateStream = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFFlateStream, _super);
    function PDFFlateStream(dict, encode) {
        var _this = _super.call(this, dict) || this;
        _this.computeContents = function() {
            var unencodedContents = _this.getUnencodedContents();
            return _this.encode ? (0, (/*@__PURE__*/$parcel$interopDefault($f68f50851d9a8a51$exports))).deflate(unencodedContents) : unencodedContents;
        };
        _this.encode = encode;
        if (encode) dict.set((0, $alPcq.default).of('Filter'), (0, $alPcq.default).of('FlateDecode'));
        _this.contentsCache = (0, $hGYOY.default).populatedBy(_this.computeContents);
        return _this;
    }
    PDFFlateStream.prototype.getContents = function() {
        return this.contentsCache.access();
    };
    PDFFlateStream.prototype.getContentsSize = function() {
        return this.contentsCache.access().length;
    };
    PDFFlateStream.prototype.getUnencodedContents = function() {
        throw new (0, $iMObG.MethodNotImplementedError)(this.constructor.name, 'getUnencodedContents');
    };
    return PDFFlateStream;
}((0, $c444ed3a6bfbd846$export$2e2bcd8739ae039));
var $beb440d1eb2e8cc9$export$2e2bcd8739ae039 = $beb440d1eb2e8cc9$var$PDFFlateStream;



var $8KH3B = parcelRequire("8KH3B");
var $76f7b8adb556b72e$var$PDFContentStream = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFContentStream, _super);
    function PDFContentStream(dict, operators, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, dict, encode) || this;
        _this.operators = operators;
        return _this;
    }
    PDFContentStream.prototype.push = function() {
        var _a;
        var operators = [];
        for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
        (_a = this.operators).push.apply(_a, operators);
    };
    PDFContentStream.prototype.clone = function(context) {
        var operators = new Array(this.operators.length);
        for(var idx = 0, len = this.operators.length; idx < len; idx++)operators[idx] = this.operators[idx].clone(context);
        var _a = this, dict = _a.dict, encode = _a.encode;
        return PDFContentStream.of(dict.clone(context), operators, encode);
    };
    PDFContentStream.prototype.getContentsString = function() {
        var value = '';
        for(var idx = 0, len = this.operators.length; idx < len; idx++)value += this.operators[idx] + "\n";
        return value;
    };
    PDFContentStream.prototype.getUnencodedContents = function() {
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = 0;
        for(var idx = 0, len = this.operators.length; idx < len; idx++){
            offset += this.operators[idx].copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8KH3B.default).Newline;
        }
        return buffer;
    };
    PDFContentStream.prototype.getUnencodedContentsSize = function() {
        var size = 0;
        for(var idx = 0, len = this.operators.length; idx < len; idx++)size += this.operators[idx].sizeInBytes() + 1;
        return size;
    };
    PDFContentStream.of = function(dict, operators, encode) {
        if (encode === void 0) encode = true;
        return new PDFContentStream(dict, operators, encode);
    };
    return PDFContentStream;
}((0, $beb440d1eb2e8cc9$export$2e2bcd8739ae039));
var $76f7b8adb556b72e$export$2e2bcd8739ae039 = $76f7b8adb556b72e$var$PDFContentStream;


parcelRequire("5bpFt");
var $a9yd5 = parcelRequire("a9yd5");
/**
 * Generates a pseudo random number. Although it is not cryptographically secure
 * and uniformly distributed, it is not a concern for the intended use-case,
 * which is to generate distinct numbers.
 *
 * Credit: https://stackoverflow.com/a/19303725/10254049
 */ var $2bff3983196d14b9$export$205b650d120b95b5 = /** @class */ function() {
    function SimpleRNG(seed) {
        this.seed = seed;
    }
    SimpleRNG.prototype.nextInt = function() {
        var x = Math.sin(this.seed++) * 10000;
        return x - Math.floor(x);
    };
    SimpleRNG.withSeed = function(seed) {
        return new SimpleRNG(seed);
    };
    return SimpleRNG;
}();


var $dcc6ee7d53aa6a90$var$byAscendingObjectNumber = function(_a, _b) {
    var a = _a[0];
    var b = _b[0];
    return a.objectNumber - b.objectNumber;
};
var $dcc6ee7d53aa6a90$var$PDFContext = /** @class */ function() {
    function PDFContext() {
        this.largestObjectNumber = 0;
        this.header = (0, $526f381db166a209$export$2e2bcd8739ae039).forVersion(1, 7);
        this.trailerInfo = {};
        this.indirectObjects = new Map();
        this.rng = (0, $2bff3983196d14b9$export$205b650d120b95b5).withSeed(1);
    }
    PDFContext.prototype.assign = function(ref, object) {
        this.indirectObjects.set(ref, object);
        if (ref.objectNumber > this.largestObjectNumber) this.largestObjectNumber = ref.objectNumber;
    };
    PDFContext.prototype.nextRef = function() {
        this.largestObjectNumber += 1;
        return (0, $69d09480b29248e9$export$2e2bcd8739ae039).of(this.largestObjectNumber);
    };
    PDFContext.prototype.register = function(object) {
        var ref = this.nextRef();
        this.assign(ref, object);
        return ref;
    };
    PDFContext.prototype.delete = function(ref) {
        return this.indirectObjects.delete(ref);
    };
    PDFContext.prototype.lookupMaybe = function(ref) {
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $634bbd76d2b867c9$export$2e2bcd8739ae039));
        var result = ref instanceof (0, $69d09480b29248e9$export$2e2bcd8739ae039) ? this.indirectObjects.get(ref) : ref;
        if (!result || result === (0, $634bbd76d2b867c9$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        for(var idx = 0, len = types.length; idx < len; idx++){
            var type = types[idx];
            if (type === (0, $634bbd76d2b867c9$export$2e2bcd8739ae039)) {
                if (result === (0, $634bbd76d2b867c9$export$2e2bcd8739ae039)) return result;
            } else {
                if (result instanceof type) return result;
            }
        }
        throw new (0, $iMObG.UnexpectedObjectTypeError)(types, result);
    };
    PDFContext.prototype.lookup = function(ref) {
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        var result = ref instanceof (0, $69d09480b29248e9$export$2e2bcd8739ae039) ? this.indirectObjects.get(ref) : ref;
        if (types.length === 0) return result;
        for(var idx = 0, len = types.length; idx < len; idx++){
            var type = types[idx];
            if (type === (0, $634bbd76d2b867c9$export$2e2bcd8739ae039)) {
                if (result === (0, $634bbd76d2b867c9$export$2e2bcd8739ae039)) return result;
            } else {
                if (result instanceof type) return result;
            }
        }
        throw new (0, $iMObG.UnexpectedObjectTypeError)(types, result);
    };
    PDFContext.prototype.getObjectRef = function(pdfObject) {
        var entries = Array.from(this.indirectObjects.entries());
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], ref = _a[0], object = _a[1];
            if (object === pdfObject) return ref;
        }
        return undefined;
    };
    PDFContext.prototype.enumerateIndirectObjects = function() {
        return Array.from(this.indirectObjects.entries()).sort($dcc6ee7d53aa6a90$var$byAscendingObjectNumber);
    };
    PDFContext.prototype.obj = function(literal) {
        if (literal instanceof (0, $eKLLF.default)) return literal;
        else if (literal === null || literal === undefined) return 0, $634bbd76d2b867c9$export$2e2bcd8739ae039;
        else if (typeof literal === 'string') return (0, $alPcq.default).of(literal);
        else if (typeof literal === 'number') return (0, $4MKjy.default).of(literal);
        else if (typeof literal === 'boolean') return literal ? (0, $63sxC.default).True : (0, $63sxC.default).False;
        else if (Array.isArray(literal)) {
            var array = (0, $dj8f2.default).withContext(this);
            for(var idx = 0, len = literal.length; idx < len; idx++)array.push(this.obj(literal[idx]));
            return array;
        } else {
            var dict = (0, $b7e75d63d5628aec$export$2e2bcd8739ae039).withContext(this);
            var keys = Object.keys(literal);
            for(var idx = 0, len = keys.length; idx < len; idx++){
                var key = keys[idx];
                var value = literal[key];
                if (value !== undefined) dict.set((0, $alPcq.default).of(key), this.obj(value));
            }
            return dict;
        }
    };
    PDFContext.prototype.stream = function(contents, dict) {
        if (dict === void 0) dict = {};
        return (0, $2f4afe25c4da346a$export$2e2bcd8739ae039).of(this.obj(dict), (0, $a9yd5.typedArrayFor)(contents));
    };
    PDFContext.prototype.flateStream = function(contents, dict) {
        if (dict === void 0) dict = {};
        return this.stream((0, (/*@__PURE__*/$parcel$interopDefault($f68f50851d9a8a51$exports))).deflate((0, $a9yd5.typedArrayFor)(contents)), (0, $273XO.__assign)((0, $273XO.__assign)({}, dict), {
            Filter: 'FlateDecode'
        }));
    };
    PDFContext.prototype.contentStream = function(operators, dict) {
        if (dict === void 0) dict = {};
        return (0, $76f7b8adb556b72e$export$2e2bcd8739ae039).of(this.obj(dict), operators);
    };
    PDFContext.prototype.formXObject = function(operators, dict) {
        if (dict === void 0) dict = {};
        return this.contentStream(operators, (0, $273XO.__assign)((0, $273XO.__assign)({
            BBox: this.obj([
                0,
                0,
                0,
                0
            ]),
            Matrix: this.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        }, dict), {
            Type: 'XObject',
            Subtype: 'Form'
        }));
    };
    /*
     * Reference to PDFContentStream that contains a single PDFOperator: `q`.
     * Used by [[PDFPageLeaf]] instances to ensure that when content streams are
     * added to a modified PDF, they start in the default, unchanged graphics
     * state.
     */ PDFContext.prototype.getPushGraphicsStateContentStream = function() {
        if (this.pushGraphicsStateContentStreamRef) return this.pushGraphicsStateContentStreamRef;
        var dict = this.obj({});
        var op = (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).PushGraphicsState);
        var stream = (0, $76f7b8adb556b72e$export$2e2bcd8739ae039).of(dict, [
            op
        ]);
        this.pushGraphicsStateContentStreamRef = this.register(stream);
        return this.pushGraphicsStateContentStreamRef;
    };
    /*
     * Reference to PDFContentStream that contains a single PDFOperator: `Q`.
     * Used by [[PDFPageLeaf]] instances to ensure that when content streams are
     * added to a modified PDF, they start in the default, unchanged graphics
     * state.
     */ PDFContext.prototype.getPopGraphicsStateContentStream = function() {
        if (this.popGraphicsStateContentStreamRef) return this.popGraphicsStateContentStreamRef;
        var dict = this.obj({});
        var op = (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).PopGraphicsState);
        var stream = (0, $76f7b8adb556b72e$export$2e2bcd8739ae039).of(dict, [
            op
        ]);
        this.popGraphicsStateContentStreamRef = this.register(stream);
        return this.popGraphicsStateContentStreamRef;
    };
    PDFContext.prototype.addRandomSuffix = function(prefix, suffixLength) {
        if (suffixLength === void 0) suffixLength = 4;
        return prefix + "-" + Math.floor(this.rng.nextInt() * Math.pow(10, suffixLength));
    };
    PDFContext.create = function() {
        return new PDFContext();
    };
    return PDFContext;
}();
var $dcc6ee7d53aa6a90$export$2e2bcd8739ae039 = $dcc6ee7d53aa6a90$var$PDFContext;



var $dj8f2 = parcelRequire("dj8f2");


var $alPcq = parcelRequire("alPcq");



var $273XO = parcelRequire("273XO");

var $dj8f2 = parcelRequire("dj8f2");


var $alPcq = parcelRequire("alPcq");

var $4MKjy = parcelRequire("4MKjy");

var $27cec0c5ad235198$var$PDFPageLeaf = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFPageLeaf, _super);
    function PDFPageLeaf(map, context, autoNormalizeCTM) {
        if (autoNormalizeCTM === void 0) autoNormalizeCTM = true;
        var _this = _super.call(this, map, context) || this;
        _this.normalized = false;
        _this.autoNormalizeCTM = autoNormalizeCTM;
        return _this;
    }
    PDFPageLeaf.prototype.clone = function(context) {
        var clone = PDFPageLeaf.fromMapWithContext(new Map(), context || this.context, this.autoNormalizeCTM);
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            clone.set(key, value);
        }
        return clone;
    };
    PDFPageLeaf.prototype.Parent = function() {
        return this.lookupMaybe((0, $alPcq.default).Parent, (0, $b7e75d63d5628aec$export$2e2bcd8739ae039));
    };
    PDFPageLeaf.prototype.Contents = function() {
        return this.lookup((0, $alPcq.default).of('Contents'));
    };
    PDFPageLeaf.prototype.Annots = function() {
        return this.lookupMaybe((0, $alPcq.default).Annots, (0, $dj8f2.default));
    };
    PDFPageLeaf.prototype.BleedBox = function() {
        return this.lookupMaybe((0, $alPcq.default).BleedBox, (0, $dj8f2.default));
    };
    PDFPageLeaf.prototype.TrimBox = function() {
        return this.lookupMaybe((0, $alPcq.default).TrimBox, (0, $dj8f2.default));
    };
    PDFPageLeaf.prototype.ArtBox = function() {
        return this.lookupMaybe((0, $alPcq.default).ArtBox, (0, $dj8f2.default));
    };
    PDFPageLeaf.prototype.Resources = function() {
        var dictOrRef = this.getInheritableAttribute((0, $alPcq.default).Resources);
        return this.context.lookupMaybe(dictOrRef, (0, $b7e75d63d5628aec$export$2e2bcd8739ae039));
    };
    PDFPageLeaf.prototype.MediaBox = function() {
        var arrayOrRef = this.getInheritableAttribute((0, $alPcq.default).MediaBox);
        return this.context.lookup(arrayOrRef, (0, $dj8f2.default));
    };
    PDFPageLeaf.prototype.CropBox = function() {
        var arrayOrRef = this.getInheritableAttribute((0, $alPcq.default).CropBox);
        return this.context.lookupMaybe(arrayOrRef, (0, $dj8f2.default));
    };
    PDFPageLeaf.prototype.Rotate = function() {
        var numberOrRef = this.getInheritableAttribute((0, $alPcq.default).Rotate);
        return this.context.lookupMaybe(numberOrRef, (0, $4MKjy.default));
    };
    PDFPageLeaf.prototype.getInheritableAttribute = function(name) {
        var attribute;
        this.ascend(function(node) {
            if (!attribute) attribute = node.get(name);
        });
        return attribute;
    };
    PDFPageLeaf.prototype.setParent = function(parentRef) {
        this.set((0, $alPcq.default).Parent, parentRef);
    };
    PDFPageLeaf.prototype.addContentStream = function(contentStreamRef) {
        var Contents = this.normalizedEntries().Contents || this.context.obj([]);
        this.set((0, $alPcq.default).Contents, Contents);
        Contents.push(contentStreamRef);
    };
    PDFPageLeaf.prototype.wrapContentStreams = function(startStream, endStream) {
        var Contents = this.Contents();
        if (Contents instanceof (0, $dj8f2.default)) {
            Contents.insert(0, startStream);
            Contents.push(endStream);
            return true;
        }
        return false;
    };
    PDFPageLeaf.prototype.addAnnot = function(annotRef) {
        var Annots = this.normalizedEntries().Annots;
        Annots.push(annotRef);
    };
    PDFPageLeaf.prototype.removeAnnot = function(annotRef) {
        var Annots = this.normalizedEntries().Annots;
        var index = Annots.indexOf(annotRef);
        if (index !== undefined) Annots.remove(index);
    };
    PDFPageLeaf.prototype.setFontDictionary = function(name, fontDictRef) {
        var Font = this.normalizedEntries().Font;
        Font.set(name, fontDictRef);
    };
    PDFPageLeaf.prototype.newFontDictionaryKey = function(tag) {
        var Font = this.normalizedEntries().Font;
        return Font.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newFontDictionary = function(tag, fontDictRef) {
        var key = this.newFontDictionaryKey(tag);
        this.setFontDictionary(key, fontDictRef);
        return key;
    };
    PDFPageLeaf.prototype.setXObject = function(name, xObjectRef) {
        var XObject = this.normalizedEntries().XObject;
        XObject.set(name, xObjectRef);
    };
    PDFPageLeaf.prototype.newXObjectKey = function(tag) {
        var XObject = this.normalizedEntries().XObject;
        return XObject.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newXObject = function(tag, xObjectRef) {
        var key = this.newXObjectKey(tag);
        this.setXObject(key, xObjectRef);
        return key;
    };
    PDFPageLeaf.prototype.setExtGState = function(name, extGStateRef) {
        var ExtGState = this.normalizedEntries().ExtGState;
        ExtGState.set(name, extGStateRef);
    };
    PDFPageLeaf.prototype.newExtGStateKey = function(tag) {
        var ExtGState = this.normalizedEntries().ExtGState;
        return ExtGState.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newExtGState = function(tag, extGStateRef) {
        var key = this.newExtGStateKey(tag);
        this.setExtGState(key, extGStateRef);
        return key;
    };
    PDFPageLeaf.prototype.ascend = function(visitor) {
        visitor(this);
        var Parent = this.Parent();
        if (Parent) Parent.ascend(visitor);
    };
    PDFPageLeaf.prototype.normalize = function() {
        if (this.normalized) return;
        var context = this.context;
        var contentsRef = this.get((0, $alPcq.default).Contents);
        var contents = this.context.lookup(contentsRef);
        if (contents instanceof (0, $c444ed3a6bfbd846$export$2e2bcd8739ae039)) this.set((0, $alPcq.default).Contents, context.obj([
            contentsRef
        ]));
        if (this.autoNormalizeCTM) this.wrapContentStreams(this.context.getPushGraphicsStateContentStream(), this.context.getPopGraphicsStateContentStream());
        // TODO: Clone `Resources` if it is inherited
        var dictOrRef = this.getInheritableAttribute((0, $alPcq.default).Resources);
        var Resources = context.lookupMaybe(dictOrRef, (0, $b7e75d63d5628aec$export$2e2bcd8739ae039)) || context.obj({});
        this.set((0, $alPcq.default).Resources, Resources);
        // TODO: Clone `Font` if it is inherited
        var Font = Resources.lookupMaybe((0, $alPcq.default).Font, (0, $b7e75d63d5628aec$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $alPcq.default).Font, Font);
        // TODO: Clone `XObject` if it is inherited
        var XObject = Resources.lookupMaybe((0, $alPcq.default).XObject, (0, $b7e75d63d5628aec$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $alPcq.default).XObject, XObject);
        // TODO: Clone `ExtGState` if it is inherited
        var ExtGState = Resources.lookupMaybe((0, $alPcq.default).ExtGState, (0, $b7e75d63d5628aec$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $alPcq.default).ExtGState, ExtGState);
        var Annots = this.Annots() || context.obj([]);
        this.set((0, $alPcq.default).Annots, Annots);
        this.normalized = true;
    };
    PDFPageLeaf.prototype.normalizedEntries = function() {
        this.normalize();
        var Annots = this.Annots();
        var Resources = this.Resources();
        var Contents = this.Contents();
        return {
            Annots: Annots,
            Resources: Resources,
            Contents: Contents,
            Font: Resources.lookup((0, $alPcq.default).Font, (0, $b7e75d63d5628aec$export$2e2bcd8739ae039)),
            XObject: Resources.lookup((0, $alPcq.default).XObject, (0, $b7e75d63d5628aec$export$2e2bcd8739ae039)),
            ExtGState: Resources.lookup((0, $alPcq.default).ExtGState, (0, $b7e75d63d5628aec$export$2e2bcd8739ae039))
        };
    };
    PDFPageLeaf.InheritableEntries = [
        'Resources',
        'MediaBox',
        'CropBox',
        'Rotate'
    ];
    PDFPageLeaf.withContextAndParent = function(context, parent) {
        var dict = new Map();
        dict.set((0, $alPcq.default).Type, (0, $alPcq.default).Page);
        dict.set((0, $alPcq.default).Parent, parent);
        dict.set((0, $alPcq.default).Resources, context.obj({}));
        dict.set((0, $alPcq.default).MediaBox, context.obj([
            0,
            0,
            612,
            792
        ]));
        return new PDFPageLeaf(dict, context, false);
    };
    PDFPageLeaf.fromMapWithContext = function(map, context, autoNormalizeCTM) {
        if (autoNormalizeCTM === void 0) autoNormalizeCTM = true;
        return new PDFPageLeaf(map, context, autoNormalizeCTM);
    };
    return PDFPageLeaf;
}((0, $b7e75d63d5628aec$export$2e2bcd8739ae039));
var $27cec0c5ad235198$export$2e2bcd8739ae039 = $27cec0c5ad235198$var$PDFPageLeaf;


/**
 * PDFObjectCopier copies PDFObjects from a src context to a dest context.
 * The primary use case for this is to copy pages between PDFs.
 *
 * _Copying_ an object with a PDFObjectCopier is different from _cloning_ an
 * object with its [[PDFObject.clone]] method:
 *
 * ```
 *   const src: PDFContext = ...
 *   const dest: PDFContext = ...
 *   const originalObject: PDFObject = ...
 *   const copiedObject = PDFObjectCopier.for(src, dest).copy(originalObject);
 *   const clonedObject = originalObject.clone();
 * ```
 *
 * Copying an object is equivalent to cloning it and then copying over any other
 * objects that it references. Note that only dictionaries, arrays, and streams
 * (or structures build from them) can contain indirect references to other
 * objects. Copying a PDFObject that is not a dictionary, array, or stream is
 * supported, but is equivalent to cloning it.
 */ var $9bb257b1a2af93c3$var$PDFObjectCopier = /** @class */ function() {
    function PDFObjectCopier(src, dest) {
        var _this = this;
        this.traversedObjects = new Map();
        // prettier-ignore
        this.copy = function(object) {
            return object instanceof (0, $27cec0c5ad235198$export$2e2bcd8739ae039) ? _this.copyPDFPage(object) : object instanceof (0, $b7e75d63d5628aec$export$2e2bcd8739ae039) ? _this.copyPDFDict(object) : object instanceof (0, $dj8f2.default) ? _this.copyPDFArray(object) : object instanceof (0, $c444ed3a6bfbd846$export$2e2bcd8739ae039) ? _this.copyPDFStream(object) : object instanceof (0, $69d09480b29248e9$export$2e2bcd8739ae039) ? _this.copyPDFIndirectObject(object) : object.clone();
        };
        this.copyPDFPage = function(originalPage) {
            var clonedPage = originalPage.clone();
            // Move any entries that the originalPage is inheriting from its parent
            // tree nodes directly into originalPage so they are preserved during
            // the copy.
            var InheritableEntries = (0, $27cec0c5ad235198$export$2e2bcd8739ae039).InheritableEntries;
            for(var idx = 0, len = InheritableEntries.length; idx < len; idx++){
                var key = (0, $alPcq.default).of(InheritableEntries[idx]);
                var value = clonedPage.getInheritableAttribute(key);
                if (!clonedPage.get(key) && value) clonedPage.set(key, value);
            }
            // Remove the parent reference to prevent the whole donor document's page
            // tree from being copied when we only need a single page.
            clonedPage.delete((0, $alPcq.default).of('Parent'));
            return _this.copyPDFDict(clonedPage);
        };
        this.copyPDFDict = function(originalDict) {
            if (_this.traversedObjects.has(originalDict)) return _this.traversedObjects.get(originalDict);
            var clonedDict = originalDict.clone(_this.dest);
            _this.traversedObjects.set(originalDict, clonedDict);
            var entries = originalDict.entries();
            for(var idx = 0, len = entries.length; idx < len; idx++){
                var _a = entries[idx], key = _a[0], value = _a[1];
                clonedDict.set(key, _this.copy(value));
            }
            return clonedDict;
        };
        this.copyPDFArray = function(originalArray) {
            if (_this.traversedObjects.has(originalArray)) return _this.traversedObjects.get(originalArray);
            var clonedArray = originalArray.clone(_this.dest);
            _this.traversedObjects.set(originalArray, clonedArray);
            for(var idx = 0, len = originalArray.size(); idx < len; idx++){
                var value = originalArray.get(idx);
                clonedArray.set(idx, _this.copy(value));
            }
            return clonedArray;
        };
        this.copyPDFStream = function(originalStream) {
            if (_this.traversedObjects.has(originalStream)) return _this.traversedObjects.get(originalStream);
            var clonedStream = originalStream.clone(_this.dest);
            _this.traversedObjects.set(originalStream, clonedStream);
            var entries = originalStream.dict.entries();
            for(var idx = 0, len = entries.length; idx < len; idx++){
                var _a = entries[idx], key = _a[0], value = _a[1];
                clonedStream.dict.set(key, _this.copy(value));
            }
            return clonedStream;
        };
        this.copyPDFIndirectObject = function(ref) {
            var alreadyMapped = _this.traversedObjects.has(ref);
            if (!alreadyMapped) {
                var newRef = _this.dest.nextRef();
                _this.traversedObjects.set(ref, newRef);
                var dereferencedValue = _this.src.lookup(ref);
                if (dereferencedValue) {
                    var cloned = _this.copy(dereferencedValue);
                    _this.dest.assign(newRef, cloned);
                }
            }
            return _this.traversedObjects.get(ref);
        };
        this.src = src;
        this.dest = dest;
    }
    PDFObjectCopier.for = function(src, dest) {
        return new PDFObjectCopier(src, dest);
    };
    return PDFObjectCopier;
}();
var $9bb257b1a2af93c3$export$2e2bcd8739ae039 = $9bb257b1a2af93c3$var$PDFObjectCopier;



var $273XO = parcelRequire("273XO");


var $8KH3B = parcelRequire("8KH3B");
parcelRequire("5bpFt");
var $8hWZH = parcelRequire("8hWZH");
/**
 * Entries should be added using the [[addEntry]] and [[addDeletedEntry]]
 * methods **in order of ascending object number**.
 */ var $9c4138d1e86666d6$var$PDFCrossRefSection = /** @class */ function() {
    function PDFCrossRefSection(firstEntry) {
        this.subsections = firstEntry ? [
            [
                firstEntry
            ]
        ] : [];
        this.chunkIdx = 0;
        this.chunkLength = firstEntry ? 1 : 0;
    }
    PDFCrossRefSection.prototype.addEntry = function(ref, offset) {
        this.append({
            ref: ref,
            offset: offset,
            deleted: false
        });
    };
    PDFCrossRefSection.prototype.addDeletedEntry = function(ref, nextFreeObjectNumber) {
        this.append({
            ref: ref,
            offset: nextFreeObjectNumber,
            deleted: true
        });
    };
    PDFCrossRefSection.prototype.toString = function() {
        var section = "xref\n";
        for(var rangeIdx = 0, rangeLen = this.subsections.length; rangeIdx < rangeLen; rangeIdx++){
            var range = this.subsections[rangeIdx];
            section += range[0].ref.objectNumber + " " + range.length + "\n";
            for(var entryIdx = 0, entryLen = range.length; entryIdx < entryLen; entryIdx++){
                var entry = range[entryIdx];
                section += (0, $8hWZH.padStart)(String(entry.offset), 10, '0');
                section += ' ';
                section += (0, $8hWZH.padStart)(String(entry.ref.generationNumber), 5, '0');
                section += ' ';
                section += entry.deleted ? 'f' : 'n';
                section += ' \n';
            }
        }
        return section;
    };
    PDFCrossRefSection.prototype.sizeInBytes = function() {
        var size = 5;
        for(var idx = 0, len = this.subsections.length; idx < len; idx++){
            var subsection = this.subsections[idx];
            var subsectionLength = subsection.length;
            var firstEntry = subsection[0];
            size += 2;
            size += String(firstEntry.ref.objectNumber).length;
            size += String(subsectionLength).length;
            size += 20 * subsectionLength;
        }
        return size;
    };
    PDFCrossRefSection.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8KH3B.default).x;
        buffer[offset++] = (0, $8KH3B.default).r;
        buffer[offset++] = (0, $8KH3B.default).e;
        buffer[offset++] = (0, $8KH3B.default).f;
        buffer[offset++] = (0, $8KH3B.default).Newline;
        offset += this.copySubsectionsIntoBuffer(this.subsections, buffer, offset);
        return offset - initialOffset;
    };
    PDFCrossRefSection.prototype.copySubsectionsIntoBuffer = function(subsections, buffer, offset) {
        var initialOffset = offset;
        var length = subsections.length;
        for(var idx = 0; idx < length; idx++){
            var subsection = this.subsections[idx];
            var firstObjectNumber = String(subsection[0].ref.objectNumber);
            offset += (0, $8hWZH.copyStringIntoBuffer)(firstObjectNumber, buffer, offset);
            buffer[offset++] = (0, $8KH3B.default).Space;
            var rangeLength = String(subsection.length);
            offset += (0, $8hWZH.copyStringIntoBuffer)(rangeLength, buffer, offset);
            buffer[offset++] = (0, $8KH3B.default).Newline;
            offset += this.copyEntriesIntoBuffer(subsection, buffer, offset);
        }
        return offset - initialOffset;
    };
    PDFCrossRefSection.prototype.copyEntriesIntoBuffer = function(entries, buffer, offset) {
        var length = entries.length;
        for(var idx = 0; idx < length; idx++){
            var entry = entries[idx];
            var entryOffset = (0, $8hWZH.padStart)(String(entry.offset), 10, '0');
            offset += (0, $8hWZH.copyStringIntoBuffer)(entryOffset, buffer, offset);
            buffer[offset++] = (0, $8KH3B.default).Space;
            var entryGen = (0, $8hWZH.padStart)(String(entry.ref.generationNumber), 5, '0');
            offset += (0, $8hWZH.copyStringIntoBuffer)(entryGen, buffer, offset);
            buffer[offset++] = (0, $8KH3B.default).Space;
            buffer[offset++] = entry.deleted ? (0, $8KH3B.default).f : (0, $8KH3B.default).n;
            buffer[offset++] = (0, $8KH3B.default).Space;
            buffer[offset++] = (0, $8KH3B.default).Newline;
        }
        return 20 * length;
    };
    PDFCrossRefSection.prototype.append = function(currEntry) {
        if (this.chunkLength === 0) {
            this.subsections.push([
                currEntry
            ]);
            this.chunkIdx = 0;
            this.chunkLength = 1;
            return;
        }
        var chunk = this.subsections[this.chunkIdx];
        var prevEntry = chunk[this.chunkLength - 1];
        if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
            this.subsections.push([
                currEntry
            ]);
            this.chunkIdx += 1;
            this.chunkLength = 1;
        } else {
            chunk.push(currEntry);
            this.chunkLength += 1;
        }
    };
    PDFCrossRefSection.create = function() {
        return new PDFCrossRefSection({
            ref: (0, $69d09480b29248e9$export$2e2bcd8739ae039).of(0, 65535),
            offset: 0,
            deleted: true
        });
    };
    PDFCrossRefSection.createEmpty = function() {
        return new PDFCrossRefSection();
    };
    return PDFCrossRefSection;
}();
var $9c4138d1e86666d6$export$2e2bcd8739ae039 = $9c4138d1e86666d6$var$PDFCrossRefSection;




var $8KH3B = parcelRequire("8KH3B");
parcelRequire("5bpFt");
var $8hWZH = parcelRequire("8hWZH");
var $61285794ba3149fa$var$PDFTrailer = /** @class */ function() {
    function PDFTrailer(lastXRefOffset) {
        this.lastXRefOffset = String(lastXRefOffset);
    }
    PDFTrailer.prototype.toString = function() {
        return "startxref\n" + this.lastXRefOffset + "\n%%EOF";
    };
    PDFTrailer.prototype.sizeInBytes = function() {
        return 16 + this.lastXRefOffset.length;
    };
    PDFTrailer.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8KH3B.default).s;
        buffer[offset++] = (0, $8KH3B.default).t;
        buffer[offset++] = (0, $8KH3B.default).a;
        buffer[offset++] = (0, $8KH3B.default).r;
        buffer[offset++] = (0, $8KH3B.default).t;
        buffer[offset++] = (0, $8KH3B.default).x;
        buffer[offset++] = (0, $8KH3B.default).r;
        buffer[offset++] = (0, $8KH3B.default).e;
        buffer[offset++] = (0, $8KH3B.default).f;
        buffer[offset++] = (0, $8KH3B.default).Newline;
        offset += (0, $8hWZH.copyStringIntoBuffer)(this.lastXRefOffset, buffer, offset);
        buffer[offset++] = (0, $8KH3B.default).Newline;
        buffer[offset++] = (0, $8KH3B.default).Percent;
        buffer[offset++] = (0, $8KH3B.default).Percent;
        buffer[offset++] = (0, $8KH3B.default).E;
        buffer[offset++] = (0, $8KH3B.default).O;
        buffer[offset++] = (0, $8KH3B.default).F;
        return offset - initialOffset;
    };
    PDFTrailer.forLastCrossRefSectionOffset = function(offset) {
        return new PDFTrailer(offset);
    };
    return PDFTrailer;
}();
var $61285794ba3149fa$export$2e2bcd8739ae039 = $61285794ba3149fa$var$PDFTrailer;



var $8KH3B = parcelRequire("8KH3B");
var $2727f9bf156d5168$var$PDFTrailerDict = /** @class */ function() {
    function PDFTrailerDict(dict) {
        this.dict = dict;
    }
    PDFTrailerDict.prototype.toString = function() {
        return "trailer\n" + this.dict.toString();
    };
    PDFTrailerDict.prototype.sizeInBytes = function() {
        return 8 + this.dict.sizeInBytes();
    };
    PDFTrailerDict.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8KH3B.default).t;
        buffer[offset++] = (0, $8KH3B.default).r;
        buffer[offset++] = (0, $8KH3B.default).a;
        buffer[offset++] = (0, $8KH3B.default).i;
        buffer[offset++] = (0, $8KH3B.default).l;
        buffer[offset++] = (0, $8KH3B.default).e;
        buffer[offset++] = (0, $8KH3B.default).r;
        buffer[offset++] = (0, $8KH3B.default).Newline;
        offset += this.dict.copyBytesInto(buffer, offset);
        return offset - initialOffset;
    };
    PDFTrailerDict.of = function(dict) {
        return new PDFTrailerDict(dict);
    };
    return PDFTrailerDict;
}();
var $2727f9bf156d5168$export$2e2bcd8739ae039 = $2727f9bf156d5168$var$PDFTrailerDict;



var $273XO = parcelRequire("273XO");

var $alPcq = parcelRequire("alPcq");

var $4MKjy = parcelRequire("4MKjy");


var $8KH3B = parcelRequire("8KH3B");
parcelRequire("5bpFt");
var $8hWZH = parcelRequire("8hWZH");
var $a9yd5 = parcelRequire("a9yd5");
var $e798caf531745813$var$PDFObjectStream = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFObjectStream, _super);
    function PDFObjectStream(context, objects, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, context.obj({}), encode) || this;
        _this.objects = objects;
        _this.offsets = _this.computeObjectOffsets();
        _this.offsetsString = _this.computeOffsetsString();
        _this.dict.set((0, $alPcq.default).of('Type'), (0, $alPcq.default).of('ObjStm'));
        _this.dict.set((0, $alPcq.default).of('N'), (0, $4MKjy.default).of(_this.objects.length));
        _this.dict.set((0, $alPcq.default).of('First'), (0, $4MKjy.default).of(_this.offsetsString.length));
        return _this;
    }
    PDFObjectStream.prototype.getObjectsCount = function() {
        return this.objects.length;
    };
    PDFObjectStream.prototype.clone = function(context) {
        return PDFObjectStream.withContextAndObjects(context || this.dict.context, this.objects.slice(), this.encode);
    };
    PDFObjectStream.prototype.getContentsString = function() {
        var value = this.offsetsString;
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], object = _a[1];
            value += object + "\n";
        }
        return value;
    };
    PDFObjectStream.prototype.getUnencodedContents = function() {
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = (0, $8hWZH.copyStringIntoBuffer)(this.offsetsString, buffer, 0);
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], object = _a[1];
            offset += object.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8KH3B.default).Newline;
        }
        return buffer;
    };
    PDFObjectStream.prototype.getUnencodedContentsSize = function() {
        return this.offsetsString.length + (0, $a9yd5.last)(this.offsets)[1] + (0, $a9yd5.last)(this.objects)[1].sizeInBytes() + 1;
    };
    PDFObjectStream.prototype.computeOffsetsString = function() {
        var offsetsString = '';
        for(var idx = 0, len = this.offsets.length; idx < len; idx++){
            var _a = this.offsets[idx], objectNumber = _a[0], offset = _a[1];
            offsetsString += objectNumber + " " + offset + " ";
        }
        return offsetsString;
    };
    PDFObjectStream.prototype.computeObjectOffsets = function() {
        var offset = 0;
        var offsets = new Array(this.objects.length);
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], ref = _a[0], object = _a[1];
            offsets[idx] = [
                ref.objectNumber,
                offset
            ];
            offset += object.sizeInBytes() + 1; // '\n'
        }
        return offsets;
    };
    PDFObjectStream.withContextAndObjects = function(context, objects, encode) {
        if (encode === void 0) encode = true;
        return new PDFObjectStream(context, objects, encode);
    };
    return PDFObjectStream;
}((0, $beb440d1eb2e8cc9$export$2e2bcd8739ae039));
var $e798caf531745813$export$2e2bcd8739ae039 = $e798caf531745813$var$PDFObjectStream;



var $8KH3B = parcelRequire("8KH3B");
parcelRequire("5bpFt");
var $8hWZH = parcelRequire("8hWZH");
var $42Fix = parcelRequire("42Fix");
var $132e973bcddbb568$var$PDFWriter = /** @class */ function() {
    function PDFWriter(context, objectsPerTick) {
        var _this = this;
        this.parsedObjects = 0;
        this.shouldWaitForTick = function(n) {
            _this.parsedObjects += n;
            return _this.parsedObjects % _this.objectsPerTick === 0;
        };
        this.context = context;
        this.objectsPerTick = objectsPerTick;
    }
    PDFWriter.prototype.serializeToBuffer = function() {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var _a, size, header, indirectObjects, xref, trailerDict, trailer, offset, buffer, idx, len, _b, ref, object, objectNumber, generationNumber, n;
            return (0, $273XO.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.computeBufferSize()
                        ];
                    case 1:
                        _a = _c.sent(), size = _a.size, header = _a.header, indirectObjects = _a.indirectObjects, xref = _a.xref, trailerDict = _a.trailerDict, trailer = _a.trailer;
                        offset = 0;
                        buffer = new Uint8Array(size);
                        offset += header.copyBytesInto(buffer, offset);
                        buffer[offset++] = (0, $8KH3B.default).Newline;
                        buffer[offset++] = (0, $8KH3B.default).Newline;
                        idx = 0, len = indirectObjects.length;
                        _c.label = 2;
                    case 2:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            5
                        ];
                        _b = indirectObjects[idx], ref = _b[0], object = _b[1];
                        objectNumber = String(ref.objectNumber);
                        offset += (0, $8hWZH.copyStringIntoBuffer)(objectNumber, buffer, offset);
                        buffer[offset++] = (0, $8KH3B.default).Space;
                        generationNumber = String(ref.generationNumber);
                        offset += (0, $8hWZH.copyStringIntoBuffer)(generationNumber, buffer, offset);
                        buffer[offset++] = (0, $8KH3B.default).Space;
                        buffer[offset++] = (0, $8KH3B.default).o;
                        buffer[offset++] = (0, $8KH3B.default).b;
                        buffer[offset++] = (0, $8KH3B.default).j;
                        buffer[offset++] = (0, $8KH3B.default).Newline;
                        offset += object.copyBytesInto(buffer, offset);
                        buffer[offset++] = (0, $8KH3B.default).Newline;
                        buffer[offset++] = (0, $8KH3B.default).e;
                        buffer[offset++] = (0, $8KH3B.default).n;
                        buffer[offset++] = (0, $8KH3B.default).d;
                        buffer[offset++] = (0, $8KH3B.default).o;
                        buffer[offset++] = (0, $8KH3B.default).b;
                        buffer[offset++] = (0, $8KH3B.default).j;
                        buffer[offset++] = (0, $8KH3B.default).Newline;
                        buffer[offset++] = (0, $8KH3B.default).Newline;
                        n = object instanceof (0, $e798caf531745813$export$2e2bcd8739ae039) ? object.getObjectsCount() : 1;
                        if (!this.shouldWaitForTick(n)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $42Fix.waitForTick)()
                        ];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        idx++;
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        if (xref) {
                            offset += xref.copyBytesInto(buffer, offset);
                            buffer[offset++] = (0, $8KH3B.default).Newline;
                        }
                        if (trailerDict) {
                            offset += trailerDict.copyBytesInto(buffer, offset);
                            buffer[offset++] = (0, $8KH3B.default).Newline;
                            buffer[offset++] = (0, $8KH3B.default).Newline;
                        }
                        offset += trailer.copyBytesInto(buffer, offset);
                        return [
                            2 /*return*/ ,
                            buffer
                        ];
                }
            });
        });
    };
    PDFWriter.prototype.computeIndirectObjectSize = function(_a) {
        var ref = _a[0], object = _a[1];
        var refSize = ref.sizeInBytes() + 3; // 'R' -> 'obj\n'
        var objectSize = object.sizeInBytes() + 9; // '\nendobj\n\n'
        return refSize + objectSize;
    };
    PDFWriter.prototype.createTrailerDict = function() {
        return this.context.obj({
            Size: this.context.largestObjectNumber + 1,
            Root: this.context.trailerInfo.Root,
            Encrypt: this.context.trailerInfo.Encrypt,
            Info: this.context.trailerInfo.Info,
            ID: this.context.trailerInfo.ID
        });
    };
    PDFWriter.prototype.computeBufferSize = function() {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var header, size, xref, indirectObjects, idx, len, indirectObject, ref, xrefOffset, trailerDict, trailer;
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        header = (0, $526f381db166a209$export$2e2bcd8739ae039).forVersion(1, 7);
                        size = header.sizeInBytes() + 2;
                        xref = (0, $9c4138d1e86666d6$export$2e2bcd8739ae039).create();
                        indirectObjects = this.context.enumerateIndirectObjects();
                        idx = 0, len = indirectObjects.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        indirectObject = indirectObjects[idx];
                        ref = indirectObject[0];
                        xref.addEntry(ref, size);
                        size += this.computeIndirectObjectSize(indirectObject);
                        if (!this.shouldWaitForTick(1)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $42Fix.waitForTick)()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        xrefOffset = size;
                        size += xref.sizeInBytes() + 1; // '\n'
                        trailerDict = (0, $2727f9bf156d5168$export$2e2bcd8739ae039).of(this.createTrailerDict());
                        size += trailerDict.sizeInBytes() + 2; // '\n\n'
                        trailer = (0, $61285794ba3149fa$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(xrefOffset);
                        size += trailer.sizeInBytes();
                        return [
                            2 /*return*/ ,
                            {
                                size: size,
                                header: header,
                                indirectObjects: indirectObjects,
                                xref: xref,
                                trailerDict: trailerDict,
                                trailer: trailer
                            }
                        ];
                }
            });
        });
    };
    PDFWriter.forContext = function(context, objectsPerTick) {
        return new PDFWriter(context, objectsPerTick);
    };
    return PDFWriter;
}();
var $132e973bcddbb568$export$2e2bcd8739ae039 = $132e973bcddbb568$var$PDFWriter;



var $273XO = parcelRequire("273XO");



var $273XO = parcelRequire("273XO");

var $eKLLF = parcelRequire("eKLLF");
var $393c3204b5eece76$var$PDFInvalidObject = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFInvalidObject, _super);
    function PDFInvalidObject(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    PDFInvalidObject.prototype.clone = function() {
        return PDFInvalidObject.of(this.data.slice());
    };
    PDFInvalidObject.prototype.toString = function() {
        return "PDFInvalidObject(" + this.data.length + " bytes)";
    };
    PDFInvalidObject.prototype.sizeInBytes = function() {
        return this.data.length;
    };
    PDFInvalidObject.prototype.copyBytesInto = function(buffer, offset) {
        var length = this.data.length;
        for(var idx = 0; idx < length; idx++)buffer[offset++] = this.data[idx];
        return length;
    };
    PDFInvalidObject.of = function(data) {
        return new PDFInvalidObject(data);
    };
    return PDFInvalidObject;
}((0, $eKLLF.default));
var $393c3204b5eece76$export$2e2bcd8739ae039 = $393c3204b5eece76$var$PDFInvalidObject;



var $alPcq = parcelRequire("alPcq");

var $4MKjy = parcelRequire("4MKjy");



var $273XO = parcelRequire("273XO");

var $alPcq = parcelRequire("alPcq");


parcelRequire("5bpFt");
var $lAEMS = parcelRequire("lAEMS");
var $hGYOY = parcelRequire("hGYOY");
var $a9yd5 = parcelRequire("a9yd5");
var $8266c2a23324656b$export$e41c32906b33062a;
(function(EntryType) {
    EntryType[EntryType["Deleted"] = 0] = "Deleted";
    EntryType[EntryType["Uncompressed"] = 1] = "Uncompressed";
    EntryType[EntryType["Compressed"] = 2] = "Compressed";
})($8266c2a23324656b$export$e41c32906b33062a || ($8266c2a23324656b$export$e41c32906b33062a = {}));
/**
 * Entries should be added using the [[addDeletedEntry]],
 * [[addUncompressedEntry]], and [[addCompressedEntry]] methods
 * **in order of ascending object number**.
 */ var $8266c2a23324656b$var$PDFCrossRefStream = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFCrossRefStream, _super);
    function PDFCrossRefStream(dict, entries, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, dict, encode) || this;
        // Returns an array of integer pairs for each subsection of the cross ref
        // section, where each integer pair represents:
        //   firstObjectNumber(OfSection), length(OfSection)
        _this.computeIndex = function() {
            var subsections = [];
            var subsectionLength = 0;
            for(var idx = 0, len = _this.entries.length; idx < len; idx++){
                var currEntry = _this.entries[idx];
                var prevEntry = _this.entries[idx - 1];
                if (idx === 0) subsections.push(currEntry.ref.objectNumber);
                else if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
                    subsections.push(subsectionLength);
                    subsections.push(currEntry.ref.objectNumber);
                    subsectionLength = 0;
                }
                subsectionLength += 1;
            }
            subsections.push(subsectionLength);
            return subsections;
        };
        _this.computeEntryTuples = function() {
            var entryTuples = new Array(_this.entries.length);
            for(var idx = 0, len = _this.entries.length; idx < len; idx++){
                var entry = _this.entries[idx];
                if (entry.type === $8266c2a23324656b$export$e41c32906b33062a.Deleted) {
                    var type = entry.type, nextFreeObjectNumber = entry.nextFreeObjectNumber, ref = entry.ref;
                    entryTuples[idx] = [
                        type,
                        nextFreeObjectNumber,
                        ref.generationNumber
                    ];
                }
                if (entry.type === $8266c2a23324656b$export$e41c32906b33062a.Uncompressed) {
                    var type = entry.type, offset = entry.offset, ref = entry.ref;
                    entryTuples[idx] = [
                        type,
                        offset,
                        ref.generationNumber
                    ];
                }
                if (entry.type === $8266c2a23324656b$export$e41c32906b33062a.Compressed) {
                    var type = entry.type, objectStreamRef = entry.objectStreamRef, index = entry.index;
                    entryTuples[idx] = [
                        type,
                        objectStreamRef.objectNumber,
                        index
                    ];
                }
            }
            return entryTuples;
        };
        _this.computeMaxEntryByteWidths = function() {
            var entryTuples = _this.entryTuplesCache.access();
            var widths = [
                0,
                0,
                0
            ];
            for(var idx = 0, len = entryTuples.length; idx < len; idx++){
                var _a = entryTuples[idx], first = _a[0], second = _a[1], third = _a[2];
                var firstSize = (0, $lAEMS.sizeInBytes)(first);
                var secondSize = (0, $lAEMS.sizeInBytes)(second);
                var thirdSize = (0, $lAEMS.sizeInBytes)(third);
                if (firstSize > widths[0]) widths[0] = firstSize;
                if (secondSize > widths[1]) widths[1] = secondSize;
                if (thirdSize > widths[2]) widths[2] = thirdSize;
            }
            return widths;
        };
        _this.entries = entries || [];
        _this.entryTuplesCache = (0, $hGYOY.default).populatedBy(_this.computeEntryTuples);
        _this.maxByteWidthsCache = (0, $hGYOY.default).populatedBy(_this.computeMaxEntryByteWidths);
        _this.indexCache = (0, $hGYOY.default).populatedBy(_this.computeIndex);
        dict.set((0, $alPcq.default).of('Type'), (0, $alPcq.default).of('XRef'));
        return _this;
    }
    PDFCrossRefStream.prototype.addDeletedEntry = function(ref, nextFreeObjectNumber) {
        var type = $8266c2a23324656b$export$e41c32906b33062a.Deleted;
        this.entries.push({
            type: type,
            ref: ref,
            nextFreeObjectNumber: nextFreeObjectNumber
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.addUncompressedEntry = function(ref, offset) {
        var type = $8266c2a23324656b$export$e41c32906b33062a.Uncompressed;
        this.entries.push({
            type: type,
            ref: ref,
            offset: offset
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.addCompressedEntry = function(ref, objectStreamRef, index) {
        var type = $8266c2a23324656b$export$e41c32906b33062a.Compressed;
        this.entries.push({
            type: type,
            ref: ref,
            objectStreamRef: objectStreamRef,
            index: index
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.clone = function(context) {
        var _a = this, dict = _a.dict, entries = _a.entries, encode = _a.encode;
        return PDFCrossRefStream.of(dict.clone(context), entries.slice(), encode);
    };
    PDFCrossRefStream.prototype.getContentsString = function() {
        var entryTuples = this.entryTuplesCache.access();
        var byteWidths = this.maxByteWidthsCache.access();
        var value = '';
        for(var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++){
            var _a = entryTuples[entryIdx], first = _a[0], second = _a[1], third = _a[2];
            var firstBytes = (0, $a9yd5.reverseArray)((0, $lAEMS.bytesFor)(first));
            var secondBytes = (0, $a9yd5.reverseArray)((0, $lAEMS.bytesFor)(second));
            var thirdBytes = (0, $a9yd5.reverseArray)((0, $lAEMS.bytesFor)(third));
            for(var idx = byteWidths[0] - 1; idx >= 0; idx--)value += (firstBytes[idx] || 0).toString(2);
            for(var idx = byteWidths[1] - 1; idx >= 0; idx--)value += (secondBytes[idx] || 0).toString(2);
            for(var idx = byteWidths[2] - 1; idx >= 0; idx--)value += (thirdBytes[idx] || 0).toString(2);
        }
        return value;
    };
    PDFCrossRefStream.prototype.getUnencodedContents = function() {
        var entryTuples = this.entryTuplesCache.access();
        var byteWidths = this.maxByteWidthsCache.access();
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = 0;
        for(var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++){
            var _a = entryTuples[entryIdx], first = _a[0], second = _a[1], third = _a[2];
            var firstBytes = (0, $a9yd5.reverseArray)((0, $lAEMS.bytesFor)(first));
            var secondBytes = (0, $a9yd5.reverseArray)((0, $lAEMS.bytesFor)(second));
            var thirdBytes = (0, $a9yd5.reverseArray)((0, $lAEMS.bytesFor)(third));
            for(var idx = byteWidths[0] - 1; idx >= 0; idx--)buffer[offset++] = firstBytes[idx] || 0;
            for(var idx = byteWidths[1] - 1; idx >= 0; idx--)buffer[offset++] = secondBytes[idx] || 0;
            for(var idx = byteWidths[2] - 1; idx >= 0; idx--)buffer[offset++] = thirdBytes[idx] || 0;
        }
        return buffer;
    };
    PDFCrossRefStream.prototype.getUnencodedContentsSize = function() {
        var byteWidths = this.maxByteWidthsCache.access();
        var entryWidth = (0, $a9yd5.sum)(byteWidths);
        return entryWidth * this.entries.length;
    };
    PDFCrossRefStream.prototype.updateDict = function() {
        _super.prototype.updateDict.call(this);
        var byteWidths = this.maxByteWidthsCache.access();
        var index = this.indexCache.access();
        var context = this.dict.context;
        this.dict.set((0, $alPcq.default).of('W'), context.obj(byteWidths));
        this.dict.set((0, $alPcq.default).of('Index'), context.obj(index));
    };
    PDFCrossRefStream.create = function(dict, encode) {
        if (encode === void 0) encode = true;
        var stream = new PDFCrossRefStream(dict, [], encode);
        stream.addDeletedEntry((0, $69d09480b29248e9$export$2e2bcd8739ae039).of(0, 65535), 0);
        return stream;
    };
    PDFCrossRefStream.of = function(dict, entries, encode) {
        if (encode === void 0) encode = true;
        return new PDFCrossRefStream(dict, entries, encode);
    };
    return PDFCrossRefStream;
}((0, $beb440d1eb2e8cc9$export$2e2bcd8739ae039));
var $8266c2a23324656b$export$2e2bcd8739ae039 = $8266c2a23324656b$var$PDFCrossRefStream;




parcelRequire("5bpFt");
var $a9yd5 = parcelRequire("a9yd5");
var $42Fix = parcelRequire("42Fix");
var $4dd4e6f2a071605b$var$PDFStreamWriter = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFStreamWriter, _super);
    function PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream) {
        var _this = _super.call(this, context, objectsPerTick) || this;
        _this.encodeStreams = encodeStreams;
        _this.objectsPerStream = objectsPerStream;
        return _this;
    }
    PDFStreamWriter.prototype.computeBufferSize = function() {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var objectNumber, header, size, xrefStream, uncompressedObjects, compressedObjects, objectStreamRefs, indirectObjects, idx, len, indirectObject, ref, object, shouldNotCompress, chunk, objectStreamRef, idx, len, chunk, ref, objectStream, xrefStreamRef, xrefOffset, trailer;
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        objectNumber = this.context.largestObjectNumber + 1;
                        header = (0, $526f381db166a209$export$2e2bcd8739ae039).forVersion(1, 7);
                        size = header.sizeInBytes() + 2;
                        xrefStream = (0, $8266c2a23324656b$export$2e2bcd8739ae039).create(this.createTrailerDict(), this.encodeStreams);
                        uncompressedObjects = [];
                        compressedObjects = [];
                        objectStreamRefs = [];
                        indirectObjects = this.context.enumerateIndirectObjects();
                        idx = 0, len = indirectObjects.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            6
                        ];
                        indirectObject = indirectObjects[idx];
                        ref = indirectObject[0], object = indirectObject[1];
                        shouldNotCompress = ref === this.context.trailerInfo.Encrypt || object instanceof (0, $c444ed3a6bfbd846$export$2e2bcd8739ae039) || object instanceof (0, $393c3204b5eece76$export$2e2bcd8739ae039) || ref.generationNumber !== 0;
                        if (!shouldNotCompress) return [
                            3 /*break*/ ,
                            4
                        ];
                        uncompressedObjects.push(indirectObject);
                        xrefStream.addUncompressedEntry(ref, size);
                        size += this.computeIndirectObjectSize(indirectObject);
                        if (!this.shouldWaitForTick(1)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $42Fix.waitForTick)()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        chunk = (0, $a9yd5.last)(compressedObjects);
                        objectStreamRef = (0, $a9yd5.last)(objectStreamRefs);
                        if (!chunk || chunk.length % this.objectsPerStream === 0) {
                            chunk = [];
                            compressedObjects.push(chunk);
                            objectStreamRef = (0, $69d09480b29248e9$export$2e2bcd8739ae039).of(objectNumber++);
                            objectStreamRefs.push(objectStreamRef);
                        }
                        xrefStream.addCompressedEntry(ref, objectStreamRef, chunk.length);
                        chunk.push(indirectObject);
                        _a.label = 5;
                    case 5:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 6:
                        idx = 0, len = compressedObjects.length;
                        _a.label = 7;
                    case 7:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            10
                        ];
                        chunk = compressedObjects[idx];
                        ref = objectStreamRefs[idx];
                        objectStream = (0, $e798caf531745813$export$2e2bcd8739ae039).withContextAndObjects(this.context, chunk, this.encodeStreams);
                        xrefStream.addUncompressedEntry(ref, size);
                        size += this.computeIndirectObjectSize([
                            ref,
                            objectStream
                        ]);
                        uncompressedObjects.push([
                            ref,
                            objectStream
                        ]);
                        if (!this.shouldWaitForTick(chunk.length)) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $42Fix.waitForTick)()
                        ];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        idx++;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 10:
                        xrefStreamRef = (0, $69d09480b29248e9$export$2e2bcd8739ae039).of(objectNumber++);
                        xrefStream.dict.set((0, $alPcq.default).of('Size'), (0, $4MKjy.default).of(objectNumber));
                        xrefStream.addUncompressedEntry(xrefStreamRef, size);
                        xrefOffset = size;
                        size += this.computeIndirectObjectSize([
                            xrefStreamRef,
                            xrefStream
                        ]);
                        uncompressedObjects.push([
                            xrefStreamRef,
                            xrefStream
                        ]);
                        trailer = (0, $61285794ba3149fa$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(xrefOffset);
                        size += trailer.sizeInBytes();
                        return [
                            2 /*return*/ ,
                            {
                                size: size,
                                header: header,
                                indirectObjects: uncompressedObjects,
                                trailer: trailer
                            }
                        ];
                }
            });
        });
    };
    PDFStreamWriter.forContext = function(context, objectsPerTick, encodeStreams, objectsPerStream) {
        if (encodeStreams === void 0) encodeStreams = true;
        if (objectsPerStream === void 0) objectsPerStream = 50;
        return new PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream);
    };
    return PDFStreamWriter;
}((0, $132e973bcddbb568$export$2e2bcd8739ae039));
var $4dd4e6f2a071605b$export$2e2bcd8739ae039 = $4dd4e6f2a071605b$var$PDFStreamWriter;






parcelRequire("X7kVn");
var $kErbs = parcelRequire("kErbs");
var $bv6ba = parcelRequire("bv6ba");

var $273XO = parcelRequire("273XO");

var $eKLLF = parcelRequire("eKLLF");

var $8KH3B = parcelRequire("8KH3B");
parcelRequire("5bpFt");
var $8hWZH = parcelRequire("8hWZH");
var $67HjY = parcelRequire("67HjY");
var $kUYxV = parcelRequire("kUYxV");

var $iMObG = parcelRequire("iMObG");
var $d8f6d7884257882d$var$PDFHexString = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFHexString, _super);
    function PDFHexString(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFHexString.prototype.asBytes = function() {
        // Append a zero if the number of digits is odd. See PDF spec 7.3.4.3
        var hex = this.value + (this.value.length % 2 === 1 ? '0' : '');
        var hexLength = hex.length;
        var bytes = new Uint8Array(hex.length / 2);
        var hexOffset = 0;
        var bytesOffset = 0;
        // Interpret each pair of hex digits as a single byte
        while(hexOffset < hexLength){
            var byte = parseInt(hex.substring(hexOffset, hexOffset + 2), 16);
            bytes[bytesOffset] = byte;
            hexOffset += 2;
            bytesOffset += 1;
        }
        return bytes;
    };
    PDFHexString.prototype.decodeText = function() {
        var bytes = this.asBytes();
        if ((0, $67HjY.hasUtf16BOM)(bytes)) return (0, $67HjY.utf16Decode)(bytes);
        return (0, $kUYxV.pdfDocEncodingDecode)(bytes);
    };
    PDFHexString.prototype.decodeDate = function() {
        var text = this.decodeText();
        var date = (0, $8hWZH.parseDate)(text);
        if (!date) throw new (0, $iMObG.InvalidPDFDateStringError)(text);
        return date;
    };
    PDFHexString.prototype.asString = function() {
        return this.value;
    };
    PDFHexString.prototype.clone = function() {
        return PDFHexString.of(this.value);
    };
    PDFHexString.prototype.toString = function() {
        return "<" + this.value + ">";
    };
    PDFHexString.prototype.sizeInBytes = function() {
        return this.value.length + 2;
    };
    PDFHexString.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $8KH3B.default).LessThan;
        offset += (0, $8hWZH.copyStringIntoBuffer)(this.value, buffer, offset);
        buffer[offset++] = (0, $8KH3B.default).GreaterThan;
        return this.value.length + 2;
    };
    PDFHexString.of = function(value) {
        return new PDFHexString(value);
    };
    PDFHexString.fromText = function(value) {
        var encoded = (0, $67HjY.utf16Encode)(value);
        var hex = '';
        for(var idx = 0, len = encoded.length; idx < len; idx++)hex += (0, $8hWZH.toHexStringOfMinLength)(encoded[idx], 4);
        return new PDFHexString(hex);
    };
    return PDFHexString;
}((0, $eKLLF.default));
var $d8f6d7884257882d$export$2e2bcd8739ae039 = $d8f6d7884257882d$var$PDFHexString;


parcelRequire("5bpFt");
var $8hWZH = parcelRequire("8hWZH");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/foliojs/pdfkit/blob/f91bdd61c164a72ea06be1a43dc0a412afc3925f/lib/font/afm.coffee
 */ var $42d3777696dc5a8a$var$StandardFontEmbedder = /** @class */ function() {
    function StandardFontEmbedder(fontName, customName) {
        // prettier-ignore
        this.encoding = fontName === (0, $bv6ba.FontNames).ZapfDingbats ? (0, $kErbs.Encodings).ZapfDingbats : fontName === (0, $bv6ba.FontNames).Symbol ? (0, $kErbs.Encodings).Symbol : (0, $kErbs.Encodings).WinAnsi;
        this.font = (0, $bv6ba.Font).load(fontName);
        this.fontName = this.font.FontName;
        this.customName = customName;
    }
    /**
     * Encode the JavaScript string into this font. (JavaScript encodes strings in
     * Unicode, but standard fonts use either WinAnsi, ZapfDingbats, or Symbol
     * encodings)
     */ StandardFontEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.encodeTextAsGlyphs(text);
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++)hexCodes[idx] = (0, $8hWZH.toHexString)(glyphs[idx].code);
        return (0, $d8f6d7884257882d$export$2e2bcd8739ae039).of(hexCodes.join(''));
    };
    StandardFontEmbedder.prototype.widthOfTextAtSize = function(text, size) {
        var glyphs = this.encodeTextAsGlyphs(text);
        var totalWidth = 0;
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var left = glyphs[idx].name;
            var right = (glyphs[idx + 1] || {}).name;
            var kernAmount = this.font.getXAxisKerningForPair(left, right) || 0;
            totalWidth += this.widthOfGlyph(left) + kernAmount;
        }
        var scale = size / 1000;
        return totalWidth * scale;
    };
    StandardFontEmbedder.prototype.heightOfFontAtSize = function(size, options) {
        if (options === void 0) options = {};
        var _a = options.descender, descender = _a === void 0 ? true : _a;
        var _b = this.font, Ascender = _b.Ascender, Descender = _b.Descender, FontBBox = _b.FontBBox;
        var yTop = Ascender || FontBBox[3];
        var yBottom = Descender || FontBBox[1];
        var height = yTop - yBottom;
        if (!descender) height += Descender || 0;
        return height / 1000 * size;
    };
    StandardFontEmbedder.prototype.sizeOfFontAtHeight = function(height) {
        var _a = this.font, Ascender = _a.Ascender, Descender = _a.Descender, FontBBox = _a.FontBBox;
        var yTop = Ascender || FontBBox[3];
        var yBottom = Descender || FontBBox[1];
        return 1000 * height / (yTop - yBottom);
    };
    StandardFontEmbedder.prototype.embedIntoContext = function(context, ref) {
        var fontDict = context.obj({
            Type: 'Font',
            Subtype: 'Type1',
            BaseFont: this.customName || this.fontName,
            Encoding: this.encoding === (0, $kErbs.Encodings).WinAnsi ? 'WinAnsiEncoding' : undefined
        });
        if (ref) {
            context.assign(ref, fontDict);
            return ref;
        } else return context.register(fontDict);
    };
    StandardFontEmbedder.prototype.widthOfGlyph = function(glyphName) {
        // Default to 250 if font doesn't specify a width
        return this.font.getWidthOfGlyph(glyphName) || 250;
    };
    StandardFontEmbedder.prototype.encodeTextAsGlyphs = function(text) {
        var codePoints = Array.from(text);
        var glyphs = new Array(codePoints.length);
        for(var idx = 0, len = codePoints.length; idx < len; idx++){
            var codePoint = (0, $8hWZH.toCodePoint)(codePoints[idx]);
            glyphs[idx] = this.encoding.encodeUnicodeCodePoint(codePoint);
        }
        return glyphs;
    };
    StandardFontEmbedder.for = function(fontName, customName) {
        return new StandardFontEmbedder(fontName, customName);
    };
    return StandardFontEmbedder;
}();
var $42d3777696dc5a8a$export$2e2bcd8739ae039 = $42d3777696dc5a8a$var$StandardFontEmbedder;



var $273XO = parcelRequire("273XO");
parcelRequire("5bpFt");
var $8hWZH = parcelRequire("8hWZH");

var $67HjY = parcelRequire("67HjY");
var $48dad45bb6329115$export$ecb273704ecc155f = function(glyphs, glyphId) {
    var bfChars = new Array(glyphs.length);
    for(var idx = 0, len = glyphs.length; idx < len; idx++){
        var glyph = glyphs[idx];
        var id = $48dad45bb6329115$var$cmapHexFormat($48dad45bb6329115$var$cmapHexString(glyphId(glyph)));
        var unicode = $48dad45bb6329115$var$cmapHexFormat.apply(void 0, glyph.codePoints.map($48dad45bb6329115$var$cmapCodePointFormat));
        bfChars[idx] = [
            id,
            unicode
        ];
    }
    return $48dad45bb6329115$var$fillCmapTemplate(bfChars);
};
/* =============================== Templates ================================ */ var $48dad45bb6329115$var$fillCmapTemplate = function(bfChars) {
    return "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange\n" + bfChars.length + " beginbfchar\n" + bfChars.map(function(_a) {
        var glyphId = _a[0], codePoint = _a[1];
        return glyphId + " " + codePoint;
    }).join('\n') + "\nendbfchar\nendcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
};
/* =============================== Utilities ================================ */ var $48dad45bb6329115$var$cmapHexFormat = function() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    return "<" + values.join('') + ">";
};
var $48dad45bb6329115$var$cmapHexString = function(value) {
    return (0, $8hWZH.toHexStringOfMinLength)(value, 4);
};
var $48dad45bb6329115$var$cmapCodePointFormat = function(codePoint) {
    if ((0, $67HjY.isWithinBMP)(codePoint)) return $48dad45bb6329115$var$cmapHexString(codePoint);
    if ((0, $67HjY.hasSurrogates)(codePoint)) {
        var hs = (0, $67HjY.highSurrogate)(codePoint);
        var ls = (0, $67HjY.lowSurrogate)(codePoint);
        return "" + $48dad45bb6329115$var$cmapHexString(hs) + $48dad45bb6329115$var$cmapHexString(ls);
    }
    var hex = (0, $8hWZH.toHexString)(codePoint);
    var msg = "0x" + hex + " is not a valid UTF-8 or UTF-16 codepoint.";
    throw new Error(msg);
};


// prettier-ignore
var $b29036bb134d30b0$var$makeFontFlags = function(options) {
    var flags = 0;
    var flipBit = function(bit) {
        flags |= 1 << bit - 1;
    };
    if (options.fixedPitch) flipBit(1);
    if (options.serif) flipBit(2);
    if (options.symbolic) flipBit(3);
    if (options.script) flipBit(4);
    if (options.nonsymbolic) flipBit(6);
    if (options.italic) flipBit(7);
    if (options.allCap) flipBit(17);
    if (options.smallCap) flipBit(18);
    if (options.forceBold) flipBit(19);
    return flags;
};
var $b29036bb134d30b0$export$aa92af1a056b24e8 = function(font) {
    var familyClass = font['OS/2'] ? font['OS/2'].sFamilyClass : 0;
    var flags = $b29036bb134d30b0$var$makeFontFlags({
        fixedPitch: font.post.isFixedPitch,
        serif: 1 <= familyClass && familyClass <= 7,
        symbolic: true,
        script: familyClass === 10,
        italic: font.head.macStyle.italic
    });
    return flags;
};




var $273XO = parcelRequire("273XO");

var $eKLLF = parcelRequire("eKLLF");

var $8KH3B = parcelRequire("8KH3B");
parcelRequire("5bpFt");
var $8hWZH = parcelRequire("8hWZH");
var $67HjY = parcelRequire("67HjY");
var $kUYxV = parcelRequire("kUYxV");

var $iMObG = parcelRequire("iMObG");
var $059039c0c7d9ffc8$var$PDFString = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFString, _super);
    function PDFString(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFString.prototype.asBytes = function() {
        var bytes = [];
        var octal = '';
        var escaped = false;
        var pushByte = function(byte) {
            if (byte !== undefined) bytes.push(byte);
            escaped = false;
        };
        for(var idx = 0, len = this.value.length; idx < len; idx++){
            var char = this.value[idx];
            var byte = (0, $8hWZH.toCharCode)(char);
            var nextChar = this.value[idx + 1];
            if (!escaped) {
                if (byte === (0, $8KH3B.default).BackSlash) escaped = true;
                else pushByte(byte);
            } else {
                if (byte === (0, $8KH3B.default).Newline) pushByte();
                else if (byte === (0, $8KH3B.default).CarriageReturn) pushByte();
                else if (byte === (0, $8KH3B.default).n) pushByte((0, $8KH3B.default).Newline);
                else if (byte === (0, $8KH3B.default).r) pushByte((0, $8KH3B.default).CarriageReturn);
                else if (byte === (0, $8KH3B.default).t) pushByte((0, $8KH3B.default).Tab);
                else if (byte === (0, $8KH3B.default).b) pushByte((0, $8KH3B.default).Backspace);
                else if (byte === (0, $8KH3B.default).f) pushByte((0, $8KH3B.default).FormFeed);
                else if (byte === (0, $8KH3B.default).LeftParen) pushByte((0, $8KH3B.default).LeftParen);
                else if (byte === (0, $8KH3B.default).RightParen) pushByte((0, $8KH3B.default).RightParen);
                else if (byte === (0, $8KH3B.default).Backspace) pushByte((0, $8KH3B.default).BackSlash);
                else if (byte >= (0, $8KH3B.default).Zero && byte <= (0, $8KH3B.default).Seven) {
                    octal += char;
                    if (octal.length === 3 || !(nextChar >= '0' && nextChar <= '7')) {
                        pushByte(parseInt(octal, 8));
                        octal = '';
                    }
                } else pushByte(byte);
            }
        }
        return new Uint8Array(bytes);
    };
    PDFString.prototype.decodeText = function() {
        var bytes = this.asBytes();
        if ((0, $67HjY.hasUtf16BOM)(bytes)) return (0, $67HjY.utf16Decode)(bytes);
        return (0, $kUYxV.pdfDocEncodingDecode)(bytes);
    };
    PDFString.prototype.decodeDate = function() {
        var text = this.decodeText();
        var date = (0, $8hWZH.parseDate)(text);
        if (!date) throw new (0, $iMObG.InvalidPDFDateStringError)(text);
        return date;
    };
    PDFString.prototype.asString = function() {
        return this.value;
    };
    PDFString.prototype.clone = function() {
        return PDFString.of(this.value);
    };
    PDFString.prototype.toString = function() {
        return "(" + this.value + ")";
    };
    PDFString.prototype.sizeInBytes = function() {
        return this.value.length + 2;
    };
    PDFString.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $8KH3B.default).LeftParen;
        offset += (0, $8hWZH.copyStringIntoBuffer)(this.value, buffer, offset);
        buffer[offset++] = (0, $8KH3B.default).RightParen;
        return this.value.length + 2;
    };
    // The PDF spec allows newlines and parens to appear directly within a literal
    // string. These character _may_ be escaped. But they do not _have_ to be. So
    // for simplicity, we will not bother escaping them.
    PDFString.of = function(value) {
        return new PDFString(value);
    };
    PDFString.fromDate = function(date) {
        var year = (0, $8hWZH.padStart)(String(date.getUTCFullYear()), 4, '0');
        var month = (0, $8hWZH.padStart)(String(date.getUTCMonth() + 1), 2, '0');
        var day = (0, $8hWZH.padStart)(String(date.getUTCDate()), 2, '0');
        var hours = (0, $8hWZH.padStart)(String(date.getUTCHours()), 2, '0');
        var mins = (0, $8hWZH.padStart)(String(date.getUTCMinutes()), 2, '0');
        var secs = (0, $8hWZH.padStart)(String(date.getUTCSeconds()), 2, '0');
        return new PDFString("D:" + year + month + day + hours + mins + secs + "Z");
    };
    return PDFString;
}((0, $eKLLF.default));
var $059039c0c7d9ffc8$export$2e2bcd8739ae039 = $059039c0c7d9ffc8$var$PDFString;


parcelRequire("5bpFt");
var $a9yd5 = parcelRequire("a9yd5");
var $hGYOY = parcelRequire("hGYOY");
var $8hWZH = parcelRequire("8hWZH");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/jpeg.coffee
 */ var $fb5d08cced3a1a67$var$CustomFontEmbedder = /** @class */ function() {
    function CustomFontEmbedder(font, fontData, customName, fontFeatures) {
        var _this = this;
        this.allGlyphsInFontSortedById = function() {
            var glyphs = new Array(_this.font.characterSet.length);
            for(var idx = 0, len = glyphs.length; idx < len; idx++){
                var codePoint = _this.font.characterSet[idx];
                glyphs[idx] = _this.font.glyphForCodePoint(codePoint);
            }
            return (0, $a9yd5.sortedUniq)(glyphs.sort((0, $a9yd5.byAscendingId)), function(g) {
                return g.id;
            });
        };
        this.font = font;
        this.scale = 1000 / this.font.unitsPerEm;
        this.fontData = fontData;
        this.fontName = this.font.postscriptName || 'Font';
        this.customName = customName;
        this.fontFeatures = fontFeatures;
        this.baseFontName = '';
        this.glyphCache = (0, $hGYOY.default).populatedBy(this.allGlyphsInFontSortedById);
    }
    CustomFontEmbedder.for = function(fontkit, fontData, customName, fontFeatures) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var font;
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fontkit.create(fontData)
                        ];
                    case 1:
                        font = _a.sent();
                        return [
                            2 /*return*/ ,
                            new CustomFontEmbedder(font, fontData, customName, fontFeatures)
                        ];
                }
            });
        });
    };
    /**
     * Encode the JavaScript string into this font. (JavaScript encodes strings in
     * Unicode, but embedded fonts use their own custom encodings)
     */ CustomFontEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++)hexCodes[idx] = (0, $8hWZH.toHexStringOfMinLength)(glyphs[idx].id, 4);
        return (0, $d8f6d7884257882d$export$2e2bcd8739ae039).of(hexCodes.join(''));
    };
    // The advanceWidth takes into account kerning automatically, so we don't
    // have to do that manually like we do for the standard fonts.
    CustomFontEmbedder.prototype.widthOfTextAtSize = function(text, size) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var totalWidth = 0;
        for(var idx = 0, len = glyphs.length; idx < len; idx++)totalWidth += glyphs[idx].advanceWidth * this.scale;
        var scale = size / 1000;
        return totalWidth * scale;
    };
    CustomFontEmbedder.prototype.heightOfFontAtSize = function(size, options) {
        if (options === void 0) options = {};
        var _a = options.descender, descender = _a === void 0 ? true : _a;
        var _b = this.font, ascent = _b.ascent, descent = _b.descent, bbox = _b.bbox;
        var yTop = (ascent || bbox.maxY) * this.scale;
        var yBottom = (descent || bbox.minY) * this.scale;
        var height = yTop - yBottom;
        if (!descender) height -= Math.abs(descent) || 0;
        return height / 1000 * size;
    };
    CustomFontEmbedder.prototype.sizeOfFontAtHeight = function(height) {
        var _a = this.font, ascent = _a.ascent, descent = _a.descent, bbox = _a.bbox;
        var yTop = (ascent || bbox.maxY) * this.scale;
        var yBottom = (descent || bbox.minY) * this.scale;
        return 1000 * height / (yTop - yBottom);
    };
    CustomFontEmbedder.prototype.embedIntoContext = function(context, ref) {
        this.baseFontName = this.customName || context.addRandomSuffix(this.fontName);
        return this.embedFontDict(context, ref);
    };
    CustomFontEmbedder.prototype.embedFontDict = function(context, ref) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var cidFontDictRef, unicodeCMapRef, fontDict;
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedCIDFontDict(context)
                        ];
                    case 1:
                        cidFontDictRef = _a.sent();
                        unicodeCMapRef = this.embedUnicodeCmap(context);
                        fontDict = context.obj({
                            Type: 'Font',
                            Subtype: 'Type0',
                            BaseFont: this.baseFontName,
                            Encoding: 'Identity-H',
                            DescendantFonts: [
                                cidFontDictRef
                            ],
                            ToUnicode: unicodeCMapRef
                        });
                        if (ref) {
                            context.assign(ref, fontDict);
                            return [
                                2 /*return*/ ,
                                ref
                            ];
                        } else return [
                            2 /*return*/ ,
                            context.register(fontDict)
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.isCFF = function() {
        return this.font.cff;
    };
    CustomFontEmbedder.prototype.embedCIDFontDict = function(context) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var fontDescriptorRef, cidFontDict;
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedFontDescriptor(context)
                        ];
                    case 1:
                        fontDescriptorRef = _a.sent();
                        cidFontDict = context.obj({
                            Type: 'Font',
                            Subtype: this.isCFF() ? 'CIDFontType0' : 'CIDFontType2',
                            CIDToGIDMap: 'Identity',
                            BaseFont: this.baseFontName,
                            CIDSystemInfo: {
                                Registry: (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039).of('Adobe'),
                                Ordering: (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039).of('Identity'),
                                Supplement: 0
                            },
                            FontDescriptor: fontDescriptorRef,
                            W: this.computeWidths()
                        });
                        return [
                            2 /*return*/ ,
                            context.register(cidFontDict)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.embedFontDescriptor = function(context) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var fontStreamRef, scale, _a, italicAngle, ascent, descent, capHeight, xHeight, _b, minX, minY, maxX, maxY, fontDescriptor;
            var _c;
            return (0, $273XO.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedFontStream(context)
                        ];
                    case 1:
                        fontStreamRef = _d.sent();
                        scale = this.scale;
                        _a = this.font, italicAngle = _a.italicAngle, ascent = _a.ascent, descent = _a.descent, capHeight = _a.capHeight, xHeight = _a.xHeight;
                        _b = this.font.bbox, minX = _b.minX, minY = _b.minY, maxX = _b.maxX, maxY = _b.maxY;
                        fontDescriptor = context.obj((_c = {
                            Type: 'FontDescriptor',
                            FontName: this.baseFontName,
                            Flags: (0, $b29036bb134d30b0$export$aa92af1a056b24e8)(this.font),
                            FontBBox: [
                                minX * scale,
                                minY * scale,
                                maxX * scale,
                                maxY * scale
                            ],
                            ItalicAngle: italicAngle,
                            Ascent: ascent * scale,
                            Descent: descent * scale,
                            CapHeight: (capHeight || ascent) * scale,
                            XHeight: (xHeight || 0) * scale,
                            // Not sure how to compute/find this, nor is anybody else really:
                            // https://stackoverflow.com/questions/35485179/stemv-value-of-the-truetype-font
                            StemV: 0
                        }, _c[this.isCFF() ? 'FontFile3' : 'FontFile2'] = fontStreamRef, _c));
                        return [
                            2 /*return*/ ,
                            context.register(fontDescriptor)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.serializeFont = function() {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            return (0, $273XO.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.fontData
                ];
            });
        });
    };
    CustomFontEmbedder.prototype.embedFontStream = function(context) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var fontStream, _a, _b;
            return (0, $273XO.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _b = (_a = context).flateStream;
                        return [
                            4 /*yield*/ ,
                            this.serializeFont()
                        ];
                    case 1:
                        fontStream = _b.apply(_a, [
                            _c.sent(),
                            {
                                Subtype: this.isCFF() ? 'CIDFontType0C' : undefined
                            }
                        ]);
                        return [
                            2 /*return*/ ,
                            context.register(fontStream)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.embedUnicodeCmap = function(context) {
        var cmap = (0, $48dad45bb6329115$export$ecb273704ecc155f)(this.glyphCache.access(), this.glyphId.bind(this));
        var cmapStream = context.flateStream(cmap);
        return context.register(cmapStream);
    };
    CustomFontEmbedder.prototype.glyphId = function(glyph) {
        return glyph ? glyph.id : -1;
    };
    CustomFontEmbedder.prototype.computeWidths = function() {
        var glyphs = this.glyphCache.access();
        var widths = [];
        var currSection = [];
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var currGlyph = glyphs[idx];
            var prevGlyph = glyphs[idx - 1];
            var currGlyphId = this.glyphId(currGlyph);
            var prevGlyphId = this.glyphId(prevGlyph);
            if (idx === 0) widths.push(currGlyphId);
            else if (currGlyphId - prevGlyphId !== 1) {
                widths.push(currSection);
                widths.push(currGlyphId);
                currSection = [];
            }
            currSection.push(currGlyph.advanceWidth * this.scale);
        }
        widths.push(currSection);
        return widths;
    };
    return CustomFontEmbedder;
}();
var $fb5d08cced3a1a67$export$2e2bcd8739ae039 = $fb5d08cced3a1a67$var$CustomFontEmbedder;



var $273XO = parcelRequire("273XO");


parcelRequire("5bpFt");
var $hGYOY = parcelRequire("hGYOY");
var $a9yd5 = parcelRequire("a9yd5");
var $8hWZH = parcelRequire("8hWZH");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/jpeg.coffee
 */ var $555fcf888deaa236$var$CustomFontSubsetEmbedder = /** @class */ function(_super) {
    (0, $273XO.__extends)(CustomFontSubsetEmbedder, _super);
    function CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures) {
        var _this = _super.call(this, font, fontData, customFontName, fontFeatures) || this;
        _this.subset = _this.font.createSubset();
        _this.glyphs = [];
        _this.glyphCache = (0, $hGYOY.default).populatedBy(function() {
            return _this.glyphs;
        });
        _this.glyphIdMap = new Map();
        return _this;
    }
    CustomFontSubsetEmbedder.for = function(fontkit, fontData, customFontName, fontFeatures) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var font;
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fontkit.create(fontData)
                        ];
                    case 1:
                        font = _a.sent();
                        return [
                            2 /*return*/ ,
                            new CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures)
                        ];
                }
            });
        });
    };
    CustomFontSubsetEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var glyph = glyphs[idx];
            var subsetGlyphId = this.subset.includeGlyph(glyph);
            this.glyphs[subsetGlyphId - 1] = glyph;
            this.glyphIdMap.set(glyph.id, subsetGlyphId);
            hexCodes[idx] = (0, $8hWZH.toHexStringOfMinLength)(subsetGlyphId, 4);
        }
        this.glyphCache.invalidate();
        return (0, $d8f6d7884257882d$export$2e2bcd8739ae039).of(hexCodes.join(''));
    };
    CustomFontSubsetEmbedder.prototype.isCFF = function() {
        return this.subset.cff;
    };
    CustomFontSubsetEmbedder.prototype.glyphId = function(glyph) {
        return glyph ? this.glyphIdMap.get(glyph.id) : -1;
    };
    CustomFontSubsetEmbedder.prototype.serializeFont = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var parts = [];
            _this.subset.encodeStream().on('data', function(bytes) {
                return parts.push(bytes);
            }).on('end', function() {
                return resolve((0, $a9yd5.mergeUint8Arrays)(parts));
            }).on('error', function(err) {
                return reject(err);
            });
        });
    };
    return CustomFontSubsetEmbedder;
}((0, $fb5d08cced3a1a67$export$2e2bcd8739ae039));
var $555fcf888deaa236$export$2e2bcd8739ae039 = $555fcf888deaa236$var$CustomFontSubsetEmbedder;



var $273XO = parcelRequire("273XO");


var $9ffabe114cecc8c9$export$c12eac46fbec1b74;
(function(AFRelationship) {
    AFRelationship["Source"] = "Source";
    AFRelationship["Data"] = "Data";
    AFRelationship["Alternative"] = "Alternative";
    AFRelationship["Supplement"] = "Supplement";
    AFRelationship["EncryptedPayload"] = "EncryptedPayload";
    AFRelationship["FormData"] = "EncryptedPayload";
    AFRelationship["Schema"] = "Schema";
    AFRelationship["Unspecified"] = "Unspecified";
})($9ffabe114cecc8c9$export$c12eac46fbec1b74 || ($9ffabe114cecc8c9$export$c12eac46fbec1b74 = {}));
var $9ffabe114cecc8c9$var$FileEmbedder = /** @class */ function() {
    function FileEmbedder(fileData, fileName, options) {
        if (options === void 0) options = {};
        this.fileData = fileData;
        this.fileName = fileName;
        this.options = options;
    }
    FileEmbedder.for = function(bytes, fileName, options) {
        if (options === void 0) options = {};
        return new FileEmbedder(bytes, fileName, options);
    };
    FileEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var _a, mimeType, description, creationDate, modificationDate, afRelationship, embeddedFileStream, embeddedFileStreamRef, fileSpecDict;
            return (0, $273XO.__generator)(this, function(_b) {
                _a = this.options, mimeType = _a.mimeType, description = _a.description, creationDate = _a.creationDate, modificationDate = _a.modificationDate, afRelationship = _a.afRelationship;
                embeddedFileStream = context.flateStream(this.fileData, {
                    Type: 'EmbeddedFile',
                    Subtype: mimeType !== null && mimeType !== void 0 ? mimeType : undefined,
                    Params: {
                        Size: this.fileData.length,
                        CreationDate: creationDate ? (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039).fromDate(creationDate) : undefined,
                        ModDate: modificationDate ? (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039).fromDate(modificationDate) : undefined
                    }
                });
                embeddedFileStreamRef = context.register(embeddedFileStream);
                fileSpecDict = context.obj({
                    Type: 'Filespec',
                    F: (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039).of(this.fileName),
                    UF: (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(this.fileName),
                    EF: {
                        F: embeddedFileStreamRef
                    },
                    Desc: description ? (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(description) : undefined,
                    AFRelationship: afRelationship !== null && afRelationship !== void 0 ? afRelationship : undefined
                });
                if (ref) {
                    context.assign(ref, fileSpecDict);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(fileSpecDict)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return FileEmbedder;
}();
var $9ffabe114cecc8c9$export$2e2bcd8739ae039 = $9ffabe114cecc8c9$var$FileEmbedder;



var $273XO = parcelRequire("273XO");
// prettier-ignore
var $979a3eda8f6e7f4c$var$MARKERS = [
    0xffc0,
    0xffc1,
    0xffc2,
    0xffc3,
    0xffc5,
    0xffc6,
    0xffc7,
    0xffc8,
    0xffc9,
    0xffca,
    0xffcb,
    0xffcc,
    0xffcd,
    0xffce,
    0xffcf
];
var $979a3eda8f6e7f4c$var$ColorSpace;
(function(ColorSpace) {
    ColorSpace["DeviceGray"] = "DeviceGray";
    ColorSpace["DeviceRGB"] = "DeviceRGB";
    ColorSpace["DeviceCMYK"] = "DeviceCMYK";
})($979a3eda8f6e7f4c$var$ColorSpace || ($979a3eda8f6e7f4c$var$ColorSpace = {}));
var $979a3eda8f6e7f4c$var$ChannelToColorSpace = {
    1: $979a3eda8f6e7f4c$var$ColorSpace.DeviceGray,
    3: $979a3eda8f6e7f4c$var$ColorSpace.DeviceRGB,
    4: $979a3eda8f6e7f4c$var$ColorSpace.DeviceCMYK
};
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/foliojs/pdfkit/blob/a6af76467ce06bd6a2af4aa7271ccac9ff152a7d/lib/image/jpeg.js
 */ var $979a3eda8f6e7f4c$var$JpegEmbedder = /** @class */ function() {
    function JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace) {
        this.imageData = imageData;
        this.bitsPerComponent = bitsPerComponent;
        this.width = width;
        this.height = height;
        this.colorSpace = colorSpace;
    }
    JpegEmbedder.for = function(imageData) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var dataView, soi, pos, marker, bitsPerComponent, height, width, channelByte, channelName, colorSpace;
            return (0, $273XO.__generator)(this, function(_a) {
                dataView = new DataView(imageData.buffer);
                soi = dataView.getUint16(0);
                if (soi !== 0xffd8) throw new Error('SOI not found in JPEG');
                pos = 2;
                while(pos < dataView.byteLength){
                    marker = dataView.getUint16(pos);
                    pos += 2;
                    if ($979a3eda8f6e7f4c$var$MARKERS.includes(marker)) break;
                    pos += dataView.getUint16(pos);
                }
                if (!$979a3eda8f6e7f4c$var$MARKERS.includes(marker)) throw new Error('Invalid JPEG');
                pos += 2;
                bitsPerComponent = dataView.getUint8(pos++);
                height = dataView.getUint16(pos);
                pos += 2;
                width = dataView.getUint16(pos);
                pos += 2;
                channelByte = dataView.getUint8(pos++);
                channelName = $979a3eda8f6e7f4c$var$ChannelToColorSpace[channelByte];
                if (!channelName) throw new Error('Unknown JPEG channel.');
                colorSpace = channelName;
                return [
                    2 /*return*/ ,
                    new JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace)
                ];
            });
        });
    };
    JpegEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var xObject;
            return (0, $273XO.__generator)(this, function(_a) {
                xObject = context.stream(this.imageData, {
                    Type: 'XObject',
                    Subtype: 'Image',
                    BitsPerComponent: this.bitsPerComponent,
                    Width: this.width,
                    Height: this.height,
                    ColorSpace: this.colorSpace,
                    Filter: 'DCTDecode',
                    // CMYK JPEG streams in PDF are typically stored complemented,
                    // with 1 as 'off' and 0 as 'on' (PDF 32000-1:2008, 8.6.4.4).
                    //
                    // Standalone CMYK JPEG (usually exported by Photoshop) are
                    // stored inverse, with 0 as 'off' and 1 as 'on', like RGB.
                    //
                    // Applying a swap here as a hedge that most bytes passing
                    // through this method will benefit from it.
                    Decode: this.colorSpace === $979a3eda8f6e7f4c$var$ColorSpace.DeviceCMYK ? [
                        1,
                        0,
                        1,
                        0,
                        1,
                        0,
                        1,
                        0
                    ] : undefined
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return JpegEmbedder;
}();
var $979a3eda8f6e7f4c$export$2e2bcd8739ae039 = $979a3eda8f6e7f4c$var$JpegEmbedder;



var $273XO = parcelRequire("273XO");
var $72a59eef0464adf4$exports = {};
// Top level file is just a mixin of submodules & constants
'use strict';
var $6581cb2ac156eb1d$exports = {};
'use strict';
var $6581cb2ac156eb1d$var$TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
function $6581cb2ac156eb1d$var$_has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
$6581cb2ac156eb1d$exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(var p in source)if ($6581cb2ac156eb1d$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
$6581cb2ac156eb1d$exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var $6581cb2ac156eb1d$var$fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var $6581cb2ac156eb1d$var$fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
$6581cb2ac156eb1d$exports.setTyped = function(on) {
    if (on) {
        $6581cb2ac156eb1d$exports.Buf8 = Uint8Array;
        $6581cb2ac156eb1d$exports.Buf16 = Uint16Array;
        $6581cb2ac156eb1d$exports.Buf32 = Int32Array;
        $6581cb2ac156eb1d$exports.assign($6581cb2ac156eb1d$exports, $6581cb2ac156eb1d$var$fnTyped);
    } else {
        $6581cb2ac156eb1d$exports.Buf8 = Array;
        $6581cb2ac156eb1d$exports.Buf16 = Array;
        $6581cb2ac156eb1d$exports.Buf32 = Array;
        $6581cb2ac156eb1d$exports.assign($6581cb2ac156eb1d$exports, $6581cb2ac156eb1d$var$fnUntyped);
    }
};
$6581cb2ac156eb1d$exports.setTyped($6581cb2ac156eb1d$var$TYPED_OK);


var $72a59eef0464adf4$require$assign = $6581cb2ac156eb1d$exports.assign;
var $3129edcfdd3d4a46$exports = {};

$parcel$export($3129edcfdd3d4a46$exports, "Deflate", function () { return $3129edcfdd3d4a46$export$ae157b6234afe138; }, function (v) { return $3129edcfdd3d4a46$export$ae157b6234afe138 = v; });
$parcel$export($3129edcfdd3d4a46$exports, "deflate", function () { return $3129edcfdd3d4a46$export$2316623ecd1285ab; }, function (v) { return $3129edcfdd3d4a46$export$2316623ecd1285ab = v; });
$parcel$export($3129edcfdd3d4a46$exports, "deflateRaw", function () { return $3129edcfdd3d4a46$export$e95d6a8f69fb340a; }, function (v) { return $3129edcfdd3d4a46$export$e95d6a8f69fb340a = v; });
$parcel$export($3129edcfdd3d4a46$exports, "gzip", function () { return $3129edcfdd3d4a46$export$69f0ea7cf3a331a8; }, function (v) { return $3129edcfdd3d4a46$export$69f0ea7cf3a331a8 = v; });
var $3129edcfdd3d4a46$export$ae157b6234afe138;
var $3129edcfdd3d4a46$export$2316623ecd1285ab;
var $3129edcfdd3d4a46$export$e95d6a8f69fb340a;
var $3129edcfdd3d4a46$export$69f0ea7cf3a331a8;
'use strict';
var $288dd007fe91662c$export$72b35d618fb8ad9b;
var $288dd007fe91662c$export$a65c7b2bde87cb70;
var $288dd007fe91662c$export$8f99f0e30bc7dd53;
var $288dd007fe91662c$export$e78fab288549509;
var $288dd007fe91662c$export$1cd50f7b2515ba19;
var $288dd007fe91662c$export$2316623ecd1285ab;
var $288dd007fe91662c$export$599854fa319a815f;
var $288dd007fe91662c$export$f55e0b3ab66b5d46;
var $288dd007fe91662c$export$12b6e1fcadea22f9;
'use strict';

var $406afe4eb5eefb4f$export$4e4fc0157c3cd14d;
var $406afe4eb5eefb4f$export$8959e34c5e020172;
var $406afe4eb5eefb4f$export$44f15b52eef0cf41;
var $406afe4eb5eefb4f$export$b3cbce147289408f;
var $406afe4eb5eefb4f$export$bfb360e02ee9b403;
'use strict';

/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $406afe4eb5eefb4f$var$Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $406afe4eb5eefb4f$var$Z_BINARY = 0;
var $406afe4eb5eefb4f$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $406afe4eb5eefb4f$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $406afe4eb5eefb4f$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $406afe4eb5eefb4f$var$STORED_BLOCK = 0;
var $406afe4eb5eefb4f$var$STATIC_TREES = 1;
var $406afe4eb5eefb4f$var$DYN_TREES = 2;
/* The three kinds of block type */ var $406afe4eb5eefb4f$var$MIN_MATCH = 3;
var $406afe4eb5eefb4f$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $406afe4eb5eefb4f$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $406afe4eb5eefb4f$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $406afe4eb5eefb4f$var$L_CODES = $406afe4eb5eefb4f$var$LITERALS + 1 + $406afe4eb5eefb4f$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $406afe4eb5eefb4f$var$D_CODES = 30;
/* number of distance codes */ var $406afe4eb5eefb4f$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $406afe4eb5eefb4f$var$HEAP_SIZE = 2 * $406afe4eb5eefb4f$var$L_CODES + 1;
/* maximum heap size */ var $406afe4eb5eefb4f$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $406afe4eb5eefb4f$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $406afe4eb5eefb4f$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $406afe4eb5eefb4f$var$END_BLOCK = 256;
/* end of block literal code */ var $406afe4eb5eefb4f$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $406afe4eb5eefb4f$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $406afe4eb5eefb4f$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $406afe4eb5eefb4f$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $406afe4eb5eefb4f$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $406afe4eb5eefb4f$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $406afe4eb5eefb4f$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $406afe4eb5eefb4f$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $406afe4eb5eefb4f$var$static_ltree = new Array(($406afe4eb5eefb4f$var$L_CODES + 2) * 2);
$406afe4eb5eefb4f$var$zero($406afe4eb5eefb4f$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $406afe4eb5eefb4f$var$static_dtree = new Array($406afe4eb5eefb4f$var$D_CODES * 2);
$406afe4eb5eefb4f$var$zero($406afe4eb5eefb4f$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $406afe4eb5eefb4f$var$_dist_code = new Array($406afe4eb5eefb4f$var$DIST_CODE_LEN);
$406afe4eb5eefb4f$var$zero($406afe4eb5eefb4f$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $406afe4eb5eefb4f$var$_length_code = new Array($406afe4eb5eefb4f$var$MAX_MATCH - $406afe4eb5eefb4f$var$MIN_MATCH + 1);
$406afe4eb5eefb4f$var$zero($406afe4eb5eefb4f$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $406afe4eb5eefb4f$var$base_length = new Array($406afe4eb5eefb4f$var$LENGTH_CODES);
$406afe4eb5eefb4f$var$zero($406afe4eb5eefb4f$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $406afe4eb5eefb4f$var$base_dist = new Array($406afe4eb5eefb4f$var$D_CODES);
$406afe4eb5eefb4f$var$zero($406afe4eb5eefb4f$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $406afe4eb5eefb4f$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $406afe4eb5eefb4f$var$static_l_desc;
var $406afe4eb5eefb4f$var$static_d_desc;
var $406afe4eb5eefb4f$var$static_bl_desc;
function $406afe4eb5eefb4f$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $406afe4eb5eefb4f$var$d_code(dist) {
    return dist < 256 ? $406afe4eb5eefb4f$var$_dist_code[dist] : $406afe4eb5eefb4f$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $406afe4eb5eefb4f$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $406afe4eb5eefb4f$var$send_bits(s, value, length) {
    if (s.bi_valid > $406afe4eb5eefb4f$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $406afe4eb5eefb4f$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $406afe4eb5eefb4f$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $406afe4eb5eefb4f$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $406afe4eb5eefb4f$var$send_code(s, c, tree) {
    $406afe4eb5eefb4f$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $406afe4eb5eefb4f$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $406afe4eb5eefb4f$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $406afe4eb5eefb4f$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $406afe4eb5eefb4f$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $406afe4eb5eefb4f$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $406afe4eb5eefb4f$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $406afe4eb5eefb4f$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($406afe4eb5eefb4f$var$MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $406afe4eb5eefb4f$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $406afe4eb5eefb4f$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $406afe4eb5eefb4f$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($406afe4eb5eefb4f$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $406afe4eb5eefb4f$var$LENGTH_CODES - 1; code++){
        $406afe4eb5eefb4f$var$base_length[code] = length;
        for(n = 0; n < 1 << $406afe4eb5eefb4f$var$extra_lbits[code]; n++)$406afe4eb5eefb4f$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $406afe4eb5eefb4f$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $406afe4eb5eefb4f$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $406afe4eb5eefb4f$var$extra_dbits[code]; n++)$406afe4eb5eefb4f$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $406afe4eb5eefb4f$var$D_CODES; code++){
        $406afe4eb5eefb4f$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $406afe4eb5eefb4f$var$extra_dbits[code] - 7; n++)$406afe4eb5eefb4f$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $406afe4eb5eefb4f$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $406afe4eb5eefb4f$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $406afe4eb5eefb4f$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $406afe4eb5eefb4f$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $406afe4eb5eefb4f$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $406afe4eb5eefb4f$var$gen_codes($406afe4eb5eefb4f$var$static_ltree, $406afe4eb5eefb4f$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $406afe4eb5eefb4f$var$D_CODES; n++){
        $406afe4eb5eefb4f$var$static_dtree[n * 2 + 1] = 5;
        $406afe4eb5eefb4f$var$static_dtree[n * 2] = $406afe4eb5eefb4f$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $406afe4eb5eefb4f$var$static_l_desc = new $406afe4eb5eefb4f$var$StaticTreeDesc($406afe4eb5eefb4f$var$static_ltree, $406afe4eb5eefb4f$var$extra_lbits, $406afe4eb5eefb4f$var$LITERALS + 1, $406afe4eb5eefb4f$var$L_CODES, $406afe4eb5eefb4f$var$MAX_BITS);
    $406afe4eb5eefb4f$var$static_d_desc = new $406afe4eb5eefb4f$var$StaticTreeDesc($406afe4eb5eefb4f$var$static_dtree, $406afe4eb5eefb4f$var$extra_dbits, 0, $406afe4eb5eefb4f$var$D_CODES, $406afe4eb5eefb4f$var$MAX_BITS);
    $406afe4eb5eefb4f$var$static_bl_desc = new $406afe4eb5eefb4f$var$StaticTreeDesc(new Array(0), $406afe4eb5eefb4f$var$extra_blbits, 0, $406afe4eb5eefb4f$var$BL_CODES, $406afe4eb5eefb4f$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $406afe4eb5eefb4f$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $406afe4eb5eefb4f$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $406afe4eb5eefb4f$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $406afe4eb5eefb4f$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$406afe4eb5eefb4f$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $406afe4eb5eefb4f$var$bi_windup(s) {
    if (s.bi_valid > 8) $406afe4eb5eefb4f$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $406afe4eb5eefb4f$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $406afe4eb5eefb4f$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $406afe4eb5eefb4f$var$put_short(s, len);
        $406afe4eb5eefb4f$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $6581cb2ac156eb1d$exports.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $406afe4eb5eefb4f$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $406afe4eb5eefb4f$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $406afe4eb5eefb4f$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($406afe4eb5eefb4f$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $406afe4eb5eefb4f$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $406afe4eb5eefb4f$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $406afe4eb5eefb4f$var$_length_code[lc];
            $406afe4eb5eefb4f$var$send_code(s, code + $406afe4eb5eefb4f$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $406afe4eb5eefb4f$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $406afe4eb5eefb4f$var$base_length[code];
                $406afe4eb5eefb4f$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $406afe4eb5eefb4f$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $406afe4eb5eefb4f$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $406afe4eb5eefb4f$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $406afe4eb5eefb4f$var$base_dist[code];
                $406afe4eb5eefb4f$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $406afe4eb5eefb4f$var$send_code(s, $406afe4eb5eefb4f$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $406afe4eb5eefb4f$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $406afe4eb5eefb4f$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$406afe4eb5eefb4f$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $406afe4eb5eefb4f$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $406afe4eb5eefb4f$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $406afe4eb5eefb4f$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $406afe4eb5eefb4f$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $406afe4eb5eefb4f$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$406afe4eb5eefb4f$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$406afe4eb5eefb4f$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$406afe4eb5eefb4f$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $406afe4eb5eefb4f$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $406afe4eb5eefb4f$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $406afe4eb5eefb4f$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $406afe4eb5eefb4f$var$send_code(s, $406afe4eb5eefb4f$var$REP_3_6, s.bl_tree);
            $406afe4eb5eefb4f$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $406afe4eb5eefb4f$var$send_code(s, $406afe4eb5eefb4f$var$REPZ_3_10, s.bl_tree);
            $406afe4eb5eefb4f$var$send_bits(s, count - 3, 3);
        } else {
            $406afe4eb5eefb4f$var$send_code(s, $406afe4eb5eefb4f$var$REPZ_11_138, s.bl_tree);
            $406afe4eb5eefb4f$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $406afe4eb5eefb4f$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $406afe4eb5eefb4f$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $406afe4eb5eefb4f$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $406afe4eb5eefb4f$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $406afe4eb5eefb4f$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$406afe4eb5eefb4f$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $406afe4eb5eefb4f$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $406afe4eb5eefb4f$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $406afe4eb5eefb4f$var$send_bits(s, dcodes - 1, 5);
    $406afe4eb5eefb4f$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $406afe4eb5eefb4f$var$send_bits(s, s.bl_tree[$406afe4eb5eefb4f$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $406afe4eb5eefb4f$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $406afe4eb5eefb4f$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $406afe4eb5eefb4f$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $406afe4eb5eefb4f$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $406afe4eb5eefb4f$var$Z_TEXT;
    for(n = 32; n < $406afe4eb5eefb4f$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $406afe4eb5eefb4f$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $406afe4eb5eefb4f$var$Z_BINARY;
}
var $406afe4eb5eefb4f$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $406afe4eb5eefb4f$var$_tr_init(s) {
    if (!$406afe4eb5eefb4f$var$static_init_done) {
        $406afe4eb5eefb4f$var$tr_static_init();
        $406afe4eb5eefb4f$var$static_init_done = true;
    }
    s.l_desc = new $406afe4eb5eefb4f$var$TreeDesc(s.dyn_ltree, $406afe4eb5eefb4f$var$static_l_desc);
    s.d_desc = new $406afe4eb5eefb4f$var$TreeDesc(s.dyn_dtree, $406afe4eb5eefb4f$var$static_d_desc);
    s.bl_desc = new $406afe4eb5eefb4f$var$TreeDesc(s.bl_tree, $406afe4eb5eefb4f$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $406afe4eb5eefb4f$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $406afe4eb5eefb4f$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $406afe4eb5eefb4f$var$send_bits(s, ($406afe4eb5eefb4f$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $406afe4eb5eefb4f$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $406afe4eb5eefb4f$var$_tr_align(s) {
    $406afe4eb5eefb4f$var$send_bits(s, $406afe4eb5eefb4f$var$STATIC_TREES << 1, 3);
    $406afe4eb5eefb4f$var$send_code(s, $406afe4eb5eefb4f$var$END_BLOCK, $406afe4eb5eefb4f$var$static_ltree);
    $406afe4eb5eefb4f$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $406afe4eb5eefb4f$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $406afe4eb5eefb4f$var$Z_UNKNOWN) s.strm.data_type = $406afe4eb5eefb4f$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $406afe4eb5eefb4f$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $406afe4eb5eefb4f$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $406afe4eb5eefb4f$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $406afe4eb5eefb4f$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $406afe4eb5eefb4f$var$Z_FIXED || static_lenb === opt_lenb) {
        $406afe4eb5eefb4f$var$send_bits(s, ($406afe4eb5eefb4f$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $406afe4eb5eefb4f$var$compress_block(s, $406afe4eb5eefb4f$var$static_ltree, $406afe4eb5eefb4f$var$static_dtree);
    } else {
        $406afe4eb5eefb4f$var$send_bits(s, ($406afe4eb5eefb4f$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $406afe4eb5eefb4f$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $406afe4eb5eefb4f$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $406afe4eb5eefb4f$var$init_block(s);
    if (last) $406afe4eb5eefb4f$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $406afe4eb5eefb4f$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($406afe4eb5eefb4f$var$_length_code[lc] + $406afe4eb5eefb4f$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$406afe4eb5eefb4f$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$406afe4eb5eefb4f$export$4e4fc0157c3cd14d = $406afe4eb5eefb4f$var$_tr_init;
$406afe4eb5eefb4f$export$8959e34c5e020172 = $406afe4eb5eefb4f$var$_tr_stored_block;
$406afe4eb5eefb4f$export$44f15b52eef0cf41 = $406afe4eb5eefb4f$var$_tr_flush_block;
$406afe4eb5eefb4f$export$b3cbce147289408f = $406afe4eb5eefb4f$var$_tr_tally;
$406afe4eb5eefb4f$export$bfb360e02ee9b403 = $406afe4eb5eefb4f$var$_tr_align;


var $4ab6edb8f766028d$exports = {};
'use strict';
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $4ab6edb8f766028d$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
$4ab6edb8f766028d$exports = $4ab6edb8f766028d$var$adler32;


var $71bb0922e613088e$exports = {};
'use strict';
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $71bb0922e613088e$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $71bb0922e613088e$var$crcTable = $71bb0922e613088e$var$makeTable();
function $71bb0922e613088e$var$crc32(crc, buf, len, pos) {
    var t = $71bb0922e613088e$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
$71bb0922e613088e$exports = $71bb0922e613088e$var$crc32;


var $ce5320513c074621$exports = {};
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
$ce5320513c074621$exports = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};


/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $288dd007fe91662c$var$Z_NO_FLUSH = 0;
var $288dd007fe91662c$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $288dd007fe91662c$var$Z_FULL_FLUSH = 3;
var $288dd007fe91662c$var$Z_FINISH = 4;
var $288dd007fe91662c$var$Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $288dd007fe91662c$var$Z_OK = 0;
var $288dd007fe91662c$var$Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $288dd007fe91662c$var$Z_STREAM_ERROR = -2;
var $288dd007fe91662c$var$Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var $288dd007fe91662c$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $288dd007fe91662c$var$Z_DEFAULT_COMPRESSION = -1;
var $288dd007fe91662c$var$Z_FILTERED = 1;
var $288dd007fe91662c$var$Z_HUFFMAN_ONLY = 2;
var $288dd007fe91662c$var$Z_RLE = 3;
var $288dd007fe91662c$var$Z_FIXED = 4;
var $288dd007fe91662c$var$Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $288dd007fe91662c$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $288dd007fe91662c$var$Z_DEFLATED = 8;
/*============================================================================*/ var $288dd007fe91662c$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $288dd007fe91662c$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $288dd007fe91662c$var$DEF_MEM_LEVEL = 8;
var $288dd007fe91662c$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $288dd007fe91662c$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $288dd007fe91662c$var$L_CODES = $288dd007fe91662c$var$LITERALS + 1 + $288dd007fe91662c$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $288dd007fe91662c$var$D_CODES = 30;
/* number of distance codes */ var $288dd007fe91662c$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $288dd007fe91662c$var$HEAP_SIZE = 2 * $288dd007fe91662c$var$L_CODES + 1;
/* maximum heap size */ var $288dd007fe91662c$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $288dd007fe91662c$var$MIN_MATCH = 3;
var $288dd007fe91662c$var$MAX_MATCH = 258;
var $288dd007fe91662c$var$MIN_LOOKAHEAD = $288dd007fe91662c$var$MAX_MATCH + $288dd007fe91662c$var$MIN_MATCH + 1;
var $288dd007fe91662c$var$PRESET_DICT = 0x20;
var $288dd007fe91662c$var$INIT_STATE = 42;
var $288dd007fe91662c$var$EXTRA_STATE = 69;
var $288dd007fe91662c$var$NAME_STATE = 73;
var $288dd007fe91662c$var$COMMENT_STATE = 91;
var $288dd007fe91662c$var$HCRC_STATE = 103;
var $288dd007fe91662c$var$BUSY_STATE = 113;
var $288dd007fe91662c$var$FINISH_STATE = 666;
var $288dd007fe91662c$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $288dd007fe91662c$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $288dd007fe91662c$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $288dd007fe91662c$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $288dd007fe91662c$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $288dd007fe91662c$var$err(strm, errorCode) {
    strm.msg = $ce5320513c074621$exports[errorCode];
    return errorCode;
}
function $288dd007fe91662c$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $288dd007fe91662c$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $288dd007fe91662c$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $6581cb2ac156eb1d$exports.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $288dd007fe91662c$var$flush_block_only(s, last) {
    $406afe4eb5eefb4f$export$44f15b52eef0cf41(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $288dd007fe91662c$var$flush_pending(s.strm);
}
function $288dd007fe91662c$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $288dd007fe91662c$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $288dd007fe91662c$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $6581cb2ac156eb1d$exports.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $4ab6edb8f766028d$exports(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $71bb0922e613088e$exports(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $288dd007fe91662c$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $288dd007fe91662c$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $288dd007fe91662c$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $288dd007fe91662c$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $288dd007fe91662c$var$MAX_MATCH - (strend - scan);
        scan = strend - $288dd007fe91662c$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $288dd007fe91662c$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $288dd007fe91662c$var$MIN_LOOKAHEAD)) {
            $6581cb2ac156eb1d$exports.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $288dd007fe91662c$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $288dd007fe91662c$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $288dd007fe91662c$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $288dd007fe91662c$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $288dd007fe91662c$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $288dd007fe91662c$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $288dd007fe91662c$var$fill_window(s);
            if (s.lookahead === 0 && flush === $288dd007fe91662c$var$Z_NO_FLUSH) return $288dd007fe91662c$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $288dd007fe91662c$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $288dd007fe91662c$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $288dd007fe91662c$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $288dd007fe91662c$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $288dd007fe91662c$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $288dd007fe91662c$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $288dd007fe91662c$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $288dd007fe91662c$var$BS_FINISH_STARTED;
        /***/ return $288dd007fe91662c$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $288dd007fe91662c$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $288dd007fe91662c$var$BS_NEED_MORE;
    /***/ }
    return $288dd007fe91662c$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $288dd007fe91662c$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $288dd007fe91662c$var$MIN_LOOKAHEAD) {
            $288dd007fe91662c$var$fill_window(s);
            if (s.lookahead < $288dd007fe91662c$var$MIN_LOOKAHEAD && flush === $288dd007fe91662c$var$Z_NO_FLUSH) return $288dd007fe91662c$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $288dd007fe91662c$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $288dd007fe91662c$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $288dd007fe91662c$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $288dd007fe91662c$var$longest_match(s, hash_head);
        if (s.match_length >= $288dd007fe91662c$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $406afe4eb5eefb4f$export$b3cbce147289408f(s, s.strstart - s.match_start, s.match_length - $288dd007fe91662c$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $288dd007fe91662c$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $288dd007fe91662c$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $406afe4eb5eefb4f$export$b3cbce147289408f(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $288dd007fe91662c$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $288dd007fe91662c$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $288dd007fe91662c$var$MIN_MATCH - 1 ? s.strstart : $288dd007fe91662c$var$MIN_MATCH - 1;
    if (flush === $288dd007fe91662c$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $288dd007fe91662c$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $288dd007fe91662c$var$BS_FINISH_STARTED;
        /***/ return $288dd007fe91662c$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $288dd007fe91662c$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $288dd007fe91662c$var$BS_NEED_MORE;
    /***/ }
    return $288dd007fe91662c$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $288dd007fe91662c$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $288dd007fe91662c$var$MIN_LOOKAHEAD) {
            $288dd007fe91662c$var$fill_window(s);
            if (s.lookahead < $288dd007fe91662c$var$MIN_LOOKAHEAD && flush === $288dd007fe91662c$var$Z_NO_FLUSH) return $288dd007fe91662c$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $288dd007fe91662c$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $288dd007fe91662c$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $288dd007fe91662c$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $288dd007fe91662c$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $288dd007fe91662c$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $288dd007fe91662c$var$Z_FILTERED || s.match_length === $288dd007fe91662c$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $288dd007fe91662c$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $288dd007fe91662c$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $288dd007fe91662c$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $406afe4eb5eefb4f$export$b3cbce147289408f(s, s.strstart - 1 - s.prev_match, s.prev_length - $288dd007fe91662c$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $288dd007fe91662c$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $288dd007fe91662c$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $288dd007fe91662c$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $288dd007fe91662c$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $406afe4eb5eefb4f$export$b3cbce147289408f(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $288dd007fe91662c$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $288dd007fe91662c$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $406afe4eb5eefb4f$export$b3cbce147289408f(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $288dd007fe91662c$var$MIN_MATCH - 1 ? s.strstart : $288dd007fe91662c$var$MIN_MATCH - 1;
    if (flush === $288dd007fe91662c$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $288dd007fe91662c$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $288dd007fe91662c$var$BS_FINISH_STARTED;
        /***/ return $288dd007fe91662c$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $288dd007fe91662c$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $288dd007fe91662c$var$BS_NEED_MORE;
    /***/ }
    return $288dd007fe91662c$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $288dd007fe91662c$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $288dd007fe91662c$var$MAX_MATCH) {
            $288dd007fe91662c$var$fill_window(s);
            if (s.lookahead <= $288dd007fe91662c$var$MAX_MATCH && flush === $288dd007fe91662c$var$Z_NO_FLUSH) return $288dd007fe91662c$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $288dd007fe91662c$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $288dd007fe91662c$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $288dd007fe91662c$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $288dd007fe91662c$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $406afe4eb5eefb4f$export$b3cbce147289408f(s, 1, s.match_length - $288dd007fe91662c$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $406afe4eb5eefb4f$export$b3cbce147289408f(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $288dd007fe91662c$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $288dd007fe91662c$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $288dd007fe91662c$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $288dd007fe91662c$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $288dd007fe91662c$var$BS_FINISH_STARTED;
        /***/ return $288dd007fe91662c$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $288dd007fe91662c$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $288dd007fe91662c$var$BS_NEED_MORE;
    /***/ }
    return $288dd007fe91662c$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $288dd007fe91662c$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $288dd007fe91662c$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $288dd007fe91662c$var$Z_NO_FLUSH) return $288dd007fe91662c$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $406afe4eb5eefb4f$export$b3cbce147289408f(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $288dd007fe91662c$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $288dd007fe91662c$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $288dd007fe91662c$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $288dd007fe91662c$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $288dd007fe91662c$var$BS_FINISH_STARTED;
        /***/ return $288dd007fe91662c$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $288dd007fe91662c$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $288dd007fe91662c$var$BS_NEED_MORE;
    /***/ }
    return $288dd007fe91662c$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $288dd007fe91662c$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $288dd007fe91662c$var$configuration_table;
$288dd007fe91662c$var$configuration_table = [
    /*      good lazy nice chain */ new $288dd007fe91662c$var$Config(0, 0, 0, 0, $288dd007fe91662c$var$deflate_stored),
    /* 0 store only */ new $288dd007fe91662c$var$Config(4, 4, 8, 4, $288dd007fe91662c$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $288dd007fe91662c$var$Config(4, 5, 16, 8, $288dd007fe91662c$var$deflate_fast),
    /* 2 */ new $288dd007fe91662c$var$Config(4, 6, 32, 32, $288dd007fe91662c$var$deflate_fast),
    /* 3 */ new $288dd007fe91662c$var$Config(4, 4, 16, 16, $288dd007fe91662c$var$deflate_slow),
    /* 4 lazy matches */ new $288dd007fe91662c$var$Config(8, 16, 32, 32, $288dd007fe91662c$var$deflate_slow),
    /* 5 */ new $288dd007fe91662c$var$Config(8, 16, 128, 128, $288dd007fe91662c$var$deflate_slow),
    /* 6 */ new $288dd007fe91662c$var$Config(8, 32, 128, 256, $288dd007fe91662c$var$deflate_slow),
    /* 7 */ new $288dd007fe91662c$var$Config(32, 128, 258, 1024, $288dd007fe91662c$var$deflate_slow),
    /* 8 */ new $288dd007fe91662c$var$Config(32, 258, 258, 4096, $288dd007fe91662c$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $288dd007fe91662c$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $288dd007fe91662c$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $288dd007fe91662c$var$configuration_table[s.level].max_lazy;
    s.good_match = $288dd007fe91662c$var$configuration_table[s.level].good_length;
    s.nice_match = $288dd007fe91662c$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $288dd007fe91662c$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $288dd007fe91662c$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $288dd007fe91662c$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $288dd007fe91662c$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $6581cb2ac156eb1d$exports.Buf16($288dd007fe91662c$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $6581cb2ac156eb1d$exports.Buf16((2 * $288dd007fe91662c$var$D_CODES + 1) * 2);
    this.bl_tree = new $6581cb2ac156eb1d$exports.Buf16((2 * $288dd007fe91662c$var$BL_CODES + 1) * 2);
    $288dd007fe91662c$var$zero(this.dyn_ltree);
    $288dd007fe91662c$var$zero(this.dyn_dtree);
    $288dd007fe91662c$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $6581cb2ac156eb1d$exports.Buf16($288dd007fe91662c$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $6581cb2ac156eb1d$exports.Buf16(2 * $288dd007fe91662c$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $288dd007fe91662c$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $6581cb2ac156eb1d$exports.Buf16(2 * $288dd007fe91662c$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $288dd007fe91662c$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $288dd007fe91662c$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $288dd007fe91662c$var$err(strm, $288dd007fe91662c$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $288dd007fe91662c$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $288dd007fe91662c$var$INIT_STATE : $288dd007fe91662c$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $288dd007fe91662c$var$Z_NO_FLUSH;
    $406afe4eb5eefb4f$export$4e4fc0157c3cd14d(s);
    return $288dd007fe91662c$var$Z_OK;
}
function $288dd007fe91662c$var$deflateReset(strm) {
    var ret = $288dd007fe91662c$var$deflateResetKeep(strm);
    if (ret === $288dd007fe91662c$var$Z_OK) $288dd007fe91662c$var$lm_init(strm.state);
    return ret;
}
function $288dd007fe91662c$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $288dd007fe91662c$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $288dd007fe91662c$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $288dd007fe91662c$var$Z_OK;
}
function $288dd007fe91662c$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $288dd007fe91662c$var$Z_STREAM_ERROR;
    var wrap = 1;
    if (level === $288dd007fe91662c$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $288dd007fe91662c$var$MAX_MEM_LEVEL || method !== $288dd007fe91662c$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $288dd007fe91662c$var$Z_FIXED) return $288dd007fe91662c$var$err(strm, $288dd007fe91662c$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $288dd007fe91662c$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $288dd007fe91662c$var$MIN_MATCH - 1) / $288dd007fe91662c$var$MIN_MATCH);
    s.window = new $6581cb2ac156eb1d$exports.Buf8(s.w_size * 2);
    s.head = new $6581cb2ac156eb1d$exports.Buf16(s.hash_size);
    s.prev = new $6581cb2ac156eb1d$exports.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $6581cb2ac156eb1d$exports.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $288dd007fe91662c$var$deflateReset(strm);
}
function $288dd007fe91662c$var$deflateInit(strm, level) {
    return $288dd007fe91662c$var$deflateInit2(strm, level, $288dd007fe91662c$var$Z_DEFLATED, $288dd007fe91662c$var$MAX_WBITS, $288dd007fe91662c$var$DEF_MEM_LEVEL, $288dd007fe91662c$var$Z_DEFAULT_STRATEGY);
}
function $288dd007fe91662c$var$deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $288dd007fe91662c$var$Z_BLOCK || flush < 0) return strm ? $288dd007fe91662c$var$err(strm, $288dd007fe91662c$var$Z_STREAM_ERROR) : $288dd007fe91662c$var$Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $288dd007fe91662c$var$FINISH_STATE && flush !== $288dd007fe91662c$var$Z_FINISH) return $288dd007fe91662c$var$err(strm, strm.avail_out === 0 ? $288dd007fe91662c$var$Z_BUF_ERROR : $288dd007fe91662c$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $288dd007fe91662c$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $288dd007fe91662c$var$put_byte(s, 31);
            $288dd007fe91662c$var$put_byte(s, 139);
            $288dd007fe91662c$var$put_byte(s, 8);
            if (!s.gzhead) {
                $288dd007fe91662c$var$put_byte(s, 0);
                $288dd007fe91662c$var$put_byte(s, 0);
                $288dd007fe91662c$var$put_byte(s, 0);
                $288dd007fe91662c$var$put_byte(s, 0);
                $288dd007fe91662c$var$put_byte(s, 0);
                $288dd007fe91662c$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $288dd007fe91662c$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $288dd007fe91662c$var$put_byte(s, $288dd007fe91662c$var$OS_CODE);
                s.status = $288dd007fe91662c$var$BUSY_STATE;
            } else {
                $288dd007fe91662c$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $288dd007fe91662c$var$put_byte(s, s.gzhead.time & 0xff);
                $288dd007fe91662c$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $288dd007fe91662c$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $288dd007fe91662c$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $288dd007fe91662c$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $288dd007fe91662c$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $288dd007fe91662c$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $288dd007fe91662c$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $288dd007fe91662c$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $71bb0922e613088e$exports(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $288dd007fe91662c$var$EXTRA_STATE;
            }
        } else {
            var header = $288dd007fe91662c$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $288dd007fe91662c$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $288dd007fe91662c$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $288dd007fe91662c$var$BUSY_STATE;
            $288dd007fe91662c$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $288dd007fe91662c$var$putShortMSB(s, strm.adler >>> 16);
                $288dd007fe91662c$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $288dd007fe91662c$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $71bb0922e613088e$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $288dd007fe91662c$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $288dd007fe91662c$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $71bb0922e613088e$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $288dd007fe91662c$var$NAME_STATE;
            }
        } else s.status = $288dd007fe91662c$var$NAME_STATE;
    }
    if (s.status === $288dd007fe91662c$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $71bb0922e613088e$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $288dd007fe91662c$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $288dd007fe91662c$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $71bb0922e613088e$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $288dd007fe91662c$var$COMMENT_STATE;
            }
        } else s.status = $288dd007fe91662c$var$COMMENT_STATE;
    }
    if (s.status === $288dd007fe91662c$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $71bb0922e613088e$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $288dd007fe91662c$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $288dd007fe91662c$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $71bb0922e613088e$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $288dd007fe91662c$var$HCRC_STATE;
        } else s.status = $288dd007fe91662c$var$HCRC_STATE;
    }
    if (s.status === $288dd007fe91662c$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $288dd007fe91662c$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $288dd007fe91662c$var$put_byte(s, strm.adler & 0xff);
                $288dd007fe91662c$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $288dd007fe91662c$var$BUSY_STATE;
            }
        } else s.status = $288dd007fe91662c$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $288dd007fe91662c$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $288dd007fe91662c$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $288dd007fe91662c$var$rank(flush) <= $288dd007fe91662c$var$rank(old_flush) && flush !== $288dd007fe91662c$var$Z_FINISH) return $288dd007fe91662c$var$err(strm, $288dd007fe91662c$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $288dd007fe91662c$var$FINISH_STATE && strm.avail_in !== 0) return $288dd007fe91662c$var$err(strm, $288dd007fe91662c$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $288dd007fe91662c$var$Z_NO_FLUSH && s.status !== $288dd007fe91662c$var$FINISH_STATE) {
        var bstate = s.strategy === $288dd007fe91662c$var$Z_HUFFMAN_ONLY ? $288dd007fe91662c$var$deflate_huff(s, flush) : s.strategy === $288dd007fe91662c$var$Z_RLE ? $288dd007fe91662c$var$deflate_rle(s, flush) : $288dd007fe91662c$var$configuration_table[s.level].func(s, flush);
        if (bstate === $288dd007fe91662c$var$BS_FINISH_STARTED || bstate === $288dd007fe91662c$var$BS_FINISH_DONE) s.status = $288dd007fe91662c$var$FINISH_STATE;
        if (bstate === $288dd007fe91662c$var$BS_NEED_MORE || bstate === $288dd007fe91662c$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $288dd007fe91662c$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $288dd007fe91662c$var$BS_BLOCK_DONE) {
            if (flush === $288dd007fe91662c$var$Z_PARTIAL_FLUSH) $406afe4eb5eefb4f$export$bfb360e02ee9b403(s);
            else if (flush !== $288dd007fe91662c$var$Z_BLOCK) {
                $406afe4eb5eefb4f$export$8959e34c5e020172(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $288dd007fe91662c$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $288dd007fe91662c$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $288dd007fe91662c$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $288dd007fe91662c$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $288dd007fe91662c$var$Z_FINISH) return $288dd007fe91662c$var$Z_OK;
    if (s.wrap <= 0) return $288dd007fe91662c$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $288dd007fe91662c$var$put_byte(s, strm.adler & 0xff);
        $288dd007fe91662c$var$put_byte(s, strm.adler >> 8 & 0xff);
        $288dd007fe91662c$var$put_byte(s, strm.adler >> 16 & 0xff);
        $288dd007fe91662c$var$put_byte(s, strm.adler >> 24 & 0xff);
        $288dd007fe91662c$var$put_byte(s, strm.total_in & 0xff);
        $288dd007fe91662c$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $288dd007fe91662c$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $288dd007fe91662c$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $288dd007fe91662c$var$putShortMSB(s, strm.adler >>> 16);
        $288dd007fe91662c$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $288dd007fe91662c$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $288dd007fe91662c$var$Z_OK : $288dd007fe91662c$var$Z_STREAM_END;
}
function $288dd007fe91662c$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $288dd007fe91662c$var$Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== $288dd007fe91662c$var$INIT_STATE && status !== $288dd007fe91662c$var$EXTRA_STATE && status !== $288dd007fe91662c$var$NAME_STATE && status !== $288dd007fe91662c$var$COMMENT_STATE && status !== $288dd007fe91662c$var$HCRC_STATE && status !== $288dd007fe91662c$var$BUSY_STATE && status !== $288dd007fe91662c$var$FINISH_STATE) return $288dd007fe91662c$var$err(strm, $288dd007fe91662c$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $288dd007fe91662c$var$BUSY_STATE ? $288dd007fe91662c$var$err(strm, $288dd007fe91662c$var$Z_DATA_ERROR) : $288dd007fe91662c$var$Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $288dd007fe91662c$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $288dd007fe91662c$var$Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $288dd007fe91662c$var$INIT_STATE || s.lookahead) return $288dd007fe91662c$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $4ab6edb8f766028d$exports(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $288dd007fe91662c$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $6581cb2ac156eb1d$exports.Buf8(s.w_size);
        $6581cb2ac156eb1d$exports.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $288dd007fe91662c$var$fill_window(s);
    while(s.lookahead >= $288dd007fe91662c$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($288dd007fe91662c$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $288dd007fe91662c$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $288dd007fe91662c$var$MIN_MATCH - 1;
        $288dd007fe91662c$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $288dd007fe91662c$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $288dd007fe91662c$var$Z_OK;
}
$288dd007fe91662c$export$72b35d618fb8ad9b = $288dd007fe91662c$var$deflateInit;
$288dd007fe91662c$export$a65c7b2bde87cb70 = $288dd007fe91662c$var$deflateInit2;
$288dd007fe91662c$export$8f99f0e30bc7dd53 = $288dd007fe91662c$var$deflateReset;
$288dd007fe91662c$export$e78fab288549509 = $288dd007fe91662c$var$deflateResetKeep;
$288dd007fe91662c$export$1cd50f7b2515ba19 = $288dd007fe91662c$var$deflateSetHeader;
$288dd007fe91662c$export$2316623ecd1285ab = $288dd007fe91662c$var$deflate;
$288dd007fe91662c$export$599854fa319a815f = $288dd007fe91662c$var$deflateEnd;
$288dd007fe91662c$export$f55e0b3ab66b5d46 = $288dd007fe91662c$var$deflateSetDictionary;
$288dd007fe91662c$export$12b6e1fcadea22f9 = 'pako deflate (from Nodeca project)'; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 



// String encode/decode helpers
// convert string to array (typed, when possible)
var $e7f6378a65b01df5$export$7a4c1b2f775b5a9f;
// Convert byte array to binary string
var $e7f6378a65b01df5$export$a751fe64af8a9a51;
// Convert binary string (typed, when possible)
var $e7f6378a65b01df5$export$1d1a7119601ff18c;
// convert array to string
var $e7f6378a65b01df5$export$49a50563f377746;
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $e7f6378a65b01df5$export$53dee3f58a714214;
'use strict';

// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var $e7f6378a65b01df5$var$STR_APPLY_OK = true;
var $e7f6378a65b01df5$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, [
        0
    ]);
} catch (__) {
    $e7f6378a65b01df5$var$STR_APPLY_OK = false;
}
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $e7f6378a65b01df5$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var $e7f6378a65b01df5$var$_utf8len = new $6581cb2ac156eb1d$exports.Buf8(256);
for(var $e7f6378a65b01df5$var$q = 0; $e7f6378a65b01df5$var$q < 256; $e7f6378a65b01df5$var$q++)$e7f6378a65b01df5$var$_utf8len[$e7f6378a65b01df5$var$q] = $e7f6378a65b01df5$var$q >= 252 ? 6 : $e7f6378a65b01df5$var$q >= 248 ? 5 : $e7f6378a65b01df5$var$q >= 240 ? 4 : $e7f6378a65b01df5$var$q >= 224 ? 3 : $e7f6378a65b01df5$var$q >= 192 ? 2 : 1;
$e7f6378a65b01df5$var$_utf8len[254] = $e7f6378a65b01df5$var$_utf8len[254] = 1; // Invalid sequence start
$e7f6378a65b01df5$export$7a4c1b2f775b5a9f = function(str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new $6581cb2ac156eb1d$exports.Buf8(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper (used in 2 places)
function $e7f6378a65b01df5$var$buf2binstring(buf, len) {
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $e7f6378a65b01df5$var$STR_APPLY_UIA_OK || !buf.subarray && $e7f6378a65b01df5$var$STR_APPLY_OK) return String.fromCharCode.apply(null, $6581cb2ac156eb1d$exports.shrinkBuf(buf, len));
    }
    var result = '';
    for(var i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
}
$e7f6378a65b01df5$export$a751fe64af8a9a51 = function(buf) {
    return $e7f6378a65b01df5$var$buf2binstring(buf, buf.length);
};
$e7f6378a65b01df5$export$1d1a7119601ff18c = function(str) {
    var buf = new $6581cb2ac156eb1d$exports.Buf8(str.length);
    for(var i = 0, len = buf.length; i < len; i++)buf[i] = str.charCodeAt(i);
    return buf;
};
$e7f6378a65b01df5$export$49a50563f377746 = function(buf, max) {
    var i, out, c, c_len;
    var len = max || buf.length;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        c_len = $e7f6378a65b01df5$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $e7f6378a65b01df5$var$buf2binstring(utf16buf, out);
};
$e7f6378a65b01df5$export$53dee3f58a714214 = function(buf, max) {
    var pos;
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $e7f6378a65b01df5$var$_utf8len[buf[pos]] > max ? pos : max;
};



var $279ed9d2862dbcca$exports = {};
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $279ed9d2862dbcca$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
$279ed9d2862dbcca$exports = $279ed9d2862dbcca$var$ZStream;


var $3129edcfdd3d4a46$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $3129edcfdd3d4a46$var$Z_NO_FLUSH = 0;
var $3129edcfdd3d4a46$var$Z_FINISH = 4;
var $3129edcfdd3d4a46$var$Z_OK = 0;
var $3129edcfdd3d4a46$var$Z_STREAM_END = 1;
var $3129edcfdd3d4a46$var$Z_SYNC_FLUSH = 2;
var $3129edcfdd3d4a46$var$Z_DEFAULT_COMPRESSION = -1;
var $3129edcfdd3d4a46$var$Z_DEFAULT_STRATEGY = 0;
var $3129edcfdd3d4a46$var$Z_DEFLATED = 8;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $3129edcfdd3d4a46$var$Deflate(options) {
    if (!(this instanceof $3129edcfdd3d4a46$var$Deflate)) return new $3129edcfdd3d4a46$var$Deflate(options);
    this.options = $6581cb2ac156eb1d$exports.assign({
        level: $3129edcfdd3d4a46$var$Z_DEFAULT_COMPRESSION,
        method: $3129edcfdd3d4a46$var$Z_DEFLATED,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $3129edcfdd3d4a46$var$Z_DEFAULT_STRATEGY,
        to: ''
    }, options || {});
    var opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $279ed9d2862dbcca$exports();
    this.strm.avail_out = 0;
    var status = $288dd007fe91662c$export$a65c7b2bde87cb70(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $3129edcfdd3d4a46$var$Z_OK) throw new Error($ce5320513c074621$exports[status]);
    if (opt.header) $288dd007fe91662c$export$1cd50f7b2515ba19(this.strm, opt.header);
    if (opt.dictionary) {
        var dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
        dict = $e7f6378a65b01df5$export$7a4c1b2f775b5a9f(opt.dictionary);
        else if ($3129edcfdd3d4a46$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $288dd007fe91662c$export$f55e0b3ab66b5d46(this.strm, dict);
        if (status !== $3129edcfdd3d4a46$var$Z_OK) throw new Error($ce5320513c074621$exports[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $3129edcfdd3d4a46$var$Deflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var status, _mode;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $3129edcfdd3d4a46$var$Z_FINISH : $3129edcfdd3d4a46$var$Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
    strm.input = $e7f6378a65b01df5$export$7a4c1b2f775b5a9f(data);
    else if ($3129edcfdd3d4a46$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $6581cb2ac156eb1d$exports.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $288dd007fe91662c$export$2316623ecd1285ab(strm, _mode); /* no bad return value */ 
        if (status !== $3129edcfdd3d4a46$var$Z_STREAM_END && status !== $3129edcfdd3d4a46$var$Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === $3129edcfdd3d4a46$var$Z_FINISH || _mode === $3129edcfdd3d4a46$var$Z_SYNC_FLUSH)) {
            if (this.options.to === 'string') this.onData($e7f6378a65b01df5$export$a751fe64af8a9a51($6581cb2ac156eb1d$exports.shrinkBuf(strm.output, strm.next_out)));
            else this.onData($6581cb2ac156eb1d$exports.shrinkBuf(strm.output, strm.next_out));
        }
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $3129edcfdd3d4a46$var$Z_STREAM_END);
    // Finalize on the last chunk.
    if (_mode === $3129edcfdd3d4a46$var$Z_FINISH) {
        status = $288dd007fe91662c$export$599854fa319a815f(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $3129edcfdd3d4a46$var$Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $3129edcfdd3d4a46$var$Z_SYNC_FLUSH) {
        this.onEnd($3129edcfdd3d4a46$var$Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $3129edcfdd3d4a46$var$Deflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $3129edcfdd3d4a46$var$Deflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $3129edcfdd3d4a46$var$Z_OK) {
        if (this.options.to === 'string') this.result = this.chunks.join('');
        else this.result = $6581cb2ac156eb1d$exports.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $3129edcfdd3d4a46$var$deflate(input, options) {
    var deflator = new $3129edcfdd3d4a46$var$Deflate(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $ce5320513c074621$exports[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $3129edcfdd3d4a46$var$deflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $3129edcfdd3d4a46$var$deflate(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $3129edcfdd3d4a46$var$gzip(input, options) {
    options = options || {};
    options.gzip = true;
    return $3129edcfdd3d4a46$var$deflate(input, options);
}
$3129edcfdd3d4a46$export$ae157b6234afe138 = $3129edcfdd3d4a46$var$Deflate;
$3129edcfdd3d4a46$export$2316623ecd1285ab = $3129edcfdd3d4a46$var$deflate;
$3129edcfdd3d4a46$export$e95d6a8f69fb340a = $3129edcfdd3d4a46$var$deflateRaw;
$3129edcfdd3d4a46$export$69f0ea7cf3a331a8 = $3129edcfdd3d4a46$var$gzip;


var $7804c104eb10a23c$exports = {};

$parcel$export($7804c104eb10a23c$exports, "Inflate", function () { return $7804c104eb10a23c$export$d1de70a877d6e43c; }, function (v) { return $7804c104eb10a23c$export$d1de70a877d6e43c = v; });
$parcel$export($7804c104eb10a23c$exports, "inflate", function () { return $7804c104eb10a23c$export$cae1ce83fe4a1782; }, function (v) { return $7804c104eb10a23c$export$cae1ce83fe4a1782 = v; });
$parcel$export($7804c104eb10a23c$exports, "inflateRaw", function () { return $7804c104eb10a23c$export$d0f0aa2d05c905c5; }, function (v) { return $7804c104eb10a23c$export$d0f0aa2d05c905c5 = v; });
$parcel$export($7804c104eb10a23c$exports, "ungzip", function () { return $7804c104eb10a23c$export$95adf9d270383091; }, function (v) { return $7804c104eb10a23c$export$95adf9d270383091 = v; });
/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $7804c104eb10a23c$export$d1de70a877d6e43c;
var $7804c104eb10a23c$export$cae1ce83fe4a1782;
var $7804c104eb10a23c$export$d0f0aa2d05c905c5;
var $7804c104eb10a23c$export$95adf9d270383091;
'use strict';
var $07a6fe68a8db7b56$export$42de45683a92ba94;
var $07a6fe68a8db7b56$export$7633ac2cd30f9650;
var $07a6fe68a8db7b56$export$6710ea52c4ec9d6a;
var $07a6fe68a8db7b56$export$9c140b25e26874f9;
var $07a6fe68a8db7b56$export$6792d92addc5c8a0;
var $07a6fe68a8db7b56$export$cae1ce83fe4a1782;
var $07a6fe68a8db7b56$export$224e1a443c3fba76;
var $07a6fe68a8db7b56$export$6d4647cb9e1c75fc;
var $07a6fe68a8db7b56$export$60da749bed98ccf8;
var $07a6fe68a8db7b56$export$220f6291ca35fd71;
'use strict';



var $36a6a35d2d4a3292$exports = {};
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $36a6a35d2d4a3292$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $36a6a35d2d4a3292$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ $36a6a35d2d4a3292$exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $36a6a35d2d4a3292$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $36a6a35d2d4a3292$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $36a6a35d2d4a3292$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $36a6a35d2d4a3292$var$TYPE;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $36a6a35d2d4a3292$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};


var $b87a81ed7888ba1c$exports = {};
'use strict';

var $b87a81ed7888ba1c$var$MAXBITS = 15;
var $b87a81ed7888ba1c$var$ENOUGH_LENS = 852;
var $b87a81ed7888ba1c$var$ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $b87a81ed7888ba1c$var$CODES = 0;
var $b87a81ed7888ba1c$var$LENS = 1;
var $b87a81ed7888ba1c$var$DISTS = 2;
var $b87a81ed7888ba1c$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $b87a81ed7888ba1c$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $b87a81ed7888ba1c$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $b87a81ed7888ba1c$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
$b87a81ed7888ba1c$exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $6581cb2ac156eb1d$exports.Buf16($b87a81ed7888ba1c$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $6581cb2ac156eb1d$exports.Buf16($b87a81ed7888ba1c$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $b87a81ed7888ba1c$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $b87a81ed7888ba1c$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $b87a81ed7888ba1c$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $b87a81ed7888ba1c$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $b87a81ed7888ba1c$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $b87a81ed7888ba1c$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $b87a81ed7888ba1c$var$LENS) {
        base = $b87a81ed7888ba1c$var$lbase;
        base_index -= 257;
        extra = $b87a81ed7888ba1c$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $b87a81ed7888ba1c$var$dbase;
        extra = $b87a81ed7888ba1c$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $b87a81ed7888ba1c$var$LENS && used > $b87a81ed7888ba1c$var$ENOUGH_LENS || type === $b87a81ed7888ba1c$var$DISTS && used > $b87a81ed7888ba1c$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $b87a81ed7888ba1c$var$LENS && used > $b87a81ed7888ba1c$var$ENOUGH_LENS || type === $b87a81ed7888ba1c$var$DISTS && used > $b87a81ed7888ba1c$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};


var $07a6fe68a8db7b56$var$CODES = 0;
var $07a6fe68a8db7b56$var$LENS = 1;
var $07a6fe68a8db7b56$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $07a6fe68a8db7b56$var$Z_FINISH = 4;
var $07a6fe68a8db7b56$var$Z_BLOCK = 5;
var $07a6fe68a8db7b56$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $07a6fe68a8db7b56$var$Z_OK = 0;
var $07a6fe68a8db7b56$var$Z_STREAM_END = 1;
var $07a6fe68a8db7b56$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $07a6fe68a8db7b56$var$Z_STREAM_ERROR = -2;
var $07a6fe68a8db7b56$var$Z_DATA_ERROR = -3;
var $07a6fe68a8db7b56$var$Z_MEM_ERROR = -4;
var $07a6fe68a8db7b56$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $07a6fe68a8db7b56$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $07a6fe68a8db7b56$var$HEAD = 1; /* i: waiting for magic header */ 
var $07a6fe68a8db7b56$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $07a6fe68a8db7b56$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $07a6fe68a8db7b56$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $07a6fe68a8db7b56$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $07a6fe68a8db7b56$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $07a6fe68a8db7b56$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $07a6fe68a8db7b56$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $07a6fe68a8db7b56$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $07a6fe68a8db7b56$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $07a6fe68a8db7b56$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $07a6fe68a8db7b56$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $07a6fe68a8db7b56$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $07a6fe68a8db7b56$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $07a6fe68a8db7b56$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $07a6fe68a8db7b56$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $07a6fe68a8db7b56$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $07a6fe68a8db7b56$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $07a6fe68a8db7b56$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $07a6fe68a8db7b56$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $07a6fe68a8db7b56$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $07a6fe68a8db7b56$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $07a6fe68a8db7b56$var$DIST = 23; /* i: waiting for distance code */ 
var $07a6fe68a8db7b56$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $07a6fe68a8db7b56$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $07a6fe68a8db7b56$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $07a6fe68a8db7b56$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $07a6fe68a8db7b56$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $07a6fe68a8db7b56$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $07a6fe68a8db7b56$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $07a6fe68a8db7b56$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $07a6fe68a8db7b56$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $07a6fe68a8db7b56$var$ENOUGH_LENS = 852;
var $07a6fe68a8db7b56$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $07a6fe68a8db7b56$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $07a6fe68a8db7b56$var$DEF_WBITS = $07a6fe68a8db7b56$var$MAX_WBITS;
function $07a6fe68a8db7b56$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $07a6fe68a8db7b56$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $6581cb2ac156eb1d$exports.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $6581cb2ac156eb1d$exports.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $07a6fe68a8db7b56$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $07a6fe68a8db7b56$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $07a6fe68a8db7b56$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $6581cb2ac156eb1d$exports.Buf32($07a6fe68a8db7b56$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $6581cb2ac156eb1d$exports.Buf32($07a6fe68a8db7b56$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $07a6fe68a8db7b56$var$Z_OK;
}
function $07a6fe68a8db7b56$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $07a6fe68a8db7b56$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $07a6fe68a8db7b56$var$inflateResetKeep(strm);
}
function $07a6fe68a8db7b56$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $07a6fe68a8db7b56$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $07a6fe68a8db7b56$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $07a6fe68a8db7b56$var$inflateReset(strm);
}
function $07a6fe68a8db7b56$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $07a6fe68a8db7b56$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $07a6fe68a8db7b56$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $07a6fe68a8db7b56$var$inflateReset2(strm, windowBits);
    if (ret !== $07a6fe68a8db7b56$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $07a6fe68a8db7b56$var$inflateInit(strm) {
    return $07a6fe68a8db7b56$var$inflateInit2(strm, $07a6fe68a8db7b56$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $07a6fe68a8db7b56$var$virgin = true;
var $07a6fe68a8db7b56$var$lenfix, $07a6fe68a8db7b56$var$distfix; // We have no pointers in JS, so keep tables separate
function $07a6fe68a8db7b56$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($07a6fe68a8db7b56$var$virgin) {
        var sym;
        $07a6fe68a8db7b56$var$lenfix = new $6581cb2ac156eb1d$exports.Buf32(512);
        $07a6fe68a8db7b56$var$distfix = new $6581cb2ac156eb1d$exports.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $b87a81ed7888ba1c$exports($07a6fe68a8db7b56$var$LENS, state.lens, 0, 288, $07a6fe68a8db7b56$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $b87a81ed7888ba1c$exports($07a6fe68a8db7b56$var$DISTS, state.lens, 0, 32, $07a6fe68a8db7b56$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $07a6fe68a8db7b56$var$virgin = false;
    }
    state.lencode = $07a6fe68a8db7b56$var$lenfix;
    state.lenbits = 9;
    state.distcode = $07a6fe68a8db7b56$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $07a6fe68a8db7b56$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $6581cb2ac156eb1d$exports.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $6581cb2ac156eb1d$exports.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $6581cb2ac156eb1d$exports.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $6581cb2ac156eb1d$exports.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $07a6fe68a8db7b56$var$inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $6581cb2ac156eb1d$exports.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $07a6fe68a8db7b56$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $07a6fe68a8db7b56$var$TYPE) state.mode = $07a6fe68a8db7b56$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $07a6fe68a8db7b56$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $07a6fe68a8db7b56$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $07a6fe68a8db7b56$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $71bb0922e613088e$exports(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $07a6fe68a8db7b56$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $07a6fe68a8db7b56$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $07a6fe68a8db7b56$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $07a6fe68a8db7b56$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $07a6fe68a8db7b56$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $07a6fe68a8db7b56$var$DICTID : $07a6fe68a8db7b56$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $07a6fe68a8db7b56$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $07a6fe68a8db7b56$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $07a6fe68a8db7b56$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $07a6fe68a8db7b56$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $71bb0922e613088e$exports(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $07a6fe68a8db7b56$var$TIME;
        /* falls through */ case $07a6fe68a8db7b56$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $71bb0922e613088e$exports(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $07a6fe68a8db7b56$var$OS;
        /* falls through */ case $07a6fe68a8db7b56$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $71bb0922e613088e$exports(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $07a6fe68a8db7b56$var$EXLEN;
        /* falls through */ case $07a6fe68a8db7b56$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $71bb0922e613088e$exports(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $07a6fe68a8db7b56$var$EXTRA;
        /* falls through */ case $07a6fe68a8db7b56$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $6581cb2ac156eb1d$exports.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $71bb0922e613088e$exports(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $07a6fe68a8db7b56$var$NAME;
        /* falls through */ case $07a6fe68a8db7b56$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $71bb0922e613088e$exports(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $07a6fe68a8db7b56$var$COMMENT;
        /* falls through */ case $07a6fe68a8db7b56$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $71bb0922e613088e$exports(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $07a6fe68a8db7b56$var$HCRC;
        /* falls through */ case $07a6fe68a8db7b56$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $07a6fe68a8db7b56$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $07a6fe68a8db7b56$var$TYPE;
            break;
        case $07a6fe68a8db7b56$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $07a6fe68a8db7b56$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $07a6fe68a8db7b56$var$DICT;
        /* falls through */ case $07a6fe68a8db7b56$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $07a6fe68a8db7b56$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $07a6fe68a8db7b56$var$TYPE;
        /* falls through */ case $07a6fe68a8db7b56$var$TYPE:
            if (flush === $07a6fe68a8db7b56$var$Z_BLOCK || flush === $07a6fe68a8db7b56$var$Z_TREES) break inf_leave;
        /* falls through */ case $07a6fe68a8db7b56$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $07a6fe68a8db7b56$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $07a6fe68a8db7b56$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $07a6fe68a8db7b56$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $07a6fe68a8db7b56$var$LEN_; /* decode codes */ 
                    if (flush === $07a6fe68a8db7b56$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $07a6fe68a8db7b56$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $07a6fe68a8db7b56$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $07a6fe68a8db7b56$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $07a6fe68a8db7b56$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $07a6fe68a8db7b56$var$COPY_;
            if (flush === $07a6fe68a8db7b56$var$Z_TREES) break inf_leave;
        /* falls through */ case $07a6fe68a8db7b56$var$COPY_:
            state.mode = $07a6fe68a8db7b56$var$COPY;
        /* falls through */ case $07a6fe68a8db7b56$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $6581cb2ac156eb1d$exports.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $07a6fe68a8db7b56$var$TYPE;
            break;
        case $07a6fe68a8db7b56$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $07a6fe68a8db7b56$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $07a6fe68a8db7b56$var$LENLENS;
        /* falls through */ case $07a6fe68a8db7b56$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $b87a81ed7888ba1c$exports($07a6fe68a8db7b56$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $07a6fe68a8db7b56$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $07a6fe68a8db7b56$var$CODELENS;
        /* falls through */ case $07a6fe68a8db7b56$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $07a6fe68a8db7b56$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $07a6fe68a8db7b56$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $07a6fe68a8db7b56$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $07a6fe68a8db7b56$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $b87a81ed7888ba1c$exports($07a6fe68a8db7b56$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $07a6fe68a8db7b56$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $b87a81ed7888ba1c$exports($07a6fe68a8db7b56$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $07a6fe68a8db7b56$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $07a6fe68a8db7b56$var$LEN_;
            if (flush === $07a6fe68a8db7b56$var$Z_TREES) break inf_leave;
        /* falls through */ case $07a6fe68a8db7b56$var$LEN_:
            state.mode = $07a6fe68a8db7b56$var$LEN;
        /* falls through */ case $07a6fe68a8db7b56$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $36a6a35d2d4a3292$exports(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $07a6fe68a8db7b56$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $07a6fe68a8db7b56$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $07a6fe68a8db7b56$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $07a6fe68a8db7b56$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $07a6fe68a8db7b56$var$LENEXT;
        /* falls through */ case $07a6fe68a8db7b56$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $07a6fe68a8db7b56$var$DIST;
        /* falls through */ case $07a6fe68a8db7b56$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $07a6fe68a8db7b56$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $07a6fe68a8db7b56$var$DISTEXT;
        /* falls through */ case $07a6fe68a8db7b56$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $07a6fe68a8db7b56$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $07a6fe68a8db7b56$var$MATCH;
        /* falls through */ case $07a6fe68a8db7b56$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $07a6fe68a8db7b56$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $07a6fe68a8db7b56$var$LEN;
            break;
        case $07a6fe68a8db7b56$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $07a6fe68a8db7b56$var$LEN;
            break;
        case $07a6fe68a8db7b56$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $71bb0922e613088e$exports(state.check, output, _out, put - _out) : $4ab6edb8f766028d$exports(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $07a6fe68a8db7b56$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $07a6fe68a8db7b56$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $07a6fe68a8db7b56$var$LENGTH;
        /* falls through */ case $07a6fe68a8db7b56$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $07a6fe68a8db7b56$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $07a6fe68a8db7b56$var$DONE;
        /* falls through */ case $07a6fe68a8db7b56$var$DONE:
            ret = $07a6fe68a8db7b56$var$Z_STREAM_END;
            break inf_leave;
        case $07a6fe68a8db7b56$var$BAD:
            ret = $07a6fe68a8db7b56$var$Z_DATA_ERROR;
            break inf_leave;
        case $07a6fe68a8db7b56$var$MEM:
            return $07a6fe68a8db7b56$var$Z_MEM_ERROR;
        case $07a6fe68a8db7b56$var$SYNC:
        /* falls through */ default:
            return $07a6fe68a8db7b56$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $07a6fe68a8db7b56$var$BAD && (state.mode < $07a6fe68a8db7b56$var$CHECK || flush !== $07a6fe68a8db7b56$var$Z_FINISH)) {
        if ($07a6fe68a8db7b56$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $07a6fe68a8db7b56$var$MEM;
            return $07a6fe68a8db7b56$var$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $71bb0922e613088e$exports(state.check, output, _out, strm.next_out - _out) : $4ab6edb8f766028d$exports(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $07a6fe68a8db7b56$var$TYPE ? 128 : 0) + (state.mode === $07a6fe68a8db7b56$var$LEN_ || state.mode === $07a6fe68a8db7b56$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $07a6fe68a8db7b56$var$Z_FINISH) && ret === $07a6fe68a8db7b56$var$Z_OK) ret = $07a6fe68a8db7b56$var$Z_BUF_ERROR;
    return ret;
}
function $07a6fe68a8db7b56$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $07a6fe68a8db7b56$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $07a6fe68a8db7b56$var$Z_OK;
}
function $07a6fe68a8db7b56$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $07a6fe68a8db7b56$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $07a6fe68a8db7b56$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $07a6fe68a8db7b56$var$Z_OK;
}
function $07a6fe68a8db7b56$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $07a6fe68a8db7b56$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $07a6fe68a8db7b56$var$DICT) return $07a6fe68a8db7b56$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $07a6fe68a8db7b56$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $4ab6edb8f766028d$exports(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $07a6fe68a8db7b56$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $07a6fe68a8db7b56$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $07a6fe68a8db7b56$var$MEM;
        return $07a6fe68a8db7b56$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $07a6fe68a8db7b56$var$Z_OK;
}
$07a6fe68a8db7b56$export$42de45683a92ba94 = $07a6fe68a8db7b56$var$inflateReset;
$07a6fe68a8db7b56$export$7633ac2cd30f9650 = $07a6fe68a8db7b56$var$inflateReset2;
$07a6fe68a8db7b56$export$6710ea52c4ec9d6a = $07a6fe68a8db7b56$var$inflateResetKeep;
$07a6fe68a8db7b56$export$9c140b25e26874f9 = $07a6fe68a8db7b56$var$inflateInit;
$07a6fe68a8db7b56$export$6792d92addc5c8a0 = $07a6fe68a8db7b56$var$inflateInit2;
$07a6fe68a8db7b56$export$cae1ce83fe4a1782 = $07a6fe68a8db7b56$var$inflate;
$07a6fe68a8db7b56$export$224e1a443c3fba76 = $07a6fe68a8db7b56$var$inflateEnd;
$07a6fe68a8db7b56$export$6d4647cb9e1c75fc = $07a6fe68a8db7b56$var$inflateGetHeader;
$07a6fe68a8db7b56$export$60da749bed98ccf8 = $07a6fe68a8db7b56$var$inflateSetDictionary;
$07a6fe68a8db7b56$export$220f6291ca35fd71 = 'pako inflate (from Nodeca project)'; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 




var $34b53cf41929f580$exports = {};
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
$34b53cf41929f580$exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};




var $058ebef245b0b977$exports = {};
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $058ebef245b0b977$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
$058ebef245b0b977$exports = $058ebef245b0b977$var$GZheader;


var $7804c104eb10a23c$var$toString = Object.prototype.toString;
/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $7804c104eb10a23c$var$Inflate(options) {
    if (!(this instanceof $7804c104eb10a23c$var$Inflate)) return new $7804c104eb10a23c$var$Inflate(options);
    this.options = $6581cb2ac156eb1d$exports.assign({
        chunkSize: 16384,
        windowBits: 0,
        to: ''
    }, options || {});
    var opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $279ed9d2862dbcca$exports();
    this.strm.avail_out = 0;
    var status = $07a6fe68a8db7b56$export$6792d92addc5c8a0(this.strm, opt.windowBits);
    if (status !== $34b53cf41929f580$exports.Z_OK) throw new Error($ce5320513c074621$exports[status]);
    this.header = new $058ebef245b0b977$exports();
    $07a6fe68a8db7b56$export$6d4647cb9e1c75fc(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') opt.dictionary = $e7f6378a65b01df5$export$7a4c1b2f775b5a9f(opt.dictionary);
        else if ($7804c104eb10a23c$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $07a6fe68a8db7b56$export$60da749bed98ccf8(this.strm, opt.dictionary);
            if (status !== $34b53cf41929f580$exports.Z_OK) throw new Error($ce5320513c074621$exports[status]);
        }
    }
}
/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $7804c104eb10a23c$var$Inflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var dictionary = this.options.dictionary;
    var status, _mode;
    var next_out_utf8, tail, utf8str;
    // Flag to properly process Z_BUF_ERROR on testing inflate call
    // when we check that all output data was flushed.
    var allowBufError = false;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $34b53cf41929f580$exports.Z_FINISH : $34b53cf41929f580$exports.Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // Only binary strings can be decompressed on practice
    strm.input = $e7f6378a65b01df5$export$1d1a7119601ff18c(data);
    else if ($7804c104eb10a23c$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $6581cb2ac156eb1d$exports.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $07a6fe68a8db7b56$export$cae1ce83fe4a1782(strm, $34b53cf41929f580$exports.Z_NO_FLUSH); /* no bad return value */ 
        if (status === $34b53cf41929f580$exports.Z_NEED_DICT && dictionary) status = $07a6fe68a8db7b56$export$60da749bed98ccf8(this.strm, dictionary);
        if (status === $34b53cf41929f580$exports.Z_BUF_ERROR && allowBufError === true) {
            status = $34b53cf41929f580$exports.Z_OK;
            allowBufError = false;
        }
        if (status !== $34b53cf41929f580$exports.Z_STREAM_END && status !== $34b53cf41929f580$exports.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $34b53cf41929f580$exports.Z_STREAM_END || strm.avail_in === 0 && (_mode === $34b53cf41929f580$exports.Z_FINISH || _mode === $34b53cf41929f580$exports.Z_SYNC_FLUSH)) {
                if (this.options.to === 'string') {
                    next_out_utf8 = $e7f6378a65b01df5$export$53dee3f58a714214(strm.output, strm.next_out);
                    tail = strm.next_out - next_out_utf8;
                    utf8str = $e7f6378a65b01df5$export$49a50563f377746(strm.output, next_out_utf8);
                    // move tail
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) $6581cb2ac156eb1d$exports.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                    this.onData(utf8str);
                } else this.onData($6581cb2ac156eb1d$exports.shrinkBuf(strm.output, strm.next_out));
            }
        }
        // When no more input data, we should check that internal inflate buffers
        // are flushed. The only way to do it when avail_out = 0 - run one more
        // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
        // Here we set flag to process this error properly.
        //
        // NOTE. Deflate does not return error in this case and does not needs such
        // logic.
        if (strm.avail_in === 0 && strm.avail_out === 0) allowBufError = true;
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $34b53cf41929f580$exports.Z_STREAM_END);
    if (status === $34b53cf41929f580$exports.Z_STREAM_END) _mode = $34b53cf41929f580$exports.Z_FINISH;
    // Finalize on the last chunk.
    if (_mode === $34b53cf41929f580$exports.Z_FINISH) {
        status = $07a6fe68a8db7b56$export$224e1a443c3fba76(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $34b53cf41929f580$exports.Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $34b53cf41929f580$exports.Z_SYNC_FLUSH) {
        this.onEnd($34b53cf41929f580$exports.Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $7804c104eb10a23c$var$Inflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $7804c104eb10a23c$var$Inflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $34b53cf41929f580$exports.Z_OK) {
        if (this.options.to === 'string') // Glue & convert here, until we teach pako to send
        // utf8 aligned strings to onData
        this.result = this.chunks.join('');
        else this.result = $6581cb2ac156eb1d$exports.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/ function $7804c104eb10a23c$var$inflate(input, options) {
    var inflator = new $7804c104eb10a23c$var$Inflate(options);
    inflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $ce5320513c074621$exports[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $7804c104eb10a23c$var$inflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $7804c104eb10a23c$var$inflate(input, options);
}
$7804c104eb10a23c$export$d1de70a877d6e43c = $7804c104eb10a23c$var$Inflate;
$7804c104eb10a23c$export$cae1ce83fe4a1782 = $7804c104eb10a23c$var$inflate;
$7804c104eb10a23c$export$d0f0aa2d05c905c5 = $7804c104eb10a23c$var$inflateRaw;
$7804c104eb10a23c$export$95adf9d270383091 = $7804c104eb10a23c$var$inflate;



var $72a59eef0464adf4$var$pako = {};
$72a59eef0464adf4$require$assign($72a59eef0464adf4$var$pako, $3129edcfdd3d4a46$exports, $7804c104eb10a23c$exports, $34b53cf41929f580$exports);
$72a59eef0464adf4$exports = $72a59eef0464adf4$var$pako;


var $f1ca3c277fe35c72$var$UPNG = {};
$f1ca3c277fe35c72$var$UPNG.toRGBA8 = function(out) {
    var w = out.width, h = out.height;
    if (out.tabs.acTL == null) return [
        $f1ca3c277fe35c72$var$UPNG.toRGBA8.decodeImage(out.data, w, h, out).buffer
    ];
    var frms = [];
    if (out.frames[0].data == null) out.frames[0].data = out.data;
    var len = w * h * 4, img = new Uint8Array(len), empty = new Uint8Array(len), prev = new Uint8Array(len);
    for(var i = 0; i < out.frames.length; i++){
        var frm = out.frames[i];
        var fx = frm.rect.x, fy = frm.rect.y, fw = frm.rect.width, fh = frm.rect.height;
        var fdata = $f1ca3c277fe35c72$var$UPNG.toRGBA8.decodeImage(frm.data, fw, fh, out);
        if (i != 0) for(var j = 0; j < len; j++)prev[j] = img[j];
        if (frm.blend == 0) $f1ca3c277fe35c72$var$UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 0);
        else if (frm.blend == 1) $f1ca3c277fe35c72$var$UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 1);
        frms.push(img.buffer.slice(0));
        if (frm.dispose == 0) ;
        else if (frm.dispose == 1) $f1ca3c277fe35c72$var$UPNG._copyTile(empty, fw, fh, img, w, h, fx, fy, 0);
        else if (frm.dispose == 2) for(var j = 0; j < len; j++)img[j] = prev[j];
    }
    return frms;
};
$f1ca3c277fe35c72$var$UPNG.toRGBA8.decodeImage = function(data, w, h, out) {
    var area = w * h, bpp = $f1ca3c277fe35c72$var$UPNG.decode._getBPP(out);
    var bpl = Math.ceil(w * bpp / 8); // bytes per line
    var bf = new Uint8Array(area * 4), bf32 = new Uint32Array(bf.buffer);
    var ctype = out.ctype, depth = out.depth;
    var rs = $f1ca3c277fe35c72$var$UPNG._bin.readUshort;
    //console.log(ctype, depth);
    var time = Date.now();
    if (ctype == 6) {
        var qarea = area << 2;
        if (depth == 8) for(var i = 0; i < qarea; i += 4){
            bf[i] = data[i];
            bf[i + 1] = data[i + 1];
            bf[i + 2] = data[i + 2];
            bf[i + 3] = data[i + 3];
        }
        if (depth == 16) for(var i = 0; i < qarea; i++)bf[i] = data[i << 1];
    } else if (ctype == 2) {
        var ts = out.tabs["tRNS"];
        if (ts == null) {
            if (depth == 8) for(var i = 0; i < area; i++){
                var ti = i * 3;
                bf32[i] = -16777216 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
            }
            if (depth == 16) for(var i = 0; i < area; i++){
                var ti = i * 6;
                bf32[i] = -16777216 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
            }
        } else {
            var tr = ts[0], tg = ts[1], tb = ts[2];
            if (depth == 8) for(var i = 0; i < area; i++){
                var qi = i << 2, ti = i * 3;
                bf32[i] = -16777216 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
                if (data[ti] == tr && data[ti + 1] == tg && data[ti + 2] == tb) bf[qi + 3] = 0;
            }
            if (depth == 16) for(var i = 0; i < area; i++){
                var qi = i << 2, ti = i * 6;
                bf32[i] = -16777216 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
                if (rs(data, ti) == tr && rs(data, ti + 2) == tg && rs(data, ti + 4) == tb) bf[qi + 3] = 0;
            }
        }
    } else if (ctype == 3) {
        var p = out.tabs["PLTE"], ap = out.tabs["tRNS"], tl = ap ? ap.length : 0;
        //console.log(p, ap);
        if (depth == 1) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 3)] >> 7 - ((i & 7) << 0) & 1, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 2) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 2)] >> 6 - ((i & 3) << 1) & 3, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 4) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 1)] >> 4 - ((i & 1) << 2) & 15, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 8) for(var i = 0; i < area; i++){
            var qi = i << 2, j = data[i], cj = 3 * j;
            bf[qi] = p[cj];
            bf[qi + 1] = p[cj + 1];
            bf[qi + 2] = p[cj + 2];
            bf[qi + 3] = j < tl ? ap[j] : 255;
        }
    } else if (ctype == 4) {
        if (depth == 8) for(var i = 0; i < area; i++){
            var qi = i << 2, di = i << 1, gr = data[di];
            bf[qi] = gr;
            bf[qi + 1] = gr;
            bf[qi + 2] = gr;
            bf[qi + 3] = data[di + 1];
        }
        if (depth == 16) for(var i = 0; i < area; i++){
            var qi = i << 2, di = i << 2, gr = data[di];
            bf[qi] = gr;
            bf[qi + 1] = gr;
            bf[qi + 2] = gr;
            bf[qi + 3] = data[di + 2];
        }
    } else if (ctype == 0) {
        var tr = out.tabs["tRNS"] ? out.tabs["tRNS"] : -1;
        for(var y = 0; y < h; y++){
            var off = y * bpl, to = y * w;
            if (depth == 1) for(var x = 0; x < w; x++){
                var gr = 255 * (data[off + (x >>> 3)] >>> 7 - (x & 7) & 1), al = gr == tr * 255 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 2) for(var x = 0; x < w; x++){
                var gr = 85 * (data[off + (x >>> 2)] >>> 6 - ((x & 3) << 1) & 3), al = gr == tr * 85 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 4) for(var x = 0; x < w; x++){
                var gr = 17 * (data[off + (x >>> 1)] >>> 4 - ((x & 1) << 2) & 15), al = gr == tr * 17 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 8) for(var x = 0; x < w; x++){
                var gr = data[off + x], al = gr == tr ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 16) for(var x = 0; x < w; x++){
                var gr = data[off + (x << 1)], al = rs(data, off + (x << i)) == tr ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
        }
    }
    //console.log(Date.now()-time);
    return bf;
};
$f1ca3c277fe35c72$var$UPNG.decode = function(buff) {
    var data = new Uint8Array(buff), offset = 8, bin = $f1ca3c277fe35c72$var$UPNG._bin, rUs = bin.readUshort, rUi = bin.readUint;
    var out = {
        tabs: {},
        frames: []
    };
    var dd = new Uint8Array(data.length), doff = 0; // put all IDAT data into it
    var fd, foff = 0; // frames
    var mgck = [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    for(var i = 0; i < 8; i++)if (data[i] != mgck[i]) throw "The input is not a PNG file!";
    while(offset < data.length){
        var len = bin.readUint(data, offset);
        offset += 4;
        var type = bin.readASCII(data, offset, 4);
        offset += 4;
        //console.log(type,len);
        if (type == "IHDR") $f1ca3c277fe35c72$var$UPNG.decode._IHDR(data, offset, out);
        else if (type == "IDAT") {
            for(var i = 0; i < len; i++)dd[doff + i] = data[offset + i];
            doff += len;
        } else if (type == "acTL") {
            out.tabs[type] = {
                num_frames: rUi(data, offset),
                num_plays: rUi(data, offset + 4)
            };
            fd = new Uint8Array(data.length);
        } else if (type == "fcTL") {
            if (foff != 0) {
                var fr = out.frames[out.frames.length - 1];
                fr.data = $f1ca3c277fe35c72$var$UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
                foff = 0;
            }
            var rct = {
                x: rUi(data, offset + 12),
                y: rUi(data, offset + 16),
                width: rUi(data, offset + 4),
                height: rUi(data, offset + 8)
            };
            var del = rUs(data, offset + 22);
            del = rUs(data, offset + 20) / (del == 0 ? 100 : del);
            var frm = {
                rect: rct,
                delay: Math.round(del * 1000),
                dispose: data[offset + 24],
                blend: data[offset + 25]
            };
            //console.log(frm);
            out.frames.push(frm);
        } else if (type == "fdAT") {
            for(var i = 0; i < len - 4; i++)fd[foff + i] = data[offset + i + 4];
            foff += len - 4;
        } else if (type == "pHYs") out.tabs[type] = [
            bin.readUint(data, offset),
            bin.readUint(data, offset + 4),
            data[offset + 8]
        ];
        else if (type == "cHRM") {
            out.tabs[type] = [];
            for(var i = 0; i < 8; i++)out.tabs[type].push(bin.readUint(data, offset + i * 4));
        } else if (type == "tEXt") {
            if (out.tabs[type] == null) out.tabs[type] = {};
            var nz = bin.nextZero(data, offset);
            var keyw = bin.readASCII(data, offset, nz - offset);
            var text = bin.readASCII(data, nz + 1, offset + len - nz - 1);
            out.tabs[type][keyw] = text;
        } else if (type == "iTXt") {
            if (out.tabs[type] == null) out.tabs[type] = {};
            var nz = 0, off = offset;
            nz = bin.nextZero(data, off);
            var keyw = bin.readASCII(data, off, nz - off);
            off = nz + 1;
            var cflag = data[off], cmeth = data[off + 1];
            off += 2;
            nz = bin.nextZero(data, off);
            var ltag = bin.readASCII(data, off, nz - off);
            off = nz + 1;
            nz = bin.nextZero(data, off);
            var tkeyw = bin.readUTF8(data, off, nz - off);
            off = nz + 1;
            var text = bin.readUTF8(data, off, len - (off - offset));
            out.tabs[type][keyw] = text;
        } else if (type == "PLTE") out.tabs[type] = bin.readBytes(data, offset, len);
        else if (type == "hIST") {
            var pl = out.tabs["PLTE"].length / 3;
            out.tabs[type] = [];
            for(var i = 0; i < pl; i++)out.tabs[type].push(rUs(data, offset + i * 2));
        } else if (type == "tRNS") {
            if (out.ctype == 3) out.tabs[type] = bin.readBytes(data, offset, len);
            else if (out.ctype == 0) out.tabs[type] = rUs(data, offset);
            else if (out.ctype == 2) out.tabs[type] = [
                rUs(data, offset),
                rUs(data, offset + 2),
                rUs(data, offset + 4)
            ];
        //else console.log("tRNS for unsupported color type",out.ctype, len);
        } else if (type == "gAMA") out.tabs[type] = bin.readUint(data, offset) / 100000;
        else if (type == "sRGB") out.tabs[type] = data[offset];
        else if (type == "bKGD") {
            if (out.ctype == 0 || out.ctype == 4) out.tabs[type] = [
                rUs(data, offset)
            ];
            else if (out.ctype == 2 || out.ctype == 6) out.tabs[type] = [
                rUs(data, offset),
                rUs(data, offset + 2),
                rUs(data, offset + 4)
            ];
            else if (out.ctype == 3) out.tabs[type] = data[offset];
        } else if (type == "IEND") break;
        //else {  log("unknown chunk type", type, len);  }
        offset += len;
        var crc = bin.readUint(data, offset);
        offset += 4;
    }
    if (foff != 0) {
        var fr = out.frames[out.frames.length - 1];
        fr.data = $f1ca3c277fe35c72$var$UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
        foff = 0;
    }
    out.data = $f1ca3c277fe35c72$var$UPNG.decode._decompress(out, dd, out.width, out.height);
    delete out.compress;
    delete out.interlace;
    delete out.filter;
    return out;
};
$f1ca3c277fe35c72$var$UPNG.decode._decompress = function(out, dd, w, h) {
    var time = Date.now();
    var bpp = $f1ca3c277fe35c72$var$UPNG.decode._getBPP(out), bpl = Math.ceil(w * bpp / 8), buff = new Uint8Array((bpl + 1 + out.interlace) * h);
    dd = $f1ca3c277fe35c72$var$UPNG.decode._inflate(dd, buff);
    //console.log(dd.length, buff.length);
    //console.log(Date.now()-time);
    var time = Date.now();
    if (out.interlace == 0) dd = $f1ca3c277fe35c72$var$UPNG.decode._filterZero(dd, out, 0, w, h);
    else if (out.interlace == 1) dd = $f1ca3c277fe35c72$var$UPNG.decode._readInterlace(dd, out);
    //console.log(Date.now()-time);
    return dd;
};
$f1ca3c277fe35c72$var$UPNG.decode._inflate = function(data, buff) {
    var out = $f1ca3c277fe35c72$var$UPNG["inflateRaw"](new Uint8Array(data.buffer, 2, data.length - 6), buff);
    return out;
};
$f1ca3c277fe35c72$var$UPNG.inflateRaw = function() {
    var H = {};
    H.H = {};
    H.H.N = function(N, W) {
        var R = Uint8Array, i = 0, m = 0, J = 0, h = 0, Q = 0, X = 0, u = 0, w = 0, d = 0, v, C;
        if (N[0] == 3 && N[1] == 0) return W ? W : new R(0);
        var V = H.H, n = V.b, A = V.e, l = V.R, M = V.n, I = V.A, e = V.Z, b = V.m, Z = W == null;
        if (Z) W = new R(N.length >>> 2 << 3);
        while(i == 0){
            i = n(N, d, 1);
            m = n(N, d + 1, 2);
            d += 3;
            if (m == 0) {
                if ((d & 7) != 0) d += 8 - (d & 7);
                var D = (d >>> 3) + 4, q = N[D - 4] | N[D - 3] << 8;
                if (Z) W = H.H.W(W, w + q);
                W.set(new R(N.buffer, N.byteOffset + D, q), w);
                d = D + q << 3;
                w += q;
                continue;
            }
            if (Z) W = H.H.W(W, w + 131072);
            if (m == 1) {
                v = b.J;
                C = b.h;
                X = 511;
                u = 31;
            }
            if (m == 2) {
                J = A(N, d, 5) + 257;
                h = A(N, d + 5, 5) + 1;
                Q = A(N, d + 10, 4) + 4;
                d += 14;
                var E = d, j = 1;
                for(var c = 0; c < 38; c += 2){
                    b.Q[c] = 0;
                    b.Q[c + 1] = 0;
                }
                for(var c = 0; c < Q; c++){
                    var K = A(N, d + c * 3, 3);
                    b.Q[(b.X[c] << 1) + 1] = K;
                    if (K > j) j = K;
                }
                d += 3 * Q;
                M(b.Q, j);
                I(b.Q, j, b.u);
                v = b.w;
                C = b.d;
                d = l(b.u, (1 << j) - 1, J + h, N, d, b.v);
                var r = V.V(b.v, 0, J, b.C);
                X = (1 << r) - 1;
                var S = V.V(b.v, J, h, b.D);
                u = (1 << S) - 1;
                M(b.C, r);
                I(b.C, r, v);
                M(b.D, S);
                I(b.D, S, C);
            }
            while(true){
                var T = v[e(N, d) & X];
                d += T & 15;
                var p = T >>> 4;
                if (p >>> 8 == 0) W[w++] = p;
                else if (p == 256) break;
                else {
                    var z = w + p - 254;
                    if (p > 264) {
                        var _ = b.q[p - 257];
                        z = w + (_ >>> 3) + A(N, d, _ & 7);
                        d += _ & 7;
                    }
                    var $ = C[e(N, d) & u];
                    d += $ & 15;
                    var s = $ >>> 4, Y = b.c[s], a = (Y >>> 4) + n(N, d, Y & 15);
                    d += Y & 15;
                    while(w < z){
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                    }
                    w = z;
                }
            }
        }
        return W.length == w ? W : W.slice(0, w);
    };
    H.H.W = function(N, W) {
        var R = N.length;
        if (W <= R) return N;
        var V = new Uint8Array(R << 1);
        V.set(N, 0);
        return V;
    };
    H.H.R = function(N, W, R, V, n, A) {
        var l = H.H.e, M = H.H.Z, I = 0;
        while(I < R){
            var e = N[M(V, n) & W];
            n += e & 15;
            var b = e >>> 4;
            if (b <= 15) {
                A[I] = b;
                I++;
            } else {
                var Z = 0, m = 0;
                if (b == 16) {
                    m = 3 + l(V, n, 2);
                    n += 2;
                    Z = A[I - 1];
                } else if (b == 17) {
                    m = 3 + l(V, n, 3);
                    n += 3;
                } else if (b == 18) {
                    m = 11 + l(V, n, 7);
                    n += 7;
                }
                var J = I + m;
                while(I < J){
                    A[I] = Z;
                    I++;
                }
            }
        }
        return n;
    };
    H.H.V = function(N, W, R, V) {
        var n = 0, A = 0, l = V.length >>> 1;
        while(A < R){
            var M = N[A + W];
            V[A << 1] = 0;
            V[(A << 1) + 1] = M;
            if (M > n) n = M;
            A++;
        }
        while(A < l){
            V[A << 1] = 0;
            V[(A << 1) + 1] = 0;
            A++;
        }
        return n;
    };
    H.H.n = function(N, W) {
        var R = H.H.m, V = N.length, n, A, l, M, I, e = R.j;
        for(var M = 0; M <= W; M++)e[M] = 0;
        for(M = 1; M < V; M += 2)e[N[M]]++;
        var b = R.K;
        n = 0;
        e[0] = 0;
        for(A = 1; A <= W; A++){
            n = n + e[A - 1] << 1;
            b[A] = n;
        }
        for(l = 0; l < V; l += 2){
            I = N[l + 1];
            if (I != 0) {
                N[l] = b[I];
                b[I]++;
            }
        }
    };
    H.H.A = function(N, W, R) {
        var V = N.length, n = H.H.m, A = n.r;
        for(var l = 0; l < V; l += 2)if (N[l + 1] != 0) {
            var M = l >> 1, I = N[l + 1], e = M << 4 | I, b = W - I, Z = N[l] << b, m = Z + (1 << b);
            while(Z != m){
                var J = A[Z] >>> 15 - W;
                R[J] = e;
                Z++;
            }
        }
    };
    H.H.l = function(N, W) {
        var R = H.H.m.r, V = 15 - W;
        for(var n = 0; n < N.length; n += 2){
            var A = N[n] << W - N[n + 1];
            N[n] = R[A] >>> V;
        }
    };
    H.H.M = function(N, W, R) {
        R = R << (W & 7);
        var V = W >>> 3;
        N[V] |= R;
        N[V + 1] |= R >>> 8;
    };
    H.H.I = function(N, W, R) {
        R = R << (W & 7);
        var V = W >>> 3;
        N[V] |= R;
        N[V + 1] |= R >>> 8;
        N[V + 2] |= R >>> 16;
    };
    H.H.e = function(N, W, R) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8) >>> (W & 7) & (1 << R) - 1;
    };
    H.H.b = function(N, W, R) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7) & (1 << R) - 1;
    };
    H.H.Z = function(N, W) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7);
    };
    H.H.i = function(N, W) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16 | N[(W >>> 3) + 3] << 24) >>> (W & 7);
    };
    H.H.m = function() {
        var N = Uint16Array, W = Uint32Array;
        return {
            K: new N(16),
            j: new N(16),
            X: [
                16,
                17,
                18,
                0,
                8,
                7,
                9,
                6,
                10,
                5,
                11,
                4,
                12,
                3,
                13,
                2,
                14,
                1,
                15
            ],
            S: [
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                13,
                15,
                17,
                19,
                23,
                27,
                31,
                35,
                43,
                51,
                59,
                67,
                83,
                99,
                115,
                131,
                163,
                195,
                227,
                258,
                999,
                999,
                999
            ],
            T: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                1,
                1,
                1,
                2,
                2,
                2,
                2,
                3,
                3,
                3,
                3,
                4,
                4,
                4,
                4,
                5,
                5,
                5,
                5,
                0,
                0,
                0,
                0
            ],
            q: new N(32),
            p: [
                1,
                2,
                3,
                4,
                5,
                7,
                9,
                13,
                17,
                25,
                33,
                49,
                65,
                97,
                129,
                193,
                257,
                385,
                513,
                769,
                1025,
                1537,
                2049,
                3073,
                4097,
                6145,
                8193,
                12289,
                16385,
                24577,
                65535,
                65535
            ],
            z: [
                0,
                0,
                0,
                0,
                1,
                1,
                2,
                2,
                3,
                3,
                4,
                4,
                5,
                5,
                6,
                6,
                7,
                7,
                8,
                8,
                9,
                9,
                10,
                10,
                11,
                11,
                12,
                12,
                13,
                13,
                0,
                0
            ],
            c: new W(32),
            J: new N(512),
            _: [],
            h: new N(32),
            $: [],
            w: new N(32768),
            C: [],
            v: [],
            d: new N(32768),
            D: [],
            u: new N(512),
            Q: [],
            r: new N(32768),
            s: new W(286),
            Y: new W(30),
            a: new W(19),
            t: new W(15e3),
            k: new N(65536),
            g: new N(32768)
        };
    }();
    (function() {
        var N = H.H.m, W = 32768;
        for(var R = 0; R < W; R++){
            var V = R;
            V = (V & 2863311530) >>> 1 | (V & 1431655765) << 1;
            V = (V & 3435973836) >>> 2 | (V & 858993459) << 2;
            V = (V & 4042322160) >>> 4 | (V & 252645135) << 4;
            V = (V & 4278255360) >>> 8 | (V & 16711935) << 8;
            N.r[R] = (V >>> 16 | V << 16) >>> 17;
        }
        function n(A, l, M) {
            while(l-- != 0)A.push(0, M);
        }
        for(var R = 0; R < 32; R++){
            N.q[R] = N.S[R] << 3 | N.T[R];
            N.c[R] = N.p[R] << 4 | N.z[R];
        }
        n(N._, 144, 8);
        n(N._, 112, 9);
        n(N._, 24, 7);
        n(N._, 8, 8);
        H.H.n(N._, 9);
        H.H.A(N._, 9, N.J);
        H.H.l(N._, 9);
        n(N.$, 32, 5);
        H.H.n(N.$, 5);
        H.H.A(N.$, 5, N.h);
        H.H.l(N.$, 5);
        n(N.Q, 19, 0);
        n(N.C, 286, 0);
        n(N.D, 30, 0);
        n(N.v, 320, 0);
    })();
    return H.H.N;
}();
$f1ca3c277fe35c72$var$UPNG.decode._readInterlace = function(data, out) {
    var w = out.width, h = out.height;
    var bpp = $f1ca3c277fe35c72$var$UPNG.decode._getBPP(out), cbpp = bpp >> 3, bpl = Math.ceil(w * bpp / 8);
    var img = new Uint8Array(h * bpl);
    var di = 0;
    var starting_row = [
        0,
        0,
        4,
        0,
        2,
        0,
        1
    ];
    var starting_col = [
        0,
        4,
        0,
        2,
        0,
        1,
        0
    ];
    var row_increment = [
        8,
        8,
        8,
        4,
        4,
        2,
        2
    ];
    var col_increment = [
        8,
        8,
        4,
        4,
        2,
        2,
        1
    ];
    var pass = 0;
    while(pass < 7){
        var ri = row_increment[pass], ci = col_increment[pass];
        var sw = 0, sh = 0;
        var cr = starting_row[pass];
        while(cr < h){
            cr += ri;
            sh++;
        }
        var cc = starting_col[pass];
        while(cc < w){
            cc += ci;
            sw++;
        }
        var bpll = Math.ceil(sw * bpp / 8);
        $f1ca3c277fe35c72$var$UPNG.decode._filterZero(data, out, di, sw, sh);
        var y = 0, row = starting_row[pass];
        while(row < h){
            var col = starting_col[pass];
            var cdi = di + y * bpll << 3;
            while(col < w){
                if (bpp == 1) {
                    var val = data[cdi >> 3];
                    val = val >> 7 - (cdi & 7) & 1;
                    img[row * bpl + (col >> 3)] |= val << 7 - ((col & 7) << 0);
                }
                if (bpp == 2) {
                    var val = data[cdi >> 3];
                    val = val >> 6 - (cdi & 7) & 3;
                    img[row * bpl + (col >> 2)] |= val << 6 - ((col & 3) << 1);
                }
                if (bpp == 4) {
                    var val = data[cdi >> 3];
                    val = val >> 4 - (cdi & 7) & 15;
                    img[row * bpl + (col >> 1)] |= val << 4 - ((col & 1) << 2);
                }
                if (bpp >= 8) {
                    var ii = row * bpl + col * cbpp;
                    for(var j = 0; j < cbpp; j++)img[ii + j] = data[(cdi >> 3) + j];
                }
                cdi += bpp;
                col += ci;
            }
            y++;
            row += ri;
        }
        if (sw * sh != 0) di += sh * (1 + bpll);
        pass = pass + 1;
    }
    return img;
};
$f1ca3c277fe35c72$var$UPNG.decode._getBPP = function(out) {
    var noc = [
        1,
        null,
        3,
        1,
        2,
        null,
        4
    ][out.ctype];
    return noc * out.depth;
};
$f1ca3c277fe35c72$var$UPNG.decode._filterZero = function(data, out, off, w, h) {
    var bpp = $f1ca3c277fe35c72$var$UPNG.decode._getBPP(out), bpl = Math.ceil(w * bpp / 8), paeth = $f1ca3c277fe35c72$var$UPNG.decode._paeth;
    bpp = Math.ceil(bpp / 8);
    var i = 0, di = 1, type = data[off], x = 0;
    if (type > 1) data[off] = [
        0,
        0,
        1
    ][type - 2];
    if (type == 3) for(x = bpp; x < bpl; x++)data[x + 1] = data[x + 1] + (data[x + 1 - bpp] >>> 1) & 255;
    for(var y = 0; y < h; y++){
        i = off + y * bpl;
        di = i + y + 1;
        type = data[di - 1];
        x = 0;
        if (type == 0) for(; x < bpl; x++)data[i + x] = data[di + x];
        else if (type == 1) {
            for(; x < bpp; x++)data[i + x] = data[di + x];
            for(; x < bpl; x++)data[i + x] = data[di + x] + data[i + x - bpp];
        } else if (type == 2) for(; x < bpl; x++)data[i + x] = data[di + x] + data[i + x - bpl];
        else if (type == 3) {
            for(; x < bpp; x++)data[i + x] = data[di + x] + (data[i + x - bpl] >>> 1);
            for(; x < bpl; x++)data[i + x] = data[di + x] + (data[i + x - bpl] + data[i + x - bpp] >>> 1);
        } else {
            for(; x < bpp; x++)data[i + x] = data[di + x] + paeth(0, data[i + x - bpl], 0);
            for(; x < bpl; x++)data[i + x] = data[di + x] + paeth(data[i + x - bpp], data[i + x - bpl], data[i + x - bpp - bpl]);
        }
    }
    return data;
};
$f1ca3c277fe35c72$var$UPNG.decode._paeth = function(a, b, c) {
    var p = a + b - c, pa = p - a, pb = p - b, pc = p - c;
    if (pa * pa <= pb * pb && pa * pa <= pc * pc) return a;
    else if (pb * pb <= pc * pc) return b;
    return c;
};
$f1ca3c277fe35c72$var$UPNG.decode._IHDR = function(data, offset, out) {
    var bin = $f1ca3c277fe35c72$var$UPNG._bin;
    out.width = bin.readUint(data, offset);
    offset += 4;
    out.height = bin.readUint(data, offset);
    offset += 4;
    out.depth = data[offset];
    offset++;
    out.ctype = data[offset];
    offset++;
    out.compress = data[offset];
    offset++;
    out.filter = data[offset];
    offset++;
    out.interlace = data[offset];
    offset++;
};
$f1ca3c277fe35c72$var$UPNG._bin = {
    nextZero: function(data, p) {
        while(data[p] != 0)p++;
        return p;
    },
    readUshort: function(buff, p) {
        return buff[p] << 8 | buff[p + 1];
    },
    writeUshort: function(buff, p, n) {
        buff[p] = n >> 8 & 255;
        buff[p + 1] = n & 255;
    },
    readUint: function(buff, p) {
        return buff[p] * 16777216 + (buff[p + 1] << 16 | buff[p + 2] << 8 | buff[p + 3]);
    },
    writeUint: function(buff, p, n) {
        buff[p] = n >> 24 & 255;
        buff[p + 1] = n >> 16 & 255;
        buff[p + 2] = n >> 8 & 255;
        buff[p + 3] = n & 255;
    },
    readASCII: function(buff, p, l) {
        var s = "";
        for(var i = 0; i < l; i++)s += String.fromCharCode(buff[p + i]);
        return s;
    },
    writeASCII: function(data, p, s) {
        for(var i = 0; i < s.length; i++)data[p + i] = s.charCodeAt(i);
    },
    readBytes: function(buff, p, l) {
        var arr = [];
        for(var i = 0; i < l; i++)arr.push(buff[p + i]);
        return arr;
    },
    pad: function(n) {
        return n.length < 2 ? "0" + n : n;
    },
    readUTF8: function(buff, p, l) {
        var s = "", ns;
        for(var i = 0; i < l; i++)s += "%" + $f1ca3c277fe35c72$var$UPNG._bin.pad(buff[p + i].toString(16));
        try {
            ns = decodeURIComponent(s);
        } catch (e) {
            return $f1ca3c277fe35c72$var$UPNG._bin.readASCII(buff, p, l);
        }
        return ns;
    }
};
$f1ca3c277fe35c72$var$UPNG._copyTile = function(sb, sw, sh, tb, tw, th, xoff, yoff, mode) {
    var w = Math.min(sw, tw), h = Math.min(sh, th);
    var si = 0, ti = 0;
    for(var y = 0; y < h; y++)for(var x = 0; x < w; x++){
        if (xoff >= 0 && yoff >= 0) {
            si = y * sw + x << 2;
            ti = (yoff + y) * tw + xoff + x << 2;
        } else {
            si = (-yoff + y) * sw - xoff + x << 2;
            ti = y * tw + x << 2;
        }
        if (mode == 0) {
            tb[ti] = sb[si];
            tb[ti + 1] = sb[si + 1];
            tb[ti + 2] = sb[si + 2];
            tb[ti + 3] = sb[si + 3];
        } else if (mode == 1) {
            var fa = sb[si + 3] * (1 / 255), fr = sb[si] * fa, fg = sb[si + 1] * fa, fb = sb[si + 2] * fa;
            var ba = tb[ti + 3] * (1 / 255), br = tb[ti] * ba, bg = tb[ti + 1] * ba, bb = tb[ti + 2] * ba;
            var ifa = 1 - fa, oa = fa + ba * ifa, ioa = oa == 0 ? 0 : 1 / oa;
            tb[ti + 3] = 255 * oa;
            tb[ti + 0] = (fr + br * ifa) * ioa;
            tb[ti + 1] = (fg + bg * ifa) * ioa;
            tb[ti + 2] = (fb + bb * ifa) * ioa;
        } else if (mode == 2) {
            var fa = sb[si + 3], fr = sb[si], fg = sb[si + 1], fb = sb[si + 2];
            var ba = tb[ti + 3], br = tb[ti], bg = tb[ti + 1], bb = tb[ti + 2];
            if (fa == ba && fr == br && fg == bg && fb == bb) {
                tb[ti] = 0;
                tb[ti + 1] = 0;
                tb[ti + 2] = 0;
                tb[ti + 3] = 0;
            } else {
                tb[ti] = fr;
                tb[ti + 1] = fg;
                tb[ti + 2] = fb;
                tb[ti + 3] = fa;
            }
        } else if (mode == 3) {
            var fa = sb[si + 3], fr = sb[si], fg = sb[si + 1], fb = sb[si + 2];
            var ba = tb[ti + 3], br = tb[ti], bg = tb[ti + 1], bb = tb[ti + 2];
            if (fa == ba && fr == br && fg == bg && fb == bb) continue;
            //if(fa!=255 && ba!=0) return false;
            if (fa < 220 && ba > 20) return false;
        }
    }
    return true;
};
$f1ca3c277fe35c72$var$UPNG.encode = function(bufs, w, h, ps, dels, tabs, forbidPlte) {
    if (ps == null) ps = 0;
    if (forbidPlte == null) forbidPlte = false;
    var nimg = $f1ca3c277fe35c72$var$UPNG.encode.compress(bufs, w, h, ps, [
        false,
        false,
        false,
        0,
        forbidPlte
    ]);
    $f1ca3c277fe35c72$var$UPNG.encode.compressPNG(nimg, -1);
    return $f1ca3c277fe35c72$var$UPNG.encode._main(nimg, w, h, dels, tabs);
};
$f1ca3c277fe35c72$var$UPNG.encodeLL = function(bufs, w, h, cc, ac, depth, dels, tabs) {
    var nimg = {
        ctype: 0 + (cc == 1 ? 0 : 2) + (ac == 0 ? 0 : 4),
        depth: depth,
        frames: []
    };
    var time = Date.now();
    var bipp = (cc + ac) * depth, bipl = bipp * w;
    for(var i = 0; i < bufs.length; i++)nimg.frames.push({
        rect: {
            x: 0,
            y: 0,
            width: w,
            height: h
        },
        img: new Uint8Array(bufs[i]),
        blend: 0,
        dispose: 1,
        bpp: Math.ceil(bipp / 8),
        bpl: Math.ceil(bipl / 8)
    });
    $f1ca3c277fe35c72$var$UPNG.encode.compressPNG(nimg, 0, true);
    var out = $f1ca3c277fe35c72$var$UPNG.encode._main(nimg, w, h, dels, tabs);
    return out;
};
$f1ca3c277fe35c72$var$UPNG.encode._main = function(nimg, w, h, dels, tabs) {
    if (tabs == null) tabs = {};
    var crc = $f1ca3c277fe35c72$var$UPNG.crc.crc, wUi = $f1ca3c277fe35c72$var$UPNG._bin.writeUint, wUs = $f1ca3c277fe35c72$var$UPNG._bin.writeUshort, wAs = $f1ca3c277fe35c72$var$UPNG._bin.writeASCII;
    var offset = 8, anim = nimg.frames.length > 1, pltAlpha = false;
    var leng = 33 + (anim ? 20 : 0);
    if (tabs["sRGB"] != null) leng += 13;
    if (tabs["pHYs"] != null) leng += 21;
    if (nimg.ctype == 3) {
        var dl = nimg.plte.length;
        for(var i = 0; i < dl; i++)if (nimg.plte[i] >>> 24 != 255) pltAlpha = true;
        leng += 8 + dl * 3 + 4 + (pltAlpha ? 8 + dl * 1 + 4 : 0);
    }
    for(var j = 0; j < nimg.frames.length; j++){
        var fr = nimg.frames[j];
        if (anim) leng += 38;
        leng += fr.cimg.length + 12;
        if (j != 0) leng += 4;
    }
    leng += 12;
    var data = new Uint8Array(leng);
    var wr = [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    for(var i = 0; i < 8; i++)data[i] = wr[i];
    wUi(data, offset, 13);
    offset += 4;
    wAs(data, offset, "IHDR");
    offset += 4;
    wUi(data, offset, w);
    offset += 4;
    wUi(data, offset, h);
    offset += 4;
    data[offset] = nimg.depth;
    offset++; // depth
    data[offset] = nimg.ctype;
    offset++; // ctype
    data[offset] = 0;
    offset++; // compress
    data[offset] = 0;
    offset++; // filter
    data[offset] = 0;
    offset++; // interlace
    wUi(data, offset, crc(data, offset - 17, 17));
    offset += 4; // crc
    // 13 bytes to say, that it is sRGB
    if (tabs["sRGB"] != null) {
        wUi(data, offset, 1);
        offset += 4;
        wAs(data, offset, "sRGB");
        offset += 4;
        data[offset] = tabs["sRGB"];
        offset++;
        wUi(data, offset, crc(data, offset - 5, 5));
        offset += 4; // crc
    }
    if (tabs["pHYs"] != null) {
        wUi(data, offset, 9);
        offset += 4;
        wAs(data, offset, "pHYs");
        offset += 4;
        wUi(data, offset, tabs["pHYs"][0]);
        offset += 4;
        wUi(data, offset, tabs["pHYs"][1]);
        offset += 4;
        data[offset] = tabs["pHYs"][2];
        offset++;
        wUi(data, offset, crc(data, offset - 13, 13));
        offset += 4; // crc
    }
    if (anim) {
        wUi(data, offset, 8);
        offset += 4;
        wAs(data, offset, "acTL");
        offset += 4;
        wUi(data, offset, nimg.frames.length);
        offset += 4;
        wUi(data, offset, tabs["loop"] != null ? tabs["loop"] : 0);
        offset += 4;
        wUi(data, offset, crc(data, offset - 12, 12));
        offset += 4; // crc
    }
    if (nimg.ctype == 3) {
        var dl = nimg.plte.length;
        wUi(data, offset, dl * 3);
        offset += 4;
        wAs(data, offset, "PLTE");
        offset += 4;
        for(var i = 0; i < dl; i++){
            var ti = i * 3, c = nimg.plte[i], r = c & 255, g = c >>> 8 & 255, b = c >>> 16 & 255;
            data[offset + ti + 0] = r;
            data[offset + ti + 1] = g;
            data[offset + ti + 2] = b;
        }
        offset += dl * 3;
        wUi(data, offset, crc(data, offset - dl * 3 - 4, dl * 3 + 4));
        offset += 4; // crc
        if (pltAlpha) {
            wUi(data, offset, dl);
            offset += 4;
            wAs(data, offset, "tRNS");
            offset += 4;
            for(var i = 0; i < dl; i++)data[offset + i] = nimg.plte[i] >>> 24 & 255;
            offset += dl;
            wUi(data, offset, crc(data, offset - dl - 4, dl + 4));
            offset += 4; // crc
        }
    }
    var fi = 0;
    for(var j = 0; j < nimg.frames.length; j++){
        var fr = nimg.frames[j];
        if (anim) {
            wUi(data, offset, 26);
            offset += 4;
            wAs(data, offset, "fcTL");
            offset += 4;
            wUi(data, offset, fi++);
            offset += 4;
            wUi(data, offset, fr.rect.width);
            offset += 4;
            wUi(data, offset, fr.rect.height);
            offset += 4;
            wUi(data, offset, fr.rect.x);
            offset += 4;
            wUi(data, offset, fr.rect.y);
            offset += 4;
            wUs(data, offset, dels[j]);
            offset += 2;
            wUs(data, offset, 1000);
            offset += 2;
            data[offset] = fr.dispose;
            offset++; // dispose
            data[offset] = fr.blend;
            offset++; // blend
            wUi(data, offset, crc(data, offset - 30, 30));
            offset += 4; // crc
        }
        var imgd = fr.cimg, dl = imgd.length;
        wUi(data, offset, dl + (j == 0 ? 0 : 4));
        offset += 4;
        var ioff = offset;
        wAs(data, offset, j == 0 ? "IDAT" : "fdAT");
        offset += 4;
        if (j != 0) {
            wUi(data, offset, fi++);
            offset += 4;
        }
        data.set(imgd, offset);
        offset += dl;
        wUi(data, offset, crc(data, ioff, offset - ioff));
        offset += 4; // crc
    }
    wUi(data, offset, 0);
    offset += 4;
    wAs(data, offset, "IEND");
    offset += 4;
    wUi(data, offset, crc(data, offset - 4, 4));
    offset += 4; // crc
    return data.buffer;
};
$f1ca3c277fe35c72$var$UPNG.encode.compressPNG = function(out, filter, levelZero) {
    for(var i = 0; i < out.frames.length; i++){
        var frm = out.frames[i], nw = frm.rect.width, nh = frm.rect.height;
        var fdata = new Uint8Array(nh * frm.bpl + nh);
        frm.cimg = $f1ca3c277fe35c72$var$UPNG.encode._filterZero(frm.img, nh, frm.bpp, frm.bpl, fdata, filter, levelZero);
    }
};
$f1ca3c277fe35c72$var$UPNG.encode.compress = function(bufs, w, h, ps, prms) {
    //var time = Date.now();
    var onlyBlend = prms[0], evenCrd = prms[1], forbidPrev = prms[2], minBits = prms[3], forbidPlte = prms[4];
    var ctype = 6, depth = 8, alphaAnd = 255;
    for(var j = 0; j < bufs.length; j++){
        var img = new Uint8Array(bufs[j]), ilen = img.length;
        for(var i = 0; i < ilen; i += 4)alphaAnd &= img[i + 3];
    }
    var gotAlpha = alphaAnd != 255;
    //console.log("alpha check", Date.now()-time);  time = Date.now();
    //var brute = gotAlpha && forGIF;		// brute : frames can only be copied, not "blended"
    var frms = $f1ca3c277fe35c72$var$UPNG.encode.framize(bufs, w, h, onlyBlend, evenCrd, forbidPrev);
    //console.log("framize", Date.now()-time);  time = Date.now();
    var cmap = {}, plte = [], inds = [];
    if (ps != 0) {
        var nbufs = [];
        for(var i = 0; i < frms.length; i++)nbufs.push(frms[i].img.buffer);
        var abuf = $f1ca3c277fe35c72$var$UPNG.encode.concatRGBA(nbufs), qres = $f1ca3c277fe35c72$var$UPNG.quantize(abuf, ps);
        var cof = 0, bb = new Uint8Array(qres.abuf);
        for(var i = 0; i < frms.length; i++){
            var ti = frms[i].img, bln = ti.length;
            inds.push(new Uint8Array(qres.inds.buffer, cof >> 2, bln >> 2));
            for(var j = 0; j < bln; j += 4){
                ti[j] = bb[cof + j];
                ti[j + 1] = bb[cof + j + 1];
                ti[j + 2] = bb[cof + j + 2];
                ti[j + 3] = bb[cof + j + 3];
            }
            cof += bln;
        }
        for(var i = 0; i < qres.plte.length; i++)plte.push(qres.plte[i].est.rgba);
    //console.log("quantize", Date.now()-time);  time = Date.now();
    } else // what if ps==0, but there are <=256 colors?  we still need to detect, if the palette could be used
    for(var j = 0; j < frms.length; j++){
        var frm = frms[j], img32 = new Uint32Array(frm.img.buffer), nw = frm.rect.width, ilen = img32.length;
        var ind = new Uint8Array(ilen);
        inds.push(ind);
        for(var i = 0; i < ilen; i++){
            var c = img32[i];
            if (i != 0 && c == img32[i - 1]) ind[i] = ind[i - 1];
            else if (i > nw && c == img32[i - nw]) ind[i] = ind[i - nw];
            else {
                var cmc = cmap[c];
                if (cmc == null) {
                    cmap[c] = cmc = plte.length;
                    plte.push(c);
                    if (plte.length >= 300) break;
                }
                ind[i] = cmc;
            }
        }
    }
    var cc = plte.length; //console.log("colors:",cc);
    if (cc <= 256 && forbidPlte == false) {
        if (cc <= 2) depth = 1;
        else if (cc <= 4) depth = 2;
        else if (cc <= 16) depth = 4;
        else depth = 8;
        depth = Math.max(depth, minBits);
    }
    for(var j = 0; j < frms.length; j++){
        var frm = frms[j], nx = frm.rect.x, ny = frm.rect.y, nw = frm.rect.width, nh = frm.rect.height;
        var cimg = frm.img, cimg32 = new Uint32Array(cimg.buffer);
        var bpl = 4 * nw, bpp = 4;
        if (cc <= 256 && forbidPlte == false) {
            bpl = Math.ceil(depth * nw / 8);
            var nimg = new Uint8Array(bpl * nh);
            var inj = inds[j];
            for(var y = 0; y < nh; y++){
                var i = y * bpl, ii = y * nw;
                if (depth == 8) for(var x = 0; x < nw; x++)nimg[i + x] = inj[ii + x];
                else if (depth == 4) for(var x = 0; x < nw; x++)nimg[i + (x >> 1)] |= inj[ii + x] << 4 - (x & 1) * 4;
                else if (depth == 2) for(var x = 0; x < nw; x++)nimg[i + (x >> 2)] |= inj[ii + x] << 6 - (x & 3) * 2;
                else if (depth == 1) for(var x = 0; x < nw; x++)nimg[i + (x >> 3)] |= inj[ii + x] << 7 - (x & 7) * 1;
            }
            cimg = nimg;
            ctype = 3;
            bpp = 1;
        } else if (gotAlpha == false && frms.length == 1) {
            var nimg = new Uint8Array(nw * nh * 3), area = nw * nh;
            for(var i = 0; i < area; i++){
                var ti = i * 3, qi = i * 4;
                nimg[ti] = cimg[qi];
                nimg[ti + 1] = cimg[qi + 1];
                nimg[ti + 2] = cimg[qi + 2];
            }
            cimg = nimg;
            ctype = 2;
            bpp = 3;
            bpl = 3 * nw;
        }
        frm.img = cimg;
        frm.bpl = bpl;
        frm.bpp = bpp;
    }
    //console.log("colors => palette indices", Date.now()-time);  time = Date.now();
    return {
        ctype: ctype,
        depth: depth,
        plte: plte,
        frames: frms
    };
};
$f1ca3c277fe35c72$var$UPNG.encode.framize = function(bufs, w, h, alwaysBlend, evenCrd, forbidPrev) {
    /*  DISPOSE
	    - 0 : no change
		- 1 : clear to transparent
		- 2 : retstore to content before rendering (previous frame disposed)
		BLEND
		- 0 : replace
		- 1 : blend
	*/ var frms = [];
    for(var j = 0; j < bufs.length; j++){
        var cimg = new Uint8Array(bufs[j]), cimg32 = new Uint32Array(cimg.buffer);
        var nimg;
        var nx = 0, ny = 0, nw = w, nh = h, blend = alwaysBlend ? 1 : 0;
        if (j != 0) {
            var tlim = forbidPrev || alwaysBlend || j == 1 || frms[j - 2].dispose != 0 ? 1 : 2, tstp = 0, tarea = 1e9;
            for(var it = 0; it < tlim; it++){
                var pimg = new Uint8Array(bufs[j - 1 - it]), p32 = new Uint32Array(bufs[j - 1 - it]);
                var mix = w, miy = h, max = -1, may = -1;
                for(var y = 0; y < h; y++)for(var x = 0; x < w; x++){
                    var i = y * w + x;
                    if (cimg32[i] != p32[i]) {
                        if (x < mix) mix = x;
                        if (x > max) max = x;
                        if (y < miy) miy = y;
                        if (y > may) may = y;
                    }
                }
                if (max == -1) mix = miy = max = may = 0;
                if (evenCrd) {
                    if ((mix & 1) == 1) mix--;
                    if ((miy & 1) == 1) miy--;
                }
                var sarea = (max - mix + 1) * (may - miy + 1);
                if (sarea < tarea) {
                    tarea = sarea;
                    tstp = it;
                    nx = mix;
                    ny = miy;
                    nw = max - mix + 1;
                    nh = may - miy + 1;
                }
            }
            // alwaysBlend: pokud zjistím, že blendit nelze, nastavím předchozímu snímku dispose=1. Zajistím, aby obsahoval můj obdélník.
            var pimg = new Uint8Array(bufs[j - 1 - tstp]);
            if (tstp == 1) frms[j - 1].dispose = 2;
            nimg = new Uint8Array(nw * nh * 4);
            $f1ca3c277fe35c72$var$UPNG._copyTile(pimg, w, h, nimg, nw, nh, -nx, -ny, 0);
            blend = $f1ca3c277fe35c72$var$UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 3) ? 1 : 0;
            if (blend == 1) $f1ca3c277fe35c72$var$UPNG.encode._prepareDiff(cimg, w, h, nimg, {
                x: nx,
                y: ny,
                width: nw,
                height: nh
            });
            else $f1ca3c277fe35c72$var$UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 0);
        //UPNG._copyTile(cimg,w,h, nimg,nw,nh, -nx,-ny, blend==1?2:0);
        } else nimg = cimg.slice(0); // img may be rewritten further ... don't rewrite input
        frms.push({
            rect: {
                x: nx,
                y: ny,
                width: nw,
                height: nh
            },
            img: nimg,
            blend: blend,
            dispose: 0
        });
    }
    if (alwaysBlend) for(var j = 0; j < frms.length; j++){
        var frm = frms[j];
        if (frm.blend == 1) continue;
        var r0 = frm.rect, r1 = frms[j - 1].rect;
        var miX = Math.min(r0.x, r1.x), miY = Math.min(r0.y, r1.y);
        var maX = Math.max(r0.x + r0.width, r1.x + r1.width), maY = Math.max(r0.y + r0.height, r1.y + r1.height);
        var r = {
            x: miX,
            y: miY,
            width: maX - miX,
            height: maY - miY
        };
        frms[j - 1].dispose = 1;
        if (j - 1 != 0) $f1ca3c277fe35c72$var$UPNG.encode._updateFrame(bufs, w, h, frms, j - 1, r, evenCrd);
        $f1ca3c277fe35c72$var$UPNG.encode._updateFrame(bufs, w, h, frms, j, r, evenCrd);
    }
    var area = 0;
    if (bufs.length != 1) for(var i = 0; i < frms.length; i++){
        var frm = frms[i];
        area += frm.rect.width * frm.rect.height;
    //if(i==0 || frm.blend!=1) continue;
    //var ob = new Uint8Array(
    //console.log(frm.blend, frm.dispose, frm.rect);
    }
    //if(area!=0) console.log(area);
    return frms;
};
$f1ca3c277fe35c72$var$UPNG.encode._updateFrame = function(bufs, w, h, frms, i, r, evenCrd) {
    var U8 = Uint8Array, U32 = Uint32Array;
    var pimg = new U8(bufs[i - 1]), pimg32 = new U32(bufs[i - 1]), nimg = i + 1 < bufs.length ? new U8(bufs[i + 1]) : null;
    var cimg = new U8(bufs[i]), cimg32 = new U32(cimg.buffer);
    var mix = w, miy = h, max = -1, may = -1;
    for(var y = 0; y < r.height; y++)for(var x = 0; x < r.width; x++){
        var cx = r.x + x, cy = r.y + y;
        var j = cy * w + cx, cc = cimg32[j];
        // no need to draw transparency, or to dispose it. Or, if writing the same color and the next one does not need transparency.
        if (cc == 0 || frms[i - 1].dispose == 0 && pimg32[j] == cc && (nimg == null || nimg[j * 4 + 3] != 0)) ;
        else {
            if (cx < mix) mix = cx;
            if (cx > max) max = cx;
            if (cy < miy) miy = cy;
            if (cy > may) may = cy;
        }
    }
    if (max == -1) mix = miy = max = may = 0;
    if (evenCrd) {
        if ((mix & 1) == 1) mix--;
        if ((miy & 1) == 1) miy--;
    }
    r = {
        x: mix,
        y: miy,
        width: max - mix + 1,
        height: may - miy + 1
    };
    var fr = frms[i];
    fr.rect = r;
    fr.blend = 1;
    fr.img = new Uint8Array(r.width * r.height * 4);
    if (frms[i - 1].dispose == 0) {
        $f1ca3c277fe35c72$var$UPNG._copyTile(pimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
        $f1ca3c277fe35c72$var$UPNG.encode._prepareDiff(cimg, w, h, fr.img, r);
    //UPNG._copyTile(cimg,w,h, fr.img,r.width,r.height, -r.x,-r.y, 2);
    } else $f1ca3c277fe35c72$var$UPNG._copyTile(cimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
};
$f1ca3c277fe35c72$var$UPNG.encode._prepareDiff = function(cimg, w, h, nimg, rec) {
    $f1ca3c277fe35c72$var$UPNG._copyTile(cimg, w, h, nimg, rec.width, rec.height, -rec.x, -rec.y, 2);
/*
	var n32 = new Uint32Array(nimg.buffer);
	var og = new Uint8Array(rec.width*rec.height*4), o32 = new Uint32Array(og.buffer);
	UPNG._copyTile(cimg,w,h, og,rec.width,rec.height, -rec.x,-rec.y, 0);
	for(var i=4; i<nimg.length; i+=4) {
		if(nimg[i-1]!=0 && nimg[i+3]==0 && o32[i>>>2]==o32[(i>>>2)-1]) {
			n32[i>>>2]=o32[i>>>2];
			//var j = i, c=p32[(i>>>2)-1];
			//while(p32[j>>>2]==c) {  n32[j>>>2]=c;  j+=4;  }
		}
	}
	for(var i=nimg.length-8; i>0; i-=4) {
		if(nimg[i+7]!=0 && nimg[i+3]==0 && o32[i>>>2]==o32[(i>>>2)+1]) {
			n32[i>>>2]=o32[i>>>2];
			//var j = i, c=p32[(i>>>2)-1];
			//while(p32[j>>>2]==c) {  n32[j>>>2]=c;  j+=4;  }
		}
	}*/ };
$f1ca3c277fe35c72$var$UPNG.encode._filterZero = function(img, h, bpp, bpl, data, filter, levelZero) {
    var fls = [], ftry = [
        0,
        1,
        2,
        3,
        4
    ];
    if (filter != -1) ftry = [
        filter
    ];
    else if (h * bpl > 500000 || bpp == 1) ftry = [
        0
    ];
    var opts;
    if (levelZero) opts = {
        level: 0
    };
    var CMPR = levelZero && UZIP != null ? UZIP : (0, (/*@__PURE__*/$parcel$interopDefault($72a59eef0464adf4$exports)));
    for(var i = 0; i < ftry.length; i++){
        for(var y = 0; y < h; y++)$f1ca3c277fe35c72$var$UPNG.encode._filterLine(data, img, y, bpl, bpp, ftry[i]);
        //var nimg = new Uint8Array(data.length);
        //var sz = UZIP.F.deflate(data, nimg);  fls.push(nimg.slice(0,sz));
        //var dfl = pako["deflate"](data), dl=dfl.length-4;
        //var crc = (dfl[dl+3]<<24)|(dfl[dl+2]<<16)|(dfl[dl+1]<<8)|(dfl[dl+0]<<0);
        //console.log(crc, UZIP.adler(data,2,data.length-6));
        fls.push(CMPR["deflate"](data, opts));
    }
    var ti, tsize = 1e9;
    for(var i = 0; i < fls.length; i++)if (fls[i].length < tsize) {
        ti = i;
        tsize = fls[i].length;
    }
    return fls[ti];
};
$f1ca3c277fe35c72$var$UPNG.encode._filterLine = function(data, img, y, bpl, bpp, type) {
    var i = y * bpl, di = i + y, paeth = $f1ca3c277fe35c72$var$UPNG.decode._paeth;
    data[di] = type;
    di++;
    if (type == 0) {
        if (bpl < 500) for(var x = 0; x < bpl; x++)data[di + x] = img[i + x];
        else data.set(new Uint8Array(img.buffer, i, bpl), di);
    } else if (type == 1) {
        for(var x = 0; x < bpp; x++)data[di + x] = img[i + x];
        for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - img[i + x - bpp] + 256 & 255;
    } else if (y == 0) {
        for(var x = 0; x < bpp; x++)data[di + x] = img[i + x];
        if (type == 2) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x];
        if (type == 3) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - (img[i + x - bpp] >> 1) + 256 & 255;
        if (type == 4) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - paeth(img[i + x - bpp], 0, 0) + 256 & 255;
    } else {
        if (type == 2) for(var x = 0; x < bpl; x++)data[di + x] = img[i + x] + 256 - img[i + x - bpl] & 255;
        if (type == 3) {
            for(var x = 0; x < bpp; x++)data[di + x] = img[i + x] + 256 - (img[i + x - bpl] >> 1) & 255;
            for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] + 256 - (img[i + x - bpl] + img[i + x - bpp] >> 1) & 255;
        }
        if (type == 4) {
            for(var x = 0; x < bpp; x++)data[di + x] = img[i + x] + 256 - paeth(0, img[i + x - bpl], 0) & 255;
            for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] + 256 - paeth(img[i + x - bpp], img[i + x - bpl], img[i + x - bpp - bpl]) & 255;
        }
    }
};
$f1ca3c277fe35c72$var$UPNG.crc = {
    table: function() {
        var tab = new Uint32Array(256);
        for(var n = 0; n < 256; n++){
            var c = n;
            for(var k = 0; k < 8; k++)if (c & 1) c = 0xedb88320 ^ c >>> 1;
            else c = c >>> 1;
            tab[n] = c;
        }
        return tab;
    }(),
    update: function(c, buf, off, len) {
        for(var i = 0; i < len; i++)c = $f1ca3c277fe35c72$var$UPNG.crc.table[(c ^ buf[off + i]) & 0xff] ^ c >>> 8;
        return c;
    },
    crc: function(b, o, l) {
        return $f1ca3c277fe35c72$var$UPNG.crc.update(0xffffffff, b, o, l) ^ 0xffffffff;
    }
};
$f1ca3c277fe35c72$var$UPNG.quantize = function(abuf, ps) {
    var oimg = new Uint8Array(abuf), nimg = oimg.slice(0), nimg32 = new Uint32Array(nimg.buffer);
    var KD = $f1ca3c277fe35c72$var$UPNG.quantize.getKDtree(nimg, ps);
    var root = KD[0], leafs = KD[1];
    var planeDst = $f1ca3c277fe35c72$var$UPNG.quantize.planeDst;
    var sb = oimg, tb = nimg32, len = sb.length;
    var inds = new Uint8Array(oimg.length >> 2);
    for(var i = 0; i < len; i += 4){
        var r = sb[i] * (1 / 255), g = sb[i + 1] * (1 / 255), b = sb[i + 2] * (1 / 255), a = sb[i + 3] * (1 / 255);
        //  exact, but too slow :(
        var nd = $f1ca3c277fe35c72$var$UPNG.quantize.getNearest(root, r, g, b, a);
        //var nd = root;
        //while(nd.left) nd = (planeDst(nd.est,r,g,b,a)<=0) ? nd.left : nd.right;
        inds[i >> 2] = nd.ind;
        tb[i >> 2] = nd.est.rgba;
    }
    return {
        abuf: nimg.buffer,
        inds: inds,
        plte: leafs
    };
};
$f1ca3c277fe35c72$var$UPNG.quantize.getKDtree = function(nimg, ps, err) {
    if (err == null) err = 0.0001;
    var nimg32 = new Uint32Array(nimg.buffer);
    var root = {
        i0: 0,
        i1: nimg.length,
        bst: null,
        est: null,
        tdst: 0,
        left: null,
        right: null
    }; // basic statistic, extra statistic
    root.bst = $f1ca3c277fe35c72$var$UPNG.quantize.stats(nimg, root.i0, root.i1);
    root.est = $f1ca3c277fe35c72$var$UPNG.quantize.estats(root.bst);
    var leafs = [
        root
    ];
    while(leafs.length < ps){
        var maxL = 0, mi = 0;
        for(var i = 0; i < leafs.length; i++)if (leafs[i].est.L > maxL) {
            maxL = leafs[i].est.L;
            mi = i;
        }
        if (maxL < err) break;
        var node = leafs[mi];
        var s0 = $f1ca3c277fe35c72$var$UPNG.quantize.splitPixels(nimg, nimg32, node.i0, node.i1, node.est.e, node.est.eMq255);
        var s0wrong = node.i0 >= s0 || node.i1 <= s0;
        //console.log(maxL, leafs.length, mi);
        if (s0wrong) {
            node.est.L = 0;
            continue;
        }
        var ln = {
            i0: node.i0,
            i1: s0,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        ln.bst = $f1ca3c277fe35c72$var$UPNG.quantize.stats(nimg, ln.i0, ln.i1);
        ln.est = $f1ca3c277fe35c72$var$UPNG.quantize.estats(ln.bst);
        var rn = {
            i0: s0,
            i1: node.i1,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        rn.bst = {
            R: [],
            m: [],
            N: node.bst.N - ln.bst.N
        };
        for(var i = 0; i < 16; i++)rn.bst.R[i] = node.bst.R[i] - ln.bst.R[i];
        for(var i = 0; i < 4; i++)rn.bst.m[i] = node.bst.m[i] - ln.bst.m[i];
        rn.est = $f1ca3c277fe35c72$var$UPNG.quantize.estats(rn.bst);
        node.left = ln;
        node.right = rn;
        leafs[mi] = ln;
        leafs.push(rn);
    }
    leafs.sort(function(a, b) {
        return b.bst.N - a.bst.N;
    });
    for(var i = 0; i < leafs.length; i++)leafs[i].ind = i;
    return [
        root,
        leafs
    ];
};
$f1ca3c277fe35c72$var$UPNG.quantize.getNearest = function(nd, r, g, b, a) {
    if (nd.left == null) {
        nd.tdst = $f1ca3c277fe35c72$var$UPNG.quantize.dist(nd.est.q, r, g, b, a);
        return nd;
    }
    var planeDst = $f1ca3c277fe35c72$var$UPNG.quantize.planeDst(nd.est, r, g, b, a);
    var node0 = nd.left, node1 = nd.right;
    if (planeDst > 0) {
        node0 = nd.right;
        node1 = nd.left;
    }
    var ln = $f1ca3c277fe35c72$var$UPNG.quantize.getNearest(node0, r, g, b, a);
    if (ln.tdst <= planeDst * planeDst) return ln;
    var rn = $f1ca3c277fe35c72$var$UPNG.quantize.getNearest(node1, r, g, b, a);
    return rn.tdst < ln.tdst ? rn : ln;
};
$f1ca3c277fe35c72$var$UPNG.quantize.planeDst = function(est, r, g, b, a) {
    var e = est.e;
    return e[0] * r + e[1] * g + e[2] * b + e[3] * a - est.eMq;
};
$f1ca3c277fe35c72$var$UPNG.quantize.dist = function(q, r, g, b, a) {
    var d0 = r - q[0], d1 = g - q[1], d2 = b - q[2], d3 = a - q[3];
    return d0 * d0 + d1 * d1 + d2 * d2 + d3 * d3;
};
$f1ca3c277fe35c72$var$UPNG.quantize.splitPixels = function(nimg, nimg32, i0, i1, e, eMq) {
    var vecDot = $f1ca3c277fe35c72$var$UPNG.quantize.vecDot;
    i1 -= 4;
    var shfs = 0;
    while(i0 < i1){
        while(vecDot(nimg, i0, e) <= eMq)i0 += 4;
        while(vecDot(nimg, i1, e) > eMq)i1 -= 4;
        if (i0 >= i1) break;
        var t = nimg32[i0 >> 2];
        nimg32[i0 >> 2] = nimg32[i1 >> 2];
        nimg32[i1 >> 2] = t;
        i0 += 4;
        i1 -= 4;
    }
    while(vecDot(nimg, i0, e) > eMq)i0 -= 4;
    return i0 + 4;
};
$f1ca3c277fe35c72$var$UPNG.quantize.vecDot = function(nimg, i, e) {
    return nimg[i] * e[0] + nimg[i + 1] * e[1] + nimg[i + 2] * e[2] + nimg[i + 3] * e[3];
};
$f1ca3c277fe35c72$var$UPNG.quantize.stats = function(nimg, i0, i1) {
    var R = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var m = [
        0,
        0,
        0,
        0
    ];
    var N = i1 - i0 >> 2;
    for(var i = i0; i < i1; i += 4){
        var r = nimg[i] * (1 / 255), g = nimg[i + 1] * (1 / 255), b = nimg[i + 2] * (1 / 255), a = nimg[i + 3] * (1 / 255);
        //var r = nimg[i], g = nimg[i+1], b = nimg[i+2], a = nimg[i+3];
        m[0] += r;
        m[1] += g;
        m[2] += b;
        m[3] += a;
        R[0] += r * r;
        R[1] += r * g;
        R[2] += r * b;
        R[3] += r * a;
        R[5] += g * g;
        R[6] += g * b;
        R[7] += g * a;
        R[10] += b * b;
        R[11] += b * a;
        R[15] += a * a;
    }
    R[4] = R[1];
    R[8] = R[2];
    R[9] = R[6];
    R[12] = R[3];
    R[13] = R[7];
    R[14] = R[11];
    return {
        R: R,
        m: m,
        N: N
    };
};
$f1ca3c277fe35c72$var$UPNG.quantize.estats = function(stats) {
    var R = stats.R, m = stats.m, N = stats.N;
    // when all samples are equal, but N is large (millions), the Rj can be non-zero ( 0.0003.... - precission error)
    var m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], iN = N == 0 ? 0 : 1 / N;
    var Rj = [
        R[0] - m0 * m0 * iN,
        R[1] - m0 * m1 * iN,
        R[2] - m0 * m2 * iN,
        R[3] - m0 * m3 * iN,
        R[4] - m1 * m0 * iN,
        R[5] - m1 * m1 * iN,
        R[6] - m1 * m2 * iN,
        R[7] - m1 * m3 * iN,
        R[8] - m2 * m0 * iN,
        R[9] - m2 * m1 * iN,
        R[10] - m2 * m2 * iN,
        R[11] - m2 * m3 * iN,
        R[12] - m3 * m0 * iN,
        R[13] - m3 * m1 * iN,
        R[14] - m3 * m2 * iN,
        R[15] - m3 * m3 * iN
    ];
    var A = Rj, M = $f1ca3c277fe35c72$var$UPNG.M4;
    var b = [
        0.5,
        0.5,
        0.5,
        0.5
    ], mi = 0, tmi = 0;
    if (N != 0) for(var i = 0; i < 10; i++){
        b = M.multVec(A, b);
        tmi = Math.sqrt(M.dot(b, b));
        b = M.sml(1 / tmi, b);
        if (Math.abs(tmi - mi) < 1e-9) break;
        mi = tmi;
    }
    //b = [0,0,1,0];  mi=N;
    var q = [
        m0 * iN,
        m1 * iN,
        m2 * iN,
        m3 * iN
    ];
    var eMq255 = M.dot(M.sml(255, q), b);
    return {
        Cov: Rj,
        q: q,
        e: b,
        L: mi,
        eMq255: eMq255,
        eMq: M.dot(b, q),
        rgba: (Math.round(255 * q[3]) << 24 | Math.round(255 * q[2]) << 16 | Math.round(255 * q[1]) << 8 | Math.round(255 * q[0]) << 0) >>> 0
    };
};
$f1ca3c277fe35c72$var$UPNG.M4 = {
    multVec: function(m, v) {
        return [
            m[0] * v[0] + m[1] * v[1] + m[2] * v[2] + m[3] * v[3],
            m[4] * v[0] + m[5] * v[1] + m[6] * v[2] + m[7] * v[3],
            m[8] * v[0] + m[9] * v[1] + m[10] * v[2] + m[11] * v[3],
            m[12] * v[0] + m[13] * v[1] + m[14] * v[2] + m[15] * v[3]
        ];
    },
    dot: function(x, y) {
        return x[0] * y[0] + x[1] * y[1] + x[2] * y[2] + x[3] * y[3];
    },
    sml: function(a, y) {
        return [
            a * y[0],
            a * y[1],
            a * y[2],
            a * y[3]
        ];
    }
};
$f1ca3c277fe35c72$var$UPNG.encode.concatRGBA = function(bufs) {
    var tlen = 0;
    for(var i = 0; i < bufs.length; i++)tlen += bufs[i].byteLength;
    var nimg = new Uint8Array(tlen), noff = 0;
    for(var i = 0; i < bufs.length; i++){
        var img = new Uint8Array(bufs[i]), il = img.length;
        for(var j = 0; j < il; j += 4){
            var r = img[j], g = img[j + 1], b = img[j + 2], a = img[j + 3];
            if (a == 0) r = g = b = 0;
            nimg[noff + j] = r;
            nimg[noff + j + 1] = g;
            nimg[noff + j + 2] = b;
            nimg[noff + j + 3] = a;
        }
        noff += il;
    }
    return nimg.buffer;
};
var $f1ca3c277fe35c72$export$2e2bcd8739ae039 = $f1ca3c277fe35c72$var$UPNG;


var $0a7381df9de46ed3$var$getImageType = function(ctype) {
    if (ctype === 0) return $0a7381df9de46ed3$export$3ff975e8f63e458c.Greyscale;
    if (ctype === 2) return $0a7381df9de46ed3$export$3ff975e8f63e458c.Truecolour;
    if (ctype === 3) return $0a7381df9de46ed3$export$3ff975e8f63e458c.IndexedColour;
    if (ctype === 4) return $0a7381df9de46ed3$export$3ff975e8f63e458c.GreyscaleWithAlpha;
    if (ctype === 6) return $0a7381df9de46ed3$export$3ff975e8f63e458c.TruecolourWithAlpha;
    throw new Error("Unknown color type: " + ctype);
};
var $0a7381df9de46ed3$var$splitAlphaChannel = function(rgbaChannel) {
    var pixelCount = Math.floor(rgbaChannel.length / 4);
    var rgbChannel = new Uint8Array(pixelCount * 3);
    var alphaChannel = new Uint8Array(pixelCount * 1);
    var rgbaOffset = 0;
    var rgbOffset = 0;
    var alphaOffset = 0;
    while(rgbaOffset < rgbaChannel.length){
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        alphaChannel[alphaOffset++] = rgbaChannel[rgbaOffset++];
    }
    return {
        rgbChannel: rgbChannel,
        alphaChannel: alphaChannel
    };
};
var $0a7381df9de46ed3$export$3ff975e8f63e458c;
(function(PngType) {
    PngType["Greyscale"] = "Greyscale";
    PngType["Truecolour"] = "Truecolour";
    PngType["IndexedColour"] = "IndexedColour";
    PngType["GreyscaleWithAlpha"] = "GreyscaleWithAlpha";
    PngType["TruecolourWithAlpha"] = "TruecolourWithAlpha";
})($0a7381df9de46ed3$export$3ff975e8f63e458c || ($0a7381df9de46ed3$export$3ff975e8f63e458c = {}));
var $0a7381df9de46ed3$export$1f536085c24cc947 = /** @class */ function() {
    function PNG(pngData) {
        var upng = (0, $f1ca3c277fe35c72$export$2e2bcd8739ae039).decode(pngData);
        var frames = (0, $f1ca3c277fe35c72$export$2e2bcd8739ae039).toRGBA8(upng);
        if (frames.length > 1) throw new Error("Animated PNGs are not supported");
        var frame = new Uint8Array(frames[0]);
        var _a = $0a7381df9de46ed3$var$splitAlphaChannel(frame), rgbChannel = _a.rgbChannel, alphaChannel = _a.alphaChannel;
        this.rgbChannel = rgbChannel;
        var hasAlphaValues = alphaChannel.some(function(a) {
            return a < 255;
        });
        if (hasAlphaValues) this.alphaChannel = alphaChannel;
        this.type = $0a7381df9de46ed3$var$getImageType(upng.ctype);
        this.width = upng.width;
        this.height = upng.height;
        this.bitsPerComponent = 8;
    }
    PNG.load = function(pngData) {
        return new PNG(pngData);
    };
    return PNG;
}();


/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/png.coffee
 */ var $9ba8d611194332cc$var$PngEmbedder = /** @class */ function() {
    function PngEmbedder(png) {
        this.image = png;
        this.bitsPerComponent = png.bitsPerComponent;
        this.width = png.width;
        this.height = png.height;
        this.colorSpace = 'DeviceRGB';
    }
    PngEmbedder.for = function(imageData) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var png;
            return (0, $273XO.__generator)(this, function(_a) {
                png = (0, $0a7381df9de46ed3$export$1f536085c24cc947).load(imageData);
                return [
                    2 /*return*/ ,
                    new PngEmbedder(png)
                ];
            });
        });
    };
    PngEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var SMask, xObject;
            return (0, $273XO.__generator)(this, function(_a) {
                SMask = this.embedAlphaChannel(context);
                xObject = context.flateStream(this.image.rgbChannel, {
                    Type: 'XObject',
                    Subtype: 'Image',
                    BitsPerComponent: this.image.bitsPerComponent,
                    Width: this.image.width,
                    Height: this.image.height,
                    ColorSpace: this.colorSpace,
                    SMask: SMask
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    PngEmbedder.prototype.embedAlphaChannel = function(context) {
        if (!this.image.alphaChannel) return undefined;
        var xObject = context.flateStream(this.image.alphaChannel, {
            Type: 'XObject',
            Subtype: 'Image',
            Height: this.image.height,
            Width: this.image.width,
            BitsPerComponent: this.image.bitsPerComponent,
            ColorSpace: 'DeviceGray',
            Decode: [
                0,
                1
            ]
        });
        return context.register(xObject);
    };
    return PngEmbedder;
}();
var $9ba8d611194332cc$export$2e2bcd8739ae039 = $9ba8d611194332cc$var$PngEmbedder;



var $273XO = parcelRequire("273XO");

var $iMObG = parcelRequire("iMObG");

var $4MKjy = parcelRequire("4MKjy");



var $iMObG = parcelRequire("iMObG");

var $dj8f2 = parcelRequire("dj8f2");


var $alPcq = parcelRequire("alPcq");

var $4MKjy = parcelRequire("4MKjy");
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The Ascii85Stream class contained in this file is a TypeScript port of the
 * JavaScript Ascii85Stream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $273XO = parcelRequire("273XO");

var $iMObG = parcelRequire("iMObG");
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The Stream class contained in this file is a TypeScript port of the
 * JavaScript Stream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ var $93d9b76cd356290c$var$Stream = /** @class */ function() {
    function Stream(buffer, start, length) {
        this.bytes = buffer;
        this.start = start || 0;
        this.pos = this.start;
        this.end = !!start && !!length ? start + length : this.bytes.length;
    }
    Object.defineProperty(Stream.prototype, "length", {
        get: function() {
            return this.end - this.start;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Stream.prototype, "isEmpty", {
        get: function() {
            return this.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Stream.prototype.getByte = function() {
        if (this.pos >= this.end) return -1;
        return this.bytes[this.pos++];
    };
    Stream.prototype.getUint16 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        if (b0 === -1 || b1 === -1) return -1;
        return (b0 << 8) + b1;
    };
    Stream.prototype.getInt32 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        var b2 = this.getByte();
        var b3 = this.getByte();
        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    };
    // Returns subarray of original buffer, should only be read.
    Stream.prototype.getBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.bytes;
        var pos = this.pos;
        var strEnd = this.end;
        if (!length) {
            var subarray = bytes.subarray(pos, strEnd);
            // `this.bytes` is always a `Uint8Array` here.
            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
        } else {
            var end = pos + length;
            if (end > strEnd) end = strEnd;
            this.pos = end;
            var subarray = bytes.subarray(pos, end);
            // `this.bytes` is always a `Uint8Array` here.
            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
        }
    };
    Stream.prototype.peekByte = function() {
        var peekedByte = this.getByte();
        this.pos--;
        return peekedByte;
    };
    Stream.prototype.peekBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.getBytes(length, forceClamped);
        this.pos -= bytes.length;
        return bytes;
    };
    Stream.prototype.skip = function(n) {
        if (!n) n = 1;
        this.pos += n;
    };
    Stream.prototype.reset = function() {
        this.pos = this.start;
    };
    Stream.prototype.moveStart = function() {
        this.start = this.pos;
    };
    Stream.prototype.makeSubStream = function(start, length) {
        return new Stream(this.bytes, start, length);
    };
    Stream.prototype.decode = function() {
        return this.bytes;
    };
    return Stream;
}();
var $93d9b76cd356290c$export$2e2bcd8739ae039 = $93d9b76cd356290c$var$Stream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The DecodeStream class contained in this file is a TypeScript port of the
 * JavaScript DecodeStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ // Lots of DecodeStreams are created whose buffers are never used.  For these
// we share a single empty buffer. This is (a) space-efficient and (b) avoids
// having special cases that would be required if we used |null| for an empty
// buffer.
var $ed179d5b40970452$var$emptyBuffer = new Uint8Array(0);
/**
 * Super class for the decoding streams
 */ var $ed179d5b40970452$var$DecodeStream = /** @class */ function() {
    function DecodeStream(maybeMinBufferLength) {
        this.pos = 0;
        this.bufferLength = 0;
        this.eof = false;
        this.buffer = $ed179d5b40970452$var$emptyBuffer;
        this.minBufferLength = 512;
        if (maybeMinBufferLength) // Compute the first power of two that is as big as maybeMinBufferLength.
        while(this.minBufferLength < maybeMinBufferLength)this.minBufferLength *= 2;
    }
    Object.defineProperty(DecodeStream.prototype, "isEmpty", {
        get: function() {
            while(!this.eof && this.bufferLength === 0)this.readBlock();
            return this.bufferLength === 0;
        },
        enumerable: false,
        configurable: true
    });
    DecodeStream.prototype.getByte = function() {
        var pos = this.pos;
        while(this.bufferLength <= pos){
            if (this.eof) return -1;
            this.readBlock();
        }
        return this.buffer[this.pos++];
    };
    DecodeStream.prototype.getUint16 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        if (b0 === -1 || b1 === -1) return -1;
        return (b0 << 8) + b1;
    };
    DecodeStream.prototype.getInt32 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        var b2 = this.getByte();
        var b3 = this.getByte();
        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    };
    DecodeStream.prototype.getBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var end;
        var pos = this.pos;
        if (length) {
            this.ensureBuffer(pos + length);
            end = pos + length;
            while(!this.eof && this.bufferLength < end)this.readBlock();
            var bufEnd = this.bufferLength;
            if (end > bufEnd) end = bufEnd;
        } else {
            while(!this.eof)this.readBlock();
            end = this.bufferLength;
        }
        this.pos = end;
        var subarray = this.buffer.subarray(pos, end);
        // `this.buffer` is either a `Uint8Array` or `Uint8ClampedArray` here.
        return forceClamped && !(subarray instanceof Uint8ClampedArray) ? new Uint8ClampedArray(subarray) : subarray;
    };
    DecodeStream.prototype.peekByte = function() {
        var peekedByte = this.getByte();
        this.pos--;
        return peekedByte;
    };
    DecodeStream.prototype.peekBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.getBytes(length, forceClamped);
        this.pos -= bytes.length;
        return bytes;
    };
    DecodeStream.prototype.skip = function(n) {
        if (!n) n = 1;
        this.pos += n;
    };
    DecodeStream.prototype.reset = function() {
        this.pos = 0;
    };
    DecodeStream.prototype.makeSubStream = function(start, length /* dict */ ) {
        var end = start + length;
        while(this.bufferLength <= end && !this.eof)this.readBlock();
        return new (0, $93d9b76cd356290c$export$2e2bcd8739ae039)(this.buffer, start, length /* dict */ );
    };
    DecodeStream.prototype.decode = function() {
        while(!this.eof)this.readBlock();
        return this.buffer.subarray(0, this.bufferLength);
    };
    DecodeStream.prototype.readBlock = function() {
        throw new (0, $iMObG.MethodNotImplementedError)(this.constructor.name, 'readBlock');
    };
    DecodeStream.prototype.ensureBuffer = function(requested) {
        var buffer = this.buffer;
        if (requested <= buffer.byteLength) return buffer;
        var size = this.minBufferLength;
        while(size < requested)size *= 2;
        var buffer2 = new Uint8Array(size);
        buffer2.set(buffer);
        return this.buffer = buffer2;
    };
    return DecodeStream;
}();
var $ed179d5b40970452$export$2e2bcd8739ae039 = $ed179d5b40970452$var$DecodeStream;


var $db144d529b2cd7ee$var$isSpace = function(ch) {
    return ch === 0x20 || ch === 0x09 || ch === 0x0d || ch === 0x0a;
};
var $db144d529b2cd7ee$var$Ascii85Stream = /** @class */ function(_super) {
    (0, $273XO.__extends)(Ascii85Stream, _super);
    function Ascii85Stream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.input = new Uint8Array(5);
        // Most streams increase in size when decoded, but Ascii85 streams
        // typically shrink by ~20%.
        if (maybeLength) maybeLength = 0.8 * maybeLength;
        return _this;
    }
    Ascii85Stream.prototype.readBlock = function() {
        var TILDA_CHAR = 0x7e; // '~'
        var Z_LOWER_CHAR = 0x7a; // 'z'
        var EOF = -1;
        var stream = this.stream;
        var c = stream.getByte();
        while($db144d529b2cd7ee$var$isSpace(c))c = stream.getByte();
        if (c === EOF || c === TILDA_CHAR) {
            this.eof = true;
            return;
        }
        var bufferLength = this.bufferLength;
        var buffer;
        var i;
        // special code for z
        if (c === Z_LOWER_CHAR) {
            buffer = this.ensureBuffer(bufferLength + 4);
            for(i = 0; i < 4; ++i)buffer[bufferLength + i] = 0;
            this.bufferLength += 4;
        } else {
            var input = this.input;
            input[0] = c;
            for(i = 1; i < 5; ++i){
                c = stream.getByte();
                while($db144d529b2cd7ee$var$isSpace(c))c = stream.getByte();
                input[i] = c;
                if (c === EOF || c === TILDA_CHAR) break;
            }
            buffer = this.ensureBuffer(bufferLength + i - 1);
            this.bufferLength += i - 1;
            // partial ending;
            if (i < 5) {
                for(; i < 5; ++i)input[i] = 117;
                this.eof = true;
            }
            var t = 0;
            for(i = 0; i < 5; ++i)t = t * 85 + (input[i] - 0x21);
            for(i = 3; i >= 0; --i){
                buffer[bufferLength + i] = t & 0xff;
                t >>= 8;
            }
        }
    };
    return Ascii85Stream;
}((0, $ed179d5b40970452$export$2e2bcd8739ae039));
var $db144d529b2cd7ee$export$2e2bcd8739ae039 = $db144d529b2cd7ee$var$Ascii85Stream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The AsciiHexStream class contained in this file is a TypeScript port of the
 * JavaScript AsciiHexStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $273XO = parcelRequire("273XO");

var $322aa2845b8da531$var$AsciiHexStream = /** @class */ function(_super) {
    (0, $273XO.__extends)(AsciiHexStream, _super);
    function AsciiHexStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.firstDigit = -1;
        // Most streams increase in size when decoded, but AsciiHex streams shrink
        // by 50%.
        if (maybeLength) maybeLength = 0.5 * maybeLength;
        return _this;
    }
    AsciiHexStream.prototype.readBlock = function() {
        var UPSTREAM_BLOCK_SIZE = 8000;
        var bytes = this.stream.getBytes(UPSTREAM_BLOCK_SIZE);
        if (!bytes.length) {
            this.eof = true;
            return;
        }
        var maxDecodeLength = bytes.length + 1 >> 1;
        var buffer = this.ensureBuffer(this.bufferLength + maxDecodeLength);
        var bufferLength = this.bufferLength;
        var firstDigit = this.firstDigit;
        for(var i = 0, ii = bytes.length; i < ii; i++){
            var ch = bytes[i];
            var digit = void 0;
            if (ch >= 0x30 && ch <= 0x39) // '0'-'9'
            digit = ch & 0x0f;
            else if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) // 'A'-'Z', 'a'-'z'
            digit = (ch & 0x0f) + 9;
            else if (ch === 0x3e) {
                // '>'
                this.eof = true;
                break;
            } else continue; // ignoring
            if (firstDigit < 0) firstDigit = digit;
            else {
                buffer[bufferLength++] = firstDigit << 4 | digit;
                firstDigit = -1;
            }
        }
        if (firstDigit >= 0 && this.eof) {
            // incomplete byte
            buffer[bufferLength++] = firstDigit << 4;
            firstDigit = -1;
        }
        this.firstDigit = firstDigit;
        this.bufferLength = bufferLength;
    };
    return AsciiHexStream;
}((0, $ed179d5b40970452$export$2e2bcd8739ae039));
var $322aa2845b8da531$export$2e2bcd8739ae039 = $322aa2845b8da531$var$AsciiHexStream;


/*
 * Copyright 1996-2003 Glyph & Cog, LLC
 *
 * The flate stream implementation contained in this file is a JavaScript port
 * of XPDF's implementation, made available under the Apache 2.0 open source
 * license.
 */ 
var $273XO = parcelRequire("273XO");

// prettier-ignore
var $060c1a225addf752$var$codeLenCodeMap = new Int32Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// prettier-ignore
var $060c1a225addf752$var$lengthDecode = new Int32Array([
    0x00003,
    0x00004,
    0x00005,
    0x00006,
    0x00007,
    0x00008,
    0x00009,
    0x0000a,
    0x1000b,
    0x1000d,
    0x1000f,
    0x10011,
    0x20013,
    0x20017,
    0x2001b,
    0x2001f,
    0x30023,
    0x3002b,
    0x30033,
    0x3003b,
    0x40043,
    0x40053,
    0x40063,
    0x40073,
    0x50083,
    0x500a3,
    0x500c3,
    0x500e3,
    0x00102,
    0x00102,
    0x00102
]);
// prettier-ignore
var $060c1a225addf752$var$distDecode = new Int32Array([
    0x00001,
    0x00002,
    0x00003,
    0x00004,
    0x10005,
    0x10007,
    0x20009,
    0x2000d,
    0x30011,
    0x30019,
    0x40021,
    0x40031,
    0x50041,
    0x50061,
    0x60081,
    0x600c1,
    0x70101,
    0x70181,
    0x80201,
    0x80301,
    0x90401,
    0x90601,
    0xa0801,
    0xa0c01,
    0xb1001,
    0xb1801,
    0xc2001,
    0xc3001,
    0xd4001,
    0xd6001
]);
// prettier-ignore
var $060c1a225addf752$var$fixedLitCodeTab = [
    new Int32Array([
        0x70100,
        0x80050,
        0x80010,
        0x80118,
        0x70110,
        0x80070,
        0x80030,
        0x900c0,
        0x70108,
        0x80060,
        0x80020,
        0x900a0,
        0x80000,
        0x80080,
        0x80040,
        0x900e0,
        0x70104,
        0x80058,
        0x80018,
        0x90090,
        0x70114,
        0x80078,
        0x80038,
        0x900d0,
        0x7010c,
        0x80068,
        0x80028,
        0x900b0,
        0x80008,
        0x80088,
        0x80048,
        0x900f0,
        0x70102,
        0x80054,
        0x80014,
        0x8011c,
        0x70112,
        0x80074,
        0x80034,
        0x900c8,
        0x7010a,
        0x80064,
        0x80024,
        0x900a8,
        0x80004,
        0x80084,
        0x80044,
        0x900e8,
        0x70106,
        0x8005c,
        0x8001c,
        0x90098,
        0x70116,
        0x8007c,
        0x8003c,
        0x900d8,
        0x7010e,
        0x8006c,
        0x8002c,
        0x900b8,
        0x8000c,
        0x8008c,
        0x8004c,
        0x900f8,
        0x70101,
        0x80052,
        0x80012,
        0x8011a,
        0x70111,
        0x80072,
        0x80032,
        0x900c4,
        0x70109,
        0x80062,
        0x80022,
        0x900a4,
        0x80002,
        0x80082,
        0x80042,
        0x900e4,
        0x70105,
        0x8005a,
        0x8001a,
        0x90094,
        0x70115,
        0x8007a,
        0x8003a,
        0x900d4,
        0x7010d,
        0x8006a,
        0x8002a,
        0x900b4,
        0x8000a,
        0x8008a,
        0x8004a,
        0x900f4,
        0x70103,
        0x80056,
        0x80016,
        0x8011e,
        0x70113,
        0x80076,
        0x80036,
        0x900cc,
        0x7010b,
        0x80066,
        0x80026,
        0x900ac,
        0x80006,
        0x80086,
        0x80046,
        0x900ec,
        0x70107,
        0x8005e,
        0x8001e,
        0x9009c,
        0x70117,
        0x8007e,
        0x8003e,
        0x900dc,
        0x7010f,
        0x8006e,
        0x8002e,
        0x900bc,
        0x8000e,
        0x8008e,
        0x8004e,
        0x900fc,
        0x70100,
        0x80051,
        0x80011,
        0x80119,
        0x70110,
        0x80071,
        0x80031,
        0x900c2,
        0x70108,
        0x80061,
        0x80021,
        0x900a2,
        0x80001,
        0x80081,
        0x80041,
        0x900e2,
        0x70104,
        0x80059,
        0x80019,
        0x90092,
        0x70114,
        0x80079,
        0x80039,
        0x900d2,
        0x7010c,
        0x80069,
        0x80029,
        0x900b2,
        0x80009,
        0x80089,
        0x80049,
        0x900f2,
        0x70102,
        0x80055,
        0x80015,
        0x8011d,
        0x70112,
        0x80075,
        0x80035,
        0x900ca,
        0x7010a,
        0x80065,
        0x80025,
        0x900aa,
        0x80005,
        0x80085,
        0x80045,
        0x900ea,
        0x70106,
        0x8005d,
        0x8001d,
        0x9009a,
        0x70116,
        0x8007d,
        0x8003d,
        0x900da,
        0x7010e,
        0x8006d,
        0x8002d,
        0x900ba,
        0x8000d,
        0x8008d,
        0x8004d,
        0x900fa,
        0x70101,
        0x80053,
        0x80013,
        0x8011b,
        0x70111,
        0x80073,
        0x80033,
        0x900c6,
        0x70109,
        0x80063,
        0x80023,
        0x900a6,
        0x80003,
        0x80083,
        0x80043,
        0x900e6,
        0x70105,
        0x8005b,
        0x8001b,
        0x90096,
        0x70115,
        0x8007b,
        0x8003b,
        0x900d6,
        0x7010d,
        0x8006b,
        0x8002b,
        0x900b6,
        0x8000b,
        0x8008b,
        0x8004b,
        0x900f6,
        0x70103,
        0x80057,
        0x80017,
        0x8011f,
        0x70113,
        0x80077,
        0x80037,
        0x900ce,
        0x7010b,
        0x80067,
        0x80027,
        0x900ae,
        0x80007,
        0x80087,
        0x80047,
        0x900ee,
        0x70107,
        0x8005f,
        0x8001f,
        0x9009e,
        0x70117,
        0x8007f,
        0x8003f,
        0x900de,
        0x7010f,
        0x8006f,
        0x8002f,
        0x900be,
        0x8000f,
        0x8008f,
        0x8004f,
        0x900fe,
        0x70100,
        0x80050,
        0x80010,
        0x80118,
        0x70110,
        0x80070,
        0x80030,
        0x900c1,
        0x70108,
        0x80060,
        0x80020,
        0x900a1,
        0x80000,
        0x80080,
        0x80040,
        0x900e1,
        0x70104,
        0x80058,
        0x80018,
        0x90091,
        0x70114,
        0x80078,
        0x80038,
        0x900d1,
        0x7010c,
        0x80068,
        0x80028,
        0x900b1,
        0x80008,
        0x80088,
        0x80048,
        0x900f1,
        0x70102,
        0x80054,
        0x80014,
        0x8011c,
        0x70112,
        0x80074,
        0x80034,
        0x900c9,
        0x7010a,
        0x80064,
        0x80024,
        0x900a9,
        0x80004,
        0x80084,
        0x80044,
        0x900e9,
        0x70106,
        0x8005c,
        0x8001c,
        0x90099,
        0x70116,
        0x8007c,
        0x8003c,
        0x900d9,
        0x7010e,
        0x8006c,
        0x8002c,
        0x900b9,
        0x8000c,
        0x8008c,
        0x8004c,
        0x900f9,
        0x70101,
        0x80052,
        0x80012,
        0x8011a,
        0x70111,
        0x80072,
        0x80032,
        0x900c5,
        0x70109,
        0x80062,
        0x80022,
        0x900a5,
        0x80002,
        0x80082,
        0x80042,
        0x900e5,
        0x70105,
        0x8005a,
        0x8001a,
        0x90095,
        0x70115,
        0x8007a,
        0x8003a,
        0x900d5,
        0x7010d,
        0x8006a,
        0x8002a,
        0x900b5,
        0x8000a,
        0x8008a,
        0x8004a,
        0x900f5,
        0x70103,
        0x80056,
        0x80016,
        0x8011e,
        0x70113,
        0x80076,
        0x80036,
        0x900cd,
        0x7010b,
        0x80066,
        0x80026,
        0x900ad,
        0x80006,
        0x80086,
        0x80046,
        0x900ed,
        0x70107,
        0x8005e,
        0x8001e,
        0x9009d,
        0x70117,
        0x8007e,
        0x8003e,
        0x900dd,
        0x7010f,
        0x8006e,
        0x8002e,
        0x900bd,
        0x8000e,
        0x8008e,
        0x8004e,
        0x900fd,
        0x70100,
        0x80051,
        0x80011,
        0x80119,
        0x70110,
        0x80071,
        0x80031,
        0x900c3,
        0x70108,
        0x80061,
        0x80021,
        0x900a3,
        0x80001,
        0x80081,
        0x80041,
        0x900e3,
        0x70104,
        0x80059,
        0x80019,
        0x90093,
        0x70114,
        0x80079,
        0x80039,
        0x900d3,
        0x7010c,
        0x80069,
        0x80029,
        0x900b3,
        0x80009,
        0x80089,
        0x80049,
        0x900f3,
        0x70102,
        0x80055,
        0x80015,
        0x8011d,
        0x70112,
        0x80075,
        0x80035,
        0x900cb,
        0x7010a,
        0x80065,
        0x80025,
        0x900ab,
        0x80005,
        0x80085,
        0x80045,
        0x900eb,
        0x70106,
        0x8005d,
        0x8001d,
        0x9009b,
        0x70116,
        0x8007d,
        0x8003d,
        0x900db,
        0x7010e,
        0x8006d,
        0x8002d,
        0x900bb,
        0x8000d,
        0x8008d,
        0x8004d,
        0x900fb,
        0x70101,
        0x80053,
        0x80013,
        0x8011b,
        0x70111,
        0x80073,
        0x80033,
        0x900c7,
        0x70109,
        0x80063,
        0x80023,
        0x900a7,
        0x80003,
        0x80083,
        0x80043,
        0x900e7,
        0x70105,
        0x8005b,
        0x8001b,
        0x90097,
        0x70115,
        0x8007b,
        0x8003b,
        0x900d7,
        0x7010d,
        0x8006b,
        0x8002b,
        0x900b7,
        0x8000b,
        0x8008b,
        0x8004b,
        0x900f7,
        0x70103,
        0x80057,
        0x80017,
        0x8011f,
        0x70113,
        0x80077,
        0x80037,
        0x900cf,
        0x7010b,
        0x80067,
        0x80027,
        0x900af,
        0x80007,
        0x80087,
        0x80047,
        0x900ef,
        0x70107,
        0x8005f,
        0x8001f,
        0x9009f,
        0x70117,
        0x8007f,
        0x8003f,
        0x900df,
        0x7010f,
        0x8006f,
        0x8002f,
        0x900bf,
        0x8000f,
        0x8008f,
        0x8004f,
        0x900ff
    ]),
    9
];
// prettier-ignore
var $060c1a225addf752$var$fixedDistCodeTab = [
    new Int32Array([
        0x50000,
        0x50010,
        0x50008,
        0x50018,
        0x50004,
        0x50014,
        0x5000c,
        0x5001c,
        0x50002,
        0x50012,
        0x5000a,
        0x5001a,
        0x50006,
        0x50016,
        0x5000e,
        0x00000,
        0x50001,
        0x50011,
        0x50009,
        0x50019,
        0x50005,
        0x50015,
        0x5000d,
        0x5001d,
        0x50003,
        0x50013,
        0x5000b,
        0x5001b,
        0x50007,
        0x50017,
        0x5000f,
        0x00000
    ]),
    5
];
var $060c1a225addf752$var$FlateStream = /** @class */ function(_super) {
    (0, $273XO.__extends)(FlateStream, _super);
    function FlateStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        var cmf = stream.getByte();
        var flg = stream.getByte();
        if (cmf === -1 || flg === -1) throw new Error("Invalid header in flate stream: " + cmf + ", " + flg);
        if ((cmf & 0x0f) !== 0x08) throw new Error("Unknown compression method in flate stream: " + cmf + ", " + flg);
        if (((cmf << 8) + flg) % 31 !== 0) throw new Error("Bad FCHECK in flate stream: " + cmf + ", " + flg);
        if (flg & 0x20) throw new Error("FDICT bit set in flate stream: " + cmf + ", " + flg);
        _this.codeSize = 0;
        _this.codeBuf = 0;
        return _this;
    }
    FlateStream.prototype.readBlock = function() {
        var buffer;
        var len;
        var str = this.stream;
        // read block header
        var hdr = this.getBits(3);
        if (hdr & 1) this.eof = true;
        hdr >>= 1;
        if (hdr === 0) {
            // uncompressed block
            var b = void 0;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            var blockLen = b;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            blockLen |= b << 8;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            var check = b;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            check |= b << 8;
            if (check !== (~blockLen & 0xffff) && (blockLen !== 0 || check !== 0)) // Ignoring error for bad "empty" block (see issue 1277)
            throw new Error('Bad uncompressed block length in flate stream');
            this.codeBuf = 0;
            this.codeSize = 0;
            var bufferLength = this.bufferLength;
            buffer = this.ensureBuffer(bufferLength + blockLen);
            var end = bufferLength + blockLen;
            this.bufferLength = end;
            if (blockLen === 0) {
                if (str.peekByte() === -1) this.eof = true;
            } else for(var n = bufferLength; n < end; ++n){
                if ((b = str.getByte()) === -1) {
                    this.eof = true;
                    break;
                }
                buffer[n] = b;
            }
            return;
        }
        var litCodeTable;
        var distCodeTable;
        if (hdr === 1) {
            // compressed block, fixed codes
            litCodeTable = $060c1a225addf752$var$fixedLitCodeTab;
            distCodeTable = $060c1a225addf752$var$fixedDistCodeTab;
        } else if (hdr === 2) {
            // compressed block, dynamic codes
            var numLitCodes = this.getBits(5) + 257;
            var numDistCodes = this.getBits(5) + 1;
            var numCodeLenCodes = this.getBits(4) + 4;
            // build the code lengths code table
            var codeLenCodeLengths = new Uint8Array($060c1a225addf752$var$codeLenCodeMap.length);
            var i = void 0;
            for(i = 0; i < numCodeLenCodes; ++i)codeLenCodeLengths[$060c1a225addf752$var$codeLenCodeMap[i]] = this.getBits(3);
            var codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);
            // build the literal and distance code tables
            len = 0;
            i = 0;
            var codes = numLitCodes + numDistCodes;
            var codeLengths = new Uint8Array(codes);
            var bitsLength = void 0;
            var bitsOffset = void 0;
            var what = void 0;
            while(i < codes){
                var code = this.getCode(codeLenCodeTab);
                if (code === 16) {
                    bitsLength = 2;
                    bitsOffset = 3;
                    what = len;
                } else if (code === 17) {
                    bitsLength = 3;
                    bitsOffset = 3;
                    what = len = 0;
                } else if (code === 18) {
                    bitsLength = 7;
                    bitsOffset = 11;
                    what = len = 0;
                } else {
                    codeLengths[i++] = len = code;
                    continue;
                }
                var repeatLength = this.getBits(bitsLength) + bitsOffset;
                while(repeatLength-- > 0)codeLengths[i++] = what;
            }
            litCodeTable = this.generateHuffmanTable(codeLengths.subarray(0, numLitCodes));
            distCodeTable = this.generateHuffmanTable(codeLengths.subarray(numLitCodes, codes));
        } else throw new Error('Unknown block type in flate stream');
        buffer = this.buffer;
        var limit = buffer ? buffer.length : 0;
        var pos = this.bufferLength;
        while(true){
            var code1 = this.getCode(litCodeTable);
            if (code1 < 256) {
                if (pos + 1 >= limit) {
                    buffer = this.ensureBuffer(pos + 1);
                    limit = buffer.length;
                }
                buffer[pos++] = code1;
                continue;
            }
            if (code1 === 256) {
                this.bufferLength = pos;
                return;
            }
            code1 -= 257;
            code1 = $060c1a225addf752$var$lengthDecode[code1];
            var code2 = code1 >> 16;
            if (code2 > 0) code2 = this.getBits(code2);
            len = (code1 & 0xffff) + code2;
            code1 = this.getCode(distCodeTable);
            code1 = $060c1a225addf752$var$distDecode[code1];
            code2 = code1 >> 16;
            if (code2 > 0) code2 = this.getBits(code2);
            var dist = (code1 & 0xffff) + code2;
            if (pos + len >= limit) {
                buffer = this.ensureBuffer(pos + len);
                limit = buffer.length;
            }
            for(var k = 0; k < len; ++k, ++pos)buffer[pos] = buffer[pos - dist];
        }
    };
    FlateStream.prototype.getBits = function(bits) {
        var str = this.stream;
        var codeSize = this.codeSize;
        var codeBuf = this.codeBuf;
        var b;
        while(codeSize < bits){
            if ((b = str.getByte()) === -1) throw new Error('Bad encoding in flate stream');
            codeBuf |= b << codeSize;
            codeSize += 8;
        }
        b = codeBuf & (1 << bits) - 1;
        this.codeBuf = codeBuf >> bits;
        this.codeSize = codeSize -= bits;
        return b;
    };
    FlateStream.prototype.getCode = function(table) {
        var str = this.stream;
        var codes = table[0];
        var maxLen = table[1];
        var codeSize = this.codeSize;
        var codeBuf = this.codeBuf;
        var b;
        while(codeSize < maxLen){
            if ((b = str.getByte()) === -1) break;
            codeBuf |= b << codeSize;
            codeSize += 8;
        }
        var code = codes[codeBuf & (1 << maxLen) - 1];
        if (typeof codes === 'number') console.log('FLATE:', code);
        var codeLen = code >> 16;
        var codeVal = code & 0xffff;
        if (codeLen < 1 || codeSize < codeLen) throw new Error('Bad encoding in flate stream');
        this.codeBuf = codeBuf >> codeLen;
        this.codeSize = codeSize - codeLen;
        return codeVal;
    };
    FlateStream.prototype.generateHuffmanTable = function(lengths) {
        var n = lengths.length;
        // find max code length
        var maxLen = 0;
        var i;
        for(i = 0; i < n; ++i)if (lengths[i] > maxLen) maxLen = lengths[i];
        // build the table
        var size = 1 << maxLen;
        var codes = new Int32Array(size);
        for(var len = 1, code = 0, skip = 2; len <= maxLen; ++len, code <<= 1, skip <<= 1){
            for(var val = 0; val < n; ++val)if (lengths[val] === len) {
                // bit-reverse the code
                var code2 = 0;
                var t = code;
                for(i = 0; i < len; ++i){
                    code2 = code2 << 1 | t & 1;
                    t >>= 1;
                }
                // fill the table entries
                for(i = code2; i < size; i += skip)codes[i] = len << 16 | val;
                ++code;
            }
        }
        return [
            codes,
            maxLen
        ];
    };
    return FlateStream;
}((0, $ed179d5b40970452$export$2e2bcd8739ae039));
var $060c1a225addf752$export$2e2bcd8739ae039 = $060c1a225addf752$var$FlateStream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The LZWStream class contained in this file is a TypeScript port of the
 * JavaScript LZWStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $273XO = parcelRequire("273XO");

var $b9e70f146626b9f5$var$LZWStream = /** @class */ function(_super) {
    (0, $273XO.__extends)(LZWStream, _super);
    function LZWStream(stream, maybeLength, earlyChange) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.cachedData = 0;
        _this.bitsCached = 0;
        var maxLzwDictionarySize = 4096;
        var lzwState = {
            earlyChange: earlyChange,
            codeLength: 9,
            nextCode: 258,
            dictionaryValues: new Uint8Array(maxLzwDictionarySize),
            dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
            dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
            currentSequence: new Uint8Array(maxLzwDictionarySize),
            currentSequenceLength: 0
        };
        for(var i = 0; i < 256; ++i){
            lzwState.dictionaryValues[i] = i;
            lzwState.dictionaryLengths[i] = 1;
        }
        _this.lzwState = lzwState;
        return _this;
    }
    LZWStream.prototype.readBlock = function() {
        var blockSize = 512;
        var estimatedDecodedSize = blockSize * 2;
        var decodedSizeDelta = blockSize;
        var i;
        var j;
        var q;
        var lzwState = this.lzwState;
        if (!lzwState) return; // eof was found
        var earlyChange = lzwState.earlyChange;
        var nextCode = lzwState.nextCode;
        var dictionaryValues = lzwState.dictionaryValues;
        var dictionaryLengths = lzwState.dictionaryLengths;
        var dictionaryPrevCodes = lzwState.dictionaryPrevCodes;
        var codeLength = lzwState.codeLength;
        var prevCode = lzwState.prevCode;
        var currentSequence = lzwState.currentSequence;
        var currentSequenceLength = lzwState.currentSequenceLength;
        var decodedLength = 0;
        var currentBufferLength = this.bufferLength;
        var buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
        for(i = 0; i < blockSize; i++){
            var code = this.readBits(codeLength);
            var hasPrev = currentSequenceLength > 0;
            if (!code || code < 256) {
                currentSequence[0] = code;
                currentSequenceLength = 1;
            } else if (code >= 258) {
                if (code < nextCode) {
                    currentSequenceLength = dictionaryLengths[code];
                    for(j = currentSequenceLength - 1, q = code; j >= 0; j--){
                        currentSequence[j] = dictionaryValues[q];
                        q = dictionaryPrevCodes[q];
                    }
                } else currentSequence[currentSequenceLength++] = currentSequence[0];
            } else if (code === 256) {
                codeLength = 9;
                nextCode = 258;
                currentSequenceLength = 0;
                continue;
            } else {
                this.eof = true;
                delete this.lzwState;
                break;
            }
            if (hasPrev) {
                dictionaryPrevCodes[nextCode] = prevCode;
                dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
                dictionaryValues[nextCode] = currentSequence[0];
                nextCode++;
                codeLength = nextCode + earlyChange & nextCode + earlyChange - 1 ? codeLength : Math.min(Math.log(nextCode + earlyChange) / 0.6931471805599453 + 1, 12) | 0;
            }
            prevCode = code;
            decodedLength += currentSequenceLength;
            if (estimatedDecodedSize < decodedLength) {
                do estimatedDecodedSize += decodedSizeDelta;
                while (estimatedDecodedSize < decodedLength);
                buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
            }
            for(j = 0; j < currentSequenceLength; j++)buffer[currentBufferLength++] = currentSequence[j];
        }
        lzwState.nextCode = nextCode;
        lzwState.codeLength = codeLength;
        lzwState.prevCode = prevCode;
        lzwState.currentSequenceLength = currentSequenceLength;
        this.bufferLength = currentBufferLength;
    };
    LZWStream.prototype.readBits = function(n) {
        var bitsCached = this.bitsCached;
        var cachedData = this.cachedData;
        while(bitsCached < n){
            var c = this.stream.getByte();
            if (c === -1) {
                this.eof = true;
                return null;
            }
            cachedData = cachedData << 8 | c;
            bitsCached += 8;
        }
        this.bitsCached = bitsCached -= n;
        this.cachedData = cachedData;
        return cachedData >>> bitsCached & (1 << n) - 1;
    };
    return LZWStream;
}((0, $ed179d5b40970452$export$2e2bcd8739ae039));
var $b9e70f146626b9f5$export$2e2bcd8739ae039 = $b9e70f146626b9f5$var$LZWStream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The RunLengthStream class contained in this file is a TypeScript port of the
 * JavaScript RunLengthStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $273XO = parcelRequire("273XO");

var $005d7d95b71b8e8a$var$RunLengthStream = /** @class */ function(_super) {
    (0, $273XO.__extends)(RunLengthStream, _super);
    function RunLengthStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        return _this;
    }
    RunLengthStream.prototype.readBlock = function() {
        // The repeatHeader has following format. The first byte defines type of run
        // and amount of bytes to repeat/copy: n = 0 through 127 - copy next n bytes
        // (in addition to the second byte from the header), n = 129 through 255 -
        // duplicate the second byte from the header (257 - n) times, n = 128 - end.
        var repeatHeader = this.stream.getBytes(2);
        if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
            this.eof = true;
            return;
        }
        var buffer;
        var bufferLength = this.bufferLength;
        var n = repeatHeader[0];
        if (n < 128) {
            // copy n bytes
            buffer = this.ensureBuffer(bufferLength + n + 1);
            buffer[bufferLength++] = repeatHeader[1];
            if (n > 0) {
                var source = this.stream.getBytes(n);
                buffer.set(source, bufferLength);
                bufferLength += n;
            }
        } else {
            n = 257 - n;
            var b = repeatHeader[1];
            buffer = this.ensureBuffer(bufferLength + n + 1);
            for(var i = 0; i < n; i++)buffer[bufferLength++] = b;
        }
        this.bufferLength = bufferLength;
    };
    return RunLengthStream;
}((0, $ed179d5b40970452$export$2e2bcd8739ae039));
var $005d7d95b71b8e8a$export$2e2bcd8739ae039 = $005d7d95b71b8e8a$var$RunLengthStream;



var $39824019df04b477$var$decodeStream = function(stream, encoding, params) {
    if (encoding === (0, $alPcq.default).of('FlateDecode')) return new (0, $060c1a225addf752$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $alPcq.default).of('LZWDecode')) {
        var earlyChange = 1;
        if (params instanceof (0, $b7e75d63d5628aec$export$2e2bcd8739ae039)) {
            var EarlyChange = params.lookup((0, $alPcq.default).of('EarlyChange'));
            if (EarlyChange instanceof (0, $4MKjy.default)) earlyChange = EarlyChange.asNumber();
        }
        return new (0, $b9e70f146626b9f5$export$2e2bcd8739ae039)(stream, undefined, earlyChange);
    }
    if (encoding === (0, $alPcq.default).of('ASCII85Decode')) return new (0, $db144d529b2cd7ee$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $alPcq.default).of('ASCIIHexDecode')) return new (0, $322aa2845b8da531$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $alPcq.default).of('RunLengthDecode')) return new (0, $005d7d95b71b8e8a$export$2e2bcd8739ae039)(stream);
    throw new (0, $iMObG.UnsupportedEncodingError)(encoding.asString());
};
var $39824019df04b477$export$b8317e68ca978594 = function(_a) {
    var dict = _a.dict, contents = _a.contents;
    var stream = new (0, $93d9b76cd356290c$export$2e2bcd8739ae039)(contents);
    var Filter = dict.lookup((0, $alPcq.default).of('Filter'));
    var DecodeParms = dict.lookup((0, $alPcq.default).of('DecodeParms'));
    if (Filter instanceof (0, $alPcq.default)) stream = $39824019df04b477$var$decodeStream(stream, Filter, DecodeParms);
    else if (Filter instanceof (0, $dj8f2.default)) for(var idx = 0, len = Filter.size(); idx < len; idx++)stream = $39824019df04b477$var$decodeStream(stream, Filter.lookup(idx, (0, $alPcq.default)), DecodeParms && DecodeParms.lookupMaybe(idx, (0, $b7e75d63d5628aec$export$2e2bcd8739ae039)));
    else if (!!Filter) throw new (0, $iMObG.UnexpectedObjectTypeError)([
        (0, $alPcq.default),
        (0, $dj8f2.default)
    ], Filter);
    return stream;
};




var $8KH3B = parcelRequire("8KH3B");
parcelRequire("5bpFt");
var $a9yd5 = parcelRequire("a9yd5");
var $fe3ada739436b861$var$fullPageBoundingBox = function(page) {
    var mediaBox = page.MediaBox();
    var width = mediaBox.lookup(2, (0, $4MKjy.default)).asNumber() - mediaBox.lookup(0, (0, $4MKjy.default)).asNumber();
    var height = mediaBox.lookup(3, (0, $4MKjy.default)).asNumber() - mediaBox.lookup(1, (0, $4MKjy.default)).asNumber();
    return {
        left: 0,
        bottom: 0,
        right: width,
        top: height
    };
};
// Returns the identity matrix, modified to position the content of the given
// bounding box at (0, 0).
var $fe3ada739436b861$var$boundingBoxAdjustedMatrix = function(bb) {
    return [
        1,
        0,
        0,
        1,
        -bb.left,
        -bb.bottom
    ];
};
var $fe3ada739436b861$var$PDFPageEmbedder = /** @class */ function() {
    function PDFPageEmbedder(page, boundingBox, transformationMatrix) {
        this.page = page;
        var bb = boundingBox !== null && boundingBox !== void 0 ? boundingBox : $fe3ada739436b861$var$fullPageBoundingBox(page);
        this.width = bb.right - bb.left;
        this.height = bb.top - bb.bottom;
        this.boundingBox = bb;
        this.transformationMatrix = transformationMatrix !== null && transformationMatrix !== void 0 ? transformationMatrix : $fe3ada739436b861$var$boundingBoxAdjustedMatrix(bb);
    }
    PDFPageEmbedder.for = function(page, boundingBox, transformationMatrix) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            return (0, $273XO.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new PDFPageEmbedder(page, boundingBox, transformationMatrix)
                ];
            });
        });
    };
    PDFPageEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var _a, Contents, Resources, decodedContents, _b, left, bottom, right, top, xObject;
            return (0, $273XO.__generator)(this, function(_c) {
                _a = this.page.normalizedEntries(), Contents = _a.Contents, Resources = _a.Resources;
                if (!Contents) throw new (0, $iMObG.MissingPageContentsEmbeddingError)();
                decodedContents = this.decodeContents(Contents);
                _b = this.boundingBox, left = _b.left, bottom = _b.bottom, right = _b.right, top = _b.top;
                xObject = context.flateStream(decodedContents, {
                    Type: 'XObject',
                    Subtype: 'Form',
                    FormType: 1,
                    BBox: [
                        left,
                        bottom,
                        right,
                        top
                    ],
                    Matrix: this.transformationMatrix,
                    Resources: Resources
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    // `contents` is an array of streams which are merged to include them in the XObject.
    // This methods extracts each stream and joins them with a newline character.
    PDFPageEmbedder.prototype.decodeContents = function(contents) {
        var newline = Uint8Array.of((0, $8KH3B.default).Newline);
        var decodedContents = [];
        for(var idx = 0, len = contents.size(); idx < len; idx++){
            var stream = contents.lookup(idx, (0, $c444ed3a6bfbd846$export$2e2bcd8739ae039));
            var content = void 0;
            if (stream instanceof (0, $2f4afe25c4da346a$export$2e2bcd8739ae039)) content = (0, $39824019df04b477$export$b8317e68ca978594)(stream).decode();
            else if (stream instanceof (0, $76f7b8adb556b72e$export$2e2bcd8739ae039)) content = stream.getUnencodedContents();
            else throw new (0, $iMObG.UnrecognizedStreamTypeError)(stream);
            decodedContents.push(content, newline);
        }
        return (0, $a9yd5.mergeIntoTypedArray).apply(void 0, decodedContents);
    };
    return PDFPageEmbedder;
}();
var $fe3ada739436b861$export$2e2bcd8739ae039 = $fe3ada739436b861$var$PDFPageEmbedder;



var $dvdsW = parcelRequire("dvdsW");

var $eKLLF = parcelRequire("eKLLF");

var $63sxC = parcelRequire("63sxC");

var $4MKjy = parcelRequire("4MKjy");



var $alPcq = parcelRequire("alPcq");


var $dj8f2 = parcelRequire("dj8f2");






var $273XO = parcelRequire("273XO");


var $alPcq = parcelRequire("alPcq");

var $273XO = parcelRequire("273XO");



var $dj8f2 = parcelRequire("dj8f2");

var $alPcq = parcelRequire("alPcq");

var $273XO = parcelRequire("273XO");


var $alPcq = parcelRequire("alPcq");




var $alPcq = parcelRequire("alPcq");

var $4MKjy = parcelRequire("4MKjy");

var $dj8f2 = parcelRequire("dj8f2");

parcelRequire("5bpFt");
var $8hWZH = parcelRequire("8hWZH");

var $iMObG = parcelRequire("iMObG");
// Examples:
//   `/Helv 12 Tf` -> ['Helv', '12']
//   `/HeBo 8.00 Tf` -> ['HeBo', '8.00']
//   `/HeBo Tf` -> ['HeBo', undefined]
var $6bdaa445abd1ddb7$var$tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+Tf/;
var $6bdaa445abd1ddb7$var$PDFAcroField = /** @class */ function() {
    function PDFAcroField(dict, ref) {
        this.dict = dict;
        this.ref = ref;
    }
    PDFAcroField.prototype.T = function() {
        return this.dict.lookupMaybe((0, $alPcq.default).of('T'), (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039), (0, $d8f6d7884257882d$export$2e2bcd8739ae039));
    };
    PDFAcroField.prototype.Ff = function() {
        var numberOrRef = this.getInheritableAttribute((0, $alPcq.default).of('Ff'));
        return this.dict.context.lookupMaybe(numberOrRef, (0, $4MKjy.default));
    };
    PDFAcroField.prototype.V = function() {
        var valueOrRef = this.getInheritableAttribute((0, $alPcq.default).of('V'));
        return this.dict.context.lookup(valueOrRef);
    };
    PDFAcroField.prototype.Kids = function() {
        return this.dict.lookupMaybe((0, $alPcq.default).of('Kids'), (0, $dj8f2.default));
    };
    // Parent(): PDFDict | undefined {
    //   return this.dict.lookupMaybe(PDFName.of('Parent'), PDFDict);
    // }
    PDFAcroField.prototype.DA = function() {
        var da = this.dict.lookup((0, $alPcq.default).of('DA'));
        if (da instanceof (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039) || da instanceof (0, $d8f6d7884257882d$export$2e2bcd8739ae039)) return da;
        return undefined;
    };
    PDFAcroField.prototype.setKids = function(kids) {
        this.dict.set((0, $alPcq.default).of('Kids'), this.dict.context.obj(kids));
    };
    PDFAcroField.prototype.getParent = function() {
        // const parent = this.Parent();
        // if (!parent) return undefined;
        // return new PDFAcroField(parent);
        var parentRef = this.dict.get((0, $alPcq.default).of('Parent'));
        if (parentRef instanceof (0, $69d09480b29248e9$export$2e2bcd8739ae039)) {
            var parent_1 = this.dict.lookup((0, $alPcq.default).of('Parent'), (0, $b7e75d63d5628aec$export$2e2bcd8739ae039));
            return new PDFAcroField(parent_1, parentRef);
        }
        return undefined;
    };
    PDFAcroField.prototype.setParent = function(parent) {
        if (!parent) this.dict.delete((0, $alPcq.default).of('Parent'));
        else this.dict.set((0, $alPcq.default).of('Parent'), parent);
    };
    PDFAcroField.prototype.getFullyQualifiedName = function() {
        var parent = this.getParent();
        if (!parent) return this.getPartialName();
        return parent.getFullyQualifiedName() + "." + this.getPartialName();
    };
    PDFAcroField.prototype.getPartialName = function() {
        var _a;
        return (_a = this.T()) === null || _a === void 0 ? void 0 : _a.decodeText();
    };
    PDFAcroField.prototype.setPartialName = function(partialName) {
        if (!partialName) this.dict.delete((0, $alPcq.default).of('T'));
        else this.dict.set((0, $alPcq.default).of('T'), (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(partialName));
    };
    PDFAcroField.prototype.setDefaultAppearance = function(appearance) {
        this.dict.set((0, $alPcq.default).of('DA'), (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039).of(appearance));
    };
    PDFAcroField.prototype.getDefaultAppearance = function() {
        var DA = this.DA();
        if (DA instanceof (0, $d8f6d7884257882d$export$2e2bcd8739ae039)) return DA.decodeText();
        return DA === null || DA === void 0 ? void 0 : DA.asString();
    };
    PDFAcroField.prototype.setFontSize = function(fontSize) {
        var _a;
        var name = (_a = this.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : '';
        var da = this.getDefaultAppearance();
        if (!da) throw new (0, $iMObG.MissingDAEntryError)(name);
        var daMatch = (0, $8hWZH.findLastMatch)(da, $6bdaa445abd1ddb7$var$tfRegex);
        if (!daMatch.match) throw new (0, $iMObG.MissingTfOperatorError)(name);
        var daStart = da.slice(0, daMatch.pos - daMatch.match[0].length);
        var daEnd = daMatch.pos <= da.length ? da.slice(daMatch.pos) : '';
        var fontName = daMatch.match[1];
        var modifiedDa = daStart + " /" + fontName + " " + fontSize + " Tf " + daEnd;
        this.setDefaultAppearance(modifiedDa);
    };
    PDFAcroField.prototype.getFlags = function() {
        var _a, _b;
        return (_b = (_a = this.Ff()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
    };
    PDFAcroField.prototype.setFlags = function(flags) {
        this.dict.set((0, $alPcq.default).of('Ff'), (0, $4MKjy.default).of(flags));
    };
    PDFAcroField.prototype.hasFlag = function(flag) {
        var flags = this.getFlags();
        return (flags & flag) !== 0;
    };
    PDFAcroField.prototype.setFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags | flag);
    };
    PDFAcroField.prototype.clearFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags & ~flag);
    };
    PDFAcroField.prototype.setFlagTo = function(flag, enable) {
        if (enable) this.setFlag(flag);
        else this.clearFlag(flag);
    };
    PDFAcroField.prototype.getInheritableAttribute = function(name) {
        var attribute;
        this.ascend(function(node) {
            if (!attribute) attribute = node.dict.get(name);
        });
        return attribute;
    };
    PDFAcroField.prototype.ascend = function(visitor) {
        visitor(this);
        var parent = this.getParent();
        if (parent) parent.ascend(visitor);
    };
    return PDFAcroField;
}();
var $6bdaa445abd1ddb7$export$2e2bcd8739ae039 = $6bdaa445abd1ddb7$var$PDFAcroField;



var $273XO = parcelRequire("273XO");


var $alPcq = parcelRequire("alPcq");




var $alPcq = parcelRequire("alPcq");

var $4MKjy = parcelRequire("4MKjy");
// TODO: Also handle the `/S` and `/D` entries
var $c75d3922c7f92d11$var$BorderStyle = /** @class */ function() {
    function BorderStyle(dict) {
        this.dict = dict;
    }
    BorderStyle.prototype.W = function() {
        var W = this.dict.lookup((0, $alPcq.default).of('W'));
        if (W instanceof (0, $4MKjy.default)) return W;
        return undefined;
    };
    BorderStyle.prototype.getWidth = function() {
        var _a, _b;
        return (_b = (_a = this.W()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
    };
    BorderStyle.prototype.setWidth = function(width) {
        var W = this.dict.context.obj(width);
        this.dict.set((0, $alPcq.default).of('W'), W);
    };
    BorderStyle.fromDict = function(dict) {
        return new BorderStyle(dict);
    };
    return BorderStyle;
}();
var $c75d3922c7f92d11$export$2e2bcd8739ae039 = $c75d3922c7f92d11$var$BorderStyle;




var $alPcq = parcelRequire("alPcq");


var $dj8f2 = parcelRequire("dj8f2");


var $4MKjy = parcelRequire("4MKjy");
var $efad75441f9151be$var$PDFAnnotation = /** @class */ function() {
    function PDFAnnotation(dict) {
        this.dict = dict;
    }
    // This is technically required by the PDF spec
    PDFAnnotation.prototype.Rect = function() {
        return this.dict.lookup((0, $alPcq.default).of('Rect'), (0, $dj8f2.default));
    };
    PDFAnnotation.prototype.AP = function() {
        return this.dict.lookupMaybe((0, $alPcq.default).of('AP'), (0, $b7e75d63d5628aec$export$2e2bcd8739ae039));
    };
    PDFAnnotation.prototype.F = function() {
        var numberOrRef = this.dict.lookup((0, $alPcq.default).of('F'));
        return this.dict.context.lookupMaybe(numberOrRef, (0, $4MKjy.default));
    };
    PDFAnnotation.prototype.getRectangle = function() {
        var _a;
        var Rect = this.Rect();
        return (_a = Rect === null || Rect === void 0 ? void 0 : Rect.asRectangle()) !== null && _a !== void 0 ? _a : {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    };
    PDFAnnotation.prototype.setRectangle = function(rect) {
        var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
        var Rect = this.dict.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.dict.set((0, $alPcq.default).of('Rect'), Rect);
    };
    PDFAnnotation.prototype.getAppearanceState = function() {
        var AS = this.dict.lookup((0, $alPcq.default).of('AS'));
        if (AS instanceof (0, $alPcq.default)) return AS;
        return undefined;
    };
    PDFAnnotation.prototype.setAppearanceState = function(state) {
        this.dict.set((0, $alPcq.default).of('AS'), state);
    };
    PDFAnnotation.prototype.setAppearances = function(appearances) {
        this.dict.set((0, $alPcq.default).of('AP'), appearances);
    };
    PDFAnnotation.prototype.ensureAP = function() {
        var AP = this.AP();
        if (!AP) {
            AP = this.dict.context.obj({});
            this.dict.set((0, $alPcq.default).of('AP'), AP);
        }
        return AP;
    };
    PDFAnnotation.prototype.getNormalAppearance = function() {
        var AP = this.ensureAP();
        var N = AP.get((0, $alPcq.default).of('N'));
        if (N instanceof (0, $69d09480b29248e9$export$2e2bcd8739ae039) || N instanceof (0, $b7e75d63d5628aec$export$2e2bcd8739ae039)) return N;
        throw new Error("Unexpected N type: " + (N === null || N === void 0 ? void 0 : N.constructor.name));
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setNormalAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $alPcq.default).of('N'), appearance);
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setRolloverAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $alPcq.default).of('R'), appearance);
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setDownAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $alPcq.default).of('D'), appearance);
    };
    PDFAnnotation.prototype.removeRolloverAppearance = function() {
        var AP = this.AP();
        AP === null || AP === void 0 || AP.delete((0, $alPcq.default).of('R'));
    };
    PDFAnnotation.prototype.removeDownAppearance = function() {
        var AP = this.AP();
        AP === null || AP === void 0 || AP.delete((0, $alPcq.default).of('D'));
    };
    PDFAnnotation.prototype.getAppearances = function() {
        var AP = this.AP();
        if (!AP) return undefined;
        var N = AP.lookup((0, $alPcq.default).of('N'), (0, $b7e75d63d5628aec$export$2e2bcd8739ae039), (0, $c444ed3a6bfbd846$export$2e2bcd8739ae039));
        var R = AP.lookupMaybe((0, $alPcq.default).of('R'), (0, $b7e75d63d5628aec$export$2e2bcd8739ae039), (0, $c444ed3a6bfbd846$export$2e2bcd8739ae039));
        var D = AP.lookupMaybe((0, $alPcq.default).of('D'), (0, $b7e75d63d5628aec$export$2e2bcd8739ae039), (0, $c444ed3a6bfbd846$export$2e2bcd8739ae039));
        return {
            normal: N,
            rollover: R,
            down: D
        };
    };
    PDFAnnotation.prototype.getFlags = function() {
        var _a, _b;
        return (_b = (_a = this.F()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
    };
    PDFAnnotation.prototype.setFlags = function(flags) {
        this.dict.set((0, $alPcq.default).of('F'), (0, $4MKjy.default).of(flags));
    };
    PDFAnnotation.prototype.hasFlag = function(flag) {
        var flags = this.getFlags();
        return (flags & flag) !== 0;
    };
    PDFAnnotation.prototype.setFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags | flag);
    };
    PDFAnnotation.prototype.clearFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags & ~flag);
    };
    PDFAnnotation.prototype.setFlagTo = function(flag, enable) {
        if (enable) this.setFlag(flag);
        else this.clearFlag(flag);
    };
    PDFAnnotation.fromDict = function(dict) {
        return new PDFAnnotation(dict);
    };
    return PDFAnnotation;
}();
var $efad75441f9151be$export$2e2bcd8739ae039 = $efad75441f9151be$var$PDFAnnotation;



var $alPcq = parcelRequire("alPcq");

var $4MKjy = parcelRequire("4MKjy");

var $dj8f2 = parcelRequire("dj8f2");


var $41873dcf7e4faa35$var$AppearanceCharacteristics = /** @class */ function() {
    function AppearanceCharacteristics(dict) {
        this.dict = dict;
    }
    AppearanceCharacteristics.prototype.R = function() {
        var R = this.dict.lookup((0, $alPcq.default).of('R'));
        if (R instanceof (0, $4MKjy.default)) return R;
        return undefined;
    };
    AppearanceCharacteristics.prototype.BC = function() {
        var BC = this.dict.lookup((0, $alPcq.default).of('BC'));
        if (BC instanceof (0, $dj8f2.default)) return BC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.BG = function() {
        var BG = this.dict.lookup((0, $alPcq.default).of('BG'));
        if (BG instanceof (0, $dj8f2.default)) return BG;
        return undefined;
    };
    AppearanceCharacteristics.prototype.CA = function() {
        var CA = this.dict.lookup((0, $alPcq.default).of('CA'));
        if (CA instanceof (0, $d8f6d7884257882d$export$2e2bcd8739ae039) || CA instanceof (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039)) return CA;
        return undefined;
    };
    AppearanceCharacteristics.prototype.RC = function() {
        var RC = this.dict.lookup((0, $alPcq.default).of('RC'));
        if (RC instanceof (0, $d8f6d7884257882d$export$2e2bcd8739ae039) || RC instanceof (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039)) return RC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.AC = function() {
        var AC = this.dict.lookup((0, $alPcq.default).of('AC'));
        if (AC instanceof (0, $d8f6d7884257882d$export$2e2bcd8739ae039) || AC instanceof (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039)) return AC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.getRotation = function() {
        var _a;
        return (_a = this.R()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    AppearanceCharacteristics.prototype.getBorderColor = function() {
        var BC = this.BC();
        if (!BC) return undefined;
        var components = [];
        for(var idx = 0, len = BC === null || BC === void 0 ? void 0 : BC.size(); idx < len; idx++){
            var component = BC.get(idx);
            if (component instanceof (0, $4MKjy.default)) components.push(component.asNumber());
        }
        return components;
    };
    AppearanceCharacteristics.prototype.getBackgroundColor = function() {
        var BG = this.BG();
        if (!BG) return undefined;
        var components = [];
        for(var idx = 0, len = BG === null || BG === void 0 ? void 0 : BG.size(); idx < len; idx++){
            var component = BG.get(idx);
            if (component instanceof (0, $4MKjy.default)) components.push(component.asNumber());
        }
        return components;
    };
    AppearanceCharacteristics.prototype.getCaptions = function() {
        var CA = this.CA();
        var RC = this.RC();
        var AC = this.AC();
        return {
            normal: CA === null || CA === void 0 ? void 0 : CA.decodeText(),
            rollover: RC === null || RC === void 0 ? void 0 : RC.decodeText(),
            down: AC === null || AC === void 0 ? void 0 : AC.decodeText()
        };
    };
    AppearanceCharacteristics.prototype.setRotation = function(rotation) {
        var R = this.dict.context.obj(rotation);
        this.dict.set((0, $alPcq.default).of('R'), R);
    };
    AppearanceCharacteristics.prototype.setBorderColor = function(color) {
        var BC = this.dict.context.obj(color);
        this.dict.set((0, $alPcq.default).of('BC'), BC);
    };
    AppearanceCharacteristics.prototype.setBackgroundColor = function(color) {
        var BG = this.dict.context.obj(color);
        this.dict.set((0, $alPcq.default).of('BG'), BG);
    };
    AppearanceCharacteristics.prototype.setCaptions = function(captions) {
        var CA = (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(captions.normal);
        this.dict.set((0, $alPcq.default).of('CA'), CA);
        if (captions.rollover) {
            var RC = (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(captions.rollover);
            this.dict.set((0, $alPcq.default).of('RC'), RC);
        } else this.dict.delete((0, $alPcq.default).of('RC'));
        if (captions.down) {
            var AC = (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(captions.down);
            this.dict.set((0, $alPcq.default).of('AC'), AC);
        } else this.dict.delete((0, $alPcq.default).of('AC'));
    };
    AppearanceCharacteristics.fromDict = function(dict) {
        return new AppearanceCharacteristics(dict);
    };
    return AppearanceCharacteristics;
}();
var $41873dcf7e4faa35$export$2e2bcd8739ae039 = $41873dcf7e4faa35$var$AppearanceCharacteristics;


var $effa7e0ecccc206a$var$PDFWidgetAnnotation = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFWidgetAnnotation, _super);
    function PDFWidgetAnnotation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFWidgetAnnotation.prototype.MK = function() {
        var MK = this.dict.lookup((0, $alPcq.default).of('MK'));
        if (MK instanceof (0, $b7e75d63d5628aec$export$2e2bcd8739ae039)) return MK;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.BS = function() {
        var BS = this.dict.lookup((0, $alPcq.default).of('BS'));
        if (BS instanceof (0, $b7e75d63d5628aec$export$2e2bcd8739ae039)) return BS;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.DA = function() {
        var da = this.dict.lookup((0, $alPcq.default).of('DA'));
        if (da instanceof (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039) || da instanceof (0, $d8f6d7884257882d$export$2e2bcd8739ae039)) return da;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.P = function() {
        var P = this.dict.get((0, $alPcq.default).of('P'));
        if (P instanceof (0, $69d09480b29248e9$export$2e2bcd8739ae039)) return P;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.setP = function(page) {
        this.dict.set((0, $alPcq.default).of('P'), page);
    };
    PDFWidgetAnnotation.prototype.setDefaultAppearance = function(appearance) {
        this.dict.set((0, $alPcq.default).of('DA'), (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039).of(appearance));
    };
    PDFWidgetAnnotation.prototype.getDefaultAppearance = function() {
        var DA = this.DA();
        if (DA instanceof (0, $d8f6d7884257882d$export$2e2bcd8739ae039)) return DA.decodeText();
        return DA === null || DA === void 0 ? void 0 : DA.asString();
    };
    PDFWidgetAnnotation.prototype.getAppearanceCharacteristics = function() {
        var MK = this.MK();
        if (MK) return (0, $41873dcf7e4faa35$export$2e2bcd8739ae039).fromDict(MK);
        return undefined;
    };
    PDFWidgetAnnotation.prototype.getOrCreateAppearanceCharacteristics = function() {
        var MK = this.MK();
        if (MK) return (0, $41873dcf7e4faa35$export$2e2bcd8739ae039).fromDict(MK);
        var ac = (0, $41873dcf7e4faa35$export$2e2bcd8739ae039).fromDict(this.dict.context.obj({}));
        this.dict.set((0, $alPcq.default).of('MK'), ac.dict);
        return ac;
    };
    PDFWidgetAnnotation.prototype.getBorderStyle = function() {
        var BS = this.BS();
        if (BS) return (0, $c75d3922c7f92d11$export$2e2bcd8739ae039).fromDict(BS);
        return undefined;
    };
    PDFWidgetAnnotation.prototype.getOrCreateBorderStyle = function() {
        var BS = this.BS();
        if (BS) return (0, $c75d3922c7f92d11$export$2e2bcd8739ae039).fromDict(BS);
        var bs = (0, $c75d3922c7f92d11$export$2e2bcd8739ae039).fromDict(this.dict.context.obj({}));
        this.dict.set((0, $alPcq.default).of('BS'), bs.dict);
        return bs;
    };
    PDFWidgetAnnotation.prototype.getOnValue = function() {
        var _a;
        var normal = (_a = this.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
        if (normal instanceof (0, $b7e75d63d5628aec$export$2e2bcd8739ae039)) {
            var keys = normal.keys();
            for(var idx = 0, len = keys.length; idx < len; idx++){
                var key = keys[idx];
                if (key !== (0, $alPcq.default).of('Off')) return key;
            }
        }
        return undefined;
    };
    PDFWidgetAnnotation.fromDict = function(dict) {
        return new PDFWidgetAnnotation(dict);
    };
    PDFWidgetAnnotation.create = function(context, parent) {
        var dict = context.obj({
            Type: 'Annot',
            Subtype: 'Widget',
            Rect: [
                0,
                0,
                0,
                0
            ],
            Parent: parent
        });
        return new PDFWidgetAnnotation(dict);
    };
    return PDFWidgetAnnotation;
}((0, $efad75441f9151be$export$2e2bcd8739ae039));
var $effa7e0ecccc206a$export$2e2bcd8739ae039 = $effa7e0ecccc206a$var$PDFWidgetAnnotation;



var $iMObG = parcelRequire("iMObG");
var $4e9d559d3658cb30$var$PDFAcroTerminal = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFAcroTerminal, _super);
    function PDFAcroTerminal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroTerminal.prototype.FT = function() {
        var nameOrRef = this.getInheritableAttribute((0, $alPcq.default).of('FT'));
        return this.dict.context.lookup(nameOrRef, (0, $alPcq.default));
    };
    PDFAcroTerminal.prototype.getWidgets = function() {
        var kidDicts = this.Kids();
        // This field is itself a widget
        if (!kidDicts) return [
            (0, $effa7e0ecccc206a$export$2e2bcd8739ae039).fromDict(this.dict)
        ];
        // This field's kids are its widgets
        var widgets = new Array(kidDicts.size());
        for(var idx = 0, len = kidDicts.size(); idx < len; idx++){
            var dict = kidDicts.lookup(idx, (0, $b7e75d63d5628aec$export$2e2bcd8739ae039));
            widgets[idx] = (0, $effa7e0ecccc206a$export$2e2bcd8739ae039).fromDict(dict);
        }
        return widgets;
    };
    PDFAcroTerminal.prototype.addWidget = function(ref) {
        var Kids = this.normalizedEntries().Kids;
        Kids.push(ref);
    };
    PDFAcroTerminal.prototype.removeWidget = function(idx) {
        var kidDicts = this.Kids();
        if (!kidDicts) {
            // This field is itself a widget
            if (idx !== 0) throw new (0, $iMObG.IndexOutOfBoundsError)(idx, 0, 0);
            this.setKids([]);
        } else {
            // This field's kids are its widgets
            if (idx < 0 || idx > kidDicts.size()) throw new (0, $iMObG.IndexOutOfBoundsError)(idx, 0, kidDicts.size());
            kidDicts.remove(idx);
        }
    };
    PDFAcroTerminal.prototype.normalizedEntries = function() {
        var Kids = this.Kids();
        // If this field is itself a widget (because it was only rendered once in
        // the document, so the field and widget properties were merged) then we
        // add itself to the `Kids` array. The alternative would be to try
        // splitting apart the widget properties and creating a separate object
        // for them.
        if (!Kids) {
            Kids = this.dict.context.obj([
                this.ref
            ]);
            this.dict.set((0, $alPcq.default).of('Kids'), Kids);
        }
        return {
            Kids: Kids
        };
    };
    PDFAcroTerminal.fromDict = function(dict, ref) {
        return new PDFAcroTerminal(dict, ref);
    };
    return PDFAcroTerminal;
}((0, $6bdaa445abd1ddb7$export$2e2bcd8739ae039));
var $4e9d559d3658cb30$export$2e2bcd8739ae039 = $4e9d559d3658cb30$var$PDFAcroTerminal;



var $iMObG = parcelRequire("iMObG");
var $9edf2c5ca3ea427c$var$PDFAcroButton = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFAcroButton, _super);
    function PDFAcroButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroButton.prototype.Opt = function() {
        return this.dict.lookupMaybe((0, $alPcq.default).of('Opt'), (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039), (0, $d8f6d7884257882d$export$2e2bcd8739ae039), (0, $dj8f2.default));
    };
    PDFAcroButton.prototype.setOpt = function(opt) {
        this.dict.set((0, $alPcq.default).of('Opt'), this.dict.context.obj(opt));
    };
    PDFAcroButton.prototype.getExportValues = function() {
        var opt = this.Opt();
        if (!opt) return undefined;
        if (opt instanceof (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039) || opt instanceof (0, $d8f6d7884257882d$export$2e2bcd8739ae039)) return [
            opt
        ];
        var values = [];
        for(var idx = 0, len = opt.size(); idx < len; idx++){
            var value = opt.lookup(idx);
            if (value instanceof (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039) || value instanceof (0, $d8f6d7884257882d$export$2e2bcd8739ae039)) values.push(value);
        }
        return values;
    };
    PDFAcroButton.prototype.removeExportValue = function(idx) {
        var opt = this.Opt();
        if (!opt) return;
        if (opt instanceof (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039) || opt instanceof (0, $d8f6d7884257882d$export$2e2bcd8739ae039)) {
            if (idx !== 0) throw new (0, $iMObG.IndexOutOfBoundsError)(idx, 0, 0);
            this.setOpt([]);
        } else {
            if (idx < 0 || idx > opt.size()) throw new (0, $iMObG.IndexOutOfBoundsError)(idx, 0, opt.size());
            opt.remove(idx);
        }
    };
    // Enforce use use of /Opt even if it isn't strictly necessary
    PDFAcroButton.prototype.normalizeExportValues = function() {
        var _a, _b, _c, _d;
        var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
        var Opt = [];
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var exportVal = (_b = exportValues[idx]) !== null && _b !== void 0 ? _b : (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText((_d = (_c = widget.getOnValue()) === null || _c === void 0 ? void 0 : _c.decodeText()) !== null && _d !== void 0 ? _d : '');
            Opt.push(exportVal);
        }
        this.setOpt(Opt);
    };
    /**
     * Reuses existing opt if one exists with the same value (assuming
     * `useExistingIdx` is `true`). Returns index of existing (or new) opt.
     */ PDFAcroButton.prototype.addOpt = function(opt, useExistingOptIdx) {
        var _a;
        this.normalizeExportValues();
        var optText = opt.decodeText();
        var existingIdx;
        if (useExistingOptIdx) {
            var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
            for(var idx = 0, len = exportValues.length; idx < len; idx++){
                var exportVal = exportValues[idx];
                if (exportVal.decodeText() === optText) existingIdx = idx;
            }
        }
        var Opt = this.Opt();
        Opt.push(opt);
        return existingIdx !== null && existingIdx !== void 0 ? existingIdx : Opt.size() - 1;
    };
    PDFAcroButton.prototype.addWidgetWithOpt = function(widget, opt, useExistingOptIdx) {
        var optIdx = this.addOpt(opt, useExistingOptIdx);
        var apStateValue = (0, $alPcq.default).of(String(optIdx));
        this.addWidget(widget);
        return apStateValue;
    };
    return PDFAcroButton;
}((0, $4e9d559d3658cb30$export$2e2bcd8739ae039));
var $9edf2c5ca3ea427c$export$2e2bcd8739ae039 = $9edf2c5ca3ea427c$var$PDFAcroButton;



var $273XO = parcelRequire("273XO");

var $alPcq = parcelRequire("alPcq");


var $iMObG = parcelRequire("iMObG");
var $e4d0dfeca465bbb2$var$PDFAcroCheckBox = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFAcroCheckBox, _super);
    function PDFAcroCheckBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroCheckBox.prototype.setValue = function(value) {
        var _a;
        var onValue = (_a = this.getOnValue()) !== null && _a !== void 0 ? _a : (0, $alPcq.default).of('Yes');
        if (value !== onValue && value !== (0, $alPcq.default).of('Off')) throw new (0, $iMObG.InvalidAcroFieldValueError)();
        this.dict.set((0, $alPcq.default).of('V'), value);
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getOnValue() === value ? value : (0, $alPcq.default).of('Off');
            widget.setAppearanceState(state);
        }
    };
    PDFAcroCheckBox.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $alPcq.default)) return v;
        return (0, $alPcq.default).of('Off');
    };
    PDFAcroCheckBox.prototype.getOnValue = function() {
        var widget = this.getWidgets()[0];
        return widget === null || widget === void 0 ? void 0 : widget.getOnValue();
    };
    PDFAcroCheckBox.fromDict = function(dict, ref) {
        return new PDFAcroCheckBox(dict, ref);
    };
    PDFAcroCheckBox.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroCheckBox(dict, ref);
    };
    return PDFAcroCheckBox;
}((0, $9edf2c5ca3ea427c$export$2e2bcd8739ae039));
var $e4d0dfeca465bbb2$export$2e2bcd8739ae039 = $e4d0dfeca465bbb2$var$PDFAcroCheckBox;



var $273XO = parcelRequire("273XO");




var $dj8f2 = parcelRequire("dj8f2");

var $alPcq = parcelRequire("alPcq");
var $2f45f5a23a67aac0$var$flag = function(bitIndex) {
    return 1 << bitIndex;
};
var $2f45f5a23a67aac0$export$3600c95532547643;
(function(AcroFieldFlags) {
    /**
     * If set, the user may not change the value of the field. Any associated
     * widget annotations will not interact with the user; that is, they will not
     * respond to mouse clicks or change their appearance in response to mouse
     * motions. This flag is useful for fields whose values are computed or
     * imported from a database.
     */ AcroFieldFlags[AcroFieldFlags["ReadOnly"] = $2f45f5a23a67aac0$var$flag(0)] = "ReadOnly";
    /**
     * If set, the field shall have a value at the time it is exported by a
     * submit-form action (see 12.7.5.2, "Submit-Form Action").
     */ AcroFieldFlags[AcroFieldFlags["Required"] = $2f45f5a23a67aac0$var$flag(1)] = "Required";
    /**
     * If set, the field shall not be exported by a submit-form action
     * (see 12.7.5.2, "Submit-Form Action").
     */ AcroFieldFlags[AcroFieldFlags["NoExport"] = $2f45f5a23a67aac0$var$flag(2)] = "NoExport";
})($2f45f5a23a67aac0$export$3600c95532547643 || ($2f45f5a23a67aac0$export$3600c95532547643 = {}));
var $2f45f5a23a67aac0$export$59f660e89ffb4f8a;
(function(AcroButtonFlags) {
    /**
     * (Radio buttons only) If set, exactly one radio button shall be selected at
     * all times; selecting the currently selected button has no effect. If clear,
     * clicking the selected button deselects it, leaving no button selected.
     */ AcroButtonFlags[AcroButtonFlags["NoToggleToOff"] = $2f45f5a23a67aac0$var$flag(14)] = "NoToggleToOff";
    /**
     * If set, the field is a set of radio buttons; if clear, the field is a check
     * box. This flag may be set only if the Pushbutton flag is clear.
     */ AcroButtonFlags[AcroButtonFlags["Radio"] = $2f45f5a23a67aac0$var$flag(15)] = "Radio";
    /**
     * If set, the field is a pushbutton that does not retain a permanent value.
     */ AcroButtonFlags[AcroButtonFlags["PushButton"] = $2f45f5a23a67aac0$var$flag(16)] = "PushButton";
    /**
     * If set, a group of radio buttons within a radio button field that use the
     * same value for the on state will turn on and off in unison; that is if one
     * is checked, they are all checked. If clear, the buttons are mutually
     * exclusive (the same behavior as HTML radio buttons).
     */ AcroButtonFlags[AcroButtonFlags["RadiosInUnison"] = $2f45f5a23a67aac0$var$flag(25)] = "RadiosInUnison";
})($2f45f5a23a67aac0$export$59f660e89ffb4f8a || ($2f45f5a23a67aac0$export$59f660e89ffb4f8a = {}));
var $2f45f5a23a67aac0$export$389fc7b97397dc8b;
(function(AcroTextFlags) {
    /**
     * If set, the field may contain multiple lines of text; if clear, the field's
     * text shall be restricted to a single line.
     */ AcroTextFlags[AcroTextFlags["Multiline"] = $2f45f5a23a67aac0$var$flag(12)] = "Multiline";
    /**
     * If set, the field is intended for entering a secure password that should
     * not be echoed visibly to the screen. Characters typed from the keyboard
     * shall instead be echoed in some unreadable form, such as asterisks or
     * bullet characters.
     * > NOTE   To protect password confidentiality, readers should never store
     * >        the value of the text field in the PDF file if this flag is set.
     */ AcroTextFlags[AcroTextFlags["Password"] = $2f45f5a23a67aac0$var$flag(13)] = "Password";
    /**
     * If set, the text entered in the field represents the pathname of a file
     * whose contents shall be submitted as the value of the field.
     */ AcroTextFlags[AcroTextFlags["FileSelect"] = $2f45f5a23a67aac0$var$flag(20)] = "FileSelect";
    /**
     * If set, text entered in the field shall not be spell-checked.
     */ AcroTextFlags[AcroTextFlags["DoNotSpellCheck"] = $2f45f5a23a67aac0$var$flag(22)] = "DoNotSpellCheck";
    /**
     * If set, the field shall not scroll (horizontally for single-line fields,
     * vertically for multiple-line fields) to accommodate more text than fits
     * within its annotation rectangle. Once the field is full, no further text
     * shall be accepted for interactive form filling; for non-interactive form
     * filling, the filler should take care not to add more character than will
     * visibly fit in the defined area.
     */ AcroTextFlags[AcroTextFlags["DoNotScroll"] = $2f45f5a23a67aac0$var$flag(23)] = "DoNotScroll";
    /**
     * May be set only if the MaxLen entry is present in the text field dictionary
     * (see Table 229) and if the Multiline, Password, and FileSelect flags are
     * clear. If set, the field shall be automatically divided into as many
     * equally spaced positions, or combs, as the value of MaxLen, and the text
     * is laid out into those combs.
     */ AcroTextFlags[AcroTextFlags["Comb"] = $2f45f5a23a67aac0$var$flag(24)] = "Comb";
    /**
     * If set, the value of this field shall be a rich text string
     * (see 12.7.3.4, "Rich Text Strings"). If the field has a value, the RV
     * entry of the field dictionary (Table 222) shall specify the rich text
     * string.
     */ AcroTextFlags[AcroTextFlags["RichText"] = $2f45f5a23a67aac0$var$flag(25)] = "RichText";
})($2f45f5a23a67aac0$export$389fc7b97397dc8b || ($2f45f5a23a67aac0$export$389fc7b97397dc8b = {}));
var $2f45f5a23a67aac0$export$eb88827058402599;
(function(AcroChoiceFlags) {
    /**
     * If set, the field is a combo box; if clear, the field is a list box.
     */ AcroChoiceFlags[AcroChoiceFlags["Combo"] = $2f45f5a23a67aac0$var$flag(17)] = "Combo";
    /**
     * If set, the combo box shall include an editable text box as well as a
     * drop-down list; if clear, it shall include only a drop-down list. This
     * flag shall be used only if the Combo flag is set.
     */ AcroChoiceFlags[AcroChoiceFlags["Edit"] = $2f45f5a23a67aac0$var$flag(18)] = "Edit";
    /**
     * If set, the field's option items shall be sorted alphabetically. This flag
     * is intended for use by writers, not by readers. Conforming readers shall
     * display the options in the order in which they occur in the Opt array
     * (see Table 231).
     */ AcroChoiceFlags[AcroChoiceFlags["Sort"] = $2f45f5a23a67aac0$var$flag(19)] = "Sort";
    /**
     * If set, more than one of the field's option items may be selected
     * simultaneously; if clear, at most one item shall be selected.
     */ AcroChoiceFlags[AcroChoiceFlags["MultiSelect"] = $2f45f5a23a67aac0$var$flag(21)] = "MultiSelect";
    /**
     * If set, text entered in the field shall not be spell-checked. This flag
     * shall not be used unless the Combo and Edit flags are both set.
     */ AcroChoiceFlags[AcroChoiceFlags["DoNotSpellCheck"] = $2f45f5a23a67aac0$var$flag(22)] = "DoNotSpellCheck";
    /**
     * If set, the new value shall be committed as soon as a selection is made
     * (commonly with the pointing device). In this case, supplying a value for
     * a field involves three actions: selecting the field for fill-in,
     * selecting a choice for the fill-in value, and leaving that field, which
     * finalizes or "commits" the data choice and triggers any actions associated
     * with the entry or changing of this data. If this flag is on, then
     * processing does not wait for leaving the field action to occur, but
     * immediately proceeds to the third step.
     *
     * This option enables applications to perform an action once a selection is
     * made, without requiring the user to exit the field. If clear, the new
     * value is not committed until the user exits the field.
     */ AcroChoiceFlags[AcroChoiceFlags["CommitOnSelChange"] = $2f45f5a23a67aac0$var$flag(26)] = "CommitOnSelChange";
})($2f45f5a23a67aac0$export$eb88827058402599 || ($2f45f5a23a67aac0$export$eb88827058402599 = {}));



var $iMObG = parcelRequire("iMObG");
var $d75113fd036fa53d$var$PDFAcroChoice = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFAcroChoice, _super);
    function PDFAcroChoice() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroChoice.prototype.setValues = function(values) {
        if (this.hasFlag((0, $2f45f5a23a67aac0$export$eb88827058402599).Combo) && !this.hasFlag((0, $2f45f5a23a67aac0$export$eb88827058402599).Edit) && !this.valuesAreValid(values)) throw new (0, $iMObG.InvalidAcroFieldValueError)();
        if (values.length === 0) this.dict.delete((0, $alPcq.default).of('V'));
        if (values.length === 1) this.dict.set((0, $alPcq.default).of('V'), values[0]);
        if (values.length > 1) {
            if (!this.hasFlag((0, $2f45f5a23a67aac0$export$eb88827058402599).MultiSelect)) throw new (0, $iMObG.MultiSelectValueError)();
            this.dict.set((0, $alPcq.default).of('V'), this.dict.context.obj(values));
        }
        this.updateSelectedIndices(values);
    };
    PDFAcroChoice.prototype.valuesAreValid = function(values) {
        var options = this.getOptions();
        var _loop_1 = function(idx, len) {
            var val = values[idx].decodeText();
            if (!options.find(function(o) {
                return val === (o.display || o.value).decodeText();
            })) return {
                value: false
            };
        };
        for(var idx = 0, len = values.length; idx < len; idx++){
            var state_1 = _loop_1(idx, len);
            if (typeof state_1 === "object") return state_1.value;
        }
        return true;
    };
    PDFAcroChoice.prototype.updateSelectedIndices = function(values) {
        if (values.length > 1) {
            var indices = new Array(values.length);
            var options = this.getOptions();
            var _loop_2 = function(idx, len) {
                var val = values[idx].decodeText();
                indices[idx] = options.findIndex(function(o) {
                    return val === (o.display || o.value).decodeText();
                });
            };
            for(var idx = 0, len = values.length; idx < len; idx++)_loop_2(idx, len);
            this.dict.set((0, $alPcq.default).of('I'), this.dict.context.obj(indices.sort()));
        } else this.dict.delete((0, $alPcq.default).of('I'));
    };
    PDFAcroChoice.prototype.getValues = function() {
        var v = this.V();
        if (v instanceof (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039) || v instanceof (0, $d8f6d7884257882d$export$2e2bcd8739ae039)) return [
            v
        ];
        if (v instanceof (0, $dj8f2.default)) {
            var values = [];
            for(var idx = 0, len = v.size(); idx < len; idx++){
                var value = v.lookup(idx);
                if (value instanceof (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039) || value instanceof (0, $d8f6d7884257882d$export$2e2bcd8739ae039)) values.push(value);
            }
            return values;
        }
        return [];
    };
    PDFAcroChoice.prototype.Opt = function() {
        return this.dict.lookupMaybe((0, $alPcq.default).of('Opt'), (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039), (0, $d8f6d7884257882d$export$2e2bcd8739ae039), (0, $dj8f2.default));
    };
    PDFAcroChoice.prototype.setOptions = function(options) {
        var newOpt = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = options[idx], value = _a.value, display = _a.display;
            newOpt[idx] = this.dict.context.obj([
                value,
                display || value
            ]);
        }
        this.dict.set((0, $alPcq.default).of('Opt'), this.dict.context.obj(newOpt));
    };
    PDFAcroChoice.prototype.getOptions = function() {
        var Opt = this.Opt();
        // Not supposed to happen - Opt _should_ always be `PDFArray | undefined`
        if (Opt instanceof (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039) || Opt instanceof (0, $d8f6d7884257882d$export$2e2bcd8739ae039)) return [
            {
                value: Opt,
                display: Opt
            }
        ];
        if (Opt instanceof (0, $dj8f2.default)) {
            var res = [];
            for(var idx = 0, len = Opt.size(); idx < len; idx++){
                var item = Opt.lookup(idx);
                // If `item` is a string, use that as both the export and text value
                if (item instanceof (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039) || item instanceof (0, $d8f6d7884257882d$export$2e2bcd8739ae039)) res.push({
                    value: item,
                    display: item
                });
                // If `item` is an array of one, treat it the same as just a string,
                // if it's an array of two then `item[0]` is the export value and
                // `item[1]` is the text value
                if (item instanceof (0, $dj8f2.default)) {
                    if (item.size() > 0) {
                        var first = item.lookup(0, (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039), (0, $d8f6d7884257882d$export$2e2bcd8739ae039));
                        var second = item.lookupMaybe(1, (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039), (0, $d8f6d7884257882d$export$2e2bcd8739ae039));
                        res.push({
                            value: first,
                            display: second || first
                        });
                    }
                }
            }
            return res;
        }
        return [];
    };
    return PDFAcroChoice;
}((0, $4e9d559d3658cb30$export$2e2bcd8739ae039));
var $d75113fd036fa53d$export$2e2bcd8739ae039 = $d75113fd036fa53d$var$PDFAcroChoice;



var $273XO = parcelRequire("273XO");


var $7e91fc20f1654182$var$PDFAcroComboBox = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFAcroComboBox, _super);
    function PDFAcroComboBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroComboBox.fromDict = function(dict, ref) {
        return new PDFAcroComboBox(dict, ref);
    };
    PDFAcroComboBox.create = function(context) {
        var dict = context.obj({
            FT: 'Ch',
            Ff: (0, $2f45f5a23a67aac0$export$eb88827058402599).Combo,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroComboBox(dict, ref);
    };
    return PDFAcroComboBox;
}((0, $d75113fd036fa53d$export$2e2bcd8739ae039));
var $7e91fc20f1654182$export$2e2bcd8739ae039 = $7e91fc20f1654182$var$PDFAcroComboBox;





var $dj8f2 = parcelRequire("dj8f2");

var $alPcq = parcelRequire("alPcq");

var $273XO = parcelRequire("273XO");

var $alPcq = parcelRequire("alPcq");

var $a8ccc6801a7a0cdb$var$PDFAcroNonTerminal = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFAcroNonTerminal, _super);
    function PDFAcroNonTerminal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroNonTerminal.prototype.addField = function(field) {
        var Kids = this.normalizedEntries().Kids;
        Kids === null || Kids === void 0 || Kids.push(field);
    };
    PDFAcroNonTerminal.prototype.normalizedEntries = function() {
        var Kids = this.Kids();
        if (!Kids) {
            Kids = this.dict.context.obj([]);
            this.dict.set((0, $alPcq.default).of('Kids'), Kids);
        }
        return {
            Kids: Kids
        };
    };
    PDFAcroNonTerminal.fromDict = function(dict, ref) {
        return new PDFAcroNonTerminal(dict, ref);
    };
    PDFAcroNonTerminal.create = function(context) {
        var dict = context.obj({});
        var ref = context.register(dict);
        return new PDFAcroNonTerminal(dict, ref);
    };
    return PDFAcroNonTerminal;
}((0, $6bdaa445abd1ddb7$export$2e2bcd8739ae039));
var $a8ccc6801a7a0cdb$export$2e2bcd8739ae039 = $a8ccc6801a7a0cdb$var$PDFAcroNonTerminal;



var $4MKjy = parcelRequire("4MKjy");


var $alPcq = parcelRequire("alPcq");

var $dj8f2 = parcelRequire("dj8f2");




var $273XO = parcelRequire("273XO");

var $c88dea97eb4cb799$var$PDFAcroSignature = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFAcroSignature, _super);
    function PDFAcroSignature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroSignature.fromDict = function(dict, ref) {
        return new PDFAcroSignature(dict, ref);
    };
    return PDFAcroSignature;
}((0, $4e9d559d3658cb30$export$2e2bcd8739ae039));
var $c88dea97eb4cb799$export$2e2bcd8739ae039 = $c88dea97eb4cb799$var$PDFAcroSignature;



var $273XO = parcelRequire("273XO");

var $4MKjy = parcelRequire("4MKjy");



var $alPcq = parcelRequire("alPcq");

var $f7fcbb3a1ecb38a8$var$PDFAcroText = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFAcroText, _super);
    function PDFAcroText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroText.prototype.MaxLen = function() {
        var maxLen = this.dict.lookup((0, $alPcq.default).of('MaxLen'));
        if (maxLen instanceof (0, $4MKjy.default)) return maxLen;
        return undefined;
    };
    PDFAcroText.prototype.Q = function() {
        var q = this.dict.lookup((0, $alPcq.default).of('Q'));
        if (q instanceof (0, $4MKjy.default)) return q;
        return undefined;
    };
    PDFAcroText.prototype.setMaxLength = function(maxLength) {
        this.dict.set((0, $alPcq.default).of('MaxLen'), (0, $4MKjy.default).of(maxLength));
    };
    PDFAcroText.prototype.removeMaxLength = function() {
        this.dict.delete((0, $alPcq.default).of('MaxLen'));
    };
    PDFAcroText.prototype.getMaxLength = function() {
        var _a;
        return (_a = this.MaxLen()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFAcroText.prototype.setQuadding = function(quadding) {
        this.dict.set((0, $alPcq.default).of('Q'), (0, $4MKjy.default).of(quadding));
    };
    PDFAcroText.prototype.getQuadding = function() {
        var _a;
        return (_a = this.Q()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFAcroText.prototype.setValue = function(value) {
        this.dict.set((0, $alPcq.default).of('V'), value);
    // const widgets = this.getWidgets();
    // for (let idx = 0, len = widgets.length; idx < len; idx++) {
    //   const widget = widgets[idx];
    //   const state = widget.getOnValue() === value ? value : PDFName.of('Off');
    //   widget.setAppearanceState(state);
    // }
    };
    PDFAcroText.prototype.removeValue = function() {
        this.dict.delete((0, $alPcq.default).of('V'));
    };
    PDFAcroText.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039) || v instanceof (0, $d8f6d7884257882d$export$2e2bcd8739ae039)) return v;
        return undefined;
    };
    PDFAcroText.fromDict = function(dict, ref) {
        return new PDFAcroText(dict, ref);
    };
    PDFAcroText.create = function(context) {
        var dict = context.obj({
            FT: 'Tx',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroText(dict, ref);
    };
    return PDFAcroText;
}((0, $4e9d559d3658cb30$export$2e2bcd8739ae039));
var $f7fcbb3a1ecb38a8$export$2e2bcd8739ae039 = $f7fcbb3a1ecb38a8$var$PDFAcroText;



var $273XO = parcelRequire("273XO");


var $91592ae7fb4500cd$var$PDFAcroPushButton = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFAcroPushButton, _super);
    function PDFAcroPushButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroPushButton.fromDict = function(dict, ref) {
        return new PDFAcroPushButton(dict, ref);
    };
    PDFAcroPushButton.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Ff: (0, $2f45f5a23a67aac0$export$59f660e89ffb4f8a).PushButton,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroPushButton(dict, ref);
    };
    return PDFAcroPushButton;
}((0, $9edf2c5ca3ea427c$export$2e2bcd8739ae039));
var $91592ae7fb4500cd$export$2e2bcd8739ae039 = $91592ae7fb4500cd$var$PDFAcroPushButton;



var $273XO = parcelRequire("273XO");

var $alPcq = parcelRequire("alPcq");



var $iMObG = parcelRequire("iMObG");
var $9004a8a5faa8e65b$var$PDFAcroRadioButton = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFAcroRadioButton, _super);
    function PDFAcroRadioButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroRadioButton.prototype.setValue = function(value) {
        var onValues = this.getOnValues();
        if (!onValues.includes(value) && value !== (0, $alPcq.default).of('Off')) throw new (0, $iMObG.InvalidAcroFieldValueError)();
        this.dict.set((0, $alPcq.default).of('V'), value);
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getOnValue() === value ? value : (0, $alPcq.default).of('Off');
            widget.setAppearanceState(state);
        }
    };
    PDFAcroRadioButton.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $alPcq.default)) return v;
        return (0, $alPcq.default).of('Off');
    };
    PDFAcroRadioButton.prototype.getOnValues = function() {
        var widgets = this.getWidgets();
        var onValues = [];
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var onValue = widgets[idx].getOnValue();
            if (onValue) onValues.push(onValue);
        }
        return onValues;
    };
    PDFAcroRadioButton.fromDict = function(dict, ref) {
        return new PDFAcroRadioButton(dict, ref);
    };
    PDFAcroRadioButton.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Ff: (0, $2f45f5a23a67aac0$export$59f660e89ffb4f8a).Radio,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroRadioButton(dict, ref);
    };
    return PDFAcroRadioButton;
}((0, $9edf2c5ca3ea427c$export$2e2bcd8739ae039));
var $9004a8a5faa8e65b$export$2e2bcd8739ae039 = $9004a8a5faa8e65b$var$PDFAcroRadioButton;





var $273XO = parcelRequire("273XO");

var $a86c1687de785cba$var$PDFAcroListBox = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFAcroListBox, _super);
    function PDFAcroListBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroListBox.fromDict = function(dict, ref) {
        return new PDFAcroListBox(dict, ref);
    };
    PDFAcroListBox.create = function(context) {
        var dict = context.obj({
            FT: 'Ch',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroListBox(dict, ref);
    };
    return PDFAcroListBox;
}((0, $d75113fd036fa53d$export$2e2bcd8739ae039));
var $a86c1687de785cba$export$2e2bcd8739ae039 = $a86c1687de785cba$var$PDFAcroListBox;



var $57f64bc5d061277e$export$34b4fb8893136c4c = function(kidDicts) {
    if (!kidDicts) return [];
    var kids = [];
    for(var idx = 0, len = kidDicts.size(); idx < len; idx++){
        var ref = kidDicts.get(idx);
        var dict = kidDicts.lookup(idx);
        // if (dict instanceof PDFDict) kids.push(PDFAcroField.fromDict(dict));
        if (ref instanceof (0, $69d09480b29248e9$export$2e2bcd8739ae039) && dict instanceof (0, $b7e75d63d5628aec$export$2e2bcd8739ae039)) kids.push([
            $57f64bc5d061277e$export$fe770f59a8fbe6d(dict, ref),
            ref
        ]);
    }
    return kids;
};
var $57f64bc5d061277e$export$fe770f59a8fbe6d = function(dict, ref) {
    var isNonTerminal = $57f64bc5d061277e$var$isNonTerminalAcroField(dict);
    if (isNonTerminal) return (0, $a8ccc6801a7a0cdb$export$2e2bcd8739ae039).fromDict(dict, ref);
    return $57f64bc5d061277e$var$createPDFAcroTerminal(dict, ref);
};
// TODO: Maybe just check if the dict is *not* a widget? That might be better.
// According to the PDF spec:
//
//   > A field's children in the hierarchy may also include widget annotations
//   > that define its appearance on the page. A field that has children that
//   > are fields is called a non-terminal field. A field that does not have
//   > children that are fields is called a terminal field.
//
// The spec is not entirely clear about how to determine whether a given
// dictionary represents an acrofield or a widget annotation. So we will assume
// that a dictionary is an acrofield if it is a member of the `/Kids` array
// and it contains a `/T` entry (widgets do not have `/T` entries). This isn't
// a bullet proof solution, because the `/T` entry is technically defined as
// optional for acrofields by the PDF spec. But in practice all acrofields seem
// to have a `/T` entry defined.
var $57f64bc5d061277e$var$isNonTerminalAcroField = function(dict) {
    var kids = dict.lookup((0, $alPcq.default).of('Kids'));
    if (kids instanceof (0, $dj8f2.default)) for(var idx = 0, len = kids.size(); idx < len; idx++){
        var kid = kids.lookup(idx);
        var kidIsField = kid instanceof (0, $b7e75d63d5628aec$export$2e2bcd8739ae039) && kid.has((0, $alPcq.default).of('T'));
        if (kidIsField) return true;
    }
    return false;
};
var $57f64bc5d061277e$var$createPDFAcroTerminal = function(dict, ref) {
    var ftNameOrRef = $57f64bc5d061277e$var$getInheritableAttribute(dict, (0, $alPcq.default).of('FT'));
    var type = dict.context.lookup(ftNameOrRef, (0, $alPcq.default));
    if (type === (0, $alPcq.default).of('Btn')) return $57f64bc5d061277e$var$createPDFAcroButton(dict, ref);
    if (type === (0, $alPcq.default).of('Ch')) return $57f64bc5d061277e$var$createPDFAcroChoice(dict, ref);
    if (type === (0, $alPcq.default).of('Tx')) return (0, $f7fcbb3a1ecb38a8$export$2e2bcd8739ae039).fromDict(dict, ref);
    if (type === (0, $alPcq.default).of('Sig')) return (0, $c88dea97eb4cb799$export$2e2bcd8739ae039).fromDict(dict, ref);
    // We should never reach this line. But there are a lot of weird PDFs out
    // there. So, just to be safe, we'll try to handle things gracefully instead
    // of throwing an error.
    return (0, $4e9d559d3658cb30$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $57f64bc5d061277e$var$createPDFAcroButton = function(dict, ref) {
    var _a;
    var ffNumberOrRef = $57f64bc5d061277e$var$getInheritableAttribute(dict, (0, $alPcq.default).of('Ff'));
    var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, (0, $4MKjy.default));
    var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
    if ($57f64bc5d061277e$var$flagIsSet(flags, (0, $2f45f5a23a67aac0$export$59f660e89ffb4f8a).PushButton)) return (0, $91592ae7fb4500cd$export$2e2bcd8739ae039).fromDict(dict, ref);
    else if ($57f64bc5d061277e$var$flagIsSet(flags, (0, $2f45f5a23a67aac0$export$59f660e89ffb4f8a).Radio)) return (0, $9004a8a5faa8e65b$export$2e2bcd8739ae039).fromDict(dict, ref);
    else return (0, $e4d0dfeca465bbb2$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $57f64bc5d061277e$var$createPDFAcroChoice = function(dict, ref) {
    var _a;
    var ffNumberOrRef = $57f64bc5d061277e$var$getInheritableAttribute(dict, (0, $alPcq.default).of('Ff'));
    var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, (0, $4MKjy.default));
    var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
    if ($57f64bc5d061277e$var$flagIsSet(flags, (0, $2f45f5a23a67aac0$export$eb88827058402599).Combo)) return (0, $7e91fc20f1654182$export$2e2bcd8739ae039).fromDict(dict, ref);
    else return (0, $a86c1687de785cba$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $57f64bc5d061277e$var$flagIsSet = function(flags, flag) {
    return (flags & flag) !== 0;
};
var $57f64bc5d061277e$var$getInheritableAttribute = function(startNode, name) {
    var attribute;
    $57f64bc5d061277e$var$ascend(startNode, function(node) {
        if (!attribute) attribute = node.get(name);
    });
    return attribute;
};
var $57f64bc5d061277e$var$ascend = function(startNode, visitor) {
    visitor(startNode);
    var Parent = startNode.lookupMaybe((0, $alPcq.default).of('Parent'), (0, $b7e75d63d5628aec$export$2e2bcd8739ae039));
    if (Parent) $57f64bc5d061277e$var$ascend(Parent, visitor);
};


var $095cce1dc29ae701$var$PDFAcroForm = /** @class */ function() {
    function PDFAcroForm(dict) {
        this.dict = dict;
    }
    PDFAcroForm.prototype.Fields = function() {
        var fields = this.dict.lookup((0, $alPcq.default).of('Fields'));
        if (fields instanceof (0, $dj8f2.default)) return fields;
        return undefined;
    };
    PDFAcroForm.prototype.getFields = function() {
        var Fields = this.normalizedEntries().Fields;
        var fields = new Array(Fields.size());
        for(var idx = 0, len = Fields.size(); idx < len; idx++){
            var ref = Fields.get(idx);
            var dict = Fields.lookup(idx, (0, $b7e75d63d5628aec$export$2e2bcd8739ae039));
            fields[idx] = [
                (0, $57f64bc5d061277e$export$fe770f59a8fbe6d)(dict, ref),
                ref
            ];
        }
        return fields;
    };
    PDFAcroForm.prototype.getAllFields = function() {
        var allFields = [];
        var pushFields = function(fields) {
            if (!fields) return;
            for(var idx = 0, len = fields.length; idx < len; idx++){
                var field = fields[idx];
                allFields.push(field);
                var fieldModel = field[0];
                if (fieldModel instanceof (0, $a8ccc6801a7a0cdb$export$2e2bcd8739ae039)) pushFields((0, $57f64bc5d061277e$export$34b4fb8893136c4c)(fieldModel.Kids()));
            }
        };
        pushFields(this.getFields());
        return allFields;
    };
    PDFAcroForm.prototype.addField = function(field) {
        var Fields = this.normalizedEntries().Fields;
        Fields === null || Fields === void 0 || Fields.push(field);
    };
    PDFAcroForm.prototype.removeField = function(field) {
        var parent = field.getParent();
        var fields = parent === undefined ? this.normalizedEntries().Fields : parent.Kids();
        var index = fields === null || fields === void 0 ? void 0 : fields.indexOf(field.ref);
        if (fields === undefined || index === undefined) throw new Error("Tried to remove inexistent field " + field.getFullyQualifiedName());
        fields.remove(index);
        if (parent !== undefined && fields.size() === 0) this.removeField(parent);
    };
    PDFAcroForm.prototype.normalizedEntries = function() {
        var Fields = this.Fields();
        if (!Fields) {
            Fields = this.dict.context.obj([]);
            this.dict.set((0, $alPcq.default).of('Fields'), Fields);
        }
        return {
            Fields: Fields
        };
    };
    PDFAcroForm.fromDict = function(dict) {
        return new PDFAcroForm(dict);
    };
    PDFAcroForm.create = function(context) {
        var dict = context.obj({
            Fields: []
        });
        return new PDFAcroForm(dict);
    };
    return PDFAcroForm;
}();
var $095cce1dc29ae701$export$2e2bcd8739ae039 = $095cce1dc29ae701$var$PDFAcroForm;














var $dvdsW = parcelRequire("dvdsW");
var $144148f0529ee19d$var$PDFCatalog = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFCatalog, _super);
    function PDFCatalog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFCatalog.prototype.Pages = function() {
        return this.lookup((0, $alPcq.default).of('Pages'), (0, $b7e75d63d5628aec$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.AcroForm = function() {
        return this.lookupMaybe((0, $alPcq.default).of('AcroForm'), (0, $b7e75d63d5628aec$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.getAcroForm = function() {
        var dict = this.AcroForm();
        if (!dict) return undefined;
        return (0, $095cce1dc29ae701$export$2e2bcd8739ae039).fromDict(dict);
    };
    PDFCatalog.prototype.getOrCreateAcroForm = function() {
        var acroForm = this.getAcroForm();
        if (!acroForm) {
            acroForm = (0, $095cce1dc29ae701$export$2e2bcd8739ae039).create(this.context);
            var acroFormRef = this.context.register(acroForm.dict);
            this.set((0, $alPcq.default).of('AcroForm'), acroFormRef);
        }
        return acroForm;
    };
    PDFCatalog.prototype.ViewerPreferences = function() {
        return this.lookupMaybe((0, $alPcq.default).of('ViewerPreferences'), (0, $b7e75d63d5628aec$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.getViewerPreferences = function() {
        var dict = this.ViewerPreferences();
        if (!dict) return undefined;
        return (0, $dvdsW.default).fromDict(dict);
    };
    PDFCatalog.prototype.getOrCreateViewerPreferences = function() {
        var viewerPrefs = this.getViewerPreferences();
        if (!viewerPrefs) {
            viewerPrefs = (0, $dvdsW.default).create(this.context);
            var viewerPrefsRef = this.context.register(viewerPrefs.dict);
            this.set((0, $alPcq.default).of('ViewerPreferences'), viewerPrefsRef);
        }
        return viewerPrefs;
    };
    /**
     * Inserts the given ref as a leaf node of this catalog's page tree at the
     * specified index (zero-based). Also increments the `Count` of each node in
     * the page tree hierarchy to accomodate the new page.
     *
     * Returns the ref of the PDFPageTree node into which `leafRef` was inserted.
     */ PDFCatalog.prototype.insertLeafNode = function(leafRef, index) {
        var pagesRef = this.get((0, $alPcq.default).of('Pages'));
        var maybeParentRef = this.Pages().insertLeafNode(leafRef, index);
        return maybeParentRef || pagesRef;
    };
    PDFCatalog.prototype.removeLeafNode = function(index) {
        this.Pages().removeLeafNode(index);
    };
    PDFCatalog.withContextAndPages = function(context, pages) {
        var dict = new Map();
        dict.set((0, $alPcq.default).of('Type'), (0, $alPcq.default).of('Catalog'));
        dict.set((0, $alPcq.default).of('Pages'), pages);
        return new PDFCatalog(dict, context);
    };
    PDFCatalog.fromMapWithContext = function(map, context) {
        return new PDFCatalog(map, context);
    };
    return PDFCatalog;
}((0, $b7e75d63d5628aec$export$2e2bcd8739ae039));
var $144148f0529ee19d$export$2e2bcd8739ae039 = $144148f0529ee19d$var$PDFCatalog;






var $273XO = parcelRequire("273XO");

var $dj8f2 = parcelRequire("dj8f2");


var $alPcq = parcelRequire("alPcq");

var $4MKjy = parcelRequire("4MKjy");


var $iMObG = parcelRequire("iMObG");
var $1ea69a2ae6505d06$var$PDFPageTree = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFPageTree, _super);
    function PDFPageTree() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFPageTree.prototype.Parent = function() {
        return this.lookup((0, $alPcq.default).of('Parent'));
    };
    PDFPageTree.prototype.Kids = function() {
        return this.lookup((0, $alPcq.default).of('Kids'), (0, $dj8f2.default));
    };
    PDFPageTree.prototype.Count = function() {
        return this.lookup((0, $alPcq.default).of('Count'), (0, $4MKjy.default));
    };
    PDFPageTree.prototype.pushTreeNode = function(treeRef) {
        var Kids = this.Kids();
        Kids.push(treeRef);
    };
    PDFPageTree.prototype.pushLeafNode = function(leafRef) {
        var Kids = this.Kids();
        this.insertLeafKid(Kids.size(), leafRef);
    };
    /**
     * Inserts the given ref as a leaf node of this page tree at the specified
     * index (zero-based). Also increments the `Count` of each page tree in the
     * hierarchy to accomodate the new page.
     *
     * Returns the ref of the PDFPageTree node into which `leafRef` was inserted,
     * or `undefined` if it was inserted into the root node (the PDFPageTree upon
     * which the method was first called).
     */ PDFPageTree.prototype.insertLeafNode = function(leafRef, targetIndex) {
        var Kids = this.Kids();
        var Count = this.Count().asNumber();
        if (targetIndex > Count) throw new (0, $iMObG.InvalidTargetIndexError)(targetIndex, Count);
        var leafsRemainingUntilTarget = targetIndex;
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            if (leafsRemainingUntilTarget === 0) {
                // Insert page and return
                this.insertLeafKid(idx, leafRef);
                return undefined;
            }
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) {
                if (kid.Count().asNumber() > leafsRemainingUntilTarget) // Dig in
                return kid.insertLeafNode(leafRef, leafsRemainingUntilTarget) || kidRef;
                else // Move on
                leafsRemainingUntilTarget -= kid.Count().asNumber();
            }
            if (kid instanceof (0, $27cec0c5ad235198$export$2e2bcd8739ae039)) // Move on
            leafsRemainingUntilTarget -= 1;
        }
        if (leafsRemainingUntilTarget === 0) {
            // Insert page at the end and return
            this.insertLeafKid(Kids.size(), leafRef);
            return undefined;
        }
        // Should never get here if `targetIndex` is valid
        throw new (0, $iMObG.CorruptPageTreeError)(targetIndex, 'insertLeafNode');
    };
    /**
     * Removes the leaf node at the specified index (zero-based) from this page
     * tree. Also decrements the `Count` of each page tree in the hierarchy to
     * account for the removed page.
     *
     * If `prune` is true, then intermediate tree nodes will be removed from the
     * tree if they contain 0 children after the leaf node is removed.
     */ PDFPageTree.prototype.removeLeafNode = function(targetIndex, prune) {
        if (prune === void 0) prune = true;
        var Kids = this.Kids();
        var Count = this.Count().asNumber();
        if (targetIndex >= Count) throw new (0, $iMObG.InvalidTargetIndexError)(targetIndex, Count);
        var leafsRemainingUntilTarget = targetIndex;
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) {
                if (kid.Count().asNumber() > leafsRemainingUntilTarget) {
                    // Dig in
                    kid.removeLeafNode(leafsRemainingUntilTarget, prune);
                    if (prune && kid.Kids().size() === 0) Kids.remove(idx);
                    return;
                } else // Move on
                leafsRemainingUntilTarget -= kid.Count().asNumber();
            }
            if (kid instanceof (0, $27cec0c5ad235198$export$2e2bcd8739ae039)) {
                if (leafsRemainingUntilTarget === 0) {
                    // Remove page and return
                    this.removeKid(idx);
                    return;
                } else // Move on
                leafsRemainingUntilTarget -= 1;
            }
        }
        // Should never get here if `targetIndex` is valid
        throw new (0, $iMObG.CorruptPageTreeError)(targetIndex, 'removeLeafNode');
    };
    PDFPageTree.prototype.ascend = function(visitor) {
        visitor(this);
        var Parent = this.Parent();
        if (Parent) Parent.ascend(visitor);
    };
    /** Performs a Post-Order traversal of this page tree */ PDFPageTree.prototype.traverse = function(visitor) {
        var Kids = this.Kids();
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) kid.traverse(visitor);
            visitor(kid, kidRef);
        }
    };
    PDFPageTree.prototype.insertLeafKid = function(kidIdx, leafRef) {
        var Kids = this.Kids();
        this.ascend(function(node) {
            var newCount = node.Count().asNumber() + 1;
            node.set((0, $alPcq.default).of('Count'), (0, $4MKjy.default).of(newCount));
        });
        Kids.insert(kidIdx, leafRef);
    };
    PDFPageTree.prototype.removeKid = function(kidIdx) {
        var Kids = this.Kids();
        var kid = Kids.lookup(kidIdx);
        if (kid instanceof (0, $27cec0c5ad235198$export$2e2bcd8739ae039)) this.ascend(function(node) {
            var newCount = node.Count().asNumber() - 1;
            node.set((0, $alPcq.default).of('Count'), (0, $4MKjy.default).of(newCount));
        });
        Kids.remove(kidIdx);
    };
    PDFPageTree.withContext = function(context, parent) {
        var dict = new Map();
        dict.set((0, $alPcq.default).of('Type'), (0, $alPcq.default).of('Pages'));
        dict.set((0, $alPcq.default).of('Kids'), context.obj([]));
        dict.set((0, $alPcq.default).of('Count'), context.obj(0));
        if (parent) dict.set((0, $alPcq.default).of('Parent'), parent);
        return new PDFPageTree(dict, context);
    };
    PDFPageTree.fromMapWithContext = function(map, context) {
        return new PDFPageTree(map, context);
    };
    return PDFPageTree;
}((0, $b7e75d63d5628aec$export$2e2bcd8739ae039));
var $1ea69a2ae6505d06$export$2e2bcd8739ae039 = $1ea69a2ae6505d06$var$PDFPageTree;







var $273XO = parcelRequire("273XO");

var $iMObG = parcelRequire("iMObG");

var $dj8f2 = parcelRequire("dj8f2");

var $63sxC = parcelRequire("63sxC");



var $alPcq = parcelRequire("alPcq");


var $4MKjy = parcelRequire("4MKjy");




var $iMObG = parcelRequire("iMObG");

var $8KH3B = parcelRequire("8KH3B");

var $8KH3B = parcelRequire("8KH3B");
var $edeff18144c0e6fd$export$9492c31549e88980 = new Uint8Array(256);
$edeff18144c0e6fd$export$9492c31549e88980[(0, $8KH3B.default).Zero] = 1;
$edeff18144c0e6fd$export$9492c31549e88980[(0, $8KH3B.default).One] = 1;
$edeff18144c0e6fd$export$9492c31549e88980[(0, $8KH3B.default).Two] = 1;
$edeff18144c0e6fd$export$9492c31549e88980[(0, $8KH3B.default).Three] = 1;
$edeff18144c0e6fd$export$9492c31549e88980[(0, $8KH3B.default).Four] = 1;
$edeff18144c0e6fd$export$9492c31549e88980[(0, $8KH3B.default).Five] = 1;
$edeff18144c0e6fd$export$9492c31549e88980[(0, $8KH3B.default).Six] = 1;
$edeff18144c0e6fd$export$9492c31549e88980[(0, $8KH3B.default).Seven] = 1;
$edeff18144c0e6fd$export$9492c31549e88980[(0, $8KH3B.default).Eight] = 1;
$edeff18144c0e6fd$export$9492c31549e88980[(0, $8KH3B.default).Nine] = 1;
var $edeff18144c0e6fd$export$d438b84505bee68c = new Uint8Array(256);
$edeff18144c0e6fd$export$d438b84505bee68c[(0, $8KH3B.default).Period] = 1;
$edeff18144c0e6fd$export$d438b84505bee68c[(0, $8KH3B.default).Plus] = 1;
$edeff18144c0e6fd$export$d438b84505bee68c[(0, $8KH3B.default).Minus] = 1;
var $edeff18144c0e6fd$export$4d926b029fa61cfe = new Uint8Array(256);
for(var $edeff18144c0e6fd$var$idx = 0, $edeff18144c0e6fd$var$len = 256; $edeff18144c0e6fd$var$idx < $edeff18144c0e6fd$var$len; $edeff18144c0e6fd$var$idx++)$edeff18144c0e6fd$export$4d926b029fa61cfe[$edeff18144c0e6fd$var$idx] = $edeff18144c0e6fd$export$9492c31549e88980[$edeff18144c0e6fd$var$idx] || $edeff18144c0e6fd$export$d438b84505bee68c[$edeff18144c0e6fd$var$idx] ? 1 : 0;



var $igTLl = parcelRequire("igTLl");
parcelRequire("5bpFt");
var $8hWZH = parcelRequire("8hWZH");
var $8bafff5f382d3f03$var$Newline = (0, $8KH3B.default).Newline, $8bafff5f382d3f03$var$CarriageReturn = (0, $8KH3B.default).CarriageReturn;
// TODO: Throw error if eof is reached before finishing object parse...
var $8bafff5f382d3f03$var$BaseParser = /** @class */ function() {
    function BaseParser(bytes, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        this.bytes = bytes;
        this.capNumbers = capNumbers;
    }
    BaseParser.prototype.parseRawInt = function() {
        var value = '';
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $edeff18144c0e6fd$export$9492c31549e88980)[byte]) break;
            value += (0, $8hWZH.charFromCode)(this.bytes.next());
        }
        var numberValue = Number(value);
        if (!value || !isFinite(numberValue)) throw new (0, $iMObG.NumberParsingError)(this.bytes.position(), value);
        return numberValue;
    };
    // TODO: Maybe handle exponential format?
    // TODO: Compare performance of string concatenation to charFromCode(...bytes)
    BaseParser.prototype.parseRawNumber = function() {
        var value = '';
        // Parse integer-part, the leading (+ | - | . | 0-9)
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $edeff18144c0e6fd$export$4d926b029fa61cfe)[byte]) break;
            value += (0, $8hWZH.charFromCode)(this.bytes.next());
            if (byte === (0, $8KH3B.default).Period) break;
        }
        // Parse decimal-part, the trailing (0-9)
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $edeff18144c0e6fd$export$9492c31549e88980)[byte]) break;
            value += (0, $8hWZH.charFromCode)(this.bytes.next());
        }
        var numberValue = Number(value);
        if (!value || !isFinite(numberValue)) throw new (0, $iMObG.NumberParsingError)(this.bytes.position(), value);
        if (numberValue > Number.MAX_SAFE_INTEGER) {
            if (this.capNumbers) {
                var msg = "Parsed number that is too large for some PDF readers: " + value + ", using Number.MAX_SAFE_INTEGER instead.";
                console.warn(msg);
                return Number.MAX_SAFE_INTEGER;
            } else {
                var msg = "Parsed number that is too large for some PDF readers: " + value + ", not capping.";
                console.warn(msg);
            }
        }
        return numberValue;
    };
    BaseParser.prototype.skipWhitespace = function() {
        while(!this.bytes.done() && (0, $igTLl.IsWhitespace)[this.bytes.peek()])this.bytes.next();
    };
    BaseParser.prototype.skipLine = function() {
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (byte === $8bafff5f382d3f03$var$Newline || byte === $8bafff5f382d3f03$var$CarriageReturn) return;
            this.bytes.next();
        }
    };
    BaseParser.prototype.skipComment = function() {
        if (this.bytes.peek() !== (0, $8KH3B.default).Percent) return false;
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (byte === $8bafff5f382d3f03$var$Newline || byte === $8bafff5f382d3f03$var$CarriageReturn) return true;
            this.bytes.next();
        }
        return true;
    };
    BaseParser.prototype.skipWhitespaceAndComments = function() {
        this.skipWhitespace();
        while(this.skipComment())this.skipWhitespace();
    };
    BaseParser.prototype.matchKeyword = function(keyword) {
        var initialOffset = this.bytes.offset();
        for(var idx = 0, len = keyword.length; idx < len; idx++)if (this.bytes.done() || this.bytes.next() !== keyword[idx]) {
            this.bytes.moveTo(initialOffset);
            return false;
        }
        return true;
    };
    return BaseParser;
}();
var $8bafff5f382d3f03$export$2e2bcd8739ae039 = $8bafff5f382d3f03$var$BaseParser;



var $iMObG = parcelRequire("iMObG");


var $8KH3B = parcelRequire("8KH3B");
// TODO: See how line/col tracking affects performance
var $a12b412bad237828$var$ByteStream = /** @class */ function() {
    function ByteStream(bytes) {
        this.idx = 0;
        this.line = 0;
        this.column = 0;
        this.bytes = bytes;
        this.length = this.bytes.length;
    }
    ByteStream.prototype.moveTo = function(offset) {
        this.idx = offset;
    };
    ByteStream.prototype.next = function() {
        var byte = this.bytes[this.idx++];
        if (byte === (0, $8KH3B.default).Newline) {
            this.line += 1;
            this.column = 0;
        } else this.column += 1;
        return byte;
    };
    ByteStream.prototype.assertNext = function(expected) {
        if (this.peek() !== expected) throw new (0, $iMObG.NextByteAssertionError)(this.position(), expected, this.peek());
        return this.next();
    };
    ByteStream.prototype.peek = function() {
        return this.bytes[this.idx];
    };
    ByteStream.prototype.peekAhead = function(steps) {
        return this.bytes[this.idx + steps];
    };
    ByteStream.prototype.peekAt = function(offset) {
        return this.bytes[offset];
    };
    ByteStream.prototype.done = function() {
        return this.idx >= this.length;
    };
    ByteStream.prototype.offset = function() {
        return this.idx;
    };
    ByteStream.prototype.slice = function(start, end) {
        return this.bytes.slice(start, end);
    };
    ByteStream.prototype.position = function() {
        return {
            line: this.line,
            column: this.column,
            offset: this.idx
        };
    };
    ByteStream.of = function(bytes) {
        return new ByteStream(bytes);
    };
    ByteStream.fromPDFRawStream = function(rawStream) {
        return ByteStream.of((0, $39824019df04b477$export$b8317e68ca978594)(rawStream).decode());
    };
    return ByteStream;
}();
var $a12b412bad237828$export$2e2bcd8739ae039 = $a12b412bad237828$var$ByteStream;






var $8KH3B = parcelRequire("8KH3B");

var $cgSZS = parcelRequire("cgSZS");

var $273XO = parcelRequire("273XO");

var $8KH3B = parcelRequire("8KH3B");
var $8b93c77c2612edaa$var$Space = (0, $8KH3B.default).Space, $8b93c77c2612edaa$var$CarriageReturn = (0, $8KH3B.default).CarriageReturn, $8b93c77c2612edaa$var$Newline = (0, $8KH3B.default).Newline;
var $8b93c77c2612edaa$var$stream = [
    (0, $8KH3B.default).s,
    (0, $8KH3B.default).t,
    (0, $8KH3B.default).r,
    (0, $8KH3B.default).e,
    (0, $8KH3B.default).a,
    (0, $8KH3B.default).m
];
var $8b93c77c2612edaa$var$endstream = [
    (0, $8KH3B.default).e,
    (0, $8KH3B.default).n,
    (0, $8KH3B.default).d,
    (0, $8KH3B.default).s,
    (0, $8KH3B.default).t,
    (0, $8KH3B.default).r,
    (0, $8KH3B.default).e,
    (0, $8KH3B.default).a,
    (0, $8KH3B.default).m
];
var $8b93c77c2612edaa$export$93ad50ccfacdd77 = {
    header: [
        (0, $8KH3B.default).Percent,
        (0, $8KH3B.default).P,
        (0, $8KH3B.default).D,
        (0, $8KH3B.default).F,
        (0, $8KH3B.default).Dash
    ],
    eof: [
        (0, $8KH3B.default).Percent,
        (0, $8KH3B.default).Percent,
        (0, $8KH3B.default).E,
        (0, $8KH3B.default).O,
        (0, $8KH3B.default).F
    ],
    obj: [
        (0, $8KH3B.default).o,
        (0, $8KH3B.default).b,
        (0, $8KH3B.default).j
    ],
    endobj: [
        (0, $8KH3B.default).e,
        (0, $8KH3B.default).n,
        (0, $8KH3B.default).d,
        (0, $8KH3B.default).o,
        (0, $8KH3B.default).b,
        (0, $8KH3B.default).j
    ],
    xref: [
        (0, $8KH3B.default).x,
        (0, $8KH3B.default).r,
        (0, $8KH3B.default).e,
        (0, $8KH3B.default).f
    ],
    trailer: [
        (0, $8KH3B.default).t,
        (0, $8KH3B.default).r,
        (0, $8KH3B.default).a,
        (0, $8KH3B.default).i,
        (0, $8KH3B.default).l,
        (0, $8KH3B.default).e,
        (0, $8KH3B.default).r
    ],
    startxref: [
        (0, $8KH3B.default).s,
        (0, $8KH3B.default).t,
        (0, $8KH3B.default).a,
        (0, $8KH3B.default).r,
        (0, $8KH3B.default).t,
        (0, $8KH3B.default).x,
        (0, $8KH3B.default).r,
        (0, $8KH3B.default).e,
        (0, $8KH3B.default).f
    ],
    true: [
        (0, $8KH3B.default).t,
        (0, $8KH3B.default).r,
        (0, $8KH3B.default).u,
        (0, $8KH3B.default).e
    ],
    false: [
        (0, $8KH3B.default).f,
        (0, $8KH3B.default).a,
        (0, $8KH3B.default).l,
        (0, $8KH3B.default).s,
        (0, $8KH3B.default).e
    ],
    null: [
        (0, $8KH3B.default).n,
        (0, $8KH3B.default).u,
        (0, $8KH3B.default).l,
        (0, $8KH3B.default).l
    ],
    stream: $8b93c77c2612edaa$var$stream,
    streamEOF1: (0, $273XO.__spreadArrays)($8b93c77c2612edaa$var$stream, [
        $8b93c77c2612edaa$var$Space,
        $8b93c77c2612edaa$var$CarriageReturn,
        $8b93c77c2612edaa$var$Newline
    ]),
    streamEOF2: (0, $273XO.__spreadArrays)($8b93c77c2612edaa$var$stream, [
        $8b93c77c2612edaa$var$CarriageReturn,
        $8b93c77c2612edaa$var$Newline
    ]),
    streamEOF3: (0, $273XO.__spreadArrays)($8b93c77c2612edaa$var$stream, [
        $8b93c77c2612edaa$var$CarriageReturn
    ]),
    streamEOF4: (0, $273XO.__spreadArrays)($8b93c77c2612edaa$var$stream, [
        $8b93c77c2612edaa$var$Newline
    ]),
    endstream: $8b93c77c2612edaa$var$endstream,
    EOF1endstream: (0, $273XO.__spreadArrays)([
        $8b93c77c2612edaa$var$CarriageReturn,
        $8b93c77c2612edaa$var$Newline
    ], $8b93c77c2612edaa$var$endstream),
    EOF2endstream: (0, $273XO.__spreadArrays)([
        $8b93c77c2612edaa$var$CarriageReturn
    ], $8b93c77c2612edaa$var$endstream),
    EOF3endstream: (0, $273XO.__spreadArrays)([
        $8b93c77c2612edaa$var$Newline
    ], $8b93c77c2612edaa$var$endstream)
};




var $igTLl = parcelRequire("igTLl");
parcelRequire("5bpFt");
var $8hWZH = parcelRequire("8hWZH");
// TODO: Throw error if eof is reached before finishing object parse...
var $0d2fcd964d08982e$var$PDFObjectParser = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFObjectParser, _super);
    function PDFObjectParser(byteStream, context, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        var _this = _super.call(this, byteStream, capNumbers) || this;
        _this.context = context;
        return _this;
    }
    // TODO: Is it possible to reduce duplicate parsing for ref lookaheads?
    PDFObjectParser.prototype.parseObject = function() {
        this.skipWhitespaceAndComments();
        if (this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).true)) return (0, $63sxC.default).True;
        if (this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).false)) return (0, $63sxC.default).False;
        if (this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).null)) return 0, $634bbd76d2b867c9$export$2e2bcd8739ae039;
        var byte = this.bytes.peek();
        if (byte === (0, $8KH3B.default).LessThan && this.bytes.peekAhead(1) === (0, $8KH3B.default).LessThan) return this.parseDictOrStream();
        if (byte === (0, $8KH3B.default).LessThan) return this.parseHexString();
        if (byte === (0, $8KH3B.default).LeftParen) return this.parseString();
        if (byte === (0, $8KH3B.default).ForwardSlash) return this.parseName();
        if (byte === (0, $8KH3B.default).LeftSquareBracket) return this.parseArray();
        if ((0, $edeff18144c0e6fd$export$4d926b029fa61cfe)[byte]) return this.parseNumberOrRef();
        throw new (0, $iMObG.PDFObjectParsingError)(this.bytes.position(), byte);
    };
    PDFObjectParser.prototype.parseNumberOrRef = function() {
        var firstNum = this.parseRawNumber();
        this.skipWhitespaceAndComments();
        var lookaheadStart = this.bytes.offset();
        if ((0, $edeff18144c0e6fd$export$9492c31549e88980)[this.bytes.peek()]) {
            var secondNum = this.parseRawNumber();
            this.skipWhitespaceAndComments();
            if (this.bytes.peek() === (0, $8KH3B.default).R) {
                this.bytes.assertNext((0, $8KH3B.default).R);
                return (0, $69d09480b29248e9$export$2e2bcd8739ae039).of(firstNum, secondNum);
            }
        }
        this.bytes.moveTo(lookaheadStart);
        return (0, $4MKjy.default).of(firstNum);
    };
    // TODO: Maybe update PDFHexString.of() logic to remove whitespace and validate input?
    PDFObjectParser.prototype.parseHexString = function() {
        var value = '';
        this.bytes.assertNext((0, $8KH3B.default).LessThan);
        while(!this.bytes.done() && this.bytes.peek() !== (0, $8KH3B.default).GreaterThan)value += (0, $8hWZH.charFromCode)(this.bytes.next());
        this.bytes.assertNext((0, $8KH3B.default).GreaterThan);
        return (0, $d8f6d7884257882d$export$2e2bcd8739ae039).of(value);
    };
    PDFObjectParser.prototype.parseString = function() {
        var nestingLvl = 0;
        var isEscaped = false;
        var value = '';
        while(!this.bytes.done()){
            var byte = this.bytes.next();
            value += (0, $8hWZH.charFromCode)(byte);
            // Check for unescaped parenthesis
            if (!isEscaped) {
                if (byte === (0, $8KH3B.default).LeftParen) nestingLvl += 1;
                if (byte === (0, $8KH3B.default).RightParen) nestingLvl -= 1;
            }
            // Track whether current character is being escaped or not
            if (byte === (0, $8KH3B.default).BackSlash) isEscaped = !isEscaped;
            else if (isEscaped) isEscaped = false;
            // Once (if) the unescaped parenthesis balance out, return their contents
            if (nestingLvl === 0) // Remove the outer parens so they aren't part of the contents
            return (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039).of(value.substring(1, value.length - 1));
        }
        throw new (0, $iMObG.UnbalancedParenthesisError)(this.bytes.position());
    };
    // TODO: Compare performance of string concatenation to charFromCode(...bytes)
    // TODO: Maybe preallocate small Uint8Array if can use charFromCode?
    PDFObjectParser.prototype.parseName = function() {
        this.bytes.assertNext((0, $8KH3B.default).ForwardSlash);
        var name = '';
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if ((0, $igTLl.IsWhitespace)[byte] || (0, $cgSZS.IsDelimiter)[byte]) break;
            name += (0, $8hWZH.charFromCode)(byte);
            this.bytes.next();
        }
        return (0, $alPcq.default).of(name);
    };
    PDFObjectParser.prototype.parseArray = function() {
        this.bytes.assertNext((0, $8KH3B.default).LeftSquareBracket);
        this.skipWhitespaceAndComments();
        var pdfArray = (0, $dj8f2.default).withContext(this.context);
        while(this.bytes.peek() !== (0, $8KH3B.default).RightSquareBracket){
            var element = this.parseObject();
            pdfArray.push(element);
            this.skipWhitespaceAndComments();
        }
        this.bytes.assertNext((0, $8KH3B.default).RightSquareBracket);
        return pdfArray;
    };
    PDFObjectParser.prototype.parseDict = function() {
        this.bytes.assertNext((0, $8KH3B.default).LessThan);
        this.bytes.assertNext((0, $8KH3B.default).LessThan);
        this.skipWhitespaceAndComments();
        var dict = new Map();
        while(!this.bytes.done() && this.bytes.peek() !== (0, $8KH3B.default).GreaterThan && this.bytes.peekAhead(1) !== (0, $8KH3B.default).GreaterThan){
            var key = this.parseName();
            var value = this.parseObject();
            dict.set(key, value);
            this.skipWhitespaceAndComments();
        }
        this.skipWhitespaceAndComments();
        this.bytes.assertNext((0, $8KH3B.default).GreaterThan);
        this.bytes.assertNext((0, $8KH3B.default).GreaterThan);
        var Type = dict.get((0, $alPcq.default).of('Type'));
        if (Type === (0, $alPcq.default).of('Catalog')) return (0, $144148f0529ee19d$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else if (Type === (0, $alPcq.default).of('Pages')) return (0, $1ea69a2ae6505d06$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else if (Type === (0, $alPcq.default).of('Page')) return (0, $27cec0c5ad235198$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else return (0, $b7e75d63d5628aec$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
    };
    PDFObjectParser.prototype.parseDictOrStream = function() {
        var startPos = this.bytes.position();
        var dict = this.parseDict();
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).streamEOF1) && !this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).streamEOF2) && !this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).streamEOF3) && !this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).streamEOF4) && !this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).stream)) return dict;
        var start = this.bytes.offset();
        var end;
        var Length = dict.get((0, $alPcq.default).of('Length'));
        if (Length instanceof (0, $4MKjy.default)) {
            end = start + Length.asNumber();
            this.bytes.moveTo(end);
            this.skipWhitespaceAndComments();
            if (!this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).endstream)) {
                this.bytes.moveTo(start);
                end = this.findEndOfStreamFallback(startPos);
            }
        } else end = this.findEndOfStreamFallback(startPos);
        var contents = this.bytes.slice(start, end);
        return (0, $2f4afe25c4da346a$export$2e2bcd8739ae039).of(dict, contents);
    };
    PDFObjectParser.prototype.findEndOfStreamFallback = function(startPos) {
        // Move to end of stream, while handling nested streams
        var nestingLvl = 1;
        var end = this.bytes.offset();
        while(!this.bytes.done()){
            end = this.bytes.offset();
            if (this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).stream)) nestingLvl += 1;
            else if (this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).EOF1endstream) || this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).EOF2endstream) || this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).EOF3endstream) || this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).endstream)) nestingLvl -= 1;
            else this.bytes.next();
            if (nestingLvl === 0) break;
        }
        if (nestingLvl !== 0) throw new (0, $iMObG.PDFStreamParsingError)(startPos);
        return end;
    };
    PDFObjectParser.forBytes = function(bytes, context, capNumbers) {
        return new PDFObjectParser((0, $a12b412bad237828$export$2e2bcd8739ae039).of(bytes), context, capNumbers);
    };
    PDFObjectParser.forByteStream = function(byteStream, context, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        return new PDFObjectParser(byteStream, context, capNumbers);
    };
    return PDFObjectParser;
}((0, $8bafff5f382d3f03$export$2e2bcd8739ae039));
var $0d2fcd964d08982e$export$2e2bcd8739ae039 = $0d2fcd964d08982e$var$PDFObjectParser;



var $273XO = parcelRequire("273XO");

var $iMObG = parcelRequire("iMObG");

var $alPcq = parcelRequire("alPcq");

var $4MKjy = parcelRequire("4MKjy");



parcelRequire("5bpFt");
var $42Fix = parcelRequire("42Fix");
var $c327448ebe4106bc$var$PDFObjectStreamParser = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFObjectStreamParser, _super);
    function PDFObjectStreamParser(rawStream, shouldWaitForTick) {
        var _this = _super.call(this, (0, $a12b412bad237828$export$2e2bcd8739ae039).fromPDFRawStream(rawStream), rawStream.dict.context) || this;
        var dict = rawStream.dict;
        _this.alreadyParsed = false;
        _this.shouldWaitForTick = shouldWaitForTick || function() {
            return false;
        };
        _this.firstOffset = dict.lookup((0, $alPcq.default).of('First'), (0, $4MKjy.default)).asNumber();
        _this.objectCount = dict.lookup((0, $alPcq.default).of('N'), (0, $4MKjy.default)).asNumber();
        return _this;
    }
    PDFObjectStreamParser.prototype.parseIntoContext = function() {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var offsetsAndObjectNumbers, idx, len, _a, objectNumber, offset, object, ref;
            return (0, $273XO.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.alreadyParsed) throw new (0, $iMObG.ReparseError)('PDFObjectStreamParser', 'parseIntoContext');
                        this.alreadyParsed = true;
                        offsetsAndObjectNumbers = this.parseOffsetsAndObjectNumbers();
                        idx = 0, len = offsetsAndObjectNumbers.length;
                        _b.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a = offsetsAndObjectNumbers[idx], objectNumber = _a.objectNumber, offset = _a.offset;
                        this.bytes.moveTo(this.firstOffset + offset);
                        object = this.parseObject();
                        ref = (0, $69d09480b29248e9$export$2e2bcd8739ae039).of(objectNumber, 0);
                        this.context.assign(ref, object);
                        if (!this.shouldWaitForTick()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $42Fix.waitForTick)()
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFObjectStreamParser.prototype.parseOffsetsAndObjectNumbers = function() {
        var offsetsAndObjectNumbers = [];
        for(var idx = 0, len = this.objectCount; idx < len; idx++){
            this.skipWhitespaceAndComments();
            var objectNumber = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var offset = this.parseRawInt();
            offsetsAndObjectNumbers.push({
                objectNumber: objectNumber,
                offset: offset
            });
        }
        return offsetsAndObjectNumbers;
    };
    PDFObjectStreamParser.forStream = function(rawStream, shouldWaitForTick) {
        return new PDFObjectStreamParser(rawStream, shouldWaitForTick);
    };
    return PDFObjectStreamParser;
}((0, $0d2fcd964d08982e$export$2e2bcd8739ae039));
var $c327448ebe4106bc$export$2e2bcd8739ae039 = $c327448ebe4106bc$var$PDFObjectStreamParser;



var $273XO = parcelRequire("273XO");




var $iMObG = parcelRequire("iMObG");



var $alPcq = parcelRequire("alPcq");






var $iMObG = parcelRequire("iMObG");

var $dj8f2 = parcelRequire("dj8f2");

var $alPcq = parcelRequire("alPcq");

var $4MKjy = parcelRequire("4MKjy");


var $2c160b3b1674c3f3$var$PDFXRefStreamParser = /** @class */ function() {
    function PDFXRefStreamParser(rawStream) {
        this.alreadyParsed = false;
        this.dict = rawStream.dict;
        this.bytes = (0, $a12b412bad237828$export$2e2bcd8739ae039).fromPDFRawStream(rawStream);
        this.context = this.dict.context;
        var Size = this.dict.lookup((0, $alPcq.default).of('Size'), (0, $4MKjy.default));
        var Index = this.dict.lookup((0, $alPcq.default).of('Index'));
        if (Index instanceof (0, $dj8f2.default)) {
            this.subsections = [];
            for(var idx = 0, len = Index.size(); idx < len; idx += 2){
                var firstObjectNumber = Index.lookup(idx + 0, (0, $4MKjy.default)).asNumber();
                var length_1 = Index.lookup(idx + 1, (0, $4MKjy.default)).asNumber();
                this.subsections.push({
                    firstObjectNumber: firstObjectNumber,
                    length: length_1
                });
            }
        } else this.subsections = [
            {
                firstObjectNumber: 0,
                length: Size.asNumber()
            }
        ];
        var W = this.dict.lookup((0, $alPcq.default).of('W'), (0, $dj8f2.default));
        this.byteWidths = [
            -1,
            -1,
            -1
        ];
        for(var idx = 0, len = W.size(); idx < len; idx++)this.byteWidths[idx] = W.lookup(idx, (0, $4MKjy.default)).asNumber();
    }
    PDFXRefStreamParser.prototype.parseIntoContext = function() {
        if (this.alreadyParsed) throw new (0, $iMObG.ReparseError)('PDFXRefStreamParser', 'parseIntoContext');
        this.alreadyParsed = true;
        this.context.trailerInfo = {
            Root: this.dict.get((0, $alPcq.default).of('Root')),
            Encrypt: this.dict.get((0, $alPcq.default).of('Encrypt')),
            Info: this.dict.get((0, $alPcq.default).of('Info')),
            ID: this.dict.get((0, $alPcq.default).of('ID'))
        };
        var entries = this.parseEntries();
        // for (let idx = 0, len = entries.length; idx < len; idx++) {
        // const entry = entries[idx];
        // if (entry.deleted) this.context.delete(entry.ref);
        // }
        return entries;
    };
    PDFXRefStreamParser.prototype.parseEntries = function() {
        var entries = [];
        var _a = this.byteWidths, typeFieldWidth = _a[0], offsetFieldWidth = _a[1], genFieldWidth = _a[2];
        for(var subsectionIdx = 0, subsectionLen = this.subsections.length; subsectionIdx < subsectionLen; subsectionIdx++){
            var _b = this.subsections[subsectionIdx], firstObjectNumber = _b.firstObjectNumber, length_2 = _b.length;
            for(var objIdx = 0; objIdx < length_2; objIdx++){
                var type = 0;
                for(var idx = 0, len = typeFieldWidth; idx < len; idx++)type = type << 8 | this.bytes.next();
                var offset = 0;
                for(var idx = 0, len = offsetFieldWidth; idx < len; idx++)offset = offset << 8 | this.bytes.next();
                var generationNumber = 0;
                for(var idx = 0, len = genFieldWidth; idx < len; idx++)generationNumber = generationNumber << 8 | this.bytes.next();
                // When the `type` field is absent, it defaults to 1
                if (typeFieldWidth === 0) type = 1;
                var objectNumber = firstObjectNumber + objIdx;
                var entry = {
                    ref: (0, $69d09480b29248e9$export$2e2bcd8739ae039).of(objectNumber, generationNumber),
                    offset: offset,
                    deleted: type === 0,
                    inObjectStream: type === 2
                };
                entries.push(entry);
            }
        }
        return entries;
    };
    PDFXRefStreamParser.forStream = function(rawStream) {
        return new PDFXRefStreamParser(rawStream);
    };
    return PDFXRefStreamParser;
}();
var $2c160b3b1674c3f3$export$2e2bcd8739ae039 = $2c160b3b1674c3f3$var$PDFXRefStreamParser;




var $8KH3B = parcelRequire("8KH3B");


parcelRequire("5bpFt");
var $42Fix = parcelRequire("42Fix");
var $efca7de1544c77bc$var$PDFParser = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFParser, _super);
    function PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
        if (objectsPerTick === void 0) objectsPerTick = Infinity;
        if (throwOnInvalidObject === void 0) throwOnInvalidObject = false;
        if (capNumbers === void 0) capNumbers = false;
        var _this = _super.call(this, (0, $a12b412bad237828$export$2e2bcd8739ae039).of(pdfBytes), (0, $dcc6ee7d53aa6a90$export$2e2bcd8739ae039).create(), capNumbers) || this;
        _this.alreadyParsed = false;
        _this.parsedObjects = 0;
        _this.shouldWaitForTick = function() {
            _this.parsedObjects += 1;
            return _this.parsedObjects % _this.objectsPerTick === 0;
        };
        _this.objectsPerTick = objectsPerTick;
        _this.throwOnInvalidObject = throwOnInvalidObject;
        return _this;
    }
    PDFParser.prototype.parseDocument = function() {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var prevOffset, offset;
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.alreadyParsed) throw new (0, $iMObG.ReparseError)('PDFParser', 'parseDocument');
                        this.alreadyParsed = true;
                        this.context.header = this.parseHeader();
                        _a.label = 1;
                    case 1:
                        if (!!this.bytes.done()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.parseDocumentSection()
                        ];
                    case 2:
                        _a.sent();
                        offset = this.bytes.offset();
                        if (offset === prevOffset) throw new (0, $iMObG.StalledParserError)(this.bytes.position());
                        prevOffset = offset;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 3:
                        this.maybeRecoverRoot();
                        if (this.context.lookup((0, $69d09480b29248e9$export$2e2bcd8739ae039).of(0))) {
                            console.warn('Removing parsed object: 0 0 R');
                            this.context.delete((0, $69d09480b29248e9$export$2e2bcd8739ae039).of(0));
                        }
                        return [
                            2 /*return*/ ,
                            this.context
                        ];
                }
            });
        });
    };
    PDFParser.prototype.maybeRecoverRoot = function() {
        var isValidCatalog = function(obj) {
            return obj instanceof (0, $b7e75d63d5628aec$export$2e2bcd8739ae039) && obj.lookup((0, $alPcq.default).of('Type')) === (0, $alPcq.default).of('Catalog');
        };
        var catalog = this.context.lookup(this.context.trailerInfo.Root);
        if (!isValidCatalog(catalog)) {
            var indirectObjects = this.context.enumerateIndirectObjects();
            for(var idx = 0, len = indirectObjects.length; idx < len; idx++){
                var _a = indirectObjects[idx], ref = _a[0], object = _a[1];
                if (isValidCatalog(object)) this.context.trailerInfo.Root = ref;
            }
        }
    };
    PDFParser.prototype.parseHeader = function() {
        while(!this.bytes.done()){
            if (this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).header)) {
                var major = this.parseRawInt();
                this.bytes.assertNext((0, $8KH3B.default).Period);
                var minor = this.parseRawInt();
                var header = (0, $526f381db166a209$export$2e2bcd8739ae039).forVersion(major, minor);
                this.skipBinaryHeaderComment();
                return header;
            }
            this.bytes.next();
        }
        throw new (0, $iMObG.MissingPDFHeaderError)(this.bytes.position());
    };
    PDFParser.prototype.parseIndirectObjectHeader = function() {
        this.skipWhitespaceAndComments();
        var objectNumber = this.parseRawInt();
        this.skipWhitespaceAndComments();
        var generationNumber = this.parseRawInt();
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).obj)) throw new (0, $iMObG.MissingKeywordError)(this.bytes.position(), (0, $8b93c77c2612edaa$export$93ad50ccfacdd77).obj);
        return (0, $69d09480b29248e9$export$2e2bcd8739ae039).of(objectNumber, generationNumber);
    };
    PDFParser.prototype.matchIndirectObjectHeader = function() {
        var initialOffset = this.bytes.offset();
        try {
            this.parseIndirectObjectHeader();
            return true;
        } catch (e) {
            this.bytes.moveTo(initialOffset);
            return false;
        }
    };
    PDFParser.prototype.parseIndirectObject = function() {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var ref, object;
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ref = this.parseIndirectObjectHeader();
                        this.skipWhitespaceAndComments();
                        object = this.parseObject();
                        this.skipWhitespaceAndComments();
                        // if (!this.matchKeyword(Keywords.endobj)) {
                        // throw new MissingKeywordError(this.bytes.position(), Keywords.endobj);
                        // }
                        // TODO: Log a warning if this fails...
                        this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).endobj);
                        if (!(object instanceof (0, $2f4afe25c4da346a$export$2e2bcd8739ae039) && object.dict.lookup((0, $alPcq.default).of('Type')) === (0, $alPcq.default).of('ObjStm'))) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $c327448ebe4106bc$export$2e2bcd8739ae039).forStream(object, this.shouldWaitForTick).parseIntoContext()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        if (object instanceof (0, $2f4afe25c4da346a$export$2e2bcd8739ae039) && object.dict.lookup((0, $alPcq.default).of('Type')) === (0, $alPcq.default).of('XRef')) (0, $2c160b3b1674c3f3$export$2e2bcd8739ae039).forStream(object).parseIntoContext();
                        else this.context.assign(ref, object);
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ ,
                            ref
                        ];
                }
            });
        });
    };
    // TODO: Improve and clean this up
    PDFParser.prototype.tryToParseInvalidIndirectObject = function() {
        var startPos = this.bytes.position();
        var msg = "Trying to parse invalid object: " + JSON.stringify(startPos) + ")";
        if (this.throwOnInvalidObject) throw new Error(msg);
        console.warn(msg);
        var ref = this.parseIndirectObjectHeader();
        console.warn("Invalid object ref: " + ref);
        this.skipWhitespaceAndComments();
        var start = this.bytes.offset();
        var failed = true;
        while(!this.bytes.done()){
            if (this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).endobj)) failed = false;
            if (!failed) break;
            this.bytes.next();
        }
        if (failed) throw new (0, $iMObG.PDFInvalidObjectParsingError)(startPos);
        var end = this.bytes.offset() - (0, $8b93c77c2612edaa$export$93ad50ccfacdd77).endobj.length;
        var object = (0, $393c3204b5eece76$export$2e2bcd8739ae039).of(this.bytes.slice(start, end));
        this.context.assign(ref, object);
        return ref;
    };
    PDFParser.prototype.parseIndirectObjects = function() {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var initialOffset, e_1;
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.skipWhitespaceAndComments();
                        _a.label = 1;
                    case 1:
                        if (!(!this.bytes.done() && (0, $edeff18144c0e6fd$export$9492c31549e88980)[this.bytes.peek()])) return [
                            3 /*break*/ ,
                            8
                        ];
                        initialOffset = this.bytes.offset();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.parseIndirectObject()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        e_1 = _a.sent();
                        // TODO: Add tracing/logging mechanism to track when this happens!
                        this.bytes.moveTo(initialOffset);
                        this.tryToParseInvalidIndirectObject();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        this.skipWhitespaceAndComments();
                        // TODO: Can this be done only when needed, to avoid harming performance?
                        this.skipJibberish();
                        if (!this.shouldWaitForTick()) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $42Fix.waitForTick)()
                        ];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFParser.prototype.maybeParseCrossRefSection = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).xref)) return;
        this.skipWhitespaceAndComments();
        var objectNumber = -1;
        var xref = (0, $9c4138d1e86666d6$export$2e2bcd8739ae039).createEmpty();
        while(!this.bytes.done() && (0, $edeff18144c0e6fd$export$9492c31549e88980)[this.bytes.peek()]){
            var firstInt = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var secondInt = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var byte = this.bytes.peek();
            if (byte === (0, $8KH3B.default).n || byte === (0, $8KH3B.default).f) {
                var ref = (0, $69d09480b29248e9$export$2e2bcd8739ae039).of(objectNumber, secondInt);
                if (this.bytes.next() === (0, $8KH3B.default).n) xref.addEntry(ref, firstInt);
                else // this.context.delete(ref);
                xref.addDeletedEntry(ref, firstInt);
                objectNumber += 1;
            } else objectNumber = firstInt;
            this.skipWhitespaceAndComments();
        }
        return xref;
    };
    PDFParser.prototype.maybeParseTrailerDict = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).trailer)) return;
        this.skipWhitespaceAndComments();
        var dict = this.parseDict();
        var context = this.context;
        context.trailerInfo = {
            Root: dict.get((0, $alPcq.default).of('Root')) || context.trailerInfo.Root,
            Encrypt: dict.get((0, $alPcq.default).of('Encrypt')) || context.trailerInfo.Encrypt,
            Info: dict.get((0, $alPcq.default).of('Info')) || context.trailerInfo.Info,
            ID: dict.get((0, $alPcq.default).of('ID')) || context.trailerInfo.ID
        };
    };
    PDFParser.prototype.maybeParseTrailer = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).startxref)) return;
        this.skipWhitespaceAndComments();
        var offset = this.parseRawInt();
        this.skipWhitespace();
        this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).eof);
        this.skipWhitespaceAndComments();
        this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).eof);
        this.skipWhitespaceAndComments();
        return (0, $61285794ba3149fa$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(offset);
    };
    PDFParser.prototype.parseDocumentSection = function() {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.parseIndirectObjects()
                        ];
                    case 1:
                        _a.sent();
                        this.maybeParseCrossRefSection();
                        this.maybeParseTrailerDict();
                        this.maybeParseTrailer();
                        // TODO: Can this be done only when needed, to avoid harming performance?
                        this.skipJibberish();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * This operation is not necessary for valid PDF files. But some invalid PDFs
     * contain jibberish in between indirect objects. This method is designed to
     * skip past that jibberish, should it exist, until it reaches the next
     * indirect object header, an xref table section, or the file trailer.
     */ PDFParser.prototype.skipJibberish = function() {
        this.skipWhitespaceAndComments();
        while(!this.bytes.done()){
            var initialOffset = this.bytes.offset();
            var byte = this.bytes.peek();
            var isAlphaNumeric = byte >= (0, $8KH3B.default).Space && byte <= (0, $8KH3B.default).Tilde;
            if (isAlphaNumeric) {
                if (this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).xref) || this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).trailer) || this.matchKeyword((0, $8b93c77c2612edaa$export$93ad50ccfacdd77).startxref) || this.matchIndirectObjectHeader()) {
                    this.bytes.moveTo(initialOffset);
                    break;
                }
            }
            this.bytes.next();
        }
    };
    /**
     * Skips the binary comment following a PDF header. The specification
     * defines this binary comment (section 7.5.2 File Header) as a sequence of 4
     * or more bytes that are 128 or greater, and which are preceded by a "%".
     *
     * This would imply that to strip out this binary comment, we could check for
     * a sequence of bytes starting with "%", and remove all subsequent bytes that
     * are 128 or greater. This works for many documents that properly comply with
     * the spec. But in the wild, there are PDFs that omit the leading "%", and
     * include bytes that are less than 128 (e.g. 0 or 1). So in order to parse
     * these headers correctly, we just throw out all bytes leading up to the
     * first indirect object header.
     */ PDFParser.prototype.skipBinaryHeaderComment = function() {
        this.skipWhitespaceAndComments();
        try {
            var initialOffset = this.bytes.offset();
            this.parseIndirectObjectHeader();
            this.bytes.moveTo(initialOffset);
        } catch (e) {
            this.bytes.next();
            this.skipWhitespaceAndComments();
        }
    };
    PDFParser.forBytesWithOptions = function(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
        return new PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers);
    };
    return PDFParser;
}((0, $0d2fcd964d08982e$export$2e2bcd8739ae039));
var $efca7de1544c77bc$export$2e2bcd8739ae039 = $efca7de1544c77bc$var$PDFParser;







var $4506fe64ca79cf11$var$flag = function(bitIndex) {
    return 1 << bitIndex;
};
var $4506fe64ca79cf11$export$1fa7b68b35026177;
(function(AnnotationFlags) {
    /**
     * If set, do not display the annotation if it does not belong to one of the
     * standard annotation types and no annotation handler is available. If clear,
     * display such an unknown annotation using an appearance stream specified by
     * its appearance dictionary, if any.
     */ AnnotationFlags[AnnotationFlags["Invisible"] = $4506fe64ca79cf11$var$flag(0)] = "Invisible";
    /**
     * If set, do not display or print the annotation or allow it to interact with
     * the user, regardless of its annotation type or whether an annotation
     * handler is available.
     *
     * In cases where screen space is limited, the ability to hide and show
     * annotations selectively can be used in combination with appearance streams
     * to display auxiliary pop-up information similar in function to online help
     * systems.
     */ AnnotationFlags[AnnotationFlags["Hidden"] = $4506fe64ca79cf11$var$flag(1)] = "Hidden";
    /**
     * If set, print the annotation when the page is printed. If clear, never
     * print the annotation, regardless of whether it is displayed on the screen.
     *
     * This can be useful for annotations representing interactive pushbuttons,
     * which would serve no meaningful purpose on the printed page.
     */ AnnotationFlags[AnnotationFlags["Print"] = $4506fe64ca79cf11$var$flag(2)] = "Print";
    /**
     * If set, do not scale the annotation’s appearance to match the magnification
     * of the page. The location of the annotation on the page (defined by the
     * upper-left corner of its annotation rectangle) shall remain fixed,
     * regardless of the page magnification.
     */ AnnotationFlags[AnnotationFlags["NoZoom"] = $4506fe64ca79cf11$var$flag(3)] = "NoZoom";
    /**
     * If set, do not rotate the annotation’s appearance to match the rotation of
     * the page. The upper-left corner of the annotation rectangle shall remain in
     * a fixed location on the page, regardless of the page rotation.
     */ AnnotationFlags[AnnotationFlags["NoRotate"] = $4506fe64ca79cf11$var$flag(4)] = "NoRotate";
    /**
     * If set, do not display the annotation on the screen or allow it to interact
     * with the user. The annotation may be printed (depending on the setting of
     * the Print flag) but should be considered hidden for purposes of on-screen
     * display and user interaction.
     */ AnnotationFlags[AnnotationFlags["NoView"] = $4506fe64ca79cf11$var$flag(5)] = "NoView";
    /**
     * If set, do not allow the annotation to interact with the user. The
     * annotation may be displayed or printed (depending on the settings of the
     * NoView and Print flags) but should not respond to mouse clicks or change
     * its appearance in response to mouse motions.
     *
     * This flag shall be ignored for widget annotations; its function is
     * subsumed by the ReadOnly flag of the associated form field.
     */ AnnotationFlags[AnnotationFlags["ReadOnly"] = $4506fe64ca79cf11$var$flag(6)] = "ReadOnly";
    /**
     * If set, do not allow the annotation to be deleted or its properties
     * (including position and size) to be modified by the user. However, this
     * flag does not restrict changes to the annotation’s contents, such as the
     * value of a form field.
     */ AnnotationFlags[AnnotationFlags["Locked"] = $4506fe64ca79cf11$var$flag(7)] = "Locked";
    /**
     * If set, invert the interpretation of the NoView flag for certain events.
     *
     * A typical use is to have an annotation that appears only when a mouse
     * cursor is held over it.
     */ AnnotationFlags[AnnotationFlags["ToggleNoView"] = $4506fe64ca79cf11$var$flag(8)] = "ToggleNoView";
    /**
     * If set, do not allow the contents of the annotation to be modified by the
     * user. This flag does not restrict deletion of the annotation or changes to
     * other annotation properties, such as position and size.
     */ AnnotationFlags[AnnotationFlags["LockedContents"] = $4506fe64ca79cf11$var$flag(9)] = "LockedContents";
})($4506fe64ca79cf11$export$1fa7b68b35026177 || ($4506fe64ca79cf11$export$1fa7b68b35026177 = {}));







var $alPcq = parcelRequire("alPcq");
var $4MKjy = parcelRequire("4MKjy");
var $41ecfa60dca9723e$export$69d5e1b305482e08 = function(name) {
    return name instanceof (0, $alPcq.default) ? name : (0, $alPcq.default).of(name);
};
var $41ecfa60dca9723e$export$fb5b5e76a3a5c568 = function(num) {
    return num instanceof (0, $4MKjy.default) ? num : (0, $4MKjy.default).of(num);
};
var $41ecfa60dca9723e$export$37576b9ba69b50db = function(num) {
    return num instanceof (0, $4MKjy.default) ? num.asNumber() : num;
};


parcelRequire("5bpFt");
var $8EKPA = parcelRequire("8EKPA");
var $kug8p = parcelRequire("kug8p");
var $86b75e7e8bb6dd95$export$c3cc0f63dbb3500f;
(function(RotationTypes) {
    RotationTypes["Degrees"] = "degrees";
    RotationTypes["Radians"] = "radians";
})($86b75e7e8bb6dd95$export$c3cc0f63dbb3500f || ($86b75e7e8bb6dd95$export$c3cc0f63dbb3500f = {}));
var $86b75e7e8bb6dd95$export$8449e153fbd325fc = function(radianAngle) {
    (0, $8EKPA.assertIs)(radianAngle, 'radianAngle', [
        'number'
    ]);
    return {
        type: $86b75e7e8bb6dd95$export$c3cc0f63dbb3500f.Radians,
        angle: radianAngle
    };
};
var $86b75e7e8bb6dd95$export$41fc368e1a942b97 = function(degreeAngle) {
    (0, $8EKPA.assertIs)(degreeAngle, 'degreeAngle', [
        'number'
    ]);
    return {
        type: $86b75e7e8bb6dd95$export$c3cc0f63dbb3500f.Degrees,
        angle: degreeAngle
    };
};
var $86b75e7e8bb6dd95$var$Radians = $86b75e7e8bb6dd95$export$c3cc0f63dbb3500f.Radians, $86b75e7e8bb6dd95$var$Degrees = $86b75e7e8bb6dd95$export$c3cc0f63dbb3500f.Degrees;
var $86b75e7e8bb6dd95$export$c9fcf1a7df975d78 = function(degree) {
    return degree * Math.PI / 180;
};
var $86b75e7e8bb6dd95$export$c41dd2a8460d3196 = function(radian) {
    return radian * 180 / Math.PI;
};
var $86b75e7e8bb6dd95$export$cba01ba138429a1d = function(rotation) {
    return rotation.type === $86b75e7e8bb6dd95$var$Radians ? rotation.angle : rotation.type === $86b75e7e8bb6dd95$var$Degrees ? $86b75e7e8bb6dd95$export$c9fcf1a7df975d78(rotation.angle) : (0, $kug8p.error)("Invalid rotation: " + JSON.stringify(rotation));
};
var $86b75e7e8bb6dd95$export$56cb859c01fa134d = function(rotation) {
    return rotation.type === $86b75e7e8bb6dd95$var$Radians ? $86b75e7e8bb6dd95$export$c41dd2a8460d3196(rotation.angle) : rotation.type === $86b75e7e8bb6dd95$var$Degrees ? rotation.angle : (0, $kug8p.error)("Invalid rotation: " + JSON.stringify(rotation));
};
var $86b75e7e8bb6dd95$export$ee0ed07fe78ec05 = function(degreeAngle) {
    if (degreeAngle === void 0) degreeAngle = 0;
    var quadrants = degreeAngle / 90 % 4;
    if (quadrants === 0) return 0;
    if (quadrants === 1) return 90;
    if (quadrants === 2) return 180;
    if (quadrants === 3) return 270;
    return 0; // `degreeAngle` is not a multiple of 90
};
var $86b75e7e8bb6dd95$export$312e44550db33c6a = function(dims, degreeAngle) {
    if (degreeAngle === void 0) degreeAngle = 0;
    var rotation = $86b75e7e8bb6dd95$export$ee0ed07fe78ec05(degreeAngle);
    return rotation === 90 || rotation === 270 ? {
        width: dims.height,
        height: dims.width
    } : {
        width: dims.width,
        height: dims.height
    };
};
var $86b75e7e8bb6dd95$export$afddc3b8600307a4 = function(rectangle, borderWidth, degreeAngle) {
    if (borderWidth === void 0) borderWidth = 0;
    if (degreeAngle === void 0) degreeAngle = 0;
    var x = rectangle.x, y = rectangle.y, w = rectangle.width, h = rectangle.height;
    var r = $86b75e7e8bb6dd95$export$ee0ed07fe78ec05(degreeAngle);
    var b = borderWidth / 2;
    // prettier-ignore
    if (r === 0) return {
        x: x - b,
        y: y - b,
        width: w,
        height: h
    };
    else if (r === 90) return {
        x: x - h + b,
        y: y - b,
        width: h,
        height: w
    };
    else if (r === 180) return {
        x: x - w + b,
        y: y - h + b,
        width: w,
        height: h
    };
    else if (r === 270) return {
        x: x - b,
        y: y - w + b,
        width: h,
        height: w
    };
    else return {
        x: x - b,
        y: y - b,
        width: w,
        height: h
    };
};



var $95072c08d604c329$export$e0b576e7a74416cd = function() {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).ClipNonZero);
};
var $95072c08d604c329$export$dd6fb25f201b5a7a = function() {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).ClipEvenOdd);
};
/* ==================== Graphics State Operators ==================== */ var $95072c08d604c329$var$cos = Math.cos, $95072c08d604c329$var$sin = Math.sin, $95072c08d604c329$var$tan = Math.tan;
var $95072c08d604c329$export$ed5b99ee38154497 = function(a, b, c, d, e, f) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).ConcatTransformationMatrix, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(a),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(b),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(c),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(d),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(e),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(f)
    ]);
};
var $95072c08d604c329$export$d73ee8ef04f5226a = function(xPos, yPos) {
    return $95072c08d604c329$export$ed5b99ee38154497(1, 0, 0, 1, xPos, yPos);
};
var $95072c08d604c329$export$dcdf75081b88279d = function(xPos, yPos) {
    return $95072c08d604c329$export$ed5b99ee38154497(xPos, 0, 0, yPos, 0, 0);
};
var $95072c08d604c329$export$a2ba89726971a90f = function(angle) {
    return $95072c08d604c329$export$ed5b99ee38154497($95072c08d604c329$var$cos((0, $41ecfa60dca9723e$export$37576b9ba69b50db)(angle)), $95072c08d604c329$var$sin((0, $41ecfa60dca9723e$export$37576b9ba69b50db)(angle)), -$95072c08d604c329$var$sin((0, $41ecfa60dca9723e$export$37576b9ba69b50db)(angle)), $95072c08d604c329$var$cos((0, $41ecfa60dca9723e$export$37576b9ba69b50db)(angle)), 0, 0);
};
var $95072c08d604c329$export$91df22fbff99d059 = function(angle) {
    return $95072c08d604c329$export$a2ba89726971a90f((0, $86b75e7e8bb6dd95$export$c9fcf1a7df975d78)((0, $41ecfa60dca9723e$export$37576b9ba69b50db)(angle)));
};
var $95072c08d604c329$export$985cb1d69d6a3add = function(xSkewAngle, ySkewAngle) {
    return $95072c08d604c329$export$ed5b99ee38154497(1, $95072c08d604c329$var$tan((0, $41ecfa60dca9723e$export$37576b9ba69b50db)(xSkewAngle)), $95072c08d604c329$var$tan((0, $41ecfa60dca9723e$export$37576b9ba69b50db)(ySkewAngle)), 1, 0, 0);
};
var $95072c08d604c329$export$8ecb831b3efbb169 = function(xSkewAngle, ySkewAngle) {
    return $95072c08d604c329$export$985cb1d69d6a3add((0, $86b75e7e8bb6dd95$export$c9fcf1a7df975d78)((0, $41ecfa60dca9723e$export$37576b9ba69b50db)(xSkewAngle)), (0, $86b75e7e8bb6dd95$export$c9fcf1a7df975d78)((0, $41ecfa60dca9723e$export$37576b9ba69b50db)(ySkewAngle)));
};
var $95072c08d604c329$export$e0e900d241274e06 = function(dashArray, dashPhase) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).SetLineDashPattern, [
        "[" + dashArray.map((0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)).join(' ') + "]",
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(dashPhase)
    ]);
};
var $95072c08d604c329$export$d10d019aadfd45c7 = function() {
    return $95072c08d604c329$export$e0e900d241274e06([], 0);
};
var $95072c08d604c329$export$7a77bc708e50709e;
(function(LineCapStyle) {
    LineCapStyle[LineCapStyle["Butt"] = 0] = "Butt";
    LineCapStyle[LineCapStyle["Round"] = 1] = "Round";
    LineCapStyle[LineCapStyle["Projecting"] = 2] = "Projecting";
})($95072c08d604c329$export$7a77bc708e50709e || ($95072c08d604c329$export$7a77bc708e50709e = {}));
var $95072c08d604c329$export$6c65ed24e870eec = function(style) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).SetLineCapStyle, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(style)
    ]);
};
var $95072c08d604c329$export$cba5d0f1cde60b86;
(function(LineJoinStyle) {
    LineJoinStyle[LineJoinStyle["Miter"] = 0] = "Miter";
    LineJoinStyle[LineJoinStyle["Round"] = 1] = "Round";
    LineJoinStyle[LineJoinStyle["Bevel"] = 2] = "Bevel";
})($95072c08d604c329$export$cba5d0f1cde60b86 || ($95072c08d604c329$export$cba5d0f1cde60b86 = {}));
var $95072c08d604c329$export$97dfb3b4509cd5bc = function(style) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).SetLineJoinStyle, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(style)
    ]);
};
var $95072c08d604c329$export$568567f665d3f3bb = function(state) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).SetGraphicsStateParams, [
        (0, $41ecfa60dca9723e$export$69d5e1b305482e08)(state)
    ]);
};
var $95072c08d604c329$export$cb182c48e35739ac = function() {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).PushGraphicsState);
};
var $95072c08d604c329$export$10581a6f45bf75eb = function() {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).PopGraphicsState);
};
var $95072c08d604c329$export$558e0f90d8262345 = function(width) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).SetLineWidth, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(width)
    ]);
};
var $95072c08d604c329$export$45bd49bb15a3c5cb = function(x1, y1, x2, y2, x3, y3) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).AppendBezierCurve, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(x1),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(y1),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(x2),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(y2),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(x3),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(y3)
    ]);
};
var $95072c08d604c329$export$6f4913b22432f892 = function(x1, y1, x2, y2) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).CurveToReplicateInitialPoint, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(x1),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(y1),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(x2),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(y2)
    ]);
};
var $95072c08d604c329$export$21f87e210c424cd0 = function() {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).ClosePath);
};
var $95072c08d604c329$export$75f1ccd6dc32e80a = function(xPos, yPos) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).MoveTo, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(xPos),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(yPos)
    ]);
};
var $95072c08d604c329$export$73abee0cf983cb99 = function(xPos, yPos) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).LineTo, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(xPos),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(yPos)
    ]);
};
var $95072c08d604c329$export$405b065079b7caf2 = function(xPos, yPos, width, height) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).AppendRectangle, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(xPos),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(yPos),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(width),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(height)
    ]);
};
var $95072c08d604c329$export$dd4f28cef696bc7d = function(xPos, yPos, size) {
    return $95072c08d604c329$export$405b065079b7caf2(xPos, yPos, size, size);
};
var $95072c08d604c329$export$d9b706f8d0a70aef = function() {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).StrokePath);
};
var $95072c08d604c329$export$9563e054e6f787fb = function() {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).FillNonZero);
};
var $95072c08d604c329$export$76d37801baac10fb = function() {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).FillNonZeroAndStroke);
};
var $95072c08d604c329$export$d366e9c0a9bd860f = function() {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).EndPath);
};
var $95072c08d604c329$export$829ffc2dbe358942 = function() {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).NextLine);
};
var $95072c08d604c329$export$b84c1833e225e397 = function(x, y) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).MoveText, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(x),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(y)
    ]);
};
var $95072c08d604c329$export$778bfc3c1a2b7ba4 = function(text) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).ShowText, [
        text
    ]);
};
var $95072c08d604c329$export$337b8dbf65fbb95e = function() {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).BeginText);
};
var $95072c08d604c329$export$e3caa83a99d72806 = function() {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).EndText);
};
var $95072c08d604c329$export$df01d619ff6ce7f7 = function(name, size) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).SetFontAndSize, [
        (0, $41ecfa60dca9723e$export$69d5e1b305482e08)(name),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(size)
    ]);
};
var $95072c08d604c329$export$710392ce2617f080 = function(spacing) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).SetCharacterSpacing, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(spacing)
    ]);
};
var $95072c08d604c329$export$a2801242b2f8967d = function(spacing) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).SetWordSpacing, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(spacing)
    ]);
};
var $95072c08d604c329$export$20dbb065c447b4da = function(squeeze) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).SetTextHorizontalScaling, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(squeeze)
    ]);
};
var $95072c08d604c329$export$79399e66b6bb212c = function(lineHeight) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).SetTextLineHeight, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(lineHeight)
    ]);
};
var $95072c08d604c329$export$ad1653459b07f70c = function(rise) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).SetTextRise, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(rise)
    ]);
};
var $95072c08d604c329$export$ca45e4ab114d4814;
(function(TextRenderingMode) {
    TextRenderingMode[TextRenderingMode["Fill"] = 0] = "Fill";
    TextRenderingMode[TextRenderingMode["Outline"] = 1] = "Outline";
    TextRenderingMode[TextRenderingMode["FillAndOutline"] = 2] = "FillAndOutline";
    TextRenderingMode[TextRenderingMode["Invisible"] = 3] = "Invisible";
    TextRenderingMode[TextRenderingMode["FillAndClip"] = 4] = "FillAndClip";
    TextRenderingMode[TextRenderingMode["OutlineAndClip"] = 5] = "OutlineAndClip";
    TextRenderingMode[TextRenderingMode["FillAndOutlineAndClip"] = 6] = "FillAndOutlineAndClip";
    TextRenderingMode[TextRenderingMode["Clip"] = 7] = "Clip";
})($95072c08d604c329$export$ca45e4ab114d4814 || ($95072c08d604c329$export$ca45e4ab114d4814 = {}));
var $95072c08d604c329$export$99f0dc2c4cb099ab = function(mode) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).SetTextRenderingMode, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(mode)
    ]);
};
var $95072c08d604c329$export$d3656d656af31043 = function(a, b, c, d, e, f) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).SetTextMatrix, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(a),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(b),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(c),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(d),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(e),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(f)
    ]);
};
var $95072c08d604c329$export$f567083ac6aa5aa3 = function(rotationAngle, xSkewAngle, ySkewAngle, x, y) {
    return $95072c08d604c329$export$d3656d656af31043($95072c08d604c329$var$cos((0, $41ecfa60dca9723e$export$37576b9ba69b50db)(rotationAngle)), $95072c08d604c329$var$sin((0, $41ecfa60dca9723e$export$37576b9ba69b50db)(rotationAngle)) + $95072c08d604c329$var$tan((0, $41ecfa60dca9723e$export$37576b9ba69b50db)(xSkewAngle)), -$95072c08d604c329$var$sin((0, $41ecfa60dca9723e$export$37576b9ba69b50db)(rotationAngle)) + $95072c08d604c329$var$tan((0, $41ecfa60dca9723e$export$37576b9ba69b50db)(ySkewAngle)), $95072c08d604c329$var$cos((0, $41ecfa60dca9723e$export$37576b9ba69b50db)(rotationAngle)), x, y);
};
var $95072c08d604c329$export$909384d9b9d39aff = function(rotationAngle, xSkewAngle, ySkewAngle, x, y) {
    return $95072c08d604c329$export$f567083ac6aa5aa3((0, $86b75e7e8bb6dd95$export$c9fcf1a7df975d78)((0, $41ecfa60dca9723e$export$37576b9ba69b50db)(rotationAngle)), (0, $86b75e7e8bb6dd95$export$c9fcf1a7df975d78)((0, $41ecfa60dca9723e$export$37576b9ba69b50db)(xSkewAngle)), (0, $86b75e7e8bb6dd95$export$c9fcf1a7df975d78)((0, $41ecfa60dca9723e$export$37576b9ba69b50db)(ySkewAngle)), x, y);
};
var $95072c08d604c329$export$382c18f8bccd9e2b = function(name) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).DrawObject, [
        (0, $41ecfa60dca9723e$export$69d5e1b305482e08)(name)
    ]);
};
var $95072c08d604c329$export$f30201749d00f572 = function(gray) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).NonStrokingColorGray, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(gray)
    ]);
};
var $95072c08d604c329$export$6502921112196b8f = function(gray) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).StrokingColorGray, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(gray)
    ]);
};
var $95072c08d604c329$export$f59cae633978eea7 = function(red, green, blue) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).NonStrokingColorRgb, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(red),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(green),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(blue)
    ]);
};
var $95072c08d604c329$export$e743468c48a4fd5a = function(red, green, blue) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).StrokingColorRgb, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(red),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(green),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(blue)
    ]);
};
var $95072c08d604c329$export$e836aceb3db98cc0 = function(cyan, magenta, yellow, key) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).NonStrokingColorCmyk, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(cyan),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(magenta),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(yellow),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(key)
    ]);
};
var $95072c08d604c329$export$4004b818fda831c1 = function(cyan, magenta, yellow, key) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).StrokingColorCmyk, [
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(cyan),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(magenta),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(yellow),
        (0, $41ecfa60dca9723e$export$fb5b5e76a3a5c568)(key)
    ]);
};
var $95072c08d604c329$export$a028b403e40f1ab2 = function(tag) {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).BeginMarkedContent, [
        (0, $41ecfa60dca9723e$export$69d5e1b305482e08)(tag)
    ]);
};
var $95072c08d604c329$export$935e2334f5a50589 = function() {
    return (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039).of((0, $711a5af78c053e90$export$2e2bcd8739ae039).EndMarkedContent);
};


parcelRequire("5bpFt");
var $8EKPA = parcelRequire("8EKPA");
var $kug8p = parcelRequire("kug8p");
var $04532fa67d29096c$export$4eb09b1c0a6dec24;
(function(ColorTypes) {
    ColorTypes["Grayscale"] = "Grayscale";
    ColorTypes["RGB"] = "RGB";
    ColorTypes["CMYK"] = "CMYK";
})($04532fa67d29096c$export$4eb09b1c0a6dec24 || ($04532fa67d29096c$export$4eb09b1c0a6dec24 = {}));
var $04532fa67d29096c$export$6f416a6db2dfcd5c = function(gray) {
    (0, $8EKPA.assertRange)(gray, 'gray', 0.0, 1.0);
    return {
        type: $04532fa67d29096c$export$4eb09b1c0a6dec24.Grayscale,
        gray: gray
    };
};
var $04532fa67d29096c$export$8972dc0e6ad9238f = function(red, green, blue) {
    (0, $8EKPA.assertRange)(red, 'red', 0, 1);
    (0, $8EKPA.assertRange)(green, 'green', 0, 1);
    (0, $8EKPA.assertRange)(blue, 'blue', 0, 1);
    return {
        type: $04532fa67d29096c$export$4eb09b1c0a6dec24.RGB,
        red: red,
        green: green,
        blue: blue
    };
};
var $04532fa67d29096c$export$358b1a66a3c77756 = function(cyan, magenta, yellow, key) {
    (0, $8EKPA.assertRange)(cyan, 'cyan', 0, 1);
    (0, $8EKPA.assertRange)(magenta, 'magenta', 0, 1);
    (0, $8EKPA.assertRange)(yellow, 'yellow', 0, 1);
    (0, $8EKPA.assertRange)(key, 'key', 0, 1);
    return {
        type: $04532fa67d29096c$export$4eb09b1c0a6dec24.CMYK,
        cyan: cyan,
        magenta: magenta,
        yellow: yellow,
        key: key
    };
};
var $04532fa67d29096c$var$Grayscale = $04532fa67d29096c$export$4eb09b1c0a6dec24.Grayscale, $04532fa67d29096c$var$RGB = $04532fa67d29096c$export$4eb09b1c0a6dec24.RGB, $04532fa67d29096c$var$CMYK = $04532fa67d29096c$export$4eb09b1c0a6dec24.CMYK;
var $04532fa67d29096c$export$6126e5d7ba707741 = function(color) {
    return color.type === $04532fa67d29096c$var$Grayscale ? (0, $95072c08d604c329$export$f30201749d00f572)(color.gray) : color.type === $04532fa67d29096c$var$RGB ? (0, $95072c08d604c329$export$f59cae633978eea7)(color.red, color.green, color.blue) : color.type === $04532fa67d29096c$var$CMYK ? (0, $95072c08d604c329$export$e836aceb3db98cc0)(color.cyan, color.magenta, color.yellow, color.key) : (0, $kug8p.error)("Invalid color: " + JSON.stringify(color));
};
var $04532fa67d29096c$export$ae31e5cacc8bb23d = function(color) {
    return color.type === $04532fa67d29096c$var$Grayscale ? (0, $95072c08d604c329$export$6502921112196b8f)(color.gray) : color.type === $04532fa67d29096c$var$RGB ? (0, $95072c08d604c329$export$e743468c48a4fd5a)(color.red, color.green, color.blue) : color.type === $04532fa67d29096c$var$CMYK ? (0, $95072c08d604c329$export$4004b818fda831c1)(color.cyan, color.magenta, color.yellow, color.key) : (0, $kug8p.error)("Invalid color: " + JSON.stringify(color));
};
var $04532fa67d29096c$export$8750a268217b0987 = function(comps, scale) {
    if (scale === void 0) scale = 1;
    return (comps === null || comps === void 0 ? void 0 : comps.length) === 1 ? $04532fa67d29096c$export$6f416a6db2dfcd5c(comps[0] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 3 ? $04532fa67d29096c$export$8972dc0e6ad9238f(comps[0] * scale, comps[1] * scale, comps[2] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 4 ? $04532fa67d29096c$export$358b1a66a3c77756(comps[0] * scale, comps[1] * scale, comps[2] * scale, comps[3] * scale) : undefined;
};
var $04532fa67d29096c$export$ffee2793812e3e56 = function(color) {
    return color.type === $04532fa67d29096c$var$Grayscale ? [
        color.gray
    ] : color.type === $04532fa67d29096c$var$RGB ? [
        color.red,
        color.green,
        color.blue
    ] : color.type === $04532fa67d29096c$var$CMYK ? [
        color.cyan,
        color.magenta,
        color.yellow,
        color.key
    ] : (0, $kug8p.error)("Invalid color: " + JSON.stringify(color));
};




// Originated from pdfkit Copyright (c) 2014 Devon Govett
// https://github.com/foliojs/pdfkit/blob/1e62e6ffe24b378eb890df507a47610f4c4a7b24/lib/path.js
// MIT LICENSE
// Updated for pdf-lib & TypeScript by Jeremy Messenger

var $9fb66356d276c3a8$var$cx = 0;
var $9fb66356d276c3a8$var$cy = 0;
var $9fb66356d276c3a8$var$px = 0;
var $9fb66356d276c3a8$var$py = 0;
var $9fb66356d276c3a8$var$sx = 0;
var $9fb66356d276c3a8$var$sy = 0;
var $9fb66356d276c3a8$var$parameters = new Map([
    [
        'A',
        7
    ],
    [
        'a',
        7
    ],
    [
        'C',
        6
    ],
    [
        'c',
        6
    ],
    [
        'H',
        1
    ],
    [
        'h',
        1
    ],
    [
        'L',
        2
    ],
    [
        'l',
        2
    ],
    [
        'M',
        2
    ],
    [
        'm',
        2
    ],
    [
        'Q',
        4
    ],
    [
        'q',
        4
    ],
    [
        'S',
        4
    ],
    [
        's',
        4
    ],
    [
        'T',
        2
    ],
    [
        't',
        2
    ],
    [
        'V',
        1
    ],
    [
        'v',
        1
    ],
    [
        'Z',
        0
    ],
    [
        'z',
        0
    ]
]);
var $9fb66356d276c3a8$var$parse = function(path) {
    var cmd;
    var ret = [];
    var args = [];
    var curArg = '';
    var foundDecimal = false;
    var params = 0;
    for(var _i = 0, path_1 = path; _i < path_1.length; _i++){
        var c = path_1[_i];
        if ($9fb66356d276c3a8$var$parameters.has(c)) {
            params = $9fb66356d276c3a8$var$parameters.get(c);
            if (cmd) {
                // save existing command
                if (curArg.length > 0) args[args.length] = +curArg;
                ret[ret.length] = {
                    cmd: cmd,
                    args: args
                };
                args = [];
                curArg = '';
                foundDecimal = false;
            }
            cmd = c;
        } else if ([
            ' ',
            ','
        ].includes(c) || c === '-' && curArg.length > 0 && curArg[curArg.length - 1] !== 'e' || c === '.' && foundDecimal) {
            if (curArg.length === 0) continue;
            if (args.length === params) {
                // handle reused commands
                ret[ret.length] = {
                    cmd: cmd,
                    args: args
                };
                args = [
                    +curArg
                ];
                // handle assumed commands
                if (cmd === 'M') cmd = 'L';
                if (cmd === 'm') cmd = 'l';
            } else args[args.length] = +curArg;
            foundDecimal = c === '.';
            // fix for negative numbers or repeated decimals with no delimeter between commands
            curArg = [
                '-',
                '.'
            ].includes(c) ? c : '';
        } else {
            curArg += c;
            if (c === '.') foundDecimal = true;
        }
    }
    // add the last command
    if (curArg.length > 0) {
        if (args.length === params) {
            // handle reused commands
            ret[ret.length] = {
                cmd: cmd,
                args: args
            };
            args = [
                +curArg
            ];
            // handle assumed commands
            if (cmd === 'M') cmd = 'L';
            if (cmd === 'm') cmd = 'l';
        } else args[args.length] = +curArg;
    }
    ret[ret.length] = {
        cmd: cmd,
        args: args
    };
    return ret;
};
var $9fb66356d276c3a8$var$apply = function(commands) {
    // current point, control point, and subpath starting point
    $9fb66356d276c3a8$var$cx = $9fb66356d276c3a8$var$cy = $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$py = $9fb66356d276c3a8$var$sx = $9fb66356d276c3a8$var$sy = 0;
    // run the commands
    var cmds = [];
    for(var i = 0; i < commands.length; i++){
        var c = commands[i];
        if (c.cmd && typeof $9fb66356d276c3a8$var$runners[c.cmd] === 'function') {
            var cmd = $9fb66356d276c3a8$var$runners[c.cmd](c.args);
            if (Array.isArray(cmd)) cmds = cmds.concat(cmd);
            else cmds.push(cmd);
        }
    }
    return cmds;
};
var $9fb66356d276c3a8$var$runners = {
    M: function(a) {
        $9fb66356d276c3a8$var$cx = a[0];
        $9fb66356d276c3a8$var$cy = a[1];
        $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$py = null;
        $9fb66356d276c3a8$var$sx = $9fb66356d276c3a8$var$cx;
        $9fb66356d276c3a8$var$sy = $9fb66356d276c3a8$var$cy;
        return (0, $95072c08d604c329$export$75f1ccd6dc32e80a)($9fb66356d276c3a8$var$cx, $9fb66356d276c3a8$var$cy);
    },
    m: function(a) {
        $9fb66356d276c3a8$var$cx += a[0];
        $9fb66356d276c3a8$var$cy += a[1];
        $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$py = null;
        $9fb66356d276c3a8$var$sx = $9fb66356d276c3a8$var$cx;
        $9fb66356d276c3a8$var$sy = $9fb66356d276c3a8$var$cy;
        return (0, $95072c08d604c329$export$75f1ccd6dc32e80a)($9fb66356d276c3a8$var$cx, $9fb66356d276c3a8$var$cy);
    },
    C: function(a) {
        $9fb66356d276c3a8$var$cx = a[4];
        $9fb66356d276c3a8$var$cy = a[5];
        $9fb66356d276c3a8$var$px = a[2];
        $9fb66356d276c3a8$var$py = a[3];
        return (0, $95072c08d604c329$export$45bd49bb15a3c5cb)(a[0], a[1], a[2], a[3], a[4], a[5]);
    },
    c: function(a) {
        var cmd = (0, $95072c08d604c329$export$45bd49bb15a3c5cb)(a[0] + $9fb66356d276c3a8$var$cx, a[1] + $9fb66356d276c3a8$var$cy, a[2] + $9fb66356d276c3a8$var$cx, a[3] + $9fb66356d276c3a8$var$cy, a[4] + $9fb66356d276c3a8$var$cx, a[5] + $9fb66356d276c3a8$var$cy);
        $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$cx + a[2];
        $9fb66356d276c3a8$var$py = $9fb66356d276c3a8$var$cy + a[3];
        $9fb66356d276c3a8$var$cx += a[4];
        $9fb66356d276c3a8$var$cy += a[5];
        return cmd;
    },
    S: function(a) {
        if ($9fb66356d276c3a8$var$px === null || $9fb66356d276c3a8$var$py === null) {
            $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$cx;
            $9fb66356d276c3a8$var$py = $9fb66356d276c3a8$var$cy;
        }
        var cmd = (0, $95072c08d604c329$export$45bd49bb15a3c5cb)($9fb66356d276c3a8$var$cx - ($9fb66356d276c3a8$var$px - $9fb66356d276c3a8$var$cx), $9fb66356d276c3a8$var$cy - ($9fb66356d276c3a8$var$py - $9fb66356d276c3a8$var$cy), a[0], a[1], a[2], a[3]);
        $9fb66356d276c3a8$var$px = a[0];
        $9fb66356d276c3a8$var$py = a[1];
        $9fb66356d276c3a8$var$cx = a[2];
        $9fb66356d276c3a8$var$cy = a[3];
        return cmd;
    },
    s: function(a) {
        if ($9fb66356d276c3a8$var$px === null || $9fb66356d276c3a8$var$py === null) {
            $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$cx;
            $9fb66356d276c3a8$var$py = $9fb66356d276c3a8$var$cy;
        }
        var cmd = (0, $95072c08d604c329$export$45bd49bb15a3c5cb)($9fb66356d276c3a8$var$cx - ($9fb66356d276c3a8$var$px - $9fb66356d276c3a8$var$cx), $9fb66356d276c3a8$var$cy - ($9fb66356d276c3a8$var$py - $9fb66356d276c3a8$var$cy), $9fb66356d276c3a8$var$cx + a[0], $9fb66356d276c3a8$var$cy + a[1], $9fb66356d276c3a8$var$cx + a[2], $9fb66356d276c3a8$var$cy + a[3]);
        $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$cx + a[0];
        $9fb66356d276c3a8$var$py = $9fb66356d276c3a8$var$cy + a[1];
        $9fb66356d276c3a8$var$cx += a[2];
        $9fb66356d276c3a8$var$cy += a[3];
        return cmd;
    },
    Q: function(a) {
        $9fb66356d276c3a8$var$px = a[0];
        $9fb66356d276c3a8$var$py = a[1];
        $9fb66356d276c3a8$var$cx = a[2];
        $9fb66356d276c3a8$var$cy = a[3];
        return (0, $95072c08d604c329$export$6f4913b22432f892)(a[0], a[1], $9fb66356d276c3a8$var$cx, $9fb66356d276c3a8$var$cy);
    },
    q: function(a) {
        var cmd = (0, $95072c08d604c329$export$6f4913b22432f892)(a[0] + $9fb66356d276c3a8$var$cx, a[1] + $9fb66356d276c3a8$var$cy, a[2] + $9fb66356d276c3a8$var$cx, a[3] + $9fb66356d276c3a8$var$cy);
        $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$cx + a[0];
        $9fb66356d276c3a8$var$py = $9fb66356d276c3a8$var$cy + a[1];
        $9fb66356d276c3a8$var$cx += a[2];
        $9fb66356d276c3a8$var$cy += a[3];
        return cmd;
    },
    T: function(a) {
        if ($9fb66356d276c3a8$var$px === null || $9fb66356d276c3a8$var$py === null) {
            $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$cx;
            $9fb66356d276c3a8$var$py = $9fb66356d276c3a8$var$cy;
        } else {
            $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$cx - ($9fb66356d276c3a8$var$px - $9fb66356d276c3a8$var$cx);
            $9fb66356d276c3a8$var$py = $9fb66356d276c3a8$var$cy - ($9fb66356d276c3a8$var$py - $9fb66356d276c3a8$var$cy);
        }
        var cmd = (0, $95072c08d604c329$export$6f4913b22432f892)($9fb66356d276c3a8$var$px, $9fb66356d276c3a8$var$py, a[0], a[1]);
        $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$cx - ($9fb66356d276c3a8$var$px - $9fb66356d276c3a8$var$cx);
        $9fb66356d276c3a8$var$py = $9fb66356d276c3a8$var$cy - ($9fb66356d276c3a8$var$py - $9fb66356d276c3a8$var$cy);
        $9fb66356d276c3a8$var$cx = a[0];
        $9fb66356d276c3a8$var$cy = a[1];
        return cmd;
    },
    t: function(a) {
        if ($9fb66356d276c3a8$var$px === null || $9fb66356d276c3a8$var$py === null) {
            $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$cx;
            $9fb66356d276c3a8$var$py = $9fb66356d276c3a8$var$cy;
        } else {
            $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$cx - ($9fb66356d276c3a8$var$px - $9fb66356d276c3a8$var$cx);
            $9fb66356d276c3a8$var$py = $9fb66356d276c3a8$var$cy - ($9fb66356d276c3a8$var$py - $9fb66356d276c3a8$var$cy);
        }
        var cmd = (0, $95072c08d604c329$export$6f4913b22432f892)($9fb66356d276c3a8$var$px, $9fb66356d276c3a8$var$py, $9fb66356d276c3a8$var$cx + a[0], $9fb66356d276c3a8$var$cy + a[1]);
        $9fb66356d276c3a8$var$cx += a[0];
        $9fb66356d276c3a8$var$cy += a[1];
        return cmd;
    },
    A: function(a) {
        var cmds = $9fb66356d276c3a8$var$solveArc($9fb66356d276c3a8$var$cx, $9fb66356d276c3a8$var$cy, a);
        $9fb66356d276c3a8$var$cx = a[5];
        $9fb66356d276c3a8$var$cy = a[6];
        return cmds;
    },
    a: function(a) {
        a[5] += $9fb66356d276c3a8$var$cx;
        a[6] += $9fb66356d276c3a8$var$cy;
        var cmds = $9fb66356d276c3a8$var$solveArc($9fb66356d276c3a8$var$cx, $9fb66356d276c3a8$var$cy, a);
        $9fb66356d276c3a8$var$cx = a[5];
        $9fb66356d276c3a8$var$cy = a[6];
        return cmds;
    },
    L: function(a) {
        $9fb66356d276c3a8$var$cx = a[0];
        $9fb66356d276c3a8$var$cy = a[1];
        $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$py = null;
        return (0, $95072c08d604c329$export$73abee0cf983cb99)($9fb66356d276c3a8$var$cx, $9fb66356d276c3a8$var$cy);
    },
    l: function(a) {
        $9fb66356d276c3a8$var$cx += a[0];
        $9fb66356d276c3a8$var$cy += a[1];
        $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$py = null;
        return (0, $95072c08d604c329$export$73abee0cf983cb99)($9fb66356d276c3a8$var$cx, $9fb66356d276c3a8$var$cy);
    },
    H: function(a) {
        $9fb66356d276c3a8$var$cx = a[0];
        $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$py = null;
        return (0, $95072c08d604c329$export$73abee0cf983cb99)($9fb66356d276c3a8$var$cx, $9fb66356d276c3a8$var$cy);
    },
    h: function(a) {
        $9fb66356d276c3a8$var$cx += a[0];
        $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$py = null;
        return (0, $95072c08d604c329$export$73abee0cf983cb99)($9fb66356d276c3a8$var$cx, $9fb66356d276c3a8$var$cy);
    },
    V: function(a) {
        $9fb66356d276c3a8$var$cy = a[0];
        $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$py = null;
        return (0, $95072c08d604c329$export$73abee0cf983cb99)($9fb66356d276c3a8$var$cx, $9fb66356d276c3a8$var$cy);
    },
    v: function(a) {
        $9fb66356d276c3a8$var$cy += a[0];
        $9fb66356d276c3a8$var$px = $9fb66356d276c3a8$var$py = null;
        return (0, $95072c08d604c329$export$73abee0cf983cb99)($9fb66356d276c3a8$var$cx, $9fb66356d276c3a8$var$cy);
    },
    Z: function() {
        var cmd = (0, $95072c08d604c329$export$21f87e210c424cd0)();
        $9fb66356d276c3a8$var$cx = $9fb66356d276c3a8$var$sx;
        $9fb66356d276c3a8$var$cy = $9fb66356d276c3a8$var$sy;
        return cmd;
    },
    z: function() {
        var cmd = (0, $95072c08d604c329$export$21f87e210c424cd0)();
        $9fb66356d276c3a8$var$cx = $9fb66356d276c3a8$var$sx;
        $9fb66356d276c3a8$var$cy = $9fb66356d276c3a8$var$sy;
        return cmd;
    }
};
var $9fb66356d276c3a8$var$solveArc = function(x, y, coords) {
    var rx = coords[0], ry = coords[1], rot = coords[2], large = coords[3], sweep = coords[4], ex = coords[5], ey = coords[6];
    var segs = $9fb66356d276c3a8$var$arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
    var cmds = [];
    for(var _i = 0, segs_1 = segs; _i < segs_1.length; _i++){
        var seg = segs_1[_i];
        var bez = $9fb66356d276c3a8$var$segmentToBezier.apply(void 0, seg);
        cmds.push((0, $95072c08d604c329$export$45bd49bb15a3c5cb).apply(void 0, bez));
    }
    return cmds;
};
// from Inkscape svgtopdf, thanks!
var $9fb66356d276c3a8$var$arcToSegments = function(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
    var th = rotateX * (Math.PI / 180);
    var sinTh = Math.sin(th);
    var cosTh = Math.cos(th);
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    $9fb66356d276c3a8$var$px = cosTh * (ox - x) * 0.5 + sinTh * (oy - y) * 0.5;
    $9fb66356d276c3a8$var$py = cosTh * (oy - y) * 0.5 - sinTh * (ox - x) * 0.5;
    var pl = $9fb66356d276c3a8$var$px * $9fb66356d276c3a8$var$px / (rx * rx) + $9fb66356d276c3a8$var$py * $9fb66356d276c3a8$var$py / (ry * ry);
    if (pl > 1) {
        pl = Math.sqrt(pl);
        rx *= pl;
        ry *= pl;
    }
    var a00 = cosTh / rx;
    var a01 = sinTh / rx;
    var a10 = -sinTh / ry;
    var a11 = cosTh / ry;
    var x0 = a00 * ox + a01 * oy;
    var y0 = a10 * ox + a11 * oy;
    var x1 = a00 * x + a01 * y;
    var y1 = a10 * x + a11 * y;
    var d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
    var sfactorSq = 1 / d - 0.25;
    if (sfactorSq < 0) sfactorSq = 0;
    var sfactor = Math.sqrt(sfactorSq);
    if (sweep === large) sfactor = -sfactor;
    var xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
    var yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
    var th0 = Math.atan2(y0 - yc, x0 - xc);
    var th1 = Math.atan2(y1 - yc, x1 - xc);
    var thArc = th1 - th0;
    if (thArc < 0 && sweep === 1) thArc += 2 * Math.PI;
    else if (thArc > 0 && sweep === 0) thArc -= 2 * Math.PI;
    var segments = Math.ceil(Math.abs(thArc / (Math.PI * 0.5 + 0.001)));
    var result = [];
    for(var i = 0; i < segments; i++){
        var th2 = th0 + i * thArc / segments;
        var th3 = th0 + (i + 1) * thArc / segments;
        result[i] = [
            xc,
            yc,
            th2,
            th3,
            rx,
            ry,
            sinTh,
            cosTh
        ];
    }
    return result;
};
var $9fb66356d276c3a8$var$segmentToBezier = function(cx1, cy1, th0, th1, rx, ry, sinTh, cosTh) {
    var a00 = cosTh * rx;
    var a01 = -sinTh * ry;
    var a10 = sinTh * rx;
    var a11 = cosTh * ry;
    var thHalf = 0.5 * (th1 - th0);
    var t = 8 / 3 * Math.sin(thHalf * 0.5) * Math.sin(thHalf * 0.5) / Math.sin(thHalf);
    var x1 = cx1 + Math.cos(th0) - t * Math.sin(th0);
    var y1 = cy1 + Math.sin(th0) + t * Math.cos(th0);
    var x3 = cx1 + Math.cos(th1);
    var y3 = cy1 + Math.sin(th1);
    var x2 = x3 + t * Math.sin(th1);
    var y2 = y3 - t * Math.cos(th1);
    var result = [
        a00 * x1 + a01 * y1,
        a10 * x1 + a11 * y1,
        a00 * x2 + a01 * y2,
        a10 * x2 + a11 * y2,
        a00 * x3 + a01 * y3,
        a10 * x3 + a11 * y3
    ];
    return result;
};
var $9fb66356d276c3a8$export$8de5166f0a5bde2a = function(path) {
    return $9fb66356d276c3a8$var$apply($9fb66356d276c3a8$var$parse(path));
};



var $c3fbae23fda05c7a$export$b11bd9a0808bdc9 = function(line, options) {
    return [
        (0, $95072c08d604c329$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $95072c08d604c329$export$568567f665d3f3bb)(options.graphicsState),
        (0, $95072c08d604c329$export$337b8dbf65fbb95e)(),
        (0, $04532fa67d29096c$export$6126e5d7ba707741)(options.color),
        (0, $95072c08d604c329$export$df01d619ff6ce7f7)(options.font, options.size),
        (0, $95072c08d604c329$export$f567083ac6aa5aa3)((0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(options.rotate), (0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(options.xSkew), (0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(options.ySkew), options.x, options.y),
        (0, $95072c08d604c329$export$778bfc3c1a2b7ba4)(line),
        (0, $95072c08d604c329$export$e3caa83a99d72806)(),
        (0, $95072c08d604c329$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $c3fbae23fda05c7a$export$f7b8b44d3d84bc26 = function(lines, options) {
    var operators = [
        (0, $95072c08d604c329$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $95072c08d604c329$export$568567f665d3f3bb)(options.graphicsState),
        (0, $95072c08d604c329$export$337b8dbf65fbb95e)(),
        (0, $04532fa67d29096c$export$6126e5d7ba707741)(options.color),
        (0, $95072c08d604c329$export$df01d619ff6ce7f7)(options.font, options.size),
        (0, $95072c08d604c329$export$79399e66b6bb212c)(options.lineHeight),
        (0, $95072c08d604c329$export$f567083ac6aa5aa3)((0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(options.rotate), (0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(options.xSkew), (0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(options.ySkew), options.x, options.y)
    ].filter(Boolean);
    for(var idx = 0, len = lines.length; idx < len; idx++)operators.push((0, $95072c08d604c329$export$778bfc3c1a2b7ba4)(lines[idx]), (0, $95072c08d604c329$export$829ffc2dbe358942)());
    operators.push((0, $95072c08d604c329$export$e3caa83a99d72806)(), (0, $95072c08d604c329$export$10581a6f45bf75eb)());
    return operators;
};
var $c3fbae23fda05c7a$export$21a059be5bfd5fb = function(name, options) {
    return [
        (0, $95072c08d604c329$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $95072c08d604c329$export$568567f665d3f3bb)(options.graphicsState),
        (0, $95072c08d604c329$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $95072c08d604c329$export$a2ba89726971a90f)((0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(options.rotate)),
        (0, $95072c08d604c329$export$dcdf75081b88279d)(options.width, options.height),
        (0, $95072c08d604c329$export$985cb1d69d6a3add)((0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(options.xSkew), (0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(options.ySkew)),
        (0, $95072c08d604c329$export$382c18f8bccd9e2b)(name),
        (0, $95072c08d604c329$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $c3fbae23fda05c7a$export$f8ea28c31069cbc9 = function(name, options) {
    return [
        (0, $95072c08d604c329$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $95072c08d604c329$export$568567f665d3f3bb)(options.graphicsState),
        (0, $95072c08d604c329$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $95072c08d604c329$export$a2ba89726971a90f)((0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(options.rotate)),
        (0, $95072c08d604c329$export$dcdf75081b88279d)(options.xScale, options.yScale),
        (0, $95072c08d604c329$export$985cb1d69d6a3add)((0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(options.xSkew), (0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(options.ySkew)),
        (0, $95072c08d604c329$export$382c18f8bccd9e2b)(name),
        (0, $95072c08d604c329$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $c3fbae23fda05c7a$export$819db45aec5fcbe5 = function(options) {
    var _a, _b;
    return [
        (0, $95072c08d604c329$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $95072c08d604c329$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $04532fa67d29096c$export$ae31e5cacc8bb23d)(options.color),
        (0, $95072c08d604c329$export$558e0f90d8262345)(options.thickness),
        (0, $95072c08d604c329$export$e0e900d241274e06)((_a = options.dashArray) !== null && _a !== void 0 ? _a : [], (_b = options.dashPhase) !== null && _b !== void 0 ? _b : 0),
        (0, $95072c08d604c329$export$75f1ccd6dc32e80a)(options.start.x, options.start.y),
        options.lineCap && (0, $95072c08d604c329$export$6c65ed24e870eec)(options.lineCap),
        (0, $95072c08d604c329$export$75f1ccd6dc32e80a)(options.start.x, options.start.y),
        (0, $95072c08d604c329$export$73abee0cf983cb99)(options.end.x, options.end.y),
        (0, $95072c08d604c329$export$d9b706f8d0a70aef)(),
        (0, $95072c08d604c329$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $c3fbae23fda05c7a$export$cac848e0621718d8 = function(options) {
    var _a, _b;
    return [
        (0, $95072c08d604c329$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $95072c08d604c329$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $04532fa67d29096c$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $04532fa67d29096c$export$ae31e5cacc8bb23d)(options.borderColor),
        (0, $95072c08d604c329$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $95072c08d604c329$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $95072c08d604c329$export$e0e900d241274e06)((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0),
        (0, $95072c08d604c329$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $95072c08d604c329$export$a2ba89726971a90f)((0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(options.rotate)),
        (0, $95072c08d604c329$export$985cb1d69d6a3add)((0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(options.xSkew), (0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(options.ySkew)),
        (0, $95072c08d604c329$export$75f1ccd6dc32e80a)(0, 0),
        (0, $95072c08d604c329$export$73abee0cf983cb99)(0, options.height),
        (0, $95072c08d604c329$export$73abee0cf983cb99)(options.width, options.height),
        (0, $95072c08d604c329$export$73abee0cf983cb99)(options.width, 0),
        (0, $95072c08d604c329$export$21f87e210c424cd0)(),
        // prettier-ignore
        options.color && options.borderWidth ? (0, $95072c08d604c329$export$76d37801baac10fb)() : options.color ? (0, $95072c08d604c329$export$9563e054e6f787fb)() : options.borderColor ? (0, $95072c08d604c329$export$d9b706f8d0a70aef)() : (0, $95072c08d604c329$export$21f87e210c424cd0)(),
        (0, $95072c08d604c329$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $c3fbae23fda05c7a$var$KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var $c3fbae23fda05c7a$export$f219d5f4b18063ad = function(config) {
    var x = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(config.x);
    var y = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(config.y);
    var xScale = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(config.xScale);
    var yScale = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(config.yScale);
    x -= xScale;
    y -= yScale;
    var ox = xScale * $c3fbae23fda05c7a$var$KAPPA;
    var oy = yScale * $c3fbae23fda05c7a$var$KAPPA;
    var xe = x + xScale * 2;
    var ye = y + yScale * 2;
    var xm = x + xScale;
    var ym = y + yScale;
    return [
        (0, $95072c08d604c329$export$cb182c48e35739ac)(),
        (0, $95072c08d604c329$export$75f1ccd6dc32e80a)(x, ym),
        (0, $95072c08d604c329$export$45bd49bb15a3c5cb)(x, ym - oy, xm - ox, y, xm, y),
        (0, $95072c08d604c329$export$45bd49bb15a3c5cb)(xm + ox, y, xe, ym - oy, xe, ym),
        (0, $95072c08d604c329$export$45bd49bb15a3c5cb)(xe, ym + oy, xm + ox, ye, xm, ye),
        (0, $95072c08d604c329$export$45bd49bb15a3c5cb)(xm - ox, ye, x, ym + oy, x, ym),
        (0, $95072c08d604c329$export$10581a6f45bf75eb)()
    ];
};
var $c3fbae23fda05c7a$var$drawEllipseCurves = function(config) {
    var centerX = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(config.x);
    var centerY = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(config.y);
    var xScale = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(config.xScale);
    var yScale = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(config.yScale);
    var x = -xScale;
    var y = -yScale;
    var ox = xScale * $c3fbae23fda05c7a$var$KAPPA;
    var oy = yScale * $c3fbae23fda05c7a$var$KAPPA;
    var xe = x + xScale * 2;
    var ye = y + yScale * 2;
    var xm = x + xScale;
    var ym = y + yScale;
    return [
        (0, $95072c08d604c329$export$d73ee8ef04f5226a)(centerX, centerY),
        (0, $95072c08d604c329$export$a2ba89726971a90f)((0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(config.rotate)),
        (0, $95072c08d604c329$export$75f1ccd6dc32e80a)(x, ym),
        (0, $95072c08d604c329$export$45bd49bb15a3c5cb)(x, ym - oy, xm - ox, y, xm, y),
        (0, $95072c08d604c329$export$45bd49bb15a3c5cb)(xm + ox, y, xe, ym - oy, xe, ym),
        (0, $95072c08d604c329$export$45bd49bb15a3c5cb)(xe, ym + oy, xm + ox, ye, xm, ye),
        (0, $95072c08d604c329$export$45bd49bb15a3c5cb)(xm - ox, ye, x, ym + oy, x, ym)
    ];
};
var $c3fbae23fda05c7a$export$43c9e2bb0dc74582 = function(options) {
    var _a, _b, _c;
    return (0, $273XO.__spreadArrays)([
        (0, $95072c08d604c329$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $95072c08d604c329$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $04532fa67d29096c$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $04532fa67d29096c$export$ae31e5cacc8bb23d)(options.borderColor),
        (0, $95072c08d604c329$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $95072c08d604c329$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $95072c08d604c329$export$e0e900d241274e06)((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0)
    ], options.rotate === undefined ? $c3fbae23fda05c7a$export$f219d5f4b18063ad({
        x: options.x,
        y: options.y,
        xScale: options.xScale,
        yScale: options.yScale
    }) : $c3fbae23fda05c7a$var$drawEllipseCurves({
        x: options.x,
        y: options.y,
        xScale: options.xScale,
        yScale: options.yScale,
        rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0)
    }), [
        // prettier-ignore
        options.color && options.borderWidth ? (0, $95072c08d604c329$export$76d37801baac10fb)() : options.color ? (0, $95072c08d604c329$export$9563e054e6f787fb)() : options.borderColor ? (0, $95072c08d604c329$export$d9b706f8d0a70aef)() : (0, $95072c08d604c329$export$21f87e210c424cd0)(),
        (0, $95072c08d604c329$export$10581a6f45bf75eb)()
    ]).filter(Boolean);
};
var $c3fbae23fda05c7a$export$47c8a640c39d0756 = function(path, options) {
    var _a, _b, _c;
    return (0, $273XO.__spreadArrays)([
        (0, $95072c08d604c329$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $95072c08d604c329$export$568567f665d3f3bb)(options.graphicsState),
        (0, $95072c08d604c329$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $95072c08d604c329$export$a2ba89726971a90f)((0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)((_a = options.rotate) !== null && _a !== void 0 ? _a : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0))),
        // SVG path Y axis is opposite pdf-lib's
        options.scale ? (0, $95072c08d604c329$export$dcdf75081b88279d)(options.scale, -options.scale) : (0, $95072c08d604c329$export$dcdf75081b88279d)(1, -1),
        options.color && (0, $04532fa67d29096c$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $04532fa67d29096c$export$ae31e5cacc8bb23d)(options.borderColor),
        options.borderWidth && (0, $95072c08d604c329$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $95072c08d604c329$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $95072c08d604c329$export$e0e900d241274e06)((_b = options.borderDashArray) !== null && _b !== void 0 ? _b : [], (_c = options.borderDashPhase) !== null && _c !== void 0 ? _c : 0)
    ], (0, $9fb66356d276c3a8$export$8de5166f0a5bde2a)(path), [
        // prettier-ignore
        options.color && options.borderWidth ? (0, $95072c08d604c329$export$76d37801baac10fb)() : options.color ? (0, $95072c08d604c329$export$9563e054e6f787fb)() : options.borderColor ? (0, $95072c08d604c329$export$d9b706f8d0a70aef)() : (0, $95072c08d604c329$export$21f87e210c424cd0)(),
        (0, $95072c08d604c329$export$10581a6f45bf75eb)()
    ]).filter(Boolean);
};
var $c3fbae23fda05c7a$export$695703ffa02b3ffb = function(options) {
    var size = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.size);
    /*********************** Define Check Mark Points ***************************/ // A check mark is defined by three points in some coordinate space. Here, we
    // define these points in a unit coordinate system, where the range of the x
    // and y axis are both [-1, 1].
    //
    // Note that we do not hard code `p1y` in case we wish to change the
    // size/shape of the check mark in the future. We want the check mark to
    // always form a right angle. This means that the dot product between (p1-p2)
    // and (p3-p2) should be zero:
    //
    //   (p1x-p2x) * (p3x-p2x) + (p1y-p2y) * (p3y-p2y) = 0
    //
    // We can now rejigger this equation to solve for `p1y`:
    //
    //   (p1y-p2y) * (p3y-p2y) = -((p1x-p2x) * (p3x-p2x))
    //   (p1y-p2y) = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y)
    //   p1y = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y) + p2y
    //
    // Thanks to my friend Joel Walker (https://github.com/JWalker1995) for
    // devising the above equation and unit coordinate system approach!
    // (x, y) coords of the check mark's bottommost point
    var p2x = -0.25;
    var p2y = -0.49;
    // (x, y) coords of the check mark's topmost point
    var p3y = 0.475;
    var p3x = 0.69;
    // (x, y) coords of the check mark's center (vertically) point
    var p1x = -0.675;
    var p1y = -((p1x - p2x) * (p3x - p2x)) / (p3y - p2y) + p2y;
    /****************************************************************************/ return [
        (0, $95072c08d604c329$export$cb182c48e35739ac)(),
        options.color && (0, $04532fa67d29096c$export$ae31e5cacc8bb23d)(options.color),
        (0, $95072c08d604c329$export$558e0f90d8262345)(options.thickness),
        (0, $95072c08d604c329$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $95072c08d604c329$export$75f1ccd6dc32e80a)(p1x * size, p1y * size),
        (0, $95072c08d604c329$export$73abee0cf983cb99)(p2x * size, p2y * size),
        (0, $95072c08d604c329$export$73abee0cf983cb99)(p3x * size, p3y * size),
        (0, $95072c08d604c329$export$d9b706f8d0a70aef)(),
        (0, $95072c08d604c329$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $c3fbae23fda05c7a$export$5dd9a0a87f38a2a6 = function(options) {
    return options.rotation === 0 ? [
        (0, $95072c08d604c329$export$d73ee8ef04f5226a)(0, 0),
        (0, $95072c08d604c329$export$91df22fbff99d059)(0)
    ] : options.rotation === 90 ? [
        (0, $95072c08d604c329$export$d73ee8ef04f5226a)(options.width, 0),
        (0, $95072c08d604c329$export$91df22fbff99d059)(90)
    ] : options.rotation === 180 ? [
        (0, $95072c08d604c329$export$d73ee8ef04f5226a)(options.width, options.height),
        (0, $95072c08d604c329$export$91df22fbff99d059)(180)
    ] : options.rotation === 270 ? [
        (0, $95072c08d604c329$export$d73ee8ef04f5226a)(0, options.height),
        (0, $95072c08d604c329$export$91df22fbff99d059)(270)
    ] : [];
}; // Invalid rotation - noop
var $c3fbae23fda05c7a$export$1c2f7a8d0ec539ab = function(options) {
    var outline = $c3fbae23fda05c7a$export$cac848e0621718d8({
        x: options.x,
        y: options.y,
        width: options.width,
        height: options.height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
        xSkew: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
        ySkew: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0)
    });
    if (!options.filled) return outline;
    var width = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.width);
    var height = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.height);
    var checkMarkSize = Math.min(width, height) / 2;
    var checkMark = $c3fbae23fda05c7a$export$695703ffa02b3ffb({
        x: width / 2,
        y: height / 2,
        size: checkMarkSize,
        thickness: options.thickness,
        color: options.markColor
    });
    return (0, $273XO.__spreadArrays)([
        (0, $95072c08d604c329$export$cb182c48e35739ac)()
    ], outline, checkMark, [
        (0, $95072c08d604c329$export$10581a6f45bf75eb)()
    ]);
};
var $c3fbae23fda05c7a$export$d01bb537f184a293 = function(options) {
    var width = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.width);
    var height = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.height);
    var outlineScale = Math.min(width, height) / 2;
    var outline = $c3fbae23fda05c7a$export$43c9e2bb0dc74582({
        x: options.x,
        y: options.y,
        xScale: outlineScale,
        yScale: outlineScale,
        color: options.color,
        borderColor: options.borderColor,
        borderWidth: options.borderWidth
    });
    if (!options.filled) return outline;
    var dot = $c3fbae23fda05c7a$export$43c9e2bb0dc74582({
        x: options.x,
        y: options.y,
        xScale: outlineScale * 0.45,
        yScale: outlineScale * 0.45,
        color: options.dotColor,
        borderColor: undefined,
        borderWidth: 0
    });
    return (0, $273XO.__spreadArrays)([
        (0, $95072c08d604c329$export$cb182c48e35739ac)()
    ], outline, dot, [
        (0, $95072c08d604c329$export$10581a6f45bf75eb)()
    ]);
};
var $c3fbae23fda05c7a$export$31046eb8c5070d92 = function(options) {
    var x = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.x);
    var y = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.y);
    var width = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.width);
    var height = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.height);
    var background = $c3fbae23fda05c7a$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
        xSkew: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
        ySkew: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0)
    });
    var lines = $c3fbae23fda05c7a$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
        xSkew: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
        ySkew: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0)
    });
    return (0, $273XO.__spreadArrays)([
        (0, $95072c08d604c329$export$cb182c48e35739ac)()
    ], background, lines, [
        (0, $95072c08d604c329$export$10581a6f45bf75eb)()
    ]);
};
var $c3fbae23fda05c7a$export$8a28629e0fa0aec4 = function(lines, options) {
    var operators = [
        (0, $95072c08d604c329$export$337b8dbf65fbb95e)(),
        (0, $04532fa67d29096c$export$6126e5d7ba707741)(options.color),
        (0, $95072c08d604c329$export$df01d619ff6ce7f7)(options.font, options.size)
    ];
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var _a = lines[idx], encoded = _a.encoded, x = _a.x, y = _a.y;
        operators.push((0, $95072c08d604c329$export$f567083ac6aa5aa3)((0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(options.rotate), (0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(options.xSkew), (0, $86b75e7e8bb6dd95$export$cba01ba138429a1d)(options.ySkew), x, y), (0, $95072c08d604c329$export$778bfc3c1a2b7ba4)(encoded));
    }
    operators.push((0, $95072c08d604c329$export$e3caa83a99d72806)());
    return operators;
};
var $c3fbae23fda05c7a$export$7d8517ad99905084 = function(options) {
    var x = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.x);
    var y = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.y);
    var width = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.width);
    var height = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.height);
    var borderWidth = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.borderWidth);
    var padding = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.padding);
    var clipX = x + borderWidth / 2 + padding;
    var clipY = y + borderWidth / 2 + padding;
    var clipWidth = width - (borderWidth / 2 + padding) * 2;
    var clipHeight = height - (borderWidth / 2 + padding) * 2;
    var clippingArea = [
        (0, $95072c08d604c329$export$75f1ccd6dc32e80a)(clipX, clipY),
        (0, $95072c08d604c329$export$73abee0cf983cb99)(clipX, clipY + clipHeight),
        (0, $95072c08d604c329$export$73abee0cf983cb99)(clipX + clipWidth, clipY + clipHeight),
        (0, $95072c08d604c329$export$73abee0cf983cb99)(clipX + clipWidth, clipY),
        (0, $95072c08d604c329$export$21f87e210c424cd0)(),
        (0, $95072c08d604c329$export$e0b576e7a74416cd)(),
        (0, $95072c08d604c329$export$d366e9c0a9bd860f)()
    ];
    var background = $c3fbae23fda05c7a$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
        xSkew: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
        ySkew: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0)
    });
    var lines = $c3fbae23fda05c7a$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
        xSkew: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
        ySkew: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0)
    });
    var markedContent = (0, $273XO.__spreadArrays)([
        (0, $95072c08d604c329$export$a028b403e40f1ab2)('Tx'),
        (0, $95072c08d604c329$export$cb182c48e35739ac)()
    ], lines, [
        (0, $95072c08d604c329$export$10581a6f45bf75eb)(),
        (0, $95072c08d604c329$export$935e2334f5a50589)()
    ]);
    return (0, $273XO.__spreadArrays)([
        (0, $95072c08d604c329$export$cb182c48e35739ac)()
    ], background, clippingArea, markedContent, [
        (0, $95072c08d604c329$export$10581a6f45bf75eb)()
    ]);
};
var $c3fbae23fda05c7a$export$5a3093287b85b7c0 = function(options) {
    var x = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.x);
    var y = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.y);
    var width = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.width);
    var height = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.height);
    var lineHeight = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.lineHeight);
    var borderWidth = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.borderWidth);
    var padding = (0, $41ecfa60dca9723e$export$37576b9ba69b50db)(options.padding);
    var clipX = x + borderWidth / 2 + padding;
    var clipY = y + borderWidth / 2 + padding;
    var clipWidth = width - (borderWidth / 2 + padding) * 2;
    var clipHeight = height - (borderWidth / 2 + padding) * 2;
    var clippingArea = [
        (0, $95072c08d604c329$export$75f1ccd6dc32e80a)(clipX, clipY),
        (0, $95072c08d604c329$export$73abee0cf983cb99)(clipX, clipY + clipHeight),
        (0, $95072c08d604c329$export$73abee0cf983cb99)(clipX + clipWidth, clipY + clipHeight),
        (0, $95072c08d604c329$export$73abee0cf983cb99)(clipX + clipWidth, clipY),
        (0, $95072c08d604c329$export$21f87e210c424cd0)(),
        (0, $95072c08d604c329$export$e0b576e7a74416cd)(),
        (0, $95072c08d604c329$export$d366e9c0a9bd860f)()
    ];
    var background = $c3fbae23fda05c7a$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
        xSkew: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
        ySkew: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0)
    });
    var highlights = [];
    for(var idx = 0, len = options.selectedLines.length; idx < len; idx++){
        var line = options.textLines[options.selectedLines[idx]];
        highlights.push.apply(highlights, $c3fbae23fda05c7a$export$cac848e0621718d8({
            x: line.x - padding,
            y: line.y - (lineHeight - line.height) / 2,
            width: width - borderWidth,
            height: line.height + (lineHeight - line.height) / 2,
            borderWidth: 0,
            color: options.selectedColor,
            borderColor: undefined,
            rotate: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            xSkew: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            ySkew: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0)
        }));
    }
    var lines = $c3fbae23fda05c7a$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
        xSkew: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
        ySkew: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0)
    });
    var markedContent = (0, $273XO.__spreadArrays)([
        (0, $95072c08d604c329$export$a028b403e40f1ab2)('Tx'),
        (0, $95072c08d604c329$export$cb182c48e35739ac)()
    ], lines, [
        (0, $95072c08d604c329$export$10581a6f45bf75eb)(),
        (0, $95072c08d604c329$export$935e2334f5a50589)()
    ]);
    return (0, $273XO.__spreadArrays)([
        (0, $95072c08d604c329$export$cb182c48e35739ac)()
    ], background, highlights, clippingArea, markedContent, [
        (0, $95072c08d604c329$export$10581a6f45bf75eb)()
    ]);
};




// tslint:disable: max-classes-per-file

var $273XO = parcelRequire("273XO");
// TODO: Include link to documentation with example
var $07ff41eb9264b36f$export$20fcceeca2b098d2 = /** @class */ function(_super) {
    (0, $273XO.__extends)(EncryptedPDFError, _super);
    function EncryptedPDFError() {
        var _this = this;
        var msg = 'Input document to `PDFDocument.load` is encrypted. You can use `PDFDocument.load(..., { ignoreEncryption: true })` if you wish to load the document anyways.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return EncryptedPDFError;
}(Error);
// TODO: Include link to documentation with example
var $07ff41eb9264b36f$export$529a7c74d0636a48 = /** @class */ function(_super) {
    (0, $273XO.__extends)(FontkitNotRegisteredError, _super);
    function FontkitNotRegisteredError() {
        var _this = this;
        var msg = 'Input to `PDFDocument.embedFont` was a custom font, but no `fontkit` instance was found. You must register a `fontkit` instance with `PDFDocument.registerFontkit(...)` before embedding custom fonts.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FontkitNotRegisteredError;
}(Error);
// TODO: Include link to documentation with example
var $07ff41eb9264b36f$export$9564a4d28d94eae2 = /** @class */ function(_super) {
    (0, $273XO.__extends)(ForeignPageError, _super);
    function ForeignPageError() {
        var _this = this;
        var msg = 'A `page` passed to `PDFDocument.addPage` or `PDFDocument.insertPage` was from a different (foreign) PDF document. If you want to copy pages from one PDFDocument to another, you must use `PDFDocument.copyPages(...)` to copy the pages before adding or inserting them.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ForeignPageError;
}(Error);
// TODO: Include link to documentation with example
var $07ff41eb9264b36f$export$cdca06c5927ddc2d = /** @class */ function(_super) {
    (0, $273XO.__extends)(RemovePageFromEmptyDocumentError, _super);
    function RemovePageFromEmptyDocumentError() {
        var _this = this;
        var msg = 'PDFDocument has no pages so `PDFDocument.removePage` cannot be called';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return RemovePageFromEmptyDocumentError;
}(Error);
var $07ff41eb9264b36f$export$5bc08baa4a027cbd = /** @class */ function(_super) {
    (0, $273XO.__extends)(NoSuchFieldError, _super);
    function NoSuchFieldError(name) {
        var _this = this;
        var msg = "PDFDocument has no form field with the name \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return NoSuchFieldError;
}(Error);
var $07ff41eb9264b36f$export$8909da6c566ff652 = /** @class */ function(_super) {
    (0, $273XO.__extends)(UnexpectedFieldTypeError, _super);
    function UnexpectedFieldTypeError(name, expected, actual) {
        var _a, _b;
        var _this = this;
        var expectedType = expected === null || expected === void 0 ? void 0 : expected.name;
        var actualType = (_b = (_a = actual === null || actual === void 0 ? void 0 : actual.constructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : actual;
        var msg = "Expected field \"" + name + "\" to be of type " + expectedType + ", " + ("but it is actually of type " + actualType);
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnexpectedFieldTypeError;
}(Error);
var $07ff41eb9264b36f$export$3437b42908c7d7a3 = /** @class */ function(_super) {
    (0, $273XO.__extends)(MissingOnValueCheckError, _super);
    function MissingOnValueCheckError(onValue) {
        var _this = this;
        var msg = "Failed to select check box due to missing onValue: \"" + onValue + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingOnValueCheckError;
}(Error);
var $07ff41eb9264b36f$export$c428cfe4dc6c68df = /** @class */ function(_super) {
    (0, $273XO.__extends)(FieldAlreadyExistsError, _super);
    function FieldAlreadyExistsError(name) {
        var _this = this;
        var msg = "A field already exists with the specified name: \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FieldAlreadyExistsError;
}(Error);
var $07ff41eb9264b36f$export$83c39fdacfe38500 = /** @class */ function(_super) {
    (0, $273XO.__extends)(InvalidFieldNamePartError, _super);
    function InvalidFieldNamePartError(namePart) {
        var _this = this;
        var msg = "Field name contains invalid component: \"" + namePart + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidFieldNamePartError;
}(Error);
var $07ff41eb9264b36f$export$6353a2ffd9106bd2 = /** @class */ function(_super) {
    (0, $273XO.__extends)(FieldExistsAsNonTerminalError, _super);
    function FieldExistsAsNonTerminalError(name) {
        var _this = this;
        var msg = "A non-terminal field already exists with the specified name: \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FieldExistsAsNonTerminalError;
}(Error);
var $07ff41eb9264b36f$export$f2fed572e1ed57ab = /** @class */ function(_super) {
    (0, $273XO.__extends)(RichTextFieldReadError, _super);
    function RichTextFieldReadError(fieldName) {
        var _this = this;
        var msg = "Reading rich text fields is not supported: Attempted to read rich text field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return RichTextFieldReadError;
}(Error);
var $07ff41eb9264b36f$export$5283dffc620a5c9f = /** @class */ function(_super) {
    (0, $273XO.__extends)(CombedTextLayoutError, _super);
    function CombedTextLayoutError(lineLength, cellCount) {
        var _this = this;
        var msg = "Failed to layout combed text as lineLength=" + lineLength + " is greater than cellCount=" + cellCount;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return CombedTextLayoutError;
}(Error);
var $07ff41eb9264b36f$export$1577e99040d42609 = /** @class */ function(_super) {
    (0, $273XO.__extends)(ExceededMaxLengthError, _super);
    function ExceededMaxLengthError(textLength, maxLength, name) {
        var _this = this;
        var msg = "Attempted to set text with length=" + textLength + " for TextField with maxLength=" + maxLength + " and name=" + name;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ExceededMaxLengthError;
}(Error);
var $07ff41eb9264b36f$export$6da6c372180e79b0 = /** @class */ function(_super) {
    (0, $273XO.__extends)(InvalidMaxLengthError, _super);
    function InvalidMaxLengthError(textLength, maxLength, name) {
        var _this = this;
        var msg = "Attempted to set maxLength=" + maxLength + ", which is less than " + textLength + ", the length of this field's current value (name=" + name + ")";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidMaxLengthError;
}(Error);


var $616c0504afff154b$export$84b2d1b68830363f;
(function(TextAlignment) {
    TextAlignment[TextAlignment["Left"] = 0] = "Left";
    TextAlignment[TextAlignment["Center"] = 1] = "Center";
    TextAlignment[TextAlignment["Right"] = 2] = "Right";
})($616c0504afff154b$export$84b2d1b68830363f || ($616c0504afff154b$export$84b2d1b68830363f = {}));


parcelRequire("5bpFt");
var $8hWZH = parcelRequire("8hWZH");
var $fb3a0deacbcf811e$var$MIN_FONT_SIZE = 4;
var $fb3a0deacbcf811e$var$MAX_FONT_SIZE = 500;
var $fb3a0deacbcf811e$var$computeFontSize = function(lines, font, bounds, multiline) {
    if (multiline === void 0) multiline = false;
    var fontSize = $fb3a0deacbcf811e$var$MIN_FONT_SIZE;
    while(fontSize < $fb3a0deacbcf811e$var$MAX_FONT_SIZE){
        var linesUsed = 0;
        for(var lineIdx = 0, lineLen = lines.length; lineIdx < lineLen; lineIdx++){
            linesUsed += 1;
            var line = lines[lineIdx];
            var words = line.split(' ');
            // Layout the words using the current `fontSize`, line wrapping
            // whenever we reach the end of the current line.
            var spaceInLineRemaining = bounds.width;
            for(var idx = 0, len = words.length; idx < len; idx++){
                var isLastWord = idx === len - 1;
                var word = isLastWord ? words[idx] : words[idx] + ' ';
                var widthOfWord = font.widthOfTextAtSize(word, fontSize);
                spaceInLineRemaining -= widthOfWord;
                if (spaceInLineRemaining <= 0) {
                    linesUsed += 1;
                    spaceInLineRemaining = bounds.width - widthOfWord;
                }
            }
        }
        // Return if we exceeded the allowed width
        if (!multiline && linesUsed > lines.length) return fontSize - 1;
        var height = font.heightAtSize(fontSize);
        var lineHeight = height + height * 0.2;
        var totalHeight = lineHeight * linesUsed;
        // Return if we exceeded the allowed height
        if (totalHeight > Math.abs(bounds.height)) return fontSize - 1;
        fontSize += 1;
    }
    return fontSize;
};
var $fb3a0deacbcf811e$var$computeCombedFontSize = function(line, font, bounds, cellCount) {
    var cellWidth = bounds.width / cellCount;
    var cellHeight = bounds.height;
    var fontSize = $fb3a0deacbcf811e$var$MIN_FONT_SIZE;
    var chars = (0, $8hWZH.charSplit)(line);
    while(fontSize < $fb3a0deacbcf811e$var$MAX_FONT_SIZE){
        for(var idx = 0, len = chars.length; idx < len; idx++){
            var c = chars[idx];
            var tooLong = font.widthOfTextAtSize(c, fontSize) > cellWidth * 0.75;
            if (tooLong) return fontSize - 1;
        }
        var height = font.heightAtSize(fontSize, {
            descender: false
        });
        if (height > cellHeight) return fontSize - 1;
        fontSize += 1;
    }
    return fontSize;
};
var $fb3a0deacbcf811e$var$lastIndexOfWhitespace = function(line) {
    for(var idx = line.length; idx > 0; idx--){
        if (/\s/.test(line[idx])) return idx;
    }
    return undefined;
};
var $fb3a0deacbcf811e$var$splitOutLines = function(input, maxWidth, font, fontSize) {
    var _a;
    var lastWhitespaceIdx = input.length;
    while(lastWhitespaceIdx > 0){
        var line = input.substring(0, lastWhitespaceIdx);
        var encoded = font.encodeText(line);
        var width = font.widthOfTextAtSize(line, fontSize);
        if (width < maxWidth) {
            var remainder = input.substring(lastWhitespaceIdx) || undefined;
            return {
                line: line,
                encoded: encoded,
                width: width,
                remainder: remainder
            };
        }
        lastWhitespaceIdx = (_a = $fb3a0deacbcf811e$var$lastIndexOfWhitespace(line)) !== null && _a !== void 0 ? _a : 0;
    }
    // We were unable to split the input enough to get a chunk that would fit
    // within the specified `maxWidth` so we'll just return everything
    return {
        line: input,
        encoded: font.encodeText(input),
        width: font.widthOfTextAtSize(input, fontSize),
        remainder: undefined
    };
};
var $fb3a0deacbcf811e$export$f6ba9f13f815cc95 = function(text, _a) {
    var alignment = _a.alignment, fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds;
    var lines = (0, $8hWZH.lineSplit)((0, $8hWZH.cleanText)(text));
    if (fontSize === undefined || fontSize === 0) fontSize = $fb3a0deacbcf811e$var$computeFontSize(lines, font, bounds, true);
    var height = font.heightAtSize(fontSize);
    var lineHeight = height + height * 0.2;
    var textLines = [];
    var minX = bounds.x;
    var minY = bounds.y;
    var maxX = bounds.x + bounds.width;
    var maxY = bounds.y + bounds.height;
    var y = bounds.y + bounds.height;
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var prevRemainder = lines[idx];
        while(prevRemainder !== undefined){
            var _b = $fb3a0deacbcf811e$var$splitOutLines(prevRemainder, bounds.width, font, fontSize), line = _b.line, encoded = _b.encoded, width = _b.width, remainder = _b.remainder;
            // prettier-ignore
            var x = alignment === (0, $616c0504afff154b$export$84b2d1b68830363f).Left ? bounds.x : alignment === (0, $616c0504afff154b$export$84b2d1b68830363f).Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === (0, $616c0504afff154b$export$84b2d1b68830363f).Right ? bounds.x + bounds.width - width : bounds.x;
            y -= lineHeight;
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x + width > maxX) maxX = x + width;
            if (y + height > maxY) maxY = y + height;
            textLines.push({
                text: line,
                encoded: encoded,
                width: width,
                height: height,
                x: x,
                y: y
            });
            // Only trim lines that we had to split ourselves. So we won't trim lines
            // that the user provided themselves with whitespace.
            prevRemainder = remainder === null || remainder === void 0 ? void 0 : remainder.trim();
        }
    }
    return {
        fontSize: fontSize,
        lineHeight: lineHeight,
        lines: textLines,
        bounds: {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        }
    };
};
var $fb3a0deacbcf811e$export$deba41d88dd75dfc = function(text, _a) {
    var fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds, cellCount = _a.cellCount;
    var line = (0, $8hWZH.mergeLines)((0, $8hWZH.cleanText)(text));
    if (line.length > cellCount) throw new (0, $07ff41eb9264b36f$export$5283dffc620a5c9f)(line.length, cellCount);
    if (fontSize === undefined || fontSize === 0) fontSize = $fb3a0deacbcf811e$var$computeCombedFontSize(line, font, bounds, cellCount);
    var cellWidth = bounds.width / cellCount;
    var height = font.heightAtSize(fontSize, {
        descender: false
    });
    var y = bounds.y + (bounds.height / 2 - height / 2);
    var cells = [];
    var minX = bounds.x;
    var minY = bounds.y;
    var maxX = bounds.x + bounds.width;
    var maxY = bounds.y + bounds.height;
    var cellOffset = 0;
    var charOffset = 0;
    while(cellOffset < cellCount){
        var _b = (0, $8hWZH.charAtIndex)(line, charOffset), char = _b[0], charLength = _b[1];
        var encoded = font.encodeText(char);
        var width = font.widthOfTextAtSize(char, fontSize);
        var cellCenter = bounds.x + (cellWidth * cellOffset + cellWidth / 2);
        var x = cellCenter - width / 2;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x + width > maxX) maxX = x + width;
        if (y + height > maxY) maxY = y + height;
        cells.push({
            text: line,
            encoded: encoded,
            width: width,
            height: height,
            x: x,
            y: y
        });
        cellOffset += 1;
        charOffset += charLength;
    }
    return {
        fontSize: fontSize,
        cells: cells,
        bounds: {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        }
    };
};
var $fb3a0deacbcf811e$export$c0030606588cf6f2 = function(text, _a) {
    var alignment = _a.alignment, fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds;
    var line = (0, $8hWZH.mergeLines)((0, $8hWZH.cleanText)(text));
    if (fontSize === undefined || fontSize === 0) fontSize = $fb3a0deacbcf811e$var$computeFontSize([
        line
    ], font, bounds);
    var encoded = font.encodeText(line);
    var width = font.widthOfTextAtSize(line, fontSize);
    var height = font.heightAtSize(fontSize, {
        descender: false
    });
    // prettier-ignore
    var x = alignment === (0, $616c0504afff154b$export$84b2d1b68830363f).Left ? bounds.x : alignment === (0, $616c0504afff154b$export$84b2d1b68830363f).Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === (0, $616c0504afff154b$export$84b2d1b68830363f).Right ? bounds.x + bounds.width - width : bounds.x;
    var y = bounds.y + (bounds.height / 2 - height / 2);
    return {
        fontSize: fontSize,
        line: {
            text: line,
            encoded: encoded,
            width: width,
            height: height,
            x: x,
            y: y
        },
        bounds: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    };
};




parcelRequire("5bpFt");
var $8hWZH = parcelRequire("8hWZH");
var $fd9d87d4f9bb8968$export$8a3aea031520d39b = function(appearance) {
    if ('normal' in appearance) return appearance;
    return {
        normal: appearance
    };
};
// Examples:
//   `/Helv 12 Tf` -> ['/Helv 12 Tf', 'Helv', '12']
//   `/HeBo 8.00 Tf` -> ['/HeBo 8 Tf', 'HeBo', '8.00']
var $fd9d87d4f9bb8968$var$tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]+(\d*\.\d+|\d+)[\0\t\n\f\r\ ]+Tf/;
var $fd9d87d4f9bb8968$var$getDefaultFontSize = function(field) {
    var _a, _b;
    var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
    var daMatch = (_b = (0, $8hWZH.findLastMatch)(da, $fd9d87d4f9bb8968$var$tfRegex).match) !== null && _b !== void 0 ? _b : [];
    var defaultFontSize = Number(daMatch[2]);
    return isFinite(defaultFontSize) ? defaultFontSize : undefined;
};
// Examples:
//   `0.3 g` -> ['0.3', 'g']
//   `0.3 1 .3 rg` -> ['0.3', '1', '.3', 'rg']
//   `0.3 1 .3 0 k` -> ['0.3', '1', '.3', '0', 'k']
var $fd9d87d4f9bb8968$var$colorRegex = /(\d*\.\d+|\d+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+(g|rg|k)/;
var $fd9d87d4f9bb8968$var$getDefaultColor = function(field) {
    var _a;
    var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
    var daMatch = (0, $8hWZH.findLastMatch)(da, $fd9d87d4f9bb8968$var$colorRegex).match;
    var _b = daMatch !== null && daMatch !== void 0 ? daMatch : [], c1 = _b[1], c2 = _b[2], c3 = _b[3], c4 = _b[4], colorSpace = _b[5];
    if (colorSpace === 'g' && c1) return (0, $04532fa67d29096c$export$6f416a6db2dfcd5c)(Number(c1));
    if (colorSpace === 'rg' && c1 && c2 && c3) return (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(Number(c1), Number(c2), Number(c3));
    if (colorSpace === 'k' && c1 && c2 && c3 && c4) return (0, $04532fa67d29096c$export$358b1a66a3c77756)(Number(c1), Number(c2), Number(c3), Number(c4));
    return undefined;
};
var $fd9d87d4f9bb8968$var$updateDefaultAppearance = function(field, color, font, fontSize) {
    var _a;
    if (fontSize === void 0) fontSize = 0;
    var da = [
        (0, $04532fa67d29096c$export$6126e5d7ba707741)(color).toString(),
        (0, $95072c08d604c329$export$df01d619ff6ce7f7)((_a = font === null || font === void 0 ? void 0 : font.name) !== null && _a !== void 0 ? _a : 'dummy__noop', fontSize).toString()
    ].join('\n');
    field.setDefaultAppearance(da);
};
var $fd9d87d4f9bb8968$export$e11eab3ac6c06eb0 = function(checkBox, widget) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $fd9d87d4f9bb8968$var$getDefaultColor(widget);
    var fieldColor = $fd9d87d4f9bb8968$var$getDefaultColor(checkBox.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $86b75e7e8bb6dd95$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $86b75e7e8bb6dd95$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $c3fbae23fda05c7a$export$5dd9a0a87f38a2a6)((0, $273XO.__assign)((0, $273XO.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (_b = (0, $04532fa67d29096c$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
    var normalBackgroundColor = (0, $04532fa67d29096c$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $04532fa67d29096c$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    // Update color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor) $fd9d87d4f9bb8968$var$updateDefaultAppearance(widget, textColor);
    else $fd9d87d4f9bb8968$var$updateDefaultAppearance(checkBox.acroField, textColor);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        thickness: 1.5,
        borderWidth: borderWidth,
        borderColor: borderColor,
        markColor: textColor
    };
    return {
        normal: {
            on: (0, $273XO.__spreadArrays)(rotate, (0, $c3fbae23fda05c7a$export$1c2f7a8d0ec539ab)((0, $273XO.__assign)((0, $273XO.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: true
            }))),
            off: (0, $273XO.__spreadArrays)(rotate, (0, $c3fbae23fda05c7a$export$1c2f7a8d0ec539ab)((0, $273XO.__assign)((0, $273XO.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: false
            })))
        },
        down: {
            on: (0, $273XO.__spreadArrays)(rotate, (0, $c3fbae23fda05c7a$export$1c2f7a8d0ec539ab)((0, $273XO.__assign)((0, $273XO.__assign)({}, options), {
                color: downBackgroundColor,
                filled: true
            }))),
            off: (0, $273XO.__spreadArrays)(rotate, (0, $c3fbae23fda05c7a$export$1c2f7a8d0ec539ab)((0, $273XO.__assign)((0, $273XO.__assign)({}, options), {
                color: downBackgroundColor,
                filled: false
            })))
        }
    };
};
var $fd9d87d4f9bb8968$export$6440094330a99ef8 = function(radioGroup, widget) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $fd9d87d4f9bb8968$var$getDefaultColor(widget);
    var fieldColor = $fd9d87d4f9bb8968$var$getDefaultColor(radioGroup.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $86b75e7e8bb6dd95$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $86b75e7e8bb6dd95$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $c3fbae23fda05c7a$export$5dd9a0a87f38a2a6)((0, $273XO.__assign)((0, $273XO.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (_b = (0, $04532fa67d29096c$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
    var normalBackgroundColor = (0, $04532fa67d29096c$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $04532fa67d29096c$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    // Update color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor) $fd9d87d4f9bb8968$var$updateDefaultAppearance(widget, textColor);
    else $fd9d87d4f9bb8968$var$updateDefaultAppearance(radioGroup.acroField, textColor);
    var options = {
        x: width / 2,
        y: height / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth,
        borderColor: borderColor,
        dotColor: textColor
    };
    return {
        normal: {
            on: (0, $273XO.__spreadArrays)(rotate, (0, $c3fbae23fda05c7a$export$d01bb537f184a293)((0, $273XO.__assign)((0, $273XO.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: true
            }))),
            off: (0, $273XO.__spreadArrays)(rotate, (0, $c3fbae23fda05c7a$export$d01bb537f184a293)((0, $273XO.__assign)((0, $273XO.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: false
            })))
        },
        down: {
            on: (0, $273XO.__spreadArrays)(rotate, (0, $c3fbae23fda05c7a$export$d01bb537f184a293)((0, $273XO.__assign)((0, $273XO.__assign)({}, options), {
                color: downBackgroundColor,
                filled: true
            }))),
            off: (0, $273XO.__spreadArrays)(rotate, (0, $c3fbae23fda05c7a$export$d01bb537f184a293)((0, $273XO.__assign)((0, $273XO.__assign)({}, options), {
                color: downBackgroundColor,
                filled: false
            })))
        }
    };
};
var $fd9d87d4f9bb8968$export$68f9b19f48ffeeec = function(button, widget, font) {
    var _a, _b, _c, _d, _e;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $fd9d87d4f9bb8968$var$getDefaultColor(widget);
    var fieldColor = $fd9d87d4f9bb8968$var$getDefaultColor(button.acroField);
    var widgetFontSize = $fd9d87d4f9bb8968$var$getDefaultFontSize(widget);
    var fieldFontSize = $fd9d87d4f9bb8968$var$getDefaultFontSize(button.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var captions = ap === null || ap === void 0 ? void 0 : ap.getCaptions();
    var normalText = (_a = captions === null || captions === void 0 ? void 0 : captions.normal) !== null && _a !== void 0 ? _a : '';
    var downText = (_c = (_b = captions === null || captions === void 0 ? void 0 : captions.down) !== null && _b !== void 0 ? _b : normalText) !== null && _c !== void 0 ? _c : '';
    var borderWidth = (_d = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _d !== void 0 ? _d : 0;
    var rotation = (0, $86b75e7e8bb6dd95$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _f = (0, $86b75e7e8bb6dd95$export$312e44550db33c6a)(rectangle, rotation), width = _f.width, height = _f.height;
    var rotate = (0, $c3fbae23fda05c7a$export$5dd9a0a87f38a2a6)((0, $273XO.__assign)((0, $273XO.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $04532fa67d29096c$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $04532fa67d29096c$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $04532fa67d29096c$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    var bounds = {
        x: borderWidth,
        y: borderWidth,
        width: width - borderWidth * 2,
        height: height - borderWidth * 2
    };
    var normalLayout = (0, $fb3a0deacbcf811e$export$c0030606588cf6f2)(normalText, {
        alignment: (0, $616c0504afff154b$export$84b2d1b68830363f).Center,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    });
    var downLayout = (0, $fb3a0deacbcf811e$export$c0030606588cf6f2)(downText, {
        alignment: (0, $616c0504afff154b$export$84b2d1b68830363f).Center,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    });
    // Update font size and color
    var fontSize = Math.min(normalLayout.fontSize, downLayout.fontSize);
    var textColor = (_e = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _e !== void 0 ? _e : black;
    if (widgetColor || widgetFontSize !== undefined) $fd9d87d4f9bb8968$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $fd9d87d4f9bb8968$var$updateDefaultAppearance(button.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize
    };
    return {
        normal: (0, $273XO.__spreadArrays)(rotate, (0, $c3fbae23fda05c7a$export$31046eb8c5070d92)((0, $273XO.__assign)((0, $273XO.__assign)({}, options), {
            color: normalBackgroundColor,
            textLines: [
                normalLayout.line
            ]
        }))),
        down: (0, $273XO.__spreadArrays)(rotate, (0, $c3fbae23fda05c7a$export$31046eb8c5070d92)((0, $273XO.__assign)((0, $273XO.__assign)({}, options), {
            color: downBackgroundColor,
            textLines: [
                downLayout.line
            ]
        })))
    };
};
var $fd9d87d4f9bb8968$export$42ba95e6b8df3d7 = function(textField, widget, font) {
    var _a, _b, _c, _d;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $fd9d87d4f9bb8968$var$getDefaultColor(widget);
    var fieldColor = $fd9d87d4f9bb8968$var$getDefaultColor(textField.acroField);
    var widgetFontSize = $fd9d87d4f9bb8968$var$getDefaultFontSize(widget);
    var fieldFontSize = $fd9d87d4f9bb8968$var$getDefaultFontSize(textField.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var text = (_a = textField.getText()) !== null && _a !== void 0 ? _a : '';
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = (0, $86b75e7e8bb6dd95$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _e = (0, $86b75e7e8bb6dd95$export$312e44550db33c6a)(rectangle, rotation), width = _e.width, height = _e.height;
    var rotate = (0, $c3fbae23fda05c7a$export$5dd9a0a87f38a2a6)((0, $273XO.__assign)((0, $273XO.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $04532fa67d29096c$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $04532fa67d29096c$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var textLines;
    var fontSize;
    var padding = textField.isCombed() ? 0 : 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    if (textField.isMultiline()) {
        var layout = (0, $fb3a0deacbcf811e$export$f6ba9f13f815cc95)(text, {
            alignment: textField.getAlignment(),
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds
        });
        textLines = layout.lines;
        fontSize = layout.fontSize;
    } else if (textField.isCombed()) {
        var layout = (0, $fb3a0deacbcf811e$export$deba41d88dd75dfc)(text, {
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds,
            cellCount: (_c = textField.getMaxLength()) !== null && _c !== void 0 ? _c : 0
        });
        textLines = layout.cells;
        fontSize = layout.fontSize;
    } else {
        var layout = (0, $fb3a0deacbcf811e$export$c0030606588cf6f2)(text, {
            alignment: textField.getAlignment(),
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds
        });
        textLines = [
            layout.line
        ];
        fontSize = layout.fontSize;
    }
    // Update font size and color
    var textColor = (_d = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _d !== void 0 ? _d : black;
    if (widgetColor || widgetFontSize !== undefined) $fd9d87d4f9bb8968$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $fd9d87d4f9bb8968$var$updateDefaultAppearance(textField.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: textLines,
        padding: padding
    };
    return (0, $273XO.__spreadArrays)(rotate, (0, $c3fbae23fda05c7a$export$7d8517ad99905084)(options));
};
var $fd9d87d4f9bb8968$export$90f1ca03d512ec5 = function(dropdown, widget, font) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $fd9d87d4f9bb8968$var$getDefaultColor(widget);
    var fieldColor = $fd9d87d4f9bb8968$var$getDefaultColor(dropdown.acroField);
    var widgetFontSize = $fd9d87d4f9bb8968$var$getDefaultFontSize(widget);
    var fieldFontSize = $fd9d87d4f9bb8968$var$getDefaultFontSize(dropdown.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var text = (_a = dropdown.getSelected()[0]) !== null && _a !== void 0 ? _a : '';
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = (0, $86b75e7e8bb6dd95$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $86b75e7e8bb6dd95$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $c3fbae23fda05c7a$export$5dd9a0a87f38a2a6)((0, $273XO.__assign)((0, $273XO.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $04532fa67d29096c$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $04532fa67d29096c$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var padding = 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    var _e = (0, $fb3a0deacbcf811e$export$c0030606588cf6f2)(text, {
        alignment: (0, $616c0504afff154b$export$84b2d1b68830363f).Left,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    }), line = _e.line, fontSize = _e.fontSize;
    // Update font size and color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor || widgetFontSize !== undefined) $fd9d87d4f9bb8968$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $fd9d87d4f9bb8968$var$updateDefaultAppearance(dropdown.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: [
            line
        ],
        padding: padding
    };
    return (0, $273XO.__spreadArrays)(rotate, (0, $c3fbae23fda05c7a$export$7d8517ad99905084)(options));
};
var $fd9d87d4f9bb8968$export$f9fab495286778d2 = function(optionList, widget, font) {
    var _a, _b;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $fd9d87d4f9bb8968$var$getDefaultColor(widget);
    var fieldColor = $fd9d87d4f9bb8968$var$getDefaultColor(optionList.acroField);
    var widgetFontSize = $fd9d87d4f9bb8968$var$getDefaultFontSize(widget);
    var fieldFontSize = $fd9d87d4f9bb8968$var$getDefaultFontSize(optionList.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $86b75e7e8bb6dd95$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _c = (0, $86b75e7e8bb6dd95$export$312e44550db33c6a)(rectangle, rotation), width = _c.width, height = _c.height;
    var rotate = (0, $c3fbae23fda05c7a$export$5dd9a0a87f38a2a6)((0, $273XO.__assign)((0, $273XO.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $04532fa67d29096c$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $04532fa67d29096c$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var options = optionList.getOptions();
    var selected = optionList.getSelected();
    if (optionList.isSorted()) options.sort();
    var text = '';
    for(var idx = 0, len = options.length; idx < len; idx++){
        text += options[idx];
        if (idx < len - 1) text += '\n';
    }
    var padding = 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    var _d = (0, $fb3a0deacbcf811e$export$f6ba9f13f815cc95)(text, {
        alignment: (0, $616c0504afff154b$export$84b2d1b68830363f).Left,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    }), lines = _d.lines, fontSize = _d.fontSize, lineHeight = _d.lineHeight;
    var selectedLines = [];
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var line = lines[idx];
        if (selected.includes(line.text)) selectedLines.push(idx);
    }
    var blue = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0.6, 193 / 255, 218 / 255);
    // Update font size and color
    var textColor = (_b = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _b !== void 0 ? _b : black;
    if (widgetColor || widgetFontSize !== undefined) $fd9d87d4f9bb8968$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $fd9d87d4f9bb8968$var$updateDefaultAppearance(optionList.acroField, textColor, font, fontSize);
    return (0, $273XO.__spreadArrays)(rotate, (0, $c3fbae23fda05c7a$export$5a3093287b85b7c0)({
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: lines,
        lineHeight: lineHeight,
        selectedColor: blue,
        selectedLines: selectedLines,
        padding: padding
    }));
};



var $273XO = parcelRequire("273XO");

var $273XO = parcelRequire("273XO");




var $273XO = parcelRequire("273XO");


var $273XO = parcelRequire("273XO");


parcelRequire("5bpFt");
var $8EKPA = parcelRequire("8EKPA");
/**
 * Represents a PDF page that has been embedded in a [[PDFDocument]].
 */ var $b964e8b946931c49$var$PDFEmbeddedPage = /** @class */ function() {
    function PDFEmbeddedPage(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        (0, $8EKPA.assertIs)(ref, 'ref', [
            [
                (0, $69d09480b29248e9$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $8EKPA.assertIs)(doc, 'doc', [
            [
                (0, $6767bf97ac5b9b71$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        (0, $8EKPA.assertIs)(embedder, 'embedder', [
            [
                (0, $fe3ada739436b861$export$2e2bcd8739ae039),
                'PDFPageEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.width = embedder.width;
        this.height = embedder.height;
        this.embedder = embedder;
    }
    /**
     * Compute the width and height of this page after being scaled by the
     * given `factor`. For example:
     * ```js
     * embeddedPage.width  // => 500
     * embeddedPage.height // => 250
     *
     * const scaled = embeddedPage.scale(0.5)
     * scaled.width  // => 250
     * scaled.height // => 125
     * ```
     * This operation is often useful before drawing a page with
     * [[PDFPage.drawPage]] to compute the `width` and `height` options.
     * @param factor The factor by which this page should be scaled.
     * @returns The width and height of the page after being scaled.
     */ PDFEmbeddedPage.prototype.scale = function(factor) {
        (0, $8EKPA.assertIs)(factor, 'factor', [
            'number'
        ]);
        return {
            width: this.width * factor,
            height: this.height * factor
        };
    };
    /**
     * Get the width and height of this page. For example:
     * ```js
     * const { width, height } = embeddedPage.size()
     * ```
     * @returns The width and height of the page.
     */ PDFEmbeddedPage.prototype.size = function() {
        return this.scale(1);
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all embeddable pages get embedded.
     *
     * Embed this embeddable page in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFEmbeddedPage.prototype.embed = function() {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        _a.sent();
                        this.alreadyEmbedded = true;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedPdf]] and
     * > [[PDFDocument.embedPage]] methods, which will create instances of
     * > [[PDFEmbeddedPage]] for you.
     *
     * Create an instance of [[PDFEmbeddedPage]] from an existing ref and embedder
     *
     * @param ref The unique reference for this embedded page.
     * @param doc The document to which the embedded page will belong.
     * @param embedder The embedder that will be used to embed the page.
     */ PDFEmbeddedPage.of = function(ref, doc, embedder) {
        return new PDFEmbeddedPage(ref, doc, embedder);
    };
    return PDFEmbeddedPage;
}();
var $b964e8b946931c49$export$2e2bcd8739ae039 = $b964e8b946931c49$var$PDFEmbeddedPage;



var $273XO = parcelRequire("273XO");


parcelRequire("5bpFt");
var $8EKPA = parcelRequire("8EKPA");
/**
 * Represents a font that has been embedded in a [[PDFDocument]].
 */ var $2afe68c947457de4$var$PDFFont = /** @class */ function() {
    function PDFFont(ref, doc, embedder) {
        this.modified = true;
        (0, $8EKPA.assertIs)(ref, 'ref', [
            [
                (0, $69d09480b29248e9$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $8EKPA.assertIs)(doc, 'doc', [
            [
                (0, $6767bf97ac5b9b71$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        (0, $8EKPA.assertIs)(embedder, 'embedder', [
            [
                (0, $fb5d08cced3a1a67$export$2e2bcd8739ae039),
                'CustomFontEmbedder'
            ],
            [
                (0, $42d3777696dc5a8a$export$2e2bcd8739ae039),
                'StandardFontEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.name = embedder.fontName;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFPage.drawText]] method will automatically encode the text it is
     * > given.
     *
     * Encodes a string of text in this font.
     *
     * @param text The text to be encoded.
     * @returns The encoded text as a hex string.
     */ PDFFont.prototype.encodeText = function(text) {
        (0, $8EKPA.assertIs)(text, 'text', [
            'string'
        ]);
        this.modified = true;
        return this.embedder.encodeText(text);
    };
    /**
     * Measure the width of a string of text drawn in this font at a given size.
     * For example:
     * ```js
     * const width = font.widthOfTextAtSize('Foo Bar Qux Baz', 36)
     * ```
     * @param text The string of text to be measured.
     * @param size The font size to be used for this measurement.
     * @returns The width of the string of text when drawn in this font at the
     *          given size.
     */ PDFFont.prototype.widthOfTextAtSize = function(text, size) {
        (0, $8EKPA.assertIs)(text, 'text', [
            'string'
        ]);
        (0, $8EKPA.assertIs)(size, 'size', [
            'number'
        ]);
        return this.embedder.widthOfTextAtSize(text, size);
    };
    /**
     * Measure the height of this font at a given size. For example:
     * ```js
     * const height = font.heightAtSize(24)
     * ```
     *
     * The `options.descender` value controls whether or not the font's
     * descender is included in the height calculation.
     *
     * @param size The font size to be used for this measurement.
     * @param options The options to be used when computing this measurement.
     * @returns The height of this font at the given size.
     */ PDFFont.prototype.heightAtSize = function(size, options) {
        var _a;
        (0, $8EKPA.assertIs)(size, 'size', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.descender, 'options.descender', [
            'boolean'
        ]);
        return this.embedder.heightOfFontAtSize(size, {
            descender: (_a = options === null || options === void 0 ? void 0 : options.descender) !== null && _a !== void 0 ? _a : true
        });
    };
    /**
     * Compute the font size at which this font is a given height. For example:
     * ```js
     * const fontSize = font.sizeAtHeight(12)
     * ```
     * @param height The height to be used for this calculation.
     * @returns The font size at which this font is the given height.
     */ PDFFont.prototype.sizeAtHeight = function(height) {
        (0, $8EKPA.assertIs)(height, 'height', [
            'number'
        ]);
        return this.embedder.sizeOfFontAtHeight(height);
    };
    /**
     * Get the set of unicode code points that can be represented by this font.
     * @returns The set of unicode code points supported by this font.
     */ PDFFont.prototype.getCharacterSet = function() {
        if (this.embedder instanceof (0, $42d3777696dc5a8a$export$2e2bcd8739ae039)) return this.embedder.encoding.supportedCodePoints;
        else return this.embedder.font.characterSet;
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all fonts get embedded.
     *
     * Embed this font in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFFont.prototype.embed = function() {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.modified) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        _a.sent();
                        this.modified = false;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedFont]] and
     * > [[PDFDocument.embedStandardFont]] methods, which will create instances
     * > of [[PDFFont]] for you.
     *
     * Create an instance of [[PDFFont]] from an existing ref and embedder
     *
     * @param ref The unique reference for this font.
     * @param doc The document to which the font will belong.
     * @param embedder The embedder that will be used to embed the font.
     */ PDFFont.of = function(ref, doc, embedder) {
        return new PDFFont(ref, doc, embedder);
    };
    return PDFFont;
}();
var $2afe68c947457de4$export$2e2bcd8739ae039 = $2afe68c947457de4$var$PDFFont;



var $273XO = parcelRequire("273XO");


parcelRequire("5bpFt");
var $8EKPA = parcelRequire("8EKPA");
/**
 * Represents an image that has been embedded in a [[PDFDocument]].
 */ var $c6adec950ad59431$var$PDFImage = /** @class */ function() {
    function PDFImage(ref, doc, embedder) {
        (0, $8EKPA.assertIs)(ref, 'ref', [
            [
                (0, $69d09480b29248e9$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $8EKPA.assertIs)(doc, 'doc', [
            [
                (0, $6767bf97ac5b9b71$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        (0, $8EKPA.assertIs)(embedder, 'embedder', [
            [
                (0, $979a3eda8f6e7f4c$export$2e2bcd8739ae039),
                'JpegEmbedder'
            ],
            [
                (0, $9ba8d611194332cc$export$2e2bcd8739ae039),
                'PngEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.width = embedder.width;
        this.height = embedder.height;
        this.embedder = embedder;
    }
    /**
     * Compute the width and height of this image after being scaled by the
     * given `factor`. For example:
     * ```js
     * image.width  // => 500
     * image.height // => 250
     *
     * const scaled = image.scale(0.5)
     * scaled.width  // => 250
     * scaled.height // => 125
     * ```
     * This operation is often useful before drawing an image with
     * [[PDFPage.drawImage]] to compute the `width` and `height` options.
     * @param factor The factor by which this image should be scaled.
     * @returns The width and height of the image after being scaled.
     */ PDFImage.prototype.scale = function(factor) {
        (0, $8EKPA.assertIs)(factor, 'factor', [
            'number'
        ]);
        return {
            width: this.width * factor,
            height: this.height * factor
        };
    };
    /**
     * Get the width and height of this image after scaling it as large as
     * possible while maintaining its aspect ratio and not exceeding the
     * specified `width` and `height`. For example:
     * ```
     * image.width  // => 500
     * image.height // => 250
     *
     * const scaled = image.scaleToFit(750, 1000)
     * scaled.width  // => 750
     * scaled.height // => 375
     * ```
     * The `width` and `height` parameters can also be thought of as the width
     * and height of a box that the scaled image must fit within.
     * @param width The bounding box's width.
     * @param height The bounding box's height.
     * @returns The width and height of the image after being scaled.
     */ PDFImage.prototype.scaleToFit = function(width, height) {
        (0, $8EKPA.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(height, 'height', [
            'number'
        ]);
        var imgWidthScale = width / this.width;
        var imgHeightScale = height / this.height;
        var scale = Math.min(imgWidthScale, imgHeightScale);
        return this.scale(scale);
    };
    /**
     * Get the width and height of this image. For example:
     * ```js
     * const { width, height } = image.size()
     * ```
     * @returns The width and height of the image.
     */ PDFImage.prototype.size = function() {
        return this.scale(1);
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all images get embedded.
     *
     * Embed this image in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFImage.prototype.embed = function() {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var _a, doc, ref;
            return (0, $273XO.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.embedder) return [
                            2 /*return*/ 
                        ];
                        // The image should only be embedded once. If there's a pending embed
                        // operation then wait on it. Otherwise we need to start the embed.
                        if (!this.embedTask) {
                            _a = this, doc = _a.doc, ref = _a.ref;
                            this.embedTask = this.embedder.embedIntoContext(doc.context, ref);
                        }
                        return [
                            4 /*yield*/ ,
                            this.embedTask
                        ];
                    case 1:
                        _b.sent();
                        // We clear `this.embedder` so that the indirectly referenced image data
                        // can be garbage collected, thus avoiding a memory leak.
                        // See https://github.com/Hopding/pdf-lib/pull/1032/files.
                        this.embedder = undefined;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedPng]] and [[PDFDocument.embedJpg]]
     * > methods, which will create instances of [[PDFImage]] for you.
     *
     * Create an instance of [[PDFImage]] from an existing ref and embedder
     *
     * @param ref The unique reference for this image.
     * @param doc The document to which the image will belong.
     * @param embedder The embedder that will be used to embed the image.
     */ PDFImage.of = function(ref, doc, embedder) {
        return new PDFImage(ref, doc, embedder);
    };
    return PDFImage;
}();
var $c6adec950ad59431$export$2e2bcd8739ae039 = $c6adec950ad59431$var$PDFImage;




var $273XO = parcelRequire("273XO");



var $273XO = parcelRequire("273XO");





var $273XO = parcelRequire("273XO");




var $iMObG = parcelRequire("iMObG");
var $alPcq = parcelRequire("alPcq");
parcelRequire("5bpFt");
var $8EKPA = parcelRequire("8EKPA");
var $2e44185893bd08e1$export$8efa99ca8f041e7e;
(function(ImageAlignment) {
    ImageAlignment[ImageAlignment["Left"] = 0] = "Left";
    ImageAlignment[ImageAlignment["Center"] = 1] = "Center";
    ImageAlignment[ImageAlignment["Right"] = 2] = "Right";
})($2e44185893bd08e1$export$8efa99ca8f041e7e || ($2e44185893bd08e1$export$8efa99ca8f041e7e = {}));





var $bba8db1758f4c42e$export$55643210f1835a35 = function(options) {
    (0, $8EKPA.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.x, 'options.x', [
        'number'
    ]);
    (0, $8EKPA.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.y, 'options.y', [
        'number'
    ]);
    (0, $8EKPA.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.width, 'options.width', [
        'number'
    ]);
    (0, $8EKPA.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.height, 'options.height', [
        'number'
    ]);
    (0, $8EKPA.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.textColor, 'options.textColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $8EKPA.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.backgroundColor, 'options.backgroundColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $8EKPA.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.borderColor, 'options.borderColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $8EKPA.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.borderWidth, 'options.borderWidth', [
        'number'
    ]);
    (0, $8EKPA.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.rotate, 'options.rotate', [
        [
            Object,
            'Rotation'
        ]
    ]);
};
/**
 * Represents a field of a [[PDFForm]].
 *
 * This class is effectively abstract. All fields in a [[PDFForm]] will
 * actually be an instance of a subclass of this class.
 *
 * Note that each field in a PDF is represented by a single field object.
 * However, a given field object may be rendered at multiple locations within
 * the document (across one or more pages). The rendering of a field is
 * controlled by its widgets. Each widget causes its field to be displayed at a
 * particular location in the document.
 *
 * Most of the time each field in a PDF has only a single widget, and thus is
 * only rendered once. However, if a field is rendered multiple times, it will
 * have multiple widgets - one for each location it is rendered.
 *
 * This abstraction of field objects and widgets is defined in the PDF
 * specification and dictates how PDF files store fields and where they are
 * to be rendered.
 */ var $bba8db1758f4c42e$var$PDFField = /** @class */ function() {
    function PDFField(acroField, ref, doc) {
        (0, $8EKPA.assertIs)(acroField, 'acroField', [
            [
                (0, $4e9d559d3658cb30$export$2e2bcd8739ae039),
                'PDFAcroTerminal'
            ]
        ]);
        (0, $8EKPA.assertIs)(ref, 'ref', [
            [
                (0, $69d09480b29248e9$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $8EKPA.assertIs)(doc, 'doc', [
            [
                (0, $6767bf97ac5b9b71$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        this.acroField = acroField;
        this.ref = ref;
        this.doc = doc;
    }
    /**
     * Get the fully qualified name of this field. For example:
     * ```js
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const name = field.getName()
     *   console.log('Field name:', name)
     * })
     * ```
     * Note that PDF fields are structured as a tree. Each field is the
     * descendent of a series of ancestor nodes all the way up to the form node,
     * which is always the root of the tree. Each node in the tree (except for
     * the form node) has a partial name. Partial names can be composed of any
     * unicode characters except a period (`.`). The fully qualified name of a
     * field is composed of the partial names of all its ancestors joined
     * with periods. This means that splitting the fully qualified name on
     * periods and taking the last element of the resulting array will give you
     * the partial name of a specific field.
     * @returns The fully qualified name of this field.
     */ PDFField.prototype.getName = function() {
        var _a;
        return (_a = this.acroField.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : '';
    };
    /**
     * Returns `true` if this field is read only. This means that PDF readers
     * will not allow users to interact with the field or change its value. See
     * [[PDFField.enableReadOnly]] and [[PDFField.disableReadOnly]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isReadOnly()) console.log('Read only is enabled')
     * ```
     * @returns Whether or not this is a read only field.
     */ PDFField.prototype.isReadOnly = function() {
        return this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$3600c95532547643).ReadOnly);
    };
    /**
     * Prevent PDF readers from allowing users to interact with this field or
     * change its value. The field will not respond to mouse or keyboard input.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableReadOnly()
     * ```
     * Useful for fields whose values are computed, imported from a database, or
     * prefilled by software before being displayed to the user.
     */ PDFField.prototype.enableReadOnly = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$3600c95532547643).ReadOnly, true);
    };
    /**
     * Allow users to interact with this field and change its value in PDF
     * readers via mouse and keyboard input. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableReadOnly()
     * ```
     */ PDFField.prototype.disableReadOnly = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$3600c95532547643).ReadOnly, false);
    };
    /**
     * Returns `true` if this field must have a value when the form is submitted.
     * See [[PDFField.enableRequired]] and [[PDFField.disableRequired]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isRequired()) console.log('Field is required')
     * ```
     * @returns Whether or not this field is required.
     */ PDFField.prototype.isRequired = function() {
        return this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$3600c95532547643).Required);
    };
    /**
     * Require this field to have a value when the form is submitted.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableRequired()
     * ```
     */ PDFField.prototype.enableRequired = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$3600c95532547643).Required, true);
    };
    /**
     * Do not require this field to have a value when the form is submitted.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableRequired()
     * ```
     */ PDFField.prototype.disableRequired = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$3600c95532547643).Required, false);
    };
    /**
     * Returns `true` if this field's value should be exported when the form is
     * submitted. See [[PDFField.enableExporting]] and
     * [[PDFField.disableExporting]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isExported()) console.log('Exporting is enabled')
     * ```
     * @returns Whether or not this field's value should be exported.
     */ PDFField.prototype.isExported = function() {
        return !this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$3600c95532547643).NoExport);
    };
    /**
     * Indicate that this field's value should be exported when the form is
     * submitted in a PDF reader. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableExporting()
     * ```
     */ PDFField.prototype.enableExporting = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$3600c95532547643).NoExport, false);
    };
    /**
     * Indicate that this field's value should **not** be exported when the form
     * is submitted in a PDF reader. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableExporting()
     * ```
     */ PDFField.prototype.disableExporting = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$3600c95532547643).NoExport, true);
    };
    /** @ignore */ PDFField.prototype.needsAppearancesUpdate = function() {
        throw new (0, $iMObG.MethodNotImplementedError)(this.constructor.name, 'needsAppearancesUpdate');
    };
    /** @ignore */ PDFField.prototype.defaultUpdateAppearances = function(_font) {
        throw new (0, $iMObG.MethodNotImplementedError)(this.constructor.name, 'defaultUpdateAppearances');
    };
    PDFField.prototype.markAsDirty = function() {
        this.doc.getForm().markFieldAsDirty(this.ref);
    };
    PDFField.prototype.markAsClean = function() {
        this.doc.getForm().markFieldAsClean(this.ref);
    };
    PDFField.prototype.isDirty = function() {
        return this.doc.getForm().fieldIsDirty(this.ref);
    };
    PDFField.prototype.createWidget = function(options) {
        var _a;
        var textColor = options.textColor;
        var backgroundColor = options.backgroundColor;
        var borderColor = options.borderColor;
        var borderWidth = options.borderWidth;
        var degreesAngle = (0, $86b75e7e8bb6dd95$export$56cb859c01fa134d)(options.rotate);
        var caption = options.caption;
        var x = options.x;
        var y = options.y;
        var width = options.width + borderWidth;
        var height = options.height + borderWidth;
        var hidden = Boolean(options.hidden);
        var pageRef = options.page;
        (0, $8EKPA.assertMultiple)(degreesAngle, 'degreesAngle', 90);
        // Create a widget for this field
        var widget = (0, $effa7e0ecccc206a$export$2e2bcd8739ae039).create(this.doc.context, this.ref);
        // Set widget properties
        var rect = (0, $86b75e7e8bb6dd95$export$afddc3b8600307a4)({
            x: x,
            y: y,
            width: width,
            height: height
        }, borderWidth, degreesAngle);
        widget.setRectangle(rect);
        if (pageRef) widget.setP(pageRef);
        var ac = widget.getOrCreateAppearanceCharacteristics();
        if (backgroundColor) ac.setBackgroundColor((0, $04532fa67d29096c$export$ffee2793812e3e56)(backgroundColor));
        ac.setRotation(degreesAngle);
        if (caption) ac.setCaptions({
            normal: caption
        });
        if (borderColor) ac.setBorderColor((0, $04532fa67d29096c$export$ffee2793812e3e56)(borderColor));
        var bs = widget.getOrCreateBorderStyle();
        if (borderWidth !== undefined) bs.setWidth(borderWidth);
        widget.setFlagTo((0, $4506fe64ca79cf11$export$1fa7b68b35026177).Print, true);
        widget.setFlagTo((0, $4506fe64ca79cf11$export$1fa7b68b35026177).Hidden, hidden);
        widget.setFlagTo((0, $4506fe64ca79cf11$export$1fa7b68b35026177).Invisible, false);
        // Set acrofield properties
        if (textColor) {
            var da = (_a = this.acroField.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
            var newDa = da + '\n' + (0, $04532fa67d29096c$export$6126e5d7ba707741)(textColor).toString();
            this.acroField.setDefaultAppearance(newDa);
        }
        return widget;
    };
    PDFField.prototype.updateWidgetAppearanceWithFont = function(widget, font, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        this.updateWidgetAppearances(widget, {
            normal: this.createAppearanceStream(widget, normal, font),
            rollover: rollover && this.createAppearanceStream(widget, rollover, font),
            down: down && this.createAppearanceStream(widget, down, font)
        });
    };
    PDFField.prototype.updateOnOffWidgetAppearance = function(widget, onValue, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        this.updateWidgetAppearances(widget, {
            normal: this.createAppearanceDict(widget, normal, onValue),
            rollover: rollover && this.createAppearanceDict(widget, rollover, onValue),
            down: down && this.createAppearanceDict(widget, down, onValue)
        });
    };
    PDFField.prototype.updateWidgetAppearances = function(widget, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        widget.setNormalAppearance(normal);
        if (rollover) widget.setRolloverAppearance(rollover);
        else widget.removeRolloverAppearance();
        if (down) widget.setDownAppearance(down);
        else widget.removeDownAppearance();
    };
    // // TODO: Do we need to do this...?
    // private foo(font: PDFFont, dict: PDFDict) {
    //   if (!dict.lookup(PDFName.of('DR'))) {
    //     dict.set(PDFName.of('DR'), dict.context.obj({}));
    //   }
    //   const DR = dict.lookup(PDFName.of('DR'), PDFDict);
    //   if (!DR.lookup(PDFName.of('Font'))) {
    //     DR.set(PDFName.of('Font'), dict.context.obj({}));
    //   }
    //   const Font = DR.lookup(PDFName.of('Font'), PDFDict);
    //   Font.set(PDFName.of(font.name), font.ref);
    // }
    PDFField.prototype.createAppearanceStream = function(widget, appearance, font) {
        var _a;
        var context = this.acroField.dict.context;
        var _b = widget.getRectangle(), width = _b.width, height = _b.height;
        // TODO: Do we need to do this...?
        // if (font) {
        //   this.foo(font, widget.dict);
        //   this.foo(font, this.doc.getForm().acroForm.dict);
        // }
        // END TODO
        var Resources = font && {
            Font: (_a = {}, _a[font.name] = font.ref, _a)
        };
        var stream = context.formXObject(appearance, {
            Resources: Resources,
            BBox: context.obj([
                0,
                0,
                width,
                height
            ]),
            Matrix: context.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        });
        var streamRef = context.register(stream);
        return streamRef;
    };
    /**
     * Create a FormXObject of the supplied image and add it to context.
     * The FormXObject size is calculated based on the widget (including
     * the alignment).
     * @param widget The widget that should display the image.
     * @param alignment The alignment of the image.
     * @param image The image that should be displayed.
     * @returns The ref for the FormXObject that was added to the context.
     */ PDFField.prototype.createImageAppearanceStream = function(widget, image, alignment) {
        // NOTE: This implementation doesn't handle image borders.
        // NOTE: Acrobat seems to resize the image (maybe even skewing its aspect
        //       ratio) to fit perfectly within the widget's rectangle. This method
        //       does not currently do that. Should there be an option for that?
        var _a;
        var _b;
        var context = this.acroField.dict.context;
        var rectangle = widget.getRectangle();
        var ap = widget.getAppearanceCharacteristics();
        var bs = widget.getBorderStyle();
        var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
        var rotation = (0, $86b75e7e8bb6dd95$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
        var rotate = (0, $c3fbae23fda05c7a$export$5dd9a0a87f38a2a6)((0, $273XO.__assign)((0, $273XO.__assign)({}, rectangle), {
            rotation: rotation
        }));
        var adj = (0, $86b75e7e8bb6dd95$export$312e44550db33c6a)(rectangle, rotation);
        var imageDims = image.scaleToFit(adj.width - borderWidth * 2, adj.height - borderWidth * 2);
        // Support borders on images and maybe other properties
        var options = {
            x: borderWidth,
            y: borderWidth,
            width: imageDims.width,
            height: imageDims.height,
            //
            rotate: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            xSkew: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            ySkew: (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0)
        };
        if (alignment === (0, $2e44185893bd08e1$export$8efa99ca8f041e7e).Center) {
            options.x += (adj.width - borderWidth * 2) / 2 - imageDims.width / 2;
            options.y += (adj.height - borderWidth * 2) / 2 - imageDims.height / 2;
        } else if (alignment === (0, $2e44185893bd08e1$export$8efa99ca8f041e7e).Right) {
            options.x = adj.width - borderWidth - imageDims.width;
            options.y = adj.height - borderWidth - imageDims.height;
        }
        var imageName = this.doc.context.addRandomSuffix('Image', 10);
        var appearance = (0, $273XO.__spreadArrays)(rotate, (0, $c3fbae23fda05c7a$export$21a059be5bfd5fb)(imageName, options));
        ////////////
        var Resources = {
            XObject: (_a = {}, _a[imageName] = image.ref, _a)
        };
        var stream = context.formXObject(appearance, {
            Resources: Resources,
            BBox: context.obj([
                0,
                0,
                rectangle.width,
                rectangle.height
            ]),
            Matrix: context.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        });
        return context.register(stream);
    };
    PDFField.prototype.createAppearanceDict = function(widget, appearance, onValue) {
        var context = this.acroField.dict.context;
        var onStreamRef = this.createAppearanceStream(widget, appearance.on);
        var offStreamRef = this.createAppearanceStream(widget, appearance.off);
        var appearanceDict = context.obj({});
        appearanceDict.set(onValue, onStreamRef);
        appearanceDict.set((0, $alPcq.default).of('Off'), offStreamRef);
        return appearanceDict;
    };
    return PDFField;
}();
var $bba8db1758f4c42e$export$2e2bcd8739ae039 = $bba8db1758f4c42e$var$PDFField;



var $alPcq = parcelRequire("alPcq");
parcelRequire("5bpFt");
var $8EKPA = parcelRequire("8EKPA");
/**
 * Represents a check box field of a [[PDFForm]].
 *
 * [[PDFCheckBox]] fields are interactive boxes that users can click with their
 * mouse. This type of [[PDFField]] has two states: `on` and `off`. The purpose
 * of a check box is to enable users to select from one or more options, where
 * each option is represented by a single check box. Check boxes are typically
 * square in shape and display a check mark when they are in the `on` state.
 */ var $0ac1f7052bcd3f50$var$PDFCheckBox = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFCheckBox, _super);
    function PDFCheckBox(acroCheckBox, ref, doc) {
        var _this = _super.call(this, acroCheckBox, ref, doc) || this;
        (0, $8EKPA.assertIs)(acroCheckBox, 'acroCheckBox', [
            [
                (0, $e4d0dfeca465bbb2$export$2e2bcd8739ae039),
                'PDFAcroCheckBox'
            ]
        ]);
        _this.acroField = acroCheckBox;
        return _this;
    }
    /**
     * Mark this check box. This operation is analogous to a human user clicking
     * a check box to fill it in a PDF reader. This method will update the
     * underlying state of the check box field to indicate it has been selected.
     * PDF libraries and readers will be able to extract this value from the
     * saved document and determine that it was selected.
     *
     * For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.check()
     * ```
     *
     * This method will mark this check box as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated appearance
     * streams will display a check mark inside the widgets of this check box
     * field.
     */ PDFCheckBox.prototype.check = function() {
        var _a;
        var onValue = (_a = this.acroField.getOnValue()) !== null && _a !== void 0 ? _a : (0, $alPcq.default).of('Yes');
        this.markAsDirty();
        this.acroField.setValue(onValue);
    };
    /**
     * Clears this check box. This operation is analogous to a human user clicking
     * a check box to unmark it in a PDF reader. This method will update the
     * underlying state of the check box field to indicate it has been deselected.
     * PDF libraries and readers will be able to extract this value from the
     * saved document and determine that it was not selected.
     *
     * For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.uncheck()
     * ```
     *
     * This method will mark this check box as dirty. See [[PDFCheckBox.check]]
     * for more details about what this means.
     */ PDFCheckBox.prototype.uncheck = function() {
        this.markAsDirty();
        this.acroField.setValue((0, $alPcq.default).of('Off'));
    };
    /**
     * Returns `true` if this check box is selected (either by a human user via
     * a PDF reader, or else programmatically via software). For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * if (checkBox.isChecked()) console.log('check box is selected')
     * ```
     * @returns Whether or not this check box is selected.
     */ PDFCheckBox.prototype.isChecked = function() {
        var onValue = this.acroField.getOnValue();
        return !!onValue && onValue === this.acroField.getValue();
    };
    /**
     * Show this check box on the specified page. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const checkBox = form.createCheckBox('some.checkBox.field')
     *
     * checkBox.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 25,
     *   height: 25,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     * })
     * ```
     * This will create a new widget for this check box field.
     * @param page The page to which this check box widget should be added.
     * @param options The options to be used when adding this check box widget.
     */ PDFCheckBox.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f;
        (0, $8EKPA.assertIs)(page, 'page', [
            [
                (0, $4488acf63d90f5a1$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $bba8db1758f4c42e$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this check box
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 50,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        widget.setAppearanceState((0, $alPcq.default).of('Off'));
        this.updateWidgetAppearance(widget, (0, $alPcq.default).of('Yes'));
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if any of this check box's widgets do not have an
     * appearance stream for its current state. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * if (checkBox.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this check box needs an appearance update.
     */ PDFCheckBox.prototype.needsAppearancesUpdate = function() {
        var _a;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getAppearanceState();
            var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
            if (!(normal instanceof (0, $b7e75d63d5628aec$export$2e2bcd8739ae039))) return true;
            if (state && !normal.has(state)) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this check box's widgets using
     * the default appearance provider for check boxes. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.defaultUpdateAppearances()
     * ```
     */ PDFCheckBox.prototype.defaultUpdateAppearances = function() {
        this.updateAppearances();
    };
    /**
     * Update the appearance streams for each of this check box's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for check boxs will be used. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.updateAppearances((field, widget) => {
     *   ...
     *   return {
     *     normal: { on: drawCheckBox(...), off: drawCheckBox(...) },
     *     down: { on: drawCheckBox(...), off: drawCheckBox(...) },
     *   }
     * })
     * ```
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFCheckBox.prototype.updateAppearances = function(provider) {
        var _a;
        (0, $8EKPA.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var onValue = (_a = widget.getOnValue()) !== null && _a !== void 0 ? _a : (0, $alPcq.default).of('Yes');
            if (!onValue) continue;
            this.updateWidgetAppearance(widget, onValue, provider);
        }
        this.markAsClean();
    };
    PDFCheckBox.prototype.updateWidgetAppearance = function(widget, onValue, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $fd9d87d4f9bb8968$export$e11eab3ac6c06eb0);
        var appearances = (0, $fd9d87d4f9bb8968$export$8a3aea031520d39b)(apProvider(this, widget));
        this.updateOnOffWidgetAppearance(widget, onValue, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getCheckBox]] method, which will create an
     * > instance of [[PDFCheckBox]] for you.
     *
     * Create an instance of [[PDFCheckBox]] from an existing acroCheckBox and ref
     *
     * @param acroCheckBox The underlying `PDFAcroCheckBox` for this check box.
     * @param ref The unique reference for this check box.
     * @param doc The document to which this check box will belong.
     */ PDFCheckBox.of = function(acroCheckBox, ref, doc) {
        return new PDFCheckBox(acroCheckBox, ref, doc);
    };
    return PDFCheckBox;
}((0, $bba8db1758f4c42e$export$2e2bcd8739ae039));
var $0ac1f7052bcd3f50$export$2e2bcd8739ae039 = $0ac1f7052bcd3f50$var$PDFCheckBox;



var $273XO = parcelRequire("273XO");







parcelRequire("5bpFt");
var $8EKPA = parcelRequire("8EKPA");
/**
 * Represents a dropdown field of a [[PDFForm]].
 *
 * [[PDFDropdown]] fields are interactive text boxes that display a single
 * element (the currently selected value). The purpose of a dropdown is to
 * enable users to select a single option from a set of possible options. Users
 * can click on a dropdown to view the full list of options it provides.
 * Clicking on an option in the list will cause it to be selected and displayed
 * in the dropdown's text box. Some dropdowns allow users to enter text
 * directly into the box from their keyboard, rather than only being allowed to
 * choose an option from the list (see [[PDFDropdown.isEditable]]).
 */ var $a129b98313319255$var$PDFDropdown = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFDropdown, _super);
    function PDFDropdown(acroComboBox, ref, doc) {
        var _this = _super.call(this, acroComboBox, ref, doc) || this;
        (0, $8EKPA.assertIs)(acroComboBox, 'acroComboBox', [
            [
                (0, $7e91fc20f1654182$export$2e2bcd8739ae039),
                'PDFAcroComboBox'
            ]
        ]);
        _this.acroField = acroComboBox;
        return _this;
    }
    /**
     * Get the list of available options for this dropdown. These options will be
     * displayed to users who click on this dropdown in a PDF reader.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * const options = dropdown.getOptions()
     * console.log('Dropdown options:', options)
     * ```
     * @returns The options for this dropdown.
     */ PDFDropdown.prototype.getOptions = function() {
        var rawOptions = this.acroField.getOptions();
        var options = new Array(rawOptions.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = rawOptions[idx], display = _a.display, value = _a.value;
            options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
        }
        return options;
    };
    /**
     * Get the selected options for this dropdown. These are the values that were
     * selected by a human user via a PDF reader, or programatically via
     * software.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * const selections = dropdown.getSelected()
     * console.log('Dropdown selections:', selections)
     * ```
     * > **NOTE:** Note that PDF readers only display one selected option when
     * > rendering dropdowns. However, the PDF specification does allow for
     * > multiple values to be selected in a dropdown. As such, the `pdf-lib`
     * > API supports this. However, in most cases the array returned by this
     * > method will contain only a single element (or no elements).
     * @returns The selected options in this dropdown.
     */ PDFDropdown.prototype.getSelected = function() {
        var values = this.acroField.getValues();
        var selected = new Array(values.length);
        for(var idx = 0, len = values.length; idx < len; idx++)selected[idx] = values[idx].decodeText();
        return selected;
    };
    /**
     * Set the list of options that are available for this dropdown. These are
     * the values that will be available for users to select when they view this
     * dropdown in a PDF reader. Note that preexisting options for this dropdown
     * will be removed. Only the values passed as `options` will be available to
     * select.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('planets.dropdown')
     * dropdown.setOptions(['Earth', 'Mars', 'Pluto', 'Venus'])
     * ```
     * @param options The options that should be available in this dropdown.
     */ PDFDropdown.prototype.setOptions = function(options) {
        (0, $8EKPA.assertIs)(options, 'options', [
            Array
        ]);
        var optionObjects = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++)optionObjects[idx] = {
            value: (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(options[idx])
        };
        this.acroField.setOptions(optionObjects);
    };
    /**
     * Add to the list of options that are available for this dropdown. Users
     * will be able to select these values in a PDF reader. In addition to the
     * values passed as `options`, any preexisting options for this dropdown will
     * still be available for users to select.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('rockets.dropdown')
     * dropdown.addOptions(['Saturn IV', 'Falcon Heavy'])
     * ```
     * @param options New options that should be available in this dropdown.
     */ PDFDropdown.prototype.addOptions = function(options) {
        (0, $8EKPA.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var existingOptions = this.acroField.getOptions();
        var newOptions = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)newOptions[idx] = {
            value: (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(optionsArr[idx])
        };
        this.acroField.setOptions(existingOptions.concat(newOptions));
    };
    /**
     * Select one or more values for this dropdown. This operation is analogous
     * to a human user opening the dropdown in a PDF reader and clicking on a
     * value to select it. This method will update the underlying state of the
     * dropdown to indicate which values have been selected. PDF libraries and
     * readers will be able to extract these values from the saved document and
     * determine which values were selected.
     *
     * For example:
     * ```js
     * const dropdown = form.getDropdown('best.superhero.dropdown')
     * dropdown.select('One Punch Man')
     * ```
     *
     * This method will mark this dropdown as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the selected option inside the widgets of this dropdown.
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if the selected option for this field
     * contains characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFDropdown.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * Selecting an option that does not exist in this dropdown's option list
     * (see [[PDFDropdown.getOptions]]) will enable editing on this dropdown
     * (see [[PDFDropdown.enableEditing]]).
     *
     * > **NOTE:** PDF readers only display one selected option when rendering
     * > dropdowns. However, the PDF specification does allow for multiple values
     * > to be selected in a dropdown. As such, the `pdf-lib` API supports this.
     * > However, it is not recommended to select more than one value with this
     * > method, as only one will be visible. [[PDFOptionList]] fields are better
     * > suited for displaying multiple selected values.
     *
     * @param options The options to be selected.
     * @param merge Whether or not existing selections should be preserved.
     */ PDFDropdown.prototype.select = function(options, merge) {
        if (merge === void 0) merge = false;
        (0, $8EKPA.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        (0, $8EKPA.assertIs)(merge, 'merge', [
            'boolean'
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var validOptions = this.getOptions();
        var hasCustomOption = optionsArr.find(function(option) {
            return !validOptions.includes(option);
        });
        if (hasCustomOption) this.enableEditing();
        this.markAsDirty();
        if (optionsArr.length > 1 || optionsArr.length === 1 && merge) this.enableMultiselect();
        var values = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)values[idx] = (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(optionsArr[idx]);
        if (merge) {
            var existingValues = this.acroField.getValues();
            this.acroField.setValues(existingValues.concat(values));
        } else this.acroField.setValues(values);
    };
    /**
     * Clear all selected values for this dropdown. This operation is equivalent
     * to selecting an empty list. This method will update the underlying state
     * of the dropdown to indicate that no values have been selected.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.clear()
     * ```
     * This method will mark this text field as dirty. See [[PDFDropdown.select]]
     * for more details about what this means.
     */ PDFDropdown.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValues([]);
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this dropdown. Font sizes may
     * be integer or floating point numbers. Supplying a negative font size will
     * cause this method to throw an error.
     *
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.setFontSize(4)
     * dropdown.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFDropdown.prototype.setFontSize = function(fontSize) {
        (0, $8EKPA.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if users are allowed to edit the selected value of this
     * dropdown directly and are not constrained by the list of available
     * options. See [[PDFDropdown.enableEditing]] and
     * [[PDFDropdown.disableEditing]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isEditable()) console.log('Editing is enabled')
     * ```
     * @returns Whether or not this dropdown is editable.
     */ PDFDropdown.prototype.isEditable = function() {
        return this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$eb88827058402599).Edit);
    };
    /**
     * Allow users to edit the selected value of this dropdown in PDF readers
     * with their keyboard. This means that the selected value of this dropdown
     * will not be constrained by the list of available options. However, if this
     * dropdown has any available options, users will still be allowed to select
     * from that list.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableEditing()
     * ```
     */ PDFDropdown.prototype.enableEditing = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$eb88827058402599).Edit, true);
    };
    /**
     * Do not allow users to edit the selected value of this dropdown in PDF
     * readers with their keyboard. This will constrain the selected value of
     * this dropdown to the list of available options. Users will only be able
     * to select an option from that list.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableEditing()
     * ```
     */ PDFDropdown.prototype.disableEditing = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$eb88827058402599).Edit, false);
    };
    /**
     * Returns `true` if the option list of this dropdown is always displayed
     * in alphabetical order, irrespective of the order in which the options
     * were added to the dropdown. See [[PDFDropdown.enableSorting]] and
     * [[PDFDropdown.disableSorting]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSorted()) console.log('Sorting is enabled')
     * ```
     * @returns Whether or not this dropdown's options are sorted.
     */ PDFDropdown.prototype.isSorted = function() {
        return this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$eb88827058402599).Sort);
    };
    /**
     * Always display the option list of this dropdown in alphabetical order,
     * irrespective of the order in which the options were added to this dropdown.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSorting()
     * ```
     */ PDFDropdown.prototype.enableSorting = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$eb88827058402599).Sort, true);
    };
    /**
     * Do not always display the option list of this dropdown in alphabetical
     * order. Instead, display the options in whichever order they were added
     * to the list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSorting()
     * ```
     */ PDFDropdown.prototype.disableSorting = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$eb88827058402599).Sort, false);
    };
    /**
     * Returns `true` if multiple options can be selected from this dropdown's
     * option list. See [[PDFDropdown.enableMultiselect]] and
     * [[PDFDropdown.disableMultiselect]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isMultiselect()) console.log('Multiselect is enabled')
     * ```
     * @returns Whether or not multiple options can be selected.
     */ PDFDropdown.prototype.isMultiselect = function() {
        return this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$eb88827058402599).MultiSelect);
    };
    /**
     * Allow users to select more than one option from this dropdown's option
     * list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableMultiselect()
     * ```
     */ PDFDropdown.prototype.enableMultiselect = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$eb88827058402599).MultiSelect, true);
    };
    /**
     * Do not allow users to select more than one option from this dropdown's
     * option list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableMultiselect()
     * ```
     */ PDFDropdown.prototype.disableMultiselect = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$eb88827058402599).MultiSelect, false);
    };
    /**
     * Returns `true` if the selected option should be spell checked by PDF
     * readers. Spell checking will only be performed if this dropdown allows
     * editing (see [[PDFDropdown.isEditable]]). See
     * [[PDFDropdown.enableSpellChecking]] and
     * [[PDFDropdown.disableSpellChecking]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSpellChecked()) console.log('Spell checking is enabled')
     * ```
     * @returns Whether or not this dropdown can be spell checked.
     */ PDFDropdown.prototype.isSpellChecked = function() {
        return !this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$eb88827058402599).DoNotSpellCheck);
    };
    /**
     * Allow PDF readers to spell check the selected option of this dropdown.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSpellChecking()
     * ```
     */ PDFDropdown.prototype.enableSpellChecking = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$eb88827058402599).DoNotSpellCheck, false);
    };
    /**
     * Do not allow PDF readers to spell check the selected option of this
     * dropdown. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSpellChecking()
     * ```
     */ PDFDropdown.prototype.disableSpellChecking = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$eb88827058402599).DoNotSpellCheck, true);
    };
    /**
     * Returns `true` if the option selected by a user is stored, or "committed",
     * when the user clicks the option. The alternative is that the user's
     * selection is stored when the user leaves this dropdown field (by clicking
     * outside of it - on another field, for example). See
     * [[PDFDropdown.enableSelectOnClick]] and
     * [[PDFDropdown.disableSelectOnClick]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSelectOnClick()) console.log('Select on click is enabled')
     * ```
     * @returns Whether or not options are selected immediately after they are
     *          clicked.
     */ PDFDropdown.prototype.isSelectOnClick = function() {
        return this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$eb88827058402599).CommitOnSelChange);
    };
    /**
     * Store the option selected by a user immediately after the user clicks the
     * option. Do not wait for the user to leave this dropdown field (by clicking
     * outside of it - on another field, for example). For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSelectOnClick()
     * ```
     */ PDFDropdown.prototype.enableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$eb88827058402599).CommitOnSelChange, true);
    };
    /**
     * Wait to store the option selected by a user until they leave this dropdown
     * field (by clicking outside of it - on another field, for example).
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSelectOnClick()
     * ```
     */ PDFDropdown.prototype.disableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$eb88827058402599).CommitOnSelChange, false);
    };
    /**
     * Show this dropdown on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const dropdown = form.createDropdown('best.gundam')
     * dropdown.setOptions(['Exia', 'Dynames'])
     * dropdown.select('Exia')
     *
     * dropdown.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this dropdown field.
     * @param page The page to which this dropdown widget should be added.
     * @param options The options to be used when adding this dropdown widget.
     */ PDFDropdown.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $8EKPA.assertIs)(page, 'page', [
            [
                (0, $4488acf63d90f5a1$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $bba8db1758f4c42e$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this dropdown
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this dropdown has been marked as dirty, or if any of
     * this dropdown's widgets do not have an appearance stream. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this dropdown needs an appearance update.
     */ PDFDropdown.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $c444ed3a6bfbd846$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this dropdown's widgets using
     * the default appearance provider for dropdowns. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFDropdown.prototype.defaultUpdateAppearances = function(font) {
        (0, $8EKPA.assertIs)(font, 'font', [
            [
                (0, $2afe68c947457de4$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this dropdown's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for dropdowns will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawTextField(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFDropdown.prototype.updateAppearances = function(font, provider) {
        (0, $8EKPA.assertIs)(font, 'font', [
            [
                (0, $2afe68c947457de4$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    // getOption(index: number): string {}
    // getSelectedIndices(): number[] {}
    // removeOptions(option: string | string[]) {}
    // removeIndices(option: number[]) {}
    // deselect(options: string | string[]) {}
    // deselectIndices(optionIndices: number[]) {}
    PDFDropdown.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $fd9d87d4f9bb8968$export$90f1ca03d512ec5);
        var appearances = (0, $fd9d87d4f9bb8968$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getDropdown]] method, which will create an
     * > instance of [[PDFDropdown]] for you.
     *
     * Create an instance of [[PDFDropdown]] from an existing acroComboBox and ref
     *
     * @param acroComboBox The underlying `PDFAcroComboBox` for this dropdown.
     * @param ref The unique reference for this dropdown.
     * @param doc The document to which this dropdown will belong.
     */ PDFDropdown.of = function(acroComboBox, ref, doc) {
        return new PDFDropdown(acroComboBox, ref, doc);
    };
    return PDFDropdown;
}((0, $bba8db1758f4c42e$export$2e2bcd8739ae039));
var $a129b98313319255$export$2e2bcd8739ae039 = $a129b98313319255$var$PDFDropdown;



var $273XO = parcelRequire("273XO");







parcelRequire("5bpFt");
var $8EKPA = parcelRequire("8EKPA");
/**
 * Represents an option list field of a [[PDFForm]].
 *
 * [[PDFOptionList]] fields are interactive lists of options. The purpose of an
 * option list is to enable users to select one or more options from a set of
 * possible options. Users are able to see the full set of options without
 * first having to click on the field (though scrolling may be necessary).
 * Clicking an option in the list will cause it to be selected and displayed
 * with a highlighted background. Some option lists allow users to select
 * more than one option (see [[PDFOptionList.isMultiselect]]).
 */ var $38d3c2cac900ede7$var$PDFOptionList = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFOptionList, _super);
    function PDFOptionList(acroListBox, ref, doc) {
        var _this = _super.call(this, acroListBox, ref, doc) || this;
        (0, $8EKPA.assertIs)(acroListBox, 'acroListBox', [
            [
                (0, $a86c1687de785cba$export$2e2bcd8739ae039),
                'PDFAcroListBox'
            ]
        ]);
        _this.acroField = acroListBox;
        return _this;
    }
    /**
     * Get the list of available options for this option list. These options will
     * be displayed to users who view this option list in a PDF reader.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * const options = optionList.getOptions()
     * console.log('Option List options:', options)
     * ```
     * @returns The options for this option list.
     */ PDFOptionList.prototype.getOptions = function() {
        var rawOptions = this.acroField.getOptions();
        var options = new Array(rawOptions.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = rawOptions[idx], display = _a.display, value = _a.value;
            options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
        }
        return options;
    };
    /**
     * Get the selected options for this option list. These are the values that
     * were selected by a human user via a PDF reader, or programatically via
     * software.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * const selections = optionList.getSelected()
     * console.log('Option List selections:', selections)
     * ```
     * @returns The selected options for this option list.
     */ PDFOptionList.prototype.getSelected = function() {
        var values = this.acroField.getValues();
        var selected = new Array(values.length);
        for(var idx = 0, len = values.length; idx < len; idx++)selected[idx] = values[idx].decodeText();
        return selected;
    };
    /**
     * Set the list of options that are available for this option list. These are
     * the values that will be available for users to select when they view this
     * option list in a PDF reader. Note that preexisting options for this
     * option list will be removed. Only the values passed as `options` will be
     * available to select.
     *
     * For example:
     * ```js
     * const optionList = form.getOptionList('planets.optionList')
     * optionList.setOptions(['Earth', 'Mars', 'Pluto', 'Venus'])
     * ```
     *
     * This method will mark this option list as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the options this field contains inside the widgets of this text
     * field (with selected options highlighted).
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if this field contains any options
     * with characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFOptionList.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * @param options The options that should be available in this option list.
     */ PDFOptionList.prototype.setOptions = function(options) {
        (0, $8EKPA.assertIs)(options, 'options', [
            Array
        ]);
        this.markAsDirty();
        var optionObjects = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++)optionObjects[idx] = {
            value: (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(options[idx])
        };
        this.acroField.setOptions(optionObjects);
    };
    /**
     * Add to the list of options that are available for this option list. Users
     * will be able to select these values in a PDF reader. In addition to the
     * values passed as `options`, any preexisting options for this option list
     * will still be available for users to select.
     * For example:
     * ```js
     * const optionList = form.getOptionList('rockets.optionList')
     * optionList.addOptions(['Saturn IV', 'Falcon Heavy'])
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     * @param options New options that should be available in this option list.
     */ PDFOptionList.prototype.addOptions = function(options) {
        (0, $8EKPA.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        this.markAsDirty();
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var existingOptions = this.acroField.getOptions();
        var newOptions = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)newOptions[idx] = {
            value: (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(optionsArr[idx])
        };
        this.acroField.setOptions(existingOptions.concat(newOptions));
    };
    /**
     * Select one or more values for this option list. This operation is analogous
     * to a human user opening the option list in a PDF reader and clicking on one
     * or more values to select them. This method will update the underlying state
     * of the option list to indicate which values have been selected. PDF
     * libraries and readers will be able to extract these values from the saved
     * document and determine which values were selected.
     * For example:
     * ```js
     * const optionList = form.getOptionList('best.superheroes.optionList')
     * optionList.select(['One Punch Man', 'Iron Man'])
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     * @param options The options to be selected.
     * @param merge Whether or not existing selections should be preserved.
     */ PDFOptionList.prototype.select = function(options, merge) {
        if (merge === void 0) merge = false;
        (0, $8EKPA.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        (0, $8EKPA.assertIs)(merge, 'merge', [
            'boolean'
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var validOptions = this.getOptions();
        (0, $8EKPA.assertIsSubset)(optionsArr, 'option', validOptions);
        this.markAsDirty();
        if (optionsArr.length > 1 || optionsArr.length === 1 && merge) this.enableMultiselect();
        var values = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)values[idx] = (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(optionsArr[idx]);
        if (merge) {
            var existingValues = this.acroField.getValues();
            this.acroField.setValues(existingValues.concat(values));
        } else this.acroField.setValues(values);
    };
    /**
     * Clear all selected values for this option list. This operation is
     * equivalent to selecting an empty list. This method will update the
     * underlying state of the option list to indicate that no values have been
     * selected.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.clear()
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     */ PDFOptionList.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValues([]);
    };
    /**
     * Set the font size for the text in this field. There needs to be a
     * default appearance string (DA) set with a font value specified
     * for this to work. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.setFontSize(4);
     * ```
     * @param fontSize The font size to set the font to.
     */ /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this option list. Font sizes
     * may be integer or floating point numbers. Supplying a negative font size
     * will cause this method to throw an error.
     *
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.setFontSize(4)
     * optionList.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFOptionList.prototype.setFontSize = function(fontSize) {
        (0, $8EKPA.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if the options of this option list are always displayed
     * in alphabetical order, irrespective of the order in which the options
     * were added to the option list. See [[PDFOptionList.enableSorting]] and
     * [[PDFOptionList.disableSorting]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isSorted()) console.log('Sorting is enabled')
     * ```
     * @returns Whether or not this option list is sorted.
     */ PDFOptionList.prototype.isSorted = function() {
        return this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$eb88827058402599).Sort);
    };
    /**
     * Always display the options of this option list in alphabetical order,
     * irrespective of the order in which the options were added to this option
     * list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableSorting()
     * ```
     */ PDFOptionList.prototype.enableSorting = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$eb88827058402599).Sort, true);
    };
    /**
     * Do not always display the options of this option list in alphabetical
     * order. Instead, display the options in whichever order they were added
     * to this option list. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableSorting()
     * ```
     */ PDFOptionList.prototype.disableSorting = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$eb88827058402599).Sort, false);
    };
    /**
     * Returns `true` if multiple options can be selected from this option list.
     * See [[PDFOptionList.enableMultiselect]] and
     * [[PDFOptionList.disableMultiselect]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isMultiselect()) console.log('Multiselect is enabled')
     * ```
     * @returns Whether or not multiple options can be selected.
     */ PDFOptionList.prototype.isMultiselect = function() {
        return this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$eb88827058402599).MultiSelect);
    };
    /**
     * Allow users to select more than one option from this option list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableMultiselect()
     * ```
     */ PDFOptionList.prototype.enableMultiselect = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$eb88827058402599).MultiSelect, true);
    };
    /**
     * Do not allow users to select more than one option from this option list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableMultiselect()
     * ```
     */ PDFOptionList.prototype.disableMultiselect = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$eb88827058402599).MultiSelect, false);
    };
    /**
     * Returns `true` if the option selected by a user is stored, or "committed",
     * when the user clicks the option. The alternative is that the user's
     * selection is stored when the user leaves this option list field (by
     * clicking outside of it - on another field, for example). See
     * [[PDFOptionList.enableSelectOnClick]] and
     * [[PDFOptionList.disableSelectOnClick]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isSelectOnClick()) console.log('Select on click is enabled')
     * ```
     * @returns Whether or not options are selected immediately after they are
     *          clicked.
     */ PDFOptionList.prototype.isSelectOnClick = function() {
        return this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$eb88827058402599).CommitOnSelChange);
    };
    /**
     * Store the option selected by a user immediately after the user clicks the
     * option. Do not wait for the user to leave this option list field (by
     * clicking outside of it - on another field, for example). For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableSelectOnClick()
     * ```
     */ PDFOptionList.prototype.enableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$eb88827058402599).CommitOnSelChange, true);
    };
    /**
     * Wait to store the option selected by a user until they leave this option
     * list field (by clicking outside of it - on another field, for example).
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableSelectOnClick()
     * ```
     */ PDFOptionList.prototype.disableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$eb88827058402599).CommitOnSelChange, false);
    };
    /**
     * Show this option list on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const optionList = form.createOptionList('best.gundams')
     * optionList.setOptions(['Exia', 'Dynames', 'Kyrios', 'Virtue'])
     * optionList.select(['Exia', 'Virtue'])
     *
     * optionList.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this option list field.
     * @param page The page to which this option list widget should be added.
     * @param options The options to be used when adding this option list widget.
     */ PDFOptionList.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $8EKPA.assertIs)(page, 'page', [
            [
                (0, $4488acf63d90f5a1$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $bba8db1758f4c42e$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this option list
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this option list has been marked as dirty, or if any of
     * this option list's widgets do not have an appearance stream. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this option list needs an appearance update.
     */ PDFOptionList.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $c444ed3a6bfbd846$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this option list's widgets using
     * the default appearance provider for option lists. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFOptionList.prototype.defaultUpdateAppearances = function(font) {
        (0, $8EKPA.assertIs)(font, 'font', [
            [
                (0, $2afe68c947457de4$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this option list's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for option lists will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawOptionList(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFOptionList.prototype.updateAppearances = function(font, provider) {
        (0, $8EKPA.assertIs)(font, 'font', [
            [
                (0, $2afe68c947457de4$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    // getOption(index: number): string {}
    // getSelectedIndices(): number[] {}
    // removeOptions(option: string | string[]) {}
    // removeIndices(option: number[]) {}
    // deselect(options: string | string[]) {}
    // deselectIndices(optionIndices: number[]) {}
    PDFOptionList.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $fd9d87d4f9bb8968$export$f9fab495286778d2);
        var appearances = (0, $fd9d87d4f9bb8968$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getOptionList]] method, which will create
     * > an instance of [[PDFOptionList]] for you.
     *
     * Create an instance of [[PDFOptionList]] from an existing acroListBox and
     * ref
     *
     * @param acroComboBox The underlying `PDFAcroListBox` for this option list.
     * @param ref The unique reference for this option list.
     * @param doc The document to which this option list will belong.
     */ PDFOptionList.of = function(acroListBox, ref, doc) {
        return new PDFOptionList(acroListBox, ref, doc);
    };
    return PDFOptionList;
}((0, $bba8db1758f4c42e$export$2e2bcd8739ae039));
var $38d3c2cac900ede7$export$2e2bcd8739ae039 = $38d3c2cac900ede7$var$PDFOptionList;



var $273XO = parcelRequire("273XO");






var $alPcq = parcelRequire("alPcq");
parcelRequire("5bpFt");
var $8EKPA = parcelRequire("8EKPA");
/**
 * Represents a radio group field of a [[PDFForm]].
 *
 * [[PDFRadioGroup]] fields are collections of radio buttons. The purpose of a
 * radio group is to enable users to select one option from a set of mutually
 * exclusive choices. Each choice in a radio group is represented by a radio
 * button. Radio buttons each have two states: `on` and `off`. At most one
 * radio button in a group may be in the `on` state at any time. Users can
 * click on a radio button to select it (and thereby automatically deselect any
 * other radio button that might have already been selected). Some radio
 * groups allow users to toggle a selected radio button `off` by clicking on
 * it (see [[PDFRadioGroup.isOffToggleable]]).
 *
 * Note that some radio groups allow multiple radio buttons to be in the `on`
 * state at the same type **if** they represent the same underlying value (see
 * [[PDFRadioGroup.isMutuallyExclusive]]).
 */ var $27943e17afee77c3$var$PDFRadioGroup = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFRadioGroup, _super);
    function PDFRadioGroup(acroRadioButton, ref, doc) {
        var _this = _super.call(this, acroRadioButton, ref, doc) || this;
        (0, $8EKPA.assertIs)(acroRadioButton, 'acroRadioButton', [
            [
                (0, $9004a8a5faa8e65b$export$2e2bcd8739ae039),
                'PDFAcroRadioButton'
            ]
        ]);
        _this.acroField = acroRadioButton;
        return _this;
    }
    /**
     * Get the list of available options for this radio group. Each option is
     * represented by a radio button. These radio buttons are displayed at
     * various locations in the document, potentially on different pages (though
     * typically they are stacked horizontally or vertically on the same page).
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * const options = radioGroup.getOptions()
     * console.log('Radio Group options:', options)
     * ```
     * @returns The options for this radio group.
     */ PDFRadioGroup.prototype.getOptions = function() {
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            var exportOptions = new Array(exportValues.length);
            for(var idx = 0, len = exportValues.length; idx < len; idx++)exportOptions[idx] = exportValues[idx].decodeText();
            return exportOptions;
        }
        var onValues = this.acroField.getOnValues();
        var onOptions = new Array(onValues.length);
        for(var idx = 0, len = onOptions.length; idx < len; idx++)onOptions[idx] = onValues[idx].decodeText();
        return onOptions;
    };
    /**
     * Get the selected option for this radio group. The selected option is
     * represented by the radio button in this group that is turned on. At most
     * one radio button in a group can be selected. If no buttons in this group
     * are selected, `undefined` is returned.
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * const selected = radioGroup.getSelected()
     * console.log('Selected radio button:', selected)
     * ```
     * @returns The selected option for this radio group.
     */ PDFRadioGroup.prototype.getSelected = function() {
        var value = this.acroField.getValue();
        if (value === (0, $alPcq.default).of('Off')) return undefined;
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            var onValues = this.acroField.getOnValues();
            for(var idx = 0, len = onValues.length; idx < len; idx++){
                if (onValues[idx] === value) return exportValues[idx].decodeText();
            }
        }
        return value.decodeText();
    };
    // // TODO: Figure out why this seems to crash Acrobat. Maybe it's because we
    // //       aren't removing the widget reference from the page's Annots?
    // removeOption(option: string) {
    //   assertIs(option, 'option', ['string']);
    //   // TODO: Assert is valid `option`!
    //   const onValues = this.acroField.getOnValues();
    //   const exportValues = this.acroField.getExportValues();
    //   if (exportValues) {
    //     for (let idx = 0, len = exportValues.length; idx < len; idx++) {
    //       if (exportValues[idx].decodeText() === option) {
    //         this.acroField.removeWidget(idx);
    //         this.acroField.removeExportValue(idx);
    //       }
    //     }
    //   } else {
    //     for (let idx = 0, len = onValues.length; idx < len; idx++) {
    //       const value = onValues[idx];
    //       if (value.decodeText() === option) {
    //         this.acroField.removeWidget(idx);
    //         this.acroField.removeExportValue(idx);
    //       }
    //     }
    //   }
    // }
    /**
     * Select an option for this radio group. This operation is analogous to a
     * human user clicking one of the radio buttons in this group via a PDF
     * reader to toggle it on. This method will update the underlying state of
     * the radio group to indicate which option has been selected. PDF libraries
     * and readers will be able to extract this value from the saved document and
     * determine which option was selected.
     *
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('best.superhero.radioGroup')
     * radioGroup.select('One Punch Man')
     * ```
     *
     * This method will mark this radio group as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated appearance
     * streams will display a dot inside the widget of this check box field
     * that represents the selected option.
     *
     * @param option The option to be selected.
     */ PDFRadioGroup.prototype.select = function(option) {
        (0, $8EKPA.assertIs)(option, 'option', [
            'string'
        ]);
        var validOptions = this.getOptions();
        (0, $8EKPA.assertIsOneOf)(option, 'option', validOptions);
        this.markAsDirty();
        var onValues = this.acroField.getOnValues();
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            for(var idx = 0, len = exportValues.length; idx < len; idx++)if (exportValues[idx].decodeText() === option) this.acroField.setValue(onValues[idx]);
        } else for(var idx = 0, len = onValues.length; idx < len; idx++){
            var value = onValues[idx];
            if (value.decodeText() === option) this.acroField.setValue(value);
        }
    };
    /**
     * Clear any selected option for this dropdown. This will result in all
     * radio buttons in this group being toggled off. This method will update
     * the underlying state of the dropdown to indicate that no radio buttons
     * have been selected.
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.clear()
     * ```
     * This method will mark this radio group as dirty. See
     * [[PDFRadioGroup.select]] for more details about what this means.
     */ PDFRadioGroup.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValue((0, $alPcq.default).of('Off'));
    };
    /**
     * Returns `true` if users can click on radio buttons in this group to toggle
     * them off. The alternative is that once a user clicks on a radio button
     * to select it, the only way to deselect it is by selecting on another radio
     * button in the group. See [[PDFRadioGroup.enableOffToggling]] and
     * [[PDFRadioGroup.disableOffToggling]]. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.isOffToggleable()) console.log('Off toggling is enabled')
     * ```
     */ PDFRadioGroup.prototype.isOffToggleable = function() {
        return !this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$59f660e89ffb4f8a).NoToggleToOff);
    };
    /**
     * Allow users to click on selected radio buttons in this group to toggle
     * them off. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.enableOffToggling()
     * ```
     * > **NOTE:** This feature is documented in the PDF specification
     * > (Table 226). However, most PDF readers do not respect this option and
     * > prevent users from toggling radio buttons off even when it is enabled.
     * > At the time of this writing (9/6/2020) Mac's Preview software did
     * > respect the option. Adobe Acrobat, Foxit Reader, and Google Chrome did
     * > not.
     */ PDFRadioGroup.prototype.enableOffToggling = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$59f660e89ffb4f8a).NoToggleToOff, false);
    };
    /**
     * Prevent users from clicking on selected radio buttons in this group to
     * toggle them off. Clicking on a selected radio button will have no effect.
     * The only way to deselect a selected radio button is to click on a
     * different radio button in the group. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.disableOffToggling()
     * ```
     */ PDFRadioGroup.prototype.disableOffToggling = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$59f660e89ffb4f8a).NoToggleToOff, true);
    };
    /**
     * Returns `true` if the radio buttons in this group are mutually exclusive.
     * This means that when the user selects a radio button, only that specific
     * button will be turned on. Even if other radio buttons in the group
     * represent the same value, they will not be enabled. The alternative to
     * this is that clicking a radio button will select that button along with
     * any other radio buttons in the group that share the same value. See
     * [[PDFRadioGroup.enableMutualExclusion]] and
     * [[PDFRadioGroup.disableMutualExclusion]].
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.isMutuallyExclusive()) console.log('Mutual exclusion is enabled')
     * ```
     */ PDFRadioGroup.prototype.isMutuallyExclusive = function() {
        return !this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$59f660e89ffb4f8a).RadiosInUnison);
    };
    /**
     * When the user clicks a radio button in this group it will be selected. In
     * addition, any other radio buttons in this group that share the same
     * underlying value will also be selected. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.enableMutualExclusion()
     * ```
     * Note that this option must be enabled prior to adding options to the
     * radio group. It does not currently apply retroactively to existing
     * radio buttons in the group.
     */ PDFRadioGroup.prototype.enableMutualExclusion = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$59f660e89ffb4f8a).RadiosInUnison, false);
    };
    /**
     * When the user clicks a radio button in this group only it will be selected.
     * No other radio buttons in the group will be selected, even if they share
     * the same underlying value. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.disableMutualExclusion()
     * ```
     * Note that this option must be disabled prior to adding options to the
     * radio group. It does not currently apply retroactively to existing
     * radio buttons in the group.
     */ PDFRadioGroup.prototype.disableMutualExclusion = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$59f660e89ffb4f8a).RadiosInUnison, true);
    };
    /**
     * Add a new radio button to this group on the specified page. For example:
     * ```js
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const radioGroup = form.createRadioGroup('best.gundam')
     *
     * const options = {
     *   x: 50,
     *   width: 25,
     *   height: 25,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     * }
     *
     * radioGroup.addOptionToPage('Exia', page, { ...options, y: 50 })
     * radioGroup.addOptionToPage('Dynames', page, { ...options, y: 110 })
     * ```
     * This will create a new radio button widget for this radio group field.
     * @param option The option that the radio button widget represents.
     * @param page The page to which the radio button widget should be added.
     * @param options The options to be used when adding the radio button widget.
     */ PDFRadioGroup.prototype.addOptionToPage = function(option, page, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        (0, $8EKPA.assertIs)(option, 'option', [
            'string'
        ]);
        (0, $8EKPA.assertIs)(page, 'page', [
            [
                (0, $4488acf63d90f5a1$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $bba8db1758f4c42e$export$55643210f1835a35)(options);
        // Create a widget for this radio button
        var widget = this.createWidget({
            x: (_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options === null || options === void 0 ? void 0 : options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options === null || options === void 0 ? void 0 : options.width) !== null && _c !== void 0 ? _c : 50,
            height: (_d = options === null || options === void 0 ? void 0 : options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: (_e = options === null || options === void 0 ? void 0 : options.textColor) !== null && _e !== void 0 ? _e : (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0),
            backgroundColor: (_f = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _f !== void 0 ? _f : (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(1, 1, 1),
            borderColor: (_g = options === null || options === void 0 ? void 0 : options.borderColor) !== null && _g !== void 0 ? _g : (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0),
            borderWidth: (_h = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _h !== void 0 ? _h : 1,
            rotate: (_j = options === null || options === void 0 ? void 0 : options.rotate) !== null && _j !== void 0 ? _j : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            hidden: options === null || options === void 0 ? void 0 : options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        var apStateValue = this.acroField.addWidgetWithOpt(widgetRef, (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(option), !this.isMutuallyExclusive());
        // Set appearance streams for widget
        widget.setAppearanceState((0, $alPcq.default).of('Off'));
        this.updateWidgetAppearance(widget, apStateValue);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if any of this group's radio button widgets do not have an
     * appearance stream for their current state. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this radio group needs an appearance update.
     */ PDFRadioGroup.prototype.needsAppearancesUpdate = function() {
        var _a;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getAppearanceState();
            var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
            if (!(normal instanceof (0, $b7e75d63d5628aec$export$2e2bcd8739ae039))) return true;
            if (state && !normal.has(state)) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this group's radio button widgets
     * using the default appearance provider for radio groups. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.defaultUpdateAppearances()
     * ```
     */ PDFRadioGroup.prototype.defaultUpdateAppearances = function() {
        this.updateAppearances();
    };
    // rg.updateAppearances((field: any, widget: any) => {
    //   assert(field === rg);
    //   assert(widget instanceof PDFWidgetAnnotation);
    //   return { on: [...rectangle, ...circle], off: [...rectangle, ...circle] };
    // });
    /**
     * Update the appearance streams for each of this group's radio button widgets
     * using the given appearance provider. If no `provider` is passed, the
     * default appearance provider for radio groups will be used. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.updateAppearances((field, widget) => {
     *   ...
     *   return {
     *     normal: { on: drawRadioButton(...), off: drawRadioButton(...) },
     *     down: { on: drawRadioButton(...), off: drawRadioButton(...) },
     *   }
     * })
     * ```
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFRadioGroup.prototype.updateAppearances = function(provider) {
        (0, $8EKPA.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var onValue = widget.getOnValue();
            if (!onValue) continue;
            this.updateWidgetAppearance(widget, onValue, provider);
        }
    };
    PDFRadioGroup.prototype.updateWidgetAppearance = function(widget, onValue, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $fd9d87d4f9bb8968$export$6440094330a99ef8);
        var appearances = (0, $fd9d87d4f9bb8968$export$8a3aea031520d39b)(apProvider(this, widget));
        this.updateOnOffWidgetAppearance(widget, onValue, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getOptionList]] method, which will create an
     * > instance of [[PDFOptionList]] for you.
     *
     * Create an instance of [[PDFOptionList]] from an existing acroRadioButton
     * and ref
     *
     * @param acroRadioButton The underlying `PDFAcroRadioButton` for this
     *                        radio group.
     * @param ref The unique reference for this radio group.
     * @param doc The document to which this radio group will belong.
     */ PDFRadioGroup.of = function(acroRadioButton, ref, doc) {
        return new PDFRadioGroup(acroRadioButton, ref, doc);
    };
    return PDFRadioGroup;
}((0, $bba8db1758f4c42e$export$2e2bcd8739ae039));
var $27943e17afee77c3$export$2e2bcd8739ae039 = $27943e17afee77c3$var$PDFRadioGroup;



var $273XO = parcelRequire("273XO");


parcelRequire("5bpFt");
var $8EKPA = parcelRequire("8EKPA");
/**
 * Represents a signature field of a [[PDFForm]].
 *
 * [[PDFSignature]] fields are digital signatures. `pdf-lib` does not
 * currently provide any specialized APIs for creating digital signatures or
 * reading the contents of existing digital signatures.
 */ var $6d8d0a9e15799b4d$var$PDFSignature = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFSignature, _super);
    function PDFSignature(acroSignature, ref, doc) {
        var _this = _super.call(this, acroSignature, ref, doc) || this;
        (0, $8EKPA.assertIs)(acroSignature, 'acroSignature', [
            [
                (0, $c88dea97eb4cb799$export$2e2bcd8739ae039),
                'PDFAcroSignature'
            ]
        ]);
        _this.acroField = acroSignature;
        return _this;
    }
    PDFSignature.prototype.needsAppearancesUpdate = function() {
        return false;
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getSignature]] method, which will create an
     * > instance of [[PDFSignature]] for you.
     *
     * Create an instance of [[PDFSignature]] from an existing acroSignature and
     * ref
     *
     * @param acroSignature The underlying `PDFAcroSignature` for this signature.
     * @param ref The unique reference for this signature.
     * @param doc The document to which this signature will belong.
     */ PDFSignature.of = function(acroSignature, ref, doc) {
        return new PDFSignature(acroSignature, ref, doc);
    };
    return PDFSignature;
}((0, $bba8db1758f4c42e$export$2e2bcd8739ae039));
var $6d8d0a9e15799b4d$export$2e2bcd8739ae039 = $6d8d0a9e15799b4d$var$PDFSignature;



var $273XO = parcelRequire("273XO");










parcelRequire("5bpFt");
var $8EKPA = parcelRequire("8EKPA");
/**
 * Represents a text field of a [[PDFForm]].
 *
 * [[PDFTextField]] fields are boxes that display text entered by the user. The
 * purpose of a text field is to enable users to enter text or view text values
 * in the document prefilled by software. Users can click on a text field and
 * input text via their keyboard. Some text fields allow multiple lines of text
 * to be entered (see [[PDFTextField.isMultiline]]).
 */ var $1b47a06ca58b1046$var$PDFTextField = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFTextField, _super);
    function PDFTextField(acroText, ref, doc) {
        var _this = _super.call(this, acroText, ref, doc) || this;
        (0, $8EKPA.assertIs)(acroText, 'acroText', [
            [
                (0, $f7fcbb3a1ecb38a8$export$2e2bcd8739ae039),
                'PDFAcroText'
            ]
        ]);
        _this.acroField = acroText;
        return _this;
    }
    /**
     * Get the text that this field contains. This text is visible to users who
     * view this field in a PDF reader.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const text = textField.getText()
     * console.log('Text field contents:', text)
     * ```
     *
     * Note that if this text field contains no underlying value, `undefined`
     * will be returned. Text fields may also contain an underlying value that
     * is simply an empty string (`''`). This detail is largely irrelevant for
     * most applications. In general, you'll want to treat both cases the same
     * way and simply consider the text field to be empty. In either case, the
     * text field will appear empty to users when viewed in a PDF reader.
     *
     * An error will be thrown if this is a rich text field. `pdf-lib` does not
     * support reading rich text fields. Nor do most PDF readers and writers.
     * Rich text fields are based on XFA (XML Forms Architecture). Relatively few
     * PDFs use rich text fields or XFA. Unlike PDF itself, XFA is not an ISO
     * standard. XFA has been deprecated in PDF 2.0:
     * * https://en.wikipedia.org/wiki/XFA
     * * http://blog.pdfshareforms.com/pdf-2-0-release-bid-farewell-xfa-forms/
     *
     * @returns The text contained in this text field.
     */ PDFTextField.prototype.getText = function() {
        var value = this.acroField.getValue();
        if (!value && this.isRichFormatted()) throw new (0, $07ff41eb9264b36f$export$f2fed572e1ed57ab)(this.getName());
        return value === null || value === void 0 ? void 0 : value.decodeText();
    };
    /**
     * Set the text for this field. This operation is analogous to a human user
     * clicking on the text field in a PDF reader and typing in text via their
     * keyboard. This method will update the underlying state of the text field
     * to indicate what text has been set. PDF libraries and readers will be able
     * to extract these values from the saved document and determine what text
     * was set.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('best.superhero.text.field')
     * textField.setText('One Punch Man')
     * ```
     *
     * This method will mark this text field as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the text this field contains inside the widgets of this text
     * field.
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if this field contains text outside
     * the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFTextField.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * If this is a rich text field, it will be converted to a standard text
     * field in order to set the text. `pdf-lib` does not support writing rich
     * text strings. Nor do most PDF readers and writers. See
     * [[PDFTextField.getText]] for more information about rich text fields and
     * their deprecation in PDF 2.0.
     *
     * @param text The text this field should contain.
     */ PDFTextField.prototype.setText = function(text) {
        (0, $8EKPA.assertOrUndefined)(text, 'text', [
            'string'
        ]);
        var maxLength = this.getMaxLength();
        if (maxLength !== undefined && text && text.length > maxLength) throw new (0, $07ff41eb9264b36f$export$1577e99040d42609)(text.length, maxLength, this.getName());
        this.markAsDirty();
        this.disableRichFormatting();
        if (text) this.acroField.setValue((0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(text));
        else this.acroField.removeValue();
    };
    /**
     * Get the alignment for this text field. This value represents the
     * justification of the text when it is displayed to the user in PDF readers.
     * There are three possible alignments: left, center, and right. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const alignment = textField.getAlignment()
     * if (alignment === TextAlignment.Left) console.log('Text is left justified')
     * if (alignment === TextAlignment.Center) console.log('Text is centered')
     * if (alignment === TextAlignment.Right) console.log('Text is right justified')
     * ```
     * @returns The alignment of this text field.
     */ PDFTextField.prototype.getAlignment = function() {
        var quadding = this.acroField.getQuadding();
        // prettier-ignore
        return quadding === 0 ? (0, $616c0504afff154b$export$84b2d1b68830363f).Left : quadding === 1 ? (0, $616c0504afff154b$export$84b2d1b68830363f).Center : quadding === 2 ? (0, $616c0504afff154b$export$84b2d1b68830363f).Right : (0, $616c0504afff154b$export$84b2d1b68830363f).Left;
    };
    /**
     * Set the alignment for this text field. This will determine the
     * justification of the text when it is displayed to the user in PDF readers.
     * There are three possible alignments: left, center, and right. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     *
     * // Text will be left justified when displayed
     * textField.setAlignment(TextAlignment.Left)
     *
     * // Text will be centered when displayed
     * textField.setAlignment(TextAlignment.Center)
     *
     * // Text will be right justified when displayed
     * textField.setAlignment(TextAlignment.Right)
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     * @param alignment The alignment for this text field.
     */ PDFTextField.prototype.setAlignment = function(alignment) {
        (0, $8EKPA.assertIsOneOf)(alignment, 'alignment', (0, $616c0504afff154b$export$84b2d1b68830363f));
        this.markAsDirty();
        this.acroField.setQuadding(alignment);
    };
    /**
     * Get the maximum length of this field. This value represents the maximum
     * number of characters that can be typed into this field by the user. If
     * this field does not have a maximum length, `undefined` is returned.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const maxLength = textField.getMaxLength()
     * if (maxLength === undefined) console.log('No max length')
     * else console.log(`Max length is ${maxLength}`)
     * ```
     * @returns The maximum number of characters allowed in this field, or
     *          `undefined` if no limit exists.
     */ PDFTextField.prototype.getMaxLength = function() {
        return this.acroField.getMaxLength();
    };
    /**
     * Set the maximum length of this field. This limits the number of characters
     * that can be typed into this field by the user. This also limits the length
     * of the string that can be passed to [[PDFTextField.setText]]. This limit
     * can be removed by passing `undefined` as `maxLength`. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     *
     * // Allow between 0 and 5 characters to be entered
     * textField.setMaxLength(5)
     *
     * // Allow any number of characters to be entered
     * textField.setMaxLength(undefined)
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     * @param maxLength The maximum number of characters allowed in this field, or
     *                  `undefined` to remove the limit.
     */ PDFTextField.prototype.setMaxLength = function(maxLength) {
        (0, $8EKPA.assertRangeOrUndefined)(maxLength, 'maxLength', 0, Number.MAX_SAFE_INTEGER);
        this.markAsDirty();
        if (maxLength === undefined) this.acroField.removeMaxLength();
        else {
            var text = this.getText();
            if (text && text.length > maxLength) throw new (0, $07ff41eb9264b36f$export$6da6c372180e79b0)(text.length, maxLength, this.getName());
            this.acroField.setMaxLength(maxLength);
        }
    };
    /**
     * Remove the maximum length for this text field. This allows any number of
     * characters to be typed into this field by the user. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.removeMaxLength()
     * ```
     * Calling this method is equivalent to passing `undefined` to
     * [[PDFTextField.setMaxLength]].
     */ PDFTextField.prototype.removeMaxLength = function() {
        this.markAsDirty();
        this.acroField.removeMaxLength();
    };
    /**
     * Display an image inside the bounds of this text field's widgets. For example:
     * ```js
     * const pngImage = await pdfDoc.embedPng(...)
     * const textField = form.getTextField('some.text.field')
     * textField.setImage(pngImage)
     * ```
     * This will update the appearances streams for each of this text field's widgets.
     * @param image The image that should be displayed.
     */ PDFTextField.prototype.setImage = function(image) {
        var fieldAlignment = this.getAlignment();
        // prettier-ignore
        var alignment = fieldAlignment === (0, $616c0504afff154b$export$84b2d1b68830363f).Center ? (0, $2e44185893bd08e1$export$8efa99ca8f041e7e).Center : fieldAlignment === (0, $616c0504afff154b$export$84b2d1b68830363f).Right ? (0, $2e44185893bd08e1$export$8efa99ca8f041e7e).Right : (0, $2e44185893bd08e1$export$8efa99ca8f041e7e).Left;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var streamRef = this.createImageAppearanceStream(widget, image, alignment);
            this.updateWidgetAppearances(widget, {
                normal: streamRef
            });
        }
        this.markAsClean();
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this text field. Font sizes
     * may be integer or floating point numbers. Supplying a negative font size
     * will cause this method to throw an error.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.setFontSize(4)
     * textField.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFTextField.prototype.setFontSize = function(fontSize) {
        (0, $8EKPA.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if each line of text is shown on a new line when this
     * field is displayed in a PDF reader. The alternative is that all lines of
     * text are merged onto a single line when displayed. See
     * [[PDFTextField.enableMultiline]] and [[PDFTextField.disableMultiline]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isMultiline()) console.log('Multiline is enabled')
     * ```
     * @returns Whether or not this is a multiline text field.
     */ PDFTextField.prototype.isMultiline = function() {
        return this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).Multiline);
    };
    /**
     * Display each line of text on a new line when this field is displayed in a
     * PDF reader. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableMultiline()
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.enableMultiline = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).Multiline, true);
    };
    /**
     * Display each line of text on the same line when this field is displayed
     * in a PDF reader. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableMultiline()
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.disableMultiline = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).Multiline, false);
    };
    /**
     * Returns `true` if this is a password text field. This means that the field
     * is intended for storing a secure password. See
     * [[PDFTextField.enablePassword]] and [[PDFTextField.disablePassword]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isPassword()) console.log('Password is enabled')
     * ```
     * @returns Whether or not this is a password text field.
     */ PDFTextField.prototype.isPassword = function() {
        return this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).Password);
    };
    /**
     * Indicate that this text field is intended for storing a secure password.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enablePassword()
     * ```
     * Values entered into password text fields should not be displayed on the
     * screen by PDF readers. Most PDF readers will display the value as
     * asterisks or bullets. PDF readers should never store values entered by the
     * user into password text fields. Similarly, applications should not
     * write data to a password text field.
     *
     * **Please note that this method does not cause entered values to be
     * encrypted or secured in any way! It simply sets a flag that PDF software
     * and readers can access to determine the _purpose_ of this field.**
     */ PDFTextField.prototype.enablePassword = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).Password, true);
    };
    /**
     * Indicate that this text field is **not** intended for storing a secure
     * password. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disablePassword()
     * ```
     */ PDFTextField.prototype.disablePassword = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).Password, false);
    };
    /**
     * Returns `true` if the contents of this text field represent a file path.
     * See [[PDFTextField.enableFileSelection]] and
     * [[PDFTextField.disableFileSelection]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isFileSelector()) console.log('Is a file selector')
     * ```
     * @returns Whether or not this field should contain file paths.
     */ PDFTextField.prototype.isFileSelector = function() {
        return this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).FileSelect);
    };
    /**
     * Indicate that this text field is intended to store a file path. The
     * contents of the file stored at that path should be submitted as the value
     * of the field. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableFileSelection()
     * ```
     */ PDFTextField.prototype.enableFileSelection = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).FileSelect, true);
    };
    /**
     * Indicate that this text field is **not** intended to store a file path.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableFileSelection()
     * ```
     */ PDFTextField.prototype.disableFileSelection = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).FileSelect, false);
    };
    /**
     * Returns `true` if the text entered in this field should be spell checked
     * by PDF readers. See [[PDFTextField.enableSpellChecking]] and
     * [[PDFTextField.disableSpellChecking]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isSpellChecked()) console.log('Spell checking is enabled')
     * ```
     * @returns Whether or not this field should be spell checked.
     */ PDFTextField.prototype.isSpellChecked = function() {
        return !this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).DoNotSpellCheck);
    };
    /**
     * Allow PDF readers to spell check the text entered in this field.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableSpellChecking()
     * ```
     */ PDFTextField.prototype.enableSpellChecking = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).DoNotSpellCheck, false);
    };
    /**
     * Do not allow PDF readers to spell check the text entered in this field.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableSpellChecking()
     * ```
     */ PDFTextField.prototype.disableSpellChecking = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).DoNotSpellCheck, true);
    };
    /**
     * Returns `true` if PDF readers should allow the user to scroll the text
     * field when its contents do not fit within the field's view bounds. See
     * [[PDFTextField.enableScrolling]] and [[PDFTextField.disableScrolling]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isScrollable()) console.log('Scrolling is enabled')
     * ```
     * @returns Whether or not the field is scrollable in PDF readers.
     */ PDFTextField.prototype.isScrollable = function() {
        return !this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).DoNotScroll);
    };
    /**
     * Allow PDF readers to present a scroll bar to the user when the contents
     * of this text field do not fit within its view bounds. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableScrolling()
     * ```
     * A horizontal scroll bar should be shown for singleline fields. A vertical
     * scroll bar should be shown for multiline fields.
     */ PDFTextField.prototype.enableScrolling = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).DoNotScroll, false);
    };
    /**
     * Do not allow PDF readers to present a scroll bar to the user when the
     * contents of this text field do not fit within its view bounds. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableScrolling()
     * ```
     */ PDFTextField.prototype.disableScrolling = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).DoNotScroll, true);
    };
    /**
     * Returns `true` if this is a combed text field. This means that the field
     * is split into `n` equal size cells with one character in each (where `n`
     * is equal to the max length of the text field). The result is that all
     * characters in this field are displayed an equal distance apart from one
     * another. See [[PDFTextField.enableCombing]] and
     * [[PDFTextField.disableCombing]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isCombed()) console.log('Combing is enabled')
     * ```
     * Note that in order for a text field to be combed, the following must be
     * true (in addition to enabling combing):
     * * It must not be a multiline field (see [[PDFTextField.isMultiline]])
     * * It must not be a password field (see [[PDFTextField.isPassword]])
     * * It must not be a file selector field (see [[PDFTextField.isFileSelector]])
     * * It must have a max length defined (see [[PDFTextField.setMaxLength]])
     * @returns Whether or not this field is combed.
     */ PDFTextField.prototype.isCombed = function() {
        return this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).Comb) && !this.isMultiline() && !this.isPassword() && !this.isFileSelector() && this.getMaxLength() !== undefined;
    };
    /**
     * Split this field into `n` equal size cells with one character in each
     * (where `n` is equal to the max length of the text field). This will cause
     * all characters in the field to be displayed an equal distance apart from
     * one another. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableCombing()
     * ```
     *
     * In addition to calling this method, text fields must have a max length
     * defined in order to be combed (see [[PDFTextField.setMaxLength]]).
     *
     * This method will also call the following three methods internally:
     * * [[PDFTextField.disableMultiline]]
     * * [[PDFTextField.disablePassword]]
     * * [[PDFTextField.disableFileSelection]]
     *
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.enableCombing = function() {
        if (this.getMaxLength() === undefined) {
            var msg = "PDFTextFields must have a max length in order to be combed";
            console.warn(msg);
        }
        this.markAsDirty();
        this.disableMultiline();
        this.disablePassword();
        this.disableFileSelection();
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).Comb, true);
    };
    /**
     * Turn off combing for this text field. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableCombing()
     * ```
     * See [[PDFTextField.isCombed]] and [[PDFTextField.enableCombing]] for more
     * information about what combing is.
     *
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.disableCombing = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).Comb, false);
    };
    /**
     * Returns `true` if this text field contains rich text. See
     * [[PDFTextField.enableRichFormatting]] and
     * [[PDFTextField.disableRichFormatting]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isRichFormatted()) console.log('Rich formatting enabled')
     * ```
     * @returns Whether or not this field contains rich text.
     */ PDFTextField.prototype.isRichFormatted = function() {
        return this.acroField.hasFlag((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).RichText);
    };
    /**
     * Indicate that this field contains XFA data - or rich text. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableRichFormatting()
     * ```
     * Note that `pdf-lib` does not support reading or writing rich text fields.
     * Nor do most PDF readers and writers. Rich text fields are based on XFA
     * (XML Forms Architecture). Relatively few PDFs use rich text fields or XFA.
     * Unlike PDF itself, XFA is not an ISO standard. XFA has been deprecated in
     * PDF 2.0:
     * * https://en.wikipedia.org/wiki/XFA
     * * http://blog.pdfshareforms.com/pdf-2-0-release-bid-farewell-xfa-forms/
     */ PDFTextField.prototype.enableRichFormatting = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).RichText, true);
    };
    /**
     * Indicate that this is a standard text field that does not XFA data (rich
     * text). For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableRichFormatting()
     * ```
     */ PDFTextField.prototype.disableRichFormatting = function() {
        this.acroField.setFlagTo((0, $2f45f5a23a67aac0$export$389fc7b97397dc8b).RichText, false);
    };
    /**
     * Show this text field on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const textField = form.createTextField('best.gundam')
     * textField.setText('Exia')
     *
     * textField.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this text field.
     * @param page The page to which this text field widget should be added.
     * @param options The options to be used when adding this text field widget.
     */ PDFTextField.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $8EKPA.assertIs)(page, 'page', [
            [
                (0, $4488acf63d90f5a1$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $bba8db1758f4c42e$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this text field
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this text field has been marked as dirty, or if any of
     * this text field's widgets do not have an appearance stream. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this text field needs an appearance update.
     */ PDFTextField.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $c444ed3a6bfbd846$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this text field's widgets using
     * the default appearance provider for text fields. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const textField = form.getTextField('some.text.field')
     * textField.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFTextField.prototype.defaultUpdateAppearances = function(font) {
        (0, $8EKPA.assertIs)(font, 'font', [
            [
                (0, $2afe68c947457de4$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this text field's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for text fields will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const textField = form.getTextField('some.text.field')
     * textField.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawTextField(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFTextField.prototype.updateAppearances = function(font, provider) {
        (0, $8EKPA.assertIs)(font, 'font', [
            [
                (0, $2afe68c947457de4$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    PDFTextField.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $fd9d87d4f9bb8968$export$42ba95e6b8df3d7);
        var appearances = (0, $fd9d87d4f9bb8968$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getTextField]] method, which will create an
     * > instance of [[PDFTextField]] for you.
     *
     * Create an instance of [[PDFTextField]] from an existing acroText and ref
     *
     * @param acroText The underlying `PDFAcroText` for this text field.
     * @param ref The unique reference for this text field.
     * @param doc The document to which this text field will belong.
     */ PDFTextField.of = function(acroText, ref, doc) {
        return new PDFTextField(acroText, ref, doc);
    };
    return PDFTextField;
}((0, $bba8db1758f4c42e$export$2e2bcd8739ae039));
var $1b47a06ca58b1046$export$2e2bcd8739ae039 = $1b47a06ca58b1046$var$PDFTextField;




var $1282fe3e684c999b$export$7dcb046109e65a3d;
(function(StandardFonts) {
    StandardFonts["Courier"] = "Courier";
    StandardFonts["CourierBold"] = "Courier-Bold";
    StandardFonts["CourierOblique"] = "Courier-Oblique";
    StandardFonts["CourierBoldOblique"] = "Courier-BoldOblique";
    StandardFonts["Helvetica"] = "Helvetica";
    StandardFonts["HelveticaBold"] = "Helvetica-Bold";
    StandardFonts["HelveticaOblique"] = "Helvetica-Oblique";
    StandardFonts["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    StandardFonts["TimesRoman"] = "Times-Roman";
    StandardFonts["TimesRomanBold"] = "Times-Bold";
    StandardFonts["TimesRomanItalic"] = "Times-Italic";
    StandardFonts["TimesRomanBoldItalic"] = "Times-BoldItalic";
    StandardFonts["Symbol"] = "Symbol";
    StandardFonts["ZapfDingbats"] = "ZapfDingbats";
})($1282fe3e684c999b$export$7dcb046109e65a3d || ($1282fe3e684c999b$export$7dcb046109e65a3d = {}));





var $alPcq = parcelRequire("alPcq");
parcelRequire("5bpFt");
var $8EKPA = parcelRequire("8EKPA");
var $hGYOY = parcelRequire("hGYOY");
/**
 * Represents the interactive form of a [[PDFDocument]].
 *
 * Interactive forms (sometimes called _AcroForms_) are collections of fields
 * designed to gather information from a user. A PDF document may contains any
 * number of fields that appear on various pages, all of which make up a single,
 * global interactive form spanning the entire document. This means that
 * instances of [[PDFDocument]] shall contain at most one [[PDFForm]].
 *
 * The fields of an interactive form are represented by [[PDFField]] instances.
 */ var $9f9197a15bd45437$var$PDFForm = /** @class */ function() {
    function PDFForm(acroForm, doc) {
        var _this = this;
        this.embedDefaultFont = function() {
            return _this.doc.embedStandardFont((0, $1282fe3e684c999b$export$7dcb046109e65a3d).Helvetica);
        };
        (0, $8EKPA.assertIs)(acroForm, 'acroForm', [
            [
                (0, $095cce1dc29ae701$export$2e2bcd8739ae039),
                'PDFAcroForm'
            ]
        ]);
        (0, $8EKPA.assertIs)(doc, 'doc', [
            [
                (0, $6767bf97ac5b9b71$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        this.acroForm = acroForm;
        this.doc = doc;
        this.dirtyFields = new Set();
        this.defaultFontCache = (0, $hGYOY.default).populatedBy(this.embedDefaultFont);
    }
    /**
     * Returns `true` if this [[PDFForm]] has XFA data. Most PDFs with form
     * fields do not use XFA as it is not widely supported by PDF readers.
     *
     * > `pdf-lib` does not support creation, modification, or reading of XFA
     * > fields.
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * if (form.hasXFA()) console.log('PDF has XFA data')
     * ```
     * @returns Whether or not this form has XFA data.
     */ PDFForm.prototype.hasXFA = function() {
        return this.acroForm.dict.has((0, $alPcq.default).of('XFA'));
    };
    /**
     * Disconnect the XFA data from this [[PDFForm]] (if any exists). This will
     * force readers to fallback to standard fields if the [[PDFDocument]]
     * contains any. For example:
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * form.deleteXFA()
     * ```
     */ PDFForm.prototype.deleteXFA = function() {
        this.acroForm.dict.delete((0, $alPcq.default).of('XFA'));
    };
    /**
     * Get all fields contained in this [[PDFForm]]. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const type = field.constructor.name
     *   const name = field.getName()
     *   console.log(`${type}: ${name}`)
     * })
     * ```
     * @returns An array of all fields in this form.
     */ PDFForm.prototype.getFields = function() {
        var allFields = this.acroForm.getAllFields();
        var fields = [];
        for(var idx = 0, len = allFields.length; idx < len; idx++){
            var _a = allFields[idx], acroField = _a[0], ref = _a[1];
            var field = $9f9197a15bd45437$var$convertToPDFField(acroField, ref, this.doc);
            if (field) fields.push(field);
        }
        return fields;
    };
    /**
     * Get the field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getFieldMaybe('Page1.Foo.Bar[0]')
     * if (field) console.log('Field exists!')
     * ```
     * @param name A fully qualified field name.
     * @returns The field with the specified name, if one exists.
     */ PDFForm.prototype.getFieldMaybe = function(name) {
        (0, $8EKPA.assertIs)(name, 'name', [
            'string'
        ]);
        var fields = this.getFields();
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var field = fields[idx];
            if (field.getName() === name) return field;
        }
        return undefined;
    };
    /**
     * Get the field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('Page1.Foo.Bar[0]')
     * ```
     * If no field exists with the provided name, an error will be thrown.
     * @param name A fully qualified field name.
     * @returns The field with the specified name.
     */ PDFForm.prototype.getField = function(name) {
        (0, $8EKPA.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getFieldMaybe(name);
        if (field) return field;
        throw new (0, $07ff41eb9264b36f$export$5bc08baa4a027cbd)(name);
    };
    /**
     * Get the button field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const button = form.getButton('Page1.Foo.Button[0]')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a button.
     * @param name A fully qualified button name.
     * @returns The button with the specified name.
     */ PDFForm.prototype.getButton = function(name) {
        (0, $8EKPA.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $2b4cbbbb2f6a4cc4$export$2e2bcd8739ae039)) return field;
        throw new (0, $07ff41eb9264b36f$export$8909da6c566ff652)(name, (0, $2b4cbbbb2f6a4cc4$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the check box field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const checkBox = form.getCheckBox('Page1.Foo.CheckBox[0]')
     * checkBox.check()
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a check box.
     * @param name A fully qualified check box name.
     * @returns The check box with the specified name.
     */ PDFForm.prototype.getCheckBox = function(name) {
        (0, $8EKPA.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $0ac1f7052bcd3f50$export$2e2bcd8739ae039)) return field;
        throw new (0, $07ff41eb9264b36f$export$8909da6c566ff652)(name, (0, $0ac1f7052bcd3f50$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the dropdown field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const dropdown = form.getDropdown('Page1.Foo.Dropdown[0]')
     * const options = dropdown.getOptions()
     * dropdown.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a dropdown.
     * @param name A fully qualified dropdown name.
     * @returns The dropdown with the specified name.
     */ PDFForm.prototype.getDropdown = function(name) {
        (0, $8EKPA.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $a129b98313319255$export$2e2bcd8739ae039)) return field;
        throw new (0, $07ff41eb9264b36f$export$8909da6c566ff652)(name, (0, $a129b98313319255$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the option list field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const optionList = form.getOptionList('Page1.Foo.OptionList[0]')
     * const options = optionList.getOptions()
     * optionList.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not an option list.
     * @param name A fully qualified option list name.
     * @returns The option list with the specified name.
     */ PDFForm.prototype.getOptionList = function(name) {
        (0, $8EKPA.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $38d3c2cac900ede7$export$2e2bcd8739ae039)) return field;
        throw new (0, $07ff41eb9264b36f$export$8909da6c566ff652)(name, (0, $38d3c2cac900ede7$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the radio group field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const radioGroup = form.getRadioGroup('Page1.Foo.RadioGroup[0]')
     * const options = radioGroup.getOptions()
     * radioGroup.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a radio group.
     * @param name A fully qualified radio group name.
     * @returns The radio group with the specified name.
     */ PDFForm.prototype.getRadioGroup = function(name) {
        (0, $8EKPA.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $27943e17afee77c3$export$2e2bcd8739ae039)) return field;
        throw new (0, $07ff41eb9264b36f$export$8909da6c566ff652)(name, (0, $27943e17afee77c3$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the signature field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const signature = form.getSignature('Page1.Foo.Signature[0]')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a signature.
     * @param name A fully qualified signature name.
     * @returns The signature with the specified name.
     */ PDFForm.prototype.getSignature = function(name) {
        (0, $8EKPA.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $6d8d0a9e15799b4d$export$2e2bcd8739ae039)) return field;
        throw new (0, $07ff41eb9264b36f$export$8909da6c566ff652)(name, (0, $6d8d0a9e15799b4d$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the text field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const textField = form.getTextField('Page1.Foo.TextField[0]')
     * textField.setText('Are you designed to act or to be acted upon?')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a text field.
     * @param name A fully qualified text field name.
     * @returns The text field with the specified name.
     */ PDFForm.prototype.getTextField = function(name) {
        (0, $8EKPA.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $1b47a06ca58b1046$export$2e2bcd8739ae039)) return field;
        throw new (0, $07ff41eb9264b36f$export$8909da6c566ff652)(name, (0, $1b47a06ca58b1046$export$2e2bcd8739ae039), field);
    };
    /**
     * Create a new button field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const button = form.createButton('cool.new.button')
     *
     * button.addToPage('Do Stuff', font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new button.
     * @returns The new button field.
     */ PDFForm.prototype.createButton = function(name) {
        (0, $8EKPA.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $9f9197a15bd45437$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var button = (0, $91592ae7fb4500cd$export$2e2bcd8739ae039).create(this.doc.context);
        button.setPartialName(nameParts.terminal);
        $9f9197a15bd45437$var$addFieldToParent(parent, [
            button,
            button.ref
        ], nameParts.terminal);
        return (0, $2b4cbbbb2f6a4cc4$export$2e2bcd8739ae039).of(button, button.ref, this.doc);
    };
    /**
     * Create a new check box field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const checkBox = form.createCheckBox('cool.new.checkBox')
     *
     * checkBox.addToPage(page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new check box.
     * @returns The new check box field.
     */ PDFForm.prototype.createCheckBox = function(name) {
        (0, $8EKPA.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $9f9197a15bd45437$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var checkBox = (0, $e4d0dfeca465bbb2$export$2e2bcd8739ae039).create(this.doc.context);
        checkBox.setPartialName(nameParts.terminal);
        $9f9197a15bd45437$var$addFieldToParent(parent, [
            checkBox,
            checkBox.ref
        ], nameParts.terminal);
        return (0, $0ac1f7052bcd3f50$export$2e2bcd8739ae039).of(checkBox, checkBox.ref, this.doc);
    };
    /**
     * Create a new dropdown field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const dropdown = form.createDropdown('cool.new.dropdown')
     *
     * dropdown.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new dropdown.
     * @returns The new dropdown field.
     */ PDFForm.prototype.createDropdown = function(name) {
        (0, $8EKPA.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $9f9197a15bd45437$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var comboBox = (0, $7e91fc20f1654182$export$2e2bcd8739ae039).create(this.doc.context);
        comboBox.setPartialName(nameParts.terminal);
        $9f9197a15bd45437$var$addFieldToParent(parent, [
            comboBox,
            comboBox.ref
        ], nameParts.terminal);
        return (0, $a129b98313319255$export$2e2bcd8739ae039).of(comboBox, comboBox.ref, this.doc);
    };
    /**
     * Create a new option list field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const optionList = form.createOptionList('cool.new.optionList')
     *
     * optionList.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new option list.
     * @returns The new option list field.
     */ PDFForm.prototype.createOptionList = function(name) {
        (0, $8EKPA.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $9f9197a15bd45437$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var listBox = (0, $a86c1687de785cba$export$2e2bcd8739ae039).create(this.doc.context);
        listBox.setPartialName(nameParts.terminal);
        $9f9197a15bd45437$var$addFieldToParent(parent, [
            listBox,
            listBox.ref
        ], nameParts.terminal);
        return (0, $38d3c2cac900ede7$export$2e2bcd8739ae039).of(listBox, listBox.ref, this.doc);
    };
    /**
     * Create a new radio group field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const radioGroup = form.createRadioGroup('cool.new.radioGroup')
     *
     * radioGroup.addOptionToPage('is-dog', page, { y: 0 })
     * radioGroup.addOptionToPage('is-cat', page, { y: 75 })
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new radio group.
     * @returns The new radio group field.
     */ PDFForm.prototype.createRadioGroup = function(name) {
        (0, $8EKPA.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $9f9197a15bd45437$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var radioButton = (0, $9004a8a5faa8e65b$export$2e2bcd8739ae039).create(this.doc.context);
        radioButton.setPartialName(nameParts.terminal);
        $9f9197a15bd45437$var$addFieldToParent(parent, [
            radioButton,
            radioButton.ref
        ], nameParts.terminal);
        return (0, $27943e17afee77c3$export$2e2bcd8739ae039).of(radioButton, radioButton.ref, this.doc);
    };
    /**
     * Create a new text field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const textField = form.createTextField('cool.new.textField')
     *
     * textField.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new radio group.
     * @returns The new radio group field.
     */ PDFForm.prototype.createTextField = function(name) {
        (0, $8EKPA.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $9f9197a15bd45437$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var text = (0, $f7fcbb3a1ecb38a8$export$2e2bcd8739ae039).create(this.doc.context);
        text.setPartialName(nameParts.terminal);
        $9f9197a15bd45437$var$addFieldToParent(parent, [
            text,
            text.ref
        ], nameParts.terminal);
        return (0, $1b47a06ca58b1046$export$2e2bcd8739ae039).of(text, text.ref, this.doc);
    };
    /**
     * Flatten all fields in this [[PDFForm]].
     *
     * Flattening a form field will take the current appearance for each of that
     * field's widgets and make them part of their page's content stream. All form
     * fields and annotations associated are then removed. Note that once a form
     * has been flattened its fields can no longer be accessed or edited.
     *
     * This operation is often used after filling form fields to ensure a
     * consistent appearance across different PDF readers and/or printers.
     * Another common use case is to copy a template document with form fields
     * into another document. In this scenario you would load the template
     * document, fill its fields, flatten it, and then copy its pages into the
     * recipient document - the filled fields will be copied over.
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm();
     * form.flatten();
     * ```
     */ PDFForm.prototype.flatten = function(options) {
        if (options === void 0) options = {
            updateFieldAppearances: true
        };
        if (options.updateFieldAppearances) this.updateFieldAppearances();
        var fields = this.getFields();
        for(var i = 0, lenFields = fields.length; i < lenFields; i++){
            var field = fields[i];
            var widgets = field.acroField.getWidgets();
            for(var j = 0, lenWidgets = widgets.length; j < lenWidgets; j++){
                var widget = widgets[j];
                var page = this.findWidgetPage(widget);
                var widgetRef = this.findWidgetAppearanceRef(field, widget);
                var xObjectKey = page.node.newXObject('FlatWidget', widgetRef);
                var rectangle = widget.getRectangle();
                var operators = (0, $273XO.__spreadArrays)([
                    (0, $95072c08d604c329$export$cb182c48e35739ac)(),
                    (0, $95072c08d604c329$export$d73ee8ef04f5226a)(rectangle.x, rectangle.y)
                ], (0, $c3fbae23fda05c7a$export$5dd9a0a87f38a2a6)((0, $273XO.__assign)((0, $273XO.__assign)({}, rectangle), {
                    rotation: 0
                })), [
                    (0, $95072c08d604c329$export$382c18f8bccd9e2b)(xObjectKey),
                    (0, $95072c08d604c329$export$10581a6f45bf75eb)()
                ]).filter(Boolean);
                page.pushOperators.apply(page, operators);
            }
            this.removeField(field);
        }
    };
    /**
     * Remove a field from this [[PDFForm]].
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm();
     * const ageField = form.getFields().find(x => x.getName() === 'Age');
     * form.removeField(ageField);
     * ```
     */ PDFForm.prototype.removeField = function(field) {
        var widgets = field.acroField.getWidgets();
        var pages = new Set();
        for(var i = 0, len = widgets.length; i < len; i++){
            var widget = widgets[i];
            var widgetRef = this.findWidgetAppearanceRef(field, widget);
            var page = this.findWidgetPage(widget);
            pages.add(page);
            page.node.removeAnnot(widgetRef);
        }
        pages.forEach(function(page) {
            return page.node.removeAnnot(field.ref);
        });
        this.acroForm.removeField(field.acroField);
        var fieldKids = field.acroField.normalizedEntries().Kids;
        var kidsCount = fieldKids.size();
        for(var childIndex = 0; childIndex < kidsCount; childIndex++){
            var child = fieldKids.get(childIndex);
            if (child instanceof (0, $69d09480b29248e9$export$2e2bcd8739ae039)) this.doc.context.delete(child);
        }
        this.doc.context.delete(field.ref);
    };
    /**
     * Update the appearance streams for all widgets of all fields in this
     * [[PDFForm]]. Appearance streams will only be created for a widget if it
     * does not have any existing appearance streams, or the field's value has
     * changed (e.g. by calling [[PDFTextField.setText]] or
     * [[PDFDropdown.select]]).
     *
     * For example:
     * ```js
     * const courier = await pdfDoc.embedFont(StandardFonts.Courier)
     * const form = pdfDoc.getForm()
     * form.updateFieldAppearances(courier)
     * ```
     *
     * **IMPORTANT:** The default value for the `font` parameter is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if any fields contain text with
     * characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing that as the `font`
     * parameter allows you to generate appearance streams with non WinAnsi
     * characters (assuming your custom font supports them).
     *
     * > **NOTE:** The [[PDFDocument.save]] method will call this method to
     * > update appearances automatically if a form was accessed via the
     * > [[PDFDocument.getForm]] method prior to saving.
     *
     * @param font Optionally, the font to use when creating new appearances.
     */ PDFForm.prototype.updateFieldAppearances = function(font) {
        (0, $8EKPA.assertOrUndefined)(font, 'font', [
            [
                (0, $2afe68c947457de4$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        font = font !== null && font !== void 0 ? font : this.getDefaultFont();
        var fields = this.getFields();
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var field = fields[idx];
            if (field.needsAppearancesUpdate()) field.defaultUpdateAppearances(font);
        }
    };
    /**
     * Mark a field as dirty. This will cause its appearance streams to be
     * updated by [[PDFForm.updateFieldAppearances]].
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * form.markFieldAsDirty(field.ref)
     * ```
     * @param fieldRef The reference to the field that should be marked.
     */ PDFForm.prototype.markFieldAsDirty = function(fieldRef) {
        (0, $8EKPA.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $69d09480b29248e9$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        this.dirtyFields.add(fieldRef);
    };
    /**
     * Mark a field as dirty. This will cause its appearance streams to not be
     * updated by [[PDFForm.updateFieldAppearances]].
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * form.markFieldAsClean(field.ref)
     * ```
     * @param fieldRef The reference to the field that should be marked.
     */ PDFForm.prototype.markFieldAsClean = function(fieldRef) {
        (0, $8EKPA.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $69d09480b29248e9$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        this.dirtyFields.delete(fieldRef);
    };
    /**
     * Returns `true` is the specified field has been marked as dirty.
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * if (form.fieldIsDirty(field.ref)) console.log('Field is dirty')
     * ```
     * @param fieldRef The reference to the field that should be checked.
     * @returns Whether or not the specified field is dirty.
     */ PDFForm.prototype.fieldIsDirty = function(fieldRef) {
        (0, $8EKPA.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $69d09480b29248e9$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        return this.dirtyFields.has(fieldRef);
    };
    PDFForm.prototype.getDefaultFont = function() {
        return this.defaultFontCache.access();
    };
    PDFForm.prototype.findWidgetPage = function(widget) {
        var pageRef = widget.P();
        var page = this.doc.getPages().find(function(x) {
            return x.ref === pageRef;
        });
        if (page === undefined) {
            var widgetRef = this.doc.context.getObjectRef(widget.dict);
            if (widgetRef === undefined) throw new Error('Could not find PDFRef for PDFObject');
            page = this.doc.findPageForAnnotationRef(widgetRef);
            if (page === undefined) throw new Error("Could not find page for PDFRef " + widgetRef);
        }
        return page;
    };
    PDFForm.prototype.findWidgetAppearanceRef = function(field, widget) {
        var _a;
        var refOrDict = widget.getNormalAppearance();
        if (refOrDict instanceof (0, $b7e75d63d5628aec$export$2e2bcd8739ae039) && (field instanceof (0, $0ac1f7052bcd3f50$export$2e2bcd8739ae039) || field instanceof (0, $27943e17afee77c3$export$2e2bcd8739ae039))) {
            var value = field.acroField.getValue();
            var ref = (_a = refOrDict.get(value)) !== null && _a !== void 0 ? _a : refOrDict.get((0, $alPcq.default).of('Off'));
            if (ref instanceof (0, $69d09480b29248e9$export$2e2bcd8739ae039)) refOrDict = ref;
        }
        if (!(refOrDict instanceof (0, $69d09480b29248e9$export$2e2bcd8739ae039))) {
            var name_1 = field.getName();
            throw new Error("Failed to extract appearance ref for: " + name_1);
        }
        return refOrDict;
    };
    PDFForm.prototype.findOrCreateNonTerminals = function(partialNames) {
        var nonTerminal = [
            this.acroForm
        ];
        for(var idx = 0, len = partialNames.length; idx < len; idx++){
            var namePart = partialNames[idx];
            if (!namePart) throw new (0, $07ff41eb9264b36f$export$83c39fdacfe38500)(namePart);
            var parent_1 = nonTerminal[0], parentRef = nonTerminal[1];
            var res = this.findNonTerminal(namePart, parent_1);
            if (res) nonTerminal = res;
            else {
                var node = (0, $a8ccc6801a7a0cdb$export$2e2bcd8739ae039).create(this.doc.context);
                node.setPartialName(namePart);
                node.setParent(parentRef);
                var nodeRef = this.doc.context.register(node.dict);
                parent_1.addField(nodeRef);
                nonTerminal = [
                    node,
                    nodeRef
                ];
            }
        }
        return nonTerminal;
    };
    PDFForm.prototype.findNonTerminal = function(partialName, parent) {
        var fields = parent instanceof (0, $095cce1dc29ae701$export$2e2bcd8739ae039) ? this.acroForm.getFields() : (0, $57f64bc5d061277e$export$34b4fb8893136c4c)(parent.Kids());
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var _a = fields[idx], field = _a[0], ref = _a[1];
            if (field.getPartialName() === partialName) {
                if (field instanceof (0, $a8ccc6801a7a0cdb$export$2e2bcd8739ae039)) return [
                    field,
                    ref
                ];
                throw new (0, $07ff41eb9264b36f$export$c428cfe4dc6c68df)(partialName);
            }
        }
        return undefined;
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.getForm]] method, which will create an
     * > instance of [[PDFForm]] for you.
     *
     * Create an instance of [[PDFForm]] from an existing acroForm and embedder
     *
     * @param acroForm The underlying `PDFAcroForm` for this form.
     * @param doc The document to which the form will belong.
     */ PDFForm.of = function(acroForm, doc) {
        return new PDFForm(acroForm, doc);
    };
    return PDFForm;
}();
var $9f9197a15bd45437$export$2e2bcd8739ae039 = $9f9197a15bd45437$var$PDFForm;
var $9f9197a15bd45437$var$convertToPDFField = function(field, ref, doc) {
    if (field instanceof (0, $91592ae7fb4500cd$export$2e2bcd8739ae039)) return (0, $2b4cbbbb2f6a4cc4$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $e4d0dfeca465bbb2$export$2e2bcd8739ae039)) return (0, $0ac1f7052bcd3f50$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $7e91fc20f1654182$export$2e2bcd8739ae039)) return (0, $a129b98313319255$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $a86c1687de785cba$export$2e2bcd8739ae039)) return (0, $38d3c2cac900ede7$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $f7fcbb3a1ecb38a8$export$2e2bcd8739ae039)) return (0, $1b47a06ca58b1046$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $9004a8a5faa8e65b$export$2e2bcd8739ae039)) return (0, $27943e17afee77c3$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $c88dea97eb4cb799$export$2e2bcd8739ae039)) return (0, $6d8d0a9e15799b4d$export$2e2bcd8739ae039).of(field, ref, doc);
    return undefined;
};
var $9f9197a15bd45437$var$splitFieldName = function(fullyQualifiedName) {
    if (fullyQualifiedName.length === 0) throw new Error('PDF field names must not be empty strings');
    var parts = fullyQualifiedName.split('.');
    for(var idx = 0, len = parts.length; idx < len; idx++){
        if (parts[idx] === '') throw new Error("Periods in PDF field names must be separated by at least one character: \"" + fullyQualifiedName + "\"");
    }
    if (parts.length === 1) return {
        nonTerminal: [],
        terminal: parts[0]
    };
    return {
        nonTerminal: parts.slice(0, parts.length - 1),
        terminal: parts[parts.length - 1]
    };
};
var $9f9197a15bd45437$var$addFieldToParent = function(_a, _b, partialName) {
    var parent = _a[0], parentRef = _a[1];
    var field = _b[0], fieldRef = _b[1];
    var entries = parent.normalizedEntries();
    var fields = (0, $57f64bc5d061277e$export$34b4fb8893136c4c)('Kids' in entries ? entries.Kids : entries.Fields);
    for(var idx = 0, len = fields.length; idx < len; idx++){
        if (fields[idx][0].getPartialName() === partialName) throw new (0, $07ff41eb9264b36f$export$c428cfe4dc6c68df)(partialName);
    }
    parent.addField(fieldRef);
    field.setParent(parentRef);
};


var $e9e9f0f7557d61f7$export$b4a05ae367f5515c = {
    '4A0': [
        4767.87,
        6740.79
    ],
    '2A0': [
        3370.39,
        4767.87
    ],
    A0: [
        2383.94,
        3370.39
    ],
    A1: [
        1683.78,
        2383.94
    ],
    A2: [
        1190.55,
        1683.78
    ],
    A3: [
        841.89,
        1190.55
    ],
    A4: [
        595.28,
        841.89
    ],
    A5: [
        419.53,
        595.28
    ],
    A6: [
        297.64,
        419.53
    ],
    A7: [
        209.76,
        297.64
    ],
    A8: [
        147.4,
        209.76
    ],
    A9: [
        104.88,
        147.4
    ],
    A10: [
        73.7,
        104.88
    ],
    B0: [
        2834.65,
        4008.19
    ],
    B1: [
        2004.09,
        2834.65
    ],
    B2: [
        1417.32,
        2004.09
    ],
    B3: [
        1000.63,
        1417.32
    ],
    B4: [
        708.66,
        1000.63
    ],
    B5: [
        498.9,
        708.66
    ],
    B6: [
        354.33,
        498.9
    ],
    B7: [
        249.45,
        354.33
    ],
    B8: [
        175.75,
        249.45
    ],
    B9: [
        124.72,
        175.75
    ],
    B10: [
        87.87,
        124.72
    ],
    C0: [
        2599.37,
        3676.54
    ],
    C1: [
        1836.85,
        2599.37
    ],
    C2: [
        1298.27,
        1836.85
    ],
    C3: [
        918.43,
        1298.27
    ],
    C4: [
        649.13,
        918.43
    ],
    C5: [
        459.21,
        649.13
    ],
    C6: [
        323.15,
        459.21
    ],
    C7: [
        229.61,
        323.15
    ],
    C8: [
        161.57,
        229.61
    ],
    C9: [
        113.39,
        161.57
    ],
    C10: [
        79.37,
        113.39
    ],
    RA0: [
        2437.8,
        3458.27
    ],
    RA1: [
        1729.13,
        2437.8
    ],
    RA2: [
        1218.9,
        1729.13
    ],
    RA3: [
        864.57,
        1218.9
    ],
    RA4: [
        609.45,
        864.57
    ],
    SRA0: [
        2551.18,
        3628.35
    ],
    SRA1: [
        1814.17,
        2551.18
    ],
    SRA2: [
        1275.59,
        1814.17
    ],
    SRA3: [
        907.09,
        1275.59
    ],
    SRA4: [
        637.8,
        907.09
    ],
    Executive: [
        521.86,
        756.0
    ],
    Folio: [
        612.0,
        936.0
    ],
    Legal: [
        612.0,
        1008.0
    ],
    Letter: [
        612.0,
        792.0
    ],
    Tabloid: [
        792.0,
        1224.0
    ]
};



var $iMObG = parcelRequire("iMObG");
var $alPcq = parcelRequire("alPcq");
var $87d093f169600950$export$ba19d141a3749548;
(function(ParseSpeeds) {
    ParseSpeeds[ParseSpeeds["Fastest"] = Infinity] = "Fastest";
    ParseSpeeds[ParseSpeeds["Fast"] = 1500] = "Fast";
    ParseSpeeds[ParseSpeeds["Medium"] = 500] = "Medium";
    ParseSpeeds[ParseSpeeds["Slow"] = 100] = "Slow";
})($87d093f169600950$export$ba19d141a3749548 || ($87d093f169600950$export$ba19d141a3749548 = {}));


parcelRequire("5bpFt");
var $8EKPA = parcelRequire("8EKPA");
var $hGYOY = parcelRequire("hGYOY");
var $a9yd5 = parcelRequire("a9yd5");
var $cMViw = parcelRequire("cMViw");
var $lxE62 = parcelRequire("lxE62");


var $273XO = parcelRequire("273XO");

var $dj8f2 = parcelRequire("dj8f2");
var $alPcq = parcelRequire("alPcq");
/**
 * Represents a file that has been embedded in a [[PDFDocument]].
 */ var $1d05749ecd8d352e$var$PDFEmbeddedFile = /** @class */ function() {
    function PDFEmbeddedFile(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        this.ref = ref;
        this.doc = doc;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all embeddable files get embedded.
     *
     * Embed this embeddable file in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFEmbeddedFile.prototype.embed = function() {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var ref, Names, EmbeddedFiles, EFNames, AF;
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        ref = _a.sent();
                        if (!this.doc.catalog.has((0, $alPcq.default).of('Names'))) this.doc.catalog.set((0, $alPcq.default).of('Names'), this.doc.context.obj({}));
                        Names = this.doc.catalog.lookup((0, $alPcq.default).of('Names'), (0, $b7e75d63d5628aec$export$2e2bcd8739ae039));
                        if (!Names.has((0, $alPcq.default).of('EmbeddedFiles'))) Names.set((0, $alPcq.default).of('EmbeddedFiles'), this.doc.context.obj({}));
                        EmbeddedFiles = Names.lookup((0, $alPcq.default).of('EmbeddedFiles'), (0, $b7e75d63d5628aec$export$2e2bcd8739ae039));
                        if (!EmbeddedFiles.has((0, $alPcq.default).of('Names'))) EmbeddedFiles.set((0, $alPcq.default).of('Names'), this.doc.context.obj([]));
                        EFNames = EmbeddedFiles.lookup((0, $alPcq.default).of('Names'), (0, $dj8f2.default));
                        EFNames.push((0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(this.embedder.fileName));
                        EFNames.push(ref);
                        /**
                         * The AF-Tag is needed to achieve PDF-A3 compliance for embedded files
                         *
                         * The following document outlines the uses cases of the associated files (AF) tag.
                         * See:
                         * https://www.pdfa.org/wp-content/uploads/2018/10/PDF20_AN002-AF.pdf
                         */ if (!this.doc.catalog.has((0, $alPcq.default).of('AF'))) this.doc.catalog.set((0, $alPcq.default).of('AF'), this.doc.context.obj([]));
                        AF = this.doc.catalog.lookup((0, $alPcq.default).of('AF'), (0, $dj8f2.default));
                        AF.push(ref);
                        this.alreadyEmbedded = true;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.attach]] method, which will create
     * instances of [[PDFEmbeddedFile]] for you.
     *
     * Create an instance of [[PDFEmbeddedFile]] from an existing ref and embedder
     *
     * @param ref The unique reference for this file.
     * @param doc The document to which the file will belong.
     * @param embedder The embedder that will be used to embed the file.
     */ PDFEmbeddedFile.of = function(ref, doc, embedder) {
        return new PDFEmbeddedFile(ref, doc, embedder);
    };
    return PDFEmbeddedFile;
}();
var $1d05749ecd8d352e$export$2e2bcd8739ae039 = $1d05749ecd8d352e$var$PDFEmbeddedFile;



var $273XO = parcelRequire("273XO");

var $dj8f2 = parcelRequire("dj8f2");
var $alPcq = parcelRequire("alPcq");
/**
 * Represents JavaScript that has been embedded in a [[PDFDocument]].
 */ var $5547987f7f289156$var$PDFJavaScript = /** @class */ function() {
    function PDFJavaScript(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        this.ref = ref;
        this.doc = doc;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all JavaScripts get embedded.
     *
     * Embed this JavaScript in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFJavaScript.prototype.embed = function() {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var _a, catalog, context, ref, Names, Javascript, JSNames;
            return (0, $273XO.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = this.doc, catalog = _a.catalog, context = _a.context;
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        ref = _b.sent();
                        if (!catalog.has((0, $alPcq.default).of('Names'))) catalog.set((0, $alPcq.default).of('Names'), context.obj({}));
                        Names = catalog.lookup((0, $alPcq.default).of('Names'), (0, $b7e75d63d5628aec$export$2e2bcd8739ae039));
                        if (!Names.has((0, $alPcq.default).of('JavaScript'))) Names.set((0, $alPcq.default).of('JavaScript'), context.obj({}));
                        Javascript = Names.lookup((0, $alPcq.default).of('JavaScript'), (0, $b7e75d63d5628aec$export$2e2bcd8739ae039));
                        if (!Javascript.has((0, $alPcq.default).of('Names'))) Javascript.set((0, $alPcq.default).of('Names'), context.obj([]));
                        JSNames = Javascript.lookup((0, $alPcq.default).of('Names'), (0, $dj8f2.default));
                        JSNames.push((0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(this.embedder.scriptName));
                        JSNames.push(ref);
                        this.alreadyEmbedded = true;
                        _b.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addJavaScript]] method, which will
     * create instances of [[PDFJavaScript]] for you.
     *
     * Create an instance of [[PDFJavaScript]] from an existing ref and script
     *
     * @param ref The unique reference for this script.
     * @param doc The document to which the script will belong.
     * @param embedder The embedder that will be used to embed the script.
     */ PDFJavaScript.of = function(ref, doc, embedder) {
        return new PDFJavaScript(ref, doc, embedder);
    };
    return PDFJavaScript;
}();
var $5547987f7f289156$export$2e2bcd8739ae039 = $5547987f7f289156$var$PDFJavaScript;



var $273XO = parcelRequire("273XO");

var $3017c5c80940eb46$var$JavaScriptEmbedder = /** @class */ function() {
    function JavaScriptEmbedder(script, scriptName) {
        this.script = script;
        this.scriptName = scriptName;
    }
    JavaScriptEmbedder.for = function(script, scriptName) {
        return new JavaScriptEmbedder(script, scriptName);
    };
    JavaScriptEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var jsActionDict;
            return (0, $273XO.__generator)(this, function(_a) {
                jsActionDict = context.obj({
                    Type: 'Action',
                    S: 'JavaScript',
                    JS: (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(this.script)
                });
                if (ref) {
                    context.assign(ref, jsActionDict);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(jsActionDict)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return JavaScriptEmbedder;
}();
var $3017c5c80940eb46$export$2e2bcd8739ae039 = $3017c5c80940eb46$var$JavaScriptEmbedder;


/**
 * Represents a PDF document.
 */ var $6767bf97ac5b9b71$var$PDFDocument = /** @class */ function() {
    function PDFDocument(context, ignoreEncryption, updateMetadata) {
        var _this = this;
        /** The default word breaks used in PDFPage.drawText */ this.defaultWordBreaks = [
            ' '
        ];
        this.computePages = function() {
            var pages = [];
            _this.catalog.Pages().traverse(function(node, ref) {
                if (node instanceof (0, $27cec0c5ad235198$export$2e2bcd8739ae039)) {
                    var page = _this.pageMap.get(node);
                    if (!page) {
                        page = (0, $4488acf63d90f5a1$export$2e2bcd8739ae039).of(node, ref, _this);
                        _this.pageMap.set(node, page);
                    }
                    pages.push(page);
                }
            });
            return pages;
        };
        this.getOrCreateForm = function() {
            var acroForm = _this.catalog.getOrCreateAcroForm();
            return (0, $9f9197a15bd45437$export$2e2bcd8739ae039).of(acroForm, _this);
        };
        (0, $8EKPA.assertIs)(context, 'context', [
            [
                (0, $dcc6ee7d53aa6a90$export$2e2bcd8739ae039),
                'PDFContext'
            ]
        ]);
        (0, $8EKPA.assertIs)(ignoreEncryption, 'ignoreEncryption', [
            'boolean'
        ]);
        this.context = context;
        this.catalog = context.lookup(context.trailerInfo.Root);
        this.isEncrypted = !!context.lookup(context.trailerInfo.Encrypt);
        this.pageCache = (0, $hGYOY.default).populatedBy(this.computePages);
        this.pageMap = new Map();
        this.formCache = (0, $hGYOY.default).populatedBy(this.getOrCreateForm);
        this.fonts = [];
        this.images = [];
        this.embeddedPages = [];
        this.embeddedFiles = [];
        this.javaScripts = [];
        if (!ignoreEncryption && this.isEncrypted) throw new (0, $07ff41eb9264b36f$export$20fcceeca2b098d2)();
        if (updateMetadata) this.updateInfoDict();
    }
    /**
     * Load an existing [[PDFDocument]]. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                               |
     * | ------------- | ------------------------------------------------------ |
     * | `string`      | A base64 encoded string (or data URI) containing a PDF |
     * | `Uint8Array`  | The raw bytes of a PDF                                 |
     * | `ArrayBuffer` | The raw bytes of a PDF                                 |
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     *
     * // pdf=string
     * const base64 =
     *  'JVBERi0xLjcKJYGBgYEKCjUgMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbm' +
     *  'd0aCAxMDQKPj4Kc3RyZWFtCniccwrhMlAAwaJ0Ln2P1Jyy1JLM5ERdc0MjCwUjE4WQNC4Q' +
     *  '6cNlCFZkqGCqYGSqEJLLZWNuYGZiZmbkYuZsZmlmZGRgZmluDCQNzc3NTM2NzdzMXMxMjQ' +
     *  'ztFEKyuEK0uFxDuAAOERdVCmVuZHN0cmVhbQplbmRvYmoKCjYgMCBvYmoKPDwKL0ZpbHRl' +
     *  'ciAvRmxhdGVEZWNvZGUKL1R5cGUgL09ialN0bQovTiA0Ci9GaXJzdCAyMAovTGVuZ3RoID' +
     *  'IxNQo+PgpzdHJlYW0KeJxVj9GqwjAMhu/zFHkBzTo3nCCCiiKIHPEICuJF3cKoSCu2E8/b' +
     *  '20wPIr1p8v9/8kVhgilmGfawX2CGaVrgcAi0/bsy0lrX7IGWpvJ4iJYEN3gEmrrGBlQwGs' +
     *  'HHO9VBX1wNrxAqMX87RBD5xpJuddqwd82tjAHxzV1U5LPgy52DKXWnr1Lheg+j/c/pzGVr' +
     *  'iqV0VlwZPXGPCJjElw/ybkwUmeoWgxesDXGhHJC/D/iikp1Av80ptKU0FdBEe25pPihAM1' +
     *  'u6ytgaaWfs2Hrz35CJT1+EWmAKZW5kc3RyZWFtCmVuZG9iagoKNyAwIG9iago8PAovU2l6' +
     *  'ZSA4Ci9Sb290IDIgMCBSCi9GaWx0ZXIgL0ZsYXRlRGVjb2RlCi9UeXBlIC9YUmVmCi9MZW' +
     *  '5ndGggMzgKL1cgWyAxIDIgMiBdCi9JbmRleCBbIDAgOCBdCj4+CnN0cmVhbQp4nBXEwREA' +
     *  'EBAEsCwz3vrvRmOOyyOoGhZdutHN2MT55fIAVocD+AplbmRzdHJlYW0KZW5kb2JqCgpzdG' +
     *  'FydHhyZWYKNTEwCiUlRU9G'
     *
     * const dataUri = 'data:application/pdf;base64,' + base64
     *
     * const pdfDoc1 = await PDFDocument.load(base64)
     * const pdfDoc2 = await PDFDocument.load(dataUri)
     *
     * // pdf=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('with_update_sections.pdf')
     * const pdfDoc3 = await PDFDocument.load(uint8Array)
     *
     * // pdf=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/with_update_sections.pdf'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const pdfDoc4 = await PDFDocument.load(arrayBuffer)
     *
     * ```
     *
     * @param pdf The input data containing a PDF document.
     * @param options The options to be used when loading the document.
     * @returns Resolves with a document loaded from the input.
     */ PDFDocument.load = function(pdf, options) {
        if (options === void 0) options = {};
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var _a, ignoreEncryption, _b, parseSpeed, _c, throwOnInvalidObject, _d, updateMetadata, _e, capNumbers, bytes, context;
            return (0, $273XO.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        _a = options.ignoreEncryption, ignoreEncryption = _a === void 0 ? false : _a, _b = options.parseSpeed, parseSpeed = _b === void 0 ? (0, $87d093f169600950$export$ba19d141a3749548).Slow : _b, _c = options.throwOnInvalidObject, throwOnInvalidObject = _c === void 0 ? false : _c, _d = options.updateMetadata, updateMetadata = _d === void 0 ? true : _d, _e = options.capNumbers, capNumbers = _e === void 0 ? false : _e;
                        (0, $8EKPA.assertIs)(pdf, 'pdf', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        (0, $8EKPA.assertIs)(ignoreEncryption, 'ignoreEncryption', [
                            'boolean'
                        ]);
                        (0, $8EKPA.assertIs)(parseSpeed, 'parseSpeed', [
                            'number'
                        ]);
                        (0, $8EKPA.assertIs)(throwOnInvalidObject, 'throwOnInvalidObject', [
                            'boolean'
                        ]);
                        bytes = (0, $a9yd5.toUint8Array)(pdf);
                        return [
                            4 /*yield*/ ,
                            (0, $efca7de1544c77bc$export$2e2bcd8739ae039).forBytesWithOptions(bytes, parseSpeed, throwOnInvalidObject, capNumbers).parseDocument()
                        ];
                    case 1:
                        context = _f.sent();
                        return [
                            2 /*return*/ ,
                            new PDFDocument(context, ignoreEncryption, updateMetadata)
                        ];
                }
            });
        });
    };
    /**
     * Create a new [[PDFDocument]].
     * @returns Resolves with the newly created document.
     */ PDFDocument.create = function(options) {
        if (options === void 0) options = {};
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var _a, updateMetadata, context, pageTree, pageTreeRef, catalog;
            return (0, $273XO.__generator)(this, function(_b) {
                _a = options.updateMetadata, updateMetadata = _a === void 0 ? true : _a;
                context = (0, $dcc6ee7d53aa6a90$export$2e2bcd8739ae039).create();
                pageTree = (0, $1ea69a2ae6505d06$export$2e2bcd8739ae039).withContext(context);
                pageTreeRef = context.register(pageTree);
                catalog = (0, $144148f0529ee19d$export$2e2bcd8739ae039).withContextAndPages(context, pageTreeRef);
                context.trailerInfo.Root = context.register(catalog);
                return [
                    2 /*return*/ ,
                    new PDFDocument(context, false, updateMetadata)
                ];
            });
        });
    };
    /**
     * Register a fontkit instance. This must be done before custom fonts can
     * be embedded. See [here](https://github.com/Hopding/pdf-lib/tree/master#fontkit-installation)
     * for instructions on how to install and register a fontkit instance.
     *
     * > You do **not** need to call this method to embed standard fonts.
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     * import fontkit from '@pdf-lib/fontkit'
     *
     * const pdfDoc = await PDFDocument.create()
     * pdfDoc.registerFontkit(fontkit)
     * ```
     *
     * @param fontkit The fontkit instance to be registered.
     */ PDFDocument.prototype.registerFontkit = function(fontkit) {
        this.fontkit = fontkit;
    };
    /**
     * Get the [[PDFForm]] containing all interactive fields for this document.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const type = field.constructor.name
     *   const name = field.getName()
     *   console.log(`${type}: ${name}`)
     * })
     * ```
     * @returns The form for this document.
     */ PDFDocument.prototype.getForm = function() {
        var form = this.formCache.access();
        if (form.hasXFA()) {
            console.warn('Removing XFA form data as pdf-lib does not support reading or writing XFA');
            form.deleteXFA();
        }
        return form;
    };
    /**
     * Get this document's title metadata. The title appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const title = pdfDoc.getTitle()
     * ```
     * @returns A string containing the title of this document, if it has one.
     */ PDFDocument.prototype.getTitle = function() {
        var title = this.getInfoDict().lookup((0, $alPcq.default).Title);
        if (!title) return undefined;
        $6767bf97ac5b9b71$var$assertIsLiteralOrHexString(title);
        return title.decodeText();
    };
    /**
     * Get this document's author metadata. The author appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const author = pdfDoc.getAuthor()
     * ```
     * @returns A string containing the author of this document, if it has one.
     */ PDFDocument.prototype.getAuthor = function() {
        var author = this.getInfoDict().lookup((0, $alPcq.default).Author);
        if (!author) return undefined;
        $6767bf97ac5b9b71$var$assertIsLiteralOrHexString(author);
        return author.decodeText();
    };
    /**
     * Get this document's subject metadata. The subject appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const subject = pdfDoc.getSubject()
     * ```
     * @returns A string containing the subject of this document, if it has one.
     */ PDFDocument.prototype.getSubject = function() {
        var subject = this.getInfoDict().lookup((0, $alPcq.default).Subject);
        if (!subject) return undefined;
        $6767bf97ac5b9b71$var$assertIsLiteralOrHexString(subject);
        return subject.decodeText();
    };
    /**
     * Get this document's keywords metadata. The keywords appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const keywords = pdfDoc.getKeywords()
     * ```
     * @returns A string containing the keywords of this document, if it has any.
     */ PDFDocument.prototype.getKeywords = function() {
        var keywords = this.getInfoDict().lookup((0, $alPcq.default).Keywords);
        if (!keywords) return undefined;
        $6767bf97ac5b9b71$var$assertIsLiteralOrHexString(keywords);
        return keywords.decodeText();
    };
    /**
     * Get this document's creator metadata. The creator appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const creator = pdfDoc.getCreator()
     * ```
     * @returns A string containing the creator of this document, if it has one.
     */ PDFDocument.prototype.getCreator = function() {
        var creator = this.getInfoDict().lookup((0, $alPcq.default).Creator);
        if (!creator) return undefined;
        $6767bf97ac5b9b71$var$assertIsLiteralOrHexString(creator);
        return creator.decodeText();
    };
    /**
     * Get this document's producer metadata. The producer appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const producer = pdfDoc.getProducer()
     * ```
     * @returns A string containing the producer of this document, if it has one.
     */ PDFDocument.prototype.getProducer = function() {
        var producer = this.getInfoDict().lookup((0, $alPcq.default).Producer);
        if (!producer) return undefined;
        $6767bf97ac5b9b71$var$assertIsLiteralOrHexString(producer);
        return producer.decodeText();
    };
    /**
     * Get this document's creation date metadata. The creation date appears in
     * the "Document Properties" section of most PDF readers. For example:
     * ```js
     * const creationDate = pdfDoc.getCreationDate()
     * ```
     * @returns A Date containing the creation date of this document,
     *          if it has one.
     */ PDFDocument.prototype.getCreationDate = function() {
        var creationDate = this.getInfoDict().lookup((0, $alPcq.default).CreationDate);
        if (!creationDate) return undefined;
        $6767bf97ac5b9b71$var$assertIsLiteralOrHexString(creationDate);
        return creationDate.decodeDate();
    };
    /**
     * Get this document's modification date metadata. The modification date
     * appears in the "Document Properties" section of most PDF readers.
     * For example:
     * ```js
     * const modification = pdfDoc.getModificationDate()
     * ```
     * @returns A Date containing the modification date of this document,
     *          if it has one.
     */ PDFDocument.prototype.getModificationDate = function() {
        var modificationDate = this.getInfoDict().lookup((0, $alPcq.default).ModDate);
        if (!modificationDate) return undefined;
        $6767bf97ac5b9b71$var$assertIsLiteralOrHexString(modificationDate);
        return modificationDate.decodeDate();
    };
    /**
     * Set this document's title metadata. The title will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setTitle('🥚 The Life of an Egg 🍳')
     * ```
     *
     * To display the title in the window's title bar, set the
     * `showInWindowTitleBar` option to `true` (works for _most_ PDF readers).
     * For example:
     * ```js
     * pdfDoc.setTitle('🥚 The Life of an Egg 🍳', { showInWindowTitleBar: true })
     * ```
     *
     * @param title The title of this document.
     * @param options The options to be used when setting the title.
     */ PDFDocument.prototype.setTitle = function(title, options) {
        (0, $8EKPA.assertIs)(title, 'title', [
            'string'
        ]);
        var key = (0, $alPcq.default).of('Title');
        this.getInfoDict().set(key, (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(title));
        // Indicate that readers should display the title rather than the filename
        if (options === null || options === void 0 ? void 0 : options.showInWindowTitleBar) {
            var prefs = this.catalog.getOrCreateViewerPreferences();
            prefs.setDisplayDocTitle(true);
        }
    };
    /**
     * Set this document's author metadata. The author will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setAuthor('Humpty Dumpty')
     * ```
     * @param author The author of this document.
     */ PDFDocument.prototype.setAuthor = function(author) {
        (0, $8EKPA.assertIs)(author, 'author', [
            'string'
        ]);
        var key = (0, $alPcq.default).of('Author');
        this.getInfoDict().set(key, (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(author));
    };
    /**
     * Set this document's subject metadata. The subject will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setSubject('📘 An Epic Tale of Woe 📖')
     * ```
     * @param subject The subject of this document.
     */ PDFDocument.prototype.setSubject = function(subject) {
        (0, $8EKPA.assertIs)(subject, 'author', [
            'string'
        ]);
        var key = (0, $alPcq.default).of('Subject');
        this.getInfoDict().set(key, (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(subject));
    };
    /**
     * Set this document's keyword metadata. These keywords will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setKeywords(['eggs', 'wall', 'fall', 'king', 'horses', 'men'])
     * ```
     * @param keywords An array of keywords associated with this document.
     */ PDFDocument.prototype.setKeywords = function(keywords) {
        (0, $8EKPA.assertIs)(keywords, 'keywords', [
            Array
        ]);
        var key = (0, $alPcq.default).of('Keywords');
        this.getInfoDict().set(key, (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(keywords.join(' ')));
    };
    /**
     * Set this document's creator metadata. The creator will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setCreator('PDF App 9000 🤖')
     * ```
     * @param creator The creator of this document.
     */ PDFDocument.prototype.setCreator = function(creator) {
        (0, $8EKPA.assertIs)(creator, 'creator', [
            'string'
        ]);
        var key = (0, $alPcq.default).of('Creator');
        this.getInfoDict().set(key, (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(creator));
    };
    /**
     * Set this document's producer metadata. The producer will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setProducer('PDF App 9000 🤖')
     * ```
     * @param producer The producer of this document.
     */ PDFDocument.prototype.setProducer = function(producer) {
        (0, $8EKPA.assertIs)(producer, 'creator', [
            'string'
        ]);
        var key = (0, $alPcq.default).of('Producer');
        this.getInfoDict().set(key, (0, $d8f6d7884257882d$export$2e2bcd8739ae039).fromText(producer));
    };
    /**
     * Set this document's language metadata. The language will appear in the
     * "Document Properties" section of some PDF readers. For example:
     * ```js
     * pdfDoc.setLanguage('en-us')
     * ```
     *
     * @param language An RFC 3066 _Language-Tag_ denoting the language of this
     *                 document, or an empty string if the language is unknown.
     */ PDFDocument.prototype.setLanguage = function(language) {
        (0, $8EKPA.assertIs)(language, 'language', [
            'string'
        ]);
        var key = (0, $alPcq.default).of('Lang');
        this.catalog.set(key, (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039).of(language));
    };
    /**
     * Set this document's creation date metadata. The creation date will appear
     * in the "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setCreationDate(new Date())
     * ```
     * @param creationDate The date this document was created.
     */ PDFDocument.prototype.setCreationDate = function(creationDate) {
        (0, $8EKPA.assertIs)(creationDate, 'creationDate', [
            [
                Date,
                'Date'
            ]
        ]);
        var key = (0, $alPcq.default).of('CreationDate');
        this.getInfoDict().set(key, (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039).fromDate(creationDate));
    };
    /**
     * Set this document's modification date metadata. The modification date will
     * appear in the "Document Properties" section of most PDF readers. For
     * example:
     * ```js
     * pdfDoc.setModificationDate(new Date())
     * ```
     * @param modificationDate The date this document was last modified.
     */ PDFDocument.prototype.setModificationDate = function(modificationDate) {
        (0, $8EKPA.assertIs)(modificationDate, 'modificationDate', [
            [
                Date,
                'Date'
            ]
        ]);
        var key = (0, $alPcq.default).of('ModDate');
        this.getInfoDict().set(key, (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039).fromDate(modificationDate));
    };
    /**
     * Get the number of pages contained in this document. For example:
     * ```js
     * const totalPages = pdfDoc.getPageCount()
     * ```
     * @returns The number of pages in this document.
     */ PDFDocument.prototype.getPageCount = function() {
        if (this.pageCount === undefined) this.pageCount = this.getPages().length;
        return this.pageCount;
    };
    /**
     * Get an array of all the pages contained in this document. The pages are
     * stored in the array in the same order that they are rendered in the
     * document. For example:
     * ```js
     * const pages = pdfDoc.getPages()
     * pages[0]   // The first page of the document
     * pages[2]   // The third page of the document
     * pages[197] // The 198th page of the document
     * ```
     * @returns An array of all the pages contained in this document.
     */ PDFDocument.prototype.getPages = function() {
        return this.pageCache.access();
    };
    /**
     * Get the page rendered at a particular `index` of the document. For example:
     * ```js
     * pdfDoc.getPage(0)   // The first page of the document
     * pdfDoc.getPage(2)   // The third page of the document
     * pdfDoc.getPage(197) // The 198th page of the document
     * ```
     * @returns The [[PDFPage]] rendered at the given `index` of the document.
     */ PDFDocument.prototype.getPage = function(index) {
        var pages = this.getPages();
        (0, $8EKPA.assertRange)(index, 'index', 0, pages.length - 1);
        return pages[index];
    };
    /**
     * Get an array of indices for all the pages contained in this document. The
     * array will contain a range of integers from
     * `0..pdfDoc.getPageCount() - 1`. For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     * pdfDoc.addPage()
     * pdfDoc.addPage()
     * pdfDoc.addPage()
     *
     * const indices = pdfDoc.getPageIndices()
     * indices // => [0, 1, 2]
     * ```
     * @returns An array of indices for all pages contained in this document.
     */ PDFDocument.prototype.getPageIndices = function() {
        return (0, $a9yd5.range)(0, this.getPageCount());
    };
    /**
     * Remove the page at a given index from this document. For example:
     * ```js
     * pdfDoc.removePage(0)   // Remove the first page of the document
     * pdfDoc.removePage(2)   // Remove the third page of the document
     * pdfDoc.removePage(197) // Remove the 198th page of the document
     * ```
     * Once a page has been removed, it will no longer be rendered at that index
     * in the document.
     * @param index The index of the page to be removed.
     */ PDFDocument.prototype.removePage = function(index) {
        var pageCount = this.getPageCount();
        if (this.pageCount === 0) throw new (0, $07ff41eb9264b36f$export$cdca06c5927ddc2d)();
        (0, $8EKPA.assertRange)(index, 'index', 0, pageCount - 1);
        this.catalog.removeLeafNode(index);
        this.pageCount = pageCount - 1;
    };
    /**
     * Add a page to the end of this document. This method accepts three
     * different value types for the `page` parameter:
     *
     * | Type               | Behavior                                                                            |
     * | ------------------ | ----------------------------------------------------------------------------------- |
     * | `undefined`        | Create a new page and add it to the end of this document                            |
     * | `[number, number]` | Create a new page with the given dimensions and add it to the end of this document  |
     * | `PDFPage`          | Add the existing page to the end of this document                                   |
     *
     * For example:
     * ```js
     * // page=undefined
     * const newPage = pdfDoc.addPage()
     *
     * // page=[number, number]
     * import { PageSizes } from 'pdf-lib'
     * const newPage1 = pdfDoc.addPage(PageSizes.A7)
     * const newPage2 = pdfDoc.addPage(PageSizes.Letter)
     * const newPage3 = pdfDoc.addPage([500, 750])
     *
     * // page=PDFPage
     * const pdfDoc1 = await PDFDocument.create()
     * const pdfDoc2 = await PDFDocument.load(...)
     * const [existingPage] = await pdfDoc1.copyPages(pdfDoc2, [0])
     * pdfDoc1.addPage(existingPage)
     * ```
     *
     * @param page Optionally, the desired dimensions or existing page.
     * @returns The newly created (or existing) page.
     */ PDFDocument.prototype.addPage = function(page) {
        (0, $8EKPA.assertIs)(page, 'page', [
            'undefined',
            [
                (0, $4488acf63d90f5a1$export$2e2bcd8739ae039),
                'PDFPage'
            ],
            Array
        ]);
        return this.insertPage(this.getPageCount(), page);
    };
    /**
     * Insert a page at a given index within this document. This method accepts
     * three different value types for the `page` parameter:
     *
     * | Type               | Behavior                                                                       |
     * | ------------------ | ------------------------------------------------------------------------------ |
     * | `undefined`        | Create a new page and insert it into this document                             |
     * | `[number, number]` | Create a new page with the given dimensions and insert it into this document   |
     * | `PDFPage`          | Insert the existing page into this document                                    |
     *
     * For example:
     * ```js
     * // page=undefined
     * const newPage = pdfDoc.insertPage(2)
     *
     * // page=[number, number]
     * import { PageSizes } from 'pdf-lib'
     * const newPage1 = pdfDoc.insertPage(2, PageSizes.A7)
     * const newPage2 = pdfDoc.insertPage(0, PageSizes.Letter)
     * const newPage3 = pdfDoc.insertPage(198, [500, 750])
     *
     * // page=PDFPage
     * const pdfDoc1 = await PDFDocument.create()
     * const pdfDoc2 = await PDFDocument.load(...)
     * const [existingPage] = await pdfDoc1.copyPages(pdfDoc2, [0])
     * pdfDoc1.insertPage(0, existingPage)
     * ```
     *
     * @param index The index at which the page should be inserted (zero-based).
     * @param page Optionally, the desired dimensions or existing page.
     * @returns The newly created (or existing) page.
     */ PDFDocument.prototype.insertPage = function(index, page) {
        var pageCount = this.getPageCount();
        (0, $8EKPA.assertRange)(index, 'index', 0, pageCount);
        (0, $8EKPA.assertIs)(page, 'page', [
            'undefined',
            [
                (0, $4488acf63d90f5a1$export$2e2bcd8739ae039),
                'PDFPage'
            ],
            Array
        ]);
        if (!page || Array.isArray(page)) {
            var dims = Array.isArray(page) ? page : (0, $e9e9f0f7557d61f7$export$b4a05ae367f5515c).A4;
            page = (0, $4488acf63d90f5a1$export$2e2bcd8739ae039).create(this);
            page.setSize.apply(page, dims);
        } else if (page.doc !== this) throw new (0, $07ff41eb9264b36f$export$9564a4d28d94eae2)();
        var parentRef = this.catalog.insertLeafNode(page.ref, index);
        page.node.setParent(parentRef);
        this.pageMap.set(page.node, page);
        this.pageCache.invalidate();
        this.pageCount = pageCount + 1;
        return page;
    };
    /**
     * Copy pages from a source document into this document. Allows pages to be
     * copied between different [[PDFDocument]] instances. For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     * const srcDoc = await PDFDocument.load(...)
     *
     * const copiedPages = await pdfDoc.copyPages(srcDoc, [0, 3, 89])
     * const [firstPage, fourthPage, ninetiethPage] = copiedPages;
     *
     * pdfDoc.addPage(fourthPage)
     * pdfDoc.insertPage(0, ninetiethPage)
     * pdfDoc.addPage(firstPage)
     * ```
     * @param srcDoc The document from which pages should be copied.
     * @param indices The indices of the pages that should be copied.
     * @returns Resolves with an array of pages copied into this document.
     */ PDFDocument.prototype.copyPages = function(srcDoc, indices) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var copier, srcPages, copiedPages, idx, len, srcPage, copiedPage, ref;
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $8EKPA.assertIs)(srcDoc, 'srcDoc', [
                            [
                                PDFDocument,
                                'PDFDocument'
                            ]
                        ]);
                        (0, $8EKPA.assertIs)(indices, 'indices', [
                            Array
                        ]);
                        return [
                            4 /*yield*/ ,
                            srcDoc.flush()
                        ];
                    case 1:
                        _a.sent();
                        copier = (0, $9bb257b1a2af93c3$export$2e2bcd8739ae039).for(srcDoc.context, this.context);
                        srcPages = srcDoc.getPages();
                        copiedPages = new Array(indices.length);
                        for(idx = 0, len = indices.length; idx < len; idx++){
                            srcPage = srcPages[indices[idx]];
                            copiedPage = copier.copy(srcPage.node);
                            ref = this.context.register(copiedPage);
                            copiedPages[idx] = (0, $4488acf63d90f5a1$export$2e2bcd8739ae039).of(copiedPage, ref, this);
                        }
                        return [
                            2 /*return*/ ,
                            copiedPages
                        ];
                }
            });
        });
    };
    /**
     * Get a copy of this document.
     *
     * For example:
     * ```js
     * const srcDoc = await PDFDocument.load(...)
     * const pdfDoc = await srcDoc.copy()
     * ```
     *
     * > **NOTE:**  This method won't copy all information over to the new
     * > document (acroforms, outlines, etc...).
     *
     * @returns Resolves with a copy this document.
     */ PDFDocument.prototype.copy = function() {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var pdfCopy, contentPages, idx, len;
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            PDFDocument.create()
                        ];
                    case 1:
                        pdfCopy = _a.sent();
                        return [
                            4 /*yield*/ ,
                            pdfCopy.copyPages(this, this.getPageIndices())
                        ];
                    case 2:
                        contentPages = _a.sent();
                        for(idx = 0, len = contentPages.length; idx < len; idx++)pdfCopy.addPage(contentPages[idx]);
                        if (this.getAuthor() !== undefined) pdfCopy.setAuthor(this.getAuthor());
                        if (this.getCreationDate() !== undefined) pdfCopy.setCreationDate(this.getCreationDate());
                        if (this.getCreator() !== undefined) pdfCopy.setCreator(this.getCreator());
                        if (this.getModificationDate() !== undefined) pdfCopy.setModificationDate(this.getModificationDate());
                        if (this.getProducer() !== undefined) pdfCopy.setProducer(this.getProducer());
                        if (this.getSubject() !== undefined) pdfCopy.setSubject(this.getSubject());
                        if (this.getTitle() !== undefined) pdfCopy.setTitle(this.getTitle());
                        pdfCopy.defaultWordBreaks = this.defaultWordBreaks;
                        return [
                            2 /*return*/ ,
                            pdfCopy
                        ];
                }
            });
        });
    };
    /**
     * Add JavaScript to this document. The supplied `script` is executed when the
     * document is opened. The `script` can be used to perform some operation
     * when the document is opened (e.g. logging to the console), or it can be
     * used to define a function that can be referenced later in a JavaScript
     * action. For example:
     * ```js
     * // Show "Hello World!" in the console when the PDF is opened
     * pdfDoc.addJavaScript(
     *   'main',
     *   'console.show(); console.println("Hello World!");'
     * );
     *
     * // Define a function named "foo" that can be called in JavaScript Actions
     * pdfDoc.addJavaScript(
     *   'foo',
     *   'function foo() { return "foo"; }'
     * );
     * ```
     * See the [JavaScript for Acrobat API Reference](https://www.adobe.com/content/dam/acom/en/devnet/acrobat/pdfs/js_api_reference.pdf)
     * for details.
     * @param name The name of the script. Must be unique per document.
     * @param script The JavaScript to execute.
     */ PDFDocument.prototype.addJavaScript = function(name, script) {
        (0, $8EKPA.assertIs)(name, 'name', [
            'string'
        ]);
        (0, $8EKPA.assertIs)(script, 'script', [
            'string'
        ]);
        var embedder = (0, $3017c5c80940eb46$export$2e2bcd8739ae039).for(script, name);
        var ref = this.context.nextRef();
        var javaScript = (0, $5547987f7f289156$export$2e2bcd8739ae039).of(ref, this, embedder);
        this.javaScripts.push(javaScript);
    };
    /**
     * Add an attachment to this document. Attachments are visible in the
     * "Attachments" panel of Adobe Acrobat and some other PDF readers. Any
     * type of file can be added as an attachment. This includes, but is not
     * limited to, `.png`, `.jpg`, `.pdf`, `.csv`, `.docx`, and `.xlsx` files.
     *
     * The input data can be provided in multiple formats:
     *
     * | Type          | Contents                                                       |
     * | ------------- | -------------------------------------------------------------- |
     * | `string`      | A base64 encoded string (or data URI) containing an attachment |
     * | `Uint8Array`  | The raw bytes of an attachment                                 |
     * | `ArrayBuffer` | The raw bytes of an attachment                                 |
     *
     * For example:
     * ```js
     * // attachment=string
     * await pdfDoc.attach('/9j/4AAQSkZJRgABAQAAAQABAAD/2wBD...', 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     * await pdfDoc.attach('data:image/jpeg;base64,/9j/4AAQ...', 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     *
     * // attachment=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('cat_riding_unicorn.jpg')
     * await pdfDoc.attach(uint8Array, 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     *
     * // attachment=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * await pdfDoc.attach(arrayBuffer, 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     * ```
     *
     * @param attachment The input data containing the file to be attached.
     * @param name The name of the file to be attached.
     * @returns Resolves when the attachment is complete.
     */ PDFDocument.prototype.attach = function(attachment, name, options) {
        if (options === void 0) options = {};
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, embeddedFile;
            return (0, $273XO.__generator)(this, function(_a) {
                (0, $8EKPA.assertIs)(attachment, 'attachment', [
                    'string',
                    Uint8Array,
                    ArrayBuffer
                ]);
                (0, $8EKPA.assertIs)(name, 'name', [
                    'string'
                ]);
                (0, $8EKPA.assertOrUndefined)(options.mimeType, 'mimeType', [
                    'string'
                ]);
                (0, $8EKPA.assertOrUndefined)(options.description, 'description', [
                    'string'
                ]);
                (0, $8EKPA.assertOrUndefined)(options.creationDate, 'options.creationDate', [
                    Date
                ]);
                (0, $8EKPA.assertOrUndefined)(options.modificationDate, 'options.modificationDate', [
                    Date
                ]);
                (0, $8EKPA.assertIsOneOfOrUndefined)(options.afRelationship, 'options.afRelationship', (0, $9ffabe114cecc8c9$export$c12eac46fbec1b74));
                bytes = (0, $a9yd5.toUint8Array)(attachment);
                embedder = (0, $9ffabe114cecc8c9$export$2e2bcd8739ae039).for(bytes, name, options);
                ref = this.context.nextRef();
                embeddedFile = (0, $1d05749ecd8d352e$export$2e2bcd8739ae039).of(ref, this, embedder);
                this.embeddedFiles.push(embeddedFile);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Embed a font into this document. The input data can be provided in multiple
     * formats:
     *
     * | Type            | Contents                                                |
     * | --------------- | ------------------------------------------------------- |
     * | `StandardFonts` | One of the standard 14 fonts                            |
     * | `string`        | A base64 encoded string (or data URI) containing a font |
     * | `Uint8Array`    | The raw bytes of a font                                 |
     * | `ArrayBuffer`   | The raw bytes of a font                                 |
     *
     * For example:
     * ```js
     * // font=StandardFonts
     * import { StandardFonts } from 'pdf-lib'
     * const font1 = await pdfDoc.embedFont(StandardFonts.Helvetica)
     *
     * // font=string
     * const font2 = await pdfDoc.embedFont('AAEAAAAVAQAABABQRFNJRx/upe...')
     * const font3 = await pdfDoc.embedFont('data:font/opentype;base64,AAEAAA...')
     *
     * // font=Uint8Array
     * import fs from 'fs'
     * const font4 = await pdfDoc.embedFont(fs.readFileSync('Ubuntu-R.ttf'))
     *
     * // font=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/ubuntu/Ubuntu-R.ttf'
     * const ubuntuBytes = await fetch(url).then(res => res.arrayBuffer())
     * const font5 = await pdfDoc.embedFont(ubuntuBytes)
     * ```
     * See also: [[registerFontkit]]
     * @param font The input data for a font.
     * @param options The options to be used when embedding the font.
     * @returns Resolves with the embedded font.
     */ PDFDocument.prototype.embedFont = function(font, options) {
        if (options === void 0) options = {};
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var _a, subset, customName, features, embedder, bytes, fontkit, _b, ref, pdfFont;
            return (0, $273XO.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = options.subset, subset = _a === void 0 ? false : _a, customName = options.customName, features = options.features;
                        (0, $8EKPA.assertIs)(font, 'font', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        (0, $8EKPA.assertIs)(subset, 'subset', [
                            'boolean'
                        ]);
                        if (!(0, $lxE62.isStandardFont)(font)) return [
                            3 /*break*/ ,
                            1
                        ];
                        embedder = (0, $42d3777696dc5a8a$export$2e2bcd8739ae039).for(font, customName);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 1:
                        if (!(0, $a9yd5.canBeConvertedToUint8Array)(font)) return [
                            3 /*break*/ ,
                            6
                        ];
                        bytes = (0, $a9yd5.toUint8Array)(font);
                        fontkit = this.assertFontkit();
                        if (!subset) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $555fcf888deaa236$export$2e2bcd8739ae039).for(fontkit, bytes, customName, features)
                        ];
                    case 2:
                        _b = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            (0, $fb5d08cced3a1a67$export$2e2bcd8739ae039).for(fontkit, bytes, customName, features)
                        ];
                    case 4:
                        _b = _c.sent();
                        _c.label = 5;
                    case 5:
                        embedder = _b;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        throw new TypeError('`font` must be one of `StandardFonts | string | Uint8Array | ArrayBuffer`');
                    case 7:
                        ref = this.context.nextRef();
                        pdfFont = (0, $2afe68c947457de4$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.fonts.push(pdfFont);
                        return [
                            2 /*return*/ ,
                            pdfFont
                        ];
                }
            });
        });
    };
    /**
     * Embed a standard font into this document.
     * For example:
     * ```js
     * import { StandardFonts } from 'pdf-lib'
     * const helveticaFont = pdfDoc.embedFont(StandardFonts.Helvetica)
     * ```
     * @param font The standard font to be embedded.
     * @param customName The name to be used when embedding the font.
     * @returns The embedded font.
     */ PDFDocument.prototype.embedStandardFont = function(font, customName) {
        (0, $8EKPA.assertIs)(font, 'font', [
            'string'
        ]);
        if (!(0, $lxE62.isStandardFont)(font)) throw new TypeError('`font` must be one of type `StandardFonts`');
        var embedder = (0, $42d3777696dc5a8a$export$2e2bcd8739ae039).for(font, customName);
        var ref = this.context.nextRef();
        var pdfFont = (0, $2afe68c947457de4$export$2e2bcd8739ae039).of(ref, this, embedder);
        this.fonts.push(pdfFont);
        return pdfFont;
    };
    /**
     * Embed a JPEG image into this document. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                                      |
     * | ------------- | ------------------------------------------------------------- |
     * | `string`      | A base64 encoded string (or data URI) containing a JPEG image |
     * | `Uint8Array`  | The raw bytes of a JPEG image                                 |
     * | `ArrayBuffer` | The raw bytes of a JPEG image                                 |
     *
     * For example:
     * ```js
     * // jpg=string
     * const image1 = await pdfDoc.embedJpg('/9j/4AAQSkZJRgABAQAAAQABAAD/2wBD...')
     * const image2 = await pdfDoc.embedJpg('data:image/jpeg;base64,/9j/4AAQ...')
     *
     * // jpg=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('cat_riding_unicorn.jpg')
     * const image3 = await pdfDoc.embedJpg(uint8Array)
     *
     * // jpg=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const image4 = await pdfDoc.embedJpg(arrayBuffer)
     * ```
     *
     * @param jpg The input data for a JPEG image.
     * @returns Resolves with the embedded image.
     */ PDFDocument.prototype.embedJpg = function(jpg) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, pdfImage;
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $8EKPA.assertIs)(jpg, 'jpg', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        bytes = (0, $a9yd5.toUint8Array)(jpg);
                        return [
                            4 /*yield*/ ,
                            (0, $979a3eda8f6e7f4c$export$2e2bcd8739ae039).for(bytes)
                        ];
                    case 1:
                        embedder = _a.sent();
                        ref = this.context.nextRef();
                        pdfImage = (0, $c6adec950ad59431$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.images.push(pdfImage);
                        return [
                            2 /*return*/ ,
                            pdfImage
                        ];
                }
            });
        });
    };
    /**
     * Embed a PNG image into this document. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                                     |
     * | ------------- | ------------------------------------------------------------ |
     * | `string`      | A base64 encoded string (or data URI) containing a PNG image |
     * | `Uint8Array`  | The raw bytes of a PNG image                                 |
     * | `ArrayBuffer` | The raw bytes of a PNG image                                 |
     *
     * For example:
     * ```js
     * // png=string
     * const image1 = await pdfDoc.embedPng('iVBORw0KGgoAAAANSUhEUgAAAlgAAAF3...')
     * const image2 = await pdfDoc.embedPng('data:image/png;base64,iVBORw0KGg...')
     *
     * // png=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('small_mario.png')
     * const image3 = await pdfDoc.embedPng(uint8Array)
     *
     * // png=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/small_mario.png'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const image4 = await pdfDoc.embedPng(arrayBuffer)
     * ```
     *
     * @param png The input data for a PNG image.
     * @returns Resolves with the embedded image.
     */ PDFDocument.prototype.embedPng = function(png) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, pdfImage;
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $8EKPA.assertIs)(png, 'png', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        bytes = (0, $a9yd5.toUint8Array)(png);
                        return [
                            4 /*yield*/ ,
                            (0, $9ba8d611194332cc$export$2e2bcd8739ae039).for(bytes)
                        ];
                    case 1:
                        embedder = _a.sent();
                        ref = this.context.nextRef();
                        pdfImage = (0, $c6adec950ad59431$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.images.push(pdfImage);
                        return [
                            2 /*return*/ ,
                            pdfImage
                        ];
                }
            });
        });
    };
    /**
     * Embed one or more PDF pages into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourcePdf = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     *
     * // Embed page 74 of `sourcePdf` into `pdfDoc`
     * const [embeddedPage] = await pdfDoc.embedPdf(sourcePdf, [73])
     * ```
     *
     * See [[PDFDocument.load]] for examples of the allowed input data formats.
     *
     * @param pdf The input data containing a PDF document.
     * @param indices The indices of the pages that should be embedded.
     * @returns Resolves with an array of the embedded pages.
     */ PDFDocument.prototype.embedPdf = function(pdf, indices) {
        if (indices === void 0) indices = [
            0
        ];
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var srcDoc, _a, srcPages;
            return (0, $273XO.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (0, $8EKPA.assertIs)(pdf, 'pdf', [
                            'string',
                            Uint8Array,
                            ArrayBuffer,
                            [
                                PDFDocument,
                                'PDFDocument'
                            ]
                        ]);
                        (0, $8EKPA.assertIs)(indices, 'indices', [
                            Array
                        ]);
                        if (!(pdf instanceof PDFDocument)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = pdf;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            PDFDocument.load(pdf)
                        ];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        srcDoc = _a;
                        srcPages = (0, $a9yd5.pluckIndices)(srcDoc.getPages(), indices);
                        return [
                            2 /*return*/ ,
                            this.embedPages(srcPages)
                        ];
                }
            });
        });
    };
    /**
     * Embed a single PDF page into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourceBuffer = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     * const sourcePdfDoc = await PDFDocument.load(sourceBuffer)
     * const sourcePdfPage = sourcePdfDoc.getPages()[73]
     *
     * const embeddedPage = await pdfDoc.embedPage(
     *   sourcePdfPage,
     *
     *   // Clip a section of the source page so that we only embed part of it
     *   { left: 100, right: 450, bottom: 330, top: 570 },
     *
     *   // Translate all drawings of the embedded page by (10, 200) units
     *   [1, 0, 0, 1, 10, 200],
     * )
     * ```
     *
     * @param page The page to be embedded.
     * @param boundingBox
     * Optionally, an area of the source page that should be embedded
     * (defaults to entire page).
     * @param transformationMatrix
     * Optionally, a transformation matrix that is always applied to the embedded
     * page anywhere it is drawn.
     * @returns Resolves with the embedded pdf page.
     */ PDFDocument.prototype.embedPage = function(page, boundingBox, transformationMatrix) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var embeddedPage;
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $8EKPA.assertIs)(page, 'page', [
                            [
                                (0, $4488acf63d90f5a1$export$2e2bcd8739ae039),
                                'PDFPage'
                            ]
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.embedPages([
                                page
                            ], [
                                boundingBox
                            ], [
                                transformationMatrix
                            ])
                        ];
                    case 1:
                        embeddedPage = _a.sent()[0];
                        return [
                            2 /*return*/ ,
                            embeddedPage
                        ];
                }
            });
        });
    };
    /**
     * Embed one or more PDF pages into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourceBuffer = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     * const sourcePdfDoc = await PDFDocument.load(sourceBuffer)
     *
     * const page1 = sourcePdfDoc.getPages()[0]
     * const page2 = sourcePdfDoc.getPages()[52]
     * const page3 = sourcePdfDoc.getPages()[73]
     *
     * const embeddedPages = await pdfDoc.embedPages([page1, page2, page3])
     * ```
     *
     * @param page
     * The pages to be embedded (they must all share the same context).
     * @param boundingBoxes
     * Optionally, an array of clipping boundaries - one for each page
     * (defaults to entirety of each page).
     * @param transformationMatrices
     * Optionally, an array of transformation matrices - one for each page
     * (each page's transformation will apply anywhere it is drawn).
     * @returns Resolves with an array of the embedded pdf pages.
     */ PDFDocument.prototype.embedPages = function(pages, boundingBoxes, transformationMatrices) {
        if (boundingBoxes === void 0) boundingBoxes = [];
        if (transformationMatrices === void 0) transformationMatrices = [];
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var idx, len, currPage, nextPage, context, maybeCopyPage, embeddedPages, idx, len, page, box, matrix, embedder, ref;
            var _a;
            return (0, $273XO.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (pages.length === 0) return [
                            2 /*return*/ ,
                            []
                        ];
                        // Assert all pages have the same context
                        for(idx = 0, len = pages.length - 1; idx < len; idx++){
                            currPage = pages[idx];
                            nextPage = pages[idx + 1];
                            if (currPage.node.context !== nextPage.node.context) throw new (0, $iMObG.PageEmbeddingMismatchedContextError)();
                        }
                        context = pages[0].node.context;
                        maybeCopyPage = context === this.context ? function(p) {
                            return p;
                        } : (0, $9bb257b1a2af93c3$export$2e2bcd8739ae039).for(context, this.context).copy;
                        embeddedPages = new Array(pages.length);
                        idx = 0, len = pages.length;
                        _b.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        page = maybeCopyPage(pages[idx].node);
                        box = boundingBoxes[idx];
                        matrix = transformationMatrices[idx];
                        return [
                            4 /*yield*/ ,
                            (0, $fe3ada739436b861$export$2e2bcd8739ae039).for(page, box, matrix)
                        ];
                    case 2:
                        embedder = _b.sent();
                        ref = this.context.nextRef();
                        embeddedPages[idx] = (0, $b964e8b946931c49$export$2e2bcd8739ae039).of(ref, this, embedder);
                        _b.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        (_a = this.embeddedPages).push.apply(_a, embeddedPages);
                        return [
                            2 /*return*/ ,
                            embeddedPages
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You shouldn't need to call this method directly. The [[save]]
     * > and [[saveAsBase64]] methods will automatically ensure that all embedded
     * > assets are flushed before serializing the document.
     *
     * Flush all embedded fonts, PDF pages, and images to this document's
     * [[context]].
     *
     * @returns Resolves when the flush is complete.
     */ PDFDocument.prototype.flush = function() {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.fonts)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.images)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.embeddedPages)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.embeddedFiles)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.javaScripts)
                        ];
                    case 5:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Serialize this document to an array of bytes making up a PDF file.
     * For example:
     * ```js
     * const pdfBytes = await pdfDoc.save()
     * ```
     *
     * There are a number of things you can do with the serialized document,
     * depending on the JavaScript environment you're running in:
     * * Write it to a file in Node or React Native
     * * Download it as a Blob in the browser
     * * Render it in an `iframe`
     *
     * @param options The options to be used when saving the document.
     * @returns Resolves with the bytes of the serialized document.
     */ PDFDocument.prototype.save = function(options) {
        if (options === void 0) options = {};
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var _a, useObjectStreams, _b, addDefaultPage, _c, objectsPerTick, _d, updateFieldAppearances, form, Writer;
            return (0, $273XO.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.useObjectStreams, useObjectStreams = _a === void 0 ? true : _a, _b = options.addDefaultPage, addDefaultPage = _b === void 0 ? true : _b, _c = options.objectsPerTick, objectsPerTick = _c === void 0 ? 50 : _c, _d = options.updateFieldAppearances, updateFieldAppearances = _d === void 0 ? true : _d;
                        (0, $8EKPA.assertIs)(useObjectStreams, 'useObjectStreams', [
                            'boolean'
                        ]);
                        (0, $8EKPA.assertIs)(addDefaultPage, 'addDefaultPage', [
                            'boolean'
                        ]);
                        (0, $8EKPA.assertIs)(objectsPerTick, 'objectsPerTick', [
                            'number'
                        ]);
                        (0, $8EKPA.assertIs)(updateFieldAppearances, 'updateFieldAppearances', [
                            'boolean'
                        ]);
                        if (addDefaultPage && this.getPageCount() === 0) this.addPage();
                        if (updateFieldAppearances) {
                            form = this.formCache.getValue();
                            if (form) form.updateFieldAppearances();
                        }
                        return [
                            4 /*yield*/ ,
                            this.flush()
                        ];
                    case 1:
                        _e.sent();
                        Writer = useObjectStreams ? (0, $4dd4e6f2a071605b$export$2e2bcd8739ae039) : (0, $132e973bcddbb568$export$2e2bcd8739ae039);
                        return [
                            2 /*return*/ ,
                            Writer.forContext(this.context, objectsPerTick).serializeToBuffer()
                        ];
                }
            });
        });
    };
    /**
     * Serialize this document to a base64 encoded string or data URI making up a
     * PDF file. For example:
     * ```js
     * const base64String = await pdfDoc.saveAsBase64()
     * base64String // => 'JVBERi0xLjcKJYGBgYEKC...'
     *
     * const base64DataUri = await pdfDoc.saveAsBase64({ dataUri: true })
     * base64DataUri // => 'data:application/pdf;base64,JVBERi0xLjcKJYGBgYEKC...'
     * ```
     *
     * @param options The options to be used when saving the document.
     * @returns Resolves with a base64 encoded string or data URI of the
     *          serialized document.
     */ PDFDocument.prototype.saveAsBase64 = function(options) {
        if (options === void 0) options = {};
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var _a, dataUri, otherOptions, bytes, base64;
            return (0, $273XO.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = options.dataUri, dataUri = _a === void 0 ? false : _a, otherOptions = (0, $273XO.__rest)(options, [
                            "dataUri"
                        ]);
                        (0, $8EKPA.assertIs)(dataUri, 'dataUri', [
                            'boolean'
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.save(otherOptions)
                        ];
                    case 1:
                        bytes = _b.sent();
                        base64 = (0, $cMViw.encodeToBase64)(bytes);
                        return [
                            2 /*return*/ ,
                            dataUri ? "data:application/pdf;base64," + base64 : base64
                        ];
                }
            });
        });
    };
    PDFDocument.prototype.findPageForAnnotationRef = function(ref) {
        var pages = this.getPages();
        for(var idx = 0, len = pages.length; idx < len; idx++){
            var page = pages[idx];
            var annotations = page.node.Annots();
            if ((annotations === null || annotations === void 0 ? void 0 : annotations.indexOf(ref)) !== undefined) return page;
        }
        return undefined;
    };
    PDFDocument.prototype.embedAll = function(embeddables) {
        return (0, $273XO.__awaiter)(this, void 0, void 0, function() {
            var idx, len;
            return (0, $273XO.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        idx = 0, len = embeddables.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            embeddables[idx].embed()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFDocument.prototype.updateInfoDict = function() {
        var pdfLib = "pdf-lib (https://github.com/Hopding/pdf-lib)";
        var now = new Date();
        var info = this.getInfoDict();
        this.setProducer(pdfLib);
        this.setModificationDate(now);
        if (!info.get((0, $alPcq.default).of('Creator'))) this.setCreator(pdfLib);
        if (!info.get((0, $alPcq.default).of('CreationDate'))) this.setCreationDate(now);
    };
    PDFDocument.prototype.getInfoDict = function() {
        var existingInfo = this.context.lookup(this.context.trailerInfo.Info);
        if (existingInfo instanceof (0, $b7e75d63d5628aec$export$2e2bcd8739ae039)) return existingInfo;
        var newInfo = this.context.obj({});
        this.context.trailerInfo.Info = this.context.register(newInfo);
        return newInfo;
    };
    PDFDocument.prototype.assertFontkit = function() {
        if (!this.fontkit) throw new (0, $07ff41eb9264b36f$export$529a7c74d0636a48)();
        return this.fontkit;
    };
    return PDFDocument;
}();
var $6767bf97ac5b9b71$export$2e2bcd8739ae039 = $6767bf97ac5b9b71$var$PDFDocument;
/* tslint:disable-next-line only-arrow-functions */ function $6767bf97ac5b9b71$var$assertIsLiteralOrHexString(pdfObject) {
    if (!(pdfObject instanceof (0, $d8f6d7884257882d$export$2e2bcd8739ae039)) && !(pdfObject instanceof (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039))) throw new (0, $iMObG.UnexpectedObjectTypeError)([
        (0, $d8f6d7884257882d$export$2e2bcd8739ae039),
        (0, $059039c0c7d9ffc8$export$2e2bcd8739ae039)
    ], pdfObject);
}





var $674643e799281547$export$c9b8fe72ac71821;
(function(BlendMode) {
    BlendMode["Normal"] = "Normal";
    BlendMode["Multiply"] = "Multiply";
    BlendMode["Screen"] = "Screen";
    BlendMode["Overlay"] = "Overlay";
    BlendMode["Darken"] = "Darken";
    BlendMode["Lighten"] = "Lighten";
    BlendMode["ColorDodge"] = "ColorDodge";
    BlendMode["ColorBurn"] = "ColorBurn";
    BlendMode["HardLight"] = "HardLight";
    BlendMode["SoftLight"] = "SoftLight";
    BlendMode["Difference"] = "Difference";
    BlendMode["Exclusion"] = "Exclusion";
})($674643e799281547$export$c9b8fe72ac71821 || ($674643e799281547$export$c9b8fe72ac71821 = {}));





var $dj8f2 = parcelRequire("dj8f2");
var $alPcq = parcelRequire("alPcq");
parcelRequire("5bpFt");
var $8EKPA = parcelRequire("8EKPA");
var $8hWZH = parcelRequire("8hWZH");
var $lxE62 = parcelRequire("lxE62");
/**
 * Represents a single page of a [[PDFDocument]].
 */ var $4488acf63d90f5a1$var$PDFPage = /** @class */ function() {
    function PDFPage(leafNode, ref, doc) {
        this.fontSize = 24;
        this.fontColor = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
        this.lineHeight = 24;
        this.x = 0;
        this.y = 0;
        (0, $8EKPA.assertIs)(leafNode, 'leafNode', [
            [
                (0, $27cec0c5ad235198$export$2e2bcd8739ae039),
                'PDFPageLeaf'
            ]
        ]);
        (0, $8EKPA.assertIs)(ref, 'ref', [
            [
                (0, $69d09480b29248e9$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $8EKPA.assertIs)(doc, 'doc', [
            [
                (0, $6767bf97ac5b9b71$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        this.node = leafNode;
        this.ref = ref;
        this.doc = doc;
    }
    /**
     * Rotate this page by a multiple of 90 degrees. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * page.setRotation(degrees(-90))
     * page.setRotation(degrees(0))
     * page.setRotation(degrees(90))
     * page.setRotation(degrees(180))
     * page.setRotation(degrees(270))
     * ```
     * @param angle The angle to rotate this page.
     */ PDFPage.prototype.setRotation = function(angle) {
        var degreesAngle = (0, $86b75e7e8bb6dd95$export$56cb859c01fa134d)(angle);
        (0, $8EKPA.assertMultiple)(degreesAngle, 'degreesAngle', 90);
        this.node.set((0, $alPcq.default).of('Rotate'), this.doc.context.obj(degreesAngle));
    };
    /**
     * Get this page's rotation angle in degrees. For example:
     * ```js
     * const rotationAngle = page.getRotation().angle;
     * ```
     * @returns The rotation angle of the page in degrees (always a multiple of
     *          90 degrees).
     */ PDFPage.prototype.getRotation = function() {
        var Rotate = this.node.Rotate();
        return (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(Rotate ? Rotate.asNumber() : 0);
    };
    /**
     * Resize this page by increasing or decreasing its width and height. For
     * example:
     * ```js
     * page.setSize(250, 500)
     * page.setSize(page.getWidth() + 50, page.getHeight() + 100)
     * page.setSize(page.getWidth() - 50, page.getHeight() - 100)
     * ```
     *
     * Note that the PDF specification does not allow for pages to have explicit
     * widths and heights. Instead it defines the "size" of a page in terms of
     * five rectangles: the MediaBox, CropBox, BleedBox, TrimBox, and ArtBox. As a
     * result, this method cannot directly change the width and height of a page.
     * Instead, it works by adjusting these five boxes.
     *
     * This method performs the following steps:
     *   1. Set width & height of MediaBox.
     *   2. Set width & height of CropBox, if it has same dimensions as MediaBox.
     *   3. Set width & height of BleedBox, if it has same dimensions as MediaBox.
     *   4. Set width & height of TrimBox, if it has same dimensions as MediaBox.
     *   5. Set width & height of ArtBox, if it has same dimensions as MediaBox.
     *
     * This approach works well for most PDF documents as all PDF pages must
     * have a MediaBox, but relatively few have a CropBox, BleedBox, TrimBox, or
     * ArtBox. And when they do have these additional boxes, they often have the
     * same dimensions as the MediaBox. However, if you find this method does not
     * work for your document, consider setting the boxes directly:
     *   * [[PDFPage.setMediaBox]]
     *   * [[PDFPage.setCropBox]]
     *   * [[PDFPage.setBleedBox]]
     *   * [[PDFPage.setTrimBox]]
     *   * [[PDFPage.setArtBox]]
     *
     * @param width The new width of the page.
     * @param height The new height of the page.
     */ PDFPage.prototype.setSize = function(width, height) {
        (0, $8EKPA.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(height, 'height', [
            'number'
        ]);
        var mediaBox = this.getMediaBox();
        this.setMediaBox(mediaBox.x, mediaBox.y, width, height);
        var cropBox = this.getCropBox();
        var bleedBox = this.getBleedBox();
        var trimBox = this.getTrimBox();
        var artBox = this.getArtBox();
        var hasCropBox = this.node.CropBox();
        var hasBleedBox = this.node.BleedBox();
        var hasTrimBox = this.node.TrimBox();
        var hasArtBox = this.node.ArtBox();
        if (hasCropBox && (0, $lxE62.rectanglesAreEqual)(cropBox, mediaBox)) this.setCropBox(mediaBox.x, mediaBox.y, width, height);
        if (hasBleedBox && (0, $lxE62.rectanglesAreEqual)(bleedBox, mediaBox)) this.setBleedBox(mediaBox.x, mediaBox.y, width, height);
        if (hasTrimBox && (0, $lxE62.rectanglesAreEqual)(trimBox, mediaBox)) this.setTrimBox(mediaBox.x, mediaBox.y, width, height);
        if (hasArtBox && (0, $lxE62.rectanglesAreEqual)(artBox, mediaBox)) this.setArtBox(mediaBox.x, mediaBox.y, width, height);
    };
    /**
     * Resize this page by increasing or decreasing its width. For example:
     * ```js
     * page.setWidth(250)
     * page.setWidth(page.getWidth() + 50)
     * page.setWidth(page.getWidth() - 50)
     * ```
     *
     * This method uses [[PDFPage.setSize]] to set the page's width.
     *
     * @param width The new width of the page.
     */ PDFPage.prototype.setWidth = function(width) {
        (0, $8EKPA.assertIs)(width, 'width', [
            'number'
        ]);
        this.setSize(width, this.getSize().height);
    };
    /**
     * Resize this page by increasing or decreasing its height. For example:
     * ```js
     * page.setHeight(500)
     * page.setHeight(page.getWidth() + 100)
     * page.setHeight(page.getWidth() - 100)
     * ```
     *
     * This method uses [[PDFPage.setSize]] to set the page's height.
     *
     * @param height The new height of the page.
     */ PDFPage.prototype.setHeight = function(height) {
        (0, $8EKPA.assertIs)(height, 'height', [
            'number'
        ]);
        this.setSize(this.getSize().width, height);
    };
    /**
     * Set the MediaBox of this page. For example:
     * ```js
     * const mediaBox = page.getMediaBox()
     *
     * page.setMediaBox(0, 0, 250, 500)
     * page.setMediaBox(mediaBox.x, mediaBox.y, 50, 100)
     * page.setMediaBox(15, 5, mediaBox.width - 50, mediaBox.height - 100)
     * ```
     *
     * See [[PDFPage.getMediaBox]] for details about what the MediaBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new MediaBox.
     * @param y The y coordinate of the lower left corner of the new MediaBox.
     * @param width The width of the new MediaBox.
     * @param height The height of the new MediaBox.
     */ PDFPage.prototype.setMediaBox = function(x, y, width, height) {
        (0, $8EKPA.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(height, 'height', [
            'number'
        ]);
        var mediaBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $alPcq.default).MediaBox, mediaBox);
    };
    /**
     * Set the CropBox of this page. For example:
     * ```js
     * const cropBox = page.getCropBox()
     *
     * page.setCropBox(0, 0, 250, 500)
     * page.setCropBox(cropBox.x, cropBox.y, 50, 100)
     * page.setCropBox(15, 5, cropBox.width - 50, cropBox.height - 100)
     * ```
     *
     * See [[PDFPage.getCropBox]] for details about what the CropBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new CropBox.
     * @param y The y coordinate of the lower left corner of the new CropBox.
     * @param width The width of the new CropBox.
     * @param height The height of the new CropBox.
     */ PDFPage.prototype.setCropBox = function(x, y, width, height) {
        (0, $8EKPA.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(height, 'height', [
            'number'
        ]);
        var cropBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $alPcq.default).CropBox, cropBox);
    };
    /**
     * Set the BleedBox of this page. For example:
     * ```js
     * const bleedBox = page.getBleedBox()
     *
     * page.setBleedBox(0, 0, 250, 500)
     * page.setBleedBox(bleedBox.x, bleedBox.y, 50, 100)
     * page.setBleedBox(15, 5, bleedBox.width - 50, bleedBox.height - 100)
     * ```
     *
     * See [[PDFPage.getBleedBox]] for details about what the BleedBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new BleedBox.
     * @param y The y coordinate of the lower left corner of the new BleedBox.
     * @param width The width of the new BleedBox.
     * @param height The height of the new BleedBox.
     */ PDFPage.prototype.setBleedBox = function(x, y, width, height) {
        (0, $8EKPA.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(height, 'height', [
            'number'
        ]);
        var bleedBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $alPcq.default).BleedBox, bleedBox);
    };
    /**
     * Set the TrimBox of this page. For example:
     * ```js
     * const trimBox = page.getTrimBox()
     *
     * page.setTrimBox(0, 0, 250, 500)
     * page.setTrimBox(trimBox.x, trimBox.y, 50, 100)
     * page.setTrimBox(15, 5, trimBox.width - 50, trimBox.height - 100)
     * ```
     *
     * See [[PDFPage.getTrimBox]] for details about what the TrimBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new TrimBox.
     * @param y The y coordinate of the lower left corner of the new TrimBox.
     * @param width The width of the new TrimBox.
     * @param height The height of the new TrimBox.
     */ PDFPage.prototype.setTrimBox = function(x, y, width, height) {
        (0, $8EKPA.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(height, 'height', [
            'number'
        ]);
        var trimBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $alPcq.default).TrimBox, trimBox);
    };
    /**
     * Set the ArtBox of this page. For example:
     * ```js
     * const artBox = page.getArtBox()
     *
     * page.setArtBox(0, 0, 250, 500)
     * page.setArtBox(artBox.x, artBox.y, 50, 100)
     * page.setArtBox(15, 5, artBox.width - 50, artBox.height - 100)
     * ```
     *
     * See [[PDFPage.getArtBox]] for details about what the ArtBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new ArtBox.
     * @param y The y coordinate of the lower left corner of the new ArtBox.
     * @param width The width of the new ArtBox.
     * @param height The height of the new ArtBox.
     */ PDFPage.prototype.setArtBox = function(x, y, width, height) {
        (0, $8EKPA.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(height, 'height', [
            'number'
        ]);
        var artBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $alPcq.default).ArtBox, artBox);
    };
    /**
     * Get this page's width and height. For example:
     * ```js
     * const { width, height } = page.getSize()
     * ```
     *
     * This method uses [[PDFPage.getMediaBox]] to obtain the page's
     * width and height.
     *
     * @returns The width and height of the page.
     */ PDFPage.prototype.getSize = function() {
        var _a = this.getMediaBox(), width = _a.width, height = _a.height;
        return {
            width: width,
            height: height
        };
    };
    /**
     * Get this page's width. For example:
     * ```js
     * const width = page.getWidth()
     * ```
     *
     * This method uses [[PDFPage.getSize]] to obtain the page's size.
     *
     * @returns The width of the page.
     */ PDFPage.prototype.getWidth = function() {
        return this.getSize().width;
    };
    /**
     * Get this page's height. For example:
     * ```js
     * const height = page.getHeight()
     * ```
     *
     * This method uses [[PDFPage.getSize]] to obtain the page's size.
     *
     * @returns The height of the page.
     */ PDFPage.prototype.getHeight = function() {
        return this.getSize().height;
    };
    /**
     * Get the rectangle defining this page's MediaBox. For example:
     * ```js
     * const { x, y, width, height } = page.getMediaBox()
     * ```
     *
     * The MediaBox of a page defines the boundaries of the physical medium on
     * which the page is to be displayed/printed. It may include extended area
     * surrounding the page content for bleed marks, printing marks, etc...
     * It may also include areas close to the edges of the medium that cannot be
     * marked because of physical limitations of the output device. Content
     * falling outside this boundary may safely be discarded without affecting
     * the meaning of the PDF file.
     *
     * @returns An object defining the lower left corner of the MediaBox and its
     *          width & height.
     */ PDFPage.prototype.getMediaBox = function() {
        var mediaBox = this.node.MediaBox();
        return mediaBox.asRectangle();
    };
    /**
     * Get the rectangle defining this page's CropBox. For example:
     * ```js
     * const { x, y, width, height } = page.getCropBox()
     * ```
     *
     * The CropBox of a page defines the region to which the contents of the page
     * shall be clipped when displayed or printed. Unlike the other boxes, the
     * CropBox does not necessarily represent the physical page geometry. It
     * merely imposes clipping on the page contents.
     *
     * The CropBox's default value is the page's MediaBox.
     *
     * @returns An object defining the lower left corner of the CropBox and its
     *          width & height.
     */ PDFPage.prototype.getCropBox = function() {
        var _a;
        var cropBox = this.node.CropBox();
        return (_a = cropBox === null || cropBox === void 0 ? void 0 : cropBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getMediaBox();
    };
    /**
     * Get the rectangle defining this page's BleedBox. For example:
     * ```js
     * const { x, y, width, height } = page.getBleedBox()
     * ```
     *
     * The BleedBox of a page defines the region to which the contents of the
     * page shall be clipped when output in a production environment. This may
     * include any extra bleed area needed to accommodate the physical
     * limitations of cutting, folding, and trimming equipment. The actual
     * printed page may include printing marks that fall outside the BleedBox.
     *
     * The BleedBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the BleedBox and its
     *          width & height.
     */ PDFPage.prototype.getBleedBox = function() {
        var _a;
        var bleedBox = this.node.BleedBox();
        return (_a = bleedBox === null || bleedBox === void 0 ? void 0 : bleedBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Get the rectangle defining this page's TrimBox. For example:
     * ```js
     * const { x, y, width, height } = page.getTrimBox()
     * ```
     *
     * The TrimBox of a page defines the intended dimensions of the finished
     * page after trimming. It may be smaller than the MediaBox to allow for
     * production-related content, such as printing instructions, cut marks, or
     * color bars.
     *
     * The TrimBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the TrimBox and its
     *          width & height.
     */ PDFPage.prototype.getTrimBox = function() {
        var _a;
        var trimBox = this.node.TrimBox();
        return (_a = trimBox === null || trimBox === void 0 ? void 0 : trimBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Get the rectangle defining this page's ArtBox. For example:
     * ```js
     * const { x, y, width, height } = page.getArtBox()
     * ```
     *
     * The ArtBox of a page defines the extent of the page's meaningful content
     * (including potential white space).
     *
     * The ArtBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the ArtBox and its
     *          width & height.
     */ PDFPage.prototype.getArtBox = function() {
        var _a;
        var artBox = this.node.ArtBox();
        return (_a = artBox === null || artBox === void 0 ? void 0 : artBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Translate this page's content to a new location on the page. This operation
     * is often useful after resizing the page with [[setSize]]. For example:
     * ```js
     * // Add 50 units of whitespace to the top and right of the page
     * page.setSize(page.getWidth() + 50, page.getHeight() + 50)
     *
     * // Move the page's content from the lower-left corner of the page
     * // to the top-right corner.
     * page.translateContent(50, 50)
     *
     * // Now there are 50 units of whitespace to the left and bottom of the page
     * ```
     * See also: [[resetPosition]]
     * @param x The new position on the x-axis for this page's content.
     * @param y The new position on the y-axis for this page's content.
     */ PDFPage.prototype.translateContent = function(x, y) {
        (0, $8EKPA.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(y, 'y', [
            'number'
        ]);
        this.node.normalize();
        this.getContentStream();
        var start = this.createContentStream((0, $95072c08d604c329$export$cb182c48e35739ac)(), (0, $95072c08d604c329$export$d73ee8ef04f5226a)(x, y));
        var startRef = this.doc.context.register(start);
        var end = this.createContentStream((0, $95072c08d604c329$export$10581a6f45bf75eb)());
        var endRef = this.doc.context.register(end);
        this.node.wrapContentStreams(startRef, endRef);
    };
    /**
     * Scale the size, content, and annotations of a page.
     *
     * For example:
     * ```js
     * page.scale(0.5, 0.5);
     * ```
     *
     * @param x The factor by which the width for the page should be scaled
     *          (e.g. `0.5` is 50%).
     * @param y The factor by which the height for the page should be scaled
     *          (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scale = function(x, y) {
        (0, $8EKPA.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(y, 'y', [
            'number'
        ]);
        this.setSize(this.getWidth() * x, this.getHeight() * y);
        this.scaleContent(x, y);
        this.scaleAnnotations(x, y);
    };
    /**
     * Scale the content of a page. This is useful after resizing an existing
     * page. This scales only the content, not the annotations.
     *
     * For example:
     * ```js
     * // Bisect the size of the page
     * page.setSize(page.getWidth() / 2, page.getHeight() / 2);
     *
     * // Scale the content of the page down by 50% in x and y
     * page.scaleContent(0.5, 0.5);
     * ```
     * See also: [[scaleAnnotations]]
     * @param x The factor by which the x-axis for the content should be scaled
     *          (e.g. `0.5` is 50%).
     * @param y The factor by which the y-axis for the content should be scaled
     *          (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scaleContent = function(x, y) {
        (0, $8EKPA.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(y, 'y', [
            'number'
        ]);
        this.node.normalize();
        this.getContentStream();
        var start = this.createContentStream((0, $95072c08d604c329$export$cb182c48e35739ac)(), (0, $95072c08d604c329$export$dcdf75081b88279d)(x, y));
        var startRef = this.doc.context.register(start);
        var end = this.createContentStream((0, $95072c08d604c329$export$10581a6f45bf75eb)());
        var endRef = this.doc.context.register(end);
        this.node.wrapContentStreams(startRef, endRef);
    };
    /**
     * Scale the annotations of a page. This is useful if you want to scale a
     * page with comments or other annotations.
     * ```js
     * // Scale the content of the page down by 50% in x and y
     * page.scaleContent(0.5, 0.5);
     *
     * // Scale the content of the page down by 50% in x and y
     * page.scaleAnnotations(0.5, 0.5);
     * ```
     * See also: [[scaleContent]]
     * @param x The factor by which the x-axis for the annotations should be
     *          scaled (e.g. `0.5` is 50%).
     * @param y The factor by which the y-axis for the annotations should be
     *          scaled (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scaleAnnotations = function(x, y) {
        (0, $8EKPA.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(y, 'y', [
            'number'
        ]);
        var annots = this.node.Annots();
        if (!annots) return;
        for(var idx = 0; idx < annots.size(); idx++){
            var annot = annots.lookup(idx);
            if (annot instanceof (0, $b7e75d63d5628aec$export$2e2bcd8739ae039)) this.scaleAnnot(annot, x, y);
        }
    };
    /**
     * Reset the x and y coordinates of this page to `(0, 0)`. This operation is
     * often useful after calling [[translateContent]]. For example:
     * ```js
     * // Shift the page's contents up and to the right by 50 units
     * page.translateContent(50, 50)
     *
     * // This text will shifted - it will be drawn at (50, 50)
     * page.drawText('I am shifted')
     *
     * // Move back to (0, 0)
     * page.resetPosition()
     *
     * // This text will not be shifted - it will be drawn at (0, 0)
     * page.drawText('I am not shifted')
     * ```
     */ PDFPage.prototype.resetPosition = function() {
        this.getContentStream(false);
        this.x = 0;
        this.y = 0;
    };
    /**
     * Choose a default font for this page. The default font will be used whenever
     * text is drawn on this page and no font is specified. For example:
     * ```js
     * import { StandardFonts } from 'pdf-lib'
     *
     * const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
     * const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const courierFont = await pdfDoc.embedFont(StandardFonts.Courier)
     *
     * const page = pdfDoc.addPage()
     *
     * page.setFont(helveticaFont)
     * page.drawText('I will be drawn in Helvetica')
     *
     * page.setFont(timesRomanFont)
     * page.drawText('I will be drawn in Courier', { font: courierFont })
     * ```
     * @param font The default font to be used when drawing text on this page.
     */ PDFPage.prototype.setFont = function(font) {
        // TODO: Reuse image Font name if we've already added this image to Resources.Fonts
        (0, $8EKPA.assertIs)(font, 'font', [
            [
                (0, $2afe68c947457de4$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.font = font;
        this.fontKey = this.node.newFontDictionary(this.font.name, this.font.ref);
    };
    /**
     * Choose a default font size for this page. The default font size will be
     * used whenever text is drawn on this page and no font size is specified.
     * For example:
     * ```js
     * page.setFontSize(12)
     * page.drawText('I will be drawn in size 12')
     *
     * page.setFontSize(36)
     * page.drawText('I will be drawn in size 24', { fontSize: 24 })
     * ```
     * @param fontSize The default font size to be used when drawing text on this
     *                 page.
     */ PDFPage.prototype.setFontSize = function(fontSize) {
        (0, $8EKPA.assertIs)(fontSize, 'fontSize', [
            'number'
        ]);
        this.fontSize = fontSize;
    };
    /**
     * Choose a default font color for this page. The default font color will be
     * used whenever text is drawn on this page and no font color is specified.
     * For example:
     * ```js
     * import { rgb, cmyk, grayscale } from 'pdf-lib'
     *
     * page.setFontColor(rgb(0.97, 0.02, 0.97))
     * page.drawText('I will be drawn in pink')
     *
     * page.setFontColor(cmyk(0.4, 0.7, 0.39, 0.15))
     * page.drawText('I will be drawn in gray', { color: grayscale(0.5) })
     * ```
     * @param fontColor The default font color to be used when drawing text on
     *                  this page.
     */ PDFPage.prototype.setFontColor = function(fontColor) {
        (0, $8EKPA.assertIs)(fontColor, 'fontColor', [
            [
                Object,
                'Color'
            ]
        ]);
        this.fontColor = fontColor;
    };
    /**
     * Choose a default line height for this page. The default line height will be
     * used whenever text is drawn on this page and no line height is specified.
     * For example:
     * ```js
     * page.setLineHeight(12);
     * page.drawText('These lines will be vertically \n separated by 12 units')
     *
     * page.setLineHeight(36);
     * page.drawText('These lines will be vertically \n separated by 24 units', {
     *   lineHeight: 24
     * })
     * ```
     * @param lineHeight The default line height to be used when drawing text on
     *                   this page.
     */ PDFPage.prototype.setLineHeight = function(lineHeight) {
        (0, $8EKPA.assertIs)(lineHeight, 'lineHeight', [
            'number'
        ]);
        this.lineHeight = lineHeight;
    };
    /**
     * Get the default position of this page. For example:
     * ```js
     * const { x, y } = page.getPosition()
     * ```
     * @returns The default position of the page.
     */ PDFPage.prototype.getPosition = function() {
        return {
            x: this.x,
            y: this.y
        };
    };
    /**
     * Get the default x coordinate of this page. For example:
     * ```js
     * const x = page.getX()
     * ```
     * @returns The default x coordinate of the page.
     */ PDFPage.prototype.getX = function() {
        return this.x;
    };
    /**
     * Get the default y coordinate of this page. For example:
     * ```js
     * const y = page.getY()
     * ```
     * @returns The default y coordinate of the page.
     */ PDFPage.prototype.getY = function() {
        return this.y;
    };
    /**
     * Change the default position of this page. For example:
     * ```js
     * page.moveTo(0, 0)
     * page.drawText('I will be drawn at the origin')
     *
     * page.moveTo(0, 25)
     * page.drawText('I will be drawn 25 units up')
     *
     * page.moveTo(25, 25)
     * page.drawText('I will be drawn 25 units up and 25 units to the right')
     * ```
     * @param x The new default position on the x-axis for this page.
     * @param y The new default position on the y-axis for this page.
     */ PDFPage.prototype.moveTo = function(x, y) {
        (0, $8EKPA.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(y, 'y', [
            'number'
        ]);
        this.x = x;
        this.y = y;
    };
    /**
     * Change the default position of this page to be further down the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveDown(10)
     * page.drawText('I will be drawn at (50, 40)')
     * ```
     * @param yDecrease The amount by which the page's default position along the
     *                  y-axis should be decreased.
     */ PDFPage.prototype.moveDown = function(yDecrease) {
        (0, $8EKPA.assertIs)(yDecrease, 'yDecrease', [
            'number'
        ]);
        this.y -= yDecrease;
    };
    /**
     * Change the default position of this page to be further up the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveUp(10)
     * page.drawText('I will be drawn at (50, 60)')
     * ```
     * @param yIncrease The amount by which the page's default position along the
     *                  y-axis should be increased.
     */ PDFPage.prototype.moveUp = function(yIncrease) {
        (0, $8EKPA.assertIs)(yIncrease, 'yIncrease', [
            'number'
        ]);
        this.y += yIncrease;
    };
    /**
     * Change the default position of this page to be further left on the x-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveLeft(10)
     * page.drawText('I will be drawn at (40, 50)')
     * ```
     * @param xDecrease The amount by which the page's default position along the
     *                  x-axis should be decreased.
     */ PDFPage.prototype.moveLeft = function(xDecrease) {
        (0, $8EKPA.assertIs)(xDecrease, 'xDecrease', [
            'number'
        ]);
        this.x -= xDecrease;
    };
    /**
     * Change the default position of this page to be further right on the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveRight(10)
     * page.drawText('I will be drawn at (60, 50)')
     * ```
     * @param xIncrease The amount by which the page's default position along the
     *                  x-axis should be increased.
     */ PDFPage.prototype.moveRight = function(xIncrease) {
        (0, $8EKPA.assertIs)(xIncrease, 'xIncrease', [
            'number'
        ]);
        this.x += xIncrease;
    };
    /**
     * Push one or more operators to the end of this page's current content
     * stream. For example:
     * ```js
     * import {
     *   pushGraphicsState,
     *   moveTo,
     *   lineTo,
     *   closePath,
     *   setFillingColor,
     *   rgb,
     *   fill,
     *   popGraphicsState,
     * } from 'pdf-lib'
     *
     * // Draw a green triangle in the lower-left corner of the page
     * page.pushOperators(
     *   pushGraphicsState(),
     *   moveTo(0, 0),
     *   lineTo(100, 0),
     *   lineTo(50, 100),
     *   closePath(),
     *   setFillingColor(rgb(0.0, 1.0, 0.0)),
     *   fill(),
     *   popGraphicsState(),
     * )
     * ```
     * @param operator The operators to be pushed.
     */ PDFPage.prototype.pushOperators = function() {
        var operator = [];
        for(var _i = 0; _i < arguments.length; _i++)operator[_i] = arguments[_i];
        (0, $8EKPA.assertEachIs)(operator, 'operator', [
            [
                (0, $7df3d1b72d21cb6b$export$2e2bcd8739ae039),
                'PDFOperator'
            ]
        ]);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, operator);
    };
    /**
     * Draw one or more lines of text on this page. For example:
     * ```js
     * import { StandardFonts, rgb } from 'pdf-lib'
     *
     * const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
     *
     * const page = pdfDoc.addPage()
     *
     * page.setFont(helveticaFont)
     *
     * page.moveTo(5, 200)
     * page.drawText('The Life of an Egg', { size: 36 })
     *
     * page.moveDown(36)
     * page.drawText('An Epic Tale of Woe', { size: 30 })
     *
     * page.drawText(
     *   `Humpty Dumpty sat on a wall \n` +
     *   `Humpty Dumpty had a great fall; \n` +
     *   `All the king's horses and all the king's men \n` +
     *   `Couldn't put Humpty together again. \n`,
     *   {
     *     x: 25,
     *     y: 100,
     *     font: timesRomanFont,
     *     size: 24,
     *     color: rgb(1, 0, 0),
     *     lineHeight: 24,
     *     opacity: 0.75,
     *   },
     * )
     * ```
     * @param text The text to be drawn.
     * @param options The options to be used when drawing the text.
     */ PDFPage.prototype.drawText = function(text, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (options === void 0) options = {};
        (0, $8EKPA.assertIs)(text, 'text', [
            'string'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $8EKPA.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $8EKPA.assertOrUndefined)(options.font, 'options.font', [
            [
                (0, $2afe68c947457de4$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(options.size, 'options.size', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.lineHeight, 'options.lineHeight', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.maxWidth, 'options.maxWidth', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.wordBreaks, 'options.wordBreaks', [
            Array
        ]);
        (0, $8EKPA.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $674643e799281547$export$c9b8fe72ac71821));
        var _h = this.setOrEmbedFont(options.font), oldFont = _h.oldFont, newFont = _h.newFont, newFontKey = _h.newFontKey;
        var fontSize = options.size || this.fontSize;
        var wordBreaks = options.wordBreaks || this.doc.defaultWordBreaks;
        var textWidth = function(t) {
            return newFont.widthOfTextAtSize(t, fontSize);
        };
        var lines = options.maxWidth === undefined ? (0, $8hWZH.lineSplit)((0, $8hWZH.cleanText)(text)) : (0, $8hWZH.breakTextIntoLines)(text, wordBreaks, options.maxWidth, textWidth);
        var encodedLines = new Array(lines.length);
        for(var idx = 0, len = lines.length; idx < len; idx++)encodedLines[idx] = newFont.encodeText(lines[idx]);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $c3fbae23fda05c7a$export$f7b8b44d3d84bc26)(encodedLines, {
            color: (_a = options.color) !== null && _a !== void 0 ? _a : this.fontColor,
            font: newFontKey,
            size: fontSize,
            rotate: (_b = options.rotate) !== null && _b !== void 0 ? _b : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            xSkew: (_c = options.xSkew) !== null && _c !== void 0 ? _c : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            ySkew: (_d = options.ySkew) !== null && _d !== void 0 ? _d : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            x: (_e = options.x) !== null && _e !== void 0 ? _e : this.x,
            y: (_f = options.y) !== null && _f !== void 0 ? _f : this.y,
            lineHeight: (_g = options.lineHeight) !== null && _g !== void 0 ? _g : this.lineHeight,
            graphicsState: graphicsStateKey
        }));
        if (options.font) {
            if (oldFont) this.setFont(oldFont);
            else this.resetFont();
        }
    };
    /**
     * Draw an image on this page. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * const jpgUrl = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const jpgImageBytes = await fetch(jpgUrl).then((res) => res.arrayBuffer())
     *
     * const jpgImage = await pdfDoc.embedJpg(jpgImageBytes)
     * const jpgDims = jpgImage.scale(0.5)
     *
     * const page = pdfDoc.addPage()
     *
     * page.drawImage(jpgImage, {
     *   x: 25,
     *   y: 25,
     *   width: jpgDims.width,
     *   height: jpgDims.height,
     *   rotate: degrees(30),
     *   opacity: 0.75,
     * })
     * ```
     * @param image The image to be drawn.
     * @param options The options to be used when drawing the image.
     */ PDFPage.prototype.drawImage = function(image, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (options === void 0) options = {};
        // TODO: Reuse image XObject name if we've already added this image to Resources.XObjects
        (0, $8EKPA.assertIs)(image, 'image', [
            [
                (0, $c6adec950ad59431$export$2e2bcd8739ae039),
                'PDFImage'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $8EKPA.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $8EKPA.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $674643e799281547$export$c9b8fe72ac71821));
        var xObjectKey = this.node.newXObject('Image', image.ref);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $c3fbae23fda05c7a$export$21a059be5bfd5fb)(xObjectKey, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : image.size().width,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : image.size().height,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw an embedded PDF page on this page. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const page = pdfDoc.addPage()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourcePdf = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     *
     * // Embed page 74 from the PDF
     * const [embeddedPage] = await pdfDoc.embedPdf(sourcePdf, 73)
     *
     * page.drawPage(embeddedPage, {
     *   x: 250,
     *   y: 200,
     *   xScale: 0.5,
     *   yScale: 0.5,
     *   rotate: degrees(30),
     *   opacity: 0.75,
     * })
     * ```
     *
     * The `options` argument accepts both `width`/`height` and `xScale`/`yScale`
     * as options. Since each of these options defines the size of the drawn page,
     * if both options are given, `width` and `height` take precedence and the
     * corresponding scale variants are ignored.
     *
     * @param embeddedPage The embedded page to be drawn.
     * @param options The options to be used when drawing the embedded page.
     */ PDFPage.prototype.drawPage = function(embeddedPage, options) {
        var _a, _b, _c, _d, _e;
        if (options === void 0) options = {};
        // TODO: Reuse embeddedPage XObject name if we've already added this embeddedPage to Resources.XObjects
        (0, $8EKPA.assertIs)(embeddedPage, 'embeddedPage', [
            [
                (0, $b964e8b946931c49$export$2e2bcd8739ae039),
                'PDFEmbeddedPage'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.xScale, 'options.xScale', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.yScale, 'options.yScale', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $8EKPA.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $8EKPA.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $674643e799281547$export$c9b8fe72ac71821));
        var xObjectKey = this.node.newXObject('EmbeddedPdfPage', embeddedPage.ref);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        // prettier-ignore
        var xScale = options.width !== undefined ? options.width / embeddedPage.width : options.xScale !== undefined ? options.xScale : 1;
        // prettier-ignore
        var yScale = options.height !== undefined ? options.height / embeddedPage.height : options.yScale !== undefined ? options.yScale : 1;
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $c3fbae23fda05c7a$export$f8ea28c31069cbc9)(xObjectKey, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            xScale: xScale,
            yScale: yScale,
            rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            xSkew: (_d = options.xSkew) !== null && _d !== void 0 ? _d : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            ySkew: (_e = options.ySkew) !== null && _e !== void 0 ? _e : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw an SVG path on this page. For example:
     * ```js
     * import { rgb } from 'pdf-lib'
     *
     * const svgPath = 'M 0,20 L 100,160 Q 130,200 150,120 C 190,-40 200,200 300,150 L 400,90'
     *
     * // Draw path as black line
     * page.drawSvgPath(svgPath, { x: 25, y: 75 })
     *
     * // Change border style and opacity
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 275,
     *   borderColor: rgb(0.5, 0.5, 0.5),
     *   borderWidth: 2,
     *   borderOpacity: 0.75,
     * })
     *
     * // Set fill color and opacity
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 475,
     *   color: rgb(1.0, 0, 0),
     *   opacity: 0.75,
     * })
     *
     * // Draw 50% of original size
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 675,
     *   scale: 0.5,
     * })
     * ```
     * @param path The SVG path to be drawn.
     * @param options The options to be used when drawing the SVG path.
     */ PDFPage.prototype.drawSvgPath = function(path, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (options === void 0) options = {};
        (0, $8EKPA.assertIs)(path, 'path', [
            'string'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.scale, 'options.scale', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $8EKPA.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $8EKPA.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $8EKPA.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $8EKPA.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $95072c08d604c329$export$7a77bc708e50709e));
        (0, $8EKPA.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $8EKPA.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $674643e799281547$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.borderColor = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $c3fbae23fda05c7a$export$47c8a640c39d0756)(path, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            scale: options.scale,
            rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            color: (_d = options.color) !== null && _d !== void 0 ? _d : undefined,
            borderColor: (_e = options.borderColor) !== null && _e !== void 0 ? _e : undefined,
            borderWidth: (_f = options.borderWidth) !== null && _f !== void 0 ? _f : 0,
            borderDashArray: (_g = options.borderDashArray) !== null && _g !== void 0 ? _g : undefined,
            borderDashPhase: (_h = options.borderDashPhase) !== null && _h !== void 0 ? _h : undefined,
            borderLineCap: (_j = options.borderLineCap) !== null && _j !== void 0 ? _j : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a line on this page. For example:
     * ```js
     * import { rgb } from 'pdf-lib'
     *
     * page.drawLine({
     *   start: { x: 25, y: 75 },
     *   end: { x: 125, y: 175 },
     *   thickness: 2,
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the line.
     */ PDFPage.prototype.drawLine = function(options) {
        var _a, _b, _c, _d, _e;
        (0, $8EKPA.assertIs)(options.start, 'options.start', [
            [
                Object,
                '{ x: number, y: number }'
            ]
        ]);
        (0, $8EKPA.assertIs)(options.end, 'options.end', [
            [
                Object,
                '{ x: number, y: number }'
            ]
        ]);
        (0, $8EKPA.assertIs)(options.start.x, 'options.start.x', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(options.start.y, 'options.start.y', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(options.end.x, 'options.end.x', [
            'number'
        ]);
        (0, $8EKPA.assertIs)(options.end.y, 'options.end.y', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.thickness, 'options.thickness', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(options.dashArray, 'options.dashArray', [
            Array
        ]);
        (0, $8EKPA.assertOrUndefined)(options.dashPhase, 'options.dashPhase', [
            'number'
        ]);
        (0, $8EKPA.assertIsOneOfOrUndefined)(options.lineCap, 'options.lineCap', (0, $95072c08d604c329$export$7a77bc708e50709e));
        (0, $8EKPA.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $8EKPA.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $674643e799281547$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            borderOpacity: options.opacity,
            blendMode: options.blendMode
        });
        if (!('color' in options)) options.color = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $c3fbae23fda05c7a$export$819db45aec5fcbe5)({
            start: options.start,
            end: options.end,
            thickness: (_a = options.thickness) !== null && _a !== void 0 ? _a : 1,
            color: (_b = options.color) !== null && _b !== void 0 ? _b : undefined,
            dashArray: (_c = options.dashArray) !== null && _c !== void 0 ? _c : undefined,
            dashPhase: (_d = options.dashPhase) !== null && _d !== void 0 ? _d : undefined,
            lineCap: (_e = options.lineCap) !== null && _e !== void 0 ? _e : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a rectangle on this page. For example:
     * ```js
     * import { degrees, grayscale, rgb } from 'pdf-lib'
     *
     * page.drawRectangle({
     *   x: 25,
     *   y: 75,
     *   width: 250,
     *   height: 75,
     *   rotate: degrees(-15),
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the rectangle.
     */ PDFPage.prototype.drawRectangle = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (options === void 0) options = {};
        (0, $8EKPA.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $8EKPA.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $8EKPA.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $8EKPA.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $8EKPA.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $95072c08d604c329$export$7a77bc708e50709e));
        (0, $8EKPA.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $8EKPA.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $674643e799281547$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.color = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $c3fbae23fda05c7a$export$cac848e0621718d8)({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 150,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
            color: (_j = options.color) !== null && _j !== void 0 ? _j : undefined,
            borderColor: (_k = options.borderColor) !== null && _k !== void 0 ? _k : undefined,
            borderDashArray: (_l = options.borderDashArray) !== null && _l !== void 0 ? _l : undefined,
            borderDashPhase: (_m = options.borderDashPhase) !== null && _m !== void 0 ? _m : undefined,
            graphicsState: graphicsStateKey,
            borderLineCap: (_o = options.borderLineCap) !== null && _o !== void 0 ? _o : undefined
        }));
    };
    /**
     * Draw a square on this page. For example:
     * ```js
     * import { degrees, grayscale, rgb } from 'pdf-lib'
     *
     * page.drawSquare({
     *   x: 25,
     *   y: 75,
     *   size: 100,
     *   rotate: degrees(-15),
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the square.
     */ PDFPage.prototype.drawSquare = function(options) {
        if (options === void 0) options = {};
        var size = options.size;
        (0, $8EKPA.assertOrUndefined)(size, 'size', [
            'number'
        ]);
        this.drawRectangle((0, $273XO.__assign)((0, $273XO.__assign)({}, options), {
            width: size,
            height: size
        }));
    };
    /**
     * Draw an ellipse on this page. For example:
     * ```js
     * import { grayscale, rgb } from 'pdf-lib'
     *
     * page.drawEllipse({
     *   x: 200,
     *   y: 75,
     *   xScale: 100,
     *   yScale: 50,
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the ellipse.
     */ PDFPage.prototype.drawEllipse = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (options === void 0) options = {};
        (0, $8EKPA.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.xScale, 'options.xScale', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.yScale, 'options.yScale', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $8EKPA.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $8EKPA.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $8EKPA.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $8EKPA.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $8EKPA.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $8EKPA.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $8EKPA.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $95072c08d604c329$export$7a77bc708e50709e));
        (0, $8EKPA.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $674643e799281547$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.color = (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $c3fbae23fda05c7a$export$43c9e2bb0dc74582)({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            xScale: (_c = options.xScale) !== null && _c !== void 0 ? _c : 100,
            yScale: (_d = options.yScale) !== null && _d !== void 0 ? _d : 100,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : undefined,
            color: (_f = options.color) !== null && _f !== void 0 ? _f : undefined,
            borderColor: (_g = options.borderColor) !== null && _g !== void 0 ? _g : undefined,
            borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
            borderDashArray: (_j = options.borderDashArray) !== null && _j !== void 0 ? _j : undefined,
            borderDashPhase: (_k = options.borderDashPhase) !== null && _k !== void 0 ? _k : undefined,
            borderLineCap: (_l = options.borderLineCap) !== null && _l !== void 0 ? _l : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a circle on this page. For example:
     * ```js
     * import { grayscale, rgb } from 'pdf-lib'
     *
     * page.drawCircle({
     *   x: 200,
     *   y: 150,
     *   size: 100,
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the ellipse.
     */ PDFPage.prototype.drawCircle = function(options) {
        if (options === void 0) options = {};
        var _a = options.size, size = _a === void 0 ? 100 : _a;
        (0, $8EKPA.assertOrUndefined)(size, 'size', [
            'number'
        ]);
        this.drawEllipse((0, $273XO.__assign)((0, $273XO.__assign)({}, options), {
            xScale: size,
            yScale: size
        }));
    };
    PDFPage.prototype.setOrEmbedFont = function(font) {
        var oldFont = this.font;
        var oldFontKey = this.fontKey;
        if (font) this.setFont(font);
        else this.getFont();
        var newFont = this.font;
        var newFontKey = this.fontKey;
        return {
            oldFont: oldFont,
            oldFontKey: oldFontKey,
            newFont: newFont,
            newFontKey: newFontKey
        };
    };
    PDFPage.prototype.getFont = function() {
        if (!this.font || !this.fontKey) {
            var font = this.doc.embedStandardFont((0, $1282fe3e684c999b$export$7dcb046109e65a3d).Helvetica);
            this.setFont(font);
        }
        return [
            this.font,
            this.fontKey
        ];
    };
    PDFPage.prototype.resetFont = function() {
        this.font = undefined;
        this.fontKey = undefined;
    };
    PDFPage.prototype.getContentStream = function(useExisting) {
        if (useExisting === void 0) useExisting = true;
        if (useExisting && this.contentStream) return this.contentStream;
        this.contentStream = this.createContentStream();
        this.contentStreamRef = this.doc.context.register(this.contentStream);
        this.node.addContentStream(this.contentStreamRef);
        return this.contentStream;
    };
    PDFPage.prototype.createContentStream = function() {
        var operators = [];
        for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
        var dict = this.doc.context.obj({});
        var contentStream = (0, $76f7b8adb556b72e$export$2e2bcd8739ae039).of(dict, operators);
        return contentStream;
    };
    PDFPage.prototype.maybeEmbedGraphicsState = function(options) {
        var opacity = options.opacity, borderOpacity = options.borderOpacity, blendMode = options.blendMode;
        if (opacity === undefined && borderOpacity === undefined && blendMode === undefined) return undefined;
        var graphicsState = this.doc.context.obj({
            Type: 'ExtGState',
            ca: opacity,
            CA: borderOpacity,
            BM: blendMode
        });
        var key = this.node.newExtGState('GS', graphicsState);
        return key;
    };
    PDFPage.prototype.scaleAnnot = function(annot, x, y) {
        var selectors = [
            'RD',
            'CL',
            'Vertices',
            'QuadPoints',
            'L',
            'Rect'
        ];
        for(var idx = 0, len = selectors.length; idx < len; idx++){
            var list = annot.lookup((0, $alPcq.default).of(selectors[idx]));
            if (list instanceof (0, $dj8f2.default)) list.scalePDFNumbers(x, y);
        }
        var inkLists = annot.lookup((0, $alPcq.default).of('InkList'));
        if (inkLists instanceof (0, $dj8f2.default)) for(var idx = 0, len = inkLists.size(); idx < len; idx++){
            var arr = inkLists.lookup(idx);
            if (arr instanceof (0, $dj8f2.default)) arr.scalePDFNumbers(x, y);
        }
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addPage]] and [[PDFDocument.insertPage]]
     * > methods, which can create instances of [[PDFPage]] for you.
     *
     * Create an instance of [[PDFPage]] from an existing leaf node.
     *
     * @param leafNode The leaf node to be wrapped.
     * @param ref The unique reference for the page.
     * @param doc The document to which the page will belong.
     */ PDFPage.of = function(leafNode, ref, doc) {
        return new PDFPage(leafNode, ref, doc);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addPage]] and [[PDFDocument.insertPage]]
     * > methods, which can create instances of [[PDFPage]] for you.
     *
     * Create an instance of [[PDFPage]].
     *
     * @param doc The document to which the page will belong.
     */ PDFPage.create = function(doc) {
        (0, $8EKPA.assertIs)(doc, 'doc', [
            [
                (0, $6767bf97ac5b9b71$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        var dummyRef = (0, $69d09480b29248e9$export$2e2bcd8739ae039).of(-1);
        var pageLeaf = (0, $27cec0c5ad235198$export$2e2bcd8739ae039).withContextAndParent(doc.context, dummyRef);
        var pageRef = doc.context.register(pageLeaf);
        return new PDFPage(pageLeaf, pageRef, doc);
    };
    return PDFPage;
}();
var $4488acf63d90f5a1$export$2e2bcd8739ae039 = $4488acf63d90f5a1$var$PDFPage;









parcelRequire("5bpFt");
var $8EKPA = parcelRequire("8EKPA");
/**
 * Represents a button field of a [[PDFForm]].
 *
 * [[PDFButton]] fields are interactive controls that users can click with their
 * mouse. This type of [[PDFField]] is not stateful. The purpose of a button
 * is to perform an action when the user clicks on it, such as opening a print
 * modal or resetting the form. Buttons are typically rectangular in shape and
 * have a text label describing the action that they perform when clicked.
 */ var $2b4cbbbb2f6a4cc4$var$PDFButton = /** @class */ function(_super) {
    (0, $273XO.__extends)(PDFButton, _super);
    function PDFButton(acroPushButton, ref, doc) {
        var _this = _super.call(this, acroPushButton, ref, doc) || this;
        (0, $8EKPA.assertIs)(acroPushButton, 'acroButton', [
            [
                (0, $91592ae7fb4500cd$export$2e2bcd8739ae039),
                'PDFAcroPushButton'
            ]
        ]);
        _this.acroField = acroPushButton;
        return _this;
    }
    /**
     * Display an image inside the bounds of this button's widgets. For example:
     * ```js
     * const pngImage = await pdfDoc.embedPng(...)
     * const button = form.getButton('some.button.field')
     * button.setImage(pngImage, ImageAlignment.Center)
     * ```
     * This will update the appearances streams for each of this button's widgets.
     * @param image The image that should be displayed.
     * @param alignment The alignment of the image.
     */ PDFButton.prototype.setImage = function(image, alignment) {
        if (alignment === void 0) alignment = (0, $2e44185893bd08e1$export$8efa99ca8f041e7e).Center;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var streamRef = this.createImageAppearanceStream(widget, image, alignment);
            this.updateWidgetAppearances(widget, {
                normal: streamRef
            });
        }
        this.markAsClean();
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this button. Font sizes may
     * be integer or floating point numbers. Supplying a negative font size will
     * cause this method to throw an error.
     *
     * For example:
     * ```js
     * const button = form.getButton('some.button.field')
     * button.setFontSize(4)
     * button.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFButton.prototype.setFontSize = function(fontSize) {
        (0, $8EKPA.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Show this button on the specified page with the given text. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const button = form.createButton('some.button.field')
     *
     * button.addToPage('Do Stuff', page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this button field.
     * @param text The text to be displayed for this button widget.
     * @param page The page to which this button widget should be added.
     * @param options The options to be used when adding this button widget.
     */ PDFButton.prototype.addToPage = function(// TODO: This needs to be optional, e.g. for image buttons
    text, page, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        (0, $8EKPA.assertOrUndefined)(text, 'text', [
            'string'
        ]);
        (0, $8EKPA.assertOrUndefined)(page, 'page', [
            [
                (0, $4488acf63d90f5a1$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $bba8db1758f4c42e$export$55643210f1835a35)(options);
        // Create a widget for this button
        var widget = this.createWidget({
            x: ((_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0) - ((_b = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _b !== void 0 ? _b : 0) / 2,
            y: ((_c = options === null || options === void 0 ? void 0 : options.y) !== null && _c !== void 0 ? _c : 0) - ((_d = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _d !== void 0 ? _d : 0) / 2,
            width: (_e = options === null || options === void 0 ? void 0 : options.width) !== null && _e !== void 0 ? _e : 100,
            height: (_f = options === null || options === void 0 ? void 0 : options.height) !== null && _f !== void 0 ? _f : 50,
            textColor: (_g = options === null || options === void 0 ? void 0 : options.textColor) !== null && _g !== void 0 ? _g : (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0, 0, 0),
            backgroundColor: (_h = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _h !== void 0 ? _h : (0, $04532fa67d29096c$export$8972dc0e6ad9238f)(0.75, 0.75, 0.75),
            borderColor: options === null || options === void 0 ? void 0 : options.borderColor,
            borderWidth: (_j = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _j !== void 0 ? _j : 0,
            rotate: (_k = options === null || options === void 0 ? void 0 : options.rotate) !== null && _k !== void 0 ? _k : (0, $86b75e7e8bb6dd95$export$41fc368e1a942b97)(0),
            caption: text,
            hidden: options === null || options === void 0 ? void 0 : options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_l = options === null || options === void 0 ? void 0 : options.font) !== null && _l !== void 0 ? _l : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this button has been marked as dirty, or if any of this
     * button's widgets do not have an appearance stream. For example:
     * ```js
     * const button = form.getButton('some.button.field')
     * if (button.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this button needs an appearance update.
     */ PDFButton.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $c444ed3a6bfbd846$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this button's widgets using
     * the default appearance provider for buttons. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const button = form.getButton('some.button.field')
     * button.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFButton.prototype.defaultUpdateAppearances = function(font) {
        (0, $8EKPA.assertIs)(font, 'font', [
            [
                (0, $2afe68c947457de4$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this button's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for buttons will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const button = form.getButton('some.button.field')
     * button.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return {
     *     normal: drawButton(...),
     *     down: drawButton(...),
     *   }
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFButton.prototype.updateAppearances = function(font, provider) {
        (0, $8EKPA.assertIs)(font, 'font', [
            [
                (0, $2afe68c947457de4$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $8EKPA.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
    };
    PDFButton.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $fd9d87d4f9bb8968$export$68f9b19f48ffeeec);
        var appearances = (0, $fd9d87d4f9bb8968$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getButton]] method, which will create an
     * > instance of [[PDFButton]] for you.
     *
     * Create an instance of [[PDFButton]] from an existing acroPushButton and ref
     *
     * @param acroPushButton The underlying `PDFAcroPushButton` for this button.
     * @param ref The unique reference for this button.
     * @param doc The document to which this button will belong.
     */ PDFButton.of = function(acroPushButton, ref, doc) {
        return new PDFButton(acroPushButton, ref, doc);
    };
    return PDFButton;
}((0, $bba8db1758f4c42e$export$2e2bcd8739ae039));
var $2b4cbbbb2f6a4cc4$export$2e2bcd8739ae039 = $2b4cbbbb2f6a4cc4$var$PDFButton;




































var $321a704dac0d4328$exports = {};


parcelRequire("5bpFt");
$parcel$exportWildcard($7b4f31ece5bced4b$exports, $321a704dac0d4328$exports);


/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 4.2.1 Built on 2026-03-17T11:11:27.057Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2025 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2025 yWorks GmbH, http://www.yworks.com
 *               2015-2025 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */ 
var $jObBy = parcelRequire("jObBy");
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $16597f9d07f22afc$var$ch2 = {};
var $16597f9d07f22afc$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($16597f9d07f22afc$var$ch2[id] || ($16597f9d07f22afc$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $16597f9d07f22afc$var$u8 = Uint8Array, $16597f9d07f22afc$var$u16 = Uint16Array, $16597f9d07f22afc$var$i32 = Int32Array;
// fixed length extra bits
var $16597f9d07f22afc$var$fleb = new $16597f9d07f22afc$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $16597f9d07f22afc$var$fdeb = new $16597f9d07f22afc$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $16597f9d07f22afc$var$clim = new $16597f9d07f22afc$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $16597f9d07f22afc$var$freb = function(eb, start) {
    var b = new $16597f9d07f22afc$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $16597f9d07f22afc$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $16597f9d07f22afc$var$_a = $16597f9d07f22afc$var$freb($16597f9d07f22afc$var$fleb, 2), $16597f9d07f22afc$var$fl = $16597f9d07f22afc$var$_a.b, $16597f9d07f22afc$var$revfl = $16597f9d07f22afc$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$16597f9d07f22afc$var$fl[28] = 258, $16597f9d07f22afc$var$revfl[258] = 28;
var $16597f9d07f22afc$var$_b = $16597f9d07f22afc$var$freb($16597f9d07f22afc$var$fdeb, 0), $16597f9d07f22afc$var$fd = $16597f9d07f22afc$var$_b.b, $16597f9d07f22afc$var$revfd = $16597f9d07f22afc$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $16597f9d07f22afc$var$rev = new $16597f9d07f22afc$var$u16(32768);
for(var $16597f9d07f22afc$var$i = 0; $16597f9d07f22afc$var$i < 32768; ++$16597f9d07f22afc$var$i){
    // reverse table algorithm from SO
    var $16597f9d07f22afc$var$x = ($16597f9d07f22afc$var$i & 0xAAAA) >> 1 | ($16597f9d07f22afc$var$i & 0x5555) << 1;
    $16597f9d07f22afc$var$x = ($16597f9d07f22afc$var$x & 0xCCCC) >> 2 | ($16597f9d07f22afc$var$x & 0x3333) << 2;
    $16597f9d07f22afc$var$x = ($16597f9d07f22afc$var$x & 0xF0F0) >> 4 | ($16597f9d07f22afc$var$x & 0x0F0F) << 4;
    $16597f9d07f22afc$var$rev[$16597f9d07f22afc$var$i] = (($16597f9d07f22afc$var$x & 0xFF00) >> 8 | ($16597f9d07f22afc$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $16597f9d07f22afc$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $16597f9d07f22afc$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $16597f9d07f22afc$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $16597f9d07f22afc$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$16597f9d07f22afc$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $16597f9d07f22afc$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $16597f9d07f22afc$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $16597f9d07f22afc$var$flt = new $16597f9d07f22afc$var$u8(288);
for(var $16597f9d07f22afc$var$i = 0; $16597f9d07f22afc$var$i < 144; ++$16597f9d07f22afc$var$i)$16597f9d07f22afc$var$flt[$16597f9d07f22afc$var$i] = 8;
for(var $16597f9d07f22afc$var$i = 144; $16597f9d07f22afc$var$i < 256; ++$16597f9d07f22afc$var$i)$16597f9d07f22afc$var$flt[$16597f9d07f22afc$var$i] = 9;
for(var $16597f9d07f22afc$var$i = 256; $16597f9d07f22afc$var$i < 280; ++$16597f9d07f22afc$var$i)$16597f9d07f22afc$var$flt[$16597f9d07f22afc$var$i] = 7;
for(var $16597f9d07f22afc$var$i = 280; $16597f9d07f22afc$var$i < 288; ++$16597f9d07f22afc$var$i)$16597f9d07f22afc$var$flt[$16597f9d07f22afc$var$i] = 8;
// fixed distance tree
var $16597f9d07f22afc$var$fdt = new $16597f9d07f22afc$var$u8(32);
for(var $16597f9d07f22afc$var$i = 0; $16597f9d07f22afc$var$i < 32; ++$16597f9d07f22afc$var$i)$16597f9d07f22afc$var$fdt[$16597f9d07f22afc$var$i] = 5;
// fixed length map
var $16597f9d07f22afc$var$flm = /*#__PURE__*/ $16597f9d07f22afc$var$hMap($16597f9d07f22afc$var$flt, 9, 0), $16597f9d07f22afc$var$flrm = /*#__PURE__*/ $16597f9d07f22afc$var$hMap($16597f9d07f22afc$var$flt, 9, 1);
// fixed distance map
var $16597f9d07f22afc$var$fdm = /*#__PURE__*/ $16597f9d07f22afc$var$hMap($16597f9d07f22afc$var$fdt, 5, 0), $16597f9d07f22afc$var$fdrm = /*#__PURE__*/ $16597f9d07f22afc$var$hMap($16597f9d07f22afc$var$fdt, 5, 1);
// find max of array
var $16597f9d07f22afc$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $16597f9d07f22afc$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $16597f9d07f22afc$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $16597f9d07f22afc$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $16597f9d07f22afc$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $16597f9d07f22afc$var$u8(v.subarray(s, e));
};
var $16597f9d07f22afc$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $16597f9d07f22afc$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $16597f9d07f22afc$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $16597f9d07f22afc$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $16597f9d07f22afc$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $16597f9d07f22afc$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $16597f9d07f22afc$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $16597f9d07f22afc$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $16597f9d07f22afc$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $16597f9d07f22afc$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $16597f9d07f22afc$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $16597f9d07f22afc$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $16597f9d07f22afc$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $16597f9d07f22afc$var$flrm, dm = $16597f9d07f22afc$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $16597f9d07f22afc$var$bits(dat, pos, 31) + 257, hcLen = $16597f9d07f22afc$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $16597f9d07f22afc$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $16597f9d07f22afc$var$u8(tl);
                // code length tree
                var clt = new $16597f9d07f22afc$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$16597f9d07f22afc$var$clim[i]] = $16597f9d07f22afc$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $16597f9d07f22afc$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $16597f9d07f22afc$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$16597f9d07f22afc$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $16597f9d07f22afc$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $16597f9d07f22afc$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $16597f9d07f22afc$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $16597f9d07f22afc$var$max(lt);
                // max dist bits
                dbt = $16597f9d07f22afc$var$max(dt);
                lm = $16597f9d07f22afc$var$hMap(lt, lbt, 1);
                dm = $16597f9d07f22afc$var$hMap(dt, dbt, 1);
            } else $16597f9d07f22afc$var$err(1);
            if (pos > tbts) {
                if (noSt) $16597f9d07f22afc$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$16597f9d07f22afc$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $16597f9d07f22afc$var$err(0);
                break;
            }
            if (!c) $16597f9d07f22afc$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $16597f9d07f22afc$var$fleb[i];
                    add = $16597f9d07f22afc$var$bits(dat, pos, (1 << b) - 1) + $16597f9d07f22afc$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$16597f9d07f22afc$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $16597f9d07f22afc$var$err(3);
                pos += d & 15;
                var dt = $16597f9d07f22afc$var$fd[dsym];
                if (dsym > 3) {
                    var b = $16597f9d07f22afc$var$fdeb[dsym];
                    dt += $16597f9d07f22afc$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $16597f9d07f22afc$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $16597f9d07f22afc$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $16597f9d07f22afc$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $16597f9d07f22afc$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $16597f9d07f22afc$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $16597f9d07f22afc$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $16597f9d07f22afc$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $16597f9d07f22afc$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $16597f9d07f22afc$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $16597f9d07f22afc$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $16597f9d07f22afc$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $16597f9d07f22afc$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($16597f9d07f22afc$var$ln(n.l, l, d + 1), $16597f9d07f22afc$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $16597f9d07f22afc$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $16597f9d07f22afc$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $16597f9d07f22afc$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $16597f9d07f22afc$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $16597f9d07f22afc$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $16597f9d07f22afc$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $16597f9d07f22afc$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $16597f9d07f22afc$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $16597f9d07f22afc$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $16597f9d07f22afc$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $16597f9d07f22afc$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $16597f9d07f22afc$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $16597f9d07f22afc$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$16597f9d07f22afc$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $16597f9d07f22afc$var$clen(lf, $16597f9d07f22afc$var$flt) + $16597f9d07f22afc$var$clen(df, $16597f9d07f22afc$var$fdt) + eb;
    var dtlen = $16597f9d07f22afc$var$clen(lf, dlt) + $16597f9d07f22afc$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $16597f9d07f22afc$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $16597f9d07f22afc$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $16597f9d07f22afc$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $16597f9d07f22afc$var$hMap(dlt, mlb, 0), ll = dlt, dm = $16597f9d07f22afc$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $16597f9d07f22afc$var$hMap(lct, mlcb, 0);
        $16597f9d07f22afc$var$wbits(out, p, nlc - 257);
        $16597f9d07f22afc$var$wbits(out, p + 5, ndc - 1);
        $16597f9d07f22afc$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$16597f9d07f22afc$var$wbits(out, p + 3 * i, lct[$16597f9d07f22afc$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $16597f9d07f22afc$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $16597f9d07f22afc$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $16597f9d07f22afc$var$flm, ll = $16597f9d07f22afc$var$flt, dm = $16597f9d07f22afc$var$fdm, dl = $16597f9d07f22afc$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $16597f9d07f22afc$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $16597f9d07f22afc$var$wbits(out, p, sym >> 23 & 31), p += $16597f9d07f22afc$var$fleb[len];
            var dst = sym & 31;
            $16597f9d07f22afc$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $16597f9d07f22afc$var$wbits16(out, p, sym >> 5 & 8191), p += $16597f9d07f22afc$var$fdeb[dst];
        } else $16597f9d07f22afc$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $16597f9d07f22afc$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $16597f9d07f22afc$var$deo = /*#__PURE__*/ new $16597f9d07f22afc$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $16597f9d07f22afc$var$et = /*#__PURE__*/ new $16597f9d07f22afc$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $16597f9d07f22afc$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $16597f9d07f22afc$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $16597f9d07f22afc$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $16597f9d07f22afc$var$u16(32768), head = st.h || new $16597f9d07f22afc$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $16597f9d07f22afc$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $16597f9d07f22afc$var$u16(288), df = new $16597f9d07f22afc$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $16597f9d07f22afc$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $16597f9d07f22afc$var$revfl[l] << 18 | $16597f9d07f22afc$var$revfd[d];
                    var lin = $16597f9d07f22afc$var$revfl[l] & 31, din = $16597f9d07f22afc$var$revfd[d] & 31;
                    eb += $16597f9d07f22afc$var$fleb[lin] + $16597f9d07f22afc$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $16597f9d07f22afc$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $16597f9d07f22afc$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $16597f9d07f22afc$var$slc(o, 0, pre + $16597f9d07f22afc$var$shft(pos) + post);
};
// CRC32 table
var $16597f9d07f22afc$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $16597f9d07f22afc$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $16597f9d07f22afc$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $16597f9d07f22afc$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $16597f9d07f22afc$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $16597f9d07f22afc$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $16597f9d07f22afc$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $16597f9d07f22afc$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $16597f9d07f22afc$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $16597f9d07f22afc$var$ch = [];
// clone bufs
var $16597f9d07f22afc$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $16597f9d07f22afc$var$wrkr = function(fns, init, id, cb) {
    if (!$16597f9d07f22afc$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $16597f9d07f22afc$var$wcln(fns[i], fnStr, td_1);
        $16597f9d07f22afc$var$ch[id] = {
            c: $16597f9d07f22afc$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $16597f9d07f22afc$var$mrg({}, $16597f9d07f22afc$var$ch[id].e);
    return $16597f9d07f22afc$var$wk($16597f9d07f22afc$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $16597f9d07f22afc$var$cbfs(td), cb);
};
// base async inflate fn
var $16597f9d07f22afc$var$bInflt = function() {
    return [
        $16597f9d07f22afc$var$u8,
        $16597f9d07f22afc$var$u16,
        $16597f9d07f22afc$var$i32,
        $16597f9d07f22afc$var$fleb,
        $16597f9d07f22afc$var$fdeb,
        $16597f9d07f22afc$var$clim,
        $16597f9d07f22afc$var$fl,
        $16597f9d07f22afc$var$fd,
        $16597f9d07f22afc$var$flrm,
        $16597f9d07f22afc$var$fdrm,
        $16597f9d07f22afc$var$rev,
        $16597f9d07f22afc$var$ec,
        $16597f9d07f22afc$var$hMap,
        $16597f9d07f22afc$var$max,
        $16597f9d07f22afc$var$bits,
        $16597f9d07f22afc$var$bits16,
        $16597f9d07f22afc$var$shft,
        $16597f9d07f22afc$var$slc,
        $16597f9d07f22afc$var$err,
        $16597f9d07f22afc$var$inflt,
        $16597f9d07f22afc$export$90366d8b308ba94a,
        $16597f9d07f22afc$var$pbf,
        $16597f9d07f22afc$var$gopt
    ];
};
var $16597f9d07f22afc$var$bDflt = function() {
    return [
        $16597f9d07f22afc$var$u8,
        $16597f9d07f22afc$var$u16,
        $16597f9d07f22afc$var$i32,
        $16597f9d07f22afc$var$fleb,
        $16597f9d07f22afc$var$fdeb,
        $16597f9d07f22afc$var$clim,
        $16597f9d07f22afc$var$revfl,
        $16597f9d07f22afc$var$revfd,
        $16597f9d07f22afc$var$flm,
        $16597f9d07f22afc$var$flt,
        $16597f9d07f22afc$var$fdm,
        $16597f9d07f22afc$var$fdt,
        $16597f9d07f22afc$var$rev,
        $16597f9d07f22afc$var$deo,
        $16597f9d07f22afc$var$et,
        $16597f9d07f22afc$var$hMap,
        $16597f9d07f22afc$var$wbits,
        $16597f9d07f22afc$var$wbits16,
        $16597f9d07f22afc$var$hTree,
        $16597f9d07f22afc$var$ln,
        $16597f9d07f22afc$var$lc,
        $16597f9d07f22afc$var$clen,
        $16597f9d07f22afc$var$wfblk,
        $16597f9d07f22afc$var$wblk,
        $16597f9d07f22afc$var$shft,
        $16597f9d07f22afc$var$slc,
        $16597f9d07f22afc$var$dflt,
        $16597f9d07f22afc$var$dopt,
        $16597f9d07f22afc$export$21533ff51b8a0b4a,
        $16597f9d07f22afc$var$pbf
    ];
};
// gzip extra
var $16597f9d07f22afc$var$gze = function() {
    return [
        $16597f9d07f22afc$var$gzh,
        $16597f9d07f22afc$var$gzhl,
        $16597f9d07f22afc$var$wbytes,
        $16597f9d07f22afc$var$crc,
        $16597f9d07f22afc$var$crct
    ];
};
// gunzip extra
var $16597f9d07f22afc$var$guze = function() {
    return [
        $16597f9d07f22afc$var$gzs,
        $16597f9d07f22afc$var$gzl
    ];
};
// zlib extra
var $16597f9d07f22afc$var$zle = function() {
    return [
        $16597f9d07f22afc$var$zlh,
        $16597f9d07f22afc$var$wbytes,
        $16597f9d07f22afc$var$adler
    ];
};
// unzlib extra
var $16597f9d07f22afc$var$zule = function() {
    return [
        $16597f9d07f22afc$var$zls
    ];
};
// post buf
var $16597f9d07f22afc$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $16597f9d07f22afc$var$gopt = function(o) {
    return o && {
        out: o.size && new $16597f9d07f22afc$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $16597f9d07f22afc$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $16597f9d07f22afc$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $16597f9d07f22afc$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data[0]) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush(ev.data[1]);
    };
};
// async stream attach
var $16597f9d07f22afc$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $16597f9d07f22afc$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $16597f9d07f22afc$var$err(5);
        if (t) strm.ondata($16597f9d07f22afc$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        // can fail for cross-realm Uint8Array, but ok - only a small performance penalty
        w.postMessage([
            d,
            t = f
        ], d.buffer instanceof ArrayBuffer ? [
            d.buffer
        ] : []);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function(sync) {
        w.postMessage([
            0,
            sync
        ]);
    };
};
// read 2 bytes
var $16597f9d07f22afc$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $16597f9d07f22afc$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
// read 8 bytes
var $16597f9d07f22afc$var$b8 = function(d, b) {
    return $16597f9d07f22afc$var$b4(d, b) + $16597f9d07f22afc$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $16597f9d07f22afc$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $16597f9d07f22afc$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $16597f9d07f22afc$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $16597f9d07f22afc$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $16597f9d07f22afc$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $16597f9d07f22afc$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $16597f9d07f22afc$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $16597f9d07f22afc$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $16597f9d07f22afc$var$adler();
        h.p(o.dictionary);
        $16597f9d07f22afc$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $16597f9d07f22afc$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $16597f9d07f22afc$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $16597f9d07f22afc$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $16597f9d07f22afc$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $16597f9d07f22afc$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $16597f9d07f22afc$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($16597f9d07f22afc$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $16597f9d07f22afc$var$err(5);
        if (this.s.l) $16597f9d07f22afc$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $16597f9d07f22afc$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
        if (final) {
            // cleanup unneeded buffers/state to reduce memory usage
            this.s = this.o = {};
            this.b = $16597f9d07f22afc$var$et;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible. A separate DEFLATE stream may be concatenated
     *             with the current output after a sync flush.
     */ Deflate.prototype.flush = function(sync) {
        if (!this.ondata) $16597f9d07f22afc$var$err(5);
        if (this.s.l) $16597f9d07f22afc$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
        // could technically skip writing the type-0 block for (this.s.r & 7) == 0,
        // but the deterministic trailer (00 00 FF FF) is useful in some situations
        if (sync) {
            var c = new $16597f9d07f22afc$var$u8(6);
            c[0] = this.s.r >> 3;
            // write empty, non-final type-0 block
            var ep = $16597f9d07f22afc$var$wfblk(c, this.s.r, $16597f9d07f22afc$var$et);
            this.s.r = 0;
            this.ondata(c.subarray(0, ep >> 3), false);
        }
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $16597f9d07f22afc$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $16597f9d07f22afc$var$astrmify([
            $16597f9d07f22afc$var$bDflt,
            function() {
                return [
                    $16597f9d07f22afc$var$astrm,
                    $16597f9d07f22afc$export$ae157b6234afe138
                ];
            }
        ], this, $16597f9d07f22afc$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $16597f9d07f22afc$export$ae157b6234afe138(ev.data);
            onmessage = $16597f9d07f22afc$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $16597f9d07f22afc$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $16597f9d07f22afc$var$err(7);
    return $16597f9d07f22afc$var$cbify(data, opts, [
        $16597f9d07f22afc$var$bDflt
    ], function(ev) {
        return $16597f9d07f22afc$var$pbf($16597f9d07f22afc$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $16597f9d07f22afc$export$21533ff51b8a0b4a(data, opts) {
    return $16597f9d07f22afc$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $16597f9d07f22afc$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $16597f9d07f22afc$var$u8(32768);
        this.p = new $16597f9d07f22afc$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $16597f9d07f22afc$var$err(5);
        if (this.d) $16597f9d07f22afc$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $16597f9d07f22afc$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $16597f9d07f22afc$var$inflt(this.p, this.s, this.o);
        this.ondata($16597f9d07f22afc$var$slc(dt, bts, this.s.b), this.d);
        this.o = $16597f9d07f22afc$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $16597f9d07f22afc$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $16597f9d07f22afc$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $16597f9d07f22afc$var$astrmify([
            $16597f9d07f22afc$var$bInflt,
            function() {
                return [
                    $16597f9d07f22afc$var$astrm,
                    $16597f9d07f22afc$export$d1de70a877d6e43c
                ];
            }
        ], this, $16597f9d07f22afc$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $16597f9d07f22afc$export$d1de70a877d6e43c(ev.data);
            onmessage = $16597f9d07f22afc$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $16597f9d07f22afc$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $16597f9d07f22afc$var$err(7);
    return $16597f9d07f22afc$var$cbify(data, opts, [
        $16597f9d07f22afc$var$bInflt
    ], function(ev) {
        return $16597f9d07f22afc$var$pbf($16597f9d07f22afc$export$90366d8b308ba94a(ev.data[0], $16597f9d07f22afc$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $16597f9d07f22afc$export$90366d8b308ba94a(data, opts) {
    return $16597f9d07f22afc$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $16597f9d07f22afc$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $16597f9d07f22afc$var$crc();
        this.l = 0;
        this.v = 1;
        $16597f9d07f22afc$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $16597f9d07f22afc$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $16597f9d07f22afc$var$dopt(c, this.o, this.v && $16597f9d07f22afc$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $16597f9d07f22afc$var$gzh(raw, this.o), this.v = 0;
        if (f) $16597f9d07f22afc$var$wbytes(raw, raw.length - 8, this.c.d()), $16597f9d07f22afc$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible.
     */ Gzip.prototype.flush = function(sync) {
        $16597f9d07f22afc$export$ae157b6234afe138.prototype.flush.call(this, sync);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $16597f9d07f22afc$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $16597f9d07f22afc$var$astrmify([
            $16597f9d07f22afc$var$bDflt,
            $16597f9d07f22afc$var$gze,
            function() {
                return [
                    $16597f9d07f22afc$var$astrm,
                    $16597f9d07f22afc$export$ae157b6234afe138,
                    $16597f9d07f22afc$export$8e4b66d280bf8342
                ];
            }
        ], this, $16597f9d07f22afc$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $16597f9d07f22afc$export$8e4b66d280bf8342(ev.data);
            onmessage = $16597f9d07f22afc$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $16597f9d07f22afc$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $16597f9d07f22afc$var$err(7);
    return $16597f9d07f22afc$var$cbify(data, opts, [
        $16597f9d07f22afc$var$bDflt,
        $16597f9d07f22afc$var$gze,
        function() {
            return [
                $16597f9d07f22afc$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $16597f9d07f22afc$var$pbf($16597f9d07f22afc$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $16597f9d07f22afc$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $16597f9d07f22afc$var$crc(), l = data.length;
    c.p(data);
    var d = $16597f9d07f22afc$var$dopt(data, opts, $16597f9d07f22afc$var$gzhl(opts), 8), s = d.length;
    return $16597f9d07f22afc$var$gzh(d, opts), $16597f9d07f22afc$var$wbytes(d, s - 8, c.d()), $16597f9d07f22afc$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $16597f9d07f22afc$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $16597f9d07f22afc$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $16597f9d07f22afc$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $16597f9d07f22afc$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $16597f9d07f22afc$export$d1de70a877d6e43c.prototype.c.call(this, 0);
        // process concatenated GZIP
        if (this.s.f && !this.s.l) {
            this.v = $16597f9d07f22afc$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $16597f9d07f22afc$var$u8(0);
            this.push(new $16597f9d07f22afc$var$u8(0), final);
        } else if (final) $16597f9d07f22afc$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $16597f9d07f22afc$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $16597f9d07f22afc$var$astrmify([
            $16597f9d07f22afc$var$bInflt,
            $16597f9d07f22afc$var$guze,
            function() {
                return [
                    $16597f9d07f22afc$var$astrm,
                    $16597f9d07f22afc$export$d1de70a877d6e43c,
                    $16597f9d07f22afc$export$4cb607de6db70415
                ];
            }
        ], this, $16597f9d07f22afc$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $16597f9d07f22afc$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $16597f9d07f22afc$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $16597f9d07f22afc$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $16597f9d07f22afc$var$err(7);
    return $16597f9d07f22afc$var$cbify(data, opts, [
        $16597f9d07f22afc$var$bInflt,
        $16597f9d07f22afc$var$guze,
        function() {
            return [
                $16597f9d07f22afc$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $16597f9d07f22afc$var$pbf($16597f9d07f22afc$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $16597f9d07f22afc$export$c80456f7aaba691c(data, opts) {
    var st = $16597f9d07f22afc$var$gzs(data);
    if (st + 8 > data.length) $16597f9d07f22afc$var$err(6, 'invalid gzip data');
    return $16597f9d07f22afc$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $16597f9d07f22afc$var$u8($16597f9d07f22afc$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $16597f9d07f22afc$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $16597f9d07f22afc$var$adler();
        this.v = 1;
        $16597f9d07f22afc$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $16597f9d07f22afc$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $16597f9d07f22afc$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $16597f9d07f22afc$var$zlh(raw, this.o), this.v = 0;
        if (f) $16597f9d07f22afc$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible.
     */ Zlib.prototype.flush = function(sync) {
        $16597f9d07f22afc$export$ae157b6234afe138.prototype.flush.call(this, sync);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $16597f9d07f22afc$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $16597f9d07f22afc$var$astrmify([
            $16597f9d07f22afc$var$bDflt,
            $16597f9d07f22afc$var$zle,
            function() {
                return [
                    $16597f9d07f22afc$var$astrm,
                    $16597f9d07f22afc$export$ae157b6234afe138,
                    $16597f9d07f22afc$export$4187ccf2467013b9
                ];
            }
        ], this, $16597f9d07f22afc$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $16597f9d07f22afc$export$4187ccf2467013b9(ev.data);
            onmessage = $16597f9d07f22afc$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $16597f9d07f22afc$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $16597f9d07f22afc$var$err(7);
    return $16597f9d07f22afc$var$cbify(data, opts, [
        $16597f9d07f22afc$var$bDflt,
        $16597f9d07f22afc$var$zle,
        function() {
            return [
                $16597f9d07f22afc$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $16597f9d07f22afc$var$pbf($16597f9d07f22afc$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $16597f9d07f22afc$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $16597f9d07f22afc$var$adler();
    a.p(data);
    var d = $16597f9d07f22afc$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $16597f9d07f22afc$var$zlh(d, opts), $16597f9d07f22afc$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $16597f9d07f22afc$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $16597f9d07f22afc$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $16597f9d07f22afc$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($16597f9d07f22afc$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $16597f9d07f22afc$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $16597f9d07f22afc$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $16597f9d07f22afc$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $16597f9d07f22afc$var$astrmify([
            $16597f9d07f22afc$var$bInflt,
            $16597f9d07f22afc$var$zule,
            function() {
                return [
                    $16597f9d07f22afc$var$astrm,
                    $16597f9d07f22afc$export$d1de70a877d6e43c,
                    $16597f9d07f22afc$export$af2424f875ff1b17
                ];
            }
        ], this, $16597f9d07f22afc$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $16597f9d07f22afc$export$af2424f875ff1b17(ev.data);
            onmessage = $16597f9d07f22afc$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $16597f9d07f22afc$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $16597f9d07f22afc$var$err(7);
    return $16597f9d07f22afc$var$cbify(data, opts, [
        $16597f9d07f22afc$var$bInflt,
        $16597f9d07f22afc$var$zule,
        function() {
            return [
                $16597f9d07f22afc$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $16597f9d07f22afc$var$pbf($16597f9d07f22afc$export$9ec8134f0f1b9fc6(ev.data[0], $16597f9d07f22afc$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $16597f9d07f22afc$export$9ec8134f0f1b9fc6(data, opts) {
    return $16597f9d07f22afc$var$inflt(data.subarray($16597f9d07f22afc$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $16597f9d07f22afc$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $16597f9d07f22afc$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $16597f9d07f22afc$export$4cb607de6db70415;
        this.I = $16597f9d07f22afc$export$d1de70a877d6e43c;
        this.Z = $16597f9d07f22afc$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $16597f9d07f22afc$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $16597f9d07f22afc$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $16597f9d07f22afc$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $16597f9d07f22afc$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $16597f9d07f22afc$export$d5adcdd968132151;
        this.I = $16597f9d07f22afc$export$fff8358d6dbaa9cc;
        this.Z = $16597f9d07f22afc$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $16597f9d07f22afc$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $16597f9d07f22afc$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $16597f9d07f22afc$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $16597f9d07f22afc$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $16597f9d07f22afc$export$cae1ce83fe4a1782(data, opts, cb) : $16597f9d07f22afc$export$ca7cbb494e731274(data, opts, cb);
}
function $16597f9d07f22afc$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $16597f9d07f22afc$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $16597f9d07f22afc$export$90366d8b308ba94a(data, opts) : $16597f9d07f22afc$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $16597f9d07f22afc$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $16597f9d07f22afc$var$mrg(o, val[1]), val = val[0];
        if (ArrayBuffer.isView(val)) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $16597f9d07f22afc$var$u8(0),
                op
            ];
            $16597f9d07f22afc$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $16597f9d07f22afc$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $16597f9d07f22afc$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $16597f9d07f22afc$var$tds = 0;
try {
    $16597f9d07f22afc$var$td.decode($16597f9d07f22afc$var$et, {
        stream: true
    });
    $16597f9d07f22afc$var$tds = 1;
} catch (e) {}
// decode UTF8
var $16597f9d07f22afc$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $16597f9d07f22afc$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $16597f9d07f22afc$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($16597f9d07f22afc$var$tds) this.t = new TextDecoder();
        else this.p = $16597f9d07f22afc$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $16597f9d07f22afc$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $16597f9d07f22afc$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $16597f9d07f22afc$var$err(4);
        var dat = new $16597f9d07f22afc$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $16597f9d07f22afc$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $16597f9d07f22afc$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $16597f9d07f22afc$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $16597f9d07f22afc$var$err(5);
        if (this.d) $16597f9d07f22afc$var$err(4);
        this.ondata($16597f9d07f22afc$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $16597f9d07f22afc$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $16597f9d07f22afc$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($16597f9d07f22afc$var$te) return $16597f9d07f22afc$var$te.encode(str);
    var l = str.length;
    var ar = new $16597f9d07f22afc$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $16597f9d07f22afc$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $16597f9d07f22afc$var$slc(ar, 0, ai);
}
function $16597f9d07f22afc$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($16597f9d07f22afc$var$td) return $16597f9d07f22afc$var$td.decode(dat);
    else {
        var _a = $16597f9d07f22afc$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $16597f9d07f22afc$var$err(8);
        return s;
    }
}
// deflate bit flag
var $16597f9d07f22afc$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $16597f9d07f22afc$var$slzh = function(d, b) {
    return b + 30 + $16597f9d07f22afc$var$b2(d, b + 26) + $16597f9d07f22afc$var$b2(d, b + 28);
};
// read zip header
var $16597f9d07f22afc$var$zh = function(d, b, z) {
    var fnl = $16597f9d07f22afc$var$b2(d, b + 28), efl = $16597f9d07f22afc$var$b2(d, b + 30), fn = $16597f9d07f22afc$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($16597f9d07f22afc$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl;
    var _a = $16597f9d07f22afc$var$z64hs(d, es, efl, z, $16597f9d07f22afc$var$b4(d, b + 20), $16597f9d07f22afc$var$b4(d, b + 24), $16597f9d07f22afc$var$b4(d, b + 42)), sc = _a[0], su = _a[1], off = _a[2];
    return [
        $16597f9d07f22afc$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + efl + $16597f9d07f22afc$var$b2(d, b + 32),
        off
    ];
};
// read zip64 header sizes
var $16597f9d07f22afc$var$z64hs = function(d, b, l, z, sc, su, off) {
    var nsc = sc == 4294967295, nsu = su == 4294967295, noff = off == 4294967295, e = b + l;
    var nf = nsc + nsu + noff;
    if (z && nf) {
        for(; b + 4 < e; b += 4 + $16597f9d07f22afc$var$b2(d, b + 2)){
            if ($16597f9d07f22afc$var$b2(d, b) == 1) return [
                nsc ? $16597f9d07f22afc$var$b8(d, b + 4 + 8 * nsu) : sc,
                nsu ? $16597f9d07f22afc$var$b8(d, b + 4) : su,
                noff ? $16597f9d07f22afc$var$b8(d, b + 4 + 8 * (nsu + nsc)) : off,
                1
            ];
        }
        // z == 2 for unknown whether or not zip64
        if (z < 2) $16597f9d07f22afc$var$err(13);
    }
    return [
        sc,
        su,
        off,
        0
    ];
};
// extra field length
var $16597f9d07f22afc$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $16597f9d07f22afc$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $16597f9d07f22afc$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $16597f9d07f22afc$var$exfl(ex);
    $16597f9d07f22afc$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $16597f9d07f22afc$var$err(10);
    $16597f9d07f22afc$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $16597f9d07f22afc$var$wbytes(d, b, f.crc);
        $16597f9d07f22afc$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $16597f9d07f22afc$var$wbytes(d, b + 8, f.size);
    }
    $16597f9d07f22afc$var$wbytes(d, b + 12, fl);
    $16597f9d07f22afc$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $16597f9d07f22afc$var$wbytes(d, b, col);
        $16597f9d07f22afc$var$wbytes(d, b + 6, f.attrs);
        $16597f9d07f22afc$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $16597f9d07f22afc$var$wbytes(d, b, +k);
        $16597f9d07f22afc$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $16597f9d07f22afc$var$wzf = function(o, b, c, d, e) {
    $16597f9d07f22afc$var$wbytes(o, b, 0x6054B50); // skip disk
    $16597f9d07f22afc$var$wbytes(o, b + 8, c);
    $16597f9d07f22afc$var$wbytes(o, b + 10, c);
    $16597f9d07f22afc$var$wbytes(o, b + 12, d);
    $16597f9d07f22afc$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $16597f9d07f22afc$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $16597f9d07f22afc$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $16597f9d07f22afc$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        // we shouldn't really do this cast, but properly handling ArrayBufferLike
        // makes the API unergonomic with Buffer
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $16597f9d07f22afc$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $16597f9d07f22afc$export$2b25194e1767ea06.call(this, filename);
        this.d = new $16597f9d07f22afc$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $16597f9d07f22afc$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $16597f9d07f22afc$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $16597f9d07f22afc$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $16597f9d07f22afc$export$2b25194e1767ea06.call(this, filename);
        this.d = new $16597f9d07f22afc$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $16597f9d07f22afc$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $16597f9d07f22afc$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $16597f9d07f22afc$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $16597f9d07f22afc$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($16597f9d07f22afc$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $16597f9d07f22afc$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $16597f9d07f22afc$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $16597f9d07f22afc$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($16597f9d07f22afc$var$err(11, 0, 1), null, false);
            var header = new $16597f9d07f22afc$var$u8(hl_1);
            $16597f9d07f22afc$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $16597f9d07f22afc$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $16597f9d07f22afc$var$u8(16);
                        $16597f9d07f22afc$var$wbytes(dd, 0, 0x8074B50);
                        $16597f9d07f22afc$var$wbytes(dd, 4, file.crc);
                        $16597f9d07f22afc$var$wbytes(dd, 8, cl_1);
                        $16597f9d07f22afc$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($16597f9d07f22afc$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $16597f9d07f22afc$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $16597f9d07f22afc$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $16597f9d07f22afc$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $16597f9d07f22afc$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $16597f9d07f22afc$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $16597f9d07f22afc$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $16597f9d07f22afc$var$err(7);
    var r = {};
    $16597f9d07f22afc$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $16597f9d07f22afc$var$mt(function() {
            cb(a, b);
        });
    };
    $16597f9d07f22afc$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $16597f9d07f22afc$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $16597f9d07f22afc$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $16597f9d07f22afc$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $16597f9d07f22afc$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $16597f9d07f22afc$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $16597f9d07f22afc$var$crc(), size = file.length;
        c.p(file);
        var f = $16597f9d07f22afc$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $16597f9d07f22afc$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $16597f9d07f22afc$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $16597f9d07f22afc$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($16597f9d07f22afc$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $16597f9d07f22afc$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($16597f9d07f22afc$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $16597f9d07f22afc$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $16597f9d07f22afc$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $16597f9d07f22afc$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $16597f9d07f22afc$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $16597f9d07f22afc$var$exfl(p.extra);
        if (s > 65535) $16597f9d07f22afc$var$err(11);
        var d = compression ? $16597f9d07f22afc$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $16597f9d07f22afc$var$crc();
        c.p(file);
        files.push($16597f9d07f22afc$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $16597f9d07f22afc$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $16597f9d07f22afc$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $16597f9d07f22afc$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $16597f9d07f22afc$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $16597f9d07f22afc$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $16597f9d07f22afc$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(chunk, final) {
        // same as ZipPassThrough: cast to retain Buffer ergonomics
        this.ondata(null, chunk, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $16597f9d07f22afc$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $16597f9d07f22afc$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(chunk, final) {
        try {
            this.i.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $16597f9d07f22afc$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $16597f9d07f22afc$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $16597f9d07f22afc$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(chunk, final) {
        if (this.i.terminate) chunk = $16597f9d07f22afc$var$slc(chunk, 0);
        this.i.push(chunk, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $16597f9d07f22afc$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $16597f9d07f22afc$export$93f81d5bbbb7c6bf
        };
        this.p = $16597f9d07f22afc$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $16597f9d07f22afc$var$err(5);
        if (!this.p) $16597f9d07f22afc$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $16597f9d07f22afc$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var sig = $16597f9d07f22afc$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $16597f9d07f22afc$var$b2(buf, i + 6), cmp_1 = $16597f9d07f22afc$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $16597f9d07f22afc$var$b2(buf, i + 26), es = $16597f9d07f22afc$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var lsc = $16597f9d07f22afc$var$b4(buf, i + 18), lsu = $16597f9d07f22afc$var$b4(buf, i + 22);
                        var fn_1 = $16597f9d07f22afc$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        var _a = $16597f9d07f22afc$var$z64hs(buf, i, es, 2, lsc, lsu, 0), sc_1 = _a[0], su_1 = _a[1], z64 = _a[3];
                        if (dd) sc_1 = -1 - z64;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $16597f9d07f22afc$var$err(5);
                                if (!sc_1) file_1.ondata(null, $16597f9d07f22afc$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($16597f9d07f22afc$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($16597f9d07f22afc$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $16597f9d07f22afc$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($16597f9d07f22afc$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $16597f9d07f22afc$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $16597f9d07f22afc$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $16597f9d07f22afc$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $16597f9d07f22afc$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $16597f9d07f22afc$var$mt(function() {
            cb(a, b);
        });
    };
    $16597f9d07f22afc$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $16597f9d07f22afc$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($16597f9d07f22afc$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $16597f9d07f22afc$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $16597f9d07f22afc$var$b4(data, e + 16);
        var z = $16597f9d07f22afc$var$b4(data, e - 20) == 0x7064B50;
        if (z) {
            var ze = $16597f9d07f22afc$var$b4(data, e - 12);
            z = $16597f9d07f22afc$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $16597f9d07f22afc$var$b4(data, ze + 32);
                o = $16597f9d07f22afc$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $16597f9d07f22afc$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $16597f9d07f22afc$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $16597f9d07f22afc$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $16597f9d07f22afc$export$90366d8b308ba94a(infl, {
                            out: new $16597f9d07f22afc$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($16597f9d07f22afc$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($16597f9d07f22afc$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $16597f9d07f22afc$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $16597f9d07f22afc$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $16597f9d07f22afc$var$err(13);
    var c = $16597f9d07f22afc$var$b2(data, e + 8);
    if (!c) return {};
    var o = $16597f9d07f22afc$var$b4(data, e + 16);
    var z = $16597f9d07f22afc$var$b4(data, e - 20) == 0x7064B50;
    if (z) {
        var ze = $16597f9d07f22afc$var$b4(data, e - 12);
        z = $16597f9d07f22afc$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $16597f9d07f22afc$var$b4(data, ze + 32);
            o = $16597f9d07f22afc$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $16597f9d07f22afc$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $16597f9d07f22afc$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $16597f9d07f22afc$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $16597f9d07f22afc$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $16597f9d07f22afc$var$u8(su)
            });
            else $16597f9d07f22afc$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}


var $9bb086d904f27bd2$exports = {};
var $4ce4cce90870af69$exports = {};
function $4ce4cce90870af69$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$4ce4cce90870af69$exports = $4ce4cce90870af69$var$_arrayWithHoles, $4ce4cce90870af69$exports.__esModule = true, $4ce4cce90870af69$exports["default"] = $4ce4cce90870af69$exports;


var $abd4e03692af6988$exports = {};
function $abd4e03692af6988$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$abd4e03692af6988$exports = $abd4e03692af6988$var$_iterableToArrayLimit, $abd4e03692af6988$exports.__esModule = true, $abd4e03692af6988$exports["default"] = $abd4e03692af6988$exports;


var $0aec1aa4e05b18c4$exports = {};
var $4037aab7a55656ef$exports = {};
function $4037aab7a55656ef$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$4037aab7a55656ef$exports = $4037aab7a55656ef$var$_arrayLikeToArray, $4037aab7a55656ef$exports.__esModule = true, $4037aab7a55656ef$exports["default"] = $4037aab7a55656ef$exports;


function $0aec1aa4e05b18c4$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $4037aab7a55656ef$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $4037aab7a55656ef$exports(r, a) : void 0;
    }
}
$0aec1aa4e05b18c4$exports = $0aec1aa4e05b18c4$var$_unsupportedIterableToArray, $0aec1aa4e05b18c4$exports.__esModule = true, $0aec1aa4e05b18c4$exports["default"] = $0aec1aa4e05b18c4$exports;


var $66cedf102cf88611$exports = {};
function $66cedf102cf88611$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$66cedf102cf88611$exports = $66cedf102cf88611$var$_nonIterableRest, $66cedf102cf88611$exports.__esModule = true, $66cedf102cf88611$exports["default"] = $66cedf102cf88611$exports;


function $9bb086d904f27bd2$var$_slicedToArray(r, e) {
    return $4ce4cce90870af69$exports(r) || $abd4e03692af6988$exports(r, e) || $0aec1aa4e05b18c4$exports(r, e) || $66cedf102cf88611$exports();
}
$9bb086d904f27bd2$exports = $9bb086d904f27bd2$var$_slicedToArray, $9bb086d904f27bd2$exports.__esModule = true, $9bb086d904f27bd2$exports["default"] = $9bb086d904f27bd2$exports;


function $079437e7273dd001$export$2f872c0f2117be69(bytes, encoding = 'utf8') {
    const decoder = new TextDecoder(encoding);
    return decoder.decode(bytes);
}
const $079437e7273dd001$var$encoder = new TextEncoder();
function $079437e7273dd001$export$c564cdbbe6da493(str) {
    return $079437e7273dd001$var$encoder.encode(str);
}


const $50657fe243c9e527$var$defaultByteLength = 8192;
const $50657fe243c9e527$var$hostBigEndian = (()=>{
    const array = new Uint8Array(4);
    const view = new Uint32Array(array.buffer);
    return !((view[0] = 1) & array[0]);
})();
const $50657fe243c9e527$var$typedArrays = {
    int8: globalThis.Int8Array,
    uint8: globalThis.Uint8Array,
    int16: globalThis.Int16Array,
    uint16: globalThis.Uint16Array,
    int32: globalThis.Int32Array,
    uint32: globalThis.Uint32Array,
    uint64: globalThis.BigUint64Array,
    int64: globalThis.BigInt64Array,
    float32: globalThis.Float32Array,
    float64: globalThis.Float64Array
};
class $50657fe243c9e527$export$6b4c32f3d5b8738a {
    /**
     * Reference to the internal ArrayBuffer object.
     */ buffer;
    /**
     * Byte length of the internal ArrayBuffer.
     */ byteLength;
    /**
     * Byte offset of the internal ArrayBuffer.
     */ byteOffset;
    /**
     * Byte length of the internal ArrayBuffer.
     */ length;
    /**
     * The current offset of the buffer's pointer.
     */ offset;
    lastWrittenByte;
    littleEndian;
    _data;
    _mark;
    _marks;
    /**
     * Create a new IOBuffer.
     * @param data - The data to construct the IOBuffer with.
     * If data is a number, it will be the new buffer's length<br>
     * If data is `undefined`, the buffer will be initialized with a default length of 8Kb<br>
     * If data is an ArrayBuffer, SharedArrayBuffer, an ArrayBufferView (Typed Array), an IOBuffer instance,
     * or a Node.js Buffer, a view will be created over the underlying ArrayBuffer.
     * @param options - An object for the options.
     * @returns A new IOBuffer instance.
     */ constructor(data = $50657fe243c9e527$var$defaultByteLength, options = {}){
        let dataIsGiven = false;
        if (typeof data === 'number') data = new ArrayBuffer(data);
        else {
            dataIsGiven = true;
            this.lastWrittenByte = data.byteLength;
        }
        const offset = options.offset ? options.offset >>> 0 : 0;
        const byteLength = data.byteLength - offset;
        let dvOffset = offset;
        if (ArrayBuffer.isView(data) || data instanceof $50657fe243c9e527$export$6b4c32f3d5b8738a) {
            if (data.byteLength !== data.buffer.byteLength) dvOffset = data.byteOffset + offset;
            data = data.buffer;
        }
        if (dataIsGiven) this.lastWrittenByte = byteLength;
        else this.lastWrittenByte = 0;
        this.buffer = data;
        this.length = byteLength;
        this.byteLength = byteLength;
        this.byteOffset = dvOffset;
        this.offset = 0;
        this.littleEndian = true;
        this._data = new DataView(this.buffer, dvOffset, byteLength);
        this._mark = 0;
        this._marks = [];
    }
    /**
     * Checks if the memory allocated to the buffer is sufficient to store more
     * bytes after the offset.
     * @param byteLength - The needed memory in bytes.
     * @returns `true` if there is sufficient space and `false` otherwise.
     */ available(byteLength = 1) {
        return this.offset + byteLength <= this.length;
    }
    /**
     * Check if little-endian mode is used for reading and writing multi-byte
     * values.
     * @returns `true` if little-endian mode is used, `false` otherwise.
     */ isLittleEndian() {
        return this.littleEndian;
    }
    /**
     * Set little-endian mode for reading and writing multi-byte values.
     * @returns This.
     */ setLittleEndian() {
        this.littleEndian = true;
        return this;
    }
    /**
     * Check if big-endian mode is used for reading and writing multi-byte values.
     * @returns `true` if big-endian mode is used, `false` otherwise.
     */ isBigEndian() {
        return !this.littleEndian;
    }
    /**
     * Switches to big-endian mode for reading and writing multi-byte values.
     * @returns This.
     */ setBigEndian() {
        this.littleEndian = false;
        return this;
    }
    /**
     * Move the pointer n bytes forward.
     * @param n - Number of bytes to skip.
     * @returns This.
     */ skip(n = 1) {
        this.offset += n;
        return this;
    }
    /**
     * Move the pointer n bytes backward.
     * @param n - Number of bytes to move back.
     * @returns This.
     */ back(n = 1) {
        this.offset -= n;
        return this;
    }
    /**
     * Move the pointer to the given offset.
     * @param offset - The offset to move to.
     * @returns This.
     */ seek(offset) {
        this.offset = offset;
        return this;
    }
    /**
     * Store the current pointer offset.
     * @see {@link IOBuffer#reset}
     * @returns This.
     */ mark() {
        this._mark = this.offset;
        return this;
    }
    /**
     * Move the pointer back to the last pointer offset set by mark.
     * @see {@link IOBuffer#mark}
     * @returns This.
     */ reset() {
        this.offset = this._mark;
        return this;
    }
    /**
     * Push the current pointer offset to the mark stack.
     * @see {@link IOBuffer#popMark}
     * @returns This.
     */ pushMark() {
        this._marks.push(this.offset);
        return this;
    }
    /**
     * Pop the last pointer offset from the mark stack, and set the current
     * pointer offset to the popped value.
     * @see {@link IOBuffer#pushMark}
     * @returns This.
     */ popMark() {
        const offset = this._marks.pop();
        if (offset === undefined) throw new Error('Mark stack empty');
        this.seek(offset);
        return this;
    }
    /**
     * Move the pointer offset back to 0.
     * @returns This.
     */ rewind() {
        this.offset = 0;
        return this;
    }
    /**
     * Make sure the buffer has sufficient memory to write a given byteLength at
     * the current pointer offset.
     * If the buffer's memory is insufficient, this method will create a new
     * buffer (a copy) with a length that is twice (byteLength + current offset).
     * @param byteLength - The needed memory in bytes.
     * @returns This.
     */ ensureAvailable(byteLength = 1) {
        if (!this.available(byteLength)) {
            const lengthNeeded = this.offset + byteLength;
            const newLength = lengthNeeded * 2;
            const newArray = new Uint8Array(newLength);
            newArray.set(new Uint8Array(this.buffer));
            this.buffer = newArray.buffer;
            this.length = newLength;
            this.byteLength = newLength;
            this._data = new DataView(this.buffer);
        }
        return this;
    }
    /**
     * Read a byte and return false if the byte's value is 0, or true otherwise.
     * Moves pointer forward by one byte.
     * @returns The read boolean.
     */ readBoolean() {
        return this.readUint8() !== 0;
    }
    /**
     * Read a signed 8-bit integer and move pointer forward by 1 byte.
     * @returns The read byte.
     */ readInt8() {
        return this._data.getInt8(this.offset++);
    }
    /**
     * Read an unsigned 8-bit integer and move pointer forward by 1 byte.
     * @returns The read byte.
     */ readUint8() {
        return this._data.getUint8(this.offset++);
    }
    /**
     * Alias for {@link IOBuffer#readUint8}.
     * @returns The read byte.
     */ readByte() {
        return this.readUint8();
    }
    /**
     * Read `n` bytes and move pointer forward by `n` bytes.
     * @param n - Number of bytes to read.
     * @returns The read bytes.
     */ readBytes(n = 1) {
        return this.readArray(n, 'uint8');
    }
    /**
     * Creates an array of corresponding to the type `type` and size `size`.
     * For example type `uint8` will create a `Uint8Array`.
     * @param size - size of the resulting array
     * @param type - number type of elements to read
     * @returns The read array.
     */ readArray(size, type) {
        const bytes = $50657fe243c9e527$var$typedArrays[type].BYTES_PER_ELEMENT * size;
        const offset = this.byteOffset + this.offset;
        const slice = this.buffer.slice(offset, offset + bytes);
        if (this.littleEndian === $50657fe243c9e527$var$hostBigEndian && type !== 'uint8' && type !== 'int8') {
            const slice = new Uint8Array(this.buffer.slice(offset, offset + bytes));
            slice.reverse();
            const returnArray = new $50657fe243c9e527$var$typedArrays[type](slice.buffer);
            this.offset += bytes;
            returnArray.reverse();
            return returnArray;
        }
        const returnArray = new $50657fe243c9e527$var$typedArrays[type](slice);
        this.offset += bytes;
        return returnArray;
    }
    /**
     * Read a 16-bit signed integer and move pointer forward by 2 bytes.
     * @returns The read value.
     */ readInt16() {
        const value = this._data.getInt16(this.offset, this.littleEndian);
        this.offset += 2;
        return value;
    }
    /**
     * Read a 16-bit unsigned integer and move pointer forward by 2 bytes.
     * @returns The read value.
     */ readUint16() {
        const value = this._data.getUint16(this.offset, this.littleEndian);
        this.offset += 2;
        return value;
    }
    /**
     * Read a 32-bit signed integer and move pointer forward by 4 bytes.
     * @returns The read value.
     */ readInt32() {
        const value = this._data.getInt32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    /**
     * Read a 32-bit unsigned integer and move pointer forward by 4 bytes.
     * @returns The read value.
     */ readUint32() {
        const value = this._data.getUint32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    /**
     * Read a 32-bit floating number and move pointer forward by 4 bytes.
     * @returns The read value.
     */ readFloat32() {
        const value = this._data.getFloat32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    /**
     * Read a 64-bit floating number and move pointer forward by 8 bytes.
     * @returns The read value.
     */ readFloat64() {
        const value = this._data.getFloat64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    /**
     * Read a 64-bit signed integer number and move pointer forward by 8 bytes.
     * @returns The read value.
     */ readBigInt64() {
        const value = this._data.getBigInt64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    /**
     * Read a 64-bit unsigned integer number and move pointer forward by 8 bytes.
     * @returns The read value.
     */ readBigUint64() {
        const value = this._data.getBigUint64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    /**
     * Read a 1-byte ASCII character and move pointer forward by 1 byte.
     * @returns The read character.
     */ readChar() {
        // eslint-disable-next-line unicorn/prefer-code-point
        return String.fromCharCode(this.readInt8());
    }
    /**
     * Read `n` 1-byte ASCII characters and move pointer forward by `n` bytes.
     * @param n - Number of characters to read.
     * @returns The read characters.
     */ readChars(n = 1) {
        let result = '';
        for(let i = 0; i < n; i++)result += this.readChar();
        return result;
    }
    /**
     * Read the next `n` bytes, return a UTF-8 decoded string and move pointer
     * forward by `n` bytes.
     * @param n - Number of bytes to read.
     * @returns The decoded string.
     */ readUtf8(n = 1) {
        return (0, $079437e7273dd001$export$2f872c0f2117be69)(this.readBytes(n));
    }
    /**
     * Read the next `n` bytes, return a string decoded with `encoding` and move pointer
     * forward by `n` bytes.
     * If no encoding is passed, the function is equivalent to @see {@link IOBuffer#readUtf8}
     * @param n - Number of bytes to read.
     * @param encoding - The encoding to use. Default is 'utf8'.
     * @returns The decoded string.
     */ decodeText(n = 1, encoding = 'utf8') {
        return (0, $079437e7273dd001$export$2f872c0f2117be69)(this.readBytes(n), encoding);
    }
    /**
     * Write 0xff if the passed value is truthy, 0x00 otherwise and move pointer
     * forward by 1 byte.
     * @param value - The value to write.
     * @returns This.
     */ writeBoolean(value) {
        this.writeUint8(value ? 0xff : 0x00);
        return this;
    }
    /**
     * Write `value` as an 8-bit signed integer and move pointer forward by 1 byte.
     * @param value - The value to write.
     * @returns This.
     */ writeInt8(value) {
        this.ensureAvailable(1);
        this._data.setInt8(this.offset++, value);
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as an 8-bit unsigned integer and move pointer forward by 1
     * byte.
     * @param value - The value to write.
     * @returns This.
     */ writeUint8(value) {
        this.ensureAvailable(1);
        this._data.setUint8(this.offset++, value);
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * An alias for {@link IOBuffer#writeUint8}.
     * @param value - The value to write.
     * @returns This.
     */ writeByte(value) {
        return this.writeUint8(value);
    }
    /**
     * Write all elements of `bytes` as uint8 values and move pointer forward by
     * `bytes.length` bytes.
     * @param bytes - The array of bytes to write.
     * @returns This.
     */ writeBytes(bytes) {
        this.ensureAvailable(bytes.length);
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < bytes.length; i++)this._data.setUint8(this.offset++, bytes[i]);
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 16-bit signed integer and move pointer forward by 2
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeInt16(value) {
        this.ensureAvailable(2);
        this._data.setInt16(this.offset, value, this.littleEndian);
        this.offset += 2;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 16-bit unsigned integer and move pointer forward by 2
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeUint16(value) {
        this.ensureAvailable(2);
        this._data.setUint16(this.offset, value, this.littleEndian);
        this.offset += 2;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 32-bit signed integer and move pointer forward by 4
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeInt32(value) {
        this.ensureAvailable(4);
        this._data.setInt32(this.offset, value, this.littleEndian);
        this.offset += 4;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 32-bit unsigned integer and move pointer forward by 4
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeUint32(value) {
        this.ensureAvailable(4);
        this._data.setUint32(this.offset, value, this.littleEndian);
        this.offset += 4;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 32-bit floating number and move pointer forward by 4
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeFloat32(value) {
        this.ensureAvailable(4);
        this._data.setFloat32(this.offset, value, this.littleEndian);
        this.offset += 4;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 64-bit floating number and move pointer forward by 8
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeFloat64(value) {
        this.ensureAvailable(8);
        this._data.setFloat64(this.offset, value, this.littleEndian);
        this.offset += 8;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 64-bit signed bigint and move pointer forward by 8
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeBigInt64(value) {
        this.ensureAvailable(8);
        this._data.setBigInt64(this.offset, value, this.littleEndian);
        this.offset += 8;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 64-bit unsigned bigint and move pointer forward by 8
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeBigUint64(value) {
        this.ensureAvailable(8);
        this._data.setBigUint64(this.offset, value, this.littleEndian);
        this.offset += 8;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write the charCode of `str`'s first character as an 8-bit unsigned integer
     * and move pointer forward by 1 byte.
     * @param str - The character to write.
     * @returns This.
     */ writeChar(str) {
        // eslint-disable-next-line unicorn/prefer-code-point
        return this.writeUint8(str.charCodeAt(0));
    }
    /**
     * Write the charCodes of all `str`'s characters as 8-bit unsigned integers
     * and move pointer forward by `str.length` bytes.
     * @param str - The characters to write.
     * @returns This.
     */ writeChars(str) {
        for(let i = 0; i < str.length; i++)// eslint-disable-next-line unicorn/prefer-code-point
        this.writeUint8(str.charCodeAt(i));
        return this;
    }
    /**
     * UTF-8 encode and write `str` to the current pointer offset and move pointer
     * forward according to the encoded length.
     * @param str - The string to write.
     * @returns This.
     */ writeUtf8(str) {
        return this.writeBytes((0, $079437e7273dd001$export$c564cdbbe6da493)(str));
    }
    /**
     * Export a Uint8Array view of the internal buffer.
     * The view starts at the byte offset and its length
     * is calculated to stop at the last written byte or the original length.
     * @returns A new Uint8Array view.
     */ toArray() {
        return new Uint8Array(this.buffer, this.byteOffset, this.lastWrittenByte);
    }
    /**
     *  Get the total number of bytes written so far, regardless of the current offset.
     * @returns - Total number of bytes.
     */ getWrittenByteLength() {
        return this.lastWrittenByte - this.byteOffset;
    }
    /**
     * Update the last written byte offset
     * @private
     */ _updateLastWrittenByte() {
        if (this.offset > this.lastWrittenByte) this.lastWrittenByte = this.offset;
    }
}


/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */ // (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const $44d791503925dde9$var$Z_FIXED$1 = 4;
//const Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ const $44d791503925dde9$var$Z_BINARY = 0;
const $44d791503925dde9$var$Z_TEXT = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const $44d791503925dde9$var$Z_UNKNOWN$1 = 2;
/*============================================================================*/ function $44d791503925dde9$var$zero$1(buf) {
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
const $44d791503925dde9$var$STORED_BLOCK = 0;
const $44d791503925dde9$var$STATIC_TREES = 1;
const $44d791503925dde9$var$DYN_TREES = 2;
/* The three kinds of block type */ const $44d791503925dde9$var$MIN_MATCH$1 = 3;
const $44d791503925dde9$var$MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ const $44d791503925dde9$var$LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $44d791503925dde9$var$LITERALS$1 = 256;
/* number of literal bytes 0..255 */ const $44d791503925dde9$var$L_CODES$1 = $44d791503925dde9$var$LITERALS$1 + 1 + $44d791503925dde9$var$LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ const $44d791503925dde9$var$D_CODES$1 = 30;
/* number of distance codes */ const $44d791503925dde9$var$BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ const $44d791503925dde9$var$HEAP_SIZE$1 = 2 * $44d791503925dde9$var$L_CODES$1 + 1;
/* maximum heap size */ const $44d791503925dde9$var$MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ const $44d791503925dde9$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ const $44d791503925dde9$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ const $44d791503925dde9$var$END_BLOCK = 256;
/* end of block literal code */ const $44d791503925dde9$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ const $44d791503925dde9$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ const $44d791503925dde9$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ const $44d791503925dde9$var$extra_lbits = /* extra bits for each length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
]);
const $44d791503925dde9$var$extra_dbits = /* extra bits for each distance code */ new Uint8Array([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
]);
const $44d791503925dde9$var$extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
]);
const $44d791503925dde9$var$bl_order = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
const $44d791503925dde9$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const $44d791503925dde9$var$static_ltree = new Array(($44d791503925dde9$var$L_CODES$1 + 2) * 2);
$44d791503925dde9$var$zero$1($44d791503925dde9$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ const $44d791503925dde9$var$static_dtree = new Array($44d791503925dde9$var$D_CODES$1 * 2);
$44d791503925dde9$var$zero$1($44d791503925dde9$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ const $44d791503925dde9$var$_dist_code = new Array($44d791503925dde9$var$DIST_CODE_LEN);
$44d791503925dde9$var$zero$1($44d791503925dde9$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ const $44d791503925dde9$var$_length_code = new Array($44d791503925dde9$var$MAX_MATCH$1 - $44d791503925dde9$var$MIN_MATCH$1 + 1);
$44d791503925dde9$var$zero$1($44d791503925dde9$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ const $44d791503925dde9$var$base_length = new Array($44d791503925dde9$var$LENGTH_CODES$1);
$44d791503925dde9$var$zero$1($44d791503925dde9$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ const $44d791503925dde9$var$base_dist = new Array($44d791503925dde9$var$D_CODES$1);
$44d791503925dde9$var$zero$1($44d791503925dde9$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $44d791503925dde9$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
let $44d791503925dde9$var$static_l_desc;
let $44d791503925dde9$var$static_d_desc;
let $44d791503925dde9$var$static_bl_desc;
function $44d791503925dde9$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
const $44d791503925dde9$var$d_code = (dist)=>{
    return dist < 256 ? $44d791503925dde9$var$_dist_code[dist] : $44d791503925dde9$var$_dist_code[256 + (dist >>> 7)];
};
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ const $44d791503925dde9$var$put_short = (s, w)=>{
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
};
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ const $44d791503925dde9$var$send_bits = (s, value, length)=>{
    if (s.bi_valid > $44d791503925dde9$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $44d791503925dde9$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $44d791503925dde9$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $44d791503925dde9$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
};
const $44d791503925dde9$var$send_code = (s, c, tree)=>{
    $44d791503925dde9$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
};
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ const $44d791503925dde9$var$bi_reverse = (code, len)=>{
    let res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
};
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ const $44d791503925dde9$var$bi_flush = (s)=>{
    if (s.bi_valid === 16) {
        $44d791503925dde9$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
};
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ const $44d791503925dde9$var$gen_bitlen = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc;    /* the tree descriptor */
    const tree = desc.dyn_tree;
    const max_code = desc.max_code;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const extra = desc.stat_desc.extra_bits;
    const base = desc.stat_desc.extra_base;
    const max_length = desc.stat_desc.max_length;
    let h; /* heap index */ 
    let n, m; /* iterate over the tree elements */ 
    let bits; /* bit length */ 
    let xbits; /* extra bits */ 
    let f; /* frequency */ 
    let overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $44d791503925dde9$var$MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $44d791503925dde9$var$HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Tracev((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
};
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ const $44d791503925dde9$var$gen_codes = (tree, max_code, bl_count)=>{
    //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */
    const next_code = new Array($44d791503925dde9$var$MAX_BITS$1 + 1); /* next code value for each bit length */ 
    let code = 0; /* running code value */ 
    let bits; /* bit index */ 
    let n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $44d791503925dde9$var$MAX_BITS$1; bits++){
        code = code + bl_count[bits - 1] << 1;
        next_code[bits] = code;
    }
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        let len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $44d791503925dde9$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
};
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ const $44d791503925dde9$var$tr_static_init = ()=>{
    let n; /* iterates over tree elements */ 
    let bits; /* bit counter */ 
    let length; /* length value */ 
    let code; /* code value */ 
    let dist; /* distance index */ 
    const bl_count = new Array($44d791503925dde9$var$MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $44d791503925dde9$var$LENGTH_CODES$1 - 1; code++){
        $44d791503925dde9$var$base_length[code] = length;
        for(n = 0; n < 1 << $44d791503925dde9$var$extra_lbits[code]; n++)$44d791503925dde9$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $44d791503925dde9$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $44d791503925dde9$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $44d791503925dde9$var$extra_dbits[code]; n++)$44d791503925dde9$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $44d791503925dde9$var$D_CODES$1; code++){
        $44d791503925dde9$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $44d791503925dde9$var$extra_dbits[code] - 7; n++)$44d791503925dde9$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $44d791503925dde9$var$MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $44d791503925dde9$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $44d791503925dde9$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $44d791503925dde9$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $44d791503925dde9$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $44d791503925dde9$var$gen_codes($44d791503925dde9$var$static_ltree, $44d791503925dde9$var$L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $44d791503925dde9$var$D_CODES$1; n++){
        $44d791503925dde9$var$static_dtree[n * 2 + 1] = 5;
        $44d791503925dde9$var$static_dtree[n * 2] = $44d791503925dde9$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $44d791503925dde9$var$static_l_desc = new $44d791503925dde9$var$StaticTreeDesc($44d791503925dde9$var$static_ltree, $44d791503925dde9$var$extra_lbits, $44d791503925dde9$var$LITERALS$1 + 1, $44d791503925dde9$var$L_CODES$1, $44d791503925dde9$var$MAX_BITS$1);
    $44d791503925dde9$var$static_d_desc = new $44d791503925dde9$var$StaticTreeDesc($44d791503925dde9$var$static_dtree, $44d791503925dde9$var$extra_dbits, 0, $44d791503925dde9$var$D_CODES$1, $44d791503925dde9$var$MAX_BITS$1);
    $44d791503925dde9$var$static_bl_desc = new $44d791503925dde9$var$StaticTreeDesc(new Array(0), $44d791503925dde9$var$extra_blbits, 0, $44d791503925dde9$var$BL_CODES$1, $44d791503925dde9$var$MAX_BL_BITS);
//static_init_done = true;
};
/* ===========================================================================
 * Initialize a new block.
 */ const $44d791503925dde9$var$init_block = (s)=>{
    let n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $44d791503925dde9$var$L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $44d791503925dde9$var$D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $44d791503925dde9$var$BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$44d791503925dde9$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.sym_next = s.matches = 0;
};
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ const $44d791503925dde9$var$bi_windup = (s)=>{
    if (s.bi_valid > 8) $44d791503925dde9$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
};
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ const $44d791503925dde9$var$smaller = (tree, n, m, depth)=>{
    const _n2 = n * 2;
    const _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
};
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ const $44d791503925dde9$var$pqdownheap = (s, tree, k)=>{
    //    deflate_state *s;
    //    ct_data *tree;  /* the tree to restore */
    //    int k;               /* node to move down */
    const v = s.heap[k];
    let j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $44d791503925dde9$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($44d791503925dde9$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
};
// inlined manually
// const SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ const $44d791503925dde9$var$compress_block = (s, ltree, dtree)=>{
    //    deflate_state *s;
    //    const ct_data *ltree; /* literal tree */
    //    const ct_data *dtree; /* distance tree */
    let dist; /* distance of matched string */ 
    let lc; /* match length or unmatched char (if dist == 0) */ 
    let sx = 0; /* running index in sym_buf */ 
    let code; /* the code to send */ 
    let extra; /* number of extra bits to send */ 
    if (s.sym_next !== 0) do {
        dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
        dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
        lc = s.pending_buf[s.sym_buf + sx++];
        if (dist === 0) $44d791503925dde9$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $44d791503925dde9$var$_length_code[lc];
            $44d791503925dde9$var$send_code(s, code + $44d791503925dde9$var$LITERALS$1 + 1, ltree); /* send the length code */ 
            extra = $44d791503925dde9$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $44d791503925dde9$var$base_length[code];
                $44d791503925dde9$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $44d791503925dde9$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $44d791503925dde9$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $44d791503925dde9$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $44d791503925dde9$var$base_dist[code];
                $44d791503925dde9$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and sym_buf is ok: */ //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");
    }while (sx < s.sym_next);
    $44d791503925dde9$var$send_code(s, $44d791503925dde9$var$END_BLOCK, ltree);
};
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ const $44d791503925dde9$var$build_tree = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc; /* the tree descriptor */
    const tree = desc.dyn_tree;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const elems = desc.stat_desc.elems;
    let n, m; /* iterate over heap elements */ 
    let max_code = -1; /* largest code with non zero frequency */ 
    let node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $44d791503925dde9$var$HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$44d791503925dde9$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $44d791503925dde9$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $44d791503925dde9$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $44d791503925dde9$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $44d791503925dde9$var$gen_codes(tree, max_code, s.bl_count);
};
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ const $44d791503925dde9$var$scan_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree;   /* the tree to be scanned */
    //    int max_code;    /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$44d791503925dde9$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$44d791503925dde9$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$44d791503925dde9$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ const $44d791503925dde9$var$send_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree; /* the tree to be scanned */
    //    int max_code;       /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $44d791503925dde9$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $44d791503925dde9$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $44d791503925dde9$var$send_code(s, $44d791503925dde9$var$REP_3_6, s.bl_tree);
            $44d791503925dde9$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $44d791503925dde9$var$send_code(s, $44d791503925dde9$var$REPZ_3_10, s.bl_tree);
            $44d791503925dde9$var$send_bits(s, count - 3, 3);
        } else {
            $44d791503925dde9$var$send_code(s, $44d791503925dde9$var$REPZ_11_138, s.bl_tree);
            $44d791503925dde9$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ const $44d791503925dde9$var$build_bl_tree = (s)=>{
    let max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $44d791503925dde9$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $44d791503925dde9$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $44d791503925dde9$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $44d791503925dde9$var$BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$44d791503925dde9$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
};
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ const $44d791503925dde9$var$send_all_trees = (s, lcodes, dcodes, blcodes)=>{
    //    deflate_state *s;
    //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
    let rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $44d791503925dde9$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $44d791503925dde9$var$send_bits(s, dcodes - 1, 5);
    $44d791503925dde9$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $44d791503925dde9$var$send_bits(s, s.bl_tree[$44d791503925dde9$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $44d791503925dde9$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $44d791503925dde9$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ const $44d791503925dde9$var$detect_data_type = (s)=>{
    /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ let block_mask = 0xf3ffc07f;
    let n;
    /* Check for non-textual ("block-listed") bytes. */ for(n = 0; n <= 31; n++, block_mask >>>= 1){
        if (block_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $44d791503925dde9$var$Z_BINARY;
    }
    /* Check for textual ("allow-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $44d791503925dde9$var$Z_TEXT;
    for(n = 32; n < $44d791503925dde9$var$LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $44d791503925dde9$var$Z_TEXT;
    }
    /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $44d791503925dde9$var$Z_BINARY;
};
let $44d791503925dde9$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ const $44d791503925dde9$var$_tr_init$1 = (s)=>{
    if (!$44d791503925dde9$var$static_init_done) {
        $44d791503925dde9$var$tr_static_init();
        $44d791503925dde9$var$static_init_done = true;
    }
    s.l_desc = new $44d791503925dde9$var$TreeDesc(s.dyn_ltree, $44d791503925dde9$var$static_l_desc);
    s.d_desc = new $44d791503925dde9$var$TreeDesc(s.dyn_dtree, $44d791503925dde9$var$static_d_desc);
    s.bl_desc = new $44d791503925dde9$var$TreeDesc(s.bl_tree, $44d791503925dde9$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $44d791503925dde9$var$init_block(s);
};
/* ===========================================================================
 * Send a stored block
 */ const $44d791503925dde9$var$_tr_stored_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    $44d791503925dde9$var$send_bits(s, ($44d791503925dde9$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $44d791503925dde9$var$bi_windup(s); /* align on byte boundary */ 
    $44d791503925dde9$var$put_short(s, stored_len);
    $44d791503925dde9$var$put_short(s, ~stored_len);
    if (stored_len) s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
    s.pending += stored_len;
};
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ const $44d791503925dde9$var$_tr_align$1 = (s)=>{
    $44d791503925dde9$var$send_bits(s, $44d791503925dde9$var$STATIC_TREES << 1, 3);
    $44d791503925dde9$var$send_code(s, $44d791503925dde9$var$END_BLOCK, $44d791503925dde9$var$static_ltree);
    $44d791503925dde9$var$bi_flush(s);
};
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */ const $44d791503925dde9$var$_tr_flush_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block, or NULL if too old */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    let opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    let max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $44d791503925dde9$var$Z_UNKNOWN$1) s.strm.data_type = $44d791503925dde9$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $44d791503925dde9$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $44d791503925dde9$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $44d791503925dde9$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->sym_next / 3));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $44d791503925dde9$var$_tr_stored_block$1(s, buf, stored_len, last);
    else if (s.strategy === $44d791503925dde9$var$Z_FIXED$1 || static_lenb === opt_lenb) {
        $44d791503925dde9$var$send_bits(s, ($44d791503925dde9$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $44d791503925dde9$var$compress_block(s, $44d791503925dde9$var$static_ltree, $44d791503925dde9$var$static_dtree);
    } else {
        $44d791503925dde9$var$send_bits(s, ($44d791503925dde9$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $44d791503925dde9$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $44d791503925dde9$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $44d791503925dde9$var$init_block(s);
    if (last) $44d791503925dde9$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
};
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ const $44d791503925dde9$var$_tr_tally$1 = (s, dist, lc)=>{
    //    deflate_state *s;
    //    unsigned dist;  /* distance of matched string */
    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
    s.pending_buf[s.sym_buf + s.sym_next++] = dist;
    s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
    s.pending_buf[s.sym_buf + s.sym_next++] = lc;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($44d791503925dde9$var$_length_code[lc] + $44d791503925dde9$var$LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[$44d791503925dde9$var$d_code(dist) * 2]++;
    }
    return s.sym_next === s.sym_end;
};
var $44d791503925dde9$var$_tr_init_1 = $44d791503925dde9$var$_tr_init$1;
var $44d791503925dde9$var$_tr_stored_block_1 = $44d791503925dde9$var$_tr_stored_block$1;
var $44d791503925dde9$var$_tr_flush_block_1 = $44d791503925dde9$var$_tr_flush_block$1;
var $44d791503925dde9$var$_tr_tally_1 = $44d791503925dde9$var$_tr_tally$1;
var $44d791503925dde9$var$_tr_align_1 = $44d791503925dde9$var$_tr_align$1;
var $44d791503925dde9$var$trees = {
    _tr_init: $44d791503925dde9$var$_tr_init_1,
    _tr_stored_block: $44d791503925dde9$var$_tr_stored_block_1,
    _tr_flush_block: $44d791503925dde9$var$_tr_flush_block_1,
    _tr_tally: $44d791503925dde9$var$_tr_tally_1,
    _tr_align: $44d791503925dde9$var$_tr_align_1
};
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $44d791503925dde9$var$adler32 = (adler, buf, len, pos)=>{
    let s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
};
var $44d791503925dde9$var$adler32_1 = $44d791503925dde9$var$adler32;
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
const $44d791503925dde9$var$makeTable = ()=>{
    let c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
};
// Create table on load. Just 255 signed longs. Not a problem.
const $44d791503925dde9$var$crcTable = new Uint32Array($44d791503925dde9$var$makeTable());
const $44d791503925dde9$var$crc32 = (crc, buf, len, pos)=>{
    const t = $44d791503925dde9$var$crcTable;
    const end = pos + len;
    crc ^= -1;
    for(let i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
};
var $44d791503925dde9$var$crc32_1 = $44d791503925dde9$var$crc32;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $44d791503925dde9$var$messages = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $44d791503925dde9$var$constants$2 = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const { _tr_init: $44d791503925dde9$var$_tr_init, _tr_stored_block: $44d791503925dde9$var$_tr_stored_block, _tr_flush_block: $44d791503925dde9$var$_tr_flush_block, _tr_tally: $44d791503925dde9$var$_tr_tally, _tr_align: $44d791503925dde9$var$_tr_align } = $44d791503925dde9$var$trees;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $44d791503925dde9$var$Z_NO_FLUSH$2, Z_PARTIAL_FLUSH: $44d791503925dde9$var$Z_PARTIAL_FLUSH, Z_FULL_FLUSH: $44d791503925dde9$var$Z_FULL_FLUSH$1, Z_FINISH: $44d791503925dde9$var$Z_FINISH$3, Z_BLOCK: $44d791503925dde9$var$Z_BLOCK$1, Z_OK: $44d791503925dde9$var$Z_OK$3, Z_STREAM_END: $44d791503925dde9$var$Z_STREAM_END$3, Z_STREAM_ERROR: $44d791503925dde9$var$Z_STREAM_ERROR$2, Z_DATA_ERROR: $44d791503925dde9$var$Z_DATA_ERROR$2, Z_BUF_ERROR: $44d791503925dde9$var$Z_BUF_ERROR$1, Z_DEFAULT_COMPRESSION: $44d791503925dde9$var$Z_DEFAULT_COMPRESSION$1, Z_FILTERED: $44d791503925dde9$var$Z_FILTERED, Z_HUFFMAN_ONLY: $44d791503925dde9$var$Z_HUFFMAN_ONLY, Z_RLE: $44d791503925dde9$var$Z_RLE, Z_FIXED: $44d791503925dde9$var$Z_FIXED, Z_DEFAULT_STRATEGY: $44d791503925dde9$var$Z_DEFAULT_STRATEGY$1, Z_UNKNOWN: $44d791503925dde9$var$Z_UNKNOWN, Z_DEFLATED: $44d791503925dde9$var$Z_DEFLATED$2 } = $44d791503925dde9$var$constants$2;
/*============================================================================*/ const $44d791503925dde9$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ const $44d791503925dde9$var$MAX_WBITS$1 = 15;
/* 32K LZ77 window */ const $44d791503925dde9$var$DEF_MEM_LEVEL = 8;
const $44d791503925dde9$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $44d791503925dde9$var$LITERALS = 256;
/* number of literal bytes 0..255 */ const $44d791503925dde9$var$L_CODES = $44d791503925dde9$var$LITERALS + 1 + $44d791503925dde9$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ const $44d791503925dde9$var$D_CODES = 30;
/* number of distance codes */ const $44d791503925dde9$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ const $44d791503925dde9$var$HEAP_SIZE = 2 * $44d791503925dde9$var$L_CODES + 1;
/* maximum heap size */ const $44d791503925dde9$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ const $44d791503925dde9$var$MIN_MATCH = 3;
const $44d791503925dde9$var$MAX_MATCH = 258;
const $44d791503925dde9$var$MIN_LOOKAHEAD = $44d791503925dde9$var$MAX_MATCH + $44d791503925dde9$var$MIN_MATCH + 1;
const $44d791503925dde9$var$PRESET_DICT = 0x20;
const $44d791503925dde9$var$INIT_STATE = 42; /* zlib header -> BUSY_STATE */ 
//#ifdef GZIP
const $44d791503925dde9$var$GZIP_STATE = 57; /* gzip header -> BUSY_STATE | EXTRA_STATE */ 
//#endif
const $44d791503925dde9$var$EXTRA_STATE = 69; /* gzip extra block -> NAME_STATE */ 
const $44d791503925dde9$var$NAME_STATE = 73; /* gzip file name -> COMMENT_STATE */ 
const $44d791503925dde9$var$COMMENT_STATE = 91; /* gzip comment -> HCRC_STATE */ 
const $44d791503925dde9$var$HCRC_STATE = 103; /* gzip header CRC -> BUSY_STATE */ 
const $44d791503925dde9$var$BUSY_STATE = 113; /* deflate -> FINISH_STATE */ 
const $44d791503925dde9$var$FINISH_STATE = 666; /* stream complete */ 
const $44d791503925dde9$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
const $44d791503925dde9$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
const $44d791503925dde9$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
const $44d791503925dde9$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
const $44d791503925dde9$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
const $44d791503925dde9$var$err = (strm, errorCode)=>{
    strm.msg = $44d791503925dde9$var$messages[errorCode];
    return errorCode;
};
const $44d791503925dde9$var$rank = (f)=>{
    return f * 2 - (f > 4 ? 9 : 0);
};
const $44d791503925dde9$var$zero = (buf)=>{
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
};
/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */ const $44d791503925dde9$var$slide_hash = (s)=>{
    let n, m;
    let p;
    let wsize = s.w_size;
    n = s.hash_size;
    p = n;
    do {
        m = s.head[--p];
        s.head[p] = m >= wsize ? m - wsize : 0;
    }while (--n);
    n = wsize;
    //#ifndef FASTEST
    p = n;
    do {
        m = s.prev[--p];
        s.prev[p] = m >= wsize ? m - wsize : 0;
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */ }while (--n);
//#endif
};
/* eslint-disable new-cap */ let $44d791503925dde9$var$HASH_ZLIB = (s, prev, data)=>(prev << s.hash_shift ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let $44d791503925dde9$var$HASH = $44d791503925dde9$var$HASH_ZLIB;
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */ const $44d791503925dde9$var$flush_pending = (strm)=>{
    const s = strm.state;
    //_tr_flush_bits(s);
    let len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
};
const $44d791503925dde9$var$flush_block_only = (s, last)=>{
    $44d791503925dde9$var$_tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $44d791503925dde9$var$flush_pending(s.strm);
};
const $44d791503925dde9$var$put_byte = (s, b)=>{
    s.pending_buf[s.pending++] = b;
};
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ const $44d791503925dde9$var$putShortMSB = (s, b)=>{
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
};
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ const $44d791503925dde9$var$read_buf = (strm, buf, start, size)=>{
    let len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
    if (strm.state.wrap === 1) strm.adler = $44d791503925dde9$var$adler32_1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $44d791503925dde9$var$crc32_1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
};
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ const $44d791503925dde9$var$longest_match = (s, cur_match)=>{
    let chain_length = s.max_chain_length; /* max hash chain length */ 
    let scan = s.strstart; /* current string */ 
    let match; /* matched string */ 
    let len; /* length of current match */ 
    let best_len = s.prev_length; /* best match length so far */ 
    let nice_match = s.nice_match; /* stop if match long enough */ 
    const limit = s.strstart > s.w_size - $44d791503925dde9$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $44d791503925dde9$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    const _win = s.window; // shortcut
    const wmask = s.w_mask;
    const prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ const strend = s.strstart + $44d791503925dde9$var$MAX_MATCH;
    let scan_end1 = _win[scan + best_len - 1];
    let scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $44d791503925dde9$var$MAX_MATCH - (strend - scan);
        scan = strend - $44d791503925dde9$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
};
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ const $44d791503925dde9$var$fill_window = (s)=>{
    const _w_size = s.w_size;
    let n, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $44d791503925dde9$var$MIN_LOOKAHEAD)) {
            s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            if (s.insert > s.strstart) s.insert = s.strstart;
            $44d791503925dde9$var$slide_hash(s);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $44d791503925dde9$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $44d791503925dde9$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = $44d791503925dde9$var$HASH(s, s.ins_h, s.window[str + 1]);
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $44d791503925dde9$var$HASH(s, s.ins_h, s.window[str + $44d791503925dde9$var$MIN_MATCH - 1]);
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $44d791503925dde9$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $44d791503925dde9$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */ const $44d791503925dde9$var$deflate_stored = (s, flush)=>{
    /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */ let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;
    /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */ let len, left, have, last = 0;
    let used = s.strm.avail_in;
    do {
        /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */ len = 65535 /* MAX_STORED */ ; /* maximum deflate stored block length */ 
        have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
        if (s.strm.avail_out < have) break;
        /* maximum stored block length that will fit in avail_out: */ have = s.strm.avail_out - have;
        left = s.strstart - s.block_start; /* bytes left in window */ 
        if (len > left + s.strm.avail_in) len = left + s.strm.avail_in; /* limit len to the input */ 
        if (len > have) len = have; /* limit len to the output */ 
        /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */ if (len < min_block && (len === 0 && flush !== $44d791503925dde9$var$Z_FINISH$3 || flush === $44d791503925dde9$var$Z_NO_FLUSH$2 || len !== left + s.strm.avail_in)) break;
        /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */ last = flush === $44d791503925dde9$var$Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
        $44d791503925dde9$var$_tr_stored_block(s, 0, 0, last);
        /* Replace the lengths in the dummy stored block with len. */ s.pending_buf[s.pending - 4] = len;
        s.pending_buf[s.pending - 3] = len >> 8;
        s.pending_buf[s.pending - 2] = ~len;
        s.pending_buf[s.pending - 1] = ~len >> 8;
        /* Write the stored block header bytes. */ $44d791503925dde9$var$flush_pending(s.strm);
        //#ifdef ZLIB_DEBUG
        //    /* Update debugging counts for the data about to be copied. */
        //    s->compressed_len += len << 3;
        //    s->bits_sent += len << 3;
        //#endif
        /* Copy uncompressed bytes from the window to next_out. */ if (left) {
            if (left > len) left = len;
            //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
            s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
            s.strm.next_out += left;
            s.strm.avail_out -= left;
            s.strm.total_out += left;
            s.block_start += left;
            len -= left;
        }
        /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */ if (len) {
            $44d791503925dde9$var$read_buf(s.strm, s.strm.output, s.strm.next_out, len);
            s.strm.next_out += len;
            s.strm.avail_out -= len;
            s.strm.total_out += len;
        }
    }while (last === 0);
    /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */ used -= s.strm.avail_in; /* number of input bytes directly copied */ 
    if (used) {
        /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */ if (used >= s.w_size) {
            s.matches = 2; /* clear hash */ 
            //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
            s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
            s.strstart = s.w_size;
            s.insert = s.strstart;
        } else {
            if (s.window_size - s.strstart <= used) {
                /* Slide the window down. */ s.strstart -= s.w_size;
                //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
                if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
                if (s.insert > s.strstart) s.insert = s.strstart;
            }
            //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
            s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
            s.strstart += used;
            s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
        }
        s.block_start = s.strstart;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* If the last block was written to next_out, then done. */ if (last) return $44d791503925dde9$var$BS_FINISH_DONE;
    /* If flushing and all input has been consumed, then done. */ if (flush !== $44d791503925dde9$var$Z_NO_FLUSH$2 && flush !== $44d791503925dde9$var$Z_FINISH$3 && s.strm.avail_in === 0 && s.strstart === s.block_start) return $44d791503925dde9$var$BS_BLOCK_DONE;
    /* Fill the window with any remaining input. */ have = s.window_size - s.strstart;
    if (s.strm.avail_in > have && s.block_start >= s.w_size) {
        /* Slide the window down. */ s.block_start -= s.w_size;
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
        have += s.w_size; /* more space now */ 
        if (s.insert > s.strstart) s.insert = s.strstart;
    }
    if (have > s.strm.avail_in) have = s.strm.avail_in;
    if (have) {
        $44d791503925dde9$var$read_buf(s.strm, s.window, s.strstart, have);
        s.strstart += have;
        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */ have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
    /* maximum stored block length that will fit in pending: */ have = s.pending_buf_size - have > 65535 /* MAX_STORED */  ? 65535 /* MAX_STORED */  : s.pending_buf_size - have;
    min_block = have > s.w_size ? s.w_size : have;
    left = s.strstart - s.block_start;
    if (left >= min_block || (left || flush === $44d791503925dde9$var$Z_FINISH$3) && flush !== $44d791503925dde9$var$Z_NO_FLUSH$2 && s.strm.avail_in === 0 && left <= have) {
        len = left > have ? have : left;
        last = flush === $44d791503925dde9$var$Z_FINISH$3 && s.strm.avail_in === 0 && len === left ? 1 : 0;
        $44d791503925dde9$var$_tr_stored_block(s, s.block_start, len, last);
        s.block_start += len;
        $44d791503925dde9$var$flush_pending(s.strm);
    }
    /* We've done all we can with the available input and output. */ return last ? $44d791503925dde9$var$BS_FINISH_STARTED : $44d791503925dde9$var$BS_NEED_MORE;
};
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ const $44d791503925dde9$var$deflate_fast = (s, flush)=>{
    let hash_head; /* head of the hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $44d791503925dde9$var$MIN_LOOKAHEAD) {
            $44d791503925dde9$var$fill_window(s);
            if (s.lookahead < $44d791503925dde9$var$MIN_LOOKAHEAD && flush === $44d791503925dde9$var$Z_NO_FLUSH$2) return $44d791503925dde9$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $44d791503925dde9$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $44d791503925dde9$var$HASH(s, s.ins_h, s.window[s.strstart + $44d791503925dde9$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $44d791503925dde9$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $44d791503925dde9$var$longest_match(s, hash_head);
        if (s.match_length >= $44d791503925dde9$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $44d791503925dde9$var$_tr_tally(s, s.strstart - s.match_start, s.match_length - $44d791503925dde9$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $44d791503925dde9$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $44d791503925dde9$var$HASH(s, s.ins_h, s.window[s.strstart + $44d791503925dde9$var$MIN_MATCH - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = $44d791503925dde9$var$HASH(s, s.ins_h, s.window[s.strstart + 1]);
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $44d791503925dde9$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $44d791503925dde9$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $44d791503925dde9$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $44d791503925dde9$var$MIN_MATCH - 1 ? s.strstart : $44d791503925dde9$var$MIN_MATCH - 1;
    if (flush === $44d791503925dde9$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $44d791503925dde9$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $44d791503925dde9$var$BS_FINISH_STARTED;
        /***/ return $44d791503925dde9$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $44d791503925dde9$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $44d791503925dde9$var$BS_NEED_MORE;
    /***/ }
    return $44d791503925dde9$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ const $44d791503925dde9$var$deflate_slow = (s, flush)=>{
    let hash_head; /* head of hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    let max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $44d791503925dde9$var$MIN_LOOKAHEAD) {
            $44d791503925dde9$var$fill_window(s);
            if (s.lookahead < $44d791503925dde9$var$MIN_LOOKAHEAD && flush === $44d791503925dde9$var$Z_NO_FLUSH$2) return $44d791503925dde9$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $44d791503925dde9$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $44d791503925dde9$var$HASH(s, s.ins_h, s.window[s.strstart + $44d791503925dde9$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $44d791503925dde9$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $44d791503925dde9$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $44d791503925dde9$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $44d791503925dde9$var$Z_FILTERED || s.match_length === $44d791503925dde9$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $44d791503925dde9$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $44d791503925dde9$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $44d791503925dde9$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $44d791503925dde9$var$_tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $44d791503925dde9$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $44d791503925dde9$var$HASH(s, s.ins_h, s.window[s.strstart + $44d791503925dde9$var$MIN_MATCH - 1]);
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $44d791503925dde9$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $44d791503925dde9$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $44d791503925dde9$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $44d791503925dde9$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $44d791503925dde9$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $44d791503925dde9$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $44d791503925dde9$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $44d791503925dde9$var$MIN_MATCH - 1 ? s.strstart : $44d791503925dde9$var$MIN_MATCH - 1;
    if (flush === $44d791503925dde9$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $44d791503925dde9$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $44d791503925dde9$var$BS_FINISH_STARTED;
        /***/ return $44d791503925dde9$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $44d791503925dde9$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $44d791503925dde9$var$BS_NEED_MORE;
    /***/ }
    return $44d791503925dde9$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ const $44d791503925dde9$var$deflate_rle = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    let prev; /* byte at distance one to match */ 
    let scan, strend; /* scan goes up to strend for length of run */ 
    const _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $44d791503925dde9$var$MAX_MATCH) {
            $44d791503925dde9$var$fill_window(s);
            if (s.lookahead <= $44d791503925dde9$var$MAX_MATCH && flush === $44d791503925dde9$var$Z_NO_FLUSH$2) return $44d791503925dde9$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $44d791503925dde9$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $44d791503925dde9$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $44d791503925dde9$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $44d791503925dde9$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $44d791503925dde9$var$_tr_tally(s, 1, s.match_length - $44d791503925dde9$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $44d791503925dde9$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $44d791503925dde9$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $44d791503925dde9$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $44d791503925dde9$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $44d791503925dde9$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $44d791503925dde9$var$BS_FINISH_STARTED;
        /***/ return $44d791503925dde9$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $44d791503925dde9$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $44d791503925dde9$var$BS_NEED_MORE;
    /***/ }
    return $44d791503925dde9$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ const $44d791503925dde9$var$deflate_huff = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $44d791503925dde9$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $44d791503925dde9$var$Z_NO_FLUSH$2) return $44d791503925dde9$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $44d791503925dde9$var$_tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $44d791503925dde9$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $44d791503925dde9$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $44d791503925dde9$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $44d791503925dde9$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $44d791503925dde9$var$BS_FINISH_STARTED;
        /***/ return $44d791503925dde9$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $44d791503925dde9$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $44d791503925dde9$var$BS_NEED_MORE;
    /***/ }
    return $44d791503925dde9$var$BS_BLOCK_DONE;
};
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $44d791503925dde9$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
const $44d791503925dde9$var$configuration_table = [
    /*      good lazy nice chain */ new $44d791503925dde9$var$Config(0, 0, 0, 0, $44d791503925dde9$var$deflate_stored),
    /* 0 store only */ new $44d791503925dde9$var$Config(4, 4, 8, 4, $44d791503925dde9$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $44d791503925dde9$var$Config(4, 5, 16, 8, $44d791503925dde9$var$deflate_fast),
    /* 2 */ new $44d791503925dde9$var$Config(4, 6, 32, 32, $44d791503925dde9$var$deflate_fast),
    /* 3 */ new $44d791503925dde9$var$Config(4, 4, 16, 16, $44d791503925dde9$var$deflate_slow),
    /* 4 lazy matches */ new $44d791503925dde9$var$Config(8, 16, 32, 32, $44d791503925dde9$var$deflate_slow),
    /* 5 */ new $44d791503925dde9$var$Config(8, 16, 128, 128, $44d791503925dde9$var$deflate_slow),
    /* 6 */ new $44d791503925dde9$var$Config(8, 32, 128, 256, $44d791503925dde9$var$deflate_slow),
    /* 7 */ new $44d791503925dde9$var$Config(32, 128, 258, 1024, $44d791503925dde9$var$deflate_slow),
    /* 8 */ new $44d791503925dde9$var$Config(32, 258, 258, 4096, $44d791503925dde9$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ const $44d791503925dde9$var$lm_init = (s)=>{
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $44d791503925dde9$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $44d791503925dde9$var$configuration_table[s.level].max_lazy;
    s.good_match = $44d791503925dde9$var$configuration_table[s.level].good_length;
    s.nice_match = $44d791503925dde9$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $44d791503925dde9$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $44d791503925dde9$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
};
function $44d791503925dde9$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $44d791503925dde9$var$Z_DEFLATED$2; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new Uint16Array($44d791503925dde9$var$HEAP_SIZE * 2);
    this.dyn_dtree = new Uint16Array((2 * $44d791503925dde9$var$D_CODES + 1) * 2);
    this.bl_tree = new Uint16Array((2 * $44d791503925dde9$var$BL_CODES + 1) * 2);
    $44d791503925dde9$var$zero(this.dyn_ltree);
    $44d791503925dde9$var$zero(this.dyn_dtree);
    $44d791503925dde9$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new Uint16Array($44d791503925dde9$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new Uint16Array(2 * $44d791503925dde9$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $44d791503925dde9$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * $44d791503925dde9$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $44d791503925dde9$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.sym_buf = 0; /* buffer for distances and literals/lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.sym_next = 0; /* running index in sym_buf */ 
    this.sym_end = 0; /* symbol table full when sym_next reaches this */ 
    this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */ const $44d791503925dde9$var$deflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const s = strm.state;
    if (!s || s.strm !== strm || s.status !== $44d791503925dde9$var$INIT_STATE && //#ifdef GZIP
    s.status !== $44d791503925dde9$var$GZIP_STATE && //#endif
    s.status !== $44d791503925dde9$var$EXTRA_STATE && s.status !== $44d791503925dde9$var$NAME_STATE && s.status !== $44d791503925dde9$var$COMMENT_STATE && s.status !== $44d791503925dde9$var$HCRC_STATE && s.status !== $44d791503925dde9$var$BUSY_STATE && s.status !== $44d791503925dde9$var$FINISH_STATE) return 1;
    return 0;
};
const $44d791503925dde9$var$deflateResetKeep = (strm)=>{
    if ($44d791503925dde9$var$deflateStateCheck(strm)) return $44d791503925dde9$var$err(strm, $44d791503925dde9$var$Z_STREAM_ERROR$2);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $44d791503925dde9$var$Z_UNKNOWN;
    const s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = //#ifdef GZIP
    s.wrap === 2 ? $44d791503925dde9$var$GZIP_STATE : //#endif
    s.wrap ? $44d791503925dde9$var$INIT_STATE : $44d791503925dde9$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = -2;
    $44d791503925dde9$var$_tr_init(s);
    return $44d791503925dde9$var$Z_OK$3;
};
const $44d791503925dde9$var$deflateReset = (strm)=>{
    const ret = $44d791503925dde9$var$deflateResetKeep(strm);
    if (ret === $44d791503925dde9$var$Z_OK$3) $44d791503925dde9$var$lm_init(strm.state);
    return ret;
};
const $44d791503925dde9$var$deflateSetHeader = (strm, head)=>{
    if ($44d791503925dde9$var$deflateStateCheck(strm) || strm.state.wrap !== 2) return $44d791503925dde9$var$Z_STREAM_ERROR$2;
    strm.state.gzhead = head;
    return $44d791503925dde9$var$Z_OK$3;
};
const $44d791503925dde9$var$deflateInit2 = (strm, level, method, windowBits, memLevel, strategy)=>{
    if (!strm) return $44d791503925dde9$var$Z_STREAM_ERROR$2;
    let wrap = 1;
    if (level === $44d791503925dde9$var$Z_DEFAULT_COMPRESSION$1) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $44d791503925dde9$var$MAX_MEM_LEVEL || method !== $44d791503925dde9$var$Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $44d791503925dde9$var$Z_FIXED || windowBits === 8 && wrap !== 1) return $44d791503925dde9$var$err(strm, $44d791503925dde9$var$Z_STREAM_ERROR$2);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ const s = new $44d791503925dde9$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.status = $44d791503925dde9$var$INIT_STATE; /* to pass state test in deflateReset() */ 
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $44d791503925dde9$var$MIN_MATCH - 1) / $44d791503925dde9$var$MIN_MATCH);
    s.window = new Uint8Array(s.w_size * 2);
    s.head = new Uint16Array(s.hash_size);
    s.prev = new Uint16Array(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */ s.pending_buf_size = s.lit_bufsize * 4;
    s.pending_buf = new Uint8Array(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->sym_buf = s->pending_buf + s->lit_bufsize;
    s.sym_buf = s.lit_bufsize;
    //s->sym_end = (s->lit_bufsize - 1) * 3;
    s.sym_end = (s.lit_bufsize - 1) * 3;
    /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $44d791503925dde9$var$deflateReset(strm);
};
const $44d791503925dde9$var$deflateInit = (strm, level)=>{
    return $44d791503925dde9$var$deflateInit2(strm, level, $44d791503925dde9$var$Z_DEFLATED$2, $44d791503925dde9$var$MAX_WBITS$1, $44d791503925dde9$var$DEF_MEM_LEVEL, $44d791503925dde9$var$Z_DEFAULT_STRATEGY$1);
};
/* ========================================================================= */ const $44d791503925dde9$var$deflate$2 = (strm, flush)=>{
    if ($44d791503925dde9$var$deflateStateCheck(strm) || flush > $44d791503925dde9$var$Z_BLOCK$1 || flush < 0) return strm ? $44d791503925dde9$var$err(strm, $44d791503925dde9$var$Z_STREAM_ERROR$2) : $44d791503925dde9$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    if (!strm.output || strm.avail_in !== 0 && !strm.input || s.status === $44d791503925dde9$var$FINISH_STATE && flush !== $44d791503925dde9$var$Z_FINISH$3) return $44d791503925dde9$var$err(strm, strm.avail_out === 0 ? $44d791503925dde9$var$Z_BUF_ERROR$1 : $44d791503925dde9$var$Z_STREAM_ERROR$2);
    const old_flush = s.last_flush;
    s.last_flush = flush;
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $44d791503925dde9$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $44d791503925dde9$var$Z_OK$3;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $44d791503925dde9$var$rank(flush) <= $44d791503925dde9$var$rank(old_flush) && flush !== $44d791503925dde9$var$Z_FINISH$3) return $44d791503925dde9$var$err(strm, $44d791503925dde9$var$Z_BUF_ERROR$1);
    /* User must not provide more input after the first FINISH: */ if (s.status === $44d791503925dde9$var$FINISH_STATE && strm.avail_in !== 0) return $44d791503925dde9$var$err(strm, $44d791503925dde9$var$Z_BUF_ERROR$1);
    /* Write the header */ if (s.status === $44d791503925dde9$var$INIT_STATE && s.wrap === 0) s.status = $44d791503925dde9$var$BUSY_STATE;
    if (s.status === $44d791503925dde9$var$INIT_STATE) {
        /* zlib header */ let header = $44d791503925dde9$var$Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
        let level_flags = -1;
        if (s.strategy >= $44d791503925dde9$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
        else if (s.level < 6) level_flags = 1;
        else if (s.level === 6) level_flags = 2;
        else level_flags = 3;
        header |= level_flags << 6;
        if (s.strstart !== 0) header |= $44d791503925dde9$var$PRESET_DICT;
        header += 31 - header % 31;
        $44d791503925dde9$var$putShortMSB(s, header);
        /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
            $44d791503925dde9$var$putShortMSB(s, strm.adler >>> 16);
            $44d791503925dde9$var$putShortMSB(s, strm.adler & 0xffff);
        }
        strm.adler = 1; // adler32(0L, Z_NULL, 0);
        s.status = $44d791503925dde9$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $44d791503925dde9$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $44d791503925dde9$var$Z_OK$3;
        }
    }
    //#ifdef GZIP
    if (s.status === $44d791503925dde9$var$GZIP_STATE) {
        /* gzip header */ strm.adler = 0; //crc32(0L, Z_NULL, 0);
        $44d791503925dde9$var$put_byte(s, 31);
        $44d791503925dde9$var$put_byte(s, 139);
        $44d791503925dde9$var$put_byte(s, 8);
        if (!s.gzhead) {
            $44d791503925dde9$var$put_byte(s, 0);
            $44d791503925dde9$var$put_byte(s, 0);
            $44d791503925dde9$var$put_byte(s, 0);
            $44d791503925dde9$var$put_byte(s, 0);
            $44d791503925dde9$var$put_byte(s, 0);
            $44d791503925dde9$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $44d791503925dde9$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $44d791503925dde9$var$put_byte(s, $44d791503925dde9$var$OS_CODE);
            s.status = $44d791503925dde9$var$BUSY_STATE;
            /* Compression must start with an empty pending buffer */ $44d791503925dde9$var$flush_pending(strm);
            if (s.pending !== 0) {
                s.last_flush = -1;
                return $44d791503925dde9$var$Z_OK$3;
            }
        } else {
            $44d791503925dde9$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
            $44d791503925dde9$var$put_byte(s, s.gzhead.time & 0xff);
            $44d791503925dde9$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
            $44d791503925dde9$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
            $44d791503925dde9$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
            $44d791503925dde9$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $44d791503925dde9$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $44d791503925dde9$var$put_byte(s, s.gzhead.os & 0xff);
            if (s.gzhead.extra && s.gzhead.extra.length) {
                $44d791503925dde9$var$put_byte(s, s.gzhead.extra.length & 0xff);
                $44d791503925dde9$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
            }
            if (s.gzhead.hcrc) strm.adler = $44d791503925dde9$var$crc32_1(strm.adler, s.pending_buf, s.pending, 0);
            s.gzindex = 0;
            s.status = $44d791503925dde9$var$EXTRA_STATE;
        }
    }
    if (s.status === $44d791503925dde9$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
            while(s.pending + left > s.pending_buf_size){
                let copy = s.pending_buf_size - s.pending;
                // zmemcpy(s.pending_buf + s.pending,
                //    s.gzhead.extra + s.gzindex, copy);
                s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
                s.pending = s.pending_buf_size;
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) strm.adler = $44d791503925dde9$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                //---//
                s.gzindex += copy;
                $44d791503925dde9$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $44d791503925dde9$var$Z_OK$3;
                }
                beg = 0;
                left -= copy;
            }
            // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
            //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
            let gzhead_extra = new Uint8Array(s.gzhead.extra);
            // zmemcpy(s->pending_buf + s->pending,
            //     s->gzhead->extra + s->gzindex, left);
            s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
            s.pending += left;
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $44d791503925dde9$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $44d791503925dde9$var$NAME_STATE;
    }
    if (s.status === $44d791503925dde9$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $44d791503925dde9$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $44d791503925dde9$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $44d791503925dde9$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $44d791503925dde9$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $44d791503925dde9$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $44d791503925dde9$var$COMMENT_STATE;
    }
    if (s.status === $44d791503925dde9$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $44d791503925dde9$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $44d791503925dde9$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $44d791503925dde9$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $44d791503925dde9$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $44d791503925dde9$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
        //---//
        }
        s.status = $44d791503925dde9$var$HCRC_STATE;
    }
    if (s.status === $44d791503925dde9$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
                $44d791503925dde9$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $44d791503925dde9$var$Z_OK$3;
                }
            }
            $44d791503925dde9$var$put_byte(s, strm.adler & 0xff);
            $44d791503925dde9$var$put_byte(s, strm.adler >> 8 & 0xff);
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
        }
        s.status = $44d791503925dde9$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $44d791503925dde9$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $44d791503925dde9$var$Z_OK$3;
        }
    }
    //#endif
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $44d791503925dde9$var$Z_NO_FLUSH$2 && s.status !== $44d791503925dde9$var$FINISH_STATE) {
        let bstate = s.level === 0 ? $44d791503925dde9$var$deflate_stored(s, flush) : s.strategy === $44d791503925dde9$var$Z_HUFFMAN_ONLY ? $44d791503925dde9$var$deflate_huff(s, flush) : s.strategy === $44d791503925dde9$var$Z_RLE ? $44d791503925dde9$var$deflate_rle(s, flush) : $44d791503925dde9$var$configuration_table[s.level].func(s, flush);
        if (bstate === $44d791503925dde9$var$BS_FINISH_STARTED || bstate === $44d791503925dde9$var$BS_FINISH_DONE) s.status = $44d791503925dde9$var$FINISH_STATE;
        if (bstate === $44d791503925dde9$var$BS_NEED_MORE || bstate === $44d791503925dde9$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $44d791503925dde9$var$Z_OK$3;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $44d791503925dde9$var$BS_BLOCK_DONE) {
            if (flush === $44d791503925dde9$var$Z_PARTIAL_FLUSH) $44d791503925dde9$var$_tr_align(s);
            else if (flush !== $44d791503925dde9$var$Z_BLOCK$1) {
                $44d791503925dde9$var$_tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $44d791503925dde9$var$Z_FULL_FLUSH$1) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $44d791503925dde9$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $44d791503925dde9$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $44d791503925dde9$var$Z_OK$3;
            }
        }
    }
    if (flush !== $44d791503925dde9$var$Z_FINISH$3) return $44d791503925dde9$var$Z_OK$3;
    if (s.wrap <= 0) return $44d791503925dde9$var$Z_STREAM_END$3;
    /* Write the trailer */ if (s.wrap === 2) {
        $44d791503925dde9$var$put_byte(s, strm.adler & 0xff);
        $44d791503925dde9$var$put_byte(s, strm.adler >> 8 & 0xff);
        $44d791503925dde9$var$put_byte(s, strm.adler >> 16 & 0xff);
        $44d791503925dde9$var$put_byte(s, strm.adler >> 24 & 0xff);
        $44d791503925dde9$var$put_byte(s, strm.total_in & 0xff);
        $44d791503925dde9$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $44d791503925dde9$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $44d791503925dde9$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $44d791503925dde9$var$putShortMSB(s, strm.adler >>> 16);
        $44d791503925dde9$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $44d791503925dde9$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $44d791503925dde9$var$Z_OK$3 : $44d791503925dde9$var$Z_STREAM_END$3;
};
const $44d791503925dde9$var$deflateEnd = (strm)=>{
    if ($44d791503925dde9$var$deflateStateCheck(strm)) return $44d791503925dde9$var$Z_STREAM_ERROR$2;
    const status = strm.state.status;
    strm.state = null;
    return status === $44d791503925dde9$var$BUSY_STATE ? $44d791503925dde9$var$err(strm, $44d791503925dde9$var$Z_DATA_ERROR$2) : $44d791503925dde9$var$Z_OK$3;
};
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ const $44d791503925dde9$var$deflateSetDictionary = (strm, dictionary)=>{
    let dictLength = dictionary.length;
    if ($44d791503925dde9$var$deflateStateCheck(strm)) return $44d791503925dde9$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    const wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $44d791503925dde9$var$INIT_STATE || s.lookahead) return $44d791503925dde9$var$Z_STREAM_ERROR$2;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $44d791503925dde9$var$adler32_1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $44d791503925dde9$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        let tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ const avail = strm.avail_in;
    const next = strm.next_in;
    const input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $44d791503925dde9$var$fill_window(s);
    while(s.lookahead >= $44d791503925dde9$var$MIN_MATCH){
        let str = s.strstart;
        let n = s.lookahead - ($44d791503925dde9$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $44d791503925dde9$var$HASH(s, s.ins_h, s.window[str + $44d791503925dde9$var$MIN_MATCH - 1]);
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $44d791503925dde9$var$MIN_MATCH - 1;
        $44d791503925dde9$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $44d791503925dde9$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $44d791503925dde9$var$Z_OK$3;
};
var $44d791503925dde9$var$deflateInit_1 = $44d791503925dde9$var$deflateInit;
var $44d791503925dde9$var$deflateInit2_1 = $44d791503925dde9$var$deflateInit2;
var $44d791503925dde9$var$deflateReset_1 = $44d791503925dde9$var$deflateReset;
var $44d791503925dde9$var$deflateResetKeep_1 = $44d791503925dde9$var$deflateResetKeep;
var $44d791503925dde9$var$deflateSetHeader_1 = $44d791503925dde9$var$deflateSetHeader;
var $44d791503925dde9$var$deflate_2$1 = $44d791503925dde9$var$deflate$2;
var $44d791503925dde9$var$deflateEnd_1 = $44d791503925dde9$var$deflateEnd;
var $44d791503925dde9$var$deflateSetDictionary_1 = $44d791503925dde9$var$deflateSetDictionary;
var $44d791503925dde9$var$deflateInfo = 'pako deflate (from Nodeca project)';
/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ var $44d791503925dde9$var$deflate_1$2 = {
    deflateInit: $44d791503925dde9$var$deflateInit_1,
    deflateInit2: $44d791503925dde9$var$deflateInit2_1,
    deflateReset: $44d791503925dde9$var$deflateReset_1,
    deflateResetKeep: $44d791503925dde9$var$deflateResetKeep_1,
    deflateSetHeader: $44d791503925dde9$var$deflateSetHeader_1,
    deflate: $44d791503925dde9$var$deflate_2$1,
    deflateEnd: $44d791503925dde9$var$deflateEnd_1,
    deflateSetDictionary: $44d791503925dde9$var$deflateSetDictionary_1,
    deflateInfo: $44d791503925dde9$var$deflateInfo
};
const $44d791503925dde9$var$_has = (obj, key)=>{
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var $44d791503925dde9$var$assign = function(obj /*from1, from2, from3, ...*/ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        const source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(const p in source)if ($44d791503925dde9$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// Join array of chunks to single array.
var $44d791503925dde9$var$flattenChunks = (chunks)=>{
    // calculate data length
    let len = 0;
    for(let i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
    // join chunks
    const result = new Uint8Array(len);
    for(let i = 0, pos = 0, l = chunks.length; i < l; i++){
        let chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
    }
    return result;
};
var $44d791503925dde9$var$common = {
    assign: $44d791503925dde9$var$assign,
    flattenChunks: $44d791503925dde9$var$flattenChunks
};
// String encode/decode helpers
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let $44d791503925dde9$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $44d791503925dde9$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const $44d791503925dde9$var$_utf8len = new Uint8Array(256);
for(let q = 0; q < 256; q++)$44d791503925dde9$var$_utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
$44d791503925dde9$var$_utf8len[254] = $44d791503925dde9$var$_utf8len[254] = 1; // Invalid sequence start
// convert string to array (typed, when possible)
var $44d791503925dde9$var$string2buf = (str)=>{
    if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) return new TextEncoder().encode(str);
    let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new Uint8Array(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper
const $44d791503925dde9$var$buf2binstring = (buf, len)=>{
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $44d791503925dde9$var$STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
    let result = '';
    for(let i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
};
// convert array to string
var $44d791503925dde9$var$buf2string = (buf, max)=>{
    const len = max || buf.length;
    if (typeof TextDecoder === 'function' && TextDecoder.prototype.decode) return new TextDecoder().decode(buf.subarray(0, max));
    let i, out;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    const utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        let c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        let c_len = $44d791503925dde9$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $44d791503925dde9$var$buf2binstring(utf16buf, out);
};
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $44d791503925dde9$var$utf8border = (buf, max)=>{
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    let pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $44d791503925dde9$var$_utf8len[buf[pos]] > max ? pos : max;
};
var $44d791503925dde9$var$strings = {
    string2buf: $44d791503925dde9$var$string2buf,
    buf2string: $44d791503925dde9$var$buf2string,
    utf8border: $44d791503925dde9$var$utf8border
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $44d791503925dde9$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var $44d791503925dde9$var$zstream = $44d791503925dde9$var$ZStream;
const $44d791503925dde9$var$toString$1 = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $44d791503925dde9$var$Z_NO_FLUSH$1, Z_SYNC_FLUSH: $44d791503925dde9$var$Z_SYNC_FLUSH, Z_FULL_FLUSH: $44d791503925dde9$var$Z_FULL_FLUSH, Z_FINISH: $44d791503925dde9$var$Z_FINISH$2, Z_OK: $44d791503925dde9$var$Z_OK$2, Z_STREAM_END: $44d791503925dde9$var$Z_STREAM_END$2, Z_DEFAULT_COMPRESSION: $44d791503925dde9$var$Z_DEFAULT_COMPRESSION, Z_DEFAULT_STRATEGY: $44d791503925dde9$var$Z_DEFAULT_STRATEGY, Z_DEFLATED: $44d791503925dde9$var$Z_DEFLATED$1 } = $44d791503925dde9$var$constants$2;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $44d791503925dde9$var$Deflate$1(options) {
    this.options = $44d791503925dde9$var$common.assign({
        level: $44d791503925dde9$var$Z_DEFAULT_COMPRESSION,
        method: $44d791503925dde9$var$Z_DEFLATED$1,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $44d791503925dde9$var$Z_DEFAULT_STRATEGY
    }, options || {});
    let opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $44d791503925dde9$var$zstream();
    this.strm.avail_out = 0;
    let status = $44d791503925dde9$var$deflate_1$2.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $44d791503925dde9$var$Z_OK$2) throw new Error($44d791503925dde9$var$messages[status]);
    if (opt.header) $44d791503925dde9$var$deflate_1$2.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        let dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
        dict = $44d791503925dde9$var$strings.string2buf(opt.dictionary);
        else if ($44d791503925dde9$var$toString$1.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $44d791503925dde9$var$deflate_1$2.deflateSetDictionary(this.strm, dict);
        if (status !== $44d791503925dde9$var$Z_OK$2) throw new Error($44d791503925dde9$var$messages[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $44d791503925dde9$var$Deflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    let status, _flush_mode;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $44d791503925dde9$var$Z_FINISH$2 : $44d791503925dde9$var$Z_NO_FLUSH$1;
    // Convert data if needed
    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
    strm.input = $44d791503925dde9$var$strings.string2buf(data);
    else if ($44d791503925dde9$var$toString$1.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        // Make sure avail_out > 6 to avoid repeating markers
        if ((_flush_mode === $44d791503925dde9$var$Z_SYNC_FLUSH || _flush_mode === $44d791503925dde9$var$Z_FULL_FLUSH) && strm.avail_out <= 6) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        status = $44d791503925dde9$var$deflate_1$2.deflate(strm, _flush_mode);
        // Ended => flush and finish
        if (status === $44d791503925dde9$var$Z_STREAM_END$2) {
            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
            status = $44d791503925dde9$var$deflate_1$2.deflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return status === $44d791503925dde9$var$Z_OK$2;
        }
        // Flush if out buffer full
        if (strm.avail_out === 0) {
            this.onData(strm.output);
            continue;
        }
        // Flush if requested and has data
        if (_flush_mode > 0 && strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $44d791503925dde9$var$Deflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $44d791503925dde9$var$Deflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $44d791503925dde9$var$Z_OK$2) this.result = $44d791503925dde9$var$common.flattenChunks(this.chunks);
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $44d791503925dde9$var$deflate$1(input, options) {
    const deflator = new $44d791503925dde9$var$Deflate$1(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $44d791503925dde9$var$messages[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $44d791503925dde9$var$deflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $44d791503925dde9$var$deflate$1(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $44d791503925dde9$var$gzip$1(input, options) {
    options = options || {};
    options.gzip = true;
    return $44d791503925dde9$var$deflate$1(input, options);
}
var $44d791503925dde9$var$Deflate_1$1 = $44d791503925dde9$var$Deflate$1;
var $44d791503925dde9$var$deflate_2 = $44d791503925dde9$var$deflate$1;
var $44d791503925dde9$var$deflateRaw_1$1 = $44d791503925dde9$var$deflateRaw$1;
var $44d791503925dde9$var$gzip_1$1 = $44d791503925dde9$var$gzip$1;
var $44d791503925dde9$var$constants$1 = $44d791503925dde9$var$constants$2;
var $44d791503925dde9$var$deflate_1$1 = {
    Deflate: $44d791503925dde9$var$Deflate_1$1,
    deflate: $44d791503925dde9$var$deflate_2,
    deflateRaw: $44d791503925dde9$var$deflateRaw_1$1,
    gzip: $44d791503925dde9$var$gzip_1$1,
    constants: $44d791503925dde9$var$constants$1
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
const $44d791503925dde9$var$BAD$1 = 16209; /* got a data error -- remain here until reset */ 
const $44d791503925dde9$var$TYPE$1 = 16191; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var $44d791503925dde9$var$inffast = function inflate_fast(strm, start) {
    let _in; /* local strm.input */ 
    let last; /* have enough input while in < last */ 
    let _out; /* local strm.output */ 
    let beg; /* inflate()'s initial strm.output */ 
    let end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    let dmax; /* maximum distance from zlib header */ 
    //#endif
    let wsize; /* window size or zero if not using window */ 
    let whave; /* valid bytes in the window */ 
    let wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    let s_window; /* allocated sliding window, if wsize != 0 */ 
    let hold; /* local strm.hold */ 
    let bits; /* local strm.bits */ 
    let lcode; /* local strm.lencode */ 
    let dcode; /* local strm.distcode */ 
    let lmask; /* mask for first level of length codes */ 
    let dmask; /* mask for first level of distance codes */ 
    let here; /* retrieved table entry */ 
    let op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ let len; /* match length, unused bytes */ 
    let dist; /* match distance */ 
    let from; /* where to copy match from */ 
    let from_source;
    let input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ const state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $44d791503925dde9$var$BAD$1;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $44d791503925dde9$var$BAD$1;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $44d791503925dde9$var$BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $44d791503925dde9$var$TYPE$1;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $44d791503925dde9$var$BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $44d791503925dde9$var$MAXBITS = 15;
const $44d791503925dde9$var$ENOUGH_LENS$1 = 852;
const $44d791503925dde9$var$ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
const $44d791503925dde9$var$CODES$1 = 0;
const $44d791503925dde9$var$LENS$1 = 1;
const $44d791503925dde9$var$DISTS$1 = 2;
const $44d791503925dde9$var$lbase = new Uint16Array([
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
]);
const $44d791503925dde9$var$lext = new Uint8Array([
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
]);
const $44d791503925dde9$var$dbase = new Uint16Array([
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
]);
const $44d791503925dde9$var$dext = new Uint8Array([
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
]);
const $44d791503925dde9$var$inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts)=>{
    const bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    let len = 0; /* a code's length in bits */ 
    let sym = 0; /* index of code symbols */ 
    let min = 0, max = 0; /* minimum and maximum code lengths */ 
    let root = 0; /* number of index bits for root table */ 
    let curr = 0; /* number of index bits for current table */ 
    let drop = 0; /* code bits to drop for sub-table */ 
    let left = 0; /* number of prefix codes available */ 
    let used = 0; /* code entries in table used */ 
    let huff = 0; /* Huffman code */ 
    let incr; /* for incrementing code, index */ 
    let fill; /* index for replicating entries */ 
    let low; /* low bits for current root entry */ 
    let mask; /* mask for low root bits */ 
    let next; /* next available space in table */ 
    let base = null; /* base value table to use */ 
    //  let shoextra;    /* extra bits table to use */
    let match; /* use base and extra for symbol >= match */ 
    const count = new Uint16Array($44d791503925dde9$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    const offs = new Uint16Array($44d791503925dde9$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    let extra = null;
    let here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $44d791503925dde9$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $44d791503925dde9$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $44d791503925dde9$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $44d791503925dde9$var$CODES$1 || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $44d791503925dde9$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $44d791503925dde9$var$CODES$1) {
        base = extra = work; /* dummy value--not used */ 
        match = 20;
    } else if (type === $44d791503925dde9$var$LENS$1) {
        base = $44d791503925dde9$var$lbase;
        extra = $44d791503925dde9$var$lext;
        match = 257;
    } else {
        base = $44d791503925dde9$var$dbase;
        extra = $44d791503925dde9$var$dext;
        match = 0;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $44d791503925dde9$var$LENS$1 && used > $44d791503925dde9$var$ENOUGH_LENS$1 || type === $44d791503925dde9$var$DISTS$1 && used > $44d791503925dde9$var$ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] + 1 < match) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] >= match) {
            here_op = extra[work[sym] - match];
            here_val = base[work[sym] - match];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $44d791503925dde9$var$LENS$1 && used > $44d791503925dde9$var$ENOUGH_LENS$1 || type === $44d791503925dde9$var$DISTS$1 && used > $44d791503925dde9$var$ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
var $44d791503925dde9$var$inftrees = $44d791503925dde9$var$inflate_table;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $44d791503925dde9$var$CODES = 0;
const $44d791503925dde9$var$LENS = 1;
const $44d791503925dde9$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_FINISH: $44d791503925dde9$var$Z_FINISH$1, Z_BLOCK: $44d791503925dde9$var$Z_BLOCK, Z_TREES: $44d791503925dde9$var$Z_TREES, Z_OK: $44d791503925dde9$var$Z_OK$1, Z_STREAM_END: $44d791503925dde9$var$Z_STREAM_END$1, Z_NEED_DICT: $44d791503925dde9$var$Z_NEED_DICT$1, Z_STREAM_ERROR: $44d791503925dde9$var$Z_STREAM_ERROR$1, Z_DATA_ERROR: $44d791503925dde9$var$Z_DATA_ERROR$1, Z_MEM_ERROR: $44d791503925dde9$var$Z_MEM_ERROR$1, Z_BUF_ERROR: $44d791503925dde9$var$Z_BUF_ERROR, Z_DEFLATED: $44d791503925dde9$var$Z_DEFLATED } = $44d791503925dde9$var$constants$2;
/* STATES ====================================================================*/ /* ===========================================================================*/ const $44d791503925dde9$var$HEAD = 16180; /* i: waiting for magic header */ 
const $44d791503925dde9$var$FLAGS = 16181; /* i: waiting for method and flags (gzip) */ 
const $44d791503925dde9$var$TIME = 16182; /* i: waiting for modification time (gzip) */ 
const $44d791503925dde9$var$OS = 16183; /* i: waiting for extra flags and operating system (gzip) */ 
const $44d791503925dde9$var$EXLEN = 16184; /* i: waiting for extra length (gzip) */ 
const $44d791503925dde9$var$EXTRA = 16185; /* i: waiting for extra bytes (gzip) */ 
const $44d791503925dde9$var$NAME = 16186; /* i: waiting for end of file name (gzip) */ 
const $44d791503925dde9$var$COMMENT = 16187; /* i: waiting for end of comment (gzip) */ 
const $44d791503925dde9$var$HCRC = 16188; /* i: waiting for header crc (gzip) */ 
const $44d791503925dde9$var$DICTID = 16189; /* i: waiting for dictionary check value */ 
const $44d791503925dde9$var$DICT = 16190; /* waiting for inflateSetDictionary() call */ 
const $44d791503925dde9$var$TYPE = 16191; /* i: waiting for type bits, including last-flag bit */ 
const $44d791503925dde9$var$TYPEDO = 16192; /* i: same, but skip check to exit inflate on new block */ 
const $44d791503925dde9$var$STORED = 16193; /* i: waiting for stored size (length and complement) */ 
const $44d791503925dde9$var$COPY_ = 16194; /* i/o: same as COPY below, but only first time in */ 
const $44d791503925dde9$var$COPY = 16195; /* i/o: waiting for input or output to copy stored block */ 
const $44d791503925dde9$var$TABLE = 16196; /* i: waiting for dynamic block table lengths */ 
const $44d791503925dde9$var$LENLENS = 16197; /* i: waiting for code length code lengths */ 
const $44d791503925dde9$var$CODELENS = 16198; /* i: waiting for length/lit and distance code lengths */ 
const $44d791503925dde9$var$LEN_ = 16199; /* i: same as LEN below, but only first time in */ 
const $44d791503925dde9$var$LEN = 16200; /* i: waiting for length/lit/eob code */ 
const $44d791503925dde9$var$LENEXT = 16201; /* i: waiting for length extra bits */ 
const $44d791503925dde9$var$DIST = 16202; /* i: waiting for distance code */ 
const $44d791503925dde9$var$DISTEXT = 16203; /* i: waiting for distance extra bits */ 
const $44d791503925dde9$var$MATCH = 16204; /* o: waiting for output space to copy string */ 
const $44d791503925dde9$var$LIT = 16205; /* o: waiting for output space to write literal */ 
const $44d791503925dde9$var$CHECK = 16206; /* i: waiting for 32-bit check value */ 
const $44d791503925dde9$var$LENGTH = 16207; /* i: waiting for 32-bit length (gzip) */ 
const $44d791503925dde9$var$DONE = 16208; /* finished check, done -- remain here until reset */ 
const $44d791503925dde9$var$BAD = 16209; /* got a data error -- remain here until reset */ 
const $44d791503925dde9$var$MEM = 16210; /* got an inflate() memory error -- remain here until reset */ 
const $44d791503925dde9$var$SYNC = 16211; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ const $44d791503925dde9$var$ENOUGH_LENS = 852;
const $44d791503925dde9$var$ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
const $44d791503925dde9$var$MAX_WBITS = 15;
/* 32K LZ77 window */ const $44d791503925dde9$var$DEF_WBITS = $44d791503925dde9$var$MAX_WBITS;
const $44d791503925dde9$var$zswap32 = (q)=>{
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
};
function $44d791503925dde9$var$InflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
    this.work = new Uint16Array(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
const $44d791503925dde9$var$inflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const state = strm.state;
    if (!state || state.strm !== strm || state.mode < $44d791503925dde9$var$HEAD || state.mode > $44d791503925dde9$var$SYNC) return 1;
    return 0;
};
const $44d791503925dde9$var$inflateResetKeep = (strm)=>{
    if ($44d791503925dde9$var$inflateStateCheck(strm)) return $44d791503925dde9$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $44d791503925dde9$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.flags = -1;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new Int32Array($44d791503925dde9$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new Int32Array($44d791503925dde9$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $44d791503925dde9$var$Z_OK$1;
};
const $44d791503925dde9$var$inflateReset = (strm)=>{
    if ($44d791503925dde9$var$inflateStateCheck(strm)) return $44d791503925dde9$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $44d791503925dde9$var$inflateResetKeep(strm);
};
const $44d791503925dde9$var$inflateReset2 = (strm, windowBits)=>{
    let wrap;
    /* get the state */ if ($44d791503925dde9$var$inflateStateCheck(strm)) return $44d791503925dde9$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 5;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $44d791503925dde9$var$Z_STREAM_ERROR$1;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $44d791503925dde9$var$inflateReset(strm);
};
const $44d791503925dde9$var$inflateInit2 = (strm, windowBits)=>{
    if (!strm) return $44d791503925dde9$var$Z_STREAM_ERROR$1;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    const state = new $44d791503925dde9$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.strm = strm;
    state.window = null /*Z_NULL*/ ;
    state.mode = $44d791503925dde9$var$HEAD; /* to pass state test in inflateReset2() */ 
    const ret = $44d791503925dde9$var$inflateReset2(strm, windowBits);
    if (ret !== $44d791503925dde9$var$Z_OK$1) strm.state = null /*Z_NULL*/ ;
    return ret;
};
const $44d791503925dde9$var$inflateInit = (strm)=>{
    return $44d791503925dde9$var$inflateInit2(strm, $44d791503925dde9$var$DEF_WBITS);
};
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ let $44d791503925dde9$var$virgin = true;
let $44d791503925dde9$var$lenfix, $44d791503925dde9$var$distfix; // We have no pointers in JS, so keep tables separate
const $44d791503925dde9$var$fixedtables = (state)=>{
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($44d791503925dde9$var$virgin) {
        $44d791503925dde9$var$lenfix = new Int32Array(512);
        $44d791503925dde9$var$distfix = new Int32Array(32);
        /* literal/length table */ let sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $44d791503925dde9$var$inftrees($44d791503925dde9$var$LENS, state.lens, 0, 288, $44d791503925dde9$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $44d791503925dde9$var$inftrees($44d791503925dde9$var$DISTS, state.lens, 0, 32, $44d791503925dde9$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $44d791503925dde9$var$virgin = false;
    }
    state.lencode = $44d791503925dde9$var$lenfix;
    state.lenbits = 9;
    state.distcode = $44d791503925dde9$var$distfix;
    state.distbits = 5;
};
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ const $44d791503925dde9$var$updatewindow = (strm, src, end, copy)=>{
    let dist;
    const state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new Uint8Array(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            state.window.set(src.subarray(end - copy, end), 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
};
const $44d791503925dde9$var$inflate$2 = (strm, flush)=>{
    let state;
    let input, output; // input/output buffers
    let next; /* next input INDEX */ 
    let put; /* next output INDEX */ 
    let have, left; /* available input and output */ 
    let hold; /* bit buffer */ 
    let bits; /* bits in bit buffer */ 
    let _in, _out; /* save starting available input and output */ 
    let copy; /* number of stored or match bytes to copy */ 
    let from; /* where to copy match bytes from */ 
    let from_source;
    let here = 0; /* current decoding table entry */ 
    let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //let last;                   /* parent table entry */
    let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    let len; /* length to copy for repeats, bits to drop */ 
    let ret; /* return code */ 
    const hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
    let opts;
    let n; // temporary variable for NEED_BITS
    const order = /* permutation of code lengths */ new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    if ($44d791503925dde9$var$inflateStateCheck(strm) || !strm.output || !strm.input && strm.avail_in !== 0) return $44d791503925dde9$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.mode === $44d791503925dde9$var$TYPE) state.mode = $44d791503925dde9$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $44d791503925dde9$var$Z_OK$1;
    inf_leave: for(;;)switch(state.mode){
        case $44d791503925dde9$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $44d791503925dde9$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                if (state.wbits === 0) state.wbits = 15;
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $44d791503925dde9$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $44d791503925dde9$var$FLAGS;
                break;
            }
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $44d791503925dde9$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $44d791503925dde9$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $44d791503925dde9$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            if (len > 15 || len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $44d791503925dde9$var$BAD;
                break;
            }
            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;
            state.flags = 0; /* indicate zlib header */ 
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $44d791503925dde9$var$DICTID : $44d791503925dde9$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $44d791503925dde9$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $44d791503925dde9$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $44d791503925dde9$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $44d791503925dde9$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $44d791503925dde9$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $44d791503925dde9$var$TIME;
        /* falls through */ case $44d791503925dde9$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $44d791503925dde9$var$crc32_1(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $44d791503925dde9$var$OS;
        /* falls through */ case $44d791503925dde9$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $44d791503925dde9$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $44d791503925dde9$var$EXLEN;
        /* falls through */ case $44d791503925dde9$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200 && state.wrap & 4) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $44d791503925dde9$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $44d791503925dde9$var$EXTRA;
        /* falls through */ case $44d791503925dde9$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Uint8Array(state.head.extra_len);
                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) state.check = $44d791503925dde9$var$crc32_1(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $44d791503925dde9$var$NAME;
        /* falls through */ case $44d791503925dde9$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $44d791503925dde9$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $44d791503925dde9$var$COMMENT;
        /* falls through */ case $44d791503925dde9$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $44d791503925dde9$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $44d791503925dde9$var$HCRC;
        /* falls through */ case $44d791503925dde9$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $44d791503925dde9$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $44d791503925dde9$var$TYPE;
            break;
        case $44d791503925dde9$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $44d791503925dde9$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $44d791503925dde9$var$DICT;
        /* falls through */ case $44d791503925dde9$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $44d791503925dde9$var$Z_NEED_DICT$1;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $44d791503925dde9$var$TYPE;
        /* falls through */ case $44d791503925dde9$var$TYPE:
            if (flush === $44d791503925dde9$var$Z_BLOCK || flush === $44d791503925dde9$var$Z_TREES) break inf_leave;
        /* falls through */ case $44d791503925dde9$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $44d791503925dde9$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $44d791503925dde9$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $44d791503925dde9$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $44d791503925dde9$var$LEN_; /* decode codes */ 
                    if (flush === $44d791503925dde9$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $44d791503925dde9$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $44d791503925dde9$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $44d791503925dde9$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $44d791503925dde9$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $44d791503925dde9$var$COPY_;
            if (flush === $44d791503925dde9$var$Z_TREES) break inf_leave;
        /* falls through */ case $44d791503925dde9$var$COPY_:
            state.mode = $44d791503925dde9$var$COPY;
        /* falls through */ case $44d791503925dde9$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                output.set(input.subarray(next, next + copy), put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $44d791503925dde9$var$TYPE;
            break;
        case $44d791503925dde9$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $44d791503925dde9$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $44d791503925dde9$var$LENLENS;
        /* falls through */ case $44d791503925dde9$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $44d791503925dde9$var$inftrees($44d791503925dde9$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $44d791503925dde9$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $44d791503925dde9$var$CODELENS;
        /* falls through */ case $44d791503925dde9$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $44d791503925dde9$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $44d791503925dde9$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $44d791503925dde9$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $44d791503925dde9$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $44d791503925dde9$var$inftrees($44d791503925dde9$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $44d791503925dde9$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $44d791503925dde9$var$inftrees($44d791503925dde9$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $44d791503925dde9$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $44d791503925dde9$var$LEN_;
            if (flush === $44d791503925dde9$var$Z_TREES) break inf_leave;
        /* falls through */ case $44d791503925dde9$var$LEN_:
            state.mode = $44d791503925dde9$var$LEN;
        /* falls through */ case $44d791503925dde9$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $44d791503925dde9$var$inffast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $44d791503925dde9$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $44d791503925dde9$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $44d791503925dde9$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $44d791503925dde9$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $44d791503925dde9$var$LENEXT;
        /* falls through */ case $44d791503925dde9$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $44d791503925dde9$var$DIST;
        /* falls through */ case $44d791503925dde9$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $44d791503925dde9$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $44d791503925dde9$var$DISTEXT;
        /* falls through */ case $44d791503925dde9$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $44d791503925dde9$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $44d791503925dde9$var$MATCH;
        /* falls through */ case $44d791503925dde9$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $44d791503925dde9$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $44d791503925dde9$var$LEN;
            break;
        case $44d791503925dde9$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $44d791503925dde9$var$LEN;
            break;
        case $44d791503925dde9$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/ state.flags ? $44d791503925dde9$var$crc32_1(state.check, output, _out, put - _out) : $44d791503925dde9$var$adler32_1(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if (state.wrap & 4 && (state.flags ? hold : $44d791503925dde9$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $44d791503925dde9$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $44d791503925dde9$var$LENGTH;
        /* falls through */ case $44d791503925dde9$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $44d791503925dde9$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $44d791503925dde9$var$DONE;
        /* falls through */ case $44d791503925dde9$var$DONE:
            ret = $44d791503925dde9$var$Z_STREAM_END$1;
            break inf_leave;
        case $44d791503925dde9$var$BAD:
            ret = $44d791503925dde9$var$Z_DATA_ERROR$1;
            break inf_leave;
        case $44d791503925dde9$var$MEM:
            return $44d791503925dde9$var$Z_MEM_ERROR$1;
        case $44d791503925dde9$var$SYNC:
        /* falls through */ default:
            return $44d791503925dde9$var$Z_STREAM_ERROR$1;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $44d791503925dde9$var$BAD && (state.mode < $44d791503925dde9$var$CHECK || flush !== $44d791503925dde9$var$Z_FINISH$1)) $44d791503925dde9$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/ state.flags ? $44d791503925dde9$var$crc32_1(state.check, output, _out, strm.next_out - _out) : $44d791503925dde9$var$adler32_1(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $44d791503925dde9$var$TYPE ? 128 : 0) + (state.mode === $44d791503925dde9$var$LEN_ || state.mode === $44d791503925dde9$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $44d791503925dde9$var$Z_FINISH$1) && ret === $44d791503925dde9$var$Z_OK$1) ret = $44d791503925dde9$var$Z_BUF_ERROR;
    return ret;
};
const $44d791503925dde9$var$inflateEnd = (strm)=>{
    if ($44d791503925dde9$var$inflateStateCheck(strm)) return $44d791503925dde9$var$Z_STREAM_ERROR$1;
    let state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $44d791503925dde9$var$Z_OK$1;
};
const $44d791503925dde9$var$inflateGetHeader = (strm, head)=>{
    /* check state */ if ($44d791503925dde9$var$inflateStateCheck(strm)) return $44d791503925dde9$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    if ((state.wrap & 2) === 0) return $44d791503925dde9$var$Z_STREAM_ERROR$1;
    /* save header structure */ state.head = head;
    head.done = false;
    return $44d791503925dde9$var$Z_OK$1;
};
const $44d791503925dde9$var$inflateSetDictionary = (strm, dictionary)=>{
    const dictLength = dictionary.length;
    let state;
    let dictid;
    let ret;
    /* check state */ if ($44d791503925dde9$var$inflateStateCheck(strm)) return $44d791503925dde9$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $44d791503925dde9$var$DICT) return $44d791503925dde9$var$Z_STREAM_ERROR$1;
    /* check for correct dictionary identifier */ if (state.mode === $44d791503925dde9$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $44d791503925dde9$var$adler32_1(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $44d791503925dde9$var$Z_DATA_ERROR$1;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $44d791503925dde9$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $44d791503925dde9$var$MEM;
        return $44d791503925dde9$var$Z_MEM_ERROR$1;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $44d791503925dde9$var$Z_OK$1;
};
var $44d791503925dde9$var$inflateReset_1 = $44d791503925dde9$var$inflateReset;
var $44d791503925dde9$var$inflateReset2_1 = $44d791503925dde9$var$inflateReset2;
var $44d791503925dde9$var$inflateResetKeep_1 = $44d791503925dde9$var$inflateResetKeep;
var $44d791503925dde9$var$inflateInit_1 = $44d791503925dde9$var$inflateInit;
var $44d791503925dde9$var$inflateInit2_1 = $44d791503925dde9$var$inflateInit2;
var $44d791503925dde9$var$inflate_2$1 = $44d791503925dde9$var$inflate$2;
var $44d791503925dde9$var$inflateEnd_1 = $44d791503925dde9$var$inflateEnd;
var $44d791503925dde9$var$inflateGetHeader_1 = $44d791503925dde9$var$inflateGetHeader;
var $44d791503925dde9$var$inflateSetDictionary_1 = $44d791503925dde9$var$inflateSetDictionary;
var $44d791503925dde9$var$inflateInfo = 'pako inflate (from Nodeca project)';
/* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/ var $44d791503925dde9$var$inflate_1$2 = {
    inflateReset: $44d791503925dde9$var$inflateReset_1,
    inflateReset2: $44d791503925dde9$var$inflateReset2_1,
    inflateResetKeep: $44d791503925dde9$var$inflateResetKeep_1,
    inflateInit: $44d791503925dde9$var$inflateInit_1,
    inflateInit2: $44d791503925dde9$var$inflateInit2_1,
    inflate: $44d791503925dde9$var$inflate_2$1,
    inflateEnd: $44d791503925dde9$var$inflateEnd_1,
    inflateGetHeader: $44d791503925dde9$var$inflateGetHeader_1,
    inflateSetDictionary: $44d791503925dde9$var$inflateSetDictionary_1,
    inflateInfo: $44d791503925dde9$var$inflateInfo
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $44d791503925dde9$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
var $44d791503925dde9$var$gzheader = $44d791503925dde9$var$GZheader;
const $44d791503925dde9$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $44d791503925dde9$var$Z_NO_FLUSH, Z_FINISH: $44d791503925dde9$var$Z_FINISH, Z_OK: $44d791503925dde9$var$Z_OK, Z_STREAM_END: $44d791503925dde9$var$Z_STREAM_END, Z_NEED_DICT: $44d791503925dde9$var$Z_NEED_DICT, Z_STREAM_ERROR: $44d791503925dde9$var$Z_STREAM_ERROR, Z_DATA_ERROR: $44d791503925dde9$var$Z_DATA_ERROR, Z_MEM_ERROR: $44d791503925dde9$var$Z_MEM_ERROR } = $44d791503925dde9$var$constants$2;
/* ===========================================================================*/ /**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $44d791503925dde9$var$Inflate$1(options) {
    this.options = $44d791503925dde9$var$common.assign({
        chunkSize: 65536,
        windowBits: 15,
        to: ''
    }, options || {});
    const opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $44d791503925dde9$var$zstream();
    this.strm.avail_out = 0;
    let status = $44d791503925dde9$var$inflate_1$2.inflateInit2(this.strm, opt.windowBits);
    if (status !== $44d791503925dde9$var$Z_OK) throw new Error($44d791503925dde9$var$messages[status]);
    this.header = new $44d791503925dde9$var$gzheader();
    $44d791503925dde9$var$inflate_1$2.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') opt.dictionary = $44d791503925dde9$var$strings.string2buf(opt.dictionary);
        else if ($44d791503925dde9$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $44d791503925dde9$var$inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $44d791503925dde9$var$Z_OK) throw new Error($44d791503925dde9$var$messages[status]);
        }
    }
}
/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $44d791503925dde9$var$Inflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    const dictionary = this.options.dictionary;
    let status, _flush_mode, last_avail_out;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $44d791503925dde9$var$Z_FINISH : $44d791503925dde9$var$Z_NO_FLUSH;
    // Convert data if needed
    if ($44d791503925dde9$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $44d791503925dde9$var$inflate_1$2.inflate(strm, _flush_mode);
        if (status === $44d791503925dde9$var$Z_NEED_DICT && dictionary) {
            status = $44d791503925dde9$var$inflate_1$2.inflateSetDictionary(strm, dictionary);
            if (status === $44d791503925dde9$var$Z_OK) status = $44d791503925dde9$var$inflate_1$2.inflate(strm, _flush_mode);
            else if (status === $44d791503925dde9$var$Z_DATA_ERROR) // Replace code with more verbose
            status = $44d791503925dde9$var$Z_NEED_DICT;
        }
        // Skip snyc markers if more data follows and not raw mode
        while(strm.avail_in > 0 && status === $44d791503925dde9$var$Z_STREAM_END && strm.state.wrap > 0 && data[strm.next_in] !== 0){
            $44d791503925dde9$var$inflate_1$2.inflateReset(strm);
            status = $44d791503925dde9$var$inflate_1$2.inflate(strm, _flush_mode);
        }
        switch(status){
            case $44d791503925dde9$var$Z_STREAM_ERROR:
            case $44d791503925dde9$var$Z_DATA_ERROR:
            case $44d791503925dde9$var$Z_NEED_DICT:
            case $44d791503925dde9$var$Z_MEM_ERROR:
                this.onEnd(status);
                this.ended = true;
                return false;
        }
        // Remember real `avail_out` value, because we may patch out buffer content
        // to align utf8 strings boundaries.
        last_avail_out = strm.avail_out;
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $44d791503925dde9$var$Z_STREAM_END) {
                if (this.options.to === 'string') {
                    let next_out_utf8 = $44d791503925dde9$var$strings.utf8border(strm.output, strm.next_out);
                    let tail = strm.next_out - next_out_utf8;
                    let utf8str = $44d791503925dde9$var$strings.buf2string(strm.output, next_out_utf8);
                    // move tail & realign counters
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
                    this.onData(utf8str);
                } else this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
            }
        }
        // Must repeat iteration if out buffer is full
        if (status === $44d791503925dde9$var$Z_OK && last_avail_out === 0) continue;
        // Finalize if end of stream reached.
        if (status === $44d791503925dde9$var$Z_STREAM_END) {
            status = $44d791503925dde9$var$inflate_1$2.inflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return true;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $44d791503925dde9$var$Inflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $44d791503925dde9$var$Inflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $44d791503925dde9$var$Z_OK) {
        if (this.options.to === 'string') this.result = this.chunks.join('');
        else this.result = $44d791503925dde9$var$common.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/ function $44d791503925dde9$var$inflate$1(input, options) {
    const inflator = new $44d791503925dde9$var$Inflate$1(options);
    inflator.push(input);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $44d791503925dde9$var$messages[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $44d791503925dde9$var$inflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $44d791503925dde9$var$inflate$1(input, options);
}
/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $44d791503925dde9$var$Inflate_1$1 = $44d791503925dde9$var$Inflate$1;
var $44d791503925dde9$var$inflate_2 = $44d791503925dde9$var$inflate$1;
var $44d791503925dde9$var$inflateRaw_1$1 = $44d791503925dde9$var$inflateRaw$1;
var $44d791503925dde9$var$ungzip$1 = $44d791503925dde9$var$inflate$1;
var $44d791503925dde9$var$constants = $44d791503925dde9$var$constants$2;
var $44d791503925dde9$var$inflate_1$1 = {
    Inflate: $44d791503925dde9$var$Inflate_1$1,
    inflate: $44d791503925dde9$var$inflate_2,
    inflateRaw: $44d791503925dde9$var$inflateRaw_1$1,
    ungzip: $44d791503925dde9$var$ungzip$1,
    constants: $44d791503925dde9$var$constants
};
const { Deflate: $44d791503925dde9$var$Deflate, deflate: $44d791503925dde9$var$deflate, deflateRaw: $44d791503925dde9$var$deflateRaw, gzip: $44d791503925dde9$var$gzip } = $44d791503925dde9$var$deflate_1$1;
const { Inflate: $44d791503925dde9$var$Inflate, inflate: $44d791503925dde9$var$inflate, inflateRaw: $44d791503925dde9$var$inflateRaw, ungzip: $44d791503925dde9$var$ungzip } = $44d791503925dde9$var$inflate_1$1;
var $44d791503925dde9$export$ae157b6234afe138 = $44d791503925dde9$var$Deflate;
var $44d791503925dde9$export$2316623ecd1285ab = $44d791503925dde9$var$deflate;
var $44d791503925dde9$export$e95d6a8f69fb340a = $44d791503925dde9$var$deflateRaw;
var $44d791503925dde9$export$69f0ea7cf3a331a8 = $44d791503925dde9$var$gzip;
var $44d791503925dde9$export$d1de70a877d6e43c = $44d791503925dde9$var$Inflate;
var $44d791503925dde9$export$cae1ce83fe4a1782 = $44d791503925dde9$var$inflate;
var $44d791503925dde9$export$d0f0aa2d05c905c5 = $44d791503925dde9$var$inflateRaw;
var $44d791503925dde9$export$95adf9d270383091 = $44d791503925dde9$var$ungzip;
var $44d791503925dde9$export$1a988e7317c65621 = $44d791503925dde9$var$constants$2;
var $44d791503925dde9$export$2e2bcd8739ae039 = {
    Deflate: $44d791503925dde9$export$ae157b6234afe138,
    deflate: $44d791503925dde9$export$2316623ecd1285ab,
    deflateRaw: $44d791503925dde9$export$e95d6a8f69fb340a,
    gzip: $44d791503925dde9$export$69f0ea7cf3a331a8,
    Inflate: $44d791503925dde9$export$d1de70a877d6e43c,
    inflate: $44d791503925dde9$export$cae1ce83fe4a1782,
    inflateRaw: $44d791503925dde9$export$d0f0aa2d05c905c5,
    ungzip: $44d791503925dde9$export$95adf9d270383091,
    constants: $44d791503925dde9$export$1a988e7317c65621
};


const $856ecd6e54b74c05$var$crcTable = [];
for(let n = 0; n < 256; n++){
    let c = n;
    for(let k = 0; k < 8; k++)if (c & 1) c = 0xedb88320 ^ c >>> 1;
    else c = c >>> 1;
    $856ecd6e54b74c05$var$crcTable[n] = c;
}
const $856ecd6e54b74c05$var$initialCrc = 0xffffffff;
function $856ecd6e54b74c05$var$updateCrc(currentCrc, data, length) {
    let c = currentCrc;
    for(let n = 0; n < length; n++)c = $856ecd6e54b74c05$var$crcTable[(c ^ data[n]) & 0xff] ^ c >>> 8;
    return c;
}
function $856ecd6e54b74c05$var$crc(data, length) {
    return ($856ecd6e54b74c05$var$updateCrc($856ecd6e54b74c05$var$initialCrc, data, length) ^ $856ecd6e54b74c05$var$initialCrc) >>> 0;
}
function $856ecd6e54b74c05$export$a27e44f4abee07bd(buffer, crcLength, chunkName) {
    const expectedCrc = buffer.readUint32();
    const actualCrc = $856ecd6e54b74c05$var$crc(new Uint8Array(buffer.buffer, buffer.byteOffset + buffer.offset - crcLength - 4, crcLength), crcLength); // "- 4" because we already advanced by reading the CRC
    if (actualCrc !== expectedCrc) throw new Error(`CRC mismatch for chunk ${chunkName}. Expected ${expectedCrc}, found ${actualCrc}`);
}
function $856ecd6e54b74c05$export$f1eadea2b27d7525(buffer, length) {
    buffer.writeUint32($856ecd6e54b74c05$var$crc(new Uint8Array(buffer.buffer, buffer.byteOffset + buffer.offset - length, length), length));
}


function $9df762f61814517f$export$b7b5bfc0952df2ea(currentLine, newLine, bytesPerLine) {
    for(let i = 0; i < bytesPerLine; i++)newLine[i] = currentLine[i];
}
function $9df762f61814517f$export$74a31f89f2bf5d02(currentLine, newLine, bytesPerLine, bytesPerPixel) {
    let i = 0;
    for(; i < bytesPerPixel; i++)// just copy first bytes
    newLine[i] = currentLine[i];
    for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + newLine[i - bytesPerPixel] & 0xff;
}
function $9df762f61814517f$export$42813f03f0be1153(currentLine, newLine, prevLine, bytesPerLine) {
    let i = 0;
    if (prevLine.length === 0) // just copy bytes for first line
    for(; i < bytesPerLine; i++)newLine[i] = currentLine[i];
    else for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + prevLine[i] & 0xff;
}
function $9df762f61814517f$export$ad0279a52dc26d29(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel) {
    let i = 0;
    if (prevLine.length === 0) {
        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i];
        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + (newLine[i - bytesPerPixel] >> 1) & 0xff;
    } else {
        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i] + (prevLine[i] >> 1) & 0xff;
        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + (newLine[i - bytesPerPixel] + prevLine[i] >> 1) & 0xff;
    }
}
function $9df762f61814517f$export$6c7fcb68da6b62(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel) {
    let i = 0;
    if (prevLine.length === 0) {
        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i];
        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + newLine[i - bytesPerPixel] & 0xff;
    } else {
        for(; i < bytesPerPixel; i++)newLine[i] = currentLine[i] + prevLine[i] & 0xff;
        for(; i < bytesPerLine; i++)newLine[i] = currentLine[i] + $9df762f61814517f$var$paethPredictor(newLine[i - bytesPerPixel], prevLine[i], prevLine[i - bytesPerPixel]) & 0xff;
    }
}
function $9df762f61814517f$var$paethPredictor(a, b, c) {
    const p = a + b - c;
    const pa = Math.abs(p - a);
    const pb = Math.abs(p - b);
    const pc = Math.abs(p - c);
    if (pa <= pb && pa <= pc) return a;
    else if (pb <= pc) return b;
    else return c;
}


function $00f6a16bb9141b11$export$cf2952a533e34237(filterType, currentLine, newLine, prevLine, passLineBytes, bytesPerPixel) {
    switch(filterType){
        case 0:
            (0, $9df762f61814517f$export$b7b5bfc0952df2ea)(currentLine, newLine, passLineBytes);
            break;
        case 1:
            (0, $9df762f61814517f$export$74a31f89f2bf5d02)(currentLine, newLine, passLineBytes, bytesPerPixel);
            break;
        case 2:
            (0, $9df762f61814517f$export$42813f03f0be1153)(currentLine, newLine, prevLine, passLineBytes);
            break;
        case 3:
            (0, $9df762f61814517f$export$ad0279a52dc26d29)(currentLine, newLine, prevLine, passLineBytes, bytesPerPixel);
            break;
        case 4:
            (0, $9df762f61814517f$export$6c7fcb68da6b62)(currentLine, newLine, prevLine, passLineBytes, bytesPerPixel);
            break;
        default:
            throw new Error(`Unsupported filter: ${filterType}`);
    }
}


const $5f6e764cf1569d03$var$uint16 = new Uint16Array([
    0x00ff
]);
const $5f6e764cf1569d03$var$uint8 = new Uint8Array($5f6e764cf1569d03$var$uint16.buffer);
const $5f6e764cf1569d03$var$osIsLittleEndian = $5f6e764cf1569d03$var$uint8[0] === 0xff;
function $5f6e764cf1569d03$export$4e311ab71083585(params) {
    const { data: data, width: width, height: height, channels: channels, depth: depth } = params;
    // Adam7 interlacing pattern
    const passes = [
        {
            x: 0,
            y: 0,
            xStep: 8,
            yStep: 8
        },
        {
            x: 4,
            y: 0,
            xStep: 8,
            yStep: 8
        },
        {
            x: 0,
            y: 4,
            xStep: 4,
            yStep: 8
        },
        {
            x: 2,
            y: 0,
            xStep: 4,
            yStep: 4
        },
        {
            x: 0,
            y: 2,
            xStep: 2,
            yStep: 4
        },
        {
            x: 1,
            y: 0,
            xStep: 2,
            yStep: 2
        },
        {
            x: 0,
            y: 1,
            xStep: 1,
            yStep: 2
        }
    ];
    const bytesPerPixel = Math.ceil(depth / 8) * channels;
    const resultData = new Uint8Array(height * width * bytesPerPixel);
    let offset = 0;
    // Process each pass
    for(let passIndex = 0; passIndex < 7; passIndex++){
        const pass = passes[passIndex];
        // Calculate pass dimensions
        const passWidth = Math.ceil((width - pass.x) / pass.xStep);
        const passHeight = Math.ceil((height - pass.y) / pass.yStep);
        if (passWidth <= 0 || passHeight <= 0) continue;
        const passLineBytes = passWidth * bytesPerPixel;
        const prevLine = new Uint8Array(passLineBytes);
        // Process each scanline in this pass
        for(let y = 0; y < passHeight; y++){
            // First byte is the filter type
            const filterType = data[offset++];
            const currentLine = data.subarray(offset, offset + passLineBytes);
            offset += passLineBytes;
            // Create a new line for the unfiltered data
            const newLine = new Uint8Array(passLineBytes);
            // Apply the appropriate unfilter
            (0, $00f6a16bb9141b11$export$cf2952a533e34237)(filterType, currentLine, newLine, prevLine, passLineBytes, bytesPerPixel);
            prevLine.set(newLine);
            for(let x = 0; x < passWidth; x++){
                const outputX = pass.x + x * pass.xStep;
                const outputY = pass.y + y * pass.yStep;
                if (outputX >= width || outputY >= height) continue;
                for(let i = 0; i < bytesPerPixel; i++)resultData[(outputY * width + outputX) * bytesPerPixel + i] = newLine[x * bytesPerPixel + i];
            }
        }
    }
    if (depth === 16) {
        const uint16Data = new Uint16Array(resultData.buffer);
        if ($5f6e764cf1569d03$var$osIsLittleEndian) for(let k = 0; k < uint16Data.length; k++)// PNG is always big endian. Swap the bytes.
        uint16Data[k] = $5f6e764cf1569d03$var$swap16(uint16Data[k]);
        return uint16Data;
    } else return resultData;
}
function $5f6e764cf1569d03$var$swap16(val) {
    return (val & 0xff) << 8 | val >> 8 & 0xff;
}



const $537230e51d3d3bdc$var$uint16 = new Uint16Array([
    0x00ff
]);
const $537230e51d3d3bdc$var$uint8 = new Uint8Array($537230e51d3d3bdc$var$uint16.buffer);
const $537230e51d3d3bdc$var$osIsLittleEndian = $537230e51d3d3bdc$var$uint8[0] === 0xff;
const $537230e51d3d3bdc$var$empty = new Uint8Array(0);
function $537230e51d3d3bdc$export$fe66f1bbb29d778e(params) {
    const { data: data, width: width, height: height, channels: channels, depth: depth } = params;
    const bytesPerPixel = Math.ceil(depth / 8) * channels;
    const bytesPerLine = Math.ceil(depth / 8 * channels * width);
    const newData = new Uint8Array(height * bytesPerLine);
    let prevLine = $537230e51d3d3bdc$var$empty;
    let offset = 0;
    let currentLine;
    let newLine;
    for(let i = 0; i < height; i++){
        currentLine = data.subarray(offset + 1, offset + 1 + bytesPerLine);
        newLine = newData.subarray(i * bytesPerLine, (i + 1) * bytesPerLine);
        switch(data[offset]){
            case 0:
                (0, $9df762f61814517f$export$b7b5bfc0952df2ea)(currentLine, newLine, bytesPerLine);
                break;
            case 1:
                (0, $9df762f61814517f$export$74a31f89f2bf5d02)(currentLine, newLine, bytesPerLine, bytesPerPixel);
                break;
            case 2:
                (0, $9df762f61814517f$export$42813f03f0be1153)(currentLine, newLine, prevLine, bytesPerLine);
                break;
            case 3:
                (0, $9df762f61814517f$export$ad0279a52dc26d29)(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel);
                break;
            case 4:
                (0, $9df762f61814517f$export$6c7fcb68da6b62)(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel);
                break;
            default:
                throw new Error(`Unsupported filter: ${data[offset]}`);
        }
        prevLine = newLine;
        offset += bytesPerLine + 1;
    }
    if (depth === 16) {
        const uint16Data = new Uint16Array(newData.buffer);
        if ($537230e51d3d3bdc$var$osIsLittleEndian) for(let k = 0; k < uint16Data.length; k++)// PNG is always big endian. Swap the bytes.
        uint16Data[k] = $537230e51d3d3bdc$var$swap16(uint16Data[k]);
        return uint16Data;
    } else return newData;
}
function $537230e51d3d3bdc$var$swap16(val) {
    return (val & 0xff) << 8 | val >> 8 & 0xff;
}


// https://www.w3.org/TR/PNG/#5PNG-file-signature
const $41be136efb06da59$var$pngSignature = Uint8Array.of(137, 80, 78, 71, 13, 10, 26, 10);
function $41be136efb06da59$export$6d91aec43a397576(buffer) {
    buffer.writeBytes($41be136efb06da59$var$pngSignature);
}
function $41be136efb06da59$export$9b20e139d888fd41(buffer) {
    if (!$41be136efb06da59$export$eb3857d891b50bba(buffer.readBytes($41be136efb06da59$var$pngSignature.length))) throw new Error('wrong PNG signature');
}
function $41be136efb06da59$export$eb3857d891b50bba(array) {
    if (array.length < $41be136efb06da59$var$pngSignature.length) return false;
    for(let i = 0; i < $41be136efb06da59$var$pngSignature.length; i++){
        if (array[i] !== $41be136efb06da59$var$pngSignature[i]) return false;
    }
    return true;
}



const $24fb9ce7b4baa3bf$export$b7828eccb3fa75e = 'tEXt';
const $24fb9ce7b4baa3bf$var$NULL = 0;
const $24fb9ce7b4baa3bf$var$latin1Decoder = new TextDecoder('latin1');
function $24fb9ce7b4baa3bf$var$validateKeyword(keyword) {
    $24fb9ce7b4baa3bf$var$validateLatin1(keyword);
    if (keyword.length === 0 || keyword.length > 79) throw new Error('keyword length must be between 1 and 79');
}
// eslint-disable-next-line no-control-regex
const $24fb9ce7b4baa3bf$var$latin1Regex = /^[\u0000-\u00FF]*$/;
function $24fb9ce7b4baa3bf$var$validateLatin1(text) {
    if (!$24fb9ce7b4baa3bf$var$latin1Regex.test(text)) throw new Error('invalid latin1 text');
}
function $24fb9ce7b4baa3bf$export$eaa080cfa45e66ec(text, buffer, length) {
    const keyword = $24fb9ce7b4baa3bf$export$7ff9b48854e294c6(buffer);
    text[keyword] = $24fb9ce7b4baa3bf$export$6f32b93aa65863bd(buffer, length - keyword.length - 1);
}
function $24fb9ce7b4baa3bf$export$304fabbece3077af(buffer, keyword, text) {
    $24fb9ce7b4baa3bf$var$validateKeyword(keyword);
    $24fb9ce7b4baa3bf$var$validateLatin1(text);
    const length = keyword.length + 1 /* NULL */  + text.length;
    buffer.writeUint32(length);
    buffer.writeChars($24fb9ce7b4baa3bf$export$b7828eccb3fa75e);
    buffer.writeChars(keyword);
    buffer.writeByte($24fb9ce7b4baa3bf$var$NULL);
    buffer.writeChars(text);
    (0, $856ecd6e54b74c05$export$f1eadea2b27d7525)(buffer, length + 4);
}
function $24fb9ce7b4baa3bf$export$7ff9b48854e294c6(buffer) {
    buffer.mark();
    while(buffer.readByte() !== $24fb9ce7b4baa3bf$var$NULL);
    const end = buffer.offset;
    buffer.reset();
    const keyword = $24fb9ce7b4baa3bf$var$latin1Decoder.decode(buffer.readBytes(end - buffer.offset - 1));
    // NULL
    buffer.skip(1);
    $24fb9ce7b4baa3bf$var$validateKeyword(keyword);
    return keyword;
}
function $24fb9ce7b4baa3bf$export$6f32b93aa65863bd(buffer, length) {
    return $24fb9ce7b4baa3bf$var$latin1Decoder.decode(buffer.readBytes(length));
}


const $8a9c4f57eda90c68$export$2cd82751acc0e609 = {
    UNKNOWN: -1,
    GREYSCALE: 0,
    TRUECOLOUR: 2,
    INDEXED_COLOUR: 3,
    GREYSCALE_ALPHA: 4,
    TRUECOLOUR_ALPHA: 6
};
const $8a9c4f57eda90c68$export$825f3c317f99229 = {
    UNKNOWN: -1,
    DEFLATE: 0
};
const $8a9c4f57eda90c68$export$3ecd618ea72c47f7 = {
    UNKNOWN: -1,
    ADAPTIVE: 0
};
const $8a9c4f57eda90c68$export$2b1dd3da86572fe2 = {
    UNKNOWN: -1,
    NO_INTERLACE: 0,
    ADAM7: 1
};
const $8a9c4f57eda90c68$export$c2de24028defae28 = {
    NONE: 0,
    BACKGROUND: 1,
    PREVIOUS: 2
};
const $8a9c4f57eda90c68$export$b8d06ec133a3a0ca = {
    SOURCE: 0,
    OVER: 1
};


class $8d2b1a59512157d3$export$2e2bcd8739ae039 extends (0, $50657fe243c9e527$export$6b4c32f3d5b8738a) {
    _checkCrc;
    _inflator;
    _png;
    _apng;
    _end;
    _hasPalette;
    _palette;
    _hasTransparency;
    _transparency;
    _compressionMethod;
    _filterMethod;
    _interlaceMethod;
    _colorType;
    _isAnimated;
    _numberOfFrames;
    _numberOfPlays;
    _frames;
    _writingDataChunks;
    constructor(data, options = {}){
        super(data);
        const { checkCrc: checkCrc = false } = options;
        this._checkCrc = checkCrc;
        this._inflator = new (0, $44d791503925dde9$export$d1de70a877d6e43c)();
        this._png = {
            width: -1,
            height: -1,
            channels: -1,
            data: new Uint8Array(0),
            depth: 1,
            text: {}
        };
        this._apng = {
            width: -1,
            height: -1,
            channels: -1,
            depth: 1,
            numberOfFrames: 1,
            numberOfPlays: 0,
            text: {},
            frames: []
        };
        this._end = false;
        this._hasPalette = false;
        this._palette = [];
        this._hasTransparency = false;
        this._transparency = new Uint16Array(0);
        this._compressionMethod = (0, $8a9c4f57eda90c68$export$825f3c317f99229).UNKNOWN;
        this._filterMethod = (0, $8a9c4f57eda90c68$export$3ecd618ea72c47f7).UNKNOWN;
        this._interlaceMethod = (0, $8a9c4f57eda90c68$export$2b1dd3da86572fe2).UNKNOWN;
        this._colorType = (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).UNKNOWN;
        this._isAnimated = false;
        this._numberOfFrames = 1;
        this._numberOfPlays = 0;
        this._frames = [];
        this._writingDataChunks = false;
        // PNG is always big endian
        // https://www.w3.org/TR/PNG/#7Integers-and-byte-order
        this.setBigEndian();
    }
    decode() {
        (0, $41be136efb06da59$export$9b20e139d888fd41)(this);
        while(!this._end){
            const length = this.readUint32();
            const type = this.readChars(4);
            this.decodeChunk(length, type);
        }
        this.decodeImage();
        return this._png;
    }
    decodeApng() {
        (0, $41be136efb06da59$export$9b20e139d888fd41)(this);
        while(!this._end){
            const length = this.readUint32();
            const type = this.readChars(4);
            this.decodeApngChunk(length, type);
        }
        this.decodeApngImage();
        return this._apng;
    }
    // https://www.w3.org/TR/PNG/#5Chunk-layout
    decodeChunk(length, type) {
        const offset = this.offset;
        switch(type){
            // 11.2 Critical chunks
            case 'IHDR':
                this.decodeIHDR();
                break;
            case 'PLTE':
                this.decodePLTE(length);
                break;
            case 'IDAT':
                this.decodeIDAT(length);
                break;
            case 'IEND':
                this._end = true;
                break;
            // 11.3 Ancillary chunks
            case 'tRNS':
                this.decodetRNS(length);
                break;
            case 'iCCP':
                this.decodeiCCP(length);
                break;
            case 0, $24fb9ce7b4baa3bf$export$b7828eccb3fa75e:
                (0, $24fb9ce7b4baa3bf$export$eaa080cfa45e66ec)(this._png.text, this, length);
                break;
            case 'pHYs':
                this.decodepHYs();
                break;
            default:
                this.skip(length);
                break;
        }
        if (this.offset - offset !== length) throw new Error(`Length mismatch while decoding chunk ${type}`);
        if (this._checkCrc) (0, $856ecd6e54b74c05$export$a27e44f4abee07bd)(this, length + 4, type);
        else this.skip(4);
    }
    decodeApngChunk(length, type) {
        const offset = this.offset;
        if (type !== 'fdAT' && type !== 'IDAT' && this._writingDataChunks) this.pushDataToFrame();
        switch(type){
            case 'acTL':
                this.decodeACTL();
                break;
            case 'fcTL':
                this.decodeFCTL();
                break;
            case 'fdAT':
                this.decodeFDAT(length);
                break;
            default:
                this.decodeChunk(length, type);
                this.offset = offset + length;
                break;
        }
        if (this.offset - offset !== length) throw new Error(`Length mismatch while decoding chunk ${type}`);
        if (this._checkCrc) (0, $856ecd6e54b74c05$export$a27e44f4abee07bd)(this, length + 4, type);
        else this.skip(4);
    }
    // https://www.w3.org/TR/PNG/#11IHDR
    decodeIHDR() {
        const image = this._png;
        image.width = this.readUint32();
        image.height = this.readUint32();
        image.depth = $8d2b1a59512157d3$var$checkBitDepth(this.readUint8());
        const colorType = this.readUint8();
        this._colorType = colorType;
        let channels;
        switch(colorType){
            case (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).GREYSCALE:
                channels = 1;
                break;
            case (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).TRUECOLOUR:
                channels = 3;
                break;
            case (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).INDEXED_COLOUR:
                channels = 1;
                break;
            case (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).GREYSCALE_ALPHA:
                channels = 2;
                break;
            case (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).TRUECOLOUR_ALPHA:
                channels = 4;
                break;
            // Kept for exhaustiveness.
            // eslint-disable-next-line unicorn/no-useless-switch-case
            case (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).UNKNOWN:
            default:
                throw new Error(`Unknown color type: ${colorType}`);
        }
        this._png.channels = channels;
        this._compressionMethod = this.readUint8();
        if (this._compressionMethod !== (0, $8a9c4f57eda90c68$export$825f3c317f99229).DEFLATE) throw new Error(`Unsupported compression method: ${this._compressionMethod}`);
        this._filterMethod = this.readUint8();
        this._interlaceMethod = this.readUint8();
    }
    decodeACTL() {
        this._numberOfFrames = this.readUint32();
        this._numberOfPlays = this.readUint32();
        this._isAnimated = true;
    }
    decodeFCTL() {
        const image = {
            sequenceNumber: this.readUint32(),
            width: this.readUint32(),
            height: this.readUint32(),
            xOffset: this.readUint32(),
            yOffset: this.readUint32(),
            delayNumber: this.readUint16(),
            delayDenominator: this.readUint16(),
            disposeOp: this.readUint8(),
            blendOp: this.readUint8(),
            data: new Uint8Array(0)
        };
        this._frames.push(image);
    }
    // https://www.w3.org/TR/PNG/#11PLTE
    decodePLTE(length) {
        if (length % 3 !== 0) throw new RangeError(`PLTE field length must be a multiple of 3. Got ${length}`);
        const l = length / 3;
        this._hasPalette = true;
        const palette = [];
        this._palette = palette;
        for(let i = 0; i < l; i++)palette.push([
            this.readUint8(),
            this.readUint8(),
            this.readUint8()
        ]);
    }
    // https://www.w3.org/TR/PNG/#11IDAT
    decodeIDAT(length) {
        this._writingDataChunks = true;
        const dataLength = length;
        const dataOffset = this.offset + this.byteOffset;
        this._inflator.push(new Uint8Array(this.buffer, dataOffset, dataLength));
        if (this._inflator.err) throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
        this.skip(length);
    }
    decodeFDAT(length) {
        this._writingDataChunks = true;
        let dataLength = length;
        let dataOffset = this.offset + this.byteOffset;
        dataOffset += 4;
        dataLength -= 4;
        this._inflator.push(new Uint8Array(this.buffer, dataOffset, dataLength));
        if (this._inflator.err) throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
        this.skip(length);
    }
    // https://www.w3.org/TR/PNG/#11tRNS
    decodetRNS(length) {
        switch(this._colorType){
            case (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).GREYSCALE:
            case (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).TRUECOLOUR:
                if (length % 2 !== 0) throw new RangeError(`tRNS chunk length must be a multiple of 2. Got ${length}`);
                if (length / 2 > this._png.width * this._png.height) throw new Error(`tRNS chunk contains more alpha values than there are pixels (${length / 2} vs ${this._png.width * this._png.height})`);
                this._hasTransparency = true;
                this._transparency = new Uint16Array(length / 2);
                for(let i = 0; i < length / 2; i++)this._transparency[i] = this.readUint16();
                break;
            case (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).INDEXED_COLOUR:
                {
                    if (length > this._palette.length) throw new Error(`tRNS chunk contains more alpha values than there are palette colors (${length} vs ${this._palette.length})`);
                    let i = 0;
                    for(; i < length; i++){
                        const alpha = this.readByte();
                        this._palette[i].push(alpha);
                    }
                    for(; i < this._palette.length; i++)this._palette[i].push(255);
                    break;
                }
            // Kept for exhaustiveness.
            /* eslint-disable unicorn/no-useless-switch-case */ case (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).UNKNOWN:
            case (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).GREYSCALE_ALPHA:
            case (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).TRUECOLOUR_ALPHA:
            default:
                throw new Error(`tRNS chunk is not supported for color type ${this._colorType}`);
        }
    }
    // https://www.w3.org/TR/PNG/#11iCCP
    decodeiCCP(length) {
        const name = (0, $24fb9ce7b4baa3bf$export$7ff9b48854e294c6)(this);
        const compressionMethod = this.readUint8();
        if (compressionMethod !== (0, $8a9c4f57eda90c68$export$825f3c317f99229).DEFLATE) throw new Error(`Unsupported iCCP compression method: ${compressionMethod}`);
        const compressedProfile = this.readBytes(length - name.length - 2);
        this._png.iccEmbeddedProfile = {
            name: name,
            profile: (0, $44d791503925dde9$export$cae1ce83fe4a1782)(compressedProfile)
        };
    }
    // https://www.w3.org/TR/PNG/#11pHYs
    decodepHYs() {
        const ppuX = this.readUint32();
        const ppuY = this.readUint32();
        const unitSpecifier = this.readByte();
        this._png.resolution = {
            x: ppuX,
            y: ppuY,
            unit: unitSpecifier
        };
    }
    decodeApngImage() {
        this._apng.width = this._png.width;
        this._apng.height = this._png.height;
        this._apng.channels = this._png.channels;
        this._apng.depth = this._png.depth;
        this._apng.numberOfFrames = this._numberOfFrames;
        this._apng.numberOfPlays = this._numberOfPlays;
        this._apng.text = this._png.text;
        this._apng.resolution = this._png.resolution;
        for(let i = 0; i < this._numberOfFrames; i++){
            const newFrame = {
                sequenceNumber: this._frames[i].sequenceNumber,
                delayNumber: this._frames[i].delayNumber,
                delayDenominator: this._frames[i].delayDenominator,
                data: this._apng.depth === 8 ? new Uint8Array(this._apng.width * this._apng.height * this._apng.channels) : new Uint16Array(this._apng.width * this._apng.height * this._apng.channels)
            };
            const frame = this._frames.at(i);
            if (frame) {
                frame.data = (0, $537230e51d3d3bdc$export$fe66f1bbb29d778e)({
                    data: frame.data,
                    width: frame.width,
                    height: frame.height,
                    channels: this._apng.channels,
                    depth: this._apng.depth
                });
                if (this._hasPalette) this._apng.palette = this._palette;
                if (this._hasTransparency) this._apng.transparency = this._transparency;
                if (i === 0 || frame.xOffset === 0 && frame.yOffset === 0 && frame.width === this._png.width && frame.height === this._png.height) newFrame.data = frame.data;
                else {
                    const prevFrame = this._apng.frames.at(i - 1);
                    this.disposeFrame(frame, prevFrame, newFrame);
                    this.addFrameDataToCanvas(newFrame, frame);
                }
                this._apng.frames.push(newFrame);
            }
        }
        return this._apng;
    }
    disposeFrame(frame, prevFrame, imageFrame) {
        switch(frame.disposeOp){
            case (0, $8a9c4f57eda90c68$export$c2de24028defae28).NONE:
                break;
            case (0, $8a9c4f57eda90c68$export$c2de24028defae28).BACKGROUND:
                for(let row = 0; row < this._png.height; row++)for(let col = 0; col < this._png.width; col++){
                    const index = (row * frame.width + col) * this._png.channels;
                    for(let channel = 0; channel < this._png.channels; channel++)imageFrame.data[index + channel] = 0;
                }
                break;
            case (0, $8a9c4f57eda90c68$export$c2de24028defae28).PREVIOUS:
                imageFrame.data.set(prevFrame.data);
                break;
            default:
                throw new Error('Unknown disposeOp');
        }
    }
    addFrameDataToCanvas(imageFrame, frame) {
        const maxValue = 1 << this._png.depth;
        const calculatePixelIndices = (row, col)=>{
            const index = ((row + frame.yOffset) * this._png.width + frame.xOffset + col) * this._png.channels;
            const frameIndex = (row * frame.width + col) * this._png.channels;
            return {
                index: index,
                frameIndex: frameIndex
            };
        };
        switch(frame.blendOp){
            case (0, $8a9c4f57eda90c68$export$b8d06ec133a3a0ca).SOURCE:
                for(let row = 0; row < frame.height; row++)for(let col = 0; col < frame.width; col++){
                    const { index: index, frameIndex: frameIndex } = calculatePixelIndices(row, col);
                    for(let channel = 0; channel < this._png.channels; channel++)imageFrame.data[index + channel] = frame.data[frameIndex + channel];
                }
                break;
            // https://www.w3.org/TR/png-3/#13Alpha-channel-processing
            case (0, $8a9c4f57eda90c68$export$b8d06ec133a3a0ca).OVER:
                for(let row = 0; row < frame.height; row++)for(let col = 0; col < frame.width; col++){
                    const { index: index, frameIndex: frameIndex } = calculatePixelIndices(row, col);
                    for(let channel = 0; channel < this._png.channels; channel++){
                        const sourceAlpha = frame.data[frameIndex + this._png.channels - 1] / maxValue;
                        const foregroundValue = channel % (this._png.channels - 1) === 0 ? 1 : frame.data[frameIndex + channel];
                        const value = Math.floor(sourceAlpha * foregroundValue + (1 - sourceAlpha) * imageFrame.data[index + channel]);
                        imageFrame.data[index + channel] += value;
                    }
                }
                break;
            default:
                throw new Error('Unknown blendOp');
        }
    }
    decodeImage() {
        if (this._inflator.err) throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
        const data = this._isAnimated ? (this._frames?.at(0)).data : this._inflator.result;
        if (this._filterMethod !== (0, $8a9c4f57eda90c68$export$3ecd618ea72c47f7).ADAPTIVE) throw new Error(`Filter method ${this._filterMethod} not supported`);
        if (this._interlaceMethod === (0, $8a9c4f57eda90c68$export$2b1dd3da86572fe2).NO_INTERLACE) this._png.data = (0, $537230e51d3d3bdc$export$fe66f1bbb29d778e)({
            data: data,
            width: this._png.width,
            height: this._png.height,
            channels: this._png.channels,
            depth: this._png.depth
        });
        else if (this._interlaceMethod === (0, $8a9c4f57eda90c68$export$2b1dd3da86572fe2).ADAM7) this._png.data = (0, $5f6e764cf1569d03$export$4e311ab71083585)({
            data: data,
            width: this._png.width,
            height: this._png.height,
            channels: this._png.channels,
            depth: this._png.depth
        });
        else throw new Error(`Interlace method ${this._interlaceMethod} not supported`);
        if (this._hasPalette) this._png.palette = this._palette;
        if (this._hasTransparency) this._png.transparency = this._transparency;
    }
    pushDataToFrame() {
        const result = this._inflator.result;
        const lastFrame = this._frames.at(-1);
        if (lastFrame) lastFrame.data = result;
        else this._frames.push({
            sequenceNumber: 0,
            width: this._png.width,
            height: this._png.height,
            xOffset: 0,
            yOffset: 0,
            delayNumber: 0,
            delayDenominator: 0,
            disposeOp: (0, $8a9c4f57eda90c68$export$c2de24028defae28).NONE,
            blendOp: (0, $8a9c4f57eda90c68$export$b8d06ec133a3a0ca).SOURCE,
            data: result
        });
        this._inflator = new (0, $44d791503925dde9$export$d1de70a877d6e43c)();
        this._writingDataChunks = false;
    }
}
function $8d2b1a59512157d3$var$checkBitDepth(value) {
    if (value !== 1 && value !== 2 && value !== 4 && value !== 8 && value !== 16) throw new Error(`invalid bit depth: ${value}`);
    return value;
}








const $7f33b3c0f1042d71$var$defaultZlibOptions = {
    level: 3
};
class $7f33b3c0f1042d71$export$2e2bcd8739ae039 extends (0, $50657fe243c9e527$export$6b4c32f3d5b8738a) {
    _png;
    _zlibOptions;
    _colorType;
    _interlaceMethod;
    constructor(data, options = {}){
        super();
        this._colorType = (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).UNKNOWN;
        this._zlibOptions = {
            ...$7f33b3c0f1042d71$var$defaultZlibOptions,
            ...options.zlib
        };
        this._png = this._checkData(data);
        this._interlaceMethod = (options.interlace === 'Adam7' ? (0, $8a9c4f57eda90c68$export$2b1dd3da86572fe2).ADAM7 : (0, $8a9c4f57eda90c68$export$2b1dd3da86572fe2).NO_INTERLACE) ?? (0, $8a9c4f57eda90c68$export$2b1dd3da86572fe2).NO_INTERLACE;
        this.setBigEndian();
    }
    encode() {
        (0, $41be136efb06da59$export$6d91aec43a397576)(this);
        this.encodeIHDR();
        if (this._png.palette) {
            this.encodePLTE();
            if (this._png.palette[0].length === 4) this.encodeTRNS();
        }
        this.encodeData();
        if (this._png.text) for (const [keyword, text] of Object.entries(this._png.text))(0, $24fb9ce7b4baa3bf$export$304fabbece3077af)(this, keyword, text);
        this.encodeIEND();
        return this.toArray();
    }
    // https://www.w3.org/TR/PNG/#11IHDR
    encodeIHDR() {
        this.writeUint32(13);
        this.writeChars('IHDR');
        this.writeUint32(this._png.width);
        this.writeUint32(this._png.height);
        this.writeByte(this._png.depth);
        this.writeByte(this._colorType);
        this.writeByte((0, $8a9c4f57eda90c68$export$825f3c317f99229).DEFLATE);
        this.writeByte((0, $8a9c4f57eda90c68$export$3ecd618ea72c47f7).ADAPTIVE);
        this.writeByte(this._interlaceMethod);
        (0, $856ecd6e54b74c05$export$f1eadea2b27d7525)(this, 17);
    }
    // https://www.w3.org/TR/PNG/#11IEND
    encodeIEND() {
        this.writeUint32(0);
        this.writeChars('IEND');
        (0, $856ecd6e54b74c05$export$f1eadea2b27d7525)(this, 4);
    }
    encodePLTE() {
        const paletteLength = this._png.palette?.length * 3;
        this.writeUint32(paletteLength);
        this.writeChars('PLTE');
        for (const color of this._png.palette){
            this.writeByte(color[0]);
            this.writeByte(color[1]);
            this.writeByte(color[2]);
        }
        (0, $856ecd6e54b74c05$export$f1eadea2b27d7525)(this, 4 + paletteLength);
    }
    encodeTRNS() {
        const alpha = this._png.palette.filter((color)=>{
            return color.at(-1) !== 255;
        });
        this.writeUint32(alpha.length);
        this.writeChars('tRNS');
        for (const el of alpha)this.writeByte(el.at(-1));
        (0, $856ecd6e54b74c05$export$f1eadea2b27d7525)(this, 4 + alpha.length);
    }
    // https://www.w3.org/TR/PNG/#11IDAT
    encodeIDAT(data) {
        this.writeUint32(data.length);
        this.writeChars('IDAT');
        this.writeBytes(data);
        (0, $856ecd6e54b74c05$export$f1eadea2b27d7525)(this, data.length + 4);
    }
    encodeData() {
        const { width: width, height: height, channels: channels, depth: depth, data: data } = this._png;
        const slotsPerLine = depth <= 8 ? Math.ceil(width * depth / 8) * channels : Math.ceil(width * depth / 8 * channels / 2);
        const newData = new (0, $50657fe243c9e527$export$6b4c32f3d5b8738a)().setBigEndian();
        let offset = 0;
        if (this._interlaceMethod === (0, $8a9c4f57eda90c68$export$2b1dd3da86572fe2).NO_INTERLACE) for(let i = 0; i < height; i++){
            newData.writeByte(0); // no filter
            if (depth === 16) offset = $7f33b3c0f1042d71$var$writeDataUint16(data, newData, slotsPerLine, offset);
            else offset = $7f33b3c0f1042d71$var$writeDataBytes(data, newData, slotsPerLine, offset);
        }
        else if (this._interlaceMethod === (0, $8a9c4f57eda90c68$export$2b1dd3da86572fe2).ADAM7) // Adam7 interlacing
        offset = $7f33b3c0f1042d71$var$writeDataInterlaced(this._png, data, newData, offset);
        const buffer = newData.toArray();
        const compressed = (0, $44d791503925dde9$export$2316623ecd1285ab)(buffer, this._zlibOptions);
        this.encodeIDAT(compressed);
    }
    _checkData(data) {
        const { colorType: colorType, channels: channels, depth: depth } = $7f33b3c0f1042d71$var$getColorType(data, data.palette);
        const png = {
            width: $7f33b3c0f1042d71$var$checkInteger(data.width, 'width'),
            height: $7f33b3c0f1042d71$var$checkInteger(data.height, 'height'),
            channels: channels,
            data: data.data,
            depth: depth,
            text: data.text,
            palette: data.palette
        };
        this._colorType = colorType;
        const expectedSize = depth < 8 ? Math.ceil(png.width * depth / 8) * png.height * channels : png.width * png.height * channels;
        if (png.data.length !== expectedSize) throw new RangeError(`wrong data size. Found ${png.data.length}, expected ${expectedSize}`);
        return png;
    }
}
function $7f33b3c0f1042d71$var$checkInteger(value, name) {
    if (Number.isInteger(value) && value > 0) return value;
    throw new TypeError(`${name} must be a positive integer`);
}
function $7f33b3c0f1042d71$var$getColorType(data, palette) {
    const { channels: channels = 4, depth: depth = 8 } = data;
    if (channels !== 4 && channels !== 3 && channels !== 2 && channels !== 1) throw new RangeError(`unsupported number of channels: ${channels}`);
    const returnValue = {
        channels: channels,
        depth: depth,
        colorType: (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).UNKNOWN
    };
    switch(channels){
        case 4:
            returnValue.colorType = (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).TRUECOLOUR_ALPHA;
            break;
        case 3:
            returnValue.colorType = (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).TRUECOLOUR;
            break;
        case 1:
            if (palette) returnValue.colorType = (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).INDEXED_COLOUR;
            else returnValue.colorType = (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).GREYSCALE;
            break;
        case 2:
            returnValue.colorType = (0, $8a9c4f57eda90c68$export$2cd82751acc0e609).GREYSCALE_ALPHA;
            break;
        default:
            throw new Error('unsupported number of channels');
    }
    return returnValue;
}
function $7f33b3c0f1042d71$var$writeDataBytes(data, newData, slotsPerLine, offset) {
    for(let j = 0; j < slotsPerLine; j++)newData.writeByte(data[offset++]);
    return offset;
}
function $7f33b3c0f1042d71$var$writeDataInterlaced(imageData, data, newData, offset) {
    const passes = [
        {
            x: 0,
            y: 0,
            xStep: 8,
            yStep: 8
        },
        {
            x: 4,
            y: 0,
            xStep: 8,
            yStep: 8
        },
        {
            x: 0,
            y: 4,
            xStep: 4,
            yStep: 8
        },
        {
            x: 2,
            y: 0,
            xStep: 4,
            yStep: 4
        },
        {
            x: 0,
            y: 2,
            xStep: 2,
            yStep: 4
        },
        {
            x: 1,
            y: 0,
            xStep: 2,
            yStep: 2
        },
        {
            x: 0,
            y: 1,
            xStep: 1,
            yStep: 2
        }
    ];
    const { width: width, height: height, channels: channels, depth: depth } = imageData;
    let pixelSize = 0;
    if (depth === 16) pixelSize = channels * depth / 8 / 2;
    else pixelSize = channels * depth / 8;
    // Process each pass
    for(let passIndex = 0; passIndex < 7; passIndex++){
        const pass = passes[passIndex];
        const passWidth = Math.floor((width - pass.x + pass.xStep - 1) / pass.xStep);
        const passHeight = Math.floor((height - pass.y + pass.yStep - 1) / pass.yStep);
        if (passWidth <= 0 || passHeight <= 0) continue;
        const passLineBytes = passWidth * pixelSize;
        // For each scanline in this pass
        for(let y = 0; y < passHeight; y++){
            const imageY = pass.y + y * pass.yStep;
            // Extract raw scanline data
            const rawScanline = depth <= 8 ? new Uint8Array(passLineBytes) : new Uint16Array(passLineBytes);
            let rawOffset = 0;
            for(let x = 0; x < passWidth; x++){
                const imageX = pass.x + x * pass.xStep;
                if (imageX < width && imageY < height) {
                    const srcPos = (imageY * width + imageX) * pixelSize;
                    for(let i = 0; i < pixelSize; i++)rawScanline[rawOffset++] = data[srcPos + i];
                }
            }
            newData.writeByte(0); // no filter
            if (depth === 8) newData.writeBytes(rawScanline);
            else if (depth === 16) for (const value of rawScanline){
                newData.writeByte(value >> 8 & 0xff); // High byte
                newData.writeByte(value & 0xff);
            }
        }
    }
    return offset;
}
function $7f33b3c0f1042d71$var$writeDataUint16(data, newData, slotsPerLine, offset) {
    for(let j = 0; j < slotsPerLine; j++)newData.writeUint16(data[offset++]);
    return offset;
}



var $ea38610b4d2f7a30$export$ba7e3928a2814288;
(function(ResolutionUnitSpecifier) {
    /**
     * Unit is unknown
     */ ResolutionUnitSpecifier[ResolutionUnitSpecifier["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * Unit is the metre
     */ ResolutionUnitSpecifier[ResolutionUnitSpecifier["METRE"] = 1] = "METRE";
})($ea38610b4d2f7a30$export$ba7e3928a2814288 || ($ea38610b4d2f7a30$export$ba7e3928a2814288 = {}));


/**
 * Converts indexed data into RGB/RGBA format
 * @param decodedImage - Image to decode data from.
 * @returns Uint8Array with RGB data.
 */ function $2d57feaf750a2bb0$export$83c94b26563411c8(decodedImage) {
    const palette = decodedImage.palette;
    const depth = decodedImage.depth;
    if (!palette) throw new Error('Color palette is undefined.');
    $2d57feaf750a2bb0$var$checkDataSize(decodedImage);
    const indexSize = decodedImage.width * decodedImage.height;
    const resSize = indexSize * palette[0].length;
    const res = new Uint8Array(resSize);
    let indexPos = 0;
    let offset = 0;
    const indexes = new Uint8Array(indexSize);
    let bit = 0xff;
    switch(depth){
        case 1:
            bit = 0x80;
            break;
        case 2:
            bit = 0xc0;
            break;
        case 4:
            bit = 0xf0;
            break;
        case 8:
            bit = 0xff;
            break;
        default:
            throw new Error('Incorrect depth value');
    }
    for (const byte of decodedImage.data){
        let bit2 = bit;
        let shift = 8;
        while(bit2){
            shift -= depth;
            indexes[indexPos++] = (byte & bit2) >> shift;
            bit2 = bit2 >> depth;
            if (indexPos % decodedImage.width === 0) break;
        }
    }
    if (decodedImage.palette) for (const index of indexes){
        const color = decodedImage.palette.at(index);
        if (!color) throw new Error('Incorrect index of palette color');
        res.set(color, offset);
        offset += color.length;
    }
    return res;
}
function $2d57feaf750a2bb0$var$checkDataSize(image) {
    const expectedSize = image.depth < 8 ? Math.ceil(image.width * image.depth / 8) * image.height * image.channels : image.width * image.height * image.channels;
    if (image.data.length !== expectedSize) throw new RangeError(`wrong data size. Found ${image.data.length}, expected ${expectedSize}`);
}


function $0022f0488c89b7e3$export$2f872c0f2117be69(data, options) {
    const decoder = new (0, $8d2b1a59512157d3$export$2e2bcd8739ae039)(data, options);
    return decoder.decode();
}
function $0022f0488c89b7e3$export$c564cdbbe6da493(png, options) {
    const encoder = new (0, $7f33b3c0f1042d71$export$2e2bcd8739ae039)(png, options);
    return encoder.encode();
}
function $0022f0488c89b7e3$export$2a608823614fb725(data, options) {
    const decoder = new (0, $8d2b1a59512157d3$export$2e2bcd8739ae039)(data, options);
    return decoder.decodeApng();
}


var $dbd37edd557d3750$var$i = function() {
    return "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : this;
}();
function $dbd37edd557d3750$var$a() {
    $dbd37edd557d3750$var$i.console && "function" == typeof $dbd37edd557d3750$var$i.console.log && $dbd37edd557d3750$var$i.console.log.apply($dbd37edd557d3750$var$i.console, arguments);
}
var $dbd37edd557d3750$var$o = {
    log: $dbd37edd557d3750$var$a,
    warn: function(t) {
        $dbd37edd557d3750$var$i.console && ("function" == typeof $dbd37edd557d3750$var$i.console.warn ? $dbd37edd557d3750$var$i.console.warn.apply($dbd37edd557d3750$var$i.console, arguments) : $dbd37edd557d3750$var$a.call(null, arguments));
    },
    error: function(t) {
        $dbd37edd557d3750$var$i.console && ("function" == typeof $dbd37edd557d3750$var$i.console.error ? $dbd37edd557d3750$var$i.console.error.apply($dbd37edd557d3750$var$i.console, arguments) : $dbd37edd557d3750$var$a(t));
    }
};
function $dbd37edd557d3750$var$s(t, e, r) {
    var n = new XMLHttpRequest;
    n.open("GET", t), n.responseType = "blob", n.onload = function() {
        $dbd37edd557d3750$var$l(n.response, e, r);
    }, n.onerror = function() {
        $dbd37edd557d3750$var$o.error("could not download file");
    }, n.send();
}
function $dbd37edd557d3750$var$u(t) {
    var e = new XMLHttpRequest;
    e.open("HEAD", t, !1);
    try {
        e.send();
    } catch (r) {}
    return e.status >= 200 && e.status <= 299;
}
function $dbd37edd557d3750$var$c(t) {
    try {
        t.dispatchEvent(new MouseEvent("click"));
    } catch (r) {
        var e = document.createEvent("MouseEvents");
        e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), t.dispatchEvent(e);
    }
}
var $dbd37edd557d3750$var$l = $dbd37edd557d3750$var$i.saveAs || ("object" !== ("undefined" == typeof window ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(window)) || window !== $dbd37edd557d3750$var$i ? function() {} : "undefined" != typeof HTMLAnchorElement && "download" in HTMLAnchorElement.prototype ? function(t, e, r) {
    var n = $dbd37edd557d3750$var$i.URL || $dbd37edd557d3750$var$i.webkitURL, a = document.createElement("a");
    e = e || t.name || "download", a.download = e, a.rel = "noopener", "string" == typeof t ? (a.href = t, a.origin !== location.origin ? $dbd37edd557d3750$var$u(a.href) ? $dbd37edd557d3750$var$s(t, e, r) : $dbd37edd557d3750$var$c(a, a.target = "_blank") : $dbd37edd557d3750$var$c(a)) : (a.href = n.createObjectURL(t), setTimeout(function() {
        n.revokeObjectURL(a.href);
    }, 4e4), setTimeout(function() {
        $dbd37edd557d3750$var$c(a);
    }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(e, r, n) {
    if (r = r || e.name || "download", "string" == typeof e) {
        if ($dbd37edd557d3750$var$u(e)) $dbd37edd557d3750$var$s(e, r, n);
        else {
            var i = document.createElement("a");
            i.href = e, i.target = "_blank", setTimeout(function() {
                $dbd37edd557d3750$var$c(i);
            });
        }
    } else navigator.msSaveOrOpenBlob(function(e, r) {
        return void 0 === r ? r = {
            autoBom: !1
        } : "object" !== (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(r) && ($dbd37edd557d3750$var$o.warn("Deprecated: Expected third argument to be a object"), r = {
            autoBom: !r
        }), r.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob([
            String.fromCharCode(65279),
            e
        ], {
            type: e.type
        }) : e;
    }(e, n), r);
} : function(e, r, n, a) {
    if ((a = a || open("", "_blank")) && (a.document.title = a.document.body.innerText = "downloading..."), "string" == typeof e) return $dbd37edd557d3750$var$s(e, r, n);
    var o = "application/octet-stream" === e.type, u = /constructor/i.test($dbd37edd557d3750$var$i.HTMLElement) || $dbd37edd557d3750$var$i.safari, c = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((c || o && u) && "object" === ("undefined" == typeof FileReader ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(FileReader))) {
        var l = new FileReader;
        l.onloadend = function() {
            var t = l.result;
            t = c ? t : t.replace(/^data:[^;]*;/, "data:attachment/file;"), a ? a.location.href = t : location = t, a = null;
        }, l.readAsDataURL(e);
    } else {
        var h = $dbd37edd557d3750$var$i.URL || $dbd37edd557d3750$var$i.webkitURL, f = h.createObjectURL(e);
        a ? a.location = f : location.href = f, a = null, setTimeout(function() {
            h.revokeObjectURL(f);
        }, 4e4);
    }
});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */ function $dbd37edd557d3750$var$h(t) {
    var e;
    t = t || "", this.ok = !1, "#" == t.charAt(0) && (t = t.substr(1, 6)), t = ({
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "00ffff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000000",
        blanchedalmond: "ffebcd",
        blue: "0000ff",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "00ffff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dodgerblue: "1e90ff",
        feldspar: "d19275",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "ff00ff",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgrey: "d3d3d3",
        lightgreen: "90ee90",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslateblue: "8470ff",
        lightslategray: "778899",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "00ff00",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "ff00ff",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370d8",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "d87093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        red: "ff0000",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        violetred: "d02090",
        wheat: "f5deb3",
        white: "ffffff",
        whitesmoke: "f5f5f5",
        yellow: "ffff00",
        yellowgreen: "9acd32"
    })[t = (t = t.replace(/ /g, "")).toLowerCase()] || t;
    for(var r = [
        {
            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
            example: [
                "rgb(123, 234, 45)",
                "rgb(255,234,245)"
            ],
            process: function(t) {
                return [
                    parseInt(t[1]),
                    parseInt(t[2]),
                    parseInt(t[3])
                ];
            }
        },
        {
            re: /^(\w{2})(\w{2})(\w{2})$/,
            example: [
                "#00ff00",
                "336699"
            ],
            process: function(t) {
                return [
                    parseInt(t[1], 16),
                    parseInt(t[2], 16),
                    parseInt(t[3], 16)
                ];
            }
        },
        {
            re: /^(\w{1})(\w{1})(\w{1})$/,
            example: [
                "#fb0",
                "f0f"
            ],
            process: function(t) {
                return [
                    parseInt(t[1] + t[1], 16),
                    parseInt(t[2] + t[2], 16),
                    parseInt(t[3] + t[3], 16)
                ];
            }
        }
    ], n = 0; n < r.length; n++){
        var i = r[n].re, a = r[n].process, o = i.exec(t);
        o && (e = a(o), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
    }
    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
        return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
    }, this.toHex = function() {
        var t = this.r.toString(16), e = this.g.toString(16), r = this.b.toString(16);
        return 1 == t.length && (t = "0" + t), 1 == e.length && (e = "0" + e), 1 == r.length && (r = "0" + r), "#" + t + e + r;
    };
}
var $dbd37edd557d3750$var$f = $dbd37edd557d3750$var$i.atob.bind($dbd37edd557d3750$var$i), $dbd37edd557d3750$var$d = $dbd37edd557d3750$var$i.btoa.bind($dbd37edd557d3750$var$i);
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */ function $dbd37edd557d3750$var$p(t, e) {
    var r = t[0], n = t[1], i = t[2], a = t[3];
    r = $dbd37edd557d3750$var$m(r, n, i, a, e[0], 7, -680876936), a = $dbd37edd557d3750$var$m(a, r, n, i, e[1], 12, -389564586), i = $dbd37edd557d3750$var$m(i, a, r, n, e[2], 17, 606105819), n = $dbd37edd557d3750$var$m(n, i, a, r, e[3], 22, -1044525330), r = $dbd37edd557d3750$var$m(r, n, i, a, e[4], 7, -176418897), a = $dbd37edd557d3750$var$m(a, r, n, i, e[5], 12, 1200080426), i = $dbd37edd557d3750$var$m(i, a, r, n, e[6], 17, -1473231341), n = $dbd37edd557d3750$var$m(n, i, a, r, e[7], 22, -45705983), r = $dbd37edd557d3750$var$m(r, n, i, a, e[8], 7, 1770035416), a = $dbd37edd557d3750$var$m(a, r, n, i, e[9], 12, -1958414417), i = $dbd37edd557d3750$var$m(i, a, r, n, e[10], 17, -42063), n = $dbd37edd557d3750$var$m(n, i, a, r, e[11], 22, -1990404162), r = $dbd37edd557d3750$var$m(r, n, i, a, e[12], 7, 1804603682), a = $dbd37edd557d3750$var$m(a, r, n, i, e[13], 12, -40341101), i = $dbd37edd557d3750$var$m(i, a, r, n, e[14], 17, -1502002290), r = $dbd37edd557d3750$var$v(r, n = $dbd37edd557d3750$var$m(n, i, a, r, e[15], 22, 1236535329), i, a, e[1], 5, -165796510), a = $dbd37edd557d3750$var$v(a, r, n, i, e[6], 9, -1069501632), i = $dbd37edd557d3750$var$v(i, a, r, n, e[11], 14, 643717713), n = $dbd37edd557d3750$var$v(n, i, a, r, e[0], 20, -373897302), r = $dbd37edd557d3750$var$v(r, n, i, a, e[5], 5, -701558691), a = $dbd37edd557d3750$var$v(a, r, n, i, e[10], 9, 38016083), i = $dbd37edd557d3750$var$v(i, a, r, n, e[15], 14, -660478335), n = $dbd37edd557d3750$var$v(n, i, a, r, e[4], 20, -405537848), r = $dbd37edd557d3750$var$v(r, n, i, a, e[9], 5, 568446438), a = $dbd37edd557d3750$var$v(a, r, n, i, e[14], 9, -1019803690), i = $dbd37edd557d3750$var$v(i, a, r, n, e[3], 14, -187363961), n = $dbd37edd557d3750$var$v(n, i, a, r, e[8], 20, 1163531501), r = $dbd37edd557d3750$var$v(r, n, i, a, e[13], 5, -1444681467), a = $dbd37edd557d3750$var$v(a, r, n, i, e[2], 9, -51403784), i = $dbd37edd557d3750$var$v(i, a, r, n, e[7], 14, 1735328473), r = $dbd37edd557d3750$var$b(r, n = $dbd37edd557d3750$var$v(n, i, a, r, e[12], 20, -1926607734), i, a, e[5], 4, -378558), a = $dbd37edd557d3750$var$b(a, r, n, i, e[8], 11, -2022574463), i = $dbd37edd557d3750$var$b(i, a, r, n, e[11], 16, 1839030562), n = $dbd37edd557d3750$var$b(n, i, a, r, e[14], 23, -35309556), r = $dbd37edd557d3750$var$b(r, n, i, a, e[1], 4, -1530992060), a = $dbd37edd557d3750$var$b(a, r, n, i, e[4], 11, 1272893353), i = $dbd37edd557d3750$var$b(i, a, r, n, e[7], 16, -155497632), n = $dbd37edd557d3750$var$b(n, i, a, r, e[10], 23, -1094730640), r = $dbd37edd557d3750$var$b(r, n, i, a, e[13], 4, 681279174), a = $dbd37edd557d3750$var$b(a, r, n, i, e[0], 11, -358537222), i = $dbd37edd557d3750$var$b(i, a, r, n, e[3], 16, -722521979), n = $dbd37edd557d3750$var$b(n, i, a, r, e[6], 23, 76029189), r = $dbd37edd557d3750$var$b(r, n, i, a, e[9], 4, -640364487), a = $dbd37edd557d3750$var$b(a, r, n, i, e[12], 11, -421815835), i = $dbd37edd557d3750$var$b(i, a, r, n, e[15], 16, 530742520), r = $dbd37edd557d3750$var$y(r, n = $dbd37edd557d3750$var$b(n, i, a, r, e[2], 23, -995338651), i, a, e[0], 6, -198630844), a = $dbd37edd557d3750$var$y(a, r, n, i, e[7], 10, 1126891415), i = $dbd37edd557d3750$var$y(i, a, r, n, e[14], 15, -1416354905), n = $dbd37edd557d3750$var$y(n, i, a, r, e[5], 21, -57434055), r = $dbd37edd557d3750$var$y(r, n, i, a, e[12], 6, 1700485571), a = $dbd37edd557d3750$var$y(a, r, n, i, e[3], 10, -1894986606), i = $dbd37edd557d3750$var$y(i, a, r, n, e[10], 15, -1051523), n = $dbd37edd557d3750$var$y(n, i, a, r, e[1], 21, -2054922799), r = $dbd37edd557d3750$var$y(r, n, i, a, e[8], 6, 1873313359), a = $dbd37edd557d3750$var$y(a, r, n, i, e[15], 10, -30611744), i = $dbd37edd557d3750$var$y(i, a, r, n, e[6], 15, -1560198380), n = $dbd37edd557d3750$var$y(n, i, a, r, e[13], 21, 1309151649), r = $dbd37edd557d3750$var$y(r, n, i, a, e[4], 6, -145523070), a = $dbd37edd557d3750$var$y(a, r, n, i, e[11], 10, -1120210379), i = $dbd37edd557d3750$var$y(i, a, r, n, e[2], 15, 718787259), n = $dbd37edd557d3750$var$y(n, i, a, r, e[9], 21, -343485551), t[0] = $dbd37edd557d3750$var$P(r, t[0]), t[1] = $dbd37edd557d3750$var$P(n, t[1]), t[2] = $dbd37edd557d3750$var$P(i, t[2]), t[3] = $dbd37edd557d3750$var$P(a, t[3]);
}
function $dbd37edd557d3750$var$g(t, e, r, n, i, a) {
    return e = $dbd37edd557d3750$var$P($dbd37edd557d3750$var$P(e, t), $dbd37edd557d3750$var$P(n, a)), $dbd37edd557d3750$var$P(e << i | e >>> 32 - i, r);
}
function $dbd37edd557d3750$var$m(t, e, r, n, i, a, o) {
    return $dbd37edd557d3750$var$g(e & r | ~e & n, t, e, i, a, o);
}
function $dbd37edd557d3750$var$v(t, e, r, n, i, a, o) {
    return $dbd37edd557d3750$var$g(e & n | r & ~n, t, e, i, a, o);
}
function $dbd37edd557d3750$var$b(t, e, r, n, i, a, o) {
    return $dbd37edd557d3750$var$g(e ^ r ^ n, t, e, i, a, o);
}
function $dbd37edd557d3750$var$y(t, e, r, n, i, a, o) {
    return $dbd37edd557d3750$var$g(r ^ (e | ~n), t, e, i, a, o);
}
function $dbd37edd557d3750$var$w(t) {
    var e, r = t.length, n = [
        1732584193,
        -271733879,
        -1732584194,
        271733878
    ];
    for(e = 64; e <= t.length; e += 64)$dbd37edd557d3750$var$p(n, $dbd37edd557d3750$var$N(t.substring(e - 64, e)));
    t = t.substring(e - 64);
    var i = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    for(e = 0; e < t.length; e++)i[e >> 2] |= t.charCodeAt(e) << (e % 4 << 3);
    if (i[e >> 2] |= 128 << (e % 4 << 3), e > 55) for($dbd37edd557d3750$var$p(n, i), e = 0; e < 16; e++)i[e] = 0;
    return i[14] = 8 * r, $dbd37edd557d3750$var$p(n, i), n;
}
function $dbd37edd557d3750$var$N(t) {
    var e, r = [];
    for(e = 0; e < 64; e += 4)r[e >> 2] = t.charCodeAt(e) + (t.charCodeAt(e + 1) << 8) + (t.charCodeAt(e + 2) << 16) + (t.charCodeAt(e + 3) << 24);
    return r;
}
var $dbd37edd557d3750$var$L = "0123456789abcdef".split("");
function $dbd37edd557d3750$var$x(t) {
    for(var e = "", r = 0; r < 4; r++)e += $dbd37edd557d3750$var$L[t >> 8 * r + 4 & 15] + $dbd37edd557d3750$var$L[t >> 8 * r & 15];
    return e;
}
function $dbd37edd557d3750$var$A(t) {
    return String.fromCharCode(255 & t, (65280 & t) >> 8, (16711680 & t) >> 16, (4278190080 & t) >> 24);
}
function $dbd37edd557d3750$var$S(t) {
    return $dbd37edd557d3750$var$w(t).map($dbd37edd557d3750$var$A).join("");
}
var $dbd37edd557d3750$var$_ = "5d41402abc4b2a76b9719d911017c592" != function(t) {
    for(var e = 0; e < t.length; e++)t[e] = $dbd37edd557d3750$var$x(t[e]);
    return t.join("");
}($dbd37edd557d3750$var$w("hello"));
function $dbd37edd557d3750$var$P(t, e) {
    if ($dbd37edd557d3750$var$_) {
        var r = (65535 & t) + (65535 & e);
        return (t >> 16) + (e >> 16) + (r >> 16) << 16 | 65535 & r;
    }
    return t + e & 4294967295;
}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */ function $dbd37edd557d3750$var$k(t, e) {
    var r, n, i, a;
    if (t !== r) {
        for(var o = (i = t, a = 1 + (256 / t.length | 0), new Array(a + 1).join(i)), s = [], u = 0; u < 256; u++)s[u] = u;
        var c = 0;
        for(u = 0; u < 256; u++){
            var l = s[u];
            c = (c + l + o.charCodeAt(u)) % 256, s[u] = s[c], s[c] = l;
        }
        r = t, n = s;
    } else s = n;
    var h = e.length, f = 0, d = 0, p = "";
    for(u = 0; u < h; u++)d = (d + (l = s[f = (f + 1) % 256])) % 256, s[f] = s[d], s[d] = l, o = s[(s[f] + s[d]) % 256], p += String.fromCharCode(e.charCodeAt(u) ^ o);
    return p;
}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */ var $dbd37edd557d3750$var$F = {
    print: 4,
    modify: 8,
    copy: 16,
    "annot-forms": 32
};
function $dbd37edd557d3750$var$I(t, e, r, n) {
    this.v = 1, this.r = 2;
    var i = 192;
    t.forEach(function(t) {
        if (void 0 !== $dbd37edd557d3750$var$F.perm) throw new Error("Invalid permission: " + t);
        i += $dbd37edd557d3750$var$F[t];
    }), this.padding = "(\xbfN^Nu\x8aAd\0NV\xff\xfa\x01\b..\0\xb6\xd0h>\x80/\f\xa9\xfedSiz";
    var a = (e + this.padding).substr(0, 32), o = (r + this.padding).substr(0, 32);
    this.O = this.processOwnerPassword(a, o), this.P = -(1 + (255 ^ i)), this.encryptionKey = $dbd37edd557d3750$var$S(a + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(n)).substr(0, 5), this.U = $dbd37edd557d3750$var$k(this.encryptionKey, this.padding);
}
function $dbd37edd557d3750$var$C(t) {
    if (/[^\u0000-\u00ff]/.test(t)) throw new Error("Invalid PDF Name Object: " + t + ", Only accept ASCII characters.");
    for(var e = "", r = t.length, n = 0; n < r; n++){
        var i = t.charCodeAt(n);
        e += i < 33 || 35 === i || 37 === i || 40 === i || 41 === i || 47 === i || 60 === i || 62 === i || 91 === i || 93 === i || 123 === i || 125 === i || i > 126 ? "#" + ("0" + i.toString(16)).slice(-2) : t[n];
    }
    return e;
}
function $dbd37edd557d3750$var$j(e) {
    if ("object" !== (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(e)) throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
    var r = {};
    this.subscribe = function(t, e, n) {
        if (n = n || !1, "string" != typeof t || "function" != typeof e || "boolean" != typeof n) throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
        r.hasOwnProperty(t) || (r[t] = {});
        var i = Math.random().toString(35);
        return r[t][i] = [
            e,
            !!n
        ], i;
    }, this.unsubscribe = function(t) {
        for(var e in r)if (r[e][t]) return delete r[e][t], 0 === Object.keys(r[e]).length && delete r[e], !0;
        return !1;
    }, this.publish = function(t) {
        if (r.hasOwnProperty(t)) {
            var n = Array.prototype.slice.call(arguments, 1), a = [];
            for(var s in r[t]){
                var u = r[t][s];
                try {
                    u[0].apply(e, n);
                } catch (c) {
                    $dbd37edd557d3750$var$i.console && $dbd37edd557d3750$var$o.error("jsPDF PubSub Error", c.message, c);
                }
                u[1] && a.push(s);
            }
            a.length && a.forEach(this.unsubscribe);
        }
    }, this.getTopics = function() {
        return r;
    };
}
function $dbd37edd557d3750$export$1bc649ab427a02ba(t) {
    if (!(this instanceof $dbd37edd557d3750$export$1bc649ab427a02ba)) return new $dbd37edd557d3750$export$1bc649ab427a02ba(t);
    var e = "opacity,stroke-opacity".split(",");
    for(var r in t)t.hasOwnProperty(r) && e.indexOf(r) >= 0 && (this[r] = t[r]);
    this.id = "", this.objectNumber = -1;
}
function $dbd37edd557d3750$var$B(t, e) {
    this.gState = t, this.matrix = e, this.id = "", this.objectNumber = -1;
}
function $dbd37edd557d3750$export$7235f0ad083cb4c6(t, e, r, n, i) {
    if (!(this instanceof $dbd37edd557d3750$export$7235f0ad083cb4c6)) return new $dbd37edd557d3750$export$7235f0ad083cb4c6(t, e, r, n, i);
    this.type = "axial" === t ? 2 : 3, this.coords = e, this.colors = r, $dbd37edd557d3750$var$B.call(this, n, i);
}
function $dbd37edd557d3750$export$549f717800d2b57f(t, e, r, n, i) {
    if (!(this instanceof $dbd37edd557d3750$export$549f717800d2b57f)) return new $dbd37edd557d3750$export$549f717800d2b57f(t, e, r, n, i);
    this.boundingBox = t, this.xStep = e, this.yStep = r, this.stream = "", this.cloneIndex = 0, $dbd37edd557d3750$var$B.call(this, n, i);
}
function $dbd37edd557d3750$export$2e2bcd8739ae039(e) {
    var r, n = "string" == typeof arguments[0] ? arguments[0] : "p", a = arguments[1], s = arguments[2], u = arguments[3], c = [], f = 1, p = 16, g = "S", m = null;
    "object" === (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(e = e || {}) && (n = e.orientation, a = e.unit || a, s = e.format || s, u = e.compress || e.compressPdf || u, null !== (m = e.encryption || null) && (m.userPassword = m.userPassword || "", m.ownerPassword = m.ownerPassword || "", m.userPermissions = m.userPermissions || []), f = "number" == typeof e.userUnit ? Math.abs(e.userUnit) : 1, void 0 !== e.precision && (r = e.precision), void 0 !== e.floatPrecision && (p = e.floatPrecision), g = e.defaultPathOperation || "S"), c = e.filters || (!0 === u ? [
        "FlateEncode"
    ] : c), a = a || "mm", n = ("" + (n || "P")).toLowerCase();
    var v = e.putOnlyUsedFonts || !1, b = {}, y = {
        internal: {},
        __private__: {}
    };
    y.__private__.PubSub = $dbd37edd557d3750$var$j;
    var w = "1.3", N = y.__private__.getPdfVersion = function() {
        return w;
    };
    y.__private__.setPdfVersion = function(t) {
        w = t;
    };
    var L = {
        a0: [
            2383.94,
            3370.39
        ],
        a1: [
            1683.78,
            2383.94
        ],
        a2: [
            1190.55,
            1683.78
        ],
        a3: [
            841.89,
            1190.55
        ],
        a4: [
            595.28,
            841.89
        ],
        a5: [
            419.53,
            595.28
        ],
        a6: [
            297.64,
            419.53
        ],
        a7: [
            209.76,
            297.64
        ],
        a8: [
            147.4,
            209.76
        ],
        a9: [
            104.88,
            147.4
        ],
        a10: [
            73.7,
            104.88
        ],
        b0: [
            2834.65,
            4008.19
        ],
        b1: [
            2004.09,
            2834.65
        ],
        b2: [
            1417.32,
            2004.09
        ],
        b3: [
            1000.63,
            1417.32
        ],
        b4: [
            708.66,
            1000.63
        ],
        b5: [
            498.9,
            708.66
        ],
        b6: [
            354.33,
            498.9
        ],
        b7: [
            249.45,
            354.33
        ],
        b8: [
            175.75,
            249.45
        ],
        b9: [
            124.72,
            175.75
        ],
        b10: [
            87.87,
            124.72
        ],
        c0: [
            2599.37,
            3676.54
        ],
        c1: [
            1836.85,
            2599.37
        ],
        c2: [
            1298.27,
            1836.85
        ],
        c3: [
            918.43,
            1298.27
        ],
        c4: [
            649.13,
            918.43
        ],
        c5: [
            459.21,
            649.13
        ],
        c6: [
            323.15,
            459.21
        ],
        c7: [
            229.61,
            323.15
        ],
        c8: [
            161.57,
            229.61
        ],
        c9: [
            113.39,
            161.57
        ],
        c10: [
            79.37,
            113.39
        ],
        dl: [
            311.81,
            623.62
        ],
        letter: [
            612,
            792
        ],
        "government-letter": [
            576,
            756
        ],
        legal: [
            612,
            1008
        ],
        "junior-legal": [
            576,
            360
        ],
        ledger: [
            1224,
            792
        ],
        tabloid: [
            792,
            1224
        ],
        "credit-card": [
            153,
            243
        ]
    };
    y.__private__.getPageFormats = function() {
        return L;
    };
    var x = y.__private__.getPageFormat = function(t) {
        return L[t];
    };
    s = s || "a4";
    var A = "compat", S = "advanced", _ = A;
    function P() {
        this.saveGraphicsState(), lt(new Wt(St, 0, 0, -St, 0, Pr() * St).toString() + " cm"), this.setFontSize(this.getFontSize() / St), g = "n", _ = S;
    }
    function k() {
        this.restoreGraphicsState(), g = "S", _ = A;
    }
    var F = y.__private__.combineFontStyleAndFontWeight = function(t, e) {
        if ("bold" == t && "normal" == e || "bold" == t && 400 == e || "normal" == t && "italic" == e || "bold" == t && "italic" == e) throw new Error("Invalid Combination of fontweight and fontstyle");
        return e && (t = 400 == e || "normal" === e ? "italic" === t ? "italic" : "normal" : 700 != e && "bold" !== e || "normal" !== t ? (700 == e ? "bold" : e) + "" + t : "bold"), t;
    };
    y.advancedAPI = function(t) {
        var e = _ === A;
        return e && P.call(this), "function" != typeof t || (t(this), e && k.call(this)), this;
    }, y.compatAPI = function(t) {
        var e = _ === S;
        return e && k.call(this), "function" != typeof t || (t(this), e && P.call(this)), this;
    }, y.isAdvancedAPI = function() {
        return _ === S;
    };
    var B, R = function(t) {
        if (_ !== S) throw new Error(t + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
    }, D = y.roundToPrecision = y.__private__.roundToPrecision = function(t, e) {
        var n = r || e;
        if (isNaN(t) || isNaN(n)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
        return t.toFixed(n).replace(/0+$/, "");
    };
    B = y.hpf = y.__private__.hpf = "number" == typeof p ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, p);
    } : "smart" === p ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, t > -1 && t < 1 ? 16 : 5);
    } : function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, 16);
    };
    var T = y.f2 = y.__private__.f2 = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f2");
        return D(t, 2);
    }, z = y.__private__.f3 = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f3");
        return D(t, 3);
    }, U = y.scale = y.__private__.scale = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.scale");
        return _ === A ? t * St : _ === S ? t : void 0;
    }, H = function(t) {
        return U(function(t) {
            return _ === A ? Pr() - t : _ === S ? t : void 0;
        }(t));
    };
    y.__private__.setPrecision = y.setPrecision = function(t) {
        "number" == typeof parseInt(t, 10) && (r = parseInt(t, 10));
    };
    var W, V = "00000000000000000000000000000000", G = y.__private__.getFileId = function() {
        return V;
    }, Y = y.__private__.setFileId = function(t) {
        return V = void 0 !== t && /^[a-fA-F0-9]{32}$/.test(t) ? t.toUpperCase() : V.split("").map(function() {
            return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
        }).join(""), null !== m && (Oe = new $dbd37edd557d3750$var$I(m.userPermissions, m.userPassword, m.ownerPassword, V)), V;
    };
    y.setFileId = function(t) {
        return Y(t), this;
    }, y.getFileId = function() {
        return G();
    };
    var J = y.__private__.convertDateToPDFDate = function(t) {
        var e = t.getTimezoneOffset(), r = e < 0 ? "+" : "-", n = Math.floor(Math.abs(e / 60)), i = Math.abs(e % 60), a = [
            r,
            Q(n),
            "'",
            Q(i),
            "'"
        ].join("");
        return [
            "D:",
            t.getFullYear(),
            Q(t.getMonth() + 1),
            Q(t.getDate()),
            Q(t.getHours()),
            Q(t.getMinutes()),
            Q(t.getSeconds()),
            a
        ].join("");
    }, X = y.__private__.convertPDFDateToDate = function(t) {
        var e = parseInt(t.substr(2, 4), 10), r = parseInt(t.substr(6, 2), 10) - 1, n = parseInt(t.substr(8, 2), 10), i = parseInt(t.substr(10, 2), 10), a = parseInt(t.substr(12, 2), 10), o = parseInt(t.substr(14, 2), 10);
        return new Date(e, r, n, i, a, o, 0);
    }, K = y.__private__.setCreationDate = function(t) {
        var e;
        if (void 0 === t && (t = new Date), t instanceof Date) e = J(t);
        else {
            if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
            e = t;
        }
        return W = e;
    }, Z = y.__private__.getCreationDate = function(t) {
        var e = W;
        return "jsDate" === t && (e = X(W)), e;
    };
    y.setCreationDate = function(t) {
        return K(t), this;
    }, y.getCreationDate = function(t) {
        return Z(t);
    };
    var $, Q = y.__private__.padd2 = function(t) {
        return ("0" + parseInt(t)).slice(-2);
    }, tt = y.__private__.padd2Hex = function(t) {
        return ("00" + (t = t.toString())).substr(t.length);
    }, et = 0, rt = [], nt = [], it = 0, at = [], ot = [], st = !1, ut = nt;
    y.__private__.setCustomOutputDestination = function(t) {
        st = !0, ut = t;
    };
    var ct = function(t) {
        st || (ut = t);
    };
    y.__private__.resetCustomOutputDestination = function() {
        st = !1, ut = nt;
    };
    var lt = y.__private__.out = function(t) {
        return t = t.toString(), it += t.length + 1, ut.push(t), ut;
    }, ht = y.__private__.write = function(t) {
        return lt(1 === arguments.length ? t.toString() : Array.prototype.join.call(arguments, " "));
    }, ft = y.__private__.getArrayBuffer = function(t) {
        for(var e = t.length, r = new ArrayBuffer(e), n = new Uint8Array(r); e--;)n[e] = t.charCodeAt(e);
        return r;
    }, dt = [
        [
            "Helvetica",
            "helvetica",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Bold",
            "helvetica",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Oblique",
            "helvetica",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-BoldOblique",
            "helvetica",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Courier",
            "courier",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Bold",
            "courier",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Oblique",
            "courier",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Courier-BoldOblique",
            "courier",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Times-Roman",
            "times",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Times-Bold",
            "times",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Times-Italic",
            "times",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Times-BoldItalic",
            "times",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "ZapfDingbats",
            "zapfdingbats",
            "normal",
            null
        ],
        [
            "Symbol",
            "symbol",
            "normal",
            null
        ]
    ];
    y.__private__.getStandardFonts = function() {
        return dt;
    };
    var pt = e.fontSize || 16;
    y.__private__.setFontSize = y.setFontSize = function(t) {
        return pt = _ === S ? t / St : t, this;
    };
    var gt, mt = y.__private__.getFontSize = y.getFontSize = function() {
        return _ === A ? pt : pt * St;
    }, vt = e.R2L || !1;
    y.__private__.setR2L = y.setR2L = function(t) {
        return vt = t, this;
    }, y.__private__.getR2L = y.getR2L = function() {
        return vt;
    };
    var bt, yt = y.__private__.setZoomMode = function(t) {
        if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(t)) gt = t;
        else if (isNaN(t)) {
            if (-1 === [
                void 0,
                null,
                "fullwidth",
                "fullheight",
                "fullpage",
                "original"
            ].indexOf(t)) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + t + '" is not recognized.');
            gt = t;
        } else gt = parseInt(t, 10);
    };
    y.__private__.getZoomMode = function() {
        return gt;
    };
    var wt, Nt = y.__private__.setPageMode = function(t) {
        if (-1 == [
            void 0,
            null,
            "UseNone",
            "UseOutlines",
            "UseThumbs",
            "FullScreen"
        ].indexOf(t)) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + t + '" is not recognized.');
        bt = t;
    };
    y.__private__.getPageMode = function() {
        return bt;
    };
    var Lt = y.__private__.setLayoutMode = function(t) {
        if (-1 == [
            void 0,
            null,
            "continuous",
            "single",
            "twoleft",
            "tworight",
            "two"
        ].indexOf(t)) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + t + '" is not recognized.');
        wt = t;
    };
    y.__private__.getLayoutMode = function() {
        return wt;
    }, y.__private__.setDisplayMode = y.setDisplayMode = function(t, e, r) {
        return yt(t), Lt(e), Nt(r), this;
    };
    var xt = {
        title: "",
        subject: "",
        author: "",
        keywords: "",
        creator: ""
    };
    y.__private__.getDocumentProperty = function(t) {
        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
        return xt[t];
    }, y.__private__.getDocumentProperties = function() {
        return xt;
    }, y.__private__.setDocumentProperties = y.setProperties = y.setDocumentProperties = function(t) {
        for(var e in xt)xt.hasOwnProperty(e) && t[e] && (xt[e] = t[e]);
        return this;
    }, y.__private__.setDocumentProperty = function(t, e) {
        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
        return xt[t] = e;
    };
    var At, St, _t, Pt, kt, Ft = {}, It = {}, Ct = [], jt = {}, Ot = {}, Bt = {}, Mt = {}, qt = null, Et = 0, Rt = [], Dt = new $dbd37edd557d3750$var$j(y), Tt = e.hotfixes || [], zt = {}, Ut = {}, Ht = [], Wt = function t(e, r, n, i, a, o) {
        if (!(this instanceof t)) return new t(e, r, n, i, a, o);
        isNaN(e) && (e = 1), isNaN(r) && (r = 0), isNaN(n) && (n = 0), isNaN(i) && (i = 1), isNaN(a) && (a = 0), isNaN(o) && (o = 0), this._matrix = [
            e,
            r,
            n,
            i,
            a,
            o
        ];
    };
    Object.defineProperty(Wt.prototype, "sx", {
        get: function() {
            return this._matrix[0];
        },
        set: function(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Wt.prototype, "shy", {
        get: function() {
            return this._matrix[1];
        },
        set: function(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Wt.prototype, "shx", {
        get: function() {
            return this._matrix[2];
        },
        set: function(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Wt.prototype, "sy", {
        get: function() {
            return this._matrix[3];
        },
        set: function(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Wt.prototype, "tx", {
        get: function() {
            return this._matrix[4];
        },
        set: function(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Wt.prototype, "ty", {
        get: function() {
            return this._matrix[5];
        },
        set: function(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Wt.prototype, "a", {
        get: function() {
            return this._matrix[0];
        },
        set: function(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Wt.prototype, "b", {
        get: function() {
            return this._matrix[1];
        },
        set: function(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Wt.prototype, "c", {
        get: function() {
            return this._matrix[2];
        },
        set: function(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Wt.prototype, "d", {
        get: function() {
            return this._matrix[3];
        },
        set: function(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Wt.prototype, "e", {
        get: function() {
            return this._matrix[4];
        },
        set: function(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Wt.prototype, "f", {
        get: function() {
            return this._matrix[5];
        },
        set: function(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Wt.prototype, "rotation", {
        get: function() {
            return Math.atan2(this.shx, this.sx);
        }
    }), Object.defineProperty(Wt.prototype, "scaleX", {
        get: function() {
            return this.decompose().scale.sx;
        }
    }), Object.defineProperty(Wt.prototype, "scaleY", {
        get: function() {
            return this.decompose().scale.sy;
        }
    }), Object.defineProperty(Wt.prototype, "isIdentity", {
        get: function() {
            return 1 === this.sx && 0 === this.shy && 0 === this.shx && 1 === this.sy && 0 === this.tx && 0 === this.ty;
        }
    }), Wt.prototype.join = function(t) {
        return [
            this.sx,
            this.shy,
            this.shx,
            this.sy,
            this.tx,
            this.ty
        ].map(B).join(t);
    }, Wt.prototype.multiply = function(t) {
        var e = t.sx * this.sx + t.shy * this.shx, r = t.sx * this.shy + t.shy * this.sy, n = t.shx * this.sx + t.sy * this.shx, i = t.shx * this.shy + t.sy * this.sy, a = t.tx * this.sx + t.ty * this.shx + this.tx, o = t.tx * this.shy + t.ty * this.sy + this.ty;
        return new Wt(e, r, n, i, a, o);
    }, Wt.prototype.decompose = function() {
        var t = this.sx, e = this.shy, r = this.shx, n = this.sy, i = this.tx, a = this.ty, o = Math.sqrt(t * t + e * e), s = (t /= o) * r + (e /= o) * n;
        r -= t * s, n -= e * s;
        var u = Math.sqrt(r * r + n * n);
        return s /= u, t * (n /= u) < e * (r /= u) && (t = -t, e = -e, s = -s, o = -o), {
            scale: new Wt(o, 0, 0, u, 0, 0),
            translate: new Wt(1, 0, 0, 1, i, a),
            rotate: new Wt(t, e, -e, t, 0, 0),
            skew: new Wt(1, 0, s, 1, 0, 0)
        };
    }, Wt.prototype.toString = function(t) {
        return this.join(" ");
    }, Wt.prototype.inversed = function() {
        var t = this.sx, e = this.shy, r = this.shx, n = this.sy, i = this.tx, a = this.ty, o = 1 / (t * n - e * r), s = n * o, u = -e * o, c = -r * o, l = t * o;
        return new Wt(s, u, c, l, -s * i - c * a, -u * i - l * a);
    }, Wt.prototype.applyToPoint = function(t) {
        var e = t.x * this.sx + t.y * this.shx + this.tx, r = t.x * this.shy + t.y * this.sy + this.ty;
        return new mr(e, r);
    }, Wt.prototype.applyToRectangle = function(t) {
        var e = this.applyToPoint(t), r = this.applyToPoint(new mr(t.x + t.w, t.y + t.h));
        return new vr(e.x, e.y, r.x - e.x, r.y - e.y);
    }, Wt.prototype.clone = function() {
        var t = this.sx, e = this.shy, r = this.shx, n = this.sy, i = this.tx, a = this.ty;
        return new Wt(t, e, r, n, i, a);
    }, y.Matrix = Wt;
    var Vt = y.matrixMult = function(t, e) {
        return e.multiply(t);
    }, Gt = new Wt(1, 0, 0, 1, 0, 0);
    y.unitMatrix = y.identityMatrix = Gt;
    var Yt = function(t, e) {
        if (!Ot[t]) {
            var r = (e instanceof $dbd37edd557d3750$export$7235f0ad083cb4c6 ? "Sh" : "P") + (Object.keys(jt).length + 1).toString(10);
            e.id = r, Ot[t] = r, jt[r] = e, Dt.publish("addPattern", e);
        }
    };
    y.ShadingPattern = $dbd37edd557d3750$export$7235f0ad083cb4c6, y.TilingPattern = $dbd37edd557d3750$export$549f717800d2b57f, y.addShadingPattern = function(t, e) {
        return R("addShadingPattern()"), Yt(t, e), this;
    }, y.beginTilingPattern = function(t) {
        R("beginTilingPattern()"), yr(t.boundingBox[0], t.boundingBox[1], t.boundingBox[2] - t.boundingBox[0], t.boundingBox[3] - t.boundingBox[1], t.matrix);
    }, y.endTilingPattern = function(t, e) {
        R("endTilingPattern()"), e.stream = ot[$].join("\n"), Yt(t, e), Dt.publish("endTilingPattern", e), Ht.pop().restore();
    };
    var Jt, Xt = y.__private__.newObject = function() {
        var t = Kt();
        return Zt(t, !0), t;
    }, Kt = y.__private__.newObjectDeferred = function() {
        return et++, rt[et] = function() {
            return it;
        }, et;
    }, Zt = function(t, e) {
        return e = "boolean" == typeof e && e, rt[t] = it, e && lt(t + " 0 obj"), t;
    }, $t = y.__private__.newAdditionalObject = function() {
        var t = {
            objId: Kt(),
            content: ""
        };
        return at.push(t), t;
    }, Qt = Kt(), te = Kt(), ee = y.__private__.decodeColorString = function(t) {
        var e = t.split(" ");
        if (2 !== e.length || "g" !== e[1] && "G" !== e[1]) 5 !== e.length || "k" !== e[4] && "K" !== e[4] || (e = [
            (1 - e[0]) * (1 - e[3]),
            (1 - e[1]) * (1 - e[3]),
            (1 - e[2]) * (1 - e[3]),
            "r"
        ]);
        else {
            var r = parseFloat(e[0]);
            e = [
                r,
                r,
                r,
                "r"
            ];
        }
        for(var n = "#", i = 0; i < 3; i++)n += ("0" + Math.floor(255 * parseFloat(e[i])).toString(16)).slice(-2);
        return n;
    }, re = y.__private__.encodeColorString = function(e) {
        var r;
        "string" == typeof e && (e = {
            ch1: e
        });
        var n = e.ch1, i = e.ch2, a = e.ch3, o = e.ch4, s = "draw" === e.pdfColorType ? [
            "G",
            "RG",
            "K"
        ] : [
            "g",
            "rg",
            "k"
        ];
        if ("string" == typeof n && "#" !== n.charAt(0)) {
            var u = new $dbd37edd557d3750$var$h(n);
            if (u.ok) n = u.toHex();
            else if (!/^\d*\.?\d*$/.test(n)) throw new Error('Invalid color "' + n + '" passed to jsPDF.encodeColorString.');
        }
        if ("string" == typeof n && /^#[0-9A-Fa-f]{3}$/.test(n) && (n = "#" + n[1] + n[1] + n[2] + n[2] + n[3] + n[3]), "string" == typeof n && /^#[0-9A-Fa-f]{6}$/.test(n)) {
            var c = parseInt(n.substr(1), 16);
            n = c >> 16 & 255, i = c >> 8 & 255, a = 255 & c;
        }
        if (void 0 === i || void 0 === o && n === i && i === a) r = "string" == typeof n ? n + " " + s[0] : 2 === e.precision ? T(n / 255) + " " + s[0] : z(n / 255) + " " + s[0];
        else if (void 0 === o || "object" === (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(o)) {
            if (o && !isNaN(o.a) && 0 === o.a) return [
                "1.",
                "1.",
                "1.",
                s[1]
            ].join(" ");
            r = "string" == typeof n ? [
                n,
                i,
                a,
                s[1]
            ].join(" ") : 2 === e.precision ? [
                T(n / 255),
                T(i / 255),
                T(a / 255),
                s[1]
            ].join(" ") : [
                z(n / 255),
                z(i / 255),
                z(a / 255),
                s[1]
            ].join(" ");
        } else r = "string" == typeof n ? [
            n,
            i,
            a,
            o,
            s[2]
        ].join(" ") : 2 === e.precision ? [
            T(n),
            T(i),
            T(a),
            T(o),
            s[2]
        ].join(" ") : [
            z(n),
            z(i),
            z(a),
            z(o),
            s[2]
        ].join(" ");
        return r;
    }, ne = y.__private__.getFilters = function() {
        return c;
    }, ie = y.__private__.putStream = function(t) {
        var e = (t = t || {}).data || "", r = t.filters || ne(), n = t.alreadyAppliedFilters || [], i = t.addLength1 || !1, a = e.length, o = t.objectId, s = function(t) {
            return t;
        };
        if (null !== m && void 0 === o) throw new Error("ObjectId must be passed to putStream for file encryption");
        null !== m && (s = Oe.encryptor(o, 0));
        var u = {};
        !0 === r && (r = [
            "FlateEncode"
        ]);
        var c = t.additionalKeyValues || [], l = (u = void 0 !== $dbd37edd557d3750$export$2e2bcd8739ae039.API.processDataByFilters ? $dbd37edd557d3750$export$2e2bcd8739ae039.API.processDataByFilters(e, r) : {
            data: e,
            reverseChain: []
        }).reverseChain + (Array.isArray(n) ? n.join(" ") : n.toString());
        if (0 !== u.data.length && (c.push({
            key: "Length",
            value: u.data.length
        }), !0 === i && c.push({
            key: "Length1",
            value: a
        })), 0 != l.length) {
            if (l.split("/").length - 1 == 1) c.push({
                key: "Filter",
                value: l
            });
            else {
                c.push({
                    key: "Filter",
                    value: "[" + l + "]"
                });
                for(var h = 0; h < c.length; h += 1)if ("DecodeParms" === c[h].key) {
                    for(var f = [], d = 0; d < u.reverseChain.split("/").length - 1; d += 1)f.push("null");
                    f.push(c[h].value), c[h].value = "[" + f.join(" ") + "]";
                }
            }
        }
        lt("<<");
        for(var p = 0; p < c.length; p++)lt("/" + c[p].key + " " + c[p].value);
        lt(">>"), 0 !== u.data.length && (lt("stream"), lt(s(u.data)), lt("endstream"));
    }, ae = y.__private__.putPage = function(t) {
        var e = t.number, r = t.data, n = t.objId, i = t.contentsObjId;
        Zt(n, !0), lt("<</Type /Page"), lt("/Parent " + t.rootDictionaryObjId + " 0 R"), lt("/Resources " + t.resourceDictionaryObjId + " 0 R"), lt("/MediaBox [" + parseFloat(B(t.mediaBox.bottomLeftX)) + " " + parseFloat(B(t.mediaBox.bottomLeftY)) + " " + B(t.mediaBox.topRightX) + " " + B(t.mediaBox.topRightY) + "]"), null !== t.cropBox && lt("/CropBox [" + B(t.cropBox.bottomLeftX) + " " + B(t.cropBox.bottomLeftY) + " " + B(t.cropBox.topRightX) + " " + B(t.cropBox.topRightY) + "]"), null !== t.bleedBox && lt("/BleedBox [" + B(t.bleedBox.bottomLeftX) + " " + B(t.bleedBox.bottomLeftY) + " " + B(t.bleedBox.topRightX) + " " + B(t.bleedBox.topRightY) + "]"), null !== t.trimBox && lt("/TrimBox [" + B(t.trimBox.bottomLeftX) + " " + B(t.trimBox.bottomLeftY) + " " + B(t.trimBox.topRightX) + " " + B(t.trimBox.topRightY) + "]"), null !== t.artBox && lt("/ArtBox [" + B(t.artBox.bottomLeftX) + " " + B(t.artBox.bottomLeftY) + " " + B(t.artBox.topRightX) + " " + B(t.artBox.topRightY) + "]"), "number" == typeof t.userUnit && 1 !== t.userUnit && lt("/UserUnit " + t.userUnit), Dt.publish("putPage", {
            objId: n,
            pageContext: Rt[e],
            pageNumber: e,
            page: r
        }), lt("/Contents " + i + " 0 R"), lt(">>"), lt("endobj");
        var a = r.join("\n");
        return _ === S && (a += "\nQ"), Zt(i, !0), ie({
            data: a,
            filters: ne(),
            objectId: i
        }), lt("endobj"), n;
    }, oe = y.__private__.putPages = function() {
        var t, e, r = [];
        for(t = 1; t <= Et; t++)Rt[t].objId = Kt(), Rt[t].contentsObjId = Kt();
        for(t = 1; t <= Et; t++)r.push(ae({
            number: t,
            data: ot[t],
            objId: Rt[t].objId,
            contentsObjId: Rt[t].contentsObjId,
            mediaBox: Rt[t].mediaBox,
            cropBox: Rt[t].cropBox,
            bleedBox: Rt[t].bleedBox,
            trimBox: Rt[t].trimBox,
            artBox: Rt[t].artBox,
            userUnit: Rt[t].userUnit,
            rootDictionaryObjId: Qt,
            resourceDictionaryObjId: te
        }));
        Zt(Qt, !0), lt("<</Type /Pages");
        var n = "/Kids [";
        for(e = 0; e < Et; e++)n += r[e] + " 0 R ";
        lt(n + "]"), lt("/Count " + Et), lt(">>"), lt("endobj"), Dt.publish("postPutPages");
    }, se = function(t) {
        Dt.publish("putFont", {
            font: t,
            out: lt,
            newObject: Xt,
            putStream: ie
        }), !0 !== t.isAlreadyPutted && (t.objectNumber = Xt(), lt("<<"), lt("/Type /Font"), lt("/BaseFont /" + $dbd37edd557d3750$var$C(t.postScriptName)), lt("/Subtype /Type1"), "string" == typeof t.encoding && lt("/Encoding /" + t.encoding), lt("/FirstChar 32"), lt("/LastChar 255"), lt(">>"), lt("endobj"));
    }, ue = function(t) {
        t.objectNumber = Xt();
        var e = [];
        e.push({
            key: "Type",
            value: "/XObject"
        }), e.push({
            key: "Subtype",
            value: "/Form"
        }), e.push({
            key: "BBox",
            value: "[" + [
                B(t.x),
                B(t.y),
                B(t.x + t.width),
                B(t.y + t.height)
            ].join(" ") + "]"
        }), e.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        });
        var r = t.pages[1].join("\n");
        ie({
            data: r,
            additionalKeyValues: e,
            objectId: t.objectNumber
        }), lt("endobj");
    }, ce = function(t, e) {
        e || (e = 21);
        var r = Xt(), n = function(t, e) {
            var r, n = [], i = 1 / (e - 1);
            for(r = 0; r < 1; r += i)n.push(r);
            if (n.push(1), 0 != t[0].offset) {
                var a = {
                    offset: 0,
                    color: t[0].color
                };
                t.unshift(a);
            }
            if (1 != t[t.length - 1].offset) {
                var o = {
                    offset: 1,
                    color: t[t.length - 1].color
                };
                t.push(o);
            }
            for(var s = "", u = 0, c = 0; c < n.length; c++){
                for(r = n[c]; r > t[u + 1].offset;)u++;
                var l = t[u].offset, h = (r - l) / (t[u + 1].offset - l), f = t[u].color, d = t[u + 1].color;
                s += tt(Math.round((1 - h) * f[0] + h * d[0]).toString(16)) + tt(Math.round((1 - h) * f[1] + h * d[1]).toString(16)) + tt(Math.round((1 - h) * f[2] + h * d[2]).toString(16));
            }
            return s.trim();
        }(t.colors, e), i = [];
        i.push({
            key: "FunctionType",
            value: "0"
        }), i.push({
            key: "Domain",
            value: "[0.0 1.0]"
        }), i.push({
            key: "Size",
            value: "[" + e + "]"
        }), i.push({
            key: "BitsPerSample",
            value: "8"
        }), i.push({
            key: "Range",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), i.push({
            key: "Decode",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), ie({
            data: n,
            additionalKeyValues: i,
            alreadyAppliedFilters: [
                "/ASCIIHexDecode"
            ],
            objectId: r
        }), lt("endobj"), t.objectNumber = Xt(), lt("<< /ShadingType " + t.type), lt("/ColorSpace /DeviceRGB");
        var a = "/Coords [" + B(parseFloat(t.coords[0])) + " " + B(parseFloat(t.coords[1])) + " ";
        2 === t.type ? a += B(parseFloat(t.coords[2])) + " " + B(parseFloat(t.coords[3])) : a += B(parseFloat(t.coords[2])) + " " + B(parseFloat(t.coords[3])) + " " + B(parseFloat(t.coords[4])) + " " + B(parseFloat(t.coords[5])), lt(a += "]"), t.matrix && lt("/Matrix [" + t.matrix.toString() + "]"), lt("/Function " + r + " 0 R"), lt("/Extend [true true]"), lt(">>"), lt("endobj");
    }, le = function(t, e) {
        var r = Kt(), n = Xt();
        e.push({
            resourcesOid: r,
            objectOid: n
        }), t.objectNumber = n;
        var i = [];
        i.push({
            key: "Type",
            value: "/Pattern"
        }), i.push({
            key: "PatternType",
            value: "1"
        }), i.push({
            key: "PaintType",
            value: "1"
        }), i.push({
            key: "TilingType",
            value: "1"
        }), i.push({
            key: "BBox",
            value: "[" + t.boundingBox.map(B).join(" ") + "]"
        }), i.push({
            key: "XStep",
            value: B(t.xStep)
        }), i.push({
            key: "YStep",
            value: B(t.yStep)
        }), i.push({
            key: "Resources",
            value: r + " 0 R"
        }), t.matrix && i.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        }), ie({
            data: t.stream,
            additionalKeyValues: i,
            objectId: t.objectNumber
        }), lt("endobj");
    }, he = function(t) {
        for(var e in t.objectNumber = Xt(), lt("<<"), t)switch(e){
            case "opacity":
                lt("/ca " + T(t[e]));
                break;
            case "stroke-opacity":
                lt("/CA " + T(t[e]));
        }
        lt(">>"), lt("endobj");
    }, fe = function(t) {
        Zt(t.resourcesOid, !0), lt("<<"), lt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), function() {
            for(var t in lt("/Font <<"), Ft)Ft.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && lt("/" + t + " " + Ft[t].objectNumber + " 0 R");
            lt(">>");
        }(), function() {
            if (Object.keys(jt).length > 0) {
                for(var t in lt("/Shading <<"), jt)jt.hasOwnProperty(t) && jt[t] instanceof $dbd37edd557d3750$export$7235f0ad083cb4c6 && jt[t].objectNumber >= 0 && lt("/" + t + " " + jt[t].objectNumber + " 0 R");
                Dt.publish("putShadingPatternDict"), lt(">>");
            }
        }(), function(t) {
            if (Object.keys(jt).length > 0) {
                for(var e in lt("/Pattern <<"), jt)jt.hasOwnProperty(e) && jt[e] instanceof y.TilingPattern && jt[e].objectNumber >= 0 && jt[e].objectNumber < t && lt("/" + e + " " + jt[e].objectNumber + " 0 R");
                Dt.publish("putTilingPatternDict"), lt(">>");
            }
        }(t.objectOid), function() {
            if (Object.keys(Bt).length > 0) {
                var t;
                for(t in lt("/ExtGState <<"), Bt)Bt.hasOwnProperty(t) && Bt[t].objectNumber >= 0 && lt("/" + t + " " + Bt[t].objectNumber + " 0 R");
                Dt.publish("putGStateDict"), lt(">>");
            }
        }(), function() {
            for(var t in lt("/XObject <<"), zt)zt.hasOwnProperty(t) && zt[t].objectNumber >= 0 && lt("/" + t + " " + zt[t].objectNumber + " 0 R");
            Dt.publish("putXobjectDict"), lt(">>");
        }(), lt(">>"), lt("endobj");
    }, de = function(t) {
        It[t.fontName] = It[t.fontName] || {}, It[t.fontName][t.fontStyle] = t.id;
    }, pe = function(t, e, r, n, i) {
        var a = {
            id: "F" + (Object.keys(Ft).length + 1).toString(10),
            postScriptName: t,
            fontName: e,
            fontStyle: r,
            encoding: n,
            isStandardFont: i || !1,
            metadata: {}
        };
        return Dt.publish("addFont", {
            font: a,
            instance: this
        }), Ft[a.id] = a, de(a), a.id;
    }, ge = y.__private__.pdfEscape = y.pdfEscape = function(t, e) {
        return (function(t, e) {
            var r, n, i, a, o, s, u, c, l;
            if (i = (e = e || {}).sourceEncoding || "Unicode", o = e.outputEncoding, (e.autoencode || o) && Ft[At].metadata && Ft[At].metadata[i] && Ft[At].metadata[i].encoding && (a = Ft[At].metadata[i].encoding, !o && Ft[At].encoding && (o = Ft[At].encoding), !o && a.codePages && (o = a.codePages[0]), "string" == typeof o && (o = a[o]), o)) {
                for(u = !1, s = [], r = 0, n = t.length; r < n; r++)(c = o[t.charCodeAt(r)]) ? s.push(String.fromCharCode(c)) : s.push(t[r]), s[r].charCodeAt(0) >> 8 && (u = !0);
                t = s.join("");
            }
            for(r = t.length; void 0 === u && 0 !== r;)t.charCodeAt(r - 1) >> 8 && (u = !0), r--;
            if (!u) return t;
            for(s = e.noBOM ? [] : [
                254,
                255
            ], r = 0, n = t.length; r < n; r++){
                if ((l = (c = t.charCodeAt(r)) >> 8) >> 8) throw new Error("Character at position " + r + " of string '" + t + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
                s.push(l), s.push(c - (l << 8));
            }
            return String.fromCharCode.apply(void 0, s);
        })(t, e).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
    }, me = y.__private__.beginPage = function(t) {
        ot[++Et] = [], Rt[Et] = {
            objId: 0,
            contentsObjId: 0,
            userUnit: Number(f),
            artBox: null,
            bleedBox: null,
            cropBox: null,
            trimBox: null,
            mediaBox: {
                bottomLeftX: 0,
                bottomLeftY: 0,
                topRightX: Number(t[0]),
                topRightY: Number(t[1])
            }
        }, ye(Et), ct(ot[$]);
    }, ve = function(t, e) {
        var r, i, a;
        switch(n = e || n, "string" == typeof t && (r = x(t.toLowerCase()), Array.isArray(r) && (i = r[0], a = r[1])), Array.isArray(t) && (i = t[0] * St, a = t[1] * St), isNaN(i) && (i = s[0], a = s[1]), (i > 14400 || a > 14400) && ($dbd37edd557d3750$var$o.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), i = Math.min(14400, i), a = Math.min(14400, a)), s = [
            i,
            a
        ], n.substr(0, 1)){
            case "l":
                a > i && (s = [
                    a,
                    i
                ]);
                break;
            case "p":
                i > a && (s = [
                    a,
                    i
                ]);
        }
        me(s), Qe(Ze), lt(sr), 0 !== dr && lt(dr + " J"), 0 !== pr && lt(pr + " j"), Dt.publish("addPage", {
            pageNumber: Et
        });
    }, be = function(t) {
        t > 0 && t <= Et && (ot.splice(t, 1), Rt.splice(t, 1), Et--, $ > Et && ($ = Et), this.setPage($));
    }, ye = function(t) {
        t > 0 && t <= Et && ($ = t);
    }, we = y.__private__.getNumberOfPages = y.getNumberOfPages = function() {
        return ot.length - 1;
    }, Ne = function(t, e, r) {
        var n, i = void 0;
        return r = r || {}, t = void 0 !== t ? t : Ft[At].fontName, e = void 0 !== e ? e : Ft[At].fontStyle, n = t.toLowerCase(), void 0 !== It[n] && void 0 !== It[n][e] ? i = It[n][e] : void 0 !== It[t] && void 0 !== It[t][e] ? i = It[t][e] : !1 === r.disableWarning && $dbd37edd557d3750$var$o.warn("Unable to look up font label for font '" + t + "', '" + e + "'. Refer to getFontList() for available fonts."), i || r.noFallback || null == (i = It.times[e]) && (i = It.times.normal), i;
    }, Le = y.__private__.putInfo = function() {
        var t = Xt(), e = function(t) {
            return t;
        };
        for(var r in null !== m && (e = Oe.encryptor(t, 0)), lt("<<"), lt("/Producer (" + ge(e("jsPDF " + $dbd37edd557d3750$export$2e2bcd8739ae039.version)) + ")"), xt)xt.hasOwnProperty(r) && xt[r] && lt("/" + r.substr(0, 1).toUpperCase() + r.substr(1) + " (" + ge(e(xt[r])) + ")");
        lt("/CreationDate (" + ge(e(W)) + ")"), lt(">>"), lt("endobj");
    }, xe = y.__private__.putCatalog = function(t) {
        var e = (t = t || {}).rootDictionaryObjId || Qt;
        switch(Xt(), lt("<<"), lt("/Type /Catalog"), lt("/Pages " + e + " 0 R"), gt || (gt = "fullwidth"), gt){
            case "fullwidth":
                lt("/OpenAction [3 0 R /FitH null]");
                break;
            case "fullheight":
                lt("/OpenAction [3 0 R /FitV null]");
                break;
            case "fullpage":
                lt("/OpenAction [3 0 R /Fit]");
                break;
            case "original":
                lt("/OpenAction [3 0 R /XYZ null null 1]");
                break;
            default:
                var r = "" + gt;
                "%" === r.substr(r.length - 1) && (gt = parseInt(gt) / 100), "number" == typeof gt && lt("/OpenAction [3 0 R /XYZ null null " + T(gt) + "]");
        }
        switch(wt || (wt = "continuous"), wt){
            case "continuous":
                lt("/PageLayout /OneColumn");
                break;
            case "single":
                lt("/PageLayout /SinglePage");
                break;
            case "two":
            case "twoleft":
                lt("/PageLayout /TwoColumnLeft");
                break;
            case "tworight":
                lt("/PageLayout /TwoColumnRight");
        }
        bt && lt("/PageMode /" + bt), Dt.publish("putCatalog"), lt(">>"), lt("endobj");
    }, Ae = y.__private__.putTrailer = function() {
        lt("trailer"), lt("<<"), lt("/Size " + (et + 1)), lt("/Root " + et + " 0 R"), lt("/Info " + (et - 1) + " 0 R"), null !== m && lt("/Encrypt " + Oe.oid + " 0 R"), lt("/ID [ <" + V + "> <" + V + "> ]"), lt(">>");
    }, Se = y.__private__.putHeader = function() {
        lt("%PDF-" + w), lt("%\xba\xdf\xac\xe0");
    }, _e = y.__private__.putXRef = function() {
        var t = "0000000000";
        lt("xref"), lt("0 " + (et + 1)), lt("0000000000 65535 f ");
        for(var e = 1; e <= et; e++)"function" == typeof rt[e] ? lt((t + rt[e]()).slice(-10) + " 00000 n ") : void 0 !== rt[e] ? lt((t + rt[e]).slice(-10) + " 00000 n ") : lt("0000000000 00000 n ");
    }, Pe = y.__private__.buildDocument = function() {
        var t;
        et = 0, it = 0, nt = [], rt = [], at = [], Qt = Kt(), te = Kt(), ct(nt), Dt.publish("buildDocument"), Se(), oe(), function() {
            Dt.publish("putAdditionalObjects");
            for(var t = 0; t < at.length; t++){
                var e = at[t];
                Zt(e.objId, !0), lt(e.content), lt("endobj");
            }
            Dt.publish("postPutAdditionalObjects");
        }(), t = [], function() {
            for(var t in Ft)Ft.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && se(Ft[t]);
        }(), function() {
            var t;
            for(t in Bt)Bt.hasOwnProperty(t) && he(Bt[t]);
        }(), function() {
            for(var t in zt)zt.hasOwnProperty(t) && ue(zt[t]);
        }(), function(t) {
            var e;
            for(e in jt)jt.hasOwnProperty(e) && (jt[e] instanceof $dbd37edd557d3750$export$7235f0ad083cb4c6 ? ce(jt[e]) : jt[e] instanceof $dbd37edd557d3750$export$549f717800d2b57f && le(jt[e], t));
        }(t), Dt.publish("putResources"), t.forEach(fe), fe({
            resourcesOid: te,
            objectOid: Number.MAX_SAFE_INTEGER
        }), Dt.publish("postPutResources"), null !== m && (Oe.oid = Xt(), lt("<<"), lt("/Filter /Standard"), lt("/V " + Oe.v), lt("/R " + Oe.r), lt("/U <" + Oe.toHexString(Oe.U) + ">"), lt("/O <" + Oe.toHexString(Oe.O) + ">"), lt("/P " + Oe.P), lt(">>"), lt("endobj")), Le(), xe();
        var e = it;
        return _e(), Ae(), lt("startxref"), lt("" + e), lt("%%EOF"), ct(ot[$]), nt.join("\n");
    }, ke = y.__private__.getBlob = function(t) {
        return new Blob([
            ft(t)
        ], {
            type: "application/pdf"
        });
    }, Fe = function(t) {
        for(; t.firstChild;)t.removeChild(t.firstChild);
    }, Ie = function(t) {
        var e, r = t.document, n = r.documentElement, i = r.head, a = r.body;
        return i || (i = r.createElement("head"), n.appendChild(i)), a || (a = r.createElement("body"), n.appendChild(a)), Fe(i), Fe(a), (e = r.createElement("style")).appendChild(r.createTextNode("html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}")), i.appendChild(e), {
            document: r,
            body: a
        };
    }, Ce = y.output = y.__private__.output = (Jt = function(t, e) {
        switch("string" == typeof (e = e || {}) ? e = {
            filename: e
        } : e.filename = e.filename || "generated.pdf", t){
            case void 0:
                return Pe();
            case "save":
                y.save(e.filename);
                break;
            case "arraybuffer":
                return ft(Pe());
            case "blob":
                return ke(Pe());
            case "bloburi":
            case "bloburl":
                if (void 0 !== $dbd37edd557d3750$var$i.URL && "function" == typeof $dbd37edd557d3750$var$i.URL.createObjectURL) return $dbd37edd557d3750$var$i.URL && $dbd37edd557d3750$var$i.URL.createObjectURL(ke(Pe())) || void 0;
                $dbd37edd557d3750$var$o.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
                break;
            case "datauristring":
            case "dataurlstring":
                var r = "", n = Pe();
                try {
                    r = $dbd37edd557d3750$var$d(n);
                } catch (L) {
                    r = $dbd37edd557d3750$var$d(unescape(encodeURIComponent(n)));
                }
                return "data:application/pdf;filename=" + encodeURIComponent(e.filename) + ";base64," + r;
            case "pdfobjectnewwindow":
                if ("[object Window]" === Object.prototype.toString.call($dbd37edd557d3750$var$i)) {
                    var a = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", s = !e.pdfObjectUrl;
                    s || (a = e.pdfObjectUrl);
                    var u = $dbd37edd557d3750$var$i.open();
                    if (null !== u) {
                        var c = Ie(u), l = c.document.createElement("script"), h = this;
                        l.src = a, s && (l.integrity = "sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==", l.crossOrigin = "anonymous"), l.onload = function() {
                            u.PDFObject.embed(h.output("dataurlstring"), e);
                        }, c.body.appendChild(l);
                    }
                    return u;
                }
                throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
            case "pdfjsnewwindow":
                if ("[object Window]" === Object.prototype.toString.call($dbd37edd557d3750$var$i)) {
                    var f = e.pdfJsUrl || "examples/PDF.js/web/viewer.html", p = $dbd37edd557d3750$var$i.open();
                    if (null !== p) {
                        var g = Ie(p), m = g.document.createElement("iframe"), v = -1 === f.indexOf("?") ? "?" : "&";
                        h = this, m.id = "pdfViewer", m.width = "500px", m.height = "400px", m.src = f + v + "file=&downloadName=" + encodeURIComponent(e.filename), m.onload = function() {
                            p.document.title = e.filename, m.contentWindow.PDFViewerApplication.open(h.output("bloburl"));
                        }, g.body.appendChild(m);
                    }
                    return p;
                }
                throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
            case "dataurlnewwindow":
                if ("[object Window]" !== Object.prototype.toString.call($dbd37edd557d3750$var$i)) throw new Error("The option dataurlnewwindow just works in a browser-environment.");
                var b = $dbd37edd557d3750$var$i.open();
                if (null !== b) {
                    var w = Ie(b), N = w.document.createElement("iframe");
                    N.src = this.output("datauristring", e), w.body.appendChild(N), b.document.title = e.filename;
                }
                if (b || "undefined" == typeof safari) return b;
                break;
            case "datauri":
            case "dataurl":
                return $dbd37edd557d3750$var$i.document.location.href = this.output("datauristring", e);
            default:
                return null;
        }
    }, Jt.foo = function() {
        try {
            return Jt.apply(this, arguments);
        } catch (r) {
            var t = r.stack || "";
            ~t.indexOf(" at ") && (t = t.split(" at ")[1]);
            var e = "Error in function " + t.split("\n")[0].split("<")[0] + ": " + r.message;
            if (!$dbd37edd557d3750$var$i.console) throw new Error(e);
            $dbd37edd557d3750$var$i.console.error(e, r), $dbd37edd557d3750$var$i.alert && alert(e);
        }
    }, Jt.foo.bar = Jt, Jt.foo), je = function(t) {
        return !0 === Array.isArray(Tt) && Tt.indexOf(t) > -1;
    };
    switch(a){
        case "pt":
            St = 1;
            break;
        case "mm":
            St = 72 / 25.4;
            break;
        case "cm":
            St = 72 / 2.54;
            break;
        case "in":
            St = 72;
            break;
        case "px":
            St = 1 == je("px_scaling") ? .75 : 96 / 72;
            break;
        case "pc":
        case "em":
            St = 12;
            break;
        case "ex":
            St = 6;
            break;
        default:
            if ("number" != typeof a) throw new Error("Invalid unit: " + a);
            St = a;
    }
    var Oe = null;
    K(), Y();
    var Be = y.__private__.getPageInfo = y.getPageInfo = function(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
        return {
            objId: Rt[t].objId,
            pageNumber: t,
            pageContext: Rt[t]
        };
    }, Me = y.__private__.getPageInfoByObjId = function(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
        for(var e in Rt)if (Rt[e].objId === t) break;
        return Be(e);
    }, qe = y.__private__.getCurrentPageInfo = y.getCurrentPageInfo = function() {
        return {
            objId: Rt[$].objId,
            pageNumber: $,
            pageContext: Rt[$]
        };
    };
    y.addPage = function() {
        return ve.apply(this, arguments), this;
    }, y.setPage = function() {
        return ye.apply(this, arguments), ct.call(this, ot[$]), this;
    }, y.insertPage = function(t) {
        return this.addPage(), this.movePage($, t), this;
    }, y.movePage = function(t, e) {
        var r, n;
        if (t > e) {
            r = ot[t], n = Rt[t];
            for(var i = t; i > e; i--)ot[i] = ot[i - 1], Rt[i] = Rt[i - 1];
            ot[e] = r, Rt[e] = n, this.setPage(e);
        } else if (t < e) {
            r = ot[t], n = Rt[t];
            for(var a = t; a < e; a++)ot[a] = ot[a + 1], Rt[a] = Rt[a + 1];
            ot[e] = r, Rt[e] = n, this.setPage(e);
        }
        return this;
    }, y.deletePage = function() {
        return be.apply(this, arguments), this;
    }, y.__private__.text = y.text = function(e, r, n, i, a) {
        var o, s, u, c, l, h, f, d, p, g = (i = i || {}).scope || this;
        if ("number" == typeof e && "number" == typeof r && ("string" == typeof n || Array.isArray(n))) {
            var m = n;
            n = r, r = e, e = m;
        }
        if (arguments[3] instanceof Wt == 0 ? (u = arguments[4], c = arguments[5], "object" === (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(f = arguments[3]) && null !== f || ("string" == typeof u && (c = u, u = null), "string" == typeof f && (c = f, f = null), "number" == typeof f && (u = f, f = null), i = {
            flags: f,
            angle: u,
            align: c
        })) : (R("The transform parameter of text() with a Matrix value"), p = a), isNaN(r) || isNaN(n) || null == e) throw new Error("Invalid arguments passed to jsPDF.text");
        if (0 === e.length) return g;
        var v, y = "", w = "number" == typeof i.lineHeightFactor ? i.lineHeightFactor : Ke, N = g.internal.scaleFactor;
        function L(t) {
            return t = t.split("\t").join(Array(i.TabLen || 9).join(" ")), ge(t, f);
        }
        function x(t) {
            for(var e, r = t.concat(), n = [], i = r.length; i--;)"string" == typeof (e = r.shift()) ? n.push(e) : Array.isArray(t) && (1 === e.length || void 0 === e[1] && void 0 === e[2]) ? n.push(e[0]) : n.push([
                e[0],
                e[1],
                e[2]
            ]);
            return n;
        }
        function A(t, e) {
            var r;
            if ("string" == typeof t) r = e(t)[0];
            else if (Array.isArray(t)) {
                for(var n, i, a = t.concat(), o = [], s = a.length; s--;)"string" == typeof (n = a.shift()) ? o.push(e(n)[0]) : Array.isArray(n) && "string" == typeof n[0] && (i = e(n[0], n[1], n[2]), o.push([
                    i[0],
                    i[1],
                    i[2]
                ]));
                r = o;
            }
            return r;
        }
        var P = !1, k = !0;
        if ("string" == typeof e) P = !0;
        else if (Array.isArray(e)) {
            var F = e.concat();
            s = [];
            for(var I, C = F.length; C--;)("string" != typeof (I = F.shift()) || Array.isArray(I) && "string" != typeof I[0]) && (k = !1);
            P = k;
        }
        if (!1 === P) throw new Error('Type of text must be string or Array. "' + e + '" is not recognized.');
        "string" == typeof e && (e = e.match(/[\r?\n]/) ? e.split(/\r\n|\r|\n/g) : [
            e
        ]);
        var j = pt / g.internal.scaleFactor, O = j * (w - 1);
        switch(i.baseline){
            case "bottom":
                n -= O;
                break;
            case "top":
                n += j - O;
                break;
            case "hanging":
                n += j - 2 * O;
                break;
            case "middle":
                n += j / 2 - O;
        }
        if ((h = i.maxWidth || 0) > 0 && ("string" == typeof e ? e = g.splitTextToSize(e, h) : "[object Array]" === Object.prototype.toString.call(e) && (e = e.reduce(function(t, e) {
            return t.concat(g.splitTextToSize(e, h));
        }, []))), o = {
            text: e,
            x: r,
            y: n,
            options: i,
            mutex: {
                pdfEscape: ge,
                activeFontKey: At,
                fonts: Ft,
                activeFontSize: pt
            }
        }, Dt.publish("preProcessText", o), e = o.text, u = (i = o.options).angle, p instanceof Wt == 0 && u && "number" == typeof u) {
            u *= Math.PI / 180, 0 === i.rotationDirection && (u = -u), _ === S && (u = -u);
            var M = Math.cos(u), q = Math.sin(u);
            p = new Wt(M, q, -q, M, 0, 0);
        } else u && u instanceof Wt && (p = u);
        _ !== S || p || (p = Gt), void 0 !== (l = i.charSpace || hr) && (y += B(U(l)) + " Tc\n", this.setCharSpace(this.getCharSpace() || 0)), void 0 !== (d = i.horizontalScale) && (y += B(100 * d) + " Tz\n"), i.lang;
        var E = -1, D = void 0 !== i.renderingMode ? i.renderingMode : i.stroke, T = g.internal.getCurrentPageInfo().pageContext;
        switch(D){
            case 0:
            case !1:
            case "fill":
                E = 0;
                break;
            case 1:
            case !0:
            case "stroke":
                E = 1;
                break;
            case 2:
            case "fillThenStroke":
                E = 2;
                break;
            case 3:
            case "invisible":
                E = 3;
                break;
            case 4:
            case "fillAndAddForClipping":
                E = 4;
                break;
            case 5:
            case "strokeAndAddPathForClipping":
                E = 5;
                break;
            case 6:
            case "fillThenStrokeAndAddToPathForClipping":
                E = 6;
                break;
            case 7:
            case "addToPathForClipping":
                E = 7;
        }
        var z = void 0 !== T.usedRenderingMode ? T.usedRenderingMode : -1;
        -1 !== E ? y += E + " Tr\n" : -1 !== z && (y += "0 Tr\n"), -1 !== E && (T.usedRenderingMode = E), c = i.align || "left";
        var H, W = pt * w, V = g.internal.pageSize.getWidth(), G = Ft[At];
        l = i.charSpace || hr, h = i.maxWidth || 0, f = Object.assign({
            autoencode: !0,
            noBOM: !0
        }, i.flags);
        var Y = [], J = function(t) {
            return g.getStringUnitWidth(t, {
                font: G,
                charSpace: l,
                fontSize: pt,
                doKerning: !1
            }) * pt / N;
        };
        if ("[object Array]" === Object.prototype.toString.call(e)) {
            var X;
            s = x(e), "left" !== c && (H = s.map(J));
            var K, Z = 0;
            if ("right" === c) {
                r -= H[0], e = [], C = s.length;
                for(var $ = 0; $ < C; $++)0 === $ ? (K = nr(r), X = ir(n)) : (K = U(Z - H[$]), X = -W), e.push([
                    s[$],
                    K,
                    X
                ]), Z = H[$];
            } else if ("center" === c) {
                r -= H[0] / 2, e = [], C = s.length;
                for(var Q = 0; Q < C; Q++)0 === Q ? (K = nr(r), X = ir(n)) : (K = U((Z - H[Q]) / 2), X = -W), e.push([
                    s[Q],
                    K,
                    X
                ]), Z = H[Q];
            } else if ("left" === c) {
                e = [], C = s.length;
                for(var tt = 0; tt < C; tt++)e.push(s[tt]);
            } else if ("justify" === c && "Identity-H" === G.encoding) {
                e = [], C = s.length, h = 0 !== h ? h : V;
                for(var et = 0, rt = 0; rt < C; rt++)if (X = 0 === rt ? ir(n) : -W, K = 0 === rt ? nr(r) : et, rt < C - 1) {
                    var nt = U((h - H[rt]) / (s[rt].split(" ").length - 1)), it = s[rt].split(" ");
                    e.push([
                        it[0] + " ",
                        K,
                        X
                    ]), et = 0;
                    for(var at = 1; at < it.length; at++){
                        var ot = (J(it[at - 1] + " " + it[at]) - J(it[at])) * N + nt;
                        at == it.length - 1 ? e.push([
                            it[at],
                            ot,
                            0
                        ]) : e.push([
                            it[at] + " ",
                            ot,
                            0
                        ]), et -= ot;
                    }
                } else e.push([
                    s[rt],
                    K,
                    X
                ]);
                e.push([
                    "",
                    et,
                    0
                ]);
            } else {
                if ("justify" !== c) throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
                for(e = [], C = s.length, h = 0 !== h ? h : V, rt = 0; rt < C; rt++){
                    X = 0 === rt ? ir(n) : -W, K = 0 === rt ? nr(r) : 0;
                    var st = s[rt].split(" ").length - 1, ut = st > 0 ? (h - H[rt]) / st : 0;
                    rt < C - 1 ? Y.push(B(U(ut))) : Y.push(0), e.push([
                        s[rt],
                        K,
                        X
                    ]);
                }
            }
        }
        !0 === ("boolean" == typeof i.R2L ? i.R2L : vt) && (e = A(e, function(t, e, r) {
            return [
                t.split("").reverse().join(""),
                e,
                r
            ];
        })), o = {
            text: e,
            x: r,
            y: n,
            options: i,
            mutex: {
                pdfEscape: ge,
                activeFontKey: At,
                fonts: Ft,
                activeFontSize: pt
            }
        }, Dt.publish("postProcessText", o), e = o.text, v = o.mutex.isHex || !1;
        var ct = Ft[At].encoding;
        "WinAnsiEncoding" !== ct && "StandardEncoding" !== ct || (e = A(e, function(t, e, r) {
            return [
                L(t),
                e,
                r
            ];
        })), s = x(e), e = [];
        for(var ht, ft, dt, gt = Array.isArray(s[0]) ? 1 : 0, mt = "", bt = function(t, e, r) {
            var n = "";
            return r instanceof Wt ? (r = "number" == typeof i.angle ? Vt(r, new Wt(1, 0, 0, 1, t, e)) : Vt(new Wt(1, 0, 0, 1, t, e), r), _ === S && (r = Vt(new Wt(1, 0, 0, -1, 0, 0), r)), n = r.join(" ") + " Tm\n") : n = B(t) + " " + B(e) + " Td\n", n;
        }, yt = 0; yt < s.length; yt++){
            switch(mt = "", gt){
                case 1:
                    dt = (v ? "<" : "(") + s[yt][0] + (v ? ">" : ")"), ht = parseFloat(s[yt][1]), ft = parseFloat(s[yt][2]);
                    break;
                case 0:
                    dt = (v ? "<" : "(") + s[yt] + (v ? ">" : ")"), ht = nr(r), ft = ir(n);
            }
            void 0 !== Y && void 0 !== Y[yt] && (mt = Y[yt] + " Tw\n"), 0 === yt ? e.push(mt + bt(ht, ft, p) + dt) : 0 === gt ? e.push(mt + dt) : 1 === gt && e.push(mt + bt(ht, ft, p) + dt);
        }
        e = 0 === gt ? e.join(" Tj\nT* ") : e.join(" Tj\n"), e += " Tj\n";
        var wt = "BT\n/";
        return wt += At + " " + pt + " Tf\n", wt += B(pt * w) + " TL\n", wt += cr + "\n", wt += y, wt += e, lt(wt += "ET"), b[At] = !0, g;
    };
    var Ee = y.__private__.clip = y.clip = function(t) {
        return lt("evenodd" === t ? "W*" : "W"), this;
    };
    y.clipEvenOdd = function() {
        return Ee("evenodd");
    }, y.__private__.discardPath = y.discardPath = function() {
        return lt("n"), this;
    };
    var Re = y.__private__.isValidStyle = function(t) {
        var e = !1;
        return -1 !== [
            void 0,
            null,
            "S",
            "D",
            "F",
            "DF",
            "FD",
            "f",
            "f*",
            "B",
            "B*",
            "n"
        ].indexOf(t) && (e = !0), e;
    };
    y.__private__.setDefaultPathOperation = y.setDefaultPathOperation = function(t) {
        return Re(t) && (g = t), this;
    };
    var De = y.__private__.getStyle = y.getStyle = function(t) {
        var e = g;
        switch(t){
            case "D":
            case "S":
                e = "S";
                break;
            case "F":
                e = "f";
                break;
            case "FD":
            case "DF":
                e = "B";
                break;
            case "f":
            case "f*":
            case "B":
            case "B*":
                e = t;
        }
        return e;
    }, Te = y.close = function() {
        return lt("h"), this;
    };
    y.stroke = function() {
        return lt("S"), this;
    }, y.fill = function(t) {
        return ze("f", t), this;
    }, y.fillEvenOdd = function(t) {
        return ze("f*", t), this;
    }, y.fillStroke = function(t) {
        return ze("B", t), this;
    }, y.fillStrokeEvenOdd = function(t) {
        return ze("B*", t), this;
    };
    var ze = function(e, r) {
        "object" === (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(r) ? We(r, e) : lt(e);
    }, Ue = function(t) {
        null === t || _ === S && void 0 === t || (t = De(t), lt(t));
    };
    function He(t, e, r, n, i) {
        var a = new $dbd37edd557d3750$export$549f717800d2b57f(e || this.boundingBox, r || this.xStep, n || this.yStep, this.gState, i || this.matrix);
        a.stream = this.stream;
        var o = t + "$$" + this.cloneIndex++ + "$$";
        return Yt(o, a), a;
    }
    var We = function(t, e) {
        var r = Ot[t.key], n = jt[r];
        if (n instanceof $dbd37edd557d3750$export$7235f0ad083cb4c6) lt("q"), lt(Ve(e)), n.gState && y.setGState(n.gState), lt(t.matrix.toString() + " cm"), lt("/" + r + " sh"), lt("Q");
        else if (n instanceof $dbd37edd557d3750$export$549f717800d2b57f) {
            var i = new Wt(1, 0, 0, -1, 0, Pr());
            t.matrix && (i = i.multiply(t.matrix || Gt), r = He.call(n, t.key, t.boundingBox, t.xStep, t.yStep, i).id), lt("q"), lt("/Pattern cs"), lt("/" + r + " scn"), n.gState && y.setGState(n.gState), lt(e), lt("Q");
        }
    }, Ve = function(t) {
        switch(t){
            case "f":
            case "F":
            case "n":
                return "W n";
            case "f*":
                return "W* n";
            case "B":
            case "S":
                return "W S";
            case "B*":
                return "W* S";
        }
    }, Ge = y.moveTo = function(t, e) {
        return lt(B(U(t)) + " " + B(H(e)) + " m"), this;
    }, Ye = y.lineTo = function(t, e) {
        return lt(B(U(t)) + " " + B(H(e)) + " l"), this;
    }, Je = y.curveTo = function(t, e, r, n, i, a) {
        return lt([
            B(U(t)),
            B(H(e)),
            B(U(r)),
            B(H(n)),
            B(U(i)),
            B(H(a)),
            "c"
        ].join(" ")), this;
    };
    y.__private__.line = y.line = function(t, e, r, n, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Re(i)) throw new Error("Invalid arguments passed to jsPDF.line");
        return _ === A ? this.lines([
            [
                r - t,
                n - e
            ]
        ], t, e, [
            1,
            1
        ], i || "S") : this.lines([
            [
                r - t,
                n - e
            ]
        ], t, e, [
            1,
            1
        ]).stroke();
    }, y.__private__.lines = y.lines = function(t, e, r, n, i, a) {
        var o, s, u, c, l, h, f, d, p, g, m, v;
        if ("number" == typeof t && (v = r, r = e, e = t, t = v), n = n || [
            1,
            1
        ], a = a || !1, isNaN(e) || isNaN(r) || !Array.isArray(t) || !Array.isArray(n) || !Re(i) || "boolean" != typeof a) throw new Error("Invalid arguments passed to jsPDF.lines");
        for(Ge(e, r), o = n[0], s = n[1], c = t.length, g = e, m = r, u = 0; u < c; u++)2 === (l = t[u]).length ? (g = l[0] * o + g, m = l[1] * s + m, Ye(g, m)) : (h = l[0] * o + g, f = l[1] * s + m, d = l[2] * o + g, p = l[3] * s + m, g = l[4] * o + g, m = l[5] * s + m, Je(h, f, d, p, g, m));
        return a && Te(), Ue(i), this;
    }, y.path = function(t) {
        for(var e = 0; e < t.length; e++){
            var r = t[e], n = r.c;
            switch(r.op){
                case "m":
                    Ge(n[0], n[1]);
                    break;
                case "l":
                    Ye(n[0], n[1]);
                    break;
                case "c":
                    Je.apply(this, n);
                    break;
                case "h":
                    Te();
            }
        }
        return this;
    }, y.__private__.rect = y.rect = function(t, e, r, n, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Re(i)) throw new Error("Invalid arguments passed to jsPDF.rect");
        return _ === A && (n = -n), lt([
            B(U(t)),
            B(H(e)),
            B(U(r)),
            B(U(n)),
            "re"
        ].join(" ")), Ue(i), this;
    }, y.__private__.triangle = y.triangle = function(t, e, r, n, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(a) || !Re(o)) throw new Error("Invalid arguments passed to jsPDF.triangle");
        return this.lines([
            [
                r - t,
                n - e
            ],
            [
                i - r,
                a - n
            ],
            [
                t - i,
                e - a
            ]
        ], t, e, [
            1,
            1
        ], o, !0), this;
    }, y.__private__.roundedRect = y.roundedRect = function(t, e, r, n, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(a) || !Re(o)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
        var s = 4 / 3 * (Math.SQRT2 - 1);
        return i = Math.min(i, .5 * r), a = Math.min(a, .5 * n), this.lines([
            [
                r - 2 * i,
                0
            ],
            [
                i * s,
                0,
                i,
                a - a * s,
                i,
                a
            ],
            [
                0,
                n - 2 * a
            ],
            [
                0,
                a * s,
                -i * s,
                a,
                -i,
                a
            ],
            [
                2 * i - r,
                0
            ],
            [
                -i * s,
                0,
                -i,
                -a * s,
                -i,
                -a
            ],
            [
                0,
                2 * a - n
            ],
            [
                0,
                -a * s,
                i * s,
                -a,
                i,
                -a
            ]
        ], t + i, e, [
            1,
            1
        ], o, !0), this;
    }, y.__private__.ellipse = y.ellipse = function(t, e, r, n, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Re(i)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
        var a = 4 / 3 * (Math.SQRT2 - 1) * r, o = 4 / 3 * (Math.SQRT2 - 1) * n;
        return Ge(t + r, e), Je(t + r, e - o, t + a, e - n, t, e - n), Je(t - a, e - n, t - r, e - o, t - r, e), Je(t - r, e + o, t - a, e + n, t, e + n), Je(t + a, e + n, t + r, e + o, t + r, e), Ue(i), this;
    }, y.__private__.circle = y.circle = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || !Re(n)) throw new Error("Invalid arguments passed to jsPDF.circle");
        return this.ellipse(t, e, r, r, n);
    }, y.setFont = function(t, e, r) {
        return r && (e = F(e, r)), At = Ne(t, e, {
            disableWarning: !1
        }), this;
    };
    var Xe = y.__private__.getFont = y.getFont = function() {
        return Ft[Ne.apply(y, arguments)];
    };
    y.__private__.getFontList = y.getFontList = function() {
        var t, e, r = {};
        for(t in It)if (It.hasOwnProperty(t)) for(e in r[t] = [], It[t])It[t].hasOwnProperty(e) && r[t].push(e);
        return r;
    }, y.addFont = function(t, e, r, n, i) {
        var a = [
            "StandardEncoding",
            "MacRomanEncoding",
            "Identity-H",
            "WinAnsiEncoding"
        ];
        return arguments[3] && -1 !== a.indexOf(arguments[3]) ? i = arguments[3] : arguments[3] && -1 == a.indexOf(arguments[3]) && (r = F(r, n)), pe.call(this, t, e, r, i = i || "Identity-H");
    };
    var Ke, Ze = e.lineWidth || .200025, $e = y.__private__.getLineWidth = y.getLineWidth = function() {
        return Ze;
    }, Qe = y.__private__.setLineWidth = y.setLineWidth = function(t) {
        return Ze = t, lt(B(U(t)) + " w"), this;
    };
    y.__private__.setLineDash = $dbd37edd557d3750$export$2e2bcd8739ae039.API.setLineDash = $dbd37edd557d3750$export$2e2bcd8739ae039.API.setLineDashPattern = function(t, e) {
        if (t = t || [], e = e || 0, isNaN(e) || !Array.isArray(t)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
        return t = t.map(function(t) {
            return B(U(t));
        }).join(" "), e = B(U(e)), lt("[" + t + "] " + e + " d"), this;
    };
    var tr = y.__private__.getLineHeight = y.getLineHeight = function() {
        return pt * Ke;
    };
    y.__private__.getLineHeight = y.getLineHeight = function() {
        return pt * Ke;
    };
    var er = y.__private__.setLineHeightFactor = y.setLineHeightFactor = function(t) {
        return "number" == typeof (t = t || 1.15) && (Ke = t), this;
    }, rr = y.__private__.getLineHeightFactor = y.getLineHeightFactor = function() {
        return Ke;
    };
    er(e.lineHeight);
    var nr = y.__private__.getHorizontalCoordinate = function(t) {
        return U(t);
    }, ir = y.__private__.getVerticalCoordinate = function(t) {
        return _ === S ? t : Rt[$].mediaBox.topRightY - Rt[$].mediaBox.bottomLeftY - U(t);
    }, ar = y.__private__.getHorizontalCoordinateString = y.getHorizontalCoordinateString = function(t) {
        return B(nr(t));
    }, or = y.__private__.getVerticalCoordinateString = y.getVerticalCoordinateString = function(t) {
        return B(ir(t));
    }, sr = e.strokeColor || "0 G";
    y.__private__.getStrokeColor = y.getDrawColor = function() {
        return ee(sr);
    }, y.__private__.setStrokeColor = y.setDrawColor = function(t, e, r, n) {
        return sr = re({
            ch1: t,
            ch2: e,
            ch3: r,
            ch4: n,
            pdfColorType: "draw",
            precision: 2
        }), lt(sr), this;
    };
    var ur = e.fillColor || "0 g";
    y.__private__.getFillColor = y.getFillColor = function() {
        return ee(ur);
    }, y.__private__.setFillColor = y.setFillColor = function(t, e, r, n) {
        return ur = re({
            ch1: t,
            ch2: e,
            ch3: r,
            ch4: n,
            pdfColorType: "fill",
            precision: 2
        }), lt(ur), this;
    };
    var cr = e.textColor || "0 g", lr = y.__private__.getTextColor = y.getTextColor = function() {
        return ee(cr);
    };
    y.__private__.setTextColor = y.setTextColor = function(t, e, r, n) {
        return cr = re({
            ch1: t,
            ch2: e,
            ch3: r,
            ch4: n,
            pdfColorType: "text",
            precision: 3
        }), this;
    };
    var hr = e.charSpace, fr = y.__private__.getCharSpace = y.getCharSpace = function() {
        return parseFloat(hr || 0);
    };
    y.__private__.setCharSpace = y.setCharSpace = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
        return hr = t, this;
    };
    var dr = 0;
    y.CapJoinStyles = {
        0: 0,
        butt: 0,
        but: 0,
        miter: 0,
        1: 1,
        round: 1,
        rounded: 1,
        circle: 1,
        2: 2,
        projecting: 2,
        project: 2,
        square: 2,
        bevel: 2
    }, y.__private__.setLineCap = y.setLineCap = function(t) {
        var e = y.CapJoinStyles[t];
        if (void 0 === e) throw new Error("Line cap style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return dr = e, lt(e + " J"), this;
    };
    var pr = 0;
    y.__private__.setLineJoin = y.setLineJoin = function(t) {
        var e = y.CapJoinStyles[t];
        if (void 0 === e) throw new Error("Line join style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return pr = e, lt(e + " j"), this;
    }, y.__private__.setLineMiterLimit = y.__private__.setMiterLimit = y.setLineMiterLimit = y.setMiterLimit = function(t) {
        if (t = t || 0, isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
        return lt(B(U(t)) + " M"), this;
    }, y.GState = $dbd37edd557d3750$export$1bc649ab427a02ba, y.setGState = function(t) {
        (t = "string" == typeof t ? Bt[Mt[t]] : gr(null, t)).equals(qt) || (lt("/" + t.id + " gs"), qt = t);
    };
    var gr = function(t, e) {
        if (!t || !Mt[t]) {
            var r = !1;
            for(var n in Bt)if (Bt.hasOwnProperty(n) && Bt[n].equals(e)) {
                r = !0;
                break;
            }
            if (r) e = Bt[n];
            else {
                var i = "GS" + (Object.keys(Bt).length + 1).toString(10);
                Bt[i] = e, e.id = i;
            }
            return t && (Mt[t] = e.id), Dt.publish("addGState", e), e;
        }
    };
    y.addGState = function(t, e) {
        return gr(t, e), this;
    }, y.saveGraphicsState = function() {
        return lt("q"), Ct.push({
            key: At,
            size: pt,
            color: cr
        }), this;
    }, y.restoreGraphicsState = function() {
        lt("Q");
        var t = Ct.pop();
        return At = t.key, pt = t.size, cr = t.color, qt = null, this;
    }, y.setCurrentTransformationMatrix = function(t) {
        return lt(t.toString() + " cm"), this;
    }, y.comment = function(t) {
        return lt("#" + t), this;
    };
    var mr = function(t, e) {
        var r = t || 0;
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function() {
                return r;
            },
            set: function(t) {
                isNaN(t) || (r = parseFloat(t));
            }
        });
        var n = e || 0;
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function() {
                return n;
            },
            set: function(t) {
                isNaN(t) || (n = parseFloat(t));
            }
        });
        var i = "pt";
        return Object.defineProperty(this, "type", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                i = t.toString();
            }
        }), this;
    }, vr = function(t, e, r, n) {
        mr.call(this, t, e), this.type = "rect";
        var i = r || 0;
        Object.defineProperty(this, "w", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                isNaN(t) || (i = parseFloat(t));
            }
        });
        var a = n || 0;
        return Object.defineProperty(this, "h", {
            enumerable: !0,
            get: function() {
                return a;
            },
            set: function(t) {
                isNaN(t) || (a = parseFloat(t));
            }
        }), this;
    }, br = function() {
        this.page = Et, this.currentPage = $, this.pages = ot.slice(0), this.pagesContext = Rt.slice(0), this.x = _t, this.y = Pt, this.matrix = kt, this.width = Nr($), this.height = xr($), this.outputDestination = ut, this.id = "", this.objectNumber = -1;
    };
    br.prototype.restore = function() {
        Et = this.page, $ = this.currentPage, Rt = this.pagesContext, ot = this.pages, _t = this.x, Pt = this.y, kt = this.matrix, Lr($, this.width), Ar($, this.height), ut = this.outputDestination;
    };
    var yr = function(t, e, r, n, i) {
        Ht.push(new br), Et = $ = 0, ot = [], _t = t, Pt = e, kt = i, me([
            r,
            n
        ]);
    };
    for(var wr in y.beginFormObject = function(t, e, r, n, i) {
        return yr(t, e, r, n, i), this;
    }, y.endFormObject = function(t) {
        return function(t) {
            if (Ut[t]) Ht.pop().restore();
            else {
                var e = new br, r = "Xo" + (Object.keys(zt).length + 1).toString(10);
                e.id = r, Ut[t] = r, zt[r] = e, Dt.publish("addFormObject", e), Ht.pop().restore();
            }
        }(t), this;
    }, y.doFormObject = function(t, e) {
        var r = zt[Ut[t]];
        return lt("q"), lt(e.toString() + " cm"), lt("/" + r.id + " Do"), lt("Q"), this;
    }, y.getFormObject = function(t) {
        var e = zt[Ut[t]];
        return {
            x: e.x,
            y: e.y,
            width: e.width,
            height: e.height,
            matrix: e.matrix
        };
    }, y.save = function(t, e) {
        return t = t || "generated.pdf", (e = e || {}).returnPromise = e.returnPromise || !1, !1 === e.returnPromise ? ($dbd37edd557d3750$var$l(ke(Pe()), t), "function" == typeof $dbd37edd557d3750$var$l.unload && $dbd37edd557d3750$var$i.setTimeout && setTimeout($dbd37edd557d3750$var$l.unload, 911), this) : new Promise(function(e, r) {
            try {
                var n = $dbd37edd557d3750$var$l(ke(Pe()), t);
                "function" == typeof $dbd37edd557d3750$var$l.unload && $dbd37edd557d3750$var$i.setTimeout && setTimeout($dbd37edd557d3750$var$l.unload, 911), e(n);
            } catch (a) {
                r(a.message);
            }
        });
    }, $dbd37edd557d3750$export$2e2bcd8739ae039.API)$dbd37edd557d3750$export$2e2bcd8739ae039.API.hasOwnProperty(wr) && ("events" === wr && $dbd37edd557d3750$export$2e2bcd8739ae039.API.events.length ? function(t, e) {
        var r, n, i;
        for(i = e.length - 1; -1 !== i; i--)r = e[i][0], n = e[i][1], t.subscribe.apply(t, [
            r
        ].concat("function" == typeof n ? [
            n
        ] : n));
    }(Dt, $dbd37edd557d3750$export$2e2bcd8739ae039.API.events) : y[wr] = $dbd37edd557d3750$export$2e2bcd8739ae039.API[wr]);
    function Nr(t) {
        return Rt[t].mediaBox.topRightX - Rt[t].mediaBox.bottomLeftX;
    }
    function Lr(t, e) {
        Rt[t].mediaBox.topRightX = e + Rt[t].mediaBox.bottomLeftX;
    }
    function xr(t) {
        return Rt[t].mediaBox.topRightY - Rt[t].mediaBox.bottomLeftY;
    }
    function Ar(t, e) {
        Rt[t].mediaBox.topRightY = e + Rt[t].mediaBox.bottomLeftY;
    }
    var Sr = y.getPageWidth = function(t) {
        return Nr(t = t || $) / St;
    }, _r = y.setPageWidth = function(t, e) {
        Lr(t, e * St);
    }, Pr = y.getPageHeight = function(t) {
        return xr(t = t || $) / St;
    }, kr = y.setPageHeight = function(t, e) {
        Ar(t, e * St);
    };
    return y.internal = {
        pdfEscape: ge,
        getStyle: De,
        getFont: Xe,
        getFontSize: mt,
        getCharSpace: fr,
        getTextColor: lr,
        getLineHeight: tr,
        getLineHeightFactor: rr,
        getLineWidth: $e,
        write: ht,
        getHorizontalCoordinate: nr,
        getVerticalCoordinate: ir,
        getCoordinateString: ar,
        getVerticalCoordinateString: or,
        collections: {},
        newObject: Xt,
        newAdditionalObject: $t,
        newObjectDeferred: Kt,
        newObjectDeferredBegin: Zt,
        getFilters: ne,
        putStream: ie,
        events: Dt,
        scaleFactor: St,
        pageSize: {
            getWidth: function() {
                return Sr($);
            },
            setWidth: function(t) {
                _r($, t);
            },
            getHeight: function() {
                return Pr($);
            },
            setHeight: function(t) {
                kr($, t);
            }
        },
        encryptionOptions: m,
        encryption: Oe,
        getEncryptor: function(t) {
            return null !== m ? Oe.encryptor(t, 0) : function(t) {
                return t;
            };
        },
        output: Ce,
        getNumberOfPages: we,
        get pages () {
            return ot;
        },
        out: lt,
        f2: T,
        f3: z,
        getPageInfo: Be,
        getPageInfoByObjId: Me,
        getCurrentPageInfo: qe,
        getPDFVersion: N,
        Point: mr,
        Rectangle: vr,
        Matrix: Wt,
        hasHotfix: je
    }, Object.defineProperty(y.internal.pageSize, "width", {
        get: function() {
            return Sr($);
        },
        set: function(t) {
            _r($, t);
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(y.internal.pageSize, "height", {
        get: function() {
            return Pr($);
        },
        set: function(t) {
            kr($, t);
        },
        enumerable: !0,
        configurable: !0
    }), (function(t) {
        for(var e = 0, r = dt.length; e < r; e++){
            var n = pe.call(this, t[e][0], t[e][1], t[e][2], dt[e][3], !0);
            !1 === v && (b[n] = !0);
            var i = t[e][0].split("-");
            de({
                id: n,
                fontName: i[0],
                fontStyle: i[1] || ""
            });
        }
        Dt.publish("addFonts", {
            fonts: Ft,
            dictionary: It
        });
    }).call(y, dt), At = "F1", ve(s, n), Dt.publish("initialized"), y;
}
$dbd37edd557d3750$var$I.prototype.lsbFirstWord = function(t) {
    return String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255);
}, $dbd37edd557d3750$var$I.prototype.toHexString = function(t) {
    return t.split("").map(function(t) {
        return ("0" + (255 & t.charCodeAt(0)).toString(16)).slice(-2);
    }).join("");
}, $dbd37edd557d3750$var$I.prototype.hexToBytes = function(t) {
    for(var e = [], r = 0; r < t.length; r += 2)e.push(String.fromCharCode(parseInt(t.substr(r, 2), 16)));
    return e.join("");
}, $dbd37edd557d3750$var$I.prototype.processOwnerPassword = function(t, e) {
    return $dbd37edd557d3750$var$k($dbd37edd557d3750$var$S(e).substr(0, 5), t);
}, $dbd37edd557d3750$var$I.prototype.encryptor = function(t, e) {
    var r = $dbd37edd557d3750$var$S(this.encryptionKey + String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, 255 & e, e >> 8 & 255)).substr(0, 10);
    return function(t) {
        return $dbd37edd557d3750$var$k(r, t);
    };
}, $dbd37edd557d3750$export$1bc649ab427a02ba.prototype.equals = function(e) {
    var r, n = "id,objectNumber,equals";
    if (!e || (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(e) !== (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(this)) return !1;
    var i = 0;
    for(r in this)if (!(n.indexOf(r) >= 0)) {
        if (this.hasOwnProperty(r) && !e.hasOwnProperty(r)) return !1;
        if (this[r] !== e[r]) return !1;
        i++;
    }
    for(r in e)e.hasOwnProperty(r) && n.indexOf(r) < 0 && i--;
    return 0 === i;
}, $dbd37edd557d3750$export$2e2bcd8739ae039.API = {
    events: []
}, $dbd37edd557d3750$export$2e2bcd8739ae039.version = "4.2.1";
var $dbd37edd557d3750$var$R = $dbd37edd557d3750$export$2e2bcd8739ae039.API, $dbd37edd557d3750$var$D = 1, $dbd37edd557d3750$var$T = function(t) {
    return t.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, $dbd37edd557d3750$var$z = function(t) {
    return t.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, $dbd37edd557d3750$var$U = function(t) {
    return t.toString().replace(/#/g, "#23").replace(/[\s\n\r()<>[\]{}\/%]/g, function(t) {
        var e = t.charCodeAt(0).toString(16).toUpperCase();
        return "#" + (1 === e.length ? "0" + e : e);
    });
}, $dbd37edd557d3750$var$H = function(t) {
    return t.toFixed(2);
}, $dbd37edd557d3750$var$W = function(t) {
    return t.toFixed(5);
};
$dbd37edd557d3750$var$R.__acroform__ = {};
var $dbd37edd557d3750$var$V = function(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
}, $dbd37edd557d3750$var$G = function(t) {
    return t * $dbd37edd557d3750$var$D;
}, $dbd37edd557d3750$var$Y = function(t) {
    var e = new $dbd37edd557d3750$var$lt, r = $dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t) || 0, n = $dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t) || 0;
    return e.BBox = [
        0,
        0,
        Number($dbd37edd557d3750$var$H(n)),
        Number($dbd37edd557d3750$var$H(r))
    ], e;
}, $dbd37edd557d3750$var$J = $dbd37edd557d3750$var$R.__acroform__.setBit = function(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
    return t | 1 << e;
}, $dbd37edd557d3750$var$X = $dbd37edd557d3750$var$R.__acroform__.clearBit = function(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
    return t & ~(1 << e);
}, $dbd37edd557d3750$var$K = $dbd37edd557d3750$var$R.__acroform__.getBit = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
    return t & 1 << e ? 1 : 0;
}, $dbd37edd557d3750$var$Z = $dbd37edd557d3750$var$R.__acroform__.getBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
    return $dbd37edd557d3750$var$K(t, e - 1);
}, $dbd37edd557d3750$var$$ = $dbd37edd557d3750$var$R.__acroform__.setBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
    return $dbd37edd557d3750$var$J(t, e - 1);
}, $dbd37edd557d3750$var$Q = $dbd37edd557d3750$var$R.__acroform__.clearBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
    return $dbd37edd557d3750$var$X(t, e - 1);
}, $dbd37edd557d3750$var$tt = $dbd37edd557d3750$var$R.__acroform__.calculateCoordinates = function(t, e) {
    var r = e.internal.getHorizontalCoordinate, n = e.internal.getVerticalCoordinate, i = t[0], a = t[1], o = t[2], s = t[3], u = {};
    return u.lowerLeft_X = r(i) || 0, u.lowerLeft_Y = n(a + s) || 0, u.upperRight_X = r(i + o) || 0, u.upperRight_Y = n(a) || 0, [
        Number($dbd37edd557d3750$var$H(u.lowerLeft_X)),
        Number($dbd37edd557d3750$var$H(u.lowerLeft_Y)),
        Number($dbd37edd557d3750$var$H(u.upperRight_X)),
        Number($dbd37edd557d3750$var$H(u.upperRight_Y))
    ];
}, $dbd37edd557d3750$var$et = function(t) {
    if (t.appearanceStreamContent) return t.appearanceStreamContent;
    if (t.V || t.DV) {
        var e = [], r = t._V || t.DV, n = $dbd37edd557d3750$var$rt(t, r), i = t.scope.internal.getFont(t.fontName, t.fontStyle).id;
        e.push("/Tx BMC"), e.push("q"), e.push("BT"), e.push(t.scope.__private__.encodeColorString(t.color)), e.push("/" + i + " " + $dbd37edd557d3750$var$H(n.fontSize) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push(n.text), e.push("ET"), e.push("Q"), e.push("EMC");
        var a = $dbd37edd557d3750$var$Y(t);
        return a.scope = t.scope, a.stream = e.join("\n"), a;
    }
}, $dbd37edd557d3750$var$rt = function(t, e) {
    var r = 0 === t.fontSize ? t.maxFontSize : t.fontSize, n = {
        text: "",
        fontSize: ""
    }, i = (e = ")" == (e = "(" == e.substr(0, 1) ? e.substr(1) : e).substr(e.length - 1) ? e.substr(0, e.length - 1) : e).split(" ");
    i = t.multiline ? i.map(function(t) {
        return t.split("\n");
    }) : i.map(function(t) {
        return [
            t
        ];
    });
    var a = r, o = $dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t) || 0;
    o = o < 0 ? -o : o;
    var s = $dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t) || 0;
    s = s < 0 ? -s : s;
    var u = function(e, r, n) {
        if (e + 1 < i.length) {
            var a = r + " " + i[e + 1][0];
            return $dbd37edd557d3750$var$nt(a, t, n).width <= s - 4;
        }
        return !1;
    };
    a++;
    t: for(; a > 0;){
        e = "", a--;
        var c, l, h = $dbd37edd557d3750$var$nt("3", t, a).height, f = t.multiline ? o - a : (o - h) / 2, d = f += 2, p = 0, g = 0, m = 0;
        if (a <= 0) {
            e = "(...) Tj\n", e += "% Width of Text: " + $dbd37edd557d3750$var$nt(e, t, a = 12).width + ", FieldWidth:" + s + "\n";
            break;
        }
        for(var v = "", b = 0, y = 0; y < i.length; y++)if (i.hasOwnProperty(y)) {
            var w = !1;
            if (1 !== i[y].length && m !== i[y].length - 1) {
                if ((h + 2) * (b + 2) + 2 > o) continue t;
                v += i[y][m], w = !0, g = y, y--;
            } else {
                v = " " == (v += i[y][m] + " ").substr(v.length - 1) ? v.substr(0, v.length - 1) : v;
                var N = parseInt(y), L = u(N, v, a), x = y >= i.length - 1;
                if (L && !x) {
                    v += " ", m = 0;
                    continue;
                }
                if (L || x) {
                    if (x) g = N;
                    else if (t.multiline && (h + 2) * (b + 2) + 2 > o) continue t;
                } else {
                    if (!t.multiline) continue t;
                    if ((h + 2) * (b + 2) + 2 > o) continue t;
                    g = N;
                }
            }
            for(var A = "", S = p; S <= g; S++){
                var _ = i[S];
                if (t.multiline) {
                    if (S === g) {
                        A += _[m] + " ", m = (m + 1) % _.length;
                        continue;
                    }
                    if (S === p) {
                        A += _[_.length - 1] + " ";
                        continue;
                    }
                }
                A += _[0] + " ";
            }
            switch(A = " " == A.substr(A.length - 1) ? A.substr(0, A.length - 1) : A, l = $dbd37edd557d3750$var$nt(A, t, a).width, t.textAlign){
                case "right":
                    c = s - l - 2;
                    break;
                case "center":
                    c = (s - l) / 2;
                    break;
                default:
                    c = 2;
            }
            e += $dbd37edd557d3750$var$H(c) + " " + $dbd37edd557d3750$var$H(d) + " Td\n", e += "(" + $dbd37edd557d3750$var$T(A) + ") Tj\n", e += -$dbd37edd557d3750$var$H(c) + " 0 Td\n", d = -(a + 2), l = 0, p = w ? g : g + 1, b++, v = "";
        }
        break;
    }
    return n.text = e, n.fontSize = a, n;
}, $dbd37edd557d3750$var$nt = function(t, e, r) {
    var n = e.scope.internal.getFont(e.fontName, e.fontStyle), i = e.scope.getStringUnitWidth(t, {
        font: n,
        fontSize: parseFloat(r),
        charSpace: 0
    }) * parseFloat(r);
    return {
        height: e.scope.getStringUnitWidth("3", {
            font: n,
            fontSize: parseFloat(r),
            charSpace: 0
        }) * parseFloat(r) * 1.5,
        width: i
    };
}, $dbd37edd557d3750$var$it = {
    fields: [],
    xForms: [],
    acroFormDictionaryRoot: null,
    printedOut: !1,
    internal: null,
    isInitialized: !1
}, $dbd37edd557d3750$var$at = function(t, e) {
    var r = {
        type: "reference",
        object: t
    };
    void 0 === e.internal.getPageInfo(t.page).pageContext.annotations.find(function(t) {
        return t.type === r.type && t.object === r.object;
    }) && e.internal.getPageInfo(t.page).pageContext.annotations.push(r);
}, $dbd37edd557d3750$var$ot = function(e, r) {
    if (r.scope = e, void 0 !== e.internal && (void 0 === e.internal.acroformPlugin || !1 === e.internal.acroformPlugin.isInitialized)) {
        if ($dbd37edd557d3750$var$ft.FieldNum = 0, e.internal.acroformPlugin = JSON.parse(JSON.stringify($dbd37edd557d3750$var$it)), e.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
        $dbd37edd557d3750$var$D = e.internal.scaleFactor, e.internal.acroformPlugin.acroFormDictionaryRoot = new $dbd37edd557d3750$var$ht, e.internal.acroformPlugin.acroFormDictionaryRoot.scope = e, e.internal.acroformPlugin.acroFormDictionaryRoot._eventID = e.internal.events.subscribe("postPutResources", function() {
            !function(t) {
                t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID, t.internal.acroformPlugin.printedOut = !0;
            }(e);
        }), e.internal.events.subscribe("buildDocument", function() {
            !function(t) {
                t.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
                var e = t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
                for(var r in e)if (e.hasOwnProperty(r)) {
                    var n = e[r];
                    n.objId = void 0, n.hasAnnotation && $dbd37edd557d3750$var$at(n, t);
                }
            }(e);
        }), e.internal.events.subscribe("putCatalog", function() {
            !function(t) {
                if (void 0 === t.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("putCatalogCallback: Root missing.");
                t.internal.write("/AcroForm " + t.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
            }(e);
        }), e.internal.events.subscribe("postPutPages", function(r) {
            !function(e, r) {
                var n = !e;
                for(var i in e || (r.internal.newObjectDeferredBegin(r.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), r.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), e = e || r.internal.acroformPlugin.acroFormDictionaryRoot.Kids)if (e.hasOwnProperty(i)) {
                    var a = e[i], o = [], s = a.Rect;
                    if (a.Rect && (a.Rect = $dbd37edd557d3750$var$tt(a.Rect, r)), r.internal.newObjectDeferredBegin(a.objId, !0), a.DA = $dbd37edd557d3750$export$7d753ad993606f45.createDefaultAppearanceStream(a), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(a) && "function" == typeof a.getKeyValueListForStream && (o = a.getKeyValueListForStream()), a.Rect = s, a.hasAppearanceStream && !a.appearanceStreamContent) {
                        var u = $dbd37edd557d3750$var$et(a);
                        o.push({
                            key: "AP",
                            value: "<</N " + u + ">>"
                        }), r.internal.acroformPlugin.xForms.push(u);
                    }
                    if (a.appearanceStreamContent) {
                        var c = "";
                        for(var l in a.appearanceStreamContent)if (a.appearanceStreamContent.hasOwnProperty(l)) {
                            var h = a.appearanceStreamContent[l];
                            if (c += "/" + l + " ", c += "<<", Object.keys(h).length >= 1 || Array.isArray(h)) {
                                for(var i in h)if (h.hasOwnProperty(i)) {
                                    var f = h[i];
                                    "function" == typeof f && (f = f.call(r, a)), c += "/" + i + " " + f + " ", r.internal.acroformPlugin.xForms.indexOf(f) >= 0 || r.internal.acroformPlugin.xForms.push(f);
                                }
                            } else "function" == typeof (f = h) && (f = f.call(r, a)), c += "/" + i + " " + f, r.internal.acroformPlugin.xForms.indexOf(f) >= 0 || r.internal.acroformPlugin.xForms.push(f);
                            c += ">>";
                        }
                        o.push({
                            key: "AP",
                            value: "<<\n" + c + ">>"
                        });
                    }
                    r.internal.putStream({
                        additionalKeyValues: o,
                        objectId: a.objId
                    }), r.internal.out("endobj");
                }
                n && function(e, r) {
                    for(var n in e)if (e.hasOwnProperty(n)) {
                        var i = n, a = e[n];
                        r.internal.newObjectDeferredBegin(a.objId, !0), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(a) && "function" == typeof a.putStream && a.putStream(), delete e[i];
                    }
                }(r.internal.acroformPlugin.xForms, r);
            }(r, e);
        }), e.internal.acroformPlugin.isInitialized = !0;
    }
}, $dbd37edd557d3750$var$st = $dbd37edd557d3750$var$R.__acroform__.arrayToPdfArray = function(e, r, n) {
    var i = function(t) {
        return t;
    };
    if (Array.isArray(e)) {
        for(var a = "[", o = 0; o < e.length; o++)switch(0 !== o && (a += " "), (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(e[o])){
            case "boolean":
            case "number":
            case "object":
                a += e[o].toString();
                break;
            case "string":
                "/" === e[o].substr(0, 1) ? a += "/" + $dbd37edd557d3750$var$U(e[o].substr(1)) : (void 0 !== r && n && (i = n.internal.getEncryptor(r)), a += "(" + $dbd37edd557d3750$var$T(i(e[o].toString())) + ")");
        }
        return a + "]";
    }
    throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
}, $dbd37edd557d3750$var$ut = function(t, e, r) {
    var n = function(t) {
        return t;
    };
    return void 0 !== e && r && (n = r.internal.getEncryptor(e)), (t = t || "").toString(), "(" + $dbd37edd557d3750$var$T(n(t)) + ")";
}, $dbd37edd557d3750$var$ct = function() {
    this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", {
        get: function() {
            if (void 0 === this._objId) {
                if (void 0 === this.scope) return;
                this._objId = this.scope.internal.newObjectDeferred();
            }
            return this._objId;
        },
        set: function(t) {
            this._objId = t;
        }
    }), Object.defineProperty(this, "scope", {
        value: this._scope,
        writable: !0
    });
};
$dbd37edd557d3750$var$ct.prototype.toString = function() {
    return this.objId + " 0 R";
}, $dbd37edd557d3750$var$ct.prototype.putStream = function() {
    var t = this.getKeyValueListForStream();
    this.scope.internal.putStream({
        data: this.stream,
        additionalKeyValues: t,
        objectId: this.objId
    }), this.scope.internal.out("endobj");
}, $dbd37edd557d3750$var$ct.prototype.getKeyValueListForStream = function() {
    var t = [], e = Object.getOwnPropertyNames(this).filter(function(t) {
        return "content" != t && "appearanceStreamContent" != t && "scope" != t && "objId" != t && "_" != t.substring(0, 1);
    });
    for(var r in e)if (!1 === Object.getOwnPropertyDescriptor(this, e[r]).configurable) {
        var n = e[r], i = this[n];
        i && (Array.isArray(i) ? t.push({
            key: n,
            value: $dbd37edd557d3750$var$st(i, this.objId, this.scope)
        }) : i instanceof $dbd37edd557d3750$var$ct ? (i.scope = this.scope, t.push({
            key: n,
            value: i.objId + " 0 R"
        })) : "function" != typeof i && t.push({
            key: n,
            value: i
        }));
    }
    return t;
};
var $dbd37edd557d3750$var$lt = function() {
    $dbd37edd557d3750$var$ct.call(this), Object.defineProperty(this, "Type", {
        value: "/XObject",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "Subtype", {
        value: "/Form",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "FormType", {
        value: 1,
        configurable: !1,
        writable: !0
    });
    var t, e = [];
    Object.defineProperty(this, "BBox", {
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "Resources", {
        value: "2 0 R",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "stream", {
        enumerable: !1,
        configurable: !0,
        set: function(e) {
            t = e.trim();
        },
        get: function() {
            return t || null;
        }
    });
};
$dbd37edd557d3750$var$V($dbd37edd557d3750$var$lt, $dbd37edd557d3750$var$ct);
var $dbd37edd557d3750$var$ht = function() {
    $dbd37edd557d3750$var$ct.call(this);
    var t, e = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !1,
        configurable: !0,
        get: function() {
            return e.length > 0 ? e : void 0;
        }
    }), Object.defineProperty(this, "Fields", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        }
    }), Object.defineProperty(this, "DA", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (t) {
                var e = function(t) {
                    return t;
                };
                return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + $dbd37edd557d3750$var$T(e(t)) + ")";
            }
        },
        set: function(e) {
            t = e;
        }
    });
};
$dbd37edd557d3750$var$V($dbd37edd557d3750$var$ht, $dbd37edd557d3750$var$ct);
var $dbd37edd557d3750$var$ft = function t() {
    $dbd37edd557d3750$var$ct.call(this);
    var e = 4;
    Object.defineProperty(this, "F", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute F supplied.');
            e = t;
        }
    }), Object.defineProperty(this, "showWhenPrinted", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(e, 3));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.F = $dbd37edd557d3750$var$$(e, 3) : this.F = $dbd37edd557d3750$var$Q(e, 3);
        }
    });
    var r = 0;
    Object.defineProperty(this, "Ff", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return r;
        },
        set: function(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute Ff supplied.');
            r = t;
        }
    });
    var n = [];
    Object.defineProperty(this, "Rect", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (0 !== n.length) return n;
        },
        set: function(t) {
            n = void 0 !== t ? t : [];
        }
    }), Object.defineProperty(this, "x", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[0]) ? 0 : n[0];
        },
        set: function(t) {
            n[0] = t;
        }
    }), Object.defineProperty(this, "y", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[1]) ? 0 : n[1];
        },
        set: function(t) {
            n[1] = t;
        }
    }), Object.defineProperty(this, "width", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[2]) ? 0 : n[2];
        },
        set: function(t) {
            n[2] = t;
        }
    }), Object.defineProperty(this, "height", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[3]) ? 0 : n[3];
        },
        set: function(t) {
            n[3] = t;
        }
    });
    var i = "";
    Object.defineProperty(this, "FT", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return i;
        },
        set: function(t) {
            switch(t){
                case "/Btn":
                case "/Tx":
                case "/Ch":
                case "/Sig":
                    i = t;
                    break;
                default:
                    throw new Error('Invalid value "' + t + '" for attribute FT supplied.');
            }
        }
    });
    var a = null;
    Object.defineProperty(this, "T", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (!a || a.length < 1) {
                if (this instanceof $dbd37edd557d3750$var$wt) return;
                a = "FieldObject" + t.FieldNum++;
            }
            var e = function(t) {
                return t;
            };
            return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + $dbd37edd557d3750$var$T(e(a)) + ")";
        },
        set: function(t) {
            a = t.toString();
        }
    }), Object.defineProperty(this, "fieldName", {
        configurable: !0,
        enumerable: !0,
        get: function() {
            return a;
        },
        set: function(t) {
            a = t;
        }
    });
    var o = "helvetica";
    Object.defineProperty(this, "fontName", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return o;
        },
        set: function(t) {
            o = t;
        }
    });
    var s = "normal";
    Object.defineProperty(this, "fontStyle", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return s;
        },
        set: function(t) {
            s = t;
        }
    });
    var u = 0;
    Object.defineProperty(this, "fontSize", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return u;
        },
        set: function(t) {
            u = t;
        }
    });
    var c = void 0;
    Object.defineProperty(this, "maxFontSize", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return void 0 === c ? 50 / $dbd37edd557d3750$var$D : c;
        },
        set: function(t) {
            c = t;
        }
    });
    var l = "black";
    Object.defineProperty(this, "color", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return l;
        },
        set: function(t) {
            l = t;
        }
    });
    var h = "/F1 0 Tf 0 g";
    Object.defineProperty(this, "DA", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (!(!h || this instanceof $dbd37edd557d3750$var$wt || this instanceof $dbd37edd557d3750$export$9d1b52e7fab50c84)) return $dbd37edd557d3750$var$ut(h, this.objId, this.scope);
        },
        set: function(t) {
            t = t.toString(), h = t;
        }
    });
    var f = null;
    Object.defineProperty(this, "DV", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (f) return this instanceof $dbd37edd557d3750$export$6aae594af76bbb7b == 0 ? $dbd37edd557d3750$var$ut(f, this.objId, this.scope) : f;
        },
        set: function(t) {
            t = t.toString(), f = this instanceof $dbd37edd557d3750$export$6aae594af76bbb7b == 0 ? "(" === t.substr(0, 1) ? $dbd37edd557d3750$var$z(t.substr(1, t.length - 2)) : $dbd37edd557d3750$var$z(t) : t;
        }
    }), Object.defineProperty(this, "defaultValue", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this instanceof $dbd37edd557d3750$export$6aae594af76bbb7b == 1 ? $dbd37edd557d3750$var$z(f.substr(1, f.length - 1)) : f;
        },
        set: function(t) {
            t = t.toString(), f = this instanceof $dbd37edd557d3750$export$6aae594af76bbb7b == 1 ? "/" + $dbd37edd557d3750$var$U(t) : t;
        }
    });
    var d = null;
    Object.defineProperty(this, "_V", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (d) return d;
        },
        set: function(t) {
            this.V = t;
        }
    }), Object.defineProperty(this, "V", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (d) return this instanceof $dbd37edd557d3750$export$6aae594af76bbb7b == 0 ? $dbd37edd557d3750$var$ut(d, this.objId, this.scope) : d;
        },
        set: function(t) {
            t = t.toString(), d = this instanceof $dbd37edd557d3750$export$6aae594af76bbb7b == 0 ? "(" === t.substr(0, 1) ? $dbd37edd557d3750$var$z(t.substr(1, t.length - 2)) : $dbd37edd557d3750$var$z(t) : t;
        }
    }), Object.defineProperty(this, "value", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this instanceof $dbd37edd557d3750$export$6aae594af76bbb7b == 1 ? $dbd37edd557d3750$var$z(d.substr(1, d.length - 1)) : d;
        },
        set: function(t) {
            t = t.toString(), d = this instanceof $dbd37edd557d3750$export$6aae594af76bbb7b == 1 ? "/" + $dbd37edd557d3750$var$U(t) : t;
        }
    }), Object.defineProperty(this, "hasAnnotation", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this.Rect;
        }
    }), Object.defineProperty(this, "Type", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return this.hasAnnotation ? "/Annot" : null;
        }
    }), Object.defineProperty(this, "Subtype", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return this.hasAnnotation ? "/Widget" : null;
        }
    });
    var p, g = !1;
    Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return g;
        },
        set: function(t) {
            t = Boolean(t), g = t;
        }
    }), Object.defineProperty(this, "page", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            if (p) return p;
        },
        set: function(t) {
            p = t;
        }
    }), Object.defineProperty(this, "readOnly", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 1));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 1) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 1);
        }
    }), Object.defineProperty(this, "required", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 2));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 2) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 2);
        }
    }), Object.defineProperty(this, "noExport", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 3));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 3) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 3);
        }
    });
    var m = null;
    Object.defineProperty(this, "Q", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (null !== m) return m;
        },
        set: function(t) {
            if (-1 === [
                0,
                1,
                2
            ].indexOf(t)) throw new Error('Invalid value "' + t + '" for attribute Q supplied.');
            m = t;
        }
    }), Object.defineProperty(this, "textAlign", {
        get: function() {
            var t;
            switch(m){
                case 0:
                default:
                    t = "left";
                    break;
                case 1:
                    t = "center";
                    break;
                case 2:
                    t = "right";
            }
            return t;
        },
        configurable: !0,
        enumerable: !0,
        set: function(t) {
            switch(t){
                case "right":
                case 2:
                    m = 2;
                    break;
                case "center":
                case 1:
                    m = 1;
                    break;
                default:
                    m = 0;
            }
        }
    });
};
$dbd37edd557d3750$var$V($dbd37edd557d3750$var$ft, $dbd37edd557d3750$var$ct);
var $dbd37edd557d3750$export$a47202eb3f827bb2 = function() {
    $dbd37edd557d3750$var$ft.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
    var t = 0;
    Object.defineProperty(this, "TI", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "topIndex", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    });
    var e = [];
    Object.defineProperty(this, "Opt", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return $dbd37edd557d3750$var$st(e, this.objId, this.scope);
        },
        set: function(t) {
            var r, n;
            n = [], "string" == typeof (r = t) && (n = function(t, e, r) {
                r || (r = 1);
                for(var n, i = []; n = e.exec(t);)i.push(n[r]);
                return i;
            }(r, /\((.*?)\)/g)), e = n;
        }
    }), this.getOptions = function() {
        return e;
    }, this.setOptions = function(t) {
        e = t, this.sort && e.sort();
    }, this.addOption = function(t) {
        t = (t = t || "").toString(), e.push(t), this.sort && e.sort();
    }, this.removeOption = function(t, r) {
        for(r = r || !1, t = (t = t || "").toString(); -1 !== e.indexOf(t) && (e.splice(e.indexOf(t), 1), !1 !== r););
    }, Object.defineProperty(this, "combo", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 18));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 18) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 18);
        }
    }), Object.defineProperty(this, "edit", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 19));
        },
        set: function(t) {
            !0 === this.combo && (!0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 19) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 19));
        }
    }), Object.defineProperty(this, "sort", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 20));
        },
        set: function(t) {
            !0 === Boolean(t) ? (this.Ff = $dbd37edd557d3750$var$$(this.Ff, 20), e.sort()) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 20);
        }
    }), Object.defineProperty(this, "multiSelect", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 22));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 22) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 22);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 23));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 23) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 23);
        }
    }), Object.defineProperty(this, "commitOnSelChange", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 27));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 27) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 27);
        }
    }), this.hasAppearanceStream = !1;
};
$dbd37edd557d3750$var$V($dbd37edd557d3750$export$a47202eb3f827bb2, $dbd37edd557d3750$var$ft);
var $dbd37edd557d3750$export$9e021dd9568dc486 = function() {
    $dbd37edd557d3750$export$a47202eb3f827bb2.call(this), this.fontName = "helvetica", this.combo = !1;
};
$dbd37edd557d3750$var$V($dbd37edd557d3750$export$9e021dd9568dc486, $dbd37edd557d3750$export$a47202eb3f827bb2);
var $dbd37edd557d3750$export$f2239d28df5f43bd = function() {
    $dbd37edd557d3750$export$9e021dd9568dc486.call(this), this.combo = !0;
};
$dbd37edd557d3750$var$V($dbd37edd557d3750$export$f2239d28df5f43bd, $dbd37edd557d3750$export$9e021dd9568dc486);
var $dbd37edd557d3750$export$4af052e7e598ad1a = function() {
    $dbd37edd557d3750$export$f2239d28df5f43bd.call(this), this.edit = !0;
};
$dbd37edd557d3750$var$V($dbd37edd557d3750$export$4af052e7e598ad1a, $dbd37edd557d3750$export$f2239d28df5f43bd);
var $dbd37edd557d3750$export$6aae594af76bbb7b = function() {
    $dbd37edd557d3750$var$ft.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 15));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 15) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 15);
        }
    }), Object.defineProperty(this, "radio", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 16));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 16) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 16);
        }
    }), Object.defineProperty(this, "pushButton", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 17));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 17) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 17);
        }
    }), Object.defineProperty(this, "radioIsUnison", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 26));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 26) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 26);
        }
    });
    var e, r = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            var t = function(t) {
                return t;
            };
            if (this.scope && (t = this.scope.internal.getEncryptor(this.objId)), 0 !== Object.keys(r).length) {
                var e, n = [];
                for(e in n.push("<<"), r)n.push("/" + e + " (" + $dbd37edd557d3750$var$T(t(r[e])) + ")");
                return n.push(">>"), n.join("\n");
            }
        },
        set: function(e) {
            "object" === (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(e) && (r = e);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return r.CA || "";
        },
        set: function(t) {
            "string" == typeof t && (r.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            var r = null == t ? "" : t.toString();
            "/" === r.substr(0, 1) && (r = r.substr(1)), e = "/" + $dbd37edd557d3750$var$U(r);
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return e.substr(1, e.length - 1);
        },
        set: function(t) {
            e = "/" + $dbd37edd557d3750$var$U(t);
        }
    });
};
$dbd37edd557d3750$var$V($dbd37edd557d3750$export$6aae594af76bbb7b, $dbd37edd557d3750$var$ft);
var $dbd37edd557d3750$export$98b7c3ef37465410 = function() {
    $dbd37edd557d3750$export$6aae594af76bbb7b.call(this), this.pushButton = !0;
};
$dbd37edd557d3750$var$V($dbd37edd557d3750$export$98b7c3ef37465410, $dbd37edd557d3750$export$6aae594af76bbb7b);
var $dbd37edd557d3750$export$bc1318bc7e5f1315 = function() {
    $dbd37edd557d3750$export$6aae594af76bbb7b.call(this), this.radio = !0, this.pushButton = !1;
    var t = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = void 0 !== e ? e : [];
        }
    });
};
$dbd37edd557d3750$var$V($dbd37edd557d3750$export$bc1318bc7e5f1315, $dbd37edd557d3750$export$6aae594af76bbb7b);
var $dbd37edd557d3750$var$wt = function() {
    var e, r;
    $dbd37edd557d3750$var$ft.call(this), Object.defineProperty(this, "Parent", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "optionName", {
        enumerable: !1,
        configurable: !0,
        get: function() {
            return r;
        },
        set: function(t) {
            r = t;
        }
    });
    var n, i = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            var t = function(t) {
                return t;
            };
            this.scope && (t = this.scope.internal.getEncryptor(this.objId));
            var e, r = [];
            for(e in r.push("<<"), i)r.push("/" + e + " (" + $dbd37edd557d3750$var$T(t(i[e])) + ")");
            return r.push(">>"), r.join("\n");
        },
        set: function(e) {
            "object" === (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(e) && (i = e);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return i.CA || "";
        },
        set: function(t) {
            "string" == typeof t && (i.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return n;
        },
        set: function(t) {
            var e = null == t ? "" : t.toString();
            "/" === e.substr(0, 1) && (e = e.substr(1)), n = "/" + $dbd37edd557d3750$var$U(e);
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return n.substr(1, n.length - 1);
        },
        set: function(t) {
            var e = null == t ? "" : t.toString();
            "/" === e.substr(0, 1) && (e = e.substr(1)), n = "/" + $dbd37edd557d3750$var$U(e);
        }
    }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = $dbd37edd557d3750$export$7d753ad993606f45.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
$dbd37edd557d3750$var$V($dbd37edd557d3750$var$wt, $dbd37edd557d3750$var$ft), $dbd37edd557d3750$export$bc1318bc7e5f1315.prototype.setAppearance = function(t) {
    if (!("createAppearanceStream" in t) || !("getCA" in t)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
    for(var e in this.Kids)if (this.Kids.hasOwnProperty(e)) {
        var r = this.Kids[e];
        r.appearanceStreamContent = t.createAppearanceStream(r.optionName), r.caption = t.getCA();
    }
}, $dbd37edd557d3750$export$bc1318bc7e5f1315.prototype.createOption = function(t) {
    var e = new $dbd37edd557d3750$var$wt;
    return e.Parent = this, e.optionName = t, this.Kids.push(e), $dbd37edd557d3750$var$St.call(this.scope, e), e;
};
var $dbd37edd557d3750$export$5fd5db01c4615478 = function() {
    $dbd37edd557d3750$export$6aae594af76bbb7b.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = $dbd37edd557d3750$export$7d753ad993606f45.CheckBox.createAppearanceStream();
};
$dbd37edd557d3750$var$V($dbd37edd557d3750$export$5fd5db01c4615478, $dbd37edd557d3750$export$6aae594af76bbb7b);
var $dbd37edd557d3750$export$9d1b52e7fab50c84 = function() {
    $dbd37edd557d3750$var$ft.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 13));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 13) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 13);
        }
    }), Object.defineProperty(this, "fileSelect", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 21));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 21) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 21);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 23));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 23) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 23);
        }
    }), Object.defineProperty(this, "doNotScroll", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 24));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 24) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 24);
        }
    }), Object.defineProperty(this, "comb", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 25));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 25) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 25);
        }
    }), Object.defineProperty(this, "richText", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 26));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 26) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 26);
        }
    });
    var t = null;
    Object.defineProperty(this, "MaxLen", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "maxLength", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t;
        },
        set: function(e) {
            Number.isInteger(e) && (t = e);
        }
    }), Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this.V || this.DV;
        }
    });
};
$dbd37edd557d3750$var$V($dbd37edd557d3750$export$9d1b52e7fab50c84, $dbd37edd557d3750$var$ft);
var $dbd37edd557d3750$export$c48d8668f8cea64d = function() {
    $dbd37edd557d3750$export$9d1b52e7fab50c84.call(this), Object.defineProperty(this, "password", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($dbd37edd557d3750$var$Z(this.Ff, 14));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $dbd37edd557d3750$var$$(this.Ff, 14) : this.Ff = $dbd37edd557d3750$var$Q(this.Ff, 14);
        }
    }), this.password = !0;
};
$dbd37edd557d3750$var$V($dbd37edd557d3750$export$c48d8668f8cea64d, $dbd37edd557d3750$export$9d1b52e7fab50c84);
var $dbd37edd557d3750$export$7d753ad993606f45 = {
    CheckBox: {
        createAppearanceStream: function() {
            return {
                N: {
                    On: $dbd37edd557d3750$export$7d753ad993606f45.CheckBox.YesNormal
                },
                D: {
                    On: $dbd37edd557d3750$export$7d753ad993606f45.CheckBox.YesPushDown,
                    Off: $dbd37edd557d3750$export$7d753ad993606f45.CheckBox.OffPushDown
                }
            };
        },
        YesPushDown: function(t) {
            var e = $dbd37edd557d3750$var$Y(t);
            e.scope = t.scope;
            var r = [], n = t.scope.internal.getFont(t.fontName, t.fontStyle).id, i = t.scope.__private__.encodeColorString(t.color), a = $dbd37edd557d3750$var$rt(t, t.caption);
            return r.push("0.749023 g"), r.push("0 0 " + $dbd37edd557d3750$var$H($dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t)) + " " + $dbd37edd557d3750$var$H($dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t)) + " re"), r.push("f"), r.push("BMC"), r.push("q"), r.push("0 0 1 rg"), r.push("/" + n + " " + $dbd37edd557d3750$var$H(a.fontSize) + " Tf " + i), r.push("BT"), r.push(a.text), r.push("ET"), r.push("Q"), r.push("EMC"), e.stream = r.join("\n"), e;
        },
        YesNormal: function(t) {
            var e = $dbd37edd557d3750$var$Y(t);
            e.scope = t.scope;
            var r = t.scope.internal.getFont(t.fontName, t.fontStyle).id, n = t.scope.__private__.encodeColorString(t.color), i = [], a = $dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t), o = $dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t), s = $dbd37edd557d3750$var$rt(t, t.caption);
            return i.push("1 g"), i.push("0 0 " + $dbd37edd557d3750$var$H(o) + " " + $dbd37edd557d3750$var$H(a) + " re"), i.push("f"), i.push("q"), i.push("0 0 1 rg"), i.push("0 0 " + $dbd37edd557d3750$var$H(o - 1) + " " + $dbd37edd557d3750$var$H(a - 1) + " re"), i.push("W"), i.push("n"), i.push("0 g"), i.push("BT"), i.push("/" + r + " " + $dbd37edd557d3750$var$H(s.fontSize) + " Tf " + n), i.push(s.text), i.push("ET"), i.push("Q"), e.stream = i.join("\n"), e;
        },
        OffPushDown: function(t) {
            var e = $dbd37edd557d3750$var$Y(t);
            e.scope = t.scope;
            var r = [];
            return r.push("0.749023 g"), r.push("0 0 " + $dbd37edd557d3750$var$H($dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t)) + " " + $dbd37edd557d3750$var$H($dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t)) + " re"), r.push("f"), e.stream = r.join("\n"), e;
        }
    },
    RadioButton: {
        Circle: {
            createAppearanceStream: function(t) {
                var e = {
                    D: {
                        Off: $dbd37edd557d3750$export$7d753ad993606f45.RadioButton.Circle.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = $dbd37edd557d3750$export$7d753ad993606f45.RadioButton.Circle.YesNormal, e.D[t] = $dbd37edd557d3750$export$7d753ad993606f45.RadioButton.Circle.YesPushDown, e;
            },
            getCA: function() {
                return "l";
            },
            YesNormal: function(t) {
                var e = $dbd37edd557d3750$var$Y(t);
                e.scope = t.scope;
                var r = [], n = $dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t) <= $dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t) ? $dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t) / 4 : $dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t) / 4;
                n = Number((.9 * n).toFixed(5));
                var i = $dbd37edd557d3750$export$7d753ad993606f45.internal.Bezier_C, a = Number((n * i).toFixed(5));
                return r.push("q"), r.push("1 0 0 1 " + $dbd37edd557d3750$var$W($dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $dbd37edd557d3750$var$W($dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(n + " 0 m"), r.push(n + " " + a + " " + a + " " + n + " 0 " + n + " c"), r.push("-" + a + " " + n + " -" + n + " " + a + " -" + n + " 0 c"), r.push("-" + n + " -" + a + " -" + a + " -" + n + " 0 -" + n + " c"), r.push(a + " -" + n + " " + n + " -" + a + " " + n + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            YesPushDown: function(t) {
                var e = $dbd37edd557d3750$var$Y(t);
                e.scope = t.scope;
                var r = [], n = $dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t) <= $dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t) ? $dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t) / 4 : $dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t) / 4;
                n = Number((.9 * n).toFixed(5));
                var i = Number((2 * n).toFixed(5)), a = Number((i * $dbd37edd557d3750$export$7d753ad993606f45.internal.Bezier_C).toFixed(5)), o = Number((n * $dbd37edd557d3750$export$7d753ad993606f45.internal.Bezier_C).toFixed(5));
                return r.push("0.749023 g"), r.push("q"), r.push("1 0 0 1 " + $dbd37edd557d3750$var$W($dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $dbd37edd557d3750$var$W($dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(i + " 0 m"), r.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), r.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), r.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), r.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), r.push("f"), r.push("Q"), r.push("0 g"), r.push("q"), r.push("1 0 0 1 " + $dbd37edd557d3750$var$W($dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $dbd37edd557d3750$var$W($dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(n + " 0 m"), r.push(n + " " + o + " " + o + " " + n + " 0 " + n + " c"), r.push("-" + o + " " + n + " -" + n + " " + o + " -" + n + " 0 c"), r.push("-" + n + " -" + o + " -" + o + " -" + n + " 0 -" + n + " c"), r.push(o + " -" + n + " " + n + " -" + o + " " + n + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            OffPushDown: function(t) {
                var e = $dbd37edd557d3750$var$Y(t);
                e.scope = t.scope;
                var r = [], n = $dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t) <= $dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t) ? $dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t) / 4 : $dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t) / 4;
                n = Number((.9 * n).toFixed(5));
                var i = Number((2 * n).toFixed(5)), a = Number((i * $dbd37edd557d3750$export$7d753ad993606f45.internal.Bezier_C).toFixed(5));
                return r.push("0.749023 g"), r.push("q"), r.push("1 0 0 1 " + $dbd37edd557d3750$var$W($dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $dbd37edd557d3750$var$W($dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(i + " 0 m"), r.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), r.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), r.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), r.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
            }
        },
        Cross: {
            createAppearanceStream: function(t) {
                var e = {
                    D: {
                        Off: $dbd37edd557d3750$export$7d753ad993606f45.RadioButton.Cross.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = $dbd37edd557d3750$export$7d753ad993606f45.RadioButton.Cross.YesNormal, e.D[t] = $dbd37edd557d3750$export$7d753ad993606f45.RadioButton.Cross.YesPushDown, e;
            },
            getCA: function() {
                return "8";
            },
            YesNormal: function(t) {
                var e = $dbd37edd557d3750$var$Y(t);
                e.scope = t.scope;
                var r = [], n = $dbd37edd557d3750$export$7d753ad993606f45.internal.calculateCross(t);
                return r.push("q"), r.push("1 1 " + $dbd37edd557d3750$var$H($dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t) - 2) + " " + $dbd37edd557d3750$var$H($dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t) - 2) + " re"), r.push("W"), r.push("n"), r.push($dbd37edd557d3750$var$H(n.x1.x) + " " + $dbd37edd557d3750$var$H(n.x1.y) + " m"), r.push($dbd37edd557d3750$var$H(n.x2.x) + " " + $dbd37edd557d3750$var$H(n.x2.y) + " l"), r.push($dbd37edd557d3750$var$H(n.x4.x) + " " + $dbd37edd557d3750$var$H(n.x4.y) + " m"), r.push($dbd37edd557d3750$var$H(n.x3.x) + " " + $dbd37edd557d3750$var$H(n.x3.y) + " l"), r.push("s"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            YesPushDown: function(t) {
                var e = $dbd37edd557d3750$var$Y(t);
                e.scope = t.scope;
                var r = $dbd37edd557d3750$export$7d753ad993606f45.internal.calculateCross(t), n = [];
                return n.push("0.749023 g"), n.push("0 0 " + $dbd37edd557d3750$var$H($dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t)) + " " + $dbd37edd557d3750$var$H($dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t)) + " re"), n.push("f"), n.push("q"), n.push("1 1 " + $dbd37edd557d3750$var$H($dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t) - 2) + " " + $dbd37edd557d3750$var$H($dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t) - 2) + " re"), n.push("W"), n.push("n"), n.push($dbd37edd557d3750$var$H(r.x1.x) + " " + $dbd37edd557d3750$var$H(r.x1.y) + " m"), n.push($dbd37edd557d3750$var$H(r.x2.x) + " " + $dbd37edd557d3750$var$H(r.x2.y) + " l"), n.push($dbd37edd557d3750$var$H(r.x4.x) + " " + $dbd37edd557d3750$var$H(r.x4.y) + " m"), n.push($dbd37edd557d3750$var$H(r.x3.x) + " " + $dbd37edd557d3750$var$H(r.x3.y) + " l"), n.push("s"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            OffPushDown: function(t) {
                var e = $dbd37edd557d3750$var$Y(t);
                e.scope = t.scope;
                var r = [];
                return r.push("0.749023 g"), r.push("0 0 " + $dbd37edd557d3750$var$H($dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t)) + " " + $dbd37edd557d3750$var$H($dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t)) + " re"), r.push("f"), e.stream = r.join("\n"), e;
            }
        }
    },
    createDefaultAppearanceStream: function(t) {
        var e = t.scope.internal.getFont(t.fontName, t.fontStyle).id, r = t.scope.__private__.encodeColorString(t.color);
        return "/" + e + " " + t.fontSize + " Tf " + r;
    }
};
$dbd37edd557d3750$export$7d753ad993606f45.internal = {
    Bezier_C: .551915024494,
    calculateCross: function(t) {
        var e = $dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth(t), r = $dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight(t), n = Math.min(e, r);
        return {
            x1: {
                x: (e - n) / 2,
                y: (r - n) / 2 + n
            },
            x2: {
                x: (e - n) / 2 + n,
                y: (r - n) / 2
            },
            x3: {
                x: (e - n) / 2,
                y: (r - n) / 2
            },
            x4: {
                x: (e - n) / 2 + n,
                y: (r - n) / 2 + n
            }
        };
    }
}, $dbd37edd557d3750$export$7d753ad993606f45.internal.getWidth = function(e) {
    var r = 0;
    return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(e) && (r = $dbd37edd557d3750$var$G(e.Rect[2])), r;
}, $dbd37edd557d3750$export$7d753ad993606f45.internal.getHeight = function(e) {
    var r = 0;
    return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(e) && (r = $dbd37edd557d3750$var$G(e.Rect[3])), r;
};
var $dbd37edd557d3750$var$St = $dbd37edd557d3750$var$R.addField = function(t) {
    if ($dbd37edd557d3750$var$ot(this, t), !(t instanceof $dbd37edd557d3750$var$ft)) throw new Error("Invalid argument passed to jsPDF.addField.");
    var e;
    return (e = t).scope.internal.acroformPlugin.printedOut && (e.scope.internal.acroformPlugin.printedOut = !1, e.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e), t.page = t.scope.internal.getCurrentPageInfo().pageNumber, this;
};
$dbd37edd557d3750$var$R.AcroFormChoiceField = $dbd37edd557d3750$export$a47202eb3f827bb2, $dbd37edd557d3750$var$R.AcroFormListBox = $dbd37edd557d3750$export$9e021dd9568dc486, $dbd37edd557d3750$var$R.AcroFormComboBox = $dbd37edd557d3750$export$f2239d28df5f43bd, $dbd37edd557d3750$var$R.AcroFormEditBox = $dbd37edd557d3750$export$4af052e7e598ad1a, $dbd37edd557d3750$var$R.AcroFormButton = $dbd37edd557d3750$export$6aae594af76bbb7b, $dbd37edd557d3750$var$R.AcroFormPushButton = $dbd37edd557d3750$export$98b7c3ef37465410, $dbd37edd557d3750$var$R.AcroFormRadioButton = $dbd37edd557d3750$export$bc1318bc7e5f1315, $dbd37edd557d3750$var$R.AcroFormCheckBox = $dbd37edd557d3750$export$5fd5db01c4615478, $dbd37edd557d3750$var$R.AcroFormTextField = $dbd37edd557d3750$export$9d1b52e7fab50c84, $dbd37edd557d3750$var$R.AcroFormPasswordField = $dbd37edd557d3750$export$c48d8668f8cea64d, $dbd37edd557d3750$var$R.AcroFormAppearance = $dbd37edd557d3750$export$7d753ad993606f45, $dbd37edd557d3750$var$R.AcroForm = {
    ChoiceField: $dbd37edd557d3750$export$a47202eb3f827bb2,
    ListBox: $dbd37edd557d3750$export$9e021dd9568dc486,
    ComboBox: $dbd37edd557d3750$export$f2239d28df5f43bd,
    EditBox: $dbd37edd557d3750$export$4af052e7e598ad1a,
    Button: $dbd37edd557d3750$export$6aae594af76bbb7b,
    PushButton: $dbd37edd557d3750$export$98b7c3ef37465410,
    RadioButton: $dbd37edd557d3750$export$bc1318bc7e5f1315,
    CheckBox: $dbd37edd557d3750$export$5fd5db01c4615478,
    TextField: $dbd37edd557d3750$export$9d1b52e7fab50c84,
    PasswordField: $dbd37edd557d3750$export$c48d8668f8cea64d,
    Appearance: $dbd37edd557d3750$export$7d753ad993606f45
}, $dbd37edd557d3750$export$2e2bcd8739ae039.AcroForm = {
    ChoiceField: $dbd37edd557d3750$export$a47202eb3f827bb2,
    ListBox: $dbd37edd557d3750$export$9e021dd9568dc486,
    ComboBox: $dbd37edd557d3750$export$f2239d28df5f43bd,
    EditBox: $dbd37edd557d3750$export$4af052e7e598ad1a,
    Button: $dbd37edd557d3750$export$6aae594af76bbb7b,
    PushButton: $dbd37edd557d3750$export$98b7c3ef37465410,
    RadioButton: $dbd37edd557d3750$export$bc1318bc7e5f1315,
    CheckBox: $dbd37edd557d3750$export$5fd5db01c4615478,
    TextField: $dbd37edd557d3750$export$9d1b52e7fab50c84,
    PasswordField: $dbd37edd557d3750$export$c48d8668f8cea64d,
    Appearance: $dbd37edd557d3750$export$7d753ad993606f45
};
var $dbd37edd557d3750$export$9cf40f67b77f45f4 = $dbd37edd557d3750$export$2e2bcd8739ae039.AcroForm;
function $dbd37edd557d3750$var$Pt(t) {
    return t.reduce(function(t, e, r) {
        return t[e] = r, t;
    }, {});
}
!function(e) {
    var r = "addImage_";
    e.__addimage__ = {};
    var n = "UNKNOWN", i = {
        PNG: [
            [
                137,
                80,
                78,
                71
            ]
        ],
        TIFF: [
            [
                77,
                77,
                0,
                42
            ],
            [
                73,
                73,
                42,
                0
            ]
        ],
        JPEG: [
            [
                255,
                216,
                255,
                224,
                void 0,
                void 0,
                74,
                70,
                73,
                70,
                0
            ],
            [
                255,
                216,
                255,
                225,
                void 0,
                void 0,
                69,
                120,
                105,
                102,
                0,
                0
            ],
            [
                255,
                216,
                255,
                219
            ],
            [
                255,
                216,
                255,
                238
            ]
        ],
        JPEG2000: [
            [
                0,
                0,
                0,
                12,
                106,
                80,
                32,
                32
            ]
        ],
        GIF87a: [
            [
                71,
                73,
                70,
                56,
                55,
                97
            ]
        ],
        GIF89a: [
            [
                71,
                73,
                70,
                56,
                57,
                97
            ]
        ],
        WEBP: [
            [
                82,
                73,
                70,
                70,
                void 0,
                void 0,
                void 0,
                void 0,
                87,
                69,
                66,
                80
            ]
        ],
        BMP: [
            [
                66,
                77
            ],
            [
                66,
                65
            ],
            [
                67,
                73
            ],
            [
                67,
                80
            ],
            [
                73,
                67
            ],
            [
                80,
                84
            ]
        ]
    }, a = e.__addimage__.getImageFileTypeByImageData = function(t, e) {
        var r, a, o, s, u, c = n;
        if ("RGBA" === (e = e || n) || void 0 !== t.data && t.data instanceof Uint8ClampedArray && "height" in t && "width" in t) return "RGBA";
        if (A(t)) for(u in i)for(o = i[u], r = 0; r < o.length; r += 1){
            for(s = !0, a = 0; a < o[r].length; a += 1)if (void 0 !== o[r][a] && o[r][a] !== t[a]) {
                s = !1;
                break;
            }
            if (!0 === s) {
                c = u;
                break;
            }
        }
        else for(u in i)for(o = i[u], r = 0; r < o.length; r += 1){
            for(s = !0, a = 0; a < o[r].length; a += 1)if (void 0 !== o[r][a] && o[r][a] !== t.charCodeAt(a)) {
                s = !1;
                break;
            }
            if (!0 === s) {
                c = u;
                break;
            }
        }
        return c === n && e !== n && (c = e), c;
    }, o = function t(e) {
        for(var r = this.internal.write, n = this.internal.putStream, i = (0, this.internal.getFilters)(); -1 !== i.indexOf("FlateEncode");)i.splice(i.indexOf("FlateEncode"), 1);
        e.objectId = this.internal.newObject();
        var a = [];
        if (a.push({
            key: "Type",
            value: "/XObject"
        }), a.push({
            key: "Subtype",
            value: "/Image"
        }), a.push({
            key: "Width",
            value: e.width
        }), a.push({
            key: "Height",
            value: e.height
        }), e.colorSpace === y.INDEXED ? a.push({
            key: "ColorSpace",
            value: "[/Indexed /DeviceRGB " + (e.palette.length / 3 - 1) + " " + ("sMask" in e && void 0 !== e.sMask ? e.objectId + 2 : e.objectId + 1) + " 0 R]"
        }) : (a.push({
            key: "ColorSpace",
            value: "/" + e.colorSpace
        }), e.colorSpace === y.DEVICE_CMYK && a.push({
            key: "Decode",
            value: "[1 0 1 0 1 0 1 0]"
        })), a.push({
            key: "BitsPerComponent",
            value: e.bitsPerComponent
        }), "decodeParameters" in e && void 0 !== e.decodeParameters && a.push({
            key: "DecodeParms",
            value: "<<" + e.decodeParameters + ">>"
        }), "transparency" in e && Array.isArray(e.transparency) && e.transparency.length > 0) {
            for(var o = "", s = 0, u = e.transparency.length; s < u; s++)o += e.transparency[s] + " " + e.transparency[s] + " ";
            a.push({
                key: "Mask",
                value: "[" + o + "]"
            });
        }
        void 0 !== e.sMask && a.push({
            key: "SMask",
            value: e.objectId + 1 + " 0 R"
        });
        var c = void 0 !== e.filter ? [
            "/" + e.filter
        ] : void 0;
        if (n({
            data: e.data,
            additionalKeyValues: a,
            alreadyAppliedFilters: c,
            objectId: e.objectId
        }), r("endobj"), "sMask" in e && void 0 !== e.sMask) {
            var l, h = null !== (l = e.sMaskBitsPerComponent) && void 0 !== l ? l : e.bitsPerComponent, f = {
                width: e.width,
                height: e.height,
                colorSpace: "DeviceGray",
                bitsPerComponent: h,
                data: e.sMask
            };
            "filter" in e && (f.decodeParameters = "/Predictor ".concat(e.predictor, " /Colors 1 /BitsPerComponent ").concat(h, " /Columns ").concat(e.width), f.filter = e.filter), t.call(this, f);
        }
        if (e.colorSpace === y.INDEXED) {
            var d = this.internal.newObject();
            n({
                data: _(new Uint8Array(e.palette)),
                objectId: d
            }), r("endobj");
        }
    }, s = function() {
        var t = this.internal.collections[r + "images"];
        for(var e in t)o.call(this, t[e]);
    }, u = function() {
        var t, e = this.internal.collections[r + "images"], n = this.internal.write;
        for(var i in e)n("/I" + (t = e[i]).index, t.objectId, "0", "R");
    }, c = function() {
        this.internal.collections[r + "images"] || (this.internal.collections[r + "images"] = {}, this.internal.events.subscribe("putResources", s), this.internal.events.subscribe("putXobjectDict", u));
    }, l = function() {
        var t = this.internal.collections[r + "images"];
        return c.call(this), t;
    }, h = function() {
        return Object.keys(this.internal.collections[r + "images"]).length;
    }, d = function(t) {
        return "function" == typeof e["process" + t.toUpperCase()];
    }, p = function(e) {
        return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(e) && 1 === e.nodeType;
    }, g = function(t, r) {
        if ("IMG" === t.nodeName && t.hasAttribute("src")) {
            var n = "" + t.getAttribute("src");
            if (0 === n.indexOf("data:image/")) return $dbd37edd557d3750$var$f(unescape(n).split("base64,").pop());
            var i = e.loadFile(n, !0);
            if (void 0 !== i) return i;
        }
        if ("CANVAS" === t.nodeName) {
            if (0 === t.width || 0 === t.height) throw new Error("Given canvas must have data. Canvas width: " + t.width + ", height: " + t.height);
            var a;
            switch(r){
                case "PNG":
                    a = "image/png";
                    break;
                case "WEBP":
                    a = "image/webp";
                    break;
                default:
                    a = "image/jpeg";
            }
            return $dbd37edd557d3750$var$f(t.toDataURL(a, 1).split("base64,").pop());
        }
    }, m = function(t) {
        var e = this.internal.collections[r + "images"];
        if (e) {
            for(var n in e)if (t === e[n].alias) return e[n];
        }
    }, v = function(t, e, r) {
        return t || e || (t = -96, e = -96), t < 0 && (t = -1 * r.width * 72 / t / this.internal.scaleFactor), e < 0 && (e = -1 * r.height * 72 / e / this.internal.scaleFactor), 0 === t && (t = e * r.width / r.height), 0 === e && (e = t * r.height / r.width), [
            t,
            e
        ];
    }, b = function(t, e, r, n, i, a) {
        var o = v.call(this, r, n, i), s = this.internal.getCoordinateString, u = this.internal.getVerticalCoordinateString, c = l.call(this);
        if (r = o[0], n = o[1], c[i.index] = i, a) {
            a *= Math.PI / 180;
            var h = Math.cos(a), f = Math.sin(a), d = function(t) {
                return t.toFixed(4);
            }, p = [
                d(h),
                d(f),
                d(-1 * f),
                d(h),
                0,
                0,
                "cm"
            ];
        }
        this.internal.write("q"), a ? (this.internal.write([
            1,
            "0",
            "0",
            1,
            s(t),
            u(e + n),
            "cm"
        ].join(" ")), this.internal.write(p.join(" ")), this.internal.write([
            s(r),
            "0",
            "0",
            s(n),
            "0",
            "0",
            "cm"
        ].join(" "))) : this.internal.write([
            s(r),
            "0",
            "0",
            s(n),
            s(t),
            u(e + n),
            "cm"
        ].join(" ")), this.isAdvancedAPI() && this.internal.write([
            1,
            0,
            0,
            -1,
            0,
            0,
            "cm"
        ].join(" ")), this.internal.write("/I" + i.index + " Do"), this.internal.write("Q");
    }, y = e.color_spaces = {
        DEVICE_RGB: "DeviceRGB",
        DEVICE_GRAY: "DeviceGray",
        DEVICE_CMYK: "DeviceCMYK",
        CAL_GREY: "CalGray",
        CAL_RGB: "CalRGB",
        LAB: "Lab",
        ICC_BASED: "ICCBased",
        INDEXED: "Indexed",
        PATTERN: "Pattern",
        SEPARATION: "Separation",
        DEVICE_N: "DeviceN"
    };
    e.decode = {
        DCT_DECODE: "DCTDecode",
        FLATE_DECODE: "FlateDecode",
        LZW_DECODE: "LZWDecode",
        JPX_DECODE: "JPXDecode",
        JBIG2_DECODE: "JBIG2Decode",
        ASCII85_DECODE: "ASCII85Decode",
        ASCII_HEX_DECODE: "ASCIIHexDecode",
        RUN_LENGTH_DECODE: "RunLengthDecode",
        CCITT_FAX_DECODE: "CCITTFaxDecode"
    };
    var w = e.image_compression = {
        NONE: "NONE",
        FAST: "FAST",
        MEDIUM: "MEDIUM",
        SLOW: "SLOW"
    }, N = e.__addimage__.sHashCode = function(t) {
        var e, r, n = 0;
        if ("string" == typeof t) for(r = t.length, e = 0; e < r; e++)n = (n << 5) - n + t.charCodeAt(e), n |= 0;
        else if (A(t)) for(r = t.byteLength / 2, e = 0; e < r; e++)n = (n << 5) - n + t[e], n |= 0;
        return n;
    }, L = e.__addimage__.validateStringAsBase64 = function(t) {
        (t = t || "").toString().trim();
        var e = !0;
        return 0 === t.length && (e = !1), t.length % 4 != 0 && (e = !1), !1 === /^[A-Za-z0-9+/]+$/.test(t.substr(0, t.length - 2)) && (e = !1), !1 === /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2)) && (e = !1), e;
    }, x = e.__addimage__.extractImageFromDataUrl = function(t) {
        if (null == t) return null;
        if (!(t = t.trim()).startsWith("data:")) return null;
        var e = t.indexOf(",");
        return e < 0 ? null : t.substring(0, e).trim().endsWith("base64") ? t.substring(e + 1) : null;
    };
    e.__addimage__.isArrayBuffer = function(t) {
        return t instanceof ArrayBuffer;
    };
    var A = e.__addimage__.isArrayBufferView = function(t) {
        return t instanceof Int8Array || t instanceof Uint8Array || t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array;
    }, S = e.__addimage__.binaryStringToUint8Array = function(t) {
        for(var e = t.length, r = new Uint8Array(e), n = 0; n < e; n++)r[n] = t.charCodeAt(n);
        return r;
    }, _ = e.__addimage__.arrayBufferToBinaryString = function(t) {
        for(var e = "", r = A(t) ? t : new Uint8Array(t), n = 0; n < r.length; n += 8192)e += String.fromCharCode.apply(null, r.subarray(n, n + 8192));
        return e;
    };
    e.addImage = function() {
        var e, r, i, a, o, s, u, l, h;
        if ("number" == typeof arguments[1] ? (r = n, i = arguments[1], a = arguments[2], o = arguments[3], s = arguments[4], u = arguments[5], l = arguments[6], h = arguments[7]) : (r = arguments[1], i = arguments[2], a = arguments[3], o = arguments[4], s = arguments[5], u = arguments[6], l = arguments[7], h = arguments[8]), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(e = arguments[0]) && !p(e) && "imageData" in e) {
            var f = e;
            e = f.imageData, r = f.format || r || n, i = f.x || i || 0, a = f.y || a || 0, o = f.w || f.width || o, s = f.h || f.height || s, u = f.alias || u, l = f.compression || l, h = f.rotation || f.angle || h;
        }
        var d = this.internal.getFilters();
        if (void 0 === l && -1 !== d.indexOf("FlateEncode") && (l = "SLOW"), isNaN(i) || isNaN(a)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
        c.call(this);
        var g = P.call(this, e, r, u, l);
        return b.call(this, i, a, o, s, g, h), this;
    };
    var P = function(t, r, i, o) {
        var s, u, c;
        if ("string" == typeof t && a(t) === n) {
            t = unescape(t);
            var l = k(t, !1);
            ("" !== l || void 0 !== (l = e.loadFile(t, !0))) && (t = l);
        }
        if (p(t) && (t = g(t, r)), r = a(t, r), !d(r)) throw new Error("addImage does not support files of type '" + r + "', please ensure that a plugin for '" + r + "' support is added.");
        if ((null == (c = i) || 0 === c.length) && (i = function(t) {
            return "string" == typeof t || A(t) ? N(t) : A(t.data) ? N(t.data) : null;
        }(t)), (s = m.call(this, i)) || (t instanceof Uint8Array || "RGBA" === r || (u = t, t = S(t)), s = this["process" + r.toUpperCase()](t, h.call(this), i, function(t) {
            return t && "string" == typeof t && (t = t.toUpperCase()), t in e.image_compression ? t : w.NONE;
        }(o), u)), !s) throw new Error("An unknown error occurred whilst processing the image.");
        return s;
    }, k = e.__addimage__.convertBase64ToBinaryString = function(t, e) {
        e = "boolean" != typeof e || e;
        var r, n = "";
        if ("string" == typeof t) {
            var i;
            r = null !== (i = x(t)) && void 0 !== i ? i : t;
            try {
                n = $dbd37edd557d3750$var$f(r);
            } catch (a) {
                if (e) throw L(r) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + a.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
            }
        }
        return n;
    };
    e.getImageProperties = function(t) {
        var r, i, o = "";
        if (p(t) && (t = g(t)), "string" == typeof t && a(t) === n && ("" === (o = k(t, !1)) && (o = e.loadFile(t) || ""), t = o), i = a(t), !d(i)) throw new Error("addImage does not support files of type '" + i + "', please ensure that a plugin for '" + i + "' support is added.");
        if (t instanceof Uint8Array || (t = S(t)), !(r = this["process" + i.toUpperCase()](t))) throw new Error("An unknown error occurred whilst processing the image");
        return r.fileType = i, r;
    };
}($dbd37edd557d3750$export$2e2bcd8739ae039.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function(t) {
        if (void 0 !== t && "" != t) return !0;
    };
    $dbd37edd557d3750$export$2e2bcd8739ae039.API.events.push([
        "addPage",
        function(t) {
            this.internal.getPageInfo(t.pageNumber).pageContext.annotations = [];
        }
    ]), t.events.push([
        "putPage",
        function(t) {
            for(var r, n, i, a = this.internal.getCoordinateString, o = this.internal.getVerticalCoordinateString, s = this.internal.getPageInfoByObjId(t.objId), u = t.pageContext.annotations, c = !1, l = 0; l < u.length && !c; l++)switch((r = u[l]).type){
                case "link":
                    (e(r.options.url) || e(r.options.pageNumber)) && (c = !0);
                    break;
                case "reference":
                case "text":
                case "freetext":
                    c = !0;
            }
            if (0 != c) {
                this.internal.write("/Annots [");
                for(var h = 0; h < u.length; h++){
                    r = u[h];
                    var f = this.internal.pdfEscape, d = this.internal.getEncryptor(t.objId);
                    switch(r.type){
                        case "reference":
                            this.internal.write(" " + r.object.objId + " 0 R ");
                            break;
                        case "text":
                            var p = this.internal.newAdditionalObject(), g = this.internal.newAdditionalObject(), m = this.internal.getEncryptor(p.objId), v = r.title || "Note";
                            i = "<</Type /Annot /Subtype /Text " + (n = "/Rect [" + a(r.bounds.x) + " " + o(r.bounds.y + r.bounds.h) + " " + a(r.bounds.x + r.bounds.w) + " " + o(r.bounds.y) + "] ") + "/Contents (" + f(m(r.contents)) + ")", i += " /Popup " + g.objId + " 0 R", i += " /P " + s.objId + " 0 R", i += " /T (" + f(m(v)) + ") >>", p.content = i;
                            var b = p.objId + " 0 R";
                            i = "<</Type /Annot /Subtype /Popup " + (n = "/Rect [" + a(r.bounds.x + 30) + " " + o(r.bounds.y + r.bounds.h) + " " + a(r.bounds.x + r.bounds.w + 30) + " " + o(r.bounds.y) + "] ") + " /Parent " + b, r.open && (i += " /Open true"), i += " >>", g.content = i, this.internal.write(p.objId, "0 R", g.objId, "0 R");
                            break;
                        case "freetext":
                            n = "/Rect [" + a(r.bounds.x) + " " + o(r.bounds.y) + " " + a(r.bounds.x + r.bounds.w) + " " + o(r.bounds.y + r.bounds.h) + "] ";
                            var y = "font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + (r.color || "#000000");
                            i = "<</Type /Annot /Subtype /FreeText " + n + "/Contents (" + f(d(r.contents)) + ")", i += " /DS(" + f(d(y)) + ")", i += " /Border [0 0 0]", i += " >>", this.internal.write(i);
                            break;
                        case "link":
                            if (r.options.name) {
                                var w = this.annotations._nameMap[r.options.name];
                                r.options.pageNumber = w.page, r.options.top = w.y;
                            } else r.options.top || (r.options.top = 0);
                            if (n = "/Rect [" + r.finalBounds.x + " " + r.finalBounds.y + " " + r.finalBounds.w + " " + r.finalBounds.h + "] ", i = "", r.options.url) i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /A <</S /URI /URI (" + f(d(r.options.url)) + ") >>";
                            else if (r.options.pageNumber) switch(i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(r.options.pageNumber).objId + " 0 R", r.options.magFactor = r.options.magFactor || "XYZ", r.options.magFactor){
                                case "Fit":
                                    i += " /Fit]";
                                    break;
                                case "FitH":
                                    i += " /FitH " + r.options.top + "]";
                                    break;
                                case "FitV":
                                    r.options.left = r.options.left || 0, i += " /FitV " + r.options.left + "]";
                                    break;
                                default:
                                    var N = o(r.options.top);
                                    r.options.left = r.options.left || 0, void 0 === r.options.zoom && (r.options.zoom = 0), i += " /XYZ " + r.options.left + " " + N + " " + r.options.zoom + "]";
                            }
                            "" != i && (i += " >>", this.internal.write(i));
                    }
                }
                this.internal.write("]");
            }
        }
    ]), t.createAnnotation = function(t) {
        var e = this.internal.getCurrentPageInfo();
        switch(t.type){
            case "link":
                this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
                break;
            case "text":
            case "freetext":
                e.pageContext.annotations.push(t);
        }
    }, t.link = function(t, e, r, n, i) {
        var a = this.internal.getCurrentPageInfo(), o = this.internal.getCoordinateString, s = this.internal.getVerticalCoordinateString;
        a.pageContext.annotations.push({
            finalBounds: {
                x: o(t),
                y: s(e),
                w: o(t + r),
                h: s(e + n)
            },
            options: i,
            type: "link"
        });
    }, t.textWithLink = function(t, e, r, n) {
        var i, a, o = this.getTextWidth(t), s = this.internal.getLineHeight() / this.internal.scaleFactor;
        if (void 0 !== n.maxWidth) {
            a = n.maxWidth;
            var u = this.splitTextToSize(t, a).length;
            i = Math.ceil(s * u);
        } else a = o, i = s;
        return this.text(t, e, r, n), r += .2 * s, "center" === n.align && (e -= o / 2), "right" === n.align && (e -= o), this.link(e, r - s, a, i, n), o;
    }, t.getTextWidth = function(t) {
        var e = this.internal.getFontSize();
        return this.getStringUnitWidth(t) * e / this.internal.scaleFactor;
    };
}($dbd37edd557d3750$export$2e2bcd8739ae039.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = {
        1569: [
            65152
        ],
        1570: [
            65153,
            65154
        ],
        1571: [
            65155,
            65156
        ],
        1572: [
            65157,
            65158
        ],
        1573: [
            65159,
            65160
        ],
        1574: [
            65161,
            65162,
            65163,
            65164
        ],
        1575: [
            65165,
            65166
        ],
        1576: [
            65167,
            65168,
            65169,
            65170
        ],
        1577: [
            65171,
            65172
        ],
        1578: [
            65173,
            65174,
            65175,
            65176
        ],
        1579: [
            65177,
            65178,
            65179,
            65180
        ],
        1580: [
            65181,
            65182,
            65183,
            65184
        ],
        1581: [
            65185,
            65186,
            65187,
            65188
        ],
        1582: [
            65189,
            65190,
            65191,
            65192
        ],
        1583: [
            65193,
            65194
        ],
        1584: [
            65195,
            65196
        ],
        1585: [
            65197,
            65198
        ],
        1586: [
            65199,
            65200
        ],
        1587: [
            65201,
            65202,
            65203,
            65204
        ],
        1588: [
            65205,
            65206,
            65207,
            65208
        ],
        1589: [
            65209,
            65210,
            65211,
            65212
        ],
        1590: [
            65213,
            65214,
            65215,
            65216
        ],
        1591: [
            65217,
            65218,
            65219,
            65220
        ],
        1592: [
            65221,
            65222,
            65223,
            65224
        ],
        1593: [
            65225,
            65226,
            65227,
            65228
        ],
        1594: [
            65229,
            65230,
            65231,
            65232
        ],
        1601: [
            65233,
            65234,
            65235,
            65236
        ],
        1602: [
            65237,
            65238,
            65239,
            65240
        ],
        1603: [
            65241,
            65242,
            65243,
            65244
        ],
        1604: [
            65245,
            65246,
            65247,
            65248
        ],
        1605: [
            65249,
            65250,
            65251,
            65252
        ],
        1606: [
            65253,
            65254,
            65255,
            65256
        ],
        1607: [
            65257,
            65258,
            65259,
            65260
        ],
        1608: [
            65261,
            65262
        ],
        1609: [
            65263,
            65264,
            64488,
            64489
        ],
        1610: [
            65265,
            65266,
            65267,
            65268
        ],
        1649: [
            64336,
            64337
        ],
        1655: [
            64477
        ],
        1657: [
            64358,
            64359,
            64360,
            64361
        ],
        1658: [
            64350,
            64351,
            64352,
            64353
        ],
        1659: [
            64338,
            64339,
            64340,
            64341
        ],
        1662: [
            64342,
            64343,
            64344,
            64345
        ],
        1663: [
            64354,
            64355,
            64356,
            64357
        ],
        1664: [
            64346,
            64347,
            64348,
            64349
        ],
        1667: [
            64374,
            64375,
            64376,
            64377
        ],
        1668: [
            64370,
            64371,
            64372,
            64373
        ],
        1670: [
            64378,
            64379,
            64380,
            64381
        ],
        1671: [
            64382,
            64383,
            64384,
            64385
        ],
        1672: [
            64392,
            64393
        ],
        1676: [
            64388,
            64389
        ],
        1677: [
            64386,
            64387
        ],
        1678: [
            64390,
            64391
        ],
        1681: [
            64396,
            64397
        ],
        1688: [
            64394,
            64395
        ],
        1700: [
            64362,
            64363,
            64364,
            64365
        ],
        1702: [
            64366,
            64367,
            64368,
            64369
        ],
        1705: [
            64398,
            64399,
            64400,
            64401
        ],
        1709: [
            64467,
            64468,
            64469,
            64470
        ],
        1711: [
            64402,
            64403,
            64404,
            64405
        ],
        1713: [
            64410,
            64411,
            64412,
            64413
        ],
        1715: [
            64406,
            64407,
            64408,
            64409
        ],
        1722: [
            64414,
            64415
        ],
        1723: [
            64416,
            64417,
            64418,
            64419
        ],
        1726: [
            64426,
            64427,
            64428,
            64429
        ],
        1728: [
            64420,
            64421
        ],
        1729: [
            64422,
            64423,
            64424,
            64425
        ],
        1733: [
            64480,
            64481
        ],
        1734: [
            64473,
            64474
        ],
        1735: [
            64471,
            64472
        ],
        1736: [
            64475,
            64476
        ],
        1737: [
            64482,
            64483
        ],
        1739: [
            64478,
            64479
        ],
        1740: [
            64508,
            64509,
            64510,
            64511
        ],
        1744: [
            64484,
            64485,
            64486,
            64487
        ],
        1746: [
            64430,
            64431
        ],
        1747: [
            64432,
            64433
        ]
    }, r = {
        65247: {
            65154: 65269,
            65156: 65271,
            65160: 65273,
            65166: 65275
        },
        65248: {
            65154: 65270,
            65156: 65272,
            65160: 65274,
            65166: 65276
        },
        65165: {
            65247: {
                65248: {
                    65258: 65010
                }
            }
        },
        1617: {
            1612: 64606,
            1613: 64607,
            1614: 64608,
            1615: 64609,
            1616: 64610
        }
    }, n = {
        1612: 64606,
        1613: 64607,
        1614: 64608,
        1615: 64609,
        1616: 64610
    }, i = [
        1570,
        1571,
        1573,
        1575
    ];
    t.__arabicParser__ = {};
    var a = t.__arabicParser__.isInArabicSubstitutionA = function(t) {
        return void 0 !== e[t.charCodeAt(0)];
    }, o = t.__arabicParser__.isArabicLetter = function(t) {
        return "string" == typeof t && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t);
    }, s = t.__arabicParser__.isArabicEndLetter = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length <= 2;
    }, u = t.__arabicParser__.isArabicAlfLetter = function(t) {
        return o(t) && i.indexOf(t.charCodeAt(0)) >= 0;
    };
    t.__arabicParser__.arabicLetterHasIsolatedForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 1;
    };
    var c = t.__arabicParser__.arabicLetterHasFinalForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 2;
    };
    t.__arabicParser__.arabicLetterHasInitialForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 3;
    };
    var l = t.__arabicParser__.arabicLetterHasMedialForm = function(t) {
        return o(t) && a(t) && 4 == e[t.charCodeAt(0)].length;
    }, h = t.__arabicParser__.resolveLigatures = function(t) {
        var e = 0, n = r, i = "", a = 0;
        for(e = 0; e < t.length; e += 1)void 0 !== n[t.charCodeAt(e)] ? (a++, "number" == typeof (n = n[t.charCodeAt(e)]) && (i += String.fromCharCode(n), n = r, a = 0), e === t.length - 1 && (n = r, i += t.charAt(e - (a - 1)), e -= a - 1, a = 0)) : (n = r, i += t.charAt(e - a), e -= a, a = 0);
        return i;
    };
    t.__arabicParser__.isArabicDiacritic = function(t) {
        return void 0 !== t && void 0 !== n[t.charCodeAt(0)];
    };
    var f = t.__arabicParser__.getCorrectForm = function(t, e, r) {
        return o(t) ? !1 === a(t) ? -1 : !c(t) || !o(e) && !o(r) || !o(r) && s(e) || s(t) && !o(e) || s(t) && u(e) || s(t) && s(e) ? 0 : l(t) && o(e) && !s(e) && o(r) && c(r) ? 3 : s(t) || !o(r) ? 1 : 2 : -1;
    }, d = function(t) {
        var r = 0, n = 0, i = 0, a = "", s = "", u = "", c = (t = t || "").split("\\s+"), l = [];
        for(r = 0; r < c.length; r += 1){
            for(l.push(""), n = 0; n < c[r].length; n += 1)a = c[r][n], s = c[r][n - 1], u = c[r][n + 1], o(a) ? (i = f(a, s, u), l[r] += -1 !== i ? String.fromCharCode(e[a.charCodeAt(0)][i]) : a) : l[r] += a;
            l[r] = h(l[r]);
        }
        return l.join(" ");
    }, p = t.__arabicParser__.processArabic = t.processArabic = function() {
        var t, e = "string" == typeof arguments[0] ? arguments[0] : arguments[0].text, r = [];
        if (Array.isArray(e)) {
            var n = 0;
            for(r = [], n = 0; n < e.length; n += 1)Array.isArray(e[n]) ? r.push([
                d(e[n][0]),
                e[n][1],
                e[n][2]
            ]) : r.push([
                d(e[n])
            ]);
            t = r;
        } else t = d(e);
        return "string" == typeof arguments[0] ? t : (arguments[0].text = t, arguments[0]);
    };
    t.events.push([
        "preProcessText",
        p
    ]);
}($dbd37edd557d3750$export$2e2bcd8739ae039.API), $dbd37edd557d3750$export$2e2bcd8739ae039.API.autoPrint = function(t) {
    var e;
    return (t = t || {}).variant = t.variant || "non-conform", "javascript" === t.variant ? this.addJS("print({});") : (this.internal.events.subscribe("postPutResources", function() {
        e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
    }), this.internal.events.subscribe("putCatalog", function() {
        this.internal.out("/OpenAction " + e + " 0 R");
    })), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function() {
        var t = void 0;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return t;
            },
            set: function(e) {
                t = e;
            }
        });
        var e = 150;
        Object.defineProperty(this, "width", {
            get: function() {
                return e;
            },
            set: function(t) {
                e = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 150 : t, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = e + 1);
            }
        });
        var r = 300;
        Object.defineProperty(this, "height", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 300 : t, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = r + 1);
            }
        });
        var n = [];
        Object.defineProperty(this, "childNodes", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = t;
            }
        });
        var i = {};
        Object.defineProperty(this, "style", {
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        }), Object.defineProperty(this, "parentNode", {});
    };
    e.prototype.getContext = function(t, e) {
        var r;
        if ("2d" !== (t = t || "2d")) return null;
        for(r in e)this.pdf.context2d.hasOwnProperty(r) && (this.pdf.context2d[r] = e[r]);
        return this.pdf.context2d._canvas = this, this.pdf.context2d;
    }, e.prototype.toDataURL = function() {
        throw new Error("toDataURL is not implemented.");
    }, t.events.push([
        "initialized",
        function() {
            this.canvas = new e, this.canvas.pdf = this;
        }
    ]);
}($dbd37edd557d3750$export$2e2bcd8739ae039.API), function(e) {
    var r = {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
    }, n = !1, i = function() {
        void 0 === this.internal.__cell__ && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, r), this.internal.__cell__.margins.width = this.getPageWidth(), a.call(this));
    }, a = function() {
        this.internal.__cell__.lastCell = new o, this.internal.__cell__.pages = 1;
    }, o = function() {
        var t = arguments[0];
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function() {
                return t;
            },
            set: function(e) {
                t = e;
            }
        });
        var e = arguments[1];
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function() {
                return e;
            },
            set: function(t) {
                e = t;
            }
        });
        var r = arguments[2];
        Object.defineProperty(this, "width", {
            enumerable: !0,
            get: function() {
                return r;
            },
            set: function(t) {
                r = t;
            }
        });
        var n = arguments[3];
        Object.defineProperty(this, "height", {
            enumerable: !0,
            get: function() {
                return n;
            },
            set: function(t) {
                n = t;
            }
        });
        var i = arguments[4];
        Object.defineProperty(this, "text", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        });
        var a = arguments[5];
        Object.defineProperty(this, "lineNumber", {
            enumerable: !0,
            get: function() {
                return a;
            },
            set: function(t) {
                a = t;
            }
        });
        var o = arguments[6];
        return Object.defineProperty(this, "align", {
            enumerable: !0,
            get: function() {
                return o;
            },
            set: function(t) {
                o = t;
            }
        }), this;
    };
    o.prototype.clone = function() {
        return new o(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
    }, o.prototype.toArray = function() {
        return [
            this.x,
            this.y,
            this.width,
            this.height,
            this.text,
            this.lineNumber,
            this.align
        ];
    }, e.setHeaderFunction = function(t) {
        return i.call(this), this.internal.__cell__.headerFunction = "function" == typeof t ? t : void 0, this;
    }, e.getTextDimensions = function(t, e) {
        i.call(this);
        var r = (e = e || {}).fontSize || this.getFontSize(), n = e.font || this.getFont(), a = e.scaleFactor || this.internal.scaleFactor, o = 0, s = 0, u = 0, c = this;
        if (!Array.isArray(t) && "string" != typeof t) {
            if ("number" != typeof t) throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
            t = String(t);
        }
        var l = e.maxWidth;
        l > 0 ? "string" == typeof t ? t = this.splitTextToSize(t, l) : "[object Array]" === Object.prototype.toString.call(t) && (t = t.reduce(function(t, e) {
            return t.concat(c.splitTextToSize(e, l));
        }, [])) : t = Array.isArray(t) ? t : [
            t
        ];
        for(var h = 0; h < t.length; h++)o < (u = this.getStringUnitWidth(t[h], {
            font: n
        }) * r) && (o = u);
        return 0 !== o && (s = t.length), {
            w: o /= a,
            h: Math.max((s * r * this.getLineHeightFactor() - r * (this.getLineHeightFactor() - 1)) / a, 0)
        };
    }, e.cellAddPage = function() {
        i.call(this), this.addPage();
        var t = this.internal.__cell__.margins || r;
        return this.internal.__cell__.lastCell = new o(t.left, t.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
    };
    var s = e.cell = function() {
        var t;
        t = arguments[0] instanceof o ? arguments[0] : new o(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]), i.call(this);
        var e = this.internal.__cell__.lastCell, a = this.internal.__cell__.padding, s = this.internal.__cell__.margins || r, u = this.internal.__cell__.tableHeaderRow, c = this.internal.__cell__.printHeaders;
        return void 0 !== e.lineNumber && (e.lineNumber === t.lineNumber ? (t.x = (e.x || 0) + (e.width || 0), t.y = e.y || 0) : e.y + e.height + t.height + s.bottom > this.getPageHeight() ? (this.cellAddPage(), t.y = s.top, c && u && (this.printHeaderRow(t.lineNumber, !0), t.y += u[0].height)) : t.y = e.y + e.height || t.y), void 0 !== t.text[0] && (this.rect(t.x, t.y, t.width, t.height, !0 === n ? "FD" : void 0), "right" === t.align ? this.text(t.text, t.x + t.width - a, t.y + a, {
            align: "right",
            baseline: "top"
        }) : "center" === t.align ? this.text(t.text, t.x + t.width / 2, t.y + a, {
            align: "center",
            baseline: "top",
            maxWidth: t.width - a - a
        }) : this.text(t.text, t.x + a, t.y + a, {
            align: "left",
            baseline: "top",
            maxWidth: t.width - a - a
        })), this.internal.__cell__.lastCell = t, this;
    };
    e.table = function(e, n, c, l, h) {
        if (i.call(this), !c) throw new Error("No data for PDF table.");
        var f, d, p, g, m = [], v = [], b = [], y = {}, w = {}, N = [], L = [], x = (h = h || {}).autoSize || !1, A = !1 !== h.printHeaders, S = h.css && void 0 !== h.css["font-size"] ? 16 * h.css["font-size"] : h.fontSize || 12, _ = h.margins || Object.assign({
            width: this.getPageWidth()
        }, r), P = "number" == typeof h.padding ? h.padding : 3, k = h.headerBackgroundColor || "#c8c8c8", F = h.headerTextColor || "#000";
        if (a.call(this), this.internal.__cell__.printHeaders = A, this.internal.__cell__.margins = _, this.internal.__cell__.table_font_size = S, this.internal.__cell__.padding = P, this.internal.__cell__.headerBackgroundColor = k, this.internal.__cell__.headerTextColor = F, this.setFontSize(S), null == l) v = m = Object.keys(c[0]), b = m.map(function() {
            return "left";
        });
        else if (Array.isArray(l) && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(l[0])) for(m = l.map(function(t) {
            return t.name;
        }), v = l.map(function(t) {
            return t.prompt || t.name || "";
        }), b = l.map(function(t) {
            return t.align || "left";
        }), f = 0; f < l.length; f += 1)w[l[f].name] = .7499990551181103 * l[f].width;
        else Array.isArray(l) && "string" == typeof l[0] && (v = m = l, b = m.map(function() {
            return "left";
        }));
        if (x || Array.isArray(l) && "string" == typeof l[0]) for(f = 0; f < m.length; f += 1){
            for(y[g = m[f]] = c.map(function(t) {
                return t[g];
            }), this.setFont(void 0, "bold"), N.push(this.getTextDimensions(v[f], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w), d = y[g], this.setFont(void 0, "normal"), p = 0; p < d.length; p += 1)N.push(this.getTextDimensions(d[p], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w);
            w[g] = Math.max.apply(null, N) + P + P, N = [];
        }
        if (A) {
            var I = {};
            for(f = 0; f < m.length; f += 1)I[m[f]] = {}, I[m[f]].text = v[f], I[m[f]].align = b[f];
            var C = u.call(this, I, w);
            L = m.map(function(t) {
                return new o(e, n, w[t], C, I[t].text, void 0, I[t].align);
            }), this.setTableHeaderRow(L), this.printHeaderRow(1, !1);
        }
        var j = l.reduce(function(t, e) {
            return t[e.name] = e.align, t;
        }, {});
        for(f = 0; f < c.length; f += 1){
            "rowStart" in h && h.rowStart instanceof Function && h.rowStart({
                row: f,
                data: c[f]
            }, this);
            var O = u.call(this, c[f], w);
            for(p = 0; p < m.length; p += 1){
                var B = c[f][m[p]];
                "cellStart" in h && h.cellStart instanceof Function && h.cellStart({
                    row: f,
                    col: p,
                    data: B
                }, this), s.call(this, new o(e, n, w[m[p]], O, B, f + 2, j[m[p]]));
            }
        }
        return this.internal.__cell__.table_x = e, this.internal.__cell__.table_y = n, this;
    };
    var u = function(t, e) {
        var r = this.internal.__cell__.padding, n = this.internal.__cell__.table_font_size, i = this.internal.scaleFactor;
        return Object.keys(t).map(function(n) {
            var i = t[n];
            return this.splitTextToSize(i.hasOwnProperty("text") ? i.text : i, e[n] - r - r);
        }, this).map(function(t) {
            return this.getLineHeightFactor() * t.length * n / i + r + r;
        }, this).reduce(function(t, e) {
            return Math.max(t, e);
        }, 0);
    };
    e.setTableHeaderRow = function(t) {
        i.call(this), this.internal.__cell__.tableHeaderRow = t;
    }, e.printHeaderRow = function(t, e) {
        if (i.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
        var r;
        if (n = !0, "function" == typeof this.internal.__cell__.headerFunction) {
            var a = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
            this.internal.__cell__.lastCell = new o(a[0], a[1], a[2], a[3], void 0, -1);
        }
        this.setFont(void 0, "bold");
        for(var u = [], c = 0; c < this.internal.__cell__.tableHeaderRow.length; c += 1){
            r = this.internal.__cell__.tableHeaderRow[c].clone(), e && (r.y = this.internal.__cell__.margins.top || 0, u.push(r)), r.lineNumber = t;
            var l = this.getTextColor();
            this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), s.call(this, r), this.setTextColor(l);
        }
        u.length > 0 && this.setTableHeaderRow(u), this.setFont(void 0, "normal"), n = !1;
    };
}($dbd37edd557d3750$export$2e2bcd8739ae039.API);
var $dbd37edd557d3750$var$kt = {
    italic: [
        "italic",
        "oblique",
        "normal"
    ],
    oblique: [
        "oblique",
        "italic",
        "normal"
    ],
    normal: [
        "normal",
        "oblique",
        "italic"
    ]
}, $dbd37edd557d3750$var$Ft = [
    "ultra-condensed",
    "extra-condensed",
    "condensed",
    "semi-condensed",
    "normal",
    "semi-expanded",
    "expanded",
    "extra-expanded",
    "ultra-expanded"
], $dbd37edd557d3750$var$It = $dbd37edd557d3750$var$Pt($dbd37edd557d3750$var$Ft), $dbd37edd557d3750$var$Ct = [
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900
], $dbd37edd557d3750$var$jt = $dbd37edd557d3750$var$Pt($dbd37edd557d3750$var$Ct);
function $dbd37edd557d3750$var$Ot(t) {
    var e = t.family.replace(/"|'/g, "").toLowerCase(), r = function(t) {
        return $dbd37edd557d3750$var$kt[t = t || "normal"] ? t : "normal";
    }(t.style), n = function(t) {
        return t ? "number" == typeof t ? t >= 100 && t <= 900 && t % 100 == 0 ? t : 400 : /^\d00$/.test(t) ? parseInt(t) : "bold" === t ? 700 : 400 : 400;
    }(t.weight), i = function(t) {
        return "number" == typeof $dbd37edd557d3750$var$It[t = t || "normal"] ? t : "normal";
    }(t.stretch);
    return {
        family: e,
        style: r,
        weight: n,
        stretch: i,
        src: t.src || [],
        ref: t.ref || {
            name: e,
            style: [
                i,
                r,
                n
            ].join(" ")
        }
    };
}
function $dbd37edd557d3750$var$Bt(t, e, r, n) {
    var i;
    for(i = r; i >= 0 && i < e.length; i += n)if (t[e[i]]) return t[e[i]];
    for(i = r; i >= 0 && i < e.length; i -= n)if (t[e[i]]) return t[e[i]];
}
var $dbd37edd557d3750$var$Mt = {
    "sans-serif": "helvetica",
    fixed: "courier",
    monospace: "courier",
    terminal: "courier",
    cursive: "times",
    fantasy: "times",
    serif: "times"
}, $dbd37edd557d3750$var$qt = {
    caption: "times",
    icon: "times",
    menu: "times",
    "message-box": "times",
    "small-caption": "times",
    "status-bar": "times"
};
function $dbd37edd557d3750$var$Et(t) {
    return [
        t.stretch,
        t.style,
        t.weight,
        t.family
    ].join(" ");
}
function $dbd37edd557d3750$var$Rt(t) {
    return t.trimLeft();
}
function $dbd37edd557d3750$var$Dt(t, e) {
    for(var r = 0; r < t.length;){
        if (t.charAt(r) === e) return [
            t.substring(0, r),
            t.substring(r + 1)
        ];
        r += 1;
    }
    return null;
}
function $dbd37edd557d3750$var$Tt(t) {
    var e = t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
    return null === e ? null : [
        e[0],
        t.substring(e[0].length)
    ];
}
var $dbd37edd557d3750$var$zt, $dbd37edd557d3750$var$Ut, $dbd37edd557d3750$var$Ht, $dbd37edd557d3750$var$Wt, $dbd37edd557d3750$var$Vt, $dbd37edd557d3750$var$Gt = [
    "times"
];
function $dbd37edd557d3750$var$Yt(t, r, n, i, a) {
    var o = 4, s = $dbd37edd557d3750$var$Kt;
    switch(a){
        case $dbd37edd557d3750$export$2e2bcd8739ae039.API.image_compression.FAST:
            o = 1, s = $dbd37edd557d3750$var$Xt;
            break;
        case $dbd37edd557d3750$export$2e2bcd8739ae039.API.image_compression.MEDIUM:
            o = 6, s = $dbd37edd557d3750$var$Zt;
            break;
        case $dbd37edd557d3750$export$2e2bcd8739ae039.API.image_compression.SLOW:
            o = 9, s = $dbd37edd557d3750$var$$t;
    }
    t = function(t, e, r, n) {
        for(var i, a = t.length / e, o = new Uint8Array(t.length + a), s = [
            $dbd37edd557d3750$var$Jt,
            $dbd37edd557d3750$var$Xt,
            $dbd37edd557d3750$var$Kt,
            $dbd37edd557d3750$var$Zt,
            $dbd37edd557d3750$var$$t
        ], u = 0; u < a; u += 1){
            var c = u * e, l = t.subarray(c, c + e);
            if (n) o.set(n(l, r, i), c + u);
            else {
                for(var h = s.length, f = [], d = 0; d < h; d += 1)f[d] = s[d](l, r, i);
                var p = $dbd37edd557d3750$var$te(f.concat());
                o.set(f[p], c + u);
            }
            i = l;
        }
        return o;
    }(t, r, Math.ceil(n * i / 8), s);
    var u = (0, $16597f9d07f22afc$export$f87121a6d50aff25)(t, {
        level: o
    });
    return $dbd37edd557d3750$export$2e2bcd8739ae039.API.__addimage__.arrayBufferToBinaryString(u);
}
function $dbd37edd557d3750$var$Jt(t) {
    var e = Array.apply([], t);
    return e.unshift(0), e;
}
function $dbd37edd557d3750$var$Xt(t, e) {
    var r = t.length, n = [];
    n[0] = 1;
    for(var i = 0; i < r; i += 1){
        var a = t[i - e] || 0;
        n[i + 1] = t[i] - a + 256 & 255;
    }
    return n;
}
function $dbd37edd557d3750$var$Kt(t, e, r) {
    var n = t.length, i = [];
    i[0] = 2;
    for(var a = 0; a < n; a += 1){
        var o = r && r[a] || 0;
        i[a + 1] = t[a] - o + 256 & 255;
    }
    return i;
}
function $dbd37edd557d3750$var$Zt(t, e, r) {
    var n = t.length, i = [];
    i[0] = 3;
    for(var a = 0; a < n; a += 1){
        var o = t[a - e] || 0, s = r && r[a] || 0;
        i[a + 1] = t[a] + 256 - (o + s >>> 1) & 255;
    }
    return i;
}
function $dbd37edd557d3750$var$$t(t, e, r) {
    var n = t.length, i = [];
    i[0] = 4;
    for(var a = 0; a < n; a += 1){
        var o = $dbd37edd557d3750$var$Qt(t[a - e] || 0, r && r[a] || 0, r && r[a - e] || 0);
        i[a + 1] = t[a] - o + 256 & 255;
    }
    return i;
}
function $dbd37edd557d3750$var$Qt(t, e, r) {
    if (t === e && e === r) return t;
    var n = Math.abs(e - r), i = Math.abs(t - r), a = Math.abs(t + e - r - r);
    return n <= i && n <= a ? t : i <= a ? e : r;
}
function $dbd37edd557d3750$var$te(t) {
    var e = t.map(function(t) {
        return t.reduce(function(t, e) {
            return t + Math.abs(e);
        }, 0);
    });
    return e.indexOf(Math.min.apply(null, e));
}
function $dbd37edd557d3750$var$ee(t, e, r) {
    var n = e * r, i = Math.floor(n / 8), a = 16 - (n - 8 * i + r), o = (1 << r) - 1;
    return $dbd37edd557d3750$var$ne(t, i) >> a & o;
}
function $dbd37edd557d3750$var$re(t, e, r, n) {
    var i = r * n, a = Math.floor(i / 8), o = 16 - (i - 8 * a + n), s = (1 << n) - 1, u = (e & s) << o;
    !function(t, e, r) {
        if (e + 1 < t.byteLength) t.setUint16(e, r, !1);
        else {
            var n = r >> 8 & 255;
            t.setUint8(e, n);
        }
    }(t, a, $dbd37edd557d3750$var$ne(t, a) & ~(s << o) & 65535 | u);
}
function $dbd37edd557d3750$var$ne(t, e) {
    return e + 1 < t.byteLength ? t.getUint16(e, !1) : t.getUint8(e) << 8;
}
function $dbd37edd557d3750$var$ie(t) {
    var e = 0;
    if (71 !== t[e++] || 73 !== t[e++] || 70 !== t[e++] || 56 !== t[e++] || 56 != (t[e++] + 1 & 253) || 97 !== t[e++]) throw new Error("Invalid GIF 87a/89a header.");
    var r = t[e++] | t[e++] << 8, n = t[e++] | t[e++] << 8, i = t[e++], a = i >> 7, o = 1 << 1 + (7 & i);
    t[e++], t[e++];
    var s = null, u = null;
    a && (s = e, u = o, e += 3 * o);
    var c = !0, l = [], h = 0, f = null, d = 0, p = null;
    for(this.width = r, this.height = n; c && e < t.length;)switch(t[e++]){
        case 33:
            switch(t[e++]){
                case 255:
                    if (11 !== t[e] || 78 == t[e + 1] && 69 == t[e + 2] && 84 == t[e + 3] && 83 == t[e + 4] && 67 == t[e + 5] && 65 == t[e + 6] && 80 == t[e + 7] && 69 == t[e + 8] && 50 == t[e + 9] && 46 == t[e + 10] && 48 == t[e + 11] && 3 == t[e + 12] && 1 == t[e + 13] && 0 == t[e + 16]) e += 14, p = t[e++] | t[e++] << 8, e++;
                    else for(e += 12;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                case 249:
                    if (4 !== t[e++] || 0 !== t[e + 4]) throw new Error("Invalid graphics extension block.");
                    var g = t[e++];
                    h = t[e++] | t[e++] << 8, f = t[e++], 1 & g || (f = null), d = g >> 2 & 7, e++;
                    break;
                case 254:
                    for(;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                default:
                    throw new Error("Unknown graphic control label: 0x" + t[e - 1].toString(16));
            }
            break;
        case 44:
            var m = t[e++] | t[e++] << 8, v = t[e++] | t[e++] << 8, b = t[e++] | t[e++] << 8, y = t[e++] | t[e++] << 8, w = t[e++], N = w >> 6 & 1, L = 1 << 1 + (7 & w), x = s, A = u, S = !1;
            w >> 7 && (S = !0, x = e, A = L, e += 3 * L);
            var _ = e;
            for(e++;;){
                var P;
                if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                if (0 === P) break;
                e += P;
            }
            l.push({
                x: m,
                y: v,
                width: b,
                height: y,
                has_local_palette: S,
                palette_offset: x,
                palette_size: A,
                data_offset: _,
                data_length: e - _,
                transparent_index: f,
                interlaced: !!N,
                delay: h,
                disposal: d
            });
            break;
        case 59:
            c = !1;
            break;
        default:
            throw new Error("Unknown gif block: 0x" + t[e - 1].toString(16));
    }
    this.numFrames = function() {
        return l.length;
    }, this.loopCount = function() {
        return p;
    }, this.frameInfo = function(t) {
        if (t < 0 || t >= l.length) throw new Error("Frame index out of range.");
        return l[t];
    }, this.decodeAndBlitFrameBGRA = function(e, n) {
        var i = this.frameInfo(e), a = i.width * i.height;
        if (a > 536870912) throw new Error("Image dimensions exceed 512MB, which is too large.");
        var o = new Uint8Array(a);
        $dbd37edd557d3750$var$ae(t, i.data_offset, o, a);
        var s = i.palette_offset, u = i.transparent_index;
        null === u && (u = 256);
        var c = i.width, l = r - c, h = c, f = 4 * (i.y * r + i.x), d = 4 * ((i.y + i.height) * r + i.x), p = f, g = 4 * l;
        !0 === i.interlaced && (g += 4 * r * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var y = o[v];
            if (0 === h && (h = c, (p += g) >= d && (g = 4 * l + 4 * r * (m - 1), p = f + (c + l) * (m << 1), m >>= 1)), y === u) p += 4;
            else {
                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                n[p++] = L, n[p++] = N, n[p++] = w, n[p++] = 255;
            }
            --h;
        }
    }, this.decodeAndBlitFrameRGBA = function(e, n) {
        var i = this.frameInfo(e), a = i.width * i.height;
        if (a > 536870912) throw new Error("Image dimensions exceed 512MB, which is too large.");
        var o = new Uint8Array(a);
        $dbd37edd557d3750$var$ae(t, i.data_offset, o, a);
        var s = i.palette_offset, u = i.transparent_index;
        null === u && (u = 256);
        var c = i.width, l = r - c, h = c, f = 4 * (i.y * r + i.x), d = 4 * ((i.y + i.height) * r + i.x), p = f, g = 4 * l;
        !0 === i.interlaced && (g += 4 * r * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var y = o[v];
            if (0 === h && (h = c, (p += g) >= d && (g = 4 * l + 4 * r * (m - 1), p = f + (c + l) * (m << 1), m >>= 1)), y === u) p += 4;
            else {
                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                n[p++] = w, n[p++] = N, n[p++] = L, n[p++] = 255;
            }
            --h;
        }
    };
}
function $dbd37edd557d3750$var$ae(t, e, r, n) {
    for(var i = t[e++], a = 1 << i, s = a + 1, u = s + 1, c = i + 1, l = (1 << c) - 1, h = 0, f = 0, d = 0, p = t[e++], g = new Int32Array(4096), m = null;;){
        for(; h < 16 && 0 !== p;)f |= t[e++] << h, h += 8, 1 === p ? p = t[e++] : --p;
        if (h < c) break;
        var v = f & l;
        if (f >>= c, h -= c, v !== a) {
            if (v === s) break;
            for(var b = v < u ? v : m, y = 0, w = b; w > a;)w = g[w] >> 8, ++y;
            var N = w;
            if (d + y + (b !== v ? 1 : 0) > n) return void $dbd37edd557d3750$var$o.log("Warning, gif stream longer than expected.");
            r[d++] = N;
            var L = d += y;
            for(b !== v && (r[d++] = N), w = b; y--;)w = g[w], r[--L] = 255 & w, w >>= 8;
            null !== m && u < 4096 && (g[u++] = m << 8 | N, u >= l + 1 && c < 12 && (++c, l = l << 1 | 1)), m = v;
        } else u = s + 1, l = (1 << (c = i + 1)) - 1, m = null;
    }
    return d !== n && $dbd37edd557d3750$var$o.log("Warning, gif stream shorter than expected."), r;
}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ function $dbd37edd557d3750$var$oe(t) {
    var e, r, n, i, a, o = Math.floor, s = new Array(64), u = new Array(64), c = new Array(64), l = new Array(64), h = new Array(65535), f = new Array(65535), d = new Array(64), p = new Array(64), g = [], m = 0, v = 7, b = new Array(64), y = new Array(64), w = new Array(64), N = new Array(256), L = new Array(2048), x = [
        0,
        1,
        5,
        6,
        14,
        15,
        27,
        28,
        2,
        4,
        7,
        13,
        16,
        26,
        29,
        42,
        3,
        8,
        12,
        17,
        25,
        30,
        41,
        43,
        9,
        11,
        18,
        24,
        31,
        40,
        44,
        53,
        10,
        19,
        23,
        32,
        39,
        45,
        52,
        54,
        20,
        22,
        33,
        38,
        46,
        51,
        55,
        60,
        21,
        34,
        37,
        47,
        50,
        56,
        59,
        61,
        35,
        36,
        48,
        49,
        57,
        58,
        62,
        63
    ], A = [
        0,
        0,
        1,
        5,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ], S = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], _ = [
        0,
        0,
        2,
        1,
        3,
        3,
        2,
        4,
        3,
        5,
        5,
        4,
        4,
        0,
        0,
        1,
        125
    ], P = [
        1,
        2,
        3,
        0,
        4,
        17,
        5,
        18,
        33,
        49,
        65,
        6,
        19,
        81,
        97,
        7,
        34,
        113,
        20,
        50,
        129,
        145,
        161,
        8,
        35,
        66,
        177,
        193,
        21,
        82,
        209,
        240,
        36,
        51,
        98,
        114,
        130,
        9,
        10,
        22,
        23,
        24,
        25,
        26,
        37,
        38,
        39,
        40,
        41,
        42,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ], k = [
        0,
        0,
        3,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0
    ], F = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], I = [
        0,
        0,
        2,
        1,
        2,
        4,
        4,
        3,
        4,
        7,
        5,
        4,
        4,
        0,
        1,
        2,
        119
    ], C = [
        0,
        1,
        2,
        3,
        17,
        4,
        5,
        33,
        49,
        6,
        18,
        65,
        81,
        7,
        97,
        113,
        19,
        34,
        50,
        129,
        8,
        20,
        66,
        145,
        161,
        177,
        193,
        9,
        35,
        51,
        82,
        240,
        21,
        98,
        114,
        209,
        10,
        22,
        36,
        52,
        225,
        37,
        241,
        23,
        24,
        25,
        26,
        38,
        39,
        40,
        41,
        42,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ];
    function j(t, e) {
        for(var r = 0, n = 0, i = new Array, a = 1; a <= 16; a++){
            for(var o = 1; o <= t[a]; o++)i[e[n]] = [], i[e[n]][0] = r, i[e[n]][1] = a, n++, r++;
            r *= 2;
        }
        return i;
    }
    function O(t) {
        for(var e = t[0], r = t[1] - 1; r >= 0;)e & 1 << r && (m |= 1 << v), r--, --v < 0 && (255 == m ? (B(255), B(0)) : B(m), v = 7, m = 0);
    }
    function B(t) {
        g.push(t);
    }
    function M(t) {
        B(t >> 8 & 255), B(255 & t);
    }
    function q(t, e, r, n, i) {
        for(var a, o = i[0], s = i[240], u = function(t, e) {
            var r, n, i, a, o, s, u, c, l, h, f = 0;
            for(l = 0; l < 8; ++l){
                r = t[f], n = t[f + 1], i = t[f + 2], a = t[f + 3], o = t[f + 4], s = t[f + 5], u = t[f + 6];
                var p = r + (c = t[f + 7]), g = r - c, m = n + u, v = n - u, b = i + s, y = i - s, w = a + o, N = a - o, L = p + w, x = p - w, A = m + b, S = m - b;
                t[f] = L + A, t[f + 4] = L - A;
                var _ = .707106781 * (S + x);
                t[f + 2] = x + _, t[f + 6] = x - _;
                var P = .382683433 * ((L = N + y) - (S = v + g)), k = .5411961 * L + P, F = 1.306562965 * S + P, I = .707106781 * (A = y + v), C = g + I, j = g - I;
                t[f + 5] = j + k, t[f + 3] = j - k, t[f + 1] = C + F, t[f + 7] = C - F, f += 8;
            }
            for(f = 0, l = 0; l < 8; ++l){
                r = t[f], n = t[f + 8], i = t[f + 16], a = t[f + 24], o = t[f + 32], s = t[f + 40], u = t[f + 48];
                var O = r + (c = t[f + 56]), B = r - c, M = n + u, q = n - u, E = i + s, R = i - s, D = a + o, T = a - o, z = O + D, U = O - D, H = M + E, W = M - E;
                t[f] = z + H, t[f + 32] = z - H;
                var V = .707106781 * (W + U);
                t[f + 16] = U + V, t[f + 48] = U - V;
                var G = .382683433 * ((z = T + R) - (W = q + B)), Y = .5411961 * z + G, J = 1.306562965 * W + G, X = .707106781 * (H = R + q), K = B + X, Z = B - X;
                t[f + 40] = Z + Y, t[f + 24] = Z - Y, t[f + 8] = K + J, t[f + 56] = K - J, f++;
            }
            for(l = 0; l < 64; ++l)h = t[l] * e[l], d[l] = h > 0 ? h + .5 | 0 : h - .5 | 0;
            return d;
        }(t, e), c = 0; c < 64; ++c)p[x[c]] = u[c];
        var l = p[0] - r;
        r = p[0], 0 == l ? O(n[0]) : (O(n[f[a = 32767 + l]]), O(h[a]));
        for(var g = 63; g > 0 && 0 == p[g];)g--;
        if (0 == g) return O(o), r;
        for(var m, v = 1; v <= g;){
            for(var b = v; 0 == p[v] && v <= g;)++v;
            var y = v - b;
            if (y >= 16) {
                m = y >> 4;
                for(var w = 1; w <= m; ++w)O(s);
                y &= 15;
            }
            a = 32767 + p[v], O(i[(y << 4) + f[a]]), O(h[a]), v++;
        }
        return 63 != g && O(o), r;
    }
    function E(t) {
        t = Math.min(Math.max(t, 1), 100), a != t && (function(t) {
            for(var e = [
                16,
                11,
                10,
                16,
                24,
                40,
                51,
                61,
                12,
                12,
                14,
                19,
                26,
                58,
                60,
                55,
                14,
                13,
                16,
                24,
                40,
                57,
                69,
                56,
                14,
                17,
                22,
                29,
                51,
                87,
                80,
                62,
                18,
                22,
                37,
                56,
                68,
                109,
                103,
                77,
                24,
                35,
                55,
                64,
                81,
                104,
                113,
                92,
                49,
                64,
                78,
                87,
                103,
                121,
                120,
                101,
                72,
                92,
                95,
                98,
                112,
                100,
                103,
                99
            ], r = 0; r < 64; r++){
                var n = o((e[r] * t + 50) / 100);
                n = Math.min(Math.max(n, 1), 255), s[x[r]] = n;
            }
            for(var i = [
                17,
                18,
                24,
                47,
                99,
                99,
                99,
                99,
                18,
                21,
                26,
                66,
                99,
                99,
                99,
                99,
                24,
                26,
                56,
                99,
                99,
                99,
                99,
                99,
                47,
                66,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99
            ], a = 0; a < 64; a++){
                var h = o((i[a] * t + 50) / 100);
                h = Math.min(Math.max(h, 1), 255), u[x[a]] = h;
            }
            for(var f = [
                1,
                1.387039845,
                1.306562965,
                1.175875602,
                1,
                .785694958,
                .5411961,
                .275899379
            ], d = 0, p = 0; p < 8; p++)for(var g = 0; g < 8; g++)c[d] = 1 / (s[x[d]] * f[p] * f[g] * 8), l[d] = 1 / (u[x[d]] * f[p] * f[g] * 8), d++;
        }(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)), a = t);
    }
    this.encode = function(t, a) {
        a && E(a), g = new Array, m = 0, v = 7, M(65496), M(65504), M(16), B(74), B(70), B(73), B(70), B(0), B(1), B(1), B(0), M(1), M(1), B(0), B(0), function() {
            M(65499), M(132), B(0);
            for(var t = 0; t < 64; t++)B(s[t]);
            B(1);
            for(var e = 0; e < 64; e++)B(u[e]);
        }(), function(t, e) {
            M(65472), M(17), B(8), M(e), M(t), B(3), B(1), B(17), B(0), B(2), B(17), B(1), B(3), B(17), B(1);
        }(t.width, t.height), function() {
            M(65476), M(418), B(0);
            for(var t = 0; t < 16; t++)B(A[t + 1]);
            for(var e = 0; e <= 11; e++)B(S[e]);
            B(16);
            for(var r = 0; r < 16; r++)B(_[r + 1]);
            for(var n = 0; n <= 161; n++)B(P[n]);
            B(1);
            for(var i = 0; i < 16; i++)B(k[i + 1]);
            for(var a = 0; a <= 11; a++)B(F[a]);
            B(17);
            for(var o = 0; o < 16; o++)B(I[o + 1]);
            for(var s = 0; s <= 161; s++)B(C[s]);
        }(), M(65498), M(12), B(3), B(1), B(0), B(2), B(17), B(3), B(17), B(0), B(63), B(0);
        var o = 0, h = 0, f = 0;
        m = 0, v = 7, this.encode.displayName = "_encode_";
        for(var d, p, N, x, j, R, D, T, z, U = t.data, H = t.width, W = t.height, V = 4 * H, G = 0; G < W;){
            for(d = 0; d < V;){
                for(j = V * G + d, D = -1, T = 0, z = 0; z < 64; z++)R = j + (T = z >> 3) * V + (D = 4 * (7 & z)), G + T >= W && (R -= V * (G + 1 + T - W)), d + D >= V && (R -= d + D - V + 4), p = U[R++], N = U[R++], x = U[R++], b[z] = (L[p] + L[N + 256 | 0] + L[x + 512 | 0] >> 16) - 128, y[z] = (L[p + 768 | 0] + L[N + 1024 | 0] + L[x + 1280 | 0] >> 16) - 128, w[z] = (L[p + 1280 | 0] + L[N + 1536 | 0] + L[x + 1792 | 0] >> 16) - 128;
                o = q(b, c, o, e, n), h = q(y, l, h, r, i), f = q(w, l, f, r, i), d += 32;
            }
            G += 8;
        }
        if (v >= 0) {
            var Y = [];
            Y[1] = v + 1, Y[0] = (1 << v + 1) - 1, O(Y);
        }
        return M(65497), new Uint8Array(g);
    }, t = t || 50, function() {
        for(var t = String.fromCharCode, e = 0; e < 256; e++)N[e] = t(e);
    }(), e = j(A, S), r = j(k, F), n = j(_, P), i = j(I, C), function() {
        for(var t = 1, e = 2, r = 1; r <= 15; r++){
            for(var n = t; n < e; n++)f[32767 + n] = r, h[32767 + n] = [], h[32767 + n][1] = r, h[32767 + n][0] = n;
            for(var i = -(e - 1); i <= -t; i++)f[32767 + i] = r, h[32767 + i] = [], h[32767 + i][1] = r, h[32767 + i][0] = e - 1 + i;
            t <<= 1, e <<= 1;
        }
    }(), function() {
        for(var t = 0; t < 256; t++)L[t] = 19595 * t, L[t + 256 | 0] = 38470 * t, L[t + 512 | 0] = 7471 * t + 32768, L[t + 768 | 0] = -11059 * t, L[t + 1024 | 0] = -21709 * t, L[t + 1280 | 0] = 32768 * t + 8421375, L[t + 1536 | 0] = -27439 * t, L[t + 1792 | 0] = -5329 * t;
    }(), E(t);
}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function $dbd37edd557d3750$var$se(t, e) {
    if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, -1 === [
        "BM",
        "BA",
        "CI",
        "CP",
        "IC",
        "PT"
    ].indexOf(this.flag)) throw new Error("Invalid BMP File");
    this.parseHeader(), this.parseBGR();
}
function $dbd37edd557d3750$var$ue(t) {
    function e(t) {
        if (!t) throw Error("assert :P");
    }
    function r(t, e, r) {
        for(var n = 0; 4 > n; n++)if (t[e + n] != r.charCodeAt(n)) return !0;
        return !1;
    }
    function n(t, e, r, n, i) {
        for(var a = 0; a < i; a++)t[e + a] = r[n + a];
    }
    function i(t, e, r, n) {
        for(var i = 0; i < n; i++)t[e + i] = r;
    }
    function a(t) {
        return new Int32Array(t);
    }
    function o(t, e) {
        for(var r = [], n = 0; n < t; n++)r.push(new e);
        return r;
    }
    function s(t, e) {
        var r = [];
        return function t(r, n, i) {
            for(var a = i[n], o = 0; o < a && (r.push(i.length > n + 1 ? [] : new e), !(i.length < n + 1)); o++)t(r[o], n + 1, i);
        }(r, 0, t), r;
    }
    var u = function() {
        var t = this;
        function u(t, e) {
            for(var r = 1 << e - 1 >>> 0; t & r;)r >>>= 1;
            return r ? (t & r - 1) + r : t;
        }
        function c(t, r, n, i, a) {
            e(!(i % n));
            do t[r + (i -= n)] = a;
            while (0 < i);
        }
        function l(t, r, n, i, o) {
            if (e(2328 >= o), 512 >= o) var s = a(512);
            else if (null == (s = a(o))) return 0;
            return function(t, r, n, i, o, s) {
                var l, f, d = r, p = 1 << n, g = a(16), m = a(16);
                for(e(0 != o), e(null != i), e(null != t), e(0 < n), f = 0; f < o; ++f){
                    if (15 < i[f]) return 0;
                    ++g[i[f]];
                }
                if (g[0] == o) return 0;
                for(m[1] = 0, l = 1; 15 > l; ++l){
                    if (g[l] > 1 << l) return 0;
                    m[l + 1] = m[l] + g[l];
                }
                for(f = 0; f < o; ++f)l = i[f], 0 < i[f] && (s[m[l]++] = f);
                if (1 == m[15]) return (i = new h).g = 0, i.value = s[0], c(t, d, 1, p, i), p;
                var v, b = -1, y = p - 1, w = 0, N = 1, L = 1, x = 1 << n;
                for(f = 0, l = 1, o = 2; l <= n; ++l, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[l])) return 0;
                    for(; 0 < g[l]; --g[l])(i = new h).g = l, i.value = s[f++], c(t, d + w, o, x, i), w = u(w, l);
                }
                for(l = n + 1, o = 2; 15 >= l; ++l, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[l])) return 0;
                    for(; 0 < g[l]; --g[l]){
                        if (i = new h, (w & y) != b) {
                            for(d += x, v = 1 << (b = l) - n; 15 > b && !(0 >= (v -= g[b]));)++b, v <<= 1;
                            p += x = 1 << (v = b - n), t[r + (b = w & y)].g = v + n, t[r + b].value = d - r - b;
                        }
                        i.g = l - n, i.value = s[f++], c(t, d + (w >> n), o, x, i), w = u(w, l);
                    }
                }
                return N != 2 * m[15] - 1 ? 0 : p;
            }(t, r, n, i, o, s);
        }
        function h() {
            this.value = this.g = 0;
        }
        function f() {
            this.value = this.g = 0;
        }
        function d() {
            this.G = o(5, h), this.H = a(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = o(Er, f);
        }
        function p(t, r, n, i) {
            e(null != t), e(null != r), e(2147483648 > i), t.Ca = 254, t.I = 0, t.b = -8, t.Ka = 0, t.oa = r, t.pa = n, t.Jd = r, t.Yc = n + i, t.Zc = 4 <= i ? n + i - 4 + 1 : n, _(t);
        }
        function g(t, e) {
            for(var r = 0; 0 < e--;)r |= k(t, 128) << e;
            return r;
        }
        function m(t, e) {
            var r = g(t, e);
            return P(t) ? -r : r;
        }
        function v(t, r, n, i) {
            var a, o = 0;
            for(e(null != t), e(null != r), e(4294967288 > i), t.Sb = i, t.Ra = 0, t.u = 0, t.h = 0, 4 < i && (i = 4), a = 0; a < i; ++a)o += r[n + a] << 8 * a;
            t.Ra = o, t.bb = i, t.oa = r, t.pa = n;
        }
        function b(t) {
            for(; 8 <= t.u && t.bb < t.Sb;)t.Ra >>>= 8, t.Ra += t.oa[t.pa + t.bb] << Tr - 8 >>> 0, ++t.bb, t.u -= 8;
            x(t) && (t.h = 1, t.u = 0);
        }
        function y(t, r) {
            if (e(0 <= r), !t.h && r <= Dr) {
                var n = L(t) & Rr[r];
                return t.u += r, b(t), n;
            }
            return t.h = 1, t.u = 0;
        }
        function w() {
            this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
        }
        function N() {
            this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
        }
        function L(t) {
            return t.Ra >>> (t.u & Tr - 1) >>> 0;
        }
        function x(t) {
            return e(t.bb <= t.Sb), t.h || t.bb == t.Sb && t.u > Tr;
        }
        function A(t, e) {
            t.u = e, t.h = x(t);
        }
        function S(t) {
            t.u >= zr && (e(t.u >= zr), b(t));
        }
        function _(t) {
            e(null != t && null != t.oa), t.pa < t.Zc ? (t.I = (t.oa[t.pa++] | t.I << 8) >>> 0, t.b += 8) : (e(null != t && null != t.oa), t.pa < t.Yc ? (t.b += 8, t.I = t.oa[t.pa++] | t.I << 8) : t.Ka ? t.b = 0 : (t.I <<= 8, t.b += 8, t.Ka = 1));
        }
        function P(t) {
            return g(t, 1);
        }
        function k(t, e) {
            var r = t.Ca;
            0 > t.b && _(t);
            var n = t.b, i = r * e >>> 8, a = (t.I >>> n > i) + 0;
            for(a ? (r -= i, t.I -= i + 1 << n >>> 0) : r = i + 1, n = r, i = 0; 256 <= n;)i += 8, n >>= 8;
            return n = 7 ^ i + Ur[n], t.b -= n, t.Ca = (r << n) - 1, a;
        }
        function F(t, e, r) {
            t[e + 0] = r >> 24 & 255, t[e + 1] = r >> 16 & 255, t[e + 2] = r >> 8 & 255, t[e + 3] = 255 & r;
        }
        function I(t, e) {
            return t[e + 0] | t[e + 1] << 8;
        }
        function C(t, e) {
            return I(t, e) | t[e + 2] << 16;
        }
        function j(t, e) {
            return I(t, e) | I(t, e + 2) << 16;
        }
        function O(t, r) {
            var n = 1 << r;
            return e(null != t), e(0 < r), t.X = a(n), null == t.X ? 0 : (t.Mb = 32 - r, t.Xa = r, 1);
        }
        function B(t, r) {
            e(null != t), e(null != r), e(t.Xa == r.Xa), n(r.X, 0, t.X, 0, 1 << r.Xa);
        }
        function M() {
            this.X = [], this.Xa = this.Mb = 0;
        }
        function q(t, r, n, i) {
            e(null != n), e(null != i);
            var a = n[0], o = i[0];
            return 0 == a && (a = (t * o + r / 2) / r), 0 == o && (o = (r * a + t / 2) / t), 0 >= a || 0 >= o ? 0 : (n[0] = a, i[0] = o, 1);
        }
        function E(t, e) {
            return t + (1 << e) - 1 >>> e;
        }
        function R(t, e) {
            return ((4278255360 & t) + (4278255360 & e) >>> 0 & 4278255360) + ((16711935 & t) + (16711935 & e) >>> 0 & 16711935) >>> 0;
        }
        function D(e, r) {
            t[r] = function(r, n, i, a, o, s, u) {
                var c;
                for(c = 0; c < o; ++c){
                    var l = t[e](s[u + c - 1], i, a + c);
                    s[u + c] = R(r[n + c], l);
                }
            };
        }
        function T() {
            this.ud = this.hd = this.jd = 0;
        }
        function z(t, e) {
            return ((4278124286 & (t ^ e)) >>> 1) + (t & e) >>> 0;
        }
        function U(t) {
            return 0 <= t && 256 > t ? t : 0 > t ? 0 : 255 < t ? 255 : void 0;
        }
        function H(t, e) {
            return U(t + (t - e + .5 >> 1));
        }
        function W(t, e, r) {
            return Math.abs(e - r) - Math.abs(t - r);
        }
        function V(t, e, r, n, i, a, o) {
            for(n = a[o - 1], r = 0; r < i; ++r)a[o + r] = n = R(t[e + r], n);
        }
        function G(t, e, r, n, i) {
            var a;
            for(a = 0; a < r; ++a){
                var o = t[e + a], s = o >> 8 & 255, u = 16711935 & (u = (u = 16711935 & o) + ((s << 16) + s));
                n[i + a] = (4278255360 & o) + u >>> 0;
            }
        }
        function Y(t, e) {
            e.jd = 255 & t, e.hd = t >> 8 & 255, e.ud = t >> 16 & 255;
        }
        function J(t, e, r, n, i, a) {
            var o;
            for(o = 0; o < n; ++o){
                var s = e[r + o], u = s >>> 8, c = s, l = 255 & (l = (l = s >>> 16) + ((t.jd << 24 >> 24) * (u << 24 >> 24) >>> 5));
                c = 255 & (c = (c += (t.hd << 24 >> 24) * (u << 24 >> 24) >>> 5) + ((t.ud << 24 >> 24) * (l << 24 >> 24) >>> 5)), i[a + o] = (4278255360 & s) + (l << 16) + c;
            }
        }
        function X(e, r, n, i, a) {
            t[r] = function(t, e, r, n, o, s, u, c, l) {
                for(n = u; n < c; ++n)for(u = 0; u < l; ++u)o[s++] = a(r[i(t[e++])]);
            }, t[e] = function(e, r, o, s, u, c, l) {
                var h = 8 >> e.b, f = e.Ea, d = e.K[0], p = e.w;
                if (8 > h) for(e = (1 << e.b) - 1, p = (1 << h) - 1; r < o; ++r){
                    var g, m = 0;
                    for(g = 0; g < f; ++g)g & e || (m = i(s[u++])), c[l++] = a(d[m & p]), m >>= h;
                }
                else t["VP8LMapColor" + n](s, u, d, p, c, l, r, o, f);
            };
        }
        function K(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = t[e++];
                n[i++] = a >> 16 & 255, n[i++] = a >> 8 & 255, n[i++] = 255 & a;
            }
        }
        function Z(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = t[e++];
                n[i++] = a >> 16 & 255, n[i++] = a >> 8 & 255, n[i++] = 255 & a, n[i++] = a >> 24 & 255;
            }
        }
        function $(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = (o = t[e++]) >> 16 & 240 | o >> 12 & 15, o = 240 & o | o >> 28 & 15;
                n[i++] = a, n[i++] = o;
            }
        }
        function Q(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = (o = t[e++]) >> 16 & 248 | o >> 13 & 7, o = o >> 5 & 224 | o >> 3 & 31;
                n[i++] = a, n[i++] = o;
            }
        }
        function tt(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = t[e++];
                n[i++] = 255 & a, n[i++] = a >> 8 & 255, n[i++] = a >> 16 & 255;
            }
        }
        function et(t, e, r, i, a, o) {
            if (0 == o) for(r = e + r; e < r;)F(i, ((o = t[e++])[0] >> 24 | o[1] >> 8 & 65280 | o[2] << 8 & 16711680 | o[3] << 24) >>> 0), a += 32;
            else n(i, a, t, e, r);
        }
        function rt(e, r) {
            t[r][0] = t[e + "0"], t[r][1] = t[e + "1"], t[r][2] = t[e + "2"], t[r][3] = t[e + "3"], t[r][4] = t[e + "4"], t[r][5] = t[e + "5"], t[r][6] = t[e + "6"], t[r][7] = t[e + "7"], t[r][8] = t[e + "8"], t[r][9] = t[e + "9"], t[r][10] = t[e + "10"], t[r][11] = t[e + "11"], t[r][12] = t[e + "12"], t[r][13] = t[e + "13"], t[r][14] = t[e + "0"], t[r][15] = t[e + "0"];
        }
        function nt(t) {
            return t == Un || t == Hn || t == Wn || t == Vn;
        }
        function it() {
            this.eb = [], this.size = this.A = this.fb = 0;
        }
        function at() {
            this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
        }
        function ot() {
            this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new it, this.f.kb = new at, this.sd = null;
        }
        function st() {
            this.width = [
                0
            ], this.height = [
                0
            ], this.Pd = [
                0
            ], this.Qd = [
                0
            ], this.format = [
                0
            ];
        }
        function ut() {
            this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
        }
        function ct(t) {
            return alert("todo:WebPSamplerProcessPlane"), t.T;
        }
        function lt(t, e) {
            var r = t.T, i = e.ba.f.RGBA, a = i.eb, o = i.fb + t.ka * i.A, s = mi[e.ba.S], u = t.y, c = t.O, l = t.f, h = t.N, f = t.ea, d = t.W, p = e.cc, g = e.dc, m = e.Mc, v = e.Nc, b = t.ka, y = t.ka + t.T, w = t.U, N = w + 1 >> 1;
            for(0 == b ? s(u, c, null, null, l, h, f, d, l, h, f, d, a, o, null, null, w) : (s(e.ec, e.fc, u, c, p, g, m, v, l, h, f, d, a, o - i.A, a, o, w), ++r); b + 2 < y; b += 2)p = l, g = h, m = f, v = d, h += t.Rc, d += t.Rc, o += 2 * i.A, s(u, (c += 2 * t.fa) - t.fa, u, c, p, g, m, v, l, h, f, d, a, o - i.A, a, o, w);
            return c += t.fa, t.j + y < t.o ? (n(e.ec, e.fc, u, c, w), n(e.cc, e.dc, l, h, N), n(e.Mc, e.Nc, f, d, N), r--) : 1 & y || s(u, c, null, null, l, h, f, d, l, h, f, d, a, o + i.A, null, null, w), r;
        }
        function ht(t, r, n) {
            var i = t.F, a = [
                t.J
            ];
            if (null != i) {
                var o = t.U, s = r.ba.S, u = s == Dn || s == Wn;
                r = r.ba.f.RGBA;
                var c = [
                    0
                ], l = t.ka;
                c[0] = t.T, t.Kb && (0 == l ? --c[0] : (--l, a[0] -= t.width), t.j + t.ka + t.T == t.o && (c[0] = t.o - t.j - l));
                var h = r.eb;
                l = r.fb + l * r.A, t = An(i, a[0], t.width, o, c, h, l + (u ? 0 : 3), r.A), e(n == c), t && nt(s) && Ln(h, l, u, o, c, r.A);
            }
            return 0;
        }
        function ft(t) {
            var e = t.ma, r = e.ba.S, n = 11 > r, i = r == qn || r == Rn || r == Dn || r == Tn || 12 == r || nt(r);
            if (e.memory = null, e.Ib = null, e.Jb = null, e.Nd = null, !Br(e.Oa, t, i ? 11 : 12)) return 0;
            if (i && nt(r) && vr(), t.da) alert("todo:use_scaling");
            else {
                if (n) {
                    if (e.Ib = ct, t.Kb) {
                        if (r = t.U + 1 >> 1, e.memory = a(t.U + 2 * r), null == e.memory) return 0;
                        e.ec = e.memory, e.fc = 0, e.cc = e.ec, e.dc = e.fc + t.U, e.Mc = e.cc, e.Nc = e.dc + r, e.Ib = lt, vr();
                    }
                } else alert("todo:EmitYUV");
                i && (e.Jb = ht, n && gr());
            }
            if (n && !Ii) {
                for(t = 0; 256 > t; ++t)Ci[t] = 89858 * (t - 128) + Si >> Ai, Bi[t] = -22014 * (t - 128) + Si, Oi[t] = -45773 * (t - 128), ji[t] = 113618 * (t - 128) + Si >> Ai;
                for(t = _i; t < Pi; ++t)e = 76283 * (t - 16) + Si >> Ai, Mi[t - _i] = Vt(e, 255), qi[t - _i] = Vt(e + 8 >> 4, 15);
                Ii = 1;
            }
            return 1;
        }
        function dt(t) {
            var r = t.ma, n = t.U, i = t.T;
            return e(!(1 & t.ka)), 0 >= n || 0 >= i ? 0 : (n = r.Ib(t, r), null != r.Jb && r.Jb(t, r, n), r.Dc += n, 1);
        }
        function pt(t) {
            t.ma.memory = null;
        }
        function gt(t, e, r, n) {
            return 47 != y(t, 8) ? 0 : (e[0] = y(t, 14) + 1, r[0] = y(t, 14) + 1, n[0] = y(t, 1), 0 != y(t, 3) ? 0 : !t.h);
        }
        function mt(t, e) {
            if (4 > t) return t + 1;
            var r = t - 2 >> 1;
            return (2 + (1 & t) << r) + y(e, r) + 1;
        }
        function vt(t, e) {
            var r;
            return 120 < e ? e - 120 : 1 <= (r = ((r = Zn[e - 1]) >> 4) * t + (8 - (15 & r))) ? r : 1;
        }
        function bt(t, e, r) {
            var n = L(r), i = t[e += 255 & n].g - 8;
            return 0 < i && (A(r, r.u + 8), n = L(r), e += t[e].value, e += n & (1 << i) - 1), A(r, r.u + t[e].g), t[e].value;
        }
        function yt(t, r, n) {
            return n.g += t.g, n.value += t.value << r >>> 0, e(8 >= n.g), t.g;
        }
        function wt(t, r, n) {
            var i = t.xc;
            return e((r = 0 == i ? 0 : t.vc[t.md * (n >> i) + (r >> i)]) < t.Wb), t.Ya[r];
        }
        function Nt(t, r, i, a) {
            var o = t.ab, s = t.c * r, u = t.C;
            r = u + r;
            var c = i, l = a;
            for(a = t.Ta, i = t.Ua; 0 < o--;){
                var h = t.gc[o], f = u, d = r, p = c, g = l, m = (l = a, c = i, h.Ea);
                switch(e(f < d), e(d <= h.nc), h.hc){
                    case 2:
                        Vr(p, g, (d - f) * m, l, c);
                        break;
                    case 0:
                        var v = f, b = d, y = l, w = c, N = (_ = h).Ea;
                        0 == v && (Hr(p, g, null, null, 1, y, w), V(p, g + 1, 0, 0, N - 1, y, w + 1), g += N, w += N, ++v);
                        for(var L = 1 << _.b, x = L - 1, A = E(N, _.b), S = _.K, _ = _.w + (v >> _.b) * A; v < b;){
                            var P = S, k = _, F = 1;
                            for(Wr(p, g, y, w - N, 1, y, w); F < N;){
                                var I = (F & ~x) + L;
                                I > N && (I = N), (0, Kr[P[k++] >> 8 & 15])(p, g + +F, y, w + F - N, I - F, y, w + F), F = I;
                            }
                            g += N, w += N, ++v & x || (_ += A);
                        }
                        d != h.nc && n(l, c - m, l, c + (d - f - 1) * m, m);
                        break;
                    case 1:
                        for(m = p, b = g, N = (p = h.Ea) - (w = p & ~(y = (g = 1 << h.b) - 1)), v = E(p, h.b), L = h.K, h = h.w + (f >> h.b) * v; f < d;){
                            for(x = L, A = h, S = new T, _ = b + w, P = b + p; b < _;)Y(x[A++], S), Zr(S, m, b, g, l, c), b += g, c += g;
                            b < P && (Y(x[A++], S), Zr(S, m, b, N, l, c), b += N, c += N), ++f & y || (h += v);
                        }
                        break;
                    case 3:
                        if (p == l && g == c && 0 < h.b) {
                            for(b = l, p = m = c + (d - f) * m - (w = (d - f) * E(h.Ea, h.b)), g = l, y = c, v = [], w = (N = w) - 1; 0 <= w; --w)v[w] = g[y + w];
                            for(w = N - 1; 0 <= w; --w)b[p + w] = v[w];
                            Gr(h, f, d, l, m, l, c);
                        } else Gr(h, f, d, p, g, l, c);
                }
                c = a, l = i;
            }
            l != i && n(a, i, c, l, s);
        }
        function Lt(t, r) {
            var n = t.V, i = t.Ba + t.c * t.C, a = r - t.C;
            if (e(r <= t.l.o), e(16 >= a), 0 < a) {
                var o = t.l, s = t.Ta, u = t.Ua, c = o.width;
                if (Nt(t, a, n, i), a = u = [
                    u
                ], e((n = t.C) < (i = r)), e(o.v < o.va), i > o.o && (i = o.o), n < o.j) {
                    var l = o.j - n;
                    n = o.j, a[0] += l * c;
                }
                if (n >= i ? n = 0 : (a[0] += 4 * o.v, o.ka = n - o.j, o.U = o.va - o.v, o.T = i - n, n = 1), n) {
                    if (u = u[0], 11 > (n = t.ca).S) {
                        var h = n.f.RGBA, f = (i = n.S, a = o.U, o = o.T, l = h.eb, h.A), d = o;
                        for(h = h.fb + t.Ma * h.A; 0 < d--;){
                            var p = s, g = u, m = a, v = l, b = h;
                            switch(i){
                                case Mn:
                                    $r(p, g, m, v, b);
                                    break;
                                case qn:
                                    Qr(p, g, m, v, b);
                                    break;
                                case Un:
                                    Qr(p, g, m, v, b), Ln(v, b, 0, m, 1, 0);
                                    break;
                                case En:
                                    rn(p, g, m, v, b);
                                    break;
                                case Rn:
                                    et(p, g, m, v, b, 1);
                                    break;
                                case Hn:
                                    et(p, g, m, v, b, 1), Ln(v, b, 0, m, 1, 0);
                                    break;
                                case Dn:
                                    et(p, g, m, v, b, 0);
                                    break;
                                case Wn:
                                    et(p, g, m, v, b, 0), Ln(v, b, 1, m, 1, 0);
                                    break;
                                case Tn:
                                    tn(p, g, m, v, b);
                                    break;
                                case Vn:
                                    tn(p, g, m, v, b), xn(v, b, m, 1, 0);
                                    break;
                                case zn:
                                    en(p, g, m, v, b);
                                    break;
                                default:
                                    e(0);
                            }
                            u += c, h += f;
                        }
                        t.Ma += o;
                    } else alert("todo:EmitRescaledRowsYUVA");
                    e(t.Ma <= n.height);
                }
            }
            t.C = r, e(t.C <= t.i);
        }
        function xt(t) {
            var e;
            if (0 < t.ua) return 0;
            for(e = 0; e < t.Wb; ++e){
                var r = t.Ya[e].G, n = t.Ya[e].H;
                if (0 < r[1][n[1] + 0].g || 0 < r[2][n[2] + 0].g || 0 < r[3][n[3] + 0].g) return 0;
            }
            return 1;
        }
        function At(t, r, n, i, a, o) {
            if (0 != t.Z) {
                var s = t.qd, u = t.rd;
                for(e(null != gi[t.Z]); r < n; ++r)gi[t.Z](s, u, i, a, i, a, o), s = i, u = a, a += o;
                t.qd = s, t.rd = u;
            }
        }
        function St(t, r) {
            var n = t.l.ma, i = 0 == n.Z || 1 == n.Z ? t.l.j : t.C;
            if (i = t.C < i ? i : t.C, e(r <= t.l.o), r > i) {
                var a = t.l.width, o = n.ca, s = n.tb + a * i, u = t.V, c = t.Ba + t.c * i, l = t.gc;
                e(1 == t.ab), e(3 == l[0].hc), Jr(l[0], i, r, u, c, o, s), At(n, i, r, o, s, a);
            }
            t.C = t.Ma = r;
        }
        function _t(t, r, n, i, a, o, s) {
            var u = t.$ / i, c = t.$ % i, l = t.m, h = t.s, f = n + t.$, d = f;
            a = n + i * a;
            var p = n + i * o, g = 280 + h.ua, m = t.Pb ? u : 16777216, v = 0 < h.ua ? h.Wa : null, b = h.wc, y = f < p ? wt(h, c, u) : null;
            e(t.C < o), e(p <= a);
            var w = !1;
            t: for(;;){
                for(; w || f < p;){
                    var N = 0;
                    if (u >= m) {
                        var _ = f - n;
                        e((m = t).Pb), m.wd = m.m, m.xd = _, 0 < m.s.ua && B(m.s.Wa, m.s.vb), m = u + Qn;
                    }
                    if (c & b || (y = wt(h, c, u)), e(null != y), y.Qb && (r[f] = y.qb, w = !0), !w) {
                        if (S(l), y.jc) {
                            N = l, _ = r;
                            var P = f, k = y.pd[L(N) & Er - 1];
                            e(y.jc), 256 > k.g ? (A(N, N.u + k.g), _[P] = k.value, N = 0) : (A(N, N.u + k.g - 256), e(256 <= k.value), N = k.value), 0 == N && (w = !0);
                        } else N = bt(y.G[0], y.H[0], l);
                    }
                    if (l.h) break;
                    if (w || 256 > N) {
                        if (!w) {
                            if (y.nd) r[f] = (y.qb | N << 8) >>> 0;
                            else {
                                if (S(l), w = bt(y.G[1], y.H[1], l), S(l), _ = bt(y.G[2], y.H[2], l), P = bt(y.G[3], y.H[3], l), l.h) break;
                                r[f] = (P << 24 | w << 16 | N << 8 | _) >>> 0;
                            }
                        }
                        if (w = !1, ++f, ++c >= i && (c = 0, ++u, null != s && u <= o && !(u % 16) && s(t, u), null != v)) for(; d < f;)N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else if (280 > N) {
                        if (N = mt(N - 256, l), _ = bt(y.G[4], y.H[4], l), S(l), _ = vt(i, _ = mt(_, l)), l.h) break;
                        if (f - n < _ || a - f < N) break t;
                        for(P = 0; P < N; ++P)r[f + P] = r[f + P - _];
                        for(f += N, c += N; c >= i;)c -= i, ++u, null != s && u <= o && !(u % 16) && s(t, u);
                        if (e(f <= a), c & b && (y = wt(h, c, u)), null != v) for(; d < f;)N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else {
                        if (!(N < g)) break t;
                        for(w = N - 280, e(null != v); d < f;)N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                        N = f, e(!(w >>> (_ = v).Xa)), r[N] = _.X[w], w = !0;
                    }
                    w || e(l.h == x(l));
                }
                if (t.Pb && l.h && f < a) e(t.m.h), t.a = 5, t.m = t.wd, t.$ = t.xd, 0 < t.s.ua && B(t.s.vb, t.s.Wa);
                else {
                    if (l.h) break t;
                    null != s && s(t, u > o ? o : u), t.a = 0, t.$ = f - n;
                }
                return 1;
            }
            return t.a = 3, 0;
        }
        function Pt(t) {
            e(null != t), t.vc = null, t.yc = null, t.Ya = null;
            var r = t.Wa;
            null != r && (r.X = null), t.vb = null, e(null != t);
        }
        function kt() {
            var e = new ar;
            return null == e ? null : (e.a = 0, e.xb = pi, rt("Predictor", "VP8LPredictors"), rt("Predictor", "VP8LPredictors_C"), rt("PredictorAdd", "VP8LPredictorsAdd"), rt("PredictorAdd", "VP8LPredictorsAdd_C"), Vr = G, Zr = J, $r = K, Qr = Z, tn = $, en = Q, rn = tt, t.VP8LMapColor32b = Yr, t.VP8LMapColor8b = Xr, e);
        }
        function Ft(t, r, n, s, u) {
            var c = 1, f = [
                t
            ], p = [
                r
            ], g = s.m, m = s.s, v = null, b = 0;
            t: for(;;){
                if (n) for(; c && y(g, 1);){
                    var w = f, N = p, x = s, _ = 1, P = x.m, k = x.gc[x.ab], F = y(P, 2);
                    if (x.Oc & 1 << F) c = 0;
                    else {
                        switch(x.Oc |= 1 << F, k.hc = F, k.Ea = w[0], k.nc = N[0], k.K = [
                            null
                        ], ++x.ab, e(4 >= x.ab), F){
                            case 0:
                            case 1:
                                k.b = y(P, 3) + 2, _ = Ft(E(k.Ea, k.b), E(k.nc, k.b), 0, x, k.K), k.K = k.K[0];
                                break;
                            case 3:
                                var I, C = y(P, 8) + 1, j = 16 < C ? 0 : 4 < C ? 1 : 2 < C ? 2 : 3;
                                if (w[0] = E(k.Ea, j), k.b = j, I = _ = Ft(C, 1, 0, x, k.K)) {
                                    var B, M = C, q = k, D = 1 << (8 >> q.b), T = a(D);
                                    if (null == T) I = 0;
                                    else {
                                        var z = q.K[0], U = q.w;
                                        for(T[0] = q.K[0][0], B = 1; B < 1 * M; ++B)T[B] = R(z[U + B], T[B - 1]);
                                        for(; B < 4 * D; ++B)T[B] = 0;
                                        q.K[0] = null, q.K[0] = T, I = 1;
                                    }
                                }
                                _ = I;
                                break;
                            case 2:
                                break;
                            default:
                                e(0);
                        }
                        c = _;
                    }
                }
                if (f = f[0], p = p[0], c && y(g, 1) && !(c = 1 <= (b = y(g, 4)) && 11 >= b)) {
                    s.a = 3;
                    break t;
                }
                var H;
                if (H = c) e: {
                    var W, V, G, Y = s, J = f, X = p, K = b, Z = n, $ = Y.m, Q = Y.s, tt = [
                        null
                    ], et = 1, rt = 0, nt = $n[K];
                    r: for(;;){
                        if (Z && y($, 1)) {
                            var it = y($, 3) + 2, at = E(J, it), ot = E(X, it), st = at * ot;
                            if (!Ft(at, ot, 0, Y, tt)) break r;
                            for(tt = tt[0], Q.xc = it, W = 0; W < st; ++W){
                                var ut = tt[W] >> 8 & 65535;
                                tt[W] = ut, ut >= et && (et = ut + 1);
                            }
                        }
                        if ($.h) break r;
                        for(V = 0; 5 > V; ++V){
                            var ct = Jn[V];
                            !V && 0 < K && (ct += 1 << K), rt < ct && (rt = ct);
                        }
                        var lt = o(et * nt, h), ht = et, ft = o(ht, d);
                        if (null == ft) var dt = null;
                        else e(65536 >= ht), dt = ft;
                        var pt = a(rt);
                        if (null == dt || null == pt || null == lt) {
                            Y.a = 1;
                            break r;
                        }
                        var gt = lt;
                        for(W = G = 0; W < et; ++W){
                            var mt = dt[W], vt = mt.G, bt = mt.H, wt = 0, Nt = 1, Lt = 0;
                            for(V = 0; 5 > V; ++V){
                                ct = Jn[V], vt[V] = gt, bt[V] = G, !V && 0 < K && (ct += 1 << K);
                                n: {
                                    var xt, At = ct, St = Y, kt = pt, It = gt, Ct = G, jt = 0, Ot = St.m, Bt = y(Ot, 1);
                                    if (i(kt, 0, 0, At), Bt) {
                                        var Mt = y(Ot, 1) + 1, qt = y(Ot, 1), Et = y(Ot, 0 == qt ? 1 : 8);
                                        kt[Et] = 1, 2 == Mt && (kt[Et = y(Ot, 8)] = 1);
                                        var Rt = 1;
                                    } else {
                                        var Dt = a(19), Tt = y(Ot, 4) + 4;
                                        if (19 < Tt) {
                                            St.a = 3;
                                            var zt = 0;
                                            break n;
                                        }
                                        for(xt = 0; xt < Tt; ++xt)Dt[Kn[xt]] = y(Ot, 3);
                                        var Ut = void 0, Ht = void 0, Wt = St, Vt = Dt, Gt = At, Yt = kt, Jt = 0, Xt = Wt.m, Kt = 8, Zt = o(128, h);
                                        i: for(; l(Zt, 0, 7, Vt, 19);){
                                            if (y(Xt, 1)) {
                                                var $t = 2 + 2 * y(Xt, 3);
                                                if ((Ut = 2 + y(Xt, $t)) > Gt) break i;
                                            } else Ut = Gt;
                                            for(Ht = 0; Ht < Gt && Ut--;){
                                                S(Xt);
                                                var Qt = Zt[0 + (127 & L(Xt))];
                                                A(Xt, Xt.u + Qt.g);
                                                var te = Qt.value;
                                                if (16 > te) Yt[Ht++] = te, 0 != te && (Kt = te);
                                                else {
                                                    var ee = 16 == te, re = te - 16, ne = Yn[re], ie = y(Xt, Gn[re]) + ne;
                                                    if (Ht + ie > Gt) break i;
                                                    for(var ae = ee ? Kt : 0; 0 < ie--;)Yt[Ht++] = ae;
                                                }
                                            }
                                            Jt = 1;
                                            break i;
                                        }
                                        Jt || (Wt.a = 3), Rt = Jt;
                                    }
                                    (Rt = Rt && !Ot.h) && (jt = l(It, Ct, 8, kt, At)), Rt && 0 != jt ? zt = jt : (St.a = 3, zt = 0);
                                }
                                if (0 == zt) break r;
                                if (Nt && 1 == Xn[V] && (Nt = 0 == gt[G].g), wt += gt[G].g, G += zt, 3 >= V) {
                                    var oe, se = pt[0];
                                    for(oe = 1; oe < ct; ++oe)pt[oe] > se && (se = pt[oe]);
                                    Lt += se;
                                }
                            }
                            if (mt.nd = Nt, mt.Qb = 0, Nt && (mt.qb = (vt[3][bt[3] + 0].value << 24 | vt[1][bt[1] + 0].value << 16 | vt[2][bt[2] + 0].value) >>> 0, 0 == wt && 256 > vt[0][bt[0] + 0].value && (mt.Qb = 1, mt.qb += vt[0][bt[0] + 0].value << 8)), mt.jc = !mt.Qb && 6 > Lt, mt.jc) {
                                var ue, ce = mt;
                                for(ue = 0; ue < Er; ++ue){
                                    var le = ue, he = ce.pd[le], fe = ce.G[0][ce.H[0] + le];
                                    256 <= fe.value ? (he.g = fe.g + 256, he.value = fe.value) : (he.g = 0, he.value = 0, le >>= yt(fe, 8, he), le >>= yt(ce.G[1][ce.H[1] + le], 16, he), le >>= yt(ce.G[2][ce.H[2] + le], 0, he), yt(ce.G[3][ce.H[3] + le], 24, he));
                                }
                            }
                        }
                        Q.vc = tt, Q.Wb = et, Q.Ya = dt, Q.yc = lt, H = 1;
                        break e;
                    }
                    H = 0;
                }
                if (!(c = H)) {
                    s.a = 3;
                    break t;
                }
                if (0 < b) {
                    if (m.ua = 1 << b, !O(m.Wa, b)) {
                        s.a = 1, c = 0;
                        break t;
                    }
                } else m.ua = 0;
                var de = s, pe = f, ge = p, me = de.s, ve = me.xc;
                if (de.c = pe, de.i = ge, me.md = E(pe, ve), me.wc = 0 == ve ? -1 : (1 << ve) - 1, n) {
                    s.xb = di;
                    break t;
                }
                if (null == (v = a(f * p))) {
                    s.a = 1, c = 0;
                    break t;
                }
                c = (c = _t(s, v, 0, f, p, p, null)) && !g.h;
                break t;
            }
            return c ? (null != u ? u[0] = v : (e(null == v), e(n)), s.$ = 0, n || Pt(m)) : Pt(m), c;
        }
        function It(t, r) {
            var n = t.c * t.i, i = n + r + 16 * r;
            return e(t.c <= r), t.V = a(i), null == t.V ? (t.Ta = null, t.Ua = 0, t.a = 1, 0) : (t.Ta = t.V, t.Ua = t.Ba + n + r, 1);
        }
        function Ct(t, r) {
            var n = t.C, i = r - n, a = t.V, o = t.Ba + t.c * n;
            for(e(r <= t.l.o); 0 < i;){
                var s = 16 < i ? 16 : i, u = t.l.ma, c = t.l.width, l = c * s, h = u.ca, f = u.tb + c * n, d = t.Ta, p = t.Ua;
                Nt(t, s, a, o), Sn(d, p, h, f, l), At(u, n, n + s, h, f, c), i -= s, a += s * t.c, n += s;
            }
            e(n == r), t.C = t.Ma = r;
        }
        function jt() {
            this.ub = this.yd = this.td = this.Rb = 0;
        }
        function Ot() {
            this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
        }
        function Bt() {
            this.Fb = this.Bb = this.Cb = 0, this.Zb = a(4), this.Lb = a(4);
        }
        function Mt() {
            this.Yb = function() {
                var t = [];
                return function t(e, r, n) {
                    for(var i = n[r], a = 0; a < i && (e.push(n.length > r + 1 ? [] : 0), !(n.length < r + 1)); a++)t(e[a], r + 1, n);
                }(t, 0, [
                    3,
                    11
                ]), t;
            }();
        }
        function qt() {
            this.jb = a(3), this.Wc = s([
                4,
                8
            ], Mt), this.Xc = s([
                4,
                17
            ], Mt);
        }
        function Et() {
            this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new a(4), this.od = new a(4);
        }
        function Rt() {
            this.ld = this.La = this.dd = this.tc = 0;
        }
        function Dt() {
            this.Na = this.la = 0;
        }
        function Tt() {
            this.Sc = [
                0,
                0
            ], this.Eb = [
                0,
                0
            ], this.Qc = [
                0,
                0
            ], this.ia = this.lc = 0;
        }
        function zt() {
            this.ad = a(384), this.Za = 0, this.Ob = a(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
        }
        function Ut() {
            this.uc = this.M = this.Nb = 0, this.wa = Array(new Rt), this.Y = 0, this.ya = Array(new zt), this.aa = 0, this.l = new Gt;
        }
        function Ht() {
            this.y = a(16), this.f = a(8), this.ea = a(8);
        }
        function Wt() {
            this.cb = this.a = 0, this.sc = "", this.m = new w, this.Od = new jt, this.Kc = new Ot, this.ed = new Et, this.Qa = new Bt, this.Ic = this.$c = this.Aa = 0, this.D = new Ut, this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = o(8, w), this.ia = 0, this.pb = o(4, Tt), this.Pa = new qt, this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [
                0,
                0,
                0,
                0
            ], this.Gd = Array(new Ht), this.Hd = 0, this.rb = Array(new Dt), this.sb = 0, this.wa = Array(new Rt), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new zt), this.L = this.aa = 0, this.gd = s([
                4,
                2
            ], Rt), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
        }
        function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        }
        function Gt() {
            this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
        }
        function Yt() {
            var t = new Wt;
            return null != t && (t.a = 0, t.sc = "OK", t.cb = 0, t.Xb = 0, ri || (ri = Zt)), t;
        }
        function Jt(t, e, r) {
            return 0 == t.a && (t.a = e, t.sc = r, t.cb = 0), 0;
        }
        function Xt(t, e, r) {
            return 3 <= r && 157 == t[e + 0] && 1 == t[e + 1] && 42 == t[e + 2];
        }
        function Kt(t, r) {
            if (null == t) return 0;
            if (t.a = 0, t.sc = "OK", null == r) return Jt(t, 2, "null VP8Io passed to VP8GetHeaders()");
            var n = r.data, a = r.w, o = r.ha;
            if (4 > o) return Jt(t, 7, "Truncated header.");
            var s = n[a + 0] | n[a + 1] << 8 | n[a + 2] << 16, u = t.Od;
            if (u.Rb = !(1 & s), u.td = s >> 1 & 7, u.yd = s >> 4 & 1, u.ub = s >> 5, 3 < u.td) return Jt(t, 3, "Incorrect keyframe parameters.");
            if (!u.yd) return Jt(t, 4, "Frame not displayable.");
            a += 3, o -= 3;
            var c = t.Kc;
            if (u.Rb) {
                if (7 > o) return Jt(t, 7, "cannot parse picture header");
                if (!Xt(n, a, o)) return Jt(t, 3, "Bad code word");
                c.c = 16383 & (n[a + 4] << 8 | n[a + 3]), c.Td = n[a + 4] >> 6, c.i = 16383 & (n[a + 6] << 8 | n[a + 5]), c.Ud = n[a + 6] >> 6, a += 7, o -= 7, t.za = c.c + 15 >> 4, t.Ub = c.i + 15 >> 4, r.width = c.c, r.height = c.i, r.Da = 0, r.j = 0, r.v = 0, r.va = r.width, r.o = r.height, r.da = 0, r.ib = r.width, r.hb = r.height, r.U = r.width, r.T = r.height, i((s = t.Pa).jb, 0, 255, s.jb.length), e(null != (s = t.Qa)), s.Cb = 0, s.Bb = 0, s.Fb = 1, i(s.Zb, 0, 0, s.Zb.length), i(s.Lb, 0, 0, s.Lb);
            }
            if (u.ub > o) return Jt(t, 7, "bad partition length");
            p(s = t.m, n, a, u.ub), a += u.ub, o -= u.ub, u.Rb && (c.Ld = P(s), c.Kd = P(s)), c = t.Qa;
            var l, h = t.Pa;
            if (e(null != s), e(null != c), c.Cb = P(s), c.Cb) {
                if (c.Bb = P(s), P(s)) {
                    for(c.Fb = P(s), l = 0; 4 > l; ++l)c.Zb[l] = P(s) ? m(s, 7) : 0;
                    for(l = 0; 4 > l; ++l)c.Lb[l] = P(s) ? m(s, 6) : 0;
                }
                if (c.Bb) for(l = 0; 3 > l; ++l)h.jb[l] = P(s) ? g(s, 8) : 255;
            } else c.Bb = 0;
            if (s.Ka) return Jt(t, 3, "cannot parse segment header");
            if ((c = t.ed).zd = P(s), c.Tb = g(s, 6), c.wb = g(s, 3), c.Pc = P(s), c.Pc && P(s)) {
                for(h = 0; 4 > h; ++h)P(s) && (c.vd[h] = m(s, 6));
                for(h = 0; 4 > h; ++h)P(s) && (c.od[h] = m(s, 6));
            }
            if (t.L = 0 == c.Tb ? 0 : c.zd ? 1 : 2, s.Ka) return Jt(t, 3, "cannot parse filter header");
            var f = o;
            if (o = l = a, a = l + f, c = f, t.Xb = (1 << g(t.m, 2)) - 1, f < 3 * (h = t.Xb)) n = 7;
            else {
                for(l += 3 * h, c -= 3 * h, f = 0; f < h; ++f){
                    var d = n[o + 0] | n[o + 1] << 8 | n[o + 2] << 16;
                    d > c && (d = c), p(t.Jc[+f], n, l, d), l += d, c -= d, o += 3;
                }
                p(t.Jc[+h], n, l, c), n = l < a ? 0 : 5;
            }
            if (0 != n) return Jt(t, n, "cannot parse partitions");
            for(n = g(l = t.m, 7), o = P(l) ? m(l, 4) : 0, a = P(l) ? m(l, 4) : 0, c = P(l) ? m(l, 4) : 0, h = P(l) ? m(l, 4) : 0, l = P(l) ? m(l, 4) : 0, f = t.Qa, d = 0; 4 > d; ++d){
                if (f.Cb) {
                    var v = f.Zb[d];
                    f.Fb || (v += n);
                } else {
                    if (0 < d) {
                        t.pb[d] = t.pb[0];
                        continue;
                    }
                    v = n;
                }
                var b = t.pb[d];
                b.Sc[0] = ti[Vt(v + o, 127)], b.Sc[1] = ei[Vt(v + 0, 127)], b.Eb[0] = 2 * ti[Vt(v + a, 127)], b.Eb[1] = 101581 * ei[Vt(v + c, 127)] >> 16, 8 > b.Eb[1] && (b.Eb[1] = 8), b.Qc[0] = ti[Vt(v + h, 117)], b.Qc[1] = ei[Vt(v + l, 127)], b.lc = v + l;
            }
            if (!u.Rb) return Jt(t, 4, "Not a key frame.");
            for(P(s), u = t.Pa, n = 0; 4 > n; ++n){
                for(o = 0; 8 > o; ++o)for(a = 0; 3 > a; ++a)for(c = 0; 11 > c; ++c)h = k(s, ui[n][o][a][c]) ? g(s, 8) : oi[n][o][a][c], u.Wc[n][o].Yb[a][c] = h;
                for(o = 0; 17 > o; ++o)u.Xc[n][o] = u.Wc[n][ci[o]];
            }
            return t.kc = P(s), t.kc && (t.Bd = g(s, 8)), t.cb = 1;
        }
        function Zt(t, e, r, n, i, a, o) {
            var s = e[i].Yb[r];
            for(r = 0; 16 > i; ++i){
                if (!k(t, s[r + 0])) return i;
                for(; !k(t, s[r + 1]);)if (s = e[++i].Yb[0], r = 0, 16 == i) return 16;
                var u = e[i + 1].Yb;
                if (k(t, s[r + 2])) {
                    var c = t, l = 0;
                    if (k(c, (f = s)[(h = r) + 3])) {
                        if (k(c, f[h + 6])) {
                            for(s = 0, h = 2 * (l = k(c, f[h + 8])) + (f = k(c, f[h + 9 + l])), l = 0, f = ni[h]; f[s]; ++s)l += l + k(c, f[s]);
                            l += 3 + (8 << h);
                        } else k(c, f[h + 7]) ? (l = 7 + 2 * k(c, 165), l += k(c, 145)) : l = 5 + k(c, 159);
                    } else l = k(c, f[h + 4]) ? 3 + k(c, f[h + 5]) : 2;
                    s = u[2];
                } else l = 1, s = u[1];
                u = o + ii[i], 0 > (c = t).b && _(c);
                var h, f = c.b, d = (h = c.Ca >> 1) - (c.I >> f) >> 31;
                --c.b, c.Ca += d, c.Ca |= 1, c.I -= (h + 1 & d) << f, a[u] = ((l ^ d) - d) * n[(0 < i) + 0];
            }
            return 16;
        }
        function $t(t) {
            var e = t.rb[t.sb - 1];
            e.la = 0, e.Na = 0, i(t.zc, 0, 0, t.zc.length), t.ja = 0;
        }
        function Qt(t, e, r, n, i) {
            i = t[e + r + 32 * n] + (i >> 3), t[e + r + 32 * n] = -256 & i ? 0 > i ? 0 : 255 : i;
        }
        function te(t, e, r, n, i, a) {
            Qt(t, e, 0, r, n + i), Qt(t, e, 1, r, n + a), Qt(t, e, 2, r, n - a), Qt(t, e, 3, r, n - i);
        }
        function ee(t) {
            return (20091 * t >> 16) + t;
        }
        function re(t, e, r, n) {
            var i, o = 0, s = a(16);
            for(i = 0; 4 > i; ++i){
                var u = t[e + 0] + t[e + 8], c = t[e + 0] - t[e + 8], l = (35468 * t[e + 4] >> 16) - ee(t[e + 12]), h = ee(t[e + 4]) + (35468 * t[e + 12] >> 16);
                s[o + 0] = u + h, s[o + 1] = c + l, s[o + 2] = c - l, s[o + 3] = u - h, o += 4, e++;
            }
            for(i = o = 0; 4 > i; ++i)u = (t = s[o + 0] + 4) + s[o + 8], c = t - s[o + 8], l = (35468 * s[o + 4] >> 16) - ee(s[o + 12]), Qt(r, n, 0, 0, u + (h = ee(s[o + 4]) + (35468 * s[o + 12] >> 16))), Qt(r, n, 1, 0, c + l), Qt(r, n, 2, 0, c - l), Qt(r, n, 3, 0, u - h), o++, n += 32;
        }
        function ne(t, e, r, n) {
            var i = t[e + 0] + 4, a = 35468 * t[e + 4] >> 16, o = ee(t[e + 4]), s = 35468 * t[e + 1] >> 16;
            te(r, n, 0, i + o, t = ee(t[e + 1]), s), te(r, n, 1, i + a, t, s), te(r, n, 2, i - a, t, s), te(r, n, 3, i - o, t, s);
        }
        function ie(t, e, r, n, i) {
            re(t, e, r, n), i && re(t, e + 16, r, n + 4);
        }
        function ae(t, e, r, n) {
            an(t, e + 0, r, n, 1), an(t, e + 32, r, n + 128, 1);
        }
        function oe(t, e, r, n) {
            var i;
            for(t = t[e + 0] + 4, i = 0; 4 > i; ++i)for(e = 0; 4 > e; ++e)Qt(r, n, e, i, t);
        }
        function se(t, e, r, n) {
            t[e + 0] && un(t, e + 0, r, n), t[e + 16] && un(t, e + 16, r, n + 4), t[e + 32] && un(t, e + 32, r, n + 128), t[e + 48] && un(t, e + 48, r, n + 128 + 4);
        }
        function ue(t, e, r, n) {
            var i, o = a(16);
            for(i = 0; 4 > i; ++i){
                var s = t[e + 0 + i] + t[e + 12 + i], u = t[e + 4 + i] + t[e + 8 + i], c = t[e + 4 + i] - t[e + 8 + i], l = t[e + 0 + i] - t[e + 12 + i];
                o[0 + i] = s + u, o[8 + i] = s - u, o[4 + i] = l + c, o[12 + i] = l - c;
            }
            for(i = 0; 4 > i; ++i)s = (t = o[0 + 4 * i] + 3) + o[3 + 4 * i], u = o[1 + 4 * i] + o[2 + 4 * i], c = o[1 + 4 * i] - o[2 + 4 * i], l = t - o[3 + 4 * i], r[n + 0] = s + u >> 3, r[n + 16] = l + c >> 3, r[n + 32] = s - u >> 3, r[n + 48] = l - c >> 3, n += 64;
        }
        function ce(t, e, r) {
            var n, i = e - 32, a = On, o = 255 - t[i - 1];
            for(n = 0; n < r; ++n){
                var s, u = a, c = o + t[e - 1];
                for(s = 0; s < r; ++s)t[e + s] = u[c + t[i + s]];
                e += 32;
            }
        }
        function le(t, e) {
            ce(t, e, 4);
        }
        function he(t, e) {
            ce(t, e, 8);
        }
        function fe(t, e) {
            ce(t, e, 16);
        }
        function de(t, e) {
            var r;
            for(r = 0; 16 > r; ++r)n(t, e + 32 * r, t, e - 32, 16);
        }
        function pe(t, e) {
            var r;
            for(r = 16; 0 < r; --r)i(t, e, t[e - 1], 16), e += 32;
        }
        function ge(t, e, r) {
            var n;
            for(n = 0; 16 > n; ++n)i(e, r + 32 * n, t, 16);
        }
        function me(t, e) {
            var r, n = 16;
            for(r = 0; 16 > r; ++r)n += t[e - 1 + 32 * r] + t[e + r - 32];
            ge(n >> 5, t, e);
        }
        function ve(t, e) {
            var r, n = 8;
            for(r = 0; 16 > r; ++r)n += t[e - 1 + 32 * r];
            ge(n >> 4, t, e);
        }
        function be(t, e) {
            var r, n = 8;
            for(r = 0; 16 > r; ++r)n += t[e + r - 32];
            ge(n >> 4, t, e);
        }
        function ye(t, e) {
            ge(128, t, e);
        }
        function we(t, e, r) {
            return t + 2 * e + r + 2 >> 2;
        }
        function Ne(t, e) {
            var r, i = e - 32;
            for(i = new Uint8Array([
                we(t[i - 1], t[i + 0], t[i + 1]),
                we(t[i + 0], t[i + 1], t[i + 2]),
                we(t[i + 1], t[i + 2], t[i + 3]),
                we(t[i + 2], t[i + 3], t[i + 4])
            ]), r = 0; 4 > r; ++r)n(t, e + 32 * r, i, 0, i.length);
        }
        function Le(t, e) {
            var r = t[e - 1], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
            F(t, e + 0, 16843009 * we(t[e - 1 - 32], r, n)), F(t, e + 32, 16843009 * we(r, n, i)), F(t, e + 64, 16843009 * we(n, i, a)), F(t, e + 96, 16843009 * we(i, a, a));
        }
        function xe(t, e) {
            var r, n = 4;
            for(r = 0; 4 > r; ++r)n += t[e + r - 32] + t[e - 1 + 32 * r];
            for(n >>= 3, r = 0; 4 > r; ++r)i(t, e + 32 * r, n, 4);
        }
        function Ae(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], u = t[e + 2 - 32], c = t[e + 3 - 32];
            t[e + 0 + 96] = we(n, i, t[e - 1 + 96]), t[e + 1 + 96] = t[e + 0 + 64] = we(r, n, i), t[e + 2 + 96] = t[e + 1 + 64] = t[e + 0 + 32] = we(a, r, n), t[e + 3 + 96] = t[e + 2 + 64] = t[e + 1 + 32] = t[e + 0 + 0] = we(o, a, r), t[e + 3 + 64] = t[e + 2 + 32] = t[e + 1 + 0] = we(s, o, a), t[e + 3 + 32] = t[e + 2 + 0] = we(u, s, o), t[e + 3 + 0] = we(c, u, s);
        }
        function Se(t, e) {
            var r = t[e + 1 - 32], n = t[e + 2 - 32], i = t[e + 3 - 32], a = t[e + 4 - 32], o = t[e + 5 - 32], s = t[e + 6 - 32], u = t[e + 7 - 32];
            t[e + 0 + 0] = we(t[e + 0 - 32], r, n), t[e + 1 + 0] = t[e + 0 + 32] = we(r, n, i), t[e + 2 + 0] = t[e + 1 + 32] = t[e + 0 + 64] = we(n, i, a), t[e + 3 + 0] = t[e + 2 + 32] = t[e + 1 + 64] = t[e + 0 + 96] = we(i, a, o), t[e + 3 + 32] = t[e + 2 + 64] = t[e + 1 + 96] = we(a, o, s), t[e + 3 + 64] = t[e + 2 + 96] = we(o, s, u), t[e + 3 + 96] = we(s, u, u);
        }
        function _e(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], u = t[e + 2 - 32], c = t[e + 3 - 32];
            t[e + 0 + 0] = t[e + 1 + 64] = a + o + 1 >> 1, t[e + 1 + 0] = t[e + 2 + 64] = o + s + 1 >> 1, t[e + 2 + 0] = t[e + 3 + 64] = s + u + 1 >> 1, t[e + 3 + 0] = u + c + 1 >> 1, t[e + 0 + 96] = we(i, n, r), t[e + 0 + 64] = we(n, r, a), t[e + 0 + 32] = t[e + 1 + 96] = we(r, a, o), t[e + 1 + 32] = t[e + 2 + 96] = we(a, o, s), t[e + 2 + 32] = t[e + 3 + 96] = we(o, s, u), t[e + 3 + 32] = we(s, u, c);
        }
        function Pe(t, e) {
            var r = t[e + 0 - 32], n = t[e + 1 - 32], i = t[e + 2 - 32], a = t[e + 3 - 32], o = t[e + 4 - 32], s = t[e + 5 - 32], u = t[e + 6 - 32], c = t[e + 7 - 32];
            t[e + 0 + 0] = r + n + 1 >> 1, t[e + 1 + 0] = t[e + 0 + 64] = n + i + 1 >> 1, t[e + 2 + 0] = t[e + 1 + 64] = i + a + 1 >> 1, t[e + 3 + 0] = t[e + 2 + 64] = a + o + 1 >> 1, t[e + 0 + 32] = we(r, n, i), t[e + 1 + 32] = t[e + 0 + 96] = we(n, i, a), t[e + 2 + 32] = t[e + 1 + 96] = we(i, a, o), t[e + 3 + 32] = t[e + 2 + 96] = we(a, o, s), t[e + 3 + 64] = we(o, s, u), t[e + 3 + 96] = we(s, u, c);
        }
        function ke(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
            t[e + 0 + 0] = r + n + 1 >> 1, t[e + 2 + 0] = t[e + 0 + 32] = n + i + 1 >> 1, t[e + 2 + 32] = t[e + 0 + 64] = i + a + 1 >> 1, t[e + 1 + 0] = we(r, n, i), t[e + 3 + 0] = t[e + 1 + 32] = we(n, i, a), t[e + 3 + 32] = t[e + 1 + 64] = we(i, a, a), t[e + 3 + 64] = t[e + 2 + 64] = t[e + 0 + 96] = t[e + 1 + 96] = t[e + 2 + 96] = t[e + 3 + 96] = a;
        }
        function Fe(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96], o = t[e - 1 - 32], s = t[e + 0 - 32], u = t[e + 1 - 32], c = t[e + 2 - 32];
            t[e + 0 + 0] = t[e + 2 + 32] = r + o + 1 >> 1, t[e + 0 + 32] = t[e + 2 + 64] = n + r + 1 >> 1, t[e + 0 + 64] = t[e + 2 + 96] = i + n + 1 >> 1, t[e + 0 + 96] = a + i + 1 >> 1, t[e + 3 + 0] = we(s, u, c), t[e + 2 + 0] = we(o, s, u), t[e + 1 + 0] = t[e + 3 + 32] = we(r, o, s), t[e + 1 + 32] = t[e + 3 + 64] = we(n, r, o), t[e + 1 + 64] = t[e + 3 + 96] = we(i, n, r), t[e + 1 + 96] = we(a, i, n);
        }
        function Ie(t, e) {
            var r;
            for(r = 0; 8 > r; ++r)n(t, e + 32 * r, t, e - 32, 8);
        }
        function Ce(t, e) {
            var r;
            for(r = 0; 8 > r; ++r)i(t, e, t[e - 1], 8), e += 32;
        }
        function je(t, e, r) {
            var n;
            for(n = 0; 8 > n; ++n)i(e, r + 32 * n, t, 8);
        }
        function Oe(t, e) {
            var r, n = 8;
            for(r = 0; 8 > r; ++r)n += t[e + r - 32] + t[e - 1 + 32 * r];
            je(n >> 4, t, e);
        }
        function Be(t, e) {
            var r, n = 4;
            for(r = 0; 8 > r; ++r)n += t[e + r - 32];
            je(n >> 3, t, e);
        }
        function Me(t, e) {
            var r, n = 4;
            for(r = 0; 8 > r; ++r)n += t[e - 1 + 32 * r];
            je(n >> 3, t, e);
        }
        function qe(t, e) {
            je(128, t, e);
        }
        function Ee(t, e, r) {
            var n = t[e - r], i = t[e + 0], a = 3 * (i - n) + Cn[1020 + t[e - 2 * r] - t[e + r]], o = jn[112 + (a + 4 >> 3)];
            t[e - r] = On[255 + n + jn[112 + (a + 3 >> 3)]], t[e + 0] = On[255 + i - o];
        }
        function Re(t, e, r, n) {
            var i = t[e + 0], a = t[e + r];
            return Bn[255 + t[e - 2 * r] - t[e - r]] > n || Bn[255 + a - i] > n;
        }
        function De(t, e, r, n) {
            return 4 * Bn[255 + t[e - r] - t[e + 0]] + Bn[255 + t[e - 2 * r] - t[e + r]] <= n;
        }
        function Te(t, e, r, n, i) {
            var a = t[e - 3 * r], o = t[e - 2 * r], s = t[e - r], u = t[e + 0], c = t[e + r], l = t[e + 2 * r], h = t[e + 3 * r];
            return 4 * Bn[255 + s - u] + Bn[255 + o - c] > n ? 0 : Bn[255 + t[e - 4 * r] - a] <= i && Bn[255 + a - o] <= i && Bn[255 + o - s] <= i && Bn[255 + h - l] <= i && Bn[255 + l - c] <= i && Bn[255 + c - u] <= i;
        }
        function ze(t, e, r, n) {
            var i = 2 * n + 1;
            for(n = 0; 16 > n; ++n)De(t, e + n, r, i) && Ee(t, e + n, r);
        }
        function Ue(t, e, r, n) {
            var i = 2 * n + 1;
            for(n = 0; 16 > n; ++n)De(t, e + n * r, 1, i) && Ee(t, e + n * r, 1);
        }
        function He(t, e, r, n) {
            var i;
            for(i = 3; 0 < i; --i)ze(t, e += 4 * r, r, n);
        }
        function We(t, e, r, n) {
            var i;
            for(i = 3; 0 < i; --i)Ue(t, e += 4, r, n);
        }
        function Ve(t, e, r, n, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Te(t, e, r, a, o)) {
                    if (Re(t, e, r, s)) Ee(t, e, r);
                    else {
                        var u = t, c = e, l = r, h = u[c - 2 * l], f = u[c - l], d = u[c + 0], p = u[c + l], g = u[c + 2 * l], m = 27 * (b = Cn[1020 + 3 * (d - f) + Cn[1020 + h - p]]) + 63 >> 7, v = 18 * b + 63 >> 7, b = 9 * b + 63 >> 7;
                        u[c - 3 * l] = On[255 + u[c - 3 * l] + b], u[c - 2 * l] = On[255 + h + v], u[c - l] = On[255 + f + m], u[c + 0] = On[255 + d - m], u[c + l] = On[255 + p - v], u[c + 2 * l] = On[255 + g - b];
                    }
                }
                e += n;
            }
        }
        function Ge(t, e, r, n, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Te(t, e, r, a, o)) {
                    if (Re(t, e, r, s)) Ee(t, e, r);
                    else {
                        var u = t, c = e, l = r, h = u[c - l], f = u[c + 0], d = u[c + l], p = jn[112 + (4 + (g = 3 * (f - h)) >> 3)], g = jn[112 + (g + 3 >> 3)], m = p + 1 >> 1;
                        u[c - 2 * l] = On[255 + u[c - 2 * l] + m], u[c - l] = On[255 + h + g], u[c + 0] = On[255 + f - p], u[c + l] = On[255 + d - m];
                    }
                }
                e += n;
            }
        }
        function Ye(t, e, r, n, i, a) {
            Ve(t, e, r, 1, 16, n, i, a);
        }
        function Je(t, e, r, n, i, a) {
            Ve(t, e, 1, r, 16, n, i, a);
        }
        function Xe(t, e, r, n, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ge(t, e += 4 * r, r, 1, 16, n, i, a);
        }
        function Ke(t, e, r, n, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ge(t, e += 4, 1, r, 16, n, i, a);
        }
        function Ze(t, e, r, n, i, a, o, s) {
            Ve(t, e, i, 1, 8, a, o, s), Ve(r, n, i, 1, 8, a, o, s);
        }
        function $e(t, e, r, n, i, a, o, s) {
            Ve(t, e, 1, i, 8, a, o, s), Ve(r, n, 1, i, 8, a, o, s);
        }
        function Qe(t, e, r, n, i, a, o, s) {
            Ge(t, e + 4 * i, i, 1, 8, a, o, s), Ge(r, n + 4 * i, i, 1, 8, a, o, s);
        }
        function tr(t, e, r, n, i, a, o, s) {
            Ge(t, e + 4, 1, i, 8, a, o, s), Ge(r, n + 4, 1, i, 8, a, o, s);
        }
        function er() {
            this.ba = new ot, this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new ut, this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
        }
        function rr() {
            this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
        }
        function nr() {
            this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
        }
        function ir() {
            this.ua = 0, this.Wa = new M, this.vb = new M, this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new d, this.yc = new h;
        }
        function ar() {
            this.xb = this.a = 0, this.l = new Gt, this.ca = new ot, this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new N, this.Pb = 0, this.wd = new N, this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new ir, this.ab = 0, this.gc = o(4, nr), this.Oc = 0;
        }
        function or() {
            this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Gt, this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
        }
        function sr(t, e, r, n, i, a, o) {
            for(t = null == t ? 0 : t[e + 0], e = 0; e < o; ++e)i[a + e] = t + r[n + e] & 255, t = i[a + e];
        }
        function ur(t, e, r, n, i, a, o) {
            var s;
            if (null == t) sr(null, null, r, n, i, a, o);
            else for(s = 0; s < o; ++s)i[a + s] = t[e + s] + r[n + s] & 255;
        }
        function cr(t, e, r, n, i, a, o) {
            if (null == t) sr(null, null, r, n, i, a, o);
            else {
                var s, u = t[e + 0], c = u, l = u;
                for(s = 0; s < o; ++s)c = l + (u = t[e + s]) - c, l = r[n + s] + (-256 & c ? 0 > c ? 0 : 255 : c) & 255, c = u, i[a + s] = l;
            }
        }
        function lr(t, r, i, o) {
            var s = r.width, u = r.o;
            if (e(null != t && null != r), 0 > i || 0 >= o || i + o > u) return null;
            if (!t.Cc) {
                if (null == t.ga) {
                    var c;
                    if (t.ga = new or, (c = null == t.ga) || (c = r.width * r.o, e(0 == t.Gb.length), t.Gb = a(c), t.Uc = 0, null == t.Gb ? c = 0 : (t.mb = t.Gb, t.nb = t.Uc, t.rc = null, c = 1), c = !c), !c) {
                        c = t.ga;
                        var l = t.Fa, h = t.P, f = t.qc, d = t.mb, p = t.nb, g = h + 1, m = f - 1, b = c.l;
                        if (e(null != l && null != d && null != r), gi[0] = null, gi[1] = sr, gi[2] = ur, gi[3] = cr, c.ca = d, c.tb = p, c.c = r.width, c.i = r.height, e(0 < c.c && 0 < c.i), 1 >= f) r = 0;
                        else if (c.$a = 3 & l[h + 0], c.Z = l[h + 0] >> 2 & 3, c.Lc = l[h + 0] >> 4 & 3, h = l[h + 0] >> 6 & 3, 0 > c.$a || 1 < c.$a || 4 <= c.Z || 1 < c.Lc || h) r = 0;
                        else if (b.put = dt, b.ac = ft, b.bc = pt, b.ma = c, b.width = r.width, b.height = r.height, b.Da = r.Da, b.v = r.v, b.va = r.va, b.j = r.j, b.o = r.o, c.$a) t: {
                            e(1 == c.$a), r = kt();
                            e: for(;;){
                                if (null == r) {
                                    r = 0;
                                    break t;
                                }
                                if (e(null != c), c.mc = r, r.c = c.c, r.i = c.i, r.l = c.l, r.l.ma = c, r.l.width = c.c, r.l.height = c.i, r.a = 0, v(r.m, l, g, m), !Ft(c.c, c.i, 1, r, null)) break e;
                                if (1 == r.ab && 3 == r.gc[0].hc && xt(r.s) ? (c.ic = 1, l = r.c * r.i, r.Ta = null, r.Ua = 0, r.V = a(l), r.Ba = 0, null == r.V ? (r.a = 1, r = 0) : r = 1) : (c.ic = 0, r = It(r, c.c)), !r) break e;
                                r = 1;
                                break t;
                            }
                            c.mc = null, r = 0;
                        }
                        else r = m >= c.c * c.i;
                        c = !r;
                    }
                    if (c) return null;
                    1 != t.ga.Lc ? t.Ga = 0 : o = u - i;
                }
                e(null != t.ga), e(i + o <= u);
                t: {
                    if (r = (l = t.ga).c, u = l.l.o, 0 == l.$a) {
                        if (g = t.rc, m = t.Vc, b = t.Fa, h = t.P + 1 + i * r, f = t.mb, d = t.nb + i * r, e(h <= t.P + t.qc), 0 != l.Z) for(e(null != gi[l.Z]), c = 0; c < o; ++c)gi[l.Z](g, m, b, h, f, d, r), g = f, m = d, d += r, h += r;
                        else for(c = 0; c < o; ++c)n(f, d, b, h, r), g = f, m = d, d += r, h += r;
                        t.rc = g, t.Vc = m;
                    } else {
                        if (e(null != l.mc), r = i + o, e(null != (c = l.mc)), e(r <= c.i), c.C >= r) r = 1;
                        else if (l.ic || gr(), l.ic) {
                            l = c.V, g = c.Ba, m = c.c;
                            var y = c.i, w = (b = 1, h = c.$ / m, f = c.$ % m, d = c.m, p = c.s, c.$), N = m * y, L = m * r, A = p.wc, _ = w < L ? wt(p, f, h) : null;
                            e(w <= N), e(r <= y), e(xt(p));
                            e: for(;;){
                                for(; !d.h && w < L;){
                                    if (f & A || (_ = wt(p, f, h)), e(null != _), S(d), 256 > (y = bt(_.G[0], _.H[0], d))) l[g + w] = y, ++w, ++f >= m && (f = 0, ++h <= r && !(h % 16) && St(c, h));
                                    else {
                                        if (!(280 > y)) {
                                            b = 0;
                                            break e;
                                        }
                                        y = mt(y - 256, d);
                                        var P, k = bt(_.G[4], _.H[4], d);
                                        if (S(d), !(w >= (k = vt(m, k = mt(k, d))) && N - w >= y)) {
                                            b = 0;
                                            break e;
                                        }
                                        for(P = 0; P < y; ++P)l[g + w + P] = l[g + w + P - k];
                                        for(w += y, f += y; f >= m;)f -= m, ++h <= r && !(h % 16) && St(c, h);
                                        w < L && f & A && (_ = wt(p, f, h));
                                    }
                                    e(d.h == x(d));
                                }
                                St(c, h > r ? r : h);
                                break e;
                            }
                            !b || d.h && w < N ? (b = 0, c.a = d.h ? 5 : 3) : c.$ = w, r = b;
                        } else r = _t(c, c.V, c.Ba, c.c, c.i, r, Ct);
                        if (!r) {
                            o = 0;
                            break t;
                        }
                    }
                    i + o >= u && (t.Cc = 1), o = 1;
                }
                if (!o) return null;
                if (t.Cc && (null != (o = t.ga) && (o.mc = null), t.ga = null, 0 < t.Ga)) return alert("todo:WebPDequantizeLevels"), null;
            }
            return t.nb + i * s;
        }
        function hr(t, e, r, n, i, a) {
            for(; 0 < i--;){
                var o, s = t, u = e + (r ? 1 : 0), c = t, l = e + (r ? 0 : 3);
                for(o = 0; o < n; ++o){
                    var h = c[l + 4 * o];
                    255 != h && (h *= 32897, s[u + 4 * o + 0] = s[u + 4 * o + 0] * h >> 23, s[u + 4 * o + 1] = s[u + 4 * o + 1] * h >> 23, s[u + 4 * o + 2] = s[u + 4 * o + 2] * h >> 23);
                }
                e += a;
            }
        }
        function fr(t, e, r, n, i) {
            for(; 0 < n--;){
                var a;
                for(a = 0; a < r; ++a){
                    var o = t[e + 2 * a + 0], s = 15 & (c = t[e + 2 * a + 1]), u = 4369 * s, c = (240 & c | c >> 4) * u >> 16;
                    t[e + 2 * a + 0] = (240 & o | o >> 4) * u >> 16 & 240 | (15 & o | o << 4) * u >> 16 >> 4 & 15, t[e + 2 * a + 1] = 240 & c | s;
                }
                e += i;
            }
        }
        function dr(t, e, r, n, i, a, o, s) {
            var u, c, l = 255;
            for(c = 0; c < i; ++c){
                for(u = 0; u < n; ++u){
                    var h = t[e + u];
                    a[o + 4 * u] = h, l &= h;
                }
                e += r, o += s;
            }
            return 255 != l;
        }
        function pr(t, e, r, n, i) {
            var a;
            for(a = 0; a < i; ++a)r[n + a] = t[e + a] >> 8;
        }
        function gr() {
            Ln = hr, xn = fr, An = dr, Sn = pr;
        }
        function mr(r, n, i) {
            t[r] = function(t, r, a, o, s, u, c, l, h, f, d, p, g, m, v, b, y) {
                var w, N = y - 1 >> 1, L = s[u + 0] | c[l + 0] << 16, x = h[f + 0] | d[p + 0] << 16;
                e(null != t);
                var A = 3 * L + x + 131074 >> 2;
                for(n(t[r + 0], 255 & A, A >> 16, g, m), null != a && (A = 3 * x + L + 131074 >> 2, n(a[o + 0], 255 & A, A >> 16, v, b)), w = 1; w <= N; ++w){
                    var S = s[u + w] | c[l + w] << 16, _ = h[f + w] | d[p + w] << 16, P = L + S + x + _ + 524296, k = P + 2 * (S + x) >> 3;
                    A = k + L >> 1, L = (P = P + 2 * (L + _) >> 3) + S >> 1, n(t[r + 2 * w - 1], 255 & A, A >> 16, g, m + (2 * w - 1) * i), n(t[r + 2 * w - 0], 255 & L, L >> 16, g, m + (2 * w - 0) * i), null != a && (A = P + x >> 1, L = k + _ >> 1, n(a[o + 2 * w - 1], 255 & A, A >> 16, v, b + (2 * w - 1) * i), n(a[o + 2 * w + 0], 255 & L, L >> 16, v, b + (2 * w + 0) * i)), L = S, x = _;
                }
                1 & y || (A = 3 * L + x + 131074 >> 2, n(t[r + y - 1], 255 & A, A >> 16, g, m + (y - 1) * i), null != a && (A = 3 * x + L + 131074 >> 2, n(a[o + y - 1], 255 & A, A >> 16, v, b + (y - 1) * i)));
            };
        }
        function vr() {
            mi[Mn] = vi, mi[qn] = yi, mi[En] = bi, mi[Rn] = wi, mi[Dn] = Ni, mi[Tn] = Li, mi[zn] = xi, mi[Un] = yi, mi[Hn] = wi, mi[Wn] = Ni, mi[Vn] = Li;
        }
        function br(t) {
            return t & ~Fi ? 0 > t ? 0 : 255 : t >> ki;
        }
        function yr(t, e) {
            return br((19077 * t >> 8) + (26149 * e >> 8) - 14234);
        }
        function wr(t, e, r) {
            return br((19077 * t >> 8) - (6419 * e >> 8) - (13320 * r >> 8) + 8708);
        }
        function Nr(t, e) {
            return br((19077 * t >> 8) + (33050 * e >> 8) - 17685);
        }
        function Lr(t, e, r, n, i) {
            n[i + 0] = yr(t, r), n[i + 1] = wr(t, e, r), n[i + 2] = Nr(t, e);
        }
        function xr(t, e, r, n, i) {
            n[i + 0] = Nr(t, e), n[i + 1] = wr(t, e, r), n[i + 2] = yr(t, r);
        }
        function Ar(t, e, r, n, i) {
            var a = wr(t, e, r);
            e = a << 3 & 224 | Nr(t, e) >> 3, n[i + 0] = 248 & yr(t, r) | a >> 5, n[i + 1] = e;
        }
        function Sr(t, e, r, n, i) {
            var a = 240 & Nr(t, e) | 15;
            n[i + 0] = 240 & yr(t, r) | wr(t, e, r) >> 4, n[i + 1] = a;
        }
        function _r(t, e, r, n, i) {
            n[i + 0] = 255, Lr(t, e, r, n, i + 1);
        }
        function Pr(t, e, r, n, i) {
            xr(t, e, r, n, i), n[i + 3] = 255;
        }
        function kr(t, e, r, n, i) {
            Lr(t, e, r, n, i), n[i + 3] = 255;
        }
        function Fr(e, r, n) {
            t[e] = function(t, e, i, a, o, s, u, c, l) {
                for(var h = c + (-2 & l) * n; c != h;)r(t[e + 0], i[a + 0], o[s + 0], u, c), r(t[e + 1], i[a + 0], o[s + 0], u, c + n), e += 2, ++a, ++s, c += 2 * n;
                1 & l && r(t[e + 0], i[a + 0], o[s + 0], u, c);
            };
        }
        function Ir(t, e, r) {
            return 0 == r ? 0 == t ? 0 == e ? 6 : 5 : 0 == e ? 4 : 0 : r;
        }
        function Cr(t, e, r, n, i) {
            switch(t >>> 30){
                case 3:
                    an(e, r, n, i, 0);
                    break;
                case 2:
                    on(e, r, n, i);
                    break;
                case 1:
                    un(e, r, n, i);
            }
        }
        function jr(t, e) {
            var r, a, o = e.M, s = e.Nb, u = t.oc, c = t.pc + 40, l = t.oc, h = t.pc + 584, f = t.oc, d = t.pc + 600;
            for(r = 0; 16 > r; ++r)u[c + 32 * r - 1] = 129;
            for(r = 0; 8 > r; ++r)l[h + 32 * r - 1] = 129, f[d + 32 * r - 1] = 129;
            for(0 < o ? u[c - 1 - 32] = l[h - 1 - 32] = f[d - 1 - 32] = 129 : (i(u, c - 32 - 1, 127, 21), i(l, h - 32 - 1, 127, 9), i(f, d - 32 - 1, 127, 9)), a = 0; a < t.za; ++a){
                var p = e.ya[e.aa + a];
                if (0 < a) {
                    for(r = -1; 16 > r; ++r)n(u, c + 32 * r - 4, u, c + 32 * r + 12, 4);
                    for(r = -1; 8 > r; ++r)n(l, h + 32 * r - 4, l, h + 32 * r + 4, 4), n(f, d + 32 * r - 4, f, d + 32 * r + 4, 4);
                }
                var g = t.Gd, m = t.Hd + a, v = p.ad, b = p.Hc;
                if (0 < o && (n(u, c - 32, g[m].y, 0, 16), n(l, h - 32, g[m].f, 0, 8), n(f, d - 32, g[m].ea, 0, 8)), p.Za) {
                    var y = u, w = c - 32 + 16;
                    for(0 < o && (a >= t.za - 1 ? i(y, w, g[m].y[15], 4) : n(y, w, g[m + 1].y, 0, 4)), r = 0; 4 > r; r++)y[w + 128 + r] = y[w + 256 + r] = y[w + 384 + r] = y[w + 0 + r];
                    for(r = 0; 16 > r; ++r, b <<= 2)y = u, w = c + Ei[r], hi[p.Ob[r]](y, w), Cr(b, v, 16 * +r, y, w);
                } else if (y = Ir(a, o, p.Ob[0]), li[y](u, c), 0 != b) for(r = 0; 16 > r; ++r, b <<= 2)Cr(b, v, 16 * +r, u, c + Ei[r]);
                for(r = p.Gc, y = Ir(a, o, p.Dd), fi[y](l, h), fi[y](f, d), b = v, y = l, w = h, 255 & (p = 0 | r) && (170 & p ? sn(b, 256, y, w) : cn(b, 256, y, w)), p = f, b = d, 255 & (r >>= 8) && (170 & r ? sn(v, 320, p, b) : cn(v, 320, p, b)), o < t.Ub - 1 && (n(g[m].y, 0, u, c + 480, 16), n(g[m].f, 0, l, h + 224, 8), n(g[m].ea, 0, f, d + 224, 8)), r = 8 * s * t.B, g = t.sa, m = t.ta + 16 * a + 16 * s * t.R, v = t.qa, p = t.ra + 8 * a + r, b = t.Ha, y = t.Ia + 8 * a + r, r = 0; 16 > r; ++r)n(g, m + r * t.R, u, c + 32 * r, 16);
                for(r = 0; 8 > r; ++r)n(v, p + r * t.B, l, h + 32 * r, 8), n(b, y + r * t.B, f, d + 32 * r, 8);
            }
        }
        function Or(t, n, i, a, o, s, u, c, l) {
            var h = [
                0
            ], f = [
                0
            ], d = 0, p = null != l ? l.kd : 0, g = null != l ? l : new rr;
            if (null == t || 12 > i) return 7;
            g.data = t, g.w = n, g.ha = i, n = [
                n
            ], i = [
                i
            ], g.gb = [
                g.gb
            ];
            t: {
                var m = n, b = i, y = g.gb;
                if (e(null != t), e(null != b), e(null != y), y[0] = 0, 12 <= b[0] && !r(t, m[0], "RIFF")) {
                    if (r(t, m[0] + 8, "WEBP")) {
                        y = 3;
                        break t;
                    }
                    var w = j(t, m[0] + 4);
                    if (12 > w || 4294967286 < w) {
                        y = 3;
                        break t;
                    }
                    if (p && w > b[0] - 8) {
                        y = 7;
                        break t;
                    }
                    y[0] = w, m[0] += 12, b[0] -= 12;
                }
                y = 0;
            }
            if (0 != y) return y;
            for(w = 0 < g.gb[0], i = i[0];;){
                t: {
                    var L = t;
                    b = n, y = i;
                    var x = h, A = f, S = m = [
                        0
                    ];
                    if ((k = d = [
                        d
                    ])[0] = 0, 8 > y[0]) y = 7;
                    else {
                        if (!r(L, b[0], "VP8X")) {
                            if (10 != j(L, b[0] + 4)) {
                                y = 3;
                                break t;
                            }
                            if (18 > y[0]) {
                                y = 7;
                                break t;
                            }
                            var _ = j(L, b[0] + 8), P = 1 + C(L, b[0] + 12);
                            if (2147483648 <= P * (L = 1 + C(L, b[0] + 15))) {
                                y = 3;
                                break t;
                            }
                            null != S && (S[0] = _), null != x && (x[0] = P), null != A && (A[0] = L), b[0] += 18, y[0] -= 18, k[0] = 1;
                        }
                        y = 0;
                    }
                }
                if (d = d[0], m = m[0], 0 != y) return y;
                if (b = !!(2 & m), !w && d) return 3;
                if (null != s && (s[0] = !!(16 & m)), null != u && (u[0] = b), null != c && (c[0] = 0), u = h[0], m = f[0], d && b && null == l) {
                    y = 0;
                    break;
                }
                if (4 > i) {
                    y = 7;
                    break;
                }
                if (w && d || !w && !d && !r(t, n[0], "ALPH")) {
                    i = [
                        i
                    ], g.na = [
                        g.na
                    ], g.P = [
                        g.P
                    ], g.Sa = [
                        g.Sa
                    ];
                    t: {
                        _ = t, y = n, w = i;
                        var k = g.gb;
                        x = g.na, A = g.P, S = g.Sa, P = 22, e(null != _), e(null != w), L = y[0];
                        var F = w[0];
                        for(e(null != x), e(null != S), x[0] = null, A[0] = null, S[0] = 0;;){
                            if (y[0] = L, w[0] = F, 8 > F) {
                                y = 7;
                                break t;
                            }
                            var I = j(_, L + 4);
                            if (4294967286 < I) {
                                y = 3;
                                break t;
                            }
                            var O = 8 + I + 1 & -2;
                            if (P += O, 0 < k && P > k) {
                                y = 3;
                                break t;
                            }
                            if (!r(_, L, "VP8 ") || !r(_, L, "VP8L")) {
                                y = 0;
                                break t;
                            }
                            if (F[0] < O) {
                                y = 7;
                                break t;
                            }
                            r(_, L, "ALPH") || (x[0] = _, A[0] = L + 8, S[0] = I), L += O, F -= O;
                        }
                    }
                    if (i = i[0], g.na = g.na[0], g.P = g.P[0], g.Sa = g.Sa[0], 0 != y) break;
                }
                i = [
                    i
                ], g.Ja = [
                    g.Ja
                ], g.xa = [
                    g.xa
                ];
                t: if (k = t, y = n, w = i, x = g.gb[0], A = g.Ja, S = g.xa, _ = y[0], L = !r(k, _, "VP8 "), P = !r(k, _, "VP8L"), e(null != k), e(null != w), e(null != A), e(null != S), 8 > w[0]) y = 7;
                else {
                    if (L || P) {
                        if (k = j(k, _ + 4), 12 <= x && k > x - 12) {
                            y = 3;
                            break t;
                        }
                        if (p && k > w[0] - 8) {
                            y = 7;
                            break t;
                        }
                        A[0] = k, y[0] += 8, w[0] -= 8, S[0] = P;
                    } else S[0] = 5 <= w[0] && 47 == k[_ + 0] && !(k[_ + 4] >> 5), A[0] = w[0];
                    y = 0;
                }
                if (i = i[0], g.Ja = g.Ja[0], g.xa = g.xa[0], n = n[0], 0 != y) break;
                if (4294967286 < g.Ja) return 3;
                if (null == c || b || (c[0] = g.xa ? 2 : 1), u = [
                    u
                ], m = [
                    m
                ], g.xa) {
                    if (5 > i) {
                        y = 7;
                        break;
                    }
                    c = u, p = m, b = s, null == t || 5 > i ? t = 0 : 5 <= i && 47 == t[n + 0] && !(t[n + 4] >> 5) ? (w = [
                        0
                    ], k = [
                        0
                    ], x = [
                        0
                    ], v(A = new N, t, n, i), gt(A, w, k, x) ? (null != c && (c[0] = w[0]), null != p && (p[0] = k[0]), null != b && (b[0] = x[0]), t = 1) : t = 0) : t = 0;
                } else {
                    if (10 > i) {
                        y = 7;
                        break;
                    }
                    c = m, null == t || 10 > i || !Xt(t, n + 3, i - 3) ? t = 0 : (p = t[n + 0] | t[n + 1] << 8 | t[n + 2] << 16, b = 16383 & (t[n + 7] << 8 | t[n + 6]), t = 16383 & (t[n + 9] << 8 | t[n + 8]), 1 & p || 3 < (p >> 1 & 7) || !(p >> 4 & 1) || p >> 5 >= g.Ja || !b || !t ? t = 0 : (u && (u[0] = b), c && (c[0] = t), t = 1));
                }
                if (!t) return 3;
                if (u = u[0], m = m[0], d && (h[0] != u || f[0] != m)) return 3;
                null != l && (l[0] = g, l.offset = n - l.w, e(4294967286 > n - l.w), e(l.offset == l.ha - i));
                break;
            }
            return 0 == y || 7 == y && d && null == l ? (null != s && (s[0] |= null != g.na && 0 < g.na.length), null != a && (a[0] = u), null != o && (o[0] = m), 0) : y;
        }
        function Br(t, e, r) {
            var n = e.width, i = e.height, a = 0, o = 0, s = n, u = i;
            if (e.Da = null != t && 0 < t.Da, e.Da && (s = t.cd, u = t.bd, a = t.v, o = t.j, 11 > r || (a &= -2, o &= -2), 0 > a || 0 > o || 0 >= s || 0 >= u || a + s > n || o + u > i)) return 0;
            if (e.v = a, e.j = o, e.va = a + s, e.o = o + u, e.U = s, e.T = u, e.da = null != t && 0 < t.da, e.da) {
                if (!q(s, u, r = [
                    t.ib
                ], a = [
                    t.hb
                ])) return 0;
                e.ib = r[0], e.hb = a[0];
            }
            return e.ob = null != t && t.ob, e.Kb = null == t || !t.Sd, e.da && (e.ob = e.ib < 3 * n / 4 && e.hb < 3 * i / 4, e.Kb = 0), 1;
        }
        function Mr(t) {
            if (null == t) return 2;
            if (11 > t.S) {
                var e = t.f.RGBA;
                e.fb += (t.height - 1) * e.A, e.A = -e.A;
            } else e = t.f.kb, t = t.height, e.O += (t - 1) * e.fa, e.fa = -e.fa, e.N += (t - 1 >> 1) * e.Ab, e.Ab = -e.Ab, e.W += (t - 1 >> 1) * e.Db, e.Db = -e.Db, null != e.F && (e.J += (t - 1) * e.lb, e.lb = -e.lb);
            return 0;
        }
        function qr(t, e, r, n) {
            if (null == n || 0 >= t || 0 >= e) return 2;
            if (null != r) {
                if (r.Da) {
                    var i = r.cd, o = r.bd, s = -2 & r.v, u = -2 & r.j;
                    if (0 > s || 0 > u || 0 >= i || 0 >= o || s + i > t || u + o > e) return 2;
                    t = i, e = o;
                }
                if (r.da) {
                    if (!q(t, e, i = [
                        r.ib
                    ], o = [
                        r.hb
                    ])) return 2;
                    t = i[0], e = o[0];
                }
            }
            n.width = t, n.height = e;
            t: {
                var c = n.width, l = n.height;
                if (t = n.S, 0 >= c || 0 >= l || !(t >= Mn && 13 > t)) t = 2;
                else {
                    if (0 >= n.Rd && null == n.sd) {
                        s = o = i = e = 0;
                        var h = (u = c * zi[t]) * l;
                        if (11 > t || (o = (l + 1) / 2 * (e = (c + 1) / 2), 12 == t && (s = (i = c) * l)), null == (l = a(h + 2 * o + s))) {
                            t = 1;
                            break t;
                        }
                        n.sd = l, 11 > t ? ((c = n.f.RGBA).eb = l, c.fb = 0, c.A = u, c.size = h) : ((c = n.f.kb).y = l, c.O = 0, c.fa = u, c.Fd = h, c.f = l, c.N = 0 + h, c.Ab = e, c.Cd = o, c.ea = l, c.W = 0 + h + o, c.Db = e, c.Ed = o, 12 == t && (c.F = l, c.J = 0 + h + 2 * o), c.Tc = s, c.lb = i);
                    }
                    if (e = 1, i = n.S, o = n.width, s = n.height, i >= Mn && 13 > i) {
                        if (11 > i) t = n.f.RGBA, e &= (u = Math.abs(t.A)) * (s - 1) + o <= t.size, e &= u >= o * zi[i], e &= null != t.eb;
                        else {
                            t = n.f.kb, u = (o + 1) / 2, h = (s + 1) / 2, c = Math.abs(t.fa), l = Math.abs(t.Ab);
                            var f = Math.abs(t.Db), d = Math.abs(t.lb), p = d * (s - 1) + o;
                            e &= c * (s - 1) + o <= t.Fd, e &= l * (h - 1) + u <= t.Cd, e = (e &= f * (h - 1) + u <= t.Ed) & c >= o & l >= u & f >= u, e &= null != t.y, e &= null != t.f, e &= null != t.ea, 12 == i && (e &= d >= o, e &= p <= t.Tc, e &= null != t.F);
                        }
                    } else e = 0;
                    t = e ? 0 : 2;
                }
            }
            return 0 != t || null != r && r.fd && (t = Mr(n)), t;
        }
        var Er = 64, Rr = [
            0,
            1,
            3,
            7,
            15,
            31,
            63,
            127,
            255,
            511,
            1023,
            2047,
            4095,
            8191,
            16383,
            32767,
            65535,
            131071,
            262143,
            524287,
            1048575,
            2097151,
            4194303,
            8388607,
            16777215
        ], Dr = 24, Tr = 32, zr = 8, Ur = [
            0,
            0,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7
        ];
        D("Predictor0", "PredictorAdd0"), t.Predictor0 = function() {
            return 4278190080;
        }, t.Predictor1 = function(t) {
            return t;
        }, t.Predictor2 = function(t, e, r) {
            return e[r + 0];
        }, t.Predictor3 = function(t, e, r) {
            return e[r + 1];
        }, t.Predictor4 = function(t, e, r) {
            return e[r - 1];
        }, t.Predictor5 = function(t, e, r) {
            return z(z(t, e[r + 1]), e[r + 0]);
        }, t.Predictor6 = function(t, e, r) {
            return z(t, e[r - 1]);
        }, t.Predictor7 = function(t, e, r) {
            return z(t, e[r + 0]);
        }, t.Predictor8 = function(t, e, r) {
            return z(e[r - 1], e[r + 0]);
        }, t.Predictor9 = function(t, e, r) {
            return z(e[r + 0], e[r + 1]);
        }, t.Predictor10 = function(t, e, r) {
            return z(z(t, e[r - 1]), z(e[r + 0], e[r + 1]));
        }, t.Predictor11 = function(t, e, r) {
            var n = e[r + 0];
            return 0 >= W(n >> 24 & 255, t >> 24 & 255, (e = e[r - 1]) >> 24 & 255) + W(n >> 16 & 255, t >> 16 & 255, e >> 16 & 255) + W(n >> 8 & 255, t >> 8 & 255, e >> 8 & 255) + W(255 & n, 255 & t, 255 & e) ? n : t;
        }, t.Predictor12 = function(t, e, r) {
            var n = e[r + 0];
            return (U((t >> 24 & 255) + (n >> 24 & 255) - ((e = e[r - 1]) >> 24 & 255)) << 24 | U((t >> 16 & 255) + (n >> 16 & 255) - (e >> 16 & 255)) << 16 | U((t >> 8 & 255) + (n >> 8 & 255) - (e >> 8 & 255)) << 8 | U((255 & t) + (255 & n) - (255 & e))) >>> 0;
        }, t.Predictor13 = function(t, e, r) {
            var n = e[r - 1];
            return (H((t = z(t, e[r + 0])) >> 24 & 255, n >> 24 & 255) << 24 | H(t >> 16 & 255, n >> 16 & 255) << 16 | H(t >> 8 & 255, n >> 8 & 255) << 8 | H(255 & t, 255 & n)) >>> 0;
        };
        var Hr = t.PredictorAdd0;
        t.PredictorAdd1 = V, D("Predictor2", "PredictorAdd2"), D("Predictor3", "PredictorAdd3"), D("Predictor4", "PredictorAdd4"), D("Predictor5", "PredictorAdd5"), D("Predictor6", "PredictorAdd6"), D("Predictor7", "PredictorAdd7"), D("Predictor8", "PredictorAdd8"), D("Predictor9", "PredictorAdd9"), D("Predictor10", "PredictorAdd10"), D("Predictor11", "PredictorAdd11"), D("Predictor12", "PredictorAdd12"), D("Predictor13", "PredictorAdd13");
        var Wr = t.PredictorAdd2;
        X("ColorIndexInverseTransform", "MapARGB", "32b", function(t) {
            return t >> 8 & 255;
        }, function(t) {
            return t;
        }), X("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(t) {
            return t;
        }, function(t) {
            return t >> 8 & 255;
        });
        var Vr, Gr = t.ColorIndexInverseTransform, Yr = t.MapARGB, Jr = t.VP8LColorIndexInverseTransformAlpha, Xr = t.MapAlpha, Kr = t.VP8LPredictorsAdd = [];
        Kr.length = 16, (t.VP8LPredictors = []).length = 16, (t.VP8LPredictorsAdd_C = []).length = 16, (t.VP8LPredictors_C = []).length = 16;
        var Zr, $r, Qr, tn, en, rn, nn, an, on, sn, un, cn, ln, hn, fn, dn, pn, gn, mn, vn, bn, yn, wn, Nn, Ln, xn, An, Sn, _n = a(511), Pn = a(2041), kn = a(225), Fn = a(767), In = 0, Cn = Pn, jn = kn, On = Fn, Bn = _n, Mn = 0, qn = 1, En = 2, Rn = 3, Dn = 4, Tn = 5, zn = 6, Un = 7, Hn = 8, Wn = 9, Vn = 10, Gn = [
            2,
            3,
            7
        ], Yn = [
            3,
            3,
            11
        ], Jn = [
            280,
            256,
            256,
            256,
            40
        ], Xn = [
            0,
            1,
            1,
            1,
            0
        ], Kn = [
            17,
            18,
            0,
            1,
            2,
            3,
            4,
            5,
            16,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15
        ], Zn = [
            24,
            7,
            23,
            25,
            40,
            6,
            39,
            41,
            22,
            26,
            38,
            42,
            56,
            5,
            55,
            57,
            21,
            27,
            54,
            58,
            37,
            43,
            72,
            4,
            71,
            73,
            20,
            28,
            53,
            59,
            70,
            74,
            36,
            44,
            88,
            69,
            75,
            52,
            60,
            3,
            87,
            89,
            19,
            29,
            86,
            90,
            35,
            45,
            68,
            76,
            85,
            91,
            51,
            61,
            104,
            2,
            103,
            105,
            18,
            30,
            102,
            106,
            34,
            46,
            84,
            92,
            67,
            77,
            101,
            107,
            50,
            62,
            120,
            1,
            119,
            121,
            83,
            93,
            17,
            31,
            100,
            108,
            66,
            78,
            118,
            122,
            33,
            47,
            117,
            123,
            49,
            63,
            99,
            109,
            82,
            94,
            0,
            116,
            124,
            65,
            79,
            16,
            32,
            98,
            110,
            48,
            115,
            125,
            81,
            95,
            64,
            114,
            126,
            97,
            111,
            80,
            113,
            127,
            96,
            112
        ], $n = [
            2954,
            2956,
            2958,
            2962,
            2970,
            2986,
            3018,
            3082,
            3212,
            3468,
            3980,
            5004
        ], Qn = 8, ti = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            17,
            18,
            19,
            20,
            20,
            21,
            21,
            22,
            22,
            23,
            23,
            24,
            25,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            91,
            93,
            95,
            96,
            98,
            100,
            101,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            118,
            122,
            124,
            126,
            128,
            130,
            132,
            134,
            136,
            138,
            140,
            143,
            145,
            148,
            151,
            154,
            157
        ], ei = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            60,
            62,
            64,
            66,
            68,
            70,
            72,
            74,
            76,
            78,
            80,
            82,
            84,
            86,
            88,
            90,
            92,
            94,
            96,
            98,
            100,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            119,
            122,
            125,
            128,
            131,
            134,
            137,
            140,
            143,
            146,
            149,
            152,
            155,
            158,
            161,
            164,
            167,
            170,
            173,
            177,
            181,
            185,
            189,
            193,
            197,
            201,
            205,
            209,
            213,
            217,
            221,
            225,
            229,
            234,
            239,
            245,
            249,
            254,
            259,
            264,
            269,
            274,
            279,
            284
        ], ri = null, ni = [
            [
                173,
                148,
                140,
                0
            ],
            [
                176,
                155,
                140,
                135,
                0
            ],
            [
                180,
                157,
                141,
                134,
                130,
                0
            ],
            [
                254,
                254,
                243,
                230,
                196,
                177,
                153,
                140,
                133,
                130,
                129,
                0
            ]
        ], ii = [
            0,
            1,
            4,
            8,
            5,
            2,
            3,
            6,
            9,
            12,
            13,
            10,
            7,
            11,
            14,
            15
        ], ai = [
            -0,
            1,
            -1,
            2,
            -2,
            3,
            4,
            6,
            -3,
            5,
            -4,
            -5,
            -6,
            7,
            -7,
            8,
            -8,
            -9
        ], oi = [
            [
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        253,
                        136,
                        254,
                        255,
                        228,
                        219,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        189,
                        129,
                        242,
                        255,
                        227,
                        213,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        106,
                        126,
                        227,
                        252,
                        214,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        98,
                        248,
                        255,
                        236,
                        226,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        181,
                        133,
                        238,
                        254,
                        221,
                        234,
                        255,
                        154,
                        128,
                        128,
                        128
                    ],
                    [
                        78,
                        134,
                        202,
                        247,
                        198,
                        180,
                        255,
                        219,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        185,
                        249,
                        255,
                        243,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        150,
                        247,
                        255,
                        236,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        77,
                        110,
                        216,
                        255,
                        236,
                        230,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        101,
                        251,
                        255,
                        241,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        170,
                        139,
                        241,
                        252,
                        236,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        37,
                        116,
                        196,
                        243,
                        228,
                        255,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        204,
                        254,
                        255,
                        245,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        207,
                        160,
                        250,
                        255,
                        238,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        102,
                        103,
                        231,
                        255,
                        211,
                        171,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        152,
                        252,
                        255,
                        240,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        177,
                        135,
                        243,
                        255,
                        234,
                        225,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        80,
                        129,
                        211,
                        255,
                        194,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        246,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        198,
                        35,
                        237,
                        223,
                        193,
                        187,
                        162,
                        160,
                        145,
                        155,
                        62
                    ],
                    [
                        131,
                        45,
                        198,
                        221,
                        172,
                        176,
                        220,
                        157,
                        252,
                        221,
                        1
                    ],
                    [
                        68,
                        47,
                        146,
                        208,
                        149,
                        167,
                        221,
                        162,
                        255,
                        223,
                        128
                    ]
                ],
                [
                    [
                        1,
                        149,
                        241,
                        255,
                        221,
                        224,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        141,
                        234,
                        253,
                        222,
                        220,
                        255,
                        199,
                        128,
                        128,
                        128
                    ],
                    [
                        81,
                        99,
                        181,
                        242,
                        176,
                        190,
                        249,
                        202,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        129,
                        232,
                        253,
                        214,
                        197,
                        242,
                        196,
                        255,
                        255,
                        128
                    ],
                    [
                        99,
                        121,
                        210,
                        250,
                        201,
                        198,
                        255,
                        202,
                        128,
                        128,
                        128
                    ],
                    [
                        23,
                        91,
                        163,
                        242,
                        170,
                        187,
                        247,
                        210,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        200,
                        246,
                        255,
                        234,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        109,
                        178,
                        241,
                        255,
                        231,
                        245,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        44,
                        130,
                        201,
                        253,
                        205,
                        192,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        132,
                        239,
                        251,
                        219,
                        209,
                        255,
                        165,
                        128,
                        128,
                        128
                    ],
                    [
                        94,
                        136,
                        225,
                        251,
                        218,
                        190,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        22,
                        100,
                        174,
                        245,
                        186,
                        161,
                        255,
                        199,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        249,
                        255,
                        232,
                        235,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        124,
                        143,
                        241,
                        255,
                        227,
                        234,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        35,
                        77,
                        181,
                        251,
                        193,
                        211,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        157,
                        247,
                        255,
                        236,
                        231,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        121,
                        141,
                        235,
                        255,
                        225,
                        227,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        45,
                        99,
                        188,
                        251,
                        195,
                        217,
                        255,
                        224,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        251,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        203,
                        1,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        137,
                        1,
                        177,
                        255,
                        224,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        253,
                        9,
                        248,
                        251,
                        207,
                        208,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        175,
                        13,
                        224,
                        243,
                        193,
                        185,
                        249,
                        198,
                        255,
                        255,
                        128
                    ],
                    [
                        73,
                        17,
                        171,
                        221,
                        161,
                        179,
                        236,
                        167,
                        255,
                        234,
                        128
                    ]
                ],
                [
                    [
                        1,
                        95,
                        247,
                        253,
                        212,
                        183,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        239,
                        90,
                        244,
                        250,
                        211,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        155,
                        77,
                        195,
                        248,
                        188,
                        195,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        24,
                        239,
                        251,
                        218,
                        219,
                        255,
                        205,
                        128,
                        128,
                        128
                    ],
                    [
                        201,
                        51,
                        219,
                        255,
                        196,
                        186,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        69,
                        46,
                        190,
                        239,
                        201,
                        218,
                        255,
                        228,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        191,
                        251,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        223,
                        165,
                        249,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        124,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        16,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        190,
                        36,
                        230,
                        255,
                        236,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        226,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        247,
                        192,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        240,
                        128,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        134,
                        252,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        213,
                        62,
                        250,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        55,
                        93,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        202,
                        24,
                        213,
                        235,
                        186,
                        191,
                        220,
                        160,
                        240,
                        175,
                        255
                    ],
                    [
                        126,
                        38,
                        182,
                        232,
                        169,
                        184,
                        228,
                        174,
                        255,
                        187,
                        128
                    ],
                    [
                        61,
                        46,
                        138,
                        219,
                        151,
                        178,
                        240,
                        170,
                        255,
                        216,
                        128
                    ]
                ],
                [
                    [
                        1,
                        112,
                        230,
                        250,
                        199,
                        191,
                        247,
                        159,
                        255,
                        255,
                        128
                    ],
                    [
                        166,
                        109,
                        228,
                        252,
                        211,
                        215,
                        255,
                        174,
                        128,
                        128,
                        128
                    ],
                    [
                        39,
                        77,
                        162,
                        232,
                        172,
                        180,
                        245,
                        178,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        52,
                        220,
                        246,
                        198,
                        199,
                        249,
                        220,
                        255,
                        255,
                        128
                    ],
                    [
                        124,
                        74,
                        191,
                        243,
                        183,
                        193,
                        250,
                        221,
                        255,
                        255,
                        128
                    ],
                    [
                        24,
                        71,
                        130,
                        219,
                        154,
                        170,
                        243,
                        182,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        225,
                        249,
                        219,
                        240,
                        255,
                        224,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        150,
                        226,
                        252,
                        216,
                        205,
                        255,
                        171,
                        128,
                        128,
                        128
                    ],
                    [
                        28,
                        108,
                        170,
                        242,
                        183,
                        194,
                        254,
                        223,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        81,
                        230,
                        252,
                        204,
                        203,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        123,
                        102,
                        209,
                        247,
                        188,
                        196,
                        255,
                        233,
                        128,
                        128,
                        128
                    ],
                    [
                        20,
                        95,
                        153,
                        243,
                        164,
                        173,
                        255,
                        203,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        222,
                        248,
                        255,
                        216,
                        213,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        168,
                        175,
                        246,
                        252,
                        235,
                        205,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        47,
                        116,
                        215,
                        255,
                        211,
                        212,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        121,
                        236,
                        253,
                        212,
                        214,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        84,
                        213,
                        252,
                        201,
                        202,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        42,
                        80,
                        160,
                        240,
                        162,
                        185,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        244,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        238,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ]
        ], si = [
            [
                [
                    231,
                    120,
                    48,
                    89,
                    115,
                    113,
                    120,
                    152,
                    112
                ],
                [
                    152,
                    179,
                    64,
                    126,
                    170,
                    118,
                    46,
                    70,
                    95
                ],
                [
                    175,
                    69,
                    143,
                    80,
                    85,
                    82,
                    72,
                    155,
                    103
                ],
                [
                    56,
                    58,
                    10,
                    171,
                    218,
                    189,
                    17,
                    13,
                    152
                ],
                [
                    114,
                    26,
                    17,
                    163,
                    44,
                    195,
                    21,
                    10,
                    173
                ],
                [
                    121,
                    24,
                    80,
                    195,
                    26,
                    62,
                    44,
                    64,
                    85
                ],
                [
                    144,
                    71,
                    10,
                    38,
                    171,
                    213,
                    144,
                    34,
                    26
                ],
                [
                    170,
                    46,
                    55,
                    19,
                    136,
                    160,
                    33,
                    206,
                    71
                ],
                [
                    63,
                    20,
                    8,
                    114,
                    114,
                    208,
                    12,
                    9,
                    226
                ],
                [
                    81,
                    40,
                    11,
                    96,
                    182,
                    84,
                    29,
                    16,
                    36
                ]
            ],
            [
                [
                    134,
                    183,
                    89,
                    137,
                    98,
                    101,
                    106,
                    165,
                    148
                ],
                [
                    72,
                    187,
                    100,
                    130,
                    157,
                    111,
                    32,
                    75,
                    80
                ],
                [
                    66,
                    102,
                    167,
                    99,
                    74,
                    62,
                    40,
                    234,
                    128
                ],
                [
                    41,
                    53,
                    9,
                    178,
                    241,
                    141,
                    26,
                    8,
                    107
                ],
                [
                    74,
                    43,
                    26,
                    146,
                    73,
                    166,
                    49,
                    23,
                    157
                ],
                [
                    65,
                    38,
                    105,
                    160,
                    51,
                    52,
                    31,
                    115,
                    128
                ],
                [
                    104,
                    79,
                    12,
                    27,
                    217,
                    255,
                    87,
                    17,
                    7
                ],
                [
                    87,
                    68,
                    71,
                    44,
                    114,
                    51,
                    15,
                    186,
                    23
                ],
                [
                    47,
                    41,
                    14,
                    110,
                    182,
                    183,
                    21,
                    17,
                    194
                ],
                [
                    66,
                    45,
                    25,
                    102,
                    197,
                    189,
                    23,
                    18,
                    22
                ]
            ],
            [
                [
                    88,
                    88,
                    147,
                    150,
                    42,
                    46,
                    45,
                    196,
                    205
                ],
                [
                    43,
                    97,
                    183,
                    117,
                    85,
                    38,
                    35,
                    179,
                    61
                ],
                [
                    39,
                    53,
                    200,
                    87,
                    26,
                    21,
                    43,
                    232,
                    171
                ],
                [
                    56,
                    34,
                    51,
                    104,
                    114,
                    102,
                    29,
                    93,
                    77
                ],
                [
                    39,
                    28,
                    85,
                    171,
                    58,
                    165,
                    90,
                    98,
                    64
                ],
                [
                    34,
                    22,
                    116,
                    206,
                    23,
                    34,
                    43,
                    166,
                    73
                ],
                [
                    107,
                    54,
                    32,
                    26,
                    51,
                    1,
                    81,
                    43,
                    31
                ],
                [
                    68,
                    25,
                    106,
                    22,
                    64,
                    171,
                    36,
                    225,
                    114
                ],
                [
                    34,
                    19,
                    21,
                    102,
                    132,
                    188,
                    16,
                    76,
                    124
                ],
                [
                    62,
                    18,
                    78,
                    95,
                    85,
                    57,
                    50,
                    48,
                    51
                ]
            ],
            [
                [
                    193,
                    101,
                    35,
                    159,
                    215,
                    111,
                    89,
                    46,
                    111
                ],
                [
                    60,
                    148,
                    31,
                    172,
                    219,
                    228,
                    21,
                    18,
                    111
                ],
                [
                    112,
                    113,
                    77,
                    85,
                    179,
                    255,
                    38,
                    120,
                    114
                ],
                [
                    40,
                    42,
                    1,
                    196,
                    245,
                    209,
                    10,
                    25,
                    109
                ],
                [
                    88,
                    43,
                    29,
                    140,
                    166,
                    213,
                    37,
                    43,
                    154
                ],
                [
                    61,
                    63,
                    30,
                    155,
                    67,
                    45,
                    68,
                    1,
                    209
                ],
                [
                    100,
                    80,
                    8,
                    43,
                    154,
                    1,
                    51,
                    26,
                    71
                ],
                [
                    142,
                    78,
                    78,
                    16,
                    255,
                    128,
                    34,
                    197,
                    171
                ],
                [
                    41,
                    40,
                    5,
                    102,
                    211,
                    183,
                    4,
                    1,
                    221
                ],
                [
                    51,
                    50,
                    17,
                    168,
                    209,
                    192,
                    23,
                    25,
                    82
                ]
            ],
            [
                [
                    138,
                    31,
                    36,
                    171,
                    27,
                    166,
                    38,
                    44,
                    229
                ],
                [
                    67,
                    87,
                    58,
                    169,
                    82,
                    115,
                    26,
                    59,
                    179
                ],
                [
                    63,
                    59,
                    90,
                    180,
                    59,
                    166,
                    93,
                    73,
                    154
                ],
                [
                    40,
                    40,
                    21,
                    116,
                    143,
                    209,
                    34,
                    39,
                    175
                ],
                [
                    47,
                    15,
                    16,
                    183,
                    34,
                    223,
                    49,
                    45,
                    183
                ],
                [
                    46,
                    17,
                    33,
                    183,
                    6,
                    98,
                    15,
                    32,
                    183
                ],
                [
                    57,
                    46,
                    22,
                    24,
                    128,
                    1,
                    54,
                    17,
                    37
                ],
                [
                    65,
                    32,
                    73,
                    115,
                    28,
                    128,
                    23,
                    128,
                    205
                ],
                [
                    40,
                    3,
                    9,
                    115,
                    51,
                    192,
                    18,
                    6,
                    223
                ],
                [
                    87,
                    37,
                    9,
                    115,
                    59,
                    77,
                    64,
                    21,
                    47
                ]
            ],
            [
                [
                    104,
                    55,
                    44,
                    218,
                    9,
                    54,
                    53,
                    130,
                    226
                ],
                [
                    64,
                    90,
                    70,
                    205,
                    40,
                    41,
                    23,
                    26,
                    57
                ],
                [
                    54,
                    57,
                    112,
                    184,
                    5,
                    41,
                    38,
                    166,
                    213
                ],
                [
                    30,
                    34,
                    26,
                    133,
                    152,
                    116,
                    10,
                    32,
                    134
                ],
                [
                    39,
                    19,
                    53,
                    221,
                    26,
                    114,
                    32,
                    73,
                    255
                ],
                [
                    31,
                    9,
                    65,
                    234,
                    2,
                    15,
                    1,
                    118,
                    73
                ],
                [
                    75,
                    32,
                    12,
                    51,
                    192,
                    255,
                    160,
                    43,
                    51
                ],
                [
                    88,
                    31,
                    35,
                    67,
                    102,
                    85,
                    55,
                    186,
                    85
                ],
                [
                    56,
                    21,
                    23,
                    111,
                    59,
                    205,
                    45,
                    37,
                    192
                ],
                [
                    55,
                    38,
                    70,
                    124,
                    73,
                    102,
                    1,
                    34,
                    98
                ]
            ],
            [
                [
                    125,
                    98,
                    42,
                    88,
                    104,
                    85,
                    117,
                    175,
                    82
                ],
                [
                    95,
                    84,
                    53,
                    89,
                    128,
                    100,
                    113,
                    101,
                    45
                ],
                [
                    75,
                    79,
                    123,
                    47,
                    51,
                    128,
                    81,
                    171,
                    1
                ],
                [
                    57,
                    17,
                    5,
                    71,
                    102,
                    57,
                    53,
                    41,
                    49
                ],
                [
                    38,
                    33,
                    13,
                    121,
                    57,
                    73,
                    26,
                    1,
                    85
                ],
                [
                    41,
                    10,
                    67,
                    138,
                    77,
                    110,
                    90,
                    47,
                    114
                ],
                [
                    115,
                    21,
                    2,
                    10,
                    102,
                    255,
                    166,
                    23,
                    6
                ],
                [
                    101,
                    29,
                    16,
                    10,
                    85,
                    128,
                    101,
                    196,
                    26
                ],
                [
                    57,
                    18,
                    10,
                    102,
                    102,
                    213,
                    34,
                    20,
                    43
                ],
                [
                    117,
                    20,
                    15,
                    36,
                    163,
                    128,
                    68,
                    1,
                    26
                ]
            ],
            [
                [
                    102,
                    61,
                    71,
                    37,
                    34,
                    53,
                    31,
                    243,
                    192
                ],
                [
                    69,
                    60,
                    71,
                    38,
                    73,
                    119,
                    28,
                    222,
                    37
                ],
                [
                    68,
                    45,
                    128,
                    34,
                    1,
                    47,
                    11,
                    245,
                    171
                ],
                [
                    62,
                    17,
                    19,
                    70,
                    146,
                    85,
                    55,
                    62,
                    70
                ],
                [
                    37,
                    43,
                    37,
                    154,
                    100,
                    163,
                    85,
                    160,
                    1
                ],
                [
                    63,
                    9,
                    92,
                    136,
                    28,
                    64,
                    32,
                    201,
                    85
                ],
                [
                    75,
                    15,
                    9,
                    9,
                    64,
                    255,
                    184,
                    119,
                    16
                ],
                [
                    86,
                    6,
                    28,
                    5,
                    64,
                    255,
                    25,
                    248,
                    1
                ],
                [
                    56,
                    8,
                    17,
                    132,
                    137,
                    255,
                    55,
                    116,
                    128
                ],
                [
                    58,
                    15,
                    20,
                    82,
                    135,
                    57,
                    26,
                    121,
                    40
                ]
            ],
            [
                [
                    164,
                    50,
                    31,
                    137,
                    154,
                    133,
                    25,
                    35,
                    218
                ],
                [
                    51,
                    103,
                    44,
                    131,
                    131,
                    123,
                    31,
                    6,
                    158
                ],
                [
                    86,
                    40,
                    64,
                    135,
                    148,
                    224,
                    45,
                    183,
                    128
                ],
                [
                    22,
                    26,
                    17,
                    131,
                    240,
                    154,
                    14,
                    1,
                    209
                ],
                [
                    45,
                    16,
                    21,
                    91,
                    64,
                    222,
                    7,
                    1,
                    197
                ],
                [
                    56,
                    21,
                    39,
                    155,
                    60,
                    138,
                    23,
                    102,
                    213
                ],
                [
                    83,
                    12,
                    13,
                    54,
                    192,
                    255,
                    68,
                    47,
                    28
                ],
                [
                    85,
                    26,
                    85,
                    85,
                    128,
                    128,
                    32,
                    146,
                    171
                ],
                [
                    18,
                    11,
                    7,
                    63,
                    144,
                    171,
                    4,
                    4,
                    246
                ],
                [
                    35,
                    27,
                    10,
                    146,
                    174,
                    171,
                    12,
                    26,
                    128
                ]
            ],
            [
                [
                    190,
                    80,
                    35,
                    99,
                    180,
                    80,
                    126,
                    54,
                    45
                ],
                [
                    85,
                    126,
                    47,
                    87,
                    176,
                    51,
                    41,
                    20,
                    32
                ],
                [
                    101,
                    75,
                    128,
                    139,
                    118,
                    146,
                    116,
                    128,
                    85
                ],
                [
                    56,
                    41,
                    15,
                    176,
                    236,
                    85,
                    37,
                    9,
                    62
                ],
                [
                    71,
                    30,
                    17,
                    119,
                    118,
                    255,
                    17,
                    18,
                    138
                ],
                [
                    101,
                    38,
                    60,
                    138,
                    55,
                    70,
                    43,
                    26,
                    142
                ],
                [
                    146,
                    36,
                    19,
                    30,
                    171,
                    255,
                    97,
                    27,
                    20
                ],
                [
                    138,
                    45,
                    61,
                    62,
                    219,
                    1,
                    81,
                    188,
                    64
                ],
                [
                    32,
                    41,
                    20,
                    117,
                    151,
                    142,
                    20,
                    21,
                    163
                ],
                [
                    112,
                    19,
                    12,
                    61,
                    195,
                    128,
                    48,
                    4,
                    24
                ]
            ]
        ], ui = [
            [
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        176,
                        246,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        241,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        244,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        246,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        239,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        217,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        225,
                        252,
                        241,
                        253,
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        250,
                        241,
                        250,
                        253,
                        255,
                        253,
                        254,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        238,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        247,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        186,
                        251,
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        251,
                        244,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        251,
                        243,
                        253,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        236,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        253,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        248,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        254,
                        252,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        249,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        246,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        254,
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        245,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ]
        ], ci = [
            0,
            1,
            2,
            3,
            6,
            4,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            0
        ], li = [], hi = [], fi = [], di = 1, pi = 2, gi = [], mi = [];
        mr("UpsampleRgbLinePair", Lr, 3), mr("UpsampleBgrLinePair", xr, 3), mr("UpsampleRgbaLinePair", kr, 4), mr("UpsampleBgraLinePair", Pr, 4), mr("UpsampleArgbLinePair", _r, 4), mr("UpsampleRgba4444LinePair", Sr, 2), mr("UpsampleRgb565LinePair", Ar, 2);
        var vi = t.UpsampleRgbLinePair, bi = t.UpsampleBgrLinePair, yi = t.UpsampleRgbaLinePair, wi = t.UpsampleBgraLinePair, Ni = t.UpsampleArgbLinePair, Li = t.UpsampleRgba4444LinePair, xi = t.UpsampleRgb565LinePair, Ai = 16, Si = 1 << Ai - 1, _i = -227, Pi = 482, ki = 6, Fi = (256 << ki) - 1, Ii = 0, Ci = a(256), ji = a(256), Oi = a(256), Bi = a(256), Mi = a(Pi - _i), qi = a(Pi - _i);
        Fr("YuvToRgbRow", Lr, 3), Fr("YuvToBgrRow", xr, 3), Fr("YuvToRgbaRow", kr, 4), Fr("YuvToBgraRow", Pr, 4), Fr("YuvToArgbRow", _r, 4), Fr("YuvToRgba4444Row", Sr, 2), Fr("YuvToRgb565Row", Ar, 2);
        var Ei = [
            0,
            4,
            8,
            12,
            128,
            132,
            136,
            140,
            256,
            260,
            264,
            268,
            384,
            388,
            392,
            396
        ], Ri = [
            0,
            2,
            8
        ], Di = [
            8,
            7,
            6,
            4,
            4,
            2,
            2,
            2,
            1,
            1,
            1,
            1
        ], Ti = 1;
        this.WebPDecodeRGBA = function(t, r, s, u, c) {
            var l = qn, h = new er, f = new ot;
            h.ba = f, f.S = l, f.width = [
                f.width
            ], f.height = [
                f.height
            ];
            var d = f.width, p = f.height, g = new st;
            if (null == g || null == t) var m = 2;
            else e(null != g), m = Or(t, r, s, g.width, g.height, g.Pd, g.Qd, g.format, null);
            if (0 != m ? d = 0 : (null != d && (d[0] = g.width[0]), null != p && (p[0] = g.height[0]), d = 1), d) {
                f.width = f.width[0], f.height = f.height[0], null != u && (u[0] = f.width), null != c && (c[0] = f.height);
                t: {
                    if (u = new Gt, (c = new rr).data = t, c.w = r, c.ha = s, c.kd = 1, r = [
                        0
                    ], e(null != c), (0 == (t = Or(c.data, c.w, c.ha, null, null, null, r, null, c)) || 7 == t) && r[0] && (t = 4), 0 == (r = t)) {
                        if (e(null != h), u.data = c.data, u.w = c.w + c.offset, u.ha = c.ha - c.offset, u.put = dt, u.ac = ft, u.bc = pt, u.ma = h, c.xa) {
                            if (null == (t = kt())) {
                                h = 1;
                                break t;
                            }
                            if (function(t, r) {
                                var n = [
                                    0
                                ], i = [
                                    0
                                ], a = [
                                    0
                                ];
                                e: for(;;){
                                    if (null == t) return 0;
                                    if (null == r) return t.a = 2, 0;
                                    if (t.l = r, t.a = 0, v(t.m, r.data, r.w, r.ha), !gt(t.m, n, i, a)) {
                                        t.a = 3;
                                        break e;
                                    }
                                    if (t.xb = pi, r.width = n[0], r.height = i[0], !Ft(n[0], i[0], 1, t, null)) break e;
                                    return 1;
                                }
                                return e(0 != t.a), 0;
                            }(t, u)) {
                                if (u = 0 == (r = qr(u.width, u.height, h.Oa, h.ba))) {
                                    e: {
                                        u = t;
                                        r: for(;;){
                                            if (null == u) {
                                                u = 0;
                                                break e;
                                            }
                                            if (e(null != u.s.yc), e(null != u.s.Ya), e(0 < u.s.Wb), e(null != (s = u.l)), e(null != (c = s.ma)), 0 != u.xb) {
                                                if (u.ca = c.ba, u.tb = c.tb, e(null != u.ca), !Br(c.Oa, s, Rn)) {
                                                    u.a = 2;
                                                    break r;
                                                }
                                                if (!It(u, s.width)) break r;
                                                if (s.da) break r;
                                                if ((s.da || nt(u.ca.S)) && gr(), 11 > u.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), null != u.ca.f.kb.F && gr()), u.Pb && 0 < u.s.ua && null == u.s.vb.X && !O(u.s.vb, u.s.Wa.Xa)) {
                                                    u.a = 1;
                                                    break r;
                                                }
                                                u.xb = 0;
                                            }
                                            if (!_t(u, u.V, u.Ba, u.c, u.i, s.o, Lt)) break r;
                                            c.Dc = u.Ma, u = 1;
                                            break e;
                                        }
                                        e(0 != u.a), u = 0;
                                    }
                                    u = !u;
                                }
                                u && (r = t.a);
                            } else r = t.a;
                        } else {
                            t = new Yt;
                            if (t.Fa = c.na, t.P = c.P, t.qc = c.Sa, Kt(t, u)) {
                                if (0 == (r = qr(u.width, u.height, h.Oa, h.ba))) {
                                    if (t.Aa = 0, s = h.Oa, e(null != (c = t)), null != s) {
                                        if (0 < (d = 0 > (d = s.Md) ? 0 : 100 < d ? 255 : 255 * d / 100)) {
                                            for(p = g = 0; 4 > p; ++p)12 > (m = c.pb[p]).lc && (m.ia = d * Di[0 > m.lc ? 0 : m.lc] >> 3), g |= m.ia;
                                            g && (alert("todo:VP8InitRandom"), c.ia = 1);
                                        }
                                        c.Ga = s.Id, 100 < c.Ga ? c.Ga = 100 : 0 > c.Ga && (c.Ga = 0);
                                    }
                                    (function(t, r) {
                                        if (null == t) return 0;
                                        if (null == r) return Jt(t, 2, "NULL VP8Io parameter in VP8Decode().");
                                        if (!t.cb && !Kt(t, r)) return 0;
                                        if (e(t.cb), null == r.ac || r.ac(r)) {
                                            r.ob && (t.L = 0);
                                            var s = Ri[t.L];
                                            if (2 == t.L ? (t.yb = 0, t.zb = 0) : (t.yb = r.v - s >> 4, t.zb = r.j - s >> 4, 0 > t.yb && (t.yb = 0), 0 > t.zb && (t.zb = 0)), t.Va = r.o + 15 + s >> 4, t.Hb = r.va + 15 + s >> 4, t.Hb > t.za && (t.Hb = t.za), t.Va > t.Ub && (t.Va = t.Ub), 0 < t.L) {
                                                var u = t.ed;
                                                for(s = 0; 4 > s; ++s){
                                                    var c;
                                                    if (t.Qa.Cb) {
                                                        var l = t.Qa.Lb[s];
                                                        t.Qa.Fb || (l += u.Tb);
                                                    } else l = u.Tb;
                                                    for(c = 0; 1 >= c; ++c){
                                                        var h = t.gd[s][c], f = l;
                                                        if (u.Pc && (f += u.vd[0], c && (f += u.od[0])), 0 < (f = 0 > f ? 0 : 63 < f ? 63 : f)) {
                                                            var d = f;
                                                            0 < u.wb && (d = 4 < u.wb ? d >> 2 : d >> 1) > 9 - u.wb && (d = 9 - u.wb), 1 > d && (d = 1), h.dd = d, h.tc = 2 * f + d, h.ld = 40 <= f ? 2 : 15 <= f ? 1 : 0;
                                                        } else h.tc = 0;
                                                        h.La = c;
                                                    }
                                                }
                                            }
                                            s = 0;
                                        } else Jt(t, 6, "Frame setup failed"), s = t.a;
                                        if (s = 0 == s) {
                                            if (s) {
                                                t.$c = 0, 0 < t.Aa || (t.Ic = Ti);
                                                e: {
                                                    s = t.Ic, u = 4 * (d = t.za);
                                                    var p = 32 * d, g = d + 1, m = 0 < t.L ? d * (0 < t.Aa ? 2 : 1) : 0, v = (2 == t.Aa ? 2 : 1) * d;
                                                    if ((h = u + 832 + (c = 3 * (16 * s + Ri[t.L]) / 2 * p) + (l = null != t.Fa && 0 < t.Fa.length ? t.Kc.c * t.Kc.i : 0)) != h) s = 0;
                                                    else {
                                                        if (h > t.Vb) {
                                                            if (t.Vb = 0, t.Ec = a(h), t.Fc = 0, null == t.Ec) {
                                                                s = Jt(t, 1, "no memory during frame initialization.");
                                                                break e;
                                                            }
                                                            t.Vb = h;
                                                        }
                                                        h = t.Ec, f = t.Fc, t.Ac = h, t.Bc = f, f += u, t.Gd = o(p, Ht), t.Hd = 0, t.rb = o(g + 1, Dt), t.sb = 1, t.wa = m ? o(m, Rt) : null, t.Y = 0, t.D.Nb = 0, t.D.wa = t.wa, t.D.Y = t.Y, 0 < t.Aa && (t.D.Y += d), e(!0), t.oc = h, t.pc = f, f += 832, t.ya = o(v, zt), t.aa = 0, t.D.ya = t.ya, t.D.aa = t.aa, 2 == t.Aa && (t.D.aa += d), t.R = 16 * d, t.B = 8 * d, d = (p = Ri[t.L]) * t.R, p = p / 2 * t.B, t.sa = h, t.ta = f + d, t.qa = t.sa, t.ra = t.ta + 16 * s * t.R + p, t.Ha = t.qa, t.Ia = t.ra + 8 * s * t.B + p, t.$c = 0, f += c, t.mb = l ? h : null, t.nb = l ? f : null, e(f + l <= t.Fc + t.Vb), $t(t), i(t.Ac, t.Bc, 0, u), s = 1;
                                                    }
                                                }
                                                if (s) {
                                                    if (r.ka = 0, r.y = t.sa, r.O = t.ta, r.f = t.qa, r.N = t.ra, r.ea = t.Ha, r.Vd = t.Ia, r.fa = t.R, r.Rc = t.B, r.F = null, r.J = 0, !In) {
                                                        for(s = -255; 255 >= s; ++s)_n[255 + s] = 0 > s ? -s : s;
                                                        for(s = -1020; 1020 >= s; ++s)Pn[1020 + s] = -128 > s ? -128 : 127 < s ? 127 : s;
                                                        for(s = -112; 112 >= s; ++s)kn[112 + s] = -16 > s ? -16 : 15 < s ? 15 : s;
                                                        for(s = -255; 510 >= s; ++s)Fn[255 + s] = 0 > s ? 0 : 255 < s ? 255 : s;
                                                        In = 1;
                                                    }
                                                    nn = ue, an = ie, sn = ae, un = oe, cn = se, on = ne, ln = Ye, hn = Je, fn = Ze, dn = $e, pn = Xe, gn = Ke, mn = Qe, vn = tr, bn = ze, yn = Ue, wn = He, Nn = We, hi[0] = xe, hi[1] = le, hi[2] = Ne, hi[3] = Le, hi[4] = Ae, hi[5] = _e, hi[6] = Se, hi[7] = Pe, hi[8] = Fe, hi[9] = ke, li[0] = me, li[1] = fe, li[2] = de, li[3] = pe, li[4] = ve, li[5] = be, li[6] = ye, fi[0] = Oe, fi[1] = he, fi[2] = Ie, fi[3] = Ce, fi[4] = Me, fi[5] = Be, fi[6] = qe, s = 1;
                                                } else s = 0;
                                            }
                                            s && (s = function(t, r) {
                                                for(t.M = 0; t.M < t.Va; ++t.M){
                                                    var o, s = t.Jc[t.M & t.Xb], u = t.m, c = t;
                                                    for(o = 0; o < c.za; ++o){
                                                        var l = u, h = c, f = h.Ac, d = h.Bc + 4 * o, p = h.zc, g = h.ya[h.aa + o];
                                                        if (h.Qa.Bb ? g.$b = k(l, h.Pa.jb[0]) ? 2 + k(l, h.Pa.jb[2]) : k(l, h.Pa.jb[1]) : g.$b = 0, h.kc && (g.Ad = k(l, h.Bd)), g.Za = !k(l, 145) + 0, g.Za) {
                                                            var m = g.Ob, v = 0;
                                                            for(h = 0; 4 > h; ++h){
                                                                var b, y = p[0 + h];
                                                                for(b = 0; 4 > b; ++b){
                                                                    y = si[f[d + b]][y];
                                                                    for(var w = ai[k(l, y[0])]; 0 < w;)w = ai[2 * w + k(l, y[w])];
                                                                    y = -w, f[d + b] = y;
                                                                }
                                                                n(m, v, f, d, 4), v += 4, p[0 + h] = y;
                                                            }
                                                        } else y = k(l, 156) ? k(l, 128) ? 1 : 3 : k(l, 163) ? 2 : 0, g.Ob[0] = y, i(f, d, y, 4), i(p, 0, y, 4);
                                                        g.Dd = k(l, 142) ? k(l, 114) ? k(l, 183) ? 1 : 3 : 2 : 0;
                                                    }
                                                    if (c.m.Ka) return Jt(t, 7, "Premature end-of-partition0 encountered.");
                                                    for(; t.ja < t.za; ++t.ja){
                                                        if (c = s, l = (u = t).rb[u.sb - 1], f = u.rb[u.sb + u.ja], o = u.ya[u.aa + u.ja], d = u.kc ? o.Ad : 0) l.la = f.la = 0, o.Za || (l.Na = f.Na = 0), o.Hc = 0, o.Gc = 0, o.ia = 0;
                                                        else {
                                                            var N, L;
                                                            if (l = f, f = c, d = u.Pa.Xc, p = u.ya[u.aa + u.ja], g = u.pb[p.$b], h = p.ad, m = 0, v = u.rb[u.sb - 1], y = b = 0, i(h, m, 0, 384), p.Za) var x = 0, A = d[3];
                                                            else {
                                                                w = a(16);
                                                                var S = l.Na + v.Na;
                                                                if (S = ri(f, d[1], S, g.Eb, 0, w, 0), l.Na = v.Na = (0 < S) + 0, 1 < S) nn(w, 0, h, m);
                                                                else {
                                                                    var _ = w[0] + 3 >> 3;
                                                                    for(w = 0; 256 > w; w += 16)h[m + w] = _;
                                                                }
                                                                x = 1, A = d[0];
                                                            }
                                                            var P = 15 & l.la, F = 15 & v.la;
                                                            for(w = 0; 4 > w; ++w){
                                                                var I = 1 & F;
                                                                for(_ = L = 0; 4 > _; ++_)P = P >> 1 | (I = (S = ri(f, A, S = I + (1 & P), g.Sc, x, h, m)) > x) << 7, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != h[m + 0]), m += 16;
                                                                P >>= 4, F = F >> 1 | I << 7, b = (b << 8 | L) >>> 0;
                                                            }
                                                            for(A = P, x = F >> 4, N = 0; 4 > N; N += 2){
                                                                for(L = 0, P = l.la >> 4 + N, F = v.la >> 4 + N, w = 0; 2 > w; ++w){
                                                                    for(I = 1 & F, _ = 0; 2 > _; ++_)S = I + (1 & P), P = P >> 1 | (I = 0 < (S = ri(f, d[2], S, g.Qc, 0, h, m))) << 3, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != h[m + 0]), m += 16;
                                                                    P >>= 2, F = F >> 1 | I << 5;
                                                                }
                                                                y |= L << 4 * N, A |= P << 4 << N, x |= (240 & F) << N;
                                                            }
                                                            l.la = A, v.la = x, p.Hc = b, p.Gc = y, p.ia = 43690 & y ? 0 : g.ia, d = !(b | y);
                                                        }
                                                        if (0 < u.L && (u.wa[u.Y + u.ja] = u.gd[o.$b][o.Za], u.wa[u.Y + u.ja].La |= !d), c.Ka) return Jt(t, 7, "Premature end-of-file encountered.");
                                                    }
                                                    if ($t(t), u = r, c = 1, o = (s = t).D, l = 0 < s.L && s.M >= s.zb && s.M <= s.Va, 0 == s.Aa) e: {
                                                        if (o.M = s.M, o.uc = l, jr(s, o), c = 1, o = (L = s.D).Nb, l = (y = Ri[s.L]) * s.R, f = y / 2 * s.B, w = 16 * o * s.R, _ = 8 * o * s.B, d = s.sa, p = s.ta - l + w, g = s.qa, h = s.ra - f + _, m = s.Ha, v = s.Ia - f + _, F = 0 == (P = L.M), b = P >= s.Va - 1, 2 == s.Aa && jr(s, L), L.uc) for(I = (S = s).D.M, e(S.D.uc), L = S.yb; L < S.Hb; ++L){
                                                            x = L, A = I;
                                                            var C = (j = (z = S).D).Nb;
                                                            N = z.R;
                                                            var j = j.wa[j.Y + x], O = z.sa, B = z.ta + 16 * C * N + 16 * x, M = j.dd, q = j.tc;
                                                            if (0 != q) {
                                                                if (e(3 <= q), 1 == z.L) 0 < x && yn(O, B, N, q + 4), j.La && Nn(O, B, N, q), 0 < A && bn(O, B, N, q + 4), j.La && wn(O, B, N, q);
                                                                else {
                                                                    var E = z.B, R = z.qa, D = z.ra + 8 * C * E + 8 * x, T = z.Ha, z = z.Ia + 8 * C * E + 8 * x;
                                                                    C = j.ld, 0 < x && (hn(O, B, N, q + 4, M, C), dn(R, D, T, z, E, q + 4, M, C)), j.La && (gn(O, B, N, q, M, C), vn(R, D, T, z, E, q, M, C)), 0 < A && (ln(O, B, N, q + 4, M, C), fn(R, D, T, z, E, q + 4, M, C)), j.La && (pn(O, B, N, q, M, C), mn(R, D, T, z, E, q, M, C));
                                                                }
                                                            }
                                                        }
                                                        if (s.ia && alert("todo:DitherRow"), null != u.put) {
                                                            if (L = 16 * P, P = 16 * (P + 1), F ? (u.y = s.sa, u.O = s.ta + w, u.f = s.qa, u.N = s.ra + _, u.ea = s.Ha, u.W = s.Ia + _) : (L -= y, u.y = d, u.O = p, u.f = g, u.N = h, u.ea = m, u.W = v), b || (P -= y), P > u.o && (P = u.o), u.F = null, u.J = null, null != s.Fa && 0 < s.Fa.length && L < P && (u.J = lr(s, u, L, P - L), u.F = s.mb, null == u.F && 0 == u.F.length)) {
                                                                c = Jt(s, 3, "Could not decode alpha data.");
                                                                break e;
                                                            }
                                                            L < u.j && (y = u.j - L, L = u.j, e(!(1 & y)), u.O += s.R * y, u.N += s.B * (y >> 1), u.W += s.B * (y >> 1), null != u.F && (u.J += u.width * y)), L < P && (u.O += u.v, u.N += u.v >> 1, u.W += u.v >> 1, null != u.F && (u.J += u.v), u.ka = L - u.j, u.U = u.va - u.v, u.T = P - L, c = u.put(u));
                                                        }
                                                        o + 1 != s.Ic || b || (n(s.sa, s.ta - l, d, p + 16 * s.R, l), n(s.qa, s.ra - f, g, h + 8 * s.B, f), n(s.Ha, s.Ia - f, m, v + 8 * s.B, f));
                                                    }
                                                    if (!c) return Jt(t, 6, "Output aborted.");
                                                }
                                                return 1;
                                            }(t, r)), null != r.bc && r.bc(r), s &= 1;
                                        }
                                        return s ? (t.cb = 0, s) : 0;
                                    })(t, u) || (r = t.a);
                                }
                            } else r = t.a;
                        }
                        0 == r && null != h.Oa && h.Oa.fd && (r = Mr(h.ba));
                    }
                    h = r;
                }
                l = 0 != h ? null : 11 > l ? f.f.RGBA.eb : f.f.kb.y;
            } else l = null;
            return l;
        };
        var zi = [
            3,
            4,
            3,
            4,
            4,
            2,
            2,
            4,
            4,
            4,
            2,
            1,
            1
        ];
    };
    function c(t, e) {
        for(var r = "", n = 0; n < 4; n++)r += String.fromCharCode(t[e++]);
        return r;
    }
    function l(t, e) {
        return t[e + 0] | t[e + 1] << 8;
    }
    function h(t, e) {
        return (t[e + 0] | t[e + 1] << 8 | t[e + 2] << 16) >>> 0;
    }
    function f(t, e) {
        return (t[e + 0] | t[e + 1] << 8 | t[e + 2] << 16 | t[e + 3] << 24) >>> 0;
    }
    new u;
    var d = [
        0
    ], p = [
        0
    ], g = [], m = new u, v = t, b = function(t, e) {
        var r = {}, n = 0, i = !1, a = 0, o = 0;
        if (r.frames = [], !/** @license
   * Copyright (c) 2017 Dominik Homberger
  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  https://webpjs.appspot.com
  WebPRiffParser dominikhlbg@gmail.com
  */ function(t, e) {
            for(var r = 0; r < 4; r++)if (t[e + r] != "RIFF".charCodeAt(r)) return !0;
            return !1;
        }(t, e)) {
            for(f(t, e += 4), e += 8; e < t.length;){
                var s = c(t, e), u = f(t, e += 4);
                e += 4;
                var d = u + (1 & u);
                switch(s){
                    case "VP8 ":
                    case "VP8L":
                        void 0 === r.frames[n] && (r.frames[n] = {}), (m = r.frames[n]).src_off = i ? o : e - 8, m.src_size = a + u + 8, n++, i && (i = !1, a = 0, o = 0);
                        break;
                    case "VP8X":
                        (m = r.header = {}).feature_flags = t[e];
                        var p = e + 4;
                        m.canvas_width = 1 + h(t, p), p += 3, m.canvas_height = 1 + h(t, p), p += 3;
                        break;
                    case "ALPH":
                        i = !0, a = d + 8, o = e - 8;
                        break;
                    case "ANIM":
                        (m = r.header).bgcolor = f(t, e), p = e + 4, m.loop_count = l(t, p), p += 2;
                        break;
                    case "ANMF":
                        var g, m;
                        (m = r.frames[n] = {}).offset_x = 2 * h(t, e), e += 3, m.offset_y = 2 * h(t, e), e += 3, m.width = 1 + h(t, e), e += 3, m.height = 1 + h(t, e), e += 3, m.duration = h(t, e), e += 3, g = t[e++], m.dispose = 1 & g, m.blend = g >> 1 & 1;
                }
                "ANMF" != s && (e += d);
            }
            return r;
        }
    }(v, 0);
    b.response = v, b.rgbaoutput = !0, b.dataurl = !1;
    var y = b.header ? b.header : null, w = b.frames ? b.frames : null;
    if (y) {
        y.loop_counter = y.loop_count, d = [
            y.canvas_height
        ], p = [
            y.canvas_width
        ];
        for(var N = 0; N < w.length && 0 != w[N].blend; N++);
    }
    var L = w[0], x = m.WebPDecodeRGBA(v, L.src_off, L.src_size, p, d);
    L.rgba = x, L.imgwidth = p[0], L.imgheight = d[0];
    for(var A = 0; A < p[0] * d[0] * 4; A++)g[A] = x[A];
    return this.width = p, this.height = d, this.data = g, this;
}
/** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function $dbd37edd557d3750$var$ce() {
    var t, e = this.internal.__metadata__.metadata, r = unescape(encodeURIComponent(e));
    t = this.internal.__metadata__.rawXml ? r : '<x:xmpmeta xmlns:x="adobe:ns:meta/"><rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceUri + '"><jspdf:metadata>' + r.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;") + "</jspdf:metadata></rdf:Description></rdf:RDF></x:xmpmeta>", this.internal.__metadata__.metadataObjectNumber = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + t.length + " >>"), this.internal.write("stream"), this.internal.write(t), this.internal.write("endstream"), this.internal.write("endobj");
}
function $dbd37edd557d3750$var$le() {
    this.internal.__metadata__.metadataObjectNumber && this.internal.write("/Metadata " + this.internal.__metadata__.metadataObjectNumber + " 0 R");
}



!function(e) {
    var r, n, i, a, s, u, c, l, f, d = function(t) {
        return t = t || {}, this.isStrokeTransparent = t.isStrokeTransparent || !1, this.strokeOpacity = t.strokeOpacity || 1, this.strokeStyle = t.strokeStyle || "#000000", this.fillStyle = t.fillStyle || "#000000", this.isFillTransparent = t.isFillTransparent || !1, this.fillOpacity = t.fillOpacity || 1, this.font = t.font || "10px sans-serif", this.textBaseline = t.textBaseline || "alphabetic", this.textAlign = t.textAlign || "left", this.lineWidth = t.lineWidth || 1, this.lineJoin = t.lineJoin || "miter", this.lineCap = t.lineCap || "butt", this.path = t.path || [], this.transform = void 0 !== t.transform ? t.transform.clone() : new l, this.globalCompositeOperation = t.globalCompositeOperation || "normal", this.globalAlpha = t.globalAlpha || 1, this.clip_path = t.clip_path || [], this.currentPoint = t.currentPoint || new u, this.miterLimit = t.miterLimit || 10, this.lastPoint = t.lastPoint || new u, this.lineDashOffset = t.lineDashOffset || 0, this.lineDash = t.lineDash || [], this.margin = t.margin || [
            0,
            0,
            0,
            0
        ], this.prevPageLastElemOffset = t.prevPageLastElemOffset || 0, this.ignoreClearRect = "boolean" != typeof t.ignoreClearRect || t.ignoreClearRect, this;
    };
    e.events.push([
        "initialized",
        function() {
            this.context2d = new p(this), r = this.internal.f2, n = this.internal.getCoordinateString, i = this.internal.getVerticalCoordinateString, a = this.internal.getHorizontalCoordinate, s = this.internal.getVerticalCoordinate, u = this.internal.Point, c = this.internal.Rectangle, l = this.internal.Matrix, f = new d;
        }
    ]);
    var p = function(t) {
        Object.defineProperty(this, "canvas", {
            get: function() {
                return {
                    parentNode: !1,
                    style: !1
                };
            }
        });
        var e = t;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return e;
            }
        });
        var r = !1;
        Object.defineProperty(this, "pageWrapXEnabled", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = Boolean(t);
            }
        });
        var n = !1;
        Object.defineProperty(this, "pageWrapYEnabled", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = Boolean(t);
            }
        });
        var i = 0;
        Object.defineProperty(this, "posX", {
            get: function() {
                return i;
            },
            set: function(t) {
                isNaN(t) || (i = t);
            }
        });
        var a = 0;
        Object.defineProperty(this, "posY", {
            get: function() {
                return a;
            },
            set: function(t) {
                isNaN(t) || (a = t);
            }
        }), Object.defineProperty(this, "margin", {
            get: function() {
                return f.margin;
            },
            set: function(t) {
                var e;
                "number" == typeof t ? e = [
                    t,
                    t,
                    t,
                    t
                ] : ((e = new Array(4))[0] = t[0], e[1] = t.length >= 2 ? t[1] : e[0], e[2] = t.length >= 3 ? t[2] : e[0], e[3] = t.length >= 4 ? t[3] : e[1]), f.margin = e;
            }
        });
        var o = !1;
        Object.defineProperty(this, "autoPaging", {
            get: function() {
                return o;
            },
            set: function(t) {
                o = t;
            }
        });
        var s = 0;
        Object.defineProperty(this, "lastBreak", {
            get: function() {
                return s;
            },
            set: function(t) {
                s = t;
            }
        });
        var u = [];
        Object.defineProperty(this, "pageBreaks", {
            get: function() {
                return u;
            },
            set: function(t) {
                u = t;
            }
        }), Object.defineProperty(this, "ctx", {
            get: function() {
                return f;
            },
            set: function(t) {
                t instanceof d && (f = t);
            }
        }), Object.defineProperty(this, "path", {
            get: function() {
                return f.path;
            },
            set: function(t) {
                f.path = t;
            }
        });
        var c = [];
        Object.defineProperty(this, "ctxStack", {
            get: function() {
                return c;
            },
            set: function(t) {
                c = t;
            }
        }), Object.defineProperty(this, "fillStyle", {
            get: function() {
                return this.ctx.fillStyle;
            },
            set: function(t) {
                var e;
                e = g(t), this.ctx.fillStyle = e.style, this.ctx.isFillTransparent = 0 === e.a, this.ctx.fillOpacity = e.a, this.pdf.setFillColor(e.r, e.g, e.b, {
                    a: e.a
                }), this.pdf.setTextColor(e.r, e.g, e.b, {
                    a: e.a
                });
            }
        }), Object.defineProperty(this, "strokeStyle", {
            get: function() {
                return this.ctx.strokeStyle;
            },
            set: function(t) {
                var e = g(t);
                this.ctx.strokeStyle = e.style, this.ctx.isStrokeTransparent = 0 === e.a, this.ctx.strokeOpacity = e.a, 0 === e.a ? this.pdf.setDrawColor(255, 255, 255) : (e.a, this.pdf.setDrawColor(e.r, e.g, e.b));
            }
        }), Object.defineProperty(this, "lineCap", {
            get: function() {
                return this.ctx.lineCap;
            },
            set: function(t) {
                -1 !== [
                    "butt",
                    "round",
                    "square"
                ].indexOf(t) && (this.ctx.lineCap = t, this.pdf.setLineCap(t));
            }
        }), Object.defineProperty(this, "lineWidth", {
            get: function() {
                return this.ctx.lineWidth;
            },
            set: function(t) {
                isNaN(t) || (this.ctx.lineWidth = t, this.pdf.setLineWidth(t));
            }
        }), Object.defineProperty(this, "lineJoin", {
            get: function() {
                return this.ctx.lineJoin;
            },
            set: function(t) {
                -1 !== [
                    "bevel",
                    "round",
                    "miter"
                ].indexOf(t) && (this.ctx.lineJoin = t, this.pdf.setLineJoin(t));
            }
        }), Object.defineProperty(this, "miterLimit", {
            get: function() {
                return this.ctx.miterLimit;
            },
            set: function(t) {
                isNaN(t) || (this.ctx.miterLimit = t, this.pdf.setMiterLimit(t));
            }
        }), Object.defineProperty(this, "textBaseline", {
            get: function() {
                return this.ctx.textBaseline;
            },
            set: function(t) {
                this.ctx.textBaseline = t;
            }
        }), Object.defineProperty(this, "textAlign", {
            get: function() {
                return this.ctx.textAlign;
            },
            set: function(t) {
                -1 !== [
                    "right",
                    "end",
                    "center",
                    "left",
                    "start"
                ].indexOf(t) && (this.ctx.textAlign = t);
            }
        });
        var l = null, h = null;
        var p = null;
        Object.defineProperty(this, "fontFaces", {
            get: function() {
                return p;
            },
            set: function(t) {
                l = null, h = null, p = t;
            }
        }), Object.defineProperty(this, "font", {
            get: function() {
                return this.ctx.font;
            },
            set: function(t) {
                var e;
                if (this.ctx.font = t, null !== (e = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z0-9]+?)\s*$/i.exec(t))) {
                    var r = e[1];
                    e[2];
                    var n = e[3], i = e[4];
                    e[5];
                    var a = e[6], o = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];
                    i = "px" === o ? Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor) : "em" === o ? Math.floor(parseFloat(i) * this.pdf.getFontSize()) : Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(i);
                    var s = function(t) {
                        var e, r, n = [], i = t.trim();
                        if ("" === i) return $dbd37edd557d3750$var$Gt;
                        if (i in $dbd37edd557d3750$var$qt) return [
                            $dbd37edd557d3750$var$qt[i]
                        ];
                        for(; "" !== i;){
                            switch(r = null, e = (i = $dbd37edd557d3750$var$Rt(i)).charAt(0)){
                                case '"':
                                case "'":
                                    r = $dbd37edd557d3750$var$Dt(i.substring(1), e);
                                    break;
                                default:
                                    r = $dbd37edd557d3750$var$Tt(i);
                            }
                            if (null === r) return $dbd37edd557d3750$var$Gt;
                            if (n.push(r[0]), "" !== (i = $dbd37edd557d3750$var$Rt(r[1])) && "," !== i.charAt(0)) return $dbd37edd557d3750$var$Gt;
                            i = i.replace(/^,/, "");
                        }
                        return n;
                    }(a);
                    if (this.fontFaces) {
                        var u = function(t, e) {
                            var r = t.getFontList(), n = JSON.stringify(r);
                            if (null === l || h !== n) {
                                var i = function(t) {
                                    var e = [];
                                    return Object.keys(t).forEach(function(r) {
                                        t[r].forEach(function(t) {
                                            var n = null;
                                            switch(t){
                                                case "bold":
                                                    n = {
                                                        family: r,
                                                        weight: "bold"
                                                    };
                                                    break;
                                                case "italic":
                                                    n = {
                                                        family: r,
                                                        style: "italic"
                                                    };
                                                    break;
                                                case "bolditalic":
                                                    n = {
                                                        family: r,
                                                        weight: "bold",
                                                        style: "italic"
                                                    };
                                                    break;
                                                case "":
                                                case "normal":
                                                    n = {
                                                        family: r
                                                    };
                                            }
                                            null !== n && (n.ref = {
                                                name: r,
                                                style: t
                                            }, e.push(n));
                                        });
                                    }), e;
                                }(r);
                                l = function(t) {
                                    for(var e = {}, r = 0; r < t.length; ++r){
                                        var n = $dbd37edd557d3750$var$Ot(t[r]), i = n.family, a = n.stretch, o = n.style, s = n.weight;
                                        e[i] = e[i] || {}, e[i][a] = e[i][a] || {}, e[i][a][o] = e[i][a][o] || {}, e[i][a][o][s] = n;
                                    }
                                    return e;
                                }(i.concat(e)), h = n;
                            }
                            return l;
                        }(this.pdf, this.fontFaces), c = s.map(function(t) {
                            return {
                                family: t,
                                stretch: "normal",
                                weight: n,
                                style: r
                            };
                        }), f = function(t, e, r) {
                            for(var n = (r = r || {}).defaultFontFamily || "times", i = Object.assign({}, $dbd37edd557d3750$var$Mt, r.genericFontFamilies || {}), a = null, o = null, s = 0; s < e.length; ++s)if (i[(a = $dbd37edd557d3750$var$Ot(e[s])).family] && (a.family = i[a.family]), t.hasOwnProperty(a.family)) {
                                o = t[a.family];
                                break;
                            }
                            if (!(o = o || t[n])) throw new Error("Could not find a font-family for the rule '" + $dbd37edd557d3750$var$Et(a) + "' and default family '" + n + "'.");
                            if (o = function(t, e) {
                                if (e[t]) return e[t];
                                var r = $dbd37edd557d3750$var$It[t], n = r <= $dbd37edd557d3750$var$It.normal ? -1 : 1, i = $dbd37edd557d3750$var$Bt(e, $dbd37edd557d3750$var$Ft, r, n);
                                if (!i) throw new Error("Could not find a matching font-stretch value for " + t);
                                return i;
                            }(a.stretch, o), o = function(t, e) {
                                if (e[t]) return e[t];
                                for(var r = $dbd37edd557d3750$var$kt[t], n = 0; n < r.length; ++n)if (e[r[n]]) return e[r[n]];
                                throw new Error("Could not find a matching font-style for " + t);
                            }(a.style, o), !(o = function(t, e) {
                                if (e[t]) return e[t];
                                if (400 === t && e[500]) return e[500];
                                if (500 === t && e[400]) return e[400];
                                var r = $dbd37edd557d3750$var$jt[t], n = $dbd37edd557d3750$var$Bt(e, $dbd37edd557d3750$var$Ct, r, t < 400 ? -1 : 1);
                                if (!n) throw new Error("Could not find a matching font-weight for value " + t);
                                return n;
                            }(a.weight, o))) throw new Error("Failed to resolve a font for the rule '" + $dbd37edd557d3750$var$Et(a) + "'.");
                            return o;
                        }(u, c);
                        this.pdf.setFont(f.ref.name, f.ref.style);
                    } else {
                        var d = "";
                        ("bold" === n || parseInt(n, 10) >= 700 || "bold" === r) && (d = "bold"), "italic" === r && (d += "italic"), 0 === d.length && (d = "normal");
                        for(var p = "", g = {
                            arial: "Helvetica",
                            Arial: "Helvetica",
                            verdana: "Helvetica",
                            Verdana: "Helvetica",
                            helvetica: "Helvetica",
                            Helvetica: "Helvetica",
                            "sans-serif": "Helvetica",
                            fixed: "Courier",
                            monospace: "Courier",
                            terminal: "Courier",
                            cursive: "Times",
                            fantasy: "Times",
                            serif: "Times"
                        }, m = 0; m < s.length; m++){
                            if (void 0 !== this.pdf.internal.getFont(s[m], d, {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                p = s[m];
                                break;
                            }
                            if ("bolditalic" === d && void 0 !== this.pdf.internal.getFont(s[m], "bold", {
                                noFallback: !0,
                                disableWarning: !0
                            })) p = s[m], d = "bold";
                            else if (void 0 !== this.pdf.internal.getFont(s[m], "normal", {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                p = s[m], d = "normal";
                                break;
                            }
                        }
                        if ("" === p) {
                            for(var v = 0; v < s.length; v++)if (g[s[v]]) {
                                p = g[s[v]];
                                break;
                            }
                        }
                        p = "" === p ? "Times" : p, this.pdf.setFont(p, d);
                    }
                }
            }
        }), Object.defineProperty(this, "globalCompositeOperation", {
            get: function() {
                return this.ctx.globalCompositeOperation;
            },
            set: function(t) {
                this.ctx.globalCompositeOperation = t;
            }
        }), Object.defineProperty(this, "globalAlpha", {
            get: function() {
                return this.ctx.globalAlpha;
            },
            set: function(t) {
                this.ctx.globalAlpha = t;
            }
        }), Object.defineProperty(this, "lineDashOffset", {
            get: function() {
                return this.ctx.lineDashOffset;
            },
            set: function(t) {
                this.ctx.lineDashOffset = t, T.call(this);
            }
        }), Object.defineProperty(this, "lineDash", {
            get: function() {
                return this.ctx.lineDash;
            },
            set: function(t) {
                this.ctx.lineDash = t, T.call(this);
            }
        }), Object.defineProperty(this, "ignoreClearRect", {
            get: function() {
                return this.ctx.ignoreClearRect;
            },
            set: function(t) {
                this.ctx.ignoreClearRect = Boolean(t);
            }
        });
    };
    p.prototype.setLineDash = function(t) {
        this.lineDash = t;
    }, p.prototype.getLineDash = function() {
        return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
    }, p.prototype.fill = function() {
        x.call(this, "fill", !1);
    }, p.prototype.stroke = function() {
        x.call(this, "stroke", !1);
    }, p.prototype.beginPath = function() {
        this.path = [
            {
                type: "begin"
            }
        ];
    }, p.prototype.moveTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $dbd37edd557d3750$var$o.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
        var r = this.ctx.transform.applyToPoint(new u(t, e));
        this.path.push({
            type: "mt",
            x: r.x,
            y: r.y
        }), this.ctx.lastPoint = new u(t, e);
    }, p.prototype.closePath = function() {
        var e = new u(0, 0), r = 0;
        for(r = this.path.length - 1; -1 !== r; r--)if ("begin" === this.path[r].type && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(this.path[r + 1]) && "number" == typeof this.path[r + 1].x) {
            e = new u(this.path[r + 1].x, this.path[r + 1].y);
            break;
        }
        this.path.push({
            type: "close"
        }), this.ctx.lastPoint = new u(e.x, e.y);
    }, p.prototype.lineTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $dbd37edd557d3750$var$o.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
        var r = this.ctx.transform.applyToPoint(new u(t, e));
        this.path.push({
            type: "lt",
            x: r.x,
            y: r.y
        }), this.ctx.lastPoint = new u(r.x, r.y);
    }, p.prototype.clip = function() {
        this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), x.call(this, null, !0);
    }, p.prototype.quadraticCurveTo = function(t, e, r, n) {
        if (isNaN(r) || isNaN(n) || isNaN(t) || isNaN(e)) throw $dbd37edd557d3750$var$o.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
        var i = this.ctx.transform.applyToPoint(new u(r, n)), a = this.ctx.transform.applyToPoint(new u(t, e));
        this.path.push({
            type: "qct",
            x1: a.x,
            y1: a.y,
            x: i.x,
            y: i.y
        }), this.ctx.lastPoint = new u(i.x, i.y);
    }, p.prototype.bezierCurveTo = function(t, e, r, n, i, a) {
        if (isNaN(i) || isNaN(a) || isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $dbd37edd557d3750$var$o.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
        var s = this.ctx.transform.applyToPoint(new u(i, a)), c = this.ctx.transform.applyToPoint(new u(t, e)), l = this.ctx.transform.applyToPoint(new u(r, n));
        this.path.push({
            type: "bct",
            x1: c.x,
            y1: c.y,
            x2: l.x,
            y2: l.y,
            x: s.x,
            y: s.y
        }), this.ctx.lastPoint = new u(s.x, s.y);
    }, p.prototype.arc = function(t, e, r, n, i, a) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i)) throw $dbd37edd557d3750$var$o.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
        if (a = Boolean(a), !this.ctx.transform.isIdentity) {
            var s = this.ctx.transform.applyToPoint(new u(t, e));
            t = s.x, e = s.y;
            var c = this.ctx.transform.applyToPoint(new u(0, r)), l = this.ctx.transform.applyToPoint(new u(0, 0));
            r = Math.sqrt(Math.pow(c.x - l.x, 2) + Math.pow(c.y - l.y, 2));
        }
        Math.abs(i - n) >= 2 * Math.PI && (n = 0, i = 2 * Math.PI), this.path.push({
            type: "arc",
            x: t,
            y: e,
            radius: r,
            startAngle: n,
            endAngle: i,
            counterclockwise: a
        });
    }, p.prototype.arcTo = function(t, e, r, n, i) {
        throw new Error("arcTo not implemented.");
    }, p.prototype.rect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $dbd37edd557d3750$var$o.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
        this.moveTo(t, e), this.lineTo(t + r, e), this.lineTo(t + r, e + n), this.lineTo(t, e + n), this.lineTo(t, e), this.lineTo(t + r, e), this.lineTo(t, e);
    }, p.prototype.fillRect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $dbd37edd557d3750$var$o.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
        if (!m.call(this)) {
            var i = {};
            "butt" !== this.lineCap && (i.lineCap = this.lineCap, this.lineCap = "butt"), "miter" !== this.lineJoin && (i.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(t, e, r, n), this.fill(), i.hasOwnProperty("lineCap") && (this.lineCap = i.lineCap), i.hasOwnProperty("lineJoin") && (this.lineJoin = i.lineJoin);
        }
    }, p.prototype.strokeRect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $dbd37edd557d3750$var$o.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
        v.call(this) || (this.beginPath(), this.rect(t, e, r, n), this.stroke());
    }, p.prototype.clearRect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $dbd37edd557d3750$var$o.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
        this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(t, e, r, n));
    }, p.prototype.save = function(t) {
        t = "boolean" != typeof t || t;
        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, r = 0; r < this.pdf.internal.getNumberOfPages(); r++)this.pdf.setPage(r + 1), this.pdf.internal.out("q");
        if (this.pdf.setPage(e), t) {
            this.ctx.fontSize = this.pdf.internal.getFontSize();
            var n = new d(this.ctx);
            this.ctxStack.push(this.ctx), this.ctx = n;
        }
    }, p.prototype.restore = function(t) {
        t = "boolean" != typeof t || t;
        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, r = 0; r < this.pdf.internal.getNumberOfPages(); r++)this.pdf.setPage(r + 1), this.pdf.internal.out("Q");
        this.pdf.setPage(e), t && 0 !== this.ctxStack.length && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
    }, p.prototype.toDataURL = function() {
        throw new Error("toDataUrl not implemented.");
    };
    var g = function(t) {
        var e, r, n, i;
        if (!0 === t.isCanvasGradient && (t = t.getColor()), !t) return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            style: t
        };
        if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t)) e = 0, r = 0, n = 0, i = 0;
        else {
            var a = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);
            if (null !== a) e = parseInt(a[1]), r = parseInt(a[2]), n = parseInt(a[3]), i = 1;
            else if (null !== (a = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t))) e = parseInt(a[1]), r = parseInt(a[2]), n = parseInt(a[3]), i = parseFloat(a[4]);
            else {
                if (i = 1, "string" == typeof t && "#" !== t.charAt(0)) {
                    var o = new $dbd37edd557d3750$var$h(t);
                    t = o.ok ? o.toHex() : "#000000";
                }
                4 === t.length ? (e = t.substring(1, 2), e += e, r = t.substring(2, 3), r += r, n = t.substring(3, 4), n += n) : (e = t.substring(1, 3), r = t.substring(3, 5), n = t.substring(5, 7)), e = parseInt(e, 16), r = parseInt(r, 16), n = parseInt(n, 16);
            }
        }
        return {
            r: e,
            g: r,
            b: n,
            a: i,
            style: t
        };
    }, m = function() {
        return this.ctx.isFillTransparent || 0 == this.globalAlpha;
    }, v = function() {
        return Boolean(this.ctx.isStrokeTransparent || 0 == this.globalAlpha);
    };
    p.prototype.fillText = function(t, e, r, n) {
        if (isNaN(e) || isNaN(r) || "string" != typeof t) throw $dbd37edd557d3750$var$o.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
        if (n = isNaN(n) ? void 0 : n, !m.call(this)) {
            var i = E(this.ctx.transform.rotation), a = this.ctx.transform.scaleX;
            C.call(this, {
                text: t,
                x: e,
                y: r,
                scale: a,
                angle: i,
                align: this.textAlign,
                maxWidth: n
            });
        }
    }, p.prototype.strokeText = function(t, e, r, n) {
        if (isNaN(e) || isNaN(r) || "string" != typeof t) throw $dbd37edd557d3750$var$o.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
        if (!v.call(this)) {
            n = isNaN(n) ? void 0 : n;
            var i = E(this.ctx.transform.rotation), a = this.ctx.transform.scaleX;
            C.call(this, {
                text: t,
                x: e,
                y: r,
                scale: a,
                renderingMode: "stroke",
                angle: i,
                align: this.textAlign,
                maxWidth: n
            });
        }
    }, p.prototype.measureText = function(t) {
        if ("string" != typeof t) throw $dbd37edd557d3750$var$o.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
        var e = this.pdf, r = this.pdf.internal.scaleFactor, n = e.internal.getFontSize(), i = e.getStringUnitWidth(t) * n / e.internal.scaleFactor;
        return new function(t) {
            var e = (t = t || {}).width || 0;
            return Object.defineProperty(this, "width", {
                get: function() {
                    return e;
                }
            }), this;
        }({
            width: i *= Math.round(96 * r / 72 * 1e4) / 1e4
        });
    }, p.prototype.scale = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $dbd37edd557d3750$var$o.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
        var r = new l(t, 0, 0, e, 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(r);
    }, p.prototype.rotate = function(t) {
        if (isNaN(t)) throw $dbd37edd557d3750$var$o.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
        var e = new l(Math.cos(t), Math.sin(t), -Math.sin(t), Math.cos(t), 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(e);
    }, p.prototype.translate = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $dbd37edd557d3750$var$o.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
        var r = new l(1, 0, 0, 1, t, e);
        this.ctx.transform = this.ctx.transform.multiply(r);
    }, p.prototype.transform = function(t, e, r, n, i, a) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(a)) throw $dbd37edd557d3750$var$o.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
        var s = new l(t, e, r, n, i, a);
        this.ctx.transform = this.ctx.transform.multiply(s);
    }, p.prototype.setTransform = function(t, e, r, n, i, a) {
        t = isNaN(t) ? 1 : t, e = isNaN(e) ? 0 : e, r = isNaN(r) ? 0 : r, n = isNaN(n) ? 1 : n, i = isNaN(i) ? 0 : i, a = isNaN(a) ? 0 : a, this.ctx.transform = new l(t, e, r, n, i, a);
    };
    var b = function() {
        return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
    };
    p.prototype.drawImage = function(t, e, r, n, i, a, o, s, u) {
        var h = this.pdf.getImageProperties(t), f = 1, d = 1, p = 1, g = 1;
        void 0 !== n && void 0 !== s && (p = s / n, g = u / i, f = h.width / n * s / n, d = h.height / i * u / i), void 0 === a && (a = e, o = r, e = 0, r = 0), void 0 !== n && void 0 === s && (s = n, u = i), void 0 === n && void 0 === s && (s = h.width, u = h.height);
        var m = this.ctx.transform.decompose(), v = E(m.rotate.shx), w = new l, x = (w = (w = (w = w.multiply(m.translate)).multiply(m.skew)).multiply(m.scale)).applyToRectangle(new c(a - e * p, o - r * g, n * f, i * d));
        if (this.autoPaging) {
            for(var S, _ = y.call(this, x), P = [], k = 0; k < _.length; k += 1)-1 === P.indexOf(_[k]) && P.push(_[k]);
            L(P);
            for(var F = P[0], I = P[P.length - 1], C = F; C < I + 1; C++){
                this.pdf.setPage(C);
                var j = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], O = 1 === C ? this.posY + this.margin[0] : this.margin[0], B = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], M = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], q = 1 === C ? 0 : B + (C - 2) * M;
                if (0 !== this.ctx.clip_path.length) {
                    var R = this.path;
                    S = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(S, this.posX + this.margin[3], -q + O + this.ctx.prevPageLastElemOffset), A.call(this, "fill", !0), this.path = R;
                }
                var D = JSON.parse(JSON.stringify(x));
                D = N([
                    D
                ], this.posX + this.margin[3], -q + O + this.ctx.prevPageLastElemOffset)[0];
                var T = (C > F || C < I) && b.call(this);
                T && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], j, M, null).clip().discardPath()), this.pdf.addImage(t, "JPEG", D.x, D.y, D.w, D.h, null, null, v), T && this.pdf.restoreGraphicsState();
            }
        } else this.pdf.addImage(t, "JPEG", x.x, x.y, x.w, x.h, null, null, v);
    };
    var y = function(t, e, r) {
        var n = [];
        e = e || this.pdf.internal.pageSize.width, r = r || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
        var i = this.posY + this.ctx.prevPageLastElemOffset;
        switch(t.type){
            default:
            case "mt":
            case "lt":
                n.push(Math.floor((t.y + i) / r) + 1);
                break;
            case "arc":
                n.push(Math.floor((t.y + i - t.radius) / r) + 1), n.push(Math.floor((t.y + i + t.radius) / r) + 1);
                break;
            case "qct":
                var a = R(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x, t.y);
                n.push(Math.floor((a.y + i) / r) + 1), n.push(Math.floor((a.y + a.h + i) / r) + 1);
                break;
            case "bct":
                var o = D(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x2, t.y2, t.x, t.y);
                n.push(Math.floor((o.y + i) / r) + 1), n.push(Math.floor((o.y + o.h + i) / r) + 1);
                break;
            case "rect":
                n.push(Math.floor((t.y + i) / r) + 1), n.push(Math.floor((t.y + t.h + i) / r) + 1);
        }
        for(var s = 0; s < n.length; s += 1)for(; this.pdf.internal.getNumberOfPages() < n[s];)w.call(this);
        return n;
    }, w = function() {
        var t = this.fillStyle, e = this.strokeStyle, r = this.font, n = this.lineCap, i = this.lineWidth, a = this.lineJoin;
        this.pdf.addPage(), this.fillStyle = t, this.strokeStyle = e, this.font = r, this.lineCap = n, this.lineWidth = i, this.lineJoin = a;
    }, N = function(t, e, r) {
        for(var n = 0; n < t.length; n++)switch(t[n].type){
            case "bct":
                t[n].x2 += e, t[n].y2 += r;
            case "qct":
                t[n].x1 += e, t[n].y1 += r;
            default:
                t[n].x += e, t[n].y += r;
        }
        return t;
    }, L = function(t) {
        return t.sort(function(t, e) {
            return t - e;
        });
    }, x = function(t, e) {
        var r = this.fillStyle, n = this.strokeStyle, i = this.lineCap, a = this.lineWidth, o = Math.abs(a * this.ctx.transform.scaleX), s = this.lineJoin;
        if (this.autoPaging) {
            for(var u, c, l = JSON.parse(JSON.stringify(this.path)), h = JSON.parse(JSON.stringify(this.path)), f = [], d = 0; d < h.length; d++)if (void 0 !== h[d].x) for(var p = y.call(this, h[d]), g = 0; g < p.length; g += 1)-1 === f.indexOf(p[g]) && f.push(p[g]);
            for(var m = 0; m < f.length; m++)for(; this.pdf.internal.getNumberOfPages() < f[m];)w.call(this);
            L(f);
            for(var v = f[0], x = f[f.length - 1], S = v; S < x + 1; S++){
                this.pdf.setPage(S), this.fillStyle = r, this.strokeStyle = n, this.lineCap = i, this.lineWidth = o, this.lineJoin = s;
                var _ = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], P = 1 === S ? this.posY + this.margin[0] : this.margin[0], k = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], F = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], I = 1 === S ? 0 : k + (S - 2) * F;
                if (0 !== this.ctx.clip_path.length) {
                    var C = this.path;
                    u = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(u, this.posX + this.margin[3], -I + P + this.ctx.prevPageLastElemOffset), A.call(this, t, !0), this.path = C;
                }
                if (c = JSON.parse(JSON.stringify(l)), this.path = N(c, this.posX + this.margin[3], -I + P + this.ctx.prevPageLastElemOffset), !1 === e || 0 === S) {
                    var j = (S > v || S < x) && b.call(this);
                    j && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], _, F, null).clip().discardPath()), A.call(this, t, e), j && this.pdf.restoreGraphicsState();
                }
                this.lineWidth = a;
            }
            this.path = l;
        } else this.lineWidth = o, A.call(this, t, e), this.lineWidth = a;
    }, A = function(t, e) {
        if (("stroke" !== t || e || !v.call(this)) && ("stroke" === t || e || !m.call(this))) {
            for(var r, n, i = [], a = this.path, o = 0; o < a.length; o++){
                var s = a[o];
                switch(s.type){
                    case "begin":
                        i.push({
                            begin: !0
                        });
                        break;
                    case "close":
                        i.push({
                            close: !0
                        });
                        break;
                    case "mt":
                        i.push({
                            start: s,
                            deltas: [],
                            abs: []
                        });
                        break;
                    case "lt":
                        var u = i.length;
                        if (a[o - 1] && !isNaN(a[o - 1].x) && (r = [
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], u > 0)) {
                            for(; u >= 0; u--)if (!0 !== i[u - 1].close && !0 !== i[u - 1].begin) {
                                i[u - 1].deltas.push(r), i[u - 1].abs.push(s);
                                break;
                            }
                        }
                        break;
                    case "bct":
                        r = [
                            s.x1 - a[o - 1].x,
                            s.y1 - a[o - 1].y,
                            s.x2 - a[o - 1].x,
                            s.y2 - a[o - 1].y,
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], i[i.length - 1].deltas.push(r);
                        break;
                    case "qct":
                        var c = a[o - 1].x + 2 / 3 * (s.x1 - a[o - 1].x), l = a[o - 1].y + 2 / 3 * (s.y1 - a[o - 1].y), h = s.x + 2 / 3 * (s.x1 - s.x), f = s.y + 2 / 3 * (s.y1 - s.y), d = s.x, p = s.y;
                        r = [
                            c - a[o - 1].x,
                            l - a[o - 1].y,
                            h - a[o - 1].x,
                            f - a[o - 1].y,
                            d - a[o - 1].x,
                            p - a[o - 1].y
                        ], i[i.length - 1].deltas.push(r);
                        break;
                    case "arc":
                        i.push({
                            deltas: [],
                            abs: [],
                            arc: !0
                        }), Array.isArray(i[i.length - 1].abs) && i[i.length - 1].abs.push(s);
                }
            }
            n = e ? null : "stroke" === t ? "stroke" : "fill";
            for(var g = !1, b = 0; b < i.length; b++)if (i[b].arc) for(var y = i[b].abs, w = 0; w < y.length; w++){
                var N = y[w];
                "arc" === N.type ? P.call(this, N.x, N.y, N.radius, N.startAngle, N.endAngle, N.counterclockwise, void 0, e, !g) : j.call(this, N.x, N.y), g = !0;
            }
            else if (!0 === i[b].close) this.pdf.internal.out("h"), g = !1;
            else if (!0 !== i[b].begin) {
                var L = i[b].start.x, x = i[b].start.y;
                O.call(this, i[b].deltas, L, x), g = !0;
            }
            n && k.call(this, n), e && F.call(this);
        }
    }, S = function(t) {
        var e = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, r = e * (this.pdf.internal.getLineHeightFactor() - 1);
        switch(this.ctx.textBaseline){
            case "bottom":
                return t - r;
            case "top":
                return t + e - r;
            case "hanging":
                return t + e - 2 * r;
            case "middle":
                return t + e / 2 - r;
            default:
                return t;
        }
    }, _ = function(t) {
        return t + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
    };
    p.prototype.createLinearGradient = function() {
        var t = function() {};
        return t.colorStops = [], t.addColorStop = function(t, e) {
            this.colorStops.push([
                t,
                e
            ]);
        }, t.getColor = function() {
            return 0 === this.colorStops.length ? "#000000" : this.colorStops[0][1];
        }, t.isCanvasGradient = !0, t;
    }, p.prototype.createPattern = function() {
        return this.createLinearGradient();
    }, p.prototype.createRadialGradient = function() {
        return this.createLinearGradient();
    };
    var P = function(t, e, r, n, i, a, o, s, u) {
        for(var c = M.call(this, r, n, i, a), l = 0; l < c.length; l++){
            var h = c[l];
            0 === l && (u ? I.call(this, h.x1 + t, h.y1 + e) : j.call(this, h.x1 + t, h.y1 + e)), B.call(this, t, e, h.x2, h.y2, h.x3, h.y3, h.x4, h.y4);
        }
        s ? F.call(this) : k.call(this, o);
    }, k = function(t) {
        switch(t){
            case "stroke":
                this.pdf.internal.out("S");
                break;
            case "fill":
                this.pdf.internal.out("f");
        }
    }, F = function() {
        this.pdf.clip(), this.pdf.discardPath();
    }, I = function(t, e) {
        this.pdf.internal.out(n(t) + " " + i(e) + " m");
    }, C = function(t) {
        var e;
        switch(t.align){
            case "right":
            case "end":
                e = "right";
                break;
            case "center":
                e = "center";
                break;
            default:
                e = "left";
        }
        var r, n, i, a = this.pdf.getTextDimensions(t.text), o = S.call(this, t.y), s = _.call(this, o) - a.h, h = this.ctx.transform.applyToPoint(new u(t.x, o));
        if (this.autoPaging) {
            var f = this.ctx.transform.decompose(), d = new l;
            d = (d = (d = d.multiply(f.translate)).multiply(f.skew)).multiply(f.scale);
            for(var p = this.ctx.transform.applyToRectangle(new c(t.x, o, a.w, a.h)), g = d.applyToRectangle(new c(t.x, s, a.w, a.h)), m = y.call(this, g), v = [], w = 0; w < m.length; w += 1)-1 === v.indexOf(m[w]) && v.push(m[w]);
            L(v);
            for(var x = v[0], P = v[v.length - 1], k = x; k < P + 1; k++){
                this.pdf.setPage(k);
                var F = 1 === k ? this.posY + this.margin[0] : this.margin[0], I = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], C = this.pdf.internal.pageSize.height - this.margin[2], j = C - this.margin[0], O = this.pdf.internal.pageSize.width - this.margin[1], B = O - this.margin[3], M = 1 === k ? 0 : I + (k - 2) * j;
                if (0 !== this.ctx.clip_path.length) {
                    var q = this.path;
                    r = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(r, this.posX + this.margin[3], -1 * M + F), A.call(this, "fill", !0), this.path = q;
                }
                var E = N([
                    JSON.parse(JSON.stringify(g))
                ], this.posX + this.margin[3], -M + F + this.ctx.prevPageLastElemOffset)[0];
                t.scale >= .01 && (n = this.pdf.internal.getFontSize(), this.pdf.setFontSize(n * t.scale), i = this.lineWidth, this.lineWidth = i * t.scale);
                var R = "text" !== this.autoPaging;
                if (R || E.y + E.h <= C) {
                    if (R || E.y >= F && E.x <= O) {
                        var D = R ? t.text : this.pdf.splitTextToSize(t.text, t.maxWidth || O - E.x)[0], T = N([
                            JSON.parse(JSON.stringify(p))
                        ], this.posX + this.margin[3], -M + F + this.ctx.prevPageLastElemOffset)[0], z = R && (k > x || k < P) && b.call(this);
                        z && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], B, j, null).clip().discardPath()), this.pdf.text(D, T.x, T.y, {
                            angle: t.angle,
                            align: e,
                            renderingMode: t.renderingMode
                        }), z && this.pdf.restoreGraphicsState();
                    }
                } else E.y < C && (this.ctx.prevPageLastElemOffset += C - E.y);
                t.scale >= .01 && (this.pdf.setFontSize(n), this.lineWidth = i);
            }
        } else t.scale >= .01 && (n = this.pdf.internal.getFontSize(), this.pdf.setFontSize(n * t.scale), i = this.lineWidth, this.lineWidth = i * t.scale), this.pdf.text(t.text, h.x + this.posX, h.y + this.posY, {
            angle: t.angle,
            align: e,
            renderingMode: t.renderingMode,
            maxWidth: t.maxWidth
        }), t.scale >= .01 && (this.pdf.setFontSize(n), this.lineWidth = i);
    }, j = function(t, e, r, a) {
        r = r || 0, a = a || 0, this.pdf.internal.out(n(t + r) + " " + i(e + a) + " l");
    }, O = function(t, e, r) {
        return this.pdf.lines(t, e, r, null, null);
    }, B = function(t, e, n, i, o, u, c, l) {
        this.pdf.internal.out([
            r(a(n + t)),
            r(s(i + e)),
            r(a(o + t)),
            r(s(u + e)),
            r(a(c + t)),
            r(s(l + e)),
            "c"
        ].join(" "));
    }, M = function(t, e, r, n) {
        for(var i = 2 * Math.PI, a = Math.PI / 2; e > r;)e -= i;
        var o = Math.abs(r - e);
        o < i && n && (o = i - o);
        for(var s = [], u = n ? -1 : 1, c = e; o > 1e-5;){
            var l = c + u * Math.min(o, a);
            s.push(q.call(this, t, c, l)), o -= Math.abs(l - c), c = l;
        }
        return s;
    }, q = function(t, e, r) {
        var n = (r - e) / 2, i = t * Math.cos(n), a = t * Math.sin(n), o = i, s = -a, u = o * o + s * s, c = u + o * i + s * a, l = 4 / 3 * (Math.sqrt(2 * u * c) - c) / (o * a - s * i), h = o - l * s, f = s + l * o, d = h, p = -f, g = n + e, m = Math.cos(g), v = Math.sin(g);
        return {
            x1: t * Math.cos(e),
            y1: t * Math.sin(e),
            x2: h * m - f * v,
            y2: h * v + f * m,
            x3: d * m - p * v,
            y3: d * v + p * m,
            x4: t * Math.cos(r),
            y4: t * Math.sin(r)
        };
    }, E = function(t) {
        return 180 * t / Math.PI;
    }, R = function(t, e, r, n, i, a) {
        var o = t + .5 * (r - t), s = e + .5 * (n - e), u = i + .5 * (r - i), l = a + .5 * (n - a), h = Math.min(t, i, o, u), f = Math.max(t, i, o, u), d = Math.min(e, a, s, l), p = Math.max(e, a, s, l);
        return new c(h, d, f - h, p - d);
    }, D = function(t, e, r, n, i, a, o, s) {
        var u, l, h, f, d, p, g, m, v, b, y, w, N, L, x = r - t, A = n - e, S = i - r, _ = a - n, P = o - i, k = s - a;
        for(l = 0; l < 41; l++)v = (g = (h = t + (u = l / 40) * x) + u * ((d = r + u * S) - h)) + u * (d + u * (i + u * P - d) - g), b = (m = (f = e + u * A) + u * ((p = n + u * _) - f)) + u * (p + u * (a + u * k - p) - m), 0 == l ? (y = v, w = b, N = v, L = b) : (y = Math.min(y, v), w = Math.min(w, b), N = Math.max(N, v), L = Math.max(L, b));
        return new c(Math.round(y), Math.round(w), Math.round(N - y), Math.round(L - w));
    }, T = function() {
        if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
            var t, e, r = (t = this.ctx.lineDash, e = this.ctx.lineDashOffset, JSON.stringify({
                lineDash: t,
                lineDashOffset: e
            }));
            this.prevLineDash !== r && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = r);
        }
    };
}($dbd37edd557d3750$export$2e2bcd8739ae039.API), /**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var r = function(t) {
        var e, r, n, i, a, o, s, u, c, l;
        for(/[^\x00-\xFF]/.test(t), r = [], n = 0, i = (t += e = "\0\0\0\0".slice(t.length % 4 || 4)).length; i > n; n += 4)0 !== (a = (t.charCodeAt(n) << 24) + (t.charCodeAt(n + 1) << 16) + (t.charCodeAt(n + 2) << 8) + t.charCodeAt(n + 3)) ? (o = (a = ((a = ((a = ((a = (a - (l = a % 85)) / 85) - (c = a % 85)) / 85) - (u = a % 85)) / 85) - (s = a % 85)) / 85) % 85, r.push(o + 33, s + 33, u + 33, c + 33, l + 33)) : r.push(122);
        return function(t, e) {
            for(var r = e; r > 0; r--)t.pop();
        }(r, e.length), String.fromCharCode.apply(String, r) + "~>";
    }, n = function(t) {
        var e, r, n, i, a, o = String, s = "length", u = 255, c = "charCodeAt", l = "slice", h = "replace";
        for(t[l](-2), t = t[l](0, -2)[h](/\s/g, "")[h]("z", "!!!!!"), n = [], i = 0, a = (t += e = "uuuuu"[l](t[s] % 5 || 5))[s]; a > i; i += 5)r = 52200625 * (t[c](i) - 33) + 614125 * (t[c](i + 1) - 33) + 7225 * (t[c](i + 2) - 33) + 85 * (t[c](i + 3) - 33) + (t[c](i + 4) - 33), n.push(u & r >> 24, u & r >> 16, u & r >> 8, u & r);
        return function(t, e) {
            for(var r = e; r > 0; r--)t.pop();
        }(n, e[s]), o.fromCharCode.apply(o, n);
    }, i = function(t) {
        return t.split("").map(function(t) {
            return ("0" + t.charCodeAt().toString(16)).slice(-2);
        }).join("") + ">";
    }, a = function(t) {
        var e = new RegExp(/^([0-9A-Fa-f]{2})+$/);
        if (-1 !== (t = t.replace(/\s/g, "")).indexOf(">") && (t = t.substr(0, t.indexOf(">"))), t.length % 2 && (t += "0"), !1 === e.test(t)) return "";
        for(var r = "", n = 0; n < t.length; n += 2)r += String.fromCharCode("0x" + (t[n] + t[n + 1]));
        return r;
    }, o = function(t) {
        for(var r = new Uint8Array(t.length), n = t.length; n--;)r[n] = t.charCodeAt(n);
        return (r = (0, $16597f9d07f22afc$export$f87121a6d50aff25)(r)).reduce(function(t, e) {
            return t + String.fromCharCode(e);
        }, "");
    };
    t.processDataByFilters = function(t, e) {
        var s = 0, u = t || "", c = [];
        for("string" == typeof (e = e || []) && (e = [
            e
        ]), s = 0; s < e.length; s += 1)switch(e[s]){
            case "ASCII85Decode":
            case "/ASCII85Decode":
                u = n(u), c.push("/ASCII85Encode");
                break;
            case "ASCII85Encode":
            case "/ASCII85Encode":
                u = r(u), c.push("/ASCII85Decode");
                break;
            case "ASCIIHexDecode":
            case "/ASCIIHexDecode":
                u = a(u), c.push("/ASCIIHexEncode");
                break;
            case "ASCIIHexEncode":
            case "/ASCIIHexEncode":
                u = i(u), c.push("/ASCIIHexDecode");
                break;
            case "FlateEncode":
            case "/FlateEncode":
                u = o(u), c.push("/FlateDecode");
                break;
            default:
                throw new Error('The filter: "' + e[s] + '" is not implemented');
        }
        return {
            data: u,
            reverseChain: c.reverse().join(" ")
        };
    };
}($dbd37edd557d3750$export$2e2bcd8739ae039.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.loadFile = function(t, e, r) {
        return function(t, e, r) {
            e = !1 !== e, r = "function" == typeof r ? r : function() {};
            var n = void 0;
            try {
                n = function(t, e, r) {
                    var n = new XMLHttpRequest, i = 0, a = function(t) {
                        var e = t.length, r = [], n = String.fromCharCode;
                        for(i = 0; i < e; i += 1)r.push(n(255 & t.charCodeAt(i)));
                        return r.join("");
                    };
                    if (n.open("GET", t, !e), n.overrideMimeType("text/plain; charset=x-user-defined"), !1 === e && (n.onload = function() {
                        200 === n.status ? r(a(this.responseText)) : r(void 0);
                    }), n.send(null), e && 200 === n.status) return a(n.responseText);
                }(t, e, r);
            } catch (i) {}
            return n;
        }(t, e, r);
    }, t.allowFsRead = void 0, t.loadImageFile = t.loadFile;
}($dbd37edd557d3750$export$2e2bcd8739ae039.API), function(e) {
    function r() {
        return ($dbd37edd557d3750$var$i.html2canvas ? Promise.resolve($dbd37edd557d3750$var$i.html2canvas) : Promise.resolve((parcelRequire("49yFe")))).catch(function(t) {
            return Promise.reject(new Error("Could not load html2canvas: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    function n() {
        return ($dbd37edd557d3750$var$i.DOMPurify ? Promise.resolve($dbd37edd557d3750$var$i.DOMPurify) : (parcelRequire("9roVb"))).catch(function(t) {
            return Promise.reject(new Error("Could not load dompurify: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    var a = function(e) {
        var r = (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(e);
        return "undefined" === r ? "undefined" : "string" === r || e instanceof String ? "string" : "number" === r || e instanceof Number ? "number" : "function" === r || e instanceof Function ? "function" : e && e.constructor === Array ? "array" : e && 1 === e.nodeType ? "element" : "object" === r ? "object" : "unknown";
    }, o = function(t, e) {
        var r = document.createElement(t);
        for(var n in e.className && (r.className = e.className), e.innerHTML && e.dompurify && (r.innerHTML = e.dompurify.sanitize(e.innerHTML)), e.style)r.style[n] = e.style[n];
        return r;
    }, s = function t(e, r) {
        for(var n = 3 === e.nodeType ? document.createTextNode(e.nodeValue) : e.cloneNode(!1), i = e.firstChild; i; i = i.nextSibling)!0 !== r && 1 === i.nodeType && "SCRIPT" === i.nodeName || n.appendChild(t(i, r));
        return 1 === e.nodeType && ("CANVAS" === e.nodeName ? (n.width = e.width, n.height = e.height, n.getContext("2d").drawImage(e, 0, 0)) : "TEXTAREA" !== e.nodeName && "SELECT" !== e.nodeName || (n.value = e.value), n.addEventListener("load", function() {
            n.scrollTop = e.scrollTop, n.scrollLeft = e.scrollLeft;
        }, !0)), n;
    }, u = function t(e) {
        var r = Object.assign(t.convert(Promise.resolve()), JSON.parse(JSON.stringify(t.template))), n = t.convert(Promise.resolve(), r);
        return (n = n.setProgress(1, t, 1, [
            t
        ])).set(e);
    };
    (u.prototype = Object.create(Promise.prototype)).constructor = u, u.convert = function(t, e) {
        return t.__proto__ = e || u.prototype, t;
    }, u.template = {
        prop: {
            src: null,
            container: null,
            overlay: null,
            canvas: null,
            img: null,
            pdf: null,
            pageSize: null,
            callback: function() {}
        },
        progress: {
            val: 0,
            state: null,
            n: 0,
            stack: []
        },
        opt: {
            filename: "file.pdf",
            margin: [
                0,
                0,
                0,
                0
            ],
            enableLinks: !0,
            x: 0,
            y: 0,
            html2canvas: {},
            jsPDF: {},
            backgroundColor: "transparent"
        }
    }, u.prototype.from = function(t, e) {
        return this.then(function() {
            switch(e = e || function(t) {
                switch(a(t)){
                    case "string":
                        return "string";
                    case "element":
                        return "canvas" === t.nodeName.toLowerCase() ? "canvas" : "element";
                    default:
                        return "unknown";
                }
            }(t), e){
                case "string":
                    return this.then(n).then(function(e) {
                        return this.set({
                            src: o("div", {
                                innerHTML: t,
                                dompurify: e
                            })
                        });
                    });
                case "element":
                    return this.set({
                        src: t
                    });
                case "canvas":
                    return this.set({
                        canvas: t
                    });
                case "img":
                    return this.set({
                        img: t
                    });
                default:
                    return this.error("Unknown source type.");
            }
        });
    }, u.prototype.to = function(t) {
        switch(t){
            case "container":
                return this.toContainer();
            case "canvas":
                return this.toCanvas();
            case "img":
                return this.toImg();
            case "pdf":
                return this.toPdf();
            default:
                return this.error("Invalid target.");
        }
    }, u.prototype.toContainer = function() {
        return this.thenList([
            function() {
                return this.prop.src || this.error("Cannot duplicate - no source HTML.");
            },
            function() {
                return this.prop.pageSize || this.setPageSize();
            }
        ]).then(function() {
            var t = {
                position: "relative",
                display: "inline-block",
                width: ("number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px",
                left: 0,
                right: 0,
                top: 0,
                margin: "auto",
                backgroundColor: this.opt.backgroundColor
            }, e = s(this.prop.src, this.opt.html2canvas.javascriptEnabled);
            "BODY" === e.tagName && (t.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = o("div", {
                className: "html2pdf__overlay",
                style: {
                    position: "fixed",
                    overflow: "hidden",
                    zIndex: 1e3,
                    left: "-100000px",
                    right: 0,
                    bottom: 0,
                    top: 0
                }
            }), this.prop.container = o("div", {
                className: "html2pdf__container",
                style: t
            }), this.prop.container.appendChild(e), this.prop.container.firstChild.appendChild(o("div", {
                style: {
                    clear: "both",
                    border: "0 none transparent",
                    margin: 0,
                    padding: 0,
                    height: 0
                }
            })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
        });
    }, u.prototype.toCanvas = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(r).then(function(t) {
            var e = Object.assign({}, this.opt.html2canvas);
            return delete e.onrendered, t(this.prop.container, e);
        }).then(function(t) {
            (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, u.prototype.toContext2d = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(r).then(function(t) {
            var e = this.opt.jsPDF, r = this.opt.fontFaces, n = "number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, i = Object.assign({
                async: !0,
                allowTaint: !0,
                scale: n,
                scrollX: this.opt.scrollX || 0,
                scrollY: this.opt.scrollY || 0,
                backgroundColor: "#ffffff",
                imageTimeout: 15e3,
                logging: !0,
                proxy: null,
                removeContainer: !0,
                foreignObjectRendering: !1,
                useCORS: !1
            }, this.opt.html2canvas);
            if (delete i.onrendered, e.context2d.autoPaging = void 0 === this.opt.autoPaging || this.opt.autoPaging, e.context2d.posX = this.opt.x, e.context2d.posY = this.opt.y, e.context2d.margin = this.opt.margin, e.context2d.fontFaces = r, r) for(var a = 0; a < r.length; ++a){
                var o = r[a], s = o.src.find(function(t) {
                    return "truetype" === t.format;
                });
                s && e.addFont(s.url, o.ref.name, o.ref.style);
            }
            return i.windowHeight = i.windowHeight || 0, i.windowHeight = 0 == i.windowHeight ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : i.windowHeight, e.context2d.save(!0), t(this.prop.container, i);
        }).then(function(t) {
            this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, u.prototype.toImg = function() {
        return this.thenList([
            function() {
                return this.prop.canvas || this.toCanvas();
            }
        ]).then(function() {
            var t = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
            this.prop.img = document.createElement("img"), this.prop.img.src = t;
        });
    }, u.prototype.toPdf = function() {
        return this.thenList([
            function() {
                return this.toContext2d();
            }
        ]).then(function() {
            this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
        });
    }, u.prototype.output = function(t, e, r) {
        return "img" === (r = r || "pdf").toLowerCase() || "image" === r.toLowerCase() ? this.outputImg(t, e) : this.outputPdf(t, e);
    }, u.prototype.outputPdf = function(t, e) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            return this.prop.pdf.output(t, e);
        });
    }, u.prototype.outputImg = function(t) {
        return this.thenList([
            function() {
                return this.prop.img || this.toImg();
            }
        ]).then(function() {
            switch(t){
                case void 0:
                case "img":
                    return this.prop.img;
                case "datauristring":
                case "dataurlstring":
                    return this.prop.img.src;
                case "datauri":
                case "dataurl":
                    return document.location.href = this.prop.img.src;
                default:
                    throw 'Image output type "' + t + '" is not supported.';
            }
        });
    }, u.prototype.save = function(t) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).set(t ? {
            filename: t
        } : null).then(function() {
            this.prop.pdf.save(this.opt.filename);
        });
    }, u.prototype.doCallback = function() {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            this.prop.callback(this.prop.pdf);
        });
    }, u.prototype.set = function(t) {
        if ("object" !== a(t)) return this;
        var e = Object.keys(t || {}).map(function(e) {
            if (e in u.template.prop) return function() {
                this.prop[e] = t[e];
            };
            switch(e){
                case "margin":
                    return this.setMargin.bind(this, t.margin);
                case "jsPDF":
                    return function() {
                        return this.opt.jsPDF = t.jsPDF, this.setPageSize();
                    };
                case "pageSize":
                    return this.setPageSize.bind(this, t.pageSize);
                default:
                    return function() {
                        this.opt[e] = t[e];
                    };
            }
        }, this);
        return this.then(function() {
            return this.thenList(e);
        });
    }, u.prototype.get = function(t, e) {
        return this.then(function() {
            var r = t in u.template.prop ? this.prop[t] : this.opt[t];
            return e ? e(r) : r;
        });
    }, u.prototype.setMargin = function(t) {
        return this.then(function() {
            switch(a(t)){
                case "number":
                    t = [
                        t,
                        t,
                        t,
                        t
                    ];
                case "array":
                    if (2 === t.length && (t = [
                        t[0],
                        t[1],
                        t[0],
                        t[1]
                    ]), 4 === t.length) break;
                default:
                    return this.error("Invalid margin array.");
            }
            this.opt.margin = t;
        }).then(this.setPageSize);
    }, u.prototype.setPageSize = function(t) {
        function e(t, e) {
            return Math.floor(t * e / 72 * 96);
        }
        return this.then(function() {
            (t = t || $dbd37edd557d3750$export$2e2bcd8739ae039.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (t.inner = {
                width: t.width - this.opt.margin[1] - this.opt.margin[3],
                height: t.height - this.opt.margin[0] - this.opt.margin[2]
            }, t.inner.px = {
                width: e(t.inner.width, t.k),
                height: e(t.inner.height, t.k)
            }, t.inner.ratio = t.inner.height / t.inner.width), this.prop.pageSize = t;
        });
    }, u.prototype.setProgress = function(t, e, r, n) {
        return null != t && (this.progress.val = t), null != e && (this.progress.state = e), null != r && (this.progress.n = r), null != n && (this.progress.stack = n), this.progress.ratio = this.progress.val / this.progress.state, this;
    }, u.prototype.updateProgress = function(t, e, r, n) {
        return this.setProgress(t ? this.progress.val + t : null, e || null, r ? this.progress.n + r : null, n ? this.progress.stack.concat(n) : null);
    }, u.prototype.then = function(t, e) {
        var r = this;
        return this.thenCore(t, e, function(t, e) {
            return r.updateProgress(null, null, 1, [
                t
            ]), Promise.prototype.then.call(this, function(e) {
                return r.updateProgress(null, t), e;
            }).then(t, e).then(function(t) {
                return r.updateProgress(1), t;
            });
        });
    }, u.prototype.thenCore = function(t, e, r) {
        r = r || Promise.prototype.then;
        var n = this;
        t && (t = t.bind(n)), e && (e = e.bind(n));
        var i = -1 !== Promise.toString().indexOf("[native code]") && "Promise" === Promise.name ? n : u.convert(Object.assign({}, n), Promise.prototype), a = r.call(i, t, e);
        return u.convert(a, n.__proto__);
    }, u.prototype.thenExternal = function(t, e) {
        return Promise.prototype.then.call(this, t, e);
    }, u.prototype.thenList = function(t) {
        var e = this;
        return t.forEach(function(t) {
            e = e.thenCore(t);
        }), e;
    }, u.prototype.catch = function(t) {
        t && (t = t.bind(this));
        var e = Promise.prototype.catch.call(this, t);
        return u.convert(e, this);
    }, u.prototype.catchExternal = function(t) {
        return Promise.prototype.catch.call(this, t);
    }, u.prototype.error = function(t) {
        return this.then(function() {
            throw new Error(t);
        });
    }, u.prototype.using = u.prototype.set, u.prototype.saveAs = u.prototype.save, u.prototype.export = u.prototype.output, u.prototype.run = u.prototype.then, $dbd37edd557d3750$export$2e2bcd8739ae039.getPageSize = function(e, r, n) {
        if ("object" === (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(e)) {
            var i = e;
            e = i.orientation, r = i.unit || r, n = i.format || n;
        }
        r = r || "mm", n = n || "a4", e = ("" + (e || "P")).toLowerCase();
        var a, o = ("" + n).toLowerCase(), s = {
            a0: [
                2383.94,
                3370.39
            ],
            a1: [
                1683.78,
                2383.94
            ],
            a2: [
                1190.55,
                1683.78
            ],
            a3: [
                841.89,
                1190.55
            ],
            a4: [
                595.28,
                841.89
            ],
            a5: [
                419.53,
                595.28
            ],
            a6: [
                297.64,
                419.53
            ],
            a7: [
                209.76,
                297.64
            ],
            a8: [
                147.4,
                209.76
            ],
            a9: [
                104.88,
                147.4
            ],
            a10: [
                73.7,
                104.88
            ],
            b0: [
                2834.65,
                4008.19
            ],
            b1: [
                2004.09,
                2834.65
            ],
            b2: [
                1417.32,
                2004.09
            ],
            b3: [
                1000.63,
                1417.32
            ],
            b4: [
                708.66,
                1000.63
            ],
            b5: [
                498.9,
                708.66
            ],
            b6: [
                354.33,
                498.9
            ],
            b7: [
                249.45,
                354.33
            ],
            b8: [
                175.75,
                249.45
            ],
            b9: [
                124.72,
                175.75
            ],
            b10: [
                87.87,
                124.72
            ],
            c0: [
                2599.37,
                3676.54
            ],
            c1: [
                1836.85,
                2599.37
            ],
            c2: [
                1298.27,
                1836.85
            ],
            c3: [
                918.43,
                1298.27
            ],
            c4: [
                649.13,
                918.43
            ],
            c5: [
                459.21,
                649.13
            ],
            c6: [
                323.15,
                459.21
            ],
            c7: [
                229.61,
                323.15
            ],
            c8: [
                161.57,
                229.61
            ],
            c9: [
                113.39,
                161.57
            ],
            c10: [
                79.37,
                113.39
            ],
            dl: [
                311.81,
                623.62
            ],
            letter: [
                612,
                792
            ],
            "government-letter": [
                576,
                756
            ],
            legal: [
                612,
                1008
            ],
            "junior-legal": [
                576,
                360
            ],
            ledger: [
                1224,
                792
            ],
            tabloid: [
                792,
                1224
            ],
            "credit-card": [
                153,
                243
            ]
        };
        switch(r){
            case "pt":
                a = 1;
                break;
            case "mm":
                a = 72 / 25.4;
                break;
            case "cm":
                a = 72 / 2.54;
                break;
            case "in":
                a = 72;
                break;
            case "px":
                a = .75;
                break;
            case "pc":
            case "em":
                a = 12;
                break;
            case "ex":
                a = 6;
                break;
            default:
                throw "Invalid unit: " + r;
        }
        var u, c = 0, l = 0;
        if (s.hasOwnProperty(o)) c = s[o][1] / a, l = s[o][0] / a;
        else try {
            c = n[1], l = n[0];
        } catch (h) {
            throw new Error("Invalid format: " + n);
        }
        if ("p" === e || "portrait" === e) e = "p", l > c && (u = l, l = c, c = u);
        else {
            if ("l" !== e && "landscape" !== e) throw "Invalid orientation: " + e;
            e = "l", c > l && (u = l, l = c, c = u);
        }
        return {
            width: l,
            height: c,
            unit: r,
            k: a,
            orientation: e
        };
    }, e.html = function(t, e) {
        (e = e || {}).callback = e.callback || function() {}, e.html2canvas = e.html2canvas || {}, e.html2canvas.canvas = e.html2canvas.canvas || this.canvas, e.jsPDF = e.jsPDF || this, e.fontFaces = e.fontFaces ? e.fontFaces.map($dbd37edd557d3750$var$Ot) : null;
        var r = new u(e);
        return e.worker ? r : r.from(t).doCallback();
    };
}($dbd37edd557d3750$export$2e2bcd8739ae039.API), $dbd37edd557d3750$export$2e2bcd8739ae039.API.addJS = function(t) {
    var e, r, n = function(t) {
        for(var e = "", r = 0; r < t.length; r++){
            var n = t[r];
            if ("(" === n || ")" === n) {
                for(var i = 0, a = r - 1; a >= 0 && "\\" === t[a]; a--)i++;
                e += i % 2 == 0 ? "\\" + n : n;
            } else e += n;
        }
        return e;
    }(t);
    return this.internal.events.subscribe("postPutResources", function() {
        e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (e + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), r = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + n + ")"), this.internal.out(">>"), this.internal.out("endobj");
    }), this.internal.events.subscribe("putCatalog", function() {
        void 0 !== e && void 0 !== r && this.internal.out("/Names <</JavaScript " + e + " 0 R>>");
    }), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e;
    t.events.push([
        "postPutResources",
        function() {
            var t = this, r = /^(\d+) 0 obj$/;
            if (this.outline.root.children.length > 0) for(var n = t.outline.render().split(/\r\n/), i = 0; i < n.length; i++){
                var a = n[i], o = r.exec(a);
                if (null != o) {
                    var s = o[1];
                    t.internal.newObjectDeferredBegin(s, !1);
                }
                t.internal.write(a);
            }
            if (this.outline.createNamedDestinations) {
                var u = this.internal.pages.length, c = [];
                for(i = 0; i < u; i++){
                    var l = t.internal.newObject();
                    c.push(l);
                    var h = t.internal.getPageInfo(i + 1);
                    t.internal.write("<< /D[" + h.objId + " 0 R /XYZ null null null]>> endobj");
                }
                var f = t.internal.newObject();
                for(t.internal.write("<< /Names [ "), i = 0; i < c.length; i++)t.internal.write("(page_" + (i + 1) + ")" + c[i] + " 0 R");
                t.internal.write(" ] >>", "endobj"), e = t.internal.newObject(), t.internal.write("<< /Dests " + f + " 0 R"), t.internal.write(">>", "endobj");
            }
        }
    ]), t.events.push([
        "putCatalog",
        function() {
            var t = this;
            t.outline.root.children.length > 0 && (t.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && t.internal.write("/Names " + e + " 0 R"));
        }
    ]), t.events.push([
        "initialized",
        function() {
            var t = this;
            t.outline = {
                createNamedDestinations: !1,
                root: {
                    children: []
                }
            }, t.outline.add = function(t, e, r) {
                var n = {
                    title: e,
                    options: r,
                    children: []
                };
                return null == t && (t = this.root), t.children.push(n), n;
            }, t.outline.render = function() {
                return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = t, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
            }, t.outline.genIds_r = function(e) {
                e.id = t.internal.newObjectDeferred();
                for(var r = 0; r < e.children.length; r++)this.genIds_r(e.children[r]);
            }, t.outline.renderRoot = function(t) {
                this.objStart(t), this.line("/Type /Outlines"), t.children.length > 0 && (this.line("/First " + this.makeRef(t.children[0])), this.line("/Last " + this.makeRef(t.children[t.children.length - 1]))), this.line("/Count " + this.count_r({
                    count: 0
                }, t)), this.objEnd();
            }, t.outline.renderItems = function(e) {
                for(var r = this.ctx.pdf.internal.getVerticalCoordinateString, n = 0; n < e.children.length; n++){
                    var i = e.children[n];
                    this.objStart(i), this.line("/Title " + this.makeString(i.title)), this.line("/Parent " + this.makeRef(e)), n > 0 && this.line("/Prev " + this.makeRef(e.children[n - 1])), n < e.children.length - 1 && this.line("/Next " + this.makeRef(e.children[n + 1])), i.children.length > 0 && (this.line("/First " + this.makeRef(i.children[0])), this.line("/Last " + this.makeRef(i.children[i.children.length - 1])));
                    var a = this.count = this.count_r({
                        count: 0
                    }, i);
                    if (a > 0 && this.line("/Count " + a), i.options && i.options.pageNumber) {
                        var o = t.internal.getPageInfo(i.options.pageNumber);
                        this.line("/Dest [" + o.objId + " 0 R /XYZ 0 " + r(0) + " 0]");
                    }
                    this.objEnd();
                }
                for(var s = 0; s < e.children.length; s++)this.renderItems(e.children[s]);
            }, t.outline.line = function(t) {
                this.ctx.val += t + "\r\n";
            }, t.outline.makeRef = function(t) {
                return t.id + " 0 R";
            }, t.outline.makeString = function(e) {
                return "(" + t.internal.pdfEscape(e) + ")";
            }, t.outline.objStart = function(t) {
                this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
            }, t.outline.objEnd = function() {
                this.ctx.val += ">> \r\nendobj\r\n";
            }, t.outline.count_r = function(t, e) {
                for(var r = 0; r < e.children.length; r++)t.count++, this.count_r(t, e.children[r]);
                return t.count;
            };
        }
    ]);
}($dbd37edd557d3750$export$2e2bcd8739ae039.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = [
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199
    ];
    t.processJPEG = function(t, r, n, i, a, o) {
        var s, u = this.decode.DCT_DECODE, c = null;
        if ("string" == typeof t || this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) {
            switch(t = a || t, t = this.__addimage__.isArrayBuffer(t) ? new Uint8Array(t) : t, s = function(t) {
                for(var r, n = 256 * t.charCodeAt(4) + t.charCodeAt(5), i = t.length, a = {
                    width: 0,
                    height: 0,
                    numcomponents: 1
                }, o = 4; o < i; o += 2){
                    if (o += n, -1 !== e.indexOf(t.charCodeAt(o + 1))) {
                        r = 256 * t.charCodeAt(o + 5) + t.charCodeAt(o + 6), a = {
                            width: 256 * t.charCodeAt(o + 7) + t.charCodeAt(o + 8),
                            height: r,
                            numcomponents: t.charCodeAt(o + 9)
                        };
                        break;
                    }
                    n = 256 * t.charCodeAt(o + 2) + t.charCodeAt(o + 3);
                }
                return a;
            }(t = this.__addimage__.isArrayBufferView(t) ? this.__addimage__.arrayBufferToBinaryString(t) : t), s.numcomponents){
                case 1:
                    o = this.color_spaces.DEVICE_GRAY;
                    break;
                case 4:
                    o = this.color_spaces.DEVICE_CMYK;
                    break;
                case 3:
                    o = this.color_spaces.DEVICE_RGB;
            }
            c = {
                data: t,
                width: s.width,
                height: s.height,
                colorSpace: o,
                bitsPerComponent: 8,
                filter: u,
                index: r,
                alias: n
            };
        }
        return c;
    };
}($dbd37edd557d3750$export$2e2bcd8739ae039.API), $dbd37edd557d3750$export$2e2bcd8739ae039.API.processPNG = function(t, i, a, o) {
    if (this.__addimage__.isArrayBuffer(t) && (t = new Uint8Array(t)), this.__addimage__.isArrayBufferView(t)) {
        var s, u = (0, $0022f0488c89b7e3$export$2f872c0f2117be69)(t, {
            checkCrc: !0
        }), c = u.width, l = u.height, h = u.channels, f = u.palette, d = u.depth;
        s = f && 1 === h ? function(t) {
            for(var e = t.width, n = t.height, i = t.data, a = t.palette, o = t.depth, s = !1, u = [], c = [], l = void 0, h = !1, f = 0, d = 0; d < a.length; d++){
                var p = (0, (/*@__PURE__*/$parcel$interopDefault($9bb086d904f27bd2$exports)))(a[d], 4), g = p[0], m = p[1], v = p[2], b = p[3];
                u.push(g, m, v), null != b && (0 === b ? (f++, c.length < 1 && c.push(d)) : b < 255 && (h = !0));
            }
            if (h || f > 1) {
                s = !0, c = void 0;
                var y = e * n;
                l = new Uint8Array(y);
                for(var w = new DataView(i.buffer), N = 0; N < y; N++){
                    var L = $dbd37edd557d3750$var$ee(w, N, o), x = (0, (/*@__PURE__*/$parcel$interopDefault($9bb086d904f27bd2$exports)))(a[L], 4)[3];
                    l[N] = x;
                }
            } else 0 === f && (c = void 0);
            return {
                colorSpace: "Indexed",
                colorsPerPixel: 1,
                sMaskBitsPerComponent: s ? 8 : void 0,
                colorBytes: i,
                alphaBytes: l,
                needSMask: s,
                palette: u,
                mask: c
            };
        }(u) : 2 === h || 4 === h ? function(t) {
            for(var e = t.data, r = t.width, n = t.height, i = t.channels, a = t.depth, o = 2 === i ? "DeviceGray" : "DeviceRGB", s = i - 1, u = r * n, c = s, l = u * c, h = 1 * u, f = Math.ceil(l * a / 8), d = Math.ceil(h * a / 8), p = new Uint8Array(f), g = new Uint8Array(d), m = new DataView(e.buffer), v = new DataView(p.buffer), b = new DataView(g.buffer), y = !1, w = 0; w < u; w++){
                for(var N = w * i, L = 0; L < c; L++)$dbd37edd557d3750$var$re(v, $dbd37edd557d3750$var$ee(m, N + L, a), w * c + L, a);
                var x = $dbd37edd557d3750$var$ee(m, N + c, a);
                x < (1 << a) - 1 && (y = !0), $dbd37edd557d3750$var$re(b, x, 1 * w, a);
            }
            return {
                colorSpace: o,
                colorsPerPixel: s,
                sMaskBitsPerComponent: y ? a : void 0,
                colorBytes: p,
                alphaBytes: g,
                needSMask: y
            };
        }(u) : function(t) {
            var e = t.data, r = 1 === t.channels ? "DeviceGray" : "DeviceRGB";
            return {
                colorSpace: r,
                colorsPerPixel: "DeviceGray" === r ? 1 : 3,
                colorBytes: e instanceof Uint16Array ? function(t) {
                    for(var e = t.length, r = new Uint8Array(2 * e), n = new DataView(r.buffer, r.byteOffset, r.byteLength), i = 0; i < e; i++)n.setUint16(2 * i, t[i], !1);
                    return r;
                }(e) : e,
                needSMask: !1
            };
        }(u);
        var p, g, m, v = s, b = v.colorSpace, y = v.colorsPerPixel, w = v.sMaskBitsPerComponent, N = v.colorBytes, L = v.alphaBytes, x = v.needSMask, A = v.palette, S = v.mask, _ = null;
        return o !== $dbd37edd557d3750$export$2e2bcd8739ae039.API.image_compression.NONE && "function" == typeof (0, $16597f9d07f22afc$export$f87121a6d50aff25) ? (_ = function(t) {
            var e;
            switch(t){
                case $dbd37edd557d3750$export$2e2bcd8739ae039.API.image_compression.FAST:
                    e = 11;
                    break;
                case $dbd37edd557d3750$export$2e2bcd8739ae039.API.image_compression.MEDIUM:
                    e = 13;
                    break;
                case $dbd37edd557d3750$export$2e2bcd8739ae039.API.image_compression.SLOW:
                    e = 14;
                    break;
                default:
                    e = 12;
            }
            return e;
        }(o), p = this.decode.FLATE_DECODE, g = "/Predictor ".concat(_, " /Colors ").concat(y, " /BitsPerComponent ").concat(d, " /Columns ").concat(c), t = $dbd37edd557d3750$var$Yt(N, Math.ceil(c * y * d / 8), y, d, o), x && (m = $dbd37edd557d3750$var$Yt(L, Math.ceil(c * w / 8), 1, w, o))) : (p = void 0, g = void 0, t = N, x && (m = L)), (this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) && (t = this.__addimage__.arrayBufferToBinaryString(t)), (m && this.__addimage__.isArrayBuffer(m) || this.__addimage__.isArrayBufferView(m)) && (m = this.__addimage__.arrayBufferToBinaryString(m)), {
            alias: a,
            data: t,
            index: i,
            filter: p,
            decodeParameters: g,
            transparency: S,
            palette: A,
            sMask: m,
            predictor: _,
            width: c,
            height: l,
            bitsPerComponent: d,
            sMaskBitsPerComponent: w,
            colorSpace: b
        };
    }
}, function(t) {
    t.processGIF89A = function(e, r, n, i) {
        var a = new $dbd37edd557d3750$var$ie(e), o = a.width, s = a.height, u = [];
        a.decodeAndBlitFrameRGBA(0, u);
        var c = {
            data: u,
            width: o,
            height: s
        }, l = new $dbd37edd557d3750$var$oe(100).encode(c, 100);
        return t.processJPEG.call(this, l, r, n, i);
    }, t.processGIF87A = t.processGIF89A;
}($dbd37edd557d3750$export$2e2bcd8739ae039.API), $dbd37edd557d3750$var$se.prototype.parseHeader = function() {
    if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, 16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
        var t = 0 === this.colors ? 1 << this.bitPP : this.colors;
        this.palette = new Array(t);
        for(var e = 0; e < t; e++){
            var r = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0);
            this.palette[e] = {
                red: i,
                green: n,
                blue: r,
                quad: a
            };
        }
    }
    this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, $dbd37edd557d3750$var$se.prototype.parseBGR = function() {
    this.pos = this.offset;
    var t = "bit" + this.bitPP, e = this.width * this.height * 4;
    if (e > 536870912) throw new Error("Image dimensions exceed 512MB, which is too large.");
    this.data = new Uint8Array(e);
    try {
        this[t]();
    } catch (r) {
        $dbd37edd557d3750$var$o.log("bit decode error:" + r);
    }
}, $dbd37edd557d3750$var$se.prototype.bit1 = function() {
    var t, e = Math.ceil(this.width / 8), r = e % 4;
    for(t = this.height - 1; t >= 0; t--){
        for(var n = this.bottom_up ? t : this.height - 1 - t, i = 0; i < e; i++)for(var a = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 8 * i * 4, s = 0; s < 8 && 8 * i + s < this.width; s++){
            var u = this.palette[a >> 7 - s & 1];
            this.data[o + 4 * s] = u.blue, this.data[o + 4 * s + 1] = u.green, this.data[o + 4 * s + 2] = u.red, this.data[o + 4 * s + 3] = 255;
        }
        0 !== r && (this.pos += 4 - r);
    }
}, $dbd37edd557d3750$var$se.prototype.bit4 = function() {
    for(var t = Math.ceil(this.width / 2), e = t % 4, r = this.height - 1; r >= 0; r--){
        for(var n = this.bottom_up ? r : this.height - 1 - r, i = 0; i < t; i++){
            var a = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 2 * i * 4, s = a >> 4, u = 15 & a, c = this.palette[s];
            if (this.data[o] = c.blue, this.data[o + 1] = c.green, this.data[o + 2] = c.red, this.data[o + 3] = 255, 2 * i + 1 >= this.width) break;
            c = this.palette[u], this.data[o + 4] = c.blue, this.data[o + 4 + 1] = c.green, this.data[o + 4 + 2] = c.red, this.data[o + 4 + 3] = 255;
        }
        0 !== e && (this.pos += 4 - e);
    }
}, $dbd37edd557d3750$var$se.prototype.bit8 = function() {
    for(var t = this.width % 4, e = this.height - 1; e >= 0; e--){
        for(var r = this.bottom_up ? e : this.height - 1 - e, n = 0; n < this.width; n++){
            var i = this.datav.getUint8(this.pos++, !0), a = r * this.width * 4 + 4 * n;
            if (i < this.palette.length) {
                var o = this.palette[i];
                this.data[a] = o.red, this.data[a + 1] = o.green, this.data[a + 2] = o.blue, this.data[a + 3] = 255;
            } else this.data[a] = 255, this.data[a + 1] = 255, this.data[a + 2] = 255, this.data[a + 3] = 255;
        }
        0 !== t && (this.pos += 4 - t);
    }
}, $dbd37edd557d3750$var$se.prototype.bit15 = function() {
    for(var t = this.width % 3, e = parseInt("11111", 2), r = this.height - 1; r >= 0; r--){
        for(var n = this.bottom_up ? r : this.height - 1 - r, i = 0; i < this.width; i++){
            var a = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var o = (a & e) / e * 255 | 0, s = (a >> 5 & e) / e * 255 | 0, u = (a >> 10 & e) / e * 255 | 0, c = a >> 15 ? 255 : 0, l = n * this.width * 4 + 4 * i;
            this.data[l] = u, this.data[l + 1] = s, this.data[l + 2] = o, this.data[l + 3] = c;
        }
        this.pos += t;
    }
}, $dbd37edd557d3750$var$se.prototype.bit16 = function() {
    for(var t = this.width % 3, e = parseInt("11111", 2), r = parseInt("111111", 2), n = this.height - 1; n >= 0; n--){
        for(var i = this.bottom_up ? n : this.height - 1 - n, a = 0; a < this.width; a++){
            var o = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var s = (o & e) / e * 255 | 0, u = (o >> 5 & r) / r * 255 | 0, c = (o >> 11) / e * 255 | 0, l = i * this.width * 4 + 4 * a;
            this.data[l] = c, this.data[l + 1] = u, this.data[l + 2] = s, this.data[l + 3] = 255;
        }
        this.pos += t;
    }
}, $dbd37edd557d3750$var$se.prototype.bit24 = function() {
    for(var t = this.height - 1; t >= 0; t--){
        for(var e = this.bottom_up ? t : this.height - 1 - t, r = 0; r < this.width; r++){
            var n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = e * this.width * 4 + 4 * r;
            this.data[o] = a, this.data[o + 1] = i, this.data[o + 2] = n, this.data[o + 3] = 255;
        }
        this.pos += this.width % 4;
    }
}, $dbd37edd557d3750$var$se.prototype.bit32 = function() {
    for(var t = this.height - 1; t >= 0; t--)for(var e = this.bottom_up ? t : this.height - 1 - t, r = 0; r < this.width; r++){
        var n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * r;
        this.data[s] = a, this.data[s + 1] = i, this.data[s + 2] = n, this.data[s + 3] = o;
    }
}, $dbd37edd557d3750$var$se.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processBMP = function(e, r, n, i) {
        var a = new $dbd37edd557d3750$var$se(e, !1), o = a.width, s = a.height, u = {
            data: a.getData(),
            width: o,
            height: s
        }, c = new $dbd37edd557d3750$var$oe(100).encode(u, 100);
        return t.processJPEG.call(this, c, r, n, i);
    };
}($dbd37edd557d3750$export$2e2bcd8739ae039.API), $dbd37edd557d3750$var$ue.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processWEBP = function(e, r, n, i) {
        var a = new $dbd37edd557d3750$var$ue(e), o = a.width, s = a.height, u = {
            data: a.getData(),
            width: o,
            height: s
        }, c = new $dbd37edd557d3750$var$oe(100).encode(u, 100);
        return t.processJPEG.call(this, c, r, n, i);
    };
}($dbd37edd557d3750$export$2e2bcd8739ae039.API), $dbd37edd557d3750$export$2e2bcd8739ae039.API.processRGBA = function(t, e, r) {
    for(var n = t.data, i = n.length, a = new Uint8Array(i / 4 * 3), o = new Uint8Array(i / 4), s = 0, u = 0, c = 0; c < i; c += 4){
        var l = n[c], h = n[c + 1], f = n[c + 2], d = n[c + 3];
        a[s++] = l, a[s++] = h, a[s++] = f, o[u++] = d;
    }
    var p = this.__addimage__.arrayBufferToBinaryString(a);
    return {
        alpha: this.__addimage__.arrayBufferToBinaryString(o),
        data: p,
        index: e,
        alias: r,
        colorSpace: "DeviceRGB",
        bitsPerComponent: 8,
        width: t.width,
        height: t.height
    };
}, $dbd37edd557d3750$export$2e2bcd8739ae039.API.setLanguage = function(t) {
    return void 0 === this.internal.languageSettings && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), void 0 !== ({
        af: "Afrikaans",
        sq: "Albanian",
        ar: "Arabic (Standard)",
        "ar-DZ": "Arabic (Algeria)",
        "ar-BH": "Arabic (Bahrain)",
        "ar-EG": "Arabic (Egypt)",
        "ar-IQ": "Arabic (Iraq)",
        "ar-JO": "Arabic (Jordan)",
        "ar-KW": "Arabic (Kuwait)",
        "ar-LB": "Arabic (Lebanon)",
        "ar-LY": "Arabic (Libya)",
        "ar-MA": "Arabic (Morocco)",
        "ar-OM": "Arabic (Oman)",
        "ar-QA": "Arabic (Qatar)",
        "ar-SA": "Arabic (Saudi Arabia)",
        "ar-SY": "Arabic (Syria)",
        "ar-TN": "Arabic (Tunisia)",
        "ar-AE": "Arabic (U.A.E.)",
        "ar-YE": "Arabic (Yemen)",
        an: "Aragonese",
        hy: "Armenian",
        as: "Assamese",
        ast: "Asturian",
        az: "Azerbaijani",
        eu: "Basque",
        be: "Belarusian",
        bn: "Bengali",
        bs: "Bosnian",
        br: "Breton",
        bg: "Bulgarian",
        my: "Burmese",
        ca: "Catalan",
        ch: "Chamorro",
        ce: "Chechen",
        zh: "Chinese",
        "zh-HK": "Chinese (Hong Kong)",
        "zh-CN": "Chinese (PRC)",
        "zh-SG": "Chinese (Singapore)",
        "zh-TW": "Chinese (Taiwan)",
        cv: "Chuvash",
        co: "Corsican",
        cr: "Cree",
        hr: "Croatian",
        cs: "Czech",
        da: "Danish",
        nl: "Dutch (Standard)",
        "nl-BE": "Dutch (Belgian)",
        en: "English",
        "en-AU": "English (Australia)",
        "en-BZ": "English (Belize)",
        "en-CA": "English (Canada)",
        "en-IE": "English (Ireland)",
        "en-JM": "English (Jamaica)",
        "en-NZ": "English (New Zealand)",
        "en-PH": "English (Philippines)",
        "en-ZA": "English (South Africa)",
        "en-TT": "English (Trinidad & Tobago)",
        "en-GB": "English (United Kingdom)",
        "en-US": "English (United States)",
        "en-ZW": "English (Zimbabwe)",
        eo: "Esperanto",
        et: "Estonian",
        fo: "Faeroese",
        fj: "Fijian",
        fi: "Finnish",
        fr: "French (Standard)",
        "fr-BE": "French (Belgium)",
        "fr-CA": "French (Canada)",
        "fr-FR": "French (France)",
        "fr-LU": "French (Luxembourg)",
        "fr-MC": "French (Monaco)",
        "fr-CH": "French (Switzerland)",
        fy: "Frisian",
        fur: "Friulian",
        gd: "Gaelic (Scots)",
        "gd-IE": "Gaelic (Irish)",
        gl: "Galacian",
        ka: "Georgian",
        de: "German (Standard)",
        "de-AT": "German (Austria)",
        "de-DE": "German (Germany)",
        "de-LI": "German (Liechtenstein)",
        "de-LU": "German (Luxembourg)",
        "de-CH": "German (Switzerland)",
        el: "Greek",
        gu: "Gujurati",
        ht: "Haitian",
        he: "Hebrew",
        hi: "Hindi",
        hu: "Hungarian",
        is: "Icelandic",
        id: "Indonesian",
        iu: "Inuktitut",
        ga: "Irish",
        it: "Italian (Standard)",
        "it-CH": "Italian (Switzerland)",
        ja: "Japanese",
        kn: "Kannada",
        ks: "Kashmiri",
        kk: "Kazakh",
        km: "Khmer",
        ky: "Kirghiz",
        tlh: "Klingon",
        ko: "Korean",
        "ko-KP": "Korean (North Korea)",
        "ko-KR": "Korean (South Korea)",
        la: "Latin",
        lv: "Latvian",
        lt: "Lithuanian",
        lb: "Luxembourgish",
        mk: "North Macedonia",
        ms: "Malay",
        ml: "Malayalam",
        mt: "Maltese",
        mi: "Maori",
        mr: "Marathi",
        mo: "Moldavian",
        nv: "Navajo",
        ng: "Ndonga",
        ne: "Nepali",
        no: "Norwegian",
        nb: "Norwegian (Bokmal)",
        nn: "Norwegian (Nynorsk)",
        oc: "Occitan",
        or: "Oriya",
        om: "Oromo",
        fa: "Persian",
        "fa-IR": "Persian/Iran",
        pl: "Polish",
        pt: "Portuguese",
        "pt-BR": "Portuguese (Brazil)",
        pa: "Punjabi",
        "pa-IN": "Punjabi (India)",
        "pa-PK": "Punjabi (Pakistan)",
        qu: "Quechua",
        rm: "Rhaeto-Romanic",
        ro: "Romanian",
        "ro-MO": "Romanian (Moldavia)",
        ru: "Russian",
        "ru-MO": "Russian (Moldavia)",
        sz: "Sami (Lappish)",
        sg: "Sango",
        sa: "Sanskrit",
        sc: "Sardinian",
        sd: "Sindhi",
        si: "Singhalese",
        sr: "Serbian",
        sk: "Slovak",
        sl: "Slovenian",
        so: "Somani",
        sb: "Sorbian",
        es: "Spanish",
        "es-AR": "Spanish (Argentina)",
        "es-BO": "Spanish (Bolivia)",
        "es-CL": "Spanish (Chile)",
        "es-CO": "Spanish (Colombia)",
        "es-CR": "Spanish (Costa Rica)",
        "es-DO": "Spanish (Dominican Republic)",
        "es-EC": "Spanish (Ecuador)",
        "es-SV": "Spanish (El Salvador)",
        "es-GT": "Spanish (Guatemala)",
        "es-HN": "Spanish (Honduras)",
        "es-MX": "Spanish (Mexico)",
        "es-NI": "Spanish (Nicaragua)",
        "es-PA": "Spanish (Panama)",
        "es-PY": "Spanish (Paraguay)",
        "es-PE": "Spanish (Peru)",
        "es-PR": "Spanish (Puerto Rico)",
        "es-ES": "Spanish (Spain)",
        "es-UY": "Spanish (Uruguay)",
        "es-VE": "Spanish (Venezuela)",
        sx: "Sutu",
        sw: "Swahili",
        sv: "Swedish",
        "sv-FI": "Swedish (Finland)",
        "sv-SV": "Swedish (Sweden)",
        ta: "Tamil",
        tt: "Tatar",
        te: "Teluga",
        th: "Thai",
        tig: "Tigre",
        ts: "Tsonga",
        tn: "Tswana",
        tr: "Turkish",
        tk: "Turkmen",
        uk: "Ukrainian",
        hsb: "Upper Sorbian",
        ur: "Urdu",
        ve: "Venda",
        vi: "Vietnamese",
        vo: "Volapuk",
        wa: "Walloon",
        cy: "Welsh",
        xh: "Xhosa",
        ji: "Yiddish",
        zu: "Zulu"
    })[t] && (this.internal.languageSettings.languageCode = t, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
    }), this.internal.languageSettings.isSubscribed = !0)), this;
}, $dbd37edd557d3750$var$zt = $dbd37edd557d3750$export$2e2bcd8739ae039.API, $dbd37edd557d3750$var$Ut = $dbd37edd557d3750$var$zt.getCharWidthsArray = function(e, r) {
    var n, i, a = (r = r || {}).font || this.internal.getFont(), o = r.fontSize || this.internal.getFontSize(), s = r.charSpace || this.internal.getCharSpace(), u = r.widths ? r.widths : a.metadata.Unicode.widths, c = u.fof ? u.fof : 1, l = r.kerning ? r.kerning : a.metadata.Unicode.kerning, h = l.fof ? l.fof : 1, f = !1 !== r.doKerning, d = 0, p = e.length, g = 0, m = u[0] || c, v = [];
    for(n = 0; n < p; n++)i = e.charCodeAt(n), "function" == typeof a.metadata.widthOfString ? v.push((a.metadata.widthOfGlyph(a.metadata.characterToGlyph(i)) + s * (1e3 / o) || 0) / 1e3) : (d = f && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(l[i]) && !isNaN(parseInt(l[i][g], 10)) ? l[i][g] / h : 0, v.push((u[i] || m) / c + d)), g = i;
    return v;
}, $dbd37edd557d3750$var$Ht = $dbd37edd557d3750$var$zt.getStringUnitWidth = function(t, e) {
    var r = (e = e || {}).fontSize || this.internal.getFontSize(), n = e.font || this.internal.getFont(), i = e.charSpace || this.internal.getCharSpace();
    return $dbd37edd557d3750$var$zt.processArabic && (t = $dbd37edd557d3750$var$zt.processArabic(t)), "function" == typeof n.metadata.widthOfString ? n.metadata.widthOfString(t, r, i) / r : $dbd37edd557d3750$var$Ut.apply(this, arguments).reduce(function(t, e) {
        return t + e;
    }, 0);
}, $dbd37edd557d3750$var$Wt = function(t, e, r, n) {
    for(var i = [], a = 0, o = t.length, s = 0; a !== o && s + e[a] < r;)s += e[a], a++;
    i.push(t.slice(0, a));
    var u = a;
    for(s = 0; a !== o;)s + e[a] > n && (i.push(t.slice(u, a)), s = 0, u = a), s += e[a], a++;
    return u !== a && i.push(t.slice(u, a)), i;
}, $dbd37edd557d3750$var$Vt = function(t, e, r) {
    r || (r = {});
    var n, i, a, o, s, u, c, l = [], h = [
        l
    ], f = r.textIndent || 0, d = 0, p = 0, g = t.split(" "), m = $dbd37edd557d3750$var$Ut.apply(this, [
        " ",
        r
    ])[0];
    if (u = -1 === r.lineIndent ? g[0].length + 2 : r.lineIndent || 0) {
        var v = Array(u).join(" "), b = [];
        g.map(function(t) {
            (t = t.split(/\s*\n/)).length > 1 ? b = b.concat(t.map(function(t, e) {
                return (e && t.length ? "\n" : "") + t;
            })) : b.push(t[0]);
        }), g = b, u = $dbd37edd557d3750$var$Ht.apply(this, [
            v,
            r
        ]);
    }
    for(a = 0, o = g.length; a < o; a++){
        var y = 0;
        if (n = g[a], u && "\n" == n[0] && (n = n.substr(1), y = 1), f + d + (p = (i = $dbd37edd557d3750$var$Ut.apply(this, [
            n,
            r
        ])).reduce(function(t, e) {
            return t + e;
        }, 0)) > e || y) {
            if (p > e) {
                for(s = $dbd37edd557d3750$var$Wt.apply(this, [
                    n,
                    i,
                    e - (f + d),
                    e
                ]), l.push(s.shift()), l = [
                    s.pop()
                ]; s.length;)h.push([
                    s.shift()
                ]);
                p = i.slice(n.length - (l[0] ? l[0].length : 0)).reduce(function(t, e) {
                    return t + e;
                }, 0);
            } else l = [
                n
            ];
            h.push(l), f = p + u, d = m;
        } else l.push(n), f += d + p, d = m;
    }
    return c = u ? function(t, e) {
        return (e ? v : "") + t.join(" ");
    } : function(t) {
        return t.join(" ");
    }, h.map(c);
}, $dbd37edd557d3750$var$zt.splitTextToSize = function(t, e, r) {
    var n, i = (r = r || {}).fontSize || this.internal.getFontSize(), a = (function(t) {
        if (t.widths && t.kerning) return {
            widths: t.widths,
            kerning: t.kerning
        };
        var e = this.internal.getFont(t.fontName, t.fontStyle), r = "Unicode";
        return e.metadata[r] ? {
            widths: e.metadata[r].widths || {
                0: 1
            },
            kerning: e.metadata[r].kerning || {}
        } : {
            font: e.metadata,
            fontSize: this.internal.getFontSize(),
            charSpace: this.internal.getCharSpace()
        };
    }).call(this, r);
    n = Array.isArray(t) ? t : String(t).split(/\r?\n/);
    var o = 1 * this.internal.scaleFactor * e / i;
    a.textIndent = r.textIndent ? 1 * r.textIndent * this.internal.scaleFactor / i : 0, a.lineIndent = r.lineIndent;
    var s, u, c = [];
    for(s = 0, u = n.length; s < u; s++)c = c.concat($dbd37edd557d3750$var$Vt.apply(this, [
        n[s],
        o,
        a
    ]));
    return c;
}, function(e) {
    e.__fontmetrics__ = e.__fontmetrics__ || {};
    for(var r = "0123456789abcdef", n = "klmnopqrstuvwxyz", i = {}, a = {}, o = 0; o < 16; o++)i[n[o]] = r[o], a[r[o]] = n[o];
    var s = function(t) {
        return "0x" + parseInt(t, 10).toString(16);
    }, u = e.__fontmetrics__.compress = function(e) {
        var r, n, i, o, c = [
            "{"
        ];
        for(var l in e){
            if (r = e[l], isNaN(parseInt(l, 10)) ? n = "'" + l + "'" : (l = parseInt(l, 10), n = (n = s(l).slice(2)).slice(0, -1) + a[n.slice(-1)]), "number" == typeof r) r < 0 ? (i = s(r).slice(3), o = "-") : (i = s(r).slice(2), o = ""), i = o + i.slice(0, -1) + a[i.slice(-1)];
            else {
                if ("object" !== (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(r)) throw new Error("Don't know what to do with value type " + (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(r) + ".");
                i = u(r);
            }
            c.push(n + i);
        }
        return c.push("}"), c.join("");
    }, c = e.__fontmetrics__.uncompress = function(t) {
        if ("string" != typeof t) throw new Error("Invalid argument passed to uncompress.");
        for(var e, r, n, a, o = {}, s = 1, u = o, c = [], l = "", h = "", f = t.length - 1, d = 1; d < f; d += 1)"'" == (a = t[d]) ? e ? (n = e.join(""), e = void 0) : e = [] : e ? e.push(a) : "{" == a ? (c.push([
            u,
            n
        ]), u = {}, n = void 0) : "}" == a ? ((r = c.pop())[0][r[1]] = u, n = void 0, u = r[0]) : "-" == a ? s = -1 : void 0 === n ? i.hasOwnProperty(a) ? (l += i[a], n = parseInt(l, 16) * s, s = 1, l = "") : l += a : i.hasOwnProperty(a) ? (h += i[a], u[n] = parseInt(h, 16) * s, s = 1, n = void 0, h = "") : h += a;
        return o;
    }, l = {
        codePages: [
            "WinAnsiEncoding"
        ],
        WinAnsiEncoding: c("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
    }, h = {
        Unicode: {
            Courier: l,
            "Courier-Bold": l,
            "Courier-BoldOblique": l,
            "Courier-Oblique": l,
            Helvetica: l,
            "Helvetica-Bold": l,
            "Helvetica-BoldOblique": l,
            "Helvetica-Oblique": l,
            "Times-Roman": l,
            "Times-Bold": l,
            "Times-BoldItalic": l,
            "Times-Italic": l
        }
    }, f = {
        Unicode: {
            "Courier-Oblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-BoldItalic": c("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
            "Helvetica-Bold": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            Courier: c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-BoldOblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Bold": c("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
            Symbol: c("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
            Helvetica: c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
            "Helvetica-BoldOblique": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            ZapfDingbats: c("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-Bold": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Italic": c("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
            "Times-Roman": c("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
            "Helvetica-Oblique": c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
        }
    };
    e.events.push([
        "addFont",
        function(t) {
            var e = t.font, r = f.Unicode[e.postScriptName];
            r && (e.metadata.Unicode = {}, e.metadata.Unicode.widths = r.widths, e.metadata.Unicode.kerning = r.kerning);
            var n = h.Unicode[e.postScriptName];
            n && (e.metadata.Unicode.encoding = n, e.encoding = n.codePages[0]);
        }
    ]);
}($dbd37edd557d3750$export$2e2bcd8739ae039.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function(t) {
        for(var e = t.length, r = new Uint8Array(e), n = 0; n < e; n++)r[n] = t.charCodeAt(n);
        return r;
    };
    t.API.events.push([
        "addFont",
        function(r) {
            var n = void 0, i = r.font, a = r.instance;
            if (!i.isStandardFont) {
                if (void 0 === a) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                if ("string" != typeof (n = !1 === a.existsFileInVFS(i.postScriptName) ? a.loadFile(i.postScriptName) : a.getFileFromVFS(i.postScriptName))) throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                !function(r, n) {
                    n = /^\x00\x01\x00\x00/.test(n) ? e(n) : e($dbd37edd557d3750$var$f(n)), r.metadata = t.API.TTFFont.open(n), r.metadata.Unicode = r.metadata.Unicode || {
                        encoding: {},
                        kerning: {},
                        widths: []
                    }, r.metadata.glyIdsUsed = [
                        0
                    ];
                }(i, n);
            }
        }
    ]);
}($dbd37edd557d3750$export$2e2bcd8739ae039), $dbd37edd557d3750$export$2e2bcd8739ae039.API.addSvgAsImage = function(t, e, r, n, a, s, u, c) {
    if (isNaN(e) || isNaN(r)) throw $dbd37edd557d3750$var$o.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
    if (isNaN(n) || isNaN(a)) throw $dbd37edd557d3750$var$o.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
    var l = document.createElement("canvas");
    l.width = n, l.height = a;
    var h = l.getContext("2d");
    h.fillStyle = "#fff", h.fillRect(0, 0, l.width, l.height);
    var f = {
        ignoreMouse: !0,
        ignoreAnimation: !0,
        ignoreDimensions: !0
    }, d = this;
    return ($dbd37edd557d3750$var$i.canvg ? Promise.resolve($dbd37edd557d3750$var$i.canvg) : (parcelRequire("ks967"))).catch(function(t) {
        return Promise.reject(new Error("Could not load canvg: " + t));
    }).then(function(t) {
        return t.default ? t.default : t;
    }).then(function(e) {
        return e.fromString(h, t, f);
    }, function() {
        return Promise.reject(new Error("Could not load canvg."));
    }).then(function(t) {
        return t.render(f);
    }).then(function() {
        d.addImage(l.toDataURL("image/jpeg", 1), e, r, n, a, u, c);
    });
}, $dbd37edd557d3750$export$2e2bcd8739ae039.API.putTotalPages = function(t) {
    var e, r = 0;
    parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e = new RegExp(t, "g"), r = this.internal.getNumberOfPages()) : (e = new RegExp(this.pdfEscape16(t, this.internal.getFont()), "g"), r = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
    for(var n = 1; n <= this.internal.getNumberOfPages(); n++)for(var i = 0; i < this.internal.pages[n].length; i++)this.internal.pages[n][i] = this.internal.pages[n][i].replace(e, r);
    return this;
}, $dbd37edd557d3750$export$2e2bcd8739ae039.API.viewerPreferences = function(e, r) {
    var n;
    e = e || {}, r = r || !1;
    var i, a, o, s = {
        HideToolbar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideMenubar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideWindowUI: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        FitWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        CenterWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        DisplayDocTitle: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.4
        },
        NonFullScreenPageMode: {
            defaultValue: "UseNone",
            value: "UseNone",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "UseNone",
                "UseOutlines",
                "UseThumbs",
                "UseOC"
            ],
            pdfVersion: 1.3
        },
        Direction: {
            defaultValue: "L2R",
            value: "L2R",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "L2R",
                "R2L"
            ],
            pdfVersion: 1.3
        },
        ViewArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        ViewClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintScaling: {
            defaultValue: "AppDefault",
            value: "AppDefault",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "AppDefault",
                "None"
            ],
            pdfVersion: 1.6
        },
        Duplex: {
            defaultValue: "",
            value: "none",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "Simplex",
                "DuplexFlipShortEdge",
                "DuplexFlipLongEdge",
                "none"
            ],
            pdfVersion: 1.7
        },
        PickTrayByPDFSize: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.7
        },
        PrintPageRange: {
            defaultValue: "",
            value: "",
            type: "array",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        },
        NumCopies: {
            defaultValue: 1,
            value: 1,
            type: "integer",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        }
    }, u = Object.keys(s), c = [], l = 0, h = 0, f = 0;
    function d(t, e) {
        var r, n = !1;
        for(r = 0; r < t.length; r += 1)t[r] === e && (n = !0);
        return n;
    }
    if (void 0 === this.internal.viewerpreferences && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(s)), this.internal.viewerpreferences.isSubscribed = !1), n = this.internal.viewerpreferences.configuration, "reset" === e || !0 === r) {
        var p = u.length;
        for(f = 0; f < p; f += 1)n[u[f]].value = n[u[f]].defaultValue, n[u[f]].explicitSet = !1;
    }
    if ("object" === (0, (/*@__PURE__*/$parcel$interopDefault($jObBy)))(e)) {
        for(a in e)if (o = e[a], d(u, a) && void 0 !== o) {
            if ("boolean" === n[a].type && "boolean" == typeof o) n[a].value = o;
            else if ("name" === n[a].type && d(n[a].valueSet, o)) n[a].value = o;
            else if ("integer" === n[a].type && Number.isInteger(o)) n[a].value = o;
            else if ("array" === n[a].type) {
                for(l = 0; l < o.length; l += 1)if (i = !0, 1 === o[l].length && "number" == typeof o[l][0]) c.push(String(o[l] - 1));
                else if (o[l].length > 1) {
                    for(h = 0; h < o[l].length; h += 1)"number" != typeof o[l][h] && (i = !1);
                    !0 === i && c.push([
                        o[l][0] - 1,
                        o[l][1] - 1
                    ].join(" "));
                }
                n[a].value = "[" + c.join(" ") + "]";
            } else n[a].value = n[a].defaultValue;
            n[a].explicitSet = !0;
        }
    }
    return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        var t, e = [];
        for(t in n)!0 === n[t].explicitSet && ("name" === n[t].type ? e.push("/" + t + " /" + n[t].value) : e.push("/" + t + " " + n[t].value));
        0 !== e.length && this.internal.write("/ViewerPreferences\n<<\n" + e.join("\n") + "\n>>");
    }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = n, this;
}, $dbd37edd557d3750$export$2e2bcd8739ae039.API.addMetadata = function(t, e) {
    return void 0 === this.internal.__metadata__ && (this.internal.__metadata__ = {
        metadata: t,
        namespaceUri: null != e ? e : "http://jspdf.default.namespaceuri/",
        rawXml: "boolean" == typeof e && e
    }, this.internal.events.subscribe("putCatalog", $dbd37edd557d3750$var$le), this.internal.events.subscribe("postPutResources", $dbd37edd557d3750$var$ce)), this;
}, function(t) {
    var e = t.API, r = e.pdfEscape16 = function(t, e) {
        for(var r, n = e.metadata.Unicode.widths, i = [
            "",
            "0",
            "00",
            "000",
            "0000"
        ], a = [
            ""
        ], o = 0, s = t.length; o < s; ++o){
            if (r = e.metadata.characterToGlyph(t.charCodeAt(o)), e.metadata.glyIdsUsed.push(r), e.metadata.toUnicode[r] = t.charCodeAt(o), -1 == n.indexOf(r) && (n.push(r), n.push([
                parseInt(e.metadata.widthOfGlyph(r), 10)
            ])), "0" == r) return a.join("");
            r = r.toString(16), a.push(i[4 - r.length], r);
        }
        return a.join("");
    }, n = function(t) {
        var e, r, n, i, a, o, s;
        for(a = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange", n = [], o = 0, s = (r = Object.keys(t).sort(function(t, e) {
            return t - e;
        })).length; o < s; o++)e = r[o], n.length >= 100 && (a += "\n" + n.length + " beginbfchar\n" + n.join("\n") + "\nendbfchar", n = []), void 0 !== t[e] && null !== t[e] && "function" == typeof t[e].toString && (i = ("0000" + t[e].toString(16)).slice(-4), e = ("0000" + (+e).toString(16)).slice(-4), n.push("<" + e + "><" + i + ">"));
        return n.length && (a += "\n" + n.length + " beginbfchar\n" + n.join("\n") + "\nendbfchar\n"), a + "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
    };
    e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var r = e.font, i = e.out, a = e.newObject, o = e.putStream;
                if (r.metadata instanceof t.API.TTFFont && "Identity-H" === r.encoding) {
                    for(var s = r.metadata.Unicode.widths, u = r.metadata.subset.encode(r.metadata.glyIdsUsed, 1), c = "", l = 0; l < u.length; l++)c += String.fromCharCode(u[l]);
                    var h = a();
                    o({
                        data: c,
                        addLength1: !0,
                        objectId: h
                    }), i("endobj");
                    var f = a();
                    o({
                        data: n(r.metadata.toUnicode),
                        addLength1: !0,
                        objectId: f
                    }), i("endobj");
                    var d = a();
                    i("<<"), i("/Type /FontDescriptor"), i("/FontName /" + $dbd37edd557d3750$var$C(r.fontName)), i("/FontFile2 " + h + " 0 R"), i("/FontBBox " + t.API.PDFObject.convert(r.metadata.bbox)), i("/Flags " + r.metadata.flags), i("/StemV " + r.metadata.stemV), i("/ItalicAngle " + r.metadata.italicAngle), i("/Ascent " + r.metadata.ascender), i("/Descent " + r.metadata.decender), i("/CapHeight " + r.metadata.capHeight), i(">>"), i("endobj");
                    var p = a();
                    i("<<"), i("/Type /Font"), i("/BaseFont /" + $dbd37edd557d3750$var$C(r.fontName)), i("/FontDescriptor " + d + " 0 R"), i("/W " + t.API.PDFObject.convert(s)), i("/CIDToGIDMap /Identity"), i("/DW 1000"), i("/Subtype /CIDFontType2"), i("/CIDSystemInfo"), i("<<"), i("/Supplement 0"), i("/Registry (Adobe)"), i("/Ordering (" + r.encoding + ")"), i(">>"), i(">>"), i("endobj"), r.objectNumber = a(), i("<<"), i("/Type /Font"), i("/Subtype /Type0"), i("/ToUnicode " + f + " 0 R"), i("/BaseFont /" + $dbd37edd557d3750$var$C(r.fontName)), i("/Encoding /" + r.encoding), i("/DescendantFonts [" + p + " 0 R]"), i(">>"), i("endobj"), r.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]), e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var r = e.font, i = e.out, a = e.newObject, o = e.putStream;
                if (r.metadata instanceof t.API.TTFFont && "WinAnsiEncoding" === r.encoding) {
                    for(var s = r.metadata.rawData, u = "", c = 0; c < s.length; c++)u += String.fromCharCode(s[c]);
                    var l = a();
                    o({
                        data: u,
                        addLength1: !0,
                        objectId: l
                    }), i("endobj");
                    var h = a();
                    o({
                        data: n(r.metadata.toUnicode),
                        addLength1: !0,
                        objectId: h
                    }), i("endobj");
                    var f = a();
                    i("<<"), i("/Descent " + r.metadata.decender), i("/CapHeight " + r.metadata.capHeight), i("/StemV " + r.metadata.stemV), i("/Type /FontDescriptor"), i("/FontFile2 " + l + " 0 R"), i("/Flags 96"), i("/FontBBox " + t.API.PDFObject.convert(r.metadata.bbox)), i("/FontName /" + $dbd37edd557d3750$var$C(r.fontName)), i("/ItalicAngle " + r.metadata.italicAngle), i("/Ascent " + r.metadata.ascender), i(">>"), i("endobj"), r.objectNumber = a();
                    for(var d = 0; d < r.metadata.hmtx.widths.length; d++)r.metadata.hmtx.widths[d] = parseInt(r.metadata.hmtx.widths[d] * (1e3 / r.metadata.head.unitsPerEm));
                    i("<</Subtype/TrueType/Type/Font/ToUnicode " + h + " 0 R/BaseFont/" + $dbd37edd557d3750$var$C(r.fontName) + "/FontDescriptor " + f + " 0 R/Encoding/" + r.encoding + " /FirstChar 29 /LastChar 255 /Widths " + t.API.PDFObject.convert(r.metadata.hmtx.widths) + ">>"), i("endobj"), r.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]);
    var i = function(t) {
        var e, n = t.text || "", i = t.x, a = t.y, o = t.options || {}, s = t.mutex || {}, u = s.pdfEscape, c = s.activeFontKey, l = s.fonts, h = c, f = "", d = 0, p = "", g = l[h].encoding;
        if ("Identity-H" !== l[h].encoding) return {
            text: n,
            x: i,
            y: a,
            options: o,
            mutex: s
        };
        for(p = n, h = c, Array.isArray(n) && (p = n[0]), d = 0; d < p.length; d += 1)l[h].metadata.hasOwnProperty("cmap") && (e = l[h].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]), e || p[d].charCodeAt(0) < 256 && l[h].metadata.hasOwnProperty("Unicode") ? f += p[d] : f += "";
        var m = "";
        return parseInt(h.slice(1)) < 14 || "WinAnsiEncoding" === g ? m = u(f, h).split("").map(function(t) {
            return t.charCodeAt(0).toString(16);
        }).join("") : "Identity-H" === g && (m = r(f, l[h])), s.isHex = !0, {
            text: m,
            x: i,
            y: a,
            options: o,
            mutex: s
        };
    };
    e.events.push([
        "postProcessText",
        function(t) {
            var e = t.text || "", r = [], n = {
                text: e,
                x: t.x,
                y: t.y,
                options: t.options,
                mutex: t.mutex
            };
            if (Array.isArray(e)) {
                var a = 0;
                for(a = 0; a < e.length; a += 1)Array.isArray(e[a]) && 3 === e[a].length ? r.push([
                    i(Object.assign({}, n, {
                        text: e[a][0]
                    })).text,
                    e[a][1],
                    e[a][2]
                ]) : r.push(i(Object.assign({}, n, {
                    text: e[a]
                })).text);
                t.text = r;
            } else t.text = i(Object.assign({}, n, {
                text: e
            })).text;
        }
    ]);
}($dbd37edd557d3750$export$2e2bcd8739ae039), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function() {
        return void 0 === this.internal.vFS && (this.internal.vFS = {}), !0;
    };
    t.existsFileInVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t];
    }, t.addFileToVFS = function(t, r) {
        return e.call(this), this.internal.vFS[t] = r, this;
    }, t.getFileFromVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t] ? this.internal.vFS[t] : null;
    };
}($dbd37edd557d3750$export$2e2bcd8739ae039.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */ function(t) {
    t.__bidiEngine__ = t.prototype.__bidiEngine__ = function(t) {
        var r, n, i, a, o, s, u, c = e, l = [
            [
                0,
                3,
                0,
                1,
                0,
                0,
                0
            ],
            [
                0,
                3,
                0,
                1,
                2,
                2,
                0
            ],
            [
                0,
                3,
                0,
                17,
                2,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                1,
                0
            ],
            [
                0,
                3,
                21,
                21,
                4,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                2,
                0
            ]
        ], h = [
            [
                2,
                0,
                1,
                1,
                0,
                1,
                0
            ],
            [
                2,
                0,
                1,
                1,
                0,
                2,
                0
            ],
            [
                2,
                0,
                2,
                1,
                3,
                2,
                0
            ],
            [
                2,
                0,
                2,
                33,
                3,
                1,
                1
            ]
        ], f = {
            L: 0,
            R: 1,
            EN: 2,
            AN: 3,
            N: 4,
            B: 5,
            S: 6
        }, d = {
            0: 0,
            5: 1,
            6: 2,
            7: 3,
            32: 4,
            251: 5,
            254: 6,
            255: 7
        }, p = [
            "(",
            ")",
            "(",
            "<",
            ">",
            "<",
            "[",
            "]",
            "[",
            "{",
            "}",
            "{",
            "\xab",
            "\xbb",
            "\xab",
            "\u2039",
            "\u203A",
            "\u2039",
            "\u2045",
            "\u2046",
            "\u2045",
            "\u207D",
            "\u207E",
            "\u207D",
            "\u208D",
            "\u208E",
            "\u208D",
            "\u2264",
            "\u2265",
            "\u2264",
            "\u2329",
            "\u232A",
            "\u2329",
            "\uFE59",
            "\uFE5A",
            "\uFE59",
            "\uFE5B",
            "\uFE5C",
            "\uFE5B",
            "\uFE5D",
            "\uFE5E",
            "\uFE5D",
            "\uFE64",
            "\uFE65",
            "\uFE64"
        ], g = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), m = !1, v = 0;
        this.__bidiEngine__ = {};
        var b = function(t) {
            var e = t.charCodeAt(), r = e >> 8, n = d[r];
            return void 0 !== n ? c[256 * n + (255 & e)] : 252 === r || 253 === r ? "AL" : g.test(r) ? "L" : 8 === r ? "R" : "N";
        }, y = function(t) {
            for(var e, r = 0; r < t.length; r++){
                if ("L" === (e = b(t.charAt(r)))) return !1;
                if ("R" === e) return !0;
            }
            return !1;
        }, w = function(t, e, o, s) {
            var u, c, l, h, f = e[s];
            switch(f){
                case "L":
                case "R":
                case "LRE":
                case "RLE":
                case "LRO":
                case "RLO":
                case "PDF":
                    m = !1;
                    break;
                case "N":
                case "AN":
                    break;
                case "EN":
                    m && (f = "AN");
                    break;
                case "AL":
                    m = !0, f = "R";
                    break;
                case "WS":
                case "BN":
                    f = "N";
                    break;
                case "CS":
                    s < 1 || s + 1 >= e.length || "EN" !== (u = o[s - 1]) && "AN" !== u || "EN" !== (c = e[s + 1]) && "AN" !== c ? f = "N" : m && (c = "AN"), f = c === u ? c : "N";
                    break;
                case "ES":
                    f = "EN" === (u = s > 0 ? o[s - 1] : "B") && s + 1 < e.length && "EN" === e[s + 1] ? "EN" : "N";
                    break;
                case "ET":
                    if (s > 0 && "EN" === o[s - 1]) {
                        f = "EN";
                        break;
                    }
                    if (m) {
                        f = "N";
                        break;
                    }
                    for(l = s + 1, h = e.length; l < h && "ET" === e[l];)l++;
                    f = l < h && "EN" === e[l] ? "EN" : "N";
                    break;
                case "NSM":
                    if (i && !a) {
                        for(h = e.length, l = s + 1; l < h && "NSM" === e[l];)l++;
                        if (l < h) {
                            var d = t[s], p = d >= 1425 && d <= 2303 || 64286 === d;
                            if (u = e[l], p && ("R" === u || "AL" === u)) {
                                f = "R";
                                break;
                            }
                        }
                    }
                    f = s < 1 || "B" === (u = e[s - 1]) ? "N" : o[s - 1];
                    break;
                case "B":
                    m = !1, r = !0, f = v;
                    break;
                case "S":
                    n = !0, f = "N";
            }
            return f;
        }, N = function(t, e, r) {
            var n = t.split("");
            return r && L(n, r, {
                hiLevel: v
            }), n.reverse(), e && e.reverse(), n.join("");
        }, L = function(t, e, i) {
            var a, o, s, u, c, d = -1, p = t.length, g = 0, y = [], N = v ? h : l, L = [];
            for(m = !1, r = !1, n = !1, o = 0; o < p; o++)L[o] = b(t[o]);
            for(s = 0; s < p; s++){
                if (c = g, y[s] = w(t, L, y, s), a = 240 & (g = N[c][f[y[s]]]), g &= 15, e[s] = u = N[g][5], a > 0) {
                    if (16 === a) {
                        for(o = d; o < s; o++)e[o] = 1;
                        d = -1;
                    } else d = -1;
                }
                if (N[g][6]) -1 === d && (d = s);
                else if (d > -1) {
                    for(o = d; o < s; o++)e[o] = u;
                    d = -1;
                }
                "B" === L[s] && (e[s] = 0), i.hiLevel |= u;
            }
            n && function(t, e, r) {
                for(var n = 0; n < r; n++)if ("S" === t[n]) {
                    e[n] = v;
                    for(var i = n - 1; i >= 0 && "WS" === t[i]; i--)e[i] = v;
                }
            }(L, e, p);
        }, x = function(t, e, n, i, a) {
            if (!(a.hiLevel < t)) {
                if (1 === t && 1 === v && !r) return e.reverse(), void (n && n.reverse());
                for(var o, s, u, c, l = e.length, h = 0; h < l;){
                    if (i[h] >= t) {
                        for(u = h + 1; u < l && i[u] >= t;)u++;
                        for(c = h, s = u - 1; c < s; c++, s--)o = e[c], e[c] = e[s], e[s] = o, n && (o = n[c], n[c] = n[s], n[s] = o);
                        h = u;
                    }
                    h++;
                }
            }
        }, A = function(t, e, r) {
            var n = t.split(""), i = {
                hiLevel: v
            };
            return r || (r = []), L(n, r, i), function(t, e, r) {
                if (0 !== r.hiLevel && u) for(var n, i = 0; i < t.length; i++)1 === e[i] && (n = p.indexOf(t[i])) >= 0 && (t[i] = p[n + 1]);
            }(n, r, i), x(2, n, e, r, i), x(1, n, e, r, i), n.join("");
        };
        return this.__bidiEngine__.doBidiReorder = function(t, e, r) {
            if (function(t, e) {
                if (e) for(var r = 0; r < t.length; r++)e[r] = r;
                void 0 === a && (a = y(t)), void 0 === s && (s = y(t));
            }(t, e), i || !o || s) {
                if (i && o && a ^ s) v = a ? 1 : 0, t = N(t, e, r);
                else if (!i && o && s) v = a ? 1 : 0, t = A(t, e, r), t = N(t, e);
                else if (!i || a || o || s) {
                    if (i && !o && a ^ s) t = N(t, e), a ? (v = 0, t = A(t, e, r)) : (v = 1, t = A(t, e, r), t = N(t, e));
                    else if (i && a && !o && s) v = 1, t = A(t, e, r), t = N(t, e);
                    else if (!i && !o && a ^ s) {
                        var n = u;
                        a ? (v = 1, t = A(t, e, r), v = 0, u = !1, t = A(t, e, r), u = n) : (v = 0, t = A(t, e, r), t = N(t, e), v = 1, u = !1, t = A(t, e, r), u = n, t = N(t, e));
                    }
                } else v = 0, t = A(t, e, r);
            } else v = a ? 1 : 0, t = A(t, e, r);
            return t;
        }, this.__bidiEngine__.setOptions = function(t) {
            t && (i = t.isInputVisual, o = t.isOutputVisual, a = t.isInputRtl, s = t.isOutputRtl, u = t.isSymmetricSwapping);
        }, this.__bidiEngine__.setOptions(t), this.__bidiEngine__;
    };
    var e = [
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "S",
        "B",
        "S",
        "WS",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "B",
        "B",
        "S",
        "WS",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "CS",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "L",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "ET",
        "ET",
        "EN",
        "EN",
        "N",
        "L",
        "N",
        "N",
        "N",
        "EN",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "N",
        "N",
        "AL",
        "ET",
        "ET",
        "AL",
        "CS",
        "AL",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "ET",
        "AN",
        "AN",
        "AL",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "BN",
        "BN",
        "BN",
        "L",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "B",
        "LRE",
        "RLE",
        "PDF",
        "LRO",
        "RLO",
        "CS",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "N",
        "LRI",
        "RLI",
        "FSI",
        "PDI",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "EN",
        "L",
        "N",
        "N",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "L",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "NSM",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "ES",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "CS",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "N",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N"
    ], r = new t.__bidiEngine__({
        isInputVisual: !0
    });
    t.API.events.push([
        "postProcessText",
        function(t) {
            var e = t.text;
            t.x, t.y;
            var n = t.options || {};
            t.mutex, n.lang;
            var i = [];
            if (n.isInputVisual = "boolean" != typeof n.isInputVisual || n.isInputVisual, r.setOptions(n), "[object Array]" === Object.prototype.toString.call(e)) {
                var a = 0;
                for(i = [], a = 0; a < e.length; a += 1)"[object Array]" === Object.prototype.toString.call(e[a]) ? i.push([
                    r.doBidiReorder(e[a][0]),
                    e[a][1],
                    e[a][2]
                ]) : i.push([
                    r.doBidiReorder(e[a])
                ]);
                t.text = i;
            } else t.text = r.doBidiReorder(e);
            r.setOptions({
                isInputVisual: !0
            });
        }
    ]);
}($dbd37edd557d3750$export$2e2bcd8739ae039), $dbd37edd557d3750$export$2e2bcd8739ae039.API.TTFFont = function() {
    function t(t) {
        var e;
        if (this.rawData = t, e = this.contents = new $dbd37edd557d3750$var$fe(t), this.contents.pos = 4, "ttcf" === e.readString(4)) throw new Error("TTCF not supported.");
        e.pos = 0, this.parse(), this.subset = new $dbd37edd557d3750$var$Ce(this), this.registerTTF();
    }
    return t.open = function(e) {
        return new t(e);
    }, t.prototype.parse = function() {
        return this.directory = new $dbd37edd557d3750$var$de(this.contents), this.head = new $dbd37edd557d3750$var$me(this), this.name = new $dbd37edd557d3750$var$xe(this), this.cmap = new $dbd37edd557d3750$var$be(this), this.toUnicode = {}, this.hhea = new $dbd37edd557d3750$var$ye(this), this.maxp = new $dbd37edd557d3750$var$Ae(this), this.hmtx = new $dbd37edd557d3750$var$Se(this), this.post = new $dbd37edd557d3750$var$Ne(this), this.os2 = new $dbd37edd557d3750$var$we(this), this.loca = new $dbd37edd557d3750$var$Ie(this), this.glyf = new $dbd37edd557d3750$var$Pe(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [
            this.head.xMin,
            this.head.yMin,
            this.head.xMax,
            this.head.yMax
        ];
    }, t.prototype.registerTTF = function() {
        var t, e, r, n, i;
        if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
            var e, r, n, i;
            for(i = [], e = 0, r = (n = this.bbox).length; e < r; e++)t = n[e], i.push(Math.round(t * this.scaleFactor));
            return i;
        }).call(this), this.stemV = 0, this.post.exists ? (r = 255 & (n = this.post.italic_angle), 32768 & (e = n >> 16) && (e = -(1 + (65535 ^ e))), this.italicAngle = +(e + "." + r)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = 1 === (i = this.familyClass) || 2 === i || 3 === i || 4 === i || 5 === i || 7 === i, this.isScript = 10 === this.familyClass, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), 0 !== this.italicAngle && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
    }, t.prototype.characterToGlyph = function(t) {
        var e;
        return (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) || 0;
    }, t.prototype.widthOfGlyph = function(t) {
        var e;
        return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
    }, t.prototype.widthOfString = function(t, e, r) {
        var n, i, a, o;
        for(a = 0, i = 0, o = (t = "" + t).length; 0 <= o ? i < o : i > o; i = 0 <= o ? ++i : --i)n = t.charCodeAt(i), a += this.widthOfGlyph(this.characterToGlyph(n)) + r * (1e3 / e) || 0;
        return a * (e / 1e3);
    }, t.prototype.lineHeight = function(t, e) {
        var r;
        return null == e && (e = !1), r = e ? this.lineGap : 0, (this.ascender + r - this.decender) / 1e3 * t;
    }, t;
}();
var $dbd37edd557d3750$var$he, $dbd37edd557d3750$var$fe = function() {
    function t(t) {
        this.data = null != t ? t : [], this.pos = 0, this.length = this.data.length;
    }
    return t.prototype.readByte = function() {
        return this.data[this.pos++];
    }, t.prototype.writeByte = function(t) {
        return this.data[this.pos++] = t;
    }, t.prototype.readUInt32 = function() {
        return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
    }, t.prototype.writeUInt32 = function(t) {
        return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, t.prototype.readInt32 = function() {
        var t;
        return (t = this.readUInt32()) >= 2147483648 ? t - 4294967296 : t;
    }, t.prototype.writeInt32 = function(t) {
        return t < 0 && (t += 4294967296), this.writeUInt32(t);
    }, t.prototype.readUInt16 = function() {
        return this.readByte() << 8 | this.readByte();
    }, t.prototype.writeUInt16 = function(t) {
        return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, t.prototype.readInt16 = function() {
        var t;
        return (t = this.readUInt16()) >= 32768 ? t - 65536 : t;
    }, t.prototype.writeInt16 = function(t) {
        return t < 0 && (t += 65536), this.writeUInt16(t);
    }, t.prototype.readString = function(t) {
        var e, r;
        for(r = [], e = 0; 0 <= t ? e < t : e > t; e = 0 <= t ? ++e : --e)r[e] = String.fromCharCode(this.readByte());
        return r.join("");
    }, t.prototype.writeString = function(t) {
        var e, r, n;
        for(n = [], e = 0, r = t.length; 0 <= r ? e < r : e > r; e = 0 <= r ? ++e : --e)n.push(this.writeByte(t.charCodeAt(e)));
        return n;
    }, t.prototype.readShort = function() {
        return this.readInt16();
    }, t.prototype.writeShort = function(t) {
        return this.writeInt16(t);
    }, t.prototype.readLongLong = function() {
        var t, e, r, n, i, a, o, s;
        return t = this.readByte(), e = this.readByte(), r = this.readByte(), n = this.readByte(), i = this.readByte(), a = this.readByte(), o = this.readByte(), s = this.readByte(), 128 & t ? -1 * (72057594037927940 * (255 ^ t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ r) + 4294967296 * (255 ^ n) + 16777216 * (255 ^ i) + 65536 * (255 ^ a) + 256 * (255 ^ o) + (255 ^ s) + 1) : 72057594037927940 * t + 281474976710656 * e + 1099511627776 * r + 4294967296 * n + 16777216 * i + 65536 * a + 256 * o + s;
    }, t.prototype.writeLongLong = function(t) {
        var e, r;
        return e = Math.floor(t / 4294967296), r = 4294967295 & t, this.writeByte(e >> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e), this.writeByte(r >> 24 & 255), this.writeByte(r >> 16 & 255), this.writeByte(r >> 8 & 255), this.writeByte(255 & r);
    }, t.prototype.readInt = function() {
        return this.readInt32();
    }, t.prototype.writeInt = function(t) {
        return this.writeInt32(t);
    }, t.prototype.read = function(t) {
        var e, r;
        for(e = [], r = 0; 0 <= t ? r < t : r > t; r = 0 <= t ? ++r : --r)e.push(this.readByte());
        return e;
    }, t.prototype.write = function(t) {
        var e, r, n, i;
        for(i = [], r = 0, n = t.length; r < n; r++)e = t[r], i.push(this.writeByte(e));
        return i;
    }, t;
}(), $dbd37edd557d3750$var$de = function() {
    var t;
    function e(t) {
        var e, r, n;
        for(this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, r = 0, n = this.tableCount; 0 <= n ? r < n : r > n; r = 0 <= n ? ++r : --r)e = {
            tag: t.readString(4),
            checksum: t.readInt(),
            offset: t.readInt(),
            length: t.readInt()
        }, this.tables[e.tag] = e;
    }
    return e.prototype.encode = function(e) {
        var r, n, i, a, o, s, u, c, l, h, f, d, p;
        for(p in f = Object.keys(e).length, s = Math.log(2), l = 16 * Math.floor(Math.log(f) / s), a = Math.floor(l / s), c = 16 * f - l, (n = new $dbd37edd557d3750$var$fe).writeInt(this.scalarType), n.writeShort(f), n.writeShort(l), n.writeShort(a), n.writeShort(c), i = 16 * f, u = n.pos + i, o = null, d = [], e)for(h = e[p], n.writeString(p), n.writeInt(t(h)), n.writeInt(u), n.writeInt(h.length), d = d.concat(h), "head" === p && (o = u), u += h.length; u % 4;)d.push(0), u++;
        return n.write(d), r = 2981146554 - t(n.data), n.pos = o + 8, n.writeUInt32(r), n.data;
    }, t = function(t) {
        var e, r, n, i;
        for(t = $dbd37edd557d3750$var$_e.call(t); t.length % 4;)t.push(0);
        for(n = new $dbd37edd557d3750$var$fe(t), r = 0, e = 0, i = t.length; e < i; e = e += 4)r += n.readUInt32();
        return 4294967295 & r;
    }, e;
}(), $dbd37edd557d3750$var$pe = {}.hasOwnProperty, $dbd37edd557d3750$var$ge = function(t, e) {
    for(var r in e)$dbd37edd557d3750$var$pe.call(e, r) && (t[r] = e[r]);
    function n() {
        this.constructor = t;
    }
    return n.prototype = e.prototype, t.prototype = new n, t.__super__ = e.prototype, t;
};
$dbd37edd557d3750$var$he = function() {
    function t(t) {
        var e;
        this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
    }
    return t.prototype.parse = function() {}, t.prototype.encode = function() {}, t.prototype.raw = function() {
        return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
    }, t;
}();
var $dbd37edd557d3750$var$me = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $dbd37edd557d3750$var$ge(t, $dbd37edd557d3750$var$he), t.prototype.tag = "head", t.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
    }, t.prototype.encode = function(t) {
        var e;
        return (e = new $dbd37edd557d3750$var$fe).writeInt(this.version), e.writeInt(this.revision), e.writeInt(this.checkSumAdjustment), e.writeInt(this.magicNumber), e.writeShort(this.flags), e.writeShort(this.unitsPerEm), e.writeLongLong(this.created), e.writeLongLong(this.modified), e.writeShort(this.xMin), e.writeShort(this.yMin), e.writeShort(this.xMax), e.writeShort(this.yMax), e.writeShort(this.macStyle), e.writeShort(this.lowestRecPPEM), e.writeShort(this.fontDirectionHint), e.writeShort(t), e.writeShort(this.glyphDataFormat), e.data;
    }, t;
}(), $dbd37edd557d3750$var$ve = function() {
    function t(t, e) {
        var r, n, i, a, o, s, u, c, l, h, f, d, p, g, m, v, b;
        switch(this.platformID = t.readUInt16(), this.encodingID = t.readShort(), this.offset = e + t.readInt(), l = t.pos, t.pos = this.offset, this.format = t.readUInt16(), this.length = t.readUInt16(), this.language = t.readUInt16(), this.isUnicode = 3 === this.platformID && 1 === this.encodingID && 4 === this.format || 0 === this.platformID && 4 === this.format, this.codeMap = {}, this.format){
            case 0:
                for(s = 0; s < 256; ++s)this.codeMap[s] = t.readByte();
                break;
            case 4:
                for(f = t.readUInt16(), h = f / 2, t.pos += 6, i = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), t.pos += 2, p = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), u = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), c = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= h ? e < h : e > h; s = 0 <= h ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), n = (this.length - t.pos + this.offset) / 2, o = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= n ? e < n : e > n; s = 0 <= n ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), s = m = 0, b = i.length; m < b; s = ++m)for(g = i[s], r = v = d = p[s]; d <= g ? v <= g : v >= g; r = d <= g ? ++v : --v)0 === c[s] ? a = r + u[s] : 0 !== (a = o[c[s] / 2 + (r - d) - (h - s)] || 0) && (a += u[s]), this.codeMap[r] = 65535 & a;
        }
        t.pos = l;
    }
    return t.encode = function(t, e) {
        var r, n, i, a, o, s, u, c, l, h, f, d, p, g, m, v, b, y, w, N, L, x, A, S, _, P, k, F, I, C, j, O, B, M, q, E, R, D, T, z, U, H, W, V, G, Y;
        switch(F = new $dbd37edd557d3750$var$fe, a = Object.keys(t).sort(function(t, e) {
            return t - e;
        }), e){
            case "macroman":
                for(p = 0, g = function() {
                    var t = [];
                    for(d = 0; d < 256; ++d)t.push(0);
                    return t;
                }(), v = {
                    0: 0
                }, i = {}, I = 0, B = a.length; I < B; I++)null == v[W = t[n = a[I]]] && (v[W] = ++p), i[n] = {
                    old: t[n],
                    new: v[t[n]]
                }, g[n] = v[t[n]];
                return F.writeUInt16(1), F.writeUInt16(0), F.writeUInt32(12), F.writeUInt16(0), F.writeUInt16(262), F.writeUInt16(0), F.write(g), {
                    charMap: i,
                    subtable: F.data,
                    maxGlyphID: p + 1
                };
            case "unicode":
                for(P = [], l = [], b = 0, v = {}, r = {}, m = u = null, C = 0, M = a.length; C < M; C++)null == v[w = t[n = a[C]]] && (v[w] = ++b), r[n] = {
                    old: w,
                    new: v[w]
                }, o = v[w] - n, null != m && o === u || (m && l.push(m), P.push(n), u = o), m = n;
                for(m && l.push(m), l.push(65535), P.push(65535), S = 2 * (A = P.length), x = 2 * Math.pow(Math.log(A) / Math.LN2, 2), h = Math.log(x / 2) / Math.LN2, L = 2 * A - x, s = [], N = [], f = [], d = j = 0, q = P.length; j < q; d = ++j){
                    if (_ = P[d], c = l[d], 65535 === _) {
                        s.push(0), N.push(0);
                        break;
                    }
                    if (_ - (k = r[_].new) >= 32768) for(s.push(0), N.push(2 * (f.length + A - d)), n = O = _; _ <= c ? O <= c : O >= c; n = _ <= c ? ++O : --O)f.push(r[n].new);
                    else s.push(k - _), N.push(0);
                }
                for(F.writeUInt16(3), F.writeUInt16(1), F.writeUInt32(12), F.writeUInt16(4), F.writeUInt16(16 + 8 * A + 2 * f.length), F.writeUInt16(0), F.writeUInt16(S), F.writeUInt16(x), F.writeUInt16(h), F.writeUInt16(L), U = 0, E = l.length; U < E; U++)n = l[U], F.writeUInt16(n);
                for(F.writeUInt16(0), H = 0, R = P.length; H < R; H++)n = P[H], F.writeUInt16(n);
                for(V = 0, D = s.length; V < D; V++)o = s[V], F.writeUInt16(o);
                for(G = 0, T = N.length; G < T; G++)y = N[G], F.writeUInt16(y);
                for(Y = 0, z = f.length; Y < z; Y++)p = f[Y], F.writeUInt16(p);
                return {
                    charMap: r,
                    subtable: F.data,
                    maxGlyphID: b + 1
                };
        }
    }, t;
}(), $dbd37edd557d3750$var$be = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $dbd37edd557d3750$var$ge(t, $dbd37edd557d3750$var$he), t.prototype.tag = "cmap", t.prototype.parse = function(t) {
        var e, r, n;
        for(t.pos = this.offset, this.version = t.readUInt16(), n = t.readUInt16(), this.tables = [], this.unicode = null, r = 0; 0 <= n ? r < n : r > n; r = 0 <= n ? ++r : --r)e = new $dbd37edd557d3750$var$ve(t, this.offset), this.tables.push(e), e.isUnicode && null == this.unicode && (this.unicode = e);
        return !0;
    }, t.encode = function(t, e) {
        var r, n;
        return null == e && (e = "macroman"), r = $dbd37edd557d3750$var$ve.encode(t, e), (n = new $dbd37edd557d3750$var$fe).writeUInt16(0), n.writeUInt16(1), r.table = n.data.concat(r.subtable), r;
    }, t;
}(), $dbd37edd557d3750$var$ye = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $dbd37edd557d3750$var$ge(t, $dbd37edd557d3750$var$he), t.prototype.tag = "hhea", t.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
    }, t;
}(), $dbd37edd557d3750$var$we = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $dbd37edd557d3750$var$ge(t, $dbd37edd557d3750$var$he), t.prototype.tag = "OS/2", t.prototype.parse = function(t) {
        if (t.pos = this.offset, this.version = t.readUInt16(), this.averageCharWidth = t.readShort(), this.weightClass = t.readUInt16(), this.widthClass = t.readUInt16(), this.type = t.readShort(), this.ySubscriptXSize = t.readShort(), this.ySubscriptYSize = t.readShort(), this.ySubscriptXOffset = t.readShort(), this.ySubscriptYOffset = t.readShort(), this.ySuperscriptXSize = t.readShort(), this.ySuperscriptYSize = t.readShort(), this.ySuperscriptXOffset = t.readShort(), this.ySuperscriptYOffset = t.readShort(), this.yStrikeoutSize = t.readShort(), this.yStrikeoutPosition = t.readShort(), this.familyClass = t.readShort(), this.panose = function() {
            var e, r;
            for(r = [], e = 0; e < 10; ++e)r.push(t.readByte());
            return r;
        }(), this.charRange = function() {
            var e, r;
            for(r = [], e = 0; e < 4; ++e)r.push(t.readInt());
            return r;
        }(), this.vendorID = t.readString(4), this.selection = t.readShort(), this.firstCharIndex = t.readShort(), this.lastCharIndex = t.readShort(), this.version > 0 && (this.ascent = t.readShort(), this.descent = t.readShort(), this.lineGap = t.readShort(), this.winAscent = t.readShort(), this.winDescent = t.readShort(), this.codePageRange = function() {
            var e, r;
            for(r = [], e = 0; e < 2; e = ++e)r.push(t.readInt());
            return r;
        }(), this.version > 1)) return this.xHeight = t.readShort(), this.capHeight = t.readShort(), this.defaultChar = t.readShort(), this.breakChar = t.readShort(), this.maxContext = t.readShort();
    }, t;
}(), $dbd37edd557d3750$var$Ne = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $dbd37edd557d3750$var$ge(t, $dbd37edd557d3750$var$he), t.prototype.tag = "post", t.prototype.parse = function(t) {
        var e, r, n;
        switch(t.pos = this.offset, this.format = t.readInt(), this.italicAngle = t.readInt(), this.underlinePosition = t.readShort(), this.underlineThickness = t.readShort(), this.isFixedPitch = t.readInt(), this.minMemType42 = t.readInt(), this.maxMemType42 = t.readInt(), this.minMemType1 = t.readInt(), this.maxMemType1 = t.readInt(), this.format){
            case 65536:
            case 196608:
                break;
            case 131072:
                var i;
                for(r = t.readUInt16(), this.glyphNameIndex = [], i = 0; 0 <= r ? i < r : i > r; i = 0 <= r ? ++i : --i)this.glyphNameIndex.push(t.readUInt16());
                for(this.names = [], n = []; t.pos < this.offset + this.length;)e = t.readByte(), n.push(this.names.push(t.readString(e)));
                return n;
            case 151552:
                return r = t.readUInt16(), this.offsets = t.read(r);
            case 262144:
                return this.map = (function() {
                    var e, r, n;
                    for(n = [], i = e = 0, r = this.file.maxp.numGlyphs; 0 <= r ? e < r : e > r; i = 0 <= r ? ++e : --e)n.push(t.readUInt32());
                    return n;
                }).call(this);
        }
    }, t;
}(), $dbd37edd557d3750$var$Le = function(t, e) {
    this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
}, $dbd37edd557d3750$var$xe = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $dbd37edd557d3750$var$ge(t, $dbd37edd557d3750$var$he), t.prototype.tag = "name", t.prototype.parse = function(t) {
        var e, r, n, i, a, o, s, u, c, l, h;
        for(t.pos = this.offset, t.readShort(), e = t.readShort(), o = t.readShort(), r = [], i = 0; 0 <= e ? i < e : i > e; i = 0 <= e ? ++i : --i)r.push({
            platformID: t.readShort(),
            encodingID: t.readShort(),
            languageID: t.readShort(),
            nameID: t.readShort(),
            length: t.readShort(),
            offset: this.offset + o + t.readShort()
        });
        for(s = {}, i = c = 0, l = r.length; c < l; i = ++c)n = r[i], t.pos = n.offset, u = t.readString(n.length), a = new $dbd37edd557d3750$var$Le(u, n), null == s[h = n.nameID] && (s[h] = []), s[n.nameID].push(a);
        this.strings = s, this.copyright = s[0], this.fontFamily = s[1], this.fontSubfamily = s[2], this.uniqueSubfamily = s[3], this.fontName = s[4], this.version = s[5];
        try {
            this.postscriptName = s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        } catch (f) {
            this.postscriptName = s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        }
        return this.trademark = s[7], this.manufacturer = s[8], this.designer = s[9], this.description = s[10], this.vendorUrl = s[11], this.designerUrl = s[12], this.license = s[13], this.licenseUrl = s[14], this.preferredFamily = s[15], this.preferredSubfamily = s[17], this.compatibleFull = s[18], this.sampleText = s[19];
    }, t;
}(), $dbd37edd557d3750$var$Ae = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $dbd37edd557d3750$var$ge(t, $dbd37edd557d3750$var$he), t.prototype.tag = "maxp", t.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
    }, t;
}(), $dbd37edd557d3750$var$Se = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $dbd37edd557d3750$var$ge(t, $dbd37edd557d3750$var$he), t.prototype.tag = "hmtx", t.prototype.parse = function(t) {
        var e, r, n, i, a, o, s;
        for(t.pos = this.offset, this.metrics = [], e = 0, o = this.file.hhea.numberOfMetrics; 0 <= o ? e < o : e > o; e = 0 <= o ? ++e : --e)this.metrics.push({
            advance: t.readUInt16(),
            lsb: t.readInt16()
        });
        for(n = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
            var r, i;
            for(i = [], e = r = 0; 0 <= n ? r < n : r > n; e = 0 <= n ? ++r : --r)i.push(t.readInt16());
            return i;
        }(), this.widths = (function() {
            var t, e, r, n;
            for(n = [], t = 0, e = (r = this.metrics).length; t < e; t++)i = r[t], n.push(i.advance);
            return n;
        }).call(this), r = this.widths[this.widths.length - 1], s = [], e = a = 0; 0 <= n ? a < n : a > n; e = 0 <= n ? ++a : --a)s.push(this.widths.push(r));
        return s;
    }, t.prototype.forGlyph = function(t) {
        return t in this.metrics ? this.metrics[t] : {
            advance: this.metrics[this.metrics.length - 1].advance,
            lsb: this.leftSideBearings[t - this.metrics.length]
        };
    }, t;
}(), $dbd37edd557d3750$var$_e = [].slice, $dbd37edd557d3750$var$Pe = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $dbd37edd557d3750$var$ge(t, $dbd37edd557d3750$var$he), t.prototype.tag = "glyf", t.prototype.parse = function() {
        return this.cache = {};
    }, t.prototype.glyphFor = function(t) {
        var e, r, n, i, a, o, s, u, c, l;
        return t in this.cache ? this.cache[t] : (i = this.file.loca, e = this.file.contents, r = i.indexOf(t), 0 === (n = i.lengthOf(t)) ? this.cache[t] = null : (e.pos = this.offset + r, a = (o = new $dbd37edd557d3750$var$fe(e.read(n))).readShort(), u = o.readShort(), l = o.readShort(), s = o.readShort(), c = o.readShort(), this.cache[t] = -1 === a ? new $dbd37edd557d3750$var$Fe(o, u, l, s, c) : new $dbd37edd557d3750$var$ke(o, a, u, l, s, c), this.cache[t]));
    }, t.prototype.encode = function(t, e, r) {
        var n, i, a, o, s;
        for(a = [], i = [], o = 0, s = e.length; o < s; o++)n = t[e[o]], i.push(a.length), n && (a = a.concat(n.encode(r)));
        return i.push(a.length), {
            table: a,
            offsets: i
        };
    }, t;
}(), $dbd37edd557d3750$var$ke = function() {
    function t(t, e, r, n, i, a) {
        this.raw = t, this.numberOfContours = e, this.xMin = r, this.yMin = n, this.xMax = i, this.yMax = a, this.compound = !1;
    }
    return t.prototype.encode = function() {
        return this.raw.data;
    }, t;
}(), $dbd37edd557d3750$var$Fe = function() {
    function t(t, e, r, n, i) {
        var a, o;
        for(this.raw = t, this.xMin = e, this.yMin = r, this.xMax = n, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], a = this.raw; o = a.readShort(), this.glyphOffsets.push(a.pos), this.glyphIDs.push(a.readUInt16()), 32 & o;)a.pos += 1 & o ? 4 : 2, 128 & o ? a.pos += 8 : 64 & o ? a.pos += 4 : 8 & o && (a.pos += 2);
    }
    return t.prototype.encode = function() {
        var t, e, r;
        for(e = new $dbd37edd557d3750$var$fe($dbd37edd557d3750$var$_e.call(this.raw.data)), t = 0, r = this.glyphIDs.length; t < r; ++t)e.pos = this.glyphOffsets[t];
        return e.data;
    }, t;
}(), $dbd37edd557d3750$var$Ie = function() {
    function t() {
        return t.__super__.constructor.apply(this, arguments);
    }
    return $dbd37edd557d3750$var$ge(t, $dbd37edd557d3750$var$he), t.prototype.tag = "loca", t.prototype.parse = function(t) {
        var e, r;
        return t.pos = this.offset, e = this.file.head.indexToLocFormat, this.offsets = 0 === e ? (function() {
            var e, n;
            for(n = [], r = 0, e = this.length; r < e; r += 2)n.push(2 * t.readUInt16());
            return n;
        }).call(this) : (function() {
            var e, n;
            for(n = [], r = 0, e = this.length; r < e; r += 4)n.push(t.readUInt32());
            return n;
        }).call(this);
    }, t.prototype.indexOf = function(t) {
        return this.offsets[t];
    }, t.prototype.lengthOf = function(t) {
        return this.offsets[t + 1] - this.offsets[t];
    }, t.prototype.encode = function(t, e) {
        for(var r = new Uint32Array(this.offsets.length), n = 0, i = 0, a = 0; a < r.length; ++a)if (r[a] = n, i < e.length && e[i] == a) {
            ++i, r[a] = n;
            var o = this.offsets[a], s = this.offsets[a + 1] - o;
            s > 0 && (n += s);
        }
        for(var u = new Array(4 * r.length), c = 0; c < r.length; ++c)u[4 * c + 3] = 255 & r[c], u[4 * c + 2] = (65280 & r[c]) >> 8, u[4 * c + 1] = (16711680 & r[c]) >> 16, u[4 * c] = (4278190080 & r[c]) >> 24;
        return u;
    }, t;
}(), $dbd37edd557d3750$var$Ce = function() {
    function t(t) {
        this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
    }
    return t.prototype.generateCmap = function() {
        var t, e, r, n, i;
        for(e in n = this.font.cmap.tables[0].codeMap, t = {}, i = this.subset)r = i[e], t[e] = n[r];
        return t;
    }, t.prototype.glyphsFor = function(t) {
        var e, r, n, i, a, o, s;
        for(n = {}, a = 0, o = t.length; a < o; a++)n[i = t[a]] = this.font.glyf.glyphFor(i);
        for(i in e = [], n)(null != (r = n[i]) ? r.compound : void 0) && e.push.apply(e, r.glyphIDs);
        if (e.length > 0) for(i in s = this.glyphsFor(e))r = s[i], n[i] = r;
        return n;
    }, t.prototype.encode = function(t, e) {
        var r, n, i, a, o, s, u, c, l, h, f, d, p, g, m;
        for(n in r = $dbd37edd557d3750$var$be.encode(this.generateCmap(), "unicode"), a = this.glyphsFor(t), f = {
            0: 0
        }, m = r.charMap)f[(s = m[n]).old] = s.new;
        for(d in h = r.maxGlyphID, a)d in f || (f[d] = h++);
        return c = function(t) {
            var e, r;
            for(e in r = {}, t)r[t[e]] = e;
            return r;
        }(f), l = Object.keys(c).sort(function(t, e) {
            return t - e;
        }), p = function() {
            var t, e, r;
            for(r = [], t = 0, e = l.length; t < e; t++)o = l[t], r.push(c[o]);
            return r;
        }(), i = this.font.glyf.encode(a, p, f), u = this.font.loca.encode(i.offsets, p), g = {
            cmap: this.font.cmap.raw(),
            glyf: i.table,
            loca: u,
            hmtx: this.font.hmtx.raw(),
            hhea: this.font.hhea.raw(),
            maxp: this.font.maxp.raw(),
            post: this.font.post.raw(),
            name: this.font.name.raw(),
            head: this.font.head.encode(e)
        }, this.font.os2.exists && (g["OS/2"] = this.font.os2.raw()), this.font.directory.encode(g);
    }, t;
}();
$dbd37edd557d3750$export$2e2bcd8739ae039.API.PDFObject = function() {
    var t;
    function e() {}
    return t = function(t, e) {
        return (Array(e + 1).join("0") + t).slice(-e);
    }, e.convert = function(r) {
        var n, i, a, o;
        if (Array.isArray(r)) return "[" + (function() {
            var t, i, a;
            for(a = [], t = 0, i = r.length; t < i; t++)n = r[t], a.push(e.convert(n));
            return a;
        })().join(" ") + "]";
        if ("string" == typeof r) return "/" + r;
        if (null != r ? r.isString : void 0) return "(" + r + ")";
        if (r instanceof Date) return "(D:" + t(r.getUTCFullYear(), 4) + t(r.getUTCMonth(), 2) + t(r.getUTCDate(), 2) + t(r.getUTCHours(), 2) + t(r.getUTCMinutes(), 2) + t(r.getUTCSeconds(), 2) + "Z)";
        if ("[object Object]" === ({}).toString.call(r)) {
            for(i in a = [
                "<<"
            ], r)o = r[i], a.push("/" + i + " " + e.convert(o));
            return a.push(">>"), a.join("\n");
        }
        return "" + r;
    }, e;
}();



var $30f18b46c5972596$exports = {};
/*!
 * 
 *               jsPDF AutoTable plugin v5.0.7
 *
 *               Copyright (c) 2026 Simon Bengtsson, https://github.com/simonbengtsson/jsPDF-AutoTable
 *               Licensed under the MIT License.
 *               http://opensource.org/licenses/mit-license
 *
 */ (function webpackUniversalModuleDefinition(root, factory) {
    var a, i;
    $30f18b46c5972596$exports = factory();
})(Object(typeof globalThis !== 'undefined' ? globalThis : typeof $30f18b46c5972596$exports !== 'undefined' ? $30f18b46c5972596$exports : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : $parcel$global), function() {
    return /******/ function() {
        /******/ "use strict";
        /******/ var __webpack_modules__ = {
            /***/ 28: /***/ function(__unused_webpack_module, exports) {
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.HtmlRowInput = void 0;
                exports.defaultStyles = defaultStyles;
                exports.getTheme = getTheme;
                var HtmlRowInput = /** @class */ function(_super) {
                    __extends(HtmlRowInput, _super);
                    function HtmlRowInput(element) {
                        var _this = _super.call(this) || this;
                        _this._element = element;
                        return _this;
                    }
                    return HtmlRowInput;
                }(Array);
                exports.HtmlRowInput = HtmlRowInput;
                // Base style for all themes
                function defaultStyles(scaleFactor) {
                    return {
                        font: 'helvetica',
                        fontStyle: 'normal',
                        overflow: 'linebreak',
                        fillColor: false,
                        textColor: 20,
                        halign: 'left',
                        valign: 'top',
                        fontSize: 10,
                        cellPadding: 5 / scaleFactor,
                        lineColor: 200,
                        lineWidth: 0,
                        cellWidth: 'auto',
                        minCellHeight: 0,
                        minCellWidth: 0
                    };
                }
                function getTheme(name) {
                    var themes = {
                        striped: {
                            table: {
                                fillColor: 255,
                                textColor: 80,
                                fontStyle: 'normal'
                            },
                            head: {
                                textColor: 255,
                                fillColor: [
                                    41,
                                    128,
                                    185
                                ],
                                fontStyle: 'bold'
                            },
                            body: {},
                            foot: {
                                textColor: 255,
                                fillColor: [
                                    41,
                                    128,
                                    185
                                ],
                                fontStyle: 'bold'
                            },
                            alternateRow: {
                                fillColor: 245
                            }
                        },
                        grid: {
                            table: {
                                fillColor: 255,
                                textColor: 80,
                                fontStyle: 'normal',
                                lineWidth: 0.1
                            },
                            head: {
                                textColor: 255,
                                fillColor: [
                                    26,
                                    188,
                                    156
                                ],
                                fontStyle: 'bold',
                                lineWidth: 0
                            },
                            body: {},
                            foot: {
                                textColor: 255,
                                fillColor: [
                                    26,
                                    188,
                                    156
                                ],
                                fontStyle: 'bold',
                                lineWidth: 0
                            },
                            alternateRow: {}
                        },
                        plain: {
                            head: {
                                fontStyle: 'bold'
                            },
                            foot: {
                                fontStyle: 'bold'
                            }
                        }
                    };
                    return themes[name];
                }
            /***/ },
            /***/ 150: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = default_1;
                /**
 * Improved text function with halign and valign support
 * Inspiration from: http://stackoverflow.com/questions/28327510/align-text-right-using-jspdf/28433113#28433113
 */ function default_1(text, x, y, styles, doc) {
                    styles = styles || {};
                    var PHYSICAL_LINE_HEIGHT = 1.15;
                    var k = doc.internal.scaleFactor;
                    var fontSize = doc.internal.getFontSize() / k;
                    var lineHeightFactor = doc.getLineHeightFactor ? doc.getLineHeightFactor() : PHYSICAL_LINE_HEIGHT;
                    var lineHeight = fontSize * lineHeightFactor;
                    var splitRegex = /\r\n|\r|\n/g;
                    var splitText = '';
                    var lineCount = 1;
                    if (styles.valign === 'middle' || styles.valign === 'bottom' || styles.halign === 'center' || styles.halign === 'right') {
                        splitText = typeof text === 'string' ? text.split(splitRegex) : text;
                        lineCount = splitText.length || 1;
                    }
                    // Align the top
                    y += fontSize * (2 - PHYSICAL_LINE_HEIGHT);
                    if (styles.valign === 'middle') y -= lineCount / 2 * lineHeight;
                    else if (styles.valign === 'bottom') y -= lineCount * lineHeight;
                    if (styles.halign === 'center' || styles.halign === 'right') {
                        var alignSize = fontSize;
                        if (styles.halign === 'center') alignSize *= 0.5;
                        if (splitText && lineCount >= 1) {
                            for(var iLine = 0; iLine < splitText.length; iLine++){
                                doc.text(splitText[iLine], x - doc.getStringUnitWidth(splitText[iLine]) * alignSize, y);
                                y += lineHeight;
                            }
                            return doc;
                        }
                        x -= doc.getStringUnitWidth(text) * alignSize;
                    }
                    if (styles.halign === 'justify') doc.text(text, x, y, {
                        maxWidth: styles.maxWidth || 100,
                        align: 'justify'
                    });
                    else doc.text(text, x, y);
                    return doc;
                }
            /***/ },
            /***/ 152: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.calculateWidths = calculateWidths;
                exports.resizeColumns = resizeColumns;
                exports.ellipsize = ellipsize;
                var common_1 = __webpack_require__(799);
                /**
 * Calculate the column widths
 */ function calculateWidths(doc, table) {
                    calculate(doc, table);
                    var resizableColumns = [];
                    var initialTableWidth = 0;
                    table.columns.forEach(function(column) {
                        var customWidth = column.getMaxCustomCellWidth(table);
                        if (customWidth) // final column width
                        column.width = customWidth;
                        else {
                            // initial column width (will be resized)
                            column.width = column.wrappedWidth;
                            resizableColumns.push(column);
                        }
                        initialTableWidth += column.width;
                    });
                    // width difference that needs to be distributed
                    var resizeWidth = table.getWidth(doc.pageSize().width) - initialTableWidth;
                    // first resize attempt: with respect to minReadableWidth and minWidth
                    if (resizeWidth) resizeWidth = resizeColumns(resizableColumns, resizeWidth, function(column) {
                        return Math.max(column.minReadableWidth, column.minWidth);
                    });
                    // second resize attempt: ignore minReadableWidth but respect minWidth
                    if (resizeWidth) resizeWidth = resizeColumns(resizableColumns, resizeWidth, function(column) {
                        return column.minWidth;
                    });
                    resizeWidth = Math.abs(resizeWidth);
                    if (!table.settings.horizontalPageBreak && resizeWidth > 0.1 / doc.scaleFactor()) {
                        // Table can't get smaller due to custom-width or minWidth restrictions
                        // We can't really do much here. Up to user to for example
                        // reduce font size, increase page size or remove custom cell widths
                        // to allow more columns to be reduced in size
                        resizeWidth = resizeWidth < 1 ? resizeWidth : Math.round(resizeWidth);
                        console.log("Of the table content, ".concat(resizeWidth, " units width could not fit page"));
                    }
                    applyColSpans(table);
                    fitContent(table, doc);
                    applyRowSpans(table);
                }
                function calculate(doc, table) {
                    var sf = doc.scaleFactor();
                    var horizontalPageBreak = table.settings.horizontalPageBreak;
                    var availablePageWidth = (0, common_1.getPageAvailableWidth)(doc, table);
                    table.allRows().forEach(function(row) {
                        for(var _i = 0, _a = table.columns; _i < _a.length; _i++){
                            var column = _a[_i];
                            var cell = row.cells[column.index];
                            if (!cell) continue;
                            var hooks = table.hooks.didParseCell;
                            table.callCellHooks(doc, hooks, cell, row, column, null);
                            var padding = cell.padding('horizontal');
                            cell.contentWidth = (0, common_1.getStringWidth)(cell.text, cell.styles, doc) + padding;
                            // Using [^\S\u00A0] instead of \s ensures that we split the text on all
                            // whitespace except non-breaking spaces (\u00A0). We need to preserve
                            // them in the split process to ensure correct word separation and width
                            // calculation.
                            var longestWordWidth = (0, common_1.getStringWidth)(cell.text.join(' ').split(/[^\S\u00A0]+/), cell.styles, doc);
                            cell.minReadableWidth = longestWordWidth + cell.padding('horizontal');
                            if (typeof cell.styles.cellWidth === 'number') {
                                cell.minWidth = cell.styles.cellWidth;
                                cell.wrappedWidth = cell.styles.cellWidth;
                            } else if (cell.styles.cellWidth === 'wrap' || horizontalPageBreak === true) {
                                // cell width should not be more than available page width
                                if (cell.contentWidth > availablePageWidth) {
                                    cell.minWidth = availablePageWidth;
                                    cell.wrappedWidth = availablePageWidth;
                                } else {
                                    cell.minWidth = cell.contentWidth;
                                    cell.wrappedWidth = cell.contentWidth;
                                }
                            } else {
                                // auto
                                var defaultMinWidth = 10 / sf;
                                cell.minWidth = cell.styles.minCellWidth || defaultMinWidth;
                                cell.wrappedWidth = cell.contentWidth;
                                if (cell.minWidth > cell.wrappedWidth) cell.wrappedWidth = cell.minWidth;
                            }
                        }
                    });
                    table.allRows().forEach(function(row) {
                        for(var _i = 0, _a = table.columns; _i < _a.length; _i++){
                            var column = _a[_i];
                            var cell = row.cells[column.index];
                            // For now we ignore the minWidth and wrappedWidth of colspan cells when calculating colspan widths.
                            // Could probably be improved upon however.
                            if (cell && cell.colSpan === 1) {
                                column.wrappedWidth = Math.max(column.wrappedWidth, cell.wrappedWidth);
                                column.minWidth = Math.max(column.minWidth, cell.minWidth);
                                column.minReadableWidth = Math.max(column.minReadableWidth, cell.minReadableWidth);
                            } else {
                                // Respect cellWidth set in columnStyles even if there is no cells for this column
                                // or if the column only have colspan cells. Since the width of colspan cells
                                // does not affect the width of columns, setting columnStyles cellWidth enables the
                                // user to at least do it manually.
                                // Note that this is not perfect for now since for example row and table styles are
                                // not accounted for
                                var columnStyles = table.styles.columnStyles[column.dataKey] || table.styles.columnStyles[column.index] || {};
                                var cellWidth = columnStyles.cellWidth || columnStyles.minCellWidth;
                                if (cellWidth && typeof cellWidth === 'number') {
                                    column.minWidth = cellWidth;
                                    column.wrappedWidth = cellWidth;
                                }
                            }
                            if (cell) {
                                // Make sure all columns get at least min width even though width calculations are not based on them
                                if (cell.colSpan > 1 && !column.minWidth) column.minWidth = cell.minWidth;
                                if (cell.colSpan > 1 && !column.wrappedWidth) column.wrappedWidth = cell.minWidth;
                            }
                        }
                    });
                }
                /**
 * Distribute resizeWidth on passed resizable columns
 */ function resizeColumns(columns, resizeWidth, getMinWidth) {
                    var initialResizeWidth = resizeWidth;
                    var sumWrappedWidth = columns.reduce(function(acc, column) {
                        return acc + column.wrappedWidth;
                    }, 0);
                    for(var i = 0; i < columns.length; i++){
                        var column = columns[i];
                        var ratio = column.wrappedWidth / sumWrappedWidth;
                        var suggestedChange = initialResizeWidth * ratio;
                        var suggestedWidth = column.width + suggestedChange;
                        var minWidth = getMinWidth(column);
                        var newWidth = suggestedWidth < minWidth ? minWidth : suggestedWidth;
                        resizeWidth -= newWidth - column.width;
                        column.width = newWidth;
                    }
                    resizeWidth = Math.round(resizeWidth * 1e10) / 1e10;
                    // Run the resizer again if there's remaining width needs
                    // to be distributed and there're columns that can be resized
                    if (resizeWidth) {
                        var resizableColumns = columns.filter(function(column) {
                            return resizeWidth < 0 ? column.width > getMinWidth(column) // check if column can shrink
                             : true; // check if column can grow
                        });
                        if (resizableColumns.length) resizeWidth = resizeColumns(resizableColumns, resizeWidth, getMinWidth);
                    }
                    return resizeWidth;
                }
                function applyRowSpans(table) {
                    var rowSpanCells = {};
                    var colRowSpansLeft = 1;
                    var all = table.allRows();
                    for(var rowIndex = 0; rowIndex < all.length; rowIndex++){
                        var row = all[rowIndex];
                        for(var _i = 0, _a = table.columns; _i < _a.length; _i++){
                            var column = _a[_i];
                            var data = rowSpanCells[column.index];
                            if (colRowSpansLeft > 1) {
                                colRowSpansLeft--;
                                delete row.cells[column.index];
                            } else if (data) {
                                data.cell.height += row.height;
                                colRowSpansLeft = data.cell.colSpan;
                                delete row.cells[column.index];
                                data.left--;
                                if (data.left <= 1) delete rowSpanCells[column.index];
                            } else {
                                var cell = row.cells[column.index];
                                if (!cell) continue;
                                cell.height = row.height;
                                if (cell.rowSpan > 1) {
                                    var remaining = all.length - rowIndex;
                                    var left = cell.rowSpan > remaining ? remaining : cell.rowSpan;
                                    rowSpanCells[column.index] = {
                                        cell: cell,
                                        left: left,
                                        row: row
                                    };
                                }
                            }
                        }
                    }
                }
                function applyColSpans(table) {
                    var all = table.allRows();
                    for(var rowIndex = 0; rowIndex < all.length; rowIndex++){
                        var row = all[rowIndex];
                        var colSpanCell = null;
                        var combinedColSpanWidth = 0;
                        var colSpansLeft = 0;
                        for(var columnIndex = 0; columnIndex < table.columns.length; columnIndex++){
                            var column = table.columns[columnIndex];
                            // Width and colspan
                            colSpansLeft -= 1;
                            if (colSpansLeft > 1 && table.columns[columnIndex + 1]) {
                                combinedColSpanWidth += column.width;
                                delete row.cells[column.index];
                            } else if (colSpanCell) {
                                var cell = colSpanCell;
                                delete row.cells[column.index];
                                colSpanCell = null;
                                cell.width = column.width + combinedColSpanWidth;
                            } else {
                                var cell = row.cells[column.index];
                                if (!cell) continue;
                                colSpansLeft = cell.colSpan;
                                combinedColSpanWidth = 0;
                                if (cell.colSpan > 1) {
                                    colSpanCell = cell;
                                    combinedColSpanWidth += column.width;
                                    continue;
                                }
                                cell.width = column.width + combinedColSpanWidth;
                            }
                        }
                    }
                }
                function fitContent(table, doc) {
                    var rowSpanHeight = {
                        count: 0,
                        height: 0
                    };
                    for(var _i = 0, _a = table.allRows(); _i < _a.length; _i++){
                        var row = _a[_i];
                        for(var _b = 0, _c = table.columns; _b < _c.length; _b++){
                            var column = _c[_b];
                            var cell = row.cells[column.index];
                            if (!cell) continue;
                            doc.applyStyles(cell.styles, true);
                            var textSpace = cell.width - cell.padding('horizontal');
                            if (cell.styles.overflow === 'linebreak') // Add one pt to textSpace to fix rounding error
                            cell.text = doc.splitTextToSize(cell.text, textSpace + 1 / doc.scaleFactor(), {
                                fontSize: cell.styles.fontSize
                            });
                            else if (cell.styles.overflow === 'ellipsize') cell.text = ellipsize(cell.text, textSpace, cell.styles, doc, '...');
                            else if (cell.styles.overflow === 'hidden') cell.text = ellipsize(cell.text, textSpace, cell.styles, doc, '');
                            else if (typeof cell.styles.overflow === 'function') {
                                var result = cell.styles.overflow(cell.text, textSpace);
                                if (typeof result === 'string') cell.text = [
                                    result
                                ];
                                else cell.text = result;
                            }
                            cell.contentHeight = cell.getContentHeight(doc.scaleFactor(), doc.getLineHeightFactor());
                            var realContentHeight = cell.contentHeight / cell.rowSpan;
                            if (cell.rowSpan > 1 && rowSpanHeight.count * rowSpanHeight.height < realContentHeight * cell.rowSpan) rowSpanHeight = {
                                height: realContentHeight,
                                count: cell.rowSpan
                            };
                            else if (rowSpanHeight && rowSpanHeight.count > 0) {
                                if (rowSpanHeight.height > realContentHeight) realContentHeight = rowSpanHeight.height;
                            }
                            if (realContentHeight > row.height) row.height = realContentHeight;
                        }
                        rowSpanHeight.count--;
                    }
                }
                function ellipsize(text, width, styles, doc, overflow) {
                    return text.map(function(str) {
                        return ellipsizeStr(str, width, styles, doc, overflow);
                    });
                }
                function ellipsizeStr(text, width, styles, doc, overflow) {
                    var precision = 10000 * doc.scaleFactor();
                    width = Math.ceil(width * precision) / precision;
                    if (width >= (0, common_1.getStringWidth)(text, styles, doc)) return text;
                    while(width < (0, common_1.getStringWidth)(text + overflow, styles, doc)){
                        if (text.length <= 1) break;
                        text = text.substring(0, text.length - 1);
                    }
                    return text.trim() + overflow;
                }
            /***/ },
            /***/ 176: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-unused-vars */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.assign = assign;
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
                function assign(target, s, s1, s2, s3) {
                    if (target == null) throw new TypeError('Cannot convert undefined or null to object');
                    var to = Object(target);
                    for(var index = 1; index < arguments.length; index++){
                        // eslint-disable-next-line prefer-rest-params
                        var nextSource = arguments[index];
                        if (nextSource != null) {
                            // Skip over if undefined or null
                            for(var nextKey in nextSource)// Avoid bugs when hasOwnProperty is shadowed
                            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) to[nextKey] = nextSource[nextKey];
                        }
                    }
                    return to;
                }
            /***/ },
            /***/ 344: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.validateInput = validateInput;
                function validateInput(global1, document, current) {
                    for(var _i = 0, _a = [
                        global1,
                        document,
                        current
                    ]; _i < _a.length; _i++){
                        var options = _a[_i];
                        if (options && typeof options !== 'object') console.error('The options parameter should be of type object, is: ' + typeof options);
                        if (options.startY && typeof options.startY !== 'number') {
                            console.error('Invalid value for startY option', options.startY);
                            delete options.startY;
                        }
                    }
                }
            /***/ },
            /***/ 371: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.parseInput = parseInput;
                var common_1 = __webpack_require__(799);
                var documentHandler_1 = __webpack_require__(643);
                var htmlParser_1 = __webpack_require__(660);
                var inputValidator_1 = __webpack_require__(344);
                var polyfills_1 = __webpack_require__(176);
                function parseInput(d, current) {
                    var doc = new documentHandler_1.DocHandler(d);
                    var document = doc.getDocumentOptions();
                    var global1 = doc.getGlobalOptions();
                    (0, inputValidator_1.validateInput)(global1, document, current);
                    var options = (0, polyfills_1.assign)({}, global1, document, current);
                    var win;
                    if (typeof window !== 'undefined') win = window;
                    var styles = parseStyles(global1, document, current);
                    var hooks = parseHooks(global1, document, current);
                    var settings = parseSettings(doc, options);
                    var content = parseContent(doc, options, win);
                    return {
                        id: current.tableId,
                        content: content,
                        hooks: hooks,
                        styles: styles,
                        settings: settings
                    };
                }
                function parseStyles(gInput, dInput, cInput) {
                    var styleOptions = {
                        styles: {},
                        headStyles: {},
                        bodyStyles: {},
                        footStyles: {},
                        alternateRowStyles: {},
                        columnStyles: {}
                    };
                    var _loop_1 = function(prop) {
                        if (prop === 'columnStyles') {
                            var global_1 = gInput[prop];
                            var document_1 = dInput[prop];
                            var current = cInput[prop];
                            styleOptions.columnStyles = (0, polyfills_1.assign)({}, global_1, document_1, current);
                        } else {
                            var allOptions = [
                                gInput,
                                dInput,
                                cInput
                            ];
                            var styles = allOptions.map(function(opts) {
                                return opts[prop] || {};
                            });
                            styleOptions[prop] = (0, polyfills_1.assign)({}, styles[0], styles[1], styles[2]);
                        }
                    };
                    for(var _i = 0, _a = Object.keys(styleOptions); _i < _a.length; _i++){
                        var prop = _a[_i];
                        _loop_1(prop);
                    }
                    return styleOptions;
                }
                function parseHooks(global1, document, current) {
                    var allOptions = [
                        global1,
                        document,
                        current
                    ];
                    var result = {
                        didParseCell: [],
                        willDrawCell: [],
                        didDrawCell: [],
                        willDrawPage: [],
                        didDrawPage: []
                    };
                    for(var _i = 0, allOptions_1 = allOptions; _i < allOptions_1.length; _i++){
                        var options = allOptions_1[_i];
                        if (options.didParseCell) result.didParseCell.push(options.didParseCell);
                        if (options.willDrawCell) result.willDrawCell.push(options.willDrawCell);
                        if (options.didDrawCell) result.didDrawCell.push(options.didDrawCell);
                        if (options.willDrawPage) result.willDrawPage.push(options.willDrawPage);
                        if (options.didDrawPage) result.didDrawPage.push(options.didDrawPage);
                    }
                    return result;
                }
                function parseSettings(doc, options) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                    var margin = (0, common_1.parseSpacing)(options.margin, 40 / doc.scaleFactor());
                    var startY = (_a = getStartY(doc, options.startY)) !== null && _a !== void 0 ? _a : margin.top;
                    var showFoot;
                    if (options.showFoot === true) showFoot = 'everyPage';
                    else if (options.showFoot === false) showFoot = 'never';
                    else showFoot = (_b = options.showFoot) !== null && _b !== void 0 ? _b : 'everyPage';
                    var showHead;
                    if (options.showHead === true) showHead = 'everyPage';
                    else if (options.showHead === false) showHead = 'never';
                    else showHead = (_c = options.showHead) !== null && _c !== void 0 ? _c : 'everyPage';
                    var useCss = (_d = options.useCss) !== null && _d !== void 0 ? _d : false;
                    var theme = options.theme || (useCss ? 'plain' : 'striped');
                    var horizontalPageBreak = !!options.horizontalPageBreak;
                    var horizontalPageBreakRepeat = (_e = options.horizontalPageBreakRepeat) !== null && _e !== void 0 ? _e : null;
                    return {
                        includeHiddenHtml: (_f = options.includeHiddenHtml) !== null && _f !== void 0 ? _f : false,
                        useCss: useCss,
                        theme: theme,
                        startY: startY,
                        margin: margin,
                        pageBreak: (_g = options.pageBreak) !== null && _g !== void 0 ? _g : 'auto',
                        rowPageBreak: (_h = options.rowPageBreak) !== null && _h !== void 0 ? _h : 'auto',
                        tableWidth: (_j = options.tableWidth) !== null && _j !== void 0 ? _j : 'auto',
                        showHead: showHead,
                        showFoot: showFoot,
                        tableLineWidth: (_k = options.tableLineWidth) !== null && _k !== void 0 ? _k : 0,
                        tableLineColor: (_l = options.tableLineColor) !== null && _l !== void 0 ? _l : 200,
                        horizontalPageBreak: horizontalPageBreak,
                        horizontalPageBreakRepeat: horizontalPageBreakRepeat,
                        horizontalPageBreakBehaviour: (_m = options.horizontalPageBreakBehaviour) !== null && _m !== void 0 ? _m : 'afterAllRows'
                    };
                }
                function getStartY(doc, userStartY) {
                    var previous = doc.getLastAutoTable();
                    var sf = doc.scaleFactor();
                    var currentPage = doc.pageNumber();
                    var isSamePageAsPreviousTable = false;
                    if (previous && previous.startPageNumber) {
                        var endingPage = previous.startPageNumber + previous.pageNumber - 1;
                        isSamePageAsPreviousTable = endingPage === currentPage;
                    }
                    if (typeof userStartY === 'number') return userStartY;
                    else if (userStartY == null || userStartY === false) {
                        if (isSamePageAsPreviousTable && (previous === null || previous === void 0 ? void 0 : previous.finalY) != null) // Some users had issues with overlapping tables when they used multiple
                        // tables without setting startY so setting it here to a sensible default.
                        return previous.finalY + 20 / sf;
                    }
                    return null;
                }
                function parseContent(doc, options, window1) {
                    var head = options.head || [];
                    var body = options.body || [];
                    var foot = options.foot || [];
                    if (options.html) {
                        var hidden = options.includeHiddenHtml;
                        if (window1) {
                            var htmlContent = (0, htmlParser_1.parseHtml)(doc, options.html, window1, hidden, options.useCss) || {};
                            head = htmlContent.head || head;
                            body = htmlContent.body || head;
                            foot = htmlContent.foot || head;
                        } else console.error('Cannot parse html in non browser environment');
                    }
                    var columns = options.columns || parseColumns(head, body, foot);
                    return {
                        columns: columns,
                        head: head,
                        body: body,
                        foot: foot
                    };
                }
                function parseColumns(head, body, foot) {
                    var firstRow = head[0] || body[0] || foot[0] || [];
                    var result = [];
                    Object.keys(firstRow).filter(function(key) {
                        return key !== '_element';
                    }).forEach(function(key) {
                        var colSpan = 1;
                        var input;
                        if (Array.isArray(firstRow)) input = firstRow[parseInt(key)];
                        else input = firstRow[key];
                        if (typeof input === 'object' && !Array.isArray(input)) colSpan = (input === null || input === void 0 ? void 0 : input.colSpan) || 1;
                        for(var i = 0; i < colSpan; i++){
                            var id = void 0;
                            if (Array.isArray(firstRow)) id = result.length;
                            else id = key + (i > 0 ? "_".concat(i) : '');
                            var rowResult = {
                                dataKey: id
                            };
                            result.push(rowResult);
                        }
                    });
                    return result;
                }
            /***/ },
            /***/ 376: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.createTable = createTable;
                var config_1 = __webpack_require__(28);
                var documentHandler_1 = __webpack_require__(643);
                var models_1 = __webpack_require__(524);
                var polyfills_1 = __webpack_require__(176);
                var widthCalculator_1 = __webpack_require__(152);
                function createTable(jsPDFDoc, input) {
                    var doc = new documentHandler_1.DocHandler(jsPDFDoc);
                    var content = parseContent(input, doc.scaleFactor());
                    var table = new models_1.Table(input, content);
                    (0, widthCalculator_1.calculateWidths)(doc, table);
                    doc.applyStyles(doc.userStyles);
                    return table;
                }
                function parseContent(input, sf) {
                    var content = input.content;
                    var columns = createColumns(content.columns);
                    // If no head or foot is set, try generating it with content from columns
                    if (content.head.length === 0) {
                        var sectionRow = generateSectionRow(columns, 'head');
                        if (sectionRow) content.head.push(sectionRow);
                    }
                    if (content.foot.length === 0) {
                        var sectionRow = generateSectionRow(columns, 'foot');
                        if (sectionRow) content.foot.push(sectionRow);
                    }
                    var theme = input.settings.theme;
                    var styles = input.styles;
                    return {
                        columns: columns,
                        head: parseSection('head', content.head, columns, styles, theme, sf),
                        body: parseSection('body', content.body, columns, styles, theme, sf),
                        foot: parseSection('foot', content.foot, columns, styles, theme, sf)
                    };
                }
                function parseSection(sectionName, sectionRows, columns, styleProps, theme, scaleFactor) {
                    var rowSpansLeftForColumn = {};
                    var result = sectionRows.map(function(rawRow, rowIndex) {
                        var skippedRowForRowSpans = 0;
                        var cells = {};
                        var colSpansAdded = 0;
                        var columnSpansLeft = 0;
                        for(var _i = 0, columns_1 = columns; _i < columns_1.length; _i++){
                            var column = columns_1[_i];
                            if (rowSpansLeftForColumn[column.index] == null || rowSpansLeftForColumn[column.index].left === 0) {
                                if (columnSpansLeft === 0) {
                                    var rawCell = void 0;
                                    if (Array.isArray(rawRow)) rawCell = rawRow[column.index - colSpansAdded - skippedRowForRowSpans];
                                    else rawCell = rawRow[column.dataKey];
                                    var cellInputStyles = {};
                                    if (typeof rawCell === 'object' && !Array.isArray(rawCell)) cellInputStyles = (rawCell === null || rawCell === void 0 ? void 0 : rawCell.styles) || {};
                                    var styles = cellStyles(sectionName, column, rowIndex, theme, styleProps, scaleFactor, cellInputStyles);
                                    var cell = new models_1.Cell(rawCell, styles, sectionName);
                                    // dataKey is not used internally no more but keep for
                                    // backwards compat in hooks
                                    cells[column.dataKey] = cell;
                                    cells[column.index] = cell;
                                    columnSpansLeft = cell.colSpan - 1;
                                    rowSpansLeftForColumn[column.index] = {
                                        left: cell.rowSpan - 1,
                                        times: columnSpansLeft
                                    };
                                } else {
                                    columnSpansLeft--;
                                    colSpansAdded++;
                                }
                            } else {
                                rowSpansLeftForColumn[column.index].left--;
                                columnSpansLeft = rowSpansLeftForColumn[column.index].times;
                                skippedRowForRowSpans++;
                            }
                        }
                        return new models_1.Row(rawRow, rowIndex, sectionName, cells);
                    });
                    return result;
                }
                function generateSectionRow(columns, section) {
                    var sectionRow = {};
                    columns.forEach(function(col) {
                        if (col.raw != null) {
                            var title = getSectionTitle(section, col.raw);
                            if (title != null) sectionRow[col.dataKey] = title;
                        }
                    });
                    return Object.keys(sectionRow).length > 0 ? sectionRow : null;
                }
                function getSectionTitle(section, column) {
                    if (section === 'head') {
                        if (typeof column === 'object') return column.header || null;
                        else if (typeof column === 'string' || typeof column === 'number') return column;
                    } else if (section === 'foot' && typeof column === 'object') return column.footer;
                    return null;
                }
                function createColumns(columns) {
                    return columns.map(function(input, index) {
                        var _a;
                        var key;
                        if (typeof input === 'object') key = (_a = input.dataKey) !== null && _a !== void 0 ? _a : index;
                        else key = index;
                        return new models_1.Column(key, input, index);
                    });
                }
                function cellStyles(sectionName, column, rowIndex, themeName, styles, scaleFactor, cellInputStyles) {
                    var theme = (0, config_1.getTheme)(themeName);
                    var sectionStyles;
                    if (sectionName === 'head') sectionStyles = styles.headStyles;
                    else if (sectionName === 'body') sectionStyles = styles.bodyStyles;
                    else if (sectionName === 'foot') sectionStyles = styles.footStyles;
                    var otherStyles = (0, polyfills_1.assign)({}, theme.table, theme[sectionName], styles.styles, sectionStyles);
                    var columnStyles = styles.columnStyles[column.dataKey] || styles.columnStyles[column.index] || {};
                    var colStyles = sectionName === 'body' ? columnStyles : {};
                    var rowStyles = sectionName === 'body' && rowIndex % 2 === 0 ? (0, polyfills_1.assign)({}, theme.alternateRow, styles.alternateRowStyles) : {};
                    var defaultStyle = (0, config_1.defaultStyles)(scaleFactor);
                    var themeStyles = (0, polyfills_1.assign)({}, defaultStyle, otherStyles, rowStyles, colStyles);
                    return (0, polyfills_1.assign)(themeStyles, cellInputStyles);
                }
            /***/ },
            /***/ 460: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.parseCss = parseCss;
                // Limitations
                // - No support for border spacing
                // - No support for transparency
                var common_1 = __webpack_require__(799);
                function parseCss(supportedFonts, element, scaleFactor, style, window1) {
                    var result = {};
                    var pxScaleFactor = 96 / 72;
                    var backgroundColor = parseColor(element, function(elem) {
                        return window1.getComputedStyle(elem)['backgroundColor'];
                    });
                    if (backgroundColor != null) result.fillColor = backgroundColor;
                    var textColor = parseColor(element, function(elem) {
                        return window1.getComputedStyle(elem)['color'];
                    });
                    if (textColor != null) result.textColor = textColor;
                    var padding = parsePadding(style, scaleFactor);
                    if (padding) result.cellPadding = padding;
                    var borderColorSide = 'borderTopColor';
                    var finalScaleFactor = pxScaleFactor * scaleFactor;
                    var btw = style.borderTopWidth;
                    if (style.borderBottomWidth === btw && style.borderRightWidth === btw && style.borderLeftWidth === btw) {
                        var borderWidth = (parseFloat(btw) || 0) / finalScaleFactor;
                        if (borderWidth) result.lineWidth = borderWidth;
                    } else {
                        result.lineWidth = {
                            top: (parseFloat(style.borderTopWidth) || 0) / finalScaleFactor,
                            right: (parseFloat(style.borderRightWidth) || 0) / finalScaleFactor,
                            bottom: (parseFloat(style.borderBottomWidth) || 0) / finalScaleFactor,
                            left: (parseFloat(style.borderLeftWidth) || 0) / finalScaleFactor
                        };
                        // Choose border color of first available side
                        // could be improved by supporting object as lineColor
                        if (!result.lineWidth.top) {
                            if (result.lineWidth.right) borderColorSide = 'borderRightColor';
                            else if (result.lineWidth.bottom) borderColorSide = 'borderBottomColor';
                            else if (result.lineWidth.left) borderColorSide = 'borderLeftColor';
                        }
                    }
                    var borderColor = parseColor(element, function(elem) {
                        return window1.getComputedStyle(elem)[borderColorSide];
                    });
                    if (borderColor != null) result.lineColor = borderColor;
                    var accepted = [
                        'left',
                        'right',
                        'center',
                        'justify'
                    ];
                    if (accepted.indexOf(style.textAlign) !== -1) result.halign = style.textAlign;
                    accepted = [
                        'middle',
                        'bottom',
                        'top'
                    ];
                    if (accepted.indexOf(style.verticalAlign) !== -1) result.valign = style.verticalAlign;
                    var res = parseInt(style.fontSize || '');
                    if (!isNaN(res)) result.fontSize = res / pxScaleFactor;
                    var fontStyle = parseFontStyle(style);
                    if (fontStyle) result.fontStyle = fontStyle;
                    var font = (style.fontFamily || '').toLowerCase();
                    if (supportedFonts.indexOf(font) !== -1) result.font = font;
                    return result;
                }
                function parseFontStyle(style) {
                    var res = '';
                    if (style.fontWeight === 'bold' || style.fontWeight === 'bolder' || parseInt(style.fontWeight) >= 700) res = 'bold';
                    if (style.fontStyle === 'italic' || style.fontStyle === 'oblique') res += 'italic';
                    return res;
                }
                function parseColor(element, styleGetter) {
                    var cssColor = realColor(element, styleGetter);
                    if (!cssColor) return null;
                    var rgba = cssColor.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d*\.?\d*))?\)$/);
                    if (!rgba || !Array.isArray(rgba)) return null;
                    var color = [
                        parseInt(rgba[1]),
                        parseInt(rgba[2]),
                        parseInt(rgba[3])
                    ];
                    var alpha = parseInt(rgba[4]);
                    if (alpha === 0 || isNaN(color[0]) || isNaN(color[1]) || isNaN(color[2])) return null;
                    return color;
                }
                function realColor(elem, styleGetter) {
                    var bg = styleGetter(elem);
                    if (bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent' || bg === 'initial' || bg === 'inherit') {
                        if (elem.parentElement == null) return null;
                        return realColor(elem.parentElement, styleGetter);
                    } else return bg;
                }
                function parsePadding(style, scaleFactor) {
                    var val = [
                        style.paddingTop,
                        style.paddingRight,
                        style.paddingBottom,
                        style.paddingLeft
                    ];
                    var pxScaleFactor = 96 / (72 / scaleFactor);
                    var linePadding = (parseInt(style.lineHeight) - parseInt(style.fontSize)) / scaleFactor / 2;
                    var inputPadding = val.map(function(n) {
                        return parseInt(n || '0') / pxScaleFactor;
                    });
                    var padding = (0, common_1.parseSpacing)(inputPadding, 0);
                    if (linePadding > padding.top) padding.top = linePadding;
                    if (linePadding > padding.bottom) padding.bottom = linePadding;
                    return padding;
                }
            /***/ },
            /***/ 524: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Column = exports.Cell = exports.Row = exports.Table = void 0;
                var common_1 = __webpack_require__(799);
                var config_1 = __webpack_require__(28);
                var HookData_1 = __webpack_require__(601);
                var Table = /** @class */ function() {
                    function Table(input, content) {
                        this.pageNumber = 1;
                        this.id = input.id;
                        this.settings = input.settings;
                        this.styles = input.styles;
                        this.hooks = input.hooks;
                        this.columns = content.columns;
                        this.head = content.head;
                        this.body = content.body;
                        this.foot = content.foot;
                    }
                    Table.prototype.getHeadHeight = function(columns) {
                        return this.head.reduce(function(acc, row) {
                            return acc + row.getMaxCellHeight(columns);
                        }, 0);
                    };
                    Table.prototype.getFootHeight = function(columns) {
                        return this.foot.reduce(function(acc, row) {
                            return acc + row.getMaxCellHeight(columns);
                        }, 0);
                    };
                    Table.prototype.allRows = function() {
                        return this.head.concat(this.body).concat(this.foot);
                    };
                    Table.prototype.callCellHooks = function(doc, handlers, cell, row, column, cursor) {
                        for(var _i = 0, handlers_1 = handlers; _i < handlers_1.length; _i++){
                            var handler = handlers_1[_i];
                            var data = new HookData_1.CellHookData(doc, this, cell, row, column, cursor);
                            var result = handler(data) === false;
                            // Make sure text is always string[] since user can assign string
                            cell.text = Array.isArray(cell.text) ? cell.text : [
                                cell.text
                            ];
                            if (result) return false;
                        }
                        return true;
                    };
                    Table.prototype.callEndPageHooks = function(doc, cursor) {
                        doc.applyStyles(doc.userStyles);
                        for(var _i = 0, _a = this.hooks.didDrawPage; _i < _a.length; _i++){
                            var handler = _a[_i];
                            handler(new HookData_1.HookData(doc, this, cursor));
                        }
                    };
                    Table.prototype.callWillDrawPageHooks = function(doc, cursor) {
                        for(var _i = 0, _a = this.hooks.willDrawPage; _i < _a.length; _i++){
                            var handler = _a[_i];
                            handler(new HookData_1.HookData(doc, this, cursor));
                        }
                    };
                    Table.prototype.getWidth = function(pageWidth) {
                        if (typeof this.settings.tableWidth === 'number') return this.settings.tableWidth;
                        else if (this.settings.tableWidth === 'wrap') {
                            var wrappedWidth = this.columns.reduce(function(total, col) {
                                return total + col.wrappedWidth;
                            }, 0);
                            return wrappedWidth;
                        } else {
                            var margin = this.settings.margin;
                            return pageWidth - margin.left - margin.right;
                        }
                    };
                    return Table;
                }();
                exports.Table = Table;
                var Row = /** @class */ function() {
                    function Row(raw, index, section, cells, spansMultiplePages) {
                        if (spansMultiplePages === void 0) spansMultiplePages = false;
                        this.height = 0;
                        this.raw = raw;
                        if (raw instanceof config_1.HtmlRowInput) {
                            this.raw = raw._element;
                            this.element = raw._element;
                        }
                        this.index = index;
                        this.section = section;
                        this.cells = cells;
                        this.spansMultiplePages = spansMultiplePages;
                    }
                    Row.prototype.getMaxCellHeight = function(columns) {
                        var _this = this;
                        return columns.reduce(function(acc, column) {
                            var _a;
                            return Math.max(acc, ((_a = _this.cells[column.index]) === null || _a === void 0 ? void 0 : _a.height) || 0);
                        }, 0);
                    };
                    Row.prototype.hasRowSpan = function(columns) {
                        var _this = this;
                        return columns.filter(function(column) {
                            var cell = _this.cells[column.index];
                            if (!cell) return false;
                            return cell.rowSpan > 1;
                        }).length > 0;
                    };
                    Row.prototype.canEntireRowFit = function(height, columns) {
                        return this.getMaxCellHeight(columns) <= height;
                    };
                    Row.prototype.getMinimumRowHeight = function(columns, doc) {
                        var _this = this;
                        return columns.reduce(function(acc, column) {
                            var cell = _this.cells[column.index];
                            if (!cell) return 0;
                            var lineHeight = doc.getLineHeight(cell.styles.fontSize);
                            var vPadding = cell.padding('vertical');
                            var oneRowHeight = vPadding + lineHeight;
                            return oneRowHeight > acc ? oneRowHeight : acc;
                        }, 0);
                    };
                    return Row;
                }();
                exports.Row = Row;
                var Cell = /** @class */ function() {
                    function Cell(raw, styles, section) {
                        var _a;
                        this.contentHeight = 0;
                        this.contentWidth = 0;
                        this.wrappedWidth = 0;
                        this.minReadableWidth = 0;
                        this.minWidth = 0;
                        this.width = 0;
                        this.height = 0;
                        this.x = 0;
                        this.y = 0;
                        this.styles = styles;
                        this.section = section;
                        this.raw = raw;
                        var content = raw;
                        if (raw != null && typeof raw === 'object' && !Array.isArray(raw)) {
                            this.rowSpan = raw.rowSpan || 1;
                            this.colSpan = raw.colSpan || 1;
                            content = (_a = raw.content) !== null && _a !== void 0 ? _a : raw;
                            if (raw._element) this.raw = raw._element;
                        } else {
                            this.rowSpan = 1;
                            this.colSpan = 1;
                        }
                        // Stringify 0 and false, but not undefined or null
                        var text = content != null ? '' + content : '';
                        var splitRegex = /\r\n|\r|\n/g;
                        this.text = text.split(splitRegex);
                    }
                    Cell.prototype.getTextPos = function() {
                        var y;
                        if (this.styles.valign === 'top') y = this.y + this.padding('top');
                        else if (this.styles.valign === 'bottom') y = this.y + this.height - this.padding('bottom');
                        else {
                            var netHeight = this.height - this.padding('vertical');
                            y = this.y + netHeight / 2 + this.padding('top');
                        }
                        var x;
                        if (this.styles.halign === 'right') x = this.x + this.width - this.padding('right');
                        else if (this.styles.halign === 'center') {
                            var netWidth = this.width - this.padding('horizontal');
                            x = this.x + netWidth / 2 + this.padding('left');
                        } else x = this.x + this.padding('left');
                        return {
                            x: x,
                            y: y
                        };
                    };
                    // TODO (v4): replace parameters with only (lineHeight)
                    Cell.prototype.getContentHeight = function(scaleFactor, lineHeightFactor) {
                        if (lineHeightFactor === void 0) lineHeightFactor = 1.15;
                        var lineCount = Array.isArray(this.text) ? this.text.length : 1;
                        var lineHeight = this.styles.fontSize / scaleFactor * lineHeightFactor;
                        var height = lineCount * lineHeight + this.padding('vertical');
                        return Math.max(height, this.styles.minCellHeight);
                    };
                    Cell.prototype.padding = function(name) {
                        var padding = (0, common_1.parseSpacing)(this.styles.cellPadding, 0);
                        if (name === 'vertical') return padding.top + padding.bottom;
                        else if (name === 'horizontal') return padding.left + padding.right;
                        else return padding[name];
                    };
                    return Cell;
                }();
                exports.Cell = Cell;
                var Column = /** @class */ function() {
                    function Column(dataKey, raw, index) {
                        this.wrappedWidth = 0;
                        this.minReadableWidth = 0;
                        this.minWidth = 0;
                        this.width = 0;
                        this.dataKey = dataKey;
                        this.raw = raw;
                        this.index = index;
                    }
                    Column.prototype.getMaxCustomCellWidth = function(table) {
                        var max = 0;
                        for(var _i = 0, _a = table.allRows(); _i < _a.length; _i++){
                            var row = _a[_i];
                            var cell = row.cells[this.index];
                            if (cell && typeof cell.styles.cellWidth === 'number') max = Math.max(max, cell.styles.cellWidth);
                        }
                        return max;
                    };
                    return Column;
                }();
                exports.Column = Column;
            /***/ },
            /***/ 601: /***/ function(__unused_webpack_module, exports) {
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CellHookData = exports.HookData = void 0;
                var HookData = /** @class */ function() {
                    function HookData(doc, table, cursor) {
                        this.table = table;
                        this.pageNumber = table.pageNumber;
                        this.settings = table.settings;
                        this.cursor = cursor;
                        this.doc = doc.getDocument();
                    }
                    return HookData;
                }();
                exports.HookData = HookData;
                var CellHookData = /** @class */ function(_super) {
                    __extends(CellHookData, _super);
                    function CellHookData(doc, table, cell, row, column, cursor) {
                        var _this = _super.call(this, doc, table, cursor) || this;
                        _this.cell = cell;
                        _this.row = row;
                        _this.column = column;
                        _this.section = row.section;
                        return _this;
                    }
                    return CellHookData;
                }(HookData);
                exports.CellHookData = CellHookData;
            /***/ },
            /***/ 626: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.calculateAllColumnsCanFitInPage = calculateAllColumnsCanFitInPage;
                var common_1 = __webpack_require__(799);
                // get columns can be fit into page
                function getColumnsCanFitInPage(doc, table, config) {
                    var _a;
                    if (config === void 0) config = {};
                    // Get page width
                    var remainingWidth = (0, common_1.getPageAvailableWidth)(doc, table);
                    // Get column data key to repeat
                    var repeatColumnsMap = new Map();
                    var colIndexes = [];
                    var columns = [];
                    var horizontalPageBreakRepeat = [];
                    if (Array.isArray(table.settings.horizontalPageBreakRepeat)) horizontalPageBreakRepeat = table.settings.horizontalPageBreakRepeat;
                    else if (typeof table.settings.horizontalPageBreakRepeat === 'string' || typeof table.settings.horizontalPageBreakRepeat === 'number') horizontalPageBreakRepeat = [
                        table.settings.horizontalPageBreakRepeat
                    ];
                    // Code to repeat the given column in split pages
                    horizontalPageBreakRepeat.forEach(function(field) {
                        var col = table.columns.find(function(item) {
                            return item.dataKey === field || item.index === field;
                        });
                        if (col && !repeatColumnsMap.has(col.index)) {
                            repeatColumnsMap.set(col.index, true);
                            colIndexes.push(col.index);
                            columns.push(table.columns[col.index]);
                            remainingWidth -= col.wrappedWidth;
                        }
                    });
                    var first = true;
                    var i = (_a = config === null || config === void 0 ? void 0 : config.start) !== null && _a !== void 0 ? _a : 0; // make sure couter is initiated outside the loop
                    while(i < table.columns.length){
                        // Prevent duplicates
                        if (repeatColumnsMap.has(i)) {
                            i++;
                            continue;
                        }
                        var colWidth = table.columns[i].wrappedWidth;
                        // Take at least one column even if it doesn't fit
                        if (first || remainingWidth >= colWidth) {
                            first = false;
                            colIndexes.push(i);
                            columns.push(table.columns[i]);
                            remainingWidth -= colWidth;
                        } else break;
                        i++;
                    }
                    return {
                        colIndexes: colIndexes,
                        columns: columns,
                        lastIndex: i - 1
                    };
                }
                function calculateAllColumnsCanFitInPage(doc, table) {
                    var allResults = [];
                    for(var i = 0; i < table.columns.length; i++){
                        var result = getColumnsCanFitInPage(doc, table, {
                            start: i
                        });
                        if (result.columns.length) {
                            allResults.push(result);
                            i = result.lastIndex;
                        }
                    }
                    return allResults;
                }
            /***/ },
            /***/ 639: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.applyPlugin = applyPlugin;
                var autoTableText_1 = __webpack_require__(150);
                var documentHandler_1 = __webpack_require__(643);
                var htmlParser_1 = __webpack_require__(660);
                var inputParser_1 = __webpack_require__(371);
                var tableCalculator_1 = __webpack_require__(376);
                var tableDrawer_1 = __webpack_require__(789);
                function applyPlugin(jsPDF) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    jsPDF.API.autoTable = function() {
                        var args = [];
                        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                        var options = args[0];
                        var input = (0, inputParser_1.parseInput)(this, options);
                        var table = (0, tableCalculator_1.createTable)(this, input);
                        (0, tableDrawer_1.drawTable)(this, table);
                        return this;
                    };
                    // Assign false to enable `doc.lastAutoTable.finalY || 40` sugar
                    jsPDF.API.lastAutoTable = false;
                    jsPDF.API.autoTableText = function(text, x, y, styles) {
                        (0, autoTableText_1.default)(text, x, y, styles, this);
                    };
                    jsPDF.API.autoTableSetDefaults = function(defaults) {
                        documentHandler_1.DocHandler.setDefaults(defaults, this);
                        return this;
                    };
                    jsPDF.autoTableSetDefaults = function(defaults, doc) {
                        documentHandler_1.DocHandler.setDefaults(defaults, doc);
                    };
                    jsPDF.API.autoTableHtmlToJson = function(tableElem, includeHiddenElements) {
                        var _a;
                        if (includeHiddenElements === void 0) includeHiddenElements = false;
                        if (typeof window === 'undefined') {
                            console.error('Cannot run autoTableHtmlToJson in non browser environment');
                            return null;
                        }
                        var doc = new documentHandler_1.DocHandler(this);
                        var _b = (0, htmlParser_1.parseHtml)(doc, tableElem, window, includeHiddenElements, false), head = _b.head, body = _b.body;
                        var columns = ((_a = head[0]) === null || _a === void 0 ? void 0 : _a.map(function(c) {
                            return c.content;
                        })) || [];
                        return {
                            columns: columns,
                            rows: body,
                            data: body
                        };
                    };
                }
            /***/ },
            /***/ 643: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DocHandler = void 0;
                var globalDefaults = {};
                var DocHandler = /** @class */ function() {
                    function DocHandler(jsPDFDocument) {
                        this.jsPDFDocument = jsPDFDocument;
                        this.userStyles = {
                            // Black for versions of jspdf without getTextColor
                            textColor: jsPDFDocument.getTextColor ? this.jsPDFDocument.getTextColor() : 0,
                            fontSize: jsPDFDocument.internal.getFontSize(),
                            fontStyle: jsPDFDocument.internal.getFont().fontStyle,
                            font: jsPDFDocument.internal.getFont().fontName,
                            // 0 for versions of jspdf without getLineWidth
                            lineWidth: jsPDFDocument.getLineWidth ? this.jsPDFDocument.getLineWidth() : 0,
                            // Black for versions of jspdf without getDrawColor
                            lineColor: jsPDFDocument.getDrawColor ? this.jsPDFDocument.getDrawColor() : 0
                        };
                    }
                    DocHandler.setDefaults = function(defaults, doc) {
                        if (doc === void 0) doc = null;
                        if (doc) doc.__autoTableDocumentDefaults = defaults;
                        else globalDefaults = defaults;
                    };
                    DocHandler.unifyColor = function(c) {
                        if (Array.isArray(c)) return c;
                        else if (typeof c === 'number') return [
                            c,
                            c,
                            c
                        ];
                        else if (typeof c === 'string') return [
                            c
                        ];
                        else return null;
                    };
                    DocHandler.prototype.applyStyles = function(styles, fontOnly) {
                        // Font style needs to be applied before font
                        // https://github.com/simonbengtsson/jsPDF-AutoTable/issues/632
                        var _a, _b, _c;
                        if (fontOnly === void 0) fontOnly = false;
                        if (styles.fontStyle && this.jsPDFDocument.setFontStyle) this.jsPDFDocument.setFontStyle(styles.fontStyle);
                        var _d = this.jsPDFDocument.internal.getFont(), fontStyle = _d.fontStyle, fontName = _d.fontName;
                        if (styles.font) fontName = styles.font;
                        if (styles.fontStyle) {
                            fontStyle = styles.fontStyle;
                            var availableFontStyles = this.getFontList()[fontName];
                            if (availableFontStyles && availableFontStyles.indexOf(fontStyle) === -1 && this.jsPDFDocument.setFontStyle) {
                                // Common issue was that the default bold in headers
                                // made custom fonts not work. For example:
                                // https://github.com/simonbengtsson/jsPDF-AutoTable/issues/653
                                this.jsPDFDocument.setFontStyle(availableFontStyles[0]);
                                fontStyle = availableFontStyles[0];
                            }
                        }
                        this.jsPDFDocument.setFont(fontName, fontStyle);
                        if (styles.fontSize) this.jsPDFDocument.setFontSize(styles.fontSize);
                        if (fontOnly) return; // Performance improvement
                        var color = DocHandler.unifyColor(styles.fillColor);
                        if (color) (_a = this.jsPDFDocument).setFillColor.apply(_a, color);
                        color = DocHandler.unifyColor(styles.textColor);
                        if (color) (_b = this.jsPDFDocument).setTextColor.apply(_b, color);
                        color = DocHandler.unifyColor(styles.lineColor);
                        if (color) (_c = this.jsPDFDocument).setDrawColor.apply(_c, color);
                        if (typeof styles.lineWidth === 'number') this.jsPDFDocument.setLineWidth(styles.lineWidth);
                    };
                    DocHandler.prototype.splitTextToSize = function(text, size, opts) {
                        return this.jsPDFDocument.splitTextToSize(text, size, opts);
                    };
                    /**
     * Adds a rectangle to the PDF
     * @param x Coordinate (in units declared at inception of PDF document) against left edge of the page
     * @param y Coordinate (in units declared at inception of PDF document) against upper edge of the page
     * @param width Width (in units declared at inception of PDF document)
     * @param height Height (in units declared at inception of PDF document)
     * @param fillStyle A string specifying the painting style or null. Valid styles include: 'S' [default] - stroke, 'F' - fill, and 'DF' (or 'FD') - fill then stroke.
     */ DocHandler.prototype.rect = function(x, y, width, height, fillStyle) {
                        // null is excluded from fillStyle possible values because it isn't needed
                        // and is prone to bugs as it's used to postpone setting the style
                        // https://rawgit.com/MrRio/jsPDF/master/docs/jsPDF.html#rect
                        return this.jsPDFDocument.rect(x, y, width, height, fillStyle);
                    };
                    DocHandler.prototype.getLastAutoTable = function() {
                        return this.jsPDFDocument.lastAutoTable || null;
                    };
                    DocHandler.prototype.getTextWidth = function(text) {
                        return this.jsPDFDocument.getTextWidth(text);
                    };
                    DocHandler.prototype.getDocument = function() {
                        return this.jsPDFDocument;
                    };
                    DocHandler.prototype.setPage = function(page) {
                        this.jsPDFDocument.setPage(page);
                    };
                    DocHandler.prototype.addPage = function() {
                        return this.jsPDFDocument.addPage();
                    };
                    DocHandler.prototype.getFontList = function() {
                        return this.jsPDFDocument.getFontList();
                    };
                    DocHandler.prototype.getGlobalOptions = function() {
                        return globalDefaults || {};
                    };
                    DocHandler.prototype.getDocumentOptions = function() {
                        return this.jsPDFDocument.__autoTableDocumentDefaults || {};
                    };
                    DocHandler.prototype.pageSize = function() {
                        var pageSize = this.jsPDFDocument.internal.pageSize;
                        // JSPDF 1.4 uses get functions instead of properties on pageSize
                        if (pageSize.width == null) pageSize = {
                            width: pageSize.getWidth(),
                            height: pageSize.getHeight()
                        };
                        return pageSize;
                    };
                    DocHandler.prototype.scaleFactor = function() {
                        return this.jsPDFDocument.internal.scaleFactor;
                    };
                    DocHandler.prototype.getLineHeightFactor = function() {
                        var doc = this.jsPDFDocument;
                        return doc.getLineHeightFactor ? doc.getLineHeightFactor() : 1.15;
                    };
                    DocHandler.prototype.getLineHeight = function(fontSize) {
                        return fontSize / this.scaleFactor() * this.getLineHeightFactor();
                    };
                    DocHandler.prototype.pageNumber = function() {
                        var pageInfo = this.jsPDFDocument.internal.getCurrentPageInfo();
                        if (!pageInfo) // Only recent versions of jspdf has pageInfo
                        return this.jsPDFDocument.internal.getNumberOfPages();
                        return pageInfo.pageNumber;
                    };
                    return DocHandler;
                }();
                exports.DocHandler = DocHandler;
            /***/ },
            /***/ 660: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.parseHtml = parseHtml;
                var config_1 = __webpack_require__(28);
                var cssParser_1 = __webpack_require__(460);
                function parseHtml(doc, input, window1, includeHiddenHtml, useCss) {
                    var _a, _b;
                    if (includeHiddenHtml === void 0) includeHiddenHtml = false;
                    if (useCss === void 0) useCss = false;
                    var tableElement;
                    if (typeof input === 'string') tableElement = window1.document.querySelector(input);
                    else tableElement = input;
                    var supportedFonts = Object.keys(doc.getFontList());
                    var scaleFactor = doc.scaleFactor();
                    var head = [], body = [], foot = [];
                    if (!tableElement) {
                        console.error('Html table could not be found with input: ', input);
                        return {
                            head: head,
                            body: body,
                            foot: foot
                        };
                    }
                    for(var i = 0; i < tableElement.rows.length; i++){
                        var element = tableElement.rows[i];
                        var tagName = (_b = (_a = element === null || element === void 0 ? void 0 : element.parentElement) === null || _a === void 0 ? void 0 : _a.tagName) === null || _b === void 0 ? void 0 : _b.toLowerCase();
                        var row = parseRowContent(supportedFonts, scaleFactor, window1, element, includeHiddenHtml, useCss);
                        if (!row) continue;
                        if (tagName === 'thead') head.push(row);
                        else if (tagName === 'tfoot') foot.push(row);
                        else // Add to body both if parent is tbody or table
                        body.push(row);
                    }
                    return {
                        head: head,
                        body: body,
                        foot: foot
                    };
                }
                function parseRowContent(supportedFonts, scaleFactor, window1, row, includeHidden, useCss) {
                    var resultRow = new config_1.HtmlRowInput(row);
                    for(var i = 0; i < row.cells.length; i++){
                        var cell = row.cells[i];
                        var style_1 = window1.getComputedStyle(cell);
                        if (includeHidden || style_1.display !== 'none') {
                            var cellStyles = void 0;
                            if (useCss) cellStyles = (0, cssParser_1.parseCss)(supportedFonts, cell, scaleFactor, style_1, window1);
                            resultRow.push({
                                rowSpan: cell.rowSpan,
                                colSpan: cell.colSpan,
                                styles: cellStyles,
                                _element: cell,
                                content: parseCellContent(cell)
                            });
                        }
                    }
                    var style = window1.getComputedStyle(row);
                    if (resultRow.length > 0 && (includeHidden || style.display !== 'none')) return resultRow;
                }
                function parseCellContent(orgCell) {
                    // Work on cloned node to make sure no changes are applied to html table
                    var cell = orgCell.cloneNode(true);
                    // Remove extra space and line breaks in markup to make it more similar to
                    // what would be shown in html
                    cell.innerHTML = cell.innerHTML.replace(/\n/g, '').replace(/ +/g, ' ');
                    // Preserve <br> tags as line breaks in the pdf
                    cell.innerHTML = cell.innerHTML.split(/<br.*?>/) //start with '<br' and ends with '>'.
                    .map(function(part) {
                        return part.trim();
                    }).join('\n');
                    // innerText for ie
                    return cell.innerText || cell.textContent || '';
                }
            /***/ },
            /***/ 789: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.drawTable = drawTable;
                exports.addPage = addPage;
                var autoTableText_1 = __webpack_require__(150);
                var common_1 = __webpack_require__(799);
                var documentHandler_1 = __webpack_require__(643);
                var models_1 = __webpack_require__(524);
                var polyfills_1 = __webpack_require__(176);
                var tablePrinter_1 = __webpack_require__(626);
                function drawTable(jsPDFDoc, table) {
                    var settings = table.settings;
                    var startY = settings.startY;
                    var margin = settings.margin;
                    var cursor = {
                        x: margin.left,
                        y: startY
                    };
                    var sectionsHeight = table.getHeadHeight(table.columns) + table.getFootHeight(table.columns);
                    var minTableBottomPos = startY + margin.bottom + sectionsHeight;
                    if (settings.pageBreak === 'avoid') {
                        var rows = table.body;
                        var tableHeight = rows.reduce(function(acc, row) {
                            return acc + row.height;
                        }, 0);
                        minTableBottomPos += tableHeight;
                    }
                    var doc = new documentHandler_1.DocHandler(jsPDFDoc);
                    if (settings.pageBreak === 'always' || settings.startY != null && minTableBottomPos > doc.pageSize().height) {
                        nextPage(doc);
                        cursor.y = margin.top;
                    }
                    table.callWillDrawPageHooks(doc, cursor);
                    var startPos = (0, polyfills_1.assign)({}, cursor);
                    table.startPageNumber = doc.pageNumber();
                    if (settings.horizontalPageBreak) // managed flow for split columns
                    printTableWithHorizontalPageBreak(doc, table, startPos, cursor);
                    else {
                        // normal flow
                        doc.applyStyles(doc.userStyles);
                        if (settings.showHead === 'firstPage' || settings.showHead === 'everyPage') table.head.forEach(function(row) {
                            return printRow(doc, table, row, cursor, table.columns);
                        });
                        doc.applyStyles(doc.userStyles);
                        table.body.forEach(function(row, index) {
                            var isLastRow = index === table.body.length - 1;
                            printFullRow(doc, table, row, isLastRow, startPos, cursor, table.columns);
                        });
                        doc.applyStyles(doc.userStyles);
                        if (settings.showFoot === 'lastPage' || settings.showFoot === 'everyPage') table.foot.forEach(function(row) {
                            return printRow(doc, table, row, cursor, table.columns);
                        });
                    }
                    (0, common_1.addTableBorder)(doc, table, startPos, cursor);
                    table.callEndPageHooks(doc, cursor);
                    table.finalY = cursor.y;
                    jsPDFDoc.lastAutoTable = table;
                    doc.applyStyles(doc.userStyles);
                }
                function printTableWithHorizontalPageBreak(doc, table, startPos, cursor) {
                    // calculate width of columns and render only those which can fit into page
                    var allColumnsCanFitResult = (0, tablePrinter_1.calculateAllColumnsCanFitInPage)(doc, table);
                    var settings = table.settings;
                    if (settings.horizontalPageBreakBehaviour === 'afterAllRows') allColumnsCanFitResult.forEach(function(colsAndIndexes, index) {
                        doc.applyStyles(doc.userStyles);
                        // add page to print next columns in new page
                        if (index > 0) // When adding a page here, make sure not to print the footers
                        // because they were already printed before on this same loop
                        addPage(doc, table, startPos, cursor, colsAndIndexes.columns, true);
                        else // print head for selected columns
                        printHead(doc, table, cursor, colsAndIndexes.columns);
                        // print body & footer for selected columns
                        printBody(doc, table, startPos, cursor, colsAndIndexes.columns);
                        printFoot(doc, table, cursor, colsAndIndexes.columns);
                    });
                    else {
                        var lastRowIndexOfLastPage_1 = -1;
                        var firstColumnsToFitResult = allColumnsCanFitResult[0];
                        var _loop_1 = function() {
                            // Print the first columns, taking note of the last row printed
                            var lastPrintedRowIndex = lastRowIndexOfLastPage_1;
                            if (firstColumnsToFitResult) {
                                doc.applyStyles(doc.userStyles);
                                var firstColumnsToFit = firstColumnsToFitResult.columns;
                                if (lastRowIndexOfLastPage_1 >= 0) // When adding a page here, make sure not to print the footers
                                // because they were already printed before on this same loop
                                addPage(doc, table, startPos, cursor, firstColumnsToFit, true);
                                else printHead(doc, table, cursor, firstColumnsToFit);
                                lastPrintedRowIndex = printBodyWithoutPageBreaks(doc, table, lastRowIndexOfLastPage_1 + 1, cursor, firstColumnsToFit);
                                printFoot(doc, table, cursor, firstColumnsToFit);
                            }
                            // Check how many rows were printed, so that the next columns would not print more rows than that
                            var maxNumberOfRows = lastPrintedRowIndex - lastRowIndexOfLastPage_1;
                            // Print the next columns, never exceding maxNumberOfRows
                            allColumnsCanFitResult.slice(1).forEach(function(colsAndIndexes) {
                                doc.applyStyles(doc.userStyles);
                                // When adding a page here, make sure not to print the footers
                                // because they were already printed before on this same loop
                                addPage(doc, table, startPos, cursor, colsAndIndexes.columns, true);
                                printBodyWithoutPageBreaks(doc, table, lastRowIndexOfLastPage_1 + 1, cursor, colsAndIndexes.columns, maxNumberOfRows);
                                printFoot(doc, table, cursor, colsAndIndexes.columns);
                            });
                            lastRowIndexOfLastPage_1 = lastPrintedRowIndex;
                        };
                        while(lastRowIndexOfLastPage_1 < table.body.length - 1)_loop_1();
                    }
                }
                function printHead(doc, table, cursor, columns) {
                    var settings = table.settings;
                    doc.applyStyles(doc.userStyles);
                    if (settings.showHead === 'firstPage' || settings.showHead === 'everyPage') table.head.forEach(function(row) {
                        return printRow(doc, table, row, cursor, columns);
                    });
                }
                function printBody(doc, table, startPos, cursor, columns) {
                    doc.applyStyles(doc.userStyles);
                    table.body.forEach(function(row, index) {
                        var isLastRow = index === table.body.length - 1;
                        printFullRow(doc, table, row, isLastRow, startPos, cursor, columns);
                    });
                }
                function printBodyWithoutPageBreaks(doc, table, startRowIndex, cursor, columns, maxNumberOfRows) {
                    doc.applyStyles(doc.userStyles);
                    maxNumberOfRows = maxNumberOfRows !== null && maxNumberOfRows !== void 0 ? maxNumberOfRows : table.body.length;
                    var endRowIndex = Math.min(startRowIndex + maxNumberOfRows, table.body.length);
                    var lastPrintedRowIndex = -1;
                    table.body.slice(startRowIndex, endRowIndex).forEach(function(row, index) {
                        var isLastRow = startRowIndex + index === table.body.length - 1;
                        var remainingSpace = getRemainingPageSpace(doc, table, isLastRow, cursor);
                        if (row.canEntireRowFit(remainingSpace, columns)) {
                            printRow(doc, table, row, cursor, columns);
                            lastPrintedRowIndex = startRowIndex + index;
                        }
                    });
                    return lastPrintedRowIndex;
                }
                function printFoot(doc, table, cursor, columns) {
                    var settings = table.settings;
                    doc.applyStyles(doc.userStyles);
                    if (settings.showFoot === 'lastPage' || settings.showFoot === 'everyPage') table.foot.forEach(function(row) {
                        return printRow(doc, table, row, cursor, columns);
                    });
                }
                function getRemainingLineCount(cell, remainingPageSpace, doc) {
                    var lineHeight = doc.getLineHeight(cell.styles.fontSize);
                    var vPadding = cell.padding('vertical');
                    var remainingLines = Math.floor((remainingPageSpace - vPadding) / lineHeight);
                    return Math.max(0, remainingLines);
                }
                function modifyRowToFit(row, remainingPageSpace, table, doc) {
                    var cells = {};
                    row.spansMultiplePages = true;
                    row.height = 0;
                    var rowHeight = 0;
                    for(var _i = 0, _a = table.columns; _i < _a.length; _i++){
                        var column = _a[_i];
                        var cell = row.cells[column.index];
                        if (!cell) continue;
                        if (!Array.isArray(cell.text)) cell.text = [
                            cell.text
                        ];
                        var remainderCell = new models_1.Cell(cell.raw, cell.styles, cell.section);
                        remainderCell = (0, polyfills_1.assign)(remainderCell, cell);
                        remainderCell.text = [];
                        var remainingLineCount = getRemainingLineCount(cell, remainingPageSpace, doc);
                        if (cell.text.length > remainingLineCount) remainderCell.text = cell.text.splice(remainingLineCount, cell.text.length);
                        var scaleFactor = doc.scaleFactor();
                        var lineHeightFactor = doc.getLineHeightFactor();
                        cell.contentHeight = cell.getContentHeight(scaleFactor, lineHeightFactor);
                        if (cell.contentHeight >= remainingPageSpace) {
                            cell.contentHeight = remainingPageSpace;
                            remainderCell.styles.minCellHeight -= remainingPageSpace;
                        }
                        if (cell.contentHeight > row.height) row.height = cell.contentHeight;
                        remainderCell.contentHeight = remainderCell.getContentHeight(scaleFactor, lineHeightFactor);
                        if (remainderCell.contentHeight > rowHeight) rowHeight = remainderCell.contentHeight;
                        cells[column.index] = remainderCell;
                    }
                    var remainderRow = new models_1.Row(row.raw, -1, row.section, cells, true);
                    remainderRow.height = rowHeight;
                    for(var _b = 0, _c = table.columns; _b < _c.length; _b++){
                        var column = _c[_b];
                        var remainderCell = remainderRow.cells[column.index];
                        if (remainderCell) remainderCell.height = remainderRow.height;
                        var cell = row.cells[column.index];
                        if (cell) cell.height = row.height;
                    }
                    return remainderRow;
                }
                function shouldPrintOnCurrentPage(doc, row, remainingPageSpace, table) {
                    var pageHeight = doc.pageSize().height;
                    var margin = table.settings.margin;
                    var marginHeight = margin.top + margin.bottom;
                    var maxRowHeight = pageHeight - marginHeight;
                    if (row.section === 'body') // Should also take into account that head and foot is not
                    // on every page with some settings
                    maxRowHeight -= table.getHeadHeight(table.columns) + table.getFootHeight(table.columns);
                    var minRowHeight = row.getMinimumRowHeight(table.columns, doc);
                    var minRowFits = minRowHeight < remainingPageSpace;
                    if (minRowHeight > maxRowHeight) {
                        console.log("Will not be able to print row ".concat(row.index, " correctly since it's minimum height is larger than page height"));
                        return true;
                    }
                    if (!minRowFits) return false;
                    var rowHasRowSpanCell = row.hasRowSpan(table.columns);
                    var rowHigherThanPage = row.getMaxCellHeight(table.columns) > maxRowHeight;
                    if (rowHigherThanPage) {
                        if (rowHasRowSpanCell) console.log("The content of row ".concat(row.index, " will not be drawn correctly since drawing rows with a height larger than the page height and has cells with rowspans is not supported."));
                        return true;
                    }
                    if (rowHasRowSpanCell) // Currently a new page is required whenever a rowspan row don't fit a page.
                    return false;
                    if (table.settings.rowPageBreak === 'avoid') return false;
                    // In all other cases print the row on current page
                    return true;
                }
                function printFullRow(doc, table, row, isLastRow, startPos, cursor, columns) {
                    var remainingSpace = getRemainingPageSpace(doc, table, isLastRow, cursor);
                    if (row.canEntireRowFit(remainingSpace, columns)) // The row fits in the current page
                    printRow(doc, table, row, cursor, columns);
                    else if (shouldPrintOnCurrentPage(doc, row, remainingSpace, table)) {
                        // The row gets split in two here, each piece in one page
                        var remainderRow = modifyRowToFit(row, remainingSpace, table, doc);
                        printRow(doc, table, row, cursor, columns);
                        addPage(doc, table, startPos, cursor, columns);
                        printFullRow(doc, table, remainderRow, isLastRow, startPos, cursor, columns);
                    } else {
                        // The row get printed entirelly on the next page
                        addPage(doc, table, startPos, cursor, columns);
                        printFullRow(doc, table, row, isLastRow, startPos, cursor, columns);
                    }
                }
                function printRow(doc, table, row, cursor, columns) {
                    cursor.x = table.settings.margin.left;
                    for(var _i = 0, columns_1 = columns; _i < columns_1.length; _i++){
                        var column = columns_1[_i];
                        var cell = row.cells[column.index];
                        if (!cell) {
                            cursor.x += column.width;
                            continue;
                        }
                        doc.applyStyles(cell.styles);
                        cell.x = cursor.x;
                        cell.y = cursor.y;
                        var result = table.callCellHooks(doc, table.hooks.willDrawCell, cell, row, column, cursor);
                        if (result === false) {
                            cursor.x += column.width;
                            continue;
                        }
                        drawCellRect(doc, cell, cursor);
                        var textPos = cell.getTextPos();
                        (0, autoTableText_1.default)(cell.text, textPos.x, textPos.y, {
                            halign: cell.styles.halign,
                            valign: cell.styles.valign,
                            maxWidth: Math.ceil(cell.width - cell.padding('left') - cell.padding('right'))
                        }, doc.getDocument());
                        table.callCellHooks(doc, table.hooks.didDrawCell, cell, row, column, cursor);
                        cursor.x += column.width;
                    }
                    cursor.y += row.height;
                }
                function drawCellRect(doc, cell, cursor) {
                    var cellStyles = cell.styles;
                    // https://github.com/simonbengtsson/jsPDF-AutoTable/issues/774
                    // TODO (v4): better solution?
                    doc.getDocument().setFillColor(doc.getDocument().getFillColor());
                    if (typeof cellStyles.lineWidth === 'number') {
                        // Draw cell background with normal borders
                        var fillStyle = (0, common_1.getFillStyle)(cellStyles.lineWidth, cellStyles.fillColor);
                        if (fillStyle) doc.rect(cell.x, cursor.y, cell.width, cell.height, fillStyle);
                    } else if (typeof cellStyles.lineWidth === 'object') {
                        // Draw cell background
                        if (cellStyles.fillColor) doc.rect(cell.x, cursor.y, cell.width, cell.height, 'F');
                        // Draw cell individual borders
                        drawCellBorders(doc, cell, cursor, cellStyles.lineWidth);
                    }
                }
                /**
 * Draw all specified borders. Borders are centered on cell's edge and lengthened
 * to overlap with neighbours to create sharp corners.
 * @param doc
 * @param cell
 * @param cursor
 * @param fillColor
 * @param lineWidth
 */ function drawCellBorders(doc, cell, cursor, lineWidth) {
                    var x1, y1, x2, y2;
                    if (lineWidth.top) {
                        x1 = cursor.x;
                        y1 = cursor.y;
                        x2 = cursor.x + cell.width;
                        y2 = cursor.y;
                        if (lineWidth.right) x2 += 0.5 * lineWidth.right;
                        if (lineWidth.left) x1 -= 0.5 * lineWidth.left;
                        drawLine(lineWidth.top, x1, y1, x2, y2);
                    }
                    if (lineWidth.bottom) {
                        x1 = cursor.x;
                        y1 = cursor.y + cell.height;
                        x2 = cursor.x + cell.width;
                        y2 = cursor.y + cell.height;
                        if (lineWidth.right) x2 += 0.5 * lineWidth.right;
                        if (lineWidth.left) x1 -= 0.5 * lineWidth.left;
                        drawLine(lineWidth.bottom, x1, y1, x2, y2);
                    }
                    if (lineWidth.left) {
                        x1 = cursor.x;
                        y1 = cursor.y;
                        x2 = cursor.x;
                        y2 = cursor.y + cell.height;
                        if (lineWidth.top) y1 -= 0.5 * lineWidth.top;
                        if (lineWidth.bottom) y2 += 0.5 * lineWidth.bottom;
                        drawLine(lineWidth.left, x1, y1, x2, y2);
                    }
                    if (lineWidth.right) {
                        x1 = cursor.x + cell.width;
                        y1 = cursor.y;
                        x2 = cursor.x + cell.width;
                        y2 = cursor.y + cell.height;
                        if (lineWidth.top) y1 -= 0.5 * lineWidth.top;
                        if (lineWidth.bottom) y2 += 0.5 * lineWidth.bottom;
                        drawLine(lineWidth.right, x1, y1, x2, y2);
                    }
                    function drawLine(width, x1, y1, x2, y2) {
                        doc.getDocument().setLineWidth(width);
                        doc.getDocument().line(x1, y1, x2, y2, 'S');
                    }
                }
                function getRemainingPageSpace(doc, table, isLastRow, cursor) {
                    var bottomContentHeight = table.settings.margin.bottom;
                    var showFoot = table.settings.showFoot;
                    if (showFoot === 'everyPage' || showFoot === 'lastPage' && isLastRow) bottomContentHeight += table.getFootHeight(table.columns);
                    return doc.pageSize().height - cursor.y - bottomContentHeight;
                }
                function addPage(doc, table, startPos, cursor, columns, suppressFooter) {
                    if (columns === void 0) columns = [];
                    if (suppressFooter === void 0) suppressFooter = false;
                    doc.applyStyles(doc.userStyles);
                    if (table.settings.showFoot === 'everyPage' && !suppressFooter) table.foot.forEach(function(row) {
                        return printRow(doc, table, row, cursor, columns);
                    });
                    // Add user content just before adding new page ensure it will
                    // be drawn above other things on the page
                    table.callEndPageHooks(doc, cursor);
                    var margin = table.settings.margin;
                    (0, common_1.addTableBorder)(doc, table, startPos, cursor);
                    nextPage(doc);
                    table.pageNumber++;
                    cursor.x = margin.left;
                    cursor.y = margin.top;
                    startPos.y = margin.top;
                    // call didAddPage hooks before any content is added to the page
                    table.callWillDrawPageHooks(doc, cursor);
                    if (table.settings.showHead === 'everyPage') {
                        table.head.forEach(function(row) {
                            return printRow(doc, table, row, cursor, columns);
                        });
                        doc.applyStyles(doc.userStyles);
                    }
                }
                function nextPage(doc) {
                    var current = doc.pageNumber();
                    doc.setPage(current + 1);
                    var newCurrent = doc.pageNumber();
                    if (newCurrent === current) {
                        doc.addPage();
                        return true;
                    }
                    return false;
                }
            /***/ },
            /***/ 799: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getStringWidth = getStringWidth;
                exports.addTableBorder = addTableBorder;
                exports.getFillStyle = getFillStyle;
                exports.parseSpacing = parseSpacing;
                exports.getPageAvailableWidth = getPageAvailableWidth;
                function getStringWidth(text, styles, doc) {
                    doc.applyStyles(styles, true);
                    var textArr = Array.isArray(text) ? text : [
                        text
                    ];
                    var widestLineWidth = textArr.map(function(text) {
                        return doc.getTextWidth(text);
                    }).reduce(function(a, b) {
                        return Math.max(a, b);
                    }, 0);
                    return widestLineWidth;
                }
                function addTableBorder(doc, table, startPos, cursor) {
                    var lineWidth = table.settings.tableLineWidth;
                    var lineColor = table.settings.tableLineColor;
                    doc.applyStyles({
                        lineWidth: lineWidth,
                        lineColor: lineColor
                    });
                    var fillStyle = getFillStyle(lineWidth, false);
                    if (fillStyle) doc.rect(startPos.x, startPos.y, table.getWidth(doc.pageSize().width), cursor.y - startPos.y, fillStyle);
                }
                function getFillStyle(lineWidth, fillColor) {
                    var drawLine = lineWidth > 0;
                    var drawBackground = fillColor || fillColor === 0;
                    if (drawLine && drawBackground) return 'DF'; // Fill then stroke
                    else if (drawLine) return 'S'; // Only stroke (transparent background)
                    else if (drawBackground) return 'F'; // Only fill, no stroke
                    else return null;
                }
                function parseSpacing(value, defaultValue) {
                    var _a, _b, _c, _d;
                    value = value || defaultValue;
                    if (Array.isArray(value)) {
                        if (value.length >= 4) return {
                            top: value[0],
                            right: value[1],
                            bottom: value[2],
                            left: value[3]
                        };
                        else if (value.length === 3) return {
                            top: value[0],
                            right: value[1],
                            bottom: value[2],
                            left: value[1]
                        };
                        else if (value.length === 2) return {
                            top: value[0],
                            right: value[1],
                            bottom: value[0],
                            left: value[1]
                        };
                        else if (value.length === 1) value = value[0];
                        else value = defaultValue;
                    }
                    if (typeof value === 'object') {
                        if (typeof value.vertical === 'number') {
                            value.top = value.vertical;
                            value.bottom = value.vertical;
                        }
                        if (typeof value.horizontal === 'number') {
                            value.right = value.horizontal;
                            value.left = value.horizontal;
                        }
                        return {
                            left: (_a = value.left) !== null && _a !== void 0 ? _a : defaultValue,
                            top: (_b = value.top) !== null && _b !== void 0 ? _b : defaultValue,
                            right: (_c = value.right) !== null && _c !== void 0 ? _c : defaultValue,
                            bottom: (_d = value.bottom) !== null && _d !== void 0 ? _d : defaultValue
                        };
                    }
                    if (typeof value !== 'number') value = defaultValue;
                    return {
                        top: value,
                        right: value,
                        bottom: value,
                        left: value
                    };
                }
                function getPageAvailableWidth(doc, table) {
                    var margins = parseSpacing(table.settings.margin, 0);
                    return doc.pageSize().width - (margins.left + margins.right);
                }
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry needs to be wrapped in an IIFE because it uses a non-standard name for the exports (exports).
        !function() {
            var exports = __webpack_exports__;
            var _a;
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.Table = exports.Row = exports.HookData = exports.Column = exports.CellHookData = exports.Cell = exports.applyPlugin = void 0;
            exports.autoTable = autoTable;
            exports.__createTable = __createTable;
            exports.__drawTable = __drawTable;
            var applyPlugin_1 = __webpack_require__(639);
            Object.defineProperty(exports, "applyPlugin", {
                enumerable: true,
                get: function() {
                    return applyPlugin_1.applyPlugin;
                }
            });
            var HookData_1 = __webpack_require__(601);
            Object.defineProperty(exports, "CellHookData", {
                enumerable: true,
                get: function() {
                    return HookData_1.CellHookData;
                }
            });
            Object.defineProperty(exports, "HookData", {
                enumerable: true,
                get: function() {
                    return HookData_1.HookData;
                }
            });
            var inputParser_1 = __webpack_require__(371);
            var models_1 = __webpack_require__(524);
            Object.defineProperty(exports, "Cell", {
                enumerable: true,
                get: function() {
                    return models_1.Cell;
                }
            });
            Object.defineProperty(exports, "Column", {
                enumerable: true,
                get: function() {
                    return models_1.Column;
                }
            });
            Object.defineProperty(exports, "Row", {
                enumerable: true,
                get: function() {
                    return models_1.Row;
                }
            });
            Object.defineProperty(exports, "Table", {
                enumerable: true,
                get: function() {
                    return models_1.Table;
                }
            });
            var tableCalculator_1 = __webpack_require__(376);
            var tableDrawer_1 = __webpack_require__(789);
            function autoTable(d, options) {
                var input = (0, inputParser_1.parseInput)(d, options);
                var table = (0, tableCalculator_1.createTable)(d, input);
                (0, tableDrawer_1.drawTable)(d, table);
            }
            // Experimental export
            function __createTable(d, options) {
                var input = (0, inputParser_1.parseInput)(d, options);
                return (0, tableCalculator_1.createTable)(d, input);
            }
            function __drawTable(d, table) {
                (0, tableDrawer_1.drawTable)(d, table);
            }
            try {
                if (typeof window !== 'undefined' && window) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var anyWindow = window;
                    var jsPDF = anyWindow.jsPDF || ((_a = anyWindow.jspdf) === null || _a === void 0 ? void 0 : _a.jsPDF);
                    if (jsPDF) (0, applyPlugin_1.applyPlugin)(jsPDF);
                }
            } catch (error) {
                console.error('Could not apply autoTable plugin', error);
            }
            exports["default"] = autoTable;
        }();
        /******/ return __webpack_exports__;
    /******/ }();
});


function $dd3e440038a44b6c$var$fmtInr(n) {
    if (!Number.isFinite(n)) return "0.00";
    return n.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
function $dd3e440038a44b6c$var$hexToRgb(hex) {
    const t = hex.trim().replace(/^#/, "");
    if (t.length !== 6) return [
        22,
        54,
        95
    ];
    return [
        parseInt(t.slice(0, 2), 16),
        parseInt(t.slice(2, 4), 16),
        parseInt(t.slice(4, 6), 16)
    ];
}
function $dd3e440038a44b6c$export$7c06f8768778302d(pdf, input, opts) {
    if (!input.allocations.length) return;
    const accent = $dd3e440038a44b6c$var$hexToRgb(input.accentColorHex);
    const doc = pdf;
    if (opts?.addLandscapePage !== false) pdf.addPage("a4", "l");
    const landW = pdf.internal.pageSize.getWidth();
    const marginL = 12;
    const marginR = 12;
    let y = 14;
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(13);
    pdf.setTextColor(accent[0], accent[1], accent[2]);
    pdf.text("ANNEXURE: BENEFICIARY ALLOCATION", marginL, y);
    y += 8;
    const usableW = landW - marginL - marginR;
    const body = [];
    let groupNo = 1;
    for (const alloc of input.allocations){
        const n = alloc.items.length;
        if (n === 0) continue;
        for(let i = 0; i < n; i++){
            const item = alloc.items[i];
            if (i === 0) body.push([
                {
                    content: String(groupNo),
                    rowSpan: n,
                    styles: {
                        valign: "middle",
                        halign: "center",
                        fontStyle: "bold",
                        fontSize: 8
                    }
                },
                {
                    content: alloc.beneficiaryName,
                    rowSpan: n,
                    styles: {
                        valign: "middle",
                        fontStyle: "bold",
                        fontSize: 7.5
                    }
                },
                {
                    content: alloc.applicationId,
                    rowSpan: n,
                    styles: {
                        valign: "middle",
                        fontStyle: "normal",
                        fontSize: 7
                    }
                },
                {
                    content: alloc.district,
                    rowSpan: n,
                    styles: {
                        valign: "middle",
                        fontSize: 7
                    }
                },
                {
                    content: alloc.mandal,
                    rowSpan: n,
                    styles: {
                        valign: "middle",
                        fontSize: 7
                    }
                },
                {
                    content: alloc.village,
                    rowSpan: n,
                    styles: {
                        valign: "middle",
                        fontSize: 7
                    }
                },
                item.label,
                `${$dd3e440038a44b6c$var$fmtInr(item.qty)} ${item.unit}`
            ]);
            else body.push([
                item.label,
                `${$dd3e440038a44b6c$var$fmtInr(item.qty)} ${item.unit}`
            ]);
        }
        groupNo += 1;
    }
    const colSno = 9;
    const colBen = 34;
    const colApp = 30;
    const colDist = 22;
    const colMandal = 22;
    const colVillage = 22;
    const colQty = 24;
    const colMat = Math.max(36, usableW - colSno - colBen - colApp - colDist - colMandal - colVillage - colQty);
    (0, (/*@__PURE__*/$parcel$interopDefault($30f18b46c5972596$exports)))(pdf, {
        startY: y,
        margin: {
            left: marginL,
            right: marginR
        },
        head: [
            [
                "S.NO",
                "BENEFICIARY NAME",
                "APPLICATION ID",
                "DISTRICT",
                "MANDAL",
                "VILLAGE",
                "MATERIAL",
                "ALLOCATED QTY"
            ]
        ],
        body: body,
        styles: {
            fontSize: 7.5,
            cellPadding: 2,
            lineColor: [
                226,
                232,
                240
            ],
            lineWidth: 0.15,
            valign: "top",
            overflow: "linebreak"
        },
        headStyles: {
            fillColor: accent,
            textColor: [
                255,
                255,
                255
            ],
            fontStyle: "bold",
            fontSize: 6.8,
            cellPadding: 2.5,
            valign: "middle"
        },
        columnStyles: {
            0: {
                cellWidth: colSno,
                halign: "center"
            },
            1: {
                cellWidth: colBen
            },
            2: {
                cellWidth: colApp,
                fontStyle: "normal"
            },
            3: {
                cellWidth: colDist
            },
            4: {
                cellWidth: colMandal
            },
            5: {
                cellWidth: colVillage
            },
            6: {
                cellWidth: colMat
            },
            7: {
                cellWidth: colQty,
                halign: "right"
            }
        },
        theme: "grid",
        tableWidth: usableW
    });
    y = doc.lastAutoTable?.finalY ?? y + 20;
    y += 4;
    const foot = input.footerNote?.trim() || "Generated from the HO console.";
    pdf.setFont("helvetica", "italic");
    pdf.setFontSize(7);
    pdf.setTextColor(100, 116, 139);
    pdf.text(foot.length > 220 ? `${foot.slice(0, 217)}\u{2026}` : foot, marginL, y);
}
function $dd3e440038a44b6c$export$2a5cb6d36bde4eed(input) {
    if (!input.allocations.length) throw new Error("No annexure rows to export.");
    const pdf = new (0, $dbd37edd557d3750$export$2e2bcd8739ae039)({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
        compress: true
    });
    $dd3e440038a44b6c$export$7c06f8768778302d(pdf, input, {
        addLandscapePage: false
    });
    const out = pdf.output("blob");
    if (!(out instanceof Blob)) throw new Error("Annexure PDF export failed.");
    return out;
}




/** After a 503, skip further server PDF attempts this session (production Chromium often stays down). */ let $be86ff96cdd54f4b$var$serverPdfUnavailable = false;
function $be86ff96cdd54f4b$export$228c570eb00ce0c0() {
    return $be86ff96cdd54f4b$var$serverPdfUnavailable;
}
async function $be86ff96cdd54f4b$export$22dba33e1dcfec62(html, landscape) {
    if ($be86ff96cdd54f4b$var$serverPdfUnavailable) return null;
    try {
        const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/console/render-html-pdf`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                html: html,
                landscape: landscape
            })
        });
        if (res.status === 503) {
            $be86ff96cdd54f4b$var$serverPdfUnavailable = true;
            return null;
        }
        if (!res.ok) {
            const ct = res.headers.get("content-type") ?? "";
            let msg = res.statusText;
            if (ct.includes("application/json")) {
                const j = await res.json().catch(()=>null);
                if (j?.error) msg = j.error;
            } else {
                const t = await res.text();
                if (t) msg = t.slice(0, 500);
            }
            throw new Error(msg);
        }
        return await res.blob();
    } catch (e) {
        console.warn("[fetchServerHtmlPdfBlob]", e);
        return null;
    }
}


/**
 * Browser PDF capture (html2canvas). Higher scale = sharper text; capped to avoid mobile OOM.
 * Server PDF (Chromium) is preferred when available — vector-sharp without this raster step.
 */ function $b2a79528db62cd8d$var$pdfCanvasScale() {
    if (typeof window === "undefined") return 1.5;
    return Math.min(2, Math.max(1.5, window.devicePixelRatio || 1.5));
}
const $b2a79528db62cd8d$var$IMAGE_WAIT_MS = 800;
const $b2a79528db62cd8d$var$PDF_LAYOUT_TIMEOUT_MS = 45000;
const $b2a79528db62cd8d$var$LOGO_MAX_WIDTH_PX = 300;
const $b2a79528db62cd8d$var$imageDataUrlCache = new Map();
function $b2a79528db62cd8d$var$baseFilename(name) {
    return name.replace(/\.pdf$/i, "").trim() || "document";
}
function $b2a79528db62cd8d$var$blobToDataUrl(blob) {
    return new Promise((resolve, reject)=>{
        const r = new FileReader();
        r.onload = ()=>resolve(String(r.result));
        r.onerror = ()=>reject(r.error ?? new Error("read failed"));
        r.readAsDataURL(blob);
    });
}
async function $b2a79528db62cd8d$var$imageBlobToDataUrl(blob) {
    if (!blob.type.startsWith("image/")) return $b2a79528db62cd8d$var$blobToDataUrl(blob);
    try {
        const bitmap = await createImageBitmap(blob);
        const scale = Math.min(1, $b2a79528db62cd8d$var$LOGO_MAX_WIDTH_PX / bitmap.width);
        const w = Math.max(1, Math.round(bitmap.width * scale));
        const h = Math.max(1, Math.round(bitmap.height * scale));
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        if (!ctx) {
            bitmap.close();
            return $b2a79528db62cd8d$var$blobToDataUrl(blob);
        }
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, w, h);
        ctx.drawImage(bitmap, 0, 0, w, h);
        bitmap.close();
        return canvas.toDataURL("image/jpeg", 0.88);
    } catch  {
        return $b2a79528db62cd8d$var$blobToDataUrl(blob);
    }
}
async function $b2a79528db62cd8d$export$e6898c6b9b3f226e(urls) {
    const origin = window.location.origin;
    await Promise.all(urls.map(async (raw)=>{
        const t = raw.trim();
        if (!t || t.startsWith("data:")) return;
        try {
            const u = new URL(t, origin);
            if (u.origin !== origin || $b2a79528db62cd8d$var$imageDataUrlCache.has(u.toString())) return;
            const res = await fetch(u.toString(), {
                credentials: "same-origin",
                cache: "force-cache"
            });
            if (!res.ok) return;
            const blob = await res.blob();
            $b2a79528db62cd8d$var$imageDataUrlCache.set(u.toString(), await $b2a79528db62cd8d$var$imageBlobToDataUrl(blob));
        } catch  {
        /* ignore */ }
    }));
}
async function $b2a79528db62cd8d$var$inlineSameOriginImages(doc) {
    const origin = window.location.origin;
    const imgs = Array.from(doc.querySelectorAll("img[src]"));
    await Promise.all(imgs.map(async (img)=>{
        const raw = (img.getAttribute("src") ?? "").trim();
        if (!raw || raw.startsWith("data:")) return;
        let fetchUrl;
        try {
            const u = new URL(raw, origin);
            if (u.origin !== origin) return;
            fetchUrl = u.toString();
        } catch  {
            return;
        }
        const cached = $b2a79528db62cd8d$var$imageDataUrlCache.get(fetchUrl);
        if (cached) {
            img.src = cached;
            return;
        }
        try {
            const res = await fetch(fetchUrl, {
                credentials: "same-origin",
                cache: "force-cache"
            });
            if (!res.ok) return;
            const blob = await res.blob();
            const dataUrl = await $b2a79528db62cd8d$var$imageBlobToDataUrl(blob);
            $b2a79528db62cd8d$var$imageDataUrlCache.set(fetchUrl, dataUrl);
            img.src = dataUrl;
        } catch  {
        /* leave original src */ }
    }));
}
function $b2a79528db62cd8d$var$waitForImages(doc, timeoutMs) {
    const imgs = Array.from(doc.images);
    if (imgs.length === 0) return Promise.resolve();
    return Promise.all(imgs.map((img)=>img.complete && img.naturalHeight > 0 ? Promise.resolve() : new Promise((resolve)=>{
            const timer = window.setTimeout(resolve, timeoutMs);
            const done = ()=>{
                window.clearTimeout(timer);
                resolve();
            };
            img.addEventListener("load", done, {
                once: true
            });
            img.addEventListener("error", done, {
                once: true
            });
        }))).then(()=>undefined);
}
async function $b2a79528db62cd8d$var$renderHtmlToCanvas(html, frame) {
    const iframe = document.createElement("iframe");
    iframe.setAttribute("aria-hidden", "true");
    iframe.title = "pdf-render";
    iframe.style.cssText = `position:fixed;top:0;left:-9999px;width:${frame.iframeWidth};min-height:${frame.iframeMinHeight};border:0;visibility:hidden;`;
    document.body.appendChild(iframe);
    try {
        const idoc = iframe.contentDocument;
        const win = iframe.contentWindow;
        if (!idoc || !win) throw new Error("Could not prepare PDF renderer.");
        idoc.open();
        idoc.write(html);
        idoc.close();
        await new Promise((resolve, reject)=>{
            if (idoc.readyState === "complete") {
                resolve();
                return;
            }
            const timer = window.setTimeout(()=>reject(new Error("PDF layout timed out \u2014 the document may be too large for this device.")), $b2a79528db62cd8d$var$PDF_LAYOUT_TIMEOUT_MS);
            win.onload = ()=>{
                window.clearTimeout(timer);
                resolve();
            };
        });
        await $b2a79528db62cd8d$var$inlineSameOriginImages(idoc);
        await $b2a79528db62cd8d$var$waitForImages(idoc, $b2a79528db62cd8d$var$IMAGE_WAIT_MS);
        for (const img of Array.from(idoc.images))if (!img.naturalWidth || !img.naturalHeight) img.remove();
        await new Promise((r)=>requestAnimationFrame(()=>requestAnimationFrame(()=>r())));
        const body = idoc.body;
        try {
            return await (0, (/*@__PURE__*/$parcel$interopDefault($49yFe)))(body, {
                scale: $b2a79528db62cd8d$var$pdfCanvasScale(),
                useCORS: true,
                logging: false,
                backgroundColor: "#ffffff",
                imageTimeout: $b2a79528db62cd8d$var$IMAGE_WAIT_MS,
                windowWidth: body.scrollWidth,
                windowHeight: body.scrollHeight,
                removeContainer: true
            });
        } catch (e) {
            const detail = e instanceof Error ? e.message : String(e);
            throw new Error(`Browser PDF capture failed (${detail}).`);
        }
    } finally{
        iframe.remove();
    }
}
function $b2a79528db62cd8d$var$appendCanvasToPdf(pdf, canvas, orientation, isFirstPage) {
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;
    const scale = pdfWidth / canvasWidth;
    const pageHeightPx = Math.floor(pdfHeight / scale);
    const PAGE_MARGIN_TOP = 10;
    const PAGE_MARGIN_BOTTOM = 8;
    const PAGE_MARGIN_LEFT = 8;
    const PAGE_MARGIN_RIGHT = 8;
    const usablePagePx = Math.floor((pdfHeight - PAGE_MARGIN_TOP - PAGE_MARGIN_BOTTOM) / scale);
    const usableWidthMm = pdfWidth - PAGE_MARGIN_LEFT - PAGE_MARGIN_RIGHT;
    let srcY = 0;
    let first = isFirstPage;
    while(srcY < canvasHeight){
        const remaining = canvasHeight - srcY;
        const maxSlicePx = first ? pageHeightPx : usablePagePx;
        const sliceHeight = remaining <= maxSlicePx ? remaining : maxSlicePx;
        const pageCanvas = document.createElement("canvas");
        pageCanvas.width = canvasWidth;
        pageCanvas.height = sliceHeight;
        const pctx = pageCanvas.getContext("2d");
        pctx.fillStyle = "#ffffff";
        pctx.fillRect(0, 0, canvasWidth, sliceHeight);
        pctx.drawImage(canvas, 0, srcY, canvasWidth, sliceHeight, 0, 0, canvasWidth, sliceHeight);
        const pageImg = pageCanvas.toDataURL("image/png");
        const sliceMmH = usableWidthMm * (sliceHeight / canvasWidth);
        if (!first) pdf.addPage("a4", orientation === "landscape" ? "l" : "p");
        pdf.addImage(pageImg, "PNG", PAGE_MARGIN_LEFT, PAGE_MARGIN_TOP, usableWidthMm, sliceMmH);
        srcY += sliceHeight;
        first = false;
    }
}
async function $b2a79528db62cd8d$var$mergeSequentialPdfBlobs(parts) {
    const merged = await (0, $6767bf97ac5b9b71$export$2e2bcd8739ae039).create();
    for (const part of parts){
        const doc = await (0, $6767bf97ac5b9b71$export$2e2bcd8739ae039).load(await part.arrayBuffer());
        const pages = await merged.copyPages(doc, doc.getPageIndices());
        pages.forEach((p)=>merged.addPage(p));
    }
    const bytes = await merged.save();
    return new Blob([
        new Uint8Array(bytes)
    ], {
        type: "application/pdf"
    });
}
async function $b2a79528db62cd8d$export$fa7100892ae9c05f(html, options) {
    const vec = options?.annexure;
    const useVectorAnnexure = Boolean(vec?.allocations?.length);
    const annexureHtml = options?.annexureHtml?.trim();
    const serverPortrait = await (0, $be86ff96cdd54f4b$export$22dba33e1dcfec62)(html, false);
    if (serverPortrait) try {
        if (useVectorAnnexure && vec) return await $b2a79528db62cd8d$var$mergeSequentialPdfBlobs([
            serverPortrait,
            (0, $dd3e440038a44b6c$export$2a5cb6d36bde4eed)(vec)
        ]);
        if (annexureHtml) {
            const serverAnnex = await (0, $be86ff96cdd54f4b$export$22dba33e1dcfec62)(annexureHtml, true);
            if (serverAnnex) return await $b2a79528db62cd8d$var$mergeSequentialPdfBlobs([
                serverPortrait,
                serverAnnex
            ]);
        } else return serverPortrait;
    } catch (e) {
        console.warn("[htmlDocumentToPdfBlob] server PDF failed, falling back to client capture:", e);
    }
    const portraitFrame = {
        iframeWidth: "816px",
        iframeMinHeight: "1100px"
    };
    const annexFrame = {
        iframeWidth: "1100px",
        iframeMinHeight: "794px"
    };
    try {
        const portraitCanvas = await $b2a79528db62cd8d$var$renderHtmlToCanvas(html, portraitFrame);
        const pdf = new (0, $dbd37edd557d3750$export$2e2bcd8739ae039)({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
            compress: true
        });
        $b2a79528db62cd8d$var$appendCanvasToPdf(pdf, portraitCanvas, "portrait", true);
        if (useVectorAnnexure && vec) (0, $dd3e440038a44b6c$export$7c06f8768778302d)(pdf, vec);
        else if (annexureHtml) {
            const landscapeCanvas = await $b2a79528db62cd8d$var$renderHtmlToCanvas(annexureHtml, annexFrame);
            $b2a79528db62cd8d$var$appendCanvasToPdf(pdf, landscapeCanvas, "landscape", false);
        }
        const out = pdf.output("blob");
        if (!(out instanceof Blob)) throw new Error("PDF export did not produce a file.");
        return out;
    } catch (e) {
        const base = e instanceof Error ? e.message : "PDF export failed.";
        const serverHint = (0, $be86ff96cdd54f4b$export$228c570eb00ce0c0)() ? " Server PDF (Chromium) is not available on the API host." : "";
        throw new Error(`${base}${serverHint} Try a desktop browser, reduce PO size, or ask your admin to enable server PDF on the API server.`);
    }
}
function $b2a79528db62cd8d$export$e56d0156e744a34e(blob, filename) {
    const url = URL.createObjectURL(blob);
    try {
        const a = document.createElement("a");
        a.href = url;
        a.download = `${$b2a79528db62cd8d$var$baseFilename(filename)}.pdf`;
        a.rel = "noopener";
        document.body.appendChild(a);
        a.click();
        a.remove();
    } finally{
        URL.revokeObjectURL(url);
    }
}
async function $b2a79528db62cd8d$export$768a1993afbfc55d(html, filename, options) {
    const blob = await $b2a79528db62cd8d$export$fa7100892ae9c05f(html, options);
    $b2a79528db62cd8d$export$e56d0156e744a34e(blob, filename);
}




function $ac21b9a9c4b3a809$export$236d41f0e28fa8fa(apps) {
    const map = new Map();
    for (const a of apps){
        const key = (0, $72c1e8625e9e63b5$export$768d2fc1615cd5ac)(a.district);
        const districtLabel = key ? (0, $72c1e8625e9e63b5$export$5e94242fadb30a0e)(key) : String(a.district ?? "").trim();
        map.set(a.id, {
            displayApplicationId: a.mobile.applicationId?.trim() || a.id,
            district: (0, $458840b99c021cb6$export$bb1029bec19025fd)(districtLabel) || "\u2014",
            mandal: (0, $458840b99c021cb6$export$bb1029bec19025fd)(a.mandal) || "\u2014",
            village: (0, $458840b99c021cb6$export$bb1029bec19025fd)(a.village) || "\u2014"
        });
    }
    return map;
}


/** Browser-local saved PO letterhead / GST defaults (per workstation). */ 
const $b75ffaa91259d13d$export$89c97ef157523537 = "indiramma.poFormat.v1";
function $b75ffaa91259d13d$var$clampLogoHeight(n) {
    if (!Number.isFinite(n)) return 56;
    return Math.min(160, Math.max(28, Math.round(n)));
}
function $b75ffaa91259d13d$var$sanitizeAccentHex(hex) {
    const t = hex.trim();
    if (/^#[0-9A-Fa-f]{6}$/.test(t)) return t;
    return "#16365f";
}
function $b75ffaa91259d13d$export$c374e061124b6d30() {
    return {
        version: 1,
        documentTitle: "PURCHASE ORDER",
        letterheadTagline: "",
        logoPrimaryUrl: "",
        logoSecondaryUrl: "",
        logoPrimaryHeightPx: 56,
        logoSecondaryHeightPx: 68,
        accentColorHex: "#16365f",
        footerNote: "",
        buyerName: "",
        buyerAddress: "",
        buyerGstin: "",
        defaultVendorName: "",
        defaultVendorAddress: "",
        defaultVendorGstin: "",
        paymentTerms: "As per agreement. Retention and statutory deductions as applicable.",
        defaultShipTo: "",
        aggregateQtyDefault: true,
        gstRows: [
            {
                label: "CGST",
                ratePercent: 9
            },
            {
                label: "SGST",
                ratePercent: 9
            }
        ]
    };
}
function $b75ffaa91259d13d$var$clampGstRows(rows) {
    const fallback = $b75ffaa91259d13d$export$c374e061124b6d30().gstRows;
    if (!Array.isArray(rows)) return fallback;
    const out = [];
    for (const r of rows){
        if (!r || typeof r !== "object") continue;
        const o = r;
        const label = typeof o.label === "string" ? o.label.trim().slice(0, 64) : "Tax";
        const rp = Number(o.ratePercent);
        out.push({
            label: label || "Tax",
            ratePercent: Number.isFinite(rp) ? Math.min(100, Math.max(0, rp)) : 0
        });
    }
    return out.length ? out : fallback;
}
function $b75ffaa91259d13d$export$87070318200d7b82(raw) {
    const d = $b75ffaa91259d13d$export$c374e061124b6d30();
    if (!raw || typeof raw !== "object") return d;
    const o = raw;
    const doc = typeof o.documentTitle === "string" && o.documentTitle.trim() ? o.documentTitle.trim().slice(0, 120) : d.documentTitle;
    const foot = typeof o.footerNote === "string" ? o.footerNote.slice(0, 2000) : d.footerNote;
    const tag = typeof o.letterheadTagline === "string" ? o.letterheadTagline.slice(0, 240) : d.letterheadTagline;
    const lp = typeof o.logoPrimaryUrl === "string" ? o.logoPrimaryUrl.trim().slice(0, 5000000) : d.logoPrimaryUrl;
    const ls = typeof o.logoSecondaryUrl === "string" ? o.logoSecondaryUrl.trim().slice(0, 5000000) : d.logoSecondaryUrl;
    const accent = typeof o.accentColorHex === "string" ? $b75ffaa91259d13d$var$sanitizeAccentHex(o.accentColorHex) : d.accentColorHex;
    const ph = Number(o.logoPrimaryHeightPx);
    const sh = Number(o.logoSecondaryHeightPx);
    return {
        version: 1,
        documentTitle: doc,
        letterheadTagline: tag,
        logoPrimaryUrl: (0, $386b0bb84b222876$export$d24624a1ee66e259)(lp),
        logoSecondaryUrl: (0, $386b0bb84b222876$export$d24624a1ee66e259)(ls),
        logoPrimaryHeightPx: Number.isFinite(ph) ? $b75ffaa91259d13d$var$clampLogoHeight(ph) : d.logoPrimaryHeightPx,
        logoSecondaryHeightPx: Number.isFinite(sh) ? $b75ffaa91259d13d$var$clampLogoHeight(sh) : d.logoSecondaryHeightPx,
        accentColorHex: accent,
        footerNote: foot,
        buyerName: typeof o.buyerName === "string" ? o.buyerName.slice(0, 2000) : "",
        buyerAddress: typeof o.buyerAddress === "string" ? o.buyerAddress.slice(0, 4000) : "",
        buyerGstin: typeof o.buyerGstin === "string" ? o.buyerGstin.toUpperCase().slice(0, 32) : "",
        defaultVendorName: typeof o.defaultVendorName === "string" ? o.defaultVendorName.trim().slice(0, 500) : "",
        defaultVendorAddress: typeof o.defaultVendorAddress === "string" ? o.defaultVendorAddress.slice(0, 4000) : "",
        defaultVendorGstin: typeof o.defaultVendorGstin === "string" ? o.defaultVendorGstin.toUpperCase().slice(0, 32) : "",
        paymentTerms: typeof o.paymentTerms === "string" && o.paymentTerms.trim() ? o.paymentTerms.slice(0, 4000) : d.paymentTerms,
        defaultShipTo: typeof o.defaultShipTo === "string" ? o.defaultShipTo.slice(0, 4000) : "",
        aggregateQtyDefault: o.aggregateQtyDefault === false ? false : true,
        gstRows: $b75ffaa91259d13d$var$clampGstRows(o.gstRows)
    };
}
function $b75ffaa91259d13d$export$e9d545cac71d8c31() {
    try {
        const raw = localStorage.getItem($b75ffaa91259d13d$export$89c97ef157523537);
        if (!raw) return $b75ffaa91259d13d$export$c374e061124b6d30();
        return $b75ffaa91259d13d$export$87070318200d7b82(JSON.parse(raw));
    } catch  {
        return $b75ffaa91259d13d$export$c374e061124b6d30();
    }
}
function $b75ffaa91259d13d$export$c0bbb72c958e7adc(s) {
    const normalized = $b75ffaa91259d13d$export$87070318200d7b82(s);
    localStorage.setItem($b75ffaa91259d13d$export$89c97ef157523537, JSON.stringify(normalized));
}
function $b75ffaa91259d13d$export$adfff66ef57cdc6d(rows) {
    return rows.map((r, i)=>({
            id: `gst-saved-${i}-${r.label.replace(/\W+/g, "").slice(0, 12)}`,
            label: r.label,
            rateInput: String(r.ratePercent)
        }));
}
function $b75ffaa91259d13d$export$b2d77326b23e5e14(rows) {
    return rows.map((r)=>{
        const n = Number.parseFloat(String(r.rateInput).replace(/,/g, "").trim());
        return {
            label: (r.label || "Tax").trim().slice(0, 64) || "Tax",
            ratePercent: Number.isFinite(n) ? Math.min(100, Math.max(0, n)) : 0
        };
    });
}


function $ba06e16e265ff29f$export$28abea153604b583(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) {
        const s = iso.trim();
        return /^\d{4}-\d{2}-\d{2}/.test(s) ? s.slice(0, 10) : "";
    }
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
}
function $ba06e16e265ff29f$export$a23f6d2e9fa47d7(header) {
    const p = header.poDate?.trim();
    if (p && /^\d{4}-\d{2}-\d{2}$/.test(p)) return p;
    return $ba06e16e265ff29f$export$28abea153604b583(header.createdAt);
}


function $e33dc87250a15327$var$lineSubtitle(ln) {
    return ln && typeof ln === "object" && "beneficiaryName" in ln ? ln.beneficiaryName : ln.standardResourceTitle;
}
function $e33dc87250a15327$var$parseMoney(raw) {
    const n = Number.parseFloat(String(raw).replace(/,/g, "").trim());
    return Number.isFinite(n) ? n : 0;
}
function $e33dc87250a15327$export$cc43a217ea1bb5fc(header, items, options) {
    if (!items.length) throw new Error("No PO lines to export.");
    const s = (0, $b75ffaa91259d13d$export$e9d545cac71d8c31)();
    const aggregateQty = s.aggregateQtyDefault;
    const baseLines = aggregateQty ? (0, $386b0bb84b222876$export$f64179ddc9de5087)(items) : (0, $386b0bb84b222876$export$50b7d8ff82608f41)(items);
    const rateByKey = options?.rateByKey ?? {};
    const hsnByKey = options?.hsnByKey ?? {};
    const htmlLines = baseLines.map((ln, idx)=>{
        const rawOverride = rateByKey[ln.key];
        const rate = rawOverride != null && String(rawOverride).trim() !== "" ? $e33dc87250a15327$var$parseMoney(rawOverride) : ln.rate ?? 0;
        const qty = ln.totalQty;
        const amount = qty * rate;
        const subDesc = "beneficiaryName" in ln ? `${ln.standardResourceTitle} \xb7 Beneficiary: ${$e33dc87250a15327$var$lineSubtitle(ln)}` : ln.standardResourceTitle;
        return {
            sno: idx + 1,
            description: ln.resourceItemLabel,
            subDescription: subDesc,
            hsn: (hsnByKey[ln.key] ?? "").trim() || (ln.hsnCode ?? "").trim(),
            qty: qty,
            unit: ln.resourceItemUnit,
            rate: rate,
            amount: amount
        };
    });
    const taxableTotal = htmlLines.reduce((sum, x)=>sum + x.amount, 0);
    const gstLines = s.gstRows.map((g)=>({
            label: g.label.trim() || "Tax",
            ratePercent: g.ratePercent,
            amount: taxableTotal * (g.ratePercent / 100)
        }));
    const grandTotal = taxableTotal + gstLines.reduce((sum, x)=>sum + x.amount, 0);
    const geoByAppId = options?.applications?.length ? (0, $ac21b9a9c4b3a809$export$236d41f0e28fa8fa)(options.applications) : undefined;
    const allocations = (0, $386b0bb84b222876$export$b78eba57c6f719ba)(items, geoByAppId);
    return {
        documentTitle: s.documentTitle,
        letterheadTagline: s.letterheadTagline,
        accentColorHex: s.accentColorHex,
        footerNote: s.footerNote,
        poNumber: header.poNumber,
        poDate: (0, $ba06e16e265ff29f$export$a23f6d2e9fa47d7)(header),
        buyerName: s.buyerName,
        buyerAddress: s.buyerAddress,
        buyerGstin: s.buyerGstin,
        vendorName: s.defaultVendorName.trim() || header.subcontractorFirmName,
        vendorAddress: s.defaultVendorAddress,
        vendorGstin: s.defaultVendorGstin,
        shipTo: header.shipToPrintText?.trim() || s.defaultShipTo,
        paymentTerms: s.paymentTerms,
        lines: htmlLines,
        taxableTotal: taxableTotal,
        gstLines: gstLines,
        grandTotal: grandTotal,
        allocations: allocations
    };
}
function $e33dc87250a15327$export$1a6d24e6d422f9b4(header, items, options) {
    const doc = $e33dc87250a15327$export$cc43a217ea1bb5fc(header, items, options);
    const s = (0, $b75ffaa91259d13d$export$e9d545cac71d8c31)();
    const pdfCap = options?.forPdfCapture === true;
    const html = (0, $386b0bb84b222876$export$4ddeb3921011e5d3)({
        documentTitle: doc.documentTitle,
        letterheadTagline: doc.letterheadTagline,
        logoPrimaryUrl: s.logoPrimaryUrl,
        logoSecondaryUrl: s.logoSecondaryUrl,
        logoPrimaryHeightPx: s.logoPrimaryHeightPx,
        logoSecondaryHeightPx: s.logoSecondaryHeightPx,
        accentColorHex: doc.accentColorHex,
        footerNote: doc.footerNote.trim() || (0, $386b0bb84b222876$export$9da41ad8ba909c87),
        defaultFooterNote: (0, $386b0bb84b222876$export$9da41ad8ba909c87),
        showSignatures: false,
        poNumber: doc.poNumber,
        poDate: doc.poDate,
        buyerName: doc.buyerName,
        buyerAddress: doc.buyerAddress,
        buyerGstin: doc.buyerGstin,
        vendorName: doc.vendorName,
        vendorAddress: doc.vendorAddress,
        vendorGstin: doc.vendorGstin,
        shipTo: doc.shipTo,
        paymentTerms: doc.paymentTerms,
        lines: doc.lines,
        taxableTotal: doc.taxableTotal,
        gstLines: doc.gstLines,
        grandTotal: doc.grandTotal,
        forPdfCapture: pdfCap
    });
    const annexureHtml = (0, $386b0bb84b222876$export$df40be970a3bd4d5)({
        allocations: doc.allocations,
        footerNote: doc.footerNote.trim() || (0, $386b0bb84b222876$export$9da41ad8ba909c87),
        accentColorHex: doc.accentColorHex,
        forPdfCapture: pdfCap
    });
    const safe = header.poNumber.replace(/[^\w.-]+/g, "_");
    return {
        html: html,
        annexureHtml: annexureHtml,
        downloadBasename: `PO_${safe}`
    };
}
async function $e33dc87250a15327$export$4ac23aa0d2f99d8a(header, items, options) {
    const s = (0, $b75ffaa91259d13d$export$e9d545cac71d8c31)();
    await (0, $b2a79528db62cd8d$export$e6898c6b9b3f226e)([
        s.logoPrimaryUrl,
        s.logoSecondaryUrl
    ]);
    const doc = $e33dc87250a15327$export$cc43a217ea1bb5fc(header, items, options);
    const { html: html } = $e33dc87250a15327$export$1a6d24e6d422f9b4(header, items, {
        ...options,
        forPdfCapture: true
    });
    const blob = await (0, $b2a79528db62cd8d$export$fa7100892ae9c05f)(html, {
        annexure: {
            allocations: doc.allocations,
            accentColorHex: doc.accentColorHex,
            footerNote: doc.footerNote.trim() || (0, $386b0bb84b222876$export$9da41ad8ba909c87)
        }
    });
    const url = URL.createObjectURL(blob);
    const win = window.open(url, "_blank", "noopener,noreferrer");
    if (!win) {
        URL.revokeObjectURL(url);
        throw new Error("Popup blocked \u2014 allow pop-ups for this site to view the PDF.");
    }
    window.setTimeout(()=>URL.revokeObjectURL(url), 120000);
}
async function $e33dc87250a15327$export$4fc88037a61ae2af(header, items, options) {
    const s = (0, $b75ffaa91259d13d$export$e9d545cac71d8c31)();
    await (0, $b2a79528db62cd8d$export$e6898c6b9b3f226e)([
        s.logoPrimaryUrl,
        s.logoSecondaryUrl
    ]);
    const doc = $e33dc87250a15327$export$cc43a217ea1bb5fc(header, items, options);
    const { html: html, downloadBasename: downloadBasename } = $e33dc87250a15327$export$1a6d24e6d422f9b4(header, items, {
        ...options,
        forPdfCapture: true
    });
    await (0, $b2a79528db62cd8d$export$768a1993afbfc55d)(html, downloadBasename, {
        annexure: {
            allocations: doc.allocations,
            accentColorHex: doc.accentColorHex,
            footerNote: doc.footerNote.trim() || (0, $386b0bb84b222876$export$9da41ad8ba909c87)
        }
    });
}


// ── row status derived from "still to order" balance ─────────────────────────
function $96c75e513c969897$var$deriveStatus(planned, stillToOrder) {
    if (stillToOrder <= 0) return "completed";
    if (stillToOrder < planned) return "partial";
    return "pending";
}
function $96c75e513c969897$var$statusBadge(status) {
    if (status === "completed") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "badge badge--complete",
        children: "Completed"
    });
    if (status === "partial") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "badge badge--progress",
        children: "Partial"
    });
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "badge badge--pending",
        children: "Pending"
    });
}
function $96c75e513c969897$var$poStatusBadge(status) {
    if (status === "completed") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "badge badge--complete",
        children: "All Completed"
    });
    if (status === "partial") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "badge badge--progress",
        children: "Partial"
    });
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "badge badge--pending",
        children: "Pending"
    });
}
function $96c75e513c969897$export$9bb4affacc3a134e() {
    const { id: id } = (0, $265aeae2597a9f58$export$99eaa27ddbbb95ef)();
    const { getById: getById, applications: applications } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const app = id ? getById(id) : undefined;
    const [poHeaders, setPoHeaders] = (0, $7UyaH.useState)([]);
    // poId → IssuePoItem[] (filtered to this beneficiary)
    const [poItemsByPoId, setPoItemsByPoId] = (0, $7UyaH.useState)(new Map());
    // milestoneTemplateId → remaining qty per item (master − all POs already raised)
    const [remainingMap, setRemainingMap] = (0, $7UyaH.useState)(new Map());
    // milestoneTemplateId → master planned qty per item
    const [masterQtyMap, setMasterQtyMap] = (0, $7UyaH.useState)(new Map());
    // milestoneTemplateId → all master-plan items (to detect items with no PO yet)
    const [masterItemsMap, setMasterItemsMap] = (0, $7UyaH.useState)(new Map());
    const [loading, setLoading] = (0, $7UyaH.useState)(true);
    const [error, setError] = (0, $7UyaH.useState)(null);
    const [downloadingId, setDownloadingId] = (0, $7UyaH.useState)(null);
    const [deletingId, setDeletingId] = (0, $7UyaH.useState)(null);
    async function loadPoRegister() {
        if (!app) return;
        setLoading(true);
        setError(null);
        try {
            const pos = await (0, $f5510818538731b9$export$199cc1209b09073e)({
                limit: 2000
            });
            setPoHeaders(pos);
            const milestoneIds = [
                ...new Set(pos.map((p)=>p.milestoneTemplateId))
            ].filter(Boolean);
            // Fetch remaining-qty/master-plan and PO items in parallel
            const [milestoneResults, poItemResults] = await Promise.all([
                // Per-milestone master plan + remaining capacity
                Promise.all(milestoneIds.map(async (mid)=>{
                    const res = await (0, $f5510818538731b9$export$c174743d83e21f46)({
                        milestoneTemplateId: mid,
                        applicationIds: [
                            app.id
                        ]
                    });
                    return {
                        mid: mid,
                        res: res
                    };
                })),
                // Per-PO line items (one fetch per PO header)
                Promise.all(pos.map(async (po)=>{
                    try {
                        const allItems = await (0, $f5510818538731b9$export$49a2b5a16b830ea4)(po.id);
                        // Keep only items belonging to this beneficiary
                        const appItems = allItems.filter((item)=>item.applicationId === app.id);
                        return {
                            poId: po.id,
                            items: appItems
                        };
                    } catch  {
                        return {
                            poId: po.id,
                            items: []
                        };
                    }
                }))
            ]);
            setRemainingMap(new Map(milestoneResults.map(({ mid: mid, res: res })=>[
                    mid,
                    res.remainingQtyByStandardResourceItemId
                ])));
            setMasterQtyMap(new Map(milestoneResults.map(({ mid: mid, res: res })=>[
                    mid,
                    res.masterPlannedQtyByStandardResourceItemId ?? {}
                ])));
            setMasterItemsMap(new Map(milestoneResults.map(({ mid: mid, res: res })=>[
                    mid,
                    res.masterItems ?? []
                ])));
            setPoItemsByPoId(new Map(poItemResults.map(({ poId: poId, items: items })=>[
                    poId,
                    items
                ])));
        } catch (err) {
            setError(err instanceof Error ? err.message : "Failed to load PO register");
        } finally{
            setLoading(false);
        }
    }
    (0, $7UyaH.useEffect)(()=>{
        loadPoRegister();
    }, [
        app?.id
    ]);
    if (!app) return null;
    // ── Build groups: one group per PO, no deduplication ─────────────────────
    const groups = [];
    const sortedPos = [
        ...poHeaders
    ].sort((a, b)=>{
        const da = a.poDate ?? a.createdAt;
        const db = b.poDate ?? b.createdAt;
        return da < db ? -1 : da > db ? 1 : 0;
    });
    // Track which items have been covered by at least one PO (per milestone)
    const coveredByMilestone = new Map();
    for (const po of sortedPos){
        const poItems = poItemsByPoId.get(po.id) ?? [];
        if (poItems.length === 0) continue; // No items for this beneficiary on this PO
        const mid = po.milestoneTemplateId;
        if (!coveredByMilestone.has(mid)) coveredByMilestone.set(mid, new Set());
        const rows = poItems.map((item)=>{
            const masterQty = masterQtyMap.get(mid)?.[item.standardResourceItemId] ?? item.plannedQty;
            const remaining = remainingMap.get(mid)?.[item.standardResourceItemId];
            const stillToOrder = remaining !== undefined ? Math.max(0, remaining) : 0;
            coveredByMilestone.get(mid).add(item.standardResourceItemId);
            return {
                key: item.id,
                standardResourceTitle: item.standardResourceTitle,
                resourceItemLabel: item.resourceItemLabel,
                resourceItemUnit: item.resourceItemUnit,
                poQty: item.plannedQty,
                masterPlannedQty: masterQty,
                stillToOrder: stillToOrder,
                derivedStatus: $96c75e513c969897$var$deriveStatus(masterQty, stillToOrder),
                createdAt: item.createdAt
            };
        });
        const allDone = rows.every((r)=>r.derivedStatus === "completed");
        const anyProgress = rows.some((r)=>r.derivedStatus !== "pending");
        groups.push({
            poHeader: po,
            rows: rows,
            poStatus: allDone ? "completed" : anyProgress ? "partial" : "pending"
        });
    }
    // ── Unordered items: master-plan items with no PO raised yet ──────────────
    // Shown once per milestone as a separate "pending" group tagged isUnordered.
    const processedMilestones = new Set();
    for (const po of sortedPos){
        const mid = po.milestoneTemplateId;
        if (processedMilestones.has(mid)) continue;
        processedMilestones.add(mid);
        const masterItems = masterItemsMap.get(mid) ?? [];
        const covered = coveredByMilestone.get(mid) ?? new Set();
        const unordered = masterItems.filter((mi)=>!covered.has(mi.standardResourceItemId));
        if (unordered.length === 0) continue;
        const rows = unordered.map((mi)=>{
            const remaining = remainingMap.get(mid)?.[mi.standardResourceItemId];
            const stillToOrder = remaining !== undefined ? Math.max(0, remaining) : mi.masterPlannedQty;
            return {
                key: `unordered-${mid}-${mi.standardResourceItemId}`,
                standardResourceTitle: mi.standardResourceTitle,
                resourceItemLabel: mi.resourceItemLabel,
                resourceItemUnit: mi.resourceItemUnit,
                poQty: null,
                masterPlannedQty: mi.masterPlannedQty,
                stillToOrder: stillToOrder,
                derivedStatus: "pending",
                createdAt: po.createdAt
            };
        });
        groups.push({
            poHeader: {
                id: `unordered-${mid}`,
                poNumber: "\u2014",
                milestoneTemplateId: mid,
                milestoneTitle: po.milestoneTitle,
                subcontractorMasterId: po.subcontractorMasterId,
                subcontractorFirmName: po.subcontractorFirmName,
                beneficiaryCount: 1,
                selectionMode: "full",
                notes: "",
                createdAt: po.createdAt,
                updatedAt: po.updatedAt
            },
            rows: rows,
            poStatus: "pending",
            isUnordered: true
        });
    }
    // ── KPIs — count only real PO groups, not unordered placeholders ──────────
    const realGroups = groups.filter((g)=>!g.isUnordered);
    const totalPos = realGroups.length;
    const completedPos = realGroups.filter((g)=>g.poStatus === "completed").length;
    const partialPos = realGroups.filter((g)=>g.poStatus === "partial").length;
    const pendingPos = realGroups.filter((g)=>g.poStatus === "pending").length;
    // ── download handler ──────────────────────────────────────────────────────
    async function handleDownload(po) {
        setDownloadingId(po.id);
        try {
            const items = await (0, $f5510818538731b9$export$49a2b5a16b830ea4)(po.id);
            await (0, $e33dc87250a15327$export$4fc88037a61ae2af)(po, items, {
                applications: applications
            });
        } catch (err) {
            alert(err instanceof Error ? err.message : "Download failed");
        } finally{
            setDownloadingId(null);
        }
    }
    async function handleCancel(po) {
        if (!po.poNumber || po.poNumber === "\u2014") return;
        const ok = window.confirm(`Cancel PO ${po.poNumber}? It will be marked inactive and removed from PO lists. Any issue-material lines created with this PO (not yet issued) will also be removed.`);
        if (!ok) return;
        setDeletingId(po.id);
        try {
            const { removedIssueMaterialRows: removedIssueMaterialRows } = await (0, $f5510818538731b9$export$c31671a30009576)(po.id);
            await loadPoRegister();
            const extra = removedIssueMaterialRows > 0 ? ` (${removedIssueMaterialRows} issue material row(s) removed)` : "";
            alert(`PO ${po.poNumber} cancelled${extra}.`);
        } catch (err) {
            alert(err instanceof Error ? err.message : "Cancel failed");
        } finally{
            setDeletingId(null);
        }
    }
    // ── render ────────────────────────────────────────────────────────────────
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "tab-body",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "po-reg__kpis",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "po-reg__kpi",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "po-reg__kpi-num",
                                children: totalPos
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "po-reg__kpi-label",
                                children: "Total POs"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "po-reg__kpi",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "po-reg__kpi-num",
                                style: {
                                    color: "#16a34a"
                                },
                                children: completedPos
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "po-reg__kpi-label",
                                children: "Completed"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "po-reg__kpi",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "po-reg__kpi-num",
                                style: {
                                    color: "#0891b2"
                                },
                                children: partialPos
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "po-reg__kpi-label",
                                children: "Partial"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "po-reg__kpi",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "po-reg__kpi-num",
                                style: {
                                    color: "#d97706"
                                },
                                children: pendingPos
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "po-reg__kpi-label",
                                children: "Pending"
                            })
                        ]
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "text-muted",
                style: {
                    padding: "1.5rem"
                },
                children: "Loading PO register\u2026"
            }) : error ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--elevated",
                style: {
                    padding: "1.25rem",
                    color: "#dc2626"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Could not load PO register:"
                    }),
                    " ",
                    error,
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        style: {
                            marginTop: "0.5rem",
                            fontSize: "0.8125rem"
                        },
                        children: "Make sure the API server is running and inventory tables are seeded."
                    })
                ]
            }) : groups.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--elevated",
                style: {
                    padding: "1.5rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "No POs have been raised for this beneficiary yet."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        style: {
                            fontSize: "0.8125rem",
                            marginTop: "0.5rem"
                        },
                        children: "POs are generated from the Issue Material Register page once a subcontractor and milestone are linked."
                    })
                ]
            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "card card--flush card--elevated",
                style: {
                    marginTop: "1rem"
                },
                children: groups.map(({ poHeader: poHeader, rows: rows, poStatus: poStatus, isUnordered: isUnordered })=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "po-reg__group",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "po-reg__group-header",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "po-reg__group-left",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "po-reg__group-title",
                                                children: poHeader.milestoneTitle
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "po-reg__group-sub",
                                                children: poHeader.subcontractorFirmName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "po-reg__group-right",
                                        children: [
                                            isUnordered ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "badge badge--pending",
                                                children: "Not Ordered"
                                            }) : $96c75e513c969897$var$poStatusBadge(poStatus),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "po-reg__po-number mono",
                                                children: poHeader.poNumber !== "\u2014" ? `PO: ${poHeader.poNumber}` : isUnordered ? "Items with no PO" : "No PO number"
                                            }),
                                            poHeader.poDate && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "po-reg__po-date text-muted",
                                                children: poHeader.poDate
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                className: "po-reg__group-count",
                                                children: [
                                                    rows.length,
                                                    " line",
                                                    rows.length !== 1 ? "s" : ""
                                                ]
                                            }),
                                            !isUnordered && poHeader.poNumber !== "\u2014" && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                type: "button",
                                                className: "btn btn--secondary btn--sm",
                                                disabled: downloadingId === poHeader.id,
                                                onClick: ()=>void handleDownload(poHeader),
                                                children: downloadingId === poHeader.id ? "Generating\u2026" : "\u2193 Download PO"
                                            }),
                                            !isUnordered && poHeader.poNumber !== "\u2014" && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                type: "button",
                                                className: "btn btn--danger btn--sm",
                                                disabled: deletingId === poHeader.id,
                                                onClick: ()=>void handleCancel(poHeader),
                                                style: {
                                                    marginLeft: "0.5rem"
                                                },
                                                children: deletingId === poHeader.id ? "Cancelling\u2026" : "Cancel PO"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "table-wrap",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                    className: "data-table",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Resource"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Item"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Unit"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        className: "geo-reports__num",
                                                        children: "This PO Qty"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        className: "geo-reports__num",
                                                        children: "Master Planned"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        className: "geo-reports__num",
                                                        children: "Still to Order"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Date"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                            children: rows.map((row)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "text-muted",
                                                            style: {
                                                                fontSize: "0.8125rem"
                                                            },
                                                            children: row.standardResourceTitle
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            style: {
                                                                fontWeight: 500
                                                            },
                                                            children: row.resourceItemLabel
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "text-muted",
                                                            children: row.resourceItemUnit
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num",
                                                            style: {
                                                                color: "#0891b2",
                                                                fontWeight: 600
                                                            },
                                                            children: row.poQty !== null ? row.poQty : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                className: "text-muted",
                                                                children: "\u2014"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num",
                                                            children: row.masterPlannedQty
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num",
                                                            style: {
                                                                color: row.stillToOrder > 0 ? "#d97706" : "#64748b"
                                                            },
                                                            children: row.stillToOrder
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: $96c75e513c969897$var$statusBadge(row.derivedStatus)
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "text-muted",
                                                            style: {
                                                                fontSize: "0.8125rem"
                                                            },
                                                            children: row.createdAt.slice(0, 10)
                                                        })
                                                    ]
                                                }, row.key))
                                        })
                                    ]
                                })
                            })
                        ]
                    }, poHeader.id))
            })
        ]
    });
}






function $f822f2d8933a1325$export$9f3b4d129470fdc3() {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $5f16f4b9f1d6ad44$export$d56d5432daeb70cb), {
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $60dd8507bac67e50$export$5bd7d0871a0924fa), {
            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$910ae8079b2c2852), {})
        })
    });
}




var $7UyaH = parcelRequire("7UyaH");



async function $1395db1d2450659e$export$a9751b7a0aebdd6(currentPassword, newPassword) {
    const base = (0, $3007f8decf026d71$export$4d28219d42798a75)();
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${base}/api/auth/change-password`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            currentPassword: currentPassword,
            newPassword: newPassword
        })
    });
    const j = await res.json().catch(()=>({}));
    if (!res.ok) throw new Error(j.error || `Could not update password (${res.status})`);
}






const $e677b7633b26deab$var$DEDUPE_MS = 1200;
const $e677b7633b26deab$var$recentKeys = new Map();
function $e677b7633b26deab$var$shouldSkipElement(el) {
    if (el.closest("[data-audit-skip]")) return true;
    if (el.closest(".sidebar-flyout-backdrop")) return true;
    return false;
}
function $e677b7633b26deab$var$labelFromElement(el) {
    const explicit = el.getAttribute("data-audit-label")?.trim();
    if (explicit) return explicit.slice(0, 200);
    const aria = el.getAttribute("aria-label")?.trim();
    if (aria) return aria.slice(0, 200);
    const title = el.getAttribute("title")?.trim();
    if (title) return title.slice(0, 200);
    const text = el.textContent?.replace(/\s+/g, " ").trim();
    if (text && text.length >= 2) return text.slice(0, 200);
    const name = el.getAttribute("name")?.trim();
    if (name) return name.slice(0, 200);
    const id = el.getAttribute("id")?.trim();
    if (id) return id.slice(0, 200);
    return null;
}
function $e677b7633b26deab$var$dedupeKey(path, label, kind) {
    return `${kind}|${path}|${label}`;
}
function $e677b7633b26deab$var$recentlyLogged(key) {
    const now = Date.now();
    const prev = $e677b7633b26deab$var$recentKeys.get(key);
    if (prev != null && now - prev < $e677b7633b26deab$var$DEDUPE_MS) return true;
    $e677b7633b26deab$var$recentKeys.set(key, now);
    if ($e677b7633b26deab$var$recentKeys.size > 200) {
        for (const [k, t] of $e677b7633b26deab$var$recentKeys)if (now - t > $e677b7633b26deab$var$DEDUPE_MS * 4) $e677b7633b26deab$var$recentKeys.delete(k);
    }
    return false;
}
function $e677b7633b26deab$export$474eb049b3adb38f(label, details) {
    const path = `${window.location.pathname}${window.location.search}`;
    const cleanLabel = label.trim().slice(0, 200);
    if (!cleanLabel) return;
    const key = $e677b7633b26deab$var$dedupeKey(path, cleanLabel, "manual");
    if ($e677b7633b26deab$var$recentlyLogged(key)) return;
    (0, $33b81a08b9616b5e$export$2ca5ef4560722a5a)({
        eventType: "client_action",
        path: path,
        label: cleanLabel,
        details: {
            source: "manual",
            ...details
        }
    }).catch(()=>{});
}
function $e677b7633b26deab$var$logDomAction(kind, el, extra) {
    const path = `${window.location.pathname}${window.location.search}`;
    const baseLabel = $e677b7633b26deab$var$labelFromElement(el);
    if (!baseLabel) return;
    const label = kind === "submit" ? `Submitted: ${baseLabel}` : `Clicked: ${baseLabel}`;
    const key = $e677b7633b26deab$var$dedupeKey(path, label, kind);
    if ($e677b7633b26deab$var$recentlyLogged(key)) return;
    (0, $33b81a08b9616b5e$export$2ca5ef4560722a5a)({
        eventType: "client_action",
        path: path,
        label: label,
        details: {
            source: kind,
            tag: el.tagName.toLowerCase(),
            id: el.id || undefined,
            className: typeof el.className === "string" ? el.className.slice(0, 120) : undefined,
            ...extra
        }
    }).catch(()=>{});
}
function $e677b7633b26deab$export$4e84bf0c48ec51ea() {
    const onClick = (event)=>{
        if (event.button !== 0) return;
        const target = event.target;
        if (!(target instanceof Element)) return;
        const anchor = target.closest("a[href]");
        if (anchor instanceof HTMLAnchorElement) {
            const href = anchor.getAttribute("href") ?? "";
            if (href.startsWith("/") || href.startsWith("#")) return;
        }
        const el = target.closest("button, [role='button'], input[type='button'], input[type='submit'], .btn");
        if (!(el instanceof HTMLElement)) return;
        if ($e677b7633b26deab$var$shouldSkipElement(el)) return;
        if (el.closest("a[href]")) return;
        $e677b7633b26deab$var$logDomAction("click", el);
    };
    const onSubmit = (event)=>{
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if ($e677b7633b26deab$var$shouldSkipElement(form)) return;
        const submitter = event.submitter;
        if (submitter instanceof HTMLElement) {
            $e677b7633b26deab$var$logDomAction("submit", submitter, {
                formId: form.id || undefined,
                formName: form.name || undefined
            });
            return;
        }
        const label = form.getAttribute("data-audit-label")?.trim() || form.getAttribute("name")?.trim() || form.id?.trim() || "Form";
        const path = `${window.location.pathname}${window.location.search}`;
        const fullLabel = `Submitted: ${label}`;
        const key = $e677b7633b26deab$var$dedupeKey(path, fullLabel, "submit");
        if ($e677b7633b26deab$var$recentlyLogged(key)) return;
        (0, $33b81a08b9616b5e$export$2ca5ef4560722a5a)({
            eventType: "client_action",
            path: path,
            label: fullLabel.slice(0, 200),
            details: {
                source: "submit",
                formId: form.id || undefined,
                formName: form.name || undefined
            }
        }).catch(()=>{});
    };
    document.addEventListener("click", onClick, true);
    document.addEventListener("submit", onSubmit, true);
    const onChange = (event)=>{
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;
        if ($e677b7633b26deab$var$shouldSkipElement(target)) return;
        if (target instanceof HTMLSelectElement) {
            const field = target.getAttribute("data-audit-label")?.trim() || target.getAttribute("name")?.trim() || target.id?.trim() || "Dropdown";
            const value = target.selectedOptions[0]?.textContent?.replace(/\s+/g, " ").trim() || target.value;
            const path = `${window.location.pathname}${window.location.search}`;
            const label = `Changed ${field}: ${value}`.slice(0, 200);
            const key = $e677b7633b26deab$var$dedupeKey(path, label, "change");
            if ($e677b7633b26deab$var$recentlyLogged(key)) return;
            (0, $33b81a08b9616b5e$export$2ca5ef4560722a5a)({
                eventType: "client_action",
                path: path,
                label: label,
                details: {
                    source: "select",
                    field: field,
                    value: target.value
                }
            }).catch(()=>{});
            return;
        }
        if (target instanceof HTMLInputElement && target.type === "file") {
            const file = target.files?.[0];
            if (!file) return;
            const field = target.getAttribute("data-audit-label")?.trim() || target.getAttribute("name")?.trim() || target.id?.trim() || "File upload";
            const path = `${window.location.pathname}${window.location.search}`;
            const label = `Selected file for ${field}: ${file.name}`.slice(0, 200);
            const key = $e677b7633b26deab$var$dedupeKey(path, label, "file");
            if ($e677b7633b26deab$var$recentlyLogged(key)) return;
            (0, $33b81a08b9616b5e$export$2ca5ef4560722a5a)({
                eventType: "client_action",
                path: path,
                label: label,
                details: {
                    source: "file",
                    field: field,
                    fileName: file.name,
                    fileSize: file.size
                }
            }).catch(()=>{});
        }
    };
    document.addEventListener("change", onChange, true);
    return ()=>{
        document.removeEventListener("click", onClick, true);
        document.removeEventListener("submit", onSubmit, true);
        document.removeEventListener("change", onChange, true);
    };
}



var $0e92781313a1af4f$exports = {};
$0e92781313a1af4f$exports = $parcel$resolve("jfJdG");


const $33fc696864f4cd4a$var$nutriniumLogoSrc = new URL($0e92781313a1af4f$exports).href;
const $33fc696864f4cd4a$var$CL = {
    portal: {
        root: "portal-login__footer",
        inner: "portal-login__footer-inner",
        copy: "portal-login__footer-copy",
        dev: "portal-login__footer-dev",
        devLabel: "portal-login__footer-dev-label",
        devLink: "portal-login__footer-dev-link",
        devLogo: "portal-login__footer-dev-logo",
        devName: "portal-login__footer-dev-name"
    },
    shell: {
        root: "app-footer",
        inner: "app-footer__inner",
        copy: "app-footer__copy",
        dev: "app-footer__dev",
        devLabel: "app-footer__dev-label",
        devLink: "app-footer__dev-link",
        devLogo: "app-footer__dev-logo",
        devName: "app-footer__dev-name"
    }
};
function $33fc696864f4cd4a$export$942d66ac691266d5({ variant: variant = "shell" }) {
    const c = $33fc696864f4cd4a$var$CL[variant];
    const year = new Date().getFullYear();
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("footer", {
        className: c.root,
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
            className: c.inner,
            children: [
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                    className: c.copy,
                    children: [
                        "\xa9 ",
                        year,
                        " Indiramma Indlu. All rights reserved."
                    ]
                }),
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: c.dev,
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                            className: c.devLabel,
                            children: "Designed and Developed by:"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("a", {
                            href: "https://nutrinium.in/",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: c.devLink,
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                                    src: $33fc696864f4cd4a$var$nutriniumLogoSrc,
                                    alt: "",
                                    className: c.devLogo,
                                    loading: "lazy",
                                    decoding: "async"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: c.devName,
                                    children: "Nutrinium Technologies Pvt Ltd"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}





var $7UyaH = parcelRequire("7UyaH");




function $96a6877a8f750278$export$64164e8119317cd({ id: id, navId: navId, label: label, icon: icon, open: open, onToggle: onToggle, children: children }) {
    const toggleClass = "sidebar__section-toggle" + (open ? " sidebar__section-toggle--active" : "");
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "sidebar__section-wrap",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("button", {
                type: "button",
                className: toggleClass,
                id: id,
                "aria-expanded": open,
                "aria-controls": navId,
                onClick: onToggle,
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "sidebar__section-toggle-left",
                        children: [
                            icon,
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "sidebar__section-toggle__text",
                                children: label
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$3f284407ead563ae), {
                        className: "sidebar__section-toggle__chevron" + (open ? " sidebar__section-toggle__chevron--open" : ""),
                        "aria-hidden": true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("nav", {
                id: navId,
                className: "sidebar__sub-nav" + (open ? "" : " sidebar__sub-nav--collapsed"),
                "aria-labelledby": id,
                "aria-hidden": !open,
                children: children
            })
        ]
    });
}




function $b9d888d76a2e043c$var$navClass({ isActive: isActive }) {
    return "nav-link" + (isActive ? " nav-link--active" : "");
}
function $b9d888d76a2e043c$export$b12e90ffec9c78e5({ idPrefix: idPrefix, can: can, authRequired: authRequired, user: user, applicationsHubOpen: applicationsHubOpen, setApplicationsHubOpen: setApplicationsHubOpen, mastersOpen: mastersOpen, setMastersOpen: setMastersOpen, procurementOpen: procurementOpen, setProcurementOpen: setProcurementOpen, inventoryOpen: inventoryOpen, setInventoryOpen: setInventoryOpen, projectsOpen: projectsOpen, setProjectsOpen: setProjectsOpen, invoiceOpen: invoiceOpen, setInvoiceOpen: setInvoiceOpen, executionOpen: executionOpen, setExecutionOpen: setExecutionOpen, administrationOpen: administrationOpen, setAdministrationOpen: setAdministrationOpen }) {
    const showLeadsHub = can("leads") || can("leads_import") || (0, $4aabdb75dcf6b773$export$8f84a4e698ab11e9)(can);
    const showProjects = can("applications") || (0, $4aabdb75dcf6b773$export$8f84a4e698ab11e9)(can);
    const showMasters = can("subcontractor_masters") || can("engineer_masters") || can("agents") || can("geo_directory") || can("geo_directory_admin") || (0, $ce83db1d656d565a$export$761e56307d10af4)(can) || can("geo_zones") || can("inventory_stores_yards");
    const showProcurement = can("inventory_issue_po") || can("inventory_issue_material");
    const showInvoice = can("bills_inward");
    const showInventory = can("inventory_inward") || can("inventory_store_stocks") || can("inventory_outward") && can("inventory_issue_material");
    const canMilestonesHub = can("applications") && can("milestone_templates");
    const showExecution = canMilestonesHub || can("bills_outward") || can("inventory_goods_receipts");
    const showReports = can("reports");
    const showAdministration = Boolean(authRequired && user && (user.role === "superadmin" || can("console_users") || can("audit_log")));
    const mastersHeadingId = `${idPrefix}-nav-masters-heading`;
    const mastersNavId = `${idPrefix}-sidebar-masters-nav`;
    const procurementHeadingId = `${idPrefix}-nav-procurement-heading`;
    const procurementNavId = `${idPrefix}-sidebar-procurement-nav`;
    const inventoryHeadingId = `${idPrefix}-nav-inventory-heading`;
    const inventoryNavId = `${idPrefix}-sidebar-inventory-nav`;
    const leadsHeadingId = `${idPrefix}-nav-leads-heading`;
    const leadsNavId = `${idPrefix}-sidebar-leads-nav`;
    const projectsHeadingId = `${idPrefix}-nav-projects-heading`;
    const projectsNavId = `${idPrefix}-sidebar-projects-nav`;
    const invoiceHeadingId = `${idPrefix}-nav-invoice-heading`;
    const invoiceNavId = `${idPrefix}-sidebar-invoice-nav`;
    const executionHeadingId = `${idPrefix}-nav-execution-heading`;
    const executionNavId = `${idPrefix}-sidebar-execution-nav`;
    const administrationHeadingId = `${idPrefix}-nav-administration-heading`;
    const administrationNavId = `${idPrefix}-sidebar-administration-nav`;
    const closeAllSections = (0, $7UyaH.useCallback)(()=>{
        setApplicationsHubOpen(false);
        setProjectsOpen(false);
        setProcurementOpen(false);
        setInventoryOpen(false);
        setMastersOpen(false);
        setInvoiceOpen(false);
        setExecutionOpen(false);
        setAdministrationOpen(false);
    }, [
        setApplicationsHubOpen,
        setProjectsOpen,
        setProcurementOpen,
        setInventoryOpen,
        setMastersOpen,
        setInvoiceOpen,
        setExecutionOpen,
        setAdministrationOpen
    ]);
    const sectionToggle = (open, setter)=>()=>{
            if (open) {
                setter(false);
                return;
            }
            closeAllSections();
            setter(true);
        };
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "sidebar__nav",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "sidebar__section-label",
                children: "Menu"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                to: "/",
                end: true,
                className: $b9d888d76a2e043c$var$navClass,
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$bbf803f6a2a59274), {
                        className: "nav-link__icon"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "nav-link__text",
                        children: "Home"
                    })
                ]
            }),
            showReports ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                to: "/reports",
                className: $b9d888d76a2e043c$var$navClass,
                title: "Comprehensive data reports and downloads",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$d4152af13dc9f56e), {
                        className: "nav-link__icon"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "nav-link__text",
                        children: "Reports Hub"
                    })
                ]
            }) : null,
            showLeadsHub ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $96a6877a8f750278$export$64164e8119317cd), {
                id: leadsHeadingId,
                navId: leadsNavId,
                label: "Leads",
                icon: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$b0c934bdae14c9ef), {
                    className: "sidebar__section-toggle__icon"
                }),
                open: applicationsHubOpen,
                onToggle: sectionToggle(applicationsHubOpen, setApplicationsHubOpen),
                children: [
                    can("leads") || can("leads_import") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: can("leads") ? "/leads" : "/leads?import=1",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: can("leads") ? "Lead list and PDF/Excel import" : "Import leads (PDF or Excel)",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$b0c934bdae14c9ef), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: can("leads") ? "Leads" : "Leads import"
                            })
                        ]
                    }) : null,
                    (0, $4aabdb75dcf6b773$export$8f84a4e698ab11e9)(can) ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/applications",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Browse beneficiary applicants",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$3ea9951b43b19b95), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Applicants"
                            })
                        ]
                    }) : null
                ]
            }) : null,
            showProjects ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $96a6877a8f750278$export$64164e8119317cd), {
                id: projectsHeadingId,
                navId: projectsNavId,
                label: "Projects",
                icon: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$ca978cd35363e096), {
                    className: "sidebar__section-toggle__icon"
                }),
                open: projectsOpen,
                onToggle: sectionToggle(projectsOpen, setProjectsOpen),
                children: [
                    showProjects ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/subcontractor-to-beneficiary",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Subcontractor to beneficiaries",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$ca978cd35363e096), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Beneficiaries"
                            })
                        ]
                    }) : null,
                    showProjects ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/timeline-approvals",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Review subcontractor timeline photos",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$1888ff721e893d0e), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Timeline approvals"
                            })
                        ]
                    }) : null,
                    showProjects ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/project-initiation",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Set planned start dates for beneficiary groups",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$1888ff721e893d0e), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Project initiation"
                            })
                        ]
                    }) : null
                ]
            }) : null,
            showProcurement ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $96a6877a8f750278$export$64164e8119317cd), {
                id: procurementHeadingId,
                navId: procurementNavId,
                label: "Procurement",
                icon: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$ff497d20f87197ae), {
                    className: "sidebar__section-toggle__icon"
                }),
                open: procurementOpen,
                onToggle: sectionToggle(procurementOpen, setProcurementOpen),
                children: [
                    can("inventory_issue_po") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/inventory/po-format",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Saved PO letterhead and GST defaults",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$ff497d20f87197ae), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "PO format"
                            })
                        ]
                    }) : null,
                    can("inventory_issue_po") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/inventory/po-register",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Generate and monitor issue PO",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$b0c934bdae14c9ef), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "PO register"
                            })
                        ]
                    }) : null,
                    can("inventory_issue_material") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/inventory/issue-material",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Issue material register",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$b0c934bdae14c9ef), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Material register"
                            })
                        ]
                    }) : null
                ]
            }) : null,
            showInventory ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $96a6877a8f750278$export$64164e8119317cd), {
                id: inventoryHeadingId,
                navId: inventoryNavId,
                label: "Inventory",
                icon: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$96bab9f815fe7c91), {
                    className: "sidebar__section-toggle__icon"
                }),
                open: inventoryOpen,
                onToggle: sectionToggle(inventoryOpen, setInventoryOpen),
                children: [
                    can("inventory_inward") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/inventory/inward",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Inventory inward",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$96bab9f815fe7c91), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Inventory inward"
                            })
                        ]
                    }) : null,
                    can("inventory_outward") && can("inventory_issue_material") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/inventory/outward",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Inventory outward",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$ca978cd35363e096), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Inventory outward"
                            })
                        ]
                    }) : null,
                    can("inventory_store_stocks") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/inventory/store-stocks",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Store stocks",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$3ea9951b43b19b95), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Store stocks"
                            })
                        ]
                    }) : null,
                    can("inventory_store_stocks") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/inventory/store-audit",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Store audit worksheet",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$ae118f79ed05e2c0), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Store audit"
                            })
                        ]
                    }) : null
                ]
            }) : null,
            showMasters ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $96a6877a8f750278$export$64164e8119317cd), {
                id: mastersHeadingId,
                navId: mastersNavId,
                label: "Masters",
                icon: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$3ea9951b43b19b95), {
                    className: "sidebar__section-toggle__icon"
                }),
                open: mastersOpen,
                onToggle: sectionToggle(mastersOpen, setMastersOpen),
                children: [
                    can("subcontractor_masters") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/subcontractor-onboarding",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Register subcontracting firms for reuse across beneficiaries",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$bdcbb206cb33984b), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Subcontractor"
                            })
                        ]
                    }) : null,
                    can("engineer_masters") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/engineer-onboarding",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Register site engineers for assignment to beneficiaries",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$ae118f79ed05e2c0), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Engineer"
                            })
                        ]
                    }) : null,
                    can("agents") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/agent-master",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Field agents and assigned villages",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$1075a81d4806599f), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Agent master"
                            })
                        ]
                    }) : null,
                    can("geo_directory") || can("geo_directory_admin") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/geo-directory",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Maintain districts, mandals, and villages in the geographic directory",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$3ea9951b43b19b95), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Geo directory"
                            })
                        ]
                    }) : null,
                    can("milestone_templates") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/milestone-master",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Milestone templates",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$8dbe4c747de8c5e2), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Milestone master"
                            })
                        ]
                    }) : null,
                    can("construction_timeline") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/construction-timeline-master",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Construction timeline master",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$1888ff721e893d0e), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Timeline master"
                            })
                        ]
                    }) : null,
                    can("standard_resources") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/standard-resources-master",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Standard resources",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$9ea67044193f5b74), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Standard resources"
                            })
                        ]
                    }) : null,
                    can("geo_zones") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/zones",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Geographic zones",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$b0c934bdae14c9ef), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Zones"
                            })
                        ]
                    }) : null,
                    can("inventory_stores_yards") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/inventory/stores-yards",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Stores and yards",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$99dbb1228c102a2c), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Stores & yards"
                            })
                        ]
                    }) : null
                ]
            }) : null,
            showInvoice ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $96a6877a8f750278$export$64164e8119317cd), {
                id: invoiceHeadingId,
                navId: invoiceNavId,
                label: "Invoice",
                icon: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$ff497d20f87197ae), {
                    className: "sidebar__section-toggle__icon"
                }),
                open: invoiceOpen,
                onToggle: sectionToggle(invoiceOpen, setInvoiceOpen),
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/bills/inward/format",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Invoice letterhead and GST defaults",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$ff497d20f87197ae), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Invoice format"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/bills/inward",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Generate and register invoices",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$b0c934bdae14c9ef), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Invoice register"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/bills/labour-suppliers",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Labour supplier master for labour invoices",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$bdcbb206cb33984b), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Labour suppliers"
                            })
                        ]
                    })
                ]
            }) : null,
            showExecution ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $96a6877a8f750278$export$64164e8119317cd), {
                id: executionHeadingId,
                navId: executionNavId,
                label: "Operations",
                icon: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$8dbe4c747de8c5e2), {
                    className: "sidebar__section-toggle__icon"
                }),
                open: executionOpen,
                onToggle: sectionToggle(executionOpen, setExecutionOpen),
                children: [
                    canMilestonesHub ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/milestones",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Milestone progress across dossiers",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$8dbe4c747de8c5e2), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Milestones"
                            })
                        ]
                    }) : null,
                    can("bills_outward") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/bills/outward",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Bills outward",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$ff497d20f87197ae), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Bills outward"
                            })
                        ]
                    }) : null,
                    can("inventory_goods_receipts") ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/inventory/goods-receipts",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Goods receipts",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$ff497d20f87197ae), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Goods receipts"
                            })
                        ]
                    }) : null
                ]
            }) : null,
            showAdministration ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $96a6877a8f750278$export$64164e8119317cd), {
                id: administrationHeadingId,
                navId: administrationNavId,
                label: "Administration",
                icon: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$bdcbb206cb33984b), {
                    className: "sidebar__section-toggle__icon"
                }),
                open: administrationOpen,
                onToggle: sectionToggle(administrationOpen, setAdministrationOpen),
                children: [
                    can("console_users") || user?.role === "superadmin" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/console-users",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "Manage HO console accounts",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$bdcbb206cb33984b), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Console users"
                            })
                        ]
                    }) : null,
                    can("audit_log") || user?.role === "superadmin" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                        to: "/audit-log",
                        className: $b9d888d76a2e043c$var$navClass,
                        title: "View HO console activity audit trail",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$ae118f79ed05e2c0), {
                                className: "nav-link__icon"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "nav-link__text",
                                children: "Audit log"
                            })
                        ]
                    }) : null
                ]
            }) : null
        ]
    });
}


var $a870d17c128907f8$exports = {};
$a870d17c128907f8$exports = $parcel$resolve("kB6wt");


const $6349e701cda54027$var$indirammaLogoSrc = new URL($a870d17c128907f8$exports).href;
function $6349e701cda54027$var$isApplicationsHubPath(pathname) {
    return pathname === "/applications" || pathname.startsWith("/applications/") || pathname === "/leads" || pathname.startsWith("/leads/");
}
function $6349e701cda54027$var$isProjectsPath(pathname) {
    return pathname === "/subcontractor-to-beneficiary" || pathname.startsWith("/subcontractor-to-beneficiary/") || pathname === "/timeline-approvals" || pathname.startsWith("/timeline-approvals/") || pathname === "/project-initiation" || pathname.startsWith("/project-initiation/");
}
function $6349e701cda54027$var$isMastersPath(pathname) {
    return pathname === "/geo-directory" || pathname.startsWith("/geo-directory/") || pathname === "/subcontractor-onboarding" || pathname.startsWith("/subcontractor-onboarding/") || pathname === "/engineer-onboarding" || pathname.startsWith("/engineer-onboarding/") || pathname === "/agent-master" || pathname === "/milestone-master" || pathname.startsWith("/milestone-master/") || pathname === "/construction-timeline-master" || pathname.startsWith("/construction-timeline-master/") || pathname === "/standard-resources-master" || pathname.startsWith("/standard-resources-master/") || pathname === "/zones" || pathname.startsWith("/zones/") || pathname === "/inventory/stores-yards" || pathname.startsWith("/inventory/stores-yards/");
}
function $6349e701cda54027$var$isProcurementPath(pathname) {
    return pathname === "/inventory/po-format" || pathname.startsWith("/inventory/po-format/") || pathname === "/inventory/po-register" || pathname.startsWith("/inventory/po-register/") || pathname === "/inventory/issue-material" || pathname.startsWith("/inventory/issue-material/");
}
function $6349e701cda54027$var$isInventoryNavPath(pathname) {
    return pathname === "/inventory/inward" || pathname.startsWith("/inventory/inward/") || pathname === "/inventory/outward" || pathname.startsWith("/inventory/outward/") || pathname === "/inventory/store-stocks" || pathname.startsWith("/inventory/store-stocks/") || pathname === "/inventory/store-audit" || pathname.startsWith("/inventory/store-audit/");
}
function $6349e701cda54027$var$isInvoicePath(pathname) {
    return pathname === "/bills/inward" || pathname.startsWith("/bills/inward/") || pathname === "/bills/labour-suppliers" || pathname.startsWith("/bills/labour-suppliers/");
}
function $6349e701cda54027$var$isExecutionPath(pathname) {
    if (pathname === "/milestones" || pathname.startsWith("/milestones/")) return true;
    if (pathname === "/bills/outward" || pathname.startsWith("/bills/outward/")) return true;
    if ($6349e701cda54027$var$isInvoicePath(pathname)) return false;
    if (!pathname.startsWith("/inventory/")) return false;
    if ($6349e701cda54027$var$isProcurementPath(pathname)) return false;
    if ($6349e701cda54027$var$isInventoryNavPath(pathname)) return false;
    if (pathname === "/inventory/stores-yards" || pathname.startsWith("/inventory/stores-yards/")) return false;
    return true;
}
function $6349e701cda54027$var$isAdministrationPath(pathname) {
    return pathname === "/console-users" || pathname.startsWith("/console-users/") || pathname === "/audit-log" || pathname.startsWith("/audit-log/");
}
const $6349e701cda54027$var$SHELL_MOBILE_MQ = "(max-width: 900px)";
function $6349e701cda54027$var$shellMobileBreakpointMatches() {
    return typeof window !== "undefined" && window.matchMedia($6349e701cda54027$var$SHELL_MOBILE_MQ).matches;
}
function $6349e701cda54027$export$c84671f46d6a1ca() {
    const location = (0, $265aeae2597a9f58$export$45d76561a5302f2b)();
    const { can: can, user: user, logout: logout, authRequired: authRequired } = (0, $a4dc0d923ddf5b19$export$1d39dc5b47e56ff0)();
    const lastLoggedPathRef = (0, $7UyaH.useRef)(null);
    const [shellMobileBp, setShellMobileBp] = (0, $7UyaH.useState)($6349e701cda54027$var$shellMobileBreakpointMatches);
    const [moreMenuOpen, setMoreMenuOpen] = (0, $7UyaH.useState)(false);
    const [applicationsHubOpen, setApplicationsHubOpen] = (0, $7UyaH.useState)(()=>$6349e701cda54027$var$isApplicationsHubPath(location.pathname));
    const [mastersOpen, setMastersOpen] = (0, $7UyaH.useState)(()=>$6349e701cda54027$var$isMastersPath(location.pathname));
    const [procurementOpen, setProcurementOpen] = (0, $7UyaH.useState)(()=>$6349e701cda54027$var$isProcurementPath(location.pathname));
    const [inventoryOpen, setInventoryOpen] = (0, $7UyaH.useState)(()=>$6349e701cda54027$var$isInventoryNavPath(location.pathname));
    const [projectsOpen, setProjectsOpen] = (0, $7UyaH.useState)(()=>$6349e701cda54027$var$isProjectsPath(location.pathname));
    const [invoiceOpen, setInvoiceOpen] = (0, $7UyaH.useState)(()=>$6349e701cda54027$var$isInvoicePath(location.pathname));
    const [executionOpen, setExecutionOpen] = (0, $7UyaH.useState)(()=>$6349e701cda54027$var$isExecutionPath(location.pathname));
    const [administrationOpen, setAdministrationOpen] = (0, $7UyaH.useState)(()=>$6349e701cda54027$var$isAdministrationPath(location.pathname));
    (0, $7UyaH.useEffect)(()=>{
        if ($6349e701cda54027$var$isApplicationsHubPath(location.pathname)) setApplicationsHubOpen(true);
    }, [
        location.pathname
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if ($6349e701cda54027$var$isMastersPath(location.pathname)) setMastersOpen(true);
    }, [
        location.pathname
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if ($6349e701cda54027$var$isProcurementPath(location.pathname)) setProcurementOpen(true);
    }, [
        location.pathname
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if ($6349e701cda54027$var$isInventoryNavPath(location.pathname)) setInventoryOpen(true);
    }, [
        location.pathname
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if ($6349e701cda54027$var$isProjectsPath(location.pathname)) setProjectsOpen(true);
    }, [
        location.pathname
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if ($6349e701cda54027$var$isInvoicePath(location.pathname)) setInvoiceOpen(true);
    }, [
        location.pathname
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if ($6349e701cda54027$var$isExecutionPath(location.pathname)) setExecutionOpen(true);
    }, [
        location.pathname
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if ($6349e701cda54027$var$isAdministrationPath(location.pathname)) setAdministrationOpen(true);
    }, [
        location.pathname
    ]);
    (0, $7UyaH.useEffect)(()=>{
        setMoreMenuOpen(false);
    }, [
        location.pathname
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!authRequired || !user) return;
        const path = `${location.pathname}${location.search}`;
        if (lastLoggedPathRef.current === path) return;
        lastLoggedPathRef.current = path;
        (0, $33b81a08b9616b5e$export$2ca5ef4560722a5a)({
            eventType: "page_view",
            path: path,
            label: path
        }).catch(()=>{});
    }, [
        location.pathname,
        location.search,
        authRequired,
        user
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!authRequired || !user) return;
        return (0, $e677b7633b26deab$export$4e84bf0c48ec51ea)();
    }, [
        authRequired,
        user
    ]);
    (0, $7UyaH.useEffect)(()=>{
        const mq = window.matchMedia($6349e701cda54027$var$SHELL_MOBILE_MQ);
        const sync = ()=>{
            setShellMobileBp(mq.matches);
            if (!mq.matches) setMoreMenuOpen(false);
        };
        sync();
        mq.addEventListener("change", sync);
        return ()=>mq.removeEventListener("change", sync);
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        if (!moreMenuOpen) return;
        const onKey = (e)=>{
            if (e.key === "Escape") setMoreMenuOpen(false);
        };
        document.addEventListener("keydown", onKey);
        return ()=>document.removeEventListener("keydown", onKey);
    }, [
        moreMenuOpen
    ]);
    /** Mobile bottom bar: Leads → Applicants → Home → Beneficiaries (+ More). Reports / Work stay in the sheet. */ const bottomPrimaryItems = (0, $7UyaH.useMemo)(()=>{
        const items = [];
        if (can("leads") || can("leads_import")) items.push({
            to: can("leads") ? "/leads" : "/leads?import=1",
            label: can("leads") ? "Leads" : "Import",
            Icon: (0, $33a10e4dd89b1f49$export$b0c934bdae14c9ef)
        });
        if ((0, $4aabdb75dcf6b773$export$8f84a4e698ab11e9)(can)) items.push({
            to: "/applications",
            label: "Applicants",
            Icon: (0, $33a10e4dd89b1f49$export$3ea9951b43b19b95)
        });
        items.push({
            to: "/",
            end: true,
            label: "Home",
            Icon: (0, $33a10e4dd89b1f49$export$bbf803f6a2a59274)
        });
        if (can("applications") || (0, $4aabdb75dcf6b773$export$8f84a4e698ab11e9)(can)) items.push({
            to: "/subcontractor-to-beneficiary",
            label: "Beneficiaries",
            Icon: (0, $33a10e4dd89b1f49$export$ca978cd35363e096)
        });
        return items;
    }, [
        can
    ]);
    const shellNavProps = {
        can: can,
        authRequired: authRequired,
        user: user,
        applicationsHubOpen: applicationsHubOpen,
        setApplicationsHubOpen: setApplicationsHubOpen,
        mastersOpen: mastersOpen,
        setMastersOpen: setMastersOpen,
        procurementOpen: procurementOpen,
        setProcurementOpen: setProcurementOpen,
        inventoryOpen: inventoryOpen,
        setInventoryOpen: setInventoryOpen,
        projectsOpen: projectsOpen,
        setProjectsOpen: setProjectsOpen,
        invoiceOpen: invoiceOpen,
        setInvoiceOpen: setInvoiceOpen,
        executionOpen: executionOpen,
        setExecutionOpen: setExecutionOpen,
        administrationOpen: administrationOpen,
        setAdministrationOpen: setAdministrationOpen
    };
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "app-shell app-shell--tg",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("a", {
                href: "#main-content",
                className: "skip-link",
                children: "Skip to main content"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "tg-strip",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("header", {
                className: "topbar topbar--tg",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "topbar__left topbar__left--brand",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "topbar__brand topbar__brand--indiramma",
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                                src: $6349e701cda54027$var$indirammaLogoSrc,
                                alt: "Indiramma Indlu \u2014 Government of Telangana, Chief Minister\u2019s Office. Beneficiary monitoring and HO console.",
                                className: "topbar__brand-img topbar__brand-img--indiramma",
                                width: 520,
                                height: 120
                            })
                        })
                    }),
                    authRequired && user ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "topbar__right topbar__right--session",
                        style: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($6349e701cda54027$var$ThemeToggle, {}),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($6349e701cda54027$var$TopbarAccountMenu, {
                                displayName: user.displayName || user.email,
                                onLogout: ()=>logout()
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "app-body",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "app-body__row",
                    children: [
                        !shellMobileBp ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("aside", {
                            id: "shell-sidebar-nav",
                            className: "sidebar sidebar--tg",
                            "aria-label": "Main navigation",
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $b9d888d76a2e043c$export$b12e90ffec9c78e5), {
                                idPrefix: "desktop",
                                ...shellNavProps
                            })
                        }) : null,
                        shellMobileBp ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("nav", {
                                    className: "shell-bottom-nav",
                                    "aria-label": "Primary",
                                    children: [
                                        bottomPrimaryItems.map(({ to: to, end: end, label: label, Icon: Icon })=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $e651fdaba0d48e3d$export$b0d92dbee9b5b60d), {
                                                to: to,
                                                end: Boolean(end),
                                                className: $6349e701cda54027$var$bottomNavClass,
                                                title: label,
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)(Icon, {
                                                        className: "shell-bottom-nav__icon"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "shell-bottom-nav__label",
                                                        children: label
                                                    })
                                                ]
                                            }, to + (end ? "?end" : ""))),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("button", {
                                            type: "button",
                                            className: "shell-bottom-nav__more" + (moreMenuOpen ? " shell-bottom-nav__more--open" : ""),
                                            "aria-haspopup": "dialog",
                                            "aria-expanded": moreMenuOpen,
                                            onClick: ()=>setMoreMenuOpen((o)=>!o),
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$94155298424a8522), {
                                                    className: "shell-bottom-nav__icon"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                    className: "shell-bottom-nav__label",
                                                    children: "More"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                moreMenuOpen ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                            type: "button",
                                            className: "shell-more-backdrop",
                                            "aria-label": "Close menu",
                                            onClick: ()=>setMoreMenuOpen(false)
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "shell-more-panel",
                                            role: "dialog",
                                            "aria-modal": "true",
                                            "aria-labelledby": "shell-more-menu-title",
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                    className: "shell-more-panel__head",
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                                            id: "shell-more-menu-title",
                                                            className: "shell-more-panel__title",
                                                            children: "All sections"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "shell-more-panel__close",
                                                            onClick: ()=>setMoreMenuOpen(false),
                                                            "aria-label": "Close menu",
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$e04bcc6127e699bf), {
                                                                className: "shell-more-panel__close-icon"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                    className: "shell-more-panel__body",
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("aside", {
                                                        className: "sidebar sidebar--tg sidebar--sheet",
                                                        "aria-label": "Full menu",
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $b9d888d76a2e043c$export$b12e90ffec9c78e5), {
                                                            idPrefix: "sheet",
                                                            ...shellNavProps
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }) : null
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("main", {
                            className: "main" + (shellMobileBp ? " main--has-bottom-nav" : ""),
                            id: "main-content",
                            tabIndex: -1,
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "main__scroll",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "main__scroll-fill",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                            className: "main__canvas",
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                className: "main__inner main__inner--wide",
                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$910ae8079b2c2852), {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33fc696864f4cd4a$export$942d66ac691266d5), {
                                            variant: "shell"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function $6349e701cda54027$var$ThemeToggle() {
    const [theme, setTheme] = (0, $7UyaH.useState)(()=>{
        return localStorage.getItem("app-theme") || "light";
    });
    (0, $7UyaH.useEffect)(()=>{
        if (theme === "dark") {
            document.documentElement.setAttribute("data-theme", "dark");
            document.documentElement.classList.add("dark-mode");
        } else {
            document.documentElement.removeAttribute("data-theme");
            document.documentElement.classList.remove("dark-mode");
        }
        localStorage.setItem("app-theme", theme);
    }, [
        theme
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("style", {
                children: `
          html.dark-mode {
            filter: invert(1) hue-rotate(180deg);
            background: #111827;
          }
          /* Double-invert images and natively dark components to keep original colors */
          html.dark-mode img,
          html.dark-mode video,
          html.dark-mode iframe,
          html.dark-mode canvas,
          html.dark-mode .dash-key-metrics {
            filter: invert(1) hue-rotate(180deg);
          }
          
          /* Key Metrics specific Dark Mode overrides */
          html.dark-mode .dash-key-metrics__sunburst {
            background: radial-gradient(circle at 50% 50%, #1e293b 0%, #0f172a 100%) !important;
          }
          html.dark-mode .dash-key-metrics__rays {
            opacity: 0.03 !important;
          }
          html.dark-mode .dash-key-metrics__card {
            background: #1e293b !important;
            box-shadow: 0 8px 30px rgba(0,0,0,0.5) !important;
            border: 1px solid #334155 !important;
          }
          html.dark-mode .dash-key-metrics__value {
            color: #f8fafc !important;
          }
          html.dark-mode .dash-key-metrics__label {
            color: #94a3b8 !important;
          }
          html.dark-mode .dash-key-metrics__ribbon {
            background: #334155 !important;
            color: #f1f5f9 !important;
          }

          /* Ensure map tooltips and cards stay readable by letting them invert naturally */
          html.dark-mode .dash-corp-map__panel {
            border-color: #374151;
          }

          /* Fix specific colors that look off after invert */
          html.dark-mode .btn--primary {
            filter: brightness(1.2);
          }
          
          /* Smooth transition for body */
          body {
            transition: background-color 0.3s;
          }
        `
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                type: "button",
                onClick: ()=>setTheme((t)=>t === "light" ? "dark" : "light"),
                style: {
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    padding: "0.5rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                    color: "#14b8a6",
                    marginRight: "0.5rem",
                    transition: "background 0.2s"
                },
                onMouseEnter: (e)=>e.currentTarget.style.background = "rgba(20, 184, 166, 0.1)",
                onMouseLeave: (e)=>e.currentTarget.style.background = "transparent",
                title: `Switch to ${theme === "light" ? "Dark" : "Light"} Mode`,
                children: theme === "light" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("svg", {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                        d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
                    })
                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("circle", {
                            cx: "12",
                            cy: "12",
                            r: "5"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("line", {
                            x1: "12",
                            y1: "1",
                            x2: "12",
                            y2: "3"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("line", {
                            x1: "12",
                            y1: "21",
                            x2: "12",
                            y2: "23"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("line", {
                            x1: "4.22",
                            y1: "4.22",
                            x2: "5.64",
                            y2: "5.64"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("line", {
                            x1: "18.36",
                            y1: "18.36",
                            x2: "19.78",
                            y2: "19.78"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("line", {
                            x1: "1",
                            y1: "12",
                            x2: "3",
                            y2: "12"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("line", {
                            x1: "21",
                            y1: "12",
                            x2: "23",
                            y2: "12"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("line", {
                            x1: "4.22",
                            y1: "19.78",
                            x2: "5.64",
                            y2: "18.36"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("line", {
                            x1: "18.36",
                            y1: "5.64",
                            x2: "19.78",
                            y2: "4.22"
                        })
                    ]
                })
            })
        ]
    });
}
function $6349e701cda54027$var$TopbarAccountMenu({ displayName: displayName, onLogout: onLogout }) {
    const [menuOpen, setMenuOpen] = (0, $7UyaH.useState)(false);
    const [resetPwOpen, setResetPwOpen] = (0, $7UyaH.useState)(false);
    const wrapRef = (0, $7UyaH.useRef)(null);
    (0, $7UyaH.useEffect)(()=>{
        if (!menuOpen) return;
        const onDocMouseDown = (e)=>{
            const el = wrapRef.current;
            if (el && !el.contains(e.target)) setMenuOpen(false);
        };
        const onKey = (e)=>{
            if (e.key === "Escape") setMenuOpen(false);
        };
        document.addEventListener("mousedown", onDocMouseDown);
        document.addEventListener("keydown", onKey);
        return ()=>{
            document.removeEventListener("mousedown", onDocMouseDown);
            document.removeEventListener("keydown", onKey);
        };
    }, [
        menuOpen
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "topbar__account",
                ref: wrapRef,
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("button", {
                        type: "button",
                        className: "topbar__account-trigger",
                        id: "topbar-account-trigger",
                        "aria-expanded": menuOpen,
                        "aria-haspopup": "menu",
                        "aria-controls": "topbar-account-menu",
                        onClick: ()=>setMenuOpen((o)=>!o),
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "topbar__account-name",
                                children: displayName
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$59f995884fc5e26a), {
                                className: "topbar__account-chevron",
                                "aria-hidden": true
                            })
                        ]
                    }),
                    menuOpen ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        id: "topbar-account-menu",
                        className: "topbar__account-dropdown",
                        role: "menu",
                        "aria-labelledby": "topbar-account-trigger",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                role: "menuitem",
                                className: "topbar__account-item",
                                onClick: ()=>{
                                    setMenuOpen(false);
                                    setResetPwOpen(true);
                                },
                                children: "Reset password"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                role: "menuitem",
                                className: "topbar__account-item",
                                onClick: ()=>{
                                    setMenuOpen(false);
                                    onLogout();
                                },
                                children: "Logout"
                            })
                        ]
                    }) : null
                ]
            }),
            resetPwOpen ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($6349e701cda54027$var$ResetPasswordModal, {
                onClose: ()=>setResetPwOpen(false)
            }) : null
        ]
    });
}
function $6349e701cda54027$var$ResetPasswordModal({ onClose: onClose }) {
    const [currentPassword, setCurrentPassword] = (0, $7UyaH.useState)("");
    const [newPassword, setNewPassword] = (0, $7UyaH.useState)("");
    const [confirmPassword, setConfirmPassword] = (0, $7UyaH.useState)("");
    const [error, setError] = (0, $7UyaH.useState)(null);
    const [busy, setBusy] = (0, $7UyaH.useState)(false);
    const submit = async ()=>{
        setError(null);
        if (newPassword !== confirmPassword) {
            setError("New passwords do not match.");
            return;
        }
        if (newPassword.length < 8) {
            setError("New password must be at least 8 characters.");
            return;
        }
        setBusy(true);
        try {
            await (0, $1395db1d2450659e$export$a9751b7a0aebdd6)(currentPassword, newPassword);
            onClose();
        } catch (e) {
            setError(e instanceof Error ? e.message : "Something went wrong.");
        } finally{
            setBusy(false);
        }
    };
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
        className: "modal-backdrop",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
            className: "modal",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "reset-pw-title",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                    id: "reset-pw-title",
                    children: "Reset password"
                }),
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                    className: "modal__lede",
                    children: "Enter your current password and choose a new one (at least 8 characters)."
                }),
                error ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                    className: "text-warning",
                    style: {
                        marginBottom: "0.75rem",
                        fontSize: "0.875rem"
                    },
                    children: error
                }) : null,
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "field-grid",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "field",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                    htmlFor: "reset-pw-current",
                                    children: "Current password"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                    id: "reset-pw-current",
                                    type: "password",
                                    autoComplete: "current-password",
                                    value: currentPassword,
                                    onChange: (e)=>setCurrentPassword(e.target.value),
                                    disabled: busy
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "field",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                    htmlFor: "reset-pw-new",
                                    children: "New password"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                    id: "reset-pw-new",
                                    type: "password",
                                    autoComplete: "new-password",
                                    value: newPassword,
                                    onChange: (e)=>setNewPassword(e.target.value),
                                    disabled: busy,
                                    minLength: 8
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "field",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                    htmlFor: "reset-pw-confirm",
                                    children: "Confirm new password"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                    id: "reset-pw-confirm",
                                    type: "password",
                                    autoComplete: "new-password",
                                    value: confirmPassword,
                                    onChange: (e)=>setConfirmPassword(e.target.value),
                                    disabled: busy,
                                    minLength: 8
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "modal__actions",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            className: "btn",
                            onClick: onClose,
                            disabled: busy,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            className: "btn btn--primary btn--tg",
                            onClick: ()=>void submit(),
                            disabled: busy,
                            children: busy ? "Saving\u2026" : "Save password"
                        })
                    ]
                })
            ]
        })
    });
}
function $6349e701cda54027$var$bottomNavClass({ isActive: isActive }) {
    return "shell-bottom-nav__link" + (isActive ? " shell-bottom-nav__link--active" : "");
}





function $9e9075b70c8a1b9b$export$8ef2ed426dede42d() {
    const { loading: loading, authRequired: authRequired, user: user } = (0, $a4dc0d923ddf5b19$export$1d39dc5b47e56ff0)();
    const location = (0, $265aeae2597a9f58$export$45d76561a5302f2b)();
    if (loading) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
        className: "workspace workspace--empty",
        style: {
            padding: "3rem 1.5rem",
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
            className: "section-lead",
            children: "Checking sign-in\u2026"
        })
    });
    if (authRequired && !user) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
        to: "/login",
        replace: true,
        state: {
            from: location.pathname
        }
    });
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$910ae8079b2c2852), {});
}





function $a5f9fb9114046d54$export$c33ee7084643513d({ permission: permission, requireAll: requireAll = false, alsoRequireAll: alsoRequireAll, children: children }) {
    const { can: can, loading: loading, authRequired: authRequired, user: user } = (0, $a4dc0d923ddf5b19$export$1d39dc5b47e56ff0)();
    if (loading) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
        className: "workspace workspace--empty",
        style: {
            padding: "3rem 1.5rem",
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
            className: "section-lead",
            children: "Loading\u2026"
        })
    });
    if (authRequired && !user) return null;
    const baseAllowed = Array.isArray(permission) ? requireAll ? permission.every((p)=>can(p)) : permission.some((p)=>can(p)) : can(permission);
    const extraOk = !alsoRequireAll?.length || alsoRequireAll.every((p)=>can(p));
    const allowed = baseAllowed && extraOk;
    if (!allowed) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "workspace",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Access"
                    }
                ],
                title: "No access"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "tab-intro",
                children: "Your account does not include permission for this section. Contact a superadmin."
            })
        ]
    });
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $64174c7064b10992$exports.Fragment), {
        children: children
    });
}




var $7UyaH = parcelRequire("7UyaH");






function $3dfb08dca289a72c$export$33348b06a055dcbd(a, opts, geo) {
    return (0, $65d82a3223f822b8$export$16b9f92e753bd4d0)(geo, a, opts);
}



const $5a2b4fba16b254e8$var$STATUS_FILTER_OPTIONS = [
    {
        value: "all",
        label: "All statuses"
    },
    {
        value: "pending_validation",
        label: "Pending validation"
    },
    {
        value: "on_hold",
        label: "On hold"
    },
    {
        value: "ready_for_icici",
        label: "Ready for ICICI"
    },
    {
        value: "ready_for_mou",
        label: "Ready for MOU"
    },
    {
        value: "icici_recorded",
        label: "Awaiting subcontractor"
    },
    {
        value: "subcontractor_linked",
        label: "Subcontractor linked"
    }
];
function $5a2b4fba16b254e8$var$statusBadge(status) {
    if (status === "on_hold") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "badge badge--hold",
        children: "On hold"
    });
    if (status === "subcontractor_linked") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "badge badge--complete",
        children: "Subcontractor linked"
    });
    if (status === "icici_recorded") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "badge badge--banking",
        children: "Awaiting subcontractor"
    });
    if (status === "ready_for_mou") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "badge badge--progress",
        children: "Ready for MOU"
    });
    if (status === "ready_for_icici") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "badge badge--progress",
        children: "Ready for ICICI"
    });
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "badge badge--pending",
        children: "Pending validation"
    });
}
function $5a2b4fba16b254e8$export$73c91b53927e421e() {
    const { store: geoStore } = (0, $60dd8507bac67e50$export$5ec0231075ddedf1)();
    const { applications: applications } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const [search, setSearch] = (0, $7UyaH.useState)("");
    const [statusFilter, setStatusFilter] = (0, $7UyaH.useState)("all");
    const [receivedFrom, setReceivedFrom] = (0, $7UyaH.useState)("");
    const [receivedTo, setReceivedTo] = (0, $7UyaH.useState)("");
    const [districtFilter, setDistrictFilter] = (0, $7UyaH.useState)("");
    const [mandalFilter, setMandalFilter] = (0, $7UyaH.useState)("");
    const [villageFilter, setVillageFilter] = (0, $7UyaH.useState)("");
    const filtered = (0, $7UyaH.useMemo)(()=>{
        const q = search.trim().toLowerCase();
        return applications.filter((a)=>{
            if (q) {
                const haystack = [
                    a.mobile.applicationId,
                    a.mobile.beneficiaryName,
                    a.mobile.houseSanctionNumber
                ].join(" ").toLowerCase();
                if (!haystack.includes(q)) return false;
            }
            if (statusFilter !== "all" && a.status !== statusFilter) return false;
            const day = a.receivedAt.slice(0, 10);
            if (receivedFrom && day < receivedFrom) return false;
            if (receivedTo && day > receivedTo) return false;
            if (!(0, $3dfb08dca289a72c$export$33348b06a055dcbd)(a, {
                district: districtFilter,
                mandal: mandalFilter,
                village: villageFilter
            }, geoStore)) return false;
            return true;
        });
    }, [
        applications,
        search,
        statusFilter,
        receivedFrom,
        receivedTo,
        districtFilter,
        mandalFilter,
        villageFilter,
        geoStore
    ]);
    const hasActiveFilters = search.trim() !== "" || statusFilter !== "all" || receivedFrom !== "" || receivedTo !== "" || districtFilter !== "" || mandalFilter !== "" || villageFilter !== "";
    function clearFilters() {
        setSearch("");
        setStatusFilter("all");
        setReceivedFrom("");
        setReceivedTo("");
        setDistrictFilter("");
        setMandalFilter("");
        setVillageFilter("");
    }
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Applicants"
                    }
                ],
                title: "Applicants"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--flush card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "table-toolbar table-toolbar--stack",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "table-toolbar__top",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "table-toolbar__count",
                                        children: hasActiveFilters ? `${filtered.length} of ${applications.length} applicants` : `${applications.length} applicants`
                                    }),
                                    hasActiveFilters ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--link btn--sm table-toolbar__clear",
                                        onClick: clearFilters,
                                        children: "Clear filters"
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "table-filters-grid",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "table-filters",
                                        role: "search",
                                        "aria-label": "Filter applicants",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "field table-filters__field table-filters__field--grow",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                        htmlFor: "app-filter-search",
                                                        children: "Search"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        id: "app-filter-search",
                                                        type: "search",
                                                        placeholder: "ID, beneficiary, or sanction ref.",
                                                        value: search,
                                                        onChange: (e)=>setSearch(e.target.value),
                                                        autoComplete: "off"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "field table-filters__field",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                        htmlFor: "app-filter-status",
                                                        children: "Pipeline status"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("select", {
                                                        id: "app-filter-status",
                                                        value: statusFilter,
                                                        onChange: (e)=>setStatusFilter(e.target.value),
                                                        children: $5a2b4fba16b254e8$var$STATUS_FILTER_OPTIONS.map((o)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                                value: o.value,
                                                                children: o.label
                                                            }, o.value))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "field table-filters__field",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                        htmlFor: "app-filter-from",
                                                        children: "Received from"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        id: "app-filter-from",
                                                        type: "date",
                                                        value: receivedFrom,
                                                        onChange: (e)=>setReceivedFrom(e.target.value)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "field table-filters__field",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                        htmlFor: "app-filter-to",
                                                        children: "Received to"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        id: "app-filter-to",
                                                        type: "date",
                                                        value: receivedTo,
                                                        onChange: (e)=>setReceivedTo(e.target.value)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "table-filters table-filters--geo-row",
                                        "aria-label": "Location filters",
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $0377fbce5921ee00$export$b3eb1a6c17723c14), {
                                            idPrefix: "app-geo",
                                            district: districtFilter,
                                            mandal: mandalFilter,
                                            village: villageFilter,
                                            onDistrictChange: (d)=>{
                                                setDistrictFilter(d);
                                                setMandalFilter("");
                                                setVillageFilter("");
                                            },
                                            onMandalChange: (m)=>{
                                                setMandalFilter(m);
                                                setVillageFilter("");
                                            },
                                            onVillageChange: setVillageFilter
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "table-wrap",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                            className: "data-table",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Application ID"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Beneficiary"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Sanction ref."
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "District"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Mandal"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Village"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Pipeline status"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                    children: filtered.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                            colSpan: 8,
                                            className: "data-table__empty",
                                            children: "No applicants match the current filters."
                                        })
                                    }) : filtered.map((a)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "mono",
                                                    children: a.mobile.applicationId
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "table-name",
                                                        children: (0, $458840b99c021cb6$export$bb1029bec19025fd)(a.mobile.beneficiaryName)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "mono text-muted",
                                                    children: a.mobile.houseSanctionNumber
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: (0, $458840b99c021cb6$export$bb1029bec19025fd)(geoStore?.findDistrict(a.district)?.registrationDistrictName ?? a.district)
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: (0, $458840b99c021cb6$export$bb1029bec19025fd)(a.mandal)
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: (0, $458840b99c021cb6$export$bb1029bec19025fd)(a.village)
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: $5a2b4fba16b254e8$var$statusBadge(a.status)
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                                        to: `/applications/${a.id}/overview`,
                                                        state: {
                                                            from: "applicants"
                                                        },
                                                        className: "btn btn--primary btn--sm btn--tg",
                                                        children: "Open"
                                                    })
                                                })
                                            ]
                                        }, a.id))
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");





function $2794c1eaff4211f4$export$1fdb4b9f50ed85c8({ permRecord: permRecord, yards: yards, yardsLoading: yardsLoading, allStores: allStores, selectedIds: selectedIds, onChange: onChange }) {
    if (!(0, $18b0587275e330a6$export$d1ee338f4fd08fe6)(permRecord)) return null;
    const toggleYard = (id, on)=>{
        const next = new Set(selectedIds);
        if (on) next.add(id);
        else next.delete(id);
        onChange({
            allStores: false,
            selectedIds: [
                ...next
            ]
        });
    };
    const sorted = [
        ...yards
    ].sort((a, b)=>(a.sortOrder ?? 0) - (b.sortOrder ?? 0) || a.name.localeCompare(b.name));
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("fieldset", {
        className: "console-users-page__perms inventory-store-access",
        "aria-label": "Inventory store / yard access",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("legend", {
                className: "permission-module-picker__legend",
                children: "Inventory \u2014 store / yard access"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "permission-module-picker__desc",
                children: [
                    "This user has at least one inventory permission tied to stores (inward, outward, issue PO, issue material, store stocks, or goods receipts). Choose whether they may use ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "all"
                    }),
                    " stores/yards or only the ones you select below."
                ]
            }),
            yardsLoading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "text-muted",
                style: {
                    margin: "0.5rem 0"
                },
                children: "Loading stores\u2026"
            }) : sorted.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "text-muted",
                style: {
                    margin: "0.5rem 0"
                },
                children: "No stores/yards found in the master list. Add stores under Masters \u2192 Stores & yards first."
            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                        className: "permission-module-picker__full-row inventory-store-access__radio-row",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                type: "radio",
                                name: "inv-store-scope",
                                checked: allStores,
                                onChange: ()=>onChange({
                                        allStores: true,
                                        selectedIds: []
                                    })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "console-users-page__perm-label",
                                children: "All stores / yards (unrestricted inventory)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                        className: "permission-module-picker__full-row inventory-store-access__radio-row",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                type: "radio",
                                name: "inv-store-scope",
                                checked: !allStores,
                                onChange: ()=>onChange({
                                        allStores: false,
                                        selectedIds: selectedIds
                                    })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "console-users-page__perm-label",
                                children: "Only selected stores / yards"
                            })
                        ]
                    }),
                    !allStores ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "inventory-store-access__grid",
                        role: "group",
                        "aria-label": "Stores this user may access",
                        children: sorted.map((y)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "console-users-page__perm-row permission-module-picker__row",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        type: "checkbox",
                                        className: "console-users-page__perm-check",
                                        checked: selectedIds.includes(y.id),
                                        onChange: (e)=>toggleYard(y.id, e.target.checked)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "console-users-page__perm-label",
                                        children: y.name || y.id
                                    })
                                ]
                            }, y.id))
                    }) : null
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");


const $032707e478bd3004$export$f82619889478f7ce = [
    {
        id: "menu",
        title: "Menu",
        description: "Home is available to all signed-in console users.",
        granularKeys: [
            "reports",
            "geo_tree"
        ]
    },
    {
        id: "leads",
        title: "Leads",
        description: "Lead intake first, then applicant registry: use full access for every dossier tab, or turn it off and assign specific dossier sections only. View-only applies only when this user can open applicant dossiers.",
        prefixGranularKeys: [
            "leads",
            "leads_import"
        ],
        exclusiveFullKey: "applications",
        postExclusiveGranularKeys: [
            (0, $4aabdb75dcf6b773$export$927907d58b89b755)
        ],
        granularKeys: (0, $4aabdb75dcf6b773$export$789d16b94f94ef4f)
    },
    {
        id: "projects",
        title: "Projects",
        infoOnly: true,
        description: "Beneficiaries, Timeline approvals, and Project initiation use the same permission as full applicant access \u2014 enable **Applicants \u2014 full access (all dossier tabs + registry)** under Leads above.",
        granularKeys: []
    },
    {
        id: "procurement",
        title: "Procurement",
        granularKeys: [
            "inventory_issue_po",
            "inventory_issue_material"
        ]
    },
    {
        id: "inventory",
        title: "Inventory",
        description: "When any inventory permission below is enabled, Console Users will ask which **stores / yards** this account may use (or \u201Call\u201D). Goods receipts (Operations) use the same store list.",
        granularKeys: [
            "inventory_inward",
            "inventory_outward",
            "inventory_store_stocks"
        ]
    },
    {
        id: "masters",
        title: "Masters",
        granularKeys: [
            "subcontractor_masters",
            "agents",
            "geo_directory",
            "geo_directory_admin",
            "milestone_templates",
            "construction_timeline",
            "standard_resources",
            "standard_item_catalogue",
            "geo_zones",
            "inventory_stores_yards"
        ]
    },
    {
        id: "operations",
        title: "Operations",
        description: "The cross-beneficiary Milestones hub also requires **full applicant access** (Leads) plus **Milestone master** under Masters.",
        granularKeys: [
            "bills_inward",
            "bills_outward",
            "inventory_goods_receipts"
        ]
    },
    {
        id: "administration",
        title: "Administration",
        granularKeys: [
            "console_users",
            "audit_log"
        ]
    }
];


function $13a7f781883ba04e$var$moduleAllKeys(m) {
    const keys = [
        ...m.prefixGranularKeys ?? [],
        ...m.exclusiveFullKey ? [
            m.exclusiveFullKey
        ] : [],
        ...m.postExclusiveGranularKeys ?? [],
        ...m.granularKeys
    ];
    return keys;
}
const $13a7f781883ba04e$var$MODULE_COVERED_KEYS = new Set((0, $032707e478bd3004$export$f82619889478f7ce).flatMap($13a7f781883ba04e$var$moduleAllKeys));
function $13a7f781883ba04e$export$2c9ba40c0d9d1d35({ keys: keys, labelsById: labelsById, value: value, onChange: onChange }) {
    const baseline = (0, $7UyaH.useMemo)(()=>Object.fromEntries(keys.map((k)=>[
                k,
                Boolean(value[k])
            ])), [
        keys,
        value
    ]);
    const merge = (patch)=>{
        const next = {
            ...baseline,
            ...patch
        };
        onChange(next);
    };
    const unknownKeys = (0, $7UyaH.useMemo)(()=>keys.filter((k)=>!$13a7f781883ba04e$var$MODULE_COVERED_KEYS.has(k)), [
        keys
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "permission-module-picker",
        children: [
            (0, $032707e478bd3004$export$f82619889478f7ce).map((module)=>{
                if (module.infoOnly) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("fieldset", {
                    className: "permission-module-picker__module permission-module-picker__module--info",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("legend", {
                            className: "permission-module-picker__legend",
                            children: module.title
                        }),
                        module.description ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                            className: "permission-module-picker__desc permission-module-picker__desc--info",
                            children: module.description
                        }) : null
                    ]
                }, module.id);
                const exclusiveFk = module.exclusiveFullKey;
                const fullLocked = Boolean(exclusiveFk && baseline[exclusiveFk]);
                const prefixKeys = module.prefixGranularKeys ?? [];
                const postExclusiveKeys = module.postExclusiveGranularKeys ?? [];
                const granularKeys = module.granularKeys;
                const allTogglable = [
                    ...prefixKeys,
                    ...granularKeys
                ];
                const hasToolbar = !exclusiveFk && allTogglable.length > 0;
                return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("fieldset", {
                    className: "permission-module-picker__module",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("legend", {
                            className: "permission-module-picker__legend",
                            children: module.title
                        }),
                        module.description ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                            className: "permission-module-picker__desc",
                            children: module.description
                        }) : null,
                        prefixKeys.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "permission-module-picker__subsection",
                            children: prefixKeys.map((k)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "console-users-page__perm-row permission-module-picker__row",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                            type: "checkbox",
                                            className: "console-users-page__perm-check",
                                            checked: Boolean(baseline[k]),
                                            onChange: ()=>merge({
                                                    [k]: !baseline[k]
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "console-users-page__perm-label",
                                            children: labelsById.get(k) ?? k
                                        })
                                    ]
                                }, k))
                        }) : null,
                        exclusiveFk ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                            className: "permission-module-picker__full-row",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                    type: "checkbox",
                                    className: "console-users-page__perm-check",
                                    checked: Boolean(baseline[exclusiveFk]),
                                    onChange: ()=>{
                                        const on = !baseline[exclusiveFk];
                                        const patch = {
                                            [exclusiveFk]: on
                                        };
                                        if (on && exclusiveFk === "applications") (0, $4aabdb75dcf6b773$export$789d16b94f94ef4f).forEach((k)=>{
                                            patch[k] = false;
                                        });
                                        merge(patch);
                                    }
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "console-users-page__perm-label",
                                    children: labelsById.get(exclusiveFk) ?? exclusiveFk
                                })
                            ]
                        }) : hasToolbar ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "permission-module-picker__toolbar",
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--tg-secondary btn--sm",
                                onClick: ()=>{
                                    const allOn = allTogglable.every((k)=>baseline[k]);
                                    const patch = {};
                                    allTogglable.forEach((k)=>{
                                        patch[k] = !allOn;
                                    });
                                    merge(patch);
                                },
                                children: allTogglable.every((k)=>baseline[k]) ? "Clear module" : "Select entire module"
                            })
                        }) : null,
                        postExclusiveKeys.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "permission-module-picker__subsection",
                            children: postExclusiveKeys.map((k)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "console-users-page__perm-row permission-module-picker__row",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                            type: "checkbox",
                                            className: "console-users-page__perm-check",
                                            checked: Boolean(baseline[k]),
                                            onChange: ()=>merge({
                                                    [k]: !baseline[k]
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "console-users-page__perm-label",
                                            children: labelsById.get(k) ?? k
                                        })
                                    ]
                                }, k))
                        }) : null,
                        granularKeys.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "permission-module-picker__granular" + (fullLocked ? " permission-module-picker__granular--disabled" : ""),
                            "aria-disabled": fullLocked || undefined,
                            children: granularKeys.map((k)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "console-users-page__perm-row permission-module-picker__row",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                            type: "checkbox",
                                            className: "console-users-page__perm-check",
                                            disabled: fullLocked,
                                            checked: Boolean(baseline[k]),
                                            onChange: ()=>{
                                                if (fullLocked) return;
                                                const patch = {
                                                    [k]: !baseline[k]
                                                };
                                                if (exclusiveFk) patch[exclusiveFk] = false;
                                                merge(patch);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "console-users-page__perm-label",
                                            children: labelsById.get(k) ?? k
                                        })
                                    ]
                                }, k))
                        }) : null
                    ]
                }, module.id);
            }),
            unknownKeys.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("fieldset", {
                className: "permission-module-picker__module",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("legend", {
                        className: "permission-module-picker__legend",
                        children: "Other permissions"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "permission-module-picker__desc",
                        children: "Keys from the server not listed in the modules above."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "permission-module-picker__granular",
                        children: unknownKeys.map((k)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "console-users-page__perm-row permission-module-picker__row",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        type: "checkbox",
                                        className: "console-users-page__perm-check",
                                        checked: Boolean(baseline[k]),
                                        onChange: ()=>merge({
                                                [k]: !baseline[k]
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "console-users-page__perm-label",
                                        children: labelsById.get(k) ?? k
                                    })
                                ]
                            }, k))
                    })
                ]
            }) : null
        ]
    });
}


/** Labels for admin permission checkboxes (keys must match server `ALL_CONSOLE_PERMISSION_KEYS`). */ const $eb8205552e563176$export$630e748bcc563e9f = [
    {
        id: "leads",
        label: "Leads (view table & filters)"
    },
    {
        id: "leads_import",
        label: "Leads import (PDF/Excel upload only)"
    },
    {
        id: "applications",
        label: "Applicants \u2014 full access (all dossier tabs + registry)"
    },
    {
        id: "dossier_tab_overview",
        label: "Applicants \u2014 tab: Overview"
    },
    {
        id: "dossier_tab_beneficiary",
        label: "Applicants \u2014 tab: Beneficiary & documents"
    },
    {
        id: "dossier_tab_validation",
        label: "Applicants \u2014 tab: Verification & Aadhaar seeding"
    },
    {
        id: "dossier_tab_banking",
        label: "Applicants \u2014 tab: ICICI & MOU"
    },
    {
        id: "dossier_tab_subcontractor",
        label: "Applicants \u2014 tab: Subcontractor"
    },
    {
        id: "dossier_tab_work_progress",
        label: "Applicants \u2014 tab: Work progress"
    },
    {
        id: "dossier_tab_po_register",
        label: "Applicants \u2014 tab: PO register"
    },
    {
        id: "dossier_tab_milestones",
        label: "Applicants \u2014 tab: Milestones"
    },
    {
        id: "dossier_tab_bills",
        label: "Applicants \u2014 tab: Bills"
    },
    {
        id: "applications_no_edit",
        label: "Applicants \u2014 view only (open dossiers but cannot save changes)"
    },
    {
        id: "bills_inward",
        label: "Bills inward"
    },
    {
        id: "bills_outward",
        label: "Bills outward"
    },
    {
        id: "reports",
        label: "Area reports"
    },
    {
        id: "geo_tree",
        label: "Area tree (district \u2192 mandal \u2192 village view + add leads)"
    },
    {
        id: "geo_directory",
        label: "Geo directory (read map data)"
    },
    {
        id: "geo_directory_admin",
        label: "Geo directory admin (edit districts/mandals/villages)"
    },
    {
        id: "geo_zones",
        label: "Zones"
    },
    {
        id: "subcontractor_masters",
        label: "Subcontractor"
    },
    {
        id: "agents",
        label: "Agent master"
    },
    {
        id: "milestone_templates",
        label: "Milestone master"
    },
    {
        id: "construction_timeline",
        label: "Timeline master"
    },
    {
        id: "standard_resources",
        label: "Standard resources"
    },
    {
        id: "standard_item_catalogue",
        label: "Standard item catalogue"
    },
    {
        id: "inventory_issue_po",
        label: "PO format & PO register"
    },
    {
        id: "inventory_issue_material",
        label: "Material register"
    },
    {
        id: "inventory_inward",
        label: "Inventory inward"
    },
    {
        id: "inventory_goods_receipts",
        label: "Goods receipts"
    },
    {
        id: "inventory_store_stocks",
        label: "Store stocks"
    },
    {
        id: "inventory_stores_yards",
        label: "Stores & yards"
    },
    {
        id: "inventory_outward",
        label: "Inventory outward"
    },
    {
        id: "console_users",
        label: "Console users"
    },
    {
        id: "audit_log",
        label: "Audit log (activity report)"
    }
];





function $9771d1fd83e2b1ce$var$AddConsoleUserForm({ keys: keys, labelsById: labelsById, yardOptions: yardOptions, yardsLoading: yardsLoading, currentUserIsSuperadmin: currentUserIsSuperadmin, onCreated: onCreated }) {
    const [email, setEmail] = (0, $7UyaH.useState)("");
    const [displayName, setDisplayName] = (0, $7UyaH.useState)("");
    const [password, setPassword] = (0, $7UyaH.useState)("");
    const [role, setRole] = (0, $7UyaH.useState)("admin");
    const [newPermRecord, setNewPermRecord] = (0, $7UyaH.useState)({});
    const [newInvAllStores, setNewInvAllStores] = (0, $7UyaH.useState)(true);
    const [newInvSelectedIds, setNewInvSelectedIds] = (0, $7UyaH.useState)([]);
    const [busy, setBusy] = (0, $7UyaH.useState)(false);
    const [formErr, setFormErr] = (0, $7UyaH.useState)(null);
    (0, $7UyaH.useEffect)(()=>{
        if (!currentUserIsSuperadmin && role === "superadmin") setRole("admin");
    }, [
        currentUserIsSuperadmin,
        role
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("form", {
        className: "milestone-master-modal-editor",
        onSubmit: (e)=>{
            e.preventDefault();
            setFormErr(null);
            setBusy(true);
            (async ()=>{
                try {
                    const merged = {
                        ...Object.fromEntries(keys.map((k)=>[
                                k,
                                false
                            ])),
                        ...newPermRecord
                    };
                    const perms = role === "superadmin" ? [] : keys.filter((k)=>merged[k]);
                    if (role === "admin" && (0, $18b0587275e330a6$export$d1ee338f4fd08fe6)(merged) && !newInvAllStores && newInvSelectedIds.length === 0) throw new Error("Inventory store access: choose \u201CAll stores\u201D or select at least one store / yard.");
                    const base = (0, $3007f8decf026d71$export$4d28219d42798a75)();
                    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${base}/api/console-users`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            email: email.trim(),
                            displayName: displayName.trim(),
                            password: password,
                            role: role,
                            permissions: perms,
                            inventoryStoreYardIds: role === "superadmin" || !(0, $18b0587275e330a6$export$d1ee338f4fd08fe6)(merged) ? undefined : newInvAllStores ? null : newInvSelectedIds
                        })
                    });
                    const j = await res.json().catch(()=>({}));
                    if (!res.ok) throw new Error(j.error || res.statusText);
                    setEmail("");
                    setDisplayName("");
                    setPassword("");
                    setRole("admin");
                    setNewPermRecord({});
                    setNewInvAllStores(true);
                    setNewInvSelectedIds([]);
                    onCreated();
                } catch (ex) {
                    setFormErr(ex instanceof Error ? ex.message : String(ex));
                } finally{
                    setBusy(false);
                }
            })();
        },
        children: [
            formErr ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "alert alert--danger",
                role: "alert",
                style: {
                    marginBottom: "0.75rem"
                },
                children: formErr
            }) : null,
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                className: "form-section-title",
                children: "Account"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field-grid",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: "cu-email",
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "cu-email",
                                type: "email",
                                value: email,
                                onChange: (e)=>setEmail(e.target.value),
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: "cu-name",
                                children: "Display name"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "cu-name",
                                value: displayName,
                                onChange: (e)=>setDisplayName(e.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: "cu-pass",
                                children: "Password (min 8)"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "cu-pass",
                                type: "password",
                                value: password,
                                onChange: (e)=>setPassword(e.target.value),
                                required: true,
                                minLength: 8
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: "cu-role",
                                children: "Role"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                                id: "cu-role",
                                value: role,
                                onChange: (e)=>setRole(e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                        value: "admin",
                                        children: "Admin (scoped permissions)"
                                    }),
                                    currentUserIsSuperadmin ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                        value: "superadmin",
                                        children: "Superadmin (full access)"
                                    }) : null
                                ]
                            })
                        ]
                    })
                ]
            }),
            role === "admin" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        children: "Module access"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("fieldset", {
                        className: "console-users-page__perms",
                        "aria-label": "Module permissions",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $13a7f781883ba04e$export$2c9ba40c0d9d1d35), {
                                keys: keys,
                                labelsById: labelsById,
                                value: newPermRecord,
                                onChange: setNewPermRecord
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $2794c1eaff4211f4$export$1fdb4b9f50ed85c8), {
                                permRecord: {
                                    ...Object.fromEntries(keys.map((k)=>[
                                            k,
                                            false
                                        ])),
                                    ...newPermRecord
                                },
                                yards: yardOptions,
                                yardsLoading: yardsLoading,
                                allStores: newInvAllStores,
                                selectedIds: newInvSelectedIds,
                                onChange: ({ allStores: allStores, selectedIds: selectedIds })=>{
                                    setNewInvAllStores(allStores);
                                    setNewInvSelectedIds(selectedIds);
                                }
                            })
                        ]
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "toolbar-row",
                style: {
                    marginTop: "0.75rem"
                },
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                    type: "submit",
                    className: "btn btn--primary btn--tg",
                    disabled: busy,
                    children: busy ? "Saving\u2026" : "Create user"
                })
            })
        ]
    });
}
function $9771d1fd83e2b1ce$var$ConsoleUserSummaryCard({ row: row, isActive: isActive, onOpen: onOpen }) {
    const accessLine = row.role === "superadmin" ? "Full access \xb7 all modules" : `${row.permissions.length} permission${row.permissions.length === 1 ? "" : "s"}`;
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("button", {
        type: "button",
        className: `milestone-master-picker-card${isActive ? " milestone-master-picker-card--active" : ""}`,
        onClick: onOpen,
        "aria-haspopup": "dialog",
        "aria-expanded": isActive,
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "milestone-master-picker-card__content",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__top",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                            className: "milestone-master-picker-card__phase-badge",
                            children: row.role === "superadmin" ? "Superadmin" : "Admin"
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__title",
                        children: row.displayName || "\u2014"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__stats mono",
                        "aria-label": "Email",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                            children: row.email
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__stats",
                        "aria-label": "Permissions",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                            children: accessLine
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                className: "milestone-master-picker-card__footer",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                    children: isActive ? "Editor open" : "Click to manage user"
                })
            })
        ]
    });
}
function $9771d1fd83e2b1ce$var$UserManagePanel({ row: row, keys: keys, labelsById: labelsById, yardOptions: yardOptions, yardsLoading: yardsLoading, onSaved: onSaved, onClose: onClose, currentUserId: currentUserId, currentUserIsSuperadmin: currentUserIsSuperadmin }) {
    const [np, setNp] = (0, $7UyaH.useState)("");
    const [permRecord, setPermRecord] = (0, $7UyaH.useState)(()=>Object.fromEntries(keys.map((k)=>[
                k,
                row.permissions.includes(k)
            ])));
    const [invAllStores, setInvAllStores] = (0, $7UyaH.useState)(()=>row.inventoryStoreYardIds == null);
    const [invSelectedIds, setInvSelectedIds] = (0, $7UyaH.useState)(()=>row.inventoryStoreYardIds ?? []);
    const [busy, setBusy] = (0, $7UyaH.useState)(false);
    const [localErr, setLocalErr] = (0, $7UyaH.useState)(null);
    (0, $7UyaH.useEffect)(()=>{
        setPermRecord(Object.fromEntries(keys.map((k)=>[
                k,
                row.permissions.includes(k)
            ])));
        setInvAllStores(row.inventoryStoreYardIds == null);
        setInvSelectedIds(row.inventoryStoreYardIds ?? []);
        setLocalErr(null);
        setNp("");
    }, [
        row.id,
        row.permissions,
        row.inventoryStoreYardIds,
        keys
    ]);
    const savePatch = async (body)=>{
        setBusy(true);
        setLocalErr(null);
        try {
            const base = (0, $3007f8decf026d71$export$4d28219d42798a75)();
            const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${base}/api/console-users/${encodeURIComponent(row.id)}`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            });
            const j = await res.json().catch(()=>({}));
            if (!res.ok) throw new Error(j.error || res.statusText);
            onSaved();
            return true;
        } catch (e) {
            setLocalErr(e instanceof Error ? e.message : String(e));
            return false;
        } finally{
            setBusy(false);
        }
    };
    const buildPermissionsPatch = ()=>{
        if ((0, $18b0587275e330a6$export$d1ee338f4fd08fe6)(permRecord) && !invAllStores && invSelectedIds.length === 0) {
            setLocalErr("Inventory store access: choose \u201CAll stores\u201D or select at least one store / yard.");
            return null;
        }
        return {
            permissions: keys.filter((k)=>permRecord[k]),
            inventoryStoreYardIds: (0, $18b0587275e330a6$export$d1ee338f4fd08fe6)(permRecord) ? invAllStores ? null : invSelectedIds : undefined
        };
    };
    const savePermissions = async ()=>{
        const body = buildPermissionsPatch();
        if (!body) return false;
        return savePatch(body);
    };
    const canDeleteRow = row.id !== currentUserId && (currentUserIsSuperadmin || row.role !== "superadmin");
    const deleteUser = async ()=>{
        if (!canDeleteRow) return;
        const ok = window.confirm(`Remove console user \u{201C}${row.displayName || row.email}\u{201D}?

They will no longer be able to sign in. This cannot be undone.`);
        if (!ok) return;
        setBusy(true);
        setLocalErr(null);
        try {
            const base = (0, $3007f8decf026d71$export$4d28219d42798a75)();
            const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${base}/api/console-users/${encodeURIComponent(row.id)}`, {
                method: "DELETE"
            });
            if (!res.ok) {
                const j = await res.json().catch(()=>({}));
                throw new Error(j.error || res.statusText);
            }
            onSaved();
            onClose();
        } catch (e) {
            setLocalErr(e instanceof Error ? e.message : String(e));
        } finally{
            setBusy(false);
        }
    };
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "milestone-master-modal-editor console-users-manage-panel",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "console-users-manage-panel__identity",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "console-users-page__user-line",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "table-name",
                                children: row.displayName || "\u2014"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "console-users-page__user-sep",
                                "aria-hidden": "true",
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "mono text-muted console-users-page__user-email-inline",
                                children: row.email
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "console-users-page__role-line",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                            className: "console-users-page__role-pill" + (row.role === "superadmin" ? " console-users-page__role-pill--super" : ""),
                            children: row.role === "superadmin" ? "Superadmin" : "Admin"
                        })
                    })
                ]
            }),
            localErr ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "alert alert--danger",
                role: "alert",
                style: {
                    margin: "0.75rem 0"
                },
                children: localErr
            }) : null,
            row.role === "superadmin" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "text-muted section-lead section-lead--tight",
                style: {
                    marginTop: "0.5rem"
                },
                children: "Superadmins always have full module access. You can change their password below."
            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        style: {
                            marginTop: "0.75rem"
                        },
                        children: "Module access"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("fieldset", {
                        className: "console-users-page__perms",
                        "aria-label": "Module permissions",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $13a7f781883ba04e$export$2c9ba40c0d9d1d35), {
                                keys: keys,
                                labelsById: labelsById,
                                value: permRecord,
                                onChange: setPermRecord
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $2794c1eaff4211f4$export$1fdb4b9f50ed85c8), {
                                permRecord: permRecord,
                                yards: yardOptions,
                                yardsLoading: yardsLoading,
                                allStores: invAllStores,
                                selectedIds: invSelectedIds,
                                onChange: ({ allStores: allStores, selectedIds: selectedIds })=>{
                                    setInvAllStores(allStores);
                                    setInvSelectedIds(selectedIds);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "toolbar-row",
                        style: {
                            marginTop: "0.65rem"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            className: "btn btn--primary btn--tg btn--sm",
                            disabled: busy,
                            onClick: ()=>void savePermissions(),
                            children: busy ? "Saving\u2026" : "Update permissions"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                className: "form-section-title",
                style: {
                    marginTop: "1.25rem"
                },
                children: "Password"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "console-users-page__pw-cell",
                style: {
                    maxWidth: "22rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        className: "console-users-page__pw-label",
                        htmlFor: `cu-pw-${row.id}`,
                        children: "New password"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                        id: `cu-pw-${row.id}`,
                        type: "password",
                        placeholder: "Min. 8 characters",
                        value: np,
                        onChange: (e)=>setNp(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--tg-secondary btn--sm",
                        disabled: busy || np.length < 8,
                        onClick: ()=>{
                            savePatch({
                                newPassword: np
                            }).then((ok)=>{
                                if (ok) setNp("");
                            });
                        },
                        children: "Set password"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "console-users-manage-panel__danger",
                style: {
                    marginTop: "1.25rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        children: "Danger zone"
                    }),
                    canDeleteRow ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--sm btn--danger",
                        disabled: busy,
                        onClick: ()=>void deleteUser(),
                        children: "Delete user"
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted section-lead section-lead--tight",
                        style: {
                            margin: 0
                        },
                        children: row.id === currentUserId ? "You cannot delete the account you are signed in as." : "Only a superadmin may remove another superadmin."
                    })
                ]
            })
        ]
    });
}
function $9771d1fd83e2b1ce$export$bd7d5434d15e712e() {
    const { user: user, authRequired: authRequired, can: can } = (0, $a4dc0d923ddf5b19$export$1d39dc5b47e56ff0)();
    const [rows, setRows] = (0, $7UyaH.useState)([]);
    const [keys, setKeys] = (0, $7UyaH.useState)([]);
    const [err, setErr] = (0, $7UyaH.useState)(null);
    const [createModalOpen, setCreateModalOpen] = (0, $7UyaH.useState)(false);
    const [manageUserId, setManageUserId] = (0, $7UyaH.useState)(null);
    const [yardOptions, setYardOptions] = (0, $7UyaH.useState)([]);
    const [yardsLoading, setYardsLoading] = (0, $7UyaH.useState)(false);
    const load = (0, $7UyaH.useCallback)(async ()=>{
        setErr(null);
        const base = (0, $3007f8decf026d71$export$4d28219d42798a75)();
        const cfg = await fetch(`${base}/api/auth/config`).then((r)=>r.json());
        setKeys(Array.isArray(cfg.permissionKeys) ? cfg.permissionKeys : []);
        const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${base}/api/console-users`);
        if (res.status === 404) {
            setErr("Console user API is only available when server has CONSOLE_AUTH_REQUIRED=true.");
            setRows([]);
            return;
        }
        if (!res.ok) {
            const j = await res.json().catch(()=>({}));
            setErr(j.error || `Failed to load (${res.status})`);
            setRows([]);
            return;
        }
        setRows(await res.json());
    }, []);
    const loadYardOptions = (0, $7UyaH.useCallback)(async ()=>{
        const base = (0, $3007f8decf026d71$export$4d28219d42798a75)();
        setYardsLoading(true);
        try {
            const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${base}/api/console-users/store-yard-options`);
            if (!res.ok) {
                setYardOptions([]);
                return;
            }
            const j = await res.json();
            setYardOptions(Array.isArray(j) ? j : []);
        } catch  {
            setYardOptions([]);
        } finally{
            setYardsLoading(false);
        }
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        if (user && can("console_users")) load();
    }, [
        user,
        can,
        load
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (user && can("console_users")) loadYardOptions();
    }, [
        user,
        can,
        loadYardOptions
    ]);
    const labelsById = (0, $7UyaH.useMemo)(()=>new Map((0, $eb8205552e563176$export$630e748bcc563e9f).map((x)=>[
                x.id,
                x.label
            ])), []);
    const manageRow = (0, $7UyaH.useMemo)(()=>manageUserId ? rows.find((r)=>r.id === manageUserId) : undefined, [
        manageUserId,
        rows
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (manageUserId && !manageRow) setManageUserId(null);
    }, [
        manageUserId,
        manageRow
    ]);
    const closeCreateModal = (0, $7UyaH.useCallback)(()=>setCreateModalOpen(false), []);
    (0, $7UyaH.useEffect)(()=>{
        if (!createModalOpen && !manageUserId) return;
        const onKey = (e)=>{
            if (e.key === "Escape") {
                closeCreateModal();
                setManageUserId(null);
            }
        };
        window.addEventListener("keydown", onKey);
        return ()=>window.removeEventListener("keydown", onKey);
    }, [
        createModalOpen,
        manageUserId,
        closeCreateModal
    ]);
    if (!authRequired) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "milestone-master-page",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Console users"
                    }
                ],
                title: "Console users",
                subtitle: "HO console accounts are disabled until server authentication is turned on."
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "tab-intro",
                children: [
                    "Enable ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("code", {
                        children: "CONSOLE_AUTH_REQUIRED=true"
                    }),
                    " on the server to manage HO accounts."
                ]
            })
        ]
    });
    if (user && !can("console_users")) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
        to: "/",
        replace: true
    });
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "milestone-master-page",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Console users"
                    }
                ],
                title: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem"
                    },
                    children: [
                        "Console users",
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                            className: "milestone-master__catalog-count",
                            children: rows.length
                        })
                    ]
                }),
                actions: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                    type: "button",
                    className: "btn btn--primary btn--tg btn--sm",
                    onClick: ()=>setCreateModalOpen(true),
                    children: "Add user"
                })
            }),
            err ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "alert alert--danger",
                role: "alert",
                style: {
                    marginBottom: "1rem"
                },
                children: err
            }) : null,
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("section", {
                className: "milestone-master__catalog",
                "aria-labelledby": "console-users-catalog-heading",
                style: {
                    marginTop: "1.75rem"
                },
                children: rows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "milestone-master__empty",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                            className: "milestone-master__empty-title",
                            children: "No console users yet"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                            className: "milestone-master__empty-desc",
                            children: [
                                "Use ",
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                    children: "Add user"
                                }),
                                " to create the first admin or superadmin for this environment."
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                    className: "milestone-master-picker-grid",
                    children: rows.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($9771d1fd83e2b1ce$var$ConsoleUserSummaryCard, {
                            row: r,
                            isActive: manageUserId === r.id,
                            onOpen: ()=>{
                                setCreateModalOpen(false);
                                setManageUserId((prev)=>prev === r.id ? null : r.id);
                            }
                        }, r.id))
                })
            }),
            createModalOpen ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "modal-backdrop",
                role: "presentation",
                onClick: ()=>{
                    closeCreateModal();
                },
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "modal milestone-master-modal console-users-manage-modal",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "console-users-create-title",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "milestone-master-modal__header",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                    id: "console-users-create-title",
                                    className: "milestone-master-modal__title",
                                    children: "Add console user"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--tg-secondary btn--sm",
                                    onClick: closeCreateModal,
                                    children: "Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "milestone-master-modal__body",
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($9771d1fd83e2b1ce$var$AddConsoleUserForm, {
                                keys: keys,
                                labelsById: labelsById,
                                yardOptions: yardOptions,
                                yardsLoading: yardsLoading,
                                currentUserIsSuperadmin: user?.role === "superadmin",
                                onCreated: async ()=>{
                                    closeCreateModal();
                                    await load();
                                }
                            })
                        })
                    ]
                })
            }) : null,
            manageRow ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "modal-backdrop",
                role: "presentation",
                onClick: ()=>{
                    setManageUserId(null);
                },
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "modal milestone-master-modal console-users-manage-modal",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "console-users-manage-title",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "milestone-master-modal__header",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                    id: "console-users-manage-title",
                                    className: "milestone-master-modal__title",
                                    children: "Manage console user"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--tg-secondary btn--sm",
                                    onClick: ()=>setManageUserId(null),
                                    children: "Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "milestone-master-modal__body",
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($9771d1fd83e2b1ce$var$UserManagePanel, {
                                row: manageRow,
                                keys: keys,
                                labelsById: labelsById,
                                yardOptions: yardOptions,
                                yardsLoading: yardsLoading,
                                onSaved: ()=>void load(),
                                onClose: ()=>setManageUserId(null),
                                currentUserId: user?.id ?? "",
                                currentUserIsSuperadmin: user?.role === "superadmin"
                            }, manageRow.id)
                        })
                    ]
                })
            }) : null
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");





/** Trigger a UTF-8 CSV download in the browser (Excel-friendly BOM). */ function $dc744e52b043da5b$export$c6d851d1877b46af(filename, headers, rows) {
    const esc = (cell)=>{
        if (/[",\n\r]/.test(cell)) return `"${cell.replace(/"/g, '""')}"`;
        return cell;
    };
    const body = [
        headers.map(esc).join(","),
        ...rows.map((r)=>r.map(esc).join(","))
    ].join("\r\n");
    const blob = new Blob([
        "\ufeff",
        body
    ], {
        type: "text/csv;charset=utf-8"
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
}


const $7e7ddf1c90cc8b31$var$PAGE_SIZE = 50;
function $7e7ddf1c90cc8b31$var$formatWhen(iso) {
    if (!iso) return "\u2014";
    try {
        return new Date(iso).toLocaleString();
    } catch  {
        return iso;
    }
}
function $7e7ddf1c90cc8b31$var$actionLabel(action) {
    return (0, $33b81a08b9616b5e$export$dab3a70ac2b18cc6)[action] ?? action;
}
function $7e7ddf1c90cc8b31$export$a99ba50f5b455b98() {
    const { user: user, can: can } = (0, $a4dc0d923ddf5b19$export$1d39dc5b47e56ff0)();
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const mayView = Boolean(user && (user.role === "superadmin" || can("audit_log")));
    const [rows, setRows] = (0, $7UyaH.useState)([]);
    const [total, setTotal] = (0, $7UyaH.useState)(0);
    const [page, setPage] = (0, $7UyaH.useState)(0);
    const [loading, setLoading] = (0, $7UyaH.useState)(true);
    const [error, setError] = (0, $7UyaH.useState)(null);
    const [actionFilter, setActionFilter] = (0, $7UyaH.useState)("");
    const [moduleFilter, setModuleFilter] = (0, $7UyaH.useState)("");
    const [userFilter, setUserFilter] = (0, $7UyaH.useState)("");
    const [search, setSearch] = (0, $7UyaH.useState)("");
    const [dateFrom, setDateFrom] = (0, $7UyaH.useState)("");
    const [dateTo, setDateTo] = (0, $7UyaH.useState)("");
    const [filterOptions, setFilterOptions] = (0, $7UyaH.useState)({
        actions: [],
        modules: [],
        users: []
    });
    const load = (0, $7UyaH.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const out = await (0, $33b81a08b9616b5e$export$4c211303ab974432)({
                limit: $7e7ddf1c90cc8b31$var$PAGE_SIZE,
                offset: page * $7e7ddf1c90cc8b31$var$PAGE_SIZE,
                action: actionFilter || undefined,
                module: moduleFilter || undefined,
                userId: userFilter || undefined,
                search: search || undefined,
                dateFrom: dateFrom || undefined,
                dateTo: dateTo || undefined
            });
            setRows(out.rows);
            setTotal(out.total);
        } catch (e) {
            setError(e instanceof Error ? e.message : "Could not load audit log.");
            setRows([]);
            setTotal(0);
        } finally{
            setLoading(false);
        }
    }, [
        page,
        actionFilter,
        moduleFilter,
        userFilter,
        search,
        dateFrom,
        dateTo
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!mayView) return;
        load();
    }, [
        load,
        mayView
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!mayView) return;
        (0, $33b81a08b9616b5e$export$24ad360e9081eb86)().then(setFilterOptions).catch(()=>{});
    }, [
        mayView
    ]);
    (0, $7UyaH.useEffect)(()=>{
        setPage(0);
    }, [
        actionFilter,
        moduleFilter,
        userFilter,
        search,
        dateFrom,
        dateTo
    ]);
    const totalPages = Math.max(1, Math.ceil(total / $7e7ddf1c90cc8b31$var$PAGE_SIZE));
    const exportCsv = ()=>{
        if (rows.length === 0) {
            showToast("No rows to export on this page.", "info");
            return;
        }
        (0, $dc744e52b043da5b$export$c6d851d1877b46af)("audit-log.csv", [
            "Time",
            "User",
            "Email",
            "Role",
            "Action",
            "Module",
            "Summary",
            "Method",
            "Path",
            "Status",
            "IP"
        ], rows.map((r)=>[
                $7e7ddf1c90cc8b31$var$formatWhen(r.occurredAt),
                r.userDisplayName ?? "",
                r.userEmail ?? "",
                r.userRole ?? "",
                $7e7ddf1c90cc8b31$var$actionLabel(r.action),
                r.module ?? "",
                r.summary,
                r.httpMethod ?? "",
                r.httpPath ?? "",
                r.statusCode != null ? String(r.statusCode) : "",
                r.ipAddress ?? ""
            ]));
    };
    const clearFilters = ()=>{
        setActionFilter("");
        setModuleFilter("");
        setUserFilter("");
        setSearch("");
        setDateFrom("");
        setDateTo("");
    };
    const userOptions = (0, $7UyaH.useMemo)(()=>filterOptions.users.map((u)=>({
                id: u.id,
                label: u.displayName ? `${u.displayName} (${u.email})` : u.email
            })), [
        filterOptions.users
    ]);
    if (user && !mayView) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
        to: "/",
        replace: true
    });
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "page-stack",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                title: "Audit log",
                subtitle: "Complete activity trail for the HO console \u2014 sign-in, sign-out, views, creates, updates, deletes, and exports."
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "card",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "card__body",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                            className: "alert alert--info",
                            role: "note",
                            style: {
                                marginTop: 0
                            },
                            children: [
                                "Activity is recorded in three layers: ",
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                    children: "API"
                                }),
                                " (every server request),",
                                " ",
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                    children: "Page opened"
                                }),
                                " (navigation), and ",
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                    children: "UI action"
                                }),
                                " (button clicks, form submits, dropdown/filter changes, file picks). Passwords and tokens are never stored."
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("details", {
                            className: "audit-coverage-details",
                            style: {
                                marginBottom: "1rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("summary", {
                                    style: {
                                        cursor: "pointer",
                                        fontWeight: 600,
                                        color: "#374151"
                                    },
                                    children: "What is covered in the audit log"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("ul", {
                                    style: {
                                        margin: "0.75rem 0 0",
                                        paddingLeft: "1.25rem",
                                        color: "#4b5563",
                                        lineHeight: 1.6
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                    children: "Authentication"
                                                }),
                                                " \u2014 sign in, sign out, failed login, password change"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                    children: "Navigation"
                                                }),
                                                " \u2014 every console page you open"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                    children: "UI actions"
                                                }),
                                                " \u2014 buttons, form submit, filters/dropdowns, file selection, SearchableSelect picks"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                    children: "API \u2014 View"
                                                }),
                                                " \u2014 all GET calls (lists, dossiers, registers, exports metadata)"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                    children: "API \u2014 Create / Update / Delete"
                                                }),
                                                " \u2014 POST, PUT, PATCH, DELETE"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                    children: "API \u2014 Import / Export"
                                                }),
                                                " \u2014 bulk uploads, PDF/CSV generation"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                    children: "Denied access"
                                                }),
                                                " \u2014 blocked requests (401 / 403) when not signed in or forbidden"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                    children: "Modules"
                                                }),
                                                " \u2014 Leads, Applicants, Masters, Procurement, Inventory, Projects, Operations, Console users, Reports, Geo, Timeline, and more"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                    style: {
                                        margin: "0.75rem 0 0",
                                        color: "#6b7280",
                                        fontSize: "0.875rem"
                                    },
                                    children: [
                                        "Not logged (by design): server health check, auth config poll, and session refresh (",
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("code", {
                                            children: "/api/auth/me"
                                        }),
                                        "). Login screen actions are recorded on the server when sign-in is attempted."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "form-grid form-grid--2",
                            style: {
                                marginBottom: "1rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "form-field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "form-field__label",
                                            children: "Search"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                            className: "form-field__input",
                                            value: search,
                                            onChange: (e)=>setSearch(e.target.value),
                                            placeholder: "Summary, email, or API path"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "form-field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "form-field__label",
                                            children: "User"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                                            className: "form-field__input",
                                            value: userFilter,
                                            onChange: (e)=>setUserFilter(e.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                    value: "",
                                                    children: "All users"
                                                }),
                                                userOptions.map((u)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                        value: u.id,
                                                        children: u.label
                                                    }, u.id))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "form-field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "form-field__label",
                                            children: "Action"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                                            className: "form-field__input",
                                            value: actionFilter,
                                            onChange: (e)=>setActionFilter(e.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                    value: "",
                                                    children: "All actions"
                                                }),
                                                filterOptions.actions.map((a)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                        value: a,
                                                        children: $7e7ddf1c90cc8b31$var$actionLabel(a)
                                                    }, a))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "form-field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "form-field__label",
                                            children: "Module"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                                            className: "form-field__input",
                                            value: moduleFilter,
                                            onChange: (e)=>setModuleFilter(e.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                    value: "",
                                                    children: "All modules"
                                                }),
                                                filterOptions.modules.map((m)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                        value: m,
                                                        children: m
                                                    }, m))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "form-field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "form-field__label",
                                            children: "From date"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                            type: "date",
                                            className: "form-field__input",
                                            value: dateFrom,
                                            onChange: (e)=>setDateFrom(e.target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "form-field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "form-field__label",
                                            children: "To date"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                            type: "date",
                                            className: "form-field__input",
                                            value: dateTo,
                                            onChange: (e)=>setDateTo(e.target.value)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                gap: "0.75rem",
                                flexWrap: "wrap",
                                marginBottom: "1rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--secondary",
                                    onClick: ()=>void load(),
                                    disabled: loading,
                                    children: "Refresh"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--secondary",
                                    onClick: clearFilters,
                                    children: "Clear filters"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--secondary",
                                    onClick: exportCsv,
                                    disabled: rows.length === 0,
                                    children: "Export page CSV"
                                })
                            ]
                        }),
                        error ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "alert alert--danger",
                            children: error
                        }) : null,
                        loading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                            className: "text-muted",
                            children: "Loading audit entries\u2026"
                        }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                    className: "text-muted",
                                    style: {
                                        marginBottom: "0.75rem"
                                    },
                                    children: [
                                        total.toLocaleString(),
                                        " total entries \xb7 page ",
                                        page + 1,
                                        " of ",
                                        totalPages
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "table-wrap",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                        className: "data-table",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            children: "Time"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            children: "User"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            children: "Action"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            children: "Module"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            children: "Summary"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            children: "Method"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            children: "Path"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            children: "Status"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                                children: rows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        colSpan: 8,
                                                        className: "text-muted",
                                                        children: "No audit entries match your filters yet."
                                                    })
                                                }) : rows.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                children: $7e7ddf1c90cc8b31$var$formatWhen(r.occurredAt)
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                        children: r.userDisplayName || "\u2014"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                        className: "text-muted",
                                                                        style: {
                                                                            fontSize: "0.8rem"
                                                                        },
                                                                        children: r.userEmail || "\u2014"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                children: $7e7ddf1c90cc8b31$var$actionLabel(r.action)
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                children: r.module || "\u2014"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                title: r.summary,
                                                                children: r.summary
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                children: r.httpMethod || "\u2014"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                title: r.httpPath ?? "",
                                                                style: {
                                                                    maxWidth: 220,
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis"
                                                                },
                                                                children: r.httpPath || "\u2014"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                children: r.statusCode ?? "\u2014"
                                                            })
                                                        ]
                                                    }, r.id))
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        gap: "0.75rem",
                                        marginTop: "1rem",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                            type: "button",
                                            className: "btn btn--secondary",
                                            disabled: page <= 0,
                                            onClick: ()=>setPage((p)=>Math.max(0, p - 1)),
                                            children: "Previous"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                            type: "button",
                                            className: "btn btn--secondary",
                                            disabled: page + 1 >= totalPages,
                                            onClick: ()=>setPage((p)=>p + 1),
                                            children: "Next"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");









const $1664cd5715ac4918$export$9ccfd8554e1bb70a = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
function $1664cd5715ac4918$export$7a720031022d4541(value) {
    return $1664cd5715ac4918$export$9ccfd8554e1bb70a.test(value.trim().toUpperCase());
}
class $1664cd5715ac4918$export$ded463841cb96375 extends Error {
    portalBlocked = true;
    constructor(message){
        super(message);
        this.name = "GstPortalBlockedError";
    }
}
async function $1664cd5715ac4918$export$69d85c6d5b4daf1(gstin) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/gst/verify/${encodeURIComponent(gstin.trim().toUpperCase())}`, {
        cache: "no-store"
    });
    if (!res.ok) {
        let msg = `GST lookup failed (${res.status})`;
        let blocked = false;
        try {
            const j = await res.json();
            if (j.error) msg = j.error;
            if (j.portalBlocked) blocked = true;
        } catch  {}
        if (blocked) throw new $1664cd5715ac4918$export$ded463841cb96375(msg);
        throw new Error(msg);
    }
    return res.json();
}
async function $1664cd5715ac4918$export$ecab5da525f49cb9() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/gst/captcha-session`, {
        cache: "no-store"
    });
    if (!res.ok) {
        let msg = "Could not load CAPTCHA from GST portal.";
        try {
            const j = await res.json();
            if (j.error) msg = j.error;
        } catch  {}
        throw new Error(msg);
    }
    return res.json();
}
async function $1664cd5715ac4918$export$49163e88815ca1d7(sessionId, gstin, captcha) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/gst/verify-captcha`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            sessionId: sessionId,
            gstin: gstin.trim().toUpperCase(),
            captcha: captcha.trim()
        }),
        cache: "no-store"
    });
    if (!res.ok) {
        let msg = `GST verification failed (${res.status})`;
        try {
            const j = await res.json();
            if (j.error) msg = j.error;
        } catch  {}
        throw new Error(msg);
    }
    return res.json();
}




async function $0ef0b8788b7a0d51$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
async function $0ef0b8788b7a0d51$export$dbb309a3036a9a0f(ifsc, signal) {
    const code = String(ifsc ?? "").trim().toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 11);
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/ifsc-lookup/${encodeURIComponent(code)}`, {
        signal: signal
    });
    if (!res.ok) throw new Error(await $0ef0b8788b7a0d51$var$parseError(res));
    return res.json();
}


const $f63bbf83ceaa0aac$var$IFSC_LOOKUP_OK_HINT = "Bank and branch filled from IFSC (you may edit).";
function $f63bbf83ceaa0aac$var$emptyDraft() {
    return {
        id: "",
        ...(0, $85279307e2bde4bc$export$fddc63ff7a5a0fb3)()
    };
}
function $f63bbf83ceaa0aac$var$isFormComplete(d, picks, mode) {
    const gstin = d.gstNumber.trim().toUpperCase();
    if (gstin.length > 0 && !(0, $1664cd5715ac4918$export$7a720031022d4541)(gstin)) return false;
    const aadhaar = (0, $85279307e2bde4bc$export$d8ac17f31f15df5a)(d.aadhaarNumber);
    const ccOk = picks.cc != null || mode === "edit" && Boolean(d.cancelChequeStored);
    const adOk = picks.ad != null || mode === "edit" && Boolean(d.aadharDocStored);
    const udyamOk = picks.udyam != null || mode === "edit" && Boolean(d.udyamMsmeStored);
    const labourOk = picks.labour != null || mode === "edit" && Boolean(d.labourLicenseStored);
    return Boolean(d.contactPersonName.trim() && d.firmName.trim() && d.contactPhone.trim() && /^[0-9]{12}$/.test(aadhaar) && d.bankAccountName.trim() && d.bankBranchName.trim() && d.bankName.trim() && d.bankAccountNumber.trim() && (0, $85279307e2bde4bc$export$5bf1a55ea00136f3)(d.bankIfsc) && ccOk && adOk && udyamOk && labourOk);
}
/* ── GST status badge ───────────────────────────────────────── */ function $f63bbf83ceaa0aac$var$GstStatusBadge({ status: status }) {
    const lower = status.toLowerCase();
    if (lower === "active") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "status-chip status-chip--done",
        style: {
            fontSize: "0.72rem"
        },
        children: "Active"
    });
    if (lower.includes("cancel")) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "status-chip status-chip--danger",
        style: {
            fontSize: "0.72rem"
        },
        children: "Cancelled"
    });
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "status-chip",
        style: {
            fontSize: "0.72rem"
        },
        children: status
    });
}
/* ── GST verified info panel ────────────────────────────────── */ function $f63bbf83ceaa0aac$var$GstVerifiedPanel({ details: details }) {
    const manualOnly = Boolean(details.portalLookupFailed && details.checksumValid);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: `gst-verified-panel${manualOnly ? " gst-verified-panel--manual" : ""}`,
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "gst-verified-panel__header",
                children: manualOnly ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                    className: "gst-verified-panel__title gst-verified-panel__title--warn",
                    children: "GSTIN format OK \u2014 manual entry"
                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("svg", {
                            className: "gst-verified-panel__icon",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("polyline", {
                                points: "20 6 9 17 4 12"
                            })
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                            children: "GST verified"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($f63bbf83ceaa0aac$var$GstStatusBadge, {
                            status: details.gstStatus
                        })
                    ]
                })
            }),
            manualOnly ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "gst-verified-panel__manual-lead",
                children: [
                    "The GST portal did not return business details (it often blocks automated requests). Your GSTIN check digit is valid. Open",
                    " ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("a", {
                        href: "https://services.gst.gov.in/services/quicklinks/searchtxp",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "GST taxpayer search"
                    }),
                    " ",
                    "in a browser, confirm the legal/trade name, then enter the firm name and other fields in Step 2 below."
                ]
            }) : null,
            !manualOnly ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("dl", {
                className: "gst-verified-panel__grid",
                children: [
                    details.legalName && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                children: "Legal name"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                children: details.legalName
                            })
                        ]
                    }),
                    details.tradeName && details.tradeName !== details.legalName && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                children: "Trade name"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                children: details.tradeName
                            })
                        ]
                    }),
                    details.constitutionOfBusiness && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                children: "Constitution"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                children: details.constitutionOfBusiness
                            })
                        ]
                    }),
                    details.taxpayerType && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                children: "Taxpayer type"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                children: details.taxpayerType
                            })
                        ]
                    }),
                    details.registrationDate && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                children: "Registered on"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                children: details.registrationDate
                            })
                        ]
                    }),
                    details.principalAddress && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                children: "Principal address"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                children: details.principalAddress
                            })
                        ]
                    }),
                    details.additionalAddresses && details.additionalAddresses.length > 0 && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                children: "Additional places"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                                    style: {
                                        margin: 0,
                                        paddingLeft: "1.1rem"
                                    },
                                    children: details.additionalAddresses.map((line, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                            children: line
                                        }, i))
                                })
                            })
                        ]
                    }),
                    details.stateJurisdiction && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                children: "State jurisdiction"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                children: details.stateJurisdiction
                            })
                        ]
                    })
                ]
            }) : null
        ]
    });
}
/* ── Form ───────────────────────────────────────────────────── */ function $f63bbf83ceaa0aac$var$SubcontractorForm({ mode: mode, draft: draft, setDraft: setDraft, onSave: onSave, onCancel: onCancel }) {
    const [gstState, setGstState] = (0, $7UyaH.useState)({
        status: "idle"
    });
    const [saveError, setSaveError] = (0, $7UyaH.useState)(null);
    const [saving, setSaving] = (0, $7UyaH.useState)(false);
    const [docPicks, setDocPicks] = (0, $7UyaH.useState)({
        cc: null,
        ad: null,
        gst: null,
        udyam: null,
        labour: null
    });
    const gstInputRef = (0, $7UyaH.useRef)(null);
    /** In-app CAPTCHA: same server session as gst.gov.in search (GET searchtp → captcha → POST). */ const [captchaInline, setCaptchaInline] = (0, $7UyaH.useState)(null);
    const [captchaLoadError, setCaptchaLoadError] = (0, $7UyaH.useState)(null);
    const [captchaLoading, setCaptchaLoading] = (0, $7UyaH.useState)(false);
    const [captchaVerifying, setCaptchaVerifying] = (0, $7UyaH.useState)(false);
    const [ifscLookupHint, setIfscLookupHint] = (0, $7UyaH.useState)(null);
    const [ifscLookupBusy, setIfscLookupBusy] = (0, $7UyaH.useState)(false);
    const gstInputVerifiedClass = gstState.status === "verified" ? "input--verified" : "";
    /* Auto-fill bank name + branch when IFSC is valid (Razorpay directory via our API). */ (0, $7UyaH.useEffect)(()=>{
        const ifsc = draft.bankIfsc.trim().toUpperCase();
        if (!(0, $85279307e2bde4bc$export$5bf1a55ea00136f3)(ifsc)) {
            setIfscLookupHint(null);
            setIfscLookupBusy(false);
            return;
        }
        let cancelled = false;
        const ac = new AbortController();
        setIfscLookupBusy(true);
        setIfscLookupHint(null);
        const debounceTimer = window.setTimeout(()=>{
            (async ()=>{
                try {
                    const r = await (0, $0ef0b8788b7a0d51$export$dbb309a3036a9a0f)(ifsc, ac.signal);
                    if (cancelled) return;
                    setDraft((d)=>{
                        const cur = d.bankIfsc.trim().toUpperCase();
                        if (cur !== ifsc) return d;
                        return {
                            ...d,
                            bankName: r.bankName || d.bankName,
                            bankBranchName: r.branchName || d.bankBranchName
                        };
                    });
                    if (!cancelled) setIfscLookupHint(r.bankName || r.branchName ? $f63bbf83ceaa0aac$var$IFSC_LOOKUP_OK_HINT : null);
                } catch (e) {
                    if (cancelled || e instanceof Error && e.name === "AbortError") return;
                    setIfscLookupHint(e instanceof Error ? e.message : "IFSC lookup failed.");
                } finally{
                    if (!cancelled) setIfscLookupBusy(false);
                }
            })();
        }, 450);
        return ()=>{
            cancelled = true;
            ac.abort();
            window.clearTimeout(debounceTimer);
            setIfscLookupBusy(false);
        };
    }, [
        draft.bankIfsc,
        setDraft
    ]);
    /**
   * Manual refresh / retry — same as initial auto-load.
   * @param clearErrorFirst - set false when chaining after verify failure so the message stays until a new image loads.
   */ async function fetchCaptchaImage(clearErrorFirst = true) {
        const gstin = draft.gstNumber.trim().toUpperCase();
        if (!(0, $1664cd5715ac4918$export$7a720031022d4541)(gstin)) {
            setCaptchaLoadError("Enter a valid 15-character GSTIN first.");
            return;
        }
        if (clearErrorFirst) setCaptchaLoadError(null);
        setCaptchaLoading(true);
        try {
            const { sessionId: sessionId, imageDataUrl: imageDataUrl } = await (0, $1664cd5715ac4918$export$ecab5da525f49cb9)();
            setCaptchaInline({
                sessionId: sessionId,
                imageDataUrl: imageDataUrl,
                answer: ""
            });
            setCaptchaLoadError(null);
        } catch (e) {
            setCaptchaLoadError(e instanceof Error ? e.message : "Could not load CAPTCHA.");
            setCaptchaInline(null);
        } finally{
            setCaptchaLoading(false);
        }
    }
    /* Auto-fetch CAPTCHA when GSTIN becomes valid (no “Load” click). */ (0, $7UyaH.useEffect)(()=>{
        const gstin = draft.gstNumber.trim().toUpperCase();
        if (!(0, $1664cd5715ac4918$export$7a720031022d4541)(gstin)) return;
        let cancelled = false;
        (async ()=>{
            setCaptchaLoadError(null);
            setCaptchaLoading(true);
            try {
                const { sessionId: sessionId, imageDataUrl: imageDataUrl } = await (0, $1664cd5715ac4918$export$ecab5da525f49cb9)();
                if (!cancelled) setCaptchaInline({
                    sessionId: sessionId,
                    imageDataUrl: imageDataUrl,
                    answer: ""
                });
            } catch (e) {
                if (!cancelled) {
                    setCaptchaLoadError(e instanceof Error ? e.message : "Could not load CAPTCHA.");
                    setCaptchaInline(null);
                }
            } finally{
                if (!cancelled) setCaptchaLoading(false);
            }
        })();
        return ()=>{
            cancelled = true;
            setCaptchaLoading(false);
        };
    }, [
        draft.gstNumber
    ]);
    async function handleVerifyWithCaptcha() {
        const gstin = draft.gstNumber.trim().toUpperCase();
        if (!captchaInline || !(0, $1664cd5715ac4918$export$7a720031022d4541)(gstin)) return;
        const answer = captchaInline.answer.trim();
        if (answer.length < 1) {
            setCaptchaLoadError("Type the characters from the image.");
            return;
        }
        setCaptchaLoadError(null);
        setCaptchaVerifying(true);
        try {
            const details = await (0, $1664cd5715ac4918$export$49163e88815ca1d7)(captchaInline.sessionId, gstin, answer);
            setGstState({
                status: "verified",
                details: details
            });
            setCaptchaInline(null);
            setDraft((d)=>{
                const extra = (details.additionalAddresses ?? []).map((x)=>x.trim()).filter(Boolean);
                const addrLines = [
                    details.principalAddress?.trim(),
                    ...extra
                ].filter(Boolean);
                const registeredAddress = addrLines.length ? addrLines.join("\n\n") : d.registeredAddress;
                return {
                    ...d,
                    gstNumber: gstin,
                    firmName: d.firmName.trim() || details.displayName || d.firmName,
                    registeredAddress: registeredAddress
                };
            });
        } catch (e) {
            /* Session is consumed server-side; fetch a new CAPTCHA automatically. */ setCaptchaInline(null);
            setCaptchaLoadError(e instanceof Error ? e.message : "CAPTCHA verification failed.");
            fetchCaptchaImage(false);
        } finally{
            setCaptchaVerifying(false);
        }
    }
    async function handleSave() {
        setSaveError(null);
        if (!$f63bbf83ceaa0aac$var$isFormComplete(draft, docPicks, mode)) return;
        setSaving(true);
        try {
            const base = {
                contactPersonName: draft.contactPersonName.trim(),
                firmName: draft.firmName.trim(),
                registeredAddress: draft.registeredAddress.trim(),
                firmRegistrationId: draft.firmRegistrationId.trim(),
                gstNumber: draft.gstNumber.trim().toUpperCase(),
                contactPhone: draft.contactPhone.trim(),
                contactEmail: draft.contactEmail.trim(),
                aadhaarNumber: (0, $85279307e2bde4bc$export$d8ac17f31f15df5a)(draft.aadhaarNumber),
                bankAccountNumber: draft.bankAccountNumber.trim(),
                bankIfsc: draft.bankIfsc.trim().toUpperCase(),
                bankBranchName: draft.bankBranchName.trim(),
                bankName: draft.bankName.trim(),
                bankAccountName: draft.bankAccountName.trim(),
                cancelChequeFileName: docPicks.cc?.name ?? draft.cancelChequeFileName ?? null,
                cancelChequeStored: draft.cancelChequeStored,
                aadharDocFileName: docPicks.ad?.name ?? draft.aadharDocFileName ?? null,
                aadharDocStored: draft.aadharDocStored,
                gstCertFileName: docPicks.gst?.name ?? draft.gstCertFileName ?? null,
                gstCertStored: draft.gstCertStored,
                udyamMsmeFileName: docPicks.udyam?.name ?? draft.udyamMsmeFileName ?? null,
                udyamMsmeStored: draft.udyamMsmeStored,
                labourLicenseFileName: docPicks.labour?.name ?? draft.labourLicenseFileName ?? null,
                labourLicenseStored: draft.labourLicenseStored
            };
            if (docPicks.cc) {
                const { base64: base64, mimeType: mimeType } = await (0, $b5ec052719425bb9$export$ff9a6fde0c58ad20)(docPicks.cc);
                base.cancelChequeBase64 = base64;
                base.cancelChequeMimeType = mimeType;
            }
            if (docPicks.ad) {
                const { base64: base64, mimeType: mimeType } = await (0, $b5ec052719425bb9$export$ff9a6fde0c58ad20)(docPicks.ad);
                base.aadharDocBase64 = base64;
                base.aadharDocMimeType = mimeType;
            }
            if (docPicks.gst) {
                const { base64: base64, mimeType: mimeType } = await (0, $b5ec052719425bb9$export$ff9a6fde0c58ad20)(docPicks.gst);
                base.gstCertBase64 = base64;
                base.gstCertMimeType = mimeType;
            }
            if (docPicks.udyam) {
                const { base64: base64, mimeType: mimeType } = await (0, $b5ec052719425bb9$export$ff9a6fde0c58ad20)(docPicks.udyam);
                base.udyamMsmeBase64 = base64;
                base.udyamMsmeMimeType = mimeType;
            }
            if (docPicks.labour) {
                const { base64: base64, mimeType: mimeType } = await (0, $b5ec052719425bb9$export$ff9a6fde0c58ad20)(docPicks.labour);
                base.labourLicenseBase64 = base64;
                base.labourLicenseMimeType = mimeType;
            }
            await onSave(base);
        } catch (err) {
            setSaveError(err instanceof Error ? err.message : "Save failed.");
        } finally{
            setSaving(false);
        }
    }
    const gstinUpper = draft.gstNumber.trim().toUpperCase();
    const gstinFormatOk = gstinUpper.length === 0 || (0, $1664cd5715ac4918$export$7a720031022d4541)(gstinUpper);
    const draftComplete = $f63bbf83ceaa0aac$var$isFormComplete(draft, docPicks, mode);
    const apiBase = (0, $3007f8decf026d71$export$4d28219d42798a75)();
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "card card--gov card--elevated",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                className: "card__title card__title--gov",
                children: mode === "new" ? "Register new subcontractor" : "Edit subcontractor"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("h3", {
                className: "form-section-title",
                children: [
                    "Step 1 \u2014 GSTIN verification",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "field-required-note",
                        children: " (optional \u2014 use CAPTCHA when you have a GSTIN)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field field--full gst-verify-row",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: "sc-gst",
                        children: "GSTIN (optional)"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                        id: "sc-gst",
                        ref: gstInputRef,
                        className: [
                            "mono",
                            !gstinFormatOk ? "input--error" : "",
                            gstInputVerifiedClass
                        ].filter(Boolean).join(" "),
                        value: draft.gstNumber,
                        onChange: (e)=>{
                            setDraft((d)=>({
                                    ...d,
                                    gstNumber: e.target.value.toUpperCase(),
                                    registeredAddress: ""
                                }));
                            setGstState({
                                status: "idle"
                            });
                            setCaptchaInline(null);
                            setCaptchaLoadError(null);
                        },
                        placeholder: "e.g. 29ABCDE1234F1Z5",
                        maxLength: 15,
                        autoComplete: "off",
                        spellCheck: false
                    }),
                    !gstinFormatOk && gstinUpper.length > 0 && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "field-hint field-hint--error",
                        children: "Invalid format. GSTIN must be 15 characters: 2 digits + 10-char PAN + 1 digit + Z + 1 char."
                    })
                ]
            }),
            (0, $1664cd5715ac4918$export$7a720031022d4541)(gstinUpper) && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "gst-captcha-inline",
                style: {
                    marginTop: "1rem"
                },
                children: [
                    captchaLoading && !captchaInline ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                        className: "field-hint",
                        style: {
                            margin: 0,
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "0.35rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "spinner spinner--sm",
                                "aria-hidden": "true"
                            }),
                            "Loading CAPTCHA\u2026"
                        ]
                    }) : null,
                    captchaInline ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexWrap: "wrap",
                                    alignItems: "center",
                                    gap: "0.5rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                                        src: captchaInline.imageDataUrl,
                                        alt: "CAPTCHA \u2014 type the characters shown",
                                        style: {
                                            display: "block",
                                            maxHeight: "56px",
                                            borderRadius: "4px",
                                            border: "1px solid var(--gov-border, #e5e7eb)"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--sm btn--link",
                                        onClick: ()=>void fetchCaptchaImage(),
                                        disabled: captchaLoading || captchaVerifying,
                                        children: "Refresh"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "toolbar-row",
                                style: {
                                    flexWrap: "wrap",
                                    gap: "0.5rem",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        id: "gst-captcha-ans",
                                        className: "mono",
                                        placeholder: "Characters from image",
                                        "aria-label": "CAPTCHA answer",
                                        value: captchaInline.answer,
                                        onChange: (e)=>setCaptchaInline((c)=>c ? {
                                                    ...c,
                                                    answer: e.target.value
                                                } : null),
                                        maxLength: 16,
                                        autoComplete: "off",
                                        spellCheck: false,
                                        style: {
                                            maxWidth: "14rem"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--sm btn--primary btn--tg",
                                        onClick: ()=>void handleVerifyWithCaptcha(),
                                        disabled: captchaVerifying || !captchaInline.answer.trim(),
                                        children: captchaVerifying ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                    className: "spinner spinner--sm",
                                                    "aria-hidden": "true"
                                                }),
                                                " Verifying\u2026"
                                            ]
                                        }) : "Submit CAPTCHA & fetch details"
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    captchaLoadError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "field-hint field-hint--error",
                        style: {
                            margin: "0.25rem 0 0"
                        },
                        children: captchaLoadError
                    }) : null,
                    !captchaLoading && !captchaInline && captchaLoadError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--sm btn--tg-secondary",
                        onClick: ()=>void fetchCaptchaImage(),
                        disabled: captchaVerifying,
                        children: "Try again"
                    }) : null
                ]
            }),
            gstState.status === "verified" && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($f63bbf83ceaa0aac$var$GstVerifiedPanel, {
                details: gstState.details
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("h3", {
                className: "form-section-title",
                style: {
                    marginTop: "1.5rem"
                },
                children: [
                    "Step 2 \u2014 Firm, contact & Aadhaar",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "field-required-note",
                        children: " (required fields marked)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field-grid",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                htmlFor: "sc-firm-name",
                                children: [
                                    "Firm / company name ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "required-star",
                                        "aria-hidden": "true",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "sc-firm-name",
                                value: draft.firmName,
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            firmName: e.target.value
                                        })),
                                placeholder: "Firm name (auto-filled from GST verification if used)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field field--full",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: "sc-registered-address",
                                children: "Registered address (from GST)"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                id: "sc-registered-address",
                                value: draft.registeredAddress,
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            registeredAddress: e.target.value
                                        })),
                                placeholder: "Filled after CAPTCHA verification, or type manually",
                                rows: 3,
                                spellCheck: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                htmlFor: "sc-contact-name",
                                children: [
                                    "Authorised contact person ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "required-star",
                                        "aria-hidden": "true",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "sc-contact-name",
                                value: draft.contactPersonName,
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            contactPersonName: e.target.value
                                        }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                htmlFor: "sc-phone",
                                children: [
                                    "Phone ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "required-star",
                                        "aria-hidden": "true",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "sc-phone",
                                value: draft.contactPhone,
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            contactPhone: e.target.value
                                        })),
                                placeholder: "10-digit mobile"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: "sc-email",
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "sc-email",
                                type: "email",
                                value: draft.contactEmail,
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            contactEmail: e.target.value
                                        }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                htmlFor: "sc-aadhaar",
                                children: [
                                    "Aadhaar number ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "required-star",
                                        "aria-hidden": "true",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "sc-aadhaar",
                                className: "mono",
                                inputMode: "numeric",
                                autoComplete: "off",
                                value: draft.aadhaarNumber,
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            aadhaarNumber: (0, $85279307e2bde4bc$export$d8ac17f31f15df5a)(e.target.value)
                                        })),
                                placeholder: "12 digits",
                                maxLength: 14,
                                spellCheck: false
                            }),
                            draft.aadhaarNumber.length > 0 && draft.aadhaarNumber.length < 12 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "field-hint field-hint--error",
                                children: "Enter all 12 digits."
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: "sc-reg-id",
                                children: "Firm registration ID (CIN / LLP-IN)"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "sc-reg-id",
                                className: "mono",
                                value: draft.firmRegistrationId,
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            firmRegistrationId: e.target.value
                                        })),
                                placeholder: "Optional if GSTIN is provided"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("h3", {
                className: "form-section-title",
                style: {
                    marginTop: "1.5rem"
                },
                children: [
                    "Step 3 \u2014 Bank account & KYC documents",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "field-required-note",
                        children: " (required)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "text-muted",
                style: {
                    fontSize: "0.85rem",
                    marginBottom: "0.75rem"
                },
                children: "Enter a valid IFSC to auto-fill bank and branch (public directory). Account holder name, account number, cancelled cheque, Aadhaar document, Udyam/MSME certificate, and labour licence are required. GST certificate is optional. Use PDF or clear photo scans (max size as allowed by your browser)."
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field-grid",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                htmlFor: "sc-bank-acc",
                                children: [
                                    "Account number ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "required-star",
                                        "aria-hidden": "true",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "sc-bank-acc",
                                className: "mono",
                                value: draft.bankAccountNumber,
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            bankAccountNumber: e.target.value
                                        }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                htmlFor: "sc-bank-ifsc",
                                children: [
                                    "IFSC ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "required-star",
                                        "aria-hidden": "true",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "sc-bank-ifsc",
                                className: "mono",
                                value: draft.bankIfsc,
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            bankIfsc: e.target.value.toUpperCase()
                                        })),
                                placeholder: "e.g. SBIN0001234",
                                maxLength: 11,
                                spellCheck: false
                            }),
                            draft.bankIfsc.length > 0 && !(0, $85279307e2bde4bc$export$5bf1a55ea00136f3)(draft.bankIfsc) ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "field-hint field-hint--error",
                                children: "IFSC must be 11 characters: 4 letters, digit 0, then 6 alphanumeric."
                            }) : null,
                            ifscLookupBusy && (0, $85279307e2bde4bc$export$5bf1a55ea00136f3)(draft.bankIfsc.trim().toUpperCase()) ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                className: "field-hint",
                                style: {
                                    marginTop: "0.25rem",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.35rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "spinner spinner--sm",
                                        "aria-hidden": "true"
                                    }),
                                    "Looking up bank\u2026"
                                ]
                            }) : null,
                            ifscLookupHint && !ifscLookupBusy ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: ifscLookupHint === $f63bbf83ceaa0aac$var$IFSC_LOOKUP_OK_HINT ? "field-hint" : "field-hint field-hint--error",
                                style: {
                                    marginTop: "0.25rem"
                                },
                                children: ifscLookupHint
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                htmlFor: "sc-bank-branch",
                                children: [
                                    "Branch name ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "required-star",
                                        "aria-hidden": "true",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "sc-bank-branch",
                                value: draft.bankBranchName,
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            bankBranchName: e.target.value
                                        })),
                                placeholder: "e.g. Habsiguda"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                htmlFor: "sc-bank-inst",
                                children: [
                                    "Bank name ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "required-star",
                                        "aria-hidden": "true",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "sc-bank-inst",
                                value: draft.bankName,
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            bankName: e.target.value
                                        })),
                                placeholder: "e.g. State Bank of India"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field field--full",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                htmlFor: "sc-bank-acc-name",
                                children: [
                                    "Account holder name ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "required-star",
                                        "aria-hidden": "true",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "sc-bank-acc-name",
                                value: draft.bankAccountName,
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            bankAccountName: e.target.value
                                        })),
                                placeholder: "As on passbook or cheque"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field field--full",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                htmlFor: "sc-cancel-cheque",
                                children: [
                                    "Cancelled cheque ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "required-star",
                                        "aria-hidden": "true",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "sc-cancel-cheque",
                                type: "file",
                                accept: ".pdf,image/*",
                                onChange: (e)=>{
                                    const f = e.target.files?.[0] ?? null;
                                    setDocPicks((p)=>({
                                            ...p,
                                            cc: f
                                        }));
                                    if (f) setDraft((d)=>({
                                            ...d,
                                            cancelChequeFileName: f.name
                                        }));
                                }
                            }),
                            docPicks.cc ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                className: "text-muted file-hint",
                                children: [
                                    "Selected: ",
                                    docPicks.cc.name
                                ]
                            }) : draft.cancelChequeStored && draft.id ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "text-muted file-hint",
                                style: {
                                    marginTop: "0.35rem"
                                },
                                children: [
                                    "On file: ",
                                    draft.cancelChequeFileName ?? "attachment",
                                    " ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d3365114b8e87556$export$91ad24bb00ba0809), {
                                        fileUrlBase: `${apiBase}/api/subcontractor-masters/${encodeURIComponent(draft.id)}/cancel-cheque-file`,
                                        fallbackFileName: draft.cancelChequeFileName ?? "cancel-cheque"
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field field--full",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                htmlFor: "sc-aadhar-doc",
                                children: [
                                    "Aadhaar document (scan / PDF) ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "required-star",
                                        "aria-hidden": "true",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "sc-aadhar-doc",
                                type: "file",
                                accept: ".pdf,image/*",
                                onChange: (e)=>{
                                    const f = e.target.files?.[0] ?? null;
                                    setDocPicks((p)=>({
                                            ...p,
                                            ad: f
                                        }));
                                    if (f) setDraft((d)=>({
                                            ...d,
                                            aadharDocFileName: f.name
                                        }));
                                }
                            }),
                            docPicks.ad ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                className: "text-muted file-hint",
                                children: [
                                    "Selected: ",
                                    docPicks.ad.name
                                ]
                            }) : draft.aadharDocStored && draft.id ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "text-muted file-hint",
                                style: {
                                    marginTop: "0.35rem"
                                },
                                children: [
                                    "On file: ",
                                    draft.aadharDocFileName ?? "attachment",
                                    " ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d3365114b8e87556$export$91ad24bb00ba0809), {
                                        fileUrlBase: `${apiBase}/api/subcontractor-masters/${encodeURIComponent(draft.id)}/aadhar-doc-file`,
                                        fallbackFileName: draft.aadharDocFileName ?? "aadhar-doc"
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field field--full",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: "sc-gst-cert",
                                children: "GST registration certificate (optional)"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "sc-gst-cert",
                                type: "file",
                                accept: ".pdf,image/*",
                                onChange: (e)=>{
                                    const f = e.target.files?.[0] ?? null;
                                    setDocPicks((p)=>({
                                            ...p,
                                            gst: f
                                        }));
                                    if (f) setDraft((d)=>({
                                            ...d,
                                            gstCertFileName: f.name
                                        }));
                                }
                            }),
                            docPicks.gst ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                className: "text-muted file-hint",
                                children: [
                                    "Selected: ",
                                    docPicks.gst.name
                                ]
                            }) : draft.gstCertStored && draft.id ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "text-muted file-hint",
                                style: {
                                    marginTop: "0.35rem"
                                },
                                children: [
                                    "On file: ",
                                    draft.gstCertFileName ?? "attachment",
                                    " ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d3365114b8e87556$export$91ad24bb00ba0809), {
                                        fileUrlBase: `${apiBase}/api/subcontractor-masters/${encodeURIComponent(draft.id)}/gst-cert-file`,
                                        fallbackFileName: draft.gstCertFileName ?? "gst-certificate"
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field field--full",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                htmlFor: "sc-udyam-msme",
                                children: [
                                    "Udyam / MSME ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "required-star",
                                        "aria-hidden": "true",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "sc-udyam-msme",
                                type: "file",
                                accept: ".pdf,image/*",
                                onChange: (e)=>{
                                    const f = e.target.files?.[0] ?? null;
                                    setDocPicks((p)=>({
                                            ...p,
                                            udyam: f
                                        }));
                                    if (f) setDraft((d)=>({
                                            ...d,
                                            udyamMsmeFileName: f.name
                                        }));
                                }
                            }),
                            docPicks.udyam ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                className: "text-muted file-hint",
                                children: [
                                    "Selected: ",
                                    docPicks.udyam.name
                                ]
                            }) : draft.udyamMsmeStored && draft.id ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "text-muted file-hint",
                                style: {
                                    marginTop: "0.35rem"
                                },
                                children: [
                                    "On file: ",
                                    draft.udyamMsmeFileName ?? "attachment",
                                    " ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d3365114b8e87556$export$91ad24bb00ba0809), {
                                        fileUrlBase: `${apiBase}/api/subcontractor-masters/${encodeURIComponent(draft.id)}/udyam-msme-file`,
                                        fallbackFileName: draft.udyamMsmeFileName ?? "udyam-msme"
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field field--full",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                htmlFor: "sc-labour-license",
                                children: [
                                    "Labour licence ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "required-star",
                                        "aria-hidden": "true",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: "sc-labour-license",
                                type: "file",
                                accept: ".pdf,image/*",
                                onChange: (e)=>{
                                    const f = e.target.files?.[0] ?? null;
                                    setDocPicks((p)=>({
                                            ...p,
                                            labour: f
                                        }));
                                    if (f) setDraft((d)=>({
                                            ...d,
                                            labourLicenseFileName: f.name
                                        }));
                                }
                            }),
                            docPicks.labour ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                className: "text-muted file-hint",
                                children: [
                                    "Selected: ",
                                    docPicks.labour.name
                                ]
                            }) : draft.labourLicenseStored && draft.id ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "text-muted file-hint",
                                style: {
                                    marginTop: "0.35rem"
                                },
                                children: [
                                    "On file: ",
                                    draft.labourLicenseFileName ?? "attachment",
                                    " ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d3365114b8e87556$export$91ad24bb00ba0809), {
                                        fileUrlBase: `${apiBase}/api/subcontractor-masters/${encodeURIComponent(draft.id)}/labour-license-file`,
                                        fallbackFileName: draft.labourLicenseFileName ?? "labour-license"
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            }),
            saveError && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "alert alert--danger",
                role: "alert",
                style: {
                    marginTop: "0.75rem"
                },
                children: saveError
            }),
            !draftComplete && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "text-muted",
                style: {
                    fontSize: "0.8rem",
                    marginTop: "0.75rem"
                },
                children: "Required: firm and contact details, 12-digit Aadhaar, account number, IFSC, branch name, bank name, account holder name, cancelled cheque, Aadhaar document, Udyam/MSME, and labour licence. If you enter a GSTIN it must be valid. GST certificate is optional."
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "toolbar-row",
                style: {
                    marginTop: "1.25rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--tg-secondary btn--sm",
                        onClick: onCancel,
                        disabled: saving,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--primary btn--tg",
                        onClick: ()=>void handleSave(),
                        disabled: !draftComplete || saving,
                        children: saving ? "Saving\u2026" : "Save firm"
                    })
                ]
            })
        ]
    });
}
function $f63bbf83ceaa0aac$export$62128d46d85dab2f() {
    const { subcontractorMasters: subcontractorMasters, addSubcontractorMaster: addSubcontractorMaster, updateSubcontractorMaster: updateSubcontractorMaster, deleteSubcontractorMaster: deleteSubcontractorMaster } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const [mode, setMode] = (0, $7UyaH.useState)("list");
    const [draft, setDraft] = (0, $7UyaH.useState)($f63bbf83ceaa0aac$var$emptyDraft());
    const sortedMasters = (0, $7UyaH.useMemo)(()=>[
            ...subcontractorMasters
        ].sort((a, b)=>b.createdAt.localeCompare(a.createdAt)), [
        subcontractorMasters
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (mode === "list") setDraft($f63bbf83ceaa0aac$var$emptyDraft());
    }, [
        mode
    ]);
    function startEdit(m) {
        setDraft({
            id: m.id,
            contactPersonName: m.contactPersonName,
            firmName: m.firmName,
            registeredAddress: m.registeredAddress ?? "",
            firmRegistrationId: m.firmRegistrationId,
            gstNumber: m.gstNumber,
            contactPhone: m.contactPhone,
            contactEmail: m.contactEmail,
            aadhaarNumber: m.aadhaarNumber ?? "",
            bankAccountNumber: m.bankAccountNumber,
            bankIfsc: m.bankIfsc,
            bankBranchName: m.bankBranchName ?? "",
            bankName: m.bankName ?? "",
            bankAccountName: m.bankAccountName ?? "",
            cancelChequeFileName: m.cancelChequeFileName ?? null,
            cancelChequeStored: Boolean(m.cancelChequeStored),
            aadharDocFileName: m.aadharDocFileName ?? null,
            aadharDocStored: Boolean(m.aadharDocStored),
            gstCertFileName: m.gstCertFileName ?? null,
            gstCertStored: Boolean(m.gstCertStored),
            udyamMsmeFileName: m.udyamMsmeFileName ?? null,
            udyamMsmeStored: Boolean(m.udyamMsmeStored),
            labourLicenseFileName: m.labourLicenseFileName ?? null,
            labourLicenseStored: Boolean(m.labourLicenseStored)
        });
        setMode("edit");
    }
    async function saveMaster(row) {
        if (mode === "new") {
            const id = await addSubcontractorMaster(row);
            if (!id) return;
        } else if (mode === "edit" && draft.id) {
            const ok = await updateSubcontractorMaster(draft.id, row);
            if (!ok) return;
        }
        setMode("list");
    }
    async function handleDeleteMaster(m) {
        const ok = window.confirm(`Delete \u{201C}${m.firmName}\u{201D} from the subcontractor master list?

Any applicant dossiers linked to this firm will be unlinked (you can pick another firm later). This cannot be undone.`);
        if (!ok) return;
        await deleteSubcontractorMaster(m.id);
    }
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Subcontractor Onboarding"
                    }
                ],
                title: "Subcontractor Onboarding",
                subtitle: "Register and manage firms engaged as subcontractors for Indiramma Indlu beneficiaries."
            }),
            mode === "list" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "toolbar-row",
                        style: {
                            marginTop: 0,
                            marginBottom: "1rem"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            className: "btn btn--primary btn--tg",
                            onClick: ()=>{
                                setDraft($f63bbf83ceaa0aac$var$emptyDraft());
                                setMode("new");
                            },
                            children: "+ Register new subcontractor"
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "card card--flush card--elevated",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "table-toolbar table-toolbar--stack",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "table-toolbar__top",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                        className: "table-toolbar__count",
                                        children: [
                                            subcontractorMasters.length,
                                            " firms onboarded"
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "table-wrap",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                    className: "data-table",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Firm"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Authorised contact"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Phone"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "GSTIN"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Reg. ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {})
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                            children: sortedMasters.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    colSpan: 6,
                                                    className: "data-table__empty",
                                                    children: 'No subcontractors registered yet. Click "Register new subcontractor" to add the first firm.'
                                                })
                                            }) : sortedMasters.map((m)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                className: "table-name",
                                                                children: m.firmName
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: m.contactPersonName
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "mono",
                                                            children: m.contactPhone
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "mono text-muted",
                                                            children: m.gstNumber || "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "mono text-muted",
                                                            children: m.firmRegistrationId || "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    flexWrap: "wrap",
                                                                    gap: "0.35rem",
                                                                    justifyContent: "flex-end"
                                                                },
                                                                children: [
                                                                    m.portalToken && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                                        type: "button",
                                                                        className: "btn btn--tg-secondary btn--sm",
                                                                        onClick: ()=>{
                                                                            const url = `${window.location.origin}/subcontractor-portal/${m.portalToken}`;
                                                                            navigator.clipboard.writeText(url);
                                                                            alert("Portal link copied to clipboard!\n" + url);
                                                                        },
                                                                        children: "Copy Portal Link"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                                        type: "button",
                                                                        className: "btn btn--tg-secondary btn--sm",
                                                                        onClick: ()=>startEdit(m),
                                                                        children: "Edit"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                                        type: "button",
                                                                        className: "btn btn--danger btn--sm",
                                                                        onClick: ()=>void handleDeleteMaster(m),
                                                                        children: "Delete"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }, m.id))
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "section-lead",
                        style: {
                            marginTop: "1.25rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/applications",
                                children: "Applicants"
                            }),
                            " \u2014 ",
                            "open a dossier, then ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Subcontractor"
                            }),
                            " to link an onboarded firm."
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($f63bbf83ceaa0aac$var$SubcontractorForm, {
                mode: mode,
                draft: draft,
                setDraft: setDraft,
                onSave: saveMaster,
                onCancel: ()=>setMode("list")
            }, `${mode}-${draft.id || "new"}`)
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");









function $9cd5f4ec856deb63$export$9fc6857dde1a395() {
    const { id: id } = (0, $265aeae2597a9f58$export$99eaa27ddbbb95ef)();
    const { getById: getById, getSubcontractorMaster: getSubcontractorMaster, refreshApplicationsFromApi: refreshApplicationsFromApi } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const app = id ? getById(id) : undefined;
    const linkedSubMaster = app?.subcontractor.subcontractorMasterId != null ? getSubcontractorMaster(app.subcontractor.subcontractorMasterId) : undefined;
    const linkedSubcontractorName = linkedSubMaster?.firmName?.trim() ?? "";
    (0, $7UyaH.useEffect)(()=>{
        refreshApplicationsFromApi();
    }, [
        id,
        refreshApplicationsFromApi
    ]);
    if (!id || !app) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Beneficiaries",
                        to: "/subcontractor-to-beneficiary"
                    },
                    {
                        label: "Not found"
                    }
                ],
                title: "Application not found",
                subtitle: "Return to the list and choose another beneficiary."
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                to: "/subcontractor-to-beneficiary",
                className: "btn btn--primary btn--tg",
                children: "Back to beneficiaries"
            })
        ]
    });
    const hideBillsMilestonesHub = (0, $656ff0cd812bb926$export$cc5055592eec1498)(app);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "dedicated-subcontractor-link beneficiary-dedicated-hub",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Beneficiaries",
                        to: "/subcontractor-to-beneficiary"
                    },
                    {
                        label: app.mobile.beneficiaryName
                    }
                ],
                title: "Beneficiary detail",
                subtitle: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "dedicated-subcontractor-link__meta",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "mono",
                                    children: app.mobile.applicationId
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    "aria-hidden": "true",
                                    children: "\xb7"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                    children: [
                                        "Sanction ",
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "mono",
                                            children: app.mobile.houseSanctionNumber
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "dedicated-subcontractor-link__title-row",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "dedicated-subcontractor-link__beneficiary-name",
                                    children: app.mobile.beneficiaryName
                                }),
                                app.subcontractor.subcontractorMasterId ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "dedicated-subcontractor-link__title-sep",
                                            "aria-hidden": "true",
                                            children: "\xb7"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "dedicated-subcontractor-link__subcontractor",
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                    className: "dedicated-subcontractor-link__subcontractor-label",
                                                    children: "Subcontractor"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                    className: "dedicated-subcontractor-link__subcontractor-name",
                                                    children: linkedSubcontractorName || "Onboarded firm record not found"
                                                })
                                            ]
                                        })
                                    ]
                                }) : null
                            ]
                        })
                    ]
                }),
                badge: (0, $dcd2d56cbb41ba43$export$40d4c787f5d14e8d)(app)
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "toolbar-row dedicated-subcontractor-link__toolbar",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                        to: "/subcontractor-to-beneficiary",
                        className: "btn btn--tg-secondary btn--sm",
                        children: "\u2190 Back to list"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                        to: `/applications/${app.id}/overview`,
                        className: "btn btn--link btn--sm",
                        children: "Open full dossier (all sections)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                className: "beneficiary-dedicated-hub__section",
                "aria-labelledby": "beneficiary-hub-timeline",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        id: "beneficiary-hub-timeline",
                        className: "beneficiary-dedicated-hub__h",
                        children: "Timeline tracking"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "card card--elevated beneficiary-dedicated-hub__panel beneficiary-dedicated-hub__panel--gantt",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $9fd373c1f367b8f0$export$68caba599735c292), {
                            app: app
                        })
                    })
                ]
            }),
            hideBillsMilestonesHub ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                className: "beneficiary-dedicated-hub__section",
                "aria-labelledby": "beneficiary-hub-deferred",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        id: "beneficiary-hub-deferred",
                        className: "beneficiary-dedicated-hub__h",
                        children: "Bills & milestones"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $f538fcabd282bc5f$export$e8861bab8171d8fe), {
                        title: "Bills & milestones \u2014 coming soon",
                        appId: app.id,
                        body: "Bills and milestone tracking are not available in this console yet \u2014 before or after subcontractor linkage. Open the full dossier from the link above when your office enables these sections."
                    })
                ]
            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                        className: "beneficiary-dedicated-hub__section",
                        "aria-labelledby": "beneficiary-hub-bills",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                id: "beneficiary-hub-bills",
                                className: "beneficiary-dedicated-hub__h",
                                children: "Bills"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "beneficiary-dedicated-hub__lead",
                                children: "Work-done bill references and site officer seeding confirmation."
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $29954f24db05ed49$export$128d59be05bb2760), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                        className: "beneficiary-dedicated-hub__section",
                        "aria-labelledby": "beneficiary-hub-milestones",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                id: "beneficiary-hub-milestones",
                                className: "beneficiary-dedicated-hub__h",
                                children: "Work progress"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "beneficiary-dedicated-hub__lead",
                                children: "Milestone phases from master data \u2014 mark items done and link bills per phase."
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $3ac7a48441ad9014$export$c9202ba29b1b038c), {})
                        ]
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");



var $7UyaH = parcelRequire("7UyaH");



function $52469139a145dbd5$export$c0d26163a8f9c4a2({ open: open, applicationId: applicationId, onClose: onClose }) {
    const { getById: getById, engineerMasters: engineerMasters, updateEngineer: updateEngineer, finalizeEngineer: finalizeEngineer } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const [linkError, setLinkError] = (0, $7UyaH.useState)(null);
    const app = applicationId ? getById(applicationId) : undefined;
    (0, $7UyaH.useEffect)(()=>{
        if (!open) setLinkError(null);
    }, [
        open
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!open) return;
        const onKey = (e)=>{
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", onKey);
        return ()=>window.removeEventListener("keydown", onKey);
    }, [
        open,
        onClose
    ]);
    if (!open || !applicationId || !app) return null;
    const link = app.engineer;
    const selectedMaster = (0, $f34886e55d1cc894$export$2a0dc13f7a78d8d8)(engineerMasters, link.engineerMasterId);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
        className: "modal-backdrop",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
            className: "modal modal--assign-subcontractor",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "eng-assign-modal-title",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                    id: "eng-assign-modal-title",
                    children: "Assign engineer"
                }),
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                    className: "modal__lede",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                            className: "table-name",
                            children: app.mobile.beneficiaryName
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                            className: "text-muted",
                            "aria-hidden": "true",
                            children: [
                                " ",
                                "\xb7",
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                            className: "mono text-muted",
                            children: app.mobile.applicationId
                        })
                    ]
                }),
                linkError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                    className: "alert alert--danger",
                    role: "alert",
                    children: linkError
                }) : null,
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                    className: "form-section-title",
                    children: "Engineer master"
                }),
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "field field--full",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                            htmlFor: "eng-assign-master-select",
                            children: "Onboarded engineer"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                            id: "eng-assign-master-select",
                            value: link.engineerMasterId ?? "",
                            onChange: (e)=>{
                                setLinkError(null);
                                const v = e.target.value;
                                updateEngineer(app.id, {
                                    engineerMasterId: v === "" ? null : v
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                    value: "",
                                    children: "\u2014 Select an engineer \u2014"
                                }),
                                engineerMasters.map((m)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("option", {
                                        value: m.id,
                                        children: [
                                            m.fullName,
                                            m.phone ? ` \xb7 ${m.phone}` : ""
                                        ]
                                    }, m.id))
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                            className: "text-muted",
                            style: {
                                marginTop: "0.35rem",
                                fontSize: "0.8125rem"
                            },
                            children: [
                                "Missing someone?",
                                " ",
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                    to: "/engineer-onboarding",
                                    className: "btn btn--link btn--sm",
                                    style: {
                                        padding: 0,
                                        verticalAlign: "baseline"
                                    },
                                    children: "Engineer onboarding"
                                })
                            ]
                        })
                    ]
                }),
                selectedMaster ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "subcontractor-firm-panel subcontractor-firm-panel--compact",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h4", {
                            className: "form-section-title",
                            children: "Selected engineer (read-only)"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("dl", {
                            className: "summary-dl",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                    children: "Phone"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                    children: selectedMaster.phone || "\u2014"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                    children: String(selectedMaster.email ?? "").trim() || "\u2014"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                    children: "Employee code"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                    className: "mono",
                                    children: String(selectedMaster.employeeCode ?? "").trim() || "\u2014"
                                })
                            ]
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                    className: "text-muted",
                    style: {
                        fontSize: "0.8125rem",
                        marginBottom: 0
                    },
                    children: [
                        "Use",
                        " ",
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                            to: `/applications/${app.id}/engineer`,
                            state: {
                                from: "beneficiaries"
                            },
                            children: "Open dossier \u2014 Engineer tab"
                        }),
                        " ",
                        "for the full screen. Click below to record the assignment once an engineer is selected."
                    ]
                }),
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "modal__actions",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            className: "btn",
                            onClick: onClose,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            className: "btn btn--primary btn--tg",
                            onClick: async ()=>{
                                setLinkError(null);
                                const master = (0, $f34886e55d1cc894$export$2a0dc13f7a78d8d8)(engineerMasters, link.engineerMasterId);
                                if (!(0, $f34886e55d1cc894$export$2654cb00f18a4c7)(link, master)) {
                                    setLinkError("Choose an engineer from the master list (name and phone required). Register them under Engineer onboarding first if they are not listed.");
                                    return;
                                }
                                const ok = await finalizeEngineer(app.id);
                                if (ok) onClose();
                            },
                            children: link.linkedAt ? "Update assignment" : "Record engineer"
                        })
                    ]
                })
            ]
        })
    });
}






var $7UyaH = parcelRequire("7UyaH");






function $b228cca8e418115f$export$f4624f34b5a79389({ open: open, applicationId: applicationId, onClose: onClose }) {
    const { getById: getById, subcontractorMasters: subcontractorMasters, updateSubcontractor: updateSubcontractor, finalizeSubcontractor: finalizeSubcontractor } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const [linkError, setLinkError] = (0, $7UyaH.useState)(null);
    const fileInputRef = (0, $7UyaH.useRef)(null);
    const app = applicationId ? getById(applicationId) : undefined;
    (0, $7UyaH.useEffect)(()=>{
        if (!open) setLinkError(null);
    }, [
        open
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!open) return;
        const onKey = (e)=>{
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", onKey);
        return ()=>window.removeEventListener("keydown", onKey);
    }, [
        open,
        onClose
    ]);
    if (!open || !applicationId || !app) return null;
    const link = app.subcontractor;
    const selectedMaster = (0, $85279307e2bde4bc$export$87d4bc3ee3ec5ea2)(subcontractorMasters, link.subcontractorMasterId);
    const workOrderFileApiBase = `${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/applications/${encodeURIComponent(app.id)}/work-order-file`;
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
        className: "modal-backdrop",
        role: "presentation",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
            className: "modal modal--assign-subcontractor",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "sub-assign-modal-title",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                    id: "sub-assign-modal-title",
                    children: "Assign subcontractor"
                }),
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                    className: "modal__lede",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                            className: "table-name",
                            children: app.mobile.beneficiaryName
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                            className: "text-muted",
                            "aria-hidden": "true",
                            children: [
                                " ",
                                "\xb7",
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                            className: "mono text-muted",
                            children: app.mobile.applicationId
                        })
                    ]
                }),
                linkError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                    className: "alert alert--danger",
                    role: "alert",
                    children: linkError
                }) : null,
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                    className: "form-section-title",
                    children: "Registered firm"
                }),
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "field field--full",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                            htmlFor: "sub-assign-master-select",
                            children: "Onboarded subcontractor"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                            id: "sub-assign-master-select",
                            value: link.subcontractorMasterId ?? "",
                            onChange: (e)=>{
                                setLinkError(null);
                                const v = e.target.value;
                                updateSubcontractor(app.id, {
                                    subcontractorMasterId: v === "" ? null : v
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                    value: "",
                                    children: "\u2014 Select an onboarded firm \u2014"
                                }),
                                subcontractorMasters.map((m)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("option", {
                                        value: m.id,
                                        children: [
                                            m.firmName,
                                            m.contactPhone ? ` \xb7 ${m.contactPhone}` : ""
                                        ]
                                    }, m.id))
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                            className: "text-muted",
                            style: {
                                marginTop: "0.35rem",
                                fontSize: "0.8125rem"
                            },
                            children: [
                                "Missing a firm?",
                                " ",
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                    to: "/subcontractor-onboarding",
                                    className: "btn btn--link btn--sm",
                                    style: {
                                        padding: 0,
                                        verticalAlign: "baseline"
                                    },
                                    children: "Subcontractor Onboarding"
                                })
                            ]
                        })
                    ]
                }),
                selectedMaster ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "subcontractor-firm-panel subcontractor-firm-panel--compact",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h4", {
                            className: "form-section-title",
                            children: "Selected firm (read-only)"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("dl", {
                            className: "summary-dl",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                    children: "Authorised contact"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                    children: selectedMaster.contactPersonName
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                    children: "Registration / GSTIN"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                    className: "mono",
                                    children: selectedMaster.firmRegistrationId.trim() || selectedMaster.gstNumber.trim() || "\u2014"
                                })
                            ]
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                    className: "form-section-title",
                    children: "Engagement for this beneficiary"
                }),
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "field field--full",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                            htmlFor: "sub-assign-work-order",
                            children: "Work order / engagement letter (scan)"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                            id: "sub-assign-work-order",
                            ref: fileInputRef,
                            type: "file",
                            accept: ".pdf,image/*",
                            onChange: (e)=>{
                                setLinkError(null);
                                const f = e.target.files?.[0];
                                updateSubcontractor(app.id, {
                                    workOrderFileName: f?.name ?? null
                                });
                            }
                        }),
                        link.workOrderFileName ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                            className: "text-muted file-hint",
                            children: [
                                "On file: ",
                                link.workOrderFileName
                            ]
                        }) : null,
                        link.workOrderFileStored ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "text-muted file-hint",
                            style: {
                                marginTop: "0.5rem"
                            },
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d3365114b8e87556$export$91ad24bb00ba0809), {
                                fileUrlBase: workOrderFileApiBase,
                                fallbackFileName: link.workOrderFileName ?? "work-order"
                            })
                        }) : null
                    ]
                }),
                link.workOrderFileStored ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                    className: "text-muted",
                    style: {
                        fontSize: "0.8125rem",
                        marginBottom: 0
                    },
                    children: [
                        "Work order is on the server (Download / View above). Or pick a new file. Full screen:",
                        " ",
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                            to: `/subcontractor-to-beneficiary/${app.id}`,
                            children: "Open"
                        }),
                        "."
                    ]
                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                    className: "text-muted",
                    style: {
                        fontSize: "0.8125rem",
                        marginBottom: 0
                    },
                    children: [
                        "Required: a firm from the list. Work order file is optional. Use",
                        " ",
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                            to: `/subcontractor-to-beneficiary/${app.id}`,
                            children: "Open"
                        }),
                        " for the full linkage screen if needed."
                    ]
                }),
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "modal__actions",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            className: "btn",
                            onClick: onClose,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            className: "btn btn--primary btn--tg",
                            onClick: ()=>{
                                (async ()=>{
                                    setLinkError(null);
                                    const master = (0, $85279307e2bde4bc$export$87d4bc3ee3ec5ea2)(subcontractorMasters, link.subcontractorMasterId);
                                    let filePayload;
                                    const f = fileInputRef.current?.files?.[0];
                                    if (f) try {
                                        const r = await (0, $b5ec052719425bb9$export$ff9a6fde0c58ad20)(f);
                                        filePayload = {
                                            workOrderFileBase64: r.base64,
                                            workOrderMimeType: r.mimeType
                                        };
                                    } catch  {
                                        setLinkError("Could not read the selected file.");
                                        return;
                                    }
                                    const effective = filePayload ? {
                                        ...link,
                                        ...filePayload
                                    } : link;
                                    if (!(0, $85279307e2bde4bc$export$148e14a666d94fa1)(effective, master)) {
                                        setLinkError("Choose a subcontractor from the onboarded list. Register the firm under Subcontractor Onboarding first if it is not listed.");
                                        return;
                                    }
                                    const ok = await finalizeSubcontractor(app.id, filePayload);
                                    if (ok) onClose();
                                    else setLinkError("Choose a subcontractor from the onboarded list. Register the firm under Subcontractor Onboarding first if it is not listed.");
                                })();
                            },
                            children: app.status === "subcontractor_linked" ? "Update linkage" : "Record subcontractor"
                        })
                    ]
                })
            ]
        })
    });
}








/** Only these pipeline stages appear on Beneficiaries (subcontractor assignment). */ const $8a6ae70d07a85836$var$BENEFICIARY_LIST_STATUSES = [
    "icici_recorded",
    "subcontractor_linked"
];
const $8a6ae70d07a85836$var$STATUS_FILTER_OPTIONS = [
    {
        value: "all",
        label: "Awaiting + linked"
    },
    {
        value: "icici_recorded",
        label: "Awaiting subcontractor"
    },
    {
        value: "subcontractor_linked",
        label: "Subcontractor linked"
    }
];
function $8a6ae70d07a85836$var$statusBadge(status) {
    if (status === "on_hold") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "badge badge--hold",
        children: "On hold"
    });
    if (status === "subcontractor_linked") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "badge badge--complete",
        children: "Subcontractor linked"
    });
    if (status === "icici_recorded") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "badge badge--banking",
        children: "Awaiting subcontractor"
    });
    if (status === "ready_for_mou") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "badge badge--progress",
        children: "Ready for MOU"
    });
    if (status === "ready_for_icici") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "badge badge--progress",
        children: "Ready for ICICI"
    });
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "badge badge--pending",
        children: "Pending validation"
    });
}
function $8a6ae70d07a85836$export$58495764dc65e71f() {
    const { store: geoStore } = (0, $60dd8507bac67e50$export$5ec0231075ddedf1)();
    const { applications: applications, getSubcontractorMaster: getSubcontractorMaster, getEngineerMaster: getEngineerMaster } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const [search, setSearch] = (0, $7UyaH.useState)("");
    const [statusFilter, setStatusFilter] = (0, $7UyaH.useState)("all");
    const [districtFilter, setDistrictFilter] = (0, $7UyaH.useState)("");
    const [mandalFilter, setMandalFilter] = (0, $7UyaH.useState)("");
    const [villageFilter, setVillageFilter] = (0, $7UyaH.useState)("");
    const [assignSubcontractorForId, setAssignSubcontractorForId] = (0, $7UyaH.useState)(null);
    const [assignEngineerForId, setAssignEngineerForId] = (0, $7UyaH.useState)(null);
    const eligible = (0, $7UyaH.useMemo)(()=>applications.filter((a)=>$8a6ae70d07a85836$var$BENEFICIARY_LIST_STATUSES.includes(a.status)), [
        applications
    ]);
    const filtered = (0, $7UyaH.useMemo)(()=>{
        const q = search.trim().toLowerCase();
        return eligible.filter((a)=>{
            if (q) {
                const haystack = [
                    a.mobile.applicationId,
                    a.mobile.beneficiaryName,
                    a.mobile.houseSanctionNumber
                ].join(" ").toLowerCase();
                if (!haystack.includes(q)) return false;
            }
            if (statusFilter !== "all" && a.status !== statusFilter) return false;
            if (!(0, $3dfb08dca289a72c$export$33348b06a055dcbd)(a, {
                district: districtFilter,
                mandal: mandalFilter,
                village: villageFilter
            }, geoStore)) return false;
            return true;
        });
    }, [
        eligible,
        search,
        statusFilter,
        districtFilter,
        mandalFilter,
        villageFilter,
        geoStore
    ]);
    const hasFilters = search.trim() !== "" || statusFilter !== "all" || districtFilter !== "" || mandalFilter !== "" || villageFilter !== "";
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Beneficiaries"
                    }
                ],
                title: "Beneficiaries"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "section-lead",
                style: {
                    marginBottom: "1rem"
                },
                children: [
                    "Pick a beneficiary below to link a registered firm (work order upload is optional) and, when unlocked, assign a site engineer from ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                        to: "/engineer-onboarding",
                        children: "Engineer onboarding"
                    }),
                    ". Register firms under",
                    " ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                        to: "/subcontractor-onboarding",
                        children: "Subcontractor"
                    }),
                    " if needed. For earlier pipeline stages use",
                    " ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                        to: "/applications",
                        children: "Applicants"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--flush card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "table-toolbar table-toolbar--stack",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "table-toolbar__top",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "table-toolbar__count",
                                        children: hasFilters ? `${filtered.length} of ${eligible.length} beneficiaries` : `${eligible.length} beneficiaries`
                                    }),
                                    hasFilters ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--link btn--sm table-toolbar__clear",
                                        onClick: ()=>{
                                            setSearch("");
                                            setStatusFilter("all");
                                            setDistrictFilter("");
                                            setMandalFilter("");
                                            setVillageFilter("");
                                        },
                                        children: "Clear filters"
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "table-filters-grid",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "table-filters table-filters--beneficiary-row",
                                        role: "search",
                                        "aria-label": "Filter beneficiaries",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "field table-filters__field table-filters__field--grow",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                        htmlFor: "sub-ben-search",
                                                        children: "Search"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        id: "sub-ben-search",
                                                        type: "search",
                                                        placeholder: "Application ID, beneficiary, or sanction ref.",
                                                        value: search,
                                                        onChange: (e)=>setSearch(e.target.value),
                                                        autoComplete: "off"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "field table-filters__field",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                        htmlFor: "sub-ben-status",
                                                        children: "Pipeline status"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("select", {
                                                        id: "sub-ben-status",
                                                        value: statusFilter,
                                                        onChange: (e)=>setStatusFilter(e.target.value),
                                                        children: $8a6ae70d07a85836$var$STATUS_FILTER_OPTIONS.map((o)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                                value: o.value,
                                                                children: o.label
                                                            }, o.value))
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "table-filters table-filters--geo-row",
                                        "aria-label": "Location filters",
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $0377fbce5921ee00$export$b3eb1a6c17723c14), {
                                            idPrefix: "sub-ben-geo",
                                            district: districtFilter,
                                            mandal: mandalFilter,
                                            village: villageFilter,
                                            onDistrictChange: (d)=>{
                                                setDistrictFilter(d);
                                                setMandalFilter("");
                                                setVillageFilter("");
                                            },
                                            onMandalChange: (m)=>{
                                                setMandalFilter(m);
                                                setVillageFilter("");
                                            },
                                            onVillageChange: setVillageFilter
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "table-wrap",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                            className: "data-table",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Application ID"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Beneficiary"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Sanction ref."
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "District"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Mandal"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Village"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Pipeline status"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Subcontractor"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Engineer"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                    children: eligible.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                            colSpan: 10,
                                            className: "data-table__empty",
                                            children: [
                                                "No beneficiaries are in ",
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                    children: "Awaiting subcontractor"
                                                }),
                                                " or",
                                                " ",
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                    children: "Subcontractor linked"
                                                }),
                                                " yet. Earlier pipeline stages stay in",
                                                " ",
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                                    to: "/applications",
                                                    children: "Applicants"
                                                }),
                                                "."
                                            ]
                                        })
                                    }) : filtered.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                            colSpan: 10,
                                            className: "data-table__empty",
                                            children: "No beneficiaries match the current filters."
                                        })
                                    }) : filtered.map((a)=>{
                                        const mid = a.subcontractor.subcontractorMasterId;
                                        const master = mid ? getSubcontractorMaster(mid) : undefined;
                                        const assigned = (0, $85279307e2bde4bc$export$148e14a666d94fa1)(a.subcontractor, master) && Boolean(a.subcontractor.linkedAt);
                                        const canAssign = (0, $85279307e2bde4bc$export$3cda207770a484f5)(a);
                                        const eid = a.engineer?.engineerMasterId;
                                        const engMaster = eid ? getEngineerMaster(eid) : undefined;
                                        const eng = a.engineer ?? {
                                            engineerMasterId: null
                                        };
                                        const engineerAssigned = (0, $f34886e55d1cc894$export$2654cb00f18a4c7)(eng, engMaster) && Boolean(eng.linkedAt);
                                        const canAssignEng = (0, $f34886e55d1cc894$export$4ec30dfd1501cd30)(a);
                                        return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "mono",
                                                    children: a.mobile.applicationId
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "table-name",
                                                        children: (0, $458840b99c021cb6$export$bb1029bec19025fd)(a.mobile.beneficiaryName)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "mono text-muted",
                                                    children: a.mobile.houseSanctionNumber
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: (0, $458840b99c021cb6$export$bb1029bec19025fd)(geoStore?.findDistrict(a.district)?.registrationDistrictName ?? a.district)
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: (0, $458840b99c021cb6$export$bb1029bec19025fd)(a.mandal)
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: (0, $458840b99c021cb6$export$bb1029bec19025fd)(a.village)
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: $8a6ae70d07a85836$var$statusBadge(a.status)
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: assigned ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "table-name",
                                                        children: (0, $458840b99c021cb6$export$bb1029bec19025fd)(master?.firmName) || "\u2014"
                                                    }) : canAssign ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "btn btn--secondary btn--sm btn--tg",
                                                        onClick: ()=>{
                                                            setAssignEngineerForId(null);
                                                            setAssignSubcontractorForId(a.id);
                                                        },
                                                        children: "Assign"
                                                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "text-muted",
                                                        title: "Complete ICICI, MOU, and bill checks before assigning.",
                                                        children: "Locked"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: engineerAssigned ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "table-name",
                                                        children: (0, $458840b99c021cb6$export$bb1029bec19025fd)(engMaster?.fullName) || "\u2014"
                                                    }) : canAssignEng ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "btn btn--secondary btn--sm btn--tg",
                                                        onClick: ()=>{
                                                            setAssignSubcontractorForId(null);
                                                            setAssignEngineerForId(a.id);
                                                        },
                                                        children: "Assign"
                                                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "text-muted",
                                                        title: "Complete ICICI, MOU, and bill checks before assigning (same gate as subcontractor).",
                                                        children: "Locked"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                                        to: `/applications/${a.id}/subcontractor`,
                                                        state: {
                                                            from: "beneficiaries"
                                                        },
                                                        className: "btn btn--primary btn--sm btn--tg",
                                                        children: "Open"
                                                    })
                                                })
                                            ]
                                        }, a.id);
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $b228cca8e418115f$export$f4624f34b5a79389), {
                open: assignSubcontractorForId !== null,
                applicationId: assignSubcontractorForId,
                onClose: ()=>setAssignSubcontractorForId(null)
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $52469139a145dbd5$export$c0d26163a8f9c4a2), {
                open: assignEngineerForId !== null,
                applicationId: assignEngineerForId,
                onClose: ()=>setAssignEngineerForId(null)
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");




function $ad328e6d26f1f2b9$var$emptyDraft() {
    return {
        fullName: "",
        phone: "",
        email: "",
        employeeCode: "",
        notes: ""
    };
}
function $ad328e6d26f1f2b9$export$54edeae681eb7b81() {
    const { engineerMasters: engineerMasters, addEngineerMaster: addEngineerMaster, updateEngineerMaster: updateEngineerMaster, deleteEngineerMaster: deleteEngineerMaster } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const [mode, setMode] = (0, $7UyaH.useState)("list");
    const [editingId, setEditingId] = (0, $7UyaH.useState)(null);
    const [draft, setDraft] = (0, $7UyaH.useState)($ad328e6d26f1f2b9$var$emptyDraft());
    const [deletingId, setDeletingId] = (0, $7UyaH.useState)(null);
    const sorted = (0, $7UyaH.useMemo)(()=>[
            ...engineerMasters
        ].sort((a, b)=>b.createdAt.localeCompare(a.createdAt)), [
        engineerMasters
    ]);
    function startNew() {
        setDraft($ad328e6d26f1f2b9$var$emptyDraft());
        setEditingId(null);
        setMode("new");
    }
    function startEdit(m) {
        setEditingId(m.id);
        setDraft({
            fullName: m.fullName,
            phone: m.phone,
            email: m.email,
            employeeCode: m.employeeCode,
            notes: m.notes
        });
        setMode("edit");
    }
    async function save() {
        if (!draft.fullName.trim() || !draft.phone.trim()) {
            showToast("Full name and phone are required.", "error");
            return;
        }
        if (mode === "new") {
            const id = await addEngineerMaster(draft);
            if (!id) return;
        } else if (mode === "edit" && editingId) {
            const ok = await updateEngineerMaster(editingId, draft);
            if (!ok) return;
        }
        setMode("list");
        setEditingId(null);
        setDraft($ad328e6d26f1f2b9$var$emptyDraft());
    }
    async function remove(id) {
        setDeletingId(id);
        try {
            await deleteEngineerMaster(id);
        } finally{
            setDeletingId(null);
        }
    }
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Engineer onboarding"
                    }
                ],
                title: "Engineer onboarding"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "section-lead",
                children: [
                    "Register site engineers for assignment to beneficiaries. This list is separate from",
                    " ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                        to: "/agent-master",
                        children: "Agent master"
                    }),
                    ". Assign engineers from the ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                        to: "/subcontractor-to-beneficiary",
                        children: "Beneficiaries"
                    }),
                    " list."
                ]
            }),
            mode === "list" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--flush card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "table-toolbar table-toolbar--stack",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "table-toolbar__top",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                    className: "table-toolbar__count",
                                    children: [
                                        sorted.length,
                                        " engineer(s)"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--primary btn--tg",
                                    onClick: startNew,
                                    children: "Add engineer"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "table-wrap",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                            className: "data-table",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Name"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Phone"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Email"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Employee code"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                    children: sorted.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                            colSpan: 5,
                                            className: "data-table__empty",
                                            children: [
                                                "No engineers yet. Click ",
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                    children: "Add engineer"
                                                }),
                                                "."
                                            ]
                                        })
                                    }) : sorted.map((m)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: m.fullName
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "mono",
                                                    children: m.phone
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: m.email || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "mono",
                                                    children: m.employeeCode || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "btn btn--secondary btn--sm btn--tg",
                                                            onClick: ()=>startEdit(m),
                                                            children: "Edit"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "btn btn--secondary btn--sm btn--tg",
                                                            disabled: deletingId === m.id,
                                                            onClick: ()=>remove(m.id),
                                                            children: deletingId === m.id ? "Removing\u2026" : "Remove"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, m.id))
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        children: mode === "new" ? "New engineer" : "Edit engineer"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field-grid",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "field field--full",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        children: "Full name"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control",
                                        value: draft.fullName,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    fullName: e.target.value
                                                })),
                                        autoComplete: "off"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        children: "Phone"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control mono",
                                        value: draft.phone,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    phone: e.target.value
                                                })),
                                        autoComplete: "off"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control",
                                        value: draft.email,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    email: e.target.value
                                                })),
                                        autoComplete: "off"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        children: "Employee code"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control mono",
                                        value: draft.employeeCode,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    employeeCode: e.target.value
                                                })),
                                        autoComplete: "off"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "field field--full",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        children: "Notes"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                        className: "form-control",
                                        rows: 3,
                                        value: draft.notes,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    notes: e.target.value
                                                }))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "toolbar-row",
                        style: {
                            marginTop: "1rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--secondary btn--tg",
                                onClick: ()=>setMode("list"),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--primary btn--tg",
                                onClick: ()=>void save(),
                                children: "Save"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");



function $25689008152b31ee$export$f10ed0ec243a688c() {
    const { applications: applications, milestoneTemplates: milestoneTemplates } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const [show, setShow] = (0, $7UyaH.useState)("open");
    const templateById = (0, $7UyaH.useMemo)(()=>new Map(milestoneTemplates.map((t)=>[
                t.id,
                t
            ])), [
        milestoneTemplates
    ]);
    const rows = (0, $7UyaH.useMemo)(()=>{
        const list = [];
        for (const a of applications)for (const p of a.milestoneProgress){
            const tpl = templateById.get(p.templateId);
            if (!tpl) continue;
            const itemsTotal = tpl.items.length;
            const itemsDone = tpl.items.filter((it)=>{
                const ip = p.itemProgress.find((x)=>x.templateItemId === it.id);
                return Boolean(ip?.completedAt);
            }).length;
            list.push({
                key: `${a.id}-${p.templateId}`,
                appId: a.id,
                beneficiaryName: a.mobile.beneficiaryName,
                applicationId: a.mobile.applicationId,
                templateId: p.templateId,
                templateTitle: tpl.title,
                phaseOpen: !p.milestoneCompletedAt,
                itemsDone: itemsDone,
                itemsTotal: itemsTotal
            });
        }
        const filtered = show === "open" ? list.filter((r)=>r.phaseOpen) : list;
        filtered.sort((a, b)=>{
            if (a.phaseOpen !== b.phaseOpen) return a.phaseOpen ? -1 : 1;
            if (a.itemsDone / Math.max(1, a.itemsTotal) !== b.itemsDone / Math.max(1, b.itemsTotal)) return a.itemsDone / Math.max(1, a.itemsTotal) - b.itemsDone / Math.max(1, b.itemsTotal);
            return a.beneficiaryName.localeCompare(b.beneficiaryName);
        });
        return filtered;
    }, [
        applications,
        templateById,
        show
    ]);
    const openPhaseCount = (0, $7UyaH.useMemo)(()=>applications.reduce((n, a)=>n + a.milestoneProgress.filter((p)=>!p.milestoneCompletedAt).length, 0), [
        applications
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Milestones"
                    }
                ],
                title: "Milestones",
                subtitle: "Master milestone templates apply to every file. This table shows progress per beneficiary and phase."
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "help-banner help-banner--info",
                style: {
                    marginBottom: "1rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Master data"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        style: {
                            margin: "0.35rem 0 0"
                        },
                        children: [
                            "Edit phases and required items under ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/milestone-master",
                                children: "Milestone master"
                            }),
                            ". Changes apply to all beneficiaries."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "toolbar-row",
                style: {
                    marginBottom: "1rem",
                    flexWrap: "wrap",
                    gap: "0.75rem"
                },
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "field field-inline",
                    style: {
                        marginBottom: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                            htmlFor: "ms-filter",
                            children: "Show"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                            id: "ms-filter",
                            value: show,
                            onChange: (e)=>setShow(e.target.value),
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("option", {
                                    value: "open",
                                    children: [
                                        "Open phases only (",
                                        openPhaseCount,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                    value: "all",
                                    children: "All phases"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        children: "Across all applications"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "table-wrap",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                            className: "data-table",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Beneficiary"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "File ref."
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Milestone (from master)"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Items done"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Phase"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Action"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                    children: rows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                            colSpan: 6,
                                            className: "empty-cell",
                                            children: show === "open" ? "No open phases. Switch to \u201CAll phases\u201D or complete items under Milestones in a file." : "No milestone data. Add templates under Milestone master."
                                        })
                                    }) : rows.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: r.beneficiaryName
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "mono",
                                                    children: r.applicationId
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                        children: r.templateTitle
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                        className: "mono",
                                                        children: [
                                                            r.itemsDone,
                                                            "/",
                                                            r.itemsTotal
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: r.phaseOpen ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "badge badge--pending",
                                                        children: "Open"
                                                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "badge badge--ok",
                                                        children: "Complete"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                                        to: `/applications/${r.appId}/milestones`,
                                                        className: "btn btn--primary btn--tg btn--sm",
                                                        children: "Open in file"
                                                    })
                                                })
                                            ]
                                        }, r.key))
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");






const $bafe695bf914f48e$var$KIND_OPTIONS = [
    {
        value: "material",
        label: "Material / supplies"
    },
    {
        value: "subcontractor_bill",
        label: "Subcontractor bill"
    },
    {
        value: "govt_bill",
        label: "Government bill / challan"
    },
    {
        value: "work_done_bill",
        label: "Work-done bill (dossier)"
    }
];
function $bafe695bf914f48e$var$MilestoneTimelineMultiLinkField({ idPrefix: idPrefix, selectedIds: selectedIds, onChange: onChange, disabled: disabled }) {
    const { constructionTimelinePhases: constructionTimelinePhases } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const sorted = (0, $7UyaH.useMemo)(()=>(0, $d0dce9c7337efc65$export$107c6562c1e7acbf)(constructionTimelinePhases), [
        constructionTimelinePhases
    ]);
    const selected = (0, $7UyaH.useMemo)(()=>new Set(selectedIds), [
        selectedIds
    ]);
    function toggle(id) {
        const next = new Set(selected);
        if (next.has(id)) next.delete(id);
        else next.add(id);
        onChange([
            ...next
        ]);
    }
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "field",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "milestone-timeline-multi__label",
                children: "Construction timeline levels (optional)"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "text-muted section-lead section-lead--tight",
                style: {
                    margin: "0.15rem 0 0.5rem"
                },
                children: [
                    "Select one or more Gantt rows this milestone relates to (reference only). Levels are defined under",
                    " ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                        to: "/construction-timeline-master",
                        children: "Timeline master"
                    }),
                    "."
                ]
            }),
            sorted.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "text-muted section-lead section-lead--tight",
                children: "No timeline levels in master yet."
            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "milestone-timeline-check-grid",
                        role: "group",
                        "aria-label": "Linked construction timeline levels",
                        children: sorted.map((p)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "milestone-timeline-check",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        type: "checkbox",
                                        id: `${idPrefix}-${p.id}`,
                                        checked: selected.has(p.id),
                                        onChange: ()=>toggle(p.id),
                                        disabled: disabled
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                        className: "milestone-timeline-check__text",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "milestone-timeline-check__title",
                                                children: p.title
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                className: "milestone-timeline-check__meta",
                                                children: [
                                                    "~",
                                                    p.approxDays,
                                                    " d plan"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, p.id))
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--link btn--sm",
                        style: {
                            marginTop: "0.35rem"
                        },
                        onClick: ()=>onChange([]),
                        disabled: disabled,
                        children: "Clear all timeline links"
                    })
                ]
            })
        ]
    });
}
function $bafe695bf914f48e$var$MilestoneResourceMultiSelectField({ idPrefix: idPrefix, selectedIds: selectedIds, onChange: onChange, disabled: disabled }) {
    const { standardResources: standardResources } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const sorted = (0, $7UyaH.useMemo)(()=>(0, $75ee0f08bbd50d82$export$a6798fb462b4557)(standardResources), [
        standardResources
    ]);
    const selected = (0, $7UyaH.useMemo)(()=>new Set(selectedIds), [
        selectedIds
    ]);
    function toggle(id) {
        const next = new Set(selected);
        if (next.has(id)) next.delete(id);
        else next.add(id);
        onChange([
            ...next
        ]);
    }
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "field",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "milestone-timeline-multi__label",
                children: "Standard resources (optional)"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "text-muted section-lead section-lead--tight",
                style: {
                    margin: "0.15rem 0 0.5rem"
                },
                children: [
                    "Select resource categories linked to this milestone (informational). Item lines and quantities are defined under ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                        to: "/standard-resources-master",
                        children: "Standard resources master"
                    }),
                    "."
                ]
            }),
            sorted.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "text-muted section-lead section-lead--tight",
                children: [
                    "No resources in master yet \u2014 add them under",
                    " ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                        to: "/standard-resources-master",
                        children: "Standard resources master"
                    }),
                    "."
                ]
            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "milestone-timeline-check-grid",
                role: "group",
                "aria-label": "Linked standard resources",
                children: sorted.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                        className: "milestone-timeline-check",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                type: "checkbox",
                                id: `${idPrefix}-${r.id}`,
                                checked: selected.has(r.id),
                                onChange: ()=>toggle(r.id),
                                disabled: disabled
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "milestone-timeline-check__text milestone-timeline-check__text--single",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "milestone-timeline-check__title",
                                    children: r.title
                                })
                            })
                        ]
                    }, r.id))
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                type: "button",
                className: "btn btn--link btn--sm",
                style: {
                    marginTop: "0.35rem"
                },
                onClick: ()=>onChange([]),
                disabled: disabled,
                children: "Clear all resource links"
            })
        ]
    });
}
function $bafe695bf914f48e$var$MilestoneTemplateSummaryCard({ template: t, phaseIndex: phaseIndex, isActive: isActive, onOpen: onOpen }) {
    const itemCount = t.items.length;
    const resCount = t.linkedResourceIds?.length ?? 0;
    const tlCount = t.linkedConstructionTimelinePhaseIds?.length ?? 0;
    const note = t.notes.trim();
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("button", {
        type: "button",
        className: `milestone-master-picker-card${isActive ? " milestone-master-picker-card--active" : ""}`,
        onClick: onOpen,
        "aria-haspopup": "dialog",
        "aria-expanded": isActive,
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "milestone-master-picker-card__content",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__top",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                            className: "milestone-master-picker-card__phase-badge",
                            children: [
                                "Phase ",
                                phaseIndex + 1
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__title",
                        children: t.title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                className: "milestone-master-picker-card__footer",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                    children: isActive ? "Editor open" : "Click card to edit"
                })
            })
        ]
    });
}
function $bafe695bf914f48e$var$TemplateEditorCard({ template: t, embedInModal: embedInModal, onDeleted: onDeleted }) {
    const { updateMilestoneTemplate: updateMilestoneTemplate, removeMilestoneTemplate: removeMilestoneTemplate, addMilestoneTemplateItem: addMilestoneTemplateItem, removeMilestoneTemplateItem: removeMilestoneTemplateItem } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const [title, setTitle] = (0, $7UyaH.useState)(t.title);
    const [notes, setNotes] = (0, $7UyaH.useState)(t.notes);
    const [linkedTimelineIds, setLinkedTimelineIds] = (0, $7UyaH.useState)(()=>[
            ...t.linkedConstructionTimelinePhaseIds ?? []
        ]);
    const [linkedResourceIds, setLinkedResourceIds] = (0, $7UyaH.useState)(()=>[
            ...t.linkedResourceIds ?? []
        ]);
    const [newKind, setNewKind] = (0, $7UyaH.useState)("material");
    const [newLabel, setNewLabel] = (0, $7UyaH.useState)("");
    const [isLocked, setIsLocked] = (0, $7UyaH.useState)(null);
    (0, $7UyaH.useEffect)(()=>{
        let active = true;
        (0, $f5510818538731b9$export$199cc1209b09073e)({
            limit: 1,
            milestoneTemplateId: t.id
        }).then((pos)=>{
            if (active) setIsLocked(pos.length > 0);
        }).catch(()=>{
            if (active) setIsLocked(false);
        });
        return ()=>{
            active = false;
        };
    }, [
        t.id
    ]);
    (0, $7UyaH.useEffect)(()=>{
        setTitle(t.title);
        setNotes(t.notes);
        setLinkedTimelineIds([
            ...t.linkedConstructionTimelinePhaseIds ?? []
        ]);
        setLinkedResourceIds([
            ...t.linkedResourceIds ?? []
        ]);
    }, [
        t.id,
        t.title,
        t.notes,
        t.linkedConstructionTimelinePhaseIds,
        t.linkedResourceIds
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: embedInModal ? "milestone-master-modal-editor" : "card card--gov card--elevated",
        role: "region",
        "aria-label": `Edit milestone: ${t.title}`,
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "toolbar-row",
                style: {
                    justifyContent: "space-between",
                    alignItems: "flex-start"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        style: {
                            margin: 0
                        },
                        children: t.title
                    }),
                    isLocked !== true && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--tg-secondary btn--sm milestone-row__remove",
                        onClick: ()=>{
                            if (window.confirm(`Remove milestone \u{201C}${t.title}\u{201D} from master? Progress on beneficiary files will lose this phase.`)) removeMilestoneTemplate(t.id).then((ok)=>{
                                if (ok) onDeleted?.();
                            });
                        },
                        children: "Delete template"
                    })
                ]
            }),
            isLocked === true && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "help-banner help-banner--warning",
                style: {
                    marginBottom: "1rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Locked for editing"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        style: {
                            margin: "0.25rem 0 0"
                        },
                        children: "Purchase Orders have already been generated using this milestone. To preserve data consistency, this master blueprint cannot be edited or deleted. It is view-only."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: `mt-title-${t.id}`,
                        children: "Title (shown on every beneficiary file)"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                        id: `mt-title-${t.id}`,
                        value: title,
                        onChange: (e)=>setTitle(e.target.value),
                        maxLength: 200,
                        disabled: isLocked === true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: `mt-notes-${t.id}`,
                        children: "Notes for officers"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                        id: `mt-notes-${t.id}`,
                        rows: 2,
                        value: notes,
                        onChange: (e)=>setNotes(e.target.value),
                        maxLength: 2000,
                        disabled: isLocked === true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($bafe695bf914f48e$var$MilestoneTimelineMultiLinkField, {
                idPrefix: `mt-timeline-${t.id}`,
                selectedIds: linkedTimelineIds,
                onChange: setLinkedTimelineIds,
                disabled: isLocked === true
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($bafe695bf914f48e$var$MilestoneResourceMultiSelectField, {
                idPrefix: `mt-res-${t.id}`,
                selectedIds: linkedResourceIds,
                onChange: setLinkedResourceIds,
                disabled: isLocked === true
            }),
            isLocked !== true && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                type: "button",
                className: "btn btn--primary btn--tg btn--sm",
                onClick: ()=>void updateMilestoneTemplate(t.id, {
                        title: title,
                        notes: notes,
                        linkedConstructionTimelinePhaseIds: linkedTimelineIds,
                        linkedResourceIds: linkedResourceIds
                    }),
                children: "Save title, notes, timeline & resource links"
            })
        ]
    });
}
function $bafe695bf914f48e$export$314de3aac775b4cc() {
    const { milestoneTemplates: milestoneTemplates, addMilestoneTemplate: addMilestoneTemplate } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const sorted = (0, $7UyaH.useMemo)(()=>[
            ...milestoneTemplates
        ].sort((a, b)=>a.sortOrder - b.sortOrder), [
        milestoneTemplates
    ]);
    const [createModalOpen, setCreateModalOpen] = (0, $7UyaH.useState)(false);
    const [editModalTemplateId, setEditModalTemplateId] = (0, $7UyaH.useState)(null);
    const [createTitle, setCreateTitle] = (0, $7UyaH.useState)("");
    const [createNotes, setCreateNotes] = (0, $7UyaH.useState)("");
    const [createLinkedTimelineIds, setCreateLinkedTimelineIds] = (0, $7UyaH.useState)([]);
    const [createLinkedResourceIds, setCreateLinkedResourceIds] = (0, $7UyaH.useState)([]);
    const editModalTemplate = (0, $7UyaH.useMemo)(()=>editModalTemplateId ? sorted.find((x)=>x.id === editModalTemplateId) : undefined, [
        editModalTemplateId,
        sorted
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (editModalTemplateId && !editModalTemplate) setEditModalTemplateId(null);
    }, [
        editModalTemplateId,
        editModalTemplate
    ]);
    const closeCreateModal = (0, $7UyaH.useCallback)(()=>{
        setCreateModalOpen(false);
        setCreateTitle("");
        setCreateNotes("");
        setCreateLinkedTimelineIds([]);
        setCreateLinkedResourceIds([]);
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        if (!createModalOpen && !editModalTemplateId) return;
        const onKey = (e)=>{
            if (e.key === "Escape") {
                closeCreateModal();
                setEditModalTemplateId(null);
            }
        };
        window.addEventListener("keydown", onKey);
        return ()=>window.removeEventListener("keydown", onKey);
    }, [
        createModalOpen,
        editModalTemplateId,
        closeCreateModal
    ]);
    const openCreateModal = ()=>{
        setEditModalTemplateId(null);
        setCreateModalOpen(true);
    };
    const openEditModal = (id)=>{
        setCreateModalOpen(false);
        setEditModalTemplateId((prev)=>prev === id ? null : id);
    };
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "milestone-master-page",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Milestone master"
                    }
                ],
                title: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem"
                    },
                    children: [
                        "Milestone master",
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                            className: "milestone-master__catalog-count",
                            children: sorted.length
                        })
                    ]
                }),
                actions: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                    type: "button",
                    className: "btn btn--primary btn--tg btn--sm",
                    onClick: openCreateModal,
                    children: "Add milestone"
                })
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("section", {
                className: "milestone-master__catalog",
                "aria-labelledby": "milestone-master-catalog-heading",
                style: {
                    marginTop: "1.75rem"
                },
                children: sorted.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "milestone-master__empty",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                            className: "milestone-master__empty-title",
                            children: "No phases yet"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                            className: "milestone-master__empty-desc",
                            children: [
                                "Create your first milestone template with ",
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                    children: "Add milestone"
                                }),
                                ". You can add checklist items after the phase exists."
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                    className: "milestone-master-picker-grid",
                    children: sorted.map((t, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($bafe695bf914f48e$var$MilestoneTemplateSummaryCard, {
                            template: t,
                            phaseIndex: i,
                            isActive: editModalTemplateId === t.id,
                            onOpen: ()=>openEditModal(t.id)
                        }, t.id))
                })
            }),
            createModalOpen ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "modal-backdrop",
                role: "presentation",
                onClick: ()=>{
                    closeCreateModal();
                },
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "modal milestone-master-modal",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "milestone-master-create-title",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "milestone-master-modal__header",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                    id: "milestone-master-create-title",
                                    className: "milestone-master-modal__title",
                                    children: "Add milestone"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--tg-secondary btn--sm",
                                    onClick: closeCreateModal,
                                    children: "Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "milestone-master-modal__body",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                            htmlFor: "new-mt-title",
                                            children: "Phase title"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                            id: "new-mt-title",
                                            value: createTitle,
                                            onChange: (e)=>setCreateTitle(e.target.value),
                                            placeholder: "e.g. Phase 4 \u2014 Electrification",
                                            maxLength: 200
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                            htmlFor: "new-mt-notes",
                                            children: "Notes (optional)"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                            id: "new-mt-notes",
                                            rows: 2,
                                            value: createNotes,
                                            onChange: (e)=>setCreateNotes(e.target.value),
                                            maxLength: 2000
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($bafe695bf914f48e$var$MilestoneTimelineMultiLinkField, {
                                    idPrefix: "new-mt-timeline",
                                    selectedIds: createLinkedTimelineIds,
                                    onChange: setCreateLinkedTimelineIds
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($bafe695bf914f48e$var$MilestoneResourceMultiSelectField, {
                                    idPrefix: "new-mt-res",
                                    selectedIds: createLinkedResourceIds,
                                    onChange: setCreateLinkedResourceIds
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                    className: "text-muted section-lead section-lead--tight",
                                    style: {
                                        marginTop: "0.25rem"
                                    },
                                    children: [
                                        "After you create the template, open its card and use ",
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                            children: "Required items & bills"
                                        }),
                                        " in the dialog to add checklist rows (type + description)."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "toolbar-row",
                                    style: {
                                        gap: "0.5rem",
                                        flexWrap: "wrap",
                                        marginTop: "0.75rem"
                                    },
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--primary btn--tg",
                                        disabled: !createTitle.trim(),
                                        onClick: ()=>{
                                            (async ()=>{
                                                const ok = await addMilestoneTemplate({
                                                    title: createTitle.trim(),
                                                    notes: createNotes.trim(),
                                                    items: [],
                                                    linkedConstructionTimelinePhaseIds: createLinkedTimelineIds,
                                                    linkedResourceIds: createLinkedResourceIds
                                                });
                                                if (!ok) return;
                                                closeCreateModal();
                                            })();
                                        },
                                        children: "Create milestone template"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }) : null,
            editModalTemplate ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "modal-backdrop",
                role: "presentation",
                onClick: ()=>{
                    setEditModalTemplateId(null);
                },
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "modal milestone-master-modal",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "milestone-master-edit-title",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "milestone-master-modal__header",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                    id: "milestone-master-edit-title",
                                    className: "milestone-master-modal__title",
                                    children: "Edit milestone"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--tg-secondary btn--sm",
                                    onClick: ()=>setEditModalTemplateId(null),
                                    children: "Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "milestone-master-modal__body",
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($bafe695bf914f48e$var$TemplateEditorCard, {
                                template: editModalTemplate,
                                embedInModal: true,
                                onDeleted: ()=>setEditModalTemplateId(null)
                            }, editModalTemplate.id)
                        })
                    ]
                })
            }) : null
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");




async function $6942d4b6a3fdbbdb$var$parseBody(res) {
    const text = await res.text();
    if (!text) return {};
    try {
        return JSON.parse(text);
    } catch  {
        return {};
    }
}
function $6942d4b6a3fdbbdb$var$geoAdminDistrictPathId(id) {
    return encodeURIComponent(String(id));
}
async function $6942d4b6a3fdbbdb$var$adminFetch(path, init) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}${path}`, {
        ...init,
        headers: {
            "Content-Type": "application/json",
            ...init?.headers
        }
    });
    const body = await $6942d4b6a3fdbbdb$var$parseBody(res);
    if (!res.ok) {
        const msg = typeof body.error === "string" ? body.error : `Request failed (${res.status})`;
        throw new Error(msg);
    }
    return body;
}
function $6942d4b6a3fdbbdb$export$6d9ad1306e88c544(payload) {
    return $6942d4b6a3fdbbdb$var$adminFetch("/api/geo/admin/districts", {
        method: "POST",
        body: JSON.stringify(payload)
    });
}
function $6942d4b6a3fdbbdb$export$6cada2a0d25a0111(id, payload) {
    return $6942d4b6a3fdbbdb$var$adminFetch(`/api/geo/admin/districts/${$6942d4b6a3fdbbdb$var$geoAdminDistrictPathId(id)}`, {
        method: "PATCH",
        body: JSON.stringify(payload)
    });
}
function $6942d4b6a3fdbbdb$export$d212eb384572da83(id) {
    return $6942d4b6a3fdbbdb$var$adminFetch(`/api/geo/admin/districts/${$6942d4b6a3fdbbdb$var$geoAdminDistrictPathId(id)}`, {
        method: "DELETE"
    });
}
function $6942d4b6a3fdbbdb$export$4f9068d5368c7d1f(payload) {
    return $6942d4b6a3fdbbdb$var$adminFetch("/api/geo/admin/mandals", {
        method: "POST",
        body: JSON.stringify(payload)
    });
}
function $6942d4b6a3fdbbdb$export$e85c18907fd95066(id, payload) {
    return $6942d4b6a3fdbbdb$var$adminFetch(`/api/geo/admin/mandals/${id}`, {
        method: "PATCH",
        body: JSON.stringify(payload)
    });
}
function $6942d4b6a3fdbbdb$export$f2c96cf78f679cd1(id) {
    return $6942d4b6a3fdbbdb$var$adminFetch(`/api/geo/admin/mandals/${id}`, {
        method: "DELETE"
    });
}
function $6942d4b6a3fdbbdb$export$3f5c5b0f32311182(payload) {
    return $6942d4b6a3fdbbdb$var$adminFetch("/api/geo/admin/villages", {
        method: "POST",
        body: JSON.stringify(payload)
    });
}
function $6942d4b6a3fdbbdb$export$52515c2ea1198afa(id, payload) {
    return $6942d4b6a3fdbbdb$var$adminFetch(`/api/geo/admin/villages/${id}`, {
        method: "PATCH",
        body: JSON.stringify(payload)
    });
}
function $6942d4b6a3fdbbdb$export$89528ef463e8c394(id) {
    return $6942d4b6a3fdbbdb$var$adminFetch(`/api/geo/admin/villages/${id}`, {
        method: "DELETE"
    });
}




function $3bed883fcd09d43d$var$districtPrimaryKey(d) {
    if (d.id !== undefined && d.id !== null) return d.id;
    return d.registrationDistrictCode;
}
function $3bed883fcd09d43d$var$DistrictEditorCard({ d: d, onChanged: onChanged }) {
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const [districtKey, setDistrictKey] = (0, $7UyaH.useState)(d.districtKey);
    const [code, setCode] = (0, $7UyaH.useState)(d.registrationDistrictCode);
    const [name, setName] = (0, $7UyaH.useState)(d.registrationDistrictName);
    const [busy, setBusy] = (0, $7UyaH.useState)(false);
    (0, $7UyaH.useEffect)(()=>{
        setDistrictKey(d.districtKey);
        setCode(d.registrationDistrictCode);
        setName(d.registrationDistrictName);
    }, [
        d.id,
        d.districtKey,
        d.registrationDistrictCode,
        d.registrationDistrictName
    ]);
    const pk = $3bed883fcd09d43d$var$districtPrimaryKey(d);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("article", {
        className: "geo-directory-master__card",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                className: "geo-directory-master__card-id",
                title: "District primary key (registration district code)",
                children: [
                    "#",
                    pk
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "geo-directory-master__card-fields geo-directory-master__card-fields--district",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: `gdist-k-${pk}`,
                                children: "District key"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: `gdist-k-${pk}`,
                                value: districtKey,
                                onChange: (e)=>setDistrictKey(e.target.value),
                                maxLength: 64
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: `gdist-c-${pk}`,
                                children: "Registration code"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: `gdist-c-${pk}`,
                                value: code,
                                onChange: (e)=>setCode(e.target.value),
                                maxLength: 32
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: `gdist-n-${pk}`,
                                children: "District name"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: `gdist-n-${pk}`,
                                value: name,
                                onChange: (e)=>setName(e.target.value),
                                maxLength: 255
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "geo-directory-master__card-foot",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--primary btn--sm",
                        disabled: busy || !districtKey.trim() || !code.trim() || !name.trim(),
                        onClick: ()=>{
                            (async ()=>{
                                setBusy(true);
                                try {
                                    await (0, $6942d4b6a3fdbbdb$export$6cada2a0d25a0111)(pk, {
                                        districtKey: districtKey.trim(),
                                        registrationDistrictCode: code.trim(),
                                        registrationDistrictName: name.trim()
                                    });
                                    showToast("District saved", "success");
                                    await onChanged();
                                } catch (e) {
                                    showToast(e instanceof Error ? e.message : String(e), "error");
                                } finally{
                                    setBusy(false);
                                }
                            })();
                        },
                        children: "Save"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--link btn--sm",
                        disabled: busy,
                        onClick: ()=>{
                            if (!window.confirm(`Delete district \u{201C}${d.registrationDistrictName}\u{201D} and all mandals and villages under it?`)) return;
                            (async ()=>{
                                setBusy(true);
                                try {
                                    await (0, $6942d4b6a3fdbbdb$export$d212eb384572da83)(pk);
                                    showToast("District removed", "success");
                                    await onChanged();
                                } catch (e) {
                                    showToast(e instanceof Error ? e.message : String(e), "error");
                                } finally{
                                    setBusy(false);
                                }
                            })();
                        },
                        children: "Delete"
                    })
                ]
            })
        ]
    });
}
function $3bed883fcd09d43d$var$MandalEditorCard({ m: m, districtId: districtId, onChanged: onChanged }) {
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const [mandalCode, setMandalCode] = (0, $7UyaH.useState)(m.mandalCode);
    const [mandalName, setMandalName] = (0, $7UyaH.useState)(m.mandalName);
    const [busy, setBusy] = (0, $7UyaH.useState)(false);
    (0, $7UyaH.useEffect)(()=>{
        setMandalCode(m.mandalCode);
        setMandalName(m.mandalName);
    }, [
        m.id,
        m.mandalCode,
        m.mandalName
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("article", {
        className: "geo-directory-master__card",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                className: "geo-directory-master__card-id",
                title: "Database id",
                children: [
                    "#",
                    m.id
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "geo-directory-master__card-fields geo-directory-master__card-fields--mandal",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: `gman-c-${m.id}`,
                                children: "Mandal code"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: `gman-c-${m.id}`,
                                value: mandalCode,
                                onChange: (e)=>setMandalCode(e.target.value),
                                maxLength: 64
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: `gman-n-${m.id}`,
                                children: "Mandal name"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: `gman-n-${m.id}`,
                                value: mandalName,
                                onChange: (e)=>setMandalName(e.target.value),
                                maxLength: 255
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "geo-directory-master__card-foot",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--primary btn--sm",
                        disabled: busy || !mandalCode.trim() || !mandalName.trim(),
                        onClick: ()=>{
                            (async ()=>{
                                setBusy(true);
                                try {
                                    await (0, $6942d4b6a3fdbbdb$export$e85c18907fd95066)(m.id, {
                                        districtId: districtId,
                                        mandalCode: mandalCode.trim(),
                                        mandalName: mandalName.trim()
                                    });
                                    showToast("Mandal saved", "success");
                                    await onChanged();
                                } catch (e) {
                                    showToast(e instanceof Error ? e.message : String(e), "error");
                                } finally{
                                    setBusy(false);
                                }
                            })();
                        },
                        children: "Save"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--link btn--sm",
                        disabled: busy,
                        onClick: ()=>{
                            if (!window.confirm(`Delete mandal \u{201C}${m.mandalName}\u{201D} and all villages under it?`)) return;
                            (async ()=>{
                                setBusy(true);
                                try {
                                    await (0, $6942d4b6a3fdbbdb$export$f2c96cf78f679cd1)(m.id);
                                    showToast("Mandal removed", "success");
                                    await onChanged();
                                } catch (e) {
                                    showToast(e instanceof Error ? e.message : String(e), "error");
                                } finally{
                                    setBusy(false);
                                }
                            })();
                        },
                        children: "Delete"
                    })
                ]
            })
        ]
    });
}
function $3bed883fcd09d43d$var$VillageEditorCard({ v: v, mandalId: mandalId, onChanged: onChanged }) {
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const [villageName, setVillageName] = (0, $7UyaH.useState)(v.name);
    const [villageCode, setVillageCode] = (0, $7UyaH.useState)(v.code);
    const [busy, setBusy] = (0, $7UyaH.useState)(false);
    (0, $7UyaH.useEffect)(()=>{
        setVillageName(v.name);
        setVillageCode(v.code);
    }, [
        v.id,
        v.name,
        v.code
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("article", {
        className: "geo-directory-master__card",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                className: "geo-directory-master__card-id",
                title: "Database id",
                children: [
                    "#",
                    v.id
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "geo-directory-master__card-fields geo-directory-master__card-fields--village",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: `gvill-n-${v.id}`,
                                children: "Village name"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: `gvill-n-${v.id}`,
                                value: villageName,
                                onChange: (e)=>setVillageName(e.target.value),
                                maxLength: 255
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: `gvill-c-${v.id}`,
                                children: "Village code"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: `gvill-c-${v.id}`,
                                value: villageCode,
                                onChange: (e)=>setVillageCode(e.target.value),
                                maxLength: 64
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "geo-directory-master__card-foot",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--primary btn--sm",
                        disabled: busy || !villageName.trim() || !villageCode.trim(),
                        onClick: ()=>{
                            (async ()=>{
                                setBusy(true);
                                try {
                                    await (0, $6942d4b6a3fdbbdb$export$52515c2ea1198afa)(v.id, {
                                        mandalId: mandalId,
                                        villageName: villageName.trim(),
                                        villageCode: villageCode.trim()
                                    });
                                    showToast("Village saved", "success");
                                    await onChanged();
                                } catch (e) {
                                    showToast(e instanceof Error ? e.message : String(e), "error");
                                } finally{
                                    setBusy(false);
                                }
                            })();
                        },
                        children: "Save"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--link btn--sm",
                        disabled: busy,
                        onClick: ()=>{
                            if (!window.confirm(`Delete village \u{201C}${v.name}\u{201D}?`)) return;
                            (async ()=>{
                                setBusy(true);
                                try {
                                    await (0, $6942d4b6a3fdbbdb$export$89528ef463e8c394)(v.id);
                                    showToast("Village removed", "success");
                                    await onChanged();
                                } catch (e) {
                                    showToast(e instanceof Error ? e.message : String(e), "error");
                                } finally{
                                    setBusy(false);
                                }
                            })();
                        },
                        children: "Delete"
                    })
                ]
            })
        ]
    });
}
function $3bed883fcd09d43d$export$fa5ac397bae91bf1() {
    const { store: store, loading: loading, refetch: refetch } = (0, $60dd8507bac67e50$export$5ec0231075ddedf1)();
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const [tab, setTab] = (0, $7UyaH.useState)("districts");
    const districts = (0, $7UyaH.useMemo)(()=>{
        if (!store) return [];
        return [
            ...store.tgRegistrationDistricts()
        ].sort((a, b)=>a.registrationDistrictName.localeCompare(b.registrationDistrictName));
    }, [
        store
    ]);
    const canEditRows = (0, $7UyaH.useMemo)(()=>{
        if (!store || districts.length === 0) return true;
        const id = districts[0].id;
        return typeof id === "number" || typeof id === "string";
    }, [
        store,
        districts
    ]);
    const [selectedDistrictId, setSelectedDistrictId] = (0, $7UyaH.useState)("");
    const [selectedMandalId, setSelectedMandalId] = (0, $7UyaH.useState)("");
    (0, $7UyaH.useEffect)(()=>{
        if (districts.length === 0) {
            setSelectedDistrictId("");
            setSelectedMandalId("");
            return;
        }
        setSelectedDistrictId((prev)=>{
            const first = districts[0];
            const firstPk = $3bed883fcd09d43d$var$districtPrimaryKey(first);
            if (prev === "" || !districts.some((d)=>$3bed883fcd09d43d$var$districtPrimaryKey(d) === prev)) return firstPk;
            return prev;
        });
    }, [
        districts
    ]);
    const selectedDistrict = (0, $7UyaH.useMemo)(()=>selectedDistrictId === "" ? undefined : districts.find((d)=>$3bed883fcd09d43d$var$districtPrimaryKey(d) === selectedDistrictId), [
        districts,
        selectedDistrictId
    ]);
    const mandalsSorted = (0, $7UyaH.useMemo)(()=>{
        if (!selectedDistrict?.mandals) return [];
        return [
            ...selectedDistrict.mandals
        ].sort((a, b)=>a.mandalName.localeCompare(b.mandalName));
    }, [
        selectedDistrict
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (mandalsSorted.length === 0) {
            setSelectedMandalId("");
            return;
        }
        setSelectedMandalId((prev)=>{
            if (prev === "" || !mandalsSorted.some((m)=>m.id === prev)) return mandalsSorted[0].id;
            return prev;
        });
    }, [
        mandalsSorted
    ]);
    const selectedMandal = (0, $7UyaH.useMemo)(()=>selectedMandalId === "" ? undefined : mandalsSorted.find((m)=>m.id === selectedMandalId), [
        mandalsSorted,
        selectedMandalId
    ]);
    const villagesSorted = (0, $7UyaH.useMemo)(()=>{
        if (!selectedMandal?.villages) return [];
        return [
            ...selectedMandal.villages
        ].sort((a, b)=>a.name.localeCompare(b.name));
    }, [
        selectedMandal
    ]);
    const onChanged = (0, $7UyaH.useCallback)(async ()=>{
        await refetch();
    }, [
        refetch
    ]);
    const [newDistrictKey, setNewDistrictKey] = (0, $7UyaH.useState)("");
    const [newDistrictCode, setNewDistrictCode] = (0, $7UyaH.useState)("");
    const [newDistrictName, setNewDistrictName] = (0, $7UyaH.useState)("");
    const [newMandalCode, setNewMandalCode] = (0, $7UyaH.useState)("");
    const [newMandalName, setNewMandalName] = (0, $7UyaH.useState)("");
    const [newVillageName, setNewVillageName] = (0, $7UyaH.useState)("");
    const [newVillageCode, setNewVillageCode] = (0, $7UyaH.useState)("");
    const tabIds = {
        districts: "geo-tab-districts",
        mandals: "geo-tab-mandals",
        villages: "geo-tab-villages"
    };
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "geo-directory-master",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Geo directory"
                    }
                ],
                title: "Districts, mandals & villages",
                subtitle: "Maintain the geographic directory used across applicants, zones, and reports. Data is stored by the API (SQLite or MySQL when configured)."
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "geo-directory-master__lede text-muted",
                children: [
                    "Use the tabs to focus on one level at a time. Choose ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Districts"
                    }),
                    " first, then ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Mandals"
                    }),
                    " for a district, then",
                    " ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Villages"
                    }),
                    " for a mandal.",
                    " ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                        to: "/reports",
                        children: "Area reports"
                    }),
                    " read from the same directory."
                ]
            }),
            loading && !store ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "geo-directory-master__loading section-lead text-muted",
                children: "Loading directory\u2026"
            }) : !store || districts.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "help-banner help-banner--muted geo-directory-master__alert",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "No districts in context"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "geo-directory-master__alert-p",
                        children: [
                            "Open the ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Districts"
                            }),
                            " tab and add a record (the server must be reachable; the offline bundle is not editable here)."
                        ]
                    })
                ]
            }) : !canEditRows ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "help-banner help-banner--info geo-directory-master__alert",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Read-only copy"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "geo-directory-master__alert-p",
                        children: [
                            "The UI is using the bundled directory (no server row identifiers). Start the API so ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("code", {
                                children: "/api/geo/directory"
                            }),
                            " returns live rows to unlock editing. You can still try ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Add district"
                            }),
                            " on the Districts tab if the admin API is running."
                        ]
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "geo-directory-master__tabs",
                role: "tablist",
                "aria-label": "Geography level",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        role: "tab",
                        id: tabIds.districts,
                        "aria-selected": tab === "districts",
                        "aria-controls": "geo-panel-districts",
                        className: "geo-directory-master__tab" + (tab === "districts" ? " geo-directory-master__tab--active" : ""),
                        onClick: ()=>setTab("districts"),
                        children: "Districts"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        role: "tab",
                        id: tabIds.mandals,
                        "aria-selected": tab === "mandals",
                        "aria-controls": "geo-panel-mandals",
                        className: "geo-directory-master__tab" + (tab === "mandals" ? " geo-directory-master__tab--active" : ""),
                        onClick: ()=>setTab("mandals"),
                        children: "Mandals"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        role: "tab",
                        id: tabIds.villages,
                        "aria-selected": tab === "villages",
                        "aria-controls": "geo-panel-villages",
                        className: "geo-directory-master__tab" + (tab === "villages" ? " geo-directory-master__tab--active" : ""),
                        onClick: ()=>setTab("villages"),
                        children: "Villages"
                    })
                ]
            }),
            tab === "districts" && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                id: "geo-panel-districts",
                role: "tabpanel",
                "aria-labelledby": tabIds.districts,
                className: "geo-directory-master__panels",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                        className: "card card--elevated geo-directory-master__section",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("header", {
                                className: "card__head card__head--accent",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                    className: "geo-directory-master__h2",
                                    children: "Add district"
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "geo-directory-master__form-grid",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "field",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                htmlFor: "geo-new-dk",
                                                children: "District key"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                id: "geo-new-dk",
                                                value: newDistrictKey,
                                                onChange: (e)=>setNewDistrictKey(e.target.value),
                                                placeholder: "e.g. hyderabad",
                                                maxLength: 64
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "field",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                htmlFor: "geo-new-dc",
                                                children: "Registration code"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                id: "geo-new-dc",
                                                value: newDistrictCode,
                                                onChange: (e)=>setNewDistrictCode(e.target.value),
                                                placeholder: "Official code",
                                                maxLength: 32
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "field geo-directory-master__form-span",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                htmlFor: "geo-new-dn",
                                                children: "District name"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                id: "geo-new-dn",
                                                value: newDistrictName,
                                                onChange: (e)=>setNewDistrictName(e.target.value),
                                                placeholder: "Display name",
                                                maxLength: 255
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "geo-directory-master__form-actions",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--primary",
                                    disabled: !newDistrictKey.trim() || !newDistrictCode.trim() || !newDistrictName.trim(),
                                    onClick: ()=>{
                                        (async ()=>{
                                            try {
                                                await (0, $6942d4b6a3fdbbdb$export$6d9ad1306e88c544)({
                                                    districtKey: newDistrictKey.trim(),
                                                    registrationDistrictCode: newDistrictCode.trim(),
                                                    registrationDistrictName: newDistrictName.trim()
                                                });
                                                showToast("District added", "success");
                                                setNewDistrictKey("");
                                                setNewDistrictCode("");
                                                setNewDistrictName("");
                                                await onChanged();
                                            } catch (e) {
                                                showToast(e instanceof Error ? e.message : String(e), "error");
                                            }
                                        })();
                                    },
                                    children: "Add district"
                                })
                            })
                        ]
                    }),
                    districts.length > 0 && canEditRows ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                        className: "card card--elevated geo-directory-master__section",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("header", {
                                className: "card__head",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                        className: "geo-directory-master__h2",
                                        children: "All districts"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "geo-directory-master__count",
                                        children: districts.length
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "geo-directory-master__list",
                                children: districts.map((d)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($3bed883fcd09d43d$var$DistrictEditorCard, {
                                        d: d,
                                        onChanged: onChanged
                                    }, String($3bed883fcd09d43d$var$districtPrimaryKey(d))))
                            })
                        ]
                    }) : districts.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                        className: "card card--elevated geo-directory-master__section",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("header", {
                                className: "card__head",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                    className: "geo-directory-master__h2",
                                    children: "Districts (read-only)"
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                                className: "geo-directory-master__readonly-list",
                                children: districts.map((d)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                        className: "geo-directory-master__readonly-row",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "geo-directory-master__readonly-k",
                                                children: d.districtKey
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "geo-directory-master__readonly-c",
                                                children: d.registrationDistrictCode
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "geo-directory-master__readonly-n",
                                                children: d.registrationDistrictName
                                            })
                                        ]
                                    }, d.districtKey))
                            })
                        ]
                    }) : null
                ]
            }),
            tab === "mandals" && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                id: "geo-panel-mandals",
                role: "tabpanel",
                "aria-labelledby": tabIds.mandals,
                className: "geo-directory-master__panels",
                children: !canEditRows ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                    className: "text-muted section-lead",
                    children: "Mandal editing needs live directory data from the API."
                }) : districts.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                    className: "text-muted section-lead",
                    children: "Add a district on the Districts tab first."
                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                            className: "card card--elevated geo-directory-master__section",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("header", {
                                    className: "card__head card__head--accent",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                                className: "geo-directory-master__h2",
                                                children: "Add mandal"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                className: "geo-directory-master__section-sub text-muted",
                                                children: "Mandals belong to one district."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                            htmlFor: "geo-mandal-district",
                                            children: "District"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("select", {
                                            id: "geo-mandal-district",
                                            className: "geo-directory-master__select",
                                            value: selectedDistrictId === "" ? "" : String(selectedDistrictId),
                                            onChange: (e)=>setSelectedDistrictId(e.target.value === "" ? "" : e.target.value),
                                            children: districts.map((d)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                    value: String($3bed883fcd09d43d$var$districtPrimaryKey(d)),
                                                    children: d.registrationDistrictName
                                                }, d.districtKey))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "geo-directory-master__form-grid geo-directory-master__form-grid--2",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "field",
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                    htmlFor: "geo-new-mc",
                                                    children: "Mandal code"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                    id: "geo-new-mc",
                                                    value: newMandalCode,
                                                    onChange: (e)=>setNewMandalCode(e.target.value),
                                                    maxLength: 64
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "field",
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                    htmlFor: "geo-new-mn",
                                                    children: "Mandal name"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                    id: "geo-new-mn",
                                                    value: newMandalName,
                                                    onChange: (e)=>setNewMandalName(e.target.value),
                                                    maxLength: 255
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "geo-directory-master__form-actions",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--primary",
                                        disabled: selectedDistrictId === "" || !newMandalCode.trim() || !newMandalName.trim(),
                                        onClick: ()=>{
                                            if (selectedDistrictId === "") return;
                                            (async ()=>{
                                                try {
                                                    await (0, $6942d4b6a3fdbbdb$export$4f9068d5368c7d1f)({
                                                        districtId: selectedDistrictId,
                                                        mandalCode: newMandalCode.trim(),
                                                        mandalName: newMandalName.trim()
                                                    });
                                                    showToast("Mandal added", "success");
                                                    setNewMandalCode("");
                                                    setNewMandalName("");
                                                    await onChanged();
                                                } catch (e) {
                                                    showToast(e instanceof Error ? e.message : String(e), "error");
                                                }
                                            })();
                                        },
                                        children: "Add mandal"
                                    })
                                })
                            ]
                        }),
                        mandalsSorted.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                            className: "card card--elevated geo-directory-master__section",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("header", {
                                    className: "card__head",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("h2", {
                                            className: "geo-directory-master__h2",
                                            children: [
                                                "Mandals in ",
                                                selectedDistrict?.registrationDistrictName ?? "district"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "geo-directory-master__count",
                                            children: mandalsSorted.length
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "geo-directory-master__list",
                                    children: selectedDistrictId !== "" && mandalsSorted.map((m)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($3bed883fcd09d43d$var$MandalEditorCard, {
                                            m: m,
                                            districtId: selectedDistrictId,
                                            onChanged: onChanged
                                        }, m.id))
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                            className: "help-banner help-banner--muted geo-directory-master__empty-banner",
                            children: "No mandals for this district yet."
                        })
                    ]
                })
            }),
            tab === "villages" && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                id: "geo-panel-villages",
                role: "tabpanel",
                "aria-labelledby": tabIds.villages,
                className: "geo-directory-master__panels",
                children: !canEditRows ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                    className: "text-muted section-lead",
                    children: "Village editing needs live directory data from the API."
                }) : mandalsSorted.length === 0 || selectedDistrictId === "" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                    className: "text-muted section-lead",
                    children: "Pick a district that has mandals (use the Mandals tab), then return here."
                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                            className: "card card--elevated geo-directory-master__section",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("header", {
                                    className: "card__head card__head--accent",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                                className: "geo-directory-master__h2",
                                                children: "Add village"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                className: "geo-directory-master__section-sub text-muted",
                                                children: [
                                                    "District: ",
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                        children: selectedDistrict?.registrationDistrictName
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                            htmlFor: "geo-village-mandal",
                                            children: "Mandal"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("select", {
                                            id: "geo-village-mandal",
                                            className: "geo-directory-master__select",
                                            value: selectedMandalId === "" ? "" : String(selectedMandalId),
                                            onChange: (e)=>setSelectedMandalId(e.target.value ? Number(e.target.value) : ""),
                                            children: mandalsSorted.map((m)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                    value: m.id,
                                                    children: m.mandalName
                                                }, m.id))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "geo-directory-master__form-grid",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "field geo-directory-master__form-span",
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                    htmlFor: "geo-new-vn",
                                                    children: "Village name"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                    id: "geo-new-vn",
                                                    value: newVillageName,
                                                    onChange: (e)=>setNewVillageName(e.target.value),
                                                    maxLength: 255
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "field",
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                    htmlFor: "geo-new-vc",
                                                    children: "Village code"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                    id: "geo-new-vc",
                                                    value: newVillageCode,
                                                    onChange: (e)=>setNewVillageCode(e.target.value),
                                                    maxLength: 64
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "geo-directory-master__form-actions",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--primary",
                                        disabled: selectedMandalId === "" || !newVillageName.trim() || !newVillageCode.trim(),
                                        onClick: ()=>{
                                            if (selectedMandalId === "") return;
                                            (async ()=>{
                                                try {
                                                    await (0, $6942d4b6a3fdbbdb$export$3f5c5b0f32311182)({
                                                        mandalId: selectedMandalId,
                                                        villageName: newVillageName.trim(),
                                                        villageCode: newVillageCode.trim()
                                                    });
                                                    showToast("Village added", "success");
                                                    setNewVillageName("");
                                                    setNewVillageCode("");
                                                    await onChanged();
                                                } catch (e) {
                                                    showToast(e instanceof Error ? e.message : String(e), "error");
                                                }
                                            })();
                                        },
                                        children: "Add village"
                                    })
                                })
                            ]
                        }),
                        villagesSorted.length > 0 && selectedMandalId !== "" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                            className: "card card--elevated geo-directory-master__section",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("header", {
                                    className: "card__head",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("h2", {
                                            className: "geo-directory-master__h2",
                                            children: [
                                                "Villages in ",
                                                selectedMandal?.mandalName ?? "mandal"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "geo-directory-master__count",
                                            children: villagesSorted.length
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "geo-directory-master__list",
                                    children: villagesSorted.map((v)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($3bed883fcd09d43d$var$VillageEditorCard, {
                                            v: v,
                                            mandalId: selectedMandalId,
                                            onChanged: onChanged
                                        }, v.id))
                                })
                            ]
                        }) : selectedMandalId !== "" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                            className: "help-banner help-banner--muted geo-directory-master__empty-banner",
                            children: "No villages for this mandal yet."
                        }) : null
                    ]
                })
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");










const $bad45714fbd4da09$export$aa5b819762e04066 = [
    "pending_validation",
    "on_hold",
    "ready_for_icici",
    "ready_for_mou",
    "icici_recorded",
    "subcontractor_linked"
];
const $bad45714fbd4da09$export$6ee1b6ba2882976e = {
    pending_validation: "Pending validation",
    on_hold: "On hold",
    ready_for_icici: "Ready for ICICI",
    ready_for_mou: "Ready for MOU",
    icici_recorded: "Awaiting subcontractor",
    subcontractor_linked: "Subcontractor linked"
};
function $bad45714fbd4da09$var$emptyByStatus() {
    return {
        pending_validation: 0,
        on_hold: 0,
        ready_for_icici: 0,
        ready_for_mou: 0,
        icici_recorded: 0,
        subcontractor_linked: 0
    };
}
function $bad45714fbd4da09$var$countStatuses(apps) {
    const out = $bad45714fbd4da09$var$emptyByStatus();
    for (const a of apps)out[a.status] += 1;
    return out;
}
function $bad45714fbd4da09$export$4f0ecbbeb220e74b(apps, geo) {
    if (geo) return geo.tgRegistrationDistricts().map((d)=>{
        const sub = apps.filter((a)=>(0, $77f9294c77fbab2e$export$bf463aeed8846c53)(geo, d.districtKey, a.district));
        return {
            key: d.districtKey,
            label: (0, $458840b99c021cb6$export$bb1029bec19025fd)(d.registrationDistrictName),
            total: sub.length,
            byStatus: $bad45714fbd4da09$var$countStatuses(sub)
        };
    });
    return (0, $72c1e8625e9e63b5$export$c213a939d88ef2f8).map((d)=>{
        const sub = apps.filter((a)=>(0, $72c1e8625e9e63b5$export$768d2fc1615cd5ac)(a.district) === d.key);
        return {
            key: d.key,
            label: d.label,
            total: sub.length,
            byStatus: $bad45714fbd4da09$var$countStatuses(sub)
        };
    });
}
function $bad45714fbd4da09$export$8e545c043541f9f6(apps, district, geo) {
    const sub = apps.filter((a)=>(0, $77f9294c77fbab2e$export$bf463aeed8846c53)(geo, district, a.district));
    const appMap = new Map();
    for (const a of sub){
        const raw = (a.mandal || "").trim();
        const nk = raw ? (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(raw) : "";
        if (!appMap.has(nk)) appMap.set(nk, []);
        appMap.get(nk).push(a);
    }
    const dir = geo.tgMandalsForDistrict(district);
    const rows = [];
    const usedNorm = new Set();
    for (const m of dir){
        const nk = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(m.mandalName);
        const list = appMap.get(nk) ?? [];
        usedNorm.add(nk);
        rows.push({
            key: m.mandalName,
            label: m.mandalName,
            total: list.length,
            byStatus: $bad45714fbd4da09$var$countStatuses(list)
        });
    }
    for (const [nk, list] of appMap){
        if (!nk || usedNorm.has(nk)) continue;
        const label = (list[0].mandal || "").trim() || "Unspecified mandal";
        rows.push({
            key: label,
            label: label,
            total: list.length,
            byStatus: $bad45714fbd4da09$var$countStatuses(list)
        });
    }
    return rows.sort((a, b)=>a.label.localeCompare(b.label, "en"));
}
function $bad45714fbd4da09$export$b8b53aeab39e07(apps, district, mandal, geo) {
    const mandalNorm = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(mandal);
    const sub = apps.filter((a)=>(0, $77f9294c77fbab2e$export$bf463aeed8846c53)(geo, district, a.district) && (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(a.mandal || "") === mandalNorm);
    const appMap = new Map();
    for (const a of sub){
        const raw = (a.village || "").trim();
        const nk = raw ? (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(raw) : "";
        if (!appMap.has(nk)) appMap.set(nk, []);
        appMap.get(nk).push(a);
    }
    const dirVillages = geo.tgVillagesForMandal(district, mandal);
    const rows = [];
    const usedNorm = new Set();
    for (const v of dirVillages){
        const nk = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(v.name);
        const list = appMap.get(nk) ?? [];
        usedNorm.add(nk);
        rows.push({
            key: v.name,
            label: v.name,
            total: list.length,
            byStatus: $bad45714fbd4da09$var$countStatuses(list)
        });
    }
    for (const [nk, list] of appMap){
        if (!nk || usedNorm.has(nk)) continue;
        const label = (list[0].village || "").trim() || "Unspecified village";
        rows.push({
            key: label,
            label: label,
            total: list.length,
            byStatus: $bad45714fbd4da09$var$countStatuses(list)
        });
    }
    return rows.sort((a, b)=>a.label.localeCompare(b.label, "en"));
}
function $bad45714fbd4da09$export$f8ee0d4f5fe56add(apps, district, mandal, village, geo) {
    const mn = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(mandal);
    const vn = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(village);
    return apps.filter((a)=>{
        if (geo && !(0, $77f9294c77fbab2e$export$bf463aeed8846c53)(geo, district, a.district)) return false;
        if (!geo && (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(a.district || "") !== (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(district)) return false;
        return (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(a.mandal || "") === mn && (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(a.village || "") === vn;
    });
}
function $bad45714fbd4da09$export$aa30e4ea490e3db9(row) {
    return {
        totalReceived: row.total,
        verificationPending: row.byStatus.pending_validation,
        onHold: row.byStatus.on_hold,
        compliance: row.byStatus.ready_for_icici + row.byStatus.ready_for_mou + row.byStatus.icici_recorded,
        subcontracted: row.byStatus.subcontractor_linked
    };
}
const $bad45714fbd4da09$export$ad094be7a982945c = [
    "Total received",
    "Verification pending",
    "On hold",
    "Compliance",
    "Subcontracted"
];
function $bad45714fbd4da09$export$a77e2ad0c8d8008a(areaColumnLabel) {
    return [
        areaColumnLabel,
        ...$bad45714fbd4da09$export$ad094be7a982945c
    ];
}
function $bad45714fbd4da09$export$3316ef93e894491a(row) {
    const d = $bad45714fbd4da09$export$aa30e4ea490e3db9(row);
    return [
        row.label,
        String(d.totalReceived),
        String(d.verificationPending),
        String(d.onHold),
        String(d.compliance),
        String(d.subcontracted)
    ];
}






async function $4e56623d4da7ea32$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
function $4e56623d4da7ea32$var$normalizeHoStatusFromApi(hoStatus) {
    if (hoStatus == null || !String(hoStatus).trim()) return null;
    const s = String(hoStatus).trim().toLowerCase();
    if (s === "approve") return "approved";
    return String(hoStatus).trim();
}
async function $4e56623d4da7ea32$export$c20290562992eebc() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/leads/table`);
    if (!res.ok) throw new Error(await $4e56623d4da7ea32$var$parseError(res));
    const raw = await res.json();
    return Array.isArray(raw) ? raw.map((r)=>({
            ...r,
            hoStatus: $4e56623d4da7ea32$var$normalizeHoStatusFromApi(r.hoStatus)
        })) : [];
}
async function $4e56623d4da7ea32$export$8c0371f2fbdd8973(rows) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/leads/table-bulk`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            leads: rows
        })
    });
    if (!res.ok) throw new Error(await $4e56623d4da7ea32$var$parseError(res));
    return res.json();
}
async function $4e56623d4da7ea32$export$efe6a7e4a0d6e085(leadId, hoStatus) {
    const id = encodeURIComponent(String(leadId ?? "").trim());
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/leads/table/${id}/status`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        /** `status` mirrors `hoStatus` so older API builds that only read `status` still receive the HO value. */ body: JSON.stringify({
            hoStatus: hoStatus,
            status: hoStatus
        })
    });
    if (!res.ok) throw new Error(await $4e56623d4da7ea32$var$parseError(res));
    return res.json();
}




var $7UyaH = parcelRequire("7UyaH");

const $31cf9fc3a9a2985f$export$82da3ba69147bdb0 = [
    "List 1",
    "List 2",
    "List 3"
];
const $31cf9fc3a9a2985f$export$dfb71a523c3ab644 = [
    "Pending",
    "Interested",
    "Not Interested"
];
function $31cf9fc3a9a2985f$export$50304b75f82eebea({ target: target, onClose: onClose, onSaved: onSaved }) {
    const [appNo, setAppNo] = (0, $7UyaH.useState)("");
    const [appName, setAppName] = (0, $7UyaH.useState)("");
    const [mobile, setMobile] = (0, $7UyaH.useState)("");
    const [aadhar, setAadhar] = (0, $7UyaH.useState)("");
    const [listType, setListType] = (0, $7UyaH.useState)(()=>$31cf9fc3a9a2985f$export$82da3ba69147bdb0[0]);
    const [status, setStatus] = (0, $7UyaH.useState)($31cf9fc3a9a2985f$export$dfb71a523c3ab644[0]);
    const [busy, setBusy] = (0, $7UyaH.useState)(false);
    const [error, setError] = (0, $7UyaH.useState)(null);
    const firstRef = (0, $7UyaH.useRef)(null);
    (0, $7UyaH.useEffect)(()=>{
        firstRef.current?.focus();
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        if (!$31cf9fc3a9a2985f$export$82da3ba69147bdb0.includes(listType)) setListType($31cf9fc3a9a2985f$export$82da3ba69147bdb0[0]);
    }, [
        listType
    ]);
    (0, $7UyaH.useEffect)(()=>{
        const fn = (e)=>{
            if (e.key === "Escape") onClose();
        };
        document.addEventListener("keydown", fn);
        return ()=>document.removeEventListener("keydown", fn);
    }, [
        onClose
    ]);
    async function submit(e) {
        e.preventDefault();
        setError(null);
        if (!appNo.trim()) {
            setError("Application No is required.");
            return;
        }
        if (!appName.trim()) {
            setError("Application Name is required.");
            return;
        }
        setBusy(true);
        try {
            const combinedStatus = [
                listType,
                status
            ].filter(Boolean).join(" \xb7 ");
            await (0, $4e56623d4da7ea32$export$8c0371f2fbdd8973)([
                {
                    leadId: appNo.trim(),
                    district: target.district,
                    mandal: target.mandal,
                    village: target.village,
                    applicantName: appName.trim() || null,
                    mobileNumber: mobile.trim() || null,
                    aadhaarNumber: aadhar.trim() || null,
                    status: combinedStatus
                }
            ]);
            onSaved();
            onClose();
        } catch (err) {
            setError(err instanceof Error ? err.message : "Failed to save lead.");
        } finally{
            setBusy(false);
        }
    }
    const fieldStyle = {
        width: "100%",
        padding: "0.45rem 0.7rem",
        border: "1.5px solid #cbd5e1",
        borderRadius: "7px",
        fontSize: "0.875rem",
        outline: "none",
        background: "#fff",
        color: "#1e293b",
        boxSizing: "border-box"
    };
    const readonlyStyle = {
        ...fieldStyle,
        background: "#f1f5f9",
        color: "#64748b"
    };
    const labelStyle = {
        fontSize: "0.78rem",
        fontWeight: 600,
        color: "#374151",
        marginBottom: "4px",
        display: "block"
    };
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
        style: {
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "1rem"
        },
        onClick: (e)=>{
            if (e.target === e.currentTarget) onClose();
        },
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
            style: {
                background: "#fff",
                borderRadius: "12px",
                width: "100%",
                maxWidth: "480px",
                boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
                overflow: "hidden"
            },
            children: [
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    style: {
                        background: "#1e3a5f",
                        padding: "1rem 1.25rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    style: {
                                        color: "#fff",
                                        fontWeight: 700,
                                        fontSize: "1rem"
                                    },
                                    children: "Add Lead"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    style: {
                                        color: "#93c5fd",
                                        fontSize: "0.75rem",
                                        marginTop: "2px"
                                    },
                                    children: [
                                        target.district,
                                        " \u203A ",
                                        target.mandal,
                                        " \u203A ",
                                        target.village
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            onClick: onClose,
                            style: {
                                background: "none",
                                border: "none",
                                color: "#93c5fd",
                                fontSize: "1.3rem",
                                cursor: "pointer",
                                lineHeight: 1
                            },
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("form", {
                    onSubmit: (e)=>void submit(e),
                    style: {
                        padding: "1.25rem",
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.9rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            style: {
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr 1fr",
                                gap: "0.75rem"
                            },
                            children: [
                                [
                                    "District",
                                    target.district
                                ],
                                [
                                    "Mandal",
                                    target.mandal
                                ],
                                [
                                    "Village",
                                    target.village
                                ]
                            ].map(([lbl, val])=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                            style: labelStyle,
                                            children: lbl
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                            value: val,
                                            readOnly: true,
                                            style: readonlyStyle
                                        })
                                    ]
                                }, lbl))
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            style: {
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "0.75rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                            style: labelStyle,
                                            children: [
                                                "Application No ",
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                    style: {
                                                        color: "#ef4444"
                                                    },
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                            ref: firstRef,
                                            value: appNo,
                                            onChange: (e)=>setAppNo(e.target.value),
                                            placeholder: "e.g. 204852/1075289",
                                            style: fieldStyle
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                            style: labelStyle,
                                            children: [
                                                "Applicant Name ",
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                    style: {
                                                        color: "#ef4444"
                                                    },
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                            value: appName,
                                            onChange: (e)=>setAppName(e.target.value),
                                            placeholder: "Full name",
                                            style: fieldStyle
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            style: {
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "0.75rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                            style: labelStyle,
                                            children: "Mobile Number"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                            value: mobile,
                                            onChange: (e)=>setMobile(e.target.value),
                                            placeholder: "10-digit number",
                                            maxLength: 10,
                                            style: fieldStyle
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                            style: labelStyle,
                                            children: "Aadhar Number"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                            value: aadhar,
                                            onChange: (e)=>setAadhar(e.target.value),
                                            placeholder: "12-digit number",
                                            maxLength: 12,
                                            style: fieldStyle
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            style: {
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "0.75rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                            style: labelStyle,
                                            children: "Initial List Type"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("select", {
                                            value: $31cf9fc3a9a2985f$export$82da3ba69147bdb0.includes(listType) ? listType : $31cf9fc3a9a2985f$export$82da3ba69147bdb0[0],
                                            onChange: (e)=>setListType(e.target.value),
                                            style: {
                                                ...fieldStyle
                                            },
                                            children: $31cf9fc3a9a2985f$export$82da3ba69147bdb0.map((t)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                    value: t,
                                                    children: t
                                                }, t))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                            style: labelStyle,
                                            children: "Application Status"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("select", {
                                            value: status,
                                            onChange: (e)=>setStatus(e.target.value),
                                            style: {
                                                ...fieldStyle
                                            },
                                            children: $31cf9fc3a9a2985f$export$dfb71a523c3ab644.map((s)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                    value: s,
                                                    children: s
                                                }, s))
                                        })
                                    ]
                                })
                            ]
                        }),
                        error && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            style: {
                                padding: "0.5rem 0.75rem",
                                background: "#fef2f2",
                                border: "1px solid #fca5a5",
                                borderRadius: "6px",
                                color: "#b91c1c",
                                fontSize: "0.8rem"
                            },
                            children: error
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "0.6rem",
                                marginTop: "0.25rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    onClick: onClose,
                                    disabled: busy,
                                    style: {
                                        padding: "0.45rem 1.1rem",
                                        borderRadius: "7px",
                                        border: "1.5px solid #cbd5e1",
                                        background: "#fff",
                                        color: "#374151",
                                        fontWeight: 600,
                                        fontSize: "0.875rem",
                                        cursor: "pointer"
                                    },
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "submit",
                                    disabled: busy,
                                    style: {
                                        padding: "0.45rem 1.25rem",
                                        borderRadius: "7px",
                                        border: "none",
                                        background: busy ? "#93c5fd" : "#1d4ed8",
                                        color: "#fff",
                                        fontWeight: 700,
                                        fontSize: "0.875rem",
                                        cursor: busy ? "not-allowed" : "pointer"
                                    },
                                    children: busy ? "Saving\u2026" : "Save Lead"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}



function $e2c4aa93a7901816$export$daaafb7835a1961e(status) {
    const s = String(status ?? "");
    if (/\bnot\s*interested\b/i.test(s)) return "not_interested";
    if (/\binterested\b/i.test(s)) return "interested";
    return "other";
}
function $e2c4aa93a7901816$export$dc60e879207a129(status) {
    const k = $e2c4aa93a7901816$export$daaafb7835a1961e(status);
    if (k === "interested") return "Interested";
    if (k === "not_interested") return "Not interested";
    return $e2c4aa93a7901816$export$6d4cf67f6f13bbd1(status);
}
function $e2c4aa93a7901816$export$4ab39ebe6cc8281b(row, filter) {
    if (filter === "all") return true;
    const kind = $e2c4aa93a7901816$export$daaafb7835a1961e(row.status);
    if (filter === "interested") return kind === "interested";
    if (filter === "not_interested") return kind === "not_interested";
    return kind === "other";
}
function $e2c4aa93a7901816$export$7895be5d7389e56a(hoStatus) {
    const s = String(hoStatus ?? "").trim().toLowerCase().replace(/\s+/g, "_");
    if (!s) return "none";
    if (s === "approve" || s === "approved") return "approved";
    if (s === "reject" || s === "rejected") return "reject";
    if (s === "on_hold" || s === "onhold" || s === "hold") return "on_hold";
    return "none";
}
function $e2c4aa93a7901816$export$7f410a2e326a592c(hoStatus) {
    const k = $e2c4aa93a7901816$export$7895be5d7389e56a(hoStatus);
    if (k === "approved") return "Approved";
    if (k === "reject") return "Reject";
    if (k === "on_hold") return "On hold";
    return "\u2014";
}
function $e2c4aa93a7901816$export$6d4cf67f6f13bbd1(status) {
    const s = String(status ?? "").trim();
    if (!s) return "\u2014";
    if (s.toLowerCase() === "pending") return "Pending";
    return s;
}
function $e2c4aa93a7901816$export$46f3e6949209f1cd(row, filter) {
    if (filter === "all") return true;
    const hoKind = $e2c4aa93a7901816$export$7895be5d7389e56a(row.hoStatus);
    if (filter === "pending") return hoKind === "none" && $e2c4aa93a7901816$export$daaafb7835a1961e(row.status) === "interested";
    return hoKind === filter;
}
function $e2c4aa93a7901816$export$8e5ecea902864081(row, opts, geo) {
    return (0, $65d82a3223f822b8$export$16b9f92e753bd4d0)(geo, row, opts);
}


function $de2781d7b399f7c5$var$reportTabLabel(tab) {
    if (tab === "overview") return "Overview";
    return tab.charAt(0).toUpperCase() + tab.slice(1);
}
function $de2781d7b399f7c5$var$viewFromSearch(params) {
    const dRaw = params.get("district");
    const mRaw = params.get("mandal");
    const vRaw = params.get("village");
    const d = dRaw?.trim() ?? null;
    const m = mRaw?.trim() ?? null;
    const v = vRaw?.trim() ?? null;
    if (d && m && v) return {
        screen: "applicants",
        district: d,
        mandal: m,
        village: v
    };
    if (d && m) return {
        screen: "villages",
        district: d,
        mandal: m
    };
    if (d) return {
        screen: "mandals",
        district: d
    };
    return {
        screen: "districts"
    };
}
function $de2781d7b399f7c5$var$reportsUrl(parts) {
    const q = new URLSearchParams();
    if (parts.district) q.set("district", parts.district);
    if (parts.mandal) q.set("mandal", parts.mandal);
    if (parts.village) q.set("village", parts.village);
    const s = q.toString();
    return s ? `/reports/area?${s}` : "/reports/area";
}
function $de2781d7b399f7c5$var$districtLabel(store, key) {
    return (0, $65d82a3223f822b8$export$1592aa82ad273940)(store, key);
}
function $de2781d7b399f7c5$var$statusLabelForCsv(status) {
    return (0, $bad45714fbd4da09$export$6ee1b6ba2882976e)[status];
}
function $de2781d7b399f7c5$export$8e46eca1ce0566f2() {
    const { applications: applications, milestoneTemplates: milestoneTemplates } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const { store: store, loading: geoLoading, error: geoError, refetch: refetchGeo } = (0, $60dd8507bac67e50$export$5ec0231075ddedf1)();
    const [searchParams] = (0, $e651fdaba0d48e3d$export$f1a78c17382fe22a)();
    const navigate = (0, $265aeae2597a9f58$export$9770f232ac06a008)();
    const view = (0, $7UyaH.useMemo)(()=>$de2781d7b399f7c5$var$viewFromSearch(searchParams), [
        searchParams
    ]);
    const [reportTab, setReportTab] = (0, $7UyaH.useState)("overview");
    const [leads, setLeads] = (0, $7UyaH.useState)([]);
    (0, $7UyaH.useEffect)(()=>{
        (0, $4e56623d4da7ea32$export$c20290562992eebc)().then(setLeads).catch(()=>setLeads([]));
    }, []);
    const [areaSearch, setAreaSearch] = (0, $7UyaH.useState)("");
    const [showAddLeadModal, setShowAddLeadModal] = (0, $7UyaH.useState)(false);
    const applicationsForReport = applications;
    const rowsRaw = (0, $7UyaH.useMemo)(()=>{
        if (!store) return [];
        if (view.screen === "districts") return (0, $bad45714fbd4da09$export$4f0ecbbeb220e74b)(applicationsForReport, store);
        if (view.screen === "mandals") return (0, $bad45714fbd4da09$export$8e545c043541f9f6)(applicationsForReport, view.district, store);
        if (view.screen === "villages") return (0, $bad45714fbd4da09$export$b8b53aeab39e07)(applicationsForReport, view.district, view.mandal, store);
        return [];
    }, [
        applicationsForReport,
        view,
        store
    ]);
    const rows = (0, $7UyaH.useMemo)(()=>{
        const q = areaSearch.trim().toLowerCase();
        let r = rowsRaw;
        if (q) r = r.filter((row)=>row.label.toLowerCase().includes(q));
        return r;
    }, [
        rowsRaw,
        areaSearch
    ]);
    const hasActiveTableFilters = areaSearch.trim() !== "";
    function clearTableFilters() {
        setAreaSearch("");
    }
    const directoryKpis = (0, $7UyaH.useMemo)(()=>{
        if (!store) return {
            districts: 0,
            mandals: 0,
            villages: 0
        };
        if (view.screen === "districts") {
            const t = store.tgDirectoryAggregateCounts();
            return {
                districts: t.districts,
                mandals: t.mandals,
                villages: t.villages
            };
        }
        if (view.screen === "mandals") {
            const t = store.tgDirectoryCountsForDistrict(view.district);
            return {
                districts: 1,
                mandals: t.mandals,
                villages: t.villages
            };
        }
        if (view.screen === "villages") {
            const v = store.tgVillageCountForMandal(view.district, view.mandal);
            return {
                districts: 1,
                mandals: 1,
                villages: v
            };
        }
        return {
            districts: 0,
            mandals: 0,
            villages: 0
        };
    }, [
        store,
        view
    ]);
    const applicantRows = (0, $7UyaH.useMemo)(()=>{
        if (view.screen !== "applicants") return [];
        return (0, $bad45714fbd4da09$export$f8ee0d4f5fe56add)(applications, view.district, view.mandal, view.village, store);
    }, [
        applications,
        view
    ]);
    const leadsForView = (0, $7UyaH.useMemo)(()=>{
        let f = leads;
        if (!store) return f;
        if (view.screen === "mandals" || view.screen === "villages" || view.screen === "applicants") f = f.filter((l)=>(0, $77f9294c77fbab2e$export$bf463aeed8846c53)(store, view.district, l.district));
        if (view.screen === "villages" || view.screen === "applicants") {
            const mn = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(view.mandal);
            f = f.filter((l)=>(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(l.mandal ?? "") === mn);
        }
        if (view.screen === "applicants") {
            const vn = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(view.village);
            f = f.filter((l)=>(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(l.village ?? "") === vn);
        }
        return f;
    }, [
        leads,
        view
    ]);
    const appsForView = (0, $7UyaH.useMemo)(()=>{
        let f = applicationsForReport;
        if (!store) return f;
        if (view.screen === "mandals" || view.screen === "villages" || view.screen === "applicants") f = f.filter((a)=>(0, $77f9294c77fbab2e$export$bf463aeed8846c53)(store, view.district, a.district));
        if (view.screen === "villages" || view.screen === "applicants") {
            const mn = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(view.mandal);
            f = f.filter((a)=>(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(a.mandal ?? "") === mn);
        }
        if (view.screen === "applicants") {
            const vn = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(view.village);
            f = f.filter((a)=>(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(a.village ?? "") === vn);
        }
        return f;
    }, [
        applicationsForReport,
        view
    ]);
    const leadsKpis = (0, $7UyaH.useMemo)(()=>{
        const total = leadsForView.length;
        const approved = leadsForView.filter((l)=>(0, $e2c4aa93a7901816$export$7895be5d7389e56a)(l.hoStatus) === "approved").length;
        const rejected = leadsForView.filter((l)=>(0, $e2c4aa93a7901816$export$7895be5d7389e56a)(l.hoStatus) === "reject").length;
        const onHold = leadsForView.filter((l)=>(0, $e2c4aa93a7901816$export$7895be5d7389e56a)(l.hoStatus) === "on_hold").length;
        return {
            total: total,
            approved: approved,
            rejected: rejected,
            onHold: onHold
        };
    }, [
        leadsForView
    ]);
    const applicantsKpis = (0, $7UyaH.useMemo)(()=>{
        const total = appsForView.length;
        const verificationPending = appsForView.filter((a)=>a.status === "pending_validation").length;
        const readyForIciciMou = appsForView.filter((a)=>a.status === "ready_for_icici" || a.status === "ready_for_mou").length;
        const mouCompleted = appsForView.filter((a)=>a.status === "icici_recorded" || a.status === "subcontractor_linked").length;
        return {
            total: total,
            verificationPending: verificationPending,
            readyForIciciMou: readyForIciciMou,
            mouCompleted: mouCompleted
        };
    }, [
        appsForView
    ]);
    // Milestone template IDs sorted by sortOrder — used to map M1/M2/M3/M4 correctly
    const sortedMilestoneIds = (0, $7UyaH.useMemo)(()=>[
            ...milestoneTemplates
        ].sort((a, b)=>a.sortOrder - b.sortOrder).map((t)=>t.id), [
        milestoneTemplates
    ]);
    const beneficiariesKpis = (0, $7UyaH.useMemo)(()=>{
        const total = appsForView.length;
        const awaitingSubcontractor = appsForView.filter((a)=>a.status === "icici_recorded").length;
        const subcontracted = appsForView.filter((a)=>a.status === "subcontractor_linked").length;
        const workInitiation = appsForView.filter((a)=>Boolean(a.plannedStartDate)).length;
        const milestoneCompleted = (idx)=>{
            const tid = sortedMilestoneIds[idx];
            if (!tid) return 0;
            return appsForView.filter((a)=>a.milestoneProgress.find((m)=>m.templateId === tid)?.milestoneCompletedAt != null).length;
        };
        return {
            total: total,
            awaitingSubcontractor: awaitingSubcontractor,
            subcontracted: subcontracted,
            workInitiation: workInitiation,
            milestone1: milestoneCompleted(0),
            milestone2: milestoneCompleted(1),
            milestone3: milestoneCompleted(2),
            milestone4: milestoneCompleted(3)
        };
    }, [
        appsForView,
        sortedMilestoneIds
    ]);
    // Per-row leads stats for the table
    const leadsRowsRaw = (0, $7UyaH.useMemo)(()=>{
        if (!store) return [];
        function buildLeadRow(key, label, sub) {
            const approved = sub.filter((l)=>(0, $e2c4aa93a7901816$export$7895be5d7389e56a)(l.hoStatus) === "approved").length;
            const rejected = sub.filter((l)=>(0, $e2c4aa93a7901816$export$7895be5d7389e56a)(l.hoStatus) === "reject").length;
            const onHold = sub.filter((l)=>(0, $e2c4aa93a7901816$export$7895be5d7389e56a)(l.hoStatus) === "on_hold").length;
            return {
                key: key,
                label: label,
                total: sub.length,
                approved: approved,
                rejected: rejected,
                onHold: onHold
            };
        }
        if (view.screen === "districts") return store.tgRegistrationDistricts().map((d)=>{
            const sub = leads.filter((l)=>(0, $77f9294c77fbab2e$export$bf463aeed8846c53)(store, d.districtKey, l.district));
            return buildLeadRow(d.districtKey, (0, $65d82a3223f822b8$export$1592aa82ad273940)(store, d.districtKey), sub);
        });
        if (view.screen === "mandals") {
            const sub = leads.filter((l)=>(0, $77f9294c77fbab2e$export$bf463aeed8846c53)(store, view.district, l.district));
            const dir = store.tgMandalsForDistrict(view.district);
            const byNorm = new Map();
            for (const l of sub){
                const nk = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(l.mandal ?? "");
                if (!byNorm.has(nk)) byNorm.set(nk, []);
                byNorm.get(nk).push(l);
            }
            const rows = [];
            const used = new Set();
            for (const m of dir){
                const nk = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(m.mandalName);
                rows.push(buildLeadRow(m.mandalName, m.mandalName, byNorm.get(nk) ?? []));
                used.add(nk);
            }
            for (const [nk, list] of byNorm){
                if (!nk || used.has(nk)) continue;
                const label = list[0].mandal?.trim() || "Unspecified mandal";
                rows.push(buildLeadRow(label, label, list));
            }
            return rows.sort((a, b)=>a.label.localeCompare(b.label, "en"));
        }
        if (view.screen === "villages") {
            const mn = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(view.mandal);
            const sub = leads.filter((l)=>(0, $77f9294c77fbab2e$export$bf463aeed8846c53)(store, view.district, l.district ?? "") && (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(l.mandal ?? "") === mn);
            const dir = store.tgVillagesForMandal(view.district, view.mandal);
            const byNorm = new Map();
            for (const l of sub){
                const nk = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(l.village ?? "");
                if (!byNorm.has(nk)) byNorm.set(nk, []);
                byNorm.get(nk).push(l);
            }
            const rows = [];
            const used = new Set();
            for (const v of dir){
                const nk = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(v.name);
                rows.push(buildLeadRow(v.name, v.name, byNorm.get(nk) ?? []));
                used.add(nk);
            }
            for (const [nk, list] of byNorm){
                if (!nk || used.has(nk)) continue;
                const label = list[0].village?.trim() || "Unspecified village";
                rows.push(buildLeadRow(label, label, list));
            }
            return rows.sort((a, b)=>a.label.localeCompare(b.label, "en"));
        }
        return [];
    }, [
        leads,
        view,
        store
    ]);
    // Per-row beneficiary + milestone stats for the table
    const beneficiaryRowsRaw = (0, $7UyaH.useMemo)(()=>{
        if (!store) return [];
        return rowsRaw.map((row)=>{
            let appsInRow;
            if (view.screen === "districts") appsInRow = applicationsForReport.filter((a)=>(0, $77f9294c77fbab2e$export$bf463aeed8846c53)(store, row.key, a.district));
            else if (view.screen === "mandals") {
                const nk = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(row.key);
                appsInRow = applicationsForReport.filter((a)=>(0, $77f9294c77fbab2e$export$bf463aeed8846c53)(store, view.district, a.district) && (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(a.mandal ?? "") === nk);
            } else if (view.screen === "villages") {
                const mn = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(view.mandal);
                const vk = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(row.key);
                appsInRow = applicationsForReport.filter((a)=>(0, $77f9294c77fbab2e$export$bf463aeed8846c53)(store, view.district, a.district) && (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(a.mandal ?? "") === mn && (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(a.village ?? "") === vk);
            } else appsInRow = [];
            return {
                ...row,
                awaitingSubcontractor: appsInRow.filter((a)=>a.status === "icici_recorded").length,
                subcontracted: appsInRow.filter((a)=>a.status === "subcontractor_linked").length,
                workInitiation: appsInRow.filter((a)=>Boolean(a.plannedStartDate)).length,
                milestone1: (()=>{
                    const tid = sortedMilestoneIds[0];
                    return tid ? appsInRow.filter((a)=>a.milestoneProgress.find((m)=>m.templateId === tid)?.milestoneCompletedAt != null).length : 0;
                })(),
                milestone2: (()=>{
                    const tid = sortedMilestoneIds[1];
                    return tid ? appsInRow.filter((a)=>a.milestoneProgress.find((m)=>m.templateId === tid)?.milestoneCompletedAt != null).length : 0;
                })(),
                milestone3: (()=>{
                    const tid = sortedMilestoneIds[2];
                    return tid ? appsInRow.filter((a)=>a.milestoneProgress.find((m)=>m.templateId === tid)?.milestoneCompletedAt != null).length : 0;
                })(),
                milestone4: (()=>{
                    const tid = sortedMilestoneIds[3];
                    return tid ? appsInRow.filter((a)=>a.milestoneProgress.find((m)=>m.templateId === tid)?.milestoneCompletedAt != null).length : 0;
                })()
            };
        });
    }, [
        rowsRaw,
        applicationsForReport,
        view,
        sortedMilestoneIds
    ]);
    const leadsRows = (0, $7UyaH.useMemo)(()=>{
        const q = areaSearch.trim().toLowerCase();
        if (!q) return leadsRowsRaw;
        return leadsRowsRaw.filter((r)=>r.label.toLowerCase().includes(q));
    }, [
        leadsRowsRaw,
        areaSearch
    ]);
    const beneficiaryRows = (0, $7UyaH.useMemo)(()=>{
        const q = areaSearch.trim().toLowerCase();
        if (!q) return beneficiaryRowsRaw;
        return beneficiaryRowsRaw.filter((r)=>r.label.toLowerCase().includes(q));
    }, [
        beneficiaryRowsRaw,
        areaSearch
    ]);
    const applicantRowsRaw = (0, $7UyaH.useMemo)(()=>{
        return rowsRaw.map((row)=>({
                ...row,
                verificationPending: row.byStatus.pending_validation,
                readyForIciciMou: row.byStatus.ready_for_icici + row.byStatus.ready_for_mou,
                mouCompleted: row.byStatus.icici_recorded + row.byStatus.subcontractor_linked
            }));
    }, [
        rowsRaw
    ]);
    const applicantTableRows = (0, $7UyaH.useMemo)(()=>{
        const q = areaSearch.trim().toLowerCase();
        if (!q) return applicantRowsRaw;
        return applicantRowsRaw.filter((r)=>r.label.toLowerCase().includes(q));
    }, [
        applicantRowsRaw,
        areaSearch
    ]);
    const activeRawRows = reportTab === "overview" ? [] : reportTab === "leads" ? leadsRowsRaw : reportTab === "applicants" ? applicantRowsRaw : beneficiaryRowsRaw;
    const activeRows = reportTab === "overview" ? [] : reportTab === "leads" ? leadsRows : reportTab === "applicants" ? applicantTableRows : beneficiaryRows;
    const pendingLeads = leadsKpis.total - leadsKpis.approved - leadsKpis.rejected - leadsKpis.onHold;
    const onHoldCount = (0, $7UyaH.useMemo)(()=>appsForView.filter((a)=>a.status === "on_hold").length, [
        appsForView
    ]);
    /** High-level snapshot for the Overview tab (same geographic scope as other tabs). */ const overviewTotals = (0, $7UyaH.useMemo)(()=>({
            totalLeads: leadsKpis.total,
            totalApplicants: applicantsKpis.total,
            totalBeneficiaries: appsForView.filter((a)=>a.status === "subcontractor_linked").length
        }), [
        leadsKpis.total,
        applicantsKpis.total,
        appsForView
    ]);
    const title = view.screen === "districts" ? "Area reports \u2014 District" : view.screen === "mandals" ? `Area reports \u{2014} Mandals (${$de2781d7b399f7c5$var$districtLabel(store, view.district)})` : view.screen === "villages" ? `Area reports \u{2014} Villages (${view.mandal})` : `Applicants \u{2014} ${view.village}`;
    const breadcrumb = (0, $7UyaH.useMemo)(()=>{
        if (view.screen === "districts") return [
            {
                label: "Home",
                to: "/"
            },
            {
                label: "Reports Hub",
                to: "/reports"
            },
            {
                label: "Area reports"
            }
        ];
        if (view.screen === "mandals") return [
            {
                label: "Home",
                to: "/"
            },
            {
                label: "Reports Hub",
                to: "/reports"
            },
            {
                label: "Area reports",
                to: "/reports/area"
            },
            {
                label: $de2781d7b399f7c5$var$districtLabel(store, view.district)
            }
        ];
        if (view.screen === "villages") return [
            {
                label: "Home",
                to: "/"
            },
            {
                label: "Reports Hub",
                to: "/reports"
            },
            {
                label: "Area reports",
                to: "/reports/area"
            },
            {
                label: $de2781d7b399f7c5$var$districtLabel(store, view.district),
                to: $de2781d7b399f7c5$var$reportsUrl({
                    district: view.district
                })
            },
            {
                label: view.mandal
            }
        ];
        return [
            {
                label: "Home",
                to: "/"
            },
            {
                label: "Reports Hub",
                to: "/reports"
            },
            {
                label: "Area reports",
                to: "/reports/area"
            },
            {
                label: $de2781d7b399f7c5$var$districtLabel(store, view.district),
                to: $de2781d7b399f7c5$var$reportsUrl({
                    district: view.district
                })
            },
            {
                label: view.mandal,
                to: $de2781d7b399f7c5$var$reportsUrl({
                    district: view.district,
                    mandal: view.mandal
                })
            },
            {
                label: view.village
            }
        ];
    }, [
        view
    ]);
    function goBack() {
        if (view.screen === "mandals") navigate("/reports/area");
        else if (view.screen === "villages") navigate($de2781d7b399f7c5$var$reportsUrl({
            district: view.district
        }));
        else if (view.screen === "applicants") navigate($de2781d7b399f7c5$var$reportsUrl({
            district: view.district,
            mandal: view.mandal
        }));
    }
    function downloadAggregateCsv() {
        const areaCol = view.screen === "districts" ? "District" : view.screen === "mandals" ? "Mandal" : "Village";
        const h = (0, $bad45714fbd4da09$export$a77e2ad0c8d8008a)(areaCol);
        const dataRows = rows.map((0, $bad45714fbd4da09$export$3316ef93e894491a));
        const name = view.screen === "districts" ? "report-districts" : view.screen === "mandals" ? `report-mandals-${view.district}` : `report-villages-${view.district}-${view.mandal.replace(/\s+/g, "_")}`;
        (0, $dc744e52b043da5b$export$c6d851d1877b46af)(`${name}.csv`, h, dataRows);
    }
    function downloadApplicantsCsv() {
        if (view.screen !== "applicants") return;
        const h = [
            "Application ID",
            "Mobile app ref",
            "Beneficiary",
            "Father / husband",
            "District",
            "Mandal",
            "Village",
            "Status",
            "Received (UTC)",
            "House sanction"
        ];
        const data = applicantRows.map((a)=>[
                a.id,
                a.mobile.applicationId,
                a.mobile.beneficiaryName,
                a.mobile.fatherOrHusbandName,
                $de2781d7b399f7c5$var$districtLabel(store, a.district),
                a.mandal,
                a.village,
                $de2781d7b399f7c5$var$statusLabelForCsv(a.status),
                a.receivedAt,
                a.mobile.houseSanctionNumber
            ]);
        (0, $dc744e52b043da5b$export$c6d851d1877b46af)(`report-applicants-${view.district}-${view.mandal}-${view.village}.csv`.replace(/\s+/g, "_"), h, data);
    }
    if (geoError) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Reports Hub",
                        to: "/reports"
                    },
                    {
                        label: "Area reports"
                    }
                ],
                title: "Area reports",
                subtitle: "Geographic directory could not be loaded"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--elevated geo-reports",
                style: {
                    padding: "1.25rem 1.5rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "geo-reports__cell-main",
                        children: "The district\u2013mandal\u2013village master is served from the API database."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        style: {
                            marginTop: "0.5rem"
                        },
                        children: geoError
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "text-muted",
                        style: {
                            marginTop: "0.75rem"
                        },
                        children: [
                            "Run the API (",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("code", {
                                children: "npm run dev"
                            }),
                            " from the repo root) with ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("code", {
                                children: "server/.env"
                            }),
                            " pointing at MariaDB/MySQL, or open ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("code", {
                                children: "http://localhost:4000/api/geo/directory"
                            }),
                            " to verify. If you use MySQL, run ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("code", {
                                children: "npm run seed:geo:mysql -w server"
                            }),
                            " once to create and fill ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("code", {
                                children: "geo_directory_*"
                            }),
                            " ",
                            "tables."
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--primary btn--sm",
                        style: {
                            marginTop: "1rem"
                        },
                        onClick: ()=>void refetchGeo(),
                        children: "Retry"
                    })
                ]
            })
        ]
    });
    if (geoLoading || !store) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Reports Hub",
                        to: "/reports"
                    },
                    {
                        label: "Area reports"
                    }
                ],
                title: "Area reports",
                subtitle: "Loading geographic directory from server\u2026"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "card card--elevated geo-reports",
                style: {
                    padding: "1.25rem 1.5rem"
                },
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                    className: "text-muted",
                    children: "Fetching district, mandal, and village data from the database."
                })
            })
        ]
    });
    // ── helper: pct string ──────────────────────────────────────────────────────
    function pct(n, base) {
        if (!base) return "\u2014";
        return `${Math.round(n / base * 100)}%`;
    }
    // ── navigate helper for table & top-areas clicks ─────────────────────────
    function drillInto(key) {
        if (view.screen === "districts") navigate($de2781d7b399f7c5$var$reportsUrl({
            district: key
        }));
        else if (view.screen === "mandals") navigate($de2781d7b399f7c5$var$reportsUrl({
            district: view.district,
            mandal: key
        }));
        else if (view.screen === "villages") navigate($de2781d7b399f7c5$var$reportsUrl({
            district: view.district,
            mandal: view.mandal,
            village: key
        }));
    }
    // ── scope breadcrumb labels ───────────────────────────────────────────────
    const scopeCrumbs = view.screen === "districts" ? [
        {
            label: "Telangana",
            active: false
        },
        {
            label: `${directoryKpis.districts} Districts`,
            active: false
        },
        {
            label: `${directoryKpis.mandals} Mandals`,
            active: false
        },
        {
            label: `${directoryKpis.villages} Villages`,
            active: true
        }
    ] : view.screen === "mandals" ? [
        {
            label: "Telangana",
            active: false
        },
        {
            label: $de2781d7b399f7c5$var$districtLabel(store, view.district),
            active: false
        },
        {
            label: `${directoryKpis.mandals} Mandals`,
            active: false
        },
        {
            label: `${directoryKpis.villages} Villages`,
            active: true
        }
    ] : view.screen === "villages" ? [
        {
            label: "Telangana",
            active: false
        },
        {
            label: $de2781d7b399f7c5$var$districtLabel(store, view.district),
            active: false
        },
        {
            label: view.mandal,
            active: false
        },
        {
            label: `${directoryKpis.villages} Villages`,
            active: true
        }
    ] : [];
    const showScope = view.screen !== "applicants" && scopeCrumbs.length > 0;
    const scopeNode = showScope ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
        className: "bi2-scope-bar bi2-scope-bar--inline",
        "aria-label": "Geographic scope",
        children: scopeCrumbs.map((crumb, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem"
                },
                children: [
                    i > 0 && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "bi2-scope-sep",
                        children: "/"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: `bi2-scope-crumb${crumb.active ? " bi2-scope-crumb--active" : ""}`,
                        children: crumb.label
                    })
                ]
            }, i))
    }) : null;
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: breadcrumb.map((c)=>c.to ? {
                        label: c.label,
                        to: c.to
                    } : {
                        label: c.label
                    }),
                title: title,
                subtitle: view.screen === "applicants" ? "Dossiers in this village. Open a row to work the file." : undefined,
                actions: view.screen !== "districts" || showScope ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "geo-reports__actions",
                    children: [
                        scopeNode,
                        view.screen !== "districts" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            className: "btn btn--secondary btn--sm",
                            onClick: goBack,
                            children: "\u2190 Back"
                        }) : null
                    ]
                }) : undefined
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "bi2-tabs",
                role: "tablist",
                "aria-label": "Report category",
                children: [
                    "overview",
                    "leads",
                    "applicants",
                    "beneficiaries"
                ].map((tab)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        role: "tab",
                        "aria-selected": reportTab === tab,
                        className: `bi2-tab${reportTab === tab ? " bi2-tab--active" : ""}`,
                        onClick: ()=>setReportTab(tab),
                        children: $de2781d7b399f7c5$var$reportTabLabel(tab)
                    }, tab))
            }),
            (()=>{
                return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                    className: "bi2-kpi-grid",
                    "aria-label": `${reportTab} KPIs`,
                    role: "tabpanel",
                    children: reportTab === "overview" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#0f172a"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: overviewTotals.totalLeads.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "Total Leads"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#2563eb"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: overviewTotals.totalApplicants.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "Total Applicants"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#15803d"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: overviewTotals.totalBeneficiaries.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "Total Beneficiaries"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "text-muted",
                                        style: {
                                            margin: "0.35rem 0 0",
                                            fontSize: "0.7rem",
                                            lineHeight: 1.35,
                                            fontWeight: 500
                                        },
                                        children: "With subcontractor linked (construction stage)"
                                    })
                                ]
                            })
                        ]
                    }) : reportTab === "leads" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#0f172a"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: leadsKpis.total.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "Total Leads"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#16a34a"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__pct",
                                        style: {
                                            background: "#dcfce7",
                                            color: "#16a34a"
                                        },
                                        children: pct(leadsKpis.approved, leadsKpis.total)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: leadsKpis.approved.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "Approved"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#dc2626"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__pct",
                                        style: {
                                            background: "#fee2e2",
                                            color: "#dc2626"
                                        },
                                        children: pct(leadsKpis.rejected, leadsKpis.total)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: leadsKpis.rejected.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "Rejected"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#d97706"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__pct",
                                        style: {
                                            background: "#fef3c7",
                                            color: "#d97706"
                                        },
                                        children: pct(leadsKpis.onHold, leadsKpis.total)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: leadsKpis.onHold.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "On hold"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#64748b"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__pct",
                                        style: {
                                            background: "#f1f5f9",
                                            color: "#64748b"
                                        },
                                        children: pct(pendingLeads, leadsKpis.total)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: pendingLeads.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "Pending"
                                    })
                                ]
                            })
                        ]
                    }) : reportTab === "applicants" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#0f172a"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: applicantsKpis.total.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "Total Applicants"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#d97706"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__pct",
                                        style: {
                                            background: "#fef3c7",
                                            color: "#d97706"
                                        },
                                        children: pct(applicantsKpis.verificationPending, applicantsKpis.total)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: applicantsKpis.verificationPending.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "Verif. Pending"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#0891b2"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__pct",
                                        style: {
                                            background: "#cffafe",
                                            color: "#0891b2"
                                        },
                                        children: pct(applicantsKpis.readyForIciciMou, applicantsKpis.total)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: applicantsKpis.readyForIciciMou.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "Ready ICICI & MOU"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#16a34a"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__pct",
                                        style: {
                                            background: "#dcfce7",
                                            color: "#16a34a"
                                        },
                                        children: pct(applicantsKpis.mouCompleted, applicantsKpis.total)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: applicantsKpis.mouCompleted.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "MOU Completed"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#dc2626"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__pct",
                                        style: {
                                            background: "#fee2e2",
                                            color: "#dc2626"
                                        },
                                        children: pct(onHoldCount, applicantsKpis.total)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: onHoldCount.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "On Hold"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#0f172a"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: beneficiariesKpis.total.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "Total Beneficiaries"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#d97706"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__pct",
                                        style: {
                                            background: "#fef3c7",
                                            color: "#d97706"
                                        },
                                        children: pct(beneficiariesKpis.awaitingSubcontractor, beneficiariesKpis.total)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: beneficiariesKpis.awaitingSubcontractor.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "Awaiting SC"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#0891b2"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__pct",
                                        style: {
                                            background: "#cffafe",
                                            color: "#0891b2"
                                        },
                                        children: pct(beneficiariesKpis.subcontracted, beneficiariesKpis.total)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: beneficiariesKpis.subcontracted.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "Subcontracted"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#7c3aed"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__pct",
                                        style: {
                                            background: "#ede9fe",
                                            color: "#7c3aed"
                                        },
                                        children: pct(beneficiariesKpis.workInitiation, beneficiariesKpis.total)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: beneficiariesKpis.workInitiation.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "Work Initiation"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#4ade80"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__pct",
                                        style: {
                                            background: "#dcfce7",
                                            color: "#16a34a"
                                        },
                                        children: pct(beneficiariesKpis.milestone1, beneficiariesKpis.total)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: beneficiariesKpis.milestone1.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "Milestone 1"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#22c55e"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__pct",
                                        style: {
                                            background: "#dcfce7",
                                            color: "#16a34a"
                                        },
                                        children: pct(beneficiariesKpis.milestone2, beneficiariesKpis.total)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: beneficiariesKpis.milestone2.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "Milestone 2"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#16a34a"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__pct",
                                        style: {
                                            background: "#dcfce7",
                                            color: "#16a34a"
                                        },
                                        children: pct(beneficiariesKpis.milestone3, beneficiariesKpis.total)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: beneficiariesKpis.milestone3.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "Milestone 3"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "bi2-kpi",
                                style: {
                                    "--kpi-color": "#15803d"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__pct",
                                        style: {
                                            background: "#dcfce7",
                                            color: "#15803d"
                                        },
                                        children: pct(beneficiariesKpis.milestone4, beneficiariesKpis.total)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__num",
                                        children: beneficiariesKpis.milestone4.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "bi2-kpi__label",
                                        children: "Milestone 4"
                                    })
                                ]
                            })
                        ]
                    })
                });
            })(),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "bi2-table-card",
                children: reportTab === "overview" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "geo-reports__overview-placeholder",
                    role: "region",
                    "aria-label": "Detail tables",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                            className: "geo-reports__overview-placeholder-title",
                            children: "Area breakdown & lists"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                            className: "text-muted",
                            style: {
                                margin: "0.25rem 0 0",
                                maxWidth: "40rem"
                            },
                            children: [
                                "Use ",
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                    children: "Leads"
                                }),
                                ", ",
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                    children: "Applicants"
                                }),
                                ", or ",
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                    children: "Beneficiaries"
                                }),
                                " to open the heatmap table and row-level data for the same area."
                            ]
                        })
                    ]
                }) : view.screen === "applicants" ? /* ── Village detail: tab-aware ─────────────────────────────── */ /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                    children: [
                        reportTab === "leads" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            style: {
                                padding: "1rem 1.25rem",
                                borderBottom: "1px solid #e2e8f0"
                            },
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--primary btn--sm btn--tg",
                                onClick: ()=>setShowAddLeadModal(true),
                                children: "+ Add Lead"
                            })
                        }) : null,
                        reportTab === "leads" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "table-wrap",
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                className: "data-table geo-reports__table",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Name"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Mobile"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Aadhaar"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Status"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Date"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                        children: leadsForView.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                colSpan: 5,
                                                className: "data-table__empty",
                                                children: "No leads in this village yet."
                                            })
                                        }) : leadsForView.map((l)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        style: {
                                                            fontWeight: 600
                                                        },
                                                        children: l.applicantName || "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono",
                                                        children: l.mobileNumber || "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono text-muted",
                                                        children: l.aadhaarNumber || "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                            className: "lead-status-cell",
                                                            children: [
                                                                (0, $e2c4aa93a7901816$export$7895be5d7389e56a)(l.hoStatus) !== "none" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                    className: `lead-status-pill lead-status-pill--${(0, $e2c4aa93a7901816$export$7895be5d7389e56a)(l.hoStatus)}`,
                                                                    style: {
                                                                        fontSize: "0.6875rem"
                                                                    },
                                                                    children: (0, $e2c4aa93a7901816$export$7f410a2e326a592c)(l.hoStatus)
                                                                }) : null,
                                                                (()=>{
                                                                    const sk = (0, $e2c4aa93a7901816$export$daaafb7835a1961e)(l.status);
                                                                    const lab = (0, $e2c4aa93a7901816$export$dc60e879207a129)(l.status);
                                                                    if (sk === "interested") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                        className: "lead-status-pill lead-status-pill--interested",
                                                                        style: {
                                                                            fontSize: "0.6875rem"
                                                                        },
                                                                        children: lab
                                                                    });
                                                                    if (sk === "not_interested") return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                        className: "lead-status-pill lead-status-pill--not-interested",
                                                                        style: {
                                                                            fontSize: "0.6875rem"
                                                                        },
                                                                        children: lab
                                                                    });
                                                                    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                        className: "text-muted",
                                                                        style: {
                                                                            fontSize: "0.6875rem",
                                                                            whiteSpace: "nowrap"
                                                                        },
                                                                        children: lab
                                                                    });
                                                                })()
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "geo-reports__num",
                                                        style: {
                                                            color: "#64748b"
                                                        },
                                                        children: l.createdAt?.slice(0, 10) || "\u2014"
                                                    })
                                                ]
                                            }, l.leadId))
                                    })
                                ]
                            })
                        }) : reportTab === "applicants" ? /* Village applicants table */ /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "table-wrap",
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                className: "data-table geo-reports__table",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Application"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Beneficiary"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Status"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Received"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                        children: applicantRows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                colSpan: 4,
                                                className: "data-table__empty",
                                                children: "No applicants in this village."
                                            })
                                        }) : applicantRows.map((a)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                                                to: `/applications/${a.id}/overview`,
                                                                state: {
                                                                    from: "applicants"
                                                                },
                                                                className: "geo-reports__app-link",
                                                                children: a.id
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                className: "geo-reports__muted",
                                                                children: a.mobile.applicationId
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        style: {
                                                            fontWeight: 600
                                                        },
                                                        children: a.mobile.beneficiaryName
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                            style: {
                                                                display: "inline-block",
                                                                fontSize: "0.6875rem",
                                                                fontWeight: 600,
                                                                padding: "0.2rem 0.55rem",
                                                                borderRadius: "9999px",
                                                                background: "#f1f5f9",
                                                                color: "#475569",
                                                                whiteSpace: "nowrap"
                                                            },
                                                            children: $de2781d7b399f7c5$var$statusLabelForCsv(a.status)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "geo-reports__num",
                                                        style: {
                                                            color: "#64748b"
                                                        },
                                                        children: a.receivedAt.slice(0, 10)
                                                    })
                                                ]
                                            }, a.id))
                                    })
                                ]
                            })
                        }) : /* Village beneficiaries table */ (()=>{
                            const benRows = applicantRows.filter((a)=>a.status === "icici_recorded" || a.status === "subcontractor_linked");
                            return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "table-wrap",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                    className: "data-table geo-reports__table",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Application"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Beneficiary"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Pipeline Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Received"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                            children: benRows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    colSpan: 4,
                                                    className: "data-table__empty",
                                                    children: "No beneficiaries in this village yet."
                                                })
                                            }) : benRows.map((a)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                                                    to: `/applications/${a.id}/subcontractor`,
                                                                    state: {
                                                                        from: "beneficiaries"
                                                                    },
                                                                    className: "geo-reports__app-link",
                                                                    children: a.id
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                    className: "geo-reports__muted",
                                                                    children: a.mobile.applicationId
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            style: {
                                                                fontWeight: 600
                                                            },
                                                            children: a.mobile.beneficiaryName
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                style: {
                                                                    display: "inline-block",
                                                                    fontSize: "0.6875rem",
                                                                    fontWeight: 600,
                                                                    padding: "0.2rem 0.55rem",
                                                                    borderRadius: "9999px",
                                                                    background: a.status === "subcontractor_linked" ? "#dcfce7" : "#fef3c7",
                                                                    color: a.status === "subcontractor_linked" ? "#16a34a" : "#d97706",
                                                                    whiteSpace: "nowrap"
                                                                },
                                                                children: $de2781d7b399f7c5$var$statusLabelForCsv(a.status)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num",
                                                            style: {
                                                                color: "#64748b"
                                                            },
                                                            children: a.receivedAt.slice(0, 10)
                                                        })
                                                    ]
                                                }, a.id))
                                        })
                                    ]
                                })
                            });
                        })()
                    ]
                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "table-toolbar table-toolbar--stack",
                            children: [
                                hasActiveTableFilters ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "table-toolbar__top geo-reports__toolbar-clear-row",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--link btn--sm table-toolbar__clear",
                                        onClick: clearTableFilters,
                                        children: "Clear filters"
                                    })
                                }) : null,
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "table-filters",
                                    role: "search",
                                    "aria-label": "Filter area report",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "field table-filters__field table-filters__field--grow",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                htmlFor: "geo-report-search",
                                                children: "Search area"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                id: "geo-report-search",
                                                type: "search",
                                                placeholder: view.screen === "districts" ? "District name" : view.screen === "mandals" ? "Mandal name" : "Village name",
                                                value: areaSearch,
                                                onChange: (e)=>setAreaSearch(e.target.value),
                                                autoComplete: "off"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "table-wrap geo-reports__table-wrap",
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                className: "data-table geo-reports__table",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: view.screen === "districts" ? "District" : view.screen === "mandals" ? "Mandal" : "Village"
                                                }),
                                                reportTab === "leads" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            className: "geo-reports__num geo-reports__th-wrap",
                                                            children: "Total"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            className: "geo-reports__num geo-reports__stat geo-reports__th-wrap",
                                                            children: "Approved"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            className: "geo-reports__num geo-reports__stat geo-reports__th-wrap",
                                                            children: "Rejected"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            className: "geo-reports__num geo-reports__stat geo-reports__th-wrap",
                                                            children: "On hold"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            className: "geo-reports__num geo-reports__stat geo-reports__th-wrap",
                                                            children: "Pending"
                                                        })
                                                    ]
                                                }) : reportTab === "applicants" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            className: "geo-reports__num geo-reports__th-wrap",
                                                            children: "Total"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            className: "geo-reports__num geo-reports__stat geo-reports__th-wrap",
                                                            children: "Verif. Pending"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            className: "geo-reports__num geo-reports__stat geo-reports__th-wrap",
                                                            children: "ICICI & MOU"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            className: "geo-reports__num geo-reports__stat geo-reports__th-wrap",
                                                            children: "MOU Done"
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            className: "geo-reports__num geo-reports__th-wrap",
                                                            children: "Total"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            className: "geo-reports__num geo-reports__stat geo-reports__th-wrap",
                                                            children: "Await SC"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            className: "geo-reports__num geo-reports__stat geo-reports__th-wrap",
                                                            children: "Subctd."
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            className: "geo-reports__num geo-reports__stat geo-reports__th-wrap",
                                                            children: "Work Init."
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            className: "geo-reports__num geo-reports__stat geo-reports__th-wrap",
                                                            children: "M1"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            className: "geo-reports__num geo-reports__stat geo-reports__th-wrap",
                                                            children: "M2"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            className: "geo-reports__num geo-reports__stat geo-reports__th-wrap",
                                                            children: "M3"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            className: "geo-reports__num geo-reports__stat geo-reports__th-wrap",
                                                            children: "M4"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                        children: activeRawRows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                colSpan: 9,
                                                className: "data-table__empty",
                                                children: "No data recorded at this level yet."
                                            })
                                        }) : activeRows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                colSpan: 9,
                                                className: "data-table__empty",
                                                children: "No rows match the current filters."
                                            })
                                        }) : reportTab === "leads" ? (()=>{
                                            const maxTotal = Math.max(...leadsRows.map((r)=>r.total), 1);
                                            return leadsRows.map((row)=>{
                                                const isEmpty = row.total === 0;
                                                const pendingRow = row.total - row.approved - row.rejected - row.onHold;
                                                return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                    className: "geo-reports__row--click" + (isEmpty ? " bi2-row--dim" : ""),
                                                    onClick: ()=>drillInto(row.key),
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                    className: "geo-reports__cell-main",
                                                                    children: row.label
                                                                }),
                                                                !isEmpty ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                    className: "geo-reports__hint",
                                                                    children: " \u2197"
                                                                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                    className: "geo-reports__hint geo-reports__hint--empty",
                                                                    children: " No data"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num bi2-cell-heat",
                                                            style: {
                                                                background: `rgba(15,23,42,${row.total / maxTotal * 0.14})`
                                                            },
                                                            children: row.total
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num geo-reports__stat bi2-cell-heat",
                                                            style: {
                                                                background: row.approved > 0 ? `rgba(22,163,74,${row.approved / (row.total || 1) * 0.22})` : undefined,
                                                                color: row.approved > 0 ? "#16a34a" : "#94a3b8"
                                                            },
                                                            children: row.approved
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num geo-reports__stat bi2-cell-heat",
                                                            style: {
                                                                background: row.rejected > 0 ? `rgba(220,38,38,${row.rejected / (row.total || 1) * 0.22})` : undefined,
                                                                color: row.rejected > 0 ? "#dc2626" : "#94a3b8"
                                                            },
                                                            children: row.rejected
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num geo-reports__stat bi2-cell-heat",
                                                            style: {
                                                                background: row.onHold > 0 ? `rgba(217,119,6,${row.onHold / (row.total || 1) * 0.22})` : undefined,
                                                                color: row.onHold > 0 ? "#d97706" : "#94a3b8"
                                                            },
                                                            children: row.onHold
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num geo-reports__stat",
                                                            style: {
                                                                color: "#64748b"
                                                            },
                                                            children: pendingRow
                                                        })
                                                    ]
                                                }, row.key);
                                            });
                                        })() : reportTab === "applicants" ? (()=>{
                                            const maxTotal = Math.max(...applicantTableRows.map((r)=>r.total), 1);
                                            return applicantTableRows.map((row)=>{
                                                const isEmpty = row.total === 0;
                                                return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                    className: "geo-reports__row--click" + (isEmpty ? " bi2-row--dim" : ""),
                                                    onClick: ()=>drillInto(row.key),
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                    className: "geo-reports__cell-main",
                                                                    children: row.label
                                                                }),
                                                                !isEmpty ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                    className: "geo-reports__hint",
                                                                    children: " \u2197"
                                                                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                    className: "geo-reports__hint geo-reports__hint--empty",
                                                                    children: " No data"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num bi2-cell-heat",
                                                            style: {
                                                                background: `rgba(15,23,42,${row.total / maxTotal * 0.14})`
                                                            },
                                                            children: row.total
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num geo-reports__stat bi2-cell-heat",
                                                            style: {
                                                                background: row.verificationPending > 0 ? `rgba(217,119,6,${row.verificationPending / (row.total || 1) * 0.22})` : undefined,
                                                                color: "#d97706"
                                                            },
                                                            children: row.verificationPending
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num geo-reports__stat bi2-cell-heat",
                                                            style: {
                                                                background: row.readyForIciciMou > 0 ? `rgba(8,145,178,${row.readyForIciciMou / (row.total || 1) * 0.22})` : undefined,
                                                                color: "#0891b2"
                                                            },
                                                            children: row.readyForIciciMou
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num geo-reports__stat bi2-cell-heat",
                                                            style: {
                                                                background: row.mouCompleted > 0 ? `rgba(22,163,74,${row.mouCompleted / (row.total || 1) * 0.22})` : undefined,
                                                                color: "#16a34a"
                                                            },
                                                            children: row.mouCompleted
                                                        })
                                                    ]
                                                }, row.key);
                                            });
                                        })() : (()=>{
                                            const maxTotal = Math.max(...beneficiaryRows.map((r)=>r.total), 1);
                                            return beneficiaryRows.map((row)=>{
                                                const isEmpty = row.total === 0;
                                                return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                    className: "geo-reports__row--click" + (isEmpty ? " bi2-row--dim" : ""),
                                                    onClick: ()=>drillInto(row.key),
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                    className: "geo-reports__cell-main",
                                                                    children: row.label
                                                                }),
                                                                !isEmpty ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                    className: "geo-reports__hint",
                                                                    children: " \u2197"
                                                                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                    className: "geo-reports__hint geo-reports__hint--empty",
                                                                    children: " No data"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num bi2-cell-heat",
                                                            style: {
                                                                background: `rgba(15,23,42,${row.total / maxTotal * 0.14})`
                                                            },
                                                            children: row.total
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num geo-reports__stat bi2-cell-heat",
                                                            style: {
                                                                background: row.awaitingSubcontractor > 0 ? `rgba(217,119,6,${row.awaitingSubcontractor / (row.total || 1) * 0.22})` : undefined,
                                                                color: "#d97706"
                                                            },
                                                            children: row.awaitingSubcontractor
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num geo-reports__stat bi2-cell-heat",
                                                            style: {
                                                                background: row.subcontracted > 0 ? `rgba(8,145,178,${row.subcontracted / (row.total || 1) * 0.22})` : undefined,
                                                                color: "#0891b2"
                                                            },
                                                            children: row.subcontracted
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num geo-reports__stat bi2-cell-heat",
                                                            style: {
                                                                background: row.workInitiation > 0 ? `rgba(124,58,237,${row.workInitiation / (row.total || 1) * 0.22})` : undefined,
                                                                color: "#7c3aed"
                                                            },
                                                            children: row.workInitiation
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num geo-reports__stat bi2-cell-heat",
                                                            style: {
                                                                background: row.milestone1 > 0 ? `rgba(74,222,128,${row.milestone1 / (row.total || 1) * 0.22})` : undefined,
                                                                color: "#16a34a"
                                                            },
                                                            children: row.milestone1
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num geo-reports__stat bi2-cell-heat",
                                                            style: {
                                                                background: row.milestone2 > 0 ? `rgba(34,197,94,${row.milestone2 / (row.total || 1) * 0.22})` : undefined,
                                                                color: "#16a34a"
                                                            },
                                                            children: row.milestone2
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num geo-reports__stat bi2-cell-heat",
                                                            style: {
                                                                background: row.milestone3 > 0 ? `rgba(22,163,74,${row.milestone3 / (row.total || 1) * 0.22})` : undefined,
                                                                color: "#16a34a"
                                                            },
                                                            children: row.milestone3
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "geo-reports__num geo-reports__stat bi2-cell-heat",
                                                            style: {
                                                                background: row.milestone4 > 0 ? `rgba(21,128,61,${row.milestone4 / (row.total || 1) * 0.22})` : undefined,
                                                                color: "#15803d"
                                                            },
                                                            children: row.milestone4
                                                        })
                                                    ]
                                                }, row.key);
                                            });
                                        })()
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            showAddLeadModal && view.screen === "applicants" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $31cf9fc3a9a2985f$export$50304b75f82eebea), {
                target: {
                    district: $de2781d7b399f7c5$var$districtLabel(store, view.district),
                    mandal: view.mandal,
                    village: view.village
                },
                onClose: ()=>setShowAddLeadModal(false),
                onSaved: ()=>(0, $4e56623d4da7ea32$export$c20290562992eebc)().then(setLeads).catch(()=>{})
            }) : null
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");










/*!
  react-datepicker v9.1.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/ function $d7d433c0a2bfd01d$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $d7d433c0a2bfd01d$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $d7d433c0a2bfd01d$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $d7d433c0a2bfd01d$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $d7d433c0a2bfd01d$export$2e2bcd8739ae039 = $d7d433c0a2bfd01d$export$4f5d2d50c9deca37;



var $7UyaH = parcelRequire("7UyaH");
var $e570a7bac6dc48a8$exports = {};
"use strict";
var $d237b6d82aac5787$exports = {};

$parcel$export($d237b6d82aac5787$exports, "add", function () { return $d237b6d82aac5787$export$e16d8520af44a096; }, function (v) { return $d237b6d82aac5787$export$e16d8520af44a096 = v; });
var $d237b6d82aac5787$export$e16d8520af44a096;
"use strict";
$d237b6d82aac5787$export$e16d8520af44a096 = $d237b6d82aac5787$var$add;
var $b7f6bbd55167ab46$exports = {};

$parcel$export($b7f6bbd55167ab46$exports, "addDays", function () { return $b7f6bbd55167ab46$export$dd412b56f1e4d8aa; }, function (v) { return $b7f6bbd55167ab46$export$dd412b56f1e4d8aa = v; });
var $b7f6bbd55167ab46$export$dd412b56f1e4d8aa;
"use strict";
$b7f6bbd55167ab46$export$dd412b56f1e4d8aa = $b7f6bbd55167ab46$var$addDays;
var $838192f7942a2bce$exports = {};

$parcel$export($838192f7942a2bce$exports, "toDate", function () { return $838192f7942a2bce$export$e67a095c620b86fe; }, function (v) { return $838192f7942a2bce$export$e67a095c620b86fe = v; });
var $838192f7942a2bce$export$e67a095c620b86fe;
"use strict";
$838192f7942a2bce$export$e67a095c620b86fe = $838192f7942a2bce$var$toDate;
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $838192f7942a2bce$var$toDate(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}


var $4eb0d2dc0fda0973$exports = {};

$parcel$export($4eb0d2dc0fda0973$exports, "constructFrom", function () { return $4eb0d2dc0fda0973$export$ead8a1812b171991; }, function (v) { return $4eb0d2dc0fda0973$export$ead8a1812b171991 = v; });
var $4eb0d2dc0fda0973$export$ead8a1812b171991;
"use strict";
$4eb0d2dc0fda0973$export$ead8a1812b171991 = $4eb0d2dc0fda0973$var$constructFrom;
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $4eb0d2dc0fda0973$var$constructFrom(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}


/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function $b7f6bbd55167ab46$var$addDays(date, amount) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    if (isNaN(amount)) return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}


var $10d770831b44f8ad$exports = {};

$parcel$export($10d770831b44f8ad$exports, "addMonths", function () { return $10d770831b44f8ad$export$17c93e242b2d3a22; }, function (v) { return $10d770831b44f8ad$export$17c93e242b2d3a22 = v; });
var $10d770831b44f8ad$export$17c93e242b2d3a22;
"use strict";
$10d770831b44f8ad$export$17c93e242b2d3a22 = $10d770831b44f8ad$var$addMonths;


/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ function $10d770831b44f8ad$var$addMonths(date, amount) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    if (isNaN(amount)) return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}




/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,\\-7
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */ function $d237b6d82aac5787$var$add(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Add years and months
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const dateWithMonths = months || years ? (0, $10d770831b44f8ad$export$17c93e242b2d3a22)(_date, months + years * 12) : _date;
    // Add weeks and days
    const dateWithDays = days || weeks ? (0, $b7f6bbd55167ab46$export$dd412b56f1e4d8aa)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    const minutesToAdd = minutes + hours * 60;
    const secondsToAdd = seconds + minutesToAdd * 60;
    const msToAdd = secondsToAdd * 1000;
    const finalDate = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, dateWithDays.getTime() + msToAdd);
    return finalDate;
}


Object.keys($d237b6d82aac5787$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $d237b6d82aac5787$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $d237b6d82aac5787$exports[key];
        }
    });
});
var $854efe1653fa92e2$exports = {};

$parcel$export($854efe1653fa92e2$exports, "addBusinessDays", function () { return $854efe1653fa92e2$export$f087b9ada3136ae9; }, function (v) { return $854efe1653fa92e2$export$f087b9ada3136ae9 = v; });
var $854efe1653fa92e2$export$f087b9ada3136ae9;
"use strict";
$854efe1653fa92e2$export$f087b9ada3136ae9 = $854efe1653fa92e2$var$addBusinessDays;

var $14c774cf63527d18$exports = {};

$parcel$export($14c774cf63527d18$exports, "isSaturday", function () { return $14c774cf63527d18$export$def9f260655b3a76; }, function (v) { return $14c774cf63527d18$export$def9f260655b3a76 = v; });
var $14c774cf63527d18$export$def9f260655b3a76;
"use strict";
$14c774cf63527d18$export$def9f260655b3a76 = $14c774cf63527d18$var$isSaturday;

/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * const result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */ function $14c774cf63527d18$var$isSaturday(date) {
    return (0, $838192f7942a2bce$export$e67a095c620b86fe)(date).getDay() === 6;
}


var $86425194c9637130$exports = {};

$parcel$export($86425194c9637130$exports, "isSunday", function () { return $86425194c9637130$export$70f720dfc6028987; }, function (v) { return $86425194c9637130$export$70f720dfc6028987 = v; });
var $86425194c9637130$export$70f720dfc6028987;
"use strict";
$86425194c9637130$export$70f720dfc6028987 = $86425194c9637130$var$isSunday;

/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */ function $86425194c9637130$var$isSunday(date) {
    return (0, $838192f7942a2bce$export$e67a095c620b86fe)(date).getDay() === 0;
}


var $cb1411d6fcaa37ae$exports = {};

$parcel$export($cb1411d6fcaa37ae$exports, "isWeekend", function () { return $cb1411d6fcaa37ae$export$618d60ea299da42; }, function (v) { return $cb1411d6fcaa37ae$export$618d60ea299da42 = v; });
var $cb1411d6fcaa37ae$export$618d60ea299da42;
"use strict";
$cb1411d6fcaa37ae$export$618d60ea299da42 = $cb1411d6fcaa37ae$var$isWeekend;

/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * const result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */ function $cb1411d6fcaa37ae$var$isWeekend(date) {
    const day = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date).getDay();
    return day === 0 || day === 6;
}



/**
 * @name addBusinessDays
 * @category Date Extension Helpers
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be added.
 *
 * @returns The new date with the business days added
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */ function $854efe1653fa92e2$var$addBusinessDays(date, amount) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const startedOnWeekend = (0, $cb1411d6fcaa37ae$export$618d60ea299da42)(_date);
    if (isNaN(amount)) return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, NaN);
    const hours = _date.getHours();
    const sign = amount < 0 ? -1 : 1;
    const fullWeeks = Math.trunc(amount / 5);
    _date.setDate(_date.getDate() + fullWeeks * 7);
    // Get remaining days not part of a full week
    let restDays = Math.abs(amount % 5);
    // Loops over remaining days
    while(restDays > 0){
        _date.setDate(_date.getDate() + sign);
        if (!(0, $cb1411d6fcaa37ae$export$618d60ea299da42)(_date)) restDays -= 1;
    }
    // If the date is a weekend day and we reduce a dividable of
    // 5 from it, we land on a weekend date.
    // To counter this, we add days accordingly to land on the next business day
    if (startedOnWeekend && (0, $cb1411d6fcaa37ae$export$618d60ea299da42)(_date) && amount !== 0) {
        // If we're reducing days, we want to add days until we land on a weekday
        // If we're adding days we want to reduce days until we land on a weekday
        if ((0, $14c774cf63527d18$export$def9f260655b3a76)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
        if ((0, $86425194c9637130$export$70f720dfc6028987)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
    }
    // Restore hours to avoid DST lag
    _date.setHours(hours);
    return _date;
}


Object.keys($854efe1653fa92e2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $854efe1653fa92e2$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $854efe1653fa92e2$exports[key];
        }
    });
});

Object.keys($b7f6bbd55167ab46$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $b7f6bbd55167ab46$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $b7f6bbd55167ab46$exports[key];
        }
    });
});
var $68df478c21901624$exports = {};

$parcel$export($68df478c21901624$exports, "addHours", function () { return $68df478c21901624$export$4a4306ad4fa0e5e6; }, function (v) { return $68df478c21901624$export$4a4306ad4fa0e5e6 = v; });
var $68df478c21901624$export$4a4306ad4fa0e5e6;
"use strict";
$68df478c21901624$export$4a4306ad4fa0e5e6 = $68df478c21901624$var$addHours;
var $f76650ee2db16d71$exports = {};

$parcel$export($f76650ee2db16d71$exports, "addMilliseconds", function () { return $f76650ee2db16d71$export$baf757aaf0c95c94; }, function (v) { return $f76650ee2db16d71$export$baf757aaf0c95c94 = v; });
var $f76650ee2db16d71$export$baf757aaf0c95c94;
"use strict";
$f76650ee2db16d71$export$baf757aaf0c95c94 = $f76650ee2db16d71$var$addMilliseconds;


/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $f76650ee2db16d71$var$addMilliseconds(date, amount) {
    const timestamp = +(0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, timestamp + amount);
}


var $9e66e67751f962b4$export$7271e9e3478110d1;
var $9e66e67751f962b4$export$34804a017b31e2fe;
var $9e66e67751f962b4$export$be1dccf2de902d31;
var $9e66e67751f962b4$export$8e6600bbdee7dabb;
var $9e66e67751f962b4$export$a77c1a7ebebe2a5a;
var $9e66e67751f962b4$export$698aec755e92c695;
var $9e66e67751f962b4$export$815a9362476d2fe3;
var $9e66e67751f962b4$export$4db7641526e3241f;
var $9e66e67751f962b4$export$80d7e435f744f319;
var $9e66e67751f962b4$export$3c58128db900d44e;
var $9e66e67751f962b4$export$3633035e63cee86a;
var $9e66e67751f962b4$export$ab7da2ccd1075c38;
var $9e66e67751f962b4$export$f2f5ae5a8e2d8f9f;
var $9e66e67751f962b4$export$2423174df8cd3cd2;
var $9e66e67751f962b4$export$4dec998e48f9c246;
var $9e66e67751f962b4$export$4fad13613e88edc8;
var $9e66e67751f962b4$export$397c2d5776aa9055;
var $9e66e67751f962b4$export$91246f0b9bd9beff;
var $9e66e67751f962b4$export$7f72910d6dfd237a;
var $9e66e67751f962b4$export$b76b1809a2898f9a;
var $9e66e67751f962b4$export$81caae6e1cc7a622;
var $9e66e67751f962b4$export$3913210603d8e9ae;
var $9e66e67751f962b4$export$dfd9b671c89acc8e;
"use strict";
$9e66e67751f962b4$export$7271e9e3478110d1 = $9e66e67751f962b4$export$34804a017b31e2fe = $9e66e67751f962b4$export$be1dccf2de902d31 = $9e66e67751f962b4$export$8e6600bbdee7dabb = $9e66e67751f962b4$export$a77c1a7ebebe2a5a = $9e66e67751f962b4$export$698aec755e92c695 = $9e66e67751f962b4$export$815a9362476d2fe3 = $9e66e67751f962b4$export$4db7641526e3241f = $9e66e67751f962b4$export$80d7e435f744f319 = $9e66e67751f962b4$export$3c58128db900d44e = $9e66e67751f962b4$export$3633035e63cee86a = $9e66e67751f962b4$export$ab7da2ccd1075c38 = $9e66e67751f962b4$export$f2f5ae5a8e2d8f9f = $9e66e67751f962b4$export$2423174df8cd3cd2 = $9e66e67751f962b4$export$4dec998e48f9c246 = $9e66e67751f962b4$export$4fad13613e88edc8 = $9e66e67751f962b4$export$397c2d5776aa9055 = $9e66e67751f962b4$export$91246f0b9bd9beff = $9e66e67751f962b4$export$7f72910d6dfd237a = $9e66e67751f962b4$export$b76b1809a2898f9a = $9e66e67751f962b4$export$81caae6e1cc7a622 = $9e66e67751f962b4$export$3913210603d8e9ae = $9e66e67751f962b4$export$dfd9b671c89acc8e = void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ 
/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $9e66e67751f962b4$var$daysInWeek = $9e66e67751f962b4$export$dfd9b671c89acc8e = 7;
/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */ const $9e66e67751f962b4$var$daysInYear = $9e66e67751f962b4$export$3913210603d8e9ae = 365.2425;
/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */ const $9e66e67751f962b4$var$maxTime = $9e66e67751f962b4$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */ const $9e66e67751f962b4$var$minTime = $9e66e67751f962b4$export$4dec998e48f9c246 = -$9e66e67751f962b4$var$maxTime;
/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */ const $9e66e67751f962b4$var$millisecondsInWeek = $9e66e67751f962b4$export$4fad13613e88edc8 = 604800000;
/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */ const $9e66e67751f962b4$var$millisecondsInDay = $9e66e67751f962b4$export$b76b1809a2898f9a = 86400000;
/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */ const $9e66e67751f962b4$var$millisecondsInMinute = $9e66e67751f962b4$export$91246f0b9bd9beff = 60000;
/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */ const $9e66e67751f962b4$var$millisecondsInHour = $9e66e67751f962b4$export$7f72910d6dfd237a = 3600000;
/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */ const $9e66e67751f962b4$var$millisecondsInSecond = $9e66e67751f962b4$export$397c2d5776aa9055 = 1000;
/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */ const $9e66e67751f962b4$var$minutesInYear = $9e66e67751f962b4$export$3633035e63cee86a = 525600;
/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */ const $9e66e67751f962b4$var$minutesInMonth = $9e66e67751f962b4$export$ab7da2ccd1075c38 = 43200;
/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */ const $9e66e67751f962b4$var$minutesInDay = $9e66e67751f962b4$export$2423174df8cd3cd2 = 1440;
/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */ const $9e66e67751f962b4$var$minutesInHour = $9e66e67751f962b4$export$f2f5ae5a8e2d8f9f = 60;
/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */ const $9e66e67751f962b4$var$monthsInQuarter = $9e66e67751f962b4$export$3c58128db900d44e = 3;
/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */ const $9e66e67751f962b4$var$monthsInYear = $9e66e67751f962b4$export$80d7e435f744f319 = 12;
/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */ const $9e66e67751f962b4$var$quartersInYear = $9e66e67751f962b4$export$4db7641526e3241f = 4;
/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */ const $9e66e67751f962b4$var$secondsInHour = $9e66e67751f962b4$export$698aec755e92c695 = 3600;
/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */ const $9e66e67751f962b4$var$secondsInMinute = $9e66e67751f962b4$export$a77c1a7ebebe2a5a = 60;
/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */ const $9e66e67751f962b4$var$secondsInDay = $9e66e67751f962b4$export$815a9362476d2fe3 = $9e66e67751f962b4$var$secondsInHour * 24;
/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */ const $9e66e67751f962b4$var$secondsInWeek = $9e66e67751f962b4$export$34804a017b31e2fe = $9e66e67751f962b4$var$secondsInDay * 7;
/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */ const $9e66e67751f962b4$var$secondsInYear = $9e66e67751f962b4$export$7271e9e3478110d1 = $9e66e67751f962b4$var$secondsInDay * $9e66e67751f962b4$var$daysInYear;
/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */ const $9e66e67751f962b4$var$secondsInMonth = $9e66e67751f962b4$export$8e6600bbdee7dabb = $9e66e67751f962b4$var$secondsInYear / 12;
/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */ const $9e66e67751f962b4$var$secondsInQuarter = $9e66e67751f962b4$export$be1dccf2de902d31 = $9e66e67751f962b4$var$secondsInMonth * 3;


/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ function $68df478c21901624$var$addHours(date, amount) {
    return (0, $f76650ee2db16d71$export$baf757aaf0c95c94)(date, amount * $9e66e67751f962b4$export$7f72910d6dfd237a);
}


Object.keys($68df478c21901624$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $68df478c21901624$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $68df478c21901624$exports[key];
        }
    });
});
var $2f795fee44493914$exports = {};

$parcel$export($2f795fee44493914$exports, "addISOWeekYears", function () { return $2f795fee44493914$export$c8240694da10d5f; }, function (v) { return $2f795fee44493914$export$c8240694da10d5f = v; });
var $2f795fee44493914$export$c8240694da10d5f;
"use strict";
$2f795fee44493914$export$c8240694da10d5f = $2f795fee44493914$var$addISOWeekYears;
var $f51448e7e5a1f4fe$exports = {};

$parcel$export($f51448e7e5a1f4fe$exports, "getISOWeekYear", function () { return $f51448e7e5a1f4fe$export$3dbc52535f6f8fcc; }, function (v) { return $f51448e7e5a1f4fe$export$3dbc52535f6f8fcc = v; });
var $f51448e7e5a1f4fe$export$3dbc52535f6f8fcc;
"use strict";
$f51448e7e5a1f4fe$export$3dbc52535f6f8fcc = $f51448e7e5a1f4fe$var$getISOWeekYear;

var $0ce4d92e449d76da$exports = {};

$parcel$export($0ce4d92e449d76da$exports, "startOfISOWeek", function () { return $0ce4d92e449d76da$export$6173213f95a4431e; }, function (v) { return $0ce4d92e449d76da$export$6173213f95a4431e = v; });
var $0ce4d92e449d76da$export$6173213f95a4431e;
"use strict";
$0ce4d92e449d76da$export$6173213f95a4431e = $0ce4d92e449d76da$var$startOfISOWeek;
var $cb6997e20defc27a$exports = {};

$parcel$export($cb6997e20defc27a$exports, "startOfWeek", function () { return $cb6997e20defc27a$export$42c81a444fbfb5d4; }, function (v) { return $cb6997e20defc27a$export$42c81a444fbfb5d4 = v; });
var $cb6997e20defc27a$export$42c81a444fbfb5d4;
"use strict";
$cb6997e20defc27a$export$42c81a444fbfb5d4 = $cb6997e20defc27a$var$startOfWeek;

var $0a8793ff6cad2441$export$430a3269e24b912e;
var $0a8793ff6cad2441$export$95365be1b0704abc;
"use strict";
$0a8793ff6cad2441$export$430a3269e24b912e = $0a8793ff6cad2441$var$getDefaultOptions;
$0a8793ff6cad2441$export$95365be1b0704abc = $0a8793ff6cad2441$var$setDefaultOptions;
let $0a8793ff6cad2441$var$defaultOptions = {};
function $0a8793ff6cad2441$var$getDefaultOptions() {
    return $0a8793ff6cad2441$var$defaultOptions;
}
function $0a8793ff6cad2441$var$setDefaultOptions(newOptions) {
    $0a8793ff6cad2441$var$defaultOptions = newOptions;
}


/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ function $cb6997e20defc27a$var$startOfWeek(date, options) {
    const defaultOptions = (0, $0a8793ff6cad2441$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $0ce4d92e449d76da$var$startOfISOWeek(date) {
    return (0, $cb6997e20defc27a$export$42c81a444fbfb5d4)(date, {
        weekStartsOn: 1
    });
}



/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ function $f51448e7e5a1f4fe$var$getISOWeekYear(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $0ce4d92e449d76da$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $0ce4d92e449d76da$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}


var $2acea2762040099f$exports = {};

$parcel$export($2acea2762040099f$exports, "setISOWeekYear", function () { return $2acea2762040099f$export$814397aabf10ab77; }, function (v) { return $2acea2762040099f$export$814397aabf10ab77 = v; });
var $2acea2762040099f$export$814397aabf10ab77;
"use strict";
$2acea2762040099f$export$814397aabf10ab77 = $2acea2762040099f$var$setISOWeekYear;

var $bb6062a6bff69209$exports = {};

$parcel$export($bb6062a6bff69209$exports, "differenceInCalendarDays", function () { return $bb6062a6bff69209$export$4a02e9c37dab4871; }, function (v) { return $bb6062a6bff69209$export$4a02e9c37dab4871 = v; });
var $bb6062a6bff69209$export$4a02e9c37dab4871;
"use strict";
$bb6062a6bff69209$export$4a02e9c37dab4871 = $bb6062a6bff69209$var$differenceInCalendarDays;

var $c21c29f68a61ba73$exports = {};

$parcel$export($c21c29f68a61ba73$exports, "startOfDay", function () { return $c21c29f68a61ba73$export$63fa379ae8a9ba2; }, function (v) { return $c21c29f68a61ba73$export$63fa379ae8a9ba2 = v; });
var $c21c29f68a61ba73$export$63fa379ae8a9ba2;
"use strict";
$c21c29f68a61ba73$export$63fa379ae8a9ba2 = $c21c29f68a61ba73$var$startOfDay;

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function $c21c29f68a61ba73$var$startOfDay(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


var $f4008ef8d68e7133$export$113002b5eff6e430;
"use strict";
$f4008ef8d68e7133$export$113002b5eff6e430 = $f4008ef8d68e7133$var$getTimezoneOffsetInMilliseconds;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $f4008ef8d68e7133$var$getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}


/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ function $bb6062a6bff69209$var$differenceInCalendarDays(dateLeft, dateRight) {
    const startOfDayLeft = (0, $c21c29f68a61ba73$export$63fa379ae8a9ba2)(dateLeft);
    const startOfDayRight = (0, $c21c29f68a61ba73$export$63fa379ae8a9ba2)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $f4008ef8d68e7133$export$113002b5eff6e430)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $f4008ef8d68e7133$export$113002b5eff6e430)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $9e66e67751f962b4$export$b76b1809a2898f9a);
}


var $4ac098d276fcecdf$exports = {};

$parcel$export($4ac098d276fcecdf$exports, "startOfISOWeekYear", function () { return $4ac098d276fcecdf$export$236bdfa374eb69a9; }, function (v) { return $4ac098d276fcecdf$export$236bdfa374eb69a9 = v; });
var $4ac098d276fcecdf$export$236bdfa374eb69a9;
"use strict";
$4ac098d276fcecdf$export$236bdfa374eb69a9 = $4ac098d276fcecdf$var$startOfISOWeekYear;



/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ function $4ac098d276fcecdf$var$startOfISOWeekYear(date) {
    const year = (0, $f51448e7e5a1f4fe$export$3dbc52535f6f8fcc)(date);
    const fourthOfJanuary = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $0ce4d92e449d76da$export$6173213f95a4431e)(fourthOfJanuary);
}



/**
 * @name setISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The ISO week-numbering year of the new date
 *
 * @returns The new date with the ISO week-numbering year set
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */ function $2acea2762040099f$var$setISOWeekYear(date, weekYear) {
    let _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const diff = (0, $bb6062a6bff69209$export$4a02e9c37dab4871)(_date, (0, $4ac098d276fcecdf$export$236bdfa374eb69a9)(_date));
    const fourthOfJanuary = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, 0);
    fourthOfJanuary.setFullYear(weekYear, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    _date = (0, $4ac098d276fcecdf$export$236bdfa374eb69a9)(fourthOfJanuary);
    _date.setDate(_date.getDate() + diff);
    return _date;
}


/**
 * @name addISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be added.
 *
 * @returns The new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jn 26 2015 00:00:00
 */ function $2f795fee44493914$var$addISOWeekYears(date, amount) {
    return (0, $2acea2762040099f$export$814397aabf10ab77)(date, (0, $f51448e7e5a1f4fe$export$3dbc52535f6f8fcc)(date) + amount);
}


Object.keys($2f795fee44493914$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $2f795fee44493914$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $2f795fee44493914$exports[key];
        }
    });
});

Object.keys($f76650ee2db16d71$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $f76650ee2db16d71$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $f76650ee2db16d71$exports[key];
        }
    });
});
var $f93c9629650c9d53$exports = {};

$parcel$export($f93c9629650c9d53$exports, "addMinutes", function () { return $f93c9629650c9d53$export$2287e3d29250119e; }, function (v) { return $f93c9629650c9d53$export$2287e3d29250119e = v; });
var $f93c9629650c9d53$export$2287e3d29250119e;
"use strict";
$f93c9629650c9d53$export$2287e3d29250119e = $f93c9629650c9d53$var$addMinutes;


/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ function $f93c9629650c9d53$var$addMinutes(date, amount) {
    return (0, $f76650ee2db16d71$export$baf757aaf0c95c94)(date, amount * $9e66e67751f962b4$export$91246f0b9bd9beff);
}


Object.keys($f93c9629650c9d53$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $f93c9629650c9d53$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $f93c9629650c9d53$exports[key];
        }
    });
});

Object.keys($10d770831b44f8ad$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $10d770831b44f8ad$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $10d770831b44f8ad$exports[key];
        }
    });
});
var $ba4355b59e4c2ae3$exports = {};

$parcel$export($ba4355b59e4c2ae3$exports, "addQuarters", function () { return $ba4355b59e4c2ae3$export$c252a41d0fbed2ce; }, function (v) { return $ba4355b59e4c2ae3$export$c252a41d0fbed2ce = v; });
var $ba4355b59e4c2ae3$export$c252a41d0fbed2ce;
"use strict";
$ba4355b59e4c2ae3$export$c252a41d0fbed2ce = $ba4355b59e4c2ae3$var$addQuarters;

/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be added.
 *
 * @returns The new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */ function $ba4355b59e4c2ae3$var$addQuarters(date, amount) {
    const months = amount * 3;
    return (0, $10d770831b44f8ad$export$17c93e242b2d3a22)(date, months);
}


Object.keys($ba4355b59e4c2ae3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $ba4355b59e4c2ae3$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $ba4355b59e4c2ae3$exports[key];
        }
    });
});
var $18d6cada2c50582b$exports = {};

$parcel$export($18d6cada2c50582b$exports, "addSeconds", function () { return $18d6cada2c50582b$export$3cb31b0df13be68; }, function (v) { return $18d6cada2c50582b$export$3cb31b0df13be68 = v; });
var $18d6cada2c50582b$export$3cb31b0df13be68;
"use strict";
$18d6cada2c50582b$export$3cb31b0df13be68 = $18d6cada2c50582b$var$addSeconds;

/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */ function $18d6cada2c50582b$var$addSeconds(date, amount) {
    return (0, $f76650ee2db16d71$export$baf757aaf0c95c94)(date, amount * 1000);
}


Object.keys($18d6cada2c50582b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $18d6cada2c50582b$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $18d6cada2c50582b$exports[key];
        }
    });
});
var $fddea87cb66f8480$exports = {};

$parcel$export($fddea87cb66f8480$exports, "addWeeks", function () { return $fddea87cb66f8480$export$ef501a2bb4f3ee6b; }, function (v) { return $fddea87cb66f8480$export$ef501a2bb4f3ee6b = v; });
var $fddea87cb66f8480$export$ef501a2bb4f3ee6b;
"use strict";
$fddea87cb66f8480$export$ef501a2bb4f3ee6b = $fddea87cb66f8480$var$addWeeks;

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ function $fddea87cb66f8480$var$addWeeks(date, amount) {
    const days = amount * 7;
    return (0, $b7f6bbd55167ab46$export$dd412b56f1e4d8aa)(date, days);
}


Object.keys($fddea87cb66f8480$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $fddea87cb66f8480$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $fddea87cb66f8480$exports[key];
        }
    });
});
var $cfb0a1019b8ddb38$exports = {};

$parcel$export($cfb0a1019b8ddb38$exports, "addYears", function () { return $cfb0a1019b8ddb38$export$3d83eec43f4ea476; }, function (v) { return $cfb0a1019b8ddb38$export$3d83eec43f4ea476 = v; });
var $cfb0a1019b8ddb38$export$3d83eec43f4ea476;
"use strict";
$cfb0a1019b8ddb38$export$3d83eec43f4ea476 = $cfb0a1019b8ddb38$var$addYears;

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ function $cfb0a1019b8ddb38$var$addYears(date, amount) {
    return (0, $10d770831b44f8ad$export$17c93e242b2d3a22)(date, amount * 12);
}


Object.keys($cfb0a1019b8ddb38$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $cfb0a1019b8ddb38$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $cfb0a1019b8ddb38$exports[key];
        }
    });
});
var $6802800db15593e2$exports = {};

$parcel$export($6802800db15593e2$exports, "areIntervalsOverlapping", function () { return $6802800db15593e2$export$2bf3385645436101; }, function (v) { return $6802800db15593e2$export$2bf3385645436101 = v; });
var $6802800db15593e2$export$2bf3385645436101;
"use strict";
$6802800db15593e2$export$2bf3385645436101 = $6802800db15593e2$var$areIntervalsOverlapping;

/**
 * The {@link areIntervalsOverlapping} function options.
 */ /**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping unless `inclusive` is set to `true`.
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 * @param options - The object with options
 *
 * @returns Whether the time intervals are overlapping
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> false
 *
 * @example
 * // For adjacent time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
 * )
 * //=> false
 *
 * @example
 * // Using the inclusive option:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
 * )
 * //=> false
 *
 * @example
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
 *   { inclusive: true }
 * )
 * //=> true
 */ function $6802800db15593e2$var$areIntervalsOverlapping(intervalLeft, intervalRight, options) {
    const [leftStartTime, leftEndTime] = [
        +(0, $838192f7942a2bce$export$e67a095c620b86fe)(intervalLeft.start),
        +(0, $838192f7942a2bce$export$e67a095c620b86fe)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStartTime, rightEndTime] = [
        +(0, $838192f7942a2bce$export$e67a095c620b86fe)(intervalRight.start),
        +(0, $838192f7942a2bce$export$e67a095c620b86fe)(intervalRight.end)
    ].sort((a, b)=>a - b);
    if (options?.inclusive) return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
    return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}


Object.keys($6802800db15593e2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $6802800db15593e2$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $6802800db15593e2$exports[key];
        }
    });
});
var $6584c3c3939d29b5$exports = {};

$parcel$export($6584c3c3939d29b5$exports, "clamp", function () { return $6584c3c3939d29b5$export$7d15b64cf5a3a4c4; }, function (v) { return $6584c3c3939d29b5$export$7d15b64cf5a3a4c4 = v; });
var $6584c3c3939d29b5$export$7d15b64cf5a3a4c4;
"use strict";
$6584c3c3939d29b5$export$7d15b64cf5a3a4c4 = $6584c3c3939d29b5$var$clamp;
var $f627985ca4c702b2$exports = {};

$parcel$export($f627985ca4c702b2$exports, "max", function () { return $f627985ca4c702b2$export$8960430cfd85939f; }, function (v) { return $f627985ca4c702b2$export$8960430cfd85939f = v; });
var $f627985ca4c702b2$export$8960430cfd85939f;
"use strict";
$f627985ca4c702b2$export$8960430cfd85939f = $f627985ca4c702b2$var$max;

/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */ function $f627985ca4c702b2$var$max(dates) {
    let result;
    dates.forEach(function(dirtyDate) {
        const currentDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}


var $d0dbe3d0d14a0124$exports = {};

$parcel$export($d0dbe3d0d14a0124$exports, "min", function () { return $d0dbe3d0d14a0124$export$96ec731ed4dcb222; }, function (v) { return $d0dbe3d0d14a0124$export$96ec731ed4dcb222 = v; });
var $d0dbe3d0d14a0124$export$96ec731ed4dcb222;
"use strict";
$d0dbe3d0d14a0124$export$96ec731ed4dcb222 = $d0dbe3d0d14a0124$var$min;

/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */ function $d0dbe3d0d14a0124$var$min(dates) {
    let result;
    dates.forEach((dirtyDate)=>{
        const date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dirtyDate);
        if (!result || result > date || isNaN(+date)) result = date;
    });
    return result || new Date(NaN);
}


/**
 * @name clamp
 * @category Interval Helpers
 * @summary Return a date bounded by the start and the end of the given interval
 *
 * @description
 * Clamps a date to the lower bound with the start of the interval and the upper
 * bound with the end of the interval.
 *
 * - When the date is less than the start of the interval, the start is returned.
 * - When the date is greater than the end of the interval, the end is returned.
 * - Otherwise the date is returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be bounded
 * @param interval - The interval to bound to
 *
 * @returns The date bounded by the start and the end of the interval
 *
 * @example
 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
 * const result = clamp(new Date(2021, 2, 21), {
 *   start: new Date(2021, 2, 22),
 *   end: new Date(2021, 3, 1),
 * })
 * //=> Mon Mar 22 2021 00:00:00
 */ function $6584c3c3939d29b5$var$clamp(date, interval) {
    return (0, $d0dbe3d0d14a0124$export$96ec731ed4dcb222)([
        (0, $f627985ca4c702b2$export$8960430cfd85939f)([
            date,
            interval.start
        ]),
        interval.end
    ]);
}


Object.keys($6584c3c3939d29b5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $6584c3c3939d29b5$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $6584c3c3939d29b5$exports[key];
        }
    });
});
var $bb0ce026bc6cf3f9$exports = {};

$parcel$export($bb0ce026bc6cf3f9$exports, "closestIndexTo", function () { return $bb0ce026bc6cf3f9$export$42127b72a9d091c7; }, function (v) { return $bb0ce026bc6cf3f9$export$42127b72a9d091c7 = v; });
var $bb0ce026bc6cf3f9$export$42127b72a9d091c7;
"use strict";
$bb0ce026bc6cf3f9$export$42127b72a9d091c7 = $bb0ce026bc6cf3f9$var$closestIndexTo;

/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns An index of the date closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */ function $bb0ce026bc6cf3f9$var$closestIndexTo(dateToCompare, dates) {
    const date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateToCompare);
    if (isNaN(Number(date))) return NaN;
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach(function(dirtyDate, index) {
        const currentDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = NaN;
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = index;
            minDistance = distance;
        }
    });
    return result;
}


Object.keys($bb0ce026bc6cf3f9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $bb0ce026bc6cf3f9$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $bb0ce026bc6cf3f9$exports[key];
        }
    });
});
var $e8a997fe6171376c$exports = {};

$parcel$export($e8a997fe6171376c$exports, "closestTo", function () { return $e8a997fe6171376c$export$73858b464497125a; }, function (v) { return $e8a997fe6171376c$export$73858b464497125a = v; });
var $e8a997fe6171376c$export$73858b464497125a;
"use strict";
$e8a997fe6171376c$export$73858b464497125a = $e8a997fe6171376c$var$closestTo;


/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns The date from the array closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */ function $e8a997fe6171376c$var$closestTo(dateToCompare, dates) {
    const date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateToCompare);
    if (isNaN(Number(date))) return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(dateToCompare, NaN);
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach((dirtyDate)=>{
        const currentDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(dateToCompare, NaN);
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = currentDate;
            minDistance = distance;
        }
    });
    return result;
}


Object.keys($e8a997fe6171376c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $e8a997fe6171376c$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $e8a997fe6171376c$exports[key];
        }
    });
});
var $371b71d1995fe7f8$exports = {};

$parcel$export($371b71d1995fe7f8$exports, "compareAsc", function () { return $371b71d1995fe7f8$export$fe114145ae75d197; }, function (v) { return $371b71d1995fe7f8$export$fe114145ae75d197 = v; });
var $371b71d1995fe7f8$export$fe114145ae75d197;
"use strict";
$371b71d1995fe7f8$export$fe114145ae75d197 = $371b71d1995fe7f8$var$compareAsc;

/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */ function $371b71d1995fe7f8$var$compareAsc(dateLeft, dateRight) {
    const _dateLeft = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}


Object.keys($371b71d1995fe7f8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $371b71d1995fe7f8$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $371b71d1995fe7f8$exports[key];
        }
    });
});
var $1cde9170e67521a4$exports = {};

$parcel$export($1cde9170e67521a4$exports, "compareDesc", function () { return $1cde9170e67521a4$export$ed84005ac9356f7a; }, function (v) { return $1cde9170e67521a4$export$ed84005ac9356f7a = v; });
var $1cde9170e67521a4$export$ed84005ac9356f7a;
"use strict";
$1cde9170e67521a4$export$ed84005ac9356f7a = $1cde9170e67521a4$var$compareDesc;

/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */ function $1cde9170e67521a4$var$compareDesc(dateLeft, dateRight) {
    const _dateLeft = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff > 0) return -1;
    else if (diff < 0) return 1;
    else return diff;
}


Object.keys($1cde9170e67521a4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $1cde9170e67521a4$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $1cde9170e67521a4$exports[key];
        }
    });
});

Object.keys($4eb0d2dc0fda0973$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $4eb0d2dc0fda0973$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $4eb0d2dc0fda0973$exports[key];
        }
    });
});
var $6284e2d2db30dabc$exports = {};

$parcel$export($6284e2d2db30dabc$exports, "constructNow", function () { return $6284e2d2db30dabc$export$18c3c6510fb97afc; }, function (v) { return $6284e2d2db30dabc$export$18c3c6510fb97afc = v; });
var $6284e2d2db30dabc$export$18c3c6510fb97afc;
"use strict";
$6284e2d2db30dabc$export$18c3c6510fb97afc = $6284e2d2db30dabc$var$constructNow;

/**
 * @name constructNow
 * @category Generic Helpers
 * @summary Constructs a new current date using the passed value constructor.
 * @pure false
 *
 * @description
 * The function constructs a new current date using the constructor from
 * the reference date. It helps to build generic functions that accept date
 * extensions and use the current date.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 *
 * @returns Current date initialized using the given date constructor
 *
 * @example
 * import { constructNow, isSameDay } from 'date-fns'
 *
 * function isToday<DateType extends Date>(
 *   date: DateType | number | string,
 * ): boolean {
 *   // If we were to use `new Date()` directly, the function would  behave
 *   // differently in different timezones and return false for the same date.
 *   return isSameDay(date, constructNow(date));
 * }
 */ function $6284e2d2db30dabc$var$constructNow(date) {
    return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, Date.now());
}


Object.keys($6284e2d2db30dabc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $6284e2d2db30dabc$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $6284e2d2db30dabc$exports[key];
        }
    });
});
var $26d401aa526b2b05$exports = {};

$parcel$export($26d401aa526b2b05$exports, "daysToWeeks", function () { return $26d401aa526b2b05$export$66d8b66cbb6006a8; }, function (v) { return $26d401aa526b2b05$export$66d8b66cbb6006a8 = v; });
var $26d401aa526b2b05$export$66d8b66cbb6006a8;
"use strict";
$26d401aa526b2b05$export$66d8b66cbb6006a8 = $26d401aa526b2b05$var$daysToWeeks;

/**
 * @name daysToWeeks
 * @category Conversion Helpers
 * @summary Convert days to weeks.
 *
 * @description
 * Convert a number of days to a full number of weeks.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param days - The number of days to be converted
 *
 * @returns The number of days converted in weeks
 *
 * @example
 * // Convert 14 days to weeks:
 * const result = daysToWeeks(14)
 * //=> 2
 *
 * @example
 * // It uses trunc rounding:
 * const result = daysToWeeks(13)
 * //=> 1
 */ function $26d401aa526b2b05$var$daysToWeeks(days) {
    const weeks = days / $9e66e67751f962b4$export$dfd9b671c89acc8e;
    const result = Math.trunc(weeks);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($26d401aa526b2b05$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $26d401aa526b2b05$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $26d401aa526b2b05$exports[key];
        }
    });
});
var $cddb643adaa88173$exports = {};

$parcel$export($cddb643adaa88173$exports, "differenceInBusinessDays", function () { return $cddb643adaa88173$export$f30d3269a6c53cb9; }, function (v) { return $cddb643adaa88173$export$f30d3269a6c53cb9 = v; });
var $cddb643adaa88173$export$f30d3269a6c53cb9;
"use strict";
$cddb643adaa88173$export$f30d3269a6c53cb9 = $cddb643adaa88173$var$differenceInBusinessDays;


var $16b25d82130e0f81$exports = {};

$parcel$export($16b25d82130e0f81$exports, "isSameDay", function () { return $16b25d82130e0f81$export$ea39ec197993aef0; }, function (v) { return $16b25d82130e0f81$export$ea39ec197993aef0 = v; });
var $16b25d82130e0f81$export$ea39ec197993aef0;
"use strict";
$16b25d82130e0f81$export$ea39ec197993aef0 = $16b25d82130e0f81$var$isSameDay;

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ function $16b25d82130e0f81$var$isSameDay(dateLeft, dateRight) {
    const dateLeftStartOfDay = (0, $c21c29f68a61ba73$export$63fa379ae8a9ba2)(dateLeft);
    const dateRightStartOfDay = (0, $c21c29f68a61ba73$export$63fa379ae8a9ba2)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}


var $9686c3631a8bde9c$exports = {};

$parcel$export($9686c3631a8bde9c$exports, "isValid", function () { return $9686c3631a8bde9c$export$1ea939691cdc45b8; }, function (v) { return $9686c3631a8bde9c$export$1ea939691cdc45b8 = v; });
var $9686c3631a8bde9c$export$1ea939691cdc45b8;
"use strict";
$9686c3631a8bde9c$export$1ea939691cdc45b8 = $9686c3631a8bde9c$var$isValid;
var $d788e870388b4443$exports = {};

$parcel$export($d788e870388b4443$exports, "isDate", function () { return $d788e870388b4443$export$871608497c498473; }, function (v) { return $d788e870388b4443$export$871608497c498473 = v; });
var $d788e870388b4443$export$871608497c498473;
"use strict";
$d788e870388b4443$export$871608497c498473 = $d788e870388b4443$var$isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
function $d788e870388b4443$var$isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $9686c3631a8bde9c$var$isValid(date) {
    if (!(0, $d788e870388b4443$export$871608497c498473)(date) && typeof date !== "number") return false;
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    return !isNaN(Number(_date));
}




/**
 * @name differenceInBusinessDays
 * @category Day Helpers
 * @summary Get the number of business days between the given dates.
 *
 * @description
 * Get the number of business day periods between the given dates.
 * Business days being days that arent in the weekend.
 * Like `differenceInCalendarDays`, the function removes the times from
 * the dates before calculating the difference.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of business days
 *
 * @example
 * // How many business days are between
 * // 10 January 2014 and 20 July 2014?
 * const result = differenceInBusinessDays(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 0, 10)
 * )
 * //=> 136
 *
 * // How many business days are between
 * // 30 November 2021 and 1 November 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 30),
 *   new Date(2021, 10, 1)
 * )
 * //=> 21
 *
 * // How many business days are between
 * // 1 November 2021 and 1 December 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 11, 1)
 * )
 * //=> -22
 *
 * // How many business days are between
 * // 1 November 2021 and 1 November 2021 ?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 1)
 * )
 * //=> 0
 */ function $cddb643adaa88173$var$differenceInBusinessDays(dateLeft, dateRight) {
    const _dateLeft = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateLeft);
    let _dateRight = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateRight);
    if (!(0, $9686c3631a8bde9c$export$1ea939691cdc45b8)(_dateLeft) || !(0, $9686c3631a8bde9c$export$1ea939691cdc45b8)(_dateRight)) return NaN;
    const calendarDifference = (0, $bb6062a6bff69209$export$4a02e9c37dab4871)(_dateLeft, _dateRight);
    const sign = calendarDifference < 0 ? -1 : 1;
    const weeks = Math.trunc(calendarDifference / 7);
    let result = weeks * 5;
    _dateRight = (0, $b7f6bbd55167ab46$export$dd412b56f1e4d8aa)(_dateRight, weeks * 7);
    // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
    while(!(0, $16b25d82130e0f81$export$ea39ec197993aef0)(_dateLeft, _dateRight)){
        // sign is used to account for both negative and positive differences
        result += (0, $cb1411d6fcaa37ae$export$618d60ea299da42)(_dateRight) ? 0 : sign;
        _dateRight = (0, $b7f6bbd55167ab46$export$dd412b56f1e4d8aa)(_dateRight, sign);
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($cddb643adaa88173$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $cddb643adaa88173$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $cddb643adaa88173$exports[key];
        }
    });
});

Object.keys($bb6062a6bff69209$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $bb6062a6bff69209$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $bb6062a6bff69209$exports[key];
        }
    });
});
var $1420adbe2f19d3bf$exports = {};

$parcel$export($1420adbe2f19d3bf$exports, "differenceInCalendarISOWeekYears", function () { return $1420adbe2f19d3bf$export$7f8a73dc2e50a070; }, function (v) { return $1420adbe2f19d3bf$export$7f8a73dc2e50a070 = v; });
var $1420adbe2f19d3bf$export$7f8a73dc2e50a070;
"use strict";
$1420adbe2f19d3bf$export$7f8a73dc2e50a070 = $1420adbe2f19d3bf$var$differenceInCalendarISOWeekYears;

/**
 * @name differenceInCalendarISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * const result = differenceInCalendarISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */ function $1420adbe2f19d3bf$var$differenceInCalendarISOWeekYears(dateLeft, dateRight) {
    return (0, $f51448e7e5a1f4fe$export$3dbc52535f6f8fcc)(dateLeft) - (0, $f51448e7e5a1f4fe$export$3dbc52535f6f8fcc)(dateRight);
}


Object.keys($1420adbe2f19d3bf$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $1420adbe2f19d3bf$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $1420adbe2f19d3bf$exports[key];
        }
    });
});
var $495191c26d75c03b$exports = {};

$parcel$export($495191c26d75c03b$exports, "differenceInCalendarISOWeeks", function () { return $495191c26d75c03b$export$28df1cb58b17e450; }, function (v) { return $495191c26d75c03b$export$28df1cb58b17e450 = v; });
var $495191c26d75c03b$export$28df1cb58b17e450;
"use strict";
$495191c26d75c03b$export$28df1cb58b17e450 = $495191c26d75c03b$var$differenceInCalendarISOWeeks;



/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * const result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */ function $495191c26d75c03b$var$differenceInCalendarISOWeeks(dateLeft, dateRight) {
    const startOfISOWeekLeft = (0, $0ce4d92e449d76da$export$6173213f95a4431e)(dateLeft);
    const startOfISOWeekRight = (0, $0ce4d92e449d76da$export$6173213f95a4431e)(dateRight);
    const timestampLeft = +startOfISOWeekLeft - (0, $f4008ef8d68e7133$export$113002b5eff6e430)(startOfISOWeekLeft);
    const timestampRight = +startOfISOWeekRight - (0, $f4008ef8d68e7133$export$113002b5eff6e430)(startOfISOWeekRight);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $9e66e67751f962b4$export$4fad13613e88edc8);
}


Object.keys($495191c26d75c03b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $495191c26d75c03b$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $495191c26d75c03b$exports[key];
        }
    });
});
var $733cedb93909e7ba$exports = {};

$parcel$export($733cedb93909e7ba$exports, "differenceInCalendarMonths", function () { return $733cedb93909e7ba$export$489984ac7c996389; }, function (v) { return $733cedb93909e7ba$export$489984ac7c996389 = v; });
var $733cedb93909e7ba$export$489984ac7c996389;
"use strict";
$733cedb93909e7ba$export$489984ac7c996389 = $733cedb93909e7ba$var$differenceInCalendarMonths;

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ function $733cedb93909e7ba$var$differenceInCalendarMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}


Object.keys($733cedb93909e7ba$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $733cedb93909e7ba$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $733cedb93909e7ba$exports[key];
        }
    });
});
var $5dacfca8607e2090$exports = {};

$parcel$export($5dacfca8607e2090$exports, "differenceInCalendarQuarters", function () { return $5dacfca8607e2090$export$f62ae9fb13958c7a; }, function (v) { return $5dacfca8607e2090$export$f62ae9fb13958c7a = v; });
var $5dacfca8607e2090$export$f62ae9fb13958c7a;
"use strict";
$5dacfca8607e2090$export$f62ae9fb13958c7a = $5dacfca8607e2090$var$differenceInCalendarQuarters;
var $65978eee93cacb6d$exports = {};

$parcel$export($65978eee93cacb6d$exports, "getQuarter", function () { return $65978eee93cacb6d$export$de90a4bb31c25221; }, function (v) { return $65978eee93cacb6d$export$de90a4bb31c25221 = v; });
var $65978eee93cacb6d$export$de90a4bb31c25221;
"use strict";
$65978eee93cacb6d$export$de90a4bb31c25221 = $65978eee93cacb6d$var$getQuarter;

/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */ function $65978eee93cacb6d$var$getQuarter(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}



/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */ function $5dacfca8607e2090$var$differenceInCalendarQuarters(dateLeft, dateRight) {
    const _dateLeft = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const quarterDiff = (0, $65978eee93cacb6d$export$de90a4bb31c25221)(_dateLeft) - (0, $65978eee93cacb6d$export$de90a4bb31c25221)(_dateRight);
    return yearDiff * 4 + quarterDiff;
}


Object.keys($5dacfca8607e2090$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $5dacfca8607e2090$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $5dacfca8607e2090$exports[key];
        }
    });
});
var $0a05c73da41121f4$exports = {};

$parcel$export($0a05c73da41121f4$exports, "differenceInCalendarWeeks", function () { return $0a05c73da41121f4$export$6ed034ce62348e4; }, function (v) { return $0a05c73da41121f4$export$6ed034ce62348e4 = v; });
var $0a05c73da41121f4$export$6ed034ce62348e4;
"use strict";
$0a05c73da41121f4$export$6ed034ce62348e4 = $0a05c73da41121f4$var$differenceInCalendarWeeks;



/**
 * The {@link differenceInCalendarWeeks} function options.
 */ /**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */ function $0a05c73da41121f4$var$differenceInCalendarWeeks(dateLeft, dateRight, options) {
    const startOfWeekLeft = (0, $cb6997e20defc27a$export$42c81a444fbfb5d4)(dateLeft, options);
    const startOfWeekRight = (0, $cb6997e20defc27a$export$42c81a444fbfb5d4)(dateRight, options);
    const timestampLeft = +startOfWeekLeft - (0, $f4008ef8d68e7133$export$113002b5eff6e430)(startOfWeekLeft);
    const timestampRight = +startOfWeekRight - (0, $f4008ef8d68e7133$export$113002b5eff6e430)(startOfWeekRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a days is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $9e66e67751f962b4$export$4fad13613e88edc8);
}


Object.keys($0a05c73da41121f4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $0a05c73da41121f4$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $0a05c73da41121f4$exports[key];
        }
    });
});
var $19dc801ab0682ed9$exports = {};

$parcel$export($19dc801ab0682ed9$exports, "differenceInCalendarYears", function () { return $19dc801ab0682ed9$export$c06dce8b38891685; }, function (v) { return $19dc801ab0682ed9$export$c06dce8b38891685 = v; });
var $19dc801ab0682ed9$export$c06dce8b38891685;
"use strict";
$19dc801ab0682ed9$export$c06dce8b38891685 = $19dc801ab0682ed9$var$differenceInCalendarYears;

/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */ function $19dc801ab0682ed9$var$differenceInCalendarYears(dateLeft, dateRight) {
    const _dateLeft = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateRight);
    return _dateLeft.getFullYear() - _dateRight.getFullYear();
}


Object.keys($19dc801ab0682ed9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $19dc801ab0682ed9$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $19dc801ab0682ed9$exports[key];
        }
    });
});
var $91b0bd8ffd6a15a9$exports = {};

$parcel$export($91b0bd8ffd6a15a9$exports, "differenceInDays", function () { return $91b0bd8ffd6a15a9$export$86415ebf4eb36b8c; }, function (v) { return $91b0bd8ffd6a15a9$export$86415ebf4eb36b8c = v; });
var $91b0bd8ffd6a15a9$export$86415ebf4eb36b8c;
"use strict";
$91b0bd8ffd6a15a9$export$86415ebf4eb36b8c = $91b0bd8ffd6a15a9$var$differenceInDays;


/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full days according to the local timezone
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 *
 * @example
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
 * //=> 92
 */ function $91b0bd8ffd6a15a9$var$differenceInDays(dateLeft, dateRight) {
    const _dateLeft = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateRight);
    const sign = $91b0bd8ffd6a15a9$var$compareLocalAsc(_dateLeft, _dateRight);
    const difference = Math.abs((0, $bb6062a6bff69209$export$4a02e9c37dab4871)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($91b0bd8ffd6a15a9$var$compareLocalAsc(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $91b0bd8ffd6a15a9$var$compareLocalAsc(dateLeft, dateRight) {
    const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}


Object.keys($91b0bd8ffd6a15a9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $91b0bd8ffd6a15a9$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $91b0bd8ffd6a15a9$exports[key];
        }
    });
});
var $8892b53d007561a7$exports = {};

$parcel$export($8892b53d007561a7$exports, "differenceInHours", function () { return $8892b53d007561a7$export$5436ca250d4d6872; }, function (v) { return $8892b53d007561a7$export$5436ca250d4d6872 = v; });
var $8892b53d007561a7$export$5436ca250d4d6872;
"use strict";
$8892b53d007561a7$export$5436ca250d4d6872 = $8892b53d007561a7$var$differenceInHours;
var $a15b9f5338a2ad49$export$b6474a47258c1211;
"use strict";
$a15b9f5338a2ad49$export$b6474a47258c1211 = $a15b9f5338a2ad49$var$getRoundingMethod;
function $a15b9f5338a2ad49$var$getRoundingMethod(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}



var $0cb45f5f0e084e00$exports = {};

$parcel$export($0cb45f5f0e084e00$exports, "differenceInMilliseconds", function () { return $0cb45f5f0e084e00$export$7be94d13716b4bf6; }, function (v) { return $0cb45f5f0e084e00$export$7be94d13716b4bf6 = v; });
var $0cb45f5f0e084e00$export$7be94d13716b4bf6;
"use strict";
$0cb45f5f0e084e00$export$7be94d13716b4bf6 = $0cb45f5f0e084e00$var$differenceInMilliseconds;

/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */ function $0cb45f5f0e084e00$var$differenceInMilliseconds(dateLeft, dateRight) {
    return +(0, $838192f7942a2bce$export$e67a095c620b86fe)(dateLeft) - +(0, $838192f7942a2bce$export$e67a095c620b86fe)(dateRight);
}


/**
 * The {@link differenceInHours} function options.
 */ /**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */ function $8892b53d007561a7$var$differenceInHours(dateLeft, dateRight, options) {
    const diff = (0, $0cb45f5f0e084e00$export$7be94d13716b4bf6)(dateLeft, dateRight) / $9e66e67751f962b4$export$7f72910d6dfd237a;
    return (0, $a15b9f5338a2ad49$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($8892b53d007561a7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $8892b53d007561a7$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $8892b53d007561a7$exports[key];
        }
    });
});
var $a416f11997d782d9$exports = {};

$parcel$export($a416f11997d782d9$exports, "differenceInISOWeekYears", function () { return $a416f11997d782d9$export$bf7bde0b3bf8913a; }, function (v) { return $a416f11997d782d9$export$bf7bde0b3bf8913a = v; });
var $a416f11997d782d9$export$bf7bde0b3bf8913a;
"use strict";
$a416f11997d782d9$export$bf7bde0b3bf8913a = $a416f11997d782d9$var$differenceInISOWeekYears;


var $7012e9ce223c4cd3$exports = {};

$parcel$export($7012e9ce223c4cd3$exports, "subISOWeekYears", function () { return $7012e9ce223c4cd3$export$4f7d47b952f4a0aa; }, function (v) { return $7012e9ce223c4cd3$export$4f7d47b952f4a0aa = v; });
var $7012e9ce223c4cd3$export$4f7d47b952f4a0aa;
"use strict";
$7012e9ce223c4cd3$export$4f7d47b952f4a0aa = $7012e9ce223c4cd3$var$subISOWeekYears;

/**
 * @name subISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be subtracted.
 *
 * @returns The new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */ function $7012e9ce223c4cd3$var$subISOWeekYears(date, amount) {
    return (0, $2f795fee44493914$export$c8240694da10d5f)(date, -amount);
}



/**
 * @name differenceInISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * const result = differenceInISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */ function $a416f11997d782d9$var$differenceInISOWeekYears(dateLeft, dateRight) {
    let _dateLeft = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateRight);
    const sign = (0, $371b71d1995fe7f8$export$fe114145ae75d197)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $1420adbe2f19d3bf$export$7f8a73dc2e50a070)(_dateLeft, _dateRight));
    _dateLeft = (0, $7012e9ce223c4cd3$export$4f7d47b952f4a0aa)(_dateLeft, sign * difference);
    // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
    // if last calendar ISO year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastISOWeekYearNotFull = Number((0, $371b71d1995fe7f8$export$fe114145ae75d197)(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastISOWeekYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($a416f11997d782d9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $a416f11997d782d9$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $a416f11997d782d9$exports[key];
        }
    });
});

Object.keys($0cb45f5f0e084e00$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $0cb45f5f0e084e00$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $0cb45f5f0e084e00$exports[key];
        }
    });
});
var $8232f7fd99cf2340$exports = {};

$parcel$export($8232f7fd99cf2340$exports, "differenceInMinutes", function () { return $8232f7fd99cf2340$export$d904251335be481a; }, function (v) { return $8232f7fd99cf2340$export$d904251335be481a = v; });
var $8232f7fd99cf2340$export$d904251335be481a;
"use strict";
$8232f7fd99cf2340$export$d904251335be481a = $8232f7fd99cf2340$var$differenceInMinutes;



/**
 * The {@link differenceInMinutes} function options.
 */ /**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */ function $8232f7fd99cf2340$var$differenceInMinutes(dateLeft, dateRight, options) {
    const diff = (0, $0cb45f5f0e084e00$export$7be94d13716b4bf6)(dateLeft, dateRight) / $9e66e67751f962b4$export$91246f0b9bd9beff;
    return (0, $a15b9f5338a2ad49$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($8232f7fd99cf2340$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $8232f7fd99cf2340$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $8232f7fd99cf2340$exports[key];
        }
    });
});
var $119c3b8c8b0e62d4$exports = {};

$parcel$export($119c3b8c8b0e62d4$exports, "differenceInMonths", function () { return $119c3b8c8b0e62d4$export$fc1ed482c2861792; }, function (v) { return $119c3b8c8b0e62d4$export$fc1ed482c2861792 = v; });
var $119c3b8c8b0e62d4$export$fc1ed482c2861792;
"use strict";
$119c3b8c8b0e62d4$export$fc1ed482c2861792 = $119c3b8c8b0e62d4$var$differenceInMonths;


var $588af2fc0365661e$exports = {};

$parcel$export($588af2fc0365661e$exports, "isLastDayOfMonth", function () { return $588af2fc0365661e$export$c817d0312007ea5e; }, function (v) { return $588af2fc0365661e$export$c817d0312007ea5e = v; });
var $588af2fc0365661e$export$c817d0312007ea5e;
"use strict";
$588af2fc0365661e$export$c817d0312007ea5e = $588af2fc0365661e$var$isLastDayOfMonth;
var $060b0a669f1660d3$exports = {};

$parcel$export($060b0a669f1660d3$exports, "endOfDay", function () { return $060b0a669f1660d3$export$eb9a03f0e9aa6cea; }, function (v) { return $060b0a669f1660d3$export$eb9a03f0e9aa6cea = v; });
var $060b0a669f1660d3$export$eb9a03f0e9aa6cea;
"use strict";
$060b0a669f1660d3$export$eb9a03f0e9aa6cea = $060b0a669f1660d3$var$endOfDay;

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ function $060b0a669f1660d3$var$endOfDay(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


var $9bf63f6cf81e2764$exports = {};

$parcel$export($9bf63f6cf81e2764$exports, "endOfMonth", function () { return $9bf63f6cf81e2764$export$a2258d9c4118825c; }, function (v) { return $9bf63f6cf81e2764$export$a2258d9c4118825c = v; });
var $9bf63f6cf81e2764$export$a2258d9c4118825c;
"use strict";
$9bf63f6cf81e2764$export$a2258d9c4118825c = $9bf63f6cf81e2764$var$endOfMonth;

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $9bf63f6cf81e2764$var$endOfMonth(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}



/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */ function $588af2fc0365661e$var$isLastDayOfMonth(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    return +(0, $060b0a669f1660d3$export$eb9a03f0e9aa6cea)(_date) === +(0, $9bf63f6cf81e2764$export$a2258d9c4118825c)(_date);
}



/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */ function $119c3b8c8b0e62d4$var$differenceInMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateRight);
    const sign = (0, $371b71d1995fe7f8$export$fe114145ae75d197)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $733cedb93909e7ba$export$489984ac7c996389)(_dateLeft, _dateRight));
    let result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        _dateLeft.setDate(30);
        _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        let isLastMonthNotFull = (0, $371b71d1995fe7f8$export$fe114145ae75d197)(_dateLeft, _dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $588af2fc0365661e$export$c817d0312007ea5e)((0, $838192f7942a2bce$export$e67a095c620b86fe)(dateLeft)) && difference === 1 && (0, $371b71d1995fe7f8$export$fe114145ae75d197)(dateLeft, _dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($119c3b8c8b0e62d4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $119c3b8c8b0e62d4$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $119c3b8c8b0e62d4$exports[key];
        }
    });
});
var $cf34a50015d2c43c$exports = {};

$parcel$export($cf34a50015d2c43c$exports, "differenceInQuarters", function () { return $cf34a50015d2c43c$export$74b5c4055a405552; }, function (v) { return $cf34a50015d2c43c$export$74b5c4055a405552 = v; });
var $cf34a50015d2c43c$export$74b5c4055a405552;
"use strict";
$cf34a50015d2c43c$export$74b5c4055a405552 = $cf34a50015d2c43c$var$differenceInQuarters;


/**
 * The {@link differenceInQuarters} function options.
 */ /**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */ function $cf34a50015d2c43c$var$differenceInQuarters(dateLeft, dateRight, options) {
    const diff = (0, $119c3b8c8b0e62d4$export$fc1ed482c2861792)(dateLeft, dateRight) / 3;
    return (0, $a15b9f5338a2ad49$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($cf34a50015d2c43c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $cf34a50015d2c43c$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $cf34a50015d2c43c$exports[key];
        }
    });
});
var $e4c0e558314ffb9c$exports = {};

$parcel$export($e4c0e558314ffb9c$exports, "differenceInSeconds", function () { return $e4c0e558314ffb9c$export$c1889aec51783710; }, function (v) { return $e4c0e558314ffb9c$export$c1889aec51783710 = v; });
var $e4c0e558314ffb9c$export$c1889aec51783710;
"use strict";
$e4c0e558314ffb9c$export$c1889aec51783710 = $e4c0e558314ffb9c$var$differenceInSeconds;


/**
 * The {@link differenceInSeconds} function options.
 */ /**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */ function $e4c0e558314ffb9c$var$differenceInSeconds(dateLeft, dateRight, options) {
    const diff = (0, $0cb45f5f0e084e00$export$7be94d13716b4bf6)(dateLeft, dateRight) / 1000;
    return (0, $a15b9f5338a2ad49$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($e4c0e558314ffb9c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $e4c0e558314ffb9c$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $e4c0e558314ffb9c$exports[key];
        }
    });
});
var $636d5f263fbd33b0$exports = {};

$parcel$export($636d5f263fbd33b0$exports, "differenceInWeeks", function () { return $636d5f263fbd33b0$export$b5147a91dc40ddb7; }, function (v) { return $636d5f263fbd33b0$export$b5147a91dc40ddb7 = v; });
var $636d5f263fbd33b0$export$b5147a91dc40ddb7;
"use strict";
$636d5f263fbd33b0$export$b5147a91dc40ddb7 = $636d5f263fbd33b0$var$differenceInWeeks;


/**
 * The {@link differenceInWeeks} function options.
 */ /**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options
 *
 * @returns The number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * @example
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */ function $636d5f263fbd33b0$var$differenceInWeeks(dateLeft, dateRight, options) {
    const diff = (0, $91b0bd8ffd6a15a9$export$86415ebf4eb36b8c)(dateLeft, dateRight) / 7;
    return (0, $a15b9f5338a2ad49$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($636d5f263fbd33b0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $636d5f263fbd33b0$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $636d5f263fbd33b0$exports[key];
        }
    });
});
var $9fd86db74e5eaff4$exports = {};

$parcel$export($9fd86db74e5eaff4$exports, "differenceInYears", function () { return $9fd86db74e5eaff4$export$ed6bf486f68899ca; }, function (v) { return $9fd86db74e5eaff4$export$ed6bf486f68899ca = v; });
var $9fd86db74e5eaff4$export$ed6bf486f68899ca;
"use strict";
$9fd86db74e5eaff4$export$ed6bf486f68899ca = $9fd86db74e5eaff4$var$differenceInYears;



/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */ function $9fd86db74e5eaff4$var$differenceInYears(dateLeft, dateRight) {
    const _dateLeft = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateRight);
    const sign = (0, $371b71d1995fe7f8$export$fe114145ae75d197)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $19dc801ab0682ed9$export$c06dce8b38891685)(_dateLeft, _dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    _dateLeft.setFullYear(1584);
    _dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastYearNotFull = (0, $371b71d1995fe7f8$export$fe114145ae75d197)(_dateLeft, _dateRight) === -sign;
    const result = sign * (difference - +isLastYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($9fd86db74e5eaff4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $9fd86db74e5eaff4$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $9fd86db74e5eaff4$exports[key];
        }
    });
});
var $6b88e797d9b907bf$exports = {};

$parcel$export($6b88e797d9b907bf$exports, "eachDayOfInterval", function () { return $6b88e797d9b907bf$export$7a337e5923c7ceb5; }, function (v) { return $6b88e797d9b907bf$export$7a337e5923c7ceb5 = v; });
var $6b88e797d9b907bf$export$7a337e5923c7ceb5;
"use strict";
$6b88e797d9b907bf$export$7a337e5923c7ceb5 = $6b88e797d9b907bf$var$eachDayOfInterval;

/**
 * The {@link eachDayOfInterval} function options.
 */ /**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of days from the day of the interval start to the day of the interval end
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */ function $6b88e797d9b907bf$var$eachDayOfInterval(interval, options) {
    const startDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $838192f7942a2bce$export$e67a095c620b86fe)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($6b88e797d9b907bf$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $6b88e797d9b907bf$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $6b88e797d9b907bf$exports[key];
        }
    });
});
var $41930b853466801e$exports = {};

$parcel$export($41930b853466801e$exports, "eachHourOfInterval", function () { return $41930b853466801e$export$bb4f48fee90ea86e; }, function (v) { return $41930b853466801e$export$bb4f48fee90ea86e = v; });
var $41930b853466801e$export$bb4f48fee90ea86e;
"use strict";
$41930b853466801e$export$bb4f48fee90ea86e = $41930b853466801e$var$eachHourOfInterval;


/**
 * The {@link eachHourOfInterval} function options.
 */ /**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of hours from the hour of the interval start to the hour of the interval end
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
 * const result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */ function $41930b853466801e$var$eachHourOfInterval(interval, options) {
    const startDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    currentDate.setMinutes(0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $838192f7942a2bce$export$e67a095c620b86fe)(currentDate));
        currentDate = (0, $68df478c21901624$export$4a4306ad4fa0e5e6)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($41930b853466801e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $41930b853466801e$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $41930b853466801e$exports[key];
        }
    });
});
var $0d58328b32235397$exports = {};

$parcel$export($0d58328b32235397$exports, "eachMinuteOfInterval", function () { return $0d58328b32235397$export$82e17d693ce9eb6c; }, function (v) { return $0d58328b32235397$export$82e17d693ce9eb6c = v; });
var $0d58328b32235397$export$82e17d693ce9eb6c;
"use strict";
$0d58328b32235397$export$82e17d693ce9eb6c = $0d58328b32235397$var$eachMinuteOfInterval;

var $f7b7b7b4fe06340d$exports = {};

$parcel$export($f7b7b7b4fe06340d$exports, "startOfMinute", function () { return $f7b7b7b4fe06340d$export$c66440458c6aa793; }, function (v) { return $f7b7b7b4fe06340d$export$c66440458c6aa793 = v; });
var $f7b7b7b4fe06340d$export$c66440458c6aa793;
"use strict";
$f7b7b7b4fe06340d$export$c66440458c6aa793 = $f7b7b7b4fe06340d$var$startOfMinute;

/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */ function $f7b7b7b4fe06340d$var$startOfMinute(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    _date.setSeconds(0, 0);
    return _date;
}



/**
 * The {@link eachMinuteOfInterval} function options.
 */ /**
 * @name eachMinuteOfInterval
 * @category Interval Helpers
 * @summary Return the array of minutes within the specified time interval.
 *
 * @description
 * Returns the array of minutes within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of minutes from the minute of the interval start to the minute of the interval end
 *
 * @example
 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
 * const result = eachMinuteOfInterval({
 *   start: new Date(2014, 9, 14, 13),
 *   end: new Date(2014, 9, 14, 13, 3)
 * })
 * //=> [
 * //   Wed Oct 14 2014 13:00:00,
 * //   Wed Oct 14 2014 13:01:00,
 * //   Wed Oct 14 2014 13:02:00,
 * //   Wed Oct 14 2014 13:03:00
 * // ]
 */ function $0d58328b32235397$var$eachMinuteOfInterval(interval, options) {
    const startDate = (0, $f7b7b7b4fe06340d$export$c66440458c6aa793)((0, $838192f7942a2bce$export$e67a095c620b86fe)(interval.start));
    const endDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $838192f7942a2bce$export$e67a095c620b86fe)(currentDate));
        currentDate = (0, $f93c9629650c9d53$export$2287e3d29250119e)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($0d58328b32235397$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $0d58328b32235397$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $0d58328b32235397$exports[key];
        }
    });
});
var $458eeb9303f92e25$exports = {};

$parcel$export($458eeb9303f92e25$exports, "eachMonthOfInterval", function () { return $458eeb9303f92e25$export$1c9322f2d2a5eed3; }, function (v) { return $458eeb9303f92e25$export$1c9322f2d2a5eed3 = v; });
var $458eeb9303f92e25$export$1c9322f2d2a5eed3;
"use strict";
$458eeb9303f92e25$export$1c9322f2d2a5eed3 = $458eeb9303f92e25$var$eachMonthOfInterval;

/**
 * The {@link eachMonthOfInterval} function options.
 */ /**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of months from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */ function $458eeb9303f92e25$var$eachMonthOfInterval(interval, options) {
    const startDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $838192f7942a2bce$export$e67a095c620b86fe)(currentDate));
        currentDate.setMonth(currentDate.getMonth() + step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($458eeb9303f92e25$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $458eeb9303f92e25$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $458eeb9303f92e25$exports[key];
        }
    });
});
var $14f0b44900245a9b$exports = {};

$parcel$export($14f0b44900245a9b$exports, "eachQuarterOfInterval", function () { return $14f0b44900245a9b$export$96790a0abfab0078; }, function (v) { return $14f0b44900245a9b$export$96790a0abfab0078 = v; });
var $14f0b44900245a9b$export$96790a0abfab0078;
"use strict";
$14f0b44900245a9b$export$96790a0abfab0078 = $14f0b44900245a9b$var$eachQuarterOfInterval;

var $fc9398e6271fd192$exports = {};

$parcel$export($fc9398e6271fd192$exports, "startOfQuarter", function () { return $fc9398e6271fd192$export$69be7267a042ecb3; }, function (v) { return $fc9398e6271fd192$export$69be7267a042ecb3 = v; });
var $fc9398e6271fd192$export$69be7267a042ecb3;
"use strict";
$fc9398e6271fd192$export$69be7267a042ecb3 = $fc9398e6271fd192$var$startOfQuarter;

/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */ function $fc9398e6271fd192$var$startOfQuarter(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}



/**
 * The {@link eachQuarterOfInterval} function options.
 */ /**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * const result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */ function $14f0b44900245a9b$var$eachQuarterOfInterval(interval, options) {
    const startDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +(0, $fc9398e6271fd192$export$69be7267a042ecb3)(startDate) : +(0, $fc9398e6271fd192$export$69be7267a042ecb3)(endDate);
    let currentDate = reversed ? (0, $fc9398e6271fd192$export$69be7267a042ecb3)(endDate) : (0, $fc9398e6271fd192$export$69be7267a042ecb3)(startDate);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $838192f7942a2bce$export$e67a095c620b86fe)(currentDate));
        currentDate = (0, $ba4355b59e4c2ae3$export$c252a41d0fbed2ce)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($14f0b44900245a9b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $14f0b44900245a9b$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $14f0b44900245a9b$exports[key];
        }
    });
});
var $8b33b5d4a5aa6e16$exports = {};

$parcel$export($8b33b5d4a5aa6e16$exports, "eachWeekOfInterval", function () { return $8b33b5d4a5aa6e16$export$d31a8caec75fa456; }, function (v) { return $8b33b5d4a5aa6e16$export$d31a8caec75fa456 = v; });
var $8b33b5d4a5aa6e16$export$d31a8caec75fa456;
"use strict";
$8b33b5d4a5aa6e16$export$d31a8caec75fa456 = $8b33b5d4a5aa6e16$var$eachWeekOfInterval;



/**
 * The {@link eachWeekOfInterval} function options.
 */ /**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of weeks from the week of the interval start to the week of the interval end
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * const result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */ function $8b33b5d4a5aa6e16$var$eachWeekOfInterval(interval, options) {
    const startDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const startDateWeek = reversed ? (0, $cb6997e20defc27a$export$42c81a444fbfb5d4)(endDate, options) : (0, $cb6997e20defc27a$export$42c81a444fbfb5d4)(startDate, options);
    const endDateWeek = reversed ? (0, $cb6997e20defc27a$export$42c81a444fbfb5d4)(startDate, options) : (0, $cb6997e20defc27a$export$42c81a444fbfb5d4)(endDate, options);
    // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
    startDateWeek.setHours(15);
    endDateWeek.setHours(15);
    const endTime = +endDateWeek.getTime();
    let currentDate = startDateWeek;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        currentDate.setHours(0);
        dates.push((0, $838192f7942a2bce$export$e67a095c620b86fe)(currentDate));
        currentDate = (0, $fddea87cb66f8480$export$ef501a2bb4f3ee6b)(currentDate, step);
        currentDate.setHours(15);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($8b33b5d4a5aa6e16$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $8b33b5d4a5aa6e16$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $8b33b5d4a5aa6e16$exports[key];
        }
    });
});
var $f29031ceab3480ac$exports = {};

$parcel$export($f29031ceab3480ac$exports, "eachWeekendOfInterval", function () { return $f29031ceab3480ac$export$a2ae85dd849354a8; }, function (v) { return $f29031ceab3480ac$export$a2ae85dd849354a8 = v; });
var $f29031ceab3480ac$export$a2ae85dd849354a8;
"use strict";
$f29031ceab3480ac$export$a2ae85dd849354a8 = $f29031ceab3480ac$var$eachWeekendOfInterval;


/**
 * @name eachWeekendOfInterval
 * @category Interval Helpers
 * @summary List all the Saturdays and Sundays in the given date interval.
 *
 * @description
 * Get all the Saturdays and Sundays in the given date interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The given interval
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given date interval
 * const result = eachWeekendOfInterval({
 *   start: new Date(2018, 8, 17),
 *   end: new Date(2018, 8, 30)
 * })
 * //=> [
 * //   Sat Sep 22 2018 00:00:00,
 * //   Sun Sep 23 2018 00:00:00,
 * //   Sat Sep 29 2018 00:00:00,
 * //   Sun Sep 30 2018 00:00:00
 * // ]
 */ function $f29031ceab3480ac$var$eachWeekendOfInterval(interval) {
    const dateInterval = (0, $6b88e797d9b907bf$export$7a337e5923c7ceb5)(interval);
    const weekends = [];
    let index = 0;
    while(index < dateInterval.length){
        const date = dateInterval[index++];
        if ((0, $cb1411d6fcaa37ae$export$618d60ea299da42)(date)) weekends.push(date);
    }
    return weekends;
}


Object.keys($f29031ceab3480ac$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $f29031ceab3480ac$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $f29031ceab3480ac$exports[key];
        }
    });
});
var $85408680d0b86abc$exports = {};

$parcel$export($85408680d0b86abc$exports, "eachWeekendOfMonth", function () { return $85408680d0b86abc$export$f9a185d0ad232d17; }, function (v) { return $85408680d0b86abc$export$f9a185d0ad232d17 = v; });
var $85408680d0b86abc$export$f9a185d0ad232d17;
"use strict";
$85408680d0b86abc$export$f9a185d0ad232d17 = $85408680d0b86abc$var$eachWeekendOfMonth;


var $ef4241263f1a03f4$exports = {};

$parcel$export($ef4241263f1a03f4$exports, "startOfMonth", function () { return $ef4241263f1a03f4$export$a5a3b454ada2268e; }, function (v) { return $ef4241263f1a03f4$export$a5a3b454ada2268e = v; });
var $ef4241263f1a03f4$export$a5a3b454ada2268e;
"use strict";
$ef4241263f1a03f4$export$a5a3b454ada2268e = $ef4241263f1a03f4$var$startOfMonth;

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $ef4241263f1a03f4$var$startOfMonth(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


/**
 * @name eachWeekendOfMonth
 * @category Month Helpers
 * @summary List all the Saturdays and Sundays in the given month.
 *
 * @description
 * Get all the Saturdays and Sundays in the given month.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given month
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given month
 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
 * //=> [
 * //   Sat Feb 05 2022 00:00:00,
 * //   Sun Feb 06 2022 00:00:00,
 * //   Sat Feb 12 2022 00:00:00,
 * //   Sun Feb 13 2022 00:00:00,
 * //   Sat Feb 19 2022 00:00:00,
 * //   Sun Feb 20 2022 00:00:00,
 * //   Sat Feb 26 2022 00:00:00,
 * //   Sun Feb 27 2022 00:00:00
 * // ]
 */ function $85408680d0b86abc$var$eachWeekendOfMonth(date) {
    const start = (0, $ef4241263f1a03f4$export$a5a3b454ada2268e)(date);
    const end = (0, $9bf63f6cf81e2764$export$a2258d9c4118825c)(date);
    return (0, $f29031ceab3480ac$export$a2ae85dd849354a8)({
        start: start,
        end: end
    });
}


Object.keys($85408680d0b86abc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $85408680d0b86abc$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $85408680d0b86abc$exports[key];
        }
    });
});
var $bb166cf3c3876a81$exports = {};

$parcel$export($bb166cf3c3876a81$exports, "eachWeekendOfYear", function () { return $bb166cf3c3876a81$export$d4a9e5efc1ddceb9; }, function (v) { return $bb166cf3c3876a81$export$d4a9e5efc1ddceb9 = v; });
var $bb166cf3c3876a81$export$d4a9e5efc1ddceb9;
"use strict";
$bb166cf3c3876a81$export$d4a9e5efc1ddceb9 = $bb166cf3c3876a81$var$eachWeekendOfYear;

var $6dfb7bb08a96201b$exports = {};

$parcel$export($6dfb7bb08a96201b$exports, "endOfYear", function () { return $6dfb7bb08a96201b$export$8b7aa55c66d5569e; }, function (v) { return $6dfb7bb08a96201b$export$8b7aa55c66d5569e = v; });
var $6dfb7bb08a96201b$export$8b7aa55c66d5569e;
"use strict";
$6dfb7bb08a96201b$export$8b7aa55c66d5569e = $6dfb7bb08a96201b$var$endOfYear;

/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ function $6dfb7bb08a96201b$var$endOfYear(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


var $ef984db75ccd03f4$exports = {};

$parcel$export($ef984db75ccd03f4$exports, "startOfYear", function () { return $ef984db75ccd03f4$export$f91e89d3d0406102; }, function (v) { return $ef984db75ccd03f4$export$f91e89d3d0406102 = v; });
var $ef984db75ccd03f4$export$f91e89d3d0406102;
"use strict";
$ef984db75ccd03f4$export$f91e89d3d0406102 = $ef984db75ccd03f4$var$startOfYear;


/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ function $ef984db75ccd03f4$var$startOfYear(date) {
    const cleanDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const _date = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


/**
 * @name eachWeekendOfYear
 * @category Year Helpers
 * @summary List all the Saturdays and Sundays in the year.
 *
 * @description
 * Get all the Saturdays and Sundays in the year.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given year
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the year
 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
 * //=> [
 * //   Sat Jan 03 2020 00:00:00,
 * //   Sun Jan 04 2020 00:00:00,
 * //   ...
 * //   Sun Dec 27 2020 00:00:00
 * // ]
 * ]
 */ function $bb166cf3c3876a81$var$eachWeekendOfYear(date) {
    const start = (0, $ef984db75ccd03f4$export$f91e89d3d0406102)(date);
    const end = (0, $6dfb7bb08a96201b$export$8b7aa55c66d5569e)(date);
    return (0, $f29031ceab3480ac$export$a2ae85dd849354a8)({
        start: start,
        end: end
    });
}


Object.keys($bb166cf3c3876a81$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $bb166cf3c3876a81$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $bb166cf3c3876a81$exports[key];
        }
    });
});
var $d308b77ad1f07c64$exports = {};

$parcel$export($d308b77ad1f07c64$exports, "eachYearOfInterval", function () { return $d308b77ad1f07c64$export$9b7f165f0a71d2a5; }, function (v) { return $d308b77ad1f07c64$export$9b7f165f0a71d2a5 = v; });
var $d308b77ad1f07c64$export$9b7f165f0a71d2a5;
"use strict";
$d308b77ad1f07c64$export$9b7f165f0a71d2a5 = $d308b77ad1f07c64$var$eachYearOfInterval;

/**
 * The {@link eachYearOfInterval} function options.
 */ /**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 *
 * @returns The array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */ function $d308b77ad1f07c64$var$eachYearOfInterval(interval, options) {
    const startDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setMonth(0, 1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $838192f7942a2bce$export$e67a095c620b86fe)(currentDate));
        currentDate.setFullYear(currentDate.getFullYear() + step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($d308b77ad1f07c64$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $d308b77ad1f07c64$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $d308b77ad1f07c64$exports[key];
        }
    });
});

Object.keys($060b0a669f1660d3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $060b0a669f1660d3$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $060b0a669f1660d3$exports[key];
        }
    });
});
var $22f3a1d871d5bcdc$exports = {};

$parcel$export($22f3a1d871d5bcdc$exports, "endOfDecade", function () { return $22f3a1d871d5bcdc$export$b922ac31d5bbe7a6; }, function (v) { return $22f3a1d871d5bcdc$export$b922ac31d5bbe7a6 = v; });
var $22f3a1d871d5bcdc$export$b922ac31d5bbe7a6;
"use strict";
$22f3a1d871d5bcdc$export$b922ac31d5bbe7a6 = $22f3a1d871d5bcdc$var$endOfDecade;

/**
 * @name endOfDecade
 * @category Decade Helpers
 * @summary Return the end of a decade for the given date.
 *
 * @description
 * Return the end of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a decade
 *
 * @example
 * // The end of a decade for 12 May 1984 00:00:00:
 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
 * //=> Dec 31 1989 23:59:59.999
 */ function $22f3a1d871d5bcdc$var$endOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 11, 31);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


Object.keys($22f3a1d871d5bcdc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $22f3a1d871d5bcdc$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $22f3a1d871d5bcdc$exports[key];
        }
    });
});
var $2a22094c7f40b95f$exports = {};

$parcel$export($2a22094c7f40b95f$exports, "endOfHour", function () { return $2a22094c7f40b95f$export$95ae95d2176c5f0; }, function (v) { return $2a22094c7f40b95f$export$95ae95d2176c5f0 = v; });
var $2a22094c7f40b95f$export$95ae95d2176c5f0;
"use strict";
$2a22094c7f40b95f$export$95ae95d2176c5f0 = $2a22094c7f40b95f$var$endOfHour;

/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */ function $2a22094c7f40b95f$var$endOfHour(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    _date.setMinutes(59, 59, 999);
    return _date;
}


Object.keys($2a22094c7f40b95f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $2a22094c7f40b95f$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $2a22094c7f40b95f$exports[key];
        }
    });
});
var $a1093d39b5427b14$exports = {};

$parcel$export($a1093d39b5427b14$exports, "endOfISOWeek", function () { return $a1093d39b5427b14$export$186cd934f32084be; }, function (v) { return $a1093d39b5427b14$export$186cd934f32084be = v; });
var $a1093d39b5427b14$export$186cd934f32084be;
"use strict";
$a1093d39b5427b14$export$186cd934f32084be = $a1093d39b5427b14$var$endOfISOWeek;
var $a720d0582428e795$exports = {};

$parcel$export($a720d0582428e795$exports, "endOfWeek", function () { return $a720d0582428e795$export$ef8b6d9133084f4e; }, function (v) { return $a720d0582428e795$export$ef8b6d9133084f4e = v; });
var $a720d0582428e795$export$ef8b6d9133084f4e;
"use strict";
$a720d0582428e795$export$ef8b6d9133084f4e = $a720d0582428e795$var$endOfWeek;


/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $a720d0582428e795$var$endOfWeek(date, options) {
    const defaultOptions = (0, $0a8793ff6cad2441$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $a1093d39b5427b14$var$endOfISOWeek(date) {
    return (0, $a720d0582428e795$export$ef8b6d9133084f4e)(date, {
        weekStartsOn: 1
    });
}


Object.keys($a1093d39b5427b14$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $a1093d39b5427b14$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $a1093d39b5427b14$exports[key];
        }
    });
});
var $85a092396596c773$exports = {};

$parcel$export($85a092396596c773$exports, "endOfISOWeekYear", function () { return $85a092396596c773$export$73068f3824c9c1d; }, function (v) { return $85a092396596c773$export$73068f3824c9c1d = v; });
var $85a092396596c773$export$73068f3824c9c1d;
"use strict";
$85a092396596c773$export$73068f3824c9c1d = $85a092396596c773$var$endOfISOWeekYear;



/**
 * @name endOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */ function $85a092396596c773$var$endOfISOWeekYear(date) {
    const year = (0, $f51448e7e5a1f4fe$export$3dbc52535f6f8fcc)(date);
    const fourthOfJanuaryOfNextYear = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const _date = (0, $0ce4d92e449d76da$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    _date.setMilliseconds(_date.getMilliseconds() - 1);
    return _date;
}


Object.keys($85a092396596c773$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $85a092396596c773$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $85a092396596c773$exports[key];
        }
    });
});
var $d7a0487d8084c239$exports = {};

$parcel$export($d7a0487d8084c239$exports, "endOfMinute", function () { return $d7a0487d8084c239$export$a06a772fc63bff07; }, function (v) { return $d7a0487d8084c239$export$a06a772fc63bff07 = v; });
var $d7a0487d8084c239$export$a06a772fc63bff07;
"use strict";
$d7a0487d8084c239$export$a06a772fc63bff07 = $d7a0487d8084c239$var$endOfMinute;

/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */ function $d7a0487d8084c239$var$endOfMinute(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    _date.setSeconds(59, 999);
    return _date;
}


Object.keys($d7a0487d8084c239$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $d7a0487d8084c239$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $d7a0487d8084c239$exports[key];
        }
    });
});

Object.keys($9bf63f6cf81e2764$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $9bf63f6cf81e2764$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $9bf63f6cf81e2764$exports[key];
        }
    });
});
var $7a6eab6e48c5b4a2$exports = {};

$parcel$export($7a6eab6e48c5b4a2$exports, "endOfQuarter", function () { return $7a6eab6e48c5b4a2$export$5f53493861eef879; }, function (v) { return $7a6eab6e48c5b4a2$export$5f53493861eef879 = v; });
var $7a6eab6e48c5b4a2$export$5f53493861eef879;
"use strict";
$7a6eab6e48c5b4a2$export$5f53493861eef879 = $7a6eab6e48c5b4a2$var$endOfQuarter;

/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $7a6eab6e48c5b4a2$var$endOfQuarter(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


Object.keys($7a6eab6e48c5b4a2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $7a6eab6e48c5b4a2$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $7a6eab6e48c5b4a2$exports[key];
        }
    });
});
var $0d2c0e64b2b1b3ce$exports = {};

$parcel$export($0d2c0e64b2b1b3ce$exports, "endOfSecond", function () { return $0d2c0e64b2b1b3ce$export$ef560ab2fa7b52a2; }, function (v) { return $0d2c0e64b2b1b3ce$export$ef560ab2fa7b52a2 = v; });
var $0d2c0e64b2b1b3ce$export$ef560ab2fa7b52a2;
"use strict";
$0d2c0e64b2b1b3ce$export$ef560ab2fa7b52a2 = $0d2c0e64b2b1b3ce$var$endOfSecond;

/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */ function $0d2c0e64b2b1b3ce$var$endOfSecond(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    _date.setMilliseconds(999);
    return _date;
}


Object.keys($0d2c0e64b2b1b3ce$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $0d2c0e64b2b1b3ce$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $0d2c0e64b2b1b3ce$exports[key];
        }
    });
});
var $cc37db05f79dbcc0$exports = {};

$parcel$export($cc37db05f79dbcc0$exports, "endOfToday", function () { return $cc37db05f79dbcc0$export$1b7031a80bd92a6e; }, function (v) { return $cc37db05f79dbcc0$export$1b7031a80bd92a6e = v; });
var $cc37db05f79dbcc0$export$1b7031a80bd92a6e;
"use strict";
$cc37db05f79dbcc0$export$1b7031a80bd92a6e = $cc37db05f79dbcc0$var$endOfToday;

/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */ function $cc37db05f79dbcc0$var$endOfToday() {
    return (0, $060b0a669f1660d3$export$eb9a03f0e9aa6cea)(Date.now());
}


Object.keys($cc37db05f79dbcc0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $cc37db05f79dbcc0$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $cc37db05f79dbcc0$exports[key];
        }
    });
});
var $ad8aa09e68e64f33$exports = {};

$parcel$export($ad8aa09e68e64f33$exports, "endOfTomorrow", function () { return $ad8aa09e68e64f33$export$d788ac27ae2a54ea; }, function (v) { return $ad8aa09e68e64f33$export$d788ac27ae2a54ea = v; });
var $ad8aa09e68e64f33$export$d788ac27ae2a54ea;
"use strict";
$ad8aa09e68e64f33$export$d788ac27ae2a54ea = $ad8aa09e68e64f33$var$endOfTomorrow; /**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */ 
function $ad8aa09e68e64f33$var$endOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(23, 59, 59, 999);
    return date;
}


Object.keys($ad8aa09e68e64f33$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $ad8aa09e68e64f33$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $ad8aa09e68e64f33$exports[key];
        }
    });
});

Object.keys($a720d0582428e795$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $a720d0582428e795$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $a720d0582428e795$exports[key];
        }
    });
});

Object.keys($6dfb7bb08a96201b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $6dfb7bb08a96201b$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $6dfb7bb08a96201b$exports[key];
        }
    });
});
var $36db6283855268cc$exports = {};

$parcel$export($36db6283855268cc$exports, "endOfYesterday", function () { return $36db6283855268cc$export$45190faf1024f97a; }, function (v) { return $36db6283855268cc$export$45190faf1024f97a = v; });
var $36db6283855268cc$export$45190faf1024f97a;
"use strict";
$36db6283855268cc$export$45190faf1024f97a = $36db6283855268cc$var$endOfYesterday; /**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */ 
function $36db6283855268cc$var$endOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(23, 59, 59, 999);
    return date;
}


Object.keys($36db6283855268cc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $36db6283855268cc$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $36db6283855268cc$exports[key];
        }
    });
});
var $5e9653939083877e$exports = {};
"use strict";
$5e9653939083877e$exports.format = $5e9653939083877e$exports.formatDate = $5e9653939083877e$var$format;
Object.defineProperty($5e9653939083877e$exports, "formatters", {
    enumerable: true,
    get: function() {
        return $5672e54b9df4bc96$export$fe98a034cfb96d55;
    }
});
Object.defineProperty($5e9653939083877e$exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $4d8da8b2c802488a$export$70cc8fd02856fd58;
    }
});
var $f767131746751219$exports = {};
"use strict";
Object.defineProperty($f767131746751219$exports, "defaultLocale", {
    enumerable: true,
    get: function() {
        return $a387a49854a692f1$export$137380d9ce54f7f;
    }
});
var $a387a49854a692f1$export$137380d9ce54f7f;
"use strict";
$a387a49854a692f1$export$137380d9ce54f7f = void 0;
var $28df8aed18a0ab61$export$2c14ff85d6318973;
"use strict";
$28df8aed18a0ab61$export$2c14ff85d6318973 = void 0;
const $28df8aed18a0ab61$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $28df8aed18a0ab61$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $28df8aed18a0ab61$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
$28df8aed18a0ab61$export$2c14ff85d6318973 = $28df8aed18a0ab61$var$formatDistance;


var $d9b5ae685e2b4649$export$cbf60ecb96cbb82f;
"use strict";
$d9b5ae685e2b4649$export$cbf60ecb96cbb82f = void 0;
var $ebbf03c2216fdd46$export$38e44e97ce4dbb7d;
"use strict";
$ebbf03c2216fdd46$export$38e44e97ce4dbb7d = $ebbf03c2216fdd46$var$buildFormatLongFn;
function $ebbf03c2216fdd46$var$buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $d9b5ae685e2b4649$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $d9b5ae685e2b4649$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $d9b5ae685e2b4649$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $d9b5ae685e2b4649$var$formatLong = $d9b5ae685e2b4649$export$cbf60ecb96cbb82f = {
    date: (0, $ebbf03c2216fdd46$export$38e44e97ce4dbb7d)({
        formats: $d9b5ae685e2b4649$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $ebbf03c2216fdd46$export$38e44e97ce4dbb7d)({
        formats: $d9b5ae685e2b4649$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $ebbf03c2216fdd46$export$38e44e97ce4dbb7d)({
        formats: $d9b5ae685e2b4649$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $d126c82acbb8e032$export$8fbbfd65594f46a0;
"use strict";
$d126c82acbb8e032$export$8fbbfd65594f46a0 = void 0;
const $d126c82acbb8e032$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $d126c82acbb8e032$var$formatRelative = (token, _date, _baseDate, _options)=>$d126c82acbb8e032$var$formatRelativeLocale[token];
$d126c82acbb8e032$export$8fbbfd65594f46a0 = $d126c82acbb8e032$var$formatRelative;


var $7fe035e43eff6d02$export$b3bd0bc58e36cd63;
"use strict";
$7fe035e43eff6d02$export$b3bd0bc58e36cd63 = void 0;
var $f1d99a649f4bd919$export$63596d6ee8878b25;
"use strict";
$f1d99a649f4bd919$export$63596d6ee8878b25 = $f1d99a649f4bd919$var$buildLocalizeFn; /* eslint-disable no-unused-vars */ 
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $f1d99a649f4bd919$var$buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $7fe035e43eff6d02$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $7fe035e43eff6d02$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $7fe035e43eff6d02$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $7fe035e43eff6d02$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $7fe035e43eff6d02$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $7fe035e43eff6d02$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $7fe035e43eff6d02$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $7fe035e43eff6d02$var$localize = $7fe035e43eff6d02$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $7fe035e43eff6d02$var$ordinalNumber,
    era: (0, $f1d99a649f4bd919$export$63596d6ee8878b25)({
        values: $7fe035e43eff6d02$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $f1d99a649f4bd919$export$63596d6ee8878b25)({
        values: $7fe035e43eff6d02$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $f1d99a649f4bd919$export$63596d6ee8878b25)({
        values: $7fe035e43eff6d02$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $f1d99a649f4bd919$export$63596d6ee8878b25)({
        values: $7fe035e43eff6d02$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $f1d99a649f4bd919$export$63596d6ee8878b25)({
        values: $7fe035e43eff6d02$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $7fe035e43eff6d02$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $d864336279b457a7$export$4659b591c19bdf3d;
"use strict";
$d864336279b457a7$export$4659b591c19bdf3d = void 0;
var $0030e0afa9ad05ff$export$1430a0f35710914d;
"use strict";
$0030e0afa9ad05ff$export$1430a0f35710914d = $0030e0afa9ad05ff$var$buildMatchFn;
function $0030e0afa9ad05ff$var$buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $0030e0afa9ad05ff$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $0030e0afa9ad05ff$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $0030e0afa9ad05ff$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $0030e0afa9ad05ff$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


var $86020007c887df0a$export$fdaf2fd6d7edde95;
"use strict";
$86020007c887df0a$export$fdaf2fd6d7edde95 = $86020007c887df0a$var$buildMatchPatternFn;
function $86020007c887df0a$var$buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $d864336279b457a7$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $d864336279b457a7$var$parseOrdinalNumberPattern = /\d+/i;
const $d864336279b457a7$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $d864336279b457a7$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $d864336279b457a7$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $d864336279b457a7$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d864336279b457a7$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $d864336279b457a7$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $d864336279b457a7$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $d864336279b457a7$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $d864336279b457a7$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $d864336279b457a7$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $d864336279b457a7$var$match = $d864336279b457a7$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $86020007c887df0a$export$fdaf2fd6d7edde95)({
        matchPattern: $d864336279b457a7$var$matchOrdinalNumberPattern,
        parsePattern: $d864336279b457a7$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $0030e0afa9ad05ff$export$1430a0f35710914d)({
        matchPatterns: $d864336279b457a7$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d864336279b457a7$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $0030e0afa9ad05ff$export$1430a0f35710914d)({
        matchPatterns: $d864336279b457a7$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d864336279b457a7$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $0030e0afa9ad05ff$export$1430a0f35710914d)({
        matchPatterns: $d864336279b457a7$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d864336279b457a7$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $0030e0afa9ad05ff$export$1430a0f35710914d)({
        matchPatterns: $d864336279b457a7$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d864336279b457a7$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $0030e0afa9ad05ff$export$1430a0f35710914d)({
        matchPatterns: $d864336279b457a7$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d864336279b457a7$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ const $a387a49854a692f1$var$enUS = $a387a49854a692f1$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: $28df8aed18a0ab61$export$2c14ff85d6318973,
    formatLong: $d9b5ae685e2b4649$export$cbf60ecb96cbb82f,
    formatRelative: $d126c82acbb8e032$export$8fbbfd65594f46a0,
    localize: $7fe035e43eff6d02$export$b3bd0bc58e36cd63,
    match: $d864336279b457a7$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};





var $5672e54b9df4bc96$export$fe98a034cfb96d55;
"use strict";
$5672e54b9df4bc96$export$fe98a034cfb96d55 = void 0;
var $b74c283f23517f77$exports = {};

$parcel$export($b74c283f23517f77$exports, "getDayOfYear", function () { return $b74c283f23517f77$export$d3b42cd8452deec; }, function (v) { return $b74c283f23517f77$export$d3b42cd8452deec = v; });
var $b74c283f23517f77$export$d3b42cd8452deec;
"use strict";
$b74c283f23517f77$export$d3b42cd8452deec = $b74c283f23517f77$var$getDayOfYear;



/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ function $b74c283f23517f77$var$getDayOfYear(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const diff = (0, $bb6062a6bff69209$export$4a02e9c37dab4871)(_date, (0, $ef984db75ccd03f4$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}


var $012d4ce6324b9cab$exports = {};

$parcel$export($012d4ce6324b9cab$exports, "getISOWeek", function () { return $012d4ce6324b9cab$export$7cabdc5698b63e2f; }, function (v) { return $012d4ce6324b9cab$export$7cabdc5698b63e2f = v; });
var $012d4ce6324b9cab$export$7cabdc5698b63e2f;
"use strict";
$012d4ce6324b9cab$export$7cabdc5698b63e2f = $012d4ce6324b9cab$var$getISOWeek;




/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ function $012d4ce6324b9cab$var$getISOWeek(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const diff = +(0, $0ce4d92e449d76da$export$6173213f95a4431e)(_date) - +(0, $4ac098d276fcecdf$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $9e66e67751f962b4$export$4fad13613e88edc8) + 1;
}



var $dc1515b472a87eee$exports = {};

$parcel$export($dc1515b472a87eee$exports, "getWeek", function () { return $dc1515b472a87eee$export$efe19b760242b2fc; }, function (v) { return $dc1515b472a87eee$export$efe19b760242b2fc = v; });
var $dc1515b472a87eee$export$efe19b760242b2fc;
"use strict";
$dc1515b472a87eee$export$efe19b760242b2fc = $dc1515b472a87eee$var$getWeek;


var $d1e02aa9a9900333$exports = {};

$parcel$export($d1e02aa9a9900333$exports, "startOfWeekYear", function () { return $d1e02aa9a9900333$export$bb7b45bb8e74da0f; }, function (v) { return $d1e02aa9a9900333$export$bb7b45bb8e74da0f = v; });
var $d1e02aa9a9900333$export$bb7b45bb8e74da0f;
"use strict";
$d1e02aa9a9900333$export$bb7b45bb8e74da0f = $d1e02aa9a9900333$var$startOfWeekYear;

var $ff8b4ec1d3426046$exports = {};

$parcel$export($ff8b4ec1d3426046$exports, "getWeekYear", function () { return $ff8b4ec1d3426046$export$12d572480ceb6e58; }, function (v) { return $ff8b4ec1d3426046$export$12d572480ceb6e58 = v; });
var $ff8b4ec1d3426046$export$12d572480ceb6e58;
"use strict";
$ff8b4ec1d3426046$export$12d572480ceb6e58 = $ff8b4ec1d3426046$var$getWeekYear;




/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ function $ff8b4ec1d3426046$var$getWeekYear(date, options) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $0a8793ff6cad2441$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $cb6997e20defc27a$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $cb6997e20defc27a$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ function $d1e02aa9a9900333$var$startOfWeekYear(date, options) {
    const defaultOptions = (0, $0a8793ff6cad2441$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $ff8b4ec1d3426046$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $cb6997e20defc27a$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}



/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ function $dc1515b472a87eee$var$getWeek(date, options) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const diff = +(0, $cb6997e20defc27a$export$42c81a444fbfb5d4)(_date, options) - +(0, $d1e02aa9a9900333$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $9e66e67751f962b4$export$4fad13613e88edc8) + 1;
}



var $0e4bfa9839b2a001$export$c8306e720e213c0f;
"use strict";
$0e4bfa9839b2a001$export$c8306e720e213c0f = $0e4bfa9839b2a001$var$addLeadingZeros;
function $0e4bfa9839b2a001$var$addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}


var $66714b725085036c$export$b0d4b338e1516f13;
"use strict";
$66714b725085036c$export$b0d4b338e1516f13 = void 0;

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ const $66714b725085036c$var$lightFormatters = $66714b725085036c$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $5672e54b9df4bc96$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ const $5672e54b9df4bc96$var$formatters = $5672e54b9df4bc96$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return $66714b725085036c$export$b0d4b338e1516f13.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $ff8b4ec1d3426046$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $f51448e7e5a1f4fe$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return $66714b725085036c$export$b0d4b338e1516f13.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $dc1515b472a87eee$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $012d4ce6324b9cab$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return $66714b725085036c$export$b0d4b338e1516f13.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $b74c283f23517f77$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $5672e54b9df4bc96$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $5672e54b9df4bc96$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $5672e54b9df4bc96$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $5672e54b9df4bc96$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $5672e54b9df4bc96$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $5672e54b9df4bc96$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return $66714b725085036c$export$b0d4b338e1516f13.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return $66714b725085036c$export$b0d4b338e1516f13.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return $66714b725085036c$export$b0d4b338e1516f13.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return $66714b725085036c$export$b0d4b338e1516f13.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $66714b725085036c$export$b0d4b338e1516f13.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $5672e54b9df4bc96$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $5672e54b9df4bc96$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $5672e54b9df4bc96$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $5672e54b9df4bc96$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $5672e54b9df4bc96$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $5672e54b9df4bc96$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $5672e54b9df4bc96$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $5672e54b9df4bc96$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $5672e54b9df4bc96$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $5672e54b9df4bc96$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(timestamp, token.length);
    }
};
function $5672e54b9df4bc96$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(minutes, 2);
}
function $5672e54b9df4bc96$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $5672e54b9df4bc96$var$formatTimezone(offset, delimiter);
}
function $5672e54b9df4bc96$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


var $4d8da8b2c802488a$export$70cc8fd02856fd58;
"use strict";
$4d8da8b2c802488a$export$70cc8fd02856fd58 = void 0;
const $4d8da8b2c802488a$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $4d8da8b2c802488a$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $4d8da8b2c802488a$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $4d8da8b2c802488a$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $4d8da8b2c802488a$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $4d8da8b2c802488a$var$timeLongFormatter(timePattern, formatLong));
};
const $4d8da8b2c802488a$var$longFormatters = $4d8da8b2c802488a$export$70cc8fd02856fd58 = {
    p: $4d8da8b2c802488a$var$timeLongFormatter,
    P: $4d8da8b2c802488a$var$dateTimeLongFormatter
};


var $aeba58ccfb38b506$export$c6cc36aa33304772;
var $aeba58ccfb38b506$export$c6b49d6dceb604a1;
var $aeba58ccfb38b506$export$f5f38f90ecaaf879;
"use strict";
$aeba58ccfb38b506$export$c6cc36aa33304772 = $aeba58ccfb38b506$var$isProtectedDayOfYearToken;
$aeba58ccfb38b506$export$c6b49d6dceb604a1 = $aeba58ccfb38b506$var$isProtectedWeekYearToken;
$aeba58ccfb38b506$export$f5f38f90ecaaf879 = $aeba58ccfb38b506$var$warnOrThrowProtectedError;
const $aeba58ccfb38b506$var$dayOfYearTokenRE = /^D+$/;
const $aeba58ccfb38b506$var$weekYearTokenRE = /^Y+$/;
const $aeba58ccfb38b506$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $aeba58ccfb38b506$var$isProtectedDayOfYearToken(token) {
    return $aeba58ccfb38b506$var$dayOfYearTokenRE.test(token);
}
function $aeba58ccfb38b506$var$isProtectedWeekYearToken(token) {
    return $aeba58ccfb38b506$var$weekYearTokenRE.test(token);
}
function $aeba58ccfb38b506$var$warnOrThrowProtectedError(token, format, input) {
    const _message = $aeba58ccfb38b506$var$message(token, format, input);
    console.warn(_message);
    if ($aeba58ccfb38b506$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $aeba58ccfb38b506$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}




// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $5e9653939083877e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $5e9653939083877e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $5e9653939083877e$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $5e9653939083877e$var$doubleQuoteRegExp = /''/g;
const $5e9653939083877e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $5e9653939083877e$var$format(date, formatStr, options) {
    const defaultOptions = (0, $0a8793ff6cad2441$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $f767131746751219$exports.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    if (!(0, $9686c3631a8bde9c$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($5e9653939083877e$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = $4d8da8b2c802488a$export$70cc8fd02856fd58[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($5e9653939083877e$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $5e9653939083877e$var$cleanEscapedString(substring)
        };
        if ($5672e54b9df4bc96$export$fe98a034cfb96d55[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($5e9653939083877e$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $aeba58ccfb38b506$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $aeba58ccfb38b506$export$c6cc36aa33304772)(token)) (0, $aeba58ccfb38b506$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = $5672e54b9df4bc96$export$fe98a034cfb96d55[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $5e9653939083877e$var$cleanEscapedString(input) {
    const matched = input.match($5e9653939083877e$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($5e9653939083877e$var$doubleQuoteRegExp, "'");
}


Object.keys($5e9653939083877e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $5e9653939083877e$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $5e9653939083877e$exports[key];
        }
    });
});
var $9f2afa0e25070fa6$exports = {};

$parcel$export($9f2afa0e25070fa6$exports, "formatDistance", function () { return $9f2afa0e25070fa6$export$2c14ff85d6318973; }, function (v) { return $9f2afa0e25070fa6$export$2c14ff85d6318973 = v; });
var $9f2afa0e25070fa6$export$2c14ff85d6318973;
"use strict";
$9f2afa0e25070fa6$export$2c14ff85d6318973 = $9f2afa0e25070fa6$var$formatDistance;








/**
 * The {@link formatDistance} function options.
 */ /**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */ function $9f2afa0e25070fa6$var$formatDistance(date, baseDate, options) {
    const defaultOptions = (0, $0a8793ff6cad2441$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $f767131746751219$exports.defaultLocale;
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, $371b71d1995fe7f8$export$fe114145ae75d197)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $838192f7942a2bce$export$e67a095c620b86fe)(baseDate);
        dateRight = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    } else {
        dateLeft = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
        dateRight = (0, $838192f7942a2bce$export$e67a095c620b86fe)(baseDate);
    }
    const seconds = (0, $e4c0e558314ffb9c$export$c1889aec51783710)(dateRight, dateLeft);
    const offsetInSeconds = ((0, $f4008ef8d68e7133$export$113002b5eff6e430)(dateRight) - (0, $f4008ef8d68e7133$export$113002b5eff6e430)(dateLeft)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < $9e66e67751f962b4$export$2423174df8cd3cd2) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < $9e66e67751f962b4$export$ab7da2ccd1075c38) {
        const days = Math.round(minutes / $9e66e67751f962b4$export$2423174df8cd3cd2);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $9e66e67751f962b4$export$ab7da2ccd1075c38 * 2) {
        months = Math.round(minutes / $9e66e67751f962b4$export$ab7da2ccd1075c38);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $119c3b8c8b0e62d4$export$fc1ed482c2861792)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / $9e66e67751f962b4$export$ab7da2ccd1075c38);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}


Object.keys($9f2afa0e25070fa6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $9f2afa0e25070fa6$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $9f2afa0e25070fa6$exports[key];
        }
    });
});
var $5dbad431def7d5d2$exports = {};

$parcel$export($5dbad431def7d5d2$exports, "formatDistanceStrict", function () { return $5dbad431def7d5d2$export$e4be225b8ee0a759; }, function (v) { return $5dbad431def7d5d2$export$e4be225b8ee0a759 = v; });
var $5dbad431def7d5d2$export$e4be225b8ee0a759;
"use strict";
$5dbad431def7d5d2$export$e4be225b8ee0a759 = $5dbad431def7d5d2$var$formatDistanceStrict;







/**
 * The {@link formatDistanceStrict} function options.
 */ /**
 * The unit used to format the distance in {@link formatDistanceStrict}.
 */ /**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */ function $5dbad431def7d5d2$var$formatDistanceStrict(date, baseDate, options) {
    const defaultOptions = (0, $0a8793ff6cad2441$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $f767131746751219$exports.defaultLocale;
    const comparison = (0, $371b71d1995fe7f8$export$fe114145ae75d197)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $838192f7942a2bce$export$e67a095c620b86fe)(baseDate);
        dateRight = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    } else {
        dateLeft = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
        dateRight = (0, $838192f7942a2bce$export$e67a095c620b86fe)(baseDate);
    }
    const roundingMethod = (0, $a15b9f5338a2ad49$export$b6474a47258c1211)(options?.roundingMethod ?? "round");
    const milliseconds = dateRight.getTime() - dateLeft.getTime();
    const minutes = milliseconds / $9e66e67751f962b4$export$91246f0b9bd9beff;
    const timezoneOffset = (0, $f4008ef8d68e7133$export$113002b5eff6e430)(dateRight) - (0, $f4008ef8d68e7133$export$113002b5eff6e430)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    const dstNormalizedMinutes = (milliseconds - timezoneOffset) / $9e66e67751f962b4$export$91246f0b9bd9beff;
    const defaultUnit = options?.unit;
    let unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < $9e66e67751f962b4$export$2423174df8cd3cd2) unit = "hour";
        else if (dstNormalizedMinutes < $9e66e67751f962b4$export$ab7da2ccd1075c38) unit = "day";
        else if (dstNormalizedMinutes < $9e66e67751f962b4$export$3633035e63cee86a) unit = "month";
        else unit = "year";
    } else unit = defaultUnit;
    // 0 up to 60 seconds
    if (unit === "second") {
        const seconds = roundingMethod(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        const roundedMinutes = roundingMethod(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        const hours = roundingMethod(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        const days = roundingMethod(dstNormalizedMinutes / $9e66e67751f962b4$export$2423174df8cd3cd2);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        const months = roundingMethod(dstNormalizedMinutes / $9e66e67751f962b4$export$ab7da2ccd1075c38);
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else {
        const years = roundingMethod(dstNormalizedMinutes / $9e66e67751f962b4$export$3633035e63cee86a);
        return locale.formatDistance("xYears", years, localizeOptions);
    }
}


Object.keys($5dbad431def7d5d2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $5dbad431def7d5d2$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $5dbad431def7d5d2$exports[key];
        }
    });
});
var $ad5e43b721767370$exports = {};

$parcel$export($ad5e43b721767370$exports, "formatDistanceToNow", function () { return $ad5e43b721767370$export$d130c20a256f8817; }, function (v) { return $ad5e43b721767370$export$d130c20a256f8817 = v; });
var $ad5e43b721767370$export$d130c20a256f8817;
"use strict";
$ad5e43b721767370$export$d130c20a256f8817 = $ad5e43b721767370$var$formatDistanceToNow;


/**
 * The {@link formatDistanceToNow} function options.
 */ /**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - The object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */ function $ad5e43b721767370$var$formatDistanceToNow(date, options) {
    return (0, $9f2afa0e25070fa6$export$2c14ff85d6318973)(date, (0, $6284e2d2db30dabc$export$18c3c6510fb97afc)(date), options);
}


Object.keys($ad5e43b721767370$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $ad5e43b721767370$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $ad5e43b721767370$exports[key];
        }
    });
});
var $dc9b3c52af00e28e$exports = {};

$parcel$export($dc9b3c52af00e28e$exports, "formatDistanceToNowStrict", function () { return $dc9b3c52af00e28e$export$d0e02d4eb1ad1e32; }, function (v) { return $dc9b3c52af00e28e$export$d0e02d4eb1ad1e32 = v; });
var $dc9b3c52af00e28e$export$d0e02d4eb1ad1e32;
"use strict";
$dc9b3c52af00e28e$export$d0e02d4eb1ad1e32 = $dc9b3c52af00e28e$var$formatDistanceToNowStrict;


/**
 * The {@link formatDistanceToNowStrict} function options.
 */ /**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */ function $dc9b3c52af00e28e$var$formatDistanceToNowStrict(date, options) {
    return (0, $5dbad431def7d5d2$export$e4be225b8ee0a759)(date, (0, $6284e2d2db30dabc$export$18c3c6510fb97afc)(date), options);
}


Object.keys($dc9b3c52af00e28e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $dc9b3c52af00e28e$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $dc9b3c52af00e28e$exports[key];
        }
    });
});
var $fc7e414172b7921a$exports = {};

$parcel$export($fc7e414172b7921a$exports, "formatDuration", function () { return $fc7e414172b7921a$export$bc733b0c5cbb3e8a; }, function (v) { return $fc7e414172b7921a$export$bc733b0c5cbb3e8a = v; });
var $fc7e414172b7921a$export$bc733b0c5cbb3e8a;
"use strict";
$fc7e414172b7921a$export$bc733b0c5cbb3e8a = $fc7e414172b7921a$var$formatDuration;


/**
 * The {@link formatDuration} function options.
 */ const $fc7e414172b7921a$var$defaultFormat = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds"
];
/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param duration - The duration to format
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */ function $fc7e414172b7921a$var$formatDuration(duration, options) {
    const defaultOptions = (0, $0a8793ff6cad2441$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $f767131746751219$exports.defaultLocale;
    const format = options?.format ?? $fc7e414172b7921a$var$defaultFormat;
    const zero = options?.zero ?? false;
    const delimiter = options?.delimiter ?? " ";
    if (!locale.formatDistance) return "";
    const result = format.reduce((acc, unit)=>{
        const token = `x${unit.replace(/(^.)/, (m)=>m.toUpperCase())}`;
        const value = duration[unit];
        if (value !== undefined && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}


Object.keys($fc7e414172b7921a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $fc7e414172b7921a$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $fc7e414172b7921a$exports[key];
        }
    });
});
var $3c703207704d08ff$exports = {};

$parcel$export($3c703207704d08ff$exports, "formatISO", function () { return $3c703207704d08ff$export$3c826ac3ab9da76c; }, function (v) { return $3c703207704d08ff$export$3c826ac3ab9da76c = v; });
var $3c703207704d08ff$export$3c826ac3ab9da76c;
"use strict";
$3c703207704d08ff$export$3c826ac3ab9da76c = $3c703207704d08ff$var$formatISO;


/**
 * The {@link formatISO} function options.
 */ /**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string (in loca.l time zone)
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */ function $3c703207704d08ff$var$formatISO(date, options) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    if (isNaN(_date.getTime())) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    let tzOffset = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getDate(), 2);
        const month = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getMonth() + 1, 2);
        const year = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        const offset = _date.getTimezoneOffset();
        if (offset !== 0) {
            const absoluteOffset = Math.abs(offset);
            const hourOffset = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(Math.trunc(absoluteOffset / 60), 2);
            const minuteOffset = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            const sign = offset < 0 ? "+" : "-";
            tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
        } else tzOffset = "Z";
        const hour = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getHours(), 2);
        const minute = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getMinutes(), 2);
        const second = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        const separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        const time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${time}${tzOffset}`;
    }
    return result;
}


Object.keys($3c703207704d08ff$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $3c703207704d08ff$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $3c703207704d08ff$exports[key];
        }
    });
});
var $8f9b0aefa69907f7$exports = {};

$parcel$export($8f9b0aefa69907f7$exports, "formatISO9075", function () { return $8f9b0aefa69907f7$export$a673944250043fa4; }, function (v) { return $8f9b0aefa69907f7$export$a673944250043fa4 = v; });
var $8f9b0aefa69907f7$export$a673944250043fa4;
"use strict";
$8f9b0aefa69907f7$export$a673944250043fa4 = $8f9b0aefa69907f7$var$formatISO9075;



/**
 * The {@link formatISO9075} function options.
 */ /**
 * @name formatISO9075
 * @category Common Helpers
 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
 *
 * @description
 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18 19:00:52'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075, short format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918 190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, date only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, time only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52'
 */ function $8f9b0aefa69907f7$var$formatISO9075(date, options) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    if (!(0, $9686c3631a8bde9c$export$1ea939691cdc45b8)(_date)) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getDate(), 2);
        const month = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getMonth() + 1, 2);
        const year = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        const hour = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getHours(), 2);
        const minute = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getMinutes(), 2);
        const second = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with a space
        const separator = result === "" ? "" : " ";
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${hour}${timeDelimiter}${minute}${timeDelimiter}${second}`;
    }
    return result;
}


Object.keys($8f9b0aefa69907f7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $8f9b0aefa69907f7$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $8f9b0aefa69907f7$exports[key];
        }
    });
});
var $58452d8d723e95c7$exports = {};

$parcel$export($58452d8d723e95c7$exports, "formatISODuration", function () { return $58452d8d723e95c7$export$437c31ab743f6b26; }, function (v) { return $58452d8d723e95c7$export$437c31ab743f6b26 = v; });
var $58452d8d723e95c7$export$437c31ab743f6b26;
"use strict";
$58452d8d723e95c7$export$437c31ab743f6b26 = $58452d8d723e95c7$var$formatISODuration;
/**
 * @name formatISODuration
 * @category Common Helpers
 * @summary Format a duration object according as ISO 8601 duration string
 *
 * @description
 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs//90001488-13/reference/r_iso_8601_duration_format.htm)
 *
 * @param duration - The duration to format
 *
 * @returns The ISO 8601 duration string
 *
 * @example
 * // Format the given duration as ISO 8601 string
 * const result = formatISODuration({
 *   years: 39,
 *   months: 2,
 *   days: 20,
 *   hours: 7,
 *   minutes: 5,
 *   seconds: 0
 * })
 * //=> 'P39Y2M20DT0H0M0S'
 */ function $58452d8d723e95c7$var$formatISODuration(duration) {
    const { years: years = 0, months: months = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    return `P${years}Y${months}M${days}DT${hours}H${minutes}M${seconds}S`;
}


Object.keys($58452d8d723e95c7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $58452d8d723e95c7$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $58452d8d723e95c7$exports[key];
        }
    });
});
var $448c551fd840a1f4$exports = {};

$parcel$export($448c551fd840a1f4$exports, "formatRFC3339", function () { return $448c551fd840a1f4$export$6d441bffeec6bd6c; }, function (v) { return $448c551fd840a1f4$export$6d441bffeec6bd6c = v; });
var $448c551fd840a1f4$export$6d441bffeec6bd6c;
"use strict";
$448c551fd840a1f4$export$6d441bffeec6bd6c = $448c551fd840a1f4$var$formatRFC3339;



/**
 * The {@link formatRFC3339} function options.
 */ /**
 * @name formatRFC3339
 * @category Common Helpers
 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
 *
 * @description
 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format:
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), {
 *   fractionDigits: 3
 * })
 * //=> '2019-09-18T19:00:52.234Z'
 */ function $448c551fd840a1f4$var$formatRFC3339(date, options) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    if (!(0, $9686c3631a8bde9c$export$1ea939691cdc45b8)(_date)) throw new RangeError("Invalid time value");
    const fractionDigits = options?.fractionDigits ?? 0;
    const day = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getDate(), 2);
    const month = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getMonth() + 1, 2);
    const year = _date.getFullYear();
    const hour = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getHours(), 2);
    const minute = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getMinutes(), 2);
    const second = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getSeconds(), 2);
    let fractionalSecond = "";
    if (fractionDigits > 0) {
        const milliseconds = _date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, fractionDigits - 3));
        fractionalSecond = "." + (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(fractionalSeconds, fractionDigits);
    }
    let offset = "";
    const tzOffset = _date.getTimezoneOffset();
    if (tzOffset !== 0) {
        const absoluteOffset = Math.abs(tzOffset);
        const hourOffset = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(Math.trunc(absoluteOffset / 60), 2);
        const minuteOffset = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(absoluteOffset % 60, 2);
        // If less than 0, the sign is +, because it is ahead of time.
        const sign = tzOffset < 0 ? "+" : "-";
        offset = `${sign}${hourOffset}:${minuteOffset}`;
    } else offset = "Z";
    return `${year}-${month}-${day}T${hour}:${minute}:${second}${fractionalSecond}${offset}`;
}


Object.keys($448c551fd840a1f4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $448c551fd840a1f4$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $448c551fd840a1f4$exports[key];
        }
    });
});
var $21e7cd086e21eacd$exports = {};

$parcel$export($21e7cd086e21eacd$exports, "formatRFC7231", function () { return $21e7cd086e21eacd$export$7add2e4539ce658a; }, function (v) { return $21e7cd086e21eacd$export$7add2e4539ce658a = v; });
var $21e7cd086e21eacd$export$7add2e4539ce658a;
"use strict";
$21e7cd086e21eacd$export$7add2e4539ce658a = $21e7cd086e21eacd$var$formatRFC7231;



const $21e7cd086e21eacd$var$days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $21e7cd086e21eacd$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
/**
 * @name formatRFC7231
 * @category Common Helpers
 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
 *
 * @description
 * Return the formatted date string in RFC 7231 format.
 * The result will always be in UTC timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 7231 format:
 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
 */ function $21e7cd086e21eacd$var$formatRFC7231(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    if (!(0, $9686c3631a8bde9c$export$1ea939691cdc45b8)(_date)) throw new RangeError("Invalid time value");
    const dayName = $21e7cd086e21eacd$var$days[_date.getUTCDay()];
    const dayOfMonth = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getUTCDate(), 2);
    const monthName = $21e7cd086e21eacd$var$months[_date.getUTCMonth()];
    const year = _date.getUTCFullYear();
    const hour = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getUTCHours(), 2);
    const minute = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getUTCMinutes(), 2);
    const second = (0, $0e4bfa9839b2a001$export$c8306e720e213c0f)(_date.getUTCSeconds(), 2);
    // Result variables.
    return `${dayName}, ${dayOfMonth} ${monthName} ${year} ${hour}:${minute}:${second} GMT`;
}


Object.keys($21e7cd086e21eacd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $21e7cd086e21eacd$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $21e7cd086e21eacd$exports[key];
        }
    });
});
var $1bac3ef95d48a665$exports = {};

$parcel$export($1bac3ef95d48a665$exports, "formatRelative", function () { return $1bac3ef95d48a665$export$8fbbfd65594f46a0; }, function (v) { return $1bac3ef95d48a665$export$8fbbfd65594f46a0 = v; });
var $1bac3ef95d48a665$export$8fbbfd65594f46a0;
"use strict";
$1bac3ef95d48a665$export$8fbbfd65594f46a0 = $1bac3ef95d48a665$var$formatRelative;





/**
 * The {@link formatRelative} function options.
 */ /**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 AM   |
 * | Last day                  | yesterday at 04:30 AM     |
 * | Same day                  | today at 04:30 AM         |
 * | Next day                  | tomorrow at 04:30 AM      |
 * | Next 6 days               | Sunday at 04:30 AM        |
 * | Other                     | 12/31/2017                |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The date in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws `options.locale` must contain `formatRelative` property
 *
 * @example
 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
 * const result = formatRelative(subDays(new Date(), 6), new Date())
 * //=> "last Thursday at 12:45 AM"
 */ function $1bac3ef95d48a665$var$formatRelative(date, baseDate, options) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const _baseDate = (0, $838192f7942a2bce$export$e67a095c620b86fe)(baseDate);
    const defaultOptions = (0, $0a8793ff6cad2441$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $f767131746751219$exports.defaultLocale;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const diff = (0, $bb6062a6bff69209$export$4a02e9c37dab4871)(_date, _baseDate);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    let token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    const formatStr = locale.formatRelative(token, _date, _baseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $5e9653939083877e$exports.format)(_date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}


Object.keys($1bac3ef95d48a665$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $1bac3ef95d48a665$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $1bac3ef95d48a665$exports[key];
        }
    });
});
var $15c57af73cf952db$exports = {};

$parcel$export($15c57af73cf952db$exports, "fromUnixTime", function () { return $15c57af73cf952db$export$3664df8597731ed4; }, function (v) { return $15c57af73cf952db$export$3664df8597731ed4 = v; });
var $15c57af73cf952db$export$3664df8597731ed4;
"use strict";
$15c57af73cf952db$export$3664df8597731ed4 = $15c57af73cf952db$var$fromUnixTime;

/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param unixTime - The given Unix timestamp (in seconds)
 *
 * @returns The date
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */ function $15c57af73cf952db$var$fromUnixTime(unixTime) {
    return (0, $838192f7942a2bce$export$e67a095c620b86fe)(unixTime * 1000);
}


Object.keys($15c57af73cf952db$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $15c57af73cf952db$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $15c57af73cf952db$exports[key];
        }
    });
});
var $797b76df5c23eee1$exports = {};

$parcel$export($797b76df5c23eee1$exports, "getDate", function () { return $797b76df5c23eee1$export$aa350b96d91cd94; }, function (v) { return $797b76df5c23eee1$export$aa350b96d91cd94 = v; });
var $797b76df5c23eee1$export$aa350b96d91cd94;
"use strict";
$797b76df5c23eee1$export$aa350b96d91cd94 = $797b76df5c23eee1$var$getDate;

/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */ function $797b76df5c23eee1$var$getDate(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const dayOfMonth = _date.getDate();
    return dayOfMonth;
}


Object.keys($797b76df5c23eee1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $797b76df5c23eee1$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $797b76df5c23eee1$exports[key];
        }
    });
});
var $34139301a572f1c6$exports = {};

$parcel$export($34139301a572f1c6$exports, "getDay", function () { return $34139301a572f1c6$export$1b64bc9c5306ed54; }, function (v) { return $34139301a572f1c6$export$1b64bc9c5306ed54 = v; });
var $34139301a572f1c6$export$1b64bc9c5306ed54;
"use strict";
$34139301a572f1c6$export$1b64bc9c5306ed54 = $34139301a572f1c6$var$getDay;

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of week, 0 represents Sunday
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */ function $34139301a572f1c6$var$getDay(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    return day;
}


Object.keys($34139301a572f1c6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $34139301a572f1c6$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $34139301a572f1c6$exports[key];
        }
    });
});

Object.keys($b74c283f23517f77$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $b74c283f23517f77$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $b74c283f23517f77$exports[key];
        }
    });
});
var $affa5299a1212e4c$exports = {};

$parcel$export($affa5299a1212e4c$exports, "getDaysInMonth", function () { return $affa5299a1212e4c$export$f645ddd439eb259d; }, function (v) { return $affa5299a1212e4c$export$f645ddd439eb259d = v; });
var $affa5299a1212e4c$export$f645ddd439eb259d;
"use strict";
$affa5299a1212e4c$export$f645ddd439eb259d = $affa5299a1212e4c$var$getDaysInMonth;


/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ function $affa5299a1212e4c$var$getDaysInMonth(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}


Object.keys($affa5299a1212e4c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $affa5299a1212e4c$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $affa5299a1212e4c$exports[key];
        }
    });
});
var $f4fd7742725d3edc$exports = {};

$parcel$export($f4fd7742725d3edc$exports, "getDaysInYear", function () { return $f4fd7742725d3edc$export$63a4a9fc49e3550e; }, function (v) { return $f4fd7742725d3edc$export$63a4a9fc49e3550e = v; });
var $f4fd7742725d3edc$export$63a4a9fc49e3550e;
"use strict";
$f4fd7742725d3edc$export$63a4a9fc49e3550e = $f4fd7742725d3edc$var$getDaysInYear;
var $af11322c722b306d$exports = {};

$parcel$export($af11322c722b306d$exports, "isLeapYear", function () { return $af11322c722b306d$export$553d7fa8e3805fc0; }, function (v) { return $af11322c722b306d$export$553d7fa8e3805fc0 = v; });
var $af11322c722b306d$export$553d7fa8e3805fc0;
"use strict";
$af11322c722b306d$export$553d7fa8e3805fc0 = $af11322c722b306d$var$isLeapYear;

/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * const result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */ function $af11322c722b306d$var$isLeapYear(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}



/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * const result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */ function $f4fd7742725d3edc$var$getDaysInYear(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    if (String(new Date(_date)) === "Invalid Date") return NaN;
    return (0, $af11322c722b306d$export$553d7fa8e3805fc0)(_date) ? 366 : 365;
}


Object.keys($f4fd7742725d3edc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $f4fd7742725d3edc$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $f4fd7742725d3edc$exports[key];
        }
    });
});
var $6c1d2707d93f8951$exports = {};

$parcel$export($6c1d2707d93f8951$exports, "getDecade", function () { return $6c1d2707d93f8951$export$5bc0f4decfc52b64; }, function (v) { return $6c1d2707d93f8951$export$5bc0f4decfc52b64 = v; });
var $6c1d2707d93f8951$export$5bc0f4decfc52b64;
"use strict";
$6c1d2707d93f8951$export$5bc0f4decfc52b64 = $6c1d2707d93f8951$var$getDecade;

/**
 * @name getDecade
 * @category Decade Helpers
 * @summary Get the decade of the given date.
 *
 * @description
 * Get the decade of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year of decade
 *
 * @example
 * // Which decade belongs 27 November 1942?
 * const result = getDecade(new Date(1942, 10, 27))
 * //=> 1940
 */ function $6c1d2707d93f8951$var$getDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    return decade;
}


Object.keys($6c1d2707d93f8951$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $6c1d2707d93f8951$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $6c1d2707d93f8951$exports[key];
        }
    });
});
var $9460588b5f8302f0$exports = {};

$parcel$export($9460588b5f8302f0$exports, "getDefaultOptions", function () { return $9460588b5f8302f0$export$430a3269e24b912e; }, function (v) { return $9460588b5f8302f0$export$430a3269e24b912e = v; });
var $9460588b5f8302f0$export$430a3269e24b912e;
"use strict";
$9460588b5f8302f0$export$430a3269e24b912e = $9460588b5f8302f0$var$getDefaultOptions;

/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */ function $9460588b5f8302f0$var$getDefaultOptions() {
    return Object.assign({}, (0, $0a8793ff6cad2441$export$430a3269e24b912e)());
}


Object.keys($9460588b5f8302f0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $9460588b5f8302f0$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $9460588b5f8302f0$exports[key];
        }
    });
});
var $69b4e3879a0ad768$exports = {};

$parcel$export($69b4e3879a0ad768$exports, "getHours", function () { return $69b4e3879a0ad768$export$257b40f71c07d58f; }, function (v) { return $69b4e3879a0ad768$export$257b40f71c07d58f = v; });
var $69b4e3879a0ad768$export$257b40f71c07d58f;
"use strict";
$69b4e3879a0ad768$export$257b40f71c07d58f = $69b4e3879a0ad768$var$getHours;

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */ function $69b4e3879a0ad768$var$getHours(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const hours = _date.getHours();
    return hours;
}


Object.keys($69b4e3879a0ad768$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $69b4e3879a0ad768$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $69b4e3879a0ad768$exports[key];
        }
    });
});
var $136624ded345602a$exports = {};

$parcel$export($136624ded345602a$exports, "getISODay", function () { return $136624ded345602a$export$c514f4c1a8ed5e9e; }, function (v) { return $136624ded345602a$export$c514f4c1a8ed5e9e = v; });
var $136624ded345602a$export$c514f4c1a8ed5e9e;
"use strict";
$136624ded345602a$export$c514f4c1a8ed5e9e = $136624ded345602a$var$getISODay;

/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */ function $136624ded345602a$var$getISODay(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    let day = _date.getDay();
    if (day === 0) day = 7;
    return day;
}


Object.keys($136624ded345602a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $136624ded345602a$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $136624ded345602a$exports[key];
        }
    });
});

Object.keys($012d4ce6324b9cab$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $012d4ce6324b9cab$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $012d4ce6324b9cab$exports[key];
        }
    });
});

Object.keys($f51448e7e5a1f4fe$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $f51448e7e5a1f4fe$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $f51448e7e5a1f4fe$exports[key];
        }
    });
});
var $39dad22dbbd9c517$exports = {};

$parcel$export($39dad22dbbd9c517$exports, "getISOWeeksInYear", function () { return $39dad22dbbd9c517$export$822983242a16750f; }, function (v) { return $39dad22dbbd9c517$export$822983242a16750f = v; });
var $39dad22dbbd9c517$export$822983242a16750f;
"use strict";
$39dad22dbbd9c517$export$822983242a16750f = $39dad22dbbd9c517$var$getISOWeeksInYear;



/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */ function $39dad22dbbd9c517$var$getISOWeeksInYear(date) {
    const thisYear = (0, $4ac098d276fcecdf$export$236bdfa374eb69a9)(date);
    const nextYear = (0, $4ac098d276fcecdf$export$236bdfa374eb69a9)((0, $fddea87cb66f8480$export$ef501a2bb4f3ee6b)(thisYear, 60));
    const diff = +nextYear - +thisYear;
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $9e66e67751f962b4$export$4fad13613e88edc8);
}


Object.keys($39dad22dbbd9c517$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $39dad22dbbd9c517$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $39dad22dbbd9c517$exports[key];
        }
    });
});
var $67ba15a7aefa26e3$exports = {};

$parcel$export($67ba15a7aefa26e3$exports, "getMilliseconds", function () { return $67ba15a7aefa26e3$export$b8e4380f312797af; }, function (v) { return $67ba15a7aefa26e3$export$b8e4380f312797af = v; });
var $67ba15a7aefa26e3$export$b8e4380f312797af;
"use strict";
$67ba15a7aefa26e3$export$b8e4380f312797af = $67ba15a7aefa26e3$var$getMilliseconds;

/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */ function $67ba15a7aefa26e3$var$getMilliseconds(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const milliseconds = _date.getMilliseconds();
    return milliseconds;
}


Object.keys($67ba15a7aefa26e3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $67ba15a7aefa26e3$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $67ba15a7aefa26e3$exports[key];
        }
    });
});
var $bc317b695ea38729$exports = {};

$parcel$export($bc317b695ea38729$exports, "getMinutes", function () { return $bc317b695ea38729$export$b7f1bc3ea3ac4145; }, function (v) { return $bc317b695ea38729$export$b7f1bc3ea3ac4145 = v; });
var $bc317b695ea38729$export$b7f1bc3ea3ac4145;
"use strict";
$bc317b695ea38729$export$b7f1bc3ea3ac4145 = $bc317b695ea38729$var$getMinutes;

/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */ function $bc317b695ea38729$var$getMinutes(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const minutes = _date.getMinutes();
    return minutes;
}


Object.keys($bc317b695ea38729$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $bc317b695ea38729$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $bc317b695ea38729$exports[key];
        }
    });
});
var $29d76448c430665b$exports = {};

$parcel$export($29d76448c430665b$exports, "getMonth", function () { return $29d76448c430665b$export$6ce1b5acc29cb53b; }, function (v) { return $29d76448c430665b$export$6ce1b5acc29cb53b = v; });
var $29d76448c430665b$export$6ce1b5acc29cb53b;
"use strict";
$29d76448c430665b$export$6ce1b5acc29cb53b = $29d76448c430665b$var$getMonth;

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */ function $29d76448c430665b$var$getMonth(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const month = _date.getMonth();
    return month;
}


Object.keys($29d76448c430665b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $29d76448c430665b$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $29d76448c430665b$exports[key];
        }
    });
});
var $4f6a60434b5375cf$exports = {};

$parcel$export($4f6a60434b5375cf$exports, "getOverlappingDaysInIntervals", function () { return $4f6a60434b5375cf$export$baae148532bd1d46; }, function (v) { return $4f6a60434b5375cf$export$baae148532bd1d46 = v; });
var $4f6a60434b5375cf$export$baae148532bd1d46;
"use strict";
$4f6a60434b5375cf$export$baae148532bd1d46 = $4f6a60434b5375cf$var$getOverlappingDaysInIntervals;



/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals. It uses the time
 * between dates to calculate the number of days, rounding it up to include
 * partial days.
 *
 * Two equal 0-length intervals will result in 0. Two equal 1ms intervals will
 * result in 1.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 *
 * @returns The number of days that overlap in two time intervals
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> 0
 */ function $4f6a60434b5375cf$var$getOverlappingDaysInIntervals(intervalLeft, intervalRight) {
    const [leftStart, leftEnd] = [
        +(0, $838192f7942a2bce$export$e67a095c620b86fe)(intervalLeft.start),
        +(0, $838192f7942a2bce$export$e67a095c620b86fe)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStart, rightEnd] = [
        +(0, $838192f7942a2bce$export$e67a095c620b86fe)(intervalRight.start),
        +(0, $838192f7942a2bce$export$e67a095c620b86fe)(intervalRight.end)
    ].sort((a, b)=>a - b);
    // Prevent NaN result if intervals don't overlap at all.
    const isOverlapping = leftStart < rightEnd && rightStart < leftEnd;
    if (!isOverlapping) return 0;
    // Remove the timezone offset to negate the DST effect on calculations.
    const overlapLeft = rightStart < leftStart ? leftStart : rightStart;
    const left = overlapLeft - (0, $f4008ef8d68e7133$export$113002b5eff6e430)(overlapLeft);
    const overlapRight = rightEnd > leftEnd ? leftEnd : rightEnd;
    const right = overlapRight - (0, $f4008ef8d68e7133$export$113002b5eff6e430)(overlapRight);
    // Ceil the number to include partial days too.
    return Math.ceil((right - left) / $9e66e67751f962b4$export$b76b1809a2898f9a);
}


Object.keys($4f6a60434b5375cf$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $4f6a60434b5375cf$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $4f6a60434b5375cf$exports[key];
        }
    });
});

Object.keys($65978eee93cacb6d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $65978eee93cacb6d$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $65978eee93cacb6d$exports[key];
        }
    });
});
var $7e54f1586d903eb8$exports = {};

$parcel$export($7e54f1586d903eb8$exports, "getSeconds", function () { return $7e54f1586d903eb8$export$5e9417507ff28427; }, function (v) { return $7e54f1586d903eb8$export$5e9417507ff28427 = v; });
var $7e54f1586d903eb8$export$5e9417507ff28427;
"use strict";
$7e54f1586d903eb8$export$5e9417507ff28427 = $7e54f1586d903eb8$var$getSeconds;

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */ function $7e54f1586d903eb8$var$getSeconds(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const seconds = _date.getSeconds();
    return seconds;
}


Object.keys($7e54f1586d903eb8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $7e54f1586d903eb8$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $7e54f1586d903eb8$exports[key];
        }
    });
});
var $bb5883b2f958b8ca$exports = {};

$parcel$export($bb5883b2f958b8ca$exports, "getTime", function () { return $bb5883b2f958b8ca$export$1428f42a7de81803; }, function (v) { return $bb5883b2f958b8ca$export$1428f42a7de81803 = v; });
var $bb5883b2f958b8ca$export$1428f42a7de81803;
"use strict";
$bb5883b2f958b8ca$export$1428f42a7de81803 = $bb5883b2f958b8ca$var$getTime;

/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */ function $bb5883b2f958b8ca$var$getTime(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const timestamp = _date.getTime();
    return timestamp;
}


Object.keys($bb5883b2f958b8ca$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $bb5883b2f958b8ca$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $bb5883b2f958b8ca$exports[key];
        }
    });
});
var $749c68a77251018e$exports = {};

$parcel$export($749c68a77251018e$exports, "getUnixTime", function () { return $749c68a77251018e$export$1f77c0008d16313; }, function (v) { return $749c68a77251018e$export$1f77c0008d16313 = v; });
var $749c68a77251018e$export$1f77c0008d16313;
"use strict";
$749c68a77251018e$export$1f77c0008d16313 = $749c68a77251018e$var$getUnixTime;

/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */ function $749c68a77251018e$var$getUnixTime(date) {
    return Math.trunc(+(0, $838192f7942a2bce$export$e67a095c620b86fe)(date) / 1000);
}


Object.keys($749c68a77251018e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $749c68a77251018e$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $749c68a77251018e$exports[key];
        }
    });
});

Object.keys($dc1515b472a87eee$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $dc1515b472a87eee$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $dc1515b472a87eee$exports[key];
        }
    });
});
var $04a368d4ed4a5d32$exports = {};

$parcel$export($04a368d4ed4a5d32$exports, "getWeekOfMonth", function () { return $04a368d4ed4a5d32$export$59fb9b85a4d8d027; }, function (v) { return $04a368d4ed4a5d32$export$59fb9b85a4d8d027 = v; });
var $04a368d4ed4a5d32$export$59fb9b85a4d8d027;
"use strict";
$04a368d4ed4a5d32$export$59fb9b85a4d8d027 = $04a368d4ed4a5d32$var$getWeekOfMonth;




/**
 * The {@link getWeekOfMonth} function options.
 */ /**
 * @name getWeekOfMonth
 * @category Week Helpers
 * @summary Get the week of the month of the given date.
 *
 * @description
 * Get the week of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The week of month
 *
 * @example
 * // Which week of the month is 9 November 2017?
 * const result = getWeekOfMonth(new Date(2017, 10, 9))
 * //=> 2
 */ function $04a368d4ed4a5d32$var$getWeekOfMonth(date, options) {
    const defaultOptions = (0, $0a8793ff6cad2441$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const currentDayOfMonth = (0, $797b76df5c23eee1$export$aa350b96d91cd94)(date);
    if (isNaN(currentDayOfMonth)) return NaN;
    const startWeekDay = (0, $34139301a572f1c6$export$1b64bc9c5306ed54)((0, $ef4241263f1a03f4$export$a5a3b454ada2268e)(date));
    let lastDayOfFirstWeek = weekStartsOn - startWeekDay;
    if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
    const remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
    return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}


Object.keys($04a368d4ed4a5d32$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $04a368d4ed4a5d32$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $04a368d4ed4a5d32$exports[key];
        }
    });
});

Object.keys($ff8b4ec1d3426046$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $ff8b4ec1d3426046$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $ff8b4ec1d3426046$exports[key];
        }
    });
});
var $6234d4ec50417437$exports = {};

$parcel$export($6234d4ec50417437$exports, "getWeeksInMonth", function () { return $6234d4ec50417437$export$ccc1b2479e7dd654; }, function (v) { return $6234d4ec50417437$export$ccc1b2479e7dd654 = v; });
var $6234d4ec50417437$export$ccc1b2479e7dd654;
"use strict";
$6234d4ec50417437$export$ccc1b2479e7dd654 = $6234d4ec50417437$var$getWeeksInMonth;

var $3726fd48ed228118$exports = {};

$parcel$export($3726fd48ed228118$exports, "lastDayOfMonth", function () { return $3726fd48ed228118$export$36818250d6c87922; }, function (v) { return $3726fd48ed228118$export$36818250d6c87922 = v; });
var $3726fd48ed228118$export$36818250d6c87922;
"use strict";
$3726fd48ed228118$export$36818250d6c87922 = $3726fd48ed228118$var$lastDayOfMonth;

/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $3726fd48ed228118$var$lastDayOfMonth(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}



/**
 * The {@link getWeeksInMonth} function options.
 */ /**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */ function $6234d4ec50417437$var$getWeeksInMonth(date, options) {
    return (0, $0a05c73da41121f4$export$6ed034ce62348e4)((0, $3726fd48ed228118$export$36818250d6c87922)(date), (0, $ef4241263f1a03f4$export$a5a3b454ada2268e)(date), options) + 1;
}


Object.keys($6234d4ec50417437$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $6234d4ec50417437$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $6234d4ec50417437$exports[key];
        }
    });
});
var $7cbedbee68421717$exports = {};

$parcel$export($7cbedbee68421717$exports, "getYear", function () { return $7cbedbee68421717$export$5846dc2d57a5c860; }, function (v) { return $7cbedbee68421717$export$5846dc2d57a5c860 = v; });
var $7cbedbee68421717$export$5846dc2d57a5c860;
"use strict";
$7cbedbee68421717$export$5846dc2d57a5c860 = $7cbedbee68421717$var$getYear;

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ function $7cbedbee68421717$var$getYear(date) {
    return (0, $838192f7942a2bce$export$e67a095c620b86fe)(date).getFullYear();
}


Object.keys($7cbedbee68421717$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $7cbedbee68421717$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $7cbedbee68421717$exports[key];
        }
    });
});
var $2cdbb57623ed950b$exports = {};

$parcel$export($2cdbb57623ed950b$exports, "hoursToMilliseconds", function () { return $2cdbb57623ed950b$export$5b42ab7a22898b69; }, function (v) { return $2cdbb57623ed950b$export$5b42ab7a22898b69 = v; });
var $2cdbb57623ed950b$export$5b42ab7a22898b69;
"use strict";
$2cdbb57623ed950b$export$5b42ab7a22898b69 = $2cdbb57623ed950b$var$hoursToMilliseconds;

/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted to milliseconds
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */ function $2cdbb57623ed950b$var$hoursToMilliseconds(hours) {
    return Math.trunc(hours * $9e66e67751f962b4$export$7f72910d6dfd237a);
}


Object.keys($2cdbb57623ed950b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $2cdbb57623ed950b$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $2cdbb57623ed950b$exports[key];
        }
    });
});
var $6d06eabbedd1526d$exports = {};

$parcel$export($6d06eabbedd1526d$exports, "hoursToMinutes", function () { return $6d06eabbedd1526d$export$83bfc73cdf89a4d8; }, function (v) { return $6d06eabbedd1526d$export$83bfc73cdf89a4d8 = v; });
var $6d06eabbedd1526d$export$83bfc73cdf89a4d8;
"use strict";
$6d06eabbedd1526d$export$83bfc73cdf89a4d8 = $6d06eabbedd1526d$var$hoursToMinutes;

/**
 * @name hoursToMinutes
 * @category Conversion Helpers
 * @summary Convert hours to minutes.
 *
 * @description
 * Convert a number of hours to a full number of minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted in minutes
 *
 * @example
 * // Convert 2 hours to minutes:
 * const result = hoursToMinutes(2)
 * //=> 120
 */ function $6d06eabbedd1526d$var$hoursToMinutes(hours) {
    return Math.trunc(hours * $9e66e67751f962b4$export$f2f5ae5a8e2d8f9f);
}


Object.keys($6d06eabbedd1526d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $6d06eabbedd1526d$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $6d06eabbedd1526d$exports[key];
        }
    });
});
var $58eda2357fe6a4b8$exports = {};

$parcel$export($58eda2357fe6a4b8$exports, "hoursToSeconds", function () { return $58eda2357fe6a4b8$export$59b1396ccbd5a4e1; }, function (v) { return $58eda2357fe6a4b8$export$59b1396ccbd5a4e1 = v; });
var $58eda2357fe6a4b8$export$59b1396ccbd5a4e1;
"use strict";
$58eda2357fe6a4b8$export$59b1396ccbd5a4e1 = $58eda2357fe6a4b8$var$hoursToSeconds;

/**
 * @name hoursToSeconds
 * @category Conversion Helpers
 * @summary Convert hours to seconds.
 *
 * @description
 * Convert a number of hours to a full number of seconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - The number of hours to be converted
 *
 * @returns The number of hours converted in seconds
 *
 * @example
 * // Convert 2 hours to seconds:
 * const result = hoursToSeconds(2)
 * //=> 7200
 */ function $58eda2357fe6a4b8$var$hoursToSeconds(hours) {
    return Math.trunc(hours * $9e66e67751f962b4$export$698aec755e92c695);
}


Object.keys($58eda2357fe6a4b8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $58eda2357fe6a4b8$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $58eda2357fe6a4b8$exports[key];
        }
    });
});
var $87c26ed0297e5277$exports = {};

$parcel$export($87c26ed0297e5277$exports, "interval", function () { return $87c26ed0297e5277$export$3174cdbf0a0cbc84; }, function (v) { return $87c26ed0297e5277$export$3174cdbf0a0cbc84 = v; });
var $87c26ed0297e5277$export$3174cdbf0a0cbc84;
"use strict";
$87c26ed0297e5277$export$3174cdbf0a0cbc84 = $87c26ed0297e5277$var$interval;

/**
 * The {@link interval} function options.
 */ /**
 * @name interval
 * @category Interval Helpers
 * @summary Creates an interval object and validates its values.
 *
 * @description
 * Creates a normalized interval object and validates its values. If the interval is invalid, an exception is thrown.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param start - The start of the interval.
 * @param end - The end of the interval.
 * @param options - The options object.
 *
 * @throws `Start date is invalid` when `start` is invalid.
 * @throws `End date is invalid` when `end` is invalid.
 * @throws `End date must be after start date` when end is before `start` and `options.assertPositive` is true.
 *
 * @returns The normalized and validated interval object.
 */ function $87c26ed0297e5277$var$interval(start, end, options) {
    const _start = (0, $838192f7942a2bce$export$e67a095c620b86fe)(start);
    if (isNaN(+_start)) throw new TypeError("Start date is invalid");
    const _end = (0, $838192f7942a2bce$export$e67a095c620b86fe)(end);
    if (isNaN(+_end)) throw new TypeError("End date is invalid");
    if (options?.assertPositive && +_start > +_end) throw new TypeError("End date must be after start date");
    return {
        start: _start,
        end: _end
    };
}


Object.keys($87c26ed0297e5277$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $87c26ed0297e5277$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $87c26ed0297e5277$exports[key];
        }
    });
});
var $b7e57ea7c57e8838$exports = {};

$parcel$export($b7e57ea7c57e8838$exports, "intervalToDuration", function () { return $b7e57ea7c57e8838$export$7b6c9a626316863; }, function (v) { return $b7e57ea7c57e8838$export$7b6c9a626316863 = v; });
var $b7e57ea7c57e8838$export$7b6c9a626316863;
"use strict";
$b7e57ea7c57e8838$export$7b6c9a626316863 = $b7e57ea7c57e8838$var$intervalToDuration;








/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval to convert to duration
 *
 * @returns The duration object
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */ function $b7e57ea7c57e8838$var$intervalToDuration(interval) {
    const start = (0, $838192f7942a2bce$export$e67a095c620b86fe)(interval.start);
    const end = (0, $838192f7942a2bce$export$e67a095c620b86fe)(interval.end);
    const duration = {};
    const years = (0, $9fd86db74e5eaff4$export$ed6bf486f68899ca)(end, start);
    if (years) duration.years = years;
    const remainingMonths = (0, $d237b6d82aac5787$export$e16d8520af44a096)(start, {
        years: duration.years
    });
    const months = (0, $119c3b8c8b0e62d4$export$fc1ed482c2861792)(end, remainingMonths);
    if (months) duration.months = months;
    const remainingDays = (0, $d237b6d82aac5787$export$e16d8520af44a096)(remainingMonths, {
        months: duration.months
    });
    const days = (0, $91b0bd8ffd6a15a9$export$86415ebf4eb36b8c)(end, remainingDays);
    if (days) duration.days = days;
    const remainingHours = (0, $d237b6d82aac5787$export$e16d8520af44a096)(remainingDays, {
        days: duration.days
    });
    const hours = (0, $8892b53d007561a7$export$5436ca250d4d6872)(end, remainingHours);
    if (hours) duration.hours = hours;
    const remainingMinutes = (0, $d237b6d82aac5787$export$e16d8520af44a096)(remainingHours, {
        hours: duration.hours
    });
    const minutes = (0, $8232f7fd99cf2340$export$d904251335be481a)(end, remainingMinutes);
    if (minutes) duration.minutes = minutes;
    const remainingSeconds = (0, $d237b6d82aac5787$export$e16d8520af44a096)(remainingMinutes, {
        minutes: duration.minutes
    });
    const seconds = (0, $e4c0e558314ffb9c$export$c1889aec51783710)(end, remainingSeconds);
    if (seconds) duration.seconds = seconds;
    return duration;
}


Object.keys($b7e57ea7c57e8838$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $b7e57ea7c57e8838$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $b7e57ea7c57e8838$exports[key];
        }
    });
});
var $6d2e350aefde09c7$exports = {};

$parcel$export($6d2e350aefde09c7$exports, "intlFormat", function () { return $6d2e350aefde09c7$export$f58f1234eed71f82; }, function (v) { return $6d2e350aefde09c7$export$f58f1234eed71f82 = v; });
var $6d2e350aefde09c7$export$f58f1234eed71f82;
"use strict";
$6d2e350aefde09c7$export$f58f1234eed71f82 = $6d2e350aefde09c7$var$intlFormat;

/**
 * The locale string (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).
 */ /**
 * The format options (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options)
 */ /**
 * The locale options.
 */ /**
 * @name intlFormat
 * @category Common Helpers
 * @summary Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   locale: 'ko-KR',
 * })
 * //=> 2019. 10. 4.
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   year: 'numeric',
 *   month: 'numeric',
 *   day: 'numeric',
 *   hour: 'numeric',
 * })
 * //=> 10/4/2019, 12 PM
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   weekday: 'long',
 *   year: 'numeric',
 *   month: 'long',
 *   day: 'numeric',
 * }, {
 *   locale: 'de-DE',
 * })
 * //=> Freitag, 4. Oktober 2019
 */ function $6d2e350aefde09c7$var$intlFormat(date, formatOrLocale, localeOptions) {
    let formatOptions;
    if ($6d2e350aefde09c7$var$isFormatOptions(formatOrLocale)) formatOptions = formatOrLocale;
    else localeOptions = formatOrLocale;
    return new Intl.DateTimeFormat(localeOptions?.locale, formatOptions).format((0, $838192f7942a2bce$export$e67a095c620b86fe)(date));
}
function $6d2e350aefde09c7$var$isFormatOptions(opts) {
    return opts !== undefined && !("locale" in opts);
}


Object.keys($6d2e350aefde09c7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $6d2e350aefde09c7$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $6d2e350aefde09c7$exports[key];
        }
    });
});
var $d11fe9ee3d124ba9$exports = {};

$parcel$export($d11fe9ee3d124ba9$exports, "intlFormatDistance", function () { return $d11fe9ee3d124ba9$export$a110a4020280fd5; }, function (v) { return $d11fe9ee3d124ba9$export$a110a4020280fd5 = v; });
var $d11fe9ee3d124ba9$export$a110a4020280fd5;
"use strict";
$d11fe9ee3d124ba9$export$a110a4020280fd5 = $d11fe9ee3d124ba9$var$intlFormatDistance;










/**
 * The {@link intlFormatDistance} function options.
 */ /**
 * The unit used to format the distance in {@link intlFormatDistance}.
 */ /**
 * @name intlFormatDistance
 * @category Common Helpers
 * @summary Formats distance between two dates in a human-readable format
 * @description
 * The function calculates the difference between two dates and formats it as a human-readable string.
 *
 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
 *
 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
 *
 * See the table below for the unit picking logic:
 *
 * | Distance between dates | Result (past)  | Result (future) |
 * | ---------------------- | -------------- | --------------- |
 * | 0 seconds              | now            | now             |
 * | 1-59 seconds           | X seconds ago  | in X seconds    |
 * | 1-59 minutes           | X minutes ago  | in X minutes    |
 * | 1-23 hours             | X hours ago    | in X hours      |
 * | 1 day                  | yesterday      | tomorrow        |
 * | 2-6 days               | X days ago     | in X days       |
 * | 7 days                 | last week      | next week       |
 * | 8 days-1 month         | X weeks ago    | in X weeks      |
 * | 1 month                | last month     | next month      |
 * | 2-3 months             | X months ago   | in X months     |
 * | 1 quarter              | last quarter   | next quarter    |
 * | 2-3 quarters           | X quarters ago | in X quarters   |
 * | 1 year                 | last year      | next year       |
 * | 2+ years               | X years ago    | in X years      |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with.
 * @param options - An object with options.
 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
 * The narrow one could be similar to the short one for some locales.
 *
 * @returns The distance in words according to language-sensitive relative time formatting.
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must not be invalid Unit
 * @throws `options.locale` must not be invalid locale
 * @throws `options.localeMatcher` must not be invalid localeMatcher
 * @throws `options.numeric` must not be invalid numeric
 * @throws `options.style` must not be invalid style
 *
 * @example
 * // What is the distance between the dates when the fist date is after the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0)
 * )
 * //=> 'in 1 hour'
 *
 * // What is the distance between the dates when the fist date is before the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0)
 * )
 * //=> '1 hour ago'
 *
 * @example
 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
 * intlFormatDistance(
 *   new Date(1987, 6, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { unit: 'quarter' }
 * )
 * //=> 'in 5 quarters'
 *
 * @example
 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { locale: 'es' }
 * )
 * //=> 'dentro de 1 hora'
 *
 * @example
 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
 * intlFormatDistance(
 *   new Date(1986, 3, 5, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { numeric: 'always' }
 * )
 * //=> 'in 1 day'
 *
 * @example
 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
 * intlFormatDistance(
 *   new Date(1988, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { style: 'short' }
 * )
 * //=> 'in 2 yr'
 */ function $d11fe9ee3d124ba9$var$intlFormatDistance(date, baseDate, options) {
    let value = 0;
    let unit;
    const dateLeft = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const dateRight = (0, $838192f7942a2bce$export$e67a095c620b86fe)(baseDate);
    if (!options?.unit) {
        // Get the unit based on diffInSeconds calculations if no unit is specified
        const diffInSeconds = (0, $e4c0e558314ffb9c$export$c1889aec51783710)(dateLeft, dateRight); // The smallest unit
        if (Math.abs(diffInSeconds) < $9e66e67751f962b4$export$a77c1a7ebebe2a5a) {
            value = (0, $e4c0e558314ffb9c$export$c1889aec51783710)(dateLeft, dateRight);
            unit = "second";
        } else if (Math.abs(diffInSeconds) < $9e66e67751f962b4$export$698aec755e92c695) {
            value = (0, $8232f7fd99cf2340$export$d904251335be481a)(dateLeft, dateRight);
            unit = "minute";
        } else if (Math.abs(diffInSeconds) < $9e66e67751f962b4$export$815a9362476d2fe3 && Math.abs((0, $bb6062a6bff69209$export$4a02e9c37dab4871)(dateLeft, dateRight)) < 1) {
            value = (0, $8892b53d007561a7$export$5436ca250d4d6872)(dateLeft, dateRight);
            unit = "hour";
        } else if (Math.abs(diffInSeconds) < $9e66e67751f962b4$export$34804a017b31e2fe && (value = (0, $bb6062a6bff69209$export$4a02e9c37dab4871)(dateLeft, dateRight)) && Math.abs(value) < 7) unit = "day";
        else if (Math.abs(diffInSeconds) < $9e66e67751f962b4$export$8e6600bbdee7dabb) {
            value = (0, $0a05c73da41121f4$export$6ed034ce62348e4)(dateLeft, dateRight);
            unit = "week";
        } else if (Math.abs(diffInSeconds) < $9e66e67751f962b4$export$be1dccf2de902d31) {
            value = (0, $733cedb93909e7ba$export$489984ac7c996389)(dateLeft, dateRight);
            unit = "month";
        } else if (Math.abs(diffInSeconds) < $9e66e67751f962b4$export$7271e9e3478110d1) {
            if ((0, $5dacfca8607e2090$export$f62ae9fb13958c7a)(dateLeft, dateRight) < 4) {
                // To filter out cases that are less than a year but match 4 quarters
                value = (0, $5dacfca8607e2090$export$f62ae9fb13958c7a)(dateLeft, dateRight);
                unit = "quarter";
            } else {
                value = (0, $19dc801ab0682ed9$export$c06dce8b38891685)(dateLeft, dateRight);
                unit = "year";
            }
        } else {
            value = (0, $19dc801ab0682ed9$export$c06dce8b38891685)(dateLeft, dateRight);
            unit = "year";
        }
    } else {
        // Get the value if unit is specified
        unit = options?.unit;
        if (unit === "second") value = (0, $e4c0e558314ffb9c$export$c1889aec51783710)(dateLeft, dateRight);
        else if (unit === "minute") value = (0, $8232f7fd99cf2340$export$d904251335be481a)(dateLeft, dateRight);
        else if (unit === "hour") value = (0, $8892b53d007561a7$export$5436ca250d4d6872)(dateLeft, dateRight);
        else if (unit === "day") value = (0, $bb6062a6bff69209$export$4a02e9c37dab4871)(dateLeft, dateRight);
        else if (unit === "week") value = (0, $0a05c73da41121f4$export$6ed034ce62348e4)(dateLeft, dateRight);
        else if (unit === "month") value = (0, $733cedb93909e7ba$export$489984ac7c996389)(dateLeft, dateRight);
        else if (unit === "quarter") value = (0, $5dacfca8607e2090$export$f62ae9fb13958c7a)(dateLeft, dateRight);
        else if (unit === "year") value = (0, $19dc801ab0682ed9$export$c06dce8b38891685)(dateLeft, dateRight);
    }
    const rtf = new Intl.RelativeTimeFormat(options?.locale, {
        localeMatcher: options?.localeMatcher,
        numeric: options?.numeric || "auto",
        style: options?.style
    });
    return rtf.format(value, unit);
}


Object.keys($d11fe9ee3d124ba9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $d11fe9ee3d124ba9$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $d11fe9ee3d124ba9$exports[key];
        }
    });
});
var $fd8a0e05943d02e8$exports = {};

$parcel$export($fd8a0e05943d02e8$exports, "isAfter", function () { return $fd8a0e05943d02e8$export$e4de839670987035; }, function (v) { return $fd8a0e05943d02e8$export$e4de839670987035 = v; });
var $fd8a0e05943d02e8$export$e4de839670987035;
"use strict";
$fd8a0e05943d02e8$export$e4de839670987035 = $fd8a0e05943d02e8$var$isAfter;

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ function $fd8a0e05943d02e8$var$isAfter(date, dateToCompare) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const _dateToCompare = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateToCompare);
    return _date.getTime() > _dateToCompare.getTime();
}


Object.keys($fd8a0e05943d02e8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $fd8a0e05943d02e8$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $fd8a0e05943d02e8$exports[key];
        }
    });
});
var $d0b5ff47967a5f18$exports = {};

$parcel$export($d0b5ff47967a5f18$exports, "isBefore", function () { return $d0b5ff47967a5f18$export$5c007e10c6929c95; }, function (v) { return $d0b5ff47967a5f18$export$5c007e10c6929c95 = v; });
var $d0b5ff47967a5f18$export$5c007e10c6929c95;
"use strict";
$d0b5ff47967a5f18$export$5c007e10c6929c95 = $d0b5ff47967a5f18$var$isBefore;

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function $d0b5ff47967a5f18$var$isBefore(date, dateToCompare) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const _dateToCompare = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateToCompare);
    return +_date < +_dateToCompare;
}


Object.keys($d0b5ff47967a5f18$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $d0b5ff47967a5f18$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $d0b5ff47967a5f18$exports[key];
        }
    });
});

Object.keys($d788e870388b4443$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $d788e870388b4443$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $d788e870388b4443$exports[key];
        }
    });
});
var $ea905e08e34b977f$exports = {};

$parcel$export($ea905e08e34b977f$exports, "isEqual", function () { return $ea905e08e34b977f$export$248d38f6296296c5; }, function (v) { return $ea905e08e34b977f$export$248d38f6296296c5 = v; });
var $ea905e08e34b977f$export$248d38f6296296c5;
"use strict";
$ea905e08e34b977f$export$248d38f6296296c5 = $ea905e08e34b977f$var$isEqual;

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */ function $ea905e08e34b977f$var$isEqual(leftDate, rightDate) {
    const _dateLeft = (0, $838192f7942a2bce$export$e67a095c620b86fe)(leftDate);
    const _dateRight = (0, $838192f7942a2bce$export$e67a095c620b86fe)(rightDate);
    return +_dateLeft === +_dateRight;
}


Object.keys($ea905e08e34b977f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $ea905e08e34b977f$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $ea905e08e34b977f$exports[key];
        }
    });
});
var $f769db0a1763d326$exports = {};

$parcel$export($f769db0a1763d326$exports, "isExists", function () { return $f769db0a1763d326$export$127519e0edcdc58b; }, function (v) { return $f769db0a1763d326$export$127519e0edcdc58b = v; });
var $f769db0a1763d326$export$127519e0edcdc58b;
"use strict";
$f769db0a1763d326$export$127519e0edcdc58b = $f769db0a1763d326$var$isExists; /**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param year - The year of the date to check
 * @param month - The month of the date to check
 * @param day - The day of the date to check
 *
 * @returns `true` if the date exists
 *
 * @example
 * // For the valid date:
 * const result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isExists(2018, 1, 31)
 * //=> false
 */ 
function $f769db0a1763d326$var$isExists(year, month, day) {
    const date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}


Object.keys($f769db0a1763d326$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $f769db0a1763d326$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $f769db0a1763d326$exports[key];
        }
    });
});
var $500842554b025439$exports = {};

$parcel$export($500842554b025439$exports, "isFirstDayOfMonth", function () { return $500842554b025439$export$2716a425049f51dd; }, function (v) { return $500842554b025439$export$2716a425049f51dd = v; });
var $500842554b025439$export$2716a425049f51dd;
"use strict";
$500842554b025439$export$2716a425049f51dd = $500842554b025439$var$isFirstDayOfMonth;

/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */ function $500842554b025439$var$isFirstDayOfMonth(date) {
    return (0, $838192f7942a2bce$export$e67a095c620b86fe)(date).getDate() === 1;
}


Object.keys($500842554b025439$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $500842554b025439$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $500842554b025439$exports[key];
        }
    });
});
var $35e6874551190f64$exports = {};

$parcel$export($35e6874551190f64$exports, "isFriday", function () { return $35e6874551190f64$export$3b7d89f127884993; }, function (v) { return $35e6874551190f64$export$3b7d89f127884993 = v; });
var $35e6874551190f64$export$3b7d89f127884993;
"use strict";
$35e6874551190f64$export$3b7d89f127884993 = $35e6874551190f64$var$isFriday;

/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * const result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */ function $35e6874551190f64$var$isFriday(date) {
    return (0, $838192f7942a2bce$export$e67a095c620b86fe)(date).getDay() === 5;
}


Object.keys($35e6874551190f64$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $35e6874551190f64$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $35e6874551190f64$exports[key];
        }
    });
});
var $b256e1612a932324$exports = {};

$parcel$export($b256e1612a932324$exports, "isFuture", function () { return $b256e1612a932324$export$2baac2df6018cd7; }, function (v) { return $b256e1612a932324$export$2baac2df6018cd7 = v; });
var $b256e1612a932324$export$2baac2df6018cd7;
"use strict";
$b256e1612a932324$export$2baac2df6018cd7 = $b256e1612a932324$var$isFuture;

/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */ function $b256e1612a932324$var$isFuture(date) {
    return +(0, $838192f7942a2bce$export$e67a095c620b86fe)(date) > Date.now();
}


Object.keys($b256e1612a932324$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $b256e1612a932324$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $b256e1612a932324$exports[key];
        }
    });
});

Object.keys($588af2fc0365661e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $588af2fc0365661e$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $588af2fc0365661e$exports[key];
        }
    });
});

Object.keys($af11322c722b306d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $af11322c722b306d$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $af11322c722b306d$exports[key];
        }
    });
});
var $db4e8a0a9c504d02$exports = {};

$parcel$export($db4e8a0a9c504d02$exports, "isMatch", function () { return $db4e8a0a9c504d02$export$b74c33566721f70f; }, function (v) { return $db4e8a0a9c504d02$export$b74c33566721f70f = v; });
var $db4e8a0a9c504d02$export$b74c33566721f70f;
"use strict";
$db4e8a0a9c504d02$export$b74c33566721f70f = $db4e8a0a9c504d02$var$isMatch;

var $36c711f59b2e134f$exports = {};
"use strict";
Object.defineProperty($36c711f59b2e134f$exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $4d8da8b2c802488a$export$70cc8fd02856fd58;
    }
});
$36c711f59b2e134f$exports.parse = $36c711f59b2e134f$var$parse;
Object.defineProperty($36c711f59b2e134f$exports, "parsers", {
    enumerable: true,
    get: function() {
        return $458b798ef3d66812$export$19131010e7fd8373;
    }
});






var $458b798ef3d66812$export$19131010e7fd8373;
"use strict";
$458b798ef3d66812$export$19131010e7fd8373 = void 0;
var $577a5802b6538ab2$export$8e5a1d3f85a9688;
"use strict";
$577a5802b6538ab2$export$8e5a1d3f85a9688 = void 0;
var $28b5937cd53b0a6d$export$7acfa6ed01010e37;
"use strict";
$28b5937cd53b0a6d$export$7acfa6ed01010e37 = void 0;
var $8b8513ac03f0d989$export$9a09e32dd4990fd5;
var $8b8513ac03f0d989$export$81d53e3678089a6;
var $8b8513ac03f0d989$export$5aaf7ff7f09ea4ee;
"use strict";
$8b8513ac03f0d989$export$9a09e32dd4990fd5 = $8b8513ac03f0d989$export$81d53e3678089a6 = $8b8513ac03f0d989$export$5aaf7ff7f09ea4ee = void 0;
var $8229f62301d5098e$exports = {};

$parcel$export($8229f62301d5098e$exports, "transpose", function () { return $8229f62301d5098e$export$9cb09a71b7d66923; }, function (v) { return $8229f62301d5098e$export$9cb09a71b7d66923 = v; });
var $8229f62301d5098e$export$9cb09a71b7d66923;
"use strict";
$8229f62301d5098e$export$9cb09a71b7d66923 = $8229f62301d5098e$var$transpose;

/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */ function $8229f62301d5098e$var$transpose(fromDate, constructor) {
    const date = constructor instanceof Date ? (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(constructor, 0) : new constructor(0);
    date.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
    return date;
}



const $8b8513ac03f0d989$var$TIMEZONE_UNIT_PRIORITY = 10;
class $8b8513ac03f0d989$var$Setter {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
$8b8513ac03f0d989$export$81d53e3678089a6 = $8b8513ac03f0d989$var$Setter;
class $8b8513ac03f0d989$var$ValueSetter extends $8b8513ac03f0d989$var$Setter {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
$8b8513ac03f0d989$export$9a09e32dd4990fd5 = $8b8513ac03f0d989$var$ValueSetter;
class $8b8513ac03f0d989$var$DateToSystemTimezoneSetter extends $8b8513ac03f0d989$var$Setter {
    priority = $8b8513ac03f0d989$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, (0, $8229f62301d5098e$export$9cb09a71b7d66923)(date, Date));
    }
}
$8b8513ac03f0d989$export$5aaf7ff7f09ea4ee = $8b8513ac03f0d989$var$DateToSystemTimezoneSetter;


class $28b5937cd53b0a6d$var$Parser {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new $8b8513ac03f0d989$export$9a09e32dd4990fd5(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}
$28b5937cd53b0a6d$export$7acfa6ed01010e37 = $28b5937cd53b0a6d$var$Parser;


class $577a5802b6538ab2$var$EraParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}
$577a5802b6538ab2$export$8e5a1d3f85a9688 = $577a5802b6538ab2$var$EraParser;


var $7122b5d4b709ee02$export$48d352de7cd4a988;
"use strict";
$7122b5d4b709ee02$export$48d352de7cd4a988 = void 0;

var $7d89a901ddced10d$export$fb506d2676e7f207;
var $7d89a901ddced10d$export$3d50627710b84d75;
var $7d89a901ddced10d$export$4f84e3a82c7b538;
var $7d89a901ddced10d$export$29126f735cbf69f7;
var $7d89a901ddced10d$export$d931c43c4608a164;
var $7d89a901ddced10d$export$513bb01536146ab6;
var $7d89a901ddced10d$export$2c9307b2e29c533c;
var $7d89a901ddced10d$export$cc7cc9e2a3ff9388;
var $7d89a901ddced10d$export$6497f4c0ecdfba8e;
"use strict";
$7d89a901ddced10d$export$fb506d2676e7f207 = $7d89a901ddced10d$var$dayPeriodEnumToHours;
$7d89a901ddced10d$export$3d50627710b84d75 = $7d89a901ddced10d$var$isLeapYearIndex;
$7d89a901ddced10d$export$4f84e3a82c7b538 = $7d89a901ddced10d$var$mapValue;
$7d89a901ddced10d$export$29126f735cbf69f7 = $7d89a901ddced10d$var$normalizeTwoDigitYear;
$7d89a901ddced10d$export$d931c43c4608a164 = $7d89a901ddced10d$var$parseAnyDigitsSigned;
$7d89a901ddced10d$export$513bb01536146ab6 = $7d89a901ddced10d$var$parseNDigits;
$7d89a901ddced10d$export$2c9307b2e29c533c = $7d89a901ddced10d$var$parseNDigitsSigned;
$7d89a901ddced10d$export$cc7cc9e2a3ff9388 = $7d89a901ddced10d$var$parseNumericPattern;
$7d89a901ddced10d$export$6497f4c0ecdfba8e = $7d89a901ddced10d$var$parseTimezonePattern;

var $a7b185e910828b49$export$a7ee192b982af9c1;
var $a7b185e910828b49$export$c123ee06d9da8480;
"use strict";
$a7b185e910828b49$export$a7ee192b982af9c1 = $a7b185e910828b49$export$c123ee06d9da8480 = void 0;
const $a7b185e910828b49$var$numericPatterns = $a7b185e910828b49$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $a7b185e910828b49$var$timezonePatterns = $a7b185e910828b49$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $7d89a901ddced10d$var$mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $7d89a901ddced10d$var$parseNumericPattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7d89a901ddced10d$var$parseTimezonePattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $9e66e67751f962b4$export$7f72910d6dfd237a + minutes * $9e66e67751f962b4$export$91246f0b9bd9beff + seconds * $9e66e67751f962b4$export$397c2d5776aa9055),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7d89a901ddced10d$var$parseAnyDigitsSigned(dateString) {
    return $7d89a901ddced10d$var$parseNumericPattern($a7b185e910828b49$export$c123ee06d9da8480.anyDigitsSigned, dateString);
}
function $7d89a901ddced10d$var$parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return $7d89a901ddced10d$var$parseNumericPattern($a7b185e910828b49$export$c123ee06d9da8480.singleDigit, dateString);
        case 2:
            return $7d89a901ddced10d$var$parseNumericPattern($a7b185e910828b49$export$c123ee06d9da8480.twoDigits, dateString);
        case 3:
            return $7d89a901ddced10d$var$parseNumericPattern($a7b185e910828b49$export$c123ee06d9da8480.threeDigits, dateString);
        case 4:
            return $7d89a901ddced10d$var$parseNumericPattern($a7b185e910828b49$export$c123ee06d9da8480.fourDigits, dateString);
        default:
            return $7d89a901ddced10d$var$parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $7d89a901ddced10d$var$parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return $7d89a901ddced10d$var$parseNumericPattern($a7b185e910828b49$export$c123ee06d9da8480.singleDigitSigned, dateString);
        case 2:
            return $7d89a901ddced10d$var$parseNumericPattern($a7b185e910828b49$export$c123ee06d9da8480.twoDigitsSigned, dateString);
        case 3:
            return $7d89a901ddced10d$var$parseNumericPattern($a7b185e910828b49$export$c123ee06d9da8480.threeDigitsSigned, dateString);
        case 4:
            return $7d89a901ddced10d$var$parseNumericPattern($a7b185e910828b49$export$c123ee06d9da8480.fourDigitsSigned, dateString);
        default:
            return $7d89a901ddced10d$var$parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $7d89a901ddced10d$var$dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $7d89a901ddced10d$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $7d89a901ddced10d$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class $7122b5d4b709ee02$var$YearParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)((0, $7d89a901ddced10d$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "yo":
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)((0, $7d89a901ddced10d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $7d89a901ddced10d$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$7122b5d4b709ee02$export$48d352de7cd4a988 = $7122b5d4b709ee02$var$YearParser;


var $1fc4ff14dcd2d7b1$export$b8ef38dfcf05d5db;
"use strict";
$1fc4ff14dcd2d7b1$export$b8ef38dfcf05d5db = void 0;




// Local week-numbering year
class $1fc4ff14dcd2d7b1$var$LocalWeekYearParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)((0, $7d89a901ddced10d$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "Yo":
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)((0, $7d89a901ddced10d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $ff8b4ec1d3426046$export$12d572480ceb6e58)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $7d89a901ddced10d$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $cb6997e20defc27a$export$42c81a444fbfb5d4)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $cb6997e20defc27a$export$42c81a444fbfb5d4)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$1fc4ff14dcd2d7b1$export$b8ef38dfcf05d5db = $1fc4ff14dcd2d7b1$var$LocalWeekYearParser;


var $c922e8657f75d671$export$951d1df011fde06f;
"use strict";
$c922e8657f75d671$export$951d1df011fde06f = void 0;




// ISO week-numbering year
class $c922e8657f75d671$var$ISOWeekYearParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $7d89a901ddced10d$export$2c9307b2e29c533c)(4, dateString);
        return (0, $7d89a901ddced10d$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $0ce4d92e449d76da$export$6173213f95a4431e)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$c922e8657f75d671$export$951d1df011fde06f = $c922e8657f75d671$var$ISOWeekYearParser;


var $c83dc0c31d81aa6c$export$bad9d2ea38e8f1a;
"use strict";
$c83dc0c31d81aa6c$export$bad9d2ea38e8f1a = void 0;


class $c83dc0c31d81aa6c$var$ExtendedYearParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $7d89a901ddced10d$export$2c9307b2e29c533c)(4, dateString);
        return (0, $7d89a901ddced10d$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$c83dc0c31d81aa6c$export$bad9d2ea38e8f1a = $c83dc0c31d81aa6c$var$ExtendedYearParser;


var $4c36f78989125f4c$export$5cb0f701186dde1d;
"use strict";
$4c36f78989125f4c$export$5cb0f701186dde1d = void 0;


class $4c36f78989125f4c$var$QuarterParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $7d89a901ddced10d$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$4c36f78989125f4c$export$5cb0f701186dde1d = $4c36f78989125f4c$var$QuarterParser;


var $1fb4d9d3a719c483$export$300c0c2990e20e6d;
"use strict";
$1fb4d9d3a719c483$export$300c0c2990e20e6d = void 0;


class $1fb4d9d3a719c483$var$StandAloneQuarterParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $7d89a901ddced10d$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$1fb4d9d3a719c483$export$300c0c2990e20e6d = $1fb4d9d3a719c483$var$StandAloneQuarterParser;


var $10fd1391eb389e3a$export$400dd8b40ef138a3;
"use strict";
$10fd1391eb389e3a$export$400dd8b40ef138a3 = void 0;



class $10fd1391eb389e3a$var$MonthParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)((0, $7d89a901ddced10d$export$cc7cc9e2a3ff9388)($a7b185e910828b49$export$c123ee06d9da8480.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)((0, $7d89a901ddced10d$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$10fd1391eb389e3a$export$400dd8b40ef138a3 = $10fd1391eb389e3a$var$MonthParser;


var $8f6bacbb83bd5d41$export$1d7eaa53eaa5deba;
"use strict";
$8f6bacbb83bd5d41$export$1d7eaa53eaa5deba = void 0;



class $8f6bacbb83bd5d41$var$StandAloneMonthParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)((0, $7d89a901ddced10d$export$cc7cc9e2a3ff9388)($a7b185e910828b49$export$c123ee06d9da8480.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)((0, $7d89a901ddced10d$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$8f6bacbb83bd5d41$export$1d7eaa53eaa5deba = $8f6bacbb83bd5d41$var$StandAloneMonthParser;


var $e26629c37f4332a6$export$c4005ffc174e07c0;
"use strict";
$e26629c37f4332a6$export$c4005ffc174e07c0 = void 0;
var $cb243320054464f8$exports = {};

$parcel$export($cb243320054464f8$exports, "setWeek", function () { return $cb243320054464f8$export$4b3066ce4afafd88; }, function (v) { return $cb243320054464f8$export$4b3066ce4afafd88 = v; });
var $cb243320054464f8$export$4b3066ce4afafd88;
"use strict";
$cb243320054464f8$export$4b3066ce4afafd88 = $cb243320054464f8$var$setWeek;


/**
 * The {@link setWeek} function options.
 */ /**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */ function $cb243320054464f8$var$setWeek(date, week, options) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const diff = (0, $dc1515b472a87eee$export$efe19b760242b2fc)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}






// Local week of year
class $e26629c37f4332a6$var$LocalWeekParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $7d89a901ddced10d$export$cc7cc9e2a3ff9388)($a7b185e910828b49$export$c123ee06d9da8480.week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $7d89a901ddced10d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $cb6997e20defc27a$export$42c81a444fbfb5d4)((0, $cb243320054464f8$export$4b3066ce4afafd88)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$e26629c37f4332a6$export$c4005ffc174e07c0 = $e26629c37f4332a6$var$LocalWeekParser;


var $e38c364871594a3c$export$6fc8dbedd560a6af;
"use strict";
$e38c364871594a3c$export$6fc8dbedd560a6af = void 0;
var $01a3f91aa5f24276$exports = {};

$parcel$export($01a3f91aa5f24276$exports, "setISOWeek", function () { return $01a3f91aa5f24276$export$6542bebf6be94082; }, function (v) { return $01a3f91aa5f24276$export$6542bebf6be94082 = v; });
var $01a3f91aa5f24276$export$6542bebf6be94082;
"use strict";
$01a3f91aa5f24276$export$6542bebf6be94082 = $01a3f91aa5f24276$var$setISOWeek;


/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */ function $01a3f91aa5f24276$var$setISOWeek(date, week) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const diff = (0, $012d4ce6324b9cab$export$7cabdc5698b63e2f)(_date) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}






// ISO week of year
class $e38c364871594a3c$var$ISOWeekParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $7d89a901ddced10d$export$cc7cc9e2a3ff9388)($a7b185e910828b49$export$c123ee06d9da8480.week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $7d89a901ddced10d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $0ce4d92e449d76da$export$6173213f95a4431e)((0, $01a3f91aa5f24276$export$6542bebf6be94082)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$e38c364871594a3c$export$6fc8dbedd560a6af = $e38c364871594a3c$var$ISOWeekParser;


var $a14684a819c0c03f$export$e8d4b28a20981dd2;
"use strict";
$a14684a819c0c03f$export$e8d4b28a20981dd2 = void 0;



const $a14684a819c0c03f$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $a14684a819c0c03f$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
// Day of the month
class $a14684a819c0c03f$var$DateParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $7d89a901ddced10d$export$cc7cc9e2a3ff9388)($a7b185e910828b49$export$c123ee06d9da8480.date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $7d89a901ddced10d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $7d89a901ddced10d$export$3d50627710b84d75)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $a14684a819c0c03f$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $a14684a819c0c03f$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$a14684a819c0c03f$export$e8d4b28a20981dd2 = $a14684a819c0c03f$var$DateParser;


var $40046e6faa68080d$export$6cfe0d613455f615;
"use strict";
$40046e6faa68080d$export$6cfe0d613455f615 = void 0;



class $40046e6faa68080d$var$DayOfYearParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $7d89a901ddced10d$export$cc7cc9e2a3ff9388)($a7b185e910828b49$export$c123ee06d9da8480.dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $7d89a901ddced10d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $7d89a901ddced10d$export$3d50627710b84d75)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$40046e6faa68080d$export$6cfe0d613455f615 = $40046e6faa68080d$var$DayOfYearParser;


var $e2d51d288c00d0d4$export$1b03c8b76262f7bd;
"use strict";
$e2d51d288c00d0d4$export$1b03c8b76262f7bd = void 0;
var $c5ed626fa0e5b3e7$exports = {};

$parcel$export($c5ed626fa0e5b3e7$exports, "setDay", function () { return $c5ed626fa0e5b3e7$export$b04fdcda82decc6c; }, function (v) { return $c5ed626fa0e5b3e7$export$b04fdcda82decc6c = v; });
var $c5ed626fa0e5b3e7$export$b04fdcda82decc6c;
"use strict";
$c5ed626fa0e5b3e7$export$b04fdcda82decc6c = $c5ed626fa0e5b3e7$var$setDay;



/**
 * The {@link setDay} function options.
 */ /**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $c5ed626fa0e5b3e7$var$setDay(date, day, options) {
    const defaultOptions = (0, $0a8793ff6cad2441$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const currentDay = _date.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $b7f6bbd55167ab46$export$dd412b56f1e4d8aa)(_date, diff);
}



// Day of week
class $e2d51d288c00d0d4$var$DayParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $c5ed626fa0e5b3e7$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$e2d51d288c00d0d4$export$1b03c8b76262f7bd = $e2d51d288c00d0d4$var$DayParser;


var $82669a4bfccaf1e9$export$44d1c127ab42c480;
"use strict";
$82669a4bfccaf1e9$export$44d1c127ab42c480 = void 0;



// Local day of week
class $82669a4bfccaf1e9$var$LocalDayParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)((0, $7d89a901ddced10d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $c5ed626fa0e5b3e7$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}
$82669a4bfccaf1e9$export$44d1c127ab42c480 = $82669a4bfccaf1e9$var$LocalDayParser;


var $8be9747b4abbae5b$export$e447a647caaaec1d;
"use strict";
$8be9747b4abbae5b$export$e447a647caaaec1d = void 0;



// Stand-alone local day of week
class $8be9747b4abbae5b$var$StandAloneLocalDayParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)((0, $7d89a901ddced10d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $c5ed626fa0e5b3e7$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}
$8be9747b4abbae5b$export$e447a647caaaec1d = $8be9747b4abbae5b$var$StandAloneLocalDayParser;


var $096693cb20dd33b6$export$693fb1e525095b2a;
"use strict";
$096693cb20dd33b6$export$693fb1e525095b2a = void 0;
var $2ab80c521057ca48$exports = {};

$parcel$export($2ab80c521057ca48$exports, "setISODay", function () { return $2ab80c521057ca48$export$1fd9df65adb0d1aa; }, function (v) { return $2ab80c521057ca48$export$1fd9df65adb0d1aa = v; });
var $2ab80c521057ca48$export$1fd9df65adb0d1aa;
"use strict";
$2ab80c521057ca48$export$1fd9df65adb0d1aa = $2ab80c521057ca48$var$setISODay;



/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */ function $2ab80c521057ca48$var$setISODay(date, day) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const currentDay = (0, $136624ded345602a$export$c514f4c1a8ed5e9e)(_date);
    const diff = day - currentDay;
    return (0, $b7f6bbd55167ab46$export$dd412b56f1e4d8aa)(_date, diff);
}




// ISO day of week
class $096693cb20dd33b6$var$ISODayParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $7d89a901ddced10d$export$513bb01536146ab6)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $2ab80c521057ca48$export$1fd9df65adb0d1aa)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}
$096693cb20dd33b6$export$693fb1e525095b2a = $096693cb20dd33b6$var$ISODayParser;


var $1777fafb9e68c81d$export$8d1e08492351df91;
"use strict";
$1777fafb9e68c81d$export$8d1e08492351df91 = void 0;


class $1777fafb9e68c81d$var$AMPMParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7d89a901ddced10d$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$1777fafb9e68c81d$export$8d1e08492351df91 = $1777fafb9e68c81d$var$AMPMParser;


var $5f8802bf27761520$export$73ca2bd0a17d273;
"use strict";
$5f8802bf27761520$export$73ca2bd0a17d273 = void 0;


class $5f8802bf27761520$var$AMPMMidnightParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7d89a901ddced10d$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$5f8802bf27761520$export$73ca2bd0a17d273 = $5f8802bf27761520$var$AMPMMidnightParser;


var $b4a8d255a789b3ef$export$bb9212adf05373db;
"use strict";
$b4a8d255a789b3ef$export$bb9212adf05373db = void 0;


// in the morning, in the afternoon, in the evening, at night
class $b4a8d255a789b3ef$var$DayPeriodParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7d89a901ddced10d$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}
$b4a8d255a789b3ef$export$bb9212adf05373db = $b4a8d255a789b3ef$var$DayPeriodParser;


var $c13dc8efb7543616$export$8a04050a727a1756;
"use strict";
$c13dc8efb7543616$export$8a04050a727a1756 = void 0;



class $c13dc8efb7543616$var$Hour1to12Parser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $7d89a901ddced10d$export$cc7cc9e2a3ff9388)($a7b185e910828b49$export$c123ee06d9da8480.hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7d89a901ddced10d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}
$c13dc8efb7543616$export$8a04050a727a1756 = $c13dc8efb7543616$var$Hour1to12Parser;


var $d3a60a591e4745a5$export$e56f4dea2c3e56dd;
"use strict";
$d3a60a591e4745a5$export$e56f4dea2c3e56dd = void 0;



class $d3a60a591e4745a5$var$Hour0to23Parser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $7d89a901ddced10d$export$cc7cc9e2a3ff9388)($a7b185e910828b49$export$c123ee06d9da8480.hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7d89a901ddced10d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}
$d3a60a591e4745a5$export$e56f4dea2c3e56dd = $d3a60a591e4745a5$var$Hour0to23Parser;


var $6b38bf4d4d92b479$export$cbbe855312f87d77;
"use strict";
$6b38bf4d4d92b479$export$cbbe855312f87d77 = void 0;



class $6b38bf4d4d92b479$var$Hour0To11Parser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $7d89a901ddced10d$export$cc7cc9e2a3ff9388)($a7b185e910828b49$export$c123ee06d9da8480.hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7d89a901ddced10d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}
$6b38bf4d4d92b479$export$cbbe855312f87d77 = $6b38bf4d4d92b479$var$Hour0To11Parser;


var $c78953afbc6dd618$export$6008046d2b34b6a5;
"use strict";
$c78953afbc6dd618$export$6008046d2b34b6a5 = void 0;



class $c78953afbc6dd618$var$Hour1To24Parser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $7d89a901ddced10d$export$cc7cc9e2a3ff9388)($a7b185e910828b49$export$c123ee06d9da8480.hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7d89a901ddced10d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}
$c78953afbc6dd618$export$6008046d2b34b6a5 = $c78953afbc6dd618$var$Hour1To24Parser;


var $dfab0e20971b2bda$export$2b52670d9e2be53;
"use strict";
$dfab0e20971b2bda$export$2b52670d9e2be53 = void 0;



class $dfab0e20971b2bda$var$MinuteParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $7d89a901ddced10d$export$cc7cc9e2a3ff9388)($a7b185e910828b49$export$c123ee06d9da8480.minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $7d89a901ddced10d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$dfab0e20971b2bda$export$2b52670d9e2be53 = $dfab0e20971b2bda$var$MinuteParser;


var $f85a12129b93341a$export$94d46d540cf1366a;
"use strict";
$f85a12129b93341a$export$94d46d540cf1366a = void 0;



class $f85a12129b93341a$var$SecondParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $7d89a901ddced10d$export$cc7cc9e2a3ff9388)($a7b185e910828b49$export$c123ee06d9da8480.second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $7d89a901ddced10d$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$f85a12129b93341a$export$94d46d540cf1366a = $f85a12129b93341a$var$SecondParser;


var $0032d044424053cf$export$b8e6f8b2d70893b1;
"use strict";
$0032d044424053cf$export$b8e6f8b2d70893b1 = void 0;


class $0032d044424053cf$var$FractionOfSecondParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $7d89a901ddced10d$export$4f84e3a82c7b538)((0, $7d89a901ddced10d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$0032d044424053cf$export$b8e6f8b2d70893b1 = $0032d044424053cf$var$FractionOfSecondParser;


var $78aaf89a88ebd5ff$export$104d901d49fea29b;
"use strict";
$78aaf89a88ebd5ff$export$104d901d49fea29b = void 0;





// Timezone (ISO-8601. +00:00 is `'Z'`)
class $78aaf89a88ebd5ff$var$ISOTimezoneWithZParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $7d89a901ddced10d$export$6497f4c0ecdfba8e)($a7b185e910828b49$export$a7ee192b982af9c1.basicOptionalMinutes, dateString);
            case "XX":
                return (0, $7d89a901ddced10d$export$6497f4c0ecdfba8e)($a7b185e910828b49$export$a7ee192b982af9c1.basic, dateString);
            case "XXXX":
                return (0, $7d89a901ddced10d$export$6497f4c0ecdfba8e)($a7b185e910828b49$export$a7ee192b982af9c1.basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $7d89a901ddced10d$export$6497f4c0ecdfba8e)($a7b185e910828b49$export$a7ee192b982af9c1.extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $7d89a901ddced10d$export$6497f4c0ecdfba8e)($a7b185e910828b49$export$a7ee192b982af9c1.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, date.getTime() - (0, $f4008ef8d68e7133$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}
$78aaf89a88ebd5ff$export$104d901d49fea29b = $78aaf89a88ebd5ff$var$ISOTimezoneWithZParser;


var $ee5845e9b6761a2f$export$12910e5204b52b9;
"use strict";
$ee5845e9b6761a2f$export$12910e5204b52b9 = void 0;





// Timezone (ISO-8601)
class $ee5845e9b6761a2f$var$ISOTimezoneParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $7d89a901ddced10d$export$6497f4c0ecdfba8e)($a7b185e910828b49$export$a7ee192b982af9c1.basicOptionalMinutes, dateString);
            case "xx":
                return (0, $7d89a901ddced10d$export$6497f4c0ecdfba8e)($a7b185e910828b49$export$a7ee192b982af9c1.basic, dateString);
            case "xxxx":
                return (0, $7d89a901ddced10d$export$6497f4c0ecdfba8e)($a7b185e910828b49$export$a7ee192b982af9c1.basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $7d89a901ddced10d$export$6497f4c0ecdfba8e)($a7b185e910828b49$export$a7ee192b982af9c1.extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $7d89a901ddced10d$export$6497f4c0ecdfba8e)($a7b185e910828b49$export$a7ee192b982af9c1.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, date.getTime() - (0, $f4008ef8d68e7133$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}
$ee5845e9b6761a2f$export$12910e5204b52b9 = $ee5845e9b6761a2f$var$ISOTimezoneParser;


var $f8a4ce745a97f176$export$2cd8bf877a05e96;
"use strict";
$f8a4ce745a97f176$export$2cd8bf877a05e96 = void 0;



class $f8a4ce745a97f176$var$TimestampSecondsParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 40;
    parse(dateString) {
        return (0, $7d89a901ddced10d$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$f8a4ce745a97f176$export$2cd8bf877a05e96 = $f8a4ce745a97f176$var$TimestampSecondsParser;


var $5589831be798357e$export$6d8f69c6906d6368;
"use strict";
$5589831be798357e$export$6d8f69c6906d6368 = void 0;



class $5589831be798357e$var$TimestampMillisecondsParser extends $28b5937cd53b0a6d$export$7acfa6ed01010e37 {
    priority = 20;
    parse(dateString) {
        return (0, $7d89a901ddced10d$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$5589831be798357e$export$6d8f69c6906d6368 = $5589831be798357e$var$TimestampMillisecondsParser;


/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
const $458b798ef3d66812$var$parsers = $458b798ef3d66812$export$19131010e7fd8373 = {
    G: new $577a5802b6538ab2$export$8e5a1d3f85a9688(),
    y: new $7122b5d4b709ee02$export$48d352de7cd4a988(),
    Y: new $1fc4ff14dcd2d7b1$export$b8ef38dfcf05d5db(),
    R: new $c922e8657f75d671$export$951d1df011fde06f(),
    u: new $c83dc0c31d81aa6c$export$bad9d2ea38e8f1a(),
    Q: new $4c36f78989125f4c$export$5cb0f701186dde1d(),
    q: new $1fb4d9d3a719c483$export$300c0c2990e20e6d(),
    M: new $10fd1391eb389e3a$export$400dd8b40ef138a3(),
    L: new $8f6bacbb83bd5d41$export$1d7eaa53eaa5deba(),
    w: new $e26629c37f4332a6$export$c4005ffc174e07c0(),
    I: new $e38c364871594a3c$export$6fc8dbedd560a6af(),
    d: new $a14684a819c0c03f$export$e8d4b28a20981dd2(),
    D: new $40046e6faa68080d$export$6cfe0d613455f615(),
    E: new $e2d51d288c00d0d4$export$1b03c8b76262f7bd(),
    e: new $82669a4bfccaf1e9$export$44d1c127ab42c480(),
    c: new $8be9747b4abbae5b$export$e447a647caaaec1d(),
    i: new $096693cb20dd33b6$export$693fb1e525095b2a(),
    a: new $1777fafb9e68c81d$export$8d1e08492351df91(),
    b: new $5f8802bf27761520$export$73ca2bd0a17d273(),
    B: new $b4a8d255a789b3ef$export$bb9212adf05373db(),
    h: new $c13dc8efb7543616$export$8a04050a727a1756(),
    H: new $d3a60a591e4745a5$export$e56f4dea2c3e56dd(),
    K: new $6b38bf4d4d92b479$export$cbbe855312f87d77(),
    k: new $c78953afbc6dd618$export$6008046d2b34b6a5(),
    m: new $dfab0e20971b2bda$export$2b52670d9e2be53(),
    s: new $f85a12129b93341a$export$94d46d540cf1366a(),
    S: new $0032d044424053cf$export$b8e6f8b2d70893b1(),
    X: new $78aaf89a88ebd5ff$export$104d901d49fea29b(),
    x: new $ee5845e9b6761a2f$export$12910e5204b52b9(),
    t: new $f8a4ce745a97f176$export$2cd8bf877a05e96(),
    T: new $5589831be798357e$export$6d8f69c6906d6368()
};



// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $36c711f59b2e134f$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $36c711f59b2e134f$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $36c711f59b2e134f$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $36c711f59b2e134f$var$doubleQuoteRegExp = /''/g;
const $36c711f59b2e134f$var$notWhitespaceRegExp = /\S/;
const $36c711f59b2e134f$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */ function $36c711f59b2e134f$var$parse(dateStr, formatStr, referenceDate, options) {
    const defaultOptions = (0, $9460588b5f8302f0$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $f767131746751219$exports.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (formatStr === "") {
        if (dateStr === "") return (0, $838192f7942a2bce$export$e67a095c620b86fe)(referenceDate);
        else return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(referenceDate, NaN);
    }
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    const setters = [
        new $8b8513ac03f0d989$export$5aaf7ff7f09ea4ee()
    ];
    const tokens = formatStr.match($36c711f59b2e134f$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in $4d8da8b2c802488a$export$70cc8fd02856fd58) {
            const longFormatter = $4d8da8b2c802488a$export$70cc8fd02856fd58[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($36c711f59b2e134f$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $aeba58ccfb38b506$export$c6b49d6dceb604a1)(token)) (0, $aeba58ccfb38b506$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $aeba58ccfb38b506$export$c6cc36aa33304772)(token)) (0, $aeba58ccfb38b506$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = $458b798ef3d66812$export$19131010e7fd8373[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(referenceDate, NaN);
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($36c711f59b2e134f$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $36c711f59b2e134f$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(referenceDate, NaN);
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $36c711f59b2e134f$var$notWhitespaceRegExp.test(dateStr)) return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(referenceDate, NaN);
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(referenceDate);
    if (isNaN(date.getTime())) return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(referenceDate, NaN);
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(referenceDate, NaN);
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(referenceDate, date);
}
function $36c711f59b2e134f$var$cleanEscapedString(input) {
    return input.match($36c711f59b2e134f$var$escapedStringRegExp)[1].replace($36c711f59b2e134f$var$doubleQuoteRegExp, "'");
}


/**
 * The {@link isMatch} function options.
 */ /**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The date string to verify
 * @param format - The string of tokens
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns Is format string a match for date string?
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */ function $db4e8a0a9c504d02$var$isMatch(dateStr, formatStr, options) {
    return (0, $9686c3631a8bde9c$export$1ea939691cdc45b8)((0, $36c711f59b2e134f$exports.parse)(dateStr, formatStr, new Date(), options));
}


Object.keys($db4e8a0a9c504d02$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $db4e8a0a9c504d02$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $db4e8a0a9c504d02$exports[key];
        }
    });
});
var $546f45593ca810ea$exports = {};

$parcel$export($546f45593ca810ea$exports, "isMonday", function () { return $546f45593ca810ea$export$9573fe9b7c9ac3f5; }, function (v) { return $546f45593ca810ea$export$9573fe9b7c9ac3f5 = v; });
var $546f45593ca810ea$export$9573fe9b7c9ac3f5;
"use strict";
$546f45593ca810ea$export$9573fe9b7c9ac3f5 = $546f45593ca810ea$var$isMonday;

/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * const result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */ function $546f45593ca810ea$var$isMonday(date) {
    return (0, $838192f7942a2bce$export$e67a095c620b86fe)(date).getDay() === 1;
}


Object.keys($546f45593ca810ea$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $546f45593ca810ea$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $546f45593ca810ea$exports[key];
        }
    });
});
var $c19a5bf03aebd445$exports = {};

$parcel$export($c19a5bf03aebd445$exports, "isPast", function () { return $c19a5bf03aebd445$export$fc5014aa3db48558; }, function (v) { return $c19a5bf03aebd445$export$fc5014aa3db48558 = v; });
var $c19a5bf03aebd445$export$fc5014aa3db48558;
"use strict";
$c19a5bf03aebd445$export$fc5014aa3db48558 = $c19a5bf03aebd445$var$isPast;

/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */ function $c19a5bf03aebd445$var$isPast(date) {
    return +(0, $838192f7942a2bce$export$e67a095c620b86fe)(date) < Date.now();
}


Object.keys($c19a5bf03aebd445$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $c19a5bf03aebd445$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $c19a5bf03aebd445$exports[key];
        }
    });
});

Object.keys($16b25d82130e0f81$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $16b25d82130e0f81$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $16b25d82130e0f81$exports[key];
        }
    });
});
var $ff11706628e8e68a$exports = {};

$parcel$export($ff11706628e8e68a$exports, "isSameHour", function () { return $ff11706628e8e68a$export$f9f3a94a0371013; }, function (v) { return $ff11706628e8e68a$export$f9f3a94a0371013 = v; });
var $ff11706628e8e68a$export$f9f3a94a0371013;
"use strict";
$ff11706628e8e68a$export$f9f3a94a0371013 = $ff11706628e8e68a$var$isSameHour;
var $8ca89137925d43b1$exports = {};

$parcel$export($8ca89137925d43b1$exports, "startOfHour", function () { return $8ca89137925d43b1$export$24f91f68e7c9d9d5; }, function (v) { return $8ca89137925d43b1$export$24f91f68e7c9d9d5 = v; });
var $8ca89137925d43b1$export$24f91f68e7c9d9d5;
"use strict";
$8ca89137925d43b1$export$24f91f68e7c9d9d5 = $8ca89137925d43b1$var$startOfHour;

/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */ function $8ca89137925d43b1$var$startOfHour(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    _date.setMinutes(0, 0, 0);
    return _date;
}


/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same hour (and same day)
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */ function $ff11706628e8e68a$var$isSameHour(dateLeft, dateRight) {
    const dateLeftStartOfHour = (0, $8ca89137925d43b1$export$24f91f68e7c9d9d5)(dateLeft);
    const dateRightStartOfHour = (0, $8ca89137925d43b1$export$24f91f68e7c9d9d5)(dateRight);
    return +dateLeftStartOfHour === +dateRightStartOfHour;
}


Object.keys($ff11706628e8e68a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $ff11706628e8e68a$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $ff11706628e8e68a$exports[key];
        }
    });
});
var $6b9b4e6d4a7847f5$exports = {};

$parcel$export($6b9b4e6d4a7847f5$exports, "isSameISOWeek", function () { return $6b9b4e6d4a7847f5$export$1c6e74e3c7b27764; }, function (v) { return $6b9b4e6d4a7847f5$export$1c6e74e3c7b27764 = v; });
var $6b9b4e6d4a7847f5$export$1c6e74e3c7b27764;
"use strict";
$6b9b4e6d4a7847f5$export$1c6e74e3c7b27764 = $6b9b4e6d4a7847f5$var$isSameISOWeek;
var $e2972b6ee522cf36$exports = {};

$parcel$export($e2972b6ee522cf36$exports, "isSameWeek", function () { return $e2972b6ee522cf36$export$6ea683876c36b8d2; }, function (v) { return $e2972b6ee522cf36$export$6ea683876c36b8d2 = v; });
var $e2972b6ee522cf36$export$6ea683876c36b8d2;
"use strict";
$e2972b6ee522cf36$export$6ea683876c36b8d2 = $e2972b6ee522cf36$var$isSameWeek;

/**
 * The {@link isSameWeek} function options.
 */ /**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same week (and month and year)
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $e2972b6ee522cf36$var$isSameWeek(dateLeft, dateRight, options) {
    const dateLeftStartOfWeek = (0, $cb6997e20defc27a$export$42c81a444fbfb5d4)(dateLeft, options);
    const dateRightStartOfWeek = (0, $cb6997e20defc27a$export$42c81a444fbfb5d4)(dateRight, options);
    return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}


/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week (and year)?
 *
 * @description
 * Are the given dates in the same ISO week (and year)?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week (and year)
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
 * //=> true
 *
 * @example
 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
 * //=> false
 */ function $6b9b4e6d4a7847f5$var$isSameISOWeek(dateLeft, dateRight) {
    return (0, $e2972b6ee522cf36$export$6ea683876c36b8d2)(dateLeft, dateRight, {
        weekStartsOn: 1
    });
}


Object.keys($6b9b4e6d4a7847f5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $6b9b4e6d4a7847f5$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $6b9b4e6d4a7847f5$exports[key];
        }
    });
});
var $7498edae84ebc379$exports = {};

$parcel$export($7498edae84ebc379$exports, "isSameISOWeekYear", function () { return $7498edae84ebc379$export$5f55dbf38a1aee81; }, function (v) { return $7498edae84ebc379$export$5f55dbf38a1aee81 = v; });
var $7498edae84ebc379$export$5f55dbf38a1aee81;
"use strict";
$7498edae84ebc379$export$5f55dbf38a1aee81 = $7498edae84ebc379$var$isSameISOWeekYear;

/**
 * @name isSameISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
 * //=> true
 */ function $7498edae84ebc379$var$isSameISOWeekYear(dateLeft, dateRight) {
    const dateLeftStartOfYear = (0, $4ac098d276fcecdf$export$236bdfa374eb69a9)(dateLeft);
    const dateRightStartOfYear = (0, $4ac098d276fcecdf$export$236bdfa374eb69a9)(dateRight);
    return +dateLeftStartOfYear === +dateRightStartOfYear;
}


Object.keys($7498edae84ebc379$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $7498edae84ebc379$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $7498edae84ebc379$exports[key];
        }
    });
});
var $00dc7ef08b67915a$exports = {};

$parcel$export($00dc7ef08b67915a$exports, "isSameMinute", function () { return $00dc7ef08b67915a$export$5d274bf63c8705cb; }, function (v) { return $00dc7ef08b67915a$export$5d274bf63c8705cb = v; });
var $00dc7ef08b67915a$export$5d274bf63c8705cb;
"use strict";
$00dc7ef08b67915a$export$5d274bf63c8705cb = $00dc7ef08b67915a$var$isSameMinute;

/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute (and hour and day)?
 *
 * @description
 * Are the given dates in the same minute (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same minute (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 5, 6, 30)
 * )
 * //=> false
 */ function $00dc7ef08b67915a$var$isSameMinute(dateLeft, dateRight) {
    const dateLeftStartOfMinute = (0, $f7b7b7b4fe06340d$export$c66440458c6aa793)(dateLeft);
    const dateRightStartOfMinute = (0, $f7b7b7b4fe06340d$export$c66440458c6aa793)(dateRight);
    return +dateLeftStartOfMinute === +dateRightStartOfMinute;
}


Object.keys($00dc7ef08b67915a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $00dc7ef08b67915a$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $00dc7ef08b67915a$exports[key];
        }
    });
});
var $f48a82bfd9f9eef4$exports = {};

$parcel$export($f48a82bfd9f9eef4$exports, "isSameMonth", function () { return $f48a82bfd9f9eef4$export$a18c89cbd24170ff; }, function (v) { return $f48a82bfd9f9eef4$export$a18c89cbd24170ff = v; });
var $f48a82bfd9f9eef4$export$a18c89cbd24170ff;
"use strict";
$f48a82bfd9f9eef4$export$a18c89cbd24170ff = $f48a82bfd9f9eef4$var$isSameMonth;

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ function $f48a82bfd9f9eef4$var$isSameMonth(dateLeft, dateRight) {
    const _dateLeft = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}


Object.keys($f48a82bfd9f9eef4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $f48a82bfd9f9eef4$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $f48a82bfd9f9eef4$exports[key];
        }
    });
});
var $96e26c99d0aa5b25$exports = {};

$parcel$export($96e26c99d0aa5b25$exports, "isSameQuarter", function () { return $96e26c99d0aa5b25$export$5c60e4190867161c; }, function (v) { return $96e26c99d0aa5b25$export$5c60e4190867161c = v; });
var $96e26c99d0aa5b25$export$5c60e4190867161c;
"use strict";
$96e26c99d0aa5b25$export$5c60e4190867161c = $96e26c99d0aa5b25$var$isSameQuarter;

/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same quarter (and year)
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $96e26c99d0aa5b25$var$isSameQuarter(dateLeft, dateRight) {
    const dateLeftStartOfQuarter = (0, $fc9398e6271fd192$export$69be7267a042ecb3)(dateLeft);
    const dateRightStartOfQuarter = (0, $fc9398e6271fd192$export$69be7267a042ecb3)(dateRight);
    return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}


Object.keys($96e26c99d0aa5b25$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $96e26c99d0aa5b25$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $96e26c99d0aa5b25$exports[key];
        }
    });
});
var $610c7097a684f69d$exports = {};

$parcel$export($610c7097a684f69d$exports, "isSameSecond", function () { return $610c7097a684f69d$export$b88fbcfe038f3498; }, function (v) { return $610c7097a684f69d$export$b88fbcfe038f3498 = v; });
var $610c7097a684f69d$export$b88fbcfe038f3498;
"use strict";
$610c7097a684f69d$export$b88fbcfe038f3498 = $610c7097a684f69d$var$isSameSecond;
var $4166e5777192872a$exports = {};

$parcel$export($4166e5777192872a$exports, "startOfSecond", function () { return $4166e5777192872a$export$66c51f9715fdbff5; }, function (v) { return $4166e5777192872a$export$66c51f9715fdbff5 = v; });
var $4166e5777192872a$export$66c51f9715fdbff5;
"use strict";
$4166e5777192872a$export$66c51f9715fdbff5 = $4166e5777192872a$var$startOfSecond;

/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */ function $4166e5777192872a$var$startOfSecond(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    _date.setMilliseconds(0);
    return _date;
}


/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same second (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */ function $610c7097a684f69d$var$isSameSecond(dateLeft, dateRight) {
    const dateLeftStartOfSecond = (0, $4166e5777192872a$export$66c51f9715fdbff5)(dateLeft);
    const dateRightStartOfSecond = (0, $4166e5777192872a$export$66c51f9715fdbff5)(dateRight);
    return +dateLeftStartOfSecond === +dateRightStartOfSecond;
}


Object.keys($610c7097a684f69d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $610c7097a684f69d$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $610c7097a684f69d$exports[key];
        }
    });
});

Object.keys($e2972b6ee522cf36$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $e2972b6ee522cf36$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $e2972b6ee522cf36$exports[key];
        }
    });
});
var $8f09ece6f2617ec7$exports = {};

$parcel$export($8f09ece6f2617ec7$exports, "isSameYear", function () { return $8f09ece6f2617ec7$export$5841f9eb9773f25f; }, function (v) { return $8f09ece6f2617ec7$export$5841f9eb9773f25f = v; });
var $8f09ece6f2617ec7$export$5841f9eb9773f25f;
"use strict";
$8f09ece6f2617ec7$export$5841f9eb9773f25f = $8f09ece6f2617ec7$var$isSameYear;

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ function $8f09ece6f2617ec7$var$isSameYear(dateLeft, dateRight) {
    const _dateLeft = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $838192f7942a2bce$export$e67a095c620b86fe)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear();
}


Object.keys($8f09ece6f2617ec7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $8f09ece6f2617ec7$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $8f09ece6f2617ec7$exports[key];
        }
    });
});

Object.keys($14c774cf63527d18$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $14c774cf63527d18$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $14c774cf63527d18$exports[key];
        }
    });
});

Object.keys($86425194c9637130$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $86425194c9637130$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $86425194c9637130$exports[key];
        }
    });
});
var $c3e2395aca0db1ec$exports = {};

$parcel$export($c3e2395aca0db1ec$exports, "isThisHour", function () { return $c3e2395aca0db1ec$export$5d41bdc7172839b9; }, function (v) { return $c3e2395aca0db1ec$export$5d41bdc7172839b9 = v; });
var $c3e2395aca0db1ec$export$5d41bdc7172839b9;
"use strict";
$c3e2395aca0db1ec$export$5d41bdc7172839b9 = $c3e2395aca0db1ec$var$isThisHour;


/**
 * @name isThisHour
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * const result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */ function $c3e2395aca0db1ec$var$isThisHour(date) {
    return (0, $ff11706628e8e68a$export$f9f3a94a0371013)(date, (0, $6284e2d2db30dabc$export$18c3c6510fb97afc)(date));
}


Object.keys($c3e2395aca0db1ec$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $c3e2395aca0db1ec$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $c3e2395aca0db1ec$exports[key];
        }
    });
});
var $e81f872d23cbeaa1$exports = {};

$parcel$export($e81f872d23cbeaa1$exports, "isThisISOWeek", function () { return $e81f872d23cbeaa1$export$4e987896c721f753; }, function (v) { return $e81f872d23cbeaa1$export$4e987896c721f753 = v; });
var $e81f872d23cbeaa1$export$4e987896c721f753;
"use strict";
$e81f872d23cbeaa1$export$4e987896c721f753 = $e81f872d23cbeaa1$var$isThisISOWeek;


/**
 * @name isThisISOWeek
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * const result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */ function $e81f872d23cbeaa1$var$isThisISOWeek(date) {
    return (0, $6b9b4e6d4a7847f5$export$1c6e74e3c7b27764)(date, (0, $6284e2d2db30dabc$export$18c3c6510fb97afc)(date));
}


Object.keys($e81f872d23cbeaa1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $e81f872d23cbeaa1$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $e81f872d23cbeaa1$exports[key];
        }
    });
});
var $ae705f89137c60a9$exports = {};

$parcel$export($ae705f89137c60a9$exports, "isThisMinute", function () { return $ae705f89137c60a9$export$fa55b7d29d8d957a; }, function (v) { return $ae705f89137c60a9$export$fa55b7d29d8d957a = v; });
var $ae705f89137c60a9$export$fa55b7d29d8d957a;
"use strict";
$ae705f89137c60a9$export$fa55b7d29d8d957a = $ae705f89137c60a9$var$isThisMinute;


/**
 * @name isThisMinute
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */ function $ae705f89137c60a9$var$isThisMinute(date) {
    return (0, $00dc7ef08b67915a$export$5d274bf63c8705cb)(date, (0, $6284e2d2db30dabc$export$18c3c6510fb97afc)(date));
}


Object.keys($ae705f89137c60a9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $ae705f89137c60a9$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $ae705f89137c60a9$exports[key];
        }
    });
});
var $c3ea71e72303022a$exports = {};

$parcel$export($c3ea71e72303022a$exports, "isThisMonth", function () { return $c3ea71e72303022a$export$173f1e1d92847276; }, function (v) { return $c3ea71e72303022a$export$173f1e1d92847276 = v; });
var $c3ea71e72303022a$export$173f1e1d92847276;
"use strict";
$c3ea71e72303022a$export$173f1e1d92847276 = $c3ea71e72303022a$var$isThisMonth;


/**
 * @name isThisMonth
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * const result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */ function $c3ea71e72303022a$var$isThisMonth(date) {
    return (0, $f48a82bfd9f9eef4$export$a18c89cbd24170ff)(date, (0, $6284e2d2db30dabc$export$18c3c6510fb97afc)(date));
}


Object.keys($c3ea71e72303022a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $c3ea71e72303022a$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $c3ea71e72303022a$exports[key];
        }
    });
});
var $1f146b4fdba3c6ac$exports = {};

$parcel$export($1f146b4fdba3c6ac$exports, "isThisQuarter", function () { return $1f146b4fdba3c6ac$export$3d88fd18ab599ccc; }, function (v) { return $1f146b4fdba3c6ac$export$3d88fd18ab599ccc = v; });
var $1f146b4fdba3c6ac$export$3d88fd18ab599ccc;
"use strict";
$1f146b4fdba3c6ac$export$3d88fd18ab599ccc = $1f146b4fdba3c6ac$var$isThisQuarter;


/**
 * @name isThisQuarter
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * const result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */ function $1f146b4fdba3c6ac$var$isThisQuarter(date) {
    return (0, $96e26c99d0aa5b25$export$5c60e4190867161c)(date, (0, $6284e2d2db30dabc$export$18c3c6510fb97afc)(date));
}


Object.keys($1f146b4fdba3c6ac$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $1f146b4fdba3c6ac$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $1f146b4fdba3c6ac$exports[key];
        }
    });
});
var $7d3f7cc48a1577e6$exports = {};

$parcel$export($7d3f7cc48a1577e6$exports, "isThisSecond", function () { return $7d3f7cc48a1577e6$export$8d7059b5bca087e6; }, function (v) { return $7d3f7cc48a1577e6$export$8d7059b5bca087e6 = v; });
var $7d3f7cc48a1577e6$export$8d7059b5bca087e6;
"use strict";
$7d3f7cc48a1577e6$export$8d7059b5bca087e6 = $7d3f7cc48a1577e6$var$isThisSecond;


/**
 * @name isThisSecond
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */ function $7d3f7cc48a1577e6$var$isThisSecond(date) {
    return (0, $610c7097a684f69d$export$b88fbcfe038f3498)(date, (0, $6284e2d2db30dabc$export$18c3c6510fb97afc)(date));
}


Object.keys($7d3f7cc48a1577e6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $7d3f7cc48a1577e6$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $7d3f7cc48a1577e6$exports[key];
        }
    });
});
var $2b9189a93fdb77c2$exports = {};

$parcel$export($2b9189a93fdb77c2$exports, "isThisWeek", function () { return $2b9189a93fdb77c2$export$cfe4b66a69cdd8a; }, function (v) { return $2b9189a93fdb77c2$export$cfe4b66a69cdd8a = v; });
var $2b9189a93fdb77c2$export$cfe4b66a69cdd8a;
"use strict";
$2b9189a93fdb77c2$export$cfe4b66a69cdd8a = $2b9189a93fdb77c2$var$isThisWeek;


/**
 * The {@link isThisWeek} function options.
 */ /**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param options - The object with options
 *
 * @returns The date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */ function $2b9189a93fdb77c2$var$isThisWeek(date, options) {
    return (0, $e2972b6ee522cf36$export$6ea683876c36b8d2)(date, (0, $6284e2d2db30dabc$export$18c3c6510fb97afc)(date), options);
}


Object.keys($2b9189a93fdb77c2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $2b9189a93fdb77c2$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $2b9189a93fdb77c2$exports[key];
        }
    });
});
var $639b9bb23d7d9df8$exports = {};

$parcel$export($639b9bb23d7d9df8$exports, "isThisYear", function () { return $639b9bb23d7d9df8$export$a28c94941893a5ac; }, function (v) { return $639b9bb23d7d9df8$export$a28c94941893a5ac = v; });
var $639b9bb23d7d9df8$export$a28c94941893a5ac;
"use strict";
$639b9bb23d7d9df8$export$a28c94941893a5ac = $639b9bb23d7d9df8$var$isThisYear;


/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */ function $639b9bb23d7d9df8$var$isThisYear(date) {
    return (0, $8f09ece6f2617ec7$export$5841f9eb9773f25f)(date, (0, $6284e2d2db30dabc$export$18c3c6510fb97afc)(date));
}


Object.keys($639b9bb23d7d9df8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $639b9bb23d7d9df8$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $639b9bb23d7d9df8$exports[key];
        }
    });
});
var $70c9c6417d537fd8$exports = {};

$parcel$export($70c9c6417d537fd8$exports, "isThursday", function () { return $70c9c6417d537fd8$export$c8e7c906983ea347; }, function (v) { return $70c9c6417d537fd8$export$c8e7c906983ea347 = v; });
var $70c9c6417d537fd8$export$c8e7c906983ea347;
"use strict";
$70c9c6417d537fd8$export$c8e7c906983ea347 = $70c9c6417d537fd8$var$isThursday;

/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * const result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */ function $70c9c6417d537fd8$var$isThursday(date) {
    return (0, $838192f7942a2bce$export$e67a095c620b86fe)(date).getDay() === 4;
}


Object.keys($70c9c6417d537fd8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $70c9c6417d537fd8$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $70c9c6417d537fd8$exports[key];
        }
    });
});
var $d8d4c3df843ef7c6$exports = {};

$parcel$export($d8d4c3df843ef7c6$exports, "isToday", function () { return $d8d4c3df843ef7c6$export$629b0a497aa65267; }, function (v) { return $d8d4c3df843ef7c6$export$629b0a497aa65267 = v; });
var $d8d4c3df843ef7c6$export$629b0a497aa65267;
"use strict";
$d8d4c3df843ef7c6$export$629b0a497aa65267 = $d8d4c3df843ef7c6$var$isToday;


/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */ function $d8d4c3df843ef7c6$var$isToday(date) {
    return (0, $16b25d82130e0f81$export$ea39ec197993aef0)(date, (0, $6284e2d2db30dabc$export$18c3c6510fb97afc)(date));
}


Object.keys($d8d4c3df843ef7c6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $d8d4c3df843ef7c6$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $d8d4c3df843ef7c6$exports[key];
        }
    });
});
var $d9338c5812513b02$exports = {};

$parcel$export($d9338c5812513b02$exports, "isTomorrow", function () { return $d9338c5812513b02$export$d6365ba92f0647f1; }, function (v) { return $d9338c5812513b02$export$d6365ba92f0647f1 = v; });
var $d9338c5812513b02$export$d6365ba92f0647f1;
"use strict";
$d9338c5812513b02$export$d6365ba92f0647f1 = $d9338c5812513b02$var$isTomorrow;



/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */ function $d9338c5812513b02$var$isTomorrow(date) {
    return (0, $16b25d82130e0f81$export$ea39ec197993aef0)(date, (0, $b7f6bbd55167ab46$export$dd412b56f1e4d8aa)((0, $6284e2d2db30dabc$export$18c3c6510fb97afc)(date), 1));
}


Object.keys($d9338c5812513b02$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $d9338c5812513b02$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $d9338c5812513b02$exports[key];
        }
    });
});
var $8162b003145563c4$exports = {};

$parcel$export($8162b003145563c4$exports, "isTuesday", function () { return $8162b003145563c4$export$90d50b8f209f5ac3; }, function (v) { return $8162b003145563c4$export$90d50b8f209f5ac3 = v; });
var $8162b003145563c4$export$90d50b8f209f5ac3;
"use strict";
$8162b003145563c4$export$90d50b8f209f5ac3 = $8162b003145563c4$var$isTuesday;

/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * const result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */ function $8162b003145563c4$var$isTuesday(date) {
    return (0, $838192f7942a2bce$export$e67a095c620b86fe)(date).getDay() === 2;
}


Object.keys($8162b003145563c4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $8162b003145563c4$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $8162b003145563c4$exports[key];
        }
    });
});

Object.keys($9686c3631a8bde9c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $9686c3631a8bde9c$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $9686c3631a8bde9c$exports[key];
        }
    });
});
var $2bb700d625644983$exports = {};

$parcel$export($2bb700d625644983$exports, "isWednesday", function () { return $2bb700d625644983$export$ec9de642cdd62944; }, function (v) { return $2bb700d625644983$export$ec9de642cdd62944 = v; });
var $2bb700d625644983$export$ec9de642cdd62944;
"use strict";
$2bb700d625644983$export$ec9de642cdd62944 = $2bb700d625644983$var$isWednesday;

/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * const result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */ function $2bb700d625644983$var$isWednesday(date) {
    return (0, $838192f7942a2bce$export$e67a095c620b86fe)(date).getDay() === 3;
}


Object.keys($2bb700d625644983$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $2bb700d625644983$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $2bb700d625644983$exports[key];
        }
    });
});

Object.keys($cb1411d6fcaa37ae$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $cb1411d6fcaa37ae$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $cb1411d6fcaa37ae$exports[key];
        }
    });
});
var $8eda43859c9fec85$exports = {};

$parcel$export($8eda43859c9fec85$exports, "isWithinInterval", function () { return $8eda43859c9fec85$export$d7deef7a3738e19d; }, function (v) { return $8eda43859c9fec85$export$d7deef7a3738e19d = v; });
var $8eda43859c9fec85$export$d7deef7a3738e19d;
"use strict";
$8eda43859c9fec85$export$d7deef7a3738e19d = $8eda43859c9fec85$var$isWithinInterval;

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */ function $8eda43859c9fec85$var$isWithinInterval(date, interval) {
    const time = +(0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const [startTime, endTime] = [
        +(0, $838192f7942a2bce$export$e67a095c620b86fe)(interval.start),
        +(0, $838192f7942a2bce$export$e67a095c620b86fe)(interval.end)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}


Object.keys($8eda43859c9fec85$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $8eda43859c9fec85$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $8eda43859c9fec85$exports[key];
        }
    });
});
var $950a205a9a733aa6$exports = {};

$parcel$export($950a205a9a733aa6$exports, "isYesterday", function () { return $950a205a9a733aa6$export$221990270ebfe867; }, function (v) { return $950a205a9a733aa6$export$221990270ebfe867 = v; });
var $950a205a9a733aa6$export$221990270ebfe867;
"use strict";
$950a205a9a733aa6$export$221990270ebfe867 = $950a205a9a733aa6$var$isYesterday;


var $1fa39d6f8b4fe4f0$exports = {};

$parcel$export($1fa39d6f8b4fe4f0$exports, "subDays", function () { return $1fa39d6f8b4fe4f0$export$70823084e2deb1ea; }, function (v) { return $1fa39d6f8b4fe4f0$export$70823084e2deb1ea = v; });
var $1fa39d6f8b4fe4f0$export$70823084e2deb1ea;
"use strict";
$1fa39d6f8b4fe4f0$export$70823084e2deb1ea = $1fa39d6f8b4fe4f0$var$subDays;

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */ function $1fa39d6f8b4fe4f0$var$subDays(date, amount) {
    return (0, $b7f6bbd55167ab46$export$dd412b56f1e4d8aa)(date, -amount);
}


/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */ function $950a205a9a733aa6$var$isYesterday(date) {
    return (0, $16b25d82130e0f81$export$ea39ec197993aef0)(date, (0, $1fa39d6f8b4fe4f0$export$70823084e2deb1ea)((0, $6284e2d2db30dabc$export$18c3c6510fb97afc)(date), 1));
}


Object.keys($950a205a9a733aa6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $950a205a9a733aa6$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $950a205a9a733aa6$exports[key];
        }
    });
});
var $aee57ec1d6870300$exports = {};

$parcel$export($aee57ec1d6870300$exports, "lastDayOfDecade", function () { return $aee57ec1d6870300$export$2aaf6241f57dd605; }, function (v) { return $aee57ec1d6870300$export$2aaf6241f57dd605 = v; });
var $aee57ec1d6870300$export$2aaf6241f57dd605;
"use strict";
$aee57ec1d6870300$export$2aaf6241f57dd605 = $aee57ec1d6870300$var$lastDayOfDecade;

/**
 * @name lastDayOfDecade
 * @category Decade Helpers
 * @summary Return the last day of a decade for the given date.
 *
 * @description
 * Return the last day of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a decade
 *
 * @example
 * // The last day of a decade for 21 December 2012 21:12:00:
 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
 * //=> Wed Dec 31 2019 00:00:00
 */ function $aee57ec1d6870300$var$lastDayOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($aee57ec1d6870300$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $aee57ec1d6870300$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $aee57ec1d6870300$exports[key];
        }
    });
});
var $6d04b5e9f7bd8433$exports = {};

$parcel$export($6d04b5e9f7bd8433$exports, "lastDayOfISOWeek", function () { return $6d04b5e9f7bd8433$export$b08a8fc26ae6d94b; }, function (v) { return $6d04b5e9f7bd8433$export$b08a8fc26ae6d94b = v; });
var $6d04b5e9f7bd8433$export$b08a8fc26ae6d94b;
"use strict";
$6d04b5e9f7bd8433$export$b08a8fc26ae6d94b = $6d04b5e9f7bd8433$var$lastDayOfISOWeek;
var $d71467eca3301fb2$exports = {};

$parcel$export($d71467eca3301fb2$exports, "lastDayOfWeek", function () { return $d71467eca3301fb2$export$b73502c35a293b0a; }, function (v) { return $d71467eca3301fb2$export$b73502c35a293b0a = v; });
var $d71467eca3301fb2$export$b73502c35a293b0a;
"use strict";
$d71467eca3301fb2$export$b73502c35a293b0a = $d71467eca3301fb2$var$lastDayOfWeek;


/**
 * The {@link lastDayOfWeek} function options.
 */ /**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $d71467eca3301fb2$var$lastDayOfWeek(date, options) {
    const defaultOptions = (0, $0a8793ff6cad2441$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setHours(0, 0, 0, 0);
    _date.setDate(_date.getDate() + diff);
    return _date;
}


/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */ function $6d04b5e9f7bd8433$var$lastDayOfISOWeek(date) {
    return (0, $d71467eca3301fb2$export$b73502c35a293b0a)(date, {
        weekStartsOn: 1
    });
}


Object.keys($6d04b5e9f7bd8433$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $6d04b5e9f7bd8433$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $6d04b5e9f7bd8433$exports[key];
        }
    });
});
var $8727d014ab5b2d87$exports = {};

$parcel$export($8727d014ab5b2d87$exports, "lastDayOfISOWeekYear", function () { return $8727d014ab5b2d87$export$1810bada8cd02ee1; }, function (v) { return $8727d014ab5b2d87$export$1810bada8cd02ee1 = v; });
var $8727d014ab5b2d87$export$1810bada8cd02ee1;
"use strict";
$8727d014ab5b2d87$export$1810bada8cd02ee1 = $8727d014ab5b2d87$var$lastDayOfISOWeekYear;



/**
 * @name lastDayOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */ function $8727d014ab5b2d87$var$lastDayOfISOWeekYear(date) {
    const year = (0, $f51448e7e5a1f4fe$export$3dbc52535f6f8fcc)(date);
    const fourthOfJanuary = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, 0);
    fourthOfJanuary.setFullYear(year + 1, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    const _date = (0, $0ce4d92e449d76da$export$6173213f95a4431e)(fourthOfJanuary);
    _date.setDate(_date.getDate() - 1);
    return _date;
}


Object.keys($8727d014ab5b2d87$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $8727d014ab5b2d87$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $8727d014ab5b2d87$exports[key];
        }
    });
});

Object.keys($3726fd48ed228118$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $3726fd48ed228118$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $3726fd48ed228118$exports[key];
        }
    });
});
var $4777bbd389ec5bea$exports = {};

$parcel$export($4777bbd389ec5bea$exports, "lastDayOfQuarter", function () { return $4777bbd389ec5bea$export$8693c04228304c7; }, function (v) { return $4777bbd389ec5bea$export$8693c04228304c7 = v; });
var $4777bbd389ec5bea$export$8693c04228304c7;
"use strict";
$4777bbd389ec5bea$export$8693c04228304c7 = $4777bbd389ec5bea$var$lastDayOfQuarter;

/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $4777bbd389ec5bea$var$lastDayOfQuarter(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($4777bbd389ec5bea$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $4777bbd389ec5bea$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $4777bbd389ec5bea$exports[key];
        }
    });
});

Object.keys($d71467eca3301fb2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $d71467eca3301fb2$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $d71467eca3301fb2$exports[key];
        }
    });
});
var $13d4058c13a69cae$exports = {};

$parcel$export($13d4058c13a69cae$exports, "lastDayOfYear", function () { return $13d4058c13a69cae$export$323f7bc07b828bed; }, function (v) { return $13d4058c13a69cae$export$323f7bc07b828bed = v; });
var $13d4058c13a69cae$export$323f7bc07b828bed;
"use strict";
$13d4058c13a69cae$export$323f7bc07b828bed = $13d4058c13a69cae$var$lastDayOfYear;

/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */ function $13d4058c13a69cae$var$lastDayOfYear(date) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($13d4058c13a69cae$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $13d4058c13a69cae$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $13d4058c13a69cae$exports[key];
        }
    });
});
var $5e1b26c153f9eaf5$exports = {};
"use strict";
$5e1b26c153f9eaf5$exports.lightFormat = $5e1b26c153f9eaf5$var$lightFormat;
Object.defineProperty($5e1b26c153f9eaf5$exports, "lightFormatters", {
    enumerable: true,
    get: function() {
        return $66714b725085036c$export$b0d4b338e1516f13;
    }
});



// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $5e1b26c153f9eaf5$var$formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
const $5e1b26c153f9eaf5$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $5e1b26c153f9eaf5$var$doubleQuoteRegExp = /''/g;
const $5e1b26c153f9eaf5$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @private
 */ /**
 * @name lightFormat
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. Unlike `format`,
 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
 *
 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   |
 * |---------------------------------|---------|-----------------------------------|
 * | AM, PM                          | a..aaa  | AM, PM                            |
 * |                                 | aaaa    | a.m., p.m.                        |
 * |                                 | aaaaa   | a, p                              |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
 * |                                 | yy      | 44, 01, 00, 17                    |
 * |                                 | yyy     | 044, 001, 000, 017                |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
 * |                                 | MM      | 01, 02, ..., 12                   |
 * | Day of month                    | d       | 1, 2, ..., 31                     |
 * |                                 | dd      | 01, 02, ..., 31                   |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
 * |                                 | hh      | 01, 02, ..., 11, 12               |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
 * |                                 | HH      | 00, 01, 02, ..., 23               |
 * | Minute                          | m       | 0, 1, ..., 59                     |
 * |                                 | mm      | 00, 01, ..., 59                   |
 * | Second                          | s       | 0, 1, ..., 59                     |
 * |                                 | ss      | 00, 01, ..., 59                   |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |
 * |                                 | SS      | 00, 01, ..., 99                   |
 * |                                 | SSS     | 000, 001, ..., 999                |
 * |                                 | SSSS    | ...                               |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 *
 * @returns The formatted date string
 *
 * @throws `Invalid time value` if the date is invalid
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
 * //=> '2014-02-11'
 */ function $5e1b26c153f9eaf5$var$lightFormat(date, formatStr) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    if (!(0, $9686c3631a8bde9c$export$1ea939691cdc45b8)(_date)) throw new RangeError("Invalid time value");
    const tokens = formatStr.match($5e1b26c153f9eaf5$var$formattingTokensRegExp);
    // The only case when formattingTokensRegExp doesn't match the string is when it's empty
    if (!tokens) return "";
    const result = tokens.map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return $5e1b26c153f9eaf5$var$cleanEscapedString(substring);
        const formatter = $66714b725085036c$export$b0d4b338e1516f13[firstCharacter];
        if (formatter) return formatter(_date, substring);
        if (firstCharacter.match($5e1b26c153f9eaf5$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $5e1b26c153f9eaf5$var$cleanEscapedString(input) {
    const matches = input.match($5e1b26c153f9eaf5$var$escapedStringRegExp);
    if (!matches) return input;
    return matches[1].replace($5e1b26c153f9eaf5$var$doubleQuoteRegExp, "'");
}


Object.keys($5e1b26c153f9eaf5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $5e1b26c153f9eaf5$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $5e1b26c153f9eaf5$exports[key];
        }
    });
});

Object.keys($f627985ca4c702b2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $f627985ca4c702b2$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $f627985ca4c702b2$exports[key];
        }
    });
});
var $bd48b5a22f9e7020$exports = {};

$parcel$export($bd48b5a22f9e7020$exports, "milliseconds", function () { return $bd48b5a22f9e7020$export$9a27fac83d67afd3; }, function (v) { return $bd48b5a22f9e7020$export$9a27fac83d67afd3 = v; });
var $bd48b5a22f9e7020$export$9a27fac83d67afd3;
"use strict";
$bd48b5a22f9e7020$export$9a27fac83d67afd3 = $bd48b5a22f9e7020$var$milliseconds;

/**
 * @name milliseconds
 * @category Millisecond Helpers
 * @summary
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * @description
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * One month is a year divided by 12.
 *
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * @returns The milliseconds
 *
 * @example
 * // 1 year in milliseconds
 * milliseconds({ years: 1 })
 * //=> 31556952000
 *
 * // 3 months in milliseconds
 * milliseconds({ months: 3 })
 * //=> 7889238000
 */ function $bd48b5a22f9e7020$var$milliseconds({ years: years, months: months, weeks: weeks, days: days, hours: hours, minutes: minutes, seconds: seconds }) {
    let totalDays = 0;
    if (years) totalDays += years * $9e66e67751f962b4$export$3913210603d8e9ae;
    if (months) totalDays += months * ($9e66e67751f962b4$export$3913210603d8e9ae / 12);
    if (weeks) totalDays += weeks * 7;
    if (days) totalDays += days;
    let totalSeconds = totalDays * 86400;
    if (hours) totalSeconds += hours * 3600;
    if (minutes) totalSeconds += minutes * 60;
    if (seconds) totalSeconds += seconds;
    return Math.trunc(totalSeconds * 1000);
}


Object.keys($bd48b5a22f9e7020$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $bd48b5a22f9e7020$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $bd48b5a22f9e7020$exports[key];
        }
    });
});
var $2ad54bc331417420$exports = {};

$parcel$export($2ad54bc331417420$exports, "millisecondsToHours", function () { return $2ad54bc331417420$export$689a412b29fa9ed5; }, function (v) { return $2ad54bc331417420$export$689a412b29fa9ed5 = v; });
var $2ad54bc331417420$export$689a412b29fa9ed5;
"use strict";
$2ad54bc331417420$export$689a412b29fa9ed5 = $2ad54bc331417420$var$millisecondsToHours;

/**
 * @name millisecondsToHours
 * @category Conversion Helpers
 * @summary Convert milliseconds to hours.
 *
 * @description
 * Convert a number of milliseconds to a full number of hours.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in hours
 *
 * @example
 * // Convert 7200000 milliseconds to hours:
 * const result = millisecondsToHours(7200000)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToHours(7199999)
 * //=> 1
 */ function $2ad54bc331417420$var$millisecondsToHours(milliseconds) {
    const hours = milliseconds / $9e66e67751f962b4$export$7f72910d6dfd237a;
    return Math.trunc(hours);
}


Object.keys($2ad54bc331417420$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $2ad54bc331417420$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $2ad54bc331417420$exports[key];
        }
    });
});
var $a75e25be20ce89d1$exports = {};

$parcel$export($a75e25be20ce89d1$exports, "millisecondsToMinutes", function () { return $a75e25be20ce89d1$export$a5f974e81e48cfc0; }, function (v) { return $a75e25be20ce89d1$export$a5f974e81e48cfc0 = v; });
var $a75e25be20ce89d1$export$a5f974e81e48cfc0;
"use strict";
$a75e25be20ce89d1$export$a5f974e81e48cfc0 = $a75e25be20ce89d1$var$millisecondsToMinutes;

/**
 * @name millisecondsToMinutes
 * @category Conversion Helpers
 * @summary Convert milliseconds to minutes.
 *
 * @description
 * Convert a number of milliseconds to a full number of minutes.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in minutes
 *
 * @example
 * // Convert 60000 milliseconds to minutes:
 * const result = millisecondsToMinutes(60000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToMinutes(119999)
 * //=> 1
 */ function $a75e25be20ce89d1$var$millisecondsToMinutes(milliseconds) {
    const minutes = milliseconds / $9e66e67751f962b4$export$91246f0b9bd9beff;
    return Math.trunc(minutes);
}


Object.keys($a75e25be20ce89d1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $a75e25be20ce89d1$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $a75e25be20ce89d1$exports[key];
        }
    });
});
var $99f7ca0d36f0b86d$exports = {};

$parcel$export($99f7ca0d36f0b86d$exports, "millisecondsToSeconds", function () { return $99f7ca0d36f0b86d$export$f64c3bfbc58eec0f; }, function (v) { return $99f7ca0d36f0b86d$export$f64c3bfbc58eec0f = v; });
var $99f7ca0d36f0b86d$export$f64c3bfbc58eec0f;
"use strict";
$99f7ca0d36f0b86d$export$f64c3bfbc58eec0f = $99f7ca0d36f0b86d$var$millisecondsToSeconds;

/**
 * @name millisecondsToSeconds
 * @category Conversion Helpers
 * @summary Convert milliseconds to seconds.
 *
 * @description
 * Convert a number of milliseconds to a full number of seconds.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in seconds
 *
 * @example
 * // Convert 1000 miliseconds to seconds:
 * const result = millisecondsToSeconds(1000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToSeconds(1999)
 * //=> 1
 */ function $99f7ca0d36f0b86d$var$millisecondsToSeconds(milliseconds) {
    const seconds = milliseconds / $9e66e67751f962b4$export$397c2d5776aa9055;
    return Math.trunc(seconds);
}


Object.keys($99f7ca0d36f0b86d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $99f7ca0d36f0b86d$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $99f7ca0d36f0b86d$exports[key];
        }
    });
});

Object.keys($d0dbe3d0d14a0124$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $d0dbe3d0d14a0124$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $d0dbe3d0d14a0124$exports[key];
        }
    });
});
var $5f9280256695f300$exports = {};

$parcel$export($5f9280256695f300$exports, "minutesToHours", function () { return $5f9280256695f300$export$815164eb42530ae7; }, function (v) { return $5f9280256695f300$export$815164eb42530ae7 = v; });
var $5f9280256695f300$export$815164eb42530ae7;
"use strict";
$5f9280256695f300$export$815164eb42530ae7 = $5f9280256695f300$var$minutesToHours;

/**
 * @name minutesToHours
 * @category Conversion Helpers
 * @summary Convert minutes to hours.
 *
 * @description
 * Convert a number of minutes to a full number of hours.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in hours
 *
 * @example
 * // Convert 140 minutes to hours:
 * const result = minutesToHours(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = minutesToHours(179)
 * //=> 2
 */ function $5f9280256695f300$var$minutesToHours(minutes) {
    const hours = minutes / $9e66e67751f962b4$export$f2f5ae5a8e2d8f9f;
    return Math.trunc(hours);
}


Object.keys($5f9280256695f300$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $5f9280256695f300$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $5f9280256695f300$exports[key];
        }
    });
});
var $959621d55aa0515d$exports = {};

$parcel$export($959621d55aa0515d$exports, "minutesToMilliseconds", function () { return $959621d55aa0515d$export$f6b9795ef9056e3d; }, function (v) { return $959621d55aa0515d$export$f6b9795ef9056e3d = v; });
var $959621d55aa0515d$export$f6b9795ef9056e3d;
"use strict";
$959621d55aa0515d$export$f6b9795ef9056e3d = $959621d55aa0515d$var$minutesToMilliseconds;

/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in milliseconds
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */ function $959621d55aa0515d$var$minutesToMilliseconds(minutes) {
    return Math.trunc(minutes * $9e66e67751f962b4$export$91246f0b9bd9beff);
}


Object.keys($959621d55aa0515d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $959621d55aa0515d$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $959621d55aa0515d$exports[key];
        }
    });
});
var $b791dbe934672532$exports = {};

$parcel$export($b791dbe934672532$exports, "minutesToSeconds", function () { return $b791dbe934672532$export$81ded4628c655103; }, function (v) { return $b791dbe934672532$export$81ded4628c655103 = v; });
var $b791dbe934672532$export$81ded4628c655103;
"use strict";
$b791dbe934672532$export$81ded4628c655103 = $b791dbe934672532$var$minutesToSeconds;

/**
 * @name minutesToSeconds
 * @category Conversion Helpers
 * @summary Convert minutes to seconds.
 *
 * @description
 * Convert a number of minutes to a full number of seconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in seconds
 *
 * @example
 * // Convert 2 minutes to seconds
 * const result = minutesToSeconds(2)
 * //=> 120
 */ function $b791dbe934672532$var$minutesToSeconds(minutes) {
    return Math.trunc(minutes * $9e66e67751f962b4$export$a77c1a7ebebe2a5a);
}


Object.keys($b791dbe934672532$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $b791dbe934672532$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $b791dbe934672532$exports[key];
        }
    });
});
var $36a29998095797a9$exports = {};

$parcel$export($36a29998095797a9$exports, "monthsToQuarters", function () { return $36a29998095797a9$export$1932fa2a2068c849; }, function (v) { return $36a29998095797a9$export$1932fa2a2068c849 = v; });
var $36a29998095797a9$export$1932fa2a2068c849;
"use strict";
$36a29998095797a9$export$1932fa2a2068c849 = $36a29998095797a9$var$monthsToQuarters;

/**
 * @name monthsToQuarters
 * @category Conversion Helpers
 * @summary Convert number of months to quarters.
 *
 * @description
 * Convert a number of months to a full number of quarters.
 *
 * @param months - The number of months to be converted.
 *
 * @returns The number of months converted in quarters
 *
 * @example
 * // Convert 6 months to quarters:
 * const result = monthsToQuarters(6)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = monthsToQuarters(7)
 * //=> 2
 */ function $36a29998095797a9$var$monthsToQuarters(months) {
    const quarters = months / $9e66e67751f962b4$export$3c58128db900d44e;
    return Math.trunc(quarters);
}


Object.keys($36a29998095797a9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $36a29998095797a9$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $36a29998095797a9$exports[key];
        }
    });
});
var $591c3056fad682cc$exports = {};

$parcel$export($591c3056fad682cc$exports, "monthsToYears", function () { return $591c3056fad682cc$export$7489026ed27fc925; }, function (v) { return $591c3056fad682cc$export$7489026ed27fc925 = v; });
var $591c3056fad682cc$export$7489026ed27fc925;
"use strict";
$591c3056fad682cc$export$7489026ed27fc925 = $591c3056fad682cc$var$monthsToYears;

/**
 * @name monthsToYears
 * @category Conversion Helpers
 * @summary Convert number of months to years.
 *
 * @description
 * Convert a number of months to a full number of years.
 *
 * @param months - The number of months to be converted
 *
 * @returns The number of months converted in years
 *
 * @example
 * // Convert 36 months to years:
 * const result = monthsToYears(36)
 * //=> 3
 *
 * // It uses floor rounding:
 * const result = monthsToYears(40)
 * //=> 3
 */ function $591c3056fad682cc$var$monthsToYears(months) {
    const years = months / $9e66e67751f962b4$export$80d7e435f744f319;
    return Math.trunc(years);
}


Object.keys($591c3056fad682cc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $591c3056fad682cc$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $591c3056fad682cc$exports[key];
        }
    });
});
var $2fad77a0d4817bce$exports = {};

$parcel$export($2fad77a0d4817bce$exports, "nextDay", function () { return $2fad77a0d4817bce$export$992728922317ffc8; }, function (v) { return $2fad77a0d4817bce$export$992728922317ffc8 = v; });
var $2fad77a0d4817bce$export$992728922317ffc8;
"use strict";
$2fad77a0d4817bce$export$992728922317ffc8 = $2fad77a0d4817bce$var$nextDay;


/**
 * @name nextDay
 * @category Weekday Helpers
 * @summary When is the next day of the week?
 *
 * @description
 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - day of the week
 *
 * @returns The date is the next day of week
 *
 * @example
 * // When is the next Monday after Mar, 20, 2020?
 * const result = nextDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 23 2020 00:00:00
 *
 * @example
 * // When is the next Tuesday after Mar, 21, 2020?
 * const result = nextDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 24 2020 00:00:00
 */ function $2fad77a0d4817bce$var$nextDay(date, day) {
    let delta = day - (0, $34139301a572f1c6$export$1b64bc9c5306ed54)(date);
    if (delta <= 0) delta += 7;
    return (0, $b7f6bbd55167ab46$export$dd412b56f1e4d8aa)(date, delta);
}


Object.keys($2fad77a0d4817bce$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $2fad77a0d4817bce$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $2fad77a0d4817bce$exports[key];
        }
    });
});
var $a4436c140005bc16$exports = {};

$parcel$export($a4436c140005bc16$exports, "nextFriday", function () { return $a4436c140005bc16$export$21d76934fce76327; }, function (v) { return $a4436c140005bc16$export$21d76934fce76327 = v; });
var $a4436c140005bc16$export$21d76934fce76327;
"use strict";
$a4436c140005bc16$export$21d76934fce76327 = $a4436c140005bc16$var$nextFriday;

/**
 * @name nextFriday
 * @category Weekday Helpers
 * @summary When is the next Friday?
 *
 * @description
 * When is the next Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Friday
 *
 * @example
 * // When is the next Friday after Mar, 22, 2020?
 * const result = nextFriday(new Date(2020, 2, 22))
 * //=> Fri Mar 27 2020 00:00:00
 */ function $a4436c140005bc16$var$nextFriday(date) {
    return (0, $2fad77a0d4817bce$export$992728922317ffc8)(date, 5);
}


Object.keys($a4436c140005bc16$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $a4436c140005bc16$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $a4436c140005bc16$exports[key];
        }
    });
});
var $0a911e792c35b76e$exports = {};

$parcel$export($0a911e792c35b76e$exports, "nextMonday", function () { return $0a911e792c35b76e$export$a20373bb0df6efdd; }, function (v) { return $0a911e792c35b76e$export$a20373bb0df6efdd = v; });
var $0a911e792c35b76e$export$a20373bb0df6efdd;
"use strict";
$0a911e792c35b76e$export$a20373bb0df6efdd = $0a911e792c35b76e$var$nextMonday;

/**
 * @name nextMonday
 * @category Weekday Helpers
 * @summary When is the next Monday?
 *
 * @description
 * When is the next Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Monday
 *
 * @example
 * // When is the next Monday after Mar, 22, 2020?
 * const result = nextMonday(new Date(2020, 2, 22))
 * //=> Mon Mar 23 2020 00:00:00
 */ function $0a911e792c35b76e$var$nextMonday(date) {
    return (0, $2fad77a0d4817bce$export$992728922317ffc8)(date, 1);
}


Object.keys($0a911e792c35b76e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $0a911e792c35b76e$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $0a911e792c35b76e$exports[key];
        }
    });
});
var $688f93e02604f493$exports = {};

$parcel$export($688f93e02604f493$exports, "nextSaturday", function () { return $688f93e02604f493$export$c52f069246f7b032; }, function (v) { return $688f93e02604f493$export$c52f069246f7b032 = v; });
var $688f93e02604f493$export$c52f069246f7b032;
"use strict";
$688f93e02604f493$export$c52f069246f7b032 = $688f93e02604f493$var$nextSaturday;

/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Saturday
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */ function $688f93e02604f493$var$nextSaturday(date) {
    return (0, $2fad77a0d4817bce$export$992728922317ffc8)(date, 6);
}


Object.keys($688f93e02604f493$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $688f93e02604f493$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $688f93e02604f493$exports[key];
        }
    });
});
var $33bc3f0b193fecb7$exports = {};

$parcel$export($33bc3f0b193fecb7$exports, "nextSunday", function () { return $33bc3f0b193fecb7$export$a30adaa3ef47f854; }, function (v) { return $33bc3f0b193fecb7$export$a30adaa3ef47f854 = v; });
var $33bc3f0b193fecb7$export$a30adaa3ef47f854;
"use strict";
$33bc3f0b193fecb7$export$a30adaa3ef47f854 = $33bc3f0b193fecb7$var$nextSunday;

/**
 * @name nextSunday
 * @category Weekday Helpers
 * @summary When is the next Sunday?
 *
 * @description
 * When is the next Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Sunday
 *
 * @example
 * // When is the next Sunday after Mar, 22, 2020?
 * const result = nextSunday(new Date(2020, 2, 22))
 * //=> Sun Mar 29 2020 00:00:00
 */ function $33bc3f0b193fecb7$var$nextSunday(date) {
    return (0, $2fad77a0d4817bce$export$992728922317ffc8)(date, 0);
}


Object.keys($33bc3f0b193fecb7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $33bc3f0b193fecb7$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $33bc3f0b193fecb7$exports[key];
        }
    });
});
var $6fc398899cb895a5$exports = {};

$parcel$export($6fc398899cb895a5$exports, "nextThursday", function () { return $6fc398899cb895a5$export$36d9a8523a98d5a4; }, function (v) { return $6fc398899cb895a5$export$36d9a8523a98d5a4 = v; });
var $6fc398899cb895a5$export$36d9a8523a98d5a4;
"use strict";
$6fc398899cb895a5$export$36d9a8523a98d5a4 = $6fc398899cb895a5$var$nextThursday;

/**
 * @name nextThursday
 * @category Weekday Helpers
 * @summary When is the next Thursday?
 *
 * @description
 * When is the next Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Thursday
 *
 * @example
 * // When is the next Thursday after Mar, 22, 2020?
 * const result = nextThursday(new Date(2020, 2, 22))
 * //=> Thur Mar 26 2020 00:00:00
 */ function $6fc398899cb895a5$var$nextThursday(date) {
    return (0, $2fad77a0d4817bce$export$992728922317ffc8)(date, 4);
}


Object.keys($6fc398899cb895a5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $6fc398899cb895a5$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $6fc398899cb895a5$exports[key];
        }
    });
});
var $b9f47d2d9354a991$exports = {};

$parcel$export($b9f47d2d9354a991$exports, "nextTuesday", function () { return $b9f47d2d9354a991$export$391d63ff7dc2f668; }, function (v) { return $b9f47d2d9354a991$export$391d63ff7dc2f668 = v; });
var $b9f47d2d9354a991$export$391d63ff7dc2f668;
"use strict";
$b9f47d2d9354a991$export$391d63ff7dc2f668 = $b9f47d2d9354a991$var$nextTuesday;

/**
 * @name nextTuesday
 * @category Weekday Helpers
 * @summary When is the next Tuesday?
 *
 * @description
 * When is the next Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Tuesday
 *
 * @example
 * // When is the next Tuesday after Mar, 22, 2020?
 * const result = nextTuesday(new Date(2020, 2, 22))
 * //=> Tue Mar 24 2020 00:00:00
 */ function $b9f47d2d9354a991$var$nextTuesday(date) {
    return (0, $2fad77a0d4817bce$export$992728922317ffc8)(date, 2);
}


Object.keys($b9f47d2d9354a991$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $b9f47d2d9354a991$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $b9f47d2d9354a991$exports[key];
        }
    });
});
var $92d60e215b399fcb$exports = {};

$parcel$export($92d60e215b399fcb$exports, "nextWednesday", function () { return $92d60e215b399fcb$export$7a895c1ff204304e; }, function (v) { return $92d60e215b399fcb$export$7a895c1ff204304e = v; });
var $92d60e215b399fcb$export$7a895c1ff204304e;
"use strict";
$92d60e215b399fcb$export$7a895c1ff204304e = $92d60e215b399fcb$var$nextWednesday;

/**
 * @name nextWednesday
 * @category Weekday Helpers
 * @summary When is the next Wednesday?
 *
 * @description
 * When is the next Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Wednesday
 *
 * @example
 * // When is the next Wednesday after Mar, 22, 2020?
 * const result = nextWednesday(new Date(2020, 2, 22))
 * //=> Wed Mar 25 2020 00:00:00
 */ function $92d60e215b399fcb$var$nextWednesday(date) {
    return (0, $2fad77a0d4817bce$export$992728922317ffc8)(date, 3);
}


Object.keys($92d60e215b399fcb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $92d60e215b399fcb$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $92d60e215b399fcb$exports[key];
        }
    });
});

Object.keys($36c711f59b2e134f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $36c711f59b2e134f$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $36c711f59b2e134f$exports[key];
        }
    });
});
var $eccd6e78e87bd9eb$exports = {};

$parcel$export($eccd6e78e87bd9eb$exports, "parseISO", function () { return $eccd6e78e87bd9eb$export$4393d2ccbbedb219; }, function (v) { return $eccd6e78e87bd9eb$export$4393d2ccbbedb219 = v; });
var $eccd6e78e87bd9eb$export$4393d2ccbbedb219;
"use strict";
$eccd6e78e87bd9eb$export$4393d2ccbbedb219 = $eccd6e78e87bd9eb$var$parseISO;

/**
 * The {@link parseISO} function options.
 */ /**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */ function $eccd6e78e87bd9eb$var$parseISO(argument, options) {
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $eccd6e78e87bd9eb$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $eccd6e78e87bd9eb$var$parseYear(dateStrings.date, additionalDigits);
        date = $eccd6e78e87bd9eb$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    const timestamp = date.getTime();
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $eccd6e78e87bd9eb$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $eccd6e78e87bd9eb$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        const dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        const result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
const $eccd6e78e87bd9eb$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $eccd6e78e87bd9eb$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $eccd6e78e87bd9eb$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $eccd6e78e87bd9eb$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $eccd6e78e87bd9eb$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($eccd6e78e87bd9eb$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($eccd6e78e87bd9eb$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($eccd6e78e87bd9eb$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $eccd6e78e87bd9eb$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $eccd6e78e87bd9eb$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $eccd6e78e87bd9eb$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($eccd6e78e87bd9eb$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $eccd6e78e87bd9eb$var$parseDateUnit(captures[1]);
    const month = $eccd6e78e87bd9eb$var$parseDateUnit(captures[2]) - 1;
    const day = $eccd6e78e87bd9eb$var$parseDateUnit(captures[3]);
    const week = $eccd6e78e87bd9eb$var$parseDateUnit(captures[4]);
    const dayOfWeek = $eccd6e78e87bd9eb$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$eccd6e78e87bd9eb$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $eccd6e78e87bd9eb$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$eccd6e78e87bd9eb$var$validateDate(year, month, day) || !$eccd6e78e87bd9eb$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $eccd6e78e87bd9eb$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $eccd6e78e87bd9eb$var$parseTime(timeString) {
    const captures = timeString.match($eccd6e78e87bd9eb$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $eccd6e78e87bd9eb$var$parseTimeUnit(captures[1]);
    const minutes = $eccd6e78e87bd9eb$var$parseTimeUnit(captures[2]);
    const seconds = $eccd6e78e87bd9eb$var$parseTimeUnit(captures[3]);
    if (!$eccd6e78e87bd9eb$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * $9e66e67751f962b4$export$7f72910d6dfd237a + minutes * $9e66e67751f962b4$export$91246f0b9bd9beff + seconds * 1000;
}
function $eccd6e78e87bd9eb$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $eccd6e78e87bd9eb$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($eccd6e78e87bd9eb$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$eccd6e78e87bd9eb$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * $9e66e67751f962b4$export$7f72910d6dfd237a + minutes * $9e66e67751f962b4$export$91246f0b9bd9beff);
}
function $eccd6e78e87bd9eb$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $eccd6e78e87bd9eb$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $eccd6e78e87bd9eb$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $eccd6e78e87bd9eb$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($eccd6e78e87bd9eb$var$daysInMonths[month] || ($eccd6e78e87bd9eb$var$isLeapYearIndex(year) ? 29 : 28));
}
function $eccd6e78e87bd9eb$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($eccd6e78e87bd9eb$var$isLeapYearIndex(year) ? 366 : 365);
}
function $eccd6e78e87bd9eb$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $eccd6e78e87bd9eb$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $eccd6e78e87bd9eb$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}


Object.keys($eccd6e78e87bd9eb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $eccd6e78e87bd9eb$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $eccd6e78e87bd9eb$exports[key];
        }
    });
});
var $0707db2360b66bbd$exports = {};

$parcel$export($0707db2360b66bbd$exports, "parseJSON", function () { return $0707db2360b66bbd$export$27924e57e9afff7f; }, function (v) { return $0707db2360b66bbd$export$27924e57e9afff7f = v; });
var $0707db2360b66bbd$export$27924e57e9afff7f;
"use strict";
$0707db2360b66bbd$export$27924e57e9afff7f = $0707db2360b66bbd$var$parseJSON; /**
 * @name parseJSON
 * @category Common Helpers
 * @summary Parse a JSON date string
 *
 * @description
 * Converts a complete ISO date string in UTC time, the typical format for transmitting
 * a date in JSON, to a JavaScript `Date` instance.
 *
 * This is a minimal implementation for converting dates retrieved from a JSON API to
 * a `Date` instance which can be used with other functions in the `date-fns` library.
 * The following formats are supported:
 *
 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
 * - `2000-03-15T05:20:10Z`: Without milliseconds
 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 *
 * For convenience and ease of use these other input types are also supported
 * via [toDate](https://date-fns.org/docs/toDate):
 *
 * - A `Date` instance will be cloned
 * - A `number` will be treated as a timestamp
 *
 * Any other input type or invalid date strings will return an `Invalid Date`.
 *
 * @param dateStr - A fully formed ISO8601 date string to convert
 *
 * @returns The parsed date in the local time zone
 */ 
function $0707db2360b66bbd$var$parseJSON(dateStr) {
    const parts = dateStr.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
    if (parts) // Group 8 matches the sign
    return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)));
    return new Date(NaN);
}


Object.keys($0707db2360b66bbd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $0707db2360b66bbd$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $0707db2360b66bbd$exports[key];
        }
    });
});
var $94b71231ba4f7839$exports = {};

$parcel$export($94b71231ba4f7839$exports, "previousDay", function () { return $94b71231ba4f7839$export$4caccb62df4eacc0; }, function (v) { return $94b71231ba4f7839$export$4caccb62df4eacc0 = v; });
var $94b71231ba4f7839$export$4caccb62df4eacc0;
"use strict";
$94b71231ba4f7839$export$4caccb62df4eacc0 = $94b71231ba4f7839$var$previousDay;


/**
 * @name previousDay
 * @category Weekday Helpers
 * @summary When is the previous day of the week?
 *
 * @description
 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - The day of the week
 *
 * @returns The date is the previous day of week
 *
 * @example
 * // When is the previous Monday before Mar, 20, 2020?
 * const result = previousDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 16 2020 00:00:00
 *
 * @example
 * // When is the previous Tuesday before Mar, 21, 2020?
 * const result = previousDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 17 2020 00:00:00
 */ function $94b71231ba4f7839$var$previousDay(date, day) {
    let delta = (0, $34139301a572f1c6$export$1b64bc9c5306ed54)(date) - day;
    if (delta <= 0) delta += 7;
    return (0, $1fa39d6f8b4fe4f0$export$70823084e2deb1ea)(date, delta);
}


Object.keys($94b71231ba4f7839$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $94b71231ba4f7839$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $94b71231ba4f7839$exports[key];
        }
    });
});
var $b2c871e423f13cab$exports = {};

$parcel$export($b2c871e423f13cab$exports, "previousFriday", function () { return $b2c871e423f13cab$export$32d52646c338c11d; }, function (v) { return $b2c871e423f13cab$export$32d52646c338c11d = v; });
var $b2c871e423f13cab$export$32d52646c338c11d;
"use strict";
$b2c871e423f13cab$export$32d52646c338c11d = $b2c871e423f13cab$var$previousFriday;

/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Friday
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */ function $b2c871e423f13cab$var$previousFriday(date) {
    return (0, $94b71231ba4f7839$export$4caccb62df4eacc0)(date, 5);
}


Object.keys($b2c871e423f13cab$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $b2c871e423f13cab$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $b2c871e423f13cab$exports[key];
        }
    });
});
var $20e7555cfdffec51$exports = {};

$parcel$export($20e7555cfdffec51$exports, "previousMonday", function () { return $20e7555cfdffec51$export$398437ab6f45c582; }, function (v) { return $20e7555cfdffec51$export$398437ab6f45c582 = v; });
var $20e7555cfdffec51$export$398437ab6f45c582;
"use strict";
$20e7555cfdffec51$export$398437ab6f45c582 = $20e7555cfdffec51$var$previousMonday;

/**
 * @name previousMonday
 * @category Weekday Helpers
 * @summary When is the previous Monday?
 *
 * @description
 * When is the previous Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Monday
 *
 * @example
 * // When is the previous Monday before Jun, 18, 2021?
 * const result = previousMonday(new Date(2021, 5, 18))
 * //=> Mon June 14 2021 00:00:00
 */ function $20e7555cfdffec51$var$previousMonday(date) {
    return (0, $94b71231ba4f7839$export$4caccb62df4eacc0)(date, 1);
}


Object.keys($20e7555cfdffec51$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $20e7555cfdffec51$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $20e7555cfdffec51$exports[key];
        }
    });
});
var $ec4ec376abfa7908$exports = {};

$parcel$export($ec4ec376abfa7908$exports, "previousSaturday", function () { return $ec4ec376abfa7908$export$36767a7e6101ecb0; }, function (v) { return $ec4ec376abfa7908$export$36767a7e6101ecb0 = v; });
var $ec4ec376abfa7908$export$36767a7e6101ecb0;
"use strict";
$ec4ec376abfa7908$export$36767a7e6101ecb0 = $ec4ec376abfa7908$var$previousSaturday;

/**
 * @name previousSaturday
 * @category Weekday Helpers
 * @summary When is the previous Saturday?
 *
 * @description
 * When is the previous Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Saturday
 *
 * @example
 * // When is the previous Saturday before Jun, 20, 2021?
 * const result = previousSaturday(new Date(2021, 5, 20))
 * //=> Sat June 19 2021 00:00:00
 */ function $ec4ec376abfa7908$var$previousSaturday(date) {
    return (0, $94b71231ba4f7839$export$4caccb62df4eacc0)(date, 6);
}


Object.keys($ec4ec376abfa7908$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $ec4ec376abfa7908$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $ec4ec376abfa7908$exports[key];
        }
    });
});
var $bda4a9d3b2b549d6$exports = {};

$parcel$export($bda4a9d3b2b549d6$exports, "previousSunday", function () { return $bda4a9d3b2b549d6$export$7d3d7d8fc5e81fd4; }, function (v) { return $bda4a9d3b2b549d6$export$7d3d7d8fc5e81fd4 = v; });
var $bda4a9d3b2b549d6$export$7d3d7d8fc5e81fd4;
"use strict";
$bda4a9d3b2b549d6$export$7d3d7d8fc5e81fd4 = $bda4a9d3b2b549d6$var$previousSunday;

/**
 * @name previousSunday
 * @category Weekday Helpers
 * @summary When is the previous Sunday?
 *
 * @description
 * When is the previous Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Sunday
 *
 * @example
 * // When is the previous Sunday before Jun, 21, 2021?
 * const result = previousSunday(new Date(2021, 5, 21))
 * //=> Sun June 20 2021 00:00:00
 */ function $bda4a9d3b2b549d6$var$previousSunday(date) {
    return (0, $94b71231ba4f7839$export$4caccb62df4eacc0)(date, 0);
}


Object.keys($bda4a9d3b2b549d6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $bda4a9d3b2b549d6$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $bda4a9d3b2b549d6$exports[key];
        }
    });
});
var $7705236a147aaaa5$exports = {};

$parcel$export($7705236a147aaaa5$exports, "previousThursday", function () { return $7705236a147aaaa5$export$1975b5b1f6b0e34e; }, function (v) { return $7705236a147aaaa5$export$1975b5b1f6b0e34e = v; });
var $7705236a147aaaa5$export$1975b5b1f6b0e34e;
"use strict";
$7705236a147aaaa5$export$1975b5b1f6b0e34e = $7705236a147aaaa5$var$previousThursday;

/**
 * @name previousThursday
 * @category Weekday Helpers
 * @summary When is the previous Thursday?
 *
 * @description
 * When is the previous Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Thursday
 *
 * @example
 * // When is the previous Thursday before Jun, 18, 2021?
 * const result = previousThursday(new Date(2021, 5, 18))
 * //=> Thu June 17 2021 00:00:00
 */ function $7705236a147aaaa5$var$previousThursday(date) {
    return (0, $94b71231ba4f7839$export$4caccb62df4eacc0)(date, 4);
}


Object.keys($7705236a147aaaa5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $7705236a147aaaa5$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $7705236a147aaaa5$exports[key];
        }
    });
});
var $00227c71f4ad7424$exports = {};

$parcel$export($00227c71f4ad7424$exports, "previousTuesday", function () { return $00227c71f4ad7424$export$a034a75f093bcfaf; }, function (v) { return $00227c71f4ad7424$export$a034a75f093bcfaf = v; });
var $00227c71f4ad7424$export$a034a75f093bcfaf;
"use strict";
$00227c71f4ad7424$export$a034a75f093bcfaf = $00227c71f4ad7424$var$previousTuesday;

/**
 * @name previousTuesday
 * @category Weekday Helpers
 * @summary When is the previous Tuesday?
 *
 * @description
 * When is the previous Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Tuesday
 *
 * @example
 * // When is the previous Tuesday before Jun, 18, 2021?
 * const result = previousTuesday(new Date(2021, 5, 18))
 * //=> Tue June 15 2021 00:00:00
 */ function $00227c71f4ad7424$var$previousTuesday(date) {
    return (0, $94b71231ba4f7839$export$4caccb62df4eacc0)(date, 2);
}


Object.keys($00227c71f4ad7424$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $00227c71f4ad7424$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $00227c71f4ad7424$exports[key];
        }
    });
});
var $39ad7d1b8d134de7$exports = {};

$parcel$export($39ad7d1b8d134de7$exports, "previousWednesday", function () { return $39ad7d1b8d134de7$export$26334f591e4ce672; }, function (v) { return $39ad7d1b8d134de7$export$26334f591e4ce672 = v; });
var $39ad7d1b8d134de7$export$26334f591e4ce672;
"use strict";
$39ad7d1b8d134de7$export$26334f591e4ce672 = $39ad7d1b8d134de7$var$previousWednesday;

/**
 * @name previousWednesday
 * @category Weekday Helpers
 * @summary When is the previous Wednesday?
 *
 * @description
 * When is the previous Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Wednesday
 *
 * @example
 * // When is the previous Wednesday before Jun, 18, 2021?
 * const result = previousWednesday(new Date(2021, 5, 18))
 * //=> Wed June 16 2021 00:00:00
 */ function $39ad7d1b8d134de7$var$previousWednesday(date) {
    return (0, $94b71231ba4f7839$export$4caccb62df4eacc0)(date, 3);
}


Object.keys($39ad7d1b8d134de7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $39ad7d1b8d134de7$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $39ad7d1b8d134de7$exports[key];
        }
    });
});
var $da0fd0145436c38c$exports = {};

$parcel$export($da0fd0145436c38c$exports, "quartersToMonths", function () { return $da0fd0145436c38c$export$a29d19ce21d74c57; }, function (v) { return $da0fd0145436c38c$export$a29d19ce21d74c57 = v; });
var $da0fd0145436c38c$export$a29d19ce21d74c57;
"use strict";
$da0fd0145436c38c$export$a29d19ce21d74c57 = $da0fd0145436c38c$var$quartersToMonths;

/**
 * @name quartersToMonths
 * @category Conversion Helpers
 * @summary Convert number of quarters to months.
 *
 * @description
 * Convert a number of quarters to a full number of months.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in months
 *
 * @example
 * // Convert 2 quarters to months
 * const result = quartersToMonths(2)
 * //=> 6
 */ function $da0fd0145436c38c$var$quartersToMonths(quarters) {
    return Math.trunc(quarters * $9e66e67751f962b4$export$3c58128db900d44e);
}


Object.keys($da0fd0145436c38c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $da0fd0145436c38c$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $da0fd0145436c38c$exports[key];
        }
    });
});
var $4d89a266bc123342$exports = {};

$parcel$export($4d89a266bc123342$exports, "quartersToYears", function () { return $4d89a266bc123342$export$c309fa8f184b4648; }, function (v) { return $4d89a266bc123342$export$c309fa8f184b4648 = v; });
var $4d89a266bc123342$export$c309fa8f184b4648;
"use strict";
$4d89a266bc123342$export$c309fa8f184b4648 = $4d89a266bc123342$var$quartersToYears;

/**
 * @name quartersToYears
 * @category Conversion Helpers
 * @summary Convert number of quarters to years.
 *
 * @description
 * Convert a number of quarters to a full number of years.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in years
 *
 * @example
 * // Convert 8 quarters to years
 * const result = quartersToYears(8)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = quartersToYears(11)
 * //=> 2
 */ function $4d89a266bc123342$var$quartersToYears(quarters) {
    const years = quarters / $9e66e67751f962b4$export$4db7641526e3241f;
    return Math.trunc(years);
}


Object.keys($4d89a266bc123342$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $4d89a266bc123342$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $4d89a266bc123342$exports[key];
        }
    });
});
var $d2ebb8f5209c000e$exports = {};

$parcel$export($d2ebb8f5209c000e$exports, "roundToNearestHours", function () { return $d2ebb8f5209c000e$export$a8b87649ebc0e3c2; }, function (v) { return $d2ebb8f5209c000e$export$a8b87649ebc0e3c2 = v; });
var $d2ebb8f5209c000e$export$a8b87649ebc0e3c2;
"use strict";
$d2ebb8f5209c000e$export$a8b87649ebc0e3c2 = $d2ebb8f5209c000e$var$roundToNearestHours;



/**
 * The {@link roundToNearestHours} function options.
 */ /**
 * @name roundToNearestHours
 * @category Hour Helpers
 * @summary Rounds the given date to the nearest hour
 *
 * @description
 * Rounds the given date to the nearest hour (or number of hours).
 * Rounds up when the given date is exactly between the nearest round hours.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest hour
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56))
 * //=> Thu Jul 10 2014 13:00:00
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 6 })
 * //=> Thu Jul 10 2014 12:00:00

 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 8 })
 * //=> Thu Jul 10 2014 16:00:00

* @example
 * // Floor (rounds down) 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 1, 23, 45), { roundingMethod: 'ceil' })
 * //=> Thu Jul 10 2014 02:00:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:34:56 to nearest quarter hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { roundingMethod: 'floor', nearestTo: 8 })
 * //=> Thu Jul 10 2014 08:00:00
 */ function $d2ebb8f5209c000e$var$roundToNearestHours(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 12) return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, NaN);
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const fractionalMinutes = _date.getMinutes() / 60;
    const fractionalSeconds = _date.getSeconds() / 60 / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60 / 60;
    const hours = _date.getHours() + fractionalMinutes + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $a15b9f5338a2ad49$export$b6474a47258c1211)(method);
    // nearestTo option does not care daylight savings time
    const roundedHours = roundingMethod(hours / nearestTo) * nearestTo;
    const result = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, _date);
    result.setHours(roundedHours, 0, 0, 0);
    return result;
}


Object.keys($d2ebb8f5209c000e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $d2ebb8f5209c000e$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $d2ebb8f5209c000e$exports[key];
        }
    });
});
var $51df83d0962b6c77$exports = {};

$parcel$export($51df83d0962b6c77$exports, "roundToNearestMinutes", function () { return $51df83d0962b6c77$export$d97410bb8cd0dff; }, function (v) { return $51df83d0962b6c77$export$d97410bb8cd0dff = v; });
var $51df83d0962b6c77$export$d97410bb8cd0dff;
"use strict";
$51df83d0962b6c77$export$d97410bb8cd0dff = $51df83d0962b6c77$var$roundToNearestMinutes;



/**
 * The {@link roundToNearestMinutes} function options.
 */ /**
 * @name roundToNearestMinutes
 * @category Minute Helpers
 * @summary Rounds the given date to the nearest minute
 *
 * @description
 * Rounds the given date to the nearest minute (or number of minutes).
 * Rounds up when the given date is exactly between the nearest round minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest minute
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
 * //=> Thu Jul 10 2014 12:13:00
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest quarter hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
 * //=> Thu Jul 10 2014 12:15:00
 *
 * @example
 * // Floor (rounds down) 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'floor' })
 * //=> Thu Jul 10 2014 12:12:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:12:34 to nearest half hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'ceil', nearestTo: 30 })
 * //=> Thu Jul 10 2014 12:30:00
 */ function $51df83d0962b6c77$var$roundToNearestMinutes(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 30) return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, NaN);
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const fractionalSeconds = _date.getSeconds() / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60;
    const minutes = _date.getMinutes() + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $a15b9f5338a2ad49$export$b6474a47258c1211)(method);
    const roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
    const result = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, _date);
    result.setMinutes(roundedMinutes, 0, 0);
    return result;
}


Object.keys($51df83d0962b6c77$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $51df83d0962b6c77$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $51df83d0962b6c77$exports[key];
        }
    });
});
var $911fb0bd652e480b$exports = {};

$parcel$export($911fb0bd652e480b$exports, "secondsToHours", function () { return $911fb0bd652e480b$export$47d555ff5354096f; }, function (v) { return $911fb0bd652e480b$export$47d555ff5354096f = v; });
var $911fb0bd652e480b$export$47d555ff5354096f;
"use strict";
$911fb0bd652e480b$export$47d555ff5354096f = $911fb0bd652e480b$var$secondsToHours;

/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in hours
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */ function $911fb0bd652e480b$var$secondsToHours(seconds) {
    const hours = seconds / $9e66e67751f962b4$export$698aec755e92c695;
    return Math.trunc(hours);
}


Object.keys($911fb0bd652e480b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $911fb0bd652e480b$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $911fb0bd652e480b$exports[key];
        }
    });
});
var $3c155feb10b1c2b1$exports = {};

$parcel$export($3c155feb10b1c2b1$exports, "secondsToMilliseconds", function () { return $3c155feb10b1c2b1$export$fc3e7e8557f8c8c7; }, function (v) { return $3c155feb10b1c2b1$export$fc3e7e8557f8c8c7 = v; });
var $3c155feb10b1c2b1$export$fc3e7e8557f8c8c7;
"use strict";
$3c155feb10b1c2b1$export$fc3e7e8557f8c8c7 = $3c155feb10b1c2b1$var$secondsToMilliseconds;

/**
 * @name secondsToMilliseconds
 * @category Conversion Helpers
 * @summary Convert seconds to milliseconds.
 *
 * @description
 * Convert a number of seconds to a full number of milliseconds.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in milliseconds
 *
 * @example
 * // Convert 2 seconds into milliseconds
 * const result = secondsToMilliseconds(2)
 * //=> 2000
 */ function $3c155feb10b1c2b1$var$secondsToMilliseconds(seconds) {
    return seconds * $9e66e67751f962b4$export$397c2d5776aa9055;
}


Object.keys($3c155feb10b1c2b1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $3c155feb10b1c2b1$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $3c155feb10b1c2b1$exports[key];
        }
    });
});
var $d460d998a631a1fe$exports = {};

$parcel$export($d460d998a631a1fe$exports, "secondsToMinutes", function () { return $d460d998a631a1fe$export$ed657adb62398e99; }, function (v) { return $d460d998a631a1fe$export$ed657adb62398e99 = v; });
var $d460d998a631a1fe$export$ed657adb62398e99;
"use strict";
$d460d998a631a1fe$export$ed657adb62398e99 = $d460d998a631a1fe$var$secondsToMinutes;

/**
 * @name secondsToMinutes
 * @category Conversion Helpers
 * @summary Convert seconds to minutes.
 *
 * @description
 * Convert a number of seconds to a full number of minutes.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in minutes
 *
 * @example
 * // Convert 120 seconds into minutes
 * const result = secondsToMinutes(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToMinutes(119)
 * //=> 1
 */ function $d460d998a631a1fe$var$secondsToMinutes(seconds) {
    const minutes = seconds / $9e66e67751f962b4$export$a77c1a7ebebe2a5a;
    return Math.trunc(minutes);
}


Object.keys($d460d998a631a1fe$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $d460d998a631a1fe$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $d460d998a631a1fe$exports[key];
        }
    });
});
var $366d14de0a909e52$exports = {};

$parcel$export($366d14de0a909e52$exports, "set", function () { return $366d14de0a909e52$export$adaa4cf7ef1b65be; }, function (v) { return $366d14de0a909e52$export$adaa4cf7ef1b65be = v; });
var $366d14de0a909e52$export$adaa4cf7ef1b65be;
"use strict";
$366d14de0a909e52$export$adaa4cf7ef1b65be = $366d14de0a909e52$var$set;

var $be49f4fbef22962e$exports = {};

$parcel$export($be49f4fbef22962e$exports, "setMonth", function () { return $be49f4fbef22962e$export$63264690f8e36790; }, function (v) { return $be49f4fbef22962e$export$63264690f8e36790 = v; });
var $be49f4fbef22962e$export$63264690f8e36790;
"use strict";
$be49f4fbef22962e$export$63264690f8e36790 = $be49f4fbef22962e$var$setMonth;



/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ function $be49f4fbef22962e$var$setMonth(date, month) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const dateWithDesiredMonth = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, 0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $affa5299a1212e4c$export$f645ddd439eb259d)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}



/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param values - The date values to be set
 *
 * @returns The new date with options set
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */ function $366d14de0a909e52$var$set(date, values) {
    let _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, NaN);
    if (values.year != null) _date.setFullYear(values.year);
    if (values.month != null) _date = (0, $be49f4fbef22962e$export$63264690f8e36790)(_date, values.month);
    if (values.date != null) _date.setDate(values.date);
    if (values.hours != null) _date.setHours(values.hours);
    if (values.minutes != null) _date.setMinutes(values.minutes);
    if (values.seconds != null) _date.setSeconds(values.seconds);
    if (values.milliseconds != null) _date.setMilliseconds(values.milliseconds);
    return _date;
}


Object.keys($366d14de0a909e52$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $366d14de0a909e52$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $366d14de0a909e52$exports[key];
        }
    });
});
var $782cfedde0ed24cb$exports = {};

$parcel$export($782cfedde0ed24cb$exports, "setDate", function () { return $782cfedde0ed24cb$export$566174fa40823587; }, function (v) { return $782cfedde0ed24cb$export$566174fa40823587 = v; });
var $782cfedde0ed24cb$export$566174fa40823587;
"use strict";
$782cfedde0ed24cb$export$566174fa40823587 = $782cfedde0ed24cb$var$setDate;

/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfMonth - The day of the month of the new date
 *
 * @returns The new date with the day of the month set
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */ function $782cfedde0ed24cb$var$setDate(date, dayOfMonth) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    _date.setDate(dayOfMonth);
    return _date;
}


Object.keys($782cfedde0ed24cb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $782cfedde0ed24cb$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $782cfedde0ed24cb$exports[key];
        }
    });
});

Object.keys($c5ed626fa0e5b3e7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $c5ed626fa0e5b3e7$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $c5ed626fa0e5b3e7$exports[key];
        }
    });
});
var $eb66c0c0e31d4b6b$exports = {};

$parcel$export($eb66c0c0e31d4b6b$exports, "setDayOfYear", function () { return $eb66c0c0e31d4b6b$export$2af590ffc7e7d7c5; }, function (v) { return $eb66c0c0e31d4b6b$export$2af590ffc7e7d7c5 = v; });
var $eb66c0c0e31d4b6b$export$2af590ffc7e7d7c5;
"use strict";
$eb66c0c0e31d4b6b$export$2af590ffc7e7d7c5 = $eb66c0c0e31d4b6b$var$setDayOfYear;

/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfYear - The day of the year of the new date
 *
 * @returns The new date with the day of the year set
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */ function $eb66c0c0e31d4b6b$var$setDayOfYear(date, dayOfYear) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    _date.setMonth(0);
    _date.setDate(dayOfYear);
    return _date;
}


Object.keys($eb66c0c0e31d4b6b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $eb66c0c0e31d4b6b$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $eb66c0c0e31d4b6b$exports[key];
        }
    });
});
var $1704f03b25661090$exports = {};

$parcel$export($1704f03b25661090$exports, "setDefaultOptions", function () { return $1704f03b25661090$export$95365be1b0704abc; }, function (v) { return $1704f03b25661090$export$95365be1b0704abc = v; });
var $1704f03b25661090$export$95365be1b0704abc;
"use strict";
$1704f03b25661090$export$95365be1b0704abc = $1704f03b25661090$var$setDefaultOptions;

/**
 * @name setDefaultOptions
 * @category Common Helpers
 * @summary Set default options including locale.
 * @pure false
 *
 * @description
 * Sets the defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * @param options - An object with options
 *
 * @example
 * // Set global locale:
 * import { es } from 'date-fns/locale'
 * setDefaultOptions({ locale: es })
 * const result = format(new Date(2014, 8, 2), 'PPPP')
 * //=> 'martes, 2 de septiembre de 2014'
 *
 * @example
 * // Start of the week for 2 September 2014:
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Start of the week for 2 September 2014,
 * // when we set that week starts on Monday by default:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Mon Sep 01 2014 00:00:00
 *
 * @example
 * // Manually set options take priority over default options:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Remove the option by setting it to `undefined`:
 * setDefaultOptions({ weekStartsOn: 1 })
 * setDefaultOptions({ weekStartsOn: undefined })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 */ function $1704f03b25661090$var$setDefaultOptions(options) {
    const result = {};
    const defaultOptions = (0, $0a8793ff6cad2441$export$430a3269e24b912e)();
    for(const property in defaultOptions)if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    result[property] = defaultOptions[property];
    for(const property in options)if (Object.prototype.hasOwnProperty.call(options, property)) {
        if (options[property] === undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        delete result[property];
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        result[property] = options[property];
    }
    (0, $0a8793ff6cad2441$export$95365be1b0704abc)(result);
}


Object.keys($1704f03b25661090$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $1704f03b25661090$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $1704f03b25661090$exports[key];
        }
    });
});
var $22e10ad9125690f9$exports = {};

$parcel$export($22e10ad9125690f9$exports, "setHours", function () { return $22e10ad9125690f9$export$f86b797a4659b781; }, function (v) { return $22e10ad9125690f9$export$f86b797a4659b781 = v; });
var $22e10ad9125690f9$export$f86b797a4659b781;
"use strict";
$22e10ad9125690f9$export$f86b797a4659b781 = $22e10ad9125690f9$var$setHours;

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */ function $22e10ad9125690f9$var$setHours(date, hours) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    _date.setHours(hours);
    return _date;
}


Object.keys($22e10ad9125690f9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $22e10ad9125690f9$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $22e10ad9125690f9$exports[key];
        }
    });
});

Object.keys($2ab80c521057ca48$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $2ab80c521057ca48$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $2ab80c521057ca48$exports[key];
        }
    });
});

Object.keys($01a3f91aa5f24276$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $01a3f91aa5f24276$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $01a3f91aa5f24276$exports[key];
        }
    });
});

Object.keys($2acea2762040099f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $2acea2762040099f$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $2acea2762040099f$exports[key];
        }
    });
});
var $f49bdb76a468de12$exports = {};

$parcel$export($f49bdb76a468de12$exports, "setMilliseconds", function () { return $f49bdb76a468de12$export$de5664029b35e06d; }, function (v) { return $f49bdb76a468de12$export$de5664029b35e06d = v; });
var $f49bdb76a468de12$export$de5664029b35e06d;
"use strict";
$f49bdb76a468de12$export$de5664029b35e06d = $f49bdb76a468de12$var$setMilliseconds;

/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param milliseconds - The milliseconds of the new date
 *
 * @returns The new date with the milliseconds set
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */ function $f49bdb76a468de12$var$setMilliseconds(date, milliseconds) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    _date.setMilliseconds(milliseconds);
    return _date;
}


Object.keys($f49bdb76a468de12$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $f49bdb76a468de12$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $f49bdb76a468de12$exports[key];
        }
    });
});
var $64af5edeea8e166d$exports = {};

$parcel$export($64af5edeea8e166d$exports, "setMinutes", function () { return $64af5edeea8e166d$export$ad569bf1c79ea89d; }, function (v) { return $64af5edeea8e166d$export$ad569bf1c79ea89d = v; });
var $64af5edeea8e166d$export$ad569bf1c79ea89d;
"use strict";
$64af5edeea8e166d$export$ad569bf1c79ea89d = $64af5edeea8e166d$var$setMinutes;

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */ function $64af5edeea8e166d$var$setMinutes(date, minutes) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    _date.setMinutes(minutes);
    return _date;
}


Object.keys($64af5edeea8e166d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $64af5edeea8e166d$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $64af5edeea8e166d$exports[key];
        }
    });
});

Object.keys($be49f4fbef22962e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $be49f4fbef22962e$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $be49f4fbef22962e$exports[key];
        }
    });
});
var $5376a56f98cae812$exports = {};

$parcel$export($5376a56f98cae812$exports, "setQuarter", function () { return $5376a56f98cae812$export$8924d1de7efe1755; }, function (v) { return $5376a56f98cae812$export$8924d1de7efe1755 = v; });
var $5376a56f98cae812$export$8924d1de7efe1755;
"use strict";
$5376a56f98cae812$export$8924d1de7efe1755 = $5376a56f98cae812$var$setQuarter;


/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param quarter - The quarter of the new date
 *
 * @returns The new date with the quarter set
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */ function $5376a56f98cae812$var$setQuarter(date, quarter) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
    const diff = quarter - oldQuarter;
    return (0, $be49f4fbef22962e$export$63264690f8e36790)(_date, _date.getMonth() + diff * 3);
}


Object.keys($5376a56f98cae812$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $5376a56f98cae812$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $5376a56f98cae812$exports[key];
        }
    });
});
var $3b55cae70b9c4819$exports = {};

$parcel$export($3b55cae70b9c4819$exports, "setSeconds", function () { return $3b55cae70b9c4819$export$aec44746644cbf43; }, function (v) { return $3b55cae70b9c4819$export$aec44746644cbf43 = v; });
var $3b55cae70b9c4819$export$aec44746644cbf43;
"use strict";
$3b55cae70b9c4819$export$aec44746644cbf43 = $3b55cae70b9c4819$var$setSeconds;

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */ function $3b55cae70b9c4819$var$setSeconds(date, seconds) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    _date.setSeconds(seconds);
    return _date;
}


Object.keys($3b55cae70b9c4819$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $3b55cae70b9c4819$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $3b55cae70b9c4819$exports[key];
        }
    });
});

Object.keys($cb243320054464f8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $cb243320054464f8$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $cb243320054464f8$exports[key];
        }
    });
});
var $2d0d65ec99518f27$exports = {};

$parcel$export($2d0d65ec99518f27$exports, "setWeekYear", function () { return $2d0d65ec99518f27$export$4340968d5939835e; }, function (v) { return $2d0d65ec99518f27$export$4340968d5939835e = v; });
var $2d0d65ec99518f27$export$4340968d5939835e;
"use strict";
$2d0d65ec99518f27$export$4340968d5939835e = $2d0d65ec99518f27$var$setWeekYear;





/**
 * The {@link setWeekYear} function options.
 */ /**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The local week-numbering year of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week-numbering year set
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */ function $2d0d65ec99518f27$var$setWeekYear(date, weekYear, options) {
    const defaultOptions = (0, $0a8793ff6cad2441$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    let _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const diff = (0, $bb6062a6bff69209$export$4a02e9c37dab4871)(_date, (0, $d1e02aa9a9900333$export$bb7b45bb8e74da0f)(_date, options));
    const firstWeek = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, 0);
    firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    _date = (0, $d1e02aa9a9900333$export$bb7b45bb8e74da0f)(firstWeek, options);
    _date.setDate(_date.getDate() + diff);
    return _date;
}


Object.keys($2d0d65ec99518f27$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $2d0d65ec99518f27$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $2d0d65ec99518f27$exports[key];
        }
    });
});
var $54d3f9e35cc38f2c$exports = {};

$parcel$export($54d3f9e35cc38f2c$exports, "setYear", function () { return $54d3f9e35cc38f2c$export$a8408b6c5639cab7; }, function (v) { return $54d3f9e35cc38f2c$export$a8408b6c5639cab7 = v; });
var $54d3f9e35cc38f2c$export$a8408b6c5639cab7;
"use strict";
$54d3f9e35cc38f2c$export$a8408b6c5639cab7 = $54d3f9e35cc38f2c$var$setYear;


/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */ function $54d3f9e35cc38f2c$var$setYear(date, year) {
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, NaN);
    _date.setFullYear(year);
    return _date;
}


Object.keys($54d3f9e35cc38f2c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $54d3f9e35cc38f2c$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $54d3f9e35cc38f2c$exports[key];
        }
    });
});

Object.keys($c21c29f68a61ba73$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $c21c29f68a61ba73$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $c21c29f68a61ba73$exports[key];
        }
    });
});
var $cc55a3af22e4ecc1$exports = {};

$parcel$export($cc55a3af22e4ecc1$exports, "startOfDecade", function () { return $cc55a3af22e4ecc1$export$730492981c634308; }, function (v) { return $cc55a3af22e4ecc1$export$730492981c634308 = v; });
var $cc55a3af22e4ecc1$export$730492981c634308;
"use strict";
$cc55a3af22e4ecc1$export$730492981c634308 = $cc55a3af22e4ecc1$var$startOfDecade;

/**
 * @name startOfDecade
 * @category Decade Helpers
 * @summary Return the start of a decade for the given date.
 *
 * @description
 * Return the start of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a decade
 *
 * @example
 * // The start of a decade for 21 October 2015 00:00:00:
 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
 * //=> Jan 01 2010 00:00:00
 */ function $cc55a3af22e4ecc1$var$startOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $838192f7942a2bce$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($cc55a3af22e4ecc1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $cc55a3af22e4ecc1$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $cc55a3af22e4ecc1$exports[key];
        }
    });
});

Object.keys($8ca89137925d43b1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $8ca89137925d43b1$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $8ca89137925d43b1$exports[key];
        }
    });
});

Object.keys($0ce4d92e449d76da$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $0ce4d92e449d76da$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $0ce4d92e449d76da$exports[key];
        }
    });
});

Object.keys($4ac098d276fcecdf$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $4ac098d276fcecdf$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $4ac098d276fcecdf$exports[key];
        }
    });
});

Object.keys($f7b7b7b4fe06340d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $f7b7b7b4fe06340d$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $f7b7b7b4fe06340d$exports[key];
        }
    });
});

Object.keys($ef4241263f1a03f4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $ef4241263f1a03f4$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $ef4241263f1a03f4$exports[key];
        }
    });
});

Object.keys($fc9398e6271fd192$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $fc9398e6271fd192$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $fc9398e6271fd192$exports[key];
        }
    });
});

Object.keys($4166e5777192872a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $4166e5777192872a$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $4166e5777192872a$exports[key];
        }
    });
});
var $40848d54e0709825$exports = {};

$parcel$export($40848d54e0709825$exports, "startOfToday", function () { return $40848d54e0709825$export$444d742fd5a45a57; }, function (v) { return $40848d54e0709825$export$444d742fd5a45a57 = v; });
var $40848d54e0709825$export$444d742fd5a45a57;
"use strict";
$40848d54e0709825$export$444d742fd5a45a57 = $40848d54e0709825$var$startOfToday;

/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * @returns The start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */ function $40848d54e0709825$var$startOfToday() {
    return (0, $c21c29f68a61ba73$export$63fa379ae8a9ba2)(Date.now());
}


Object.keys($40848d54e0709825$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $40848d54e0709825$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $40848d54e0709825$exports[key];
        }
    });
});
var $5c214e890289b4e0$exports = {};

$parcel$export($5c214e890289b4e0$exports, "startOfTomorrow", function () { return $5c214e890289b4e0$export$7e8566c79d5bee07; }, function (v) { return $5c214e890289b4e0$export$7e8566c79d5bee07 = v; });
var $5c214e890289b4e0$export$7e8566c79d5bee07;
"use strict";
$5c214e890289b4e0$export$7e8566c79d5bee07 = $5c214e890289b4e0$var$startOfTomorrow; /**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns The start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */ 
function $5c214e890289b4e0$var$startOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


Object.keys($5c214e890289b4e0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $5c214e890289b4e0$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $5c214e890289b4e0$exports[key];
        }
    });
});

Object.keys($cb6997e20defc27a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $cb6997e20defc27a$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $cb6997e20defc27a$exports[key];
        }
    });
});

Object.keys($d1e02aa9a9900333$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $d1e02aa9a9900333$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $d1e02aa9a9900333$exports[key];
        }
    });
});

Object.keys($ef984db75ccd03f4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $ef984db75ccd03f4$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $ef984db75ccd03f4$exports[key];
        }
    });
});
var $46d314df5c5e3c34$exports = {};

$parcel$export($46d314df5c5e3c34$exports, "startOfYesterday", function () { return $46d314df5c5e3c34$export$23a16f3c6d143ce9; }, function (v) { return $46d314df5c5e3c34$export$23a16f3c6d143ce9 = v; });
var $46d314df5c5e3c34$export$23a16f3c6d143ce9;
"use strict";
$46d314df5c5e3c34$export$23a16f3c6d143ce9 = $46d314df5c5e3c34$var$startOfYesterday; /**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns The start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */ 
function $46d314df5c5e3c34$var$startOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


Object.keys($46d314df5c5e3c34$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $46d314df5c5e3c34$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $46d314df5c5e3c34$exports[key];
        }
    });
});
var $8a21371a528fb5c7$exports = {};

$parcel$export($8a21371a528fb5c7$exports, "sub", function () { return $8a21371a528fb5c7$export$f93b5905241a7cca; }, function (v) { return $8a21371a528fb5c7$export$f93b5905241a7cca = v; });
var $8a21371a528fb5c7$export$f93b5905241a7cca;
"use strict";
$8a21371a528fb5c7$export$f93b5905241a7cca = $8a21371a528fb5c7$var$sub;

var $88699ee25f17259b$exports = {};

$parcel$export($88699ee25f17259b$exports, "subMonths", function () { return $88699ee25f17259b$export$73d1c15a21f9fae5; }, function (v) { return $88699ee25f17259b$export$73d1c15a21f9fae5 = v; });
var $88699ee25f17259b$export$73d1c15a21f9fae5;
"use strict";
$88699ee25f17259b$export$73d1c15a21f9fae5 = $88699ee25f17259b$var$subMonths;

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */ function $88699ee25f17259b$var$subMonths(date, amount) {
    return (0, $10d770831b44f8ad$export$17c93e242b2d3a22)(date, -amount);
}



/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */ function $8a21371a528fb5c7$var$sub(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Subtract years and months
    const dateWithoutMonths = (0, $88699ee25f17259b$export$73d1c15a21f9fae5)(date, months + years * 12);
    // Subtract weeks and days
    const dateWithoutDays = (0, $1fa39d6f8b4fe4f0$export$70823084e2deb1ea)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    const minutestoSub = minutes + hours * 60;
    const secondstoSub = seconds + minutestoSub * 60;
    const mstoSub = secondstoSub * 1000;
    const finalDate = (0, $4eb0d2dc0fda0973$export$ead8a1812b171991)(date, dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}


Object.keys($8a21371a528fb5c7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $8a21371a528fb5c7$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $8a21371a528fb5c7$exports[key];
        }
    });
});
var $3bcc0beb9ec25c2b$exports = {};

$parcel$export($3bcc0beb9ec25c2b$exports, "subBusinessDays", function () { return $3bcc0beb9ec25c2b$export$e5cc51ae28664a93; }, function (v) { return $3bcc0beb9ec25c2b$export$e5cc51ae28664a93 = v; });
var $3bcc0beb9ec25c2b$export$e5cc51ae28664a93;
"use strict";
$3bcc0beb9ec25c2b$export$e5cc51ae28664a93 = $3bcc0beb9ec25c2b$var$subBusinessDays;

/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be subtracted.
 *
 * @returns The new date with the business days subtracted
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */ function $3bcc0beb9ec25c2b$var$subBusinessDays(date, amount) {
    return (0, $854efe1653fa92e2$export$f087b9ada3136ae9)(date, -amount);
}


Object.keys($3bcc0beb9ec25c2b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $3bcc0beb9ec25c2b$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $3bcc0beb9ec25c2b$exports[key];
        }
    });
});

Object.keys($1fa39d6f8b4fe4f0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $1fa39d6f8b4fe4f0$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $1fa39d6f8b4fe4f0$exports[key];
        }
    });
});
var $85ad09eafe5969f8$exports = {};

$parcel$export($85ad09eafe5969f8$exports, "subHours", function () { return $85ad09eafe5969f8$export$5e9fa51cd5bb1e71; }, function (v) { return $85ad09eafe5969f8$export$5e9fa51cd5bb1e71 = v; });
var $85ad09eafe5969f8$export$5e9fa51cd5bb1e71;
"use strict";
$85ad09eafe5969f8$export$5e9fa51cd5bb1e71 = $85ad09eafe5969f8$var$subHours;

/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be subtracted.
 *
 * @returns The new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */ function $85ad09eafe5969f8$var$subHours(date, amount) {
    return (0, $68df478c21901624$export$4a4306ad4fa0e5e6)(date, -amount);
}


Object.keys($85ad09eafe5969f8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $85ad09eafe5969f8$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $85ad09eafe5969f8$exports[key];
        }
    });
});

Object.keys($7012e9ce223c4cd3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $7012e9ce223c4cd3$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $7012e9ce223c4cd3$exports[key];
        }
    });
});
var $1fa5f9683d519aa5$exports = {};

$parcel$export($1fa5f9683d519aa5$exports, "subMilliseconds", function () { return $1fa5f9683d519aa5$export$5abaf57ab8e91640; }, function (v) { return $1fa5f9683d519aa5$export$5abaf57ab8e91640 = v; });
var $1fa5f9683d519aa5$export$5abaf57ab8e91640;
"use strict";
$1fa5f9683d519aa5$export$5abaf57ab8e91640 = $1fa5f9683d519aa5$var$subMilliseconds;

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be subtracted.
 *
 * @returns The new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $1fa5f9683d519aa5$var$subMilliseconds(date, amount) {
    return (0, $f76650ee2db16d71$export$baf757aaf0c95c94)(date, -amount);
}


Object.keys($1fa5f9683d519aa5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $1fa5f9683d519aa5$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $1fa5f9683d519aa5$exports[key];
        }
    });
});
var $4841493135821e65$exports = {};

$parcel$export($4841493135821e65$exports, "subMinutes", function () { return $4841493135821e65$export$e12a970efb73fce5; }, function (v) { return $4841493135821e65$export$e12a970efb73fce5 = v; });
var $4841493135821e65$export$e12a970efb73fce5;
"use strict";
$4841493135821e65$export$e12a970efb73fce5 = $4841493135821e65$var$subMinutes;

/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be subtracted.
 *
 * @returns The new date with the minutes subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */ function $4841493135821e65$var$subMinutes(date, amount) {
    return (0, $f93c9629650c9d53$export$2287e3d29250119e)(date, -amount);
}


Object.keys($4841493135821e65$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $4841493135821e65$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $4841493135821e65$exports[key];
        }
    });
});

Object.keys($88699ee25f17259b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $88699ee25f17259b$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $88699ee25f17259b$exports[key];
        }
    });
});
var $057af009165aba63$exports = {};

$parcel$export($057af009165aba63$exports, "subQuarters", function () { return $057af009165aba63$export$a31bfeeeee80cce6; }, function (v) { return $057af009165aba63$export$a31bfeeeee80cce6 = v; });
var $057af009165aba63$export$a31bfeeeee80cce6;
"use strict";
$057af009165aba63$export$a31bfeeeee80cce6 = $057af009165aba63$var$subQuarters;

/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be subtracted.
 *
 * @returns The new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */ function $057af009165aba63$var$subQuarters(date, amount) {
    return (0, $ba4355b59e4c2ae3$export$c252a41d0fbed2ce)(date, -amount);
}


Object.keys($057af009165aba63$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $057af009165aba63$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $057af009165aba63$exports[key];
        }
    });
});
var $d6e7fa0803f51027$exports = {};

$parcel$export($d6e7fa0803f51027$exports, "subSeconds", function () { return $d6e7fa0803f51027$export$e95d8ad9981db689; }, function (v) { return $d6e7fa0803f51027$export$e95d8ad9981db689 = v; });
var $d6e7fa0803f51027$export$e95d8ad9981db689;
"use strict";
$d6e7fa0803f51027$export$e95d8ad9981db689 = $d6e7fa0803f51027$var$subSeconds;

/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be subtracted.
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */ function $d6e7fa0803f51027$var$subSeconds(date, amount) {
    return (0, $18d6cada2c50582b$export$3cb31b0df13be68)(date, -amount);
}


Object.keys($d6e7fa0803f51027$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $d6e7fa0803f51027$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $d6e7fa0803f51027$exports[key];
        }
    });
});
var $0c069164daf78537$exports = {};

$parcel$export($0c069164daf78537$exports, "subWeeks", function () { return $0c069164daf78537$export$b4d8ae6376193efb; }, function (v) { return $0c069164daf78537$export$b4d8ae6376193efb = v; });
var $0c069164daf78537$export$b4d8ae6376193efb;
"use strict";
$0c069164daf78537$export$b4d8ae6376193efb = $0c069164daf78537$var$subWeeks;

/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be subtracted.
 *
 * @returns The new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */ function $0c069164daf78537$var$subWeeks(date, amount) {
    return (0, $fddea87cb66f8480$export$ef501a2bb4f3ee6b)(date, -amount);
}


Object.keys($0c069164daf78537$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $0c069164daf78537$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $0c069164daf78537$exports[key];
        }
    });
});
var $a75e02943163ce31$exports = {};

$parcel$export($a75e02943163ce31$exports, "subYears", function () { return $a75e02943163ce31$export$14867687ff6c92e2; }, function (v) { return $a75e02943163ce31$export$14867687ff6c92e2 = v; });
var $a75e02943163ce31$export$14867687ff6c92e2;
"use strict";
$a75e02943163ce31$export$14867687ff6c92e2 = $a75e02943163ce31$var$subYears;

/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */ function $a75e02943163ce31$var$subYears(date, amount) {
    return (0, $cfb0a1019b8ddb38$export$3d83eec43f4ea476)(date, -amount);
}


Object.keys($a75e02943163ce31$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $a75e02943163ce31$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $a75e02943163ce31$exports[key];
        }
    });
});

Object.keys($838192f7942a2bce$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $838192f7942a2bce$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $838192f7942a2bce$exports[key];
        }
    });
});

Object.keys($8229f62301d5098e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $8229f62301d5098e$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $8229f62301d5098e$exports[key];
        }
    });
});
var $947d6a113de767ce$exports = {};

$parcel$export($947d6a113de767ce$exports, "weeksToDays", function () { return $947d6a113de767ce$export$b696b6eeb89501ad; }, function (v) { return $947d6a113de767ce$export$b696b6eeb89501ad = v; });
var $947d6a113de767ce$export$b696b6eeb89501ad;
"use strict";
$947d6a113de767ce$export$b696b6eeb89501ad = $947d6a113de767ce$var$weeksToDays;

/**
 * @name weeksToDays
 * @category Conversion Helpers
 * @summary Convert weeks to days.
 *
 * @description
 * Convert a number of weeks to a full number of days.
 *
 * @param weeks - The number of weeks to be converted
 *
 * @returns The number of weeks converted in days
 *
 * @example
 * // Convert 2 weeks into days
 * const result = weeksToDays(2)
 * //=> 14
 */ function $947d6a113de767ce$var$weeksToDays(weeks) {
    return Math.trunc(weeks * $9e66e67751f962b4$export$dfd9b671c89acc8e);
}


Object.keys($947d6a113de767ce$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $947d6a113de767ce$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $947d6a113de767ce$exports[key];
        }
    });
});
var $50662340dbf44d19$exports = {};

$parcel$export($50662340dbf44d19$exports, "yearsToDays", function () { return $50662340dbf44d19$export$862cb7b6e45c3b17; }, function (v) { return $50662340dbf44d19$export$862cb7b6e45c3b17 = v; });
var $50662340dbf44d19$export$862cb7b6e45c3b17;
"use strict";
$50662340dbf44d19$export$862cb7b6e45c3b17 = $50662340dbf44d19$var$yearsToDays;

/**
 * @name yearsToDays
 * @category Conversion Helpers
 * @summary Convert years to days.
 *
 * @description
 * Convert a number of years to a full number of days.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in days
 *
 * @example
 * // Convert 2 years into days
 * const result = yearsToDays(2)
 * //=> 730
 */ function $50662340dbf44d19$var$yearsToDays(years) {
    return Math.trunc(years * $9e66e67751f962b4$export$3913210603d8e9ae);
}


Object.keys($50662340dbf44d19$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $50662340dbf44d19$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $50662340dbf44d19$exports[key];
        }
    });
});
var $263cce5ae26c9040$exports = {};

$parcel$export($263cce5ae26c9040$exports, "yearsToMonths", function () { return $263cce5ae26c9040$export$894abb0747b9a00; }, function (v) { return $263cce5ae26c9040$export$894abb0747b9a00 = v; });
var $263cce5ae26c9040$export$894abb0747b9a00;
"use strict";
$263cce5ae26c9040$export$894abb0747b9a00 = $263cce5ae26c9040$var$yearsToMonths;

/**
 * @name yearsToMonths
 * @category Conversion Helpers
 * @summary Convert years to months.
 *
 * @description
 * Convert a number of years to a full number of months.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in months
 *
 * @example
 * // Convert 2 years into months
 * const result = yearsToMonths(2)
 * //=> 24
 */ function $263cce5ae26c9040$var$yearsToMonths(years) {
    return Math.trunc(years * $9e66e67751f962b4$export$80d7e435f744f319);
}


Object.keys($263cce5ae26c9040$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $263cce5ae26c9040$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $263cce5ae26c9040$exports[key];
        }
    });
});
var $d7613ad91c044625$exports = {};

$parcel$export($d7613ad91c044625$exports, "yearsToQuarters", function () { return $d7613ad91c044625$export$ab26576e5e7379d7; }, function (v) { return $d7613ad91c044625$export$ab26576e5e7379d7 = v; });
var $d7613ad91c044625$export$ab26576e5e7379d7;
"use strict";
$d7613ad91c044625$export$ab26576e5e7379d7 = $d7613ad91c044625$var$yearsToQuarters;

/**
 * @name yearsToQuarters
 * @category Conversion Helpers
 * @summary Convert years to quarters.
 *
 * @description
 * Convert a number of years to a full number of quarters.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in quarters
 *
 * @example
 * // Convert 2 years to quarters
 * const result = yearsToQuarters(2)
 * //=> 8
 */ function $d7613ad91c044625$var$yearsToQuarters(years) {
    return Math.trunc(years * $9e66e67751f962b4$export$4db7641526e3241f);
}


Object.keys($d7613ad91c044625$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $e570a7bac6dc48a8$exports && $e570a7bac6dc48a8$exports[key] === $d7613ad91c044625$exports[key]) return;
    Object.defineProperty($e570a7bac6dc48a8$exports, key, {
        enumerable: true,
        get: function() {
            return $d7613ad91c044625$exports[key];
        }
    });
});


/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $1ed36fbf686620c4$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $1ed36fbf686620c4$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $1ed36fbf686620c4$export$803cd8101b6c182b = /*#__PURE__*/ $1ed36fbf686620c4$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $1ed36fbf686620c4$export$27b07d8a310ed8b5[0], side + "-" + $1ed36fbf686620c4$export$27b07d8a310ed8b5[1]), []);
const $1ed36fbf686620c4$export$96ec731ed4dcb222 = Math.min;
const $1ed36fbf686620c4$export$8960430cfd85939f = Math.max;
const $1ed36fbf686620c4$export$2077e0241d6afd3c = Math.round;
const $1ed36fbf686620c4$export$a3fe094919f356fd = Math.floor;
const $1ed36fbf686620c4$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $1ed36fbf686620c4$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $1ed36fbf686620c4$export$7d15b64cf5a3a4c4(start, value, end) {
    return $1ed36fbf686620c4$export$8960430cfd85939f(start, $1ed36fbf686620c4$export$96ec731ed4dcb222(value, end));
}
function $1ed36fbf686620c4$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $1ed36fbf686620c4$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $1ed36fbf686620c4$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $1ed36fbf686620c4$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $1ed36fbf686620c4$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $1ed36fbf686620c4$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $1ed36fbf686620c4$export$2b57e0052a6d6d4c(placement) {
    return $1ed36fbf686620c4$export$8a000a963141ac32($1ed36fbf686620c4$export$f28e8f882010718a(placement));
}
function $1ed36fbf686620c4$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $1ed36fbf686620c4$export$f0989780f32bfcda(placement);
    const alignmentAxis = $1ed36fbf686620c4$export$2b57e0052a6d6d4c(placement);
    const length = $1ed36fbf686620c4$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $1ed36fbf686620c4$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $1ed36fbf686620c4$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $1ed36fbf686620c4$export$496432a3699e50b1(placement) {
    const oppositePlacement = $1ed36fbf686620c4$export$9c5e28bad23365fa(placement);
    return [
        $1ed36fbf686620c4$export$2b182c584985588b(placement),
        oppositePlacement,
        $1ed36fbf686620c4$export$2b182c584985588b(oppositePlacement)
    ];
}
function $1ed36fbf686620c4$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $1ed36fbf686620c4$var$lrPlacement = [
    'left',
    'right'
];
const $1ed36fbf686620c4$var$rlPlacement = [
    'right',
    'left'
];
const $1ed36fbf686620c4$var$tbPlacement = [
    'top',
    'bottom'
];
const $1ed36fbf686620c4$var$btPlacement = [
    'bottom',
    'top'
];
function $1ed36fbf686620c4$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $1ed36fbf686620c4$var$rlPlacement : $1ed36fbf686620c4$var$lrPlacement;
            return isStart ? $1ed36fbf686620c4$var$lrPlacement : $1ed36fbf686620c4$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $1ed36fbf686620c4$var$tbPlacement : $1ed36fbf686620c4$var$btPlacement;
        default:
            return [];
    }
}
function $1ed36fbf686620c4$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $1ed36fbf686620c4$export$f0989780f32bfcda(placement);
    let list = $1ed36fbf686620c4$var$getSideList($1ed36fbf686620c4$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($1ed36fbf686620c4$export$2b182c584985588b));
    }
    return list;
}
function $1ed36fbf686620c4$export$9c5e28bad23365fa(placement) {
    const side = $1ed36fbf686620c4$export$3c915306cb7fc97a(placement);
    return $1ed36fbf686620c4$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $1ed36fbf686620c4$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $1ed36fbf686620c4$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $1ed36fbf686620c4$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $1ed36fbf686620c4$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $0ff672b4d4034982$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $1ed36fbf686620c4$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $1ed36fbf686620c4$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $1ed36fbf686620c4$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $1ed36fbf686620c4$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $1ed36fbf686620c4$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $0ff672b4d4034982$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $1ed36fbf686620c4$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $1ed36fbf686620c4$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $1ed36fbf686620c4$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $1ed36fbf686620c4$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $0ff672b4d4034982$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $0ff672b4d4034982$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $0ff672b4d4034982$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $0ff672b4d4034982$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $0ff672b4d4034982$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $0ff672b4d4034982$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $0ff672b4d4034982$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $1ed36fbf686620c4$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $1ed36fbf686620c4$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $1ed36fbf686620c4$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $1ed36fbf686620c4$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $1ed36fbf686620c4$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $1ed36fbf686620c4$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $1ed36fbf686620c4$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $1ed36fbf686620c4$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $0ff672b4d4034982$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $1ed36fbf686620c4$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $1ed36fbf686620c4$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $1ed36fbf686620c4$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $1ed36fbf686620c4$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $1ed36fbf686620c4$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $0ff672b4d4034982$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $1ed36fbf686620c4$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $1ed36fbf686620c4$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $1ed36fbf686620c4$export$803cd8101b6c182b) ? $0ff672b4d4034982$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $1ed36fbf686620c4$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $1ed36fbf686620c4$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $1ed36fbf686620c4$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $1ed36fbf686620c4$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $0ff672b4d4034982$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $1ed36fbf686620c4$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $1ed36fbf686620c4$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $1ed36fbf686620c4$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $1ed36fbf686620c4$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $1ed36fbf686620c4$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $1ed36fbf686620c4$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $1ed36fbf686620c4$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $1ed36fbf686620c4$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $1ed36fbf686620c4$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $1ed36fbf686620c4$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $1ed36fbf686620c4$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $0ff672b4d4034982$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $0ff672b4d4034982$var$isAnySideFullyClipped(overflow) {
    return (0, $1ed36fbf686620c4$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $0ff672b4d4034982$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $1ed36fbf686620c4$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $0ff672b4d4034982$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $0ff672b4d4034982$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $0ff672b4d4034982$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $0ff672b4d4034982$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $0ff672b4d4034982$var$getBoundingRect(rects) {
    const minX = (0, $1ed36fbf686620c4$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $1ed36fbf686620c4$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $1ed36fbf686620c4$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $1ed36fbf686620c4$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $0ff672b4d4034982$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $1ed36fbf686620c4$export$ee05aea0aeecbad4)($0ff672b4d4034982$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $0ff672b4d4034982$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $1ed36fbf686620c4$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $0ff672b4d4034982$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $1ed36fbf686620c4$export$ee05aea0aeecbad4)($0ff672b4d4034982$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $1ed36fbf686620c4$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $1ed36fbf686620c4$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $1ed36fbf686620c4$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $1ed36fbf686620c4$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $1ed36fbf686620c4$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $1ed36fbf686620c4$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $0ff672b4d4034982$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $0ff672b4d4034982$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $1ed36fbf686620c4$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $1ed36fbf686620c4$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $1ed36fbf686620c4$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $0ff672b4d4034982$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $1ed36fbf686620c4$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $0ff672b4d4034982$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $0ff672b4d4034982$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $0ff672b4d4034982$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $1ed36fbf686620c4$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $1ed36fbf686620c4$export$f28e8f882010718a)((0, $1ed36fbf686620c4$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $1ed36fbf686620c4$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $1ed36fbf686620c4$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $1ed36fbf686620c4$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $0ff672b4d4034982$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $1ed36fbf686620c4$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $1ed36fbf686620c4$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $1ed36fbf686620c4$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $1ed36fbf686620c4$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $0ff672b4d4034982$var$originSides.has((0, $1ed36fbf686620c4$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $0ff672b4d4034982$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $1ed36fbf686620c4$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $1ed36fbf686620c4$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $1ed36fbf686620c4$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $1ed36fbf686620c4$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $1ed36fbf686620c4$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $1ed36fbf686620c4$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $1ed36fbf686620c4$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $1ed36fbf686620c4$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $1ed36fbf686620c4$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $1ed36fbf686620c4$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $1ed36fbf686620c4$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $1ed36fbf686620c4$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $05207b419b5e3dd6$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $05207b419b5e3dd6$export$651544f548703224(node) {
    if ($05207b419b5e3dd6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $05207b419b5e3dd6$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $05207b419b5e3dd6$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($05207b419b5e3dd6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $05207b419b5e3dd6$export$8ee0fc9ee280b4ee(value) {
    if (!$05207b419b5e3dd6$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $05207b419b5e3dd6$export$38b2d434cce3ea22(value).Node;
}
function $05207b419b5e3dd6$export$45a5e7f76e0caa8d(value) {
    if (!$05207b419b5e3dd6$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $05207b419b5e3dd6$export$38b2d434cce3ea22(value).Element;
}
function $05207b419b5e3dd6$export$1b3bfaa9684536aa(value) {
    if (!$05207b419b5e3dd6$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $05207b419b5e3dd6$export$38b2d434cce3ea22(value).HTMLElement;
}
function $05207b419b5e3dd6$export$af51f0f06c0f328a(value) {
    if (!$05207b419b5e3dd6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $05207b419b5e3dd6$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $05207b419b5e3dd6$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $05207b419b5e3dd6$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $05207b419b5e3dd6$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($05207b419b5e3dd6$export$651544f548703224(element));
}
function $05207b419b5e3dd6$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $05207b419b5e3dd6$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $05207b419b5e3dd6$var$containRe = /paint|layout|strict|content/;
const $05207b419b5e3dd6$var$isNotNone = (value)=>!!value && value !== 'none';
let $05207b419b5e3dd6$var$isWebKitValue;
function $05207b419b5e3dd6$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $05207b419b5e3dd6$export$45a5e7f76e0caa8d(elementOrCss) ? $05207b419b5e3dd6$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $05207b419b5e3dd6$var$isNotNone(css.transform) || $05207b419b5e3dd6$var$isNotNone(css.translate) || $05207b419b5e3dd6$var$isNotNone(css.scale) || $05207b419b5e3dd6$var$isNotNone(css.rotate) || $05207b419b5e3dd6$var$isNotNone(css.perspective) || !$05207b419b5e3dd6$export$78551043582a6a98() && ($05207b419b5e3dd6$var$isNotNone(css.backdropFilter) || $05207b419b5e3dd6$var$isNotNone(css.filter)) || $05207b419b5e3dd6$var$willChangeRe.test(css.willChange || '') || $05207b419b5e3dd6$var$containRe.test(css.contain || '');
}
function $05207b419b5e3dd6$export$940d8225183e1404(element) {
    let currentNode = $05207b419b5e3dd6$export$4e12058fc4d51d56(element);
    while($05207b419b5e3dd6$export$1b3bfaa9684536aa(currentNode) && !$05207b419b5e3dd6$export$d1162fb0b6d4cd51(currentNode)){
        if ($05207b419b5e3dd6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($05207b419b5e3dd6$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $05207b419b5e3dd6$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $05207b419b5e3dd6$export$78551043582a6a98() {
    if ($05207b419b5e3dd6$var$isWebKitValue == null) $05207b419b5e3dd6$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $05207b419b5e3dd6$var$isWebKitValue;
}
function $05207b419b5e3dd6$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($05207b419b5e3dd6$export$651544f548703224(node));
}
function $05207b419b5e3dd6$export$3735103072e4a80(element) {
    return $05207b419b5e3dd6$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $05207b419b5e3dd6$export$dc8fc79fa2800137(element) {
    if ($05207b419b5e3dd6$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $05207b419b5e3dd6$export$4e12058fc4d51d56(node) {
    if ($05207b419b5e3dd6$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $05207b419b5e3dd6$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $05207b419b5e3dd6$export$e495491855dc5418(node);
    return $05207b419b5e3dd6$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $05207b419b5e3dd6$export$7cd01a57c8ca906c(node) {
    const parentNode = $05207b419b5e3dd6$export$4e12058fc4d51d56(node);
    if ($05207b419b5e3dd6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($05207b419b5e3dd6$export$1b3bfaa9684536aa(parentNode) && $05207b419b5e3dd6$export$989e911fa9af580a(parentNode)) return parentNode;
    return $05207b419b5e3dd6$export$7cd01a57c8ca906c(parentNode);
}
function $05207b419b5e3dd6$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $05207b419b5e3dd6$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $05207b419b5e3dd6$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $05207b419b5e3dd6$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $05207b419b5e3dd6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $05207b419b5e3dd6$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $05207b419b5e3dd6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $05207b419b5e3dd6$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $c44eab932bc33f33$var$getCssDimensions(element) {
    const css = (0, $05207b419b5e3dd6$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $05207b419b5e3dd6$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $1ed36fbf686620c4$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $1ed36fbf686620c4$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $c44eab932bc33f33$var$unwrapElement(element) {
    return !(0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $c44eab932bc33f33$var$getScale(element) {
    const domElement = $c44eab932bc33f33$var$unwrapElement(element);
    if (!(0, $05207b419b5e3dd6$export$1b3bfaa9684536aa)(domElement)) return (0, $1ed36fbf686620c4$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $c44eab932bc33f33$var$getCssDimensions(domElement);
    let x = ($ ? (0, $1ed36fbf686620c4$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $1ed36fbf686620c4$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $c44eab932bc33f33$var$noOffsets = /*#__PURE__*/ (0, $1ed36fbf686620c4$export$a397704b5e280835)(0);
function $c44eab932bc33f33$var$getVisualOffsets(element) {
    const win = (0, $05207b419b5e3dd6$export$38b2d434cce3ea22)(element);
    if (!(0, $05207b419b5e3dd6$export$78551043582a6a98)() || !win.visualViewport) return $c44eab932bc33f33$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $c44eab932bc33f33$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $05207b419b5e3dd6$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $c44eab932bc33f33$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $c44eab932bc33f33$var$unwrapElement(element);
    let scale = (0, $1ed36fbf686620c4$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(offsetParent)) scale = $c44eab932bc33f33$var$getScale(offsetParent);
        } else scale = $c44eab932bc33f33$var$getScale(element);
    }
    const visualOffsets = $c44eab932bc33f33$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $c44eab932bc33f33$var$getVisualOffsets(domElement) : (0, $1ed36fbf686620c4$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $05207b419b5e3dd6$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $05207b419b5e3dd6$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $05207b419b5e3dd6$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $c44eab932bc33f33$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $05207b419b5e3dd6$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $05207b419b5e3dd6$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $05207b419b5e3dd6$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $1ed36fbf686620c4$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $c44eab932bc33f33$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $05207b419b5e3dd6$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $c44eab932bc33f33$var$getBoundingClientRect((0, $05207b419b5e3dd6$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $c44eab932bc33f33$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $c44eab932bc33f33$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $c44eab932bc33f33$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $05207b419b5e3dd6$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $05207b419b5e3dd6$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $1ed36fbf686620c4$export$a397704b5e280835)(1);
    const offsets = (0, $1ed36fbf686620c4$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $05207b419b5e3dd6$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $05207b419b5e3dd6$export$651544f548703224)(offsetParent) !== 'body' || (0, $05207b419b5e3dd6$export$989e911fa9af580a)(documentElement)) scroll = (0, $05207b419b5e3dd6$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $c44eab932bc33f33$var$getBoundingClientRect(offsetParent);
            scale = $c44eab932bc33f33$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $c44eab932bc33f33$var$getHTMLOffset(documentElement, scroll) : (0, $1ed36fbf686620c4$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $c44eab932bc33f33$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $c44eab932bc33f33$var$getDocumentRect(element) {
    const html = (0, $05207b419b5e3dd6$export$e495491855dc5418)(element);
    const scroll = (0, $05207b419b5e3dd6$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $1ed36fbf686620c4$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $1ed36fbf686620c4$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $c44eab932bc33f33$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $05207b419b5e3dd6$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $1ed36fbf686620c4$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $c44eab932bc33f33$var$SCROLLBAR_MAX = 25;
function $c44eab932bc33f33$var$getViewportRect(element, strategy) {
    const win = (0, $05207b419b5e3dd6$export$38b2d434cce3ea22)(element);
    const html = (0, $05207b419b5e3dd6$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $05207b419b5e3dd6$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $c44eab932bc33f33$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $c44eab932bc33f33$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $c44eab932bc33f33$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $c44eab932bc33f33$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $c44eab932bc33f33$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $05207b419b5e3dd6$export$1b3bfaa9684536aa)(element) ? $c44eab932bc33f33$var$getScale(element) : (0, $1ed36fbf686620c4$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $c44eab932bc33f33$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $c44eab932bc33f33$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $c44eab932bc33f33$var$getDocumentRect((0, $05207b419b5e3dd6$export$e495491855dc5418)(element));
    else if ((0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $c44eab932bc33f33$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $c44eab932bc33f33$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $1ed36fbf686620c4$export$ee05aea0aeecbad4)(rect);
}
function $c44eab932bc33f33$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $05207b419b5e3dd6$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(parentNode) || (0, $05207b419b5e3dd6$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $05207b419b5e3dd6$export$3735103072e4a80)(parentNode).position === 'fixed' || $c44eab932bc33f33$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $c44eab932bc33f33$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $05207b419b5e3dd6$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(el) && (0, $05207b419b5e3dd6$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $05207b419b5e3dd6$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $05207b419b5e3dd6$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(currentNode) && !(0, $05207b419b5e3dd6$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $05207b419b5e3dd6$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $05207b419b5e3dd6$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $05207b419b5e3dd6$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $c44eab932bc33f33$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $05207b419b5e3dd6$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $c44eab932bc33f33$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $05207b419b5e3dd6$export$89e651af02346cd4)(element) ? [] : $c44eab932bc33f33$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $c44eab932bc33f33$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $c44eab932bc33f33$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $1ed36fbf686620c4$export$8960430cfd85939f)(rect.top, top);
        right = (0, $1ed36fbf686620c4$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $1ed36fbf686620c4$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $1ed36fbf686620c4$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $c44eab932bc33f33$var$getDimensions(element) {
    const { width: width, height: height } = $c44eab932bc33f33$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $c44eab932bc33f33$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $05207b419b5e3dd6$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $05207b419b5e3dd6$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $c44eab932bc33f33$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $1ed36fbf686620c4$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $c44eab932bc33f33$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $05207b419b5e3dd6$export$651544f548703224)(offsetParent) !== 'body' || (0, $05207b419b5e3dd6$export$989e911fa9af580a)(documentElement)) scroll = (0, $05207b419b5e3dd6$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $c44eab932bc33f33$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $c44eab932bc33f33$var$getHTMLOffset(documentElement, scroll) : (0, $1ed36fbf686620c4$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $c44eab932bc33f33$var$isStaticPositioned(element) {
    return (0, $05207b419b5e3dd6$export$3735103072e4a80)(element).position === 'static';
}
function $c44eab932bc33f33$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $05207b419b5e3dd6$export$1b3bfaa9684536aa)(element) || (0, $05207b419b5e3dd6$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $05207b419b5e3dd6$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $c44eab932bc33f33$var$getOffsetParent(element, polyfill) {
    const win = (0, $05207b419b5e3dd6$export$38b2d434cce3ea22)(element);
    if ((0, $05207b419b5e3dd6$export$89e651af02346cd4)(element)) return win;
    if (!(0, $05207b419b5e3dd6$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $05207b419b5e3dd6$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $05207b419b5e3dd6$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$c44eab932bc33f33$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $05207b419b5e3dd6$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $c44eab932bc33f33$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $05207b419b5e3dd6$export$71535ffaa902797f)(offsetParent) && $c44eab932bc33f33$var$isStaticPositioned(offsetParent))offsetParent = $c44eab932bc33f33$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $05207b419b5e3dd6$export$d1162fb0b6d4cd51)(offsetParent) && $c44eab932bc33f33$var$isStaticPositioned(offsetParent) && !(0, $05207b419b5e3dd6$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $05207b419b5e3dd6$export$940d8225183e1404)(element) || win;
}
const $c44eab932bc33f33$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $c44eab932bc33f33$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $c44eab932bc33f33$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $c44eab932bc33f33$var$isRTL(element) {
    return (0, $05207b419b5e3dd6$export$3735103072e4a80)(element).direction === 'rtl';
}
const $c44eab932bc33f33$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $c44eab932bc33f33$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $05207b419b5e3dd6$export$e495491855dc5418,
    getClippingRect: $c44eab932bc33f33$var$getClippingRect,
    getOffsetParent: $c44eab932bc33f33$var$getOffsetParent,
    getElementRects: $c44eab932bc33f33$var$getElementRects,
    getClientRects: $c44eab932bc33f33$var$getClientRects,
    getDimensions: $c44eab932bc33f33$var$getDimensions,
    getScale: $c44eab932bc33f33$var$getScale,
    isElement: $05207b419b5e3dd6$export$45a5e7f76e0caa8d,
    isRTL: $c44eab932bc33f33$var$isRTL
};
function $c44eab932bc33f33$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $c44eab932bc33f33$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $05207b419b5e3dd6$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $1ed36fbf686620c4$export$a3fe094919f356fd)(top);
        const insetRight = (0, $1ed36fbf686620c4$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $1ed36fbf686620c4$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $1ed36fbf686620c4$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $1ed36fbf686620c4$export$8960430cfd85939f)(0, (0, $1ed36fbf686620c4$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$c44eab932bc33f33$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $c44eab932bc33f33$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $c44eab932bc33f33$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $05207b419b5e3dd6$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $05207b419b5e3dd6$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $c44eab932bc33f33$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $c44eab932bc33f33$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $c44eab932bc33f33$var$getBoundingClientRect(reference);
        if (prevRefRect && !$c44eab932bc33f33$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $c44eab932bc33f33$export$37b6bde19b108ecc = (0, $0ff672b4d4034982$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $c44eab932bc33f33$export$cc800923e997bb8 = (0, $0ff672b4d4034982$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $c44eab932bc33f33$export$91fb6ecbd551914 = (0, $0ff672b4d4034982$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $c44eab932bc33f33$export$fba63a578e423eb = (0, $0ff672b4d4034982$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $c44eab932bc33f33$export$8a83211c878a3f1f = (0, $0ff672b4d4034982$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $c44eab932bc33f33$export$346677f925de839c = (0, $0ff672b4d4034982$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $c44eab932bc33f33$export$fe8985bb6374093c = (0, $0ff672b4d4034982$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $c44eab932bc33f33$export$f2120bbfa5450bd2 = (0, $0ff672b4d4034982$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $c44eab932bc33f33$export$18c8ad048e32c7d5 = (0, $0ff672b4d4034982$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $c44eab932bc33f33$export$7bf07e38f3dc4b69 = (0, $0ff672b4d4034982$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $c44eab932bc33f33$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $c44eab932bc33f33$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $0ff672b4d4034982$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $7UyaH = parcelRequire("7UyaH");

var $3357e590fc26c933$var$isClient = typeof document !== 'undefined';
var $3357e590fc26c933$var$noop = function noop() {};
var $3357e590fc26c933$var$index = $3357e590fc26c933$var$isClient ? (0, $7UyaH.useLayoutEffect) : $3357e590fc26c933$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $3357e590fc26c933$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$3357e590fc26c933$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$3357e590fc26c933$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $3357e590fc26c933$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $3357e590fc26c933$var$roundByDPR(element, value) {
    const dpr = $3357e590fc26c933$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $3357e590fc26c933$var$useLatestRef(value) {
    const ref = $7UyaH.useRef(value);
    $3357e590fc26c933$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $3357e590fc26c933$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $7UyaH.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $7UyaH.useState(middleware);
    if (!$3357e590fc26c933$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $7UyaH.useState(null);
    const [_floating, _setFloating] = $7UyaH.useState(null);
    const setReference = $7UyaH.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $7UyaH.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $7UyaH.useRef(null);
    const floatingRef = $7UyaH.useRef(null);
    const dataRef = $7UyaH.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $3357e590fc26c933$var$useLatestRef(whileElementsMounted);
    const platformRef = $3357e590fc26c933$var$useLatestRef(platform);
    const openRef = $3357e590fc26c933$var$useLatestRef(open);
    const update = $7UyaH.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $c44eab932bc33f33$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$3357e590fc26c933$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $32e03ff3f068d28e$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $3357e590fc26c933$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $7UyaH.useRef(false);
    $3357e590fc26c933$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $3357e590fc26c933$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $7UyaH.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $7UyaH.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $7UyaH.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $3357e590fc26c933$var$roundByDPR(elements.floating, data.x);
        const y = $3357e590fc26c933$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$3357e590fc26c933$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $7UyaH.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $3357e590fc26c933$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $c44eab932bc33f33$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $c44eab932bc33f33$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $3357e590fc26c933$export$cc800923e997bb8 = (options, deps)=>{
    const result = (0, $c44eab932bc33f33$export$cc800923e997bb8)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $3357e590fc26c933$export$fba63a578e423eb = (options, deps)=>{
    const result = (0, $c44eab932bc33f33$export$fba63a578e423eb)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $3357e590fc26c933$export$7bf07e38f3dc4b69 = (options, deps)=>{
    const result = (0, $c44eab932bc33f33$export$7bf07e38f3dc4b69)(options);
    return {
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $3357e590fc26c933$export$8a83211c878a3f1f = (options, deps)=>{
    const result = (0, $c44eab932bc33f33$export$8a83211c878a3f1f)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $3357e590fc26c933$export$346677f925de839c = (options, deps)=>{
    const result = (0, $c44eab932bc33f33$export$346677f925de839c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $3357e590fc26c933$export$91fb6ecbd551914 = (options, deps)=>{
    const result = (0, $c44eab932bc33f33$export$91fb6ecbd551914)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $3357e590fc26c933$export$fe8985bb6374093c = (options, deps)=>{
    const result = (0, $c44eab932bc33f33$export$fe8985bb6374093c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $3357e590fc26c933$export$18c8ad048e32c7d5 = (options, deps)=>{
    const result = (0, $c44eab932bc33f33$export$18c8ad048e32c7d5)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $3357e590fc26c933$export$f2120bbfa5450bd2 = (options, deps)=>{
    const result = $3357e590fc26c933$var$arrow$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};


var $7UyaH = parcelRequire("7UyaH");

function $6a1c7d7f17eb210d$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $6a1c7d7f17eb210d$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $05207b419b5e3dd6$export$af51f0f06c0f328a)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
// Avoid Chrome DevTools blue warning.
function $6a1c7d7f17eb210d$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $6a1c7d7f17eb210d$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $6a1c7d7f17eb210d$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($6a1c7d7f17eb210d$export$a11b0059900ceec8() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $6a1c7d7f17eb210d$export$29bf1b5f2c56cf63(event) {
    if ($6a1c7d7f17eb210d$export$c8f880a2d81914c4()) return false;
    return !$6a1c7d7f17eb210d$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $6a1c7d7f17eb210d$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function $6a1c7d7f17eb210d$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $6a1c7d7f17eb210d$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($6a1c7d7f17eb210d$export$867a782338812cb4()) || re.test($6a1c7d7f17eb210d$export$7935961ef7719cb0());
}
function $6a1c7d7f17eb210d$export$9ac100e40613ea10() {
    return $6a1c7d7f17eb210d$export$867a782338812cb4().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function $6a1c7d7f17eb210d$export$c8f880a2d81914c4() {
    return $6a1c7d7f17eb210d$export$7935961ef7719cb0().includes('jsdom/');
}
function $6a1c7d7f17eb210d$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
function $6a1c7d7f17eb210d$export$94781ce41a161222(event) {
    return 'nativeEvent' in event;
}
function $6a1c7d7f17eb210d$export$7b296c28e0fa3aed(element) {
    return element.matches('html,body');
}
function $6a1c7d7f17eb210d$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $6a1c7d7f17eb210d$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $6a1c7d7f17eb210d$export$c22522a4dfa48e9c(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $6a1c7d7f17eb210d$export$78b3d091ff376bc = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $6a1c7d7f17eb210d$export$42ad131c32f0fb8d(element) {
    return (0, $05207b419b5e3dd6$export$1b3bfaa9684536aa)(element) && element.matches($6a1c7d7f17eb210d$export$78b3d091ff376bc);
}
function $6a1c7d7f17eb210d$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $6a1c7d7f17eb210d$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && $6a1c7d7f17eb210d$export$42ad131c32f0fb8d(element);
}




/*!
* tabbable 6.4.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
var $386abf931dfc3549$var$candidateSelectors = [
    'input:not([inert]):not([inert] *)',
    'select:not([inert]):not([inert] *)',
    'textarea:not([inert]):not([inert] *)',
    'a[href]:not([inert]):not([inert] *)',
    'button:not([inert]):not([inert] *)',
    '[tabindex]:not(slot):not([inert]):not([inert] *)',
    'audio[controls]:not([inert]):not([inert] *)',
    'video[controls]:not([inert]):not([inert] *)',
    '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
    'details>summary:first-of-type:not([inert]):not([inert] *)',
    'details:not([inert]):not([inert] *)'
];
var $386abf931dfc3549$var$candidateSelector = /* #__PURE__ */ $386abf931dfc3549$var$candidateSelectors.join(',');
var $386abf931dfc3549$var$NoElement = typeof Element === 'undefined';
var $386abf931dfc3549$var$matches = $386abf931dfc3549$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $386abf931dfc3549$var$getRootNode = !$386abf931dfc3549$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Node} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $386abf931dfc3549$var$_isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    var result = inert || lookUp && node && // closest does not exist on shadow roots, so we fall back to a manual
    // lookup upward, in case it is not defined.
    (typeof node.closest === 'function' ? node.closest('[inert]') : $386abf931dfc3549$var$_isInert(node.parentNode));
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $386abf931dfc3549$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $386abf931dfc3549$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert (either by itself or via its parent), then all its children are inert
    if ($386abf931dfc3549$var$_isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($386abf931dfc3549$var$candidateSelector));
    if (includeContainer && $386abf931dfc3549$var$matches.call(el, $386abf931dfc3549$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $386abf931dfc3549$var$_getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($386abf931dfc3549$var$_isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = $386abf931dfc3549$var$_getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $386abf931dfc3549$var$matches.call(element, $386abf931dfc3549$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$386abf931dfc3549$var$_isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = $386abf931dfc3549$var$_getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $386abf931dfc3549$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $386abf931dfc3549$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $386abf931dfc3549$var$isContentEditable(node)) && !$386abf931dfc3549$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $386abf931dfc3549$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $386abf931dfc3549$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$386abf931dfc3549$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $386abf931dfc3549$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $386abf931dfc3549$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $386abf931dfc3549$var$isHiddenInput = function isHiddenInput(node) {
    return $386abf931dfc3549$var$isInput(node) && node.type === 'hidden';
};
var $386abf931dfc3549$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $386abf931dfc3549$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $386abf931dfc3549$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $386abf931dfc3549$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $386abf931dfc3549$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $386abf931dfc3549$var$isRadio = function isRadio(node) {
    return $386abf931dfc3549$var$isInput(node) && node.type === 'radio';
};
var $386abf931dfc3549$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $386abf931dfc3549$var$isRadio(node) && !$386abf931dfc3549$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $386abf931dfc3549$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $386abf931dfc3549$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $386abf931dfc3549$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $386abf931dfc3549$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $386abf931dfc3549$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (displayCheck === 'full-native') {
        if ('checkVisibility' in node) {
            // Chrome >= 105, Edge >= 105, Firefox >= 106, Safari >= 17.4
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/checkVisibility#browser_compatibility
            var visible = node.checkVisibility({
                // Checking opacity might be desirable for some use cases, but natively,
                // opacity zero elements _are_ focusable and tabbable.
                checkOpacity: false,
                opacityProperty: false,
                contentVisibilityAuto: true,
                visibilityProperty: true,
                // This is an alias for `visibilityProperty`. Contemporary browsers
                // support both. However, this alias has wider browser support (Chrome
                // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
                // we include it anyway.
                checkVisibilityCSS: true
            });
            return !visible;
        }
    }
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === 'hidden') return true;
    var isDirectSummary = $386abf931dfc3549$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($386abf931dfc3549$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || // full-native can run this branch when it falls through in case
    // Element#checkVisibility is unsupported
    displayCheck === 'full-native' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $386abf931dfc3549$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $386abf931dfc3549$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($386abf931dfc3549$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $386abf931dfc3549$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $386abf931dfc3549$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $386abf931dfc3549$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $386abf931dfc3549$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || $386abf931dfc3549$var$isHiddenInput(node) || $386abf931dfc3549$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $386abf931dfc3549$var$isDetailsWithSummary(node) || $386abf931dfc3549$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $386abf931dfc3549$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($386abf931dfc3549$var$isNonTabbableRadio(node) || $386abf931dfc3549$export$a4672efddb4181b8(node) < 0 || !$386abf931dfc3549$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $386abf931dfc3549$var$isShadowRootTabbable = function isShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $386abf931dfc3549$var$_sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $386abf931dfc3549$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? $386abf931dfc3549$var$_sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($386abf931dfc3549$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $386abf931dfc3549$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $386abf931dfc3549$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $386abf931dfc3549$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $386abf931dfc3549$var$isShadowRootTabbable
    });
    else candidates = $386abf931dfc3549$var$getCandidates(container, options.includeContainer, $386abf931dfc3549$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $386abf931dfc3549$var$_sortByOrder(candidates);
};
var $386abf931dfc3549$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $386abf931dfc3549$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $386abf931dfc3549$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $386abf931dfc3549$var$getCandidates(container, options.includeContainer, $386abf931dfc3549$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $386abf931dfc3549$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($386abf931dfc3549$var$matches.call(node, $386abf931dfc3549$var$candidateSelector) === false) return false;
    return $386abf931dfc3549$var$isNodeMatchingSelectorTabbable(options, node);
};
var $386abf931dfc3549$var$focusableCandidateSelector = /* #__PURE__ */ $386abf931dfc3549$var$candidateSelectors.concat('iframe:not([inert]):not([inert] *)').join(',');
var $386abf931dfc3549$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($386abf931dfc3549$var$matches.call(node, $386abf931dfc3549$var$focusableCandidateSelector) === false) return false;
    return $386abf931dfc3549$var$isNodeMatchingSelectorFocusable(options, node);
};




/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $0ae2eb679eb5490e$export$74665b213cb5c4cf(refs) {
    return $7UyaH.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $0ae2eb679eb5490e$var$SafeReact = {
    ...$7UyaH
};
const $0ae2eb679eb5490e$var$useInsertionEffect = $0ae2eb679eb5490e$var$SafeReact.useInsertionEffect;
const $0ae2eb679eb5490e$var$useSafeInsertionEffect = $0ae2eb679eb5490e$var$useInsertionEffect || ((fn)=>fn());
function $0ae2eb679eb5490e$var$useEffectEvent(callback) {
    const ref = $7UyaH.useRef(()=>{});
    $0ae2eb679eb5490e$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $7UyaH.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
const $0ae2eb679eb5490e$var$ARROW_UP = 'ArrowUp';
const $0ae2eb679eb5490e$var$ARROW_DOWN = 'ArrowDown';
const $0ae2eb679eb5490e$var$ARROW_LEFT = 'ArrowLeft';
const $0ae2eb679eb5490e$var$ARROW_RIGHT = 'ArrowRight';
function $0ae2eb679eb5490e$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $0ae2eb679eb5490e$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $0ae2eb679eb5490e$var$getMinIndex(listRef, disabledIndices) {
    return $0ae2eb679eb5490e$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $0ae2eb679eb5490e$var$getMaxIndex(listRef, disabledIndices) {
    return $0ae2eb679eb5490e$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $0ae2eb679eb5490e$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && $0ae2eb679eb5490e$var$isDisabled(list, index, disabledIndices));
    return index;
}
function $0ae2eb679eb5490e$var$getGridNavigatedIndex(elementsRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, rtl: rtl, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $0ae2eb679eb5490e$var$ARROW_UP) {
        stop && (0, $6a1c7d7f17eb210d$export$7ae4cd3a66c1e050)(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $0ae2eb679eb5490e$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($0ae2eb679eb5490e$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $0ae2eb679eb5490e$var$ARROW_DOWN) {
        stop && (0, $6a1c7d7f17eb210d$export$7ae4cd3a66c1e050)(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $0ae2eb679eb5490e$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $0ae2eb679eb5490e$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($0ae2eb679eb5490e$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        const prevRow = (0, $1ed36fbf686620c4$export$a3fe094919f356fd)(prevIndex / cols);
        if (event.key === (rtl ? $0ae2eb679eb5490e$var$ARROW_LEFT : $0ae2eb679eb5490e$var$ARROW_RIGHT)) {
            stop && (0, $6a1c7d7f17eb210d$export$7ae4cd3a66c1e050)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $0ae2eb679eb5490e$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $0ae2eb679eb5490e$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $0ae2eb679eb5490e$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $0ae2eb679eb5490e$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($0ae2eb679eb5490e$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? $0ae2eb679eb5490e$var$ARROW_RIGHT : $0ae2eb679eb5490e$var$ARROW_LEFT)) {
            stop && (0, $6a1c7d7f17eb210d$export$7ae4cd3a66c1e050)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $0ae2eb679eb5490e$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $0ae2eb679eb5490e$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $0ae2eb679eb5490e$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $0ae2eb679eb5490e$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($0ae2eb679eb5490e$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $1ed36fbf686620c4$export$a3fe094919f356fd)(maxIndex / cols) === prevRow;
        if ($0ae2eb679eb5490e$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? $0ae2eb679eb5490e$var$ARROW_RIGHT : $0ae2eb679eb5490e$var$ARROW_LEFT) ? maxIndex : $0ae2eb679eb5490e$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $0ae2eb679eb5490e$var$buildCellMap(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $0ae2eb679eb5490e$var$getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case 'bl':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $0ae2eb679eb5490e$var$getCellIndices(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $0ae2eb679eb5490e$var$isDisabled(list, index, disabledIndices) {
    if (disabledIndices) return disabledIndices.includes(index);
    const element = list[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
var $0ae2eb679eb5490e$var$index = typeof document !== 'undefined' ? (0, $7UyaH.useLayoutEffect) : (0, $7UyaH.useEffect);
function $0ae2eb679eb5490e$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $0ae2eb679eb5490e$var$areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    for (const [key, value] of map1.entries()){
        if (value !== map2.get(key)) return false;
    }
    return true;
}
const $0ae2eb679eb5490e$var$FloatingListContext = /*#__PURE__*/ $7UyaH.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $0ae2eb679eb5490e$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [map, setMap] = $7UyaH.useState(()=>new Map());
    const register = $7UyaH.useCallback((node)=>{
        setMap((prevMap)=>new Map(prevMap).set(node, null));
    }, []);
    const unregister = $7UyaH.useCallback((node)=>{
        setMap((prevMap)=>{
            const map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    $0ae2eb679eb5490e$var$index(()=>{
        const newMap = new Map(map);
        const nodes = Array.from(newMap.keys()).sort($0ae2eb679eb5490e$var$sortByDocumentPosition);
        nodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        if (!$0ae2eb679eb5490e$var$areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ $7UyaH.createElement($0ae2eb679eb5490e$var$FloatingListContext.Provider, {
        value: $7UyaH.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $0ae2eb679eb5490e$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $7UyaH.useContext($0ae2eb679eb5490e$var$FloatingListContext);
    const [index$1, setIndex] = $7UyaH.useState(null);
    const componentRef = $7UyaH.useRef(null);
    const ref = $7UyaH.useCallback((node)=>{
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    $0ae2eb679eb5490e$var$index(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    $0ae2eb679eb5490e$var$index(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $7UyaH.useMemo(()=>({
            ref: ref,
            index: index$1 == null ? -1 : index$1
        }), [
        index$1,
        ref
    ]);
}
function $0ae2eb679eb5490e$var$renderJsx(render, computedProps) {
    if (typeof render === 'function') return render(computedProps);
    if (render) return /*#__PURE__*/ $7UyaH.cloneElement(render, computedProps);
    return /*#__PURE__*/ $7UyaH.createElement("div", computedProps);
}
const $0ae2eb679eb5490e$var$CompositeContext = /*#__PURE__*/ $7UyaH.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $0ae2eb679eb5490e$var$horizontalKeys = [
    $0ae2eb679eb5490e$var$ARROW_LEFT,
    $0ae2eb679eb5490e$var$ARROW_RIGHT
];
const $0ae2eb679eb5490e$var$verticalKeys = [
    $0ae2eb679eb5490e$var$ARROW_UP,
    $0ae2eb679eb5490e$var$ARROW_DOWN
];
const $0ae2eb679eb5490e$var$allKeys = [
    ...$0ae2eb679eb5490e$var$horizontalKeys,
    ...$0ae2eb679eb5490e$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $0ae2eb679eb5490e$export$43586241d9db0c6d = /*#__PURE__*/ $7UyaH.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = 'both', loop: loop = true, rtl: rtl = false, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $7UyaH.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = $0ae2eb679eb5490e$var$useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $7UyaH.useRef([]);
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const contextValue = $7UyaH.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$0ae2eb679eb5490e$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = $0ae2eb679eb5490e$var$getMinIndex(elementsRef, disabledIndices);
        const maxIndex = $0ae2eb679eb5490e$var$getMaxIndex(elementsRef, disabledIndices);
        const horizontalEndKey = rtl ? $0ae2eb679eb5490e$var$ARROW_LEFT : $0ae2eb679eb5490e$var$ARROW_RIGHT;
        const horizontalStartKey = rtl ? $0ae2eb679eb5490e$var$ARROW_RIGHT : $0ae2eb679eb5490e$var$ARROW_LEFT;
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $0ae2eb679eb5490e$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$0ae2eb679eb5490e$var$isDisabled(elementsRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$0ae2eb679eb5490e$var$isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[$0ae2eb679eb5490e$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $0ae2eb679eb5490e$var$getCellIndices([
                    ...disabledIndices || elementsRef.current.map((_, index)=>$0ae2eb679eb5490e$var$isDisabled(elementsRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $0ae2eb679eb5490e$var$getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $0ae2eb679eb5490e$var$ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                $0ae2eb679eb5490e$var$ARROW_DOWN
            ],
            both: [
                horizontalEndKey,
                $0ae2eb679eb5490e$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                $0ae2eb679eb5490e$var$ARROW_UP
            ],
            both: [
                horizontalStartKey,
                $0ae2eb679eb5490e$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $0ae2eb679eb5490e$var$allKeys : ({
            horizontal: $0ae2eb679eb5490e$var$horizontalKeys,
            vertical: $0ae2eb679eb5490e$var$verticalKeys,
            both: $0ae2eb679eb5490e$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = $0ae2eb679eb5490e$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !$0ae2eb679eb5490e$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            var _elementsRef$current$;
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ $7UyaH.createElement($0ae2eb679eb5490e$var$CompositeContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $7UyaH.createElement($0ae2eb679eb5490e$export$ffe15b0e64951704, {
        elementsRef: elementsRef
    }, $0ae2eb679eb5490e$var$renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $0ae2eb679eb5490e$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $7UyaH.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $7UyaH.useContext($0ae2eb679eb5490e$var$CompositeContext);
    const { ref: ref, index: index } = $0ae2eb679eb5490e$export$dcdc7ff5149f7d1a();
    const mergedRef = $0ae2eb679eb5490e$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        'data-active': isActive ? '' : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $0ae2eb679eb5490e$var$renderJsx(render, computedProps);
});
function $0ae2eb679eb5490e$var$_extends() {
    $0ae2eb679eb5490e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0ae2eb679eb5490e$var$_extends.apply(this, arguments);
}
let $0ae2eb679eb5490e$var$serverHandoffComplete = false;
let $0ae2eb679eb5490e$var$count = 0;
const $0ae2eb679eb5490e$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $0ae2eb679eb5490e$var$count++;
function $0ae2eb679eb5490e$var$useFloatingId() {
    const [id, setId] = $7UyaH.useState(()=>$0ae2eb679eb5490e$var$serverHandoffComplete ? $0ae2eb679eb5490e$var$genId() : undefined);
    $0ae2eb679eb5490e$var$index(()=>{
        if (id == null) setId($0ae2eb679eb5490e$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $7UyaH.useEffect(()=>{
        $0ae2eb679eb5490e$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $0ae2eb679eb5490e$var$useReactId = $0ae2eb679eb5490e$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $0ae2eb679eb5490e$export$f680877a34711e37 = $0ae2eb679eb5490e$var$useReactId || $0ae2eb679eb5490e$var$useFloatingId;
let $0ae2eb679eb5490e$var$devMessageSet;
function $0ae2eb679eb5490e$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet = $0ae2eb679eb5490e$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $0ae2eb679eb5490e$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $0ae2eb679eb5490e$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet3 = $0ae2eb679eb5490e$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $0ae2eb679eb5490e$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $0ae2eb679eb5490e$export$33511391554732bc = /*#__PURE__*/ $7UyaH.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $0ae2eb679eb5490e$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $7UyaH.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    $0ae2eb679eb5490e$var$index(()=>{
        if (!floating) return;
        const isRTL = (0, $05207b419b5e3dd6$export$3735103072e4a80)(floating).direction === 'rtl';
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split('-');
    const isVerticalSide = side === 'top' || side === 'bottom';
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
    let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === 'end' ? 'left' : 'right';
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
    const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
    const rotation = {
        top: isCustomShape ? 'rotate(180deg)' : '',
        left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
        bottom: isCustomShape ? '' : 'rotate(180deg)',
        right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
    }[side];
    return /*#__PURE__*/ $7UyaH.createElement("svg", $0ae2eb679eb5490e$var$_extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(' '),
            ...restStyle
        }
    }), computedStrokeWidth > 0 && /*#__PURE__*/ $7UyaH.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: computedStrokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ $7UyaH.createElement("path", {
        stroke: computedStrokeWidth && !d ? rest.fill : 'none',
        d: dValue
    }), /*#__PURE__*/ $7UyaH.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $7UyaH.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
    })));
});
function $0ae2eb679eb5490e$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l)=>l !== listener)) || []);
        }
    };
}
const $0ae2eb679eb5490e$var$FloatingNodeContext = /*#__PURE__*/ $7UyaH.createContext(null);
const $0ae2eb679eb5490e$var$FloatingTreeContext = /*#__PURE__*/ $7UyaH.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $0ae2eb679eb5490e$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $7UyaH.useContext($0ae2eb679eb5490e$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $0ae2eb679eb5490e$export$db0c2a7c7a2a4f69 = ()=>$7UyaH.useContext($0ae2eb679eb5490e$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $0ae2eb679eb5490e$export$9b136e0e758a42f4(customParentId) {
    const id = $0ae2eb679eb5490e$export$f680877a34711e37();
    const tree = $0ae2eb679eb5490e$export$db0c2a7c7a2a4f69();
    const reactParentId = $0ae2eb679eb5490e$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $0ae2eb679eb5490e$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $0ae2eb679eb5490e$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $0ae2eb679eb5490e$export$165209eae06d3488();
    return /*#__PURE__*/ $7UyaH.createElement($0ae2eb679eb5490e$var$FloatingNodeContext.Provider, {
        value: $7UyaH.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $0ae2eb679eb5490e$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $7UyaH.useRef([]);
    const addNode = $7UyaH.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $7UyaH.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $7UyaH.useState(()=>$0ae2eb679eb5490e$var$createPubSub())[0];
    return /*#__PURE__*/ $7UyaH.createElement($0ae2eb679eb5490e$var$FloatingTreeContext.Provider, {
        value: $7UyaH.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function $0ae2eb679eb5490e$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $0ae2eb679eb5490e$var$useLatestRef(value) {
    const ref = (0, $7UyaH.useRef)(value);
    $0ae2eb679eb5490e$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $0ae2eb679eb5490e$var$safePolygonIdentifier = /*#__PURE__*/ $0ae2eb679eb5490e$var$createAttribute('safe-polygon');
function $0ae2eb679eb5490e$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $6a1c7d7f17eb210d$export$81cf264172d31e51)(pointerType)) return 0;
    if (typeof value === 'number') return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $0ae2eb679eb5490e$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $0ae2eb679eb5490e$export$db0c2a7c7a2a4f69();
    const parentId = $0ae2eb679eb5490e$export$165209eae06d3488();
    const handleCloseRef = $0ae2eb679eb5490e$var$useLatestRef(handleClose);
    const delayRef = $0ae2eb679eb5490e$var$useLatestRef(delay);
    const openRef = $0ae2eb679eb5490e$var$useLatestRef(open);
    const pointerTypeRef = $7UyaH.useRef();
    const timeoutRef = $7UyaH.useRef(-1);
    const handlerRef = $7UyaH.useRef();
    const restTimeoutRef = $7UyaH.useRef(-1);
    const blockMouseMoveRef = $7UyaH.useRef(true);
    const performedPointerEventsMutationRef = $7UyaH.useRef(false);
    const unbindMouseMoveRef = $7UyaH.useRef(()=>{});
    const restTimeoutPendingRef = $7UyaH.useRef(false);
    const isHoverOpen = $7UyaH.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $7UyaH.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $7UyaH.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, 'hover');
        }
        const html = (0, $6a1c7d7f17eb210d$export$f65ca476c09acec0)(elements.floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $7UyaH.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = 'hover';
        const closeDelay = $0ae2eb679eb5490e$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $0ae2eb679eb5490e$var$useEffectEvent(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = $0ae2eb679eb5490e$var$useEffectEvent(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $6a1c7d7f17eb210d$export$f65ca476c09acec0)(elements.floating).body;
            body.style.pointerEvents = '';
            body.removeAttribute($0ae2eb679eb5490e$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    const isClickLikeOpenEvent = $0ae2eb679eb5490e$var$useEffectEvent(()=>{
        return dataRef.current.openEvent ? [
            'click',
            'mousedown'
        ].includes(dataRef.current.openEvent.type) : false;
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $7UyaH.useEffect(()=>{
        if (!enabled) return;
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $6a1c7d7f17eb210d$export$81cf264172d31e51)(pointerTypeRef.current) || restMs > 0 && !$0ae2eb679eb5490e$var$getDelay(delayRef.current, 'open')) return;
            const openDelay = $0ae2eb679eb5490e$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, 'hover');
            }, openDelay);
            else if (!open) onOpenChange(true, event, 'hover');
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = (0, $6a1c7d7f17eb210d$export$f65ca476c09acec0)(elements.floating);
            clearTimeout(restTimeoutRef.current);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event, true, 'safe-polygon');
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === 'touch' ? !(0, $6a1c7d7f17eb210d$export$2344b14b097df817)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event);
                }
            })(event);
        }
        if ((0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(elements.domReference)) {
            var _elements$floating;
            const ref = elements.domReference;
            open && ref.addEventListener('mouseleave', onScrollMouseLeave);
            (_elements$floating = elements.floating) == null || _elements$floating.addEventListener('mouseleave', onScrollMouseLeave);
            move && ref.addEventListener('mousemove', onMouseEnter, {
                once: true
            });
            ref.addEventListener('mouseenter', onMouseEnter);
            ref.addEventListener('mouseleave', onMouseLeave);
            return ()=>{
                var _elements$floating2;
                open && ref.removeEventListener('mouseleave', onScrollMouseLeave);
                (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener('mouseleave', onScrollMouseLeave);
                move && ref.removeEventListener('mousemove', onMouseEnter);
                ref.removeEventListener('mouseenter', onMouseEnter);
                ref.removeEventListener('mouseleave', onMouseLeave);
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $0ae2eb679eb5490e$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $6a1c7d7f17eb210d$export$f65ca476c09acec0)(elements.floating).body;
                body.setAttribute($0ae2eb679eb5490e$var$safePolygonIdentifier, '');
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                body.style.pointerEvents = 'none';
                ref.style.pointerEvents = 'auto';
                floatingEl.style.pointerEvents = 'auto';
                return ()=>{
                    body.style.pointerEvents = '';
                    ref.style.pointerEvents = '';
                    floatingEl.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    $0ae2eb679eb5490e$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $7UyaH.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $7UyaH.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, 'hover');
                }
                if (mouseOnly && !(0, $6a1c7d7f17eb210d$export$81cf264172d31e51)(pointerTypeRef.current)) return;
                if (open || restMs === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                clearTimeout(restTimeoutRef.current);
                if (pointerTypeRef.current === 'touch') handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMs
    ]);
    const floating = $7UyaH.useMemo(()=>({
            onMouseEnter () {
                clearTimeout(timeoutRef.current);
            },
            onMouseLeave (event) {
                if (!isClickLikeOpenEvent()) closeWithDelay(event.nativeEvent, false);
            }
        }), [
        closeWithDelay,
        isClickLikeOpenEvent
    ]);
    return $7UyaH.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
const $0ae2eb679eb5490e$var$NOOP = ()=>{};
const $0ae2eb679eb5490e$var$FloatingDelayGroupContext = /*#__PURE__*/ $7UyaH.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $0ae2eb679eb5490e$var$NOOP,
    setState: $0ae2eb679eb5490e$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $0ae2eb679eb5490e$export$e2411914b150383d = ()=>$7UyaH.useContext($0ae2eb679eb5490e$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $0ae2eb679eb5490e$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $7UyaH.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $7UyaH.useRef(null);
    const setCurrentId = $7UyaH.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $0ae2eb679eb5490e$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ $7UyaH.createElement($0ae2eb679eb5490e$var$FloatingDelayGroupContext.Provider, {
        value: $7UyaH.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ])
    }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $0ae2eb679eb5490e$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $0ae2eb679eb5490e$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    $0ae2eb679eb5490e$var$index(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $0ae2eb679eb5490e$var$getDelay(initialDelay, 'close')
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $0ae2eb679eb5490e$var$index(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $0ae2eb679eb5490e$var$index(()=>{
        if (!enabled) return;
        if (setCurrentId === $0ae2eb679eb5490e$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
let $0ae2eb679eb5490e$var$rafId = 0;
function $0ae2eb679eb5490e$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($0ae2eb679eb5490e$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $0ae2eb679eb5490e$var$rafId = requestAnimationFrame(exec);
}
function $0ae2eb679eb5490e$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $0ae2eb679eb5490e$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $0ae2eb679eb5490e$var$getDeepestNode(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $0ae2eb679eb5490e$var$getChildren(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let $0ae2eb679eb5490e$var$counterMap = /*#__PURE__*/ new WeakMap();
let $0ae2eb679eb5490e$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $0ae2eb679eb5490e$var$markerMap = {};
let $0ae2eb679eb5490e$var$lockCount$1 = 0;
const $0ae2eb679eb5490e$var$supportsInert = ()=>typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
const $0ae2eb679eb5490e$var$unwrapHost = (node)=>node && (node.host || $0ae2eb679eb5490e$var$unwrapHost(node.parentNode));
const $0ae2eb679eb5490e$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $0ae2eb679eb5490e$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $0ae2eb679eb5490e$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = 'data-floating-ui-inert';
    const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
    const avoidElements = $0ae2eb679eb5490e$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$0ae2eb679eb5490e$var$markerMap[markerName]) $0ae2eb679eb5490e$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $0ae2eb679eb5490e$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $05207b419b5e3dd6$export$651544f548703224)(node) === 'script') return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== 'false';
                const counterValue = ($0ae2eb679eb5490e$var$counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $0ae2eb679eb5490e$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $0ae2eb679eb5490e$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, '');
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, 'true');
            }
        });
    }
    $0ae2eb679eb5490e$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterValue = ($0ae2eb679eb5490e$var$counterMap.get(element) || 0) - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            $0ae2eb679eb5490e$var$counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$0ae2eb679eb5490e$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $0ae2eb679eb5490e$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $0ae2eb679eb5490e$var$lockCount$1--;
        if (!$0ae2eb679eb5490e$var$lockCount$1) {
            $0ae2eb679eb5490e$var$counterMap = new WeakMap();
            $0ae2eb679eb5490e$var$counterMap = new WeakMap();
            $0ae2eb679eb5490e$var$uncontrolledElementsSet = new WeakSet();
            $0ae2eb679eb5490e$var$markerMap = {};
        }
    };
}
function $0ae2eb679eb5490e$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = (0, $6a1c7d7f17eb210d$export$f65ca476c09acec0)(avoidElements[0]).body;
    return $0ae2eb679eb5490e$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live]'))), body, ariaHidden, inert);
}
const $0ae2eb679eb5490e$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    });
function $0ae2eb679eb5490e$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $386abf931dfc3549$export$17100aea90429aa7)(container, $0ae2eb679eb5490e$var$getTabbableOptions());
    if (direction === 'prev') allTabbable.reverse();
    const activeIndex = allTabbable.indexOf((0, $6a1c7d7f17eb210d$export$da980962bd2147a4)((0, $6a1c7d7f17eb210d$export$f65ca476c09acec0)(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $0ae2eb679eb5490e$var$getNextTabbable() {
    return $0ae2eb679eb5490e$var$getTabbableIn(document.body, 'next');
}
function $0ae2eb679eb5490e$var$getPreviousTabbable() {
    return $0ae2eb679eb5490e$var$getTabbableIn(document.body, 'prev');
}
function $0ae2eb679eb5490e$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, $6a1c7d7f17eb210d$export$2344b14b097df817)(containerElement, relatedTarget);
}
function $0ae2eb679eb5490e$var$disableFocusInside(container) {
    const tabbableElements = (0, $386abf931dfc3549$export$17100aea90429aa7)(container, $0ae2eb679eb5490e$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $0ae2eb679eb5490e$var$enableFocusInside(container) {
    const elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
const $0ae2eb679eb5490e$var$HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
let $0ae2eb679eb5490e$var$timeoutId;
function $0ae2eb679eb5490e$var$setActiveElementOnTab(event) {
    if (event.key === 'Tab') {
        event.target;
        clearTimeout($0ae2eb679eb5490e$var$timeoutId);
    }
}
const $0ae2eb679eb5490e$var$FocusGuard = /*#__PURE__*/ $7UyaH.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $7UyaH.useState();
    $0ae2eb679eb5490e$var$index(()=>{
        if ((0, $6a1c7d7f17eb210d$export$95df08bae54cb4df)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
        document.addEventListener('keydown', $0ae2eb679eb5490e$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener('keydown', $0ae2eb679eb5490e$var$setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        'aria-hidden': role ? undefined : true,
        [$0ae2eb679eb5490e$var$createAttribute('focus-guard')]: '',
        style: $0ae2eb679eb5490e$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ $7UyaH.createElement("span", $0ae2eb679eb5490e$var$_extends({}, props, restProps));
});
const $0ae2eb679eb5490e$var$PortalContext = /*#__PURE__*/ $7UyaH.createContext(null);
const $0ae2eb679eb5490e$var$attr = /*#__PURE__*/ $0ae2eb679eb5490e$var$createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $0ae2eb679eb5490e$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $0ae2eb679eb5490e$export$f680877a34711e37();
    const portalContext = $0ae2eb679eb5490e$var$usePortalContext();
    const [portalNode, setPortalNode] = $7UyaH.useState(null);
    const portalNodeRef = $7UyaH.useRef(null);
    $0ae2eb679eb5490e$var$index(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    $0ae2eb679eb5490e$var$index(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($0ae2eb679eb5490e$var$attr, '');
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    $0ae2eb679eb5490e$var$index(()=>{
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement('div');
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($0ae2eb679eb5490e$var$attr, '');
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $0ae2eb679eb5490e$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $0ae2eb679eb5490e$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $7UyaH.useState(null);
    const beforeOutsideRef = $7UyaH.useRef(null);
    const afterOutsideRef = $7UyaH.useRef(null);
    const beforeInsideRef = $7UyaH.useRef(null);
    const afterInsideRef = $7UyaH.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $7UyaH.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $0ae2eb679eb5490e$var$isOutsideEvent(event)) {
                const focusing = event.type === 'focusin';
                const manageFocus = focusing ? $0ae2eb679eb5490e$var$enableFocusInside : $0ae2eb679eb5490e$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return ()=>{
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $7UyaH.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        $0ae2eb679eb5490e$var$enableFocusInside(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ $7UyaH.createElement($0ae2eb679eb5490e$var$PortalContext.Provider, {
        value: $7UyaH.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ $7UyaH.createElement($0ae2eb679eb5490e$var$FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event)=>{
            if ($0ae2eb679eb5490e$var$isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = $0ae2eb679eb5490e$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ $7UyaH.createElement("span", {
        "aria-owns": portalNode.id,
        style: $0ae2eb679eb5490e$var$HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ $32e03ff3f068d28e$exports.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ $7UyaH.createElement($0ae2eb679eb5490e$var$FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event)=>{
            if ($0ae2eb679eb5490e$var$isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = $0ae2eb679eb5490e$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
            }
        }
    }));
}
const $0ae2eb679eb5490e$var$usePortalContext = ()=>$7UyaH.useContext($0ae2eb679eb5490e$var$PortalContext);
const $0ae2eb679eb5490e$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
function $0ae2eb679eb5490e$var$getFloatingFocusElement(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($0ae2eb679eb5490e$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $0ae2eb679eb5490e$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
const $0ae2eb679eb5490e$var$LIST_LIMIT = 20;
let $0ae2eb679eb5490e$var$previouslyFocusedElements = [];
function $0ae2eb679eb5490e$var$addPreviouslyFocusedElement(element) {
    $0ae2eb679eb5490e$var$previouslyFocusedElements = $0ae2eb679eb5490e$var$previouslyFocusedElements.filter((el)=>el.isConnected);
    let tabbableEl = element;
    if (!tabbableEl || (0, $05207b419b5e3dd6$export$651544f548703224)(tabbableEl) === 'body') return;
    if (!(0, $386abf931dfc3549$export$bebd5a1431fec25d)(tabbableEl, $0ae2eb679eb5490e$var$getTabbableOptions())) {
        const tabbableChild = (0, $386abf931dfc3549$export$17100aea90429aa7)(tabbableEl, $0ae2eb679eb5490e$var$getTabbableOptions())[0];
        if (tabbableChild) tabbableEl = tabbableChild;
    }
    $0ae2eb679eb5490e$var$previouslyFocusedElements.push(tabbableEl);
    if ($0ae2eb679eb5490e$var$previouslyFocusedElements.length > $0ae2eb679eb5490e$var$LIST_LIMIT) $0ae2eb679eb5490e$var$previouslyFocusedElements = $0ae2eb679eb5490e$var$previouslyFocusedElements.slice(-$0ae2eb679eb5490e$var$LIST_LIMIT);
}
function $0ae2eb679eb5490e$var$getPreviouslyFocusedElement() {
    return $0ae2eb679eb5490e$var$previouslyFocusedElements.slice().reverse().find((el)=>el.isConnected);
}
const $0ae2eb679eb5490e$var$VisuallyHiddenDismiss = /*#__PURE__*/ $7UyaH.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ $7UyaH.createElement("button", $0ae2eb679eb5490e$var$_extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $0ae2eb679eb5490e$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $0ae2eb679eb5490e$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        'content'
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true } = props;
    const { open: open, refs: refs, nodeId: nodeId, onOpenChange: onOpenChange, events: events, dataRef: dataRef, floatingId: floatingId, elements: { domReference: domReference, floating: floating } } = context;
    const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $6a1c7d7f17eb210d$export$259ba5ae38188551)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const guards = $0ae2eb679eb5490e$var$supportsInert() ? _guards : true;
    const orderRef = $0ae2eb679eb5490e$var$useLatestRef(order);
    const initialFocusRef = $0ae2eb679eb5490e$var$useLatestRef(initialFocus);
    const returnFocusRef = $0ae2eb679eb5490e$var$useLatestRef(returnFocus);
    const tree = $0ae2eb679eb5490e$export$db0c2a7c7a2a4f69();
    const portalContext = $0ae2eb679eb5490e$var$usePortalContext();
    const startDismissButtonRef = $7UyaH.useRef(null);
    const endDismissButtonRef = $7UyaH.useRef(null);
    const preventReturnFocusRef = $7UyaH.useRef(false);
    const isPointerDownRef = $7UyaH.useRef(false);
    const tabbableIndexRef = $7UyaH.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = $0ae2eb679eb5490e$var$getFloatingFocusElement(floating);
    const getTabbableContent = $0ae2eb679eb5490e$var$useEffectEvent(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $386abf931dfc3549$export$17100aea90429aa7)(container, $0ae2eb679eb5490e$var$getTabbableOptions()) : [];
    });
    const getTabbableElements = $0ae2eb679eb5490e$var$useEffectEvent((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === 'reference') return domReference;
            if (floatingFocusElement && type === 'floating') return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $7UyaH.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $6a1c7d7f17eb210d$export$2344b14b097df817)(floatingFocusElement, (0, $6a1c7d7f17eb210d$export$da980962bd2147a4)((0, $6a1c7d7f17eb210d$export$f65ca476c09acec0)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $6a1c7d7f17eb210d$export$7ae4cd3a66c1e050)(event);
                const els = getTabbableElements();
                const target = (0, $6a1c7d7f17eb210d$export$c22522a4dfa48e9c)(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    (0, $6a1c7d7f17eb210d$export$7ae4cd3a66c1e050)(event);
                    if (event.shiftKey) $0ae2eb679eb5490e$var$enqueueFocus(els[els.length - 1]);
                    else $0ae2eb679eb5490e$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
                    (0, $6a1c7d7f17eb210d$export$7ae4cd3a66c1e050)(event);
                    $0ae2eb679eb5490e$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $6a1c7d7f17eb210d$export$f65ca476c09acec0)(floatingFocusElement);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $7UyaH.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $6a1c7d7f17eb210d$export$c22522a4dfa48e9c)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener('focusin', handleFocusIn);
        return ()=>{
            floating.removeEventListener('focusin', handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $7UyaH.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            queueMicrotask(()=>{
                const movedToUnrelatedNode = !((0, $6a1c7d7f17eb210d$export$2344b14b097df817)(domReference, relatedTarget) || (0, $6a1c7d7f17eb210d$export$2344b14b097df817)(floating, relatedTarget) || (0, $6a1c7d7f17eb210d$export$2344b14b097df817)(relatedTarget, floating) || (0, $6a1c7d7f17eb210d$export$2344b14b097df817)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($0ae2eb679eb5490e$var$createAttribute('focus-guard')) || tree && ($0ae2eb679eb5490e$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $6a1c7d7f17eb210d$export$2344b14b097df817)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $6a1c7d7f17eb210d$export$2344b14b097df817)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || $0ae2eb679eb5490e$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && movedToUnrelatedNode && (0, $6a1c7d7f17eb210d$export$da980962bd2147a4)((0, $6a1c7d7f17eb210d$export$f65ca476c09acec0)(floatingFocusElement)) === (0, $6a1c7d7f17eb210d$export$f65ca476c09acec0)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $05207b419b5e3dd6$export$1b3bfaa9684536aa)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $05207b419b5e3dd6$export$1b3bfaa9684536aa)(nodeToFocus)) nodeToFocus.focus();
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $0ae2eb679eb5490e$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, 'focus-out');
                }
            });
        }
        if (floating && (0, $05207b419b5e3dd6$export$1b3bfaa9684536aa)(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            floating.addEventListener('focusout', handleFocusOutside);
            return ()=>{
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                floating.removeEventListener('focusout', handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox
    ]);
    $7UyaH.useEffect(()=>{
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $0ae2eb679eb5490e$var$createAttribute('portal') + "]")) || []);
        if (floating) {
            const insideElements = [
                floating,
                ...portalNodes,
                startDismissButtonRef.current,
                endDismissButtonRef.current,
                orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null
            ].filter((x)=>x != null);
            const cleanup = modal || isUntrappedTypeableCombobox ? $0ae2eb679eb5490e$var$markOthers(insideElements, guards, !guards) : $0ae2eb679eb5490e$var$markOthers(insideElements);
            return ()=>{
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards
    ]);
    $0ae2eb679eb5490e$var$index(()=>{
        if (disabled || !(0, $05207b419b5e3dd6$export$1b3bfaa9684536aa)(floatingFocusElement)) return;
        const doc = (0, $6a1c7d7f17eb210d$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $6a1c7d7f17eb210d$export$da980962bd2147a4)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $6a1c7d7f17eb210d$export$2344b14b097df817)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $0ae2eb679eb5490e$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    $0ae2eb679eb5490e$var$index(()=>{
        if (disabled || !floatingFocusElement) return;
        let preventReturnFocusScroll = false;
        const doc = (0, $6a1c7d7f17eb210d$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $6a1c7d7f17eb210d$export$da980962bd2147a4)(doc);
        const contextData = dataRef.current;
        let openEvent = contextData.openEvent;
        $0ae2eb679eb5490e$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { open: open, reason: reason, event: event, nested: nested } = _ref;
            if (open) openEvent = event;
            if (reason === 'escape-key' && refs.domReference.current) $0ae2eb679eb5490e$var$addPreviouslyFocusedElement(refs.domReference.current);
            if (reason === 'hover' && event.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (reason !== 'outside-press') return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !((0, $6a1c7d7f17eb210d$export$60278871457622de)(event) || (0, $6a1c7d7f17eb210d$export$29bf1b5f2c56cf63)(event));
        }
        events.on('openchange', onOpenChange);
        const fallbackEl = doc.createElement('span');
        fallbackEl.setAttribute('tabindex', '-1');
        fallbackEl.setAttribute('aria-hidden', 'true');
        Object.assign(fallbackEl.style, $0ae2eb679eb5490e$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement('afterend', fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === 'boolean') return $0ae2eb679eb5490e$var$getPreviouslyFocusedElement() || fallbackEl;
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off('openchange', onOpenChange);
            const activeEl = (0, $6a1c7d7f17eb210d$export$da980962bd2147a4)(doc);
            const isFocusInsideFloatingTree = (0, $6a1c7d7f17eb210d$export$2344b14b097df817)(floating, activeEl) || tree && $0ae2eb679eb5490e$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context5;
                return (0, $6a1c7d7f17eb210d$export$2344b14b097df817)((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            });
            const shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                'click',
                'mousedown'
            ].includes(openEvent.type);
            if (shouldFocusReference && refs.domReference.current) $0ae2eb679eb5490e$var$addPreviouslyFocusedElement(refs.domReference.current);
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $05207b419b5e3dd6$export$1b3bfaa9684536aa)(returnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) returnElement.focus({
                    preventScroll: preventReturnFocusScroll
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId,
        isInsidePortal,
        domReference
    ]);
    $7UyaH.useEffect(()=>{
        // The `returnFocus` cleanup behavior is inside a microtask; ensure we
        // wait for it to complete before resetting the flag.
        queueMicrotask(()=>{
            preventReturnFocusRef.current = false;
        });
    }, [
        disabled
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $0ae2eb679eb5490e$var$index(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            refs: refs
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        refs,
        closeOnFocusOut
    ]);
    $0ae2eb679eb5490e$var$index(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        if (typeof MutationObserver !== 'function') return;
        if (ignoreInitialFocus) return;
        const handleMutation = ()=>{
            const tabIndex = floatingFocusElement.getAttribute('tabindex');
            const tabbableContent = getTabbableContent();
            const activeEl = (0, $6a1c7d7f17eb210d$export$da980962bd2147a4)((0, $6a1c7d7f17eb210d$export$f65ca476c09acec0)(floating));
            const tabbableIndex = tabbableContent.indexOf(activeEl);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
            if (orderRef.current.includes('floating') || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
                if (tabIndex !== '0') floatingFocusElement.setAttribute('tabindex', '0');
            } else if (tabIndex !== '-1') floatingFocusElement.setAttribute('tabindex', '-1');
        };
        handleMutation();
        const observer = new MutationObserver(handleMutation);
        observer.observe(floatingFocusElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        refs,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ $7UyaH.createElement($0ae2eb679eb5490e$var$VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent)
        }, typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss');
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ $7UyaH.createElement($7UyaH.Fragment, null, shouldRenderGuards && /*#__PURE__*/ $7UyaH.createElement($0ae2eb679eb5490e$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: (event)=>{
            if (modal) {
                const els = getTabbableElements();
                $0ae2eb679eb5490e$var$enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if ($0ae2eb679eb5490e$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const nextTabbable = $0ae2eb679eb5490e$var$getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isUntrappedTypeableCombobox && renderDismissButton('start'), children, renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/ $7UyaH.createElement($0ae2eb679eb5490e$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: (event)=>{
            if (modal) $0ae2eb679eb5490e$var$enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if ($0ae2eb679eb5490e$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const prevTabbable = $0ae2eb679eb5490e$var$getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
let $0ae2eb679eb5490e$var$lockCount = 0;
function $0ae2eb679eb5490e$var$enableScrollLock() {
    const isIOS = /iP(hone|ad|od)|iOS/.test((0, $6a1c7d7f17eb210d$export$867a782338812cb4)());
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = 'hidden';
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: 'fixed',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0'
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: '',
            [paddingProp]: ''
        });
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: '',
                top: '',
                left: '',
                right: ''
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $0ae2eb679eb5490e$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $0ae2eb679eb5490e$export$a35954495955337b = /*#__PURE__*/ $7UyaH.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    $0ae2eb679eb5490e$var$index(()=>{
        if (!lockScroll) return;
        $0ae2eb679eb5490e$var$lockCount++;
        if ($0ae2eb679eb5490e$var$lockCount === 1) $0ae2eb679eb5490e$var$cleanup = $0ae2eb679eb5490e$var$enableScrollLock();
        return ()=>{
            $0ae2eb679eb5490e$var$lockCount--;
            if ($0ae2eb679eb5490e$var$lockCount === 0) $0ae2eb679eb5490e$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ $7UyaH.createElement("div", $0ae2eb679eb5490e$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
function $0ae2eb679eb5490e$var$isButtonTarget(event) {
    return (0, $05207b419b5e3dd6$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === 'BUTTON';
}
function $0ae2eb679eb5490e$var$isSpaceIgnored(element) {
    return (0, $6a1c7d7f17eb210d$export$42ad131c32f0fb8d)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $0ae2eb679eb5490e$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true, stickIfOpen: stickIfOpen = true } = props;
    const pointerTypeRef = $7UyaH.useRef();
    const didKeyDownRef = $7UyaH.useRef(false);
    const reference = $7UyaH.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === 'click') return;
                if ((0, $6a1c7d7f17eb210d$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === 'mousedown' && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $6a1c7d7f17eb210d$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else onOpenChange(true, event.nativeEvent, 'click');
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $0ae2eb679eb5490e$var$isButtonTarget(event)) return;
                if (event.key === ' ' && !$0ae2eb679eb5490e$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if (event.key === 'Enter') {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $0ae2eb679eb5490e$var$isButtonTarget(event) || $0ae2eb679eb5490e$var$isSpaceIgnored(domReference)) return;
                if (event.key === ' ' && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        stickIfOpen,
        toggle
    ]);
    return $7UyaH.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $0ae2eb679eb5490e$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === 'x' || data.axis === 'both';
            const isYAxis = data.axis === 'y' || data.axis === 'both';
            const canTrackCursorOnAutoUpdate = [
                'mouseenter',
                'mousemove'
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === 'y' ? domRect.width : 0;
                height = data.axis === 'x' ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === 'x' ? domRect.height : height;
                width = data.axis === 'y' ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $0ae2eb679eb5490e$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $0ae2eb679eb5490e$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = 'both', x: x = null, y: y = null } = props;
    const initialRef = $7UyaH.useRef(false);
    const cleanupListenerRef = $7UyaH.useRef(null);
    const [pointerType, setPointerType] = $7UyaH.useState();
    const [reactive, setReactive] = $7UyaH.useState([]);
    const setReference = $0ae2eb679eb5490e$var$useEffectEvent((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$0ae2eb679eb5490e$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($0ae2eb679eb5490e$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = $0ae2eb679eb5490e$var$useEffectEvent((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $6a1c7d7f17eb210d$export$81cf264172d31e51)(pointerType) ? floating : open;
    const addListener = $7UyaH.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $05207b419b5e3dd6$export$38b2d434cce3ea22)(floating);
        function handleMouseMove(event) {
            const target = (0, $6a1c7d7f17eb210d$export$c22522a4dfa48e9c)(event);
            if (!(0, $6a1c7d7f17eb210d$export$2344b14b097df817)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $0ae2eb679eb5490e$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener('mousemove', handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $7UyaH.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $7UyaH.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $7UyaH.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    $0ae2eb679eb5490e$var$index(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $7UyaH.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $7UyaH.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $0ae2eb679eb5490e$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const $0ae2eb679eb5490e$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
const $0ae2eb679eb5490e$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $0ae2eb679eb5490e$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = 'pointerdown', referencePress: referencePress = false, referencePressEvent: referencePressEvent = 'pointerdown', ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $0ae2eb679eb5490e$export$db0c2a7c7a2a4f69();
    const outsidePressFn = $0ae2eb679eb5490e$var$useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $7UyaH.useRef(false);
    const endedOrStartedInsideRef = $7UyaH.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $0ae2eb679eb5490e$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $0ae2eb679eb5490e$var$normalizeProp(capture);
    const isComposingRef = $7UyaH.useRef(false);
    const closeOnEscapeKeyDown = $0ae2eb679eb5490e$var$useEffectEvent((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? $0ae2eb679eb5490e$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $6a1c7d7f17eb210d$export$94781ce41a161222)(event) ? event.nativeEvent : event, 'escape-key');
    });
    const closeOnEscapeKeyDownCapture = $0ae2eb679eb5490e$var$useEffectEvent((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $6a1c7d7f17eb210d$export$c22522a4dfa48e9c)(event)) == null || _getTarget.removeEventListener('keydown', callback);
        };
        (_getTarget2 = (0, $6a1c7d7f17eb210d$export$c22522a4dfa48e9c)(event)) == null || _getTarget2.addEventListener('keydown', callback);
    });
    const closeOnPressOutside = $0ae2eb679eb5490e$var$useEffectEvent((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === 'click' && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === 'function' && !outsidePress(event)) return;
        const target = (0, $6a1c7d7f17eb210d$export$c22522a4dfa48e9c)(event);
        const inertSelector = "[" + $0ae2eb679eb5490e$var$createAttribute('inert') + "]";
        const markers = (0, $6a1c7d7f17eb210d$export$f65ca476c09acec0)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(target) ? target : null;
        while(targetRootAncestor && !(0, $05207b419b5e3dd6$export$d1162fb0b6d4cd51)(targetRootAncestor)){
            const nextParent = (0, $05207b419b5e3dd6$export$4e12058fc4d51d56)(targetRootAncestor);
            if ((0, $05207b419b5e3dd6$export$d1162fb0b6d4cd51)(nextParent) || !(0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(target) && !(0, $6a1c7d7f17eb210d$export$7b296c28e0fa3aed)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $6a1c7d7f17eb210d$export$2344b14b097df817)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $6a1c7d7f17eb210d$export$2344b14b097df817)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $05207b419b5e3dd6$export$1b3bfaa9684536aa)(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            let xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                const isRTL = (0, $05207b419b5e3dd6$export$3735103072e4a80)(target).direction === 'rtl';
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && $0ae2eb679eb5490e$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $6a1c7d7f17eb210d$export$43c3154d5bf2c6c2)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $6a1c7d7f17eb210d$export$43c3154d5bf2c6c2)(event, elements.floating) || (0, $6a1c7d7f17eb210d$export$43c3154d5bf2c6c2)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? $0ae2eb679eb5490e$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, 'outside-press');
    });
    const closeOnPressOutsideCapture = $0ae2eb679eb5490e$var$useEffectEvent((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $6a1c7d7f17eb210d$export$c22522a4dfa48e9c)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $6a1c7d7f17eb210d$export$c22522a4dfa48e9c)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $7UyaH.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, 'ancestor-scroll');
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $05207b419b5e3dd6$export$78551043582a6a98)() ? 5 : 0);
        }
        const doc = (0, $6a1c7d7f17eb210d$export$f65ca476c09acec0)(elements.floating);
        if (escapeKey) {
            doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener('compositionstart', handleCompositionStart);
            doc.addEventListener('compositionend', handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(elements.domReference)) ancestors = (0, $05207b419b5e3dd6$export$3b57c1601291186b)(elements.domReference);
            if ((0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(elements.floating)) ancestors = ancestors.concat((0, $05207b419b5e3dd6$export$3b57c1601291186b)(elements.floating));
            if (!(0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $05207b419b5e3dd6$export$3b57c1601291186b)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll, {
                passive: true
            });
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener('compositionstart', handleCompositionStart);
                doc.removeEventListener('compositionend', handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $7UyaH.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $7UyaH.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            [$0ae2eb679eb5490e$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                if (referencePress) onOpenChange(false, event.nativeEvent, 'reference-press');
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $7UyaH.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown () {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp () {
                endedOrStartedInsideRef.current = true;
            },
            [$0ae2eb679eb5490e$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                insideReactTreeRef.current = true;
            }
        }), [
        closeOnEscapeKeyDown,
        outsidePressEvent
    ]);
    return $7UyaH.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $0ae2eb679eb5490e$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $0ae2eb679eb5490e$export$f680877a34711e37();
    const dataRef = $7UyaH.useRef({});
    const [events] = $7UyaH.useState(()=>$0ae2eb679eb5490e$var$createPubSub());
    const nested = $0ae2eb679eb5490e$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $7UyaH.useState(elementsProp.reference);
    const onOpenChange = $0ae2eb679eb5490e$var$useEffectEvent((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit('openchange', {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $7UyaH.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $7UyaH.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $7UyaH.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $0ae2eb679eb5490e$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId } = options;
    const internalRootContext = $0ae2eb679eb5490e$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $7UyaH.useState(null);
    const [positionReference, _setPositionReference] = $7UyaH.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $7UyaH.useRef(null);
    const tree = $0ae2eb679eb5490e$export$db0c2a7c7a2a4f69();
    $0ae2eb679eb5490e$var$index(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $3357e590fc26c933$export$4e02a5c1d08bac65)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $7UyaH.useCallback((node)=>{
        const computedPositionReference = (0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $7UyaH.useCallback((node)=>{
        if ((0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $7UyaH.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $7UyaH.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $7UyaH.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    $0ae2eb679eb5490e$var$index(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $7UyaH.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $0ae2eb679eb5490e$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $7UyaH.useRef(false);
    const timeoutRef = $7UyaH.useRef();
    const keyboardModalityRef = $7UyaH.useRef(true);
    $7UyaH.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $05207b419b5e3dd6$export$38b2d434cce3ea22)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $05207b419b5e3dd6$export$1b3bfaa9684536aa)(elements.domReference) && elements.domReference === (0, $6a1c7d7f17eb210d$export$da980962bd2147a4)((0, $6a1c7d7f17eb210d$export$f65ca476c09acec0)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        win.addEventListener('blur', onBlur);
        win.addEventListener('keydown', onKeyDown, true);
        return ()=>{
            win.removeEventListener('blur', onBlur);
            win.removeEventListener('keydown', onKeyDown, true);
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $7UyaH.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === 'reference-press' || reason === 'escape-key') blockFocusRef.current = true;
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $7UyaH.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const reference = $7UyaH.useMemo(()=>({
            onPointerDown (event) {
                if ((0, $6a1c7d7f17eb210d$export$29bf1b5f2c56cf63)(event.nativeEvent)) return;
                keyboardModalityRef.current = false;
            },
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $6a1c7d7f17eb210d$export$c22522a4dfa48e9c)(event.nativeEvent);
                if (visibleOnly && (0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(target)) try {
                    // Mac Safari unreliably matches `:focus-visible` on the reference
                    // if focus was outside the page initially - use the fallback
                    // instead.
                    if ((0, $6a1c7d7f17eb210d$export$95df08bae54cb4df)() && (0, $6a1c7d7f17eb210d$export$9ac100e40613ea10)()) throw Error();
                    if (!target.matches(':focus-visible')) return;
                } catch (e) {
                    // Old browsers will throw an error when using `:focus-visible`.
                    if (!keyboardModalityRef.current && !(0, $6a1c7d7f17eb210d$export$42ad131c32f0fb8d)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, 'focus');
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(relatedTarget) && relatedTarget.hasAttribute($0ae2eb679eb5490e$var$createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $6a1c7d7f17eb210d$export$da980962bd2147a4)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $6a1c7d7f17eb210d$export$2344b14b097df817)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $6a1c7d7f17eb210d$export$2344b14b097df817)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, 'focus');
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $7UyaH.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $0ae2eb679eb5490e$var$ACTIVE_KEY = 'active';
const $0ae2eb679eb5490e$var$SELECTED_KEY = 'selected';
function $0ae2eb679eb5490e$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === 'item';
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$0ae2eb679eb5490e$var$ACTIVE_KEY]: _, [$0ae2eb679eb5490e$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === 'floating' && {
            tabIndex: -1,
            [$0ae2eb679eb5490e$var$FOCUSABLE_ATTRIBUTE]: ''
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === 'function') return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $0ae2eb679eb5490e$var$ACTIVE_KEY,
                    $0ae2eb679eb5490e$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf('on') === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === 'function') {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $0ae2eb679eb5490e$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $7UyaH.useCallback((userProps)=>$0ae2eb679eb5490e$var$mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $7UyaH.useCallback((userProps)=>$0ae2eb679eb5490e$var$mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $7UyaH.useCallback((userProps)=>$0ae2eb679eb5490e$var$mergeProps(userProps, propsList, 'item'), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $7UyaH.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
let $0ae2eb679eb5490e$var$isPreventScrollSupported = false;
function $0ae2eb679eb5490e$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $0ae2eb679eb5490e$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $0ae2eb679eb5490e$var$ARROW_UP || key === $0ae2eb679eb5490e$var$ARROW_DOWN;
    const horizontal = key === $0ae2eb679eb5490e$var$ARROW_LEFT || key === $0ae2eb679eb5490e$var$ARROW_RIGHT;
    return $0ae2eb679eb5490e$var$doSwitch(orientation, vertical, horizontal);
}
function $0ae2eb679eb5490e$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $0ae2eb679eb5490e$var$ARROW_DOWN;
    const horizontal = rtl ? key === $0ae2eb679eb5490e$var$ARROW_LEFT : key === $0ae2eb679eb5490e$var$ARROW_RIGHT;
    return $0ae2eb679eb5490e$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function $0ae2eb679eb5490e$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $0ae2eb679eb5490e$var$ARROW_LEFT : key === $0ae2eb679eb5490e$var$ARROW_RIGHT;
    const horizontal = key === $0ae2eb679eb5490e$var$ARROW_DOWN;
    return $0ae2eb679eb5490e$var$doSwitch(orientation, vertical, horizontal);
}
function $0ae2eb679eb5490e$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $0ae2eb679eb5490e$var$ARROW_RIGHT : key === $0ae2eb679eb5490e$var$ARROW_LEFT;
    const horizontal = key === $0ae2eb679eb5490e$var$ARROW_UP;
    return $0ae2eb679eb5490e$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $0ae2eb679eb5490e$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = $0ae2eb679eb5490e$var$getFloatingFocusElement(elements.floating);
    const floatingFocusElementRef = $0ae2eb679eb5490e$var$useLatestRef(floatingFocusElement);
    const parentId = $0ae2eb679eb5490e$export$165209eae06d3488();
    const tree = $0ae2eb679eb5490e$export$db0c2a7c7a2a4f69();
    const onNavigate = $0ae2eb679eb5490e$var$useEffectEvent(unstable_onNavigate);
    const typeableComboboxReference = (0, $6a1c7d7f17eb210d$export$259ba5ae38188551)(elements.domReference);
    const focusItemOnOpenRef = $7UyaH.useRef(focusItemOnOpen);
    const indexRef = $7UyaH.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $7UyaH.useRef(null);
    const isPointerModalityRef = $7UyaH.useRef(true);
    const previousOnNavigateRef = $7UyaH.useRef(onNavigate);
    const previousMountedRef = $7UyaH.useRef(!!elements.floating);
    const previousOpenRef = $7UyaH.useRef(open);
    const forceSyncFocus = $7UyaH.useRef(false);
    const forceScrollIntoViewRef = $7UyaH.useRef(false);
    const disabledIndicesRef = $0ae2eb679eb5490e$var$useLatestRef(disabledIndices);
    const latestOpenRef = $0ae2eb679eb5490e$var$useLatestRef(open);
    const scrollItemIntoViewRef = $0ae2eb679eb5490e$var$useLatestRef(scrollItemIntoView);
    const selectedIndexRef = $0ae2eb679eb5490e$var$useLatestRef(selectedIndex);
    const [activeId, setActiveId] = $7UyaH.useState();
    const [virtualId, setVirtualId] = $7UyaH.useState();
    const focusItem = $0ae2eb679eb5490e$var$useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        function runFocus(item) {
            if (virtual) {
                setActiveId(item.id);
                tree == null || tree.events.emit('virtualfocus', item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $0ae2eb679eb5490e$var$enqueueFocus(item, {
                preventScroll: true,
                // Mac Safari does not move the virtual cursor unless the focus call
                // is sync. However, for the very first focus call, we need to wait
                // for the position to be ready in order to prevent unwanted
                // scrolling. This means the virtual cursor will not move to the first
                // item when first opening the floating element, but will on
                // subsequent calls. `preventScroll` is supported in modern Safari,
                // so we can use that instead.
                // iOS Safari must be async or the first item will not be focused.
                sync: (0, $6a1c7d7f17eb210d$export$9ac100e40613ea10)() && (0, $6a1c7d7f17eb210d$export$95df08bae54cb4df)() ? $0ae2eb679eb5490e$var$isPreventScrollSupported || forceSyncFocus.current : false
            });
        }
        const initialItem = listRef.current[indexRef.current];
        if (initialItem) runFocus(initialItem);
        requestAnimationFrame(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    });
    $0ae2eb679eb5490e$var$index(()=>{
        document.createElement('div').focus({
            get preventScroll () {
                $0ae2eb679eb5490e$var$isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $0ae2eb679eb5490e$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $0ae2eb679eb5490e$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndexRef.current != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    let runs = 0;
                    const waitForListPopulated = ()=>{
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || $0ae2eb679eb5490e$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $0ae2eb679eb5490e$var$getMinIndex(listRef, disabledIndicesRef.current) : $0ae2eb679eb5490e$var$getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!$0ae2eb679eb5490e$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $0ae2eb679eb5490e$var$index(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $6a1c7d7f17eb210d$export$da980962bd2147a4)((0, $6a1c7d7f17eb210d$export$f65ca476c09acec0)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $6a1c7d7f17eb210d$export$2344b14b097df817)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    $0ae2eb679eb5490e$var$index(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on('virtualfocus', handleVirtualFocus);
        return ()=>{
            tree.events.off('virtualfocus', handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    $0ae2eb679eb5490e$var$index(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!elements.floating;
    });
    $0ae2eb679eb5490e$var$index(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    $0ae2eb679eb5490e$var$index(()=>{
        previousOpenRef.current = open;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $7UyaH.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget } = _ref3;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === 'touch') return;
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                    onNavigate(null);
                    if (!virtual) $0ae2eb679eb5490e$var$enqueueFocus(floatingFocusElementRef.current, {
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        open,
        floatingFocusElementRef,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const commonOnKeyDown = $0ae2eb679eb5490e$var$useEffectEvent((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocus.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $0ae2eb679eb5490e$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
            (0, $6a1c7d7f17eb210d$export$7ae4cd3a66c1e050)(event);
            onOpenChange(false, event.nativeEvent, 'list-navigation');
            if ((0, $05207b419b5e3dd6$export$1b3bfaa9684536aa)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit('virtualfocus', elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = $0ae2eb679eb5490e$var$getMinIndex(listRef, disabledIndices);
        const maxIndex = $0ae2eb679eb5490e$var$getMaxIndex(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === 'Home') {
                (0, $6a1c7d7f17eb210d$export$7ae4cd3a66c1e050)(event);
                indexRef.current = minIndex;
                onNavigate(indexRef.current);
            }
            if (event.key === 'End') {
                (0, $6a1c7d7f17eb210d$export$7ae4cd3a66c1e050)(event);
                indexRef.current = maxIndex;
                onNavigate(indexRef.current);
            }
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $0ae2eb679eb5490e$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$0ae2eb679eb5490e$var$isDisabled(listRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$0ae2eb679eb5490e$var$isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[$0ae2eb679eb5490e$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $0ae2eb679eb5490e$var$getCellIndices([
                    ...disabledIndices || listRef.current.map((_, index)=>$0ae2eb679eb5490e$var$isDisabled(listRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $0ae2eb679eb5490e$var$getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $0ae2eb679eb5490e$var$ARROW_DOWN ? 'bl' : event.key === (rtl ? $0ae2eb679eb5490e$var$ARROW_LEFT : $0ae2eb679eb5490e$var$ARROW_RIGHT) ? 'tr' : 'tl'),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate(indexRef.current);
            }
            if (orientation === 'both') return;
        }
        if ($0ae2eb679eb5490e$var$isMainOrientationKey(event.key, orientation)) {
            (0, $6a1c7d7f17eb210d$export$7ae4cd3a66c1e050)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $6a1c7d7f17eb210d$export$da980962bd2147a4)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $0ae2eb679eb5490e$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate(indexRef.current);
                return;
            }
            if ($0ae2eb679eb5490e$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $0ae2eb679eb5490e$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, $0ae2eb679eb5490e$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $0ae2eb679eb5490e$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, $0ae2eb679eb5490e$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ($0ae2eb679eb5490e$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
            else onNavigate(indexRef.current);
        }
    });
    const ariaActiveDescendantProp = $7UyaH.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            'aria-activedescendant': virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $7UyaH.useMemo(()=>{
        return {
            'aria-orientation': orientation === 'both' ? undefined : orientation,
            ...!(0, $6a1c7d7f17eb210d$export$259ba5ae38188551)(elements.domReference) && ariaActiveDescendantProp,
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        elements.domReference,
        orientation
    ]);
    const reference = $7UyaH.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, $6a1c7d7f17eb210d$export$60278871457622de)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, $6a1c7d7f17eb210d$export$29bf1b5f2c56cf63)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith('Arrow');
                const isHomeOrEndKey = [
                    'Home',
                    'End'
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $0ae2eb679eb5490e$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $0ae2eb679eb5490e$var$isCrossOrientationCloseKey(event.key, orientation, rtl);
                const isMainKey = $0ae2eb679eb5490e$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? $0ae2eb679eb5490e$var$getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent('keydown', {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $6a1c7d7f17eb210d$export$7ae4cd3a66c1e050)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $6a1c7d7f17eb210d$export$7ae4cd3a66c1e050)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                if (nested) {
                    if (isCrossOpenKey) {
                        (0, $6a1c7d7f17eb210d$export$7ae4cd3a66c1e050)(event);
                        if (open) {
                            indexRef.current = $0ae2eb679eb5490e$var$getMinIndex(listRef, disabledIndicesRef.current);
                            onNavigate(indexRef.current);
                        } else onOpenChange(true, event.nativeEvent, 'list-navigation');
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $6a1c7d7f17eb210d$export$7ae4cd3a66c1e050)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, 'list-navigation');
                    else commonOnKeyDown(event);
                    if (open) onNavigate(indexRef.current);
                }
            },
            onFocus () {
                if (open && !virtual) onNavigate(null);
            },
            onPointerDown: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $7UyaH.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $0ae2eb679eb5490e$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        'select',
        'listbox'
    ],
    [
        'combobox',
        'listbox'
    ],
    [
        'label',
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $0ae2eb679eb5490e$export$f66572793fa256a1(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, floatingId: floatingId } = context;
    const { enabled: enabled = true, role: role = 'dialog' } = props;
    const ariaRole = (_componentRoleToAriaR = $0ae2eb679eb5490e$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const referenceId = $0ae2eb679eb5490e$export$f680877a34711e37();
    const parentId = $0ae2eb679eb5490e$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $7UyaH.useMemo(()=>{
        if (ariaRole === 'tooltip' || role === 'label') return {
            ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
        };
        return {
            'aria-expanded': open ? 'true' : 'false',
            'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
            'aria-controls': open ? floatingId : undefined,
            ...ariaRole === 'listbox' && {
                role: 'combobox'
            },
            ...ariaRole === 'menu' && {
                id: referenceId
            },
            ...ariaRole === 'menu' && isNested && {
                role: 'menuitem'
            },
            ...role === 'select' && {
                'aria-autocomplete': 'none'
            },
            ...role === 'combobox' && {
                'aria-autocomplete': 'list'
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $7UyaH.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === 'tooltip' || role === 'label') return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === 'menu' && {
                'aria-labelledby': referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $7UyaH.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: 'option',
            ...active && {
                id: floatingId + "-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case 'select':
                return {
                    ...commonProps,
                    'aria-selected': active && selected
                };
            case 'combobox':
                return {
                    ...commonProps,
                    ...active && {
                        'aria-selected': true
                    }
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $7UyaH.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $0ae2eb679eb5490e$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
function $0ae2eb679eb5490e$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function $0ae2eb679eb5490e$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $7UyaH.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $7UyaH.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $0ae2eb679eb5490e$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === 'number';
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $7UyaH.useState('unmounted');
    const isMounted = $0ae2eb679eb5490e$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === 'close') setStatus('unmounted');
    $0ae2eb679eb5490e$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus('initial');
            const frame = requestAnimationFrame(()=>{
                setStatus('open');
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus('close');
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $0ae2eb679eb5490e$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split('-')[0];
    const fnArgs = $7UyaH.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === 'number';
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $7UyaH.useState(()=>({
            ...$0ae2eb679eb5490e$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$0ae2eb679eb5490e$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $0ae2eb679eb5490e$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $0ae2eb679eb5490e$var$useLatestRef(unstable_initial);
    const openRef = $0ae2eb679eb5490e$var$useLatestRef(unstable_open);
    const closeRef = $0ae2eb679eb5490e$var$useLatestRef(unstable_close);
    const commonRef = $0ae2eb679eb5490e$var$useLatestRef(unstable_common);
    $0ae2eb679eb5490e$var$index(()=>{
        const initialStyles = $0ae2eb679eb5490e$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $0ae2eb679eb5490e$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $0ae2eb679eb5490e$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $0ae2eb679eb5490e$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial') setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === 'open') setStyles({
            transitionProperty: Object.keys(openStyles).map($0ae2eb679eb5490e$var$camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === 'close') {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($0ae2eb679eb5490e$var$camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $0ae2eb679eb5490e$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $7UyaH.useRef();
    const stringRef = $7UyaH.useRef('');
    const prevIndexRef = $7UyaH.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $7UyaH.useRef(null);
    const onMatch = $0ae2eb679eb5490e$var$useEffectEvent(unstable_onMatch);
    const onTypingChange = $0ae2eb679eb5490e$var$useEffectEvent(unstable_onTypingChange);
    const findMatchRef = $0ae2eb679eb5490e$var$useLatestRef(findMatch);
    const ignoreKeysRef = $0ae2eb679eb5490e$var$useLatestRef(ignoreKeys);
    $0ae2eb679eb5490e$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    $0ae2eb679eb5490e$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = $0ae2eb679eb5490e$var$useEffectEvent((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = $0ae2eb679eb5490e$var$useEffectEvent((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === ' ') (0, $6a1c7d7f17eb210d$export$7ae4cd3a66c1e050)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== ' ') {
            (0, $6a1c7d7f17eb210d$export$7ae4cd3a66c1e050)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(()=>{
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== ' ') {
            stringRef.current = '';
            setTypingChange(false);
        }
    });
    const reference = $7UyaH.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $7UyaH.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === ' ') setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $7UyaH.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $0ae2eb679eb5490e$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ const $0ae2eb679eb5490e$export$4ae363f1d88fb658 = (props)=>({
        name: 'inner',
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $1ed36fbf686620c4$export$fef61f332f2c0afc)(props, state);
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $3357e590fc26c933$export$cc800923e997bb8)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await (0, $c44eab932bc33f33$export$37b6bde19b108ecc)($0ae2eb679eb5490e$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await (0, $c44eab932bc33f33$export$37b6bde19b108ecc)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: 'reference'
            });
            const diffY = (0, $1ed36fbf686620c4$export$8960430cfd85939f)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $1ed36fbf686620c4$export$2077e0241d6afd3c);
            const maxHeight = rounder((0, $1ed36fbf686620c4$export$8960430cfd85939f)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $1ed36fbf686620c4$export$8960430cfd85939f)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, $1ed36fbf686620c4$export$96ec731ed4dcb222)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $32e03ff3f068d28e$exports.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await (0, $c44eab932bc33f33$export$37b6bde19b108ecc)($0ae2eb679eb5490e$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function $0ae2eb679eb5490e$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = $0ae2eb679eb5490e$var$useEffectEvent(unstable_onChange);
    const controlledScrollingRef = $7UyaH.useRef(false);
    const prevScrollTopRef = $7UyaH.useRef(null);
    const initialOverflowRef = $7UyaH.useRef(null);
    $7UyaH.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $32e03ff3f068d28e$exports.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $6a1c7d7f17eb210d$export$7935961ef7719cb0)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $7UyaH.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $32e03ff3f068d28e$exports.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $7UyaH.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $0ae2eb679eb5490e$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $0ae2eb679eb5490e$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $0ae2eb679eb5490e$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = (0, $6a1c7d7f17eb210d$export$c22522a4dfa48e9c)(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = (0, $6a1c7d7f17eb210d$export$2344b14b097df817)(elements.floating, target);
            const isOverReferenceEl = (0, $6a1c7d7f17eb210d$export$2344b14b097df817)(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $0ae2eb679eb5490e$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $05207b419b5e3dd6$export$45a5e7f76e0caa8d)(event.relatedTarget) && (0, $6a1c7d7f17eb210d$export$2344b14b097df817)(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $0ae2eb679eb5490e$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($0ae2eb679eb5490e$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$0ae2eb679eb5490e$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $e5a100bdab37c2de$var$_extendStatics = function extendStatics(d, b) {
    $e5a100bdab37c2de$var$_extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e5a100bdab37c2de$var$_extendStatics(d, b);
};
function $e5a100bdab37c2de$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e5a100bdab37c2de$var$_extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e5a100bdab37c2de$var$_assign = function __assign() {
    $e5a100bdab37c2de$var$_assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e5a100bdab37c2de$var$_assign.apply(this, arguments);
};
function $e5a100bdab37c2de$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
var $e5a100bdab37c2de$export$946daa762919616e = function(_a) {
    var _b = _a.showTimeSelectOnly, showTimeSelectOnly = _b === void 0 ? false : _b, _c = _a.showTime, showTime = _c === void 0 ? false : _c, className = _a.className, children = _a.children, inline = _a.inline;
    var ariaLabel = showTimeSelectOnly ? "Choose Time" : "Choose Date".concat(showTime ? " and Time" : "");
    return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
        className: className,
        "aria-label": ariaLabel,
        role: inline ? undefined : "dialog",
        "aria-modal": inline ? undefined : "true",
        translate: "no"
    }, children);
};
var $e5a100bdab37c2de$var$useDetectClickOutside = function(onClickOutside, ignoreClass) {
    var ref = (0, $7UyaH.useRef)(null);
    var onClickOutsideRef = (0, $7UyaH.useRef)(onClickOutside);
    (0, $7UyaH.useEffect)(function() {
        onClickOutsideRef.current = onClickOutside;
    }, [
        onClickOutside
    ]);
    var handleClickOutside = (0, $7UyaH.useCallback)(function(event) {
        var _a;
        var target = event.composed && event.composedPath && event.composedPath().find(function(eventTarget) {
            return eventTarget instanceof Node;
        }) || event.target;
        if (ref.current && !ref.current.contains(target)) {
            if (!(ignoreClass && target instanceof HTMLElement && target.classList.contains(ignoreClass))) (_a = onClickOutsideRef.current) === null || _a === void 0 || _a.call(onClickOutsideRef, event);
        }
    }, [
        ignoreClass
    ]);
    (0, $7UyaH.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        handleClickOutside
    ]);
    return ref;
};
var $e5a100bdab37c2de$var$ClickOutsideWrapper = function(_a) {
    var children = _a.children, onClickOutside = _a.onClickOutside, className = _a.className, containerRef = _a.containerRef, style = _a.style, ignoreClass = _a.ignoreClass;
    var detectRef = $e5a100bdab37c2de$var$useDetectClickOutside(onClickOutside, ignoreClass);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
        className: className,
        style: style,
        ref: function(node) {
            detectRef.current = node;
            if (containerRef) containerRef.current = node;
        }
    }, children);
};
// Cache for the date-fns-tz module
var $e5a100bdab37c2de$var$dateFnsTz = null;
var $e5a100bdab37c2de$var$dateFnsTzLoadAttempted = false;
/**
 * Attempts to load date-fns-tz module.
 * Returns null if the module is not installed.
 */ function $e5a100bdab37c2de$var$getDateFnsTz() {
    if ($e5a100bdab37c2de$var$dateFnsTzLoadAttempted) return $e5a100bdab37c2de$var$dateFnsTz;
    $e5a100bdab37c2de$var$dateFnsTzLoadAttempted = true;
    try {
        // Dynamic require for date-fns-tz
        // Use a variable to prevent webpack from statically analyzing the require
        // and showing warnings when the optional dependency is not installed
        // See: https://github.com/Hacker0x01/react-datepicker/issues/6154
        var dateFnsTzModuleName = "date-fns-tz";
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        $e5a100bdab37c2de$var$dateFnsTz = require(dateFnsTzModuleName);
    } catch (_a) {
        /* istanbul ignore next - only executes when date-fns-tz is not installed */ $e5a100bdab37c2de$var$dateFnsTz = null;
    }
    return $e5a100bdab37c2de$var$dateFnsTz;
}
/**
 * Converts a date to the specified timezone.
 * If no timezone is specified or date-fns-tz is not installed, returns the original date.
 *
 * @param date - The date to convert
 * @param timeZone - The IANA timezone identifier (e.g., "America/New_York", "UTC")
 * @returns The date in the specified timezone
 */ function $e5a100bdab37c2de$var$toZonedTime(date, timeZone) {
    if (!timeZone) return date;
    var tz = $e5a100bdab37c2de$var$getDateFnsTz();
    if (!tz) return date;
    return tz.toZonedTime(date, timeZone);
}
/**
 * Converts a date from the specified timezone to UTC.
 * If no timezone is specified or date-fns-tz is not installed, returns the original date.
 *
 * @param date - The date in the specified timezone
 * @param timeZone - The IANA timezone identifier (e.g., "America/New_York", "UTC")
 * @returns The date in UTC
 */ function $e5a100bdab37c2de$var$fromZonedTime(date, timeZone) {
    if (!timeZone) return date;
    var tz = $e5a100bdab37c2de$var$getDateFnsTz();
    if (!tz) return date;
    return tz.fromZonedTime(date, timeZone);
}
var $e5a100bdab37c2de$var$KeyType;
(function(KeyType) {
    KeyType["ArrowUp"] = "ArrowUp";
    KeyType["ArrowDown"] = "ArrowDown";
    KeyType["ArrowLeft"] = "ArrowLeft";
    KeyType["ArrowRight"] = "ArrowRight";
    KeyType["PageUp"] = "PageUp";
    KeyType["PageDown"] = "PageDown";
    KeyType["Home"] = "Home";
    KeyType["End"] = "End";
    KeyType["Enter"] = "Enter";
    KeyType["Space"] = " ";
    KeyType["Tab"] = "Tab";
    KeyType["Escape"] = "Escape";
    KeyType["Backspace"] = "Backspace";
    KeyType["X"] = "x";
})($e5a100bdab37c2de$var$KeyType || ($e5a100bdab37c2de$var$KeyType = {}));
function $e5a100bdab37c2de$var$getLocaleScope() {
    // Use this cast to avoid messing with users globalThis (like window) and the rest of keys in the globalThis object we don't care about
    var scope = typeof window !== "undefined" ? window : globalThis;
    return scope;
}
var $e5a100bdab37c2de$var$DEFAULT_YEAR_ITEM_NUMBER = 12;
// ** Date Constructors **
function $e5a100bdab37c2de$var$newDate(value) {
    if (value == null) return new Date();
    var d = typeof value === "string" ? (0, $e570a7bac6dc48a8$exports.parseISO)(value) : (0, $e570a7bac6dc48a8$exports.toDate)(value);
    return $e5a100bdab37c2de$var$isValid(d) ? d : new Date();
}
/**
 * Parses a date.
 *
 * @param value - The string representing the Date in a parsable form, e.g., ISO 1861
 * @param dateFormat - The date format.
 * @param locale - The locale.
 * @param strictParsing - The strict parsing flag.
 * @param refDate - The base date to be passed to date-fns parse() function.
 * @returns - The parsed date or null.
 */ function $e5a100bdab37c2de$var$parseDate(value, dateFormat, locale, strictParsing, refDate) {
    if (refDate === void 0) refDate = $e5a100bdab37c2de$var$newDate();
    var localeObject = $e5a100bdab37c2de$var$getLocaleObject(locale) || $e5a100bdab37c2de$var$getLocaleObject($e5a100bdab37c2de$export$f09106e7c6677ec5());
    var formats = Array.isArray(dateFormat) ? dateFormat : [
        dateFormat
    ];
    for(var _i = 0, formats_1 = formats; _i < formats_1.length; _i++){
        var format_1 = formats_1[_i];
        var parsedDate = (0, $e570a7bac6dc48a8$exports.parse)(value, format_1, refDate, {
            locale: localeObject,
            useAdditionalWeekYearTokens: true,
            useAdditionalDayOfYearTokens: true
        });
        if ($e5a100bdab37c2de$var$isValid(parsedDate) && (!strictParsing || value === $e5a100bdab37c2de$var$formatDate(parsedDate, format_1, locale))) return parsedDate;
    }
    // When strictParsing is false, try native Date parsing as a fallback
    // This allows flexible input formats like "12/05/2025" or "2025-12-16"
    // even when the dateFormat prop specifies a different format.
    // Only attempt this for inputs that look like complete dates (minimum
    // length of 8 characters, e.g., "1/1/2000") to avoid parsing partial
    // inputs like "03/" or "2000" which should be handled by parseDateForNavigation.
    if (!strictParsing && value && value.length >= 8) {
        var nativeDate = new Date(value);
        if ((0, $e570a7bac6dc48a8$exports.isValid)(nativeDate)) return nativeDate;
    }
    return null;
}
/**
 * Parses a partial date string for calendar navigation purposes.
 * Unlike parseDate, this function attempts to extract whatever date
 * information is available (year, month) from a partial input,
 * returning a date suitable for navigating the calendar view.
 *
 * @param value - The date string to parse.
 * @param refDate - The reference date to use for missing components.
 * @returns - A date for navigation or null if no date info could be extracted.
 */ function $e5a100bdab37c2de$var$parseDateForNavigation(value, refDate) {
    if (refDate === void 0) refDate = $e5a100bdab37c2de$var$newDate();
    if (!value) return null;
    // Try to extract a 4-digit year from the input
    var yearMatch = value.match(/\b(1\d{3}|2\d{3})\b/);
    if (!yearMatch || !yearMatch[1]) return null;
    var year = parseInt(yearMatch[1], 10);
    // Try to extract a month (1-12) from the input
    // Look for patterns like "03/", "/03", "03-", "-03" or standalone "03" at start
    var monthMatch = value.match(/(?:^|[/\-\s])?(0?[1-9]|1[0-2])(?:[/\-\s]|$)/);
    var month = monthMatch && monthMatch[1] ? parseInt(monthMatch[1], 10) - 1 : refDate.getMonth();
    // Return a date with the extracted year and month, using day 1
    return new Date(year, month, 1);
}
/**
 * Checks if a given date is a valid Date object.
 * @param date - The date to be checked.
 * @returns A boolean value indicating whether the date is valid.
 */ function $e5a100bdab37c2de$var$isValid(date) {
    return (0, $e570a7bac6dc48a8$exports.isValid)(date);
}
/**
 * Safely returns a valid Date or null.
 * This handles cases where a value might be passed as a string or other
 * invalid type at runtime, even though TypeScript expects a Date.
 * @param date - The value to check (typed as Date but could be anything at runtime)
 * @returns The date if it's a valid Date object, otherwise null
 */ function $e5a100bdab37c2de$var$safeToDate(date) {
    if (date == null) return null;
    // Check if it's actually a Date object AND is valid
    if ((0, $e570a7bac6dc48a8$exports.isDate)(date) && (0, $e570a7bac6dc48a8$exports.isValid)(date)) return date;
    return null;
}
// ** Date Formatting **
/**
 * Formats a date.
 *
 * @param date - The date.
 * @param formatStr - The format string.
 * @param locale - The locale.
 * @returns - The formatted date.
 */ function $e5a100bdab37c2de$var$formatDate(date, formatStr, locale) {
    if (locale === "en") return (0, $e570a7bac6dc48a8$exports.format)(date, formatStr, {
        useAdditionalWeekYearTokens: true,
        useAdditionalDayOfYearTokens: true
    });
    var localeObj = locale ? $e5a100bdab37c2de$var$getLocaleObject(locale) : undefined;
    if (locale && !localeObj) console.warn("A locale object was not found for the provided string [\"".concat(locale, "\"]."));
    localeObj = localeObj || $e5a100bdab37c2de$var$getLocaleObject($e5a100bdab37c2de$export$f09106e7c6677ec5());
    return (0, $e570a7bac6dc48a8$exports.format)(date, formatStr, {
        locale: localeObj,
        useAdditionalWeekYearTokens: true,
        useAdditionalDayOfYearTokens: true
    });
}
/**
 * Safely formats a date.
 *
 * @param date - The date.
 * @param options - An object containing the dateFormat and locale.
 * @returns - The formatted date or an empty string.
 */ function $e5a100bdab37c2de$var$safeDateFormat(date, _a) {
    var dateFormat = _a.dateFormat, locale = _a.locale;
    var formatStr = Array.isArray(dateFormat) && dateFormat.length > 0 ? dateFormat[0] : dateFormat; // Cast to string because it's impossible to get `string | string[] | undefined` here and typescript doesn't know that
    return date && $e5a100bdab37c2de$var$formatDate(date, formatStr, locale) || "";
}
/**
 * Used as a delimiter to separate two dates when formatting a date range
 */ var $e5a100bdab37c2de$var$DATE_RANGE_SEPARATOR = " - ";
/**
 * Safely formats a date range.
 *
 * @param startDate - The start date.
 * @param endDate - The end date.
 * @param props - The props.
 * @returns - The formatted date range or an empty string.
 */ function $e5a100bdab37c2de$var$safeDateRangeFormat(startDate, endDate, props) {
    if (!startDate && !endDate) return "";
    var formattedStartDate = startDate ? $e5a100bdab37c2de$var$safeDateFormat(startDate, props) : "";
    var formattedEndDate = endDate ? $e5a100bdab37c2de$var$safeDateFormat(endDate, props) : "";
    var dateRangeSeparator = props.rangeSeparator || $e5a100bdab37c2de$var$DATE_RANGE_SEPARATOR;
    return "".concat(formattedStartDate).concat(dateRangeSeparator).concat(formattedEndDate);
}
/**
 * Safely formats multiple dates.
 *
 * @param dates - The dates.
 * @param props - The props.
 * @returns - The formatted dates or an empty string.
 */ function $e5a100bdab37c2de$var$safeMultipleDatesFormat(dates, props) {
    if (!(dates === null || dates === void 0 ? void 0 : dates.length)) return "";
    var formattedFirstDate = dates[0] ? $e5a100bdab37c2de$var$safeDateFormat(dates[0], props) : "";
    if (dates.length === 1) return formattedFirstDate;
    if (dates.length === 2 && dates[1]) {
        var formattedSecondDate = $e5a100bdab37c2de$var$safeDateFormat(dates[1], props);
        return "".concat(formattedFirstDate, ", ").concat(formattedSecondDate);
    }
    var extraDatesCount = dates.length - 1;
    return "".concat(formattedFirstDate, " (+").concat(extraDatesCount, ")");
}
// ** Date Setters **
/**
 * Sets the time for a given date.
 *
 * @param date - The date.
 * @param time - An object containing the hour, minute, and second.
 * @returns - The date with the time set.
 */ function $e5a100bdab37c2de$var$setTime(date, _a) {
    var _b = _a.hour, hour = _b === void 0 ? 0 : _b, _c = _a.minute, minute = _c === void 0 ? 0 : _c, _d = _a.second, second = _d === void 0 ? 0 : _d;
    return (0, $e570a7bac6dc48a8$exports.setHours)((0, $e570a7bac6dc48a8$exports.setMinutes)((0, $e570a7bac6dc48a8$exports.setSeconds)(date, second), minute), hour);
}
/**
 * Gets the week of the year for a given date.
 *
 * @param date - The date.
 * @returns - The week of the year.
 */ function $e5a100bdab37c2de$var$getWeek(date) {
    return (0, $e570a7bac6dc48a8$exports.getISOWeek)(date);
}
/**
 * Gets the day of the week code for a given day.
 *
 * @param day - The day.
 * @param locale - The locale.
 * @returns - The day of the week code.
 */ function $e5a100bdab37c2de$var$getDayOfWeekCode(day, locale) {
    return $e5a100bdab37c2de$var$formatDate(day, "ddd", locale);
}
// *** Start of ***
/**
 * Gets the start of the day for a given date.
 *
 * @param date - The date.
 * @returns - The start of the day.
 */ function $e5a100bdab37c2de$var$getStartOfDay(date) {
    return (0, $e570a7bac6dc48a8$exports.startOfDay)(date);
}
/**
 * Gets the start of the week for a given date.
 *
 * @param date - The date.
 * @param locale - The locale.
 * @param calendarStartDay - The day the calendar starts on.
 * @returns - The start of the week.
 */ function $e5a100bdab37c2de$var$getStartOfWeek(date, locale, calendarStartDay) {
    var localeObj = locale ? $e5a100bdab37c2de$var$getLocaleObject(locale) : $e5a100bdab37c2de$var$getLocaleObject($e5a100bdab37c2de$export$f09106e7c6677ec5());
    return (0, $e570a7bac6dc48a8$exports.startOfWeek)(date, {
        locale: localeObj,
        weekStartsOn: calendarStartDay
    });
}
/**
 * Gets the start of the month for a given date.
 *
 * @param date - The date.
 * @returns - The start of the month.
 */ function $e5a100bdab37c2de$var$getStartOfMonth(date) {
    return (0, $e570a7bac6dc48a8$exports.startOfMonth)(date);
}
/**
 * Gets the start of the year for a given date.
 *
 * @param date - The date.
 * @returns - The start of the year.
 */ function $e5a100bdab37c2de$var$getStartOfYear(date) {
    return (0, $e570a7bac6dc48a8$exports.startOfYear)(date);
}
/**
 * Gets the start of the quarter for a given date.
 *
 * @param date - The date.
 * @returns - The start of the quarter.
 */ function $e5a100bdab37c2de$var$getStartOfQuarter(date) {
    return (0, $e570a7bac6dc48a8$exports.startOfQuarter)(date);
}
/**
 * Gets the start of today.
 *
 * @returns - The start of today.
 */ function $e5a100bdab37c2de$var$getStartOfToday() {
    return (0, $e570a7bac6dc48a8$exports.startOfDay)($e5a100bdab37c2de$var$newDate());
}
// *** End of ***
/**
 * Gets the end of the day for a given date.
 *
 * @param date - The date.
 * @returns - The end of the day.
 */ function $e5a100bdab37c2de$var$getEndOfDay(date) {
    return (0, $e570a7bac6dc48a8$exports.endOfDay)(date);
}
/**
 * Gets the end of the week for a given date.
 *
 * @param date - The date.
 * @returns - The end of the week.
 */ function $e5a100bdab37c2de$var$getEndOfWeek(date) {
    return (0, $e570a7bac6dc48a8$exports.endOfWeek)(date);
}
/**
 * Gets the end of the month for a given date.
 *
 * @param date - The date.
 * @returns - The end of the month.
 */ function $e5a100bdab37c2de$var$getEndOfMonth(date) {
    return (0, $e570a7bac6dc48a8$exports.endOfMonth)(date);
}
/**
 * Checks if two dates are in the same year.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are in the same year, false otherwise.
 */ function $e5a100bdab37c2de$var$isSameYear(date1, date2) {
    if (date1 && date2) return (0, $e570a7bac6dc48a8$exports.isSameYear)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are in the same month.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are in the same month, false otherwise.
 */ function $e5a100bdab37c2de$var$isSameMonth(date1, date2) {
    if (date1 && date2) return (0, $e570a7bac6dc48a8$exports.isSameMonth)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are in the same quarter.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are in the same quarter, false otherwise.
 */ function $e5a100bdab37c2de$var$isSameQuarter(date1, date2) {
    if (date1 && date2) return (0, $e570a7bac6dc48a8$exports.isSameQuarter)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are on the same day.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are on the same day, false otherwise.
 */ function $e5a100bdab37c2de$var$isSameDay(date1, date2) {
    if (date1 && date2) return (0, $e570a7bac6dc48a8$exports.isSameDay)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are equal.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are equal, false otherwise.
 */ function $e5a100bdab37c2de$var$isEqual(date1, date2) {
    if (date1 && date2) return (0, $e570a7bac6dc48a8$exports.isEqual)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if a day is within a date range.
 *
 * @param day - The day to check.
 * @param startDate - The start date of the range.
 * @param endDate - The end date of the range.
 * @returns - True if the day is within the range, false otherwise.
 */ function $e5a100bdab37c2de$var$isDayInRange(day, startDate, endDate) {
    var valid;
    var start = (0, $e570a7bac6dc48a8$exports.startOfDay)(startDate);
    var end = (0, $e570a7bac6dc48a8$exports.endOfDay)(endDate);
    try {
        valid = (0, $e570a7bac6dc48a8$exports.isWithinInterval)(day, {
            start: start,
            end: end
        });
    } catch (err) {
        valid = false;
    }
    return valid;
}
// ** Date Localization **
/**
 * Registers a locale.
 *
 * @param localeName - The name of the locale.
 * @param localeData - The data of the locale.
 */ function $e5a100bdab37c2de$export$bab6a7822cc1e2cd(localeName, localeData) {
    var scope = $e5a100bdab37c2de$var$getLocaleScope();
    if (!scope.__localeData__) scope.__localeData__ = {};
    scope.__localeData__[localeName] = localeData;
}
/**
 * Sets the default locale.
 *
 * @param localeName - The name of the locale.
 */ function $e5a100bdab37c2de$export$a1a5025df4e9ba34(localeName) {
    var scope = $e5a100bdab37c2de$var$getLocaleScope();
    scope.__localeId__ = localeName;
}
/**
 * Gets the default locale.
 *
 * @returns - The default locale.
 */ function $e5a100bdab37c2de$export$f09106e7c6677ec5() {
    var scope = $e5a100bdab37c2de$var$getLocaleScope();
    return scope.__localeId__;
}
/**
 * Gets the locale object.
 *
 * @param localeSpec - The locale specification.
 * @returns - The locale object.
 */ function $e5a100bdab37c2de$var$getLocaleObject(localeSpec) {
    if (typeof localeSpec === "string") {
        // Treat it as a locale name registered by registerLocale
        var scope = $e5a100bdab37c2de$var$getLocaleScope();
        // Null was replaced with undefined to avoid type coercion
        return scope.__localeData__ ? scope.__localeData__[localeSpec] : undefined;
    } else // Treat it as a raw date-fns locale object
    return localeSpec;
}
/**
 * Formats the weekday in a given locale.
 *
 * @param date - The date to format.
 * @param formatFunc - The formatting function.
 * @param locale - The locale to use for formatting.
 * @returns - The formatted weekday.
 */ function $e5a100bdab37c2de$var$getFormattedWeekdayInLocale(date, formatFunc, locale) {
    return formatFunc($e5a100bdab37c2de$var$formatDate(date, "EEEE", locale));
}
/**
 * Gets the minimum weekday in a given locale.
 *
 * @param date - The date to format.
 * @param locale - The locale to use for formatting.
 * @returns - The minimum weekday.
 */ function $e5a100bdab37c2de$var$getWeekdayMinInLocale(date, locale) {
    return $e5a100bdab37c2de$var$formatDate(date, "EEEEEE", locale);
}
/**
 * Gets the short weekday in a given locale.
 *
 * @param date - The date to format.
 * @param locale - The locale to use for formatting.
 * @returns - The short weekday.
 */ function $e5a100bdab37c2de$var$getWeekdayShortInLocale(date, locale) {
    return $e5a100bdab37c2de$var$formatDate(date, "EEE", locale);
}
/**
 * Gets the month in a given locale.
 *
 * @param month - The month to format.
 * @param locale - The locale to use for formatting.
 * @returns - The month.
 */ function $e5a100bdab37c2de$var$getMonthInLocale(month, locale) {
    return $e5a100bdab37c2de$var$formatDate((0, $e570a7bac6dc48a8$exports.setMonth)($e5a100bdab37c2de$var$newDate(), month), "LLLL", locale);
}
/**
 * Gets the short month in a given locale.
 *
 * @param month - The month to format.
 * @param locale - The locale to use for formatting.
 * @returns - The short month.
 */ function $e5a100bdab37c2de$var$getMonthShortInLocale(month, locale) {
    return $e5a100bdab37c2de$var$formatDate((0, $e570a7bac6dc48a8$exports.setMonth)($e5a100bdab37c2de$var$newDate(), month), "LLL", locale);
}
/**
 * Gets the short quarter in a given locale.
 *
 * @param quarter - The quarter to format.
 * @param locale - The locale to use for formatting.
 * @returns - The short quarter.
 */ function $e5a100bdab37c2de$var$getQuarterShortInLocale(quarter, locale) {
    return $e5a100bdab37c2de$var$formatDate((0, $e570a7bac6dc48a8$exports.setQuarter)($e5a100bdab37c2de$var$newDate(), quarter), "QQQ", locale);
}
/**
 * Checks if a day is disabled.
 *
 * @param day - The day to check.
 * @param options - The options to consider when checking.
 * @returns - Returns true if the day is disabled, false otherwise.
 */ function $e5a100bdab37c2de$var$isDayDisabled(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, excludeDateIntervals = _b.excludeDateIntervals, includeDates = _b.includeDates, includeDateIntervals = _b.includeDateIntervals, filterDate = _b.filterDate, disabled = _b.disabled;
    if (disabled) return true;
    return $e5a100bdab37c2de$var$isOutOfBounds(day, {
        minDate: minDate,
        maxDate: maxDate
    }) || excludeDates && excludeDates.some(function(excludeDate) {
        if (excludeDate instanceof Date) return $e5a100bdab37c2de$var$isSameDay(day, excludeDate);
        else return $e5a100bdab37c2de$var$isSameDay(day, excludeDate.date);
    }) || excludeDateIntervals && excludeDateIntervals.some(function(_a) {
        var start = _a.start, end = _a.end;
        return (0, $e570a7bac6dc48a8$exports.isWithinInterval)(day, {
            start: start,
            end: end
        });
    }) || includeDates && !includeDates.some(function(includeDate) {
        return $e5a100bdab37c2de$var$isSameDay(day, includeDate);
    }) || includeDateIntervals && !includeDateIntervals.some(function(_a) {
        var start = _a.start, end = _a.end;
        return (0, $e570a7bac6dc48a8$exports.isWithinInterval)(day, {
            start: start,
            end: end
        });
    }) || filterDate && !filterDate($e5a100bdab37c2de$var$newDate(day)) || false;
}
/**
 * Checks if a day is excluded.
 *
 * @param day - The day to check.
 * @param options - The options to consider when checking.
 * @returns - Returns true if the day is excluded, false otherwise.
 */ function $e5a100bdab37c2de$var$isDayExcluded(day, _a) {
    var _b = _a === void 0 ? {} : _a, excludeDates = _b.excludeDates, excludeDateIntervals = _b.excludeDateIntervals;
    if (excludeDateIntervals && excludeDateIntervals.length > 0) return excludeDateIntervals.some(function(_a) {
        var start = _a.start, end = _a.end;
        return (0, $e570a7bac6dc48a8$exports.isWithinInterval)(day, {
            start: start,
            end: end
        });
    });
    return excludeDates && excludeDates.some(function(excludeDate) {
        var _a;
        if (excludeDate instanceof Date) return $e5a100bdab37c2de$var$isSameDay(day, excludeDate);
        else return $e5a100bdab37c2de$var$isSameDay(day, (_a = excludeDate.date) !== null && _a !== void 0 ? _a : new Date());
    }) || false;
}
function $e5a100bdab37c2de$var$isMonthDisabled(month, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate;
    return $e5a100bdab37c2de$var$isOutOfBounds(month, {
        minDate: minDate ? (0, $e570a7bac6dc48a8$exports.startOfMonth)(minDate) : undefined,
        maxDate: maxDate ? (0, $e570a7bac6dc48a8$exports.endOfMonth)(maxDate) : undefined
    }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
        return $e5a100bdab37c2de$var$isSameMonth(month, excludeDate instanceof Date ? excludeDate : excludeDate.date);
    })) || includeDates && !includeDates.some(function(includeDate) {
        return $e5a100bdab37c2de$var$isSameMonth(month, includeDate);
    }) || filterDate && !filterDate($e5a100bdab37c2de$var$newDate(month)) || false;
}
function $e5a100bdab37c2de$var$isMonthInRange(startDate, endDate, m, day) {
    var startDateYear = (0, $e570a7bac6dc48a8$exports.getYear)(startDate);
    var startDateMonth = (0, $e570a7bac6dc48a8$exports.getMonth)(startDate);
    var endDateYear = (0, $e570a7bac6dc48a8$exports.getYear)(endDate);
    var endDateMonth = (0, $e570a7bac6dc48a8$exports.getMonth)(endDate);
    var dayYear = (0, $e570a7bac6dc48a8$exports.getYear)(day);
    if (startDateYear === endDateYear && startDateYear === dayYear) return startDateMonth <= m && m <= endDateMonth;
    else if (startDateYear < endDateYear) return dayYear === startDateYear && startDateMonth <= m || dayYear === endDateYear && endDateMonth >= m || dayYear < endDateYear && dayYear > startDateYear;
    return false;
}
/**
 * To check if a date's month and year are disabled/excluded
 * @param date Date to check
 * @returns {boolean} true if month and year are disabled/excluded, false otherwise
 */ function $e5a100bdab37c2de$var$isMonthYearDisabled(date, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates;
    return $e5a100bdab37c2de$var$isOutOfBounds(date, {
        minDate: minDate,
        maxDate: maxDate
    }) || excludeDates && excludeDates.some(function(excludedDate) {
        return $e5a100bdab37c2de$var$isSameMonth(excludedDate instanceof Date ? excludedDate : excludedDate.date, date);
    }) || includeDates && !includeDates.some(function(includedDate) {
        return $e5a100bdab37c2de$var$isSameMonth(includedDate, date);
    }) || false;
}
function $e5a100bdab37c2de$var$isQuarterDisabled(quarter, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate, disabled = _b.disabled;
    if (disabled) return true;
    return $e5a100bdab37c2de$var$isOutOfBounds(quarter, {
        minDate: minDate,
        maxDate: maxDate
    }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
        return $e5a100bdab37c2de$var$isSameQuarter(quarter, excludeDate instanceof Date ? excludeDate : excludeDate.date);
    })) || includeDates && !includeDates.some(function(includeDate) {
        return $e5a100bdab37c2de$var$isSameQuarter(quarter, includeDate);
    }) || filterDate && !filterDate($e5a100bdab37c2de$var$newDate(quarter)) || false;
}
function $e5a100bdab37c2de$var$isYearInRange(year, start, end) {
    if (!start || !end) return false;
    if (!(0, $e570a7bac6dc48a8$exports.isValid)(start) || !(0, $e570a7bac6dc48a8$exports.isValid)(end)) return false;
    var startYear = (0, $e570a7bac6dc48a8$exports.getYear)(start);
    var endYear = (0, $e570a7bac6dc48a8$exports.getYear)(end);
    return startYear <= year && endYear >= year;
}
function $e5a100bdab37c2de$var$isYearDisabled(year, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate, disabled = _b.disabled;
    if (disabled) return true;
    var date = new Date(year, 0, 1);
    return $e5a100bdab37c2de$var$isOutOfBounds(date, {
        minDate: minDate ? (0, $e570a7bac6dc48a8$exports.startOfYear)(minDate) : undefined,
        maxDate: maxDate ? (0, $e570a7bac6dc48a8$exports.endOfYear)(maxDate) : undefined
    }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
        return $e5a100bdab37c2de$var$isSameYear(date, excludeDate instanceof Date ? excludeDate : excludeDate.date);
    })) || includeDates && !includeDates.some(function(includeDate) {
        return $e5a100bdab37c2de$var$isSameYear(date, includeDate);
    }) || filterDate && !filterDate($e5a100bdab37c2de$var$newDate(date)) || false;
}
function $e5a100bdab37c2de$var$isQuarterInRange(startDate, endDate, q, day) {
    var startDateYear = (0, $e570a7bac6dc48a8$exports.getYear)(startDate);
    var startDateQuarter = (0, $e570a7bac6dc48a8$exports.getQuarter)(startDate);
    var endDateYear = (0, $e570a7bac6dc48a8$exports.getYear)(endDate);
    var endDateQuarter = (0, $e570a7bac6dc48a8$exports.getQuarter)(endDate);
    var dayYear = (0, $e570a7bac6dc48a8$exports.getYear)(day);
    if (startDateYear === endDateYear && startDateYear === dayYear) return startDateQuarter <= q && q <= endDateQuarter;
    else if (startDateYear < endDateYear) return dayYear === startDateYear && startDateQuarter <= q || dayYear === endDateYear && endDateQuarter >= q || dayYear < endDateYear && dayYear > startDateYear;
    return false;
}
function $e5a100bdab37c2de$var$isOutOfBounds(day, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, minDate = _c.minDate, maxDate = _c.maxDate;
    return (_b = minDate && (0, $e570a7bac6dc48a8$exports.differenceInCalendarDays)(day, minDate) < 0 || maxDate && (0, $e570a7bac6dc48a8$exports.differenceInCalendarDays)(day, maxDate) > 0) !== null && _b !== void 0 ? _b : false;
}
function $e5a100bdab37c2de$var$isTimeInList(time, times) {
    return times.some(function(listTime) {
        return (0, $e570a7bac6dc48a8$exports.getHours)(listTime) === (0, $e570a7bac6dc48a8$exports.getHours)(time) && (0, $e570a7bac6dc48a8$exports.getMinutes)(listTime) === (0, $e570a7bac6dc48a8$exports.getMinutes)(time) && (0, $e570a7bac6dc48a8$exports.getSeconds)(listTime) === (0, $e570a7bac6dc48a8$exports.getSeconds)(time);
    });
}
function $e5a100bdab37c2de$var$isTimeDisabled(time, _a) {
    var _b = _a === void 0 ? {} : _a, excludeTimes = _b.excludeTimes, includeTimes = _b.includeTimes, filterTime = _b.filterTime;
    return excludeTimes && $e5a100bdab37c2de$var$isTimeInList(time, excludeTimes) || includeTimes && !$e5a100bdab37c2de$var$isTimeInList(time, includeTimes) || filterTime && !filterTime(time) || false;
}
function $e5a100bdab37c2de$var$isTimeInDisabledRange(time, _a) {
    var minTime = _a.minTime, maxTime = _a.maxTime;
    if (!minTime || !maxTime) throw new Error("Both minTime and maxTime props required");
    var baseTime = $e5a100bdab37c2de$var$newDate();
    baseTime = (0, $e570a7bac6dc48a8$exports.setHours)(baseTime, (0, $e570a7bac6dc48a8$exports.getHours)(time));
    baseTime = (0, $e570a7bac6dc48a8$exports.setMinutes)(baseTime, (0, $e570a7bac6dc48a8$exports.getMinutes)(time));
    baseTime = (0, $e570a7bac6dc48a8$exports.setSeconds)(baseTime, (0, $e570a7bac6dc48a8$exports.getSeconds)(time));
    var min = $e5a100bdab37c2de$var$newDate();
    min = (0, $e570a7bac6dc48a8$exports.setHours)(min, (0, $e570a7bac6dc48a8$exports.getHours)(minTime));
    min = (0, $e570a7bac6dc48a8$exports.setMinutes)(min, (0, $e570a7bac6dc48a8$exports.getMinutes)(minTime));
    min = (0, $e570a7bac6dc48a8$exports.setSeconds)(min, (0, $e570a7bac6dc48a8$exports.getSeconds)(minTime));
    var max = $e5a100bdab37c2de$var$newDate();
    max = (0, $e570a7bac6dc48a8$exports.setHours)(max, (0, $e570a7bac6dc48a8$exports.getHours)(maxTime));
    max = (0, $e570a7bac6dc48a8$exports.setMinutes)(max, (0, $e570a7bac6dc48a8$exports.getMinutes)(maxTime));
    max = (0, $e570a7bac6dc48a8$exports.setSeconds)(max, (0, $e570a7bac6dc48a8$exports.getSeconds)(maxTime));
    var valid;
    try {
        valid = !(0, $e570a7bac6dc48a8$exports.isWithinInterval)(baseTime, {
            start: min,
            end: max
        });
    } catch (err) {
        /* istanbul ignore next - date-fns historically threw on invalid intervals */ valid = false;
    }
    return valid;
}
function $e5a100bdab37c2de$var$monthDisabledBefore(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var previousMonth = (0, $e570a7bac6dc48a8$exports.subMonths)(day, 1);
    return minDate && (0, $e570a7bac6dc48a8$exports.differenceInCalendarMonths)(minDate, previousMonth) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $e570a7bac6dc48a8$exports.differenceInCalendarMonths)(includeDate, previousMonth) > 0;
    }) || false;
}
function $e5a100bdab37c2de$var$monthDisabledAfter(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var nextMonth = (0, $e570a7bac6dc48a8$exports.addMonths)(day, 1);
    return maxDate && (0, $e570a7bac6dc48a8$exports.differenceInCalendarMonths)(nextMonth, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $e570a7bac6dc48a8$exports.differenceInCalendarMonths)(nextMonth, includeDate) > 0;
    }) || false;
}
function $e5a100bdab37c2de$var$quarterDisabledBefore(date, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var firstDateOfYear = (0, $e570a7bac6dc48a8$exports.startOfYear)(date);
    var previousQuarter = (0, $e570a7bac6dc48a8$exports.subQuarters)(firstDateOfYear, 1);
    return minDate && (0, $e570a7bac6dc48a8$exports.differenceInCalendarQuarters)(minDate, previousQuarter) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $e570a7bac6dc48a8$exports.differenceInCalendarQuarters)(includeDate, previousQuarter) > 0;
    }) || false;
}
function $e5a100bdab37c2de$var$quarterDisabledAfter(date, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var lastDateOfYear = (0, $e570a7bac6dc48a8$exports.endOfYear)(date);
    var nextQuarter = (0, $e570a7bac6dc48a8$exports.addQuarters)(lastDateOfYear, 1);
    return maxDate && (0, $e570a7bac6dc48a8$exports.differenceInCalendarQuarters)(nextQuarter, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $e570a7bac6dc48a8$exports.differenceInCalendarQuarters)(nextQuarter, includeDate) > 0;
    }) || false;
}
function $e5a100bdab37c2de$var$yearDisabledBefore(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var previousYear = (0, $e570a7bac6dc48a8$exports.subYears)(day, 1);
    return minDate && (0, $e570a7bac6dc48a8$exports.differenceInCalendarYears)(minDate, previousYear) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $e570a7bac6dc48a8$exports.differenceInCalendarYears)(includeDate, previousYear) > 0;
    }) || false;
}
function $e5a100bdab37c2de$var$yearsDisabledBefore(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? $e5a100bdab37c2de$var$DEFAULT_YEAR_ITEM_NUMBER : _c;
    var previousYear = $e5a100bdab37c2de$var$getStartOfYear((0, $e570a7bac6dc48a8$exports.subYears)(day, yearItemNumber));
    var endPeriod = $e5a100bdab37c2de$var$getYearsPeriod(previousYear, yearItemNumber).endPeriod;
    var minDateYear = minDate && (0, $e570a7bac6dc48a8$exports.getYear)(minDate);
    return minDateYear && minDateYear > endPeriod || false;
}
function $e5a100bdab37c2de$var$yearDisabledAfter(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var nextYear = (0, $e570a7bac6dc48a8$exports.addYears)(day, 1);
    return maxDate && (0, $e570a7bac6dc48a8$exports.differenceInCalendarYears)(nextYear, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $e570a7bac6dc48a8$exports.differenceInCalendarYears)(nextYear, includeDate) > 0;
    }) || false;
}
function $e5a100bdab37c2de$var$yearsDisabledAfter(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? $e5a100bdab37c2de$var$DEFAULT_YEAR_ITEM_NUMBER : _c;
    var nextYear = (0, $e570a7bac6dc48a8$exports.addYears)(day, yearItemNumber);
    var startPeriod = $e5a100bdab37c2de$var$getYearsPeriod(nextYear, yearItemNumber).startPeriod;
    var maxDateYear = maxDate && (0, $e570a7bac6dc48a8$exports.getYear)(maxDate);
    return maxDateYear && maxDateYear < startPeriod || false;
}
function $e5a100bdab37c2de$var$getEffectiveMinDate(_a) {
    var minDate = _a.minDate, includeDates = _a.includeDates;
    if (includeDates && minDate) {
        var minDates = includeDates.filter(function(includeDate) {
            return (0, $e570a7bac6dc48a8$exports.differenceInCalendarDays)(includeDate, minDate) >= 0;
        });
        return (0, $e570a7bac6dc48a8$exports.min)(minDates);
    } else if (includeDates) return (0, $e570a7bac6dc48a8$exports.min)(includeDates);
    else return minDate;
}
function $e5a100bdab37c2de$var$getEffectiveMaxDate(_a) {
    var maxDate = _a.maxDate, includeDates = _a.includeDates;
    if (includeDates && maxDate) {
        var maxDates = includeDates.filter(function(includeDate) {
            return (0, $e570a7bac6dc48a8$exports.differenceInCalendarDays)(includeDate, maxDate) <= 0;
        });
        return (0, $e570a7bac6dc48a8$exports.max)(maxDates);
    } else if (includeDates) return (0, $e570a7bac6dc48a8$exports.max)(includeDates);
    else return maxDate;
}
/**
 * Get a map of highlighted dates with their corresponding classes.
 * @param highlightDates The dates to highlight.
 * @param defaultClassName The default class to use for highlighting.
 * @returns A map with dates as keys and arrays of class names as values.
 */ function $e5a100bdab37c2de$var$getHighLightDaysMap(highlightDates, defaultClassName) {
    var _a;
    if (highlightDates === void 0) highlightDates = [];
    if (defaultClassName === void 0) defaultClassName = "react-datepicker__day--highlighted";
    var dateClasses = new Map();
    for(var i = 0, len = highlightDates.length; i < len; i++){
        var obj = highlightDates[i];
        if ((0, $e570a7bac6dc48a8$exports.isDate)(obj)) {
            var key = $e5a100bdab37c2de$var$formatDate(obj, "MM.dd.yyyy");
            var classNamesArr = dateClasses.get(key) || [];
            if (!classNamesArr.includes(defaultClassName)) {
                classNamesArr.push(defaultClassName);
                dateClasses.set(key, classNamesArr);
            }
        } else if (typeof obj === "object") {
            var keys = Object.keys(obj);
            var className = (_a = keys[0]) !== null && _a !== void 0 ? _a : "";
            var arrOfDates = obj[className];
            if (typeof className === "string" && Array.isArray(arrOfDates)) for(var k = 0, len_1 = arrOfDates.length; k < len_1; k++){
                var dateK = arrOfDates[k];
                if (dateK) {
                    var key = $e5a100bdab37c2de$var$formatDate(dateK, "MM.dd.yyyy");
                    var classNamesArr = dateClasses.get(key) || [];
                    if (!classNamesArr.includes(className)) {
                        classNamesArr.push(className);
                        dateClasses.set(key, classNamesArr);
                    }
                }
            }
        }
    }
    return dateClasses;
}
/**
 * Compare the two arrays
 * @param array1 The first array to compare.
 * @param array2 The second array to compare.
 * @returns true, if the passed arrays are equal, false otherwise.
 */ function $e5a100bdab37c2de$var$arraysAreEqual(array1, array2) {
    if (array1.length !== array2.length) return false;
    return array1.every(function(value, index) {
        return value === array2[index];
    });
}
/**
 * Assign the custom class to each date
 * @param holidayDates array of object containing date and name of the holiday
 * @param defaultClassName className to be added.
 * @returns Map containing date as key and array of className and holiday name as value
 */ function $e5a100bdab37c2de$var$getHolidaysMap(holidayDates, defaultClassName) {
    if (holidayDates === void 0) holidayDates = [];
    if (defaultClassName === void 0) defaultClassName = "react-datepicker__day--holidays";
    var dateClasses = new Map();
    holidayDates.forEach(function(holiday) {
        var dateObj = holiday.date, holidayName = holiday.holidayName;
        if (!(0, $e570a7bac6dc48a8$exports.isDate)(dateObj)) return;
        var key = $e5a100bdab37c2de$var$formatDate(dateObj, "MM.dd.yyyy");
        var classNamesObj = dateClasses.get(key) || {
            className: "",
            holidayNames: []
        };
        if ("className" in classNamesObj && classNamesObj["className"] === defaultClassName && $e5a100bdab37c2de$var$arraysAreEqual(classNamesObj["holidayNames"], [
            holidayName
        ])) return;
        classNamesObj["className"] = defaultClassName;
        var holidayNameArr = classNamesObj["holidayNames"];
        classNamesObj["holidayNames"] = holidayNameArr ? $e5a100bdab37c2de$var$__spreadArray($e5a100bdab37c2de$var$__spreadArray([], holidayNameArr, true), [
            holidayName
        ], false) : [
            holidayName
        ];
        dateClasses.set(key, classNamesObj);
    });
    return dateClasses;
}
/**
 * Determines the times to inject after a given start of day, current time, and multiplier.
 * @param startOfDay The start of the day.
 * @param currentTime The current time.
 * @param currentMultiplier The current multiplier.
 * @param intervals The intervals.
 * @param injectedTimes The times to potentially inject.
 * @returns An array of times to inject.
 */ function $e5a100bdab37c2de$var$timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
    var l = injectedTimes.length;
    var times = [];
    for(var i = 0; i < l; i++){
        var injectedTime = startOfDay;
        var injectedTimeValue = injectedTimes[i];
        if (injectedTimeValue) {
            injectedTime = (0, $e570a7bac6dc48a8$exports.addHours)(injectedTime, (0, $e570a7bac6dc48a8$exports.getHours)(injectedTimeValue));
            injectedTime = (0, $e570a7bac6dc48a8$exports.addMinutes)(injectedTime, (0, $e570a7bac6dc48a8$exports.getMinutes)(injectedTimeValue));
            injectedTime = (0, $e570a7bac6dc48a8$exports.addSeconds)(injectedTime, (0, $e570a7bac6dc48a8$exports.getSeconds)(injectedTimeValue));
        }
        var nextTime = (0, $e570a7bac6dc48a8$exports.addMinutes)(startOfDay, (currentMultiplier + 1) * intervals);
        if ((0, $e570a7bac6dc48a8$exports.isAfter)(injectedTime, currentTime) && (0, $e570a7bac6dc48a8$exports.isBefore)(injectedTime, nextTime) && injectedTimeValue != undefined) times.push(injectedTimeValue);
    }
    return times;
}
/**
 * Adds a leading zero to a number if it's less than 10.
 * @param i The number to add a leading zero to.
 * @returns The number as a string, with a leading zero if it was less than 10.
 */ function $e5a100bdab37c2de$var$addZero(i) {
    return i < 10 ? "0".concat(i) : "".concat(i);
}
/**
 * Gets the start and end years for a period.
 * @param date The date to get the period for.
 * @param yearItemNumber The number of years in the period. Defaults to DEFAULT_YEAR_ITEM_NUMBER.
 * @returns An object with the start and end years for the period.
 */ function $e5a100bdab37c2de$var$getYearsPeriod(date, yearItemNumber) {
    if (yearItemNumber === void 0) yearItemNumber = $e5a100bdab37c2de$var$DEFAULT_YEAR_ITEM_NUMBER;
    var endPeriod = Math.ceil((0, $e570a7bac6dc48a8$exports.getYear)(date) / yearItemNumber) * yearItemNumber;
    var startPeriod = endPeriod - (yearItemNumber - 1);
    return {
        startPeriod: startPeriod,
        endPeriod: endPeriod
    };
}
/**
 * Gets the number of hours in a day.
 * @param d The date to get the number of hours for.
 * @returns The number of hours in the day.
 */ function $e5a100bdab37c2de$var$getHoursInDay(d) {
    var startOfDay = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    var startOfTheNextDay = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 24);
    return Math.round((+startOfTheNextDay - +startOfDay) / 3600000);
}
/**
 * Returns the start of the minute for the given date
 *
 * NOTE: this function is a DST and timezone-safe analog of `date-fns/startOfMinute`
 * do not make changes unless you know what you're doing
 *
 * See comments on https://github.com/Hacker0x01/react-datepicker/pull/4244
 * for more details
 *
 * @param d date
 * @returns start of the minute
 */ function $e5a100bdab37c2de$var$startOfMinute(d) {
    var seconds = d.getSeconds();
    var milliseconds = d.getMilliseconds();
    return (0, $e570a7bac6dc48a8$exports.toDate)(d.getTime() - seconds * 1000 - milliseconds);
}
/**
 * Returns whether the given dates are in the same minute
 *
 * This function is a DST and timezone-safe analog of `date-fns/isSameMinute`
 *
 * @param d1
 * @param d2
 * @returns
 */ function $e5a100bdab37c2de$var$isSameMinute(d1, d2) {
    return $e5a100bdab37c2de$var$startOfMinute(d1).getTime() === $e5a100bdab37c2de$var$startOfMinute(d2).getTime();
}
/**
 * Returns a new datetime object representing the input date with midnight time
 * @param date The date to get the midnight time for
 * @returns A new datetime object representing the input date with midnight time
 */ function $e5a100bdab37c2de$var$getMidnightDate(date) {
    if (!(0, $e570a7bac6dc48a8$exports.isDate)(date)) throw new Error("Invalid date");
    var dateWithoutTime = new Date(date);
    dateWithoutTime.setHours(0, 0, 0, 0);
    return dateWithoutTime;
}
/**
 * Is the first date before the second one?
 * @param date The date that should be before the other one to return true
 * @param dateToCompare The date to compare with
 * @returns The first date is before the second date
 *
 * Note:
 *  This function considers the mid-night of the given dates for comparison.
 *  It evaluates whether date is before dateToCompare based on their mid-night timestamps.
 */ function $e5a100bdab37c2de$var$isDateBefore(date, dateToCompare) {
    if (!(0, $e570a7bac6dc48a8$exports.isDate)(date) || !(0, $e570a7bac6dc48a8$exports.isDate)(dateToCompare)) throw new Error("Invalid date received");
    var midnightDate = $e5a100bdab37c2de$var$getMidnightDate(date);
    var midnightDateToCompare = $e5a100bdab37c2de$var$getMidnightDate(dateToCompare);
    return (0, $e570a7bac6dc48a8$exports.isBefore)(midnightDate, midnightDateToCompare);
}
/**
 * Checks if the space key was pressed down.
 *
 * @param event - The keyboard event.
 * @returns - Returns true if the space key was pressed down, false otherwise.
 */ function $e5a100bdab37c2de$var$isSpaceKeyDown(event) {
    return event.key === $e5a100bdab37c2de$var$KeyType.Space;
}
/**
 * `InputTime` is a React component that manages time input.
 *
 * @component
 * @example
 * <InputTime timeString="12:00" />
 *
 * @param props - The properties that define the `InputTime` component.
 * @param props.onChange - Function that is called when the date changes.
 * @param props.date - The initial date value.
 * @param props.timeString - The initial time string value.
 * @param props.timeInputLabel - The label for the time input.
 * @param props.customTimeInput - An optional custom time input element.
 *
 * @returns The `InputTime` component.
 */ var $e5a100bdab37c2de$var$InputTime = /** @class */ function(_super) {
    $e5a100bdab37c2de$var$__extends(InputTime, _super);
    function InputTime(props) {
        var _this = _super.call(this, props) || this;
        _this.inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createRef();
        _this.onTimeChange = function(time) {
            var _a, _b;
            _this.setState({
                time: time
            });
            var propDate = _this.props.date;
            var isPropDateValid = propDate instanceof Date && !isNaN(+propDate);
            var date = isPropDateValid ? propDate : new Date();
            if (time === null || time === void 0 ? void 0 : time.includes(":")) {
                var _c = time.split(":"), hours = _c[0], minutes = _c[1];
                date.setHours(Number(hours));
                date.setMinutes(Number(minutes));
            }
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, date);
        };
        _this.renderTimeInput = function() {
            var time = _this.state.time;
            var _a = _this.props, date = _a.date, timeString = _a.timeString, customTimeInput = _a.customTimeInput;
            if (customTimeInput) return (0, $7UyaH.cloneElement)(customTimeInput, {
                date: date,
                value: time,
                onChange: _this.onTimeChange
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("input", {
                type: "time",
                className: "react-datepicker-time__input",
                placeholder: "Time",
                name: "time-input",
                ref: _this.inputRef,
                onClick: function() {
                    var _a;
                    (_a = _this.inputRef.current) === null || _a === void 0 || _a.focus();
                },
                required: true,
                value: time,
                onChange: function(event) {
                    _this.onTimeChange(event.target.value || timeString);
                }
            });
        };
        _this.state = {
            time: _this.props.timeString
        };
        return _this;
    }
    InputTime.getDerivedStateFromProps = function(props, state) {
        if (props.timeString !== state.time) return {
            time: props.timeString
        };
        // Return null to indicate no change to state.
        return null;
    };
    InputTime.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: "react-datepicker__input-time-container"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: "react-datepicker-time__caption"
        }, this.props.timeInputLabel), (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: "react-datepicker-time__input-container"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: "react-datepicker-time__input"
        }, this.renderTimeInput())));
    };
    return InputTime;
}((0, $7UyaH.Component));
/**
 * `Day` is a React component that represents a single day in a date picker.
 * It handles the rendering and interaction of a day.
 *
 * @prop ariaLabelPrefixWhenEnabled - Aria label prefix when the day is enabled.
 * @prop ariaLabelPrefixWhenDisabled - Aria label prefix when the day is disabled.
 * @prop disabledKeyboardNavigation - Whether keyboard navigation is disabled.
 * @prop day - The day to be displayed.
 * @prop dayClassName - Function to customize the CSS class of the day.
 * @prop endDate - The end date in a range.
 * @prop highlightDates - Map of dates to be highlighted.
 * @prop holidays - Map of holiday dates.
 * @prop inline - Whether the date picker is inline.
 * @prop shouldFocusDayInline - Whether the day should be focused when date picker is inline.
 * @prop month - The month the day belongs to.
 * @prop onClick - Click event handler.
 * @prop onMouseEnter - Mouse enter event handler.
 * @prop handleOnKeyDown - Key down event handler.
 * @prop usePointerEvent - Whether to use pointer events.
 * @prop preSelection - The date that is currently selected.
 * @prop selected - The selected date.
 * @prop selectingDate - The date currently being selected.
 * @prop selectsEnd - Whether the day can be the end date in a range.
 * @prop selectsStart - Whether the day can be the start date in a range.
 * @prop selectsRange - Whether the day can be in a range.
 * @prop showWeekPicker - Whether to show week picker.
 * @prop showWeekNumber - Whether to show week numbers.
 * @prop selectsDisabledDaysInRange - Whether to select disabled days in a range.
 * @prop selectsMultiple - Whether to allow multiple date selection.
 * @prop selectedDates - Array of selected dates.
 * @prop startDate - The start date in a range.
 * @prop renderDayContents - Function to customize the rendering of the day's contents.
 * @prop containerRef - Ref for the container.
 * @prop excludeDates - Array of dates to be excluded.
 * @prop calendarStartDay - The start day of the week.
 * @prop locale - The locale object.
 * @prop monthShowsDuplicateDaysEnd - Whether to show duplicate days at the end of the month.
 * @prop monthShowsDuplicateDaysStart - Whether to show duplicate days at the start of the month.
 * @prop includeDates - Array of dates to be included.
 * @prop includeDateIntervals - Array of date intervals to be included.
 * @prop minDate - The minimum date that can be selected.
 * @prop maxDate - The maximum date that can be selected.
 *
 * @example
 * ```tsx
 * import React from 'react';
 * import Day from './day';
 *
 * function MyComponent() {
 *   const handleDayClick = (event) => {
 *     console.log('Day clicked', event);
 *   };
 *
 *   const handleDayMouseEnter = (event) => {
 *     console.log('Mouse entered day', event);
 *   };
 *
 *   const renderDayContents = (date) => {
 *     return <div>{date.getDate()}</div>;
 *   };
 *
 *   return (
 *     <Day
 *       day={new Date()}
 *       onClick={handleDayClick}
 *       onMouseEnter={handleDayMouseEnter}
 *       renderDayContents={renderDayContents}
 *     />
 *   );
 * }
 *
 * export default MyComponent;
 * ```
 */ var $e5a100bdab37c2de$var$Day = /** @class */ function(_super) {
    $e5a100bdab37c2de$var$__extends(Day, _super);
    function Day() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dayEl = (0, $7UyaH.createRef)();
        _this.handleClick = function(event) {
            if (!_this.isDisabled() && _this.props.onClick) _this.props.onClick(event);
        };
        _this.handleMouseEnter = function(event) {
            if (!_this.isDisabled() && _this.props.onMouseEnter) _this.props.onMouseEnter(event);
        };
        _this.handleOnKeyDown = function(event) {
            var _a, _b;
            var eventKey = event.key;
            if (eventKey === $e5a100bdab37c2de$var$KeyType.Space) {
                event.preventDefault();
                event.key = $e5a100bdab37c2de$var$KeyType.Enter;
            }
            (_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.isSameDay = function(other) {
            return $e5a100bdab37c2de$var$isSameDay(_this.props.day, other);
        };
        _this.isKeyboardSelected = function() {
            var _a;
            if (_this.props.disabledKeyboardNavigation) return false;
            var isSelectedDate = _this.props.selectsMultiple ? (_a = _this.props.selectedDates) === null || _a === void 0 ? void 0 : _a.some(function(date) {
                return _this.isSameDayOrWeek(date);
            }) : _this.isSameDayOrWeek(_this.props.selected);
            var isDisabled = _this.props.preSelection && _this.isDisabled(_this.props.preSelection);
            return !isSelectedDate && _this.isSameDayOrWeek(_this.props.preSelection) && !isDisabled;
        };
        _this.isDisabled = function(day) {
            if (day === void 0) day = _this.props.day;
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $e5a100bdab37c2de$var$isDayDisabled(day, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals,
                includeDateIntervals: _this.props.includeDateIntervals,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate,
                disabled: _this.props.disabled
            });
        };
        _this.isExcluded = function() {
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $e5a100bdab37c2de$var$isDayExcluded(_this.props.day, {
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals
            });
        };
        _this.isStartOfWeek = function() {
            return $e5a100bdab37c2de$var$isSameDay(_this.props.day, $e5a100bdab37c2de$var$getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
        };
        _this.isSameWeek = function(other) {
            return _this.props.showWeekPicker && $e5a100bdab37c2de$var$isSameDay(other, $e5a100bdab37c2de$var$getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
        };
        _this.isSameDayOrWeek = function(other) {
            return _this.isSameDay(other) || _this.isSameWeek(other);
        };
        _this.getHighLightedClass = function() {
            var _a = _this.props, day = _a.day, highlightDates = _a.highlightDates;
            if (!highlightDates) return false;
            // Looking for className in the Map of {'day string, 'className'}
            var dayStr = $e5a100bdab37c2de$var$formatDate(day, "MM.dd.yyyy");
            return highlightDates.get(dayStr);
        };
        // Function to return the array containing className associated to the date
        _this.getHolidaysClass = function() {
            var _a;
            var _b = _this.props, day = _b.day, holidays = _b.holidays;
            if (!holidays) // For type consistency no other reasons
            return [
                undefined
            ];
            var dayStr = $e5a100bdab37c2de$var$formatDate(day, "MM.dd.yyyy");
            // Looking for className in the Map of {day string: {className, holidayName}}
            if (holidays.has(dayStr)) return [
                (_a = holidays.get(dayStr)) === null || _a === void 0 ? void 0 : _a.className
            ];
            // For type consistency no other reasons
            return [
                undefined
            ];
        };
        _this.isInRange = function() {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $e5a100bdab37c2de$var$isDayInRange(day, startDate, endDate);
        };
        _this.isInSelectingRange = function() {
            var _a;
            var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, selectsDisabledDaysInRange = _b.selectsDisabledDaysInRange, startDate = _b.startDate, swapRange = _b.swapRange, endDate = _b.endDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            // Don't highlight days outside the current month
            if (_this.isAfterMonth() || _this.isBeforeMonth()) return false;
            if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate || !selectsDisabledDaysInRange && _this.isDisabled()) return false;
            if (selectsStart && endDate && ((0, $e570a7bac6dc48a8$exports.isBefore)(selectingDate, endDate) || $e5a100bdab37c2de$var$isEqual(selectingDate, endDate))) return $e5a100bdab37c2de$var$isDayInRange(day, selectingDate, endDate);
            if (selectsEnd && startDate && ((0, $e570a7bac6dc48a8$exports.isAfter)(selectingDate, startDate) || $e5a100bdab37c2de$var$isEqual(selectingDate, startDate))) return $e5a100bdab37c2de$var$isDayInRange(day, startDate, selectingDate);
            if (selectsRange && startDate && !endDate) {
                if ($e5a100bdab37c2de$var$isEqual(selectingDate, startDate)) return $e5a100bdab37c2de$var$isDayInRange(day, startDate, selectingDate);
                if ((0, $e570a7bac6dc48a8$exports.isAfter)(selectingDate, startDate)) return $e5a100bdab37c2de$var$isDayInRange(day, startDate, selectingDate);
                if (swapRange && (0, $e570a7bac6dc48a8$exports.isBefore)(selectingDate, startDate)) return $e5a100bdab37c2de$var$isDayInRange(day, selectingDate, startDate);
            }
            return false;
        };
        _this.isSelectingRangeStart = function() {
            var _a;
            if (!_this.isInSelectingRange()) return false;
            var _b = _this.props, day = _b.day, startDate = _b.startDate, selectsStart = _b.selectsStart, swapRange = _b.swapRange, selectsRange = _b.selectsRange;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsStart) return $e5a100bdab37c2de$var$isSameDay(day, selectingDate);
            if (selectsRange && swapRange && startDate && selectingDate) return $e5a100bdab37c2de$var$isSameDay(day, (0, $e570a7bac6dc48a8$exports.isBefore)(selectingDate, startDate) ? selectingDate : startDate);
            return $e5a100bdab37c2de$var$isSameDay(day, startDate);
        };
        _this.isSelectingRangeEnd = function() {
            var _a;
            if (!_this.isInSelectingRange()) return false;
            var _b = _this.props, day = _b.day, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, swapRange = _b.swapRange, startDate = _b.startDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsEnd) return $e5a100bdab37c2de$var$isSameDay(day, selectingDate);
            if (selectsRange && swapRange && startDate && selectingDate) return $e5a100bdab37c2de$var$isSameDay(day, (0, $e570a7bac6dc48a8$exports.isBefore)(selectingDate, startDate) ? startDate : selectingDate);
            if (selectsRange) return $e5a100bdab37c2de$var$isSameDay(day, selectingDate);
            return $e5a100bdab37c2de$var$isSameDay(day, endDate);
        };
        _this.isRangeStart = function() {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $e5a100bdab37c2de$var$isSameDay(startDate, day);
        };
        _this.isRangeEnd = function() {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $e5a100bdab37c2de$var$isSameDay(endDate, day);
        };
        _this.isWeekend = function() {
            var weekday = (0, $e570a7bac6dc48a8$exports.getDay)(_this.props.day);
            return weekday === 0 || weekday === 6;
        };
        _this.isAfterMonth = function() {
            return _this.props.month !== undefined && (_this.props.month + 1) % 12 === (0, $e570a7bac6dc48a8$exports.getMonth)(_this.props.day);
        };
        _this.isBeforeMonth = function() {
            return _this.props.month !== undefined && ((0, $e570a7bac6dc48a8$exports.getMonth)(_this.props.day) + 1) % 12 === _this.props.month;
        };
        _this.isCurrentDay = function() {
            return _this.isSameDay($e5a100bdab37c2de$var$newDate());
        };
        _this.isSelected = function() {
            var _a;
            if (_this.props.selectsMultiple) return (_a = _this.props.selectedDates) === null || _a === void 0 ? void 0 : _a.some(function(date) {
                return _this.isSameDayOrWeek(date);
            });
            return _this.isSameDayOrWeek(_this.props.selected);
        };
        _this.getClassNames = function(date) {
            var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
            return (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)("react-datepicker__day", dayClassName, "react-datepicker__day--" + $e5a100bdab37c2de$var$getDayOfWeekCode(_this.props.day), {
                "react-datepicker__day--disabled": _this.isDisabled(),
                "react-datepicker__day--excluded": _this.isExcluded(),
                "react-datepicker__day--selected": _this.isSelected(),
                "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
                "react-datepicker__day--range-start": _this.isRangeStart(),
                "react-datepicker__day--range-end": _this.isRangeEnd(),
                "react-datepicker__day--in-range": _this.isInRange(),
                "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
                "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
                "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
                "react-datepicker__day--today": _this.isCurrentDay(),
                "react-datepicker__day--weekend": _this.isWeekend(),
                "react-datepicker__day--outside-month": _this.isAfterMonth() || _this.isBeforeMonth()
            }, _this.getHighLightedClass(), _this.getHolidaysClass());
        };
        _this.getAriaLabel = function() {
            var _a = _this.props, day = _a.day, _b = _a.ariaLabelPrefixWhenEnabled, ariaLabelPrefixWhenEnabled = _b === void 0 ? "Choose" : _b, _c = _a.ariaLabelPrefixWhenDisabled, ariaLabelPrefixWhenDisabled = _c === void 0 ? "Not available" : _c;
            var prefix = _this.isDisabled() || _this.isExcluded() ? ariaLabelPrefixWhenDisabled : ariaLabelPrefixWhenEnabled;
            return "".concat(prefix, " ").concat($e5a100bdab37c2de$var$formatDate(day, "PPPP", _this.props.locale));
        };
        // A function to return the holiday's name as title's content
        _this.getTitle = function() {
            var _a = _this.props, day = _a.day, _b = _a.holidays, holidays = _b === void 0 ? new Map() : _b, excludeDates = _a.excludeDates;
            var compareDt = $e5a100bdab37c2de$var$formatDate(day, "MM.dd.yyyy");
            var titles = [];
            if (holidays.has(compareDt)) titles.push.apply(titles, holidays.get(compareDt).holidayNames);
            if (_this.isExcluded()) titles.push(excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.filter(function(excludeDate) {
                if (excludeDate instanceof Date) return $e5a100bdab37c2de$var$isSameDay(excludeDate, day);
                return $e5a100bdab37c2de$var$isSameDay(excludeDate === null || excludeDate === void 0 ? void 0 : excludeDate.date, day);
            }).map(function(excludeDate) {
                if (excludeDate instanceof Date) return undefined;
                return excludeDate === null || excludeDate === void 0 ? void 0 : excludeDate.message;
            }));
            // I'm not sure that this is a right output, but all tests are green
            return titles.join(", ");
        };
        _this.getTabIndex = function() {
            var selectedDay = _this.props.selected;
            var preSelectionDay = _this.props.preSelection;
            var tabIndex = !(_this.props.showWeekPicker && (_this.props.showWeekNumber || !_this.isStartOfWeek())) && (_this.isKeyboardSelected() || _this.isSameDay(selectedDay) && $e5a100bdab37c2de$var$isSameDay(preSelectionDay, selectedDay)) ? 0 : -1;
            return tabIndex;
        };
        // various cases when we need to apply focus to the preselected day
        // focus the day on mount/update so that keyboard navigation works while cycling through months with up or down keys (not for prev and next month buttons)
        // prevent focus for these activeElement cases so we don't pull focus from the input as the calendar opens
        _this.handleFocusDay = function() {
            var _a;
            // only do this while the input isn't focused
            // otherwise, typing/backspacing the date manually may steal focus away from the input
            _this.shouldFocusDay() && ((_a = _this.dayEl.current) === null || _a === void 0 || _a.focus({
                preventScroll: true
            }));
        };
        _this.renderDayContents = function() {
            if (_this.props.monthShowsDuplicateDaysEnd && _this.isAfterMonth()) return null;
            if (_this.props.monthShowsDuplicateDaysStart && _this.isBeforeMonth()) return null;
            return _this.props.renderDayContents ? _this.props.renderDayContents((0, $e570a7bac6dc48a8$exports.getDate)(_this.props.day), _this.props.day) : (0, $e570a7bac6dc48a8$exports.getDate)(_this.props.day);
        };
        _this.render = function() {
            return(// TODO: Use <option> instead of the "option" role to ensure accessibility across all devices.
            (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                ref: _this.dayEl,
                className: _this.getClassNames(_this.props.day),
                onKeyDown: _this.handleOnKeyDown,
                onClick: _this.handleClick,
                onMouseEnter: !_this.props.usePointerEvent ? _this.handleMouseEnter : undefined,
                onPointerEnter: _this.props.usePointerEvent ? _this.handleMouseEnter : undefined,
                tabIndex: _this.getTabIndex(),
                "aria-label": _this.getAriaLabel(),
                role: "gridcell",
                title: _this.getTitle(),
                "aria-disabled": _this.isDisabled(),
                "aria-current": _this.isCurrentDay() ? "date" : undefined,
                "aria-selected": _this.isSelected() || _this.isInRange()
            }, _this.renderDayContents(), _this.getTitle() !== "" && (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                className: "overlay"
            }, _this.getTitle())));
        };
        return _this;
    }
    Day.prototype.componentDidMount = function() {
        this.handleFocusDay();
    };
    Day.prototype.componentDidUpdate = function() {
        this.handleFocusDay();
    };
    Day.prototype.shouldFocusDay = function() {
        var shouldFocusDay = false;
        if (this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection)) {
            // there is currently no activeElement and not inline
            if (!document.activeElement || document.activeElement === document.body) shouldFocusDay = true;
            // inline version:
            // do not focus on initial render to prevent autoFocus issue
            // focus after month has changed via keyboard
            if (this.props.inline && !this.props.shouldFocusDayInline) shouldFocusDay = false;
            if (this.isDayActiveElement()) shouldFocusDay = true;
            if (this.isDuplicateDay()) shouldFocusDay = false;
        }
        return shouldFocusDay;
    };
    // the activeElement is in the container, and it is another instance of Day
    Day.prototype.isDayActiveElement = function() {
        var _a, _b, _c;
        return ((_b = (_a = this.props.containerRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.contains(document.activeElement)) && ((_c = document.activeElement) === null || _c === void 0 ? void 0 : _c.classList.contains("react-datepicker__day"));
    };
    Day.prototype.isDuplicateDay = function() {
        return(//day is one of the non rendered duplicate days
        this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth());
    };
    return Day;
}((0, $7UyaH.Component));
var $e5a100bdab37c2de$var$WeekNumber = /** @class */ function(_super) {
    $e5a100bdab37c2de$var$__extends(WeekNumber, _super);
    function WeekNumber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.weekNumberEl = (0, $7UyaH.createRef)();
        _this.handleClick = function(event) {
            if (_this.props.onClick) _this.props.onClick(event);
        };
        _this.handleOnKeyDown = function(event) {
            var _a, _b;
            var eventKey = event.key;
            if (eventKey === $e5a100bdab37c2de$var$KeyType.Space) {
                event.preventDefault();
                event.key = $e5a100bdab37c2de$var$KeyType.Enter;
            }
            (_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.isKeyboardSelected = function() {
            return !_this.props.disabledKeyboardNavigation && !$e5a100bdab37c2de$var$isSameDay(_this.props.date, _this.props.selected) && $e5a100bdab37c2de$var$isSameDay(_this.props.date, _this.props.preSelection);
        };
        _this.getTabIndex = function() {
            return _this.props.showWeekPicker && _this.props.showWeekNumber && (_this.isKeyboardSelected() || $e5a100bdab37c2de$var$isSameDay(_this.props.date, _this.props.selected) && $e5a100bdab37c2de$var$isSameDay(_this.props.preSelection, _this.props.selected)) ? 0 : -1;
        };
        // various cases when we need to apply focus to the preselected week-number
        // focus the week-number on mount/update so that keyboard navigation works while cycling through months with up or down keys (not for prev and next month buttons)
        // prevent focus for these activeElement cases so we don't pull focus from the input as the calendar opens
        _this.handleFocusWeekNumber = function(prevProps) {
            var shouldFocusWeekNumber = false;
            // only do this while the input isn't focused
            // otherwise, typing/backspacing the date manually may steal focus away from the input
            if (_this.getTabIndex() === 0 && !(prevProps === null || prevProps === void 0 ? void 0 : prevProps.isInputFocused) && $e5a100bdab37c2de$var$isSameDay(_this.props.date, _this.props.preSelection)) {
                // there is currently no activeElement and not inline
                if (!document.activeElement || document.activeElement === document.body) shouldFocusWeekNumber = true;
                // inline version:
                // do not focus on initial render to prevent autoFocus issue
                // focus after month has changed via keyboard
                if (_this.props.inline && !_this.props.shouldFocusDayInline) shouldFocusWeekNumber = false;
                // the activeElement is in the container, and it is another instance of WeekNumber
                if (_this.props.containerRef && _this.props.containerRef.current && _this.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number")) shouldFocusWeekNumber = true;
            }
            shouldFocusWeekNumber && _this.weekNumberEl.current && _this.weekNumberEl.current.focus({
                preventScroll: true
            });
        };
        return _this;
    }
    Object.defineProperty(WeekNumber, "defaultProps", {
        get: function() {
            return {
                ariaLabelPrefix: "week "
            };
        },
        enumerable: false,
        configurable: true
    });
    WeekNumber.prototype.componentDidMount = function() {
        this.handleFocusWeekNumber();
    };
    WeekNumber.prototype.componentDidUpdate = function(prevProps) {
        this.handleFocusWeekNumber(prevProps);
    };
    WeekNumber.prototype.render = function() {
        var _a = this.props, weekNumber = _a.weekNumber, isWeekDisabled = _a.isWeekDisabled, _b = _a.ariaLabelPrefix, ariaLabelPrefix = _b === void 0 ? WeekNumber.defaultProps.ariaLabelPrefix : _b, onClick = _a.onClick;
        var weekNumberClasses = {
            "react-datepicker__week-number": true,
            "react-datepicker__week-number--clickable": !!onClick && !isWeekDisabled,
            "react-datepicker__week-number--selected": !!onClick && $e5a100bdab37c2de$var$isSameDay(this.props.date, this.props.selected)
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            ref: this.weekNumberEl,
            className: (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)(weekNumberClasses),
            "aria-label": "".concat(ariaLabelPrefix, " ").concat(this.props.weekNumber),
            onClick: this.handleClick,
            onKeyDown: this.handleOnKeyDown,
            tabIndex: this.getTabIndex(),
            role: "gridcell"
        }, weekNumber);
    };
    return WeekNumber;
}((0, $7UyaH.Component));
var $e5a100bdab37c2de$var$Week = /** @class */ function(_super) {
    $e5a100bdab37c2de$var$__extends(Week, _super);
    function Week() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isDisabled = function(day) {
            return $e5a100bdab37c2de$var$isDayDisabled(day, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals,
                includeDateIntervals: _this.props.includeDateIntervals,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate
            });
        };
        _this.handleDayClick = function(day, event) {
            if (_this.props.onDayClick) _this.props.onDayClick(day, event);
        };
        _this.handleDayMouseEnter = function(day) {
            if (_this.props.onDayMouseEnter) _this.props.onDayMouseEnter(day);
        };
        _this.handleWeekClick = function(day, weekNumber, event) {
            var _a, _b, _c;
            var enabledWeekDay = new Date(day);
            for(var i = 0; i < 7; i++){
                var processingDay = new Date(day);
                processingDay.setDate(processingDay.getDate() + i);
                var isEnabled = !_this.isDisabled(processingDay);
                if (isEnabled) {
                    enabledWeekDay = processingDay;
                    break;
                }
            }
            if (typeof _this.props.onWeekSelect === "function") _this.props.onWeekSelect(enabledWeekDay, weekNumber, event);
            if (_this.props.showWeekPicker) _this.handleDayClick(enabledWeekDay, event);
            if ((_a = _this.props.shouldCloseOnSelect) !== null && _a !== void 0 ? _a : Week.defaultProps.shouldCloseOnSelect) (_c = (_b = _this.props).setOpen) === null || _c === void 0 || _c.call(_b, false);
        };
        _this.formatWeekNumber = function(date) {
            if (_this.props.formatWeekNumber) return _this.props.formatWeekNumber(date);
            return $e5a100bdab37c2de$var$getWeek(date);
        };
        _this.isWeekDisabled = function() {
            var startOfWeek = _this.startOfWeek();
            var endOfWeek = (0, $e570a7bac6dc48a8$exports.addDays)(startOfWeek, 6);
            var processingDate = new Date(startOfWeek);
            while(processingDate <= endOfWeek){
                if (!_this.isDisabled(processingDate)) return false;
                processingDate = (0, $e570a7bac6dc48a8$exports.addDays)(processingDate, 1);
            }
            return true;
        };
        _this.renderDays = function() {
            var startOfWeek = _this.startOfWeek();
            var days = [];
            var weekNumber = _this.formatWeekNumber(startOfWeek);
            if (_this.props.showWeekNumber) {
                var onClickAction = _this.props.onWeekSelect || _this.props.showWeekPicker ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
                days.push((0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$WeekNumber, $e5a100bdab37c2de$var$_assign({
                    key: "W"
                }, Week.defaultProps, _this.props, {
                    weekNumber: weekNumber,
                    isWeekDisabled: _this.isWeekDisabled(),
                    date: startOfWeek,
                    onClick: onClickAction
                })));
            }
            return days.concat([
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map(function(offset) {
                var day = (0, $e570a7bac6dc48a8$exports.addDays)(startOfWeek, offset);
                return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$Day, $e5a100bdab37c2de$var$_assign({}, Week.defaultProps, _this.props, {
                    ariaLabelPrefixWhenEnabled: _this.props.chooseDayAriaLabelPrefix,
                    ariaLabelPrefixWhenDisabled: _this.props.disabledDayAriaLabelPrefix,
                    key: day.valueOf(),
                    day: day,
                    onClick: _this.handleDayClick.bind(_this, day),
                    onMouseEnter: _this.handleDayMouseEnter.bind(_this, day)
                }));
            }));
        };
        _this.startOfWeek = function() {
            return $e5a100bdab37c2de$var$getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay);
        };
        _this.isKeyboardSelected = function() {
            return !_this.props.disabledKeyboardNavigation && !$e5a100bdab37c2de$var$isSameDay(_this.startOfWeek(), _this.props.selected) && $e5a100bdab37c2de$var$isSameDay(_this.startOfWeek(), _this.props.preSelection);
        };
        return _this;
    }
    Object.defineProperty(Week, "defaultProps", {
        get: function() {
            return {
                shouldCloseOnSelect: true
            };
        },
        enumerable: false,
        configurable: true
    });
    Week.prototype.render = function() {
        var weekNumberClasses = {
            "react-datepicker__week": true,
            "react-datepicker__week--selected": $e5a100bdab37c2de$var$isSameDay(this.startOfWeek(), this.props.selected),
            "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
        };
        var customWeekClassName = this.props.weekClassName ? this.props.weekClassName(this.startOfWeek()) : undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)(weekNumberClasses, customWeekClassName),
            role: "row"
        }, this.renderDays());
    };
    return Week;
}((0, $7UyaH.Component));
var $e5a100bdab37c2de$var$_a;
var $e5a100bdab37c2de$var$FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
var $e5a100bdab37c2de$var$MONTH_COLUMNS_LAYOUT = {
    TWO_COLUMNS: "two_columns",
    THREE_COLUMNS: "three_columns",
    FOUR_COLUMNS: "four_columns"
};
var $e5a100bdab37c2de$var$MONTH_COLUMNS = ($e5a100bdab37c2de$var$_a = {}, $e5a100bdab37c2de$var$_a[$e5a100bdab37c2de$var$MONTH_COLUMNS_LAYOUT.TWO_COLUMNS] = {
    grid: [
        [
            0,
            1
        ],
        [
            2,
            3
        ],
        [
            4,
            5
        ],
        [
            6,
            7
        ],
        [
            8,
            9
        ],
        [
            10,
            11
        ]
    ],
    verticalNavigationOffset: 2
}, $e5a100bdab37c2de$var$_a[$e5a100bdab37c2de$var$MONTH_COLUMNS_LAYOUT.THREE_COLUMNS] = {
    grid: [
        [
            0,
            1,
            2
        ],
        [
            3,
            4,
            5
        ],
        [
            6,
            7,
            8
        ],
        [
            9,
            10,
            11
        ]
    ],
    verticalNavigationOffset: 3
}, $e5a100bdab37c2de$var$_a[$e5a100bdab37c2de$var$MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS] = {
    grid: [
        [
            0,
            1,
            2,
            3
        ],
        [
            4,
            5,
            6,
            7
        ],
        [
            8,
            9,
            10,
            11
        ]
    ],
    verticalNavigationOffset: 4
}, $e5a100bdab37c2de$var$_a);
var $e5a100bdab37c2de$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET = 1;
function $e5a100bdab37c2de$var$getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker) {
    if (showFourColumnMonthYearPicker) return $e5a100bdab37c2de$var$MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS;
    if (showTwoColumnMonthYearPicker) return $e5a100bdab37c2de$var$MONTH_COLUMNS_LAYOUT.TWO_COLUMNS;
    return $e5a100bdab37c2de$var$MONTH_COLUMNS_LAYOUT.THREE_COLUMNS;
}
/**
 * `Month` is a React component that represents a month in a calendar.
 * It accepts a `MonthProps` object as props which provides various configurations and event handlers.
 *
 * @prop dayClassName - Function to determine the class name for a day.
 * @prop monthClassName - Function to determine the class name for a month.
 * @prop filterDate - Function to filter dates.
 * @prop formatWeekNumber - Function to format the week number.
 * @prop onDayClick - Function to handle day click events.
 * @prop onDayMouseEnter - Function to handle mouse enter events on a day.
 * @prop onMouseLeave - Function to handle mouse leave events.
 * @prop onWeekSelect - Function to handle week selection.
 * @prop setPreSelection - Function to set pre-selection.
 * @prop setOpen - Function to set open state.
 * @prop renderDayContents - Function to render day contents.
 * @prop renderMonthContent - Function to render month content.
 * @prop renderQuarterContent - Function to render quarter content.
 * @prop handleOnKeyDown - Function to handle key down events.
 * @prop handleOnMonthKeyDown - Function to handle key down events on a month.
 * @prop ariaLabelPrefix - Aria label prefix.
 * @prop chooseDayAriaLabelPrefix - Aria label prefix for choosing a day.
 * @prop disabledDayAriaLabelPrefix - Aria label prefix for disabled day.
 * @prop disabledKeyboardNavigation - Flag to disable keyboard navigation.
 * @prop day - The day.
 * @prop endDate - The end date.
 * @prop orderInDisplay - The order in display.
 * @prop excludeDates - Dates to exclude.
 * @prop excludeDateIntervals - Date intervals to exclude.
 * @prop fixedHeight - Flag to set fixed height.
 * @prop highlightDates - Dates to highlight.
 * @prop holidays - Holidays.
 * @prop includeDates - Dates to include.
 * @prop includeDateIntervals - Date intervals to include.
 * @prop inline - Flag to set inline.
 * @prop shouldFocusDayInline - Flag to set focus on day inline.
 * @prop locale - The locale.
 * @prop maxDate - The maximum date.
 * @prop minDate - The minimum date.
 * @prop usePointerEvent - Flag to use pointer event.
 * @prop peekNextMonth - Flag to peek next month.
 * @prop preSelection - The pre-selection.
 * @prop selected - The selected date.
 * @prop selectingDate - The selecting date.
 * @prop calendarStartDay - The calendar start day.
 * @prop selectsEnd - Flag to select end.
 * @prop selectsStart - Flag to select start.
 * @prop selectsRange - Flag to select range.
 * @prop selectsDisabledDaysInRange - Flag to select disabled days in range.
 * @prop selectsMultiple - Flag to select multiple.
 * @prop selectedDates - The selected dates.
 * @prop showWeekNumbers - Flag to show week numbers.
 * @prop startDate - The start date.
 * @prop shouldCloseOnSelect - Flag to close on select.
 * @prop showMonthYearPicker - Flag to show month year picker.
 * @prop showFullMonthYearPicker - Flag to show full month year picker.
 * @prop showTwoColumnMonthYearPicker - Flag to show two column month year picker.
 * @prop showFourColumnMonthYearPicker - Flag to show four column month year picker.
 * @prop showQuarterYearPicker - Flag to show quarter year picker.
 * @prop showWeekPicker - Flag to show week picker.
 * @prop isInputFocused - Flag to set input focus.
 * @prop weekAriaLabelPrefix - Aria label prefix for week.
 * @prop containerRef - The container reference.
 * @prop monthShowsDuplicateDaysEnd - Flag to show duplicate days at the end of the month.
 * @prop monthShowsDuplicateDaysStart - Flag to show duplicate days at the start of the month.
 *
 * @example
 * ```tsx
 * function App() {
 *  const handleDayClick = (date) => {
 *     console.log('Day clicked: ', date);
 *   };
 *
 *   const handleDayMouseEnter = (date) => {
 *     console.log('Mouse entered on day: ', date);
 *   };
 *
 *   return (
 *     <div>
 *       <Month
 *         day={new Date()}
 *         endDate={new Date()}
 *         onDayClick={handleDayClick}
 *         onDayMouseEnter={handleDayMouseEnter}
 *         disabledKeyboardNavigation={false}
 *         showWeekNumbers={true}
 *         showMonthYearPicker={false}
 *       />
 *     </div>
 *   );
 * }
 * ```
 */ var $e5a100bdab37c2de$var$Month = /** @class */ function(_super) {
    $e5a100bdab37c2de$var$__extends(Month, _super);
    function Month() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.MONTH_REFS = $e5a100bdab37c2de$var$__spreadArray([], Array(12), true).map(function() {
            return (0, $7UyaH.createRef)();
        });
        _this.QUARTER_REFS = $e5a100bdab37c2de$var$__spreadArray([], Array(4), true).map(function() {
            return (0, $7UyaH.createRef)();
        });
        _this.isDisabled = function(day) {
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $e5a100bdab37c2de$var$isDayDisabled(day, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals,
                includeDateIntervals: _this.props.includeDateIntervals,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate,
                disabled: _this.props.disabled
            });
        };
        _this.isExcluded = function(day) {
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $e5a100bdab37c2de$var$isDayExcluded(day, {
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals
            });
        };
        _this.handleDayClick = function(day, event) {
            var _a, _b;
            (_b = (_a = _this.props).onDayClick) === null || _b === void 0 || _b.call(_a, day, event, _this.props.orderInDisplay);
        };
        _this.handleDayMouseEnter = function(day) {
            var _a, _b;
            (_b = (_a = _this.props).onDayMouseEnter) === null || _b === void 0 || _b.call(_a, day);
        };
        _this.handleMouseLeave = function() {
            var _a, _b;
            (_b = (_a = _this.props).onMouseLeave) === null || _b === void 0 || _b.call(_a);
        };
        _this.isRangeStartMonth = function(m) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $e5a100bdab37c2de$var$isSameMonth((0, $e570a7bac6dc48a8$exports.setMonth)(day, m), startDate);
        };
        _this.isRangeStartQuarter = function(q) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $e5a100bdab37c2de$var$isSameQuarter((0, $e570a7bac6dc48a8$exports.setQuarter)(day, q), startDate);
        };
        _this.isRangeEndMonth = function(m) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $e5a100bdab37c2de$var$isSameMonth((0, $e570a7bac6dc48a8$exports.setMonth)(day, m), endDate);
        };
        _this.isRangeEndQuarter = function(q) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $e5a100bdab37c2de$var$isSameQuarter((0, $e570a7bac6dc48a8$exports.setQuarter)(day, q), endDate);
        };
        _this.isInSelectingRangeMonth = function(m) {
            var _a;
            var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) return false;
            if (selectsStart && endDate) return $e5a100bdab37c2de$var$isMonthInRange(selectingDate, endDate, m, day);
            if (selectsEnd && startDate) return $e5a100bdab37c2de$var$isMonthInRange(startDate, selectingDate, m, day);
            if (selectsRange && startDate && !endDate) return $e5a100bdab37c2de$var$isMonthInRange(startDate, selectingDate, m, day);
            return false;
        };
        _this.isSelectingMonthRangeStart = function(m) {
            var _a;
            if (!_this.isInSelectingRangeMonth(m)) return false;
            var _b = _this.props, day = _b.day, startDate = _b.startDate, selectsStart = _b.selectsStart;
            var _month = (0, $e570a7bac6dc48a8$exports.setMonth)(day, m);
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsStart) return $e5a100bdab37c2de$var$isSameMonth(_month, selectingDate);
            else return $e5a100bdab37c2de$var$isSameMonth(_month, startDate);
        };
        _this.isSelectingMonthRangeEnd = function(m) {
            var _a;
            if (!_this.isInSelectingRangeMonth(m)) return false;
            var _b = _this.props, day = _b.day, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange;
            var _month = (0, $e570a7bac6dc48a8$exports.setMonth)(day, m);
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsEnd || selectsRange) return $e5a100bdab37c2de$var$isSameMonth(_month, selectingDate);
            else return $e5a100bdab37c2de$var$isSameMonth(_month, endDate);
        };
        _this.isInSelectingRangeQuarter = function(q) {
            var _a;
            var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) return false;
            if (selectsStart && endDate) return $e5a100bdab37c2de$var$isQuarterInRange(selectingDate, endDate, q, day);
            if (selectsEnd && startDate) return $e5a100bdab37c2de$var$isQuarterInRange(startDate, selectingDate, q, day);
            if (selectsRange && startDate && !endDate) return $e5a100bdab37c2de$var$isQuarterInRange(startDate, selectingDate, q, day);
            return false;
        };
        _this.isWeekInMonth = function(startOfWeek) {
            var day = _this.props.day;
            var endOfWeek = (0, $e570a7bac6dc48a8$exports.addDays)(startOfWeek, 6);
            return $e5a100bdab37c2de$var$isSameMonth(startOfWeek, day) || $e5a100bdab37c2de$var$isSameMonth(endOfWeek, day);
        };
        _this.isCurrentMonth = function(day, m) {
            return (0, $e570a7bac6dc48a8$exports.getYear)(day) === (0, $e570a7bac6dc48a8$exports.getYear)($e5a100bdab37c2de$var$newDate()) && m === (0, $e570a7bac6dc48a8$exports.getMonth)($e5a100bdab37c2de$var$newDate());
        };
        _this.isCurrentQuarter = function(day, q) {
            return (0, $e570a7bac6dc48a8$exports.getYear)(day) === (0, $e570a7bac6dc48a8$exports.getYear)($e5a100bdab37c2de$var$newDate()) && q === (0, $e570a7bac6dc48a8$exports.getQuarter)($e5a100bdab37c2de$var$newDate());
        };
        _this.isSelectedMonth = function(day, m, selected) {
            return (0, $e570a7bac6dc48a8$exports.getMonth)(selected) === m && (0, $e570a7bac6dc48a8$exports.getYear)(day) === (0, $e570a7bac6dc48a8$exports.getYear)(selected);
        };
        _this.isSelectMonthInList = function(day, m, selectedDates) {
            return selectedDates.some(function(selectedDate) {
                return _this.isSelectedMonth(day, m, selectedDate);
            });
        };
        _this.isSelectedQuarter = function(day, q, selected) {
            return (0, $e570a7bac6dc48a8$exports.getQuarter)(selected) === q && (0, $e570a7bac6dc48a8$exports.getYear)(day) === (0, $e570a7bac6dc48a8$exports.getYear)(selected);
        };
        _this.isSelectQuarterInList = function(day, q, selectedDates) {
            return selectedDates.some(function(selectedDate) {
                return _this.isSelectedQuarter(day, q, selectedDate);
            });
        };
        _this.isMonthSelected = function() {
            var _a = _this.props, day = _a.day, selected = _a.selected, selectedDates = _a.selectedDates, selectsMultiple = _a.selectsMultiple;
            var monthIdx = (0, $e570a7bac6dc48a8$exports.getMonth)(day);
            if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(date) {
                return _this.isSelectedMonth(day, monthIdx, date);
            });
            return !!selected && _this.isSelectedMonth(day, monthIdx, selected);
        };
        _this.isQuarterSelected = function() {
            var _a = _this.props, day = _a.day, selected = _a.selected, selectedDates = _a.selectedDates, selectsMultiple = _a.selectsMultiple;
            var quarterIdx = (0, $e570a7bac6dc48a8$exports.getQuarter)(day);
            if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(selectedDate) {
                return _this.isSelectedQuarter(day, quarterIdx, selectedDate);
            });
            return !!selected && _this.isSelectedQuarter(day, quarterIdx, selected);
        };
        _this.renderWeeks = function() {
            // Return empty array if day is invalid
            if (!$e5a100bdab37c2de$var$isValid(_this.props.day)) return [];
            var weeks = [];
            var isFixedHeight = _this.props.fixedHeight;
            var i = 0;
            var breakAfterNextPush = false;
            var currentWeekStart = $e5a100bdab37c2de$var$getStartOfWeek($e5a100bdab37c2de$var$getStartOfMonth(_this.props.day), _this.props.locale, _this.props.calendarStartDay);
            var isPreSelected = function(preSelection) {
                return _this.props.showWeekPicker ? $e5a100bdab37c2de$var$getStartOfWeek(preSelection, _this.props.locale, _this.props.calendarStartDay) : _this.props.preSelection;
            };
            var isSelected = function(selected) {
                return _this.props.showWeekPicker ? $e5a100bdab37c2de$var$getStartOfWeek(selected, _this.props.locale, _this.props.calendarStartDay) : _this.props.selected;
            };
            var selected = _this.props.selected ? isSelected(_this.props.selected) : undefined;
            var preSelection = _this.props.preSelection ? isPreSelected(_this.props.preSelection) : undefined;
            while(true){
                weeks.push((0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$Week, $e5a100bdab37c2de$var$_assign({}, _this.props, {
                    ariaLabelPrefix: _this.props.weekAriaLabelPrefix,
                    key: i,
                    day: currentWeekStart,
                    month: (0, $e570a7bac6dc48a8$exports.getMonth)(_this.props.day),
                    onDayClick: _this.handleDayClick,
                    onDayMouseEnter: _this.handleDayMouseEnter,
                    selected: selected,
                    preSelection: preSelection,
                    showWeekNumber: _this.props.showWeekNumbers
                })));
                if (breakAfterNextPush) break;
                i++;
                currentWeekStart = (0, $e570a7bac6dc48a8$exports.addWeeks)(currentWeekStart, 1);
                // If one of these conditions is true, we will either break on this week
                // or break on the next week
                var isFixedAndFinalWeek = isFixedHeight && i >= $e5a100bdab37c2de$var$FIXED_HEIGHT_STANDARD_WEEK_COUNT;
                var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
                if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
                    if (_this.props.peekNextMonth) breakAfterNextPush = true;
                    else break;
                }
            }
            return weeks;
        };
        _this.onMonthClick = function(event, m) {
            var _a = _this.isMonthDisabledForLabelDate(m), isDisabled = _a.isDisabled, labelDate = _a.labelDate;
            if (isDisabled) return;
            _this.handleDayClick($e5a100bdab37c2de$var$getStartOfMonth(labelDate), event);
        };
        _this.onMonthMouseEnter = function(m) {
            var _a = _this.isMonthDisabledForLabelDate(m), isDisabled = _a.isDisabled, labelDate = _a.labelDate;
            if (isDisabled) return;
            _this.handleDayMouseEnter($e5a100bdab37c2de$var$getStartOfMonth(labelDate));
        };
        _this.handleMonthNavigation = function(newMonth, newDate) {
            var _a, _b, _c, _d;
            (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
            (_d = (_c = _this.MONTH_REFS[newMonth]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        };
        _this.handleKeyboardNavigation = function(event, eventKey, month) {
            var _a;
            var _b = _this.props, selected = _b.selected, preSelection = _b.preSelection, setPreSelection = _b.setPreSelection, minDate = _b.minDate, maxDate = _b.maxDate, showFourColumnMonthYearPicker = _b.showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker = _b.showTwoColumnMonthYearPicker;
            if (!preSelection) return;
            var monthColumnsLayout = $e5a100bdab37c2de$var$getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker);
            var verticalOffset = _this.getVerticalOffset(monthColumnsLayout);
            var monthsGrid = (_a = $e5a100bdab37c2de$var$MONTH_COLUMNS[monthColumnsLayout]) === null || _a === void 0 ? void 0 : _a.grid;
            var calculateNewDateAndMonth = function(eventKey, date, month) {
                var _a, _b;
                var newCalculatedDate = date;
                var newCalculatedMonth = month;
                switch(eventKey){
                    case $e5a100bdab37c2de$var$KeyType.ArrowRight:
                        newCalculatedDate = (0, $e570a7bac6dc48a8$exports.addMonths)(date, $e5a100bdab37c2de$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET);
                        newCalculatedMonth = month === 11 ? 0 : month + $e5a100bdab37c2de$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET;
                        break;
                    case $e5a100bdab37c2de$var$KeyType.ArrowLeft:
                        newCalculatedDate = (0, $e570a7bac6dc48a8$exports.subMonths)(date, $e5a100bdab37c2de$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET);
                        newCalculatedMonth = month === 0 ? 11 : month - $e5a100bdab37c2de$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET;
                        break;
                    case $e5a100bdab37c2de$var$KeyType.ArrowUp:
                        newCalculatedDate = (0, $e570a7bac6dc48a8$exports.subMonths)(date, verticalOffset);
                        newCalculatedMonth = ((_a = monthsGrid === null || monthsGrid === void 0 ? void 0 : monthsGrid[0]) === null || _a === void 0 ? void 0 : _a.includes(month)) ? month + 12 - verticalOffset : month - verticalOffset;
                        break;
                    case $e5a100bdab37c2de$var$KeyType.ArrowDown:
                        newCalculatedDate = (0, $e570a7bac6dc48a8$exports.addMonths)(date, verticalOffset);
                        newCalculatedMonth = ((_b = monthsGrid === null || monthsGrid === void 0 ? void 0 : monthsGrid[monthsGrid.length - 1]) === null || _b === void 0 ? void 0 : _b.includes(month)) ? month - 12 + verticalOffset : month + verticalOffset;
                        break;
                }
                return {
                    newCalculatedDate: newCalculatedDate,
                    newCalculatedMonth: newCalculatedMonth
                };
            };
            var getNewDateAndMonth = function(eventKey, selectedDate, month) {
                var MAX_ITERATIONS = 40;
                var eventKeyCopy = eventKey;
                var validDateFound = false;
                var iterations = 0;
                var _a = calculateNewDateAndMonth(eventKeyCopy, selectedDate, month), newCalculatedDate = _a.newCalculatedDate, newCalculatedMonth = _a.newCalculatedMonth;
                while(!validDateFound){
                    if (iterations >= MAX_ITERATIONS) {
                        newCalculatedDate = selectedDate;
                        newCalculatedMonth = month;
                        break;
                    }
                    // if minDate exists and the new month is before the minimum month, it will try to find the next available month after
                    if (minDate && newCalculatedDate < minDate) {
                        eventKeyCopy = $e5a100bdab37c2de$var$KeyType.ArrowRight;
                        var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
                        newCalculatedDate = obj.newCalculatedDate;
                        newCalculatedMonth = obj.newCalculatedMonth;
                    }
                    // if maxDate exists and the new month is after the maximum month, it will try to find the next available month before
                    if (maxDate && newCalculatedDate > maxDate) {
                        eventKeyCopy = $e5a100bdab37c2de$var$KeyType.ArrowLeft;
                        var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
                        newCalculatedDate = obj.newCalculatedDate;
                        newCalculatedMonth = obj.newCalculatedMonth;
                    }
                    if ($e5a100bdab37c2de$var$isMonthYearDisabled(newCalculatedDate, _this.props)) {
                        var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
                        newCalculatedDate = obj.newCalculatedDate;
                        newCalculatedMonth = obj.newCalculatedMonth;
                    } else validDateFound = true;
                    iterations++;
                }
                return {
                    newCalculatedDate: newCalculatedDate,
                    newCalculatedMonth: newCalculatedMonth
                };
            };
            if (eventKey === $e5a100bdab37c2de$var$KeyType.Enter) {
                if (!_this.isMonthDisabled(month)) {
                    _this.onMonthClick(event, month);
                    setPreSelection === null || setPreSelection === void 0 || setPreSelection(selected);
                }
                return;
            }
            var _c = getNewDateAndMonth(eventKey, preSelection, month), newCalculatedDate = _c.newCalculatedDate, newCalculatedMonth = _c.newCalculatedMonth;
            switch(eventKey){
                case $e5a100bdab37c2de$var$KeyType.ArrowRight:
                case $e5a100bdab37c2de$var$KeyType.ArrowLeft:
                case $e5a100bdab37c2de$var$KeyType.ArrowUp:
                case $e5a100bdab37c2de$var$KeyType.ArrowDown:
                    _this.handleMonthNavigation(newCalculatedMonth, newCalculatedDate);
                    break;
            }
        };
        _this.getVerticalOffset = function(monthColumnsLayout) {
            var _a, _b;
            return (_b = (_a = $e5a100bdab37c2de$var$MONTH_COLUMNS[monthColumnsLayout]) === null || _a === void 0 ? void 0 : _a.verticalNavigationOffset) !== null && _b !== void 0 ? _b : 0;
        };
        _this.onMonthKeyDown = function(event, month) {
            var _a = _this.props, disabledKeyboardNavigation = _a.disabledKeyboardNavigation, handleOnMonthKeyDown = _a.handleOnMonthKeyDown;
            var eventKey = event.key;
            if (eventKey !== $e5a100bdab37c2de$var$KeyType.Tab) // preventDefault on tab event blocks focus change
            event.preventDefault();
            if (!disabledKeyboardNavigation) _this.handleKeyboardNavigation(event, eventKey, month);
            handleOnMonthKeyDown && handleOnMonthKeyDown(event);
        };
        _this.onQuarterClick = function(event, q) {
            var labelDate = (0, $e570a7bac6dc48a8$exports.setQuarter)(_this.props.day, q);
            if ($e5a100bdab37c2de$var$isQuarterDisabled(labelDate, _this.props)) return;
            _this.handleDayClick($e5a100bdab37c2de$var$getStartOfQuarter(labelDate), event);
        };
        _this.onQuarterMouseEnter = function(q) {
            var labelDate = (0, $e570a7bac6dc48a8$exports.setQuarter)(_this.props.day, q);
            if ($e5a100bdab37c2de$var$isQuarterDisabled(labelDate, _this.props)) return;
            _this.handleDayMouseEnter($e5a100bdab37c2de$var$getStartOfQuarter(labelDate));
        };
        _this.handleQuarterNavigation = function(newQuarter, newDate) {
            var _a, _b, _c, _d;
            if (_this.isDisabled(newDate) || _this.isExcluded(newDate)) return;
            (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
            (_d = (_c = _this.QUARTER_REFS[newQuarter - 1]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        };
        _this.onQuarterKeyDown = function(event, quarter) {
            var _a, _b;
            var eventKey = event.key;
            if (!_this.props.disabledKeyboardNavigation) switch(eventKey){
                case $e5a100bdab37c2de$var$KeyType.Enter:
                    _this.onQuarterClick(event, quarter);
                    (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, _this.props.selected);
                    break;
                case $e5a100bdab37c2de$var$KeyType.ArrowRight:
                    if (!_this.props.preSelection) break;
                    _this.handleQuarterNavigation(quarter === 4 ? 1 : quarter + 1, (0, $e570a7bac6dc48a8$exports.addQuarters)(_this.props.preSelection, 1));
                    break;
                case $e5a100bdab37c2de$var$KeyType.ArrowLeft:
                    if (!_this.props.preSelection) break;
                    _this.handleQuarterNavigation(quarter === 1 ? 4 : quarter - 1, (0, $e570a7bac6dc48a8$exports.subQuarters)(_this.props.preSelection, 1));
                    break;
            }
        };
        _this.isMonthDisabledForLabelDate = function(month) {
            var _a;
            var _b = _this.props, day = _b.day, disabled = _b.disabled, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates;
            var labelDate = (0, $e570a7bac6dc48a8$exports.setMonth)(day, month);
            if (disabled) return {
                isDisabled: true,
                labelDate: (0, $e570a7bac6dc48a8$exports.setMonth)(day, month)
            };
            return {
                isDisabled: (_a = (minDate || maxDate || excludeDates || includeDates) && $e5a100bdab37c2de$var$isMonthDisabled(labelDate, _this.props)) !== null && _a !== void 0 ? _a : false,
                labelDate: labelDate
            };
        };
        _this.isMonthDisabled = function(month) {
            var isDisabled = _this.isMonthDisabledForLabelDate(month).isDisabled;
            return isDisabled;
        };
        _this.getMonthClassNames = function(m) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate, preSelection = _a.preSelection, monthClassName = _a.monthClassName;
            var _monthClassName = monthClassName ? monthClassName((0, $e570a7bac6dc48a8$exports.setMonth)(day, m)) : undefined;
            var selection = _this.getSelection();
            return (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)("react-datepicker__month-text", "react-datepicker__month-".concat(m), _monthClassName, {
                "react-datepicker__month-text--disabled": _this.isMonthDisabled(m),
                "react-datepicker__month-text--selected": selection ? _this.isSelectMonthInList(day, m, selection) : undefined,
                "react-datepicker__month-text--keyboard-selected": !_this.props.disabledKeyboardNavigation && preSelection && _this.isSelectedMonth(day, m, preSelection) && !_this.isMonthSelected() && !_this.isMonthDisabled(m),
                "react-datepicker__month-text--in-selecting-range": _this.isInSelectingRangeMonth(m),
                "react-datepicker__month-text--in-range": startDate && endDate ? $e5a100bdab37c2de$var$isMonthInRange(startDate, endDate, m, day) : undefined,
                "react-datepicker__month-text--range-start": _this.isRangeStartMonth(m),
                "react-datepicker__month-text--range-end": _this.isRangeEndMonth(m),
                "react-datepicker__month-text--selecting-range-start": _this.isSelectingMonthRangeStart(m),
                "react-datepicker__month-text--selecting-range-end": _this.isSelectingMonthRangeEnd(m),
                "react-datepicker__month-text--today": _this.isCurrentMonth(day, m)
            });
        };
        _this.getTabIndex = function(m) {
            if (_this.props.preSelection == null) return "-1";
            var preSelectedMonth = (0, $e570a7bac6dc48a8$exports.getMonth)(_this.props.preSelection);
            var isPreSelectedMonthDisabled = _this.isMonthDisabledForLabelDate(preSelectedMonth).isDisabled;
            var tabIndex = m === preSelectedMonth && !(isPreSelectedMonthDisabled || _this.props.disabledKeyboardNavigation) ? "0" : "-1";
            return tabIndex;
        };
        _this.getQuarterTabIndex = function(q) {
            if (_this.props.preSelection == null) return "-1";
            var preSelectedQuarter = (0, $e570a7bac6dc48a8$exports.getQuarter)(_this.props.preSelection);
            var isCurrentQuarterDisabled = $e5a100bdab37c2de$var$isQuarterDisabled(_this.props.day, _this.props);
            var tabIndex = q === preSelectedQuarter && !(isCurrentQuarterDisabled || _this.props.disabledKeyboardNavigation) ? "0" : "-1";
            return tabIndex;
        };
        _this.getAriaLabel = function(month) {
            var _a = _this.props, _b = _a.chooseDayAriaLabelPrefix, chooseDayAriaLabelPrefix = _b === void 0 ? "Choose" : _b, _c = _a.disabledDayAriaLabelPrefix, disabledDayAriaLabelPrefix = _c === void 0 ? "Not available" : _c, day = _a.day, locale = _a.locale;
            var labelDate = (0, $e570a7bac6dc48a8$exports.setMonth)(day, month);
            var prefix = _this.isDisabled(labelDate) || _this.isExcluded(labelDate) ? disabledDayAriaLabelPrefix : chooseDayAriaLabelPrefix;
            return "".concat(prefix, " ").concat($e5a100bdab37c2de$var$formatDate(labelDate, "MMMM yyyy", locale));
        };
        _this.getQuarterClassNames = function(q) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, preSelection = _a.preSelection, disabledKeyboardNavigation = _a.disabledKeyboardNavigation, disabled = _a.disabled;
            var isDisabled = (minDate || maxDate || excludeDates || includeDates || filterDate || disabled) && $e5a100bdab37c2de$var$isQuarterDisabled((0, $e570a7bac6dc48a8$exports.setQuarter)(day, q), _this.props);
            var selection = _this.getSelection();
            return (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(q), {
                "react-datepicker__quarter-text--disabled": isDisabled,
                "react-datepicker__quarter-text--selected": selection ? _this.isSelectQuarterInList(day, q, selection) : undefined,
                "react-datepicker__quarter-text--keyboard-selected": !disabledKeyboardNavigation && preSelection && _this.isSelectedQuarter(day, q, preSelection) && !_this.isQuarterSelected() && !isDisabled,
                "react-datepicker__quarter-text--in-selecting-range": _this.isInSelectingRangeQuarter(q),
                "react-datepicker__quarter-text--in-range": startDate && endDate ? $e5a100bdab37c2de$var$isQuarterInRange(startDate, endDate, q, day) : undefined,
                "react-datepicker__quarter-text--range-start": _this.isRangeStartQuarter(q),
                "react-datepicker__quarter-text--range-end": _this.isRangeEndQuarter(q),
                "react-datepicker__quarter-text--today": _this.isCurrentQuarter(day, q)
            });
        };
        _this.getMonthContent = function(m) {
            var _a = _this.props, showFullMonthYearPicker = _a.showFullMonthYearPicker, renderMonthContent = _a.renderMonthContent, locale = _a.locale, day = _a.day;
            var shortMonthText = $e5a100bdab37c2de$var$getMonthShortInLocale(m, locale);
            var fullMonthText = $e5a100bdab37c2de$var$getMonthInLocale(m, locale);
            if (renderMonthContent) return renderMonthContent(m, shortMonthText, fullMonthText, day);
            return showFullMonthYearPicker ? fullMonthText : shortMonthText;
        };
        _this.getQuarterContent = function(q) {
            var _a;
            var _b = _this.props, renderQuarterContent = _b.renderQuarterContent, locale = _b.locale;
            var shortQuarter = $e5a100bdab37c2de$var$getQuarterShortInLocale(q, locale);
            return (_a = renderQuarterContent === null || renderQuarterContent === void 0 ? void 0 : renderQuarterContent(q, shortQuarter)) !== null && _a !== void 0 ? _a : shortQuarter;
        };
        _this.renderMonths = function() {
            var _a;
            var _b = _this.props, showTwoColumnMonthYearPicker = _b.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker = _b.showFourColumnMonthYearPicker, day = _b.day, selected = _b.selected;
            var monthColumns = (_a = $e5a100bdab37c2de$var$MONTH_COLUMNS[$e5a100bdab37c2de$var$getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker)]) === null || _a === void 0 ? void 0 : _a.grid;
            return monthColumns === null || monthColumns === void 0 ? void 0 : monthColumns.map(function(month, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                    className: "react-datepicker__month-wrapper",
                    key: i
                }, month.map(function(m, j) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                        ref: _this.MONTH_REFS[m],
                        key: j,
                        onClick: function(event) {
                            _this.onMonthClick(event, m);
                        },
                        onKeyDown: function(event) {
                            if ($e5a100bdab37c2de$var$isSpaceKeyDown(event)) {
                                event.preventDefault();
                                event.key = $e5a100bdab37c2de$var$KeyType.Enter;
                            }
                            _this.onMonthKeyDown(event, m);
                        },
                        onMouseEnter: !_this.props.usePointerEvent ? function() {
                            return _this.onMonthMouseEnter(m);
                        } : undefined,
                        onPointerEnter: _this.props.usePointerEvent ? function() {
                            return _this.onMonthMouseEnter(m);
                        } : undefined,
                        tabIndex: Number(_this.getTabIndex(m)),
                        className: _this.getMonthClassNames(m),
                        "aria-disabled": _this.isMonthDisabled(m),
                        role: "option",
                        "aria-label": _this.getAriaLabel(m),
                        "aria-current": _this.isCurrentMonth(day, m) ? "date" : undefined,
                        "aria-selected": selected ? _this.isSelectedMonth(day, m, selected) : undefined
                    }, _this.getMonthContent(m));
                }));
            });
        };
        _this.renderQuarters = function() {
            var _a = _this.props, day = _a.day, selected = _a.selected;
            var quarters = [
                1,
                2,
                3,
                4
            ];
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                className: "react-datepicker__quarter-wrapper"
            }, quarters.map(function(q, j) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                    key: j,
                    ref: _this.QUARTER_REFS[j],
                    role: "option",
                    onClick: function(event) {
                        _this.onQuarterClick(event, q);
                    },
                    onKeyDown: function(event) {
                        _this.onQuarterKeyDown(event, q);
                    },
                    onMouseEnter: !_this.props.usePointerEvent ? function() {
                        return _this.onQuarterMouseEnter(q);
                    } : undefined,
                    onPointerEnter: _this.props.usePointerEvent ? function() {
                        return _this.onQuarterMouseEnter(q);
                    } : undefined,
                    className: _this.getQuarterClassNames(q),
                    "aria-selected": selected ? _this.isSelectedQuarter(day, q, selected) : undefined,
                    tabIndex: Number(_this.getQuarterTabIndex(q)),
                    "aria-current": _this.isCurrentQuarter(day, q) ? "date" : undefined
                }, _this.getQuarterContent(q));
            }));
        };
        _this.getClassNames = function() {
            var _a = _this.props, selectingDate = _a.selectingDate, selectsStart = _a.selectsStart, selectsEnd = _a.selectsEnd, showMonthYearPicker = _a.showMonthYearPicker, showQuarterYearPicker = _a.showQuarterYearPicker, showWeekPicker = _a.showWeekPicker;
            return (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)("react-datepicker__month", {
                "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
            }, {
                "react-datepicker__monthPicker": showMonthYearPicker
            }, {
                "react-datepicker__quarterPicker": showQuarterYearPicker
            }, {
                "react-datepicker__weekPicker": showWeekPicker
            });
        };
        return _this;
    }
    Month.prototype.getSelection = function() {
        var _a = this.props, selected = _a.selected, selectedDates = _a.selectedDates, selectsMultiple = _a.selectsMultiple;
        if (selectsMultiple) return selectedDates;
        if (selected) return [
            selected
        ];
        return undefined;
    };
    Month.prototype.render = function() {
        var _a = this.props, showMonthYearPicker = _a.showMonthYearPicker, showQuarterYearPicker = _a.showQuarterYearPicker, day = _a.day, _b = _a.ariaLabelPrefix, ariaLabelPrefix = _b === void 0 ? "Month " : _b;
        var formattedAriaLabelPrefix = ariaLabelPrefix ? ariaLabelPrefix.trim() + " " : "";
        // Format aria-label, return empty string if date is invalid
        var formattedAriaLabel = $e5a100bdab37c2de$var$isValid(day) ? "".concat(formattedAriaLabelPrefix).concat($e5a100bdab37c2de$var$formatDate(day, "MMMM, yyyy", this.props.locale)) : "";
        var shouldUseListboxRole = showMonthYearPicker || showQuarterYearPicker;
        if (shouldUseListboxRole) return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: this.getClassNames(),
            onMouseLeave: !this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            "aria-label": formattedAriaLabel,
            role: "listbox"
        }, showMonthYearPicker ? this.renderMonths() : this.renderQuarters());
        // For regular calendar view, use table structure
        return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            role: "table"
        }, this.props.dayNamesHeader && (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            role: "rowgroup"
        }, this.props.dayNamesHeader), this.props.monthHeader && (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            role: "rowgroup"
        }, this.props.monthHeader), (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: this.getClassNames(),
            onMouseLeave: !this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            "aria-label": formattedAriaLabel,
            role: "rowgroup"
        }, this.renderWeeks()), this.props.monthFooter && (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            role: "rowgroup"
        }, this.props.monthFooter));
    };
    return Month;
}((0, $7UyaH.Component));
var $e5a100bdab37c2de$var$MonthDropdownOptions = /** @class */ function(_super) {
    $e5a100bdab37c2de$var$__extends(MonthDropdownOptions, _super);
    function MonthDropdownOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.monthOptionButtonsRef = {};
        _this.isSelectedMonth = function(i) {
            return _this.props.month === i;
        };
        _this.handleOptionKeyDown = function(i, e) {
            var _a;
            switch(e.key){
                case "Enter":
                    e.preventDefault();
                    _this.onChange(i);
                    break;
                case "Escape":
                    e.preventDefault();
                    _this.props.onCancel();
                    break;
                case "ArrowUp":
                case "ArrowDown":
                    e.preventDefault();
                    var newMonth = (i + (e.key === "ArrowUp" ? -1 : 1) + _this.props.monthNames.length) % _this.props.monthNames.length;
                    (_a = _this.monthOptionButtonsRef[newMonth]) === null || _a === void 0 || _a.focus();
                    break;
            }
        };
        _this.renderOptions = function() {
            // Clear refs to prevent memory leaks on re-render
            _this.monthOptionButtonsRef = {};
            return _this.props.monthNames.map(function(month, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                    ref: function(el) {
                        _this.monthOptionButtonsRef[i] = el;
                        if (_this.isSelectedMonth(i)) el === null || el === void 0 || el.focus();
                    },
                    role: "button",
                    tabIndex: 0,
                    className: _this.isSelectedMonth(i) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                    key: month,
                    onClick: _this.onChange.bind(_this, i),
                    onKeyDown: _this.handleOptionKeyDown.bind(_this, i),
                    "aria-selected": _this.isSelectedMonth(i) ? "true" : undefined
                }, _this.isSelectedMonth(i) ? (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                    className: "react-datepicker__month-option--selected"
                }, "\u2713") : "", month);
            });
        };
        _this.onChange = function(month) {
            return _this.props.onChange(month);
        };
        _this.handleClickOutside = function() {
            return _this.props.onCancel();
        };
        return _this;
    }
    MonthDropdownOptions.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$ClickOutsideWrapper, {
            className: "react-datepicker__month-dropdown",
            onClickOutside: this.handleClickOutside
        }, this.renderOptions());
    };
    return MonthDropdownOptions;
}((0, $7UyaH.Component));
var $e5a100bdab37c2de$var$MonthDropdown = /** @class */ function(_super) {
    $e5a100bdab37c2de$var$__extends(MonthDropdown, _super);
    function MonthDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownVisible: false
        };
        _this.renderSelectOptions = function(monthNames) {
            return monthNames.map(function(m, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("option", {
                    key: m,
                    value: i
                }, m);
            });
        };
        _this.renderSelectMode = function(monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("select", {
                value: _this.props.month,
                className: "react-datepicker__month-select",
                onChange: function(e) {
                    return _this.onChange(parseInt(e.target.value));
                }
            }, _this.renderSelectOptions(monthNames));
        };
        _this.renderReadView = function(visible, monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("button", {
                key: "read",
                type: "button",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__month-read-view",
                onClick: _this.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                className: "react-datepicker__month-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                className: "react-datepicker__month-read-view--selected-month"
            }, monthNames[_this.props.month]));
        };
        _this.renderDropdown = function(monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$MonthDropdownOptions, $e5a100bdab37c2de$var$_assign({
                key: "dropdown"
            }, _this.props, {
                monthNames: monthNames,
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            }));
        };
        _this.renderScrollMode = function(monthNames) {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible, monthNames)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown(monthNames));
            return result;
        };
        _this.onChange = function(month) {
            _this.toggleDropdown();
            if (month !== _this.props.month) _this.props.onChange(month);
        };
        _this.toggleDropdown = function() {
            return _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            });
        };
        return _this;
    }
    MonthDropdown.prototype.render = function() {
        var _this = this;
        var monthNames = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map(this.props.useShortMonthInDropdown ? function(m) {
            return $e5a100bdab37c2de$var$getMonthShortInLocale(m, _this.props.locale);
        } : function(m) {
            return $e5a100bdab37c2de$var$getMonthInLocale(m, _this.props.locale);
        });
        var renderedDropdown;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode(monthNames);
                break;
            case "select":
                renderedDropdown = this.renderSelectMode(monthNames);
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
        }, renderedDropdown);
    };
    return MonthDropdown;
}((0, $7UyaH.Component));
// Default range: 5 years before and after current date
var $e5a100bdab37c2de$var$DEFAULT_YEAR_RANGE$1 = 5;
function $e5a100bdab37c2de$var$generateMonthYears(minDate, maxDate, currentDate) {
    var list = [];
    // Use defaults if minDate/maxDate not provided
    var effectiveMinDate = minDate !== null && minDate !== void 0 ? minDate : (0, $e570a7bac6dc48a8$exports.subYears)(currentDate, $e5a100bdab37c2de$var$DEFAULT_YEAR_RANGE$1);
    var effectiveMaxDate = maxDate !== null && maxDate !== void 0 ? maxDate : (0, $e570a7bac6dc48a8$exports.addYears)(currentDate, $e5a100bdab37c2de$var$DEFAULT_YEAR_RANGE$1);
    var currDate = $e5a100bdab37c2de$var$getStartOfMonth(effectiveMinDate);
    var lastDate = $e5a100bdab37c2de$var$getStartOfMonth(effectiveMaxDate);
    while(!(0, $e570a7bac6dc48a8$exports.isAfter)(currDate, lastDate)){
        list.push($e5a100bdab37c2de$var$newDate(currDate));
        currDate = (0, $e570a7bac6dc48a8$exports.addMonths)(currDate, 1);
    }
    return list;
}
var $e5a100bdab37c2de$var$MonthYearDropdownOptions = /** @class */ function(_super) {
    $e5a100bdab37c2de$var$__extends(MonthYearDropdownOptions, _super);
    function MonthYearDropdownOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.renderOptions = function() {
            return _this.state.monthYearsList.map(function(monthYear) {
                var monthYearPoint = (0, $e570a7bac6dc48a8$exports.getTime)(monthYear);
                var isSameMonthYear = $e5a100bdab37c2de$var$isSameYear(_this.props.date, monthYear) && $e5a100bdab37c2de$var$isSameMonth(_this.props.date, monthYear);
                return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                    className: isSameMonthYear ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                    key: monthYearPoint,
                    onClick: _this.onChange.bind(_this, monthYearPoint),
                    "aria-selected": isSameMonthYear ? "true" : undefined
                }, isSameMonthYear ? (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                    className: "react-datepicker__month-year-option--selected"
                }, "\u2713") : "", $e5a100bdab37c2de$var$formatDate(monthYear, _this.props.dateFormat, _this.props.locale));
            });
        };
        _this.onChange = function(monthYear) {
            return _this.props.onChange(monthYear);
        };
        _this.handleClickOutside = function() {
            _this.props.onCancel();
        };
        _this.state = {
            monthYearsList: $e5a100bdab37c2de$var$generateMonthYears(_this.props.minDate, _this.props.maxDate, _this.props.date)
        };
        return _this;
    }
    MonthYearDropdownOptions.prototype.render = function() {
        var dropdownClass = (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)({
            "react-datepicker__month-year-dropdown": true,
            "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$ClickOutsideWrapper, {
            className: dropdownClass,
            onClickOutside: this.handleClickOutside
        }, this.renderOptions());
    };
    return MonthYearDropdownOptions;
}((0, $7UyaH.Component));
// Default range: 5 years before and after current date
var $e5a100bdab37c2de$var$DEFAULT_YEAR_RANGE = 5;
var $e5a100bdab37c2de$var$MonthYearDropdown = /** @class */ function(_super) {
    $e5a100bdab37c2de$var$__extends(MonthYearDropdown, _super);
    function MonthYearDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownVisible: false
        };
        _this.renderSelectOptions = function() {
            var _a, _b;
            // Use defaults if minDate/maxDate not provided
            var minDate = (_a = _this.props.minDate) !== null && _a !== void 0 ? _a : (0, $e570a7bac6dc48a8$exports.subYears)(_this.props.date, $e5a100bdab37c2de$var$DEFAULT_YEAR_RANGE);
            var maxDate = (_b = _this.props.maxDate) !== null && _b !== void 0 ? _b : (0, $e570a7bac6dc48a8$exports.addYears)(_this.props.date, $e5a100bdab37c2de$var$DEFAULT_YEAR_RANGE);
            var currDate = $e5a100bdab37c2de$var$getStartOfMonth(minDate);
            var lastDate = $e5a100bdab37c2de$var$getStartOfMonth(maxDate);
            var options = [];
            while(!(0, $e570a7bac6dc48a8$exports.isAfter)(currDate, lastDate)){
                var timePoint = (0, $e570a7bac6dc48a8$exports.getTime)(currDate);
                options.push((0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("option", {
                    key: timePoint,
                    value: timePoint
                }, $e5a100bdab37c2de$var$formatDate(currDate, _this.props.dateFormat, _this.props.locale)));
                currDate = (0, $e570a7bac6dc48a8$exports.addMonths)(currDate, 1);
            }
            return options;
        };
        _this.onSelectChange = function(event) {
            _this.onChange(parseInt(event.target.value));
        };
        _this.renderSelectMode = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("select", {
                value: (0, $e570a7bac6dc48a8$exports.getTime)($e5a100bdab37c2de$var$getStartOfMonth(_this.props.date)),
                className: "react-datepicker__month-year-select",
                onChange: _this.onSelectChange
            }, _this.renderSelectOptions());
        };
        _this.renderReadView = function(visible) {
            var yearMonth = $e5a100bdab37c2de$var$formatDate(_this.props.date, _this.props.dateFormat, _this.props.locale);
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                key: "read",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__month-year-read-view",
                onClick: _this.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                className: "react-datepicker__month-year-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                className: "react-datepicker__month-year-read-view--selected-month-year"
            }, yearMonth));
        };
        _this.renderDropdown = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$MonthYearDropdownOptions, $e5a100bdab37c2de$var$_assign({
                key: "dropdown"
            }, _this.props, {
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            }));
        };
        _this.renderScrollMode = function() {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown());
            return result;
        };
        _this.onChange = function(monthYearPoint) {
            _this.toggleDropdown();
            var changedDate = $e5a100bdab37c2de$var$newDate(monthYearPoint);
            if ($e5a100bdab37c2de$var$isSameYear(_this.props.date, changedDate) && $e5a100bdab37c2de$var$isSameMonth(_this.props.date, changedDate)) return;
            _this.props.onChange(changedDate);
        };
        _this.toggleDropdown = function() {
            return _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            });
        };
        return _this;
    }
    MonthYearDropdown.prototype.render = function() {
        var renderedDropdown;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode();
                break;
            case "select":
                renderedDropdown = this.renderSelectMode();
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
        }, renderedDropdown);
    };
    return MonthYearDropdown;
}((0, $7UyaH.Component));
var $e5a100bdab37c2de$var$Time = /** @class */ function(_super) {
    $e5a100bdab37c2de$var$__extends(Time, _super);
    function Time() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            height: null
        };
        _this.scrollToTheSelectedTime = function() {
            requestAnimationFrame(function() {
                var _a, _b, _c;
                if (!_this.list) return;
                _this.list.scrollTop = (_c = _this.centerLi && Time.calcCenterPosition(_this.props.monthRef ? _this.props.monthRef.clientHeight - ((_b = (_a = _this.header) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0) : _this.list.clientHeight, _this.centerLi)) !== null && _c !== void 0 ? _c : 0;
            });
        };
        _this.handleClick = function(time) {
            var _a, _b;
            if ((_this.props.minTime || _this.props.maxTime) && $e5a100bdab37c2de$var$isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && $e5a100bdab37c2de$var$isTimeDisabled(time, _this.props)) return;
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, time);
        };
        _this.isSelectedTime = function(time) {
            var selected = $e5a100bdab37c2de$var$safeToDate(_this.props.selected);
            return selected && $e5a100bdab37c2de$var$isSameMinute(selected, time);
        };
        _this.isDisabledTime = function(time) {
            return (_this.props.minTime || _this.props.maxTime) && $e5a100bdab37c2de$var$isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && $e5a100bdab37c2de$var$isTimeDisabled(time, _this.props);
        };
        _this.liClasses = function(time) {
            var _a;
            var classes = [
                "react-datepicker__time-list-item",
                _this.props.timeClassName ? _this.props.timeClassName(time) : undefined
            ];
            if (_this.isSelectedTime(time)) classes.push("react-datepicker__time-list-item--selected");
            if (_this.isDisabledTime(time)) classes.push("react-datepicker__time-list-item--disabled");
            //convert this.props.intervals and the relevant time to seconds and check if it it's a clean multiple of the interval
            if (_this.props.injectTimes && ((0, $e570a7bac6dc48a8$exports.getHours)(time) * 3600 + (0, $e570a7bac6dc48a8$exports.getMinutes)(time) * 60 + (0, $e570a7bac6dc48a8$exports.getSeconds)(time)) % (((_a = _this.props.intervals) !== null && _a !== void 0 ? _a : Time.defaultProps.intervals) * 60) !== 0) classes.push("react-datepicker__time-list-item--injected");
            return classes.join(" ");
        };
        _this.handleOnKeyDown = function(event, time) {
            var _a, _b;
            if (event.key === $e5a100bdab37c2de$var$KeyType.Space) {
                event.preventDefault();
                event.key = $e5a100bdab37c2de$var$KeyType.Enter;
            }
            if ((event.key === $e5a100bdab37c2de$var$KeyType.ArrowUp || event.key === $e5a100bdab37c2de$var$KeyType.ArrowLeft) && event.target instanceof HTMLElement && event.target.previousSibling) {
                event.preventDefault();
                event.target.previousSibling instanceof HTMLElement && event.target.previousSibling.focus();
            }
            if ((event.key === $e5a100bdab37c2de$var$KeyType.ArrowDown || event.key === $e5a100bdab37c2de$var$KeyType.ArrowRight) && event.target instanceof HTMLElement && event.target.nextSibling) {
                event.preventDefault();
                event.target.nextSibling instanceof HTMLElement && event.target.nextSibling.focus();
            }
            if (event.key === $e5a100bdab37c2de$var$KeyType.Enter) _this.handleClick(time);
            (_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.renderTimes = function() {
            var _a;
            var times = [];
            var format = typeof _this.props.format === "string" ? _this.props.format : "p";
            var intervals = (_a = _this.props.intervals) !== null && _a !== void 0 ? _a : Time.defaultProps.intervals;
            var activeDate = $e5a100bdab37c2de$var$safeToDate(_this.props.selected) || $e5a100bdab37c2de$var$safeToDate(_this.props.openToDate) || $e5a100bdab37c2de$var$newDate();
            var base = $e5a100bdab37c2de$var$getStartOfDay(activeDate);
            var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
            var minutesInDay = 60 * $e5a100bdab37c2de$var$getHoursInDay(activeDate);
            var multiplier = minutesInDay / intervals;
            for(var i = 0; i < multiplier; i++){
                var currentTime = (0, $e570a7bac6dc48a8$exports.addMinutes)(base, i * intervals);
                times.push(currentTime);
                if (sortedInjectTimes) {
                    var timesToInject = $e5a100bdab37c2de$var$timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
                    times = times.concat(timesToInject);
                }
            }
            // Determine which time to focus and scroll into view when component mounts
            var timeToFocus = times.reduce(function(prev, time) {
                if (time.getTime() <= activeDate.getTime()) return time;
                return prev;
            }, times[0]);
            return times.map(function(time) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("li", {
                    key: time.valueOf(),
                    onClick: _this.handleClick.bind(_this, time),
                    className: _this.liClasses(time),
                    ref: function(li) {
                        if (time === timeToFocus) _this.centerLi = li;
                    },
                    onKeyDown: function(event) {
                        _this.handleOnKeyDown(event, time);
                    },
                    tabIndex: time === timeToFocus ? 0 : -1,
                    role: "option",
                    "aria-selected": _this.isSelectedTime(time) ? "true" : undefined,
                    "aria-disabled": _this.isDisabledTime(time) ? "true" : undefined
                }, $e5a100bdab37c2de$var$formatDate(time, format, _this.props.locale));
            });
        };
        _this.renderTimeCaption = function() {
            if (_this.props.showTimeCaption === false) return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).Fragment, null);
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                className: "react-datepicker__header react-datepicker__header--time ".concat(_this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                ref: function(header) {
                    _this.header = header;
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                className: "react-datepicker-time__header"
            }, _this.props.timeCaption));
        };
        return _this;
    }
    Object.defineProperty(Time, "defaultProps", {
        get: function() {
            return {
                intervals: 30,
                todayButton: null,
                timeCaption: "Time",
                showTimeCaption: true
            };
        },
        enumerable: false,
        configurable: true
    });
    Time.prototype.componentDidMount = function() {
        // code to ensure selected time will always be in focus within time window when it first appears
        this.scrollToTheSelectedTime();
        this.observeDatePickerHeightChanges();
    };
    Time.prototype.componentWillUnmount = function() {
        var _a;
        (_a = this.resizeObserver) === null || _a === void 0 || _a.disconnect();
    };
    Time.prototype.observeDatePickerHeightChanges = function() {
        var _this = this;
        var monthRef = this.props.monthRef;
        this.updateContainerHeight();
        if (monthRef) {
            this.resizeObserver = new ResizeObserver(function() {
                _this.updateContainerHeight();
            });
            this.resizeObserver.observe(monthRef);
        }
    };
    Time.prototype.updateContainerHeight = function() {
        if (this.props.monthRef && this.header) {
            var newHeight = this.props.monthRef.clientHeight - this.header.clientHeight;
            // Only update state if height actually changed to prevent infinite resize loops
            if (this.state.height !== newHeight) this.setState({
                height: newHeight
            });
        }
    };
    Time.prototype.render = function() {
        var _this = this;
        var _a;
        var height = this.state.height;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: "react-datepicker__time-container ".concat(((_a = this.props.todayButton) !== null && _a !== void 0 ? _a : Time.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "")
        }, this.renderTimeCaption(), (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: "react-datepicker__time"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: "react-datepicker__time-box"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("ul", {
            className: "react-datepicker__time-list",
            ref: function(list) {
                _this.list = list;
            },
            style: height ? {
                height: height
            } : {},
            role: "listbox",
            "aria-label": this.props.timeCaption
        }, this.renderTimes()))));
    };
    Time.calcCenterPosition = function(listHeight, centerLiRef) {
        return centerLiRef.offsetTop - (listHeight / 2 - centerLiRef.clientHeight / 2);
    };
    return Time;
}((0, $7UyaH.Component));
var $e5a100bdab37c2de$var$VERTICAL_NAVIGATION_OFFSET = 3;
/**
 * `Year` is a component that represents a year in a date picker.
 *
 * @class
 * @param {YearProps} props - The properties that define the `Year` component.
 * @property {VoidFunction} [props.clearSelectingDate] - Function to clear the selected date.
 * @property {Date} [props.date] - The currently selected date.
 * @property {boolean} [props.disabledKeyboardNavigation] - If true, keyboard navigation is disabled.
 * @property {Date} [props.endDate] - The end date in a range selection.
 * @property {(date: Date) => void} props.onDayClick - Function to handle day click events.
 * @property {Date} props.preSelection - The date that is currently in focus.
 * @property {(date: Date) => void} props.setPreSelection - Function to set the pre-selected date.
 * @property {{ [key: string]: any }} props.selected - The selected date(s).
 * @property {boolean} props.inline - If true, the date picker is displayed inline.
 * @property {Date} props.maxDate - The maximum selectable date.
 * @property {Date} props.minDate - The minimum selectable date.
 * @property {boolean} props.usePointerEvent - If true, pointer events are used instead of mouse events.
 * @property {(date: Date) => void} props.onYearMouseEnter - Function to handle mouse enter events on a year.
 * @property {(date: Date) => void} props.onYearMouseLeave - Function to handle mouse leave events on a year.
 */ var $e5a100bdab37c2de$var$Year = /** @class */ function(_super) {
    $e5a100bdab37c2de$var$__extends(Year, _super);
    function Year(props) {
        var _this = _super.call(this, props) || this;
        _this.YEAR_REFS = $e5a100bdab37c2de$var$__spreadArray([], Array(_this.props.yearItemNumber), true).map(function() {
            return (0, $7UyaH.createRef)();
        });
        _this.isDisabled = function(date) {
            return $e5a100bdab37c2de$var$isDayDisabled(date, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate
            });
        };
        _this.isExcluded = function(date) {
            return $e5a100bdab37c2de$var$isDayExcluded(date, {
                excludeDates: _this.props.excludeDates
            });
        };
        _this.selectingDate = function() {
            var _a;
            return (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
        };
        _this.updateFocusOnPaginate = function(refIndex) {
            var waitForReRender = function() {
                var _a, _b;
                (_b = (_a = _this.YEAR_REFS[refIndex]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 || _b.focus();
            };
            window.requestAnimationFrame(waitForReRender);
        };
        _this.handleYearClick = function(day, event) {
            if (_this.props.onDayClick) _this.props.onDayClick(day, event);
        };
        _this.handleYearNavigation = function(newYear, newDate) {
            var _a, _b, _c, _d;
            var _e = _this.props, date = _e.date, yearItemNumber = _e.yearItemNumber;
            if (date === undefined || yearItemNumber === undefined) return;
            var startPeriod = $e5a100bdab37c2de$var$getYearsPeriod(date, yearItemNumber).startPeriod;
            if (_this.isDisabled(newDate) || _this.isExcluded(newDate)) return;
            (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
            if (newYear - startPeriod < 0) _this.updateFocusOnPaginate(yearItemNumber - (startPeriod - newYear));
            else if (newYear - startPeriod >= yearItemNumber) _this.updateFocusOnPaginate(Math.abs(yearItemNumber - (newYear - startPeriod)));
            else (_d = (_c = _this.YEAR_REFS[newYear - startPeriod]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        };
        _this.isSameDay = function(y, other) {
            return $e5a100bdab37c2de$var$isSameDay(y, other);
        };
        _this.isCurrentYear = function(y) {
            return y === (0, $e570a7bac6dc48a8$exports.getYear)($e5a100bdab37c2de$var$newDate());
        };
        _this.isRangeStart = function(y) {
            return _this.props.startDate && _this.props.endDate && $e5a100bdab37c2de$var$isSameYear((0, $e570a7bac6dc48a8$exports.setYear)($e5a100bdab37c2de$var$newDate(), y), _this.props.startDate);
        };
        _this.isRangeEnd = function(y) {
            return _this.props.startDate && _this.props.endDate && $e5a100bdab37c2de$var$isSameYear((0, $e570a7bac6dc48a8$exports.setYear)($e5a100bdab37c2de$var$newDate(), y), _this.props.endDate);
        };
        _this.isInRange = function(y) {
            return $e5a100bdab37c2de$var$isYearInRange(y, _this.props.startDate, _this.props.endDate);
        };
        _this.isInSelectingRange = function(y) {
            var _a = _this.props, selectsStart = _a.selectsStart, selectsEnd = _a.selectsEnd, selectsRange = _a.selectsRange, startDate = _a.startDate, endDate = _a.endDate;
            if (!(selectsStart || selectsEnd || selectsRange) || !_this.selectingDate()) return false;
            if (selectsStart && endDate) return $e5a100bdab37c2de$var$isYearInRange(y, _this.selectingDate(), endDate);
            if (selectsEnd && startDate) return $e5a100bdab37c2de$var$isYearInRange(y, startDate, _this.selectingDate());
            if (selectsRange && startDate && !endDate) return $e5a100bdab37c2de$var$isYearInRange(y, startDate, _this.selectingDate());
            return false;
        };
        _this.isSelectingRangeStart = function(y) {
            var _a;
            if (!_this.isInSelectingRange(y)) return false;
            var _b = _this.props, startDate = _b.startDate, selectsStart = _b.selectsStart;
            var _year = (0, $e570a7bac6dc48a8$exports.setYear)($e5a100bdab37c2de$var$newDate(), y);
            if (selectsStart) return $e5a100bdab37c2de$var$isSameYear(_year, (_a = _this.selectingDate()) !== null && _a !== void 0 ? _a : null);
            return $e5a100bdab37c2de$var$isSameYear(_year, startDate !== null && startDate !== void 0 ? startDate : null);
        };
        _this.isSelectingRangeEnd = function(y) {
            var _a;
            if (!_this.isInSelectingRange(y)) return false;
            var _b = _this.props, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange;
            var _year = (0, $e570a7bac6dc48a8$exports.setYear)($e5a100bdab37c2de$var$newDate(), y);
            if (selectsEnd || selectsRange) return $e5a100bdab37c2de$var$isSameYear(_year, (_a = _this.selectingDate()) !== null && _a !== void 0 ? _a : null);
            return $e5a100bdab37c2de$var$isSameYear(_year, endDate !== null && endDate !== void 0 ? endDate : null);
        };
        _this.isKeyboardSelected = function(y) {
            if (_this.props.disabledKeyboardNavigation || _this.props.date === undefined || _this.props.preSelection == null) return;
            var _a = _this.props, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, selected = _a.selected;
            var date = $e5a100bdab37c2de$var$getStartOfYear((0, $e570a7bac6dc48a8$exports.setYear)(_this.props.date, y));
            var isDisabled = (minDate || maxDate || excludeDates || includeDates || filterDate) && $e5a100bdab37c2de$var$isYearDisabled(y, _this.props);
            var isSelectedDay = !!selected && $e5a100bdab37c2de$var$isSameDay(date, $e5a100bdab37c2de$var$getStartOfYear(selected));
            var isKeyboardSelectedDay = $e5a100bdab37c2de$var$isSameDay(date, $e5a100bdab37c2de$var$getStartOfYear(_this.props.preSelection));
            return !_this.props.inline && !isSelectedDay && isKeyboardSelectedDay && !isDisabled;
        };
        _this.isSelectedYear = function(year) {
            var _a = _this.props, selectsMultiple = _a.selectsMultiple, selected = _a.selected, selectedDates = _a.selectedDates;
            if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(date) {
                return year === (0, $e570a7bac6dc48a8$exports.getYear)(date);
            });
            return !!selected && year === (0, $e570a7bac6dc48a8$exports.getYear)(selected);
        };
        _this.onYearClick = function(event, y) {
            var date = _this.props.date;
            if (date === undefined) return;
            _this.handleYearClick($e5a100bdab37c2de$var$getStartOfYear((0, $e570a7bac6dc48a8$exports.setYear)(date, y)), event);
        };
        _this.onYearKeyDown = function(event, y) {
            var _a, _b;
            var key = event.key;
            var _c = _this.props, date = _c.date, yearItemNumber = _c.yearItemNumber, handleOnKeyDown = _c.handleOnKeyDown;
            if (key !== $e5a100bdab37c2de$var$KeyType.Tab) // preventDefault on tab event blocks focus change
            event.preventDefault();
            if (!_this.props.disabledKeyboardNavigation) switch(key){
                case $e5a100bdab37c2de$var$KeyType.Enter:
                    if (_this.props.selected == null) break;
                    _this.onYearClick(event, y);
                    (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, _this.props.selected);
                    break;
                case $e5a100bdab37c2de$var$KeyType.ArrowRight:
                    if (_this.props.preSelection == null) break;
                    _this.handleYearNavigation(y + 1, (0, $e570a7bac6dc48a8$exports.addYears)(_this.props.preSelection, 1));
                    break;
                case $e5a100bdab37c2de$var$KeyType.ArrowLeft:
                    if (_this.props.preSelection == null) break;
                    _this.handleYearNavigation(y - 1, (0, $e570a7bac6dc48a8$exports.subYears)(_this.props.preSelection, 1));
                    break;
                case $e5a100bdab37c2de$var$KeyType.ArrowUp:
                    if (date === undefined || yearItemNumber === undefined || _this.props.preSelection == null) break;
                    var startPeriod = $e5a100bdab37c2de$var$getYearsPeriod(date, yearItemNumber).startPeriod;
                    var offset = $e5a100bdab37c2de$var$VERTICAL_NAVIGATION_OFFSET;
                    var newYear = y - offset;
                    if (newYear < startPeriod) {
                        var leftOverOffset = yearItemNumber % offset;
                        if (y >= startPeriod && y < startPeriod + leftOverOffset) offset = leftOverOffset;
                        else offset += leftOverOffset;
                        newYear = y - offset;
                    }
                    _this.handleYearNavigation(newYear, (0, $e570a7bac6dc48a8$exports.subYears)(_this.props.preSelection, offset));
                    break;
                case $e5a100bdab37c2de$var$KeyType.ArrowDown:
                    if (date === undefined || yearItemNumber === undefined || _this.props.preSelection == null) break;
                    var endPeriod = $e5a100bdab37c2de$var$getYearsPeriod(date, yearItemNumber).endPeriod;
                    var offset = $e5a100bdab37c2de$var$VERTICAL_NAVIGATION_OFFSET;
                    var newYear = y + offset;
                    if (newYear > endPeriod) {
                        var leftOverOffset = yearItemNumber % offset;
                        if (y <= endPeriod && y > endPeriod - leftOverOffset) offset = leftOverOffset;
                        else offset += leftOverOffset;
                        newYear = y + offset;
                    }
                    _this.handleYearNavigation(newYear, (0, $e570a7bac6dc48a8$exports.addYears)(_this.props.preSelection, offset));
                    break;
            }
            handleOnKeyDown && handleOnKeyDown(event);
        };
        _this.getYearClassNames = function(y) {
            var _a = _this.props, date = _a.date, disabled = _a.disabled, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, yearClassName = _a.yearClassName;
            return (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)("react-datepicker__year-text", "react-datepicker__year-".concat(y), date ? yearClassName === null || yearClassName === void 0 ? void 0 : yearClassName((0, $e570a7bac6dc48a8$exports.setYear)(date, y)) : undefined, {
                "react-datepicker__year-text--selected": _this.isSelectedYear(y),
                "react-datepicker__year-text--disabled": (minDate || maxDate || excludeDates || includeDates || filterDate || disabled) && $e5a100bdab37c2de$var$isYearDisabled(y, _this.props),
                "react-datepicker__year-text--keyboard-selected": _this.isKeyboardSelected(y),
                "react-datepicker__year-text--range-start": _this.isRangeStart(y),
                "react-datepicker__year-text--range-end": _this.isRangeEnd(y),
                "react-datepicker__year-text--in-range": _this.isInRange(y),
                "react-datepicker__year-text--in-selecting-range": _this.isInSelectingRange(y),
                "react-datepicker__year-text--selecting-range-start": _this.isSelectingRangeStart(y),
                "react-datepicker__year-text--selecting-range-end": _this.isSelectingRangeEnd(y),
                "react-datepicker__year-text--today": _this.isCurrentYear(y)
            });
        };
        _this.getYearTabIndex = function(y) {
            if (_this.props.disabledKeyboardNavigation || _this.props.preSelection == null) return "-1";
            var preSelected = (0, $e570a7bac6dc48a8$exports.getYear)(_this.props.preSelection);
            var isPreSelectedYearDisabled = $e5a100bdab37c2de$var$isYearDisabled(y, _this.props);
            return y === preSelected && !isPreSelectedYearDisabled ? "0" : "-1";
        };
        _this.getYearContent = function(y) {
            return _this.props.renderYearContent ? _this.props.renderYearContent(y) : y;
        };
        return _this;
    }
    Year.prototype.render = function() {
        var _this = this;
        var yearsList = [];
        var _a = this.props, date = _a.date, yearItemNumber = _a.yearItemNumber, onYearMouseEnter = _a.onYearMouseEnter, onYearMouseLeave = _a.onYearMouseLeave;
        if (date === undefined) return null;
        var _b = $e5a100bdab37c2de$var$getYearsPeriod(date, yearItemNumber), startPeriod = _b.startPeriod, endPeriod = _b.endPeriod;
        var _loop_1 = function(y) {
            yearsList.push((0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                ref: this_1.YEAR_REFS[y - startPeriod],
                onClick: function(event) {
                    _this.onYearClick(event, y);
                },
                onKeyDown: function(event) {
                    if ($e5a100bdab37c2de$var$isSpaceKeyDown(event)) {
                        event.preventDefault();
                        event.key = $e5a100bdab37c2de$var$KeyType.Enter;
                    }
                    _this.onYearKeyDown(event, y);
                },
                tabIndex: Number(this_1.getYearTabIndex(y)),
                className: this_1.getYearClassNames(y),
                onMouseEnter: !this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseEnter(event, y);
                } : undefined,
                onPointerEnter: this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseEnter(event, y);
                } : undefined,
                onMouseLeave: !this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseLeave(event, y);
                } : undefined,
                onPointerLeave: this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseLeave(event, y);
                } : undefined,
                key: y,
                "aria-current": this_1.isCurrentYear(y) ? "date" : undefined
            }, this_1.getYearContent(y)));
        };
        var this_1 = this;
        for(var y = startPeriod; y <= endPeriod; y++)_loop_1(y);
        return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: "react-datepicker__year"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: "react-datepicker__year-wrapper",
            onMouseLeave: !this.props.usePointerEvent ? this.props.clearSelectingDate : undefined,
            onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : undefined
        }, yearsList));
    };
    return Year;
}((0, $7UyaH.Component));
function $e5a100bdab37c2de$var$generateYears(year, noOfYear, minDate, maxDate) {
    var list = [];
    for(var i = 0; i < 2 * noOfYear + 1; i++){
        var newYear = year + noOfYear - i;
        var isInRange = true;
        if (minDate) isInRange = (0, $e570a7bac6dc48a8$exports.getYear)(minDate) <= newYear;
        if (maxDate && isInRange) isInRange = (0, $e570a7bac6dc48a8$exports.getYear)(maxDate) >= newYear;
        if (isInRange) list.push(newYear);
    }
    return list;
}
var $e5a100bdab37c2de$var$YearDropdownOptions = /** @class */ function(_super) {
    $e5a100bdab37c2de$var$__extends(YearDropdownOptions, _super);
    function YearDropdownOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.yearOptionButtonsRef = {};
        _this.handleOptionKeyDown = function(year, e) {
            var _a;
            switch(e.key){
                case "Enter":
                    e.preventDefault();
                    _this.onChange(year);
                    break;
                case "Escape":
                    e.preventDefault();
                    _this.props.onCancel();
                    break;
                case "ArrowUp":
                case "ArrowDown":
                    e.preventDefault();
                    var newYear = year + (e.key === "ArrowUp" ? 1 : -1);
                    // Add bounds checking to ensure the year exists in our refs
                    if (_this.yearOptionButtonsRef[newYear]) (_a = _this.yearOptionButtonsRef[newYear]) === null || _a === void 0 || _a.focus();
                    break;
            }
        };
        _this.renderOptions = function() {
            // Clear refs to prevent memory leaks on re-render
            _this.yearOptionButtonsRef = {};
            var selectedYear = _this.props.year;
            var options = _this.state.yearsList.map(function(year) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                    ref: function(el) {
                        _this.yearOptionButtonsRef[year] = el;
                        if (year === selectedYear) el === null || el === void 0 || el.focus();
                    },
                    role: "button",
                    tabIndex: 0,
                    className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                    key: year,
                    onClick: _this.onChange.bind(_this, year),
                    onKeyDown: _this.handleOptionKeyDown.bind(_this, year),
                    "aria-selected": selectedYear === year ? "true" : undefined
                }, selectedYear === year ? (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                    className: "react-datepicker__year-option--selected"
                }, "\u2713") : "", year);
            });
            var minYear = _this.props.minDate ? (0, $e570a7bac6dc48a8$exports.getYear)(_this.props.minDate) : null;
            var maxYear = _this.props.maxDate ? (0, $e570a7bac6dc48a8$exports.getYear)(_this.props.maxDate) : null;
            if (!maxYear || !_this.state.yearsList.find(function(year) {
                return year === maxYear;
            })) options.unshift((0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                className: "react-datepicker__year-option",
                key: "upcoming",
                onClick: _this.incrementYears
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("a", {
                className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
            })));
            if (!minYear || !_this.state.yearsList.find(function(year) {
                return year === minYear;
            })) options.push((0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                className: "react-datepicker__year-option",
                key: "previous",
                onClick: _this.decrementYears
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("a", {
                className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
            })));
            return options;
        };
        _this.onChange = function(year) {
            _this.props.onChange(year);
        };
        _this.handleClickOutside = function() {
            _this.props.onCancel();
        };
        _this.shiftYears = function(amount) {
            var years = _this.state.yearsList.map(function(year) {
                return year + amount;
            });
            _this.setState({
                yearsList: years
            });
        };
        _this.incrementYears = function() {
            return _this.shiftYears(1);
        };
        _this.decrementYears = function() {
            return _this.shiftYears(-1);
        };
        var yearDropdownItemNumber = props.yearDropdownItemNumber, scrollableYearDropdown = props.scrollableYearDropdown;
        var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
        _this.state = {
            yearsList: $e5a100bdab37c2de$var$generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
        };
        _this.dropdownRef = (0, $7UyaH.createRef)();
        return _this;
    }
    YearDropdownOptions.prototype.componentDidMount = function() {
        var dropdownCurrent = this.dropdownRef.current;
        if (dropdownCurrent) {
            // Get array from HTMLCollection
            var dropdownCurrentChildren = dropdownCurrent.children ? Array.from(dropdownCurrent.children) : null;
            var selectedYearOptionEl = dropdownCurrentChildren ? dropdownCurrentChildren.find(function(childEl) {
                return childEl.ariaSelected;
            }) : null;
            dropdownCurrent.scrollTop = selectedYearOptionEl && selectedYearOptionEl instanceof HTMLElement ? selectedYearOptionEl.offsetTop + (selectedYearOptionEl.clientHeight - dropdownCurrent.clientHeight) / 2 : (dropdownCurrent.scrollHeight - dropdownCurrent.clientHeight) / 2;
        }
    };
    YearDropdownOptions.prototype.render = function() {
        var dropdownClass = (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)({
            "react-datepicker__year-dropdown": true,
            "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$ClickOutsideWrapper, {
            className: dropdownClass,
            containerRef: this.dropdownRef,
            onClickOutside: this.handleClickOutside
        }, this.renderOptions());
    };
    return YearDropdownOptions;
}((0, $7UyaH.Component));
var $e5a100bdab37c2de$var$YearDropdown = /** @class */ function(_super) {
    $e5a100bdab37c2de$var$__extends(YearDropdown, _super);
    function YearDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownVisible: false
        };
        _this.renderSelectOptions = function() {
            var minYear = _this.props.minDate ? (0, $e570a7bac6dc48a8$exports.getYear)(_this.props.minDate) : 1900;
            var maxYear = _this.props.maxDate ? (0, $e570a7bac6dc48a8$exports.getYear)(_this.props.maxDate) : 2100;
            var options = [];
            for(var i = minYear; i <= maxYear; i++)options.push((0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("option", {
                key: i,
                value: i
            }, i));
            return options;
        };
        _this.onSelectChange = function(event) {
            _this.onChange(parseInt(event.target.value));
        };
        _this.renderSelectMode = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("select", {
                value: _this.props.year,
                className: "react-datepicker__year-select",
                onChange: _this.onSelectChange
            }, _this.renderSelectOptions());
        };
        _this.renderReadView = function(visible) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("button", {
                key: "read",
                type: "button",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__year-read-view",
                onClick: _this.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                className: "react-datepicker__year-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                className: "react-datepicker__year-read-view--selected-year"
            }, _this.props.year));
        };
        _this.renderDropdown = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$YearDropdownOptions, $e5a100bdab37c2de$var$_assign({
                key: "dropdown"
            }, _this.props, {
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            }));
        };
        _this.renderScrollMode = function() {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown());
            return result;
        };
        _this.onChange = function(year) {
            _this.toggleDropdown();
            if (year === _this.props.year) return;
            _this.props.onChange(year);
        };
        _this.toggleDropdown = function(event) {
            _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            }, function() {
                if (_this.props.adjustDateOnChange) _this.handleYearChange(_this.props.date, event);
            });
        };
        _this.handleYearChange = function(date, event) {
            var _a;
            (_a = _this.onSelect) === null || _a === void 0 || _a.call(_this, date, event);
            _this.setOpen();
        };
        _this.onSelect = function(date, event) {
            var _a, _b;
            (_b = (_a = _this.props).onSelect) === null || _b === void 0 || _b.call(_a, date, event);
        };
        _this.setOpen = function() {
            var _a, _b;
            (_b = (_a = _this.props).setOpen) === null || _b === void 0 || _b.call(_a, true);
        };
        return _this;
    }
    YearDropdown.prototype.render = function() {
        var renderedDropdown;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode();
                break;
            case "select":
                renderedDropdown = this.renderSelectMode();
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
        }, renderedDropdown);
    };
    return YearDropdown;
}((0, $7UyaH.Component));
var $e5a100bdab37c2de$var$DROPDOWN_FOCUS_CLASSNAMES = [
    "react-datepicker__year-select",
    "react-datepicker__month-select",
    "react-datepicker__month-year-select"
];
var $e5a100bdab37c2de$var$OUTSIDE_CLICK_IGNORE_CLASS = "react-datepicker-ignore-onclickoutside";
var $e5a100bdab37c2de$var$isDropdownSelect = function(element) {
    var classNames = (element.className || "").split(/\s+/);
    return $e5a100bdab37c2de$var$DROPDOWN_FOCUS_CLASSNAMES.some(function(testClassname) {
        return classNames.indexOf(testClassname) >= 0;
    });
};
var $e5a100bdab37c2de$var$Calendar = /** @class */ function(_super) {
    $e5a100bdab37c2de$var$__extends(Calendar, _super);
    function Calendar(props) {
        var _this = _super.call(this, props) || this;
        _this.monthContainer = undefined;
        _this.handleClickOutside = function(event) {
            _this.props.onClickOutside(event);
        };
        _this.setClickOutsideRef = function() {
            return _this.containerRef.current;
        };
        _this.handleDropdownFocus = function(event) {
            var _a, _b;
            if ($e5a100bdab37c2de$var$isDropdownSelect(event.target)) (_b = (_a = _this.props).onDropdownFocus) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.getDateInView = function() {
            var _a = _this.props, preSelection = _a.preSelection, selected = _a.selected, openToDate = _a.openToDate;
            var minDate = $e5a100bdab37c2de$var$getEffectiveMinDate(_this.props);
            var maxDate = $e5a100bdab37c2de$var$getEffectiveMaxDate(_this.props);
            var current = $e5a100bdab37c2de$var$newDate();
            var initialDate = openToDate || selected || preSelection;
            if (initialDate) return initialDate;
            else {
                if (minDate && (0, $e570a7bac6dc48a8$exports.isBefore)(current, minDate)) return minDate;
                else if (maxDate && (0, $e570a7bac6dc48a8$exports.isAfter)(current, maxDate)) return maxDate;
            }
            return current;
        };
        _this.increaseMonth = function() {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $e570a7bac6dc48a8$exports.addMonths)(date, 1)
                };
            }, function() {
                return _this.handleMonthChange(_this.state.date);
            });
        };
        _this.decreaseMonth = function() {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $e570a7bac6dc48a8$exports.subMonths)(date, 1)
                };
            }, function() {
                return _this.handleMonthChange(_this.state.date);
            });
        };
        _this.handleDayClick = function(day, event, monthSelectedIn) {
            _this.props.onSelect(day, event, monthSelectedIn);
            _this.props.setPreSelection && _this.props.setPreSelection(day);
        };
        _this.handleDayMouseEnter = function(day) {
            _this.setState({
                selectingDate: day
            });
            _this.props.onDayMouseEnter && _this.props.onDayMouseEnter(day);
        };
        _this.handleMonthMouseLeave = function() {
            _this.setState({
                selectingDate: undefined
            });
            _this.props.onMonthMouseLeave && _this.props.onMonthMouseLeave();
        };
        _this.handleYearMouseEnter = function(event, year) {
            _this.setState({
                selectingDate: (0, $e570a7bac6dc48a8$exports.setYear)($e5a100bdab37c2de$var$newDate(), year)
            });
            !!_this.props.onYearMouseEnter && _this.props.onYearMouseEnter(event, year);
        };
        _this.handleYearMouseLeave = function(event, year) {
            !!_this.props.onYearMouseLeave && _this.props.onYearMouseLeave(event, year);
        };
        _this.handleYearChange = function(date) {
            var _a, _b, _c, _d;
            (_b = (_a = _this.props).onYearChange) === null || _b === void 0 || _b.call(_a, date);
            _this.setState({
                isRenderAriaLiveMessage: true
            });
            if (_this.props.adjustDateOnChange) {
                _this.props.onSelect(date);
                (_d = (_c = _this.props).setOpen) === null || _d === void 0 || _d.call(_c, true);
            }
            _this.props.setPreSelection && _this.props.setPreSelection(date);
        };
        _this.getEnabledPreSelectionDateForMonth = function(date) {
            if (!$e5a100bdab37c2de$var$isDayDisabled(date, _this.props)) return date;
            var startOfMonth = $e5a100bdab37c2de$var$getStartOfMonth(date);
            var endOfMonth = $e5a100bdab37c2de$var$getEndOfMonth(date);
            var totalDays = (0, $e570a7bac6dc48a8$exports.differenceInDays)(endOfMonth, startOfMonth);
            var preSelectedDate = null;
            for(var dayIdx = 0; dayIdx <= totalDays; dayIdx++){
                var processingDate = (0, $e570a7bac6dc48a8$exports.addDays)(startOfMonth, dayIdx);
                if (!$e5a100bdab37c2de$var$isDayDisabled(processingDate, _this.props)) {
                    preSelectedDate = processingDate;
                    break;
                }
            }
            return preSelectedDate;
        };
        _this.handleMonthChange = function(date) {
            var _a, _b, _c;
            var enabledPreSelectionDate = (_a = _this.getEnabledPreSelectionDateForMonth(date)) !== null && _a !== void 0 ? _a : date;
            _this.handleCustomMonthChange(enabledPreSelectionDate);
            if (_this.props.adjustDateOnChange) {
                _this.props.onSelect(enabledPreSelectionDate);
                (_c = (_b = _this.props).setOpen) === null || _c === void 0 || _c.call(_b, true);
            }
            _this.props.setPreSelection && _this.props.setPreSelection(enabledPreSelectionDate);
        };
        _this.handleCustomMonthChange = function(date) {
            var _a, _b;
            (_b = (_a = _this.props).onMonthChange) === null || _b === void 0 || _b.call(_a, date);
            _this.setState({
                isRenderAriaLiveMessage: true
            });
        };
        _this.handleMonthYearChange = function(date) {
            _this.handleYearChange(date);
            _this.handleMonthChange(date);
        };
        _this.changeYear = function(year) {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $e570a7bac6dc48a8$exports.setYear)(date, Number(year))
                };
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.changeMonth = function(month) {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $e570a7bac6dc48a8$exports.setMonth)(date, Number(month))
                };
            }, function() {
                var _a, _b;
                _this.handleMonthChange(_this.state.date);
                // Reset monthSelectedIn to 0 so the target month appears in the leftmost position
                // This ensures consistent behavior when using changeMonth in custom headers
                (_b = (_a = _this.props).onMonthSelectedInChange) === null || _b === void 0 || _b.call(_a, 0);
            });
        };
        _this.changeMonthYear = function(monthYear) {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $e570a7bac6dc48a8$exports.setYear)((0, $e570a7bac6dc48a8$exports.setMonth)(date, (0, $e570a7bac6dc48a8$exports.getMonth)(monthYear)), (0, $e570a7bac6dc48a8$exports.getYear)(monthYear))
                };
            }, function() {
                return _this.handleMonthYearChange(_this.state.date);
            });
        };
        _this.header = function(date, customDayNameCount) {
            if (date === void 0) date = _this.state.date;
            if (customDayNameCount === void 0) customDayNameCount = 0;
            // Return empty array if date is invalid
            if (!$e5a100bdab37c2de$var$isValid(date)) return [];
            var disabled = _this.props.disabled;
            var startOfWeek = $e5a100bdab37c2de$var$getStartOfWeek(date, _this.props.locale, _this.props.calendarStartDay);
            var dayNames = [];
            if (_this.props.showWeekNumbers) dayNames.push((0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                key: "W",
                className: "react-datepicker__day-name ".concat(disabled ? "react-datepicker__day-name--disabled" : ""),
                role: "columnheader"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                className: "react-datepicker__sr-only"
            }, "Week number"), (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                "aria-hidden": "true"
            }, _this.props.weekLabel || "#")));
            return dayNames.concat([
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map(function(offset) {
                var day = (0, $e570a7bac6dc48a8$exports.addDays)(startOfWeek, offset);
                var weekDayName = _this.formatWeekday(day, _this.props.locale);
                var fullDayName = $e5a100bdab37c2de$var$formatDate(day, "EEEE", _this.props.locale);
                var weekDayClassName = _this.props.weekDayClassName ? _this.props.weekDayClassName(day) : undefined;
                // Use custom render if provided
                if (_this.props.renderCustomDayName) {
                    var customContent = _this.props.renderCustomDayName({
                        day: day,
                        shortName: weekDayName,
                        fullName: fullDayName,
                        locale: _this.props.locale,
                        customDayNameCount: customDayNameCount
                    });
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                        key: offset,
                        role: "columnheader",
                        className: (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)("react-datepicker__day-name", weekDayClassName, disabled ? "react-datepicker__day-name--disabled" : "")
                    }, customContent);
                }
                // Default render
                return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                    key: offset,
                    role: "columnheader",
                    className: (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)("react-datepicker__day-name", weekDayClassName, disabled ? "react-datepicker__day-name--disabled" : "")
                }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                    className: "react-datepicker__sr-only"
                }, fullDayName), (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                    "aria-hidden": "true"
                }, weekDayName));
            }));
        };
        _this.formatWeekday = function(day, locale) {
            if (_this.props.formatWeekDay) return $e5a100bdab37c2de$var$getFormattedWeekdayInLocale(day, _this.props.formatWeekDay, locale);
            return _this.props.useWeekdaysShort ? $e5a100bdab37c2de$var$getWeekdayShortInLocale(day, locale) : $e5a100bdab37c2de$var$getWeekdayMinInLocale(day, locale);
        };
        _this.decreaseYear = function() {
            _this.setState(function(_a) {
                var _b;
                var date = _a.date;
                return {
                    date: (0, $e570a7bac6dc48a8$exports.subYears)(date, _this.props.showYearPicker ? (_b = _this.props.yearItemNumber) !== null && _b !== void 0 ? _b : Calendar.defaultProps.yearItemNumber : 1)
                };
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.clearSelectingDate = function() {
            _this.setState({
                selectingDate: undefined
            });
        };
        _this.renderPreviousButton = function() {
            var _a, _b, _c;
            if (_this.props.renderCustomHeader) return;
            var monthsShown = (_a = _this.props.monthsShown) !== null && _a !== void 0 ? _a : Calendar.defaultProps.monthsShown;
            var monthsToSubtract = _this.props.showPreviousMonths ? monthsShown - 1 : 0;
            var monthSelectedIn = (_b = _this.props.monthSelectedIn) !== null && _b !== void 0 ? _b : monthsToSubtract;
            var fromMonthDate = (0, $e570a7bac6dc48a8$exports.subMonths)(_this.state.date, monthSelectedIn);
            var allPrevDaysDisabled;
            switch(true){
                case _this.props.disabled:
                    allPrevDaysDisabled = true;
                    break;
                case _this.props.showMonthYearPicker:
                    allPrevDaysDisabled = $e5a100bdab37c2de$var$yearDisabledBefore(_this.state.date, _this.props);
                    break;
                case _this.props.showYearPicker:
                    allPrevDaysDisabled = $e5a100bdab37c2de$var$yearsDisabledBefore(_this.state.date, _this.props);
                    break;
                case _this.props.showQuarterYearPicker:
                    allPrevDaysDisabled = $e5a100bdab37c2de$var$quarterDisabledBefore(_this.state.date, _this.props);
                    break;
                default:
                    allPrevDaysDisabled = $e5a100bdab37c2de$var$monthDisabledBefore(fromMonthDate, _this.props);
                    break;
            }
            if (!((_c = _this.props.forceShowMonthNavigation) !== null && _c !== void 0 ? _c : Calendar.defaultProps.forceShowMonthNavigation) && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) return;
            var iconClasses = [
                "react-datepicker__navigation-icon",
                "react-datepicker__navigation-icon--previous"
            ];
            var classes = [
                "react-datepicker__navigation",
                "react-datepicker__navigation--previous"
            ];
            var clickHandler = _this.decreaseMonth;
            if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) clickHandler = _this.decreaseYear;
            if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
                classes.push("react-datepicker__navigation--previous--disabled");
                clickHandler = undefined;
            }
            var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
            var _d = _this.props, _e = _d.previousMonthButtonLabel, previousMonthButtonLabel = _e === void 0 ? Calendar.defaultProps.previousMonthButtonLabel : _e, _f = _d.previousYearButtonLabel, previousYearButtonLabel = _f === void 0 ? Calendar.defaultProps.previousYearButtonLabel : _f;
            var _g = _this.props, _h = _g.previousMonthAriaLabel, previousMonthAriaLabel = _h === void 0 ? typeof previousMonthButtonLabel === "string" ? previousMonthButtonLabel : "Previous Month" : _h, _j = _g.previousYearAriaLabel, previousYearAriaLabel = _j === void 0 ? typeof previousYearButtonLabel === "string" ? previousYearButtonLabel : "Previous Year" : _j;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("button", {
                type: "button",
                className: classes.join(" "),
                onClick: clickHandler,
                onKeyDown: _this.props.handleOnKeyDown,
                "aria-label": isForYear ? previousYearAriaLabel : previousMonthAriaLabel
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                className: iconClasses.join(" ")
            }, isForYear ? previousYearButtonLabel : previousMonthButtonLabel));
        };
        _this.increaseYear = function() {
            _this.setState(function(_a) {
                var _b;
                var date = _a.date;
                return {
                    date: (0, $e570a7bac6dc48a8$exports.addYears)(date, _this.props.showYearPicker ? (_b = _this.props.yearItemNumber) !== null && _b !== void 0 ? _b : Calendar.defaultProps.yearItemNumber : 1)
                };
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.renderNextButton = function() {
            var _a;
            if (_this.props.renderCustomHeader) return;
            var allNextDaysDisabled;
            switch(true){
                case _this.props.disabled:
                    allNextDaysDisabled = true;
                    break;
                case _this.props.showMonthYearPicker:
                    allNextDaysDisabled = $e5a100bdab37c2de$var$yearDisabledAfter(_this.state.date, _this.props);
                    break;
                case _this.props.showYearPicker:
                    allNextDaysDisabled = $e5a100bdab37c2de$var$yearsDisabledAfter(_this.state.date, _this.props);
                    break;
                case _this.props.showQuarterYearPicker:
                    allNextDaysDisabled = $e5a100bdab37c2de$var$quarterDisabledAfter(_this.state.date, _this.props);
                    break;
                default:
                    allNextDaysDisabled = $e5a100bdab37c2de$var$monthDisabledAfter(_this.state.date, _this.props);
                    break;
            }
            if (!((_a = _this.props.forceShowMonthNavigation) !== null && _a !== void 0 ? _a : Calendar.defaultProps.forceShowMonthNavigation) && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) return;
            var classes = [
                "react-datepicker__navigation",
                "react-datepicker__navigation--next"
            ];
            var iconClasses = [
                "react-datepicker__navigation-icon",
                "react-datepicker__navigation-icon--next"
            ];
            if (_this.props.showTimeSelect) classes.push("react-datepicker__navigation--next--with-time");
            if (_this.props.todayButton) classes.push("react-datepicker__navigation--next--with-today-button");
            var clickHandler = _this.increaseMonth;
            if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) clickHandler = _this.increaseYear;
            if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
                classes.push("react-datepicker__navigation--next--disabled");
                clickHandler = undefined;
            }
            var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
            var _b = _this.props, _c = _b.nextMonthButtonLabel, nextMonthButtonLabel = _c === void 0 ? Calendar.defaultProps.nextMonthButtonLabel : _c, _d = _b.nextYearButtonLabel, nextYearButtonLabel = _d === void 0 ? Calendar.defaultProps.nextYearButtonLabel : _d;
            var _e = _this.props, _f = _e.nextMonthAriaLabel, nextMonthAriaLabel = _f === void 0 ? typeof nextMonthButtonLabel === "string" ? nextMonthButtonLabel : "Next Month" : _f, _g = _e.nextYearAriaLabel, nextYearAriaLabel = _g === void 0 ? typeof nextYearButtonLabel === "string" ? nextYearButtonLabel : "Next Year" : _g;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("button", {
                type: "button",
                className: classes.join(" "),
                onClick: clickHandler,
                onKeyDown: _this.props.handleOnKeyDown,
                "aria-label": isForYear ? nextYearAriaLabel : nextMonthAriaLabel
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                className: iconClasses.join(" ")
            }, isForYear ? nextYearButtonLabel : nextMonthButtonLabel));
        };
        _this.renderCurrentMonth = function(date) {
            if (date === void 0) date = _this.state.date;
            var classes = [
                "react-datepicker__current-month"
            ];
            if (_this.props.showYearDropdown) classes.push("react-datepicker__current-month--hasYearDropdown");
            if (_this.props.showMonthDropdown) classes.push("react-datepicker__current-month--hasMonthDropdown");
            if (_this.props.showMonthYearDropdown) classes.push("react-datepicker__current-month--hasMonthYearDropdown");
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("h2", {
                className: classes.join(" ")
            }, $e5a100bdab37c2de$var$isValid(date) ? $e5a100bdab37c2de$var$formatDate(date, _this.props.dateFormat, _this.props.locale) : "");
        };
        _this.renderYearDropdown = function(overrideHide) {
            if (overrideHide === void 0) overrideHide = false;
            if (!_this.props.showYearDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$YearDropdown, $e5a100bdab37c2de$var$_assign({}, Calendar.defaultProps, _this.props, {
                date: _this.state.date,
                onChange: _this.changeYear,
                year: (0, $e570a7bac6dc48a8$exports.getYear)(_this.state.date)
            }));
        };
        _this.renderMonthDropdown = function(overrideHide) {
            if (overrideHide === void 0) overrideHide = false;
            if (!_this.props.showMonthDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$MonthDropdown, $e5a100bdab37c2de$var$_assign({}, Calendar.defaultProps, _this.props, {
                month: (0, $e570a7bac6dc48a8$exports.getMonth)(_this.state.date),
                onChange: _this.changeMonth
            }));
        };
        _this.renderMonthYearDropdown = function(overrideHide) {
            if (overrideHide === void 0) overrideHide = false;
            if (!_this.props.showMonthYearDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$MonthYearDropdown, $e5a100bdab37c2de$var$_assign({}, Calendar.defaultProps, _this.props, {
                date: _this.state.date,
                onChange: _this.changeMonthYear
            }));
        };
        _this.handleTodayButtonClick = function(event) {
            _this.props.onSelect($e5a100bdab37c2de$var$getStartOfToday(), event);
            _this.props.setPreSelection && _this.props.setPreSelection($e5a100bdab37c2de$var$getStartOfToday());
        };
        _this.renderTodayButton = function() {
            if (!_this.props.todayButton || _this.props.showTimeSelectOnly) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                className: "react-datepicker__today-button",
                onClick: _this.handleTodayButtonClick
            }, _this.props.todayButton);
        };
        _this.renderDayNamesHeader = function(monthDate, customDayNameCount) {
            if (customDayNameCount === void 0) customDayNameCount = 0;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                className: "react-datepicker__day-names",
                role: "row"
            }, _this.header(monthDate, customDayNameCount));
        };
        _this.renderDefaultHeader = function(_a) {
            var monthDate = _a.monthDate, i = _a.i;
            var headerContent = (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                className: (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)("react-datepicker__header", {
                    "react-datepicker__header--has-time-select": _this.props.showTimeSelect,
                    "react-datepicker__header--middle": _this.props.monthHeaderPosition === "middle",
                    "react-datepicker__header--bottom": _this.props.monthHeaderPosition === "bottom"
                })
            }, _this.renderCurrentMonth(monthDate), (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(_this.props.dropdownMode),
                onFocus: _this.handleDropdownFocus
            }, _this.renderMonthDropdown(i !== 0), _this.renderMonthYearDropdown(i !== 0), _this.renderYearDropdown(i !== 0)));
            // Top position: render header directly in default location
            if (_this.props.monthHeaderPosition === "top") return headerContent;
            // Middle/bottom positions: wrap with navigation buttons
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                className: "react-datepicker__header-wrapper"
            }, _this.renderPreviousButton() || null, _this.renderNextButton() || null, headerContent);
        };
        _this.renderCustomHeader = function(headerArgs) {
            var _a, _b;
            var monthDate = headerArgs.monthDate, i = headerArgs.i;
            if (_this.props.showTimeSelect && !_this.state.monthContainer || _this.props.showTimeSelectOnly) return null;
            var _c = _this.props, showYearPicker = _c.showYearPicker, yearItemNumber = _c.yearItemNumber;
            var visibleYearsRange;
            if (showYearPicker) {
                var _d = $e5a100bdab37c2de$var$getYearsPeriod(monthDate, yearItemNumber), startYear = _d.startPeriod, endYear = _d.endPeriod;
                visibleYearsRange = {
                    startYear: startYear,
                    endYear: endYear
                };
            }
            var prevMonthButtonDisabled = $e5a100bdab37c2de$var$monthDisabledBefore(_this.state.date, _this.props);
            var nextMonthButtonDisabled = $e5a100bdab37c2de$var$monthDisabledAfter(_this.state.date, _this.props);
            var prevYearButtonDisabled = $e5a100bdab37c2de$var$yearDisabledBefore(_this.state.date, _this.props);
            var nextYearButtonDisabled = $e5a100bdab37c2de$var$yearDisabledAfter(_this.state.date, _this.props);
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                className: "react-datepicker__header react-datepicker__header--custom",
                onFocus: _this.props.onDropdownFocus
            }, (_b = (_a = _this.props).renderCustomHeader) === null || _b === void 0 ? void 0 : _b.call(_a, $e5a100bdab37c2de$var$_assign($e5a100bdab37c2de$var$_assign($e5a100bdab37c2de$var$_assign({}, _this.state), showYearPicker && {
                visibleYearsRange: visibleYearsRange
            }), {
                customHeaderCount: i,
                monthDate: monthDate,
                changeMonth: _this.changeMonth,
                changeYear: _this.changeYear,
                decreaseMonth: _this.decreaseMonth,
                increaseMonth: _this.increaseMonth,
                decreaseYear: _this.decreaseYear,
                increaseYear: _this.increaseYear,
                prevMonthButtonDisabled: prevMonthButtonDisabled,
                nextMonthButtonDisabled: nextMonthButtonDisabled,
                prevYearButtonDisabled: prevYearButtonDisabled,
                nextYearButtonDisabled: nextYearButtonDisabled
            })));
        };
        _this.renderYearHeader = function(_a) {
            var monthDate = _a.monthDate;
            var _b = _this.props, showYearPicker = _b.showYearPicker, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? Calendar.defaultProps.yearItemNumber : _c;
            var _d = $e5a100bdab37c2de$var$getYearsPeriod(monthDate, yearItemNumber), startPeriod = _d.startPeriod, endPeriod = _d.endPeriod;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                className: "react-datepicker__header react-datepicker-year-header"
            }, showYearPicker ? "".concat(startPeriod, " - ").concat(endPeriod) : (0, $e570a7bac6dc48a8$exports.getYear)(monthDate));
        };
        _this.renderHeader = function(_a) {
            var monthDate = _a.monthDate, _b = _a.i, i = _b === void 0 ? 0 : _b;
            var headerArgs = {
                monthDate: monthDate,
                i: i
            };
            switch(true){
                case _this.props.renderCustomHeader !== undefined:
                    return _this.renderCustomHeader(headerArgs);
                case _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker:
                    return _this.renderYearHeader(headerArgs);
                default:
                    return _this.renderDefaultHeader(headerArgs);
            }
        };
        _this.renderMonths = function() {
            var _a, _b;
            if (_this.props.showTimeSelectOnly || _this.props.showYearPicker) return;
            var monthList = [];
            var monthsShown = (_a = _this.props.monthsShown) !== null && _a !== void 0 ? _a : Calendar.defaultProps.monthsShown;
            var monthsToSubtract = _this.props.showPreviousMonths ? monthsShown - 1 : 0;
            var fromMonthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? (0, $e570a7bac6dc48a8$exports.addYears)(_this.state.date, monthsToSubtract) : (0, $e570a7bac6dc48a8$exports.subMonths)(_this.state.date, monthsToSubtract);
            var monthSelectedIn = (_b = _this.props.monthSelectedIn) !== null && _b !== void 0 ? _b : monthsToSubtract;
            for(var i = 0; i < monthsShown; ++i){
                var monthsToAdd = i - monthSelectedIn + monthsToSubtract;
                var monthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? (0, $e570a7bac6dc48a8$exports.addYears)(fromMonthDate, monthsToAdd) : (0, $e570a7bac6dc48a8$exports.addMonths)(fromMonthDate, monthsToAdd);
                var monthKey = "month-".concat(i);
                var monthShowsDuplicateDaysEnd = i < monthsShown - 1;
                var monthShowsDuplicateDaysStart = i > 0;
                monthList.push((0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                    key: monthKey,
                    ref: function(div) {
                        _this.monthContainer = div !== null && div !== void 0 ? div : undefined;
                    },
                    className: "react-datepicker__month-container"
                }, _this.props.monthHeaderPosition === "top" && _this.renderHeader({
                    monthDate: monthDate,
                    i: i
                }), (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$Month, $e5a100bdab37c2de$var$_assign({}, Calendar.defaultProps, _this.props, {
                    containerRef: _this.containerRef,
                    ariaLabelPrefix: _this.props.monthAriaLabelPrefix,
                    day: monthDate,
                    onDayClick: _this.handleDayClick,
                    handleOnKeyDown: _this.props.handleOnDayKeyDown,
                    handleOnMonthKeyDown: _this.props.handleOnKeyDown,
                    onDayMouseEnter: _this.handleDayMouseEnter,
                    onMouseLeave: _this.handleMonthMouseLeave,
                    orderInDisplay: i,
                    selectingDate: _this.state.selectingDate,
                    monthShowsDuplicateDaysEnd: monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: monthShowsDuplicateDaysStart,
                    dayNamesHeader: _this.renderDayNamesHeader(monthDate, i),
                    monthHeader: _this.props.monthHeaderPosition === "middle" ? _this.renderHeader({
                        monthDate: monthDate,
                        i: i
                    }) : undefined,
                    monthFooter: _this.props.monthHeaderPosition === "bottom" ? _this.renderHeader({
                        monthDate: monthDate,
                        i: i
                    }) : undefined
                }))));
            }
            return monthList;
        };
        _this.renderYears = function() {
            if (_this.props.showTimeSelectOnly) return;
            if (_this.props.showYearPicker) return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                className: "react-datepicker__year--container"
            }, _this.renderHeader({
                monthDate: _this.state.date
            }), (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$Year, $e5a100bdab37c2de$var$_assign({}, Calendar.defaultProps, _this.props, {
                selectingDate: _this.state.selectingDate,
                date: _this.state.date,
                onDayClick: _this.handleDayClick,
                clearSelectingDate: _this.clearSelectingDate,
                onYearMouseEnter: _this.handleYearMouseEnter,
                onYearMouseLeave: _this.handleYearMouseLeave
            })));
            return;
        };
        _this.renderTimeSection = function() {
            if (_this.props.showTimeSelect && (_this.state.monthContainer || _this.props.showTimeSelectOnly)) return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$Time, $e5a100bdab37c2de$var$_assign({}, Calendar.defaultProps, _this.props, {
                onChange: _this.props.onTimeChange,
                format: _this.props.timeFormat,
                intervals: _this.props.timeIntervals,
                monthRef: _this.state.monthContainer
            }));
            return;
        };
        _this.renderInputTimeSection = function() {
            var _a, _b;
            if (!_this.props.showTimeInput) return;
            // Handle selectsRange mode - render two time inputs
            if (_this.props.selectsRange) {
                var _c = _this.props, startDate = _c.startDate, endDate = _c.endDate;
                var startTime = startDate ? new Date(startDate) : undefined;
                var startTimeValid = startTime && $e5a100bdab37c2de$var$isValid(startTime) && Boolean(startDate);
                var startTimeString = startTimeValid ? "".concat($e5a100bdab37c2de$var$addZero(startTime.getHours()), ":").concat($e5a100bdab37c2de$var$addZero(startTime.getMinutes())) : "";
                var endTime = endDate ? new Date(endDate) : undefined;
                var endTimeValid = endTime && $e5a100bdab37c2de$var$isValid(endTime) && Boolean(endDate);
                var endTimeString = endTimeValid ? "".concat($e5a100bdab37c2de$var$addZero(endTime.getHours()), ":").concat($e5a100bdab37c2de$var$addZero(endTime.getMinutes())) : "";
                return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$InputTime, $e5a100bdab37c2de$var$_assign({}, Calendar.defaultProps, _this.props, {
                    date: startTime,
                    timeString: startTimeString,
                    onChange: function(time) {
                        var _a, _b;
                        (_b = (_a = _this.props).onTimeChange) === null || _b === void 0 || _b.call(_a, time, "start");
                    },
                    timeInputLabel: ((_a = _this.props.timeInputLabel) !== null && _a !== void 0 ? _a : "Time") + " (Start)"
                })), (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$InputTime, $e5a100bdab37c2de$var$_assign({}, Calendar.defaultProps, _this.props, {
                    date: endTime,
                    timeString: endTimeString,
                    onChange: function(time) {
                        var _a, _b;
                        (_b = (_a = _this.props).onTimeChange) === null || _b === void 0 || _b.call(_a, time, "end");
                    },
                    timeInputLabel: ((_b = _this.props.timeInputLabel) !== null && _b !== void 0 ? _b : "Time") + " (End)"
                })));
            }
            // Single date mode (original behavior)
            var time = _this.props.selected ? new Date(_this.props.selected) : undefined;
            var timeValid = time && $e5a100bdab37c2de$var$isValid(time) && Boolean(_this.props.selected);
            var timeString = timeValid ? "".concat($e5a100bdab37c2de$var$addZero(time.getHours()), ":").concat($e5a100bdab37c2de$var$addZero(time.getMinutes())) : "";
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$InputTime, $e5a100bdab37c2de$var$_assign({}, Calendar.defaultProps, _this.props, {
                date: time,
                timeString: timeString,
                onChange: function(time) {
                    var _a, _b;
                    (_b = (_a = _this.props).onTimeChange) === null || _b === void 0 || _b.call(_a, time);
                }
            }));
        };
        _this.renderAriaLiveRegion = function() {
            var _a;
            // Don't render aria-live message if date is invalid
            if (!$e5a100bdab37c2de$var$isValid(_this.state.date)) return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            });
            var _b = $e5a100bdab37c2de$var$getYearsPeriod(_this.state.date, (_a = _this.props.yearItemNumber) !== null && _a !== void 0 ? _a : Calendar.defaultProps.yearItemNumber), startPeriod = _b.startPeriod, endPeriod = _b.endPeriod;
            var ariaLiveMessage;
            if (_this.props.showYearPicker) ariaLiveMessage = "".concat(startPeriod, " - ").concat(endPeriod);
            else if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker) ariaLiveMessage = (0, $e570a7bac6dc48a8$exports.getYear)(_this.state.date);
            else ariaLiveMessage = "".concat($e5a100bdab37c2de$var$getMonthInLocale((0, $e570a7bac6dc48a8$exports.getMonth)(_this.state.date), _this.props.locale), " ").concat((0, $e570a7bac6dc48a8$exports.getYear)(_this.state.date));
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            }, _this.state.isRenderAriaLiveMessage && ariaLiveMessage);
        };
        _this.renderChildren = function() {
            if (_this.props.children) return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                className: "react-datepicker__children-container"
            }, _this.props.children);
            return;
        };
        _this.containerRef = (0, $7UyaH.createRef)();
        _this.state = {
            date: _this.getDateInView(),
            selectingDate: undefined,
            monthContainer: undefined,
            isRenderAriaLiveMessage: false
        };
        return _this;
    }
    Object.defineProperty(Calendar, "defaultProps", {
        get: function() {
            return {
                monthsShown: 1,
                forceShowMonthNavigation: false,
                outsideClickIgnoreClass: $e5a100bdab37c2de$var$OUTSIDE_CLICK_IGNORE_CLASS,
                timeCaption: "Time",
                previousYearButtonLabel: "Previous Year",
                nextYearButtonLabel: "Next Year",
                previousMonthButtonLabel: "Previous Month",
                nextMonthButtonLabel: "Next Month",
                yearItemNumber: $e5a100bdab37c2de$var$DEFAULT_YEAR_ITEM_NUMBER,
                monthHeaderPosition: "top"
            };
        },
        enumerable: false,
        configurable: true
    });
    Calendar.prototype.componentDidMount = function() {
        var _this = this;
        // monthContainer height is needed in time component
        // to determine the height for the ul in the time component
        // setState here so height is given after final component
        // layout is rendered
        if (this.props.showTimeSelect) this.assignMonthContainer = function() {
            _this.setState({
                monthContainer: _this.monthContainer
            });
        }();
    };
    Calendar.prototype.componentDidUpdate = function(prevProps) {
        var _this = this;
        if (this.props.preSelection && $e5a100bdab37c2de$var$isValid(this.props.preSelection) && (!$e5a100bdab37c2de$var$isSameDay(this.props.preSelection, prevProps.preSelection) || this.props.monthSelectedIn !== prevProps.monthSelectedIn)) {
            var hasMonthChanged_1 = !$e5a100bdab37c2de$var$isSameMonth(this.state.date, this.props.preSelection);
            this.setState({
                date: this.props.preSelection
            }, function() {
                return hasMonthChanged_1 && _this.handleCustomMonthChange(_this.state.date);
            });
        } else if (this.props.openToDate && !$e5a100bdab37c2de$var$isSameDay(this.props.openToDate, prevProps.openToDate)) this.setState({
            date: this.props.openToDate
        });
    };
    Calendar.prototype.render = function() {
        var Container = this.props.container || $e5a100bdab37c2de$export$946daa762919616e;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$ClickOutsideWrapper, {
            onClickOutside: this.handleClickOutside,
            style: {
                display: "contents"
            },
            ignoreClass: this.props.outsideClickIgnoreClass
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            style: {
                display: "contents"
            },
            ref: this.containerRef
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement(Container, {
            className: (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)("react-datepicker", this.props.className, {
                "react-datepicker--time-only": this.props.showTimeSelectOnly
            }),
            showTime: this.props.showTimeSelect || this.props.showTimeInput,
            showTimeSelectOnly: this.props.showTimeSelectOnly,
            inline: this.props.inline
        }, this.renderAriaLiveRegion(), this.props.monthHeaderPosition === "top" && this.renderPreviousButton(), this.props.monthHeaderPosition === "top" && this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren())));
    };
    return Calendar;
}((0, $7UyaH.Component));
/**
 * `CalendarIcon` is a React component that renders an icon for a calendar.
 * The icon can be a string representing a CSS class, a React node, or a default SVG icon.
 *
 * @component
 * @prop  icon - The icon to be displayed. This can be a string representing a CSS class or a React node.
 * @prop  className - An optional string representing additional CSS classes to be applied to the icon.
 * @prop  onClick - An optional function to be called when the icon is clicked.
 *
 * @example
 * // To use a CSS class as the icon
 * <CalendarIcon icon="my-icon-class" onClick={myClickHandler} />
 *
 * @example
 * // To use a React node as the icon
 * <CalendarIcon icon={<MyIconComponent />} onClick={myClickHandler} />
 *
 * @returns  The `CalendarIcon` component.
 */ var $e5a100bdab37c2de$var$CalendarIcon = function(_a) {
    var icon = _a.icon, _b = _a.className, className = _b === void 0 ? "" : _b, onClick = _a.onClick;
    var defaultClass = "react-datepicker__calendar-icon";
    if (typeof icon === "string") return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("i", {
        className: "".concat(defaultClass, " ").concat(icon, " ").concat(className),
        "aria-hidden": "true",
        onClick: onClick
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).isValidElement(icon)) {
        // Because we are checking that typeof icon is string first, we can safely cast icon as React.ReactElement on types level and code level
        var iconElement_1 = icon;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).cloneElement(iconElement_1, {
            className: "".concat(iconElement_1.props.className || "", " ").concat(defaultClass, " ").concat(className),
            onClick: function(event) {
                if (typeof iconElement_1.props.onClick === "function") iconElement_1.props.onClick(event);
                if (typeof onClick === "function") onClick(event);
            }
        });
    }
    // Default SVG Icon
    return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("svg", {
        className: "".concat(defaultClass, " ").concat(className),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512",
        onClick: onClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("path", {
        d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
    }));
};
/**
 * `Portal` is a React component that allows you to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * @class
 * @param {PortalProps} props - The properties that define the `Portal` component.
 * @property {React.ReactNode} props.children - The children to be rendered into the `Portal`.
 * @property {string} props.portalId - The id of the DOM node into which the `Portal` will render.
 * @property {ShadowRoot} [props.portalHost] - The DOM node to host the `Portal`.
 */ var $e5a100bdab37c2de$var$Portal = /** @class */ function(_super) {
    $e5a100bdab37c2de$var$__extends(Portal, _super);
    function Portal(props) {
        var _this = _super.call(this, props) || this;
        _this.portalRoot = null;
        _this.el = document.createElement("div");
        return _this;
    }
    Portal.prototype.componentDidMount = function() {
        this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId);
        if (!this.portalRoot) {
            this.portalRoot = document.createElement("div");
            this.portalRoot.setAttribute("id", this.props.portalId);
            (this.props.portalHost || document.body).appendChild(this.portalRoot);
        }
        this.portalRoot.appendChild(this.el);
    };
    Portal.prototype.componentWillUnmount = function() {
        if (this.portalRoot) this.portalRoot.removeChild(this.el);
    };
    Portal.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($32e03ff3f068d28e$exports))).createPortal(this.props.children, this.el);
    };
    return Portal;
}((0, $7UyaH.Component));
var $e5a100bdab37c2de$var$focusableElementsSelector = "[tabindex], a, button, input, select, textarea";
var $e5a100bdab37c2de$var$focusableFilter = function(node) {
    if (node instanceof HTMLAnchorElement) return node.tabIndex !== -1;
    return !node.disabled && node.tabIndex !== -1;
};
/**
 * `TabLoop` is a React component that manages tabbing behavior for its children.
 *
 * TabLoop prevents the user from tabbing outside of the popper
 * It creates a tabindex loop so that "Tab" on the last element will focus the first element
 * and "Shift Tab" on the first element will focus the last element
 *
 * @component
 * @example
 * <TabLoop enableTabLoop={true}>
 *   <ChildComponent />
 * </TabLoop>
 *
 * @param props - The properties that define the `TabLoop` component.
 * @param props.children - The child components.
 * @param props.enableTabLoop - Whether to enable the tab loop.
 *
 * @returns The `TabLoop` component.
 */ var $e5a100bdab37c2de$var$TabLoop = /** @class */ function(_super) {
    $e5a100bdab37c2de$var$__extends(TabLoop, _super);
    function TabLoop(props) {
        var _this = _super.call(this, props) || this;
        /**
         * `getTabChildren` is a method of the `TabLoop` class that retrieves all tabbable children of the component.
         *
         * This method uses the `tabbable` library to find all tabbable elements within the `TabLoop` component.
         * It then filters out any elements that are not visible.
         *
         * @returns An array of all tabbable and visible children of the `TabLoop` component.
         */ _this.getTabChildren = function() {
            var _a;
            return Array.prototype.slice.call((_a = _this.tabLoopRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll($e5a100bdab37c2de$var$focusableElementsSelector), 1, -1).filter($e5a100bdab37c2de$var$focusableFilter);
        };
        _this.handleFocusStart = function() {
            var tabChildren = _this.getTabChildren();
            tabChildren && tabChildren.length > 1 && tabChildren[tabChildren.length - 1].focus();
        };
        _this.handleFocusEnd = function() {
            var tabChildren = _this.getTabChildren();
            tabChildren && tabChildren.length > 1 && tabChildren[0].focus();
        };
        _this.tabLoopRef = (0, $7UyaH.createRef)();
        return _this;
    }
    TabLoop.prototype.render = function() {
        var _a;
        if (!((_a = this.props.enableTabLoop) !== null && _a !== void 0 ? _a : TabLoop.defaultProps.enableTabLoop)) return this.props.children;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: "react-datepicker__tab-loop",
            ref: this.tabLoopRef
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: "react-datepicker__tab-loop__start",
            tabIndex: 0,
            onFocus: this.handleFocusStart
        }), this.props.children, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: "react-datepicker__tab-loop__end",
            tabIndex: 0,
            onFocus: this.handleFocusEnd
        }));
    };
    TabLoop.defaultProps = {
        enableTabLoop: true
    };
    return TabLoop;
}((0, $7UyaH.Component));
/**
 * `withFloating` is a higher-order component that adds floating behavior to a component.
 *
 * @param Component - The component to enhance.
 *
 * @example
 * const FloatingComponent = withFloating(MyComponent);
 * <FloatingComponent popperModifiers={[]} popperProps={{}} hidePopper={true} />
 *
 * @param popperModifiers - The modifiers to use for the popper.
 * @param popperProps - The props to pass to the popper.
 * @param hidePopper - Whether to hide the popper.
 * @param popperPlacement - The placement of the popper.
 *
 * @returns A new component with floating behavior.
 */ function $e5a100bdab37c2de$var$withFloating(Component) {
    function WithFloating(props) {
        var _a;
        var hidePopper = typeof props.hidePopper === "boolean" ? props.hidePopper : true;
        var arrowRef = (0, $7UyaH.useRef)(null);
        var floatingProps = (0, $0ae2eb679eb5490e$export$4e02a5c1d08bac65)($e5a100bdab37c2de$var$_assign({
            open: !hidePopper,
            whileElementsMounted: (0, $c44eab932bc33f33$export$deee3a793edee05f),
            placement: props.popperPlacement,
            middleware: $e5a100bdab37c2de$var$__spreadArray([
                (0, $3357e590fc26c933$export$8a83211c878a3f1f)({
                    padding: 15
                }),
                (0, $3357e590fc26c933$export$cc800923e997bb8)(10),
                // eslint-disable-next-line react-hooks/refs -- Floating UI requires refs to be passed during render
                (0, $3357e590fc26c933$export$f2120bbfa5450bd2)({
                    element: arrowRef
                })
            ], (_a = props.popperModifiers) !== null && _a !== void 0 ? _a : [], true)
        }, props.popperProps));
        var componentProps = $e5a100bdab37c2de$var$_assign($e5a100bdab37c2de$var$_assign({}, props), {
            hidePopper: hidePopper,
            popperProps: $e5a100bdab37c2de$var$_assign($e5a100bdab37c2de$var$_assign({}, floatingProps), {
                arrowRef: arrowRef
            })
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement(Component, $e5a100bdab37c2de$var$_assign({}, componentProps));
    }
    WithFloating.displayName = "withFloating(".concat(Component.displayName || Component.name || "Component", ")");
    return WithFloating;
}
// Exported for testing purposes
var $e5a100bdab37c2de$var$PopperComponent$1 = function(props) {
    var className = props.className, wrapperClassName = props.wrapperClassName, _a = props.hidePopper, hidePopper = _a === void 0 ? true : _a, popperComponent = props.popperComponent, targetComponent = props.targetComponent, enableTabLoop = props.enableTabLoop, popperOnKeyDown = props.popperOnKeyDown, portalId = props.portalId, portalHost = props.portalHost, popperProps = props.popperProps, showArrow = props.showArrow, popperTargetRef = props.popperTargetRef, monthHeaderPosition = props.monthHeaderPosition;
    // When a custom popperTargetRef is provided, use it as the position reference
    // This allows the popper to be positioned relative to a specific element
    // within the custom input, rather than the wrapper div
    (0, $7UyaH.useEffect)(function() {
        if (popperTargetRef === null || popperTargetRef === void 0 ? void 0 : popperTargetRef.current) popperProps.refs.setPositionReference(popperTargetRef.current);
    }, [
        popperTargetRef,
        popperProps.refs
    ]);
    var popper = undefined;
    if (!hidePopper) {
        var classes = (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)("react-datepicker-popper", !showArrow && "react-datepicker-popper-offset", monthHeaderPosition === "middle" && "react-datepicker-popper--header-middle", monthHeaderPosition === "bottom" && "react-datepicker-popper--header-bottom", className);
        popper = (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$TabLoop, {
            enableTabLoop: enableTabLoop
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            ref: popperProps.refs.setFloating,
            style: popperProps.floatingStyles,
            className: classes,
            "data-placement": popperProps.placement,
            onKeyDown: popperOnKeyDown
        }, popperComponent, showArrow && (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement((0, $0ae2eb679eb5490e$export$33511391554732bc), {
            ref: popperProps.arrowRef,
            context: popperProps.context,
            fill: "currentColor",
            strokeWidth: 1,
            height: 8,
            width: 16,
            style: {
                transform: "translateY(-1px)"
            },
            className: "react-datepicker__triangle"
        })));
    }
    if (props.popperContainer) popper = (0, $7UyaH.createElement)(props.popperContainer, {}, popper);
    if (portalId && !hidePopper) popper = (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$Portal, {
        portalId: portalId,
        portalHost: portalHost
    }, popper);
    var wrapperClasses = (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)("react-datepicker-wrapper", wrapperClassName);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
        ref: popperProps.refs.setReference,
        className: wrapperClasses
    }, targetComponent), popper);
};
var $e5a100bdab37c2de$var$PopperComponent = $e5a100bdab37c2de$var$withFloating($e5a100bdab37c2de$var$PopperComponent$1);
// Compares dates year+month combinations
function $e5a100bdab37c2de$var$hasPreSelectionChanged(date1, date2) {
    if (date1 && date2) return (0, $e570a7bac6dc48a8$exports.getMonth)(date1) !== (0, $e570a7bac6dc48a8$exports.getMonth)(date2) || (0, $e570a7bac6dc48a8$exports.getYear)(date1) !== (0, $e570a7bac6dc48a8$exports.getYear)(date2);
    return date1 !== date2;
}
/**
 * General datepicker component.
 */ var $e5a100bdab37c2de$var$INPUT_ERR_1 = "Date input not valid.";
var $e5a100bdab37c2de$export$5109c6dd95d8fb00 = /** @class */ function(_super) {
    $e5a100bdab37c2de$var$__extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.calendar = null;
        _this.input = null;
        _this.getPreSelection = function() {
            var timeZone = _this.props.timeZone;
            var baseDate = _this.props.openToDate ? _this.props.openToDate : _this.props.selectsEnd && _this.props.startDate ? _this.props.startDate : _this.props.selectsStart && _this.props.endDate ? _this.props.endDate : $e5a100bdab37c2de$var$newDate();
            // Convert to the specified timezone for display
            return timeZone ? $e5a100bdab37c2de$var$toZonedTime(baseDate, timeZone) : baseDate;
        };
        // Convert the date from string format to standard Date format
        // Uses parseDate with ISO format to parse as local time, preventing
        // dates from shifting in timezones west of UTC. See issue #6105.
        _this.modifyHolidays = function() {
            var _a;
            return (_a = _this.props.holidays) === null || _a === void 0 ? void 0 : _a.reduce(function(accumulator, holiday) {
                var date = $e5a100bdab37c2de$var$parseDate(holiday.date, "yyyy-MM-dd", undefined, false);
                if (!date) return accumulator;
                return $e5a100bdab37c2de$var$__spreadArray($e5a100bdab37c2de$var$__spreadArray([], accumulator, true), [
                    $e5a100bdab37c2de$var$_assign($e5a100bdab37c2de$var$_assign({}, holiday), {
                        date: date
                    })
                ], false);
            }, []);
        };
        _this.calcInitialState = function() {
            var timeZone = _this.props.timeZone;
            var defaultPreSelection = _this.getPreSelection();
            var minDate = $e5a100bdab37c2de$var$getEffectiveMinDate(_this.props);
            var maxDate = $e5a100bdab37c2de$var$getEffectiveMaxDate(_this.props);
            var boundedPreSelection = minDate && (0, $e570a7bac6dc48a8$exports.isBefore)(defaultPreSelection, $e5a100bdab37c2de$var$getStartOfDay(minDate)) ? minDate : maxDate && (0, $e570a7bac6dc48a8$exports.isAfter)(defaultPreSelection, $e5a100bdab37c2de$var$getEndOfDay(maxDate)) ? maxDate : defaultPreSelection;
            // Convert selected/startDate to zoned time for display if timezone is specified
            var initialPreSelection = _this.props.selectsRange ? _this.props.startDate : _this.props.selected;
            if (initialPreSelection && timeZone) initialPreSelection = $e5a100bdab37c2de$var$toZonedTime(initialPreSelection, timeZone);
            return {
                open: _this.props.startOpen || false,
                preventFocus: false,
                inputValue: null,
                preSelection: initialPreSelection !== null && initialPreSelection !== void 0 ? initialPreSelection : boundedPreSelection,
                // transforming highlighted days (perhaps nested array)
                // to flat Map for faster access in day.jsx
                highlightDates: $e5a100bdab37c2de$var$getHighLightDaysMap(_this.props.highlightDates),
                focused: false,
                // used to focus day in inline version after month has changed, but not on
                // initial render
                shouldFocusDayInline: false,
                isRenderAriaLiveMessage: false,
                wasHidden: false
            };
        };
        _this.getInputValue = function() {
            var _a;
            var _b = _this.props, locale = _b.locale, startDate = _b.startDate, endDate = _b.endDate, rangeSeparator = _b.rangeSeparator, selected = _b.selected, selectedDates = _b.selectedDates, selectsMultiple = _b.selectsMultiple, selectsRange = _b.selectsRange, formatMultipleDates = _b.formatMultipleDates, value = _b.value;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var inputValue = _this.state.inputValue;
            if (typeof value === "string") return value;
            else if (typeof inputValue === "string") return inputValue;
            else if (selectsRange) return $e5a100bdab37c2de$var$safeDateRangeFormat(startDate, endDate, {
                dateFormat: dateFormat,
                locale: locale,
                rangeSeparator: rangeSeparator
            });
            else if (selectsMultiple) {
                if (formatMultipleDates) {
                    var formatDateFn = function(date) {
                        return $e5a100bdab37c2de$var$safeDateFormat(date, {
                            dateFormat: dateFormat,
                            locale: locale
                        });
                    };
                    return formatMultipleDates(selectedDates !== null && selectedDates !== void 0 ? selectedDates : [], formatDateFn);
                }
                return $e5a100bdab37c2de$var$safeMultipleDatesFormat(selectedDates !== null && selectedDates !== void 0 ? selectedDates : [], {
                    dateFormat: dateFormat,
                    locale: locale
                });
            }
            return $e5a100bdab37c2de$var$safeDateFormat(selected, {
                dateFormat: dateFormat,
                locale: locale
            });
        };
        _this.resetHiddenStatus = function() {
            _this.setState($e5a100bdab37c2de$var$_assign($e5a100bdab37c2de$var$_assign({}, _this.state), {
                wasHidden: false
            }));
        };
        _this.setHiddenStatus = function() {
            _this.setState($e5a100bdab37c2de$var$_assign($e5a100bdab37c2de$var$_assign({}, _this.state), {
                wasHidden: true
            }));
        };
        _this.setHiddenStateOnVisibilityHidden = function() {
            if (document.visibilityState !== "hidden") return;
            _this.setHiddenStatus();
        };
        _this.clearPreventFocusTimeout = function() {
            if (_this.preventFocusTimeout) clearTimeout(_this.preventFocusTimeout);
        };
        _this.setFocus = function() {
            var _a, _b;
            (_b = (_a = _this.input) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a, {
                preventScroll: true
            });
        };
        _this.setBlur = function() {
            var _a, _b;
            (_b = (_a = _this.input) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 || _b.call(_a);
            _this.cancelFocusInput();
        };
        _this.deferBlur = function() {
            requestAnimationFrame(function() {
                _this.setBlur();
            });
        };
        _this.setOpen = function(open, skipSetBlur) {
            if (skipSetBlur === void 0) skipSetBlur = false;
            _this.setState({
                open: open,
                preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
                lastPreSelectChange: $e5a100bdab37c2de$var$PRESELECT_CHANGE_VIA_NAVIGATE
            }, function() {
                if (!open) _this.setState(function(prev) {
                    return {
                        focused: skipSetBlur ? prev.focused : false
                    };
                }, function() {
                    !skipSetBlur && _this.deferBlur();
                    _this.setState({
                        inputValue: null
                    });
                });
            });
        };
        _this.inputOk = function() {
            return (0, $e570a7bac6dc48a8$exports.isDate)(_this.state.preSelection);
        };
        _this.isCalendarOpen = function() {
            return _this.props.open === undefined ? _this.state.open && !_this.props.disabled && !_this.props.readOnly : _this.props.open;
        };
        _this.handleFocus = function(event) {
            var _a, _b;
            var isAutoReFocus = _this.state.wasHidden;
            var isOpenAllowed = isAutoReFocus ? _this.state.open : true;
            if (isAutoReFocus) _this.resetHiddenStatus();
            if (!_this.state.preventFocus) {
                (_b = (_a = _this.props).onFocus) === null || _b === void 0 || _b.call(_a, event);
                if (isOpenAllowed && !_this.props.preventOpenOnFocus && !_this.props.readOnly) _this.setOpen(true);
            }
            _this.setState({
                focused: true
            });
        };
        _this.sendFocusBackToInput = function() {
            // Clear previous timeout if it exists
            if (_this.preventFocusTimeout) _this.clearPreventFocusTimeout();
            // close the popper and refocus the input
            // stop the input from auto opening onFocus
            // setFocus to the input
            _this.setState({
                preventFocus: true
            }, function() {
                _this.preventFocusTimeout = setTimeout(function() {
                    _this.setFocus();
                    _this.setState({
                        preventFocus: false
                    });
                });
            });
        };
        _this.cancelFocusInput = function() {
            clearTimeout(_this.inputFocusTimeout);
            _this.inputFocusTimeout = undefined;
        };
        _this.deferFocusInput = function() {
            _this.cancelFocusInput();
            _this.inputFocusTimeout = setTimeout(function() {
                return _this.setFocus();
            }, 1);
        };
        _this.handleDropdownFocus = function() {
            _this.cancelFocusInput();
        };
        _this.resetInputValue = function() {
            _this.setState($e5a100bdab37c2de$var$_assign($e5a100bdab37c2de$var$_assign({}, _this.state), {
                inputValue: null
            }));
        };
        _this.handleBlur = function(event) {
            var _a, _b;
            if (!_this.state.open || _this.props.withPortal || _this.props.showTimeInput) (_b = (_a = _this.props).onBlur) === null || _b === void 0 || _b.call(_a, event);
            // If user cleared the input via a mask library (inputValue has no date-like
            // characters), clear the selection on blur (fixes issue #5814 with mask inputs)
            var inputValue = _this.state.inputValue;
            if (typeof inputValue === "string" && inputValue.length > 0) {
                // Check if input looks like a cleared mask (no alphanumeric characters)
                // This distinguishes between:
                // - "__/__/____" (cleared mask) → should clear selection
                // - "2025-02-45" (invalid date) → should keep previous selection
                var hasDateCharacters = /[a-zA-Z0-9]/.test(inputValue);
                if (!hasDateCharacters && _this.props.selected) _this.setSelected(null, undefined, true);
            }
            _this.resetInputValue();
            if (_this.state.open && _this.props.open === false) _this.setOpen(false);
            _this.setState({
                focused: false
            });
        };
        _this.handleCalendarClickOutside = function(event) {
            var _a, _b;
            // Call user's onClickOutside first, allowing them to call preventDefault()
            (_b = (_a = _this.props).onClickOutside) === null || _b === void 0 || _b.call(_a, event);
            // Only close if not prevented and not inline
            if (!_this.props.inline && !event.defaultPrevented) _this.setOpen(false);
            if (_this.props.withPortal) event.preventDefault();
        };
        // handleChange is called when user types in the textbox
        _this.handleChange = function() {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var allArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)allArgs[_i] = arguments[_i];
            var event = allArgs[0];
            if (_this.props.onChangeRaw) {
                _this.props.onChangeRaw.apply(_this, allArgs);
                if (!event || typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) return;
            }
            _this.setState({
                inputValue: (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLInputElement ? event.target.value : null,
                lastPreSelectChange: $e5a100bdab37c2de$var$PRESELECT_CHANGE_VIA_INPUT
            });
            var _j = _this.props, selectsRange = _j.selectsRange, startDate = _j.startDate, endDate = _j.endDate;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var strictParsing = (_b = _this.props.strictParsing) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.strictParsing;
            var value = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLInputElement ? event.target.value : "";
            if (selectsRange) {
                var rangeSeparator = _this.props.rangeSeparator;
                var trimmedRangeSeparator = rangeSeparator.trim();
                var _k = value.split(dateFormat.includes(trimmedRangeSeparator) ? rangeSeparator : trimmedRangeSeparator, 2).map(function(val) {
                    return val.trim();
                }), valueStart = _k[0], valueEnd = _k[1];
                var startDateNew = $e5a100bdab37c2de$var$parseDate(valueStart !== null && valueStart !== void 0 ? valueStart : "", dateFormat, _this.props.locale, strictParsing);
                var endDateNew = startDateNew ? $e5a100bdab37c2de$var$parseDate(valueEnd !== null && valueEnd !== void 0 ? valueEnd : "", dateFormat, _this.props.locale, strictParsing) : null;
                var startChanged = ((_c = $e5a100bdab37c2de$var$safeToDate(startDate)) === null || _c === void 0 ? void 0 : _c.getTime()) !== (startDateNew === null || startDateNew === void 0 ? void 0 : startDateNew.getTime());
                var endChanged = ((_d = $e5a100bdab37c2de$var$safeToDate(endDate)) === null || _d === void 0 ? void 0 : _d.getTime()) !== (endDateNew === null || endDateNew === void 0 ? void 0 : endDateNew.getTime());
                if (!startChanged && !endChanged) return;
                if (startDateNew && $e5a100bdab37c2de$var$isDayDisabled(startDateNew, _this.props)) return;
                if (endDateNew && $e5a100bdab37c2de$var$isDayDisabled(endDateNew, _this.props)) return;
                // Update preSelection to keep calendar viewport consistent when reopening
                // Use startDate for preSelection to match calcInitialState behavior
                if (startDateNew) _this.setState({
                    preSelection: startDateNew
                });
                (_f = (_e = _this.props).onChange) === null || _f === void 0 || _f.call(_e, [
                    startDateNew,
                    endDateNew
                ], event);
            } else {
                // not selectsRange
                var date = $e5a100bdab37c2de$var$parseDate(value, dateFormat, _this.props.locale, strictParsing, (_g = _this.props.selected) !== null && _g !== void 0 ? _g : undefined);
                // Update selection if either (1) date was successfully parsed, or (2) input field is empty
                if (date || !value) _this.setSelected(date, event, true);
                else if (!_this.props.inline) {
                    // If full date parsing failed but we have partial input,
                    // try to extract date info for calendar navigation
                    var navDate = $e5a100bdab37c2de$var$parseDateForNavigation(value, (_h = _this.state.preSelection) !== null && _h !== void 0 ? _h : undefined);
                    // Only update preSelection if navDate is valid and within min/max bounds
                    if (navDate && (!_this.props.minDate || !(0, $e570a7bac6dc48a8$exports.isBefore)(navDate, _this.props.minDate)) && (!_this.props.maxDate || !(0, $e570a7bac6dc48a8$exports.isAfter)(navDate, _this.props.maxDate))) _this.setState({
                        preSelection: navDate
                    });
                }
            }
        };
        _this.handleSelect = function(date, event, monthSelectedIn) {
            var _a;
            if (_this.props.readOnly) return;
            var _b = _this.props, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate, locale = _b.locale, swapRange = _b.swapRange;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var isDateSelectionComplete = !selectsRange || startDate && !endDate && (swapRange || !$e5a100bdab37c2de$var$isDateBefore(date, startDate));
            if (_this.props.shouldCloseOnSelect && !_this.props.showTimeSelect && isDateSelectionComplete) // Preventing onFocus event to fix issue
            // https://github.com/Hacker0x01/react-datepicker/issues/628
            _this.sendFocusBackToInput();
            if (_this.props.onChangeRaw) {
                var formattedDate = $e5a100bdab37c2de$var$safeDateFormat(date, {
                    dateFormat: dateFormat,
                    locale: locale
                });
                _this.props.onChangeRaw(event, {
                    date: date,
                    formattedDate: formattedDate
                });
            }
            _this.setSelected(date, event, false, monthSelectedIn);
            if (_this.props.showDateSelect) _this.setState({
                isRenderAriaLiveMessage: true
            });
            if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) _this.setPreSelection(date);
            else if (isDateSelectionComplete) _this.setOpen(false);
        };
        // setSelected is called either from handleChange (user typed date into textbox and it was parsed) or handleSelect (user selected date from calendar using mouse or keyboard)
        _this.setSelected = function(date, event, keepInput, monthSelectedIn) {
            var _a, _b;
            var timeZone = _this.props.timeZone;
            // If timezone is specified, convert the selected date from zoned time to UTC
            // This ensures the onChange callback receives a proper UTC Date object
            var changedDate = date;
            if (changedDate && timeZone) changedDate = $e5a100bdab37c2de$var$fromZonedTime(changedDate, timeZone);
            // Early return if selected year/month/day is disabled
            if (_this.props.showYearPicker) {
                if (changedDate !== null && $e5a100bdab37c2de$var$isYearDisabled((0, $e570a7bac6dc48a8$exports.getYear)(changedDate), _this.props)) return;
            } else if (_this.props.showMonthYearPicker) {
                if (changedDate !== null && $e5a100bdab37c2de$var$isMonthDisabled(changedDate, _this.props)) return;
            } else {
                if (changedDate !== null && $e5a100bdab37c2de$var$isDayDisabled(changedDate, _this.props)) return;
            }
            var _c = _this.props, onChange = _c.onChange, selectsRange = _c.selectsRange, startDate = _c.startDate, endDate = _c.endDate, selectsMultiple = _c.selectsMultiple, selectedDates = _c.selectedDates, minTime = _c.minTime, swapRange = _c.swapRange;
            if (!$e5a100bdab37c2de$var$isEqual(_this.props.selected, changedDate) || _this.props.allowSameDay || selectsRange || selectsMultiple) {
                if (changedDate !== null) {
                    // Preserve previously selected time if only date is currently being changed
                    if (_this.props.selected && (!keepInput || !_this.props.showTimeSelect && !_this.props.showTimeSelectOnly && !_this.props.showTimeInput)) changedDate = $e5a100bdab37c2de$var$setTime(changedDate, {
                        hour: (0, $e570a7bac6dc48a8$exports.getHours)(_this.props.selected),
                        minute: (0, $e570a7bac6dc48a8$exports.getMinutes)(_this.props.selected),
                        second: (0, $e570a7bac6dc48a8$exports.getSeconds)(_this.props.selected)
                    });
                    // If minTime is present then set the time to minTime
                    if (!keepInput && (_this.props.showTimeSelect || _this.props.showTimeSelectOnly)) {
                        if (minTime) changedDate = $e5a100bdab37c2de$var$setTime(changedDate, {
                            hour: minTime.getHours(),
                            minute: minTime.getMinutes(),
                            second: minTime.getSeconds()
                        });
                    }
                    if (!_this.props.inline) _this.setState({
                        preSelection: changedDate
                    });
                    if (!_this.props.focusSelectedMonth) _this.setState({
                        monthSelectedIn: monthSelectedIn
                    });
                }
                if (selectsRange) {
                    var onChangeRange = onChange;
                    var noRanges = !startDate && !endDate;
                    var hasStartRange = startDate && !endDate;
                    var hasOnlyEndRange = !startDate && !!endDate;
                    var isRangeFilled = startDate && endDate;
                    if (noRanges) onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                        changedDate,
                        null
                    ], event);
                    else if (hasStartRange) {
                        if (changedDate === null) onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            null,
                            null
                        ], event);
                        else if ($e5a100bdab37c2de$var$isDateBefore(changedDate, startDate)) {
                            if (swapRange) onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                                changedDate,
                                startDate
                            ], event);
                            else onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                                changedDate,
                                null
                            ], event);
                        } else onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            startDate,
                            changedDate
                        ], event);
                    } else if (hasOnlyEndRange) {
                        if (changedDate && $e5a100bdab37c2de$var$isDateBefore(changedDate, endDate)) onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            changedDate,
                            endDate
                        ], event);
                        else onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            changedDate,
                            null
                        ], event);
                    }
                    if (isRangeFilled) onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                        changedDate,
                        null
                    ], event);
                } else if (selectsMultiple) {
                    var onChangeMultiple = onChange;
                    if (changedDate !== null) {
                        if (!(selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length)) onChangeMultiple === null || onChangeMultiple === void 0 || onChangeMultiple([
                            changedDate
                        ], event);
                        else {
                            var isChangedDateAlreadySelected = selectedDates.some(function(selectedDate) {
                                return $e5a100bdab37c2de$var$isSameDay(selectedDate, changedDate);
                            });
                            if (isChangedDateAlreadySelected) {
                                var nextDates = selectedDates.filter(function(selectedDate) {
                                    return !$e5a100bdab37c2de$var$isSameDay(selectedDate, changedDate);
                                });
                                onChangeMultiple === null || onChangeMultiple === void 0 || onChangeMultiple(nextDates, event);
                            } else onChangeMultiple === null || onChangeMultiple === void 0 || onChangeMultiple($e5a100bdab37c2de$var$__spreadArray($e5a100bdab37c2de$var$__spreadArray([], selectedDates, true), [
                                changedDate
                            ], false), event);
                        }
                    }
                } else onChange === null || onChange === void 0 || onChange(changedDate, event);
            }
            if (!keepInput) {
                (_b = (_a = _this.props).onSelect) === null || _b === void 0 || _b.call(_a, changedDate, event);
                _this.setState({
                    inputValue: null
                });
            }
        };
        // When checking preSelection via min/maxDate, times need to be manipulated via getStartOfDay/getEndOfDay
        _this.setPreSelection = function(date) {
            if (_this.props.readOnly) return;
            var hasMinDate = (0, $e570a7bac6dc48a8$exports.isDate)(_this.props.minDate);
            var hasMaxDate = (0, $e570a7bac6dc48a8$exports.isDate)(_this.props.maxDate);
            var isValidDateSelection = true;
            if (date) {
                var dateStartOfDay = $e5a100bdab37c2de$var$getStartOfDay(date);
                if (hasMinDate && hasMaxDate) // isDayInRange uses getStartOfDay internally, so not necessary to manipulate times here
                isValidDateSelection = $e5a100bdab37c2de$var$isDayInRange(date, _this.props.minDate, _this.props.maxDate);
                else if (hasMinDate) {
                    var minDateStartOfDay = $e5a100bdab37c2de$var$getStartOfDay(_this.props.minDate);
                    isValidDateSelection = (0, $e570a7bac6dc48a8$exports.isAfter)(date, minDateStartOfDay) || $e5a100bdab37c2de$var$isEqual(dateStartOfDay, minDateStartOfDay);
                } else if (hasMaxDate) {
                    var maxDateEndOfDay = $e5a100bdab37c2de$var$getEndOfDay(_this.props.maxDate);
                    isValidDateSelection = (0, $e570a7bac6dc48a8$exports.isBefore)(date, maxDateEndOfDay) || $e5a100bdab37c2de$var$isEqual(dateStartOfDay, maxDateEndOfDay);
                }
            }
            if (isValidDateSelection) _this.setState({
                preSelection: date
            });
        };
        _this.toggleCalendar = function() {
            _this.setOpen(!_this.state.open);
        };
        _this.handleTimeChange = function(time, modifyDateType) {
            var _a, _b;
            if (_this.props.selectsMultiple) return;
            var _c = _this.props, selectsRange = _c.selectsRange, startDate = _c.startDate, endDate = _c.endDate, onChange = _c.onChange, timeZone = _c.timeZone;
            if (selectsRange) {
                var onChangeRange = onChange;
                // In range mode, apply time to the appropriate date
                // If modifyDateType is specified, use that to determine which date to modify
                // Otherwise, use the legacy behavior:
                // - If we have a startDate but no endDate, apply time to startDate
                // - If we have both, apply time to endDate
                if (modifyDateType === "start") // Explicitly modify start date
                {
                    if (startDate) {
                        var changedStartDate = $e5a100bdab37c2de$var$setTime(startDate, {
                            hour: (0, $e570a7bac6dc48a8$exports.getHours)(time),
                            minute: (0, $e570a7bac6dc48a8$exports.getMinutes)(time)
                        });
                        _this.setState({
                            preSelection: changedStartDate
                        });
                        // Convert from zoned time to UTC if timezone is specified
                        if (timeZone) changedStartDate = $e5a100bdab37c2de$var$fromZonedTime(changedStartDate, timeZone);
                        onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            changedStartDate,
                            endDate ? timeZone ? $e5a100bdab37c2de$var$fromZonedTime(endDate, timeZone) : endDate : null
                        ], undefined);
                    }
                } else if (modifyDateType === "end") // Explicitly modify end date
                {
                    if (endDate) {
                        var changedEndDate = $e5a100bdab37c2de$var$setTime(endDate, {
                            hour: (0, $e570a7bac6dc48a8$exports.getHours)(time),
                            minute: (0, $e570a7bac6dc48a8$exports.getMinutes)(time)
                        });
                        _this.setState({
                            preSelection: changedEndDate
                        });
                        // Convert from zoned time to UTC if timezone is specified
                        if (timeZone) changedEndDate = $e5a100bdab37c2de$var$fromZonedTime(changedEndDate, timeZone);
                        onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            startDate ? timeZone ? $e5a100bdab37c2de$var$fromZonedTime(startDate, timeZone) : startDate : null,
                            changedEndDate
                        ], undefined);
                    }
                } else {
                    // Legacy behavior for showTimeSelect (single time picker)
                    var hasStartRange = startDate && !endDate;
                    if (hasStartRange) {
                        // Apply time to startDate
                        var changedStartDate = $e5a100bdab37c2de$var$setTime(startDate, {
                            hour: (0, $e570a7bac6dc48a8$exports.getHours)(time),
                            minute: (0, $e570a7bac6dc48a8$exports.getMinutes)(time)
                        });
                        _this.setState({
                            preSelection: changedStartDate
                        });
                        // Convert from zoned time to UTC if timezone is specified
                        if (timeZone) changedStartDate = $e5a100bdab37c2de$var$fromZonedTime(changedStartDate, timeZone);
                        onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            changedStartDate,
                            null
                        ], undefined);
                    } else if (startDate && endDate) {
                        // Apply time to endDate
                        var changedEndDate = $e5a100bdab37c2de$var$setTime(endDate, {
                            hour: (0, $e570a7bac6dc48a8$exports.getHours)(time),
                            minute: (0, $e570a7bac6dc48a8$exports.getMinutes)(time)
                        });
                        _this.setState({
                            preSelection: changedEndDate
                        });
                        // Convert from zoned time to UTC if timezone is specified
                        if (timeZone) changedEndDate = $e5a100bdab37c2de$var$fromZonedTime(changedEndDate, timeZone);
                        onChangeRange === null || onChangeRange === void 0 || onChangeRange([
                            timeZone ? $e5a100bdab37c2de$var$fromZonedTime(startDate, timeZone) : startDate,
                            changedEndDate
                        ], undefined);
                    } else {
                        // No dates selected yet, just update preSelection
                        var changedDate = $e5a100bdab37c2de$var$setTime(_this.getPreSelection(), {
                            hour: (0, $e570a7bac6dc48a8$exports.getHours)(time),
                            minute: (0, $e570a7bac6dc48a8$exports.getMinutes)(time)
                        });
                        _this.setState({
                            preSelection: changedDate
                        });
                    }
                }
            } else {
                // Single date mode (original behavior)
                var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
                var changedDate = _this.props.selected ? time : $e5a100bdab37c2de$var$setTime(selected, {
                    hour: (0, $e570a7bac6dc48a8$exports.getHours)(time),
                    minute: (0, $e570a7bac6dc48a8$exports.getMinutes)(time)
                });
                _this.setState({
                    preSelection: changedDate
                });
                // Convert from zoned time to UTC if timezone is specified
                if (changedDate && timeZone) changedDate = $e5a100bdab37c2de$var$fromZonedTime(changedDate, timeZone);
                (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, changedDate);
            }
            if (_this.props.shouldCloseOnSelect && !_this.props.showTimeInput) {
                _this.sendFocusBackToInput();
                _this.setOpen(false);
            }
            if (_this.props.showTimeInput) _this.setOpen(true);
            if (_this.props.showTimeSelectOnly || _this.props.showTimeSelect) _this.setState({
                isRenderAriaLiveMessage: true
            });
            _this.setState({
                inputValue: null
            });
        };
        _this.onInputClick = function() {
            var _a, _b;
            if (!_this.props.disabled && !_this.props.readOnly) _this.setOpen(true);
            (_b = (_a = _this.props).onInputClick) === null || _b === void 0 || _b.call(_a);
        };
        _this.handleTimeOnlyArrowKey = function(eventKey) {
            var _a, _b, _c, _d;
            var currentTime = $e5a100bdab37c2de$var$safeToDate(_this.props.selected) || _this.state.preSelection || $e5a100bdab37c2de$var$newDate();
            var timeIntervals = (_a = _this.props.timeIntervals) !== null && _a !== void 0 ? _a : 30;
            var dateFormat = (_b = _this.props.dateFormat) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.dateFormat;
            var formatStr = Array.isArray(dateFormat) ? dateFormat[0] : dateFormat;
            var baseDate = $e5a100bdab37c2de$var$getStartOfDay(currentTime);
            var currentMinutes = (0, $e570a7bac6dc48a8$exports.getHours)(currentTime) * 60 + (0, $e570a7bac6dc48a8$exports.getMinutes)(currentTime);
            var maxMinutes = 1440 - timeIntervals; // Cap at last valid interval of the day
            var newTime;
            if (eventKey === $e5a100bdab37c2de$var$KeyType.ArrowUp) {
                var newMinutes = Math.max(0, currentMinutes - timeIntervals);
                newTime = (0, $e570a7bac6dc48a8$exports.addMinutes)(baseDate, newMinutes);
            } else {
                var newMinutes = Math.min(maxMinutes, currentMinutes + timeIntervals);
                newTime = (0, $e570a7bac6dc48a8$exports.addMinutes)(baseDate, newMinutes);
            }
            var formattedTime = $e5a100bdab37c2de$var$formatDate(newTime, formatStr || DatePicker.defaultProps.dateFormat, _this.props.locale);
            _this.setState({
                preSelection: newTime,
                inputValue: formattedTime
            });
            if (_this.props.selectsRange || _this.props.selectsMultiple) return;
            var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
            var changedDate = _this.props.selected ? newTime : $e5a100bdab37c2de$var$setTime(selected, {
                hour: (0, $e570a7bac6dc48a8$exports.getHours)(newTime),
                minute: (0, $e570a7bac6dc48a8$exports.getMinutes)(newTime)
            });
            (_d = (_c = _this.props).onChange) === null || _d === void 0 || _d.call(_c, changedDate);
            if (_this.props.showTimeSelectOnly || _this.props.showTimeSelect) _this.setState({
                isRenderAriaLiveMessage: true
            });
            requestAnimationFrame(function() {
                _this.scrollToTimeOption(newTime);
            });
        };
        _this.handleTimeOnlyEnterKey = function(event) {
            var _a, _b, _c, _d;
            var inputElement = event.target;
            var inputValue = inputElement.value;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var timeFormat = _this.props.timeFormat || "p";
            var defaultTime = _this.state.preSelection || $e5a100bdab37c2de$var$safeToDate(_this.props.selected) || $e5a100bdab37c2de$var$newDate();
            var parsedDate = $e5a100bdab37c2de$var$parseDate(inputValue, dateFormat, _this.props.locale, (_b = _this.props.strictParsing) !== null && _b !== void 0 ? _b : false, defaultTime);
            var timeToCommit = defaultTime;
            if (parsedDate && $e5a100bdab37c2de$var$isValid(parsedDate)) timeToCommit = parsedDate;
            else {
                var highlightedItem = ((_c = _this.calendar) === null || _c === void 0 ? void 0 : _c.containerRef.current) instanceof Element && _this.calendar.containerRef.current.querySelector(".react-datepicker__time-list-item[tabindex='0']");
                if (highlightedItem instanceof HTMLElement) {
                    var itemText = (_d = highlightedItem.textContent) === null || _d === void 0 ? void 0 : _d.trim();
                    if (itemText) {
                        var itemTime = $e5a100bdab37c2de$var$parseDate(itemText, timeFormat, _this.props.locale, false, defaultTime);
                        if (itemTime && $e5a100bdab37c2de$var$isValid(itemTime)) timeToCommit = itemTime;
                    }
                }
            }
            _this.handleTimeChange(timeToCommit);
            _this.setOpen(false);
            _this.sendFocusBackToInput();
        };
        _this.scrollToTimeOption = function(time) {
            var _a, _b;
            if (!((_a = _this.calendar) === null || _a === void 0 ? void 0 : _a.containerRef.current)) return;
            var container = _this.calendar.containerRef.current;
            var timeListItems = Array.from(container.querySelectorAll(".react-datepicker__time-list-item"));
            var targetItem = null;
            var closestTimeDiff = Infinity;
            var timeFormat = _this.props.timeFormat || "p";
            for(var _i = 0, timeListItems_1 = timeListItems; _i < timeListItems_1.length; _i++){
                var item = timeListItems_1[_i];
                var itemText = (_b = item.textContent) === null || _b === void 0 ? void 0 : _b.trim();
                if (itemText) {
                    var itemTime = $e5a100bdab37c2de$var$parseDate(itemText, timeFormat, _this.props.locale, false, time);
                    if (itemTime && $e5a100bdab37c2de$var$isValid(itemTime)) {
                        if ($e5a100bdab37c2de$var$isSameMinute(itemTime, time)) {
                            targetItem = item;
                            break;
                        }
                        var timeDiff = Math.abs(itemTime.getTime() - time.getTime());
                        if (timeDiff < closestTimeDiff) {
                            closestTimeDiff = timeDiff;
                            targetItem = item;
                        }
                    }
                }
            }
            if (targetItem) {
                timeListItems.forEach(function(item) {
                    item.setAttribute("tabindex", "-1");
                });
                targetItem.setAttribute("tabindex", "0");
                targetItem.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }
        };
        _this.onInputKeyDown = function(event) {
            var _a, _b, _c, _d, _e, _f;
            (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, event);
            var eventKey = event.key;
            if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
                if (eventKey === $e5a100bdab37c2de$var$KeyType.ArrowDown || eventKey === $e5a100bdab37c2de$var$KeyType.ArrowUp || eventKey === $e5a100bdab37c2de$var$KeyType.Enter) (_c = _this.onInputClick) === null || _c === void 0 || _c.call(_this);
                return;
            }
            if (_this.state.open && _this.props.showTimeSelectOnly) {
                if (eventKey === $e5a100bdab37c2de$var$KeyType.ArrowDown || eventKey === $e5a100bdab37c2de$var$KeyType.ArrowUp) {
                    event.preventDefault();
                    _this.handleTimeOnlyArrowKey(eventKey);
                    return;
                }
                if (eventKey === $e5a100bdab37c2de$var$KeyType.Enter) {
                    event.preventDefault();
                    _this.handleTimeOnlyEnterKey(event);
                    return;
                }
            }
            // if calendar is open, these keys will focus the selected item
            if (_this.state.open) {
                if (eventKey === $e5a100bdab37c2de$var$KeyType.ArrowDown || eventKey === $e5a100bdab37c2de$var$KeyType.ArrowUp) {
                    event.preventDefault();
                    var selectorString = _this.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : _this.props.showWeekPicker && _this.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : _this.props.showFullMonthYearPicker || _this.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]';
                    var selectedItem = ((_d = _this.calendar) === null || _d === void 0 ? void 0 : _d.containerRef.current) instanceof Element && _this.calendar.containerRef.current.querySelector(selectorString);
                    selectedItem instanceof HTMLElement && selectedItem.focus({
                        preventScroll: true
                    });
                    return;
                }
                var copy = $e5a100bdab37c2de$var$newDate(_this.state.preSelection);
                if (eventKey === $e5a100bdab37c2de$var$KeyType.Enter) {
                    event.preventDefault();
                    event.target.blur();
                    if (_this.inputOk() && _this.state.lastPreSelectChange === $e5a100bdab37c2de$var$PRESELECT_CHANGE_VIA_NAVIGATE) {
                        _this.handleSelect(copy, event);
                        !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
                    } else _this.setOpen(false);
                } else if (eventKey === $e5a100bdab37c2de$var$KeyType.Escape) {
                    event.preventDefault();
                    event.target.blur();
                    _this.sendFocusBackToInput();
                    _this.setOpen(false);
                } else if (eventKey === $e5a100bdab37c2de$var$KeyType.Tab) _this.setOpen(false);
                if (!_this.inputOk()) (_f = (_e = _this.props).onInputError) === null || _f === void 0 || _f.call(_e, {
                    code: 1,
                    msg: $e5a100bdab37c2de$var$INPUT_ERR_1
                });
            }
        };
        _this.onPortalKeyDown = function(event) {
            var eventKey = event.key;
            if (eventKey === $e5a100bdab37c2de$var$KeyType.Escape) {
                event.preventDefault();
                _this.setState({
                    preventFocus: true
                }, function() {
                    _this.setOpen(false);
                    setTimeout(function() {
                        _this.setFocus();
                        _this.setState({
                            preventFocus: false
                        });
                    });
                });
            }
        };
        // keyDown events passed down to day.jsx
        _this.onDayKeyDown = function(event) {
            var _a, _b, _c, _d, _e, _f;
            var _g = _this.props, minDate = _g.minDate, maxDate = _g.maxDate, disabledKeyboardNavigation = _g.disabledKeyboardNavigation, showWeekPicker = _g.showWeekPicker, shouldCloseOnSelect = _g.shouldCloseOnSelect, locale = _g.locale, calendarStartDay = _g.calendarStartDay, adjustDateOnChange = _g.adjustDateOnChange, inline = _g.inline;
            (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, event);
            if (disabledKeyboardNavigation) return;
            var eventKey = event.key;
            var isShiftKeyActive = event.shiftKey;
            var copy = $e5a100bdab37c2de$var$newDate(_this.state.preSelection);
            var calculateNewDate = function(eventKey, date) {
                var newCalculatedDate = date;
                switch(eventKey){
                    case $e5a100bdab37c2de$var$KeyType.ArrowRight:
                        newCalculatedDate = showWeekPicker ? (0, $e570a7bac6dc48a8$exports.addWeeks)(date, 1) : (0, $e570a7bac6dc48a8$exports.addDays)(date, 1);
                        break;
                    case $e5a100bdab37c2de$var$KeyType.ArrowLeft:
                        newCalculatedDate = showWeekPicker ? (0, $e570a7bac6dc48a8$exports.subWeeks)(date, 1) : (0, $e570a7bac6dc48a8$exports.subDays)(date, 1);
                        break;
                    case $e5a100bdab37c2de$var$KeyType.ArrowUp:
                        newCalculatedDate = (0, $e570a7bac6dc48a8$exports.subWeeks)(date, 1);
                        break;
                    case $e5a100bdab37c2de$var$KeyType.ArrowDown:
                        newCalculatedDate = (0, $e570a7bac6dc48a8$exports.addWeeks)(date, 1);
                        break;
                    case $e5a100bdab37c2de$var$KeyType.PageUp:
                        newCalculatedDate = isShiftKeyActive ? (0, $e570a7bac6dc48a8$exports.subYears)(date, 1) : (0, $e570a7bac6dc48a8$exports.subMonths)(date, 1);
                        break;
                    case $e5a100bdab37c2de$var$KeyType.PageDown:
                        newCalculatedDate = isShiftKeyActive ? (0, $e570a7bac6dc48a8$exports.addYears)(date, 1) : (0, $e570a7bac6dc48a8$exports.addMonths)(date, 1);
                        break;
                    case $e5a100bdab37c2de$var$KeyType.Home:
                        newCalculatedDate = $e5a100bdab37c2de$var$getStartOfWeek(date, locale, calendarStartDay);
                        break;
                    case $e5a100bdab37c2de$var$KeyType.End:
                        newCalculatedDate = $e5a100bdab37c2de$var$getEndOfWeek(date);
                        break;
                }
                return newCalculatedDate;
            };
            var getNewDate = function(eventKey, date) {
                var MAX_ITERATIONS = 40;
                var eventKeyCopy = eventKey;
                var validDateFound = false;
                var iterations = 0;
                var newSelection = calculateNewDate(eventKey, date);
                while(!validDateFound){
                    if (iterations >= MAX_ITERATIONS) {
                        newSelection = date;
                        break;
                    }
                    // if minDate exists and the new selection is before the min date, get the nearest date that isn't disabled
                    if (minDate && newSelection < minDate) {
                        eventKeyCopy = $e5a100bdab37c2de$var$KeyType.ArrowRight;
                        newSelection = $e5a100bdab37c2de$var$isDayDisabled(minDate, _this.props) ? calculateNewDate(eventKeyCopy, newSelection) : minDate;
                    }
                    // if maxDate exists and the new selection is after the max date, get the nearest date that isn't disabled
                    if (maxDate && newSelection > maxDate) {
                        eventKeyCopy = $e5a100bdab37c2de$var$KeyType.ArrowLeft;
                        newSelection = $e5a100bdab37c2de$var$isDayDisabled(maxDate, _this.props) ? calculateNewDate(eventKeyCopy, newSelection) : maxDate;
                    }
                    if ($e5a100bdab37c2de$var$isDayDisabled(newSelection, _this.props)) {
                        // if PageUp and Home is pressed to a disabled date, it will try to find the next available date after
                        if (eventKeyCopy === $e5a100bdab37c2de$var$KeyType.PageUp || eventKeyCopy === $e5a100bdab37c2de$var$KeyType.Home) eventKeyCopy = $e5a100bdab37c2de$var$KeyType.ArrowRight;
                        // if PageDown and End is pressed to a disabled date, it will try to find the next available date before
                        if (eventKeyCopy === $e5a100bdab37c2de$var$KeyType.PageDown || eventKeyCopy === $e5a100bdab37c2de$var$KeyType.End) eventKeyCopy = $e5a100bdab37c2de$var$KeyType.ArrowLeft;
                        newSelection = calculateNewDate(eventKeyCopy, newSelection);
                    } else validDateFound = true;
                    iterations++;
                }
                return newSelection;
            };
            if (eventKey === $e5a100bdab37c2de$var$KeyType.Enter) {
                event.preventDefault();
                _this.handleSelect(copy, event);
                !shouldCloseOnSelect && _this.setPreSelection(copy);
                return;
            } else if (eventKey === $e5a100bdab37c2de$var$KeyType.Escape) {
                event.preventDefault();
                _this.setOpen(false);
                if (!_this.inputOk()) (_d = (_c = _this.props).onInputError) === null || _d === void 0 || _d.call(_c, {
                    code: 1,
                    msg: $e5a100bdab37c2de$var$INPUT_ERR_1
                });
                return;
            }
            var newSelection = null;
            switch(eventKey){
                case $e5a100bdab37c2de$var$KeyType.ArrowLeft:
                case $e5a100bdab37c2de$var$KeyType.ArrowRight:
                case $e5a100bdab37c2de$var$KeyType.ArrowUp:
                case $e5a100bdab37c2de$var$KeyType.ArrowDown:
                case $e5a100bdab37c2de$var$KeyType.PageUp:
                case $e5a100bdab37c2de$var$KeyType.PageDown:
                case $e5a100bdab37c2de$var$KeyType.Home:
                case $e5a100bdab37c2de$var$KeyType.End:
                    newSelection = getNewDate(eventKey, copy);
                    break;
            }
            if (!newSelection) {
                (_f = (_e = _this.props).onInputError) === null || _f === void 0 || _f.call(_e, {
                    code: 1,
                    msg: $e5a100bdab37c2de$var$INPUT_ERR_1
                });
                return;
            }
            event.preventDefault();
            _this.setState({
                lastPreSelectChange: $e5a100bdab37c2de$var$PRESELECT_CHANGE_VIA_NAVIGATE
            });
            if (adjustDateOnChange) _this.setSelected(newSelection);
            _this.setPreSelection(newSelection);
            // In inline mode, always set shouldFocusDayInline to true when navigating via keyboard.
            // This ensures focus is properly transferred to the new day element regardless of
            // whether the month changed. The user initiated this navigation from a focused day,
            // so we should always focus the destination day.
            if (inline) _this.setState({
                shouldFocusDayInline: true
            });
        };
        // handle generic key down events in the popper that do not adjust or select dates
        // ex: while focusing prev and next month buttons
        _this.onPopperKeyDown = function(event) {
            var eventKey = event.key;
            if (eventKey === $e5a100bdab37c2de$var$KeyType.Escape) {
                event.preventDefault();
                _this.sendFocusBackToInput();
                _this.setOpen(false);
            }
        };
        _this.onClearClick = function(event) {
            if (event) {
                if (event.preventDefault) event.preventDefault();
            }
            _this.sendFocusBackToInput();
            var _a = _this.props, selectsRange = _a.selectsRange, onChange = _a.onChange;
            if (selectsRange) onChange === null || onChange === void 0 || onChange([
                null,
                null
            ], event);
            else onChange === null || onChange === void 0 || onChange(null, event);
            _this.setState({
                inputValue: null
            });
        };
        _this.clear = function() {
            _this.onClearClick();
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeOnScroll === "boolean" && _this.props.closeOnScroll) {
                if (event.target === document || event.target === document.documentElement || event.target === document.body) _this.setOpen(false);
            } else if (typeof _this.props.closeOnScroll === "function") {
                if (_this.props.closeOnScroll(event)) _this.setOpen(false);
            }
        };
        _this.handleMonthSelectedInChange = function(monthSelectedIn) {
            _this.setState({
                monthSelectedIn: monthSelectedIn
            });
        };
        _this.renderCalendar = function() {
            var _a, _b;
            if (!_this.props.inline && !_this.isCalendarOpen()) return null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$Calendar, $e5a100bdab37c2de$var$_assign({
                showMonthYearDropdown: undefined,
                ref: function(elem) {
                    _this.calendar = elem;
                }
            }, _this.props, _this.state, {
                setOpen: _this.setOpen,
                dateFormat: (_a = _this.props.dateFormatCalendar) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormatCalendar,
                onSelect: _this.handleSelect,
                onClickOutside: _this.handleCalendarClickOutside,
                holidays: $e5a100bdab37c2de$var$getHolidaysMap(_this.modifyHolidays()),
                outsideClickIgnoreClass: _this.props.outsideClickIgnoreClass,
                onDropdownFocus: _this.handleDropdownFocus,
                onTimeChange: _this.handleTimeChange,
                className: _this.props.calendarClassName,
                container: _this.props.calendarContainer,
                handleOnKeyDown: _this.props.onKeyDown,
                handleOnDayKeyDown: _this.onDayKeyDown,
                setPreSelection: _this.setPreSelection,
                dropdownMode: (_b = _this.props.dropdownMode) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.dropdownMode,
                onMonthSelectedInChange: _this.handleMonthSelectedInChange
            }), _this.props.children);
        };
        _this.renderAriaLiveRegion = function() {
            var _a;
            var locale = _this.props.locale;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var isContainsTime = _this.props.showTimeInput || _this.props.showTimeSelect;
            var longDateFormat = isContainsTime ? "PPPPp" : "PPPP";
            var ariaLiveMessage;
            if (_this.props.selectsRange) ariaLiveMessage = "Selected start date: ".concat($e5a100bdab37c2de$var$safeDateFormat(_this.props.startDate, {
                dateFormat: longDateFormat,
                locale: locale
            }), ". ").concat(_this.props.endDate ? "End date: " + $e5a100bdab37c2de$var$safeDateFormat(_this.props.endDate, {
                dateFormat: longDateFormat,
                locale: locale
            }) : "");
            else {
                if (_this.props.showTimeSelectOnly) ariaLiveMessage = "Selected time: ".concat($e5a100bdab37c2de$var$safeDateFormat(_this.props.selected, {
                    dateFormat: dateFormat,
                    locale: locale
                }));
                else if (_this.props.showYearPicker) ariaLiveMessage = "Selected year: ".concat($e5a100bdab37c2de$var$safeDateFormat(_this.props.selected, {
                    dateFormat: "yyyy",
                    locale: locale
                }));
                else if (_this.props.showMonthYearPicker) ariaLiveMessage = "Selected month: ".concat($e5a100bdab37c2de$var$safeDateFormat(_this.props.selected, {
                    dateFormat: "MMMM yyyy",
                    locale: locale
                }));
                else if (_this.props.showQuarterYearPicker) ariaLiveMessage = "Selected quarter: ".concat($e5a100bdab37c2de$var$safeDateFormat(_this.props.selected, {
                    dateFormat: "yyyy, QQQ",
                    locale: locale
                }));
                else ariaLiveMessage = "Selected date: ".concat($e5a100bdab37c2de$var$safeDateFormat(_this.props.selected, {
                    dateFormat: longDateFormat,
                    locale: locale
                }));
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            }, ariaLiveMessage);
        };
        _this.renderDateInput = function() {
            var _a, _b;
            var _c, _d, _e, _f, _g;
            var className = (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)(_this.props.className, (_a = {}, _a[_this.props.outsideClickIgnoreClass || DatePicker.defaultProps.outsideClickIgnoreClass] = _this.state.open, _a));
            var customInput = _this.props.customInput || (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("input", {
                type: "text"
            });
            var customInputRef = _this.props.customInputRef || "ref";
            // Build aria props object, only including defined values to avoid
            // overwriting aria attributes that may be set on the custom input
            var ariaProps = {};
            var ariaDescribedBy = (_c = _this.props["aria-describedby"]) !== null && _c !== void 0 ? _c : _this.props.ariaDescribedBy;
            var ariaInvalid = (_d = _this.props["aria-invalid"]) !== null && _d !== void 0 ? _d : _this.props.ariaInvalid;
            var ariaLabel = (_e = _this.props["aria-label"]) !== null && _e !== void 0 ? _e : _this.props.ariaLabel;
            var ariaLabelledBy = (_f = _this.props["aria-labelledby"]) !== null && _f !== void 0 ? _f : _this.props.ariaLabelledBy;
            var ariaRequired = (_g = _this.props["aria-required"]) !== null && _g !== void 0 ? _g : _this.props.ariaRequired;
            if (ariaDescribedBy != null) ariaProps["aria-describedby"] = ariaDescribedBy;
            if (ariaInvalid != null) ariaProps["aria-invalid"] = ariaInvalid;
            if (ariaLabel != null) ariaProps["aria-label"] = ariaLabel;
            if (ariaLabelledBy != null) ariaProps["aria-labelledby"] = ariaLabelledBy;
            if (ariaRequired != null) ariaProps["aria-required"] = ariaRequired;
            return (0, $7UyaH.cloneElement)(customInput, $e5a100bdab37c2de$var$_assign((_b = {}, _b[customInputRef] = function(input) {
                _this.input = input;
            }, _b.value = _this.getInputValue(), _b.onBlur = _this.handleBlur, _b.onChange = _this.handleChange, _b.onClick = _this.onInputClick, _b.onFocus = _this.handleFocus, _b.onKeyDown = _this.onInputKeyDown, _b.id = _this.props.id, _b.name = _this.props.name, _b.form = _this.props.form, _b.autoFocus = _this.props.autoFocus, _b.placeholder = _this.props.placeholderText, _b.disabled = _this.props.disabled, _b.autoComplete = _this.props.autoComplete, _b.className = (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)(customInput.props.className, className), _b.title = _this.props.title, _b.readOnly = _this.props.readOnly, _b.required = _this.props.required, _b.tabIndex = _this.props.tabIndex, _b), ariaProps));
        };
        _this.renderClearButton = function() {
            var _a = _this.props, isClearable = _a.isClearable, disabled = _a.disabled, selected = _a.selected, startDate = _a.startDate, endDate = _a.endDate, clearButtonTitle = _a.clearButtonTitle, _b = _a.clearButtonClassName, clearButtonClassName = _b === void 0 ? "" : _b, _c = _a.ariaLabelClose, ariaLabelClose = _c === void 0 ? "Close" : _c, selectedDates = _a.selectedDates, readOnly = _a.readOnly;
            if (isClearable && !readOnly && (selected != null || startDate != null || endDate != null || (selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length))) return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("button", {
                type: "button",
                className: (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)("react-datepicker__close-icon", clearButtonClassName, {
                    "react-datepicker__close-icon--disabled": disabled
                }),
                disabled: disabled,
                "aria-label": ariaLabelClose,
                onClick: _this.onClearClick,
                title: clearButtonTitle,
                tabIndex: -1
            });
            else return null;
        };
        _this.state = _this.calcInitialState();
        _this.preventFocusTimeout = undefined;
        return _this;
    }
    Object.defineProperty(DatePicker, "defaultProps", {
        get: function() {
            return {
                allowSameDay: false,
                dateFormat: "MM/dd/yyyy",
                dateFormatCalendar: "LLLL yyyy",
                disabled: false,
                disabledKeyboardNavigation: false,
                dropdownMode: "scroll",
                preventOpenOnFocus: false,
                monthsShown: 1,
                outsideClickIgnoreClass: $e5a100bdab37c2de$var$OUTSIDE_CLICK_IGNORE_CLASS,
                readOnly: false,
                rangeSeparator: $e5a100bdab37c2de$var$DATE_RANGE_SEPARATOR,
                withPortal: false,
                selectsDisabledDaysInRange: false,
                shouldCloseOnSelect: true,
                showTimeSelect: false,
                showTimeInput: false,
                showPreviousMonths: false,
                showMonthYearPicker: false,
                showFullMonthYearPicker: false,
                showTwoColumnMonthYearPicker: false,
                showFourColumnMonthYearPicker: false,
                showYearPicker: false,
                showQuarterYearPicker: false,
                showWeekPicker: false,
                strictParsing: false,
                swapRange: false,
                timeIntervals: 30,
                timeCaption: "Time",
                previousMonthAriaLabel: "Previous Month",
                previousMonthButtonLabel: "Previous Month",
                nextMonthAriaLabel: "Next Month",
                nextMonthButtonLabel: "Next Month",
                previousYearAriaLabel: "Previous Year",
                previousYearButtonLabel: "Previous Year",
                nextYearAriaLabel: "Next Year",
                nextYearButtonLabel: "Next Year",
                timeInputLabel: "Time",
                enableTabLoop: true,
                yearItemNumber: $e5a100bdab37c2de$var$DEFAULT_YEAR_ITEM_NUMBER,
                focusSelectedMonth: false,
                showPopperArrow: true,
                excludeScrollbar: true,
                customTimeInput: null,
                calendarStartDay: undefined,
                toggleCalendarOnIconClick: false,
                usePointerEvent: false
            };
        },
        enumerable: false,
        configurable: true
    });
    DatePicker.prototype.componentDidMount = function() {
        window.addEventListener("scroll", this.onScroll, true);
        document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    };
    DatePicker.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _a, _b, _c, _d;
        // Update preSelection when selected/startDate prop changes to a different month/year.
        // This ensures the calendar view updates when dates are programmatically set
        // (e.g., via "Today" or "This Week" buttons). (Fix for #3367)
        if (this.props.selectsRange && $e5a100bdab37c2de$var$hasPreSelectionChanged(prevProps.startDate, this.props.startDate)) this.setPreSelection(this.props.startDate);
        else if ($e5a100bdab37c2de$var$hasPreSelectionChanged(prevProps.selected, this.props.selected)) this.setPreSelection(this.props.selected);
        if (this.state.monthSelectedIn !== undefined && prevProps.monthsShown !== this.props.monthsShown) this.setState({
            monthSelectedIn: 0
        });
        // Reset monthSelectedIn when calendar opens for range selection
        // This ensures startDate is displayed as the first month when reopening
        // (Fix for #5939), but we don't reset during active selection to avoid
        // the view jumping when clicking dates in the second calendar (Fix for #5275)
        if (this.props.selectsRange && prevState.open === false && this.state.open === true && this.state.monthSelectedIn !== 0) this.setState({
            monthSelectedIn: 0
        });
        if (prevProps.highlightDates !== this.props.highlightDates) this.setState({
            highlightDates: $e5a100bdab37c2de$var$getHighLightDaysMap(this.props.highlightDates)
        });
        if (!prevState.focused && !$e5a100bdab37c2de$var$isEqual(prevProps.selected, this.props.selected)) this.setState({
            inputValue: null
        });
        if (prevState.open !== this.state.open) {
            if (prevState.open === false && this.state.open === true) (_b = (_a = this.props).onCalendarOpen) === null || _b === void 0 || _b.call(_a);
            if (prevState.open === true && this.state.open === false) (_d = (_c = this.props).onCalendarClose) === null || _d === void 0 || _d.call(_c);
        }
    };
    DatePicker.prototype.componentWillUnmount = function() {
        this.clearPreventFocusTimeout();
        window.removeEventListener("scroll", this.onScroll, true);
        document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    };
    DatePicker.prototype.renderInputContainer = function() {
        var _a = this.props, showIcon = _a.showIcon, icon = _a.icon, calendarIconClassname = _a.calendarIconClassname, calendarIconClassName = _a.calendarIconClassName, toggleCalendarOnIconClick = _a.toggleCalendarOnIconClick;
        var open = this.state.open;
        if (calendarIconClassname) console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props.");
        return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
            className: "react-datepicker__input-container".concat(showIcon ? " react-datepicker__view-calendar-icon" : "")
        }, showIcon && (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$CalendarIcon, $e5a100bdab37c2de$var$_assign({
            icon: icon,
            className: (0, $d7d433c0a2bfd01d$export$4f5d2d50c9deca37)(calendarIconClassName, !calendarIconClassName && calendarIconClassname, open && "react-datepicker-ignore-onclickoutside")
        }, toggleCalendarOnIconClick ? {
            onClick: this.toggleCalendar
        } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
    };
    DatePicker.prototype.render = function() {
        var calendar = this.renderCalendar();
        if (this.props.inline) return calendar;
        if (this.props.withPortal) {
            var portalContainer = this.state.open ? (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$TabLoop, {
                enableTabLoop: this.props.enableTabLoop
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement("div", {
                className: "react-datepicker__portal",
                tabIndex: -1,
                onKeyDown: this.onPortalKeyDown
            }, calendar)) : null;
            if (this.state.open && this.props.portalId) portalContainer = (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$Portal, $e5a100bdab37c2de$var$_assign({
                portalId: this.props.portalId
            }, this.props), portalContainer);
            return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).Fragment, null, this.renderInputContainer(), portalContainer);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).createElement($e5a100bdab37c2de$var$PopperComponent, $e5a100bdab37c2de$var$_assign({}, this.props, {
            className: this.props.popperClassName,
            hidePopper: !this.isCalendarOpen(),
            targetComponent: this.renderInputContainer(),
            popperComponent: calendar,
            popperOnKeyDown: this.onPopperKeyDown,
            showArrow: this.props.showPopperArrow,
            monthHeaderPosition: this.props.monthHeaderPosition
        }));
    };
    return DatePicker;
}((0, $7UyaH.Component));
var $e5a100bdab37c2de$var$PRESELECT_CHANGE_VIA_INPUT = "input";
var $e5a100bdab37c2de$var$PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";



const $48e2a2c54694d2c7$var$MODULES = [
    {
        id: "leads",
        title: "Leads Intelligence",
        icon: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$b0c934bdae14c9ef), {})
    },
    {
        id: "applicants",
        title: "Applicants",
        icon: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$3ea9951b43b19b95), {})
    },
    {
        id: "subcontractors",
        title: "Subcontractor Performance",
        icon: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$ca978cd35363e096), {})
    },
    {
        id: "progress",
        title: "Work Progress",
        icon: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$8dbe4c747de8c5e2), {})
    },
    {
        id: "engineers",
        title: "Engineering Field Staff",
        icon: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$bdcbb206cb33984b), {})
    },
    {
        id: "po",
        title: "Purchase Orders (PO)",
        icon: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$ff497d20f87197ae), {})
    },
    {
        id: "material_issue",
        title: "Material Issue",
        icon: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$ae118f79ed05e2c0), {})
    },
    {
        id: "inwards",
        title: "Inwards (Receipts)",
        icon: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$96bab9f815fe7c91), {})
    },
    {
        id: "outwards",
        title: "Outwards (Dispatch)",
        icon: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$a6e57fbaa96aaaf9), {})
    },
    {
        id: "inventory",
        title: "Inventory Master",
        icon: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$9ea67044193f5b74), {})
    }
];
// --- MODERN BI WIDGET STYLING ---
const $48e2a2c54694d2c7$var$modernShadow = "0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03)";
const $48e2a2c54694d2c7$var$AnimatedNumber = ({ value: value })=>{
    const [displayValue, setDisplayValue] = (0, $7UyaH.useState)(0);
    (0, $7UyaH.useEffect)(()=>{
        let start = 0;
        const duration = 1000;
        const startTime = performance.now();
        let rAF;
        const animate = (currentTime)=>{
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
            setDisplayValue(Math.floor(easeProgress * value));
            if (progress < 1) rAF = requestAnimationFrame(animate);
            else setDisplayValue(value);
        };
        rAF = requestAnimationFrame(animate);
        return ()=>cancelAnimationFrame(rAF);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $64174c7064b10992$exports.Fragment), {
        children: displayValue.toLocaleString()
    });
};
const $48e2a2c54694d2c7$var$KpiWidget = ({ title: title, value: value, subtitle: subtitle, badge: badge, color: color = "#3b82f6", variant: variant = "metric" })=>{
    const pctNum = badge?.endsWith("%") ? Number.parseInt(badge, 10) : null;
    const style = {
        "--report-kpi-accent": color
    };
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("article", {
        className: `report-kpi-card${variant === "hero" ? " report-kpi-card--hero" : ""}`,
        style: style,
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "report-kpi-card__accent",
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "report-kpi-card__body",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "report-kpi-card__head",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "report-kpi-card__label",
                                title: title,
                                children: title
                            }),
                            badge ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "report-kpi-card__badge",
                                children: badge
                            }) : variant === "hero" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "report-kpi-card__badge report-kpi-card__badge--neutral",
                                children: "Overview"
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "report-kpi-card__value",
                        "aria-live": "polite",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($48e2a2c54694d2c7$var$AnimatedNumber, {
                            value: value
                        })
                    }),
                    pctNum != null && variant !== "hero" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "report-kpi-card__track",
                        role: "img",
                        "aria-label": `${pctNum}% of total`,
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "report-kpi-card__fill",
                            style: {
                                width: `${Math.min(100, Math.max(0, pctNum))}%`
                            }
                        })
                    }) : null,
                    subtitle ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "report-kpi-card__subtitle",
                        children: subtitle
                    }) : null
                ]
            })
        ]
    });
};
const $48e2a2c54694d2c7$var$PieChart = ({ data: data, title: title })=>{
    const total = Math.max(data.reduce((a, b)=>a + b.value, 0), 1);
    let currentPercent = 0;
    const gradientStops = data.map((d)=>{
        const start = currentPercent;
        currentPercent += d.value / total * 100;
        return `${d.color} ${start}% ${currentPercent}%`;
    }).join(", ");
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        style: {
            background: "#fff",
            borderRadius: "8px",
            padding: "1.25rem",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            boxShadow: $48e2a2c54694d2c7$var$modernShadow,
            border: "1px solid #f1f5f9"
        },
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("style", {
                children: `.hide-scroll::-webkit-scrollbar { display: none; } .hide-scroll { -ms-overflow-style: none; scrollbar-width: none; }`
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h4", {
                style: {
                    margin: "0 0 1rem",
                    fontSize: "0.85rem",
                    fontWeight: 600,
                    color: "#334155"
                },
                children: title
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "1.5rem",
                    flex: 1
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        style: {
                            width: "110px",
                            height: "110px",
                            borderRadius: "50%",
                            background: `conic-gradient(${gradientStops})`,
                            flexShrink: 0,
                            boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)"
                        }
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "hide-scroll",
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.5rem",
                            flex: 1,
                            overflowY: "auto",
                            maxHeight: "110px",
                            paddingRight: "4px"
                        },
                        children: [
                            data.map((d, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        fontSize: "0.8rem"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "0.5rem",
                                                overflow: "hidden"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                    style: {
                                                        width: "10px",
                                                        height: "10px",
                                                        borderRadius: "50%",
                                                        background: d.color,
                                                        display: "inline-block",
                                                        flexShrink: 0
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                    style: {
                                                        color: "#475569",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        maxWidth: "200px"
                                                    },
                                                    title: d.label,
                                                    children: d.label
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            style: {
                                                fontWeight: 600,
                                                color: "#1e293b",
                                                marginLeft: "0.5rem"
                                            },
                                            children: d.value
                                        })
                                    ]
                                }, i)),
                            data.length === 0 && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                style: {
                                    fontSize: "0.8rem",
                                    color: "#94a3b8"
                                },
                                children: "No data points"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $48e2a2c54694d2c7$var$HorizontalBarChart = ({ data: data, title: title })=>{
    const max = Math.max(...data.map((d)=>d.value), 1);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        style: {
            background: "#fff",
            borderRadius: "8px",
            padding: "1.25rem",
            boxShadow: $48e2a2c54694d2c7$var$modernShadow,
            border: "1px solid #f1f5f9"
        },
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h4", {
                style: {
                    margin: "0 0 1rem",
                    fontSize: "0.85rem",
                    fontWeight: 600,
                    color: "#334155"
                },
                children: title
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.85rem"
                },
                children: [
                    data.length === 0 && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        style: {
                            fontSize: "0.8rem",
                            color: "#94a3b8"
                        },
                        children: "No data available"
                    }),
                    data.map((d, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        fontSize: "0.8rem",
                                        marginBottom: "0.25rem",
                                        color: "#475569"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            style: {
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                maxWidth: "85%"
                                            },
                                            title: d.label,
                                            children: d.label
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            style: {
                                                fontWeight: 600,
                                                color: "#1e293b"
                                            },
                                            children: d.value.toLocaleString()
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    style: {
                                        height: "10px",
                                        background: "#f1f5f9",
                                        borderRadius: "5px",
                                        overflow: "hidden"
                                    },
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        style: {
                                            height: "100%",
                                            width: `${d.value / max * 100}%`,
                                            background: "#3b82f6",
                                            borderRadius: "5px"
                                        }
                                    })
                                })
                            ]
                        }, i))
                ]
            })
        ]
    });
};
const $48e2a2c54694d2c7$var$FunnelChart = ({ data: data, title: title })=>{
    const max = Math.max(data[0]?.value || 1, 1);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        style: {
            background: "#fff",
            borderRadius: "8px",
            padding: "1.25rem",
            boxShadow: $48e2a2c54694d2c7$var$modernShadow,
            border: "1px solid #f1f5f9",
            display: "flex",
            flexDirection: "column",
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h4", {
                style: {
                    margin: "0 0 1rem",
                    fontSize: "0.85rem",
                    fontWeight: 600,
                    color: "#334155"
                },
                children: title
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    flex: 1,
                    justifyContent: "center"
                },
                children: [
                    data.length === 0 && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        style: {
                            fontSize: "0.8rem",
                            color: "#94a3b8"
                        },
                        children: "No data available"
                    }),
                    data.map((d, i)=>{
                        const widthPct = d.value / max * 100;
                        return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            style: {
                                width: "100%",
                                display: "flex",
                                flexDirection: "column"
                            },
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        fontSize: "0.8rem",
                                        marginBottom: "0.35rem",
                                        color: "#475569"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            style: {
                                                fontWeight: 500
                                            },
                                            children: d.label
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                            style: {
                                                fontWeight: 600,
                                                color: "#1e293b"
                                            },
                                            children: [
                                                d.value.toLocaleString(),
                                                " ",
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                    style: {
                                                        color: "#94a3b8",
                                                        marginLeft: "0.25rem",
                                                        fontSize: "0.75rem",
                                                        display: "inline-block",
                                                        width: "32px",
                                                        textAlign: "right"
                                                    },
                                                    children: [
                                                        Math.round(widthPct),
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    style: {
                                        width: "100%",
                                        height: "10px",
                                        background: "#f1f5f9",
                                        borderRadius: "5px",
                                        overflow: "hidden"
                                    },
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        style: {
                                            width: `${Math.max(widthPct, 1)}%`,
                                            height: "100%",
                                            background: d.color,
                                            borderRadius: "5px",
                                            transition: "width 0.5s ease"
                                        }
                                    })
                                })
                            ]
                        }, i);
                    })
                ]
            })
        ]
    });
};
function $48e2a2c54694d2c7$export$1fdf307dd6b0ec16() {
    const { applications: applications, subcontractorMasters: subcontractorMasters, engineerMasters: engineerMasters, milestoneTemplates: milestoneTemplates, storeYards: storeYards, standardResources: standardResources } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const { store: geoStore } = (0, $60dd8507bac67e50$export$5ec0231075ddedf1)();
    const [leads, setLeads] = (0, $7UyaH.useState)([]);
    const [poData, setPoData] = (0, $7UyaH.useState)([]);
    const [issueData, setIssueData] = (0, $7UyaH.useState)([]);
    const [inwardData, setInwardData] = (0, $7UyaH.useState)([]);
    const [outwardData, setOutwardData] = (0, $7UyaH.useState)([]);
    const [isLoadingBI, setIsLoadingBI] = (0, $7UyaH.useState)(true);
    const [activeModule, setActiveModule] = (0, $7UyaH.useState)("leads");
    // Advanced BI Slicers
    const [dateFrom, setDateFrom] = (0, $7UyaH.useState)("");
    const [dateTo, setDateTo] = (0, $7UyaH.useState)("");
    const [datePreset, setDatePreset] = (0, $7UyaH.useState)("custom");
    const [selectedYear, setSelectedYear] = (0, $7UyaH.useState)(new Date().getFullYear().toString());
    const [selectedMonth, setSelectedMonth] = (0, $7UyaH.useState)(new Date().getMonth().toString());
    const [selectedQuarter, setSelectedQuarter] = (0, $7UyaH.useState)(Math.floor(new Date().getMonth() / 3).toString());
    const [districtFilter, setDistrictFilter] = (0, $7UyaH.useState)("");
    const applyPresetDates = (preset, y, m, q)=>{
        const formatDate = (date)=>{
            const yy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            return `${yy}-${mm}-${dd}`;
        };
        const now = new Date();
        let start = "";
        let end = "";
        if (preset === "today") {
            start = formatDate(now);
            end = start;
        } else if (preset === "weekly") {
            const d = new Date(now);
            d.setDate(d.getDate() - d.getDay());
            start = formatDate(d);
            const e = new Date(d);
            e.setDate(e.getDate() + 6);
            end = formatDate(e);
        } else if (preset === "monthly") {
            start = formatDate(new Date(y, m, 1));
            end = formatDate(new Date(y, m + 1, 0));
        } else if (preset === "quarterly") {
            start = formatDate(new Date(y, q * 3, 1));
            end = formatDate(new Date(y, q * 3 + 3, 0));
        } else if (preset === "yearly") {
            start = formatDate(new Date(y, 0, 1));
            end = formatDate(new Date(y, 11, 31));
        }
        if (preset !== "custom") {
            setDateFrom(start);
            setDateTo(end);
        }
    };
    const handleDatePreset = (preset)=>{
        setDatePreset(preset);
        applyPresetDates(preset, parseInt(selectedYear), parseInt(selectedMonth), parseInt(selectedQuarter));
    };
    const handleYearChange = (val)=>{
        setSelectedYear(val);
        applyPresetDates(datePreset, parseInt(val), parseInt(selectedMonth), parseInt(selectedQuarter));
    };
    const handleMonthChange = (val)=>{
        setSelectedMonth(val);
        applyPresetDates(datePreset, parseInt(selectedYear), parseInt(val), parseInt(selectedQuarter));
    };
    const handleQuarterChange = (val)=>{
        setSelectedQuarter(val);
        applyPresetDates(datePreset, parseInt(selectedYear), parseInt(selectedMonth), parseInt(val));
    };
    const [mandalFilter, setMandalFilter] = (0, $7UyaH.useState)("");
    const [villageFilter, setVillageFilter] = (0, $7UyaH.useState)("");
    const [statusFilter, setStatusFilter] = (0, $7UyaH.useState)("ALL");
    const [isFiltersOpen, setIsFiltersOpen] = (0, $7UyaH.useState)(false);
    const [currentPage, setCurrentPage] = (0, $7UyaH.useState)(1);
    const pageSize = 20;
    (0, $7UyaH.useEffect)(()=>{
        setCurrentPage(1);
    }, [
        activeModule,
        dateFrom,
        dateTo,
        districtFilter,
        mandalFilter,
        villageFilter,
        statusFilter
    ]);
    (0, $7UyaH.useEffect)(()=>{
        Promise.all([
            (0, $4e56623d4da7ea32$export$c20290562992eebc)().catch(()=>[]),
            (0, $f5510818538731b9$export$199cc1209b09073e)().catch(()=>[]),
            (0, $f5510818538731b9$export$8ae7398780b7bae5)().catch(()=>[]),
            (0, $f5510818538731b9$export$4661dba8bff6ca9)().catch(()=>[]),
            (0, $f5510818538731b9$export$36d59bdb7dee965)().catch(()=>[])
        ]).then(([leadsRes, poRes, issueRes, inRes, outRes])=>{
            setLeads(leadsRes);
            setPoData(poRes);
            setIssueData(issueRes);
            setInwardData(inRes);
            setOutwardData(outRes);
            setIsLoadingBI(false);
        });
    }, []);
    const passesDateFilter = (dStr)=>{
        if (!dateFrom && !dateTo) return true;
        if (!dStr) return false;
        const d = new Date(dStr);
        if (dateFrom && d < new Date(dateFrom)) return false;
        if (dateTo) {
            const to = new Date(dateTo);
            to.setHours(23, 59, 59, 999);
            if (d > to) return false;
        }
        return true;
    };
    const getSubReportFilters = (modId)=>{
        switch(modId){
            case "leads":
                return [
                    "ALL",
                    "approved",
                    "rejected",
                    "interested",
                    "not_interested"
                ];
            case "applicants":
                return [
                    "ALL",
                    "verif_pending",
                    "ready_icici_mou",
                    "mou_completed",
                    "on_hold"
                ];
            case "subcontractors":
                return [
                    "ALL",
                    "active",
                    "inactive"
                ];
            case "progress":
                return [
                    "ALL",
                    "delayed",
                    "on_track"
                ];
            case "po":
                return [
                    "ALL",
                    "full",
                    "partial"
                ];
            case "material_issue":
                return [
                    "ALL",
                    "pending",
                    "completed"
                ];
            default:
                return [
                    "ALL"
                ];
        }
    };
    const COLORS = [
        "#3b82f6",
        "#10b981",
        "#f59e0b",
        "#ef4444",
        "#8b5cf6",
        "#14b8a6",
        "#ec4899",
        "#f97316"
    ];
    const currentReportData = (0, $7UyaH.useMemo)(()=>{
        let headers = [];
        let rows = [];
        let kpis = {
            total: 0,
            metric1: {
                label: "",
                val: 0
            },
            metric2: {
                label: "",
                val: 0
            }
        };
        let donutData = [];
        let barData = [];
        let funnelData = [];
        let barTitle = "Top 5 Distribution Categories";
        let pieTitle = "Status Segmentation";
        const geoFilter = {
            district: districtFilter,
            mandal: mandalFilter,
            village: villageFilter
        };
        const hasGeoFilter = Boolean(districtFilter || mandalFilter || villageFilter);
        const passesGeo = (row)=>(0, $65d82a3223f822b8$export$16b9f92e753bd4d0)(geoStore, row, geoFilter);
        if (activeModule === "leads") {
            const getNormalizedStatus = (l)=>{
                const s = (l.hoStatus || l.status || "Unknown").toLowerCase().replace(/\s+/g, "_");
                if (s.includes("approv")) return "approved";
                if (s.includes("reject")) return "rejected";
                if (s.includes("not_interested")) return "not_interested";
                if (s.includes("interested")) return "interested";
                return "pending_processing";
            };
            let f = leads.filter((l)=>passesDateFilter(l.createdAt) && passesGeo(l));
            if (statusFilter !== "ALL") f = f.filter((l)=>getNormalizedStatus(l) === statusFilter);
            headers = [
                "Lead ID",
                "Name",
                "Mobile",
                "District",
                "Mandal",
                "Village",
                "Status",
                "Date"
            ];
            rows = f.map((l)=>[
                    l.leadId,
                    l.applicantName || "",
                    l.mobileNumber || "",
                    l.district || "",
                    l.mandal || "",
                    l.village || "",
                    getNormalizedStatus(l).replace(/_/g, " ").toUpperCase(),
                    l.createdAt?.split('T')[0] || ""
                ]);
            const interested = f.filter((l)=>getNormalizedStatus(l) === "interested").length;
            const notInterested = f.filter((l)=>getNormalizedStatus(l) === "not_interested").length;
            const approved = f.filter((l)=>getNormalizedStatus(l) === "approved").length;
            const rejected = f.filter((l)=>getNormalizedStatus(l) === "rejected").length;
            const calcPct = (v)=>f.length > 0 ? Math.round(v / f.length * 100) + '%' : '0%';
            kpis = {
                total: f.length,
                totalLabel: "Total Leads",
                totalColor: "#0f172a",
                metric1: {
                    label: "Interested",
                    val: interested,
                    color: "#f59e0b",
                    badge: calcPct(interested)
                },
                metric2: {
                    label: "Not Interested",
                    val: notInterested,
                    color: "#8b5cf6",
                    badge: calcPct(notInterested)
                },
                metric3: {
                    label: "Approved",
                    val: approved,
                    color: "#10b981",
                    badge: calcPct(approved)
                },
                metric4: {
                    label: "Rejected",
                    val: rejected,
                    color: "#ef4444",
                    badge: calcPct(rejected)
                }
            };
            pieTitle = "Sanction Phase Distribution";
            const phaseDist = f.reduce((acc, l)=>{
                const s = (l.hoStatus || l.status || "Unknown").toUpperCase();
                let bucket = "Other";
                if (s.includes("LIST 1")) bucket = "Phase 1 (List 1)";
                else if (s.includes("LIST 2")) bucket = "Phase 2 (List 2)";
                else if (s.includes("LIST 3")) bucket = "Phase 3 (List 3)";
                // Exclude empty/unknown if you only want to see actual lists, but we can include them
                acc[bucket] = (acc[bucket] || 0) + 1;
                return acc;
            }, {});
            donutData = Object.entries(phaseDist).sort((a, b)=>b[1] - a[1]) // Sort by volume
            .map(([k, v], i)=>({
                    label: k,
                    value: v,
                    color: COLORS[i % COLORS.length]
                }));
            let groupKey = "district";
            barTitle = "Top 5 Districts";
            if (villageFilter) {
                groupKey = "status";
                barTitle = "Top 5 Statuses";
            } else if (mandalFilter) {
                groupKey = "village";
                barTitle = "Top 5 Villages";
            } else if (districtFilter) {
                groupKey = "mandal";
                barTitle = "Top 5 Mandals";
            }
            const dist = f.reduce((acc, l)=>{
                let val = groupKey === "status" ? getNormalizedStatus(l).replace(/_/g, " ").toUpperCase() : l[groupKey] || "Unknown";
                acc[val] = (acc[val] || 0) + 1;
                return acc;
            }, {});
            barData = Object.entries(dist).sort((a, b)=>b[1] - a[1]).slice(0, 5).map(([k, v])=>({
                    label: k,
                    value: v
                }));
            funnelData = [
                {
                    label: "Total Target Leads",
                    value: f.length,
                    color: "#94a3b8"
                },
                {
                    label: "Contacted / In Progress",
                    value: f.filter((l)=>getNormalizedStatus(l) !== "pending_processing").length,
                    color: "#3b82f6"
                },
                {
                    label: "Interested (Converted)",
                    value: f.filter((l)=>getNormalizedStatus(l) === "interested").length,
                    color: "#f59e0b"
                },
                {
                    label: "Qualified & Approved",
                    value: f.filter((l)=>getNormalizedStatus(l) === "approved").length,
                    color: "#10b981"
                }
            ];
        } else if (activeModule === "applicants") {
            let f = applications.filter((a)=>passesDateFilter(a.receivedAt) && passesGeo(a));
            if (statusFilter !== "ALL") f = f.filter((a)=>a.status === statusFilter);
            headers = [
                "App ID",
                "Beneficiary",
                "Mobile",
                "District",
                "Mandal",
                "Status",
                "Subcontractor"
            ];
            rows = f.map((a)=>[
                    a.id,
                    a.mobile.beneficiaryName,
                    "N/A",
                    a.district,
                    a.mandal,
                    a.status,
                    subcontractorMasters.find((s)=>s.id === a.subcontractor?.subcontractorMasterId)?.firmName || ""
                ]);
            const verifPending = f.filter((a)=>[
                    "pending_validation",
                    "verif_pending"
                ].includes(a.status || "")).length;
            const readyIcici = f.filter((a)=>[
                    "subcontractor_linked",
                    "ready_icici_mou"
                ].includes(a.status || "")).length;
            const mouCompleted = f.filter((a)=>[
                    "work_initiated",
                    "mou_completed"
                ].includes(a.status || "")).length;
            const onHold = f.filter((a)=>a.status === "on_hold").length;
            const calcPct = (v)=>f.length > 0 ? Math.round(v / f.length * 100) + '%' : '0%';
            kpis = {
                total: f.length,
                totalLabel: "Total Applicants",
                totalColor: "#0f172a",
                metric1: {
                    label: "Verif. Pending",
                    val: verifPending,
                    color: "#f59e0b",
                    badge: calcPct(verifPending)
                },
                metric2: {
                    label: "Ready ICICI & MOU",
                    val: readyIcici,
                    color: "#0ea5e9",
                    badge: calcPct(readyIcici)
                },
                metric3: {
                    label: "MOU Completed",
                    val: mouCompleted,
                    color: "#10b981",
                    badge: calcPct(mouCompleted)
                },
                metric4: {
                    label: "On Hold",
                    val: onHold,
                    color: "#ef4444",
                    badge: calcPct(onHold)
                }
            };
            const st = f.reduce((acc, a)=>{
                acc[a.status || "Unknown"] = (acc[a.status || "Unknown"] || 0) + 1;
                return acc;
            }, {});
            donutData = Object.entries(st).map(([k, v], i)=>({
                    label: k,
                    value: v,
                    color: COLORS[i % COLORS.length]
                }));
            const subs = f.reduce((acc, a)=>{
                const s = subcontractorMasters.find((x)=>x.id === a.subcontractor?.subcontractorMasterId)?.firmName || "Unassigned";
                acc[s] = (acc[s] || 0) + 1;
                return acc;
            }, {});
            barData = Object.entries(subs).sort((a, b)=>b[1] - a[1]).slice(0, 5).map(([k, v])=>({
                    label: k,
                    value: v
                }));
        } else if (activeModule === "subcontractors") {
            let f = subcontractorMasters;
            if (hasGeoFilter) {
                const validSubIds = new Set(applications.filter(passesGeo).map((a)=>a.subcontractor?.subcontractorMasterId).filter(Boolean));
                f = f.filter((s)=>validSubIds.has(s.id));
            }
            if (statusFilter === "active") f = f.filter((s)=>applications.some((a)=>a.subcontractor?.subcontractorMasterId === s.id));
            if (statusFilter === "inactive") f = f.filter((s)=>!applications.some((a)=>a.subcontractor?.subcontractorMasterId === s.id));
            headers = [
                "ID",
                "Firm Name",
                "Contact",
                "Phone",
                "Assigned Apps"
            ];
            rows = f.map((s)=>[
                    s.id,
                    s.firmName,
                    s.contactPersonName || "",
                    s.contactPhone || "",
                    applications.filter((a)=>a.subcontractor?.subcontractorMasterId === s.id).length
                ]);
            const activeFirms = f.filter((s)=>applications.some((a)=>a.subcontractor?.subcontractorMasterId === s.id)).length;
            const assignedApps = applications.filter((a)=>a.subcontractor?.subcontractorMasterId).length;
            const calcPct = (v)=>f.length > 0 ? Math.round(v / f.length * 100) + '%' : '0%';
            kpis = {
                total: f.length,
                totalLabel: "Total Firms",
                totalColor: "#0f172a",
                metric1: {
                    label: "Active Firms",
                    val: activeFirms,
                    color: "#10b981",
                    badge: calcPct(activeFirms)
                },
                metric2: {
                    label: "Total Assigned",
                    val: assignedApps,
                    color: "#3b82f6",
                    badge: ""
                }
            };
            const top = rows.sort((a, b)=>b[4] - a[4]).slice(0, 5);
            barData = top.map((r)=>({
                    label: String(r[1]),
                    value: Number(r[4])
                }));
        } else if (activeModule === "po") {
            let f = poData.filter((p)=>passesDateFilter(p.createdAt));
            // Try to filter by subcontractor assigned apps if po has subcontractorFirmName
            if (hasGeoFilter) {
                const validSubIds = new Set(applications.filter(passesGeo).map((a)=>a.subcontractor?.subcontractorMasterId).filter(Boolean));
                const validFirmNames = new Set(subcontractorMasters.filter((s)=>validSubIds.has(s.id)).map((s)=>s.firmName));
                f = f.filter((p)=>validFirmNames.has(p.subcontractorFirmName));
            }
            if (statusFilter !== "ALL") f = f.filter((p)=>p.selectionMode === statusFilter);
            headers = [
                "PO Number",
                "Milestone",
                "Subcontractor",
                "Mode",
                "Date"
            ];
            rows = f.map((p)=>[
                    p.poNumber,
                    p.milestoneTitle,
                    p.subcontractorFirmName,
                    p.selectionMode,
                    p.poDate || p.createdAt.split('T')[0]
                ]);
            const full = f.filter((p)=>p.selectionMode === "full").length;
            const partial = f.filter((p)=>p.selectionMode === "partial").length;
            const calcPct = (v)=>f.length > 0 ? Math.round(v / f.length * 100) + '%' : '0%';
            kpis = {
                total: f.length,
                totalLabel: "Total POs",
                totalColor: "#0f172a",
                metric1: {
                    label: "Full POs",
                    val: full,
                    color: "#10b981",
                    badge: calcPct(full)
                },
                metric2: {
                    label: "Partial POs",
                    val: partial,
                    color: "#f59e0b",
                    badge: calcPct(partial)
                }
            };
            const modes = f.reduce((acc, p)=>{
                acc[p.selectionMode] = (acc[p.selectionMode] || 0) + 1;
                return acc;
            }, {});
            donutData = Object.entries(modes).map(([k, v], i)=>({
                    label: k,
                    value: v,
                    color: COLORS[i % COLORS.length]
                }));
            const bySub = f.reduce((acc, p)=>{
                acc[p.subcontractorFirmName] = (acc[p.subcontractorFirmName] || 0) + 1;
                return acc;
            }, {});
            barData = Object.entries(bySub).sort((a, b)=>b[1] - a[1]).slice(0, 5).map(([k, v])=>({
                    label: k,
                    value: v
                }));
        } else if (activeModule === "material_issue") {
            let f = issueData.filter((i)=>passesDateFilter(i.createdAt));
            if (hasGeoFilter) {
                const validAppIds = new Set(applications.filter(passesGeo).map((a)=>a.id));
                f = f.filter((i)=>validAppIds.has(i.applicationId));
            }
            if (statusFilter !== "ALL") f = f.filter((i)=>i.status === statusFilter);
            headers = [
                "Issue ID",
                "App ID",
                "Resource",
                "Planned",
                "Issued",
                "Status"
            ];
            rows = f.map((i)=>[
                    i.id,
                    i.applicationId,
                    i.resourceItemLabel,
                    i.plannedQty,
                    i.issuedQty,
                    i.status
                ]);
            const completed = f.filter((i)=>i.status === "completed").length;
            const pending = f.filter((i)=>i.status !== "completed").length;
            const calcPct = (v)=>f.length > 0 ? Math.round(v / f.length * 100) + '%' : '0%';
            kpis = {
                total: f.length,
                totalLabel: "Total Issued",
                totalColor: "#0f172a",
                metric1: {
                    label: "Completed",
                    val: completed,
                    color: "#10b981",
                    badge: calcPct(completed)
                },
                metric2: {
                    label: "Pending",
                    val: pending,
                    color: "#f59e0b",
                    badge: calcPct(pending)
                }
            };
            const stats = f.reduce((acc, i)=>{
                acc[i.status] = (acc[i.status] || 0) + 1;
                return acc;
            }, {});
            donutData = Object.entries(stats).map(([k, v], i)=>({
                    label: k,
                    value: v,
                    color: COLORS[i % COLORS.length]
                }));
            const res = f.reduce((acc, i)=>{
                acc[i.resourceItemLabel] = (acc[i.resourceItemLabel] || 0) + i.plannedQty;
                return acc;
            }, {});
            barData = Object.entries(res).sort((a, b)=>b[1] - a[1]).slice(0, 5).map(([k, v])=>({
                    label: k,
                    value: v
                }));
        } else {
            headers = [
                "Record ID",
                "Module",
                "Count"
            ];
            rows = [
                [
                    "-",
                    activeModule,
                    1
                ]
            ];
        }
        return {
            headers: headers,
            rows: rows,
            kpis: kpis,
            donutData: donutData,
            barData: barData,
            barTitle: barTitle,
            funnelData: funnelData,
            pieTitle: pieTitle
        };
    }, [
        activeModule,
        leads,
        applications,
        subcontractorMasters,
        poData,
        issueData,
        dateFrom,
        dateTo,
        districtFilter,
        mandalFilter,
        villageFilter,
        statusFilter,
        geoStore
    ]);
    const handleDownloadCsv = ()=>{
        (0, $dc744e52b043da5b$export$c6d851d1877b46af)(`BI_${activeModule}_${new Date().getTime()}.csv`, currentReportData.headers, currentReportData.rows.map((r)=>r.map(String)));
    };
    const handleDownloadPdf = async ()=>{
        const html = `
      <html>
        <head>
          <style>
            body { font-family: sans-serif; color: #111; }
            h1 { font-size: 20px; border-bottom: 2px solid #000; padding-bottom: 10px; text-transform: uppercase; margin-top: 0; }
            table { width: 100%; border-collapse: collapse; margin-top: 15px; font-size: 11px; }
            th, td { border: 1px solid #cbd5e1; padding: 6px; text-align: left; }
            th { background-color: #f1f5f9; color: #334155; }
          </style>
        </head>
        <body>
          <h1>Corporate BI Report: ${activeModule.toUpperCase()}</h1>
          <p style="font-size:12px; color:#64748b; margin-top:0;">Generated on: ${new Date().toLocaleString()} | Filter Segment: ${statusFilter}</p>
          <table>
            <thead><tr>${currentReportData.headers.map((h)=>`<th>${h}</th>`).join('')}</tr></thead>
            <tbody>${currentReportData.rows.map((r)=>`<tr>${r.map((c)=>`<td>${c}</td>`).join('')}</tr>`).join('')}</tbody>
          </table>
        </body>
      </html>
    `;
        await (0, $b2a79528db62cd8d$export$768a1993afbfc55d)(html, `BI_${activeModule}.pdf`);
    };
    if (isLoadingBI) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
        style: {
            background: "#f8fafc",
            minHeight: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "#64748b"
        },
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
            children: "Loading Data Model..."
        })
    });
    const totalPages = Math.max(1, Math.ceil(currentReportData.rows.length / pageSize));
    const paginatedRows = currentReportData.rows.slice((currentPage - 1) * pageSize, currentPage * pageSize);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        style: {
            background: "#f8fafc",
            minHeight: "calc(100vh - 60px)",
            fontFamily: "'Inter', system-ui, sans-serif",
            padding: "1.25rem",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    marginBottom: "1.25rem",
                    flexShrink: 0
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("h1", {
                                style: {
                                    margin: 0,
                                    fontSize: "1.35rem",
                                    fontWeight: 700,
                                    color: "#111827",
                                    letterSpacing: "-0.01em"
                                },
                                children: [
                                    $48e2a2c54694d2c7$var$MODULES.find((m)=>m.id === activeModule)?.title,
                                    " Analytics"
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                style: {
                                    margin: "0.25rem 0 0",
                                    fontSize: "0.85rem",
                                    color: "#6b7280"
                                },
                                children: [
                                    "Last refreshed: ",
                                    new Date().toLocaleTimeString()
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            gap: "0.75rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("button", {
                                onClick: ()=>setIsFiltersOpen(!isFiltersOpen),
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.5rem",
                                    padding: "0.5rem 1rem",
                                    borderRadius: "6px",
                                    background: isFiltersOpen ? "#f3f4f6" : "#fff",
                                    border: "1px solid #d1d5db",
                                    color: "#374151",
                                    fontWeight: 600,
                                    fontSize: "0.875rem",
                                    cursor: "pointer",
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$625671e92c10ce58), {
                                        width: 18,
                                        height: 18,
                                        color: "#4b5563",
                                        strokeWidth: isFiltersOpen ? 2 : 1.5
                                    }),
                                    "Global Filters ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        style: {
                                            fontSize: "0.7rem",
                                            color: "#9ca3af"
                                        },
                                        children: isFiltersOpen ? "\u25B2" : "\u25BC"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("button", {
                                onClick: handleDownloadPdf,
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.5rem",
                                    padding: "0.5rem 1rem",
                                    borderRadius: "6px",
                                    background: "#fff",
                                    border: "1px solid #d1d5db",
                                    color: "#374151",
                                    fontWeight: 600,
                                    fontSize: "0.875rem",
                                    cursor: "pointer",
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$a53026e91890dfa1), {
                                        width: 18,
                                        height: 18,
                                        color: "#4b5563"
                                    }),
                                    " Export PDF"
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("button", {
                                onClick: handleDownloadCsv,
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.5rem",
                                    padding: "0.5rem 1rem",
                                    borderRadius: "6px",
                                    background: "#fff",
                                    border: "1px solid #d1d5db",
                                    color: "#374151",
                                    fontWeight: 600,
                                    fontSize: "0.875rem",
                                    cursor: "pointer",
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33a10e4dd89b1f49$export$1aeec9750ae9fdbe), {
                                        width: 18,
                                        height: 18,
                                        color: "#4b5563"
                                    }),
                                    " Export Data"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "alert alert--info",
                role: "note",
                style: {
                    marginBottom: "1.25rem",
                    flexShrink: 0
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Note:"
                    }),
                    " Reports in this hub are under active development. Figures, charts, and exports may be incomplete or contain errors. If any information looks wrong, please verify it against the source registers before official use or decision-making. Upcoming updates will bring more accurate, real-time analytics and richer reporting across all modules."
                ]
            }),
            isFiltersOpen && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                style: {
                    background: "#fff",
                    padding: "1.25rem",
                    borderRadius: "8px",
                    boxShadow: $48e2a2c54694d2c7$var$modernShadow,
                    border: "1px solid #f1f5f9",
                    marginBottom: "1.25rem",
                    flexShrink: 0,
                    position: "relative",
                    animation: "fadeIn 0.2s ease-in-out"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            marginBottom: "1rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                style: {
                                    margin: 0,
                                    fontSize: "0.95rem",
                                    fontWeight: 600,
                                    color: "#374151"
                                },
                                children: "Filter Data"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                onClick: ()=>{
                                    setDateFrom("");
                                    setDateTo("");
                                    setDatePreset("custom");
                                    setDistrictFilter("");
                                    setMandalFilter("");
                                    setVillageFilter("");
                                    setStatusFilter("ALL");
                                },
                                style: {
                                    background: "#eff6ff",
                                    border: "none",
                                    color: "#3b82f6",
                                    fontSize: "0.8rem",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    padding: "0.4rem 0.8rem",
                                    borderRadius: "6px",
                                    transition: "all 0.2s"
                                },
                                children: "Clear all slicers"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "1.5rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("style", {
                                children: `
            .react-datepicker-wrapper { width: 100%; }
            .custom-datepicker { border: 1px solid #cbd5e1; border-radius: 6px; padding: 0.4rem; font-size: 0.8rem; color: #334155; outline: none; width: 100%; box-sizing: border-box; }
            .custom-datepicker:focus { border-color: #3b82f6; box-shadow: 0 0 0 1px #3b82f6; }
          `
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    gap: "1rem",
                                    flex: "1 1 auto",
                                    flexWrap: "wrap"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "0.4rem",
                                            minWidth: "100px",
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                style: {
                                                    fontSize: "0.7rem",
                                                    color: "#64748b",
                                                    fontWeight: 700,
                                                    textTransform: "uppercase"
                                                },
                                                children: "Date Range"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                id: "date-preset",
                                                value: datePreset,
                                                onChange: handleDatePreset,
                                                options: [
                                                    {
                                                        value: "custom",
                                                        label: "Custom"
                                                    },
                                                    {
                                                        value: "today",
                                                        label: "Today"
                                                    },
                                                    {
                                                        value: "weekly",
                                                        label: "This Week"
                                                    },
                                                    {
                                                        value: "monthly",
                                                        label: "Monthly"
                                                    },
                                                    {
                                                        value: "quarterly",
                                                        label: "Quarterly"
                                                    },
                                                    {
                                                        value: "yearly",
                                                        label: "Yearly"
                                                    }
                                                ]
                                            })
                                        ]
                                    }),
                                    (datePreset === "monthly" || datePreset === "quarterly" || datePreset === "yearly") && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "0.4rem",
                                            minWidth: "80px",
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                style: {
                                                    fontSize: "0.7rem",
                                                    color: "#64748b",
                                                    fontWeight: 700,
                                                    textTransform: "uppercase"
                                                },
                                                children: "Year"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                id: "year-preset",
                                                value: selectedYear,
                                                onChange: handleYearChange,
                                                options: [
                                                    2024,
                                                    2025,
                                                    2026,
                                                    2027,
                                                    2028
                                                ].map((y)=>({
                                                        value: y.toString(),
                                                        label: y.toString()
                                                    }))
                                            })
                                        ]
                                    }),
                                    datePreset === "monthly" && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "0.4rem",
                                            minWidth: "100px",
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                style: {
                                                    fontSize: "0.7rem",
                                                    color: "#64748b",
                                                    fontWeight: 700,
                                                    textTransform: "uppercase"
                                                },
                                                children: "Month"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                id: "month-preset",
                                                value: selectedMonth,
                                                onChange: handleMonthChange,
                                                options: [
                                                    "January",
                                                    "February",
                                                    "March",
                                                    "April",
                                                    "May",
                                                    "June",
                                                    "July",
                                                    "August",
                                                    "September",
                                                    "October",
                                                    "November",
                                                    "December"
                                                ].map((m, i)=>({
                                                        value: i.toString(),
                                                        label: m
                                                    }))
                                            })
                                        ]
                                    }),
                                    datePreset === "quarterly" && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "0.4rem",
                                            minWidth: "100px",
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                style: {
                                                    fontSize: "0.7rem",
                                                    color: "#64748b",
                                                    fontWeight: 700,
                                                    textTransform: "uppercase"
                                                },
                                                children: "Quarter"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                id: "quarter-preset",
                                                value: selectedQuarter,
                                                onChange: handleQuarterChange,
                                                options: [
                                                    "Q1 (Jan-Mar)",
                                                    "Q2 (Apr-Jun)",
                                                    "Q3 (Jul-Sep)",
                                                    "Q4 (Oct-Dec)"
                                                ].map((q, i)=>({
                                                        value: i.toString(),
                                                        label: q
                                                    }))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "0.4rem",
                                            minWidth: "120px",
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                style: {
                                                    fontSize: "0.7rem",
                                                    color: "#64748b",
                                                    fontWeight: 700,
                                                    textTransform: "uppercase"
                                                },
                                                children: "From Date"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e5a100bdab37c2de$export$5109c6dd95d8fb00), {
                                                selected: dateFrom ? new Date(dateFrom) : null,
                                                onChange: (d)=>{
                                                    if (d) {
                                                        const yy = d.getFullYear();
                                                        const mm = String(d.getMonth() + 1).padStart(2, '0');
                                                        const dd = String(d.getDate()).padStart(2, '0');
                                                        setDateFrom(`${yy}-${mm}-${dd}`);
                                                    } else setDateFrom("");
                                                    setDatePreset("custom");
                                                },
                                                dateFormat: "dd-MM-yyyy",
                                                className: "custom-datepicker",
                                                placeholderText: "dd-mm-yyyy"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "0.4rem",
                                            minWidth: "120px",
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                style: {
                                                    fontSize: "0.7rem",
                                                    color: "#64748b",
                                                    fontWeight: 700,
                                                    textTransform: "uppercase"
                                                },
                                                children: "To Date"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e5a100bdab37c2de$export$5109c6dd95d8fb00), {
                                                selected: dateTo ? new Date(dateTo) : null,
                                                onChange: (d)=>{
                                                    if (d) {
                                                        const yy = d.getFullYear();
                                                        const mm = String(d.getMonth() + 1).padStart(2, '0');
                                                        const dd = String(d.getDate()).padStart(2, '0');
                                                        setDateTo(`${yy}-${mm}-${dd}`);
                                                    } else setDateTo("");
                                                    setDatePreset("custom");
                                                },
                                                dateFormat: "dd-MM-yyyy",
                                                className: "custom-datepicker",
                                                placeholderText: "dd-mm-yyyy"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                style: {
                                    width: "1px",
                                    background: "#e2e8f0",
                                    display: "none"
                                },
                                className: "divider"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("style", {
                                children: `@media (min-width: 1024px) { .divider { display: block !important; } }`
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                style: {
                                    display: "flex",
                                    gap: "1rem",
                                    flex: "1.5 1 auto",
                                    flexWrap: "wrap"
                                },
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $0377fbce5921ee00$export$b3eb1a6c17723c14), {
                                    idPrefix: "reports-hub",
                                    district: districtFilter,
                                    mandal: mandalFilter,
                                    village: villageFilter,
                                    onDistrictChange: (d)=>{
                                        setDistrictFilter(d);
                                        setMandalFilter("");
                                        setVillageFilter("");
                                    },
                                    onMandalChange: (m)=>{
                                        setMandalFilter(m);
                                        setVillageFilter("");
                                    },
                                    onVillageChange: setVillageFilter
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "hide-scroll",
                style: {
                    display: "flex",
                    gap: "1.5rem",
                    overflowX: "auto",
                    borderBottom: "1px solid #e2e8f0",
                    marginBottom: "1.25rem",
                    flexShrink: 0
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("style", {
                        children: `.hide-scroll::-webkit-scrollbar { display: none; } .hide-scroll { -ms-overflow-style: none; scrollbar-width: none; }`
                    }),
                    $48e2a2c54694d2c7$var$MODULES.map((m)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            onClick: ()=>{
                                setActiveModule(m.id);
                                setStatusFilter("ALL");
                            },
                            style: {
                                background: "transparent",
                                border: "none",
                                borderBottom: activeModule === m.id ? "3px solid #3b82f6" : "3px solid transparent",
                                padding: "0 0.25rem 0.75rem",
                                color: activeModule === m.id ? "#1e293b" : "#64748b",
                                fontWeight: activeModule === m.id ? 600 : 500,
                                fontSize: "0.9rem",
                                cursor: "pointer",
                                whiteSpace: "nowrap",
                                transition: "all 0.2s"
                            },
                            children: m.title
                        }, m.id))
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "1.25rem",
                    flex: 1,
                    minHeight: 0,
                    paddingBottom: "1rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "1.25rem",
                            flexShrink: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "report-kpi-grid",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($48e2a2c54694d2c7$var$KpiWidget, {
                                        title: currentReportData.kpis.totalLabel || "Total Records",
                                        value: currentReportData.kpis.total,
                                        color: currentReportData.kpis.totalColor || "#0f172a",
                                        variant: "hero"
                                    }),
                                    currentReportData.kpis.metric1?.label ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($48e2a2c54694d2c7$var$KpiWidget, {
                                        title: currentReportData.kpis.metric1.label,
                                        value: currentReportData.kpis.metric1.val,
                                        color: currentReportData.kpis.metric1.color || "#10b981",
                                        badge: currentReportData.kpis.metric1.badge
                                    }) : null,
                                    currentReportData.kpis.metric2?.label ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($48e2a2c54694d2c7$var$KpiWidget, {
                                        title: currentReportData.kpis.metric2.label,
                                        value: currentReportData.kpis.metric2.val,
                                        color: currentReportData.kpis.metric2.color || "#ef4444",
                                        badge: currentReportData.kpis.metric2.badge
                                    }) : null,
                                    currentReportData.kpis.metric3?.label ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($48e2a2c54694d2c7$var$KpiWidget, {
                                        title: currentReportData.kpis.metric3.label,
                                        value: currentReportData.kpis.metric3.val,
                                        color: currentReportData.kpis.metric3.color || "#f59e0b",
                                        badge: currentReportData.kpis.metric3.badge
                                    }) : null,
                                    currentReportData.kpis.metric4?.label ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($48e2a2c54694d2c7$var$KpiWidget, {
                                        title: currentReportData.kpis.metric4.label,
                                        value: currentReportData.kpis.metric4.val,
                                        color: currentReportData.kpis.metric4.color || "#8b5cf6",
                                        badge: currentReportData.kpis.metric4.badge
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    gap: "1.25rem",
                                    height: "250px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        style: {
                                            flex: 1.1
                                        },
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($48e2a2c54694d2c7$var$PieChart, {
                                            title: currentReportData.pieTitle,
                                            data: currentReportData.donutData
                                        })
                                    }),
                                    currentReportData.funnelData && currentReportData.funnelData.length > 0 && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        style: {
                                            flex: 1
                                        },
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($48e2a2c54694d2c7$var$FunnelChart, {
                                            title: "Lead Conversion Pipeline",
                                            data: currentReportData.funnelData
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        style: {
                                            flex: 1.3
                                        },
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($48e2a2c54694d2c7$var$HorizontalBarChart, {
                                            title: currentReportData.barTitle,
                                            data: currentReportData.barData
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        style: {
                            background: "#fff",
                            borderRadius: "8px",
                            display: "flex",
                            flexDirection: "column",
                            flex: 1,
                            minHeight: "350px",
                            boxShadow: $48e2a2c54694d2c7$var$modernShadow,
                            border: "1px solid #f1f5f9"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                style: {
                                    padding: "1rem 1.25rem",
                                    borderBottom: "1px solid #e2e8f0"
                                },
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                    style: {
                                        margin: 0,
                                        fontSize: "0.85rem",
                                        fontWeight: 600,
                                        color: "#334155"
                                    },
                                    children: "Matrix Details"
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                style: {
                                    overflow: "auto",
                                    flex: 1
                                },
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                    style: {
                                        width: "100%",
                                        borderCollapse: "collapse",
                                        textAlign: "left",
                                        fontSize: "0.8rem"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                            style: {
                                                position: "sticky",
                                                top: 0,
                                                background: "#f8fafc",
                                                zIndex: 10
                                            },
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                                children: currentReportData.headers.map((h, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        style: {
                                                            padding: "0.75rem 1.25rem",
                                                            color: "#475569",
                                                            fontWeight: 600,
                                                            textTransform: "uppercase",
                                                            letterSpacing: "0.5px",
                                                            fontSize: "0.75rem",
                                                            borderBottom: "1px solid #e2e8f0",
                                                            whiteSpace: "nowrap"
                                                        },
                                                        children: h
                                                    }, i))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                            children: paginatedRows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    colSpan: currentReportData.headers.length,
                                                    style: {
                                                        padding: "3rem",
                                                        textAlign: "center",
                                                        color: "#94a3b8"
                                                    },
                                                    children: "(Blank)"
                                                })
                                            }) : paginatedRows.map((row, rIdx)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                                    style: {
                                                        borderBottom: "1px solid #f1f5f9",
                                                        transition: "background 0.15s"
                                                    },
                                                    onMouseOver: (e)=>e.currentTarget.style.background = "#f8fafc",
                                                    onMouseOut: (e)=>e.currentTarget.style.background = "transparent",
                                                    children: row.map((cell, cIdx)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            style: {
                                                                padding: "0.75rem 1.25rem",
                                                                color: "#475569",
                                                                whiteSpace: "nowrap"
                                                            },
                                                            children: cell
                                                        }, cIdx))
                                                }, rIdx))
                                        })
                                    ]
                                })
                            }),
                            currentReportData.rows.length > 0 && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "0.75rem 1.25rem",
                                    borderTop: "1px solid #e2e8f0",
                                    background: "#f8fafc",
                                    borderRadius: "0 0 8px 8px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                        style: {
                                            fontSize: "0.8rem",
                                            color: "#64748b"
                                        },
                                        children: [
                                            "Showing ",
                                            (currentPage - 1) * pageSize + 1,
                                            " to ",
                                            Math.min(currentPage * pageSize, currentReportData.rows.length),
                                            " of ",
                                            currentReportData.rows.length,
                                            " entries"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            gap: "0.5rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                disabled: currentPage === 1,
                                                onClick: ()=>setCurrentPage((p)=>p - 1),
                                                style: {
                                                    padding: "0.35rem 0.75rem",
                                                    border: "1px solid #cbd5e1",
                                                    background: currentPage === 1 ? "#f1f5f9" : "#fff",
                                                    color: currentPage === 1 ? "#94a3b8" : "#334155",
                                                    borderRadius: "6px",
                                                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                                                    fontSize: "0.8rem",
                                                    fontWeight: 500
                                                },
                                                children: "Previous"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                disabled: currentPage === totalPages,
                                                onClick: ()=>setCurrentPage((p)=>p + 1),
                                                style: {
                                                    padding: "0.35rem 0.75rem",
                                                    border: "1px solid #cbd5e1",
                                                    background: currentPage === totalPages ? "#f1f5f9" : "#fff",
                                                    color: currentPage === totalPages ? "#94a3b8" : "#334155",
                                                    borderRadius: "6px",
                                                    cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                                                    fontSize: "0.8rem",
                                                    fontWeight: 500
                                                },
                                                children: "Next"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");




var $7UyaH = parcelRequire("7UyaH");







async function $a963053b23bbe36c$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
async function $a963053b23bbe36c$export$43fefe6ead983557(file) {
    const fd = new FormData();
    fd.append("file", file);
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/leads/pdf-text`, {
        method: "POST",
        body: fd
    });
    if (!res.ok) throw new Error(await $a963053b23bbe36c$var$parseError(res));
    const j = await res.json();
    return j.text ?? "";
}






const $4d458044ff7299c6$var$APP_CELL = /^(\d+)\s+(\d+\/\d+|\d{4,})$/;
const $4d458044ff7299c6$var$APP_CELL_SLASH_ONLY = /^(\d+\/\d+)$/;
function $4d458044ff7299c6$var$splitLineToCells(line) {
    const t = line.trim();
    if (!t) return [];
    if (t.includes("\t")) return t.split("\t").map((c)=>c.trim());
    return t.split(/\s{2,}/).map((c)=>c.trim()).filter(Boolean);
}
/**
 * PDFs often split "57" and "279505/1563504" into two cells — merge back for app detection.
 * Also merge "148" + "1002205" (no slash in second part).
 */ function $4d458044ff7299c6$var$mergeSplitApplicationCells(cells) {
    const out = [];
    let i = 0;
    while(i < cells.length){
        const a = cells[i] ?? "";
        const b = cells[i + 1] ?? "";
        if (/^\d+$/.test(a) && /^\d+\/\d+/.test(b)) {
            out.push(`${a} ${b}`.trim());
            i += 2;
            continue;
        }
        if (/^\d+$/.test(a) && /^\d{5,}$/.test(b) && !b.includes("/")) {
            out.push(`${a} ${b}`.trim());
            i += 2;
            continue;
        }
        out.push(a);
        i += 1;
    }
    return out;
}
function $4d458044ff7299c6$var$findAppCellIndex(cells) {
    for(let i = 0; i < cells.length; i++){
        if ($4d458044ff7299c6$var$parseAppCell(cells[i])) return i;
        if (i + 1 < cells.length) {
            const joined = `${cells[i]} ${cells[i + 1]}`.trim();
            if ($4d458044ff7299c6$var$parseAppCell(joined)) return i;
        }
    }
    return -1;
}
function $4d458044ff7299c6$export$c2732a86a59b93fb(cell) {
    const t = cell.trim();
    const m1 = t.match($4d458044ff7299c6$var$APP_CELL);
    if (m1) return {
        serial: m1[1],
        applicationRef: m1[2]
    };
    const m2 = t.match($4d458044ff7299c6$var$APP_CELL_SLASH_ONLY);
    if (m2) return {
        serial: "0",
        applicationRef: m2[1]
    };
    return null;
}
function $4d458044ff7299c6$export$18ff105403df77a4(line) {
    const m = line.trim().match(/^District\s*[-–]\s*(.+)$/i);
    if (!m) return null;
    return $4d458044ff7299c6$export$16493bc9d946cb71(m[1]);
}
function $4d458044ff7299c6$export$16493bc9d946cb71(raw) {
    const label = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(String(raw ?? "").trim());
    if (!label) return null;
    for (const d of (0, $72c1e8625e9e63b5$export$c213a939d88ef2f8)){
        if ((0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(d.label) === label) return d.key;
        for (const ln of d.lines){
            if ((0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(ln) === label) return d.key;
        }
    }
    const compact = label.replace(/\s+/g, "");
    for (const d of (0, $72c1e8625e9e63b5$export$c213a939d88ef2f8)){
        if ((0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(d.label).replace(/\s+/g, "") === compact) return d.key;
    }
    return null;
}
function $4d458044ff7299c6$var$parseAppCell(cell) {
    return $4d458044ff7299c6$export$c2732a86a59b93fb(cell);
}
/**
 * Parse tabular text from TG-style PDF text extraction (e.g. Amrabad list).
 * Uses "District - …" lines when present; otherwise caller should pass default district for geo matching.
 */ /**
 * When a line has no tabs, try to split using "… serial appNo … name … mobile … aadhaar …".
 * Recovers many PDF.js extractions that glue columns with single spaces.
 */ function $4d458044ff7299c6$var$tryParseLeadLineLoose(line, ctx, geo, districtKey) {
    const t = line.trim();
    if (!t || t.includes("\t")) return null;
    const m = t.match(/^(?:(.*?)\s+)?(\d+)\s+(\d+\/\d+)\s+(.+?)\s+(\d[\d\s\-]{8,14}\d)\s+(\d[\d\s]{7,16}\d)(?:\s+(.*))?$/u);
    if (!m) {
        const m2 = t.match(/^(?:(.*?)\s+)?(\d+)\s+(\d{5,})\s+(.+?)\s+(\d[\d\s\-]{8,14}\d)\s+(\d[\d\s]{7,16}\d)(?:\s+(.*))?$/u);
        if (!m2) return null;
        const left = (m2[1] ?? "").trim();
        const serial = m2[2];
        const appRef = m2[3];
        const applicantName = m2[4].trim();
        const mobile = m2[5].replace(/\D/g, "").slice(0, 15);
        const aadhaarRaw = m2[6].replace(/\D/g, "").slice(0, 12);
        if (mobile.length < 10 || aadhaarRaw.length < 9) return null;
        const tail = (m2[7] ?? "").trim();
        return $4d458044ff7299c6$var$buildRowFromLeftAndApp(left, serial, appRef, applicantName, mobile, aadhaarRaw, tail, ctx, geo, districtKey);
    }
    const left = (m[1] ?? "").trim();
    const serial = m[2];
    const appRef = m[3];
    const applicantName = m[4].trim();
    const mobile = m[5].replace(/\D/g, "").slice(0, 15);
    const aadhaarRaw = m[6].replace(/\D/g, "").slice(0, 12);
    if (mobile.length < 10 || aadhaarRaw.length < 9) return null;
    const tail = (m[7] ?? "").trim();
    return $4d458044ff7299c6$var$buildRowFromLeftAndApp(left, serial, appRef, applicantName, mobile, aadhaarRaw, tail, ctx, geo, districtKey);
}
function $4d458044ff7299c6$var$buildRowFromLeftAndApp(left, serial, appRef, applicantName, mobile, aadhaarRaw, tail, ctx, geo, districtKey) {
    if (!applicantName || applicantName.length < 1) return null;
    let fileMandal = ctx.currentMandal;
    let fileVillage = ctx.currentVillage;
    const tokens = left.split(/\s+/).filter(Boolean);
    if (tokens.length >= 2 && geo && districtKey && (0, $72c1e8625e9e63b5$export$15dbe5472819b55d)(districtKey)) {
        const nm = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(tokens[0]);
        const hit = geo.tgMandalsForDistrict(districtKey).find((x)=>(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(x.mandalName) === nm);
        if (hit) {
            fileMandal = hit.mandalName;
            fileVillage = tokens.slice(1).join(" ").trim();
        } else if (left.trim()) fileVillage = left.trim();
    } else if (left.trim()) fileVillage = left.trim();
    if (!fileMandal || !fileVillage) return null;
    const listParts = tail.split(/\s+/);
    let listType = "\u2014";
    let applicationStatus = tail || "\u2014";
    const li = listParts.findIndex((x)=>/^list\s*\d*$/i.test(x));
    if (li >= 0) {
        listType = listParts.slice(li, li + 2).join(" ").replace(/\s+/g, " ").trim() || listParts[li];
        applicationStatus = listParts.slice(li + 2).join(" ").trim() || "\u2014";
    }
    return {
        fileMandal: fileMandal,
        fileVillage: fileVillage,
        applicantName: applicantName,
        mobile: mobile,
        aadhaarDigits: aadhaarRaw,
        applicationRef: appRef,
        applicationSerial: serial,
        listType: listType,
        applicationStatus: applicationStatus
    };
}
function $4d458044ff7299c6$export$4977f36add1cb0df(raw, opts) {
    const lines = raw.split(/\r?\n/);
    let districtKey = opts?.defaultDistrictKey ?? null;
    let currentMandal = "";
    let currentVillage = "";
    const rows = [];
    const geo = opts?.geo ?? null;
    const stats = {
        fileLineCount: lines.length,
        rowsAccepted: 0,
        skippedNoAppToken: 0,
        skippedNoMandalVillage: 0,
        skippedShortApplicant: 0,
        skippedRequiredBlank: 0,
        looseLineFallbacks: 0
    };
    const effectiveDistrictForGeo = ()=>{
        if (districtKey && (0, $72c1e8625e9e63b5$export$15dbe5472819b55d)(districtKey)) return districtKey;
        const d = opts?.defaultDistrictKey;
        return d && (0, $72c1e8625e9e63b5$export$15dbe5472819b55d)(d) ? d : null;
    };
    const mandalNameInDistrict = (name)=>{
        const dk = effectiveDistrictForGeo();
        if (!geo || !dk) return false;
        const nm = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(name);
        return geo.tgMandalsForDistrict(dk).some((m)=>(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(m.mandalName) === nm);
    };
    for (const line of lines){
        const t = line.trim();
        if (!t) continue;
        if (/^--\s*\d+\s+of\s+\d+\s*--$/i.test(t)) continue;
        if (/^Name of the Mandal/i.test(t)) continue;
        if (/^Sno\s+Application/i.test(t)) continue;
        const dk = $4d458044ff7299c6$export$18ff105403df77a4(t);
        if (dk) {
            districtKey = dk;
            continue;
        }
        let cells = $4d458044ff7299c6$var$mergeSplitApplicationCells($4d458044ff7299c6$var$splitLineToCells(t));
        let appIdx = $4d458044ff7299c6$var$findAppCellIndex(cells);
        if (appIdx < 0) {
            const loose = $4d458044ff7299c6$var$tryParseLeadLineLoose(t, {
                currentMandal: currentMandal,
                currentVillage: currentVillage
            }, geo, districtKey && (0, $72c1e8625e9e63b5$export$15dbe5472819b55d)(districtKey) ? districtKey : null);
            if (loose) {
                currentMandal = loose.fileMandal;
                currentVillage = loose.fileVillage;
                rows.push(loose);
                stats.looseLineFallbacks += 1;
            } else stats.skippedNoAppToken += 1;
            continue;
        }
        if (cells.length < 4) {
            stats.skippedNoAppToken += 1;
            continue;
        }
        const joinedAtIdx = $4d458044ff7299c6$export$c2732a86a59b93fb(cells[appIdx]) ? cells[appIdx] : `${cells[appIdx]} ${cells[appIdx + 1]}`.trim();
        const parsed = $4d458044ff7299c6$export$c2732a86a59b93fb(joinedAtIdx);
        if (!parsed) {
            stats.skippedNoAppToken += 1;
            continue;
        }
        if (joinedAtIdx !== cells[appIdx]) cells = [
            ...cells.slice(0, appIdx),
            joinedAtIdx,
            ...cells.slice(appIdx + 2)
        ];
        const applicantName = cells[appIdx + 1]?.trim() ?? "";
        const mobile = (cells[appIdx + 2] ?? "").replace(/\D/g, "").slice(0, 15);
        const aadhaarRaw = (cells[appIdx + 3] ?? "").replace(/\D/g, "").slice(0, 12);
        let listType = cells[appIdx + 4]?.trim() ?? "";
        let statusStart = appIdx + 5;
        if (listType && !/^list\s*\d/i.test(listType) && /^list$/i.test(listType) && cells[appIdx + 5] === "1") {
            listType = "List 1";
            statusStart = appIdx + 6;
        }
        const applicationStatus = cells.slice(statusStart).join(" ").trim();
        if (!applicantName || applicantName.length < 1) {
            stats.skippedShortApplicant += 1;
            continue;
        }
        if (!mobile || !aadhaarRaw || !listType || !applicationStatus || !effectiveDistrictForGeo()) {
            stats.skippedRequiredBlank += 1;
            continue;
        }
        const left = cells.slice(0, appIdx);
        if (left.length >= 2) {
            currentMandal = left[0].trim();
            currentVillage = left[1].trim();
        } else if (left.length === 1) {
            const token = left[0].trim();
            const dk = effectiveDistrictForGeo();
            if (geo && dk && mandalNameInDistrict(token)) currentMandal = geo.tgMandalsForDistrict(dk).find((m)=>(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(m.mandalName) === (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(token)).mandalName;
            else currentVillage = token;
        }
        if (!currentMandal || !currentVillage) {
            stats.skippedNoMandalVillage += 1;
            continue;
        }
        rows.push({
            fileMandal: currentMandal,
            fileVillage: currentVillage,
            applicantName: applicantName,
            mobile: mobile,
            aadhaarDigits: aadhaarRaw,
            applicationRef: parsed.applicationRef,
            applicationSerial: parsed.serial,
            listType: listType,
            applicationStatus: applicationStatus
        });
    }
    stats.rowsAccepted = rows.length;
    return {
        districtKey: districtKey,
        rows: rows,
        stats: stats
    };
}


/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported XLSX */ /*global process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */ var $38c758311cb94f73$exports = {};
"use strict";


var $7c3b72a365cc0275$require$Buffer = $38c758311cb94f73$exports.Buffer;
var $7c3b72a365cc0275$var$XLSX = {};
$7c3b72a365cc0275$var$XLSX.version = '0.18.5';
var $7c3b72a365cc0275$var$current_codepage = 1200, $7c3b72a365cc0275$var$current_ansi = 1252;
var $7c3b72a365cc0275$var$VALID_ANSI = [
    874,
    932,
    936,
    949,
    950,
    1250,
    1251,
    1252,
    1253,
    1254,
    1255,
    1256,
    1257,
    1258,
    10000
];
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */ var $7c3b72a365cc0275$var$CS2CP = {
    /*::[*/ 0: 1252,
    /* ANSI */ /*::[*/ 1: 65001,
    /* DEFAULT */ /*::[*/ 2: 65001,
    /* SYMBOL */ /*::[*/ 77: 10000,
    /* MAC */ /*::[*/ 128: 932,
    /* SHIFTJIS */ /*::[*/ 129: 949,
    /* HANGUL */ /*::[*/ 130: 1361,
    /* JOHAB */ /*::[*/ 134: 936,
    /* GB2312 */ /*::[*/ 136: 950,
    /* CHINESEBIG5 */ /*::[*/ 161: 1253,
    /* GREEK */ /*::[*/ 162: 1254,
    /* TURKISH */ /*::[*/ 163: 1258,
    /* VIETNAMESE */ /*::[*/ 177: 1255,
    /* HEBREW */ /*::[*/ 178: 1256,
    /* ARABIC */ /*::[*/ 186: 1257,
    /* BALTIC */ /*::[*/ 204: 1251,
    /* RUSSIAN */ /*::[*/ 222: 874,
    /* THAI */ /*::[*/ 238: 1250,
    /* EASTEUROPE */ /*::[*/ 255: 1252,
    /* OEM */ /*::[*/ 69: 6969 /* MISC */ 
} /*:any*/ ;
var $7c3b72a365cc0275$var$set_ansi = function(cp /*:number*/ ) {
    if ($7c3b72a365cc0275$var$VALID_ANSI.indexOf(cp) == -1) return;
    $7c3b72a365cc0275$var$current_ansi = $7c3b72a365cc0275$var$CS2CP[0] = cp;
};
function $7c3b72a365cc0275$var$reset_ansi() {
    $7c3b72a365cc0275$var$set_ansi(1252);
}
var $7c3b72a365cc0275$var$set_cp = function(cp /*:number*/ ) {
    $7c3b72a365cc0275$var$current_codepage = cp;
    $7c3b72a365cc0275$var$set_ansi(cp);
};
function $7c3b72a365cc0275$var$reset_cp() {
    $7c3b72a365cc0275$var$set_cp(1200);
    $7c3b72a365cc0275$var$reset_ansi();
}
function $7c3b72a365cc0275$var$char_codes(data /*:string*/ ) /*:Array<number>*/ {
    var o /*:Array<number>*/  = [];
    for(var i = 0, len = data.length; i < len; ++i)o[i] = data.charCodeAt(i);
    return o;
}
function $7c3b72a365cc0275$var$utf16leread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i) + (data.charCodeAt(2 * i + 1) << 8));
    return o.join("");
}
function $7c3b72a365cc0275$var$utf16beread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i + 1) + (data.charCodeAt(2 * i) << 8));
    return o.join("");
}
var $7c3b72a365cc0275$var$debom = function(data /*:string*/ ) /*:string*/ {
    var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
    if (c1 == 0xFF && c2 == 0xFE) return $7c3b72a365cc0275$var$utf16leread(data.slice(2));
    if (c1 == 0xFE && c2 == 0xFF) return $7c3b72a365cc0275$var$utf16beread(data.slice(2));
    if (c1 == 0xFEFF) return data.slice(1);
    return data;
};
var $7c3b72a365cc0275$var$_getchar = function _gc1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var $7c3b72a365cc0275$var$_getansi = function _ga1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var $7c3b72a365cc0275$var$$cptable;
function $7c3b72a365cc0275$export$58f247d16f363b86(cptable) {
    $7c3b72a365cc0275$var$$cptable = cptable;
    $7c3b72a365cc0275$var$set_cp = function(cp /*:number*/ ) {
        $7c3b72a365cc0275$var$current_codepage = cp;
        $7c3b72a365cc0275$var$set_ansi(cp);
    };
    $7c3b72a365cc0275$var$debom = function(data /*:string*/ ) {
        if (data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) return $7c3b72a365cc0275$var$$cptable.utils.decode(1200, $7c3b72a365cc0275$var$char_codes(data.slice(2)));
        return data;
    };
    $7c3b72a365cc0275$var$_getchar = function _gc2(x /*:number*/ ) /*:string*/ {
        if ($7c3b72a365cc0275$var$current_codepage === 1200) return String.fromCharCode(x);
        return $7c3b72a365cc0275$var$$cptable.utils.decode($7c3b72a365cc0275$var$current_codepage, [
            x & 255,
            x >> 8
        ])[0];
    };
    $7c3b72a365cc0275$var$_getansi = function _ga2(x /*:number*/ ) /*:string*/ {
        return $7c3b72a365cc0275$var$$cptable.utils.decode($7c3b72a365cc0275$var$current_ansi, [
            x
        ])[0];
    };
    $7c3b72a365cc0275$var$cpdoit();
}
var $7c3b72a365cc0275$var$DENSE = null;
var $7c3b72a365cc0275$var$DIF_XL = true;
var $7c3b72a365cc0275$var$Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function $7c3b72a365cc0275$var$Base64_encode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $7c3b72a365cc0275$var$Base64_map.charAt(e1) + $7c3b72a365cc0275$var$Base64_map.charAt(e2) + $7c3b72a365cc0275$var$Base64_map.charAt(e3) + $7c3b72a365cc0275$var$Base64_map.charAt(e4);
    }
    return o;
}
function $7c3b72a365cc0275$var$Base64_decode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    input = input.replace(/[^\w\+\/\=]/g, "");
    for(var i = 0; i < input.length;){
        e1 = $7c3b72a365cc0275$var$Base64_map.indexOf(input.charAt(i++));
        e2 = $7c3b72a365cc0275$var$Base64_map.indexOf(input.charAt(i++));
        c1 = e1 << 2 | e2 >> 4;
        o += String.fromCharCode(c1);
        e3 = $7c3b72a365cc0275$var$Base64_map.indexOf(input.charAt(i++));
        c2 = (e2 & 15) << 4 | e3 >> 2;
        if (e3 !== 64) o += String.fromCharCode(c2);
        e4 = $7c3b72a365cc0275$var$Base64_map.indexOf(input.charAt(i++));
        c3 = (e3 & 3) << 6 | e4;
        if (e4 !== 64) o += String.fromCharCode(c3);
    }
    return o;
}
var $7c3b72a365cc0275$var$has_buf = /*#__PURE__*/ function() {
    return typeof $7c3b72a365cc0275$require$Buffer !== 'undefined' && false;
}();
var $7c3b72a365cc0275$var$Buffer_from = /*#__PURE__*/ function() {
    if (typeof $7c3b72a365cc0275$require$Buffer !== 'undefined') {
        var nbfs = !$7c3b72a365cc0275$require$Buffer.from;
        if (!nbfs) try {
            $7c3b72a365cc0275$require$Buffer.from("foo", "utf8");
        } catch (e) {
            nbfs = true;
        }
        return nbfs ? function(buf, enc) {
            return enc ? new $7c3b72a365cc0275$require$Buffer(buf, enc) : new $7c3b72a365cc0275$require$Buffer(buf);
        } : $7c3b72a365cc0275$require$Buffer.from.bind($7c3b72a365cc0275$require$Buffer);
    }
    return function() {};
}();
function $7c3b72a365cc0275$var$new_raw_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($7c3b72a365cc0275$var$has_buf) return $7c3b72a365cc0275$require$Buffer.alloc ? $7c3b72a365cc0275$require$Buffer.alloc(len) : new $7c3b72a365cc0275$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
function $7c3b72a365cc0275$var$new_unsafe_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($7c3b72a365cc0275$var$has_buf) return $7c3b72a365cc0275$require$Buffer.allocUnsafe ? $7c3b72a365cc0275$require$Buffer.allocUnsafe(len) : new $7c3b72a365cc0275$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
var $7c3b72a365cc0275$var$s2a = function s2a(s /*:string*/ ) /*:any*/ {
    if ($7c3b72a365cc0275$var$has_buf) return $7c3b72a365cc0275$var$Buffer_from(s, "binary");
    return s.split("").map(function(x /*:string*/ ) /*:number*/ {
        return x.charCodeAt(0) & 0xff;
    });
};
function $7c3b72a365cc0275$var$s2ab(s /*:string*/ ) /*:any*/ {
    if (typeof ArrayBuffer === 'undefined') return $7c3b72a365cc0275$var$s2a(s);
    var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
    for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}
function $7c3b72a365cc0275$var$a2s(data /*:any*/ ) /*:string*/ {
    if (Array.isArray(data)) return data.map(function(c) {
        return String.fromCharCode(c);
    }).join("");
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length; ++i)o[i] = String.fromCharCode(data[i]);
    return o.join("");
}
function $7c3b72a365cc0275$var$a2u(data /*:Array<number>*/ ) /*:Uint8Array*/ {
    if (typeof Uint8Array === 'undefined') throw new Error("Unsupported");
    return new Uint8Array(data);
}
function $7c3b72a365cc0275$var$ab2a(data /*:ArrayBuffer|Uint8Array*/ ) /*:Array<number>*/ {
    if (typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
    if (data instanceof ArrayBuffer) return $7c3b72a365cc0275$var$ab2a(new Uint8Array(data));
    /*:: if(data instanceof ArrayBuffer) throw new Error("unreachable"); */ var o = new Array(data.length);
    for(var i = 0; i < data.length; ++i)o[i] = data[i];
    return o;
}
var $7c3b72a365cc0275$var$bconcat = $7c3b72a365cc0275$var$has_buf ? function(bufs) {
    return $7c3b72a365cc0275$require$Buffer.concat(bufs.map(function(buf) {
        return $7c3b72a365cc0275$require$Buffer.isBuffer(buf) ? buf : $7c3b72a365cc0275$var$Buffer_from(buf);
    }));
} : function(bufs) {
    if (typeof Uint8Array !== "undefined") {
        var i = 0, maxlen = 0;
        for(i = 0; i < bufs.length; ++i)maxlen += bufs[i].length;
        var o = new Uint8Array(maxlen);
        var len = 0;
        for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i){
            len = bufs[i].length;
            if (bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
            else if (typeof bufs[i] == "string") throw "wtf";
            else o.set(new Uint8Array(bufs[i]), maxlen);
        }
        return o;
    }
    return [].concat.apply([], bufs.map(function(buf) {
        return Array.isArray(buf) ? buf : [].slice.call(buf);
    }));
};
function $7c3b72a365cc0275$var$utf8decode(content /*:string*/ ) {
    var out = [], widx = 0, L = content.length + 250;
    var o = $7c3b72a365cc0275$var$new_raw_buf(content.length + 255);
    for(var ridx = 0; ridx < content.length; ++ridx){
        var c = content.charCodeAt(ridx);
        if (c < 0x80) o[widx++] = c;
        else if (c < 0x800) {
            o[widx++] = 192 | c >> 6 & 31;
            o[widx++] = 128 | c & 63;
        } else if (c >= 0xD800 && c < 0xE000) {
            c = (c & 1023) + 64;
            var d = content.charCodeAt(++ridx) & 1023;
            o[widx++] = 240 | c >> 8 & 7;
            o[widx++] = 128 | c >> 2 & 63;
            o[widx++] = 128 | d >> 6 & 15 | (c & 3) << 4;
            o[widx++] = 128 | d & 63;
        } else {
            o[widx++] = 224 | c >> 12 & 15;
            o[widx++] = 128 | c >> 6 & 63;
            o[widx++] = 128 | c & 63;
        }
        if (widx > L) {
            out.push(o.slice(0, widx));
            widx = 0;
            o = $7c3b72a365cc0275$var$new_raw_buf(65535);
            L = 65530;
        }
    }
    out.push(o.slice(0, widx));
    return $7c3b72a365cc0275$var$bconcat(out);
}
var $7c3b72a365cc0275$var$chr0 = /\u0000/g, $7c3b72a365cc0275$var$chr1 = /[\u0001-\u0006]/g;
/*::
declare type Block = any;
declare type BufArray = {
	newblk(sz:number):Block;
	next(sz:number):Block;
	end():any;
	push(buf:Block):void;
};

type RecordHopperCB = {(d:any, Rn:string, RT:number):?boolean;};

type EvertType = {[string]:string};
type EvertNumType = {[string]:number};
type EvertArrType = {[string]:Array<string>};

type StringConv = {(string):string};

*/ /* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W041 */ function $7c3b72a365cc0275$var$_strrev(x /*:string*/ ) /*:string*/ {
    var o = "", i = x.length - 1;
    while(i >= 0)o += x.charAt(i--);
    return o;
}
function $7c3b72a365cc0275$var$pad0(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $7c3b72a365cc0275$var$fill('0', d - t.length) + t;
}
function $7c3b72a365cc0275$var$pad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $7c3b72a365cc0275$var$fill(' ', d - t.length) + t;
}
function $7c3b72a365cc0275$var$rpad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : t + $7c3b72a365cc0275$var$fill(' ', d - t.length);
}
function $7c3b72a365cc0275$var$pad0r1(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + Math.round(v);
    return t.length >= d ? t : $7c3b72a365cc0275$var$fill('0', d - t.length) + t;
}
function $7c3b72a365cc0275$var$pad0r2(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $7c3b72a365cc0275$var$fill('0', d - t.length) + t;
}
var $7c3b72a365cc0275$var$p2_32 = /*#__PURE__*/ Math.pow(2, 32);
function $7c3b72a365cc0275$var$pad0r(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    if (v > $7c3b72a365cc0275$var$p2_32 || v < -$7c3b72a365cc0275$var$p2_32) return $7c3b72a365cc0275$var$pad0r1(v, d);
    var i = Math.round(v);
    return $7c3b72a365cc0275$var$pad0r2(i, d);
}
/* yes, in 2022 this is still faster than string compare */ function $7c3b72a365cc0275$var$SSF_isgeneral(s /*:string*/ , i /*:?number*/ ) /*:boolean*/ {
    i = i || 0;
    return s.length >= 7 + i && (s.charCodeAt(i) | 32) === 103 && (s.charCodeAt(i + 1) | 32) === 101 && (s.charCodeAt(i + 2) | 32) === 110 && (s.charCodeAt(i + 3) | 32) === 101 && (s.charCodeAt(i + 4) | 32) === 114 && (s.charCodeAt(i + 5) | 32) === 97 && (s.charCodeAt(i + 6) | 32) === 108;
}
var $7c3b72a365cc0275$var$days /*:Array<Array<string> >*/  = [
    [
        'Sun',
        'Sunday'
    ],
    [
        'Mon',
        'Monday'
    ],
    [
        'Tue',
        'Tuesday'
    ],
    [
        'Wed',
        'Wednesday'
    ],
    [
        'Thu',
        'Thursday'
    ],
    [
        'Fri',
        'Friday'
    ],
    [
        'Sat',
        'Saturday'
    ]
];
var $7c3b72a365cc0275$var$months /*:Array<Array<string> >*/  = [
    [
        'J',
        'Jan',
        'January'
    ],
    [
        'F',
        'Feb',
        'February'
    ],
    [
        'M',
        'Mar',
        'March'
    ],
    [
        'A',
        'Apr',
        'April'
    ],
    [
        'M',
        'May',
        'May'
    ],
    [
        'J',
        'Jun',
        'June'
    ],
    [
        'J',
        'Jul',
        'July'
    ],
    [
        'A',
        'Aug',
        'August'
    ],
    [
        'S',
        'Sep',
        'September'
    ],
    [
        'O',
        'Oct',
        'October'
    ],
    [
        'N',
        'Nov',
        'November'
    ],
    [
        'D',
        'Dec',
        'December'
    ]
];
function $7c3b72a365cc0275$var$SSF_init_table(t /*:any*/ ) {
    if (!t) t = {};
    t[0] = 'General';
    t[1] = '0';
    t[2] = '0.00';
    t[3] = '#,##0';
    t[4] = '#,##0.00';
    t[9] = '0%';
    t[10] = '0.00%';
    t[11] = '0.00E+00';
    t[12] = '# ?/?';
    t[13] = '# ??/??';
    t[14] = 'm/d/yy';
    t[15] = 'd-mmm-yy';
    t[16] = 'd-mmm';
    t[17] = 'mmm-yy';
    t[18] = 'h:mm AM/PM';
    t[19] = 'h:mm:ss AM/PM';
    t[20] = 'h:mm';
    t[21] = 'h:mm:ss';
    t[22] = 'm/d/yy h:mm';
    t[37] = '#,##0 ;(#,##0)';
    t[38] = '#,##0 ;[Red](#,##0)';
    t[39] = '#,##0.00;(#,##0.00)';
    t[40] = '#,##0.00;[Red](#,##0.00)';
    t[45] = 'mm:ss';
    t[46] = '[h]:mm:ss';
    t[47] = 'mmss.0';
    t[48] = '##0.0E+0';
    t[49] = '@';
    t[56] = '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "';
    return t;
}
/* repeated to satiate webpack */ var $7c3b72a365cc0275$var$table_fmt = {
    0: 'General',
    1: '0',
    2: '0.00',
    3: '#,##0',
    4: '#,##0.00',
    9: '0%',
    10: '0.00%',
    11: '0.00E+00',
    12: '# ?/?',
    13: '# ??/??',
    14: 'm/d/yy',
    15: 'd-mmm-yy',
    16: 'd-mmm',
    17: 'mmm-yy',
    18: 'h:mm AM/PM',
    19: 'h:mm:ss AM/PM',
    20: 'h:mm',
    21: 'h:mm:ss',
    22: 'm/d/yy h:mm',
    37: '#,##0 ;(#,##0)',
    38: '#,##0 ;[Red](#,##0)',
    39: '#,##0.00;(#,##0.00)',
    40: '#,##0.00;[Red](#,##0.00)',
    45: 'mm:ss',
    46: '[h]:mm:ss',
    47: 'mmss.0',
    48: '##0.0E+0',
    49: '@',
    56: '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "'
};
/* Defaults determined by systematically testing in Excel 2019 */ /* These formats appear to default to other formats in the table */ var $7c3b72a365cc0275$var$SSF_default_map = {
    5: 37,
    6: 38,
    7: 39,
    8: 40,
    23: 0,
    24: 0,
    25: 0,
    26: 0,
    27: 14,
    28: 14,
    29: 14,
    30: 14,
    31: 14,
    50: 14,
    51: 14,
    52: 14,
    53: 14,
    54: 14,
    55: 14,
    56: 14,
    57: 14,
    58: 14,
    59: 1,
    60: 2,
    61: 3,
    62: 4,
    67: 9,
    68: 10,
    69: 12,
    70: 13,
    71: 14,
    72: 14,
    73: 15,
    74: 16,
    75: 17,
    76: 20,
    77: 21,
    78: 22,
    79: 45,
    80: 46,
    81: 47,
    82: 0 // 82 ->  0 ... 65536 -> 0 (omitted)
};
/* These formats technically refer to Accounting formats with no equivalent */ var $7c3b72a365cc0275$var$SSF_default_str = {
    //  5 -- Currency,   0 decimal, black negative
    5: '"$"#,##0_);\\("$"#,##0\\)',
    63: '"$"#,##0_);\\("$"#,##0\\)',
    //  6 -- Currency,   0 decimal, red   negative
    6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    //  7 -- Currency,   2 decimal, black negative
    7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    //  8 -- Currency,   2 decimal, red   negative
    8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    // 41 -- Accounting, 0 decimal, No Symbol
    41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
    // 42 -- Accounting, 0 decimal, $  Symbol
    42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
    // 43 -- Accounting, 2 decimal, No Symbol
    43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
    // 44 -- Accounting, 2 decimal, $  Symbol
    44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function $7c3b72a365cc0275$var$SSF_frac(x /*:number*/ , D /*:number*/ , mixed /*:?boolean*/ ) /*:Array<number>*/ {
    var sgn = x < 0 ? -1 : 1;
    var B = x * sgn;
    var P_2 = 0, P_1 = 1, P = 0;
    var Q_2 = 1, Q_1 = 0, Q = 0;
    var A = Math.floor(B);
    while(Q_1 < D){
        A = Math.floor(B);
        P = A * P_1 + P_2;
        Q = A * Q_1 + Q_2;
        if (B - A < 0.00000005) break;
        B = 1 / (B - A);
        P_2 = P_1;
        P_1 = P;
        Q_2 = Q_1;
        Q_1 = Q;
    }
    if (Q > D) {
        if (Q_1 > D) {
            Q = Q_2;
            P = P_2;
        } else {
            Q = Q_1;
            P = P_1;
        }
    }
    if (!mixed) return [
        0,
        sgn * P,
        Q
    ];
    var q = Math.floor(sgn * P / Q);
    return [
        q,
        sgn * P - q * Q,
        Q
    ];
}
function $7c3b72a365cc0275$var$SSF_parse_date_code(v /*:number*/ , opts /*:?any*/ , b2 /*:?boolean*/ ) {
    if (v > 2958465 || v < 0) return null;
    var date = v | 0, time = Math.floor(86400 * (v - date)), dow = 0;
    var dout = [];
    var out = {
        D: date,
        T: time,
        u: 86400 * (v - date) - time,
        y: 0,
        m: 0,
        d: 0,
        H: 0,
        M: 0,
        S: 0,
        q: 0
    };
    if (Math.abs(out.u) < 1e-6) out.u = 0;
    if (opts && opts.date1904) date += 1462;
    if (out.u > 0.9999) {
        out.u = 0;
        if (++time == 86400) {
            out.T = time = 0;
            ++date;
            ++out.D;
        }
    }
    if (date === 60) {
        dout = b2 ? [
            1317,
            10,
            29
        ] : [
            1900,
            2,
            29
        ];
        dow = 3;
    } else if (date === 0) {
        dout = b2 ? [
            1317,
            8,
            29
        ] : [
            1900,
            1,
            0
        ];
        dow = 6;
    } else {
        if (date > 60) --date;
        /* 1 = Jan 1 1900 in Gregorian */ var d = new Date(1900, 0, 1);
        d.setDate(d.getDate() + date - 1);
        dout = [
            d.getFullYear(),
            d.getMonth() + 1,
            d.getDate()
        ];
        dow = d.getDay();
        if (date < 60) dow = (dow + 6) % 7;
        if (b2) dow = $7c3b72a365cc0275$var$SSF_fix_hijri(d, dout);
    }
    out.y = dout[0];
    out.m = dout[1];
    out.d = dout[2];
    out.S = time % 60;
    time = Math.floor(time / 60);
    out.M = time % 60;
    time = Math.floor(time / 60);
    out.H = time;
    out.q = dow;
    return out;
}
var $7c3b72a365cc0275$var$SSFbasedate = /*#__PURE__*/ new Date(1899, 11, 31, 0, 0, 0);
var $7c3b72a365cc0275$var$SSFdnthresh = /*#__PURE__*/ $7c3b72a365cc0275$var$SSFbasedate.getTime();
var $7c3b72a365cc0275$var$SSFbase1904 = /*#__PURE__*/ new Date(1900, 2, 1, 0, 0, 0);
function $7c3b72a365cc0275$var$datenum_local(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    if (date1904) epoch -= 126230400000;
    else if (v >= $7c3b72a365cc0275$var$SSFbase1904) epoch += 86400000;
    return (epoch - ($7c3b72a365cc0275$var$SSFdnthresh + /*#__PURE__*/ (v.getTimezoneOffset() - /*#__PURE__*/ $7c3b72a365cc0275$var$SSFbasedate.getTimezoneOffset()) * 60000)) / 86400000;
}
/* ECMA-376 18.8.30 numFmt*/ /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */ /* exponent >= -9 and <= 9 */ function $7c3b72a365cc0275$var$SSF_strip_decimal(o /*:string*/ ) /*:string*/ {
    return o.indexOf(".") == -1 ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
/* General Exponential always shows 2 digits exp and trims the mantissa */ function $7c3b72a365cc0275$var$SSF_normalize_exp(o /*:string*/ ) /*:string*/ {
    if (o.indexOf("E") == -1) return o;
    return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
/* exponent >= -9 and <= 9 */ function $7c3b72a365cc0275$var$SSF_small_exp(v /*:number*/ ) /*:string*/ {
    var w = v < 0 ? 12 : 11;
    var o = $7c3b72a365cc0275$var$SSF_strip_decimal(v.toFixed(12));
    if (o.length <= w) return o;
    o = v.toPrecision(10);
    if (o.length <= w) return o;
    return v.toExponential(5);
}
/* exponent >= 11 or <= -10 likely exponential */ function $7c3b72a365cc0275$var$SSF_large_exp(v /*:number*/ ) /*:string*/ {
    var o = $7c3b72a365cc0275$var$SSF_strip_decimal(v.toFixed(11));
    return o.length > (v < 0 ? 12 : 11) || o === "0" || o === "-0" ? v.toPrecision(6) : o;
}
function $7c3b72a365cc0275$var$SSF_general_num(v /*:number*/ ) /*:string*/ {
    var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E), o;
    if (V >= -4 && V <= -1) o = v.toPrecision(10 + V);
    else if (Math.abs(V) <= 9) o = $7c3b72a365cc0275$var$SSF_small_exp(v);
    else if (V === 10) o = v.toFixed(10).substr(0, 12);
    else o = $7c3b72a365cc0275$var$SSF_large_exp(v);
    return $7c3b72a365cc0275$var$SSF_strip_decimal($7c3b72a365cc0275$var$SSF_normalize_exp(o.toUpperCase()));
}
/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	The longest 32-bit integer text is "-2147483648", exactly 11 chars
	TODO: technically the display depends on the width of the cell
*/ function $7c3b72a365cc0275$var$SSF_general(v /*:any*/ , opts /*:any*/ ) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? "TRUE" : "FALSE";
        case 'number':
            return (v | 0) === v ? v.toString(10) : $7c3b72a365cc0275$var$SSF_general_num(v);
        case 'undefined':
            return "";
        case 'object':
            if (v == null) return "";
            if (v instanceof Date) return $7c3b72a365cc0275$var$SSF_format(14, $7c3b72a365cc0275$var$datenum_local(v, opts && opts.date1904), opts);
    }
    throw new Error("unsupported value in General format: " + v);
}
function $7c3b72a365cc0275$var$SSF_fix_hijri(date /*:Date*/ , o /*:[number, number, number]*/ ) {
    /* TODO: properly adjust y/m/d and  */ o[0] -= 581;
    var dow = date.getDay();
    if (date < 60) dow = (dow + 6) % 7;
    return dow;
}
//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
function $7c3b72a365cc0275$var$SSF_write_date(type /*:number*/ , fmt /*:string*/ , val, ss0 /*:?number*/ ) /*:string*/ {
    var o = "", ss = 0, tt = 0, y = val.y, out, outl = 0;
    switch(type){
        case 98:
            /* 'b' buddhist year */ y = val.y + 543;
        /* falls through */ case 121:
            /* 'y' year */ switch(fmt.length){
                case 1:
                case 2:
                    out = y % 100;
                    outl = 2;
                    break;
                default:
                    out = y % 10000;
                    outl = 4;
                    break;
            }
            break;
        case 109:
            /* 'm' month */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.m;
                    outl = fmt.length;
                    break;
                case 3:
                    return $7c3b72a365cc0275$var$months[val.m - 1][1];
                case 5:
                    return $7c3b72a365cc0275$var$months[val.m - 1][0];
                default:
                    return $7c3b72a365cc0275$var$months[val.m - 1][2];
            }
            break;
        case 100:
            /* 'd' day */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.d;
                    outl = fmt.length;
                    break;
                case 3:
                    return $7c3b72a365cc0275$var$days[val.q][0];
                default:
                    return $7c3b72a365cc0275$var$days[val.q][1];
            }
            break;
        case 104:
            /* 'h' 12-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = 1 + (val.H + 11) % 12;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad hour format: ' + fmt;
            }
            break;
        case 72:
            /* 'H' 24-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.H;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad hour format: ' + fmt;
            }
            break;
        case 77:
            /* 'M' minutes */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.M;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad minute format: ' + fmt;
            }
            break;
        case 115:
            /* 's' seconds */ if (fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
            if (val.u === 0 && (fmt == "s" || fmt == "ss")) return $7c3b72a365cc0275$var$pad0(val.S, fmt.length);
            /*::if(!ss0) ss0 = 0; */ if (ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
            else tt = ss0 === 1 ? 10 : 1;
            ss = Math.round(tt * (val.S + val.u));
            if (ss >= 60 * tt) ss = 0;
            if (fmt === 's') return ss === 0 ? "0" : "" + ss / tt;
            o = $7c3b72a365cc0275$var$pad0(ss, 2 + ss0);
            if (fmt === 'ss') return o.substr(0, 2);
            return "." + o.substr(2, fmt.length - 1);
        case 90:
            /* 'Z' absolute time */ switch(fmt){
                case '[h]':
                case '[hh]':
                    out = val.D * 24 + val.H;
                    break;
                case '[m]':
                case '[mm]':
                    out = (val.D * 24 + val.H) * 60 + val.M;
                    break;
                case '[s]':
                case '[ss]':
                    out = ((val.D * 24 + val.H) * 60 + val.M) * 60 + Math.round(val.S + val.u);
                    break;
                default:
                    throw 'bad abstime format: ' + fmt;
            }
            outl = fmt.length === 3 ? 1 : 2;
            break;
        case 101:
            /* 'e' era */ out = y;
            outl = 1;
            break;
    }
    var outstr = outl > 0 ? $7c3b72a365cc0275$var$pad0(out, outl) : "";
    return outstr;
}
/*jshint -W086 */ /*jshint +W086 */ function $7c3b72a365cc0275$var$commaify(s /*:string*/ ) /*:string*/ {
    var w = 3;
    if (s.length <= w) return s;
    var j = s.length % w, o = s.substr(0, j);
    for(; j != s.length; j += w)o += (o.length > 0 ? "," : "") + s.substr(j, w);
    return o;
}
var $7c3b72a365cc0275$var$pct1 = /%/g;
function $7c3b72a365cc0275$var$write_num_pct(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($7c3b72a365cc0275$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $7c3b72a365cc0275$var$write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + $7c3b72a365cc0275$var$fill("%", mul);
}
function $7c3b72a365cc0275$var$write_num_cm(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $7c3b72a365cc0275$var$write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
}
function $7c3b72a365cc0275$var$write_num_exp(fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val == 0) return "0.0E+0";
        else if (val < 0) return "-" + $7c3b72a365cc0275$var$write_num_exp(fmt, -val);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf('E');
        var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (o.indexOf("e") === -1) {
            var fakee = Math.floor(Math.log(val) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            while(o.substr(0, 2) === "0."){
                o = o.charAt(0) + o.substr(2, period) + "." + o.substr(2 + period);
                o = o.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
            }
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
var $7c3b72a365cc0275$var$frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function $7c3b72a365cc0275$var$write_num_f1(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    var den = parseInt(r[4], 10), rr = Math.round(aval * den), base = Math.floor(rr / den);
    var myn = rr - base * den, myd = den;
    return sign + (base === 0 ? "" : "" + base) + " " + (myn === 0 ? $7c3b72a365cc0275$var$fill(" ", r[1].length + 1 + r[4].length) : $7c3b72a365cc0275$var$pad_(myn, r[1].length) + r[2] + "/" + r[3] + $7c3b72a365cc0275$var$pad0(myd, r[4].length));
}
function $7c3b72a365cc0275$var$write_num_f2(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    return sign + (aval === 0 ? "" : "" + aval) + $7c3b72a365cc0275$var$fill(" ", r[1].length + 2 + r[4].length);
}
var $7c3b72a365cc0275$var$dec1 = /^#*0*\.([0#]+)/;
var $7c3b72a365cc0275$var$closeparen = /\).*[0#]/;
var $7c3b72a365cc0275$var$phone = /\(###\) ###\\?-####/;
function $7c3b72a365cc0275$var$hashq(str /*:string*/ ) /*:string*/ {
    var o = "", cc;
    for(var i = 0; i != str.length; ++i)switch(cc = str.charCodeAt(i)){
        case 35:
            break;
        case 63:
            o += " ";
            break;
        case 48:
            o += "0";
            break;
        default:
            o += String.fromCharCode(cc);
    }
    return o;
}
function $7c3b72a365cc0275$var$rnd(val /*:number*/ , d /*:number*/ ) /*:string*/ {
    var dd = Math.pow(10, d);
    return "" + Math.round(val * dd) / dd;
}
function $7c3b72a365cc0275$var$dec(val /*:number*/ , d /*:number*/ ) /*:number*/ {
    var _frac = val - Math.floor(val), dd = Math.pow(10, d);
    if (d < ('' + Math.round(_frac * dd)).length) return 0;
    return Math.round(_frac * dd);
}
function $7c3b72a365cc0275$var$carry(val /*:number*/ , d /*:number*/ ) /*:number*/ {
    if (d < ('' + Math.round((val - Math.floor(val)) * Math.pow(10, d))).length) return 1;
    return 0;
}
function $7c3b72a365cc0275$var$flr(val /*:number*/ ) /*:string*/ {
    if (val < 2147483647 && val > -2147483648) return "" + (val >= 0 ? val | 0 : val - 1 | 0);
    return "" + Math.floor(val);
}
function $7c3b72a365cc0275$var$write_num_flt(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($7c3b72a365cc0275$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val >= 0) return $7c3b72a365cc0275$var$write_num_flt('n', ffmt, val);
        return '(' + $7c3b72a365cc0275$var$write_num_flt('n', ffmt, -val) + ')';
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $7c3b72a365cc0275$var$write_num_cm(type, fmt, val);
    if (fmt.indexOf('%') !== -1) return $7c3b72a365cc0275$var$write_num_pct(type, fmt, val);
    if (fmt.indexOf('E') !== -1) return $7c3b72a365cc0275$var$write_num_exp(fmt, val);
    if (fmt.charCodeAt(0) === 36) return "$" + $7c3b72a365cc0275$var$write_num_flt(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $7c3b72a365cc0275$var$pad0r(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = $7c3b72a365cc0275$var$pad0r(val, 0);
        if (o === "0") o = "";
        return o.length > fmt.length ? o : $7c3b72a365cc0275$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($7c3b72a365cc0275$var$frac1)) return $7c3b72a365cc0275$var$write_num_f1(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $7c3b72a365cc0275$var$pad0r(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($7c3b72a365cc0275$var$dec1)) {
        o = $7c3b72a365cc0275$var$rnd(val, r[1].length).replace(/^([^\.]+)$/, "$1." + $7c3b72a365cc0275$var$hashq(r[1])).replace(/\.$/, "." + $7c3b72a365cc0275$var$hashq(r[1])).replace(/\.(\d*)$/, function($$, $1) {
            return "." + $1 + $7c3b72a365cc0275$var$fill("0", $7c3b72a365cc0275$var$hashq(/*::(*/ r /*::||[""])*/ [1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + $7c3b72a365cc0275$var$rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $7c3b72a365cc0275$var$commaify($7c3b72a365cc0275$var$pad0r(aval, 0));
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val < 0 ? "-" + $7c3b72a365cc0275$var$write_num_flt(type, fmt, -val) : $7c3b72a365cc0275$var$commaify("" + (Math.floor(val) + $7c3b72a365cc0275$var$carry(val, r[1].length))) + "." + $7c3b72a365cc0275$var$pad0($7c3b72a365cc0275$var$dec(val, r[1].length), r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $7c3b72a365cc0275$var$write_num_flt(type, fmt.replace(/^#,#*,/, ""), val);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $7c3b72a365cc0275$var$_strrev($7c3b72a365cc0275$var$write_num_flt(type, fmt.replace(/[\\-]/g, ""), val));
        ri = 0;
        return $7c3b72a365cc0275$var$_strrev($7c3b72a365cc0275$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
        }));
    }
    if (fmt.match($7c3b72a365cc0275$var$phone)) {
        o = $7c3b72a365cc0275$var$write_num_flt(type, "##########", val);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $7c3b72a365cc0275$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $7c3b72a365cc0275$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $7c3b72a365cc0275$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $7c3b72a365cc0275$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $7c3b72a365cc0275$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $7c3b72a365cc0275$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $7c3b72a365cc0275$var$rpad_(ff[2], ri) : $7c3b72a365cc0275$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = $7c3b72a365cc0275$var$pad0r(val, 0);
        if (fmt.length <= o.length) return o;
        return $7c3b72a365cc0275$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0?]+)\.([#0]+)$/)) {
        o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $7c3b72a365cc0275$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) {
        ri = $7c3b72a365cc0275$var$dec(val, r[1].length);
        return val < 0 ? "-" + $7c3b72a365cc0275$var$write_num_flt(type, fmt, -val) : $7c3b72a365cc0275$var$commaify($7c3b72a365cc0275$var$flr(val)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
            return "00," + ($$.length < 3 ? $7c3b72a365cc0275$var$pad0(0, 3 - $$.length) : "") + $$;
        }) + "." + $7c3b72a365cc0275$var$pad0(ri, r[1].length);
    }
    switch(fmt){
        case "###,##0.00":
            return $7c3b72a365cc0275$var$write_num_flt(type, "#,##0.00", val);
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $7c3b72a365cc0275$var$commaify($7c3b72a365cc0275$var$pad0r(aval, 0));
            return x !== "0" ? sign + x : "";
        case "###,###.00":
            return $7c3b72a365cc0275$var$write_num_flt(type, "###,##0.00", val).replace(/^0\./, ".");
        case "#,###.00":
            return $7c3b72a365cc0275$var$write_num_flt(type, "#,##0.00", val).replace(/^0\./, ".");
        default:
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $7c3b72a365cc0275$var$write_num_cm2(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $7c3b72a365cc0275$var$write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
}
function $7c3b72a365cc0275$var$write_num_pct2(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($7c3b72a365cc0275$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $7c3b72a365cc0275$var$write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + $7c3b72a365cc0275$var$fill("%", mul);
}
function $7c3b72a365cc0275$var$write_num_exp2(fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val == 0) return "0.0E+0";
        else if (val < 0) return "-" + $7c3b72a365cc0275$var$write_num_exp2(fmt, -val);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf('E');
        var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (!o.match(/[Ee]/)) {
            var fakee = Math.floor(Math.log(val) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
function $7c3b72a365cc0275$var$write_num_int(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($7c3b72a365cc0275$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val >= 0) return $7c3b72a365cc0275$var$write_num_int('n', ffmt, val);
        return '(' + $7c3b72a365cc0275$var$write_num_int('n', ffmt, -val) + ')';
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $7c3b72a365cc0275$var$write_num_cm2(type, fmt, val);
    if (fmt.indexOf('%') !== -1) return $7c3b72a365cc0275$var$write_num_pct2(type, fmt, val);
    if (fmt.indexOf('E') !== -1) return $7c3b72a365cc0275$var$write_num_exp2(fmt, val);
    if (fmt.charCodeAt(0) === 36) return "$" + $7c3b72a365cc0275$var$write_num_int(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $7c3b72a365cc0275$var$pad0(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = "" + val;
        if (val === 0) o = "";
        return o.length > fmt.length ? o : $7c3b72a365cc0275$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($7c3b72a365cc0275$var$frac1)) return $7c3b72a365cc0275$var$write_num_f2(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $7c3b72a365cc0275$var$pad0(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($7c3b72a365cc0275$var$dec1)) {
        /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ o = ("" + val).replace(/^([^\.]+)$/, "$1." + $7c3b72a365cc0275$var$hashq(r[1])).replace(/\.$/, "." + $7c3b72a365cc0275$var$hashq(r[1]));
        o = o.replace(/\.(\d*)$/, function($$, $1) {
            /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ return "." + $1 + $7c3b72a365cc0275$var$fill("0", $7c3b72a365cc0275$var$hashq(r[1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + ("" + aval).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $7c3b72a365cc0275$var$commaify("" + aval);
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val < 0 ? "-" + $7c3b72a365cc0275$var$write_num_int(type, fmt, -val) : $7c3b72a365cc0275$var$commaify("" + val) + "." + $7c3b72a365cc0275$var$fill('0', r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $7c3b72a365cc0275$var$write_num_int(type, fmt.replace(/^#,#*,/, ""), val);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $7c3b72a365cc0275$var$_strrev($7c3b72a365cc0275$var$write_num_int(type, fmt.replace(/[\\-]/g, ""), val));
        ri = 0;
        return $7c3b72a365cc0275$var$_strrev($7c3b72a365cc0275$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
        }));
    }
    if (fmt.match($7c3b72a365cc0275$var$phone)) {
        o = $7c3b72a365cc0275$var$write_num_int(type, "##########", val);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $7c3b72a365cc0275$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $7c3b72a365cc0275$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $7c3b72a365cc0275$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $7c3b72a365cc0275$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $7c3b72a365cc0275$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $7c3b72a365cc0275$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $7c3b72a365cc0275$var$rpad_(ff[2], ri) : $7c3b72a365cc0275$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = "" + val;
        if (fmt.length <= o.length) return o;
        return $7c3b72a365cc0275$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0]+)\.([#0]+)$/)) {
        o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $7c3b72a365cc0275$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) return val < 0 ? "-" + $7c3b72a365cc0275$var$write_num_int(type, fmt, -val) : $7c3b72a365cc0275$var$commaify("" + val).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
        return "00," + ($$.length < 3 ? $7c3b72a365cc0275$var$pad0(0, 3 - $$.length) : "") + $$;
    }) + "." + $7c3b72a365cc0275$var$pad0(0, r[1].length);
    switch(fmt){
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $7c3b72a365cc0275$var$commaify("" + aval);
            return x !== "0" ? sign + x : "";
        default:
            if (fmt.match(/\.[0#?]*$/)) return $7c3b72a365cc0275$var$write_num_int(type, fmt.slice(0, fmt.lastIndexOf(".")), val) + $7c3b72a365cc0275$var$hashq(fmt.slice(fmt.lastIndexOf(".")));
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $7c3b72a365cc0275$var$write_num(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    return (val | 0) === val ? $7c3b72a365cc0275$var$write_num_int(type, fmt, val) : $7c3b72a365cc0275$var$write_num_flt(type, fmt, val);
}
function $7c3b72a365cc0275$var$SSF_split_fmt(fmt /*:string*/ ) /*:Array<string>*/ {
    var out /*:Array<string>*/  = [];
    var in_str = false /*, cc*/ ;
    for(var i = 0, j = 0; i < fmt.length; ++i)switch(/*cc=*/ fmt.charCodeAt(i)){
        case 34:
            /* '"' */ in_str = !in_str;
            break;
        case 95:
        case 42:
        case 92:
            /* '_' '*' '\\' */ ++i;
            break;
        case 59:
            /* ';' */ out[out.length] = fmt.substr(j, i - j);
            j = i + 1;
    }
    out[out.length] = fmt.substr(j);
    if (in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
    return out;
}
var $7c3b72a365cc0275$var$SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function $7c3b72a365cc0275$var$fmt_is_date(fmt /*:string*/ ) /*:boolean*/ {
    var i = 0, /*cc = 0,*/ c = "", o = "";
    while(i < fmt.length)switch(c = fmt.charAt(i)){
        case 'G':
            if ($7c3b72a365cc0275$var$SSF_isgeneral(fmt, i)) i += 6;
            i++;
            break;
        case '"':
            for(; /*cc=*/ fmt.charCodeAt(++i) !== 34 && i < fmt.length;);
            ++i;
            break;
        case '\\':
            i += 2;
            break;
        case '_':
            i += 2;
            break;
        case '@':
            ++i;
            break;
        case 'B':
        case 'b':
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") return true;
        /* falls through */ case 'M':
        case 'D':
        case 'Y':
        case 'H':
        case 'S':
        case 'E':
        /* falls through */ case 'm':
        case 'd':
        case 'y':
        case 'h':
        case 's':
        case 'e':
        case 'g':
            return true;
        case 'A':
        case 'a':
        case "\u4E0A":
            if (fmt.substr(i, 3).toUpperCase() === "A/P") return true;
            if (fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
            if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") return true;
            ++i;
            break;
        case '[':
            o = c;
            while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
            if (o.match($7c3b72a365cc0275$var$SSF_abstime)) return true;
            break;
        case '.':
        /* falls through */ case '0':
        case '#':
            while(i < fmt.length && ("0#?.,E+-%".indexOf(c = fmt.charAt(++i)) > -1 || c == '\\' && fmt.charAt(i + 1) == "-" && "0#".indexOf(fmt.charAt(i + 2)) > -1));
            break;
        case '?':
            while(fmt.charAt(++i) === c);
            break;
        case '*':
            ++i;
            if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
            break;
        case '(':
        case ')':
            ++i;
            break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1);
            break;
        case ' ':
            ++i;
            break;
        default:
            ++i;
            break;
    }
    return false;
}
function $7c3b72a365cc0275$var$eval_fmt(fmt /*:string*/ , v /*:any*/ , opts /*:any*/ , flen /*:number*/ ) {
    var out = [], o = "", i = 0, c = "", lst = 't', dt, j, cc;
    var hr = 'H';
    /* Tokenize */ while(i < fmt.length)switch(c = fmt.charAt(i)){
        case 'G':
            /* General */ if (!$7c3b72a365cc0275$var$SSF_isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' + fmt);
            out[out.length] = {
                t: 'G',
                v: 'General'
            };
            i += 7;
            break;
        case '"':
            /* Literal text */ for(o = ""; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length;)o += String.fromCharCode(cc);
            out[out.length] = {
                t: 't',
                v: o
            };
            ++i;
            break;
        case '\\':
            var w = fmt.charAt(++i), t = w === "(" || w === ")" ? w : 't';
            out[out.length] = {
                t: t,
                v: w
            };
            ++i;
            break;
        case '_':
            out[out.length] = {
                t: 't',
                v: " "
            };
            i += 2;
            break;
        case '@':
            /* Text Placeholder */ out[out.length] = {
                t: 'T',
                v: v
            };
            ++i;
            break;
        case 'B':
        case 'b':
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") {
                if (dt == null) {
                    dt = $7c3b72a365cc0275$var$SSF_parse_date_code(v, opts, fmt.charAt(i + 1) === "2");
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: 'X',
                    v: fmt.substr(i, 2)
                };
                lst = c;
                i += 2;
                break;
            }
        /* falls through */ case 'M':
        case 'D':
        case 'Y':
        case 'H':
        case 'S':
        case 'E':
            c = c.toLowerCase();
        /* falls through */ case 'm':
        case 'd':
        case 'y':
        case 'h':
        case 's':
        case 'e':
        case 'g':
            if (v < 0) return "";
            if (dt == null) {
                dt = $7c3b72a365cc0275$var$SSF_parse_date_code(v, opts);
                if (dt == null) return "";
            }
            o = c;
            while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c)o += c;
            if (c === 'm' && lst.toLowerCase() === 'h') c = 'M';
            if (c === 'h') c = hr;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case 'A':
        case 'a':
        case "\u4E0A":
            var q = {
                t: c,
                v: c
            };
            if (dt == null) dt = $7c3b72a365cc0275$var$SSF_parse_date_code(v, opts);
            if (fmt.substr(i, 3).toUpperCase() === "A/P") {
                if (dt != null) q.v = dt.H >= 12 ? "P" : "A";
                q.t = 'T';
                hr = 'h';
                i += 3;
            } else if (fmt.substr(i, 5).toUpperCase() === "AM/PM") {
                if (dt != null) q.v = dt.H >= 12 ? "PM" : "AM";
                q.t = 'T';
                i += 5;
                hr = 'h';
            } else if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") {
                if (dt != null) q.v = dt.H >= 12 ? "\u4E0B\u5348" : "\u4E0A\u5348";
                q.t = 'T';
                i += 5;
                hr = 'h';
            } else {
                q.t = "t";
                ++i;
            }
            if (dt == null && q.t === 'T') return "";
            out[out.length] = q;
            lst = c;
            break;
        case '[':
            o = c;
            while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
            if (o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
            if (o.match($7c3b72a365cc0275$var$SSF_abstime)) {
                if (dt == null) {
                    dt = $7c3b72a365cc0275$var$SSF_parse_date_code(v, opts);
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: 'Z',
                    v: o.toLowerCase()
                };
                lst = o.charAt(1);
            } else if (o.indexOf("$") > -1) {
                o = (o.match(/\$([^-\[\]]*)/) || [])[1] || "$";
                if (!$7c3b72a365cc0275$var$fmt_is_date(fmt)) out[out.length] = {
                    t: 't',
                    v: o
                };
            }
            break;
        /* Numbers */ case '.':
            if (dt != null) {
                o = c;
                while(++i < fmt.length && (c = fmt.charAt(i)) === "0")o += c;
                out[out.length] = {
                    t: 's',
                    v: o
                };
                break;
            }
        /* falls through */ case '0':
        case '#':
            o = c;
            while(++i < fmt.length && "0#?.,E+-%".indexOf(c = fmt.charAt(i)) > -1)o += c;
            out[out.length] = {
                t: 'n',
                v: o
            };
            break;
        case '?':
            o = c;
            while(fmt.charAt(++i) === c)o += c;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case '*':
            ++i;
            if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
            break; // **
        case '(':
        case ')':
            out[out.length] = {
                t: flen === 1 ? 't' : c,
                v: c
            };
            ++i;
            break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            o = c;
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1)o += fmt.charAt(i);
            out[out.length] = {
                t: 'D',
                v: o
            };
            break;
        case ' ':
            out[out.length] = {
                t: c,
                v: c
            };
            ++i;
            break;
        case '$':
            out[out.length] = {
                t: 't',
                v: '$'
            };
            ++i;
            break;
        default:
            if (",$-+/():!^&'~{}<>=\u20ACacfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
            out[out.length] = {
                t: 't',
                v: c
            };
            ++i;
            break;
    }
    /* Scan for date/time parts */ var bt = 0, ss0 = 0, ssm;
    for(i = out.length - 1, lst = 't'; i >= 0; --i)switch(out[i].t){
        case 'h':
        case 'H':
            out[i].t = hr;
            lst = 'h';
            if (bt < 1) bt = 1;
            break;
        case 's':
            if (ssm = out[i].v.match(/\.0+$/)) ss0 = Math.max(ss0, ssm[0].length - 1);
            if (bt < 3) bt = 3;
        /* falls through */ case 'd':
        case 'y':
        case 'M':
        case 'e':
            lst = out[i].t;
            break;
        case 'm':
            if (lst === 's') {
                out[i].t = 'M';
                if (bt < 2) bt = 2;
            }
            break;
        case 'X':
            break;
        case 'Z':
            if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
            if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
            if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
    }
    /* time rounding depends on presence of minute / second / usec fields */ switch(bt){
        case 0:
            break;
        case 1:
            /*::if(!dt) break;*/ if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            break;
        case 2:
            /*::if(!dt) break;*/ if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            break;
    }
    /* replace fields */ var nstr = "", jj;
    for(i = 0; i < out.length; ++i)switch(out[i].t){
        case 't':
        case 'T':
        case ' ':
        case 'D':
            break;
        case 'X':
            out[i].v = "";
            out[i].t = ";";
            break;
        case 'd':
        case 'm':
        case 'y':
        case 'h':
        case 'H':
        case 'M':
        case 's':
        case 'e':
        case 'b':
        case 'Z':
            /*::if(!dt) throw "unreachable"; */ out[i].v = $7c3b72a365cc0275$var$SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
            out[i].t = 't';
            break;
        case 'n':
        case '?':
            jj = i + 1;
            while(out[jj] != null && ((c = out[jj].t) === "?" || c === "D" || (c === " " || c === "t") && out[jj + 1] != null && (out[jj + 1].t === '?' || out[jj + 1].t === "t" && out[jj + 1].v === '/') || out[i].t === '(' && (c === ' ' || c === 'n' || c === ')') || c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj + 1] != null && out[jj + 1].t == '?'))){
                out[i].v += out[jj].v;
                out[jj] = {
                    v: "",
                    t: ";"
                };
                ++jj;
            }
            nstr += out[i].v;
            i = jj - 1;
            break;
        case 'G':
            out[i].t = 't';
            out[i].v = $7c3b72a365cc0275$var$SSF_general(v, opts);
            break;
    }
    var vv = "", myv, ostr;
    if (nstr.length > 0) {
        if (nstr.charCodeAt(0) == 40) /* '(' */ {
            myv = v < 0 && nstr.charCodeAt(0) === 45 ? -v : v;
            ostr = $7c3b72a365cc0275$var$write_num('n', nstr, myv);
        } else {
            myv = v < 0 && flen > 1 ? -v : v;
            ostr = $7c3b72a365cc0275$var$write_num('n', nstr, myv);
            if (myv < 0 && out[0] && out[0].t == 't') {
                ostr = ostr.substr(1);
                out[0].v = "-" + out[0].v;
            }
        }
        jj = ostr.length - 1;
        var decpt = out.length;
        for(i = 0; i < out.length; ++i)if (out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) {
            decpt = i;
            break;
        }
        var lasti = out.length;
        if (decpt === out.length && ostr.indexOf("E") === -1) {
            for(i = out.length - 1; i >= 0; --i){
                if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                if (jj >= out[i].v.length - 1) {
                    jj -= out[i].v.length;
                    out[i].v = ostr.substr(jj + 1, out[i].v.length);
                } else if (jj < 0) out[i].v = "";
                else {
                    out[i].v = ostr.substr(0, jj + 1);
                    jj = -1;
                }
                out[i].t = 't';
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
        } else if (decpt !== out.length && ostr.indexOf("E") === -1) {
            jj = ostr.indexOf(".") - 1;
            for(i = decpt; i >= 0; --i){
                if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") - 1 : out[i].v.length - 1;
                vv = out[i].v.substr(j + 1);
                for(; j >= 0; --j)if (jj >= 0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
                out[i].v = vv;
                out[i].t = 't';
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
            jj = ostr.indexOf(".") + 1;
            for(i = decpt; i < out.length; ++i){
                if (out[i] == null || 'n?('.indexOf(out[i].t) === -1 && i !== decpt) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") + 1 : 0;
                vv = out[i].v.substr(0, j);
                for(; j < out[i].v.length; ++j)if (jj < ostr.length) vv += ostr.charAt(jj++);
                out[i].v = vv;
                out[i].t = 't';
                lasti = i;
            }
        }
    }
    for(i = 0; i < out.length; ++i)if (out[i] != null && 'n?'.indexOf(out[i].t) > -1) {
        myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === "-" ? -v : v;
        out[i].v = $7c3b72a365cc0275$var$write_num(out[i].t, out[i].v, myv);
        out[i].t = 't';
    }
    var retval = "";
    for(i = 0; i !== out.length; ++i)if (out[i] != null) retval += out[i].v;
    return retval;
}
var $7c3b72a365cc0275$var$cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function $7c3b72a365cc0275$var$chkcond(v, rr) {
    if (rr == null) return false;
    var thresh = parseFloat(rr[2]);
    switch(rr[1]){
        case "=":
            if (v == thresh) return true;
            break;
        case ">":
            if (v > thresh) return true;
            break;
        case "<":
            if (v < thresh) return true;
            break;
        case "<>":
            if (v != thresh) return true;
            break;
        case ">=":
            if (v >= thresh) return true;
            break;
        case "<=":
            if (v <= thresh) return true;
            break;
    }
    return false;
}
function $7c3b72a365cc0275$var$choose_fmt(f /*:string*/ , v /*:any*/ ) {
    var fmt = $7c3b72a365cc0275$var$SSF_split_fmt(f);
    var l = fmt.length, lat = fmt[l - 1].indexOf("@");
    if (l < 4 && lat > -1) --l;
    if (fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
    if (typeof v !== "number") return [
        4,
        fmt.length === 4 || lat > -1 ? fmt[fmt.length - 1] : "@"
    ];
    switch(fmt.length){
        case 1:
            fmt = lat > -1 ? [
                "General",
                "General",
                "General",
                fmt[0]
            ] : [
                fmt[0],
                fmt[0],
                fmt[0],
                "@"
            ];
            break;
        case 2:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[0],
                fmt[0],
                fmt[1]
            ] : [
                fmt[0],
                fmt[1],
                fmt[0],
                "@"
            ];
            break;
        case 3:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[1],
                fmt[0],
                fmt[2]
            ] : [
                fmt[0],
                fmt[1],
                fmt[2],
                "@"
            ];
            break;
        case 4:
            break;
    }
    var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
    if (fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [
        l,
        ff
    ];
    if (fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
        var m1 = fmt[0].match($7c3b72a365cc0275$var$cfregex2);
        var m2 = fmt[1].match($7c3b72a365cc0275$var$cfregex2);
        return $7c3b72a365cc0275$var$chkcond(v, m1) ? [
            l,
            fmt[0]
        ] : $7c3b72a365cc0275$var$chkcond(v, m2) ? [
            l,
            fmt[1]
        ] : [
            l,
            fmt[m1 != null && m2 != null ? 2 : 1]
        ];
    }
    return [
        l,
        ff
    ];
}
function $7c3b72a365cc0275$var$SSF_format(fmt /*:string|number*/ , v /*:any*/ , o /*:?any*/ ) {
    if (o == null) o = {};
    var sfmt = "";
    switch(typeof fmt){
        case "string":
            if (fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
            else sfmt = fmt;
            break;
        case "number":
            if (fmt == 14 && o.dateNF) sfmt = o.dateNF;
            else sfmt = (o.table != null ? o.table /*:any*/  : $7c3b72a365cc0275$var$table_fmt)[fmt];
            if (sfmt == null) sfmt = o.table && o.table[$7c3b72a365cc0275$var$SSF_default_map[fmt]] || $7c3b72a365cc0275$var$table_fmt[$7c3b72a365cc0275$var$SSF_default_map[fmt]];
            if (sfmt == null) sfmt = $7c3b72a365cc0275$var$SSF_default_str[fmt] || "General";
            break;
    }
    if ($7c3b72a365cc0275$var$SSF_isgeneral(sfmt, 0)) return $7c3b72a365cc0275$var$SSF_general(v, o);
    if (v instanceof Date) v = $7c3b72a365cc0275$var$datenum_local(v, o.date1904);
    var f = $7c3b72a365cc0275$var$choose_fmt(sfmt, v);
    if ($7c3b72a365cc0275$var$SSF_isgeneral(f[1])) return $7c3b72a365cc0275$var$SSF_general(v, o);
    if (v === true) v = "TRUE";
    else if (v === false) v = "FALSE";
    else if (v === "" || v == null) return "";
    return $7c3b72a365cc0275$var$eval_fmt(f[1], v, o, f[0]);
}
function $7c3b72a365cc0275$var$SSF_load(fmt /*:string*/ , idx /*:?number*/ ) /*:number*/ {
    if (typeof idx != 'number') {
        idx = +idx || -1;
        /*::if(typeof idx != 'number') return 0x188; */ for(var i = 0; i < 0x0188; ++i){
            /*::if(typeof idx != 'number') return 0x188; */ if ($7c3b72a365cc0275$var$table_fmt[i] == undefined) {
                if (idx < 0) idx = i;
                continue;
            }
            if ($7c3b72a365cc0275$var$table_fmt[i] == fmt) {
                idx = i;
                break;
            }
        }
        /*::if(typeof idx != 'number') return 0x188; */ if (idx < 0) idx = 0x187;
    }
    /*::if(typeof idx != 'number') return 0x188; */ $7c3b72a365cc0275$var$table_fmt[idx] = fmt;
    return idx;
}
function $7c3b72a365cc0275$var$SSF_load_table(tbl /*:SSFTable*/ ) /*:void*/ {
    for(var i = 0; i != 0x0188; ++i)if (tbl[i] !== undefined) $7c3b72a365cc0275$var$SSF_load(tbl[i], i);
}
function $7c3b72a365cc0275$var$make_ssf() {
    $7c3b72a365cc0275$var$table_fmt = $7c3b72a365cc0275$var$SSF_init_table();
}
var $7c3b72a365cc0275$export$40d8edd678456c2b = {
    format: $7c3b72a365cc0275$var$SSF_format,
    load: $7c3b72a365cc0275$var$SSF_load,
    _table: $7c3b72a365cc0275$var$table_fmt,
    load_table: $7c3b72a365cc0275$var$SSF_load_table,
    parse_date_code: $7c3b72a365cc0275$var$SSF_parse_date_code,
    is_date: $7c3b72a365cc0275$var$fmt_is_date,
    get_table: function get_table() {
        return $7c3b72a365cc0275$export$40d8edd678456c2b._table = $7c3b72a365cc0275$var$table_fmt;
    }
};
var $7c3b72a365cc0275$var$SSFImplicit /*{[number]:string}*/  = {
    "5": '"$"#,##0_);\\("$"#,##0\\)',
    "6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "23": 'General',
    "24": 'General',
    "25": 'General',
    "26": 'General',
    "27": 'm/d/yy',
    "28": 'm/d/yy',
    "29": 'm/d/yy',
    "30": 'm/d/yy',
    "31": 'm/d/yy',
    "32": 'h:mm:ss',
    "33": 'h:mm:ss',
    "34": 'h:mm:ss',
    "35": 'h:mm:ss',
    "36": 'm/d/yy',
    "41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
    "42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
    "43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
    "44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
    "50": 'm/d/yy',
    "51": 'm/d/yy',
    "52": 'm/d/yy',
    "53": 'm/d/yy',
    "54": 'm/d/yy',
    "55": 'm/d/yy',
    "56": 'm/d/yy',
    "57": 'm/d/yy',
    "58": 'm/d/yy',
    "59": '0',
    "60": '0.00',
    "61": '#,##0',
    "62": '#,##0.00',
    "63": '"$"#,##0_);\\("$"#,##0\\)',
    "64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "67": '0%',
    "68": '0.00%',
    "69": '# ?/?',
    "70": '# ??/??',
    "71": 'm/d/yy',
    "72": 'm/d/yy',
    "73": 'd-mmm-yy',
    "74": 'd-mmm',
    "75": 'mmm-yy',
    "76": 'h:mm',
    "77": 'h:mm:ss',
    "78": 'm/d/yy h:mm',
    "79": 'mm:ss',
    "80": '[h]:mm:ss',
    "81": 'mmss.0'
} /*:any*/ ;
/* dateNF parse TODO: move to SSF */ var $7c3b72a365cc0275$var$dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function $7c3b72a365cc0275$var$dateNF_regex(dateNF /*:string|number*/ ) /*:RegExp*/ {
    var fmt = typeof dateNF == "number" ? $7c3b72a365cc0275$var$table_fmt[dateNF] : dateNF;
    fmt = fmt.replace($7c3b72a365cc0275$var$dateNFregex, "(\\d+)");
    return new RegExp("^" + fmt + "$");
}
function $7c3b72a365cc0275$var$dateNF_fix(str /*:string*/ , dateNF /*:string*/ , match /*:Array<string>*/ ) /*:string*/ {
    var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
    (dateNF.match($7c3b72a365cc0275$var$dateNFregex) || []).forEach(function(n, i) {
        var v = parseInt(match[i + 1], 10);
        switch(n.toLowerCase().charAt(0)){
            case 'y':
                Y = v;
                break;
            case 'd':
                d = v;
                break;
            case 'h':
                H = v;
                break;
            case 's':
                S = v;
                break;
            case 'm':
                if (H >= 0) M = v;
                else m = v;
                break;
        }
    });
    if (S >= 0 && M == -1 && m >= 0) {
        M = m;
        m = -1;
    }
    var datestr = ("" + (Y >= 0 ? Y : new Date().getFullYear())).slice(-4) + "-" + ("00" + (m >= 1 ? m : 1)).slice(-2) + "-" + ("00" + (d >= 1 ? d : 1)).slice(-2);
    if (datestr.length == 7) datestr = "0" + datestr;
    if (datestr.length == 8) datestr = "20" + datestr;
    var timestr = ("00" + (H >= 0 ? H : 0)).slice(-2) + ":" + ("00" + (M >= 0 ? M : 0)).slice(-2) + ":" + ("00" + (S >= 0 ? S : 0)).slice(-2);
    if (H == -1 && M == -1 && S == -1) return datestr;
    if (Y == -1 && m == -1 && d == -1) return timestr;
    return datestr + "T" + timestr;
}
/*::
declare var ReadShift:any;
declare var CheckField:any;
declare var prep_blob:any;
declare var __readUInt32LE:any;
declare var __readInt32LE:any;
declare var __toBuffer:any;
declare var __utf16le:any;
declare var bconcat:any;
declare var s2a:any;
declare var chr0:any;
declare var chr1:any;
declare var has_buf:boolean;
declare var new_buf:any;
declare var new_raw_buf:any;
declare var new_unsafe_buf:any;
declare var Buffer_from:any;
*/ /* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*jshint eqnull:true */ /*exported CFB */ /*global Uint8Array:false, Uint16Array:false */ /*::
type SectorEntry = {
	name?:string;
	nodes?:Array<number>;
	data:RawBytes;
};
type SectorList = {
	[k:string|number]:SectorEntry;
	name:?string;
	fat_addrs:Array<number>;
	ssz:number;
}
type CFBFiles = {[n:string]:CFBEntry};
*/ /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */ var $7c3b72a365cc0275$var$CRC32 = /*#__PURE__*/ function() {
    var CRC32 = {};
    CRC32.version = '1.2.0';
    /* see perf/crc32table.js */ /*global Int32Array */ function signed_crc_table() /*:any*/ {
        var c = 0, table /*:Array<number>*/  = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
    }
    var T0 = signed_crc_table();
    function slice_by_16_tables(T) {
        var c = 0, v = 0, n = 0, table /*:Array<number>*/  = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096);
        for(n = 0; n != 256; ++n)table[n] = T[n];
        for(n = 0; n != 256; ++n){
            v = T[n];
            for(c = 256 + n; c < 4096; c += 256)v = table[c] = v >>> 8 ^ T[v & 0xFF];
        }
        var out = [];
        for(n = 1; n != 16; ++n)out[n - 1] = typeof Int32Array !== 'undefined' ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
        return out;
    }
    var TT = slice_by_16_tables(T0);
    var T1 = TT[0], T2 = TT[1], T3 = TT[2], T4 = TT[3], T5 = TT[4];
    var T6 = TT[5], T7 = TT[6], T8 = TT[7], T9 = TT[8], Ta = TT[9];
    var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
    function crc32_bstr(bstr /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1;
        for(var i = 0, L = bstr.length; i < L;)C = C >>> 8 ^ T0[(C ^ bstr.charCodeAt(i++)) & 0xFF];
        return ~C;
    }
    function crc32_buf(B /*:Uint8Array|Array<number>*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1, L = B.length - 15, i = 0;
        for(; i < L;)C = Tf[B[i++] ^ C & 255] ^ Te[B[i++] ^ C >> 8 & 255] ^ Td[B[i++] ^ C >> 16 & 255] ^ Tc[B[i++] ^ C >>> 24] ^ Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^ T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^ T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
        L += 15;
        while(i < L)C = C >>> 8 ^ T0[(C ^ B[i++]) & 0xFF];
        return ~C;
    }
    function crc32_str(str /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed ^ -1;
        for(var i = 0, L = str.length, c = 0, d = 0; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) C = C >>> 8 ^ T0[(C ^ c) & 0xFF];
            else if (c < 0x800) {
                C = C >>> 8 ^ T0[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                C = C >>> 8 ^ T0[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d & 63)) & 0xFF];
            } else {
                C = C >>> 8 ^ T0[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            }
        }
        return ~C;
    }
    CRC32.table = T0;
    CRC32.bstr = crc32_bstr;
    CRC32.buf = crc32_buf;
    CRC32.str = crc32_str;
    return CRC32;
}();
/* [MS-CFB] v20171201 */ var $7c3b72a365cc0275$export$9f0e51cd97c572a = /*#__PURE__*/ function _CFB() {
    var exports = {};
    exports.version = '1.2.1';
    /* [MS-CFB] 2.6.4 */ function namecmp(l /*:string*/ , r /*:string*/ ) /*:number*/ {
        var L = l.split("/"), R = r.split("/");
        for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i){
            if (c = L[i].length - R[i].length) return c;
            if (L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
        }
        return L.length - R.length;
    }
    function dirname(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return p.slice(0, -1).indexOf("/") === -1 ? p : dirname(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(0, c + 1);
    }
    function filename(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(c + 1);
    }
    /* -------------------------------------------------------------------------- */ /* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/ /* write JS date to buf as a DOS date */ function write_dos_date(buf /*:CFBlob*/ , date /*:Date|string*/ ) {
        if (typeof date === "string") date = new Date(date);
        var hms /*:number*/  = date.getHours();
        hms = hms << 6 | date.getMinutes();
        hms = hms << 5 | date.getSeconds() >>> 1;
        buf.write_shift(2, hms);
        var ymd /*:number*/  = date.getFullYear() - 1980;
        ymd = ymd << 4 | date.getMonth() + 1;
        ymd = ymd << 5 | date.getDate();
        buf.write_shift(2, ymd);
    }
    /* read four bytes from buf and interpret as a DOS date */ function parse_dos_date(buf /*:CFBlob*/ ) /*:Date*/ {
        var hms = buf.read_shift(2) & 0xFFFF;
        var ymd = buf.read_shift(2) & 0xFFFF;
        var val = new Date();
        var d = ymd & 0x1F;
        ymd >>>= 5;
        var m = ymd & 0x0F;
        ymd >>>= 4;
        val.setMilliseconds(0);
        val.setFullYear(ymd + 1980);
        val.setMonth(m - 1);
        val.setDate(d);
        var S = hms & 0x1F;
        hms >>>= 5;
        var M = hms & 0x3F;
        hms >>>= 6;
        val.setHours(hms);
        val.setMinutes(M);
        val.setSeconds(S << 1);
        return val;
    }
    function parse_extra_field(blob /*:CFBlob*/ ) /*:any*/ {
        $7c3b72a365cc0275$var$prep_blob(blob, 0);
        var o = /*::(*/ {} /*:: :any)*/ ;
        var flags = 0;
        while(blob.l <= blob.length - 4){
            var type = blob.read_shift(2);
            var sz = blob.read_shift(2), tgt = blob.l + sz;
            var p = {};
            switch(type){
                /* UNIX-style Timestamps */ case 0x5455:
                    flags = blob.read_shift(1);
                    if (flags & 1) p.mtime = blob.read_shift(4);
                    /* for some reason, CD flag corresponds to LFH */ if (sz > 5) {
                        if (flags & 2) p.atime = blob.read_shift(4);
                        if (flags & 4) p.ctime = blob.read_shift(4);
                    }
                    if (p.mtime) p.mt = new Date(p.mtime * 1000);
                    break;
            }
            blob.l = tgt;
            o[type] = p;
        }
        return o;
    }
    var fs /*:: = require('fs'); */ ;
    function get_fs() {
        return fs || (fs = {});
    }
    function parse(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
        if ((file[0] | 0x20) == 0x6d && (file[1] | 0x20) == 0x69) return parse_mad(file, options);
        if (file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
        var mver = 3;
        var ssz = 512;
        var nmfs = 0; // number of mini FAT sectors
        var difat_sec_cnt = 0;
        var dir_start = 0;
        var minifat_start = 0;
        var difat_start = 0;
        var fat_addrs /*:Array<number>*/  = []; // locations of FAT sectors
        /* [MS-CFB] 2.2 Compound File Header */ var blob /*:CFBlob*/  = /*::(*/ file.slice(0, 512) /*:: :any)*/ ;
        $7c3b72a365cc0275$var$prep_blob(blob, 0);
        /* major version */ var mv = check_get_mver(blob);
        mver = mv[0];
        switch(mver){
            case 3:
                ssz = 512;
                break;
            case 4:
                ssz = 4096;
                break;
            case 0:
                if (mv[1] == 0) return parse_zip(file, options);
            /* falls through */ default:
                throw new Error("Major Version: Expected 3 or 4 saw " + mver);
        }
        /* reprocess header */ if (ssz !== 512) {
            blob = /*::(*/ file.slice(0, ssz) /*:: :any)*/ ;
            $7c3b72a365cc0275$var$prep_blob(blob, 28 /* blob.l */ );
        }
        /* Save header for final object */ var header /*:RawBytes*/  = file.slice(0, ssz);
        check_shifts(blob, mver);
        // Number of Directory Sectors
        var dir_cnt /*:number*/  = blob.read_shift(4, 'i');
        if (mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);
        // Number of FAT Sectors
        blob.l += 4;
        // First Directory Sector Location
        dir_start = blob.read_shift(4, 'i');
        // Transaction Signature
        blob.l += 4;
        // Mini Stream Cutoff Size
        blob.chk('00100000', 'Mini Stream Cutoff Size: ');
        // First Mini FAT Sector Location
        minifat_start = blob.read_shift(4, 'i');
        // Number of Mini FAT Sectors
        nmfs = blob.read_shift(4, 'i');
        // First DIFAT sector location
        difat_start = blob.read_shift(4, 'i');
        // Number of DIFAT Sectors
        difat_sec_cnt = blob.read_shift(4, 'i');
        // Grab FAT Sector Locations
        for(var q = -1, j = 0; j < 109; ++j){
            q = blob.read_shift(4, 'i');
            if (q < 0) break;
            fat_addrs[j] = q;
        }
        /** Break the file up into sectors */ var sectors /*:Array<RawBytes>*/  = sectorify(file, ssz);
        sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
        /** Chains */ var sector_list /*:SectorList*/  = make_sector_list(sectors, dir_start, fat_addrs, ssz);
        sector_list[dir_start].name = "!Directory";
        if (nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
        sector_list[fat_addrs[0]].name = "!FAT";
        sector_list.fat_addrs = fat_addrs;
        sector_list.ssz = ssz;
        /* [MS-CFB] 2.6.1 Compound File Directory Entry */ var files /*:CFBFiles*/  = {}, Paths /*:Array<string>*/  = [], FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
        build_full_paths(FileIndex, FullPaths, Paths);
        Paths.shift();
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        // $FlowIgnore
        if (options && options.raw) o.raw = {
            header: header,
            sectors: sectors
        };
        return o;
    } // parse
    /* [MS-CFB] 2.2 Compound File Header -- read up to major version */ function check_get_mver(blob /*:CFBlob*/ ) /*:[number, number]*/ {
        if (blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [
            0,
            0
        ];
        // header signature 8
        blob.chk(HEADER_SIGNATURE, 'Header Signature: ');
        // clsid 16
        //blob.chk(HEADER_CLSID, 'CLSID: ');
        blob.l += 16;
        // minor version 2
        var mver /*:number*/  = blob.read_shift(2, 'u');
        return [
            blob.read_shift(2, 'u'),
            mver
        ];
    }
    function check_shifts(blob /*:CFBlob*/ , mver /*:number*/ ) /*:void*/ {
        var shift = 0x09;
        // Byte Order
        //blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
        blob.l += 2;
        // Sector Shift
        switch(shift = blob.read_shift(2)){
            case 0x09:
                if (mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift);
                break;
            case 0x0c:
                if (mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift);
                break;
            default:
                throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
        }
        // Mini Sector Shift
        blob.chk('0600', 'Mini Sector Shift: ');
        // Reserved
        blob.chk('000000000000', 'Reserved: ');
    }
    /** Break the file up into sectors */ function sectorify(file /*:RawBytes*/ , ssz /*:number*/ ) /*:Array<RawBytes>*/ {
        var nsectors = Math.ceil(file.length / ssz) - 1;
        var sectors /*:Array<RawBytes>*/  = [];
        for(var i = 1; i < nsectors; ++i)sectors[i - 1] = file.slice(i * ssz, (i + 1) * ssz);
        sectors[nsectors - 1] = file.slice(nsectors * ssz);
        return sectors;
    }
    /* [MS-CFB] 2.6.4 Red-Black Tree */ function build_full_paths(FI /*:CFBFileIndex*/ , FP /*:Array<string>*/ , Paths /*:Array<string>*/ ) /*:void*/ {
        var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
        var dad /*:Array<number>*/  = [], q /*:Array<number>*/  = [];
        for(; i < pl; ++i){
            dad[i] = q[i] = i;
            FP[i] = Paths[i];
        }
        for(; j < q.length; ++j){
            i = q[j];
            L = FI[i].L;
            R = FI[i].R;
            C = FI[i].C;
            if (dad[i] === i) {
                if (L !== -1 /*NOSTREAM*/  && dad[L] !== L) dad[i] = dad[L];
                if (R !== -1 && dad[R] !== R) dad[i] = dad[R];
            }
            if (C !== -1 /*NOSTREAM*/ ) dad[C] = i;
            if (L !== -1 && i != dad[i]) {
                dad[L] = dad[i];
                if (q.lastIndexOf(L) < j) q.push(L);
            }
            if (R !== -1 && i != dad[i]) {
                dad[R] = dad[i];
                if (q.lastIndexOf(R) < j) q.push(R);
            }
        }
        for(i = 1; i < pl; ++i)if (dad[i] === i) {
            if (R !== -1 /*NOSTREAM*/  && dad[R] !== R) dad[i] = dad[R];
            else if (L !== -1 && dad[L] !== L) dad[i] = dad[L];
        }
        for(i = 1; i < pl; ++i){
            if (FI[i].type === 0 /* unknown */ ) continue;
            j = i;
            if (j != dad[j]) do {
                j = dad[j];
                FP[i] = FP[j] + "/" + FP[i];
            }while (j !== 0 && -1 !== dad[j] && j != dad[j]);
            dad[i] = -1;
        }
        FP[0] += "/";
        for(i = 1; i < pl; ++i)if (FI[i].type !== 2 /* stream */ ) FP[i] += "/";
    }
    function get_mfat_entry(entry /*:CFBEntry*/ , payload /*:RawBytes*/ , mini /*:?RawBytes*/ ) /*:CFBlob*/ {
        var start = entry.start, size = entry.size;
        //return (payload.slice(start*MSSZ, start*MSSZ + size)/*:any*/);
        var o = [];
        var idx = start;
        while(mini && size > 0 && idx >= 0){
            o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
            size -= MSSZ;
            idx = $7c3b72a365cc0275$var$__readInt32LE(mini, idx * 4);
        }
        if (o.length === 0) return $7c3b72a365cc0275$var$new_buf(0);
        return $7c3b72a365cc0275$var$bconcat(o).slice(0, entry.size);
    }
    /** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */ function sleuth_fat(idx /*:number*/ , cnt /*:number*/ , sectors /*:Array<RawBytes>*/ , ssz /*:number*/ , fat_addrs) /*:void*/ {
        var q /*:number*/  = ENDOFCHAIN;
        if (idx === ENDOFCHAIN) {
            if (cnt !== 0) throw new Error("DIFAT chain shorter than expected");
        } else if (idx !== -1 /*FREESECT*/ ) {
            var sector = sectors[idx], m = (ssz >>> 2) - 1;
            if (!sector) return;
            for(var i = 0; i < m; ++i){
                if ((q = $7c3b72a365cc0275$var$__readInt32LE(sector, i * 4)) === ENDOFCHAIN) break;
                fat_addrs.push(q);
            }
            sleuth_fat($7c3b72a365cc0275$var$__readInt32LE(sector, ssz - 4), cnt - 1, sectors, ssz, fat_addrs);
        }
    }
    /** Follow the linked list of sectors for a given starting point */ function get_sector_list(sectors /*:Array<RawBytes>*/ , start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ , chkd /*:?Array<boolean>*/ ) /*:SectorEntry*/ {
        var buf /*:Array<number>*/  = [], buf_chain /*:Array<any>*/  = [];
        if (!chkd) chkd = [];
        var modulus = ssz - 1, j = 0, jj = 0;
        for(j = start; j >= 0;){
            chkd[j] = true;
            buf[buf.length] = j;
            buf_chain.push(sectors[j]);
            var addr = fat_addrs[Math.floor(j * 4 / ssz)];
            jj = j * 4 & modulus;
            if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
            if (!sectors[addr]) break;
            j = $7c3b72a365cc0275$var$__readInt32LE(sectors[addr], jj);
        }
        return {
            nodes: buf,
            data: $7c3b72a365cc0275$var$__toBuffer([
                buf_chain
            ])
        };
    }
    /** Chase down the sector linked lists */ function make_sector_list(sectors /*:Array<RawBytes>*/ , dir_start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ ) /*:SectorList*/ {
        var sl = sectors.length, sector_list /*:SectorList*/  = [];
        var chkd /*:Array<boolean>*/  = [], buf /*:Array<number>*/  = [], buf_chain /*:Array<RawBytes>*/  = [];
        var modulus = ssz - 1, i = 0, j = 0, k = 0, jj = 0;
        for(i = 0; i < sl; ++i){
            buf = [];
            k = i + dir_start;
            if (k >= sl) k -= sl;
            if (chkd[k]) continue;
            buf_chain = [];
            var seen = [];
            for(j = k; j >= 0;){
                seen[j] = true;
                chkd[j] = true;
                buf[buf.length] = j;
                buf_chain.push(sectors[j]);
                var addr /*:number*/  = fat_addrs[Math.floor(j * 4 / ssz)];
                jj = j * 4 & modulus;
                if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
                if (!sectors[addr]) break;
                j = $7c3b72a365cc0275$var$__readInt32LE(sectors[addr], jj);
                if (seen[j]) break;
            }
            sector_list[k] = {
                nodes: buf,
                data: $7c3b72a365cc0275$var$__toBuffer([
                    buf_chain
                ])
            } /*:SectorEntry*/ ;
        }
        return sector_list;
    }
    /* [MS-CFB] 2.6.1 Compound File Directory Entry */ function read_directory(dir_start /*:number*/ , sector_list /*:SectorList*/ , sectors /*:Array<RawBytes>*/ , Paths /*:Array<string>*/ , nmfs, files, FileIndex, mini) {
        var minifat_store = 0, pl = Paths.length ? 2 : 0;
        var sector = sector_list[dir_start].data;
        var i = 0, namelen = 0, name;
        for(; i < sector.length; i += 128){
            var blob /*:CFBlob*/  = /*::(*/ sector.slice(i, i + 128) /*:: :any)*/ ;
            $7c3b72a365cc0275$var$prep_blob(blob, 64);
            namelen = blob.read_shift(2);
            name = $7c3b72a365cc0275$var$__utf16le(blob, 0, namelen - pl);
            Paths.push(name);
            var o /*:CFBEntry*/  = {
                name: name,
                type: blob.read_shift(1),
                color: blob.read_shift(1),
                L: blob.read_shift(4, 'i'),
                R: blob.read_shift(4, 'i'),
                C: blob.read_shift(4, 'i'),
                clsid: blob.read_shift(16),
                state: blob.read_shift(4, 'i'),
                start: 0,
                size: 0
            };
            var ctime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (ctime !== 0) o.ct = read_date(blob, blob.l - 8);
            var mtime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (mtime !== 0) o.mt = read_date(blob, blob.l - 8);
            o.start = blob.read_shift(4, 'i');
            o.size = blob.read_shift(4, 'i');
            if (o.size < 0 && o.start < 0) {
                o.size = o.type = 0;
                o.start = ENDOFCHAIN;
                o.name = "";
            }
            if (o.type === 5) {
                minifat_store = o.start;
                if (nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
            /*minifat_size = o.size;*/ } else if (o.size >= 4096 /* MSCSZ */ ) {
                o.storage = 'fat';
                if (sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
                sector_list[o.start].name = o.name;
                o.content = sector_list[o.start].data.slice(0, o.size);
            } else {
                o.storage = 'minifat';
                if (o.size < 0) o.size = 0;
                else if (minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini] || {}).data);
            }
            if (o.content) $7c3b72a365cc0275$var$prep_blob(o.content, 0);
            files[name] = o;
            FileIndex.push(o);
        }
    }
    function read_date(blob /*:RawBytes|CFBlob*/ , offset /*:number*/ ) /*:Date*/ {
        return new Date(($7c3b72a365cc0275$var$__readUInt32LE(blob, offset + 4) / 1e7 * Math.pow(2, 32) + $7c3b72a365cc0275$var$__readUInt32LE(blob, offset) / 1e7 - 11644473600) * 1000);
    }
    function read_file(filename /*:string*/ , options /*:CFBReadOpts*/ ) {
        get_fs();
        return parse(fs.readFileSync(filename), options);
    }
    function read(blob /*:RawBytes|string*/ , options /*:CFBReadOpts*/ ) {
        var type = options && options.type;
        if (!type) {
            if ($7c3b72a365cc0275$var$has_buf && $7c3b72a365cc0275$require$Buffer.isBuffer(blob)) type = "buffer";
        }
        switch(type || "base64"){
            case "file":
                /*:: if(typeof blob !== 'string') throw "Must pass a filename when type='file'"; */ return read_file(blob, options);
            case "base64":
                /*:: if(typeof blob !== 'string') throw "Must pass a base64-encoded binary string when type='file'"; */ return parse($7c3b72a365cc0275$var$s2a($7c3b72a365cc0275$var$Base64_decode(blob)), options);
            case "binary":
                /*:: if(typeof blob !== 'string') throw "Must pass a binary string when type='file'"; */ return parse($7c3b72a365cc0275$var$s2a(blob), options);
        }
        return parse(/*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */ blob, options);
    }
    function init_cfb(cfb /*:CFBContainer*/ , opts /*:?any*/ ) /*:void*/ {
        var o = opts || {}, root = o.root || "Root Entry";
        if (!cfb.FullPaths) cfb.FullPaths = [];
        if (!cfb.FileIndex) cfb.FileIndex = [];
        if (cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
        if (cfb.FullPaths.length === 0) {
            cfb.FullPaths[0] = root + "/";
            cfb.FileIndex[0] = {
                name: root,
                type: 5
            } /*:any*/ ;
        }
        if (o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
        seed_cfb(cfb);
    }
    function seed_cfb(cfb /*:CFBContainer*/ ) /*:void*/ {
        var nm = "\u0001Sh33tJ5";
        if ($7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, "/" + nm)) return;
        var p = $7c3b72a365cc0275$var$new_buf(4);
        p[0] = 55;
        p[1] = p[3] = 50;
        p[2] = 54;
        cfb.FileIndex.push({
            name: nm,
            type: 2,
            content: p,
            size: 4,
            L: 69,
            R: 69,
            C: 69
        } /*:any*/ );
        cfb.FullPaths.push(cfb.FullPaths[0] + nm);
        rebuild_cfb(cfb);
    }
    function rebuild_cfb(cfb /*:CFBContainer*/ , f /*:?boolean*/ ) /*:void*/ {
        init_cfb(cfb);
        var gc = false, s = false;
        for(var i = cfb.FullPaths.length - 1; i >= 0; --i){
            var _file = cfb.FileIndex[i];
            switch(_file.type){
                case 0:
                    if (s) gc = true;
                    else {
                        cfb.FileIndex.pop();
                        cfb.FullPaths.pop();
                    }
                    break;
                case 1:
                case 2:
                case 5:
                    s = true;
                    if (isNaN(_file.R * _file.L * _file.C)) gc = true;
                    if (_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
                    break;
                default:
                    gc = true;
                    break;
            }
        }
        if (!gc && !f) return;
        var now = new Date(1987, 1, 19), j = 0;
        // Track which names exist
        var fullPaths = Object.create ? Object.create(null) : {};
        var data /*:Array<[string, CFBEntry]>*/  = [];
        for(i = 0; i < cfb.FullPaths.length; ++i){
            fullPaths[cfb.FullPaths[i]] = true;
            if (cfb.FileIndex[i].type === 0) continue;
            data.push([
                cfb.FullPaths[i],
                cfb.FileIndex[i]
            ]);
        }
        for(i = 0; i < data.length; ++i){
            var dad = dirname(data[i][0]);
            s = fullPaths[dad];
            if (!s) {
                data.push([
                    dad,
                    {
                        name: filename(dad).replace("/", ""),
                        type: 1,
                        clsid: HEADER_CLSID,
                        ct: now,
                        mt: now,
                        content: null
                    } /*:any*/ 
                ]);
                // Add name to set
                fullPaths[dad] = true;
            }
        }
        data.sort(function(x, y) {
            return namecmp(x[0], y[0]);
        });
        cfb.FullPaths = [];
        cfb.FileIndex = [];
        for(i = 0; i < data.length; ++i){
            cfb.FullPaths[i] = data[i][0];
            cfb.FileIndex[i] = data[i][1];
        }
        for(i = 0; i < data.length; ++i){
            var elt = cfb.FileIndex[i];
            var nm = cfb.FullPaths[i];
            elt.name = filename(nm).replace("/", "");
            elt.L = elt.R = elt.C = -(elt.color = 1);
            elt.size = elt.content ? elt.content.length : 0;
            elt.start = 0;
            elt.clsid = elt.clsid || HEADER_CLSID;
            if (i === 0) {
                elt.C = data.length > 1 ? 1 : -1;
                elt.size = 0;
                elt.type = 5;
            } else if (nm.slice(-1) == "/") {
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == nm) break;
                elt.C = j >= data.length ? -1 : j;
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == dirname(nm)) break;
                elt.R = j >= data.length ? -1 : j;
                elt.type = 1;
            } else {
                if (dirname(cfb.FullPaths[i + 1] || "") == dirname(nm)) elt.R = i + 1;
                elt.type = 2;
            }
        }
    }
    function _write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var _opts = options || {};
        /* MAD is order-sensitive, skip rebuild and sort */ if (_opts.fileType == 'mad') return write_mad(cfb, _opts);
        rebuild_cfb(cfb);
        switch(_opts.fileType){
            case 'zip':
                return write_zip(cfb, _opts);
        }
        var L = function(cfb /*:CFBContainer*/ ) /*:Array<number>*/ {
            var mini_size = 0, fat_size = 0;
            for(var i = 0; i < cfb.FileIndex.length; ++i){
                var file = cfb.FileIndex[i];
                if (!file.content) continue;
                /*:: if(file.content == null) throw new Error("unreachable"); */ var flen = file.content.length;
                if (flen > 0) {
                    if (flen < 0x1000) mini_size += flen + 0x3F >> 6;
                    else fat_size += flen + 0x01FF >> 9;
                }
            }
            var dir_cnt = cfb.FullPaths.length + 3 >> 2;
            var mini_cnt = mini_size + 7 >> 3;
            var mfat_cnt = mini_size + 0x7F >> 7;
            var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
            var fat_cnt = fat_base + 0x7F >> 7;
            var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            while(fat_base + fat_cnt + difat_cnt + 0x7F >> 7 > fat_cnt)difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            var L = [
                1,
                difat_cnt,
                fat_cnt,
                mfat_cnt,
                dir_cnt,
                fat_size,
                mini_size,
                0
            ];
            cfb.FileIndex[0].size = mini_size << 6;
            L[7] = (cfb.FileIndex[0].start = L[0] + L[1] + L[2] + L[3] + L[4] + L[5]) + (L[6] + 7 >> 3);
            return L;
        }(cfb);
        var o = $7c3b72a365cc0275$var$new_buf(L[7] << 9);
        var i = 0, T = 0;
        for(i = 0; i < 8; ++i)o.write_shift(1, HEADER_SIG[i]);
        for(i = 0; i < 8; ++i)o.write_shift(2, 0);
        o.write_shift(2, 0x003E);
        o.write_shift(2, 0x0003);
        o.write_shift(2, 0xFFFE);
        o.write_shift(2, 0x0009);
        o.write_shift(2, 0x0006);
        for(i = 0; i < 3; ++i)o.write_shift(2, 0);
        o.write_shift(4, 0);
        o.write_shift(4, L[2]);
        o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
        o.write_shift(4, 0);
        o.write_shift(4, 4096);
        o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[3]);
        o.write_shift(-4, L[1] ? L[0] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[1]);
        for(i = 0; i < 109; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
        if (L[1]) for(T = 0; T < L[1]; ++T){
            for(; i < 236 + T * 127; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
            o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
        }
        var chainit = function(w /*:number*/ ) /*:void*/ {
            for(T += w; i < T - 1; ++i)o.write_shift(-4, i + 1);
            if (w) {
                ++i;
                o.write_shift(-4, ENDOFCHAIN);
            }
        };
        T = i = 0;
        for(T += L[1]; i < T; ++i)o.write_shift(-4, consts.DIFSECT);
        for(T += L[2]; i < T; ++i)o.write_shift(-4, consts.FATSECT);
        chainit(L[3]);
        chainit(L[4]);
        var j /*:number*/  = 0, flen /*:number*/  = 0;
        var file /*:CFBEntry*/  = cfb.FileIndex[0];
        for(; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (flen < 0x1000) continue;
            file.start = T;
            chainit(flen + 0x01FF >> 9);
        }
        chainit(L[6] + 7 >> 3);
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        T = i = 0;
        for(j = 0; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (!flen || flen >= 0x1000) continue;
            file.start = T;
            chainit(flen + 0x3F >> 6);
        }
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        for(i = 0; i < L[4] << 2; ++i){
            var nm = cfb.FullPaths[i];
            if (!nm || nm.length === 0) {
                for(j = 0; j < 17; ++j)o.write_shift(4, 0);
                for(j = 0; j < 3; ++j)o.write_shift(4, -1);
                for(j = 0; j < 12; ++j)o.write_shift(4, 0);
                continue;
            }
            file = cfb.FileIndex[i];
            if (i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
            var _nm /*:string*/  = i === 0 && _opts.root || file.name;
            flen = 2 * (_nm.length + 1);
            o.write_shift(64, _nm, "utf16le");
            o.write_shift(2, flen);
            o.write_shift(1, file.type);
            o.write_shift(1, file.color);
            o.write_shift(-4, file.L);
            o.write_shift(-4, file.R);
            o.write_shift(-4, file.C);
            if (!file.clsid) for(j = 0; j < 4; ++j)o.write_shift(4, 0);
            else o.write_shift(16, file.clsid, "hex");
            o.write_shift(4, file.state || 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, file.start);
            o.write_shift(4, file.size);
            o.write_shift(4, 0);
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size >= 0x1000) {
                o.l = file.start + 1 << 9;
                if ($7c3b72a365cc0275$var$has_buf && $7c3b72a365cc0275$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 511 & -512;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x1FF; ++j)o.write_shift(1, 0);
                }
            }
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size > 0 && file.size < 0x1000) {
                if ($7c3b72a365cc0275$var$has_buf && $7c3b72a365cc0275$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 63 & -64;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x3F; ++j)o.write_shift(1, 0);
                }
            }
        }
        if ($7c3b72a365cc0275$var$has_buf) o.l = o.length;
        else // When using Buffer, already 0-filled
        while(o.l < o.length)o.write_shift(1, 0);
        return o;
    }
    /* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */ function find(cfb /*:CFBContainer*/ , path /*:string*/ ) /*:?CFBEntry*/ {
        var UCFullPaths /*:Array<string>*/  = cfb.FullPaths.map(function(x) {
            return x.toUpperCase();
        });
        var UCPaths /*:Array<string>*/  = UCFullPaths.map(function(x) {
            var y = x.split("/");
            return y[y.length - (x.slice(-1) == "/" ? 2 : 1)];
        });
        var k /*:boolean*/  = false;
        if (path.charCodeAt(0) === 47 /* "/" */ ) {
            k = true;
            path = UCFullPaths[0].slice(0, -1) + path;
        } else k = path.indexOf("/") !== -1;
        var UCPath /*:string*/  = path.toUpperCase();
        var w /*:number*/  = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
        if (w !== -1) return cfb.FileIndex[w];
        var m = !UCPath.match($7c3b72a365cc0275$var$chr1);
        UCPath = UCPath.replace($7c3b72a365cc0275$var$chr0, '');
        if (m) UCPath = UCPath.replace($7c3b72a365cc0275$var$chr1, '!');
        for(w = 0; w < UCFullPaths.length; ++w){
            if ((m ? UCFullPaths[w].replace($7c3b72a365cc0275$var$chr1, '!') : UCFullPaths[w]).replace($7c3b72a365cc0275$var$chr0, '') == UCPath) return cfb.FileIndex[w];
            if ((m ? UCPaths[w].replace($7c3b72a365cc0275$var$chr1, '!') : UCPaths[w]).replace($7c3b72a365cc0275$var$chr0, '') == UCPath) return cfb.FileIndex[w];
        }
        return null;
    }
    /** CFB Constants */ var MSSZ = 64; /* Mini Sector Size = 1<<6 */ 
    //var MSCSZ = 4096; /* Mini Stream Cutoff Size */
    /* 2.1 Compound File Sector Numbers and Types */ var ENDOFCHAIN = -2;
    /* 2.2 Compound File Header */ var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
    var HEADER_SIG = [
        0xD0,
        0xCF,
        0x11,
        0xE0,
        0xA1,
        0xB1,
        0x1A,
        0xE1
    ];
    var HEADER_CLSID = '00000000000000000000000000000000';
    var consts = {
        /* 2.1 Compund File Sector Numbers and Types */ MAXREGSECT: -6,
        DIFSECT: -4,
        FATSECT: -3,
        ENDOFCHAIN: ENDOFCHAIN,
        FREESECT: -1,
        /* 2.2 Compound File Header */ HEADER_SIGNATURE: HEADER_SIGNATURE,
        HEADER_MINOR_VERSION: '3e00',
        MAXREGSID: -6,
        NOSTREAM: -1,
        HEADER_CLSID: HEADER_CLSID,
        /* 2.6.1 Compound File Directory Entry */ EntryTypes: [
            'unknown',
            'storage',
            'stream',
            'lockbytes',
            'property',
            'root'
        ]
    };
    function write_file(cfb /*:CFBContainer*/ , filename /*:string*/ , options /*:CFBWriteOpts*/ ) /*:void*/ {
        get_fs();
        var o = _write(cfb, options);
        /*:: if(typeof Buffer == 'undefined' || !Buffer.isBuffer(o) || !(o instanceof Buffer)) throw new Error("unreachable"); */ fs.writeFileSync(filename, o);
    }
    function a2s(o /*:RawBytes*/ ) /*:string*/ {
        var out = new Array(o.length);
        for(var i = 0; i < o.length; ++i)out[i] = String.fromCharCode(o[i]);
        return out.join("");
    }
    function write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var o = _write(cfb, options);
        switch(options && options.type || "buffer"){
            case "file":
                get_fs();
                fs.writeFileSync(options.filename, o /*:any*/ );
                return o;
            case "binary":
                return typeof o == "string" ? o : a2s(o);
            case "base64":
                return $7c3b72a365cc0275$var$Base64_encode(typeof o == "string" ? o : a2s(o));
            case "buffer":
                if ($7c3b72a365cc0275$var$has_buf) return $7c3b72a365cc0275$require$Buffer.isBuffer(o) ? o : $7c3b72a365cc0275$var$Buffer_from(o);
            /* falls through */ case "array":
                return typeof o == "string" ? $7c3b72a365cc0275$var$s2a(o) : o;
        }
        return o;
    }
    /* node < 8.1 zlib does not expose bytesRead, so default to pure JS */ var _zlib;
    function use_zlib(zlib) {
        try {
            var InflateRaw = zlib.InflateRaw;
            var InflRaw = new InflateRaw();
            InflRaw._processChunk(new Uint8Array([
                3,
                0
            ]), InflRaw._finishFlushFlag);
            if (InflRaw.bytesRead) _zlib = zlib;
            else throw new Error("zlib does not expose bytesRead");
        } catch (e) {
            console.error("cannot use native zlib: " + (e.message || e));
        }
    }
    function _inflateRawSync(payload, usz) {
        if (!_zlib) return _inflate(payload, usz);
        var InflateRaw = _zlib.InflateRaw;
        var InflRaw = new InflateRaw();
        var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
        payload.l += InflRaw.bytesRead;
        return out;
    }
    function _deflateRawSync(payload) {
        return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
    }
    var CLEN_ORDER = [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    /*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */ var LEN_LN = [
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258
    ];
    /*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */ var DST_LN = [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577
    ];
    function bit_swap_8(n) {
        var t = (n << 1 | n << 11) & 0x22110 | (n << 5 | n << 15) & 0x88440;
        return (t >> 16 | t >> 8 | t) & 0xFF;
    }
    var use_typed_arrays = typeof Uint8Array !== 'undefined';
    var bitswap8 = use_typed_arrays ? new Uint8Array(256) : [];
    for(var q = 0; q < 256; ++q)bitswap8[q] = bit_swap_8(q);
    function bit_swap_n(n, b) {
        var rev = bitswap8[n & 0xFF];
        if (b <= 8) return rev >>> 8 - b;
        rev = rev << 8 | bitswap8[n >> 8 & 0xFF];
        if (b <= 16) return rev >>> 16 - b;
        rev = rev << 8 | bitswap8[n >> 16 & 0xFF];
        return rev >>> 24 - b;
    }
    /* helpers for unaligned bit reads */ function read_bits_2(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 6 ? 0 : buf[h + 1] << 8)) >>> w & 0x03;
    }
    function read_bits_3(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 5 ? 0 : buf[h + 1] << 8)) >>> w & 0x07;
    }
    function read_bits_4(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 4 ? 0 : buf[h + 1] << 8)) >>> w & 0x0F;
    }
    function read_bits_5(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 3 ? 0 : buf[h + 1] << 8)) >>> w & 0x1F;
    }
    function read_bits_7(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 1 ? 0 : buf[h + 1] << 8)) >>> w & 0x7F;
    }
    /* works up to n = 3 * 8 + 1 = 25 */ function read_bits_n(buf, bl, n) {
        var w = bl & 7, h = bl >>> 3, f = (1 << n) - 1;
        var v = buf[h] >>> w;
        if (n < 8 - w) return v & f;
        v |= buf[h + 1] << 8 - w;
        if (n < 16 - w) return v & f;
        v |= buf[h + 2] << 16 - w;
        if (n < 24 - w) return v & f;
        v |= buf[h + 3] << 24 - w;
        return v & f;
    }
    /* helpers for unaligned bit writes */ function write_bits_3(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        if (w <= 5) buf[h] |= (v & 7) << w;
        else {
            buf[h] |= v << w & 0xFF;
            buf[h + 1] = (v & 7) >> 8 - w;
        }
        return bl + 3;
    }
    function write_bits_1(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v = (v & 1) << w;
        buf[h] |= v;
        return bl + 1;
    }
    function write_bits_8(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v;
        return bl + 8;
    }
    function write_bits_16(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v & 0xFF;
        buf[h + 2] = v >>> 8;
        return bl + 16;
    }
    /* until ArrayBuffer#realloc is a thing, fake a realloc */ function realloc(b, sz /*:number*/ ) {
        var L = b.length, M = 2 * L > sz ? 2 * L : sz + 5, i = 0;
        if (L >= sz) return b;
        if ($7c3b72a365cc0275$var$has_buf) {
            var o = $7c3b72a365cc0275$var$new_unsafe_buf(M);
            // $FlowIgnore
            if (b.copy) b.copy(o);
            else for(; i < b.length; ++i)o[i] = b[i];
            return o;
        } else if (use_typed_arrays) {
            var a = new Uint8Array(M);
            if (a.set) a.set(b);
            else for(; i < L; ++i)a[i] = b[i];
            return a;
        }
        b.length = M;
        return b;
    }
    /* zero-filled arrays for older browsers */ function zero_fill_array(n) {
        var o = new Array(n);
        for(var i = 0; i < n; ++i)o[i] = 0;
        return o;
    }
    /* build tree (used for literals and lengths) */ function build_tree(clens, cmap, MAX /*:number*/ ) /*:number*/ {
        var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
        var bl_count = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
        for(i = 0; i < 32; ++i)bl_count[i] = 0;
        for(i = L; i < MAX; ++i)clens[i] = 0;
        L = clens.length;
        var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
        /* build code tree */ for(i = 0; i < L; ++i){
            bl_count[w = clens[i]]++;
            if (maxlen < w) maxlen = w;
            ctree[i] = 0;
        }
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)bl_count[i + 16] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i){
            ccode = clens[i];
            if (ccode != 0) ctree[i] = bl_count[ccode + 16]++;
        }
        /* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bit_swap_n(ctree[i], maxlen) >> maxlen - cleni;
                for(j = (1 << maxlen + 4 - cleni) - 1; j >= 0; --j)cmap[ccode | j << cleni] = cleni & 15 | i << 4;
            }
        }
        return maxlen;
    }
    /* Fixed Huffman */ var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
    var fix_dmap = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
    if (!use_typed_arrays) {
        for(var i = 0; i < 512; ++i)fix_lmap[i] = 0;
        for(i = 0; i < 32; ++i)fix_dmap[i] = 0;
    }
    (function() {
        var dlens /*:Array<number>*/  = [];
        var i = 0;
        for(; i < 32; i++)dlens.push(5);
        build_tree(dlens, fix_dmap, 32);
        var clens /*:Array<number>*/  = [];
        i = 0;
        for(; i <= 143; i++)clens.push(8);
        for(; i <= 255; i++)clens.push(9);
        for(; i <= 279; i++)clens.push(7);
        for(; i <= 287; i++)clens.push(8);
        build_tree(clens, fix_lmap, 288);
    })();
    var _deflateRaw = /*#__PURE__*/ function _deflateRawIIFE() {
        var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
        var j = 0, k = 0;
        for(; j < DST_LN.length - 1; ++j)for(; k < DST_LN[j + 1]; ++k)DST_LN_RE[k] = j;
        for(; k < 32768; ++k)DST_LN_RE[k] = 29;
        var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
        for(j = 0, k = 0; j < LEN_LN.length - 1; ++j)for(; k < LEN_LN[j + 1]; ++k)LEN_LN_RE[k] = j;
        function write_stored(data, out) {
            var boff = 0;
            while(boff < data.length){
                var L = Math.min(0xFFFF, data.length - boff);
                var h = boff + L == data.length;
                out.write_shift(1, +h);
                out.write_shift(2, L);
                out.write_shift(2, ~L & 0xFFFF);
                while(L-- > 0)out[out.l++] = data[boff++];
            }
            return out.l;
        }
        /* Fixed Huffman */ function write_huff_fixed(data, out) {
            var bl = 0;
            var boff = 0;
            var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
            while(boff < data.length){
                var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);
                /* write a stored block for short data */ if (L < 10) {
                    bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
                    if (bl & 7) bl += 8 - (bl & 7);
                    out.l = bl / 8 | 0;
                    out.write_shift(2, L);
                    out.write_shift(2, ~L & 0xFFFF);
                    while(L-- > 0)out[out.l++] = data[boff++];
                    bl = out.l * 8;
                    continue;
                }
                bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
                var hash = 0;
                while(L-- > 0){
                    var d = data[boff];
                    hash = (hash << 5 ^ d) & 0x7FFF;
                    var match = -1, mlen = 0;
                    if (match = addrs[hash]) {
                        match |= boff & -32768;
                        if (match > boff) match -= 0x8000;
                        if (match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250)++mlen;
                    }
                    if (mlen > 2) {
                        /* Copy Token  */ d = LEN_LN_RE[mlen];
                        if (d <= 22) bl = write_bits_8(out, bl, bitswap8[d + 1] >> 1) - 1;
                        else {
                            write_bits_8(out, bl, 3);
                            bl += 5;
                            write_bits_8(out, bl, bitswap8[d - 23] >> 5);
                            bl += 3;
                        }
                        var len_eb = d < 8 ? 0 : d - 4 >> 2;
                        if (len_eb > 0) {
                            write_bits_16(out, bl, mlen - LEN_LN[d]);
                            bl += len_eb;
                        }
                        d = DST_LN_RE[boff - match];
                        bl = write_bits_8(out, bl, bitswap8[d] >> 3);
                        bl -= 3;
                        var dst_eb = d < 4 ? 0 : d - 2 >> 1;
                        if (dst_eb > 0) {
                            write_bits_16(out, bl, boff - match - DST_LN[d]);
                            bl += dst_eb;
                        }
                        for(var q = 0; q < mlen; ++q){
                            addrs[hash] = boff & 0x7FFF;
                            hash = (hash << 5 ^ data[boff]) & 0x7FFF;
                            ++boff;
                        }
                        L -= mlen - 1;
                    } else {
                        /* Literal Token */ if (d <= 143) d = d + 48;
                        else bl = write_bits_1(out, bl, 1);
                        bl = write_bits_8(out, bl, bitswap8[d]);
                        addrs[hash] = boff & 0x7FFF;
                        ++boff;
                    }
                }
                bl = write_bits_8(out, bl, 0) - 1;
            }
            out.l = (bl + 7) / 8 | 0;
            return out.l;
        }
        return function _deflateRaw(data, out) {
            if (data.length < 8) return write_stored(data, out);
            return write_huff_fixed(data, out);
        };
    }();
    function _deflate(data) {
        var buf = $7c3b72a365cc0275$var$new_buf(50 + Math.floor(data.length * 1.1));
        var off = _deflateRaw(data, buf);
        return buf.slice(0, off);
    }
    /* modified inflate function also moves original read head */ var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_cmap = use_typed_arrays ? new Uint16Array(128) : zero_fill_array(128);
    var dyn_len_1 = 1, dyn_len_2 = 1;
    /* 5.5.3 Expanding Huffman Codes */ function dyn(data, boff /*:number*/ ) {
        /* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */ var _HLIT = read_bits_5(data, boff) + 257;
        boff += 5;
        var _HDIST = read_bits_5(data, boff) + 1;
        boff += 5;
        var _HCLEN = read_bits_4(data, boff) + 4;
        boff += 4;
        var w = 0;
        /* grab and store code lengths */ var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
        var ctree = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var maxlen = 1;
        var bl_count = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var L = clens.length; /* 19 */ 
        for(var i = 0; i < _HCLEN; ++i){
            clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
            if (maxlen < w) maxlen = w;
            bl_count[w]++;
            boff += 3;
        }
        /* build code tree */ var ccode = 0;
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)next_code[i] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i)if ((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
        /* cmap[7 bits from stream] = (off&7) + (lit<<3) */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bitswap8[ctree[i]] >> 8 - cleni;
                for(var j = (1 << 7 - cleni) - 1; j >= 0; --j)dyn_cmap[ccode | j << cleni] = cleni & 7 | i << 3;
            }
        }
        /* read literal and dist codes at once */ var hcodes /*:Array<number>*/  = [];
        maxlen = 1;
        for(; hcodes.length < _HLIT + _HDIST;){
            ccode = dyn_cmap[read_bits_7(data, boff)];
            boff += ccode & 7;
            switch(ccode >>>= 3){
                case 16:
                    w = 3 + read_bits_2(data, boff);
                    boff += 2;
                    ccode = hcodes[hcodes.length - 1];
                    while(w-- > 0)hcodes.push(ccode);
                    break;
                case 17:
                    w = 3 + read_bits_3(data, boff);
                    boff += 3;
                    while(w-- > 0)hcodes.push(0);
                    break;
                case 18:
                    w = 11 + read_bits_7(data, boff);
                    boff += 7;
                    while(w-- > 0)hcodes.push(0);
                    break;
                default:
                    hcodes.push(ccode);
                    if (maxlen < ccode) maxlen = ccode;
                    break;
            }
        }
        /* build literal / length trees */ var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
        for(i = _HLIT; i < 286; ++i)h1[i] = 0;
        for(i = _HDIST; i < 30; ++i)h2[i] = 0;
        dyn_len_1 = build_tree(h1, dyn_lmap, 286);
        dyn_len_2 = build_tree(h2, dyn_dmap, 30);
        return boff;
    }
    /* return [ data, bytesRead ] */ function inflate(data, usz /*:number*/ ) {
        /* shortcircuit for empty buffer [0x03, 0x00] */ if (data[0] == 3 && !(data[1] & 0x3)) return [
            $7c3b72a365cc0275$var$new_raw_buf(usz),
            2
        ];
        /* bit offset */ var boff = 0;
        /* header includes final bit and type bits */ var header = 0;
        var outbuf = $7c3b72a365cc0275$var$new_unsafe_buf(usz ? usz : 262144);
        var woff = 0;
        var OL = outbuf.length >>> 0;
        var max_len_1 = 0, max_len_2 = 0;
        while((header & 1) == 0){
            header = read_bits_3(data, boff);
            boff += 3;
            if (header >>> 1 == 0) {
                /* Stored block */ if (boff & 7) boff += 8 - (boff & 7);
                /* 2 bytes sz, 2 bytes bit inverse */ var sz = data[boff >>> 3] | data[(boff >>> 3) + 1] << 8;
                boff += 32;
                /* push sz bytes */ if (sz > 0) {
                    if (!usz && OL < woff + sz) {
                        outbuf = realloc(outbuf, woff + sz);
                        OL = outbuf.length;
                    }
                    while(sz-- > 0){
                        outbuf[woff++] = data[boff >>> 3];
                        boff += 8;
                    }
                }
                continue;
            } else if (header >> 1 == 1) {
                /* Fixed Huffman */ max_len_1 = 9;
                max_len_2 = 5;
            } else {
                /* Dynamic Huffman */ boff = dyn(data, boff);
                max_len_1 = dyn_len_1;
                max_len_2 = dyn_len_2;
            }
            for(;;){
                if (!usz && OL < woff + 32767) {
                    outbuf = realloc(outbuf, woff + 32767);
                    OL = outbuf.length;
                }
                /* ingest code and move read head */ var bits = read_bits_n(data, boff, max_len_1);
                var code = header >>> 1 == 1 ? fix_lmap[bits] : dyn_lmap[bits];
                boff += code & 15;
                code >>>= 4;
                /* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */ if ((code >>> 8 & 0xFF) === 0) outbuf[woff++] = code;
                else if (code == 256) break;
                else {
                    code -= 257;
                    var len_eb = code < 8 ? 0 : code - 4 >> 2;
                    if (len_eb > 5) len_eb = 0;
                    var tgt = woff + LEN_LN[code];
                    /* length extra bits */ if (len_eb > 0) {
                        tgt += read_bits_n(data, boff, len_eb);
                        boff += len_eb;
                    }
                    /* dist code */ bits = read_bits_n(data, boff, max_len_2);
                    code = header >>> 1 == 1 ? fix_dmap[bits] : dyn_dmap[bits];
                    boff += code & 15;
                    code >>>= 4;
                    var dst_eb = code < 4 ? 0 : code - 2 >> 1;
                    var dst = DST_LN[code];
                    /* dist extra bits */ if (dst_eb > 0) {
                        dst += read_bits_n(data, boff, dst_eb);
                        boff += dst_eb;
                    }
                    /* in the common case, manual byte copy is faster than TA set / Buffer copy */ if (!usz && OL < tgt) {
                        outbuf = realloc(outbuf, tgt + 100);
                        OL = outbuf.length;
                    }
                    while(woff < tgt){
                        outbuf[woff] = outbuf[woff - dst];
                        ++woff;
                    }
                }
            }
        }
        if (usz) return [
            outbuf,
            boff + 7 >>> 3
        ];
        return [
            outbuf.slice(0, woff),
            boff + 7 >>> 3
        ];
    }
    function _inflate(payload, usz) {
        var data = payload.slice(payload.l || 0);
        var out = inflate(data, usz);
        payload.l += out[1];
        return out[0];
    }
    function warn_or_throw(wrn, msg) {
        if (wrn) {
            if (typeof console !== 'undefined') console.error(msg);
        } else throw new Error(msg);
    }
    function parse_zip(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        var blob /*:CFBlob*/  = /*::(*/ file /*:: :any)*/ ;
        $7c3b72a365cc0275$var$prep_blob(blob, 0);
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o, {
            root: options.root
        });
        /* find end of central directory, start just after signature */ var i = blob.length - 4;
        while((blob[i] != 0x50 || blob[i + 1] != 0x4b || blob[i + 2] != 0x05 || blob[i + 3] != 0x06) && i >= 0)--i;
        blob.l = i + 4;
        /* parse end of central directory */ blob.l += 4;
        var fcnt = blob.read_shift(2);
        blob.l += 6;
        var start_cd = blob.read_shift(4);
        /* parse central directory */ blob.l = start_cd;
        for(i = 0; i < fcnt; ++i){
            /* trust local file header instead of CD entry */ blob.l += 20;
            var csz = blob.read_shift(4);
            var usz = blob.read_shift(4);
            var namelen = blob.read_shift(2);
            var efsz = blob.read_shift(2);
            var fcsz = blob.read_shift(2);
            blob.l += 8;
            var offset = blob.read_shift(4);
            var EF = parse_extra_field(/*::(*/ blob.slice(blob.l + namelen, blob.l + namelen + efsz));
            blob.l += namelen + efsz + fcsz;
            var L = blob.l;
            blob.l = offset + 4;
            parse_local_file(blob, csz, usz, o, EF);
            blob.l = L;
        }
        return o;
    }
    /* head starts just after local file header signature */ function parse_local_file(blob /*:CFBlob*/ , csz /*:number*/ , usz /*:number*/ , o /*:CFBContainer*/ , EF) {
        /* [local file header] */ blob.l += 2;
        var flags = blob.read_shift(2);
        var meth = blob.read_shift(2);
        var date = parse_dos_date(blob);
        if (flags & 0x2041) throw new Error("Unsupported ZIP encryption");
        var crc32 = blob.read_shift(4);
        var _csz = blob.read_shift(4);
        var _usz = blob.read_shift(4);
        var namelen = blob.read_shift(2);
        var efsz = blob.read_shift(2);
        // TODO: flags & (1<<11) // UTF8
        var name = "";
        for(var i = 0; i < namelen; ++i)name += String.fromCharCode(blob[blob.l++]);
        if (efsz) {
            var ef = parse_extra_field(/*::(*/ blob.slice(blob.l, blob.l + efsz));
            if ((ef[0x5455] || {}).mt) date = ef[0x5455].mt;
            if (((EF || {})[0x5455] || {}).mt) date = EF[0x5455].mt;
        }
        blob.l += efsz;
        /* [encryption header] */ /* [file data] */ var data = blob.slice(blob.l, blob.l + _csz);
        switch(meth){
            case 8:
                data = _inflateRawSync(blob, _usz);
                break;
            case 0:
                break; // TODO: scan for magic number
            default:
                throw new Error("Unsupported ZIP Compression method " + meth);
        }
        /* [data descriptor] */ var wrn = false;
        if (flags & 8) {
            crc32 = blob.read_shift(4);
            if (crc32 == 0x08074b50) {
                crc32 = blob.read_shift(4);
                wrn = true;
            }
            _csz = blob.read_shift(4);
            _usz = blob.read_shift(4);
        }
        if (_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
        if (_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
        //var _crc32 = CRC32.buf(data, 0);
        //if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
        cfb_add(o, name, data, {
            unsafe: true,
            mt: date
        });
    }
    function write_zip(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes*/ {
        var _opts = options || {};
        var out = [], cdirs = [];
        var o /*:CFBlob*/  = $7c3b72a365cc0275$var$new_buf(1);
        var method = _opts.compression ? 8 : 0, flags = 0;
        var desc = false;
        if (desc) flags |= 8;
        var i = 0, j = 0;
        var start_cd = 0, fcnt = 0;
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        var crcs = [];
        var sz_cd = 0;
        for(i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
            var start = start_cd;
            /* TODO: CP437 filename */ var namebuf = $7c3b72a365cc0275$var$new_buf(fp.length);
            for(j = 0; j < fp.length; ++j)namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
            namebuf = namebuf.slice(0, namebuf.l);
            crcs[fcnt] = $7c3b72a365cc0275$var$CRC32.buf(/*::((*/ fi.content /*::||[]):any)*/ , 0);
            var outbuf = fi.content /*::||[]*/ ;
            if (method == 8) outbuf = _deflateRawSync(outbuf);
            /* local file header */ o = $7c3b72a365cc0275$var$new_buf(30);
            o.write_shift(4, 0x04034b50);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            /* TODO: last mod file time/date */ if (fi.mt) write_dos_date(o, fi.mt);
            else o.write_shift(4, 0);
            o.write_shift(-4, flags & 8 ? 0 : crcs[fcnt]);
            o.write_shift(4, flags & 8 ? 0 : outbuf.length);
            o.write_shift(4, flags & 8 ? 0 : /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            start_cd += o.length;
            out.push(o);
            start_cd += namebuf.length;
            out.push(namebuf);
            /* TODO: extra fields? */ /* TODO: encryption header ? */ start_cd += outbuf.length;
            out.push(outbuf);
            /* data descriptor */ if (flags & 8) {
                o = $7c3b72a365cc0275$var$new_buf(12);
                o.write_shift(-4, crcs[fcnt]);
                o.write_shift(4, outbuf.length);
                o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
                start_cd += o.l;
                out.push(o);
            }
            /* central directory */ o = $7c3b72a365cc0275$var$new_buf(46);
            o.write_shift(4, 0x02014b50);
            o.write_shift(2, 0);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            o.write_shift(4, 0); /* TODO: last mod file time/date */ 
            o.write_shift(-4, crcs[fcnt]);
            o.write_shift(4, outbuf.length);
            o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(4, 0);
            o.write_shift(4, start);
            sz_cd += o.l;
            cdirs.push(o);
            sz_cd += namebuf.length;
            cdirs.push(namebuf);
            ++fcnt;
        }
        /* end of central directory */ o = $7c3b72a365cc0275$var$new_buf(22);
        o.write_shift(4, 0x06054b50);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, fcnt);
        o.write_shift(2, fcnt);
        o.write_shift(4, sz_cd);
        o.write_shift(4, start_cd);
        o.write_shift(2, 0);
        return $7c3b72a365cc0275$var$bconcat([
            $7c3b72a365cc0275$var$bconcat(out /*:any*/ ),
            $7c3b72a365cc0275$var$bconcat(cdirs),
            o
        ]);
    }
    var ContentTypeMap = {
        "htm": "text/html",
        "xml": "text/xml",
        "gif": "image/gif",
        "jpg": "image/jpeg",
        "png": "image/png",
        "mso": "application/x-mso",
        "thmx": "application/vnd.ms-officetheme",
        "sh33tj5": "application/octet-stream"
    } /*:any*/ ;
    function get_content_type(fi /*:CFBEntry*/ , fp /*:string*/ ) /*:string*/ {
        if (fi.ctype) return fi.ctype;
        var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
        if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        if (fp) {
            m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
            if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        }
        return "application/octet-stream";
    }
    /* 76 character chunks TODO: intertwine encoding */ function write_base64_76(bstr /*:string*/ ) /*:string*/ {
        var data = $7c3b72a365cc0275$var$Base64_encode(bstr);
        var o = [];
        for(var i = 0; i < data.length; i += 76)o.push(data.slice(i, i + 76));
        return o.join("\r\n") + "\r\n";
    }
    /*
Rules for QP:
	- escape =## applies for all non-display characters and literal "="
	- space or tab at end of line must be encoded
	- \r\n newlines can be preserved, but bare \r and \n must be escaped
	- lines must not exceed 76 characters, use soft breaks =\r\n

TODO: Some files from word appear to write line extensions with bare equals:

```
<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
="70%"
```
*/ function write_quoted_printable(text /*:string*/ ) /*:string*/ {
        var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
            var w = c.charCodeAt(0).toString(16).toUpperCase();
            return "=" + (w.length == 1 ? "0" + w : w);
        });
        encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");
        if (encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
        encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");
        var o /*:Array<string>*/  = [], split = encoded.split("\r\n");
        for(var si = 0; si < split.length; ++si){
            var str = split[si];
            if (str.length == 0) {
                o.push("");
                continue;
            }
            for(var i = 0; i < str.length;){
                var end = 76;
                var tmp = str.slice(i, i + end);
                if (tmp.charAt(end - 1) == "=") end--;
                else if (tmp.charAt(end - 2) == "=") end -= 2;
                else if (tmp.charAt(end - 3) == "=") end -= 3;
                tmp = str.slice(i, i + end);
                i += end;
                if (i < str.length) tmp += "=";
                o.push(tmp);
            }
        }
        return o.join("\r\n");
    }
    function parse_quoted_printable(data /*:Array<string>*/ ) /*:RawBytes*/ {
        var o = [];
        /* unify long lines */ for(var di = 0; di < data.length; ++di){
            var line = data[di];
            while(di <= data.length && line.charAt(line.length - 1) == "=")line = line.slice(0, line.length - 1) + data[++di];
            o.push(line);
        }
        /* decode */ for(var oi = 0; oi < o.length; ++oi)o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) {
            return String.fromCharCode(parseInt($$.slice(1), 16));
        });
        return $7c3b72a365cc0275$var$s2a(o.join("\r\n"));
    }
    function parse_mime(cfb /*:CFBContainer*/ , data /*:Array<string>*/ , root /*:string*/ ) /*:void*/ {
        var fname = "", cte = "", ctype = "", fdata;
        var di = 0;
        for(; di < 10; ++di){
            var line = data[di];
            if (!line || line.match(/^\s*$/)) break;
            var m = line.match(/^(.*?):\s*([^\s].*)$/);
            if (m) switch(m[1].toLowerCase()){
                case "content-location":
                    fname = m[2].trim();
                    break;
                case "content-type":
                    ctype = m[2].trim();
                    break;
                case "content-transfer-encoding":
                    cte = m[2].trim();
                    break;
            }
        }
        ++di;
        switch(cte.toLowerCase()){
            case 'base64':
                fdata = $7c3b72a365cc0275$var$s2a($7c3b72a365cc0275$var$Base64_decode(data.slice(di).join("")));
                break;
            case 'quoted-printable':
                fdata = parse_quoted_printable(data.slice(di));
                break;
            default:
                throw new Error("Unsupported Content-Transfer-Encoding " + cte);
        }
        var file = cfb_add(cfb, fname.slice(root.length), fdata, {
            unsafe: true
        });
        if (ctype) file.ctype = ctype;
    }
    function parse_mad(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (a2s(file.slice(0, 13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
        var root = options && options.root || "";
        // $FlowIgnore
        var data = ($7c3b72a365cc0275$var$has_buf && $7c3b72a365cc0275$require$Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
        var di = 0, row = "";
        /* if root is not specified, scan for the common prefix */ for(di = 0; di < data.length; ++di){
            row = data[di];
            if (!/^Content-Location:/i.test(row)) continue;
            row = row.slice(row.indexOf("file"));
            if (!root) root = row.slice(0, row.lastIndexOf("/") + 1);
            if (row.slice(0, root.length) == root) continue;
            while(root.length > 0){
                root = root.slice(0, root.length - 1);
                root = root.slice(0, root.lastIndexOf("/") + 1);
                if (row.slice(0, root.length) == root) break;
            }
        }
        var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
        if (!mboundary) throw new Error("MAD cannot find boundary");
        var boundary = "--" + (mboundary[1] || "");
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o);
        var start_di, fcnt = 0;
        for(di = 0; di < data.length; ++di){
            var line = data[di];
            if (line !== boundary && line !== boundary + "--") continue;
            if (fcnt++) parse_mime(o, data.slice(start_di, di), root);
            start_di = di;
        }
        return o;
    }
    function write_mad(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:string*/ {
        var opts = options || {};
        var boundary = opts.boundary || "SheetJS";
        boundary = '------=' + boundary;
        var out = [
            'MIME-Version: 1.0',
            'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
            '',
            '',
            ''
        ];
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        for(var i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
            /* Normalize filename */ fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
                return "_x" + c.charCodeAt(0).toString(16) + "_";
            }).replace(/[\u0080-\uFFFF]/g, function(u) {
                return "_u" + u.charCodeAt(0).toString(16) + "_";
            });
            /* Extract content as binary string */ var ca = fi.content;
            // $FlowIgnore
            var cstr = $7c3b72a365cc0275$var$has_buf && $7c3b72a365cc0275$require$Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);
            /* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */ var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
            for(var csl = 0; csl <= L; ++csl)if ((cc = cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
            var qp = dispcnt >= L * 4 / 5;
            out.push(boundary);
            out.push('Content-Location: ' + (opts.root || 'file:///C:/SheetJS/') + fp);
            out.push('Content-Transfer-Encoding: ' + (qp ? 'quoted-printable' : 'base64'));
            out.push('Content-Type: ' + get_content_type(fi, fp));
            out.push('');
            out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
        }
        out.push(boundary + '--\r\n');
        return out.join("\r\n");
    }
    function cfb_new(opts /*:?any*/ ) /*:CFBContainer*/ {
        var o /*:CFBContainer*/  = {} /*:any*/ ;
        init_cfb(o, opts);
        return o;
    }
    function cfb_add(cfb /*:CFBContainer*/ , name /*:string*/ , content /*:?RawBytes*/ , opts /*:?any*/ ) /*:CFBEntry*/ {
        var unsafe = opts && opts.unsafe;
        if (!unsafe) init_cfb(cfb);
        var file = !unsafe && $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, name);
        if (!file) {
            var fpath /*:string*/  = cfb.FullPaths[0];
            if (name.slice(0, fpath.length) == fpath) fpath = name;
            else {
                if (fpath.slice(-1) != "/") fpath += "/";
                fpath = (fpath + name).replace("//", "/");
            }
            file = {
                name: filename(name),
                type: 2
            } /*:any*/ ;
            cfb.FileIndex.push(file);
            cfb.FullPaths.push(fpath);
            if (!unsafe) $7c3b72a365cc0275$export$9f0e51cd97c572a.utils.cfb_gc(cfb);
        }
        /*:: if(!file) throw new Error("unreachable"); */ file.content = content /*:any*/ ;
        file.size = content ? content.length : 0;
        if (opts) {
            if (opts.CLSID) file.clsid = opts.CLSID;
            if (opts.mt) file.mt = opts.mt;
            if (opts.ct) file.ct = opts.ct;
        }
        return file;
    }
    function cfb_del(cfb /*:CFBContainer*/ , name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex.splice(j, 1);
                cfb.FullPaths.splice(j, 1);
                return true;
            }
        }
        return false;
    }
    function cfb_mov(cfb /*:CFBContainer*/ , old_name /*:string*/ , new_name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, old_name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex[j].name = filename(new_name);
                cfb.FullPaths[j] = new_name;
                return true;
            }
        }
        return false;
    }
    function cfb_gc(cfb /*:CFBContainer*/ ) /*:void*/ {
        rebuild_cfb(cfb, true);
    }
    exports.find = find;
    exports.read = read;
    exports.parse = parse;
    exports.write = write;
    exports.writeFile = write_file;
    exports.utils = {
        cfb_new: cfb_new,
        cfb_add: cfb_add,
        cfb_del: cfb_del,
        cfb_mov: cfb_mov,
        cfb_gc: cfb_gc,
        ReadShift: $7c3b72a365cc0275$var$ReadShift,
        CheckField: $7c3b72a365cc0275$var$CheckField,
        prep_blob: $7c3b72a365cc0275$var$prep_blob,
        bconcat: $7c3b72a365cc0275$var$bconcat,
        use_zlib: use_zlib,
        _deflateRaw: _deflate,
        _inflateRaw: _inflate,
        consts: consts
    };
    return exports;
}();
let $7c3b72a365cc0275$var$_fs = void 0;
function $7c3b72a365cc0275$export$a48eb669e1768bcf(fs) {
    $7c3b72a365cc0275$var$_fs = fs;
}
/* normalize data for blob ctor */ function $7c3b72a365cc0275$var$blobify(data) {
    if (typeof data === "string") return $7c3b72a365cc0275$var$s2ab(data);
    if (Array.isArray(data)) return $7c3b72a365cc0275$var$a2u(data);
    return data;
}
/* write or download file */ function $7c3b72a365cc0275$var$write_dl(fname /*:string*/ , payload /*:any*/ , enc /*:?string*/ ) {
    /*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */ if (typeof $7c3b72a365cc0275$var$_fs !== 'undefined' && $7c3b72a365cc0275$var$_fs.writeFileSync) return enc ? $7c3b72a365cc0275$var$_fs.writeFileSync(fname, payload, enc) : $7c3b72a365cc0275$var$_fs.writeFileSync(fname, payload);
    if (typeof Deno !== 'undefined') {
        /* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */ if (enc && typeof payload == "string") switch(enc){
            case "utf8":
                payload = new TextEncoder(enc).encode(payload);
                break;
            case "binary":
                payload = $7c3b72a365cc0275$var$s2ab(payload);
                break;
            /* TODO: binary equivalent */ default:
                throw new Error("Unsupported encoding " + enc);
        }
        return Deno.writeFileSync(fname, payload);
    }
    var data = enc == "utf8" ? $7c3b72a365cc0275$var$utf8write(payload) : payload;
    /*:: declare var IE_SaveFile: any; */ if (typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
    if (typeof Blob !== 'undefined') {
        var blob = new Blob([
            $7c3b72a365cc0275$var$blobify(data)
        ], {
            type: "application/octet-stream"
        });
        /*:: declare var navigator: any; */ if (typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
        /*:: declare var saveAs: any; */ if (typeof saveAs !== 'undefined') return saveAs(blob, fname);
        if (typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
            var url = URL.createObjectURL(blob);
            /*:: declare var chrome: any; */ if (typeof chrome === 'object' && typeof (chrome.downloads || {}).download == "function") {
                if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return chrome.downloads.download({
                    url: url,
                    filename: fname,
                    saveAs: true
                });
            }
            var a = document.createElement("a");
            if (a.download != null) {
                /*:: if(document.body == null) throw new Error("unreachable"); */ a.download = fname;
                a.href = url;
                document.body.appendChild(a);
                a.click();
                /*:: if(document.body == null) throw new Error("unreachable"); */ document.body.removeChild(a);
                if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return url;
            }
        }
    }
    // $FlowIgnore
    if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
        // $FlowIgnore
        var out = File(fname);
        out.open("w");
        out.encoding = "binary";
        if (Array.isArray(payload)) payload = $7c3b72a365cc0275$var$a2s(payload);
        out.write(payload);
        out.close();
        return payload;
    } catch (e) {
        if (!e.message || !e.message.match(/onstruct/)) throw e;
    }
    throw new Error("cannot save file " + fname);
}
/* read binary data from file */ function $7c3b72a365cc0275$var$read_binary(path /*:string*/ ) {
    if (typeof $7c3b72a365cc0275$var$_fs !== 'undefined') return $7c3b72a365cc0275$var$_fs.readFileSync(path);
    if (typeof Deno !== 'undefined') return Deno.readFileSync(path);
    // $FlowIgnore
    if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
        // $FlowIgnore
        var infile = File(path);
        infile.open("r");
        infile.encoding = "binary";
        var data = infile.read();
        infile.close();
        return data;
    } catch (e) {
        if (!e.message || !e.message.match(/onstruct/)) throw e;
    }
    throw new Error("Cannot access file " + path);
}
function $7c3b72a365cc0275$var$keys(o /*:any*/ ) /*:Array<any>*/ {
    var ks = Object.keys(o), o2 = [];
    for(var i = 0; i < ks.length; ++i)if (Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
    return o2;
}
function $7c3b72a365cc0275$var$evert_key(obj /*:any*/ , key /*:string*/ ) /*:EvertType*/ {
    var o = [], K = $7c3b72a365cc0275$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)if (o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
    return o;
}
function $7c3b72a365cc0275$var$evert(obj /*:any*/ ) /*:EvertType*/ {
    var o = [], K = $7c3b72a365cc0275$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = K[i];
    return o;
}
function $7c3b72a365cc0275$var$evert_num(obj /*:any*/ ) /*:EvertNumType*/ {
    var o = [], K = $7c3b72a365cc0275$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = parseInt(K[i], 10);
    return o;
}
function $7c3b72a365cc0275$var$evert_arr(obj /*:any*/ ) /*:EvertArrType*/ {
    var o /*:EvertArrType*/  = [], K = $7c3b72a365cc0275$var$keys(obj);
    for(var i = 0; i !== K.length; ++i){
        if (o[obj[K[i]]] == null) o[obj[K[i]]] = [];
        o[obj[K[i]]].push(K[i]);
    }
    return o;
}
var $7c3b72a365cc0275$var$basedate = /*#__PURE__*/ new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
function $7c3b72a365cc0275$var$datenum(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    if (date1904) epoch -= 126316800000;
    var dnthresh = /*#__PURE__*/ $7c3b72a365cc0275$var$basedate.getTime() + /*#__PURE__*/ (v.getTimezoneOffset() - /*#__PURE__*/ $7c3b72a365cc0275$var$basedate.getTimezoneOffset()) * 60000;
    return (epoch - dnthresh) / 86400000;
}
var $7c3b72a365cc0275$var$refdate = /*#__PURE__*/ new Date();
var $7c3b72a365cc0275$var$dnthresh = /*#__PURE__*/ $7c3b72a365cc0275$var$basedate.getTime() + /*#__PURE__*/ ($7c3b72a365cc0275$var$refdate.getTimezoneOffset() - /*#__PURE__*/ $7c3b72a365cc0275$var$basedate.getTimezoneOffset()) * 60000;
var $7c3b72a365cc0275$var$refoffset = /*#__PURE__*/ $7c3b72a365cc0275$var$refdate.getTimezoneOffset();
function $7c3b72a365cc0275$var$numdate(v /*:number*/ ) /*:Date*/ {
    var out = new Date();
    out.setTime(v * 86400000 + $7c3b72a365cc0275$var$dnthresh);
    if (out.getTimezoneOffset() !== $7c3b72a365cc0275$var$refoffset) out.setTime(out.getTime() + (out.getTimezoneOffset() - $7c3b72a365cc0275$var$refoffset) * 60000);
    return out;
}
/* ISO 8601 Duration */ function $7c3b72a365cc0275$var$parse_isodur(s) {
    var sec = 0, mt = 0, time = false;
    var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
    if (!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
    for(var i = 1; i != m.length; ++i){
        if (!m[i]) continue;
        mt = 1;
        if (i > 3) time = true;
        switch(m[i].slice(m[i].length - 1)){
            case 'Y':
                throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length - 1));
            case 'D':
                mt *= 24;
            /* falls through */ case 'H':
                mt *= 60;
            /* falls through */ case 'M':
                if (!time) throw new Error("Unsupported ISO Duration Field: M");
                else mt *= 60;
            /* falls through */ case 'S':
                break;
        }
        sec += mt * parseInt(m[i], 10);
    }
    return sec;
}
var $7c3b72a365cc0275$var$good_pd_date_1 = /*#__PURE__*/ new Date('2017-02-19T19:06:09.000Z');
var $7c3b72a365cc0275$var$good_pd_date = /*#__PURE__*/ isNaN(/*#__PURE__*/ $7c3b72a365cc0275$var$good_pd_date_1.getFullYear()) ? /*#__PURE__*/ new Date('2/19/17') : $7c3b72a365cc0275$var$good_pd_date_1;
var $7c3b72a365cc0275$var$good_pd = /*#__PURE__*/ $7c3b72a365cc0275$var$good_pd_date.getFullYear() == 2017;
/* parses a date as a local date */ function $7c3b72a365cc0275$var$parseDate(str /*:string|Date*/ , fixdate /*:?number*/ ) /*:Date*/ {
    var d = new Date(str);
    if ($7c3b72a365cc0275$var$good_pd) {
        /*:: if(fixdate == null) fixdate = 0; */ if (fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60000);
        else if (fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60000);
        return d;
    }
    if (str instanceof Date) return str;
    if ($7c3b72a365cc0275$var$good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
        var s = d.getFullYear();
        if (str.indexOf("" + s) > -1) return d;
        d.setFullYear(d.getFullYear() + 100);
        return d;
    }
    var n = str.match(/\d+/g) || [
        "2017",
        "2",
        "19",
        "0",
        "0",
        "0"
    ];
    var out = new Date(+n[0], +n[1] - 1, +n[2], +n[3] || 0, +n[4] || 0, +n[5] || 0);
    if (str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60000);
    return out;
}
function $7c3b72a365cc0275$var$cc2str(arr /*:Array<number>*/ , debomit) /*:string*/ {
    if ($7c3b72a365cc0275$var$has_buf && $7c3b72a365cc0275$require$Buffer.isBuffer(arr)) {
        if (debomit) {
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $7c3b72a365cc0275$var$utf8write(arr.slice(2).toString("utf16le"));
            if (arr[1] == 0xFE && arr[2] == 0xFF) return $7c3b72a365cc0275$var$utf8write($7c3b72a365cc0275$var$utf16beread(arr.slice(2).toString("binary")));
        }
        return arr.toString("binary");
    }
    if (typeof TextDecoder !== "undefined") try {
        if (debomit) {
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $7c3b72a365cc0275$var$utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
            if (arr[0] == 0xFE && arr[1] == 0xFF) return $7c3b72a365cc0275$var$utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
        }
        var rev = {
            "\u20ac": "\x80",
            "\u201a": "\x82",
            "\u0192": "\x83",
            "\u201e": "\x84",
            "\u2026": "\x85",
            "\u2020": "\x86",
            "\u2021": "\x87",
            "\u02c6": "\x88",
            "\u2030": "\x89",
            "\u0160": "\x8a",
            "\u2039": "\x8b",
            "\u0152": "\x8c",
            "\u017d": "\x8e",
            "\u2018": "\x91",
            "\u2019": "\x92",
            "\u201c": "\x93",
            "\u201d": "\x94",
            "\u2022": "\x95",
            "\u2013": "\x96",
            "\u2014": "\x97",
            "\u02dc": "\x98",
            "\u2122": "\x99",
            "\u0161": "\x9a",
            "\u203a": "\x9b",
            "\u0153": "\x9c",
            "\u017e": "\x9e",
            "\u0178": "\x9f"
        };
        if (Array.isArray(arr)) arr = new Uint8Array(arr);
        return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) {
            return rev[c] || c;
        });
    } catch (e) {}
    var o = [];
    for(var i = 0; i != arr.length; ++i)o.push(String.fromCharCode(arr[i]));
    return o.join("");
}
function $7c3b72a365cc0275$var$dup(o /*:any*/ ) /*:any*/ {
    if (typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
    if (typeof o != 'object' || o == null) return o;
    if (o instanceof Date) return new Date(o.getTime());
    var out = {};
    for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = $7c3b72a365cc0275$var$dup(o[k]);
    return out;
}
function $7c3b72a365cc0275$var$fill(c /*:string*/ , l /*:number*/ ) /*:string*/ {
    var o = "";
    while(o.length < l)o += c;
    return o;
}
/* TODO: stress test */ function $7c3b72a365cc0275$var$fuzzynum(s /*:string*/ ) /*:number*/ {
    var v /*:number*/  = Number(s);
    if (!isNaN(v)) return isFinite(v) ? v : NaN;
    if (!/\d/.test(s)) return v;
    var wt = 1;
    var ss = s.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
        wt *= 100;
        return "";
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    ss = ss.replace(/[(](.*)[)]/, function($$, $1) {
        wt = -wt;
        return $1;
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    return v;
}
var $7c3b72a365cc0275$var$lower_months = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december'
];
function $7c3b72a365cc0275$var$fuzzydate(s /*:string*/ ) /*:Date*/ {
    var o = new Date(s), n = new Date(NaN);
    var y = o.getYear(), m = o.getMonth(), d = o.getDate();
    if (isNaN(d)) return n;
    var lower = s.toLowerCase();
    if (lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
        lower = lower.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, "");
        if (lower.length > 3 && $7c3b72a365cc0275$var$lower_months.indexOf(lower) == -1) return n;
    } else if (lower.match(/[a-z]/)) return n;
    if (y < 0 || y > 8099) return n;
    if ((m > 0 || d > 1) && y != 101) return o;
    if (s.match(/[^-0-9:,\/\\]/)) return n;
    return o;
}
var $7c3b72a365cc0275$var$split_regex = /*#__PURE__*/ function() {
    var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
    return function split_regex(str /*:string*/ , re, def /*:string*/ ) /*:Array<string>*/ {
        if (safe_split_regex || typeof re == "string") return str.split(re);
        var p = str.split(re), o = [
            p[0]
        ];
        for(var i = 1; i < p.length; ++i){
            o.push(def);
            o.push(p[i]);
        }
        return o;
    };
}();
function $7c3b72a365cc0275$var$getdatastr(data) /*:?string*/ {
    if (!data) return null;
    if (data.content && data.type) return $7c3b72a365cc0275$var$cc2str(data.content, true);
    if (data.data) return $7c3b72a365cc0275$var$debom(data.data);
    if (data.asNodeBuffer && $7c3b72a365cc0275$var$has_buf) return $7c3b72a365cc0275$var$debom(data.asNodeBuffer().toString('binary'));
    if (data.asBinary) return $7c3b72a365cc0275$var$debom(data.asBinary());
    if (data._data && data._data.getContent) return $7c3b72a365cc0275$var$debom($7c3b72a365cc0275$var$cc2str(Array.prototype.slice.call(data._data.getContent(), 0)));
    return null;
}
function $7c3b72a365cc0275$var$getdatabin(data) {
    if (!data) return null;
    if (data.data) return $7c3b72a365cc0275$var$char_codes(data.data);
    if (data.asNodeBuffer && $7c3b72a365cc0275$var$has_buf) return data.asNodeBuffer();
    if (data._data && data._data.getContent) {
        var o = data._data.getContent();
        if (typeof o == "string") return $7c3b72a365cc0275$var$char_codes(o);
        return Array.prototype.slice.call(o);
    }
    if (data.content && data.type) return data.content;
    return null;
}
function $7c3b72a365cc0275$var$getdata(data) {
    return data && data.name.slice(-4) === ".bin" ? $7c3b72a365cc0275$var$getdatabin(data) : $7c3b72a365cc0275$var$getdatastr(data);
}
/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */ /* OASIS does not comment on filename case sensitivity */ function $7c3b72a365cc0275$var$safegetzipfile(zip, file /*:string*/ ) {
    var k = zip.FullPaths || $7c3b72a365cc0275$var$keys(zip.files);
    var f = file.toLowerCase().replace(/[\/]/g, '\\'), g = f.replace(/\\/g, '\/');
    for(var i = 0; i < k.length; ++i){
        var n = k[i].replace(/^Root Entry[\/]/, "").toLowerCase();
        if (f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
    }
    return null;
}
function $7c3b72a365cc0275$var$getzipfile(zip, file /*:string*/ ) {
    var o = $7c3b72a365cc0275$var$safegetzipfile(zip, file);
    if (o == null) throw new Error("Cannot find file " + file + " in zip");
    return o;
}
function $7c3b72a365cc0275$var$getzipdata(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $7c3b72a365cc0275$var$getdata($7c3b72a365cc0275$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $7c3b72a365cc0275$var$getzipdata(zip, file);
    } catch (e) {
        return null;
    }
}
function $7c3b72a365cc0275$var$getzipstr(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:?string*/ {
    if (!safe) return $7c3b72a365cc0275$var$getdatastr($7c3b72a365cc0275$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $7c3b72a365cc0275$var$getzipstr(zip, file);
    } catch (e) {
        return null;
    }
}
function $7c3b72a365cc0275$var$getzipbin(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $7c3b72a365cc0275$var$getdatabin($7c3b72a365cc0275$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $7c3b72a365cc0275$var$getzipbin(zip, file);
    } catch (e) {
        return null;
    }
}
function $7c3b72a365cc0275$var$zipentries(zip) {
    var k = zip.FullPaths || $7c3b72a365cc0275$var$keys(zip.files), o = [];
    for(var i = 0; i < k.length; ++i)if (k[i].slice(-1) != '/') o.push(k[i].replace(/^Root Entry[\/]/, ""));
    return o.sort();
}
function $7c3b72a365cc0275$var$zip_add_file(zip, path, content) {
    if (zip.FullPaths) {
        if (typeof content == "string") {
            var res;
            if ($7c3b72a365cc0275$var$has_buf) res = $7c3b72a365cc0275$var$Buffer_from(content);
            else res = $7c3b72a365cc0275$var$utf8decode(content);
            return $7c3b72a365cc0275$export$9f0e51cd97c572a.utils.cfb_add(zip, path, res);
        }
        $7c3b72a365cc0275$export$9f0e51cd97c572a.utils.cfb_add(zip, path, content);
    } else zip.file(path, content);
}
function $7c3b72a365cc0275$var$zip_new() {
    return $7c3b72a365cc0275$export$9f0e51cd97c572a.utils.cfb_new();
}
function $7c3b72a365cc0275$var$zip_read(d, o) {
    switch(o.type){
        case "base64":
            return $7c3b72a365cc0275$export$9f0e51cd97c572a.read(d, {
                type: "base64"
            });
        case "binary":
            return $7c3b72a365cc0275$export$9f0e51cd97c572a.read(d, {
                type: "binary"
            });
        case "buffer":
        case "array":
            return $7c3b72a365cc0275$export$9f0e51cd97c572a.read(d, {
                type: "buffer"
            });
    }
    throw new Error("Unrecognized type " + o.type);
}
function $7c3b72a365cc0275$var$resolve_path(path /*:string*/ , base /*:string*/ ) /*:string*/ {
    if (path.charAt(0) == "/") return path.slice(1);
    var result = base.split('/');
    if (base.slice(-1) != "/") result.pop(); // folder path
    var target = path.split('/');
    while(target.length !== 0){
        var step = target.shift();
        if (step === '..') result.pop();
        else if (step !== '.') result.push(step);
    }
    return result.join('/');
}
var $7c3b72a365cc0275$var$XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var $7c3b72a365cc0275$var$attregexg = /([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var $7c3b72a365cc0275$var$tagregex1 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, $7c3b72a365cc0275$var$tagregex2 = /<[^>]*>/g;
var $7c3b72a365cc0275$var$tagregex = /*#__PURE__*/ $7c3b72a365cc0275$var$XML_HEADER.match($7c3b72a365cc0275$var$tagregex1) ? $7c3b72a365cc0275$var$tagregex1 : $7c3b72a365cc0275$var$tagregex2;
var $7c3b72a365cc0275$var$nsregex = /<\w*:/, $7c3b72a365cc0275$var$nsregex2 = /<(\/?)\w+:/;
function $7c3b72a365cc0275$var$parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($7c3b72a365cc0275$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i];
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        for(j = 0; j != q.length; ++j)if (q.charCodeAt(j) === 58) break;
        if (j === q.length) {
            if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
            z[q] = v;
            if (!skip_LC) z[q.toLowerCase()] = v;
        } else {
            var k = (j === 5 && q.slice(0, 5) === "xmlns" ? "xmlns" : "") + q.slice(j + 1);
            if (z[k] && q.slice(j - 3, j) == "ext") continue; // from ods
            z[k] = v;
            if (!skip_LC) z[k.toLowerCase()] = v;
        }
    }
    return z;
}
function $7c3b72a365cc0275$var$strip_ns(x /*:string*/ ) /*:string*/ {
    return x.replace($7c3b72a365cc0275$var$nsregex2, "<$1");
}
var $7c3b72a365cc0275$var$encodings = {
    '&quot;': '"',
    '&apos;': "'",
    '&gt;': '>',
    '&lt;': '<',
    '&amp;': '&'
};
var $7c3b72a365cc0275$var$rencoding = /*#__PURE__*/ $7c3b72a365cc0275$var$evert($7c3b72a365cc0275$var$encodings);
//var rencstr = "&<>'\"".split("");
// TODO: CP remap (need to read file version to determine OS)
var $7c3b72a365cc0275$var$unescapexml /*:StringConv*/  = /*#__PURE__*/ function() {
    /* 22.4.2.4 bstr (Basic String) */ var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
    return function unescapexml(text /*:string*/ ) /*:string*/ {
        var s = text + '', i = s.indexOf("<![CDATA[");
        if (i == -1) return s.replace(encregex, function($$, $1) {
            return $7c3b72a365cc0275$var$encodings[$$] || String.fromCharCode(parseInt($1, $$.indexOf("x") > -1 ? 16 : 10)) || $$;
        }).replace(coderegex, function(m, c) {
            return String.fromCharCode(parseInt(c, 16));
        });
        var j = s.indexOf("]]>");
        return unescapexml(s.slice(0, i)) + s.slice(i + 9, j) + unescapexml(s.slice(j + 3));
    };
}();
var $7c3b72a365cc0275$var$decregex = /[&<>'"]/g, $7c3b72a365cc0275$var$charegex = /[\u0000-\u0008\u000b-\u001f]/g;
function $7c3b72a365cc0275$var$escapexml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($7c3b72a365cc0275$var$decregex, function(y) {
        return $7c3b72a365cc0275$var$rencoding[y];
    }).replace($7c3b72a365cc0275$var$charegex, function(s) {
        return "_x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + "_";
    });
}
function $7c3b72a365cc0275$var$escapexmltag(text /*:string*/ ) /*:string*/ {
    return $7c3b72a365cc0275$var$escapexml(text).replace(/ /g, "_x0020_");
}
var $7c3b72a365cc0275$var$htmlcharegex = /[\u0000-\u001f]/g;
function $7c3b72a365cc0275$var$escapehtml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($7c3b72a365cc0275$var$decregex, function(y) {
        return $7c3b72a365cc0275$var$rencoding[y];
    }).replace(/\n/g, "<br/>").replace($7c3b72a365cc0275$var$htmlcharegex, function(s) {
        return "&#x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + ";";
    });
}
function $7c3b72a365cc0275$var$escapexlml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($7c3b72a365cc0275$var$decregex, function(y) {
        return $7c3b72a365cc0275$var$rencoding[y];
    }).replace($7c3b72a365cc0275$var$htmlcharegex, function(s) {
        return "&#x" + s.charCodeAt(0).toString(16).toUpperCase() + ";";
    });
}
/* TODO: handle codepages */ var $7c3b72a365cc0275$var$xlml_fixstr /*:StringConv*/  = /*#__PURE__*/ function() {
    var entregex = /&#(\d+);/g;
    function entrepl($$ /*:string*/ , $1 /*:string*/ ) /*:string*/ {
        return String.fromCharCode(parseInt($1, 10));
    }
    return function xlml_fixstr(str /*:string*/ ) /*:string*/ {
        return str.replace(entregex, entrepl);
    };
}();
function $7c3b72a365cc0275$var$xlml_unfixstr(str /*:string*/ ) /*:string*/ {
    return str.replace(/(\r\n|[\r\n])/g, "\&#10;");
}
function $7c3b72a365cc0275$var$parsexmlbool(value /*:any*/ ) /*:boolean*/ {
    switch(value){
        case 1:
        case true:
        case '1':
        case 'true':
        case 'TRUE':
            return true;
        /* case '0': case 'false': case 'FALSE':*/ default:
            return false;
    }
}
function $7c3b72a365cc0275$var$utf8reada(orig /*:string*/ ) /*:string*/ {
    var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        if (c < 128) {
            out += String.fromCharCode(c);
            continue;
        }
        d = orig.charCodeAt(i++);
        if (c > 191 && c < 224) {
            f = (c & 31) << 6;
            f |= d & 63;
            out += String.fromCharCode(f);
            continue;
        }
        e = orig.charCodeAt(i++);
        if (c < 240) {
            out += String.fromCharCode((c & 15) << 12 | (d & 63) << 6 | e & 63);
            continue;
        }
        f = orig.charCodeAt(i++);
        w = ((c & 7) << 18 | (d & 63) << 12 | (e & 63) << 6 | f & 63) - 65536;
        out += String.fromCharCode(0xD800 + (w >>> 10 & 1023));
        out += String.fromCharCode(0xDC00 + (w & 1023));
    }
    return out;
}
function $7c3b72a365cc0275$var$utf8readb(data) {
    var out = $7c3b72a365cc0275$var$new_raw_buf(2 * data.length), w, i, j = 1, k = 0, ww = 0, c;
    for(i = 0; i < data.length; i += j){
        j = 1;
        if ((c = data.charCodeAt(i)) < 128) w = c;
        else if (c < 224) {
            w = (c & 31) * 64 + (data.charCodeAt(i + 1) & 63);
            j = 2;
        } else if (c < 240) {
            w = (c & 15) * 4096 + (data.charCodeAt(i + 1) & 63) * 64 + (data.charCodeAt(i + 2) & 63);
            j = 3;
        } else {
            j = 4;
            w = (c & 7) * 262144 + (data.charCodeAt(i + 1) & 63) * 4096 + (data.charCodeAt(i + 2) & 63) * 64 + (data.charCodeAt(i + 3) & 63);
            w -= 65536;
            ww = 0xD800 + (w >>> 10 & 1023);
            w = 0xDC00 + (w & 1023);
        }
        if (ww !== 0) {
            out[k++] = ww & 255;
            out[k++] = ww >>> 8;
            ww = 0;
        }
        out[k++] = w % 256;
        out[k++] = w >>> 8;
    }
    return out.slice(0, k).toString('ucs2');
}
function $7c3b72a365cc0275$var$utf8readc(data) {
    return $7c3b72a365cc0275$var$Buffer_from(data, 'binary').toString('utf8');
}
var $7c3b72a365cc0275$var$utf8corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
var $7c3b72a365cc0275$var$utf8read = $7c3b72a365cc0275$var$has_buf && /*#__PURE__*/ ($7c3b72a365cc0275$var$utf8readc($7c3b72a365cc0275$var$utf8corpus) == /*#__PURE__*/ $7c3b72a365cc0275$var$utf8reada($7c3b72a365cc0275$var$utf8corpus) && $7c3b72a365cc0275$var$utf8readc || /*#__PURE__*/ $7c3b72a365cc0275$var$utf8readb($7c3b72a365cc0275$var$utf8corpus) == /*#__PURE__*/ $7c3b72a365cc0275$var$utf8reada($7c3b72a365cc0275$var$utf8corpus) && $7c3b72a365cc0275$var$utf8readb) || $7c3b72a365cc0275$var$utf8reada;
var $7c3b72a365cc0275$var$utf8write /*:StringConv*/  = $7c3b72a365cc0275$var$has_buf ? function(data) {
    return $7c3b72a365cc0275$var$Buffer_from(data, 'utf8').toString("binary");
} : function(orig /*:string*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [], i = 0, c = 0, d = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        switch(true){
            case c < 128:
                out.push(String.fromCharCode(c));
                break;
            case c < 2048:
                out.push(String.fromCharCode(192 + (c >> 6)));
                out.push(String.fromCharCode(128 + (c & 63)));
                break;
            case c >= 55296 && c < 57344:
                c -= 55296;
                d = orig.charCodeAt(i++) - 56320 + (c << 10);
                out.push(String.fromCharCode(240 + (d >> 18 & 7)));
                out.push(String.fromCharCode(144 + (d >> 12 & 63)));
                out.push(String.fromCharCode(128 + (d >> 6 & 63)));
                out.push(String.fromCharCode(128 + (d & 63)));
                break;
            default:
                out.push(String.fromCharCode(224 + (c >> 12)));
                out.push(String.fromCharCode(128 + (c >> 6 & 63)));
                out.push(String.fromCharCode(128 + (c & 63)));
        }
    }
    return out.join("");
};
// matches <foo>...</foo> extracts content
var $7c3b72a365cc0275$var$matchtag = /*#__PURE__*/ function() {
    var mtcache /*:{[k:string]:RegExp}*/  = {} /*:any*/ ;
    return function matchtag(f /*:string*/ , g /*:?string*/ ) /*:RegExp*/ {
        var t = f + "|" + (g || "");
        if (mtcache[t]) return mtcache[t];
        return mtcache[t] = new RegExp('<(?:\\w+:)?' + f + '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' + f + '>', g || "");
    };
}();
var $7c3b72a365cc0275$var$htmldecode /*:{(s:string):string}*/  = /*#__PURE__*/ function() {
    var entities /*:Array<[RegExp, string]>*/  = [
        [
            'nbsp',
            ' '
        ],
        [
            'middot',
            "\xb7"
        ],
        [
            'quot',
            '"'
        ],
        [
            'apos',
            "'"
        ],
        [
            'gt',
            '>'
        ],
        [
            'lt',
            '<'
        ],
        [
            'amp',
            '&'
        ]
    ].map(function(x /*:[string, string]*/ ) {
        return [
            new RegExp('&' + x[0] + ';', "ig"),
            x[1]
        ];
    });
    return function htmldecode(str /*:string*/ ) /*:string*/ {
        var o = str// Remove new lines and spaces from start of content
        .replace(/^[\t\n\r ]+/, "")// Remove new lines and spaces from end of content
        .replace(/[\t\n\r ]+$/, "")// Added line which removes any white space characters after and before html tags
        .replace(/>\s+/g, ">").replace(/\s+</g, "<")// Replace remaining new lines and spaces with space
        .replace(/[\t\n\r ]+/g, " ")// Replace <br> tags with new lines
        .replace(/<\s*[bB][rR]\s*\/?>/g, "\n")// Strip HTML elements
        .replace(/<[^>]*>/g, "");
        for(var i = 0; i < entities.length; ++i)o = o.replace(entities[i][0], entities[i][1]);
        return o;
    };
}();
var $7c3b72a365cc0275$var$vtregex = /*#__PURE__*/ function() {
    var vt_cache = {};
    return function vt_regex(bt) {
        if (vt_cache[bt] !== undefined) return vt_cache[bt];
        return vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", 'g');
    };
}();
var $7c3b72a365cc0275$var$vtvregex = /<\/?(?:vt:)?variant>/g, $7c3b72a365cc0275$var$vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
function $7c3b72a365cc0275$var$parseVector(data /*:string*/ , opts) /*:Array<{v:string,t:string}>*/ {
    var h = $7c3b72a365cc0275$var$parsexmltag(data);
    var matches /*:Array<string>*/  = data.match($7c3b72a365cc0275$var$vtregex(h.baseType)) || [];
    var res /*:Array<any>*/  = [];
    if (matches.length != h.size) {
        if (opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
        return res;
    }
    matches.forEach(function(x /*:string*/ ) {
        var v = x.replace($7c3b72a365cc0275$var$vtvregex, "").match($7c3b72a365cc0275$var$vtmregex);
        if (v) res.push({
            v: $7c3b72a365cc0275$var$utf8read(v[2]),
            t: v[1]
        });
    });
    return res;
}
var $7c3b72a365cc0275$var$wtregex = /(^\s|\s$|\n)/;
function $7c3b72a365cc0275$var$writetag(f /*:string*/ , g /*:string*/ ) /*:string*/ {
    return '<' + f + (g.match($7c3b72a365cc0275$var$wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f + '>';
}
function $7c3b72a365cc0275$var$wxt_helper(h) /*:string*/ {
    return $7c3b72a365cc0275$var$keys(h).map(function(k) {
        return " " + k + '="' + h[k] + '"';
    }).join("");
}
function $7c3b72a365cc0275$var$writextag(f /*:string*/ , g /*:?string*/ , h) {
    return '<' + f + (h != null ? $7c3b72a365cc0275$var$wxt_helper(h) : "") + (g != null ? (g.match($7c3b72a365cc0275$var$wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';
}
function $7c3b72a365cc0275$var$write_w3cdtf(d /*:Date*/ , t /*:?boolean*/ ) /*:string*/ {
    try {
        return d.toISOString().replace(/\.\d*/, "");
    } catch (e) {
        if (t) throw e;
    }
    return "";
}
function $7c3b72a365cc0275$var$write_vt(s, xlsx /*:?boolean*/ ) /*:string*/ {
    switch(typeof s){
        case 'string':
            var o = $7c3b72a365cc0275$var$writextag('vt:lpwstr', $7c3b72a365cc0275$var$escapexml(s));
            if (xlsx) o = o.replace(/&quot;/g, "_x0022_");
            return o;
        case 'number':
            return $7c3b72a365cc0275$var$writextag((s | 0) == s ? 'vt:i4' : 'vt:r8', $7c3b72a365cc0275$var$escapexml(String(s)));
        case 'boolean':
            return $7c3b72a365cc0275$var$writextag('vt:bool', s ? 'true' : 'false');
    }
    if (s instanceof Date) return $7c3b72a365cc0275$var$writextag('vt:filetime', $7c3b72a365cc0275$var$write_w3cdtf(s));
    throw new Error("Unable to serialize " + s);
}
function $7c3b72a365cc0275$var$xlml_normalize(d) /*:string*/ {
    if ($7c3b72a365cc0275$var$has_buf && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/ $7c3b72a365cc0275$require$Buffer.isBuffer(d)) return d.toString('utf8');
    if (typeof d === 'string') return d;
    /* duktape */ if (typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return $7c3b72a365cc0275$var$utf8read($7c3b72a365cc0275$var$a2s($7c3b72a365cc0275$var$ab2a(d)));
    throw new Error("Bad input format: expected Buffer or string");
}
/* UOS uses CJK in tags */ var $7c3b72a365cc0275$var$xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg;
//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
var $7c3b72a365cc0275$var$XMLNS = {
    CORE_PROPS: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
    CT: 'http://schemas.openxmlformats.org/package/2006/content-types',
    RELS: 'http://schemas.openxmlformats.org/package/2006/relationships',
    TCMNT: 'http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments',
    'dc': 'http://purl.org/dc/elements/1.1/',
    'dcterms': 'http://purl.org/dc/terms/',
    'dcmitype': 'http://purl.org/dc/dcmitype/',
    'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
    'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
    'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
    'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
    'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
    'xsd': 'http://www.w3.org/2001/XMLSchema'
} /*:any*/ ;
var $7c3b72a365cc0275$var$XMLNS_main = [
    'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
    'http://purl.oclc.org/ooxml/spreadsheetml/main',
    'http://schemas.microsoft.com/office/excel/2006/main',
    'http://schemas.microsoft.com/office/excel/2006/2'
];
var $7c3b72a365cc0275$var$XLMLNS = {
    'o': 'urn:schemas-microsoft-com:office:office',
    'x': 'urn:schemas-microsoft-com:office:excel',
    'ss': 'urn:schemas-microsoft-com:office:spreadsheet',
    'dt': 'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
    'mv': 'http://macVmlSchemaUri',
    'v': 'urn:schemas-microsoft-com:vml',
    'html': 'http://www.w3.org/TR/REC-html40'
} /*:any*/ ;
function $7c3b72a365cc0275$var$read_double_le(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var s = 1 - 2 * (b[idx + 7] >>> 7);
    var e = ((b[idx + 7] & 0x7f) << 4) + (b[idx + 6] >>> 4 & 0x0f);
    var m = b[idx + 6] & 0x0f;
    for(var i = 5; i >= 0; --i)m = m * 256 + b[idx + i];
    if (e == 0x7ff) return m == 0 ? s * Infinity : NaN;
    if (e == 0) e = -1022;
    else {
        e -= 1023;
        m += Math.pow(2, 52);
    }
    return s * Math.pow(2, e - 52) * m;
}
function $7c3b72a365cc0275$var$write_double_le(b /*:RawBytes|CFBlob*/ , v /*:number*/ , idx /*:number*/ ) {
    var bs = (v < 0 || 1 / v == -Infinity ? 1 : 0) << 7, e = 0, m = 0;
    var av = bs ? -v : v;
    if (!isFinite(av)) {
        e = 0x7ff;
        m = isNaN(v) ? 0x6969 : 0;
    } else if (av == 0) e = m = 0;
    else {
        e = Math.floor(Math.log(av) / Math.LN2);
        m = av * Math.pow(2, 52 - e);
        if (e <= -1023 && (!isFinite(m) || m < Math.pow(2, 52))) e = -1022;
        else {
            m -= Math.pow(2, 52);
            e += 1023;
        }
    }
    for(var i = 0; i <= 5; ++i, m /= 256)b[idx + i] = m & 0xff;
    b[idx + 6] = (e & 0x0f) << 4 | m & 0xf;
    b[idx + 7] = e >> 4 | bs;
}
var $7c3b72a365cc0275$var$___toBuffer = function(bufs /*:Array<Array<RawBytes> >*/ ) /*:RawBytes*/ {
    var x = [], w = 10240;
    for(var i = 0; i < bufs[0].length; ++i)if (bufs[0][i]) for(var j = 0, L = bufs[0][i].length; j < L; j += w)x.push.apply(x, bufs[0][i].slice(j, j + w));
    return x;
};
var $7c3b72a365cc0275$var$__toBuffer = $7c3b72a365cc0275$var$has_buf ? function(bufs) {
    return bufs[0].length > 0 && $7c3b72a365cc0275$require$Buffer.isBuffer(bufs[0][0]) ? $7c3b72a365cc0275$require$Buffer.concat(bufs[0].map(function(x) {
        return $7c3b72a365cc0275$require$Buffer.isBuffer(x) ? x : $7c3b72a365cc0275$var$Buffer_from(x);
    })) : $7c3b72a365cc0275$var$___toBuffer(bufs);
} : $7c3b72a365cc0275$var$___toBuffer;
var $7c3b72a365cc0275$var$___utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < e; i += 2)ss.push(String.fromCharCode($7c3b72a365cc0275$var$__readUInt16LE(b, i)));
    return ss.join("").replace($7c3b72a365cc0275$var$chr0, '');
};
var $7c3b72a365cc0275$var$__utf16le = $7c3b72a365cc0275$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    if (!$7c3b72a365cc0275$require$Buffer.isBuffer(b)) return $7c3b72a365cc0275$var$___utf16le(b, s, e);
    return b.toString('utf16le', s, e).replace($7c3b72a365cc0275$var$chr0, '') /*.replace(chr1,'!')*/ ;
} : $7c3b72a365cc0275$var$___utf16le;
var $7c3b72a365cc0275$var$___hexlify = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < s + l; ++i)ss.push(("0" + b[i].toString(16)).slice(-2));
    return ss.join("");
};
var $7c3b72a365cc0275$var$__hexlify = $7c3b72a365cc0275$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    return $7c3b72a365cc0275$require$Buffer.isBuffer(b) ? b.toString('hex', s, s + l) : $7c3b72a365cc0275$var$___hexlify(b, s, l);
} : $7c3b72a365cc0275$var$___hexlify;
var $7c3b72a365cc0275$var$___utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    var ss = [];
    for(var i = s; i < e; i++)ss.push(String.fromCharCode($7c3b72a365cc0275$var$__readUInt8(b, i)));
    return ss.join("");
};
var $7c3b72a365cc0275$var$__utf8 = $7c3b72a365cc0275$var$has_buf ? function utf8_b(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    return $7c3b72a365cc0275$require$Buffer.isBuffer(b) ? b.toString('utf8', s, e) : $7c3b72a365cc0275$var$___utf8(b, s, e);
} : $7c3b72a365cc0275$var$___utf8;
var $7c3b72a365cc0275$var$___lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $7c3b72a365cc0275$var$__readUInt32LE(b, i);
    return len > 0 ? $7c3b72a365cc0275$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $7c3b72a365cc0275$var$__lpstr = $7c3b72a365cc0275$var$___lpstr;
var $7c3b72a365cc0275$var$___cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $7c3b72a365cc0275$var$__readUInt32LE(b, i);
    return len > 0 ? $7c3b72a365cc0275$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $7c3b72a365cc0275$var$__cpstr = $7c3b72a365cc0275$var$___cpstr;
var $7c3b72a365cc0275$var$___lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = 2 * $7c3b72a365cc0275$var$__readUInt32LE(b, i);
    return len > 0 ? $7c3b72a365cc0275$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $7c3b72a365cc0275$var$__lpwstr = $7c3b72a365cc0275$var$___lpwstr;
var $7c3b72a365cc0275$var$___lpp4 = function lpp4_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $7c3b72a365cc0275$var$__readUInt32LE(b, i);
    return len > 0 ? $7c3b72a365cc0275$var$__utf16le(b, i + 4, i + 4 + len) : "";
};
var $7c3b72a365cc0275$var$__lpp4 = $7c3b72a365cc0275$var$___lpp4;
var $7c3b72a365cc0275$var$___8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $7c3b72a365cc0275$var$__readUInt32LE(b, i);
    return len > 0 ? $7c3b72a365cc0275$var$__utf8(b, i + 4, i + 4 + len) : "";
};
var $7c3b72a365cc0275$var$__8lpp4 = $7c3b72a365cc0275$var$___8lpp4;
var $7c3b72a365cc0275$var$___double = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) {
    return $7c3b72a365cc0275$var$read_double_le(b, idx);
};
var $7c3b72a365cc0275$var$__double = $7c3b72a365cc0275$var$___double;
var $7c3b72a365cc0275$var$is_buf = function is_buf_a(a) {
    return Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
};
if ($7c3b72a365cc0275$var$has_buf /*:: && typeof Buffer !== 'undefined'*/ ) {
    $7c3b72a365cc0275$var$__lpstr = function lpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$7c3b72a365cc0275$require$Buffer.isBuffer(b)) return $7c3b72a365cc0275$var$___lpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
    };
    $7c3b72a365cc0275$var$__cpstr = function cpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$7c3b72a365cc0275$require$Buffer.isBuffer(b)) return $7c3b72a365cc0275$var$___cpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
    };
    $7c3b72a365cc0275$var$__lpwstr = function lpwstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$7c3b72a365cc0275$require$Buffer.isBuffer(b)) return $7c3b72a365cc0275$var$___lpwstr(b, i);
        var len = 2 * b.readUInt32LE(i);
        return b.toString('utf16le', i + 4, i + 4 + len - 1);
    };
    $7c3b72a365cc0275$var$__lpp4 = function lpp4_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$7c3b72a365cc0275$require$Buffer.isBuffer(b)) return $7c3b72a365cc0275$var$___lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString('utf16le', i + 4, i + 4 + len);
    };
    $7c3b72a365cc0275$var$__8lpp4 = function lpp4_8b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$7c3b72a365cc0275$require$Buffer.isBuffer(b)) return $7c3b72a365cc0275$var$___8lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString('utf8', i + 4, i + 4 + len);
    };
    $7c3b72a365cc0275$var$__double = function double_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if ($7c3b72a365cc0275$require$Buffer.isBuffer(b)) return b.readDoubleLE(i);
        return $7c3b72a365cc0275$var$___double(b, i);
    };
    $7c3b72a365cc0275$var$is_buf = function is_buf_b(a) {
        return $7c3b72a365cc0275$require$Buffer.isBuffer(a) || Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
    };
}
/* from js-xls */ function $7c3b72a365cc0275$var$cpdoit() {
    $7c3b72a365cc0275$var$__utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $7c3b72a365cc0275$var$$cptable.utils.decode(1200, b.slice(s, e)).replace($7c3b72a365cc0275$var$chr0, '');
    };
    $7c3b72a365cc0275$var$__utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $7c3b72a365cc0275$var$$cptable.utils.decode(65001, b.slice(s, e));
    };
    $7c3b72a365cc0275$var$__lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $7c3b72a365cc0275$var$__readUInt32LE(b, i);
        return len > 0 ? $7c3b72a365cc0275$var$$cptable.utils.decode($7c3b72a365cc0275$var$current_ansi, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $7c3b72a365cc0275$var$__cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $7c3b72a365cc0275$var$__readUInt32LE(b, i);
        return len > 0 ? $7c3b72a365cc0275$var$$cptable.utils.decode($7c3b72a365cc0275$var$current_codepage, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $7c3b72a365cc0275$var$__lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = 2 * $7c3b72a365cc0275$var$__readUInt32LE(b, i);
        return len > 0 ? $7c3b72a365cc0275$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $7c3b72a365cc0275$var$__lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $7c3b72a365cc0275$var$__readUInt32LE(b, i);
        return len > 0 ? $7c3b72a365cc0275$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len)) : "";
    };
    $7c3b72a365cc0275$var$__8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $7c3b72a365cc0275$var$__readUInt32LE(b, i);
        return len > 0 ? $7c3b72a365cc0275$var$$cptable.utils.decode(65001, b.slice(i + 4, i + 4 + len)) : "";
    };
}
if (typeof $7c3b72a365cc0275$var$$cptable !== 'undefined') $7c3b72a365cc0275$var$cpdoit();
var $7c3b72a365cc0275$var$__readUInt8 = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx];
};
var $7c3b72a365cc0275$var$__readUInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 1] * 256 + b[idx];
};
var $7c3b72a365cc0275$var$__readInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var u = b[idx + 1] * 256 + b[idx];
    return u < 0x8000 ? u : (0xffff - u + 1) * -1;
};
var $7c3b72a365cc0275$var$__readUInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] * 16777216 + (b[idx + 2] << 16) + (b[idx + 1] << 8) + b[idx];
};
var $7c3b72a365cc0275$var$__readInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] << 24 | b[idx + 2] << 16 | b[idx + 1] << 8 | b[idx];
};
var $7c3b72a365cc0275$var$__readInt32BE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx] << 24 | b[idx + 1] << 16 | b[idx + 2] << 8 | b[idx + 3];
};
function $7c3b72a365cc0275$var$ReadShift(size /*:number*/ , t /*:?string*/ ) /*:number|string*/ {
    var o = "", oI /*:: :number = 0*/ , oR, oo = [], w, vv, i, loc;
    switch(t){
        case 'dbcs':
            loc = this.l;
            if ($7c3b72a365cc0275$var$has_buf && $7c3b72a365cc0275$require$Buffer.isBuffer(this)) o = this.slice(this.l, this.l + 2 * size).toString("utf16le");
            else for(i = 0; i < size; ++i){
                o += String.fromCharCode($7c3b72a365cc0275$var$__readUInt16LE(this, loc));
                loc += 2;
            }
            size *= 2;
            break;
        case 'utf8':
            o = $7c3b72a365cc0275$var$__utf8(this, this.l, this.l + size);
            break;
        case 'utf16le':
            size *= 2;
            o = $7c3b72a365cc0275$var$__utf16le(this, this.l, this.l + size);
            break;
        case 'wstr':
            if (typeof $7c3b72a365cc0275$var$$cptable !== 'undefined') o = $7c3b72a365cc0275$var$$cptable.utils.decode($7c3b72a365cc0275$var$current_codepage, this.slice(this.l, this.l + 2 * size));
            else return $7c3b72a365cc0275$var$ReadShift.call(this, size, 'dbcs');
            size = 2 * size;
            break;
        /* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */ case 'lpstr-ansi':
            o = $7c3b72a365cc0275$var$__lpstr(this, this.l);
            size = 4 + $7c3b72a365cc0275$var$__readUInt32LE(this, this.l);
            break;
        case 'lpstr-cp':
            o = $7c3b72a365cc0275$var$__cpstr(this, this.l);
            size = 4 + $7c3b72a365cc0275$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */ case 'lpwstr':
            o = $7c3b72a365cc0275$var$__lpwstr(this, this.l);
            size = 4 + 2 * $7c3b72a365cc0275$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */ case 'lpp4':
            size = 4 + $7c3b72a365cc0275$var$__readUInt32LE(this, this.l);
            o = $7c3b72a365cc0275$var$__lpp4(this, this.l);
            if (size & 0x02) size += 2;
            break;
        /* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */ case '8lpp4':
            size = 4 + $7c3b72a365cc0275$var$__readUInt32LE(this, this.l);
            o = $7c3b72a365cc0275$var$__8lpp4(this, this.l);
            if (size & 0x03) size += 4 - (size & 0x03);
            break;
        case 'cstr':
            size = 0;
            o = "";
            while((w = $7c3b72a365cc0275$var$__readUInt8(this, this.l + size++)) !== 0)oo.push($7c3b72a365cc0275$var$_getchar(w));
            o = oo.join("");
            break;
        case '_wstr':
            size = 0;
            o = "";
            while((w = $7c3b72a365cc0275$var$__readUInt16LE(this, this.l + size)) !== 0){
                oo.push($7c3b72a365cc0275$var$_getchar(w));
                size += 2;
            }
            size += 2;
            o = oo.join("");
            break;
        /* sbcs and dbcs support continue records in the SST way TODO codepages */ case 'dbcs-cont':
            o = "";
            loc = this.l;
            for(i = 0; i < size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $7c3b72a365cc0275$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $7c3b72a365cc0275$var$ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                    return oo.join("") + vv;
                }
                oo.push($7c3b72a365cc0275$var$_getchar($7c3b72a365cc0275$var$__readUInt16LE(this, loc)));
                loc += 2;
            }
            o = oo.join("");
            size *= 2;
            break;
        case 'cpstr':
            if (typeof $7c3b72a365cc0275$var$$cptable !== 'undefined') {
                o = $7c3b72a365cc0275$var$$cptable.utils.decode($7c3b72a365cc0275$var$current_codepage, this.slice(this.l, this.l + size));
                break;
            }
        /* falls through */ case 'sbcs-cont':
            o = "";
            loc = this.l;
            for(i = 0; i != size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $7c3b72a365cc0275$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $7c3b72a365cc0275$var$ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                    return oo.join("") + vv;
                }
                oo.push($7c3b72a365cc0275$var$_getchar($7c3b72a365cc0275$var$__readUInt8(this, loc)));
                loc += 1;
            }
            o = oo.join("");
            break;
        default:
            switch(size){
                case 1:
                    oI = $7c3b72a365cc0275$var$__readUInt8(this, this.l);
                    this.l++;
                    return oI;
                case 2:
                    oI = (t === 'i' ? $7c3b72a365cc0275$var$__readInt16LE : $7c3b72a365cc0275$var$__readUInt16LE)(this, this.l);
                    this.l += 2;
                    return oI;
                case 4:
                case -4:
                    if (t === 'i' || (this[this.l + 3] & 0x80) === 0) {
                        oI = (size > 0 ? $7c3b72a365cc0275$var$__readInt32LE : $7c3b72a365cc0275$var$__readInt32BE)(this, this.l);
                        this.l += 4;
                        return oI;
                    } else {
                        oR = $7c3b72a365cc0275$var$__readUInt32LE(this, this.l);
                        this.l += 4;
                    }
                    return oR;
                case 8:
                case -8:
                    if (t === 'f') {
                        if (size == 8) oR = $7c3b72a365cc0275$var$__double(this, this.l);
                        else oR = $7c3b72a365cc0275$var$__double([
                            this[this.l + 7],
                            this[this.l + 6],
                            this[this.l + 5],
                            this[this.l + 4],
                            this[this.l + 3],
                            this[this.l + 2],
                            this[this.l + 1],
                            this[this.l + 0]
                        ], 0);
                        this.l += 8;
                        return oR;
                    } else size = 8;
                /* falls through */ case 16:
                    o = $7c3b72a365cc0275$var$__hexlify(this, this.l, size);
                    break;
            }
    }
    this.l += size;
    return o;
}
var $7c3b72a365cc0275$var$__writeUInt32LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >>> 8 & 0xFF;
    b[idx + 2] = val >>> 16 & 0xFF;
    b[idx + 3] = val >>> 24 & 0xFF;
};
var $7c3b72a365cc0275$var$__writeInt32LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >> 8 & 0xFF;
    b[idx + 2] = val >> 16 & 0xFF;
    b[idx + 3] = val >> 24 & 0xFF;
};
var $7c3b72a365cc0275$var$__writeUInt16LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >>> 8 & 0xFF;
};
function $7c3b72a365cc0275$var$WriteShift(t /*:number*/ , val /*:string|number*/ , f /*:?string*/ ) /*:any*/ {
    var size = 0, i = 0;
    if (f === 'dbcs') {
        /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i)$7c3b72a365cc0275$var$__writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
        size = 2 * val.length;
    } else if (f === 'sbcs') {
        if (typeof $7c3b72a365cc0275$var$$cptable !== 'undefined' && $7c3b72a365cc0275$var$current_ansi == 874) /* TODO: use tables directly, don't encode */ /*:: if(typeof val !== "string") throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i){
            var cppayload = $7c3b72a365cc0275$var$$cptable.utils.encode($7c3b72a365cc0275$var$current_ansi, val.charAt(i));
            this[this.l + i] = cppayload[0];
        }
        else {
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ val = val.replace(/[^\x00-\x7F]/g, "_");
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i)this[this.l + i] = val.charCodeAt(i) & 0xFF;
        }
        size = val.length;
    } else if (f === 'hex') {
        for(; i < t; ++i)/*:: if(typeof val !== "string") throw new Error("unreachable"); */ this[this.l++] = parseInt(val.slice(2 * i, 2 * i + 2), 16) || 0;
        return this;
    } else if (f === 'utf16le') {
        /*:: if(typeof val !== "string") throw new Error("unreachable"); */ var end /*:number*/  = Math.min(this.l + t, this.length);
        for(i = 0; i < Math.min(val.length, t); ++i){
            var cc = val.charCodeAt(i);
            this[this.l++] = cc & 0xff;
            this[this.l++] = cc >> 8;
        }
        while(this.l < end)this[this.l++] = 0;
        return this;
    } else /*:: if(typeof val === 'number') */ switch(t){
        case 1:
            size = 1;
            this[this.l] = val & 0xFF;
            break;
        case 2:
            size = 2;
            this[this.l] = val & 0xFF;
            val >>>= 8;
            this[this.l + 1] = val & 0xFF;
            break;
        case 3:
            size = 3;
            this[this.l] = val & 0xFF;
            val >>>= 8;
            this[this.l + 1] = val & 0xFF;
            val >>>= 8;
            this[this.l + 2] = val & 0xFF;
            break;
        case 4:
            size = 4;
            $7c3b72a365cc0275$var$__writeUInt32LE(this, val, this.l);
            break;
        case 8:
            size = 8;
            if (f === 'f') {
                $7c3b72a365cc0275$var$write_double_le(this, val, this.l);
                break;
            }
        /* falls through */ case 16:
            break;
        case -4:
            size = 4;
            $7c3b72a365cc0275$var$__writeInt32LE(this, val, this.l);
            break;
    }
    this.l += size;
    return this;
}
function $7c3b72a365cc0275$var$CheckField(hexstr /*:string*/ , fld /*:string*/ ) /*:void*/ {
    var m = $7c3b72a365cc0275$var$__hexlify(this, this.l, hexstr.length >> 1);
    if (m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
    this.l += hexstr.length >> 1;
}
function $7c3b72a365cc0275$var$prep_blob(blob, pos /*:number*/ ) /*:void*/ {
    blob.l = pos;
    blob.read_shift = /*::(*/ $7c3b72a365cc0275$var$ReadShift /*:: :any)*/ ;
    blob.chk = $7c3b72a365cc0275$var$CheckField;
    blob.write_shift = $7c3b72a365cc0275$var$WriteShift;
}
function $7c3b72a365cc0275$var$parsenoop(blob, length /*:: :number, opts?:any */ ) {
    blob.l += length;
}
function $7c3b72a365cc0275$var$new_buf(sz /*:number*/ ) /*:Block*/ {
    var o = $7c3b72a365cc0275$var$new_raw_buf(sz);
    $7c3b72a365cc0275$var$prep_blob(o, 0);
    return o;
}
/* [MS-XLSB] 2.1.4 Record */ function $7c3b72a365cc0275$var$recordhopper(data, cb /*:RecordHopperCB*/ , opts /*:?any*/ ) {
    if (!data) return;
    var tmpbyte, cntbyte, length;
    $7c3b72a365cc0275$var$prep_blob(data, data.l || 0);
    var L = data.length, RT = 0, tgt = 0;
    while(data.l < L){
        RT = data.read_shift(1);
        if (RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F) << 7);
        var R = $7c3b72a365cc0275$var$XLSBRecordEnum[RT] || $7c3b72a365cc0275$var$XLSBRecordEnum[0xFFFF];
        tmpbyte = data.read_shift(1);
        length = tmpbyte & 0x7F;
        for(cntbyte = 1; cntbyte < 4 && tmpbyte & 0x80; ++cntbyte)length += ((tmpbyte = data.read_shift(1)) & 0x7F) << 7 * cntbyte;
        tgt = data.l + length;
        var d = R.f && R.f(data, length, opts);
        data.l = tgt;
        if (cb(d, R, RT)) return;
    }
}
/* control buffer usage for fixed-length buffers */ function $7c3b72a365cc0275$var$buf_array() /*:BufArray*/ {
    var bufs /*:Array<Block>*/  = [], blksz = $7c3b72a365cc0275$var$has_buf ? 256 : 2048;
    var newblk = function ba_newblk(sz /*:number*/ ) /*:Block*/ {
        var o /*:Block*/  = $7c3b72a365cc0275$var$new_buf(sz);
        $7c3b72a365cc0275$var$prep_blob(o, 0);
        return o;
    };
    var curbuf /*:Block*/  = newblk(blksz);
    var endbuf = function ba_endbuf() {
        if (!curbuf) return;
        if (curbuf.length > curbuf.l) {
            curbuf = curbuf.slice(0, curbuf.l);
            curbuf.l = curbuf.length;
        }
        if (curbuf.length > 0) bufs.push(curbuf);
        curbuf = null;
    };
    var next = function ba_next(sz /*:number*/ ) /*:Block*/ {
        if (curbuf && sz < curbuf.length - curbuf.l) return curbuf;
        endbuf();
        return curbuf = newblk(Math.max(sz + 1, blksz));
    };
    var end = function ba_end() {
        endbuf();
        return $7c3b72a365cc0275$var$bconcat(bufs);
    };
    var push = function ba_push(buf) {
        endbuf();
        curbuf = buf;
        if (curbuf.l == null) curbuf.l = curbuf.length;
        next(blksz);
    };
    return {
        next: next,
        push: push,
        end: end,
        _bufs: bufs
    } /*:any*/ ;
}
function $7c3b72a365cc0275$var$write_record(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) {
    var t /*:number*/  = +type, l;
    if (isNaN(t)) return; // TODO: throw something here?
    if (!length) length = $7c3b72a365cc0275$var$XLSBRecordEnum[t].p || (payload || []).length || 0;
    l = 1 + (t >= 0x80 ? 1 : 0) + 1 /* + length*/ ;
    if (length >= 0x80) ++l;
    if (length >= 0x4000) ++l;
    if (length >= 0x200000) ++l;
    var o = ba.next(l);
    if (t <= 0x7F) o.write_shift(1, t);
    else {
        o.write_shift(1, (t & 0x7F) + 0x80);
        o.write_shift(1, t >> 7);
    }
    for(var i = 0; i != 4; ++i)if (length >= 0x80) {
        o.write_shift(1, (length & 0x7F) + 0x80);
        length >>= 7;
    } else {
        o.write_shift(1, length);
        break;
    }
    if (/*:: length != null &&*/ length > 0 && $7c3b72a365cc0275$var$is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */ function $7c3b72a365cc0275$var$shift_cell_xls(cell /*:CellAddress*/ , tgt /*:any*/ , opts /*:?any*/ ) /*:CellAddress*/ {
    var out = $7c3b72a365cc0275$var$dup(cell);
    if (tgt.s) {
        if (out.cRel) out.c += tgt.s.c;
        if (out.rRel) out.r += tgt.s.r;
    } else {
        if (out.cRel) out.c += tgt.c;
        if (out.rRel) out.r += tgt.r;
    }
    if (!opts || opts.biff < 12) {
        while(out.c >= 0x100)out.c -= 0x100;
        while(out.r >= 0x10000)out.r -= 0x10000;
    }
    return out;
}
function $7c3b72a365cc0275$var$shift_range_xls(cell, range, opts) {
    var out = $7c3b72a365cc0275$var$dup(cell);
    out.s = $7c3b72a365cc0275$var$shift_cell_xls(out.s, range.s, opts);
    out.e = $7c3b72a365cc0275$var$shift_cell_xls(out.e, range.s, opts);
    return out;
}
function $7c3b72a365cc0275$var$encode_cell_xls(c /*:CellAddress*/ , biff /*:number*/ ) /*:string*/ {
    if (c.cRel && c.c < 0) {
        c = $7c3b72a365cc0275$var$dup(c);
        while(c.c < 0)c.c += biff > 8 ? 0x4000 : 0x100;
    }
    if (c.rRel && c.r < 0) {
        c = $7c3b72a365cc0275$var$dup(c);
        while(c.r < 0)c.r += biff > 8 ? 0x100000 : biff > 5 ? 0x10000 : 0x4000;
    }
    var s = $7c3b72a365cc0275$var$encode_cell(c);
    if (!c.cRel && c.cRel != null) s = $7c3b72a365cc0275$var$fix_col(s);
    if (!c.rRel && c.rRel != null) s = $7c3b72a365cc0275$var$fix_row(s);
    return s;
}
function $7c3b72a365cc0275$var$encode_range_xls(r, opts) /*:string*/ {
    if (r.s.r == 0 && !r.s.rRel) {
        if (r.e.r == (opts.biff >= 12 ? 0xFFFFF : opts.biff >= 8 ? 0x10000 : 0x4000) && !r.e.rRel) return (r.s.cRel ? "" : "$") + $7c3b72a365cc0275$var$encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + $7c3b72a365cc0275$var$encode_col(r.e.c);
    }
    if (r.s.c == 0 && !r.s.cRel) {
        if (r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) return (r.s.rRel ? "" : "$") + $7c3b72a365cc0275$var$encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + $7c3b72a365cc0275$var$encode_row(r.e.r);
    }
    return $7c3b72a365cc0275$var$encode_cell_xls(r.s, opts.biff) + ":" + $7c3b72a365cc0275$var$encode_cell_xls(r.e, opts.biff);
}
function $7c3b72a365cc0275$var$decode_row(rowstr /*:string*/ ) /*:number*/ {
    return parseInt($7c3b72a365cc0275$var$unfix_row(rowstr), 10) - 1;
}
function $7c3b72a365cc0275$var$encode_row(row /*:number*/ ) /*:string*/ {
    return "" + (row + 1);
}
function $7c3b72a365cc0275$var$fix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function $7c3b72a365cc0275$var$unfix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/\$(\d+)$/, "$1");
}
function $7c3b72a365cc0275$var$decode_col(colstr /*:string*/ ) /*:number*/ {
    var c = $7c3b72a365cc0275$var$unfix_col(colstr), d = 0, i = 0;
    for(; i !== c.length; ++i)d = 26 * d + c.charCodeAt(i) - 64;
    return d - 1;
}
function $7c3b72a365cc0275$var$encode_col(col /*:number*/ ) /*:string*/ {
    if (col < 0) throw new Error("invalid column " + col);
    var s = "";
    for(++col; col; col = Math.floor((col - 1) / 26))s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s;
}
function $7c3b72a365cc0275$var$fix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^([A-Z])/, "$$$1");
}
function $7c3b72a365cc0275$var$unfix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^\$([A-Z])/, "$1");
}
function $7c3b72a365cc0275$var$split_cell(cstr /*:string*/ ) /*:Array<string>*/ {
    return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
//function decode_cell(cstr/*:string*/)/*:CellAddress*/ { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
function $7c3b72a365cc0275$var$decode_cell(cstr /*:string*/ ) /*:CellAddress*/ {
    var R = 0, C = 0;
    for(var i = 0; i < cstr.length; ++i){
        var cc = cstr.charCodeAt(i);
        if (cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
        else if (cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
    }
    return {
        c: C - 1,
        r: R - 1
    };
}
//function encode_cell(cell/*:CellAddress*/)/*:string*/ { return encode_col(cell.c) + encode_row(cell.r); }
function $7c3b72a365cc0275$var$encode_cell(cell /*:CellAddress*/ ) /*:string*/ {
    var col = cell.c + 1;
    var s = "";
    for(; col; col = (col - 1) / 26 | 0)s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s + (cell.r + 1);
}
function $7c3b72a365cc0275$var$decode_range(range /*:string*/ ) /*:Range*/ {
    var idx = range.indexOf(":");
    if (idx == -1) return {
        s: $7c3b72a365cc0275$var$decode_cell(range),
        e: $7c3b72a365cc0275$var$decode_cell(range)
    };
    return {
        s: $7c3b72a365cc0275$var$decode_cell(range.slice(0, idx)),
        e: $7c3b72a365cc0275$var$decode_cell(range.slice(idx + 1))
    };
}
/*# if only one arg, it is assumed to be a Range.  If 2 args, both are cell addresses */ function $7c3b72a365cc0275$var$encode_range(cs /*:CellAddrSpec|Range*/ , ce /*:?CellAddrSpec*/ ) /*:string*/ {
    if (typeof ce === 'undefined' || typeof ce === 'number') /*:: if(!(cs instanceof Range)) throw "unreachable"; */ return $7c3b72a365cc0275$var$encode_range(cs.s, cs.e);
    /*:: if((cs instanceof Range)) throw "unreachable"; */ if (typeof cs !== 'string') cs = $7c3b72a365cc0275$var$encode_cell(cs /*:any*/ );
    if (typeof ce !== 'string') ce = $7c3b72a365cc0275$var$encode_cell(ce /*:any*/ );
    /*:: if(typeof cs !== 'string') throw "unreachable"; */ /*:: if(typeof ce !== 'string') throw "unreachable"; */ return cs == ce ? cs : cs + ":" + ce;
}
function $7c3b72a365cc0275$var$safe_decode_range(range /*:string*/ ) /*:Range*/ {
    var o = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var idx = 0, i = 0, cc = 0;
    var len = range.length;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.s.c = --idx;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.s.r = --idx;
    if (i === len || cc != 10) {
        o.e.c = o.s.c;
        o.e.r = o.s.r;
        return o;
    }
    ++i;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.e.c = --idx;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.e.r = --idx;
    return o;
}
function $7c3b72a365cc0275$var$safe_format_cell(cell /*:Cell*/ , v /*:any*/ ) {
    var q = cell.t == 'd' && v instanceof Date;
    if (cell.z != null) try {
        return cell.w = $7c3b72a365cc0275$var$SSF_format(cell.z, q ? $7c3b72a365cc0275$var$datenum(v) : v);
    } catch (e) {}
    try {
        return cell.w = $7c3b72a365cc0275$var$SSF_format((cell.XF || {}).numFmtId || (q ? 14 : 0), q ? $7c3b72a365cc0275$var$datenum(v) : v);
    } catch (e) {
        return '' + v;
    }
}
function $7c3b72a365cc0275$var$format_cell(cell /*:Cell*/ , v /*:any*/ , o /*:any*/ ) {
    if (cell == null || cell.t == null || cell.t == 'z') return "";
    if (cell.w !== undefined) return cell.w;
    if (cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
    if (cell.t == "e") return $7c3b72a365cc0275$var$BErr[cell.v] || cell.v;
    if (v == undefined) return $7c3b72a365cc0275$var$safe_format_cell(cell, cell.v);
    return $7c3b72a365cc0275$var$safe_format_cell(cell, v);
}
function $7c3b72a365cc0275$var$sheet_to_workbook(sheet /*:Worksheet*/ , opts) /*:Workbook*/ {
    var n = opts && opts.sheet ? opts.sheet : "Sheet1";
    var sheets = {};
    sheets[n] = sheet;
    return {
        SheetNames: [
            n
        ],
        Sheets: sheets
    };
}
function $7c3b72a365cc0275$var$sheet_add_aoa(_ws /*:?Worksheet*/ , data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? Array.isArray(_ws) : o.dense;
    if ($7c3b72a365cc0275$var$DENSE != null && dense == null) dense = $7c3b72a365cc0275$var$DENSE;
    var ws /*:Worksheet*/  = _ws || (dense ? [] : {} /*:any*/ );
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == 'number') _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $7c3b72a365cc0275$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
        if (!ws["!ref"]) ws["!ref"] = "A1:A1";
    }
    var range /*:Range*/  = {
        s: {
            c: 10000000,
            r: 10000000
        },
        e: {
            c: 0,
            r: 0
        }
    } /*:any*/ ;
    if (ws['!ref']) {
        var _range = $7c3b72a365cc0275$var$safe_decode_range(ws['!ref']);
        range.s.c = _range.s.c;
        range.s.r = _range.s.r;
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) range.e.r = _R = _range.e.r + 1;
    }
    for(var R = 0; R != data.length; ++R){
        if (!data[R]) continue;
        if (!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
        for(var C = 0; C != data[R].length; ++C){
            if (typeof data[R][C] === 'undefined') continue;
            var cell /*:Cell*/  = {
                v: data[R][C]
            } /*:any*/ ;
            var __R = _R + R, __C = _C + C;
            if (range.s.r > __R) range.s.r = __R;
            if (range.s.c > __C) range.s.c = __C;
            if (range.e.r < __R) range.e.r = __R;
            if (range.e.c < __C) range.e.c = __C;
            if (data[R][C] && typeof data[R][C] === 'object' && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
            else {
                if (Array.isArray(cell.v)) {
                    cell.f = data[R][C][1];
                    cell.v = cell.v[0];
                }
                if (cell.v === null) {
                    if (cell.f) cell.t = 'n';
                    else if (o.nullError) {
                        cell.t = 'e';
                        cell.v = 0;
                    } else if (!o.sheetStubs) continue;
                    else cell.t = 'z';
                } else if (typeof cell.v === 'number') cell.t = 'n';
                else if (typeof cell.v === 'boolean') cell.t = 'b';
                else if (cell.v instanceof Date) {
                    cell.z = o.dateNF || $7c3b72a365cc0275$var$table_fmt[14];
                    if (o.cellDates) {
                        cell.t = 'd';
                        cell.w = $7c3b72a365cc0275$var$SSF_format(cell.z, $7c3b72a365cc0275$var$datenum(cell.v));
                    } else {
                        cell.t = 'n';
                        cell.v = $7c3b72a365cc0275$var$datenum(cell.v);
                        cell.w = $7c3b72a365cc0275$var$SSF_format(cell.z, cell.v);
                    }
                } else cell.t = 's';
            }
            if (dense) {
                if (!ws[__R]) ws[__R] = [];
                if (ws[__R][__C] && ws[__R][__C].z) cell.z = ws[__R][__C].z;
                ws[__R][__C] = cell;
            } else {
                var cell_ref = $7c3b72a365cc0275$var$encode_cell({
                    c: __C,
                    r: __R
                } /*:any*/ );
                if (ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
                ws[cell_ref] = cell;
            }
        }
    }
    if (range.s.c < 10000000) ws['!ref'] = $7c3b72a365cc0275$var$encode_range(range);
    return ws;
}
function $7c3b72a365cc0275$var$aoa_to_sheet(data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    return $7c3b72a365cc0275$var$sheet_add_aoa(null, data, opts);
}
function $7c3b72a365cc0275$var$parse_Int32LE(data) {
    return data.read_shift(4, 'i');
}
function $7c3b72a365cc0275$var$write_UInt32LE(x /*:number*/ , o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(4);
    o.write_shift(4, x);
    return o;
}
/* [MS-XLSB] 2.5.168 */ function $7c3b72a365cc0275$var$parse_XLWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function $7c3b72a365cc0275$var$write_XLWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $7c3b72a365cc0275$var$new_buf(4 + 2 * data.length);
    }
    o.write_shift(4, data.length);
    if (data.length > 0) o.write_shift(0, data, 'dbcs');
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.91 */ //function parse_LPWideString(data/*::, length*/)/*:string*/ {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}
/* [MS-XLSB] 2.5.143 */ function $7c3b72a365cc0275$var$parse_StrRun(data) {
    return {
        ich: data.read_shift(2),
        ifnt: data.read_shift(2)
    };
}
function $7c3b72a365cc0275$var$write_StrRun(run, o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(4);
    o.write_shift(2, run.ich || 0);
    o.write_shift(2, run.ifnt || 0);
    return o;
}
/* [MS-XLSB] 2.5.121 */ function $7c3b72a365cc0275$var$parse_RichStr(data, length /*:number*/ ) /*:XLString*/ {
    var start = data.l;
    var flags = data.read_shift(1);
    var str = $7c3b72a365cc0275$var$parse_XLWideString(data);
    var rgsStrRun = [];
    var z = {
        t: str,
        h: str
    } /*:any*/ ;
    if ((flags & 1) !== 0) {
        /* TODO: formatted string */ var dwSizeStrRun = data.read_shift(4);
        for(var i = 0; i != dwSizeStrRun; ++i)rgsStrRun.push($7c3b72a365cc0275$var$parse_StrRun(data));
        z.r = rgsStrRun;
    } else z.r = [
        {
            ich: 0,
            ifnt: 0
        }
    ];
    //if((flags & 2) !== 0) { /* fExtStr */
    //	/* TODO: phonetic string */
    //}
    data.l = start + length;
    return z;
}
function $7c3b72a365cc0275$var$write_RichStr(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $7c3b72a365cc0275$var$new_buf(15 + 4 * str.t.length);
    }
    o.write_shift(1, 0);
    $7c3b72a365cc0275$var$write_XLWideString(str.t, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */ var $7c3b72a365cc0275$var$parse_BrtCommentText = $7c3b72a365cc0275$var$parse_RichStr;
function $7c3b72a365cc0275$var$write_BrtCommentText(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $7c3b72a365cc0275$var$new_buf(23 + 4 * str.t.length);
    }
    o.write_shift(1, 1);
    $7c3b72a365cc0275$var$write_XLWideString(str.t, o);
    o.write_shift(4, 1);
    $7c3b72a365cc0275$var$write_StrRun({
        ich: 0,
        ifnt: 0
    }, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.9 */ function $7c3b72a365cc0275$var$parse_XLSBCell(data) /*:any*/ {
    var col = data.read_shift(4);
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: col,
        iStyleRef: iStyleRef
    };
}
function $7c3b72a365cc0275$var$write_XLSBCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(8);
    o.write_shift(-4, cell.c);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* Short XLSB Cell does not include column */ function $7c3b72a365cc0275$var$parse_XLSBShortCell(data) /*:any*/ {
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: -1,
        iStyleRef: iStyleRef
    };
}
function $7c3b72a365cc0275$var$write_XLSBShortCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(4);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* [MS-XLSB] 2.5.21 */ var $7c3b72a365cc0275$var$parse_XLSBCodeName = $7c3b72a365cc0275$var$parse_XLWideString;
var $7c3b72a365cc0275$var$write_XLSBCodeName = $7c3b72a365cc0275$var$write_XLWideString;
/* [MS-XLSB] 2.5.166 */ function $7c3b72a365cc0275$var$parse_XLNullableWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function $7c3b72a365cc0275$var$write_XLNullableWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $7c3b72a365cc0275$var$new_buf(127);
    }
    o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
    if (data.length > 0) o.write_shift(0, data, 'dbcs');
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.165 */ var $7c3b72a365cc0275$var$parse_XLNameWideString = $7c3b72a365cc0275$var$parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;
/* [MS-XLSB] 2.5.114 */ var $7c3b72a365cc0275$var$parse_RelID = $7c3b72a365cc0275$var$parse_XLNullableWideString;
var $7c3b72a365cc0275$var$write_RelID = $7c3b72a365cc0275$var$write_XLNullableWideString;
/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */ function $7c3b72a365cc0275$var$parse_RkNumber(data) /*:number*/ {
    var b = data.slice(data.l, data.l + 4);
    var fX100 = b[0] & 1, fInt = b[0] & 2;
    data.l += 4;
    var RK = fInt === 0 ? $7c3b72a365cc0275$var$__double([
        0,
        0,
        0,
        0,
        b[0] & 0xFC,
        b[1],
        b[2],
        b[3]
    ], 0) : $7c3b72a365cc0275$var$__readInt32LE(b, 0) >> 2;
    return fX100 ? RK / 100 : RK;
}
function $7c3b72a365cc0275$var$write_RkNumber(data /*:number*/ , o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(4);
    var fX100 = 0, fInt = 0, d100 = data * 100;
    if (data == (data | 0) && data >= -536870912 && data < 536870912) fInt = 1;
    else if (d100 == (d100 | 0) && d100 >= -536870912 && d100 < 536870912) {
        fInt = 1;
        fX100 = 1;
    }
    if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
    else throw new Error("unsupported RkNumber " + data); // TODO
}
/* [MS-XLSB] 2.5.117 RfX */ function $7c3b72a365cc0275$var$parse_RfX(data /*::, length*/ ) /*:Range*/ {
    var cell /*:Range*/  = {
        s: {},
        e: {}
    } /*:any*/ ;
    cell.s.r = data.read_shift(4);
    cell.e.r = data.read_shift(4);
    cell.s.c = data.read_shift(4);
    cell.e.c = data.read_shift(4);
    return cell;
}
function $7c3b72a365cc0275$var$write_RfX(r /*:Range*/ , o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(16);
    o.write_shift(4, r.s.r);
    o.write_shift(4, r.e.r);
    o.write_shift(4, r.s.c);
    o.write_shift(4, r.e.c);
    return o;
}
/* [MS-XLSB] 2.5.153 UncheckedRfX */ var $7c3b72a365cc0275$var$parse_UncheckedRfX = $7c3b72a365cc0275$var$parse_RfX;
var $7c3b72a365cc0275$var$write_UncheckedRfX = $7c3b72a365cc0275$var$write_RfX;
/* [MS-XLSB] 2.5.155 UncheckedSqRfX */ //function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx/*:string*/) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}
/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */ /* TODO: error checking, NaN and Infinity values are not valid Xnum */ function $7c3b72a365cc0275$var$parse_Xnum(data /*::, length*/ ) {
    if (data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
    return data.read_shift(8, 'f');
}
function $7c3b72a365cc0275$var$write_Xnum(data, o) {
    return (o || $7c3b72a365cc0275$var$new_buf(8)).write_shift(8, data, 'f');
}
/* [MS-XLSB] 2.4.324 BrtColor */ function $7c3b72a365cc0275$var$parse_BrtColor(data /*::, length*/ ) {
    var out = {};
    var d = data.read_shift(1);
    //var fValidRGB = d & 1;
    var xColorType = d >>> 1;
    var index = data.read_shift(1);
    var nTS = data.read_shift(2, 'i');
    var bR = data.read_shift(1);
    var bG = data.read_shift(1);
    var bB = data.read_shift(1);
    data.l++; //var bAlpha = data.read_shift(1);
    switch(xColorType){
        case 0:
            out.auto = 1;
            break;
        case 1:
            out.index = index;
            var icv = $7c3b72a365cc0275$var$XLSIcv[index];
            /* automatic pseudo index 81 */ if (icv) out.rgb = $7c3b72a365cc0275$var$rgb2Hex(icv);
            break;
        case 2:
            /* if(!fValidRGB) throw new Error("invalid"); */ out.rgb = $7c3b72a365cc0275$var$rgb2Hex([
                bR,
                bG,
                bB
            ]);
            break;
        case 3:
            out.theme = index;
            break;
    }
    if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
    return out;
}
function $7c3b72a365cc0275$var$write_BrtColor(color, o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(8);
    if (!color || color.auto) {
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        return o;
    }
    if (color.index != null) {
        o.write_shift(1, 0x02);
        o.write_shift(1, color.index);
    } else if (color.theme != null) {
        o.write_shift(1, 0x06);
        o.write_shift(1, color.theme);
    } else {
        o.write_shift(1, 0x05);
        o.write_shift(1, 0);
    }
    var nTS = color.tint || 0;
    if (nTS > 0) nTS *= 32767;
    else if (nTS < 0) nTS *= 32768;
    o.write_shift(2, nTS);
    if (!color.rgb || color.theme != null) {
        o.write_shift(2, 0);
        o.write_shift(1, 0);
        o.write_shift(1, 0);
    } else {
        var rgb = color.rgb || 'FFFFFF';
        if (typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
        o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
        o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
        o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
        o.write_shift(1, 0xFF);
    }
    return o;
}
/* [MS-XLSB] 2.5.52 */ function $7c3b72a365cc0275$var$parse_FontFlags(data /*::, length, opts*/ ) {
    var d = data.read_shift(1);
    data.l++;
    var out = {
        fBold: d & 0x01,
        fItalic: d & 0x02,
        fUnderline: d & 0x04,
        fStrikeout: d & 0x08,
        fOutline: d & 0x10,
        fShadow: d & 0x20,
        fCondense: d & 0x40,
        fExtend: d & 0x80
    };
    return out;
}
function $7c3b72a365cc0275$var$write_FontFlags(font, o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(2);
    var grbit = (font.italic ? 0x02 : 0) | (font.strike ? 0x08 : 0) | (font.outline ? 0x10 : 0) | (font.shadow ? 0x20 : 0) | (font.condense ? 0x40 : 0) | (font.extend ? 0x80 : 0);
    o.write_shift(1, grbit);
    o.write_shift(1, 0);
    return o;
}
/* [MS-OLEDS] 2.3.1 and 2.3.2 */ function $7c3b72a365cc0275$var$parse_ClipboardFormatOrString(o, w /*:number*/ ) /*:string*/ {
    // $FlowIgnore
    var ClipFmt = {
        2: "BITMAP",
        3: "METAFILEPICT",
        8: "DIB",
        14: "ENHMETAFILE"
    };
    var m /*:number*/  = o.read_shift(4);
    switch(m){
        case 0x00000000:
            return "";
        case 0xffffffff:
        case 0xfffffffe:
            return ClipFmt[o.read_shift(4)] || "";
    }
    if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
    o.l -= 4;
    return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function $7c3b72a365cc0275$var$parse_ClipboardFormatOrAnsiString(o) {
    return $7c3b72a365cc0275$var$parse_ClipboardFormatOrString(o, 1);
}
function $7c3b72a365cc0275$var$parse_ClipboardFormatOrUnicodeString(o) {
    return $7c3b72a365cc0275$var$parse_ClipboardFormatOrString(o, 2);
}
/* [MS-OLEPS] 2.2 PropertyType */ // Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var $7c3b72a365cc0275$var$VT_I2 = 0x0002;
var $7c3b72a365cc0275$var$VT_I4 = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var $7c3b72a365cc0275$var$VT_BOOL = 0x000B;
var $7c3b72a365cc0275$var$VT_VARIANT = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var $7c3b72a365cc0275$var$VT_UI4 = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
var $7c3b72a365cc0275$var$VT_LPSTR = 0x001E;
//var VT_LPWSTR   = 0x001F;
var $7c3b72a365cc0275$var$VT_FILETIME = 0x0040;
var $7c3b72a365cc0275$var$VT_BLOB = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var $7c3b72a365cc0275$var$VT_CF = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
var $7c3b72a365cc0275$var$VT_VECTOR = 0x1000;
var $7c3b72a365cc0275$var$VT_VECTOR_VARIANT = 0x100C;
var $7c3b72a365cc0275$var$VT_VECTOR_LPSTR = 0x101E;
//var VT_ARRAY    = 0x2000;
var $7c3b72a365cc0275$var$VT_STRING = 0x0050; // 2.3.3.1.11 VtString
var $7c3b72a365cc0275$var$VT_USTR = 0x0051; // 2.3.3.1.12 VtUnalignedString
var $7c3b72a365cc0275$var$VT_CUSTOM = [
    $7c3b72a365cc0275$var$VT_STRING,
    $7c3b72a365cc0275$var$VT_USTR
];
/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */ var $7c3b72a365cc0275$var$DocSummaryPIDDSI = {
    /*::[*/ 0x01: {
        n: 'CodePage',
        t: $7c3b72a365cc0275$var$VT_I2
    },
    /*::[*/ 0x02: {
        n: 'Category',
        t: $7c3b72a365cc0275$var$VT_STRING
    },
    /*::[*/ 0x03: {
        n: 'PresentationFormat',
        t: $7c3b72a365cc0275$var$VT_STRING
    },
    /*::[*/ 0x04: {
        n: 'ByteCount',
        t: $7c3b72a365cc0275$var$VT_I4
    },
    /*::[*/ 0x05: {
        n: 'LineCount',
        t: $7c3b72a365cc0275$var$VT_I4
    },
    /*::[*/ 0x06: {
        n: 'ParagraphCount',
        t: $7c3b72a365cc0275$var$VT_I4
    },
    /*::[*/ 0x07: {
        n: 'SlideCount',
        t: $7c3b72a365cc0275$var$VT_I4
    },
    /*::[*/ 0x08: {
        n: 'NoteCount',
        t: $7c3b72a365cc0275$var$VT_I4
    },
    /*::[*/ 0x09: {
        n: 'HiddenCount',
        t: $7c3b72a365cc0275$var$VT_I4
    },
    /*::[*/ 0x0a: {
        n: 'MultimediaClipCount',
        t: $7c3b72a365cc0275$var$VT_I4
    },
    /*::[*/ 0x0b: {
        n: 'ScaleCrop',
        t: $7c3b72a365cc0275$var$VT_BOOL
    },
    /*::[*/ 0x0c: {
        n: 'HeadingPairs',
        t: $7c3b72a365cc0275$var$VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ 
    },
    /*::[*/ 0x0d: {
        n: 'TitlesOfParts',
        t: $7c3b72a365cc0275$var$VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ 
    },
    /*::[*/ 0x0e: {
        n: 'Manager',
        t: $7c3b72a365cc0275$var$VT_STRING
    },
    /*::[*/ 0x0f: {
        n: 'Company',
        t: $7c3b72a365cc0275$var$VT_STRING
    },
    /*::[*/ 0x10: {
        n: 'LinksUpToDate',
        t: $7c3b72a365cc0275$var$VT_BOOL
    },
    /*::[*/ 0x11: {
        n: 'CharacterCount',
        t: $7c3b72a365cc0275$var$VT_I4
    },
    /*::[*/ 0x13: {
        n: 'SharedDoc',
        t: $7c3b72a365cc0275$var$VT_BOOL
    },
    /*::[*/ 0x16: {
        n: 'HyperlinksChanged',
        t: $7c3b72a365cc0275$var$VT_BOOL
    },
    /*::[*/ 0x17: {
        n: 'AppVersion',
        t: $7c3b72a365cc0275$var$VT_I4,
        p: 'version'
    },
    /*::[*/ 0x18: {
        n: 'DigSig',
        t: $7c3b72a365cc0275$var$VT_BLOB
    },
    /*::[*/ 0x1A: {
        n: 'ContentType',
        t: $7c3b72a365cc0275$var$VT_STRING
    },
    /*::[*/ 0x1B: {
        n: 'ContentStatus',
        t: $7c3b72a365cc0275$var$VT_STRING
    },
    /*::[*/ 0x1C: {
        n: 'Language',
        t: $7c3b72a365cc0275$var$VT_STRING
    },
    /*::[*/ 0x1D: {
        n: 'Version',
        t: $7c3b72a365cc0275$var$VT_STRING
    },
    /*::[*/ 0xFF: {},
    /* [MS-OLEPS] 2.18 */ /*::[*/ 0x80000000: {
        n: 'Locale',
        t: $7c3b72a365cc0275$var$VT_UI4
    },
    /*::[*/ 0x80000003: {
        n: 'Behavior',
        t: $7c3b72a365cc0275$var$VT_UI4
    },
    /*::[*/ 0x72627262: {}
};
/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */ var $7c3b72a365cc0275$var$SummaryPIDSI = {
    /*::[*/ 0x01: {
        n: 'CodePage',
        t: $7c3b72a365cc0275$var$VT_I2
    },
    /*::[*/ 0x02: {
        n: 'Title',
        t: $7c3b72a365cc0275$var$VT_STRING
    },
    /*::[*/ 0x03: {
        n: 'Subject',
        t: $7c3b72a365cc0275$var$VT_STRING
    },
    /*::[*/ 0x04: {
        n: 'Author',
        t: $7c3b72a365cc0275$var$VT_STRING
    },
    /*::[*/ 0x05: {
        n: 'Keywords',
        t: $7c3b72a365cc0275$var$VT_STRING
    },
    /*::[*/ 0x06: {
        n: 'Comments',
        t: $7c3b72a365cc0275$var$VT_STRING
    },
    /*::[*/ 0x07: {
        n: 'Template',
        t: $7c3b72a365cc0275$var$VT_STRING
    },
    /*::[*/ 0x08: {
        n: 'LastAuthor',
        t: $7c3b72a365cc0275$var$VT_STRING
    },
    /*::[*/ 0x09: {
        n: 'RevNumber',
        t: $7c3b72a365cc0275$var$VT_STRING
    },
    /*::[*/ 0x0A: {
        n: 'EditTime',
        t: $7c3b72a365cc0275$var$VT_FILETIME
    },
    /*::[*/ 0x0B: {
        n: 'LastPrinted',
        t: $7c3b72a365cc0275$var$VT_FILETIME
    },
    /*::[*/ 0x0C: {
        n: 'CreatedDate',
        t: $7c3b72a365cc0275$var$VT_FILETIME
    },
    /*::[*/ 0x0D: {
        n: 'ModifiedDate',
        t: $7c3b72a365cc0275$var$VT_FILETIME
    },
    /*::[*/ 0x0E: {
        n: 'PageCount',
        t: $7c3b72a365cc0275$var$VT_I4
    },
    /*::[*/ 0x0F: {
        n: 'WordCount',
        t: $7c3b72a365cc0275$var$VT_I4
    },
    /*::[*/ 0x10: {
        n: 'CharCount',
        t: $7c3b72a365cc0275$var$VT_I4
    },
    /*::[*/ 0x11: {
        n: 'Thumbnail',
        t: $7c3b72a365cc0275$var$VT_CF
    },
    /*::[*/ 0x12: {
        n: 'Application',
        t: $7c3b72a365cc0275$var$VT_STRING
    },
    /*::[*/ 0x13: {
        n: 'DocSecurity',
        t: $7c3b72a365cc0275$var$VT_I4
    },
    /*::[*/ 0xFF: {},
    /* [MS-OLEPS] 2.18 */ /*::[*/ 0x80000000: {
        n: 'Locale',
        t: $7c3b72a365cc0275$var$VT_UI4
    },
    /*::[*/ 0x80000003: {
        n: 'Behavior',
        t: $7c3b72a365cc0275$var$VT_UI4
    },
    /*::[*/ 0x72627262: {}
};
/* [MS-XLS] 2.4.63 Country/Region codes */ var $7c3b72a365cc0275$var$CountryEnum = {
    /*::[*/ 0x0001: "US",
    /*::[*/ 0x0002: "CA",
    /*::[*/ 0x0003: "",
    /*::[*/ 0x0007: "RU",
    /*::[*/ 0x0014: "EG",
    /*::[*/ 0x001E: "GR",
    /*::[*/ 0x001F: "NL",
    /*::[*/ 0x0020: "BE",
    /*::[*/ 0x0021: "FR",
    /*::[*/ 0x0022: "ES",
    /*::[*/ 0x0024: "HU",
    /*::[*/ 0x0027: "IT",
    /*::[*/ 0x0029: "CH",
    /*::[*/ 0x002B: "AT",
    /*::[*/ 0x002C: "GB",
    /*::[*/ 0x002D: "DK",
    /*::[*/ 0x002E: "SE",
    /*::[*/ 0x002F: "NO",
    /*::[*/ 0x0030: "PL",
    /*::[*/ 0x0031: "DE",
    /*::[*/ 0x0034: "MX",
    /*::[*/ 0x0037: "BR",
    /*::[*/ 0x003d: "AU",
    /*::[*/ 0x0040: "NZ",
    /*::[*/ 0x0042: "TH",
    /*::[*/ 0x0051: "JP",
    /*::[*/ 0x0052: "KR",
    /*::[*/ 0x0054: "VN",
    /*::[*/ 0x0056: "CN",
    /*::[*/ 0x005A: "TR",
    /*::[*/ 0x0069: "JS",
    /*::[*/ 0x00D5: "DZ",
    /*::[*/ 0x00D8: "MA",
    /*::[*/ 0x00DA: "LY",
    /*::[*/ 0x015F: "PT",
    /*::[*/ 0x0162: "IS",
    /*::[*/ 0x0166: "FI",
    /*::[*/ 0x01A4: "CZ",
    /*::[*/ 0x0376: "TW",
    /*::[*/ 0x03C1: "LB",
    /*::[*/ 0x03C2: "JO",
    /*::[*/ 0x03C3: "SY",
    /*::[*/ 0x03C4: "IQ",
    /*::[*/ 0x03C5: "KW",
    /*::[*/ 0x03C6: "SA",
    /*::[*/ 0x03CB: "AE",
    /*::[*/ 0x03CC: "IL",
    /*::[*/ 0x03CE: "QA",
    /*::[*/ 0x03D5: "IR",
    /*::[*/ 0xFFFF: "US" // United States
};
/* [MS-XLS] 2.5.127 */ var $7c3b72a365cc0275$var$XLSFillPattern = [
    null,
    'solid',
    'mediumGray',
    'darkGray',
    'lightGray',
    'darkHorizontal',
    'darkVertical',
    'darkDown',
    'darkUp',
    'darkGrid',
    'darkTrellis',
    'lightHorizontal',
    'lightVertical',
    'lightDown',
    'lightUp',
    'lightGrid',
    'lightTrellis',
    'gray125',
    'gray0625'
];
function $7c3b72a365cc0275$var$rgbify(arr /*:Array<number>*/ ) /*:Array<[number, number, number]>*/ {
    return arr.map(function(x) {
        return [
            x >> 16 & 255,
            x >> 8 & 255,
            x & 255
        ];
    });
}
/* [MS-XLS] 2.5.161 */ /* [MS-XLSB] 2.5.75 Icv */ var $7c3b72a365cc0275$var$_XLSIcv = /*#__PURE__*/ $7c3b72a365cc0275$var$rgbify([
    /* Color Constants */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    /* Overridable Defaults */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    0x800000,
    0x008000,
    0x000080,
    0x808000,
    0x800080,
    0x008080,
    0xC0C0C0,
    0x808080,
    0x9999FF,
    0x993366,
    0xFFFFCC,
    0xCCFFFF,
    0x660066,
    0xFF8080,
    0x0066CC,
    0xCCCCFF,
    0x000080,
    0xFF00FF,
    0xFFFF00,
    0x00FFFF,
    0x800080,
    0x800000,
    0x008080,
    0x0000FF,
    0x00CCFF,
    0xCCFFFF,
    0xCCFFCC,
    0xFFFF99,
    0x99CCFF,
    0xFF99CC,
    0xCC99FF,
    0xFFCC99,
    0x3366FF,
    0x33CCCC,
    0x99CC00,
    0xFFCC00,
    0xFF9900,
    0xFF6600,
    0x666699,
    0x969696,
    0x003366,
    0x339966,
    0x003300,
    0x333300,
    0x993300,
    0x993366,
    0x333399,
    0x333333,
    /* Other entries to appease BIFF8/12 */ 0xFFFFFF,
    /* 0x40 icvForeground ?? */ 0x000000,
    /* 0x41 icvBackground ?? */ 0x000000,
    /* 0x42 icvFrame ?? */ 0x000000,
    /* 0x43 icv3D ?? */ 0x000000,
    /* 0x44 icv3DText ?? */ 0x000000,
    /* 0x45 icv3DHilite ?? */ 0x000000,
    /* 0x46 icv3DShadow ?? */ 0x000000,
    /* 0x47 icvHilite ?? */ 0x000000,
    /* 0x48 icvCtlText ?? */ 0x000000,
    /* 0x49 icvCtlScrl ?? */ 0x000000,
    /* 0x4A icvCtlInv ?? */ 0x000000,
    /* 0x4B icvCtlBody ?? */ 0x000000,
    /* 0x4C icvCtlFrame ?? */ 0x000000,
    /* 0x4D icvCtlFore ?? */ 0x000000,
    /* 0x4E icvCtlBack ?? */ 0x000000,
    /* 0x4F icvCtlNeutral */ 0x000000,
    /* 0x50 icvInfoBk ?? */ 0x000000 /* 0x51 icvInfoText ?? */ 
]);
var $7c3b72a365cc0275$var$XLSIcv = /*#__PURE__*/ $7c3b72a365cc0275$var$dup($7c3b72a365cc0275$var$_XLSIcv);
/* [MS-XLSB] 2.5.97.2 */ var $7c3b72a365cc0275$var$BErr = {
    /*::[*/ 0x00: "#NULL!",
    /*::[*/ 0x07: "#DIV/0!",
    /*::[*/ 0x0F: "#VALUE!",
    /*::[*/ 0x17: "#REF!",
    /*::[*/ 0x1D: "#NAME?",
    /*::[*/ 0x24: "#NUM!",
    /*::[*/ 0x2A: "#N/A",
    /*::[*/ 0x2B: "#GETTING_DATA",
    /*::[*/ 0xFF: "#WTF?"
};
//var RBErr = evert_num(BErr);
var $7c3b72a365cc0275$var$RBErr = {
    "#NULL!": 0x00,
    "#DIV/0!": 0x07,
    "#VALUE!": 0x0F,
    "#REF!": 0x17,
    "#NAME?": 0x1D,
    "#NUM!": 0x24,
    "#N/A": 0x2A,
    "#GETTING_DATA": 0x2B,
    "#WTF?": 0xFF
};
/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */ /* 12.3 Part Summary <SpreadsheetML> */ /* 14.2 Part Summary <DrawingML> */ /* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */ var $7c3b72a365cc0275$var$ct2type /*{[string]:string}*/  = {
    /* Workbook */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
    "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
    /* Worksheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
    "application/vnd.ms-excel.worksheet": "sheets",
    "application/vnd.ms-excel.binIndexWs": "TODO",
    /* Binary Index */ /* Chartsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
    "application/vnd.ms-excel.chartsheet": "charts",
    /* Macrosheet */ "application/vnd.ms-excel.macrosheet+xml": "macros",
    "application/vnd.ms-excel.macrosheet": "macros",
    "application/vnd.ms-excel.intlmacrosheet": "TODO",
    "application/vnd.ms-excel.binIndexMs": "TODO",
    /* Binary Index */ /* Dialogsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
    "application/vnd.ms-excel.dialogsheet": "dialogs",
    /* Shared Strings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
    "application/vnd.ms-excel.sharedStrings": "strs",
    /* Styles */ "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
    "application/vnd.ms-excel.styles": "styles",
    /* File Properties */ "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
    "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
    "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
    /* Custom Data Properties */ "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
    /* Comments */ "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
    "application/vnd.ms-excel.comments": "comments",
    "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
    "application/vnd.ms-excel.person+xml": "people",
    /* Metadata (Stock/Geography and Dynamic Array) */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
    "application/vnd.ms-excel.sheetMetadata": "metadata",
    /* PivotTable */ "application/vnd.ms-excel.pivotTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
    /* Chart Objects */ "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
    /* Chart Colors */ "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
    /* Chart Style */ "application/vnd.ms-office.chartstyle+xml": "TODO",
    /* Chart Advanced */ "application/vnd.ms-office.chartex+xml": "TODO",
    /* Calculation Chain */ "application/vnd.ms-excel.calcChain": "calcchains",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
    /* Printer Settings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
    /* ActiveX */ "application/vnd.ms-office.activeX": "TODO",
    "application/vnd.ms-office.activeX+xml": "TODO",
    /* Custom Toolbars */ "application/vnd.ms-excel.attachedToolbars": "TODO",
    /* External Data Connections */ "application/vnd.ms-excel.connections": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
    /* External Links */ "application/vnd.ms-excel.externalLink": "links",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
    /* PivotCache */ "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
    "application/vnd.ms-excel.pivotCacheRecords": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
    /* Query Table */ "application/vnd.ms-excel.queryTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
    /* Shared Workbook */ "application/vnd.ms-excel.userNames": "TODO",
    "application/vnd.ms-excel.revisionHeaders": "TODO",
    "application/vnd.ms-excel.revisionLog": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
    /* Single Cell Table */ "application/vnd.ms-excel.tableSingleCells": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
    /* Slicer */ "application/vnd.ms-excel.slicer": "TODO",
    "application/vnd.ms-excel.slicerCache": "TODO",
    "application/vnd.ms-excel.slicer+xml": "TODO",
    "application/vnd.ms-excel.slicerCache+xml": "TODO",
    /* Sort Map */ "application/vnd.ms-excel.wsSortMap": "TODO",
    /* Table */ "application/vnd.ms-excel.table": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
    /* Themes */ "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
    /* Theme Override */ "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
    /* Timeline */ "application/vnd.ms-excel.Timeline+xml": "TODO",
    /* verify */ "application/vnd.ms-excel.TimelineCache+xml": "TODO",
    /* verify */ /* VBA */ "application/vnd.ms-office.vbaProject": "vba",
    "application/vnd.ms-office.vbaProjectSignature": "TODO",
    /* Volatile Dependencies */ "application/vnd.ms-office.volatileDependencies": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
    /* Control Properties */ "application/vnd.ms-excel.controlproperties+xml": "TODO",
    /* Data Model */ "application/vnd.openxmlformats-officedocument.model+data": "TODO",
    /* Survey */ "application/vnd.ms-excel.Survey+xml": "TODO",
    /* Drawing */ "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
    "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
    /* VML */ "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
    "application/vnd.openxmlformats-package.relationships+xml": "rels",
    "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
    /* Image */ "image/png": "TODO",
    "sheet": "js"
} /*:any*/ ;
var $7c3b72a365cc0275$var$CT_LIST = {
    workbooks: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
        xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
        xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
        xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
        xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
    },
    strs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
        xlsb: "application/vnd.ms-excel.sharedStrings"
    },
    comments: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
        xlsb: "application/vnd.ms-excel.comments"
    },
    sheets: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
        xlsb: "application/vnd.ms-excel.worksheet"
    },
    charts: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
        xlsb: "application/vnd.ms-excel.chartsheet"
    },
    dialogs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
        xlsb: "application/vnd.ms-excel.dialogsheet"
    },
    macros: {
        xlsx: "application/vnd.ms-excel.macrosheet+xml",
        xlsb: "application/vnd.ms-excel.macrosheet"
    },
    metadata: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
        xlsb: "application/vnd.ms-excel.sheetMetadata"
    },
    styles: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
        xlsb: "application/vnd.ms-excel.styles"
    }
};
function $7c3b72a365cc0275$var$new_ct() /*:any*/ {
    return {
        workbooks: [],
        sheets: [],
        charts: [],
        dialogs: [],
        macros: [],
        rels: [],
        strs: [],
        comments: [],
        threadedcomments: [],
        links: [],
        coreprops: [],
        extprops: [],
        custprops: [],
        themes: [],
        styles: [],
        calcchains: [],
        vba: [],
        drawings: [],
        metadata: [],
        people: [],
        TODO: [],
        xmlns: ""
    } /*:any*/ ;
}
function $7c3b72a365cc0275$var$parse_ct(data /*:?string*/ ) {
    var ct = $7c3b72a365cc0275$var$new_ct();
    if (!data || !data.match) return ct;
    var ctext = {};
    (data.match($7c3b72a365cc0275$var$tagregex) || []).forEach(function(x) {
        var y = $7c3b72a365cc0275$var$parsexmltag(x);
        switch(y[0].replace($7c3b72a365cc0275$var$nsregex, "<")){
            case '<?xml':
                break;
            case '<Types':
                ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/) || [
                    "",
                    ""
                ])[1]];
                break;
            case '<Default':
                ctext[y.Extension] = y.ContentType;
                break;
            case '<Override':
                if (ct[$7c3b72a365cc0275$var$ct2type[y.ContentType]] !== undefined) ct[$7c3b72a365cc0275$var$ct2type[y.ContentType]].push(y.PartName);
                break;
        }
    });
    if (ct.xmlns !== $7c3b72a365cc0275$var$XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
    ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
    ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
    ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
    ct.defaults = ctext;
    delete ct.calcchains;
    return ct;
}
function $7c3b72a365cc0275$var$write_ct(ct, opts) /*:string*/ {
    var type2ct /*{[string]:Array<string>}*/  = $7c3b72a365cc0275$var$evert_arr($7c3b72a365cc0275$var$ct2type);
    var o /*:Array<string>*/  = [], v;
    o[o.length] = $7c3b72a365cc0275$var$XML_HEADER;
    o[o.length] = $7c3b72a365cc0275$var$writextag('Types', null, {
        'xmlns': $7c3b72a365cc0275$var$XMLNS.CT,
        'xmlns:xsd': $7c3b72a365cc0275$var$XMLNS.xsd,
        'xmlns:xsi': $7c3b72a365cc0275$var$XMLNS.xsi
    });
    o = o.concat([
        [
            'xml',
            'application/xml'
        ],
        [
            'bin',
            'application/vnd.ms-excel.sheet.binary.macroEnabled.main'
        ],
        [
            'vml',
            'application/vnd.openxmlformats-officedocument.vmlDrawing'
        ],
        [
            'data',
            'application/vnd.openxmlformats-officedocument.model+data'
        ],
        /* from test files */ [
            'bmp',
            'image/bmp'
        ],
        [
            'png',
            'image/png'
        ],
        [
            'gif',
            'image/gif'
        ],
        [
            'emf',
            'image/x-emf'
        ],
        [
            'wmf',
            'image/x-wmf'
        ],
        [
            'jpg',
            'image/jpeg'
        ],
        [
            'jpeg',
            'image/jpeg'
        ],
        [
            'tif',
            'image/tiff'
        ],
        [
            'tiff',
            'image/tiff'
        ],
        [
            'pdf',
            'application/pdf'
        ],
        [
            'rels',
            'application/vnd.openxmlformats-package.relationships+xml'
        ]
    ].map(function(x) {
        return $7c3b72a365cc0275$var$writextag('Default', null, {
            'Extension': x[0],
            'ContentType': x[1]
        });
    }));
    /* only write first instance */ var f1 = function(w) {
        if (ct[w] && ct[w].length > 0) {
            v = ct[w][0];
            o[o.length] = $7c3b72a365cc0275$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': $7c3b72a365cc0275$var$CT_LIST[w][opts.bookType] || $7c3b72a365cc0275$var$CT_LIST[w]['xlsx']
            });
        }
    };
    /* book type-specific */ var f2 = function(w) {
        (ct[w] || []).forEach(function(v) {
            o[o.length] = $7c3b72a365cc0275$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': $7c3b72a365cc0275$var$CT_LIST[w][opts.bookType] || $7c3b72a365cc0275$var$CT_LIST[w]['xlsx']
            });
        });
    };
    /* standard type */ var f3 = function(t) {
        (ct[t] || []).forEach(function(v) {
            o[o.length] = $7c3b72a365cc0275$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': type2ct[t][0]
            });
        });
    };
    f1('workbooks');
    f2('sheets');
    f2('charts');
    f3('themes');
    [
        'strs',
        'styles'
    ].forEach(f1);
    [
        'coreprops',
        'extprops',
        'custprops'
    ].forEach(f3);
    f3('vba');
    f3('comments');
    f3('threadedcomments');
    f3('drawings');
    f2('metadata');
    f3('people');
    if (o.length > 2) {
        o[o.length] = '</Types>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 9.3 Relationships */ var $7c3b72a365cc0275$var$RELS = {
    WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
    VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
    XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
    XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
    XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
    CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
    CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
    CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
    EXT_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties',
    CUST_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties',
    SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
    STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
    THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
    CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
    CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
    CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
    WS: [
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
        "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
    ],
    DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
    MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
    IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
    DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
    XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
    TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
    PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
    VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
} /*:any*/ ;
/* 9.3.3 Representing Relationships */ function $7c3b72a365cc0275$var$get_rels_path(file /*:string*/ ) /*:string*/ {
    var n = file.lastIndexOf("/");
    return file.slice(0, n + 1) + '_rels/' + file.slice(n + 1) + ".rels";
}
function $7c3b72a365cc0275$var$parse_rels(data /*:?string*/ , currentFilePath /*:string*/ ) {
    var rels = {
        "!id": {}
    };
    if (!data) return rels;
    if (currentFilePath.charAt(0) !== '/') currentFilePath = '/' + currentFilePath;
    var hash = {};
    (data.match($7c3b72a365cc0275$var$tagregex) || []).forEach(function(x) {
        var y = $7c3b72a365cc0275$var$parsexmltag(x);
        /* 9.3.2.2 OPC_Relationships */ if (y[0] === '<Relationship') {
            var rel = {};
            rel.Type = y.Type;
            rel.Target = y.Target;
            rel.Id = y.Id;
            if (y.TargetMode) rel.TargetMode = y.TargetMode;
            var canonictarget = y.TargetMode === 'External' ? y.Target : $7c3b72a365cc0275$var$resolve_path(y.Target, currentFilePath);
            rels[canonictarget] = rel;
            hash[y.Id] = rel;
        }
    });
    rels["!id"] = hash;
    return rels;
}
/* TODO */ function $7c3b72a365cc0275$var$write_rels(rels) /*:string*/ {
    var o = [
        $7c3b72a365cc0275$var$XML_HEADER,
        $7c3b72a365cc0275$var$writextag('Relationships', null, {
            //'xmlns:ns0': XMLNS.RELS,
            'xmlns': $7c3b72a365cc0275$var$XMLNS.RELS
        })
    ];
    $7c3b72a365cc0275$var$keys(rels['!id']).forEach(function(rid) {
        o[o.length] = $7c3b72a365cc0275$var$writextag('Relationship', null, rels['!id'][rid]);
    });
    if (o.length > 2) {
        o[o.length] = '</Relationships>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
function $7c3b72a365cc0275$var$add_rels(rels, rId /*:number*/ , f, type, relobj, targetmode /*:?string*/ ) /*:number*/ {
    if (!relobj) relobj = {};
    if (!rels['!id']) rels['!id'] = {};
    if (!rels['!idx']) rels['!idx'] = 1;
    if (rId < 0) for(rId = rels['!idx']; rels['!id']['rId' + rId]; ++rId);
    rels['!idx'] = rId + 1;
    relobj.Id = 'rId' + rId;
    relobj.Type = type;
    relobj.Target = f;
    if (targetmode) relobj.TargetMode = targetmode;
    else if ([
        $7c3b72a365cc0275$var$RELS.HLINK,
        $7c3b72a365cc0275$var$RELS.XPATH,
        $7c3b72a365cc0275$var$RELS.XMISS
    ].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
    if (rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
    rels['!id'][relobj.Id] = relobj;
    rels[('/' + relobj.Target).replace("//", "/")] = relobj;
    return rId;
}
/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */ /* Part 3 Section 4 Manifest File */ var $7c3b72a365cc0275$var$CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function $7c3b72a365cc0275$var$parse_manifest(d, opts) {
    var str = $7c3b72a365cc0275$var$xlml_normalize(d);
    var Rn;
    var FEtag;
    while(Rn = $7c3b72a365cc0275$var$xlmlregex.exec(str))switch(Rn[3]){
        case 'manifest':
            break; // 4.2 <manifest:manifest>
        case 'file-entry':
            FEtag = $7c3b72a365cc0275$var$parsexmltag(Rn[0], false);
            if (FEtag.path == '/' && FEtag.type !== $7c3b72a365cc0275$var$CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
            break;
        case 'encryption-data':
        case 'algorithm':
        case 'start-key-generation':
        case 'key-derivation':
            throw new Error("Unsupported ODS Encryption");
        default:
            if (opts && opts.WTF) throw Rn;
    }
}
function $7c3b72a365cc0275$var$write_manifest(manifest /*:Array<Array<string> >*/ ) /*:string*/ {
    var o = [
        $7c3b72a365cc0275$var$XML_HEADER
    ];
    o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
    o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
    for(var i = 0; i < manifest.length; ++i)o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
    o.push('</manifest:manifest>');
    return o.join("");
}
/* Part 3 Section 6 Metadata Manifest File */ function $7c3b72a365cc0275$var$write_rdf_type(file /*:string*/ , res /*:string*/ , tag /*:?string*/ ) {
    return [
        '  <rdf:Description rdf:about="' + file + '">\n',
        '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + '#' + res + '"/>\n',
        '  </rdf:Description>\n'
    ].join("");
}
function $7c3b72a365cc0275$var$write_rdf_has(base /*:string*/ , file /*:string*/ ) {
    return [
        '  <rdf:Description rdf:about="' + base + '">\n',
        '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
        '  </rdf:Description>\n'
    ].join("");
}
function $7c3b72a365cc0275$var$write_rdf(rdf) {
    var o = [
        $7c3b72a365cc0275$var$XML_HEADER
    ];
    o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
    for(var i = 0; i != rdf.length; ++i){
        o.push($7c3b72a365cc0275$var$write_rdf_type(rdf[i][0], rdf[i][1]));
        o.push($7c3b72a365cc0275$var$write_rdf_has("", rdf[i][0]));
    }
    o.push($7c3b72a365cc0275$var$write_rdf_type("", "Document", "pkg"));
    o.push('</rdf:RDF>');
    return o.join("");
}
/* TODO: pull properties */ function $7c3b72a365cc0275$var$write_meta_ods() /*:string*/ {
    return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + $7c3b72a365cc0275$var$XLSX.version + '</meta:generator></office:meta></office:document-meta>';
}
/* ECMA-376 Part II 11.1 Core Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $7c3b72a365cc0275$var$CORE_PROPS /*:Array<Array<string> >*/  = [
    [
        "cp:category",
        "Category"
    ],
    [
        "cp:contentStatus",
        "ContentStatus"
    ],
    [
        "cp:keywords",
        "Keywords"
    ],
    [
        "cp:lastModifiedBy",
        "LastAuthor"
    ],
    [
        "cp:lastPrinted",
        "LastPrinted"
    ],
    [
        "cp:revision",
        "RevNumber"
    ],
    [
        "cp:version",
        "Version"
    ],
    [
        "dc:creator",
        "Author"
    ],
    [
        "dc:description",
        "Comments"
    ],
    [
        "dc:identifier",
        "Identifier"
    ],
    [
        "dc:language",
        "Language"
    ],
    [
        "dc:subject",
        "Subject"
    ],
    [
        "dc:title",
        "Title"
    ],
    [
        "dcterms:created",
        "CreatedDate",
        'date'
    ],
    [
        "dcterms:modified",
        "ModifiedDate",
        'date'
    ]
];
var $7c3b72a365cc0275$var$CORE_PROPS_REGEX /*:Array<RegExp>*/  = /*#__PURE__*/ function() {
    var r = new Array($7c3b72a365cc0275$var$CORE_PROPS.length);
    for(var i = 0; i < $7c3b72a365cc0275$var$CORE_PROPS.length; ++i){
        var f = $7c3b72a365cc0275$var$CORE_PROPS[i];
        var g = "(?:" + f[0].slice(0, f[0].indexOf(":")) + ":)" + f[0].slice(f[0].indexOf(":") + 1);
        r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)<\/" + g + ">");
    }
    return r;
}();
function $7c3b72a365cc0275$var$parse_core_props(data) {
    var p = {};
    data = $7c3b72a365cc0275$var$utf8read(data);
    for(var i = 0; i < $7c3b72a365cc0275$var$CORE_PROPS.length; ++i){
        var f = $7c3b72a365cc0275$var$CORE_PROPS[i], cur = data.match($7c3b72a365cc0275$var$CORE_PROPS_REGEX[i]);
        if (cur != null && cur.length > 0) p[f[1]] = $7c3b72a365cc0275$var$unescapexml(cur[1]);
        if (f[2] === 'date' && p[f[1]]) p[f[1]] = $7c3b72a365cc0275$var$parseDate(p[f[1]]);
    }
    return p;
}
function $7c3b72a365cc0275$var$cp_doit(f, g, h, o, p) {
    if (p[f] != null || g == null || g === "") return;
    p[f] = g;
    g = $7c3b72a365cc0275$var$escapexml(g);
    o[o.length] = h ? $7c3b72a365cc0275$var$writextag(f, g, h) : $7c3b72a365cc0275$var$writetag(f, g);
}
function $7c3b72a365cc0275$var$write_core_props(cp, _opts) {
    var opts = _opts || {};
    var o = [
        $7c3b72a365cc0275$var$XML_HEADER,
        $7c3b72a365cc0275$var$writextag('cp:coreProperties', null, {
            //'xmlns': XMLNS.CORE_PROPS,
            'xmlns:cp': $7c3b72a365cc0275$var$XMLNS.CORE_PROPS,
            'xmlns:dc': $7c3b72a365cc0275$var$XMLNS.dc,
            'xmlns:dcterms': $7c3b72a365cc0275$var$XMLNS.dcterms,
            'xmlns:dcmitype': $7c3b72a365cc0275$var$XMLNS.dcmitype,
            'xmlns:xsi': $7c3b72a365cc0275$var$XMLNS.xsi
        })
    ], p = {};
    if (!cp && !opts.Props) return o.join("");
    if (cp) {
        if (cp.CreatedDate != null) $7c3b72a365cc0275$var$cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : $7c3b72a365cc0275$var$write_w3cdtf(cp.CreatedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
        if (cp.ModifiedDate != null) $7c3b72a365cc0275$var$cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : $7c3b72a365cc0275$var$write_w3cdtf(cp.ModifiedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
    }
    for(var i = 0; i != $7c3b72a365cc0275$var$CORE_PROPS.length; ++i){
        var f = $7c3b72a365cc0275$var$CORE_PROPS[i];
        var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
        if (v === true) v = "1";
        else if (v === false) v = "0";
        else if (typeof v == "number") v = String(v);
        if (v != null) $7c3b72a365cc0275$var$cp_doit(f[0], v, null, o, p);
    }
    if (o.length > 2) {
        o[o.length] = '</cp:coreProperties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $7c3b72a365cc0275$var$EXT_PROPS /*:Array<Array<string> >*/  = [
    [
        "Application",
        "Application",
        "string"
    ],
    [
        "AppVersion",
        "AppVersion",
        "string"
    ],
    [
        "Company",
        "Company",
        "string"
    ],
    [
        "DocSecurity",
        "DocSecurity",
        "string"
    ],
    [
        "Manager",
        "Manager",
        "string"
    ],
    [
        "HyperlinksChanged",
        "HyperlinksChanged",
        "bool"
    ],
    [
        "SharedDoc",
        "SharedDoc",
        "bool"
    ],
    [
        "LinksUpToDate",
        "LinksUpToDate",
        "bool"
    ],
    [
        "ScaleCrop",
        "ScaleCrop",
        "bool"
    ],
    [
        "HeadingPairs",
        "HeadingPairs",
        "raw"
    ],
    [
        "TitlesOfParts",
        "TitlesOfParts",
        "raw"
    ]
];
var $7c3b72a365cc0275$var$PseudoPropsPairs = [
    "Worksheets",
    "SheetNames",
    "NamedRanges",
    "DefinedNames",
    "Chartsheets",
    "ChartNames"
];
function $7c3b72a365cc0275$var$load_props_pairs(HP /*:string|Array<Array<any>>*/ , TOP, props, opts) {
    var v = [];
    if (typeof HP == "string") v = $7c3b72a365cc0275$var$parseVector(HP, opts);
    else for(var j = 0; j < HP.length; ++j)v = v.concat(HP[j].map(function(hp) {
        return {
            v: hp
        };
    }));
    var parts = typeof TOP == "string" ? $7c3b72a365cc0275$var$parseVector(TOP, opts).map(function(x) {
        return x.v;
    }) : TOP;
    var idx = 0, len = 0;
    if (parts.length > 0) for(var i = 0; i !== v.length; i += 2){
        len = +v[i + 1].v;
        switch(v[i].v){
            case "Worksheets":
            case "\u5DE5\u4F5C\u8868":
            case "\u041B\u0438\u0441\u0442\u044B":
            case "\u0623\u0648\u0631\u0627\u0642 \u0627\u0644\u0639\u0645\u0644":
            case "\u30EF\u30FC\u30AF\u30B7\u30FC\u30C8":
            case "\u05D2\u05DC\u05D9\u05D5\u05E0\u05D5\u05EA \u05E2\u05D1\u05D5\u05D3\u05D4":
            case "Arbeitsbl\xe4tter":
            case "\xc7al\u0131\u015Fma Sayfalar\u0131":
            case "Feuilles de calcul":
            case "Fogli di lavoro":
            case "Folhas de c\xe1lculo":
            case "Planilhas":
            case "Regneark":
            case "Hojas de c\xe1lculo":
            case "Werkbladen":
                props.Worksheets = len;
                props.SheetNames = parts.slice(idx, idx + len);
                break;
            case "Named Ranges":
            case "Rangos con nombre":
            case "\u540D\u524D\u4ED8\u304D\u4E00\u89A7":
            case "Benannte Bereiche":
            case "Navngivne omr\xe5der":
                props.NamedRanges = len;
                props.DefinedNames = parts.slice(idx, idx + len);
                break;
            case "Charts":
            case "Diagramme":
                props.Chartsheets = len;
                props.ChartNames = parts.slice(idx, idx + len);
                break;
        }
        idx += len;
    }
}
function $7c3b72a365cc0275$var$parse_ext_props(data, p, opts) {
    var q = {};
    if (!p) p = {};
    data = $7c3b72a365cc0275$var$utf8read(data);
    $7c3b72a365cc0275$var$EXT_PROPS.forEach(function(f) {
        var xml = (data.match($7c3b72a365cc0275$var$matchtag(f[0])) || [])[1];
        switch(f[2]){
            case "string":
                if (xml) p[f[1]] = $7c3b72a365cc0275$var$unescapexml(xml);
                break;
            case "bool":
                p[f[1]] = xml === "true";
                break;
            case "raw":
                var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)<\/" + f[0] + ">"));
                if (cur && cur.length > 0) q[f[1]] = cur[1];
                break;
        }
    });
    if (q.HeadingPairs && q.TitlesOfParts) $7c3b72a365cc0275$var$load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
    return p;
}
function $7c3b72a365cc0275$var$write_ext_props(cp /*::, opts*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], W = $7c3b72a365cc0275$var$writextag;
    if (!cp) cp = {};
    cp.Application = "SheetJS";
    o[o.length] = $7c3b72a365cc0275$var$XML_HEADER;
    o[o.length] = $7c3b72a365cc0275$var$writextag('Properties', null, {
        'xmlns': $7c3b72a365cc0275$var$XMLNS.EXT_PROPS,
        'xmlns:vt': $7c3b72a365cc0275$var$XMLNS.vt
    });
    $7c3b72a365cc0275$var$EXT_PROPS.forEach(function(f) {
        if (cp[f[1]] === undefined) return;
        var v;
        switch(f[2]){
            case 'string':
                v = $7c3b72a365cc0275$var$escapexml(String(cp[f[1]]));
                break;
            case 'bool':
                v = cp[f[1]] ? 'true' : 'false';
                break;
        }
        if (v !== undefined) o[o.length] = W(f[0], v);
    });
    /* TODO: HeadingPairs, TitlesOfParts */ o[o.length] = W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>') + W('vt:variant', W('vt:i4', String(cp.Worksheets))), {
        size: 2,
        baseType: "variant"
    }));
    o[o.length] = W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) {
        return "<vt:lpstr>" + $7c3b72a365cc0275$var$escapexml(s) + "</vt:lpstr>";
    }).join(""), {
        size: cp.Worksheets,
        baseType: "lpstr"
    }));
    if (o.length > 2) {
        o[o.length] = '</Properties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */ var $7c3b72a365cc0275$var$custregex = /<[^>]+>[^<]*/g;
function $7c3b72a365cc0275$var$parse_cust_props(data /*:string*/ , opts) {
    var p = {}, name = "";
    var m = data.match($7c3b72a365cc0275$var$custregex);
    if (m) for(var i = 0; i != m.length; ++i){
        var x = m[i], y = $7c3b72a365cc0275$var$parsexmltag(x);
        switch(y[0]){
            case '<?xml':
                break;
            case '<Properties':
                break;
            case '<property':
                name = $7c3b72a365cc0275$var$unescapexml(y.name);
                break;
            case '</property>':
                name = null;
                break;
            default:
                if (x.indexOf('<vt:') === 0) {
                    var toks = x.split('>');
                    var type = toks[0].slice(4), text = toks[1];
                    /* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */ switch(type){
                        case 'lpstr':
                        case 'bstr':
                        case 'lpwstr':
                            p[name] = $7c3b72a365cc0275$var$unescapexml(text);
                            break;
                        case 'bool':
                            p[name] = $7c3b72a365cc0275$var$parsexmlbool(text);
                            break;
                        case 'i1':
                        case 'i2':
                        case 'i4':
                        case 'i8':
                        case 'int':
                        case 'uint':
                            p[name] = parseInt(text, 10);
                            break;
                        case 'r4':
                        case 'r8':
                        case 'decimal':
                            p[name] = parseFloat(text);
                            break;
                        case 'filetime':
                        case 'date':
                            p[name] = $7c3b72a365cc0275$var$parseDate(text);
                            break;
                        case 'cy':
                        case 'error':
                            p[name] = $7c3b72a365cc0275$var$unescapexml(text);
                            break;
                        default:
                            if (type.slice(-1) == '/') break;
                            if (opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
                    }
                } else if (x.slice(0, 2) === "</") ;
                else if (opts.WTF) throw new Error(x);
        }
    }
    return p;
}
function $7c3b72a365cc0275$var$write_cust_props(cp /*::, opts*/ ) /*:string*/ {
    var o = [
        $7c3b72a365cc0275$var$XML_HEADER,
        $7c3b72a365cc0275$var$writextag('Properties', null, {
            'xmlns': $7c3b72a365cc0275$var$XMLNS.CUST_PROPS,
            'xmlns:vt': $7c3b72a365cc0275$var$XMLNS.vt
        })
    ];
    if (!cp) return o.join("");
    var pid = 1;
    $7c3b72a365cc0275$var$keys(cp).forEach(function custprop(k) {
        ++pid;
        o[o.length] = $7c3b72a365cc0275$var$writextag('property', $7c3b72a365cc0275$var$write_vt(cp[k], true), {
            'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
            'pid': pid,
            'name': $7c3b72a365cc0275$var$escapexml(k)
        });
    });
    if (o.length > 2) {
        o[o.length] = '</Properties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* Common Name -> XLML Name */ var $7c3b72a365cc0275$var$XLMLDocPropsMap = {
    Title: 'Title',
    Subject: 'Subject',
    Author: 'Author',
    Keywords: 'Keywords',
    Comments: 'Description',
    LastAuthor: 'LastAuthor',
    RevNumber: 'Revision',
    Application: 'AppName',
    /* TotalTime: 'TotalTime', */ LastPrinted: 'LastPrinted',
    CreatedDate: 'Created',
    ModifiedDate: 'LastSaved',
    /* Pages */ /* Words */ /* Characters */ Category: 'Category',
    /* PresentationFormat */ Manager: 'Manager',
    Company: 'Company',
    /* Guid */ /* HyperlinkBase */ /* Bytes */ /* Lines */ /* Paragraphs */ /* CharactersWithSpaces */ AppVersion: 'Version',
    ContentStatus: 'ContentStatus',
    /* NOTE: missing from schema */ Identifier: 'Identifier',
    /* NOTE: missing from schema */ Language: 'Language' /* NOTE: missing from schema */ 
};
var $7c3b72a365cc0275$var$evert_XLMLDPM;
function $7c3b72a365cc0275$var$xlml_set_prop(Props, tag /*:string*/ , val) {
    if (!$7c3b72a365cc0275$var$evert_XLMLDPM) $7c3b72a365cc0275$var$evert_XLMLDPM = $7c3b72a365cc0275$var$evert($7c3b72a365cc0275$var$XLMLDocPropsMap);
    tag = $7c3b72a365cc0275$var$evert_XLMLDPM[tag] || tag;
    Props[tag] = val;
}
function $7c3b72a365cc0275$var$xlml_write_docprops(Props, opts) {
    var o /*:Array<string>*/  = [];
    $7c3b72a365cc0275$var$keys($7c3b72a365cc0275$var$XLMLDocPropsMap).map(function(m) {
        for(var i = 0; i < $7c3b72a365cc0275$var$CORE_PROPS.length; ++i)if ($7c3b72a365cc0275$var$CORE_PROPS[i][1] == m) return $7c3b72a365cc0275$var$CORE_PROPS[i];
        for(i = 0; i < $7c3b72a365cc0275$var$EXT_PROPS.length; ++i)if ($7c3b72a365cc0275$var$EXT_PROPS[i][1] == m) return $7c3b72a365cc0275$var$EXT_PROPS[i];
        throw m;
    }).forEach(function(p) {
        if (Props[p[1]] == null) return;
        var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
        switch(p[2]){
            case 'date':
                m = new Date(m).toISOString().replace(/\.\d*Z/, "Z");
                break;
        }
        if (typeof m == 'number') m = String(m);
        else if (m === true || m === false) m = m ? "1" : "0";
        else if (m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/, "");
        o.push($7c3b72a365cc0275$var$writetag($7c3b72a365cc0275$var$XLMLDocPropsMap[p[1]] || p[1], m));
    });
    return $7c3b72a365cc0275$var$writextag('DocumentProperties', o.join(""), {
        xmlns: $7c3b72a365cc0275$var$XLMLNS.o
    });
}
function $7c3b72a365cc0275$var$xlml_write_custprops(Props, Custprops /*::, opts*/ ) {
    var BLACKLIST = [
        "Worksheets",
        "SheetNames"
    ];
    var T = 'CustomDocumentProperties';
    var o /*:Array<string>*/  = [];
    if (Props) $7c3b72a365cc0275$var$keys(Props).forEach(function(k) {
        /*:: if(!Props) return; */ if (!Object.prototype.hasOwnProperty.call(Props, k)) return;
        for(var i = 0; i < $7c3b72a365cc0275$var$CORE_PROPS.length; ++i)if (k == $7c3b72a365cc0275$var$CORE_PROPS[i][1]) return;
        for(i = 0; i < $7c3b72a365cc0275$var$EXT_PROPS.length; ++i)if (k == $7c3b72a365cc0275$var$EXT_PROPS[i][1]) return;
        for(i = 0; i < BLACKLIST.length; ++i)if (k == BLACKLIST[i]) return;
        var m = Props[k];
        var t = "string";
        if (typeof m == 'number') {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else m = String(m);
        o.push($7c3b72a365cc0275$var$writextag($7c3b72a365cc0275$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    if (Custprops) $7c3b72a365cc0275$var$keys(Custprops).forEach(function(k) {
        /*:: if(!Custprops) return; */ if (!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
        if (Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
        var m = Custprops[k];
        var t = "string";
        if (typeof m == 'number') {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else if (m instanceof Date) {
            t = "dateTime.tz";
            m = m.toISOString();
        } else m = String(m);
        o.push($7c3b72a365cc0275$var$writextag($7c3b72a365cc0275$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    return '<' + T + ' xmlns="' + $7c3b72a365cc0275$var$XLMLNS.o + '">' + o.join("") + '</' + T + '>';
}
/* [MS-DTYP] 2.3.3 FILETIME */ /* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */ /* [MS-OLEPS] 2.8 FILETIME (Packet Version) */ function $7c3b72a365cc0275$var$parse_FILETIME(blob) {
    var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
    return new Date((dwHighDateTime / 1e7 * Math.pow(2, 32) + dwLowDateTime / 1e7 - 11644473600) * 1000).toISOString().replace(/\.000/, "");
}
function $7c3b72a365cc0275$var$write_FILETIME(time /*:string|Date*/ ) {
    var date = typeof time == "string" ? new Date(Date.parse(time)) : time;
    var t = date.getTime() / 1000 + 11644473600;
    var l = t % Math.pow(2, 32), h = (t - l) / Math.pow(2, 32);
    l *= 1e7;
    h *= 1e7;
    var w = l / Math.pow(2, 32) | 0;
    if (w > 0) {
        l = l % Math.pow(2, 32);
        h += w;
    }
    var o = $7c3b72a365cc0275$var$new_buf(8);
    o.write_shift(4, l);
    o.write_shift(4, h);
    return o;
}
/* [MS-OSHARED] 2.3.3.1.4 Lpstr */ function $7c3b72a365cc0275$var$parse_lpstr(blob, type, pad /*:?number*/ ) {
    var start = blob.l;
    var str = blob.read_shift(0, 'lpstr-cp');
    if (pad) while(blob.l - start & 3)++blob.l;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */ function $7c3b72a365cc0275$var$parse_lpwstr(blob, type, pad) {
    var str = blob.read_shift(0, 'lpwstr');
    if (pad) blob.l += 4 - (str.length + 1 & 3) & 3;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.11 VtString */ /* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */ function $7c3b72a365cc0275$var$parse_VtStringBase(blob, stringType, pad) {
    if (stringType === 0x1F /*VT_LPWSTR*/ ) return $7c3b72a365cc0275$var$parse_lpwstr(blob);
    return $7c3b72a365cc0275$var$parse_lpstr(blob, stringType, pad);
}
function $7c3b72a365cc0275$var$parse_VtString(blob, t /*:number*/ , pad /*:?boolean*/ ) {
    return $7c3b72a365cc0275$var$parse_VtStringBase(blob, t, pad === false ? 0 : 4);
}
function $7c3b72a365cc0275$var$parse_VtUnalignedString(blob, t /*:number*/ ) {
    if (!t) throw new Error("VtUnalignedString must have positive length");
    return $7c3b72a365cc0275$var$parse_VtStringBase(blob, t, 0);
}
/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */ function $7c3b72a365cc0275$var$parse_VtVecLpwstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i){
        var start = blob.l;
        ret[i] = blob.read_shift(0, 'lpwstr').replace($7c3b72a365cc0275$var$chr0, '');
        if (blob.l - start & 0x02) blob.l += 2;
    }
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */ function $7c3b72a365cc0275$var$parse_VtVecUnalignedLpstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i)ret[i] = blob.read_shift(0, 'lpstr-cp').replace($7c3b72a365cc0275$var$chr0, '');
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */ function $7c3b72a365cc0275$var$parse_VtHeadingPair(blob) {
    var start = blob.l;
    var headingString = $7c3b72a365cc0275$var$parse_TypedPropertyValue(blob, $7c3b72a365cc0275$var$VT_USTR);
    if (blob[blob.l] == 0x00 && blob[blob.l + 1] == 0x00 && blob.l - start & 0x02) blob.l += 2;
    var headerParts = $7c3b72a365cc0275$var$parse_TypedPropertyValue(blob, $7c3b72a365cc0275$var$VT_I4);
    return [
        headingString,
        headerParts
    ];
}
/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */ function $7c3b72a365cc0275$var$parse_VtVecHeadingPairValue(blob) {
    var cElements = blob.read_shift(4);
    var out = [];
    for(var i = 0; i < cElements / 2; ++i)out.push($7c3b72a365cc0275$var$parse_VtHeadingPair(blob));
    return out;
}
/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */ function $7c3b72a365cc0275$var$parse_dictionary(blob, CodePage) {
    var cnt = blob.read_shift(4);
    var dict /*:{[number]:string}*/  = {} /*:any*/ ;
    for(var j = 0; j != cnt; ++j){
        var pid = blob.read_shift(4);
        var len = blob.read_shift(4);
        dict[pid] = blob.read_shift(len, CodePage === 0x4B0 ? 'utf16le' : 'utf8').replace($7c3b72a365cc0275$var$chr0, '').replace($7c3b72a365cc0275$var$chr1, '!');
        if (CodePage === 0x4B0 && len % 2) blob.l += 2;
    }
    if (blob.l & 3) blob.l = blob.l >> 3 << 2;
    return dict;
}
/* [MS-OLEPS] 2.9 BLOB */ function $7c3b72a365cc0275$var$parse_BLOB(blob) {
    var size = blob.read_shift(4);
    var bytes = blob.slice(blob.l, blob.l + size);
    blob.l += size;
    if ((size & 3) > 0) blob.l += 4 - (size & 3) & 3;
    return bytes;
}
/* [MS-OLEPS] 2.11 ClipboardData */ function $7c3b72a365cc0275$var$parse_ClipboardData(blob) {
    // TODO
    var o = {};
    o.Size = blob.read_shift(4);
    //o.Format = blob.read_shift(4);
    blob.l += o.Size + 3 - (o.Size - 1) % 4;
    return o;
}
/* [MS-OLEPS] 2.15 TypedPropertyValue */ function $7c3b72a365cc0275$var$parse_TypedPropertyValue(blob, type /*:number*/ , _opts) /*:any*/ {
    var t = blob.read_shift(2), ret, opts = _opts || {};
    blob.l += 2;
    if (type !== $7c3b72a365cc0275$var$VT_VARIANT) {
        if (t !== type && $7c3b72a365cc0275$var$VT_CUSTOM.indexOf(type) === -1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error('Expected type ' + type + ' saw ' + t);
    }
    switch(type === $7c3b72a365cc0275$var$VT_VARIANT ? t : type){
        case 0x02 /*VT_I2*/ :
            ret = blob.read_shift(2, 'i');
            if (!opts.raw) blob.l += 2;
            return ret;
        case 0x03 /*VT_I4*/ :
            ret = blob.read_shift(4, 'i');
            return ret;
        case 0x0B /*VT_BOOL*/ :
            return blob.read_shift(4) !== 0x0;
        case 0x13 /*VT_UI4*/ :
            ret = blob.read_shift(4);
            return ret;
        case 0x1E /*VT_LPSTR*/ :
            return $7c3b72a365cc0275$var$parse_lpstr(blob, t, 4).replace($7c3b72a365cc0275$var$chr0, '');
        case 0x1F /*VT_LPWSTR*/ :
            return $7c3b72a365cc0275$var$parse_lpwstr(blob);
        case 0x40 /*VT_FILETIME*/ :
            return $7c3b72a365cc0275$var$parse_FILETIME(blob);
        case 0x41 /*VT_BLOB*/ :
            return $7c3b72a365cc0275$var$parse_BLOB(blob);
        case 0x47 /*VT_CF*/ :
            return $7c3b72a365cc0275$var$parse_ClipboardData(blob);
        case 0x50 /*VT_STRING*/ :
            return $7c3b72a365cc0275$var$parse_VtString(blob, t, !opts.raw).replace($7c3b72a365cc0275$var$chr0, '');
        case 0x51 /*VT_USTR*/ :
            return $7c3b72a365cc0275$var$parse_VtUnalignedString(blob, t /*, 4*/ ).replace($7c3b72a365cc0275$var$chr0, '');
        case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
            return $7c3b72a365cc0275$var$parse_VtVecHeadingPairValue(blob);
        case 0x101E /*VT_VECTOR|VT_LPSTR*/ :
        case 0x101F /*VT_VECTOR|VT_LPWSTR*/ :
            return t == 0x101F ? $7c3b72a365cc0275$var$parse_VtVecLpwstrValue(blob) : $7c3b72a365cc0275$var$parse_VtVecUnalignedLpstrValue(blob);
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
    }
}
function $7c3b72a365cc0275$var$write_TypedPropertyValue(type /*:number*/ , value) {
    var o = $7c3b72a365cc0275$var$new_buf(4), p = $7c3b72a365cc0275$var$new_buf(4);
    o.write_shift(4, type == 0x50 ? 0x1F : type);
    switch(type){
        case 0x03 /*VT_I4*/ :
            p.write_shift(-4, value);
            break;
        case 0x05 /*VT_I4*/ :
            p = $7c3b72a365cc0275$var$new_buf(8);
            p.write_shift(8, value, 'f');
            break;
        case 0x0B /*VT_BOOL*/ :
            p.write_shift(4, value ? 0x01 : 0x00);
            break;
        case 0x40 /*VT_FILETIME*/ :
            /*:: if(typeof value !== "string" && !(value instanceof Date)) throw "unreachable"; */ p = $7c3b72a365cc0275$var$write_FILETIME(value);
            break;
        case 0x1F /*VT_LPWSTR*/ :
        case 0x50 /*VT_STRING*/ :
            /*:: if(typeof value !== "string") throw "unreachable"; */ p = $7c3b72a365cc0275$var$new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            p.write_shift(4, value.length + 1);
            p.write_shift(0, value, "dbcs");
            while(p.l != p.length)p.write_shift(1, 0);
            break;
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
    }
    return $7c3b72a365cc0275$var$bconcat([
        o,
        p
    ]);
}
/* [MS-OLEPS] 2.20 PropertySet */ function $7c3b72a365cc0275$var$parse_PropertySet(blob, PIDSI) {
    var start_addr = blob.l;
    var size = blob.read_shift(4);
    var NumProps = blob.read_shift(4);
    var Props = [], i = 0;
    var CodePage = 0;
    var Dictionary = -1, DictObj /*:{[number]:string}*/  = {} /*:any*/ ;
    for(i = 0; i != NumProps; ++i){
        var PropID = blob.read_shift(4);
        var Offset = blob.read_shift(4);
        Props[i] = [
            PropID,
            Offset + start_addr
        ];
    }
    Props.sort(function(x, y) {
        return x[1] - y[1];
    });
    var PropH = {};
    for(i = 0; i != NumProps; ++i){
        if (blob.l !== Props[i][1]) {
            var fail = true;
            if (i > 0 && PIDSI) switch(PIDSI[Props[i - 1][0]].t){
                case 0x02 /*VT_I2*/ :
                    if (blob.l + 2 === Props[i][1]) {
                        blob.l += 2;
                        fail = false;
                    }
                    break;
                case 0x50 /*VT_STRING*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
                case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
            }
            if ((!PIDSI || i == 0) && blob.l <= Props[i][1]) {
                fail = false;
                blob.l = Props[i][1];
            }
            if (fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
        }
        if (PIDSI) {
            var piddsi = PIDSI[Props[i][0]];
            PropH[piddsi.n] = $7c3b72a365cc0275$var$parse_TypedPropertyValue(blob, piddsi.t, {
                raw: true
            });
            if (piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
            if (piddsi.n == "CodePage") switch(PropH[piddsi.n]){
                case 0:
                    PropH[piddsi.n] = 1252;
                /* falls through */ case 874:
                case 932:
                case 936:
                case 949:
                case 950:
                case 1250:
                case 1251:
                case 1253:
                case 1254:
                case 1255:
                case 1256:
                case 1257:
                case 1258:
                case 10000:
                case 1200:
                case 1201:
                case 1252:
                case 65000:
                case -536:
                case 65001:
                case -535:
                    $7c3b72a365cc0275$var$set_cp(CodePage = PropH[piddsi.n] >>> 0 & 0xFFFF);
                    break;
                default:
                    throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
            }
        } else {
            if (Props[i][0] === 0x1) {
                CodePage = PropH.CodePage = $7c3b72a365cc0275$var$parse_TypedPropertyValue(blob, $7c3b72a365cc0275$var$VT_I2);
                $7c3b72a365cc0275$var$set_cp(CodePage);
                if (Dictionary !== -1) {
                    var oldpos = blob.l;
                    blob.l = Props[Dictionary][1];
                    DictObj = $7c3b72a365cc0275$var$parse_dictionary(blob, CodePage);
                    blob.l = oldpos;
                }
            } else if (Props[i][0] === 0) {
                if (CodePage === 0) {
                    Dictionary = i;
                    blob.l = Props[i + 1][1];
                    continue;
                }
                DictObj = $7c3b72a365cc0275$var$parse_dictionary(blob, CodePage);
            } else {
                var name = DictObj[Props[i][0]];
                var val;
                /* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */ switch(blob[blob.l]){
                    case 0x41 /*VT_BLOB*/ :
                        blob.l += 4;
                        val = $7c3b72a365cc0275$var$parse_BLOB(blob);
                        break;
                    case 0x1E /*VT_LPSTR*/ :
                        blob.l += 4;
                        val = $7c3b72a365cc0275$var$parse_VtString(blob, blob[blob.l - 4]).replace(/\u0000+$/, "");
                        break;
                    case 0x1F /*VT_LPWSTR*/ :
                        blob.l += 4;
                        val = $7c3b72a365cc0275$var$parse_VtString(blob, blob[blob.l - 4]).replace(/\u0000+$/, "");
                        break;
                    case 0x03 /*VT_I4*/ :
                        blob.l += 4;
                        val = blob.read_shift(4, 'i');
                        break;
                    case 0x13 /*VT_UI4*/ :
                        blob.l += 4;
                        val = blob.read_shift(4);
                        break;
                    case 0x05 /*VT_R8*/ :
                        blob.l += 4;
                        val = blob.read_shift(8, 'f');
                        break;
                    case 0x0B /*VT_BOOL*/ :
                        blob.l += 4;
                        val = $7c3b72a365cc0275$var$parsebool(blob, 4);
                        break;
                    case 0x40 /*VT_FILETIME*/ :
                        blob.l += 4;
                        val = $7c3b72a365cc0275$var$parseDate($7c3b72a365cc0275$var$parse_FILETIME(blob));
                        break;
                    default:
                        throw new Error("unparsed value: " + blob[blob.l]);
                }
                PropH[name] = val;
            }
        }
    }
    blob.l = start_addr + size; /* step ahead to skip padding */ 
    return PropH;
}
var $7c3b72a365cc0275$var$XLSPSSkip = [
    "CodePage",
    "Thumbnail",
    "_PID_LINKBASE",
    "_PID_HLINKS",
    "SystemIdentifier",
    "FMTID"
]; //.concat(PseudoPropsPairs);
function $7c3b72a365cc0275$var$guess_property_type(val /*:any*/ ) /*:number*/ {
    switch(typeof val){
        case "boolean":
            return 0x0B;
        case "number":
            return (val | 0) == val ? 0x03 : 0x05;
        case "string":
            return 0x1F;
        case "object":
            if (val instanceof Date) return 0x40;
            break;
    }
    return -1;
}
function $7c3b72a365cc0275$var$write_PropertySet(entries, RE, PIDSI) {
    var hdr = $7c3b72a365cc0275$var$new_buf(8), piao = [], prop = [];
    var sz = 8, i = 0;
    var pr = $7c3b72a365cc0275$var$new_buf(8), pio = $7c3b72a365cc0275$var$new_buf(8);
    pr.write_shift(4, 0x0002);
    pr.write_shift(4, 0x04B0);
    pio.write_shift(4, 0x0001);
    prop.push(pr);
    piao.push(pio);
    sz += 8 + pr.length;
    if (!RE) {
        pio = $7c3b72a365cc0275$var$new_buf(8);
        pio.write_shift(4, 0);
        piao.unshift(pio);
        var bufs = [
            $7c3b72a365cc0275$var$new_buf(4)
        ];
        bufs[0].write_shift(4, entries.length);
        for(i = 0; i < entries.length; ++i){
            var value = entries[i][0];
            pr = $7c3b72a365cc0275$var$new_buf(8 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            pr.write_shift(4, i + 2);
            pr.write_shift(4, value.length + 1);
            pr.write_shift(0, value, "dbcs");
            while(pr.l != pr.length)pr.write_shift(1, 0);
            bufs.push(pr);
        }
        pr = $7c3b72a365cc0275$var$bconcat(bufs);
        prop.unshift(pr);
        sz += 8 + pr.length;
    }
    for(i = 0; i < entries.length; ++i){
        if (RE && !RE[entries[i][0]]) continue;
        if ($7c3b72a365cc0275$var$XLSPSSkip.indexOf(entries[i][0]) > -1 || $7c3b72a365cc0275$var$PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
        if (entries[i][1] == null) continue;
        var val = entries[i][1], idx = 0;
        if (RE) {
            idx = +RE[entries[i][0]];
            var pinfo = PIDSI /*:: || {}*/ [idx] /*:: || {} */ ;
            if (pinfo.p == "version" && typeof val == "string") {
                /*:: if(typeof val !== "string") throw "unreachable"; */ var arr = val.split(".");
                val = (+arr[0] << 16) + (+arr[1] || 0);
            }
            pr = $7c3b72a365cc0275$var$write_TypedPropertyValue(pinfo.t, val);
        } else {
            var T = $7c3b72a365cc0275$var$guess_property_type(val);
            if (T == -1) {
                T = 0x1F;
                val = String(val);
            }
            pr = $7c3b72a365cc0275$var$write_TypedPropertyValue(T, val);
        }
        prop.push(pr);
        pio = $7c3b72a365cc0275$var$new_buf(8);
        pio.write_shift(4, !RE ? 2 + i : idx);
        piao.push(pio);
        sz += 8 + pr.length;
    }
    var w = 8 * (prop.length + 1);
    for(i = 0; i < prop.length; ++i){
        piao[i].write_shift(4, w);
        w += prop[i].length;
    }
    hdr.write_shift(4, sz);
    hdr.write_shift(4, prop.length);
    return $7c3b72a365cc0275$var$bconcat([
        hdr
    ].concat(piao).concat(prop));
}
/* [MS-OLEPS] 2.21 PropertySetStream */ function $7c3b72a365cc0275$var$parse_PropertySetStream(file, PIDSI, clsid) {
    var blob = file.content;
    if (!blob) return {} /*:any*/ ;
    $7c3b72a365cc0275$var$prep_blob(blob, 0);
    var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
    blob.chk('feff', 'Byte Order: ');
    /*var vers = */ blob.read_shift(2); // TODO: check version
    var SystemIdentifier = blob.read_shift(4);
    var CLSID = blob.read_shift(16);
    if (CLSID !== $7c3b72a365cc0275$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
    NumSets = blob.read_shift(4);
    if (NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
    FMTID0 = blob.read_shift(16);
    Offset0 = blob.read_shift(4);
    if (NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
    else if (NumSets === 2) {
        FMTID1 = blob.read_shift(16);
        Offset1 = blob.read_shift(4);
    }
    var PSet0 = $7c3b72a365cc0275$var$parse_PropertySet(blob, PIDSI);
    var rval = {
        SystemIdentifier: SystemIdentifier
    } /*:any*/ ;
    for(var y in PSet0)rval[y] = PSet0[y];
    //rval.blob = blob;
    rval.FMTID = FMTID0;
    //rval.PSet0 = PSet0;
    if (NumSets === 1) return rval;
    if (Offset1 - blob.l == 2) blob.l += 2;
    if (blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
    var PSet1;
    try {
        PSet1 = $7c3b72a365cc0275$var$parse_PropertySet(blob, null);
    } catch (e) {}
    for(y in PSet1)rval[y] = PSet1[y];
    rval.FMTID = [
        FMTID0,
        FMTID1
    ]; // TODO: verify FMTID0/1
    return rval;
}
function $7c3b72a365cc0275$var$write_PropertySetStream(entries, clsid, RE, PIDSI /*:{[key:string|number]:any}*/ , entries2 /*:?any*/ , clsid2 /*:?any*/ ) {
    var hdr = $7c3b72a365cc0275$var$new_buf(entries2 ? 68 : 48);
    var bufs = [
        hdr
    ];
    hdr.write_shift(2, 0xFFFE);
    hdr.write_shift(2, 0x0000); /* TODO: type 1 props */ 
    hdr.write_shift(4, 0x32363237);
    hdr.write_shift(16, $7c3b72a365cc0275$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID, "hex");
    hdr.write_shift(4, entries2 ? 2 : 1);
    hdr.write_shift(16, clsid, "hex");
    hdr.write_shift(4, entries2 ? 68 : 48);
    var ps0 = $7c3b72a365cc0275$var$write_PropertySet(entries, RE, PIDSI);
    bufs.push(ps0);
    if (entries2) {
        var ps1 = $7c3b72a365cc0275$var$write_PropertySet(entries2, null, null);
        hdr.write_shift(16, clsid2, "hex");
        hdr.write_shift(4, 68 + ps0.length);
        bufs.push(ps1);
    }
    return $7c3b72a365cc0275$var$bconcat(bufs);
}
function $7c3b72a365cc0275$var$parsenoop2(blob, length) {
    blob.read_shift(length);
    return null;
}
function $7c3b72a365cc0275$var$writezeroes(n, o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(n);
    for(var j = 0; j < n; ++j)o.write_shift(1, 0);
    return o;
}
function $7c3b72a365cc0275$var$parslurp(blob, length, cb) {
    var arr = [], target = blob.l + length;
    while(blob.l < target)arr.push(cb(blob, target - blob.l));
    if (target !== blob.l) throw new Error("Slurp error");
    return arr;
}
function $7c3b72a365cc0275$var$parsebool(blob, length /*:number*/ ) {
    return blob.read_shift(length) === 0x1;
}
function $7c3b72a365cc0275$var$writebool(v /*:any*/ , o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(2);
    o.write_shift(2, +!!v);
    return o;
}
function $7c3b72a365cc0275$var$parseuint16(blob /*::, length:?number, opts:?any*/ ) {
    return blob.read_shift(2, 'u');
}
function $7c3b72a365cc0275$var$writeuint16(v /*:number*/ , o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(2);
    o.write_shift(2, v);
    return o;
}
function $7c3b72a365cc0275$var$parseuint16a(blob, length /*:: :?number, opts:?any*/ ) {
    return $7c3b72a365cc0275$var$parslurp(blob, length, $7c3b72a365cc0275$var$parseuint16);
}
/* --- 2.5 Structures --- */ /* [MS-XLS] 2.5.10 Bes (boolean or error) */ function $7c3b72a365cc0275$var$parse_Bes(blob /*::, length*/ ) {
    var v = blob.read_shift(1), t = blob.read_shift(1);
    return t === 0x01 ? v : v === 0x01;
}
function $7c3b72a365cc0275$var$write_Bes(v, t /*:string*/ , o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(2);
    o.write_shift(1, t == 'e' ? +v : +!!v);
    o.write_shift(1, t == 'e' ? 1 : 0);
    return o;
}
/* [MS-XLS] 2.5.240 ShortXLUnicodeString */ function $7c3b72a365cc0275$var$parse_ShortXLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
    var encoding = 'sbcs-cont';
    var cp = $7c3b72a365cc0275$var$current_codepage;
    if (opts && opts.biff >= 8) $7c3b72a365cc0275$var$current_codepage = 1200;
    if (!opts || opts.biff == 8) {
        var fHighByte = blob.read_shift(1);
        if (fHighByte) encoding = 'dbcs-cont';
    } else if (opts.biff == 12) encoding = 'wstr';
    if (opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
    var o = cch ? blob.read_shift(cch, encoding) : "";
    $7c3b72a365cc0275$var$current_codepage = cp;
    return o;
}
/* 2.5.293 XLUnicodeRichExtendedString */ function $7c3b72a365cc0275$var$parse_XLUnicodeRichExtendedString(blob) {
    var cp = $7c3b72a365cc0275$var$current_codepage;
    $7c3b72a365cc0275$var$current_codepage = 1200;
    var cch = blob.read_shift(2), flags = blob.read_shift(1);
    var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
    var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
    var cRun = 0, cbExtRst;
    var z = {};
    if (fRichSt) cRun = blob.read_shift(2);
    if (fExtSt) cbExtRst = blob.read_shift(4);
    var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
    var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
    if (fRichSt) blob.l += 4 * cRun; //TODO: parse this
    if (fExtSt) blob.l += cbExtRst; //TODO: parse this
    z.t = msg;
    if (!fRichSt) {
        z.raw = "<t>" + z.t + "</t>";
        z.r = z.t;
    }
    $7c3b72a365cc0275$var$current_codepage = cp;
    return z;
}
function $7c3b72a365cc0275$var$write_XLUnicodeRichExtendedString(xlstr /*:: :XLString, opts*/ ) {
    var str = xlstr.t || "", nfmts = 1;
    var hdr = $7c3b72a365cc0275$var$new_buf(3 + (nfmts > 1 ? 2 : 0));
    hdr.write_shift(2, str.length);
    hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
    if (nfmts > 1) hdr.write_shift(2, nfmts);
    var otext = $7c3b72a365cc0275$var$new_buf(2 * str.length);
    otext.write_shift(2 * str.length, str, 'utf16le');
    var out = [
        hdr,
        otext
    ];
    return $7c3b72a365cc0275$var$bconcat(out);
}
/* 2.5.296 XLUnicodeStringNoCch */ function $7c3b72a365cc0275$var$parse_XLUnicodeStringNoCch(blob, cch, opts) {
    var retval;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
        if (opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
    }
    var fHighByte = blob.read_shift(1);
    if (fHighByte === 0) retval = blob.read_shift(cch, 'sbcs-cont');
    else retval = blob.read_shift(cch, 'dbcs-cont');
    return retval;
}
/* 2.5.294 XLUnicodeString */ function $7c3b72a365cc0275$var$parse_XLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return $7c3b72a365cc0275$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */ function $7c3b72a365cc0275$var$parse_XLUnicodeString2(blob, length, opts) {
    if (opts.biff > 5) return $7c3b72a365cc0275$var$parse_XLUnicodeString(blob, length, opts);
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, opts.biff <= 4 || !blob.lens ? 'cpstr' : 'sbcs-cont');
}
/* TODO: BIFF5 and lower, codepage awareness */ function $7c3b72a365cc0275$var$write_XLUnicodeString(str, opts, o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(3 + 2 * str.length);
    o.write_shift(2, str.length);
    o.write_shift(1, 1);
    o.write_shift(31, str, 'utf16le');
    return o;
}
/* [MS-XLS] 2.5.61 ControlInfo */ function $7c3b72a365cc0275$var$parse_ControlInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(1);
    blob.l++;
    var accel = blob.read_shift(2);
    blob.l += 2;
    return [
        flags,
        accel
    ];
}
/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */ function $7c3b72a365cc0275$var$parse_URLMoniker(blob /*::, length, opts*/ ) {
    var len = blob.read_shift(4), start = blob.l;
    var extra = false;
    if (len > 24) {
        /* look ahead */ blob.l += len - 24;
        if (blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
        blob.l = start;
    }
    var url = blob.read_shift((extra ? len - 24 : len) >> 1, 'utf16le').replace($7c3b72a365cc0275$var$chr0, "");
    if (extra) blob.l += 24;
    return url;
}
/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */ function $7c3b72a365cc0275$var$parse_FileMoniker(blob /*::, length*/ ) {
    var cAnti = blob.read_shift(2);
    var preamble = "";
    while(cAnti-- > 0)preamble += "../";
    var ansiPath = blob.read_shift(0, 'lpstr-ansi');
    blob.l += 2; //var endServer = blob.read_shift(2);
    if (blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
    var sz = blob.read_shift(4);
    if (sz === 0) return preamble + ansiPath.replace(/\\/g, "/");
    var bytes = blob.read_shift(4);
    if (blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
    var unicodePath = blob.read_shift(bytes >> 1, 'utf16le').replace($7c3b72a365cc0275$var$chr0, "");
    return preamble + unicodePath;
}
/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */ function $7c3b72a365cc0275$var$parse_HyperlinkMoniker(blob, length) {
    var clsid = blob.read_shift(16);
    length -= 16;
    switch(clsid){
        case "e0c9ea79f9bace118c8200aa004ba90b":
            return $7c3b72a365cc0275$var$parse_URLMoniker(blob, length);
        case "0303000000000000c000000000000046":
            return $7c3b72a365cc0275$var$parse_FileMoniker(blob, length);
        default:
            throw new Error("Unsupported Moniker " + clsid);
    }
}
/* [MS-OSHARED] 2.3.7.9 HyperlinkString */ function $7c3b72a365cc0275$var$parse_HyperlinkString(blob /*::, length*/ ) {
    var len = blob.read_shift(4);
    var o = len > 0 ? blob.read_shift(len, 'utf16le').replace($7c3b72a365cc0275$var$chr0, "") : "";
    return o;
}
function $7c3b72a365cc0275$var$write_HyperlinkString(str /*:string*/ , o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(6 + str.length * 2);
    o.write_shift(4, 1 + str.length);
    for(var i = 0; i < str.length; ++i)o.write_shift(2, str.charCodeAt(i));
    o.write_shift(2, 0);
    return o;
}
/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */ function $7c3b72a365cc0275$var$parse_Hyperlink(blob, length) /*:Hyperlink*/ {
    var end = blob.l + length;
    var sVer = blob.read_shift(4);
    if (sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
    var flags = blob.read_shift(2);
    blob.l += 2;
    var displayName, targetFrameName, moniker, oleMoniker, Loc = "", guid, fileTime;
    if (flags & 0x0010) displayName = $7c3b72a365cc0275$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0080) targetFrameName = $7c3b72a365cc0275$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0101) moniker = $7c3b72a365cc0275$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0001) oleMoniker = $7c3b72a365cc0275$var$parse_HyperlinkMoniker(blob, end - blob.l);
    if (flags & 0x0008) Loc = $7c3b72a365cc0275$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0020) guid = blob.read_shift(16);
    if (flags & 0x0040) fileTime = $7c3b72a365cc0275$var$parse_FILETIME(blob /*, 8*/ );
    blob.l = end;
    var target = targetFrameName || moniker || oleMoniker || "";
    if (target && Loc) target += "#" + Loc;
    if (!target) target = "#" + Loc;
    if (flags & 0x0002 && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
    var out = {
        Target: target
    } /*:any*/ ;
    if (guid) out.guid = guid;
    if (fileTime) out.time = fileTime;
    if (displayName) out.Tooltip = displayName;
    return out;
}
function $7c3b72a365cc0275$var$write_Hyperlink(hl) {
    var out = $7c3b72a365cc0275$var$new_buf(512), i = 0;
    var Target = hl.Target;
    if (Target.slice(0, 7) == "file://") Target = Target.slice(7);
    var hashidx = Target.indexOf("#");
    var F = hashidx > -1 ? 0x1f : 0x17;
    switch(Target.charAt(0)){
        case "#":
            F = 0x1c;
            break;
        case ".":
            F &= -3;
            break;
    }
    out.write_shift(4, 2);
    out.write_shift(4, F);
    var data = [
        8,
        6815827,
        6619237,
        4849780,
        83
    ];
    for(i = 0; i < data.length; ++i)out.write_shift(4, data[i]);
    if (F == 0x1C) {
        Target = Target.slice(1);
        $7c3b72a365cc0275$var$write_HyperlinkString(Target, out);
    } else if (F & 0x02) {
        data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
        out.write_shift(4, 2 * (Pretarget.length + 1));
        for(i = 0; i < Pretarget.length; ++i)out.write_shift(2, Pretarget.charCodeAt(i));
        out.write_shift(2, 0);
        if (F & 0x08) $7c3b72a365cc0275$var$write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx + 1) : "", out);
    } else {
        data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var P = 0;
        while(Target.slice(P * 3, P * 3 + 3) == "../" || Target.slice(P * 3, P * 3 + 3) == "..\\")++P;
        out.write_shift(2, P);
        out.write_shift(4, Target.length - 3 * P + 1);
        for(i = 0; i < Target.length - 3 * P; ++i)out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
        out.write_shift(1, 0);
        out.write_shift(2, 0xFFFF);
        out.write_shift(2, 0xDEAD);
        for(i = 0; i < 6; ++i)out.write_shift(4, 0);
    }
    return out.slice(0, out.l);
}
/* 2.5.178 LongRGBA */ function $7c3b72a365cc0275$var$parse_LongRGBA(blob /*::, length*/ ) {
    var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1);
    return [
        r,
        g,
        b,
        a
    ];
}
/* 2.5.177 LongRGB */ function $7c3b72a365cc0275$var$parse_LongRGB(blob, length) {
    var x = $7c3b72a365cc0275$var$parse_LongRGBA(blob, length);
    x[3] = 0;
    return x;
}
/* [MS-XLS] 2.5.19 */ function $7c3b72a365cc0275$var$parse_XLSCell(blob /*::, length*/ ) /*:Cell*/ {
    var rw = blob.read_shift(2); // 0-indexed
    var col = blob.read_shift(2);
    var ixfe = blob.read_shift(2);
    return {
        r: rw,
        c: col,
        ixfe: ixfe
    } /*:any*/ ;
}
function $7c3b72a365cc0275$var$write_XLSCell(R /*:number*/ , C /*:number*/ , ixfe /*:?number*/ , o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(6);
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, ixfe || 0);
    return o;
}
/* [MS-XLS] 2.5.134 */ function $7c3b72a365cc0275$var$parse_frtHeader(blob) {
    var rt = blob.read_shift(2);
    var flags = blob.read_shift(2); // TODO: parse these flags
    blob.l += 8;
    return {
        type: rt,
        flags: flags
    };
}
function $7c3b72a365cc0275$var$parse_OptXLUnicodeString(blob, length, opts) {
    return length === 0 ? "" : $7c3b72a365cc0275$var$parse_XLUnicodeString2(blob, length, opts);
}
/* [MS-XLS] 2.5.344 */ function $7c3b72a365cc0275$var$parse_XTI(blob, length, opts) {
    var w = opts.biff > 8 ? 4 : 2;
    var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w, 'i'), itabLast = blob.read_shift(w, 'i');
    return [
        iSupBook,
        itabFirst,
        itabLast
    ];
}
/* [MS-XLS] 2.5.218 */ function $7c3b72a365cc0275$var$parse_RkRec(blob) {
    var ixfe = blob.read_shift(2);
    var RK = $7c3b72a365cc0275$var$parse_RkNumber(blob);
    return [
        ixfe,
        RK
    ];
}
/* [MS-XLS] 2.5.1 */ function $7c3b72a365cc0275$var$parse_AddinUdf(blob, length, opts) {
    blob.l += 4;
    length -= 4;
    var l = blob.l + length;
    var udfName = $7c3b72a365cc0275$var$parse_ShortXLUnicodeString(blob, length, opts);
    var cb = blob.read_shift(2);
    l -= blob.l;
    if (cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
    blob.l += cb;
    return udfName;
}
/* [MS-XLS] 2.5.209 TODO: Check sizes */ function $7c3b72a365cc0275$var$parse_Ref8U(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(2);
    var colLast = blob.read_shift(2);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
function $7c3b72a365cc0275$var$write_Ref8U(r /*:Range*/ , o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(8);
    o.write_shift(2, r.s.r);
    o.write_shift(2, r.e.r);
    o.write_shift(2, r.s.c);
    o.write_shift(2, r.e.c);
    return o;
}
/* [MS-XLS] 2.5.211 */ function $7c3b72a365cc0275$var$parse_RefU(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(1);
    var colLast = blob.read_shift(1);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
/* [MS-XLS] 2.5.207 */ var $7c3b72a365cc0275$var$parse_Ref = $7c3b72a365cc0275$var$parse_RefU;
/* [MS-XLS] 2.5.143 */ function $7c3b72a365cc0275$var$parse_FtCmo(blob /*::, length*/ ) {
    blob.l += 4;
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var flags = blob.read_shift(2);
    blob.l += 12;
    return [
        id,
        ot,
        flags
    ];
}
/* [MS-XLS] 2.5.149 */ function $7c3b72a365cc0275$var$parse_FtNts(blob) {
    var out = {};
    blob.l += 4;
    blob.l += 16; // GUID TODO
    out.fSharedNote = blob.read_shift(2);
    blob.l += 4;
    return out;
}
/* [MS-XLS] 2.5.142 */ function $7c3b72a365cc0275$var$parse_FtCf(blob) {
    var out = {};
    blob.l += 4;
    blob.cf = blob.read_shift(2);
    return out;
}
/* [MS-XLS] 2.5.140 - 2.5.154 and friends */ function $7c3b72a365cc0275$var$parse_FtSkip(blob) {
    blob.l += 2;
    blob.l += blob.read_shift(2);
}
var $7c3b72a365cc0275$var$FtTab = {
    /*::[*/ 0x00: $7c3b72a365cc0275$var$parse_FtSkip,
    /* FtEnd */ /*::[*/ 0x04: $7c3b72a365cc0275$var$parse_FtSkip,
    /* FtMacro */ /*::[*/ 0x05: $7c3b72a365cc0275$var$parse_FtSkip,
    /* FtButton */ /*::[*/ 0x06: $7c3b72a365cc0275$var$parse_FtSkip,
    /* FtGmo */ /*::[*/ 0x07: $7c3b72a365cc0275$var$parse_FtCf,
    /* FtCf */ /*::[*/ 0x08: $7c3b72a365cc0275$var$parse_FtSkip,
    /* FtPioGrbit */ /*::[*/ 0x09: $7c3b72a365cc0275$var$parse_FtSkip,
    /* FtPictFmla */ /*::[*/ 0x0A: $7c3b72a365cc0275$var$parse_FtSkip,
    /* FtCbls */ /*::[*/ 0x0B: $7c3b72a365cc0275$var$parse_FtSkip,
    /* FtRbo */ /*::[*/ 0x0C: $7c3b72a365cc0275$var$parse_FtSkip,
    /* FtSbs */ /*::[*/ 0x0D: $7c3b72a365cc0275$var$parse_FtNts,
    /* FtNts */ /*::[*/ 0x0E: $7c3b72a365cc0275$var$parse_FtSkip,
    /* FtSbsFmla */ /*::[*/ 0x0F: $7c3b72a365cc0275$var$parse_FtSkip,
    /* FtGboData */ /*::[*/ 0x10: $7c3b72a365cc0275$var$parse_FtSkip,
    /* FtEdoData */ /*::[*/ 0x11: $7c3b72a365cc0275$var$parse_FtSkip,
    /* FtRboData */ /*::[*/ 0x12: $7c3b72a365cc0275$var$parse_FtSkip,
    /* FtCblsData */ /*::[*/ 0x13: $7c3b72a365cc0275$var$parse_FtSkip,
    /* FtLbsData */ /*::[*/ 0x14: $7c3b72a365cc0275$var$parse_FtSkip,
    /* FtCblsFmla */ /*::[*/ 0x15: $7c3b72a365cc0275$var$parse_FtCmo
};
function $7c3b72a365cc0275$var$parse_FtArray(blob, length /*::, ot*/ ) {
    var tgt = blob.l + length;
    var fts = [];
    while(blob.l < tgt){
        var ft = blob.read_shift(2);
        blob.l -= 2;
        try {
            fts.push($7c3b72a365cc0275$var$FtTab[ft](blob, tgt - blob.l));
        } catch (e) {
            blob.l = tgt;
            return fts;
        }
    }
    if (blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
    return fts;
}
/* --- 2.4 Records --- */ /* [MS-XLS] 2.4.21 */ function $7c3b72a365cc0275$var$parse_BOF(blob, length) {
    var o = {
        BIFFVer: 0,
        dt: 0
    };
    o.BIFFVer = blob.read_shift(2);
    length -= 2;
    if (length >= 2) {
        o.dt = blob.read_shift(2);
        blob.l -= 2;
    }
    switch(o.BIFFVer){
        case 0x0600:
        /* BIFF8 */ case 0x0500:
        /* BIFF5 */ case 0x0400:
        /* BIFF4 */ case 0x0300:
        /* BIFF3 */ case 0x0200:
        /* BIFF2 */ case 0x0002:
        case 0x0007:
            break;
        default:
            if (length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
    }
    blob.read_shift(length);
    return o;
}
function $7c3b72a365cc0275$var$write_BOF(wb /*:Workbook*/ , t /*:number*/ , o) {
    var h = 0x0600, w = 16;
    switch(o.bookType){
        case 'biff8':
            break;
        case 'biff5':
            h = 0x0500;
            w = 8;
            break;
        case 'biff4':
            h = 0x0004;
            w = 6;
            break;
        case 'biff3':
            h = 0x0003;
            w = 6;
            break;
        case 'biff2':
            h = 0x0002;
            w = 4;
            break;
        case 'xla':
            break;
        default:
            throw new Error("unsupported BIFF version");
    }
    var out = $7c3b72a365cc0275$var$new_buf(w);
    out.write_shift(2, h);
    out.write_shift(2, t);
    if (w > 4) out.write_shift(2, 0x7262);
    if (w > 6) out.write_shift(2, 0x07CD);
    if (w > 8) {
        out.write_shift(2, 0xC009);
        out.write_shift(2, 0x0001);
        out.write_shift(2, 0x0706);
        out.write_shift(2, 0x0000);
    }
    return out;
}
/* [MS-XLS] 2.4.146 */ function $7c3b72a365cc0275$var$parse_InterfaceHdr(blob, length) {
    if (length === 0) return 0x04b0;
    blob.read_shift(2);
    return 0x04b0;
}
/* [MS-XLS] 2.4.349 */ function $7c3b72a365cc0275$var$parse_WriteAccess(blob, length, opts) {
    if (opts.enc) {
        blob.l += length;
        return "";
    }
    var l = blob.l;
    // TODO: make sure XLUnicodeString doesnt overrun
    var UserName = $7c3b72a365cc0275$var$parse_XLUnicodeString2(blob, 0, opts);
    blob.read_shift(length + l - blob.l);
    return UserName;
}
function $7c3b72a365cc0275$var$write_WriteAccess(s /*:string*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $7c3b72a365cc0275$var$new_buf(b8 ? 112 : 54);
    o.write_shift(opts.biff == 8 ? 2 : 1, 7);
    if (b8) o.write_shift(1, 0);
    o.write_shift(4, 0x33336853);
    o.write_shift(4, 0x00534A74 | (b8 ? 0 : 0x20000000));
    while(o.l < o.length)o.write_shift(1, b8 ? 0 : 32);
    return o;
}
/* [MS-XLS] 2.4.351 */ function $7c3b72a365cc0275$var$parse_WsBool(blob, length, opts) {
    var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
    return {
        fDialog: flags & 0x10,
        fBelow: flags & 0x40,
        fRight: flags & 0x80
    };
}
/* [MS-XLS] 2.4.28 */ function $7c3b72a365cc0275$var$parse_BoundSheet8(blob, length, opts) {
    var pos = blob.read_shift(4);
    var hidden = blob.read_shift(1) & 0x03;
    var dt = blob.read_shift(1);
    switch(dt){
        case 0:
            dt = 'Worksheet';
            break;
        case 1:
            dt = 'Macrosheet';
            break;
        case 2:
            dt = 'Chartsheet';
            break;
        case 6:
            dt = 'VBAModule';
            break;
    }
    var name = $7c3b72a365cc0275$var$parse_ShortXLUnicodeString(blob, 0, opts);
    if (name.length === 0) name = "Sheet1";
    return {
        pos: pos,
        hs: hidden,
        dt: dt,
        name: name
    };
}
function $7c3b72a365cc0275$var$write_BoundSheet8(data, opts) {
    var w = !opts || opts.biff >= 8 ? 2 : 1;
    var o = $7c3b72a365cc0275$var$new_buf(8 + w * data.name.length);
    o.write_shift(4, data.pos);
    o.write_shift(1, data.hs || 0);
    o.write_shift(1, data.dt);
    o.write_shift(1, data.name.length);
    if (opts.biff >= 8) o.write_shift(1, 1);
    o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
    var out = o.slice(0, o.l);
    out.l = o.l;
    return out;
}
/* [MS-XLS] 2.4.265 TODO */ function $7c3b72a365cc0275$var$parse_SST(blob, length) /*:SST*/ {
    var end = blob.l + length;
    var cnt = blob.read_shift(4);
    var ucnt = blob.read_shift(4);
    var strs /*:SST*/  = [];
    for(var i = 0; i != ucnt && blob.l < end; ++i)strs.push($7c3b72a365cc0275$var$parse_XLUnicodeRichExtendedString(blob));
    strs.Count = cnt;
    strs.Unique = ucnt;
    return strs;
}
function $7c3b72a365cc0275$var$write_SST(sst, opts) {
    var header = $7c3b72a365cc0275$var$new_buf(8);
    header.write_shift(4, sst.Count);
    header.write_shift(4, sst.Unique);
    var strs = [];
    for(var j = 0; j < sst.length; ++j)strs[j] = $7c3b72a365cc0275$var$write_XLUnicodeRichExtendedString(sst[j], opts);
    var o = $7c3b72a365cc0275$var$bconcat([
        header
    ].concat(strs));
    /*::(*/ o /*:: :any)*/ .parts = [
        header.length
    ].concat(strs.map(function(str) {
        return str.length;
    }));
    return o;
}
/* [MS-XLS] 2.4.107 */ function $7c3b72a365cc0275$var$parse_ExtSST(blob, length) {
    var extsst = {};
    extsst.dsst = blob.read_shift(2);
    blob.l += length - 2;
    return extsst;
}
/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */ function $7c3b72a365cc0275$var$parse_Row(blob) {
    var z = {} /*:any*/ ;
    z.r = blob.read_shift(2);
    z.c = blob.read_shift(2);
    z.cnt = blob.read_shift(2) - z.c;
    var miyRw = blob.read_shift(2);
    blob.l += 4; // reserved(2), unused(2)
    var flags = blob.read_shift(1); // various flags
    blob.l += 3; // reserved(8), ixfe(12), flags(4)
    if (flags & 0x07) z.level = flags & 0x07;
    // collapsed: flags & 0x10
    if (flags & 0x20) z.hidden = true;
    if (flags & 0x40) z.hpt = miyRw / 20;
    return z;
}
/* [MS-XLS] 2.4.125 */ function $7c3b72a365cc0275$var$parse_ForceFullCalculation(blob) {
    var header = $7c3b72a365cc0275$var$parse_frtHeader(blob);
    if (header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
    var fullcalc = blob.read_shift(4);
    return fullcalc !== 0x0;
}
/* [MS-XLS] 2.4.215 rt */ function $7c3b72a365cc0275$var$parse_RecalcId(blob) {
    blob.read_shift(2);
    return blob.read_shift(4);
}
/* [MS-XLS] 2.4.87 */ function $7c3b72a365cc0275$var$parse_DefaultRowHeight(blob, length, opts) {
    var f = 0;
    if (!(opts && opts.biff == 2)) f = blob.read_shift(2);
    var miyRw = blob.read_shift(2);
    if (opts && opts.biff == 2) {
        f = 1 - (miyRw >> 15);
        miyRw &= 0x7fff;
    }
    var fl = {
        Unsynced: f & 1,
        DyZero: (f & 2) >> 1,
        ExAsc: (f & 4) >> 2,
        ExDsc: (f & 8) >> 3
    };
    return [
        fl,
        miyRw
    ];
}
/* [MS-XLS] 2.4.345 TODO */ function $7c3b72a365cc0275$var$parse_Window1(blob) {
    var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
    var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
    var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
    return {
        Pos: [
            xWn,
            yWn
        ],
        Dim: [
            dxWn,
            dyWn
        ],
        Flags: flags,
        CurTab: iTabCur,
        FirstTab: iTabFirst,
        Selected: ctabSel,
        TabRatio: wTabRatio
    };
}
function $7c3b72a365cc0275$var$write_Window1() {
    var o = $7c3b72a365cc0275$var$new_buf(18);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0x7260);
    o.write_shift(2, 0x44c0);
    o.write_shift(2, 0x38);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 1);
    o.write_shift(2, 0x01f4);
    return o;
}
/* [MS-XLS] 2.4.346 TODO */ function $7c3b72a365cc0275$var$parse_Window2(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff < 5) return {};
    var f = blob.read_shift(2);
    return {
        RTL: f & 0x40
    };
}
function $7c3b72a365cc0275$var$write_Window2(view) {
    var o = $7c3b72a365cc0275$var$new_buf(18), f = 0x6b6;
    if (view && view.RTL) f |= 0x40;
    o.write_shift(2, f);
    o.write_shift(4, 0);
    o.write_shift(4, 64);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLS] 2.4.189 TODO */ function $7c3b72a365cc0275$var$parse_Pane() {}
/* [MS-XLS] 2.4.122 TODO */ function $7c3b72a365cc0275$var$parse_Font(blob, length, opts) {
    var o /*:any*/  = {
        dyHeight: blob.read_shift(2),
        fl: blob.read_shift(2)
    };
    switch(opts && opts.biff || 8){
        case 2:
            break;
        case 3:
        case 4:
            blob.l += 2;
            break;
        default:
            blob.l += 10;
            break;
    }
    o.name = $7c3b72a365cc0275$var$parse_ShortXLUnicodeString(blob, 0, opts);
    return o;
}
function $7c3b72a365cc0275$var$write_Font(data, opts) {
    var name = data.name || "Arial";
    var b5 = opts && opts.biff == 5, w = b5 ? 15 + name.length : 16 + 2 * name.length;
    var o = $7c3b72a365cc0275$var$new_buf(w);
    o.write_shift(2, (data.sz || 12) * 20);
    o.write_shift(4, 0);
    o.write_shift(2, 400);
    o.write_shift(4, 0);
    o.write_shift(2, 0);
    o.write_shift(1, name.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * name.length, name, b5 ? "sbcs" : "utf16le");
    return o;
}
/* [MS-XLS] 2.4.149 */ function $7c3b72a365cc0275$var$parse_LabelSst(blob) {
    var cell = $7c3b72a365cc0275$var$parse_XLSCell(blob);
    cell.isst = blob.read_shift(4);
    return cell;
}
function $7c3b72a365cc0275$var$write_LabelSst(R /*:number*/ , C /*:number*/ , v /*:number*/ , os /*:number*/  /*::, opts*/ ) {
    var o = $7c3b72a365cc0275$var$new_buf(10);
    $7c3b72a365cc0275$var$write_XLSCell(R, C, os, o);
    o.write_shift(4, v);
    return o;
}
/* [MS-XLS] 2.4.148 */ function $7c3b72a365cc0275$var$parse_Label(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var target = blob.l + length;
    var cell = $7c3b72a365cc0275$var$parse_XLSCell(blob, 6);
    if (opts.biff == 2) blob.l++;
    var str = $7c3b72a365cc0275$var$parse_XLUnicodeString(blob, target - blob.l, opts);
    cell.val = str;
    return cell;
}
function $7c3b72a365cc0275$var$write_Label(R /*:number*/ , C /*:number*/ , v /*:string*/ , os /*:number*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $7c3b72a365cc0275$var$new_buf(8 + +b8 + (1 + b8) * v.length);
    $7c3b72a365cc0275$var$write_XLSCell(R, C, os, o);
    o.write_shift(2, v.length);
    if (b8) o.write_shift(1, 1);
    o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
    return o;
}
/* [MS-XLS] 2.4.126 Number Formats */ function $7c3b72a365cc0275$var$parse_Format(blob, length, opts) {
    var numFmtId = blob.read_shift(2);
    var fmtstr = $7c3b72a365cc0275$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        numFmtId,
        fmtstr
    ];
}
function $7c3b72a365cc0275$var$write_Format(i /*:number*/ , f /*:string*/ , opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $7c3b72a365cc0275$var$new_buf(b5 ? 3 + f.length : 5 + 2 * f.length);
    o.write_shift(2, i);
    o.write_shift(b5 ? 1 : 2, f.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * f.length, f, b5 ? 'sbcs' : 'utf16le');
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (out.l == null) out.l = out.length;
    return out;
}
var $7c3b72a365cc0275$var$parse_BIFF2Format = $7c3b72a365cc0275$var$parse_XLUnicodeString2;
/* [MS-XLS] 2.4.90 */ function $7c3b72a365cc0275$var$parse_Dimensions(blob, length, opts) {
    var end = blob.l + length;
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = blob.read_shift(2), C = blob.read_shift(2);
    blob.l = end;
    return {
        s: {
            r: r,
            c: c
        },
        e: {
            r: R,
            c: C
        }
    };
}
function $7c3b72a365cc0275$var$write_Dimensions(range, opts) {
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var o = $7c3b72a365cc0275$var$new_buf(2 * w + 6);
    o.write_shift(w, range.s.r);
    o.write_shift(w, range.e.r + 1);
    o.write_shift(2, range.s.c);
    o.write_shift(2, range.e.c + 1);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.220 */ function $7c3b72a365cc0275$var$parse_RK(blob) {
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrec = $7c3b72a365cc0275$var$parse_RkRec(blob);
    return {
        r: rw,
        c: col,
        ixfe: rkrec[0],
        rknum: rkrec[1]
    };
}
/* [MS-XLS] 2.4.175 */ function $7c3b72a365cc0275$var$parse_MulRk(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrecs = [];
    while(blob.l < target)rkrecs.push($7c3b72a365cc0275$var$parse_RkRec(blob));
    if (blob.l !== target) throw new Error("MulRK read error");
    var lastcol = blob.read_shift(2);
    if (rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        rkrec: rkrecs
    };
}
/* [MS-XLS] 2.4.174 */ function $7c3b72a365cc0275$var$parse_MulBlank(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var ixfes = [];
    while(blob.l < target)ixfes.push(blob.read_shift(2));
    if (blob.l !== target) throw new Error("MulBlank read error");
    var lastcol = blob.read_shift(2);
    if (ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        ixfe: ixfes
    };
}
/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */ function $7c3b72a365cc0275$var$parse_CellStyleXF(blob, length, style, opts) {
    var o = {};
    var a = blob.read_shift(4), b = blob.read_shift(4);
    var c = blob.read_shift(4), d = blob.read_shift(2);
    o.patternType = $7c3b72a365cc0275$var$XLSFillPattern[c >> 26];
    if (!opts.cellStyles) return o;
    o.alc = a & 0x07;
    o.fWrap = a >> 3 & 0x01;
    o.alcV = a >> 4 & 0x07;
    o.fJustLast = a >> 7 & 0x01;
    o.trot = a >> 8 & 0xFF;
    o.cIndent = a >> 16 & 0x0F;
    o.fShrinkToFit = a >> 20 & 0x01;
    o.iReadOrder = a >> 22 & 0x02;
    o.fAtrNum = a >> 26 & 0x01;
    o.fAtrFnt = a >> 27 & 0x01;
    o.fAtrAlc = a >> 28 & 0x01;
    o.fAtrBdr = a >> 29 & 0x01;
    o.fAtrPat = a >> 30 & 0x01;
    o.fAtrProt = a >> 31 & 0x01;
    o.dgLeft = b & 0x0F;
    o.dgRight = b >> 4 & 0x0F;
    o.dgTop = b >> 8 & 0x0F;
    o.dgBottom = b >> 12 & 0x0F;
    o.icvLeft = b >> 16 & 0x7F;
    o.icvRight = b >> 23 & 0x7F;
    o.grbitDiag = b >> 30 & 0x03;
    o.icvTop = c & 0x7F;
    o.icvBottom = c >> 7 & 0x7F;
    o.icvDiag = c >> 14 & 0x7F;
    o.dgDiag = c >> 21 & 0x0F;
    o.icvFore = d & 0x7F;
    o.icvBack = d >> 7 & 0x7F;
    o.fsxButton = d >> 14 & 0x01;
    return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
/* [MS-XLS] 2.4.353 TODO: actually do this right */ function $7c3b72a365cc0275$var$parse_XF(blob, length, opts) {
    var o = {};
    o.ifnt = blob.read_shift(2);
    o.numFmtId = blob.read_shift(2);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    length -= 6;
    o.data = $7c3b72a365cc0275$var$parse_CellStyleXF(blob, length, o.fStyle, opts);
    return o;
}
function $7c3b72a365cc0275$var$write_XF(data, ixfeP, opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $7c3b72a365cc0275$var$new_buf(b5 ? 16 : 20);
    o.write_shift(2, 0);
    if (data.style) {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, 0xFFF4);
    } else {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, ixfeP << 4);
    }
    var f = 0;
    if (data.numFmtId > 0 && b5) f |= 0x0400;
    o.write_shift(4, f);
    o.write_shift(4, 0);
    if (!b5) o.write_shift(4, 0);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.134 */ function $7c3b72a365cc0275$var$parse_Guts(blob) {
    blob.l += 4;
    var out = [
        blob.read_shift(2),
        blob.read_shift(2)
    ];
    if (out[0] !== 0) out[0]--;
    if (out[1] !== 0) out[1]--;
    if (out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
    return out;
}
function $7c3b72a365cc0275$var$write_Guts(guts /*:Array<number>*/ ) {
    var o = $7c3b72a365cc0275$var$new_buf(8);
    o.write_shift(4, 0);
    o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
    o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
    return o;
}
/* [MS-XLS] 2.4.24 */ function $7c3b72a365cc0275$var$parse_BoolErr(blob, length, opts) {
    var cell = $7c3b72a365cc0275$var$parse_XLSCell(blob, 6);
    if (opts.biff == 2 || length == 9) ++blob.l;
    var val = $7c3b72a365cc0275$var$parse_Bes(blob, 2);
    cell.val = val;
    cell.t = val === true || val === false ? 'b' : 'e';
    return cell;
}
function $7c3b72a365cc0275$var$write_BoolErr(R /*:number*/ , C /*:number*/ , v, os /*:number*/ , opts, t /*:string*/ ) {
    var o = $7c3b72a365cc0275$var$new_buf(8);
    $7c3b72a365cc0275$var$write_XLSCell(R, C, os, o);
    $7c3b72a365cc0275$var$write_Bes(v, t, o);
    return o;
}
/* [MS-XLS] 2.4.180 Number */ function $7c3b72a365cc0275$var$parse_Number(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var cell = $7c3b72a365cc0275$var$parse_XLSCell(blob, 6);
    var xnum = $7c3b72a365cc0275$var$parse_Xnum(blob, 8);
    cell.val = xnum;
    return cell;
}
function $7c3b72a365cc0275$var$write_Number(R /*:number*/ , C /*:number*/ , v, os /*:: :number, opts*/ ) {
    var o = $7c3b72a365cc0275$var$new_buf(14);
    $7c3b72a365cc0275$var$write_XLSCell(R, C, os, o);
    $7c3b72a365cc0275$var$write_Xnum(v, o);
    return o;
}
var $7c3b72a365cc0275$var$parse_XLHeaderFooter = $7c3b72a365cc0275$var$parse_OptXLUnicodeString; // TODO: parse 2.4.136
/* [MS-XLS] 2.4.271 */ function $7c3b72a365cc0275$var$parse_SupBook(blob, length, opts) {
    var end = blob.l + length;
    var ctab = blob.read_shift(2);
    var cch = blob.read_shift(2);
    opts.sbcch = cch;
    if (cch == 0x0401 || cch == 0x3A01) return [
        cch,
        ctab
    ];
    if (cch < 0x01 || cch > 0xff) throw new Error("Unexpected SupBook type: " + cch);
    var virtPath = $7c3b72a365cc0275$var$parse_XLUnicodeStringNoCch(blob, cch);
    /* TODO: 2.5.277 Virtual Path */ var rgst = [];
    while(end > blob.l)rgst.push($7c3b72a365cc0275$var$parse_XLUnicodeString(blob));
    return [
        cch,
        ctab,
        virtPath,
        rgst
    ];
}
/* [MS-XLS] 2.4.105 TODO */ function $7c3b72a365cc0275$var$parse_ExternName(blob, length, opts) {
    var flags = blob.read_shift(2);
    var body;
    var o = {
        fBuiltIn: flags & 0x01,
        fWantAdvise: flags >>> 1 & 0x01,
        fWantPict: flags >>> 2 & 0x01,
        fOle: flags >>> 3 & 0x01,
        fOleLink: flags >>> 4 & 0x01,
        cf: flags >>> 5 & 0x3FF,
        fIcon: flags >>> 15 & 0x01
    } /*:any*/ ;
    if (opts.sbcch === 0x3A01) body = $7c3b72a365cc0275$var$parse_AddinUdf(blob, length - 2, opts);
    //else throw new Error("unsupported SupBook cch: " + opts.sbcch);
    o.body = body || blob.read_shift(length - 2);
    if (typeof body === "string") o.Name = body;
    return o;
}
/* [MS-XLS] 2.4.150 TODO */ var $7c3b72a365cc0275$var$XLSLblBuiltIn = [
    "_xlnm.Consolidate_Area",
    "_xlnm.Auto_Open",
    "_xlnm.Auto_Close",
    "_xlnm.Extract",
    "_xlnm.Database",
    "_xlnm.Criteria",
    "_xlnm.Print_Area",
    "_xlnm.Print_Titles",
    "_xlnm.Recorder",
    "_xlnm.Data_Form",
    "_xlnm.Auto_Activate",
    "_xlnm.Auto_Deactivate",
    "_xlnm.Sheet_Title",
    "_xlnm._FilterDatabase"
];
function $7c3b72a365cc0275$var$parse_Lbl(blob, length, opts) {
    var target = blob.l + length;
    var flags = blob.read_shift(2);
    var chKey = blob.read_shift(1);
    var cch = blob.read_shift(1);
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var itab = 0;
    if (!opts || opts.biff >= 5) {
        if (opts.biff != 5) blob.l += 2;
        itab = blob.read_shift(2);
        if (opts.biff == 5) blob.l += 2;
        blob.l += 4;
    }
    var name = $7c3b72a365cc0275$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    if (flags & 0x20) name = $7c3b72a365cc0275$var$XLSLblBuiltIn[name.charCodeAt(0)];
    var npflen = target - blob.l;
    if (opts && opts.biff == 2) --npflen;
    /*jshint -W018 */ var rgce = target == blob.l || cce === 0 || !(npflen > 0) ? [] : $7c3b72a365cc0275$var$parse_NameParsedFormula(blob, npflen, opts, cce);
    /*jshint +W018 */ return {
        chKey: chKey,
        Name: name,
        itab: itab,
        rgce: rgce
    };
}
/* [MS-XLS] 2.4.106 TODO: verify filename encoding */ function $7c3b72a365cc0275$var$parse_ExternSheet(blob, length, opts) {
    if (opts.biff < 8) return $7c3b72a365cc0275$var$parse_BIFF5ExternSheet(blob, length, opts);
    var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
    while(len-- !== 0)o.push($7c3b72a365cc0275$var$parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
    // [iSupBook, itabFirst, itabLast];
    if (blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
    return o;
}
function $7c3b72a365cc0275$var$parse_BIFF5ExternSheet(blob, length, opts) {
    if (blob[blob.l + 1] == 0x03) blob[blob.l]++;
    var o = $7c3b72a365cc0275$var$parse_ShortXLUnicodeString(blob, length, opts);
    return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}
/* [MS-XLS] 2.4.176 TODO: check older biff */ function $7c3b72a365cc0275$var$parse_NameCmt(blob, length, opts) {
    if (opts.biff < 8) {
        blob.l += length;
        return;
    }
    var cchName = blob.read_shift(2);
    var cchComment = blob.read_shift(2);
    var name = $7c3b72a365cc0275$var$parse_XLUnicodeStringNoCch(blob, cchName, opts);
    var comment = $7c3b72a365cc0275$var$parse_XLUnicodeStringNoCch(blob, cchComment, opts);
    return [
        name,
        comment
    ];
}
/* [MS-XLS] 2.4.260 */ function $7c3b72a365cc0275$var$parse_ShrFmla(blob, length, opts) {
    var ref = $7c3b72a365cc0275$var$parse_RefU(blob, 6);
    blob.l++;
    var cUse = blob.read_shift(1);
    length -= 8;
    return [
        $7c3b72a365cc0275$var$parse_SharedParsedFormula(blob, length, opts),
        cUse,
        ref
    ];
}
/* [MS-XLS] 2.4.4 TODO */ function $7c3b72a365cc0275$var$parse_Array(blob, length, opts) {
    var ref = $7c3b72a365cc0275$var$parse_Ref(blob, 6);
    /* TODO: fAlwaysCalc */ switch(opts.biff){
        case 2:
            blob.l++;
            length -= 7;
            break;
        case 3:
        case 4:
            blob.l += 2;
            length -= 8;
            break;
        default:
            blob.l += 6;
            length -= 12;
    }
    return [
        ref,
        $7c3b72a365cc0275$var$parse_ArrayParsedFormula(blob, length, opts, ref)
    ];
}
/* [MS-XLS] 2.4.173 */ function $7c3b72a365cc0275$var$parse_MTRSettings(blob) {
    var fMTREnabled = blob.read_shift(4) !== 0x00;
    var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
    var cUserThreadCount = blob.read_shift(4);
    return [
        fMTREnabled,
        fUserSetThreadCount,
        cUserThreadCount
    ];
}
/* [MS-XLS] 2.5.186 TODO: BIFF5 */ function $7c3b72a365cc0275$var$parse_NoteSh(blob, length, opts) {
    if (opts.biff < 8) return;
    var row = blob.read_shift(2), col = blob.read_shift(2);
    var flags = blob.read_shift(2), idObj = blob.read_shift(2);
    var stAuthor = $7c3b72a365cc0275$var$parse_XLUnicodeString2(blob, 0, opts);
    if (opts.biff < 8) blob.read_shift(1);
    return [
        {
            r: row,
            c: col
        },
        stAuthor,
        idObj,
        flags
    ];
}
/* [MS-XLS] 2.4.179 */ function $7c3b72a365cc0275$var$parse_Note(blob, length, opts) {
    /* TODO: Support revisions */ return $7c3b72a365cc0275$var$parse_NoteSh(blob, length, opts);
}
/* [MS-XLS] 2.4.168 */ function $7c3b72a365cc0275$var$parse_MergeCells(blob, length) /*:Array<Range>*/ {
    var merges /*:Array<Range>*/  = [];
    var cmcs = blob.read_shift(2);
    while(cmcs--)merges.push($7c3b72a365cc0275$var$parse_Ref8U(blob, length));
    return merges;
}
function $7c3b72a365cc0275$var$write_MergeCells(merges /*:Array<Range>*/ ) {
    var o = $7c3b72a365cc0275$var$new_buf(2 + merges.length * 8);
    o.write_shift(2, merges.length);
    for(var i = 0; i < merges.length; ++i)$7c3b72a365cc0275$var$write_Ref8U(merges[i], o);
    return o;
}
/* [MS-XLS] 2.4.181 TODO: parse all the things! */ function $7c3b72a365cc0275$var$parse_Obj(blob, length, opts) {
    if (opts && opts.biff < 8) return $7c3b72a365cc0275$var$parse_BIFF5Obj(blob, length, opts);
    var cmo = $7c3b72a365cc0275$var$parse_FtCmo(blob, 22); // id, ot, flags
    var fts = $7c3b72a365cc0275$var$parse_FtArray(blob, length - 22, cmo[1]);
    return {
        cmo: cmo,
        ft: fts
    };
}
/* from older spec */ var $7c3b72a365cc0275$var$parse_BIFF5OT = {
    0x08: function(blob, length) {
        var tgt = blob.l + length;
        blob.l += 10; // todo
        var cf = blob.read_shift(2);
        blob.l += 4;
        blob.l += 2; //var cbPictFmla = blob.read_shift(2);
        blob.l += 2;
        blob.l += 2; //var grbit = blob.read_shift(2);
        blob.l += 4;
        var cchName = blob.read_shift(1);
        blob.l += cchName; // TODO: stName
        blob.l = tgt; // TODO: fmla
        return {
            fmt: cf
        };
    }
};
function $7c3b72a365cc0275$var$parse_BIFF5Obj(blob, length, opts) {
    blob.l += 4; //var cnt = blob.read_shift(4);
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var grbit = blob.read_shift(2);
    blob.l += 2; //var colL = blob.read_shift(2);
    blob.l += 2; //var dxL = blob.read_shift(2);
    blob.l += 2; //var rwT = blob.read_shift(2);
    blob.l += 2; //var dyT = blob.read_shift(2);
    blob.l += 2; //var colR = blob.read_shift(2);
    blob.l += 2; //var dxR = blob.read_shift(2);
    blob.l += 2; //var rwB = blob.read_shift(2);
    blob.l += 2; //var dyB = blob.read_shift(2);
    blob.l += 2; //var cbMacro = blob.read_shift(2);
    blob.l += 6;
    length -= 36;
    var fts = [];
    fts.push(($7c3b72a365cc0275$var$parse_BIFF5OT[ot] || $7c3b72a365cc0275$var$parsenoop)(blob, length, opts));
    return {
        cmo: [
            id,
            ot,
            grbit
        ],
        ft: fts
    };
}
/* [MS-XLS] 2.4.329 TODO: parse properly */ function $7c3b72a365cc0275$var$parse_TxO(blob, length, opts) {
    var s = blob.l;
    var texts = "";
    try {
        blob.l += 4;
        var ot = (opts.lastobj || {
            cmo: [
                0,
                0
            ]
        }).cmo[1];
        var controlInfo; // eslint-disable-line no-unused-vars
        if ([
            0,
            5,
            7,
            11,
            12,
            14
        ].indexOf(ot) == -1) blob.l += 6;
        else controlInfo = $7c3b72a365cc0275$var$parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
        var cchText = blob.read_shift(2);
        /*var cbRuns = */ blob.read_shift(2);
        /*var ifntEmpty = */ $7c3b72a365cc0275$var$parseuint16(blob, 2);
        var len = blob.read_shift(2);
        blob.l += len;
        //var fmla = parse_ObjFmla(blob, s + length - blob.l);
        for(var i = 1; i < blob.lens.length - 1; ++i){
            if (blob.l - s != blob.lens[i]) throw new Error("TxO: bad continue record");
            var hdr = blob[blob.l];
            var t = $7c3b72a365cc0275$var$parse_XLUnicodeStringNoCch(blob, blob.lens[i + 1] - blob.lens[i] - 1);
            texts += t;
            if (texts.length >= (hdr ? cchText : 2 * cchText)) break;
        }
        if (texts.length !== cchText && texts.length !== cchText * 2) throw new Error("cchText: " + cchText + " != " + texts.length);
        blob.l = s + length;
        /* [MS-XLS] 2.5.272 TxORuns */ //	var rgTxoRuns = [];
        //	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
        //	var cchText2 = blob.read_shift(2);
        //	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
        //	blob.l += 6;
        //	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
        return {
            t: texts
        };
    } catch (e) {
        blob.l = s + length;
        return {
            t: texts
        };
    }
}
/* [MS-XLS] 2.4.140 */ function $7c3b72a365cc0275$var$parse_HLink(blob, length) {
    var ref = $7c3b72a365cc0275$var$parse_Ref8U(blob, 8);
    blob.l += 16; /* CLSID */ 
    var hlink = $7c3b72a365cc0275$var$parse_Hyperlink(blob, length - 24);
    return [
        ref,
        hlink
    ];
}
function $7c3b72a365cc0275$var$write_HLink(hl) {
    var O = $7c3b72a365cc0275$var$new_buf(24);
    var ref = $7c3b72a365cc0275$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
    for(var i = 0; i < 16; ++i)O.write_shift(1, parseInt(clsid[i], 16));
    return $7c3b72a365cc0275$var$bconcat([
        O,
        $7c3b72a365cc0275$var$write_Hyperlink(hl[1])
    ]);
}
/* [MS-XLS] 2.4.141 */ function $7c3b72a365cc0275$var$parse_HLinkTooltip(blob, length) {
    blob.read_shift(2);
    var ref = $7c3b72a365cc0275$var$parse_Ref8U(blob, 8);
    var wzTooltip = blob.read_shift((length - 10) / 2, 'dbcs-cont');
    wzTooltip = wzTooltip.replace($7c3b72a365cc0275$var$chr0, "");
    return [
        ref,
        wzTooltip
    ];
}
function $7c3b72a365cc0275$var$write_HLinkTooltip(hl) {
    var TT = hl[1].Tooltip;
    var O = $7c3b72a365cc0275$var$new_buf(10 + 2 * (TT.length + 1));
    O.write_shift(2, 0x0800);
    var ref = $7c3b72a365cc0275$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    for(var i = 0; i < TT.length; ++i)O.write_shift(2, TT.charCodeAt(i));
    O.write_shift(2, 0);
    return O;
}
/* [MS-XLS] 2.4.63 */ function $7c3b72a365cc0275$var$parse_Country(blob) /*:[string|number, string|number]*/ {
    var o = [
        0,
        0
    ], d;
    d = blob.read_shift(2);
    o[0] = $7c3b72a365cc0275$var$CountryEnum[d] || d;
    d = blob.read_shift(2);
    o[1] = $7c3b72a365cc0275$var$CountryEnum[d] || d;
    return o;
}
function $7c3b72a365cc0275$var$write_Country(o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(4);
    o.write_shift(2, 0x01);
    o.write_shift(2, 0x01);
    return o;
}
/* [MS-XLS] 2.4.50 ClrtClient */ function $7c3b72a365cc0275$var$parse_ClrtClient(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($7c3b72a365cc0275$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.188 */ function $7c3b72a365cc0275$var$parse_Palette(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($7c3b72a365cc0275$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.354 */ function $7c3b72a365cc0275$var$parse_XFCRC(blob) {
    blob.l += 2;
    var o = {
        cxfs: 0,
        crc: 0
    };
    o.cxfs = blob.read_shift(2);
    o.crc = blob.read_shift(4);
    return o;
}
/* [MS-XLS] 2.4.53 TODO: parse flags */ /* [MS-XLSB] 2.4.323 TODO: parse flags */ function $7c3b72a365cc0275$var$parse_ColInfo(blob, length, opts) {
    if (!opts.cellStyles) return $7c3b72a365cc0275$var$parsenoop(blob, length);
    var w = opts && opts.biff >= 12 ? 4 : 2;
    var colFirst = blob.read_shift(w);
    var colLast = blob.read_shift(w);
    var coldx = blob.read_shift(w);
    var ixfe = blob.read_shift(w);
    var flags = blob.read_shift(2);
    if (w == 2) blob.l += 2;
    var o = {
        s: colFirst,
        e: colLast,
        w: coldx,
        ixfe: ixfe,
        flags: flags
    } /*:any*/ ;
    if (opts.biff >= 5 || !opts.biff) o.level = flags >> 8 & 0x7;
    return o;
}
function $7c3b72a365cc0275$var$write_ColInfo(col, idx) {
    var o = $7c3b72a365cc0275$var$new_buf(12);
    o.write_shift(2, idx);
    o.write_shift(2, idx);
    o.write_shift(2, col.width * 256);
    o.write_shift(2, 0);
    var f = 0;
    if (col.hidden) f |= 1;
    o.write_shift(1, f);
    f = col.level || 0;
    o.write_shift(1, f);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.257 */ function $7c3b72a365cc0275$var$parse_Setup(blob, length) {
    var o = {};
    if (length < 32) return o;
    blob.l += 16;
    o.header = $7c3b72a365cc0275$var$parse_Xnum(blob, 8);
    o.footer = $7c3b72a365cc0275$var$parse_Xnum(blob, 8);
    blob.l += 2;
    return o;
}
/* [MS-XLS] 2.4.261 */ function $7c3b72a365cc0275$var$parse_ShtProps(blob, length, opts) {
    var def = {
        area: false
    };
    if (opts.biff != 5) {
        blob.l += length;
        return def;
    }
    var d = blob.read_shift(1);
    blob.l += 3;
    if (d & 0x10) def.area = true;
    return def;
}
/* [MS-XLS] 2.4.241 */ function $7c3b72a365cc0275$var$write_RRTabId(n /*:number*/ ) {
    var out = $7c3b72a365cc0275$var$new_buf(2 * n);
    for(var i = 0; i < n; ++i)out.write_shift(2, i + 1);
    return out;
}
var $7c3b72a365cc0275$var$parse_Blank = $7c3b72a365cc0275$var$parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */ 
var $7c3b72a365cc0275$var$parse_Scl = $7c3b72a365cc0275$var$parseuint16a; /* [MS-XLS] 2.4.247 num, den */ 
var $7c3b72a365cc0275$var$parse_String = $7c3b72a365cc0275$var$parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */ 
/* --- Specific to versions before BIFF8 --- */ function $7c3b72a365cc0275$var$parse_ImData(blob) {
    var cf = blob.read_shift(2);
    var env = blob.read_shift(2);
    var lcb = blob.read_shift(4);
    var o = {
        fmt: cf,
        env: env,
        len: lcb,
        data: blob.slice(blob.l, blob.l + lcb)
    };
    blob.l += lcb;
    return o;
}
/* BIFF2_??? where ??? is the name from [XLS] */ function $7c3b72a365cc0275$var$parse_BIFF2STR(blob, length, opts) {
    if (opts.biffguess && opts.biff == 5) opts.biff = 2;
    var cell = $7c3b72a365cc0275$var$parse_XLSCell(blob, 6);
    ++blob.l;
    var str = $7c3b72a365cc0275$var$parse_XLUnicodeString2(blob, length - 7, opts);
    cell.t = 'str';
    cell.val = str;
    return cell;
}
function $7c3b72a365cc0275$var$parse_BIFF2NUM(blob /*::, length*/ ) {
    var cell = $7c3b72a365cc0275$var$parse_XLSCell(blob, 6);
    ++blob.l;
    var num = $7c3b72a365cc0275$var$parse_Xnum(blob, 8);
    cell.t = 'n';
    cell.val = num;
    return cell;
}
function $7c3b72a365cc0275$var$write_BIFF2NUM(r /*:number*/ , c /*:number*/ , val /*:number*/ ) {
    var out = $7c3b72a365cc0275$var$new_buf(15);
    $7c3b72a365cc0275$var$write_BIFF2Cell(out, r, c);
    out.write_shift(8, val, 'f');
    return out;
}
function $7c3b72a365cc0275$var$parse_BIFF2INT(blob) {
    var cell = $7c3b72a365cc0275$var$parse_XLSCell(blob, 6);
    ++blob.l;
    var num = blob.read_shift(2);
    cell.t = 'n';
    cell.val = num;
    return cell;
}
function $7c3b72a365cc0275$var$write_BIFF2INT(r /*:number*/ , c /*:number*/ , val /*:number*/ ) {
    var out = $7c3b72a365cc0275$var$new_buf(9);
    $7c3b72a365cc0275$var$write_BIFF2Cell(out, r, c);
    out.write_shift(2, val);
    return out;
}
function $7c3b72a365cc0275$var$parse_BIFF2STRING(blob) {
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, 'sbcs-cont');
}
/* TODO: convert to BIFF8 font struct */ function $7c3b72a365cc0275$var$parse_BIFF2FONTXTRA(blob, length) {
    blob.l += 6; // unknown
    blob.l += 2; // font weight "bls"
    blob.l += 1; // charset
    blob.l += 3; // unknown
    blob.l += 1; // font family
    blob.l += length - 13;
}
/* TODO: parse rich text runs */ function $7c3b72a365cc0275$var$parse_RString(blob, length, opts) {
    var end = blob.l + length;
    var cell = $7c3b72a365cc0275$var$parse_XLSCell(blob, 6);
    var cch = blob.read_shift(2);
    var str = $7c3b72a365cc0275$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    blob.l = end;
    cell.t = 'str';
    cell.val = str;
    return cell;
}
/* from js-harb (C) 2014-present  SheetJS */ var $7c3b72a365cc0275$var$DBF_SUPPORTED_VERSIONS = [
    0x02,
    0x03,
    0x30,
    0x31,
    0x83,
    0x8B,
    0x8C,
    0xF5
];
var $7c3b72a365cc0275$var$DBF = /*#__PURE__*/ function() {
    var dbf_codepage_map = {
        /* Code Pages Supported by Visual FoxPro */ /*::[*/ 0x01: 437,
        /*::[*/ 0x02: 850,
        /*::[*/ 0x03: 1252,
        /*::[*/ 0x04: 10000,
        /*::[*/ 0x64: 852,
        /*::[*/ 0x65: 866,
        /*::[*/ 0x66: 865,
        /*::[*/ 0x67: 861,
        /*::[*/ 0x68: 895,
        /*::[*/ 0x69: 620,
        /*::[*/ 0x6A: 737,
        /*::[*/ 0x6B: 857,
        /*::[*/ 0x78: 950,
        /*::[*/ 0x79: 949,
        /*::[*/ 0x7A: 936,
        /*::[*/ 0x7B: 932,
        /*::[*/ 0x7C: 874,
        /*::[*/ 0x7D: 1255,
        /*::[*/ 0x7E: 1256,
        /*::[*/ 0x96: 10007,
        /*::[*/ 0x97: 10029,
        /*::[*/ 0x98: 10006,
        /*::[*/ 0xC8: 1250,
        /*::[*/ 0xC9: 1251,
        /*::[*/ 0xCA: 1254,
        /*::[*/ 0xCB: 1253,
        /* shapefile DBF extension */ /*::[*/ 0x00: 20127,
        /*::[*/ 0x08: 865,
        /*::[*/ 0x09: 437,
        /*::[*/ 0x0A: 850,
        /*::[*/ 0x0B: 437,
        /*::[*/ 0x0D: 437,
        /*::[*/ 0x0E: 850,
        /*::[*/ 0x0F: 437,
        /*::[*/ 0x10: 850,
        /*::[*/ 0x11: 437,
        /*::[*/ 0x12: 850,
        /*::[*/ 0x13: 932,
        /*::[*/ 0x14: 850,
        /*::[*/ 0x15: 437,
        /*::[*/ 0x16: 850,
        /*::[*/ 0x17: 865,
        /*::[*/ 0x18: 437,
        /*::[*/ 0x19: 437,
        /*::[*/ 0x1A: 850,
        /*::[*/ 0x1B: 437,
        /*::[*/ 0x1C: 863,
        /*::[*/ 0x1D: 850,
        /*::[*/ 0x1F: 852,
        /*::[*/ 0x22: 852,
        /*::[*/ 0x23: 852,
        /*::[*/ 0x24: 860,
        /*::[*/ 0x25: 850,
        /*::[*/ 0x26: 866,
        /*::[*/ 0x37: 850,
        /*::[*/ 0x40: 852,
        /*::[*/ 0x4D: 936,
        /*::[*/ 0x4E: 949,
        /*::[*/ 0x4F: 950,
        /*::[*/ 0x50: 874,
        /*::[*/ 0x57: 1252,
        /*::[*/ 0x58: 1252,
        /*::[*/ 0x59: 1252,
        /*::[*/ 0x6C: 863,
        /*::[*/ 0x86: 737,
        /*::[*/ 0x87: 852,
        /*::[*/ 0x88: 857,
        /*::[*/ 0xCC: 1257,
        /*::[*/ 0xFF: 16969
    };
    var dbf_reverse_map = $7c3b72a365cc0275$var$evert({
        /*::[*/ 0x01: 437,
        /*::[*/ 0x02: 850,
        /*::[*/ 0x03: 1252,
        /*::[*/ 0x04: 10000,
        /*::[*/ 0x64: 852,
        /*::[*/ 0x65: 866,
        /*::[*/ 0x66: 865,
        /*::[*/ 0x67: 861,
        /*::[*/ 0x68: 895,
        /*::[*/ 0x69: 620,
        /*::[*/ 0x6A: 737,
        /*::[*/ 0x6B: 857,
        /*::[*/ 0x78: 950,
        /*::[*/ 0x79: 949,
        /*::[*/ 0x7A: 936,
        /*::[*/ 0x7B: 932,
        /*::[*/ 0x7C: 874,
        /*::[*/ 0x7D: 1255,
        /*::[*/ 0x7E: 1256,
        /*::[*/ 0x96: 10007,
        /*::[*/ 0x97: 10029,
        /*::[*/ 0x98: 10006,
        /*::[*/ 0xC8: 1250,
        /*::[*/ 0xC9: 1251,
        /*::[*/ 0xCA: 1254,
        /*::[*/ 0xCB: 1253,
        /*::[*/ 0x00: 20127
    });
    /* TODO: find an actual specification */ function dbf_to_aoa(buf, opts) /*:AOA*/ {
        var out /*:AOA*/  = [];
        var d /*:Block*/  = $7c3b72a365cc0275$var$new_raw_buf(1);
        switch(opts.type){
            case 'base64':
                d = $7c3b72a365cc0275$var$s2a($7c3b72a365cc0275$var$Base64_decode(buf));
                break;
            case 'binary':
                d = $7c3b72a365cc0275$var$s2a(buf);
                break;
            case 'buffer':
            case 'array':
                d = buf;
                break;
        }
        $7c3b72a365cc0275$var$prep_blob(d, 0);
        /* header */ var ft = d.read_shift(1);
        var memo = !!(ft & 0x88);
        var vfp = false, l7 = false;
        switch(ft){
            case 0x02:
                break; // dBASE II
            case 0x03:
                break; // dBASE III
            case 0x30:
                vfp = true;
                memo = true;
                break; // VFP
            case 0x31:
                vfp = true;
                memo = true;
                break; // VFP with autoincrement
            // 0x43 dBASE IV SQL table files
            // 0x63 dBASE IV SQL system files
            case 0x83:
                break; // dBASE III with memo
            case 0x8B:
                break; // dBASE IV with memo
            case 0x8C:
                l7 = true;
                break; // dBASE Level 7 with memo
            // case 0xCB dBASE IV SQL table files with memo
            case 0xF5:
                break; // FoxPro 2.x with memo
            // case 0xFB FoxBASE
            default:
                throw new Error("DBF Unsupported Version: " + ft.toString(16));
        }
        var nrow = 0, fpos = 0x0209;
        if (ft == 0x02) nrow = d.read_shift(2);
        d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
        if (ft != 0x02) nrow = d.read_shift(4);
        if (nrow > 1048576) nrow = 1e6;
        if (ft != 0x02) fpos = d.read_shift(2); // header length
        var rlen = d.read_shift(2); // record length
        var /*flags = 0,*/ current_cp = opts.codepage || 1252;
        if (ft != 0x02) {
            d.l += 16;
            /*flags = */ d.read_shift(1);
            //if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
            /* codepage present in FoxPro and dBASE Level 7 */ if (d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
            d.l += 1;
            d.l += 2;
        }
        if (l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
        /*:: type DBFField = { name:string; len:number; type:string; } */ var fields /*:Array<DBFField>*/  = [], field /*:DBFField*/  = {} /*:any*/ ;
        var hend = Math.min(d.length, ft == 0x02 ? 0x209 : fpos - 10 - (vfp ? 264 : 0));
        var ww = l7 ? 32 : 11;
        while(d.l < hend && d[d.l] != 0x0d){
            field = {} /*:any*/ ;
            field.name = $7c3b72a365cc0275$var$$cptable.utils.decode(current_cp, d.slice(d.l, d.l + ww)).replace(/[\u0000\r\n].*$/g, "");
            d.l += ww;
            field.type = String.fromCharCode(d.read_shift(1));
            if (ft != 0x02 && !l7) field.offset = d.read_shift(4);
            field.len = d.read_shift(1);
            if (ft == 0x02) field.offset = d.read_shift(2);
            field.dec = d.read_shift(1);
            if (field.name.length) fields.push(field);
            if (ft != 0x02) d.l += l7 ? 13 : 14;
            switch(field.type){
                case 'B':
                    if ((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                    break;
                case 'G':
                case 'P':
                    if (opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                    break;
                case '+':
                case '0':
                case '@':
                case 'C':
                case 'D':
                case 'F':
                case 'I':
                case 'L':
                case 'M':
                case 'N':
                case 'O':
                case 'T':
                case 'Y':
                    break;
                default:
                    throw new Error('Unknown Field Type: ' + field.type);
            }
        }
        if (d[d.l] !== 0x0D) d.l = fpos - 1;
        if (d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
        d.l = fpos;
        /* data */ var R = 0, C = 0;
        out[0] = [];
        for(C = 0; C != fields.length; ++C)out[0][C] = fields[C].name;
        while(nrow-- > 0){
            if (d[d.l] === 0x2A) {
                // TODO: record marked as deleted -- create a hidden row?
                d.l += rlen;
                continue;
            }
            ++d.l;
            out[++R] = [];
            C = 0;
            for(C = 0; C != fields.length; ++C){
                var dd = d.slice(d.l, d.l + fields[C].len);
                d.l += fields[C].len;
                $7c3b72a365cc0275$var$prep_blob(dd, 0);
                var s = $7c3b72a365cc0275$var$$cptable.utils.decode(current_cp, dd);
                switch(fields[C].type){
                    case 'C':
                        // NOTE: it is conventional to write '  /  /  ' for empty dates
                        if (s.trim().length) out[R][C] = s.replace(/\s+$/, "");
                        break;
                    case 'D':
                        if (s.length === 8) out[R][C] = new Date(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8));
                        else out[R][C] = s;
                        break;
                    case 'F':
                        out[R][C] = parseFloat(s.trim());
                        break;
                    case '+':
                    case 'I':
                        out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i');
                        break;
                    case 'L':
                        switch(s.trim().toUpperCase()){
                            case 'Y':
                            case 'T':
                                out[R][C] = true;
                                break;
                            case 'N':
                            case 'F':
                                out[R][C] = false;
                                break;
                            case '':
                            case '?':
                                break;
                            default:
                                throw new Error("DBF Unrecognized L:|" + s + "|");
                        }
                        break;
                    case 'M':
                        /* TODO: handle memo files */ if (!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
                        out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10) : dd.read_shift(4));
                        break;
                    case 'N':
                        s = s.replace(/\u0000/g, "").trim();
                        // NOTE: dBASE II interprets "  .  " as 0
                        if (s && s != ".") out[R][C] = +s || 0;
                        break;
                    case '@':
                        // NOTE: dBASE specs appear to be incorrect
                        out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
                        break;
                    case 'T':
                        out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4));
                        break;
                    case 'Y':
                        out[R][C] = dd.read_shift(4, 'i') / 1e4 + dd.read_shift(4, 'i') / 1e4 * Math.pow(2, 32);
                        break;
                    case 'O':
                        out[R][C] = -dd.read_shift(-8, 'f');
                        break;
                    case 'B':
                        if (vfp && fields[C].len == 8) {
                            out[R][C] = dd.read_shift(8, 'f');
                            break;
                        }
                    /* falls through */ case 'G':
                    case 'P':
                        dd.l += fields[C].len;
                        break;
                    case '0':
                        if (fields[C].name === '_NullFlags') break;
                    /* falls through */ default:
                        throw new Error("DBF Unsupported data type " + fields[C].type);
                }
            }
        }
        if (ft != 0x02) {
            if (d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l - 1) + " of " + d.length + " " + d[d.l - 1].toString(16));
        }
        if (opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
        opts.DBF = fields;
        return out;
    }
    function dbf_to_sheet(buf, opts) /*:Worksheet*/ {
        var o = opts || {};
        if (!o.dateNF) o.dateNF = "yyyymmdd";
        var ws = $7c3b72a365cc0275$var$aoa_to_sheet(dbf_to_aoa(buf, o), o);
        ws["!cols"] = o.DBF.map(function(field) {
            return {
                wch: field.len,
                DBF: field
            };
        });
        delete o.DBF;
        return ws;
    }
    function dbf_to_workbook(buf, opts) /*:Workbook*/ {
        try {
            return $7c3b72a365cc0275$var$sheet_to_workbook(dbf_to_sheet(buf, opts), opts);
        } catch (e) {
            if (opts && opts.WTF) throw e;
        }
        return {
            SheetNames: [],
            Sheets: {}
        };
    }
    var _RLEN = {
        'B': 8,
        'C': 250,
        'L': 1,
        'D': 8,
        '?': 0,
        '': 0
    };
    function sheet_to_dbf(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $7c3b72a365cc0275$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write DBF to JS string");
        var ba = $7c3b72a365cc0275$var$buf_array();
        var aoa /*:AOA*/  = $7c3b72a365cc0275$var$sheet_to_json(ws, {
            header: 1,
            raw: true,
            cellDates: true
        });
        var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
        var i = 0, j = 0, hcnt = 0, rlen = 1;
        for(i = 0; i < headers.length; ++i){
            if (((cols[i] || {}).DBF || {}).name) {
                headers[i] = cols[i].DBF.name;
                ++hcnt;
                continue;
            }
            if (headers[i] == null) continue;
            ++hcnt;
            if (typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
            if (typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + typeof headers[i] + "|");
            if (headers.indexOf(headers[i]) !== i) {
                for(j = 0; j < 1024; ++j)if (headers.indexOf(headers[i] + "_" + j) == -1) {
                    headers[i] += "_" + j;
                    break;
                }
            }
        }
        var range = $7c3b72a365cc0275$var$safe_decode_range(ws['!ref']);
        var coltypes /*:Array<string>*/  = [];
        var colwidths /*:Array<number>*/  = [];
        var coldecimals /*:Array<number>*/  = [];
        for(i = 0; i <= range.e.c - range.s.c; ++i){
            var guess = '', _guess = '', maxlen = 0;
            var col /*:Array<any>*/  = [];
            for(j = 0; j < data.length; ++j)if (data[j][i] != null) col.push(data[j][i]);
            if (col.length == 0 || headers[i] == null) {
                coltypes[i] = '?';
                continue;
            }
            for(j = 0; j < col.length; ++j){
                switch(typeof col[j]){
                    /* TODO: check if L2 compat is desired */ case 'number':
                        _guess = 'B';
                        break;
                    case 'string':
                        _guess = 'C';
                        break;
                    case 'boolean':
                        _guess = 'L';
                        break;
                    case 'object':
                        _guess = col[j] instanceof Date ? 'D' : 'C';
                        break;
                    default:
                        _guess = 'C';
                }
                maxlen = Math.max(maxlen, String(col[j]).length);
                guess = guess && guess != _guess ? 'C' : _guess;
            //if(guess == 'C') break;
            }
            if (maxlen > 250) maxlen = 250;
            _guess = ((cols[i] || {}).DBF || {}).type;
            /* TODO: more fine grained control over DBF type resolution */ if (_guess == 'C') {
                if (cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
            }
            if (guess == 'B' && _guess == 'N') {
                guess = 'N';
                coldecimals[i] = cols[i].DBF.dec;
                maxlen = cols[i].DBF.len;
            }
            colwidths[i] = guess == 'C' || _guess == 'N' ? maxlen : _RLEN[guess] || 0;
            rlen += colwidths[i];
            coltypes[i] = guess;
        }
        var h = ba.next(32);
        h.write_shift(4, 0x13021130);
        h.write_shift(4, data.length);
        h.write_shift(2, 296 + 32 * hcnt);
        h.write_shift(2, rlen);
        for(i = 0; i < 4; ++i)h.write_shift(4, 0);
        h.write_shift(4, 0x00000000 | (+dbf_reverse_map[/*::String(*/ $7c3b72a365cc0275$var$current_ansi /*::)*/ ] || 0x03) << 8);
        for(i = 0, j = 0; i < headers.length; ++i){
            if (headers[i] == null) continue;
            var hf = ba.next(32);
            var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
            hf.write_shift(1, _f, "sbcs");
            hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
            hf.write_shift(4, j);
            hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
            hf.write_shift(1, coldecimals[i] || 0);
            hf.write_shift(1, 0x02);
            hf.write_shift(4, 0);
            hf.write_shift(1, 0);
            hf.write_shift(4, 0);
            hf.write_shift(4, 0);
            j += colwidths[i] || _RLEN[coltypes[i]] || 0;
        }
        var hb = ba.next(264);
        hb.write_shift(4, 0x0000000D);
        for(i = 0; i < 65; ++i)hb.write_shift(4, 0x00000000);
        for(i = 0; i < data.length; ++i){
            var rout = ba.next(rlen);
            rout.write_shift(1, 0);
            for(j = 0; j < headers.length; ++j){
                if (headers[j] == null) continue;
                switch(coltypes[j]){
                    case 'L':
                        rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46);
                        break;
                    case 'B':
                        rout.write_shift(8, data[i][j] || 0, 'f');
                        break;
                    case 'N':
                        var _n = "0";
                        if (typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j] || 0);
                        for(hcnt = 0; hcnt < colwidths[j] - _n.length; ++hcnt)rout.write_shift(1, 0x20);
                        rout.write_shift(1, _n, "sbcs");
                        break;
                    case 'D':
                        if (!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
                        else {
                            rout.write_shift(4, ("0000" + data[i][j].getFullYear()).slice(-4), "sbcs");
                            rout.write_shift(2, ("00" + (data[i][j].getMonth() + 1)).slice(-2), "sbcs");
                            rout.write_shift(2, ("00" + data[i][j].getDate()).slice(-2), "sbcs");
                        }
                        break;
                    case 'C':
                        var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
                        rout.write_shift(1, _s, "sbcs");
                        for(hcnt = 0; hcnt < colwidths[j] - _s.length; ++hcnt)rout.write_shift(1, 0x20);
                        break;
                }
            }
        // data
        }
        ba.next(1).write_shift(1, 0x1A);
        return ba.end();
    }
    return {
        to_workbook: dbf_to_workbook,
        to_sheet: dbf_to_sheet,
        from_sheet: sheet_to_dbf
    };
}();
var $7c3b72a365cc0275$var$SYLK = /*#__PURE__*/ function() {
    /* TODO: stress test sequences */ var sylk_escapes = {
        AA: "\xc0",
        BA: "\xc1",
        CA: "\xc2",
        DA: 195,
        HA: "\xc4",
        JA: 197,
        AE: "\xc8",
        BE: "\xc9",
        CE: "\xca",
        HE: "\xcb",
        AI: "\xcc",
        BI: "\xcd",
        CI: "\xce",
        HI: "\xcf",
        AO: "\xd2",
        BO: "\xd3",
        CO: "\xd4",
        DO: 213,
        HO: "\xd6",
        AU: "\xd9",
        BU: "\xda",
        CU: "\xdb",
        HU: "\xdc",
        Aa: "\xe0",
        Ba: "\xe1",
        Ca: "\xe2",
        Da: 227,
        Ha: "\xe4",
        Ja: 229,
        Ae: "\xe8",
        Be: "\xe9",
        Ce: "\xea",
        He: "\xeb",
        Ai: "\xec",
        Bi: "\xed",
        Ci: "\xee",
        Hi: "\xef",
        Ao: "\xf2",
        Bo: "\xf3",
        Co: "\xf4",
        Do: 245,
        Ho: "\xf6",
        Au: "\xf9",
        Bu: "\xfa",
        Cu: "\xfb",
        Hu: "\xfc",
        KC: "\xc7",
        Kc: "\xe7",
        q: "\xe6",
        z: "\u0153",
        a: "\xc6",
        j: "\u0152",
        DN: 209,
        Dn: 241,
        Hy: 255,
        S: 169,
        c: 170,
        R: 174,
        "B ": 180,
        /*::[*/ 0: 176,
        /*::[*/ 1: 177,
        /*::[*/ 2: 178,
        /*::[*/ 3: 179,
        /*::[*/ 5: 181,
        /*::[*/ 6: 182,
        /*::[*/ 7: 183,
        Q: 185,
        k: 186,
        b: 208,
        i: 216,
        l: 222,
        s: 240,
        y: 248,
        "!": 161,
        '"': 162,
        "#": 163,
        "(": 164,
        "%": 165,
        "'": 167,
        "H ": 168,
        "+": 171,
        ";": 187,
        "<": 188,
        "=": 189,
        ">": 190,
        "?": 191,
        "{": 223
    } /*:any*/ ;
    var sylk_char_regex = new RegExp("\u001BN(" + $7c3b72a365cc0275$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm");
    var sylk_char_fn = function(_, $1) {
        var o = sylk_escapes[$1];
        return typeof o == "number" ? $7c3b72a365cc0275$var$_getansi(o) : o;
    };
    var decode_sylk_char = function($$, $1, $2) {
        var newcc = $1.charCodeAt(0) - 0x20 << 4 | $2.charCodeAt(0) - 0x30;
        return newcc == 59 ? $$ : $7c3b72a365cc0275$var$_getansi(newcc);
    };
    sylk_escapes["|"] = 254;
    /* TODO: find an actual specification */ function sylk_to_aoa(d /*:RawData*/ , opts) /*:[AOA, Worksheet]*/ {
        switch(opts.type){
            case 'base64':
                return sylk_to_aoa_str($7c3b72a365cc0275$var$Base64_decode(d), opts);
            case 'binary':
                return sylk_to_aoa_str(d, opts);
            case 'buffer':
                return sylk_to_aoa_str($7c3b72a365cc0275$var$has_buf && $7c3b72a365cc0275$require$Buffer.isBuffer(d) ? d.toString('binary') : $7c3b72a365cc0275$var$a2s(d), opts);
            case 'array':
                return sylk_to_aoa_str($7c3b72a365cc0275$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function sylk_to_aoa_str(str /*:string*/ , opts) /*:[AOA, Worksheet]*/ {
        var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr /*:AOA*/  = [];
        var formats /*:Array<string>*/  = [];
        var next_cell_format /*:string|null*/  = null;
        var sht = {}, rowinfo /*:Array<RowInfo>*/  = [], colinfo /*:Array<ColInfo>*/  = [], cw /*:Array<string>*/  = [];
        var Mval = 0, j;
        if (+opts.codepage >= 0) $7c3b72a365cc0275$var$set_cp(+opts.codepage);
        for(; ri !== records.length; ++ri){
            Mval = 0;
            var rstr = records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
            var record = rstr.replace(/;;/g, "\u0000").split(";").map(function(x) {
                return x.replace(/\u0000/g, ";");
            });
            var RT = record[0], val;
            if (rstr.length > 0) switch(RT){
                case 'ID':
                    break; /* header */ 
                case 'E':
                    break; /* EOF */ 
                case 'B':
                    break; /* dimensions */ 
                case 'O':
                    break; /* options? */ 
                case 'W':
                    break; /* window? */ 
                case 'P':
                    if (record[1].charAt(0) == 'P') formats.push(rstr.slice(3).replace(/;;/g, ";"));
                    break;
                case 'C':
                    var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1;
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'A':
                            break; // TODO: comment
                        case 'X':
                            C = parseInt(record[rj].slice(1)) - 1;
                            C_seen_X = true;
                            break;
                        case 'Y':
                            R = parseInt(record[rj].slice(1)) - 1;
                            if (!C_seen_X) C = 0;
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case 'K':
                            val = record[rj].slice(1);
                            if (val.charAt(0) === '"') val = val.slice(1, val.length - 1);
                            else if (val === 'TRUE') val = true;
                            else if (val === 'FALSE') val = false;
                            else if (!isNaN($7c3b72a365cc0275$var$fuzzynum(val))) {
                                val = $7c3b72a365cc0275$var$fuzzynum(val);
                                if (next_cell_format !== null && $7c3b72a365cc0275$var$fmt_is_date(next_cell_format)) val = $7c3b72a365cc0275$var$numdate(val);
                            } else if (!isNaN($7c3b72a365cc0275$var$fuzzydate(val).getDate())) val = $7c3b72a365cc0275$var$parseDate(val);
                            if (typeof $7c3b72a365cc0275$var$$cptable !== 'undefined' && typeof val == "string" && (opts || {}).type != "string" && (opts || {}).codepage) val = $7c3b72a365cc0275$var$$cptable.utils.decode(opts.codepage, val);
                            C_seen_K = true;
                            break;
                        case 'E':
                            C_seen_E = true;
                            var formula = $7c3b72a365cc0275$var$rc_to_a1(record[rj].slice(1), {
                                r: R,
                                c: C
                            });
                            arr[R][C] = [
                                arr[R][C],
                                formula
                            ];
                            break;
                        case 'S':
                            C_seen_S = true;
                            arr[R][C] = [
                                arr[R][C],
                                "S5S"
                            ];
                            break;
                        case 'G':
                            break; // unknown
                        case 'R':
                            _R = parseInt(record[rj].slice(1)) - 1;
                            break;
                        case 'C':
                            _C = parseInt(record[rj].slice(1)) - 1;
                            break;
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (C_seen_K) {
                        if (arr[R][C] && arr[R][C].length == 2) arr[R][C][0] = val;
                        else arr[R][C] = val;
                        next_cell_format = null;
                    }
                    if (C_seen_S) {
                        if (C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
                        var shrbase = _R > -1 && arr[_R][_C];
                        if (!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
                        arr[R][C][1] = $7c3b72a365cc0275$var$shift_formula_str(shrbase[1], {
                            r: R - _R,
                            c: C - _C
                        });
                    }
                    break;
                case 'F':
                    var F_seen = 0;
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'X':
                            C = parseInt(record[rj].slice(1)) - 1;
                            ++F_seen;
                            break;
                        case 'Y':
                            R = parseInt(record[rj].slice(1)) - 1; /*C = 0;*/ 
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case 'M':
                            Mval = parseInt(record[rj].slice(1)) / 20;
                            break;
                        case 'F':
                            break; /* ??? */ 
                        case 'G':
                            break; /* hide grid */ 
                        case 'P':
                            next_cell_format = formats[parseInt(record[rj].slice(1))];
                            break;
                        case 'S':
                            break; /* cell style */ 
                        case 'D':
                            break; /* column */ 
                        case 'N':
                            break; /* font */ 
                        case 'W':
                            cw = record[rj].slice(1).split(" ");
                            for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j){
                                Mval = parseInt(cw[2], 10);
                                colinfo[j - 1] = Mval === 0 ? {
                                    hidden: true
                                } : {
                                    wch: Mval
                                };
                                $7c3b72a365cc0275$var$process_col(colinfo[j - 1]);
                            }
                            break;
                        case 'C':
                            /* default column format */ C = parseInt(record[rj].slice(1)) - 1;
                            if (!colinfo[C]) colinfo[C] = {};
                            break;
                        case 'R':
                            /* row properties */ R = parseInt(record[rj].slice(1)) - 1;
                            if (!rowinfo[R]) rowinfo[R] = {};
                            if (Mval > 0) {
                                rowinfo[R].hpt = Mval;
                                rowinfo[R].hpx = $7c3b72a365cc0275$var$pt2px(Mval);
                            } else if (Mval === 0) rowinfo[R].hidden = true;
                            break;
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (F_seen < 1) next_cell_format = null;
                    break;
                default:
                    if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
            }
        }
        if (rowinfo.length > 0) sht['!rows'] = rowinfo;
        if (colinfo.length > 0) sht['!cols'] = colinfo;
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return [
            arr,
            sht
        ];
    }
    function sylk_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        var aoasht = sylk_to_aoa(d, opts);
        var aoa = aoasht[0], ws = aoasht[1];
        var o = $7c3b72a365cc0275$var$aoa_to_sheet(aoa, opts);
        $7c3b72a365cc0275$var$keys(ws).forEach(function(k) {
            o[k] = ws[k];
        });
        return o;
    }
    function sylk_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $7c3b72a365cc0275$var$sheet_to_workbook(sylk_to_sheet(d, opts), opts);
    }
    function write_ws_cell_sylk(cell /*:Cell*/ , ws /*:Worksheet*/ , R /*:number*/ , C /*:number*/  /*::, opts*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";K";
        switch(cell.t){
            case 'n':
                o += cell.v || 0;
                if (cell.f && !cell.F) o += ";E" + $7c3b72a365cc0275$var$a1_to_rc(cell.f, {
                    r: R,
                    c: C
                });
                break;
            case 'b':
                o += cell.v ? "TRUE" : "FALSE";
                break;
            case 'e':
                o += cell.w || cell.v;
                break;
            case 'd':
                o += '"' + (cell.w || cell.v) + '"';
                break;
            case 's':
                o += '"' + cell.v.replace(/"/g, "").replace(/;/g, ";;") + '"';
                break;
        }
        return o;
    }
    function write_ws_cols_sylk(out, cols) {
        cols.forEach(function(col, i) {
            var rec = "F;W" + (i + 1) + " " + (i + 1) + " ";
            if (col.hidden) rec += "0";
            else {
                if (typeof col.width == 'number' && !col.wpx) col.wpx = $7c3b72a365cc0275$var$width2px(col.width);
                if (typeof col.wpx == 'number' && !col.wch) col.wch = $7c3b72a365cc0275$var$px2char(col.wpx);
                if (typeof col.wch == 'number') rec += Math.round(col.wch);
            }
            if (rec.charAt(rec.length - 1) != " ") out.push(rec);
        });
    }
    function write_ws_rows_sylk(out /*:Array<string>*/ , rows /*:Array<RowInfo>*/ ) {
        rows.forEach(function(row, i) {
            var rec = "F;";
            if (row.hidden) rec += "M0;";
            else if (row.hpt) rec += "M" + 20 * row.hpt + ";";
            else if (row.hpx) rec += "M" + 20 * $7c3b72a365cc0275$var$px2pt(row.hpx) + ";";
            if (rec.length > 2) out.push(rec + "R" + (i + 1));
        });
    }
    function sheet_to_sylk(ws /*:Worksheet*/ , opts /*:?any*/ ) /*:string*/ {
        var preamble /*:Array<string>*/  = [
            "ID;PWXL;N;E"
        ], o /*:Array<string>*/  = [];
        var r = $7c3b72a365cc0275$var$safe_decode_range(ws['!ref']), cell /*:Cell*/ ;
        var dense = Array.isArray(ws);
        var RS = "\r\n";
        preamble.push("P;PGeneral");
        preamble.push("F;P0;DG0G8;M255");
        if (ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
        if (ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);
        preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [
            r.s.c,
            r.s.r,
            r.e.c,
            r.e.r
        ].join(" "));
        for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
            var coord = $7c3b72a365cc0275$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? (ws[R] || [])[C] : ws[coord];
            if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
            o.push(write_ws_cell_sylk(cell, ws, R, C, opts));
        }
        return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
    }
    return {
        to_workbook: sylk_to_workbook,
        to_sheet: sylk_to_sheet,
        from_sheet: sheet_to_sylk
    };
}();
var $7c3b72a365cc0275$var$DIF = /*#__PURE__*/ function() {
    function dif_to_aoa(d /*:RawData*/ , opts) /*:AOA*/ {
        switch(opts.type){
            case 'base64':
                return dif_to_aoa_str($7c3b72a365cc0275$var$Base64_decode(d), opts);
            case 'binary':
                return dif_to_aoa_str(d, opts);
            case 'buffer':
                return dif_to_aoa_str($7c3b72a365cc0275$var$has_buf && $7c3b72a365cc0275$require$Buffer.isBuffer(d) ? d.toString('binary') : $7c3b72a365cc0275$var$a2s(d), opts);
            case 'array':
                return dif_to_aoa_str($7c3b72a365cc0275$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function dif_to_aoa_str(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split('\n'), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            if (records[ri].trim() === 'BOT') {
                arr[++R] = [];
                C = 0;
                continue;
            }
            if (R < 0) continue;
            var metadata = records[ri].trim().split(",");
            var type = metadata[0], value = metadata[1];
            ++ri;
            var data = records[ri] || "";
            while((data.match(/["]/g) || []).length & 1 && ri < records.length - 1)data += "\n" + records[++ri];
            data = data.trim();
            switch(+type){
                case -1:
                    if (data === 'BOT') {
                        arr[++R] = [];
                        C = 0;
                        continue;
                    } else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
                    break;
                case 0:
                    if (data === 'TRUE') arr[R][C] = true;
                    else if (data === 'FALSE') arr[R][C] = false;
                    else if (!isNaN($7c3b72a365cc0275$var$fuzzynum(value))) arr[R][C] = $7c3b72a365cc0275$var$fuzzynum(value);
                    else if (!isNaN($7c3b72a365cc0275$var$fuzzydate(value).getDate())) arr[R][C] = $7c3b72a365cc0275$var$parseDate(value);
                    else arr[R][C] = value;
                    ++C;
                    break;
                case 1:
                    data = data.slice(1, data.length - 1);
                    data = data.replace(/""/g, '"');
                    if ($7c3b72a365cc0275$var$DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
                    arr[R][C++] = data !== '' ? data : null;
                    break;
            }
            if (data === 'EOD') break;
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function dif_to_sheet(str /*:string*/ , opts) /*:Worksheet*/ {
        return $7c3b72a365cc0275$var$aoa_to_sheet(dif_to_aoa(str, opts), opts);
    }
    function dif_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
        return $7c3b72a365cc0275$var$sheet_to_workbook(dif_to_sheet(str, opts), opts);
    }
    var sheet_to_dif = /*#__PURE__*/ function() {
        var push_field = function pf(o /*:Array<string>*/ , topic /*:string*/ , v /*:number*/ , n /*:number*/ , s /*:string*/ ) {
            o.push(topic);
            o.push(v + "," + n);
            o.push('"' + s.replace(/"/g, '""') + '"');
        };
        var push_value = function po(o /*:Array<string>*/ , type /*:number*/ , v /*:any*/ , s /*:string*/ ) {
            o.push(type + "," + v);
            o.push(type == 1 ? '"' + s.replace(/"/g, '""') + '"' : s);
        };
        return function sheet_to_dif(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
            var o /*:Array<string>*/  = [];
            var r = $7c3b72a365cc0275$var$safe_decode_range(ws['!ref']), cell /*:Cell*/ ;
            var dense = Array.isArray(ws);
            push_field(o, "TABLE", 0, 1, "sheetjs");
            push_field(o, "VECTORS", 0, r.e.r - r.s.r + 1, "");
            push_field(o, "TUPLES", 0, r.e.c - r.s.c + 1, "");
            push_field(o, "DATA", 0, 0, "");
            for(var R = r.s.r; R <= r.e.r; ++R){
                push_value(o, -1, 0, "BOT");
                for(var C = r.s.c; C <= r.e.c; ++C){
                    var coord = $7c3b72a365cc0275$var$encode_cell({
                        r: R,
                        c: C
                    });
                    cell = dense ? (ws[R] || [])[C] : ws[coord];
                    if (!cell) {
                        push_value(o, 1, 0, "");
                        continue;
                    }
                    switch(cell.t){
                        case 'n':
                            var val = $7c3b72a365cc0275$var$DIF_XL ? cell.w : cell.v;
                            if (!val && cell.v != null) val = cell.v;
                            if (val == null) {
                                if ($7c3b72a365cc0275$var$DIF_XL && cell.f && !cell.F) push_value(o, 1, 0, "=" + cell.f);
                                else push_value(o, 1, 0, "");
                            } else push_value(o, 0, val, "V");
                            break;
                        case 'b':
                            push_value(o, 0, cell.v ? 1 : 0, cell.v ? "TRUE" : "FALSE");
                            break;
                        case 's':
                            push_value(o, 1, 0, !$7c3b72a365cc0275$var$DIF_XL || isNaN(cell.v) ? cell.v : '="' + cell.v + '"');
                            break;
                        case 'd':
                            if (!cell.w) cell.w = $7c3b72a365cc0275$var$SSF_format(cell.z || $7c3b72a365cc0275$var$table_fmt[14], $7c3b72a365cc0275$var$datenum($7c3b72a365cc0275$var$parseDate(cell.v)));
                            if ($7c3b72a365cc0275$var$DIF_XL) push_value(o, 0, cell.w, "V");
                            else push_value(o, 1, 0, cell.w);
                            break;
                        default:
                            push_value(o, 1, 0, "");
                    }
                }
            }
            push_value(o, -1, 0, "EOD");
            var RS = "\r\n";
            var oo = o.join(RS);
            //while((oo.length & 0x7F) != 0) oo += "\0";
            return oo;
        };
    }();
    return {
        to_workbook: dif_to_workbook,
        to_sheet: dif_to_sheet,
        from_sheet: sheet_to_dif
    };
}();
var $7c3b72a365cc0275$var$ETH = /*#__PURE__*/ function() {
    function decode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, "\n");
    }
    function encode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
    }
    function eth_to_aoa(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split('\n'), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            var record = records[ri].trim().split(":");
            if (record[0] !== 'cell') continue;
            var addr = $7c3b72a365cc0275$var$decode_cell(record[1]);
            if (arr.length <= addr.r) {
                for(R = arr.length; R <= addr.r; ++R)if (!arr[R]) arr[R] = [];
            }
            R = addr.r;
            C = addr.c;
            switch(record[2]){
                case 't':
                    arr[R][C] = decode(record[3]);
                    break;
                case 'v':
                    arr[R][C] = +record[3];
                    break;
                case 'vtf':
                    var _f = record[record.length - 1];
                /* falls through */ case 'vtc':
                    switch(record[3]){
                        case 'nl':
                            arr[R][C] = +record[4] ? true : false;
                            break;
                        default:
                            arr[R][C] = +record[4];
                            break;
                    }
                    if (record[2] == 'vtf') arr[R][C] = [
                        arr[R][C],
                        _f
                    ];
            }
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function eth_to_sheet(d /*:string*/ , opts) /*:Worksheet*/ {
        return $7c3b72a365cc0275$var$aoa_to_sheet(eth_to_aoa(d, opts), opts);
    }
    function eth_to_workbook(d /*:string*/ , opts) /*:Workbook*/ {
        return $7c3b72a365cc0275$var$sheet_to_workbook(eth_to_sheet(d, opts), opts);
    }
    var header = [
        "socialcalc:version:1.5",
        "MIME-Version: 1.0",
        "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
    ].join("\n");
    var sep = [
        "--SocialCalcSpreadsheetControlSave",
        "Content-type: text/plain; charset=UTF-8"
    ].join("\n") + "\n";
    /* TODO: the other parts */ var meta = [
        "# SocialCalc Spreadsheet Control Save",
        "part:sheet"
    ].join("\n");
    var end = "--SocialCalcSpreadsheetControlSave--";
    function sheet_to_eth_data(ws /*:Worksheet*/ ) /*:string*/ {
        if (!ws || !ws['!ref']) return "";
        var o /*:Array<string>*/  = [], oo /*:Array<string>*/  = [], cell, coord = "";
        var r = $7c3b72a365cc0275$var$decode_range(ws['!ref']);
        var dense = Array.isArray(ws);
        for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
            coord = $7c3b72a365cc0275$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? (ws[R] || [])[C] : ws[coord];
            if (!cell || cell.v == null || cell.t === 'z') continue;
            oo = [
                "cell",
                coord,
                't'
            ];
            switch(cell.t){
                case 's':
                case 'str':
                    oo.push(encode(cell.v));
                    break;
                case 'n':
                    if (!cell.f) {
                        oo[2] = 'v';
                        oo[3] = cell.v;
                    } else {
                        oo[2] = 'vtf';
                        oo[3] = 'n';
                        oo[4] = cell.v;
                        oo[5] = encode(cell.f);
                    }
                    break;
                case 'b':
                    oo[2] = 'vt' + (cell.f ? 'f' : 'c');
                    oo[3] = 'nl';
                    oo[4] = cell.v ? "1" : "0";
                    oo[5] = encode(cell.f || (cell.v ? 'TRUE' : 'FALSE'));
                    break;
                case 'd':
                    var t = $7c3b72a365cc0275$var$datenum($7c3b72a365cc0275$var$parseDate(cell.v));
                    oo[2] = 'vtc';
                    oo[3] = 'nd';
                    oo[4] = "" + t;
                    oo[5] = cell.w || $7c3b72a365cc0275$var$SSF_format(cell.z || $7c3b72a365cc0275$var$table_fmt[14], t);
                    break;
                case 'e':
                    continue;
            }
            o.push(oo.join(":"));
        }
        o.push("sheet:c:" + (r.e.c - r.s.c + 1) + ":r:" + (r.e.r - r.s.r + 1) + ":tvf:1");
        o.push("valueformat:1:text-wiki");
        //o.push("copiedfrom:" + ws['!ref']); // clipboard only
        return o.join("\n");
    }
    function sheet_to_eth(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        return [
            header,
            sep,
            meta,
            sep,
            sheet_to_eth_data(ws),
            end
        ].join("\n");
    // return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
    }
    return {
        to_workbook: eth_to_workbook,
        to_sheet: eth_to_sheet,
        from_sheet: sheet_to_eth
    };
}();
var $7c3b72a365cc0275$var$PRN = /*#__PURE__*/ function() {
    function set_text_arr(data /*:string*/ , arr /*:AOA*/ , R /*:number*/ , C /*:number*/ , o /*:any*/ ) {
        if (o.raw) arr[R][C] = data;
        else if (data === "") ;
        else if (data === 'TRUE') arr[R][C] = true;
        else if (data === 'FALSE') arr[R][C] = false;
        else if (!isNaN($7c3b72a365cc0275$var$fuzzynum(data))) arr[R][C] = $7c3b72a365cc0275$var$fuzzynum(data);
        else if (!isNaN($7c3b72a365cc0275$var$fuzzydate(data).getDate())) arr[R][C] = $7c3b72a365cc0275$var$parseDate(data);
        else arr[R][C] = data;
    }
    function prn_to_aoa_str(f /*:string*/ , opts) /*:AOA*/ {
        var o = opts || {};
        var arr /*:AOA*/  = [];
        if (!f || f.length === 0) return arr;
        var lines = f.split(/[\r\n]/);
        var L = lines.length - 1;
        while(L >= 0 && lines[L].length === 0)--L;
        var start = 10, idx = 0;
        var R = 0;
        for(; R <= L; ++R){
            idx = lines[R].indexOf(" ");
            if (idx == -1) idx = lines[R].length;
            else idx++;
            start = Math.max(start, idx);
        }
        for(R = 0; R <= L; ++R){
            arr[R] = [];
            /* TODO: confirm that widths are always 10 */ var C = 0;
            set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
            for(C = 1; C <= (lines[R].length - start) / 10 + 1; ++C)set_text_arr(lines[R].slice(start + (C - 1) * 10, start + C * 10).trim(), arr, R, C, o);
        }
        if (o.sheetRows) arr = arr.slice(0, o.sheetRows);
        return arr;
    }
    // List of accepted CSV separators
    var guess_seps = {
        /*::[*/ 0x2C: ',',
        /*::[*/ 0x09: "\t",
        /*::[*/ 0x3B: ';',
        /*::[*/ 0x7C: '|'
    };
    // CSV separator weights to be used in case of equal numbers
    var guess_sep_weights = {
        /*::[*/ 0x2C: 3,
        /*::[*/ 0x09: 2,
        /*::[*/ 0x3B: 1,
        /*::[*/ 0x7C: 0
    };
    function guess_sep(str) {
        var cnt = {}, instr = false, end = 0, cc = 0;
        for(; end < str.length; ++end){
            if ((cc = str.charCodeAt(end)) == 0x22) instr = !instr;
            else if (!instr && cc in guess_seps) cnt[cc] = (cnt[cc] || 0) + 1;
        }
        cc = [];
        for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
            cnt[end],
            end
        ]);
        if (!cc.length) {
            cnt = guess_sep_weights;
            for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
                cnt[end],
                end
            ]);
        }
        cc.sort(function(a, b) {
            return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]];
        });
        return guess_seps[cc.pop()[1]] || 0x2C;
    }
    function dsv_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        var o = opts || {};
        var sep = "";
        if ($7c3b72a365cc0275$var$DENSE != null && o.dense == null) o.dense = $7c3b72a365cc0275$var$DENSE;
        var ws /*:Worksheet*/  = o.dense ? [] : {} /*:any*/ ;
        var range /*:Range*/  = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        } /*:any*/ ;
        if (str.slice(0, 4) == "sep=") {
            // If the line ends in \r\n
            if (str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10) {
                sep = str.charAt(4);
                str = str.slice(7);
            } else if (str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10) {
                sep = str.charAt(4);
                str = str.slice(6);
            } else sep = guess_sep(str.slice(0, 1024));
        } else if (o && o.FS) sep = o.FS;
        else sep = guess_sep(str.slice(0, 1024));
        var R = 0, C = 0, v = 0;
        var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc = 0, startcc = str.charCodeAt(0);
        str = str.replace(/\r\n/mg, "\n");
        var _re /*:?RegExp*/  = o.dateNF != null ? $7c3b72a365cc0275$var$dateNF_regex(o.dateNF) : null;
        function finish_cell() {
            var s = str.slice(start, end);
            var cell = {} /*:any*/ ;
            if (s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1, -1).replace(/""/g, '"');
            if (s.length === 0) cell.t = 'z';
            else if (o.raw) {
                cell.t = 's';
                cell.v = s;
            } else if (s.trim().length === 0) {
                cell.t = 's';
                cell.v = s;
            } else if (s.charCodeAt(0) == 0x3D) {
                if (s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) {
                    cell.t = 's';
                    cell.v = s.slice(2, -1).replace(/""/g, '"');
                } else if ($7c3b72a365cc0275$var$fuzzyfmla(s)) {
                    cell.t = 'n';
                    cell.f = s.slice(1);
                } else {
                    cell.t = 's';
                    cell.v = s;
                }
            } else if (s == "TRUE") {
                cell.t = 'b';
                cell.v = true;
            } else if (s == "FALSE") {
                cell.t = 'b';
                cell.v = false;
            } else if (!isNaN(v = $7c3b72a365cc0275$var$fuzzynum(s))) {
                cell.t = 'n';
                if (o.cellText !== false) cell.w = s;
                cell.v = v;
            } else if (!isNaN($7c3b72a365cc0275$var$fuzzydate(s).getDate()) || _re && s.match(_re)) {
                cell.z = o.dateNF || $7c3b72a365cc0275$var$table_fmt[14];
                var k = 0;
                if (_re && s.match(_re)) {
                    s = $7c3b72a365cc0275$var$dateNF_fix(s, o.dateNF, s.match(_re) || []);
                    k = 1;
                }
                if (o.cellDates) {
                    cell.t = 'd';
                    cell.v = $7c3b72a365cc0275$var$parseDate(s, k);
                } else {
                    cell.t = 'n';
                    cell.v = $7c3b72a365cc0275$var$datenum($7c3b72a365cc0275$var$parseDate(s, k));
                }
                if (o.cellText !== false) cell.w = $7c3b72a365cc0275$var$SSF_format(cell.z, cell.v instanceof Date ? $7c3b72a365cc0275$var$datenum(cell.v) : cell.v);
                if (!o.cellNF) delete cell.z;
            } else {
                cell.t = 's';
                cell.v = s;
            }
            if (cell.t == 'z') ;
            else if (o.dense) {
                if (!ws[R]) ws[R] = [];
                ws[R][C] = cell;
            } else ws[$7c3b72a365cc0275$var$encode_cell({
                c: C,
                r: R
            })] = cell;
            start = end + 1;
            startcc = str.charCodeAt(start);
            if (range.e.c < C) range.e.c = C;
            if (range.e.r < R) range.e.r = R;
            if (cc == sepcc) ++C;
            else {
                C = 0;
                ++R;
                if (o.sheetRows && o.sheetRows <= R) return true;
            }
        }
        outer: for(; end < str.length; ++end)switch(cc = str.charCodeAt(end)){
            case 0x22:
                if (startcc === 0x22) instr = !instr;
                break;
            case sepcc:
            case 0x0a:
            case 0x0d:
                if (!instr && finish_cell()) break outer;
                break;
            default:
                break;
        }
        if (end - start > 0) finish_cell();
        ws['!ref'] = $7c3b72a365cc0275$var$encode_range(range);
        return ws;
    }
    function prn_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        if (!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
        if (opts.FS) return dsv_to_sheet_str(str, opts);
        if (str.slice(0, 4) == "sep=") return dsv_to_sheet_str(str, opts);
        if (str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
        return $7c3b72a365cc0275$var$aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
    }
    function prn_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        var str = "", bytes = opts.type == 'string' ? [
            0,
            0,
            0,
            0
        ] : $7c3b72a365cc0275$var$firstbyte(d, opts);
        switch(opts.type){
            case 'base64':
                str = $7c3b72a365cc0275$var$Base64_decode(d);
                break;
            case 'binary':
                str = d;
                break;
            case 'buffer':
                if (opts.codepage == 65001) str = d.toString('utf8'); // TODO: test if buf
                else if (opts.codepage && typeof $7c3b72a365cc0275$var$$cptable !== 'undefined') str = $7c3b72a365cc0275$var$$cptable.utils.decode(opts.codepage, d);
                else str = $7c3b72a365cc0275$var$has_buf && $7c3b72a365cc0275$require$Buffer.isBuffer(d) ? d.toString('binary') : $7c3b72a365cc0275$var$a2s(d);
                break;
            case 'array':
                str = $7c3b72a365cc0275$var$cc2str(d);
                break;
            case 'string':
                str = d;
                break;
            default:
                throw new Error("Unrecognized type " + opts.type);
        }
        if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $7c3b72a365cc0275$var$utf8read(str.slice(3));
        else if (opts.type != 'string' && opts.type != 'buffer' && opts.codepage == 65001) str = $7c3b72a365cc0275$var$utf8read(str);
        else if (opts.type == 'binary' && typeof $7c3b72a365cc0275$var$$cptable !== 'undefined' && opts.codepage) str = $7c3b72a365cc0275$var$$cptable.utils.decode(opts.codepage, $7c3b72a365cc0275$var$$cptable.utils.encode(28591, str));
        if (str.slice(0, 19) == "socialcalc:version:") return $7c3b72a365cc0275$var$ETH.to_sheet(opts.type == 'string' ? str : $7c3b72a365cc0275$var$utf8read(str), opts);
        return prn_to_sheet_str(str, opts);
    }
    function prn_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $7c3b72a365cc0275$var$sheet_to_workbook(prn_to_sheet(d, opts), opts);
    }
    function sheet_to_prn(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var o /*:Array<string>*/  = [];
        var r = $7c3b72a365cc0275$var$safe_decode_range(ws['!ref']), cell /*:Cell*/ ;
        var dense = Array.isArray(ws);
        for(var R = r.s.r; R <= r.e.r; ++R){
            var oo /*:Array<string>*/  = [];
            for(var C = r.s.c; C <= r.e.c; ++C){
                var coord = $7c3b72a365cc0275$var$encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws[R] || [])[C] : ws[coord];
                if (!cell || cell.v == null) {
                    oo.push("          ");
                    continue;
                }
                var w = (cell.w || ($7c3b72a365cc0275$var$format_cell(cell), cell.w) || "").slice(0, 10);
                while(w.length < 10)w += " ";
                oo.push(w + (C === 0 ? " " : ""));
            }
            o.push(oo.join(""));
        }
        return o.join("\n");
    }
    return {
        to_workbook: prn_to_workbook,
        to_sheet: prn_to_sheet,
        from_sheet: sheet_to_prn
    };
}();
/* Excel defaults to SYLK but warns if data is not valid */ function $7c3b72a365cc0275$var$read_wb_ID(d, opts) {
    var o = opts || {}, OLD_WTF = !!o.WTF;
    o.WTF = true;
    try {
        var out = $7c3b72a365cc0275$var$SYLK.to_workbook(d, o);
        o.WTF = OLD_WTF;
        return out;
    } catch (e) {
        o.WTF = OLD_WTF;
        if (!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
        return $7c3b72a365cc0275$var$PRN.to_workbook(d, opts);
    }
}
var $7c3b72a365cc0275$var$WK_ = /*#__PURE__*/ function() {
    function lotushopper(data, cb /*:RecordHopperCB*/ , opts /*:any*/ ) {
        if (!data) return;
        $7c3b72a365cc0275$var$prep_blob(data, data.l || 0);
        var Enum = opts.Enum || WK1Enum;
        while(data.l < data.length){
            var RT = data.read_shift(2);
            var R = Enum[RT] || Enum[0xFFFF];
            var length = data.read_shift(2);
            var tgt = data.l + length;
            var d = R.f && R.f(data, length, opts);
            data.l = tgt;
            if (cb(d, R, RT)) return;
        }
    }
    function lotus_to_workbook(d /*:RawData*/ , opts) {
        switch(opts.type){
            case 'base64':
                return lotus_to_workbook_buf($7c3b72a365cc0275$var$s2a($7c3b72a365cc0275$var$Base64_decode(d)), opts);
            case 'binary':
                return lotus_to_workbook_buf($7c3b72a365cc0275$var$s2a(d), opts);
            case 'buffer':
            case 'array':
                return lotus_to_workbook_buf(d, opts);
        }
        throw "Unsupported type " + opts.type;
    }
    function lotus_to_workbook_buf(d, opts) /*:Workbook*/ {
        if (!d) return d;
        var o = opts || {};
        if ($7c3b72a365cc0275$var$DENSE != null && o.dense == null) o.dense = $7c3b72a365cc0275$var$DENSE;
        var s /*:Worksheet*/  = o.dense ? [] : {}, n = "Sheet1", next_n = "", sidx = 0;
        var sheets = {}, snames = [], realnames = [];
        var refguess = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        var sheetRows = o.sheetRows || 0;
        if (d[2] == 0x00) {
            if (d[3] == 0x08 || d[3] == 0x09) {
                if (d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
            }
        }
        if (d[2] == 0x02) {
            o.Enum = WK1Enum;
            lotushopper(d, function(val, R, RT) {
                switch(RT){
                    case 0x00:
                        /* BOF */ o.vers = val;
                        if (val >= 0x1000) o.qpro = true;
                        break;
                    case 0x06:
                        refguess = val;
                        break; /* RANGE */ 
                    case 0xCC:
                        if (val) next_n = val;
                        break; /* SHEETNAMECS */ 
                    case 0xDE:
                        next_n = val;
                        break; /* SHEETNAMELP */ 
                    case 0x0F:
                    /* LABEL */ case 0x33:
                        /* STRING */ if (!o.qpro) val[1].v = val[1].v.slice(1);
                    /* falls through */ case 0x0D:
                    /* INTEGER */ case 0x0E:
                    /* NUMBER */ case 0x10:
                        /* FORMULA */ /* TODO: actual translation of the format code */ if (RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
                            val[1].z = o.dateNF || $7c3b72a365cc0275$var$table_fmt[14];
                            if (o.cellDates) {
                                val[1].t = 'd';
                                val[1].v = $7c3b72a365cc0275$var$numdate(val[1].v);
                            }
                        }
                        if (o.qpro) {
                            if (val[3] > sidx) {
                                s["!ref"] = $7c3b72a365cc0275$var$encode_range(refguess);
                                sheets[n] = s;
                                snames.push(n);
                                s = o.dense ? [] : {};
                                refguess = {
                                    s: {
                                        r: 0,
                                        c: 0
                                    },
                                    e: {
                                        r: 0,
                                        c: 0
                                    }
                                };
                                sidx = val[3];
                                n = next_n || "Sheet" + (sidx + 1);
                                next_n = "";
                            }
                        }
                        var tmpcell = o.dense ? (s[val[0].r] || [])[val[0].c] : s[$7c3b72a365cc0275$var$encode_cell(val[0])];
                        if (tmpcell) {
                            tmpcell.t = val[1].t;
                            tmpcell.v = val[1].v;
                            if (val[1].z != null) tmpcell.z = val[1].z;
                            if (val[1].f != null) tmpcell.f = val[1].f;
                            break;
                        }
                        if (o.dense) {
                            if (!s[val[0].r]) s[val[0].r] = [];
                            s[val[0].r][val[0].c] = val[1];
                        } else s[$7c3b72a365cc0275$var$encode_cell(val[0])] = val[1];
                        break;
                    default:
                }
            }, o);
        } else if (d[2] == 0x1A || d[2] == 0x0E) {
            o.Enum = WK3Enum;
            if (d[2] == 0x0E) {
                o.qpro = true;
                d.l = 0;
            }
            lotushopper(d, function(val, R, RT) {
                switch(RT){
                    case 0xCC:
                        n = val;
                        break; /* SHEETNAMECS */ 
                    case 0x16:
                        /* LABEL16 */ val[1].v = val[1].v.slice(1);
                    /* falls through */ case 0x17:
                    /* NUMBER17 */ case 0x18:
                    /* NUMBER18 */ case 0x19:
                    /* FORMULA19 */ case 0x25:
                    /* NUMBER25 */ case 0x27:
                    /* NUMBER27 */ case 0x28:
                        /* FORMULA28 */ if (val[3] > sidx) {
                            s["!ref"] = $7c3b72a365cc0275$var$encode_range(refguess);
                            sheets[n] = s;
                            snames.push(n);
                            s = o.dense ? [] : {};
                            refguess = {
                                s: {
                                    r: 0,
                                    c: 0
                                },
                                e: {
                                    r: 0,
                                    c: 0
                                }
                            };
                            sidx = val[3];
                            n = "Sheet" + (sidx + 1);
                        }
                        if (sheetRows > 0 && val[0].r >= sheetRows) break;
                        if (o.dense) {
                            if (!s[val[0].r]) s[val[0].r] = [];
                            s[val[0].r][val[0].c] = val[1];
                        } else s[$7c3b72a365cc0275$var$encode_cell(val[0])] = val[1];
                        if (refguess.e.c < val[0].c) refguess.e.c = val[0].c;
                        if (refguess.e.r < val[0].r) refguess.e.r = val[0].r;
                        break;
                    case 0x1B:
                        /* XFORMAT */ if (val[0x36b0]) realnames[val[0x36b0][0]] = val[0x36b0][1];
                        break;
                    case 0x0601:
                        /* SHEETINFOQP */ realnames[val[0]] = val[1];
                        if (val[0] == sidx) n = val[1];
                        break;
                    default:
                        break;
                }
            }, o);
        } else throw new Error("Unrecognized LOTUS BOF " + d[2]);
        s["!ref"] = $7c3b72a365cc0275$var$encode_range(refguess);
        sheets[next_n || n] = s;
        snames.push(next_n || n);
        if (!realnames.length) return {
            SheetNames: snames,
            Sheets: sheets
        };
        var osheets = {}, rnames = [];
        /* TODO: verify no collisions */ for(var i = 0; i < realnames.length; ++i)if (sheets[snames[i]]) {
            rnames.push(realnames[i] || snames[i]);
            osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
        } else {
            rnames.push(realnames[i]);
            osheets[realnames[i]] = {
                "!ref": "A1"
            };
        }
        return {
            SheetNames: rnames,
            Sheets: osheets
        };
    }
    function sheet_to_wk1(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $7c3b72a365cc0275$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK1 to JS string");
        var ba = $7c3b72a365cc0275$var$buf_array();
        var range = $7c3b72a365cc0275$var$safe_decode_range(ws["!ref"]);
        var dense = Array.isArray(ws);
        var cols = [];
        $7c3b72a365cc0275$var$write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
        $7c3b72a365cc0275$var$write_biff_rec(ba, 0x06, write_RANGE(range));
        var max_R = Math.min(range.e.r, 8191);
        for(var R = range.s.r; R <= max_R; ++R){
            var rr = $7c3b72a365cc0275$var$encode_row(R);
            for(var C = range.s.c; C <= range.e.c; ++C){
                if (R === range.s.r) cols[C] = $7c3b72a365cc0275$var$encode_col(C);
                var ref = cols[C] + rr;
                var cell = dense ? (ws[R] || [])[C] : ws[ref];
                if (!cell || cell.t == "z") continue;
                /* TODO: formula records */ if (cell.t == "n") {
                    if ((cell.v | 0) == cell.v && cell.v >= -32768 && cell.v <= 32767) $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell.v));
                    else $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell.v));
                } else {
                    var str = $7c3b72a365cc0275$var$format_cell(cell);
                    $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
                }
            }
        }
        $7c3b72a365cc0275$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function book_to_wk3(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $7c3b72a365cc0275$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK3 to JS string");
        var ba = $7c3b72a365cc0275$var$buf_array();
        $7c3b72a365cc0275$var$write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
        for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i)if ((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) $7c3b72a365cc0275$var$write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
        var wsidx = 0;
        for(i = 0; i < wb.SheetNames.length; ++i){
            var ws = wb.Sheets[wb.SheetNames[i]];
            if (!ws || !ws["!ref"]) continue;
            var range = $7c3b72a365cc0275$var$safe_decode_range(ws["!ref"]);
            var dense = Array.isArray(ws);
            var cols = [];
            var max_R = Math.min(range.e.r, 8191);
            for(var R = range.s.r; R <= max_R; ++R){
                var rr = $7c3b72a365cc0275$var$encode_row(R);
                for(var C = range.s.c; C <= range.e.c; ++C){
                    if (R === range.s.r) cols[C] = $7c3b72a365cc0275$var$encode_col(C);
                    var ref = cols[C] + rr;
                    var cell = dense ? (ws[R] || [])[C] : ws[ref];
                    if (!cell || cell.t == "z") continue;
                    /* TODO: FORMULA19 NUMBER18 records */ if (cell.t == "n") $7c3b72a365cc0275$var$write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
                    else {
                        var str = $7c3b72a365cc0275$var$format_cell(cell);
                        /* TODO: max len? */ $7c3b72a365cc0275$var$write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
                    }
                }
            }
            ++wsidx;
        }
        $7c3b72a365cc0275$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function write_BOF_WK1(v /*:number*/ ) {
        var out = $7c3b72a365cc0275$var$new_buf(2);
        out.write_shift(2, v);
        return out;
    }
    function write_BOF_WK3(wb /*:Workbook*/ ) {
        var out = $7c3b72a365cc0275$var$new_buf(26);
        out.write_shift(2, 0x1000);
        out.write_shift(2, 0x0004);
        out.write_shift(4, 0x0000);
        var rows = 0, cols = 0, wscnt = 0;
        for(var i = 0; i < wb.SheetNames.length; ++i){
            var name = wb.SheetNames[i];
            var ws = wb.Sheets[name];
            if (!ws || !ws["!ref"]) continue;
            ++wscnt;
            var range = $7c3b72a365cc0275$var$decode_range(ws["!ref"]);
            if (rows < range.e.r) rows = range.e.r;
            if (cols < range.e.c) cols = range.e.c;
        }
        if (rows > 8191) rows = 8191;
        out.write_shift(2, rows);
        out.write_shift(1, wscnt);
        out.write_shift(1, cols);
        out.write_shift(2, 0x00);
        out.write_shift(2, 0x00);
        out.write_shift(1, 0x01);
        out.write_shift(1, 0x02);
        out.write_shift(4, 0);
        out.write_shift(4, 0);
        return out;
    }
    function parse_RANGE(blob, length, opts) {
        var o = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        };
        if (length == 8 && opts.qpro) {
            o.s.c = blob.read_shift(1);
            blob.l++;
            o.s.r = blob.read_shift(2);
            o.e.c = blob.read_shift(1);
            blob.l++;
            o.e.r = blob.read_shift(2);
            return o;
        }
        o.s.c = blob.read_shift(2);
        o.s.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        o.e.c = blob.read_shift(2);
        o.e.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        if (o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
        return o;
    }
    function write_RANGE(range) {
        var out = $7c3b72a365cc0275$var$new_buf(8);
        out.write_shift(2, range.s.c);
        out.write_shift(2, range.s.r);
        out.write_shift(2, range.e.c);
        out.write_shift(2, range.e.r);
        return out;
    }
    function parse_cell(blob, length, opts) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: 'n',
                v: 0
            },
            0,
            0
        ];
        if (opts.qpro && opts.vers != 0x5120) {
            o[0].c = blob.read_shift(1);
            o[3] = blob.read_shift(1);
            o[0].r = blob.read_shift(2);
            blob.l += 2;
        } else {
            o[2] = blob.read_shift(1);
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
        }
        return o;
    }
    function parse_LABEL(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = 's';
        if (opts.vers == 0x5120) {
            blob.l++;
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, 'utf8');
            return o;
        }
        if (opts.qpro) blob.l++;
        o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
        return o;
    }
    function write_LABEL(R, C, s) {
        /* TODO: encoding */ var o = $7c3b72a365cc0275$var$new_buf(7 + s.length);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(1, 0x27); // ??
        for(var i = 0; i < o.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_INTEGER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(2, 'i');
        return o;
    }
    function write_INTEGER(R, C, v) {
        var o = $7c3b72a365cc0275$var$new_buf(7);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(2, v, 'i');
        return o;
    }
    function parse_NUMBER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(8, 'f');
        return o;
    }
    function write_NUMBER(R, C, v) {
        var o = $7c3b72a365cc0275$var$new_buf(13);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(8, v, 'f');
        return o;
    }
    function parse_FORMULA(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        /* TODO: formula */ o[1].v = blob.read_shift(8, 'f');
        if (opts.qpro) blob.l = tgt;
        else {
            var flen = blob.read_shift(2);
            wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
            blob.l += flen;
        }
        return o;
    }
    function wk1_parse_rc(B, V, col) {
        var rel = V & 0x8000;
        V &= -32769;
        V = (rel ? B : 0) + (V >= 0x2000 ? V - 0x4000 : V);
        return (rel ? "" : "$") + (col ? $7c3b72a365cc0275$var$encode_col(V) : $7c3b72a365cc0275$var$encode_row(V));
    }
    /* var oprec = [
		8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
		3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
	]; */ /* TODO: flesh out */ var FuncTab = {
        0x33: [
            "FALSE",
            0
        ],
        0x34: [
            "TRUE",
            0
        ],
        0x46: [
            "LEN",
            1
        ],
        0x50: [
            "SUM",
            69
        ],
        0x51: [
            "AVERAGEA",
            69
        ],
        0x52: [
            "COUNTA",
            69
        ],
        0x53: [
            "MINA",
            69
        ],
        0x54: [
            "MAXA",
            69
        ],
        0x6F: [
            "T",
            1
        ]
    };
    var BinOpTab = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "+",
        "-",
        "*",
        "/",
        "^",
        "=",
        "<>",
        "<=",
        ">=",
        "<",
        ">",
        "",
        "",
        "",
        "",
        "&",
        "",
        "",
        "",
        "",
        "",
        "",
        "" // eslint-disable-line no-mixed-spaces-and-tabs
    ];
    function wk1_fmla_to_csf(blob, o) {
        $7c3b72a365cc0275$var$prep_blob(blob, 0);
        var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
        while(blob.l < blob.length){
            var cc = blob[blob.l++];
            switch(cc){
                case 0x00:
                    out.push(blob.read_shift(8, 'f'));
                    break;
                case 0x01:
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(C + R);
                    break;
                case 0x02:
                    var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(c + r + ":" + C + R);
                    break;
                case 0x03:
                    if (blob.l < blob.length) {
                        console.error("WK1 premature formula end");
                        return;
                    }
                    break;
                case 0x04:
                    out.push("(" + out.pop() + ")");
                    break;
                case 0x05:
                    out.push(blob.read_shift(2));
                    break;
                case 0x06:
                    /* TODO: text encoding */ var Z = "";
                    while(cc = blob[blob.l++])Z += String.fromCharCode(cc);
                    out.push('"' + Z.replace(/"/g, '""') + '"');
                    break;
                case 0x08:
                    out.push("-" + out.pop());
                    break;
                case 0x17:
                    out.push("+" + out.pop());
                    break;
                case 0x16:
                    out.push("NOT(" + out.pop() + ")");
                    break;
                case 0x14:
                case 0x15:
                    argR = out.pop();
                    argL = out.pop();
                    out.push([
                        "AND",
                        "OR"
                    ][cc - 0x14] + "(" + argL + "," + argR + ")");
                    break;
                default:
                    if (cc < 0x20 && BinOpTab[cc]) {
                        argR = out.pop();
                        argL = out.pop();
                        out.push(argL + BinOpTab[cc] + argR);
                    } else if (FuncTab[cc]) {
                        argc = FuncTab[cc][1];
                        if (argc == 69) argc = blob[blob.l++];
                        if (argc > out.length) {
                            console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|");
                            return;
                        }
                        var args = out.slice(-argc);
                        out.length -= argc;
                        out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
                    } else if (cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
                    else if (cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
                    else return console.error("WK1 unrecognized opcode " + cc.toString(16));
            }
        }
        if (out.length == 1) o[1].f = "" + out[0];
        else console.error("WK1 bad formula parse |" + out.join("|") + "|");
    }
    function parse_cell_3(blob /*::, length*/ ) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: 'n',
                v: 0
            },
            0
        ];
        o[0].r = blob.read_shift(2);
        o[3] = blob[blob.l++];
        o[0].c = blob[blob.l++];
        return o;
    }
    function parse_LABEL_16(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].t = 's';
        o[1].v = blob.read_shift(length - 4, 'cstr');
        return o;
    }
    function write_LABEL_16(R, C, wsidx, s) {
        /* TODO: encoding */ var o = $7c3b72a365cc0275$var$new_buf(6 + s.length);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        o.write_shift(1, 0x27);
        for(var i = 0; i < s.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_NUMBER_18(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].v = blob.read_shift(2);
        var v = o[1].v >> 1;
        if (o[1].v & 0x1) switch(v & 0x07){
            case 0:
                v = (v >> 3) * 5000;
                break;
            case 1:
                v = (v >> 3) * 500;
                break;
            case 2:
                v = (v >> 3) / 20;
                break;
            case 3:
                v = (v >> 3) / 200;
                break;
            case 4:
                v = (v >> 3) / 2000;
                break;
            case 5:
                v = (v >> 3) / 20000;
                break;
            case 6:
                v = (v >> 3) / 16;
                break;
            case 7:
                v = (v >> 3) / 64;
                break;
        }
        o[1].v = v;
        return o;
    }
    function parse_NUMBER_17(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        var v2 = blob.read_shift(4);
        var e = blob.read_shift(2);
        if (e == 0xFFFF) {
            if (v1 === 0 && v2 === 0xC0000000) {
                o[1].t = "e";
                o[1].v = 0x0F;
            } else if (v1 === 0 && v2 === 0xD0000000) {
                o[1].t = "e";
                o[1].v = 0x2A;
            } else o[1].v = 0;
            return o;
        }
        var s = e & 0x8000;
        e = (e & 0x7FFF) - 16446;
        o[1].v = (1 - s * 2) * (v2 * Math.pow(2, e + 32) + v1 * Math.pow(2, e));
        return o;
    }
    function write_NUMBER_17(R, C, wsidx, v) {
        var o = $7c3b72a365cc0275$var$new_buf(14);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        if (v == 0) {
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(2, 0xFFFF);
            return o;
        }
        var s = 0, e = 0, v1 = 0, v2 = 0;
        if (v < 0) {
            s = 1;
            v = -v;
        }
        e = Math.log2(v) | 0;
        v /= Math.pow(2, e - 31);
        v2 = v >>> 0;
        if ((v2 & 0x80000000) == 0) {
            v /= 2;
            ++e;
            v2 = v >>> 0;
        }
        v -= v2;
        v2 |= 0x80000000;
        v2 >>>= 0;
        v *= Math.pow(2, 32);
        v1 = v >>> 0;
        o.write_shift(4, v1);
        o.write_shift(4, v2);
        e += 0x3FFF + (s ? 0x8000 : 0);
        o.write_shift(2, e);
        return o;
    }
    function parse_FORMULA_19(blob, length) {
        var o = parse_NUMBER_17(blob, 14);
        blob.l += length - 14; /* TODO: WK3 formula */ 
        return o;
    }
    function parse_NUMBER_25(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        o[1].v = v1 >> 6;
        return o;
    }
    function parse_NUMBER_27(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(8, 'f');
        o[1].v = v1;
        return o;
    }
    function parse_FORMULA_28(blob, length) {
        var o = parse_NUMBER_27(blob, 14);
        blob.l += length - 10; /* TODO: formula */ 
        return o;
    }
    function parse_SHEETNAMECS(blob, length) {
        return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, 'cstr') : "";
    }
    function parse_SHEETNAMELP(blob, length) {
        var len = blob[blob.l++];
        if (len > length - 1) len = length - 1;
        var o = "";
        while(o.length < len)o += String.fromCharCode(blob[blob.l++]);
        return o;
    }
    function parse_SHEETINFOQP(blob, length, opts) {
        if (!opts.qpro || length < 21) return;
        var id = blob.read_shift(1);
        blob.l += 17;
        blob.l += 1; //var len = blob.read_shift(1);
        blob.l += 2;
        var nm = blob.read_shift(length - 21, 'cstr');
        return [
            id,
            nm
        ];
    }
    function parse_XFORMAT(blob, length) {
        var o = {}, tgt = blob.l + length;
        while(blob.l < tgt){
            var dt = blob.read_shift(2);
            if (dt == 0x36b0) {
                o[dt] = [
                    0,
                    ""
                ];
                o[dt][0] = blob.read_shift(2);
                while(blob[blob.l]){
                    o[dt][1] += String.fromCharCode(blob[blob.l]);
                    blob.l++;
                }
                blob.l++;
            }
        // TODO: 0x3a99 ??
        }
        return o;
    }
    function write_XFORMAT_SHEETNAME(name, wsidx) {
        var out = $7c3b72a365cc0275$var$new_buf(5 + name.length);
        out.write_shift(2, 0x36b0);
        out.write_shift(2, wsidx);
        for(var i = 0; i < name.length; ++i){
            var cc = name.charCodeAt(i);
            out[out.l++] = cc > 0x7F ? 0x5F : cc;
        }
        out[out.l++] = 0;
        return out;
    }
    var WK1Enum = {
        /*::[*/ 0x0000: {
            n: "BOF",
            f: $7c3b72a365cc0275$var$parseuint16
        },
        /*::[*/ 0x0001: {
            n: "EOF"
        },
        /*::[*/ 0x0002: {
            n: "CALCMODE"
        },
        /*::[*/ 0x0003: {
            n: "CALCORDER"
        },
        /*::[*/ 0x0004: {
            n: "SPLIT"
        },
        /*::[*/ 0x0005: {
            n: "SYNC"
        },
        /*::[*/ 0x0006: {
            n: "RANGE",
            f: parse_RANGE
        },
        /*::[*/ 0x0007: {
            n: "WINDOW1"
        },
        /*::[*/ 0x0008: {
            n: "COLW1"
        },
        /*::[*/ 0x0009: {
            n: "WINTWO"
        },
        /*::[*/ 0x000A: {
            n: "COLW2"
        },
        /*::[*/ 0x000B: {
            n: "NAME"
        },
        /*::[*/ 0x000C: {
            n: "BLANK"
        },
        /*::[*/ 0x000D: {
            n: "INTEGER",
            f: parse_INTEGER
        },
        /*::[*/ 0x000E: {
            n: "NUMBER",
            f: parse_NUMBER
        },
        /*::[*/ 0x000F: {
            n: "LABEL",
            f: parse_LABEL
        },
        /*::[*/ 0x0010: {
            n: "FORMULA",
            f: parse_FORMULA
        },
        /*::[*/ 0x0018: {
            n: "TABLE"
        },
        /*::[*/ 0x0019: {
            n: "ORANGE"
        },
        /*::[*/ 0x001A: {
            n: "PRANGE"
        },
        /*::[*/ 0x001B: {
            n: "SRANGE"
        },
        /*::[*/ 0x001C: {
            n: "FRANGE"
        },
        /*::[*/ 0x001D: {
            n: "KRANGE1"
        },
        /*::[*/ 0x0020: {
            n: "HRANGE"
        },
        /*::[*/ 0x0023: {
            n: "KRANGE2"
        },
        /*::[*/ 0x0024: {
            n: "PROTEC"
        },
        /*::[*/ 0x0025: {
            n: "FOOTER"
        },
        /*::[*/ 0x0026: {
            n: "HEADER"
        },
        /*::[*/ 0x0027: {
            n: "SETUP"
        },
        /*::[*/ 0x0028: {
            n: "MARGINS"
        },
        /*::[*/ 0x0029: {
            n: "LABELFMT"
        },
        /*::[*/ 0x002A: {
            n: "TITLES"
        },
        /*::[*/ 0x002B: {
            n: "SHEETJS"
        },
        /*::[*/ 0x002D: {
            n: "GRAPH"
        },
        /*::[*/ 0x002E: {
            n: "NGRAPH"
        },
        /*::[*/ 0x002F: {
            n: "CALCCOUNT"
        },
        /*::[*/ 0x0030: {
            n: "UNFORMATTED"
        },
        /*::[*/ 0x0031: {
            n: "CURSORW12"
        },
        /*::[*/ 0x0032: {
            n: "WINDOW"
        },
        /*::[*/ 0x0033: {
            n: "STRING",
            f: parse_LABEL
        },
        /*::[*/ 0x0037: {
            n: "PASSWORD"
        },
        /*::[*/ 0x0038: {
            n: "LOCKED"
        },
        /*::[*/ 0x003C: {
            n: "QUERY"
        },
        /*::[*/ 0x003D: {
            n: "QUERYNAME"
        },
        /*::[*/ 0x003E: {
            n: "PRINT"
        },
        /*::[*/ 0x003F: {
            n: "PRINTNAME"
        },
        /*::[*/ 0x0040: {
            n: "GRAPH2"
        },
        /*::[*/ 0x0041: {
            n: "GRAPHNAME"
        },
        /*::[*/ 0x0042: {
            n: "ZOOM"
        },
        /*::[*/ 0x0043: {
            n: "SYMSPLIT"
        },
        /*::[*/ 0x0044: {
            n: "NSROWS"
        },
        /*::[*/ 0x0045: {
            n: "NSCOLS"
        },
        /*::[*/ 0x0046: {
            n: "RULER"
        },
        /*::[*/ 0x0047: {
            n: "NNAME"
        },
        /*::[*/ 0x0048: {
            n: "ACOMM"
        },
        /*::[*/ 0x0049: {
            n: "AMACRO"
        },
        /*::[*/ 0x004A: {
            n: "PARSE"
        },
        /*::[*/ 0x0066: {
            n: "PRANGES??"
        },
        /*::[*/ 0x0067: {
            n: "RRANGES??"
        },
        /*::[*/ 0x0068: {
            n: "FNAME??"
        },
        /*::[*/ 0x0069: {
            n: "MRANGES??"
        },
        /*::[*/ 0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        /*::[*/ 0x00DE: {
            n: "SHEETNAMELP",
            f: parse_SHEETNAMELP
        },
        /*::[*/ 0xFFFF: {
            n: ""
        }
    };
    var WK3Enum = {
        /*::[*/ 0x0000: {
            n: "BOF"
        },
        /*::[*/ 0x0001: {
            n: "EOF"
        },
        /*::[*/ 0x0002: {
            n: "PASSWORD"
        },
        /*::[*/ 0x0003: {
            n: "CALCSET"
        },
        /*::[*/ 0x0004: {
            n: "WINDOWSET"
        },
        /*::[*/ 0x0005: {
            n: "SHEETCELLPTR"
        },
        /*::[*/ 0x0006: {
            n: "SHEETLAYOUT"
        },
        /*::[*/ 0x0007: {
            n: "COLUMNWIDTH"
        },
        /*::[*/ 0x0008: {
            n: "HIDDENCOLUMN"
        },
        /*::[*/ 0x0009: {
            n: "USERRANGE"
        },
        /*::[*/ 0x000A: {
            n: "SYSTEMRANGE"
        },
        /*::[*/ 0x000B: {
            n: "ZEROFORCE"
        },
        /*::[*/ 0x000C: {
            n: "SORTKEYDIR"
        },
        /*::[*/ 0x000D: {
            n: "FILESEAL"
        },
        /*::[*/ 0x000E: {
            n: "DATAFILLNUMS"
        },
        /*::[*/ 0x000F: {
            n: "PRINTMAIN"
        },
        /*::[*/ 0x0010: {
            n: "PRINTSTRING"
        },
        /*::[*/ 0x0011: {
            n: "GRAPHMAIN"
        },
        /*::[*/ 0x0012: {
            n: "GRAPHSTRING"
        },
        /*::[*/ 0x0013: {
            n: "??"
        },
        /*::[*/ 0x0014: {
            n: "ERRCELL"
        },
        /*::[*/ 0x0015: {
            n: "NACELL"
        },
        /*::[*/ 0x0016: {
            n: "LABEL16",
            f: parse_LABEL_16
        },
        /*::[*/ 0x0017: {
            n: "NUMBER17",
            f: parse_NUMBER_17
        },
        /*::[*/ 0x0018: {
            n: "NUMBER18",
            f: parse_NUMBER_18
        },
        /*::[*/ 0x0019: {
            n: "FORMULA19",
            f: parse_FORMULA_19
        },
        /*::[*/ 0x001A: {
            n: "FORMULA1A"
        },
        /*::[*/ 0x001B: {
            n: "XFORMAT",
            f: parse_XFORMAT
        },
        /*::[*/ 0x001C: {
            n: "DTLABELMISC"
        },
        /*::[*/ 0x001D: {
            n: "DTLABELCELL"
        },
        /*::[*/ 0x001E: {
            n: "GRAPHWINDOW"
        },
        /*::[*/ 0x001F: {
            n: "CPA"
        },
        /*::[*/ 0x0020: {
            n: "LPLAUTO"
        },
        /*::[*/ 0x0021: {
            n: "QUERY"
        },
        /*::[*/ 0x0022: {
            n: "HIDDENSHEET"
        },
        /*::[*/ 0x0023: {
            n: "??"
        },
        /*::[*/ 0x0025: {
            n: "NUMBER25",
            f: parse_NUMBER_25
        },
        /*::[*/ 0x0026: {
            n: "??"
        },
        /*::[*/ 0x0027: {
            n: "NUMBER27",
            f: parse_NUMBER_27
        },
        /*::[*/ 0x0028: {
            n: "FORMULA28",
            f: parse_FORMULA_28
        },
        /*::[*/ 0x008E: {
            n: "??"
        },
        /*::[*/ 0x0093: {
            n: "??"
        },
        /*::[*/ 0x0096: {
            n: "??"
        },
        /*::[*/ 0x0097: {
            n: "??"
        },
        /*::[*/ 0x0098: {
            n: "??"
        },
        /*::[*/ 0x0099: {
            n: "??"
        },
        /*::[*/ 0x009A: {
            n: "??"
        },
        /*::[*/ 0x009B: {
            n: "??"
        },
        /*::[*/ 0x009C: {
            n: "??"
        },
        /*::[*/ 0x00A3: {
            n: "??"
        },
        /*::[*/ 0x00AE: {
            n: "??"
        },
        /*::[*/ 0x00AF: {
            n: "??"
        },
        /*::[*/ 0x00B0: {
            n: "??"
        },
        /*::[*/ 0x00B1: {
            n: "??"
        },
        /*::[*/ 0x00B8: {
            n: "??"
        },
        /*::[*/ 0x00B9: {
            n: "??"
        },
        /*::[*/ 0x00BA: {
            n: "??"
        },
        /*::[*/ 0x00BB: {
            n: "??"
        },
        /*::[*/ 0x00BC: {
            n: "??"
        },
        /*::[*/ 0x00C3: {
            n: "??"
        },
        /*::[*/ 0x00C9: {
            n: "??"
        },
        /*::[*/ 0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        /*::[*/ 0x00CD: {
            n: "??"
        },
        /*::[*/ 0x00CE: {
            n: "??"
        },
        /*::[*/ 0x00CF: {
            n: "??"
        },
        /*::[*/ 0x00D0: {
            n: "??"
        },
        /*::[*/ 0x0100: {
            n: "??"
        },
        /*::[*/ 0x0103: {
            n: "??"
        },
        /*::[*/ 0x0104: {
            n: "??"
        },
        /*::[*/ 0x0105: {
            n: "??"
        },
        /*::[*/ 0x0106: {
            n: "??"
        },
        /*::[*/ 0x0107: {
            n: "??"
        },
        /*::[*/ 0x0109: {
            n: "??"
        },
        /*::[*/ 0x010A: {
            n: "??"
        },
        /*::[*/ 0x010B: {
            n: "??"
        },
        /*::[*/ 0x010C: {
            n: "??"
        },
        /*::[*/ 0x010E: {
            n: "??"
        },
        /*::[*/ 0x010F: {
            n: "??"
        },
        /*::[*/ 0x0180: {
            n: "??"
        },
        /*::[*/ 0x0185: {
            n: "??"
        },
        /*::[*/ 0x0186: {
            n: "??"
        },
        /*::[*/ 0x0189: {
            n: "??"
        },
        /*::[*/ 0x018C: {
            n: "??"
        },
        /*::[*/ 0x0200: {
            n: "??"
        },
        /*::[*/ 0x0202: {
            n: "??"
        },
        /*::[*/ 0x0201: {
            n: "??"
        },
        /*::[*/ 0x0204: {
            n: "??"
        },
        /*::[*/ 0x0205: {
            n: "??"
        },
        /*::[*/ 0x0280: {
            n: "??"
        },
        /*::[*/ 0x0281: {
            n: "??"
        },
        /*::[*/ 0x0282: {
            n: "??"
        },
        /*::[*/ 0x0283: {
            n: "??"
        },
        /*::[*/ 0x0284: {
            n: "??"
        },
        /*::[*/ 0x0285: {
            n: "??"
        },
        /*::[*/ 0x0286: {
            n: "??"
        },
        /*::[*/ 0x0287: {
            n: "??"
        },
        /*::[*/ 0x0288: {
            n: "??"
        },
        /*::[*/ 0x0292: {
            n: "??"
        },
        /*::[*/ 0x0293: {
            n: "??"
        },
        /*::[*/ 0x0294: {
            n: "??"
        },
        /*::[*/ 0x0295: {
            n: "??"
        },
        /*::[*/ 0x0296: {
            n: "??"
        },
        /*::[*/ 0x0299: {
            n: "??"
        },
        /*::[*/ 0x029A: {
            n: "??"
        },
        /*::[*/ 0x0300: {
            n: "??"
        },
        /*::[*/ 0x0304: {
            n: "??"
        },
        /*::[*/ 0x0601: {
            n: "SHEETINFOQP",
            f: parse_SHEETINFOQP
        },
        /*::[*/ 0x0640: {
            n: "??"
        },
        /*::[*/ 0x0642: {
            n: "??"
        },
        /*::[*/ 0x0701: {
            n: "??"
        },
        /*::[*/ 0x0702: {
            n: "??"
        },
        /*::[*/ 0x0703: {
            n: "??"
        },
        /*::[*/ 0x0704: {
            n: "??"
        },
        /*::[*/ 0x0780: {
            n: "??"
        },
        /*::[*/ 0x0800: {
            n: "??"
        },
        /*::[*/ 0x0801: {
            n: "??"
        },
        /*::[*/ 0x0804: {
            n: "??"
        },
        /*::[*/ 0x0A80: {
            n: "??"
        },
        /*::[*/ 0x2AF6: {
            n: "??"
        },
        /*::[*/ 0x3231: {
            n: "??"
        },
        /*::[*/ 0x6E49: {
            n: "??"
        },
        /*::[*/ 0x6F44: {
            n: "??"
        },
        /*::[*/ 0xFFFF: {
            n: ""
        }
    };
    return {
        sheet_to_wk1: sheet_to_wk1,
        book_to_wk3: book_to_wk3,
        to_workbook: lotus_to_workbook
    };
}();
/* 18.4.7 rPr CT_RPrElt */ function $7c3b72a365cc0275$var$parse_rpr(rpr) {
    var font = {}, m = rpr.match($7c3b72a365cc0275$var$tagregex), i = 0;
    var pass = false;
    if (m) for(; i != m.length; ++i){
        var y = $7c3b72a365cc0275$var$parsexmltag(m[i]);
        switch(y[0].replace(/\w*:/g, "")){
            /* 18.8.12 condense CT_BooleanProperty */ /* ** not required . */ case '<condense':
                break;
            /* 18.8.17 extend CT_BooleanProperty */ /* ** not required . */ case '<extend':
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ /* ** not required . */ case '<shadow':
                if (!y.val) break;
            /* falls through */ case '<shadow>':
            case '<shadow/>':
                font.shadow = 1;
                break;
            case '</shadow>':
                break;
            /* 18.4.1 charset CT_IntProperty TODO */ case '<charset':
                if (y.val == '1') break;
                font.cp = $7c3b72a365cc0275$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.4.2 outline CT_BooleanProperty TODO */ case '<outline':
                if (!y.val) break;
            /* falls through */ case '<outline>':
            case '<outline/>':
                font.outline = 1;
                break;
            case '</outline>':
                break;
            /* 18.4.5 rFont CT_FontName */ case '<rFont':
                font.name = y.val;
                break;
            /* 18.4.11 sz CT_FontSize */ case '<sz':
                font.sz = y.val;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                if (!y.val) break;
            /* falls through */ case '<strike>':
            case '<strike/>':
                font.strike = 1;
                break;
            case '</strike>':
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                if (!y.val) break;
                switch(y.val){
                    case 'double':
                        font.uval = "double";
                        break;
                    case 'singleAccounting':
                        font.uval = "single-accounting";
                        break;
                    case 'doubleAccounting':
                        font.uval = "double-accounting";
                        break;
                }
            /* falls through */ case '<u>':
            case '<u/>':
                font.u = 1;
                break;
            case '</u>':
                break;
            /* 18.8.2 b */ case '<b':
                if (y.val == '0') break;
            /* falls through */ case '<b>':
            case '<b/>':
                font.b = 1;
                break;
            case '</b>':
                break;
            /* 18.8.26 i */ case '<i':
                if (y.val == '0') break;
            /* falls through */ case '<i>':
            case '<i/>':
                font.i = 1;
                break;
            case '</i>':
                break;
            /* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */ case '<color':
                if (y.rgb) font.color = y.rgb.slice(2, 8);
                break;
            case '<color>':
            case '<color/>':
            case '</color>':
                break;
            /* 18.8.18 family ST_FontFamily */ case '<family':
                font.family = y.val;
                break;
            case '<family>':
            case '<family/>':
            case '</family>':
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */ case '<vertAlign':
                font.valign = y.val;
                break;
            case '<vertAlign>':
            case '<vertAlign/>':
            case '</vertAlign>':
                break;
            /* 18.8.35 scheme CT_FontScheme TODO */ case '<scheme':
                break;
            case '<scheme>':
            case '<scheme/>':
            case '</scheme>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
        }
    }
    return font;
}
var $7c3b72a365cc0275$var$parse_rs = /*#__PURE__*/ function() {
    var tregex = $7c3b72a365cc0275$var$matchtag("t"), rpregex = $7c3b72a365cc0275$var$matchtag("rPr");
    /* 18.4.4 r CT_RElt */ function parse_r(r) {
        /* 18.4.12 t ST_Xstring */ var t = r.match(tregex) /*, cp = 65001*/ ;
        if (!t) return {
            t: "s",
            v: ""
        };
        var o /*:Cell*/  = {
            t: 's',
            v: $7c3b72a365cc0275$var$unescapexml(t[1])
        } /*:any*/ ;
        var rpr = r.match(rpregex);
        if (rpr) o.s = $7c3b72a365cc0275$var$parse_rpr(rpr[1]);
        return o;
    }
    var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
    return function parse_rs(rs) {
        return rs.replace(rregex, "").split(rend).map(parse_r).filter(function(r) {
            return r.v;
        });
    };
}();
/* Parse a list of <r> tags */ var $7c3b72a365cc0275$var$rs_to_html = /*#__PURE__*/ function parse_rs_factory() {
    var nlregex = /(\r\n|\n)/g;
    function parse_rpr2(font, intro, outro) {
        var style /*:Array<string>*/  = [];
        if (font.u) style.push("text-decoration: underline;");
        if (font.uval) style.push("text-underline-style:" + font.uval + ";");
        if (font.sz) style.push("font-size:" + font.sz + "pt;");
        if (font.outline) style.push("text-effect: outline;");
        if (font.shadow) style.push("text-shadow: auto;");
        intro.push('<span style="' + style.join("") + '">');
        if (font.b) {
            intro.push("<b>");
            outro.push("</b>");
        }
        if (font.i) {
            intro.push("<i>");
            outro.push("</i>");
        }
        if (font.strike) {
            intro.push("<s>");
            outro.push("</s>");
        }
        var align = font.valign || "";
        if (align == "superscript" || align == "super") align = "sup";
        else if (align == "subscript") align = "sub";
        if (align != "") {
            intro.push("<" + align + ">");
            outro.push("</" + align + ">");
        }
        outro.push("</span>");
        return font;
    }
    /* 18.4.4 r CT_RElt */ function r_to_html(r) {
        var terms /*:[Array<string>, string, Array<string>]*/  = [
            [],
            r.v,
            []
        ];
        if (!r.v) return "";
        if (r.s) parse_rpr2(r.s, terms[0], terms[2]);
        return terms[0].join("") + terms[1].replace(nlregex, '<br/>') + terms[2].join("");
    }
    return function parse_rs(rs) {
        return rs.map(r_to_html).join("");
    };
}();
/* 18.4.8 si CT_Rst */ var $7c3b72a365cc0275$var$sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, $7c3b72a365cc0275$var$sirregex = /<(?:\w+:)?r>/;
var $7c3b72a365cc0275$var$sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function $7c3b72a365cc0275$var$parse_si(x, opts) {
    var html = opts ? opts.cellHTML : true;
    var z = {};
    if (!x) return {
        t: ""
    };
    //var y;
    /* 18.4.12 t ST_Xstring (Plaintext String) */ // TODO: is whitespace actually valid here?
    if (x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
        z.t = $7c3b72a365cc0275$var$unescapexml($7c3b72a365cc0275$var$utf8read(x.slice(x.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || ""));
        z.r = $7c3b72a365cc0275$var$utf8read(x);
        if (html) z.h = $7c3b72a365cc0275$var$escapehtml(z.t);
    } else if (/*y = */ x.match($7c3b72a365cc0275$var$sirregex)) {
        z.r = $7c3b72a365cc0275$var$utf8read(x);
        z.t = $7c3b72a365cc0275$var$unescapexml($7c3b72a365cc0275$var$utf8read((x.replace($7c3b72a365cc0275$var$sirphregex, '').match($7c3b72a365cc0275$var$sitregex) || []).join("").replace($7c3b72a365cc0275$var$tagregex, "")));
        if (html) z.h = $7c3b72a365cc0275$var$rs_to_html($7c3b72a365cc0275$var$parse_rs(z.r));
    }
    /* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */ /* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */ return z;
}
/* 18.4 Shared String Table */ var $7c3b72a365cc0275$var$sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
var $7c3b72a365cc0275$var$sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var $7c3b72a365cc0275$var$sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function $7c3b72a365cc0275$var$parse_sst_xml(data /*:string*/ , opts) /*:SST*/ {
    var s /*:SST*/  = [], ss = "";
    if (!data) return s;
    /* 18.4.9 sst CT_Sst */ var sst = data.match($7c3b72a365cc0275$var$sstr0);
    if (sst) {
        ss = sst[2].replace($7c3b72a365cc0275$var$sstr1, "").split($7c3b72a365cc0275$var$sstr2);
        for(var i = 0; i != ss.length; ++i){
            var o = $7c3b72a365cc0275$var$parse_si(ss[i].trim(), opts);
            if (o != null) s[s.length] = o;
        }
        sst = $7c3b72a365cc0275$var$parsexmltag(sst[1]);
        s.Count = sst.count;
        s.Unique = sst.uniqueCount;
    }
    return s;
}
var $7c3b72a365cc0275$var$straywsregex = /^\s|\s$|[\t\n\r]/;
function $7c3b72a365cc0275$var$write_sst_xml(sst /*:SST*/ , opts) /*:string*/ {
    if (!opts.bookSST) return "";
    var o = [
        $7c3b72a365cc0275$var$XML_HEADER
    ];
    o[o.length] = $7c3b72a365cc0275$var$writextag('sst', null, {
        xmlns: $7c3b72a365cc0275$var$XMLNS_main[0],
        count: sst.Count,
        uniqueCount: sst.Unique
    });
    for(var i = 0; i != sst.length; ++i){
        if (sst[i] == null) continue;
        var s /*:XLString*/  = sst[i];
        var sitag = "<si>";
        if (s.r) sitag += s.r;
        else {
            sitag += "<t";
            if (!s.t) s.t = "";
            if (s.t.match($7c3b72a365cc0275$var$straywsregex)) sitag += ' xml:space="preserve"';
            sitag += ">" + $7c3b72a365cc0275$var$escapexml(s.t) + "</t>";
        }
        sitag += "</si>";
        o[o.length] = sitag;
    }
    if (o.length > 2) {
        o[o.length] = '</sst>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */ function $7c3b72a365cc0275$var$parse_BrtBeginSst(data) {
    return [
        data.read_shift(4),
        data.read_shift(4)
    ];
}
/* [MS-XLSB] 2.1.7.45 Shared Strings */ function $7c3b72a365cc0275$var$parse_sst_bin(data, opts) /*:SST*/ {
    var s /*:SST*/  = [];
    var pass = false;
    $7c3b72a365cc0275$var$recordhopper(data, function hopper_sst(val, R, RT) {
        switch(RT){
            case 0x009F:
                /* BrtBeginSst */ s.Count = val[0];
                s.Unique = val[1];
                break;
            case 0x0013:
                /* BrtSSTItem */ s.push(val);
                break;
            case 0x00A0:
                /* BrtEndSst */ return true;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            default:
                R.T;
                if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return s;
}
function $7c3b72a365cc0275$var$write_BrtBeginSst(sst, o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(8);
    o.write_shift(4, sst.Count);
    o.write_shift(4, sst.Unique);
    return o;
}
var $7c3b72a365cc0275$var$write_BrtSSTItem = $7c3b72a365cc0275$var$write_RichStr;
function $7c3b72a365cc0275$var$write_sst_bin(sst /*::, opts*/ ) {
    var ba = $7c3b72a365cc0275$var$buf_array();
    $7c3b72a365cc0275$var$write_record(ba, 0x009F /* BrtBeginSst */ , $7c3b72a365cc0275$var$write_BrtBeginSst(sst));
    for(var i = 0; i < sst.length; ++i)$7c3b72a365cc0275$var$write_record(ba, 0x0013 /* BrtSSTItem */ , $7c3b72a365cc0275$var$write_BrtSSTItem(sst[i]));
    /* FRTSST */ $7c3b72a365cc0275$var$write_record(ba, 0x00A0 /* BrtEndSst */ );
    return ba.end();
}
function $7c3b72a365cc0275$var$_JS2ANSI(str /*:string*/ ) /*:Array<number>*/ {
    if (typeof $7c3b72a365cc0275$var$$cptable !== 'undefined') return $7c3b72a365cc0275$var$$cptable.utils.encode($7c3b72a365cc0275$var$current_ansi, str);
    var o /*:Array<number>*/  = [], oo = str.split("");
    for(var i = 0; i < oo.length; ++i)o[i] = oo[i].charCodeAt(0);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.4 Version */ function $7c3b72a365cc0275$var$parse_CRYPTOVersion(blob, length /*:?number*/ ) {
    var o /*:any*/  = {};
    o.Major = blob.read_shift(2);
    o.Minor = blob.read_shift(2);
    /*:: if(length == null) return o; */ if (length >= 4) blob.l += length - 4;
    return o;
}
/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */ function $7c3b72a365cc0275$var$parse_DataSpaceVersionInfo(blob) {
    var o = {};
    o.id = blob.read_shift(0, 'lpp4');
    o.R = $7c3b72a365cc0275$var$parse_CRYPTOVersion(blob, 4);
    o.U = $7c3b72a365cc0275$var$parse_CRYPTOVersion(blob, 4);
    o.W = $7c3b72a365cc0275$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */ function $7c3b72a365cc0275$var$parse_DataSpaceMapEntry(blob) {
    var len = blob.read_shift(4);
    var end = blob.l + len - 4;
    var o = {};
    var cnt = blob.read_shift(4);
    var comps /*:Array<{t:number, v:string}>*/  = [];
    /* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */ while(cnt-- > 0)comps.push({
        t: blob.read_shift(4),
        v: blob.read_shift(0, 'lpp4')
    });
    o.name = blob.read_shift(0, 'lpp4');
    o.comps = comps;
    if (blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */ function $7c3b72a365cc0275$var$parse_DataSpaceMap(blob) {
    var o = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push($7c3b72a365cc0275$var$parse_DataSpaceMapEntry(blob));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */ function $7c3b72a365cc0275$var$parse_DataSpaceDefinition(blob) /*:Array<string>*/ {
    var o /*:Array<string>*/  = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push(blob.read_shift(0, 'lpp4'));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */ function $7c3b72a365cc0275$var$parse_TransformInfoHeader(blob) {
    var o = {};
    /*var len = */ blob.read_shift(4);
    blob.l += 4; // must be 0x1
    o.id = blob.read_shift(0, 'lpp4');
    o.name = blob.read_shift(0, 'lpp4');
    o.R = $7c3b72a365cc0275$var$parse_CRYPTOVersion(blob, 4);
    o.U = $7c3b72a365cc0275$var$parse_CRYPTOVersion(blob, 4);
    o.W = $7c3b72a365cc0275$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
function $7c3b72a365cc0275$var$parse_Primary(blob) {
    /* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */ var hdr = $7c3b72a365cc0275$var$parse_TransformInfoHeader(blob);
    /* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */ hdr.ename = blob.read_shift(0, '8lpp4');
    hdr.blksz = blob.read_shift(4);
    hdr.cmode = blob.read_shift(4);
    if (blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
    return hdr;
}
/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */ function $7c3b72a365cc0275$var$parse_EncryptionHeader(blob, length /*:number*/ ) {
    var tgt = blob.l + length;
    var o = {};
    o.Flags = blob.read_shift(4) & 0x3F;
    blob.l += 4;
    o.AlgID = blob.read_shift(4);
    var valid = false;
    switch(o.AlgID){
        case 0x660E:
        case 0x660F:
        case 0x6610:
            valid = o.Flags == 0x24;
            break;
        case 0x6801:
            valid = o.Flags == 0x04;
            break;
        case 0:
            valid = o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24;
            break;
        default:
            throw 'Unrecognized encryption algorithm: ' + o.AlgID;
    }
    if (!valid) throw new Error("Encryption Flags/AlgID mismatch");
    o.AlgIDHash = blob.read_shift(4);
    o.KeySize = blob.read_shift(4);
    o.ProviderType = blob.read_shift(4);
    blob.l += 8;
    o.CSPName = blob.read_shift(tgt - blob.l >> 1, 'utf16le');
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */ function $7c3b72a365cc0275$var$parse_EncryptionVerifier(blob, length /*:number*/ ) {
    var o = {}, tgt = blob.l + length;
    blob.l += 4; // SaltSize must be 0x10
    o.Salt = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    o.Verifier = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    /*var sz = */ blob.read_shift(4);
    o.VerifierHash = blob.slice(blob.l, tgt);
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */ function $7c3b72a365cc0275$var$parse_EncryptionInfo(blob) {
    var vers = $7c3b72a365cc0275$var$parse_CRYPTOVersion(blob);
    switch(vers.Minor){
        case 0x02:
            return [
                vers.Minor,
                $7c3b72a365cc0275$var$parse_EncInfoStd(blob, vers)
            ];
        case 0x03:
            return [
                vers.Minor,
                $7c3b72a365cc0275$var$parse_EncInfoExt(blob, vers)
            ];
        case 0x04:
            return [
                vers.Minor,
                $7c3b72a365cc0275$var$parse_EncInfoAgl(blob, vers)
            ];
    }
    throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}
/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */ function $7c3b72a365cc0275$var$parse_EncInfoStd(blob /*::, vers*/ ) {
    var flags = blob.read_shift(4);
    if ((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
    var sz = blob.read_shift(4);
    //var tgt = blob.l + sz;
    var hdr = $7c3b72a365cc0275$var$parse_EncryptionHeader(blob, sz);
    var verifier = $7c3b72a365cc0275$var$parse_EncryptionVerifier(blob, blob.length - blob.l);
    return {
        t: "Std",
        h: hdr,
        v: verifier
    };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */ function $7c3b72a365cc0275$var$parse_EncInfoExt() {
    throw new Error("File is password-protected: ECMA-376 Extensible");
}
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */ function $7c3b72a365cc0275$var$parse_EncInfoAgl(blob /*::, vers*/ ) {
    var KeyData = [
        "saltSize",
        "blockSize",
        "keyBits",
        "hashSize",
        "cipherAlgorithm",
        "cipherChaining",
        "hashAlgorithm",
        "saltValue"
    ];
    blob.l += 4;
    var xml = blob.read_shift(blob.length - blob.l, 'utf8');
    var o = {};
    xml.replace($7c3b72a365cc0275$var$tagregex, function xml_agile(x) {
        var y /*:any*/  = $7c3b72a365cc0275$var$parsexmltag(x);
        switch($7c3b72a365cc0275$var$strip_ns(y[0])){
            case '<?xml':
                break;
            case '<encryption':
            case '</encryption>':
                break;
            case '<keyData':
                KeyData.forEach(function(k) {
                    o[k] = y[k];
                });
                break;
            case '<dataIntegrity':
                o.encryptedHmacKey = y.encryptedHmacKey;
                o.encryptedHmacValue = y.encryptedHmacValue;
                break;
            case '<keyEncryptors>':
            case '<keyEncryptors':
                o.encs = [];
                break;
            case '</keyEncryptors>':
                break;
            case '<keyEncryptor':
                o.uri = y.uri;
                break;
            case '</keyEncryptor>':
                break;
            case '<encryptedKey':
                o.encs.push(y);
                break;
            default:
                throw y[0];
        }
    });
    return o;
}
/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */ function $7c3b72a365cc0275$var$parse_RC4CryptoHeader(blob, length /*:number*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $7c3b72a365cc0275$var$parse_CRYPTOVersion(blob, 4);
    length -= 4;
    if (vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
    if (vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
    o.Flags = blob.read_shift(4);
    length -= 4;
    var sz = blob.read_shift(4);
    length -= 4;
    o.EncryptionHeader = $7c3b72a365cc0275$var$parse_EncryptionHeader(blob, sz);
    length -= sz;
    o.EncryptionVerifier = $7c3b72a365cc0275$var$parse_EncryptionVerifier(blob, length);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */ function $7c3b72a365cc0275$var$parse_RC4Header(blob /*::, length*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $7c3b72a365cc0275$var$parse_CRYPTOVersion(blob, 4);
    if (vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
    o.Salt = blob.read_shift(16);
    o.EncryptedVerifier = blob.read_shift(16);
    o.EncryptedVerifierHash = blob.read_shift(16);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */ function $7c3b72a365cc0275$var$crypto_CreatePasswordVerifier_Method1(Password /*:string*/ ) {
    var Verifier = 0x0000, PasswordArray;
    var PasswordDecoded = $7c3b72a365cc0275$var$_JS2ANSI(Password);
    var len = PasswordDecoded.length + 1, i, PasswordByte;
    var Intermediate1, Intermediate2, Intermediate3;
    PasswordArray = $7c3b72a365cc0275$var$new_raw_buf(len);
    PasswordArray[0] = PasswordDecoded.length;
    for(i = 1; i != len; ++i)PasswordArray[i] = PasswordDecoded[i - 1];
    for(i = len - 1; i >= 0; --i){
        PasswordByte = PasswordArray[i];
        Intermediate1 = (Verifier & 0x4000) === 0x0000 ? 0 : 1;
        Intermediate2 = Verifier << 1 & 0x7FFF;
        Intermediate3 = Intermediate1 | Intermediate2;
        Verifier = Intermediate3 ^ PasswordByte;
    }
    return Verifier ^ 0xCE4B;
}
/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */ var $7c3b72a365cc0275$var$crypto_CreateXorArray_Method1 = /*#__PURE__*/ function() {
    var PadArray = [
        0xBB,
        0xFF,
        0xFF,
        0xBA,
        0xFF,
        0xFF,
        0xB9,
        0x80,
        0x00,
        0xBE,
        0x0F,
        0x00,
        0xBF,
        0x0F,
        0x00
    ];
    var InitialCode = [
        0xE1F0,
        0x1D0F,
        0xCC9C,
        0x84C0,
        0x110C,
        0x0E10,
        0xF1CE,
        0x313E,
        0x1872,
        0xE139,
        0xD40F,
        0x84F9,
        0x280C,
        0xA96A,
        0x4EC3
    ];
    var XorMatrix = [
        0xAEFC,
        0x4DD9,
        0x9BB2,
        0x2745,
        0x4E8A,
        0x9D14,
        0x2A09,
        0x7B61,
        0xF6C2,
        0xFDA5,
        0xEB6B,
        0xC6F7,
        0x9DCF,
        0x2BBF,
        0x4563,
        0x8AC6,
        0x05AD,
        0x0B5A,
        0x16B4,
        0x2D68,
        0x5AD0,
        0x0375,
        0x06EA,
        0x0DD4,
        0x1BA8,
        0x3750,
        0x6EA0,
        0xDD40,
        0xD849,
        0xA0B3,
        0x5147,
        0xA28E,
        0x553D,
        0xAA7A,
        0x44D5,
        0x6F45,
        0xDE8A,
        0xAD35,
        0x4A4B,
        0x9496,
        0x390D,
        0x721A,
        0xEB23,
        0xC667,
        0x9CEF,
        0x29FF,
        0x53FE,
        0xA7FC,
        0x5FD9,
        0x47D3,
        0x8FA6,
        0x0F6D,
        0x1EDA,
        0x3DB4,
        0x7B68,
        0xF6D0,
        0xB861,
        0x60E3,
        0xC1C6,
        0x93AD,
        0x377B,
        0x6EF6,
        0xDDEC,
        0x45A0,
        0x8B40,
        0x06A1,
        0x0D42,
        0x1A84,
        0x3508,
        0x6A10,
        0xAA51,
        0x4483,
        0x8906,
        0x022D,
        0x045A,
        0x08B4,
        0x1168,
        0x76B4,
        0xED68,
        0xCAF1,
        0x85C3,
        0x1BA7,
        0x374E,
        0x6E9C,
        0x3730,
        0x6E60,
        0xDCC0,
        0xA9A1,
        0x4363,
        0x86C6,
        0x1DAD,
        0x3331,
        0x6662,
        0xCCC4,
        0x89A9,
        0x0373,
        0x06E6,
        0x0DCC,
        0x1021,
        0x2042,
        0x4084,
        0x8108,
        0x1231,
        0x2462,
        0x48C4
    ];
    var Ror = function(Byte) {
        return (Byte / 2 | Byte * 128) & 0xFF;
    };
    var XorRor = function(byte1, byte2) {
        return Ror(byte1 ^ byte2);
    };
    var CreateXorKey_Method1 = function(Password) {
        var XorKey = InitialCode[Password.length - 1];
        var CurrentElement = 0x68;
        for(var i = Password.length - 1; i >= 0; --i){
            var Char = Password[i];
            for(var j = 0; j != 7; ++j){
                if (Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
                Char *= 2;
                --CurrentElement;
            }
        }
        return XorKey;
    };
    return function(password /*:string*/ ) {
        var Password = $7c3b72a365cc0275$var$_JS2ANSI(password);
        var XorKey = CreateXorKey_Method1(Password);
        var Index = Password.length;
        var ObfuscationArray = $7c3b72a365cc0275$var$new_raw_buf(16);
        for(var i = 0; i != 16; ++i)ObfuscationArray[i] = 0x00;
        var Temp, PasswordLastChar, PadIndex;
        if ((Index & 1) === 1) {
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            PasswordLastChar = Password[Password.length - 1];
            ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
        }
        while(Index > 0){
            --Index;
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
        }
        Index = 15;
        PadIndex = 15 - Password.length;
        while(PadIndex > 0){
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
            --Index;
            --PadIndex;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            --PadIndex;
        }
        return ObfuscationArray;
    };
}();
/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */ var $7c3b72a365cc0275$var$crypto_DecryptData_Method1 = function(password /*:string*/ , Data, XorArrayIndex, XorArray, O) {
    /* If XorArray is set, use it; if O is not set, make changes in-place */ if (!O) O = Data;
    if (!XorArray) XorArray = $7c3b72a365cc0275$var$crypto_CreateXorArray_Method1(password);
    var Index, Value;
    for(Index = 0; Index != Data.length; ++Index){
        Value = Data[Index];
        Value ^= XorArray[XorArrayIndex];
        Value = (Value >> 5 | Value << 3) & 0xFF;
        O[Index] = Value;
        ++XorArrayIndex;
    }
    return [
        O,
        XorArrayIndex,
        XorArray
    ];
};
var $7c3b72a365cc0275$var$crypto_MakeXorDecryptor = function(password /*:string*/ ) {
    var XorArrayIndex = 0, XorArray = $7c3b72a365cc0275$var$crypto_CreateXorArray_Method1(password);
    return function(Data) {
        var O = $7c3b72a365cc0275$var$crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
        XorArrayIndex = O[1];
        return O[0];
    };
};
/* 2.5.343 */ function $7c3b72a365cc0275$var$parse_XORObfuscation(blob, length, opts, out) {
    var o = {
        key: $7c3b72a365cc0275$var$parseuint16(blob),
        verificationBytes: $7c3b72a365cc0275$var$parseuint16(blob)
    } /*:any*/ ;
    if (opts.password) o.verifier = $7c3b72a365cc0275$var$crypto_CreatePasswordVerifier_Method1(opts.password);
    out.valid = o.verificationBytes === o.verifier;
    if (out.valid) out.insitu = $7c3b72a365cc0275$var$crypto_MakeXorDecryptor(opts.password);
    return o;
}
/* 2.4.117 */ function $7c3b72a365cc0275$var$parse_FilePassHeader(blob, length /*:number*/ , oo) {
    var o = oo || {};
    o.Info = blob.read_shift(2);
    blob.l -= 2;
    if (o.Info === 1) o.Data = $7c3b72a365cc0275$var$parse_RC4Header(blob, length);
    else o.Data = $7c3b72a365cc0275$var$parse_RC4CryptoHeader(blob, length);
    return o;
}
function $7c3b72a365cc0275$var$parse_FilePass(blob, length /*:number*/ , opts) {
    var o = {
        Type: opts.biff >= 8 ? blob.read_shift(2) : 0
    } /*:any*/ ; /* wEncryptionType */ 
    if (o.Type) $7c3b72a365cc0275$var$parse_FilePassHeader(blob, length - 2, o);
    else $7c3b72a365cc0275$var$parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
    return o;
}
var $7c3b72a365cc0275$var$RTF = /*#__PURE__*/ function() {
    function rtf_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        switch(opts.type){
            case 'base64':
                return rtf_to_sheet_str($7c3b72a365cc0275$var$Base64_decode(d), opts);
            case 'binary':
                return rtf_to_sheet_str(d, opts);
            case 'buffer':
                return rtf_to_sheet_str($7c3b72a365cc0275$var$has_buf && $7c3b72a365cc0275$require$Buffer.isBuffer(d) ? d.toString('binary') : $7c3b72a365cc0275$var$a2s(d), opts);
            case 'array':
                return rtf_to_sheet_str($7c3b72a365cc0275$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    /* TODO: this is a stub */ function rtf_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        var o = opts || {};
        var ws /*:Worksheet*/  = o.dense ? [] : {} /*:any*/ ;
        var rows = str.match(/\\trowd.*?\\row\b/g);
        if (!rows.length) throw new Error("RTF missing table");
        var range /*:Range*/  = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: rows.length - 1
            }
        } /*:any*/ ;
        rows.forEach(function(rowtf, R) {
            if (Array.isArray(ws)) ws[R] = [];
            var rtfre = /\\\w+\b/g;
            var last_index = 0;
            var res;
            var C = -1;
            while(res = rtfre.exec(rowtf)){
                switch(res[0]){
                    case "\\cell":
                        var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
                        if (data[0] == " ") data = data.slice(1);
                        ++C;
                        if (data.length) {
                            // TODO: value parsing, including codepage adjustments
                            var cell = {
                                v: data,
                                t: "s"
                            };
                            if (Array.isArray(ws)) ws[R][C] = cell;
                            else ws[$7c3b72a365cc0275$var$encode_cell({
                                r: R,
                                c: C
                            })] = cell;
                        }
                        break;
                }
                last_index = rtfre.lastIndex;
            }
            if (C > range.e.c) range.e.c = C;
        });
        ws['!ref'] = $7c3b72a365cc0275$var$encode_range(range);
        return ws;
    }
    function rtf_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $7c3b72a365cc0275$var$sheet_to_workbook(rtf_to_sheet(d, opts), opts);
    }
    /* TODO: this is a stub */ function sheet_to_rtf(ws /*:Worksheet*/  /*::, opts*/ ) /*:string*/ {
        var o = [
            "{\\rtf1\\ansi"
        ];
        var r = $7c3b72a365cc0275$var$safe_decode_range(ws['!ref']), cell /*:Cell*/ ;
        var dense = Array.isArray(ws);
        for(var R = r.s.r; R <= r.e.r; ++R){
            o.push("\\trowd\\trautofit1");
            for(var C = r.s.c; C <= r.e.c; ++C)o.push("\\cellx" + (C + 1));
            o.push("\\pard\\intbl");
            for(C = r.s.c; C <= r.e.c; ++C){
                var coord = $7c3b72a365cc0275$var$encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws[R] || [])[C] : ws[coord];
                if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
                o.push(" " + (cell.w || ($7c3b72a365cc0275$var$format_cell(cell), cell.w)));
                o.push("\\cell");
            }
            o.push("\\pard\\intbl\\row");
        }
        return o.join("") + "}";
    }
    return {
        to_workbook: rtf_to_workbook,
        to_sheet: rtf_to_sheet,
        from_sheet: sheet_to_rtf
    };
}();
function $7c3b72a365cc0275$var$hex2RGB(h) {
    var o = h.slice(h[0] === "#" ? 1 : 0).slice(0, 6);
    return [
        parseInt(o.slice(0, 2), 16),
        parseInt(o.slice(2, 4), 16),
        parseInt(o.slice(4, 6), 16)
    ];
}
function $7c3b72a365cc0275$var$rgb2Hex(rgb) {
    for(var i = 0, o = 1; i != 3; ++i)o = o * 256 + (rgb[i] > 255 ? 255 : rgb[i] < 0 ? 0 : rgb[i]);
    return o.toString(16).toUpperCase().slice(1);
}
function $7c3b72a365cc0275$var$rgb2HSL(rgb) {
    var R = rgb[0] / 255, G = rgb[1] / 255, B = rgb[2] / 255;
    var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
    if (C === 0) return [
        0,
        0,
        R
    ];
    var H6 = 0, S = 0, L2 = M + m;
    S = C / (L2 > 1 ? 2 - L2 : L2);
    switch(M){
        case R:
            H6 = ((G - B) / C + 6) % 6;
            break;
        case G:
            H6 = (B - R) / C + 2;
            break;
        case B:
            H6 = (R - G) / C + 4;
            break;
    }
    return [
        H6 / 6,
        S,
        L2 / 2
    ];
}
function $7c3b72a365cc0275$var$hsl2RGB(hsl) {
    var H = hsl[0], S = hsl[1], L = hsl[2];
    var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C / 2;
    var rgb = [
        m,
        m,
        m
    ], h6 = 6 * H;
    var X;
    if (S !== 0) switch(h6 | 0){
        case 0:
        case 6:
            X = C * h6;
            rgb[0] += C;
            rgb[1] += X;
            break;
        case 1:
            X = C * (2 - h6);
            rgb[0] += X;
            rgb[1] += C;
            break;
        case 2:
            X = C * (h6 - 2);
            rgb[1] += C;
            rgb[2] += X;
            break;
        case 3:
            X = C * (4 - h6);
            rgb[1] += X;
            rgb[2] += C;
            break;
        case 4:
            X = C * (h6 - 4);
            rgb[2] += C;
            rgb[0] += X;
            break;
        case 5:
            X = C * (6 - h6);
            rgb[2] += X;
            rgb[0] += C;
            break;
    }
    for(var i = 0; i != 3; ++i)rgb[i] = Math.round(rgb[i] * 255);
    return rgb;
}
/* 18.8.3 bgColor tint algorithm */ function $7c3b72a365cc0275$var$rgb_tint(hex, tint) {
    if (tint === 0) return hex;
    var hsl = $7c3b72a365cc0275$var$rgb2HSL($7c3b72a365cc0275$var$hex2RGB(hex));
    if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
    else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
    return $7c3b72a365cc0275$var$rgb2Hex($7c3b72a365cc0275$var$hsl2RGB(hsl));
}
/* 18.3.1.13 width calculations */ /* [MS-OI29500] 2.1.595 Column Width & Formatting */ var $7c3b72a365cc0275$var$DEF_MDW = 6, $7c3b72a365cc0275$var$MAX_MDW = 15, $7c3b72a365cc0275$var$MIN_MDW = 1, $7c3b72a365cc0275$var$MDW = $7c3b72a365cc0275$var$DEF_MDW;
function $7c3b72a365cc0275$var$width2px(width) {
    return Math.floor((width + Math.round(128 / $7c3b72a365cc0275$var$MDW) / 256) * $7c3b72a365cc0275$var$MDW);
}
function $7c3b72a365cc0275$var$px2char(px) {
    return Math.floor((px - 5) / $7c3b72a365cc0275$var$MDW * 100 + 0.5) / 100;
}
function $7c3b72a365cc0275$var$char2width(chr) {
    return Math.round((chr * $7c3b72a365cc0275$var$MDW + 5) / $7c3b72a365cc0275$var$MDW * 256) / 256;
}
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function $7c3b72a365cc0275$var$cycle_width(collw) {
    return $7c3b72a365cc0275$var$char2width($7c3b72a365cc0275$var$px2char($7c3b72a365cc0275$var$width2px(collw)));
}
/* XLSX/XLSB/XLS specify width in units of MDW */ function $7c3b72a365cc0275$var$find_mdw_colw(collw) {
    var delta = Math.abs(collw - $7c3b72a365cc0275$var$cycle_width(collw)), _MDW = $7c3b72a365cc0275$var$MDW;
    if (delta > 0.005) {
        for($7c3b72a365cc0275$var$MDW = $7c3b72a365cc0275$var$MIN_MDW; $7c3b72a365cc0275$var$MDW < $7c3b72a365cc0275$var$MAX_MDW; ++$7c3b72a365cc0275$var$MDW)if (Math.abs(collw - $7c3b72a365cc0275$var$cycle_width(collw)) <= delta) {
            delta = Math.abs(collw - $7c3b72a365cc0275$var$cycle_width(collw));
            _MDW = $7c3b72a365cc0275$var$MDW;
        }
    }
    $7c3b72a365cc0275$var$MDW = _MDW;
}
/* XLML specifies width in terms of pixels */ /*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/ function $7c3b72a365cc0275$var$process_col(coll /*:ColInfo*/ ) {
    if (coll.width) {
        coll.wpx = $7c3b72a365cc0275$var$width2px(coll.width);
        coll.wch = $7c3b72a365cc0275$var$px2char(coll.wpx);
        coll.MDW = $7c3b72a365cc0275$var$MDW;
    } else if (coll.wpx) {
        coll.wch = $7c3b72a365cc0275$var$px2char(coll.wpx);
        coll.width = $7c3b72a365cc0275$var$char2width(coll.wch);
        coll.MDW = $7c3b72a365cc0275$var$MDW;
    } else if (typeof coll.wch == 'number') {
        coll.width = $7c3b72a365cc0275$var$char2width(coll.wch);
        coll.wpx = $7c3b72a365cc0275$var$width2px(coll.width);
        coll.MDW = $7c3b72a365cc0275$var$MDW;
    }
    if (coll.customWidth) delete coll.customWidth;
}
var $7c3b72a365cc0275$var$DEF_PPI = 96, $7c3b72a365cc0275$var$PPI = $7c3b72a365cc0275$var$DEF_PPI;
function $7c3b72a365cc0275$var$px2pt(px) {
    return px * 96 / $7c3b72a365cc0275$var$PPI;
}
function $7c3b72a365cc0275$var$pt2px(pt) {
    return pt * $7c3b72a365cc0275$var$PPI / 96;
}
/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */ var $7c3b72a365cc0275$var$XLMLPatternTypeMap = {
    "None": "none",
    "Solid": "solid",
    "Gray50": "mediumGray",
    "Gray75": "darkGray",
    "Gray25": "lightGray",
    "HorzStripe": "darkHorizontal",
    "VertStripe": "darkVertical",
    "ReverseDiagStripe": "darkDown",
    "DiagStripe": "darkUp",
    "DiagCross": "darkGrid",
    "ThickDiagCross": "darkTrellis",
    "ThinHorzStripe": "lightHorizontal",
    "ThinVertStripe": "lightVertical",
    "ThinReverseDiagStripe": "lightDown",
    "ThinHorzCross": "lightGrid"
};
/* 18.8.5 borders CT_Borders */ function $7c3b72a365cc0275$var$parse_borders(t, styles, themes, opts) {
    styles.Borders = [];
    var border = {};
    var pass = false;
    (t[0].match($7c3b72a365cc0275$var$tagregex) || []).forEach(function(x) {
        var y = $7c3b72a365cc0275$var$parsexmltag(x);
        switch($7c3b72a365cc0275$var$strip_ns(y[0])){
            case '<borders':
            case '<borders>':
            case '</borders>':
                break;
            /* 18.8.4 border CT_Border */ case '<border':
            case '<border>':
            case '<border/>':
                border = /*::(*/ {} /*:: :any)*/ ;
                if (y.diagonalUp) border.diagonalUp = $7c3b72a365cc0275$var$parsexmlbool(y.diagonalUp);
                if (y.diagonalDown) border.diagonalDown = $7c3b72a365cc0275$var$parsexmlbool(y.diagonalDown);
                styles.Borders.push(border);
                break;
            case '</border>':
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case '<left/>':
                break;
            case '<left':
            case '<left>':
                break;
            case '</left>':
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case '<right/>':
                break;
            case '<right':
            case '<right>':
                break;
            case '</right>':
                break;
            /* 18.8.43 top CT_BorderPr */ case '<top/>':
                break;
            case '<top':
            case '<top>':
                break;
            case '</top>':
                break;
            /* 18.8.6 bottom CT_BorderPr */ case '<bottom/>':
                break;
            case '<bottom':
            case '<bottom>':
                break;
            case '</bottom>':
                break;
            /* 18.8.13 diagonal CT_BorderPr */ case '<diagonal':
            case '<diagonal>':
            case '<diagonal/>':
                break;
            case '</diagonal>':
                break;
            /* 18.8.25 horizontal CT_BorderPr */ case '<horizontal':
            case '<horizontal>':
            case '<horizontal/>':
                break;
            case '</horizontal>':
                break;
            /* 18.8.44 vertical CT_BorderPr */ case '<vertical':
            case '<vertical>':
            case '<vertical/>':
                break;
            case '</vertical>':
                break;
            /* 18.8.37 start CT_BorderPr */ case '<start':
            case '<start>':
            case '<start/>':
                break;
            case '</start>':
                break;
            /* 18.8.16 end CT_BorderPr */ case '<end':
            case '<end>':
            case '<end/>':
                break;
            case '</end>':
                break;
            /* 18.8.? color CT_Color */ case '<color':
            case '<color>':
                break;
            case '<color/>':
            case '</color>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
                }
        }
    });
}
/* 18.8.21 fills CT_Fills */ function $7c3b72a365cc0275$var$parse_fills(t, styles, themes, opts) {
    styles.Fills = [];
    var fill = {};
    var pass = false;
    (t[0].match($7c3b72a365cc0275$var$tagregex) || []).forEach(function(x) {
        var y = $7c3b72a365cc0275$var$parsexmltag(x);
        switch($7c3b72a365cc0275$var$strip_ns(y[0])){
            case '<fills':
            case '<fills>':
            case '</fills>':
                break;
            /* 18.8.20 fill CT_Fill */ case '<fill>':
            case '<fill':
            case '<fill/>':
                fill = {};
                styles.Fills.push(fill);
                break;
            case '</fill>':
                break;
            /* 18.8.24 gradientFill CT_GradientFill */ case '<gradientFill>':
                break;
            case '<gradientFill':
            case '</gradientFill>':
                styles.Fills.push(fill);
                fill = {};
                break;
            /* 18.8.32 patternFill CT_PatternFill */ case '<patternFill':
            case '<patternFill>':
                if (y.patternType) fill.patternType = y.patternType;
                break;
            case '<patternFill/>':
            case '</patternFill>':
                break;
            /* 18.8.3 bgColor CT_Color */ case '<bgColor':
                if (!fill.bgColor) fill.bgColor = {};
                if (y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
                if (y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.bgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
                break;
            case '<bgColor/>':
            case '</bgColor>':
                break;
            /* 18.8.19 fgColor CT_Color */ case '<fgColor':
                if (!fill.fgColor) fill.fgColor = {};
                if (y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.fgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
                break;
            case '<fgColor/>':
            case '</fgColor>':
                break;
            /* 18.8.38 stop CT_GradientStop */ case '<stop':
            case '<stop/>':
                break;
            case '</stop>':
                break;
            /* 18.8.? color CT_Color */ case '<color':
            case '<color/>':
                break;
            case '</color>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
                }
        }
    });
}
/* 18.8.23 fonts CT_Fonts */ function $7c3b72a365cc0275$var$parse_fonts(t, styles, themes, opts) {
    styles.Fonts = [];
    var font = {};
    var pass = false;
    (t[0].match($7c3b72a365cc0275$var$tagregex) || []).forEach(function(x) {
        var y = $7c3b72a365cc0275$var$parsexmltag(x);
        switch($7c3b72a365cc0275$var$strip_ns(y[0])){
            case '<fonts':
            case '<fonts>':
            case '</fonts>':
                break;
            /* 18.8.22 font CT_Font */ case '<font':
            case '<font>':
                break;
            case '</font>':
            case '<font/>':
                styles.Fonts.push(font);
                font = {};
                break;
            /* 18.8.29 name CT_FontName */ case '<name':
                if (y.val) font.name = $7c3b72a365cc0275$var$utf8read(y.val);
                break;
            case '<name/>':
            case '</name>':
                break;
            /* 18.8.2  b CT_BooleanProperty */ case '<b':
                font.bold = y.val ? $7c3b72a365cc0275$var$parsexmlbool(y.val) : 1;
                break;
            case '<b/>':
                font.bold = 1;
                break;
            /* 18.8.26 i CT_BooleanProperty */ case '<i':
                font.italic = y.val ? $7c3b72a365cc0275$var$parsexmlbool(y.val) : 1;
                break;
            case '<i/>':
                font.italic = 1;
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                switch(y.val){
                    case "none":
                        font.underline = 0x00;
                        break;
                    case "single":
                        font.underline = 0x01;
                        break;
                    case "double":
                        font.underline = 0x02;
                        break;
                    case "singleAccounting":
                        font.underline = 0x21;
                        break;
                    case "doubleAccounting":
                        font.underline = 0x22;
                        break;
                }
                break;
            case '<u/>':
                font.underline = 1;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                font.strike = y.val ? $7c3b72a365cc0275$var$parsexmlbool(y.val) : 1;
                break;
            case '<strike/>':
                font.strike = 1;
                break;
            /* 18.4.2  outline CT_BooleanProperty */ case '<outline':
                font.outline = y.val ? $7c3b72a365cc0275$var$parsexmlbool(y.val) : 1;
                break;
            case '<outline/>':
                font.outline = 1;
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ case '<shadow':
                font.shadow = y.val ? $7c3b72a365cc0275$var$parsexmlbool(y.val) : 1;
                break;
            case '<shadow/>':
                font.shadow = 1;
                break;
            /* 18.8.12 condense CT_BooleanProperty */ case '<condense':
                font.condense = y.val ? $7c3b72a365cc0275$var$parsexmlbool(y.val) : 1;
                break;
            case '<condense/>':
                font.condense = 1;
                break;
            /* 18.8.17 extend CT_BooleanProperty */ case '<extend':
                font.extend = y.val ? $7c3b72a365cc0275$var$parsexmlbool(y.val) : 1;
                break;
            case '<extend/>':
                font.extend = 1;
                break;
            /* 18.4.11 sz CT_FontSize */ case '<sz':
                if (y.val) font.sz = +y.val;
                break;
            case '<sz/>':
            case '</sz>':
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty */ case '<vertAlign':
                if (y.val) font.vertAlign = y.val;
                break;
            case '<vertAlign/>':
            case '</vertAlign>':
                break;
            /* 18.8.18 family CT_FontFamily */ case '<family':
                if (y.val) font.family = parseInt(y.val, 10);
                break;
            case '<family/>':
            case '</family>':
                break;
            /* 18.8.35 scheme CT_FontScheme */ case '<scheme':
                if (y.val) font.scheme = y.val;
                break;
            case '<scheme/>':
            case '</scheme>':
                break;
            /* 18.4.1 charset CT_IntProperty */ case '<charset':
                if (y.val == '1') break;
                y.codepage = $7c3b72a365cc0275$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.?.? color CT_Color */ case '<color':
                if (!font.color) font.color = {};
                if (y.auto) font.color.auto = $7c3b72a365cc0275$var$parsexmlbool(y.auto);
                if (y.rgb) font.color.rgb = y.rgb.slice(-6);
                else if (y.indexed) {
                    font.color.index = parseInt(y.indexed, 10);
                    var icv = $7c3b72a365cc0275$var$XLSIcv[font.color.index];
                    if (font.color.index == 81) icv = $7c3b72a365cc0275$var$XLSIcv[1];
                    if (!icv) icv = $7c3b72a365cc0275$var$XLSIcv[1]; //throw new Error(x); // note: 206 is valid
                    font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
                } else if (y.theme) {
                    font.color.theme = parseInt(y.theme, 10);
                    if (y.tint) font.color.tint = parseFloat(y.tint);
                    if (y.theme && themes.themeElements && themes.themeElements.clrScheme) font.color.rgb = $7c3b72a365cc0275$var$rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
                }
                break;
            case '<color/>':
            case '</color>':
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
                }
        }
    });
}
/* 18.8.31 numFmts CT_NumFmts */ function $7c3b72a365cc0275$var$parse_numFmts(t, styles, opts) {
    styles.NumberFmt = [];
    var k /*Array<number>*/  = $7c3b72a365cc0275$var$keys($7c3b72a365cc0275$var$table_fmt);
    for(var i = 0; i < k.length; ++i)styles.NumberFmt[k[i]] = $7c3b72a365cc0275$var$table_fmt[k[i]];
    var m = t[0].match($7c3b72a365cc0275$var$tagregex);
    if (!m) return;
    for(i = 0; i < m.length; ++i){
        var y = $7c3b72a365cc0275$var$parsexmltag(m[i]);
        switch($7c3b72a365cc0275$var$strip_ns(y[0])){
            case '<numFmts':
            case '</numFmts>':
            case '<numFmts/>':
            case '<numFmts>':
                break;
            case '<numFmt':
                var f = $7c3b72a365cc0275$var$unescapexml($7c3b72a365cc0275$var$utf8read(y.formatCode)), j = parseInt(y.numFmtId, 10);
                styles.NumberFmt[j] = f;
                if (j > 0) {
                    if (j > 0x188) {
                        for(j = 0x188; j > 0x3c; --j)if (styles.NumberFmt[j] == null) break;
                        styles.NumberFmt[j] = f;
                    }
                    $7c3b72a365cc0275$var$SSF_load(f, j);
                }
                break;
            case '</numFmt>':
                break;
            default:
                if (opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
        }
    }
}
function $7c3b72a365cc0275$var$write_numFmts(NF /*:{[n:number|string]:string}*/  /*::, opts*/ ) {
    var o = [
        "<numFmts>"
    ];
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) o[o.length] = $7c3b72a365cc0275$var$writextag('numFmt', null, {
            numFmtId: i,
            formatCode: $7c3b72a365cc0275$var$escapexml(NF[i])
        });
    });
    if (o.length === 1) return "";
    o[o.length] = "</numFmts>";
    o[0] = $7c3b72a365cc0275$var$writextag('numFmts', null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8.10 cellXfs CT_CellXfs */ var $7c3b72a365cc0275$var$cellXF_uint = [
    "numFmtId",
    "fillId",
    "fontId",
    "borderId",
    "xfId"
];
var $7c3b72a365cc0275$var$cellXF_bool = [
    "applyAlignment",
    "applyBorder",
    "applyFill",
    "applyFont",
    "applyNumberFormat",
    "applyProtection",
    "pivotButton",
    "quotePrefix"
];
function $7c3b72a365cc0275$var$parse_cellXfs(t, styles, opts) {
    styles.CellXf = [];
    var xf;
    var pass = false;
    (t[0].match($7c3b72a365cc0275$var$tagregex) || []).forEach(function(x) {
        var y = $7c3b72a365cc0275$var$parsexmltag(x), i = 0;
        switch($7c3b72a365cc0275$var$strip_ns(y[0])){
            case '<cellXfs':
            case '<cellXfs>':
            case '<cellXfs/>':
            case '</cellXfs>':
                break;
            /* 18.8.45 xf CT_Xf */ case '<xf':
            case '<xf/>':
                xf = y;
                delete xf[0];
                for(i = 0; i < $7c3b72a365cc0275$var$cellXF_uint.length; ++i)if (xf[$7c3b72a365cc0275$var$cellXF_uint[i]]) xf[$7c3b72a365cc0275$var$cellXF_uint[i]] = parseInt(xf[$7c3b72a365cc0275$var$cellXF_uint[i]], 10);
                for(i = 0; i < $7c3b72a365cc0275$var$cellXF_bool.length; ++i)if (xf[$7c3b72a365cc0275$var$cellXF_bool[i]]) xf[$7c3b72a365cc0275$var$cellXF_bool[i]] = $7c3b72a365cc0275$var$parsexmlbool(xf[$7c3b72a365cc0275$var$cellXF_bool[i]]);
                if (styles.NumberFmt && xf.numFmtId > 0x188) {
                    for(i = 0x188; i > 0x3c; --i)if (styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) {
                        xf.numFmtId = i;
                        break;
                    }
                }
                styles.CellXf.push(xf);
                break;
            case '</xf>':
                break;
            /* 18.8.1 alignment CT_CellAlignment */ case '<alignment':
            case '<alignment/>':
                var alignment = {};
                if (y.vertical) alignment.vertical = y.vertical;
                if (y.horizontal) alignment.horizontal = y.horizontal;
                if (y.textRotation != null) alignment.textRotation = y.textRotation;
                if (y.indent) alignment.indent = y.indent;
                if (y.wrapText) alignment.wrapText = $7c3b72a365cc0275$var$parsexmlbool(y.wrapText);
                xf.alignment = alignment;
                break;
            case '</alignment>':
                break;
            /* 18.8.33 protection CT_CellProtection */ case '<protection':
                break;
            case '</protection>':
            case '<protection/>':
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
                }
        }
    });
}
function $7c3b72a365cc0275$var$write_cellXfs(cellXfs) /*:string*/ {
    var o /*:Array<string>*/  = [];
    o[o.length] = $7c3b72a365cc0275$var$writextag('cellXfs', null);
    cellXfs.forEach(function(c) {
        o[o.length] = $7c3b72a365cc0275$var$writextag('xf', null, c);
    });
    o[o.length] = "</cellXfs>";
    if (o.length === 2) return "";
    o[0] = $7c3b72a365cc0275$var$writextag('cellXfs', null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8 Styles CT_Stylesheet*/ var $7c3b72a365cc0275$var$parse_sty_xml = /*#__PURE__*/ function make_pstyx() {
    var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
    var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
    var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
    var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
    var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
    return function parse_sty_xml(data, themes, opts) {
        var styles = {};
        if (!data) return styles;
        data = data.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
        /* 18.8.39 styleSheet CT_Stylesheet */ var t;
        /* 18.8.31 numFmts CT_NumFmts ? */ if (t = data.match(numFmtRegex)) $7c3b72a365cc0275$var$parse_numFmts(t, styles, opts);
        /* 18.8.23 fonts CT_Fonts ? */ if (t = data.match(fontsRegex)) $7c3b72a365cc0275$var$parse_fonts(t, styles, themes, opts);
        /* 18.8.21 fills CT_Fills ? */ if (t = data.match(fillsRegex)) $7c3b72a365cc0275$var$parse_fills(t, styles, themes, opts);
        /* 18.8.5  borders CT_Borders ? */ if (t = data.match(bordersRegex)) $7c3b72a365cc0275$var$parse_borders(t, styles, themes, opts);
        /* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */ /* 18.8.8  cellStyles CT_CellStyles ? */ /* 18.8.10 cellXfs CT_CellXfs ? */ if (t = data.match(cellXfRegex)) $7c3b72a365cc0275$var$parse_cellXfs(t, styles, opts);
        /* 18.8.15 dxfs CT_Dxfs ? */ /* 18.8.42 tableStyles CT_TableStyles ? */ /* 18.8.11 colors CT_Colors ? */ /* 18.2.10 extLst CT_ExtensionList ? */ return styles;
    };
}();
function $7c3b72a365cc0275$var$write_sty_xml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o = [
        $7c3b72a365cc0275$var$XML_HEADER,
        $7c3b72a365cc0275$var$writextag('styleSheet', null, {
            'xmlns': $7c3b72a365cc0275$var$XMLNS_main[0],
            'xmlns:vt': $7c3b72a365cc0275$var$XMLNS.vt
        })
    ], w;
    if (wb.SSF && (w = $7c3b72a365cc0275$var$write_numFmts(wb.SSF)) != null) o[o.length] = w;
    o[o.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';
    o[o.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';
    o[o.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';
    o[o.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
    if (w = $7c3b72a365cc0275$var$write_cellXfs(opts.cellXfs)) o[o.length] = w;
    o[o.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';
    o[o.length] = '<dxfs count="0"/>';
    o[o.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';
    if (o.length > 2) {
        o[o.length] = '</styleSheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */ function $7c3b72a365cc0275$var$parse_BrtFmt(data, length /*:number*/ ) {
    var numFmtId = data.read_shift(2);
    var stFmtCode = $7c3b72a365cc0275$var$parse_XLWideString(data, length - 2);
    return [
        numFmtId,
        stFmtCode
    ];
}
function $7c3b72a365cc0275$var$write_BrtFmt(i /*:number*/ , f /*:string*/ , o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(6 + 4 * f.length);
    o.write_shift(2, i);
    $7c3b72a365cc0275$var$write_XLWideString(f, o);
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (o.l == null) o.l = o.length;
    return out;
}
/* [MS-XLSB] 2.4.659 BrtFont TODO */ function $7c3b72a365cc0275$var$parse_BrtFont(data, length /*:number*/ , opts) {
    var out = {} /*:any*/ ;
    out.sz = data.read_shift(2) / 20;
    var grbit = $7c3b72a365cc0275$var$parse_FontFlags(data, 2, opts);
    if (grbit.fItalic) out.italic = 1;
    if (grbit.fCondense) out.condense = 1;
    if (grbit.fExtend) out.extend = 1;
    if (grbit.fShadow) out.shadow = 1;
    if (grbit.fOutline) out.outline = 1;
    if (grbit.fStrikeout) out.strike = 1;
    var bls = data.read_shift(2);
    if (bls === 0x02BC) out.bold = 1;
    switch(data.read_shift(2)){
        /* case 0: out.vertAlign = "baseline"; break; */ case 1:
            out.vertAlign = "superscript";
            break;
        case 2:
            out.vertAlign = "subscript";
            break;
    }
    var underline = data.read_shift(1);
    if (underline != 0) out.underline = underline;
    var family = data.read_shift(1);
    if (family > 0) out.family = family;
    var bCharSet = data.read_shift(1);
    if (bCharSet > 0) out.charset = bCharSet;
    data.l++;
    out.color = $7c3b72a365cc0275$var$parse_BrtColor(data, 8);
    switch(data.read_shift(1)){
        /* case 0: out.scheme = "none": break; */ case 1:
            out.scheme = "major";
            break;
        case 2:
            out.scheme = "minor";
            break;
    }
    out.name = $7c3b72a365cc0275$var$parse_XLWideString(data, length - 21);
    return out;
}
function $7c3b72a365cc0275$var$write_BrtFont(font /*:any*/ , o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(153);
    o.write_shift(2, font.sz * 20);
    $7c3b72a365cc0275$var$write_FontFlags(font, o);
    o.write_shift(2, font.bold ? 0x02BC : 0x0190);
    var sss = 0;
    if (font.vertAlign == "superscript") sss = 1;
    else if (font.vertAlign == "subscript") sss = 2;
    o.write_shift(2, sss);
    o.write_shift(1, font.underline || 0);
    o.write_shift(1, font.family || 0);
    o.write_shift(1, font.charset || 0);
    o.write_shift(1, 0);
    $7c3b72a365cc0275$var$write_BrtColor(font.color, o);
    var scheme = 0;
    if (font.scheme == "major") scheme = 1;
    if (font.scheme == "minor") scheme = 2;
    o.write_shift(1, scheme);
    $7c3b72a365cc0275$var$write_XLWideString(font.name, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.650 BrtFill */ var $7c3b72a365cc0275$var$XLSBFillPTNames = [
    "none",
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
var $7c3b72a365cc0275$var$rev_XLSBFillPTNames /*:EvertNumType*/ ;
/* TODO: gradient fill representation */ var $7c3b72a365cc0275$var$parse_BrtFill = $7c3b72a365cc0275$var$parsenoop;
function $7c3b72a365cc0275$var$write_BrtFill(fill, o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(84);
    if (!$7c3b72a365cc0275$var$rev_XLSBFillPTNames) $7c3b72a365cc0275$var$rev_XLSBFillPTNames = $7c3b72a365cc0275$var$evert($7c3b72a365cc0275$var$XLSBFillPTNames);
    var fls /*:number*/  = $7c3b72a365cc0275$var$rev_XLSBFillPTNames[fill.patternType];
    if (fls == null) fls = 0x28;
    o.write_shift(4, fls);
    var j = 0;
    if (fls != 0x28) {
        /* TODO: custom FG Color */ $7c3b72a365cc0275$var$write_BrtColor({
            auto: 1
        }, o);
        /* TODO: custom BG Color */ $7c3b72a365cc0275$var$write_BrtColor({
            auto: 1
        }, o);
        for(; j < 12; ++j)o.write_shift(4, 0);
    } else {
        for(; j < 4; ++j)o.write_shift(4, 0);
        for(; j < 12; ++j)o.write_shift(4, 0); /* TODO */ 
    /* iGradientType */ /* xnumDegree */ /* xnumFillToLeft */ /* xnumFillToRight */ /* xnumFillToTop */ /* xnumFillToBottom */ /* cNumStop */ /* xfillGradientStop */ }
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.824 BrtXF */ function $7c3b72a365cc0275$var$parse_BrtXF(data, length /*:number*/ ) {
    var tgt = data.l + length;
    var ixfeParent = data.read_shift(2);
    var ifmt = data.read_shift(2);
    data.l = tgt;
    return {
        ixfe: ixfeParent,
        numFmtId: ifmt
    };
}
function $7c3b72a365cc0275$var$write_BrtXF(data, ixfeP, o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(16);
    o.write_shift(2, ixfeP || 0);
    o.write_shift(2, data.numFmtId || 0);
    o.write_shift(2, 0); /* iFont */ 
    o.write_shift(2, 0); /* iFill */ 
    o.write_shift(2, 0); /* ixBorder */ 
    o.write_shift(1, 0); /* trot */ 
    o.write_shift(1, 0); /* indent */ 
    var flow = 0;
    o.write_shift(1, flow); /* flags */ 
    o.write_shift(1, 0); /* flags */ 
    o.write_shift(1, 0); /* xfGrbitAtr */ 
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.5.4 Blxf TODO */ function $7c3b72a365cc0275$var$write_Blxf(data, o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(10);
    o.write_shift(1, 0); /* dg */ 
    o.write_shift(1, 0);
    o.write_shift(4, 0); /* color */ 
    o.write_shift(4, 0); /* color */ 
    return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */ var $7c3b72a365cc0275$var$parse_BrtBorder = $7c3b72a365cc0275$var$parsenoop;
function $7c3b72a365cc0275$var$write_BrtBorder(border, o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(51);
    o.write_shift(1, 0); /* diagonal */ 
    $7c3b72a365cc0275$var$write_Blxf(null, o); /* top */ 
    $7c3b72a365cc0275$var$write_Blxf(null, o); /* bottom */ 
    $7c3b72a365cc0275$var$write_Blxf(null, o); /* left */ 
    $7c3b72a365cc0275$var$write_Blxf(null, o); /* right */ 
    $7c3b72a365cc0275$var$write_Blxf(null, o); /* diag */ 
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.763 BrtStyle TODO */ function $7c3b72a365cc0275$var$write_BrtStyle(style, o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(52);
    o.write_shift(4, style.xfId);
    o.write_shift(2, 1);
    o.write_shift(1, +style.builtinId);
    o.write_shift(1, 0); /* iLevel */ 
    $7c3b72a365cc0275$var$write_XLNullableWideString(style.name || "", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */ function $7c3b72a365cc0275$var$write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
    var o = $7c3b72a365cc0275$var$new_buf(2052);
    o.write_shift(4, cnt);
    $7c3b72a365cc0275$var$write_XLNullableWideString(defTableStyle, o);
    $7c3b72a365cc0275$var$write_XLNullableWideString(defPivotStyle, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.1.7.50 Styles */ function $7c3b72a365cc0275$var$parse_sty_bin(data, themes, opts) {
    var styles = {};
    styles.NumberFmt = [];
    for(var y in $7c3b72a365cc0275$var$table_fmt)styles.NumberFmt[y] = $7c3b72a365cc0275$var$table_fmt[y];
    styles.CellXf = [];
    styles.Fonts = [];
    var state /*:Array<string>*/  = [];
    var pass = false;
    $7c3b72a365cc0275$var$recordhopper(data, function hopper_sty(val, R, RT) {
        switch(RT){
            case 0x002C:
                /* BrtFmt */ styles.NumberFmt[val[0]] = val[1];
                $7c3b72a365cc0275$var$SSF_load(val[1], val[0]);
                break;
            case 0x002B:
                /* BrtFont */ styles.Fonts.push(val);
                if (val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) val.color.rgb = $7c3b72a365cc0275$var$rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
                break;
            case 0x0401:
                break;
            case 0x002D:
                break;
            case 0x002E:
                break;
            case 0x002F:
                /* BrtXF */ if (state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */ ) styles.CellXf.push(val);
                break;
            case 0x0030:
            /* BrtStyle */ case 0x01FB:
            /* BrtDXF */ case 0x023C:
            /* BrtMRUColor */ case 0x01DB:
                break;
            case 0x0493:
            /* BrtDXF14 */ case 0x0836:
            /* BrtDXF15 */ case 0x046A:
            /* BrtSlicerStyleElement */ case 0x0200:
            /* BrtTableStyleElement */ case 0x082F:
            /* BrtTimelineStyleElement */ case 0x0C00:
                break;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            case 0x0025:
                /* BrtACBegin */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* BrtACEnd */ state.pop();
                pass = false;
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return styles;
}
function $7c3b72a365cc0275$var$write_FMTS_bin(ba, NF /*:?SSFTable*/ ) {
    if (!NF) return;
    var cnt = 0;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) ++cnt;
    });
    if (cnt == 0) return;
    $7c3b72a365cc0275$var$write_record(ba, 0x0267 /* BrtBeginFmts */ , $7c3b72a365cc0275$var$write_UInt32LE(cnt));
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $7c3b72a365cc0275$var$write_record(ba, 0x002C /* BrtFmt */ , $7c3b72a365cc0275$var$write_BrtFmt(i, NF[i]));
    });
    $7c3b72a365cc0275$var$write_record(ba, 0x0268 /* BrtEndFmts */ );
}
function $7c3b72a365cc0275$var$write_FONTS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $7c3b72a365cc0275$var$write_record(ba, 0x0263 /* BrtBeginFonts */ , $7c3b72a365cc0275$var$write_UInt32LE(cnt));
    $7c3b72a365cc0275$var$write_record(ba, 0x002B /* BrtFont */ , $7c3b72a365cc0275$var$write_BrtFont({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Calibri",
        family: 2,
        scheme: "minor"
    }));
    /* 1*65491BrtFont [ACFONTS] */ $7c3b72a365cc0275$var$write_record(ba, 0x0264 /* BrtEndFonts */ );
}
function $7c3b72a365cc0275$var$write_FILLS_bin(ba /*::, data*/ ) {
    var cnt = 2;
    if (cnt == 0) return;
    $7c3b72a365cc0275$var$write_record(ba, 0x025B /* BrtBeginFills */ , $7c3b72a365cc0275$var$write_UInt32LE(cnt));
    $7c3b72a365cc0275$var$write_record(ba, 0x002D /* BrtFill */ , $7c3b72a365cc0275$var$write_BrtFill({
        patternType: "none"
    }));
    $7c3b72a365cc0275$var$write_record(ba, 0x002D /* BrtFill */ , $7c3b72a365cc0275$var$write_BrtFill({
        patternType: "gray125"
    }));
    /* 1*65431BrtFill */ $7c3b72a365cc0275$var$write_record(ba, 0x025C /* BrtEndFills */ );
}
function $7c3b72a365cc0275$var$write_BORDERS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $7c3b72a365cc0275$var$write_record(ba, 0x0265 /* BrtBeginBorders */ , $7c3b72a365cc0275$var$write_UInt32LE(cnt));
    $7c3b72a365cc0275$var$write_record(ba, 0x002E /* BrtBorder */ , $7c3b72a365cc0275$var$write_BrtBorder({}));
    /* 1*65430BrtBorder */ $7c3b72a365cc0275$var$write_record(ba, 0x0266 /* BrtEndBorders */ );
}
function $7c3b72a365cc0275$var$write_CELLSTYLEXFS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $7c3b72a365cc0275$var$write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */ , $7c3b72a365cc0275$var$write_UInt32LE(cnt));
    $7c3b72a365cc0275$var$write_record(ba, 0x002F /* BrtXF */ , $7c3b72a365cc0275$var$write_BrtXF({
        numFmtId: 0,
        fontId: 0,
        fillId: 0,
        borderId: 0
    }, 0xFFFF));
    /* 1*65430(BrtXF *FRT) */ $7c3b72a365cc0275$var$write_record(ba, 0x0273 /* BrtEndCellStyleXFs */ );
}
function $7c3b72a365cc0275$var$write_CELLXFS_bin(ba, data) {
    $7c3b72a365cc0275$var$write_record(ba, 0x0269 /* BrtBeginCellXFs */ , $7c3b72a365cc0275$var$write_UInt32LE(data.length));
    data.forEach(function(c) {
        $7c3b72a365cc0275$var$write_record(ba, 0x002F /* BrtXF */ , $7c3b72a365cc0275$var$write_BrtXF(c, 0));
    });
    /* 1*65430(BrtXF *FRT) */ $7c3b72a365cc0275$var$write_record(ba, 0x026A /* BrtEndCellXFs */ );
}
function $7c3b72a365cc0275$var$write_STYLES_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $7c3b72a365cc0275$var$write_record(ba, 0x026B /* BrtBeginStyles */ , $7c3b72a365cc0275$var$write_UInt32LE(cnt));
    $7c3b72a365cc0275$var$write_record(ba, 0x0030 /* BrtStyle */ , $7c3b72a365cc0275$var$write_BrtStyle({
        xfId: 0,
        builtinId: 0,
        name: "Normal"
    }));
    /* 1*65430(BrtStyle *FRT) */ $7c3b72a365cc0275$var$write_record(ba, 0x026C /* BrtEndStyles */ );
}
function $7c3b72a365cc0275$var$write_DXFS_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $7c3b72a365cc0275$var$write_record(ba, 0x01F9 /* BrtBeginDXFs */ , $7c3b72a365cc0275$var$write_UInt32LE(cnt));
    /* *2147483647(BrtDXF *FRT) */ $7c3b72a365cc0275$var$write_record(ba, 0x01FA /* BrtEndDXFs */ );
}
function $7c3b72a365cc0275$var$write_TABLESTYLES_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $7c3b72a365cc0275$var$write_record(ba, 0x01FC /* BrtBeginTableStyles */ , $7c3b72a365cc0275$var$write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
    /* *TABLESTYLE */ $7c3b72a365cc0275$var$write_record(ba, 0x01FD /* BrtEndTableStyles */ );
}
function $7c3b72a365cc0275$var$write_COLORPALETTE_bin() {
    return;
/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */ }
/* [MS-XLSB] 2.1.7.50 Styles */ function $7c3b72a365cc0275$var$write_sty_bin(wb, opts) {
    var ba = $7c3b72a365cc0275$var$buf_array();
    $7c3b72a365cc0275$var$write_record(ba, 0x0116 /* BrtBeginStyleSheet */ );
    $7c3b72a365cc0275$var$write_FMTS_bin(ba, wb.SSF);
    $7c3b72a365cc0275$var$write_FONTS_bin(ba, wb);
    $7c3b72a365cc0275$var$write_FILLS_bin(ba, wb);
    $7c3b72a365cc0275$var$write_BORDERS_bin(ba, wb);
    $7c3b72a365cc0275$var$write_CELLSTYLEXFS_bin(ba, wb);
    $7c3b72a365cc0275$var$write_CELLXFS_bin(ba, opts.cellXfs);
    $7c3b72a365cc0275$var$write_STYLES_bin(ba, wb);
    $7c3b72a365cc0275$var$write_DXFS_bin(ba, wb);
    $7c3b72a365cc0275$var$write_TABLESTYLES_bin(ba, wb);
    $7c3b72a365cc0275$var$write_COLORPALETTE_bin(ba, wb);
    /* FRTSTYLESHEET*/ $7c3b72a365cc0275$var$write_record(ba, 0x0117 /* BrtEndStyleSheet */ );
    return ba.end();
}
/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */ var $7c3b72a365cc0275$var$XLSXThemeClrScheme = [
    '</a:lt1>',
    '</a:dk1>',
    '</a:lt2>',
    '</a:dk2>',
    '</a:accent1>',
    '</a:accent2>',
    '</a:accent3>',
    '</a:accent4>',
    '</a:accent5>',
    '</a:accent6>',
    '</a:hlink>',
    '</a:folHlink>'
];
/* 20.1.6.2 clrScheme CT_ColorScheme */ function $7c3b72a365cc0275$var$parse_clrScheme(t, themes, opts) {
    themes.themeElements.clrScheme = [];
    var color = {};
    (t[0].match($7c3b72a365cc0275$var$tagregex) || []).forEach(function(x) {
        var y = $7c3b72a365cc0275$var$parsexmltag(x);
        switch(y[0]){
            /* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */ case '<a:clrScheme':
            case '</a:clrScheme>':
                break;
            /* 20.1.2.3.32 srgbClr CT_SRgbColor */ case '<a:srgbClr':
                color.rgb = y.val;
                break;
            /* 20.1.2.3.33 sysClr CT_SystemColor */ case '<a:sysClr':
                color.rgb = y.lastClr;
                break;
            /* 20.1.4.1.1 accent1 (Accent 1) */ /* 20.1.4.1.2 accent2 (Accent 2) */ /* 20.1.4.1.3 accent3 (Accent 3) */ /* 20.1.4.1.4 accent4 (Accent 4) */ /* 20.1.4.1.5 accent5 (Accent 5) */ /* 20.1.4.1.6 accent6 (Accent 6) */ /* 20.1.4.1.9 dk1 (Dark 1) */ /* 20.1.4.1.10 dk2 (Dark 2) */ /* 20.1.4.1.15 folHlink (Followed Hyperlink) */ /* 20.1.4.1.19 hlink (Hyperlink) */ /* 20.1.4.1.22 lt1 (Light 1) */ /* 20.1.4.1.23 lt2 (Light 2) */ case '<a:dk1>':
            case '</a:dk1>':
            case '<a:lt1>':
            case '</a:lt1>':
            case '<a:dk2>':
            case '</a:dk2>':
            case '<a:lt2>':
            case '</a:lt2>':
            case '<a:accent1>':
            case '</a:accent1>':
            case '<a:accent2>':
            case '</a:accent2>':
            case '<a:accent3>':
            case '</a:accent3>':
            case '<a:accent4>':
            case '</a:accent4>':
            case '<a:accent5>':
            case '</a:accent5>':
            case '<a:accent6>':
            case '</a:accent6>':
            case '<a:hlink>':
            case '</a:hlink>':
            case '<a:folHlink>':
            case '</a:folHlink>':
                if (y[0].charAt(1) === '/') {
                    themes.themeElements.clrScheme[$7c3b72a365cc0275$var$XLSXThemeClrScheme.indexOf(y[0])] = color;
                    color = {};
                } else color.name = y[0].slice(3, y[0].length - 1);
                break;
            default:
                if (opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
        }
    });
}
/* 20.1.4.1.18 fontScheme CT_FontScheme */ function $7c3b72a365cc0275$var$parse_fontScheme() {}
/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */ function $7c3b72a365cc0275$var$parse_fmtScheme() {}
var $7c3b72a365cc0275$var$clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
var $7c3b72a365cc0275$var$fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
var $7c3b72a365cc0275$var$fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
/* 20.1.6.10 themeElements CT_BaseStyles */ function $7c3b72a365cc0275$var$parse_themeElements(data, themes, opts) {
    themes.themeElements = {};
    var t;
    [
        /* clrScheme CT_ColorScheme */ [
            'clrScheme',
            $7c3b72a365cc0275$var$clrsregex,
            $7c3b72a365cc0275$var$parse_clrScheme
        ],
        /* fontScheme CT_FontScheme */ [
            'fontScheme',
            $7c3b72a365cc0275$var$fntsregex,
            $7c3b72a365cc0275$var$parse_fontScheme
        ],
        /* fmtScheme CT_StyleMatrix */ [
            'fmtScheme',
            $7c3b72a365cc0275$var$fmtsregex,
            $7c3b72a365cc0275$var$parse_fmtScheme
        ]
    ].forEach(function(m) {
        if (!(t = data.match(m[1]))) throw new Error(m[0] + ' not found in themeElements');
        m[2](t, themes, opts);
    });
}
var $7c3b72a365cc0275$var$themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
/* 14.2.7 Theme Part */ function $7c3b72a365cc0275$var$parse_theme_xml(data /*:string*/ , opts) {
    /* 20.1.6.9 theme CT_OfficeStyleSheet */ if (!data || data.length === 0) data = $7c3b72a365cc0275$var$write_theme();
    var t;
    var themes = {};
    /* themeElements CT_BaseStyles */ if (!(t = data.match($7c3b72a365cc0275$var$themeltregex))) throw new Error('themeElements not found in theme');
    $7c3b72a365cc0275$var$parse_themeElements(t[0], themes, opts);
    themes.raw = data;
    return themes;
}
function $7c3b72a365cc0275$var$write_theme(Themes, opts) /*:string*/ {
    if (opts && opts.themeXLSX) return opts.themeXLSX;
    if (Themes && typeof Themes.raw == "string") return Themes.raw;
    var o = [
        $7c3b72a365cc0275$var$XML_HEADER
    ];
    o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
    o[o.length] = '<a:themeElements>';
    o[o.length] = '<a:clrScheme name="Office">';
    o[o.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
    o[o.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
    o[o.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
    o[o.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
    o[o.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
    o[o.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
    o[o.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
    o[o.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
    o[o.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
    o[o.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
    o[o.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
    o[o.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
    o[o.length] = '</a:clrScheme>';
    o[o.length] = '<a:fontScheme name="Office">';
    o[o.length] = '<a:majorFont>';
    o[o.length] = '<a:latin typeface="Cambria"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="MoolBoran"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = '</a:majorFont>';
    o[o.length] = '<a:minorFont>';
    o[o.length] = '<a:latin typeface="Calibri"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Arial"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Arial"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="DaunPenh"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Arial"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = '</a:minorFont>';
    o[o.length] = '</a:fontScheme>';
    o[o.length] = '<a:fmtScheme name="Office">';
    o[o.length] = '<a:fillStyleLst>';
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:lin ang="16200000" scaled="1"/>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:lin ang="16200000" scaled="0"/>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '</a:fillStyleLst>';
    o[o.length] = '<a:lnStyleLst>';
    o[o.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '</a:lnStyleLst>';
    o[o.length] = '<a:effectStyleLst>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
    o[o.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '</a:effectStyleLst>';
    o[o.length] = '<a:bgFillStyleLst>';
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '</a:bgFillStyleLst>';
    o[o.length] = '</a:fmtScheme>';
    o[o.length] = '</a:themeElements>';
    o[o.length] = '<a:objectDefaults>';
    o[o.length] = '<a:spDef>';
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
    o[o.length] = '</a:spDef>';
    o[o.length] = '<a:lnDef>';
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
    o[o.length] = '</a:lnDef>';
    o[o.length] = '</a:objectDefaults>';
    o[o.length] = '<a:extraClrSchemeLst/>';
    o[o.length] = '</a:theme>';
    return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */ function $7c3b72a365cc0275$var$parse_Theme(blob, length, opts) {
    var end = blob.l + length;
    var dwThemeVersion = blob.read_shift(4);
    if (dwThemeVersion === 124226) return;
    if (!opts.cellStyles) {
        blob.l = end;
        return;
    }
    var data = blob.slice(blob.l);
    blob.l = end;
    var zip;
    try {
        zip = $7c3b72a365cc0275$var$zip_read(data, {
            type: "array"
        });
    } catch (e) {
        return;
    }
    var themeXML = $7c3b72a365cc0275$var$getzipstr(zip, "theme/theme/theme1.xml", true);
    if (!themeXML) return;
    return $7c3b72a365cc0275$var$parse_theme_xml(themeXML, opts);
}
/* 2.5.49 */ function $7c3b72a365cc0275$var$parse_ColorTheme(blob /*::, length*/ ) {
    return blob.read_shift(4);
}
/* 2.5.155 */ function $7c3b72a365cc0275$var$parse_FullColorExt(blob /*::, length*/ ) {
    var o = {};
    o.xclrType = blob.read_shift(2);
    o.nTintShade = blob.read_shift(2);
    switch(o.xclrType){
        case 0:
            blob.l += 4;
            break;
        case 1:
            o.xclrValue = $7c3b72a365cc0275$var$parse_IcvXF(blob, 4);
            break;
        case 2:
            o.xclrValue = $7c3b72a365cc0275$var$parse_LongRGBA(blob, 4);
            break;
        case 3:
            o.xclrValue = $7c3b72a365cc0275$var$parse_ColorTheme(blob, 4);
            break;
        case 4:
            blob.l += 4;
            break;
    }
    blob.l += 8;
    return o;
}
/* 2.5.164 TODO: read 7 bits*/ function $7c3b72a365cc0275$var$parse_IcvXF(blob, length) {
    return $7c3b72a365cc0275$var$parsenoop(blob, length);
}
/* 2.5.280 */ function $7c3b72a365cc0275$var$parse_XFExtGradient(blob, length) {
    return $7c3b72a365cc0275$var$parsenoop(blob, length);
}
/* [MS-XLS] 2.5.108 */ function $7c3b72a365cc0275$var$parse_ExtProp(blob /*::, length*/ ) /*:Array<any>*/ {
    var extType = blob.read_shift(2);
    var cb = blob.read_shift(2) - 4;
    var o = [
        extType
    ];
    switch(extType){
        case 0x04:
        case 0x05:
        case 0x07:
        case 0x08:
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0D:
            o[1] = $7c3b72a365cc0275$var$parse_FullColorExt(blob, cb);
            break;
        case 0x06:
            o[1] = $7c3b72a365cc0275$var$parse_XFExtGradient(blob, cb);
            break;
        case 0x0E:
        case 0x0F:
            o[1] = blob.read_shift(cb === 1 ? 1 : 2);
            break;
        default:
            throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
    }
    return o;
}
/* 2.4.355 */ function $7c3b72a365cc0275$var$parse_XFExt(blob, length) {
    var end = blob.l + length;
    blob.l += 2;
    var ixfe = blob.read_shift(2);
    blob.l += 2;
    var cexts = blob.read_shift(2);
    var ext /*:AOA*/  = [];
    while(cexts-- > 0)ext.push($7c3b72a365cc0275$var$parse_ExtProp(blob, end - blob.l));
    return {
        ixfe: ixfe,
        ext: ext
    };
}
/* xf is an XF, see parse_XFExt for xfext */ function $7c3b72a365cc0275$var$update_xfext(xf, xfext) {
    xfext.forEach(function(xfe) {
        xfe[0];
    });
}
function $7c3b72a365cc0275$var$parse_BrtMdtinfo(data, length) {
    return {
        flags: data.read_shift(4),
        version: data.read_shift(4),
        name: $7c3b72a365cc0275$var$parse_XLWideString(data, length - 8)
    };
}
function $7c3b72a365cc0275$var$write_BrtMdtinfo(data) {
    var o = $7c3b72a365cc0275$var$new_buf(12 + 2 * data.name.length);
    o.write_shift(4, data.flags);
    o.write_shift(4, data.version);
    $7c3b72a365cc0275$var$write_XLWideString(data.name, o);
    return o.slice(0, o.l);
}
function $7c3b72a365cc0275$var$parse_BrtMdb(data) {
    var out = [];
    var cnt = data.read_shift(4);
    while(cnt-- > 0)out.push([
        data.read_shift(4),
        data.read_shift(4)
    ]);
    return out;
}
function $7c3b72a365cc0275$var$write_BrtMdb(mdb) {
    var o = $7c3b72a365cc0275$var$new_buf(4 + 8 * mdb.length);
    o.write_shift(4, mdb.length);
    for(var i = 0; i < mdb.length; ++i){
        o.write_shift(4, mdb[i][0]);
        o.write_shift(4, mdb[i][1]);
    }
    return o;
}
function $7c3b72a365cc0275$var$write_BrtBeginEsfmd(cnt, name) {
    var o = $7c3b72a365cc0275$var$new_buf(8 + 2 * name.length);
    o.write_shift(4, cnt);
    $7c3b72a365cc0275$var$write_XLWideString(name, o);
    return o.slice(0, o.l);
}
function $7c3b72a365cc0275$var$parse_BrtBeginEsmdb(data) {
    data.l += 4;
    return data.read_shift(4) != 0;
}
function $7c3b72a365cc0275$var$write_BrtBeginEsmdb(cnt, cm) {
    var o = $7c3b72a365cc0275$var$new_buf(8);
    o.write_shift(4, cnt);
    o.write_shift(4, cm ? 1 : 0);
    return o;
}
function $7c3b72a365cc0275$var$parse_xlmeta_bin(data, name, _opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    var opts = _opts || {};
    var state = [];
    var pass = false;
    var metatype = 2;
    $7c3b72a365cc0275$var$recordhopper(data, function(val, R, RT) {
        switch(RT){
            case 335:
                out.Types.push({
                    name: val.name
                });
                break;
            case 51:
                val.forEach(function(r) {
                    if (metatype == 1) out.Cell.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                    else if (metatype == 0) out.Value.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                });
                break;
            case 337:
                metatype = val ? 1 : 0;
                break;
            case 338:
                metatype = 2;
                break;
            case 35:
                state.push(RT);
                pass = true;
                break;
            case 36:
                state.pop();
                pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 35) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $7c3b72a365cc0275$var$write_xlmeta_bin() {
    var ba = $7c3b72a365cc0275$var$buf_array();
    $7c3b72a365cc0275$var$write_record(ba, 332);
    $7c3b72a365cc0275$var$write_record(ba, 334, $7c3b72a365cc0275$var$write_UInt32LE(1));
    $7c3b72a365cc0275$var$write_record(ba, 335, $7c3b72a365cc0275$var$write_BrtMdtinfo({
        name: "XLDAPR",
        version: 12e4,
        flags: 3496657072
    }));
    $7c3b72a365cc0275$var$write_record(ba, 336);
    $7c3b72a365cc0275$var$write_record(ba, 339, $7c3b72a365cc0275$var$write_BrtBeginEsfmd(1, "XLDAPR"));
    $7c3b72a365cc0275$var$write_record(ba, 52);
    $7c3b72a365cc0275$var$write_record(ba, 35, $7c3b72a365cc0275$var$write_UInt32LE(514));
    $7c3b72a365cc0275$var$write_record(ba, 4096, $7c3b72a365cc0275$var$write_UInt32LE(0));
    $7c3b72a365cc0275$var$write_record(ba, 4097, $7c3b72a365cc0275$var$writeuint16(1));
    $7c3b72a365cc0275$var$write_record(ba, 36);
    $7c3b72a365cc0275$var$write_record(ba, 53);
    $7c3b72a365cc0275$var$write_record(ba, 340);
    $7c3b72a365cc0275$var$write_record(ba, 337, $7c3b72a365cc0275$var$write_BrtBeginEsmdb(1, true));
    $7c3b72a365cc0275$var$write_record(ba, 51, $7c3b72a365cc0275$var$write_BrtMdb([
        [
            1,
            0
        ]
    ]));
    $7c3b72a365cc0275$var$write_record(ba, 338);
    $7c3b72a365cc0275$var$write_record(ba, 333);
    return ba.end();
}
function $7c3b72a365cc0275$var$parse_xlmeta_xml(data, name, opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    if (!data) return out;
    var pass = false;
    var metatype = 2;
    var lastmeta;
    data.replace($7c3b72a365cc0275$var$tagregex, function(x) {
        var y = $7c3b72a365cc0275$var$parsexmltag(x);
        switch($7c3b72a365cc0275$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<metadata":
            case "</metadata>":
                break;
            case "<metadataTypes":
            case "</metadataTypes>":
                break;
            case "<metadataType":
                out.Types.push({
                    name: y.name
                });
                break;
            case "</metadataType>":
                break;
            case "<futureMetadata":
                for(var j = 0; j < out.Types.length; ++j)if (out.Types[j].name == y.name) lastmeta = out.Types[j];
                break;
            case "</futureMetadata>":
                break;
            case "<bk>":
                break;
            case "</bk>":
                break;
            case "<rc":
                if (metatype == 1) out.Cell.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                else if (metatype == 0) out.Value.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                break;
            case "</rc>":
                break;
            case "<cellMetadata":
                metatype = 1;
                break;
            case "</cellMetadata>":
                metatype = 2;
                break;
            case "<valueMetadata":
                metatype = 0;
                break;
            case "</valueMetadata>":
                metatype = 2;
                break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            case "<rvb":
                if (!lastmeta) break;
                if (!lastmeta.offsets) lastmeta.offsets = [];
                lastmeta.offsets.push(+y.i);
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in metadata");
        }
        return x;
    });
    return out;
}
function $7c3b72a365cc0275$var$write_xlmeta_xml() {
    var o = [
        $7c3b72a365cc0275$var$XML_HEADER
    ];
    o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
    return o.join("");
}
/* 18.6 Calculation Chain */ function $7c3b72a365cc0275$var$parse_cc_xml(data /*::, name, opts*/ ) /*:Array<any>*/ {
    var d = [];
    if (!data) return d;
    var i = 1;
    (data.match($7c3b72a365cc0275$var$tagregex) || []).forEach(function(x) {
        var y = $7c3b72a365cc0275$var$parsexmltag(x);
        switch(y[0]){
            case '<?xml':
                break;
            /* 18.6.2  calcChain CT_CalcChain 1 */ case '<calcChain':
            case '<calcChain>':
            case '</calcChain>':
                break;
            /* 18.6.1  c CT_CalcCell 1 */ case '<c':
                delete y[0];
                if (y.i) i = y.i;
                else y.i = i;
                d.push(y);
                break;
        }
    });
    return d;
}
//function write_cc_xml(data, opts) { }
/* [MS-XLSB] 2.6.4.1 */ function $7c3b72a365cc0275$var$parse_BrtCalcChainItem$(data) {
    var out = {};
    out.i = data.read_shift(4);
    var cell = {};
    cell.r = data.read_shift(4);
    cell.c = data.read_shift(4);
    out.r = $7c3b72a365cc0275$var$encode_cell(cell);
    var flags = data.read_shift(1);
    if (flags & 0x2) out.l = '1';
    if (flags & 0x8) out.a = '1';
    return out;
}
/* 18.6 Calculation Chain */ function $7c3b72a365cc0275$var$parse_cc_bin(data, name, opts) {
    var out = [];
    var pass = false;
    $7c3b72a365cc0275$var$recordhopper(data, function hopper_cc(val, R, RT) {
        switch(RT){
            case 0x003F:
                /* 'BrtCalcChainItem$' */ out.push(val);
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */ function $7c3b72a365cc0275$var$parse_xlink_xml() {
//var opts = _opts || {};
//if(opts.WTF) throw "XLSX External Link";
}
/* [MS-XLSB] 2.1.7.25 External Link */ function $7c3b72a365cc0275$var$parse_xlink_bin(data, rel, name /*:string*/ , _opts) {
    if (!data) return data;
    var opts = _opts || {};
    var pass = false, end = false;
    $7c3b72a365cc0275$var$recordhopper(data, function xlink_parse(val, R, RT) {
        if (end) return;
        switch(RT){
            case 0x0167:
            /* 'BrtSupTabs' */ case 0x016B:
            /* 'BrtExternTableStart' */ case 0x016C:
            /* 'BrtExternTableEnd' */ case 0x016E:
            /* 'BrtExternRowHdr' */ case 0x016F:
            /* 'BrtExternCellBlank' */ case 0x0170:
            /* 'BrtExternCellReal' */ case 0x0171:
            /* 'BrtExternCellBool' */ case 0x0172:
            /* 'BrtExternCellError' */ case 0x0173:
            /* 'BrtExternCellString' */ case 0x01D8:
            /* 'BrtExternValueMeta' */ case 0x0241:
            /* 'BrtSupNameStart' */ case 0x0242:
            /* 'BrtSupNameValueStart' */ case 0x0243:
            /* 'BrtSupNameValueEnd' */ case 0x0244:
            /* 'BrtSupNameNum' */ case 0x0245:
            /* 'BrtSupNameErr' */ case 0x0246:
            /* 'BrtSupNameSt' */ case 0x0247:
            /* 'BrtSupNameNil' */ case 0x0248:
            /* 'BrtSupNameBool' */ case 0x0249:
            /* 'BrtSupNameFmla' */ case 0x024A:
            /* 'BrtSupNameBits' */ case 0x024B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
}
/* 20.5 DrawingML - SpreadsheetML Drawing */ /* 20.5.2.35 wsDr CT_Drawing */ function $7c3b72a365cc0275$var$parse_drawing(data, rels /*:any*/ ) {
    if (!data) return "??";
    /*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/ var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/) || [
        "",
        ""
    ])[1];
    return rels['!id'][id].Target;
}
/* L.5.5.2 SpreadsheetML Comments + VML Schema */ var $7c3b72a365cc0275$var$_shapeid = 1024;
function $7c3b72a365cc0275$var$write_comments_vml(rId /*:number*/ , comments) {
    var csize = [
        21600,
        21600
    ];
    /* L.5.2.1.2 Path Attribute */ var bbox = [
        "m0,0l0",
        csize[1],
        csize[0],
        csize[1],
        csize[0],
        "0xe"
    ].join(",");
    var o = [
        $7c3b72a365cc0275$var$writextag("xml", null, {
            'xmlns:v': $7c3b72a365cc0275$var$XLMLNS.v,
            'xmlns:o': $7c3b72a365cc0275$var$XLMLNS.o,
            'xmlns:x': $7c3b72a365cc0275$var$XLMLNS.x,
            'xmlns:mv': $7c3b72a365cc0275$var$XLMLNS.mv
        }).replace(/\/>/, ">"),
        $7c3b72a365cc0275$var$writextag("o:shapelayout", $7c3b72a365cc0275$var$writextag("o:idmap", null, {
            'v:ext': "edit",
            'data': rId
        }), {
            'v:ext': "edit"
        }),
        $7c3b72a365cc0275$var$writextag("v:shapetype", [
            $7c3b72a365cc0275$var$writextag("v:stroke", null, {
                joinstyle: "miter"
            }),
            $7c3b72a365cc0275$var$writextag("v:path", null, {
                gradientshapeok: "t",
                'o:connecttype': "rect"
            })
        ].join(""), {
            id: "_x0000_t202",
            'o:spt': 202,
            coordsize: csize.join(","),
            path: bbox
        })
    ];
    while($7c3b72a365cc0275$var$_shapeid < rId * 1000)$7c3b72a365cc0275$var$_shapeid += 1000;
    comments.forEach(function(x) {
        var c = $7c3b72a365cc0275$var$decode_cell(x[0]);
        var fillopts = /*::(*/ {
            'color2': "#BEFF82",
            'type': "gradient"
        } /*:: :any)*/ ;
        if (fillopts.type == "gradient") fillopts.angle = "-180";
        var fillparm = fillopts.type == "gradient" ? $7c3b72a365cc0275$var$writextag("o:fill", null, {
            type: "gradientUnscaled",
            'v:ext': "view"
        }) : null;
        var fillxml = $7c3b72a365cc0275$var$writextag('v:fill', fillparm, fillopts);
        var shadata = {
            on: "t",
            'obscured': "t"
        } /*:any*/ ;
        ++$7c3b72a365cc0275$var$_shapeid;
        o = o.concat([
            '<v:shape' + $7c3b72a365cc0275$var$wxt_helper({
                id: '_x0000_s' + $7c3b72a365cc0275$var$_shapeid,
                type: "#_x0000_t202",
                style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : ""),
                fillcolor: "#ECFAD4",
                strokecolor: "#edeaa1"
            }) + '>',
            fillxml,
            $7c3b72a365cc0275$var$writextag("v:shadow", null, shadata),
            $7c3b72a365cc0275$var$writextag("v:path", null, {
                'o:connecttype': "none"
            }),
            '<v:textbox><div style="text-align:left"></div></v:textbox>',
            '<x:ClientData ObjectType="Note">',
            '<x:MoveWithCells/>',
            '<x:SizeWithCells/>',
            /* Part 4 19.4.2.3 Anchor (Anchor) */ $7c3b72a365cc0275$var$writetag('x:Anchor', [
                c.c + 1,
                0,
                c.r + 1,
                0,
                c.c + 3,
                20,
                c.r + 5,
                20
            ].join(",")),
            $7c3b72a365cc0275$var$writetag('x:AutoFill', "False"),
            $7c3b72a365cc0275$var$writetag('x:Row', String(c.r)),
            $7c3b72a365cc0275$var$writetag('x:Column', String(c.c)),
            x[1].hidden ? '' : '<x:Visible/>',
            '</x:ClientData>',
            '</v:shape>'
        ]);
    });
    o.push('</xml>');
    return o.join("");
}
function $7c3b72a365cc0275$var$sheet_insert_comments(sheet, comments /*:Array<RawComment>*/ , threaded /*:boolean*/ , people /*:?Array<any>*/ ) {
    var dense = Array.isArray(sheet);
    var cell /*:Cell*/ ;
    comments.forEach(function(comment) {
        var r = $7c3b72a365cc0275$var$decode_cell(comment.ref);
        if (dense) {
            if (!sheet[r.r]) sheet[r.r] = [];
            cell = sheet[r.r][r.c];
        } else cell = sheet[comment.ref];
        if (!cell) {
            cell = {
                t: "z"
            } /*:any*/ ;
            if (dense) sheet[r.r][r.c] = cell;
            else sheet[comment.ref] = cell;
            var range = $7c3b72a365cc0275$var$safe_decode_range(sheet["!ref"] || "BDWGO1000001:A1");
            if (range.s.r > r.r) range.s.r = r.r;
            if (range.e.r < r.r) range.e.r = r.r;
            if (range.s.c > r.c) range.s.c = r.c;
            if (range.e.c < r.c) range.e.c = r.c;
            var encoded = $7c3b72a365cc0275$var$encode_range(range);
            if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
        }
        if (!cell.c) cell.c = [];
        var o /*:Comment*/  = {
            a: comment.author,
            t: comment.t,
            r: comment.r,
            T: threaded
        };
        if (comment.h) o.h = comment.h;
        /* threaded comments always override */ for(var i = cell.c.length - 1; i >= 0; --i){
            if (!threaded && cell.c[i].T) return;
            if (threaded && !cell.c[i].T) cell.c.splice(i, 1);
        }
        if (threaded && people) {
            for(i = 0; i < people.length; ++i)if (o.a == people[i].id) {
                o.a = people[i].name || o.a;
                break;
            }
        }
        cell.c.push(o);
    });
}
/* 18.7 Comments */ function $7c3b72a365cc0275$var$parse_comments_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    /* 18.7.6 CT_Comments */ if (data.match(/<(?:\w+:)?comments *\/>/)) return [];
    var authors /*:Array<string>*/  = [];
    var commentList /*:Array<RawComment>*/  = [];
    var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
    if (authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
        if (a) authors.push(a[1]);
    });
    var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
    if (cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
        if (!cm) return;
        var y = $7c3b72a365cc0275$var$parsexmltag(cm[0]);
        var comment /*:RawComment*/  = {
            author: y.authorId && authors[y.authorId] || "sheetjsghost",
            ref: y.ref,
            guid: y.guid
        } /*:any*/ ;
        var cell = $7c3b72a365cc0275$var$decode_cell(y.ref);
        if (opts.sheetRows && opts.sheetRows <= cell.r) return;
        var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
        var rt = !!textMatch && !!textMatch[1] && $7c3b72a365cc0275$var$parse_si(textMatch[1]) || {
            r: "",
            t: "",
            h: ""
        };
        comment.r = rt.r;
        if (rt.r == "<t></t>") rt.t = rt.h = "";
        comment.t = (rt.t || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        if (opts.cellHTML) comment.h = rt.h;
        commentList.push(comment);
    });
    return commentList;
}
function $7c3b72a365cc0275$var$write_comments_xml(data /*::, opts*/ ) {
    var o = [
        $7c3b72a365cc0275$var$XML_HEADER,
        $7c3b72a365cc0275$var$writextag('comments', null, {
            'xmlns': $7c3b72a365cc0275$var$XMLNS_main[0]
        })
    ];
    var iauthor /*:Array<string>*/  = [];
    o.push("<authors>");
    data.forEach(function(x) {
        x[1].forEach(function(w) {
            var a = $7c3b72a365cc0275$var$escapexml(w.a);
            if (iauthor.indexOf(a) == -1) {
                iauthor.push(a);
                o.push("<author>" + a + "</author>");
            }
            if (w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
                iauthor.push("tc=" + w.ID);
                o.push("<author>tc=" + w.ID + "</author>");
            }
        });
    });
    if (iauthor.length == 0) {
        iauthor.push("SheetJ5");
        o.push("<author>SheetJ5</author>");
    }
    o.push("</authors>");
    o.push("<commentList>");
    data.forEach(function(d) {
        /* 18.7.3 CT_Comment */ var lastauthor = 0, ts = [];
        if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
        else d[1].forEach(function(c) {
            if (c.a) lastauthor = iauthor.indexOf($7c3b72a365cc0275$var$escapexml(c.a));
            ts.push(c.t || "");
        });
        o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
        if (ts.length <= 1) o.push($7c3b72a365cc0275$var$writetag("t", $7c3b72a365cc0275$var$escapexml(ts[0] || "")));
        else {
            /* based on Threaded Comments -> Comments projection */ var t = "Comment:\n    " + ts[0] + "\n";
            for(var i = 1; i < ts.length; ++i)t += "Reply:\n    " + ts[i] + "\n";
            o.push($7c3b72a365cc0275$var$writetag("t", $7c3b72a365cc0275$var$escapexml(t)));
        }
        o.push('</text></comment>');
    });
    o.push("</commentList>");
    if (o.length > 2) {
        o[o.length] = '</comments>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSX] 2.1.17 */ function $7c3b72a365cc0275$var$parse_tcmnt_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    var out = [];
    var pass = false, comment = {}, tidx = 0;
    data.replace($7c3b72a365cc0275$var$tagregex, function xml_tcmnt(x, idx) {
        var y /*:any*/  = $7c3b72a365cc0275$var$parsexmltag(x);
        switch($7c3b72a365cc0275$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 2.6.207 ThreadedComments CT_ThreadedComments */ case '<ThreadedComments':
                break;
            case '</ThreadedComments>':
                break;
            /* 2.6.205 threadedComment CT_ThreadedComment */ case '<threadedComment':
                comment = {
                    author: y.personId,
                    guid: y.id,
                    ref: y.ref,
                    T: 1
                };
                break;
            case '</threadedComment>':
                if (comment.t != null) out.push(comment);
                break;
            case '<text>':
            case '<text':
                tidx = idx + x.length;
                break;
            case '</text>':
                comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                break;
            /* 2.6.206 mentions CT_ThreadedCommentMentions TODO */ case '<mentions':
            case '<mentions>':
                pass = true;
                break;
            case '</mentions>':
                pass = false;
                break;
            /* 2.6.202 mention CT_Mention TODO */ /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
        }
        return x;
    });
    return out;
}
function $7c3b72a365cc0275$var$write_tcmnt_xml(comments, people, opts) {
    var o = [
        $7c3b72a365cc0275$var$XML_HEADER,
        $7c3b72a365cc0275$var$writextag('ThreadedComments', null, {
            'xmlns': $7c3b72a365cc0275$var$XMLNS.TCMNT
        }).replace(/[\/]>/, ">")
    ];
    comments.forEach(function(carr) {
        var rootid = "";
        (carr[1] || []).forEach(function(c, idx) {
            if (!c.T) {
                delete c.ID;
                return;
            }
            if (c.a && people.indexOf(c.a) == -1) people.push(c.a);
            var tcopts = {
                ref: carr[0],
                id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
            };
            if (idx == 0) rootid = tcopts.id;
            else tcopts.parentId = rootid;
            c.ID = tcopts.id;
            if (c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
            o.push($7c3b72a365cc0275$var$writextag('threadedComment', $7c3b72a365cc0275$var$writetag('text', c.t || ""), tcopts));
        });
    });
    o.push('</ThreadedComments>');
    return o.join("");
}
/* [MS-XLSX] 2.1.18 */ function $7c3b72a365cc0275$var$parse_people_xml(data /*:string*/ , opts) {
    var out = [];
    var pass = false;
    data.replace($7c3b72a365cc0275$var$tagregex, function xml_tcmnt(x) {
        var y /*:any*/  = $7c3b72a365cc0275$var$parsexmltag(x);
        switch($7c3b72a365cc0275$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 2.4.85 personList CT_PersonList */ case '<personList':
                break;
            case '</personList>':
                break;
            /* 2.6.203 person CT_Person TODO: providers */ case '<person':
                out.push({
                    name: y.displayname,
                    id: y.id
                });
                break;
            case '</person>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
        }
        return x;
    });
    return out;
}
function $7c3b72a365cc0275$var$write_people_xml(people /*, opts*/ ) {
    var o = [
        $7c3b72a365cc0275$var$XML_HEADER,
        $7c3b72a365cc0275$var$writextag('personList', null, {
            'xmlns': $7c3b72a365cc0275$var$XMLNS.TCMNT,
            'xmlns:x': $7c3b72a365cc0275$var$XMLNS_main[0]
        }).replace(/[\/]>/, ">")
    ];
    people.forEach(function(person, idx) {
        o.push($7c3b72a365cc0275$var$writextag('person', null, {
            displayName: person,
            id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
            userId: person,
            providerId: "None"
        }));
    });
    o.push("</personList>");
    return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */ function $7c3b72a365cc0275$var$parse_BrtBeginComment(data) {
    var out = {};
    out.iauthor = data.read_shift(4);
    var rfx = $7c3b72a365cc0275$var$parse_UncheckedRfX(data, 16);
    out.rfx = rfx.s;
    out.ref = $7c3b72a365cc0275$var$encode_cell(rfx.s);
    data.l += 16; /*var guid = parse_GUID(data); */ 
    return out;
}
function $7c3b72a365cc0275$var$write_BrtBeginComment(data, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(36);
    o.write_shift(4, data[1].iauthor);
    $7c3b72a365cc0275$var$write_UncheckedRfX(data[0], o);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLSB] 2.4.327 BrtCommentAuthor */ var $7c3b72a365cc0275$var$parse_BrtCommentAuthor = $7c3b72a365cc0275$var$parse_XLWideString;
function $7c3b72a365cc0275$var$write_BrtCommentAuthor(data) {
    return $7c3b72a365cc0275$var$write_XLWideString(data.slice(0, 54));
}
/* [MS-XLSB] 2.1.7.8 Comments */ function $7c3b72a365cc0275$var$parse_comments_bin(data, opts) /*:Array<RawComment>*/ {
    var out /*:Array<RawComment>*/  = [];
    var authors /*:Array<string>*/  = [];
    var c = {};
    var pass = false;
    $7c3b72a365cc0275$var$recordhopper(data, function hopper_cmnt(val, R, RT) {
        switch(RT){
            case 0x0278:
                /* 'BrtCommentAuthor' */ authors.push(val);
                break;
            case 0x027B:
                /* 'BrtBeginComment' */ c = val;
                break;
            case 0x027D:
                /* 'BrtCommentText' */ c.t = val.t;
                c.h = val.h;
                c.r = val.r;
                break;
            case 0x027C:
                /* 'BrtEndComment' */ c.author = authors[c.iauthor];
                delete c /*:any*/ .iauthor;
                if (opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
                if (!c.t) c.t = "";
                delete c.rfx;
                out.push(c);
                break;
            case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                break;
            case 0x0026:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $7c3b72a365cc0275$var$write_comments_bin(data /*::, opts*/ ) {
    var ba = $7c3b72a365cc0275$var$buf_array();
    var iauthor /*:Array<string>*/  = [];
    $7c3b72a365cc0275$var$write_record(ba, 0x0274 /* BrtBeginComments */ );
    $7c3b72a365cc0275$var$write_record(ba, 0x0276 /* BrtBeginCommentAuthors */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            if (iauthor.indexOf(c.a) > -1) return;
            iauthor.push(c.a.slice(0, 54));
            $7c3b72a365cc0275$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $7c3b72a365cc0275$var$write_BrtCommentAuthor(c.a));
        });
    });
    $7c3b72a365cc0275$var$write_record(ba, 0x0277 /* BrtEndCommentAuthors */ );
    $7c3b72a365cc0275$var$write_record(ba, 0x0279 /* BrtBeginCommentList */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            c.iauthor = iauthor.indexOf(c.a);
            var range = {
                s: $7c3b72a365cc0275$var$decode_cell(comment[0]),
                e: $7c3b72a365cc0275$var$decode_cell(comment[0])
            };
            $7c3b72a365cc0275$var$write_record(ba, 0x027B /* BrtBeginComment */ , $7c3b72a365cc0275$var$write_BrtBeginComment([
                range,
                c
            ]));
            if (c.t && c.t.length > 0) $7c3b72a365cc0275$var$write_record(ba, 0x027D /* BrtCommentText */ , $7c3b72a365cc0275$var$write_BrtCommentText(c));
            $7c3b72a365cc0275$var$write_record(ba, 0x027C /* BrtEndComment */ );
            delete c.iauthor;
        });
    });
    $7c3b72a365cc0275$var$write_record(ba, 0x027A /* BrtEndCommentList */ );
    $7c3b72a365cc0275$var$write_record(ba, 0x0275 /* BrtEndComments */ );
    return ba.end();
}
var $7c3b72a365cc0275$var$CT_VBA = "application/vnd.ms-office.vbaProject";
function $7c3b72a365cc0275$var$make_vba_xls(cfb) {
    var newcfb = $7c3b72a365cc0275$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    cfb.FullPaths.forEach(function(p, i) {
        if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
        var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
        $7c3b72a365cc0275$export$9f0e51cd97c572a.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
    });
    return $7c3b72a365cc0275$export$9f0e51cd97c572a.write(newcfb);
}
function $7c3b72a365cc0275$var$fill_vba_xls(cfb, vba) {
    vba.FullPaths.forEach(function(p, i) {
        if (i == 0) return;
        var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
        if (newpath.slice(-1) !== "/") $7c3b72a365cc0275$export$9f0e51cd97c572a.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
    });
}
var $7c3b72a365cc0275$var$VBAFMTS = [
    "xlsb",
    "xlsm",
    "xlam",
    "biff8",
    "xla"
];
/* macro and dialog sheet stubs */ function $7c3b72a365cc0275$var$parse_ds_bin() /*:Worksheet*/ {
    return {
        '!type': 'dialog'
    };
}
function $7c3b72a365cc0275$var$parse_ds_xml() /*:Worksheet*/ {
    return {
        '!type': 'dialog'
    };
}
function $7c3b72a365cc0275$var$parse_ms_bin() /*:Worksheet*/ {
    return {
        '!type': 'macro'
    };
}
function $7c3b72a365cc0275$var$parse_ms_xml() /*:Worksheet*/ {
    return {
        '!type': 'macro'
    };
}
/* TODO: it will be useful to parse the function str */ var $7c3b72a365cc0275$var$rc_to_a1 = /*#__PURE__*/ function() {
    var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
    var rcbase /*:Cell*/  = {
        r: 0,
        c: 0
    } /*:any*/ ;
    function rcfunc($$, $1, $2, $3) {
        var cRel = false, rRel = false;
        if ($2.length == 0) rRel = true;
        else if ($2.charAt(0) == "[") {
            rRel = true;
            $2 = $2.slice(1, -1);
        }
        if ($3.length == 0) cRel = true;
        else if ($3.charAt(0) == "[") {
            cRel = true;
            $3 = $3.slice(1, -1);
        }
        var R = $2.length > 0 ? parseInt($2, 10) | 0 : 0, C = $3.length > 0 ? parseInt($3, 10) | 0 : 0;
        if (cRel) C += rcbase.c;
        else --C;
        if (rRel) R += rcbase.r;
        else --R;
        return $1 + (cRel ? "" : "$") + $7c3b72a365cc0275$var$encode_col(C) + (rRel ? "" : "$") + $7c3b72a365cc0275$var$encode_row(R);
    }
    return function rc_to_a1(fstr /*:string*/ , base /*:Cell*/ ) /*:string*/ {
        rcbase = base;
        return fstr.replace(rcregex, rcfunc);
    };
}();
var $7c3b72a365cc0275$var$crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
var $7c3b72a365cc0275$var$a1_to_rc = /*#__PURE__*/ function() {
    return function a1_to_rc(fstr /*:string*/ , base /*:CellAddress*/ ) {
        return fstr.replace($7c3b72a365cc0275$var$crefregex, function($0, $1, $2, $3, $4, $5) {
            var c = $7c3b72a365cc0275$var$decode_col($3) - ($2 ? 0 : base.c);
            var r = $7c3b72a365cc0275$var$decode_row($5) - ($4 ? 0 : base.r);
            var R = r == 0 ? "" : !$4 ? "[" + r + "]" : r + 1;
            var C = c == 0 ? "" : !$2 ? "[" + c + "]" : c + 1;
            return $1 + "R" + R + "C" + C;
        });
    };
}();
/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */ function $7c3b72a365cc0275$var$shift_formula_str(f /*:string*/ , delta /*:Cell*/ ) /*:string*/ {
    return f.replace($7c3b72a365cc0275$var$crefregex, function($0, $1, $2, $3, $4, $5) {
        return $1 + ($2 == "$" ? $2 + $3 : $7c3b72a365cc0275$var$encode_col($7c3b72a365cc0275$var$decode_col($3) + delta.c)) + ($4 == "$" ? $4 + $5 : $7c3b72a365cc0275$var$encode_row($7c3b72a365cc0275$var$decode_row($5) + delta.r));
    });
}
function $7c3b72a365cc0275$var$shift_formula_xlsx(f /*:string*/ , range /*:string*/ , cell /*:string*/ ) /*:string*/ {
    var r = $7c3b72a365cc0275$var$decode_range(range), s = r.s, c = $7c3b72a365cc0275$var$decode_cell(cell);
    var delta = {
        r: c.r - s.r,
        c: c.c - s.c
    };
    return $7c3b72a365cc0275$var$shift_formula_str(f, delta);
}
/* TODO: parse formula */ function $7c3b72a365cc0275$var$fuzzyfmla(f /*:string*/ ) /*:boolean*/ {
    if (f.length == 1) return false;
    return true;
}
function $7c3b72a365cc0275$var$_xlfn(f /*:string*/ ) /*:string*/ {
    return f.replace(/_xlfn\./g, "");
}
function $7c3b72a365cc0275$var$parseread1(blob) {
    blob.l += 1;
    return;
}
/* [MS-XLS] 2.5.51 */ function $7c3b72a365cc0275$var$parse_ColRelU(blob, length) {
    var c = blob.read_shift(length == 1 ? 1 : 2);
    return [
        c & 0x3FFF,
        c >> 14 & 1,
        c >> 15 & 1
    ];
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */ function $7c3b72a365cc0275$var$parse_RgceArea(blob, length, opts) {
    var w = 2;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return $7c3b72a365cc0275$var$parse_RgceArea_BIFF2(blob, length, opts);
        else if (opts.biff == 12) w = 4;
    }
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = $7c3b72a365cc0275$var$parse_ColRelU(blob, 2);
    var C = $7c3b72a365cc0275$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* BIFF 2-5 encodes flags in the row field */ function $7c3b72a365cc0275$var$parse_RgceArea_BIFF2(blob /*::, length, opts*/ ) {
    var r = $7c3b72a365cc0275$var$parse_ColRelU(blob, 2), R = $7c3b72a365cc0275$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    var C = blob.read_shift(1);
    return {
        s: {
            r: r[0],
            c: c,
            cRel: r[1],
            rRel: r[2]
        },
        e: {
            r: R[0],
            c: C,
            cRel: R[1],
            rRel: R[2]
        }
    };
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */ function $7c3b72a365cc0275$var$parse_RgceAreaRel(blob, length, opts) {
    if (opts.biff < 8) return $7c3b72a365cc0275$var$parse_RgceArea_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts.biff == 12 ? 4 : 2), R = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var c = $7c3b72a365cc0275$var$parse_ColRelU(blob, 2);
    var C = $7c3b72a365cc0275$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */ function $7c3b72a365cc0275$var$parse_RgceLoc(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff <= 5) return $7c3b72a365cc0275$var$parse_RgceLoc_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
    var c = $7c3b72a365cc0275$var$parse_ColRelU(blob, 2);
    return {
        r: r,
        c: c[0],
        cRel: c[1],
        rRel: c[2]
    };
}
function $7c3b72a365cc0275$var$parse_RgceLoc_BIFF2(blob /*::, length, opts*/ ) {
    var r = $7c3b72a365cc0275$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    return {
        r: r[0],
        c: c,
        cRel: r[1],
        rRel: r[2]
    };
}
/* [MS-XLS] 2.5.198.107, 2.5.47 */ function $7c3b72a365cc0275$var$parse_RgceElfLoc(blob /*::, length, opts*/ ) {
    var r = blob.read_shift(2);
    var c = blob.read_shift(2);
    return {
        r: r,
        c: c & 0xFF,
        fQuoted: !!(c & 0x4000),
        cRel: c >> 15,
        rRel: c >> 15
    };
}
/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */ function $7c3b72a365cc0275$var$parse_RgceLocRel(blob, length, opts) {
    var biff = opts && opts.biff ? opts.biff : 8;
    if (biff >= 2 && biff <= 5) return $7c3b72a365cc0275$var$parse_RgceLocRel_BIFF2(blob, length, opts);
    var r = blob.read_shift(biff >= 12 ? 4 : 2);
    var cl = blob.read_shift(2);
    var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
    cl &= 0x3FFF;
    if (rRel == 1) while(r > 0x7FFFF)r -= 0x100000;
    if (cRel == 1) while(cl > 0x1FFF)cl = cl - 0x4000;
    return {
        r: r,
        c: cl,
        cRel: cRel,
        rRel: rRel
    };
}
function $7c3b72a365cc0275$var$parse_RgceLocRel_BIFF2(blob /*::, length:number, opts*/ ) {
    var rl = blob.read_shift(2);
    var c = blob.read_shift(1);
    var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
    rl &= 0x3FFF;
    if (rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
    if (cRel == 1 && c >= 0x80) c = c - 0x100;
    return {
        r: rl,
        c: c,
        cRel: cRel,
        rRel: rRel
    };
}
/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */ function $7c3b72a365cc0275$var$parse_PtgArea(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $7c3b72a365cc0275$var$parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */ function $7c3b72a365cc0275$var$parse_PtgArea3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2, 'i');
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    var area = $7c3b72a365cc0275$var$parse_RgceArea(blob, w, opts);
    return [
        type,
        ixti,
        area
    ];
}
/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */ function $7c3b72a365cc0275$var$parse_PtgAreaErr(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts && opts.biff > 8 ? 12 : opts.biff < 8 ? 6 : 8;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */ function $7c3b72a365cc0275$var$parse_PtgAreaErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */ function $7c3b72a365cc0275$var$parse_PtgAreaN(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $7c3b72a365cc0275$var$parse_RgceAreaRel(blob, length - 1, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */ function $7c3b72a365cc0275$var$parse_PtgArray(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */ function $7c3b72a365cc0275$var$parse_PtgAttrBaxcel(blob) {
    var bitSemi = blob[blob.l + 1] & 0x01; /* 1 = volatile */ 
    var bitBaxcel = 1;
    blob.l += 4;
    return [
        bitSemi,
        bitBaxcel
    ];
}
/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */ function $7c3b72a365cc0275$var$parse_PtgAttrChoose(blob, length, opts) /*:Array<number>*/ {
    blob.l += 2;
    var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var o /*:Array<number>*/  = [];
    /* offset is 1 less than the number of elements */ for(var i = 0; i <= offset; ++i)o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
    return o;
}
/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */ function $7c3b72a365cc0275$var$parse_PtgAttrGoto(blob, length, opts) {
    var bitGoto = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitGoto,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */ function $7c3b72a365cc0275$var$parse_PtgAttrIf(blob, length, opts) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLSB] 2.5.97.28 */ function $7c3b72a365cc0275$var$parse_PtgAttrIfError(blob) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(2)
    ];
}
/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */ function $7c3b72a365cc0275$var$parse_PtgAttrSemi(blob, length, opts) {
    var bitSemi = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return [
        bitSemi
    ];
}
/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */ function $7c3b72a365cc0275$var$parse_PtgAttrSpaceType(blob /*::, length*/ ) {
    var type = blob.read_shift(1), cch = blob.read_shift(1);
    return [
        type,
        cch
    ];
}
/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */ function $7c3b72a365cc0275$var$parse_PtgAttrSpace(blob) {
    blob.read_shift(2);
    return $7c3b72a365cc0275$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */ function $7c3b72a365cc0275$var$parse_PtgAttrSpaceSemi(blob) {
    blob.read_shift(2);
    return $7c3b72a365cc0275$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */ function $7c3b72a365cc0275$var$parse_PtgRef(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $7c3b72a365cc0275$var$parse_RgceLoc(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */ function $7c3b72a365cc0275$var$parse_PtgRefN(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $7c3b72a365cc0275$var$parse_RgceLocRel(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */ function $7c3b72a365cc0275$var$parse_PtgRef3d(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var ixti = blob.read_shift(2); // XtiIndex
    if (opts && opts.biff == 5) blob.l += 12;
    var loc = $7c3b72a365cc0275$var$parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
    return [
        type,
        ixti,
        loc
    ];
}
/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */ function $7c3b72a365cc0275$var$parse_PtgFunc(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
    return [
        $7c3b72a365cc0275$var$FtabArgc[iftab],
        $7c3b72a365cc0275$var$Ftab[iftab],
        type
    ];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */ function $7c3b72a365cc0275$var$parse_PtgFuncVar(blob, length, opts) {
    var type = blob[blob.l++];
    var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [
        type == 0x58 ? -1 : 0,
        blob.read_shift(1)
    ] : $7c3b72a365cc0275$var$parsetab(blob);
    return [
        cparams,
        (tab[0] === 0 ? $7c3b72a365cc0275$var$Ftab : $7c3b72a365cc0275$var$Cetab)[tab[1]]
    ];
}
function $7c3b72a365cc0275$var$parsetab(blob) {
    return [
        blob[blob.l + 1] >> 7,
        blob.read_shift(2) & 0x7FFF
    ];
}
/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */ function $7c3b72a365cc0275$var$parse_PtgAttrSum(blob, length, opts) {
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return;
}
/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */ function $7c3b72a365cc0275$var$parse_PtgExp(blob, length, opts) {
    blob.l++;
    if (opts && opts.biff == 12) return [
        blob.read_shift(4, 'i'),
        0
    ];
    var row = blob.read_shift(2);
    var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        row,
        col
    ];
}
/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */ function $7c3b72a365cc0275$var$parse_PtgErr(blob) {
    blob.l++;
    return $7c3b72a365cc0275$var$BErr[blob.read_shift(1)];
}
/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */ function $7c3b72a365cc0275$var$parse_PtgInt(blob) {
    blob.l++;
    return blob.read_shift(2);
}
/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */ function $7c3b72a365cc0275$var$parse_PtgBool(blob) {
    blob.l++;
    return blob.read_shift(1) !== 0;
}
/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */ function $7c3b72a365cc0275$var$parse_PtgNum(blob) {
    blob.l++;
    return $7c3b72a365cc0275$var$parse_Xnum(blob, 8);
}
/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */ function $7c3b72a365cc0275$var$parse_PtgStr(blob, length, opts) {
    blob.l++;
    return $7c3b72a365cc0275$var$parse_ShortXLUnicodeString(blob, length - 1, opts);
}
/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */ /* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */ function $7c3b72a365cc0275$var$parse_SerAr(blob, biff /*:number*/ ) {
    var val = [
        blob.read_shift(1)
    ];
    if (biff == 12) switch(val[0]){
        case 0x02:
            val[0] = 0x04;
            break; /* SerBool */ 
        case 0x04:
            val[0] = 0x10;
            break; /* SerErr */ 
        case 0x00:
            val[0] = 0x01;
            break; /* SerNum */ 
        case 0x01:
            val[0] = 0x02;
            break; /* SerStr */ 
    }
    switch(val[0]){
        case 0x04:
            /* SerBool -- boolean */ val[1] = $7c3b72a365cc0275$var$parsebool(blob, 1) ? 'TRUE' : 'FALSE';
            if (biff != 12) blob.l += 7;
            break;
        case 0x25:
        /* appears to be an alias */ case 0x10:
            /* SerErr -- error */ val[1] = $7c3b72a365cc0275$var$BErr[blob[blob.l]];
            blob.l += biff == 12 ? 4 : 8;
            break;
        case 0x00:
            /* SerNil -- honestly, I'm not sure how to reproduce this */ blob.l += 8;
            break;
        case 0x01:
            /* SerNum -- Xnum */ val[1] = $7c3b72a365cc0275$var$parse_Xnum(blob, 8);
            break;
        case 0x02:
            /* SerStr -- XLUnicodeString (<256 chars) */ val[1] = $7c3b72a365cc0275$var$parse_XLUnicodeString2(blob, 0, {
                biff: biff > 0 && biff < 8 ? 2 : biff
            });
            break;
        default:
            throw new Error("Bad SerAr: " + val[0]); /* Unreachable */ 
    }
    return val;
}
/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */ function $7c3b72a365cc0275$var$parse_PtgExtraMem(blob, cce, opts) {
    var count = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var out /*:Array<Range>*/  = [];
    for(var i = 0; i != count; ++i)out.push((opts.biff == 12 ? $7c3b72a365cc0275$var$parse_UncheckedRfX : $7c3b72a365cc0275$var$parse_Ref8U)(blob, 8));
    return out;
}
/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */ function $7c3b72a365cc0275$var$parse_PtgExtraArray(blob, length, opts) {
    var rows = 0, cols = 0;
    if (opts.biff == 12) {
        rows = blob.read_shift(4); // DRw
        cols = blob.read_shift(4); // DCol
    } else {
        cols = 1 + blob.read_shift(1); //DColByteU
        rows = 1 + blob.read_shift(2); //DRw
    }
    if (opts.biff >= 2 && opts.biff < 8) {
        --rows;
        if (--cols == 0) cols = 0x100;
    }
    // $FlowIgnore
    for(var i = 0, o /*:Array<Array<any>>*/  = []; i != rows && (o[i] = []); ++i)for(var j = 0; j != cols; ++j)o[i][j] = $7c3b72a365cc0275$var$parse_SerAr(blob, opts.biff);
    return o;
}
/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */ function $7c3b72a365cc0275$var$parse_PtgName(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var w = !opts || opts.biff >= 8 ? 4 : 2;
    var nameindex = blob.read_shift(w);
    switch(opts.biff){
        case 2:
            blob.l += 5;
            break;
        case 3:
        case 4:
            blob.l += 8;
            break;
        case 5:
            blob.l += 12;
            break;
    }
    return [
        type,
        0,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */ function $7c3b72a365cc0275$var$parse_PtgNameX(blob, length, opts) {
    if (opts.biff == 5) return $7c3b72a365cc0275$var$parse_PtgNameX_BIFF5(blob, length, opts);
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2); // XtiIndex
    var nameindex = blob.read_shift(4);
    return [
        type,
        ixti,
        nameindex
    ];
}
function $7c3b72a365cc0275$var$parse_PtgNameX_BIFF5(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2, 'i'); // XtiIndex
    blob.l += 8;
    var nameindex = blob.read_shift(2);
    blob.l += 12;
    return [
        type,
        ixti,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */ function $7c3b72a365cc0275$var$parse_PtgMemArea(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */ function $7c3b72a365cc0275$var$parse_PtgMemFunc(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */ function $7c3b72a365cc0275$var$parse_PtgRefErr(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += 4;
    if (opts.biff < 8) blob.l--;
    if (opts.biff == 12) blob.l += 2;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */ function $7c3b72a365cc0275$var$parse_PtgRefErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 4;
    if (opts) switch(opts.biff){
        case 5:
            w = 15;
            break;
        case 12:
            w = 6;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */ var $7c3b72a365cc0275$var$parse_PtgMemErr = $7c3b72a365cc0275$var$parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */ var $7c3b72a365cc0275$var$parse_PtgMemNoMem = $7c3b72a365cc0275$var$parsenoop;
/* [MS-XLS] 2.5.198.92 */ var $7c3b72a365cc0275$var$parse_PtgTbl = $7c3b72a365cc0275$var$parsenoop;
function $7c3b72a365cc0275$var$parse_PtgElfLoc(blob, length, opts) {
    blob.l += 2;
    return [
        $7c3b72a365cc0275$var$parse_RgceElfLoc(blob, 4, opts)
    ];
}
function $7c3b72a365cc0275$var$parse_PtgElfNoop(blob /*::, length, opts*/ ) {
    blob.l += 6;
    return [];
}
/* [MS-XLS] 2.5.198.46 */ var $7c3b72a365cc0275$var$parse_PtgElfCol = $7c3b72a365cc0275$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */ var $7c3b72a365cc0275$var$parse_PtgElfColS = $7c3b72a365cc0275$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */ var $7c3b72a365cc0275$var$parse_PtgElfColSV = $7c3b72a365cc0275$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */ var $7c3b72a365cc0275$var$parse_PtgElfColV = $7c3b72a365cc0275$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */ function $7c3b72a365cc0275$var$parse_PtgElfLel(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        $7c3b72a365cc0275$var$parseuint16(blob),
        blob.read_shift(2) & 0x01
    ];
}
/* [MS-XLS] 2.5.198.51 */ var $7c3b72a365cc0275$var$parse_PtgElfRadical = $7c3b72a365cc0275$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */ var $7c3b72a365cc0275$var$parse_PtgElfRadicalLel = $7c3b72a365cc0275$var$parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */ var $7c3b72a365cc0275$var$parse_PtgElfRadicalS = $7c3b72a365cc0275$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */ var $7c3b72a365cc0275$var$parse_PtgElfRw = $7c3b72a365cc0275$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */ var $7c3b72a365cc0275$var$parse_PtgElfRwV = $7c3b72a365cc0275$var$parse_PtgElfLoc;
/* [MS-XLSB] 2.5.97.52 TODO */ var $7c3b72a365cc0275$var$PtgListRT = [
    "Data",
    "All",
    "Headers",
    "??",
    "?Data2",
    "??",
    "?DataHeaders",
    "??",
    "Totals",
    "??",
    "??",
    "??",
    "?DataTotals",
    "??",
    "??",
    "??",
    "?Current"
];
function $7c3b72a365cc0275$var$parse_PtgList(blob /*::, length, opts*/ ) {
    blob.l += 2;
    var ixti = blob.read_shift(2);
    var flags = blob.read_shift(2);
    var idx = blob.read_shift(4);
    var c = blob.read_shift(2);
    var C = blob.read_shift(2);
    var rt = $7c3b72a365cc0275$var$PtgListRT[flags >> 2 & 0x1F];
    return {
        ixti: ixti,
        coltype: flags & 0x3,
        rt: rt,
        idx: idx,
        c: c,
        C: C
    };
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */ function $7c3b72a365cc0275$var$parse_PtgSxName(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        blob.read_shift(4)
    ];
}
/* [XLS] old spec */ function $7c3b72a365cc0275$var$parse_PtgSheet(blob, length, opts) {
    blob.l += 5;
    blob.l += 2;
    blob.l += opts.biff == 2 ? 1 : 4;
    return [
        "PTGSHEET"
    ];
}
function $7c3b72a365cc0275$var$parse_PtgEndSheet(blob, length, opts) {
    blob.l += opts.biff == 2 ? 4 : 5;
    return [
        "PTGENDSHEET"
    ];
}
function $7c3b72a365cc0275$var$parse_PtgMemAreaN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $7c3b72a365cc0275$var$parse_PtgMemNoMemN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $7c3b72a365cc0275$var$parse_PtgAttrNoop(blob /*::, length, opts*/ ) {
    blob.l += 4;
    return [
        0,
        0
    ];
}
/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */ var $7c3b72a365cc0275$var$PtgTypes = {
    /*::[*/ 0x01: {
        n: 'PtgExp',
        f: $7c3b72a365cc0275$var$parse_PtgExp
    },
    /*::[*/ 0x02: {
        n: 'PtgTbl',
        f: $7c3b72a365cc0275$var$parse_PtgTbl
    },
    /*::[*/ 0x03: {
        n: 'PtgAdd',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x04: {
        n: 'PtgSub',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x05: {
        n: 'PtgMul',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x06: {
        n: 'PtgDiv',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x07: {
        n: 'PtgPower',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x08: {
        n: 'PtgConcat',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x09: {
        n: 'PtgLt',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x0A: {
        n: 'PtgLe',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x0B: {
        n: 'PtgEq',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x0C: {
        n: 'PtgGe',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x0D: {
        n: 'PtgGt',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x0E: {
        n: 'PtgNe',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x0F: {
        n: 'PtgIsect',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x10: {
        n: 'PtgUnion',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x11: {
        n: 'PtgRange',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x12: {
        n: 'PtgUplus',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x13: {
        n: 'PtgUminus',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x14: {
        n: 'PtgPercent',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x15: {
        n: 'PtgParen',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x16: {
        n: 'PtgMissArg',
        f: $7c3b72a365cc0275$var$parseread1
    },
    /*::[*/ 0x17: {
        n: 'PtgStr',
        f: $7c3b72a365cc0275$var$parse_PtgStr
    },
    /*::[*/ 0x1A: {
        n: 'PtgSheet',
        f: $7c3b72a365cc0275$var$parse_PtgSheet
    },
    /*::[*/ 0x1B: {
        n: 'PtgEndSheet',
        f: $7c3b72a365cc0275$var$parse_PtgEndSheet
    },
    /*::[*/ 0x1C: {
        n: 'PtgErr',
        f: $7c3b72a365cc0275$var$parse_PtgErr
    },
    /*::[*/ 0x1D: {
        n: 'PtgBool',
        f: $7c3b72a365cc0275$var$parse_PtgBool
    },
    /*::[*/ 0x1E: {
        n: 'PtgInt',
        f: $7c3b72a365cc0275$var$parse_PtgInt
    },
    /*::[*/ 0x1F: {
        n: 'PtgNum',
        f: $7c3b72a365cc0275$var$parse_PtgNum
    },
    /*::[*/ 0x20: {
        n: 'PtgArray',
        f: $7c3b72a365cc0275$var$parse_PtgArray
    },
    /*::[*/ 0x21: {
        n: 'PtgFunc',
        f: $7c3b72a365cc0275$var$parse_PtgFunc
    },
    /*::[*/ 0x22: {
        n: 'PtgFuncVar',
        f: $7c3b72a365cc0275$var$parse_PtgFuncVar
    },
    /*::[*/ 0x23: {
        n: 'PtgName',
        f: $7c3b72a365cc0275$var$parse_PtgName
    },
    /*::[*/ 0x24: {
        n: 'PtgRef',
        f: $7c3b72a365cc0275$var$parse_PtgRef
    },
    /*::[*/ 0x25: {
        n: 'PtgArea',
        f: $7c3b72a365cc0275$var$parse_PtgArea
    },
    /*::[*/ 0x26: {
        n: 'PtgMemArea',
        f: $7c3b72a365cc0275$var$parse_PtgMemArea
    },
    /*::[*/ 0x27: {
        n: 'PtgMemErr',
        f: $7c3b72a365cc0275$var$parse_PtgMemErr
    },
    /*::[*/ 0x28: {
        n: 'PtgMemNoMem',
        f: $7c3b72a365cc0275$var$parse_PtgMemNoMem
    },
    /*::[*/ 0x29: {
        n: 'PtgMemFunc',
        f: $7c3b72a365cc0275$var$parse_PtgMemFunc
    },
    /*::[*/ 0x2A: {
        n: 'PtgRefErr',
        f: $7c3b72a365cc0275$var$parse_PtgRefErr
    },
    /*::[*/ 0x2B: {
        n: 'PtgAreaErr',
        f: $7c3b72a365cc0275$var$parse_PtgAreaErr
    },
    /*::[*/ 0x2C: {
        n: 'PtgRefN',
        f: $7c3b72a365cc0275$var$parse_PtgRefN
    },
    /*::[*/ 0x2D: {
        n: 'PtgAreaN',
        f: $7c3b72a365cc0275$var$parse_PtgAreaN
    },
    /*::[*/ 0x2E: {
        n: 'PtgMemAreaN',
        f: $7c3b72a365cc0275$var$parse_PtgMemAreaN
    },
    /*::[*/ 0x2F: {
        n: 'PtgMemNoMemN',
        f: $7c3b72a365cc0275$var$parse_PtgMemNoMemN
    },
    /*::[*/ 0x39: {
        n: 'PtgNameX',
        f: $7c3b72a365cc0275$var$parse_PtgNameX
    },
    /*::[*/ 0x3A: {
        n: 'PtgRef3d',
        f: $7c3b72a365cc0275$var$parse_PtgRef3d
    },
    /*::[*/ 0x3B: {
        n: 'PtgArea3d',
        f: $7c3b72a365cc0275$var$parse_PtgArea3d
    },
    /*::[*/ 0x3C: {
        n: 'PtgRefErr3d',
        f: $7c3b72a365cc0275$var$parse_PtgRefErr3d
    },
    /*::[*/ 0x3D: {
        n: 'PtgAreaErr3d',
        f: $7c3b72a365cc0275$var$parse_PtgAreaErr3d
    },
    /*::[*/ 0xFF: {}
};
/* These are duplicated in the PtgTypes table */ var $7c3b72a365cc0275$var$PtgDupes = {
    /*::[*/ 0x40: 0x20,
    /*::[*/ 0x60: 0x20,
    /*::[*/ 0x41: 0x21,
    /*::[*/ 0x61: 0x21,
    /*::[*/ 0x42: 0x22,
    /*::[*/ 0x62: 0x22,
    /*::[*/ 0x43: 0x23,
    /*::[*/ 0x63: 0x23,
    /*::[*/ 0x44: 0x24,
    /*::[*/ 0x64: 0x24,
    /*::[*/ 0x45: 0x25,
    /*::[*/ 0x65: 0x25,
    /*::[*/ 0x46: 0x26,
    /*::[*/ 0x66: 0x26,
    /*::[*/ 0x47: 0x27,
    /*::[*/ 0x67: 0x27,
    /*::[*/ 0x48: 0x28,
    /*::[*/ 0x68: 0x28,
    /*::[*/ 0x49: 0x29,
    /*::[*/ 0x69: 0x29,
    /*::[*/ 0x4A: 0x2A,
    /*::[*/ 0x6A: 0x2A,
    /*::[*/ 0x4B: 0x2B,
    /*::[*/ 0x6B: 0x2B,
    /*::[*/ 0x4C: 0x2C,
    /*::[*/ 0x6C: 0x2C,
    /*::[*/ 0x4D: 0x2D,
    /*::[*/ 0x6D: 0x2D,
    /*::[*/ 0x4E: 0x2E,
    /*::[*/ 0x6E: 0x2E,
    /*::[*/ 0x4F: 0x2F,
    /*::[*/ 0x6F: 0x2F,
    /*::[*/ 0x58: 0x22,
    /*::[*/ 0x78: 0x22,
    /*::[*/ 0x59: 0x39,
    /*::[*/ 0x79: 0x39,
    /*::[*/ 0x5A: 0x3A,
    /*::[*/ 0x7A: 0x3A,
    /*::[*/ 0x5B: 0x3B,
    /*::[*/ 0x7B: 0x3B,
    /*::[*/ 0x5C: 0x3C,
    /*::[*/ 0x7C: 0x3C,
    /*::[*/ 0x5D: 0x3D,
    /*::[*/ 0x7D: 0x3D
};
var $7c3b72a365cc0275$var$Ptg18 = {
    /*::[*/ 0x01: {
        n: 'PtgElfLel',
        f: $7c3b72a365cc0275$var$parse_PtgElfLel
    },
    /*::[*/ 0x02: {
        n: 'PtgElfRw',
        f: $7c3b72a365cc0275$var$parse_PtgElfRw
    },
    /*::[*/ 0x03: {
        n: 'PtgElfCol',
        f: $7c3b72a365cc0275$var$parse_PtgElfCol
    },
    /*::[*/ 0x06: {
        n: 'PtgElfRwV',
        f: $7c3b72a365cc0275$var$parse_PtgElfRwV
    },
    /*::[*/ 0x07: {
        n: 'PtgElfColV',
        f: $7c3b72a365cc0275$var$parse_PtgElfColV
    },
    /*::[*/ 0x0A: {
        n: 'PtgElfRadical',
        f: $7c3b72a365cc0275$var$parse_PtgElfRadical
    },
    /*::[*/ 0x0B: {
        n: 'PtgElfRadicalS',
        f: $7c3b72a365cc0275$var$parse_PtgElfRadicalS
    },
    /*::[*/ 0x0D: {
        n: 'PtgElfColS',
        f: $7c3b72a365cc0275$var$parse_PtgElfColS
    },
    /*::[*/ 0x0F: {
        n: 'PtgElfColSV',
        f: $7c3b72a365cc0275$var$parse_PtgElfColSV
    },
    /*::[*/ 0x10: {
        n: 'PtgElfRadicalLel',
        f: $7c3b72a365cc0275$var$parse_PtgElfRadicalLel
    },
    /*::[*/ 0x19: {
        n: 'PtgList',
        f: $7c3b72a365cc0275$var$parse_PtgList
    },
    /*::[*/ 0x1D: {
        n: 'PtgSxName',
        f: $7c3b72a365cc0275$var$parse_PtgSxName
    },
    /*::[*/ 0xFF: {}
};
var $7c3b72a365cc0275$var$Ptg19 = {
    /*::[*/ 0x00: {
        n: 'PtgAttrNoop',
        f: $7c3b72a365cc0275$var$parse_PtgAttrNoop
    },
    /*::[*/ 0x01: {
        n: 'PtgAttrSemi',
        f: $7c3b72a365cc0275$var$parse_PtgAttrSemi
    },
    /*::[*/ 0x02: {
        n: 'PtgAttrIf',
        f: $7c3b72a365cc0275$var$parse_PtgAttrIf
    },
    /*::[*/ 0x04: {
        n: 'PtgAttrChoose',
        f: $7c3b72a365cc0275$var$parse_PtgAttrChoose
    },
    /*::[*/ 0x08: {
        n: 'PtgAttrGoto',
        f: $7c3b72a365cc0275$var$parse_PtgAttrGoto
    },
    /*::[*/ 0x10: {
        n: 'PtgAttrSum',
        f: $7c3b72a365cc0275$var$parse_PtgAttrSum
    },
    /*::[*/ 0x20: {
        n: 'PtgAttrBaxcel',
        f: $7c3b72a365cc0275$var$parse_PtgAttrBaxcel
    },
    /*::[*/ 0x21: {
        n: 'PtgAttrBaxcel',
        f: $7c3b72a365cc0275$var$parse_PtgAttrBaxcel
    },
    /*::[*/ 0x40: {
        n: 'PtgAttrSpace',
        f: $7c3b72a365cc0275$var$parse_PtgAttrSpace
    },
    /*::[*/ 0x41: {
        n: 'PtgAttrSpaceSemi',
        f: $7c3b72a365cc0275$var$parse_PtgAttrSpaceSemi
    },
    /*::[*/ 0x80: {
        n: 'PtgAttrIfError',
        f: $7c3b72a365cc0275$var$parse_PtgAttrIfError
    },
    /*::[*/ 0xFF: {}
};
/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */ function $7c3b72a365cc0275$var$parse_RgbExtra(blob, length, rgce, opts) {
    if (opts.biff < 8) return $7c3b72a365cc0275$var$parsenoop(blob, length);
    var target = blob.l + length;
    var o = [];
    for(var i = 0; i !== rgce.length; ++i)switch(rgce[i][0]){
        case 'PtgArray':
            /* PtgArray -> PtgExtraArray */ rgce[i][1] = $7c3b72a365cc0275$var$parse_PtgExtraArray(blob, 0, opts);
            o.push(rgce[i][1]);
            break;
        case 'PtgMemArea':
            /* PtgMemArea -> PtgExtraMem */ rgce[i][2] = $7c3b72a365cc0275$var$parse_PtgExtraMem(blob, rgce[i][1], opts);
            o.push(rgce[i][2]);
            break;
        case 'PtgExp':
            /* PtgExp -> PtgExtraCol */ if (opts && opts.biff == 12) {
                rgce[i][1][1] = blob.read_shift(4);
                o.push(rgce[i][1]);
            }
            break;
        case 'PtgList':
        /* TODO: PtgList -> PtgExtraList */ case 'PtgElfRadicalS':
        /* TODO: PtgElfRadicalS -> PtgExtraElf */ case 'PtgElfColS':
        /* TODO: PtgElfColS -> PtgExtraElf */ case 'PtgElfColSV':
            /* TODO: PtgElfColSV -> PtgExtraElf */ throw "Unsupported " + rgce[i][0];
        default:
            break;
    }
    length = target - blob.l;
    /* note: this is technically an error but Excel disregards */ //if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
    if (length !== 0) o.push($7c3b72a365cc0275$var$parsenoop(blob, length));
    return o;
}
/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */ function $7c3b72a365cc0275$var$parse_Rgce(blob, length, opts) {
    var target = blob.l + length;
    var R, id, ptgs = [];
    while(target != blob.l){
        length = target - blob.l;
        id = blob[blob.l];
        R = $7c3b72a365cc0275$var$PtgTypes[id] || $7c3b72a365cc0275$var$PtgTypes[$7c3b72a365cc0275$var$PtgDupes[id]];
        if (id === 0x18 || id === 0x19) R = (id === 0x18 ? $7c3b72a365cc0275$var$Ptg18 : $7c3b72a365cc0275$var$Ptg19)[blob[blob.l + 1]];
        if (!R || !R.f) $7c3b72a365cc0275$var$parsenoop(blob, length);
        else ptgs.push([
            R.n,
            R.f(blob, length, opts)
        ]);
    }
    return ptgs;
}
function $7c3b72a365cc0275$var$stringify_array(f /*:Array<Array<string>>*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < f.length; ++i){
        var x = f[i], r /*:Array<string>*/  = [];
        for(var j = 0; j < x.length; ++j){
            var y = x[j];
            if (y) switch(y[0]){
                // TODO: handle embedded quotes
                case 0x02:
                    /*:: if(typeof y[1] != 'string') throw "unreachable"; */ r.push('"' + y[1].replace(/"/g, '""') + '"');
                    break;
                default:
                    r.push(y[1]);
            }
            else r.push("");
        }
        o.push(r.join(","));
    }
    return o.join(";");
}
/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */ var $7c3b72a365cc0275$var$PtgBinOp = {
    PtgAdd: "+",
    PtgConcat: "&",
    PtgDiv: "/",
    PtgEq: "=",
    PtgGe: ">=",
    PtgGt: ">",
    PtgLe: "<=",
    PtgLt: "<",
    PtgMul: "*",
    PtgNe: "<>",
    PtgPower: "^",
    PtgSub: "-"
};
// List of invalid characters needs to be tested further
function $7c3b72a365cc0275$var$formula_quote_sheet_name(sname /*:string*/ , opts) /*:string*/ {
    if (!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
    if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname + "'";
    return sname;
}
function $7c3b72a365cc0275$var$get_ixti_raw(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    if (!supbooks) return "SH33TJSERR0";
    if (opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
    if (!supbooks.XTI) return "SH33TJSERR6";
    var XTI = supbooks.XTI[ixti];
    if (opts.biff < 8) {
        if (ixti > 10000) ixti -= 65536;
        if (ixti < 0) ixti = -ixti;
        return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
    }
    if (!XTI) return "SH33TJSERR1";
    var o = "";
    if (opts.biff > 8) switch(supbooks[XTI[0]][0]){
        case 0x0165:
            /* 'BrtSupSelf' */ o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x0166:
            /* 'BrtSupSame' */ if (opts.SID != null) return supbooks.SheetNames[opts.SID];
            return "SH33TJSSAME" + supbooks[XTI[0]][0];
        case 0x0163:
        /* 'BrtSupBookSrc' */ /* falls through */ default:
            return "SH33TJSSRC" + supbooks[XTI[0]][0];
    }
    switch(supbooks[XTI[0]][0][0]){
        case 0x0401:
            o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]] || "SH33TJSERR3";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x3A01:
            return supbooks[XTI[0]].slice(1).map(function(name) {
                return name.Name;
            }).join(";;"); //return "SH33TJSERR8";
        default:
            if (!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
            o = XTI[1] == -1 ? "#REF" : supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
    }
}
function $7c3b72a365cc0275$var$get_ixti(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    var ixtiraw = $7c3b72a365cc0275$var$get_ixti_raw(supbooks, ixti, opts);
    return ixtiraw == "#REF" ? ixtiraw : $7c3b72a365cc0275$var$formula_quote_sheet_name(ixtiraw, opts);
}
function $7c3b72a365cc0275$var$stringify_formula(formula /*Array<any>*/ , range, cell /*:any*/ , supbooks, opts) /*:string*/ {
    var biff = opts && opts.biff || 8;
    var _range = /*range != null ? range :*/ {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var stack /*:Array<string>*/  = [], e1, e2, /*::type,*/ c /*:CellAddress*/ , ixti = 0, nameidx = 0, r, sname = "";
    if (!formula[0] || !formula[0][0]) return "";
    var last_sp = -1, sp = "";
    for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff){
        var f = formula[0][ff];
        switch(f[0]){
            case 'PtgUminus':
                /* [MS-XLS] 2.5.198.93 */ stack.push("-" + stack.pop());
                break;
            case 'PtgUplus':
                /* [MS-XLS] 2.5.198.95 */ stack.push("+" + stack.pop());
                break;
            case 'PtgPercent':
                /* [MS-XLS] 2.5.198.81 */ stack.push(stack.pop() + "%");
                break;
            case 'PtgAdd':
            /* [MS-XLS] 2.5.198.26 */ case 'PtgConcat':
            /* [MS-XLS] 2.5.198.43 */ case 'PtgDiv':
            /* [MS-XLS] 2.5.198.45 */ case 'PtgEq':
            /* [MS-XLS] 2.5.198.56 */ case 'PtgGe':
            /* [MS-XLS] 2.5.198.64 */ case 'PtgGt':
            /* [MS-XLS] 2.5.198.65 */ case 'PtgLe':
            /* [MS-XLS] 2.5.198.68 */ case 'PtgLt':
            /* [MS-XLS] 2.5.198.69 */ case 'PtgMul':
            /* [MS-XLS] 2.5.198.75 */ case 'PtgNe':
            /* [MS-XLS] 2.5.198.78 */ case 'PtgPower':
            /* [MS-XLS] 2.5.198.82 */ case 'PtgSub':
                /* [MS-XLS] 2.5.198.90 */ e1 = stack.pop();
                e2 = stack.pop();
                if (last_sp >= 0) {
                    switch(formula[0][last_sp][1][0]){
                        case 0:
                            // $FlowIgnore
                            sp = $7c3b72a365cc0275$var$fill(" ", formula[0][last_sp][1][1]);
                            break;
                        case 1:
                            // $FlowIgnore
                            sp = $7c3b72a365cc0275$var$fill("\r", formula[0][last_sp][1][1]);
                            break;
                        default:
                            sp = "";
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    e2 = e2 + sp;
                    last_sp = -1;
                }
                stack.push(e2 + $7c3b72a365cc0275$var$PtgBinOp[f[0]] + e1);
                break;
            case 'PtgIsect':
                /* [MS-XLS] 2.5.198.67 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + " " + e1);
                break;
            case 'PtgUnion':
                /* [MS-XLS] 2.5.198.94 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + "," + e1);
                break;
            case 'PtgRange':
                /* [MS-XLS] 2.5.198.83 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + ":" + e1);
                break;
            case 'PtgAttrChoose':
                break;
            case 'PtgAttrGoto':
                break;
            case 'PtgAttrIf':
                break;
            case 'PtgAttrIfError':
                break;
            case 'PtgRef':
                /* [MS-XLS] 2.5.198.84 */ /*::type = f[1][0]; */ c = $7c3b72a365cc0275$var$shift_cell_xls(f[1][1], _range, opts);
                stack.push($7c3b72a365cc0275$var$encode_cell_xls(c, biff));
                break;
            case 'PtgRefN':
                /* [MS-XLS] 2.5.198.88 */ /*::type = f[1][0]; */ c = cell ? $7c3b72a365cc0275$var$shift_cell_xls(f[1][1], cell, opts) : f[1][1];
                stack.push($7c3b72a365cc0275$var$encode_cell_xls(c, biff));
                break;
            case 'PtgRef3d':
                /* [MS-XLS] 2.5.198.85 */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                c = $7c3b72a365cc0275$var$shift_cell_xls(f[1][2], _range, opts);
                sname = $7c3b72a365cc0275$var$get_ixti(supbooks, ixti, opts);
                var w = sname; /* IE9 fails on defined names */  // eslint-disable-line no-unused-vars
                stack.push(sname + "!" + $7c3b72a365cc0275$var$encode_cell_xls(c, biff));
                break;
            case 'PtgFunc':
            /* [MS-XLS] 2.5.198.62 */ case 'PtgFuncVar':
                /* [MS-XLS] 2.5.198.63 */ /* f[1] = [argc, func, type] */ var argc /*:number*/  = f[1][0], func /*:string*/  = f[1][1];
                if (!argc) argc = 0;
                argc &= 0x7F;
                var args = argc == 0 ? [] : stack.slice(-argc);
                stack.length -= argc;
                if (func === 'User') func = args.shift();
                stack.push(func + "(" + args.join(",") + ")");
                break;
            case 'PtgBool':
                /* [MS-XLS] 2.5.198.42 */ stack.push(f[1] ? "TRUE" : "FALSE");
                break;
            case 'PtgInt':
                /* [MS-XLS] 2.5.198.66 */ stack.push(/*::String(*/ f[1]);
                break;
            case 'PtgNum':
                /* [MS-XLS] 2.5.198.79 TODO: precision? */ stack.push(String(f[1]));
                break;
            case 'PtgStr':
                /* [MS-XLS] 2.5.198.89 */ // $FlowIgnore
                stack.push('"' + f[1].replace(/"/g, '""') + '"');
                break;
            case 'PtgErr':
                /* [MS-XLS] 2.5.198.57 */ stack.push(/*::String(*/ f[1]);
                break;
            case 'PtgAreaN':
                /* [MS-XLS] 2.5.198.31 TODO */ /*::type = f[1][0]; */ r = $7c3b72a365cc0275$var$shift_range_xls(f[1][1], cell ? {
                    s: cell
                } : _range, opts);
                stack.push($7c3b72a365cc0275$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgArea':
                /* [MS-XLS] 2.5.198.27 TODO: fixed points */ /*::type = f[1][0]; */ r = $7c3b72a365cc0275$var$shift_range_xls(f[1][1], _range, opts);
                stack.push($7c3b72a365cc0275$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgArea3d':
                /* [MS-XLS] 2.5.198.28 TODO */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                r = f[1][2];
                sname = $7c3b72a365cc0275$var$get_ixti(supbooks, ixti, opts);
                stack.push(sname + "!" + $7c3b72a365cc0275$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgAttrSum':
                /* [MS-XLS] 2.5.198.41 */ stack.push("SUM(" + stack.pop() + ")");
                break;
            case 'PtgAttrBaxcel':
            /* [MS-XLS] 2.5.198.33 */ case 'PtgAttrSemi':
                break;
            case 'PtgName':
                /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */ /* f[1] = type, 0, nameindex */ nameidx = f[1][2];
                var lbl = (supbooks.names || [])[nameidx - 1] || (supbooks[0] || [])[nameidx];
                var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
                /* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */ if (name && name.slice(0, 6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
                stack.push(name);
                break;
            case 'PtgNameX':
                /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */ /* f[1] = type, ixti, nameindex */ var bookidx /*:number*/  = f[1][1];
                nameidx = f[1][2];
                var externbook;
                /* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */ if (opts.biff <= 5) {
                    if (bookidx < 0) bookidx = -bookidx;
                    if (supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
                } else {
                    var o = "";
                    if (((supbooks[bookidx] || [])[0] || [])[0] == 0x3A01) ;
                    else if (((supbooks[bookidx] || [])[0] || [])[0] == 0x0401) {
                        if (supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab - 1] + "!";
                    } else o = supbooks.SheetNames[nameidx - 1] + "!";
                    if (supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
                    else if (supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
                    else {
                        var ixtidata = ($7c3b72a365cc0275$var$get_ixti_raw(supbooks, bookidx, opts) || "").split(";;");
                        if (ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
                        else o += "SH33TJSERRX";
                    }
                    stack.push(o);
                    break;
                }
                if (!externbook) externbook = {
                    Name: "SH33TJSERRY"
                };
                stack.push(externbook.Name);
                break;
            case 'PtgParen':
                /* [MS-XLS] 2.5.198.80 */ var lp = '(', rp = ')';
                if (last_sp >= 0) {
                    sp = "";
                    switch(formula[0][last_sp][1][0]){
                        // $FlowIgnore
                        case 2:
                            lp = $7c3b72a365cc0275$var$fill(" ", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 3:
                            lp = $7c3b72a365cc0275$var$fill("\r", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 4:
                            rp = $7c3b72a365cc0275$var$fill(" ", formula[0][last_sp][1][1]) + rp;
                            break;
                        // $FlowIgnore
                        case 5:
                            rp = $7c3b72a365cc0275$var$fill("\r", formula[0][last_sp][1][1]) + rp;
                            break;
                        default:
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    last_sp = -1;
                }
                stack.push(lp + stack.pop() + rp);
                break;
            case 'PtgRefErr':
                /* [MS-XLS] 2.5.198.86 */ stack.push('#REF!');
                break;
            case 'PtgRefErr3d':
                /* [MS-XLS] 2.5.198.87 */ stack.push('#REF!');
                break;
            case 'PtgExp':
                /* [MS-XLS] 2.5.198.58 TODO */ c = {
                    c: f[1][1],
                    r: f[1][0]
                };
                var q = {
                    c: cell.c,
                    r: cell.r
                } /*:any*/ ;
                if (supbooks.sharedf[$7c3b72a365cc0275$var$encode_cell(c)]) {
                    var parsedf = supbooks.sharedf[$7c3b72a365cc0275$var$encode_cell(c)];
                    stack.push($7c3b72a365cc0275$var$stringify_formula(parsedf, _range, q, supbooks, opts));
                } else {
                    var fnd = false;
                    for(e1 = 0; e1 != supbooks.arrayf.length; ++e1){
                        /* TODO: should be something like range_has */ e2 = supbooks.arrayf[e1];
                        if (c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
                        if (c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
                        stack.push($7c3b72a365cc0275$var$stringify_formula(e2[1], _range, q, supbooks, opts));
                        fnd = true;
                        break;
                    }
                    if (!fnd) stack.push(/*::String(*/ f[1]);
                }
                break;
            case 'PtgArray':
                /* [MS-XLS] 2.5.198.32 TODO */ stack.push("{" + $7c3b72a365cc0275$var$stringify_array(/*::(*/ f[1]) + "}");
                break;
            case 'PtgMemArea':
                break;
            case 'PtgAttrSpace':
            /* [MS-XLS] 2.5.198.38 */ case 'PtgAttrSpaceSemi':
                /* [MS-XLS] 2.5.198.39 */ last_sp = ff;
                break;
            case 'PtgTbl':
                break;
            case 'PtgMemErr':
                break;
            case 'PtgMissArg':
                /* [MS-XLS] 2.5.198.74 */ stack.push("");
                break;
            case 'PtgAreaErr':
                /* [MS-XLS] 2.5.198.29 */ stack.push("#REF!");
                break;
            case 'PtgAreaErr3d':
                /* [MS-XLS] 2.5.198.30 */ stack.push("#REF!");
                break;
            case 'PtgList':
                /* [MS-XLSB] 2.5.97.52 */ // $FlowIgnore
                stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
                break;
            case 'PtgMemAreaN':
            case 'PtgMemNoMemN':
            case 'PtgAttrNoop':
            case 'PtgSheet':
            case 'PtgEndSheet':
                break;
            case 'PtgMemFunc':
                break;
            case 'PtgMemNoMem':
                break;
            case 'PtgElfCol':
            /* [MS-XLS] 2.5.198.46 */ case 'PtgElfColS':
            /* [MS-XLS] 2.5.198.47 */ case 'PtgElfColSV':
            /* [MS-XLS] 2.5.198.48 */ case 'PtgElfColV':
            /* [MS-XLS] 2.5.198.49 */ case 'PtgElfLel':
            /* [MS-XLS] 2.5.198.50 */ case 'PtgElfRadical':
            /* [MS-XLS] 2.5.198.51 */ case 'PtgElfRadicalLel':
            /* [MS-XLS] 2.5.198.52 */ case 'PtgElfRadicalS':
            /* [MS-XLS] 2.5.198.53 */ case 'PtgElfRw':
            /* [MS-XLS] 2.5.198.54 */ case 'PtgElfRwV':
                /* [MS-XLS] 2.5.198.55 */ throw new Error("Unsupported ELFs");
            case 'PtgSxName':
                /* [MS-XLS] 2.5.198.91 TODO -- find a test case */ throw new Error('Unrecognized Formula Token: ' + String(f));
            default:
                throw new Error('Unrecognized Formula Token: ' + String(f));
        }
        var PtgNonDisp = [
            'PtgAttrSpace',
            'PtgAttrSpaceSemi',
            'PtgAttrGoto'
        ];
        if (opts.biff != 3) {
            if (last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
                f = formula[0][last_sp];
                var _left = true;
                switch(f[1][0]){
                    /* note: some bad XLSB files omit the PtgParen */ case 4:
                        _left = false;
                    /* falls through */ case 0:
                        // $FlowIgnore
                        sp = $7c3b72a365cc0275$var$fill(" ", f[1][1]);
                        break;
                    case 5:
                        _left = false;
                    /* falls through */ case 1:
                        // $FlowIgnore
                        sp = $7c3b72a365cc0275$var$fill("\r", f[1][1]);
                        break;
                    default:
                        sp = "";
                        // $FlowIgnore
                        if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
                }
                stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
                last_sp = -1;
            }
        }
    }
    if (stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
    return stack[0];
}
/* [MS-XLS] 2.5.198.1 TODO */ function $7c3b72a365cc0275$var$parse_ArrayParsedFormula(blob, length, opts /*::, ref*/ ) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $7c3b72a365cc0275$var$parsenoop(blob, length - 2)
    ];
    var rgce = $7c3b72a365cc0275$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $7c3b72a365cc0275$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.3 TODO */ function $7c3b72a365cc0275$var$parse_XLSCellParsedFormula(blob, length, opts) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $7c3b72a365cc0275$var$parsenoop(blob, length - 2)
    ];
    var rgce = $7c3b72a365cc0275$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $7c3b72a365cc0275$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.21 */ function $7c3b72a365cc0275$var$parse_NameParsedFormula(blob, length, opts, cce) {
    var target = blob.l + length;
    var rgce = $7c3b72a365cc0275$var$parse_Rgce(blob, cce, opts);
    var rgcb;
    if (target !== blob.l) rgcb = $7c3b72a365cc0275$var$parse_RgbExtra(blob, target - blob.l, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.118 TODO */ function $7c3b72a365cc0275$var$parse_SharedParsedFormula(blob, length, opts) {
    var target = blob.l + length;
    var rgcb, cce = blob.read_shift(2); // length of rgce
    var rgce = $7c3b72a365cc0275$var$parse_Rgce(blob, cce, opts);
    if (cce == 0xFFFF) return [
        [],
        $7c3b72a365cc0275$var$parsenoop(blob, length - 2)
    ];
    if (length !== cce + 2) rgcb = $7c3b72a365cc0275$var$parse_RgbExtra(blob, target - cce - 2, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */ function $7c3b72a365cc0275$var$parse_FormulaValue(blob /*::, length*/ ) {
    var b;
    if ($7c3b72a365cc0275$var$__readUInt16LE(blob, blob.l + 6) !== 0xFFFF) return [
        $7c3b72a365cc0275$var$parse_Xnum(blob),
        'n'
    ];
    switch(blob[blob.l]){
        case 0x00:
            blob.l += 8;
            return [
                "String",
                's'
            ];
        case 0x01:
            b = blob[blob.l + 2] === 0x1;
            blob.l += 8;
            return [
                b,
                'b'
            ];
        case 0x02:
            b = blob[blob.l + 2];
            blob.l += 8;
            return [
                b,
                'e'
            ];
        case 0x03:
            blob.l += 8;
            return [
                "",
                's'
            ];
    }
    return [];
}
function $7c3b72a365cc0275$var$write_FormulaValue(value) {
    if (value == null) {
        // Blank String Value
        var o = $7c3b72a365cc0275$var$new_buf(8);
        o.write_shift(1, 0x03);
        o.write_shift(1, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0xFFFF);
        return o;
    } else if (typeof value == "number") return $7c3b72a365cc0275$var$write_Xnum(value);
    return $7c3b72a365cc0275$var$write_Xnum(0);
}
/* [MS-XLS] 2.4.127 TODO */ function $7c3b72a365cc0275$var$parse_Formula(blob, length, opts) {
    var end = blob.l + length;
    var cell = $7c3b72a365cc0275$var$parse_XLSCell(blob, 6);
    if (opts.biff == 2) ++blob.l;
    var val = $7c3b72a365cc0275$var$parse_FormulaValue(blob, 8);
    var flags = blob.read_shift(1);
    if (opts.biff != 2) {
        blob.read_shift(1);
        if (opts.biff >= 5) /*var chn = */ blob.read_shift(4);
    }
    var cbf = $7c3b72a365cc0275$var$parse_XLSCellParsedFormula(blob, end - blob.l, opts);
    return {
        cell: cell,
        val: val[0],
        formula: cbf,
        shared: flags >> 3 & 1,
        tt: val[1]
    };
}
function $7c3b72a365cc0275$var$write_Formula(cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, os /*:number*/ ) {
    // Cell
    var o1 = $7c3b72a365cc0275$var$write_XLSCell(R, C, os);
    // FormulaValue
    var o2 = $7c3b72a365cc0275$var$write_FormulaValue(cell.v);
    // flags + cache
    var o3 = $7c3b72a365cc0275$var$new_buf(6);
    var flags = 33;
    o3.write_shift(2, flags);
    o3.write_shift(4, 0);
    // CellParsedFormula
    var bf = $7c3b72a365cc0275$var$new_buf(cell.bf.length);
    for(var i = 0; i < cell.bf.length; ++i)bf[i] = cell.bf[i];
    var out = $7c3b72a365cc0275$var$bconcat([
        o1,
        o2,
        o3,
        bf
    ]);
    return out;
}
/* XLSB Parsed Formula records have the same shape */ function $7c3b72a365cc0275$var$parse_XLSBParsedFormula(data, length, opts) {
    var cce = data.read_shift(4);
    var rgce = $7c3b72a365cc0275$var$parse_Rgce(data, cce, opts);
    var cb = data.read_shift(4);
    var rgcb = cb > 0 ? $7c3b72a365cc0275$var$parse_RgbExtra(data, cb, rgce, opts) : null;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */ var $7c3b72a365cc0275$var$parse_XLSBArrayParsedFormula = $7c3b72a365cc0275$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */ var $7c3b72a365cc0275$var$parse_XLSBCellParsedFormula = $7c3b72a365cc0275$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.8 DVParsedFormula */ //var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */ //var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */ var $7c3b72a365cc0275$var$parse_XLSBNameParsedFormula = $7c3b72a365cc0275$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */ var $7c3b72a365cc0275$var$parse_XLSBSharedParsedFormula = $7c3b72a365cc0275$var$parse_XLSBParsedFormula;
var $7c3b72a365cc0275$var$Cetab = {
    0: "BEEP",
    1: "OPEN",
    2: "OPEN.LINKS",
    3: "CLOSE.ALL",
    4: "SAVE",
    5: "SAVE.AS",
    6: "FILE.DELETE",
    7: "PAGE.SETUP",
    8: "PRINT",
    9: "PRINTER.SETUP",
    10: "QUIT",
    11: "NEW.WINDOW",
    12: "ARRANGE.ALL",
    13: "WINDOW.SIZE",
    14: "WINDOW.MOVE",
    15: "FULL",
    16: "CLOSE",
    17: "RUN",
    22: "SET.PRINT.AREA",
    23: "SET.PRINT.TITLES",
    24: "SET.PAGE.BREAK",
    25: "REMOVE.PAGE.BREAK",
    26: "FONT",
    27: "DISPLAY",
    28: "PROTECT.DOCUMENT",
    29: "PRECISION",
    30: "A1.R1C1",
    31: "CALCULATE.NOW",
    32: "CALCULATION",
    34: "DATA.FIND",
    35: "EXTRACT",
    36: "DATA.DELETE",
    37: "SET.DATABASE",
    38: "SET.CRITERIA",
    39: "SORT",
    40: "DATA.SERIES",
    41: "TABLE",
    42: "FORMAT.NUMBER",
    43: "ALIGNMENT",
    44: "STYLE",
    45: "BORDER",
    46: "CELL.PROTECTION",
    47: "COLUMN.WIDTH",
    48: "UNDO",
    49: "CUT",
    50: "COPY",
    51: "PASTE",
    52: "CLEAR",
    53: "PASTE.SPECIAL",
    54: "EDIT.DELETE",
    55: "INSERT",
    56: "FILL.RIGHT",
    57: "FILL.DOWN",
    61: "DEFINE.NAME",
    62: "CREATE.NAMES",
    63: "FORMULA.GOTO",
    64: "FORMULA.FIND",
    65: "SELECT.LAST.CELL",
    66: "SHOW.ACTIVE.CELL",
    67: "GALLERY.AREA",
    68: "GALLERY.BAR",
    69: "GALLERY.COLUMN",
    70: "GALLERY.LINE",
    71: "GALLERY.PIE",
    72: "GALLERY.SCATTER",
    73: "COMBINATION",
    74: "PREFERRED",
    75: "ADD.OVERLAY",
    76: "GRIDLINES",
    77: "SET.PREFERRED",
    78: "AXES",
    79: "LEGEND",
    80: "ATTACH.TEXT",
    81: "ADD.ARROW",
    82: "SELECT.CHART",
    83: "SELECT.PLOT.AREA",
    84: "PATTERNS",
    85: "MAIN.CHART",
    86: "OVERLAY",
    87: "SCALE",
    88: "FORMAT.LEGEND",
    89: "FORMAT.TEXT",
    90: "EDIT.REPEAT",
    91: "PARSE",
    92: "JUSTIFY",
    93: "HIDE",
    94: "UNHIDE",
    95: "WORKSPACE",
    96: "FORMULA",
    97: "FORMULA.FILL",
    98: "FORMULA.ARRAY",
    99: "DATA.FIND.NEXT",
    100: "DATA.FIND.PREV",
    101: "FORMULA.FIND.NEXT",
    102: "FORMULA.FIND.PREV",
    103: "ACTIVATE",
    104: "ACTIVATE.NEXT",
    105: "ACTIVATE.PREV",
    106: "UNLOCKED.NEXT",
    107: "UNLOCKED.PREV",
    108: "COPY.PICTURE",
    109: "SELECT",
    110: "DELETE.NAME",
    111: "DELETE.FORMAT",
    112: "VLINE",
    113: "HLINE",
    114: "VPAGE",
    115: "HPAGE",
    116: "VSCROLL",
    117: "HSCROLL",
    118: "ALERT",
    119: "NEW",
    120: "CANCEL.COPY",
    121: "SHOW.CLIPBOARD",
    122: "MESSAGE",
    124: "PASTE.LINK",
    125: "APP.ACTIVATE",
    126: "DELETE.ARROW",
    127: "ROW.HEIGHT",
    128: "FORMAT.MOVE",
    129: "FORMAT.SIZE",
    130: "FORMULA.REPLACE",
    131: "SEND.KEYS",
    132: "SELECT.SPECIAL",
    133: "APPLY.NAMES",
    134: "REPLACE.FONT",
    135: "FREEZE.PANES",
    136: "SHOW.INFO",
    137: "SPLIT",
    138: "ON.WINDOW",
    139: "ON.DATA",
    140: "DISABLE.INPUT",
    142: "OUTLINE",
    143: "LIST.NAMES",
    144: "FILE.CLOSE",
    145: "SAVE.WORKBOOK",
    146: "DATA.FORM",
    147: "COPY.CHART",
    148: "ON.TIME",
    149: "WAIT",
    150: "FORMAT.FONT",
    151: "FILL.UP",
    152: "FILL.LEFT",
    153: "DELETE.OVERLAY",
    155: "SHORT.MENUS",
    159: "SET.UPDATE.STATUS",
    161: "COLOR.PALETTE",
    162: "DELETE.STYLE",
    163: "WINDOW.RESTORE",
    164: "WINDOW.MAXIMIZE",
    166: "CHANGE.LINK",
    167: "CALCULATE.DOCUMENT",
    168: "ON.KEY",
    169: "APP.RESTORE",
    170: "APP.MOVE",
    171: "APP.SIZE",
    172: "APP.MINIMIZE",
    173: "APP.MAXIMIZE",
    174: "BRING.TO.FRONT",
    175: "SEND.TO.BACK",
    185: "MAIN.CHART.TYPE",
    186: "OVERLAY.CHART.TYPE",
    187: "SELECT.END",
    188: "OPEN.MAIL",
    189: "SEND.MAIL",
    190: "STANDARD.FONT",
    191: "CONSOLIDATE",
    192: "SORT.SPECIAL",
    193: "GALLERY.3D.AREA",
    194: "GALLERY.3D.COLUMN",
    195: "GALLERY.3D.LINE",
    196: "GALLERY.3D.PIE",
    197: "VIEW.3D",
    198: "GOAL.SEEK",
    199: "WORKGROUP",
    200: "FILL.GROUP",
    201: "UPDATE.LINK",
    202: "PROMOTE",
    203: "DEMOTE",
    204: "SHOW.DETAIL",
    206: "UNGROUP",
    207: "OBJECT.PROPERTIES",
    208: "SAVE.NEW.OBJECT",
    209: "SHARE",
    210: "SHARE.NAME",
    211: "DUPLICATE",
    212: "APPLY.STYLE",
    213: "ASSIGN.TO.OBJECT",
    214: "OBJECT.PROTECTION",
    215: "HIDE.OBJECT",
    216: "SET.EXTRACT",
    217: "CREATE.PUBLISHER",
    218: "SUBSCRIBE.TO",
    219: "ATTRIBUTES",
    220: "SHOW.TOOLBAR",
    222: "PRINT.PREVIEW",
    223: "EDIT.COLOR",
    224: "SHOW.LEVELS",
    225: "FORMAT.MAIN",
    226: "FORMAT.OVERLAY",
    227: "ON.RECALC",
    228: "EDIT.SERIES",
    229: "DEFINE.STYLE",
    240: "LINE.PRINT",
    243: "ENTER.DATA",
    249: "GALLERY.RADAR",
    250: "MERGE.STYLES",
    251: "EDITION.OPTIONS",
    252: "PASTE.PICTURE",
    253: "PASTE.PICTURE.LINK",
    254: "SPELLING",
    256: "ZOOM",
    259: "INSERT.OBJECT",
    260: "WINDOW.MINIMIZE",
    265: "SOUND.NOTE",
    266: "SOUND.PLAY",
    267: "FORMAT.SHAPE",
    268: "EXTEND.POLYGON",
    269: "FORMAT.AUTO",
    272: "GALLERY.3D.BAR",
    273: "GALLERY.3D.SURFACE",
    274: "FILL.AUTO",
    276: "CUSTOMIZE.TOOLBAR",
    277: "ADD.TOOL",
    278: "EDIT.OBJECT",
    279: "ON.DOUBLECLICK",
    280: "ON.ENTRY",
    281: "WORKBOOK.ADD",
    282: "WORKBOOK.MOVE",
    283: "WORKBOOK.COPY",
    284: "WORKBOOK.OPTIONS",
    285: "SAVE.WORKSPACE",
    288: "CHART.WIZARD",
    289: "DELETE.TOOL",
    290: "MOVE.TOOL",
    291: "WORKBOOK.SELECT",
    292: "WORKBOOK.ACTIVATE",
    293: "ASSIGN.TO.TOOL",
    295: "COPY.TOOL",
    296: "RESET.TOOL",
    297: "CONSTRAIN.NUMERIC",
    298: "PASTE.TOOL",
    302: "WORKBOOK.NEW",
    305: "SCENARIO.CELLS",
    306: "SCENARIO.DELETE",
    307: "SCENARIO.ADD",
    308: "SCENARIO.EDIT",
    309: "SCENARIO.SHOW",
    310: "SCENARIO.SHOW.NEXT",
    311: "SCENARIO.SUMMARY",
    312: "PIVOT.TABLE.WIZARD",
    313: "PIVOT.FIELD.PROPERTIES",
    314: "PIVOT.FIELD",
    315: "PIVOT.ITEM",
    316: "PIVOT.ADD.FIELDS",
    318: "OPTIONS.CALCULATION",
    319: "OPTIONS.EDIT",
    320: "OPTIONS.VIEW",
    321: "ADDIN.MANAGER",
    322: "MENU.EDITOR",
    323: "ATTACH.TOOLBARS",
    324: "VBAActivate",
    325: "OPTIONS.CHART",
    328: "VBA.INSERT.FILE",
    330: "VBA.PROCEDURE.DEFINITION",
    336: "ROUTING.SLIP",
    338: "ROUTE.DOCUMENT",
    339: "MAIL.LOGON",
    342: "INSERT.PICTURE",
    343: "EDIT.TOOL",
    344: "GALLERY.DOUGHNUT",
    350: "CHART.TREND",
    352: "PIVOT.ITEM.PROPERTIES",
    354: "WORKBOOK.INSERT",
    355: "OPTIONS.TRANSITION",
    356: "OPTIONS.GENERAL",
    370: "FILTER.ADVANCED",
    373: "MAIL.ADD.MAILER",
    374: "MAIL.DELETE.MAILER",
    375: "MAIL.REPLY",
    376: "MAIL.REPLY.ALL",
    377: "MAIL.FORWARD",
    378: "MAIL.NEXT.LETTER",
    379: "DATA.LABEL",
    380: "INSERT.TITLE",
    381: "FONT.PROPERTIES",
    382: "MACRO.OPTIONS",
    383: "WORKBOOK.HIDE",
    384: "WORKBOOK.UNHIDE",
    385: "WORKBOOK.DELETE",
    386: "WORKBOOK.NAME",
    388: "GALLERY.CUSTOM",
    390: "ADD.CHART.AUTOFORMAT",
    391: "DELETE.CHART.AUTOFORMAT",
    392: "CHART.ADD.DATA",
    393: "AUTO.OUTLINE",
    394: "TAB.ORDER",
    395: "SHOW.DIALOG",
    396: "SELECT.ALL",
    397: "UNGROUP.SHEETS",
    398: "SUBTOTAL.CREATE",
    399: "SUBTOTAL.REMOVE",
    400: "RENAME.OBJECT",
    412: "WORKBOOK.SCROLL",
    413: "WORKBOOK.NEXT",
    414: "WORKBOOK.PREV",
    415: "WORKBOOK.TAB.SPLIT",
    416: "FULL.SCREEN",
    417: "WORKBOOK.PROTECT",
    420: "SCROLLBAR.PROPERTIES",
    421: "PIVOT.SHOW.PAGES",
    422: "TEXT.TO.COLUMNS",
    423: "FORMAT.CHARTTYPE",
    424: "LINK.FORMAT",
    425: "TRACER.DISPLAY",
    430: "TRACER.NAVIGATE",
    431: "TRACER.CLEAR",
    432: "TRACER.ERROR",
    433: "PIVOT.FIELD.GROUP",
    434: "PIVOT.FIELD.UNGROUP",
    435: "CHECKBOX.PROPERTIES",
    436: "LABEL.PROPERTIES",
    437: "LISTBOX.PROPERTIES",
    438: "EDITBOX.PROPERTIES",
    439: "PIVOT.REFRESH",
    440: "LINK.COMBO",
    441: "OPEN.TEXT",
    442: "HIDE.DIALOG",
    443: "SET.DIALOG.FOCUS",
    444: "ENABLE.OBJECT",
    445: "PUSHBUTTON.PROPERTIES",
    446: "SET.DIALOG.DEFAULT",
    447: "FILTER",
    448: "FILTER.SHOW.ALL",
    449: "CLEAR.OUTLINE",
    450: "FUNCTION.WIZARD",
    451: "ADD.LIST.ITEM",
    452: "SET.LIST.ITEM",
    453: "REMOVE.LIST.ITEM",
    454: "SELECT.LIST.ITEM",
    455: "SET.CONTROL.VALUE",
    456: "SAVE.COPY.AS",
    458: "OPTIONS.LISTS.ADD",
    459: "OPTIONS.LISTS.DELETE",
    460: "SERIES.AXES",
    461: "SERIES.X",
    462: "SERIES.Y",
    463: "ERRORBAR.X",
    464: "ERRORBAR.Y",
    465: "FORMAT.CHART",
    466: "SERIES.ORDER",
    467: "MAIL.LOGOFF",
    468: "CLEAR.ROUTING.SLIP",
    469: "APP.ACTIVATE.MICROSOFT",
    470: "MAIL.EDIT.MAILER",
    471: "ON.SHEET",
    472: "STANDARD.WIDTH",
    473: "SCENARIO.MERGE",
    474: "SUMMARY.INFO",
    475: "FIND.FILE",
    476: "ACTIVE.CELL.FONT",
    477: "ENABLE.TIPWIZARD",
    478: "VBA.MAKE.ADDIN",
    480: "INSERTDATATABLE",
    481: "WORKGROUP.OPTIONS",
    482: "MAIL.SEND.MAILER",
    485: "AUTOCORRECT",
    489: "POST.DOCUMENT",
    491: "PICKLIST",
    493: "VIEW.SHOW",
    494: "VIEW.DEFINE",
    495: "VIEW.DELETE",
    509: "SHEET.BACKGROUND",
    510: "INSERT.MAP.OBJECT",
    511: "OPTIONS.MENONO",
    517: "MSOCHECKS",
    518: "NORMAL",
    519: "LAYOUT",
    520: "RM.PRINT.AREA",
    521: "CLEAR.PRINT.AREA",
    522: "ADD.PRINT.AREA",
    523: "MOVE.BRK",
    545: "HIDECURR.NOTE",
    546: "HIDEALL.NOTES",
    547: "DELETE.NOTE",
    548: "TRAVERSE.NOTES",
    549: "ACTIVATE.NOTES",
    620: "PROTECT.REVISIONS",
    621: "UNPROTECT.REVISIONS",
    647: "OPTIONS.ME",
    653: "WEB.PUBLISH",
    667: "NEWWEBQUERY",
    673: "PIVOT.TABLE.CHART",
    753: "OPTIONS.SAVE",
    755: "OPTIONS.SPELL",
    808: "HIDEALL.INKANNOTS"
};
var $7c3b72a365cc0275$var$Ftab = {
    0: "COUNT",
    1: "IF",
    2: "ISNA",
    3: "ISERROR",
    4: "SUM",
    5: "AVERAGE",
    6: "MIN",
    7: "MAX",
    8: "ROW",
    9: "COLUMN",
    10: "NA",
    11: "NPV",
    12: "STDEV",
    13: "DOLLAR",
    14: "FIXED",
    15: "SIN",
    16: "COS",
    17: "TAN",
    18: "ATAN",
    19: "PI",
    20: "SQRT",
    21: "EXP",
    22: "LN",
    23: "LOG10",
    24: "ABS",
    25: "INT",
    26: "SIGN",
    27: "ROUND",
    28: "LOOKUP",
    29: "INDEX",
    30: "REPT",
    31: "MID",
    32: "LEN",
    33: "VALUE",
    34: "TRUE",
    35: "FALSE",
    36: "AND",
    37: "OR",
    38: "NOT",
    39: "MOD",
    40: "DCOUNT",
    41: "DSUM",
    42: "DAVERAGE",
    43: "DMIN",
    44: "DMAX",
    45: "DSTDEV",
    46: "VAR",
    47: "DVAR",
    48: "TEXT",
    49: "LINEST",
    50: "TREND",
    51: "LOGEST",
    52: "GROWTH",
    53: "GOTO",
    54: "HALT",
    55: "RETURN",
    56: "PV",
    57: "FV",
    58: "NPER",
    59: "PMT",
    60: "RATE",
    61: "MIRR",
    62: "IRR",
    63: "RAND",
    64: "MATCH",
    65: "DATE",
    66: "TIME",
    67: "DAY",
    68: "MONTH",
    69: "YEAR",
    70: "WEEKDAY",
    71: "HOUR",
    72: "MINUTE",
    73: "SECOND",
    74: "NOW",
    75: "AREAS",
    76: "ROWS",
    77: "COLUMNS",
    78: "OFFSET",
    79: "ABSREF",
    80: "RELREF",
    81: "ARGUMENT",
    82: "SEARCH",
    83: "TRANSPOSE",
    84: "ERROR",
    85: "STEP",
    86: "TYPE",
    87: "ECHO",
    88: "SET.NAME",
    89: "CALLER",
    90: "DEREF",
    91: "WINDOWS",
    92: "SERIES",
    93: "DOCUMENTS",
    94: "ACTIVE.CELL",
    95: "SELECTION",
    96: "RESULT",
    97: "ATAN2",
    98: "ASIN",
    99: "ACOS",
    100: "CHOOSE",
    101: "HLOOKUP",
    102: "VLOOKUP",
    103: "LINKS",
    104: "INPUT",
    105: "ISREF",
    106: "GET.FORMULA",
    107: "GET.NAME",
    108: "SET.VALUE",
    109: "LOG",
    110: "EXEC",
    111: "CHAR",
    112: "LOWER",
    113: "UPPER",
    114: "PROPER",
    115: "LEFT",
    116: "RIGHT",
    117: "EXACT",
    118: "TRIM",
    119: "REPLACE",
    120: "SUBSTITUTE",
    121: "CODE",
    122: "NAMES",
    123: "DIRECTORY",
    124: "FIND",
    125: "CELL",
    126: "ISERR",
    127: "ISTEXT",
    128: "ISNUMBER",
    129: "ISBLANK",
    130: "T",
    131: "N",
    132: "FOPEN",
    133: "FCLOSE",
    134: "FSIZE",
    135: "FREADLN",
    136: "FREAD",
    137: "FWRITELN",
    138: "FWRITE",
    139: "FPOS",
    140: "DATEVALUE",
    141: "TIMEVALUE",
    142: "SLN",
    143: "SYD",
    144: "DDB",
    145: "GET.DEF",
    146: "REFTEXT",
    147: "TEXTREF",
    148: "INDIRECT",
    149: "REGISTER",
    150: "CALL",
    151: "ADD.BAR",
    152: "ADD.MENU",
    153: "ADD.COMMAND",
    154: "ENABLE.COMMAND",
    155: "CHECK.COMMAND",
    156: "RENAME.COMMAND",
    157: "SHOW.BAR",
    158: "DELETE.MENU",
    159: "DELETE.COMMAND",
    160: "GET.CHART.ITEM",
    161: "DIALOG.BOX",
    162: "CLEAN",
    163: "MDETERM",
    164: "MINVERSE",
    165: "MMULT",
    166: "FILES",
    167: "IPMT",
    168: "PPMT",
    169: "COUNTA",
    170: "CANCEL.KEY",
    171: "FOR",
    172: "WHILE",
    173: "BREAK",
    174: "NEXT",
    175: "INITIATE",
    176: "REQUEST",
    177: "POKE",
    178: "EXECUTE",
    179: "TERMINATE",
    180: "RESTART",
    181: "HELP",
    182: "GET.BAR",
    183: "PRODUCT",
    184: "FACT",
    185: "GET.CELL",
    186: "GET.WORKSPACE",
    187: "GET.WINDOW",
    188: "GET.DOCUMENT",
    189: "DPRODUCT",
    190: "ISNONTEXT",
    191: "GET.NOTE",
    192: "NOTE",
    193: "STDEVP",
    194: "VARP",
    195: "DSTDEVP",
    196: "DVARP",
    197: "TRUNC",
    198: "ISLOGICAL",
    199: "DCOUNTA",
    200: "DELETE.BAR",
    201: "UNREGISTER",
    204: "USDOLLAR",
    205: "FINDB",
    206: "SEARCHB",
    207: "REPLACEB",
    208: "LEFTB",
    209: "RIGHTB",
    210: "MIDB",
    211: "LENB",
    212: "ROUNDUP",
    213: "ROUNDDOWN",
    214: "ASC",
    215: "DBCS",
    216: "RANK",
    219: "ADDRESS",
    220: "DAYS360",
    221: "TODAY",
    222: "VDB",
    223: "ELSE",
    224: "ELSE.IF",
    225: "END.IF",
    226: "FOR.CELL",
    227: "MEDIAN",
    228: "SUMPRODUCT",
    229: "SINH",
    230: "COSH",
    231: "TANH",
    232: "ASINH",
    233: "ACOSH",
    234: "ATANH",
    235: "DGET",
    236: "CREATE.OBJECT",
    237: "VOLATILE",
    238: "LAST.ERROR",
    239: "CUSTOM.UNDO",
    240: "CUSTOM.REPEAT",
    241: "FORMULA.CONVERT",
    242: "GET.LINK.INFO",
    243: "TEXT.BOX",
    244: "INFO",
    245: "GROUP",
    246: "GET.OBJECT",
    247: "DB",
    248: "PAUSE",
    251: "RESUME",
    252: "FREQUENCY",
    253: "ADD.TOOLBAR",
    254: "DELETE.TOOLBAR",
    255: "User",
    256: "RESET.TOOLBAR",
    257: "EVALUATE",
    258: "GET.TOOLBAR",
    259: "GET.TOOL",
    260: "SPELLING.CHECK",
    261: "ERROR.TYPE",
    262: "APP.TITLE",
    263: "WINDOW.TITLE",
    264: "SAVE.TOOLBAR",
    265: "ENABLE.TOOL",
    266: "PRESS.TOOL",
    267: "REGISTER.ID",
    268: "GET.WORKBOOK",
    269: "AVEDEV",
    270: "BETADIST",
    271: "GAMMALN",
    272: "BETAINV",
    273: "BINOMDIST",
    274: "CHIDIST",
    275: "CHIINV",
    276: "COMBIN",
    277: "CONFIDENCE",
    278: "CRITBINOM",
    279: "EVEN",
    280: "EXPONDIST",
    281: "FDIST",
    282: "FINV",
    283: "FISHER",
    284: "FISHERINV",
    285: "FLOOR",
    286: "GAMMADIST",
    287: "GAMMAINV",
    288: "CEILING",
    289: "HYPGEOMDIST",
    290: "LOGNORMDIST",
    291: "LOGINV",
    292: "NEGBINOMDIST",
    293: "NORMDIST",
    294: "NORMSDIST",
    295: "NORMINV",
    296: "NORMSINV",
    297: "STANDARDIZE",
    298: "ODD",
    299: "PERMUT",
    300: "POISSON",
    301: "TDIST",
    302: "WEIBULL",
    303: "SUMXMY2",
    304: "SUMX2MY2",
    305: "SUMX2PY2",
    306: "CHITEST",
    307: "CORREL",
    308: "COVAR",
    309: "FORECAST",
    310: "FTEST",
    311: "INTERCEPT",
    312: "PEARSON",
    313: "RSQ",
    314: "STEYX",
    315: "SLOPE",
    316: "TTEST",
    317: "PROB",
    318: "DEVSQ",
    319: "GEOMEAN",
    320: "HARMEAN",
    321: "SUMSQ",
    322: "KURT",
    323: "SKEW",
    324: "ZTEST",
    325: "LARGE",
    326: "SMALL",
    327: "QUARTILE",
    328: "PERCENTILE",
    329: "PERCENTRANK",
    330: "MODE",
    331: "TRIMMEAN",
    332: "TINV",
    334: "MOVIE.COMMAND",
    335: "GET.MOVIE",
    336: "CONCATENATE",
    337: "POWER",
    338: "PIVOT.ADD.DATA",
    339: "GET.PIVOT.TABLE",
    340: "GET.PIVOT.FIELD",
    341: "GET.PIVOT.ITEM",
    342: "RADIANS",
    343: "DEGREES",
    344: "SUBTOTAL",
    345: "SUMIF",
    346: "COUNTIF",
    347: "COUNTBLANK",
    348: "SCENARIO.GET",
    349: "OPTIONS.LISTS.GET",
    350: "ISPMT",
    351: "DATEDIF",
    352: "DATESTRING",
    353: "NUMBERSTRING",
    354: "ROMAN",
    355: "OPEN.DIALOG",
    356: "SAVE.DIALOG",
    357: "VIEW.GET",
    358: "GETPIVOTDATA",
    359: "HYPERLINK",
    360: "PHONETIC",
    361: "AVERAGEA",
    362: "MAXA",
    363: "MINA",
    364: "STDEVPA",
    365: "VARPA",
    366: "STDEVA",
    367: "VARA",
    368: "BAHTTEXT",
    369: "THAIDAYOFWEEK",
    370: "THAIDIGIT",
    371: "THAIMONTHOFYEAR",
    372: "THAINUMSOUND",
    373: "THAINUMSTRING",
    374: "THAISTRINGLENGTH",
    375: "ISTHAIDIGIT",
    376: "ROUNDBAHTDOWN",
    377: "ROUNDBAHTUP",
    378: "THAIYEAR",
    379: "RTD",
    380: "CUBEVALUE",
    381: "CUBEMEMBER",
    382: "CUBEMEMBERPROPERTY",
    383: "CUBERANKEDMEMBER",
    384: "HEX2BIN",
    385: "HEX2DEC",
    386: "HEX2OCT",
    387: "DEC2BIN",
    388: "DEC2HEX",
    389: "DEC2OCT",
    390: "OCT2BIN",
    391: "OCT2HEX",
    392: "OCT2DEC",
    393: "BIN2DEC",
    394: "BIN2OCT",
    395: "BIN2HEX",
    396: "IMSUB",
    397: "IMDIV",
    398: "IMPOWER",
    399: "IMABS",
    400: "IMSQRT",
    401: "IMLN",
    402: "IMLOG2",
    403: "IMLOG10",
    404: "IMSIN",
    405: "IMCOS",
    406: "IMEXP",
    407: "IMARGUMENT",
    408: "IMCONJUGATE",
    409: "IMAGINARY",
    410: "IMREAL",
    411: "COMPLEX",
    412: "IMSUM",
    413: "IMPRODUCT",
    414: "SERIESSUM",
    415: "FACTDOUBLE",
    416: "SQRTPI",
    417: "QUOTIENT",
    418: "DELTA",
    419: "GESTEP",
    420: "ISEVEN",
    421: "ISODD",
    422: "MROUND",
    423: "ERF",
    424: "ERFC",
    425: "BESSELJ",
    426: "BESSELK",
    427: "BESSELY",
    428: "BESSELI",
    429: "XIRR",
    430: "XNPV",
    431: "PRICEMAT",
    432: "YIELDMAT",
    433: "INTRATE",
    434: "RECEIVED",
    435: "DISC",
    436: "PRICEDISC",
    437: "YIELDDISC",
    438: "TBILLEQ",
    439: "TBILLPRICE",
    440: "TBILLYIELD",
    441: "PRICE",
    442: "YIELD",
    443: "DOLLARDE",
    444: "DOLLARFR",
    445: "NOMINAL",
    446: "EFFECT",
    447: "CUMPRINC",
    448: "CUMIPMT",
    449: "EDATE",
    450: "EOMONTH",
    451: "YEARFRAC",
    452: "COUPDAYBS",
    453: "COUPDAYS",
    454: "COUPDAYSNC",
    455: "COUPNCD",
    456: "COUPNUM",
    457: "COUPPCD",
    458: "DURATION",
    459: "MDURATION",
    460: "ODDLPRICE",
    461: "ODDLYIELD",
    462: "ODDFPRICE",
    463: "ODDFYIELD",
    464: "RANDBETWEEN",
    465: "WEEKNUM",
    466: "AMORDEGRC",
    467: "AMORLINC",
    468: "CONVERT",
    724: "SHEETJS",
    469: "ACCRINT",
    470: "ACCRINTM",
    471: "WORKDAY",
    472: "NETWORKDAYS",
    473: "GCD",
    474: "MULTINOMIAL",
    475: "LCM",
    476: "FVSCHEDULE",
    477: "CUBEKPIMEMBER",
    478: "CUBESET",
    479: "CUBESETCOUNT",
    480: "IFERROR",
    481: "COUNTIFS",
    482: "SUMIFS",
    483: "AVERAGEIF",
    484: "AVERAGEIFS"
};
var $7c3b72a365cc0275$var$FtabArgc = {
    2: 1,
    3: 1,
    10: 0,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    34: 0,
    35: 0,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    63: 0,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    74: 0,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    89: 0,
    90: 1,
    94: 0,
    95: 0,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    106: 1,
    108: 2,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    161: 1,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    186: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    225: 0,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    382: 3,
    385: 1,
    392: 1,
    393: 1,
    396: 2,
    397: 2,
    398: 2,
    399: 1,
    400: 1,
    401: 1,
    402: 1,
    403: 1,
    404: 1,
    405: 1,
    406: 1,
    407: 1,
    408: 1,
    409: 1,
    410: 1,
    414: 4,
    415: 1,
    416: 1,
    417: 2,
    420: 1,
    421: 1,
    422: 2,
    424: 1,
    425: 2,
    426: 2,
    427: 2,
    428: 2,
    430: 3,
    438: 3,
    439: 3,
    440: 3,
    443: 2,
    444: 2,
    445: 2,
    446: 2,
    447: 6,
    448: 6,
    449: 2,
    450: 2,
    464: 2,
    468: 3,
    476: 2,
    479: 1,
    480: 2,
    65535: 0
};
/* Part 3 TODO: actually parse formulae */ function $7c3b72a365cc0275$var$ods_to_csf_formula(f /*:string*/ ) /*:string*/ {
    if (f.slice(0, 3) == "of:") f = f.slice(3);
    /* 5.2 Basic Expressions */ if (f.charCodeAt(0) == 61) {
        f = f.slice(1);
        if (f.charCodeAt(0) == 61) f = f.slice(1);
    }
    f = f.replace(/COM\.MICROSOFT\./g, "");
    /* Part 3 Section 5.8 References */ f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) {
        return $1.replace(/\./g, "");
    });
    /* TODO: something other than this */ f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
    return f.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function $7c3b72a365cc0275$var$csf_to_ods_formula(f /*:string*/ ) /*:string*/ {
    var o = "of:=" + f.replace($7c3b72a365cc0275$var$crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
    /* TODO: something other than this */ return o.replace(/;/g, "|").replace(/,/g, ";");
}
function $7c3b72a365cc0275$var$ods_to_csf_3D(r /*:string*/ ) /*:[string, string]*/ {
    var a = r.split(":");
    var s = a[0].split(".")[0];
    return [
        s,
        a[0].split(".")[1] + (a.length > 1 ? ":" + (a[1].split(".")[1] || a[1].split(".")[0]) : "")
    ];
}
function $7c3b72a365cc0275$var$csf_to_ods_3D(r /*:string*/ ) /*:string*/ {
    return r.replace(/\./, "!");
}
var $7c3b72a365cc0275$var$strs = {}; // shared strings
var $7c3b72a365cc0275$var$_ssfopts = {}; // spreadsheet formatting options
/*global Map */ var $7c3b72a365cc0275$var$browser_has_Map = typeof Map !== 'undefined';
function $7c3b72a365cc0275$var$get_sst_id(sst /*:SST*/ , str /*:string*/ , rev) /*:number*/ {
    var i = 0, len = sst.length;
    if (rev) {
        if ($7c3b72a365cc0275$var$browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
            var revarr = $7c3b72a365cc0275$var$browser_has_Map ? rev.get(str) : rev[str];
            for(; i < revarr.length; ++i)if (sst[revarr[i]].t === str) {
                sst.Count++;
                return revarr[i];
            }
        }
    } else for(; i < len; ++i)if (sst[i].t === str) {
        sst.Count++;
        return i;
    }
    sst[len] = {
        t: str
    } /*:any*/ ;
    sst.Count++;
    sst.Unique++;
    if (rev) {
        if ($7c3b72a365cc0275$var$browser_has_Map) {
            if (!rev.has(str)) rev.set(str, []);
            rev.get(str).push(len);
        } else {
            if (!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
            rev[str].push(len);
        }
    }
    return len;
}
function $7c3b72a365cc0275$var$col_obj_w(C /*:number*/ , col) {
    var p = {
        min: C + 1,
        max: C + 1
    } /*:any*/ ;
    /* wch (chars), wpx (pixels) */ var wch = -1;
    if (col.MDW) $7c3b72a365cc0275$var$MDW = col.MDW;
    if (col.width != null) p.customWidth = 1;
    else if (col.wpx != null) wch = $7c3b72a365cc0275$var$px2char(col.wpx);
    else if (col.wch != null) wch = col.wch;
    if (wch > -1) {
        p.width = $7c3b72a365cc0275$var$char2width(wch);
        p.customWidth = 1;
    } else if (col.width != null) p.width = col.width;
    if (col.hidden) p.hidden = true;
    if (col.level != null) p.outlineLevel = p.level = col.level;
    return p;
}
function $7c3b72a365cc0275$var$default_margins(margins /*:Margins*/ , mode /*:?string*/ ) {
    if (!margins) return;
    var defs = [
        0.7,
        0.7,
        0.75,
        0.75,
        0.3,
        0.3
    ];
    if (mode == 'xlml') defs = [
        1,
        1,
        1,
        1,
        0.5,
        0.5
    ];
    if (margins.left == null) margins.left = defs[0];
    if (margins.right == null) margins.right = defs[1];
    if (margins.top == null) margins.top = defs[2];
    if (margins.bottom == null) margins.bottom = defs[3];
    if (margins.header == null) margins.header = defs[4];
    if (margins.footer == null) margins.footer = defs[5];
}
function $7c3b72a365cc0275$var$get_cell_style(styles /*:Array<any>*/ , cell /*:Cell*/ , opts) {
    var z = opts.revssf[cell.z != null ? cell.z : "General"];
    var i = 0x3c, len = styles.length;
    if (z == null && opts.ssf) {
        for(; i < 0x188; ++i)if (opts.ssf[i] == null) {
            $7c3b72a365cc0275$var$SSF_load(cell.z, i);
            // $FlowIgnore
            opts.ssf[i] = cell.z;
            opts.revssf[cell.z] = z = i;
            break;
        }
    }
    for(i = 0; i != len; ++i)if (styles[i].numFmtId === z) return i;
    styles[len] = {
        numFmtId: z,
        fontId: 0,
        fillId: 0,
        borderId: 0,
        xfId: 0,
        applyNumberFormat: 1
    };
    return len;
}
function $7c3b72a365cc0275$var$safe_format(p /*:Cell*/ , fmtid /*:number*/ , fillid /*:?number*/ , opts, themes, styles) {
    try {
        if (opts.cellNF) p.z = $7c3b72a365cc0275$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (p.t === 'z' && !opts.cellStyles) return;
    if (p.t === 'd' && typeof p.v === 'string') p.v = $7c3b72a365cc0275$var$parseDate(p.v);
    if ((!opts || opts.cellText !== false) && p.t !== 'z') try {
        if ($7c3b72a365cc0275$var$table_fmt[fmtid] == null) $7c3b72a365cc0275$var$SSF_load($7c3b72a365cc0275$var$SSFImplicit[fmtid] || "General", fmtid);
        if (p.t === 'e') p.w = p.w || $7c3b72a365cc0275$var$BErr[p.v];
        else if (fmtid === 0) {
            if (p.t === 'n') {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $7c3b72a365cc0275$var$SSF_general_num(p.v);
            } else if (p.t === 'd') {
                var dd = $7c3b72a365cc0275$var$datenum(p.v);
                if ((dd | 0) === dd) p.w = dd.toString(10);
                else p.w = $7c3b72a365cc0275$var$SSF_general_num(dd);
            } else if (p.v === undefined) return "";
            else p.w = $7c3b72a365cc0275$var$SSF_general(p.v, $7c3b72a365cc0275$var$_ssfopts);
        } else if (p.t === 'd') p.w = $7c3b72a365cc0275$var$SSF_format(fmtid, $7c3b72a365cc0275$var$datenum(p.v), $7c3b72a365cc0275$var$_ssfopts);
        else p.w = $7c3b72a365cc0275$var$SSF_format(fmtid, p.v, $7c3b72a365cc0275$var$_ssfopts);
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts.cellStyles) return;
    if (fillid != null) try {
        p.s = styles.Fills[fillid];
        if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
            p.s.fgColor.rgb = $7c3b72a365cc0275$var$rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
            if (opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
        }
        if (p.s.bgColor && p.s.bgColor.theme) {
            p.s.bgColor.rgb = $7c3b72a365cc0275$var$rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
            if (opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
        }
    } catch (e) {
        if (opts.WTF && styles.Fills) throw e;
    }
}
function $7c3b72a365cc0275$var$check_ws(ws /*:Worksheet*/ , sname /*:string*/ , i /*:number*/ ) {
    if (ws && ws['!ref']) {
        var range = $7c3b72a365cc0275$var$safe_decode_range(ws['!ref']);
        if (range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
    }
}
function $7c3b72a365cc0275$var$parse_ws_xml_dim(ws /*:Worksheet*/ , s /*:string*/ ) {
    var d = $7c3b72a365cc0275$var$safe_decode_range(s);
    if (d.s.r <= d.e.r && d.s.c <= d.e.c && d.s.r >= 0 && d.s.c >= 0) ws["!ref"] = $7c3b72a365cc0275$var$encode_range(d);
}
var $7c3b72a365cc0275$var$mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
var $7c3b72a365cc0275$var$sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;
var $7c3b72a365cc0275$var$hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
var $7c3b72a365cc0275$var$dimregex = /"(\w*:\w*)"/;
var $7c3b72a365cc0275$var$colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
var $7c3b72a365cc0275$var$afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
var $7c3b72a365cc0275$var$marginregex = /<(?:\w:)?pageMargins[^>]*\/>/g;
var $7c3b72a365cc0275$var$sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
var $7c3b72a365cc0275$var$sheetprregex2 = /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;
var $7c3b72a365cc0275$var$svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
/* 18.3 Worksheets */ function $7c3b72a365cc0275$var$parse_ws_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        '!id': {}
    };
    if ($7c3b72a365cc0275$var$DENSE != null && opts.dense == null) opts.dense = $7c3b72a365cc0275$var$DENSE;
    /* 18.3.1.99 worksheet CT_Worksheet */ var s = opts.dense ? [] : {} /*:any*/ ;
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    } /*:any*/ ;
    var data1 = "", data2 = "";
    var mtch /*:?any*/  = data.match($7c3b72a365cc0275$var$sheetdataregex);
    if (mtch) {
        data1 = data.slice(0, mtch.index);
        data2 = data.slice(mtch.index + mtch[0].length);
    } else data1 = data2 = data;
    /* 18.3.1.82 sheetPr CT_SheetPr */ var sheetPr = data1.match($7c3b72a365cc0275$var$sheetprregex);
    if (sheetPr) $7c3b72a365cc0275$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    else if (sheetPr = data1.match($7c3b72a365cc0275$var$sheetprregex2)) $7c3b72a365cc0275$var$parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1] || "", s, wb, idx, styles, themes);
    /* 18.3.1.35 dimension CT_SheetDimension */ var ridx = (data1.match(/<(?:\w*:)?dimension/) || {
        index: -1
    }).index;
    if (ridx > 0) {
        var ref = data1.slice(ridx, ridx + 50).match($7c3b72a365cc0275$var$dimregex);
        if (ref) $7c3b72a365cc0275$var$parse_ws_xml_dim(s, ref[1]);
    }
    /* 18.3.1.88 sheetViews CT_SheetViews */ var svs = data1.match($7c3b72a365cc0275$var$svsregex);
    if (svs && svs[1]) $7c3b72a365cc0275$var$parse_ws_xml_sheetviews(svs[1], wb);
    /* 18.3.1.17 cols CT_Cols */ var columns /*:Array<ColInfo>*/  = [];
    if (opts.cellStyles) {
        /* 18.3.1.13 col CT_Col */ var cols = data1.match($7c3b72a365cc0275$var$colregex);
        if (cols) $7c3b72a365cc0275$var$parse_ws_xml_cols(columns, cols);
    }
    /* 18.3.1.80 sheetData CT_SheetData ? */ if (mtch) $7c3b72a365cc0275$var$parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);
    /* 18.3.1.2  autoFilter CT_AutoFilter */ var afilter = data2.match($7c3b72a365cc0275$var$afregex);
    if (afilter) s['!autofilter'] = $7c3b72a365cc0275$var$parse_ws_xml_autofilter(afilter[0]);
    /* 18.3.1.55 mergeCells CT_MergeCells */ var merges /*:Array<Range>*/  = [];
    var _merge = data2.match($7c3b72a365cc0275$var$mergecregex);
    if (_merge) for(ridx = 0; ridx != _merge.length; ++ridx)merges[ridx] = $7c3b72a365cc0275$var$safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"") + 1));
    /* 18.3.1.48 hyperlinks CT_Hyperlinks */ var hlink = data2.match($7c3b72a365cc0275$var$hlinkregex);
    if (hlink) $7c3b72a365cc0275$var$parse_ws_xml_hlinks(s, hlink, rels);
    /* 18.3.1.62 pageMargins CT_PageMargins */ var margins = data2.match($7c3b72a365cc0275$var$marginregex);
    if (margins) s['!margins'] = $7c3b72a365cc0275$var$parse_ws_xml_margins($7c3b72a365cc0275$var$parsexmltag(margins[0]));
    if (!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = $7c3b72a365cc0275$var$encode_range(refguess);
    if (opts.sheetRows > 0 && s["!ref"]) {
        var tmpref = $7c3b72a365cc0275$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $7c3b72a365cc0275$var$encode_range(tmpref);
        }
    }
    if (columns.length > 0) s["!cols"] = columns;
    if (merges.length > 0) s["!merges"] = merges;
    return s;
}
function $7c3b72a365cc0275$var$write_ws_xml_merges(merges /*:Array<Range>*/ ) /*:string*/ {
    if (merges.length === 0) return "";
    var o = '<mergeCells count="' + merges.length + '">';
    for(var i = 0; i != merges.length; ++i)o += '<mergeCell ref="' + $7c3b72a365cc0275$var$encode_range(merges[i]) + '"/>';
    return o + '</mergeCells>';
}
/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */ function $7c3b72a365cc0275$var$parse_ws_xml_sheetpr(sheetPr /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    var data = $7c3b72a365cc0275$var$parsexmltag(sheetPr);
    if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
    if (data.codeName) wb.Sheets[idx].CodeName = $7c3b72a365cc0275$var$unescapexml($7c3b72a365cc0275$var$utf8read(data.codeName));
}
function $7c3b72a365cc0275$var$parse_ws_xml_sheetpr2(sheetPr /*:string*/ , body /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    $7c3b72a365cc0275$var$parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
}
function $7c3b72a365cc0275$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
    var needed = false;
    var props = {}, payload = null;
    if (opts.bookType !== 'xlsx' && wb.vbaraw) {
        var cname = wb.SheetNames[idx];
        try {
            if (wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname;
        } catch (e) {}
        needed = true;
        props.codeName = $7c3b72a365cc0275$var$utf8write($7c3b72a365cc0275$var$escapexml(cname));
    }
    if (ws && ws["!outline"]) {
        var outlineprops = {
            summaryBelow: 1,
            summaryRight: 1
        };
        if (ws["!outline"].above) outlineprops.summaryBelow = 0;
        if (ws["!outline"].left) outlineprops.summaryRight = 0;
        payload = (payload || "") + $7c3b72a365cc0275$var$writextag('outlinePr', null, outlineprops);
    }
    if (!needed && !payload) return;
    o[o.length] = $7c3b72a365cc0275$var$writextag('sheetPr', payload, props);
}
/* 18.3.1.85 sheetProtection CT_SheetProtection */ var $7c3b72a365cc0275$var$sheetprot_deffalse = [
    "objects",
    "scenarios",
    "selectLockedCells",
    "selectUnlockedCells"
];
var $7c3b72a365cc0275$var$sheetprot_deftrue = [
    "formatColumns",
    "formatRows",
    "formatCells",
    "insertColumns",
    "insertRows",
    "insertHyperlinks",
    "deleteColumns",
    "deleteRows",
    "sort",
    "autoFilter",
    "pivotTables"
];
function $7c3b72a365cc0275$var$write_ws_xml_protection(sp) /*:string*/ {
    // algorithmName, hashValue, saltValue, spinCount
    var o = {
        sheet: 1
    } /*:any*/ ;
    $7c3b72a365cc0275$var$sheetprot_deffalse.forEach(function(n) {
        if (sp[n] != null && sp[n]) o[n] = "1";
    });
    $7c3b72a365cc0275$var$sheetprot_deftrue.forEach(function(n) {
        if (sp[n] != null && !sp[n]) o[n] = "0";
    });
    /* TODO: algorithm */ if (sp.password) o.password = $7c3b72a365cc0275$var$crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
    return $7c3b72a365cc0275$var$writextag('sheetProtection', null, o);
}
function $7c3b72a365cc0275$var$parse_ws_xml_hlinks(s, data /*:Array<string>*/ , rels) {
    var dense = Array.isArray(s);
    for(var i = 0; i != data.length; ++i){
        var val = $7c3b72a365cc0275$var$parsexmltag($7c3b72a365cc0275$var$utf8read(data[i]), true);
        if (!val.ref) return;
        var rel = ((rels || {})['!id'] || [])[val.id];
        if (rel) {
            val.Target = rel.Target;
            if (val.location) val.Target += "#" + $7c3b72a365cc0275$var$unescapexml(val.location);
        } else {
            val.Target = "#" + $7c3b72a365cc0275$var$unescapexml(val.location);
            rel = {
                Target: val.Target,
                TargetMode: 'Internal'
            };
        }
        val.Rel = rel;
        if (val.tooltip) {
            val.Tooltip = val.tooltip;
            delete val.tooltip;
        }
        var rng = $7c3b72a365cc0275$var$safe_decode_range(val.ref);
        for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
            var addr = $7c3b72a365cc0275$var$encode_cell({
                c: C,
                r: R
            });
            if (dense) {
                if (!s[R]) s[R] = [];
                if (!s[R][C]) s[R][C] = {
                    t: "z",
                    v: undefined
                };
                s[R][C].l = val;
            } else {
                if (!s[addr]) s[addr] = {
                    t: "z",
                    v: undefined
                };
                s[addr].l = val;
            }
        }
    }
}
function $7c3b72a365cc0275$var$parse_ws_xml_margins(margin) {
    var o = {};
    [
        "left",
        "right",
        "top",
        "bottom",
        "header",
        "footer"
    ].forEach(function(k) {
        if (margin[k]) o[k] = parseFloat(margin[k]);
    });
    return o;
}
function $7c3b72a365cc0275$var$write_ws_xml_margins(margin) /*:string*/ {
    $7c3b72a365cc0275$var$default_margins(margin);
    return $7c3b72a365cc0275$var$writextag('pageMargins', null, margin);
}
function $7c3b72a365cc0275$var$parse_ws_xml_cols(columns, cols) {
    var seencol = false;
    for(var coli = 0; coli != cols.length; ++coli){
        var coll = $7c3b72a365cc0275$var$parsexmltag(cols[coli], true);
        if (coll.hidden) coll.hidden = $7c3b72a365cc0275$var$parsexmlbool(coll.hidden);
        var colm = parseInt(coll.min, 10) - 1, colM = parseInt(coll.max, 10) - 1;
        if (coll.outlineLevel) coll.level = +coll.outlineLevel || 0;
        delete coll.min;
        delete coll.max;
        coll.width = +coll.width;
        if (!seencol && coll.width) {
            seencol = true;
            $7c3b72a365cc0275$var$find_mdw_colw(coll.width);
        }
        $7c3b72a365cc0275$var$process_col(coll);
        while(colm <= colM)columns[colm++] = $7c3b72a365cc0275$var$dup(coll);
    }
}
function $7c3b72a365cc0275$var$write_ws_xml_cols(ws, cols) /*:string*/ {
    var o = [
        "<cols>"
    ], col;
    for(var i = 0; i != cols.length; ++i){
        if (!(col = cols[i])) continue;
        o[o.length] = $7c3b72a365cc0275$var$writextag('col', null, $7c3b72a365cc0275$var$col_obj_w(i, col));
    }
    o[o.length] = "</cols>";
    return o.join("");
}
function $7c3b72a365cc0275$var$parse_ws_xml_autofilter(data /*:string*/ ) {
    var o = {
        ref: (data.match(/ref="([^"]*)"/) || [])[1]
    };
    return o;
}
function $7c3b72a365cc0275$var$write_ws_xml_autofilter(data, ws, wb, idx) /*:string*/ {
    var ref = typeof data.ref == "string" ? data.ref : $7c3b72a365cc0275$var$encode_range(data.ref);
    if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $7c3b72a365cc0275$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $7c3b72a365cc0275$var$decode_range(ws["!ref"]).e.r;
        ref = $7c3b72a365cc0275$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != '_xlnm._FilterDatabase') continue;
        if (name.Sheet != idx) continue;
        name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref;
        break;
    }
    if (i == names.length) names.push({
        Name: '_xlnm._FilterDatabase',
        Sheet: idx,
        Ref: "'" + wb.SheetNames[idx] + "'!" + ref
    });
    return $7c3b72a365cc0275$var$writextag("autoFilter", null, {
        ref: ref
    });
}
/* 18.3.1.88 sheetViews CT_SheetViews */ /* 18.3.1.87 sheetView CT_SheetView */ var $7c3b72a365cc0275$var$sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
function $7c3b72a365cc0275$var$parse_ws_xml_sheetviews(data, wb /*:WBWBProps*/ ) {
    if (!wb.Views) wb.Views = [
        {}
    ];
    (data.match($7c3b72a365cc0275$var$sviewregex) || []).forEach(function(r /*:string*/ , i /*:number*/ ) {
        var tag = $7c3b72a365cc0275$var$parsexmltag(r);
        // $FlowIgnore
        if (!wb.Views[i]) wb.Views[i] = {};
        // $FlowIgnore
        if (+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
        // $FlowIgnore
        if ($7c3b72a365cc0275$var$parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
    });
}
function $7c3b72a365cc0275$var$write_ws_xml_sheetviews(ws, opts, idx, wb) /*:string*/ {
    var sview = {
        workbookViewId: "0"
    } /*:any*/ ;
    // $FlowIgnore
    if ((((wb || {}).Workbook || {}).Views || [])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
    return $7c3b72a365cc0275$var$writextag("sheetViews", $7c3b72a365cc0275$var$writextag("sheetView", null, sview), {});
}
function $7c3b72a365cc0275$var$write_ws_xml_cell(cell /*:Cell*/ , ref, ws, opts /*::, idx, wb*/ ) /*:string*/ {
    if (cell.c) ws['!comments'].push([
        ref,
        cell.c
    ]);
    if (cell.v === undefined && typeof cell.f !== "string" || cell.t === 'z' && !cell.f) return "";
    var vv = "";
    var oldt = cell.t, oldv = cell.v;
    if (cell.t !== "z") switch(cell.t){
        case 'b':
            vv = cell.v ? "1" : "0";
            break;
        case 'n':
            vv = '' + cell.v;
            break;
        case 'e':
            vv = $7c3b72a365cc0275$var$BErr[cell.v];
            break;
        case 'd':
            if (opts && opts.cellDates) vv = $7c3b72a365cc0275$var$parseDate(cell.v, -1).toISOString();
            else {
                cell = $7c3b72a365cc0275$var$dup(cell);
                cell.t = 'n';
                vv = '' + (cell.v = $7c3b72a365cc0275$var$datenum($7c3b72a365cc0275$var$parseDate(cell.v)));
            }
            if (typeof cell.z === 'undefined') cell.z = $7c3b72a365cc0275$var$table_fmt[14];
            break;
        default:
            vv = cell.v;
            break;
    }
    var v = $7c3b72a365cc0275$var$writetag('v', $7c3b72a365cc0275$var$escapexml(vv)), o = {
        r: ref
    } /*:any*/ ;
    /* TODO: cell style */ var os = $7c3b72a365cc0275$var$get_cell_style(opts.cellXfs, cell, opts);
    if (os !== 0) o.s = os;
    switch(cell.t){
        case 'n':
            break;
        case 'd':
            o.t = "d";
            break;
        case 'b':
            o.t = "b";
            break;
        case 'e':
            o.t = "e";
            break;
        case 'z':
            break;
        default:
            if (cell.v == null) {
                delete cell.t;
                break;
            }
            if (cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
            if (opts && opts.bookSST) {
                v = $7c3b72a365cc0275$var$writetag('v', '' + $7c3b72a365cc0275$var$get_sst_id(opts.Strings, cell.v, opts.revStrings));
                o.t = "s";
                break;
            }
            o.t = "str";
            break;
    }
    if (cell.t != oldt) {
        cell.t = oldt;
        cell.v = oldv;
    }
    if (typeof cell.f == "string" && cell.f) {
        var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {
            t: "array",
            ref: cell.F
        } : null;
        v = $7c3b72a365cc0275$var$writextag('f', $7c3b72a365cc0275$var$escapexml(cell.f), ff) + (cell.v != null ? v : "");
    }
    if (cell.l) ws['!links'].push([
        ref,
        cell.l
    ]);
    if (cell.D) o.cm = 1;
    return $7c3b72a365cc0275$var$writextag('c', v, o);
}
var $7c3b72a365cc0275$var$parse_ws_xml_data = /*#__PURE__*/ function() {
    var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
    var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
    var refregex = /ref=["']([^"']*)["']/;
    var match_v = $7c3b72a365cc0275$var$matchtag("v"), match_f = $7c3b72a365cc0275$var$matchtag("f");
    return function parse_ws_xml_data(sdata /*:string*/ , s, opts, guess /*:Range*/ , themes, styles) {
        var ri = 0, x = "", cells /*:Array<string>*/  = [], cref /*:?Array<string>*/  = [], idx = 0, i = 0, cc = 0, d = "", p /*:any*/ ;
        var tag, tagr = 0, tagc = 0;
        var sstr, ftag;
        var fmtid = 0, fillid = 0;
        var do_format = Array.isArray(styles.CellXf), cf;
        var arrayf /*:Array<[Range, string]>*/  = [];
        var sharedf = [];
        var dense = Array.isArray(s);
        var rows /*:Array<RowInfo>*/  = [], rowobj = {}, rowrite = false;
        var sheetStubs = !!opts.sheetStubs;
        for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt){
            x = marr[mt].trim();
            var xlen = x.length;
            if (xlen === 0) continue;
            /* 18.3.1.73 row CT_Row */ var rstarti = 0;
            outa: for(ri = 0; ri < xlen; ++ri)switch(/*x.charCodeAt(ri)*/ x[ri]){
                case ">" /*62*/ :
                    if (/*x.charCodeAt(ri-1) != 47*/ x[ri - 1] != "/") {
                        ++ri;
                        break outa;
                    }
                    if (opts && opts.cellStyles) {
                        // TODO: avoid duplication
                        tag = $7c3b72a365cc0275$var$parsexmltag(x.slice(rstarti, ri), true);
                        tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
                        tagc = -1;
                        if (opts.sheetRows && opts.sheetRows < tagr) continue;
                        rowobj = {};
                        rowrite = false;
                        if (tag.ht) {
                            rowrite = true;
                            rowobj.hpt = parseFloat(tag.ht);
                            rowobj.hpx = $7c3b72a365cc0275$var$pt2px(rowobj.hpt);
                        }
                        if (tag.hidden == "1") {
                            rowrite = true;
                            rowobj.hidden = true;
                        }
                        if (tag.outlineLevel != null) {
                            rowrite = true;
                            rowobj.level = +tag.outlineLevel;
                        }
                        if (rowrite) rows[tagr - 1] = rowobj;
                    }
                    break;
                case "<" /*60*/ :
                    rstarti = ri;
                    break;
            }
            if (rstarti >= ri) break;
            tag = $7c3b72a365cc0275$var$parsexmltag(x.slice(rstarti, ri), true);
            tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
            tagc = -1;
            if (opts.sheetRows && opts.sheetRows < tagr) continue;
            if (guess.s.r > tagr - 1) guess.s.r = tagr - 1;
            if (guess.e.r < tagr - 1) guess.e.r = tagr - 1;
            if (opts && opts.cellStyles) {
                rowobj = {};
                rowrite = false;
                if (tag.ht) {
                    rowrite = true;
                    rowobj.hpt = parseFloat(tag.ht);
                    rowobj.hpx = $7c3b72a365cc0275$var$pt2px(rowobj.hpt);
                }
                if (tag.hidden == "1") {
                    rowrite = true;
                    rowobj.hidden = true;
                }
                if (tag.outlineLevel != null) {
                    rowrite = true;
                    rowobj.level = +tag.outlineLevel;
                }
                if (rowrite) rows[tagr - 1] = rowobj;
            }
            /* 18.3.1.4 c CT_Cell */ cells = x.slice(ri).split(cellregex);
            for(var rslice = 0; rslice != cells.length; ++rslice)if (cells[rslice].trim().charAt(0) != "<") break;
            cells = cells.slice(rslice);
            for(ri = 0; ri != cells.length; ++ri){
                x = cells[ri].trim();
                if (x.length === 0) continue;
                cref = x.match(rregex);
                idx = ri;
                i = 0;
                cc = 0;
                x = "<c " + (x.slice(0, 1) == "<" ? ">" : "") + x;
                if (cref != null && cref.length === 2) {
                    idx = 0;
                    d = cref[1];
                    for(i = 0; i != d.length; ++i){
                        if ((cc = d.charCodeAt(i) - 64) < 1 || cc > 26) break;
                        idx = 26 * idx + cc;
                    }
                    --idx;
                    tagc = idx;
                } else ++tagc;
                for(i = 0; i != x.length; ++i)if (x.charCodeAt(i) === 62) break;
                ++i;
                tag = $7c3b72a365cc0275$var$parsexmltag(x.slice(0, i), true);
                if (!tag.r) tag.r = $7c3b72a365cc0275$var$encode_cell({
                    r: tagr - 1,
                    c: tagc
                });
                d = x.slice(i);
                p = {
                    t: ""
                } /*:any*/ ;
                if ((cref = d.match(match_v)) != null && /*::cref != null && */ cref[1] !== '') p.v = $7c3b72a365cc0275$var$unescapexml(cref[1]);
                if (opts.cellFormula) {
                    if ((cref = d.match(match_f)) != null && /*::cref != null && */ cref[1] !== '') {
                        /* TODO: match against XLSXFutureFunctions */ p.f = $7c3b72a365cc0275$var$unescapexml($7c3b72a365cc0275$var$utf8read(cref[1])).replace(/\r\n/g, "\n");
                        if (!opts.xlfn) p.f = $7c3b72a365cc0275$var$_xlfn(p.f);
                        if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="array"') > -1) {
                            p.F = (d.match(refregex) || [])[1];
                            if (p.F.indexOf(":") > -1) arrayf.push([
                                $7c3b72a365cc0275$var$safe_decode_range(p.F),
                                p.F
                            ]);
                        } else if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                            // TODO: parse formula
                            ftag = $7c3b72a365cc0275$var$parsexmltag(cref[0]);
                            var ___f = $7c3b72a365cc0275$var$unescapexml($7c3b72a365cc0275$var$utf8read(cref[1]));
                            if (!opts.xlfn) ___f = $7c3b72a365cc0275$var$_xlfn(___f);
                            sharedf[parseInt(ftag.si, 10)] = [
                                ftag,
                                ___f,
                                tag.r
                            ];
                        }
                    } else if (cref = d.match(/<f[^>]*\/>/)) {
                        ftag = $7c3b72a365cc0275$var$parsexmltag(cref[0]);
                        if (sharedf[ftag.si]) p.f = $7c3b72a365cc0275$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                    }
                    /* TODO: factor out contains logic */ var _tag = $7c3b72a365cc0275$var$decode_cell(tag.r);
                    for(i = 0; i < arrayf.length; ++i)if (_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r) {
                        if (_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c) p.F = arrayf[i][1];
                    }
                }
                if (tag.t == null && p.v === undefined) {
                    if (p.f || p.F) {
                        p.v = 0;
                        p.t = "n";
                    } else if (!sheetStubs) continue;
                    else p.t = "z";
                } else p.t = tag.t || "n";
                if (guess.s.c > tagc) guess.s.c = tagc;
                if (guess.e.c < tagc) guess.e.c = tagc;
                /* 18.18.11 t ST_CellType */ switch(p.t){
                    case 'n':
                        if (p.v == "" || p.v == null) {
                            if (!sheetStubs) continue;
                            p.t = 'z';
                        } else p.v = parseFloat(p.v);
                        break;
                    case 's':
                        if (typeof p.v == 'undefined') {
                            if (!sheetStubs) continue;
                            p.t = 'z';
                        } else {
                            sstr = $7c3b72a365cc0275$var$strs[parseInt(p.v, 10)];
                            p.v = sstr.t;
                            p.r = sstr.r;
                            if (opts.cellHTML) p.h = sstr.h;
                        }
                        break;
                    case 'str':
                        p.t = "s";
                        p.v = p.v != null ? $7c3b72a365cc0275$var$utf8read(p.v) : '';
                        if (opts.cellHTML) p.h = $7c3b72a365cc0275$var$escapehtml(p.v);
                        break;
                    case 'inlineStr':
                        cref = d.match(isregex);
                        p.t = 's';
                        if (cref != null && (sstr = $7c3b72a365cc0275$var$parse_si(cref[1]))) {
                            p.v = sstr.t;
                            if (opts.cellHTML) p.h = sstr.h;
                        } else p.v = "";
                        break;
                    case 'b':
                        p.v = $7c3b72a365cc0275$var$parsexmlbool(p.v);
                        break;
                    case 'd':
                        if (opts.cellDates) p.v = $7c3b72a365cc0275$var$parseDate(p.v, 1);
                        else {
                            p.v = $7c3b72a365cc0275$var$datenum($7c3b72a365cc0275$var$parseDate(p.v, 1));
                            p.t = 'n';
                        }
                        break;
                    /* error string in .w, number in .v */ case 'e':
                        if (!opts || opts.cellText !== false) p.w = p.v;
                        p.v = $7c3b72a365cc0275$var$RBErr[p.v];
                        break;
                }
                /* formatting */ fmtid = fillid = 0;
                cf = null;
                if (do_format && tag.s !== undefined) {
                    cf = styles.CellXf[tag.s];
                    if (cf != null) {
                        if (cf.numFmtId != null) fmtid = cf.numFmtId;
                        if (opts.cellStyles) {
                            if (cf.fillId != null) fillid = cf.fillId;
                        }
                    }
                }
                $7c3b72a365cc0275$var$safe_format(p, fmtid, fillid, opts, themes, styles);
                if (opts.cellDates && do_format && p.t == 'n' && $7c3b72a365cc0275$var$fmt_is_date($7c3b72a365cc0275$var$table_fmt[fmtid])) {
                    p.t = 'd';
                    p.v = $7c3b72a365cc0275$var$numdate(p.v);
                }
                if (tag.cm && opts.xlmeta) {
                    var cm = (opts.xlmeta.Cell || [])[+tag.cm - 1];
                    if (cm && cm.type == 'XLDAPR') p.D = true;
                }
                if (dense) {
                    var _r = $7c3b72a365cc0275$var$decode_cell(tag.r);
                    if (!s[_r.r]) s[_r.r] = [];
                    s[_r.r][_r.c] = p;
                } else s[tag.r] = p;
            }
        }
        if (rows.length > 0) s['!rows'] = rows;
    };
}();
function $7c3b72a365cc0275$var$write_ws_xml_data(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/  /*::, rels*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], r /*:Array<string>*/  = [], range = $7c3b72a365cc0275$var$safe_decode_range(ws['!ref']), cell = "", ref, rr = "", cols /*:Array<string>*/  = [], R = 0, C = 0, rows = ws['!rows'];
    var dense = Array.isArray(ws);
    var params = {
        r: rr
    } /*:any*/ , row /*:RowInfo*/ , height = -1;
    for(C = range.s.c; C <= range.e.c; ++C)cols[C] = $7c3b72a365cc0275$var$encode_col(C);
    for(R = range.s.r; R <= range.e.r; ++R){
        r = [];
        rr = $7c3b72a365cc0275$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            ref = cols[C] + rr;
            var _cell = dense ? (ws[R] || [])[C] : ws[ref];
            if (_cell === undefined) continue;
            if ((cell = $7c3b72a365cc0275$var$write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
        }
        if (r.length > 0 || rows && rows[R]) {
            params = {
                r: rr
            } /*:any*/ ;
            if (rows && rows[R]) {
                row = rows[R];
                if (row.hidden) params.hidden = 1;
                height = -1;
                if (row.hpx) height = $7c3b72a365cc0275$var$px2pt(row.hpx);
                else if (row.hpt) height = row.hpt;
                if (height > -1) {
                    params.ht = height;
                    params.customHeight = 1;
                }
                if (row.level) params.outlineLevel = row.level;
            }
            o[o.length] = $7c3b72a365cc0275$var$writextag('row', r.join(""), params);
        }
    }
    if (rows) {
        for(; R < rows.length; ++R)if (rows && rows[R]) {
            params = {
                r: R + 1
            } /*:any*/ ;
            row = rows[R];
            if (row.hidden) params.hidden = 1;
            height = -1;
            if (row.hpx) height = $7c3b72a365cc0275$var$px2pt(row.hpx);
            else if (row.hpt) height = row.hpt;
            if (height > -1) {
                params.ht = height;
                params.customHeight = 1;
            }
            if (row.level) params.outlineLevel = row.level;
            o[o.length] = $7c3b72a365cc0275$var$writextag('row', "", params);
        }
    }
    return o.join("");
}
function $7c3b72a365cc0275$var$write_ws_xml(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) /*:string*/ {
    var o = [
        $7c3b72a365cc0275$var$XML_HEADER,
        $7c3b72a365cc0275$var$writextag('worksheet', null, {
            'xmlns': $7c3b72a365cc0275$var$XMLNS_main[0],
            'xmlns:r': $7c3b72a365cc0275$var$XMLNS.r
        })
    ];
    var s = wb.SheetNames[idx], sidx = 0, rdata = "";
    var ws = wb.Sheets[s];
    if (ws == null) ws = {};
    var ref = ws['!ref'] || 'A1';
    var range = $7c3b72a365cc0275$var$safe_decode_range(ref);
    if (range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
        range.e.c = Math.min(range.e.c, 0x3FFF);
        range.e.r = Math.min(range.e.c, 0xFFFFF);
        ref = $7c3b72a365cc0275$var$encode_range(range);
    }
    if (!rels) rels = {};
    ws['!comments'] = [];
    var _drawing = [];
    $7c3b72a365cc0275$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o);
    o[o.length] = $7c3b72a365cc0275$var$writextag('dimension', null, {
        'ref': ref
    });
    o[o.length] = $7c3b72a365cc0275$var$write_ws_xml_sheetviews(ws, opts, idx, wb);
    /* TODO: store in WB, process styles */ if (opts.sheetFormat) o[o.length] = $7c3b72a365cc0275$var$writextag('sheetFormatPr', null, {
        defaultRowHeight: opts.sheetFormat.defaultRowHeight || '16',
        baseColWidth: opts.sheetFormat.baseColWidth || '10',
        outlineLevelRow: opts.sheetFormat.outlineLevelRow || '7'
    });
    if (ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = $7c3b72a365cc0275$var$write_ws_xml_cols(ws, ws['!cols']);
    o[sidx = o.length] = '<sheetData/>';
    ws['!links'] = [];
    if (ws['!ref'] != null) {
        rdata = $7c3b72a365cc0275$var$write_ws_xml_data(ws, opts, idx, wb, rels);
        if (rdata.length > 0) o[o.length] = rdata;
    }
    if (o.length > sidx + 1) {
        o[o.length] = '</sheetData>';
        o[sidx] = o[sidx].replace("/>", ">");
    }
    /* sheetCalcPr */ if (ws['!protect']) o[o.length] = $7c3b72a365cc0275$var$write_ws_xml_protection(ws['!protect']);
    /* protectedRanges */ /* scenarios */ if (ws['!autofilter'] != null) o[o.length] = $7c3b72a365cc0275$var$write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);
    /* sortState */ /* dataConsolidate */ /* customSheetViews */ if (ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = $7c3b72a365cc0275$var$write_ws_xml_merges(ws['!merges']);
    /* phoneticPr */ /* conditionalFormatting */ /* dataValidations */ var relc = -1, rel, rId = -1;
    if (/*::(*/ ws['!links']/*::||[])*/ .length > 0) {
        o[o.length] = "<hyperlinks>";
        /*::(*/ ws['!links']/*::||[])*/ .forEach(function(l) {
            if (!l[1].Target) return;
            rel = {
                "ref": l[0]
            } /*:any*/ ;
            if (l[1].Target.charAt(0) != "#") {
                rId = $7c3b72a365cc0275$var$add_rels(rels, -1, $7c3b72a365cc0275$var$escapexml(l[1].Target).replace(/#.*$/, ""), $7c3b72a365cc0275$var$RELS.HLINK);
                rel["r:id"] = "rId" + rId;
            }
            if ((relc = l[1].Target.indexOf("#")) > -1) rel.location = $7c3b72a365cc0275$var$escapexml(l[1].Target.slice(relc + 1));
            if (l[1].Tooltip) rel.tooltip = $7c3b72a365cc0275$var$escapexml(l[1].Tooltip);
            o[o.length] = $7c3b72a365cc0275$var$writextag("hyperlink", null, rel);
        });
        o[o.length] = "</hyperlinks>";
    }
    delete ws['!links'];
    /* printOptions */ if (ws['!margins'] != null) o[o.length] = $7c3b72a365cc0275$var$write_ws_xml_margins(ws['!margins']);
    /* pageSetup */ /* headerFooter */ /* rowBreaks */ /* colBreaks */ /* customProperties */ /* cellWatches */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) o[o.length] = $7c3b72a365cc0275$var$writetag("ignoredErrors", $7c3b72a365cc0275$var$writextag("ignoredError", null, {
        numberStoredAsText: 1,
        sqref: ref
    }));
    /* smartTags */ if (_drawing.length > 0) {
        rId = $7c3b72a365cc0275$var$add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", $7c3b72a365cc0275$var$RELS.DRAW);
        o[o.length] = $7c3b72a365cc0275$var$writextag("drawing", null, {
            "r:id": "rId" + rId
        });
        ws['!drawing'] = _drawing;
    }
    if (ws['!comments'].length > 0) {
        rId = $7c3b72a365cc0275$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $7c3b72a365cc0275$var$RELS.VML);
        o[o.length] = $7c3b72a365cc0275$var$writextag("legacyDrawing", null, {
            "r:id": "rId" + rId
        });
        ws['!legacy'] = rId;
    }
    /* legacyDrawingHF */ /* picture */ /* oleObjects */ /* controls */ /* webPublishItems */ /* tableParts */ /* extLst */ if (o.length > 1) {
        o[o.length] = '</worksheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.726 BrtRowHdr */ function $7c3b72a365cc0275$var$parse_BrtRowHdr(data, length) {
    var z = {} /*:any*/ ;
    var tgt = data.l + length;
    z.r = data.read_shift(4);
    data.l += 4; // TODO: ixfe
    var miyRw = data.read_shift(2);
    data.l += 1; // TODO: top/bot padding
    var flags = data.read_shift(1);
    data.l = tgt;
    if (flags & 0x07) z.level = flags & 0x07;
    if (flags & 0x10) z.hidden = true;
    if (flags & 0x20) z.hpt = miyRw / 20;
    return z;
}
function $7c3b72a365cc0275$var$write_BrtRowHdr(R /*:number*/ , range, ws) {
    var o = $7c3b72a365cc0275$var$new_buf(145);
    var row = (ws['!rows'] || [])[R] || {};
    o.write_shift(4, R);
    o.write_shift(4, 0); /* TODO: ixfe */ 
    var miyRw = 0x0140;
    if (row.hpx) miyRw = $7c3b72a365cc0275$var$px2pt(row.hpx) * 20;
    else if (row.hpt) miyRw = row.hpt * 20;
    o.write_shift(2, miyRw);
    o.write_shift(1, 0); /* top/bot padding */ 
    var flags = 0x0;
    if (row.level) flags |= row.level;
    if (row.hidden) flags |= 0x10;
    if (row.hpx || row.hpt) flags |= 0x20;
    o.write_shift(1, flags);
    o.write_shift(1, 0); /* phonetic guide */ 
    /* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */ var ncolspan = 0, lcs = o.l;
    o.l += 4;
    var caddr = {
        r: R,
        c: 0
    };
    for(var i = 0; i < 16; ++i){
        if (range.s.c > i + 1 << 10 || range.e.c < i << 10) continue;
        var first = -1, last = -1;
        for(var j = i << 10; j < i + 1 << 10; ++j){
            caddr.c = j;
            var cell = Array.isArray(ws) ? (ws[caddr.r] || [])[caddr.c] : ws[$7c3b72a365cc0275$var$encode_cell(caddr)];
            if (cell) {
                if (first < 0) first = j;
                last = j;
            }
        }
        if (first < 0) continue;
        ++ncolspan;
        o.write_shift(4, first);
        o.write_shift(4, last);
    }
    var l = o.l;
    o.l = lcs;
    o.write_shift(4, ncolspan);
    o.l = l;
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $7c3b72a365cc0275$var$write_row_header(ba, ws, range, R) {
    var o = $7c3b72a365cc0275$var$write_BrtRowHdr(R, range, ws);
    if (o.length > 17 || (ws['!rows'] || [])[R]) $7c3b72a365cc0275$var$write_record(ba, 0x0000 /* BrtRowHdr */ , o);
}
/* [MS-XLSB] 2.4.820 BrtWsDim */ var $7c3b72a365cc0275$var$parse_BrtWsDim = $7c3b72a365cc0275$var$parse_UncheckedRfX;
var $7c3b72a365cc0275$var$write_BrtWsDim = $7c3b72a365cc0275$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */ function $7c3b72a365cc0275$var$parse_BrtWsFmtInfo() {}
//function write_BrtWsFmtInfo(ws, o) { }
/* [MS-XLSB] 2.4.823 BrtWsProp */ function $7c3b72a365cc0275$var$parse_BrtWsProp(data, length) {
    var z = {};
    var f = data[data.l];
    ++data.l;
    z.above = !(f & 0x40);
    z.left = !(f & 0x80);
    /* TODO: pull flags */ data.l += 18;
    z.name = $7c3b72a365cc0275$var$parse_XLSBCodeName(data, length - 19);
    return z;
}
function $7c3b72a365cc0275$var$write_BrtWsProp(str, outl, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(84 + 4 * str.length);
    var f = 0xC0;
    if (outl) {
        if (outl.above) f &= -65;
        if (outl.left) f &= -129;
    }
    o.write_shift(1, f);
    for(var i = 1; i < 3; ++i)o.write_shift(1, 0);
    $7c3b72a365cc0275$var$write_BrtColor({
        auto: 1
    }, o);
    o.write_shift(-4, -1);
    o.write_shift(-4, -1);
    $7c3b72a365cc0275$var$write_XLSBCodeName(str, o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.306 BrtCellBlank */ function $7c3b72a365cc0275$var$parse_BrtCellBlank(data) {
    var cell = $7c3b72a365cc0275$var$parse_XLSBCell(data);
    return [
        cell
    ];
}
function $7c3b72a365cc0275$var$write_BrtCellBlank(cell, ncell, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(8);
    return $7c3b72a365cc0275$var$write_XLSBCell(ncell, o);
}
function $7c3b72a365cc0275$var$parse_BrtShortBlank(data) {
    var cell = $7c3b72a365cc0275$var$parse_XLSBShortCell(data);
    return [
        cell
    ];
}
function $7c3b72a365cc0275$var$write_BrtShortBlank(cell, ncell, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(4);
    return $7c3b72a365cc0275$var$write_XLSBShortCell(ncell, o);
}
/* [MS-XLSB] 2.4.307 BrtCellBool */ function $7c3b72a365cc0275$var$parse_BrtCellBool(data) {
    var cell = $7c3b72a365cc0275$var$parse_XLSBCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        'b'
    ];
}
function $7c3b72a365cc0275$var$write_BrtCellBool(cell, ncell, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(9);
    $7c3b72a365cc0275$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
function $7c3b72a365cc0275$var$parse_BrtShortBool(data) {
    var cell = $7c3b72a365cc0275$var$parse_XLSBShortCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        'b'
    ];
}
function $7c3b72a365cc0275$var$write_BrtShortBool(cell, ncell, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(5);
    $7c3b72a365cc0275$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
/* [MS-XLSB] 2.4.308 BrtCellError */ function $7c3b72a365cc0275$var$parse_BrtCellError(data) {
    var cell = $7c3b72a365cc0275$var$parse_XLSBCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        'e'
    ];
}
function $7c3b72a365cc0275$var$write_BrtCellError(cell, ncell, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(9);
    $7c3b72a365cc0275$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v);
    return o;
}
function $7c3b72a365cc0275$var$parse_BrtShortError(data) {
    var cell = $7c3b72a365cc0275$var$parse_XLSBShortCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        'e'
    ];
}
function $7c3b72a365cc0275$var$write_BrtShortError(cell, ncell, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(8);
    $7c3b72a365cc0275$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v);
    o.write_shift(2, 0);
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.4.311 BrtCellIsst */ function $7c3b72a365cc0275$var$parse_BrtCellIsst(data) {
    var cell = $7c3b72a365cc0275$var$parse_XLSBCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        's'
    ];
}
function $7c3b72a365cc0275$var$write_BrtCellIsst(cell, ncell, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(12);
    $7c3b72a365cc0275$var$write_XLSBCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
function $7c3b72a365cc0275$var$parse_BrtShortIsst(data) {
    var cell = $7c3b72a365cc0275$var$parse_XLSBShortCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        's'
    ];
}
function $7c3b72a365cc0275$var$write_BrtShortIsst(cell, ncell, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(8);
    $7c3b72a365cc0275$var$write_XLSBShortCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
/* [MS-XLSB] 2.4.313 BrtCellReal */ function $7c3b72a365cc0275$var$parse_BrtCellReal(data) {
    var cell = $7c3b72a365cc0275$var$parse_XLSBCell(data);
    var value = $7c3b72a365cc0275$var$parse_Xnum(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $7c3b72a365cc0275$var$write_BrtCellReal(cell, ncell, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(16);
    $7c3b72a365cc0275$var$write_XLSBCell(ncell, o);
    $7c3b72a365cc0275$var$write_Xnum(cell.v, o);
    return o;
}
function $7c3b72a365cc0275$var$parse_BrtShortReal(data) {
    var cell = $7c3b72a365cc0275$var$parse_XLSBShortCell(data);
    var value = $7c3b72a365cc0275$var$parse_Xnum(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $7c3b72a365cc0275$var$write_BrtShortReal(cell, ncell, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(12);
    $7c3b72a365cc0275$var$write_XLSBShortCell(ncell, o);
    $7c3b72a365cc0275$var$write_Xnum(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.314 BrtCellRk */ function $7c3b72a365cc0275$var$parse_BrtCellRk(data) {
    var cell = $7c3b72a365cc0275$var$parse_XLSBCell(data);
    var value = $7c3b72a365cc0275$var$parse_RkNumber(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $7c3b72a365cc0275$var$write_BrtCellRk(cell, ncell, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(12);
    $7c3b72a365cc0275$var$write_XLSBCell(ncell, o);
    $7c3b72a365cc0275$var$write_RkNumber(cell.v, o);
    return o;
}
function $7c3b72a365cc0275$var$parse_BrtShortRk(data) {
    var cell = $7c3b72a365cc0275$var$parse_XLSBShortCell(data);
    var value = $7c3b72a365cc0275$var$parse_RkNumber(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $7c3b72a365cc0275$var$write_BrtShortRk(cell, ncell, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(8);
    $7c3b72a365cc0275$var$write_XLSBShortCell(ncell, o);
    $7c3b72a365cc0275$var$write_RkNumber(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.323 BrtCellRString */ function $7c3b72a365cc0275$var$parse_BrtCellRString(data) {
    var cell = $7c3b72a365cc0275$var$parse_XLSBCell(data);
    var value = $7c3b72a365cc0275$var$parse_RichStr(data);
    return [
        cell,
        value,
        'is'
    ];
}
/* [MS-XLSB] 2.4.317 BrtCellSt */ function $7c3b72a365cc0275$var$parse_BrtCellSt(data) {
    var cell = $7c3b72a365cc0275$var$parse_XLSBCell(data);
    var value = $7c3b72a365cc0275$var$parse_XLWideString(data);
    return [
        cell,
        value,
        'str'
    ];
}
function $7c3b72a365cc0275$var$write_BrtCellSt(cell, ncell, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(12 + 4 * cell.v.length);
    $7c3b72a365cc0275$var$write_XLSBCell(ncell, o);
    $7c3b72a365cc0275$var$write_XLWideString(cell.v, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $7c3b72a365cc0275$var$parse_BrtShortSt(data) {
    var cell = $7c3b72a365cc0275$var$parse_XLSBShortCell(data);
    var value = $7c3b72a365cc0275$var$parse_XLWideString(data);
    return [
        cell,
        value,
        'str'
    ];
}
function $7c3b72a365cc0275$var$write_BrtShortSt(cell, ncell, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(8 + 4 * cell.v.length);
    $7c3b72a365cc0275$var$write_XLSBShortCell(ncell, o);
    $7c3b72a365cc0275$var$write_XLWideString(cell.v, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.653 BrtFmlaBool */ function $7c3b72a365cc0275$var$parse_BrtFmlaBool(data, length, opts) {
    var end = data.l + length;
    var cell = $7c3b72a365cc0275$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        'b'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $7c3b72a365cc0275$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $7c3b72a365cc0275$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.654 BrtFmlaError */ function $7c3b72a365cc0275$var$parse_BrtFmlaError(data, length, opts) {
    var end = data.l + length;
    var cell = $7c3b72a365cc0275$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        'e'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $7c3b72a365cc0275$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $7c3b72a365cc0275$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.655 BrtFmlaNum */ function $7c3b72a365cc0275$var$parse_BrtFmlaNum(data, length, opts) {
    var end = data.l + length;
    var cell = $7c3b72a365cc0275$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = $7c3b72a365cc0275$var$parse_Xnum(data);
    var o = [
        cell,
        value,
        'n'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $7c3b72a365cc0275$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $7c3b72a365cc0275$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.656 BrtFmlaString */ function $7c3b72a365cc0275$var$parse_BrtFmlaString(data, length, opts) {
    var end = data.l + length;
    var cell = $7c3b72a365cc0275$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = $7c3b72a365cc0275$var$parse_XLWideString(data);
    var o = [
        cell,
        value,
        'str'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $7c3b72a365cc0275$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $7c3b72a365cc0275$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.682 BrtMergeCell */ var $7c3b72a365cc0275$var$parse_BrtMergeCell = $7c3b72a365cc0275$var$parse_UncheckedRfX;
var $7c3b72a365cc0275$var$write_BrtMergeCell = $7c3b72a365cc0275$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */ function $7c3b72a365cc0275$var$write_BrtBeginMergeCells(cnt, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(4);
    o.write_shift(4, cnt);
    return o;
}
/* [MS-XLSB] 2.4.662 BrtHLink */ function $7c3b72a365cc0275$var$parse_BrtHLink(data, length /*::, opts*/ ) {
    var end = data.l + length;
    var rfx = $7c3b72a365cc0275$var$parse_UncheckedRfX(data, 16);
    var relId = $7c3b72a365cc0275$var$parse_XLNullableWideString(data);
    var loc = $7c3b72a365cc0275$var$parse_XLWideString(data);
    var tooltip = $7c3b72a365cc0275$var$parse_XLWideString(data);
    var display = $7c3b72a365cc0275$var$parse_XLWideString(data);
    data.l = end;
    var o = {
        rfx: rfx,
        relId: relId,
        loc: loc,
        display: display
    } /*:any*/ ;
    if (tooltip) o.Tooltip = tooltip;
    return o;
}
function $7c3b72a365cc0275$var$write_BrtHLink(l, rId) {
    var o = $7c3b72a365cc0275$var$new_buf(50 + 4 * (l[1].Target.length + (l[1].Tooltip || "").length));
    $7c3b72a365cc0275$var$write_UncheckedRfX({
        s: $7c3b72a365cc0275$var$decode_cell(l[0]),
        e: $7c3b72a365cc0275$var$decode_cell(l[0])
    }, o);
    $7c3b72a365cc0275$var$write_RelID("rId" + rId, o);
    var locidx = l[1].Target.indexOf("#");
    var loc = locidx == -1 ? "" : l[1].Target.slice(locidx + 1);
    $7c3b72a365cc0275$var$write_XLWideString(loc || "", o);
    $7c3b72a365cc0275$var$write_XLWideString(l[1].Tooltip || "", o);
    $7c3b72a365cc0275$var$write_XLWideString("", o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.692 BrtPane */ function $7c3b72a365cc0275$var$parse_BrtPane() {}
/* [MS-XLSB] 2.4.6 BrtArrFmla */ function $7c3b72a365cc0275$var$parse_BrtArrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $7c3b72a365cc0275$var$parse_RfX(data, 16);
    var fAlwaysCalc = data.read_shift(1);
    var o = [
        rfx
    ];
    o[2] = fAlwaysCalc;
    if (opts.cellFormula) {
        var formula = $7c3b72a365cc0275$var$parse_XLSBArrayParsedFormula(data, end - data.l, opts);
        o[1] = formula;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.750 BrtShrFmla */ function $7c3b72a365cc0275$var$parse_BrtShrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $7c3b72a365cc0275$var$parse_UncheckedRfX(data, 16);
    var o = [
        rfx
    ];
    if (opts.cellFormula) {
        var formula = $7c3b72a365cc0275$var$parse_XLSBSharedParsedFormula(data, end - data.l, opts);
        o[1] = formula;
        data.l = end;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.323 BrtColInfo */ /* TODO: once XLS ColInfo is set, combine the functions */ function $7c3b72a365cc0275$var$write_BrtColInfo(C /*:number*/ , col, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(18);
    var p = $7c3b72a365cc0275$var$col_obj_w(C, col);
    o.write_shift(-4, C);
    o.write_shift(-4, C);
    o.write_shift(4, (p.width || 10) * 256);
    o.write_shift(4, 0 /*ixfe*/ ); // style
    var flags = 0;
    if (col.hidden) flags |= 0x01;
    if (typeof p.width == 'number') flags |= 0x02;
    if (col.level) flags |= col.level << 8;
    o.write_shift(2, flags); // bit flag
    return o;
}
/* [MS-XLSB] 2.4.678 BrtMargins */ var $7c3b72a365cc0275$var$BrtMarginKeys = [
    "left",
    "right",
    "top",
    "bottom",
    "header",
    "footer"
];
function $7c3b72a365cc0275$var$parse_BrtMargins(data /*::, length, opts*/ ) /*:Margins*/ {
    var margins = {} /*:any*/ ;
    $7c3b72a365cc0275$var$BrtMarginKeys.forEach(function(k) {
        margins[k] = $7c3b72a365cc0275$var$parse_Xnum(data, 8);
    });
    return margins;
}
function $7c3b72a365cc0275$var$write_BrtMargins(margins /*:Margins*/ , o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(48);
    $7c3b72a365cc0275$var$default_margins(margins);
    $7c3b72a365cc0275$var$BrtMarginKeys.forEach(function(k) {
        $7c3b72a365cc0275$var$write_Xnum(margins /*:any*/ [k], o);
    });
    return o;
}
/* [MS-XLSB] 2.4.299 BrtBeginWsView */ function $7c3b72a365cc0275$var$parse_BrtBeginWsView(data /*::, length, opts*/ ) {
    var f = data.read_shift(2);
    data.l += 28;
    return {
        RTL: f & 0x20
    };
}
function $7c3b72a365cc0275$var$write_BrtBeginWsView(ws, Workbook, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(30);
    var f = 0x39c;
    if ((((Workbook || {}).Views || [])[0] || {}).RTL) f |= 0x20;
    o.write_shift(2, f); // bit flag
    o.write_shift(4, 0);
    o.write_shift(4, 0); // view first row
    o.write_shift(4, 0); // view first col
    o.write_shift(1, 0); // gridline color ICV
    o.write_shift(1, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 100); // zoom scale
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(4, 0); // workbook view id
    return o;
}
/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */ function $7c3b72a365cc0275$var$write_BrtCellIgnoreEC(ref) {
    var o = $7c3b72a365cc0275$var$new_buf(24);
    o.write_shift(4, 4);
    o.write_shift(4, 1);
    $7c3b72a365cc0275$var$write_UncheckedRfX(ref, o);
    return o;
}
/* [MS-XLSB] 2.4.748 BrtSheetProtection */ function $7c3b72a365cc0275$var$write_BrtSheetProtection(sp, o) {
    if (o == null) o = $7c3b72a365cc0275$var$new_buf(66);
    o.write_shift(2, sp.password ? $7c3b72a365cc0275$var$crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
    o.write_shift(4, 1); // this record should not be written if no protection
    [
        [
            "objects",
            false
        ],
        [
            "scenarios",
            false
        ],
        [
            "formatCells",
            true
        ],
        [
            "formatColumns",
            true
        ],
        [
            "formatRows",
            true
        ],
        [
            "insertColumns",
            true
        ],
        [
            "insertRows",
            true
        ],
        [
            "insertHyperlinks",
            true
        ],
        [
            "deleteColumns",
            true
        ],
        [
            "deleteRows",
            true
        ],
        [
            "selectLockedCells",
            false
        ],
        [
            "sort",
            true
        ],
        [
            "autoFilter",
            true
        ],
        [
            "pivotTables",
            true
        ],
        [
            "selectUnlockedCells",
            false
        ] // fSelUnlockedCells
    ].forEach(function(n) {
        /*:: if(o == null) throw "unreachable"; */ if (n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
        else o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
    });
    return o;
}
function $7c3b72a365cc0275$var$parse_BrtDVal() {}
function $7c3b72a365cc0275$var$parse_BrtDVal14() {}
/* [MS-XLSB] 2.1.7.61 Worksheet */ function $7c3b72a365cc0275$var$parse_ws_bin(data, _opts, idx, rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    var opts = _opts || {};
    if (!rels) rels = {
        '!id': {}
    };
    if ($7c3b72a365cc0275$var$DENSE != null && opts.dense == null) opts.dense = $7c3b72a365cc0275$var$DENSE;
    var s /*:Worksheet*/  = opts.dense ? [] : {};
    var ref;
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var state /*:Array<string>*/  = [];
    var pass = false, end = false;
    var row, p, cf, R, C, addr, sstr, rr, cell /*:Cell*/ ;
    var merges /*:Array<Range>*/  = [];
    opts.biff = 12;
    opts['!row'] = 0;
    var ai = 0, af = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var sharedf = {};
    var supbooks = opts.supbooks || /*::(*/ wb /*:: :any)*/ .supbooks || [
        []
    ];
    supbooks.sharedf = sharedf;
    supbooks.arrayf = arrayf;
    supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) {
        return x.name;
    });
    if (!opts.supbooks) {
        opts.supbooks = supbooks;
        if (wb.Names) for(var i = 0; i < wb.Names.length; ++i)supbooks[0][i + 1] = wb.Names[i];
    }
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    $7c3b72a365cc0275$var$XLSBRecordEnum[0x0010] = {
        n: "BrtShortReal",
        f: $7c3b72a365cc0275$var$parse_BrtShortReal
    };
    var cm, vm;
    $7c3b72a365cc0275$var$recordhopper(data, function ws_parse(val, RR, RT) {
        if (end) return;
        switch(RT){
            case 0x0094:
                /* 'BrtWsDim' */ ref = val;
                break;
            case 0x0000:
                /* 'BrtRowHdr' */ row = val;
                if (opts.sheetRows && opts.sheetRows <= row.r) end = true;
                rr = $7c3b72a365cc0275$var$encode_row(R = row.r);
                opts['!row'] = row.r;
                if (val.hidden || val.hpt || val.level != null) {
                    if (val.hpt) val.hpx = $7c3b72a365cc0275$var$pt2px(val.hpt);
                    rowinfo[val.r] = val;
                }
                break;
            case 0x0002:
            /* 'BrtCellRk' */ case 0x0003:
            /* 'BrtCellError' */ case 0x0004:
            /* 'BrtCellBool' */ case 0x0005:
            /* 'BrtCellReal' */ case 0x0006:
            /* 'BrtCellSt' */ case 0x0007:
            /* 'BrtCellIsst' */ case 0x0008:
            /* 'BrtFmlaString' */ case 0x0009:
            /* 'BrtFmlaNum' */ case 0x000A:
            /* 'BrtFmlaBool' */ case 0x000B:
            /* 'BrtFmlaError' */ case 0x000D:
            /* 'BrtShortRk' */ case 0x000E:
            /* 'BrtShortError' */ case 0x000F:
            /* 'BrtShortBool' */ case 0x0010:
            /* 'BrtShortReal' */ case 0x0011:
            /* 'BrtShortSt' */ case 0x0012:
            /* 'BrtShortIsst' */ case 0x003E:
                /* 'BrtCellRString' */ p = {
                    t: val[2]
                } /*:any*/ ;
                switch(val[2]){
                    case 'n':
                        p.v = val[1];
                        break;
                    case 's':
                        sstr = $7c3b72a365cc0275$var$strs[val[1]];
                        p.v = sstr.t;
                        p.r = sstr.r;
                        break;
                    case 'b':
                        p.v = val[1] ? true : false;
                        break;
                    case 'e':
                        p.v = val[1];
                        if (opts.cellText !== false) p.w = $7c3b72a365cc0275$var$BErr[p.v];
                        break;
                    case 'str':
                        p.t = 's';
                        p.v = val[1];
                        break;
                    case 'is':
                        p.t = 's';
                        p.v = val[1].t;
                        break;
                }
                if (cf = styles.CellXf[val[0].iStyleRef]) $7c3b72a365cc0275$var$safe_format(p, cf.numFmtId, null, opts, themes, styles);
                C = val[0].c == -1 ? C + 1 : val[0].c;
                if (opts.dense) {
                    if (!s[R]) s[R] = [];
                    s[R][C] = p;
                } else s[$7c3b72a365cc0275$var$encode_col(C) + rr] = p;
                if (opts.cellFormula) {
                    af = false;
                    for(ai = 0; ai < arrayf.length; ++ai){
                        var aii = arrayf[ai];
                        if (row.r >= aii[0].s.r && row.r <= aii[0].e.r) {
                            if (C >= aii[0].s.c && C <= aii[0].e.c) {
                                p.F = $7c3b72a365cc0275$var$encode_range(aii[0]);
                                af = true;
                            }
                        }
                    }
                    if (!af && val.length > 3) p.f = val[3];
                }
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (opts.cellDates && cf && p.t == 'n' && $7c3b72a365cc0275$var$fmt_is_date($7c3b72a365cc0275$var$table_fmt[cf.numFmtId])) {
                    var _d = $7c3b72a365cc0275$var$SSF_parse_date_code(p.v);
                    if (_d) {
                        p.t = 'd';
                        p.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
                    }
                }
                if (cm) {
                    if (cm.type == 'XLDAPR') p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x0001:
            /* 'BrtCellBlank' */ case 0x000C:
                /* 'BrtShortBlank' */ if (!opts.sheetStubs || pass) break;
                p = {
                    t: 'z',
                    v: void 0
                } /*:any*/ ;
                C = val[0].c == -1 ? C + 1 : val[0].c;
                if (opts.dense) {
                    if (!s[R]) s[R] = [];
                    s[R][C] = p;
                } else s[$7c3b72a365cc0275$var$encode_col(C) + rr] = p;
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (cm) {
                    if (cm.type == 'XLDAPR') p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x00B0:
                /* 'BrtMergeCell' */ merges.push(val);
                break;
            case 0x0031:
                cm = ((opts.xlmeta || {}).Cell || [])[val - 1];
                break;
            case 0x01EE:
                /* 'BrtHLink' */ var rel = rels['!id'][val.relId];
                if (rel) {
                    val.Target = rel.Target;
                    if (val.loc) val.Target += "#" + val.loc;
                    val.Rel = rel;
                } else if (val.relId == '') val.Target = "#" + val.loc;
                for(R = val.rfx.s.r; R <= val.rfx.e.r; ++R)for(C = val.rfx.s.c; C <= val.rfx.e.c; ++C)if (opts.dense) {
                    if (!s[R]) s[R] = [];
                    if (!s[R][C]) s[R][C] = {
                        t: 'z',
                        v: undefined
                    };
                    s[R][C].l = val;
                } else {
                    addr = $7c3b72a365cc0275$var$encode_cell({
                        c: C,
                        r: R
                    });
                    if (!s[addr]) s[addr] = {
                        t: 'z',
                        v: undefined
                    };
                    s[addr].l = val;
                }
                break;
            case 0x01AA:
                /* 'BrtArrFmla' */ if (!opts.cellFormula) break;
                arrayf.push(val);
                cell = opts.dense ? s[R][C] : s[$7c3b72a365cc0275$var$encode_col(C) + rr];
                cell.f = $7c3b72a365cc0275$var$stringify_formula(val[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                cell.F = $7c3b72a365cc0275$var$encode_range(val[0]);
                break;
            case 0x01AB:
                /* 'BrtShrFmla' */ if (!opts.cellFormula) break;
                sharedf[$7c3b72a365cc0275$var$encode_cell(val[0].s)] = val[1];
                cell = opts.dense ? s[R][C] : s[$7c3b72a365cc0275$var$encode_col(C) + rr];
                cell.f = $7c3b72a365cc0275$var$stringify_formula(val[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                break;
            /* identical to 'ColInfo' in XLS */ case 0x003C:
                /* 'BrtColInfo' */ if (!opts.cellStyles) break;
                while(val.e >= val.s){
                    colinfo[val.e--] = {
                        width: val.w / 256,
                        hidden: !!(val.flags & 0x01),
                        level: val.level
                    };
                    if (!seencol) {
                        seencol = true;
                        $7c3b72a365cc0275$var$find_mdw_colw(val.w / 256);
                    }
                    $7c3b72a365cc0275$var$process_col(colinfo[val.e + 1]);
                }
                break;
            case 0x00A1:
                /* 'BrtBeginAFilter' */ s['!autofilter'] = {
                    ref: $7c3b72a365cc0275$var$encode_range(val)
                };
                break;
            case 0x01DC:
                /* 'BrtMargins' */ s['!margins'] = val;
                break;
            case 0x0093:
                /* 'BrtWsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val.name) wb.Sheets[idx].CodeName = val.name;
                if (val.above || val.left) s['!outline'] = {
                    above: val.above,
                    left: val.left
                };
                break;
            case 0x0089:
                /* 'BrtBeginWsView' */ if (!wb.Views) wb.Views = [
                    {}
                ];
                if (!wb.Views[0]) wb.Views[0] = {};
                if (val.RTL) wb.Views[0].RTL = true;
                break;
            case 0x01E5:
                break;
            case 0x0040:
            /* 'BrtDVal' */ case 0x041D:
                break;
            case 0x0097:
                break;
            case 0x0098:
            /* 'BrtSel' */ case 0x00AF:
            /* 'BrtAFilterDateGroupItem' */ case 0x0284:
            /* 'BrtActiveX' */ case 0x0271:
            /* 'BrtBigName' */ case 0x0232:
            /* 'BrtBkHim' */ case 0x018C:
            /* 'BrtBrk' */ case 0x0458:
            /* 'BrtCFIcon' */ case 0x047A:
            /* 'BrtCFRuleExt' */ case 0x01D7:
            /* 'BrtCFVO' */ case 0x041A:
            /* 'BrtCFVO14' */ case 0x0289:
            /* 'BrtCellIgnoreEC' */ case 0x0451:
            /* 'BrtCellIgnoreEC14' */ case 0x024D:
            /* 'BrtCellSmartTagProperty' */ case 0x025F:
            /* 'BrtCellWatch' */ case 0x0234:
            /* 'BrtColor' */ case 0x041F:
            /* 'BrtColor14' */ case 0x00A8:
            /* 'BrtColorFilter' */ case 0x00AE:
            /* 'BrtCustomFilter' */ case 0x049C:
            /* 'BrtCustomFilter14' */ case 0x01F3:
            /* 'BrtDRef' */ case 0x01FB:
            /* 'BrtDXF' */ case 0x0226:
            /* 'BrtDrawing' */ case 0x00AB:
            /* 'BrtDynamicFilter' */ case 0x00A7:
            /* 'BrtFilter' */ case 0x0499:
            /* 'BrtFilter14' */ case 0x00A9:
            /* 'BrtIconFilter' */ case 0x049D:
            /* 'BrtIconFilter14' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x0295:
            /* 'BrtListPart' */ case 0x027F:
            /* 'BrtOleObject' */ case 0x01DE:
            /* 'BrtPageSetup' */ case 0x0219:
            /* 'BrtPhoneticInfo' */ case 0x01DD:
            /* 'BrtPrintOptions' */ case 0x0218:
            /* 'BrtRangeProtection' */ case 0x044F:
            /* 'BrtRangeProtection14' */ case 0x02A8:
            /* 'BrtRangeProtectionIso' */ case 0x0450:
            /* 'BrtRangeProtectionIso14' */ case 0x0400:
            /* 'BrtRwDescent' */ case 0x0297:
            /* 'BrtSheetCalcProp' */ case 0x0217:
            /* 'BrtSheetProtection' */ case 0x02A6:
            /* 'BrtSheetProtectionIso' */ case 0x01F8:
            /* 'BrtSlc' */ case 0x0413:
            /* 'BrtSparkline' */ case 0x01AC:
            /* 'BrtTable' */ case 0x00AA:
            /* 'BrtTop10Filter' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0032:
            /* 'BrtValueMeta' */ case 0x0816:
            /* 'BrtWebExtension' */ case 0x0415:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            default:
                if (RR.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    delete opts.supbooks;
    delete opts['!row'];
    if (!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = $7c3b72a365cc0275$var$encode_range(ref || refguess);
    if (opts.sheetRows && s["!ref"]) {
        var tmpref = $7c3b72a365cc0275$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $7c3b72a365cc0275$var$encode_range(tmpref);
        }
    }
    if (merges.length > 0) s["!merges"] = merges;
    if (colinfo.length > 0) s["!cols"] = colinfo;
    if (rowinfo.length > 0) s["!rows"] = rowinfo;
    return s;
}
/* TODO: something useful -- this is a stub */ function $7c3b72a365cc0275$var$write_ws_bin_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, ws /*:Worksheet*/ , last_seen /*:boolean*/ ) /*:boolean*/ {
    if (cell.v === undefined) return false;
    var vv = "";
    switch(cell.t){
        case 'b':
            vv = cell.v ? "1" : "0";
            break;
        case 'd':
            cell = $7c3b72a365cc0275$var$dup(cell);
            cell.z = cell.z || $7c3b72a365cc0275$var$table_fmt[14];
            cell.v = $7c3b72a365cc0275$var$datenum($7c3b72a365cc0275$var$parseDate(cell.v));
            cell.t = 'n';
            break;
        /* falls through */ case 'n':
        case 'e':
            vv = '' + cell.v;
            break;
        default:
            vv = cell.v;
            break;
    }
    var o /*:any*/  = {
        r: R,
        c: C
    } /*:any*/ ;
    /* TODO: cell style */ o.s = $7c3b72a365cc0275$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.l) ws['!links'].push([
        $7c3b72a365cc0275$var$encode_cell(o),
        cell.l
    ]);
    if (cell.c) ws['!comments'].push([
        $7c3b72a365cc0275$var$encode_cell(o),
        cell.c
    ]);
    switch(cell.t){
        case 's':
        case 'str':
            if (opts.bookSST) {
                vv = $7c3b72a365cc0275$var$get_sst_id(opts.Strings, cell.v /*:any*/ , opts.revStrings);
                o.t = "s";
                o.v = vv;
                if (last_seen) $7c3b72a365cc0275$var$write_record(ba, 0x0012 /* BrtShortIsst */ , $7c3b72a365cc0275$var$write_BrtShortIsst(cell, o));
                else $7c3b72a365cc0275$var$write_record(ba, 0x0007 /* BrtCellIsst */ , $7c3b72a365cc0275$var$write_BrtCellIsst(cell, o));
            } else {
                o.t = "str";
                if (last_seen) $7c3b72a365cc0275$var$write_record(ba, 0x0011 /* BrtShortSt */ , $7c3b72a365cc0275$var$write_BrtShortSt(cell, o));
                else $7c3b72a365cc0275$var$write_record(ba, 0x0006 /* BrtCellSt */ , $7c3b72a365cc0275$var$write_BrtCellSt(cell, o));
            }
            return true;
        case 'n':
            /* TODO: determine threshold for Real vs RK */ if (cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
                if (last_seen) $7c3b72a365cc0275$var$write_record(ba, 0x000D /* BrtShortRk */ , $7c3b72a365cc0275$var$write_BrtShortRk(cell, o));
                else $7c3b72a365cc0275$var$write_record(ba, 0x0002 /* BrtCellRk */ , $7c3b72a365cc0275$var$write_BrtCellRk(cell, o));
            } else if (last_seen) $7c3b72a365cc0275$var$write_record(ba, 0x0010 /* BrtShortReal */ , $7c3b72a365cc0275$var$write_BrtShortReal(cell, o));
            else $7c3b72a365cc0275$var$write_record(ba, 0x0005 /* BrtCellReal */ , $7c3b72a365cc0275$var$write_BrtCellReal(cell, o));
            return true;
        case 'b':
            o.t = "b";
            if (last_seen) $7c3b72a365cc0275$var$write_record(ba, 0x000F /* BrtShortBool */ , $7c3b72a365cc0275$var$write_BrtShortBool(cell, o));
            else $7c3b72a365cc0275$var$write_record(ba, 0x0004 /* BrtCellBool */ , $7c3b72a365cc0275$var$write_BrtCellBool(cell, o));
            return true;
        case 'e':
            o.t = "e";
            if (last_seen) $7c3b72a365cc0275$var$write_record(ba, 0x000E /* BrtShortError */ , $7c3b72a365cc0275$var$write_BrtShortError(cell, o));
            else $7c3b72a365cc0275$var$write_record(ba, 0x0003 /* BrtCellError */ , $7c3b72a365cc0275$var$write_BrtCellError(cell, o));
            return true;
    }
    if (last_seen) $7c3b72a365cc0275$var$write_record(ba, 0x000C /* BrtShortBlank */ , $7c3b72a365cc0275$var$write_BrtShortBlank(cell, o));
    else $7c3b72a365cc0275$var$write_record(ba, 0x0001 /* BrtCellBlank */ , $7c3b72a365cc0275$var$write_BrtCellBlank(cell, o));
    return true;
}
function $7c3b72a365cc0275$var$write_CELLTABLE(ba, ws /*:Worksheet*/ , idx /*:number*/ , opts /*::, wb:Workbook*/ ) {
    var range = $7c3b72a365cc0275$var$safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols /*:Array<string>*/  = [];
    $7c3b72a365cc0275$var$write_record(ba, 0x0091 /* BrtBeginSheetData */ );
    var dense = Array.isArray(ws);
    var cap = range.e.r;
    if (ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
    for(var R = range.s.r; R <= cap; ++R){
        rr = $7c3b72a365cc0275$var$encode_row(R);
        /* [ACCELLTABLE] */ /* BrtRowHdr */ $7c3b72a365cc0275$var$write_row_header(ba, ws, range, R);
        var last_seen = false;
        if (R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C){
            /* *16384CELL */ if (R === range.s.r) cols[C] = $7c3b72a365cc0275$var$encode_col(C);
            ref = cols[C] + rr;
            var cell = dense ? (ws[R] || [])[C] : ws[ref];
            if (!cell) {
                last_seen = false;
                continue;
            }
            /* write cell */ last_seen = $7c3b72a365cc0275$var$write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen);
        }
    }
    $7c3b72a365cc0275$var$write_record(ba, 0x0092 /* BrtEndSheetData */ );
}
function $7c3b72a365cc0275$var$write_MERGECELLS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws['!merges']) return;
    $7c3b72a365cc0275$var$write_record(ba, 0x00B1 /* BrtBeginMergeCells */ , $7c3b72a365cc0275$var$write_BrtBeginMergeCells(ws['!merges'].length));
    ws['!merges'].forEach(function(m) {
        $7c3b72a365cc0275$var$write_record(ba, 0x00B0 /* BrtMergeCell */ , $7c3b72a365cc0275$var$write_BrtMergeCell(m));
    });
    $7c3b72a365cc0275$var$write_record(ba, 0x00B2 /* BrtEndMergeCells */ );
}
function $7c3b72a365cc0275$var$write_COLINFOS(ba, ws /*:Worksheet*/  /*::, idx:number, opts, wb:Workbook*/ ) {
    if (!ws || !ws['!cols']) return;
    $7c3b72a365cc0275$var$write_record(ba, 0x0186 /* BrtBeginColInfos */ );
    ws['!cols'].forEach(function(m, i) {
        if (m) $7c3b72a365cc0275$var$write_record(ba, 0x003C /* 'BrtColInfo' */ , $7c3b72a365cc0275$var$write_BrtColInfo(i, m));
    });
    $7c3b72a365cc0275$var$write_record(ba, 0x0187 /* BrtEndColInfos */ );
}
function $7c3b72a365cc0275$var$write_IGNOREECS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws['!ref']) return;
    $7c3b72a365cc0275$var$write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */ );
    $7c3b72a365cc0275$var$write_record(ba, 0x0289 /* BrtCellIgnoreEC */ , $7c3b72a365cc0275$var$write_BrtCellIgnoreEC($7c3b72a365cc0275$var$safe_decode_range(ws['!ref'])));
    $7c3b72a365cc0275$var$write_record(ba, 0x028A /* BrtEndCellIgnoreECs */ );
}
function $7c3b72a365cc0275$var$write_HLINKS(ba, ws /*:Worksheet*/ , rels) {
    /* *BrtHLink */ ws['!links'].forEach(function(l) {
        if (!l[1].Target) return;
        var rId = $7c3b72a365cc0275$var$add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), $7c3b72a365cc0275$var$RELS.HLINK);
        $7c3b72a365cc0275$var$write_record(ba, 0x01EE /* BrtHLink */ , $7c3b72a365cc0275$var$write_BrtHLink(l, rId));
    });
    delete ws['!links'];
}
function $7c3b72a365cc0275$var$write_LEGACYDRAWING(ba, ws /*:Worksheet*/ , idx /*:number*/ , rels) {
    /* [BrtLegacyDrawing] */ if (ws['!comments'].length > 0) {
        var rId = $7c3b72a365cc0275$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $7c3b72a365cc0275$var$RELS.VML);
        $7c3b72a365cc0275$var$write_record(ba, 0x0227 /* BrtLegacyDrawing */ , $7c3b72a365cc0275$var$write_RelID("rId" + rId));
        ws['!legacy'] = rId;
    }
}
function $7c3b72a365cc0275$var$write_AUTOFILTER(ba, ws, wb, idx) {
    if (!ws['!autofilter']) return;
    var data = ws['!autofilter'];
    var ref = typeof data.ref === "string" ? data.ref : $7c3b72a365cc0275$var$encode_range(data.ref);
    /* Update FilterDatabase defined name for the worksheet */ if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $7c3b72a365cc0275$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $7c3b72a365cc0275$var$decode_range(ws["!ref"]).e.r;
        ref = $7c3b72a365cc0275$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != '_xlnm._FilterDatabase') continue;
        if (name.Sheet != idx) continue;
        name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref;
        break;
    }
    if (i == names.length) names.push({
        Name: '_xlnm._FilterDatabase',
        Sheet: idx,
        Ref: "'" + wb.SheetNames[idx] + "'!" + ref
    });
    $7c3b72a365cc0275$var$write_record(ba, 0x00A1 /* BrtBeginAFilter */ , $7c3b72a365cc0275$var$write_UncheckedRfX($7c3b72a365cc0275$var$safe_decode_range(ref)));
    /* *FILTERCOLUMN */ /* [SORTSTATE] */ /* BrtEndAFilter */ $7c3b72a365cc0275$var$write_record(ba, 0x00A2 /* BrtEndAFilter */ );
}
function $7c3b72a365cc0275$var$write_WSVIEWS2(ba, ws, Workbook) {
    $7c3b72a365cc0275$var$write_record(ba, 0x0085 /* BrtBeginWsViews */ );
    /* [ACUID] */ $7c3b72a365cc0275$var$write_record(ba, 0x0089 /* BrtBeginWsView */ , $7c3b72a365cc0275$var$write_BrtBeginWsView(ws, Workbook));
    /* [BrtPane] */ /* *4BrtSel */ /* *4SXSELECT */ /* *FRT */ $7c3b72a365cc0275$var$write_record(ba, 0x008A /* BrtEndWsView */ );
    /* *FRT */ $7c3b72a365cc0275$var$write_record(ba, 0x0086 /* BrtEndWsViews */ );
}
function $7c3b72a365cc0275$var$write_WSFMTINFO() {
/* [ACWSFMTINFO] */ // write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
}
function $7c3b72a365cc0275$var$write_SHEETPROTECT(ba, ws) {
    if (!ws['!protect']) return;
    /* [BrtSheetProtectionIso] */ $7c3b72a365cc0275$var$write_record(ba, 0x0217 /* BrtSheetProtection */ , $7c3b72a365cc0275$var$write_BrtSheetProtection(ws['!protect']));
}
function $7c3b72a365cc0275$var$write_ws_bin(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) {
    var ba = $7c3b72a365cc0275$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var c /*:string*/  = s;
    try {
        if (wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c;
    } catch (e) {}
    var r = $7c3b72a365cc0275$var$safe_decode_range(ws['!ref'] || "A1");
    if (r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
        r.e.c = Math.min(r.e.c, 0x3FFF);
        r.e.r = Math.min(r.e.c, 0xFFFFF);
    }
    ws['!links'] = [];
    /* passed back to write_zip and removed there */ ws['!comments'] = [];
    $7c3b72a365cc0275$var$write_record(ba, 0x0081 /* BrtBeginSheet */ );
    if (wb.vbaraw || ws['!outline']) $7c3b72a365cc0275$var$write_record(ba, 0x0093 /* BrtWsProp */ , $7c3b72a365cc0275$var$write_BrtWsProp(c, ws['!outline']));
    $7c3b72a365cc0275$var$write_record(ba, 0x0094 /* BrtWsDim */ , $7c3b72a365cc0275$var$write_BrtWsDim(r));
    $7c3b72a365cc0275$var$write_WSVIEWS2(ba, ws, wb.Workbook);
    $7c3b72a365cc0275$var$write_WSFMTINFO(ba, ws);
    $7c3b72a365cc0275$var$write_COLINFOS(ba, ws, idx, opts, wb);
    $7c3b72a365cc0275$var$write_CELLTABLE(ba, ws, idx, opts, wb);
    /* [BrtSheetCalcProp] */ $7c3b72a365cc0275$var$write_SHEETPROTECT(ba, ws);
    /* *([BrtRangeProtectionIso] BrtRangeProtection) */ /* [SCENMAN] */ $7c3b72a365cc0275$var$write_AUTOFILTER(ba, ws, wb, idx);
    /* [SORTSTATE] */ /* [DCON] */ /* [USERSHVIEWS] */ $7c3b72a365cc0275$var$write_MERGECELLS(ba, ws);
    /* [BrtPhoneticInfo] */ /* *CONDITIONALFORMATTING */ /* [DVALS] */ $7c3b72a365cc0275$var$write_HLINKS(ba, ws, rels);
    /* [BrtPrintOptions] */ if (ws['!margins']) $7c3b72a365cc0275$var$write_record(ba, 0x01DC /* BrtMargins */ , $7c3b72a365cc0275$var$write_BrtMargins(ws['!margins']));
    /* [BrtPageSetup] */ /* [HEADERFOOTER] */ /* [RWBRK] */ /* [COLBRK] */ /* *BrtBigName */ /* [CELLWATCHES] */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) $7c3b72a365cc0275$var$write_IGNOREECS(ba, ws);
    /* [SMARTTAGS] */ /* [BrtDrawing] */ $7c3b72a365cc0275$var$write_LEGACYDRAWING(ba, ws, idx, rels);
    /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [OLEOBJECTS] */ /* [ACTIVEXCONTROLS] */ /* [WEBPUBITEMS] */ /* [LISTPARTS] */ /* FRTWORKSHEET */ $7c3b72a365cc0275$var$write_record(ba, 0x0082 /* BrtEndSheet */ );
    return ba.end();
}
function $7c3b72a365cc0275$var$parse_Cache(data /*:string*/ ) /*:[Array<number|string>, string, ?string]*/ {
    var col /*:Array<number|string>*/  = [];
    var num = data.match(/^<c:numCache>/);
    var f;
    /* 21.2.2.150 pt CT_NumVal */ (data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg) || []).forEach(function(pt) {
        var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
        if (!q) return;
        col[+q[1]] = num ? +q[2] : q[2];
    });
    /* 21.2.2.71 formatCode CT_Xstring */ var nf = $7c3b72a365cc0275$var$unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || [
        "",
        "General"
    ])[1]);
    (data.match(/<c:f>(.*?)<\/c:f>/mg) || []).forEach(function(F) {
        f = F.replace(/<.*?>/g, "");
    });
    return [
        col,
        nf,
        f
    ];
}
/* 21.2 DrawingML - Charts */ function $7c3b72a365cc0275$var$parse_chart(data /*:?string*/ , name /*:string*/ , opts, rels, wb, csheet) {
    var cs /*:Worksheet*/  = csheet || {
        "!type": "chart"
    };
    if (!data) return csheet;
    /* 21.2.2.27 chart CT_Chart */ var C = 0, R = 0, col = "A";
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    /* 21.2.2.120 numCache CT_NumData */ (data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function(nc) {
        var cache = $7c3b72a365cc0275$var$parse_Cache(nc);
        refguess.s.r = refguess.s.c = 0;
        refguess.e.c = C;
        col = $7c3b72a365cc0275$var$encode_col(C);
        cache[0].forEach(function(n, i) {
            cs[col + $7c3b72a365cc0275$var$encode_row(i)] = {
                t: 'n',
                v: n,
                z: cache[1]
            };
            R = i;
        });
        if (refguess.e.r < R) refguess.e.r = R;
        ++C;
    });
    if (C > 0) cs["!ref"] = $7c3b72a365cc0275$var$encode_range(refguess);
    return cs;
}
/* 18.3 Worksheets also covers Chartsheets */ function $7c3b72a365cc0275$var$parse_cs_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    /* 18.3.1.12 chartsheet CT_ChartSheet */ if (!rels) rels = {
        '!id': {}
    };
    var s = {
        '!type': "chart",
        '!drawel': null,
        '!rel': ""
    } /*:any*/ ;
    var m;
    /* 18.3.1.83 sheetPr CT_ChartsheetPr */ var sheetPr = data.match($7c3b72a365cc0275$var$sheetprregex);
    if (sheetPr) $7c3b72a365cc0275$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    /* 18.3.1.36 drawing CT_Drawing */ if (m = data.match(/drawing r:id="(.*?)"/)) s['!rel'] = m[1];
    if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
    return s;
}
function $7c3b72a365cc0275$var$write_cs_xml(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) /*:string*/ {
    var o = [
        $7c3b72a365cc0275$var$XML_HEADER,
        $7c3b72a365cc0275$var$writextag('chartsheet', null, {
            'xmlns': $7c3b72a365cc0275$var$XMLNS_main[0],
            'xmlns:r': $7c3b72a365cc0275$var$XMLNS.r
        })
    ];
    o[o.length] = $7c3b72a365cc0275$var$writextag("drawing", null, {
        "r:id": "rId1"
    });
    $7c3b72a365cc0275$var$add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", $7c3b72a365cc0275$var$RELS.DRAW);
    if (o.length > 2) {
        o[o.length] = '</chartsheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.331 BrtCsProp */ function $7c3b72a365cc0275$var$parse_BrtCsProp(data, length /*:number*/ ) {
    data.l += 10;
    var name = $7c3b72a365cc0275$var$parse_XLWideString(data, length - 10);
    return {
        name: name
    };
}
/* [MS-XLSB] 2.1.7.7 Chart Sheet */ function $7c3b72a365cc0275$var$parse_cs_bin(data, opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        '!id': {}
    };
    var s = {
        '!type': "chart",
        '!drawel': null,
        '!rel': ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    $7c3b72a365cc0275$var$recordhopper(data, function cs_parse(val, R, RT) {
        switch(RT){
            case 0x0226:
                /* 'BrtDrawing' */ s['!rel'] = val;
                break;
            case 0x028B:
                /* 'BrtCsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val.name) wb.Sheets[idx].CodeName = val.name;
                break;
            case 0x0232:
            /* 'BrtBkHim' */ case 0x028C:
            /* 'BrtCsPageSetup' */ case 0x029D:
            /* 'BrtCsProtection' */ case 0x02A7:
            /* 'BrtCsProtectionIso' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x01DC:
            /* 'BrtMargins' */ case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
    return s;
}
function $7c3b72a365cc0275$var$write_cs_bin() {
    var ba = $7c3b72a365cc0275$var$buf_array();
    $7c3b72a365cc0275$var$write_record(ba, 0x0081 /* BrtBeginSheet */ );
    /* [BrtCsProp] */ /* CSVIEWS */ /* [[BrtCsProtectionIso] BrtCsProtection] */ /* [USERCSVIEWS] */ /* [BrtMargins] */ /* [BrtCsPageSetup] */ /* [HEADERFOOTER] */ /* BrtDrawing */ /* [BrtLegacyDrawing] */ /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [WEBPUBITEMS] */ /* FRTCHARTSHEET */ $7c3b72a365cc0275$var$write_record(ba, 0x0082 /* BrtEndSheet */ );
    return ba.end();
}
/* 18.2.28 (CT_WorkbookProtection) Defaults */ var $7c3b72a365cc0275$var$WBPropsDef = [
    [
        'allowRefreshQuery',
        false,
        "bool"
    ],
    [
        'autoCompressPictures',
        true,
        "bool"
    ],
    [
        'backupFile',
        false,
        "bool"
    ],
    [
        'checkCompatibility',
        false,
        "bool"
    ],
    [
        'CodeName',
        ''
    ],
    [
        'date1904',
        false,
        "bool"
    ],
    [
        'defaultThemeVersion',
        0,
        "int"
    ],
    [
        'filterPrivacy',
        false,
        "bool"
    ],
    [
        'hidePivotFieldList',
        false,
        "bool"
    ],
    [
        'promptedSolutions',
        false,
        "bool"
    ],
    [
        'publishItems',
        false,
        "bool"
    ],
    [
        'refreshAllConnections',
        false,
        "bool"
    ],
    [
        'saveExternalLinkValues',
        true,
        "bool"
    ],
    [
        'showBorderUnselectedTables',
        true,
        "bool"
    ],
    [
        'showInkAnnotation',
        true,
        "bool"
    ],
    [
        'showObjects',
        'all'
    ],
    [
        'showPivotChartFilter',
        false,
        "bool"
    ],
    [
        'updateLinks',
        'userSet'
    ]
];
/* 18.2.30 (CT_BookView) Defaults */ var $7c3b72a365cc0275$var$WBViewDef = [
    [
        'activeTab',
        0,
        "int"
    ],
    [
        'autoFilterDateGrouping',
        true,
        "bool"
    ],
    [
        'firstSheet',
        0,
        "int"
    ],
    [
        'minimized',
        false,
        "bool"
    ],
    [
        'showHorizontalScroll',
        true,
        "bool"
    ],
    [
        'showSheetTabs',
        true,
        "bool"
    ],
    [
        'showVerticalScroll',
        true,
        "bool"
    ],
    [
        'tabRatio',
        600,
        "int"
    ],
    [
        'visibility',
        'visible'
    ]
];
/* 18.2.19 (CT_Sheet) Defaults */ var $7c3b72a365cc0275$var$SheetDef = [];
/* 18.2.2  (CT_CalcPr) Defaults */ var $7c3b72a365cc0275$var$CalcPrDef = [
    [
        'calcCompleted',
        'true'
    ],
    [
        'calcMode',
        'auto'
    ],
    [
        'calcOnSave',
        'true'
    ],
    [
        'concurrentCalc',
        'true'
    ],
    [
        'fullCalcOnLoad',
        'false'
    ],
    [
        'fullPrecision',
        'true'
    ],
    [
        'iterate',
        'false'
    ],
    [
        'iterateCount',
        '100'
    ],
    [
        'iterateDelta',
        '0.001'
    ],
    [
        'refMode',
        'A1'
    ]
];
/* 18.2.3 (CT_CustomWorkbookView) Defaults */ /*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/ function $7c3b72a365cc0275$var$push_defaults_array(target, defaults) {
    for(var j = 0; j != target.length; ++j){
        var w = target[j];
        for(var i = 0; i != defaults.length; ++i){
            var z = defaults[i];
            if (w[z[0]] == null) w[z[0]] = z[1];
            else switch(z[2]){
                case "bool":
                    if (typeof w[z[0]] == "string") w[z[0]] = $7c3b72a365cc0275$var$parsexmlbool(w[z[0]]);
                    break;
                case "int":
                    if (typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10);
                    break;
            }
        }
    }
}
function $7c3b72a365cc0275$var$push_defaults(target, defaults) {
    for(var i = 0; i != defaults.length; ++i){
        var z = defaults[i];
        if (target[z[0]] == null) target[z[0]] = z[1];
        else switch(z[2]){
            case "bool":
                if (typeof target[z[0]] == "string") target[z[0]] = $7c3b72a365cc0275$var$parsexmlbool(target[z[0]]);
                break;
            case "int":
                if (typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10);
                break;
        }
    }
}
function $7c3b72a365cc0275$var$parse_wb_defaults(wb) {
    $7c3b72a365cc0275$var$push_defaults(wb.WBProps, $7c3b72a365cc0275$var$WBPropsDef);
    $7c3b72a365cc0275$var$push_defaults(wb.CalcPr, $7c3b72a365cc0275$var$CalcPrDef);
    $7c3b72a365cc0275$var$push_defaults_array(wb.WBView, $7c3b72a365cc0275$var$WBViewDef);
    $7c3b72a365cc0275$var$push_defaults_array(wb.Sheets, $7c3b72a365cc0275$var$SheetDef);
    $7c3b72a365cc0275$var$_ssfopts.date1904 = $7c3b72a365cc0275$var$parsexmlbool(wb.WBProps.date1904);
}
function $7c3b72a365cc0275$var$safe1904(wb /*:Workbook*/ ) /*:string*/ {
    /* TODO: store date1904 somewhere else */ if (!wb.Workbook) return "false";
    if (!wb.Workbook.WBProps) return "false";
    return $7c3b72a365cc0275$var$parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}
var $7c3b72a365cc0275$var$badchars = /*#__PURE__*/ "][*?\/\\".split("");
function $7c3b72a365cc0275$var$check_ws_name(n /*:string*/ , safe /*:?boolean*/ ) /*:boolean*/ {
    if (n.length > 31) {
        if (safe) return false;
        throw new Error("Sheet names cannot exceed 31 chars");
    }
    var _good = true;
    $7c3b72a365cc0275$var$badchars.forEach(function(c) {
        if (n.indexOf(c) == -1) return;
        if (!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
        _good = false;
    });
    return _good;
}
function $7c3b72a365cc0275$var$check_wb_names(N, S, codes) {
    N.forEach(function(n, i) {
        $7c3b72a365cc0275$var$check_ws_name(n);
        for(var j = 0; j < i; ++j)if (n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
        if (codes) {
            var cn = S && S[i] && S[i].CodeName || n;
            if (cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
        }
    });
}
function $7c3b72a365cc0275$var$check_wb(wb) {
    if (!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
    if (!wb.SheetNames.length) throw new Error("Workbook is empty");
    var Sheets = wb.Workbook && wb.Workbook.Sheets || [];
    $7c3b72a365cc0275$var$check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
    for(var i = 0; i < wb.SheetNames.length; ++i)$7c3b72a365cc0275$var$check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
/* TODO: validate workbook */ }
/* 18.2 Workbook */ var $7c3b72a365cc0275$var$wbnsregex = /<\w+:workbook/;
function $7c3b72a365cc0275$var$parse_wb_xml(data, opts) /*:WorkbookFile*/ {
    if (!data) throw new Error("Could not find file");
    var wb = /*::(*/ {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        Names: [],
        xmlns: ""
    } /*::)*/ ;
    var pass = false, xmlns = "xmlns";
    var dname = {}, dnstart = 0;
    data.replace($7c3b72a365cc0275$var$tagregex, function xml_wb(x, idx) {
        var y /*:any*/  = $7c3b72a365cc0275$var$parsexmltag(x);
        switch($7c3b72a365cc0275$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 18.2.27 workbook CT_Workbook 1 */ case '<workbook':
                if (x.match($7c3b72a365cc0275$var$wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
                wb.xmlns = y[xmlns];
                break;
            case '</workbook>':
                break;
            /* 18.2.13 fileVersion CT_FileVersion ? */ case '<fileVersion':
                delete y[0];
                wb.AppVersion = y;
                break;
            case '<fileVersion/>':
            case '</fileVersion>':
                break;
            /* 18.2.12 fileSharing CT_FileSharing ? */ case '<fileSharing':
                break;
            case '<fileSharing/>':
                break;
            /* 18.2.28 workbookPr CT_WorkbookPr ? */ case '<workbookPr':
            case '<workbookPr/>':
                $7c3b72a365cc0275$var$WBPropsDef.forEach(function(w) {
                    if (y[w[0]] == null) return;
                    switch(w[2]){
                        case "bool":
                            wb.WBProps[w[0]] = $7c3b72a365cc0275$var$parsexmlbool(y[w[0]]);
                            break;
                        case "int":
                            wb.WBProps[w[0]] = parseInt(y[w[0]], 10);
                            break;
                        default:
                            wb.WBProps[w[0]] = y[w[0]];
                    }
                });
                if (y.codeName) wb.WBProps.CodeName = $7c3b72a365cc0275$var$utf8read(y.codeName);
                break;
            case '</workbookPr>':
                break;
            /* 18.2.29 workbookProtection CT_WorkbookProtection ? */ case '<workbookProtection':
                break;
            case '<workbookProtection/>':
                break;
            /* 18.2.1  bookViews CT_BookViews ? */ case '<bookViews':
            case '<bookViews>':
            case '</bookViews>':
                break;
            /* 18.2.30   workbookView CT_BookView + */ case '<workbookView':
            case '<workbookView/>':
                delete y[0];
                wb.WBView.push(y);
                break;
            case '</workbookView>':
                break;
            /* 18.2.20 sheets CT_Sheets 1 */ case '<sheets':
            case '<sheets>':
            case '</sheets>':
                break; // aggregate sheet
            /* 18.2.19   sheet CT_Sheet + */ case '<sheet':
                switch(y.state){
                    case "hidden":
                        y.Hidden = 1;
                        break;
                    case "veryHidden":
                        y.Hidden = 2;
                        break;
                    default:
                        y.Hidden = 0;
                }
                delete y.state;
                y.name = $7c3b72a365cc0275$var$unescapexml($7c3b72a365cc0275$var$utf8read(y.name));
                delete y[0];
                wb.Sheets.push(y);
                break;
            case '</sheet>':
                break;
            /* 18.2.15 functionGroups CT_FunctionGroups ? */ case '<functionGroups':
            case '<functionGroups/>':
                break;
            /* 18.2.14   functionGroup CT_FunctionGroup + */ case '<functionGroup':
                break;
            /* 18.2.9  externalReferences CT_ExternalReferences ? */ case '<externalReferences':
            case '</externalReferences>':
            case '<externalReferences>':
                break;
            /* 18.2.8    externalReference CT_ExternalReference + */ case '<externalReference':
                break;
            /* 18.2.6  definedNames CT_DefinedNames ? */ case '<definedNames/>':
                break;
            case '<definedNames>':
            case '<definedNames':
                pass = true;
                break;
            case '</definedNames>':
                pass = false;
                break;
            /* 18.2.5    definedName CT_DefinedName + */ case '<definedName':
                dname = {};
                dname.Name = $7c3b72a365cc0275$var$utf8read(y.name);
                if (y.comment) dname.Comment = y.comment;
                if (y.localSheetId) dname.Sheet = +y.localSheetId;
                if ($7c3b72a365cc0275$var$parsexmlbool(y.hidden || "0")) dname.Hidden = true;
                dnstart = idx + x.length;
                break;
            case '</definedName>':
                dname.Ref = $7c3b72a365cc0275$var$unescapexml($7c3b72a365cc0275$var$utf8read(data.slice(dnstart, idx)));
                wb.Names.push(dname);
                break;
            case '<definedName/>':
                break;
            /* 18.2.2  calcPr CT_CalcPr ? */ case '<calcPr':
                delete y[0];
                wb.CalcPr = y;
                break;
            case '<calcPr/>':
                delete y[0];
                wb.CalcPr = y;
                break;
            case '</calcPr>':
                break;
            /* 18.2.16 oleSize CT_OleSize ? (ref required) */ case '<oleSize':
                break;
            /* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */ case '<customWorkbookViews>':
            case '</customWorkbookViews>':
            case '<customWorkbookViews':
                break;
            /* 18.2.3  customWorkbookView CT_CustomWorkbookView + */ case '<customWorkbookView':
            case '</customWorkbookView>':
                break;
            /* 18.2.18 pivotCaches CT_PivotCaches ? */ case '<pivotCaches>':
            case '</pivotCaches>':
            case '<pivotCaches':
                break;
            /* 18.2.17 pivotCache CT_PivotCache ? */ case '<pivotCache':
                break;
            /* 18.2.21 smartTagPr CT_SmartTagPr ? */ case '<smartTagPr':
            case '<smartTagPr/>':
                break;
            /* 18.2.23 smartTagTypes CT_SmartTagTypes ? */ case '<smartTagTypes':
            case '<smartTagTypes>':
            case '</smartTagTypes>':
                break;
            /* 18.2.22 smartTagType CT_SmartTagType ? */ case '<smartTagType':
                break;
            /* 18.2.24 webPublishing CT_WebPublishing ? */ case '<webPublishing':
            case '<webPublishing/>':
                break;
            /* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */ case '<fileRecoveryPr':
            case '<fileRecoveryPr/>':
                break;
            /* 18.2.26 webPublishObjects CT_WebPublishObjects ? */ case '<webPublishObjects>':
            case '<webPublishObjects':
            case '</webPublishObjects>':
                break;
            /* 18.2.25 webPublishObject CT_WebPublishObject ? */ case '<webPublishObject':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break; //TODO: check with versions of excel
            case '</ext>':
                pass = false;
                break;
            /* Others */ case '<ArchID':
                break;
            case '<AlternateContent':
            case '<AlternateContent>':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* TODO */ case '<revisionPtr':
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
        }
        return x;
    });
    if ($7c3b72a365cc0275$var$XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
    $7c3b72a365cc0275$var$parse_wb_defaults(wb);
    return wb;
}
function $7c3b72a365cc0275$var$write_wb_xml(wb /*:Workbook*/  /*::, opts:?WriteOpts*/ ) /*:string*/ {
    var o = [
        $7c3b72a365cc0275$var$XML_HEADER
    ];
    o[o.length] = $7c3b72a365cc0275$var$writextag('workbook', null, {
        'xmlns': $7c3b72a365cc0275$var$XMLNS_main[0],
        //'xmlns:mx': XMLNS.mx,
        //'xmlns:s': XMLNS_main[0],
        'xmlns:r': $7c3b72a365cc0275$var$XMLNS.r
    });
    var write_names = wb.Workbook && (wb.Workbook.Names || []).length > 0;
    /* fileVersion */ /* fileSharing */ var workbookPr /*:any*/  = {
        codeName: "ThisWorkbook"
    } /*:any*/ ;
    if (wb.Workbook && wb.Workbook.WBProps) {
        $7c3b72a365cc0275$var$WBPropsDef.forEach(function(x) {
            /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps[x[0]] == null) return;
            if (wb.Workbook.WBProps[x[0]] == x[1]) return;
            workbookPr[x[0]] = wb.Workbook.WBProps[x[0]];
        });
        /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps.CodeName) {
            workbookPr.codeName = wb.Workbook.WBProps.CodeName;
            delete workbookPr.CodeName;
        }
    }
    o[o.length] = $7c3b72a365cc0275$var$writextag('workbookPr', null, workbookPr);
    /* workbookProtection */ var sheets = wb.Workbook && wb.Workbook.Sheets || [];
    var i = 0;
    /* bookViews only written if first worksheet is hidden */ if (sheets && sheets[0] && !!sheets[0].Hidden) {
        o[o.length] = "<bookViews>";
        for(i = 0; i != wb.SheetNames.length; ++i){
            if (!sheets[i]) break;
            if (!sheets[i].Hidden) break;
        }
        if (i == wb.SheetNames.length) i = 0;
        o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
        o[o.length] = "</bookViews>";
    }
    o[o.length] = "<sheets>";
    for(i = 0; i != wb.SheetNames.length; ++i){
        var sht = {
            name: $7c3b72a365cc0275$var$escapexml(wb.SheetNames[i].slice(0, 31))
        } /*:any*/ ;
        sht.sheetId = "" + (i + 1);
        sht["r:id"] = "rId" + (i + 1);
        if (sheets[i]) switch(sheets[i].Hidden){
            case 1:
                sht.state = "hidden";
                break;
            case 2:
                sht.state = "veryHidden";
                break;
        }
        o[o.length] = $7c3b72a365cc0275$var$writextag('sheet', null, sht);
    }
    o[o.length] = "</sheets>";
    /* functionGroups */ /* externalReferences */ if (write_names) {
        o[o.length] = "<definedNames>";
        if (wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
            var d /*:any*/  = {
                name: n.Name
            };
            if (n.Comment) d.comment = n.Comment;
            if (n.Sheet != null) d.localSheetId = "" + n.Sheet;
            if (n.Hidden) d.hidden = "1";
            if (!n.Ref) return;
            o[o.length] = $7c3b72a365cc0275$var$writextag('definedName', $7c3b72a365cc0275$var$escapexml(n.Ref), d);
        });
        o[o.length] = "</definedNames>";
    }
    /* calcPr */ /* oleSize */ /* customWorkbookViews */ /* pivotCaches */ /* smartTagPr */ /* smartTagTypes */ /* webPublishing */ /* fileRecoveryPr */ /* webPublishObjects */ /* extLst */ if (o.length > 2) {
        o[o.length] = '</workbook>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */ function $7c3b72a365cc0275$var$parse_BrtBundleSh(data, length /*:number*/ ) {
    var z = {};
    z.Hidden = data.read_shift(4); //hsState ST_SheetState
    z.iTabID = data.read_shift(4);
    z.strRelID = $7c3b72a365cc0275$var$parse_RelID(data, length - 8);
    z.name = $7c3b72a365cc0275$var$parse_XLWideString(data);
    return z;
}
function $7c3b72a365cc0275$var$write_BrtBundleSh(data, o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(127);
    o.write_shift(4, data.Hidden);
    o.write_shift(4, data.iTabID);
    $7c3b72a365cc0275$var$write_RelID(data.strRelID, o);
    $7c3b72a365cc0275$var$write_XLWideString(data.name.slice(0, 31), o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.815 BrtWbProp */ function $7c3b72a365cc0275$var$parse_BrtWbProp(data, length) /*:WBProps*/ {
    var o /*:WBProps*/  = {} /*:any*/ ;
    var flags = data.read_shift(4);
    o.defaultThemeVersion = data.read_shift(4);
    var strName = length > 8 ? $7c3b72a365cc0275$var$parse_XLWideString(data) : "";
    if (strName.length > 0) o.CodeName = strName;
    o.autoCompressPictures = !!(flags & 0x10000);
    o.backupFile = !!(flags & 0x40);
    o.checkCompatibility = !!(flags & 0x1000);
    o.date1904 = !!(flags & 0x01);
    o.filterPrivacy = !!(flags & 0x08);
    o.hidePivotFieldList = !!(flags & 0x400);
    o.promptedSolutions = !!(flags & 0x10);
    o.publishItems = !!(flags & 0x800);
    o.refreshAllConnections = !!(flags & 0x40000);
    o.saveExternalLinkValues = !!(flags & 0x80);
    o.showBorderUnselectedTables = !!(flags & 0x04);
    o.showInkAnnotation = !!(flags & 0x20);
    o.showObjects = [
        "all",
        "placeholders",
        "none"
    ][flags >> 13 & 0x03];
    o.showPivotChartFilter = !!(flags & 0x8000);
    o.updateLinks = [
        "userSet",
        "never",
        "always"
    ][flags >> 8 & 0x03];
    return o;
}
function $7c3b72a365cc0275$var$write_BrtWbProp(data /*:?WBProps*/ , o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(72);
    var flags = 0;
    if (data) /* TODO: mirror parse_BrtWbProp fields */ {
        if (data.filterPrivacy) flags |= 0x08;
    }
    o.write_shift(4, flags);
    o.write_shift(4, 0);
    $7c3b72a365cc0275$var$write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
    return o.slice(0, o.l);
}
function $7c3b72a365cc0275$var$parse_BrtFRTArchID$(data, length) {
    var o = {};
    data.read_shift(4);
    o.ArchID = data.read_shift(4);
    data.l += length - 8;
    return o;
}
/* [MS-XLSB] 2.4.687 BrtName */ function $7c3b72a365cc0275$var$parse_BrtName(data, length, opts) {
    var end = data.l + length;
    data.l += 4; //var flags = data.read_shift(4);
    data.l += 1; //var chKey = data.read_shift(1);
    var itab = data.read_shift(4);
    var name = $7c3b72a365cc0275$var$parse_XLNameWideString(data);
    var formula = $7c3b72a365cc0275$var$parse_XLSBNameParsedFormula(data, 0, opts);
    var comment = $7c3b72a365cc0275$var$parse_XLNullableWideString(data);
    //if(0 /* fProc */) {
    // unusedstring1: XLNullableWideString
    // description: XLNullableWideString
    // helpTopic: XLNullableWideString
    // unusedstring2: XLNullableWideString
    //}
    data.l = end;
    var out = {
        Name: name,
        Ptg: formula
    } /*:any*/ ;
    if (itab < 0xFFFFFFF) out.Sheet = itab;
    if (comment) out.Comment = comment;
    return out;
}
/* [MS-XLSB] 2.1.7.61 Workbook */ function $7c3b72a365cc0275$var$parse_wb_bin(data, opts) /*:WorkbookFile*/ {
    var wb = {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        xmlns: ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    if (!opts) opts = {};
    opts.biff = 12;
    var Names = [];
    var supbooks = [
        []
    ];
    supbooks.SheetNames = [];
    supbooks.XTI = [];
    $7c3b72a365cc0275$var$XLSBRecordEnum[0x0010] = {
        n: "BrtFRTArchID$",
        f: $7c3b72a365cc0275$var$parse_BrtFRTArchID$
    };
    $7c3b72a365cc0275$var$recordhopper(data, function hopper_wb(val, R, RT) {
        switch(RT){
            case 0x009C:
                /* 'BrtBundleSh' */ supbooks.SheetNames.push(val.name);
                wb.Sheets.push(val);
                break;
            case 0x0099:
                /* 'BrtWbProp' */ wb.WBProps = val;
                break;
            case 0x0027:
                /* 'BrtName' */ if (val.Sheet != null) opts.SID = val.Sheet;
                val.Ref = $7c3b72a365cc0275$var$stringify_formula(val.Ptg, null, null, supbooks, opts);
                delete opts.SID;
                delete val.Ptg;
                Names.push(val);
                break;
            case 0x040C:
                break;
            case 0x0165:
            /* 'BrtSupSelf' */ case 0x0166:
            /* 'BrtSupSame' */ case 0x0163:
            /* 'BrtSupBookSrc' */ case 0x029B:
                /* 'BrtSupAddin' */ if (!supbooks[0].length) supbooks[0] = [
                    RT,
                    val
                ];
                else supbooks.push([
                    RT,
                    val
                ]);
                supbooks[supbooks.length - 1].XTI = [];
                break;
            case 0x016A:
                /* 'BrtExternSheet' */ if (supbooks.length === 0) {
                    supbooks[0] = [];
                    supbooks[0].XTI = [];
                }
                supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
                supbooks.XTI = supbooks.XTI.concat(val);
                break;
            case 0x0169:
                break;
            case 0x0817:
            /* 'BrtAbsPath15' */ case 0x009E:
            /* 'BrtBookView' */ case 0x008F:
            /* 'BrtBeginBundleShs' */ case 0x0298:
            /* 'BrtBeginFnGroup' */ case 0x0161:
                break;
            /* case 'BrtModelTimeGroupingCalcCol' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0C01:
            /* 'BrtRevisionPtr' */ case 0x0216:
            /* 'BrtBookProtection' */ case 0x02A5:
            /* 'BrtBookProtectionIso' */ case 0x009D:
            /* 'BrtCalcProp' */ case 0x0262:
            /* 'BrtCrashRecErr' */ case 0x0802:
            /* 'BrtDecoupledPivotCacheID' */ case 0x009B:
            /* 'BrtFileRecover' */ case 0x0224:
            /* 'BrtFileSharing' */ case 0x02A4:
            /* 'BrtFileSharingIso' */ case 0x0080:
            /* 'BrtFileVersion' */ case 0x0299:
            /* 'BrtFnGroup' */ case 0x0850:
            /* 'BrtModelRelationship' */ case 0x084D:
            /* 'BrtModelTable' */ case 0x0225:
            /* 'BrtOleSize' */ case 0x0805:
            /* 'BrtPivotTableRef' */ case 0x0254:
            /* 'BrtSmartTagType' */ case 0x081C:
            /* 'BrtTableSlicerCacheID' */ case 0x081B:
            /* 'BrtTableSlicerCacheIDs' */ case 0x0822:
            /* 'BrtTimelineCachePivotCacheID' */ case 0x018D:
            /* 'BrtUserBookView' */ case 0x009A:
            /* 'BrtWbFactoid' */ case 0x045D:
            /* 'BrtWbProp14' */ case 0x0229:
            /* 'BrtWebOpt' */ case 0x082B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ state.pop();
                pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            case 0x0010:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */  && state[state.length - 1] != 0x0023 /* BrtFRTBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    $7c3b72a365cc0275$var$parse_wb_defaults(wb);
    // $FlowIgnore
    wb.Names = Names;
    wb /*:any*/ .supbooks = supbooks;
    return wb;
}
function $7c3b72a365cc0275$var$write_BUNDLESHS(ba, wb /*::, opts*/ ) {
    $7c3b72a365cc0275$var$write_record(ba, 0x008F /* BrtBeginBundleShs */ );
    for(var idx = 0; idx != wb.SheetNames.length; ++idx){
        var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
        var d = {
            Hidden: viz,
            iTabID: idx + 1,
            strRelID: 'rId' + (idx + 1),
            name: wb.SheetNames[idx]
        };
        $7c3b72a365cc0275$var$write_record(ba, 0x009C /* BrtBundleSh */ , $7c3b72a365cc0275$var$write_BrtBundleSh(d));
    }
    $7c3b72a365cc0275$var$write_record(ba, 0x0090 /* BrtEndBundleShs */ );
}
/* [MS-XLSB] 2.4.649 BrtFileVersion */ function $7c3b72a365cc0275$var$write_BrtFileVersion(data, o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(127);
    for(var i = 0; i != 4; ++i)o.write_shift(4, 0);
    $7c3b72a365cc0275$var$write_XLWideString("SheetJS", o);
    $7c3b72a365cc0275$var$write_XLWideString($7c3b72a365cc0275$var$XLSX.version, o);
    $7c3b72a365cc0275$var$write_XLWideString($7c3b72a365cc0275$var$XLSX.version, o);
    $7c3b72a365cc0275$var$write_XLWideString("7262", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.301 BrtBookView */ function $7c3b72a365cc0275$var$write_BrtBookView(idx, o) {
    if (!o) o = $7c3b72a365cc0275$var$new_buf(29);
    o.write_shift(-4, 0);
    o.write_shift(-4, 460);
    o.write_shift(4, 28800);
    o.write_shift(4, 17600);
    o.write_shift(4, 500);
    o.write_shift(4, idx);
    o.write_shift(4, idx);
    var flags = 0x78;
    o.write_shift(1, flags);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $7c3b72a365cc0275$var$write_BOOKVIEWS(ba, wb /*::, opts*/ ) {
    /* required if hidden tab appears before visible tab */ if (!wb.Workbook || !wb.Workbook.Sheets) return;
    var sheets = wb.Workbook.Sheets;
    var i = 0, vistab = -1, hidden = -1;
    for(; i < sheets.length; ++i){
        if (!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
        else if (sheets[i].Hidden == 1 && hidden == -1) hidden = i;
    }
    if (hidden > vistab) return;
    $7c3b72a365cc0275$var$write_record(ba, 0x0087 /* BrtBeginBookViews */ );
    $7c3b72a365cc0275$var$write_record(ba, 0x009E /* BrtBookView */ , $7c3b72a365cc0275$var$write_BrtBookView(vistab));
    /* 1*(BrtBookView *FRT) */ $7c3b72a365cc0275$var$write_record(ba, 0x0088 /* BrtEndBookViews */ );
}
/* [MS-XLSB] 2.4.305 BrtCalcProp */ /*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/ /* [MS-XLSB] 2.4.646 BrtFileRecover */ /*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/ /* [MS-XLSB] 2.1.7.61 Workbook */ function $7c3b72a365cc0275$var$write_wb_bin(wb, opts) {
    var ba = $7c3b72a365cc0275$var$buf_array();
    $7c3b72a365cc0275$var$write_record(ba, 0x0083 /* BrtBeginBook */ );
    $7c3b72a365cc0275$var$write_record(ba, 0x0080 /* BrtFileVersion */ , $7c3b72a365cc0275$var$write_BrtFileVersion());
    /* [[BrtFileSharingIso] BrtFileSharing] */ $7c3b72a365cc0275$var$write_record(ba, 0x0099 /* BrtWbProp */ , $7c3b72a365cc0275$var$write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
    /* [ACABSPATH] */ /* [[BrtBookProtectionIso] BrtBookProtection] */ $7c3b72a365cc0275$var$write_BOOKVIEWS(ba, wb, opts);
    $7c3b72a365cc0275$var$write_BUNDLESHS(ba, wb, opts);
    /* [FNGROUP] */ /* [EXTERNALS] */ /* *BrtName */ /* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */ /* [BrtOleSize] */ /* *(BrtUserBookView *FRT) */ /* [PIVOTCACHEIDS] */ /* [BrtWbFactoid] */ /* [SMARTTAGTYPES] */ /* [BrtWebOpt] */ /* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */ /* [WEBPUBITEMS] */ /* [CRERRS] */ /* FRTWORKBOOK */ $7c3b72a365cc0275$var$write_record(ba, 0x0084 /* BrtEndBook */ );
    return ba.end();
}
function $7c3b72a365cc0275$var$parse_wb(data, name /*:string*/ , opts) /*:WorkbookFile*/ {
    if (name.slice(-4) === ".bin") return $7c3b72a365cc0275$var$parse_wb_bin(data /*:any*/ , opts);
    return $7c3b72a365cc0275$var$parse_wb_xml(data /*:any*/ , opts);
}
function $7c3b72a365cc0275$var$parse_ws(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $7c3b72a365cc0275$var$parse_ws_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $7c3b72a365cc0275$var$parse_ws_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $7c3b72a365cc0275$var$parse_cs(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $7c3b72a365cc0275$var$parse_cs_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $7c3b72a365cc0275$var$parse_cs_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $7c3b72a365cc0275$var$parse_ms(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $7c3b72a365cc0275$var$parse_ms_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $7c3b72a365cc0275$var$parse_ms_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $7c3b72a365cc0275$var$parse_ds(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $7c3b72a365cc0275$var$parse_ds_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $7c3b72a365cc0275$var$parse_ds_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $7c3b72a365cc0275$var$parse_sty(data, name /*:string*/ , themes, opts) {
    if (name.slice(-4) === ".bin") return $7c3b72a365cc0275$var$parse_sty_bin(data /*:any*/ , themes, opts);
    return $7c3b72a365cc0275$var$parse_sty_xml(data /*:any*/ , themes, opts);
}
function $7c3b72a365cc0275$var$parse_theme(data /*:string*/ , name /*:string*/ , opts) {
    return $7c3b72a365cc0275$var$parse_theme_xml(data, opts);
}
function $7c3b72a365cc0275$var$parse_sst(data, name /*:string*/ , opts) /*:SST*/ {
    if (name.slice(-4) === ".bin") return $7c3b72a365cc0275$var$parse_sst_bin(data /*:any*/ , opts);
    return $7c3b72a365cc0275$var$parse_sst_xml(data /*:any*/ , opts);
}
function $7c3b72a365cc0275$var$parse_cmnt(data, name /*:string*/ , opts) /*:Array<RawComment>*/ {
    if (name.slice(-4) === ".bin") return $7c3b72a365cc0275$var$parse_comments_bin(data /*:any*/ , opts);
    return $7c3b72a365cc0275$var$parse_comments_xml(data /*:any*/ , opts);
}
function $7c3b72a365cc0275$var$parse_cc(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $7c3b72a365cc0275$var$parse_cc_bin(data /*:any*/ , name, opts);
    return $7c3b72a365cc0275$var$parse_cc_xml(data /*:any*/ , name, opts);
}
function $7c3b72a365cc0275$var$parse_xlink(data, rel, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $7c3b72a365cc0275$var$parse_xlink_bin(data /*:any*/ , rel, name, opts);
    return $7c3b72a365cc0275$var$parse_xlink_xml(data /*:any*/ , rel, name, opts);
}
function $7c3b72a365cc0275$var$parse_xlmeta(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $7c3b72a365cc0275$var$parse_xlmeta_bin(data /*:any*/ , name, opts);
    return $7c3b72a365cc0275$var$parse_xlmeta_xml(data /*:any*/ , name, opts);
}
function $7c3b72a365cc0275$var$write_wb(wb, name /*:string*/ , opts) {
    return (name.slice(-4) === ".bin" ? $7c3b72a365cc0275$var$write_wb_bin : $7c3b72a365cc0275$var$write_wb_xml)(wb, opts);
}
function $7c3b72a365cc0275$var$write_ws(data /*:number*/ , name /*:string*/ , opts, wb /*:Workbook*/ , rels) {
    return (name.slice(-4) === ".bin" ? $7c3b72a365cc0275$var$write_ws_bin : $7c3b72a365cc0275$var$write_ws_xml)(data, opts, wb, rels);
}
// eslint-disable-next-line no-unused-vars
function $7c3b72a365cc0275$var$write_cs(data /*:number*/ , name /*:string*/ , opts, wb /*:Workbook*/ , rels) {
    return (name.slice(-4) === ".bin" ? $7c3b72a365cc0275$var$write_cs_bin : $7c3b72a365cc0275$var$write_cs_xml)(data, opts, wb, rels);
}
function $7c3b72a365cc0275$var$write_sty(data, name /*:string*/ , opts) {
    return (name.slice(-4) === ".bin" ? $7c3b72a365cc0275$var$write_sty_bin : $7c3b72a365cc0275$var$write_sty_xml)(data, opts);
}
function $7c3b72a365cc0275$var$write_sst(data /*:SST*/ , name /*:string*/ , opts) {
    return (name.slice(-4) === ".bin" ? $7c3b72a365cc0275$var$write_sst_bin : $7c3b72a365cc0275$var$write_sst_xml)(data, opts);
}
function $7c3b72a365cc0275$var$write_cmnt(data /*:Array<any>*/ , name /*:string*/ , opts) {
    return (name.slice(-4) === ".bin" ? $7c3b72a365cc0275$var$write_comments_bin : $7c3b72a365cc0275$var$write_comments_xml)(data, opts);
}
/*
function write_cc(data, name:string, opts) {
	return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
}
*/ function $7c3b72a365cc0275$var$write_xlmeta(name /*:string*/ ) {
    return (name.slice(-4) === ".bin" ? $7c3b72a365cc0275$var$write_xlmeta_bin : $7c3b72a365cc0275$var$write_xlmeta_xml)();
}
var $7c3b72a365cc0275$var$attregexg2 = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var $7c3b72a365cc0275$var$attregex2 = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function $7c3b72a365cc0275$var$xlml_parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ ) {
    var words = tag.split(/\s+/);
    var z /*:any*/  = [];
    if (!skip_root) z[0] = words[0];
    if (words.length === 1) return z;
    var m = tag.match($7c3b72a365cc0275$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($7c3b72a365cc0275$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
function $7c3b72a365cc0275$var$xlml_parsexmltagobj(tag /*:string*/ ) {
    var words = tag.split(/\s+/);
    var z = {};
    if (words.length === 1) return z;
    var m = tag.match($7c3b72a365cc0275$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($7c3b72a365cc0275$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
// ----
/* map from xlml named formats to SSF TODO: localize */ var $7c3b72a365cc0275$var$XLMLFormatMap /*: {[string]:string}*/ ;
function $7c3b72a365cc0275$var$xlml_format(format, value) /*:string*/ {
    var fmt = $7c3b72a365cc0275$var$XLMLFormatMap[format] || $7c3b72a365cc0275$var$unescapexml(format);
    if (fmt === "General") return $7c3b72a365cc0275$var$SSF_general(value);
    return $7c3b72a365cc0275$var$SSF_format(fmt, value);
}
function $7c3b72a365cc0275$var$xlml_set_custprop(Custprops, key, cp, val /*:string*/ ) {
    var oval /*:any*/  = val;
    switch((cp[0].match(/dt:dt="([\w.]+)"/) || [
        "",
        ""
    ])[1]){
        case "boolean":
            oval = $7c3b72a365cc0275$var$parsexmlbool(val);
            break;
        case "i2":
        case "int":
            oval = parseInt(val, 10);
            break;
        case "r4":
        case "float":
            oval = parseFloat(val);
            break;
        case "date":
        case "dateTime.tz":
            oval = $7c3b72a365cc0275$var$parseDate(val);
            break;
        case "i8":
        case "string":
        case "fixed":
        case "uuid":
        case "bin.base64":
            break;
        default:
            throw new Error("bad custprop:" + cp[0]);
    }
    Custprops[$7c3b72a365cc0275$var$unescapexml(key)] = oval;
}
function $7c3b72a365cc0275$var$safe_format_xlml(cell /*:Cell*/ , nf, o) {
    if (cell.t === 'z') return;
    if (!o || o.cellText !== false) try {
        if (cell.t === 'e') cell.w = cell.w || $7c3b72a365cc0275$var$BErr[cell.v];
        else if (nf === "General") {
            if (cell.t === 'n') {
                if ((cell.v | 0) === cell.v) cell.w = cell.v.toString(10);
                else cell.w = $7c3b72a365cc0275$var$SSF_general_num(cell.v);
            } else cell.w = $7c3b72a365cc0275$var$SSF_general(cell.v);
        } else cell.w = $7c3b72a365cc0275$var$xlml_format(nf || "General", cell.v);
    } catch (e) {
        if (o.WTF) throw e;
    }
    try {
        var z = $7c3b72a365cc0275$var$XLMLFormatMap[nf] || nf || "General";
        if (o.cellNF) cell.z = z;
        if (o.cellDates && cell.t == 'n' && $7c3b72a365cc0275$var$fmt_is_date(z)) {
            var _d = $7c3b72a365cc0275$var$SSF_parse_date_code(cell.v);
            if (_d) {
                cell.t = 'd';
                cell.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
            }
        }
    } catch (e) {
        if (o.WTF) throw e;
    }
}
function $7c3b72a365cc0275$var$process_style_xlml(styles, stag, opts) {
    if (opts.cellStyles) {
        if (stag.Interior) {
            var I = stag.Interior;
            if (I.Pattern) I.patternType = $7c3b72a365cc0275$var$XLMLPatternTypeMap[I.Pattern] || I.Pattern;
        }
    }
    styles[stag.ID] = stag;
}
/* TODO: there must exist some form of OSP-blessed spec */ function $7c3b72a365cc0275$var$parse_xlml_data(xml, ss, data, cell /*:any*/ , base, styles, csty, row, arrayf, o) {
    var nf = "General", sid = cell.StyleID, S = {};
    o = o || {};
    var interiors = [];
    var i = 0;
    if (sid === undefined && row) sid = row.StyleID;
    if (sid === undefined && csty) sid = csty.StyleID;
    while(styles[sid] !== undefined){
        if (styles[sid].nf) nf = styles[sid].nf;
        if (styles[sid].Interior) interiors.push(styles[sid].Interior);
        if (!styles[sid].Parent) break;
        sid = styles[sid].Parent;
    }
    switch(data.Type){
        case 'Boolean':
            cell.t = 'b';
            cell.v = $7c3b72a365cc0275$var$parsexmlbool(xml);
            break;
        case 'String':
            cell.t = 's';
            cell.r = $7c3b72a365cc0275$var$xlml_fixstr($7c3b72a365cc0275$var$unescapexml(xml));
            cell.v = xml.indexOf("<") > -1 ? $7c3b72a365cc0275$var$unescapexml(ss || xml).replace(/<.*?>/g, "") : cell.r; // todo: BR etc
            break;
        case 'DateTime':
            if (xml.slice(-1) != "Z") xml += "Z";
            cell.v = ($7c3b72a365cc0275$var$parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / 86400000;
            if (cell.v !== cell.v) cell.v = $7c3b72a365cc0275$var$unescapexml(xml);
            else if (cell.v < 60) cell.v = cell.v - 1;
            if (!nf || nf == "General") nf = "yyyy-mm-dd";
        /* falls through */ case 'Number':
            if (cell.v === undefined) cell.v = +xml;
            if (!cell.t) cell.t = 'n';
            break;
        case 'Error':
            cell.t = 'e';
            cell.v = $7c3b72a365cc0275$var$RBErr[xml];
            if (o.cellText !== false) cell.w = xml;
            break;
        default:
            if (xml == "" && ss == "") cell.t = 'z';
            else {
                cell.t = 's';
                cell.v = $7c3b72a365cc0275$var$xlml_fixstr(ss || xml);
            }
            break;
    }
    $7c3b72a365cc0275$var$safe_format_xlml(cell, nf, o);
    if (o.cellFormula !== false) {
        if (cell.Formula) {
            var fstr = $7c3b72a365cc0275$var$unescapexml(cell.Formula);
            /* strictly speaking, the leading = is required but some writers omit */ if (fstr.charCodeAt(0) == 61 /* = */ ) fstr = fstr.slice(1);
            cell.f = $7c3b72a365cc0275$var$rc_to_a1(fstr, base);
            delete cell.Formula;
            if (cell.ArrayRange == "RC") cell.F = $7c3b72a365cc0275$var$rc_to_a1("RC:RC", base);
            else if (cell.ArrayRange) {
                cell.F = $7c3b72a365cc0275$var$rc_to_a1(cell.ArrayRange, base);
                arrayf.push([
                    $7c3b72a365cc0275$var$safe_decode_range(cell.F),
                    cell.F
                ]);
            }
        } else {
            for(i = 0; i < arrayf.length; ++i)if (base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r) {
                if (base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c) cell.F = arrayf[i][1];
            }
        }
    }
    if (o.cellStyles) {
        interiors.forEach(function(x) {
            if (!S.patternType && x.patternType) S.patternType = x.patternType;
        });
        cell.s = S;
    }
    if (cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}
function $7c3b72a365cc0275$var$xlml_clean_comment(comment /*:any*/ ) {
    comment.t = comment.v || "";
    comment.t = comment.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    comment.v = comment.w = comment.ixfe = undefined;
}
/* TODO: Everything */ function $7c3b72a365cc0275$var$parse_xlml_xml(d, _opts) /*:Workbook*/ {
    var opts = _opts || {};
    $7c3b72a365cc0275$var$make_ssf();
    var str = $7c3b72a365cc0275$var$debom($7c3b72a365cc0275$var$xlml_normalize(d));
    if (opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
        if (typeof $7c3b72a365cc0275$var$$cptable !== 'undefined') str = $7c3b72a365cc0275$var$$cptable.utils.decode(65001, $7c3b72a365cc0275$var$char_codes(str));
        else str = $7c3b72a365cc0275$var$utf8read(str);
    }
    var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
    opening = opening.replace(/".*?"/g, "");
    if ((opening.indexOf(">") & 1023) > Math.min(opening.indexOf(",") & 1023, opening.indexOf(";") & 1023)) {
        var _o = $7c3b72a365cc0275$var$dup(opts);
        _o.type = "string";
        return $7c3b72a365cc0275$var$PRN.to_workbook(str, _o);
    }
    if (opening.indexOf("<?xml") == -1) [
        "html",
        "table",
        "head",
        "meta",
        "script",
        "style",
        "div"
    ].forEach(function(tag) {
        if (opening.indexOf("<" + tag) >= 0) ishtml = true;
    });
    if (ishtml) return $7c3b72a365cc0275$var$html_to_workbook(str, opts);
    $7c3b72a365cc0275$var$XLMLFormatMap = {
        "General Number": "General",
        "General Date": $7c3b72a365cc0275$var$table_fmt[22],
        "Long Date": "dddd, mmmm dd, yyyy",
        "Medium Date": $7c3b72a365cc0275$var$table_fmt[15],
        "Short Date": $7c3b72a365cc0275$var$table_fmt[14],
        "Long Time": $7c3b72a365cc0275$var$table_fmt[19],
        "Medium Time": $7c3b72a365cc0275$var$table_fmt[18],
        "Short Time": $7c3b72a365cc0275$var$table_fmt[20],
        "Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        "Fixed": $7c3b72a365cc0275$var$table_fmt[2],
        "Standard": $7c3b72a365cc0275$var$table_fmt[4],
        "Percent": $7c3b72a365cc0275$var$table_fmt[10],
        "Scientific": $7c3b72a365cc0275$var$table_fmt[11],
        "Yes/No": '"Yes";"Yes";"No";@',
        "True/False": '"True";"True";"False";@',
        "On/Off": '"Yes";"Yes";"No";@'
    } /*:any*/ ;
    var Rn;
    var state = [], tmp;
    if ($7c3b72a365cc0275$var$DENSE != null && opts.dense == null) opts.dense = $7c3b72a365cc0275$var$DENSE;
    var sheets = {}, sheetnames /*:Array<string>*/  = [], cursheet /*:Worksheet*/  = opts.dense ? [] : {}, sheetname = "";
    var cell = {} /*:any*/ , row = {}; // eslint-disable-line no-unused-vars
    var dtag = $7c3b72a365cc0275$var$xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
    var c = 0, r = 0;
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var styles = {}, stag = {};
    var ss = "", fidx = 0;
    var merges /*:Array<Range>*/  = [];
    var Props = {}, Custprops = {}, pidx = 0, cp = [];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var cstys = [], csty, seencol = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var rowinfo /*:Array<RowInfo>*/  = [], rowobj = {}, cc = 0, rr = 0;
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        }
    } /*:any*/ , wsprops = {};
    $7c3b72a365cc0275$var$xlmlregex.lastIndex = 0;
    str = str.replace(/<!--([\s\S]*?)-->/mg, "");
    var raw_Rn3 = "";
    while(Rn = $7c3b72a365cc0275$var$xlmlregex.exec(str))switch(Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase()){
        case 'data' /*case 'Data'*/ :
            if (raw_Rn3 == "data") {
                if (Rn[1] === '/') {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                    Rn[3],
                    true
                ]);
                break;
            }
            if (state[state.length - 1][1]) break;
            if (Rn[1] === '/') $7c3b72a365cc0275$var$parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length - 1][0] == /*"Comment"*/ "comment" ? comment : cell, {
                c: c,
                r: r
            }, styles, cstys[c], row, arrayf, opts);
            else {
                ss = "";
                dtag = $7c3b72a365cc0275$var$xlml_parsexmltag(Rn[0]);
                didx = Rn.index + Rn[0].length;
            }
            break;
        case 'cell' /*case 'Cell'*/ :
            if (Rn[1] === '/') {
                if (comments.length > 0) cell.c = comments;
                if ((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) {
                    if (opts.dense) {
                        if (!cursheet[r]) cursheet[r] = [];
                        cursheet[r][c] = cell;
                    } else cursheet[$7c3b72a365cc0275$var$encode_col(c) + $7c3b72a365cc0275$var$encode_row(r)] = cell;
                }
                if (cell.HRef) {
                    cell.l = {
                        Target: $7c3b72a365cc0275$var$unescapexml(cell.HRef)
                    } /*:any*/ ;
                    if (cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
                    delete cell.HRef;
                    delete cell.HRefScreenTip;
                }
                if (cell.MergeAcross || cell.MergeDown) {
                    cc = c + (parseInt(cell.MergeAcross, 10) | 0);
                    rr = r + (parseInt(cell.MergeDown, 10) | 0);
                    merges.push({
                        s: {
                            c: c,
                            r: r
                        },
                        e: {
                            c: cc,
                            r: rr
                        }
                    });
                }
                if (!opts.sheetStubs) {
                    if (cell.MergeAcross) c = cc + 1;
                    else ++c;
                } else if (cell.MergeAcross || cell.MergeDown) {
                    /*:: if(!cc) cc = 0; if(!rr) rr = 0; */ for(var cma = c; cma <= cc; ++cma){
                        for(var cmd = r; cmd <= rr; ++cmd)if (cma > c || cmd > r) {
                            if (opts.dense) {
                                if (!cursheet[cmd]) cursheet[cmd] = [];
                                cursheet[cmd][cma] = {
                                    t: 'z'
                                };
                            } else cursheet[$7c3b72a365cc0275$var$encode_col(cma) + $7c3b72a365cc0275$var$encode_row(cmd)] = {
                                t: 'z'
                            };
                        }
                    }
                    c = cc + 1;
                } else ++c;
            } else {
                cell = $7c3b72a365cc0275$var$xlml_parsexmltagobj(Rn[0]);
                if (cell.Index) c = +cell.Index - 1;
                if (c < refguess.s.c) refguess.s.c = c;
                if (c > refguess.e.c) refguess.e.c = c;
                if (Rn[0].slice(-2) === "/>") ++c;
                comments = [];
            }
            break;
        case 'row' /*case 'Row'*/ :
            if (Rn[1] === '/' || Rn[0].slice(-2) === "/>") {
                if (r < refguess.s.r) refguess.s.r = r;
                if (r > refguess.e.r) refguess.e.r = r;
                if (Rn[0].slice(-2) === "/>") {
                    row = $7c3b72a365cc0275$var$xlml_parsexmltag(Rn[0]);
                    if (row.Index) r = +row.Index - 1;
                }
                c = 0;
                ++r;
            } else {
                row = $7c3b72a365cc0275$var$xlml_parsexmltag(Rn[0]);
                if (row.Index) r = +row.Index - 1;
                rowobj = {};
                if (row.AutoFitHeight == "0" || row.Height) {
                    rowobj.hpx = parseInt(row.Height, 10);
                    rowobj.hpt = $7c3b72a365cc0275$var$px2pt(rowobj.hpx);
                    rowinfo[r] = rowobj;
                }
                if (row.Hidden == "1") {
                    rowobj.hidden = true;
                    rowinfo[r] = rowobj;
                }
            }
            break;
        case 'worksheet' /*case 'Worksheet'*/ :
            /* TODO: read range from FullRows/FullColumns */ if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                sheetnames.push(sheetname);
                if (refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
                    cursheet["!ref"] = $7c3b72a365cc0275$var$encode_range(refguess);
                    if (opts.sheetRows && opts.sheetRows <= refguess.e.r) {
                        cursheet["!fullref"] = cursheet["!ref"];
                        refguess.e.r = opts.sheetRows - 1;
                        cursheet["!ref"] = $7c3b72a365cc0275$var$encode_range(refguess);
                    }
                }
                if (merges.length) cursheet["!merges"] = merges;
                if (cstys.length > 0) cursheet["!cols"] = cstys;
                if (rowinfo.length > 0) cursheet["!rows"] = rowinfo;
                sheets[sheetname] = cursheet;
            } else {
                refguess = {
                    s: {
                        r: 2000000,
                        c: 2000000
                    },
                    e: {
                        r: 0,
                        c: 0
                    }
                };
                r = c = 0;
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $7c3b72a365cc0275$var$xlml_parsexmltag(Rn[0]);
                sheetname = $7c3b72a365cc0275$var$unescapexml(tmp.Name);
                cursheet = opts.dense ? [] : {};
                merges = [];
                arrayf = [];
                rowinfo = [];
                wsprops = {
                    name: sheetname,
                    Hidden: 0
                };
                Workbook.Sheets.push(wsprops);
            }
            break;
        case 'table' /*case 'Table'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].slice(-2) == "/>") break;
            else {
                state.push([
                    Rn[3],
                    false
                ]);
                cstys = [];
                seencol = false;
            }
            break;
        case 'style' /*case 'Style'*/ :
            if (Rn[1] === '/') $7c3b72a365cc0275$var$process_style_xlml(styles, stag, opts);
            else stag = $7c3b72a365cc0275$var$xlml_parsexmltag(Rn[0]);
            break;
        case 'numberformat' /*case 'NumberFormat'*/ :
            stag.nf = $7c3b72a365cc0275$var$unescapexml($7c3b72a365cc0275$var$xlml_parsexmltag(Rn[0]).Format || "General");
            if ($7c3b72a365cc0275$var$XLMLFormatMap[stag.nf]) stag.nf = $7c3b72a365cc0275$var$XLMLFormatMap[stag.nf];
            for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx)if ($7c3b72a365cc0275$var$table_fmt[ssfidx] == stag.nf) break;
            if (ssfidx == 0x188) {
                for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx)if ($7c3b72a365cc0275$var$table_fmt[ssfidx] == null) {
                    $7c3b72a365cc0275$var$SSF_load(stag.nf, ssfidx);
                    break;
                }
            }
            break;
        case 'column' /*case 'Column'*/ :
            if (state[state.length - 1][0] !== /*'Table'*/ 'table') break;
            csty = $7c3b72a365cc0275$var$xlml_parsexmltag(Rn[0]);
            if (csty.Hidden) {
                csty.hidden = true;
                delete csty.Hidden;
            }
            if (csty.Width) csty.wpx = parseInt(csty.Width, 10);
            if (!seencol && csty.wpx > 10) {
                seencol = true;
                $7c3b72a365cc0275$var$MDW = $7c3b72a365cc0275$var$DEF_MDW; //find_mdw_wpx(csty.wpx);
                for(var _col = 0; _col < cstys.length; ++_col)if (cstys[_col]) $7c3b72a365cc0275$var$process_col(cstys[_col]);
            }
            if (seencol) $7c3b72a365cc0275$var$process_col(csty);
            cstys[csty.Index - 1 || cstys.length] = csty;
            for(var i = 0; i < +csty.Span; ++i)cstys[cstys.length] = $7c3b72a365cc0275$var$dup(csty);
            break;
        case 'namedrange' /*case 'NamedRange'*/ :
            if (Rn[1] === '/') break;
            if (!Workbook.Names) Workbook.Names = [];
            var _NamedRange = $7c3b72a365cc0275$var$parsexmltag(Rn[0]);
            var _DefinedName /*:DefinedName*/  = {
                Name: _NamedRange.Name,
                Ref: $7c3b72a365cc0275$var$rc_to_a1(_NamedRange.RefersTo.slice(1), {
                    r: 0,
                    c: 0
                })
            } /*:any*/ ;
            if (Workbook.Sheets.length > 0) _DefinedName.Sheet = Workbook.Sheets.length - 1;
            /*:: if(Workbook.Names) */ Workbook.Names.push(_DefinedName);
            break;
        case 'namedcell' /*case 'NamedCell'*/ :
            break;
        case 'b' /*case 'B'*/ :
            break;
        case 'i' /*case 'I'*/ :
            break;
        case 'u' /*case 'U'*/ :
            break;
        case 's' /*case 'S'*/ :
            break;
        case 'em' /*case 'EM'*/ :
            break;
        case 'h2' /*case 'H2'*/ :
            break;
        case 'h3' /*case 'H3'*/ :
            break;
        case 'sub' /*case 'Sub'*/ :
            break;
        case 'sup' /*case 'Sup'*/ :
            break;
        case 'span' /*case 'Span'*/ :
            break;
        case 'alignment' /*case 'Alignment'*/ :
            break;
        case 'borders' /*case 'Borders'*/ :
            break;
        case 'border' /*case 'Border'*/ :
            break;
        case 'font' /*case 'Font'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") ss += str.slice(fidx, Rn.index);
            else fidx = Rn.index + Rn[0].length;
            break;
        case 'interior' /*case 'Interior'*/ :
            if (!opts.cellStyles) break;
            stag.Interior = $7c3b72a365cc0275$var$xlml_parsexmltag(Rn[0]);
            break;
        case 'protection' /*case 'Protection'*/ :
            break;
        case 'author' /*case 'Author'*/ :
        case 'title' /*case 'Title'*/ :
        case 'description' /*case 'Description'*/ :
        case 'created' /*case 'Created'*/ :
        case 'keywords' /*case 'Keywords'*/ :
        case 'subject' /*case 'Subject'*/ :
        case 'category' /*case 'Category'*/ :
        case 'company' /*case 'Company'*/ :
        case 'lastauthor' /*case 'LastAuthor'*/ :
        case 'lastsaved' /*case 'LastSaved'*/ :
        case 'lastprinted' /*case 'LastPrinted'*/ :
        case 'version' /*case 'Version'*/ :
        case 'revision' /*case 'Revision'*/ :
        case 'totaltime' /*case 'TotalTime'*/ :
        case 'hyperlinkbase' /*case 'HyperlinkBase'*/ :
        case 'manager' /*case 'Manager'*/ :
        case 'contentstatus' /*case 'ContentStatus'*/ :
        case 'identifier' /*case 'Identifier'*/ :
        case 'language' /*case 'Language'*/ :
        case 'appname' /*case 'AppName'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") $7c3b72a365cc0275$var$xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
            else pidx = Rn.index + Rn[0].length;
            break;
        case 'paragraphs' /*case 'Paragraphs'*/ :
            break;
        case 'styles' /*case 'Styles'*/ :
        case 'workbook' /*case 'Workbook'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else state.push([
                Rn[3],
                false
            ]);
            break;
        case 'comment' /*case 'Comment'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                $7c3b72a365cc0275$var$xlml_clean_comment(comment);
                comments.push(comment);
            } else {
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $7c3b72a365cc0275$var$xlml_parsexmltag(Rn[0]);
                comment = {
                    a: tmp.Author
                } /*:any*/ ;
            }
            break;
        case 'autofilter' /*case 'AutoFilter'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                var AutoFilter = $7c3b72a365cc0275$var$xlml_parsexmltag(Rn[0]);
                cursheet['!autofilter'] = {
                    ref: $7c3b72a365cc0275$var$rc_to_a1(AutoFilter.Range).replace(/\$/g, "")
                };
                state.push([
                    Rn[3],
                    true
                ]);
            }
            break;
        case 'name' /*case 'Name'*/ :
            break;
        case 'datavalidation' /*case 'DataValidation'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'pixelsperinch' /*case 'PixelsPerInch'*/ :
            break;
        case 'componentoptions' /*case 'ComponentOptions'*/ :
        case 'documentproperties' /*case 'DocumentProperties'*/ :
        case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/ :
        case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
        case 'pivottable' /*case 'PivotTable'*/ :
        case 'pivotcache' /*case 'PivotCache'*/ :
        case 'names' /*case 'Names'*/ :
        case 'mapinfo' /*case 'MapInfo'*/ :
        case 'pagebreaks' /*case 'PageBreaks'*/ :
        case 'querytable' /*case 'QueryTable'*/ :
        case 'sorting' /*case 'Sorting'*/ :
        case 'schema' /*case 'Schema'*/ :
        case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
        case 'smarttagtype' /*case 'SmartTagType'*/ :
        case 'smarttags' /*case 'SmartTags'*/ :
        case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
        case 'workbookoptions' /*case 'WorkbookOptions'*/ :
        case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'null' /*case 'Null'*/ :
            break;
        default:
            /* FODS file root is <office:document> */ if (state.length == 0 && Rn[3] == "document") return $7c3b72a365cc0275$var$parse_fods(str, opts);
            /* UOS file root is <uof:UOF> */ if (state.length == 0 && Rn[3] == "uof" /*"UOF"*/ ) return $7c3b72a365cc0275$var$parse_fods(str, opts);
            var seen = true;
            switch(state[state.length - 1][0]){
                /* OfficeDocumentSettings */ case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
                    switch(Rn[3]){
                        case 'allowpng' /*case 'AllowPNG'*/ :
                            break;
                        case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/ :
                            break;
                        case 'downloadcomponents' /*case 'DownloadComponents'*/ :
                            break;
                        case 'locationofcomponents' /*case 'LocationOfComponents'*/ :
                            break;
                        case 'colors' /*case 'Colors'*/ :
                            break;
                        case 'color' /*case 'Color'*/ :
                            break;
                        case 'index' /*case 'Index'*/ :
                            break;
                        case 'rgb' /*case 'RGB'*/ :
                            break;
                        case 'targetscreensize' /*case 'TargetScreenSize'*/ :
                            break;
                        case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ComponentOptions */ case 'componentoptions' /*case 'ComponentOptions'*/ :
                    switch(Rn[3]){
                        case 'toolbar' /*case 'Toolbar'*/ :
                            break;
                        case 'hideofficelogo' /*case 'HideOfficeLogo'*/ :
                            break;
                        case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/ :
                            break;
                        case 'label' /*case 'Label'*/ :
                            break;
                        case 'caption' /*case 'Caption'*/ :
                            break;
                        case 'maxheight' /*case 'MaxHeight'*/ :
                            break;
                        case 'maxwidth' /*case 'MaxWidth'*/ :
                            break;
                        case 'nextsheetnumber' /*case 'NextSheetNumber'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ExcelWorkbook */ case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
                    switch(Rn[3]){
                        case 'date1904' /*case 'Date1904'*/ :
                            /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ Workbook.WBProps.date1904 = true;
                            break;
                        case 'windowheight' /*case 'WindowHeight'*/ :
                            break;
                        case 'windowwidth' /*case 'WindowWidth'*/ :
                            break;
                        case 'windowtopx' /*case 'WindowTopX'*/ :
                            break;
                        case 'windowtopy' /*case 'WindowTopY'*/ :
                            break;
                        case 'tabratio' /*case 'TabRatio'*/ :
                            break;
                        case 'protectstructure' /*case 'ProtectStructure'*/ :
                            break;
                        case 'protectwindow' /*case 'ProtectWindow'*/ :
                            break;
                        case 'protectwindows' /*case 'ProtectWindows'*/ :
                            break;
                        case 'activesheet' /*case 'ActiveSheet'*/ :
                            break;
                        case 'displayinknotes' /*case 'DisplayInkNotes'*/ :
                            break;
                        case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/ :
                            break;
                        case 'supbook' /*case 'SupBook'*/ :
                            break;
                        case 'sheetname' /*case 'SheetName'*/ :
                            break;
                        case 'sheetindex' /*case 'SheetIndex'*/ :
                            break;
                        case 'sheetindexfirst' /*case 'SheetIndexFirst'*/ :
                            break;
                        case 'sheetindexlast' /*case 'SheetIndexLast'*/ :
                            break;
                        case 'dll' /*case 'Dll'*/ :
                            break;
                        case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/ :
                            break;
                        case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/ :
                            break;
                        case 'iteration' /*case 'Iteration'*/ :
                            break;
                        case 'maxiterations' /*case 'MaxIterations'*/ :
                            break;
                        case 'maxchange' /*case 'MaxChange'*/ :
                            break;
                        case 'path' /*case 'Path'*/ :
                            break;
                        case 'xct' /*case 'Xct'*/ :
                            break;
                        case 'count' /*case 'Count'*/ :
                            break;
                        case 'selectedsheets' /*case 'SelectedSheets'*/ :
                            break;
                        case 'calculation' /*case 'Calculation'*/ :
                            break;
                        case 'uncalced' /*case 'Uncalced'*/ :
                            break;
                        case 'startupprompt' /*case 'StartupPrompt'*/ :
                            break;
                        case 'crn' /*case 'Crn'*/ :
                            break;
                        case 'externname' /*case 'ExternName'*/ :
                            break;
                        case 'formula' /*case 'Formula'*/ :
                            break;
                        case 'colfirst' /*case 'ColFirst'*/ :
                            break;
                        case 'collast' /*case 'ColLast'*/ :
                            break;
                        case 'wantadvise' /*case 'WantAdvise'*/ :
                            break;
                        case 'boolean' /*case 'Boolean'*/ :
                            break;
                        case 'error' /*case 'Error'*/ :
                            break;
                        case 'text' /*case 'Text'*/ :
                            break;
                        case 'ole' /*case 'OLE'*/ :
                            break;
                        case 'noautorecover' /*case 'NoAutoRecover'*/ :
                            break;
                        case 'publishobjects' /*case 'PublishObjects'*/ :
                            break;
                        case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'refmoder1c1' /*case 'RefModeR1C1'*/ :
                            break;
                        case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorkbookOptions */ case 'workbookoptions' /*case 'WorkbookOptions'*/ :
                    switch(Rn[3]){
                        case 'owcversion' /*case 'OWCVersion'*/ :
                            break;
                        case 'height' /*case 'Height'*/ :
                            break;
                        case 'width' /*case 'Width'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorksheetOptions */ case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
                    switch(Rn[3]){
                        case 'visible' /*case 'Visible'*/ :
                            if (Rn[0].slice(-2) === "/>") ;
                            else if (Rn[1] === "/") switch(str.slice(pidx, Rn.index)){
                                case "SheetHidden":
                                    wsprops.Hidden = 1;
                                    break;
                                case "SheetVeryHidden":
                                    wsprops.Hidden = 2;
                                    break;
                            }
                            else pidx = Rn.index + Rn[0].length;
                            break;
                        case 'header' /*case 'Header'*/ :
                            if (!cursheet['!margins']) $7c3b72a365cc0275$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+$7c3b72a365cc0275$var$parsexmltag(Rn[0]).Margin)) cursheet['!margins'].header = +$7c3b72a365cc0275$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case 'footer' /*case 'Footer'*/ :
                            if (!cursheet['!margins']) $7c3b72a365cc0275$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+$7c3b72a365cc0275$var$parsexmltag(Rn[0]).Margin)) cursheet['!margins'].footer = +$7c3b72a365cc0275$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case 'pagemargins' /*case 'PageMargins'*/ :
                            var pagemargins = $7c3b72a365cc0275$var$parsexmltag(Rn[0]);
                            if (!cursheet['!margins']) $7c3b72a365cc0275$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+pagemargins.Top)) cursheet['!margins'].top = +pagemargins.Top;
                            if (!isNaN(+pagemargins.Left)) cursheet['!margins'].left = +pagemargins.Left;
                            if (!isNaN(+pagemargins.Right)) cursheet['!margins'].right = +pagemargins.Right;
                            if (!isNaN(+pagemargins.Bottom)) cursheet['!margins'].bottom = +pagemargins.Bottom;
                            break;
                        case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/ :
                            if (!Workbook.Views) Workbook.Views = [];
                            if (!Workbook.Views[0]) Workbook.Views[0] = {};
                            Workbook.Views[0].RTL = true;
                            break;
                        case 'freezepanes' /*case 'FreezePanes'*/ :
                            break;
                        case 'frozennosplit' /*case 'FrozenNoSplit'*/ :
                            break;
                        case 'splithorizontal' /*case 'SplitHorizontal'*/ :
                        case 'splitvertical' /*case 'SplitVertical'*/ :
                            break;
                        case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/ :
                            break;
                        case 'activerow' /*case 'ActiveRow'*/ :
                            break;
                        case 'activecol' /*case 'ActiveCol'*/ :
                            break;
                        case 'toprowbottompane' /*case 'TopRowBottomPane'*/ :
                            break;
                        case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/ :
                            break;
                        case 'unsynced' /*case 'Unsynced'*/ :
                            break;
                        case 'print' /*case 'Print'*/ :
                            break;
                        case 'printerrors' /*case 'PrintErrors'*/ :
                            break;
                        case 'panes' /*case 'Panes'*/ :
                            break;
                        case 'scale' /*case 'Scale'*/ :
                            break;
                        case 'pane' /*case 'Pane'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'layout' /*case 'Layout'*/ :
                            break;
                        case 'pagesetup' /*case 'PageSetup'*/ :
                            break;
                        case 'selected' /*case 'Selected'*/ :
                            break;
                        case 'protectobjects' /*case 'ProtectObjects'*/ :
                            break;
                        case 'enableselection' /*case 'EnableSelection'*/ :
                            break;
                        case 'protectscenarios' /*case 'ProtectScenarios'*/ :
                            break;
                        case 'validprinterinfo' /*case 'ValidPrinterInfo'*/ :
                            break;
                        case 'horizontalresolution' /*case 'HorizontalResolution'*/ :
                            break;
                        case 'verticalresolution' /*case 'VerticalResolution'*/ :
                            break;
                        case 'numberofcopies' /*case 'NumberofCopies'*/ :
                            break;
                        case 'activepane' /*case 'ActivePane'*/ :
                            break;
                        case 'toprowvisible' /*case 'TopRowVisible'*/ :
                            break;
                        case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/ :
                            break;
                        case 'fittopage' /*case 'FitToPage'*/ :
                            break;
                        case 'rangeselection' /*case 'RangeSelection'*/ :
                            break;
                        case 'papersizeindex' /*case 'PaperSizeIndex'*/ :
                            break;
                        case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/ :
                            break;
                        case 'pagebreakzoom' /*case 'PageBreakZoom'*/ :
                            break;
                        case 'filteron' /*case 'FilterOn'*/ :
                            break;
                        case 'fitwidth' /*case 'FitWidth'*/ :
                            break;
                        case 'fitheight' /*case 'FitHeight'*/ :
                            break;
                        case 'commentslayout' /*case 'CommentsLayout'*/ :
                            break;
                        case 'zoom' /*case 'Zoom'*/ :
                            break;
                        case 'lefttoright' /*case 'LeftToRight'*/ :
                            break;
                        case 'gridlines' /*case 'Gridlines'*/ :
                            break;
                        case 'allowsort' /*case 'AllowSort'*/ :
                            break;
                        case 'allowfilter' /*case 'AllowFilter'*/ :
                            break;
                        case 'allowinsertrows' /*case 'AllowInsertRows'*/ :
                            break;
                        case 'allowdeleterows' /*case 'AllowDeleteRows'*/ :
                            break;
                        case 'allowinsertcols' /*case 'AllowInsertCols'*/ :
                            break;
                        case 'allowdeletecols' /*case 'AllowDeleteCols'*/ :
                            break;
                        case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/ :
                            break;
                        case 'allowformatcells' /*case 'AllowFormatCells'*/ :
                            break;
                        case 'allowsizecols' /*case 'AllowSizeCols'*/ :
                            break;
                        case 'allowsizerows' /*case 'AllowSizeRows'*/ :
                            break;
                        case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].above = true;
                            break;
                        case 'tabcolorindex' /*case 'TabColorIndex'*/ :
                            break;
                        case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/ :
                            break;
                        case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/ :
                            break;
                        case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].left = true;
                            break;
                        case 'blackandwhite' /*case 'BlackAndWhite'*/ :
                            break;
                        case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/ :
                            break;
                        case 'displaypagebreak' /*case 'DisplayPageBreak'*/ :
                            break;
                        case 'rowcolheadings' /*case 'RowColHeadings'*/ :
                            break;
                        case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/ :
                            break;
                        case 'noorientation' /*case 'NoOrientation'*/ :
                            break;
                        case 'allowusepivottables' /*case 'AllowUsePivotTables'*/ :
                            break;
                        case 'zeroheight' /*case 'ZeroHeight'*/ :
                            break;
                        case 'viewablerange' /*case 'ViewableRange'*/ :
                            break;
                        case 'selection' /*case 'Selection'*/ :
                            break;
                        case 'protectcontents' /*case 'ProtectContents'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PivotTable */ case 'pivottable' /*case 'PivotTable'*/ :
                case 'pivotcache' /*case 'PivotCache'*/ :
                    switch(Rn[3]){
                        case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/ :
                            break;
                        case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/ :
                            break;
                        case 'compactrowindent' /*case 'CompactRowIndent'*/ :
                            break;
                        case 'location' /*case 'Location'*/ :
                            break;
                        case 'pivotfield' /*case 'PivotField'*/ :
                            break;
                        case 'orientation' /*case 'Orientation'*/ :
                            break;
                        case 'layoutform' /*case 'LayoutForm'*/ :
                            break;
                        case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/ :
                            break;
                        case 'layoutcompactrow' /*case 'LayoutCompactRow'*/ :
                            break;
                        case 'position' /*case 'Position'*/ :
                            break;
                        case 'pivotitem' /*case 'PivotItem'*/ :
                            break;
                        case 'datatype' /*case 'DataType'*/ :
                            break;
                        case 'datafield' /*case 'DataField'*/ :
                            break;
                        case 'sourcename' /*case 'SourceName'*/ :
                            break;
                        case 'parentfield' /*case 'ParentField'*/ :
                            break;
                        case 'ptlineitems' /*case 'PTLineItems'*/ :
                            break;
                        case 'ptlineitem' /*case 'PTLineItem'*/ :
                            break;
                        case 'countofsameitems' /*case 'CountOfSameItems'*/ :
                            break;
                        case 'item' /*case 'Item'*/ :
                            break;
                        case 'itemtype' /*case 'ItemType'*/ :
                            break;
                        case 'ptsource' /*case 'PTSource'*/ :
                            break;
                        case 'cacheindex' /*case 'CacheIndex'*/ :
                            break;
                        case 'consolidationreference' /*case 'ConsolidationReference'*/ :
                            break;
                        case 'filename' /*case 'FileName'*/ :
                            break;
                        case 'reference' /*case 'Reference'*/ :
                            break;
                        case 'nocolumngrand' /*case 'NoColumnGrand'*/ :
                            break;
                        case 'norowgrand' /*case 'NoRowGrand'*/ :
                            break;
                        case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/ :
                            break;
                        case 'hidden' /*case 'Hidden'*/ :
                            break;
                        case 'subtotal' /*case 'Subtotal'*/ :
                            break;
                        case 'basefield' /*case 'BaseField'*/ :
                            break;
                        case 'mapchilditems' /*case 'MapChildItems'*/ :
                            break;
                        case 'function' /*case 'Function'*/ :
                            break;
                        case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/ :
                            break;
                        case 'printsettitles' /*case 'PrintSetTitles'*/ :
                            break;
                        case 'mergelabels' /*case 'MergeLabels'*/ :
                            break;
                        case 'defaultversion' /*case 'DefaultVersion'*/ :
                            break;
                        case 'refreshname' /*case 'RefreshName'*/ :
                            break;
                        case 'refreshdate' /*case 'RefreshDate'*/ :
                            break;
                        case 'refreshdatecopy' /*case 'RefreshDateCopy'*/ :
                            break;
                        case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                            break;
                        case 'versionlastupdate' /*case 'VersionLastUpdate'*/ :
                            break;
                        case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/ :
                            break;
                        case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/ :
                            break;
                        case 'calculation' /*case 'Calculation'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PageBreaks */ case 'pagebreaks' /*case 'PageBreaks'*/ :
                    switch(Rn[3]){
                        case 'colbreaks' /*case 'ColBreaks'*/ :
                            break;
                        case 'colbreak' /*case 'ColBreak'*/ :
                            break;
                        case 'rowbreaks' /*case 'RowBreaks'*/ :
                            break;
                        case 'rowbreak' /*case 'RowBreak'*/ :
                            break;
                        case 'colstart' /*case 'ColStart'*/ :
                            break;
                        case 'colend' /*case 'ColEnd'*/ :
                            break;
                        case 'rowend' /*case 'RowEnd'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* AutoFilter */ case 'autofilter' /*case 'AutoFilter'*/ :
                    switch(Rn[3]){
                        case 'autofiltercolumn' /*case 'AutoFilterColumn'*/ :
                            break;
                        case 'autofiltercondition' /*case 'AutoFilterCondition'*/ :
                            break;
                        case 'autofilterand' /*case 'AutoFilterAnd'*/ :
                            break;
                        case 'autofilteror' /*case 'AutoFilterOr'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* QueryTable */ case 'querytable' /*case 'QueryTable'*/ :
                    switch(Rn[3]){
                        case 'id' /*case 'Id'*/ :
                            break;
                        case 'autoformatfont' /*case 'AutoFormatFont'*/ :
                            break;
                        case 'autoformatpattern' /*case 'AutoFormatPattern'*/ :
                            break;
                        case 'querysource' /*case 'QuerySource'*/ :
                            break;
                        case 'querytype' /*case 'QueryType'*/ :
                            break;
                        case 'enableredirections' /*case 'EnableRedirections'*/ :
                            break;
                        case 'refreshedinxl9' /*case 'RefreshedInXl9'*/ :
                            break;
                        case 'urlstring' /*case 'URLString'*/ :
                            break;
                        case 'htmltables' /*case 'HTMLTables'*/ :
                            break;
                        case 'connection' /*case 'Connection'*/ :
                            break;
                        case 'commandtext' /*case 'CommandText'*/ :
                            break;
                        case 'refreshinfo' /*case 'RefreshInfo'*/ :
                            break;
                        case 'notitles' /*case 'NoTitles'*/ :
                            break;
                        case 'nextid' /*case 'NextId'*/ :
                            break;
                        case 'columninfo' /*case 'ColumnInfo'*/ :
                            break;
                        case 'overwritecells' /*case 'OverwriteCells'*/ :
                            break;
                        case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/ :
                            break;
                        case 'textwizardsettings' /*case 'TextWizardSettings'*/ :
                            break;
                        case 'source' /*case 'Source'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'decimal' /*case 'Decimal'*/ :
                            break;
                        case 'thousandseparator' /*case 'ThousandSeparator'*/ :
                            break;
                        case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/ :
                            break;
                        case 'formatsettings' /*case 'FormatSettings'*/ :
                            break;
                        case 'fieldtype' /*case 'FieldType'*/ :
                            break;
                        case 'delimiters' /*case 'Delimiters'*/ :
                            break;
                        case 'tab' /*case 'Tab'*/ :
                            break;
                        case 'comma' /*case 'Comma'*/ :
                            break;
                        case 'autoformatname' /*case 'AutoFormatName'*/ :
                            break;
                        case 'versionlastedit' /*case 'VersionLastEdit'*/ :
                            break;
                        case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case 'datavalidation' /*case 'DataValidation'*/ :
                    switch(Rn[3]){
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'type' /*case 'Type'*/ :
                            break;
                        case 'min' /*case 'Min'*/ :
                            break;
                        case 'max' /*case 'Max'*/ :
                            break;
                        case 'sort' /*case 'Sort'*/ :
                            break;
                        case 'descending' /*case 'Descending'*/ :
                            break;
                        case 'order' /*case 'Order'*/ :
                            break;
                        case 'casesensitive' /*case 'CaseSensitive'*/ :
                            break;
                        case 'value' /*case 'Value'*/ :
                            break;
                        case 'errorstyle' /*case 'ErrorStyle'*/ :
                            break;
                        case 'errormessage' /*case 'ErrorMessage'*/ :
                            break;
                        case 'errortitle' /*case 'ErrorTitle'*/ :
                            break;
                        case 'inputmessage' /*case 'InputMessage'*/ :
                            break;
                        case 'inputtitle' /*case 'InputTitle'*/ :
                            break;
                        case 'combohide' /*case 'ComboHide'*/ :
                            break;
                        case 'inputhide' /*case 'InputHide'*/ :
                            break;
                        case 'condition' /*case 'Condition'*/ :
                            break;
                        case 'qualifier' /*case 'Qualifier'*/ :
                            break;
                        case 'useblank' /*case 'UseBlank'*/ :
                            break;
                        case 'value1' /*case 'Value1'*/ :
                            break;
                        case 'value2' /*case 'Value2'*/ :
                            break;
                        case 'format' /*case 'Format'*/ :
                            break;
                        case 'cellrangelist' /*case 'CellRangeList'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case 'sorting' /*case 'Sorting'*/ :
                case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
                    switch(Rn[3]){
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'type' /*case 'Type'*/ :
                            break;
                        case 'min' /*case 'Min'*/ :
                            break;
                        case 'max' /*case 'Max'*/ :
                            break;
                        case 'sort' /*case 'Sort'*/ :
                            break;
                        case 'descending' /*case 'Descending'*/ :
                            break;
                        case 'order' /*case 'Order'*/ :
                            break;
                        case 'casesensitive' /*case 'CaseSensitive'*/ :
                            break;
                        case 'value' /*case 'Value'*/ :
                            break;
                        case 'errorstyle' /*case 'ErrorStyle'*/ :
                            break;
                        case 'errormessage' /*case 'ErrorMessage'*/ :
                            break;
                        case 'errortitle' /*case 'ErrorTitle'*/ :
                            break;
                        case 'cellrangelist' /*case 'CellRangeList'*/ :
                            break;
                        case 'inputmessage' /*case 'InputMessage'*/ :
                            break;
                        case 'inputtitle' /*case 'InputTitle'*/ :
                            break;
                        case 'combohide' /*case 'ComboHide'*/ :
                            break;
                        case 'inputhide' /*case 'InputHide'*/ :
                            break;
                        case 'condition' /*case 'Condition'*/ :
                            break;
                        case 'qualifier' /*case 'Qualifier'*/ :
                            break;
                        case 'useblank' /*case 'UseBlank'*/ :
                            break;
                        case 'value1' /*case 'Value1'*/ :
                            break;
                        case 'value2' /*case 'Value2'*/ :
                            break;
                        case 'format' /*case 'Format'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* MapInfo (schema) */ case 'mapinfo' /*case 'MapInfo'*/ :
                case 'schema' /*case 'Schema'*/ :
                case 'data' /*case 'data'*/ :
                    switch(Rn[3]){
                        case 'map' /*case 'Map'*/ :
                            break;
                        case 'entry' /*case 'Entry'*/ :
                            break;
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'xpath' /*case 'XPath'*/ :
                            break;
                        case 'field' /*case 'Field'*/ :
                            break;
                        case 'xsdtype' /*case 'XSDType'*/ :
                            break;
                        case 'filteron' /*case 'FilterOn'*/ :
                            break;
                        case 'aggregate' /*case 'Aggregate'*/ :
                            break;
                        case 'elementtype' /*case 'ElementType'*/ :
                            break;
                        case 'attributetype' /*case 'AttributeType'*/ :
                            break;
                        /* These are from xsd (XML Schema Definition) */ case 'schema' /*case 'schema'*/ :
                        case 'element' /*case 'element'*/ :
                        case 'complextype' /*case 'complexType'*/ :
                        case 'datatype' /*case 'datatype'*/ :
                        case 'all' /*case 'all'*/ :
                        case 'attribute' /*case 'attribute'*/ :
                        case 'extends' /*case 'extends'*/ :
                            break;
                        case 'row' /*case 'row'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* SmartTags (can be anything) */ case 'smarttags' /*case 'SmartTags'*/ :
                    break;
                default:
                    seen = false;
                    break;
            }
            if (seen) break;
            /* CustomDocumentProperties */ if (Rn[3].match(/!\[CDATA/)) break;
            if (!state[state.length - 1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
            if (state[state.length - 1][0] === /*'CustomDocumentProperties'*/ 'customdocumentproperties') {
                if (Rn[0].slice(-2) === "/>") break;
                else if (Rn[1] === "/") $7c3b72a365cc0275$var$xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
                else {
                    cp = Rn;
                    pidx = Rn.index + Rn[0].length;
                }
                break;
            }
            if (opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
    }
    var out = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
    out.SheetNames = sheetnames;
    out.Workbook = Workbook;
    out.SSF = $7c3b72a365cc0275$var$dup($7c3b72a365cc0275$var$table_fmt);
    out.Props = Props;
    out.Custprops = Custprops;
    return out;
}
function $7c3b72a365cc0275$var$parse_xlml(data /*:RawBytes|string*/ , opts) /*:Workbook*/ {
    $7c3b72a365cc0275$var$fix_read_opts(opts = opts || {});
    switch(opts.type || "base64"){
        case "base64":
            return $7c3b72a365cc0275$var$parse_xlml_xml($7c3b72a365cc0275$var$Base64_decode(data), opts);
        case "binary":
        case "buffer":
        case "file":
            return $7c3b72a365cc0275$var$parse_xlml_xml(data, opts);
        case "array":
            return $7c3b72a365cc0275$var$parse_xlml_xml($7c3b72a365cc0275$var$a2s(data), opts);
    }
/*:: throw new Error("unsupported type " + opts.type); */ }
/* TODO */ function $7c3b72a365cc0275$var$write_props_xlml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o /*:Array<string>*/  = [];
    /* DocumentProperties */ if (wb.Props) o.push($7c3b72a365cc0275$var$xlml_write_docprops(wb.Props, opts));
    /* CustomDocumentProperties */ if (wb.Custprops) o.push($7c3b72a365cc0275$var$xlml_write_custprops(wb.Props, wb.Custprops, opts));
    return o.join("");
}
/* TODO */ function $7c3b72a365cc0275$var$write_wb_xlml() /*:string*/ {
    /* OfficeDocumentSettings */ /* ExcelWorkbook */ return "";
}
/* TODO */ function $7c3b72a365cc0275$var$write_sty_xlml(wb, opts) /*:string*/ {
    /* Styles */ var styles /*:Array<string>*/  = [
        '<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'
    ];
    opts.cellXfs.forEach(function(xf, id) {
        var payload /*:Array<string>*/  = [];
        payload.push($7c3b72a365cc0275$var$writextag('NumberFormat', null, {
            "ss:Format": $7c3b72a365cc0275$var$escapexml($7c3b72a365cc0275$var$table_fmt[xf.numFmtId])
        }));
        var o = /*::(*/ {
            "ss:ID": "s" + (21 + id)
        } /*:: :any)*/ ;
        styles.push($7c3b72a365cc0275$var$writextag('Style', payload.join(""), o));
    });
    return $7c3b72a365cc0275$var$writextag("Styles", styles.join(""));
}
function $7c3b72a365cc0275$var$write_name_xlml(n) {
    return $7c3b72a365cc0275$var$writextag("NamedRange", null, {
        "ss:Name": n.Name,
        "ss:RefersTo": "=" + $7c3b72a365cc0275$var$a1_to_rc(n.Ref, {
            r: 0,
            c: 0
        })
    });
}
function $7c3b72a365cc0275$var$write_names_xlml(wb /*::, opts*/ ) /*:string*/ {
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != null) continue;
        if (n.Name.match(/^_xlfn\./)) continue;
        out.push($7c3b72a365cc0275$var$write_name_xlml(n));
    }
    return $7c3b72a365cc0275$var$writextag("Names", out.join(""));
}
function $7c3b72a365cc0275$var$write_ws_xlml_names(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != idx) continue;
        /*switch(n.Name) {
			case "_": continue;
		}*/ if (n.Name.match(/^_xlfn\./)) continue;
        out.push($7c3b72a365cc0275$var$write_name_xlml(n));
    }
    return out.join("");
}
/* WorksheetOptions */ function $7c3b72a365cc0275$var$write_ws_xlml_wsopts(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    var o /*:Array<string>*/  = [];
    /* NOTE: spec technically allows any order, but stick with implied order */ /* FitToPage */ /* DoNotDisplayColHeaders */ /* DoNotDisplayRowHeaders */ /* ViewableRange */ /* Selection */ /* GridlineColor */ /* Name */ /* ExcelWorksheetType */ /* IntlMacro */ /* Unsynced */ /* Selected */ /* CodeName */ if (ws['!margins']) {
        o.push("<PageSetup>");
        if (ws['!margins'].header) o.push($7c3b72a365cc0275$var$writextag("Header", null, {
            'x:Margin': ws['!margins'].header
        }));
        if (ws['!margins'].footer) o.push($7c3b72a365cc0275$var$writextag("Footer", null, {
            'x:Margin': ws['!margins'].footer
        }));
        o.push($7c3b72a365cc0275$var$writextag("PageMargins", null, {
            'x:Bottom': ws['!margins'].bottom || "0.75",
            'x:Left': ws['!margins'].left || "0.7",
            'x:Right': ws['!margins'].right || "0.7",
            'x:Top': ws['!margins'].top || "0.75"
        }));
        o.push("</PageSetup>");
    }
    /* PageSetup */ /* DisplayPageBreak */ /* TransitionExpressionEvaluation */ /* TransitionFormulaEntry */ /* Print */ /* Zoom */ /* PageLayoutZoom */ /* PageBreakZoom */ /* ShowPageBreakZoom */ /* DefaultRowHeight */ /* DefaultColumnWidth */ /* StandardWidth */ if (wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
        /* Visible */ if (wb.Workbook.Sheets[idx].Hidden) o.push($7c3b72a365cc0275$var$writextag("Visible", wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
        else {
            /* Selected */ for(var i = 0; i < idx; ++i)if (wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
            if (i == idx) o.push("<Selected/>");
        }
    }
    /* LeftColumnVisible */ if (((((wb || {}).Workbook || {}).Views || [])[0] || {}).RTL) o.push("<DisplayRightToLeft/>");
    /* GridlineColorIndex */ /* DisplayFormulas */ /* DoNotDisplayGridlines */ /* DoNotDisplayHeadings */ /* DoNotDisplayOutline */ /* ApplyAutomaticOutlineStyles */ /* NoSummaryRowsBelowDetail */ /* NoSummaryColumnsRightDetail */ /* DoNotDisplayZeros */ /* ActiveRow */ /* ActiveColumn */ /* FilterOn */ /* RangeSelection */ /* TopRowVisible */ /* TopRowBottomPane */ /* LeftColumnRightPane */ /* ActivePane */ /* SplitHorizontal */ /* SplitVertical */ /* FreezePanes */ /* FrozenNoSplit */ /* TabColorIndex */ /* Panes */ /* NOTE: Password not supported in XLML Format */ if (ws['!protect']) {
        o.push($7c3b72a365cc0275$var$writetag("ProtectContents", "True"));
        if (ws['!protect'].objects) o.push($7c3b72a365cc0275$var$writetag("ProtectObjects", "True"));
        if (ws['!protect'].scenarios) o.push($7c3b72a365cc0275$var$writetag("ProtectScenarios", "True"));
        if (ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push($7c3b72a365cc0275$var$writetag("EnableSelection", "NoSelection"));
        else if (ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push($7c3b72a365cc0275$var$writetag("EnableSelection", "UnlockedCells"));
        [
            [
                "formatCells",
                "AllowFormatCells"
            ],
            [
                "formatColumns",
                "AllowSizeCols"
            ],
            [
                "formatRows",
                "AllowSizeRows"
            ],
            [
                "insertColumns",
                "AllowInsertCols"
            ],
            [
                "insertRows",
                "AllowInsertRows"
            ],
            [
                "insertHyperlinks",
                "AllowInsertHyperlinks"
            ],
            [
                "deleteColumns",
                "AllowDeleteCols"
            ],
            [
                "deleteRows",
                "AllowDeleteRows"
            ],
            [
                "sort",
                "AllowSort"
            ],
            [
                "autoFilter",
                "AllowFilter"
            ],
            [
                "pivotTables",
                "AllowUsePivotTables"
            ]
        ].forEach(function(x) {
            if (ws['!protect'][x[0]]) o.push("<" + x[1] + "/>");
        });
    }
    if (o.length == 0) return "";
    return $7c3b72a365cc0275$var$writextag("WorksheetOptions", o.join(""), {
        xmlns: $7c3b72a365cc0275$var$XLMLNS.x
    });
}
function $7c3b72a365cc0275$var$write_ws_xlml_comment(comments /*:Array<any>*/ ) /*:string*/ {
    return comments.map(function(c) {
        // TODO: formatted text
        var t = $7c3b72a365cc0275$var$xlml_unfixstr(c.t || "");
        var d = $7c3b72a365cc0275$var$writextag("ss:Data", t, {
            "xmlns": "http://www.w3.org/TR/REC-html40"
        });
        return $7c3b72a365cc0275$var$writextag("Comment", d, {
            "ss:Author": c.a
        });
    }).join("");
}
function $7c3b72a365cc0275$var$write_ws_xlml_cell(cell, ref /*:string*/ , ws, opts, idx /*:number*/ , wb, addr) /*:string*/ {
    if (!cell || cell.v == undefined && cell.f == undefined) return "";
    var attr = {};
    if (cell.f) attr["ss:Formula"] = "=" + $7c3b72a365cc0275$var$escapexml($7c3b72a365cc0275$var$a1_to_rc(cell.f, addr));
    if (cell.F && cell.F.slice(0, ref.length) == ref) {
        var end = $7c3b72a365cc0275$var$decode_cell(cell.F.slice(ref.length + 1));
        attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
    }
    if (cell.l && cell.l.Target) {
        attr["ss:HRef"] = $7c3b72a365cc0275$var$escapexml(cell.l.Target);
        if (cell.l.Tooltip) attr["x:HRefScreenTip"] = $7c3b72a365cc0275$var$escapexml(cell.l.Tooltip);
    }
    if (ws['!merges']) {
        var marr = ws['!merges'];
        for(var mi = 0; mi != marr.length; ++mi){
            if (marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
            if (marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
            if (marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
        }
    }
    var t = "", p = "";
    switch(cell.t){
        case 'z':
            if (!opts.sheetStubs) return "";
            break;
        case 'n':
            t = 'Number';
            p = String(cell.v);
            break;
        case 'b':
            t = 'Boolean';
            p = cell.v ? "1" : "0";
            break;
        case 'e':
            t = 'Error';
            p = $7c3b72a365cc0275$var$BErr[cell.v];
            break;
        case 'd':
            t = 'DateTime';
            p = new Date(cell.v).toISOString();
            if (cell.z == null) cell.z = cell.z || $7c3b72a365cc0275$var$table_fmt[14];
            break;
        case 's':
            t = 'String';
            p = $7c3b72a365cc0275$var$escapexlml(cell.v || "");
            break;
    }
    /* TODO: cell style */ var os = $7c3b72a365cc0275$var$get_cell_style(opts.cellXfs, cell, opts);
    attr["ss:StyleID"] = "s" + (21 + os);
    attr["ss:Index"] = addr.c + 1;
    var _v = cell.v != null ? p : "";
    var m = cell.t == 'z' ? "" : '<Data ss:Type="' + t + '">' + _v + '</Data>';
    if ((cell.c || []).length > 0) m += $7c3b72a365cc0275$var$write_ws_xlml_comment(cell.c);
    return $7c3b72a365cc0275$var$writextag("Cell", m, attr);
}
function $7c3b72a365cc0275$var$write_ws_xlml_row(R /*:number*/ , row) /*:string*/ {
    var o = '<Row ss:Index="' + (R + 1) + '"';
    if (row) {
        if (row.hpt && !row.hpx) row.hpx = $7c3b72a365cc0275$var$pt2px(row.hpt);
        if (row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
        if (row.hidden) o += ' ss:Hidden="1"';
    }
    return o + '>';
}
/* TODO */ function $7c3b72a365cc0275$var$write_ws_xlml_table(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws['!ref']) return "";
    var range /*:Range*/  = $7c3b72a365cc0275$var$safe_decode_range(ws['!ref']);
    var marr /*:Array<Range>*/  = ws['!merges'] || [], mi = 0;
    var o /*:Array<string>*/  = [];
    if (ws['!cols']) ws['!cols'].forEach(function(n, i) {
        $7c3b72a365cc0275$var$process_col(n);
        var w = !!n.width;
        var p = $7c3b72a365cc0275$var$col_obj_w(i, n);
        var k /*:any*/  = {
            "ss:Index": i + 1
        };
        if (w) k['ss:Width'] = $7c3b72a365cc0275$var$width2px(p.width);
        if (n.hidden) k['ss:Hidden'] = "1";
        o.push($7c3b72a365cc0275$var$writextag("Column", null, k));
    });
    var dense = Array.isArray(ws);
    for(var R = range.s.r; R <= range.e.r; ++R){
        var row = [
            $7c3b72a365cc0275$var$write_ws_xlml_row(R, (ws['!rows'] || [])[R])
        ];
        for(var C = range.s.c; C <= range.e.c; ++C){
            var skip = false;
            for(mi = 0; mi != marr.length; ++mi){
                if (marr[mi].s.c > C) continue;
                if (marr[mi].s.r > R) continue;
                if (marr[mi].e.c < C) continue;
                if (marr[mi].e.r < R) continue;
                if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                break;
            }
            if (skip) continue;
            var addr = {
                r: R,
                c: C
            };
            var ref = $7c3b72a365cc0275$var$encode_cell(addr), cell = dense ? (ws[R] || [])[C] : ws[ref];
            row.push($7c3b72a365cc0275$var$write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
        }
        row.push("</Row>");
        if (row.length > 2) o.push(row.join(""));
    }
    return o.join("");
}
function $7c3b72a365cc0275$var$write_ws_xlml(idx /*:number*/ , opts, wb /*:Workbook*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    var s = wb.SheetNames[idx];
    var ws = wb.Sheets[s];
    var t /*:string*/  = ws ? $7c3b72a365cc0275$var$write_ws_xlml_names(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Names>" + t + "</Names>");
    /* Table */ t = ws ? $7c3b72a365cc0275$var$write_ws_xlml_table(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Table>" + t + "</Table>");
    /* WorksheetOptions */ o.push($7c3b72a365cc0275$var$write_ws_xlml_wsopts(ws, opts, idx, wb));
    return o.join("");
}
function $7c3b72a365cc0275$var$write_xlml(wb, opts) /*:string*/ {
    if (!opts) opts = {};
    if (!wb.SSF) wb.SSF = $7c3b72a365cc0275$var$dup($7c3b72a365cc0275$var$table_fmt);
    if (wb.SSF) {
        $7c3b72a365cc0275$var$make_ssf();
        $7c3b72a365cc0275$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $7c3b72a365cc0275$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $7c3b72a365cc0275$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    var d /*:Array<string>*/  = [];
    d.push($7c3b72a365cc0275$var$write_props_xlml(wb, opts));
    d.push($7c3b72a365cc0275$var$write_wb_xlml(wb, opts));
    d.push("");
    d.push("");
    for(var i = 0; i < wb.SheetNames.length; ++i)d.push($7c3b72a365cc0275$var$writextag("Worksheet", $7c3b72a365cc0275$var$write_ws_xlml(i, opts, wb), {
        "ss:Name": $7c3b72a365cc0275$var$escapexml(wb.SheetNames[i])
    }));
    d[2] = $7c3b72a365cc0275$var$write_sty_xlml(wb, opts);
    d[3] = $7c3b72a365cc0275$var$write_names_xlml(wb, opts);
    return $7c3b72a365cc0275$var$XML_HEADER + $7c3b72a365cc0275$var$writextag("Workbook", d.join(""), {
        'xmlns': $7c3b72a365cc0275$var$XLMLNS.ss,
        'xmlns:o': $7c3b72a365cc0275$var$XLMLNS.o,
        'xmlns:x': $7c3b72a365cc0275$var$XLMLNS.x,
        'xmlns:ss': $7c3b72a365cc0275$var$XLMLNS.ss,
        'xmlns:dt': $7c3b72a365cc0275$var$XLMLNS.dt,
        'xmlns:html': $7c3b72a365cc0275$var$XLMLNS.html
    });
}
/* [MS-OLEDS] 2.3.8 CompObjStream */ function $7c3b72a365cc0275$var$parse_compobj(obj /*:CFBEntry*/ ) {
    var v = {};
    var o = obj.content;
    /*:: if(o == null) return; */ /* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */ o.l = 28;
    v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
    v.AnsiClipboardFormat = $7c3b72a365cc0275$var$parse_ClipboardFormatOrAnsiString(o);
    if (o.length - o.l <= 4) return v;
    var m /*:number*/  = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved1 = o.read_shift(0, "lpstr-ansi");
    if (o.length - o.l <= 4) return v;
    m = o.read_shift(4);
    if (m !== 0x71b239f4) return v;
    v.UnicodeClipboardFormat = $7c3b72a365cc0275$var$parse_ClipboardFormatOrUnicodeString(o);
    m = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved2 = o.read_shift(0, "lpwstr");
}
/*
	Continue logic for:
	- 2.4.58 Continue          0x003c
	- 2.4.59 ContinueBigName   0x043c
	- 2.4.60 ContinueFrt       0x0812
	- 2.4.61 ContinueFrt11     0x0875
	- 2.4.62 ContinueFrt12     0x087f
*/ var $7c3b72a365cc0275$var$CONTINUE_RT = [
    0x003c,
    0x043c,
    0x0812,
    0x0875,
    0x087f
];
function $7c3b72a365cc0275$var$slurp(RecordType, R, blob, length /*:number*/ , opts) /*:any*/ {
    var l = length;
    var bufs = [];
    var d = blob.slice(blob.l, blob.l + l);
    if (opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType){
        case 0x0009:
        case 0x0209:
        case 0x0409:
        case 0x0809 /* BOF */ :
        case 0x002f /* FilePass */ :
        case 0x0195 /* FileLock */ :
        case 0x00e1 /* InterfaceHdr */ :
        case 0x0196 /* RRDInfo */ :
        case 0x0138 /* RRDHead */ :
        case 0x0194 /* UsrExcl */ :
        case 0x000a /* EOF */ :
            break;
        case 0x0085 /* BoundSheet8 */ :
            break;
        default:
            opts.enc.insitu(d);
    }
    bufs.push(d);
    blob.l += l;
    var nextrt = $7c3b72a365cc0275$var$__readUInt16LE(blob, blob.l), next = $7c3b72a365cc0275$var$XLSRecordEnum[nextrt];
    var start = 0;
    while(next != null && $7c3b72a365cc0275$var$CONTINUE_RT.indexOf(nextrt) > -1){
        l = $7c3b72a365cc0275$var$__readUInt16LE(blob, blob.l + 2);
        start = blob.l + 4;
        if (nextrt == 0x0812 /* ContinueFrt */ ) start += 4;
        else if (nextrt == 0x0875 || nextrt == 0x087f) start += 12;
        d = blob.slice(start, blob.l + 4 + l);
        bufs.push(d);
        blob.l += 4 + l;
        next = $7c3b72a365cc0275$var$XLSRecordEnum[nextrt = $7c3b72a365cc0275$var$__readUInt16LE(blob, blob.l)];
    }
    var b = $7c3b72a365cc0275$var$bconcat(bufs);
    $7c3b72a365cc0275$var$prep_blob(b, 0);
    var ll = 0;
    b.lens = [];
    for(var j = 0; j < bufs.length; ++j){
        b.lens.push(ll);
        ll += bufs[j].length;
    }
    if (b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
    return R.f(b, b.length, opts);
}
function $7c3b72a365cc0275$var$safe_format_xf(p /*:any*/ , opts /*:ParseOpts*/ , date1904 /*:?boolean*/ ) {
    if (p.t === 'z') return;
    if (!p.XF) return;
    var fmtid = 0;
    try {
        fmtid = p.z || p.XF.numFmtId || 0;
        if (opts.cellNF) p.z = $7c3b72a365cc0275$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts || opts.cellText !== false) try {
        if (p.t === 'e') p.w = p.w || $7c3b72a365cc0275$var$BErr[p.v];
        else if (fmtid === 0 || fmtid == "General") {
            if (p.t === 'n') {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $7c3b72a365cc0275$var$SSF_general_num(p.v);
            } else p.w = $7c3b72a365cc0275$var$SSF_general(p.v);
        } else p.w = $7c3b72a365cc0275$var$SSF_format(fmtid, p.v, {
            date1904: !!date1904,
            dateNF: opts && opts.dateNF
        });
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (opts.cellDates && fmtid && p.t == 'n' && $7c3b72a365cc0275$var$fmt_is_date($7c3b72a365cc0275$var$table_fmt[fmtid] || String(fmtid))) {
        var _d = $7c3b72a365cc0275$var$SSF_parse_date_code(p.v);
        if (_d) {
            p.t = 'd';
            p.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
        }
    }
}
function $7c3b72a365cc0275$var$make_cell(val, ixfe, t) /*:Cell*/ {
    return {
        v: val,
        ixfe: ixfe,
        t: t
    } /*:any*/ ;
}
// 2.3.2
function $7c3b72a365cc0275$var$parse_workbook(blob, options /*:ParseOpts*/ ) /*:Workbook*/ {
    var wb = {
        opts: {}
    } /*:any*/ ;
    var Sheets = {};
    if ($7c3b72a365cc0275$var$DENSE != null && options.dense == null) options.dense = $7c3b72a365cc0275$var$DENSE;
    var out /*:Worksheet*/  = options.dense ? [] : {};
    var Directory = {};
    var range /*:Range*/  = {} /*:any*/ ;
    var last_formula = null;
    var sst /*:SST*/  = [];
    var cur_sheet = "";
    var Preamble = {};
    var lastcell, last_cell = "", cc /*:Cell*/ , cmnt, rngC, rngR;
    var sharedf = {};
    var arrayf /*:Array<[Range, string]>*/  = [];
    var temp_val /*:Cell*/ ;
    var country;
    var XFs = []; /* XF records */ 
    var palette /*:Array<[number, number, number]>*/  = [];
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        },
        Views: [
            {}
        ]
    } /*:any*/ , wsprops = {};
    var get_rgb = function getrgb(icv /*:number*/ ) /*:[number, number, number]*/ {
        if (icv < 8) return $7c3b72a365cc0275$var$XLSIcv[icv];
        if (icv < 64) return palette[icv - 8] || $7c3b72a365cc0275$var$XLSIcv[icv];
        return $7c3b72a365cc0275$var$XLSIcv[icv];
    };
    var process_cell_style = function pcs(cell, line /*:any*/ , options) {
        var xfd = line.XF.data;
        if (!xfd || !xfd.patternType || !options || !options.cellStyles) return;
        line.s = {} /*:any*/ ;
        line.s.patternType = xfd.patternType;
        var t;
        if (t = $7c3b72a365cc0275$var$rgb2Hex(get_rgb(xfd.icvFore))) line.s.fgColor = {
            rgb: t
        };
        if (t = $7c3b72a365cc0275$var$rgb2Hex(get_rgb(xfd.icvBack))) line.s.bgColor = {
            rgb: t
        };
    };
    var addcell = function addcell(cell /*:any*/ , line /*:any*/ , options /*:any*/ ) {
        if (file_depth > 1) return;
        if (options.sheetRows && cell.r >= options.sheetRows) return;
        if (options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
        delete line.ixfe;
        delete line.XF;
        lastcell = cell;
        last_cell = $7c3b72a365cc0275$var$encode_cell(cell);
        if (!range || !range.s || !range.e) range = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        if (cell.r < range.s.r) range.s.r = cell.r;
        if (cell.c < range.s.c) range.s.c = cell.c;
        if (cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
        if (cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
        if (options.cellFormula && line.f) for(var afi = 0; afi < arrayf.length; ++afi){
            if (arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
            if (arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
            line.F = $7c3b72a365cc0275$var$encode_range(arrayf[afi][0]);
            if (arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
            if (line.f) line.f = "" + $7c3b72a365cc0275$var$stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
            break;
        }
        if (options.dense) {
            if (!out[cell.r]) out[cell.r] = [];
            out[cell.r][cell.c] = line;
        } else out[last_cell] = line;
    };
    var opts = {
        enc: false,
        sbcch: 0,
        snames: [],
        sharedf: sharedf,
        arrayf: arrayf,
        rrtabid: [],
        lastuser: "",
        biff: 8,
        codepage: 0,
        winlocked: 0,
        cellStyles: !!options && !!options.cellStyles,
        WTF: !!options && !!options.wtf
    } /*:any*/ ;
    if (options.password) opts.password = options.password;
    var themes;
    var merges /*:Array<Range>*/  = [];
    var objects = [];
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    var supbooks = []; // 1-indexed, will hold extern names
    supbooks.SheetNames = opts.snames;
    supbooks.sharedf = opts.sharedf;
    supbooks.arrayf = opts.arrayf;
    supbooks.names = [];
    supbooks.XTI = [];
    var last_RT = 0;
    var file_depth = 0; /* TODO: make a real stack */ 
    var BIFF2Fmt = 0, BIFF2FmtTable /*:Array<string>*/  = [];
    var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */ 
    var last_lbl /*:?DefinedName*/ ;
    /* explicit override for some broken writers */ opts.codepage = 1200;
    $7c3b72a365cc0275$var$set_cp(1200);
    var seen_codepage = false;
    while(blob.l < blob.length - 1){
        var s = blob.l;
        var RecordType = blob.read_shift(2);
        if (RecordType === 0 && last_RT === 0x000a /* EOF */ ) break;
        var length = blob.l === blob.length ? 0 : blob.read_shift(2);
        var R = $7c3b72a365cc0275$var$XLSRecordEnum[RecordType];
        //console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
        //if(!R) console.log(blob.slice(blob.l, blob.l + length));
        if (R && R.f) {
            if (options.bookSheets) {
                if (last_RT === 0x0085 /* BoundSheet8 */  && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */ ) break;
            }
            last_RT = RecordType;
            if (R.r === 2 || R.r == 12) {
                var rt = blob.read_shift(2);
                length -= 2;
                if (!opts.enc && rt !== RecordType && ((rt & 0xFF) << 8 | rt >> 8) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
                if (R.r == 12) {
                    blob.l += 10;
                    length -= 10;
                } // skip FRT
            }
            //console.error(R,blob.l,length,blob.length);
            var val /*:any*/  = {} /*:any*/ ;
            if (RecordType === 0x000a /* EOF */ ) val = /*::(*/ R.f(blob, length, opts) /*:: :any)*/ ;
            else val = /*::(*/ $7c3b72a365cc0275$var$slurp(RecordType, R, blob, length, opts) /*:: :any)*/ ;
            /*:: val = (val:any); */ if (file_depth == 0 && [
                0x0009,
                0x0209,
                0x0409,
                0x0809
            ].indexOf(last_RT) === -1 /* 'BOF' */ ) continue;
            switch(RecordType){
                case 0x0022 /* Date1904 */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ wb.opts.Date1904 = Workbook.WBProps.date1904 = val;
                    break;
                case 0x0086 /* WriteProtect */ :
                    wb.opts.WriteProtect = true;
                    break;
                case 0x002f /* FilePass */ :
                    if (!opts.enc) blob.l = 0;
                    opts.enc = val;
                    if (!options.password) throw new Error("File is password-protected");
                    if (val.valid == null) throw new Error("Encryption scheme unsupported");
                    if (!val.valid) throw new Error("Password is incorrect");
                    break;
                case 0x005c /* WriteAccess */ :
                    opts.lastuser = val;
                    break;
                case 0x0042 /* CodePage */ :
                    var cpval = Number(val);
                    /* overrides based on test cases */ switch(cpval){
                        case 0x5212:
                            cpval = 1200;
                            break;
                        case 0x8000:
                            cpval = 10000;
                            break;
                        case 0x8001:
                            cpval = 1252;
                            break;
                    }
                    $7c3b72a365cc0275$var$set_cp(opts.codepage = cpval);
                    seen_codepage = true;
                    break;
                case 0x013d /* RRTabId */ :
                    opts.rrtabid = val;
                    break;
                case 0x0019 /* WinProtect */ :
                    opts.winlocked = val;
                    break;
                case 0x01b7 /* RefreshAll */ :
                    wb.opts["RefreshAll"] = val;
                    break;
                case 0x000c /* CalcCount */ :
                    wb.opts["CalcCount"] = val;
                    break;
                case 0x0010 /* CalcDelta */ :
                    wb.opts["CalcDelta"] = val;
                    break;
                case 0x0011 /* CalcIter */ :
                    wb.opts["CalcIter"] = val;
                    break;
                case 0x000d /* CalcMode */ :
                    wb.opts["CalcMode"] = val;
                    break;
                case 0x000e /* CalcPrecision */ :
                    wb.opts["CalcPrecision"] = val;
                    break;
                case 0x005f /* CalcSaveRecalc */ :
                    wb.opts["CalcSaveRecalc"] = val;
                    break;
                case 0x000f /* CalcRefMode */ :
                    opts.CalcRefMode = val;
                    break; // TODO: implement R1C1
                case 0x08a3 /* ForceFullCalculation */ :
                    wb.opts.FullCalc = val;
                    break;
                case 0x0081 /* WsBool */ :
                    if (val.fDialog) out["!type"] = "dialog";
                    if (!val.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
                    if (!val.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
                    break; // TODO
                case 0x00e0 /* XF */ :
                    XFs.push(val);
                    break;
                case 0x01ae /* SupBook */ :
                    supbooks.push([
                        val
                    ]);
                    supbooks[supbooks.length - 1].XTI = [];
                    break;
                case 0x0023:
                case 0x0223 /* ExternName */ :
                    supbooks[supbooks.length - 1].push(val);
                    break;
                case 0x0018:
                case 0x0218 /* Lbl */ :
                    last_lbl = {
                        Name: val.Name,
                        Ref: $7c3b72a365cc0275$var$stringify_formula(val.rgce, range, null, supbooks, opts)
                    } /*:DefinedName*/ ;
                    if (val.itab > 0) last_lbl.Sheet = val.itab - 1;
                    supbooks.names.push(last_lbl);
                    if (!supbooks[0]) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].push(val);
                    if (val.Name == "_xlnm._FilterDatabase" && val.itab > 0) {
                        if (val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == 'PtgArea3d') FilterDatabases[val.itab - 1] = {
                            ref: $7c3b72a365cc0275$var$encode_range(val.rgce[0][0][1][2])
                        };
                    }
                    break;
                case 0x0016 /* ExternCount */ :
                    opts.ExternCount = val;
                    break;
                case 0x0017 /* ExternSheet */ :
                    if (supbooks.length == 0) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
                    supbooks.XTI = supbooks.XTI.concat(val);
                    break;
                case 0x0894 /* NameCmt */ :
                    /* TODO: search for correct name */ if (opts.biff < 8) break;
                    if (last_lbl != null) last_lbl.Comment = val[1];
                    break;
                case 0x0012 /* Protect */ :
                    out["!protect"] = val;
                    break; /* for sheet or book */ 
                case 0x0013 /* Password */ :
                    if (val !== 0 && opts.WTF) console.error("Password verifier: " + val);
                    break;
                case 0x0085 /* BoundSheet8 */ :
                    Directory[val.pos] = val;
                    opts.snames.push(val.name);
                    break;
                case 0x000a /* EOF */ :
                    if (--file_depth) break;
                    if (range.e) {
                        if (range.e.r > 0 && range.e.c > 0) {
                            range.e.r--;
                            range.e.c--;
                            out["!ref"] = $7c3b72a365cc0275$var$encode_range(range);
                            if (options.sheetRows && options.sheetRows <= range.e.r) {
                                var tmpri = range.e.r;
                                range.e.r = options.sheetRows - 1;
                                out["!fullref"] = out["!ref"];
                                out["!ref"] = $7c3b72a365cc0275$var$encode_range(range);
                                range.e.r = tmpri;
                            }
                            range.e.r++;
                            range.e.c++;
                        }
                        if (merges.length > 0) out["!merges"] = merges;
                        if (objects.length > 0) out["!objects"] = objects;
                        if (colinfo.length > 0) out["!cols"] = colinfo;
                        if (rowinfo.length > 0) out["!rows"] = rowinfo;
                        Workbook.Sheets.push(wsprops);
                    }
                    if (cur_sheet === "") Preamble = out;
                    else Sheets[cur_sheet] = out;
                    out = options.dense ? [] : {};
                    break;
                case 0x0009:
                case 0x0209:
                case 0x0409:
                case 0x0809 /* BOF */ :
                    if (opts.biff === 8) opts.biff = ({
                        /*::[*/ 0x0009: 2,
                        /*::[*/ 0x0209: 3,
                        /*::[*/ 0x0409: 4
                    })[RecordType] || ({
                        /*::[*/ 0x0200: 2,
                        /*::[*/ 0x0300: 3,
                        /*::[*/ 0x0400: 4,
                        /*::[*/ 0x0500: 5,
                        /*::[*/ 0x0600: 8,
                        /*::[*/ 0x0002: 2,
                        /*::[*/ 0x0007: 2
                    })[val.BIFFVer] || 8;
                    opts.biffguess = val.BIFFVer == 0;
                    if (val.BIFFVer == 0 && val.dt == 0x1000) {
                        opts.biff = 5;
                        seen_codepage = true;
                        $7c3b72a365cc0275$var$set_cp(opts.codepage = 28591);
                    }
                    if (opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
                    if (file_depth++) break;
                    out = options.dense ? [] : {};
                    if (opts.biff < 8 && !seen_codepage) {
                        seen_codepage = true;
                        $7c3b72a365cc0275$var$set_cp(opts.codepage = options.codepage || 1252);
                    }
                    if (opts.biff < 5 || val.BIFFVer == 0 && val.dt == 0x1000) {
                        if (cur_sheet === "") cur_sheet = "Sheet1";
                        range = {
                            s: {
                                r: 0,
                                c: 0
                            },
                            e: {
                                r: 0,
                                c: 0
                            }
                        };
                        /* fake BoundSheet8 */ var fakebs8 = {
                            pos: blob.l - length,
                            name: cur_sheet
                        };
                        Directory[fakebs8.pos] = fakebs8;
                        opts.snames.push(cur_sheet);
                    } else cur_sheet = (Directory[s] || {
                        name: ""
                    }).name;
                    if (val.dt == 0x20) out["!type"] = "chart";
                    if (val.dt == 0x40) out["!type"] = "macro";
                    merges = [];
                    objects = [];
                    opts.arrayf = arrayf = [];
                    colinfo = [];
                    rowinfo = [];
                    seencol = false;
                    wsprops = {
                        Hidden: (Directory[s] || {
                            hs: 0
                        }).hs,
                        name: cur_sheet
                    };
                    break;
                case 0x0203 /* Number */ :
                case 0x0003 /* BIFF2NUM */ :
                case 0x0002 /* BIFF2INT */ :
                    if (out["!type"] == "chart") {
                        if (options.dense ? (out[val.r] || [])[val.c] : out[$7c3b72a365cc0275$var$encode_cell({
                            c: val.c,
                            r: val.r
                        })]) ++val.c;
                    }
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe] || {},
                        v: val.val,
                        t: 'n'
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $7c3b72a365cc0275$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0005:
                case 0x0205 /* BoolErr */ :
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe],
                        v: val.val,
                        t: val.t
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $7c3b72a365cc0275$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x027e /* RK */ :
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe],
                        v: val.rknum,
                        t: 'n'
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $7c3b72a365cc0275$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x00bd /* MulRk */ :
                    for(var j = val.c; j <= val.C; ++j){
                        var ixfe = val.rkrec[j - val.c][0];
                        temp_val = {
                            ixfe: ixfe,
                            XF: XFs[ixfe],
                            v: val.rkrec[j - val.c][1],
                            t: 'n'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $7c3b72a365cc0275$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: j,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x0006:
                case 0x0206:
                case 0x0406 /* Formula */ :
                    if (val.val == 'String') {
                        last_formula = val;
                        break;
                    }
                    temp_val = $7c3b72a365cc0275$var$make_cell(val.val, val.cell.ixfe, val.tt);
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (options.cellFormula) {
                        var _f = val.formula;
                        if (_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
                            var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
                            var _fe = $7c3b72a365cc0275$var$encode_cell({
                                r: _fr,
                                c: _fc
                            });
                            if (sharedf[_fe]) temp_val.f = "" + $7c3b72a365cc0275$var$stringify_formula(val.formula, range, val.cell, supbooks, opts);
                            else temp_val.F = ((options.dense ? (out[_fr] || [])[_fc] : out[_fe]) || {}).F;
                        } else temp_val.f = "" + $7c3b72a365cc0275$var$stringify_formula(val.formula, range, val.cell, supbooks, opts);
                    }
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $7c3b72a365cc0275$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell(val.cell, temp_val, options);
                    last_formula = val;
                    break;
                case 0x0007:
                case 0x0207 /* String */ :
                    if (last_formula) {
                        last_formula.val = val;
                        temp_val = $7c3b72a365cc0275$var$make_cell(val, last_formula.cell.ixfe, 's');
                        temp_val.XF = XFs[temp_val.ixfe];
                        if (options.cellFormula) temp_val.f = "" + $7c3b72a365cc0275$var$stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $7c3b72a365cc0275$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell(last_formula.cell, temp_val, options);
                        last_formula = null;
                    } else throw new Error("String record expects Formula");
                    break;
                case 0x0021:
                case 0x0221 /* Array */ :
                    arrayf.push(val);
                    var _arraystart = $7c3b72a365cc0275$var$encode_cell(val[0].s);
                    cc = options.dense ? (out[val[0].s.r] || [])[val[0].s.c] : out[_arraystart];
                    if (options.cellFormula && cc) {
                        if (!last_formula) break; /* technically unreachable */ 
                        if (!_arraystart || !cc) break;
                        cc.f = "" + $7c3b72a365cc0275$var$stringify_formula(val[1], range, val[0], supbooks, opts);
                        cc.F = $7c3b72a365cc0275$var$encode_range(val[0]);
                    }
                    break;
                case 0x04bc /* ShrFmla */ :
                    if (!options.cellFormula) break;
                    if (last_cell) {
                        /* TODO: capture range */ if (!last_formula) break; /* technically unreachable */ 
                        sharedf[$7c3b72a365cc0275$var$encode_cell(last_formula.cell)] = val[0];
                        cc = options.dense ? (out[last_formula.cell.r] || [])[last_formula.cell.c] : out[$7c3b72a365cc0275$var$encode_cell(last_formula.cell)];
                        (cc || {}).f = "" + $7c3b72a365cc0275$var$stringify_formula(val[0], range, lastcell, supbooks, opts);
                    }
                    break;
                case 0x00fd /* LabelSst */ :
                    temp_val = $7c3b72a365cc0275$var$make_cell(sst[val.isst].t, val.ixfe, 's');
                    if (sst[val.isst].h) temp_val.h = sst[val.isst].h;
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $7c3b72a365cc0275$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0201 /* Blank */ :
                    if (options.sheetStubs) {
                        temp_val = {
                            ixfe: val.ixfe,
                            XF: XFs[val.ixfe],
                            t: 'z'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $7c3b72a365cc0275$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val.c,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00be /* MulBlank */ :
                    if (options.sheetStubs) for(var _j = val.c; _j <= val.C; ++_j){
                        var _ixfe = val.ixfe[_j - val.c];
                        temp_val = {
                            ixfe: _ixfe,
                            XF: XFs[_ixfe],
                            t: 'z'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $7c3b72a365cc0275$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: _j,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00d6 /* RString */ :
                case 0x0204 /* Label */ :
                case 0x0004 /* BIFF2STR */ :
                    temp_val = $7c3b72a365cc0275$var$make_cell(val.val, val.ixfe, 's');
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $7c3b72a365cc0275$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0000:
                case 0x0200 /* Dimensions */ :
                    if (file_depth === 1) range = val; /* TODO: stack */ 
                    break;
                case 0x00fc /* SST */ :
                    sst = val;
                    break;
                case 0x041e /* Format */ :
                    if (opts.biff == 4) {
                        BIFF2FmtTable[BIFF2Fmt++] = val[1];
                        for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx)if ($7c3b72a365cc0275$var$table_fmt[b4idx] == val[1]) break;
                        if (b4idx >= 163) $7c3b72a365cc0275$var$SSF_load(val[1], BIFF2Fmt + 163);
                    } else $7c3b72a365cc0275$var$SSF_load(val[1], val[0]);
                    break;
                case 0x001e /* BIFF2FORMAT */ :
                    BIFF2FmtTable[BIFF2Fmt++] = val;
                    for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx)if ($7c3b72a365cc0275$var$table_fmt[b2idx] == val) break;
                    if (b2idx >= 163) $7c3b72a365cc0275$var$SSF_load(val, BIFF2Fmt + 163);
                    break;
                case 0x00e5 /* MergeCells */ :
                    merges = merges.concat(val);
                    break;
                case 0x005d /* Obj */ :
                    objects[val.cmo[0]] = opts.lastobj = val;
                    break;
                case 0x01b6 /* TxO */ :
                    opts.lastobj.TxO = val;
                    break;
                case 0x007f /* ImData */ :
                    opts.lastobj.ImData = val;
                    break;
                case 0x01b8 /* HLink */ :
                    for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC){
                        cc = options.dense ? (out[rngR] || [])[rngC] : out[$7c3b72a365cc0275$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc) cc.l = val[1];
                    }
                    break;
                case 0x0800 /* HLinkTooltip */ :
                    for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC){
                        cc = options.dense ? (out[rngR] || [])[rngC] : out[$7c3b72a365cc0275$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc && cc.l) cc.l.Tooltip = val[1];
                    }
                    break;
                case 0x001c /* Note */ :
                    if (opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */ 
                    cc = options.dense ? (out[val[0].r] || [])[val[0].c] : out[$7c3b72a365cc0275$var$encode_cell(val[0])];
                    var noteobj = objects[val[2]];
                    if (!cc) {
                        if (options.dense) {
                            if (!out[val[0].r]) out[val[0].r] = [];
                            cc = out[val[0].r][val[0].c] = {
                                t: "z"
                            } /*:any*/ ;
                        } else cc = out[$7c3b72a365cc0275$var$encode_cell(val[0])] = {
                            t: "z"
                        } /*:any*/ ;
                        range.e.r = Math.max(range.e.r, val[0].r);
                        range.s.r = Math.min(range.s.r, val[0].r);
                        range.e.c = Math.max(range.e.c, val[0].c);
                        range.s.c = Math.min(range.s.c, val[0].c);
                    }
                    if (!cc.c) cc.c = [];
                    cmnt = {
                        a: val[1],
                        t: noteobj.TxO.t
                    };
                    cc.c.push(cmnt);
                    break;
                case 0x087d /* XFExt */ :
                    $7c3b72a365cc0275$var$update_xfext(XFs[val.ixfe], val.ext);
                    break;
                case 0x007d /* ColInfo */ :
                    if (!opts.cellStyles) break;
                    while(val.e >= val.s){
                        colinfo[val.e--] = {
                            width: val.w / 256,
                            level: val.level || 0,
                            hidden: !!(val.flags & 1)
                        };
                        if (!seencol) {
                            seencol = true;
                            $7c3b72a365cc0275$var$find_mdw_colw(val.w / 256);
                        }
                        $7c3b72a365cc0275$var$process_col(colinfo[val.e + 1]);
                    }
                    break;
                case 0x0208 /* Row */ :
                    var rowobj = {};
                    if (val.level != null) {
                        rowinfo[val.r] = rowobj;
                        rowobj.level = val.level;
                    }
                    if (val.hidden) {
                        rowinfo[val.r] = rowobj;
                        rowobj.hidden = true;
                    }
                    if (val.hpt) {
                        rowinfo[val.r] = rowobj;
                        rowobj.hpt = val.hpt;
                        rowobj.hpx = $7c3b72a365cc0275$var$pt2px(val.hpt);
                    }
                    break;
                case 0x0026 /* LeftMargin */ :
                case 0x0027 /* RightMargin */ :
                case 0x0028 /* TopMargin */ :
                case 0x0029 /* BottomMargin */ :
                    if (!out['!margins']) $7c3b72a365cc0275$var$default_margins(out['!margins'] = {});
                    out['!margins'][({
                        0x26: "left",
                        0x27: "right",
                        0x28: "top",
                        0x29: "bottom"
                    })[RecordType]] = val;
                    break;
                case 0x00a1 /* Setup */ :
                    if (!out['!margins']) $7c3b72a365cc0275$var$default_margins(out['!margins'] = {});
                    out['!margins'].header = val.header;
                    out['!margins'].footer = val.footer;
                    break;
                case 0x023e /* Window2 */ :
                    // $FlowIgnore
                    if (val.RTL) Workbook.Views[0].RTL = true;
                    break;
                case 0x0092 /* Palette */ :
                    palette = val;
                    break;
                case 0x0896 /* Theme */ :
                    themes = val;
                    break;
                case 0x008c /* Country */ :
                    country = val;
                    break;
                case 0x01ba /* CodeName */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ if (!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
                    else wsprops.CodeName = val || wsprops.name;
                    break;
            }
        } else {
            if (!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
            blob.l += length;
        }
    }
    wb.SheetNames = $7c3b72a365cc0275$var$keys(Directory).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(x) {
        return Directory[x].name;
    });
    if (!options.bookSheets) wb.Sheets = Sheets;
    if (!wb.SheetNames.length && Preamble["!ref"]) {
        wb.SheetNames.push("Sheet1");
        /*jshint -W069 */ if (wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
    /*jshint +W069 */ } else wb.Preamble = Preamble;
    if (wb.Sheets) FilterDatabases.forEach(function(r, i) {
        wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r;
    });
    wb.Strings = sst;
    wb.SSF = $7c3b72a365cc0275$var$dup($7c3b72a365cc0275$var$table_fmt);
    if (opts.enc) wb.Encryption = opts.enc;
    if (themes) wb.Themes = themes;
    wb.Metadata = {};
    if (country !== undefined) wb.Metadata.Country = country;
    if (supbooks.names.length > 0) Workbook.Names = supbooks.names;
    wb.Workbook = Workbook;
    return wb;
}
/* TODO: split props*/ var $7c3b72a365cc0275$var$PSCLSID = {
    SI: "e0859ff2f94f6810ab9108002b27b3d9",
    DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
    UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function $7c3b72a365cc0275$var$parse_xls_props(cfb /*:CFBContainer*/ , props, o) {
    /* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */ var DSI = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, '/!DocumentSummaryInformation');
    if (DSI && DSI.size > 0) try {
        var DocSummary = $7c3b72a365cc0275$var$parse_PropertySetStream(DSI, $7c3b72a365cc0275$var$DocSummaryPIDDSI, $7c3b72a365cc0275$var$PSCLSID.DSI);
        for(var d in DocSummary)props[d] = DocSummary[d];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    /* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/ var SI = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, '/!SummaryInformation');
    if (SI && SI.size > 0) try {
        var Summary = $7c3b72a365cc0275$var$parse_PropertySetStream(SI, $7c3b72a365cc0275$var$SummaryPIDSI, $7c3b72a365cc0275$var$PSCLSID.SI);
        for(var s in Summary)if (props[s] == null) props[s] = Summary[s];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    if (props.HeadingPairs && props.TitlesOfParts) {
        $7c3b72a365cc0275$var$load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
        delete props.HeadingPairs;
        delete props.TitlesOfParts;
    }
}
function $7c3b72a365cc0275$var$write_xls_props(wb /*:Workbook*/ , cfb /*:CFBContainer*/ ) {
    var DSEntries = [], SEntries = [], CEntries = [];
    var i = 0, Keys;
    var DocSummaryRE /*:{[key:string]:string}*/  = $7c3b72a365cc0275$var$evert_key($7c3b72a365cc0275$var$DocSummaryPIDDSI, "n");
    var SummaryRE /*:{[key:string]:string}*/  = $7c3b72a365cc0275$var$evert_key($7c3b72a365cc0275$var$SummaryPIDSI, "n");
    if (wb.Props) {
        Keys = $7c3b72a365cc0275$var$keys(wb.Props);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)(Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Props[Keys[i]]
        ]);
    }
    if (wb.Custprops) {
        Keys = $7c3b72a365cc0275$var$keys(wb.Custprops);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)if (!Object.prototype.hasOwnProperty.call(wb.Props || {}, Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Custprops[Keys[i]]
        ]);
    }
    var CEntries2 = [];
    for(i = 0; i < CEntries.length; ++i){
        if ($7c3b72a365cc0275$var$XLSPSSkip.indexOf(CEntries[i][0]) > -1 || $7c3b72a365cc0275$var$PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
        if (CEntries[i][1] == null) continue;
        CEntries2.push(CEntries[i]);
    }
    if (SEntries.length) $7c3b72a365cc0275$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\u0005SummaryInformation", $7c3b72a365cc0275$var$write_PropertySetStream(SEntries, $7c3b72a365cc0275$var$PSCLSID.SI, SummaryRE, $7c3b72a365cc0275$var$SummaryPIDSI));
    if (DSEntries.length || CEntries2.length) $7c3b72a365cc0275$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", $7c3b72a365cc0275$var$write_PropertySetStream(DSEntries, $7c3b72a365cc0275$var$PSCLSID.DSI, DocSummaryRE, $7c3b72a365cc0275$var$DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, $7c3b72a365cc0275$var$PSCLSID.UDI));
}
function $7c3b72a365cc0275$export$b41972a043aba84c(cfb /*:any*/ , options /*:?ParseOpts*/ ) /*:Workbook*/ {
    if (!options) options = {};
    $7c3b72a365cc0275$var$fix_read_opts(options);
    $7c3b72a365cc0275$var$reset_cp();
    if (options.codepage) $7c3b72a365cc0275$var$set_ansi(options.codepage);
    var CompObj /*:?CFBEntry*/ , WB /*:?any*/ ;
    if (cfb.FullPaths) {
        if ($7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, '/encryption')) throw new Error("File is password-protected");
        CompObj = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, '!CompObj');
        WB = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, '/Workbook') || $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, '/Book');
    } else {
        switch(options.type){
            case 'base64':
                cfb = $7c3b72a365cc0275$var$s2a($7c3b72a365cc0275$var$Base64_decode(cfb));
                break;
            case 'binary':
                cfb = $7c3b72a365cc0275$var$s2a(cfb);
                break;
            case 'buffer':
                break;
            case 'array':
                if (!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb);
                break;
        }
        $7c3b72a365cc0275$var$prep_blob(cfb, 0);
        WB = {
            content: cfb
        } /*:any*/ ;
    }
    var /*::CompObjP, */ WorkbookP /*:: :Workbook = XLSX.utils.book_new(); */ ;
    var _data /*:?any*/ ;
    if (CompObj) /*::CompObjP = */ $7c3b72a365cc0275$var$parse_compobj(CompObj);
    if (options.bookProps && !options.bookSheets) WorkbookP = {} /*:any*/ ;
    else /*:: if(cfb instanceof CFBContainer) */ {
        var T = $7c3b72a365cc0275$var$has_buf ? 'buffer' : 'array';
        if (WB && WB.content) WorkbookP = $7c3b72a365cc0275$var$parse_workbook(WB.content, options);
        else if ((_data = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = $7c3b72a365cc0275$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = $7c3b72a365cc0275$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, 'MN0')) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
        else throw new Error("Cannot find Workbook stream");
        if (options.bookVBA && cfb.FullPaths && $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = $7c3b72a365cc0275$var$make_vba_xls(cfb);
    }
    var props = {};
    if (cfb.FullPaths) $7c3b72a365cc0275$var$parse_xls_props(/*::((*/ cfb /*:: :any):CFBContainer)*/ , props, options);
    WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */ 
    if (options.bookFiles) WorkbookP.cfb = cfb;
    /*WorkbookP.CompObjP = CompObjP; // TODO: storage? */ return WorkbookP;
}
function $7c3b72a365cc0275$var$write_xlscfb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:CFBContainer*/ {
    var o = opts || {};
    var cfb = $7c3b72a365cc0275$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    var wbpath = "/Workbook";
    switch(o.bookType || "xls"){
        case "xls":
            o.bookType = "biff8";
        /* falls through */ case "xla":
            if (!o.bookType) o.bookType = "xla";
        /* falls through */ case "biff8":
            wbpath = "/Workbook";
            o.biff = 8;
            break;
        case "biff5":
            wbpath = "/Book";
            o.biff = 5;
            break;
        default:
            throw new Error("invalid type " + o.bookType + " for XLS CFB");
    }
    $7c3b72a365cc0275$export$9f0e51cd97c572a.utils.cfb_add(cfb, wbpath, $7c3b72a365cc0275$var$write_biff_buf(wb, o));
    if (o.biff == 8 && (wb.Props || wb.Custprops)) $7c3b72a365cc0275$var$write_xls_props(wb, cfb);
    // TODO: SI, DSI, CO
    if (o.biff == 8 && wb.vbaraw) $7c3b72a365cc0275$var$fill_vba_xls(cfb, $7c3b72a365cc0275$export$9f0e51cd97c572a.read(wb.vbaraw, {
        type: typeof wb.vbaraw == "string" ? "binary" : "buffer"
    }));
    return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */ var $7c3b72a365cc0275$var$XLSBRecordEnum = {
    /*::[*/ 0x0000: {
        f: $7c3b72a365cc0275$var$parse_BrtRowHdr
    },
    /*::[*/ 0x0001: {
        f: $7c3b72a365cc0275$var$parse_BrtCellBlank
    },
    /*::[*/ 0x0002: {
        f: $7c3b72a365cc0275$var$parse_BrtCellRk
    },
    /*::[*/ 0x0003: {
        f: $7c3b72a365cc0275$var$parse_BrtCellError
    },
    /*::[*/ 0x0004: {
        f: $7c3b72a365cc0275$var$parse_BrtCellBool
    },
    /*::[*/ 0x0005: {
        f: $7c3b72a365cc0275$var$parse_BrtCellReal
    },
    /*::[*/ 0x0006: {
        f: $7c3b72a365cc0275$var$parse_BrtCellSt
    },
    /*::[*/ 0x0007: {
        f: $7c3b72a365cc0275$var$parse_BrtCellIsst
    },
    /*::[*/ 0x0008: {
        f: $7c3b72a365cc0275$var$parse_BrtFmlaString
    },
    /*::[*/ 0x0009: {
        f: $7c3b72a365cc0275$var$parse_BrtFmlaNum
    },
    /*::[*/ 0x000A: {
        f: $7c3b72a365cc0275$var$parse_BrtFmlaBool
    },
    /*::[*/ 0x000B: {
        f: $7c3b72a365cc0275$var$parse_BrtFmlaError
    },
    /*::[*/ 0x000C: {
        f: $7c3b72a365cc0275$var$parse_BrtShortBlank
    },
    /*::[*/ 0x000D: {
        f: $7c3b72a365cc0275$var$parse_BrtShortRk
    },
    /*::[*/ 0x000E: {
        f: $7c3b72a365cc0275$var$parse_BrtShortError
    },
    /*::[*/ 0x000F: {
        f: $7c3b72a365cc0275$var$parse_BrtShortBool
    },
    /*::[*/ 0x0010: {
        f: $7c3b72a365cc0275$var$parse_BrtShortReal
    },
    /*::[*/ 0x0011: {
        f: $7c3b72a365cc0275$var$parse_BrtShortSt
    },
    /*::[*/ 0x0012: {
        f: $7c3b72a365cc0275$var$parse_BrtShortIsst
    },
    /*::[*/ 0x0013: {
        f: $7c3b72a365cc0275$var$parse_RichStr
    },
    /*::[*/ 0x0014: {},
    /*::[*/ 0x0015: {},
    /*::[*/ 0x0016: {},
    /*::[*/ 0x0017: {},
    /*::[*/ 0x0018: {},
    /*::[*/ 0x0019: {},
    /*::[*/ 0x001A: {},
    /*::[*/ 0x001B: {},
    /*::[*/ 0x001C: {},
    /*::[*/ 0x001D: {},
    /*::[*/ 0x001E: {},
    /*::[*/ 0x001F: {},
    /*::[*/ 0x0020: {},
    /*::[*/ 0x0021: {},
    /*::[*/ 0x0022: {},
    /*::[*/ 0x0023: {
        T: 1
    },
    /*::[*/ 0x0024: {
        T: -1
    },
    /*::[*/ 0x0025: {
        T: 1
    },
    /*::[*/ 0x0026: {
        T: -1
    },
    /*::[*/ 0x0027: {
        f: $7c3b72a365cc0275$var$parse_BrtName
    },
    /*::[*/ 0x0028: {},
    /*::[*/ 0x002A: {},
    /*::[*/ 0x002B: {
        f: $7c3b72a365cc0275$var$parse_BrtFont
    },
    /*::[*/ 0x002C: {
        f: $7c3b72a365cc0275$var$parse_BrtFmt
    },
    /*::[*/ 0x002D: {
        f: $7c3b72a365cc0275$var$parse_BrtFill
    },
    /*::[*/ 0x002E: {
        f: $7c3b72a365cc0275$var$parse_BrtBorder
    },
    /*::[*/ 0x002F: {
        f: $7c3b72a365cc0275$var$parse_BrtXF
    },
    /*::[*/ 0x0030: {},
    /*::[*/ 0x0031: {
        f: $7c3b72a365cc0275$var$parse_Int32LE
    },
    /*::[*/ 0x0032: {},
    /*::[*/ 0x0033: {
        f: $7c3b72a365cc0275$var$parse_BrtMdb
    },
    /*::[*/ 0x0034: {
        T: 1
    },
    /*::[*/ 0x0035: {
        T: -1
    },
    /*::[*/ 0x0036: {
        T: 1
    },
    /*::[*/ 0x0037: {
        T: -1
    },
    /*::[*/ 0x0038: {
        T: 1
    },
    /*::[*/ 0x0039: {
        T: -1
    },
    /*::[*/ 0x003A: {},
    /*::[*/ 0x003B: {},
    /*::[*/ 0x003C: {
        f: $7c3b72a365cc0275$var$parse_ColInfo
    },
    /*::[*/ 0x003E: {
        f: $7c3b72a365cc0275$var$parse_BrtCellRString
    },
    /*::[*/ 0x003F: {
        f: $7c3b72a365cc0275$var$parse_BrtCalcChainItem$
    },
    /*::[*/ 0x0040: {
        f: $7c3b72a365cc0275$var$parse_BrtDVal
    },
    /*::[*/ 0x0041: {},
    /*::[*/ 0x0042: {},
    /*::[*/ 0x0043: {},
    /*::[*/ 0x0044: {},
    /*::[*/ 0x0045: {},
    /*::[*/ 0x0046: {},
    /*::[*/ 0x0080: {},
    /*::[*/ 0x0081: {
        T: 1
    },
    /*::[*/ 0x0082: {
        T: -1
    },
    /*::[*/ 0x0083: {
        T: 1,
        f: $7c3b72a365cc0275$var$parsenoop,
        p: 0
    },
    /*::[*/ 0x0084: {
        T: -1
    },
    /*::[*/ 0x0085: {
        T: 1
    },
    /*::[*/ 0x0086: {
        T: -1
    },
    /*::[*/ 0x0087: {
        T: 1
    },
    /*::[*/ 0x0088: {
        T: -1
    },
    /*::[*/ 0x0089: {
        T: 1,
        f: $7c3b72a365cc0275$var$parse_BrtBeginWsView
    },
    /*::[*/ 0x008A: {
        T: -1
    },
    /*::[*/ 0x008B: {
        T: 1
    },
    /*::[*/ 0x008C: {
        T: -1
    },
    /*::[*/ 0x008D: {
        T: 1
    },
    /*::[*/ 0x008E: {
        T: -1
    },
    /*::[*/ 0x008F: {
        T: 1
    },
    /*::[*/ 0x0090: {
        T: -1
    },
    /*::[*/ 0x0091: {
        T: 1
    },
    /*::[*/ 0x0092: {
        T: -1
    },
    /*::[*/ 0x0093: {
        f: $7c3b72a365cc0275$var$parse_BrtWsProp
    },
    /*::[*/ 0x0094: {
        f: $7c3b72a365cc0275$var$parse_BrtWsDim,
        p: 16
    },
    /*::[*/ 0x0097: {
        f: $7c3b72a365cc0275$var$parse_BrtPane
    },
    /*::[*/ 0x0098: {},
    /*::[*/ 0x0099: {
        f: $7c3b72a365cc0275$var$parse_BrtWbProp
    },
    /*::[*/ 0x009A: {},
    /*::[*/ 0x009B: {},
    /*::[*/ 0x009C: {
        f: $7c3b72a365cc0275$var$parse_BrtBundleSh
    },
    /*::[*/ 0x009D: {},
    /*::[*/ 0x009E: {},
    /*::[*/ 0x009F: {
        T: 1,
        f: $7c3b72a365cc0275$var$parse_BrtBeginSst
    },
    /*::[*/ 0x00A0: {
        T: -1
    },
    /*::[*/ 0x00A1: {
        T: 1,
        f: $7c3b72a365cc0275$var$parse_UncheckedRfX
    },
    /*::[*/ 0x00A2: {
        T: -1
    },
    /*::[*/ 0x00A3: {
        T: 1
    },
    /*::[*/ 0x00A4: {
        T: -1
    },
    /*::[*/ 0x00A5: {
        T: 1
    },
    /*::[*/ 0x00A6: {
        T: -1
    },
    /*::[*/ 0x00A7: {},
    /*::[*/ 0x00A8: {},
    /*::[*/ 0x00A9: {},
    /*::[*/ 0x00AA: {},
    /*::[*/ 0x00AB: {},
    /*::[*/ 0x00AC: {
        T: 1
    },
    /*::[*/ 0x00AD: {
        T: -1
    },
    /*::[*/ 0x00AE: {},
    /*::[*/ 0x00AF: {},
    /*::[*/ 0x00B0: {
        f: $7c3b72a365cc0275$var$parse_BrtMergeCell
    },
    /*::[*/ 0x00B1: {
        T: 1
    },
    /*::[*/ 0x00B2: {
        T: -1
    },
    /*::[*/ 0x00B3: {
        T: 1
    },
    /*::[*/ 0x00B4: {
        T: -1
    },
    /*::[*/ 0x00B5: {
        T: 1
    },
    /*::[*/ 0x00B6: {
        T: -1
    },
    /*::[*/ 0x00B7: {
        T: 1
    },
    /*::[*/ 0x00B8: {
        T: -1
    },
    /*::[*/ 0x00B9: {
        T: 1
    },
    /*::[*/ 0x00BA: {
        T: -1
    },
    /*::[*/ 0x00BB: {
        T: 1
    },
    /*::[*/ 0x00BC: {
        T: -1
    },
    /*::[*/ 0x00BD: {
        T: 1
    },
    /*::[*/ 0x00BE: {
        T: -1
    },
    /*::[*/ 0x00BF: {
        T: 1
    },
    /*::[*/ 0x00C0: {
        T: -1
    },
    /*::[*/ 0x00C1: {
        T: 1
    },
    /*::[*/ 0x00C2: {
        T: -1
    },
    /*::[*/ 0x00C3: {
        T: 1
    },
    /*::[*/ 0x00C4: {
        T: -1
    },
    /*::[*/ 0x00C5: {
        T: 1
    },
    /*::[*/ 0x00C6: {
        T: -1
    },
    /*::[*/ 0x00C7: {
        T: 1
    },
    /*::[*/ 0x00C8: {
        T: -1
    },
    /*::[*/ 0x00C9: {
        T: 1
    },
    /*::[*/ 0x00CA: {
        T: -1
    },
    /*::[*/ 0x00CB: {
        T: 1
    },
    /*::[*/ 0x00CC: {
        T: -1
    },
    /*::[*/ 0x00CD: {
        T: 1
    },
    /*::[*/ 0x00CE: {
        T: -1
    },
    /*::[*/ 0x00CF: {
        T: 1
    },
    /*::[*/ 0x00D0: {
        T: -1
    },
    /*::[*/ 0x00D1: {
        T: 1
    },
    /*::[*/ 0x00D2: {
        T: -1
    },
    /*::[*/ 0x00D3: {
        T: 1
    },
    /*::[*/ 0x00D4: {
        T: -1
    },
    /*::[*/ 0x00D5: {
        T: 1
    },
    /*::[*/ 0x00D6: {
        T: -1
    },
    /*::[*/ 0x00D7: {
        T: 1
    },
    /*::[*/ 0x00D8: {
        T: -1
    },
    /*::[*/ 0x00D9: {
        T: 1
    },
    /*::[*/ 0x00DA: {
        T: -1
    },
    /*::[*/ 0x00DB: {
        T: 1
    },
    /*::[*/ 0x00DC: {
        T: -1
    },
    /*::[*/ 0x00DD: {
        T: 1
    },
    /*::[*/ 0x00DE: {
        T: -1
    },
    /*::[*/ 0x00DF: {
        T: 1
    },
    /*::[*/ 0x00E0: {
        T: -1
    },
    /*::[*/ 0x00E1: {
        T: 1
    },
    /*::[*/ 0x00E2: {
        T: -1
    },
    /*::[*/ 0x00E3: {
        T: 1
    },
    /*::[*/ 0x00E4: {
        T: -1
    },
    /*::[*/ 0x00E5: {
        T: 1
    },
    /*::[*/ 0x00E6: {
        T: -1
    },
    /*::[*/ 0x00E7: {
        T: 1
    },
    /*::[*/ 0x00E8: {
        T: -1
    },
    /*::[*/ 0x00E9: {
        T: 1
    },
    /*::[*/ 0x00EA: {
        T: -1
    },
    /*::[*/ 0x00EB: {
        T: 1
    },
    /*::[*/ 0x00EC: {
        T: -1
    },
    /*::[*/ 0x00ED: {
        T: 1
    },
    /*::[*/ 0x00EE: {
        T: -1
    },
    /*::[*/ 0x00EF: {
        T: 1
    },
    /*::[*/ 0x00F0: {
        T: -1
    },
    /*::[*/ 0x00F1: {
        T: 1
    },
    /*::[*/ 0x00F2: {
        T: -1
    },
    /*::[*/ 0x00F3: {
        T: 1
    },
    /*::[*/ 0x00F4: {
        T: -1
    },
    /*::[*/ 0x00F5: {
        T: 1
    },
    /*::[*/ 0x00F6: {
        T: -1
    },
    /*::[*/ 0x00F7: {
        T: 1
    },
    /*::[*/ 0x00F8: {
        T: -1
    },
    /*::[*/ 0x00F9: {
        T: 1
    },
    /*::[*/ 0x00FA: {
        T: -1
    },
    /*::[*/ 0x00FB: {
        T: 1
    },
    /*::[*/ 0x00FC: {
        T: -1
    },
    /*::[*/ 0x00FD: {
        T: 1
    },
    /*::[*/ 0x00FE: {
        T: -1
    },
    /*::[*/ 0x00FF: {
        T: 1
    },
    /*::[*/ 0x0100: {
        T: -1
    },
    /*::[*/ 0x0101: {
        T: 1
    },
    /*::[*/ 0x0102: {
        T: -1
    },
    /*::[*/ 0x0103: {
        T: 1
    },
    /*::[*/ 0x0104: {
        T: -1
    },
    /*::[*/ 0x0105: {
        T: 1
    },
    /*::[*/ 0x0106: {
        T: -1
    },
    /*::[*/ 0x0107: {
        T: 1
    },
    /*::[*/ 0x0108: {
        T: -1
    },
    /*::[*/ 0x0109: {
        T: 1
    },
    /*::[*/ 0x010A: {
        T: -1
    },
    /*::[*/ 0x010B: {
        T: 1
    },
    /*::[*/ 0x010C: {
        T: -1
    },
    /*::[*/ 0x010D: {
        T: 1
    },
    /*::[*/ 0x010E: {
        T: -1
    },
    /*::[*/ 0x010F: {
        T: 1
    },
    /*::[*/ 0x0110: {
        T: -1
    },
    /*::[*/ 0x0111: {
        T: 1
    },
    /*::[*/ 0x0112: {
        T: -1
    },
    /*::[*/ 0x0113: {
        T: 1
    },
    /*::[*/ 0x0114: {
        T: -1
    },
    /*::[*/ 0x0115: {},
    /*::[*/ 0x0116: {
        T: 1
    },
    /*::[*/ 0x0117: {
        T: -1
    },
    /*::[*/ 0x0118: {
        T: 1
    },
    /*::[*/ 0x0119: {
        T: -1
    },
    /*::[*/ 0x011A: {
        T: 1
    },
    /*::[*/ 0x011B: {
        T: 1
    },
    /*::[*/ 0x011C: {
        T: -1
    },
    /*::[*/ 0x011D: {
        T: 1
    },
    /*::[*/ 0x011E: {
        T: -1
    },
    /*::[*/ 0x011F: {
        T: 1
    },
    /*::[*/ 0x0120: {
        T: -1
    },
    /*::[*/ 0x0121: {
        T: 1
    },
    /*::[*/ 0x0122: {
        T: -1
    },
    /*::[*/ 0x0123: {
        T: 1
    },
    /*::[*/ 0x0124: {
        T: -1
    },
    /*::[*/ 0x0125: {
        T: 1
    },
    /*::[*/ 0x0126: {
        T: -1
    },
    /*::[*/ 0x0127: {
        T: 1
    },
    /*::[*/ 0x0128: {
        T: -1
    },
    /*::[*/ 0x0129: {
        T: 1
    },
    /*::[*/ 0x012A: {
        T: -1
    },
    /*::[*/ 0x012B: {
        T: 1
    },
    /*::[*/ 0x012C: {
        T: -1
    },
    /*::[*/ 0x012D: {
        T: 1
    },
    /*::[*/ 0x012E: {
        T: -1
    },
    /*::[*/ 0x012F: {
        T: 1
    },
    /*::[*/ 0x0130: {
        T: -1
    },
    /*::[*/ 0x0131: {
        T: 1
    },
    /*::[*/ 0x0132: {
        T: -1
    },
    /*::[*/ 0x0133: {
        T: 1
    },
    /*::[*/ 0x0134: {
        T: -1
    },
    /*::[*/ 0x0135: {
        T: 1
    },
    /*::[*/ 0x0136: {
        T: -1
    },
    /*::[*/ 0x0137: {
        T: 1
    },
    /*::[*/ 0x0138: {
        T: -1
    },
    /*::[*/ 0x0139: {
        T: -1
    },
    /*::[*/ 0x013A: {
        T: 1
    },
    /*::[*/ 0x013B: {
        T: -1
    },
    /*::[*/ 0x013C: {
        T: 1
    },
    /*::[*/ 0x013D: {
        T: -1
    },
    /*::[*/ 0x013E: {
        T: 1
    },
    /*::[*/ 0x013F: {
        T: -1
    },
    /*::[*/ 0x0140: {
        T: 1
    },
    /*::[*/ 0x0141: {
        T: -1
    },
    /*::[*/ 0x0142: {
        T: 1
    },
    /*::[*/ 0x0143: {
        T: -1
    },
    /*::[*/ 0x0144: {
        T: 1
    },
    /*::[*/ 0x0145: {
        T: -1
    },
    /*::[*/ 0x0146: {
        T: 1
    },
    /*::[*/ 0x0147: {
        T: -1
    },
    /*::[*/ 0x0148: {
        T: 1
    },
    /*::[*/ 0x0149: {
        T: -1
    },
    /*::[*/ 0x014A: {
        T: 1
    },
    /*::[*/ 0x014B: {
        T: -1
    },
    /*::[*/ 0x014C: {
        T: 1
    },
    /*::[*/ 0x014D: {
        T: -1
    },
    /*::[*/ 0x014E: {
        T: 1
    },
    /*::[*/ 0x014F: {
        f: $7c3b72a365cc0275$var$parse_BrtMdtinfo
    },
    /*::[*/ 0x0150: {
        T: -1
    },
    /*::[*/ 0x0151: {
        f: $7c3b72a365cc0275$var$parse_BrtBeginEsmdb,
        T: 1
    },
    /*::[*/ 0x0152: {
        T: -1
    },
    /*::[*/ 0x0153: {
        T: 1
    },
    /*::[*/ 0x0154: {
        T: -1
    },
    /*::[*/ 0x0155: {
        T: 1
    },
    /*::[*/ 0x0156: {
        T: -1
    },
    /*::[*/ 0x0157: {
        T: 1
    },
    /*::[*/ 0x0158: {
        T: -1
    },
    /*::[*/ 0x0159: {
        T: 1
    },
    /*::[*/ 0x015A: {
        T: -1
    },
    /*::[*/ 0x015B: {
        T: 1
    },
    /*::[*/ 0x015C: {
        T: -1
    },
    /*::[*/ 0x015D: {
        T: 1
    },
    /*::[*/ 0x015E: {
        T: -1
    },
    /*::[*/ 0x015F: {},
    /*::[*/ 0x0160: {},
    /*::[*/ 0x0161: {
        T: 1
    },
    /*::[*/ 0x0162: {
        T: -1
    },
    /*::[*/ 0x0163: {
        f: $7c3b72a365cc0275$var$parse_RelID
    },
    /*::[*/ 0x0165: {},
    /*::[*/ 0x0166: {},
    /*::[*/ 0x0167: {},
    /*::[*/ 0x0168: {
        T: 1
    },
    /*::[*/ 0x0169: {},
    /*::[*/ 0x016A: {
        f: $7c3b72a365cc0275$var$parse_ExternSheet
    },
    /*::[*/ 0x016B: {},
    /*::[*/ 0x016C: {},
    /*::[*/ 0x016E: {},
    /*::[*/ 0x016F: {},
    /*::[*/ 0x0170: {},
    /*::[*/ 0x0171: {},
    /*::[*/ 0x0172: {},
    /*::[*/ 0x0173: {},
    /*::[*/ 0x0174: {
        T: 1
    },
    /*::[*/ 0x0175: {
        T: -1
    },
    /*::[*/ 0x0176: {
        T: 1
    },
    /*::[*/ 0x0177: {
        T: -1
    },
    /*::[*/ 0x0178: {
        T: 1
    },
    /*::[*/ 0x0179: {
        T: -1
    },
    /*::[*/ 0x017A: {
        T: 1
    },
    /*::[*/ 0x017B: {
        T: -1
    },
    /*::[*/ 0x017C: {
        T: 1
    },
    /*::[*/ 0x017D: {
        T: -1
    },
    /*::[*/ 0x017E: {
        T: 1
    },
    /*::[*/ 0x017F: {
        T: -1
    },
    /*::[*/ 0x0180: {
        T: 1
    },
    /*::[*/ 0x0181: {
        T: -1
    },
    /*::[*/ 0x0182: {
        T: 1
    },
    /*::[*/ 0x0183: {
        T: -1
    },
    /*::[*/ 0x0184: {
        T: 1
    },
    /*::[*/ 0x0185: {
        T: -1
    },
    /*::[*/ 0x0186: {
        T: 1
    },
    /*::[*/ 0x0187: {
        T: -1
    },
    /*::[*/ 0x0188: {
        T: 1
    },
    /*::[*/ 0x0189: {
        T: -1
    },
    /*::[*/ 0x018A: {
        T: 1
    },
    /*::[*/ 0x018B: {
        T: -1
    },
    /*::[*/ 0x018C: {},
    /*::[*/ 0x018D: {},
    /*::[*/ 0x018E: {},
    /*::[*/ 0x018F: {},
    /*::[*/ 0x0190: {},
    /*::[*/ 0x0191: {
        T: 1
    },
    /*::[*/ 0x0193: {},
    /*::[*/ 0x0194: {},
    /*::[*/ 0x0195: {},
    /*::[*/ 0x0196: {},
    /*::[*/ 0x0197: {},
    /*::[*/ 0x0198: {},
    /*::[*/ 0x0199: {},
    /*::[*/ 0x019A: {},
    /*::[*/ 0x019B: {},
    /*::[*/ 0x019C: {},
    /*::[*/ 0x019D: {},
    /*::[*/ 0x019E: {},
    /*::[*/ 0x019F: {},
    /*::[*/ 0x01A0: {},
    /*::[*/ 0x01A1: {},
    /*::[*/ 0x01A2: {},
    /*::[*/ 0x01A3: {},
    /*::[*/ 0x01A4: {},
    /*::[*/ 0x01A5: {},
    /*::[*/ 0x01A6: {
        T: 1
    },
    /*::[*/ 0x01A7: {
        T: 1
    },
    /*::[*/ 0x01A8: {
        T: -1
    },
    /*::[*/ 0x01A9: {
        T: -1
    },
    /*::[*/ 0x01AA: {
        f: $7c3b72a365cc0275$var$parse_BrtArrFmla
    },
    /*::[*/ 0x01AB: {
        f: $7c3b72a365cc0275$var$parse_BrtShrFmla
    },
    /*::[*/ 0x01AC: {},
    /*::[*/ 0x01AD: {
        T: 1
    },
    /*::[*/ 0x01AE: {
        T: -1
    },
    /*::[*/ 0x01AF: {
        T: 1
    },
    /*::[*/ 0x01B0: {
        T: -1
    },
    /*::[*/ 0x01B1: {
        T: 1
    },
    /*::[*/ 0x01B2: {
        T: -1
    },
    /*::[*/ 0x01B3: {
        T: 1
    },
    /*::[*/ 0x01B4: {
        T: -1
    },
    /*::[*/ 0x01B5: {
        T: 1
    },
    /*::[*/ 0x01B6: {
        T: -1
    },
    /*::[*/ 0x01B7: {
        T: 1
    },
    /*::[*/ 0x01B8: {
        T: -1
    },
    /*::[*/ 0x01B9: {
        T: 1
    },
    /*::[*/ 0x01BA: {
        T: -1
    },
    /*::[*/ 0x01BB: {
        T: 1
    },
    /*::[*/ 0x01BC: {
        T: -1
    },
    /*::[*/ 0x01BD: {
        T: 1
    },
    /*::[*/ 0x01BE: {
        T: -1
    },
    /*::[*/ 0x01BF: {
        T: 1
    },
    /*::[*/ 0x01C0: {
        T: -1
    },
    /*::[*/ 0x01C1: {
        T: 1
    },
    /*::[*/ 0x01C2: {
        T: -1
    },
    /*::[*/ 0x01C3: {
        T: 1
    },
    /*::[*/ 0x01C4: {
        T: -1
    },
    /*::[*/ 0x01C5: {
        T: 1
    },
    /*::[*/ 0x01C6: {
        T: -1
    },
    /*::[*/ 0x01C7: {
        T: 1
    },
    /*::[*/ 0x01C8: {
        T: -1
    },
    /*::[*/ 0x01C9: {
        T: 1
    },
    /*::[*/ 0x01CA: {
        T: -1
    },
    /*::[*/ 0x01CB: {
        T: 1
    },
    /*::[*/ 0x01CC: {
        T: -1
    },
    /*::[*/ 0x01CD: {
        T: 1
    },
    /*::[*/ 0x01CE: {
        T: -1
    },
    /*::[*/ 0x01CF: {
        T: 1
    },
    /*::[*/ 0x01D0: {
        T: -1
    },
    /*::[*/ 0x01D1: {
        T: 1
    },
    /*::[*/ 0x01D2: {
        T: -1
    },
    /*::[*/ 0x01D3: {
        T: 1
    },
    /*::[*/ 0x01D4: {
        T: -1
    },
    /*::[*/ 0x01D5: {
        T: 1
    },
    /*::[*/ 0x01D6: {
        T: -1
    },
    /*::[*/ 0x01D7: {},
    /*::[*/ 0x01D8: {},
    /*::[*/ 0x01D9: {
        T: 1
    },
    /*::[*/ 0x01DA: {
        T: -1
    },
    /*::[*/ 0x01DB: {},
    /*::[*/ 0x01DC: {
        f: $7c3b72a365cc0275$var$parse_BrtMargins
    },
    /*::[*/ 0x01DD: {},
    /*::[*/ 0x01DE: {},
    /*::[*/ 0x01DF: {
        T: 1
    },
    /*::[*/ 0x01E0: {
        T: -1
    },
    /*::[*/ 0x01E1: {
        T: 1
    },
    /*::[*/ 0x01E2: {
        T: -1
    },
    /*::[*/ 0x01E3: {
        T: 1
    },
    /*::[*/ 0x01E4: {
        T: -1
    },
    /*::[*/ 0x01E5: {
        f: $7c3b72a365cc0275$var$parse_BrtWsFmtInfo
    },
    /*::[*/ 0x01E6: {
        T: 1
    },
    /*::[*/ 0x01E7: {
        T: -1
    },
    /*::[*/ 0x01E8: {
        T: 1
    },
    /*::[*/ 0x01E9: {
        T: -1
    },
    /*::[*/ 0x01EA: {
        T: 1
    },
    /*::[*/ 0x01EB: {
        T: -1
    },
    /*::[*/ 0x01EC: {
        T: 1
    },
    /*::[*/ 0x01ED: {
        T: -1
    },
    /*::[*/ 0x01EE: {
        f: $7c3b72a365cc0275$var$parse_BrtHLink
    },
    /*::[*/ 0x01EF: {
        T: 1
    },
    /*::[*/ 0x01F0: {
        T: -1
    },
    /*::[*/ 0x01F1: {
        T: 1
    },
    /*::[*/ 0x01F2: {
        T: -1
    },
    /*::[*/ 0x01F3: {},
    /*::[*/ 0x01F4: {
        T: 1
    },
    /*::[*/ 0x01F5: {
        T: -1
    },
    /*::[*/ 0x01F6: {
        T: 1
    },
    /*::[*/ 0x01F7: {
        T: -1
    },
    /*::[*/ 0x01F8: {},
    /*::[*/ 0x01F9: {
        T: 1
    },
    /*::[*/ 0x01FA: {
        T: -1
    },
    /*::[*/ 0x01FB: {},
    /*::[*/ 0x01FC: {
        T: 1
    },
    /*::[*/ 0x01FD: {
        T: -1
    },
    /*::[*/ 0x01FE: {
        T: 1
    },
    /*::[*/ 0x01FF: {
        T: -1
    },
    /*::[*/ 0x0200: {},
    /*::[*/ 0x0201: {},
    /*::[*/ 0x0202: {
        T: 1
    },
    /*::[*/ 0x0203: {
        T: -1
    },
    /*::[*/ 0x0204: {
        T: 1
    },
    /*::[*/ 0x0205: {
        T: -1
    },
    /*::[*/ 0x0206: {
        T: 1
    },
    /*::[*/ 0x0207: {
        T: -1
    },
    /*::[*/ 0x0208: {
        T: 1
    },
    /*::[*/ 0x0209: {
        T: -1
    },
    /*::[*/ 0x020A: {},
    /*::[*/ 0x020B: {},
    /*::[*/ 0x020C: {},
    /*::[*/ 0x020D: {},
    /*::[*/ 0x020E: {},
    /*::[*/ 0x020F: {},
    /*::[*/ 0x0210: {
        T: 1
    },
    /*::[*/ 0x0211: {
        T: -1
    },
    /*::[*/ 0x0212: {
        T: 1
    },
    /*::[*/ 0x0213: {
        T: -1
    },
    /*::[*/ 0x0214: {
        T: 1
    },
    /*::[*/ 0x0215: {
        T: -1
    },
    /*::[*/ 0x0216: {},
    /*::[*/ 0x0217: {},
    /*::[*/ 0x0218: {},
    /*::[*/ 0x0219: {},
    /*::[*/ 0x021A: {
        T: 1
    },
    /*::[*/ 0x021B: {
        T: -1
    },
    /*::[*/ 0x021C: {
        T: 1
    },
    /*::[*/ 0x021D: {
        T: -1
    },
    /*::[*/ 0x021E: {
        T: 1
    },
    /*::[*/ 0x0224: {},
    /*::[*/ 0x0225: {},
    /*::[*/ 0x0226: {
        f: $7c3b72a365cc0275$var$parse_RelID
    },
    /*::[*/ 0x0227: {},
    /*::[*/ 0x0228: {},
    /*::[*/ 0x0229: {},
    /*::[*/ 0x022A: {
        T: 1
    },
    /*::[*/ 0x022B: {
        T: -1
    },
    /*::[*/ 0x022C: {
        T: 1
    },
    /*::[*/ 0x022D: {
        T: -1
    },
    /*::[*/ 0x022E: {
        T: 1
    },
    /*::[*/ 0x022F: {
        T: -1
    },
    /*::[*/ 0x0230: {
        T: 1
    },
    /*::[*/ 0x0231: {
        T: -1
    },
    /*::[*/ 0x0232: {},
    /*::[*/ 0x0234: {},
    /*::[*/ 0x0235: {
        T: 1
    },
    /*::[*/ 0x0236: {
        T: -1
    },
    /*::[*/ 0x0239: {
        T: 1
    },
    /*::[*/ 0x023A: {
        T: -1
    },
    /*::[*/ 0x023C: {},
    /*::[*/ 0x023D: {
        T: 1
    },
    /*::[*/ 0x023E: {
        T: -1
    },
    /*::[*/ 0x0241: {},
    /*::[*/ 0x0242: {},
    /*::[*/ 0x0243: {},
    /*::[*/ 0x0244: {},
    /*::[*/ 0x0245: {},
    /*::[*/ 0x0246: {},
    /*::[*/ 0x0247: {},
    /*::[*/ 0x0248: {},
    /*::[*/ 0x0249: {},
    /*::[*/ 0x024A: {},
    /*::[*/ 0x024B: {},
    /*::[*/ 0x024C: {
        T: -1
    },
    /*::[*/ 0x024D: {},
    /*::[*/ 0x024E: {
        T: 1
    },
    /*::[*/ 0x024F: {
        T: -1
    },
    /*::[*/ 0x0250: {
        T: 1
    },
    /*::[*/ 0x0251: {
        T: -1
    },
    /*::[*/ 0x0252: {
        T: 1
    },
    /*::[*/ 0x0253: {
        T: -1
    },
    /*::[*/ 0x0254: {},
    /*::[*/ 0x0255: {
        T: 1
    },
    /*::[*/ 0x0256: {
        T: -1
    },
    /*::[*/ 0x0257: {
        T: 1
    },
    /*::[*/ 0x0258: {
        T: -1
    },
    /*::[*/ 0x0259: {
        T: 1
    },
    /*::[*/ 0x025A: {
        T: -1
    },
    /*::[*/ 0x025B: {
        T: 1
    },
    /*::[*/ 0x025C: {
        T: -1
    },
    /*::[*/ 0x025D: {
        T: 1
    },
    /*::[*/ 0x025E: {
        T: -1
    },
    /*::[*/ 0x025F: {},
    /*::[*/ 0x0260: {
        T: 1
    },
    /*::[*/ 0x0261: {
        T: -1
    },
    /*::[*/ 0x0262: {},
    /*::[*/ 0x0263: {
        T: 1
    },
    /*::[*/ 0x0264: {
        T: -1
    },
    /*::[*/ 0x0265: {
        T: 1
    },
    /*::[*/ 0x0266: {
        T: -1
    },
    /*::[*/ 0x0267: {
        T: 1
    },
    /*::[*/ 0x0268: {
        T: -1
    },
    /*::[*/ 0x0269: {
        T: 1
    },
    /*::[*/ 0x026A: {
        T: -1
    },
    /*::[*/ 0x026B: {
        T: 1
    },
    /*::[*/ 0x026C: {
        T: -1
    },
    /*::[*/ 0x0271: {},
    /*::[*/ 0x0272: {
        T: 1
    },
    /*::[*/ 0x0273: {
        T: -1
    },
    /*::[*/ 0x0274: {
        T: 1
    },
    /*::[*/ 0x0275: {
        T: -1
    },
    /*::[*/ 0x0276: {
        T: 1
    },
    /*::[*/ 0x0277: {
        T: -1
    },
    /*::[*/ 0x0278: {
        f: $7c3b72a365cc0275$var$parse_BrtCommentAuthor
    },
    /*::[*/ 0x0279: {
        T: 1
    },
    /*::[*/ 0x027A: {
        T: -1
    },
    /*::[*/ 0x027B: {
        T: 1,
        f: $7c3b72a365cc0275$var$parse_BrtBeginComment
    },
    /*::[*/ 0x027C: {
        T: -1
    },
    /*::[*/ 0x027D: {
        f: $7c3b72a365cc0275$var$parse_BrtCommentText
    },
    /*::[*/ 0x027E: {
        T: 1
    },
    /*::[*/ 0x027F: {},
    /*::[*/ 0x0280: {
        T: -1
    },
    /*::[*/ 0x0281: {
        T: 1
    },
    /*::[*/ 0x0282: {
        T: -1
    },
    /*::[*/ 0x0283: {
        T: 1
    },
    /*::[*/ 0x0284: {},
    /*::[*/ 0x0285: {
        T: -1
    },
    /*::[*/ 0x0286: {
        T: 1
    },
    /*::[*/ 0x0288: {
        T: 1
    },
    /*::[*/ 0x0289: {},
    /*::[*/ 0x028A: {
        T: -1
    },
    /*::[*/ 0x028B: {
        f: $7c3b72a365cc0275$var$parse_BrtCsProp
    },
    /*::[*/ 0x028C: {},
    /*::[*/ 0x028D: {
        T: 1
    },
    /*::[*/ 0x028E: {
        T: -1
    },
    /*::[*/ 0x028F: {
        T: 1
    },
    /*::[*/ 0x0290: {
        T: -1
    },
    /*::[*/ 0x0291: {
        T: 1
    },
    /*::[*/ 0x0292: {
        T: -1
    },
    /*::[*/ 0x0293: {},
    /*::[*/ 0x0294: {
        T: 1
    },
    /*::[*/ 0x0295: {},
    /*::[*/ 0x0296: {
        T: -1
    },
    /*::[*/ 0x0297: {},
    /*::[*/ 0x0298: {
        T: 1
    },
    /*::[*/ 0x0299: {},
    /*::[*/ 0x029A: {
        T: -1
    },
    /*::[*/ 0x029B: {},
    /*::[*/ 0x029C: {},
    /*::[*/ 0x029D: {},
    /*::[*/ 0x029F: {
        T: 1
    },
    /*::[*/ 0x02A0: {
        T: -1
    },
    /*::[*/ 0x02A1: {
        T: 1
    },
    /*::[*/ 0x02A2: {
        T: -1
    },
    /*::[*/ 0x02A3: {},
    /*::[*/ 0x02A4: {},
    /*::[*/ 0x02A5: {},
    /*::[*/ 0x02A6: {},
    /*::[*/ 0x02A7: {},
    /*::[*/ 0x02A8: {},
    /*::[*/ 0x02A9: {},
    /*::[*/ 0x0400: {},
    /*::[*/ 0x0401: {},
    /*::[*/ 0x0402: {
        T: 1
    },
    /*::[*/ 0x0403: {
        T: -1
    },
    /*::[*/ 0x0404: {
        T: 1
    },
    /*::[*/ 0x0405: {
        T: -1
    },
    /*::[*/ 0x0406: {},
    /*::[*/ 0x0407: {
        T: 1
    },
    /*::[*/ 0x0408: {
        T: -1
    },
    /*::[*/ 0x0409: {
        T: 1
    },
    /*::[*/ 0x040A: {
        T: -1
    },
    /*::[*/ 0x040B: {},
    /*::[*/ 0x040C: {},
    /*::[*/ 0x040D: {},
    /*::[*/ 0x040E: {
        T: 1
    },
    /*::[*/ 0x040F: {
        T: -1
    },
    /*::[*/ 0x0410: {},
    /*::[*/ 0x0411: {
        T: 1
    },
    /*::[*/ 0x0412: {
        T: -1
    },
    /*::[*/ 0x0413: {},
    /*::[*/ 0x0414: {},
    /*::[*/ 0x0415: {},
    /*::[*/ 0x0416: {
        T: 1
    },
    /*::[*/ 0x0417: {
        T: -1
    },
    /*::[*/ 0x0418: {
        T: 1
    },
    /*::[*/ 0x0419: {
        T: -1
    },
    /*::[*/ 0x041A: {},
    /*::[*/ 0x041B: {
        T: 1
    },
    /*::[*/ 0x041C: {
        T: 1
    },
    /*::[*/ 0x041D: {
        f: $7c3b72a365cc0275$var$parse_BrtDVal14
    },
    /*::[*/ 0x041E: {
        T: 1
    },
    /*::[*/ 0x041F: {},
    /*::[*/ 0x0420: {
        T: 1
    },
    /*::[*/ 0x0421: {
        T: -1
    },
    /*::[*/ 0x0422: {
        T: 1
    },
    /*::[*/ 0x0423: {
        T: -1
    },
    /*::[*/ 0x0425: {},
    /*::[*/ 0x0426: {
        T: 1
    },
    /*::[*/ 0x0427: {
        T: -1
    },
    /*::[*/ 0x0428: {
        T: 1
    },
    /*::[*/ 0x0429: {
        T: -1
    },
    /*::[*/ 0x042A: {
        T: 1
    },
    /*::[*/ 0x042B: {
        T: -1
    },
    /*::[*/ 0x042C: {
        T: 1
    },
    /*::[*/ 0x042D: {
        T: -1
    },
    /*::[*/ 0x042E: {
        T: 1
    },
    /*::[*/ 0x042F: {
        T: -1
    },
    /*::[*/ 0x0430: {
        T: 1
    },
    /*::[*/ 0x0431: {
        T: -1
    },
    /*::[*/ 0x0433: {
        T: 1
    },
    /*::[*/ 0x0434: {
        T: -1
    },
    /*::[*/ 0x0435: {
        T: 1
    },
    /*::[*/ 0x0436: {
        T: -1
    },
    /*::[*/ 0x0437: {
        T: 1
    },
    /*::[*/ 0x0438: {
        T: -1
    },
    /*::[*/ 0x0439: {
        T: 1
    },
    /*::[*/ 0x043A: {
        T: -1
    },
    /*::[*/ 0x043B: {
        T: 1
    },
    /*::[*/ 0x043C: {
        T: -1
    },
    /*::[*/ 0x043D: {},
    /*::[*/ 0x043E: {
        T: 1
    },
    /*::[*/ 0x043F: {
        T: -1
    },
    /*::[*/ 0x0440: {
        T: 1
    },
    /*::[*/ 0x0441: {
        T: -1
    },
    /*::[*/ 0x0442: {
        T: 1
    },
    /*::[*/ 0x0443: {
        T: -1
    },
    /*::[*/ 0x0444: {
        T: 1
    },
    /*::[*/ 0x0445: {
        T: -1
    },
    /*::[*/ 0x0446: {
        T: 1
    },
    /*::[*/ 0x0447: {
        T: -1
    },
    /*::[*/ 0x0448: {},
    /*::[*/ 0x0449: {
        T: 1
    },
    /*::[*/ 0x044A: {},
    /*::[*/ 0x044B: {
        T: -1
    },
    /*::[*/ 0x044C: {
        T: 1
    },
    /*::[*/ 0x044D: {
        T: -1
    },
    /*::[*/ 0x044E: {},
    /*::[*/ 0x044F: {},
    /*::[*/ 0x0450: {},
    /*::[*/ 0x0451: {},
    /*::[*/ 0x0457: {},
    /*::[*/ 0x0458: {},
    /*::[*/ 0x0459: {
        T: 1
    },
    /*::[*/ 0x045A: {
        T: -1
    },
    /*::[*/ 0x045B: {
        T: 1
    },
    /*::[*/ 0x045C: {
        T: -1
    },
    /*::[*/ 0x045D: {},
    /*::[*/ 0x045E: {
        T: 1
    },
    /*::[*/ 0x045F: {
        T: -1
    },
    /*::[*/ 0x0460: {
        T: 1
    },
    /*::[*/ 0x0461: {
        T: -1
    },
    /*::[*/ 0x0462: {
        T: 1
    },
    /*::[*/ 0x0463: {
        T: -1
    },
    /*::[*/ 0x0464: {
        T: 1
    },
    /*::[*/ 0x0465: {
        T: -1
    },
    /*::[*/ 0x0466: {},
    /*::[*/ 0x0468: {
        T: 1
    },
    /*::[*/ 0x0469: {
        T: -1
    },
    /*::[*/ 0x046A: {},
    /*::[*/ 0x046B: {
        T: 1
    },
    /*::[*/ 0x046C: {
        T: -1
    },
    /*::[*/ 0x046D: {
        T: 1
    },
    /*::[*/ 0x046E: {
        T: -1
    },
    /*::[*/ 0x046F: {
        T: 1
    },
    /*::[*/ 0x0470: {
        T: -1
    },
    /*::[*/ 0x0471: {
        T: 1
    },
    /*::[*/ 0x0472: {
        T: -1
    },
    /*::[*/ 0x0473: {
        T: 1
    },
    /*::[*/ 0x0474: {
        T: -1
    },
    /*::[*/ 0x0475: {},
    /*::[*/ 0x0476: {
        T: 1
    },
    /*::[*/ 0x0477: {
        T: -1
    },
    /*::[*/ 0x0478: {
        T: 1
    },
    /*::[*/ 0x0479: {
        T: -1
    },
    /*::[*/ 0x047A: {},
    /*::[*/ 0x047B: {
        T: 1
    },
    /*::[*/ 0x047C: {
        T: -1
    },
    /*::[*/ 0x047D: {
        T: 1
    },
    /*::[*/ 0x047E: {
        T: -1
    },
    /*::[*/ 0x0480: {
        T: 1
    },
    /*::[*/ 0x0481: {
        T: -1
    },
    /*::[*/ 0x0482: {
        T: -1
    },
    /*::[*/ 0x0483: {
        T: -1
    },
    /*::[*/ 0x0484: {
        T: -1
    },
    /*::[*/ 0x0485: {
        T: 1
    },
    /*::[*/ 0x0486: {
        T: -1
    },
    /*::[*/ 0x0487: {
        T: 1
    },
    /*::[*/ 0x0488: {
        T: -1
    },
    /*::[*/ 0x0489: {
        T: 1
    },
    /*::[*/ 0x048A: {
        T: -1
    },
    /*::[*/ 0x048B: {
        T: 1
    },
    /*::[*/ 0x048C: {
        T: -1
    },
    /*::[*/ 0x048D: {
        T: 1
    },
    /*::[*/ 0x048E: {
        T: -1
    },
    /*::[*/ 0x048F: {
        T: 1
    },
    /*::[*/ 0x0490: {
        T: -1
    },
    /*::[*/ 0x0491: {
        T: 1
    },
    /*::[*/ 0x0492: {
        T: -1
    },
    /*::[*/ 0x0493: {},
    /*::[*/ 0x0494: {
        T: 1
    },
    /*::[*/ 0x0495: {
        T: -1
    },
    /*::[*/ 0x0499: {},
    /*::[*/ 0x049A: {
        T: 1
    },
    /*::[*/ 0x049C: {},
    /*::[*/ 0x049D: {},
    /*::[*/ 0x049E: {},
    /*::[*/ 0x0800: {
        T: 1
    },
    /*::[*/ 0x0801: {
        T: -1
    },
    /*::[*/ 0x0802: {},
    /*::[*/ 0x0803: {
        T: 1
    },
    /*::[*/ 0x0804: {
        T: -1
    },
    /*::[*/ 0x0805: {},
    /*::[*/ 0x0806: {},
    /*::[*/ 0x0807: {
        T: 1
    },
    /*::[*/ 0x0808: {
        T: -1
    },
    /*::[*/ 0x0809: {
        T: 1
    },
    /*::[*/ 0x080A: {
        T: -1
    },
    /*::[*/ 0x080C: {},
    /*::[*/ 0x0813: {},
    /*::[*/ 0x0814: {
        T: 1
    },
    /*::[*/ 0x0815: {
        T: -1
    },
    /*::[*/ 0x0816: {},
    /*::[*/ 0x0817: {},
    /*::[*/ 0x0818: {
        T: 1
    },
    /*::[*/ 0x0819: {
        T: -1
    },
    /*::[*/ 0x081B: {},
    /*::[*/ 0x081C: {},
    /*::[*/ 0x081D: {
        T: 1
    },
    /*::[*/ 0x081E: {
        T: -1
    },
    /*::[*/ 0x081F: {},
    /*::[*/ 0x0820: {
        T: 1
    },
    /*::[*/ 0x0821: {
        T: -1
    },
    /*::[*/ 0x0822: {},
    /*::[*/ 0x0823: {
        T: 1
    },
    /*::[*/ 0x0824: {
        T: -1
    },
    /*::[*/ 0x0825: {
        T: 1
    },
    /*::[*/ 0x0826: {
        T: -1
    },
    /*::[*/ 0x0827: {
        T: 1
    },
    /*::[*/ 0x0828: {
        T: -1
    },
    /*::[*/ 0x0829: {
        T: 1
    },
    /*::[*/ 0x082A: {
        T: -1
    },
    /*::[*/ 0x082B: {},
    /*::[*/ 0x082C: {},
    /*::[*/ 0x082D: {
        T: 1
    },
    /*::[*/ 0x082E: {
        T: -1
    },
    /*::[*/ 0x082F: {},
    /*::[*/ 0x0830: {
        T: 1
    },
    /*::[*/ 0x0831: {
        T: -1
    },
    /*::[*/ 0x0832: {
        T: 1
    },
    /*::[*/ 0x0833: {
        T: -1
    },
    /*::[*/ 0x0834: {
        T: 1
    },
    /*::[*/ 0x0835: {
        T: -1
    },
    /*::[*/ 0x0836: {},
    /*::[*/ 0x0837: {
        T: 1
    },
    /*::[*/ 0x0838: {
        T: -1
    },
    /*::[*/ 0x0839: {},
    /*::[*/ 0x083A: {
        T: 1
    },
    /*::[*/ 0x083B: {
        T: -1
    },
    /*::[*/ 0x083C: {},
    /*::[*/ 0x083D: {
        T: 1
    },
    /*::[*/ 0x083E: {
        T: -1
    },
    /*::[*/ 0x083F: {
        T: 1
    },
    /*::[*/ 0x0840: {
        T: -1
    },
    /*::[*/ 0x0841: {
        T: 1
    },
    /*::[*/ 0x0842: {
        T: -1
    },
    /*::[*/ 0x0843: {},
    /*::[*/ 0x0844: {},
    /*::[*/ 0x0845: {},
    /*::[*/ 0x0846: {
        T: 1
    },
    /*::[*/ 0x0847: {
        T: -1
    },
    /*::[*/ 0x0848: {},
    /*::[*/ 0x0849: {
        T: 1
    },
    /*::[*/ 0x084A: {
        T: -1
    },
    /*::[*/ 0x084B: {
        T: 1
    },
    /*::[*/ 0x084C: {
        T: -1
    },
    /*::[*/ 0x084D: {},
    /*::[*/ 0x084E: {
        T: 1
    },
    /*::[*/ 0x084F: {
        T: -1
    },
    /*::[*/ 0x0850: {},
    /*::[*/ 0x0851: {
        T: 1
    },
    /*::[*/ 0x0852: {
        T: -1
    },
    /*::[*/ 0x0853: {
        T: 1
    },
    /*::[*/ 0x0854: {
        T: -1
    },
    /*::[*/ 0x0855: {
        T: 1
    },
    /*::[*/ 0x0856: {},
    /*::[*/ 0x0857: {},
    /*::[*/ 0x0858: {},
    /*::[*/ 0x0859: {
        T: 1
    },
    /*::[*/ 0x085A: {
        T: -1
    },
    /*::[*/ 0x085B: {
        T: 1
    },
    /*::[*/ 0x085C: {
        T: -1
    },
    /*::[*/ 0x085D: {},
    /*::[*/ 0x0C00: {},
    /*::[*/ 0x0C01: {},
    /*::[*/ 0x1000: {
        T: 1
    },
    /*::[*/ 0x1001: {
        T: -1
    },
    /*::[*/ 0x138A: {
        T: 1
    },
    /*::[*/ 0x138B: {
        T: -1
    },
    /*::[*/ 0x13D9: {
        T: 1
    },
    /*::[*/ 0x13DA: {
        T: -1
    },
    /*::[*/ 0x13DB: {},
    /*::[*/ 0x13DC: {
        T: 1
    },
    /*::[*/ 0x13DD: {
        T: -1
    },
    /*::[*/ 0x13DE: {
        T: 1
    },
    /*::[*/ 0x13DF: {
        T: -1
    },
    /*::[*/ 0x13E0: {},
    /*::[*/ 0x13E1: {},
    /*::[*/ 0x13E2: {},
    /*::[*/ 0x13E4: {
        T: 1
    },
    /*::[*/ 0x13E5: {
        T: -1
    },
    /*::[*/ 0x13E6: {},
    /*::[*/ 0x13E7: {
        T: 1
    },
    /*::[*/ 0x13E8: {
        T: -1
    },
    /*::[*/ 0x13E9: {},
    /*::[*/ 0x13EB: {},
    /*::[*/ 0xFFFF: {
        n: ""
    }
};
/* [MS-XLS] 2.3 Record Enumeration (and other sources) */ var $7c3b72a365cc0275$var$XLSRecordEnum = {
    /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */ /*::[*/ 0x0006: {
        f: $7c3b72a365cc0275$var$parse_Formula
    },
    /*::[*/ 0x000a: {
        f: $7c3b72a365cc0275$var$parsenoop2
    },
    /*::[*/ 0x000c: {
        f: $7c3b72a365cc0275$var$parseuint16
    },
    /*::[*/ 0x000d: {
        f: $7c3b72a365cc0275$var$parseuint16
    },
    /*::[*/ 0x000e: {
        f: $7c3b72a365cc0275$var$parsebool
    },
    /*::[*/ 0x000f: {
        f: $7c3b72a365cc0275$var$parsebool
    },
    /*::[*/ 0x0010: {
        f: $7c3b72a365cc0275$var$parse_Xnum
    },
    /*::[*/ 0x0011: {
        f: $7c3b72a365cc0275$var$parsebool
    },
    /*::[*/ 0x0012: {
        f: $7c3b72a365cc0275$var$parsebool
    },
    /*::[*/ 0x0013: {
        f: $7c3b72a365cc0275$var$parseuint16
    },
    /*::[*/ 0x0014: {
        f: $7c3b72a365cc0275$var$parse_XLHeaderFooter
    },
    /*::[*/ 0x0015: {
        f: $7c3b72a365cc0275$var$parse_XLHeaderFooter
    },
    /*::[*/ 0x0017: {
        f: $7c3b72a365cc0275$var$parse_ExternSheet
    },
    /*::[*/ 0x0018: {
        f: $7c3b72a365cc0275$var$parse_Lbl
    },
    /*::[*/ 0x0019: {
        f: $7c3b72a365cc0275$var$parsebool
    },
    /*::[*/ 0x001a: {},
    /*::[*/ 0x001b: {},
    /*::[*/ 0x001c: {
        f: $7c3b72a365cc0275$var$parse_Note
    },
    /*::[*/ 0x001d: {},
    /*::[*/ 0x0022: {
        f: $7c3b72a365cc0275$var$parsebool
    },
    /*::[*/ 0x0023: {
        f: $7c3b72a365cc0275$var$parse_ExternName
    },
    /*::[*/ 0x0026: {
        f: $7c3b72a365cc0275$var$parse_Xnum
    },
    /*::[*/ 0x0027: {
        f: $7c3b72a365cc0275$var$parse_Xnum
    },
    /*::[*/ 0x0028: {
        f: $7c3b72a365cc0275$var$parse_Xnum
    },
    /*::[*/ 0x0029: {
        f: $7c3b72a365cc0275$var$parse_Xnum
    },
    /*::[*/ 0x002a: {
        f: $7c3b72a365cc0275$var$parsebool
    },
    /*::[*/ 0x002b: {
        f: $7c3b72a365cc0275$var$parsebool
    },
    /*::[*/ 0x002f: {
        f: $7c3b72a365cc0275$var$parse_FilePass
    },
    /*::[*/ 0x0031: {
        f: $7c3b72a365cc0275$var$parse_Font
    },
    /*::[*/ 0x0033: {
        f: $7c3b72a365cc0275$var$parseuint16
    },
    /*::[*/ 0x003c: {},
    /*::[*/ 0x003d: {
        f: $7c3b72a365cc0275$var$parse_Window1
    },
    /*::[*/ 0x0040: {
        f: $7c3b72a365cc0275$var$parsebool
    },
    /*::[*/ 0x0041: {
        f: $7c3b72a365cc0275$var$parse_Pane
    },
    /*::[*/ 0x0042: {
        f: $7c3b72a365cc0275$var$parseuint16
    },
    /*::[*/ 0x004d: {},
    /*::[*/ 0x0050: {},
    /*::[*/ 0x0051: {},
    /*::[*/ 0x0052: {},
    /*::[*/ 0x0055: {
        f: $7c3b72a365cc0275$var$parseuint16
    },
    /*::[*/ 0x0059: {},
    /*::[*/ 0x005a: {},
    /*::[*/ 0x005b: {},
    /*::[*/ 0x005c: {
        f: $7c3b72a365cc0275$var$parse_WriteAccess
    },
    /*::[*/ 0x005d: {
        f: $7c3b72a365cc0275$var$parse_Obj
    },
    /*::[*/ 0x005e: {},
    /*::[*/ 0x005f: {
        f: $7c3b72a365cc0275$var$parsebool
    },
    /*::[*/ 0x0060: {},
    /*::[*/ 0x0061: {},
    /*::[*/ 0x0063: {
        f: $7c3b72a365cc0275$var$parsebool
    },
    /*::[*/ 0x007d: {
        f: $7c3b72a365cc0275$var$parse_ColInfo
    },
    /*::[*/ 0x0080: {
        f: $7c3b72a365cc0275$var$parse_Guts
    },
    /*::[*/ 0x0081: {
        f: $7c3b72a365cc0275$var$parse_WsBool
    },
    /*::[*/ 0x0082: {
        f: $7c3b72a365cc0275$var$parseuint16
    },
    /*::[*/ 0x0083: {
        f: $7c3b72a365cc0275$var$parsebool
    },
    /*::[*/ 0x0084: {
        f: $7c3b72a365cc0275$var$parsebool
    },
    /*::[*/ 0x0085: {
        f: $7c3b72a365cc0275$var$parse_BoundSheet8
    },
    /*::[*/ 0x0086: {},
    /*::[*/ 0x008c: {
        f: $7c3b72a365cc0275$var$parse_Country
    },
    /*::[*/ 0x008d: {
        f: $7c3b72a365cc0275$var$parseuint16
    },
    /*::[*/ 0x0090: {},
    /*::[*/ 0x0092: {
        f: $7c3b72a365cc0275$var$parse_Palette
    },
    /*::[*/ 0x0097: {},
    /*::[*/ 0x0098: {},
    /*::[*/ 0x0099: {},
    /*::[*/ 0x009a: {},
    /*::[*/ 0x009b: {},
    /*::[*/ 0x009c: {
        f: $7c3b72a365cc0275$var$parseuint16
    },
    /*::[*/ 0x009d: {},
    /*::[*/ 0x009e: {},
    /*::[*/ 0x00a0: {
        f: $7c3b72a365cc0275$var$parse_Scl
    },
    /*::[*/ 0x00a1: {
        f: $7c3b72a365cc0275$var$parse_Setup
    },
    /*::[*/ 0x00ae: {},
    /*::[*/ 0x00af: {},
    /*::[*/ 0x00b0: {},
    /*::[*/ 0x00b1: {},
    /*::[*/ 0x00b2: {},
    /*::[*/ 0x00b4: {},
    /*::[*/ 0x00b5: {},
    /*::[*/ 0x00b6: {},
    /*::[*/ 0x00b8: {},
    /*::[*/ 0x00b9: {},
    /*::[*/ 0x00bd: {
        f: $7c3b72a365cc0275$var$parse_MulRk
    },
    /*::[*/ 0x00be: {
        f: $7c3b72a365cc0275$var$parse_MulBlank
    },
    /*::[*/ 0x00c1: {
        f: $7c3b72a365cc0275$var$parsenoop2
    },
    /*::[*/ 0x00c5: {},
    /*::[*/ 0x00c6: {},
    /*::[*/ 0x00c7: {},
    /*::[*/ 0x00c8: {},
    /*::[*/ 0x00c9: {},
    /*::[*/ 0x00ca: {
        f: $7c3b72a365cc0275$var$parsebool
    },
    /*::[*/ 0x00cb: {},
    /*::[*/ 0x00cc: {},
    /*::[*/ 0x00cd: {},
    /*::[*/ 0x00ce: {},
    /*::[*/ 0x00cf: {},
    /*::[*/ 0x00d0: {},
    /*::[*/ 0x00d1: {},
    /*::[*/ 0x00d2: {},
    /*::[*/ 0x00d3: {},
    /*::[*/ 0x00d5: {},
    /*::[*/ 0x00d7: {},
    /*::[*/ 0x00d8: {},
    /*::[*/ 0x00d9: {},
    /*::[*/ 0x00da: {
        f: $7c3b72a365cc0275$var$parseuint16
    },
    /*::[*/ 0x00dc: {},
    /*::[*/ 0x00dd: {
        f: $7c3b72a365cc0275$var$parsebool
    },
    /*::[*/ 0x00de: {},
    /*::[*/ 0x00e0: {
        f: $7c3b72a365cc0275$var$parse_XF
    },
    /*::[*/ 0x00e1: {
        f: $7c3b72a365cc0275$var$parse_InterfaceHdr
    },
    /*::[*/ 0x00e2: {
        f: $7c3b72a365cc0275$var$parsenoop2
    },
    /*::[*/ 0x00e3: {},
    /*::[*/ 0x00e5: {
        f: $7c3b72a365cc0275$var$parse_MergeCells
    },
    /*::[*/ 0x00e9: {},
    /*::[*/ 0x00eb: {},
    /*::[*/ 0x00ec: {},
    /*::[*/ 0x00ed: {},
    /*::[*/ 0x00ef: {},
    /*::[*/ 0x00f0: {},
    /*::[*/ 0x00f1: {},
    /*::[*/ 0x00f2: {},
    /*::[*/ 0x00f4: {},
    /*::[*/ 0x00f5: {},
    /*::[*/ 0x00f6: {},
    /*::[*/ 0x00f7: {},
    /*::[*/ 0x00f8: {},
    /*::[*/ 0x00f9: {},
    /*::[*/ 0x00fb: {},
    /*::[*/ 0x00fc: {
        f: $7c3b72a365cc0275$var$parse_SST
    },
    /*::[*/ 0x00fd: {
        f: $7c3b72a365cc0275$var$parse_LabelSst
    },
    /*::[*/ 0x00ff: {
        f: $7c3b72a365cc0275$var$parse_ExtSST
    },
    /*::[*/ 0x0100: {},
    /*::[*/ 0x0103: {},
    /*::[*/ 0x0122: {},
    /*::[*/ 0x0137: {},
    /*::[*/ 0x0138: {},
    /*::[*/ 0x013b: {},
    /*::[*/ 0x013d: {
        f: $7c3b72a365cc0275$var$parseuint16a
    },
    /*::[*/ 0x013e: {},
    /*::[*/ 0x013f: {},
    /*::[*/ 0x0140: {},
    /*::[*/ 0x014a: {},
    /*::[*/ 0x014b: {},
    /*::[*/ 0x014d: {},
    /*::[*/ 0x014e: {},
    /*::[*/ 0x014f: {},
    /*::[*/ 0x0150: {},
    /*::[*/ 0x0151: {},
    /*::[*/ 0x0152: {},
    /*::[*/ 0x0153: {},
    /*::[*/ 0x0154: {},
    /*::[*/ 0x015f: {},
    /*::[*/ 0x0160: {
        f: $7c3b72a365cc0275$var$parsebool
    },
    /*::[*/ 0x0161: {
        f: $7c3b72a365cc0275$var$parsenoop2
    },
    /*::[*/ 0x0191: {},
    /*::[*/ 0x0192: {},
    /*::[*/ 0x0193: {},
    /*::[*/ 0x0194: {},
    /*::[*/ 0x0195: {},
    /*::[*/ 0x0196: {},
    /*::[*/ 0x0197: {},
    /*::[*/ 0x0198: {},
    /*::[*/ 0x01a9: {},
    /*::[*/ 0x01aa: {},
    /*::[*/ 0x01ab: {},
    /*::[*/ 0x01ac: {},
    /*::[*/ 0x01ad: {},
    /*::[*/ 0x01ae: {
        f: $7c3b72a365cc0275$var$parse_SupBook
    },
    /*::[*/ 0x01af: {
        f: $7c3b72a365cc0275$var$parsebool
    },
    /*::[*/ 0x01b0: {},
    /*::[*/ 0x01b1: {},
    /*::[*/ 0x01b2: {},
    /*::[*/ 0x01b5: {},
    /*::[*/ 0x01b6: {
        f: $7c3b72a365cc0275$var$parse_TxO
    },
    /*::[*/ 0x01b7: {
        f: $7c3b72a365cc0275$var$parsebool
    },
    /*::[*/ 0x01b8: {
        f: $7c3b72a365cc0275$var$parse_HLink
    },
    /*::[*/ 0x01b9: {},
    /*::[*/ 0x01ba: {
        f: $7c3b72a365cc0275$var$parse_XLUnicodeString
    },
    /*::[*/ 0x01bb: {},
    /*::[*/ 0x01bc: {
        f: $7c3b72a365cc0275$var$parseuint16
    },
    /*::[*/ 0x01bd: {},
    /*::[*/ 0x01be: {},
    /*::[*/ 0x01c0: {
        f: $7c3b72a365cc0275$var$parsenoop2
    },
    /*::[*/ 0x01c1: {
        f: $7c3b72a365cc0275$var$parse_RecalcId,
        r: 2
    },
    /*::[*/ 0x01c2: {
        f: $7c3b72a365cc0275$var$parsenoop2
    },
    /*::[*/ 0x0200: {
        f: $7c3b72a365cc0275$var$parse_Dimensions
    },
    /*::[*/ 0x0201: {
        f: $7c3b72a365cc0275$var$parse_Blank
    },
    /*::[*/ 0x0203: {
        f: $7c3b72a365cc0275$var$parse_Number
    },
    /*::[*/ 0x0204: {
        f: $7c3b72a365cc0275$var$parse_Label
    },
    /*::[*/ 0x0205: {
        f: $7c3b72a365cc0275$var$parse_BoolErr
    },
    /*::[*/ 0x0207: {
        f: $7c3b72a365cc0275$var$parse_String
    },
    /*::[*/ 0x0208: {
        f: $7c3b72a365cc0275$var$parse_Row
    },
    /*::[*/ 0x020b: {},
    /*::[*/ 0x0221: {
        f: $7c3b72a365cc0275$var$parse_Array
    },
    /*::[*/ 0x0225: {
        f: $7c3b72a365cc0275$var$parse_DefaultRowHeight
    },
    /*::[*/ 0x0236: {},
    /*::[*/ 0x023e: {
        f: $7c3b72a365cc0275$var$parse_Window2
    },
    /*::[*/ 0x027e: {
        f: $7c3b72a365cc0275$var$parse_RK
    },
    /*::[*/ 0x0293: {},
    /*::[*/ 0x0418: {},
    /*::[*/ 0x041e: {
        f: $7c3b72a365cc0275$var$parse_Format
    },
    /*::[*/ 0x043c: {},
    /*::[*/ 0x04bc: {
        f: $7c3b72a365cc0275$var$parse_ShrFmla
    },
    /*::[*/ 0x0800: {
        f: $7c3b72a365cc0275$var$parse_HLinkTooltip
    },
    /*::[*/ 0x0801: {},
    /*::[*/ 0x0802: {},
    /*::[*/ 0x0803: {},
    /*::[*/ 0x0804: {},
    /*::[*/ 0x0805: {},
    /*::[*/ 0x0806: {},
    /*::[*/ 0x0807: {},
    /*::[*/ 0x0808: {},
    /*::[*/ 0x0809: {
        f: $7c3b72a365cc0275$var$parse_BOF
    },
    /*::[*/ 0x080a: {},
    /*::[*/ 0x080b: {},
    /*::[*/ 0x080c: {},
    /*::[*/ 0x080d: {},
    /*::[*/ 0x080e: {},
    /*::[*/ 0x080f: {},
    /*::[*/ 0x0810: {},
    /*::[*/ 0x0812: {},
    /*::[*/ 0x0813: {},
    /*::[*/ 0x0850: {},
    /*::[*/ 0x0851: {},
    /*::[*/ 0x0852: {},
    /*::[*/ 0x0853: {},
    /*::[*/ 0x0854: {},
    /*::[*/ 0x0855: {},
    /*::[*/ 0x0856: {},
    /*::[*/ 0x0857: {},
    /*::[*/ 0x0858: {},
    /*::[*/ 0x0859: {},
    /*::[*/ 0x085a: {},
    /*::[*/ 0x0862: {},
    /*::[*/ 0x0863: {
        r: 12
    },
    /*::[*/ 0x0864: {},
    /*::[*/ 0x0865: {},
    /*::[*/ 0x0866: {},
    /*::[*/ 0x0867: {
        f: $7c3b72a365cc0275$var$parsenoop2
    },
    /*::[*/ 0x0868: {},
    /*::[*/ 0x086a: {},
    /*::[*/ 0x086b: {},
    /*::[*/ 0x086c: {},
    /*::[*/ 0x0871: {},
    /*::[*/ 0x0872: {},
    /*::[*/ 0x0874: {},
    /*::[*/ 0x0875: {},
    /*::[*/ 0x0876: {},
    /*::[*/ 0x0877: {},
    /*::[*/ 0x0878: {},
    /*::[*/ 0x0879: {},
    /*::[*/ 0x087a: {},
    /*::[*/ 0x087b: {},
    /*::[*/ 0x087c: {
        f: $7c3b72a365cc0275$var$parse_XFCRC,
        r: 12
    },
    /*::[*/ 0x087d: {
        f: $7c3b72a365cc0275$var$parse_XFExt,
        r: 12
    },
    /*::[*/ 0x087e: {},
    /*::[*/ 0x087f: {},
    /*::[*/ 0x0884: {},
    /*::[*/ 0x0885: {},
    /*::[*/ 0x0886: {},
    /*::[*/ 0x0887: {},
    /*::[*/ 0x0888: {},
    /*::[*/ 0x0889: {},
    /*::[*/ 0x088a: {},
    /*::[*/ 0x088b: {},
    /*::[*/ 0x088c: {
        f: $7c3b72a365cc0275$var$parsebool,
        r: 12
    },
    /*::[*/ 0x088d: {},
    /*::[*/ 0x088e: {
        r: 12
    },
    /*::[*/ 0x088f: {},
    /*::[*/ 0x0890: {},
    /*::[*/ 0x0892: {},
    /*::[*/ 0x0893: {},
    /*::[*/ 0x0894: {
        f: $7c3b72a365cc0275$var$parse_NameCmt,
        r: 12
    },
    /*::[*/ 0x0895: {},
    /*::[*/ 0x0896: {
        f: $7c3b72a365cc0275$var$parse_Theme,
        r: 12
    },
    /*::[*/ 0x0897: {},
    /*::[*/ 0x0898: {},
    /*::[*/ 0x0899: {},
    /*::[*/ 0x089a: {
        f: $7c3b72a365cc0275$var$parse_MTRSettings,
        r: 12
    },
    /*::[*/ 0x089b: {
        f: $7c3b72a365cc0275$var$parsenoop2
    },
    /*::[*/ 0x089c: {},
    /*::[*/ 0x089d: {},
    /*::[*/ 0x089e: {},
    /*::[*/ 0x089f: {},
    /*::[*/ 0x08a3: {
        f: $7c3b72a365cc0275$var$parse_ForceFullCalculation
    },
    /*::[*/ 0x08a4: {},
    /*::[*/ 0x08a5: {},
    /*::[*/ 0x08a6: {},
    /*::[*/ 0x08a7: {},
    /*::[*/ 0x1001: {},
    /*::[*/ 0x1002: {},
    /*::[*/ 0x1003: {},
    /*::[*/ 0x1006: {},
    /*::[*/ 0x1007: {},
    /*::[*/ 0x1009: {},
    /*::[*/ 0x100a: {},
    /*::[*/ 0x100b: {},
    /*::[*/ 0x100c: {},
    /*::[*/ 0x100d: {},
    /*::[*/ 0x1014: {},
    /*::[*/ 0x1015: {},
    /*::[*/ 0x1016: {},
    /*::[*/ 0x1017: {},
    /*::[*/ 0x1018: {},
    /*::[*/ 0x1019: {},
    /*::[*/ 0x101a: {},
    /*::[*/ 0x101b: {},
    /*::[*/ 0x101c: {},
    /*::[*/ 0x101d: {},
    /*::[*/ 0x101e: {},
    /*::[*/ 0x101f: {},
    /*::[*/ 0x1020: {},
    /*::[*/ 0x1021: {},
    /*::[*/ 0x1022: {},
    /*::[*/ 0x1024: {},
    /*::[*/ 0x1025: {},
    /*::[*/ 0x1026: {
        f: $7c3b72a365cc0275$var$parseuint16
    },
    /*::[*/ 0x1027: {},
    /*::[*/ 0x1032: {},
    /*::[*/ 0x1033: {},
    /*::[*/ 0x1034: {},
    /*::[*/ 0x1035: {},
    /*::[*/ 0x103a: {},
    /*::[*/ 0x103c: {},
    /*::[*/ 0x103d: {},
    /*::[*/ 0x103e: {},
    /*::[*/ 0x103f: {},
    /*::[*/ 0x1040: {},
    /*::[*/ 0x1041: {},
    /*::[*/ 0x1043: {},
    /*::[*/ 0x1044: {
        f: $7c3b72a365cc0275$var$parse_ShtProps
    },
    /*::[*/ 0x1045: {},
    /*::[*/ 0x1046: {},
    /*::[*/ 0x1048: {},
    /*::[*/ 0x104a: {},
    /*::[*/ 0x104b: {},
    /*::[*/ 0x104e: {},
    /*::[*/ 0x104f: {},
    /*::[*/ 0x1050: {},
    /*::[*/ 0x1051: {},
    /*::[*/ 0x105b: {},
    /*::[*/ 0x105c: {
        f: $7c3b72a365cc0275$var$parse_ClrtClient
    },
    /*::[*/ 0x105d: {},
    /*::[*/ 0x105f: {},
    /*::[*/ 0x1060: {},
    /*::[*/ 0x1061: {},
    /*::[*/ 0x1062: {},
    /*::[*/ 0x1063: {},
    /*::[*/ 0x1064: {},
    /*::[*/ 0x1065: {},
    /*::[*/ 0x1066: {},
    /*::[*/ 0x1067: {},
    /*::[*/ 0x1068: {},
    /*::[*/ 0x0000: {
        f: $7c3b72a365cc0275$var$parse_Dimensions
    },
    /*::[*/ 0x0001: {},
    /*::[*/ 0x0002: {
        f: $7c3b72a365cc0275$var$parse_BIFF2INT
    },
    /*::[*/ 0x0003: {
        f: $7c3b72a365cc0275$var$parse_BIFF2NUM
    },
    /*::[*/ 0x0004: {
        f: $7c3b72a365cc0275$var$parse_BIFF2STR
    },
    /*::[*/ 0x0005: {
        f: $7c3b72a365cc0275$var$parse_BoolErr
    },
    /*::[*/ 0x0007: {
        f: $7c3b72a365cc0275$var$parse_BIFF2STRING
    },
    /*::[*/ 0x0008: {},
    /*::[*/ 0x0009: {
        f: $7c3b72a365cc0275$var$parse_BOF
    },
    /*::[*/ 0x000b: {},
    /*::[*/ 0x0016: {
        f: $7c3b72a365cc0275$var$parseuint16
    },
    /*::[*/ 0x001e: {
        f: $7c3b72a365cc0275$var$parse_BIFF2Format
    },
    /*::[*/ 0x001f: {},
    /* 16-bit cnt of BIFF2FORMAT records */ /*::[*/ 0x0020: {},
    /*::[*/ 0x0021: {
        f: $7c3b72a365cc0275$var$parse_Array
    },
    /*::[*/ 0x0024: {},
    /*::[*/ 0x0025: {
        f: $7c3b72a365cc0275$var$parse_DefaultRowHeight
    },
    // 0x2c ??
    // 0x2d ??
    // 0x2e ??
    // 0x30 FONTCOUNT: number of fonts
    /*::[*/ 0x0032: {
        f: $7c3b72a365cc0275$var$parse_BIFF2FONTXTRA
    },
    // 0x35: INFOOPTS
    // 0x36: TABLE (BIFF2 only)
    // 0x37: TABLE2 (BIFF2 only)
    // 0x38: WNDESK
    // 0x39 ??
    // 0x3a: BEGINPREF
    // 0x3b: ENDPREF
    /*::[*/ 0x003e: {},
    // 0x3f ??
    // 0x46: SHOWSCROLL
    // 0x47: SHOWFORMULA
    // 0x48: STATUSBAR
    // 0x49: SHORTMENUS
    // 0x4A:
    // 0x4B:
    // 0x4C:
    // 0x4E:
    // 0x4F:
    // 0x58: TOOLBAR (BIFF3)
    /* - - - */ /*::[*/ 0x0034: {},
    /*::[*/ 0x0043: {},
    /*::[*/ 0x0044: {
        f: $7c3b72a365cc0275$var$parseuint16
    },
    /*::[*/ 0x0045: {},
    /*::[*/ 0x0056: {},
    /* 16-bit cnt, similar to BIFF2 */ /*::[*/ 0x007e: {},
    /* Not necessarily same as 0x027e */ /*::[*/ 0x007f: {
        f: $7c3b72a365cc0275$var$parse_ImData
    },
    /*::[*/ 0x0087: {},
    /*::[*/ 0x0088: {},
    /*::[*/ 0x0089: {},
    // 0x8A
    // 0x8B LH: alternate menu key flag (BIFF3/4)
    // 0x8E
    // 0x8F
    /*::[*/ 0x0091: {},
    // 0x93 STYLE
    /*::[*/ 0x0094: {},
    /*::[*/ 0x0095: {},
    /*::[*/ 0x0096: {},
    // 0xA2 FNPROTO: function prototypes (BIFF4)
    // 0xA3
    // 0xA8
    /*::[*/ 0x00a9: {},
    /*::[*/ 0x00ab: {},
    /*::[*/ 0x00bc: {},
    /* Not necessarily same as 0x04bc */ /*::[*/ 0x00bf: {},
    /*::[*/ 0x00c0: {},
    /*::[*/ 0x00c2: {},
    /*::[*/ 0x00c3: {},
    /*::[*/ 0x00d6: {
        f: $7c3b72a365cc0275$var$parse_RString
    },
    /*::[*/ 0x00df: {},
    /*::[*/ 0x00ea: {},
    /*::[*/ 0x0162: {},
    /*::[*/ 0x01a5: {},
    /*::[*/ 0x0206: {
        f: $7c3b72a365cc0275$var$parse_Formula
    },
    /*::[*/ 0x0209: {
        f: $7c3b72a365cc0275$var$parse_BOF
    },
    /*::[*/ 0x0218: {
        f: $7c3b72a365cc0275$var$parse_Lbl
    },
    /*::[*/ 0x0223: {
        f: $7c3b72a365cc0275$var$parse_ExternName
    },
    /*::[*/ 0x0231: {},
    /*::[*/ 0x0243: {},
    /*::[*/ 0x0406: {
        f: $7c3b72a365cc0275$var$parse_Formula
    },
    /*::[*/ 0x0409: {
        f: $7c3b72a365cc0275$var$parse_BOF
    },
    /*::[*/ 0x0443: {},
    /*::[*/ 0x086d: {},
    /*::[*/ 0x0873: {},
    /*::[*/ 0x0881: {},
    /*::[*/ 0x08c0: {},
    /*::[*/ 0x08c1: {},
    /*::[*/ 0x08c2: {},
    /*::[*/ 0x08c3: {},
    /*::[*/ 0x08c4: {},
    /*::[*/ 0x08c5: {},
    /*::[*/ 0x08c6: {},
    /*::[*/ 0x08c7: {},
    /*::[*/ 0x08c8: {},
    /*::[*/ 0x08c9: {},
    /*::[*/ 0x08ca: {},
    /*::[*/ 0x08cb: {},
    /*::[*/ 0x08d6: {
        r: 12
    },
    /*::[*/ 0x7262: {}
};
function $7c3b72a365cc0275$var$write_biff_rec(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var t /*:number*/  = type;
    if (isNaN(t)) return;
    var len = length || (payload || []).length || 0;
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, len);
    if (/*:: len != null &&*/ len > 0 && $7c3b72a365cc0275$var$is_buf(payload)) ba.push(payload);
}
function $7c3b72a365cc0275$var$write_biff_continue(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var len = length || (payload || []).length || 0;
    if (len <= 8224) return $7c3b72a365cc0275$var$write_biff_rec(ba, type, payload, len);
    var t = type;
    if (isNaN(t)) return;
    var parts = payload.parts || [], sidx = 0;
    var i = 0, w = 0;
    while(w + (parts[sidx] || 8224) <= 8224){
        w += parts[sidx] || 8224;
        sidx++;
    }
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, w);
    ba.push(payload.slice(i, i + w));
    i += w;
    while(i < len){
        o = ba.next(4);
        o.write_shift(2, 0x3c); // TODO: figure out correct continue type
        w = 0;
        while(w + (parts[sidx] || 8224) <= 8224){
            w += parts[sidx] || 8224;
            sidx++;
        }
        o.write_shift(2, w);
        ba.push(payload.slice(i, i + w));
        i += w;
    }
}
function $7c3b72a365cc0275$var$write_BIFF2Cell(out, r /*:number*/ , c /*:number*/ ) {
    if (!out) out = $7c3b72a365cc0275$var$new_buf(7);
    out.write_shift(2, r);
    out.write_shift(2, c);
    out.write_shift(2, 0);
    out.write_shift(1, 0);
    return out;
}
function $7c3b72a365cc0275$var$write_BIFF2BERR(r /*:number*/ , c /*:number*/ , val, t /*:?string*/ ) {
    var out = $7c3b72a365cc0275$var$new_buf(9);
    $7c3b72a365cc0275$var$write_BIFF2Cell(out, r, c);
    $7c3b72a365cc0275$var$write_Bes(val, t || 'b', out);
    return out;
}
/* TODO: codepage, large strings */ function $7c3b72a365cc0275$var$write_BIFF2LABEL(r /*:number*/ , c /*:number*/ , val) {
    var out = $7c3b72a365cc0275$var$new_buf(8 + 2 * val.length);
    $7c3b72a365cc0275$var$write_BIFF2Cell(out, r, c);
    out.write_shift(1, val.length);
    out.write_shift(val.length, val, 'sbcs');
    return out.l < out.length ? out.slice(0, out.l) : out;
}
function $7c3b72a365cc0275$var$write_ws_biff2_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/  /*::, opts*/ ) {
    if (cell.v != null) switch(cell.t){
        case 'd':
        case 'n':
            var v = cell.t == 'd' ? $7c3b72a365cc0275$var$datenum($7c3b72a365cc0275$var$parseDate(cell.v)) : cell.v;
            if (v == (v | 0) && v >= 0 && v < 65536) $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0002, $7c3b72a365cc0275$var$write_BIFF2INT(R, C, v));
            else $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0003, $7c3b72a365cc0275$var$write_BIFF2NUM(R, C, v));
            return;
        case 'b':
        case 'e':
            $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0005, $7c3b72a365cc0275$var$write_BIFF2BERR(R, C, cell.v, cell.t));
            return;
        /* TODO: codepage, sst */ case 's':
        case 'str':
            $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0004, $7c3b72a365cc0275$var$write_BIFF2LABEL(R, C, (cell.v || "").slice(0, 255)));
            return;
    }
    $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0001, $7c3b72a365cc0275$var$write_BIFF2Cell(null, R, C));
}
function $7c3b72a365cc0275$var$write_ws_biff2(ba /*:BufArray*/ , ws /*:Worksheet*/ , idx /*:number*/ , opts /*::, wb:Workbook*/ ) {
    var dense = Array.isArray(ws);
    var range = $7c3b72a365cc0275$var$safe_decode_range(ws['!ref'] || "A1"), ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    if (range.e.c > 0xFF || range.e.r > 0x3FFF) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.c, 0x3FFF);
        ref = $7c3b72a365cc0275$var$encode_range(range);
    }
    for(var R = range.s.r; R <= range.e.r; ++R){
        rr = $7c3b72a365cc0275$var$encode_row(R);
        for(var C = range.s.c; C <= range.e.c; ++C){
            if (R === range.s.r) cols[C] = $7c3b72a365cc0275$var$encode_col(C);
            ref = cols[C] + rr;
            var cell = dense ? (ws[R] || [])[C] : ws[ref];
            if (!cell) continue;
            /* write cell */ $7c3b72a365cc0275$var$write_ws_biff2_cell(ba, cell, R, C, opts);
        }
    }
}
/* Based on test files */ function $7c3b72a365cc0275$var$write_biff2_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    if ($7c3b72a365cc0275$var$DENSE != null && o.dense == null) o.dense = $7c3b72a365cc0275$var$DENSE;
    var ba = $7c3b72a365cc0275$var$buf_array();
    var idx = 0;
    for(var i = 0; i < wb.SheetNames.length; ++i)if (wb.SheetNames[i] == o.sheet) idx = i;
    if (idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
    $7c3b72a365cc0275$var$write_biff_rec(ba, o.biff == 4 ? 0x0409 : o.biff == 3 ? 0x0209 : 0x0009, $7c3b72a365cc0275$var$write_BOF(wb, 0x10, o));
    /* ... */ $7c3b72a365cc0275$var$write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
    /* ... */ $7c3b72a365cc0275$var$write_biff_rec(ba, 0x000A);
    return ba.end();
}
function $7c3b72a365cc0275$var$write_FONTS_biff8(ba, data, opts) {
    $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0031 /* Font */ , $7c3b72a365cc0275$var$write_Font({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Arial",
        family: 2,
        scheme: "minor"
    }, opts));
}
function $7c3b72a365cc0275$var$write_FMTS_biff8(ba, NF /*:?SSFTable*/ , opts) {
    if (!NF) return;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $7c3b72a365cc0275$var$write_biff_rec(ba, 0x041E /* Format */ , $7c3b72a365cc0275$var$write_Format(i, NF[i], opts));
    });
}
function $7c3b72a365cc0275$var$write_FEAT(ba, ws) {
    /* [MS-XLS] 2.4.112 */ var o = $7c3b72a365cc0275$var$new_buf(19);
    o.write_shift(4, 0x867);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 1);
    o.write_shift(4, 0);
    $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0867 /* FeatHdr */ , o);
    /* [MS-XLS] 2.4.111 */ o = $7c3b72a365cc0275$var$new_buf(39);
    o.write_shift(4, 0x868);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 1);
    o.write_shift(4, 4);
    o.write_shift(2, 0);
    $7c3b72a365cc0275$var$write_Ref8U($7c3b72a365cc0275$var$safe_decode_range(ws['!ref'] || "A1"), o);
    o.write_shift(4, 4);
    $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0868 /* Feat */ , o);
}
function $7c3b72a365cc0275$var$write_CELLXFS_biff8(ba, opts) {
    for(var i = 0; i < 16; ++i)$7c3b72a365cc0275$var$write_biff_rec(ba, 0x00e0 /* XF */ , $7c3b72a365cc0275$var$write_XF({
        numFmtId: 0,
        style: true
    }, 0, opts));
    opts.cellXfs.forEach(function(c) {
        $7c3b72a365cc0275$var$write_biff_rec(ba, 0x00e0 /* XF */ , $7c3b72a365cc0275$var$write_XF(c, 0, opts));
    });
}
function $7c3b72a365cc0275$var$write_ws_biff8_hlinks(ba /*:BufArray*/ , ws) {
    for(var R = 0; R < ws['!links'].length; ++R){
        var HL = ws['!links'][R];
        $7c3b72a365cc0275$var$write_biff_rec(ba, 0x01b8 /* HLink */ , $7c3b72a365cc0275$var$write_HLink(HL));
        if (HL[1].Tooltip) $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0800 /* HLinkTooltip */ , $7c3b72a365cc0275$var$write_HLinkTooltip(HL));
    }
    delete ws['!links'];
}
function $7c3b72a365cc0275$var$write_ws_cols_biff8(ba, cols) {
    if (!cols) return;
    var cnt = 0;
    cols.forEach(function(col, idx) {
        if (++cnt <= 256 && col) $7c3b72a365cc0275$var$write_biff_rec(ba, 0x007d /* ColInfo */ , $7c3b72a365cc0275$var$write_ColInfo($7c3b72a365cc0275$var$col_obj_w(idx, col), idx));
    });
}
function $7c3b72a365cc0275$var$write_ws_biff8_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts) {
    var os = 16 + $7c3b72a365cc0275$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.v == null && !cell.bf) {
        $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0201 /* Blank */ , $7c3b72a365cc0275$var$write_XLSCell(R, C, os));
        return;
    }
    if (cell.bf) $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0006 /* Formula */ , $7c3b72a365cc0275$var$write_Formula(cell, R, C, opts, os));
    else switch(cell.t){
        case 'd':
        case 'n':
            var v = cell.t == 'd' ? $7c3b72a365cc0275$var$datenum($7c3b72a365cc0275$var$parseDate(cell.v)) : cell.v;
            /* TODO: emit RK as appropriate */ $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0203 /* Number */ , $7c3b72a365cc0275$var$write_Number(R, C, v, os, opts));
            break;
        case 'b':
        case 'e':
            $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $7c3b72a365cc0275$var$write_BoolErr(R, C, cell.v, os, opts, cell.t));
            break;
        /* TODO: codepage, sst */ case 's':
        case 'str':
            if (opts.bookSST) {
                var isst = $7c3b72a365cc0275$var$get_sst_id(opts.Strings, cell.v, opts.revStrings);
                $7c3b72a365cc0275$var$write_biff_rec(ba, 0x00fd /* LabelSst */ , $7c3b72a365cc0275$var$write_LabelSst(R, C, isst, os, opts));
            } else $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0204 /* Label */ , $7c3b72a365cc0275$var$write_Label(R, C, (cell.v || "").slice(0, 255), os, opts));
            break;
        default:
            $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0201 /* Blank */ , $7c3b72a365cc0275$var$write_XLSCell(R, C, os));
    }
}
/* [MS-XLS] 2.1.7.20.5 */ function $7c3b72a365cc0275$var$write_ws_biff8(idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var ba = $7c3b72a365cc0275$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheet /*:WBWSProp*/  = (_WB.Sheets || [])[idx] || {} /*:any*/ ;
    var dense = Array.isArray(ws);
    var b8 = opts.biff == 8;
    var ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    var range = $7c3b72a365cc0275$var$safe_decode_range(ws['!ref'] || "A1");
    var MAX_ROWS = b8 ? 65536 : 16384;
    if (range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.c, MAX_ROWS - 1);
    }
    $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0809, $7c3b72a365cc0275$var$write_BOF(wb, 0x10, opts));
    /* [Uncalced] Index */ $7c3b72a365cc0275$var$write_biff_rec(ba, 0x000d /* CalcMode */ , $7c3b72a365cc0275$var$writeuint16(1));
    $7c3b72a365cc0275$var$write_biff_rec(ba, 0x000c /* CalcCount */ , $7c3b72a365cc0275$var$writeuint16(100));
    $7c3b72a365cc0275$var$write_biff_rec(ba, 0x000f /* CalcRefMode */ , $7c3b72a365cc0275$var$writebool(true));
    $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0011 /* CalcIter */ , $7c3b72a365cc0275$var$writebool(false));
    $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0010 /* CalcDelta */ , $7c3b72a365cc0275$var$write_Xnum(0.001));
    $7c3b72a365cc0275$var$write_biff_rec(ba, 0x005f /* CalcSaveRecalc */ , $7c3b72a365cc0275$var$writebool(true));
    $7c3b72a365cc0275$var$write_biff_rec(ba, 0x002a /* PrintRowCol */ , $7c3b72a365cc0275$var$writebool(false));
    $7c3b72a365cc0275$var$write_biff_rec(ba, 0x002b /* PrintGrid */ , $7c3b72a365cc0275$var$writebool(false));
    $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0082 /* GridSet */ , $7c3b72a365cc0275$var$writeuint16(1));
    $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0080 /* Guts */ , $7c3b72a365cc0275$var$write_Guts([
        0,
        0
    ]));
    /* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */ /* Header (string) */ /* Footer (string) */ $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0083 /* HCenter */ , $7c3b72a365cc0275$var$writebool(false));
    $7c3b72a365cc0275$var$write_biff_rec(ba, 0x0084 /* VCenter */ , $7c3b72a365cc0275$var$writebool(false));
    /* ... */ if (b8) $7c3b72a365cc0275$var$write_ws_cols_biff8(ba, ws["!cols"]);
    /* ... */ $7c3b72a365cc0275$var$write_biff_rec(ba, 0x200, $7c3b72a365cc0275$var$write_Dimensions(range, opts));
    /* ... */ if (b8) ws['!links'] = [];
    for(var R = range.s.r; R <= range.e.r; ++R){
        rr = $7c3b72a365cc0275$var$encode_row(R);
        for(var C = range.s.c; C <= range.e.c; ++C){
            if (R === range.s.r) cols[C] = $7c3b72a365cc0275$var$encode_col(C);
            ref = cols[C] + rr;
            var cell = dense ? (ws[R] || [])[C] : ws[ref];
            if (!cell) continue;
            /* write cell */ $7c3b72a365cc0275$var$write_ws_biff8_cell(ba, cell, R, C, opts);
            if (b8 && cell.l) ws['!links'].push([
                ref,
                cell.l
            ]);
        }
    }
    var cname /*:string*/  = _sheet.CodeName || _sheet.name || s;
    /* ... */ if (b8) $7c3b72a365cc0275$var$write_biff_rec(ba, 0x023e /* Window2 */ , $7c3b72a365cc0275$var$write_Window2((_WB.Views || [])[0]));
    /* ... */ if (b8 && (ws['!merges'] || []).length) $7c3b72a365cc0275$var$write_biff_rec(ba, 0x00e5 /* MergeCells */ , $7c3b72a365cc0275$var$write_MergeCells(ws['!merges']));
    /* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */ if (b8) $7c3b72a365cc0275$var$write_ws_biff8_hlinks(ba, ws);
    /* [DVAL] */ $7c3b72a365cc0275$var$write_biff_rec(ba, 0x01ba /* CodeName */ , $7c3b72a365cc0275$var$write_XLUnicodeString(cname, opts));
    /* *WebPub *CellWatch [SheetExt] */ if (b8) $7c3b72a365cc0275$var$write_FEAT(ba, ws);
    /* *FEAT11 *RECORD12 */ $7c3b72a365cc0275$var$write_biff_rec(ba, 0x000a /* EOF */ );
    return ba.end();
}
/* [MS-XLS] 2.1.7.20.3 */ function $7c3b72a365cc0275$var$write_biff8_global(wb /*:Workbook*/ , bufs, opts /*:WriteOpts*/ ) {
    var A = $7c3b72a365cc0275$var$buf_array();
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheets /*:Array<WBWSProp>*/  = _WB.Sheets || [];
    var _wb /*:WBProps*/  = /*::((*/ _WB.WBProps || {} /*:: ):any)*/ ;
    var b8 = opts.biff == 8, b5 = opts.biff == 5;
    $7c3b72a365cc0275$var$write_biff_rec(A, 0x0809, $7c3b72a365cc0275$var$write_BOF(wb, 0x05, opts));
    if (opts.bookType == "xla") $7c3b72a365cc0275$var$write_biff_rec(A, 0x0087 /* Addin */ );
    $7c3b72a365cc0275$var$write_biff_rec(A, 0x00e1 /* InterfaceHdr */ , b8 ? $7c3b72a365cc0275$var$writeuint16(0x04b0) : null);
    $7c3b72a365cc0275$var$write_biff_rec(A, 0x00c1 /* Mms */ , $7c3b72a365cc0275$var$writezeroes(2));
    if (b5) $7c3b72a365cc0275$var$write_biff_rec(A, 0x00bf /* ToolbarHdr */ );
    if (b5) $7c3b72a365cc0275$var$write_biff_rec(A, 0x00c0 /* ToolbarEnd */ );
    $7c3b72a365cc0275$var$write_biff_rec(A, 0x00e2 /* InterfaceEnd */ );
    $7c3b72a365cc0275$var$write_biff_rec(A, 0x005c /* WriteAccess */ , $7c3b72a365cc0275$var$write_WriteAccess("SheetJS", opts));
    /* [FileSharing] */ $7c3b72a365cc0275$var$write_biff_rec(A, 0x0042 /* CodePage */ , $7c3b72a365cc0275$var$writeuint16(b8 ? 0x04b0 : 0x04E4));
    /* *2047 Lel */ if (b8) $7c3b72a365cc0275$var$write_biff_rec(A, 0x0161 /* DSF */ , $7c3b72a365cc0275$var$writeuint16(0));
    if (b8) $7c3b72a365cc0275$var$write_biff_rec(A, 0x01c0 /* Excel9File */ );
    $7c3b72a365cc0275$var$write_biff_rec(A, 0x013d /* RRTabId */ , $7c3b72a365cc0275$var$write_RRTabId(wb.SheetNames.length));
    if (b8 && wb.vbaraw) $7c3b72a365cc0275$var$write_biff_rec(A, 0x00d3 /* ObProj */ );
    /* [ObNoMacros] */ if (b8 && wb.vbaraw) {
        var cname /*:string*/  = _wb.CodeName || "ThisWorkbook";
        $7c3b72a365cc0275$var$write_biff_rec(A, 0x01ba /* CodeName */ , $7c3b72a365cc0275$var$write_XLUnicodeString(cname, opts));
    }
    $7c3b72a365cc0275$var$write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */ , $7c3b72a365cc0275$var$writeuint16(0x11));
    /* *FnGroupName *FnGrp12 */ /* *Lbl */ /* [OleObjectSize] */ $7c3b72a365cc0275$var$write_biff_rec(A, 0x0019 /* WinProtect */ , $7c3b72a365cc0275$var$writebool(false));
    $7c3b72a365cc0275$var$write_biff_rec(A, 0x0012 /* Protect */ , $7c3b72a365cc0275$var$writebool(false));
    $7c3b72a365cc0275$var$write_biff_rec(A, 0x0013 /* Password */ , $7c3b72a365cc0275$var$writeuint16(0));
    if (b8) $7c3b72a365cc0275$var$write_biff_rec(A, 0x01af /* Prot4Rev */ , $7c3b72a365cc0275$var$writebool(false));
    if (b8) $7c3b72a365cc0275$var$write_biff_rec(A, 0x01bc /* Prot4RevPass */ , $7c3b72a365cc0275$var$writeuint16(0));
    $7c3b72a365cc0275$var$write_biff_rec(A, 0x003d /* Window1 */ , $7c3b72a365cc0275$var$write_Window1(opts));
    $7c3b72a365cc0275$var$write_biff_rec(A, 0x0040 /* Backup */ , $7c3b72a365cc0275$var$writebool(false));
    $7c3b72a365cc0275$var$write_biff_rec(A, 0x008d /* HideObj */ , $7c3b72a365cc0275$var$writeuint16(0));
    $7c3b72a365cc0275$var$write_biff_rec(A, 0x0022 /* Date1904 */ , $7c3b72a365cc0275$var$writebool($7c3b72a365cc0275$var$safe1904(wb) == "true"));
    $7c3b72a365cc0275$var$write_biff_rec(A, 0x000e /* CalcPrecision */ , $7c3b72a365cc0275$var$writebool(true));
    if (b8) $7c3b72a365cc0275$var$write_biff_rec(A, 0x01b7 /* RefreshAll */ , $7c3b72a365cc0275$var$writebool(false));
    $7c3b72a365cc0275$var$write_biff_rec(A, 0x00DA /* BookBool */ , $7c3b72a365cc0275$var$writeuint16(0));
    /* ... */ $7c3b72a365cc0275$var$write_FONTS_biff8(A, wb, opts);
    $7c3b72a365cc0275$var$write_FMTS_biff8(A, wb.SSF, opts);
    $7c3b72a365cc0275$var$write_CELLXFS_biff8(A, opts);
    /* ... */ if (b8) $7c3b72a365cc0275$var$write_biff_rec(A, 0x0160 /* UsesELFs */ , $7c3b72a365cc0275$var$writebool(false));
    var a = A.end();
    var C = $7c3b72a365cc0275$var$buf_array();
    /* METADATA [MTRSettings] [ForceFullCalculation] */ if (b8) $7c3b72a365cc0275$var$write_biff_rec(C, 0x008C, $7c3b72a365cc0275$var$write_Country());
    /* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */ /* BIFF8: [SST *Continue] ExtSST */ if (b8 && opts.Strings) $7c3b72a365cc0275$var$write_biff_continue(C, 0x00FC, $7c3b72a365cc0275$var$write_SST(opts.Strings, opts));
    /* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */ $7c3b72a365cc0275$var$write_biff_rec(C, 0x000A /* EOF */ );
    var c = C.end();
    var B = $7c3b72a365cc0275$var$buf_array();
    var blen = 0, j = 0;
    for(j = 0; j < wb.SheetNames.length; ++j)blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
    var start = a.length + blen + c.length;
    for(j = 0; j < wb.SheetNames.length; ++j){
        var _sheet /*:WBWSProp*/  = _sheets[j] || {} /*:any*/ ;
        $7c3b72a365cc0275$var$write_biff_rec(B, 0x0085 /* BoundSheet8 */ , $7c3b72a365cc0275$var$write_BoundSheet8({
            pos: start,
            hs: _sheet.Hidden || 0,
            dt: 0,
            name: wb.SheetNames[j]
        }, opts));
        start += bufs[j].length;
    }
    /* 1*BoundSheet8 */ var b = B.end();
    if (blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
    var out = [];
    if (a.length) out.push(a);
    if (b.length) out.push(b);
    if (c.length) out.push(c);
    return $7c3b72a365cc0275$var$bconcat(out);
}
/* [MS-XLS] 2.1.7.20 Workbook Stream */ function $7c3b72a365cc0275$var$write_biff8_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var bufs = [];
    if (wb && !wb.SSF) wb.SSF = $7c3b72a365cc0275$var$dup($7c3b72a365cc0275$var$table_fmt);
    if (wb && wb.SSF) {
        $7c3b72a365cc0275$var$make_ssf();
        $7c3b72a365cc0275$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        o.revssf = $7c3b72a365cc0275$var$evert_num(wb.SSF);
        o.revssf[wb.SSF[65535]] = 0;
        o.ssf = wb.SSF;
    }
    o.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    o.Strings.Count = 0;
    o.Strings.Unique = 0;
    $7c3b72a365cc0275$var$fix_write_opts(o);
    o.cellXfs = [];
    $7c3b72a365cc0275$var$get_cell_style(o.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    for(var i = 0; i < wb.SheetNames.length; ++i)bufs[bufs.length] = $7c3b72a365cc0275$var$write_ws_biff8(i, o, wb);
    bufs.unshift($7c3b72a365cc0275$var$write_biff8_global(wb, bufs, o));
    return $7c3b72a365cc0275$var$bconcat(bufs);
}
function $7c3b72a365cc0275$var$write_biff_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    for(var i = 0; i <= wb.SheetNames.length; ++i){
        var ws = wb.Sheets[wb.SheetNames[i]];
        if (!ws || !ws["!ref"]) continue;
        var range = $7c3b72a365cc0275$var$decode_range(ws["!ref"]);
        if (range.e.c > 255) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
        }
    }
    var o = opts || {};
    switch(o.biff || 2){
        case 8:
        case 5:
            return $7c3b72a365cc0275$var$write_biff8_buf(wb, opts);
        case 4:
        case 3:
        case 2:
            return $7c3b72a365cc0275$var$write_biff2_buf(wb, opts);
    }
    throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */ function $7c3b72a365cc0275$var$html_to_sheet(str /*:string*/ , _opts) /*:Workbook*/ {
    var opts = _opts || {};
    if ($7c3b72a365cc0275$var$DENSE != null && opts.dense == null) opts.dense = $7c3b72a365cc0275$var$DENSE;
    var ws /*:Worksheet*/  = opts.dense ? [] : {} /*:any*/ ;
    str = str.replace(/<!--.*?-->/g, "");
    var mtch /*:any*/  = str.match(/<table/i);
    if (!mtch) throw new Error("Invalid HTML: could not find <table>");
    var mtch2 /*:any*/  = str.match(/<\/table/i);
    var i /*:number*/  = mtch.index, j /*:number*/  = mtch2 && mtch2.index || str.length;
    var rows = $7c3b72a365cc0275$var$split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
    var R = -1, C = 0, RS = 0, CS = 0;
    var range /*:Range*/  = {
        s: {
            r: 10000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var merges /*:Array<Range>*/  = [];
    for(i = 0; i < rows.length; ++i){
        var row = rows[i].trim();
        var hd = row.slice(0, 3).toLowerCase();
        if (hd == "<tr") {
            ++R;
            if (opts.sheetRows && opts.sheetRows <= R) {
                --R;
                break;
            }
            C = 0;
            continue;
        }
        if (hd != "<td" && hd != "<th") continue;
        var cells = row.split(/<\/t[dh]>/i);
        for(j = 0; j < cells.length; ++j){
            var cell = cells[j].trim();
            if (!cell.match(/<t[dh]/i)) continue;
            var m = cell, cc = 0;
            /* TODO: parse styles etc */ while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1)m = m.slice(cc + 1);
            for(var midx = 0; midx < merges.length; ++midx){
                var _merge /*:Range*/  = merges[midx];
                if (_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) {
                    C = _merge.e.c + 1;
                    midx = -1;
                }
            }
            var tag = $7c3b72a365cc0275$var$parsexmltag(cell.slice(0, cell.indexOf(">")));
            CS = tag.colspan ? +tag.colspan : 1;
            if ((RS = +tag.rowspan) > 1 || CS > 1) merges.push({
                s: {
                    r: R,
                    c: C
                },
                e: {
                    r: R + (RS || 1) - 1,
                    c: C + CS - 1
                }
            });
            var _t /*:string*/  = tag.t || tag["data-t"] || "";
            /* TODO: generate stub cells */ if (!m.length) {
                C += CS;
                continue;
            }
            m = $7c3b72a365cc0275$var$htmldecode(m);
            if (range.s.r > R) range.s.r = R;
            if (range.e.r < R) range.e.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.c < C) range.e.c = C;
            if (!m.length) {
                C += CS;
                continue;
            }
            var o /*:Cell*/  = {
                t: 's',
                v: m
            };
            if (opts.raw || !m.trim().length || _t == 's') ;
            else if (m === 'TRUE') o = {
                t: 'b',
                v: true
            };
            else if (m === 'FALSE') o = {
                t: 'b',
                v: false
            };
            else if (!isNaN($7c3b72a365cc0275$var$fuzzynum(m))) o = {
                t: 'n',
                v: $7c3b72a365cc0275$var$fuzzynum(m)
            };
            else if (!isNaN($7c3b72a365cc0275$var$fuzzydate(m).getDate())) {
                o = {
                    t: 'd',
                    v: $7c3b72a365cc0275$var$parseDate(m)
                } /*:any*/ ;
                if (!opts.cellDates) o = {
                    t: 'n',
                    v: $7c3b72a365cc0275$var$datenum(o.v)
                } /*:any*/ ;
                o.z = opts.dateNF || $7c3b72a365cc0275$var$table_fmt[14];
            }
            if (opts.dense) {
                if (!ws[R]) ws[R] = [];
                ws[R][C] = o;
            } else ws[$7c3b72a365cc0275$var$encode_cell({
                r: R,
                c: C
            })] = o;
            C += CS;
        }
    }
    ws['!ref'] = $7c3b72a365cc0275$var$encode_range(range);
    if (merges.length) ws["!merges"] = merges;
    return ws;
}
function $7c3b72a365cc0275$var$make_html_row(ws /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var M /*:Array<Range>*/  = ws['!merges'] || [];
    var oo /*:Array<string>*/  = [];
    for(var C = r.s.c; C <= r.e.c; ++C){
        var RS = 0, CS = 0;
        for(var j = 0; j < M.length; ++j){
            if (M[j].s.r > R || M[j].s.c > C) continue;
            if (M[j].e.r < R || M[j].e.c < C) continue;
            if (M[j].s.r < R || M[j].s.c < C) {
                RS = -1;
                break;
            }
            RS = M[j].e.r - M[j].s.r + 1;
            CS = M[j].e.c - M[j].s.c + 1;
            break;
        }
        if (RS < 0) continue;
        var coord = $7c3b72a365cc0275$var$encode_cell({
            r: R,
            c: C
        });
        var cell = o.dense ? (ws[R] || [])[C] : ws[coord];
        /* TODO: html entities */ var w = cell && cell.v != null && (cell.h || $7c3b72a365cc0275$var$escapehtml(cell.w || ($7c3b72a365cc0275$var$format_cell(cell), cell.w) || "")) || "";
        var sp = {} /*:any*/ ;
        if (RS > 1) sp.rowspan = RS;
        if (CS > 1) sp.colspan = CS;
        if (o.editable) w = '<span contenteditable="true">' + w + '</span>';
        else if (cell) {
            sp["data-t"] = cell && cell.t || 'z';
            if (cell.v != null) sp["data-v"] = cell.v;
            if (cell.z != null) sp["data-z"] = cell.z;
            if (cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + cell.l.Target + '">' + w + '</a>';
        }
        sp.id = (o.id || "sjs") + "-" + coord;
        oo.push($7c3b72a365cc0275$var$writextag('td', w, sp));
    }
    var preamble = "<tr>";
    return preamble + oo.join("") + "</tr>";
}
var $7c3b72a365cc0275$var$HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
var $7c3b72a365cc0275$var$HTML_END = '</body></html>';
function $7c3b72a365cc0275$var$html_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
    var mtch = str.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
    if (!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
    if (mtch.length == 1) return $7c3b72a365cc0275$var$sheet_to_workbook($7c3b72a365cc0275$var$html_to_sheet(mtch[0], opts), opts);
    var wb = $7c3b72a365cc0275$var$book_new();
    mtch.forEach(function(s, idx) {
        $7c3b72a365cc0275$var$book_append_sheet(wb, $7c3b72a365cc0275$var$html_to_sheet(s, opts), "Sheet" + (idx + 1));
    });
    return wb;
}
function $7c3b72a365cc0275$var$make_html_preamble(ws /*:Worksheet*/ , R /*:Range*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
}
function $7c3b72a365cc0275$var$sheet_to_html(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/  /*, wb:?Workbook*/ ) /*:string*/ {
    var o = opts || {};
    var header = o.header != null ? o.header : $7c3b72a365cc0275$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $7c3b72a365cc0275$var$HTML_END;
    var out /*:Array<string>*/  = [
        header
    ];
    var r = $7c3b72a365cc0275$var$decode_range(ws['!ref']);
    o.dense = Array.isArray(ws);
    out.push($7c3b72a365cc0275$var$make_html_preamble(ws, r, o));
    for(var R = r.s.r; R <= r.e.r; ++R)out.push($7c3b72a365cc0275$var$make_html_row(ws, r, R, o));
    out.push("</table>" + footer);
    return out.join("");
}
function $7c3b72a365cc0275$var$sheet_add_dom(ws /*:Worksheet*/ , table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var opts = _opts || {};
    if ($7c3b72a365cc0275$var$DENSE != null) opts.dense = $7c3b72a365cc0275$var$DENSE;
    var or_R = 0, or_C = 0;
    if (opts.origin != null) {
        if (typeof opts.origin == 'number') or_R = opts.origin;
        else {
            var _origin /*:CellAddress*/  = typeof opts.origin == "string" ? $7c3b72a365cc0275$var$decode_cell(opts.origin) : opts.origin;
            or_R = _origin.r;
            or_C = _origin.c;
        }
    }
    var rows /*:HTMLCollection<HTMLTableRowElement>*/  = table.getElementsByTagName('tr');
    var sheetRows = Math.min(opts.sheetRows || 10000000, rows.length);
    var range /*:Range*/  = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: or_R,
            c: or_C
        }
    };
    if (ws["!ref"]) {
        var _range /*:Range*/  = $7c3b72a365cc0275$var$decode_range(ws["!ref"]);
        range.s.r = Math.min(range.s.r, _range.s.r);
        range.s.c = Math.min(range.s.c, _range.s.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        range.e.c = Math.max(range.e.c, _range.e.c);
        if (or_R == -1) range.e.r = or_R = _range.e.r + 1;
    }
    var merges /*:Array<Range>*/  = [], midx = 0;
    var rowinfo /*:Array<RowInfo>*/  = ws["!rows"] || (ws["!rows"] = []);
    var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
    if (!ws["!cols"]) ws['!cols'] = [];
    for(; _R < rows.length && R < sheetRows; ++_R){
        var row /*:HTMLTableRowElement*/  = rows[_R];
        if ($7c3b72a365cc0275$var$is_dom_element_hidden(row)) {
            if (opts.display) continue;
            rowinfo[R] = {
                hidden: true
            };
        }
        var elts /*:HTMLCollection<HTMLTableCellElement>*/  = row.children /*:any*/ ;
        for(_C = C = 0; _C < elts.length; ++_C){
            var elt /*:HTMLTableCellElement*/  = elts[_C];
            if (opts.display && $7c3b72a365cc0275$var$is_dom_element_hidden(elt)) continue;
            var v /*:?string*/  = elt.hasAttribute('data-v') ? elt.getAttribute('data-v') : elt.hasAttribute('v') ? elt.getAttribute('v') : $7c3b72a365cc0275$var$htmldecode(elt.innerHTML);
            var z /*:?string*/  = elt.getAttribute('data-z') || elt.getAttribute('z');
            for(midx = 0; midx < merges.length; ++midx){
                var m /*:Range*/  = merges[midx];
                if (m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) {
                    C = m.e.c + 1 - or_C;
                    midx = -1;
                }
            }
            /* TODO: figure out how to extract nonstandard mso- style */ CS = +elt.getAttribute("colspan") || 1;
            if ((RS = +elt.getAttribute("rowspan") || 1) > 1 || CS > 1) merges.push({
                s: {
                    r: R + or_R,
                    c: C + or_C
                },
                e: {
                    r: R + or_R + (RS || 1) - 1,
                    c: C + or_C + (CS || 1) - 1
                }
            });
            var o /*:Cell*/  = {
                t: 's',
                v: v
            };
            var _t /*:string*/  = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
            if (v != null) {
                if (v.length == 0) o.t = _t || 'z';
                else if (opts.raw || v.trim().length == 0 || _t == "s") ;
                else if (v === 'TRUE') o = {
                    t: 'b',
                    v: true
                };
                else if (v === 'FALSE') o = {
                    t: 'b',
                    v: false
                };
                else if (!isNaN($7c3b72a365cc0275$var$fuzzynum(v))) o = {
                    t: 'n',
                    v: $7c3b72a365cc0275$var$fuzzynum(v)
                };
                else if (!isNaN($7c3b72a365cc0275$var$fuzzydate(v).getDate())) {
                    o = {
                        t: 'd',
                        v: $7c3b72a365cc0275$var$parseDate(v)
                    } /*:any*/ ;
                    if (!opts.cellDates) o = {
                        t: 'n',
                        v: $7c3b72a365cc0275$var$datenum(o.v)
                    } /*:any*/ ;
                    o.z = opts.dateNF || $7c3b72a365cc0275$var$table_fmt[14];
                }
            }
            if (o.z === undefined && z != null) o.z = z;
            /* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */ var l = "", Aelts = elt.getElementsByTagName("A");
            if (Aelts && Aelts.length) {
                for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)if (Aelts[Aelti].hasAttribute("href")) {
                    l = Aelts[Aelti].getAttribute("href");
                    if (l.charAt(0) != "#") break;
                }
            }
            if (l && l.charAt(0) != "#") o.l = {
                Target: l
            };
            if (opts.dense) {
                if (!ws[R + or_R]) ws[R + or_R] = [];
                ws[R + or_R][C + or_C] = o;
            } else ws[$7c3b72a365cc0275$var$encode_cell({
                c: C + or_C,
                r: R + or_R
            })] = o;
            if (range.e.c < C + or_C) range.e.c = C + or_C;
            C += CS;
        }
        ++R;
    }
    if (merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
    range.e.r = Math.max(range.e.r, R - 1 + or_R);
    ws['!ref'] = $7c3b72a365cc0275$var$encode_range(range);
    if (R >= sheetRows) ws['!fullref'] = $7c3b72a365cc0275$var$encode_range((range.e.r = rows.length - _R + R - 1 + or_R, range)); // We can count the real number of rows to parse but we don't to improve the performance
    return ws;
}
function $7c3b72a365cc0275$var$parse_dom_table(table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var opts = _opts || {};
    var ws /*:Worksheet*/  = opts.dense ? [] : {} /*:any*/ ;
    return $7c3b72a365cc0275$var$sheet_add_dom(ws, table, _opts);
}
function $7c3b72a365cc0275$var$table_to_book(table /*:HTMLElement*/ , opts /*:?any*/ ) /*:Workbook*/ {
    return $7c3b72a365cc0275$var$sheet_to_workbook($7c3b72a365cc0275$var$parse_dom_table(table, opts), opts);
}
function $7c3b72a365cc0275$var$is_dom_element_hidden(element /*:HTMLElement*/ ) /*:boolean*/ {
    var display /*:string*/  = '';
    var get_computed_style /*:?function*/  = $7c3b72a365cc0275$var$get_get_computed_style_function(element);
    if (get_computed_style) display = get_computed_style(element).getPropertyValue('display');
    if (!display) display = element.style && element.style.display;
    return display === 'none';
}
/* global getComputedStyle */ function $7c3b72a365cc0275$var$get_get_computed_style_function(element /*:HTMLElement*/ ) /*:?function*/ {
    // The proper getComputedStyle implementation is the one defined in the element window
    if (element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
    // If it is not available, try to get one from the global namespace
    if (typeof getComputedStyle === 'function') return getComputedStyle;
    return null;
}
/* OpenDocument */ function $7c3b72a365cc0275$var$parse_text_p(text /*:string*/  /*::, tag*/ ) /*:Array<any>*/ {
    /* 6.1.2 White Space Characters */ var fixed = text.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function($$, $1) {
        return Array(parseInt($1, 10) + 1).join(" ");
    }).replace(/<text:tab[^>]*\/>/g, "\t").replace(/<text:line-break\/>/g, "\n");
    var v = $7c3b72a365cc0275$var$unescapexml(fixed.replace(/<[^>]*>/g, ""));
    return [
        v
    ];
}
var $7c3b72a365cc0275$var$number_formats_ods = {
    /* ods name: [short ssf fmt, long ssf fmt] */ day: [
        "d",
        "dd"
    ],
    month: [
        "m",
        "mm"
    ],
    year: [
        "y",
        "yy"
    ],
    hours: [
        "h",
        "hh"
    ],
    minutes: [
        "m",
        "mm"
    ],
    seconds: [
        "s",
        "ss"
    ],
    "am-pm": [
        "A/P",
        "AM/PM"
    ],
    "day-of-week": [
        "ddd",
        "dddd"
    ],
    era: [
        "e",
        "ee"
    ],
    /* there is no native representation of LO "Q" format */ quarter: [
        "\\Qm",
        "m\\\"th quarter\""
    ]
};
function $7c3b72a365cc0275$var$parse_content_xml(d /*:string*/ , _opts) /*:Workbook*/ {
    var opts = _opts || {};
    if ($7c3b72a365cc0275$var$DENSE != null && opts.dense == null) opts.dense = $7c3b72a365cc0275$var$DENSE;
    var str = $7c3b72a365cc0275$var$xlml_normalize(d);
    var state /*:Array<any>*/  = [], tmp;
    var tag /*:: = {}*/ ;
    var NFtag = {
        name: ""
    }, NF = "", pidx = 0;
    var sheetag /*:: = {name:"", '名称':""}*/ ;
    var rowtag /*:: = {'行号':""}*/ ;
    var Sheets = {}, SheetNames /*:Array<string>*/  = [];
    var ws = opts.dense ? [] : {} /*:any*/ ;
    var Rn, q /*:: :any = ({t:"", v:null, z:null, w:"",c:[],}:any)*/ ;
    var ctag = {
        value: ""
    } /*:any*/ ;
    var textp = "", textpidx = 0, textptag /*:: = {}*/ ;
    var textR = [];
    var R = -1, C = -1, range = {
        s: {
            r: 1000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var row_ol = 0;
    var number_format_map = {};
    var merges /*:Array<Range>*/  = [], mrange = {}, mR = 0, mC = 0;
    var rowinfo /*:Array<RowInfo>*/  = [], rowpeat = 1, colpeat = 1;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var WB = {
        Names: []
    };
    var atag = {} /*:any*/ ;
    var _Ref /*:[string, string]*/  = [
        "",
        ""
    ];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var creator = "", creatoridx = 0;
    var isstub = false, intable = false;
    var i = 0;
    $7c3b72a365cc0275$var$xlmlregex.lastIndex = 0;
    str = str.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
    while(Rn = $7c3b72a365cc0275$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_.*$/, "")){
        case 'table':
        case "\u5DE5\u4F5C\u8868":
            if (Rn[1] === '/') {
                if (range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = $7c3b72a365cc0275$var$encode_range(range);
                else ws['!ref'] = "A1:A1";
                if (opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
                    ws['!fullref'] = ws['!ref'];
                    range.e.r = opts.sheetRows - 1;
                    ws['!ref'] = $7c3b72a365cc0275$var$encode_range(range);
                }
                if (merges.length) ws['!merges'] = merges;
                if (rowinfo.length) ws["!rows"] = rowinfo;
                sheetag.name = sheetag["\u540D\u79F0"] || sheetag.name;
                if (typeof JSON !== 'undefined') JSON.stringify(sheetag);
                SheetNames.push(sheetag.name);
                Sheets[sheetag.name] = ws;
                intable = false;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                sheetag = $7c3b72a365cc0275$var$parsexmltag(Rn[0], false);
                R = C = -1;
                range.s.r = range.s.c = 10000000;
                range.e.r = range.e.c = 0;
                ws = opts.dense ? [] : {} /*:any*/ ;
                merges = [];
                rowinfo = [];
                intable = true;
            }
            break;
        case 'table-row-group':
            if (Rn[1] === "/") --row_ol;
            else ++row_ol;
            break;
        case 'table-row':
        case "\u884C":
            if (Rn[1] === '/') {
                R += rowpeat;
                rowpeat = 1;
                break;
            }
            rowtag = $7c3b72a365cc0275$var$parsexmltag(Rn[0], false);
            if (rowtag["\u884C\u53F7"]) R = rowtag["\u884C\u53F7"] - 1;
            else if (R == -1) R = 0;
            rowpeat = +rowtag['number-rows-repeated'] || 1;
            /* TODO: remove magic */ if (rowpeat < 10) {
                for(i = 0; i < rowpeat; ++i)if (row_ol > 0) rowinfo[R + i] = {
                    level: row_ol
                };
            }
            C = -1;
            break;
        case 'covered-table-cell':
            if (Rn[1] !== '/') ++C;
            if (opts.sheetStubs) {
                if (opts.dense) {
                    if (!ws[R]) ws[R] = [];
                    ws[R][C] = {
                        t: 'z'
                    };
                } else ws[$7c3b72a365cc0275$var$encode_cell({
                    r: R,
                    c: C
                })] = {
                    t: 'z'
                };
            }
            textp = "";
            textR = [];
            break; /* stub */ 
        case 'table-cell':
        case "\u6570\u636E":
            if (Rn[0].charAt(Rn[0].length - 2) === '/') {
                ++C;
                ctag = $7c3b72a365cc0275$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                q = {
                    t: 'z',
                    v: null
                } /*:any*/ ;
                if (ctag.formula && opts.cellFormula != false) q.f = $7c3b72a365cc0275$var$ods_to_csf_formula($7c3b72a365cc0275$var$unescapexml(ctag.formula));
                if ((ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type']) == "string") {
                    q.t = "s";
                    q.v = $7c3b72a365cc0275$var$unescapexml(ctag['string-value'] || "");
                    if (opts.dense) {
                        if (!ws[R]) ws[R] = [];
                        ws[R][C] = q;
                    } else ws[$7c3b72a365cc0275$var$encode_cell({
                        r: R,
                        c: C
                    })] = q;
                }
                C += colpeat - 1;
            } else if (Rn[1] !== '/') {
                ++C;
                textp = "";
                textpidx = 0;
                textR = [];
                colpeat = 1;
                var rptR = rowpeat ? R + rowpeat - 1 : R;
                if (C > range.e.c) range.e.c = C;
                if (C < range.s.c) range.s.c = C;
                if (R < range.s.r) range.s.r = R;
                if (rptR > range.e.r) range.e.r = rptR;
                ctag = $7c3b72a365cc0275$var$parsexmltag(Rn[0], false);
                comments = [];
                comment = {} /*:any*/ ;
                q = {
                    t: ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type'],
                    v: null
                } /*:any*/ ;
                if (opts.cellFormula) {
                    if (ctag.formula) ctag.formula = $7c3b72a365cc0275$var$unescapexml(ctag.formula);
                    if (ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
                        mR = parseInt(ctag['number-matrix-rows-spanned'], 10) || 0;
                        mC = parseInt(ctag['number-matrix-columns-spanned'], 10) || 0;
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        q.F = $7c3b72a365cc0275$var$encode_range(mrange);
                        arrayf.push([
                            mrange,
                            q.F
                        ]);
                    }
                    if (ctag.formula) q.f = $7c3b72a365cc0275$var$ods_to_csf_formula(ctag.formula);
                    else for(i = 0; i < arrayf.length; ++i)if (R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r) {
                        if (C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c) q.F = arrayf[i][1];
                    }
                }
                if (ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
                    mR = parseInt(ctag['number-rows-spanned'], 10) || 0;
                    mC = parseInt(ctag['number-columns-spanned'], 10) || 0;
                    mrange = {
                        s: {
                            r: R,
                            c: C
                        },
                        e: {
                            r: R + mR - 1,
                            c: C + mC - 1
                        }
                    };
                    merges.push(mrange);
                }
                /* 19.675.2 table:number-columns-repeated */ if (ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);
                /* 19.385 office:value-type */ switch(q.t){
                    case 'boolean':
                        q.t = 'b';
                        q.v = $7c3b72a365cc0275$var$parsexmlbool(ctag['boolean-value']);
                        break;
                    case 'float':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'percentage':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'currency':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'date':
                        q.t = 'd';
                        q.v = $7c3b72a365cc0275$var$parseDate(ctag['date-value']);
                        if (!opts.cellDates) {
                            q.t = 'n';
                            q.v = $7c3b72a365cc0275$var$datenum(q.v);
                        }
                        q.z = 'm/d/yy';
                        break;
                    case 'time':
                        q.t = 'n';
                        q.v = $7c3b72a365cc0275$var$parse_isodur(ctag['time-value']) / 86400;
                        if (opts.cellDates) {
                            q.t = 'd';
                            q.v = $7c3b72a365cc0275$var$numdate(q.v);
                        }
                        q.z = 'HH:MM:SS';
                        break;
                    case 'number':
                        q.t = 'n';
                        q.v = parseFloat(ctag["\u6570\u636E\u6570\u503C"]);
                        break;
                    default:
                        if (q.t === 'string' || q.t === 'text' || !q.t) {
                            q.t = 's';
                            if (ctag['string-value'] != null) {
                                textp = $7c3b72a365cc0275$var$unescapexml(ctag['string-value']);
                                textR = [];
                            }
                        } else throw new Error('Unsupported value type ' + q.t);
                }
            } else {
                isstub = false;
                if (q.t === 's') {
                    q.v = textp || '';
                    if (textR.length) q.R = textR;
                    isstub = textpidx == 0;
                }
                if (atag.Target) q.l = atag;
                if (comments.length > 0) {
                    q.c = comments;
                    comments = [];
                }
                if (textp && opts.cellText !== false) q.w = textp;
                if (isstub) {
                    q.t = "z";
                    delete q.v;
                }
                if (!isstub || opts.sheetStubs) {
                    if (!(opts.sheetRows && opts.sheetRows <= R)) for(var rpt = 0; rpt < rowpeat; ++rpt){
                        colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                        if (opts.dense) {
                            if (!ws[R + rpt]) ws[R + rpt] = [];
                            ws[R + rpt][C] = rpt == 0 ? q : $7c3b72a365cc0275$var$dup(q);
                            while(--colpeat > 0)ws[R + rpt][C + colpeat] = $7c3b72a365cc0275$var$dup(q);
                        } else {
                            ws[$7c3b72a365cc0275$var$encode_cell({
                                r: R + rpt,
                                c: C
                            })] = q;
                            while(--colpeat > 0)ws[$7c3b72a365cc0275$var$encode_cell({
                                r: R + rpt,
                                c: C + colpeat
                            })] = $7c3b72a365cc0275$var$dup(q);
                        }
                        if (range.e.c <= C) range.e.c = C;
                    }
                }
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                C += colpeat - 1;
                colpeat = 0;
                q = {};
                textp = "";
                textR = [];
            }
            atag = {} /*:any*/ ;
            break; // 9.1.4 <table:table-cell>
        /* pure state */ case 'document':
        case 'document-content':
        case "\u7535\u5B50\u8868\u683C\u6587\u6863":
        case 'spreadsheet':
        case "\u4E3B\u4F53":
        case 'scripts':
        case 'styles':
        case 'font-face-decls':
        case 'master-styles':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'annotation':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
                comment.t = textp;
                if (textR.length) /*::(*/ comment /*:: :any)*/ .R = textR;
                comment.a = creator;
                comments.push(comment);
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                false
            ]);
            creator = "";
            creatoridx = 0;
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case 'creator':
            if (Rn[1] === '/') creator = str.slice(creatoridx, Rn.index);
            else creatoridx = Rn.index + Rn[0].length;
            break;
        /* ignore state */ case 'meta':
        case "\u5143\u6570\u636E":
        case 'settings':
        case 'config-item-set':
        case 'config-item-map-indexed':
        case 'config-item-map-entry':
        case 'config-item-map-named':
        case 'shapes':
        case 'frame':
        case 'text-box':
        case 'image':
        case 'data-pilot-tables':
        case 'list-style':
        case 'form':
        case 'dde-links':
        case 'event-listeners':
        case 'chart':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                false
            ]);
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case 'scientific-number':
            break;
        case 'currency-symbol':
            break;
        case 'currency-style':
            break;
        case 'number-style':
        case 'percentage-style':
        case 'date-style':
        case 'time-style':
            if (Rn[1] === '/') {
                number_format_map[NFtag.name] = NF;
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                NF = "";
                NFtag = $7c3b72a365cc0275$var$parsexmltag(Rn[0], false);
                state.push([
                    Rn[3],
                    true
                ]);
            }
            break;
        case 'script':
            break; // 3.13 <office:script>
        case 'libraries':
            break; // TODO: <ooo:libraries>
        case 'automatic-styles':
            break; // 3.15.3 <office:automatic-styles>
        case 'default-style':
        case 'page-layout':
            break; // TODO: <style:page-layout>
        case 'style':
            break;
        case 'map':
            break; // 16.3 <style:map>
        case 'font-face':
            break; // 16.21 <style:font-face>
        case 'paragraph-properties':
            break; // 17.6 <style:paragraph-properties>
        case 'table-properties':
            break; // 17.15 <style:table-properties>
        case 'table-column-properties':
            break; // 17.16 <style:table-column-properties>
        case 'table-row-properties':
            break; // 17.17 <style:table-row-properties>
        case 'table-cell-properties':
            break; // 17.18 <style:table-cell-properties>
        case 'number':
            switch(state[state.length - 1][0]){
                case 'time-style':
                case 'date-style':
                    tag = $7c3b72a365cc0275$var$parsexmltag(Rn[0], false);
                    NF += $7c3b72a365cc0275$var$number_formats_ods[Rn[3]][tag.style === 'long' ? 1 : 0];
                    break;
            }
            break;
        case 'fraction':
            break; // TODO 16.27.6 <number:fraction>
        case 'day':
        case 'month':
        case 'year':
        case 'era':
        case 'day-of-week':
        case 'week-of-year':
        case 'quarter':
        case 'hours':
        case 'minutes':
        case 'seconds':
        case 'am-pm':
            switch(state[state.length - 1][0]){
                case 'time-style':
                case 'date-style':
                    tag = $7c3b72a365cc0275$var$parsexmltag(Rn[0], false);
                    NF += $7c3b72a365cc0275$var$number_formats_ods[Rn[3]][tag.style === 'long' ? 1 : 0];
                    break;
            }
            break;
        case 'boolean-style':
            break; // 16.27.23 <number:boolean-style>
        case 'boolean':
            break; // 16.27.24 <number:boolean>
        case 'text-style':
            break; // 16.27.25 <number:text-style>
        case 'text':
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") switch(state[state.length - 1][0]){
                case 'number-style':
                case 'date-style':
                case 'time-style':
                    NF += str.slice(pidx, Rn.index);
                    break;
            }
            else pidx = Rn.index + Rn[0].length;
            break;
        case 'named-range':
            tag = $7c3b72a365cc0275$var$parsexmltag(Rn[0], false);
            _Ref = $7c3b72a365cc0275$var$ods_to_csf_3D(tag['cell-range-address']);
            var nrange = {
                Name: tag.name,
                Ref: _Ref[0] + '!' + _Ref[1]
            } /*:any*/ ;
            if (intable) nrange.Sheet = SheetNames.length;
            WB.Names.push(nrange);
            break;
        case 'text-content':
            break; // 16.27.27 <number:text-content>
        case 'text-properties':
            break; // 16.27.27 <style:text-properties>
        case 'embedded-text':
            break; // 16.27.4 <number:embedded-text>
        case 'body':
        case "\u7535\u5B50\u8868\u683C":
            break; // 3.3 16.9.6 19.726.3
        case 'forms':
            break; // 12.25.2 13.2
        case 'table-column':
            break; // 9.1.6 <table:table-column>
        case 'table-header-rows':
            break; // 9.1.7 <table:table-header-rows>
        case 'table-rows':
            break; // 9.1.12 <table:table-rows>
        /* TODO: outline levels */ case 'table-column-group':
            break; // 9.1.10 <table:table-column-group>
        case 'table-header-columns':
            break; // 9.1.11 <table:table-header-columns>
        case 'table-columns':
            break; // 9.1.12 <table:table-columns>
        case 'null-date':
            break; // 9.4.2 <table:null-date> TODO: date1904
        case 'graphic-properties':
            break; // 17.21 <style:graphic-properties>
        case 'calculation-settings':
            break; // 9.4.1 <table:calculation-settings>
        case 'named-expressions':
            break; // 9.4.11 <table:named-expressions>
        case 'label-range':
            break; // 9.4.9 <table:label-range>
        case 'label-ranges':
            break; // 9.4.10 <table:label-ranges>
        case 'named-expression':
            break; // 9.4.13 <table:named-expression>
        case 'sort':
            break; // 9.4.19 <table:sort>
        case 'sort-by':
            break; // 9.4.20 <table:sort-by>
        case 'sort-groups':
            break; // 9.4.22 <table:sort-groups>
        case 'tab':
            break; // 6.1.4 <text:tab>
        case 'line-break':
            break; // 6.1.5 <text:line-break>
        case 'span':
            break; // 6.1.7 <text:span>
        case 'p':
        case "\u6587\u672C\u4E32":
            if ([
                'master-styles'
            ].indexOf(state[state.length - 1][0]) > -1) break;
            if (Rn[1] === '/' && (!ctag || !ctag['string-value'])) {
                var ptp = $7c3b72a365cc0275$var$parse_text_p(str.slice(textpidx, Rn.index), textptag);
                textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
            } else {
                textptag = $7c3b72a365cc0275$var$parsexmltag(Rn[0], false);
                textpidx = Rn.index + Rn[0].length;
            }
            break; // <text:p>
        case 's':
            break; // <text:s>
        case 'database-range':
            if (Rn[1] === '/') break;
            try {
                _Ref = $7c3b72a365cc0275$var$ods_to_csf_3D($7c3b72a365cc0275$var$parsexmltag(Rn[0])['target-range-address']);
                Sheets[_Ref[0]]['!autofilter'] = {
                    ref: _Ref[1]
                };
            } catch (e) {}
            break;
        case 'date':
            break; // <*:date>
        case 'object':
            break; // 10.4.6.2 <draw:object>
        case 'title':
        case "\u6807\u9898":
            break; // <*:title> OR <uof:标题>
        case 'desc':
            break; // <*:desc>
        case 'binary-data':
            break; // 10.4.5 TODO: b64 blob
        /* 9.2 Advanced Tables */ case 'table-source':
            break; // 9.2.6
        case 'scenario':
            break; // 9.2.6
        case 'iteration':
            break; // 9.4.3 <table:iteration>
        case 'content-validations':
            break; // 9.4.4 <table:
        case 'content-validation':
            break; // 9.4.5 <table:
        case 'help-message':
            break; // 9.4.6 <table:
        case 'error-message':
            break; // 9.4.7 <table:
        case 'database-ranges':
            break; // 9.4.14 <table:database-ranges>
        case 'filter':
            break; // 9.5.2 <table:filter>
        case 'filter-and':
            break; // 9.5.3 <table:filter-and>
        case 'filter-or':
            break; // 9.5.4 <table:filter-or>
        case 'filter-condition':
            break; // 9.5.5 <table:filter-condition>
        case 'list-level-style-bullet':
            break; // 16.31 <text:
        case 'list-level-style-number':
            break; // 16.32 <text:
        case 'list-level-properties':
            break; // 17.19 <style:
        /* 7.3 Document Fields */ case 'sender-firstname':
        case 'sender-lastname':
        case 'sender-initials':
        case 'sender-title':
        case 'sender-position':
        case 'sender-email':
        case 'sender-phone-private':
        case 'sender-fax':
        case 'sender-company':
        case 'sender-phone-work':
        case 'sender-street':
        case 'sender-city':
        case 'sender-postal-code':
        case 'sender-country':
        case 'sender-state-or-province':
        case 'author-name':
        case 'author-initials':
        case 'chapter':
        case 'file-name':
        case 'template-name':
        case 'sheet-name':
            break;
        case 'event-listener':
            break;
        /* TODO: FODS Properties */ case 'initial-creator':
        case 'creation-date':
        case 'print-date':
        case 'generator':
        case 'document-statistic':
        case 'user-defined':
        case 'editing-duration':
        case 'editing-cycles':
            break;
        /* TODO: FODS Config */ case 'config-item':
            break;
        /* TODO: style tokens */ case 'page-number':
            break; // TODO <text:page-number>
        case 'page-count':
            break; // TODO <text:page-count>
        case 'time':
            break; // TODO <text:time>
        /* 9.3 Advanced Table Cells */ case 'cell-range-source':
            break; // 9.3.1 <table:
        case 'detective':
            break; // 9.3.2 <table:
        case 'operation':
            break; // 9.3.3 <table:
        case 'highlighted-range':
            break; // 9.3.4 <table:
        /* 9.6 Data Pilot Tables <table: */ case 'data-pilot-table':
        case 'source-cell-range':
        case 'source-service':
        case 'data-pilot-field':
        case 'data-pilot-level':
        case 'data-pilot-subtotals':
        case 'data-pilot-subtotal':
        case 'data-pilot-members':
        case 'data-pilot-member':
        case 'data-pilot-display-info':
        case 'data-pilot-sort-info':
        case 'data-pilot-layout-info':
        case 'data-pilot-field-reference':
        case 'data-pilot-groups':
        case 'data-pilot-group':
        case 'data-pilot-group-member':
            break;
        /* 10.3 Drawing Shapes */ case 'rect':
            break;
        /* 14.6 DDE Connections */ case 'dde-connection-decls':
        case 'dde-connection-decl':
        case 'dde-link':
        case 'dde-source':
            break;
        case 'properties':
            break; // 13.7 <form:properties>
        case 'property':
            break; // 13.8 <form:property>
        case 'a':
            if (Rn[1] !== '/') {
                atag = $7c3b72a365cc0275$var$parsexmltag(Rn[0], false);
                if (!atag.href) break;
                atag.Target = $7c3b72a365cc0275$var$unescapexml(atag.href);
                delete atag.href;
                if (atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
                    _Ref = $7c3b72a365cc0275$var$ods_to_csf_3D(atag.Target.slice(1));
                    atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
                } else if (atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
            }
            break;
        /* non-standard */ case 'table-protection':
            break;
        case 'data-pilot-grand-total':
            break; // <table:
        case 'office-document-common-attrs':
            break; // bare
        default:
            switch(Rn[2]){
                case 'dc:':
                case 'calcext:':
                case 'loext:':
                case 'ooo:':
                case 'chartooo:':
                case 'draw:':
                case 'style:':
                case 'chart:':
                case 'form:':
                case 'uof:':
                case "\u8868:":
                case "\u5B57:":
                    break;
                default:
                    if (opts.WTF) throw new Error(Rn);
            }
    }
    var out /*:Workbook*/  = {
        Sheets: Sheets,
        SheetNames: SheetNames,
        Workbook: WB
    } /*:any*/ ;
    if (opts.bookSheets) delete /*::(*/ out /*:: :any)*/ .Sheets;
    return out;
}
function $7c3b72a365cc0275$var$parse_ods(zip /*:ZIPFile*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    opts = opts || {} /*:any*/ ;
    if ($7c3b72a365cc0275$var$safegetzipfile(zip, 'META-INF/manifest.xml')) $7c3b72a365cc0275$var$parse_manifest($7c3b72a365cc0275$var$getzipdata(zip, 'META-INF/manifest.xml'), opts);
    var content = $7c3b72a365cc0275$var$getzipstr(zip, 'content.xml');
    if (!content) throw new Error("Missing content.xml in ODS / UOF file");
    var wb = $7c3b72a365cc0275$var$parse_content_xml($7c3b72a365cc0275$var$utf8read(content), opts);
    if ($7c3b72a365cc0275$var$safegetzipfile(zip, 'meta.xml')) wb.Props = $7c3b72a365cc0275$var$parse_core_props($7c3b72a365cc0275$var$getzipdata(zip, 'meta.xml'));
    return wb;
}
function $7c3b72a365cc0275$var$parse_fods(data /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    return $7c3b72a365cc0275$var$parse_content_xml(data, opts);
}
/* OpenDocument */ var $7c3b72a365cc0275$var$write_styles_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    var master_styles = [
        '<office:master-styles>',
        '<style:master-page style:name="mp1" style:page-layout-name="mp1">',
        '<style:header/>',
        '<style:header-left style:display="false"/>',
        '<style:footer/>',
        '<style:footer-left style:display="false"/>',
        '</style:master-page>',
        '</office:master-styles>'
    ].join("");
    var payload = '<office:document-styles ' + $7c3b72a365cc0275$var$wxt_helper({
        'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
        'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
        'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
        'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
        'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
        'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
        'xmlns:xlink': "http://www.w3.org/1999/xlink",
        'xmlns:dc': "http://purl.org/dc/elements/1.1/",
        'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
        'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
        'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
        'office:version': "1.2"
    }) + '>' + master_styles + '</office:document-styles>';
    return function wso() {
        return $7c3b72a365cc0275$var$XML_HEADER + payload;
    };
}();
var $7c3b72a365cc0275$var$write_content_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    /* 6.1.2 White Space Characters */ var write_text_p = function(text /*:string*/ ) /*:string*/ {
        return $7c3b72a365cc0275$var$escapexml(text).replace(/  +/g, function($$) {
            return '<text:s text:c="' + $$.length + '"/>';
        }).replace(/\t/g, "<text:tab/>").replace(/\n/g, "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
    };
    var null_cell_xml = '          <table:table-cell />\n';
    var covered_cell_xml = '          <table:covered-table-cell/>\n';
    var write_ws = function(ws, wb /*:Workbook*/ , i /*:number*/  /*::, opts*/ ) /*:string*/ {
        /* Section 9 Tables */ var o /*:Array<string>*/  = [];
        o.push('      <table:table table:name="' + $7c3b72a365cc0275$var$escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
        var R = 0, C = 0, range = $7c3b72a365cc0275$var$decode_range(ws['!ref'] || "A1");
        var marr /*:Array<Range>*/  = ws['!merges'] || [], mi = 0;
        var dense = Array.isArray(ws);
        if (ws["!cols"]) for(C = 0; C <= range.e.c; ++C)o.push('        <table:table-column' + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : '') + '></table:table-column>\n');
        var H = "", ROWS = ws["!rows"] || [];
        for(R = 0; R < range.s.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push('        <table:table-row' + H + '></table:table-row>\n');
        }
        for(; R <= range.e.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push('        <table:table-row' + H + '>\n');
            for(C = 0; C < range.s.c; ++C)o.push(null_cell_xml);
            for(; C <= range.e.c; ++C){
                var skip = false, ct = {}, textp = "";
                for(mi = 0; mi != marr.length; ++mi){
                    if (marr[mi].s.c > C) continue;
                    if (marr[mi].s.r > R) continue;
                    if (marr[mi].e.c < C) continue;
                    if (marr[mi].e.r < R) continue;
                    if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                    ct['table:number-columns-spanned'] = marr[mi].e.c - marr[mi].s.c + 1;
                    ct['table:number-rows-spanned'] = marr[mi].e.r - marr[mi].s.r + 1;
                    break;
                }
                if (skip) {
                    o.push(covered_cell_xml);
                    continue;
                }
                var ref = $7c3b72a365cc0275$var$encode_cell({
                    r: R,
                    c: C
                }), cell = dense ? (ws[R] || [])[C] : ws[ref];
                if (cell && cell.f) {
                    ct['table:formula'] = $7c3b72a365cc0275$var$escapexml($7c3b72a365cc0275$var$csf_to_ods_formula(cell.f));
                    if (cell.F) {
                        if (cell.F.slice(0, ref.length) == ref) {
                            var _Fref = $7c3b72a365cc0275$var$decode_range(cell.F);
                            ct['table:number-matrix-columns-spanned'] = _Fref.e.c - _Fref.s.c + 1;
                            ct['table:number-matrix-rows-spanned'] = _Fref.e.r - _Fref.s.r + 1;
                        }
                    }
                }
                if (!cell) {
                    o.push(null_cell_xml);
                    continue;
                }
                switch(cell.t){
                    case 'b':
                        textp = cell.v ? 'TRUE' : 'FALSE';
                        ct['office:value-type'] = "boolean";
                        ct['office:boolean-value'] = cell.v ? 'true' : 'false';
                        break;
                    case 'n':
                        textp = cell.w || String(cell.v || 0);
                        ct['office:value-type'] = "float";
                        ct['office:value'] = cell.v || 0;
                        break;
                    case 's':
                    case 'str':
                        textp = cell.v == null ? "" : cell.v;
                        ct['office:value-type'] = "string";
                        break;
                    case 'd':
                        textp = cell.w || $7c3b72a365cc0275$var$parseDate(cell.v).toISOString();
                        ct['office:value-type'] = "date";
                        ct['office:date-value'] = $7c3b72a365cc0275$var$parseDate(cell.v).toISOString();
                        ct['table:style-name'] = "ce1";
                        break;
                    //case 'e':
                    default:
                        o.push(null_cell_xml);
                        continue;
                }
                var text_p = write_text_p(textp);
                if (cell.l && cell.l.Target) {
                    var _tgt = cell.l.Target;
                    _tgt = _tgt.charAt(0) == "#" ? "#" + $7c3b72a365cc0275$var$csf_to_ods_3D(_tgt.slice(1)) : _tgt;
                    // TODO: choose correct parent path format based on link delimiters
                    if (_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = '../' + _tgt;
                    text_p = $7c3b72a365cc0275$var$writextag('text:a', text_p, {
                        'xlink:href': _tgt.replace(/&/g, "&amp;")
                    });
                }
                o.push('          ' + $7c3b72a365cc0275$var$writextag('table:table-cell', $7c3b72a365cc0275$var$writextag('text:p', text_p, {}), ct) + '\n');
            }
            o.push('        </table:table-row>\n');
        }
        o.push('      </table:table>\n');
        return o.join("");
    };
    var write_automatic_styles_ods = function(o /*:Array<string>*/ , wb) {
        o.push(' <office:automatic-styles>\n');
        o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
        o.push('   <number:month number:style="long"/>\n');
        o.push('   <number:text>/</number:text>\n');
        o.push('   <number:day number:style="long"/>\n');
        o.push('   <number:text>/</number:text>\n');
        o.push('   <number:year/>\n');
        o.push('  </number:date-style>\n');
        /* column styles */ var cidx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!cols"]) {
                for(var C = 0; C < ws["!cols"].length; ++C)if (ws["!cols"][C]) {
                    var colobj = ws["!cols"][C];
                    if (colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
                    $7c3b72a365cc0275$var$process_col(colobj);
                    colobj.ods = cidx;
                    var w = ws["!cols"][C].wpx + "px";
                    o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
                    o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
                    o.push('  </style:style>\n');
                    ++cidx;
                }
            }
        });
        /* row styles */ var ridx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!rows"]) {
                for(var R = 0; R < ws["!rows"].length; ++R)if (ws["!rows"][R]) {
                    ws["!rows"][R].ods = ridx;
                    var h = ws["!rows"][R].hpx + "px";
                    o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
                    o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
                    o.push('  </style:style>\n');
                    ++ridx;
                }
            }
        });
        /* table */ o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
        o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
        o.push('  </style:style>\n');
        /* table cells, text */ o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
        /* page-layout */ o.push(' </office:automatic-styles>\n');
    };
    return function wcx(wb, opts) {
        var o = [
            $7c3b72a365cc0275$var$XML_HEADER
        ];
        /* 3.1.3.2 */ var attr = $7c3b72a365cc0275$var$wxt_helper({
            'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
            'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
            'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
            'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
            'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
            'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
            'xmlns:xlink': "http://www.w3.org/1999/xlink",
            'xmlns:dc': "http://purl.org/dc/elements/1.1/",
            'xmlns:meta': "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
            'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
            'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
            'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
            'xmlns:chart': "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
            'xmlns:dr3d': "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
            'xmlns:math': "http://www.w3.org/1998/Math/MathML",
            'xmlns:form': "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
            'xmlns:script': "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
            'xmlns:ooo': "http://openoffice.org/2004/office",
            'xmlns:ooow': "http://openoffice.org/2004/writer",
            'xmlns:oooc': "http://openoffice.org/2004/calc",
            'xmlns:dom': "http://www.w3.org/2001/xml-events",
            'xmlns:xforms': "http://www.w3.org/2002/xforms",
            'xmlns:xsd': "http://www.w3.org/2001/XMLSchema",
            'xmlns:xsi': "http://www.w3.org/2001/XMLSchema-instance",
            'xmlns:sheet': "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
            'xmlns:rpt': "http://openoffice.org/2005/report",
            'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
            'xmlns:xhtml': "http://www.w3.org/1999/xhtml",
            'xmlns:grddl': "http://www.w3.org/2003/g/data-view#",
            'xmlns:tableooo': "http://openoffice.org/2009/table",
            'xmlns:drawooo': "http://openoffice.org/2010/draw",
            'xmlns:calcext': "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
            'xmlns:loext': "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
            'xmlns:field': "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
            'xmlns:formx': "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
            'xmlns:css3t': "http://www.w3.org/TR/css3-text/",
            'office:version': "1.2"
        });
        var fods = $7c3b72a365cc0275$var$wxt_helper({
            'xmlns:config': "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
            'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
        });
        if (opts.bookType == "fods") {
            o.push('<office:document' + attr + fods + '>\n');
            o.push($7c3b72a365cc0275$var$write_meta_ods().replace(/office:document-meta/g, "office:meta"));
        // TODO: settings (equiv of settings.xml for ODS)
        } else o.push('<office:document-content' + attr + '>\n');
        // o.push('  <office:scripts/>\n');
        write_automatic_styles_ods(o, wb);
        o.push('  <office:body>\n');
        o.push('    <office:spreadsheet>\n');
        for(var i = 0; i != wb.SheetNames.length; ++i)o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts));
        o.push('    </office:spreadsheet>\n');
        o.push('  </office:body>\n');
        if (opts.bookType == "fods") o.push('</office:document>');
        else o.push('</office:document-content>');
        return o.join("");
    };
}();
function $7c3b72a365cc0275$var$write_ods(wb /*:any*/ , opts /*:any*/ ) {
    if (opts.bookType == "fods") return $7c3b72a365cc0275$var$write_content_ods(wb, opts);
    var zip = $7c3b72a365cc0275$var$zip_new();
    var f = "";
    var manifest /*:Array<Array<string> >*/  = [];
    var rdf /*:Array<[string, string]>*/  = [];
    /* Part 3 Section 3.3 MIME Media Type */ f = "mimetype";
    $7c3b72a365cc0275$var$zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
    /* Part 1 Section 2.2 Documents */ f = "content.xml";
    $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_content_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "ContentFile"
    ]);
    /* TODO: these are hard-coded styles to satiate excel */ f = "styles.xml";
    $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_styles_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "StylesFile"
    ]);
    /* TODO: this is hard-coded to satiate excel */ f = "meta.xml";
    $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$XML_HEADER + $7c3b72a365cc0275$var$write_meta_ods());
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "MetadataFile"
    ]);
    /* Part 3 Section 6 Metadata Manifest File */ f = "manifest.rdf";
    $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_rdf(rdf /*, opts*/ ));
    manifest.push([
        f,
        "application/rdf+xml"
    ]);
    /* Part 3 Section 4 Manifest File */ f = "META-INF/manifest.xml";
    $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_manifest(manifest /*, opts*/ ));
    return zip;
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */ function $7c3b72a365cc0275$var$u8_to_dataview(array) {
    return new DataView(array.buffer, array.byteOffset, array.byteLength);
}
function $7c3b72a365cc0275$var$u8str(u8) {
    return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : $7c3b72a365cc0275$var$utf8read($7c3b72a365cc0275$var$a2s(u8));
}
function $7c3b72a365cc0275$var$stru8(str) {
    return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : $7c3b72a365cc0275$var$s2a($7c3b72a365cc0275$var$utf8write(str));
}
function $7c3b72a365cc0275$var$u8contains(body, search) {
    outer: for(var L = 0; L <= body.length - search.length; ++L){
        for(var j = 0; j < search.length; ++j)if (body[L + j] != search[j]) continue outer;
        return true;
    }
    return false;
}
function $7c3b72a365cc0275$var$u8concat(u8a) {
    var len = u8a.reduce(function(acc, x) {
        return acc + x.length;
    }, 0);
    var out = new Uint8Array(len);
    var off = 0;
    u8a.forEach(function(u8) {
        out.set(u8, off);
        off += u8.length;
    });
    return out;
}
function $7c3b72a365cc0275$var$popcnt(x) {
    x -= x >> 1 & 1431655765;
    x = (x & 858993459) + (x >> 2 & 858993459);
    return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
}
function $7c3b72a365cc0275$var$readDecimal128LE(buf, offset) {
    var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
    var mantissa = buf[offset + 14] & 1;
    for(var j = offset + 13; j >= offset; --j)mantissa = mantissa * 256 + buf[j];
    return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
}
function $7c3b72a365cc0275$var$writeDecimal128LE(buf, offset, value) {
    var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 20;
    var mantissa = value / Math.pow(10, exp - 6176);
    buf[offset + 15] |= exp >> 7;
    buf[offset + 14] |= (exp & 127) << 1;
    for(var i = 0; mantissa >= 1; ++i, mantissa /= 256)buf[offset + i] = mantissa & 255;
    buf[offset + 15] |= value >= 0 ? 0 : 128;
}
function $7c3b72a365cc0275$var$parse_varint49(buf, ptr) {
    var l = ptr ? ptr[0] : 0;
    var usz = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        usz |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 28);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 35);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 42);
        ++l;
        if (buf[l++] < 128) break varint;
    }
    if (ptr) ptr[0] = l;
    return usz;
}
function $7c3b72a365cc0275$var$write_varint49(v) {
    var usz = new Uint8Array(7);
    usz[0] = v & 127;
    var L = 1;
    sz: if (v > 127) {
        usz[L - 1] |= 128;
        usz[L] = v >> 7 & 127;
        ++L;
        if (v <= 16383) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 14 & 127;
        ++L;
        if (v <= 2097151) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 21 & 127;
        ++L;
        if (v <= 268435455) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 256 >>> 21 & 127;
        ++L;
        if (v <= 34359738367) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 65536 >>> 21 & 127;
        ++L;
        if (v <= 4398046511103) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 16777216 >>> 21 & 127;
        ++L;
    }
    return usz.slice(0, L);
}
function $7c3b72a365cc0275$var$varint_to_i32(buf) {
    var l = 0, i32 = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        i32 |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 28;
    }
    return i32;
}
function $7c3b72a365cc0275$var$parse_shallow(buf) {
    var out = [], ptr = [
        0
    ];
    while(ptr[0] < buf.length){
        var off = ptr[0];
        var num = $7c3b72a365cc0275$var$parse_varint49(buf, ptr);
        var type = num & 7;
        num = Math.floor(num / 8);
        var len = 0;
        var res;
        if (num == 0) break;
        switch(type){
            case 0:
                var l = ptr[0];
                while(buf[ptr[0]++] >= 128);
                res = buf.slice(l, ptr[0]);
                break;
            case 5:
                len = 4;
                res = buf.slice(ptr[0], ptr[0] + len);
                ptr[0] += len;
                break;
            case 1:
                len = 8;
                res = buf.slice(ptr[0], ptr[0] + len);
                ptr[0] += len;
                break;
            case 2:
                len = $7c3b72a365cc0275$var$parse_varint49(buf, ptr);
                res = buf.slice(ptr[0], ptr[0] + len);
                ptr[0] += len;
                break;
            case 3:
            case 4:
            default:
                throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
        }
        var v = {
            data: res,
            type: type
        };
        if (out[num] == null) out[num] = [
            v
        ];
        else out[num].push(v);
    }
    return out;
}
function $7c3b72a365cc0275$var$write_shallow(proto) {
    var out = [];
    proto.forEach(function(field, idx) {
        field.forEach(function(item) {
            if (!item.data) return;
            out.push($7c3b72a365cc0275$var$write_varint49(idx * 8 + item.type));
            if (item.type == 2) out.push($7c3b72a365cc0275$var$write_varint49(item.data.length));
            out.push(item.data);
        });
    });
    return $7c3b72a365cc0275$var$u8concat(out);
}
function $7c3b72a365cc0275$var$mappa(data, cb) {
    return (data == null ? void 0 : data.map(function(d) {
        return cb(d.data);
    })) || [];
}
function $7c3b72a365cc0275$var$parse_iwa_file(buf) {
    var _a;
    var out = [], ptr = [
        0
    ];
    while(ptr[0] < buf.length){
        var len = $7c3b72a365cc0275$var$parse_varint49(buf, ptr);
        var ai = $7c3b72a365cc0275$var$parse_shallow(buf.slice(ptr[0], ptr[0] + len));
        ptr[0] += len;
        var res = {
            id: $7c3b72a365cc0275$var$varint_to_i32(ai[1][0].data),
            messages: []
        };
        ai[2].forEach(function(b) {
            var mi = $7c3b72a365cc0275$var$parse_shallow(b.data);
            var fl = $7c3b72a365cc0275$var$varint_to_i32(mi[3][0].data);
            res.messages.push({
                meta: mi,
                data: buf.slice(ptr[0], ptr[0] + fl)
            });
            ptr[0] += fl;
        });
        if ((_a = ai[3]) == null ? void 0 : _a[0]) res.merge = $7c3b72a365cc0275$var$varint_to_i32(ai[3][0].data) >>> 0 > 0;
        out.push(res);
    }
    return out;
}
function $7c3b72a365cc0275$var$write_iwa_file(ias) {
    var bufs = [];
    ias.forEach(function(ia) {
        var ai = [];
        ai[1] = [
            {
                data: $7c3b72a365cc0275$var$write_varint49(ia.id),
                type: 0
            }
        ];
        ai[2] = [];
        if (ia.merge != null) ai[3] = [
            {
                data: $7c3b72a365cc0275$var$write_varint49(+!!ia.merge),
                type: 0
            }
        ];
        var midata = [];
        ia.messages.forEach(function(mi) {
            midata.push(mi.data);
            mi.meta[3] = [
                {
                    type: 0,
                    data: $7c3b72a365cc0275$var$write_varint49(mi.data.length)
                }
            ];
            ai[2].push({
                data: $7c3b72a365cc0275$var$write_shallow(mi.meta),
                type: 2
            });
        });
        var aipayload = $7c3b72a365cc0275$var$write_shallow(ai);
        bufs.push($7c3b72a365cc0275$var$write_varint49(aipayload.length));
        bufs.push(aipayload);
        midata.forEach(function(mid) {
            return bufs.push(mid);
        });
    });
    return $7c3b72a365cc0275$var$u8concat(bufs);
}
function $7c3b72a365cc0275$var$parse_snappy_chunk(type, buf) {
    if (type != 0) throw new Error("Unexpected Snappy chunk type ".concat(type));
    var ptr = [
        0
    ];
    var usz = $7c3b72a365cc0275$var$parse_varint49(buf, ptr);
    var chunks = [];
    while(ptr[0] < buf.length){
        var tag = buf[ptr[0]] & 3;
        if (tag == 0) {
            var len = buf[ptr[0]++] >> 2;
            if (len < 60) ++len;
            else {
                var c = len - 59;
                len = buf[ptr[0]];
                if (c > 1) len |= buf[ptr[0] + 1] << 8;
                if (c > 2) len |= buf[ptr[0] + 2] << 16;
                if (c > 3) len |= buf[ptr[0] + 3] << 24;
                len >>>= 0;
                len++;
                ptr[0] += c;
            }
            chunks.push(buf.slice(ptr[0], ptr[0] + len));
            ptr[0] += len;
            continue;
        } else {
            var offset = 0, length = 0;
            if (tag == 1) {
                length = (buf[ptr[0]] >> 2 & 7) + 4;
                offset = (buf[ptr[0]++] & 224) << 3;
                offset |= buf[ptr[0]++];
            } else {
                length = (buf[ptr[0]++] >> 2) + 1;
                if (tag == 2) {
                    offset = buf[ptr[0]] | buf[ptr[0] + 1] << 8;
                    ptr[0] += 2;
                } else {
                    offset = (buf[ptr[0]] | buf[ptr[0] + 1] << 8 | buf[ptr[0] + 2] << 16 | buf[ptr[0] + 3] << 24) >>> 0;
                    ptr[0] += 4;
                }
            }
            chunks = [
                $7c3b72a365cc0275$var$u8concat(chunks)
            ];
            if (offset == 0) throw new Error("Invalid offset 0");
            if (offset > chunks[0].length) throw new Error("Invalid offset beyond length");
            if (length >= offset) {
                chunks.push(chunks[0].slice(-offset));
                length -= offset;
                while(length >= chunks[chunks.length - 1].length){
                    chunks.push(chunks[chunks.length - 1]);
                    length -= chunks[chunks.length - 1].length;
                }
            }
            chunks.push(chunks[0].slice(-offset, -offset + length));
        }
    }
    var o = $7c3b72a365cc0275$var$u8concat(chunks);
    if (o.length != usz) throw new Error("Unexpected length: ".concat(o.length, " != ").concat(usz));
    return o;
}
function $7c3b72a365cc0275$var$decompress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while(l < buf.length){
        var t = buf[l++];
        var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
        l += 3;
        out.push($7c3b72a365cc0275$var$parse_snappy_chunk(t, buf.slice(l, l + len)));
        l += len;
    }
    if (l !== buf.length) throw new Error("data is not a valid framed stream!");
    return $7c3b72a365cc0275$var$u8concat(out);
}
function $7c3b72a365cc0275$var$compress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while(l < buf.length){
        var c = Math.min(buf.length - l, 268435455);
        var frame = new Uint8Array(4);
        out.push(frame);
        var usz = $7c3b72a365cc0275$var$write_varint49(c);
        var L = usz.length;
        out.push(usz);
        if (c <= 60) {
            L++;
            out.push(new Uint8Array([
                c - 1 << 2
            ]));
        } else if (c <= 256) {
            L += 2;
            out.push(new Uint8Array([
                240,
                c - 1 & 255
            ]));
        } else if (c <= 65536) {
            L += 3;
            out.push(new Uint8Array([
                244,
                c - 1 & 255,
                c - 1 >> 8 & 255
            ]));
        } else if (c <= 16777216) {
            L += 4;
            out.push(new Uint8Array([
                248,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255
            ]));
        } else if (c <= 4294967296) {
            L += 5;
            out.push(new Uint8Array([
                252,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255,
                c - 1 >>> 24 & 255
            ]));
        }
        out.push(buf.slice(l, l + c));
        L += c;
        frame[0] = 0;
        frame[1] = L & 255;
        frame[2] = L >> 8 & 255;
        frame[3] = L >> 16 & 255;
        l += c;
    }
    return $7c3b72a365cc0275$var$u8concat(out);
}
function $7c3b72a365cc0275$var$parse_old_storage(buf, sst, rsst, v) {
    var dv = $7c3b72a365cc0275$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var data_offset = (v > 1 ? 12 : 8) + $7c3b72a365cc0275$var$popcnt(flags & (v > 1 ? 3470 : 398)) * 4;
    var ridx = -1, sidx = -1, ieee = NaN, dt = new Date(2001, 0, 1);
    if (flags & 512) {
        ridx = dv.getUint32(data_offset, true);
        data_offset += 4;
    }
    data_offset += $7c3b72a365cc0275$var$popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
    if (flags & 16) {
        sidx = dv.getUint32(data_offset, true);
        data_offset += 4;
    }
    if (flags & 32) {
        ieee = dv.getFloat64(data_offset, true);
        data_offset += 8;
    }
    if (flags & 64) {
        dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
        data_offset += 8;
    }
    var ret;
    switch(buf[2]){
        case 0:
            break;
        case 2:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: sst[sidx]
            };
            break;
        case 5:
            ret = {
                t: "d",
                v: dt
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee / 86400
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) ret = {
                t: "s",
                v: rsst[ridx]
            };
            else if (sidx > -1) ret = {
                t: "s",
                v: sst[sidx]
            };
            else if (!isNaN(ieee)) ret = {
                t: "n",
                v: ieee
            };
            else throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
    }
    return ret;
}
function $7c3b72a365cc0275$var$parse_new_storage(buf, sst, rsst) {
    var dv = $7c3b72a365cc0275$var$u8_to_dataview(buf);
    var flags = dv.getUint32(8, true);
    var data_offset = 12;
    var ridx = -1, sidx = -1, d128 = NaN, ieee = NaN, dt = new Date(2001, 0, 1);
    if (flags & 1) {
        d128 = $7c3b72a365cc0275$var$readDecimal128LE(buf, data_offset);
        data_offset += 16;
    }
    if (flags & 2) {
        ieee = dv.getFloat64(data_offset, true);
        data_offset += 8;
    }
    if (flags & 4) {
        dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
        data_offset += 8;
    }
    if (flags & 8) {
        sidx = dv.getUint32(data_offset, true);
        data_offset += 4;
    }
    if (flags & 16) {
        ridx = dv.getUint32(data_offset, true);
        data_offset += 4;
    }
    var ret;
    switch(buf[1]){
        case 0:
            break;
        case 2:
            ret = {
                t: "n",
                v: d128
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: sst[sidx]
            };
            break;
        case 5:
            ret = {
                t: "d",
                v: dt
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee / 86400
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) ret = {
                t: "s",
                v: rsst[ridx]
            };
            else throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
            break;
        case 10:
            ret = {
                t: "n",
                v: d128
            };
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
    }
    return ret;
}
function $7c3b72a365cc0275$var$write_new_storage(cell, sst) {
    var out = new Uint8Array(32), dv = $7c3b72a365cc0275$var$u8_to_dataview(out), l = 12, flags = 0;
    out[0] = 5;
    switch(cell.t){
        case "n":
            out[1] = 2;
            $7c3b72a365cc0275$var$writeDecimal128LE(out, l, cell.v);
            flags |= 1;
            l += 16;
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            flags |= 2;
            l += 8;
            break;
        case "s":
            if (sst.indexOf(cell.v) == -1) throw new Error("Value ".concat(cell.v, " missing from SST!"));
            out[1] = 3;
            dv.setUint32(l, sst.indexOf(cell.v), true);
            flags |= 8;
            l += 4;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(8, flags, true);
    return out.slice(0, l);
}
function $7c3b72a365cc0275$var$write_old_storage(cell, sst) {
    var out = new Uint8Array(32), dv = $7c3b72a365cc0275$var$u8_to_dataview(out), l = 12, flags = 0;
    out[0] = 3;
    switch(cell.t){
        case "n":
            out[2] = 2;
            dv.setFloat64(l, cell.v, true);
            flags |= 32;
            l += 8;
            break;
        case "b":
            out[2] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            flags |= 32;
            l += 8;
            break;
        case "s":
            if (sst.indexOf(cell.v) == -1) throw new Error("Value ".concat(cell.v, " missing from SST!"));
            out[2] = 3;
            dv.setUint32(l, sst.indexOf(cell.v), true);
            flags |= 16;
            l += 4;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(4, flags, true);
    return out.slice(0, l);
}
function $7c3b72a365cc0275$var$parse_cell_storage(buf, sst, rsst) {
    switch(buf[0]){
        case 0:
        case 1:
        case 2:
        case 3:
            return $7c3b72a365cc0275$var$parse_old_storage(buf, sst, rsst, buf[0]);
        case 5:
            return $7c3b72a365cc0275$var$parse_new_storage(buf, sst, rsst);
        default:
            throw new Error("Unsupported payload version ".concat(buf[0]));
    }
}
function $7c3b72a365cc0275$var$parse_TSP_Reference(buf) {
    var pb = $7c3b72a365cc0275$var$parse_shallow(buf);
    return $7c3b72a365cc0275$var$parse_varint49(pb[1][0].data);
}
function $7c3b72a365cc0275$var$write_TSP_Reference(idx) {
    var out = [];
    out[1] = [
        {
            type: 0,
            data: $7c3b72a365cc0275$var$write_varint49(idx)
        }
    ];
    return $7c3b72a365cc0275$var$write_shallow(out);
}
function $7c3b72a365cc0275$var$parse_TST_TableDataList(M, root) {
    var pb = $7c3b72a365cc0275$var$parse_shallow(root.data);
    var type = $7c3b72a365cc0275$var$varint_to_i32(pb[1][0].data);
    var entries = pb[3];
    var data = [];
    (entries || []).forEach(function(entry) {
        var le = $7c3b72a365cc0275$var$parse_shallow(entry.data);
        var key = $7c3b72a365cc0275$var$varint_to_i32(le[1][0].data) >>> 0;
        switch(type){
            case 1:
                data[key] = $7c3b72a365cc0275$var$u8str(le[3][0].data);
                break;
            case 8:
                var rt = M[$7c3b72a365cc0275$var$parse_TSP_Reference(le[9][0].data)][0];
                var rtp = $7c3b72a365cc0275$var$parse_shallow(rt.data);
                var rtpref = M[$7c3b72a365cc0275$var$parse_TSP_Reference(rtp[1][0].data)][0];
                var mtype = $7c3b72a365cc0275$var$varint_to_i32(rtpref.meta[1][0].data);
                if (mtype != 2001) throw new Error("2000 unexpected reference to ".concat(mtype));
                var tswpsa = $7c3b72a365cc0275$var$parse_shallow(rtpref.data);
                data[key] = tswpsa[3].map(function(x) {
                    return $7c3b72a365cc0275$var$u8str(x.data);
                }).join("");
                break;
        }
    });
    return data;
}
function $7c3b72a365cc0275$var$parse_TST_TileRowInfo(u8, type) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $7c3b72a365cc0275$var$parse_shallow(u8);
    var R = $7c3b72a365cc0275$var$varint_to_i32(pb[1][0].data) >>> 0;
    var cnt = $7c3b72a365cc0275$var$varint_to_i32(pb[2][0].data) >>> 0;
    var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && $7c3b72a365cc0275$var$varint_to_i32(pb[8][0].data) > 0 || false;
    var used_storage_u8, used_storage;
    if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
        used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
        used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
    } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
        used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
        used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
    } else throw "NUMBERS Tile missing ".concat(type, " cell storage");
    var width = wide_offsets ? 4 : 1;
    var used_storage_offsets = $7c3b72a365cc0275$var$u8_to_dataview(used_storage_u8);
    var offsets = [];
    for(var C = 0; C < used_storage_u8.length / 2; ++C){
        var off = used_storage_offsets.getUint16(C * 2, true);
        if (off < 65535) offsets.push([
            C,
            off
        ]);
    }
    if (offsets.length != cnt) throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
    var cells = [];
    for(C = 0; C < offsets.length - 1; ++C)cells[offsets[C][0]] = used_storage.subarray(offsets[C][1] * width, offsets[C + 1][1] * width);
    if (offsets.length >= 1) cells[offsets[offsets.length - 1][0]] = used_storage.subarray(offsets[offsets.length - 1][1] * width);
    return {
        R: R,
        cells: cells
    };
}
function $7c3b72a365cc0275$var$parse_TST_Tile(M, root) {
    var _a;
    var pb = $7c3b72a365cc0275$var$parse_shallow(root.data);
    var storage = ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) ? $7c3b72a365cc0275$var$varint_to_i32(pb[7][0].data) >>> 0 > 0 ? 1 : 0 : -1;
    var ri = $7c3b72a365cc0275$var$mappa(pb[5], function(u8) {
        return $7c3b72a365cc0275$var$parse_TST_TileRowInfo(u8, storage);
    });
    return {
        nrows: $7c3b72a365cc0275$var$varint_to_i32(pb[4][0].data) >>> 0,
        data: ri.reduce(function(acc, x) {
            if (!acc[x.R]) acc[x.R] = [];
            x.cells.forEach(function(cell, C) {
                if (acc[x.R][C]) throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
                acc[x.R][C] = cell;
            });
            return acc;
        }, [])
    };
}
function $7c3b72a365cc0275$var$parse_TST_TableModelArchive(M, root, ws) {
    var _a;
    var pb = $7c3b72a365cc0275$var$parse_shallow(root.data);
    var range = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    range.e.r = ($7c3b72a365cc0275$var$varint_to_i32(pb[6][0].data) >>> 0) - 1;
    if (range.e.r < 0) throw new Error("Invalid row varint ".concat(pb[6][0].data));
    range.e.c = ($7c3b72a365cc0275$var$varint_to_i32(pb[7][0].data) >>> 0) - 1;
    if (range.e.c < 0) throw new Error("Invalid col varint ".concat(pb[7][0].data));
    ws["!ref"] = $7c3b72a365cc0275$var$encode_range(range);
    var store = $7c3b72a365cc0275$var$parse_shallow(pb[4][0].data);
    var sst = $7c3b72a365cc0275$var$parse_TST_TableDataList(M, M[$7c3b72a365cc0275$var$parse_TSP_Reference(store[4][0].data)][0]);
    var rsst = ((_a = store[17]) == null ? void 0 : _a[0]) ? $7c3b72a365cc0275$var$parse_TST_TableDataList(M, M[$7c3b72a365cc0275$var$parse_TSP_Reference(store[17][0].data)][0]) : [];
    var tile = $7c3b72a365cc0275$var$parse_shallow(store[3][0].data);
    var _R = 0;
    tile[1].forEach(function(t) {
        var tl = $7c3b72a365cc0275$var$parse_shallow(t.data);
        var ref = M[$7c3b72a365cc0275$var$parse_TSP_Reference(tl[2][0].data)][0];
        var mtype = $7c3b72a365cc0275$var$varint_to_i32(ref.meta[1][0].data);
        if (mtype != 6002) throw new Error("6001 unexpected reference to ".concat(mtype));
        var _tile = $7c3b72a365cc0275$var$parse_TST_Tile(M, ref);
        _tile.data.forEach(function(row, R) {
            row.forEach(function(buf, C) {
                var addr = $7c3b72a365cc0275$var$encode_cell({
                    r: _R + R,
                    c: C
                });
                var res = $7c3b72a365cc0275$var$parse_cell_storage(buf, sst, rsst);
                if (res) ws[addr] = res;
            });
        });
        _R += _tile.nrows;
    });
}
function $7c3b72a365cc0275$var$parse_TST_TableInfoArchive(M, root) {
    var pb = $7c3b72a365cc0275$var$parse_shallow(root.data);
    var out = {
        "!ref": "A1"
    };
    var tableref = M[$7c3b72a365cc0275$var$parse_TSP_Reference(pb[2][0].data)];
    var mtype = $7c3b72a365cc0275$var$varint_to_i32(tableref[0].meta[1][0].data);
    if (mtype != 6001) throw new Error("6000 unexpected reference to ".concat(mtype));
    $7c3b72a365cc0275$var$parse_TST_TableModelArchive(M, tableref[0], out);
    return out;
}
function $7c3b72a365cc0275$var$parse_TN_SheetArchive(M, root) {
    var _a;
    var pb = $7c3b72a365cc0275$var$parse_shallow(root.data);
    var out = {
        name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? $7c3b72a365cc0275$var$u8str(pb[1][0].data) : "",
        sheets: []
    };
    var shapeoffs = $7c3b72a365cc0275$var$mappa(pb[2], $7c3b72a365cc0275$var$parse_TSP_Reference);
    shapeoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $7c3b72a365cc0275$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 6e3) out.sheets.push($7c3b72a365cc0275$var$parse_TST_TableInfoArchive(M, m));
        });
    });
    return out;
}
function $7c3b72a365cc0275$var$parse_TN_DocumentArchive(M, root) {
    var out = $7c3b72a365cc0275$var$book_new();
    var pb = $7c3b72a365cc0275$var$parse_shallow(root.data);
    var sheetoffs = $7c3b72a365cc0275$var$mappa(pb[1], $7c3b72a365cc0275$var$parse_TSP_Reference);
    sheetoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $7c3b72a365cc0275$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 2) {
                var root2 = $7c3b72a365cc0275$var$parse_TN_SheetArchive(M, m);
                root2.sheets.forEach(function(sheet, idx) {
                    $7c3b72a365cc0275$var$book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
                });
            }
        });
    });
    if (out.SheetNames.length == 0) throw new Error("Empty NUMBERS file");
    return out;
}
function $7c3b72a365cc0275$var$parse_numbers_iwa(cfb) {
    var _a, _b, _c, _d;
    var M = {}, indices = [];
    cfb.FullPaths.forEach(function(p) {
        if (p.match(/\.iwpv2/)) throw new Error("Unsupported password protection");
    });
    cfb.FileIndex.forEach(function(s) {
        if (!s.name.match(/\.iwa$/)) return;
        var o;
        try {
            o = $7c3b72a365cc0275$var$decompress_iwa_file(s.content);
        } catch (e) {
            return console.log("?? " + s.content.length + " " + (e.message || e));
        }
        var packets;
        try {
            packets = $7c3b72a365cc0275$var$parse_iwa_file(o);
        } catch (e) {
            return console.log("## " + (e.message || e));
        }
        packets.forEach(function(packet) {
            M[packet.id] = packet.messages;
            indices.push(packet.id);
        });
    });
    if (!indices.length) throw new Error("File has no messages");
    var docroot = ((_d = (_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0]) == null ? void 0 : _b.meta) == null ? void 0 : _c[1]) == null ? void 0 : _d[0].data) && $7c3b72a365cc0275$var$varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
    if (!docroot) indices.forEach(function(idx) {
        M[idx].forEach(function(iwam) {
            var mtype = $7c3b72a365cc0275$var$varint_to_i32(iwam.meta[1][0].data) >>> 0;
            if (mtype == 1) {
                if (!docroot) docroot = iwam;
                else throw new Error("Document has multiple roots");
            }
        });
    });
    if (!docroot) throw new Error("Cannot find Document root");
    return $7c3b72a365cc0275$var$parse_TN_DocumentArchive(M, docroot);
}
function $7c3b72a365cc0275$var$write_tile_row(tri, data, SST) {
    var _a, _b, _c, _d;
    if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0])) throw "Mutation only works on post-BNC storages!";
    var wide_offsets = ((_d = (_c = tri[8]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && $7c3b72a365cc0275$var$varint_to_i32(tri[8][0].data) > 0 || false;
    if (wide_offsets) throw "Math only works with normal offsets";
    var cnt = 0;
    var dv = $7c3b72a365cc0275$var$u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
    var _dv = $7c3b72a365cc0275$var$u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
    for(var C = 0; C < data.length; ++C){
        if (data[C] == null) {
            dv.setUint16(C * 2, 65535, true);
            _dv.setUint16(C * 2, 65535);
            continue;
        }
        dv.setUint16(C * 2, last_offset, true);
        _dv.setUint16(C * 2, _last_offset, true);
        var celload, _celload;
        switch(typeof data[C]){
            case "string":
                celload = $7c3b72a365cc0275$var$write_new_storage({
                    t: "s",
                    v: data[C]
                }, SST);
                _celload = $7c3b72a365cc0275$var$write_old_storage({
                    t: "s",
                    v: data[C]
                }, SST);
                break;
            case "number":
                celload = $7c3b72a365cc0275$var$write_new_storage({
                    t: "n",
                    v: data[C]
                }, SST);
                _celload = $7c3b72a365cc0275$var$write_old_storage({
                    t: "n",
                    v: data[C]
                }, SST);
                break;
            case "boolean":
                celload = $7c3b72a365cc0275$var$write_new_storage({
                    t: "b",
                    v: data[C]
                }, SST);
                _celload = $7c3b72a365cc0275$var$write_old_storage({
                    t: "b",
                    v: data[C]
                }, SST);
                break;
            default:
                throw new Error("Unsupported value " + data[C]);
        }
        cell_storage.push(celload);
        last_offset += celload.length;
        _cell_storage.push(_celload);
        _last_offset += _celload.length;
        ++cnt;
    }
    tri[2][0].data = $7c3b72a365cc0275$var$write_varint49(cnt);
    for(; C < tri[7][0].data.length / 2; ++C){
        dv.setUint16(C * 2, 65535, true);
        _dv.setUint16(C * 2, 65535, true);
    }
    tri[6][0].data = $7c3b72a365cc0275$var$u8concat(cell_storage);
    tri[3][0].data = $7c3b72a365cc0275$var$u8concat(_cell_storage);
    return cnt;
}
function $7c3b72a365cc0275$var$write_numbers_iwa(wb, opts) {
    if (!opts || !opts.numbers) throw new Error("Must pass a `numbers` option -- check the README");
    var ws = wb.Sheets[wb.SheetNames[0]];
    if (wb.SheetNames.length > 1) console.error("The Numbers writer currently writes only the first table");
    var range = $7c3b72a365cc0275$var$decode_range(ws["!ref"]);
    range.s.r = range.s.c = 0;
    var trunc = false;
    if (range.e.c > 9) {
        trunc = true;
        range.e.c = 9;
    }
    if (range.e.r > 49) {
        trunc = true;
        range.e.r = 49;
    }
    if (trunc) console.error("The Numbers writer is currently limited to ".concat($7c3b72a365cc0275$var$encode_range(range)));
    var data = $7c3b72a365cc0275$var$sheet_to_json(ws, {
        range: range,
        header: 1
    });
    var SST = [
        "~Sh33tJ5~"
    ];
    data.forEach(function(row) {
        return row.forEach(function(cell) {
            if (typeof cell == "string") SST.push(cell);
        });
    });
    var dependents = {};
    var indices = [];
    var cfb = $7c3b72a365cc0275$export$9f0e51cd97c572a.read(opts.numbers, {
        type: "base64"
    });
    cfb.FileIndex.map(function(fi, idx) {
        return [
            fi,
            cfb.FullPaths[idx]
        ];
    }).forEach(function(row) {
        var fi = row[0], fp = row[1];
        if (fi.type != 2) return;
        if (!fi.name.match(/\.iwa/)) return;
        var old_content = fi.content;
        var raw1 = $7c3b72a365cc0275$var$decompress_iwa_file(old_content);
        var x2 = $7c3b72a365cc0275$var$parse_iwa_file(raw1);
        x2.forEach(function(packet2) {
            indices.push(packet2.id);
            dependents[packet2.id] = {
                deps: [],
                location: fp,
                type: $7c3b72a365cc0275$var$varint_to_i32(packet2.messages[0].meta[1][0].data)
            };
        });
    });
    indices.sort(function(x2, y2) {
        return x2 - y2;
    });
    var indices_varint = indices.filter(function(x2) {
        return x2 > 1;
    }).map(function(x2) {
        return [
            x2,
            $7c3b72a365cc0275$var$write_varint49(x2)
        ];
    });
    cfb.FileIndex.map(function(fi, idx) {
        return [
            fi,
            cfb.FullPaths[idx]
        ];
    }).forEach(function(row) {
        var fi = row[0], fp = row[1];
        if (!fi.name.match(/\.iwa/)) return;
        var x2 = $7c3b72a365cc0275$var$parse_iwa_file($7c3b72a365cc0275$var$decompress_iwa_file(fi.content));
        x2.forEach(function(ia) {
            ia.messages.forEach(function(m) {
                indices_varint.forEach(function(ivi) {
                    if (ia.messages.some(function(mess) {
                        return $7c3b72a365cc0275$var$varint_to_i32(mess.meta[1][0].data) != 11006 && $7c3b72a365cc0275$var$u8contains(mess.data, ivi[1]);
                    })) dependents[ivi[0]].deps.push(ia.id);
                });
            });
        });
    });
    function get_unique_msgid() {
        for(var i = 927262; i < 2e6; ++i)if (!dependents[i]) return i;
        throw new Error("Too many messages");
    }
    var entry = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, dependents[1].location);
    var x = $7c3b72a365cc0275$var$parse_iwa_file($7c3b72a365cc0275$var$decompress_iwa_file(entry.content));
    var docroot;
    for(var xi = 0; xi < x.length; ++xi){
        var packet = x[xi];
        if (packet.id == 1) docroot = packet;
    }
    var sheetrootref = $7c3b72a365cc0275$var$parse_TSP_Reference($7c3b72a365cc0275$var$parse_shallow(docroot.messages[0].data)[1][0].data);
    entry = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, dependents[sheetrootref].location);
    x = $7c3b72a365cc0275$var$parse_iwa_file($7c3b72a365cc0275$var$decompress_iwa_file(entry.content));
    for(xi = 0; xi < x.length; ++xi){
        packet = x[xi];
        if (packet.id == sheetrootref) docroot = packet;
    }
    sheetrootref = $7c3b72a365cc0275$var$parse_TSP_Reference($7c3b72a365cc0275$var$parse_shallow(docroot.messages[0].data)[2][0].data);
    entry = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, dependents[sheetrootref].location);
    x = $7c3b72a365cc0275$var$parse_iwa_file($7c3b72a365cc0275$var$decompress_iwa_file(entry.content));
    for(xi = 0; xi < x.length; ++xi){
        packet = x[xi];
        if (packet.id == sheetrootref) docroot = packet;
    }
    sheetrootref = $7c3b72a365cc0275$var$parse_TSP_Reference($7c3b72a365cc0275$var$parse_shallow(docroot.messages[0].data)[2][0].data);
    entry = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, dependents[sheetrootref].location);
    x = $7c3b72a365cc0275$var$parse_iwa_file($7c3b72a365cc0275$var$decompress_iwa_file(entry.content));
    for(xi = 0; xi < x.length; ++xi){
        packet = x[xi];
        if (packet.id == sheetrootref) docroot = packet;
    }
    var pb = $7c3b72a365cc0275$var$parse_shallow(docroot.messages[0].data);
    pb[6][0].data = $7c3b72a365cc0275$var$write_varint49(range.e.r + 1);
    pb[7][0].data = $7c3b72a365cc0275$var$write_varint49(range.e.c + 1);
    var cruidsref = $7c3b72a365cc0275$var$parse_TSP_Reference(pb[46][0].data);
    var oldbucket = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, dependents[cruidsref].location);
    var _x = $7c3b72a365cc0275$var$parse_iwa_file($7c3b72a365cc0275$var$decompress_iwa_file(oldbucket.content));
    for(var j = 0; j < _x.length; ++j){
        if (_x[j].id == cruidsref) break;
    }
    if (_x[j].id != cruidsref) throw "Bad ColumnRowUIDMapArchive";
    var cruids = $7c3b72a365cc0275$var$parse_shallow(_x[j].messages[0].data);
    cruids[1] = [];
    cruids[2] = [], cruids[3] = [];
    for(var C = 0; C <= range.e.c; ++C){
        var uuid = [];
        uuid[1] = uuid[2] = [
            {
                type: 0,
                data: $7c3b72a365cc0275$var$write_varint49(C + 420690)
            }
        ];
        cruids[1].push({
            type: 2,
            data: $7c3b72a365cc0275$var$write_shallow(uuid)
        });
        cruids[2].push({
            type: 0,
            data: $7c3b72a365cc0275$var$write_varint49(C)
        });
        cruids[3].push({
            type: 0,
            data: $7c3b72a365cc0275$var$write_varint49(C)
        });
    }
    cruids[4] = [];
    cruids[5] = [], cruids[6] = [];
    for(var R = 0; R <= range.e.r; ++R){
        uuid = [];
        uuid[1] = uuid[2] = [
            {
                type: 0,
                data: $7c3b72a365cc0275$var$write_varint49(R + 726270)
            }
        ];
        cruids[4].push({
            type: 2,
            data: $7c3b72a365cc0275$var$write_shallow(uuid)
        });
        cruids[5].push({
            type: 0,
            data: $7c3b72a365cc0275$var$write_varint49(R)
        });
        cruids[6].push({
            type: 0,
            data: $7c3b72a365cc0275$var$write_varint49(R)
        });
    }
    _x[j].messages[0].data = $7c3b72a365cc0275$var$write_shallow(cruids);
    oldbucket.content = $7c3b72a365cc0275$var$compress_iwa_file($7c3b72a365cc0275$var$write_iwa_file(_x));
    oldbucket.size = oldbucket.content.length;
    delete pb[46];
    var store = $7c3b72a365cc0275$var$parse_shallow(pb[4][0].data);
    store[7][0].data = $7c3b72a365cc0275$var$write_varint49(range.e.r + 1);
    var row_headers = $7c3b72a365cc0275$var$parse_shallow(store[1][0].data);
    var row_header_ref = $7c3b72a365cc0275$var$parse_TSP_Reference(row_headers[2][0].data);
    oldbucket = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, dependents[row_header_ref].location);
    _x = $7c3b72a365cc0275$var$parse_iwa_file($7c3b72a365cc0275$var$decompress_iwa_file(oldbucket.content));
    if (_x[0].id != row_header_ref) throw "Bad HeaderStorageBucket";
    var base_bucket = $7c3b72a365cc0275$var$parse_shallow(_x[0].messages[0].data);
    for(R = 0; R < data.length; ++R){
        var _bucket = $7c3b72a365cc0275$var$parse_shallow(base_bucket[2][0].data);
        _bucket[1][0].data = $7c3b72a365cc0275$var$write_varint49(R);
        _bucket[4][0].data = $7c3b72a365cc0275$var$write_varint49(data[R].length);
        base_bucket[2][R] = {
            type: base_bucket[2][0].type,
            data: $7c3b72a365cc0275$var$write_shallow(_bucket)
        };
    }
    _x[0].messages[0].data = $7c3b72a365cc0275$var$write_shallow(base_bucket);
    oldbucket.content = $7c3b72a365cc0275$var$compress_iwa_file($7c3b72a365cc0275$var$write_iwa_file(_x));
    oldbucket.size = oldbucket.content.length;
    var col_header_ref = $7c3b72a365cc0275$var$parse_TSP_Reference(store[2][0].data);
    oldbucket = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, dependents[col_header_ref].location);
    _x = $7c3b72a365cc0275$var$parse_iwa_file($7c3b72a365cc0275$var$decompress_iwa_file(oldbucket.content));
    if (_x[0].id != col_header_ref) throw "Bad HeaderStorageBucket";
    base_bucket = $7c3b72a365cc0275$var$parse_shallow(_x[0].messages[0].data);
    for(C = 0; C <= range.e.c; ++C){
        _bucket = $7c3b72a365cc0275$var$parse_shallow(base_bucket[2][0].data);
        _bucket[1][0].data = $7c3b72a365cc0275$var$write_varint49(C);
        _bucket[4][0].data = $7c3b72a365cc0275$var$write_varint49(range.e.r + 1);
        base_bucket[2][C] = {
            type: base_bucket[2][0].type,
            data: $7c3b72a365cc0275$var$write_shallow(_bucket)
        };
    }
    _x[0].messages[0].data = $7c3b72a365cc0275$var$write_shallow(base_bucket);
    oldbucket.content = $7c3b72a365cc0275$var$compress_iwa_file($7c3b72a365cc0275$var$write_iwa_file(_x));
    oldbucket.size = oldbucket.content.length;
    var sstref = $7c3b72a365cc0275$var$parse_TSP_Reference(store[4][0].data);
    (function() {
        var sentry = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, dependents[sstref].location);
        var sx = $7c3b72a365cc0275$var$parse_iwa_file($7c3b72a365cc0275$var$decompress_iwa_file(sentry.content));
        var sstroot;
        for(var sxi = 0; sxi < sx.length; ++sxi){
            var packet2 = sx[sxi];
            if (packet2.id == sstref) sstroot = packet2;
        }
        var sstdata = $7c3b72a365cc0275$var$parse_shallow(sstroot.messages[0].data);
        sstdata[3] = [];
        var newsst = [];
        SST.forEach(function(str, i) {
            newsst[1] = [
                {
                    type: 0,
                    data: $7c3b72a365cc0275$var$write_varint49(i)
                }
            ];
            newsst[2] = [
                {
                    type: 0,
                    data: $7c3b72a365cc0275$var$write_varint49(1)
                }
            ];
            newsst[3] = [
                {
                    type: 2,
                    data: $7c3b72a365cc0275$var$stru8(str)
                }
            ];
            sstdata[3].push({
                type: 2,
                data: $7c3b72a365cc0275$var$write_shallow(newsst)
            });
        });
        sstroot.messages[0].data = $7c3b72a365cc0275$var$write_shallow(sstdata);
        var sy = $7c3b72a365cc0275$var$write_iwa_file(sx);
        var raw32 = $7c3b72a365cc0275$var$compress_iwa_file(sy);
        sentry.content = raw32;
        sentry.size = sentry.content.length;
    })();
    var tile = $7c3b72a365cc0275$var$parse_shallow(store[3][0].data);
    var t = tile[1][0];
    delete tile[2];
    var tl = $7c3b72a365cc0275$var$parse_shallow(t.data);
    var tileref = $7c3b72a365cc0275$var$parse_TSP_Reference(tl[2][0].data);
    (function() {
        var tentry = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, dependents[tileref].location);
        var tx = $7c3b72a365cc0275$var$parse_iwa_file($7c3b72a365cc0275$var$decompress_iwa_file(tentry.content));
        var tileroot;
        for(var sxi = 0; sxi < tx.length; ++sxi){
            var packet2 = tx[sxi];
            if (packet2.id == tileref) tileroot = packet2;
        }
        var tiledata = $7c3b72a365cc0275$var$parse_shallow(tileroot.messages[0].data);
        delete tiledata[6];
        delete tile[7];
        var rowload = new Uint8Array(tiledata[5][0].data);
        tiledata[5] = [];
        var cnt = 0;
        for(var R2 = 0; R2 <= range.e.r; ++R2){
            var tilerow = $7c3b72a365cc0275$var$parse_shallow(rowload);
            cnt += $7c3b72a365cc0275$var$write_tile_row(tilerow, data[R2], SST);
            tilerow[1][0].data = $7c3b72a365cc0275$var$write_varint49(R2);
            tiledata[5].push({
                data: $7c3b72a365cc0275$var$write_shallow(tilerow),
                type: 2
            });
        }
        tiledata[1] = [
            {
                type: 0,
                data: $7c3b72a365cc0275$var$write_varint49(range.e.c + 1)
            }
        ];
        tiledata[2] = [
            {
                type: 0,
                data: $7c3b72a365cc0275$var$write_varint49(range.e.r + 1)
            }
        ];
        tiledata[3] = [
            {
                type: 0,
                data: $7c3b72a365cc0275$var$write_varint49(cnt)
            }
        ];
        tiledata[4] = [
            {
                type: 0,
                data: $7c3b72a365cc0275$var$write_varint49(range.e.r + 1)
            }
        ];
        tileroot.messages[0].data = $7c3b72a365cc0275$var$write_shallow(tiledata);
        var ty = $7c3b72a365cc0275$var$write_iwa_file(tx);
        var raw32 = $7c3b72a365cc0275$var$compress_iwa_file(ty);
        tentry.content = raw32;
        tentry.size = tentry.content.length;
    })();
    t.data = $7c3b72a365cc0275$var$write_shallow(tl);
    store[3][0].data = $7c3b72a365cc0275$var$write_shallow(tile);
    pb[4][0].data = $7c3b72a365cc0275$var$write_shallow(store);
    docroot.messages[0].data = $7c3b72a365cc0275$var$write_shallow(pb);
    var y = $7c3b72a365cc0275$var$write_iwa_file(x);
    var raw3 = $7c3b72a365cc0275$var$compress_iwa_file(y);
    entry.content = raw3;
    entry.size = entry.content.length;
    return cfb;
}
function $7c3b72a365cc0275$var$fix_opts_func(defaults /*:Array<Array<any> >*/ ) /*:{(o:any):void}*/ {
    return function fix_opts(opts) {
        for(var i = 0; i != defaults.length; ++i){
            var d = defaults[i];
            if (opts[d[0]] === undefined) opts[d[0]] = d[1];
            if (d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
        }
    };
}
function $7c3b72a365cc0275$var$fix_read_opts(opts) {
    $7c3b72a365cc0275$var$fix_opts_func([
        [
            'cellNF',
            false
        ],
        /* emit cell number format string as .z */ [
            'cellHTML',
            true
        ],
        /* emit html string as .h */ [
            'cellFormula',
            true
        ],
        /* emit formulae as .f */ [
            'cellStyles',
            false
        ],
        /* emits style/theme as .s */ [
            'cellText',
            true
        ],
        /* emit formatted text as .w */ [
            'cellDates',
            false
        ],
        /* emit date cells with type `d` */ [
            'sheetStubs',
            false
        ],
        /* emit empty cells */ [
            'sheetRows',
            0,
            'n'
        ],
        /* read n rows (0 = read all rows) */ [
            'bookDeps',
            false
        ],
        /* parse calculation chains */ [
            'bookSheets',
            false
        ],
        /* only try to get sheet names (no Sheets) */ [
            'bookProps',
            false
        ],
        /* only try to get properties (no Sheets) */ [
            'bookFiles',
            false
        ],
        /* include raw file structure (keys, files, cfb) */ [
            'bookVBA',
            false
        ],
        /* include vba raw data (vbaraw) */ [
            'password',
            ''
        ],
        /* password */ [
            'WTF',
            false
        ]
    ])(opts);
}
function $7c3b72a365cc0275$var$fix_write_opts(opts) {
    $7c3b72a365cc0275$var$fix_opts_func([
        [
            'cellDates',
            false
        ],
        /* write date cells with type `d` */ [
            'bookSST',
            false
        ],
        /* Generate Shared String Table */ [
            'bookType',
            'xlsx'
        ],
        /* Type of workbook (xlsx/m/b) */ [
            'compression',
            false
        ],
        /* Use file compression */ [
            'WTF',
            false
        ]
    ])(opts);
}
function $7c3b72a365cc0275$var$get_sheet_type(n /*:string*/ ) /*:string*/ {
    if ($7c3b72a365cc0275$var$RELS.WS.indexOf(n) > -1) return "sheet";
    if ($7c3b72a365cc0275$var$RELS.CS && n == $7c3b72a365cc0275$var$RELS.CS) return "chart";
    if ($7c3b72a365cc0275$var$RELS.DS && n == $7c3b72a365cc0275$var$RELS.DS) return "dialog";
    if ($7c3b72a365cc0275$var$RELS.MS && n == $7c3b72a365cc0275$var$RELS.MS) return "macro";
    return n && n.length ? n : "sheet";
}
function $7c3b72a365cc0275$var$safe_parse_wbrels(wbrels, sheets) {
    if (!wbrels) return 0;
    try {
        wbrels = sheets.map(function pwbr(w) {
            if (!w.id) w.id = w.strRelID;
            return [
                w.name,
                wbrels['!id'][w.id].Target,
                $7c3b72a365cc0275$var$get_sheet_type(wbrels['!id'][w.id].Type)
            ];
        });
    } catch (e) {
        return null;
    }
    return !wbrels || wbrels.length === 0 ? null : wbrels;
}
function $7c3b72a365cc0275$var$safe_parse_sheet(zip, path /*:string*/ , relsPath /*:string*/ , sheet, idx /*:number*/ , sheetRels, sheets, stype /*:string*/ , opts, wb, themes, styles) {
    try {
        sheetRels[sheet] = $7c3b72a365cc0275$var$parse_rels($7c3b72a365cc0275$var$getzipstr(zip, relsPath, true), path);
        var data = $7c3b72a365cc0275$var$getzipdata(zip, path);
        var _ws;
        switch(stype){
            case 'sheet':
                _ws = $7c3b72a365cc0275$var$parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case 'chart':
                _ws = $7c3b72a365cc0275$var$parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                if (!_ws || !_ws['!drawel']) break;
                var dfile = $7c3b72a365cc0275$var$resolve_path(_ws['!drawel'].Target, path);
                var drelsp = $7c3b72a365cc0275$var$get_rels_path(dfile);
                var draw = $7c3b72a365cc0275$var$parse_drawing($7c3b72a365cc0275$var$getzipstr(zip, dfile, true), $7c3b72a365cc0275$var$parse_rels($7c3b72a365cc0275$var$getzipstr(zip, drelsp, true), dfile));
                var chartp = $7c3b72a365cc0275$var$resolve_path(draw, dfile);
                var crelsp = $7c3b72a365cc0275$var$get_rels_path(chartp);
                _ws = $7c3b72a365cc0275$var$parse_chart($7c3b72a365cc0275$var$getzipstr(zip, chartp, true), chartp, opts, $7c3b72a365cc0275$var$parse_rels($7c3b72a365cc0275$var$getzipstr(zip, crelsp, true), chartp), wb, _ws);
                break;
            case 'macro':
                _ws = $7c3b72a365cc0275$var$parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case 'dialog':
                _ws = $7c3b72a365cc0275$var$parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            default:
                throw new Error("Unrecognized sheet type " + stype);
        }
        sheets[sheet] = _ws;
        /* scan rels for comments and threaded comments */ var tcomments = [];
        if (sheetRels && sheetRels[sheet]) $7c3b72a365cc0275$var$keys(sheetRels[sheet]).forEach(function(n) {
            var dfile = "";
            if (sheetRels[sheet][n].Type == $7c3b72a365cc0275$var$RELS.CMNT) {
                dfile = $7c3b72a365cc0275$var$resolve_path(sheetRels[sheet][n].Target, path);
                var comments = $7c3b72a365cc0275$var$parse_cmnt($7c3b72a365cc0275$var$getzipdata(zip, dfile, true), dfile, opts);
                if (!comments || !comments.length) return;
                $7c3b72a365cc0275$var$sheet_insert_comments(_ws, comments, false);
            }
            if (sheetRels[sheet][n].Type == $7c3b72a365cc0275$var$RELS.TCMNT) {
                dfile = $7c3b72a365cc0275$var$resolve_path(sheetRels[sheet][n].Target, path);
                tcomments = tcomments.concat($7c3b72a365cc0275$var$parse_tcmnt_xml($7c3b72a365cc0275$var$getzipdata(zip, dfile, true), opts));
            }
        });
        if (tcomments && tcomments.length) $7c3b72a365cc0275$var$sheet_insert_comments(_ws, tcomments, true, opts.people || []);
    } catch (e) {
        if (opts.WTF) throw e;
    }
}
function $7c3b72a365cc0275$var$strip_front_slash(x /*:string*/ ) /*:string*/ {
    return x.charAt(0) == '/' ? x.slice(1) : x;
}
function $7c3b72a365cc0275$export$b165387946f79a1(zip /*:ZIP*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $7c3b72a365cc0275$var$make_ssf();
    opts = opts || {};
    $7c3b72a365cc0275$var$fix_read_opts(opts);
    /* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */ if ($7c3b72a365cc0275$var$safegetzipfile(zip, 'META-INF/manifest.xml')) return $7c3b72a365cc0275$var$parse_ods(zip, opts);
    /* UOC */ if ($7c3b72a365cc0275$var$safegetzipfile(zip, 'objectdata.xml')) return $7c3b72a365cc0275$var$parse_ods(zip, opts);
    /* Numbers */ if ($7c3b72a365cc0275$var$safegetzipfile(zip, 'Index/Document.iwa')) {
        if (typeof Uint8Array == "undefined") throw new Error('NUMBERS file parsing requires Uint8Array support');
        if (typeof $7c3b72a365cc0275$var$parse_numbers_iwa != "undefined") {
            if (zip.FileIndex) return $7c3b72a365cc0275$var$parse_numbers_iwa(zip);
            var _zip = $7c3b72a365cc0275$export$9f0e51cd97c572a.utils.cfb_new();
            $7c3b72a365cc0275$var$zipentries(zip).forEach(function(e) {
                $7c3b72a365cc0275$var$zip_add_file(_zip, e, $7c3b72a365cc0275$var$getzipbin(zip, e));
            });
            return $7c3b72a365cc0275$var$parse_numbers_iwa(_zip);
        }
        throw new Error('Unsupported NUMBERS file');
    }
    if (!$7c3b72a365cc0275$var$safegetzipfile(zip, '[Content_Types].xml')) {
        if ($7c3b72a365cc0275$var$safegetzipfile(zip, 'index.xml.gz')) throw new Error('Unsupported NUMBERS 08 file');
        if ($7c3b72a365cc0275$var$safegetzipfile(zip, 'index.xml')) throw new Error('Unsupported NUMBERS 09 file');
        throw new Error('Unsupported ZIP file');
    }
    var entries = $7c3b72a365cc0275$var$zipentries(zip);
    var dir = $7c3b72a365cc0275$var$parse_ct($7c3b72a365cc0275$var$getzipstr(zip, '[Content_Types].xml'));
    var xlsb = false;
    var sheets, binname;
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.xml";
        if ($7c3b72a365cc0275$var$getzipdata(zip, binname, true)) dir.workbooks.push(binname);
    }
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.bin";
        if (!$7c3b72a365cc0275$var$getzipdata(zip, binname, true)) throw new Error("Could not find workbook");
        dir.workbooks.push(binname);
        xlsb = true;
    }
    if (dir.workbooks[0].slice(-3) == "bin") xlsb = true;
    var themes = {} /*:any*/ ;
    var styles = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) {
        $7c3b72a365cc0275$var$strs = [];
        if (dir.sst) try {
            $7c3b72a365cc0275$var$strs = $7c3b72a365cc0275$var$parse_sst($7c3b72a365cc0275$var$getzipdata(zip, $7c3b72a365cc0275$var$strip_front_slash(dir.sst)), dir.sst, opts);
        } catch (e) {
            if (opts.WTF) throw e;
        }
        if (opts.cellStyles && dir.themes.length) themes = $7c3b72a365cc0275$var$parse_theme($7c3b72a365cc0275$var$getzipstr(zip, dir.themes[0].replace(/^\//, ''), true) || "", dir.themes[0], opts);
        if (dir.style) styles = $7c3b72a365cc0275$var$parse_sty($7c3b72a365cc0275$var$getzipdata(zip, $7c3b72a365cc0275$var$strip_front_slash(dir.style)), dir.style, themes, opts);
    }
    /*var externbooks = */ dir.links.map(function(link) {
        try {
            var rels = $7c3b72a365cc0275$var$parse_rels($7c3b72a365cc0275$var$getzipstr(zip, $7c3b72a365cc0275$var$get_rels_path($7c3b72a365cc0275$var$strip_front_slash(link))), link);
            return $7c3b72a365cc0275$var$parse_xlink($7c3b72a365cc0275$var$getzipdata(zip, $7c3b72a365cc0275$var$strip_front_slash(link)), rels, link, opts);
        } catch (e) {}
    });
    var wb = $7c3b72a365cc0275$var$parse_wb($7c3b72a365cc0275$var$getzipdata(zip, $7c3b72a365cc0275$var$strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
    var props = {}, propdata = "";
    if (dir.coreprops.length) {
        propdata = $7c3b72a365cc0275$var$getzipdata(zip, $7c3b72a365cc0275$var$strip_front_slash(dir.coreprops[0]), true);
        if (propdata) props = $7c3b72a365cc0275$var$parse_core_props(propdata);
        if (dir.extprops.length !== 0) {
            propdata = $7c3b72a365cc0275$var$getzipdata(zip, $7c3b72a365cc0275$var$strip_front_slash(dir.extprops[0]), true);
            if (propdata) $7c3b72a365cc0275$var$parse_ext_props(propdata, props, opts);
        }
    }
    var custprops = {};
    if (!opts.bookSheets || opts.bookProps) {
        if (dir.custprops.length !== 0) {
            propdata = $7c3b72a365cc0275$var$getzipstr(zip, $7c3b72a365cc0275$var$strip_front_slash(dir.custprops[0]), true);
            if (propdata) custprops = $7c3b72a365cc0275$var$parse_cust_props(propdata, opts);
        }
    }
    var out = {} /*:any*/ ;
    if (opts.bookSheets || opts.bookProps) {
        if (wb.Sheets) sheets = wb.Sheets.map(function pluck(x) {
            return x.name;
        });
        else if (props.Worksheets && props.SheetNames.length > 0) sheets = props.SheetNames;
        if (opts.bookProps) {
            out.Props = props;
            out.Custprops = custprops;
        }
        if (opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
        if (opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
    }
    sheets = {};
    var deps = {};
    if (opts.bookDeps && dir.calcchain) deps = $7c3b72a365cc0275$var$parse_cc($7c3b72a365cc0275$var$getzipdata(zip, $7c3b72a365cc0275$var$strip_front_slash(dir.calcchain)), dir.calcchain, opts);
    var i = 0;
    var sheetRels = {} /*:any*/ ;
    var path, relsPath;
    var wbsheets = wb.Sheets;
    props.Worksheets = wbsheets.length;
    props.SheetNames = [];
    for(var j = 0; j != wbsheets.length; ++j)props.SheetNames[j] = wbsheets[j].name;
    var wbext = xlsb ? "bin" : "xml";
    var wbrelsi = dir.workbooks[0].lastIndexOf("/");
    var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi + 1) + "_rels/" + dir.workbooks[0].slice(wbrelsi + 1) + ".rels").replace(/^\//, "");
    if (!$7c3b72a365cc0275$var$safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
    var wbrels = $7c3b72a365cc0275$var$parse_rels($7c3b72a365cc0275$var$getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));
    if ((dir.metadata || []).length >= 1) /* TODO: MDX and other types of metadata */ opts.xlmeta = $7c3b72a365cc0275$var$parse_xlmeta($7c3b72a365cc0275$var$getzipdata(zip, $7c3b72a365cc0275$var$strip_front_slash(dir.metadata[0])), dir.metadata[0], opts);
    if ((dir.people || []).length >= 1) opts.people = $7c3b72a365cc0275$var$parse_people_xml($7c3b72a365cc0275$var$getzipdata(zip, $7c3b72a365cc0275$var$strip_front_slash(dir.people[0])), opts);
    if (wbrels) wbrels = $7c3b72a365cc0275$var$safe_parse_wbrels(wbrels, wb.Sheets);
    /* Numbers iOS hack */ var nmode = $7c3b72a365cc0275$var$getzipdata(zip, "xl/worksheets/sheet.xml", true) ? 1 : 0;
    wsloop: for(i = 0; i != props.Worksheets; ++i){
        var stype = "sheet";
        if (wbrels && wbrels[i]) {
            path = 'xl/' + wbrels[i][1].replace(/[\/]?xl\//, "");
            if (!$7c3b72a365cc0275$var$safegetzipfile(zip, path)) path = wbrels[i][1];
            if (!$7c3b72a365cc0275$var$safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/, "") + wbrels[i][1];
            stype = wbrels[i][2];
        } else {
            path = 'xl/worksheets/sheet' + (i + 1 - nmode) + "." + wbext;
            path = path.replace(/sheet0\./, "sheet.");
        }
        relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
        if (opts && opts.sheets != null) switch(typeof opts.sheets){
            case "number":
                if (i != opts.sheets) continue wsloop;
                break;
            case "string":
                if (props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop;
                break;
            default:
                if (Array.isArray && Array.isArray(opts.sheets)) {
                    var snjseen = false;
                    for(var snj = 0; snj != opts.sheets.length; ++snj){
                        if (typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen = 1;
                        if (typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
                    }
                    if (!snjseen) continue wsloop;
                }
        }
        $7c3b72a365cc0275$var$safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
    }
    out = {
        Directory: dir,
        Workbook: wb,
        Props: props,
        Custprops: custprops,
        Deps: deps,
        Sheets: sheets,
        SheetNames: props.SheetNames,
        Strings: $7c3b72a365cc0275$var$strs,
        Styles: styles,
        Themes: themes,
        SSF: $7c3b72a365cc0275$var$dup($7c3b72a365cc0275$var$table_fmt)
    } /*:any*/ ;
    if (opts && opts.bookFiles) {
        if (zip.files) {
            out.keys = entries;
            out.files = zip.files;
        } else {
            out.keys = [];
            out.files = {};
            zip.FullPaths.forEach(function(p, idx) {
                p = p.replace(/^Root Entry[\/]/, "");
                out.keys.push(p);
                out.files[p] = zip.FileIndex[idx];
            });
        }
    }
    if (opts && opts.bookVBA) {
        if (dir.vba.length > 0) out.vbaraw = $7c3b72a365cc0275$var$getzipdata(zip, $7c3b72a365cc0275$var$strip_front_slash(dir.vba[0]), true);
        else if (dir.defaults && dir.defaults.bin === $7c3b72a365cc0275$var$CT_VBA) out.vbaraw = $7c3b72a365cc0275$var$getzipdata(zip, 'xl/vbaProject.bin', true);
    }
    return out;
}
/* [MS-OFFCRYPTO] 2.1.1 */ function $7c3b72a365cc0275$var$parse_xlsxcfb(cfb, _opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var opts = _opts || {};
    var f = 'Workbook', data = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, f);
    try {
        f = '/!DataSpaces/Version';
        data = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var version = */ $7c3b72a365cc0275$var$parse_DataSpaceVersionInfo(data.content);
        /* 2.3.4.1 */ f = '/!DataSpaces/DataSpaceMap';
        data = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var dsm = $7c3b72a365cc0275$var$parse_DataSpaceMap(data.content);
        if (dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.2 */ f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
        data = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var seds = $7c3b72a365cc0275$var$parse_DataSpaceDefinition(data.content);
        if (seds.length != 1 || seds[0] != "StrongEncryptionTransform") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.3 */ f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
        data = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var hdr = */ $7c3b72a365cc0275$var$parse_Primary(data.content);
    } catch (e) {}
    f = '/EncryptionInfo';
    data = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    var einfo = $7c3b72a365cc0275$var$parse_EncryptionInfo(data.content);
    /* 2.3.4.4 */ f = '/EncryptedPackage';
    data = $7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    /*global decrypt_agile */ /*:: declare var decrypt_agile:any; */ if (einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
    /*global decrypt_std76 */ /*:: declare var decrypt_std76:any; */ if (einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
    throw new Error("File is password-protected");
}
function $7c3b72a365cc0275$var$write_zip(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (opts.bookType == "ods") return $7c3b72a365cc0275$var$write_ods(wb, opts);
    if (opts.bookType == "numbers") return $7c3b72a365cc0275$var$write_numbers_iwa(wb, opts);
    if (opts.bookType == "xlsb") return $7c3b72a365cc0275$var$write_zip_xlsxb(wb, opts);
    return $7c3b72a365cc0275$var$write_zip_xlsx(wb, opts);
}
/* XLSX and XLSB writing are very similar.  Originally they were unified in one
   export function.  This is horrible for tree shaking in the common case (most
   applications need to export files in one format) so this function supports
   both formats while write_zip_xlsx only handles XLSX */ function $7c3b72a365cc0275$var$write_zip_xlsxb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    $7c3b72a365cc0275$var$_shapeid = 1024;
    if (wb && !wb.SSF) wb.SSF = $7c3b72a365cc0275$var$dup($7c3b72a365cc0275$var$table_fmt);
    if (wb && wb.SSF) {
        $7c3b72a365cc0275$var$make_ssf();
        $7c3b72a365cc0275$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $7c3b72a365cc0275$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($7c3b72a365cc0275$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = opts.bookType == "xlsb" ? "bin" : "xml";
    var vbafmt = $7c3b72a365cc0275$var$VBAFMTS.indexOf(opts.bookType) > -1;
    var ct = $7c3b72a365cc0275$var$new_ct();
    $7c3b72a365cc0275$var$fix_write_opts(opts = opts || {});
    var zip = $7c3b72a365cc0275$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $7c3b72a365cc0275$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $7c3b72a365cc0275$var$add_rels(opts.rels, 2, f, $7c3b72a365cc0275$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $7c3b72a365cc0275$var$add_rels(opts.rels, 3, f, $7c3b72a365cc0275$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $7c3b72a365cc0275$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $7c3b72a365cc0275$var$add_rels(opts.rels, 4, f, $7c3b72a365cc0275$var$RELS.CUST_PROPS);
    }
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            '!id': {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_ws(rId - 1, f, opts, wb, wsrels));
        ct.sheets.push(f);
        $7c3b72a365cc0275$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $7c3b72a365cc0275$var$RELS.WS[0]);
        if (ws) {
            var comments = ws['!comments'];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                cf = "xl/comments" + rId + "." + wbext;
                $7c3b72a365cc0275$var$zip_add_file(zip, cf, $7c3b72a365cc0275$var$write_cmnt(comments, cf, opts));
                ct.comments.push(cf);
                $7c3b72a365cc0275$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $7c3b72a365cc0275$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws['!legacy']) {
                if (need_vml) $7c3b72a365cc0275$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $7c3b72a365cc0275$var$write_comments_vml(rId, ws['!comments']));
            }
            delete ws['!comments'];
            delete ws['!legacy'];
        }
        if (wsrels['!id'].rId1) $7c3b72a365cc0275$var$zip_add_file(zip, $7c3b72a365cc0275$var$get_rels_path(f), $7c3b72a365cc0275$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_sst(opts.Strings, f, opts));
        ct.strs.push(f);
        $7c3b72a365cc0275$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $7c3b72a365cc0275$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_wb(wb, f, opts));
    ct.workbooks.push(f);
    $7c3b72a365cc0275$var$add_rels(opts.rels, 1, f, $7c3b72a365cc0275$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_theme(wb.Themes, opts));
    ct.themes.push(f);
    $7c3b72a365cc0275$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $7c3b72a365cc0275$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_sty(wb, f, opts));
    ct.styles.push(f);
    $7c3b72a365cc0275$var$add_rels(opts.wbrels, -1, "styles." + wbext, $7c3b72a365cc0275$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $7c3b72a365cc0275$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $7c3b72a365cc0275$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $7c3b72a365cc0275$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_xlmeta(f));
    ct.metadata.push(f);
    $7c3b72a365cc0275$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $7c3b72a365cc0275$var$RELS.XLMETA);
    $7c3b72a365cc0275$var$zip_add_file(zip, "[Content_Types].xml", $7c3b72a365cc0275$var$write_ct(ct, opts));
    $7c3b72a365cc0275$var$zip_add_file(zip, '_rels/.rels', $7c3b72a365cc0275$var$write_rels(opts.rels));
    $7c3b72a365cc0275$var$zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', $7c3b72a365cc0275$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $7c3b72a365cc0275$var$write_zip_xlsx(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    $7c3b72a365cc0275$var$_shapeid = 1024;
    if (wb && !wb.SSF) wb.SSF = $7c3b72a365cc0275$var$dup($7c3b72a365cc0275$var$table_fmt);
    if (wb && wb.SSF) {
        $7c3b72a365cc0275$var$make_ssf();
        $7c3b72a365cc0275$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $7c3b72a365cc0275$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($7c3b72a365cc0275$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "xml";
    var vbafmt = $7c3b72a365cc0275$var$VBAFMTS.indexOf(opts.bookType) > -1;
    var ct = $7c3b72a365cc0275$var$new_ct();
    $7c3b72a365cc0275$var$fix_write_opts(opts = opts || {});
    var zip = $7c3b72a365cc0275$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $7c3b72a365cc0275$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $7c3b72a365cc0275$var$add_rels(opts.rels, 2, f, $7c3b72a365cc0275$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $7c3b72a365cc0275$var$add_rels(opts.rels, 3, f, $7c3b72a365cc0275$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $7c3b72a365cc0275$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $7c3b72a365cc0275$var$add_rels(opts.rels, 4, f, $7c3b72a365cc0275$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            '!id': {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_ws_xml(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $7c3b72a365cc0275$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $7c3b72a365cc0275$var$RELS.WS[0]);
        if (ws) {
            var comments = ws['!comments'];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + "." + wbext;
                    $7c3b72a365cc0275$var$zip_add_file(zip, cf, $7c3b72a365cc0275$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $7c3b72a365cc0275$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + "." + wbext, $7c3b72a365cc0275$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $7c3b72a365cc0275$var$zip_add_file(zip, cf, $7c3b72a365cc0275$var$write_comments_xml(comments, opts));
                ct.comments.push(cf);
                $7c3b72a365cc0275$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $7c3b72a365cc0275$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws['!legacy']) {
                if (need_vml) $7c3b72a365cc0275$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $7c3b72a365cc0275$var$write_comments_vml(rId, ws['!comments']));
            }
            delete ws['!comments'];
            delete ws['!legacy'];
        }
        if (wsrels['!id'].rId1) $7c3b72a365cc0275$var$zip_add_file(zip, $7c3b72a365cc0275$var$get_rels_path(f), $7c3b72a365cc0275$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_sst_xml(opts.Strings, opts));
        ct.strs.push(f);
        $7c3b72a365cc0275$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $7c3b72a365cc0275$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_wb_xml(wb, opts));
    ct.workbooks.push(f);
    $7c3b72a365cc0275$var$add_rels(opts.rels, 1, f, $7c3b72a365cc0275$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_theme(wb.Themes, opts));
    ct.themes.push(f);
    $7c3b72a365cc0275$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $7c3b72a365cc0275$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_sty_xml(wb, opts));
    ct.styles.push(f);
    $7c3b72a365cc0275$var$add_rels(opts.wbrels, -1, "styles." + wbext, $7c3b72a365cc0275$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $7c3b72a365cc0275$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $7c3b72a365cc0275$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $7c3b72a365cc0275$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_xlmeta_xml());
    ct.metadata.push(f);
    $7c3b72a365cc0275$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $7c3b72a365cc0275$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $7c3b72a365cc0275$var$zip_add_file(zip, f, $7c3b72a365cc0275$var$write_people_xml(people, opts));
        ct.people.push(f);
        $7c3b72a365cc0275$var$add_rels(opts.wbrels, -1, "persons/person.xml", $7c3b72a365cc0275$var$RELS.PEOPLE);
    }
    $7c3b72a365cc0275$var$zip_add_file(zip, "[Content_Types].xml", $7c3b72a365cc0275$var$write_ct(ct, opts));
    $7c3b72a365cc0275$var$zip_add_file(zip, '_rels/.rels', $7c3b72a365cc0275$var$write_rels(opts.rels));
    $7c3b72a365cc0275$var$zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', $7c3b72a365cc0275$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $7c3b72a365cc0275$var$firstbyte(f /*:RawData*/ , o /*:?TypeOpts*/ ) /*:Array<number>*/ {
    var x = "";
    switch((o || {}).type || "base64"){
        case 'buffer':
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        case 'base64':
            x = $7c3b72a365cc0275$var$Base64_decode(f.slice(0, 12));
            break;
        case 'binary':
            x = f;
            break;
        case 'array':
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        default:
            throw new Error("Unrecognized type " + (o && o.type || "undefined"));
    }
    return [
        x.charCodeAt(0),
        x.charCodeAt(1),
        x.charCodeAt(2),
        x.charCodeAt(3),
        x.charCodeAt(4),
        x.charCodeAt(5),
        x.charCodeAt(6),
        x.charCodeAt(7)
    ];
}
function $7c3b72a365cc0275$var$read_cfb(cfb /*:CFBContainer*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    if ($7c3b72a365cc0275$export$9f0e51cd97c572a.find(cfb, "EncryptedPackage")) return $7c3b72a365cc0275$var$parse_xlsxcfb(cfb, opts);
    return $7c3b72a365cc0275$export$b41972a043aba84c(cfb, opts);
}
function $7c3b72a365cc0275$var$read_zip(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var zip, d = data;
    var o = opts || {};
    if (!o.type) o.type = $7c3b72a365cc0275$var$has_buf && $7c3b72a365cc0275$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    zip = $7c3b72a365cc0275$var$zip_read(d, o);
    return $7c3b72a365cc0275$export$b165387946f79a1(zip, o);
}
function $7c3b72a365cc0275$var$read_plaintext(data /*:string*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var i = 0;
    main: while(i < data.length)switch(data.charCodeAt(i)){
        case 0x0A:
        case 0x0D:
        case 0x20:
            ++i;
            break;
        case 0x3C:
            return $7c3b72a365cc0275$var$parse_xlml(data.slice(i), o);
        default:
            break main;
    }
    return $7c3b72a365cc0275$var$PRN.to_workbook(data, o);
}
function $7c3b72a365cc0275$var$read_plaintext_raw(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var str = "", bytes = $7c3b72a365cc0275$var$firstbyte(data, o);
    switch(o.type){
        case 'base64':
            str = $7c3b72a365cc0275$var$Base64_decode(data);
            break;
        case 'binary':
            str = data;
            break;
        case 'buffer':
            str = data.toString('binary');
            break;
        case 'array':
            str = $7c3b72a365cc0275$var$cc2str(data);
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $7c3b72a365cc0275$var$utf8read(str);
    o.type = "binary";
    return $7c3b72a365cc0275$var$read_plaintext(str, o);
}
function $7c3b72a365cc0275$var$read_utf16(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var d = data;
    if (o.type == 'base64') d = $7c3b72a365cc0275$var$Base64_decode(d);
    d = $7c3b72a365cc0275$var$$cptable.utils.decode(1200, d.slice(2), 'str');
    o.type = "binary";
    return $7c3b72a365cc0275$var$read_plaintext(d, o);
}
function $7c3b72a365cc0275$var$bstrify(data /*:string*/ ) /*:string*/ {
    return !data.match(/[^\x00-\x7F]/) ? data : $7c3b72a365cc0275$var$utf8write(data);
}
function $7c3b72a365cc0275$var$read_prn(data, d, o, str) {
    if (str) {
        o.type = "string";
        return $7c3b72a365cc0275$var$PRN.to_workbook(data, o);
    }
    return $7c3b72a365cc0275$var$PRN.to_workbook(d, o);
}
function $7c3b72a365cc0275$export$aafa59e2e03f2942(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $7c3b72a365cc0275$var$reset_cp();
    var o = opts || {};
    if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return $7c3b72a365cc0275$export$aafa59e2e03f2942(new Uint8Array(data), (o = $7c3b72a365cc0275$var$dup(o), o.type = "array", o));
    if (typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
    var d = data, n = [
        0,
        0,
        0,
        0
    ], str = false;
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    $7c3b72a365cc0275$var$_ssfopts = {};
    if (o.dateNF) $7c3b72a365cc0275$var$_ssfopts.dateNF = o.dateNF;
    if (!o.type) o.type = $7c3b72a365cc0275$var$has_buf && $7c3b72a365cc0275$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    if (o.type == "file") {
        o.type = $7c3b72a365cc0275$var$has_buf ? "buffer" : "binary";
        d = $7c3b72a365cc0275$var$read_binary(data);
        if (typeof Uint8Array !== 'undefined' && !$7c3b72a365cc0275$var$has_buf) o.type = "array";
    }
    if (o.type == "string") {
        str = true;
        o.type = "binary";
        o.codepage = 65001;
        d = $7c3b72a365cc0275$var$bstrify(data);
    }
    if (o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
        // $FlowIgnore
        var ab = new ArrayBuffer(3), vu = new Uint8Array(ab);
        vu.foo = "bar";
        // $FlowIgnore
        if (!vu.foo) {
            o = $7c3b72a365cc0275$var$dup(o);
            o.type = 'array';
            return $7c3b72a365cc0275$export$aafa59e2e03f2942($7c3b72a365cc0275$var$ab2a(d), o);
        }
    }
    switch((n = $7c3b72a365cc0275$var$firstbyte(d, o))[0]){
        case 0xD0:
            if (n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return $7c3b72a365cc0275$var$read_cfb($7c3b72a365cc0275$export$9f0e51cd97c572a.read(d, o), o);
            break;
        case 0x09:
            if (n[1] <= 0x08) return $7c3b72a365cc0275$export$b41972a043aba84c(d, o);
            break;
        case 0x3C:
            return $7c3b72a365cc0275$var$parse_xlml(d, o);
        case 0x49:
            if (n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
            if (n[1] === 0x44) return $7c3b72a365cc0275$var$read_wb_ID(d, o);
            break;
        case 0x54:
            if (n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return $7c3b72a365cc0275$var$DIF.to_workbook(d, o);
            break;
        case 0x50:
            return n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09 ? $7c3b72a365cc0275$var$read_zip(d, o) : $7c3b72a365cc0275$var$read_prn(data, d, o, str);
        case 0xEF:
            return n[3] === 0x3C ? $7c3b72a365cc0275$var$parse_xlml(d, o) : $7c3b72a365cc0275$var$read_prn(data, d, o, str);
        case 0xFF:
            if (n[1] === 0xFE) return $7c3b72a365cc0275$var$read_utf16(d, o);
            else if (n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return $7c3b72a365cc0275$var$WK_.to_workbook(d, o);
            break;
        case 0x00:
            if (n[1] === 0x00) {
                if (n[2] >= 0x02 && n[3] === 0x00) return $7c3b72a365cc0275$var$WK_.to_workbook(d, o);
                if (n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return $7c3b72a365cc0275$var$WK_.to_workbook(d, o);
            }
            break;
        case 0x03:
        case 0x83:
        case 0x8B:
        case 0x8C:
            return $7c3b72a365cc0275$var$DBF.to_workbook(d, o);
        case 0x7B:
            if (n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return $7c3b72a365cc0275$var$RTF.to_workbook(d, o);
            break;
        case 0x0A:
        case 0x0D:
        case 0x20:
            return $7c3b72a365cc0275$var$read_plaintext_raw(d, o);
        case 0x89:
            if (n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet");
            break;
    }
    if ($7c3b72a365cc0275$var$DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return $7c3b72a365cc0275$var$DBF.to_workbook(d, o);
    return $7c3b72a365cc0275$var$read_prn(data, d, o, str);
}
function $7c3b72a365cc0275$export$72c04af63de9061a(filename /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var o = opts || {};
    o.type = 'file';
    return $7c3b72a365cc0275$export$aafa59e2e03f2942(filename, o);
}
function $7c3b72a365cc0275$var$write_cfb_ctr(cfb /*:CFBContainer*/ , o /*:WriteOpts*/ ) /*:any*/ {
    switch(o.type){
        case "base64":
        case "binary":
            break;
        case "buffer":
        case "array":
            o.type = "";
            break;
        case "file":
            return $7c3b72a365cc0275$var$write_dl(o.file, $7c3b72a365cc0275$export$9f0e51cd97c572a.write(cfb, {
                type: $7c3b72a365cc0275$var$has_buf ? 'buffer' : ""
            }));
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    return $7c3b72a365cc0275$export$9f0e51cd97c572a.write(cfb, o);
}
/*:: declare var encrypt_agile:any; */ function $7c3b72a365cc0275$var$write_zip_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $7c3b72a365cc0275$var$dup(opts || {});
    var z = $7c3b72a365cc0275$var$write_zip(wb, o);
    return $7c3b72a365cc0275$var$write_zip_denouement(z, o);
}
function $7c3b72a365cc0275$var$write_zip_typeXLSX(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $7c3b72a365cc0275$var$dup(opts || {});
    var z = $7c3b72a365cc0275$var$write_zip_xlsx(wb, o);
    return $7c3b72a365cc0275$var$write_zip_denouement(z, o);
}
function $7c3b72a365cc0275$var$write_zip_denouement(z /*:any*/ , o /*:?WriteOpts*/ ) /*:any*/ {
    var oopts = {};
    var ftype = $7c3b72a365cc0275$var$has_buf ? "nodebuffer" : typeof Uint8Array !== "undefined" ? "array" : "string";
    if (o.compression) oopts.compression = 'DEFLATE';
    if (o.password) oopts.type = ftype;
    else switch(o.type){
        case "base64":
            oopts.type = "base64";
            break;
        case "binary":
            oopts.type = "string";
            break;
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        case "buffer":
        case "file":
            oopts.type = ftype;
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    var out = z.FullPaths ? $7c3b72a365cc0275$export$9f0e51cd97c572a.write(z, {
        fileType: "zip",
        type: /*::(*/ {
            "nodebuffer": "buffer",
            "string": "binary"
        } /*:: :any)*/ [oopts.type] || oopts.type,
        compression: !!o.compression
    }) : z.generate(oopts);
    if (typeof Deno !== "undefined") {
        if (typeof out == "string") {
            if (o.type == "binary" || o.type == "base64") return out;
            out = new Uint8Array($7c3b72a365cc0275$var$s2ab(out));
        }
    }
    /*jshint -W083 */ if (o.password && typeof encrypt_agile !== 'undefined') return $7c3b72a365cc0275$var$write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
    /*jshint +W083 */ if (o.type === "file") return $7c3b72a365cc0275$var$write_dl(o.file, out);
    return o.type == "string" ? $7c3b72a365cc0275$var$utf8read(/*::(*/ out /*:: :any)*/ ) : out;
}
function $7c3b72a365cc0275$var$write_cfb_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = opts || {};
    var cfb /*:CFBContainer*/  = $7c3b72a365cc0275$var$write_xlscfb(wb, o);
    return $7c3b72a365cc0275$var$write_cfb_ctr(cfb, o);
}
function $7c3b72a365cc0275$var$write_string_type(out /*:string*/ , opts /*:WriteOpts*/ , bom /*:?string*/ ) /*:any*/ {
    if (!bom) bom = "";
    var o = bom + out;
    switch(opts.type){
        case "base64":
            return $7c3b72a365cc0275$var$Base64_encode($7c3b72a365cc0275$var$utf8write(o));
        case "binary":
            return $7c3b72a365cc0275$var$utf8write(o);
        case "string":
            return out;
        case "file":
            return $7c3b72a365cc0275$var$write_dl(opts.file, o, 'utf8');
        case "buffer":
            if ($7c3b72a365cc0275$var$has_buf) return $7c3b72a365cc0275$var$Buffer_from(o, 'utf8');
            else if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
            else return $7c3b72a365cc0275$var$write_string_type(o, {
                type: 'binary'
            }).split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $7c3b72a365cc0275$var$write_stxt_type(out /*:string*/ , opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "base64":
            return $7c3b72a365cc0275$var$Base64_encode(out);
        case "binary":
            return out;
        case "string":
            return out; /* override in sheet_to_txt */ 
        case "file":
            return $7c3b72a365cc0275$var$write_dl(opts.file, out, 'binary');
        case "buffer":
            if ($7c3b72a365cc0275$var$has_buf) return $7c3b72a365cc0275$var$Buffer_from(out, 'binary');
            else return out.split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
/* TODO: test consistency */ function $7c3b72a365cc0275$var$write_binary_type(out, opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "string":
        case "base64":
        case "binary":
            var bstr = "";
            // $FlowIgnore
            for(var i = 0; i < out.length; ++i)bstr += String.fromCharCode(out[i]);
            return opts.type == 'base64' ? $7c3b72a365cc0275$var$Base64_encode(bstr) : opts.type == 'string' ? $7c3b72a365cc0275$var$utf8read(bstr) : bstr;
        case "file":
            return $7c3b72a365cc0275$var$write_dl(opts.file, out);
        case "buffer":
            return out;
        default:
            throw new Error("Unrecognized type " + opts.type);
    }
}
function $7c3b72a365cc0275$export$f6ca43591cb061b1(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $7c3b72a365cc0275$var$reset_cp();
    $7c3b72a365cc0275$var$check_wb(wb);
    var o = $7c3b72a365cc0275$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $7c3b72a365cc0275$export$f6ca43591cb061b1(wb, o);
        o.type = "array";
        return $7c3b72a365cc0275$var$s2ab(out);
    }
    return $7c3b72a365cc0275$var$write_zip_typeXLSX(wb, o);
}
function $7c3b72a365cc0275$export$68d8715fc104d294(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $7c3b72a365cc0275$var$reset_cp();
    $7c3b72a365cc0275$var$check_wb(wb);
    var o = $7c3b72a365cc0275$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $7c3b72a365cc0275$export$68d8715fc104d294(wb, o);
        o.type = "array";
        return $7c3b72a365cc0275$var$s2ab(out);
    }
    var idx = 0;
    if (o.sheet) {
        if (typeof o.sheet == "number") idx = o.sheet;
        else idx = wb.SheetNames.indexOf(o.sheet);
        if (!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + typeof o.sheet);
    }
    switch(o.bookType || 'xlsb'){
        case 'xml':
        case 'xlml':
            return $7c3b72a365cc0275$var$write_string_type($7c3b72a365cc0275$var$write_xlml(wb, o), o);
        case 'slk':
        case 'sylk':
            return $7c3b72a365cc0275$var$write_string_type($7c3b72a365cc0275$var$SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'htm':
        case 'html':
            return $7c3b72a365cc0275$var$write_string_type($7c3b72a365cc0275$var$sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'txt':
            return $7c3b72a365cc0275$var$write_stxt_type($7c3b72a365cc0275$var$sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'csv':
            return $7c3b72a365cc0275$var$write_string_type($7c3b72a365cc0275$var$sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\ufeff");
        case 'dif':
            return $7c3b72a365cc0275$var$write_string_type($7c3b72a365cc0275$var$DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'dbf':
            return $7c3b72a365cc0275$var$write_binary_type($7c3b72a365cc0275$var$DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'prn':
            return $7c3b72a365cc0275$var$write_string_type($7c3b72a365cc0275$var$PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'rtf':
            return $7c3b72a365cc0275$var$write_string_type($7c3b72a365cc0275$var$RTF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'eth':
            return $7c3b72a365cc0275$var$write_string_type($7c3b72a365cc0275$var$ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'fods':
            return $7c3b72a365cc0275$var$write_string_type($7c3b72a365cc0275$var$write_ods(wb, o), o);
        case 'wk1':
            return $7c3b72a365cc0275$var$write_binary_type($7c3b72a365cc0275$var$WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'wk3':
            return $7c3b72a365cc0275$var$write_binary_type($7c3b72a365cc0275$var$WK_.book_to_wk3(wb, o), o);
        case 'biff2':
            if (!o.biff) o.biff = 2; /* falls through */ 
        case 'biff3':
            if (!o.biff) o.biff = 3; /* falls through */ 
        case 'biff4':
            if (!o.biff) o.biff = 4;
            return $7c3b72a365cc0275$var$write_binary_type($7c3b72a365cc0275$var$write_biff_buf(wb, o), o);
        case 'biff5':
            if (!o.biff) o.biff = 5; /* falls through */ 
        case 'biff8':
        case 'xla':
        case 'xls':
            if (!o.biff) o.biff = 8;
            return $7c3b72a365cc0275$var$write_cfb_type(wb, o);
        case 'xlsx':
        case 'xlsm':
        case 'xlam':
        case 'xlsb':
        case 'numbers':
        case 'ods':
            return $7c3b72a365cc0275$var$write_zip_type(wb, o);
        default:
            throw new Error("Unrecognized bookType |" + o.bookType + "|");
    }
}
function $7c3b72a365cc0275$var$resolve_book_type(o /*:WriteFileOpts*/ ) {
    if (o.bookType) return;
    var _BT = {
        "xls": "biff8",
        "htm": "html",
        "slk": "sylk",
        "socialcalc": "eth",
        "Sh33tJS": "WTF"
    };
    var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
    if (ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
    o.bookType = _BT[o.bookType] || o.bookType;
}
function $7c3b72a365cc0275$export$552bfb764b5cd2b4(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $7c3b72a365cc0275$var$resolve_book_type(o);
    return $7c3b72a365cc0275$export$68d8715fc104d294(wb, o);
}
function $7c3b72a365cc0275$export$40a06aea54ee074e(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $7c3b72a365cc0275$var$resolve_book_type(o);
    return $7c3b72a365cc0275$export$f6ca43591cb061b1(wb, o);
}
function $7c3b72a365cc0275$export$25469296c4b8ebda(filename /*:string*/ , wb /*:Workbook*/ , opts /*:?WriteFileOpts*/ , cb /*:?(e?:ErrnoError)=>void*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $7c3b72a365cc0275$var$resolve_book_type(o);
    o.type = 'buffer';
    var _cb = cb;
    if (!(_cb instanceof Function)) _cb = opts /*:any*/ ;
    return $7c3b72a365cc0275$var$_fs.writeFile(filename, $7c3b72a365cc0275$export$68d8715fc104d294(wb, o), _cb);
}
/*::
type MJRObject = {
	row: any;
	isempty: boolean;
};
*/ function $7c3b72a365cc0275$var$make_json_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , header /*:number*/ , hdr /*:Array<any>*/ , dense /*:boolean*/ , o /*:Sheet2JSONOpts*/ ) /*:MJRObject*/ {
    var rr = $7c3b72a365cc0275$var$encode_row(R);
    var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
    var isempty = true;
    var row /*:any*/  = header === 1 ? [] : {};
    if (header !== 1) {
        if (Object.defineProperty) try {
            Object.defineProperty(row, '__rowNum__', {
                value: R,
                enumerable: false
            });
        } catch (e) {
            row.__rowNum__ = R;
        }
        else row.__rowNum__ = R;
    }
    if (!dense || sheet[R]) for(var C = r.s.c; C <= r.e.c; ++C){
        var val = dense ? sheet[R][C] : sheet[cols[C] + rr];
        if (val === undefined || val.t === undefined) {
            if (defval === undefined) continue;
            if (hdr[C] != null) row[hdr[C]] = defval;
            continue;
        }
        var v = val.v;
        switch(val.t){
            case 'z':
                if (v == null) break;
                continue;
            case 'e':
                v = v == 0 ? null : void 0;
                break;
            case 's':
            case 'd':
            case 'b':
            case 'n':
                break;
            default:
                throw new Error('unrecognized type ' + val.t);
        }
        if (hdr[C] != null) {
            if (v == null) {
                if (val.t == "e" && v === null) row[hdr[C]] = null;
                else if (defval !== undefined) row[hdr[C]] = defval;
                else if (raw && v === null) row[hdr[C]] = null;
                else continue;
            } else row[hdr[C]] = raw && (val.t !== "n" || val.t === "n" && o.rawNumbers !== false) ? v : $7c3b72a365cc0275$var$format_cell(val, v, o);
            if (v != null) isempty = false;
        }
    }
    return {
        row: row,
        isempty: isempty
    };
}
function $7c3b72a365cc0275$var$sheet_to_json(sheet /*:Worksheet*/ , opts /*:?Sheet2JSONOpts*/ ) {
    if (sheet == null || sheet["!ref"] == null) return [];
    var val = {
        t: 'n',
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    else if (o.header == null) header = 0;
    switch(typeof range){
        case 'string':
            r = $7c3b72a365cc0275$var$safe_decode_range(range);
            break;
        case 'number':
            r = $7c3b72a365cc0275$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $7c3b72a365cc0275$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var out /*:Array<any>*/  = [];
    var outi = 0, counter = 0;
    var dense = Array.isArray(sheet);
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet[R]) sheet[R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $7c3b72a365cc0275$var$encode_col(C);
        val = dense ? sheet[R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val == null) val = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $7c3b72a365cc0275$var$format_cell(val, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    for(R = r.s.r + offset; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        var row = $7c3b72a365cc0275$var$make_json_row(sheet, r, R, cols, header, hdr, dense, o);
        if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
    }
    out.length = outi;
    return out;
}
var $7c3b72a365cc0275$var$qreg = /"/g;
function $7c3b72a365cc0275$var$make_csv_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , fs /*:number*/ , rs /*:number*/ , FS /*:string*/ , o /*:Sheet2CSVOpts*/ ) /*:?string*/ {
    var isempty = true;
    var row /*:Array<string>*/  = [], txt = "", rr = $7c3b72a365cc0275$var$encode_row(R);
    for(var C = r.s.c; C <= r.e.c; ++C){
        if (!cols[C]) continue;
        var val = o.dense ? (sheet[R] || [])[C] : sheet[cols[C] + rr];
        if (val == null) txt = "";
        else if (val.v != null) {
            isempty = false;
            txt = '' + (o.rawNumbers && val.t == "n" ? val.v : $7c3b72a365cc0275$var$format_cell(val, null, o));
            for(var i = 0, cc = 0; i !== txt.length; ++i)if ((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {
                txt = "\"" + txt.replace($7c3b72a365cc0275$var$qreg, '""') + "\"";
                break;
            }
            if (txt == "ID") txt = '"ID"';
        } else if (val.f != null && !val.F) {
            isempty = false;
            txt = '=' + val.f;
            if (txt.indexOf(",") >= 0) txt = '"' + txt.replace($7c3b72a365cc0275$var$qreg, '""') + '"';
        } else txt = "";
        /* NOTE: Excel CSV does not support array formulae */ row.push(txt);
    }
    if (o.blankrows === false && isempty) return null;
    return row.join(FS);
}
function $7c3b72a365cc0275$var$sheet_to_csv(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) return "";
    var r = $7c3b72a365cc0275$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var endregex = new RegExp((FS == "|" ? "\\|" : FS) + "+$");
    var row = "", cols /*:Array<string>*/  = [];
    o.dense = Array.isArray(sheet);
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $7c3b72a365cc0275$var$encode_col(C);
    var w = 0;
    for(var R = r.s.r; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        row = $7c3b72a365cc0275$var$make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
        if (row == null) continue;
        if (o.strip) row = row.replace(endregex, "");
        if (row || o.blankrows !== false) out.push((w++ ? RS : "") + row);
    }
    delete o.dense;
    return out.join("");
}
function $7c3b72a365cc0275$var$sheet_to_txt(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    if (!opts) opts = {};
    opts.FS = "\t";
    opts.RS = "\n";
    var s = $7c3b72a365cc0275$var$sheet_to_csv(sheet, opts);
    if (typeof $7c3b72a365cc0275$var$$cptable == 'undefined' || opts.type == 'string') return s;
    var o = $7c3b72a365cc0275$var$$cptable.utils.encode(1200, s, 'str');
    return String.fromCharCode(255) + String.fromCharCode(254) + o;
}
function $7c3b72a365cc0275$var$sheet_to_formulae(sheet /*:Worksheet*/ ) /*:Array<string>*/ {
    var y = "", x, val = "";
    if (sheet == null || sheet["!ref"] == null) return [];
    var r = $7c3b72a365cc0275$var$safe_decode_range(sheet['!ref']), rr = "", cols /*:Array<string>*/  = [], C;
    var cmds /*:Array<string>*/  = [];
    var dense = Array.isArray(sheet);
    for(C = r.s.c; C <= r.e.c; ++C)cols[C] = $7c3b72a365cc0275$var$encode_col(C);
    for(var R = r.s.r; R <= r.e.r; ++R){
        rr = $7c3b72a365cc0275$var$encode_row(R);
        for(C = r.s.c; C <= r.e.c; ++C){
            y = cols[C] + rr;
            x = dense ? (sheet[R] || [])[C] : sheet[y];
            val = "";
            if (x === undefined) continue;
            else if (x.F != null) {
                y = x.F;
                if (!x.f) continue;
                val = x.f;
                if (y.indexOf(":") == -1) y = y + ":" + y;
            }
            if (x.f != null) val = x.f;
            else if (x.t == 'z') continue;
            else if (x.t == 'n' && x.v != null) val = "" + x.v;
            else if (x.t == 'b') val = x.v ? "TRUE" : "FALSE";
            else if (x.w !== undefined) val = "'" + x.w;
            else if (x.v === undefined) continue;
            else if (x.t == 's') val = "'" + x.v;
            else val = "" + x.v;
            cmds[cmds.length] = y + "=" + val;
        }
    }
    return cmds;
}
function $7c3b72a365cc0275$var$sheet_add_json(_ws /*:?Worksheet*/ , js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    var o = opts || {};
    var offset = +!o.skipHeader;
    var ws /*:Worksheet*/  = _ws || {} /*:any*/ ;
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == 'number') _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $7c3b72a365cc0275$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var cell /*:Cell*/ ;
    var range /*:Range*/  = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: _C,
            r: _R + js.length - 1 + offset
        }
    } /*:any*/ ;
    if (ws['!ref']) {
        var _range = $7c3b72a365cc0275$var$safe_decode_range(ws['!ref']);
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) {
            _R = _range.e.r + 1;
            range.e.r = _R + js.length - 1 + offset;
        }
    } else if (_R == -1) {
        _R = 0;
        range.e.r = js.length - 1 + offset;
    }
    var hdr /*:Array<string>*/  = o.header || [], C = 0;
    js.forEach(function(JS, R /*:number*/ ) {
        $7c3b72a365cc0275$var$keys(JS).forEach(function(k) {
            if ((C = hdr.indexOf(k)) == -1) hdr[C = hdr.length] = k;
            var v = JS[k];
            var t = 'z';
            var z = "";
            var ref = $7c3b72a365cc0275$var$encode_cell({
                c: _C + C,
                r: _R + R + offset
            });
            cell = $7c3b72a365cc0275$var$ws_get_cell_stub(ws, ref);
            if (v && typeof v === 'object' && !(v instanceof Date)) ws[ref] = v;
            else {
                if (typeof v == 'number') t = 'n';
                else if (typeof v == 'boolean') t = 'b';
                else if (typeof v == 'string') t = 's';
                else if (v instanceof Date) {
                    t = 'd';
                    if (!o.cellDates) {
                        t = 'n';
                        v = $7c3b72a365cc0275$var$datenum(v);
                    }
                    z = o.dateNF || $7c3b72a365cc0275$var$table_fmt[14];
                } else if (v === null && o.nullError) {
                    t = 'e';
                    v = 0;
                }
                if (!cell) ws[ref] = cell = {
                    t: t,
                    v: v
                } /*:any*/ ;
                else {
                    cell.t = t;
                    cell.v = v;
                    delete cell.w;
                    delete cell.R;
                    if (z) cell.z = z;
                }
                if (z) cell.z = z;
            }
        });
    });
    range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
    var __R = $7c3b72a365cc0275$var$encode_row(_R);
    if (offset) for(C = 0; C < hdr.length; ++C)ws[$7c3b72a365cc0275$var$encode_col(C + _C) + __R] = {
        t: 's',
        v: hdr[C]
    };
    ws['!ref'] = $7c3b72a365cc0275$var$encode_range(range);
    return ws;
}
function $7c3b72a365cc0275$var$json_to_sheet(js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    return $7c3b72a365cc0275$var$sheet_add_json(null, js, opts);
}
/* get cell, creating a stub if necessary */ function $7c3b72a365cc0275$var$ws_get_cell_stub(ws /*:Worksheet*/ , R, C /*:?number*/ ) /*:Cell*/ {
    /* A1 cell address */ if (typeof R == "string") {
        /* dense */ if (Array.isArray(ws)) {
            var RC = $7c3b72a365cc0275$var$decode_cell(R);
            if (!ws[RC.r]) ws[RC.r] = [];
            return ws[RC.r][RC.c] || (ws[RC.r][RC.c] = {
                t: 'z'
            });
        }
        return ws[R] || (ws[R] = {
            t: 'z'
        });
    }
    /* cell address object */ if (typeof R != "number") return $7c3b72a365cc0275$var$ws_get_cell_stub(ws, $7c3b72a365cc0275$var$encode_cell(R));
    /* R and C are 0-based indices */ return $7c3b72a365cc0275$var$ws_get_cell_stub(ws, $7c3b72a365cc0275$var$encode_cell({
        r: R,
        c: C || 0
    }));
}
/* find sheet index for given name / validate index */ function $7c3b72a365cc0275$var$wb_sheet_idx(wb /*:Workbook*/ , sh /*:number|string*/ ) {
    if (typeof sh == "number") {
        if (sh >= 0 && wb.SheetNames.length > sh) return sh;
        throw new Error("Cannot find sheet # " + sh);
    } else if (typeof sh == "string") {
        var idx = wb.SheetNames.indexOf(sh);
        if (idx > -1) return idx;
        throw new Error("Cannot find sheet name |" + sh + "|");
    } else throw new Error("Cannot find sheet |" + sh + "|");
}
/* simple blank workbook object */ function $7c3b72a365cc0275$var$book_new() /*:Workbook*/ {
    return {
        SheetNames: [],
        Sheets: {}
    };
}
/* add a worksheet to the end of a given workbook */ function $7c3b72a365cc0275$var$book_append_sheet(wb /*:Workbook*/ , ws /*:Worksheet*/ , name /*:?string*/ , roll /*:?boolean*/ ) /*:string*/ {
    var i = 1;
    if (!name) {
        for(; i <= 0xFFFF; ++i, name = undefined)if (wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
    }
    if (!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
    if (roll && wb.SheetNames.indexOf(name) >= 0) {
        var m = name.match(/(^.*?)(\d+)$/);
        i = m && +m[2] || 0;
        var root = m && m[1] || name;
        for(++i; i <= 0xFFFF; ++i)if (wb.SheetNames.indexOf(name = root + i) == -1) break;
    }
    $7c3b72a365cc0275$var$check_ws_name(name);
    if (wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
    wb.SheetNames.push(name);
    wb.Sheets[name] = ws;
    return name;
}
/* set sheet visibility (visible/hidden/very hidden) */ function $7c3b72a365cc0275$var$book_set_sheet_visibility(wb /*:Workbook*/ , sh /*:number|string*/ , vis /*:number*/ ) {
    if (!wb.Workbook) wb.Workbook = {};
    if (!wb.Workbook.Sheets) wb.Workbook.Sheets = [];
    var idx = $7c3b72a365cc0275$var$wb_sheet_idx(wb, sh);
    // $FlowIgnore
    if (!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};
    switch(vis){
        case 0:
        case 1:
        case 2:
            break;
        default:
            throw new Error("Bad sheet visibility setting " + vis);
    }
    // $FlowIgnore
    wb.Workbook.Sheets[idx].Hidden = vis;
}
/* set number format */ function $7c3b72a365cc0275$var$cell_set_number_format(cell /*:Cell*/ , fmt /*:string|number*/ ) {
    cell.z = fmt;
    return cell;
}
/* set cell hyperlink */ function $7c3b72a365cc0275$var$cell_set_hyperlink(cell /*:Cell*/ , target /*:string*/ , tooltip /*:?string*/ ) {
    if (!target) delete cell.l;
    else {
        cell.l = {
            Target: target
        } /*:Hyperlink*/ ;
        if (tooltip) cell.l.Tooltip = tooltip;
    }
    return cell;
}
function $7c3b72a365cc0275$var$cell_set_internal_link(cell /*:Cell*/ , range /*:string*/ , tooltip /*:?string*/ ) {
    return $7c3b72a365cc0275$var$cell_set_hyperlink(cell, "#" + range, tooltip);
}
/* add to cell comments */ function $7c3b72a365cc0275$var$cell_add_comment(cell /*:Cell*/ , text /*:string*/ , author /*:?string*/ ) {
    if (!cell.c) cell.c = [];
    cell.c.push({
        t: text,
        a: author || "SheetJS"
    });
}
/* set array formula and flush related cells */ function $7c3b72a365cc0275$var$sheet_set_array_formula(ws /*:Worksheet*/ , range, formula /*:string*/ , dynamic /*:boolean*/ ) {
    var rng = typeof range != "string" ? range : $7c3b72a365cc0275$var$safe_decode_range(range);
    var rngstr = typeof range == "string" ? range : $7c3b72a365cc0275$var$encode_range(range);
    for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
        var cell = $7c3b72a365cc0275$var$ws_get_cell_stub(ws, R, C);
        cell.t = 'n';
        cell.F = rngstr;
        delete cell.v;
        if (R == rng.s.r && C == rng.s.c) {
            cell.f = formula;
            if (dynamic) cell.D = true;
        }
    }
    return ws;
}
var $7c3b72a365cc0275$export$eab97d15b1788b8d /*:any*/  = {
    encode_col: $7c3b72a365cc0275$var$encode_col,
    encode_row: $7c3b72a365cc0275$var$encode_row,
    encode_cell: $7c3b72a365cc0275$var$encode_cell,
    encode_range: $7c3b72a365cc0275$var$encode_range,
    decode_col: $7c3b72a365cc0275$var$decode_col,
    decode_row: $7c3b72a365cc0275$var$decode_row,
    split_cell: $7c3b72a365cc0275$var$split_cell,
    decode_cell: $7c3b72a365cc0275$var$decode_cell,
    decode_range: $7c3b72a365cc0275$var$decode_range,
    format_cell: $7c3b72a365cc0275$var$format_cell,
    sheet_add_aoa: $7c3b72a365cc0275$var$sheet_add_aoa,
    sheet_add_json: $7c3b72a365cc0275$var$sheet_add_json,
    sheet_add_dom: $7c3b72a365cc0275$var$sheet_add_dom,
    aoa_to_sheet: $7c3b72a365cc0275$var$aoa_to_sheet,
    json_to_sheet: $7c3b72a365cc0275$var$json_to_sheet,
    table_to_sheet: $7c3b72a365cc0275$var$parse_dom_table,
    table_to_book: $7c3b72a365cc0275$var$table_to_book,
    sheet_to_csv: $7c3b72a365cc0275$var$sheet_to_csv,
    sheet_to_txt: $7c3b72a365cc0275$var$sheet_to_txt,
    sheet_to_json: $7c3b72a365cc0275$var$sheet_to_json,
    sheet_to_html: $7c3b72a365cc0275$var$sheet_to_html,
    sheet_to_formulae: $7c3b72a365cc0275$var$sheet_to_formulae,
    sheet_to_row_object_array: $7c3b72a365cc0275$var$sheet_to_json,
    sheet_get_cell: $7c3b72a365cc0275$var$ws_get_cell_stub,
    book_new: $7c3b72a365cc0275$var$book_new,
    book_append_sheet: $7c3b72a365cc0275$var$book_append_sheet,
    book_set_sheet_visibility: $7c3b72a365cc0275$var$book_set_sheet_visibility,
    cell_set_number_format: $7c3b72a365cc0275$var$cell_set_number_format,
    cell_set_hyperlink: $7c3b72a365cc0275$var$cell_set_hyperlink,
    cell_set_internal_link: $7c3b72a365cc0275$var$cell_set_internal_link,
    cell_add_comment: $7c3b72a365cc0275$var$cell_add_comment,
    sheet_set_array_formula: $7c3b72a365cc0275$var$sheet_set_array_formula,
    consts: {
        SHEET_VISIBLE: 0,
        SHEET_HIDDEN: 1,
        SHEET_VERY_HIDDEN: 2
    }
};
var $7c3b72a365cc0275$var$_Readable;
function $7c3b72a365cc0275$var$set_readable(R) {
    $7c3b72a365cc0275$var$_Readable = R;
}
function $7c3b72a365cc0275$var$write_csv_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $7c3b72a365cc0275$var$_Readable();
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var r = $7c3b72a365cc0275$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var endregex = new RegExp((FS == "|" ? "\\|" : FS) + "+$");
    var row /*:?string*/  = "", cols /*:Array<string>*/  = [];
    o.dense = Array.isArray(sheet);
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $7c3b72a365cc0275$var$encode_col(C);
    var R = r.s.r;
    var BOM = false, w = 0;
    stream._read = function() {
        if (!BOM) {
            BOM = true;
            return stream.push("\uFEFF");
        }
        while(R <= r.e.r){
            ++R;
            if ((rowinfo[R - 1] || {}).hidden) continue;
            row = $7c3b72a365cc0275$var$make_csv_row(sheet, r, R - 1, cols, fs, rs, FS, o);
            if (row != null) {
                if (o.strip) row = row.replace(endregex, "");
                if (row || o.blankrows !== false) return stream.push((w++ ? RS : "") + row);
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $7c3b72a365cc0275$var$write_html_stream(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/ ) {
    var stream = $7c3b72a365cc0275$var$_Readable();
    var o = opts || {};
    var header = o.header != null ? o.header : $7c3b72a365cc0275$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $7c3b72a365cc0275$var$HTML_END;
    stream.push(header);
    var r = $7c3b72a365cc0275$var$decode_range(ws['!ref']);
    o.dense = Array.isArray(ws);
    stream.push($7c3b72a365cc0275$var$make_html_preamble(ws, r, o));
    var R = r.s.r;
    var end = false;
    stream._read = function() {
        if (R > r.e.r) {
            if (!end) {
                end = true;
                stream.push("</table>" + footer);
            }
            return stream.push(null);
        }
        while(R <= r.e.r){
            stream.push($7c3b72a365cc0275$var$make_html_row(ws, r, R, o));
            ++R;
            break;
        }
    };
    return stream;
}
function $7c3b72a365cc0275$var$write_json_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $7c3b72a365cc0275$var$_Readable({
        objectMode: true
    });
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var val = {
        t: 'n',
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    switch(typeof range){
        case 'string':
            r = $7c3b72a365cc0275$var$safe_decode_range(range);
            break;
        case 'number':
            r = $7c3b72a365cc0275$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $7c3b72a365cc0275$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var counter = 0;
    var dense = Array.isArray(sheet);
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet[R]) sheet[R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $7c3b72a365cc0275$var$encode_col(C);
        val = dense ? sheet[R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val == null) val = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $7c3b72a365cc0275$var$format_cell(val, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    R = r.s.r + offset;
    stream._read = function() {
        while(R <= r.e.r){
            if ((rowinfo[R - 1] || {}).hidden) continue;
            var row = $7c3b72a365cc0275$var$make_json_row(sheet, r, R, cols, header, hdr, dense, o);
            ++R;
            if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
                stream.push(row.row);
                return;
            }
        }
        return stream.push(null);
    };
    return stream;
}
var $7c3b72a365cc0275$export$4938110305e6185f = {
    to_json: $7c3b72a365cc0275$var$write_json_stream,
    to_html: $7c3b72a365cc0275$var$write_html_stream,
    to_csv: $7c3b72a365cc0275$var$write_csv_stream,
    set_readable: $7c3b72a365cc0275$var$set_readable
};
const $7c3b72a365cc0275$export$83d89fbfd8236492 = $7c3b72a365cc0275$var$XLSX.version;




function $1080b5c0ea382d39$var$normHeader(s) {
    return String(s ?? "").trim().toLowerCase().replace(/\s+/g, " ");
}
function $1080b5c0ea382d39$var$findCol(headers, ...candidates) {
    const h = headers.map($1080b5c0ea382d39$var$normHeader);
    for (const c of candidates){
        const n = $1080b5c0ea382d39$var$normHeader(c);
        const i = h.findIndex((x)=>x === n || x.includes(n) || n.includes(x));
        if (i >= 0) return i;
    }
    return -1;
}
/** Exact header “District” only — avoids substring false positives (e.g. “constituency”). */ function $1080b5c0ea382d39$var$findDistrictCol(headers) {
    const h = headers.map($1080b5c0ea382d39$var$normHeader);
    const exact = [
        "district",
        "district name",
        "name of district",
        "name of the district",
        "dist",
        "dist name",
        "name of dist",
        "name of the dist"
    ];
    for (const ex of exact){
        const i = h.findIndex((x)=>x === ex);
        if (i >= 0) return i;
    }
    return -1;
}
function $1080b5c0ea382d39$var$findSlNoCol(headers) {
    const h = headers.map($1080b5c0ea382d39$var$normHeader);
    const exact = [
        "sl no",
        "s.no",
        "slno",
        "serial no",
        "serial number",
        "s no"
    ];
    for (const ex of exact){
        const i = h.findIndex((x)=>x === ex);
        if (i >= 0) return i;
    }
    return $1080b5c0ea382d39$var$findCol(headers, "sl no", "serial");
}
function $1080b5c0ea382d39$export$ec96d96dcde49aa0(data, opts) {
    const wb = $7c3b72a365cc0275$export$aafa59e2e03f2942(data, {
        type: "array"
    });
    const sheet = wb.Sheets[wb.SheetNames[0]];
    const emptyStats = (lineCount)=>({
            fileLineCount: lineCount,
            rowsAccepted: 0,
            skippedNoAppToken: 0,
            skippedNoMandalVillage: 0,
            skippedShortApplicant: 0,
            skippedRequiredBlank: 0,
            looseLineFallbacks: 0
        });
    if (!sheet) return {
        districtKey: null,
        rows: [],
        stats: emptyStats(0)
    };
    const matrix = $7c3b72a365cc0275$export$eab97d15b1788b8d.sheet_to_json(sheet, {
        header: 1,
        defval: "",
        raw: false
    });
    let headerRowIdx = -1;
    const headers = [];
    for(let i = 0; i < Math.min(matrix.length, 30); i++){
        const row = matrix[i] ?? [];
        const joined = row.map((c)=>String(c ?? "")).join(" ");
        if (/district\s*[-–]/i.test(joined)) {
            const dk = (0, $4d458044ff7299c6$export$18ff105403df77a4)(joined);
            dk;
        }
        const lower = joined.toLowerCase();
        if (lower.includes("mandal") && lower.includes("village") && (lower.includes("applicant") || lower.includes("name"))) {
            headerRowIdx = i;
            for (const c of row)headers.push(String(c ?? ""));
            break;
        }
    }
    if (headerRowIdx < 0) return {
        districtKey: null,
        rows: [],
        stats: emptyStats(matrix.length)
    };
    const iMandal = $1080b5c0ea382d39$var$findCol(headers, "name of the mandal", "mandal");
    const iVillage = $1080b5c0ea382d39$var$findCol(headers, "village name", "village");
    /** Prefer explicit “Application No” so we do not treat S.No as part of the application number. */ const iApp = $1080b5c0ea382d39$var$findCol(headers, "application no", "application number", "sno application", "application");
    const iName = $1080b5c0ea382d39$var$findCol(headers, "applicant name", "applicant");
    const iMobile = $1080b5c0ea382d39$var$findCol(headers, "mobile");
    const iAadhaar = $1080b5c0ea382d39$var$findCol(headers, "aadhaar");
    const iList = $1080b5c0ea382d39$var$findCol(headers, "list type", "initial list");
    const iStatus = $1080b5c0ea382d39$var$findCol(headers, "status", "application status");
    const iDistrict = $1080b5c0ea382d39$var$findDistrictCol(headers);
    const iSl = $1080b5c0ea382d39$var$findSlNoCol(headers);
    if (iMandal < 0 || iVillage < 0 || iApp < 0 || iName < 0) return {
        districtKey: null,
        rows: [],
        stats: emptyStats(matrix.length)
    };
    let documentDistrictKey = opts?.defaultDistrictKey ?? null;
    let currentMandal = "";
    let currentVillage = "";
    const rows = [];
    const stats = {
        fileLineCount: matrix.length,
        rowsAccepted: 0,
        skippedNoAppToken: 0,
        skippedNoMandalVillage: 0,
        skippedShortApplicant: 0,
        skippedRequiredBlank: 0,
        looseLineFallbacks: 0
    };
    for(let r = headerRowIdx + 1; r < matrix.length; r++){
        const excelRow = matrix[r] ?? [];
        const joined = excelRow.map((c)=>String(c ?? "").trim()).join(" ");
        const dk = (0, $4d458044ff7299c6$export$18ff105403df77a4)(joined) ?? (0, $4d458044ff7299c6$export$18ff105403df77a4)(String(excelRow[0] ?? ""));
        if (dk) {
            documentDistrictKey = dk;
            continue;
        }
        const cell = (i)=>i >= 0 ? String(excelRow[i] ?? "").trim() : "";
        let fm = cell(iMandal);
        let fv = cell(iVillage);
        const appCell = cell(iApp);
        const name = cell(iName);
        const mobile = (iMobile >= 0 ? cell(iMobile) : "").replace(/\D/g, "").slice(0, 15);
        const aadhaar = (iAadhaar >= 0 ? cell(iAadhaar) : "").replace(/\D/g, "").slice(0, 12);
        const listType = iList >= 0 ? cell(iList) : "";
        const applicationStatus = iStatus >= 0 ? cell(iStatus) : "";
        const districtCell = iDistrict >= 0 ? cell(iDistrict) : "";
        const rowDistrictKey = districtCell ? (0, $4d458044ff7299c6$export$16493bc9d946cb71)(districtCell) : null;
        const slCell = iSl >= 0 ? cell(iSl) : "";
        const slDigits = slCell.replace(/\D/g, "");
        if (!fm && !fv && !appCell && !name) continue;
        const parsedApp = (0, $4d458044ff7299c6$export$c2732a86a59b93fb)(appCell);
        const applicationRef = parsedApp?.applicationRef ?? appCell.replace(/^\d+\s+/, "").trim();
        const applicationSerial = slDigits && slDigits.length > 0 ? slDigits : parsedApp?.serial ?? "0";
        if (fm) currentMandal = fm;
        if (fv) currentVillage = fv;
        if (!parsedApp && !applicationRef) {
            stats.skippedNoAppToken += 1;
            continue;
        }
        if (!name || name.length < 1) {
            stats.skippedShortApplicant += 1;
            continue;
        }
        if (!mobile || !aadhaar || !listType || !applicationStatus || !(rowDistrictKey || documentDistrictKey || opts?.defaultDistrictKey)) {
            stats.skippedRequiredBlank += 1;
            continue;
        }
        if (!currentMandal || !currentVillage) {
            stats.skippedNoMandalVillage += 1;
            continue;
        }
        const parsedRow = {
            fileMandal: currentMandal,
            fileVillage: currentVillage,
            applicantName: name,
            mobile: mobile,
            aadhaarDigits: aadhaar,
            applicationRef: applicationRef || appCell,
            applicationSerial: applicationSerial,
            listType: listType,
            applicationStatus: applicationStatus
        };
        if (rowDistrictKey && (0, $72c1e8625e9e63b5$export$15dbe5472819b55d)(rowDistrictKey)) parsedRow.fileDistrictKey = rowDistrictKey;
        rows.push(parsedRow);
    }
    stats.rowsAccepted = rows.length;
    const keysFromRows = rows.map((r)=>r.fileDistrictKey).filter((k)=>!!(k && (0, $72c1e8625e9e63b5$export$15dbe5472819b55d)(k)));
    let aggregateDistrict = documentDistrictKey ?? opts?.defaultDistrictKey ?? null;
    if (keysFromRows.length === rows.length && rows.length > 0) {
        const k0 = keysFromRows[0];
        aggregateDistrict = keysFromRows.every((k)=>k === k0) ? k0 : null;
    }
    return {
        districtKey: aggregateDistrict,
        rows: rows,
        stats: stats
    };
}



/** Normalise for fuzzy comparison (same idea as geoLabel). */ function $0afbdc4f904df7f1$export$8a68d07ab0cc0f60(s) {
    return String(s ?? "").trim().toLowerCase().replace(/\s+/g, " ");
}
function $0afbdc4f904df7f1$export$bf89e973afcb2927(a, b) {
    const m = a.length;
    const n = b.length;
    if (m === 0) return n;
    if (n === 0) return m;
    const row = new Array(n + 1);
    for(let j = 0; j <= n; j++)row[j] = j;
    for(let i = 1; i <= m; i++){
        let prev = row[0];
        row[0] = i;
        for(let j = 1; j <= n; j++){
            const tmp = row[j];
            const cost = a[i - 1] === b[j - 1] ? 0 : 1;
            row[j] = Math.min(row[j] + 1, row[j - 1] + 1, prev + cost);
            prev = tmp;
        }
    }
    return row[n];
}
function $0afbdc4f904df7f1$export$996937ac79f3fd1f(a, b) {
    const x = $0afbdc4f904df7f1$export$8a68d07ab0cc0f60(a);
    const y = $0afbdc4f904df7f1$export$8a68d07ab0cc0f60(b);
    if (!x.length && !y.length) return 1;
    if (!x.length || !y.length) return 0;
    if (x === y) return 1;
    const d = $0afbdc4f904df7f1$export$bf89e973afcb2927(x, y);
    const maxLen = Math.max(x.length, y.length);
    return 1 - d / maxLen;
}
function $0afbdc4f904df7f1$export$e42d936345da11b5(query, candidates, getLabel, minScore) {
    let best = null;
    let bestScore = 0;
    for (const c of candidates){
        const s = $0afbdc4f904df7f1$export$996937ac79f3fd1f(query, getLabel(c));
        if (s > bestScore) {
            bestScore = s;
            best = c;
        }
    }
    if (best && bestScore >= minScore) return {
        item: best,
        score: bestScore
    };
    return null;
}



/** Minimum similarity (0–1) to accept a fuzzy village match when no exact/substring hit. */ const $24d7686700a3e8b0$var$FUZZY_VILLAGE_MIN_SCORE = 0.66;
function $24d7686700a3e8b0$export$142efbfe642d9c41(store, districtKey, fileMandal) {
    const nm = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(fileMandal);
    const m = store.tgMandalsForDistrict(districtKey).find((x)=>(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(x.mandalName) === nm);
    return m?.mandalName ?? null;
}
function $24d7686700a3e8b0$export$448074fd0d3dc43b(store, districtKey, canonicalMandal, fileVillage) {
    const villages = store.tgVillagesForMandal(districtKey, canonicalMandal);
    if (!villages.length) return null;
    const fv = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(fileVillage);
    const exact = villages.find((v)=>(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(v.name) === fv);
    if (exact) return {
        name: exact.name,
        fuzzy: false
    };
    const starts = villages.find((v)=>(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(v.name).startsWith(fv) || fv.startsWith((0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(v.name)));
    if (starts) return {
        name: starts.name,
        fuzzy: false
    };
    const includes = villages.find((v)=>(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(v.name).includes(fv) || fv.includes((0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(v.name)) || (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(v.name).replace(/\s+/g, "") === fv.replace(/\s+/g, ""));
    if (includes) return {
        name: includes.name,
        fuzzy: false
    };
    const fuzzy = (0, $0afbdc4f904df7f1$export$e42d936345da11b5)(fileVillage, villages, (v)=>v.name, $24d7686700a3e8b0$var$FUZZY_VILLAGE_MIN_SCORE);
    if (fuzzy) return {
        name: fuzzy.item.name,
        fuzzy: true
    };
    return null;
}
function $24d7686700a3e8b0$export$f684e5257c4aa24a(store, districtKey, parsed) {
    const matched = [];
    const unmatched = [];
    if (!store) {
        for (const r of parsed)unmatched.push({
            ...r,
            reason: "Geo directory not loaded."
        });
        return {
            matched: matched,
            unmatched: unmatched
        };
    }
    for (const r of parsed){
        const dKey = r.fileDistrictKey != null && (0, $72c1e8625e9e63b5$export$15dbe5472819b55d)(r.fileDistrictKey) ? r.fileDistrictKey : districtKey && (0, $72c1e8625e9e63b5$export$15dbe5472819b55d)(districtKey) ? districtKey : null;
        if (!dKey) {
            unmatched.push({
                ...r,
                reason: "Missing or unknown district for this row. Use a District column in Excel, or a \u201CDistrict - \u2026\u201D line in PDF exports."
            });
            continue;
        }
        const mandal = $24d7686700a3e8b0$export$142efbfe642d9c41(store, dKey, r.fileMandal);
        if (!mandal) {
            unmatched.push({
                ...r,
                reason: `Mandal "${r.fileMandal}" not found in ${dKey} directory.`
            });
            continue;
        }
        const villageHit = $24d7686700a3e8b0$export$448074fd0d3dc43b(store, dKey, mandal, r.fileVillage);
        if (!villageHit) {
            unmatched.push({
                ...r,
                reason: `Village "${r.fileVillage}" not found under mandal "${mandal}" in directory list.`
            });
            continue;
        }
        matched.push({
            ...r,
            districtKey: dKey,
            canonicalMandal: mandal,
            canonicalVillage: villageHit.name,
            villageMatchedFuzzy: villageHit.fuzzy
        });
    }
    return {
        matched: matched,
        unmatched: unmatched
    };
}




async function $d344741a629d67ca$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
async function $d344741a629d67ca$export$80ce7a218ee6e0d(body) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/geo/admin/villages-by-path`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $d344741a629d67ca$var$parseError(res));
    return res.json();
}





/** Village not on directory list under a resolved mandal. */ function $2e68d50886672da3$var$isMissingVillageRow(u) {
    return u.reason.includes("not found under mandal");
}
/** Mandal name from the file is not in that district’s directory (village was never checked). */ function $2e68d50886672da3$var$isMissingMandalRow(u) {
    return /^Mandal "/.test(u.reason) && u.reason.includes("not found in") && u.reason.includes("directory");
}
function $2e68d50886672da3$var$isLeadGeoAutoCreateCandidate(u) {
    return $2e68d50886672da3$var$isMissingVillageRow(u) || $2e68d50886672da3$var$isMissingMandalRow(u);
}
function $2e68d50886672da3$export$cd9abd1820b933d(unmatched) {
    return unmatched.some($2e68d50886672da3$var$isLeadGeoAutoCreateCandidate);
}
async function $2e68d50886672da3$export$dab79ec8037d362a(store, batchDistrictKey, unmatched) {
    const targets = unmatched.filter($2e68d50886672da3$var$isLeadGeoAutoCreateCandidate);
    const seen = new Set();
    let created = 0;
    let existed = 0;
    const errors = [];
    for (const u of targets){
        const dKey = u.fileDistrictKey != null && (0, $72c1e8625e9e63b5$export$15dbe5472819b55d)(u.fileDistrictKey) ? u.fileDistrictKey : batchDistrictKey && (0, $72c1e8625e9e63b5$export$15dbe5472819b55d)(batchDistrictKey) ? batchDistrictKey : null;
        if (!dKey) continue;
        const mandalFromFile = u.fileMandal.trim();
        const villageFromFile = u.fileVillage.trim();
        if (!mandalFromFile || !villageFromFile) continue;
        let mandalNameForApi = mandalFromFile;
        if ($2e68d50886672da3$var$isMissingVillageRow(u) && !$2e68d50886672da3$var$isMissingMandalRow(u)) {
            const resolved = (0, $24d7686700a3e8b0$export$142efbfe642d9c41)(store, dKey, u.fileMandal);
            if (!resolved) continue;
            mandalNameForApi = resolved;
        }
        const key = `${dKey}|${(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(mandalNameForApi)}|${(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(villageFromFile)}`;
        if (seen.has(key)) continue;
        seen.add(key);
        try {
            const r = await (0, $d344741a629d67ca$export$80ce7a218ee6e0d)({
                districtKey: dKey,
                mandalName: mandalNameForApi,
                villageName: villageFromFile
            });
            if (r.created) created += 1;
            else existed += 1;
        } catch (e) {
            errors.push(`${villageFromFile} (${mandalNameForApi}): ${e instanceof Error ? e.message : String(e)}`);
        }
    }
    return {
        created: created,
        existed: existed,
        errors: errors
    };
}



function $d8867abc7f6f8dd0$var$trunc(s, max) {
    if (s == null) return null;
    const t = String(s).trim();
    if (!t) return null;
    return t.length <= max ? t : t.slice(0, max);
}
function $d8867abc7f6f8dd0$export$ccf1b0f21acdcdbc(applicationRef) {
    return String(applicationRef ?? "").trim().slice(0, 128);
}
function $d8867abc7f6f8dd0$var$statusFromMatchedRow(r) {
    const pieces = [
        r.listType,
        r.applicationStatus
    ].map((s)=>String(s ?? "").trim()).filter((s)=>s && s !== "\u2014");
    if (pieces.length) return pieces.join(" \xb7 ");
    return "Pending";
}
function $d8867abc7f6f8dd0$export$aa27e2b7a0c0317d(matched) {
    const out = [];
    for (const r of matched){
        const leadId = $d8867abc7f6f8dd0$export$ccf1b0f21acdcdbc(r.applicationRef);
        if (!leadId) continue;
        out.push({
            leadId: leadId,
            district: $d8867abc7f6f8dd0$var$trunc((0, $72c1e8625e9e63b5$export$5e94242fadb30a0e)(r.districtKey), 50),
            mandal: $d8867abc7f6f8dd0$var$trunc(r.canonicalMandal, 50),
            village: $d8867abc7f6f8dd0$var$trunc(r.canonicalVillage, 50),
            applicantName: $d8867abc7f6f8dd0$var$trunc(r.applicantName, 50),
            mobileNumber: $d8867abc7f6f8dd0$var$trunc(r.mobile.replace(/\D/g, ""), 50),
            aadhaarNumber: $d8867abc7f6f8dd0$var$trunc(r.aadhaarDigits.replace(/\D/g, ""), 50),
            status: $d8867abc7f6f8dd0$var$trunc($d8867abc7f6f8dd0$var$statusFromMatchedRow(r), 50)
        });
    }
    return out;
}


var $0d25836fd2daef0e$exports = {};
$0d25836fd2daef0e$exports = $parcel$resolve("kLv6d");


function $24a37b97828dfea2$export$27654cf739fef2d5({ onSaved: onSaved }) {
    const { store: geoStore, loading: geoLoading, error: geoError, refetch: refetch } = (0, $60dd8507bac67e50$export$5ec0231075ddedf1)();
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const [busy, setBusy] = (0, $7UyaH.useState)(false);
    const [error, setError] = (0, $7UyaH.useState)(null);
    const [fileLabel, setFileLabel] = (0, $7UyaH.useState)("");
    const [matched, setMatched] = (0, $7UyaH.useState)([]);
    const [unmatched, setUnmatched] = (0, $7UyaH.useState)([]);
    const [parsedDistrict, setParsedDistrict] = (0, $7UyaH.useState)(null);
    const [autoCreateVillages, setAutoCreateVillages] = (0, $7UyaH.useState)(true);
    const [ensureInfo, setEnsureInfo] = (0, $7UyaH.useState)(null);
    const [ensureErrors, setEnsureErrors] = (0, $7UyaH.useState)([]);
    const [parseStats, setParseStats] = (0, $7UyaH.useState)(null);
    (0, $7UyaH.useEffect)(()=>{
        if (!geoStore) setAutoCreateVillages(false);
    }, [
        geoStore
    ]);
    const runParse = (0, $7UyaH.useCallback)(async (file)=>{
        setBusy(true);
        setError(null);
        setFileLabel(file.name);
        setMatched([]);
        setUnmatched([]);
        setParsedDistrict(null);
        setEnsureInfo(null);
        setEnsureErrors([]);
        setParseStats(null);
        try {
            const ext = file.name.split(".").pop()?.toLowerCase() ?? "";
            let parsedRows = [];
            let distFromFile = null;
            const noDefaultDistrict = null;
            if (ext === "pdf") {
                const text = await (0, $a963053b23bbe36c$export$43fefe6ead983557)(file);
                const pr = (0, $4d458044ff7299c6$export$4977f36add1cb0df)(text, {
                    geo: geoStore,
                    defaultDistrictKey: noDefaultDistrict
                });
                parsedRows = pr.rows;
                distFromFile = pr.districtKey;
                setParseStats(pr.stats);
            } else if (ext === "xlsx" || ext === "xls") {
                const buf = await file.arrayBuffer();
                const pr = (0, $1080b5c0ea382d39$export$ec96d96dcde49aa0)(buf, {
                    defaultDistrictKey: noDefaultDistrict
                });
                parsedRows = pr.rows;
                distFromFile = pr.districtKey;
                setParseStats(pr.stats);
            } else throw new Error("Use a .pdf, .xlsx, or .xls file.");
            setParsedDistrict(distFromFile);
            if (parsedRows.length === 0) throw new Error("No data rows were found. Check headers (Mandal, Village, Application No, Applicant, etc.).");
            let { matched: m, unmatched: u } = (0, $24d7686700a3e8b0$export$f684e5257c4aa24a)(geoStore, distFromFile, parsedRows);
            if (autoCreateVillages && geoStore && (0, $2e68d50886672da3$export$cd9abd1820b933d)(u)) {
                const ens = await (0, $2e68d50886672da3$export$dab79ec8037d362a)(geoStore, distFromFile, u);
                const parts = [];
                if (ens.created > 0) parts.push(`Added ${ens.created} new mandal/village name(s) in the geo directory where missing`);
                if (ens.existed > 0) parts.push(`${ens.existed} already present (skipped)`);
                setEnsureInfo(parts.length ? parts.join(" \xb7 ") : null);
                setEnsureErrors(ens.errors);
                await refetch();
                const freshStore = (0, $77f9294c77fbab2e$export$2bf115fe882c633)(await (0, $ede95d5ea387352a$export$bc937d06acaf044f)());
                const second = (0, $24d7686700a3e8b0$export$f684e5257c4aa24a)(freshStore, distFromFile, parsedRows);
                m = second.matched;
                u = second.unmatched;
            }
            setMatched(m);
            setUnmatched(u);
        } catch (e) {
            setError(e instanceof Error ? e.message : String(e));
        } finally{
            setBusy(false);
        }
    }, [
        geoStore,
        autoCreateVillages,
        refetch
    ]);
    const onFile = (e)=>{
        const f = e.target.files?.[0];
        e.target.value = "";
        if (f) runParse(f);
    };
    const doImport = async ()=>{
        if (matched.length === 0) return;
        const rows = (0, $d8867abc7f6f8dd0$export$aa27e2b7a0c0317d)(matched);
        if (!rows.length) {
            showToast("No rows with an application number to save.", "error");
            return;
        }
        setBusy(true);
        try {
            const { count: count } = await (0, $4e56623d4da7ea32$export$8c0371f2fbdd8973)(rows);
            showToast(`Saved ${count} row(s) to the Leads table (Lead_ID = application no).`, "success");
            onSaved?.();
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not save to the Leads table.", "error");
        } finally{
            setBusy(false);
        }
    };
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                style: {
                    marginBottom: "1.25rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "section-lead section-lead--tight text-muted",
                        style: {
                            marginTop: 0
                        },
                        children: [
                            "Import ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Excel"
                            }),
                            " (e.g. SL No, Mandal, ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "District"
                            }),
                            ", Village, ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Application No"
                            }),
                            ", Applicant, Mobile, Aadhaar, list type, status) or TG-style ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "PDF"
                            }),
                            " exports. The ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Name of the Constituency"
                            }),
                            " ",
                            "column is ignored. Mandals and villages are matched to the",
                            " ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/geo-directory",
                                children: "geo directory"
                            }),
                            " (with fuzzy village matching). PDFs should include a line like",
                            " ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "mono",
                                children: "District - Nagarkurnool"
                            }),
                            " when there is no per-row district. Saving writes only to the",
                            " ",
                            "MySQL ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Leads"
                            }),
                            " table; ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Lead_ID"
                            }),
                            " is the application number from the file."
                        ]
                    }),
                    geoLoading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "Loading geo directory\u2026"
                    }) : geoError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "alert alert--danger",
                        role: "alert",
                        children: [
                            "Geo directory unavailable: ",
                            geoError,
                            ". Imports cannot match villages until this loads."
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                        className: `goods-receipts-filters__field${!geoStore ? " text-muted" : ""}`,
                        style: {
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                            marginTop: "0.75rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                type: "checkbox",
                                checked: autoCreateVillages,
                                disabled: !geoStore,
                                onChange: (e)=>setAutoCreateVillages(e.target.checked)
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                className: "goods-receipts-filters__label",
                                style: {
                                    margin: 0
                                },
                                children: [
                                    "After matching, if the mandal or village from the file is still missing under that row's District in the geo directory, add them automatically (only under that row's district).",
                                    !geoStore ? " Requires geo directory admin access on your account." : ""
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "toolbar-row",
                        style: {
                            marginTop: "1rem",
                            flexWrap: "wrap",
                            gap: "0.75rem",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("a", {
                                href: (0, (/*@__PURE__*/$parcel$interopDefault($0d25836fd2daef0e$exports))),
                                className: "btn btn--secondary btn--tg",
                                download: "Leads-import-template.xlsx",
                                children: "Download Excel template (blank)"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "text-muted section-lead--tight",
                                style: {
                                    margin: 0,
                                    maxWidth: "36rem"
                                },
                                children: "Same column layout as the reference leads Excel (headers only, no data). Fill in rows, then import below."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                        className: "goods-receipts-filters__field",
                        style: {
                            marginTop: "1rem",
                            display: "block",
                            maxWidth: "28rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "goods-receipts-filters__label",
                                children: "Import file"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                type: "file",
                                className: "form-control",
                                accept: ".pdf,.xlsx,.xls,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
                                disabled: busy,
                                onChange: onFile
                            })
                        ]
                    }),
                    fileLabel ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "text-muted section-lead--tight",
                        children: [
                            "Last file: ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: fileLabel
                            }),
                            parsedDistrict ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                children: [
                                    " ",
                                    "\xb7 Single district in file: ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                        children: (0, $72c1e8625e9e63b5$export$5e94242fadb30a0e)(parsedDistrict)
                                    })
                                ]
                            }) : parseStats && parseStats.rowsAccepted > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                children: [
                                    " \xb7 District: read from each row's ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                        children: "District"
                                    }),
                                    " column (or from the PDF header line)."
                                ]
                            }) : null
                        ]
                    }) : null,
                    parseStats ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "text-muted section-lead--tight",
                        style: {
                            marginTop: "0.35rem"
                        },
                        children: [
                            "Parsed from file: ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: parseStats.rowsAccepted
                            }),
                            " data row(s) \xb7",
                            " ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                className: "mono",
                                style: {
                                    fontSize: "0.9em"
                                },
                                children: [
                                    "lines ",
                                    parseStats.fileLineCount
                                ]
                            }),
                            parseStats.looseLineFallbacks > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                children: [
                                    " ",
                                    "\xb7 ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                        children: parseStats.looseLineFallbacks
                                    }),
                                    " recovered via space-glue fallback (PDF)"
                                ]
                            }) : null,
                            parseStats.skippedNoAppToken > 0 || parseStats.skippedNoMandalVillage > 0 || parseStats.skippedShortApplicant > 0 || parseStats.skippedRequiredBlank > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                children: [
                                    " ",
                                    "\xb7 Skipped: no app pattern ",
                                    parseStats.skippedNoAppToken,
                                    ", no mandal/village",
                                    " ",
                                    parseStats.skippedNoMandalVillage,
                                    ", short name ",
                                    parseStats.skippedShortApplicant,
                                    ", blank required fields",
                                    " ",
                                    parseStats.skippedRequiredBlank
                                ]
                            }) : null
                        ]
                    }) : null,
                    busy ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "Reading file\u2026"
                    }) : null,
                    ensureInfo ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted section-lead--tight",
                        children: ensureInfo
                    }) : null,
                    ensureErrors.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "alert alert--danger",
                        role: "alert",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Geo directory API issues:"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                                style: {
                                    margin: "0.5rem 0 0",
                                    paddingLeft: "1.25rem"
                                },
                                children: ensureErrors.slice(0, 15).map((x, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                        children: x
                                    }, i))
                            })
                        ]
                    }) : null,
                    error ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "alert alert--danger",
                        role: "alert",
                        children: error
                    }) : null,
                    !busy && matched.length + unmatched.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                className: "section-lead",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                        children: matched.length
                                    }),
                                    " row(s) matched directory villages \xb7",
                                    " ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                        children: unmatched.length
                                    }),
                                    " could not be matched."
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "toolbar-row",
                                style: {
                                    marginBottom: "1rem"
                                },
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--primary btn--tg btn--lg",
                                    disabled: matched.length === 0 || busy,
                                    onClick: ()=>void doImport(),
                                    children: "Save matched rows to Leads table"
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                className: "text-muted section-lead--tight",
                                style: {
                                    marginTop: 0
                                },
                                children: [
                                    "Rows are upserted into ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                        children: "Leads"
                                    }),
                                    " by application number (",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                        children: "Lead_ID"
                                    }),
                                    "). Re-importing refreshes District, Mandal, Village, Applicant Name, Mobile and Aadhaar from the file, but",
                                    " ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                        children: "keeps the existing Status"
                                    }),
                                    " for any application that is already in the list (a blank existing status will be filled from the file)."
                                ]
                            })
                        ]
                    }) : null
                ]
            }),
            unmatched.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                style: {
                    marginBottom: "1.25rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("h3", {
                        className: "form-section-title",
                        style: {
                            marginTop: 0
                        },
                        children: [
                            "Unmatched rows (",
                            unmatched.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted section-lead--tight",
                        children: "Correct village spelling to match the IGRS directory under the mandal, or add the village in Geo directory."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        style: {
                            overflowX: "auto",
                            maxHeight: "22rem",
                            overflowY: "auto"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                className: "data-table",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Mandal (file)"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Village (file)"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Applicant"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Application ref"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Reason"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                        children: unmatched.slice(0, 200).map((r, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: r.fileMandal
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: r.fileVillage
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: r.applicantName
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono",
                                                        children: r.applicationRef
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "text-muted",
                                                        children: r.reason
                                                    })
                                                ]
                                            }, `${r.applicationSerial}-${r.applicationRef}-${i}`))
                                    })
                                ]
                            }),
                            unmatched.length > 200 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                children: "Showing first 200 unmatched."
                            }) : null
                        ]
                    })
                ]
            }) : null,
            matched.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("h3", {
                        className: "form-section-title",
                        style: {
                            marginTop: 0
                        },
                        children: [
                            "Preview \u2014 matched (",
                            Math.min(matched.length, 50),
                            " of ",
                            matched.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        style: {
                            overflowX: "auto"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                            className: "data-table",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "District"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Mandal"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Village (directory)"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Applicant"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Mobile"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "App ref"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Match"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                    children: matched.slice(0, 50).map((r, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: (0, $72c1e8625e9e63b5$export$5e94242fadb30a0e)(r.districtKey)
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: r.canonicalMandal
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: r.canonicalVillage
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: r.applicantName
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "mono",
                                                    children: r.mobile
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "mono",
                                                    children: r.applicationRef
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "text-muted",
                                                    children: r.villageMatchedFuzzy ? "Fuzzy village" : "Exact / list"
                                                })
                                            ]
                                        }, `${r.applicationSerial}-${r.applicationRef}-${i}`))
                                })
                            ]
                        })
                    })
                ]
            }) : null
        ]
    });
}









const $39c80d2c861a73f3$var$LEAD_HO_STATUS_FILTER_OPTIONS = [
    {
        value: "all",
        label: "All HO statuses"
    },
    {
        value: "pending",
        label: "Interested \u2014 HO not set"
    },
    {
        value: "approved",
        label: "Approve"
    },
    {
        value: "reject",
        label: "Reject"
    },
    {
        value: "on_hold",
        label: "On hold"
    }
];
const $39c80d2c861a73f3$var$LEAD_LIST_STATUS_FILTER_OPTIONS = [
    {
        value: "all",
        label: "All list statuses"
    },
    {
        value: "pending",
        label: "Pending / other"
    },
    {
        value: "interested",
        label: "Interested"
    },
    {
        value: "not_interested",
        label: "Not interested"
    }
];
function $39c80d2c861a73f3$var$LeadsStatusCell({ row: row }) {
    const hoKind = (0, $e2c4aa93a7901816$export$7895be5d7389e56a)(row.hoStatus);
    const sheetKind = (0, $e2c4aa93a7901816$export$daaafb7835a1961e)(row.status);
    const sheetLabel = (0, $e2c4aa93a7901816$export$dc60e879207a129)(row.status);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "lead-status-cell",
        children: [
            hoKind !== "none" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                className: `lead-status-pill lead-status-pill--${hoKind}`,
                children: (0, $e2c4aa93a7901816$export$7f410a2e326a592c)(row.hoStatus)
            }) : null,
            sheetKind === "interested" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                className: "lead-status-pill lead-status-pill--interested",
                children: sheetLabel
            }) : sheetKind === "not_interested" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                className: "lead-status-pill lead-status-pill--not-interested",
                children: sheetLabel
            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                className: "text-muted",
                children: sheetLabel
            })
        ]
    });
}
function $39c80d2c861a73f3$export$4492245542fbc3ce() {
    const [searchParams, setSearchParams] = (0, $e651fdaba0d48e3d$export$f1a78c17382fe22a)();
    const { can: can } = (0, $a4dc0d923ddf5b19$export$1d39dc5b47e56ff0)();
    const { store: geoStore } = (0, $60dd8507bac67e50$export$5ec0231075ddedf1)();
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const importQuery = searchParams.get("import");
    const canViewLeadsTable = can("leads");
    /** Import is a separate permission from viewing the table (`leads` vs `leads_import`). */ const canImportLeads = can("leads_import");
    const importOnly = canImportLeads && !canViewLeadsTable;
    const [search, setSearch] = (0, $7UyaH.useState)("");
    const [hoStatusFilter, setHoStatusFilter] = (0, $7UyaH.useState)("all");
    const [listStatusFilter, setListStatusFilter] = (0, $7UyaH.useState)("all");
    const [districtFilter, setDistrictFilter] = (0, $7UyaH.useState)("");
    const [mandalFilter, setMandalFilter] = (0, $7UyaH.useState)("");
    const [villageFilter, setVillageFilter] = (0, $7UyaH.useState)("");
    const [importOpen, setImportOpen] = (0, $7UyaH.useState)(false);
    const importOnlyAutoOpenedRef = (0, $7UyaH.useRef)(false);
    const importSectionRef = (0, $7UyaH.useRef)(null);
    const [rows, setRows] = (0, $7UyaH.useState)([]);
    const [loadError, setLoadError] = (0, $7UyaH.useState)(null);
    const [loading, setLoading] = (0, $7UyaH.useState)(canViewLeadsTable);
    /** Lead IDs whose Action buttons are currently saving. */ const [savingLeadIds, setSavingLeadIds] = (0, $7UyaH.useState)(new Set());
    const setLeadHoStatusAction = (0, $7UyaH.useCallback)(async (leadId, next)=>{
        setSavingLeadIds((prev)=>{
            const n = new Set(prev);
            n.add(leadId);
            return n;
        });
        const previousRow = rows.find((r)=>r.leadId === leadId);
        setRows((prev)=>prev.map((r)=>r.leadId === leadId ? {
                    ...r,
                    hoStatus: next === "" ? null : next
                } : r));
        try {
            const updated = await (0, $4e56623d4da7ea32$export$efe6a7e4a0d6e085)(leadId, next);
            setRows((prev)=>prev.map((r)=>r.leadId === leadId ? updated : r));
        } catch (e) {
            if (previousRow) setRows((prev)=>prev.map((r)=>r.leadId === leadId ? previousRow : r));
            showToast(e instanceof Error ? e.message : "Could not update HO status.", "error");
        } finally{
            setSavingLeadIds((prev)=>{
                const n = new Set(prev);
                n.delete(leadId);
                return n;
            });
        }
    }, [
        rows,
        showToast
    ]);
    const reloadLeads = (0, $7UyaH.useCallback)(async ()=>{
        setLoading(true);
        setLoadError(null);
        try {
            const data = await (0, $4e56623d4da7ea32$export$c20290562992eebc)();
            setRows(Array.isArray(data) ? data : []);
        } catch (e) {
            setRows([]);
            setLoadError(e instanceof Error ? e.message : String(e));
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        if (!canViewLeadsTable) {
            setLoading(false);
            setRows([]);
            setLoadError(null);
            return;
        }
        reloadLeads();
    }, [
        canViewLeadsTable,
        reloadLeads
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (importQuery === "1" && !canImportLeads) {
            setImportOpen(false);
            setSearchParams((prev)=>{
                const p = new URLSearchParams(prev);
                p.delete("import");
                return p;
            }, {
                replace: true
            });
            return;
        }
        if (importQuery === "1" && canImportLeads) {
            setImportOpen(true);
            return;
        }
        if (importOnly && !importOnlyAutoOpenedRef.current) {
            setImportOpen(true);
            importOnlyAutoOpenedRef.current = true;
        }
    }, [
        importQuery,
        importOnly,
        canImportLeads,
        setSearchParams
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!canImportLeads && importOpen) setImportOpen(false);
    }, [
        canImportLeads,
        importOpen
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (importOpen && importQuery === "1") importSectionRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }, [
        importOpen,
        importQuery
    ]);
    function openImportPanel() {
        if (!canImportLeads) return;
        setImportOpen(true);
        setSearchParams((prev)=>{
            const p = new URLSearchParams(prev);
            p.set("import", "1");
            return p;
        }, {
            replace: true
        });
    }
    function closeImportPanel() {
        setImportOpen(false);
        setSearchParams((prev)=>{
            const p = new URLSearchParams(prev);
            p.delete("import");
            return p;
        }, {
            replace: true
        });
    }
    const filtered = (0, $7UyaH.useMemo)(()=>{
        const q = search.trim().toLowerCase();
        return rows.filter((r)=>{
            if (q) {
                const hay = [
                    r.leadId,
                    r.applicantName,
                    r.mobileNumber,
                    r.aadhaarNumber,
                    r.mandal,
                    r.village,
                    r.district,
                    r.status,
                    r.hoStatus
                ].join(" ").toLowerCase();
                if (!hay.includes(q)) return false;
            }
            if (!(0, $e2c4aa93a7901816$export$46f3e6949209f1cd)(r, hoStatusFilter)) return false;
            if (!(0, $e2c4aa93a7901816$export$4ab39ebe6cc8281b)(r, listStatusFilter)) return false;
            if (!(0, $e2c4aa93a7901816$export$8e5ecea902864081)(r, {
                district: districtFilter,
                mandal: mandalFilter,
                village: villageFilter
            }, geoStore)) return false;
            return true;
        });
    }, [
        rows,
        search,
        hoStatusFilter,
        listStatusFilter,
        districtFilter,
        mandalFilter,
        villageFilter,
        geoStore
    ]);
    const hasActiveFilters = search.trim() !== "" || hoStatusFilter !== "all" || listStatusFilter !== "all" || districtFilter !== "" || mandalFilter !== "" || villageFilter !== "";
    function clearFilters() {
        setSearch("");
        setHoStatusFilter("all");
        setListStatusFilter("all");
        setDistrictFilter("");
        setMandalFilter("");
        setVillageFilter("");
    }
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: importOnly ? "Leads import" : "Leads"
                    }
                ],
                title: importOnly ? "Leads import" : "Leads",
                actions: canImportLeads ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                    className: "leads-import-header-actions",
                    children: !importOpen ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "leads-import-box leads-import-box--corner card card--gov card--elevated",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            className: "btn btn--secondary btn--tg",
                            onClick: ()=>openImportPanel(),
                            children: "Import leads (PDF or Excel)"
                        })
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--ghost btn--sm",
                        onClick: ()=>closeImportPanel(),
                        children: "Close import"
                    })
                }) : null
            }),
            importOpen && canImportLeads ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                id: "leads-import-section",
                ref: importSectionRef,
                className: "leads-import-panel-below-header",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $24a37b97828dfea2$export$27654cf739fef2d5), {
                    onSaved: ()=>{
                        if (canViewLeadsTable) reloadLeads();
                    }
                })
            }) : null,
            importOnly && !importOpen ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "section-lead",
                style: {
                    marginBottom: "1rem"
                },
                children: [
                    "Your account can import leads only. Use ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "Import leads (PDF or Excel)"
                    }),
                    " above to upload a file."
                ]
            }) : null,
            canViewLeadsTable && loadError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "text-muted",
                style: {
                    color: "var(--dash-danger, #b91c1c)",
                    marginBottom: "1rem"
                },
                children: [
                    "Could not load the Leads table: ",
                    loadError
                ]
            }) : null,
            canViewLeadsTable ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                style: {
                    marginBottom: "1rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "table-toolbar table-toolbar--stack",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "table-toolbar__top",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "table-toolbar__count",
                                        children: loading ? "Loading leads\u2026" : hasActiveFilters ? `${filtered.length} of ${rows.length} lead(s)` : `${rows.length} lead(s)`
                                    }),
                                    hasActiveFilters ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--link btn--sm table-toolbar__clear",
                                        onClick: clearFilters,
                                        children: "Clear filters"
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "table-filters-grid",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "table-filters table-filters--leads",
                                    role: "search",
                                    "aria-label": "Filter leads",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "field table-filters__field table-filters__field--grow",
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                    htmlFor: "leads-list-search",
                                                    children: "Search"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                    id: "leads-list-search",
                                                    type: "search",
                                                    placeholder: "Application no., name, village\u2026",
                                                    value: search,
                                                    onChange: (e)=>setSearch(e.target.value),
                                                    autoComplete: "off"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "field table-filters__field",
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                    htmlFor: "leads-filter-status",
                                                    children: "HO status"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("select", {
                                                    id: "leads-filter-ho-status",
                                                    value: hoStatusFilter,
                                                    onChange: (e)=>setHoStatusFilter(e.target.value),
                                                    children: $39c80d2c861a73f3$var$LEAD_HO_STATUS_FILTER_OPTIONS.map((o)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                            value: o.value,
                                                            children: o.label
                                                        }, o.value))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "field table-filters__field",
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                    htmlFor: "leads-filter-list-status",
                                                    children: "List status"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("select", {
                                                    id: "leads-filter-list-status",
                                                    value: listStatusFilter,
                                                    onChange: (e)=>setListStatusFilter(e.target.value),
                                                    children: $39c80d2c861a73f3$var$LEAD_LIST_STATUS_FILTER_OPTIONS.map((o)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                            value: o.value,
                                                            children: o.label
                                                        }, o.value))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $0377fbce5921ee00$export$b3eb1a6c17723c14), {
                                            idPrefix: "leads-geo",
                                            district: districtFilter,
                                            mandal: mandalFilter,
                                            village: villageFilter,
                                            onDistrictChange: (d)=>{
                                                setDistrictFilter(d);
                                                setMandalFilter("");
                                                setVillageFilter("");
                                            },
                                            onMandalChange: (m)=>{
                                                setMandalFilter(m);
                                                setVillageFilter("");
                                            },
                                            onVillageChange: setVillageFilter
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "table-wrap",
                        style: {
                            marginTop: "1rem"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                            className: "data-table",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Application No."
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Applicant Name"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "District"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Mandal"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Village"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Action"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                    children: loading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                            colSpan: 7,
                                            className: "data-table__empty",
                                            children: "Loading\u2026"
                                        })
                                    }) : filtered.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                            colSpan: 7,
                                            className: "data-table__empty",
                                            children: rows.length === 0 ? "No rows in the Leads table yet. Use Import leads (top right) to save from PDF or Excel." : "No leads match the current filters."
                                        })
                                    }) : filtered.map((r)=>{
                                        const hoKind = (0, $e2c4aa93a7901816$export$7895be5d7389e56a)(r.hoStatus);
                                        const saving = savingLeadIds.has(r.leadId);
                                        return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "mono",
                                                    children: r.leadId
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "table-name",
                                                        children: (0, $458840b99c021cb6$export$bb1029bec19025fd)(r.applicantName) || "\u2014"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: (0, $458840b99c021cb6$export$bb1029bec19025fd)(r.district) || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: (0, $458840b99c021cb6$export$bb1029bec19025fd)(r.mandal) || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: (0, $458840b99c021cb6$export$bb1029bec19025fd)(r.village) || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($39c80d2c861a73f3$var$LeadsStatusCell, {
                                                        row: r
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "lead-action-cell",
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                                                        className: "lead-action-select",
                                                        "aria-label": `HO action for application ${r.leadId}`,
                                                        value: hoKind === "none" ? "" : hoKind,
                                                        disabled: saving,
                                                        "aria-busy": saving,
                                                        onChange: (e)=>{
                                                            const v = e.target.value;
                                                            setLeadHoStatusAction(r.leadId, v === "" ? "" : v);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                                value: "",
                                                                children: "Choose HO action\u2026"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                                value: "approved",
                                                                children: "Approve"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                                value: "reject",
                                                                children: "Reject"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                                value: "on_hold",
                                                                children: "On hold"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, r.leadId);
                                    })
                                })
                            ]
                        })
                    })
                ]
            }) : null
        ]
    });
}




function $9e17c29da680e410$export$83626dc447481fee({ title: title, breadcrumb: breadcrumb, subtitle: subtitle }) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: breadcrumb.map((c)=>c.to ? {
                        label: c.label,
                        to: c.to
                    } : {
                        label: c.label
                    }),
                title: title,
                subtitle: subtitle ?? "This screen is reserved for your workflow. Connect APIs or forms when ready."
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "card card--elevated",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                    className: "text-muted",
                    children: "No data to show yet. Use this area for registers, approvals, or integrations."
                })
            })
        ]
    });
}
function $9e17c29da680e410$export$6759cc8b66e1e2cb() {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($9e17c29da680e410$export$83626dc447481fee, {
        title: "Bills \u2014 Inward",
        breadcrumb: [
            {
                label: "Home",
                to: "/"
            },
            {
                label: "Bills",
                to: "/bills/inward"
            },
            {
                label: "Inward"
            }
        ]
    });
}
function $9e17c29da680e410$export$ad75aefabe253746() {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($9e17c29da680e410$export$83626dc447481fee, {
        title: "Bills \u2014 Outward",
        breadcrumb: [
            {
                label: "Home",
                to: "/"
            },
            {
                label: "Bills",
                to: "/bills/inward"
            },
            {
                label: "Outward"
            }
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");





var $7UyaH = parcelRequire("7UyaH");




/** Browser-local saved invoice letterhead / GST defaults (per workstation). */ 
const $0167ea69d6388932$export$f58068f368efb763 = "indiramma.invoiceFormat.v1";
function $0167ea69d6388932$var$clampLogoHeight(n) {
    if (!Number.isFinite(n)) return 56;
    return Math.min(160, Math.max(28, Math.round(n)));
}
function $0167ea69d6388932$var$sanitizeAccentHex(hex) {
    const t = hex.trim();
    if (/^#[0-9A-Fa-f]{6}$/.test(t)) return t;
    return "#16365f";
}
function $0167ea69d6388932$var$defaultTypeFormatBlock() {
    return {
        billFromName: "",
        billFromAddress: "",
        billFromGstin: "",
        billToName: "",
        billToAddress: "",
        billToGstin: "",
        paymentTerms: "As per agreement. Retention and statutory deductions as applicable.",
        footerNote: "",
        aggregateQtyDefault: true,
        gstRows: [
            {
                label: "CGST",
                ratePercent: 9
            },
            {
                label: "SGST",
                ratePercent: 9
            }
        ]
    };
}
function $0167ea69d6388932$export$45c6a1876597daad() {
    const block = $0167ea69d6388932$var$defaultTypeFormatBlock();
    return {
        version: 2,
        documentTitleMaterial: "MATERIAL TAX INVOICE",
        documentTitleSubcontractor: "SUBCONTRACTOR RA BILL",
        documentTitleLabour: "LABOUR SUPPLIER INVOICE",
        letterheadTagline: "",
        logoPrimaryUrl: "",
        logoSecondaryUrl: "",
        logoPrimaryHeightPx: 56,
        logoSecondaryHeightPx: 68,
        accentColorHex: "#16365f",
        material: {
            ...block,
            gstRows: block.gstRows.map((r)=>({
                    ...r
                }))
        },
        subcontractor: {
            ...block,
            gstRows: block.gstRows.map((r)=>({
                    ...r
                }))
        },
        labour: {
            ...block,
            gstRows: block.gstRows.map((r)=>({
                    ...r
                }))
        },
        subcontractorBillLines: [],
        labourBillLines: []
    };
}
function $0167ea69d6388932$var$clampGstRows(rows) {
    const fallback = $0167ea69d6388932$var$defaultTypeFormatBlock().gstRows;
    // Missing key → factory defaults; empty array [] → user chose no GST rows.
    if (rows === undefined || rows === null) return fallback.map((r)=>({
            ...r
        }));
    if (!Array.isArray(rows)) return fallback.map((r)=>({
            ...r
        }));
    const out = [];
    for (const r of rows){
        if (!r || typeof r !== "object") continue;
        const o = r;
        const label = typeof o.label === "string" ? o.label.trim().slice(0, 64) : "Tax";
        const rp = Number(o.ratePercent);
        out.push({
            label: label || "Tax",
            ratePercent: Number.isFinite(rp) ? Math.min(100, Math.max(0, rp)) : 0
        });
    }
    return out;
}
function $0167ea69d6388932$export$6d2212a43f753781(s, type) {
    return $0167ea69d6388932$export$dd38b1b42a1ef675(s, type).gstRows.filter((g)=>g.ratePercent > 0.0000001);
}
function $0167ea69d6388932$var$clampTypeFormatBlock(raw, fallback) {
    const d = fallback ?? $0167ea69d6388932$var$defaultTypeFormatBlock();
    if (!raw || typeof raw !== "object") return {
        ...d,
        gstRows: d.gstRows.map((r)=>({
                ...r
            }))
    };
    const o = raw;
    return {
        billFromName: typeof o.billFromName === "string" ? o.billFromName.slice(0, 2000) : d.billFromName,
        billFromAddress: typeof o.billFromAddress === "string" ? o.billFromAddress.slice(0, 4000) : d.billFromAddress,
        billFromGstin: typeof o.billFromGstin === "string" ? o.billFromGstin.toUpperCase().slice(0, 32) : d.billFromGstin,
        billToName: typeof o.billToName === "string" ? o.billToName.slice(0, 2000) : d.billToName,
        billToAddress: typeof o.billToAddress === "string" ? o.billToAddress.slice(0, 4000) : d.billToAddress,
        billToGstin: typeof o.billToGstin === "string" ? o.billToGstin.toUpperCase().slice(0, 32) : d.billToGstin,
        paymentTerms: typeof o.paymentTerms === "string" && o.paymentTerms.trim() ? o.paymentTerms.slice(0, 4000) : d.paymentTerms,
        footerNote: typeof o.footerNote === "string" ? o.footerNote.slice(0, 2000) : d.footerNote,
        aggregateQtyDefault: o.aggregateQtyDefault === false ? false : true,
        gstRows: $0167ea69d6388932$var$clampGstRows(o.gstRows)
    };
}
function $0167ea69d6388932$var$clampSubcontractorBillLines(rows) {
    if (!Array.isArray(rows)) return [];
    const out = [];
    for (const r of rows){
        if (!r || typeof r !== "object") continue;
        const o = r;
        const milestoneTemplateId = typeof o.milestoneTemplateId === "string" ? o.milestoneTemplateId.trim() : "";
        const milestoneTemplateItemId = typeof o.milestoneTemplateItemId === "string" ? o.milestoneTemplateItemId.trim() : "";
        const lineLabel = typeof o.lineLabel === "string" ? o.lineLabel.trim().slice(0, 512) : "";
        if (!milestoneTemplateItemId || !lineLabel) continue;
        const isTimeline = o.billSource === "timeline" || milestoneTemplateItemId.startsWith("tlbill:");
        if (!isTimeline && !milestoneTemplateId) continue;
        const qtyRaw = Number(o.qty);
        const rateRaw = Number(o.rate);
        out.push({
            billSource: isTimeline ? "timeline" : "milestone",
            milestoneTemplateId: milestoneTemplateId,
            milestoneTemplateItemId: milestoneTemplateItemId,
            milestoneTitle: typeof o.milestoneTitle === "string" ? o.milestoneTitle.trim().slice(0, 512) : "",
            lineLabel: lineLabel,
            timelinePhaseIds: Array.isArray(o.timelinePhaseIds) ? o.timelinePhaseIds.map((x)=>String(x).trim()).filter(Boolean) : [],
            timelinePhaseTitles: Array.isArray(o.timelinePhaseTitles) ? o.timelinePhaseTitles.map((x)=>String(x).trim()).filter(Boolean) : [],
            qty: Number.isFinite(qtyRaw) && qtyRaw > 0 ? qtyRaw : 1,
            unit: typeof o.unit === "string" && o.unit.trim() ? o.unit.trim().slice(0, 64) : "LS",
            rate: Number.isFinite(rateRaw) && rateRaw >= 0 ? rateRaw : 0,
            hsnCode: typeof o.hsnCode === "string" ? o.hsnCode.toUpperCase().slice(0, 40) : ""
        });
    }
    return out;
}
function $0167ea69d6388932$var$migrateLegacyFlatSettings(o) {
    const sharedBlock = $0167ea69d6388932$var$clampTypeFormatBlock({
        billFromName: o.billFromName,
        billFromAddress: o.billFromAddress,
        billFromGstin: o.billFromGstin,
        billToName: o.billToName,
        billToAddress: o.billToAddress,
        billToGstin: o.billToGstin,
        paymentTerms: o.paymentTerms,
        footerNote: o.footerNote,
        aggregateQtyDefault: o.aggregateQtyDefault,
        gstRows: o.gstRows
    });
    const d = $0167ea69d6388932$export$45c6a1876597daad();
    return {
        version: 2,
        documentTitleMaterial: typeof o.documentTitleMaterial === "string" && o.documentTitleMaterial.trim() ? o.documentTitleMaterial.trim().slice(0, 120) : d.documentTitleMaterial,
        documentTitleSubcontractor: typeof o.documentTitleSubcontractor === "string" && o.documentTitleSubcontractor.trim() ? o.documentTitleSubcontractor.trim().slice(0, 120) : d.documentTitleSubcontractor,
        documentTitleLabour: typeof o.documentTitleLabour === "string" && o.documentTitleLabour.trim() ? o.documentTitleLabour.trim().slice(0, 120) : d.documentTitleLabour,
        letterheadTagline: typeof o.letterheadTagline === "string" ? o.letterheadTagline.slice(0, 240) : d.letterheadTagline,
        logoPrimaryUrl: (0, $386b0bb84b222876$export$d24624a1ee66e259)(typeof o.logoPrimaryUrl === "string" ? o.logoPrimaryUrl.trim().slice(0, 5000000) : d.logoPrimaryUrl),
        logoSecondaryUrl: (0, $386b0bb84b222876$export$d24624a1ee66e259)(typeof o.logoSecondaryUrl === "string" ? o.logoSecondaryUrl.trim().slice(0, 5000000) : d.logoSecondaryUrl),
        logoPrimaryHeightPx: Number.isFinite(Number(o.logoPrimaryHeightPx)) ? $0167ea69d6388932$var$clampLogoHeight(Number(o.logoPrimaryHeightPx)) : d.logoPrimaryHeightPx,
        logoSecondaryHeightPx: Number.isFinite(Number(o.logoSecondaryHeightPx)) ? $0167ea69d6388932$var$clampLogoHeight(Number(o.logoSecondaryHeightPx)) : d.logoSecondaryHeightPx,
        accentColorHex: typeof o.accentColorHex === "string" ? $0167ea69d6388932$var$sanitizeAccentHex(o.accentColorHex) : d.accentColorHex,
        material: $0167ea69d6388932$var$clampTypeFormatBlock(o.material, sharedBlock),
        subcontractor: $0167ea69d6388932$var$clampTypeFormatBlock(o.subcontractor, sharedBlock),
        labour: $0167ea69d6388932$var$clampTypeFormatBlock(o.labour, sharedBlock),
        subcontractorBillLines: $0167ea69d6388932$var$clampSubcontractorBillLines(o.subcontractorBillLines),
        labourBillLines: $0167ea69d6388932$var$clampSubcontractorBillLines(o.labourBillLines)
    };
}
function $0167ea69d6388932$export$29a48fb856242f74(raw) {
    const d = $0167ea69d6388932$export$45c6a1876597daad();
    if (!raw || typeof raw !== "object") return d;
    const o = raw;
    if (!o.material && (o.billFromName !== undefined || o.version === 1)) return $0167ea69d6388932$var$migrateLegacyFlatSettings(o);
    return {
        version: 2,
        documentTitleMaterial: typeof o.documentTitleMaterial === "string" && o.documentTitleMaterial.trim() ? o.documentTitleMaterial.trim().slice(0, 120) : d.documentTitleMaterial,
        documentTitleSubcontractor: typeof o.documentTitleSubcontractor === "string" && o.documentTitleSubcontractor.trim() ? o.documentTitleSubcontractor.trim().slice(0, 120) : d.documentTitleSubcontractor,
        documentTitleLabour: typeof o.documentTitleLabour === "string" && o.documentTitleLabour.trim() ? o.documentTitleLabour.trim().slice(0, 120) : d.documentTitleLabour,
        letterheadTagline: typeof o.letterheadTagline === "string" ? o.letterheadTagline.slice(0, 240) : d.letterheadTagline,
        logoPrimaryUrl: (0, $386b0bb84b222876$export$d24624a1ee66e259)(typeof o.logoPrimaryUrl === "string" ? o.logoPrimaryUrl.trim().slice(0, 5000000) : d.logoPrimaryUrl),
        logoSecondaryUrl: (0, $386b0bb84b222876$export$d24624a1ee66e259)(typeof o.logoSecondaryUrl === "string" ? o.logoSecondaryUrl.trim().slice(0, 5000000) : d.logoSecondaryUrl),
        logoPrimaryHeightPx: Number.isFinite(Number(o.logoPrimaryHeightPx)) ? $0167ea69d6388932$var$clampLogoHeight(Number(o.logoPrimaryHeightPx)) : d.logoPrimaryHeightPx,
        logoSecondaryHeightPx: Number.isFinite(Number(o.logoSecondaryHeightPx)) ? $0167ea69d6388932$var$clampLogoHeight(Number(o.logoSecondaryHeightPx)) : d.logoSecondaryHeightPx,
        accentColorHex: typeof o.accentColorHex === "string" ? $0167ea69d6388932$var$sanitizeAccentHex(o.accentColorHex) : d.accentColorHex,
        material: $0167ea69d6388932$var$clampTypeFormatBlock(o.material, d.material),
        subcontractor: $0167ea69d6388932$var$clampTypeFormatBlock(o.subcontractor, d.subcontractor),
        labour: $0167ea69d6388932$var$clampTypeFormatBlock(o.labour, d.labour),
        subcontractorBillLines: $0167ea69d6388932$var$clampSubcontractorBillLines(o.subcontractorBillLines),
        labourBillLines: $0167ea69d6388932$var$clampSubcontractorBillLines(o.labourBillLines)
    };
}
function $0167ea69d6388932$export$f1d229bf4759dfa5() {
    try {
        const raw = localStorage.getItem($0167ea69d6388932$export$f58068f368efb763);
        if (!raw) return $0167ea69d6388932$export$45c6a1876597daad();
        return $0167ea69d6388932$export$29a48fb856242f74(JSON.parse(raw));
    } catch  {
        return $0167ea69d6388932$export$45c6a1876597daad();
    }
}
function $0167ea69d6388932$export$54e25f11670cea4a(s) {
    localStorage.setItem($0167ea69d6388932$export$f58068f368efb763, JSON.stringify($0167ea69d6388932$export$29a48fb856242f74(s)));
}
function $0167ea69d6388932$export$dd38b1b42a1ef675(s, type) {
    if (type === "material") return s.material;
    if (type === "subcontractor") return s.subcontractor;
    return s.labour;
}
function $0167ea69d6388932$export$d302ae792a4823cf(s, type) {
    if (type === "material") return s.documentTitleMaterial;
    if (type === "subcontractor") return s.documentTitleSubcontractor;
    return s.documentTitleLabour;
}
function $0167ea69d6388932$export$95bc935682e4d0b6(name, address, gstin) {
    const parts = [
        name.trim(),
        address.trim(),
        gstin.trim() ? `GSTIN: ${gstin.trim()}` : ""
    ].filter(Boolean);
    return parts.join("\n");
}
function $0167ea69d6388932$export$3897bf2f9c79d79d(invoiceType, settings) {
    const s = settings ?? $0167ea69d6388932$export$f1d229bf4759dfa5();
    const b = $0167ea69d6388932$export$dd38b1b42a1ef675(s, invoiceType);
    return $0167ea69d6388932$export$95bc935682e4d0b6(b.billFromName, b.billFromAddress, b.billFromGstin);
}
function $0167ea69d6388932$export$c9841c0638bbd9e9(invoiceType, settings) {
    const s = settings ?? $0167ea69d6388932$export$f1d229bf4759dfa5();
    const b = $0167ea69d6388932$export$dd38b1b42a1ef675(s, invoiceType);
    return $0167ea69d6388932$export$95bc935682e4d0b6(b.billToName, b.billToAddress, b.billToGstin);
}
function $0167ea69d6388932$export$5438c0cb848cd4a2(header, settings) {
    const s = settings ?? $0167ea69d6388932$export$f1d229bf4759dfa5();
    const b = $0167ea69d6388932$export$dd38b1b42a1ef675(s, header.invoiceType);
    const stored = $0167ea69d6388932$var$parseBillBlockText(header.billFromText);
    return {
        name: b.billFromName.trim() || stored.name || header.partyFirmName.trim(),
        address: b.billFromAddress.trim() || stored.address || header.partyAddress.trim(),
        gstin: b.billFromGstin.trim() || stored.gstin || header.partyGstin.trim()
    };
}
function $0167ea69d6388932$export$e356c6ab785ef972(header, settings) {
    const s = settings ?? $0167ea69d6388932$export$f1d229bf4759dfa5();
    const b = $0167ea69d6388932$export$dd38b1b42a1ef675(s, header.invoiceType);
    const stored = $0167ea69d6388932$var$parseBillBlockText(header.billToText);
    return {
        name: stored.name || b.billToName.trim(),
        address: stored.address || b.billToAddress.trim(),
        gstin: stored.gstin || b.billToGstin.trim()
    };
}
function $0167ea69d6388932$var$parseBillBlockText(text) {
    const lines = String(text ?? "").split(/\r?\n/).map((l)=>l.trim()).filter(Boolean);
    if (!lines.length) return {
        name: "",
        address: "",
        gstin: ""
    };
    const gstLine = lines.find((l)=>/^GSTIN:/i.test(l));
    const gstin = gstLine ? gstLine.replace(/^GSTIN:\s*/i, "").trim() : "";
    const rest = lines.filter((l)=>l !== gstLine);
    return {
        name: rest[0] ?? "",
        address: rest.slice(1).join("\n"),
        gstin: gstin
    };
}
function $0167ea69d6388932$export$b2d77326b23e5e14(rows) {
    return rows.map((r)=>{
        const n = Number.parseFloat(String(r.rateInput).replace(/,/g, "").trim());
        return {
            label: (r.label || "Tax").trim().slice(0, 64) || "Tax",
            ratePercent: Number.isFinite(n) ? Math.min(100, Math.max(0, n)) : 0
        };
    });
}
function $0167ea69d6388932$export$adfff66ef57cdc6d(rows) {
    return rows.map((r, i)=>({
            id: `gst-saved-${i}-${r.label.replace(/\W+/g, "").slice(0, 12)}`,
            label: r.label,
            rateInput: String(r.ratePercent)
        }));
}
function $0167ea69d6388932$export$7bd8f27d066809be(s, type) {
    return $0167ea69d6388932$export$6d2212a43f753781(s, type).reduce((sum, g)=>sum + g.ratePercent, 0);
}



async function $3a5f8f99aa429a90$export$2789c339476599aa(items, limit, fn) {
    if (!items.length) return [];
    const results = new Array(items.length);
    let nextIndex = 0;
    const workers = Math.max(1, Math.min(limit, items.length));
    async function worker() {
        for(;;){
            const i = nextIndex;
            nextIndex += 1;
            if (i >= items.length) return;
            results[i] = await fn(items[i], i);
        }
    }
    await Promise.all(Array.from({
        length: workers
    }, ()=>worker()));
    return results;
}
function $3a5f8f99aa429a90$export$b108a22f683cb589(blob, filename) {
    const url = URL.createObjectURL(blob);
    try {
        const a = document.createElement("a");
        a.href = url;
        a.download = filename.replace(/\.zip$/i, "").trim() || "download";
        if (!/\.zip$/i.test(a.download)) a.download += ".zip";
        a.rel = "noopener";
        document.body.appendChild(a);
        a.click();
        a.remove();
    } finally{
        URL.revokeObjectURL(url);
    }
}
async function $3a5f8f99aa429a90$var$blobToUint8Array(blob) {
    return new Uint8Array(await blob.arrayBuffer());
}
async function $3a5f8f99aa429a90$export$37cf72083ea610cb(files) {
    const zipEntries = {};
    for (const file of files){
        const path = file.path.replace(/\\/g, "/").replace(/^\/+/, "");
        if (!path) continue;
        zipEntries[path] = await $3a5f8f99aa429a90$var$blobToUint8Array(file.blob);
    }
    if (!Object.keys(zipEntries).length) throw new Error("No files to zip.");
    const zipped = (0, $16597f9d07f22afc$export$eb1654f146d54eb3)(zipEntries);
    return new Blob([
        zipped
    ], {
        type: "application/zip"
    });
}
async function $3a5f8f99aa429a90$export$81f0481d70653cd4(files, zipBasename) {
    const blob = await $3a5f8f99aa429a90$export$37cf72083ea610cb(files);
    $3a5f8f99aa429a90$export$b108a22f683cb589(blob, zipBasename);
}


const $103f1d5fa9f5b81b$export$413f67f7ce41f8d4 = "This is a computer-generated tax invoice and is valid without a physical signature. Amounts and GST are as per the details recorded at the time of generation.";
function $103f1d5fa9f5b81b$var$invoiceFooterNote(typeBlock) {
    return typeBlock.footerNote.trim() || $103f1d5fa9f5b81b$export$413f67f7ce41f8d4;
}
function $103f1d5fa9f5b81b$export$8f1e1ccf0a5808fa(header, allocations) {
    if (allocations.length <= 1) return false;
    if (header.selectionMode === "single" || header.beneficiaryCount <= 1) return false;
    return true;
}
function $103f1d5fa9f5b81b$var$parseBillBlock(text) {
    const lines = String(text ?? "").split(/\r?\n/).map((l)=>l.trim()).filter(Boolean);
    if (!lines.length) return {
        name: "",
        address: "",
        gstin: ""
    };
    const gstLine = lines.find((l)=>/^GSTIN:/i.test(l));
    const gstin = gstLine ? gstLine.replace(/^GSTIN:\s*/i, "").trim() : "";
    const rest = lines.filter((l)=>l !== gstLine);
    return {
        name: rest[0] ?? "",
        address: rest.slice(1).join("\n"),
        gstin: gstin
    };
}
function $103f1d5fa9f5b81b$var$aggregateInvoiceItems(items) {
    const map = new Map();
    for (const it of items){
        const key = `${it.lineLabel}::${it.catalogStandardItemId || it.lineKey}`;
        const cur = map.get(key);
        if (cur) cur.totalQty += it.qty;
        else map.set(key, {
            key: key,
            lineLabel: it.lineLabel,
            lineUnit: it.lineUnit,
            totalQty: it.qty,
            rate: it.rate,
            hsnCode: it.hsnCode
        });
    }
    return [
        ...map.values()
    ].sort((a, b)=>a.lineLabel.localeCompare(b.lineLabel));
}
function $103f1d5fa9f5b81b$var$getInvoiceBeneficiaryAllocations(items, geoByApplicationId) {
    const map = new Map();
    for (const it of items){
        if (!it.applicationId && !it.beneficiaryName) continue;
        const appKey = String(it.applicationId ?? "").trim() || `name::${(it.beneficiaryName ?? "").trim()}`;
        if (!map.has(appKey)) {
            const geo = geoByApplicationId?.get(String(it.applicationId ?? "").trim());
            map.set(appKey, {
                beneficiaryName: (it.beneficiaryName ?? "").trim() || "\u2014",
                applicationId: geo?.displayApplicationId ?? ((it.beneficiaryMobileApplicationId ?? "").trim() || appKey),
                district: geo?.district?.trim() || "\u2014",
                mandal: geo?.mandal?.trim() || "\u2014",
                village: geo?.village?.trim() || "\u2014",
                itemsMap: new Map()
            });
        }
        const row = map.get(appKey);
        const itemKey = it.lineKey;
        if (!row.itemsMap.has(itemKey)) row.itemsMap.set(itemKey, {
            label: it.lineLabel,
            qty: 0,
            unit: it.lineUnit
        });
        row.itemsMap.get(itemKey).qty += it.qty;
    }
    return [
        ...map.values()
    ].map((row)=>({
            beneficiaryName: row.beneficiaryName,
            applicationId: row.applicationId,
            district: row.district,
            mandal: row.mandal,
            village: row.village,
            items: [
                ...row.itemsMap.values()
            ].sort((a, b)=>a.label.localeCompare(b.label))
        })).sort((a, b)=>a.beneficiaryName.localeCompare(b.beneficiaryName));
}
function $103f1d5fa9f5b81b$var$invoiceReferenceText(header) {
    const parts = [];
    if (header.sourceMilestoneTitle?.trim()) parts.push(header.sourceMilestoneTitle.trim());
    if (header.notes?.trim()) parts.push(header.notes.trim());
    return parts.join("\n\n") || "\u2014";
}
function $103f1d5fa9f5b81b$export$8a60d6a0cea9b00(header, items, options) {
    const s = options?.formatSettings ?? (0, $0167ea69d6388932$export$f1d229bf4759dfa5)();
    const typeBlock = (0, $0167ea69d6388932$export$dd38b1b42a1ef675)(s, header.invoiceType);
    const billFrom = (0, $0167ea69d6388932$export$5438c0cb848cd4a2)(header, s);
    const billTo = (0, $0167ea69d6388932$export$e356c6ab785ef972)(header, s);
    const aggregateQty = typeBlock.aggregateQtyDefault;
    const baseLines = aggregateQty ? $103f1d5fa9f5b81b$var$aggregateInvoiceItems(items) : items.map((it)=>({
            key: it.id,
            lineLabel: it.lineLabel,
            lineUnit: it.lineUnit,
            totalQty: it.qty,
            rate: it.rate,
            hsnCode: it.hsnCode,
            beneficiaryName: it.beneficiaryName
        }));
    const htmlLines = baseLines.map((ln, idx)=>{
        const qty = ln.totalQty;
        const rate = ln.rate ?? 0;
        const subDesc = "beneficiaryName" in ln && ln.beneficiaryName ? `Beneficiary: ${ln.beneficiaryName}` : header.partyFirmName;
        return {
            sno: idx + 1,
            description: ln.lineLabel,
            subDescription: subDesc,
            hsn: (ln.hsnCode ?? "").trim(),
            qty: qty,
            unit: ln.lineUnit,
            rate: rate,
            amount: qty * rate
        };
    });
    const taxableTotal = htmlLines.reduce((sum, x)=>sum + x.amount, 0);
    const gstLines = (0, $0167ea69d6388932$export$6d2212a43f753781)(s, header.invoiceType).map((g)=>({
            label: g.label.trim() || "Tax",
            ratePercent: g.ratePercent,
            amount: taxableTotal * (g.ratePercent / 100)
        }));
    const grandTotal = taxableTotal + gstLines.reduce((sum, x)=>sum + x.amount, 0);
    const geoByAppId = options?.applications?.length ? (0, $ac21b9a9c4b3a809$export$236d41f0e28fa8fa)(options.applications) : undefined;
    const allocations = $103f1d5fa9f5b81b$var$getInvoiceBeneficiaryAllocations(items, geoByAppId);
    const pdfCap = options?.forPdfCapture === true;
    const footer = $103f1d5fa9f5b81b$var$invoiceFooterNote(typeBlock);
    const includeAnnexure = $103f1d5fa9f5b81b$export$8f1e1ccf0a5808fa(header, allocations);
    const html = (0, $386b0bb84b222876$export$4ddeb3921011e5d3)({
        documentTitle: (0, $0167ea69d6388932$export$d302ae792a4823cf)(s, header.invoiceType),
        letterheadTagline: s.letterheadTagline,
        logoPrimaryUrl: s.logoPrimaryUrl,
        logoSecondaryUrl: s.logoSecondaryUrl,
        logoPrimaryHeightPx: s.logoPrimaryHeightPx,
        logoSecondaryHeightPx: s.logoSecondaryHeightPx,
        accentColorHex: s.accentColorHex,
        footerNote: footer,
        defaultFooterNote: $103f1d5fa9f5b81b$export$413f67f7ce41f8d4,
        showSignatures: false,
        poNumber: header.invoiceNumber,
        poDate: header.invoiceDate || header.createdAt.slice(0, 10),
        buyerName: billTo.name,
        buyerAddress: billTo.address,
        buyerGstin: billTo.gstin,
        vendorName: billFrom.name,
        vendorAddress: billFrom.address,
        vendorGstin: billFrom.gstin,
        shipTo: $103f1d5fa9f5b81b$var$invoiceReferenceText(header),
        paymentTerms: typeBlock.paymentTerms,
        lines: htmlLines,
        taxableTotal: taxableTotal,
        gstLines: gstLines,
        grandTotal: grandTotal,
        forPdfCapture: pdfCap,
        labels: (0, $386b0bb84b222876$export$12f7be8231520394)
    });
    const annexureHtml = includeAnnexure ? (0, $386b0bb84b222876$export$df40be970a3bd4d5)({
        allocations: allocations,
        footerNote: footer,
        accentColorHex: s.accentColorHex,
        forPdfCapture: pdfCap
    }) : "";
    const safe = header.invoiceNumber.replace(/[^\w.-]+/g, "_");
    return {
        html: html,
        annexureHtml: annexureHtml,
        downloadBasename: `Invoice_${safe}`
    };
}
function $103f1d5fa9f5b81b$export$3fbbd2c30a83978c(header, items, applications, usedNames) {
    const appById = applications?.length ? new Map(applications.map((a)=>[
            a.id,
            a
        ])) : undefined;
    const firstItem = items[0];
    const appId = firstItem?.beneficiaryMobileApplicationId?.trim() || (firstItem?.applicationId ? appById?.get(firstItem.applicationId)?.mobile.applicationId : "") || header.invoiceNumber;
    const beneficiaryName = firstItem?.beneficiaryName?.trim() || (firstItem?.applicationId ? appById?.get(firstItem.applicationId)?.mobile.beneficiaryName : "") || "Beneficiary";
    return $103f1d5fa9f5b81b$var$uniquePdfFilename($103f1d5fa9f5b81b$var$sanitizeInvoicePdfBasename(appId, beneficiaryName), usedNames);
}
function $103f1d5fa9f5b81b$var$sanitizeInvoicePdfBasename(applicationId, beneficiaryName) {
    const app = applicationId.trim().replace(/[^\w.-]+/g, "_").replace(/^_+|_+$/g, "") || "APP";
    const name = beneficiaryName.trim().replace(/[^\w\s.-]+/g, "").replace(/\s+/g, "_").replace(/^_+|_+$/g, "").slice(0, 100) || "Beneficiary";
    return `${app}_${name}`;
}
function $103f1d5fa9f5b81b$var$uniquePdfFilename(base, usedNames = new Set()) {
    let candidate = `${base.replace(/\.pdf$/i, "")}.pdf`;
    let n = 2;
    while(usedNames.has(candidate.toLowerCase())){
        const stem = base.replace(/\.pdf$/i, "");
        candidate = `${stem}_${n}.pdf`;
        n += 1;
    }
    usedNames.add(candidate.toLowerCase());
    return candidate;
}
async function $103f1d5fa9f5b81b$export$3e814271300c1f0(header, items, options) {
    if (!items.length) throw new Error("No invoice lines to export.");
    const s = (0, $0167ea69d6388932$export$f1d229bf4759dfa5)();
    if (!options?.skipLogoWarm) await (0, $b2a79528db62cd8d$export$e6898c6b9b3f226e)([
        s.logoPrimaryUrl,
        s.logoSecondaryUrl
    ]);
    const geoByAppId = options?.applications?.length ? (0, $ac21b9a9c4b3a809$export$236d41f0e28fa8fa)(options.applications) : undefined;
    const allocations = $103f1d5fa9f5b81b$var$getInvoiceBeneficiaryAllocations(items, geoByAppId);
    const typeBlock = (0, $0167ea69d6388932$export$dd38b1b42a1ef675)(s, header.invoiceType);
    const footer = $103f1d5fa9f5b81b$var$invoiceFooterNote(typeBlock);
    const { html: html } = $103f1d5fa9f5b81b$export$8a60d6a0cea9b00(header, items, {
        applications: options?.applications,
        forPdfCapture: true
    });
    const useAnnexure = !options?.skipAnnexure && $103f1d5fa9f5b81b$export$8f1e1ccf0a5808fa(header, allocations);
    return (0, $b2a79528db62cd8d$export$fa7100892ae9c05f)(html, useAnnexure ? {
        annexure: {
            allocations: allocations,
            accentColorHex: s.accentColorHex,
            footerNote: footer
        }
    } : undefined);
}
function $103f1d5fa9f5b81b$var$normalizeInvoicePdfBundles(invoices) {
    return invoices.map((entry, index)=>{
        const header = entry.header ?? entry.invoice;
        if (!header) throw new Error(`Missing invoice header for PDF export (row ${index + 1}).`);
        if (!entry.items?.length) throw new Error(`Missing invoice lines for PDF export (row ${index + 1}).`);
        return {
            header: header,
            items: entry.items
        };
    });
}
async function $103f1d5fa9f5b81b$export$85a297f7329c9893(invoices, options) {
    if (!invoices.length) throw new Error("No invoices to export.");
    const bundles = $103f1d5fa9f5b81b$var$normalizeInvoicePdfBundles(invoices);
    const s = (0, $0167ea69d6388932$export$f1d229bf4759dfa5)();
    await (0, $b2a79528db62cd8d$export$e6898c6b9b3f226e)([
        s.logoPrimaryUrl,
        s.logoSecondaryUrl
    ]);
    const usedNames = new Set();
    const total = bundles.length;
    const pdfConcurrency = options?.pdfConcurrency ?? 6;
    let pdfDone = 0;
    const files = await (0, $3a5f8f99aa429a90$export$2789c339476599aa)(bundles, pdfConcurrency, async ({ header: header, items: items })=>{
        const blob = await $103f1d5fa9f5b81b$export$3e814271300c1f0(header, items, {
            applications: options?.applications,
            skipAnnexure: true,
            skipLogoWarm: true
        });
        pdfDone += 1;
        options?.onProgress?.(pdfDone, total);
        return {
            path: $103f1d5fa9f5b81b$export$3fbbd2c30a83978c(header, items, options?.applications, usedNames),
            blob: blob
        };
    });
    options?.onProgress?.(total, total);
    const zipName = options?.zipBasename?.trim() || `Invoices_${bundles.length}_${new Date().toISOString().slice(0, 10)}`;
    await (0, $3a5f8f99aa429a90$export$81f0481d70653cd4)(files, zipName);
}
async function $103f1d5fa9f5b81b$export$e680a9cf3c04adb(header, items, options) {
    if (!items.length) throw new Error("No invoice lines to export.");
    const s = (0, $0167ea69d6388932$export$f1d229bf4759dfa5)();
    await (0, $b2a79528db62cd8d$export$e6898c6b9b3f226e)([
        s.logoPrimaryUrl,
        s.logoSecondaryUrl
    ]);
    const geoByAppId = options?.applications?.length ? (0, $ac21b9a9c4b3a809$export$236d41f0e28fa8fa)(options.applications) : undefined;
    const typeBlock = (0, $0167ea69d6388932$export$dd38b1b42a1ef675)(s, header.invoiceType);
    const allocations = $103f1d5fa9f5b81b$var$getInvoiceBeneficiaryAllocations(items, geoByAppId);
    const footer = $103f1d5fa9f5b81b$var$invoiceFooterNote(typeBlock);
    const { html: html, downloadBasename: downloadBasename } = $103f1d5fa9f5b81b$export$8a60d6a0cea9b00(header, items, {
        applications: options?.applications,
        forPdfCapture: true
    });
    const useAnnexure = $103f1d5fa9f5b81b$export$8f1e1ccf0a5808fa(header, allocations);
    await (0, $b2a79528db62cd8d$export$768a1993afbfc55d)(html, downloadBasename, useAnnexure ? {
        annexure: {
            allocations: allocations,
            accentColorHex: s.accentColorHex,
            footerNote: footer
        }
    } : undefined);
}
const $103f1d5fa9f5b81b$var$SAMPLE_NOW = "2026-05-21T10:00:00.000Z";
function $103f1d5fa9f5b81b$var$sampleInvoiceItems(invoiceType, settings) {
    const base = {
        invoiceId: "sample",
        applicationId: "app-sample-1",
        beneficiaryName: "Sample Beneficiary",
        beneficiaryMobileApplicationId: "APP-2026-0001",
        hsnCode: "2523",
        catalogStandardItemId: "cat-1",
        sourcePoId: null,
        sourcePoItemId: null,
        sourceMilestoneTemplateItemId: null,
        createdAt: $103f1d5fa9f5b81b$var$SAMPLE_NOW
    };
    if (invoiceType === "subcontractor" && settings) {
        const row = settings.subcontractorBillLines.find((r)=>r.rate > 0) ?? settings.subcontractorBillLines[0];
        if (row) {
            const qty = row.qty > 0 ? row.qty : 1;
            const rate = row.rate > 0 ? row.rate : 185000;
            return [
                {
                    ...base,
                    id: "sample-s1",
                    lineKey: row.milestoneTemplateItemId,
                    lineLabel: row.lineLabel || "Masonry work \u2014 Subcontractor RA Bill",
                    lineUnit: row.unit || "LS",
                    qty: qty,
                    rate: rate,
                    lineAmount: qty * rate,
                    hsnCode: row.hsnCode || "9954"
                }
            ];
        }
    }
    if (invoiceType === "labour" && settings) {
        const priced = settings.labourBillLines.filter((r)=>r.rate > 0);
        const rows = (priced.length ? priced : settings.labourBillLines).slice(0, 2);
        if (rows.length) return rows.map((row, idx)=>{
            const qty = row.qty > 0 ? row.qty : 1;
            const rate = row.rate > 0 ? row.rate : 850;
            return {
                ...base,
                id: `sample-l${idx + 1}`,
                lineKey: row.milestoneTemplateItemId,
                lineLabel: row.lineLabel || "Labour Charges",
                lineUnit: row.unit || "LS",
                qty: qty,
                rate: rate,
                lineAmount: qty * rate,
                hsnCode: row.hsnCode || ""
            };
        });
    }
    if (invoiceType === "material") return [
        {
            ...base,
            id: "sample-m1",
            lineKey: "cement",
            lineLabel: "OPC 53 Grade Cement",
            lineUnit: "Bag",
            qty: 120,
            rate: 385,
            lineAmount: 46200
        },
        {
            ...base,
            id: "sample-m2",
            lineKey: "sand",
            lineLabel: "River Sand (fine)",
            lineUnit: "Cum",
            qty: 8,
            rate: 2200,
            lineAmount: 17600
        }
    ];
    if (invoiceType === "subcontractor") return [
        {
            ...base,
            id: "sample-s1",
            lineKey: "masonry",
            lineLabel: "Masonry work \u2014 ground floor",
            lineUnit: "LS",
            qty: 1,
            rate: 185000,
            lineAmount: 185000,
            hsnCode: "9954"
        }
    ];
    return [
        {
            ...base,
            id: "sample-l1",
            lineKey: "labour-1",
            lineLabel: "Skilled mason \u2014 daily wages",
            lineUnit: "Day",
            qty: 24,
            rate: 850,
            lineAmount: 20400,
            hsnCode: ""
        },
        {
            ...base,
            id: "sample-l2",
            lineKey: "labour-2",
            lineLabel: "Helper \u2014 daily wages",
            lineUnit: "Day",
            qty: 18,
            rate: 550,
            lineAmount: 9900,
            hsnCode: ""
        }
    ];
}
function $103f1d5fa9f5b81b$var$sampleInvoiceHeader(invoiceType, settings) {
    const b = (0, $0167ea69d6388932$export$dd38b1b42a1ef675)(settings, invoiceType);
    const billFrom = (0, $0167ea69d6388932$export$95bc935682e4d0b6)(b.billFromName || "Sample Supplier Pvt Ltd", b.billFromAddress || "Plot 12, Industrial Area\nHyderabad, Telangana \u2014 500032", b.billFromGstin || "36AABCS1234A1Z5");
    const billTo = (0, $0167ea69d6388932$export$95bc935682e4d0b6)(b.billToName || "Indiramma Indlu Programme", b.billToAddress || "Chief Minister's Office\nHyderabad, Telangana", b.billToGstin || "36AAAGT1234A1Z9");
    return {
        id: "sample",
        invoiceNumber: `INV-SAMPLE-${invoiceType.slice(0, 3).toUpperCase()}-001`,
        invoiceType: invoiceType,
        invoiceDate: $103f1d5fa9f5b81b$var$SAMPLE_NOW.slice(0, 10),
        status: "generated",
        partyKind: invoiceType === "labour" ? "labour_supplier" : "subcontractor",
        partyMasterId: "",
        partyFirmName: b.billFromName || "Sample Supplier Pvt Ltd",
        partyGstin: b.billFromGstin || "36AABCS1234A1Z5",
        partyAddress: b.billFromAddress,
        billFromText: billFrom,
        billToText: billTo,
        beneficiaryCount: 1,
        selectionMode: "single",
        sourcePoId: null,
        sourceMilestoneTemplateId: null,
        sourceMilestoneTitle: invoiceType === "subcontractor" ? "Milestone: Masonry completion" : null,
        subcontractorMasterId: null,
        notes: invoiceType === "material" ? "Against PO / inward for sample preview." : "",
        taxableTotal: 0,
        grandTotal: 0,
        createdAt: $103f1d5fa9f5b81b$var$SAMPLE_NOW,
        updatedAt: $103f1d5fa9f5b81b$var$SAMPLE_NOW
    };
}
function $103f1d5fa9f5b81b$export$ff58404e836f6d1f(settings, invoiceType, options) {
    const header = $103f1d5fa9f5b81b$var$sampleInvoiceHeader(invoiceType, settings);
    const items = $103f1d5fa9f5b81b$var$sampleInvoiceItems(invoiceType, settings);
    return $103f1d5fa9f5b81b$export$8a60d6a0cea9b00(header, items, {
        forPdfCapture: options?.forPdfCapture,
        formatSettings: settings
    }).html;
}
function $103f1d5fa9f5b81b$export$4fede9169bf217a0(settings, invoiceType) {
    const header = $103f1d5fa9f5b81b$var$sampleInvoiceHeader(invoiceType, settings);
    const items = $103f1d5fa9f5b81b$var$sampleInvoiceItems(invoiceType, settings);
    const doc = $103f1d5fa9f5b81b$export$8a60d6a0cea9b00(header, items, {
        formatSettings: settings
    });
    const allocations = $103f1d5fa9f5b81b$var$getInvoiceBeneficiaryAllocations(items);
    const typeBlock = (0, $0167ea69d6388932$export$dd38b1b42a1ef675)(settings, invoiceType);
    return {
        html: doc.html,
        allocations: allocations,
        accentColorHex: settings.accentColorHex,
        footerNote: $103f1d5fa9f5b81b$var$invoiceFooterNote(typeBlock)
    };
}


function $ec93bb30e5e10f28$export$31630dc90ebea42e({ invoice: invoice, items: items, applications: applications, onClose: onClose, onCancel: onCancel }) {
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const [pdfBusy, setPdfBusy] = (0, $7UyaH.useState)(false);
    const [cancelBusy, setCancelBusy] = (0, $7UyaH.useState)(false);
    const previewHtml = (0, $7UyaH.useMemo)(()=>{
        try {
            return (0, $103f1d5fa9f5b81b$export$8a60d6a0cea9b00)(invoice, items, {
                applications: applications
            }).html;
        } catch  {
            return "";
        }
    }, [
        invoice,
        items,
        applications
    ]);
    (0, $7UyaH.useEffect)(()=>{
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return ()=>{
            document.body.style.overflow = prev;
        };
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        function onKey(e) {
            if (e.key === "Escape") onClose();
        }
        window.addEventListener("keydown", onKey);
        return ()=>window.removeEventListener("keydown", onKey);
    }, [
        onClose
    ]);
    const runDownload = (0, $7UyaH.useCallback)(async ()=>{
        setPdfBusy(true);
        try {
            await (0, $103f1d5fa9f5b81b$export$e680a9cf3c04adb)(invoice, items, {
                applications: applications
            });
            showToast(`PDF downloaded (${invoice.invoiceNumber}).`, "success");
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not download PDF.", "error");
        } finally{
            setPdfBusy(false);
        }
    }, [
        invoice,
        items,
        applications,
        showToast
    ]);
    const runCancel = (0, $7UyaH.useCallback)(async ()=>{
        if (!onCancel) return;
        const ok = window.confirm(`Cancel invoice ${invoice.invoiceNumber}? It will be marked inactive.`);
        if (!ok) return;
        setCancelBusy(true);
        try {
            await onCancel();
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not cancel invoice.", "error");
        } finally{
            setCancelBusy(false);
        }
    }, [
        onCancel,
        invoice.invoiceNumber,
        showToast
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "po-success-overlay",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "inv-success-title",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                type: "button",
                className: "po-success-overlay__backdrop",
                "aria-label": "Dismiss",
                onClick: onClose
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "po-success-ticket",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("header", {
                        className: "po-success-ticket__header",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                id: "inv-success-title",
                                children: "Invoice generated"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "po-success-ticket__close",
                                onClick: onClose,
                                "aria-label": "Close",
                                children: "\xd7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "po-success-ticket__meta",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                        children: invoice.invoiceNumber
                                    }),
                                    " \xb7 ",
                                    invoice.partyFirmName,
                                    " \xb7 ",
                                    invoice.beneficiaryCount,
                                    " ",
                                    "beneficiary(ies)"
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                className: "text-muted",
                                children: [
                                    "Taxable \u20B9",
                                    invoice.taxableTotal.toLocaleString("en-IN"),
                                    " \xb7 Grand total \u20B9",
                                    invoice.grandTotal.toLocaleString("en-IN")
                                ]
                            })
                        ]
                    }),
                    previewHtml ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("iframe", {
                        className: "po-success-ticket__preview",
                        title: "Invoice preview",
                        srcDoc: previewHtml,
                        sandbox: "allow-same-origin"
                    }) : null,
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "po-success-ticket__actions",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--primary btn--tg",
                                disabled: pdfBusy,
                                onClick: ()=>void runDownload(),
                                children: pdfBusy ? "Preparing PDF\u2026" : "Download PDF"
                            }),
                            onCancel ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--danger btn--tg-secondary",
                                disabled: cancelBusy,
                                onClick: ()=>void runCancel(),
                                children: cancelBusy ? "Cancelling\u2026" : "Cancel invoice"
                            }) : null,
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--tg-secondary",
                                onClick: onClose,
                                children: "Close"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}






async function $cbddb03275b22218$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
async function $cbddb03275b22218$export$aaa1b475f4a0ad4a(q = {}) {
    const params = new URLSearchParams();
    params.set("limit", String(Math.min(2000, Math.max(1, q.limit ?? 500))));
    if (q.invoiceType) params.set("invoiceType", q.invoiceType);
    if (q.search?.trim()) params.set("search", q.search.trim());
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/invoices?${params.toString()}`);
    if (!res.ok) throw new Error(await $cbddb03275b22218$var$parseError(res));
    return res.json();
}
async function $cbddb03275b22218$export$6886af56b3cb5e7f(invoiceId) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/invoices/${encodeURIComponent(invoiceId)}/items`);
    if (!res.ok) throw new Error(await $cbddb03275b22218$var$parseError(res));
    return res.json();
}
async function $cbddb03275b22218$export$597be8017f4f4590(body) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/invoices/eligible-material-lines`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $cbddb03275b22218$var$parseError(res));
    return res.json();
}
async function $cbddb03275b22218$export$93c3270efb9c08d8(body) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/invoices/eligible-subcontractor-lines`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $cbddb03275b22218$var$parseError(res));
    return res.json();
}
async function $cbddb03275b22218$export$5c2ff2dfc7400301(body) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/invoices/eligible-labour-lines`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $cbddb03275b22218$var$parseError(res));
    return res.json();
}
async function $cbddb03275b22218$export$1e474a5c026bd11a(body) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/invoices/generate`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $cbddb03275b22218$var$parseError(res));
    return res.json();
}
async function $cbddb03275b22218$export$222a9c561ea276af(invoiceId) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/inventory/invoices/${encodeURIComponent(invoiceId)}/cancel`, {
        method: "POST"
    });
    if (!res.ok) throw new Error(await $cbddb03275b22218$var$parseError(res));
    return res.json();
}





async function $ba596e844a9fe971$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
async function $ba596e844a9fe971$export$3ba796e348617408() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/labour-suppliers`);
    if (!res.ok) throw new Error(await $ba596e844a9fe971$var$parseError(res));
    return res.json();
}
async function $ba596e844a9fe971$export$d90a620c7a57ca8(body) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/labour-suppliers`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $ba596e844a9fe971$var$parseError(res));
    return res.json();
}
async function $ba596e844a9fe971$export$23ed12d3722d7f8f(id, body) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/labour-suppliers/${encodeURIComponent(id)}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $ba596e844a9fe971$var$parseError(res));
    return res.json();
}
async function $ba596e844a9fe971$export$8cdf04b0a5ea78b7(id) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/labour-suppliers/${encodeURIComponent(id)}/deactivate`, {
        method: "POST"
    });
    if (!res.ok) throw new Error(await $ba596e844a9fe971$var$parseError(res));
}




/** Parse quantity from form text (never use string + number addition on raw inputs). */ function $50736abadf17d9d0$export$9402e78cb00b9e90(raw) {
    if (raw == null) return 0;
    const t = String(raw).trim().replace(/\s/g, "").replace(/,/g, ".");
    if (t === "" || t === ".") return 0;
    const n = Number.parseFloat(t);
    if (!Number.isFinite(n) || n < 0) return 0;
    return Math.round(n * 10000) / 10000;
}
function $50736abadf17d9d0$export$73a62fdf13118eb6(raw) {
    const s = raw.replace(/[^\d.,]/g, "").replace(/,/g, ".");
    const firstDot = s.indexOf(".");
    if (firstDot === -1) return s;
    return s.slice(0, firstDot + 1) + s.slice(firstDot + 1).replace(/\./g, "");
}


const $dce066e6da047798$export$de0ab417ffcd8733 = "Subcontractor RA Bill";
const $dce066e6da047798$export$a5e38af2a003aa19 = "Labour Charges";
function $dce066e6da047798$export$6fedc93dd82b3e77(phaseTitle, kind) {
    const title = phaseTitle.trim();
    const suffix = kind === "labour" ? $dce066e6da047798$export$a5e38af2a003aa19 : $dce066e6da047798$export$de0ab417ffcd8733;
    return title ? `${title} \u{2014} ${suffix}` : suffix;
}
function $dce066e6da047798$export$c2a61fbb231f1b61(phaseTitles) {
    return [
        ...new Set(phaseTitles.map((t)=>t.trim()).filter(Boolean))
    ].join(", ");
}


function $34977f436b6dfc5f$export$2f39f40a19f14ecb(milestoneTemplateId) {
    return `msbill:${milestoneTemplateId}`;
}
function $34977f436b6dfc5f$export$51fb74a418e36fe9(timelinePhaseId) {
    return `tlbill:${timelinePhaseId}`;
}
function $34977f436b6dfc5f$export$4e138964600e2f53(templateItemId) {
    return String(templateItemId ?? "").startsWith("msbill:");
}
function $34977f436b6dfc5f$export$d2c83727172fa24f(row) {
    return row.billSource === "timeline" || String(row.milestoneTemplateItemId ?? "").startsWith("tlbill:");
}
function $34977f436b6dfc5f$export$ddb07746716ede91(row) {
    return !$34977f436b6dfc5f$export$d2c83727172fa24f(row);
}
function $34977f436b6dfc5f$export$86f9b6bfee38c313(lines) {
    return lines.filter($34977f436b6dfc5f$export$ddb07746716ede91);
}
function $34977f436b6dfc5f$export$ab3222ab10de271e(lines) {
    return lines.filter($34977f436b6dfc5f$export$d2c83727172fa24f);
}
function $34977f436b6dfc5f$export$cf7f626c7699a89f(milestoneTemplates, existing = []) {
    const byItemId = new Map(existing.map((row)=>[
            row.milestoneTemplateItemId,
            row
        ]));
    const out = [];
    const sortedMilestones = [
        ...milestoneTemplates
    ].sort((a, b)=>a.sortOrder - b.sortOrder || a.title.localeCompare(b.title));
    for (const tpl of sortedMilestones){
        const billItems = tpl.items.filter((item)=>item.kind === "subcontractor_bill");
        if (billItems.length > 0) {
            for (const item of billItems){
                const prev = byItemId.get(item.id);
                out.push({
                    billSource: "milestone",
                    milestoneTemplateId: tpl.id,
                    milestoneTemplateItemId: item.id,
                    milestoneTitle: tpl.title,
                    lineLabel: prev?.lineLabel?.trim() || item.label,
                    timelinePhaseIds: [],
                    timelinePhaseTitles: [],
                    qty: prev?.qty ?? 1,
                    unit: prev?.unit ?? "LS",
                    rate: prev?.rate ?? 0,
                    hsnCode: prev?.hsnCode ?? ""
                });
            }
            continue;
        }
        const syntheticId = $34977f436b6dfc5f$export$2f39f40a19f14ecb(tpl.id);
        const prev = byItemId.get(syntheticId);
        out.push({
            billSource: "milestone",
            milestoneTemplateId: tpl.id,
            milestoneTemplateItemId: syntheticId,
            milestoneTitle: tpl.title,
            lineLabel: prev?.lineLabel?.trim() || (0, $dce066e6da047798$export$6fedc93dd82b3e77)(tpl.title, "subcontractor"),
            timelinePhaseIds: [],
            timelinePhaseTitles: [],
            qty: prev?.qty ?? 1,
            unit: prev?.unit ?? "LS",
            rate: prev?.rate ?? 0,
            hsnCode: prev?.hsnCode ?? ""
        });
    }
    return out;
}
function $34977f436b6dfc5f$export$d86cd36d4afa3287(timelinePhases, existing = []) {
    const byItemId = new Map(existing.map((row)=>[
            row.milestoneTemplateItemId,
            row
        ]));
    const out = [];
    const sortedPhases = [
        ...timelinePhases
    ].sort((a, b)=>a.sortOrder - b.sortOrder || a.title.localeCompare(b.title));
    for (const phase of sortedPhases){
        const phaseId = String(phase.id);
        const syntheticId = $34977f436b6dfc5f$export$51fb74a418e36fe9(phaseId);
        const prev = byItemId.get(syntheticId);
        out.push({
            billSource: "timeline",
            milestoneTemplateId: "",
            milestoneTemplateItemId: syntheticId,
            milestoneTitle: phase.title,
            lineLabel: prev?.lineLabel?.trim() || (0, $dce066e6da047798$export$6fedc93dd82b3e77)(phase.title, "subcontractor"),
            timelinePhaseIds: [
                phaseId
            ],
            timelinePhaseTitles: [
                phase.title
            ],
            qty: prev?.qty ?? 1,
            unit: prev?.unit ?? "LS",
            rate: prev?.rate ?? 0,
            hsnCode: prev?.hsnCode ?? ""
        });
    }
    return out;
}
function $34977f436b6dfc5f$export$ac195a4586e1676e(milestoneTemplates, timelinePhases, existing = []) {
    return [
        ...$34977f436b6dfc5f$export$cf7f626c7699a89f(milestoneTemplates, existing),
        ...$34977f436b6dfc5f$export$d86cd36d4afa3287(timelinePhases, existing)
    ];
}
function $34977f436b6dfc5f$export$c05f3b2e8cce4802(settings, templateItemId) {
    return settings.subcontractorBillLines.find((row)=>row.milestoneTemplateItemId === templateItemId);
}
function $34977f436b6dfc5f$export$d9c9921405b45f3e(line, settings) {
    const cfg = $34977f436b6dfc5f$export$c05f3b2e8cce4802(settings, line.templateItemId);
    if (!cfg) return line;
    return {
        ...line,
        lineLabel: cfg.lineLabel.trim() || line.lineLabel,
        lineUnit: cfg.unit.trim() || line.lineUnit,
        eligibleQty: cfg.qty > 0 ? cfg.qty : line.eligibleQty,
        rate: cfg.rate > 0 ? cfg.rate : line.rate,
        hsnCode: cfg.hsnCode.trim() || line.hsnCode
    };
}
function $34977f436b6dfc5f$export$dd3da66e9b042e55(templates) {
    return [
        ...templates
    ].sort((a, b)=>a.sortOrder - b.sortOrder || a.title.localeCompare(b.title));
}
function $34977f436b6dfc5f$export$6b24979a13156f76(templates) {
    return $34977f436b6dfc5f$export$dd3da66e9b042e55(templates);
}
function $34977f436b6dfc5f$export$a3f7d7727b8b1f85(templates, timelinePhaseId) {
    const phaseId = String(timelinePhaseId).trim();
    if (!phaseId) return [];
    return $34977f436b6dfc5f$export$dd3da66e9b042e55(templates).filter((tpl)=>(tpl.linkedConstructionTimelinePhaseIds ?? []).some((id)=>String(id) === phaseId));
}



function $fe4bf9984635f90b$var$subLineByItemId(subcontractorFallback, itemId) {
    return subcontractorFallback.find((row)=>row.milestoneTemplateItemId === itemId);
}
function $fe4bf9984635f90b$var$labourPricingFields(prev, sub) {
    const rate = (prev?.rate ?? 0) > 0 ? prev.rate : sub?.rate ?? 0;
    const qty = (prev?.qty ?? 0) > 0 ? prev.qty : sub?.qty ?? 1;
    return {
        qty: qty,
        unit: prev?.unit?.trim() || sub?.unit?.trim() || "LS",
        rate: rate,
        hsnCode: prev?.hsnCode?.trim() || sub?.hsnCode?.trim() || ""
    };
}
function $fe4bf9984635f90b$export$91ed5d6b8e5de3fc(milestoneTemplates, existing = [], subcontractorFallback = []) {
    const byItemId = new Map(existing.map((row)=>[
            row.milestoneTemplateItemId,
            row
        ]));
    const out = [];
    const sortedMilestones = [
        ...milestoneTemplates
    ].sort((a, b)=>a.sortOrder - b.sortOrder || a.title.localeCompare(b.title));
    for (const tpl of sortedMilestones){
        const billItems = tpl.items.filter((item)=>item.kind === "subcontractor_bill");
        if (billItems.length > 0) {
            for (const item of billItems){
                const prev = byItemId.get(item.id);
                const sub = $fe4bf9984635f90b$var$subLineByItemId(subcontractorFallback, item.id);
                out.push({
                    billSource: "milestone",
                    milestoneTemplateId: tpl.id,
                    milestoneTemplateItemId: item.id,
                    milestoneTitle: tpl.title,
                    lineLabel: prev?.lineLabel?.trim() || (0, $dce066e6da047798$export$6fedc93dd82b3e77)(tpl.title, "labour"),
                    timelinePhaseIds: [],
                    timelinePhaseTitles: [],
                    ...$fe4bf9984635f90b$var$labourPricingFields(prev, sub)
                });
            }
            continue;
        }
        const syntheticId = (0, $34977f436b6dfc5f$export$2f39f40a19f14ecb)(tpl.id);
        const prev = byItemId.get(syntheticId);
        const sub = $fe4bf9984635f90b$var$subLineByItemId(subcontractorFallback, syntheticId);
        out.push({
            billSource: "milestone",
            milestoneTemplateId: tpl.id,
            milestoneTemplateItemId: syntheticId,
            milestoneTitle: tpl.title,
            lineLabel: prev?.lineLabel?.trim() || (0, $dce066e6da047798$export$6fedc93dd82b3e77)(tpl.title, "labour"),
            timelinePhaseIds: [],
            timelinePhaseTitles: [],
            ...$fe4bf9984635f90b$var$labourPricingFields(prev, sub)
        });
    }
    return out;
}
function $fe4bf9984635f90b$export$8560aeee2e462875(timelinePhases, existing = [], subcontractorFallback = []) {
    const byItemId = new Map(existing.map((row)=>[
            row.milestoneTemplateItemId,
            row
        ]));
    const out = [];
    const sortedPhases = [
        ...timelinePhases
    ].sort((a, b)=>a.sortOrder - b.sortOrder || a.title.localeCompare(b.title));
    for (const phase of sortedPhases){
        const phaseId = String(phase.id);
        const syntheticId = (0, $34977f436b6dfc5f$export$51fb74a418e36fe9)(phaseId);
        const prev = byItemId.get(syntheticId);
        const sub = $fe4bf9984635f90b$var$subLineByItemId(subcontractorFallback, syntheticId);
        out.push({
            billSource: "timeline",
            milestoneTemplateId: "",
            milestoneTemplateItemId: syntheticId,
            milestoneTitle: phase.title,
            lineLabel: prev?.lineLabel?.trim() || (0, $dce066e6da047798$export$6fedc93dd82b3e77)(phase.title, "labour"),
            timelinePhaseIds: [
                phaseId
            ],
            timelinePhaseTitles: [
                phase.title
            ],
            ...$fe4bf9984635f90b$var$labourPricingFields(prev, sub)
        });
    }
    return out;
}
function $fe4bf9984635f90b$export$70b883779db5e631(milestoneTemplates, timelinePhases, existing = [], subcontractorFallback = []) {
    return [
        ...$fe4bf9984635f90b$export$91ed5d6b8e5de3fc(milestoneTemplates, existing, subcontractorFallback),
        ...$fe4bf9984635f90b$export$8560aeee2e462875(timelinePhases, existing, subcontractorFallback)
    ];
}
function $fe4bf9984635f90b$export$320c707e0f51d712(labourLines, subcontractorLines) {
    const subById = new Map(subcontractorLines.map((row)=>[
            row.milestoneTemplateItemId,
            row
        ]));
    return labourLines.map((lab)=>{
        const sub = subById.get(lab.milestoneTemplateItemId);
        if (!sub) return lab;
        return {
            ...lab,
            qty: sub.qty > 0 ? sub.qty : lab.qty,
            unit: sub.unit.trim() || lab.unit,
            rate: sub.rate,
            hsnCode: sub.hsnCode.trim() || lab.hsnCode
        };
    });
}
function $fe4bf9984635f90b$export$9b01fbcdd1a94bc6(lines) {
    return lines.filter((row)=>!(0, $34977f436b6dfc5f$export$d2c83727172fa24f)(row));
}
function $fe4bf9984635f90b$export$d9233c310eec4fba(lines) {
    return lines.filter((0, $34977f436b6dfc5f$export$d2c83727172fa24f));
}
function $fe4bf9984635f90b$export$2c1440abcfd24dff(settings, templateItemId) {
    return settings.labourBillLines.find((row)=>row.milestoneTemplateItemId === templateItemId);
}
function $fe4bf9984635f90b$export$c135998fb4d1d908(line, settings) {
    const cfg = $fe4bf9984635f90b$export$2c1440abcfd24dff(settings, line.templateItemId);
    const subCfg = cfg && cfg.rate > 0 ? undefined : (0, $34977f436b6dfc5f$export$c05f3b2e8cce4802)(settings, line.templateItemId);
    const pricing = cfg?.rate > 0 ? cfg : subCfg;
    if (!cfg && !pricing) return line;
    return {
        ...line,
        lineLabel: cfg?.lineLabel.trim() || line.lineLabel,
        lineUnit: cfg?.unit.trim() || pricing?.unit.trim() || line.lineUnit,
        eligibleQty: (cfg?.qty ?? 0) > 0 ? cfg.qty : (pricing?.qty ?? 0) > 0 ? pricing.qty : line.eligibleQty,
        rate: (cfg?.rate ?? 0) > 0 ? cfg.rate : (pricing?.rate ?? 0) > 0 ? pricing.rate : line.rate,
        hsnCode: cfg?.hsnCode.trim() || pricing?.hsnCode.trim() || line.hsnCode,
        milestoneTitle: cfg?.timelinePhaseTitles[0]?.trim() || cfg?.milestoneTitle.trim() || line.milestoneTitle
    };
}





function $a78dc66b5570f421$var$timelineReferenceFromPhaseIds(phaseIds, titleById) {
    return (0, $dce066e6da047798$export$c2a61fbb231f1b61)(phaseIds.map((id)=>titleById.get(id) ?? "").filter(Boolean));
}
function $a78dc66b5570f421$var$formatWhen(iso) {
    if (!iso) return "\u2014";
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? iso : d.toLocaleString();
}
function $a78dc66b5570f421$var$fmtInr(n) {
    if (!Number.isFinite(n)) return "\u2014";
    return `\u{20B9}${n.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })}`;
}
function $a78dc66b5570f421$var$invoiceTypeLabel(t) {
    if (t === "material") return "Material";
    if (t === "subcontractor") return "Subcontractor";
    return "Labour";
}
function $a78dc66b5570f421$var$buildBeneficiaryBillTo(app) {
    const addressParts = [
        app.sitePlot?.trim(),
        app.village?.trim(),
        app.mandal?.trim(),
        String(app.district ?? "").trim()
    ].filter(Boolean);
    const address = [
        app.mobile.applicationId ? `Application ID: ${app.mobile.applicationId}` : "",
        addressParts.join(", ")
    ].filter(Boolean).join("\n");
    return (0, $0167ea69d6388932$export$95bc935682e4d0b6)(app.mobile.beneficiaryName, address, "");
}
function $a78dc66b5570f421$var$materialLinesForApp(lines, appId, qtyOverrides) {
    const out = [];
    for (const ln of lines){
        if (ln.applicationId !== appId) continue;
        const rawQty = qtyOverrides[ln.lineKey];
        const qty = rawQty != null && rawQty.trim() !== "" ? (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(rawQty) : ln.eligibleQty;
        if (!(qty > 0)) continue;
        if (qty > ln.eligibleQty + 0.0001) throw new Error(`Qty exceeds eligible for ${ln.beneficiaryName} \u{2014} ${ln.lineLabel}.`);
        out.push({
            applicationId: ln.applicationId,
            beneficiaryName: ln.beneficiaryName,
            beneficiaryMobileApplicationId: ln.beneficiaryMobileApplicationId,
            lineKey: ln.lineKey,
            lineLabel: ln.lineLabel,
            lineUnit: ln.lineUnit,
            qty: qty,
            rate: ln.rate,
            hsnCode: ln.hsnCode,
            catalogStandardItemId: ln.catalogStandardItemId,
            sourcePoId: ln.poId,
            sourcePoItemId: ln.poItemId
        });
    }
    return out;
}
function $a78dc66b5570f421$var$materialLinesToGenerateInput(lines, qtyOverrides) {
    const out = [];
    for (const ln of lines){
        const rawQty = qtyOverrides[ln.lineKey];
        const qty = rawQty != null && rawQty.trim() !== "" ? (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(rawQty) : ln.eligibleQty;
        if (!(qty > 0)) continue;
        if (qty > ln.eligibleQty + 0.0001) throw new Error(`Qty exceeds eligible for ${ln.lineLabel}.`);
        out.push({
            applicationId: ln.applicationId,
            beneficiaryName: ln.beneficiaryName,
            beneficiaryMobileApplicationId: ln.beneficiaryMobileApplicationId,
            lineKey: ln.lineKey,
            lineLabel: ln.lineLabel,
            lineUnit: ln.lineUnit,
            qty: qty,
            rate: ln.rate,
            hsnCode: ln.hsnCode,
            catalogStandardItemId: ln.catalogStandardItemId,
            sourcePoId: ln.poId,
            sourcePoItemId: ln.poItemId
        });
    }
    return out;
}
function $a78dc66b5570f421$var$subcontractorLinesForApp(lines, appId, qtyOverrides, rateOverrides) {
    const out = [];
    for (const ln of lines){
        if (ln.applicationId !== appId) continue;
        const rawQty = qtyOverrides[ln.lineKey];
        const qty = rawQty != null && rawQty.trim() !== "" ? (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(rawQty) : ln.eligibleQty;
        const rawRate = rateOverrides[ln.lineKey];
        const rate = rawRate != null && rawRate.trim() !== "" ? (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(rawRate) : ln.rate;
        if (!(qty > 0) || !(rate > 0)) continue;
        out.push({
            applicationId: ln.applicationId,
            beneficiaryName: ln.beneficiaryName,
            beneficiaryMobileApplicationId: ln.beneficiaryMobileApplicationId,
            lineKey: ln.lineKey,
            lineLabel: ln.lineLabel,
            lineUnit: ln.lineUnit,
            qty: qty,
            rate: rate,
            hsnCode: ln.hsnCode,
            sourceMilestoneTemplateItemId: ln.templateItemId
        });
    }
    return out;
}
function $a78dc66b5570f421$var$subcontractorLinesToGenerateInput(lines, qtyOverrides, rateOverrides) {
    const out = [];
    for (const ln of lines){
        const rawQty = qtyOverrides[ln.lineKey];
        const qty = rawQty != null && rawQty.trim() !== "" ? (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(rawQty) : ln.eligibleQty;
        const rawRate = rateOverrides[ln.lineKey];
        const rate = rawRate != null && rawRate.trim() !== "" ? (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(rawRate) : ln.rate;
        if (!(qty > 0) || !(rate > 0)) continue;
        out.push({
            applicationId: ln.applicationId,
            beneficiaryName: ln.beneficiaryName,
            beneficiaryMobileApplicationId: ln.beneficiaryMobileApplicationId,
            lineKey: ln.lineKey,
            lineLabel: ln.lineLabel,
            lineUnit: ln.lineUnit,
            qty: qty,
            rate: rate,
            hsnCode: ln.hsnCode,
            sourceMilestoneTemplateItemId: ln.templateItemId
        });
    }
    return out;
}
function $a78dc66b5570f421$export$7edcbc4514f9bffd() {
    const { applications: applications, milestoneTemplates: milestoneTemplates, subcontractorMasters: subcontractorMasters, constructionTimelinePhases: constructionTimelinePhases } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const [viewMode, setViewMode] = (0, $7UyaH.useState)("generate");
    const [invoiceType, setInvoiceType] = (0, $7UyaH.useState)("material");
    const [invoiceApplicationIds, setInvoiceApplicationIds] = (0, $7UyaH.useState)([]);
    const [beneficiarySearch, setBeneficiarySearch] = (0, $7UyaH.useState)("");
    const [districtFilter, setDistrictFilter] = (0, $7UyaH.useState)("all");
    const [milestoneTemplateId, setMilestoneTemplateId] = (0, $7UyaH.useState)("");
    const [materialPoId, setMaterialPoId] = (0, $7UyaH.useState)("");
    const [materialInvoiceMode, setMaterialInvoiceMode] = (0, $7UyaH.useState)("consolidated");
    const [subcontractorBrowseMode, setSubcontractorBrowseMode] = (0, $7UyaH.useState)("milestone");
    const [subcontractorTimelinePhaseIds, setSubcontractorTimelinePhaseIds] = (0, $7UyaH.useState)([]);
    const [subcontractorInvoiceMode, setSubcontractorInvoiceMode] = (0, $7UyaH.useState)("consolidated");
    const [subcontractorMilestoneSearch, setSubcontractorMilestoneSearch] = (0, $7UyaH.useState)("");
    const [subcontractorBeneficiaries, setSubcontractorBeneficiaries] = (0, $7UyaH.useState)([]);
    const [poSearch, setPoSearch] = (0, $7UyaH.useState)("");
    const [labourSupplierId, setLabourSupplierId] = (0, $7UyaH.useState)("");
    const [labourSuppliers, setLabourSuppliers] = (0, $7UyaH.useState)([]);
    const [labourBrowseMode, setLabourBrowseMode] = (0, $7UyaH.useState)("milestone");
    const [labourTimelinePhaseIds, setLabourTimelinePhaseIds] = (0, $7UyaH.useState)([]);
    const [labourInvoiceMode, setLabourInvoiceMode] = (0, $7UyaH.useState)("consolidated");
    const [labourBeneficiaries, setLabourBeneficiaries] = (0, $7UyaH.useState)([]);
    const [poList, setPoList] = (0, $7UyaH.useState)([]);
    const [materialLines, setMaterialLines] = (0, $7UyaH.useState)([]);
    const [subcontractorLines, setSubcontractorLines] = (0, $7UyaH.useState)([]);
    const [labourLines, setLabourLines] = (0, $7UyaH.useState)([]);
    const [qtyOverrides, setQtyOverrides] = (0, $7UyaH.useState)({});
    const [rateOverrides, setRateOverrides] = (0, $7UyaH.useState)({});
    const [linesLoading, setLinesLoading] = (0, $7UyaH.useState)(false);
    const [generating, setGenerating] = (0, $7UyaH.useState)(false);
    const [generateProgress, setGenerateProgress] = (0, $7UyaH.useState)(null);
    const [invoiceNotes, setInvoiceNotes] = (0, $7UyaH.useState)("");
    const [generateSuccess, setGenerateSuccess] = (0, $7UyaH.useState)(null);
    const [batchGenerateResult, setBatchGenerateResult] = (0, $7UyaH.useState)(null);
    const [batchZipBusy, setBatchZipBusy] = (0, $7UyaH.useState)(false);
    const [registerRows, setRegisterRows] = (0, $7UyaH.useState)([]);
    const [registerLoading, setRegisterLoading] = (0, $7UyaH.useState)(false);
    const [registerSearch, setRegisterSearch] = (0, $7UyaH.useState)("");
    const [registerTypeFilter, setRegisterTypeFilter] = (0, $7UyaH.useState)("all");
    const [pdfDownloadingId, setPdfDownloadingId] = (0, $7UyaH.useState)("");
    const [cancellingId, setCancellingId] = (0, $7UyaH.useState)("");
    const appById = (0, $7UyaH.useMemo)(()=>new Map(applications.map((a)=>[
                a.id,
                a
            ])), [
        applications
    ]);
    const subcontractorNameById = (0, $7UyaH.useMemo)(()=>new Map(subcontractorMasters.map((s)=>[
                s.id,
                s.firmName
            ])), [
        subcontractorMasters
    ]);
    const eligibleApplications = (0, $7UyaH.useMemo)(()=>applications.filter((a)=>Boolean(a.subcontractor.subcontractorMasterId) && Boolean(a.plannedStartDate)).sort((a, b)=>a.mobile.beneficiaryName.localeCompare(b.mobile.beneficiaryName)), [
        applications
    ]);
    const districtOptions = (0, $7UyaH.useMemo)(()=>{
        const districts = [
            ...new Set(eligibleApplications.map((a)=>String(a.district).trim()).filter(Boolean))
        ];
        districts.sort((a, b)=>a.localeCompare(b));
        return districts;
    }, [
        eligibleApplications
    ]);
    const filteredBeneficiaries = (0, $7UyaH.useMemo)(()=>{
        const q = beneficiarySearch.trim().toLowerCase();
        return eligibleApplications.filter((a)=>{
            if (districtFilter !== "all" && a.district !== districtFilter) return false;
            if (!q) return true;
            return a.mobile.beneficiaryName.toLowerCase().includes(q) || a.mobile.applicationId.toLowerCase().includes(q);
        });
    }, [
        eligibleApplications,
        beneficiarySearch,
        districtFilter
    ]);
    const visibleBeneficiaryIds = (0, $7UyaH.useMemo)(()=>filteredBeneficiaries.map((a)=>a.id), [
        filteredBeneficiaries
    ]);
    const allVisibleSelected = (0, $7UyaH.useMemo)(()=>visibleBeneficiaryIds.length > 0 && visibleBeneficiaryIds.every((id)=>invoiceApplicationIds.includes(id)), [
        visibleBeneficiaryIds,
        invoiceApplicationIds
    ]);
    const subcontractorValidation = (0, $7UyaH.useMemo)(()=>{
        const lineAppIds = [
            ...new Set(subcontractorLines.map((l)=>l.applicationId).filter(Boolean))
        ];
        const eligibleFromApi = subcontractorBeneficiaries.filter((b)=>b.invoiceEligible);
        const subIds = new Set((eligibleFromApi.length ? eligibleFromApi : subcontractorBeneficiaries).map((b)=>b.subcontractorMasterId ?? "").filter(Boolean));
        if (!lineAppIds.length && !subIds.size) return {
            ok: true,
            subcontractorId: ""
        };
        if (subIds.size !== 1) return {
            ok: false,
            subcontractorId: ""
        };
        return {
            ok: true,
            subcontractorId: [
                ...subIds
            ][0]
        };
    }, [
        subcontractorBeneficiaries,
        subcontractorLines
    ]);
    const selectionMode = invoiceType === "material" ? materialInvoiceMode === "individual" ? "single" : "consolidated" : invoiceType === "subcontractor" ? subcontractorInvoiceMode === "individual" ? "single" : "consolidated" : invoiceType === "labour" ? labourInvoiceMode === "individual" ? "single" : "consolidated" : invoiceApplicationIds.length > 1 ? "consolidated" : "single";
    const subcontractorMilestoneOptions = (0, $7UyaH.useMemo)(()=>(0, $34977f436b6dfc5f$export$dd3da66e9b042e55)(milestoneTemplates), [
        milestoneTemplates
    ]);
    const sortedTimelinePhases = (0, $7UyaH.useMemo)(()=>(0, $d0dce9c7337efc65$export$107c6562c1e7acbf)(constructionTimelinePhases), [
        constructionTimelinePhases
    ]);
    const timelinePhaseTitleById = (0, $7UyaH.useMemo)(()=>new Map(sortedTimelinePhases.map((p)=>[
                String(p.id),
                p.title
            ])), [
        sortedTimelinePhases
    ]);
    const filteredSubcontractorMilestones = (0, $7UyaH.useMemo)(()=>{
        const q = subcontractorMilestoneSearch.trim().toLowerCase();
        return subcontractorMilestoneOptions.filter((tpl)=>{
            if (!q) return true;
            const timelineText = (tpl.linkedConstructionTimelinePhaseIds ?? []).map((id)=>timelinePhaseTitleById.get(String(id)) ?? "").join(" ").toLowerCase();
            return tpl.title.toLowerCase().includes(q) || timelineText.includes(q);
        });
    }, [
        subcontractorMilestoneOptions,
        subcontractorMilestoneSearch,
        timelinePhaseTitleById
    ]);
    const selectedSubcontractorMilestone = (0, $7UyaH.useMemo)(()=>subcontractorMilestoneOptions.find((m)=>m.id === milestoneTemplateId) ?? null, [
        subcontractorMilestoneOptions,
        milestoneTemplateId
    ]);
    const subcontractorSelectionReady = subcontractorBrowseMode === "milestone" && Boolean(milestoneTemplateId.trim()) || subcontractorBrowseMode === "timeline" && subcontractorTimelinePhaseIds.length > 0;
    const subcontractorBeneficiaryIds = (0, $7UyaH.useMemo)(()=>[
            ...new Set(subcontractorLines.map((l)=>l.applicationId).filter(Boolean))
        ], [
        subcontractorLines
    ]);
    const labourSelectionReady = labourBrowseMode === "milestone" && Boolean(milestoneTemplateId.trim()) || labourBrowseMode === "timeline" && labourTimelinePhaseIds.length > 0;
    const labourBeneficiaryIds = (0, $7UyaH.useMemo)(()=>[
            ...new Set(labourLines.map((l)=>l.applicationId).filter(Boolean))
        ], [
        labourLines
    ]);
    const activePoList = (0, $7UyaH.useMemo)(()=>poList.filter((p)=>(p.status ?? "active") === "active"), [
        poList
    ]);
    const filteredPoList = (0, $7UyaH.useMemo)(()=>{
        const q = poSearch.trim().toLowerCase();
        return activePoList.filter((p)=>{
            if (!q) return true;
            return p.poNumber.toLowerCase().includes(q) || p.milestoneTitle.toLowerCase().includes(q) || p.subcontractorFirmName.toLowerCase().includes(q);
        });
    }, [
        activePoList,
        poSearch
    ]);
    const selectedMaterialPo = (0, $7UyaH.useMemo)(()=>activePoList.find((p)=>p.id === materialPoId) ?? null, [
        activePoList,
        materialPoId
    ]);
    const materialBeneficiaryIds = (0, $7UyaH.useMemo)(()=>[
            ...new Set(materialLines.map((l)=>l.applicationId).filter(Boolean))
        ], [
        materialLines
    ]);
    const loadRegister = (0, $7UyaH.useCallback)(async ()=>{
        setRegisterLoading(true);
        try {
            const rows = await (0, $cbddb03275b22218$export$aaa1b475f4a0ad4a)({
                limit: 1000,
                search: registerSearch.trim() || undefined,
                invoiceType: registerTypeFilter === "all" ? undefined : registerTypeFilter
            });
            setRegisterRows(rows);
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not load invoice register.", "error");
        } finally{
            setRegisterLoading(false);
        }
    }, [
        registerSearch,
        registerTypeFilter,
        showToast
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (viewMode === "register") loadRegister();
    }, [
        viewMode,
        loadRegister
    ]);
    (0, $7UyaH.useEffect)(()=>{
        (0, $ba596e844a9fe971$export$3ba796e348617408)().then(setLabourSuppliers).catch(()=>setLabourSuppliers([]));
        (0, $f5510818538731b9$export$199cc1209b09073e)({
            limit: 1000,
            sort: "desc"
        }).then(setPoList).catch(()=>setPoList([]));
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        setMaterialLines([]);
        setSubcontractorLines([]);
        setLabourLines([]);
        setQtyOverrides({});
        setRateOverrides({});
    }, [
        invoiceType
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (invoiceType !== "material") return;
        setMaterialLines([]);
        setQtyOverrides({});
    }, [
        invoiceType,
        materialPoId
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (invoiceType !== "subcontractor") return;
        setSubcontractorLines([]);
        setSubcontractorBeneficiaries([]);
        setQtyOverrides({});
        setRateOverrides({});
        setInvoiceApplicationIds([]);
    }, [
        invoiceType,
        milestoneTemplateId,
        subcontractorTimelinePhaseIds,
        subcontractorBrowseMode
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (invoiceType !== "material") return;
        setMaterialPoId("");
        setMaterialInvoiceMode("consolidated");
        setPoSearch("");
        setInvoiceApplicationIds([]);
        setMilestoneTemplateId("");
        setSubcontractorBrowseMode("milestone");
        setSubcontractorTimelinePhaseIds([]);
        setSubcontractorInvoiceMode("consolidated");
        setSubcontractorMilestoneSearch("");
        setSubcontractorBeneficiaries([]);
        setLabourTimelinePhaseIds([]);
        setLabourBrowseMode("milestone");
        setLabourInvoiceMode("consolidated");
        setLabourBeneficiaries([]);
        setLabourSupplierId("");
    }, [
        invoiceType
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (invoiceType !== "labour") return;
        setLabourLines([]);
        setLabourBeneficiaries([]);
        setQtyOverrides({});
        setRateOverrides({});
        setInvoiceApplicationIds([]);
    }, [
        invoiceType,
        labourBrowseMode,
        milestoneTemplateId,
        labourTimelinePhaseIds
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (invoiceType !== "material" || !materialPoId) {
            if (invoiceType === "material") setInvoiceApplicationIds([]);
            return;
        }
        const po = activePoList.find((p)=>p.id === materialPoId);
        if (po) setMilestoneTemplateId(po.milestoneTemplateId);
        (0, $f5510818538731b9$export$49a2b5a16b830ea4)(materialPoId).then((items)=>{
            setInvoiceApplicationIds([
                ...new Set(items.map((i)=>i.applicationId).filter(Boolean))
            ]);
        }).catch(()=>setInvoiceApplicationIds([]));
    }, [
        invoiceType,
        materialPoId,
        activePoList
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (invoiceType !== "material" || !materialPoId) return;
        let cancelled = false;
        setLinesLoading(true);
        (0, $cbddb03275b22218$export$597be8017f4f4590)({
            poId: materialPoId
        }).then((data)=>{
            if (!cancelled) setMaterialLines(data.lines.filter((l)=>l.eligibleQty > 0.0000001));
        }).catch((e)=>{
            if (!cancelled) {
                setMaterialLines([]);
                showToast(e instanceof Error ? e.message : "Could not load material lines.", "error");
            }
        }).finally(()=>{
            if (!cancelled) setLinesLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        invoiceType,
        materialPoId,
        showToast
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (invoiceType !== "subcontractor") return;
        const milestoneReady = subcontractorBrowseMode === "milestone" && milestoneTemplateId.trim();
        const timelineReady = subcontractorBrowseMode === "timeline" && subcontractorTimelinePhaseIds.length > 0;
        if (!milestoneReady && !timelineReady) return;
        let cancelled = false;
        setLinesLoading(true);
        const fmt = (0, $0167ea69d6388932$export$f1d229bf4759dfa5)();
        (0, $cbddb03275b22218$export$93c3270efb9c08d8)(milestoneReady ? {
            sourceMode: "milestone",
            milestoneTemplateId: milestoneTemplateId.trim()
        } : {
            sourceMode: "timeline",
            timelinePhaseIds: subcontractorTimelinePhaseIds
        }).then((data)=>{
            if (cancelled) return;
            setSubcontractorBeneficiaries(data.beneficiaries ?? []);
            setInvoiceApplicationIds(data.applicationIds ?? []);
            setSubcontractorLines(data.lines.map((ln)=>(0, $34977f436b6dfc5f$export$d9c9921405b45f3e)(ln, fmt)));
        }).catch((e)=>{
            if (!cancelled) {
                setSubcontractorLines([]);
                setSubcontractorBeneficiaries([]);
                setInvoiceApplicationIds([]);
                showToast(e instanceof Error ? e.message : "Could not load subcontractor lines.", "error");
            }
        }).finally(()=>{
            if (!cancelled) setLinesLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        invoiceType,
        subcontractorBrowseMode,
        milestoneTemplateId,
        subcontractorTimelinePhaseIds,
        showToast
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (invoiceType !== "labour") return;
        const milestoneReady = labourBrowseMode === "milestone" && milestoneTemplateId.trim();
        const timelineReady = labourBrowseMode === "timeline" && labourTimelinePhaseIds.length > 0;
        if (!milestoneReady && !timelineReady) return;
        let cancelled = false;
        setLinesLoading(true);
        const fmt = (0, $0167ea69d6388932$export$f1d229bf4759dfa5)();
        (0, $cbddb03275b22218$export$5c2ff2dfc7400301)(milestoneReady ? {
            sourceMode: "milestone",
            milestoneTemplateId: milestoneTemplateId.trim()
        } : {
            sourceMode: "timeline",
            timelinePhaseIds: labourTimelinePhaseIds
        }).then((data)=>{
            if (cancelled) return;
            setLabourBeneficiaries(data.beneficiaries ?? []);
            setInvoiceApplicationIds(data.applicationIds ?? []);
            setLabourLines(data.lines.map((ln)=>(0, $fe4bf9984635f90b$export$c135998fb4d1d908)(ln, fmt)));
        }).catch((e)=>{
            if (!cancelled) {
                setLabourLines([]);
                setLabourBeneficiaries([]);
                setInvoiceApplicationIds([]);
                showToast(e instanceof Error ? e.message : "Could not load labour lines.", "error");
            }
        }).finally(()=>{
            if (!cancelled) setLinesLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        invoiceType,
        labourBrowseMode,
        milestoneTemplateId,
        labourTimelinePhaseIds,
        showToast
    ]);
    const labourSupplierOptions = (0, $7UyaH.useMemo)(()=>[
            {
                value: "",
                label: "Select labour supplier\u2026"
            },
            ...labourSuppliers.map((s)=>({
                    value: s.id,
                    label: s.firmName
                }))
        ], [
        labourSuppliers
    ]);
    function buildCompanyBillTo() {
        return (0, $0167ea69d6388932$export$c9841c0638bbd9e9)(invoiceType);
    }
    function buildFormatBillFrom() {
        return (0, $0167ea69d6388932$export$3897bf2f9c79d79d)(invoiceType);
    }
    async function runGenerate() {
        const fmt = (0, $0167ea69d6388932$export$f1d229bf4759dfa5)();
        const gstRatePercent = (0, $0167ea69d6388932$export$7bd8f27d066809be)(fmt, invoiceType);
        /** @type {GenerateInvoiceLineInput[]} */ const lines = [];
        if (invoiceType === "material") {
            if (!materialPoId || !selectedMaterialPo) {
                showToast("Select a purchase order.", "error");
                return;
            }
            if (!materialLines.length) {
                showToast(selectedMaterialPo ? "No invoiceable lines on this PO \u2014 all lines may already be invoiced, or the PO has no material rows." : "Select a purchase order.", "error");
                return;
            }
            const sub = subcontractorMasters.find((s)=>s.id === selectedMaterialPo.subcontractorMasterId);
            const billFrom = buildFormatBillFrom();
            const milestoneId = selectedMaterialPo.milestoneTemplateId || materialLines[0]?.milestoneTemplateId;
            setGenerating(true);
            setGenerateProgress(null);
            setBatchGenerateResult(null);
            try {
                if (materialInvoiceMode === "individual") {
                    const jobs = materialBeneficiaryIds.map((appId)=>({
                            appId: appId,
                            lines: $a78dc66b5570f421$var$materialLinesForApp(materialLines, appId, qtyOverrides)
                        })).filter((j)=>j.lines.length > 0);
                    if (!jobs.length) {
                        showToast("Enter quantity on at least one line.", "error");
                        return;
                    }
                    setGenerateProgress({
                        phase: "invoices",
                        done: 0,
                        total: jobs.length
                    });
                    let invoicesDone = 0;
                    const generated = await (0, $3a5f8f99aa429a90$export$2789c339476599aa)(jobs, 6, async ({ appId: appId, lines: lines })=>{
                        const app = appById.get(appId);
                        const billTo = app ? $a78dc66b5570f421$var$buildBeneficiaryBillTo(app) : buildCompanyBillTo();
                        const result = await (0, $cbddb03275b22218$export$1e474a5c026bd11a)({
                            invoiceType: "material",
                            applicationIds: [
                                appId
                            ],
                            selectionMode: "single",
                            partyKind: "subcontractor",
                            partyMasterId: selectedMaterialPo.subcontractorMasterId,
                            billFromText: billFrom,
                            billToText: billTo,
                            sourcePoId: materialPoId,
                            sourceMilestoneTemplateId: milestoneId,
                            notes: invoiceNotes.trim() || undefined,
                            gstRatePercent: gstRatePercent,
                            lines: lines
                        });
                        invoicesDone += 1;
                        setGenerateProgress({
                            phase: "invoices",
                            done: invoicesDone,
                            total: jobs.length
                        });
                        return {
                            header: result.invoice,
                            items: result.items
                        };
                    });
                    setBatchGenerateResult(generated);
                    setGenerateProgress({
                        phase: "pdfs",
                        done: 0,
                        total: generated.length
                    });
                    showToast(`Generated ${generated.length} invoice(s). Building PDF ZIP\u{2026}`, "success");
                    try {
                        await (0, $103f1d5fa9f5b81b$export$85a297f7329c9893)(generated, {
                            applications: applications,
                            zipBasename: `Invoices_${selectedMaterialPo.poNumber.replace(/[^\w.-]+/g, "_")}`,
                            pdfConcurrency: 6,
                            onProgress: (done, total)=>setGenerateProgress({
                                    phase: "pdfs",
                                    done: done,
                                    total: total
                                })
                        });
                        showToast(`ZIP downloaded with ${generated.length} invoice PDF(s).`, "success");
                    } catch (zipErr) {
                        showToast(zipErr instanceof Error ? zipErr.message : "Invoices saved but ZIP download failed.", "error");
                    }
                } else {
                    const lines = $a78dc66b5570f421$var$materialLinesToGenerateInput(materialLines, qtyOverrides);
                    if (!lines.length) {
                        showToast("Enter quantity on at least one line.", "error");
                        return;
                    }
                    const result = await (0, $cbddb03275b22218$export$1e474a5c026bd11a)({
                        invoiceType: "material",
                        applicationIds: invoiceApplicationIds,
                        selectionMode: "consolidated",
                        partyKind: "subcontractor",
                        partyMasterId: selectedMaterialPo.subcontractorMasterId,
                        billFromText: billFrom,
                        billToText: buildCompanyBillTo(),
                        sourcePoId: materialPoId,
                        sourceMilestoneTemplateId: milestoneId,
                        notes: invoiceNotes.trim() || undefined,
                        gstRatePercent: gstRatePercent,
                        lines: lines
                    });
                    setGenerateSuccess(result);
                    showToast(`Invoice ${result.invoice.invoiceNumber} generated.`, "success");
                }
            } catch (e) {
                showToast(e instanceof Error ? e.message : "Could not generate invoice.", "error");
            } finally{
                setGenerating(false);
                setGenerateProgress(null);
            }
            return;
        }
        if (invoiceType === "subcontractor") {
            const milestoneReady = subcontractorBrowseMode === "milestone" && milestoneTemplateId.trim();
            const timelineReady = subcontractorBrowseMode === "timeline" && subcontractorTimelinePhaseIds.length > 0;
            if (!milestoneReady && !timelineReady) {
                showToast("Select a milestone or at least one timeline level.", "error");
                return;
            }
            if (!subcontractorLines.length) {
                showToast("No invoiceable subcontractor bill lines for this milestone \u2014 check completion and invoice format rates.", "error");
                return;
            }
            if (!subcontractorValidation.ok) {
                showToast("Eligible beneficiaries must share one subcontractor.", "error");
                return;
            }
            const billFrom = buildFormatBillFrom();
            const milestoneTitle = selectedSubcontractorMilestone?.title ?? milestoneTemplateId;
            const sourceMilestoneTitle = subcontractorBrowseMode === "timeline" ? $a78dc66b5570f421$var$timelineReferenceFromPhaseIds(subcontractorTimelinePhaseIds, timelinePhaseTitleById) || undefined : selectedSubcontractorMilestone?.title?.trim() || undefined;
            setGenerating(true);
            setGenerateProgress(null);
            setBatchGenerateResult(null);
            try {
                if (subcontractorInvoiceMode === "individual") {
                    const jobs = subcontractorBeneficiaryIds.map((appId)=>({
                            appId: appId,
                            lines: $a78dc66b5570f421$var$subcontractorLinesForApp(subcontractorLines, appId, qtyOverrides, rateOverrides)
                        })).filter((j)=>j.lines.length > 0);
                    if (!jobs.length) {
                        showToast("Configure rate/qty in Invoice format and ensure at least one eligible line.", "error");
                        return;
                    }
                    setGenerateProgress({
                        phase: "invoices",
                        done: 0,
                        total: jobs.length
                    });
                    let invoicesDone = 0;
                    const generated = await (0, $3a5f8f99aa429a90$export$2789c339476599aa)(jobs, 6, async ({ appId: appId, lines: lines })=>{
                        const app = appById.get(appId);
                        const billTo = app ? $a78dc66b5570f421$var$buildBeneficiaryBillTo(app) : buildCompanyBillTo();
                        const result = await (0, $cbddb03275b22218$export$1e474a5c026bd11a)({
                            invoiceType: "subcontractor",
                            applicationIds: [
                                appId
                            ],
                            selectionMode: "single",
                            partyKind: "subcontractor",
                            partyMasterId: subcontractorValidation.subcontractorId,
                            billFromText: billFrom,
                            billToText: billTo,
                            sourceMilestoneTemplateId: subcontractorBrowseMode === "milestone" ? milestoneTemplateId.trim() : undefined,
                            sourceMilestoneTitle: sourceMilestoneTitle,
                            notes: invoiceNotes.trim() || undefined,
                            gstRatePercent: gstRatePercent,
                            lines: lines
                        });
                        invoicesDone += 1;
                        setGenerateProgress({
                            phase: "invoices",
                            done: invoicesDone,
                            total: jobs.length
                        });
                        return {
                            header: result.invoice,
                            items: result.items
                        };
                    });
                    setBatchGenerateResult(generated);
                    setGenerateProgress({
                        phase: "pdfs",
                        done: 0,
                        total: generated.length
                    });
                    showToast(`Generated ${generated.length} invoice(s). Building PDF ZIP\u{2026}`, "success");
                    try {
                        await (0, $103f1d5fa9f5b81b$export$85a297f7329c9893)(generated, {
                            applications: applications,
                            zipBasename: `Subcontractor_Invoices_${milestoneTitle.replace(/[^\w.-]+/g, "_").slice(0, 40)}`,
                            pdfConcurrency: 6,
                            onProgress: (done, total)=>setGenerateProgress({
                                    phase: "pdfs",
                                    done: done,
                                    total: total
                                })
                        });
                        showToast(`ZIP downloaded with ${generated.length} invoice PDF(s).`, "success");
                    } catch (zipErr) {
                        showToast(zipErr instanceof Error ? zipErr.message : "Invoices saved but ZIP download failed.", "error");
                    }
                } else {
                    const lines = $a78dc66b5570f421$var$subcontractorLinesToGenerateInput(subcontractorLines, qtyOverrides, rateOverrides);
                    if (!lines.length) {
                        showToast("Configure rate/qty in Invoice format and ensure at least one eligible line.", "error");
                        return;
                    }
                    const result = await (0, $cbddb03275b22218$export$1e474a5c026bd11a)({
                        invoiceType: "subcontractor",
                        applicationIds: subcontractorBeneficiaryIds,
                        selectionMode: "consolidated",
                        partyKind: "subcontractor",
                        partyMasterId: subcontractorValidation.subcontractorId,
                        billFromText: billFrom,
                        billToText: buildCompanyBillTo(),
                        sourceMilestoneTemplateId: subcontractorBrowseMode === "milestone" ? milestoneTemplateId.trim() : undefined,
                        sourceMilestoneTitle: sourceMilestoneTitle,
                        notes: invoiceNotes.trim() || undefined,
                        gstRatePercent: gstRatePercent,
                        lines: lines
                    });
                    setGenerateSuccess(result);
                    showToast(`Invoice ${result.invoice.invoiceNumber} generated.`, "success");
                }
            } catch (e) {
                showToast(e instanceof Error ? e.message : "Could not generate invoice.", "error");
            } finally{
                setGenerating(false);
                setGenerateProgress(null);
            }
            return;
        }
        if (invoiceType === "labour") {
            const milestoneReady = labourBrowseMode === "milestone" && milestoneTemplateId.trim();
            const timelineReady = labourBrowseMode === "timeline" && labourTimelinePhaseIds.length > 0;
            if (!milestoneReady && !timelineReady) {
                showToast("Select a milestone or at least one timeline level.", "error");
                return;
            }
            if (!labourSupplierId.trim()) {
                showToast("Select a labour supplier.", "error");
                return;
            }
            const supplier = labourSuppliers.find((s)=>s.id === labourSupplierId);
            if (!supplier) {
                showToast("Labour supplier not found.", "error");
                return;
            }
            if (!labourLines.length) {
                showToast("No invoiceable labour bill lines \u2014 check completion and invoice format rates.", "error");
                return;
            }
            const billFrom = buildFormatBillFrom();
            const labourMilestoneTitle = selectedSubcontractorMilestone?.title?.trim() || undefined;
            const sourceMilestoneTitle = labourBrowseMode === "timeline" ? $a78dc66b5570f421$var$timelineReferenceFromPhaseIds(labourTimelinePhaseIds, timelinePhaseTitleById) || undefined : labourMilestoneTitle;
            const zipLabel = labourBrowseMode === "milestone" ? selectedSubcontractorMilestone?.title ?? "milestone" : labourTimelinePhaseIds.length === 1 ? timelinePhaseTitleById.get(labourTimelinePhaseIds[0]) ?? "timeline" : `${labourTimelinePhaseIds.length} timeline levels`;
            setGenerating(true);
            setGenerateProgress(null);
            setBatchGenerateResult(null);
            try {
                if (labourInvoiceMode === "individual") {
                    const jobs = labourBeneficiaryIds.map((appId)=>({
                            appId: appId,
                            lines: $a78dc66b5570f421$var$subcontractorLinesForApp(labourLines, appId, qtyOverrides, rateOverrides)
                        })).filter((j)=>j.lines.length > 0);
                    if (!jobs.length) {
                        showToast("Configure rate/qty in Invoice format and ensure at least one eligible line.", "error");
                        return;
                    }
                    setGenerateProgress({
                        phase: "invoices",
                        done: 0,
                        total: jobs.length
                    });
                    let invoicesDone = 0;
                    const generated = await (0, $3a5f8f99aa429a90$export$2789c339476599aa)(jobs, 6, async ({ appId: appId, lines: jobLines })=>{
                        const app = appById.get(appId);
                        const billTo = app ? $a78dc66b5570f421$var$buildBeneficiaryBillTo(app) : buildCompanyBillTo();
                        const result = await (0, $cbddb03275b22218$export$1e474a5c026bd11a)({
                            invoiceType: "labour",
                            applicationIds: [
                                appId
                            ],
                            selectionMode: "single",
                            partyKind: "labour_supplier",
                            partyMasterId: supplier.id,
                            billFromText: billFrom,
                            billToText: billTo,
                            sourceMilestoneTemplateId: labourBrowseMode === "milestone" ? milestoneTemplateId.trim() : undefined,
                            sourceMilestoneTitle: sourceMilestoneTitle,
                            notes: invoiceNotes.trim() || undefined,
                            gstRatePercent: gstRatePercent,
                            lines: jobLines
                        });
                        invoicesDone += 1;
                        setGenerateProgress({
                            phase: "invoices",
                            done: invoicesDone,
                            total: jobs.length
                        });
                        return {
                            header: result.invoice,
                            items: result.items
                        };
                    });
                    setBatchGenerateResult(generated);
                    setGenerateProgress({
                        phase: "pdfs",
                        done: 0,
                        total: generated.length
                    });
                    showToast(`Generated ${generated.length} invoice(s). Building PDF ZIP\u{2026}`, "success");
                    try {
                        await (0, $103f1d5fa9f5b81b$export$85a297f7329c9893)(generated, {
                            applications: applications,
                            zipBasename: `Labour_Invoices_${zipLabel.replace(/[^\w.-]+/g, "_").slice(0, 40)}`,
                            pdfConcurrency: 6,
                            onProgress: (done, total)=>setGenerateProgress({
                                    phase: "pdfs",
                                    done: done,
                                    total: total
                                })
                        });
                        showToast(`ZIP downloaded with ${generated.length} invoice PDF(s).`, "success");
                    } catch (zipErr) {
                        showToast(zipErr instanceof Error ? zipErr.message : "Invoices saved but ZIP download failed.", "error");
                    }
                } else {
                    const jobLines = $a78dc66b5570f421$var$subcontractorLinesToGenerateInput(labourLines, qtyOverrides, rateOverrides);
                    if (!jobLines.length) {
                        showToast("Configure rate/qty in Invoice format and ensure at least one eligible line.", "error");
                        return;
                    }
                    const result = await (0, $cbddb03275b22218$export$1e474a5c026bd11a)({
                        invoiceType: "labour",
                        applicationIds: invoiceApplicationIds,
                        selectionMode: "consolidated",
                        partyKind: "labour_supplier",
                        partyMasterId: supplier.id,
                        billFromText: billFrom,
                        billToText: buildCompanyBillTo(),
                        sourceMilestoneTemplateId: labourBrowseMode === "milestone" ? milestoneTemplateId.trim() : undefined,
                        sourceMilestoneTitle: sourceMilestoneTitle,
                        notes: invoiceNotes.trim() || undefined,
                        gstRatePercent: gstRatePercent,
                        lines: jobLines
                    });
                    setGenerateSuccess(result);
                    showToast(`Invoice ${result.invoice.invoiceNumber} generated.`, "success");
                }
            } catch (e) {
                showToast(e instanceof Error ? e.message : "Could not generate invoice.", "error");
            } finally{
                setGenerating(false);
                setGenerateProgress(null);
            }
            return;
        }
    }
    async function handleDownloadRegisterPdf(row) {
        setPdfDownloadingId(row.id);
        try {
            const items = await (0, $cbddb03275b22218$export$6886af56b3cb5e7f)(row.id);
            await (0, $103f1d5fa9f5b81b$export$e680a9cf3c04adb)(row, items, {
                applications: applications
            });
            showToast(`PDF downloaded (${row.invoiceNumber}).`, "success");
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not download PDF.", "error");
        } finally{
            setPdfDownloadingId("");
        }
    }
    async function handleDownloadBatchZip() {
        if (!batchGenerateResult?.length) return;
        setBatchZipBusy(true);
        setGenerateProgress({
            phase: "pdfs",
            done: 0,
            total: batchGenerateResult.length
        });
        try {
            await (0, $103f1d5fa9f5b81b$export$85a297f7329c9893)(batchGenerateResult, {
                applications: applications,
                zipBasename: selectedMaterialPo ? `Invoices_${selectedMaterialPo.poNumber.replace(/[^\w.-]+/g, "_")}` : undefined,
                pdfConcurrency: 6,
                onProgress: (done, total)=>setGenerateProgress({
                        phase: "pdfs",
                        done: done,
                        total: total
                    })
            });
            showToast(`ZIP downloaded with ${batchGenerateResult.length} invoice PDF(s).`, "success");
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not download ZIP.", "error");
        } finally{
            setBatchZipBusy(false);
            setGenerateProgress(null);
        }
    }
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Invoice"
                    },
                    {
                        label: "Invoice register"
                    }
                ],
                title: "Invoice register",
                subtitle: "Generate material, subcontractor, or labour supplier invoices \u2014 single beneficiary or consolidated.",
                actions: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                    className: "toolbar-row",
                    style: {
                        margin: 0
                    },
                    children: viewMode === "register" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--tg-secondary btn--sm",
                        onClick: ()=>void loadRegister(),
                        children: "Refresh"
                    }) : null
                })
            }),
            batchGenerateResult && batchGenerateResult.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--elevated",
                style: {
                    marginBottom: "1rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        style: {
                            margin: "0 0 0.5rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("strong", {
                                children: [
                                    batchGenerateResult.length,
                                    " individual invoices"
                                ]
                            }),
                            " generated for PO",
                            " ",
                            selectedMaterialPo?.poNumber ?? materialPoId,
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "text-muted",
                        style: {
                            margin: "0 0 0.75rem",
                            fontSize: "0.88rem"
                        },
                        children: [
                            "PDFs in the ZIP are named ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "ApplicationID_BeneficiaryName.pdf"
                            }),
                            " (e.g.",
                            " ",
                            "APP-NK-00019_Ayodhyanallapothula.pdf)."
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        style: {
                            margin: "0 0 0.75rem",
                            fontSize: "0.88rem"
                        },
                        children: batchGenerateResult.map(({ header: header })=>header.invoiceNumber).join(", ")
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "toolbar-row",
                        style: {
                            margin: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--primary btn--tg btn--sm",
                                disabled: batchZipBusy,
                                onClick: ()=>void handleDownloadBatchZip(),
                                children: batchZipBusy ? "Preparing ZIP\u2026" : "Download ZIP again"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--tg-secondary btn--sm",
                                onClick: ()=>{
                                    setBatchGenerateResult(null);
                                    setViewMode("register");
                                    loadRegister();
                                },
                                children: "View in register"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--tg-secondary btn--sm",
                                onClick: ()=>setBatchGenerateResult(null),
                                children: "Dismiss"
                            })
                        ]
                    })
                ]
            }) : null,
            generateSuccess ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $ec93bb30e5e10f28$export$31630dc90ebea42e), {
                invoice: generateSuccess.invoice,
                items: generateSuccess.items,
                applications: applications,
                onClose: ()=>setGenerateSuccess(null),
                onCancel: async ()=>{
                    await (0, $cbddb03275b22218$export$222a9c561ea276af)(generateSuccess.invoice.id);
                    setGenerateSuccess(null);
                    await loadRegister();
                    showToast(`Invoice ${generateSuccess.invoice.invoiceNumber} cancelled.`, "success");
                }
            }) : null,
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "issue-mode-toggle-wrap",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "issue-mode-toggle",
                    role: "tablist",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            role: "tab",
                            "aria-selected": viewMode === "generate",
                            className: `issue-mode-toggle__btn ${viewMode === "generate" ? "is-active" : ""}`,
                            onClick: ()=>setViewMode("generate"),
                            children: "Generate Invoice"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            role: "tab",
                            "aria-selected": viewMode === "register",
                            className: `issue-mode-toggle__btn ${viewMode === "register" ? "is-active" : ""}`,
                            onClick: ()=>setViewMode("register"),
                            children: "Invoice Register"
                        })
                    ]
                })
            }),
            viewMode === "generate" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "issue-po-flow",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                        className: "issue-po-flow__section",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "inv-outward-issue__label",
                                children: "Step 1 \u2014 Invoice type"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "toolbar-row",
                                style: {
                                    marginTop: "0.5rem"
                                },
                                children: [
                                    "material",
                                    "subcontractor",
                                    "labour"
                                ].map((t)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: `btn btn--sm ${invoiceType === t ? "btn--primary btn--tg" : "btn--tg-secondary"}`,
                                        onClick: ()=>setInvoiceType(t),
                                        children: $a78dc66b5570f421$var$invoiceTypeLabel(t)
                                    }, t))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("section", {
                        className: "issue-po-flow__section",
                        children: invoiceType === "material" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "inv-outward-issue__label",
                                    children: "Step 2 \u2014 Select purchase order"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "goods-receipts-filters__grid",
                                    style: {
                                        marginTop: "0.5rem"
                                    },
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "goods-receipts-filters__field",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "goods-receipts-filters__label",
                                                children: "Search PO"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                className: "form-control",
                                                value: poSearch,
                                                onChange: (e)=>setPoSearch(e.target.value),
                                                placeholder: "PO number / milestone / subcontractor"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                    className: "text-muted",
                                    style: {
                                        fontSize: "0.85rem"
                                    },
                                    children: [
                                        "Selected PO:",
                                        " ",
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                            children: selectedMaterialPo ? selectedMaterialPo.poNumber : "\u2014"
                                        }),
                                        selectedMaterialPo ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                            children: [
                                                " ",
                                                "\xb7 ",
                                                selectedMaterialPo.beneficiaryCount,
                                                " beneficiary(ies) \xb7 ",
                                                selectedMaterialPo.milestoneTitle
                                            ]
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "issue-po-beneficiary-table-wrap",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                        className: "data-table issue-po-beneficiary-table",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            style: {
                                                                width: "2.5rem"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            children: "PO number"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            children: "Milestone"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            children: "Subcontractor"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            children: "Beneficiaries"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                            children: "PO date"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                                children: filteredPoList.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        colSpan: 6,
                                                        className: "text-muted",
                                                        children: "No active purchase orders found."
                                                    })
                                                }) : filteredPoList.map((po)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                    type: "radio",
                                                                    name: "material-po-select",
                                                                    checked: materialPoId === po.id,
                                                                    onChange: ()=>setMaterialPoId(po.id),
                                                                    "aria-label": `Select PO ${po.poNumber}`
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                className: "mono",
                                                                children: po.poNumber
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                children: po.milestoneTitle
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                children: po.subcontractorFirmName
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                children: po.beneficiaryCount
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                children: po.poDate || po.createdAt.slice(0, 10)
                                                            })
                                                        ]
                                                    }, po.id))
                                            })
                                        ]
                                    })
                                })
                            ]
                        }) : invoiceType === "subcontractor" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "inv-outward-issue__label",
                                    children: "Step 2 \u2014 Select milestone or timeline level"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "toolbar-row",
                                    style: {
                                        marginTop: "0.5rem"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                            type: "button",
                                            className: `btn btn--sm ${subcontractorBrowseMode === "milestone" ? "btn--primary btn--tg" : "btn--tg-secondary"}`,
                                            onClick: ()=>{
                                                setSubcontractorBrowseMode("milestone");
                                                setSubcontractorTimelinePhaseIds([]);
                                                setMilestoneTemplateId("");
                                            },
                                            children: "By milestone"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                            type: "button",
                                            className: `btn btn--sm ${subcontractorBrowseMode === "timeline" ? "btn--primary btn--tg" : "btn--tg-secondary"}`,
                                            onClick: ()=>{
                                                setSubcontractorBrowseMode("timeline");
                                                setMilestoneTemplateId("");
                                                setSubcontractorTimelinePhaseIds([]);
                                            },
                                            children: "By timeline level"
                                        })
                                    ]
                                }),
                                subcontractorBrowseMode === "milestone" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                            className: "goods-receipts-filters__grid",
                                            style: {
                                                marginTop: "0.5rem"
                                            },
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "goods-receipts-filters__field",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "goods-receipts-filters__label",
                                                        children: "Search milestone"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control",
                                                        value: subcontractorMilestoneSearch,
                                                        onChange: (e)=>setSubcontractorMilestoneSearch(e.target.value),
                                                        placeholder: "Milestone / timeline level"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                            className: "text-muted",
                                            style: {
                                                fontSize: "0.85rem"
                                            },
                                            children: [
                                                "Selected: ",
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                    children: selectedSubcontractorMilestone?.title ?? "\u2014"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                            className: "issue-po-beneficiary-table-wrap",
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                                className: "data-table issue-po-beneficiary-table",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                    style: {
                                                                        width: "2.5rem"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                    children: "Milestone"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                    children: "Timeline levels"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                    children: "Bill items"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                                        children: filteredSubcontractorMilestones.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                colSpan: 4,
                                                                className: "text-muted",
                                                                children: "No milestones in master yet. Add milestones under Milestone master and set rates in Invoice format."
                                                            })
                                                        }) : filteredSubcontractorMilestones.map((tpl)=>{
                                                            const billCount = tpl.items.filter((i)=>i.kind === "subcontractor_bill").length || 1;
                                                            const timelineText = (tpl.linkedConstructionTimelinePhaseIds ?? []).map((id)=>timelinePhaseTitleById.get(String(id)) ?? "").filter(Boolean).join(", ");
                                                            return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                            type: "radio",
                                                                            name: "subcontractor-milestone-select",
                                                                            checked: milestoneTemplateId === tpl.id,
                                                                            onChange: ()=>setMilestoneTemplateId(tpl.id),
                                                                            "aria-label": `Select milestone ${tpl.title}`
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        children: tpl.title
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        className: "text-muted",
                                                                        children: timelineText || "\u2014"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        children: billCount
                                                                    })
                                                                ]
                                                            }, tpl.id);
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "toolbar-row",
                                            style: {
                                                marginTop: "0.35rem"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "btn btn--sm btn--tg-secondary",
                                                    onClick: ()=>setSubcontractorTimelinePhaseIds(sortedTimelinePhases.map((p)=>String(p.id))),
                                                    children: "Select all timeline levels"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "btn btn--sm btn--tg-secondary",
                                                    onClick: ()=>setSubcontractorTimelinePhaseIds([]),
                                                    children: "Clear all"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                            className: "text-muted",
                                            style: {
                                                fontSize: "0.85rem",
                                                marginTop: "0.35rem"
                                            },
                                            children: [
                                                "Selected: ",
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                    children: subcontractorTimelinePhaseIds.length
                                                }),
                                                " timeline level(s). Beneficiaries must have ",
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                    children: "Approved"
                                                }),
                                                " status on all selected levels."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                            className: "issue-po-beneficiary-table-wrap",
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                                className: "data-table issue-po-beneficiary-table",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                    style: {
                                                                        width: "2.5rem"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        checked: sortedTimelinePhases.length > 0 && sortedTimelinePhases.every((p)=>subcontractorTimelinePhaseIds.includes(String(p.id))),
                                                                        onChange: (e)=>setSubcontractorTimelinePhaseIds(e.target.checked ? sortedTimelinePhases.map((p)=>String(p.id)) : [])
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                    children: "Timeline level"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                    children: "Planned days"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                                        children: sortedTimelinePhases.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                colSpan: 3,
                                                                className: "text-muted",
                                                                children: "No timeline levels in master yet."
                                                            })
                                                        }) : sortedTimelinePhases.map((phase)=>{
                                                            const phaseId = String(phase.id);
                                                            return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                            type: "checkbox",
                                                                            checked: subcontractorTimelinePhaseIds.includes(phaseId),
                                                                            onChange: ()=>setSubcontractorTimelinePhaseIds((prev)=>prev.includes(phaseId) ? prev.filter((id)=>id !== phaseId) : [
                                                                                        ...prev,
                                                                                        phaseId
                                                                                    ]),
                                                                            "aria-label": `Select timeline ${phase.title}`
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        children: phase.title
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                                        className: "mono",
                                                                        children: [
                                                                            "~",
                                                                            phase.approxDays,
                                                                            " d"
                                                                        ]
                                                                    })
                                                                ]
                                                            }, phase.id);
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                subcontractorBrowseMode === "milestone" && milestoneTemplateId || subcontractorBrowseMode === "timeline" && subcontractorTimelinePhaseIds.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    style: {
                                        marginTop: "1rem"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "inv-outward-issue__label",
                                            children: "Completed beneficiaries"
                                        }),
                                        linesLoading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                            className: "text-muted",
                                            style: {
                                                marginTop: "0.35rem"
                                            },
                                            children: "Loading beneficiaries\u2026"
                                        }) : subcontractorBeneficiaries.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                            className: "text-muted",
                                            style: {
                                                marginTop: "0.35rem"
                                            },
                                            children: [
                                                "No beneficiaries have completed",
                                                " ",
                                                subcontractorBrowseMode === "milestone" ? selectedSubcontractorMilestone?.title ?? "this milestone" : "all selected timeline levels (office-approved)",
                                                "."
                                            ]
                                        }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                    className: "text-muted",
                                                    style: {
                                                        fontSize: "0.85rem",
                                                        marginTop: "0.35rem"
                                                    },
                                                    children: [
                                                        "Completed: ",
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                            children: subcontractorBeneficiaries.length
                                                        }),
                                                        " \xb7 Ready to invoice:",
                                                        " ",
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                            children: subcontractorBeneficiaries.filter((b)=>b.invoiceEligible).length
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                    className: "issue-po-beneficiary-table-wrap",
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                                        className: "data-table issue-po-beneficiary-table",
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                            children: "Application ID"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                            children: "Name"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                            children: "Subcontractor"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                            children: "Status"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                                                children: subcontractorBeneficiaries.map((b)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                                className: "mono",
                                                                                children: b.beneficiaryMobileApplicationId || b.applicationId
                                                                            }),
                                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                                children: b.beneficiaryName
                                                                            }),
                                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                                children: subcontractorNameById.get(b.subcontractorMasterId || "") || "\u2014"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                                children: b.invoiceEligible ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                                    style: {
                                                                                        color: "#15803d"
                                                                                    },
                                                                                    children: "Ready to invoice"
                                                                                }) : b.skipReason ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                                    style: {
                                                                                        color: "#dc2626"
                                                                                    },
                                                                                    children: b.skipReason
                                                                                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                                    className: "text-muted",
                                                                                    children: "Already invoiced"
                                                                                })
                                                                            })
                                                                        ]
                                                                    }, b.applicationId))
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }) : null
                            ]
                        }) : invoiceType === "labour" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "inv-outward-issue__label",
                                    children: "Step 2 \u2014 Select milestone or timeline level"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "toolbar-row",
                                    style: {
                                        marginTop: "0.5rem"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                            type: "button",
                                            className: `btn btn--sm ${labourBrowseMode === "milestone" ? "btn--primary btn--tg" : "btn--tg-secondary"}`,
                                            onClick: ()=>{
                                                setLabourBrowseMode("milestone");
                                                setLabourTimelinePhaseIds([]);
                                                setMilestoneTemplateId("");
                                            },
                                            children: "By milestone"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                            type: "button",
                                            className: `btn btn--sm ${labourBrowseMode === "timeline" ? "btn--primary btn--tg" : "btn--tg-secondary"}`,
                                            onClick: ()=>{
                                                setLabourBrowseMode("timeline");
                                                setMilestoneTemplateId("");
                                                setLabourTimelinePhaseIds([]);
                                            },
                                            children: "By timeline level"
                                        })
                                    ]
                                }),
                                labourBrowseMode === "milestone" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                            className: "goods-receipts-filters__grid",
                                            style: {
                                                marginTop: "0.5rem"
                                            },
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "goods-receipts-filters__field",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "goods-receipts-filters__label",
                                                        children: "Search milestone"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control",
                                                        value: subcontractorMilestoneSearch,
                                                        onChange: (e)=>setSubcontractorMilestoneSearch(e.target.value),
                                                        placeholder: "Milestone / timeline level"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                            className: "text-muted",
                                            style: {
                                                fontSize: "0.85rem"
                                            },
                                            children: [
                                                "Selected: ",
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                    children: selectedSubcontractorMilestone?.title ?? "\u2014"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                            className: "issue-po-beneficiary-table-wrap",
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                                className: "data-table issue-po-beneficiary-table",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                    style: {
                                                                        width: "2.5rem"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                    children: "Milestone"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                    children: "Timeline levels"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                                        children: filteredSubcontractorMilestones.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                colSpan: 3,
                                                                className: "text-muted",
                                                                children: "No milestones in master yet."
                                                            })
                                                        }) : filteredSubcontractorMilestones.map((tpl)=>{
                                                            const timelineText = (tpl.linkedConstructionTimelinePhaseIds ?? []).map((id)=>timelinePhaseTitleById.get(String(id)) ?? "").filter(Boolean).join(", ");
                                                            return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                            type: "radio",
                                                                            name: "labour-milestone-select",
                                                                            checked: milestoneTemplateId === tpl.id,
                                                                            onChange: ()=>setMilestoneTemplateId(tpl.id),
                                                                            "aria-label": `Select milestone ${tpl.title}`
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        children: tpl.title
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        className: "text-muted",
                                                                        children: timelineText || "\u2014"
                                                                    })
                                                                ]
                                                            }, tpl.id);
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "toolbar-row",
                                            style: {
                                                marginTop: "0.35rem"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "btn btn--sm btn--tg-secondary",
                                                    onClick: ()=>setLabourTimelinePhaseIds(sortedTimelinePhases.map((p)=>String(p.id))),
                                                    children: "Select all timeline levels"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "btn btn--sm btn--tg-secondary",
                                                    onClick: ()=>setLabourTimelinePhaseIds([]),
                                                    children: "Clear all"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                            className: "text-muted",
                                            style: {
                                                fontSize: "0.85rem",
                                                marginTop: "0.35rem"
                                            },
                                            children: [
                                                "Selected: ",
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                    children: labourTimelinePhaseIds.length
                                                }),
                                                " timeline level(s). Beneficiaries must have ",
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                    children: "Approved"
                                                }),
                                                " status on all selected levels."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                            className: "issue-po-beneficiary-table-wrap",
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                                className: "data-table issue-po-beneficiary-table",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                    style: {
                                                                        width: "2.5rem"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        checked: sortedTimelinePhases.length > 0 && sortedTimelinePhases.every((p)=>labourTimelinePhaseIds.includes(String(p.id))),
                                                                        onChange: (e)=>setLabourTimelinePhaseIds(e.target.checked ? sortedTimelinePhases.map((p)=>String(p.id)) : [])
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                    children: "Timeline level"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                    children: "Planned days"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                                        children: sortedTimelinePhases.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                colSpan: 3,
                                                                className: "text-muted",
                                                                children: "No timeline levels in master yet."
                                                            })
                                                        }) : sortedTimelinePhases.map((phase)=>{
                                                            const phaseId = String(phase.id);
                                                            return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                            type: "checkbox",
                                                                            checked: labourTimelinePhaseIds.includes(phaseId),
                                                                            onChange: ()=>setLabourTimelinePhaseIds((prev)=>prev.includes(phaseId) ? prev.filter((id)=>id !== phaseId) : [
                                                                                        ...prev,
                                                                                        phaseId
                                                                                    ]),
                                                                            "aria-label": `Select timeline ${phase.title}`
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        children: phase.title
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                                        className: "mono",
                                                                        children: [
                                                                            "~",
                                                                            phase.approxDays,
                                                                            " d"
                                                                        ]
                                                                    })
                                                                ]
                                                            }, phase.id);
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                labourBrowseMode === "milestone" && milestoneTemplateId || labourBrowseMode === "timeline" && labourTimelinePhaseIds.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    style: {
                                        marginTop: "1rem"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "inv-outward-issue__label",
                                            children: "Completed beneficiaries"
                                        }),
                                        linesLoading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                            className: "text-muted",
                                            style: {
                                                marginTop: "0.35rem"
                                            },
                                            children: "Loading beneficiaries\u2026"
                                        }) : labourBeneficiaries.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                            className: "text-muted",
                                            style: {
                                                marginTop: "0.35rem"
                                            },
                                            children: [
                                                "No beneficiaries have completed",
                                                " ",
                                                labourBrowseMode === "milestone" ? selectedSubcontractorMilestone?.title ?? "this milestone" : "all selected timeline levels (office-approved)",
                                                "."
                                            ]
                                        }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                    className: "text-muted",
                                                    style: {
                                                        fontSize: "0.85rem",
                                                        marginTop: "0.35rem"
                                                    },
                                                    children: [
                                                        "Completed: ",
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                            children: labourBeneficiaries.length
                                                        }),
                                                        " \xb7 Ready to invoice:",
                                                        " ",
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                            children: labourBeneficiaries.filter((b)=>b.invoiceEligible).length
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                    className: "issue-po-beneficiary-table-wrap",
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                                        className: "data-table issue-po-beneficiary-table",
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                            children: "Application ID"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                            children: "Name"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                            children: "Status"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                                                children: labourBeneficiaries.map((b)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                                className: "mono",
                                                                                children: b.beneficiaryMobileApplicationId || b.applicationId
                                                                            }),
                                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                                children: b.beneficiaryName
                                                                            }),
                                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                                children: b.invoiceEligible ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                                    style: {
                                                                                        color: "#15803d"
                                                                                    },
                                                                                    children: "Ready to invoice"
                                                                                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                                    className: "text-muted",
                                                                                    children: "Already invoiced"
                                                                                })
                                                                            })
                                                                        ]
                                                                    }, b.applicationId))
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }) : null
                            ]
                        }) : null
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("section", {
                        className: "issue-po-flow__section",
                        children: invoiceType === "material" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "inv-outward-issue__label",
                                    children: "Step 3 \u2014 Invoice mode"
                                }),
                                !materialPoId ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                    className: "text-muted",
                                    style: {
                                        marginTop: "0.5rem"
                                    },
                                    children: "Select a PO above to choose individual or consolidated invoice."
                                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "toolbar-row",
                                            style: {
                                                marginTop: "0.5rem"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                    type: "button",
                                                    className: `btn btn--sm ${materialInvoiceMode === "individual" ? "btn--primary btn--tg" : "btn--tg-secondary"}`,
                                                    onClick: ()=>setMaterialInvoiceMode("individual"),
                                                    children: "Individual invoices"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                    type: "button",
                                                    className: `btn btn--sm ${materialInvoiceMode === "consolidated" ? "btn--primary btn--tg" : "btn--tg-secondary"}`,
                                                    onClick: ()=>setMaterialInvoiceMode("consolidated"),
                                                    children: "Single consolidated invoice"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                            className: "text-muted",
                                            style: {
                                                fontSize: "0.85rem",
                                                marginTop: "0.5rem"
                                            },
                                            children: materialInvoiceMode === "individual" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                                children: [
                                                    "Creates ",
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                        children: materialBeneficiaryIds.length || selectedMaterialPo?.beneficiaryCount || 0
                                                    }),
                                                    " ",
                                                    "separate invoice(s) \u2014 Bill To filled with each beneficiary's name and site address."
                                                ]
                                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $64174c7064b10992$exports.Fragment), {
                                                children: "Creates one invoice for all beneficiaries on this PO \u2014 beneficiary breakdown appears in the annexure (current format)."
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : invoiceType === "subcontractor" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "inv-outward-issue__label",
                                    children: "Step 3 \u2014 Invoice mode"
                                }),
                                !subcontractorSelectionReady ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                    className: "text-muted",
                                    style: {
                                        marginTop: "0.5rem"
                                    },
                                    children: "Select a milestone or at least one timeline level above to choose individual or consolidated invoice."
                                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "toolbar-row",
                                            style: {
                                                marginTop: "0.5rem"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                    type: "button",
                                                    className: `btn btn--sm ${subcontractorInvoiceMode === "individual" ? "btn--primary btn--tg" : "btn--tg-secondary"}`,
                                                    onClick: ()=>setSubcontractorInvoiceMode("individual"),
                                                    children: "Individual invoices"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                    type: "button",
                                                    className: `btn btn--sm ${subcontractorInvoiceMode === "consolidated" ? "btn--primary btn--tg" : "btn--tg-secondary"}`,
                                                    onClick: ()=>setSubcontractorInvoiceMode("consolidated"),
                                                    children: "Single consolidated invoice"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                            className: "text-muted",
                                            style: {
                                                fontSize: "0.85rem",
                                                marginTop: "0.5rem"
                                            },
                                            children: [
                                                subcontractorInvoiceMode === "individual" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                                    children: [
                                                        "Creates ",
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                            children: subcontractorBeneficiaryIds.length || invoiceApplicationIds.length
                                                        }),
                                                        " ",
                                                        "separate invoice(s) for beneficiaries ready to invoice."
                                                    ]
                                                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                                    children: [
                                                        "Creates one invoice for all beneficiaries ready to invoice on",
                                                        " ",
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                            children: subcontractorBrowseMode === "milestone" ? selectedSubcontractorMilestone?.title ?? "this milestone" : `${subcontractorTimelinePhaseIds.length} timeline level(s)`
                                                        }),
                                                        "."
                                                    ]
                                                }),
                                                invoiceApplicationIds.length > 1 && !subcontractorValidation.ok ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                    style: {
                                                        color: "#dc2626",
                                                        display: "block",
                                                        marginTop: "0.35rem"
                                                    },
                                                    children: "Eligible beneficiaries must share the same subcontractor."
                                                }) : null
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }) : invoiceType === "labour" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "inv-outward-issue__label",
                                    children: "Step 3 \u2014 Labour supplier & invoice mode"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    style: {
                                        marginTop: "0.5rem"
                                    },
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "goods-receipts-filters__field",
                                        style: {
                                            display: "block",
                                            maxWidth: "28rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "goods-receipts-filters__label",
                                                children: "Labour supplier *"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                id: "inv-labour-supplier",
                                                value: labourSupplierId,
                                                onChange: setLabourSupplierId,
                                                options: labourSupplierOptions
                                            })
                                        ]
                                    })
                                }),
                                !labourSelectionReady ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                    className: "text-muted",
                                    style: {
                                        marginTop: "0.5rem"
                                    },
                                    children: "Select a milestone or at least one timeline level above to choose individual or consolidated invoice."
                                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "toolbar-row",
                                            style: {
                                                marginTop: "0.5rem"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                    type: "button",
                                                    className: `btn btn--sm ${labourInvoiceMode === "individual" ? "btn--primary btn--tg" : "btn--tg-secondary"}`,
                                                    onClick: ()=>setLabourInvoiceMode("individual"),
                                                    children: "Individual invoices"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                    type: "button",
                                                    className: `btn btn--sm ${labourInvoiceMode === "consolidated" ? "btn--primary btn--tg" : "btn--tg-secondary"}`,
                                                    onClick: ()=>setLabourInvoiceMode("consolidated"),
                                                    children: "Single consolidated invoice"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                            className: "text-muted",
                                            style: {
                                                fontSize: "0.85rem",
                                                marginTop: "0.5rem"
                                            },
                                            children: labourInvoiceMode === "individual" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                                children: [
                                                    "Creates ",
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                        children: labourBeneficiaryIds.length || invoiceApplicationIds.length
                                                    }),
                                                    " separate invoice(s) for beneficiaries ready to invoice."
                                                ]
                                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                                children: [
                                                    "Creates one invoice for all beneficiaries ready to invoice on",
                                                    " ",
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                        children: labourBrowseMode === "milestone" ? selectedSubcontractorMilestone?.title ?? "this milestone" : `${labourTimelinePhaseIds.length} timeline level(s)`
                                                    }),
                                                    "."
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : null
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                        className: "issue-po-flow__section",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "inv-outward-issue__label",
                                children: "Step 4 \u2014 Invoice preview lines"
                            }),
                            linesLoading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                children: "Loading eligible lines\u2026"
                            }) : null,
                            invoiceType === "material" && !linesLoading ? !materialPoId ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                children: "Select a PO to load material lines."
                            }) : materialLines.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                children: "No invoiceable lines for this PO. If store inward was recorded, only received quantities can be invoiced; otherwise PO planned quantities are used. Lines already fully invoiced are hidden."
                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                className: "data-table",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Beneficiary"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Item"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "PO"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Eligible qty"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Qty"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Rate"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Line"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                        children: materialLines.map((ln)=>{
                                            const rawQty = qtyOverrides[ln.lineKey];
                                            const qty = rawQty != null && rawQty.trim() !== "" ? (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(rawQty) : ln.eligibleQty;
                                            return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: ln.beneficiaryName
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: ln.lineLabel
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono",
                                                        children: ln.poNumber
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono",
                                                        children: ln.eligibleQty
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                            className: "form-control",
                                                            style: {
                                                                maxWidth: "6rem"
                                                            },
                                                            value: rawQty ?? String(ln.eligibleQty),
                                                            onChange: (e)=>setQtyOverrides((p)=>({
                                                                        ...p,
                                                                        [ln.lineKey]: (0, $50736abadf17d9d0$export$73a62fdf13118eb6)(e.target.value)
                                                                    }))
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono",
                                                        children: ln.rate
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono",
                                                        children: $a78dc66b5570f421$var$fmtInr(qty * ln.rate)
                                                    })
                                                ]
                                            }, ln.lineKey);
                                        })
                                    })
                                ]
                            }) : null,
                            invoiceType === "subcontractor" && !linesLoading ? !subcontractorSelectionReady ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                children: "Select a milestone or timeline level to load invoice lines."
                            }) : subcontractorLines.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                children: "No invoiceable lines \u2014 beneficiaries may not have completed subcontractor bill items, items may already be invoiced, or rates are not set in Invoice format."
                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                className: "data-table",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Beneficiary"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Bill line"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "HSN"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Qty"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Rate (\u20B9)"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Line"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                        children: subcontractorLines.map((ln)=>{
                                            const rawRate = rateOverrides[ln.lineKey];
                                            const rate = rawRate != null && rawRate.trim() !== "" ? (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(rawRate) : ln.rate;
                                            const rawQty = qtyOverrides[ln.lineKey];
                                            const qty = rawQty != null && rawQty.trim() !== "" ? (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(rawQty) : ln.eligibleQty;
                                            return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: ln.beneficiaryName
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: ln.lineLabel
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono",
                                                        children: ln.hsnCode || "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                            className: "form-control",
                                                            style: {
                                                                maxWidth: "5rem"
                                                            },
                                                            value: rawQty ?? String(ln.eligibleQty),
                                                            onChange: (e)=>setQtyOverrides((p)=>({
                                                                        ...p,
                                                                        [ln.lineKey]: (0, $50736abadf17d9d0$export$73a62fdf13118eb6)(e.target.value)
                                                                    }))
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                            className: "form-control",
                                                            style: {
                                                                maxWidth: "7rem"
                                                            },
                                                            value: rawRate ?? (ln.rate > 0 ? String(ln.rate) : ""),
                                                            onChange: (e)=>setRateOverrides((p)=>({
                                                                        ...p,
                                                                        [ln.lineKey]: (0, $50736abadf17d9d0$export$73a62fdf13118eb6)(e.target.value)
                                                                    }))
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono",
                                                        children: rate > 0 ? $a78dc66b5570f421$var$fmtInr(qty * rate) : "\u2014"
                                                    })
                                                ]
                                            }, ln.lineKey);
                                        })
                                    })
                                ]
                            }) : null,
                            invoiceType === "labour" && !linesLoading ? !labourSelectionReady ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                children: "Select a milestone or timeline level(s) to load labour bill lines."
                            }) : labourLines.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                className: "text-muted",
                                children: [
                                    "No invoiceable labour lines \u2014 beneficiaries may not have completed selected timeline levels, items may already be invoiced, or rates are not set in",
                                    " ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                        to: "/bills/inward/format",
                                        children: "Invoice format \u2192 Labour"
                                    }),
                                    "."
                                ]
                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                className: "data-table",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Beneficiary"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Bill line"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "HSN"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Qty"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Rate (\u20B9)"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Line"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                        children: labourLines.map((ln)=>{
                                            const rawRate = rateOverrides[ln.lineKey];
                                            const rate = rawRate != null && rawRate.trim() !== "" ? (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(rawRate) : ln.rate;
                                            const rawQty = qtyOverrides[ln.lineKey];
                                            const qty = rawQty != null && rawQty.trim() !== "" ? (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(rawQty) : ln.eligibleQty;
                                            return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: ln.beneficiaryName
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: ln.lineLabel
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono",
                                                        children: ln.hsnCode || "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                            className: "form-control",
                                                            style: {
                                                                maxWidth: "5rem"
                                                            },
                                                            value: rawQty ?? String(ln.eligibleQty),
                                                            onChange: (e)=>setQtyOverrides((p)=>({
                                                                        ...p,
                                                                        [ln.lineKey]: (0, $50736abadf17d9d0$export$73a62fdf13118eb6)(e.target.value)
                                                                    }))
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                            className: "form-control",
                                                            style: {
                                                                maxWidth: "7rem"
                                                            },
                                                            value: rawRate ?? (ln.rate > 0 ? String(ln.rate) : ""),
                                                            onChange: (e)=>setRateOverrides((p)=>({
                                                                        ...p,
                                                                        [ln.lineKey]: (0, $50736abadf17d9d0$export$73a62fdf13118eb6)(e.target.value)
                                                                    }))
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono",
                                                        children: rate > 0 ? $a78dc66b5570f421$var$fmtInr(qty * rate) : "\u2014"
                                                    })
                                                ]
                                            }, ln.lineKey);
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                        className: "issue-po-flow__section",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "goods-receipts-filters__field goods-receipts-filters__field--wide",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "goods-receipts-filters__label",
                                        children: "Notes (optional)"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                        className: "form-control",
                                        rows: 2,
                                        value: invoiceNotes,
                                        onChange: (e)=>setInvoiceNotes(e.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "inv-outward-issue__actions",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--primary btn--tg btn--lg",
                                    disabled: generating,
                                    onClick: ()=>void runGenerate(),
                                    children: generating && generateProgress ? generateProgress.phase === "invoices" ? `Creating invoices ${generateProgress.done}/${generateProgress.total}\u{2026}` : `Building PDFs ${generateProgress.done}/${generateProgress.total}\u{2026}` : generating ? "Generating\u2026" : invoiceType === "material" && materialInvoiceMode === "individual" && materialBeneficiaryIds.length > 0 ? `Generate ${materialBeneficiaryIds.length} invoices & ZIP` : invoiceType === "material" && materialInvoiceMode === "consolidated" ? "Generate consolidated invoice" : invoiceType === "subcontractor" && subcontractorInvoiceMode === "individual" && subcontractorBeneficiaryIds.length > 0 ? `Generate ${subcontractorBeneficiaryIds.length} invoices & ZIP` : invoiceType === "labour" && labourInvoiceMode === "individual" && labourBeneficiaryIds.length > 0 ? `Generate ${labourBeneficiaryIds.length} invoices & ZIP` : "Generate invoice"
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "goods-receipts-filters__grid",
                        style: {
                            marginBottom: "0.75rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "goods-receipts-filters__field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "goods-receipts-filters__label",
                                        children: "Search"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control",
                                        value: registerSearch,
                                        onChange: (e)=>setRegisterSearch(e.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "goods-receipts-filters__field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "goods-receipts-filters__label",
                                        children: "Type"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                                        className: "form-control",
                                        value: registerTypeFilter,
                                        onChange: (e)=>setRegisterTypeFilter(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                value: "all",
                                                children: "All types"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                value: "material",
                                                children: "Material"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                value: "subcontractor",
                                                children: "Subcontractor"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                value: "labour",
                                                children: "Labour"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "goods-receipts-filters__field",
                                style: {
                                    alignSelf: "end"
                                },
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--tg-secondary",
                                    onClick: ()=>void loadRegister(),
                                    children: "Apply filters"
                                })
                            })
                        ]
                    }),
                    registerLoading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "Loading\u2026"
                    }) : registerRows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "No invoices yet."
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                        className: "data-table",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                            children: "Invoice no."
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                            children: "Type"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                            children: "Party"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                            children: "Beneficiaries"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                            children: "Date"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                            children: "Grand total"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                children: registerRows.map((row)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                className: "mono",
                                                children: row.invoiceNumber
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                children: $a78dc66b5570f421$var$invoiceTypeLabel(row.invoiceType)
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                children: row.partyFirmName
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                children: row.beneficiaryCount
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                children: $a78dc66b5570f421$var$formatWhen(row.createdAt)
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                className: "mono",
                                                children: $a78dc66b5570f421$var$fmtInr(row.grandTotal)
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "btn btn--sm btn--tg-secondary",
                                                        disabled: pdfDownloadingId === row.id,
                                                        onClick: ()=>void handleDownloadRegisterPdf(row),
                                                        children: pdfDownloadingId === row.id ? "\u2026" : "Download PDF"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "btn btn--sm btn--danger",
                                                        style: {
                                                            marginLeft: "0.35rem"
                                                        },
                                                        disabled: cancellingId === row.id,
                                                        onClick: ()=>{
                                                            if (!window.confirm(`Cancel ${row.invoiceNumber}?`)) return;
                                                            setCancellingId(row.id);
                                                            (0, $cbddb03275b22218$export$222a9c561ea276af)(row.id).then(()=>loadRegister()).then(()=>showToast("Invoice cancelled.", "success")).catch((e)=>showToast(e instanceof Error ? e.message : "Cancel failed.", "error")).finally(()=>setCancellingId(""));
                                                        },
                                                        children: "Cancel"
                                                    })
                                                ]
                                            })
                                        ]
                                    }, row.id))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");








const $772f7392f7d83c73$var$INVOICE_TYPE_TABS = [
    {
        id: "material",
        label: "Material"
    },
    {
        id: "subcontractor",
        label: "Subcontractor"
    },
    {
        id: "labour",
        label: "Labour"
    }
];
function $772f7392f7d83c73$var$documentTitleForType(s, type) {
    return (0, $0167ea69d6388932$export$d302ae792a4823cf)(s, type);
}
function $772f7392f7d83c73$var$cloneTypeFormats(initial) {
    return {
        material: {
            ...initial.material,
            gstRows: initial.material.gstRows.map((r)=>({
                    ...r
                }))
        },
        subcontractor: {
            ...initial.subcontractor,
            gstRows: initial.subcontractor.gstRows.map((r)=>({
                    ...r
                }))
        },
        labour: {
            ...initial.labour,
            gstRows: initial.labour.gstRows.map((r)=>({
                    ...r
                }))
        }
    };
}
function $772f7392f7d83c73$var$setDocumentTitleForType(type, value, setters) {
    if (type === "material") setters.setMaterial(value);
    else if (type === "subcontractor") setters.setSubcontractor(value);
    else setters.setLabour(value);
}
function $772f7392f7d83c73$export$1469c8e425f39bb8() {
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const { milestoneTemplates: milestoneTemplates, constructionTimelinePhases: constructionTimelinePhases } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const initial = (0, $7UyaH.useMemo)(()=>(0, $0167ea69d6388932$export$f1d229bf4759dfa5)(), []);
    const [documentTitleMaterial, setDocumentTitleMaterial] = (0, $7UyaH.useState)(initial.documentTitleMaterial);
    const [documentTitleSubcontractor, setDocumentTitleSubcontractor] = (0, $7UyaH.useState)(initial.documentTitleSubcontractor);
    const [documentTitleLabour, setDocumentTitleLabour] = (0, $7UyaH.useState)(initial.documentTitleLabour);
    const [letterheadTagline, setLetterheadTagline] = (0, $7UyaH.useState)(initial.letterheadTagline);
    const [logoPrimaryUrl, setLogoPrimaryUrl] = (0, $7UyaH.useState)(initial.logoPrimaryUrl);
    const [logoSecondaryUrl, setLogoSecondaryUrl] = (0, $7UyaH.useState)(initial.logoSecondaryUrl);
    const [logoPrimaryHeightPx, setLogoPrimaryHeightPx] = (0, $7UyaH.useState)(initial.logoPrimaryHeightPx);
    const [logoSecondaryHeightPx, setLogoSecondaryHeightPx] = (0, $7UyaH.useState)(initial.logoSecondaryHeightPx);
    const [accentColorHex, setAccentColorHex] = (0, $7UyaH.useState)(initial.accentColorHex);
    const [typeFormats, setTypeFormats] = (0, $7UyaH.useState)(()=>$772f7392f7d83c73$var$cloneTypeFormats(initial));
    const [subcontractorBillLines, setSubcontractorBillLines] = (0, $7UyaH.useState)(()=>initial.subcontractorBillLines);
    const [labourBillLines, setLabourBillLines] = (0, $7UyaH.useState)(()=>initial.labourBillLines);
    const [activeTab, setActiveTab] = (0, $7UyaH.useState)("format");
    const [invoiceTypeTab, setInvoiceTypeTab] = (0, $7UyaH.useState)("material");
    const [samplePdfBusy, setSamplePdfBusy] = (0, $7UyaH.useState)(false);
    const activeFormat = typeFormats[invoiceTypeTab];
    const gstRows = (0, $7UyaH.useMemo)(()=>(0, $0167ea69d6388932$export$adfff66ef57cdc6d)(activeFormat.gstRows), [
        activeFormat.gstRows
    ]);
    function patchActiveFormat(patch) {
        setTypeFormats((prev)=>({
                ...prev,
                [invoiceTypeTab]: {
                    ...prev[invoiceTypeTab],
                    ...patch
                }
            }));
    }
    function setActiveGstRows(updater) {
        setTypeFormats((prev)=>{
            const cur = prev[invoiceTypeTab];
            const editorRows = (0, $0167ea69d6388932$export$adfff66ef57cdc6d)(cur.gstRows);
            return {
                ...prev,
                [invoiceTypeTab]: {
                    ...cur,
                    gstRows: (0, $0167ea69d6388932$export$b2d77326b23e5e14)(updater(editorRows))
                }
            };
        });
    }
    function buildDraft() {
        return (0, $0167ea69d6388932$export$29a48fb856242f74)({
            version: 2,
            documentTitleMaterial: documentTitleMaterial,
            documentTitleSubcontractor: documentTitleSubcontractor,
            documentTitleLabour: documentTitleLabour,
            letterheadTagline: letterheadTagline,
            logoPrimaryUrl: logoPrimaryUrl,
            logoSecondaryUrl: logoSecondaryUrl,
            logoPrimaryHeightPx: logoPrimaryHeightPx,
            logoSecondaryHeightPx: logoSecondaryHeightPx,
            accentColorHex: accentColorHex,
            material: typeFormats.material,
            subcontractor: typeFormats.subcontractor,
            labour: typeFormats.labour,
            subcontractorBillLines: subcontractorBillLines,
            labourBillLines: labourBillLines
        });
    }
    (0, $7UyaH.useEffect)(()=>{
        setSubcontractorBillLines((prev)=>(0, $34977f436b6dfc5f$export$ac195a4586e1676e)(milestoneTemplates, constructionTimelinePhases, prev));
    }, [
        milestoneTemplates,
        constructionTimelinePhases
    ]);
    (0, $7UyaH.useEffect)(()=>{
        setLabourBillLines((prev)=>(0, $fe4bf9984635f90b$export$70b883779db5e631)(milestoneTemplates, constructionTimelinePhases, prev, subcontractorBillLines));
    }, [
        milestoneTemplates,
        constructionTimelinePhases,
        subcontractorBillLines
    ]);
    const draftSettings = (0, $7UyaH.useMemo)(()=>buildDraft(), [
        documentTitleMaterial,
        documentTitleSubcontractor,
        documentTitleLabour,
        letterheadTagline,
        logoPrimaryUrl,
        logoSecondaryUrl,
        logoPrimaryHeightPx,
        logoSecondaryHeightPx,
        accentColorHex,
        typeFormats,
        subcontractorBillLines,
        labourBillLines
    ]);
    const subcontractorMilestoneRows = (0, $7UyaH.useMemo)(()=>(0, $34977f436b6dfc5f$export$86f9b6bfee38c313)(subcontractorBillLines), [
        subcontractorBillLines
    ]);
    const subcontractorTimelineRows = (0, $7UyaH.useMemo)(()=>(0, $34977f436b6dfc5f$export$ab3222ab10de271e)(subcontractorBillLines), [
        subcontractorBillLines
    ]);
    const labourTimelineRows = (0, $7UyaH.useMemo)(()=>(0, $34977f436b6dfc5f$export$ab3222ab10de271e)(labourBillLines), [
        labourBillLines
    ]);
    const labourMilestoneRows = (0, $7UyaH.useMemo)(()=>(0, $fe4bf9984635f90b$export$9b01fbcdd1a94bc6)(labourBillLines), [
        labourBillLines
    ]);
    function patchSubcontractorBillLine(itemId, patch) {
        setSubcontractorBillLines((rows)=>rows.map((r)=>r.milestoneTemplateItemId === itemId ? {
                    ...r,
                    ...patch
                } : r));
    }
    function patchLabourBillLine(itemId, patch) {
        setLabourBillLines((rows)=>rows.map((r)=>r.milestoneTemplateItemId === itemId ? {
                    ...r,
                    ...patch
                } : r));
    }
    const previewHtml = (0, $7UyaH.useMemo)(()=>(0, $103f1d5fa9f5b81b$export$ff58404e836f6d1f)(draftSettings, invoiceTypeTab), [
        draftSettings,
        invoiceTypeTab
    ]);
    const samplePdfDoc = (0, $7UyaH.useMemo)(()=>(0, $103f1d5fa9f5b81b$export$4fede9169bf217a0)(draftSettings, invoiceTypeTab), [
        draftSettings,
        invoiceTypeTab
    ]);
    (0, $7UyaH.useEffect)(()=>{
        (0, $b2a79528db62cd8d$export$e6898c6b9b3f226e)([
            logoPrimaryUrl,
            logoSecondaryUrl
        ]);
    }, [
        logoPrimaryUrl,
        logoSecondaryUrl
    ]);
    function handleLogoUpload(e, setter) {
        const file = e.target.files?.[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (ev)=>{
            if (typeof ev.target?.result === "string") setter(ev.target.result);
        };
        reader.readAsDataURL(file);
    }
    function handleSave() {
        (0, $0167ea69d6388932$export$54e25f11670cea4a)(buildDraft());
        showToast("Invoice format saved. Downloads will use these defaults.", "success");
    }
    function handleReset() {
        const d = (0, $0167ea69d6388932$export$45c6a1876597daad)();
        setDocumentTitleMaterial(d.documentTitleMaterial);
        setDocumentTitleSubcontractor(d.documentTitleSubcontractor);
        setDocumentTitleLabour(d.documentTitleLabour);
        setLetterheadTagline(d.letterheadTagline);
        setLogoPrimaryUrl(d.logoPrimaryUrl);
        setLogoSecondaryUrl(d.logoSecondaryUrl);
        setLogoPrimaryHeightPx(d.logoPrimaryHeightPx);
        setLogoSecondaryHeightPx(d.logoSecondaryHeightPx);
        setAccentColorHex(d.accentColorHex);
        setTypeFormats($772f7392f7d83c73$var$cloneTypeFormats(d));
        setSubcontractorBillLines((0, $34977f436b6dfc5f$export$ac195a4586e1676e)(milestoneTemplates, constructionTimelinePhases, d.subcontractorBillLines));
        setLabourBillLines((0, $fe4bf9984635f90b$export$70b883779db5e631)(milestoneTemplates, constructionTimelinePhases, d.labourBillLines, d.subcontractorBillLines));
        showToast("Form reset to factory defaults (not saved yet).", "info");
    }
    const titleSetters = {
        setMaterial: setDocumentTitleMaterial,
        setSubcontractor: setDocumentTitleSubcontractor,
        setLabour: setDocumentTitleLabour
    };
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "workspace",
        style: {
            display: "flex",
            flexDirection: "column",
            height: "calc(100vh - 4rem)",
            background: "#f1f5f9"
        },
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                style: {
                    width: "100%",
                    padding: "1rem",
                    flex: "0 0 auto",
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    gap: "0.75rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            gap: "0.25rem",
                            background: "#cbd5e1",
                            padding: "0.3rem",
                            borderRadius: "8px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: `btn ${activeTab === "format" ? "btn--primary" : ""}`,
                                style: activeTab === "format" ? {
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                    minWidth: "140px"
                                } : {
                                    background: "transparent",
                                    border: "none",
                                    color: "#334155",
                                    minWidth: "140px",
                                    fontWeight: 500
                                },
                                onClick: ()=>setActiveTab("format"),
                                children: "Format settings"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: `btn ${activeTab === "preview" ? "btn--primary" : ""}`,
                                style: activeTab === "preview" ? {
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                    minWidth: "140px"
                                } : {
                                    background: "transparent",
                                    border: "none",
                                    color: "#334155",
                                    minWidth: "140px",
                                    fontWeight: 500
                                },
                                onClick: ()=>setActiveTab("preview"),
                                children: "Live preview"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            gap: "0.25rem",
                            background: "#e2e8f0",
                            padding: "0.3rem",
                            borderRadius: "8px"
                        },
                        children: $772f7392f7d83c73$var$INVOICE_TYPE_TABS.map((t)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: `btn ${invoiceTypeTab === t.id ? "btn--primary" : ""}`,
                                style: invoiceTypeTab === t.id ? {
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                    minWidth: "120px"
                                } : {
                                    background: "transparent",
                                    border: "none",
                                    color: "#334155",
                                    minWidth: "120px",
                                    fontWeight: 500
                                },
                                onClick: ()=>setInvoiceTypeTab(t.id),
                                children: t.label
                            }, t.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    flex: 1,
                    overflow: "hidden",
                    gap: "1rem",
                    padding: "0 1rem 1rem 1rem",
                    justifyContent: "center"
                },
                children: [
                    activeTab === "format" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "card card--gov card--elevated",
                        style: {
                            flex: 1,
                            maxWidth: "1200px",
                            overflowY: "auto",
                            margin: 0,
                            padding: 0,
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                style: {
                                    padding: "1.5rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "section-lead section-lead--tight text-muted",
                                        style: {
                                            marginTop: 0
                                        },
                                        children: "Letterhead and logos are shared. Use the Material / Subcontractor / Labour tabs to set document title, Bill From / Bill To, payment terms, footer, GST, and aggregate-qty defaults for each invoice type."
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("h3", {
                                        className: "form-section-title",
                                        children: [
                                            $772f7392f7d83c73$var$INVOICE_TYPE_TABS.find((t)=>t.id === invoiceTypeTab)?.label,
                                            " invoice title"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "inv-outward-issue__field inv-outward-issue__field--full",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "inv-outward-issue__label",
                                                children: "Document title on PDF"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                className: "form-control",
                                                value: $772f7392f7d83c73$var$documentTitleForType(draftSettings, invoiceTypeTab),
                                                onChange: (e)=>$772f7392f7d83c73$var$setDocumentTitleForType(invoiceTypeTab, e.target.value, titleSetters),
                                                placeholder: "TAX INVOICE"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                        className: "form-section-title",
                                        style: {
                                            marginTop: "1.25rem"
                                        },
                                        children: "Shared letterhead"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "inv-outward-issue__grid",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Letterhead tagline"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control",
                                                        value: letterheadTagline,
                                                        onChange: (e)=>setLetterheadTagline(e.target.value),
                                                        placeholder: "Programme / department name"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--r1",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Accent colour"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        type: "color",
                                                        className: "form-control",
                                                        style: {
                                                            maxWidth: "72px",
                                                            height: "38px",
                                                            padding: "4px"
                                                        },
                                                        value: /^#[0-9A-Fa-f]{6}$/.test(accentColorHex.trim()) ? accentColorHex.trim() : "#16365f",
                                                        onChange: (e)=>setAccentColorHex(e.target.value),
                                                        "aria-label": "Accent colour"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--r1",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Accent hex"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control mono",
                                                        value: accentColorHex,
                                                        onChange: (e)=>setAccentColorHex(e.target.value),
                                                        placeholder: "#16365f"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                style: {
                                                    display: "grid",
                                                    gridTemplateColumns: "1fr 120px",
                                                    gap: "1rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: "0.5rem"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                                className: "inv-outward-issue__field",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                        className: "inv-outward-issue__label",
                                                                        children: "Primary logo"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                        type: "file",
                                                                        accept: "image/*",
                                                                        className: "form-control",
                                                                        style: {
                                                                            padding: "0.4rem 0.6rem"
                                                                        },
                                                                        onChange: (e)=>handleLogoUpload(e, setLogoPrimaryUrl)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                className: "form-control mono",
                                                                value: logoPrimaryUrl,
                                                                onChange: (e)=>setLogoPrimaryUrl(e.target.value),
                                                                placeholder: "/branding/Telangana-LOGO.png"
                                                            })
                                                        ]
                                                    }),
                                                    logoPrimaryUrl ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            border: "1px dashed var(--border)",
                                                            borderRadius: "8px",
                                                            padding: "0.5rem",
                                                            background: "#f8fafc"
                                                        },
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                                                            src: logoPrimaryUrl,
                                                            alt: "Primary preview",
                                                            style: {
                                                                maxHeight: "80px",
                                                                maxWidth: "100%",
                                                                objectFit: "contain"
                                                            }
                                                        })
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--r1",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Primary logo height (px)"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        type: "number",
                                                        min: 28,
                                                        max: 160,
                                                        className: "form-control mono",
                                                        value: Number.isFinite(logoPrimaryHeightPx) ? logoPrimaryHeightPx : "",
                                                        onChange: (e)=>{
                                                            const v = parseInt(e.target.value, 10);
                                                            setLogoPrimaryHeightPx(Number.isFinite(v) ? v : (0, $0167ea69d6388932$export$45c6a1876597daad)().logoPrimaryHeightPx);
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                style: {
                                                    display: "grid",
                                                    gridTemplateColumns: "1fr 120px",
                                                    gap: "1rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: "0.5rem"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                                className: "inv-outward-issue__field",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                        className: "inv-outward-issue__label",
                                                                        children: "Secondary logo (optional)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                        type: "file",
                                                                        accept: "image/*",
                                                                        className: "form-control",
                                                                        style: {
                                                                            padding: "0.4rem 0.6rem"
                                                                        },
                                                                        onChange: (e)=>handleLogoUpload(e, setLogoSecondaryUrl)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                className: "form-control mono",
                                                                value: logoSecondaryUrl,
                                                                onChange: (e)=>setLogoSecondaryUrl(e.target.value),
                                                                placeholder: "/branding/your-company.png"
                                                            })
                                                        ]
                                                    }),
                                                    logoSecondaryUrl ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            border: "1px dashed var(--border)",
                                                            borderRadius: "8px",
                                                            padding: "0.5rem",
                                                            background: "#f8fafc"
                                                        },
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                                                            src: logoSecondaryUrl,
                                                            alt: "Secondary preview",
                                                            style: {
                                                                maxHeight: "80px",
                                                                maxWidth: "100%",
                                                                objectFit: "contain"
                                                            }
                                                        })
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--r1",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Secondary logo height (px)"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        type: "number",
                                                        min: 28,
                                                        max: 160,
                                                        className: "form-control mono",
                                                        value: Number.isFinite(logoSecondaryHeightPx) ? logoSecondaryHeightPx : "",
                                                        onChange: (e)=>{
                                                            const v = parseInt(e.target.value, 10);
                                                            setLogoSecondaryHeightPx(Number.isFinite(v) ? v : (0, $0167ea69d6388932$export$45c6a1876597daad)().logoSecondaryHeightPx);
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("h3", {
                                        className: "form-section-title",
                                        style: {
                                            marginTop: "1.25rem"
                                        },
                                        children: [
                                            $772f7392f7d83c73$var$INVOICE_TYPE_TABS.find((t)=>t.id === invoiceTypeTab)?.label,
                                            " \u2014 Bill From / Bill To"
                                        ]
                                    }),
                                    invoiceTypeTab === "subcontractor" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        style: {
                                            marginBottom: "1.25rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                                className: "form-section-title",
                                                children: "Subcontractor bill lines"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                className: "text-muted",
                                                style: {
                                                    fontSize: "0.88rem",
                                                    marginTop: "-0.35rem"
                                                },
                                                children: [
                                                    "Configure milestone-wise and timeline-wise rates separately. Milestones come from",
                                                    " ",
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                                        to: "/milestone-master",
                                                        children: "Milestone master"
                                                    }),
                                                    "; timeline levels from",
                                                    " ",
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                                        to: "/construction-timeline-master",
                                                        children: "Timeline master"
                                                    }),
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h4", {
                                                className: "form-section-title",
                                                style: {
                                                    marginTop: "1rem",
                                                    fontSize: "0.95rem"
                                                },
                                                children: "Milestone-wise bill lines"
                                            }),
                                            subcontractorMilestoneRows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                className: "text-muted",
                                                children: "No milestones in master yet."
                                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                style: {
                                                    overflowX: "auto"
                                                },
                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                                    className: "data-table",
                                                    style: {
                                                        marginTop: "0.35rem"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Milestone"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Bill line"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Qty"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Unit"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Rate (\u20B9)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "HSN/SAC"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                                            children: subcontractorMilestoneRows.map((row)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: row.milestoneTitle
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: row.lineLabel
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                className: "form-control mono",
                                                                                style: {
                                                                                    maxWidth: "5rem"
                                                                                },
                                                                                value: String(row.qty),
                                                                                onChange: (e)=>patchSubcontractorBillLine(row.milestoneTemplateItemId, {
                                                                                        qty: Math.max(0, Number(e.target.value) || 0)
                                                                                    })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                className: "form-control",
                                                                                style: {
                                                                                    maxWidth: "5rem"
                                                                                },
                                                                                value: row.unit,
                                                                                onChange: (e)=>patchSubcontractorBillLine(row.milestoneTemplateItemId, {
                                                                                        unit: e.target.value
                                                                                    })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                className: "form-control mono",
                                                                                style: {
                                                                                    maxWidth: "7rem"
                                                                                },
                                                                                value: String(row.rate),
                                                                                onChange: (e)=>patchSubcontractorBillLine(row.milestoneTemplateItemId, {
                                                                                        rate: Math.max(0, Number(e.target.value) || 0)
                                                                                    })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                className: "form-control mono",
                                                                                style: {
                                                                                    maxWidth: "7rem"
                                                                                },
                                                                                value: row.hsnCode,
                                                                                onChange: (e)=>patchSubcontractorBillLine(row.milestoneTemplateItemId, {
                                                                                        hsnCode: e.target.value.toUpperCase()
                                                                                    })
                                                                            })
                                                                        })
                                                                    ]
                                                                }, row.milestoneTemplateItemId))
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h4", {
                                                className: "form-section-title",
                                                style: {
                                                    marginTop: "1.25rem",
                                                    fontSize: "0.95rem"
                                                },
                                                children: "Timeline-wise bill lines"
                                            }),
                                            subcontractorTimelineRows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                className: "text-muted",
                                                children: "No timeline levels in master yet."
                                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                style: {
                                                    overflowX: "auto"
                                                },
                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                                    className: "data-table",
                                                    style: {
                                                        marginTop: "0.35rem"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Timeline level"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Bill line"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Qty"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Unit"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Rate (\u20B9)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "HSN/SAC"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                                            children: subcontractorTimelineRows.map((row)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: row.timelinePhaseTitles[0] || "\u2014"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: row.lineLabel
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                className: "form-control mono",
                                                                                style: {
                                                                                    maxWidth: "5rem"
                                                                                },
                                                                                value: String(row.qty),
                                                                                onChange: (e)=>patchSubcontractorBillLine(row.milestoneTemplateItemId, {
                                                                                        qty: Math.max(0, Number(e.target.value) || 0)
                                                                                    })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                className: "form-control",
                                                                                style: {
                                                                                    maxWidth: "5rem"
                                                                                },
                                                                                value: row.unit,
                                                                                onChange: (e)=>patchSubcontractorBillLine(row.milestoneTemplateItemId, {
                                                                                        unit: e.target.value
                                                                                    })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                className: "form-control mono",
                                                                                style: {
                                                                                    maxWidth: "7rem"
                                                                                },
                                                                                value: String(row.rate),
                                                                                onChange: (e)=>patchSubcontractorBillLine(row.milestoneTemplateItemId, {
                                                                                        rate: Math.max(0, Number(e.target.value) || 0)
                                                                                    })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                className: "form-control mono",
                                                                                style: {
                                                                                    maxWidth: "7rem"
                                                                                },
                                                                                value: row.hsnCode,
                                                                                onChange: (e)=>patchSubcontractorBillLine(row.milestoneTemplateItemId, {
                                                                                        hsnCode: e.target.value.toUpperCase()
                                                                                    })
                                                                            })
                                                                        })
                                                                    ]
                                                                }, row.milestoneTemplateItemId))
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                type: "button",
                                                className: "btn btn--tg-secondary btn--sm",
                                                style: {
                                                    marginTop: "0.75rem"
                                                },
                                                onClick: ()=>setSubcontractorBillLines((prev)=>(0, $34977f436b6dfc5f$export$ac195a4586e1676e)(milestoneTemplates, constructionTimelinePhases, prev)),
                                                children: "Refresh from masters"
                                            })
                                        ]
                                    }) : invoiceTypeTab === "labour" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        style: {
                                            marginBottom: "1.25rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                                className: "form-section-title",
                                                children: "Labour bill lines"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                className: "text-muted",
                                                style: {
                                                    fontSize: "0.88rem",
                                                    marginTop: "-0.35rem"
                                                },
                                                children: [
                                                    "Configure milestone-wise and timeline-wise labour rates separately (same setup as subcontractor). Milestones come from ",
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                                        to: "/milestone-master",
                                                        children: "Milestone master"
                                                    }),
                                                    "; timeline levels from",
                                                    " ",
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                                        to: "/construction-timeline-master",
                                                        children: "Timeline master"
                                                    }),
                                                    ". Bill lines use",
                                                    " ",
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                        children: "Labour Charges"
                                                    }),
                                                    " (e.g. Basement Level 1 \u2014 Labour Charges)."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h4", {
                                                className: "form-section-title",
                                                style: {
                                                    marginTop: "1rem",
                                                    fontSize: "0.95rem"
                                                },
                                                children: "Milestone-wise bill lines"
                                            }),
                                            labourMilestoneRows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                className: "text-muted",
                                                children: "No milestones in master yet."
                                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                style: {
                                                    overflowX: "auto"
                                                },
                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                                    className: "data-table",
                                                    style: {
                                                        marginTop: "0.35rem"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Milestone"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Bill line"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Qty"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Unit"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Rate (\u20B9)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "HSN/SAC"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                                            children: labourMilestoneRows.map((row)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: row.milestoneTitle
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: row.lineLabel
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                className: "form-control mono",
                                                                                style: {
                                                                                    maxWidth: "5rem"
                                                                                },
                                                                                value: String(row.qty),
                                                                                onChange: (e)=>patchLabourBillLine(row.milestoneTemplateItemId, {
                                                                                        qty: Math.max(0, Number(e.target.value) || 0)
                                                                                    })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                className: "form-control",
                                                                                style: {
                                                                                    maxWidth: "5rem"
                                                                                },
                                                                                value: row.unit,
                                                                                onChange: (e)=>patchLabourBillLine(row.milestoneTemplateItemId, {
                                                                                        unit: e.target.value
                                                                                    })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                className: "form-control mono",
                                                                                style: {
                                                                                    maxWidth: "7rem"
                                                                                },
                                                                                value: String(row.rate),
                                                                                onChange: (e)=>patchLabourBillLine(row.milestoneTemplateItemId, {
                                                                                        rate: Math.max(0, Number(e.target.value) || 0)
                                                                                    })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                className: "form-control mono",
                                                                                style: {
                                                                                    maxWidth: "7rem"
                                                                                },
                                                                                value: row.hsnCode,
                                                                                onChange: (e)=>patchLabourBillLine(row.milestoneTemplateItemId, {
                                                                                        hsnCode: e.target.value.toUpperCase()
                                                                                    })
                                                                            })
                                                                        })
                                                                    ]
                                                                }, row.milestoneTemplateItemId))
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h4", {
                                                className: "form-section-title",
                                                style: {
                                                    marginTop: "1.25rem",
                                                    fontSize: "0.95rem"
                                                },
                                                children: "Timeline-wise bill lines"
                                            }),
                                            labourTimelineRows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                className: "text-muted",
                                                children: "No timeline levels in master yet."
                                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                style: {
                                                    overflowX: "auto"
                                                },
                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                                    className: "data-table",
                                                    style: {
                                                        marginTop: "0.35rem"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Timeline level"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Bill line"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Qty"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Unit"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "Rate (\u20B9)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                        children: "HSN/SAC"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                                            children: labourTimelineRows.map((row)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: row.timelinePhaseTitles[0] || "\u2014"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: row.lineLabel
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                className: "form-control mono",
                                                                                style: {
                                                                                    maxWidth: "5rem"
                                                                                },
                                                                                value: String(row.qty),
                                                                                onChange: (e)=>patchLabourBillLine(row.milestoneTemplateItemId, {
                                                                                        qty: Math.max(0, Number(e.target.value) || 0)
                                                                                    })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                className: "form-control",
                                                                                style: {
                                                                                    maxWidth: "5rem"
                                                                                },
                                                                                value: row.unit,
                                                                                onChange: (e)=>patchLabourBillLine(row.milestoneTemplateItemId, {
                                                                                        unit: e.target.value
                                                                                    })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                className: "form-control mono",
                                                                                style: {
                                                                                    maxWidth: "7rem"
                                                                                },
                                                                                value: String(row.rate),
                                                                                onChange: (e)=>patchLabourBillLine(row.milestoneTemplateItemId, {
                                                                                        rate: Math.max(0, Number(e.target.value) || 0)
                                                                                    })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                className: "form-control mono",
                                                                                style: {
                                                                                    maxWidth: "7rem"
                                                                                },
                                                                                value: row.hsnCode,
                                                                                onChange: (e)=>patchLabourBillLine(row.milestoneTemplateItemId, {
                                                                                        hsnCode: e.target.value.toUpperCase()
                                                                                    })
                                                                            })
                                                                        })
                                                                    ]
                                                                }, row.milestoneTemplateItemId))
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "toolbar-row",
                                                style: {
                                                    marginTop: "0.75rem",
                                                    gap: "0.5rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "btn btn--tg-secondary btn--sm",
                                                        onClick: ()=>setLabourBillLines((prev)=>(0, $fe4bf9984635f90b$export$70b883779db5e631)(milestoneTemplates, constructionTimelinePhases, prev, subcontractorBillLines)),
                                                        children: "Refresh from masters"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "btn btn--tg-secondary btn--sm",
                                                        onClick: ()=>setLabourBillLines((prev)=>(0, $fe4bf9984635f90b$export$320c707e0f51d712)(prev, subcontractorBillLines)),
                                                        disabled: !subcontractorBillLines.some((r)=>r.rate > 0),
                                                        children: "Copy rates from subcontractor"
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "inv-outward-issue__grid",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Bill From name"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control",
                                                        value: activeFormat.billFromName,
                                                        onChange: (e)=>patchActiveFormat({
                                                                billFromName: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Bill From address"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                                        className: "form-control",
                                                        rows: 3,
                                                        value: activeFormat.billFromAddress,
                                                        onChange: (e)=>patchActiveFormat({
                                                                billFromAddress: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--r1",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Bill From GSTIN"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control mono",
                                                        value: activeFormat.billFromGstin,
                                                        onChange: (e)=>patchActiveFormat({
                                                                billFromGstin: e.target.value.toUpperCase()
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Bill To name"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control",
                                                        value: activeFormat.billToName,
                                                        onChange: (e)=>patchActiveFormat({
                                                                billToName: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Bill To address"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                                        className: "form-control",
                                                        rows: 3,
                                                        value: activeFormat.billToAddress,
                                                        onChange: (e)=>patchActiveFormat({
                                                                billToAddress: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--r1",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Bill To GSTIN"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control mono",
                                                        value: activeFormat.billToGstin,
                                                        onChange: (e)=>patchActiveFormat({
                                                                billToGstin: e.target.value.toUpperCase()
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Payment terms"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                                        className: "form-control",
                                                        rows: 2,
                                                        value: activeFormat.paymentTerms,
                                                        onChange: (e)=>patchActiveFormat({
                                                                paymentTerms: e.target.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Footer note"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                                        className: "form-control",
                                                        rows: 2,
                                                        value: activeFormat.footerNote,
                                                        onChange: (e)=>patchActiveFormat({
                                                                footerNote: e.target.value
                                                            })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "text-muted",
                                        style: {
                                            display: "flex",
                                            gap: "0.4rem",
                                            alignItems: "center",
                                            marginTop: "0.75rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: activeFormat.aggregateQtyDefault,
                                                onChange: (e)=>patchActiveFormat({
                                                        aggregateQtyDefault: e.target.checked
                                                    })
                                            }),
                                            "Aggregate quantities on PDF main table (beneficiary detail in annexure)"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                style: {
                                    padding: "0 1.5rem 1.5rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("h3", {
                                        className: "form-section-title",
                                        children: [
                                            $772f7392f7d83c73$var$INVOICE_TYPE_TABS.find((t)=>t.id === invoiceTypeTab)?.label,
                                            " \u2014 default GST rows"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "text-muted",
                                        style: {
                                            fontSize: "0.88rem",
                                            marginTop: "-0.35rem"
                                        },
                                        children: "Applied on each invoice download; tax is computed on taxable value (qty \xd7 rate)."
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "0.5rem",
                                            marginBottom: "0.75rem"
                                        },
                                        children: gstRows.map((row)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    gap: "0.5rem",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control",
                                                        style: {
                                                            width: "120px"
                                                        },
                                                        value: row.label,
                                                        onChange: (e)=>setActiveGstRows((rs)=>rs.map((r)=>r.id === row.id ? {
                                                                        ...r,
                                                                        label: e.target.value
                                                                    } : r)),
                                                        "aria-label": "GST label"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control mono",
                                                        style: {
                                                            width: "88px"
                                                        },
                                                        value: row.rateInput,
                                                        onChange: (e)=>setActiveGstRows((rs)=>rs.map((r)=>r.id === row.id ? {
                                                                        ...r,
                                                                        rateInput: e.target.value
                                                                    } : r)),
                                                        "aria-label": "GST percent"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "text-muted",
                                                        style: {
                                                            fontSize: "0.85rem"
                                                        },
                                                        children: "%"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "btn btn--secondary btn--sm",
                                                        onClick: ()=>setActiveGstRows((rs)=>rs.filter((r)=>r.id !== row.id)),
                                                        children: "Remove"
                                                    })
                                                ]
                                            }, row.id))
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--tg-secondary btn--sm",
                                        onClick: ()=>setActiveGstRows((rs)=>[
                                                    ...rs,
                                                    {
                                                        id: `gst-${Date.now()}`,
                                                        label: "IGST",
                                                        rateInput: "18"
                                                    }
                                                ]),
                                        children: "Add GST row"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                style: {
                                    position: "sticky",
                                    bottom: 0,
                                    background: "#fff",
                                    padding: "1rem 1.5rem",
                                    borderTop: "1px solid var(--border)",
                                    marginTop: "auto",
                                    zIndex: 10
                                },
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "toolbar-row",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                            type: "button",
                                            className: "btn btn--primary btn--tg btn--lg",
                                            onClick: handleSave,
                                            children: "Save invoice format"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                            type: "button",
                                            className: "btn btn--tg-secondary btn--lg",
                                            onClick: handleReset,
                                            children: "Reset"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                            className: "btn btn--tg-secondary btn--lg",
                                            to: "/bills/inward",
                                            children: "Invoice register"
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null,
                    activeTab === "preview" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "card card--gov card--elevated",
                        style: {
                            flex: 1,
                            maxWidth: "1200px",
                            margin: 0,
                            padding: 0,
                            overflowX: "auto",
                            overflowY: "hidden",
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                style: {
                                    padding: "1rem",
                                    borderBottom: "1px solid var(--border)",
                                    background: "#f8fafc",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    gap: "0.5rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("h3", {
                                                style: {
                                                    margin: 0,
                                                    fontSize: "1rem",
                                                    color: "var(--text)"
                                                },
                                                children: [
                                                    "Live preview \u2014 ",
                                                    $772f7392f7d83c73$var$INVOICE_TYPE_TABS.find((t)=>t.id === invoiceTypeTab)?.label,
                                                    " invoice"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                className: "text-muted",
                                                style: {
                                                    margin: "0.2rem 0 0",
                                                    fontSize: "0.85rem"
                                                },
                                                children: "Updates instantly with sample lines."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--primary btn--tg btn--sm",
                                        disabled: samplePdfBusy,
                                        onClick: ()=>{
                                            (async ()=>{
                                                setSamplePdfBusy(true);
                                                try {
                                                    await (0, $b2a79528db62cd8d$export$768a1993afbfc55d)((0, $103f1d5fa9f5b81b$export$ff58404e836f6d1f)(draftSettings, invoiceTypeTab, {
                                                        forPdfCapture: true
                                                    }), `INVOICE_SAMPLE_${invoiceTypeTab.toUpperCase()}`, samplePdfDoc.allocations.length > 1 ? {
                                                        annexure: {
                                                            allocations: samplePdfDoc.allocations,
                                                            accentColorHex: samplePdfDoc.accentColorHex,
                                                            footerNote: samplePdfDoc.footerNote
                                                        }
                                                    } : undefined);
                                                    showToast("Sample invoice PDF downloaded.", "success");
                                                } catch (e) {
                                                    showToast(e instanceof Error ? e.message : "Could not create PDF.", "error");
                                                } finally{
                                                    setSamplePdfBusy(false);
                                                }
                                            })();
                                        },
                                        children: samplePdfBusy ? "Creating PDF\u2026" : "Download sample PDF"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("iframe", {
                                srcDoc: previewHtml,
                                style: {
                                    flex: 1,
                                    width: "100%",
                                    minWidth: "800px",
                                    border: "none",
                                    background: "#cbd5e1"
                                },
                                title: "Live invoice preview"
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");




const $fd48466b252a00d6$var$emptyDraft = ()=>({
        contactPersonName: "",
        firmName: "",
        gstNumber: "",
        contactPhone: "",
        contactEmail: "",
        registeredAddress: "",
        bankAccountNumber: "",
        bankIfsc: "",
        bankName: "",
        bankAccountName: ""
    });
function $fd48466b252a00d6$export$f9444343c6dbd5e3() {
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const [draft, setDraft] = (0, $7UyaH.useState)($fd48466b252a00d6$var$emptyDraft);
    const [saving, setSaving] = (0, $7UyaH.useState)(false);
    async function handleSave(e) {
        e.preventDefault();
        if (!draft.firmName.trim() || !draft.contactPersonName.trim()) {
            showToast("Firm name and contact person are required.", "error");
            return;
        }
        setSaving(true);
        try {
            await (0, $ba596e844a9fe971$export$d90a620c7a57ca8)(draft);
            showToast("Labour supplier saved.", "success");
            setDraft($fd48466b252a00d6$var$emptyDraft());
        } catch (err) {
            showToast(err instanceof Error ? err.message : "Could not save labour supplier.", "error");
        } finally{
            setSaving(false);
        }
    }
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Invoice",
                        to: "/bills/inward"
                    },
                    {
                        label: "Labour suppliers"
                    }
                ],
                title: "Labour supplier master",
                subtitle: "Register labour suppliers used on labour invoices.",
                actions: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                    className: "btn btn--tg-secondary btn--sm",
                    to: "/bills/inward",
                    children: "Back to invoices"
                })
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("form", {
                className: "card card--elevated",
                onSubmit: (e)=>void handleSave(e),
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "goods-receipts-filters__grid",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "goods-receipts-filters__field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "goods-receipts-filters__label",
                                        children: "Firm name *"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control",
                                        value: draft.firmName,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    firmName: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "goods-receipts-filters__field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "goods-receipts-filters__label",
                                        children: "Contact person *"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control",
                                        value: draft.contactPersonName,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    contactPersonName: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "goods-receipts-filters__field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "goods-receipts-filters__label",
                                        children: "Phone"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control",
                                        value: draft.contactPhone,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    contactPhone: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "goods-receipts-filters__field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "goods-receipts-filters__label",
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control",
                                        type: "email",
                                        value: draft.contactEmail,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    contactEmail: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "goods-receipts-filters__field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "goods-receipts-filters__label",
                                        children: "GSTIN"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control",
                                        value: draft.gstNumber,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    gstNumber: e.target.value.toUpperCase()
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "goods-receipts-filters__field goods-receipts-filters__field--wide",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "goods-receipts-filters__label",
                                        children: "Registered address"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                        className: "form-control",
                                        rows: 2,
                                        value: draft.registeredAddress,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    registeredAddress: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "goods-receipts-filters__field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "goods-receipts-filters__label",
                                        children: "Bank account name"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control",
                                        value: draft.bankAccountName,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    bankAccountName: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "goods-receipts-filters__field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "goods-receipts-filters__label",
                                        children: "Bank name"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control",
                                        value: draft.bankName,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    bankName: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "goods-receipts-filters__field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "goods-receipts-filters__label",
                                        children: "Account number"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control",
                                        value: draft.bankAccountNumber,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    bankAccountNumber: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "goods-receipts-filters__field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "goods-receipts-filters__label",
                                        children: "IFSC"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        className: "form-control",
                                        value: draft.bankIfsc,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    bankIfsc: e.target.value.toUpperCase()
                                                }))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "inv-outward-issue__actions",
                        style: {
                            marginTop: "1rem"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "submit",
                            className: "btn btn--primary btn--tg",
                            disabled: saving,
                            children: saving ? "Saving\u2026" : "Save labour supplier"
                        })
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");











function $51c57f3e5aa6a385$export$d6b86fbd35e4a8a4(app, zone) {
    const appDk = (0, $72c1e8625e9e63b5$export$768d2fc1615cd5ac)(app.district);
    if (appDk && zone.districtKeys.includes(appDk)) return true;
    const m = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(app.mandal);
    const v = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(app.village);
    if (zone.mandalRefs.some((r)=>{
        const refDk = (0, $72c1e8625e9e63b5$export$768d2fc1615cd5ac)(r.district);
        return refDk === appDk && (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(r.mandalName) === m;
    })) return true;
    return zone.villageRefs.some((r)=>{
        const refDk = (0, $72c1e8625e9e63b5$export$768d2fc1615cd5ac)(r.district);
        return refDk === appDk && (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(r.mandalName) === m && (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(r.villageName) === v;
    });
}
function $51c57f3e5aa6a385$export$727dcd1ed8aa5b17(district, mandalName) {
    return `${district}|${(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(mandalName)}`;
}
function $51c57f3e5aa6a385$export$19c0af9de87a0272(district, mandalName, villageName) {
    return `${district}|${(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(mandalName)}|${(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(villageName)}`;
}



const $20fcbacb797c31b5$var$SCOPE_RANK = {
    village: 4,
    mandal: 3,
    district: 2,
    zone: 1
};
function $20fcbacb797c31b5$export$10c96d46689e0b9c(app, store, zones) {
    switch(store.scopeType){
        case "district":
            {
                const dk = (0, $72c1e8625e9e63b5$export$768d2fc1615cd5ac)(app.district);
                return dk != null && store.districtKeys.length > 0 && store.districtKeys.includes(dk);
            }
        case "mandal":
            {
                const m = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(app.mandal);
                const appDk = (0, $72c1e8625e9e63b5$export$768d2fc1615cd5ac)(app.district);
                return store.mandalRefs.some((r)=>(0, $72c1e8625e9e63b5$export$768d2fc1615cd5ac)(r.district) === appDk && (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(r.mandalName) === m);
            }
        case "village":
            {
                const m = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(app.mandal);
                const v = (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(app.village);
                const appDk = (0, $72c1e8625e9e63b5$export$768d2fc1615cd5ac)(app.district);
                return store.villageRefs.some((r)=>(0, $72c1e8625e9e63b5$export$768d2fc1615cd5ac)(r.district) === appDk && (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(r.mandalName) === m && (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(r.villageName) === v);
            }
        case "zone":
            return store.zoneIds.some((zid)=>{
                const z = zones.find((x)=>x.id === zid);
                return z ? (0, $51c57f3e5aa6a385$export$d6b86fbd35e4a8a4)(app, z) : false;
            });
        default:
            return false;
    }
}
function $20fcbacb797c31b5$export$5d182919b70563bb(app, stores, zones) {
    const matches = stores.filter((s)=>$20fcbacb797c31b5$export$10c96d46689e0b9c(app, s, zones));
    if (matches.length === 0) return null;
    matches.sort((a, b)=>{
        const dr = $20fcbacb797c31b5$var$SCOPE_RANK[b.scopeType] - $20fcbacb797c31b5$var$SCOPE_RANK[a.scopeType];
        if (dr !== 0) return dr;
        if (a.sortOrder !== b.sortOrder) return a.sortOrder - b.sortOrder;
        return a.id.localeCompare(b.id);
    });
    return matches[0] ?? null;
}


function $c37c630ddc5233f9$var$formatOutwardWhen(iso) {
    if (!iso) return "\u2014";
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? iso : d.toLocaleString();
}
function $c37c630ddc5233f9$export$1b0fbbf48a13b5ef() {
    const { applications: applications, subcontractorMasters: subcontractorMasters, storeYards: storeYards, geoZones: geoZones } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const sortedYards = (0, $7UyaH.useMemo)(()=>[
            ...storeYards
        ].sort((a, b)=>a.sortOrder - b.sortOrder), [
        storeYards
    ]);
    const sortedMasters = (0, $7UyaH.useMemo)(()=>[
            ...subcontractorMasters
        ].sort((a, b)=>a.firmName.localeCompare(b.firmName)), [
        subcontractorMasters
    ]);
    const [outwardViewMode, setOutwardViewMode] = (0, $7UyaH.useState)("dispatch");
    const [issueStoreYardId, setIssueStoreYardId] = (0, $7UyaH.useState)("");
    const [subcontractorMasterId, setSubcontractorMasterId] = (0, $7UyaH.useState)("");
    const [selectedRowIds, setSelectedRowIds] = (0, $7UyaH.useState)(()=>new Set());
    const [dispatchMode, setDispatchMode] = (0, $7UyaH.useState)("full");
    const [qtyInput, setQtyInput] = (0, $7UyaH.useState)("");
    const [outwardBeneficiarySearch, setOutwardBeneficiarySearch] = (0, $7UyaH.useState)("");
    const [outwardDistrictFilter, setOutwardDistrictFilter] = (0, $7UyaH.useState)("all");
    const [outwardMandalFilter, setOutwardMandalFilter] = (0, $7UyaH.useState)("all");
    const [outwardVillageFilter, setOutwardVillageFilter] = (0, $7UyaH.useState)("all");
    const [pendingRows, setPendingRows] = (0, $7UyaH.useState)([]);
    const [pendingLoading, setPendingLoading] = (0, $7UyaH.useState)(false);
    const [submitting, setSubmitting] = (0, $7UyaH.useState)(false);
    const [otpModalOpen, setOtpModalOpen] = (0, $7UyaH.useState)(false);
    const [otpSending, setOtpSending] = (0, $7UyaH.useState)(false);
    const [otpConfirming, setOtpConfirming] = (0, $7UyaH.useState)(false);
    const [otpChallengeId, setOtpChallengeId] = (0, $7UyaH.useState)(null);
    const [otpEmailHint, setOtpEmailHint] = (0, $7UyaH.useState)("");
    const [otpInput, setOtpInput] = (0, $7UyaH.useState)("");
    const [otpInlineError, setOtpInlineError] = (0, $7UyaH.useState)(null);
    const otpPayloadRef = (0, $7UyaH.useRef)(null);
    const [registerRows, setRegisterRows] = (0, $7UyaH.useState)([]);
    const [registerLoading, setRegisterLoading] = (0, $7UyaH.useState)(true);
    const [registerError, setRegisterError] = (0, $7UyaH.useState)(null);
    const [listStoreYardId, setListStoreYardId] = (0, $7UyaH.useState)("");
    const [listSubcontractorId, setListSubcontractorId] = (0, $7UyaH.useState)("");
    const [listSearch, setListSearch] = (0, $7UyaH.useState)("");
    const [listSort, setListSort] = (0, $7UyaH.useState)("desc");
    const allEligibleBeneficiaries = (0, $7UyaH.useMemo)(()=>{
        const sid = subcontractorMasterId.trim();
        if (!sid) return [];
        return applications.filter((a)=>{
            const m = (0, $85279307e2bde4bc$export$87d4bc3ee3ec5ea2)(subcontractorMasters, a.subcontractor.subcontractorMasterId);
            return a.subcontractor.subcontractorMasterId === sid && (0, $85279307e2bde4bc$export$148e14a666d94fa1)(a.subcontractor, m);
        }).sort((a, b)=>a.mobile.beneficiaryName.localeCompare(b.mobile.beneficiaryName));
    }, [
        applications,
        subcontractorMasters,
        subcontractorMasterId
    ]);
    const beneficiaryOptions = (0, $7UyaH.useMemo)(()=>{
        if (!subcontractorMasterId.trim()) return [];
        const presentAppIds = new Set(pendingRows.map((r)=>r.applicationId));
        return allEligibleBeneficiaries.filter((a)=>presentAppIds.has(a.id));
    }, [
        allEligibleBeneficiaries,
        pendingRows,
        subcontractorMasterId
    ]);
    const eligibleAppMap = (0, $7UyaH.useMemo)(()=>{
        const m = new Map();
        for (const a of allEligibleBeneficiaries)m.set(a.id, a);
        return m;
    }, [
        allEligibleBeneficiaries
    ]);
    const issueRowsForSelection = (0, $7UyaH.useMemo)(()=>{
        const sid = subcontractorMasterId.trim();
        if (!sid) return [];
        const selectedStore = issueStoreYardId ? storeYards.find((y)=>y.id === issueStoreYardId) : null;
        return pendingRows.filter((row)=>{
            if (row.subcontractorMasterId !== sid || row.status === "completed" || row.balanceQty <= 0) return false;
            // If a scoped store yard is selected, only show rows for beneficiaries in its scope
            if (selectedStore) {
                const app = eligibleAppMap.get(row.applicationId);
                if (app && !(0, $20fcbacb797c31b5$export$10c96d46689e0b9c)(app, selectedStore, geoZones)) return false;
            }
            return true;
        });
    }, [
        pendingRows,
        subcontractorMasterId,
        issueStoreYardId,
        storeYards,
        eligibleAppMap,
        geoZones
    ]);
    /** Pending rows after geo + search filters (each row carries its own beneficiary). */ const filteredIssueRows = (0, $7UyaH.useMemo)(()=>{
        const q = outwardBeneficiarySearch.trim().toLowerCase();
        return issueRowsForSelection.filter((row)=>{
            const app = eligibleAppMap.get(row.applicationId);
            if (!app) return false;
            if (outwardDistrictFilter !== "all" && app.district !== outwardDistrictFilter) return false;
            if (outwardMandalFilter !== "all" && app.mandal !== outwardMandalFilter) return false;
            if (outwardVillageFilter !== "all" && app.village !== outwardVillageFilter) return false;
            if (!q) return true;
            const hay = [
                row.beneficiaryName,
                row.beneficiaryMobileApplicationId,
                row.applicationId,
                row.resourceItemLabel,
                row.catalogStandardItemId,
                row.milestoneTitle,
                app.district,
                app.mandal,
                app.village
            ].filter(Boolean).join(" ").toLowerCase();
            return hay.includes(q);
        });
    }, [
        eligibleAppMap,
        issueRowsForSelection,
        outwardBeneficiarySearch,
        outwardDistrictFilter,
        outwardMandalFilter,
        outwardVillageFilter
    ]);
    const materialGroups = (0, $7UyaH.useMemo)(()=>{
        const map = new Map();
        for (const r of filteredIssueRows){
            const key = `${r.milestoneTemplateId}|${r.standardResourceItemId}|${r.balanceQty}|${r.resourceItemUnit}`;
            let g = map.get(key);
            if (!g) {
                g = {
                    key: key,
                    milestoneTemplateId: r.milestoneTemplateId,
                    milestoneTitle: r.milestoneTitle,
                    standardResourceTitle: r.standardResourceTitle,
                    resourceItemLabel: r.resourceItemLabel,
                    resourceItemUnit: r.resourceItemUnit,
                    catalogStandardItemId: r.catalogStandardItemId,
                    balanceQty: r.balanceQty,
                    rows: []
                };
                map.set(key, g);
            }
            g.rows.push(r);
        }
        const out = [
            ...map.values()
        ];
        out.forEach((g)=>g.rows.sort((a, b)=>(a.beneficiaryName ?? "").localeCompare(b.beneficiaryName ?? "")));
        out.sort((a, b)=>a.milestoneTitle.localeCompare(b.milestoneTitle) || a.resourceItemLabel.localeCompare(b.resourceItemLabel) || b.balanceQty - a.balanceQty);
        return out;
    }, [
        filteredIssueRows
    ]);
    const selectedRows = (0, $7UyaH.useMemo)(()=>filteredIssueRows.filter((r)=>selectedRowIds.has(r.id)), [
        filteredIssueRows,
        selectedRowIds
    ]);
    const toggleOneRow = (0, $7UyaH.useCallback)((id)=>{
        setSelectedRowIds((prev)=>{
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    }, []);
    const groupSelectionState = (0, $7UyaH.useCallback)((g)=>{
        let on = 0;
        for (const r of g.rows)if (selectedRowIds.has(r.id)) on += 1;
        if (on === 0) return false;
        if (on === g.rows.length) return true;
        return "indeterminate";
    }, [
        selectedRowIds
    ]);
    const toggleWholeGroup = (0, $7UyaH.useCallback)((g)=>{
        setSelectedRowIds((prev)=>{
            const next = new Set(prev);
            const allOn = g.rows.every((r)=>next.has(r.id));
            if (allOn) g.rows.forEach((r)=>next.delete(r.id));
            else g.rows.forEach((r)=>next.add(r.id));
            return next;
        });
    }, []);
    const outwardDistrictOptions = (0, $7UyaH.useMemo)(()=>{
        const list = [
            ...new Set(beneficiaryOptions.map((a)=>String(a.district ?? "").trim()).filter(Boolean))
        ];
        list.sort((a, b)=>a.localeCompare(b));
        return list;
    }, [
        beneficiaryOptions
    ]);
    const outwardMandalOptions = (0, $7UyaH.useMemo)(()=>{
        const list = beneficiaryOptions.filter((a)=>outwardDistrictFilter === "all" || a.district === outwardDistrictFilter).map((a)=>String(a.mandal ?? "").trim()).filter(Boolean);
        return [
            ...new Set(list)
        ].sort((a, b)=>a.localeCompare(b));
    }, [
        beneficiaryOptions,
        outwardDistrictFilter
    ]);
    const outwardVillageOptions = (0, $7UyaH.useMemo)(()=>{
        const list = beneficiaryOptions.filter((a)=>outwardDistrictFilter === "all" || a.district === outwardDistrictFilter).filter((a)=>outwardMandalFilter === "all" || a.mandal === outwardMandalFilter).map((a)=>String(a.village ?? "").trim()).filter(Boolean);
        return [
            ...new Set(list)
        ].sort((a, b)=>a.localeCompare(b));
    }, [
        beneficiaryOptions,
        outwardDistrictFilter,
        outwardMandalFilter
    ]);
    const filteredOutwardBeneficiaries = (0, $7UyaH.useMemo)(()=>{
        const q = outwardBeneficiarySearch.trim().toLowerCase();
        return beneficiaryOptions.filter((a)=>{
            if (outwardDistrictFilter !== "all" && a.district !== outwardDistrictFilter) return false;
            if (outwardMandalFilter !== "all" && a.mandal !== outwardMandalFilter) return false;
            if (outwardVillageFilter !== "all" && a.village !== outwardVillageFilter) return false;
            if (!q) return true;
            const hay = [
                a.mobile.beneficiaryName,
                a.mobile.applicationId,
                a.district,
                a.mandal,
                a.village
            ].join(" ").toLowerCase();
            return hay.includes(q);
        });
    }, [
        beneficiaryOptions,
        outwardBeneficiarySearch,
        outwardDistrictFilter,
        outwardMandalFilter,
        outwardVillageFilter
    ]);
    const outwardStoreYardSelectOptions = (0, $7UyaH.useMemo)(()=>[
            {
                value: "",
                label: "Select\u2026"
            },
            ...sortedYards.map((y)=>({
                    value: y.id,
                    label: y.name
                }))
        ], [
        sortedYards
    ]);
    const outwardSubcontractorSelectOptions = (0, $7UyaH.useMemo)(()=>[
            {
                value: "",
                label: "Select\u2026"
            },
            ...sortedMasters.map((m)=>({
                    value: m.id,
                    label: m.firmName.trim() || m.id
                }))
        ], [
        sortedMasters
    ]);
    const outwardDistrictSelectOptions = (0, $7UyaH.useMemo)(()=>[
            {
                value: "all",
                label: "All districts"
            },
            ...outwardDistrictOptions.map((d)=>({
                    value: d,
                    label: d
                }))
        ], [
        outwardDistrictOptions
    ]);
    const outwardMandalSelectOptions = (0, $7UyaH.useMemo)(()=>[
            {
                value: "all",
                label: "All mandals"
            },
            ...outwardMandalOptions.map((m)=>({
                    value: m,
                    label: m
                }))
        ], [
        outwardMandalOptions
    ]);
    const outwardVillageSelectOptions = (0, $7UyaH.useMemo)(()=>[
            {
                value: "all",
                label: "All villages"
            },
            ...outwardVillageOptions.map((v)=>({
                    value: v,
                    label: v
                }))
        ], [
        outwardVillageOptions
    ]);
    const outwardDispatchModeOptions = (0, $7UyaH.useMemo)(()=>[
            {
                value: "full",
                label: "Full balance"
            },
            {
                value: "partial",
                label: "Partial qty (single row)"
            }
        ], []);
    /** Partial dispatch is only meaningful when a single row is selected — otherwise force "full". */ const partialAllowed = selectedRows.length === 1;
    (0, $7UyaH.useEffect)(()=>{
        let cancelled = false;
        setPendingLoading(true);
        (0, $f5510818538731b9$export$3e57dfaa18cba007)({
            limit: 2000,
            subcontractorMasterId: subcontractorMasterId.trim() || undefined
        }).then((list)=>{
            if (!cancelled) setPendingRows(list);
        }).catch(()=>{
            if (!cancelled) setPendingRows([]);
        }).finally(()=>{
            if (!cancelled) setPendingLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        subcontractorMasterId
    ]);
    const loadRegister = (0, $7UyaH.useCallback)(async ()=>{
        setRegisterLoading(true);
        setRegisterError(null);
        try {
            const list = await (0, $f5510818538731b9$export$36d59bdb7dee965)({
                limit: 800,
                storeYardId: listStoreYardId.trim() || undefined,
                subcontractorMasterId: listSubcontractorId.trim() || undefined,
                search: listSearch.trim() || undefined,
                sort: listSort
            });
            setRegisterRows(list);
        } catch (e) {
            setRegisterError(e instanceof Error ? e.message : String(e));
            setRegisterRows([]);
        } finally{
            setRegisterLoading(false);
        }
    }, [
        listStoreYardId,
        listSubcontractorId,
        listSearch,
        listSort
    ]);
    (0, $7UyaH.useEffect)(()=>{
        loadRegister();
    }, [
        loadRegister
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!issueStoreYardId && sortedYards[0]?.id) setIssueStoreYardId(sortedYards[0].id);
    }, [
        issueStoreYardId,
        sortedYards
    ]);
    (0, $7UyaH.useEffect)(()=>{
        setSelectedRowIds(new Set());
        setOutwardBeneficiarySearch("");
        setOutwardDistrictFilter("all");
        setOutwardMandalFilter("all");
        setOutwardVillageFilter("all");
    }, [
        subcontractorMasterId
    ]);
    (0, $7UyaH.useEffect)(()=>{
        setOutwardMandalFilter("all");
        setOutwardVillageFilter("all");
    }, [
        outwardDistrictFilter
    ]);
    (0, $7UyaH.useEffect)(()=>{
        setOutwardVillageFilter("all");
    }, [
        outwardMandalFilter
    ]);
    /** Drop selected ids that no longer match filters or no longer have a balance. */ (0, $7UyaH.useEffect)(()=>{
        const valid = new Set(filteredIssueRows.map((r)=>r.id));
        setSelectedRowIds((prev)=>{
            let changed = false;
            const next = new Set();
            for (const id of prev)if (valid.has(id)) next.add(id);
            else changed = true;
            return changed ? next : prev;
        });
    }, [
        filteredIssueRows
    ]);
    (0, $7UyaH.useEffect)(()=>{
        setDispatchMode("full");
        setQtyInput("");
    }, [
        issueStoreYardId,
        subcontractorMasterId
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (dispatchMode === "full") setQtyInput("");
    }, [
        dispatchMode
    ]);
    /** Force "full" mode whenever 0 or 2+ rows are selected — partial only meaningful for one row. */ (0, $7UyaH.useEffect)(()=>{
        if (!partialAllowed && dispatchMode === "partial") setDispatchMode("full");
    }, [
        partialAllowed,
        dispatchMode
    ]);
    const sendOtpChallenge = (0, $7UyaH.useCallback)(async ()=>{
        const payload = otpPayloadRef.current;
        if (!payload) {
            setOtpInlineError("Nothing to send. Close this dialog and start again.");
            return;
        }
        setOtpSending(true);
        setOtpInlineError(null);
        setOtpChallengeId(null);
        setOtpEmailHint("");
        setOtpInput("");
        try {
            const r = await (0, $f5510818538731b9$export$18d330c1cfaace8d)(payload);
            setOtpChallengeId(r.challengeId);
            setOtpEmailHint(r.emailHint);
        } catch (e) {
            setOtpInlineError(e instanceof Error ? e.message : String(e));
        } finally{
            setOtpSending(false);
        }
    }, []);
    const closeOtpModal = (0, $7UyaH.useCallback)(()=>{
        if (otpConfirming) return;
        setOtpModalOpen(false);
        otpPayloadRef.current = null;
        setOtpChallengeId(null);
        setOtpEmailHint("");
        setOtpInput("");
        setOtpInlineError(null);
        setOtpSending(false);
    }, [
        otpConfirming
    ]);
    const validateOutwardDispatchPayload = ()=>{
        if (!issueStoreYardId.trim()) return {
            error: "Select a store / yard."
        };
        if (!subcontractorMasterId.trim()) return {
            error: "Select the subcontractor receiving stock for the beneficiary."
        };
        if (selectedRows.length === 0) return {
            error: "Select at least one beneficiary row to dispatch."
        };
        const yard = sortedYards.find((y)=>y.id === issueStoreYardId.trim());
        const sid = subcontractorMasterId.trim();
        let partialQty = 0;
        if (dispatchMode === "partial") {
            if (selectedRows.length !== 1) return {
                error: "Partial qty is only allowed when exactly one row is selected."
            };
            partialQty = (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(qtyInput);
            if (!(partialQty > 0)) return {
                error: "Enter a partial quantity greater than zero."
            };
            const onlyRow = selectedRows[0];
            if (partialQty > onlyRow.balanceQty) return {
                error: `Quantity cannot exceed balance (${onlyRow.balanceQty}).`
            };
        }
        for (const r of selectedRows){
            if (r.status === "completed" || r.balanceQty <= 0) return {
                error: `Material issue for "${r.resourceItemLabel}" (${r.beneficiaryName ?? r.applicationId}) is already completed.`
            };
            const app = applications.find((a)=>a.id === r.applicationId);
            if (!app) return {
                error: `Beneficiary not found for row ${r.id}.`
            };
            if (app.subcontractor.subcontractorMasterId !== sid) return {
                error: `Beneficiary "${r.beneficiaryName ?? r.applicationId}" is not linked to this subcontractor.`
            };
        }
        const plans = selectedRows.map((r)=>dispatchMode === "partial" ? {
                issueId: r.id,
                mode: "partial",
                qty: partialQty
            } : {
                issueId: r.id,
                mode: "full"
            });
        return {
            ok: true,
            payload: {
                subcontractorMasterId: sid,
                storeYardId: issueStoreYardId.trim(),
                storeYardName: yard?.name,
                plans: plans
            }
        };
    };
    const beginOutwardOtpFlow = async ()=>{
        const v = validateOutwardDispatchPayload();
        if ("error" in v) {
            showToast(v.error, "error");
            return;
        }
        otpPayloadRef.current = v.payload;
        setOtpModalOpen(true);
        setOtpChallengeId(null);
        setOtpEmailHint("");
        setOtpInput("");
        setOtpInlineError(null);
        await sendOtpChallenge();
    };
    const confirmOtpAndDispatch = async ()=>{
        const digits = otpInput.replace(/\D/g, "").trim();
        if (digits.length !== 6) {
            setOtpInlineError("Enter the 6-digit OTP sent to the subcontractor\u2019s email.");
            return;
        }
        if (!otpChallengeId) {
            setOtpInlineError("No active OTP. Use \u201CResend code\u201D or close and try again.");
            return;
        }
        const sid = otpPayloadRef.current?.subcontractorMasterId ?? subcontractorMasterId.trim();
        setOtpConfirming(true);
        setOtpInlineError(null);
        setSubmitting(true);
        try {
            const res = await (0, $f5510818538731b9$export$87339d226f8794b1)({
                challengeId: otpChallengeId,
                otp: digits
            });
            showToast(`Outward dispatch recorded for ${res.dispatched} row(s).`, "success");
            setOtpModalOpen(false);
            otpPayloadRef.current = null;
            setOtpChallengeId(null);
            setOtpEmailHint("");
            setOtpInput("");
            setSelectedRowIds(new Set());
            setQtyInput("");
            setDispatchMode("full");
            await loadRegister();
            const refreshedPending = await (0, $f5510818538731b9$export$3e57dfaa18cba007)({
                limit: 2000,
                subcontractorMasterId: sid || undefined
            });
            setPendingRows(refreshedPending);
        } catch (e) {
            setOtpInlineError(e instanceof Error ? e.message : String(e));
        } finally{
            setOtpConfirming(false);
            setSubmitting(false);
        }
    };
    const submitIssue = async ()=>{
        await beginOutwardOtpFlow();
    };
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Inventory",
                        to: "/inventory/inward"
                    },
                    {
                        label: outwardViewMode === "register" ? "Outward Register" : "Outward"
                    }
                ],
                title: outwardViewMode === "register" ? "Inventory \u2014 Outward Register" : "Inventory \u2014 Outward"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "issue-mode-toggle-wrap",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "issue-mode-toggle",
                    role: "tablist",
                    "aria-label": "Outward mode",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            role: "tab",
                            "aria-selected": outwardViewMode === "dispatch",
                            className: `issue-mode-toggle__btn ${outwardViewMode === "dispatch" ? "is-active" : ""}`,
                            onClick: ()=>setOutwardViewMode("dispatch"),
                            children: "Outward"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            role: "tab",
                            "aria-selected": outwardViewMode === "register",
                            className: `issue-mode-toggle__btn ${outwardViewMode === "register" ? "is-active" : ""}`,
                            onClick: ()=>setOutwardViewMode("register"),
                            children: "Outward Register"
                        })
                    ]
                })
            }),
            outwardViewMode === "dispatch" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                style: {
                    marginBottom: "1.25rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "section-lead section-lead--tight text-muted",
                        style: {
                            marginTop: 0
                        },
                        children: [
                            "Dispatch only from beneficiary-wise rows created in ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Issue Material Register"
                            }),
                            ". Choose store, subcontractor, beneficiary, then the pending issued line.",
                            " ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/inventory/issue-material",
                                children: "Issue material register"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/inventory/store-stocks",
                                children: "Store stocks"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/subcontractor-to-beneficiary",
                                children: "Subcontractor \u2192 beneficiary"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "inv-outward-issue",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                className: "form-section-title",
                                children: "Dispatch issued material to site"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                className: "text-muted",
                                style: {
                                    marginTop: "-0.35rem",
                                    marginBottom: "0.75rem",
                                    fontSize: "0.88rem"
                                },
                                children: [
                                    "Step 1: Choose store, subcontractor and beneficiary ",
                                    "->",
                                    " Step 2: Pick the pending issue row ",
                                    "->",
                                    "Step 3: Select dispatch mode and quantity ",
                                    "->",
                                    " Record dispatch."
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "inv-outward-issue__grid",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "inv-outward-issue__field inv-outward-issue__field--r1",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "inv-outward-issue__label",
                                                children: "Step 1 \u2014 Store / yard"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                id: "outward-store-yard",
                                                value: issueStoreYardId,
                                                onChange: setIssueStoreYardId,
                                                options: outwardStoreYardSelectOptions,
                                                placeholder: "Select\u2026"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "inv-outward-issue__field inv-outward-issue__field--r1",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "inv-outward-issue__label",
                                                children: "Step 1 \u2014 Subcontractor"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                id: "outward-subcontractor",
                                                value: subcontractorMasterId,
                                                onChange: setSubcontractorMasterId,
                                                options: outwardSubcontractorSelectOptions,
                                                placeholder: "Select\u2026"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "inv-outward-issue__field inv-outward-issue__field--full",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "inv-outward-issue__label",
                                                children: "Step 1 \u2014 Beneficiary filters"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "goods-receipts-filters__grid",
                                                style: {
                                                    marginBottom: "0.5rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                        className: "goods-receipts-filters__field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                className: "goods-receipts-filters__label",
                                                                children: "Search"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                type: "search",
                                                                className: "form-control",
                                                                value: outwardBeneficiarySearch,
                                                                onChange: (e)=>setOutwardBeneficiarySearch(e.target.value),
                                                                placeholder: "Beneficiary name / application id",
                                                                disabled: !subcontractorMasterId.trim()
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                        className: "goods-receipts-filters__field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                className: "goods-receipts-filters__label",
                                                                children: "District"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                                id: "outward-beneficiary-district",
                                                                value: outwardDistrictFilter,
                                                                onChange: setOutwardDistrictFilter,
                                                                options: outwardDistrictSelectOptions,
                                                                placeholder: "All districts"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                        className: "goods-receipts-filters__field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                className: "goods-receipts-filters__label",
                                                                children: "Mandal"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                                id: "outward-beneficiary-mandal",
                                                                value: outwardMandalFilter,
                                                                onChange: setOutwardMandalFilter,
                                                                options: outwardMandalSelectOptions,
                                                                placeholder: "All mandals"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                        className: "goods-receipts-filters__field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                className: "goods-receipts-filters__label",
                                                                children: "Village"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                                id: "outward-beneficiary-village",
                                                                value: outwardVillageFilter,
                                                                onChange: setOutwardVillageFilter,
                                                                options: outwardVillageSelectOptions,
                                                                placeholder: "All villages"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                className: "text-muted",
                                                style: {
                                                    margin: 0,
                                                    fontSize: "0.84rem"
                                                },
                                                children: [
                                                    "Showing ",
                                                    filteredOutwardBeneficiaries.length,
                                                    " of ",
                                                    beneficiaryOptions.length,
                                                    " beneficiaries \xb7",
                                                    " ",
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                        children: selectedRows.length
                                                    }),
                                                    " row(s) selected"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "inv-outward-issue__field inv-outward-issue__field--qty",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "inv-outward-issue__label",
                                                children: "Step 3 \u2014 Dispatch mode"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                id: "outward-dispatch-mode",
                                                value: dispatchMode,
                                                onChange: (v)=>setDispatchMode(v === "partial" ? "partial" : "full"),
                                                options: outwardDispatchModeOptions,
                                                placeholder: "Select mode\u2026"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "inv-outward-issue__field inv-outward-issue__field--qty",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "inv-outward-issue__label",
                                                children: "Step 3 \u2014 Quantity"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                type: "text",
                                                inputMode: "decimal",
                                                className: "form-control",
                                                value: qtyInput,
                                                onChange: (e)=>setQtyInput((0, $50736abadf17d9d0$export$73a62fdf13118eb6)(e.target.value)),
                                                placeholder: dispatchMode === "full" ? "Auto (full balance)" : "0",
                                                "aria-label": "Quantity to dispatch",
                                                disabled: dispatchMode === "full"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                className: "form-section-title",
                                style: {
                                    marginTop: "1rem"
                                },
                                children: "Step 2 \u2014 Pending issue rows (tick beneficiaries to dispatch)"
                            }),
                            !subcontractorMasterId.trim() ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                children: "Select a subcontractor above to see pending issue rows."
                            }) : pendingLoading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                children: "Loading pending rows\u2026"
                            }) : materialGroups.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                className: "text-muted",
                                children: [
                                    "No pending issue rows match the current filters. Create rows in",
                                    " ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                        to: "/inventory/issue-material",
                                        children: "Issue material register"
                                    }),
                                    "."
                                ]
                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "inv-outward-batch__table-wrap",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                    className: "data-table inv-outward-grouped-table",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        style: {
                                                            width: "2.5rem"
                                                        },
                                                        "aria-label": "Select"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Beneficiary"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Application ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Milestone"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Item"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Catalog"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Balance"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Unit"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                            children: materialGroups.map((g)=>{
                                                const st = groupSelectionState(g);
                                                return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $7UyaH.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                            className: "inv-outward-grouped-table__group-header",
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        checked: st === true,
                                                                        ref: (el)=>{
                                                                            if (el) el.indeterminate = st === "indeterminate";
                                                                        },
                                                                        onChange: ()=>toggleWholeGroup(g),
                                                                        "aria-label": `Select all beneficiaries for ${g.resourceItemLabel}`
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                                    colSpan: 7,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                                            children: g.resourceItemLabel
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                                            className: "text-muted",
                                                                            children: [
                                                                                " (",
                                                                                g.standardResourceTitle,
                                                                                ")"
                                                                            ]
                                                                        }),
                                                                        " \xb7 ",
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("strong", {
                                                                            children: [
                                                                                g.balanceQty,
                                                                                " ",
                                                                                g.resourceItemUnit
                                                                            ]
                                                                        }),
                                                                        " ",
                                                                        "each \xb7",
                                                                        " ",
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                            className: "text-muted",
                                                                            children: g.milestoneTitle
                                                                        }),
                                                                        " \xb7 ",
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                                            className: "inv-outward-grouped-table__badge",
                                                                            children: [
                                                                                g.rows.length,
                                                                                " beneficiar",
                                                                                g.rows.length === 1 ? "y" : "ies"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        g.rows.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                className: "inv-outward-grouped-table__member",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                            type: "checkbox",
                                                                            checked: selectedRowIds.has(r.id),
                                                                            onChange: ()=>toggleOneRow(r.id),
                                                                            "aria-label": `Select ${r.beneficiaryName ?? r.applicationId}`
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                            className: "table-name",
                                                                            children: r.beneficiaryName ?? "\u2014"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        className: "mono",
                                                                        children: r.beneficiaryMobileApplicationId ?? r.applicationId
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        children: r.milestoneTitle
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        children: r.resourceItemLabel
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        className: "mono",
                                                                        children: r.catalogStandardItemId || "\u2014"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        children: r.balanceQty
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                        children: r.resourceItemUnit
                                                                    })
                                                                ]
                                                            }, r.id))
                                                    ]
                                                }, g.key);
                                            })
                                        })
                                    ]
                                })
                            }),
                            selectedRows.length === 1 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                className: "inv-outward-issue__hint",
                                children: [
                                    "Balance for the selected row: ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                        children: selectedRows[0].balanceQty
                                    }),
                                    " ",
                                    selectedRows[0].resourceItemUnit
                                ]
                            }) : selectedRows.length > 1 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                className: "inv-outward-issue__hint",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                        children: selectedRows.length
                                    }),
                                    " rows selected. In ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("em", {
                                        children: "Full balance"
                                    }),
                                    " mode, each row will be dispatched at its own balance qty."
                                ]
                            }) : null,
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "inv-outward-issue__actions",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--primary btn--tg btn--lg",
                                    disabled: submitting || otpSending || otpModalOpen || selectedRows.length === 0,
                                    onClick: ()=>void submitIssue(),
                                    children: otpModalOpen ? otpSending ? "Sending OTP\u2026" : submitting ? "Recording dispatch\u2026" : "Complete OTP in dialog" : submitting ? "Recording dispatch\u2026" : otpSending ? "Sending OTP\u2026" : `Record outward dispatch${selectedRows.length > 0 ? ` (${selectedRows.length})` : ""}`
                                })
                            })
                        ]
                    })
                ]
            }) : null,
            otpModalOpen ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "modal-backdrop",
                role: "presentation",
                onClick: ()=>{
                    if (!otpConfirming) closeOtpModal();
                },
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "modal",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "outward-otp-title",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                            id: "outward-otp-title",
                            style: {
                                marginTop: 0
                            },
                            children: "Subcontractor email verification"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                            className: "text-muted",
                            style: {
                                fontSize: "0.9rem"
                            },
                            children: "A one-time code is emailed to the subcontractor\u2019s registered contact. Enter that code here to record the outward dispatch. The subcontractor must share the code with you."
                        }),
                        otpSending ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                            className: "text-muted",
                            children: "Sending email\u2026"
                        }) : null,
                        otpEmailHint ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                            style: {
                                marginBottom: "0.5rem"
                            },
                            children: [
                                "Code sent to ",
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                    children: otpEmailHint
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                            className: "field field--full",
                            style: {
                                display: "block",
                                marginTop: "0.75rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "field__label",
                                    children: "6-digit OTP"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                    type: "text",
                                    inputMode: "numeric",
                                    autoComplete: "one-time-code",
                                    className: "form-control",
                                    placeholder: "000000",
                                    maxLength: 6,
                                    value: otpInput,
                                    disabled: otpSending || otpConfirming || !otpChallengeId,
                                    onChange: (e)=>setOtpInput(e.target.value.replace(/\D/g, "").slice(0, 6))
                                })
                            ]
                        }),
                        otpInlineError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                            style: {
                                color: "var(--dash-danger, #b91c1c)",
                                fontSize: "0.9rem",
                                marginTop: "0.5rem"
                            },
                            children: otpInlineError
                        }) : null,
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "modal__actions",
                            style: {
                                marginTop: "1rem",
                                flexWrap: "wrap",
                                gap: "0.5rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn",
                                    disabled: otpConfirming,
                                    onClick: closeOtpModal,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--tg-secondary",
                                    disabled: otpSending || otpConfirming,
                                    onClick: ()=>void sendOtpChallenge(),
                                    children: otpChallengeId ? "Resend code" : "Try send again"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--primary",
                                    disabled: otpConfirming || otpSending || !otpChallengeId || otpInput.replace(/\D/g, "").length !== 6,
                                    onClick: ()=>void confirmOtpAndDispatch(),
                                    children: otpConfirming ? "Recording\u2026" : "Verify and dispatch"
                                })
                            ]
                        })
                    ]
                })
            }) : null,
            outwardViewMode === "register" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        style: {
                            marginTop: 0
                        },
                        children: "Outward register"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "section-lead section-lead--tight text-muted",
                        children: [
                            "Each issue shows which ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "subcontractor"
                            }),
                            " received stock and which ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "beneficiary"
                            }),
                            " it was for. Filter by store, firm, or search names / application id."
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "goods-receipts-filters",
                        style: {
                            marginBottom: "1rem"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "goods-receipts-filters__grid",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "goods-receipts-filters__field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "goods-receipts-filters__label",
                                            children: "Store / yard"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                                            className: "form-control",
                                            value: listStoreYardId,
                                            onChange: (e)=>setListStoreYardId(e.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                    value: "",
                                                    children: "All stores / yards"
                                                }),
                                                sortedYards.map((y)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                        value: y.id,
                                                        children: y.name
                                                    }, y.id))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "goods-receipts-filters__field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "goods-receipts-filters__label",
                                            children: "Subcontractor"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                                            className: "form-control",
                                            value: listSubcontractorId,
                                            onChange: (e)=>setListSubcontractorId(e.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                    value: "",
                                                    children: "All firms"
                                                }),
                                                sortedMasters.map((m)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                        value: m.id,
                                                        children: m.firmName.trim() || m.id
                                                    }, m.id))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "goods-receipts-filters__field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "goods-receipts-filters__label",
                                            children: "Search"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                            type: "search",
                                            className: "form-control",
                                            placeholder: "Firm, beneficiary, app id\u2026",
                                            value: listSearch,
                                            onChange: (e)=>setListSearch(e.target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "goods-receipts-filters__field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "goods-receipts-filters__label",
                                            children: "Sort by time"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                                            className: "form-control",
                                            value: listSort,
                                            onChange: (e)=>setListSort(e.target.value === "asc" ? "asc" : "desc"),
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                    value: "desc",
                                                    children: "Newest first"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                    value: "asc",
                                                    children: "Oldest first"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    registerLoading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "Loading\u2026"
                    }) : registerError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        style: {
                            color: "var(--dash-danger, #b91c1c)"
                        },
                        children: registerError
                    }) : registerRows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "No outward issues recorded yet."
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        style: {
                            overflowX: "auto"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                            className: "data-table",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "When"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Store / yard"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Subcontractor"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Beneficiary"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Item"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Unit"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Qty"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Notes"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                    children: registerRows.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "text-muted",
                                                    children: $c37c630ddc5233f9$var$formatOutwardWhen(r.createdAt)
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: r.storeYardName?.trim() || r.storeYardId
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "table-name",
                                                        children: r.subcontractorFirmName
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                            className: "table-name",
                                                            children: r.beneficiaryName ?? "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                            className: "text-muted mono",
                                                            style: {
                                                                fontSize: "0.85em"
                                                            },
                                                            children: r.beneficiaryMobileApplicationId ?? r.applicationId
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: r.resourceItemLabel || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: r.resourceItemUnit || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: r.qty
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "text-muted",
                                                    children: r.notes?.trim() ? r.notes : "\u2014"
                                                })
                                            ]
                                        }, r.id))
                                })
                            ]
                        })
                    })
                ]
            }) : null
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");




const $91f48421ad887d8b$var$DEFAULT_LIMIT = 1500;
const $91f48421ad887d8b$var$emptyApplied = {
    search: "",
    from: "",
    to: "",
    storeYardId: "",
    sort: "desc",
    mrrId: ""
};
function $91f48421ad887d8b$export$f0310cffb7081843() {
    const { storeYards: storeYards } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const sortedYards = (0, $7UyaH.useMemo)(()=>[
            ...storeYards
        ].sort((a, b)=>a.sortOrder - b.sortOrder), [
        storeYards
    ]);
    const [rows, setRows] = (0, $7UyaH.useState)([]);
    const [loading, setLoading] = (0, $7UyaH.useState)(true);
    const [error, setError] = (0, $7UyaH.useState)(null);
    const [expandedId, setExpandedId] = (0, $7UyaH.useState)(null);
    const [draft, setDraft] = (0, $7UyaH.useState)(()=>({
            ...$91f48421ad887d8b$var$emptyApplied
        }));
    const [applied, setApplied] = (0, $7UyaH.useState)(()=>({
            ...$91f48421ad887d8b$var$emptyApplied
        }));
    const load = (0, $7UyaH.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        const q = {
            limit: $91f48421ad887d8b$var$DEFAULT_LIMIT,
            sort: applied.sort
        };
        if (applied.search.trim()) q.search = applied.search.trim();
        if (applied.from.trim()) q.from = applied.from.trim();
        if (applied.to.trim()) q.to = applied.to.trim();
        if (applied.storeYardId.trim()) q.storeYardId = applied.storeYardId.trim();
        const mid = Number.parseInt(applied.mrrId.trim(), 10);
        if (Number.isFinite(mid) && mid > 0) q.mrrId = mid;
        try {
            const list = await (0, $f5510818538731b9$export$c8944828706cd19f)(q);
            setRows(list);
        } catch (e) {
            setError(e instanceof Error ? e.message : String(e));
            setRows([]);
        } finally{
            setLoading(false);
        }
    }, [
        applied
    ]);
    (0, $7UyaH.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const applyFilters = ()=>{
        setApplied({
            ...draft
        });
        setExpandedId(null);
    };
    const clearFilters = ()=>{
        setDraft({
            ...$91f48421ad887d8b$var$emptyApplied
        });
        setApplied({
            ...$91f48421ad887d8b$var$emptyApplied
        });
        setExpandedId(null);
    };
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Inventory",
                        to: "/inventory/inward"
                    },
                    {
                        label: "Goods receipts"
                    }
                ],
                title: "Goods receipts"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "section-lead section-lead--tight text-muted",
                        style: {
                            marginTop: 0
                        },
                        children: [
                            "Records from ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("code", {
                                children: "inventory_mrr_goods_receipt"
                            }),
                            " on operational MySQL.",
                            " ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/inventory/inward",
                                children: "Record inward"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/inventory/store-stocks",
                                children: "Store stocks"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("form", {
                        className: "goods-receipts-filters",
                        onSubmit: (e)=>{
                            e.preventDefault();
                            applyFilters();
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "goods-receipts-filters__grid",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "goods-receipts-filters__field",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "goods-receipts-filters__label",
                                                children: "Search"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                type: "search",
                                                className: "form-control",
                                                placeholder: "Receipt #, MRR #, store, received by, notes\u2026",
                                                value: draft.search,
                                                onChange: (e)=>setDraft((d)=>({
                                                            ...d,
                                                            search: e.target.value
                                                        })),
                                                autoComplete: "off"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "goods-receipts-filters__field",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "goods-receipts-filters__label",
                                                children: "From date"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                type: "date",
                                                className: "form-control",
                                                value: draft.from,
                                                onChange: (e)=>setDraft((d)=>({
                                                            ...d,
                                                            from: e.target.value
                                                        }))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "goods-receipts-filters__field",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "goods-receipts-filters__label",
                                                children: "To date"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                type: "date",
                                                className: "form-control",
                                                value: draft.to,
                                                onChange: (e)=>setDraft((d)=>({
                                                            ...d,
                                                            to: e.target.value
                                                        }))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "goods-receipts-filters__field",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "goods-receipts-filters__label",
                                                children: "Store / yard"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                                                className: "form-control",
                                                value: draft.storeYardId,
                                                onChange: (e)=>setDraft((d)=>({
                                                            ...d,
                                                            storeYardId: e.target.value
                                                        })),
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                        value: "",
                                                        children: "All"
                                                    }),
                                                    sortedYards.map((y)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                            value: y.id,
                                                            children: y.name
                                                        }, y.id))
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "goods-receipts-filters__field",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "goods-receipts-filters__label",
                                                children: "MRR id"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                type: "number",
                                                min: 1,
                                                className: "form-control",
                                                placeholder: "Optional",
                                                value: draft.mrrId,
                                                onChange: (e)=>setDraft((d)=>({
                                                            ...d,
                                                            mrrId: e.target.value
                                                        }))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "goods-receipts-filters__field",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "goods-receipts-filters__label",
                                                children: "Sort by time"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                                                className: "form-control",
                                                value: draft.sort,
                                                onChange: (e)=>setDraft((d)=>({
                                                            ...d,
                                                            sort: e.target.value
                                                        })),
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                        value: "desc",
                                                        children: "Newest first"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                        value: "asc",
                                                        children: "Oldest first"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "goods-receipts-filters__actions",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "submit",
                                        className: "btn btn--primary btn--tg btn--sm",
                                        disabled: loading,
                                        children: "Apply filters"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--tg-secondary btn--sm",
                                        onClick: clearFilters,
                                        disabled: loading,
                                        children: "Clear all"
                                    })
                                ]
                            })
                        ]
                    }),
                    !loading && !error ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "text-muted section-lead section-lead--tight",
                        style: {
                            marginBottom: "0.65rem"
                        },
                        children: [
                            "Showing ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: rows.length
                            }),
                            " receipt",
                            rows.length === 1 ? "" : "s",
                            rows.length >= $91f48421ad887d8b$var$DEFAULT_LIMIT ? ` (limit ${$91f48421ad887d8b$var$DEFAULT_LIMIT} \u{2014} narrow filters for older rows)` : ""
                        ]
                    }) : null,
                    loading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "Loading\u2026"
                    }) : error ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        style: {
                            color: "var(--dash-danger, #b91c1c)"
                        },
                        children: error
                    }) : rows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "No goods receipts match these filters."
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        style: {
                            overflowX: "auto",
                            marginTop: "0.75rem"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                            className: "data-table",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "When"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                title: "Goods receipt number",
                                                children: "Receipt #"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "MRR"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Store / yard"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Items"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Received by"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                    children: rows.map((rec)=>{
                                        const open = expandedId === rec.id;
                                        return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $7UyaH.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: new Date(rec.createdAt).toLocaleString()
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                                children: rec.id
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                                children: rec.mrrNumber
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: rec.storeYardName || rec.storeYardId
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: rec.lineReceipts.length
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: rec.receivedBy || "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "btn btn--link btn--sm",
                                                                onClick: ()=>setExpandedId(open ? null : rec.id),
                                                                children: open ? "Hide items" : "View items"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                open ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                                    className: "goods-receipt-detail-row",
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                        colSpan: 7,
                                                        style: {
                                                            background: "#f8fafc",
                                                            padding: "0.85rem 1rem"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                                                className: "data-table",
                                                                style: {
                                                                    margin: 0
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                                    children: "Item"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                                    children: "Unit"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                                    children: "Qty inward"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                                    children: "Reject qty"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                                                        children: rec.lineReceipts.map((ln, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                                        children: ln.itemName?.trim() ? ln.itemName : "\u2014"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                                        children: ln.itemUnit?.trim() ? ln.itemUnit : "\u2014"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                                        children: ln.qtyReceived
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                                        children: ln.qtyRejected ?? 0
                                                                                    })
                                                                                ]
                                                                            }, `${rec.id}-ln-${i}`))
                                                                    })
                                                                ]
                                                            }),
                                                            rec.notes ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                                className: "text-muted section-lead section-lead--tight",
                                                                style: {
                                                                    marginTop: "0.65rem"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                                        children: "Notes:"
                                                                    }),
                                                                    " ",
                                                                    rec.notes
                                                                ]
                                                            }) : null
                                                        ]
                                                    })
                                                }) : null
                                            ]
                                        }, rec.id);
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");







function $cf08e8e171c31603$var$roundQtyDisplay(n) {
    return Math.round(n * 1000) / 1000;
}
function $cf08e8e171c31603$var$lineKey(catalogStandardItemId, resourceItemLabel) {
    return `${catalogStandardItemId}\t${resourceItemLabel}`;
}
function $cf08e8e171c31603$var$buildAggregatedFromBalance(items) {
    return items.filter((it)=>it.yetToReceive > 0).map((it)=>({
            catalogStandardItemId: it.catalogStandardItemId,
            resourceItemLabel: it.resourceItemLabel,
            resourceItemUnit: it.resourceItemUnit,
            poQty: it.poQty,
            priorReceivedQty: it.receivedQty,
            yetToReceive: it.yetToReceive
        }));
}
function $cf08e8e171c31603$export$ddf50f3f40e659f0() {
    const { storeYards: storeYards, applications: applications, geoZones: geoZones } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const sortedYards = (0, $7UyaH.useMemo)(()=>[
            ...storeYards
        ].sort((a, b)=>a.sortOrder - b.sortOrder), [
        storeYards
    ]);
    const [viewMode, setViewMode] = (0, $7UyaH.useState)("inward");
    // Inward Tab State
    const [poList, setPoList] = (0, $7UyaH.useState)([]);
    const [poLoading, setPoLoading] = (0, $7UyaH.useState)(false);
    const [selectedPoId, setSelectedPoId] = (0, $7UyaH.useState)("");
    const [poItemsLoading, setPoItemsLoading] = (0, $7UyaH.useState)(false);
    const [aggregatedItems, setAggregatedItems] = (0, $7UyaH.useState)([]);
    const [storeYardId, setStoreYardId] = (0, $7UyaH.useState)("");
    const [receivedBy, setReceivedBy] = (0, $7UyaH.useState)("");
    const [notes, setNotes] = (0, $7UyaH.useState)("");
    const [lineQty, setLineQty] = (0, $7UyaH.useState)({});
    const [lineRejectQty, setLineRejectQty] = (0, $7UyaH.useState)({});
    const [submitting, setSubmitting] = (0, $7UyaH.useState)(false);
    // Register Tab State
    const [registerList, setRegisterList] = (0, $7UyaH.useState)([]);
    const [registerLoading, setRegisterLoading] = (0, $7UyaH.useState)(false);
    const [registerError, setRegisterError] = (0, $7UyaH.useState)(null);
    // Load POs with open receipt balance only
    (0, $7UyaH.useEffect)(()=>{
        if (viewMode !== "inward") return;
        let cancelled = false;
        setPoLoading(true);
        Promise.all([
            (0, $f5510818538731b9$export$199cc1209b09073e)({
                limit: 1000,
                sort: "desc"
            }),
            (0, $f5510818538731b9$export$e1c899c5a3ced486)()
        ]).then(([allPos, openPoIds])=>{
            if (cancelled) return;
            const openSet = new Set(openPoIds);
            setPoList(allPos.filter((p)=>openSet.has(p.id)));
        }).catch((err)=>{
            if (!cancelled) showToast(err instanceof Error ? err.message : "Failed to load POs", "error");
        }).finally(()=>{
            if (!cancelled) setPoLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        viewMode,
        showToast
    ]);
    // Load PO receipt balance when a PO is selected
    (0, $7UyaH.useEffect)(()=>{
        if (!selectedPoId) {
            setAggregatedItems([]);
            setLineQty({});
            setLineRejectQty({});
            return;
        }
        let cancelled = false;
        setPoItemsLoading(true);
        const po = poList.find((p)=>p.id === selectedPoId);
        (0, $f5510818538731b9$export$3a64cece2dbaba22)(selectedPoId).then((balance)=>{
            if (cancelled) return;
            if (!balance.hasOpenBalance) {
                showToast("This PO is fully received.", "error");
                setSelectedPoId("");
                return;
            }
            const agg = $cf08e8e171c31603$var$buildAggregatedFromBalance(balance.items);
            setAggregatedItems(agg);
            const qtyMap = {};
            const rejMap = {};
            for (const it of agg){
                const key = $cf08e8e171c31603$var$lineKey(it.catalogStandardItemId, it.resourceItemLabel);
                qtyMap[key] = String($cf08e8e171c31603$var$roundQtyDisplay(it.yetToReceive));
                rejMap[key] = "0";
            }
            setLineQty(qtyMap);
            setLineRejectQty(rejMap);
            if (sortedYards.length > 0) {
                const shipYard = po?.shipToStoreYardId?.trim();
                if (shipYard && sortedYards.some((y)=>y.id === shipYard)) setStoreYardId(shipYard);
                else {
                    const appId = po?.shipToApplicationId?.trim();
                    const app = appId ? applications.find((a)=>a.id === appId) : null;
                    const resolved = app ? (0, $20fcbacb797c31b5$export$5d182919b70563bb)(app, sortedYards, geoZones) : null;
                    setStoreYardId(resolved?.id ?? sortedYards[0].id);
                }
            }
        }).catch((err)=>{
            if (!cancelled) showToast(err instanceof Error ? err.message : "Failed to load PO balance", "error");
        }).finally(()=>{
            if (!cancelled) setPoItemsLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        selectedPoId,
        poList,
        showToast,
        sortedYards,
        applications,
        geoZones
    ]);
    // Load Register
    const loadRegister = (0, $7UyaH.useCallback)(async ()=>{
        setRegisterLoading(true);
        setRegisterError(null);
        try {
            const data = await (0, $f5510818538731b9$export$4661dba8bff6ca9)({
                limit: 1000,
                sort: "desc"
            });
            setRegisterList(data);
        } catch (e) {
            setRegisterError(e instanceof Error ? e.message : String(e));
            setRegisterList([]);
        } finally{
            setRegisterLoading(false);
        }
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        if (viewMode === "register") loadRegister();
    }, [
        viewMode,
        loadRegister
    ]);
    const selectedPo = (0, $7UyaH.useMemo)(()=>poList.find((p)=>p.id === selectedPoId), [
        poList,
        selectedPoId
    ]);
    const poSelectOptions = (0, $7UyaH.useMemo)(()=>[
            {
                value: "",
                label: poLoading ? "Loading POs..." : poList.length === 0 ? "No POs with pending quantity" : "Select PO\u2026"
            },
            ...poList.map((p)=>({
                    value: p.id,
                    label: `${p.poNumber} \u{2014} ${p.milestoneTitle} \u{2014} ${p.subcontractorFirmName}`
                }))
        ], [
        poList,
        poLoading
    ]);
    const submitReceipt = async ()=>{
        if (!selectedPo) return;
        if (!storeYardId.trim()) {
            showToast("Select a store / yard.", "error");
            return;
        }
        const lines = aggregatedItems.map((it)=>{
            const key = $cf08e8e171c31603$var$lineKey(it.catalogStandardItemId, it.resourceItemLabel);
            const qtyReceived = (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(lineQty[key]);
            const qtyRejected = (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(lineRejectQty[key]);
            return {
                catalogStandardItemId: it.catalogStandardItemId || undefined,
                resourceItemLabel: it.resourceItemLabel,
                resourceItemUnit: it.resourceItemUnit,
                qtyReceived: qtyReceived,
                qtyRejected: qtyRejected,
                yetToReceive: it.yetToReceive
            };
        });
        if (lines.every((l)=>l.qtyReceived <= 0 && l.qtyRejected <= 0)) {
            showToast("Enter at least one received or damaged quantity.", "error");
            return;
        }
        for (const l of lines){
            if (l.qtyRejected > l.qtyReceived + 0.000001) {
                showToast(`Damaged quantity for "${l.resourceItemLabel}" cannot exceed received quantity.`, "error");
                return;
            }
            if (l.qtyReceived > 0 && l.qtyReceived - l.yetToReceive > 0.000001) {
                showToast(`Received quantity for "${l.resourceItemLabel}" exceeds yet to receive (${$cf08e8e171c31603$var$roundQtyDisplay(l.yetToReceive)}).`, "error");
                return;
            }
        }
        setSubmitting(true);
        try {
            const saved = await (0, $f5510818538731b9$export$f3dca58bae5bbc47)({
                poId: selectedPo.id,
                poNumber: selectedPo.poNumber,
                storeYardId: storeYardId.trim(),
                receivedBy: receivedBy.trim() || undefined,
                notes: notes.trim() || undefined,
                lines: lines.map(({ yetToReceive: _y, ...l })=>l)
            });
            showToast(`Inward transaction saved: ${saved.id}`, "success");
            // Reset form
            setSelectedPoId("");
            setReceivedBy("");
            setNotes("");
            setViewMode("register");
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Save failed", "error");
        } finally{
            setSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "inventory-inward-page",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Inventory",
                        to: "/inventory/inward"
                    },
                    {
                        label: "Inward"
                    }
                ],
                title: "Inventory \u2014 Inward"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "issue-mode-toggle-wrap",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "issue-mode-toggle",
                    role: "tablist",
                    "aria-label": "Inward mode",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            role: "tab",
                            "aria-selected": viewMode === "inward",
                            className: `issue-mode-toggle__btn ${viewMode === "inward" ? "is-active" : ""}`,
                            onClick: ()=>setViewMode("inward"),
                            children: "Inward"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            role: "tab",
                            "aria-selected": viewMode === "register",
                            className: `issue-mode-toggle__btn ${viewMode === "register" ? "is-active" : ""}`,
                            onClick: ()=>setViewMode("register"),
                            children: "Inward Register"
                        })
                    ]
                })
            }),
            viewMode === "inward" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "card card--gov card--elevated",
                        style: {
                            marginBottom: "1.25rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                className: "form-section-title",
                                style: {
                                    marginTop: 0
                                },
                                children: "Search Purchase Order"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "searchable-select-field",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                    id: "po-search",
                                    options: poSelectOptions,
                                    value: selectedPoId,
                                    onChange: setSelectedPoId,
                                    placeholder: "Search by PO Number or Subcontractor\u2026"
                                })
                            })
                        ]
                    }),
                    selectedPoId && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "card card--gov card--elevated",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                className: "form-section-title",
                                style: {
                                    marginTop: 0
                                },
                                children: "Inward Form"
                            }),
                            poItemsLoading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                children: "Loading items\u2026"
                            }) : aggregatedItems.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                children: "This PO has no valid items to inward."
                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "goods-receipts-filters__grid",
                                        style: {
                                            marginBottom: "1.5rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "goods-receipts-filters__field",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "goods-receipts-filters__label",
                                                        children: "Store / yard"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("select", {
                                                        className: "form-control",
                                                        value: storeYardId,
                                                        onChange: (e)=>setStoreYardId(e.target.value),
                                                        disabled: sortedYards.length === 0,
                                                        children: sortedYards.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                            value: "",
                                                            children: "No store yards \u2014 configure Stores / yards"
                                                        }) : sortedYards.map((y)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                                value: y.id,
                                                                children: y.name
                                                            }, y.id))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "goods-receipts-filters__field",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "goods-receipts-filters__label",
                                                        children: "Received by (optional)"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control",
                                                        value: receivedBy,
                                                        onChange: (e)=>setReceivedBy(e.target.value),
                                                        placeholder: "Name or user ID"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h4", {
                                        className: "form-section-title inv-receive-modal__table-title",
                                        children: "Item Quantities"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "inv-receive-modal__table-wrap",
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                            className: "data-table",
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                children: "Item"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                children: "Unit"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                children: "PO Qty"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                style: {
                                                                    width: "8rem"
                                                                },
                                                                children: "Received Qty"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                style: {
                                                                    width: "8rem"
                                                                },
                                                                children: "Damaged Qty"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                style: {
                                                                    width: "8rem"
                                                                },
                                                                children: "Yet to Received"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                                    children: aggregatedItems.map((it)=>{
                                                        const key = $cf08e8e171c31603$var$lineKey(it.catalogStandardItemId, it.resourceItemLabel);
                                                        const enteredReceived = (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(lineQty[key] ?? "");
                                                        const remainingYet = Math.max(0, $cf08e8e171c31603$var$roundQtyDisplay(it.yetToReceive - enteredReceived));
                                                        return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    children: it.resourceItemLabel
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    children: it.resourceItemUnit
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    children: $cf08e8e171c31603$var$roundQtyDisplay(it.poQty)
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                        className: "inv-receive-modal__input inv-receive-modal__qty-input",
                                                                        type: "text",
                                                                        inputMode: "decimal",
                                                                        autoComplete: "off",
                                                                        value: lineQty[key] ?? "",
                                                                        onChange: (e)=>setLineQty((prev)=>({
                                                                                    ...prev,
                                                                                    [key]: (0, $50736abadf17d9d0$export$73a62fdf13118eb6)(e.target.value)
                                                                                }))
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                        className: "inv-receive-modal__input inv-receive-modal__qty-input",
                                                                        type: "text",
                                                                        inputMode: "decimal",
                                                                        autoComplete: "off",
                                                                        value: lineRejectQty[key] ?? "",
                                                                        onChange: (e)=>setLineRejectQty((prev)=>({
                                                                                    ...prev,
                                                                                    [key]: (0, $50736abadf17d9d0$export$73a62fdf13118eb6)(e.target.value)
                                                                                }))
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    children: remainingYet
                                                                })
                                                            ]
                                                        }, key);
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "inv-receive-modal__actions",
                                        style: {
                                            marginTop: "1.5rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                type: "button",
                                                className: "btn btn--primary btn--tg",
                                                disabled: submitting || sortedYards.length === 0,
                                                onClick: ()=>void submitReceipt(),
                                                children: submitting ? "Recording\u2026" : "Record Inward"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                type: "button",
                                                className: "btn btn--tg-secondary btn--sm",
                                                onClick: ()=>setSelectedPoId(""),
                                                disabled: submitting,
                                                children: "Cancel"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        style: {
                            marginTop: 0
                        },
                        children: "Inward Register"
                    }),
                    registerLoading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "Loading register\u2026"
                    }) : registerError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        style: {
                            color: "var(--dash-danger, #b91c1c)"
                        },
                        children: registerError
                    }) : registerList.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "No inward transactions found."
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        style: {
                            overflowX: "auto"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                            className: "data-table",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Date"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Receipt #"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "PO #"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Store / Yard"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Item"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                style: {
                                                    textAlign: "right"
                                                },
                                                children: "Received Qty"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                style: {
                                                    textAlign: "right"
                                                },
                                                children: "Damaged Qty"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                    children: registerList.flatMap((r)=>{
                                        const d = new Date(r.createdAt);
                                        const dateStr = Number.isNaN(d.getTime()) ? r.createdAt : d.toLocaleString();
                                        return r.lineReceipts.map((l, idx)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: dateStr
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                            children: r.id
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: r.poNumber
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: r.storeYardName || r.storeYardId
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: l.resourceItemLabel
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                        style: {
                                                            textAlign: "right"
                                                        },
                                                        children: [
                                                            l.qtyReceived,
                                                            " ",
                                                            l.resourceItemUnit
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                        style: {
                                                            textAlign: "right"
                                                        },
                                                        children: [
                                                            l.qtyRejected,
                                                            " ",
                                                            l.resourceItemUnit
                                                        ]
                                                    })
                                                ]
                                            }, `${r.id}-${idx}`));
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");






function $6628e38dabcd836c$var$rowKey(r) {
    return `${r.storeYardId}\u0001${r.catalogStandardItemId}`;
}
function $6628e38dabcd836c$var$parseQty(raw) {
    const t = raw.trim();
    if (t === "") return null;
    const n = Number(t);
    return Number.isFinite(n) ? n : null;
}
function $6628e38dabcd836c$var$escapeCsvCell(v) {
    if (/[",\r\n]/.test(v)) return `"${v.replace(/"/g, '""')}"`;
    return v;
}
function $6628e38dabcd836c$export$90d1add2989dbab8() {
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const { user: user, authRequired: authRequired } = (0, $a4dc0d923ddf5b19$export$1d39dc5b47e56ff0)();
    const { storeYards: storeYards } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const sortedYards = (0, $7UyaH.useMemo)(()=>[
            ...storeYards
        ].sort((a, b)=>a.sortOrder - b.sortOrder), [
        storeYards
    ]);
    const [filterYardId, setFilterYardId] = (0, $7UyaH.useState)("");
    const [itemSearch, setItemSearch] = (0, $7UyaH.useState)("");
    const [rows, setRows] = (0, $7UyaH.useState)([]);
    const [loading, setLoading] = (0, $7UyaH.useState)(true);
    const [error, setError] = (0, $7UyaH.useState)(null);
    const [physicalByRow, setPhysicalByRow] = (0, $7UyaH.useState)({});
    const [remarkByRow, setRemarkByRow] = (0, $7UyaH.useState)({});
    const [reportStamp, setReportStamp] = (0, $7UyaH.useState)(()=>new Date().toLocaleString());
    const [lastSavedAt, setLastSavedAt] = (0, $7UyaH.useState)(null);
    const [saving, setSaving] = (0, $7UyaH.useState)(false);
    (0, $7UyaH.useEffect)(()=>{
        if (!authRequired || user?.role === "superadmin") return;
        const ids = user?.inventoryStoreYardIds;
        if (Array.isArray(ids) && ids.length >= 1 && filterYardId === "") setFilterYardId(ids[0]);
    }, [
        authRequired,
        user?.role,
        user?.inventoryStoreYardIds,
        filterYardId
    ]);
    const filteredRows = (0, $7UyaH.useMemo)(()=>{
        const q = itemSearch.trim().toLowerCase();
        if (!q) return rows;
        return rows.filter((r)=>{
            const name = (r.resourceItemLabel ?? "").toLowerCase();
            const idStr = String(r.catalogStandardItemId);
            return name.includes(q) || idStr.includes(q);
        });
    }, [
        rows,
        itemSearch
    ]);
    const load = (0, $7UyaH.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const list = await (0, $f5510818538731b9$export$684057024fdd9083)(filterYardId.trim() || undefined);
            let worksheet = {
                physicalByRow: {},
                remarkByRow: {},
                savedAt: null
            };
            try {
                worksheet = await (0, $f5510818538731b9$export$8fe1afdbf49dcb49)(filterYardId.trim() || undefined);
            } catch  {
            /* worksheet API optional until server upgraded */ }
            const validKeys = new Set(list.map($6628e38dabcd836c$var$rowKey));
            const phy = {};
            const rem = {};
            for (const [k, v] of Object.entries(worksheet.physicalByRow))if (validKeys.has(k) && typeof v === "string") phy[k] = v;
            for (const [k, v] of Object.entries(worksheet.remarkByRow))if (validKeys.has(k) && typeof v === "string") rem[k] = v;
            setRows(list);
            setPhysicalByRow(phy);
            setRemarkByRow(rem);
            setLastSavedAt(worksheet.savedAt);
            setReportStamp(new Date().toLocaleString());
        } catch (e) {
            setError(e instanceof Error ? e.message : String(e));
            setRows([]);
            setPhysicalByRow({});
            setRemarkByRow({});
            setLastSavedAt(null);
        } finally{
            setLoading(false);
        }
    }, [
        filterYardId
    ]);
    const saveWorksheet = (0, $7UyaH.useCallback)(async ()=>{
        if (rows.length === 0) return;
        const allowed = new Set(rows.map($6628e38dabcd836c$var$rowKey));
        const phy = Object.fromEntries(Object.entries(physicalByRow).filter(([k])=>allowed.has(k)));
        const rem = Object.fromEntries(Object.entries(remarkByRow).filter(([k])=>allowed.has(k)));
        setSaving(true);
        try {
            const out = await (0, $f5510818538731b9$export$baa128ccfbdcbc9f)({
                storeYardId: filterYardId.trim() || undefined,
                physicalByRow: phy,
                remarkByRow: rem
            });
            setLastSavedAt(out.savedAt);
            showToast("Store audit worksheet saved.", "success");
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not save worksheet.", "error");
        } finally{
            setSaving(false);
        }
    }, [
        rows,
        physicalByRow,
        remarkByRow,
        filterYardId,
        showToast
    ]);
    (0, $7UyaH.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const restrictedInvYards = authRequired && user?.role !== "superadmin" ? user?.inventoryStoreYardIds : null;
    const hideAllStoresAuditOption = Array.isArray(restrictedInvYards) && restrictedInvYards.length >= 1;
    const filterLabel = filterYardId.trim() === "" ? "All stores / yards" : sortedYards.find((y)=>y.id === filterYardId)?.name ?? filterYardId;
    const downloadCsv = ()=>{
        const header = [
            "Sl No",
            "Store / yard",
            "Item",
            "Unit",
            "System qty",
            "Physical qty",
            "Variance",
            "Remark"
        ];
        const lines = filteredRows.map((r, i)=>{
            const k = $6628e38dabcd836c$var$rowKey(r);
            const physicalRaw = physicalByRow[k] ?? "";
            const physicalNum = $6628e38dabcd836c$var$parseQty(physicalRaw);
            const variance = physicalNum === null ? "" : String(Math.round((physicalNum - r.currentStock) * 1000) / 1000);
            return [
                String(i + 1),
                r.storeYardName || r.storeYardId,
                r.resourceItemLabel || "",
                r.resourceItemUnit || "",
                String(r.currentStock),
                physicalRaw.trim(),
                variance,
                remarkByRow[k] ?? ""
            ].map((c)=>$6628e38dabcd836c$var$escapeCsvCell(String(c))).join(",");
        });
        const titleLine = $6628e38dabcd836c$var$escapeCsvCell(`Store audit \u{2014} ${filterLabel} \u{2014} ${new Date().toISOString().slice(0, 10)}`);
        const csv = `\uFEFF${titleLine}\n${header.map((h)=>$6628e38dabcd836c$var$escapeCsvCell(h)).join(",")}\n${lines.join("\n")}`;
        const blob = new Blob([
            csv
        ], {
            type: "text/csv;charset=utf-8"
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `store-audit-${new Date().toISOString().slice(0, 10)}.csv`;
        a.click();
        URL.revokeObjectURL(url);
    };
    const clearCounts = ()=>{
        setPhysicalByRow({});
        setRemarkByRow({});
    };
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "store-audit-page-root",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Inventory",
                        to: "/inventory/inward"
                    },
                    {
                        label: "Store audit"
                    }
                ],
                title: "Store audit worksheet"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated store-audit-page",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "section-lead section-lead--tight text-muted store-audit-no-print",
                        style: {
                            marginTop: 0
                        },
                        children: [
                            "System quantities match",
                            " ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/inventory/store-stocks",
                                children: "Store stocks"
                            }),
                            ". Enter counted physical quantities during the audit; variance updates automatically. Use ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Save worksheet"
                            }),
                            " to store counts and remarks on the server (one draft per scope: all yards or the yard you selected). Export CSV or print when ready.",
                            " ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/inventory/goods-receipts",
                                children: "Goods receipts"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/inventory/inward",
                                children: "Inward"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "goods-receipts-filters store-audit-no-print",
                        style: {
                            marginBottom: "1rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "goods-receipts-filters__grid",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "goods-receipts-filters__field",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "goods-receipts-filters__label",
                                                children: "Store / yard"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                                                className: "form-control",
                                                value: filterYardId,
                                                onChange: (e)=>setFilterYardId(e.target.value),
                                                children: [
                                                    !hideAllStoresAuditOption ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                        value: "",
                                                        children: "All stores / yards"
                                                    }) : null,
                                                    sortedYards.map((y)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                            value: y.id,
                                                            children: y.name
                                                        }, y.id))
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "goods-receipts-filters__field",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "goods-receipts-filters__label",
                                                children: "Search item"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                type: "search",
                                                className: "form-control",
                                                placeholder: "Name or item id",
                                                value: itemSearch,
                                                onChange: (e)=>setItemSearch(e.target.value),
                                                autoComplete: "off"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "store-audit-toolbar",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--tg-secondary btn--sm",
                                        onClick: ()=>void load(),
                                        children: "Refresh list"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--tg-secondary btn--sm",
                                        title: "Clears entries on this screen; choose Save worksheet to update the saved draft on the server.",
                                        onClick: clearCounts,
                                        children: "Clear physical & remarks"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--tg-secondary btn--sm",
                                        onClick: downloadCsv,
                                        disabled: filteredRows.length === 0,
                                        children: "Download CSV report"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--primary btn--sm",
                                        disabled: loading || rows.length === 0 || saving,
                                        onClick: ()=>void saveWorksheet(),
                                        children: saving ? "Saving\u2026" : "Save worksheet"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--tg-secondary btn--sm",
                                        onClick: ()=>{
                                            setReportStamp(new Date().toLocaleString());
                                            requestAnimationFrame(()=>window.print());
                                        },
                                        children: "Print report"
                                    })
                                ]
                            })
                        ]
                    }),
                    loading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "Loading\u2026"
                    }) : error ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        style: {
                            color: "var(--dash-danger, #b91c1c)"
                        },
                        children: error
                    }) : rows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "No stock rows yet (record goods receipts from Inward first)."
                    }) : filteredRows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "No items match your search."
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "store-audit-report-wrap",
                        style: {
                            overflowX: "auto"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "store-audit-report-head",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                        className: "store-audit-report-title",
                                        children: "Store audit report"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                        className: "store-audit-report-meta text-muted",
                                        children: [
                                            "Scope: ",
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                children: filterLabel
                                            }),
                                            " \xb7 ",
                                            "Report generated: ",
                                            reportStamp,
                                            lastSavedAt ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                                children: [
                                                    " \xb7 ",
                                                    "Last saved: ",
                                                    new Date(lastSavedAt).toLocaleString()
                                                ]
                                            }) : null,
                                            " \xb7 ",
                                            "Lines: ",
                                            filteredRows.length
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                className: "data-table store-audit-table",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    className: "store-audit-col-sl",
                                                    children: "#"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Store / yard"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Item"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Unit"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "System qty"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Physical qty"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Variance"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Remark"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                        children: filteredRows.map((r, idx)=>{
                                            const k = $6628e38dabcd836c$var$rowKey(r);
                                            const physicalRaw = physicalByRow[k] ?? "";
                                            const physicalNum = $6628e38dabcd836c$var$parseQty(physicalRaw);
                                            const variance = physicalNum === null ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "text-muted",
                                                children: "\u2014"
                                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: physicalNum === r.currentStock ? "" : physicalNum > r.currentStock ? "store-audit-variance--pos" : "store-audit-variance--neg",
                                                children: Math.round((physicalNum - r.currentStock) * 1000) / 1000
                                            });
                                            return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono",
                                                        children: idx + 1
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: r.storeYardName || r.storeYardId
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: r.resourceItemLabel || "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: r.resourceItemUnit || "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono",
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                            children: r.currentStock
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "store-audit-physical-cell",
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                            type: "text",
                                                            className: "form-control store-audit-qty-input",
                                                            inputMode: "decimal",
                                                            "aria-label": `Physical quantity for ${r.resourceItemLabel || r.catalogStandardItemId}`,
                                                            placeholder: "\u2014",
                                                            value: physicalRaw,
                                                            onChange: (e)=>setPhysicalByRow((prev)=>({
                                                                        ...prev,
                                                                        [k]: e.target.value
                                                                    }))
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono",
                                                        children: variance
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "store-audit-remark-cell",
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                            type: "text",
                                                            className: "form-control store-audit-remark-input",
                                                            placeholder: "\u2014",
                                                            value: remarkByRow[k] ?? "",
                                                            onChange: (e)=>setRemarkByRow((prev)=>({
                                                                        ...prev,
                                                                        [k]: e.target.value
                                                                    }))
                                                        })
                                                    })
                                                ]
                                            }, k);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");




function $ffd8d70d6d40ad58$export$b3c652e15547d534() {
    const { storeYards: storeYards } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const sortedYards = (0, $7UyaH.useMemo)(()=>[
            ...storeYards
        ].sort((a, b)=>a.sortOrder - b.sortOrder), [
        storeYards
    ]);
    const [filterYardId, setFilterYardId] = (0, $7UyaH.useState)("");
    const [itemSearch, setItemSearch] = (0, $7UyaH.useState)("");
    const [rows, setRows] = (0, $7UyaH.useState)([]);
    const [loading, setLoading] = (0, $7UyaH.useState)(true);
    const [error, setError] = (0, $7UyaH.useState)(null);
    const filteredRows = (0, $7UyaH.useMemo)(()=>{
        const q = itemSearch.trim().toLowerCase();
        if (!q) return rows;
        return rows.filter((r)=>{
            const name = (r.resourceItemLabel ?? "").toLowerCase();
            const idStr = String(r.catalogStandardItemId);
            return name.includes(q) || idStr.includes(q);
        });
    }, [
        rows,
        itemSearch
    ]);
    const load = (0, $7UyaH.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const list = await (0, $f5510818538731b9$export$684057024fdd9083)(filterYardId.trim() || undefined);
            setRows(list);
        } catch (e) {
            setError(e instanceof Error ? e.message : String(e));
            setRows([]);
        } finally{
            setLoading(false);
        }
    }, [
        filterYardId
    ]);
    (0, $7UyaH.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Inventory",
                        to: "/inventory/inward"
                    },
                    {
                        label: "Store stocks"
                    }
                ],
                title: "Stock by store / yard"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "section-lead section-lead--tight text-muted",
                        style: {
                            marginTop: 0
                        },
                        children: [
                            "Total inward and QC rejects come from goods receipts. Total outward sums the store issue ledger (zero until outward is recorded). Current stock = inward \u2212 reject \u2212 outward (not below zero). Names load from the MRR database when configured.",
                            " ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/inventory/goods-receipts",
                                children: "Goods receipts"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/inventory/inward",
                                children: "Inward"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/inventory/store-audit",
                                children: "Store audit"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "goods-receipts-filters",
                        style: {
                            marginBottom: "1rem"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "goods-receipts-filters__grid",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "goods-receipts-filters__field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "goods-receipts-filters__label",
                                            children: "Filter by store / yard"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                                            className: "form-control",
                                            value: filterYardId,
                                            onChange: (e)=>setFilterYardId(e.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                    value: "",
                                                    children: "All stores / yards"
                                                }),
                                                sortedYards.map((y)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                        value: y.id,
                                                        children: y.name
                                                    }, y.id))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "goods-receipts-filters__field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "goods-receipts-filters__label",
                                            children: "Search item"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                            id: "store-stocks-item-search",
                                            type: "search",
                                            className: "form-control",
                                            placeholder: "Name or item id",
                                            value: itemSearch,
                                            onChange: (e)=>setItemSearch(e.target.value),
                                            autoComplete: "off"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    loading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "Loading\u2026"
                    }) : error ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        style: {
                            color: "var(--dash-danger, #b91c1c)"
                        },
                        children: error
                    }) : rows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "No stock movements recorded yet (save a goods receipt from Inward first)."
                    }) : filteredRows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "No items match your search. Try a different term or clear the search box."
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        style: {
                            overflowX: "auto"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                            className: "data-table",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Store / yard"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Item"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Unit"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Total inward"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Total outward"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Current stock"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                    children: filteredRows.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: r.storeYardName || r.storeYardId
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: r.resourceItemLabel || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: r.resourceItemUnit || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: r.totalInward
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: r.totalOutward > 0 ? r.totalOutward : "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                        children: r.currentStock
                                                    })
                                                })
                                            ]
                                        }, `${r.storeYardId}-${r.catalogStandardItemId}-${r.resourceItemLabel}`))
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");









function $f22caf1cf81c9c4c$var$districtLabel(geoStore, key) {
    return (0, $65d82a3223f822b8$export$1592aa82ad273940)(geoStore, key);
}
const $f22caf1cf81c9c4c$var$SCOPE_OPTIONS = [
    {
        value: "district",
        label: "Whole district(s)"
    },
    {
        value: "mandal",
        label: "Specific mandal(s)"
    },
    {
        value: "village",
        label: "Specific village(s)"
    },
    {
        value: "zone",
        label: "Geographic zone(s) from master"
    }
];
function $f22caf1cf81c9c4c$var$addStoreCoverageValid(scopeType, districtKeys, mandalRefs, villageRefs, zoneIds) {
    switch(scopeType){
        case "district":
            return districtKeys.length > 0;
        case "mandal":
            return mandalRefs.length > 0;
        case "village":
            return villageRefs.length > 0;
        case "zone":
            return zoneIds.length > 0;
        default:
            return false;
    }
}
function $f22caf1cf81c9c4c$var$storeYardCoverageStats(s) {
    switch(s.scopeType){
        case "district":
            return `${s.districtKeys.length} district${s.districtKeys.length === 1 ? "" : "s"}`;
        case "mandal":
            return `${s.mandalRefs.length} mandal${s.mandalRefs.length === 1 ? "" : "s"}`;
        case "village":
            return `${s.villageRefs.length} village${s.villageRefs.length === 1 ? "" : "s"}`;
        case "zone":
            return `${s.zoneIds.length} zone${s.zoneIds.length === 1 ? "" : "s"}`;
        default:
            return "\u2014";
    }
}
function $f22caf1cf81c9c4c$var$StoreYardSummaryCard({ store: s, storeIndex: storeIndex, isActive: isActive, onOpen: onOpen }) {
    const scopeLabel = $f22caf1cf81c9c4c$var$SCOPE_OPTIONS.find((o)=>o.value === s.scopeType)?.label ?? s.scopeType;
    const note = s.notes.trim();
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("button", {
        type: "button",
        className: `milestone-master-picker-card${isActive ? " milestone-master-picker-card--active" : ""}`,
        onClick: onOpen,
        "aria-haspopup": "dialog",
        "aria-expanded": isActive,
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "milestone-master-picker-card__content",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__top",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                            className: "milestone-master-picker-card__phase-badge",
                            children: [
                                "Store ",
                                storeIndex + 1
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__title",
                        children: s.name
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                        className: "milestone-master-picker-card__stats",
                        "aria-label": "Coverage summary",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                children: scopeLabel
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "milestone-master-picker-card__stat-dot",
                                "aria-hidden": true,
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                children: $f22caf1cf81c9c4c$var$storeYardCoverageStats(s)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                className: "milestone-master-picker-card__footer",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                    children: isActive ? "Editor open" : "Click card to edit"
                })
            })
        ]
    });
}
function $f22caf1cf81c9c4c$var$AddStoreYardForm({ geoZones: geoZones, onCreated: onCreated }) {
    const { addStoreYard: addStoreYard, updateStoreYard: updateStoreYard } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const { store: geoStore } = (0, $60dd8507bac67e50$export$5ec0231075ddedf1)();
    const [createName, setCreateName] = (0, $7UyaH.useState)("");
    const [createNotes, setCreateNotes] = (0, $7UyaH.useState)("");
    const [createAddress, setCreateAddress] = (0, $7UyaH.useState)("");
    const [createScopeType, setCreateScopeType] = (0, $7UyaH.useState)("district");
    const [createDistrictKeys, setCreateDistrictKeys] = (0, $7UyaH.useState)([]);
    const [createMandalRefs, setCreateMandalRefs] = (0, $7UyaH.useState)([]);
    const [createVillageRefs, setCreateVillageRefs] = (0, $7UyaH.useState)([]);
    const [createZoneIds, setCreateZoneIds] = (0, $7UyaH.useState)([]);
    const [createDistrictPickKey, setCreateDistrictPickKey] = (0, $7UyaH.useState)("");
    const [mandalDistrict, setMandalDistrict] = (0, $7UyaH.useState)("");
    const [mandalName, setMandalName] = (0, $7UyaH.useState)("");
    const [villageDistrict, setVillageDistrict] = (0, $7UyaH.useState)("");
    const [villageMandal, setVillageMandal] = (0, $7UyaH.useState)("");
    const [villageName, setVillageName] = (0, $7UyaH.useState)("");
    (0, $7UyaH.useEffect)(()=>{
        if (!geoStore) return;
        const first = geoStore.tgRegistrationDistricts()[0]?.districtKey ?? "";
        setMandalDistrict((prev)=>prev || first);
        setVillageDistrict((prev)=>prev || first);
    }, [
        geoStore
    ]);
    const mandalsForPick = (0, $7UyaH.useMemo)(()=>geoStore ? geoStore.tgMandalsForDistrict(mandalDistrict) : [], [
        geoStore,
        mandalDistrict
    ]);
    const villagesForPick = (0, $7UyaH.useMemo)(()=>{
        if (!geoStore || !villageMandal.trim()) return [];
        return geoStore.tgVillagesForMandal(villageDistrict, villageMandal);
    }, [
        geoStore,
        villageDistrict,
        villageMandal
    ]);
    const sortedDistricts = (0, $7UyaH.useMemo)(()=>(0, $65d82a3223f822b8$export$ebb9edc449c9191c)(geoStore), [
        geoStore
    ]);
    const districtPickOptions = sortedDistricts;
    const districtAddPickOptions = (0, $7UyaH.useMemo)(()=>{
        const avail = sortedDistricts.filter((d)=>!createDistrictKeys.includes(d.value));
        return [
            {
                value: "",
                label: "\u2014 Choose district \u2014",
                rowKey: "none"
            },
            ...avail
        ];
    }, [
        sortedDistricts,
        createDistrictKeys
    ]);
    const mandalPickOptions = (0, $7UyaH.useMemo)(()=>{
        const sorted = (0, $65d82a3223f822b8$export$92a1b4b7233300e5)(geoStore, mandalDistrict);
        return [
            {
                value: "",
                label: "\u2014 Choose mandal \u2014",
                rowKey: "none"
            },
            ...sorted
        ];
    }, [
        geoStore,
        mandalDistrict
    ]);
    const villageMandalPickOptions = (0, $7UyaH.useMemo)(()=>{
        const sorted = (0, $65d82a3223f822b8$export$92a1b4b7233300e5)(geoStore, villageDistrict);
        return [
            {
                value: "",
                label: "\u2014 Choose mandal \u2014",
                rowKey: "none"
            },
            ...sorted
        ];
    }, [
        villageDistrict,
        geoStore
    ]);
    const villageNamePickOptions = (0, $7UyaH.useMemo)(()=>{
        const sorted = (0, $65d82a3223f822b8$export$b4f94b88b15ef2d1)(geoStore, villageDistrict, villageMandal);
        return [
            {
                value: "",
                label: "\u2014 Choose village \u2014",
                rowKey: "none"
            },
            ...sorted
        ];
    }, [
        geoStore,
        villageDistrict,
        villageMandal
    ]);
    const sortedZones = (0, $7UyaH.useMemo)(()=>[
            ...geoZones
        ].sort((a, b)=>a.sortOrder - b.sortOrder), [
        geoZones
    ]);
    function resetCreateGeo() {
        setCreateDistrictKeys([]);
        setCreateMandalRefs([]);
        setCreateVillageRefs([]);
        setCreateZoneIds([]);
        setCreateDistrictPickKey("");
        setMandalName("");
        setVillageMandal("");
        setVillageName("");
    }
    function onCreateScopeTypeChange(next) {
        setCreateScopeType(next);
        resetCreateGeo();
    }
    function addCreateMandal() {
        const mn = mandalName.trim();
        if (!mn) return;
        const ref = {
            district: mandalDistrict,
            mandalName: mn
        };
        const k = (0, $51c57f3e5aa6a385$export$727dcd1ed8aa5b17)(ref.district, ref.mandalName);
        setCreateMandalRefs((prev)=>{
            if (prev.some((r)=>(0, $51c57f3e5aa6a385$export$727dcd1ed8aa5b17)(r.district, r.mandalName) === k)) return prev;
            return [
                ...prev,
                ref
            ];
        });
        setMandalName("");
    }
    function removeCreateMandal(ref) {
        setCreateMandalRefs((prev)=>prev.filter((r)=>(0, $51c57f3e5aa6a385$export$727dcd1ed8aa5b17)(r.district, r.mandalName) !== (0, $51c57f3e5aa6a385$export$727dcd1ed8aa5b17)(ref.district, ref.mandalName)));
    }
    function addCreateVillage() {
        const mn = villageMandal.trim();
        const vn = villageName.trim();
        if (!mn || !vn) return;
        const ref = {
            district: villageDistrict,
            mandalName: mn,
            villageName: vn
        };
        const k = (0, $51c57f3e5aa6a385$export$19c0af9de87a0272)(ref.district, ref.mandalName, ref.villageName);
        setCreateVillageRefs((prev)=>{
            if (prev.some((r)=>(0, $51c57f3e5aa6a385$export$19c0af9de87a0272)(r.district, r.mandalName, r.villageName) === k)) return prev;
            return [
                ...prev,
                ref
            ];
        });
        setVillageName("");
    }
    function removeCreateVillage(ref) {
        setCreateVillageRefs((prev)=>prev.filter((r)=>(0, $51c57f3e5aa6a385$export$19c0af9de87a0272)(r.district, r.mandalName, r.villageName) !== (0, $51c57f3e5aa6a385$export$19c0af9de87a0272)(ref.district, ref.mandalName, ref.villageName)));
    }
    function toggleCreateZone(zoneId) {
        setCreateZoneIds((prev)=>prev.includes(zoneId) ? prev.filter((id)=>id !== zoneId) : [
                ...prev,
                zoneId
            ]);
    }
    /** District picked in the dropdown counts toward coverage even before "Add district". */ const effectiveDistrictKeysForCreate = (0, $7UyaH.useMemo)(()=>{
        if (createScopeType !== "district") return createDistrictKeys;
        const k = createDistrictPickKey;
        if (k && !createDistrictKeys.includes(k)) return [
            ...createDistrictKeys,
            k
        ];
        return createDistrictKeys;
    }, [
        createScopeType,
        createDistrictKeys,
        createDistrictPickKey
    ]);
    const coverageOk = $f22caf1cf81c9c4c$var$addStoreCoverageValid(createScopeType, effectiveDistrictKeysForCreate, createMandalRefs, createVillageRefs, createZoneIds);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: "new-sy-name",
                        children: "Name"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                        id: "new-sy-name",
                        value: createName,
                        onChange: (e)=>setCreateName(e.target.value),
                        placeholder: "e.g. District warehouse \u2014 Karimnagar",
                        maxLength: 200
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: "new-sy-notes",
                        children: "Notes (optional)"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                        id: "new-sy-notes",
                        rows: 2,
                        value: createNotes,
                        onChange: (e)=>setCreateNotes(e.target.value),
                        maxLength: 2000
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: "new-sy-address",
                        children: "Shipping address (for PO print)"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                        id: "new-sy-address",
                        rows: 3,
                        value: createAddress,
                        onChange: (e)=>setCreateAddress(e.target.value),
                        placeholder: "Full postal / site address shown on PO when this store is ship-to",
                        maxLength: 4000
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                className: "form-section-title",
                style: {
                    marginTop: "0.5rem"
                },
                children: "Geographic coverage"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "section-lead section-lead--tight text-muted",
                children: "Pick how this depot is tied to location. You can change this later on the store card."
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: "new-sy-scope",
                        children: "Coverage type"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("select", {
                        id: "new-sy-scope",
                        value: createScopeType,
                        onChange: (e)=>onCreateScopeTypeChange(e.target.value),
                        children: $f22caf1cf81c9c4c$var$SCOPE_OPTIONS.map((o)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                value: o.value,
                                children: o.label
                            }, o.value))
                    })
                ]
            }),
            createScopeType === "district" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "section-lead section-lead--tight text-muted",
                        style: {
                            marginTop: "0.85rem"
                        },
                        children: "Add every district this depot covers (multiselect). Choose a district, click Add district, repeat. Remove any row with Remove."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "geo-zones-add-row",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field-inline",
                                style: {
                                    flex: "1 1 14rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: "new-sy-district-pick",
                                        children: "District"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                        id: "new-sy-district-pick",
                                        variant: "dash",
                                        value: createDistrictPickKey,
                                        onChange: (v)=>setCreateDistrictPickKey(v),
                                        options: districtAddPickOptions,
                                        placeholder: "\u2014 Choose district \u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--tg-secondary btn--sm",
                                disabled: !createDistrictPickKey || !createDistrictPickKey || createDistrictKeys.includes(createDistrictPickKey),
                                onClick: ()=>{
                                    const k = createDistrictPickKey;
                                    if (!k || createDistrictKeys.includes(k)) return;
                                    setCreateDistrictKeys((prev)=>[
                                            ...prev,
                                            k
                                        ]);
                                    setCreateDistrictPickKey("");
                                },
                                children: "Add district"
                            })
                        ]
                    }),
                    createDistrictKeys.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                        className: "geo-zones-pill-list",
                        children: [
                            ...createDistrictKeys
                        ].sort((a, b)=>$f22caf1cf81c9c4c$var$districtLabel(geoStore, a).localeCompare($f22caf1cf81c9c4c$var$districtLabel(geoStore, b))).map((key)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                className: "geo-zones-pill-row",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        children: $f22caf1cf81c9c4c$var$districtLabel(geoStore, key)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--link btn--sm",
                                        onClick: ()=>setCreateDistrictKeys((prev)=>prev.filter((x)=>x !== key)),
                                        children: "Remove"
                                    })
                                ]
                            }, key))
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted section-lead section-lead--tight",
                        children: createDistrictPickKey ? `${$f22caf1cf81c9c4c$var$districtLabel(geoStore, createDistrictPickKey)} will be saved when you create. Use Add district if you need several districts.` : "Choose a district above, then create or click Add district to build a list."
                    })
                ]
            }) : null,
            createScopeType === "mandal" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "section-lead section-lead--tight text-muted",
                        style: {
                            marginTop: "0.5rem"
                        },
                        children: "Choose district and mandal, then Add mandal. Repeat for each mandal served."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "geo-zones-add-row",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field-inline",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: "new-sy-mandal-district",
                                        children: "District"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                        id: "new-sy-mandal-district",
                                        variant: "dash",
                                        value: mandalDistrict,
                                        onChange: (v)=>{
                                            if (v) {
                                                setMandalDistrict(v);
                                                setMandalName("");
                                            }
                                        },
                                        options: districtPickOptions,
                                        placeholder: "District"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field-inline",
                                style: {
                                    flex: "1 1 12rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: "new-sy-mandal-name",
                                        children: "Mandal"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                        id: "new-sy-mandal-name",
                                        variant: "dash",
                                        value: mandalName,
                                        onChange: setMandalName,
                                        options: mandalPickOptions,
                                        placeholder: "\u2014 Choose mandal \u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--tg-secondary btn--sm",
                                disabled: !mandalName.trim(),
                                onClick: addCreateMandal,
                                children: "Add mandal"
                            })
                        ]
                    }),
                    createMandalRefs.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                        className: "geo-zones-pill-list",
                        children: createMandalRefs.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                className: "geo-zones-pill-row",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                children: $f22caf1cf81c9c4c$var$districtLabel(geoStore, r.district)
                                            }),
                                            " \u2014 ",
                                            r.mandalName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--link btn--sm",
                                        onClick: ()=>removeCreateMandal(r),
                                        children: "Remove"
                                    })
                                ]
                            }, (0, $51c57f3e5aa6a385$export$727dcd1ed8aa5b17)(r.district, r.mandalName)))
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted section-lead section-lead--tight",
                        children: "Add at least one mandal before creating."
                    })
                ]
            }) : null,
            createScopeType === "village" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "section-lead section-lead--tight text-muted",
                        style: {
                            marginTop: "0.5rem"
                        },
                        children: "Choose district, mandal, and village, then Add village."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "geo-zones-add-row geo-zones-add-row--wrap",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field-inline",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: "new-sy-village-district",
                                        children: "District"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                        id: "new-sy-village-district",
                                        variant: "dash",
                                        value: villageDistrict,
                                        onChange: (v)=>{
                                            if (v) {
                                                setVillageDistrict(v);
                                                setVillageMandal("");
                                                setVillageName("");
                                            }
                                        },
                                        options: districtPickOptions,
                                        placeholder: "District"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field-inline",
                                style: {
                                    flex: "1 1 11rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: "new-sy-village-mandal",
                                        children: "Mandal"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                        id: "new-sy-village-mandal",
                                        variant: "dash",
                                        value: villageMandal,
                                        onChange: (v)=>{
                                            setVillageMandal(v);
                                            setVillageName("");
                                        },
                                        options: villageMandalPickOptions,
                                        placeholder: "\u2014 Choose mandal \u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field-inline",
                                style: {
                                    flex: "1 1 12rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: "new-sy-village-name",
                                        children: "Village"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                        id: "new-sy-village-name",
                                        variant: "dash",
                                        value: villageName,
                                        onChange: setVillageName,
                                        options: villageNamePickOptions,
                                        placeholder: "\u2014 Choose village \u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--tg-secondary btn--sm",
                                disabled: !villageMandal.trim() || !villageName.trim(),
                                onClick: addCreateVillage,
                                children: "Add village"
                            })
                        ]
                    }),
                    createVillageRefs.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                        className: "geo-zones-pill-list",
                        children: createVillageRefs.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                className: "geo-zones-pill-row",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                children: $f22caf1cf81c9c4c$var$districtLabel(geoStore, r.district)
                                            }),
                                            " \u2014 ",
                                            r.mandalName,
                                            " \u2014 ",
                                            r.villageName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--link btn--sm",
                                        onClick: ()=>removeCreateVillage(r),
                                        children: "Remove"
                                    })
                                ]
                            }, (0, $51c57f3e5aa6a385$export$19c0af9de87a0272)(r.district, r.mandalName, r.villageName)))
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted section-lead section-lead--tight",
                        children: "Add at least one village before creating."
                    })
                ]
            }) : null,
            createScopeType === "zone" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "section-lead section-lead--tight text-muted",
                        style: {
                            marginTop: "0.5rem"
                        },
                        children: [
                            "Tick zones from ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/zones",
                                children: "Zones master"
                            }),
                            "."
                        ]
                    }),
                    sortedZones.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "text-muted section-lead section-lead--tight",
                        children: [
                            "No zones yet \u2014 define them under ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/zones",
                                children: "Zones"
                            }),
                            " first."
                        ]
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "geo-zones-district-grid",
                        children: sortedZones.map((z)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "geo-zones-check",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        type: "checkbox",
                                        checked: createZoneIds.includes(z.id),
                                        onChange: ()=>toggleCreateZone(z.id)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        children: z.name
                                    })
                                ]
                            }, z.id))
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                type: "button",
                className: "btn btn--primary btn--tg",
                style: {
                    marginTop: "1rem"
                },
                disabled: !createName.trim() || !coverageOk,
                onClick: ()=>{
                    (async ()=>{
                        if (!$f22caf1cf81c9c4c$var$addStoreCoverageValid(createScopeType, effectiveDistrictKeysForCreate, createMandalRefs, createVillageRefs, createZoneIds)) {
                            showToast("Select at least one district, mandal, village, or zone for the chosen coverage type.", "error");
                            return;
                        }
                        const id = await addStoreYard({
                            name: createName.trim(),
                            notes: createNotes.trim(),
                            address: createAddress.trim()
                        });
                        if (!id) return;
                        await updateStoreYard(id, {
                            scopeType: createScopeType,
                            districtKeys: createScopeType === "district" ? effectiveDistrictKeysForCreate : [],
                            mandalRefs: createScopeType === "mandal" ? createMandalRefs : [],
                            villageRefs: createScopeType === "village" ? createVillageRefs : [],
                            zoneIds: createScopeType === "zone" ? createZoneIds : []
                        });
                        setCreateName("");
                        setCreateNotes("");
                        setCreateAddress("");
                        setCreateScopeType("district");
                        resetCreateGeo();
                        onCreated();
                    })();
                },
                children: "Create store / yard"
            })
        ]
    });
}
function $f22caf1cf81c9c4c$var$StoreYardEditorForm({ store: s, geoZones: geoZones, index: index, total: total, onDeleted: onDeleted }) {
    const { store: geoStore } = (0, $60dd8507bac67e50$export$5ec0231075ddedf1)();
    const { applications: applications, updateStoreYard: updateStoreYard, removeStoreYard: removeStoreYard, moveStoreYard: moveStoreYard } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const [name, setName] = (0, $7UyaH.useState)(s.name);
    const [notes, setNotes] = (0, $7UyaH.useState)(s.notes);
    const [address, setAddress] = (0, $7UyaH.useState)(s.address ?? "");
    (0, $7UyaH.useEffect)(()=>{
        setName(s.name);
        setNotes(s.notes);
        setAddress(s.address ?? "");
    }, [
        s.id,
        s.name,
        s.notes,
        s.address
    ]);
    const matchCount = (0, $7UyaH.useMemo)(()=>applications.filter((a)=>(0, $20fcbacb797c31b5$export$10c96d46689e0b9c)(a, s, geoZones)).length, [
        applications,
        s,
        geoZones
    ]);
    const [mandalDistrict, setMandalDistrict] = (0, $7UyaH.useState)("");
    const [mandalName, setMandalName] = (0, $7UyaH.useState)("");
    const [villageDistrict, setVillageDistrict] = (0, $7UyaH.useState)("");
    const [villageMandal, setVillageMandal] = (0, $7UyaH.useState)("");
    const [villageName, setVillageName] = (0, $7UyaH.useState)("");
    const [districtPickKey, setDistrictPickKey] = (0, $7UyaH.useState)("");
    (0, $7UyaH.useEffect)(()=>{
        if (!geoStore) return;
        const first = geoStore.tgRegistrationDistricts()[0]?.districtKey ?? "";
        setMandalDistrict((prev)=>prev || first);
        setVillageDistrict((prev)=>prev || first);
    }, [
        geoStore
    ]);
    const mandalsForPick = (0, $7UyaH.useMemo)(()=>geoStore ? geoStore.tgMandalsForDistrict(mandalDistrict) : [], [
        geoStore,
        mandalDistrict
    ]);
    const villagesForPick = (0, $7UyaH.useMemo)(()=>{
        if (!geoStore || !villageMandal.trim()) return [];
        return geoStore.tgVillagesForMandal(villageDistrict, villageMandal);
    }, [
        geoStore,
        villageDistrict,
        villageMandal
    ]);
    const sortedDistricts = (0, $7UyaH.useMemo)(()=>(0, $65d82a3223f822b8$export$ebb9edc449c9191c)(geoStore), [
        geoStore
    ]);
    const districtPickOptions = sortedDistricts;
    const districtAddOptions = (0, $7UyaH.useMemo)(()=>{
        const avail = sortedDistricts.filter((d)=>!s.districtKeys.includes(d.value));
        return [
            {
                value: "",
                label: "\u2014 Choose district \u2014",
                rowKey: "none"
            },
            ...avail
        ];
    }, [
        sortedDistricts,
        s.districtKeys
    ]);
    const mandalPickOptions = (0, $7UyaH.useMemo)(()=>{
        const sorted = (0, $65d82a3223f822b8$export$92a1b4b7233300e5)(geoStore, mandalDistrict);
        return [
            {
                value: "",
                label: "\u2014 Choose mandal \u2014",
                rowKey: "none"
            },
            ...sorted
        ];
    }, [
        geoStore,
        mandalDistrict
    ]);
    const villageMandalPickOptions = (0, $7UyaH.useMemo)(()=>{
        const sorted = (0, $65d82a3223f822b8$export$92a1b4b7233300e5)(geoStore, villageDistrict);
        return [
            {
                value: "",
                label: "\u2014 Choose mandal \u2014",
                rowKey: "none"
            },
            ...sorted
        ];
    }, [
        villageDistrict,
        geoStore
    ]);
    const villageNamePickOptions = (0, $7UyaH.useMemo)(()=>{
        const sorted = (0, $65d82a3223f822b8$export$b4f94b88b15ef2d1)(geoStore, villageDistrict, villageMandal);
        return [
            {
                value: "",
                label: "\u2014 Choose village \u2014",
                rowKey: "none"
            },
            ...sorted
        ];
    }, [
        geoStore,
        villageDistrict,
        villageMandal
    ]);
    const sortedZones = (0, $7UyaH.useMemo)(()=>[
            ...geoZones
        ].sort((a, b)=>a.sortOrder - b.sortOrder), [
        geoZones
    ]);
    function addDistrictPick() {
        const k = districtPickKey;
        if (!k || s.districtKeys.includes(k)) return;
        updateStoreYard(s.id, {
            districtKeys: [
                ...s.districtKeys,
                k
            ]
        });
        setDistrictPickKey("");
    }
    function removeDistrictKey(key) {
        updateStoreYard(s.id, {
            districtKeys: s.districtKeys.filter((dk)=>dk !== key)
        });
    }
    function addMandal() {
        const mn = mandalName.trim();
        if (!mn) return;
        const ref = {
            district: mandalDistrict,
            mandalName: mn
        };
        const k = (0, $51c57f3e5aa6a385$export$727dcd1ed8aa5b17)(ref.district, ref.mandalName);
        if (s.mandalRefs.some((r)=>(0, $51c57f3e5aa6a385$export$727dcd1ed8aa5b17)(r.district, r.mandalName) === k)) return;
        updateStoreYard(s.id, {
            mandalRefs: [
                ...s.mandalRefs,
                ref
            ]
        });
        setMandalName("");
    }
    function removeMandal(ref) {
        updateStoreYard(s.id, {
            mandalRefs: s.mandalRefs.filter((r)=>(0, $51c57f3e5aa6a385$export$727dcd1ed8aa5b17)(r.district, r.mandalName) !== (0, $51c57f3e5aa6a385$export$727dcd1ed8aa5b17)(ref.district, ref.mandalName))
        });
    }
    function addVillage() {
        const mn = villageMandal.trim();
        const vn = villageName.trim();
        if (!mn || !vn) return;
        const ref = {
            district: villageDistrict,
            mandalName: mn,
            villageName: vn
        };
        const k = (0, $51c57f3e5aa6a385$export$19c0af9de87a0272)(ref.district, ref.mandalName, ref.villageName);
        if (s.villageRefs.some((r)=>(0, $51c57f3e5aa6a385$export$19c0af9de87a0272)(r.district, r.mandalName, r.villageName) === k)) return;
        updateStoreYard(s.id, {
            villageRefs: [
                ...s.villageRefs,
                ref
            ]
        });
        setVillageName("");
    }
    function removeVillage(ref) {
        updateStoreYard(s.id, {
            villageRefs: s.villageRefs.filter((r)=>(0, $51c57f3e5aa6a385$export$19c0af9de87a0272)(r.district, r.mandalName, r.villageName) !== (0, $51c57f3e5aa6a385$export$19c0af9de87a0272)(ref.district, ref.mandalName, ref.villageName))
        });
    }
    function toggleZone(zoneId) {
        const has = s.zoneIds.includes(zoneId);
        const zoneIds = has ? s.zoneIds.filter((id)=>id !== zoneId) : [
            ...s.zoneIds,
            zoneId
        ];
        updateStoreYard(s.id, {
            zoneIds: zoneIds
        });
    }
    function onScopeTypeChange(next) {
        updateStoreYard(s.id, {
            scopeType: next,
            districtKeys: [],
            mandalRefs: [],
            villageRefs: [],
            zoneIds: []
        });
    }
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "milestone-master-modal-editor geo-zones-card",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "toolbar-row",
                style: {
                    justifyContent: "space-between",
                    alignItems: "flex-start"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        style: {
                            margin: 0
                        },
                        children: "Store / yard"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "toolbar-row",
                        style: {
                            gap: "0.35rem",
                            flexWrap: "wrap"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--tg-secondary btn--sm",
                                disabled: index <= 0,
                                onClick: ()=>void moveStoreYard(s.id, "up"),
                                children: "Move up"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--tg-secondary btn--sm",
                                disabled: index >= total - 1,
                                onClick: ()=>void moveStoreYard(s.id, "down"),
                                children: "Move down"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--tg-secondary btn--sm",
                                onClick: ()=>{
                                    if (window.confirm(`Delete store / yard \u{201C}${s.name}\u{201D}?`)) (async ()=>{
                                        const ok = await removeStoreYard(s.id);
                                        if (ok) onDeleted?.();
                                    })();
                                },
                                children: "Delete"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: `sy-name-${s.id}`,
                        children: "Name"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                        id: `sy-name-${s.id}`,
                        value: name,
                        onChange: (e)=>setName(e.target.value),
                        maxLength: 200
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: `sy-notes-${s.id}`,
                        children: "Notes"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                        id: `sy-notes-${s.id}`,
                        rows: 2,
                        value: notes,
                        onChange: (e)=>setNotes(e.target.value),
                        maxLength: 2000
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: `sy-address-${s.id}`,
                        children: "Shipping address (for PO print)"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                        id: `sy-address-${s.id}`,
                        rows: 3,
                        value: address,
                        onChange: (e)=>setAddress(e.target.value),
                        maxLength: 4000
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                type: "button",
                className: "btn btn--primary btn--tg btn--sm",
                onClick: ()=>void updateStoreYard(s.id, {
                        name: name,
                        notes: notes,
                        address: address
                    }),
                children: "Save name, notes & address"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "text-muted section-lead section-lead--tight",
                style: {
                    marginTop: "1rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: matchCount
                    }),
                    " applicant file",
                    matchCount === 1 ? "" : "s",
                    " match this store\u2019s current rule (for this console\u2019s mock data)."
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                className: "form-section-title",
                style: {
                    marginTop: "1.15rem"
                },
                children: "Coverage type"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "section-lead section-lead--tight text-muted",
                children: "Choose one level. Changing type clears the previous selection. Finer scopes (village, mandal) win over district or zone when resolving which store serves a beneficiary."
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: `sy-scope-${s.id}`,
                        children: "How this store is tied to geography"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("select", {
                        id: `sy-scope-${s.id}`,
                        value: s.scopeType,
                        onChange: (e)=>onScopeTypeChange(e.target.value),
                        children: $f22caf1cf81c9c4c$var$SCOPE_OPTIONS.map((o)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                value: o.value,
                                children: o.label
                            }, o.value))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "section-lead section-lead--tight text-muted",
                style: {
                    marginTop: "0.4rem"
                },
                children: 'Coverage saves as soon as you change it (district list, mandals, villages, zones, or coverage type). "Save name & notes" only updates the name and notes fields.'
            }),
            s.scopeType === "district" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        style: {
                            marginTop: "1rem"
                        },
                        children: "Districts served"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "section-lead section-lead--tight text-muted",
                        children: "Add every district this store covers (multiselect). Choose a district, click Add district, repeat."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "geo-zones-add-row",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field-inline",
                                style: {
                                    flex: "1 1 14rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: `sy-${s.id}-district-pick`,
                                        children: "District"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                        id: `sy-${s.id}-district-pick`,
                                        variant: "dash",
                                        value: districtPickKey,
                                        onChange: (v)=>setDistrictPickKey(v),
                                        options: districtAddOptions,
                                        placeholder: "\u2014 Choose district \u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--tg-secondary btn--sm",
                                disabled: !districtPickKey || !districtPickKey || s.districtKeys.includes(districtPickKey),
                                onClick: ()=>void addDistrictPick(),
                                children: "Add district"
                            })
                        ]
                    }),
                    s.districtKeys.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                        className: "geo-zones-pill-list",
                        children: [
                            ...s.districtKeys
                        ].sort((a, b)=>$f22caf1cf81c9c4c$var$districtLabel(geoStore, a).localeCompare($f22caf1cf81c9c4c$var$districtLabel(geoStore, b))).map((key)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                className: "geo-zones-pill-row",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        children: $f22caf1cf81c9c4c$var$districtLabel(geoStore, key)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--link btn--sm",
                                        onClick: ()=>removeDistrictKey(key),
                                        children: "Remove"
                                    })
                                ]
                            }, key))
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted section-lead section-lead--tight",
                        children: "Add at least one district."
                    })
                ]
            }) : null,
            s.scopeType === "mandal" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        style: {
                            marginTop: "1rem"
                        },
                        children: "Mandals served"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "geo-zones-add-row",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field-inline",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: `sy-${s.id}-mandal-district`,
                                        children: "District"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                        id: `sy-${s.id}-mandal-district`,
                                        variant: "dash",
                                        value: mandalDistrict,
                                        onChange: (v)=>{
                                            if (v) {
                                                setMandalDistrict(v);
                                                setMandalName("");
                                            }
                                        },
                                        options: districtPickOptions,
                                        placeholder: "District"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field-inline",
                                style: {
                                    flex: "1 1 12rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: `sy-${s.id}-mandal-name`,
                                        children: "Mandal"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                        id: `sy-${s.id}-mandal-name`,
                                        variant: "dash",
                                        value: mandalName,
                                        onChange: setMandalName,
                                        options: mandalPickOptions,
                                        placeholder: "\u2014 Choose mandal \u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--tg-secondary btn--sm",
                                disabled: !mandalName.trim(),
                                onClick: addMandal,
                                children: "Add mandal"
                            })
                        ]
                    }),
                    s.mandalRefs.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                        className: "geo-zones-pill-list",
                        children: s.mandalRefs.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                className: "geo-zones-pill-row",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                children: $f22caf1cf81c9c4c$var$districtLabel(geoStore, r.district)
                                            }),
                                            " \u2014 ",
                                            r.mandalName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--link btn--sm",
                                        onClick: ()=>removeMandal(r),
                                        children: "Remove"
                                    })
                                ]
                            }, (0, $51c57f3e5aa6a385$export$727dcd1ed8aa5b17)(r.district, r.mandalName)))
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted section-lead section-lead--tight",
                        children: "Add at least one mandal."
                    })
                ]
            }) : null,
            s.scopeType === "village" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        style: {
                            marginTop: "1rem"
                        },
                        children: "Villages served"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "geo-zones-add-row geo-zones-add-row--wrap",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field-inline",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: `sy-${s.id}-village-district`,
                                        children: "District"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                        id: `sy-${s.id}-village-district`,
                                        variant: "dash",
                                        value: villageDistrict,
                                        onChange: (v)=>{
                                            if (v) {
                                                setVillageDistrict(v);
                                                setVillageMandal("");
                                                setVillageName("");
                                            }
                                        },
                                        options: districtPickOptions,
                                        placeholder: "District"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field-inline",
                                style: {
                                    flex: "1 1 11rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: `sy-${s.id}-village-mandal`,
                                        children: "Mandal"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                        id: `sy-${s.id}-village-mandal`,
                                        variant: "dash",
                                        value: villageMandal,
                                        onChange: (v)=>{
                                            setVillageMandal(v);
                                            setVillageName("");
                                        },
                                        options: villageMandalPickOptions,
                                        placeholder: "\u2014 Choose mandal \u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field-inline",
                                style: {
                                    flex: "1 1 12rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: `sy-${s.id}-village-name`,
                                        children: "Village"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                        id: `sy-${s.id}-village-name`,
                                        variant: "dash",
                                        value: villageName,
                                        onChange: setVillageName,
                                        options: villageNamePickOptions,
                                        placeholder: "\u2014 Choose village \u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--tg-secondary btn--sm",
                                disabled: !villageMandal.trim() || !villageName.trim(),
                                onClick: addVillage,
                                children: "Add village"
                            })
                        ]
                    }),
                    s.villageRefs.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                        className: "geo-zones-pill-list",
                        children: s.villageRefs.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                className: "geo-zones-pill-row",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                children: $f22caf1cf81c9c4c$var$districtLabel(geoStore, r.district)
                                            }),
                                            " \u2014 ",
                                            r.mandalName,
                                            " \u2014 ",
                                            r.villageName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--link btn--sm",
                                        onClick: ()=>removeVillage(r),
                                        children: "Remove"
                                    })
                                ]
                            }, (0, $51c57f3e5aa6a385$export$19c0af9de87a0272)(r.district, r.mandalName, r.villageName)))
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted section-lead section-lead--tight",
                        children: "Add at least one village."
                    })
                ]
            }) : null,
            s.scopeType === "zone" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        style: {
                            marginTop: "1rem"
                        },
                        children: "Zones from master"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "section-lead section-lead--tight text-muted",
                        children: [
                            "Uses the same rules as ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/zones",
                                children: "Zones"
                            }),
                            ". Tick one or more zones this depot supplies."
                        ]
                    }),
                    sortedZones.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "text-muted section-lead section-lead--tight",
                        children: [
                            "No zones defined yet \u2014 create them under ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/zones",
                                children: "Zones"
                            }),
                            " first."
                        ]
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "geo-zones-district-grid",
                        children: sortedZones.map((z)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "geo-zones-check",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        type: "checkbox",
                                        checked: s.zoneIds.includes(z.id),
                                        onChange: ()=>toggleZone(z.id)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        children: z.name
                                    })
                                ]
                            }, z.id))
                    })
                ]
            }) : null
        ]
    });
}
function $f22caf1cf81c9c4c$export$f9f9e4986c335ce2() {
    const { storeYards: storeYards, geoZones: geoZones } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const sorted = (0, $7UyaH.useMemo)(()=>[
            ...storeYards
        ].sort((a, b)=>a.sortOrder - b.sortOrder), [
        storeYards
    ]);
    const [createModalOpen, setCreateModalOpen] = (0, $7UyaH.useState)(false);
    const [editModalStoreId, setEditModalStoreId] = (0, $7UyaH.useState)(null);
    const editModalStore = (0, $7UyaH.useMemo)(()=>editModalStoreId ? sorted.find((x)=>x.id === editModalStoreId) : undefined, [
        editModalStoreId,
        sorted
    ]);
    const editModalIndex = (0, $7UyaH.useMemo)(()=>{
        if (!editModalStore) return -1;
        return sorted.findIndex((s)=>s.id === editModalStore.id);
    }, [
        editModalStore,
        sorted
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (editModalStoreId && !editModalStore) setEditModalStoreId(null);
    }, [
        editModalStoreId,
        editModalStore
    ]);
    const closeCreateModal = (0, $7UyaH.useCallback)(()=>{
        setCreateModalOpen(false);
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        if (!createModalOpen && !editModalStoreId) return;
        const onKey = (e)=>{
            if (e.key === "Escape") {
                closeCreateModal();
                setEditModalStoreId(null);
            }
        };
        window.addEventListener("keydown", onKey);
        return ()=>window.removeEventListener("keydown", onKey);
    }, [
        createModalOpen,
        editModalStoreId,
        closeCreateModal
    ]);
    const openCreateModal = ()=>{
        setEditModalStoreId(null);
        setCreateModalOpen(true);
    };
    const openEditModal = (id)=>{
        setCreateModalOpen(false);
        setEditModalStoreId((prev)=>prev === id ? null : id);
    };
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "milestone-master-page",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Inventory",
                        to: "/inventory/inward"
                    },
                    {
                        label: "Stores / yards"
                    }
                ],
                title: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem"
                    },
                    children: [
                        "Stores & yards",
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                            className: "milestone-master__catalog-count",
                            children: sorted.length
                        })
                    ]
                }),
                actions: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                    type: "button",
                    className: "btn btn--primary btn--tg btn--sm",
                    onClick: openCreateModal,
                    children: "Add store / yard"
                })
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("section", {
                className: "milestone-master__catalog",
                "aria-labelledby": "stores-yards-catalog-heading",
                style: {
                    marginTop: "1.75rem"
                },
                children: sorted.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "milestone-master__empty",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                            className: "milestone-master__empty-title",
                            children: "No stores yet"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                            className: "milestone-master__empty-desc",
                            children: [
                                "Create your first depot with ",
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                    children: "Add store / yard"
                                }),
                                ", then pick districts, mandals, villages, or zones in the dialog."
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                    className: "milestone-master-picker-grid",
                    children: sorted.map((s, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($f22caf1cf81c9c4c$var$StoreYardSummaryCard, {
                            store: s,
                            storeIndex: i,
                            isActive: editModalStoreId === s.id,
                            onOpen: ()=>openEditModal(s.id)
                        }, s.id))
                })
            }),
            createModalOpen ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "modal-backdrop",
                role: "presentation",
                onClick: ()=>{
                    closeCreateModal();
                },
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "modal milestone-master-modal stores-yards-master-modal",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "stores-yards-create-title",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "milestone-master-modal__header",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                    id: "stores-yards-create-title",
                                    className: "milestone-master-modal__title",
                                    children: "Add store or yard"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--tg-secondary btn--sm",
                                    onClick: closeCreateModal,
                                    children: "Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "milestone-master-modal__body",
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($f22caf1cf81c9c4c$var$AddStoreYardForm, {
                                geoZones: geoZones,
                                onCreated: ()=>{
                                    closeCreateModal();
                                }
                            })
                        })
                    ]
                })
            }) : null,
            editModalStore && editModalIndex >= 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "modal-backdrop",
                role: "presentation",
                onClick: ()=>{
                    setEditModalStoreId(null);
                },
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "modal milestone-master-modal stores-yards-master-modal",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "stores-yards-edit-title",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "milestone-master-modal__header",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                    id: "stores-yards-edit-title",
                                    className: "milestone-master-modal__title",
                                    children: "Edit store / yard"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--tg-secondary btn--sm",
                                    onClick: ()=>setEditModalStoreId(null),
                                    children: "Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "milestone-master-modal__body",
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($f22caf1cf81c9c4c$var$StoreYardEditorForm, {
                                store: editModalStore,
                                geoZones: geoZones,
                                index: editModalIndex,
                                total: sorted.length,
                                onDeleted: ()=>setEditModalStoreId(null)
                            }, editModalStore.id)
                        })
                    ]
                })
            }) : null
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");






function $4e24c9f8770af11a$var$villageKey(v) {
    return `${v.district}\t${(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(v.mandalName)}\t${(0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(v.villageName)}`;
}
function $4e24c9f8770af11a$var$villageRowKey(v, idx) {
    if (v.villageDbId != null && v.villageDbId > 0) return `${v.district}\tvid-${v.villageDbId}`;
    return `${$4e24c9f8770af11a$var$villageKey(v)}\tidx-${idx}`;
}
/** When `embedVillageDbIdInValue` is on, village select value is `"{id}\\t{name}"`. */ function $4e24c9f8770af11a$var$parseVillageSelectValue(raw) {
    const tab = raw.indexOf("\t");
    if (tab > 0) {
        const id = Number(raw.slice(0, tab));
        if (Number.isFinite(id) && id > 0) return {
            villageName: raw.slice(tab + 1).trim(),
            villageDbId: id
        };
    }
    return {
        villageName: raw.trim()
    };
}
function $4e24c9f8770af11a$var$enrichAssignedVillagesWithStore(villages, store) {
    if (!store) return villages;
    return villages.map((v)=>{
        if (v.villageDbId != null && v.villageDbId > 0) return v;
        const districtKey = store.findDistrict(v.district)?.districtKey ?? v.district;
        const id = store.tgResolveVillageDbIdInDistrict(districtKey, v.mandalName, v.villageName);
        return id != null ? {
            ...v,
            villageDbId: id
        } : v;
    });
}
function $4e24c9f8770af11a$var$emptyDraft() {
    return {
        id: "",
        displayName: "",
        phone: "",
        email: "",
        employeeCode: "",
        notes: "",
        hasPassword: false,
        passwordMode: "random",
        onboardingEmailSentAt: null,
        assignedVillages: []
    };
}
function $4e24c9f8770af11a$var$isDraftNameOk(d) {
    return Boolean(d.displayName.trim());
}
const $4e24c9f8770af11a$var$MIN_PW = 8;
function $4e24c9f8770af11a$export$f8513ed6e739adcd() {
    const { agentMasters: agentMasters, addAgentMaster: addAgentMaster, updateAgentMaster: updateAgentMaster, deleteAgentMaster: deleteAgentMaster, sendAgentOnboardingEmail: sendAgentOnboardingEmail } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const { store: store } = (0, $60dd8507bac67e50$export$5ec0231075ddedf1)();
    const [mode, setMode] = (0, $7UyaH.useState)("list");
    const [draft, setDraft] = (0, $7UyaH.useState)($4e24c9f8770af11a$var$emptyDraft());
    const [newPassword, setNewPassword] = (0, $7UyaH.useState)("");
    const [confirmPassword, setConfirmPassword] = (0, $7UyaH.useState)("");
    const [passwordFormError, setPasswordFormError] = (0, $7UyaH.useState)(null);
    const [sendingOnboardingId, setSendingOnboardingId] = (0, $7UyaH.useState)(null);
    const [deletingAgentId, setDeletingAgentId] = (0, $7UyaH.useState)(null);
    const [initialPasswordMode, setInitialPasswordMode] = (0, $7UyaH.useState)("random");
    const [onboardingDialog, setOnboardingDialog] = (0, $7UyaH.useState)(null);
    const [onboardingDialogPw, setOnboardingDialogPw] = (0, $7UyaH.useState)("");
    const [onboardingDialogErr, setOnboardingDialogErr] = (0, $7UyaH.useState)(null);
    const [pickDistrict, setPickDistrict] = (0, $7UyaH.useState)("");
    const [pickMandal, setPickMandal] = (0, $7UyaH.useState)("");
    const [pickVillage, setPickVillage] = (0, $7UyaH.useState)("");
    const sorted = (0, $7UyaH.useMemo)(()=>[
            ...agentMasters
        ].sort((a, b)=>b.createdAt.localeCompare(a.createdAt)), [
        agentMasters
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (mode === "list") {
            setDraft($4e24c9f8770af11a$var$emptyDraft());
            setNewPassword("");
            setConfirmPassword("");
            setPasswordFormError(null);
            setPickDistrict("");
            setPickMandal("");
            setPickVillage("");
            setOnboardingDialog(null);
            setOnboardingDialogPw("");
            setOnboardingDialogErr(null);
        }
    }, [
        mode
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (mode === "list") return;
        if (draft.passwordMode === "random") {
            setNewPassword("");
            setConfirmPassword("");
            setPasswordFormError(null);
        }
    }, [
        mode,
        draft.passwordMode
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (mode !== "edit" && mode !== "new") return;
        if (!store) return;
        setDraft((d)=>{
            const next = $4e24c9f8770af11a$var$enrichAssignedVillagesWithStore(d.assignedVillages, store);
            const same = next.length === d.assignedVillages.length && next.every((v, i)=>v.villageDbId === d.assignedVillages[i]?.villageDbId);
            return same ? d : {
                ...d,
                assignedVillages: next
            };
        });
    }, [
        store,
        mode
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!onboardingDialog) return;
        const onKey = (e)=>{
            if (e.key === "Escape") {
                setOnboardingDialog(null);
                setOnboardingDialogPw("");
                setOnboardingDialogErr(null);
            }
        };
        window.addEventListener("keydown", onKey);
        return ()=>window.removeEventListener("keydown", onKey);
    }, [
        onboardingDialog
    ]);
    function startNew() {
        setDraft($4e24c9f8770af11a$var$emptyDraft());
        setNewPassword("");
        setConfirmPassword("");
        setPasswordFormError(null);
        setInitialPasswordMode("random");
        setMode("new");
    }
    function startEdit(m) {
        const villagesForEdit = store ? $4e24c9f8770af11a$var$enrichAssignedVillagesWithStore([
            ...m.assignedVillages
        ], store) : [
            ...m.assignedVillages
        ];
        setDraft({
            id: m.id,
            displayName: m.displayName,
            phone: m.phone,
            email: m.email,
            employeeCode: m.employeeCode,
            notes: m.notes,
            hasPassword: m.hasPassword,
            passwordMode: m.passwordMode ?? "random",
            onboardingEmailSentAt: m.onboardingEmailSentAt,
            assignedVillages: villagesForEdit
        });
        setNewPassword("");
        setConfirmPassword("");
        setPasswordFormError(null);
        setInitialPasswordMode(m.passwordMode ?? "random");
        setPickDistrict("");
        setPickMandal("");
        setPickVillage("");
        setMode("edit");
    }
    function addPickedVillage() {
        if (!pickDistrict || !pickMandal.trim() || !pickVillage.trim()) return;
        const parsed = $4e24c9f8770af11a$var$parseVillageSelectValue(pickVillage);
        if (!parsed.villageName) return;
        const resolvedId = parsed.villageDbId ?? (store ? store.tgResolveVillageDbIdInDistrict(pickDistrict, pickMandal, parsed.villageName) : undefined);
        const next = {
            district: pickDistrict,
            mandalName: pickMandal.trim(),
            villageName: parsed.villageName,
            ...resolvedId != null ? {
                villageDbId: resolvedId
            } : {}
        };
        const dedupeKey = next.villageDbId != null && next.villageDbId > 0 ? `vid:${next.villageDbId}` : $4e24c9f8770af11a$var$villageKey(next);
        if (draft.assignedVillages.some((v)=>(v.villageDbId != null && v.villageDbId > 0 ? `vid:${v.villageDbId}` : $4e24c9f8770af11a$var$villageKey(v)) === dedupeKey)) return;
        setDraft((d)=>({
                ...d,
                assignedVillages: [
                    ...d.assignedVillages,
                    next
                ]
            }));
        setPickVillage("");
    }
    function removeVillage(idx) {
        setDraft((d)=>({
                ...d,
                assignedVillages: d.assignedVillages.filter((_, i)=>i !== idx)
            }));
    }
    function buildUpsertPayload() {
        const np = newPassword.trim();
        const cp = confirmPassword.trim();
        const row = {
            displayName: draft.displayName.trim(),
            phone: draft.phone.trim(),
            email: draft.email.trim(),
            employeeCode: draft.employeeCode.trim(),
            notes: draft.notes.trim(),
            assignedVillages: draft.assignedVillages,
            passwordMode: draft.passwordMode
        };
        if (draft.passwordMode === "custom") {
            const mustSetPassword = mode === "new" || !draft.hasPassword || initialPasswordMode === "random" && draft.passwordMode === "custom";
            if (mustSetPassword) {
                if (np.length < $4e24c9f8770af11a$var$MIN_PW) {
                    setPasswordFormError(`Password must be at least ${$4e24c9f8770af11a$var$MIN_PW} characters.`);
                    return null;
                }
                if (np !== cp) {
                    setPasswordFormError("Password and confirmation do not match.");
                    return null;
                }
                row.newPassword = np;
            } else if (np || cp) {
                if (np.length < $4e24c9f8770af11a$var$MIN_PW) {
                    setPasswordFormError(`Password must be at least ${$4e24c9f8770af11a$var$MIN_PW} characters.`);
                    return null;
                }
                if (np !== cp) {
                    setPasswordFormError("Password and confirmation do not match.");
                    return null;
                }
                row.newPassword = np;
            }
        }
        setPasswordFormError(null);
        return row;
    }
    async function saveAgent() {
        if (!$4e24c9f8770af11a$var$isDraftNameOk(draft)) return;
        const row = buildUpsertPayload();
        if (!row) return;
        if (mode === "new") {
            const id = await addAgentMaster(row);
            if (!id) return;
        } else if (mode === "edit" && draft.id) {
            const ok = await updateAgentMaster(draft.id, row);
            if (!ok) return;
        }
        setMode("list");
    }
    async function handleSendOnboarding(agentId) {
        const agent = agentMasters.find((a)=>a.id === agentId);
        if (!agent) return;
        if (agent.passwordMode === "custom" && agent.hasPassword) {
            setOnboardingDialog({
                agentId: agentId,
                displayName: agent.displayName
            });
            setOnboardingDialogPw("");
            setOnboardingDialogErr(null);
            return;
        }
        setSendingOnboardingId(agentId);
        try {
            await sendAgentOnboardingEmail(agentId);
        } finally{
            setSendingOnboardingId(null);
        }
    }
    async function handleDeleteAgent(m) {
        const ok = window.confirm(`Remove agent \u{201C}${m.displayName}\u{201D} from the master list?

Assigned villages will be cleared. This cannot be undone.`);
        if (!ok) return;
        setDeletingAgentId(m.id);
        try {
            await deleteAgentMaster(m.id);
        } finally{
            setDeletingAgentId(null);
        }
    }
    async function submitOnboardingDialog() {
        if (!onboardingDialog) return;
        const pw = onboardingDialogPw.trim();
        if (!pw) {
            setOnboardingDialogErr("Enter the agent password.");
            return;
        }
        setOnboardingDialogErr(null);
        setSendingOnboardingId(onboardingDialog.agentId);
        try {
            const ok = await sendAgentOnboardingEmail(onboardingDialog.agentId, {
                customPasswordForEmail: pw
            });
            if (ok) {
                setOnboardingDialog(null);
                setOnboardingDialogPw("");
            }
        } finally{
            setSendingOnboardingId(null);
        }
    }
    const canSave = $4e24c9f8770af11a$var$isDraftNameOk(draft);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Agent master"
                    }
                ],
                title: "Agent master"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "section-lead section-lead--tight text-muted",
                style: {
                    marginBottom: "0.75rem"
                },
                children: "Register field agents and assign villages from the geographic directory. Villages are matched the same way as on the Applicants screen."
            }),
            mode === "list" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "flex-end",
                            marginBottom: "0.75rem"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            className: "btn btn--primary btn--tg",
                            onClick: startNew,
                            children: "Add agent"
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "card card--gov card--elevated",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "table-wrap",
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                className: "data-table",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Name"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Phone"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Email"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Employee ref."
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Villages"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Sign-in"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {})
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                        children: sorted.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                colSpan: 7,
                                                className: "data-table__empty",
                                                children: "No agents yet. Use Add agent to create one."
                                            })
                                        }) : sorted.map((m)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                            className: "table-name",
                                                            children: m.displayName
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono",
                                                        children: m.phone || "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: m.email || "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono",
                                                        children: m.employeeCode || "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: m.assignedVillages.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                            className: "text-muted",
                                                            children: "None"
                                                        }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                            children: [
                                                                m.assignedVillages.length,
                                                                " village(s)"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                            className: "agent-master-form__stack",
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                                    className: "text-muted",
                                                                    style: {
                                                                        fontSize: "0.85rem"
                                                                    },
                                                                    children: [
                                                                        m.passwordMode === "custom" ? "Custom" : "Random",
                                                                        " \xb7 ",
                                                                        m.hasPassword ? "Password set" : "No password"
                                                                    ]
                                                                }),
                                                                m.onboardingEmailSentAt ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                                    className: "text-muted",
                                                                    style: {
                                                                        fontSize: "0.8rem"
                                                                    },
                                                                    children: [
                                                                        "Emailed ",
                                                                        new Date(m.onboardingEmailSentAt).toLocaleDateString()
                                                                    ]
                                                                }) : null,
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                                    type: "button",
                                                                    className: "btn btn--sm btn--secondary btn--tg",
                                                                    disabled: Boolean(sendingOnboardingId) || !m.email.trim() || m.passwordMode === "custom" && !m.hasPassword,
                                                                    title: !m.email.trim() ? "Add an email to send onboarding" : m.passwordMode === "custom" && !m.hasPassword ? "Save a custom password for this agent first" : m.passwordMode === "custom" ? "Opens a short step: enter the saved password to verify it matches and include it in the email" : "Creates a new random password and emails it with the sign-in link",
                                                                    onClick: ()=>void handleSendOnboarding(m.id),
                                                                    children: sendingOnboardingId === m.id ? "Sending\u2026" : "Send onboarding"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexWrap: "wrap",
                                                                gap: "0.35rem",
                                                                justifyContent: "flex-end"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                                    type: "button",
                                                                    className: "btn btn--sm btn--tg-secondary",
                                                                    onClick: ()=>startEdit(m),
                                                                    children: "Edit"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                                    type: "button",
                                                                    className: "btn btn--sm btn--danger",
                                                                    disabled: deletingAgentId !== null || sendingOnboardingId === m.id,
                                                                    onClick: ()=>void handleDeleteAgent(m),
                                                                    children: deletingAgentId === m.id ? "Removing\u2026" : "Delete"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }, m.id))
                                    })
                                ]
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated agent-master-form",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "card__title card__title--gov",
                        children: mode === "new" ? "New agent" : "Edit agent"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        children: "Contact & details"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field-grid",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: "agent-display-name",
                                        children: "Display name"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        id: "agent-display-name",
                                        value: draft.displayName,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    displayName: e.target.value
                                                })),
                                        autoComplete: "name"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: "agent-phone",
                                        children: "Phone"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        id: "agent-phone",
                                        value: draft.phone,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    phone: e.target.value
                                                })),
                                        autoComplete: "tel"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: "agent-email",
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        id: "agent-email",
                                        type: "email",
                                        value: draft.email,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    email: e.target.value
                                                })),
                                        autoComplete: "email"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: "agent-emp",
                                        children: "Employee / ID ref."
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        id: "agent-emp",
                                        value: draft.employeeCode,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    employeeCode: e.target.value
                                                }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field--full",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: "agent-notes",
                                        children: "Notes"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                        id: "agent-notes",
                                        rows: 4,
                                        value: draft.notes,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    notes: e.target.value
                                                }))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        children: "Sign-in (email + password)"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "agent-master-form__hint",
                        children: [
                            "Agents use the ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "email"
                            }),
                            " above to sign in. Choose ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Random"
                            }),
                            " to let the system generate a password when you send onboarding, or ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Custom"
                            }),
                            " to set a password here; for custom, you re-enter that password when sending onboarding so it can be verified and included in the message (the password is stored on the server as entered)."
                        ]
                    }),
                    mode === "edit" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "agent-master-form__hint",
                        style: {
                            marginTop: "-0.25rem"
                        },
                        children: [
                            "Status:",
                            " ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: draft.hasPassword ? "Password is set" : "No password yet"
                            }),
                            draft.onboardingEmailSentAt ? ` \xb7 Onboarding email last sent ${new Date(draft.onboardingEmailSentAt).toLocaleString()}` : ""
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field field--full",
                        style: {
                            marginBottom: "0.5rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "text-muted",
                                style: {
                                    fontSize: "0.85rem",
                                    display: "block",
                                    marginBottom: "0.35rem"
                                },
                                children: "Password type"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "1rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        style: {
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "0.35rem",
                                            cursor: "pointer"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                type: "radio",
                                                name: "agent-pw-mode",
                                                checked: draft.passwordMode === "random",
                                                onChange: ()=>setDraft((d)=>({
                                                            ...d,
                                                            passwordMode: "random"
                                                        }))
                                            }),
                                            "Random"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        style: {
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "0.35rem",
                                            cursor: "pointer"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                type: "radio",
                                                name: "agent-pw-mode",
                                                checked: draft.passwordMode === "custom",
                                                onChange: ()=>setDraft((d)=>({
                                                            ...d,
                                                            passwordMode: "custom"
                                                        }))
                                            }),
                                            "Custom"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    draft.passwordMode === "random" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "agent-master-form__hint",
                        style: {
                            marginTop: 0
                        },
                        children: [
                            "No password is stored until you use ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Send onboarding"
                            }),
                            " from the list; each send creates a new random password and emails it."
                        ]
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field-grid",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: "agent-new-pw",
                                        children: "Password"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        id: "agent-new-pw",
                                        type: "password",
                                        autoComplete: "new-password",
                                        value: newPassword,
                                        onChange: (e)=>{
                                            setNewPassword(e.target.value);
                                            setPasswordFormError(null);
                                        },
                                        placeholder: mode === "edit" && draft.hasPassword && !(initialPasswordMode === "random") ? "Leave blank to keep current" : "At least 8 characters"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: "agent-confirm-pw",
                                        children: "Confirm password"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        id: "agent-confirm-pw",
                                        type: "password",
                                        autoComplete: "new-password",
                                        value: confirmPassword,
                                        onChange: (e)=>{
                                            setConfirmPassword(e.target.value);
                                            setPasswordFormError(null);
                                        },
                                        placeholder: "Repeat password"
                                    })
                                ]
                            })
                        ]
                    }),
                    passwordFormError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "agent-master-form__hint",
                        style: {
                            color: "var(--danger, #b91c1c)"
                        },
                        children: passwordFormError
                    }) : null,
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        children: "Assign villages"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "agent-master-form__hint",
                        children: [
                            "Pick ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "district"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "mandal"
                            }),
                            ", and ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "village"
                            }),
                            ", then use",
                            " ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Add village"
                            }),
                            ". The database keys each assignment by ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Geo ID"
                            }),
                            " (with district / mandal / village names stored for display). The server rejects saves that cannot be matched to the geo directory."
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "agent-master-form__geo",
                        "aria-label": "Pick village to assign",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $0377fbce5921ee00$export$b3eb1a6c17723c14), {
                                idPrefix: "agent-master-geo",
                                district: pickDistrict,
                                mandal: pickMandal,
                                village: pickVillage,
                                embedVillageDbIdInValue: true,
                                onDistrictChange: (d)=>{
                                    setPickDistrict(d);
                                    setPickMandal("");
                                    setPickVillage("");
                                },
                                onMandalChange: (m)=>{
                                    setPickMandal(m);
                                    setPickVillage("");
                                },
                                onVillageChange: setPickVillage
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "agent-master-form__geo-btn",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--secondary btn--tg",
                                    "aria-label": "Add selected village to this agent",
                                    onClick: addPickedVillage,
                                    children: "Add village"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "agent-master-form__village-table",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "table-wrap",
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                className: "data-table",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "District"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    className: "mono",
                                                    children: "Reg. code"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "District (official)"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    className: "mono",
                                                    children: "Mandal ID"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    className: "mono",
                                                    children: "Mandal code"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Mandal"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    className: "mono",
                                                    children: "Village code"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Village"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    className: "mono",
                                                    children: "Geo ID"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {})
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                        children: draft.assignedVillages.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                colSpan: 10,
                                                className: "data-table__empty",
                                                children: "No villages assigned yet."
                                            })
                                        }) : draft.assignedVillages.map((v, idx)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: v.registrationDistrictName || (0, $458840b99c021cb6$export$bb1029bec19025fd)(v.district) || "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono text-muted",
                                                        children: v.registrationDistrictCode || "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: v.registrationDistrictName || "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono text-muted",
                                                        children: v.mandalId != null ? String(v.mandalId) : "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono text-muted",
                                                        children: v.mandalCode || "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: v.mandalName
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono text-muted",
                                                        children: v.villageCode || "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: v.villageName
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        className: "mono text-muted",
                                                        children: v.villageDbId != null ? String(v.villageDbId) : "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "btn btn--link btn--sm",
                                                            onClick: ()=>removeVillage(idx),
                                                            children: "Remove"
                                                        })
                                                    })
                                                ]
                                            }, $4e24c9f8770af11a$var$villageRowKey(v, idx)))
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "agent-master-form__actions",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--primary btn--tg",
                                disabled: !canSave,
                                onClick: ()=>void saveAgent(),
                                children: "Save"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--ghost",
                                onClick: ()=>setMode("list"),
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            }),
            onboardingDialog ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "modal-backdrop",
                role: "presentation",
                onClick: ()=>{
                    setOnboardingDialog(null);
                    setOnboardingDialogPw("");
                    setOnboardingDialogErr(null);
                },
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "modal",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "agent-onboard-dialog-title",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                            id: "agent-onboard-dialog-title",
                            children: "Send onboarding email"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                            className: "modal__lede",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "table-name",
                                    children: onboardingDialog.displayName
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "text-muted",
                                    style: {
                                        display: "block",
                                        marginTop: "0.35rem"
                                    },
                                    children: "Custom sign-in: enter the same password you saved for this agent. It is checked against the saved password and included in the email; the database row is not updated by this send."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "field",
                            style: {
                                marginTop: "0.75rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                    htmlFor: "agent-onboard-pw",
                                    children: "Agent password"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                    id: "agent-onboard-pw",
                                    type: "password",
                                    autoComplete: "off",
                                    value: onboardingDialogPw,
                                    onChange: (e)=>{
                                        setOnboardingDialogPw(e.target.value);
                                        setOnboardingDialogErr(null);
                                    }
                                })
                            ]
                        }),
                        onboardingDialogErr ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                            className: "agent-master-form__hint",
                            style: {
                                color: "var(--danger, #b91c1c)",
                                marginTop: "0.5rem"
                            },
                            children: onboardingDialogErr
                        }) : null,
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "modal__actions",
                            style: {
                                marginTop: "1rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--primary btn--tg",
                                    disabled: Boolean(sendingOnboardingId),
                                    onClick: ()=>void submitOnboardingDialog(),
                                    children: sendingOnboardingId === onboardingDialog.agentId ? "Sending\u2026" : "Send email"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--ghost",
                                    disabled: Boolean(sendingOnboardingId),
                                    onClick: ()=>{
                                        setOnboardingDialog(null);
                                        setOnboardingDialogPw("");
                                        setOnboardingDialogErr(null);
                                    },
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            }) : null
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");






function $f6cf58a0c1aaa9dd$var$TimelineLevelSummaryCard({ phase: phase, levelIndex: levelIndex, isActive: isActive, onOpen: onOpen }) {
    const days = phase.approxDays;
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("button", {
        type: "button",
        className: `milestone-master-picker-card${isActive ? " milestone-master-picker-card--active" : ""}`,
        onClick: onOpen,
        "aria-haspopup": "dialog",
        "aria-expanded": isActive,
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "milestone-master-picker-card__content",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__top",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                            className: "milestone-master-picker-card__phase-badge",
                            children: [
                                "Level ",
                                levelIndex + 1
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__title",
                        children: phase.title
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__stats",
                        "aria-label": "Planned duration",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                            children: [
                                "~",
                                days,
                                " day",
                                days === 1 ? "" : "s",
                                " planned"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                className: "milestone-master-picker-card__footer",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                    children: isActive ? "Editor open" : "Click card to edit"
                })
            })
        ]
    });
}
function $f6cf58a0c1aaa9dd$var$TimelineLevelEditorForm({ phase: phase, index: index, total: total, onDeleted: onDeleted }) {
    const { updateConstructionTimelinePhase: updateConstructionTimelinePhase, removeConstructionTimelinePhase: removeConstructionTimelinePhase, moveConstructionTimelinePhase: moveConstructionTimelinePhase } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const [title, setTitle] = (0, $7UyaH.useState)(phase.title);
    const [approxDays, setApproxDays] = (0, $7UyaH.useState)(String(phase.approxDays));
    (0, $7UyaH.useEffect)(()=>{
        setTitle(phase.title);
        setApproxDays(String(phase.approxDays));
    }, [
        phase.id,
        phase.title,
        phase.approxDays
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "milestone-master-modal-editor",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "toolbar-row",
                style: {
                    justifyContent: "space-between",
                    alignItems: "flex-start"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "text-muted section-lead section-lead--tight",
                        style: {
                            margin: 0,
                            maxWidth: "36rem"
                        },
                        children: [
                            "Level ",
                            index + 1,
                            " of ",
                            total,
                            ". Changing order updates every beneficiary chart. Deleting clears logged actual days for this level everywhere."
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--tg-secondary btn--sm milestone-row__remove",
                        onClick: ()=>{
                            if (window.confirm(`Remove \u{201C}${phase.title}\u{201D} from the construction timeline? Logged actual days for this level will be cleared on all beneficiaries.`)) (async ()=>{
                                const ok = await removeConstructionTimelinePhase(phase.id);
                                if (ok) onDeleted?.();
                            })();
                        },
                        children: "Delete level"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: `ctp-title-${phase.id}`,
                        children: "Level name (shown on Gantt)"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                        id: `ctp-title-${phase.id}`,
                        value: title,
                        onChange: (e)=>setTitle(e.target.value),
                        maxLength: 200
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: `ctp-days-${phase.id}`,
                        children: "Approximate days (plan)"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                        id: `ctp-days-${phase.id}`,
                        type: "number",
                        min: 0,
                        step: 1,
                        value: approxDays,
                        onChange: (e)=>setApproxDays(e.target.value)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "toolbar-row",
                style: {
                    gap: "0.5rem",
                    flexWrap: "wrap"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--primary btn--tg btn--sm",
                        disabled: !title.trim(),
                        onClick: ()=>void updateConstructionTimelinePhase(phase.id, {
                                title: title.trim(),
                                approxDays: Math.max(0, Math.floor(Number(approxDays)) || 0)
                            }),
                        children: "Save level"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--tg-secondary btn--sm",
                        disabled: index <= 0,
                        onClick: ()=>void moveConstructionTimelinePhase(phase.id, "up"),
                        children: "Move up"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--tg-secondary btn--sm",
                        disabled: index >= total - 1,
                        onClick: ()=>void moveConstructionTimelinePhase(phase.id, "down"),
                        children: "Move down"
                    })
                ]
            })
        ]
    });
}
function $f6cf58a0c1aaa9dd$export$f1aea5cae31542d() {
    const { constructionTimelinePhases: constructionTimelinePhases, addConstructionTimelinePhase: addConstructionTimelinePhase } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const sorted = (0, $7UyaH.useMemo)(()=>(0, $d0dce9c7337efc65$export$107c6562c1e7acbf)(constructionTimelinePhases), [
        constructionTimelinePhases
    ]);
    const samplePortalPhotos = (0, $7UyaH.useMemo)(()=>(0, $6e0ebd679bab8d2f$export$3f36d6d90c29dfc3)(sorted), [
        sorted
    ]);
    const [createModalOpen, setCreateModalOpen] = (0, $7UyaH.useState)(false);
    const [editModalPhaseId, setEditModalPhaseId] = (0, $7UyaH.useState)(null);
    const [newTitle, setNewTitle] = (0, $7UyaH.useState)("");
    const [newDays, setNewDays] = (0, $7UyaH.useState)("14");
    const editModalPhase = (0, $7UyaH.useMemo)(()=>editModalPhaseId ? sorted.find((x)=>x.id === editModalPhaseId) : undefined, [
        editModalPhaseId,
        sorted
    ]);
    const editModalIndex = (0, $7UyaH.useMemo)(()=>{
        if (!editModalPhase) return -1;
        return sorted.findIndex((p)=>p.id === editModalPhase.id);
    }, [
        editModalPhase,
        sorted
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (editModalPhaseId && !editModalPhase) setEditModalPhaseId(null);
    }, [
        editModalPhaseId,
        editModalPhase
    ]);
    const closeCreateModal = (0, $7UyaH.useCallback)(()=>{
        setCreateModalOpen(false);
        setNewTitle("");
        setNewDays("14");
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        if (!createModalOpen && !editModalPhaseId) return;
        const onKey = (e)=>{
            if (e.key === "Escape") {
                closeCreateModal();
                setEditModalPhaseId(null);
            }
        };
        window.addEventListener("keydown", onKey);
        return ()=>window.removeEventListener("keydown", onKey);
    }, [
        createModalOpen,
        editModalPhaseId,
        closeCreateModal
    ]);
    const openCreateModal = ()=>{
        setEditModalPhaseId(null);
        setCreateModalOpen(true);
    };
    const openEditModal = (id)=>{
        setCreateModalOpen(false);
        setEditModalPhaseId((prev)=>prev === id ? null : id);
    };
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "milestone-master-page",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Timeline master"
                    }
                ],
                title: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem"
                    },
                    children: [
                        "Construction timeline master",
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                            className: "milestone-master__catalog-count",
                            children: sorted.length
                        })
                    ]
                }),
                actions: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                    type: "button",
                    className: "btn btn--primary btn--tg btn--sm",
                    onClick: openCreateModal,
                    children: "Add level"
                })
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("section", {
                className: "milestone-master__catalog",
                "aria-labelledby": "timeline-master-catalog-heading",
                style: {
                    marginTop: "1.75rem"
                },
                children: sorted.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "milestone-master__empty",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                            className: "milestone-master__empty-title",
                            children: "No levels yet"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                            className: "milestone-master__empty-desc",
                            children: [
                                "Create your first timeline level with ",
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                    children: "Add level"
                                }),
                                ". You can fine-tune the name and planned days in the dialog."
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                    className: "milestone-master-picker-grid",
                    children: sorted.map((p, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($f6cf58a0c1aaa9dd$var$TimelineLevelSummaryCard, {
                            phase: p,
                            levelIndex: i,
                            isActive: editModalPhaseId === p.id,
                            onOpen: ()=>openEditModal(p.id)
                        }, p.id))
                })
            }),
            createModalOpen ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "modal-backdrop",
                role: "presentation",
                onClick: ()=>{
                    closeCreateModal();
                },
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "modal milestone-master-modal",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "timeline-master-create-title",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "milestone-master-modal__header",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                    id: "timeline-master-create-title",
                                    className: "milestone-master-modal__title",
                                    children: "Add level"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--tg-secondary btn--sm",
                                    onClick: closeCreateModal,
                                    children: "Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "milestone-master-modal__body",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                            htmlFor: "new-ctp-title",
                                            children: "Level name"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                            id: "new-ctp-title",
                                            value: newTitle,
                                            onChange: (e)=>setNewTitle(e.target.value),
                                            placeholder: "e.g. Excavation",
                                            maxLength: 200
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                            htmlFor: "new-ctp-days",
                                            children: "Approximate days"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                            id: "new-ctp-days",
                                            type: "number",
                                            min: 0,
                                            step: 1,
                                            value: newDays,
                                            onChange: (e)=>setNewDays(e.target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "toolbar-row",
                                    style: {
                                        gap: "0.5rem",
                                        flexWrap: "wrap",
                                        marginTop: "0.75rem"
                                    },
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--primary btn--tg",
                                        disabled: !newTitle.trim(),
                                        onClick: ()=>{
                                            (async ()=>{
                                                const id = await addConstructionTimelinePhase({
                                                    title: newTitle.trim(),
                                                    approxDays: Math.max(0, Math.floor(Number(newDays)) || 0)
                                                });
                                                if (!id) return;
                                                closeCreateModal();
                                            })();
                                        },
                                        children: "Add level"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }) : null,
            editModalPhase && editModalIndex >= 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "modal-backdrop",
                role: "presentation",
                onClick: ()=>{
                    setEditModalPhaseId(null);
                },
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "modal milestone-master-modal",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "timeline-master-edit-title",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "milestone-master-modal__header",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                    id: "timeline-master-edit-title",
                                    className: "milestone-master-modal__title",
                                    children: "Edit level"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--tg-secondary btn--sm",
                                    onClick: ()=>setEditModalPhaseId(null),
                                    children: "Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "milestone-master-modal__body",
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($f6cf58a0c1aaa9dd$var$TimelineLevelEditorForm, {
                                phase: editModalPhase,
                                index: editModalIndex,
                                total: sorted.length,
                                onDeleted: ()=>setEditModalPhaseId(null)
                            }, editModalPhase.id)
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "milestone-master-editor-shell timeline-master-chart-section",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "milestone-master__catalog-title",
                        id: "timeline-master-preview-heading",
                        children: "Chart preview (plan only)"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "milestone-master__catalog-sub",
                        children: [
                            "Same layout as on a beneficiary file, without logged actuals. The right column shows ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "sample"
                            }),
                            " ",
                            "subcontractor portal thumbnails (SVG placeholders) so you can see how real photos appear after portal submission. Open a beneficiary from ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/subcontractor-to-beneficiary",
                                children: "Beneficiaries"
                            }),
                            " for live data."
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "card card--elevated beneficiary-dedicated-hub__panel beneficiary-dedicated-hub__panel--gantt",
                        style: {
                            marginTop: "1rem"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $9fd373c1f367b8f0$export$2d757ab5570a0ed6), {
                            phases: sorted,
                            actualDays: {},
                            preview: true,
                            phasePortalPhotos: samplePortalPhotos
                        })
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");








async function $0bced91eb1ccba4a$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
        if (j.message) return j.message;
    } catch  {}
    return text || `Request failed (${res.status})`;
}
async function $0bced91eb1ccba4a$export$dae64cbfe8074895() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/project-initiation`);
    if (!res.ok) throw new Error(await $0bced91eb1ccba4a$var$parseError(res));
    return res.json();
}
async function $0bced91eb1ccba4a$export$261b8e6880688d3(id) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/project-initiation/${encodeURIComponent(id)}`);
    if (!res.ok) throw new Error(await $0bced91eb1ccba4a$var$parseError(res));
    return res.json();
}
async function $0bced91eb1ccba4a$export$5eb11898ebc0a721(body) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/project-initiation`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $0bced91eb1ccba4a$var$parseError(res));
    return res.json();
}
async function $0bced91eb1ccba4a$export$4bb12da671ea38f9(id, body) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/project-initiation/${encodeURIComponent(id)}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await $0bced91eb1ccba4a$var$parseError(res));
    return res.json();
}
async function $0bced91eb1ccba4a$export$515673d2f21522f0(id) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/project-initiation/${encodeURIComponent(id)}`, {
        method: "DELETE"
    });
    if (!res.ok) throw new Error(await $0bced91eb1ccba4a$var$parseError(res));
}
async function $0bced91eb1ccba4a$export$af307dd512f8bb7c(q = {}) {
    const params = new URLSearchParams();
    if (q.district?.trim()) params.set("district", q.district.trim());
    if (q.mandal?.trim()) params.set("mandal", q.mandal.trim());
    if (q.village?.trim()) params.set("village", q.village.trim());
    if (q.search?.trim()) params.set("search", q.search.trim());
    if (q.zoneGroupId?.trim()) params.set("zoneGroupId", q.zoneGroupId.trim());
    if (q.limit) params.set("limit", String(q.limit));
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/project-initiation-apps?${params.toString()}`);
    if (!res.ok) throw new Error(await $0bced91eb1ccba4a$var$parseError(res));
    return res.json();
}
async function $0bced91eb1ccba4a$export$a75cb04423263638() {
    // Fetch categories and groups in parallel, merge category name onto each group
    const [catRes, grpRes] = await Promise.all([
        (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/geo/zone-group-categories`),
        (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/geo/zone-groups`)
    ]);
    if (!catRes.ok || !grpRes.ok) return [];
    const cats = await catRes.json();
    const grps = await grpRes.json();
    const catMap = new Map(cats.map((c)=>[
            c.id,
            c.name
        ]));
    return grps.map((g)=>({
            id: g.id,
            name: g.name,
            categoryId: g.categoryId,
            categoryName: catMap.get(g.categoryId) ?? "",
            zoneId: g.zoneId ?? ""
        }));
}






var $7UyaH = parcelRequire("7UyaH");
function $b0f18b868de5b6c3$export$df64d0a76ccb01ad(app) {
    const lines = [];
    const name = app.mobile.beneficiaryName.trim();
    if (name) lines.push(name);
    const plot = (app.sitePlot ?? "").trim();
    if (plot) lines.push(plot);
    const lat = (app.siteLatitude ?? "").trim();
    const lng = (app.siteLongitude ?? "").trim();
    if (lat || lng) lines.push(`Latitude: ${lat || "\u2014"}, Longitude: ${lng || "\u2014"}`);
    const state = (app.siteState ?? "").trim() || "Telangana";
    const geo = [
        app.village,
        app.mandal,
        app.district,
        state
    ].map((x)=>String(x ?? "").trim()).filter(Boolean);
    if (geo.length) lines.push(geo.join(", "));
    return lines.join("\n").trim() || "\u2014";
}
function $b0f18b868de5b6c3$export$a16863543f39a8be(store) {
    const name = store.name.trim();
    const addr = (store.address ?? "").trim();
    if (name && addr) return `${name}\n${addr}`;
    return name || addr || "\u2014";
}


function $250dac8a65e1623b$export$ed75c201738b864a({ open: open, storeYards: storeYards, onCancel: onCancel, onConfirm: onConfirm }) {
    const [storeYardId, setStoreYardId] = (0, $7UyaH.useState)("");
    (0, $7UyaH.useEffect)(()=>{
        if (!open) return;
        setStoreYardId(storeYards[0]?.id ?? "");
    }, [
        open,
        storeYards
    ]);
    const preview = (0, $7UyaH.useMemo)(()=>{
        const store = storeYards.find((s)=>s.id === storeYardId);
        return store ? (0, $b0f18b868de5b6c3$export$a16863543f39a8be)(store) : "";
    }, [
        storeYardId,
        storeYards
    ]);
    if (!open) return null;
    const canConfirm = Boolean(storeYardId.trim());
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "po-success-overlay",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "po-ship-title",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                type: "button",
                className: "po-success-overlay__backdrop",
                "aria-label": "Cancel",
                onClick: onCancel
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov",
                style: {
                    position: "relative",
                    zIndex: 2,
                    maxWidth: "32rem",
                    width: "100%",
                    margin: "1rem",
                    padding: "1.25rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        id: "po-ship-title",
                        className: "card__title card__title--gov",
                        style: {
                            marginTop: 0
                        },
                        children: "Shipping address for PO print"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        style: {
                            fontSize: "0.875rem",
                            marginTop: "-0.25rem"
                        },
                        children: "Select a store / yard. This is used only on the printed PO (Ship to / site). It does not change issue material or store stock."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                        className: "field field--full",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "field__label",
                                children: "Select store"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                                className: "form-control",
                                value: storeYardId,
                                onChange: (e)=>setStoreYardId(e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                        value: "",
                                        children: "\u2014 Choose store \u2014"
                                    }),
                                    storeYards.map((s)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                            value: s.id,
                                            children: s.name
                                        }, s.id))
                                ]
                            }),
                            storeYards.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-warning",
                                style: {
                                    fontSize: "0.8125rem",
                                    marginTop: "0.35rem"
                                },
                                children: "No stores in master. Add a store with an address under Stores & yards first."
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                        className: "field field--full",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "field__label",
                                children: "Address preview (on PO)"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                className: "form-control",
                                rows: 5,
                                readOnly: true,
                                value: preview
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "toolbar-row",
                        style: {
                            marginTop: "1rem",
                            marginBottom: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--tg-secondary",
                                onClick: onCancel,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--primary btn--tg",
                                disabled: !canConfirm || !preview.trim() || preview === "\u2014",
                                onClick: ()=>{
                                    if (storeYardId.trim()) onConfirm({
                                        storeYardId: storeYardId.trim()
                                    });
                                },
                                children: "Generate PO with this address"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}





var $7UyaH = parcelRequire("7UyaH");


function $b4a38ff5748e24ca$export$ab8ec7e0e8056a6d({ po: po, items: items, applications: applications, onClose: onClose, onCancel: onCancel }) {
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const [pdfBusy, setPdfBusy] = (0, $7UyaH.useState)(false);
    const [cancelBusy, setCancelBusy] = (0, $7UyaH.useState)(false);
    const previewHtml = (0, $7UyaH.useMemo)(()=>{
        try {
            return (0, $e33dc87250a15327$export$1a6d24e6d422f9b4)(po, items).html;
        } catch  {
            return "";
        }
    }, [
        po,
        items
    ]);
    (0, $7UyaH.useEffect)(()=>{
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return ()=>{
            document.body.style.overflow = prev;
        };
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        function onKey(e) {
            if (e.key === "Escape") onClose();
        }
        window.addEventListener("keydown", onKey);
        return ()=>window.removeEventListener("keydown", onKey);
    }, [
        onClose
    ]);
    const runDownload = (0, $7UyaH.useCallback)(async ()=>{
        setPdfBusy(true);
        try {
            await (0, $e33dc87250a15327$export$4fc88037a61ae2af)(po, items, {
                applications: applications
            });
            showToast(`PDF downloaded (${po.poNumber}).`, "success");
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not download PDF.", "error");
        } finally{
            setPdfBusy(false);
        }
    }, [
        po,
        items,
        applications,
        showToast
    ]);
    const runCancel = (0, $7UyaH.useCallback)(async ()=>{
        if (!onCancel) return;
        const ok = window.confirm(`Cancel PO ${po.poNumber}? It will be marked inactive and removed from PO lists. Any issue-material lines created with this PO (not yet issued) will also be removed.`);
        if (!ok) return;
        setCancelBusy(true);
        try {
            await onCancel();
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not cancel PO.", "error");
        } finally{
            setCancelBusy(false);
        }
    }, [
        onCancel,
        po.poNumber,
        showToast
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "po-success-overlay",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "po-success-title",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                type: "button",
                className: "po-success-overlay__backdrop",
                "aria-label": "Dismiss",
                onClick: onClose
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "po-success-modal",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "po-success-printer",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "po-success-printer__slot"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "po-success-printer__body"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "po-success-ticket-wrap",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("article", {
                            className: "po-success-ticket",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "po-success-ticket__perforation",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                    id: "po-success-title",
                                    className: "po-success-ticket__kicker",
                                    children: "Purchase order issued"
                                }),
                                previewHtml ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "po-success-ticket__doc-frame",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("iframe", {
                                        title: "Purchase order document",
                                        className: "po-success-ticket__iframe",
                                        srcDoc: previewHtml,
                                        scrolling: "yes"
                                    })
                                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                    className: "po-success-ticket__preview-fallback text-muted",
                                    children: "Could not build the on-screen PO preview. Use Download PDF if available."
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "po-success-ticket__actions",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                            type: "button",
                                            className: "btn btn--primary btn--tg btn--lg",
                                            disabled: pdfBusy || cancelBusy || !items.length,
                                            onClick: ()=>void runDownload(),
                                            children: pdfBusy ? "Saving\u2026" : "Download PDF"
                                        }),
                                        onCancel ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                            type: "button",
                                            className: "btn btn--danger btn--tg btn--lg",
                                            disabled: pdfBusy || cancelBusy,
                                            onClick: ()=>void runCancel(),
                                            children: cancelBusy ? "Cancelling\u2026" : "Cancel PO"
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--link btn--sm po-success-ticket__close",
                                    onClick: onClose,
                                    children: "Close"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}



/** Trim trailing zeros for qty input display (matches typical PO decimals). */ function $466faaf7f5001d36$var$formatQtyInputDisplay(n) {
    if (!Number.isFinite(n)) return "0";
    const s = n.toFixed(4).replace(/\.?0+$/, "");
    return s || "0";
}
/**
 * Step 3 default qty: remaining allowed after earlier POs for this milestone (when API loaded),
 * otherwise master planned qty until the check finishes.
 */ function $466faaf7f5001d36$var$poLineBaseQtyForRemaining(args) {
    const { masterQty: masterQty, itemId: itemId, remainingByItem: remainingByItem, remainingLoading: remainingLoading } = args;
    if (remainingLoading) return masterQty;
    const r = remainingByItem[itemId];
    if (r === undefined) return masterQty;
    return r;
}
function $466faaf7f5001d36$var$formatWhen(iso) {
    if (!iso) return "\u2014";
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? iso : d.toLocaleString();
}
function $466faaf7f5001d36$var$fmtInrAmount(n) {
    if (!Number.isFinite(n)) return "\u2014";
    return `\u{20B9}${n.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })}`;
}
function $466faaf7f5001d36$var$issueRowLookupKey(applicationId, milestoneTemplateId, standardResourceItemId) {
    return `${applicationId}\t${milestoneTemplateId}\t${standardResourceItemId}`;
}
function $466faaf7f5001d36$var$issueLineState(row) {
    if (!row) return "none";
    if (row.status === "completed" || row.balanceQty <= 0) return "completed";
    return "open";
}
function $466faaf7f5001d36$var$issueLineStateLabel(state) {
    if (state === "completed") return "Completed";
    if (state === "open") return "Open";
    return "Not created";
}
function $466faaf7f5001d36$var$evaluateIssueGeneration(lines) {
    if (lines.length === 0) return {
        canGenerate: false,
        message: "",
        showMessage: false
    };
    const hasNone = lines.some((s)=>s === "none");
    const allCompleted = lines.every((s)=>s === "completed");
    const allExist = lines.every((s)=>s !== "none");
    if (hasNone) return {
        canGenerate: true,
        message: "",
        showMessage: false
    };
    if (allCompleted) return {
        canGenerate: false,
        showMessage: true,
        message: "Material issue is already completed for this selection. No new issue rows can be generated. View records in the Register tab."
    };
    if (allExist) return {
        canGenerate: false,
        showMessage: true,
        message: "Issue rows already exist for these items. Use Inventory outward to dispatch remaining stock."
    };
    return {
        canGenerate: true,
        message: "",
        showMessage: false
    };
}
const $466faaf7f5001d36$var$STATUS_OPTIONS = [
    {
        id: "all",
        label: "All statuses"
    },
    {
        id: "pending",
        label: "Pending"
    },
    {
        id: "partial",
        label: "Partial"
    },
    {
        id: "completed",
        label: "Completed"
    }
];
function $466faaf7f5001d36$export$ea440fc09d663f6f({ section: section = "issue" }) {
    const { can: can } = (0, $a4dc0d923ddf5b19$export$1d39dc5b47e56ff0)();
    const { applications: applications, milestoneTemplates: milestoneTemplates, standardResources: standardResources, subcontractorMasters: subcontractorMasters, geoZones: geoZones, storeYards: storeYards } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    // Zone groups for filtering (loaded from API, same as ProjectInitiationPage)
    const [zoneGroupOptions, setZoneGroupOptions] = (0, $7UyaH.useState)([]);
    (0, $7UyaH.useEffect)(()=>{
        (0, $0bced91eb1ccba4a$export$a75cb04423263638)().then(setZoneGroupOptions).catch(()=>{});
    }, []);
    const canUsePo = can("inventory_issue_po");
    const isPoSection = section === "po";
    const isIssueSection = section === "issue";
    const [poViewMode, setPoViewMode] = (0, $7UyaH.useState)("generate");
    const [issueViewMode, setIssueViewMode] = (0, $7UyaH.useState)("generate");
    const [applicationId, setApplicationId] = (0, $7UyaH.useState)("");
    const [milestoneTemplateId, setMilestoneTemplateId] = (0, $7UyaH.useState)("");
    const [selectionMode, setSelectionMode] = (0, $7UyaH.useState)("all");
    const [issueBeneficiarySearch, setIssueBeneficiarySearch] = (0, $7UyaH.useState)("");
    const [issueDistrictFilter, setIssueDistrictFilter] = (0, $7UyaH.useState)("all");
    const [issueMandalFilter, setIssueMandalFilter] = (0, $7UyaH.useState)("all");
    const [issueVillageFilter, setIssueVillageFilter] = (0, $7UyaH.useState)("all");
    const [issueZoneGroupFilter, setIssueZoneGroupFilter] = (0, $7UyaH.useState)("all");
    const [selectedResourceIds, setSelectedResourceIds] = (0, $7UyaH.useState)([]);
    const [notes, setNotes] = (0, $7UyaH.useState)("");
    const [generating, setGenerating] = (0, $7UyaH.useState)(false);
    const [issueGenerateSubMode, setIssueGenerateSubMode] = (0, $7UyaH.useState)("manual");
    const [issueFromPoId, setIssueFromPoId] = (0, $7UyaH.useState)("");
    const [issueFromPoItems, setIssueFromPoItems] = (0, $7UyaH.useState)([]);
    const [issueFromPoItemsLoading, setIssueFromPoItemsLoading] = (0, $7UyaH.useState)(false);
    const [issueFromPoNotes, setIssueFromPoNotes] = (0, $7UyaH.useState)("");
    const [generatingFromPo, setGeneratingFromPo] = (0, $7UyaH.useState)(false);
    const [issueFromPoMode, setIssueFromPoMode] = (0, $7UyaH.useState)("full");
    const [issueFromPoQtyOverrides, setIssueFromPoQtyOverrides] = (0, $7UyaH.useState)({});
    const [openPoIdsForIssue, setOpenPoIdsForIssue] = (0, $7UyaH.useState)([]);
    const [openPoIdsForIssueLoading, setOpenPoIdsForIssueLoading] = (0, $7UyaH.useState)(false);
    const [issueFromPoBalance, setIssueFromPoBalance] = (0, $7UyaH.useState)([]);
    const [issueFromPoBalanceLoading, setIssueFromPoBalanceLoading] = (0, $7UyaH.useState)(false);
    const [rows, setRows] = (0, $7UyaH.useState)([]);
    const [allIssueRows, setAllIssueRows] = (0, $7UyaH.useState)([]);
    const [loadingRows, setLoadingRows] = (0, $7UyaH.useState)(true);
    const [rowsError, setRowsError] = (0, $7UyaH.useState)(null);
    const [filterStatus, setFilterStatus] = (0, $7UyaH.useState)("all");
    const [filterSearch, setFilterSearch] = (0, $7UyaH.useState)("");
    const [sortDir, setSortDir] = (0, $7UyaH.useState)("desc");
    const [poApplicationIds, setPoApplicationIds] = (0, $7UyaH.useState)([]);
    const [poMilestoneTemplateId, setPoMilestoneTemplateId] = (0, $7UyaH.useState)("");
    const [poSelectionMode, setPoSelectionMode] = (0, $7UyaH.useState)("full");
    const [poBeneficiarySearch, setPoBeneficiarySearch] = (0, $7UyaH.useState)("");
    const [poDistrictFilter, setPoDistrictFilter] = (0, $7UyaH.useState)("all");
    const [poMandalFilter, setPoMandalFilter] = (0, $7UyaH.useState)("all");
    const [poVillageFilter, setPoVillageFilter] = (0, $7UyaH.useState)("all");
    const [poZoneGroupFilter, setPoZoneGroupFilter] = (0, $7UyaH.useState)("all");
    const [poShowSelectedOnly, setPoShowSelectedOnly] = (0, $7UyaH.useState)(false);
    const [poSelectedResourceIds, setPoSelectedResourceIds] = (0, $7UyaH.useState)([]);
    const [poSelectedResourceItemIds, setPoSelectedResourceItemIds] = (0, $7UyaH.useState)([]);
    const [poQtyOverrides, setPoQtyOverrides] = (0, $7UyaH.useState)({});
    const [poGenerating, setPoGenerating] = (0, $7UyaH.useState)(false);
    const [poShipToModalOpen, setPoShipToModalOpen] = (0, $7UyaH.useState)(false);
    const [poRows, setPoRows] = (0, $7UyaH.useState)([]);
    const [poRowsLoading, setPoRowsLoading] = (0, $7UyaH.useState)(false);
    const [poRowsError, setPoRowsError] = (0, $7UyaH.useState)(null);
    const [selectedPoId, setSelectedPoId] = (0, $7UyaH.useState)("");
    const [selectedPoItems, setSelectedPoItems] = (0, $7UyaH.useState)([]);
    const [poItemsLoading, setPoItemsLoading] = (0, $7UyaH.useState)(false);
    const [poPdfDownloadingId, setPoPdfDownloadingId] = (0, $7UyaH.useState)("");
    const [poCancellingId, setPoCancellingId] = (0, $7UyaH.useState)("");
    /** Milestones where any selected beneficiary already has a full PO — omitted from Step 2 dropdown. */ const [poBlockedMilestoneTemplateIds, setPoBlockedMilestoneTemplateIds] = (0, $7UyaH.useState)([]);
    const [poBlockedFullPos, setPoBlockedFullPos] = (0, $7UyaH.useState)([]);
    const [poBlockedMilestonesLoading, setPoBlockedMilestonesLoading] = (0, $7UyaH.useState)(false);
    const [poGenerateSuccess, setPoGenerateSuccess] = (0, $7UyaH.useState)(null);
    /** Min remaining qty per standard resource item across selected beneficiaries (from API). */ const [poRemainingQtyByItemId, setPoRemainingQtyByItemId] = (0, $7UyaH.useState)({});
    const [poRemainingQtyLoading, setPoRemainingQtyLoading] = (0, $7UyaH.useState)(false);
    const [poAnalyticsData, setPoAnalyticsData] = (0, $7UyaH.useState)(null);
    const [poAnalyticsLoading, setPoAnalyticsLoading] = (0, $7UyaH.useState)(false);
    const [poAnalyticsError, setPoAnalyticsError] = (0, $7UyaH.useState)(null);
    const [issueAnalyticsData, setIssueAnalyticsData] = (0, $7UyaH.useState)(null);
    const [issueAnalyticsLoading, setIssueAnalyticsLoading] = (0, $7UyaH.useState)(false);
    const [issueAnalyticsError, setIssueAnalyticsError] = (0, $7UyaH.useState)(null);
    // All applications that have a subcontractor linked
    const subcontractorLinked = (0, $7UyaH.useMemo)(()=>applications.filter((a)=>Boolean(a.subcontractor.subcontractorMasterId)), [
        applications
    ]);
    // Eligible for PO: must ALSO have a project initiation (plannedStartDate set)
    const eligibleApplications = (0, $7UyaH.useMemo)(()=>subcontractorLinked.filter((a)=>Boolean(a.plannedStartDate)).sort((a, b)=>a.mobile.beneficiaryName.localeCompare(b.mobile.beneficiaryName)), [
        subcontractorLinked
    ]);
    // Blocked from PO: subcontractor linked but no project initiation yet
    const notInitiatedApplications = (0, $7UyaH.useMemo)(()=>subcontractorLinked.filter((a)=>!a.plannedStartDate).sort((a, b)=>a.mobile.beneficiaryName.localeCompare(b.mobile.beneficiaryName)), [
        subcontractorLinked
    ]);
    const appById = (0, $7UyaH.useMemo)(()=>new Map(applications.map((a)=>[
                a.id,
                a
            ])), [
        applications
    ]);
    const selectedMilestone = (0, $7UyaH.useMemo)(()=>milestoneTemplates.find((m)=>m.id === milestoneTemplateId), [
        milestoneTemplateId,
        milestoneTemplates
    ]);
    const selectedPoMilestone = (0, $7UyaH.useMemo)(()=>milestoneTemplates.find((m)=>m.id === poMilestoneTemplateId), [
        poMilestoneTemplateId,
        milestoneTemplates
    ]);
    const linkedResources = (0, $7UyaH.useMemo)(()=>{
        if (!selectedMilestone) return [];
        const set = new Set(selectedMilestone.linkedResourceIds);
        return standardResources.filter((r)=>set.has(r.id)).sort((a, b)=>a.title.localeCompare(b.title));
    }, [
        selectedMilestone,
        standardResources
    ]);
    const poLinkedResources = (0, $7UyaH.useMemo)(()=>{
        if (!selectedPoMilestone) return [];
        const set = new Set(selectedPoMilestone.linkedResourceIds);
        return standardResources.filter((r)=>set.has(r.id)).sort((a, b)=>a.title.localeCompare(b.title));
    }, [
        selectedPoMilestone,
        standardResources
    ]);
    const pickedResourceIds = (0, $7UyaH.useMemo)(()=>selectionMode === "all" ? linkedResources.map((r)=>r.id) : selectedResourceIds, [
        selectionMode,
        linkedResources,
        selectedResourceIds
    ]);
    const previewItems = (0, $7UyaH.useMemo)(()=>{
        const picked = new Set(pickedResourceIds);
        return linkedResources.filter((r)=>picked.has(r.id)).flatMap((resource)=>resource.items.map((item)=>({
                    resourceId: resource.id,
                    resourceTitle: resource.title,
                    itemId: item.id,
                    itemLabel: item.label,
                    qty: item.quantity,
                    unit: item.unit,
                    rate: item.rate ?? 0,
                    hsnCode: item.hsnCode ?? "",
                    catalogStandardItemId: item.catalogStandardItemId ?? ""
                })));
    }, [
        linkedResources,
        pickedResourceIds
    ]);
    const hasMissingCatalog = (0, $7UyaH.useMemo)(()=>previewItems.some((it)=>!it.catalogStandardItemId.trim()), [
        previewItems
    ]);
    const poPreviewItems = (0, $7UyaH.useMemo)(()=>{
        const pickedResources = poSelectionMode === "full" ? new Set(poLinkedResources.map((r)=>r.id)) : new Set(poSelectedResourceIds);
        let items = poLinkedResources.filter((r)=>pickedResources.has(r.id)).flatMap((resource)=>resource.items.map((item)=>({
                    resourceId: resource.id,
                    resourceTitle: resource.title,
                    itemId: item.id,
                    itemLabel: item.label,
                    qty: item.quantity,
                    unit: item.unit,
                    rate: item.rate ?? 0,
                    hsnCode: item.hsnCode ?? "",
                    catalogStandardItemId: item.catalogStandardItemId ?? ""
                })));
        if (poSelectionMode === "partial" && poSelectedResourceItemIds.length > 0) {
            const selected = new Set(poSelectedResourceItemIds);
            items = items.filter((it)=>selected.has(it.itemId));
        }
        return items;
    }, [
        poLinkedResources,
        poSelectedResourceIds,
        poSelectedResourceItemIds,
        poSelectionMode
    ]);
    const poHasMissingCatalog = (0, $7UyaH.useMemo)(()=>poPreviewItems.some((it)=>!it.catalogStandardItemId.trim()), [
        poPreviewItems
    ]);
    const poPreviewWithQty = (0, $7UyaH.useMemo)(()=>poPreviewItems.map((it)=>{
            const baseQty = $466faaf7f5001d36$var$poLineBaseQtyForRemaining({
                masterQty: it.qty,
                itemId: it.itemId,
                remainingByItem: poRemainingQtyByItemId,
                remainingLoading: poRemainingQtyLoading
            });
            const typed = poQtyOverrides[it.itemId];
            const parsed = typed == null || String(typed).trim() === "" ? NaN : (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(typed);
            const effectiveQty = parsed > 0 ? parsed : baseQty;
            const rate = it.rate ?? 0;
            const lineAmount = Math.round(effectiveQty * rate * 100) / 100;
            return {
                ...it,
                effectiveQty: effectiveQty,
                qtyInputValue: typed != null ? typed : $466faaf7f5001d36$var$formatQtyInputDisplay(baseQty),
                lineAmount: lineAmount
            };
        }), [
        poPreviewItems,
        poQtyOverrides,
        poRemainingQtyByItemId,
        poRemainingQtyLoading
    ]);
    const poSubcontractorValidation = (0, $7UyaH.useMemo)(()=>{
        if (!poApplicationIds.length) return {
            ok: true,
            subcontractorId: ""
        };
        const subIds = new Set(poApplicationIds.map((id)=>appById.get(id)?.subcontractor?.subcontractorMasterId ?? "").filter((x)=>String(x).trim()));
        if (subIds.size !== 1) return {
            ok: false,
            subcontractorId: ""
        };
        return {
            ok: true,
            subcontractorId: [
                ...subIds
            ][0]
        };
    }, [
        appById,
        poApplicationIds
    ]);
    const poDistrictOptions = (0, $7UyaH.useMemo)(()=>{
        const districts = [
            ...new Set(eligibleApplications.map((a)=>String(a.district).trim()).filter(Boolean))
        ];
        districts.sort((a, b)=>a.localeCompare(b));
        return districts;
    }, [
        eligibleApplications
    ]);
    const issueDistrictOptions = (0, $7UyaH.useMemo)(()=>{
        const districts = [
            ...new Set(eligibleApplications.map((a)=>String(a.district).trim()).filter(Boolean))
        ];
        districts.sort((a, b)=>a.localeCompare(b));
        return districts;
    }, [
        eligibleApplications
    ]);
    const issueMandalOptions = (0, $7UyaH.useMemo)(()=>{
        const list = eligibleApplications.filter((a)=>issueDistrictFilter === "all" || a.district === issueDistrictFilter).map((a)=>String(a.mandal).trim()).filter(Boolean);
        return [
            ...new Set(list)
        ].sort((a, b)=>a.localeCompare(b));
    }, [
        eligibleApplications,
        issueDistrictFilter
    ]);
    const issueVillageOptions = (0, $7UyaH.useMemo)(()=>{
        const list = eligibleApplications.filter((a)=>issueDistrictFilter === "all" || a.district === issueDistrictFilter).filter((a)=>issueMandalFilter === "all" || a.mandal === issueMandalFilter).map((a)=>String(a.village).trim()).filter(Boolean);
        return [
            ...new Set(list)
        ].sort((a, b)=>a.localeCompare(b));
    }, [
        eligibleApplications,
        issueDistrictFilter,
        issueMandalFilter
    ]);
    const filteredIssueBeneficiaries = (0, $7UyaH.useMemo)(()=>{
        const q = issueBeneficiarySearch.trim().toLowerCase();
        return eligibleApplications.filter((a)=>{
            if (issueDistrictFilter !== "all" && a.district !== issueDistrictFilter) return false;
            if (issueMandalFilter !== "all" && a.mandal !== issueMandalFilter) return false;
            if (issueVillageFilter !== "all" && a.village !== issueVillageFilter) return false;
            if (issueZoneGroupFilter !== "all") {
                const grpOption = zoneGroupOptions.find((g)=>g.id === issueZoneGroupFilter);
                if (grpOption) {
                    const matchingZone = geoZones.find((z)=>z.id === grpOption.zoneId);
                    if (!matchingZone || !(0, $51c57f3e5aa6a385$export$d6b86fbd35e4a8a4)(a, matchingZone)) return false;
                }
            }
            if (!q) return true;
            const name = a.mobile.beneficiaryName.toLowerCase();
            const appNo = a.mobile.applicationId.toLowerCase();
            return name.includes(q) || appNo.includes(q);
        });
    }, [
        eligibleApplications,
        issueBeneficiarySearch,
        issueDistrictFilter,
        issueMandalFilter,
        issueVillageFilter,
        issueZoneGroupFilter,
        zoneGroupOptions,
        geoZones
    ]);
    const poMandalOptions = (0, $7UyaH.useMemo)(()=>{
        const list = eligibleApplications.filter((a)=>poDistrictFilter === "all" || a.district === poDistrictFilter).map((a)=>String(a.mandal).trim()).filter(Boolean);
        return [
            ...new Set(list)
        ].sort((a, b)=>a.localeCompare(b));
    }, [
        eligibleApplications,
        poDistrictFilter
    ]);
    const poVillageOptions = (0, $7UyaH.useMemo)(()=>{
        const list = eligibleApplications.filter((a)=>poDistrictFilter === "all" || a.district === poDistrictFilter).filter((a)=>poMandalFilter === "all" || a.mandal === poMandalFilter).map((a)=>String(a.village).trim()).filter(Boolean);
        return [
            ...new Set(list)
        ].sort((a, b)=>a.localeCompare(b));
    }, [
        eligibleApplications,
        poDistrictFilter,
        poMandalFilter
    ]);
    const filteredPoBeneficiaries = (0, $7UyaH.useMemo)(()=>{
        const q = poBeneficiarySearch.trim().toLowerCase();
        return eligibleApplications.filter((a)=>{
            if (poDistrictFilter !== "all" && a.district !== poDistrictFilter) return false;
            if (poMandalFilter !== "all" && a.mandal !== poMandalFilter) return false;
            if (poVillageFilter !== "all" && a.village !== poVillageFilter) return false;
            if (poZoneGroupFilter !== "all") {
                const grpOption = zoneGroupOptions.find((g)=>g.id === poZoneGroupFilter);
                if (grpOption) {
                    const matchingZone = geoZones.find((z)=>z.id === grpOption.zoneId);
                    if (!matchingZone || !(0, $51c57f3e5aa6a385$export$d6b86fbd35e4a8a4)(a, matchingZone)) return false;
                }
            }
            if (!q) return true;
            const name = a.mobile.beneficiaryName.toLowerCase();
            const appNo = a.mobile.applicationId.toLowerCase();
            return name.includes(q) || appNo.includes(q);
        });
    }, [
        eligibleApplications,
        poBeneficiarySearch,
        poDistrictFilter,
        poMandalFilter,
        poVillageFilter,
        poZoneGroupFilter,
        zoneGroupOptions,
        geoZones
    ]);
    const visiblePoBeneficiaries = (0, $7UyaH.useMemo)(()=>poShowSelectedOnly ? filteredPoBeneficiaries.filter((a)=>poApplicationIds.includes(a.id)) : filteredPoBeneficiaries, [
        filteredPoBeneficiaries,
        poApplicationIds,
        poShowSelectedOnly
    ]);
    const poSelectedBeneficiaryNames = (0, $7UyaH.useMemo)(()=>poApplicationIds.map((id)=>appById.get(id)?.mobile?.beneficiaryName).filter((x)=>Boolean(x)), [
        appById,
        poApplicationIds
    ]);
    const subcontractorNameById = (0, $7UyaH.useMemo)(()=>new Map(subcontractorMasters.map((s)=>[
                s.id,
                s.firmName
            ])), [
        subcontractorMasters
    ]);
    const visiblePoBeneficiaryIds = (0, $7UyaH.useMemo)(()=>visiblePoBeneficiaries.map((a)=>a.id), [
        visiblePoBeneficiaries
    ]);
    const poAllVisibleSelected = (0, $7UyaH.useMemo)(()=>visiblePoBeneficiaryIds.length > 0 && visiblePoBeneficiaryIds.every((id)=>poApplicationIds.includes(id)), [
        visiblePoBeneficiaryIds,
        poApplicationIds
    ]);
    const poDistrictSelectOptions = (0, $7UyaH.useMemo)(()=>[
            {
                value: "all",
                label: "All districts"
            },
            ...poDistrictOptions.map((d)=>({
                    value: d,
                    label: d
                }))
        ], [
        poDistrictOptions
    ]);
    const poMandalSelectOptions = (0, $7UyaH.useMemo)(()=>[
            {
                value: "all",
                label: "All mandals"
            },
            ...poMandalOptions.map((m)=>({
                    value: m,
                    label: m
                }))
        ], [
        poMandalOptions
    ]);
    const poVillageSelectOptions = (0, $7UyaH.useMemo)(()=>[
            {
                value: "all",
                label: "All villages"
            },
            ...poVillageOptions.map((v)=>({
                    value: v,
                    label: v
                }))
        ], [
        poVillageOptions
    ]);
    const zoneGroupsByCategory = (0, $7UyaH.useMemo)(()=>zoneGroupOptions.reduce((acc, g)=>{
            const cat = g.categoryName || "General";
            (acc[cat] ??= []).push(g);
            return acc;
        }, {}), [
        zoneGroupOptions
    ]);
    const poZoneGroupSelectOptions = (0, $7UyaH.useMemo)(()=>{
        const opts = [
            {
                value: "all",
                label: "All groups"
            }
        ];
        for (const [cat, grps] of Object.entries(zoneGroupsByCategory))for (const g of grps)opts.push({
            value: g.id,
            label: `${cat}: ${g.name}`,
            group: cat
        });
        return opts;
    }, [
        zoneGroupsByCategory
    ]);
    const issueZoneGroupSelectOptions = (0, $7UyaH.useMemo)(()=>{
        const opts = [
            {
                value: "all",
                label: "All groups"
            }
        ];
        for (const [cat, grps] of Object.entries(zoneGroupsByCategory))for (const g of grps)opts.push({
            value: g.id,
            label: `${cat}: ${g.name}`
        });
        return opts;
    }, [
        zoneGroupsByCategory
    ]);
    const issueDistrictSelectOptions = (0, $7UyaH.useMemo)(()=>[
            {
                value: "all",
                label: "All districts"
            },
            ...issueDistrictOptions.map((d)=>({
                    value: d,
                    label: d
                }))
        ], [
        issueDistrictOptions
    ]);
    const issueMandalSelectOptions = (0, $7UyaH.useMemo)(()=>[
            {
                value: "all",
                label: "All mandals"
            },
            ...issueMandalOptions.map((m)=>({
                    value: m,
                    label: m
                }))
        ], [
        issueMandalOptions
    ]);
    const issueVillageSelectOptions = (0, $7UyaH.useMemo)(()=>[
            {
                value: "all",
                label: "All villages"
            },
            ...issueVillageOptions.map((v)=>({
                    value: v,
                    label: v
                }))
        ], [
        issueVillageOptions
    ]);
    const issueBeneficiarySelectOptions = (0, $7UyaH.useMemo)(()=>[
            {
                value: "",
                label: filteredIssueBeneficiaries.length ? "Select\u2026" : "No beneficiaries match filters"
            },
            ...filteredIssueBeneficiaries.map((a)=>({
                    value: a.id,
                    label: `${a.mobile.beneficiaryName} \u{2014} ${a.mobile.applicationId}`
                }))
        ], [
        filteredIssueBeneficiaries
    ]);
    const issueModeSelectOptions = (0, $7UyaH.useMemo)(()=>[
            {
                value: "all",
                label: "Entire milestone resources"
            },
            {
                value: "selected",
                label: "Selected resource(s)"
            }
        ], []);
    const poBlockedMilestoneIdSet = (0, $7UyaH.useMemo)(()=>new Set(poBlockedMilestoneTemplateIds), [
        poBlockedMilestoneTemplateIds
    ]);
    const poMilestoneSelectOptions = (0, $7UyaH.useMemo)(()=>{
        const templates = poApplicationIds.length > 0 && !poBlockedMilestonesLoading ? milestoneTemplates.filter((m)=>!poBlockedMilestoneIdSet.has(m.id)) : milestoneTemplates;
        return [
            {
                value: "",
                label: "Select\u2026"
            },
            ...templates.map((m)=>({
                    value: m.id,
                    label: m.title
                }))
        ];
    }, [
        milestoneTemplates,
        poApplicationIds.length,
        poBlockedMilestonesLoading,
        poBlockedMilestoneIdSet
    ]);
    const poModeSelectOptions = (0, $7UyaH.useMemo)(()=>[
            {
                value: "full",
                label: "Complete PO (all linked resources/items)"
            },
            {
                value: "partial",
                label: "Partial PO (selected resources/items)"
            }
        ], []);
    const poPreviewHasExhaustedQtyLine = (0, $7UyaH.useMemo)(()=>{
        if (poRemainingQtyLoading) return false;
        return poPreviewItems.some((it)=>{
            const r = poRemainingQtyByItemId[it.itemId];
            return r !== undefined && r <= 0;
        });
    }, [
        poPreviewItems,
        poRemainingQtyByItemId,
        poRemainingQtyLoading
    ]);
    const poCanGenerate = (0, $7UyaH.useMemo)(()=>{
        if (!poApplicationIds.length) return {
            ok: false,
            reason: "Select at least one beneficiary."
        };
        if (!poMilestoneTemplateId.trim()) return {
            ok: false,
            reason: "Select milestone."
        };
        if (poApplicationIds.length > 0 && poBlockedMilestonesLoading) return {
            ok: false,
            reason: "Updating milestone list for selected beneficiaries\u2026"
        };
        if (poApplicationIds.length > 0 && poMilestoneTemplateId.trim() && poRemainingQtyLoading) return {
            ok: false,
            reason: "Checking how much quantity is still allowed per line\u2026"
        };
        if (!poSubcontractorValidation.ok) return {
            ok: false,
            reason: "Selected beneficiaries must have same subcontractor."
        };
        if (poSelectionMode === "partial" && poSelectedResourceIds.length === 0 && poSelectedResourceItemIds.length === 0) return {
            ok: false,
            reason: "For partial PO, select resources or specific items."
        };
        if (!poPreviewItems.length) return {
            ok: false,
            reason: "No valid items selected for PO."
        };
        if (poHasMissingCatalog) return {
            ok: false,
            reason: "Some selected items are not linked to Item Master."
        };
        if (poPreviewHasExhaustedQtyLine) return {
            ok: false,
            reason: "One or more lines have no remaining quantity (already fully PO\u2019d) \u2014 remove those lines or change beneficiaries."
        };
        return {
            ok: true,
            reason: ""
        };
    }, [
        poApplicationIds,
        poMilestoneTemplateId,
        poSubcontractorValidation.ok,
        poSelectionMode,
        poSelectedResourceIds.length,
        poSelectedResourceItemIds.length,
        poPreviewItems.length,
        poHasMissingCatalog,
        poBlockedMilestonesLoading,
        poRemainingQtyLoading,
        poPreviewHasExhaustedQtyLine
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!canUsePo || !isPoSection || poViewMode !== "generate") return;
        if (!poApplicationIds.length) {
            setPoBlockedMilestoneTemplateIds([]);
            setPoBlockedFullPos([]);
            setPoBlockedMilestonesLoading(false);
            return;
        }
        let cancelled = false;
        setPoBlockedMilestonesLoading(true);
        (0, $f5510818538731b9$export$c07542c0e6c2ce3d)(poApplicationIds).then((data)=>{
            if (!cancelled) {
                setPoBlockedMilestoneTemplateIds(data.milestoneTemplateIds ?? []);
                setPoBlockedFullPos(data.blockedFullPos ?? []);
            }
        }).catch((e)=>{
            if (!cancelled) {
                setPoBlockedMilestoneTemplateIds([]);
                setPoBlockedFullPos([]);
                showToast(e instanceof Error ? e.message : "Could not load milestone eligibility for beneficiaries.", "error");
            }
        }).finally(()=>{
            if (!cancelled) setPoBlockedMilestonesLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        canUsePo,
        isPoSection,
        poViewMode,
        poApplicationIds,
        showToast
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!canUsePo || !isPoSection || poViewMode !== "generate") return;
        const mid = poMilestoneTemplateId.trim();
        if (!mid || !poApplicationIds.length) {
            setPoRemainingQtyByItemId({});
            setPoRemainingQtyLoading(false);
            return;
        }
        let cancelled = false;
        setPoRemainingQtyLoading(true);
        (0, $f5510818538731b9$export$c174743d83e21f46)({
            milestoneTemplateId: mid,
            applicationIds: poApplicationIds
        }).then((data)=>{
            if (!cancelled) setPoRemainingQtyByItemId(data.remainingQtyByStandardResourceItemId ?? {});
        }).catch((e)=>{
            if (!cancelled) {
                setPoRemainingQtyByItemId({});
                showToast(e instanceof Error ? e.message : "Could not load remaining PO quantities for selected beneficiaries.", "error");
            }
        }).finally(()=>{
            if (!cancelled) setPoRemainingQtyLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        canUsePo,
        isPoSection,
        poViewMode,
        poMilestoneTemplateId,
        poApplicationIds,
        showToast
    ]);
    (0, $7UyaH.useEffect)(()=>{
        const blocked = new Set(poBlockedMilestoneTemplateIds);
        if (poMilestoneTemplateId && blocked.has(poMilestoneTemplateId)) setPoMilestoneTemplateId("");
    }, [
        poMilestoneTemplateId,
        poBlockedMilestoneTemplateIds
    ]);
    (0, $7UyaH.useEffect)(()=>{
        setPoMandalFilter("all");
        setPoVillageFilter("all");
        setPoZoneGroupFilter("all");
    }, [
        poDistrictFilter
    ]);
    (0, $7UyaH.useEffect)(()=>{
        setPoVillageFilter("all");
    }, [
        poMandalFilter
    ]);
    (0, $7UyaH.useEffect)(()=>{
        setIssueMandalFilter("all");
        setIssueVillageFilter("all");
        setIssueZoneGroupFilter("all");
    }, [
        issueDistrictFilter
    ]);
    (0, $7UyaH.useEffect)(()=>{
        setIssueVillageFilter("all");
    }, [
        issueMandalFilter
    ]);
    // When zone group is picked, reset district/mandal/village (mutually exclusive quick-filter)
    (0, $7UyaH.useEffect)(()=>{
        if (poZoneGroupFilter !== "all") {
            setPoDistrictFilter("all");
            setPoMandalFilter("all");
            setPoVillageFilter("all");
        }
    }, [
        poZoneGroupFilter
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (issueZoneGroupFilter !== "all") {
            setIssueDistrictFilter("all");
            setIssueMandalFilter("all");
            setIssueVillageFilter("all");
        }
    }, [
        issueZoneGroupFilter
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!canUsePo && issueGenerateSubMode === "fromPo") setIssueGenerateSubMode("manual");
    }, [
        canUsePo,
        issueGenerateSubMode
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!applicationId) return;
        const validIds = new Set(filteredIssueBeneficiaries.map((a)=>a.id));
        if (!validIds.has(applicationId)) setApplicationId("");
    }, [
        applicationId,
        filteredIssueBeneficiaries
    ]);
    (0, $7UyaH.useEffect)(()=>{
        setSelectedResourceIds([]);
    }, [
        milestoneTemplateId
    ]);
    (0, $7UyaH.useEffect)(()=>{
        setPoSelectedResourceIds([]);
        setPoSelectedResourceItemIds([]);
        setPoQtyOverrides({});
    }, [
        poMilestoneTemplateId
    ]);
    (0, $7UyaH.useEffect)(()=>{
        setPoQtyOverrides((prev)=>{
            const next = {
                ...prev
            };
            const valid = new Set(poPreviewItems.map((it)=>it.itemId));
            for (const key of Object.keys(next))if (!valid.has(key)) delete next[key];
            return next;
        });
    }, [
        poPreviewItems
    ]);
    const loadRows = (0, $7UyaH.useCallback)(async ()=>{
        setLoadingRows(true);
        setRowsError(null);
        try {
            const list = await (0, $f5510818538731b9$export$8ae7398780b7bae5)({
                limit: 1500,
                status: filterStatus === "all" ? undefined : filterStatus,
                search: filterSearch.trim() || undefined,
                sort: sortDir
            });
            setRows(list);
        } catch (e) {
            setRows([]);
            setRowsError(e instanceof Error ? e.message : String(e));
        } finally{
            setLoadingRows(false);
        }
    }, [
        filterSearch,
        filterStatus,
        sortDir
    ]);
    (0, $7UyaH.useEffect)(()=>{
        loadRows();
    }, [
        loadRows
    ]);
    const loadAllIssueRows = (0, $7UyaH.useCallback)(async ()=>{
        try {
            const list = await (0, $f5510818538731b9$export$8ae7398780b7bae5)({
                limit: 2000,
                sort: "desc"
            });
            setAllIssueRows(list);
        } catch  {
            setAllIssueRows([]);
        }
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        if (isIssueSection && issueViewMode === "generate") loadAllIssueRows();
    }, [
        isIssueSection,
        issueViewMode,
        loadAllIssueRows
    ]);
    const issueRowByKey = (0, $7UyaH.useMemo)(()=>{
        const map = new Map();
        for (const row of allIssueRows)map.set($466faaf7f5001d36$var$issueRowLookupKey(row.applicationId, row.milestoneTemplateId, row.standardResourceItemId), row);
        return map;
    }, [
        allIssueRows
    ]);
    const manualIssueGenerateState = (0, $7UyaH.useMemo)(()=>{
        if (!applicationId.trim() || !milestoneTemplateId.trim() || previewItems.length === 0) return {
            canGenerate: false,
            message: "",
            showMessage: false
        };
        const app = applicationId.trim();
        const ms = milestoneTemplateId.trim();
        const lineStates = previewItems.map((it)=>$466faaf7f5001d36$var$issueLineState(issueRowByKey.get($466faaf7f5001d36$var$issueRowLookupKey(app, ms, it.itemId))));
        return $466faaf7f5001d36$var$evaluateIssueGeneration(lineStates);
    }, [
        applicationId,
        milestoneTemplateId,
        previewItems,
        issueRowByKey
    ]);
    const issueFromPoBalanceByItemId = (0, $7UyaH.useMemo)(()=>{
        const map = new Map();
        for (const line of issueFromPoBalance)map.set(line.poItemId, line);
        return map;
    }, [
        issueFromPoBalance
    ]);
    const loadOpenPoIdsForIssue = (0, $7UyaH.useCallback)(async ()=>{
        setOpenPoIdsForIssueLoading(true);
        try {
            const ids = await (0, $f5510818538731b9$export$3d876b601a2feeb)();
            setOpenPoIdsForIssue(ids);
        } catch  {
            setOpenPoIdsForIssue([]);
        } finally{
            setOpenPoIdsForIssueLoading(false);
        }
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        if (!canUsePo || !isIssueSection || issueViewMode !== "generate" || issueGenerateSubMode !== "fromPo") return;
        loadOpenPoIdsForIssue();
    }, [
        canUsePo,
        isIssueSection,
        issueViewMode,
        issueGenerateSubMode,
        loadOpenPoIdsForIssue
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!issueFromPoId.trim()) {
            setIssueFromPoBalance([]);
            return;
        }
        let cancelled = false;
        setIssueFromPoBalanceLoading(true);
        (0, $f5510818538731b9$export$54291f157608c7ce)(issueFromPoId.trim()).then((data)=>{
            if (!cancelled) setIssueFromPoBalance(data.items);
        }).catch(()=>{
            if (!cancelled) setIssueFromPoBalance([]);
        }).finally(()=>{
            if (!cancelled) setIssueFromPoBalanceLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        issueFromPoId
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (issueFromPoMode !== "full") return;
        const next = {};
        for (const it of issueFromPoItems){
            const bal = issueFromPoBalanceByItemId.get(it.id);
            const yetTo = bal?.yetToIssue ?? it.plannedQty;
            if (yetTo > 0) next[it.id] = $466faaf7f5001d36$var$formatQtyInputDisplay(yetTo);
        }
        setIssueFromPoQtyOverrides(next);
    }, [
        issueFromPoMode,
        issueFromPoItems,
        issueFromPoBalanceByItemId
    ]);
    (0, $7UyaH.useEffect)(()=>{
        setIssueFromPoQtyOverrides({});
        setIssueFromPoMode("full");
    }, [
        issueFromPoId
    ]);
    const issueFromPoGenerateState = (0, $7UyaH.useMemo)(()=>{
        if (!issueFromPoId.trim() || issueFromPoItemsLoading || issueFromPoBalanceLoading) return {
            canGenerate: false,
            message: "",
            showMessage: false
        };
        if (issueFromPoItems.length === 0) return {
            canGenerate: false,
            message: "",
            showMessage: false
        };
        const hasOpen = issueFromPoBalance.some((l)=>l.yetToIssue > 0);
        if (!hasOpen) return {
            canGenerate: false,
            showMessage: true,
            message: "This PO is fully issued. No remaining PO quantity to issue."
        };
        let totalIssueQty = 0;
        for (const it of issueFromPoItems){
            const bal = issueFromPoBalanceByItemId.get(it.id);
            const yetTo = bal?.yetToIssue ?? 0;
            if (!(yetTo > 0)) continue;
            let issueQty;
            if (issueFromPoMode === "full") issueQty = yetTo;
            else {
                const raw = issueFromPoQtyOverrides[it.id];
                if (raw == null || String(raw).trim() === "") continue;
                issueQty = (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(raw);
                if (!(issueQty > 0)) return {
                    canGenerate: false,
                    showMessage: true,
                    message: `Enter a quantity greater than zero for "${it.resourceItemLabel}" or leave it blank.`
                };
                if (issueQty - yetTo > 0.000001) return {
                    canGenerate: false,
                    showMessage: true,
                    message: `Issue quantity for "${it.resourceItemLabel}" exceeds yet to issue (${$466faaf7f5001d36$var$formatQtyInputDisplay(yetTo)}).`
                };
            }
            totalIssueQty += issueQty;
        }
        if (!(totalIssueQty > 0)) return {
            canGenerate: false,
            showMessage: true,
            message: issueFromPoMode === "partial" ? "Enter issue quantity for at least one line with remaining PO balance." : "No remaining PO quantity to issue on the selected lines."
        };
        return {
            canGenerate: true,
            message: "",
            showMessage: false
        };
    }, [
        issueFromPoId,
        issueFromPoItems,
        issueFromPoItemsLoading,
        issueFromPoBalanceLoading,
        issueFromPoBalance,
        issueFromPoBalanceByItemId,
        issueFromPoMode,
        issueFromPoQtyOverrides
    ]);
    const loadPoRows = (0, $7UyaH.useCallback)(async ()=>{
        setPoRowsLoading(true);
        setPoRowsError(null);
        try {
            const list = await (0, $f5510818538731b9$export$199cc1209b09073e)({
                limit: 1000,
                sort: "desc"
            });
            setPoRows(list);
        } catch (e) {
            setPoRows([]);
            setPoRowsError(e instanceof Error ? e.message : String(e));
        } finally{
            setPoRowsLoading(false);
        }
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        if (!canUsePo) return;
        loadPoRows();
    }, [
        canUsePo,
        loadPoRows
    ]);
    const loadPoAnalytics = (0, $7UyaH.useCallback)(async ()=>{
        setPoAnalyticsLoading(true);
        setPoAnalyticsError(null);
        try {
            const data = await (0, $f5510818538731b9$export$ac344e3ef6210f97)();
            setPoAnalyticsData(data);
        } catch (e) {
            setPoAnalyticsData(null);
            setPoAnalyticsError(e instanceof Error ? e.message : String(e));
        } finally{
            setPoAnalyticsLoading(false);
        }
    }, []);
    const loadIssueAnalytics = (0, $7UyaH.useCallback)(async ()=>{
        setIssueAnalyticsLoading(true);
        setIssueAnalyticsError(null);
        try {
            const data = await (0, $f5510818538731b9$export$104fbd1210c34e9d)();
            setIssueAnalyticsData(data);
        } catch (e) {
            setIssueAnalyticsData(null);
            setIssueAnalyticsError(e instanceof Error ? e.message : String(e));
        } finally{
            setIssueAnalyticsLoading(false);
        }
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        if (!isPoSection || poViewMode !== "register" || !canUsePo) return;
        loadPoAnalytics();
    }, [
        isPoSection,
        poViewMode,
        canUsePo,
        loadPoAnalytics
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!isIssueSection || issueViewMode !== "register") return;
        loadIssueAnalytics();
        if (canUsePo) loadPoAnalytics();
    }, [
        isIssueSection,
        issueViewMode,
        canUsePo,
        loadIssueAnalytics,
        loadPoAnalytics
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!selectedPoId) {
            setSelectedPoItems([]);
            return;
        }
        let cancelled = false;
        setPoItemsLoading(true);
        (0, $f5510818538731b9$export$49a2b5a16b830ea4)(selectedPoId).then((items)=>{
            if (!cancelled) setSelectedPoItems(items);
        }).catch((e)=>{
            if (!cancelled) showToast(e instanceof Error ? e.message : "Could not load PO items.", "error");
        }).finally(()=>{
            if (!cancelled) setPoItemsLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        selectedPoId,
        showToast
    ]);
    (0, $7UyaH.useEffect)(()=>{
        const active = isIssueSection && issueViewMode === "generate" && issueGenerateSubMode === "fromPo" && issueFromPoId.trim();
        if (!active) {
            setIssueFromPoItems([]);
            return;
        }
        let cancelled = false;
        const id = issueFromPoId.trim();
        setIssueFromPoItemsLoading(true);
        (0, $f5510818538731b9$export$49a2b5a16b830ea4)(id).then((items)=>{
            if (!cancelled) setIssueFromPoItems(items);
        }).catch((e)=>{
            if (!cancelled) {
                setIssueFromPoItems([]);
                showToast(e instanceof Error ? e.message : "Could not load PO lines.", "error");
            }
        }).finally(()=>{
            if (!cancelled) setIssueFromPoItemsLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        isIssueSection,
        issueViewMode,
        issueGenerateSubMode,
        issueFromPoId,
        showToast
    ]);
    const issueFromPoSelectOptions = (0, $7UyaH.useMemo)(()=>{
        const openSet = new Set(openPoIdsForIssue);
        const eligible = poRows.filter((p)=>openSet.has(p.id));
        return [
            {
                value: "",
                label: poRowsLoading || openPoIdsForIssueLoading ? "Loading POs\u2026" : eligible.length ? "Select PO\u2026" : "No POs with pending issue balance"
            },
            ...eligible.map((p)=>({
                    value: p.id,
                    label: `${p.poNumber} \xb7 ${p.milestoneTitle} \xb7 ${p.subcontractorFirmName}`
                }))
        ];
    }, [
        poRows,
        poRowsLoading,
        openPoIdsForIssue,
        openPoIdsForIssueLoading
    ]);
    const issueFromPoHeader = (0, $7UyaH.useMemo)(()=>issueFromPoId.trim() ? poRows.find((p)=>p.id === issueFromPoId.trim()) : undefined, [
        poRows,
        issueFromPoId
    ]);
    const issueFromPoHintMessage = (0, $7UyaH.useMemo)(()=>{
        if (issueFromPoGenerateState.showMessage) return issueFromPoGenerateState.message;
        return "";
    }, [
        issueFromPoGenerateState
    ]);
    const handleDownloadPoPdfRow = (0, $7UyaH.useCallback)(async (header)=>{
        setPoPdfDownloadingId(header.id);
        try {
            const items = await (0, $f5510818538731b9$export$49a2b5a16b830ea4)(header.id);
            if (!items.length) {
                showToast("This PO has no lines to export.", "error");
                return;
            }
            await (0, $e33dc87250a15327$export$4fc88037a61ae2af)(header, items, {
                applications: applications
            });
            showToast(`PDF downloaded (${header.poNumber}).`, "success");
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not download PDF.", "error");
        } finally{
            setPoPdfDownloadingId("");
        }
    }, [
        applications,
        showToast
    ]);
    const handleCancelPoRow = (0, $7UyaH.useCallback)(async (header)=>{
        const ok = window.confirm(`Cancel PO ${header.poNumber}? It will be marked inactive and removed from PO lists. Any issue-material lines created with this PO (not yet issued) will also be removed.`);
        if (!ok) return;
        setPoCancellingId(header.id);
        try {
            const { removedIssueMaterialRows: removedIssueMaterialRows } = await (0, $f5510818538731b9$export$c31671a30009576)(header.id);
            if (selectedPoId === header.id) setSelectedPoId("");
            await Promise.all([
                loadPoRows(),
                loadRows(),
                loadPoAnalytics(),
                loadIssueAnalytics()
            ]);
            const extra = removedIssueMaterialRows > 0 ? ` \xb7 ${removedIssueMaterialRows} issue material row(s) removed` : "";
            showToast(`PO ${header.poNumber} cancelled${extra}.`, "success");
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not cancel PO.", "error");
        } finally{
            setPoCancellingId("");
        }
    }, [
        loadPoRows,
        loadRows,
        loadPoAnalytics,
        loadIssueAnalytics,
        selectedPoId,
        showToast
    ]);
    async function handleGenerate() {
        if (!applicationId.trim()) {
            showToast("Select beneficiary.", "error");
            return;
        }
        if (!milestoneTemplateId.trim()) {
            showToast("Select milestone.", "error");
            return;
        }
        if (!selectedMilestone?.linkedResourceIds.length) {
            showToast("Selected milestone has no linked standard resources.", "error");
            return;
        }
        if (selectionMode === "selected" && selectedResourceIds.length === 0) {
            showToast("Select at least one standard resource.", "error");
            return;
        }
        if (previewItems.length === 0) {
            showToast("No valid resource items found for selection.", "error");
            return;
        }
        if (hasMissingCatalog) {
            showToast("Some resource items are not linked to Item Master. Fix in Standard Resources master.", "error");
            return;
        }
        if (!manualIssueGenerateState.canGenerate) {
            showToast(manualIssueGenerateState.message || "Cannot generate issue rows for this selection.", "error");
            return;
        }
        setGenerating(true);
        try {
            const result = await (0, $f5510818538731b9$export$9e1eaee4574c732d)({
                applicationId: applicationId.trim(),
                milestoneTemplateId: milestoneTemplateId.trim(),
                mode: selectionMode,
                selectedResourceIds: selectionMode === "selected" ? selectedResourceIds : undefined,
                notes: notes.trim() || undefined
            });
            showToast(`Issue rows updated. Created: ${result.created}, skipped existing: ${result.skipped}`, "success");
            setNotes("");
            await Promise.all([
                loadRows(),
                loadIssueAnalytics(),
                loadAllIssueRows()
            ]);
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not generate issue rows.", "error");
        } finally{
            setGenerating(false);
        }
    }
    async function handleGenerateIssueFromPo() {
        if (!issueFromPoId.trim()) {
            showToast("Select a PO.", "error");
            return;
        }
        if (issueFromPoItemsLoading) {
            showToast("Still loading PO lines\u2026", "error");
            return;
        }
        if (issueFromPoItems.length === 0) {
            showToast("This PO has no lines to issue.", "error");
            return;
        }
        if (!issueFromPoGenerateState.canGenerate) {
            showToast(issueFromPoGenerateState.message || "Cannot create issue rows from this PO.", "error");
            return;
        }
        setGeneratingFromPo(true);
        try {
            const quantityOverrides = {};
            if (issueFromPoMode === "partial") for (const it of issueFromPoItems){
                const bal = issueFromPoBalanceByItemId.get(it.id);
                const yetTo = bal?.yetToIssue ?? 0;
                if (!(yetTo > 0)) continue;
                const raw = issueFromPoQtyOverrides[it.id];
                if (raw == null || String(raw).trim() === "") continue;
                const qty = (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(raw);
                if (qty > 0) quantityOverrides[it.id] = qty;
            }
            const result = await (0, $f5510818538731b9$export$3a7b1232eff56131)({
                poId: issueFromPoId.trim(),
                notes: issueFromPoNotes.trim() || undefined,
                mode: issueFromPoMode,
                quantityOverrides: issueFromPoMode === "partial" ? quantityOverrides : undefined
            });
            showToast(`PO ${result.poNumber}: ${result.created} issue row(s) created \xb7 ${result.beneficiaryCount} beneficiary(ies). Use Inventory outward to dispatch.`, "success");
            setIssueFromPoNotes("");
            const balanceData = await (0, $f5510818538731b9$export$54291f157608c7ce)(issueFromPoId.trim());
            setIssueFromPoBalance(balanceData.items);
            await Promise.all([
                loadRows(),
                loadIssueAnalytics(),
                loadAllIssueRows(),
                loadOpenPoIdsForIssue()
            ]);
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not create issue rows from PO.", "error");
        } finally{
            setGeneratingFromPo(false);
        }
    }
    function buildPoQtyOverrides() {
        const qtyOverrides = {};
        for (const it of poPreviewItems){
            const baseQty = $466faaf7f5001d36$var$poLineBaseQtyForRemaining({
                masterQty: it.qty,
                itemId: it.itemId,
                remainingByItem: poRemainingQtyByItemId,
                remainingLoading: poRemainingQtyLoading
            });
            const raw = poQtyOverrides[it.itemId];
            const parsed = raw != null && String(raw).trim() !== "" ? (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(raw) : baseQty;
            if (!(parsed > 0)) {
                showToast(`Quantity must be greater than zero for item: ${it.itemLabel}`, "error");
                return null;
            }
            if (Math.abs(parsed - it.qty) > 0.0000001) qtyOverrides[it.itemId] = parsed;
        }
        return qtyOverrides;
    }
    function openPoShipToModal() {
        if (!poApplicationIds.length) {
            showToast("Select at least one beneficiary.", "error");
            return;
        }
        if (!poMilestoneTemplateId.trim()) {
            showToast("Select milestone.", "error");
            return;
        }
        if (!poSubcontractorValidation.ok) {
            showToast("Selected beneficiaries must belong to the same subcontractor.", "error");
            return;
        }
        if (poSelectionMode === "partial" && poSelectedResourceIds.length === 0 && poSelectedResourceItemIds.length === 0) {
            showToast("For partial PO, select resources and/or specific items.", "error");
            return;
        }
        if (!poPreviewItems.length) {
            showToast("No valid items selected for PO.", "error");
            return;
        }
        if (poHasMissingCatalog) {
            showToast("Some selected items are not linked to Item Master.", "error");
            return;
        }
        if (buildPoQtyOverrides() === null) return;
        setPoShipToModalOpen(true);
    }
    async function runGeneratePoWithShipTo(shipTo) {
        const qtyOverrides = buildPoQtyOverrides();
        if (qtyOverrides === null) return;
        setPoShipToModalOpen(false);
        setPoGenerating(true);
        try {
            const shipToApi = {
                kind: "store",
                storeYardId: shipTo.storeYardId
            };
            const result = await (0, $f5510818538731b9$export$a0f770912cdc0acb)({
                milestoneTemplateId: poMilestoneTemplateId.trim(),
                applicationIds: poApplicationIds,
                selectionMode: poSelectionMode,
                selectedResourceIds: poSelectionMode === "partial" ? poSelectedResourceIds : undefined,
                selectedResourceItemIds: poSelectionMode === "partial" ? poSelectedResourceItemIds : undefined,
                quantityOverrides: Object.keys(qtyOverrides).length ? qtyOverrides : undefined,
                shipTo: shipToApi
            });
            setPoGenerateSuccess({
                po: result.po,
                items: result.items
            });
            setSelectedPoId(result.po.id);
            setPoQtyOverrides({});
            await Promise.all([
                loadPoRows(),
                loadRows(),
                loadPoAnalytics(),
                loadIssueAnalytics()
            ]);
        } catch (e) {
            showToast(e instanceof Error ? e.message : "Could not generate PO.", "error");
        } finally{
            setPoGenerating(false);
        }
    }
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "issue-material-register-page",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Inventory",
                        to: "/inventory/inward"
                    },
                    {
                        label: isPoSection ? "PO Register" : "Material Register"
                    }
                ],
                title: isPoSection ? "PO Register" : "Material Register",
                actions: isPoSection && canUsePo ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                    className: "btn btn--tg-secondary btn--sm",
                    to: "/inventory/po-format",
                    children: "PO format"
                }) : undefined
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $250dac8a65e1623b$export$ed75c201738b864a), {
                open: poShipToModalOpen,
                storeYards: storeYards,
                onCancel: ()=>setPoShipToModalOpen(false),
                onConfirm: (choice)=>void runGeneratePoWithShipTo(choice)
            }),
            poGenerateSuccess ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $b4a38ff5748e24ca$export$ab8ec7e0e8056a6d), {
                po: poGenerateSuccess.po,
                items: poGenerateSuccess.items,
                applications: applications,
                onClose: ()=>setPoGenerateSuccess(null),
                onCancel: async ()=>{
                    const { removedIssueMaterialRows: removedIssueMaterialRows } = await (0, $f5510818538731b9$export$c31671a30009576)(poGenerateSuccess.po.id);
                    setPoGenerateSuccess(null);
                    setSelectedPoId("");
                    await Promise.all([
                        loadPoRows(),
                        loadRows(),
                        loadPoAnalytics(),
                        loadIssueAnalytics()
                    ]);
                    const extra = removedIssueMaterialRows > 0 ? ` \xb7 ${removedIssueMaterialRows} issue material row(s) removed` : "";
                    showToast(`PO ${poGenerateSuccess.po.poNumber} cancelled${extra}.`, "success");
                }
            }) : null,
            isPoSection && canUsePo ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "issue-mode-toggle-wrap",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "issue-mode-toggle",
                    role: "tablist",
                    "aria-label": "Issue material mode",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            role: "tab",
                            "aria-selected": poViewMode === "generate",
                            className: `issue-mode-toggle__btn ${poViewMode === "generate" ? "is-active" : ""}`,
                            onClick: ()=>setPoViewMode("generate"),
                            children: "Generate PO"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            role: "tab",
                            "aria-selected": poViewMode === "register",
                            className: `issue-mode-toggle__btn ${poViewMode === "register" ? "is-active" : ""}`,
                            onClick: ()=>setPoViewMode("register"),
                            children: "PO Register"
                        })
                    ]
                })
            }) : null,
            isIssueSection ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "issue-mode-toggle-wrap",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "issue-mode-toggle",
                    role: "tablist",
                    "aria-label": "Issue material mode",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            role: "tab",
                            "aria-selected": issueViewMode === "generate",
                            className: `issue-mode-toggle__btn ${issueViewMode === "generate" ? "is-active" : ""}`,
                            onClick: ()=>setIssueViewMode("generate"),
                            children: "Issue Material"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            role: "tab",
                            "aria-selected": issueViewMode === "register",
                            className: `issue-mode-toggle__btn ${issueViewMode === "register" ? "is-active" : ""}`,
                            onClick: ()=>setIssueViewMode("register"),
                            children: "Register"
                        })
                    ]
                })
            }) : null,
            isPoSection && canUsePo && poViewMode === "generate" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                style: {
                    marginBottom: "1.25rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "section-lead section-lead--tight text-muted",
                        style: {
                            marginTop: 0
                        },
                        children: "Generate beneficiary-wise PO for selected milestone resources. Single or multiple beneficiaries are supported only when they belong to the same subcontractor. Generated PO auto-creates Issue Material rows."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        children: "Generate PO"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "text-muted",
                        style: {
                            marginTop: "-0.35rem",
                            marginBottom: "0.75rem",
                            fontSize: "0.88rem"
                        },
                        children: [
                            "Step 1: Choose beneficiaries ",
                            "->",
                            " Step 2: Choose milestone and full/partial mode ",
                            "->",
                            " Step 3: Review/edit quantities below, then generate PO."
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "text-muted",
                        style: {
                            marginTop: "-0.5rem",
                            marginBottom: "0.75rem",
                            fontSize: "0.82rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Limits (per beneficiary, per milestone):"
                            }),
                            " one ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("em", {
                                children: "full"
                            }),
                            " PO locks the milestone \u2014 no more POs. After any PO exists, use ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("em", {
                                children: "partial"
                            }),
                            " only. Each line cannot exceed the remaining quantity (master plan minus quantities already on earlier POs for that item)."
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "issue-po-flow",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                                className: "issue-po-flow__section",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "inv-outward-issue__label",
                                        children: "Step 1 \u2014 Beneficiaries (single or multiple)"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                        className: "text-muted",
                                        style: {
                                            margin: "0 0 0.5rem",
                                            fontSize: "0.84rem"
                                        },
                                        children: [
                                            "After you pick beneficiaries here, Step 2 only lists milestones where those beneficiaries can still get a PO. Phases where someone already has a ",
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("em", {
                                                children: "full"
                                            }),
                                            " PO are omitted from the milestone dropdown."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "goods-receipts-filters__grid",
                                        style: {
                                            marginBottom: "0.5rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "goods-receipts-filters__field",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "goods-receipts-filters__label",
                                                        children: "Search"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        type: "search",
                                                        className: "form-control",
                                                        value: poBeneficiarySearch,
                                                        onChange: (e)=>setPoBeneficiarySearch(e.target.value),
                                                        placeholder: "Beneficiary name / application id"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "goods-receipts-filters__field",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "goods-receipts-filters__label",
                                                        children: "District"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                        id: "po-beneficiary-district",
                                                        value: poDistrictFilter,
                                                        onChange: setPoDistrictFilter,
                                                        options: poDistrictSelectOptions,
                                                        placeholder: "All districts"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "goods-receipts-filters__field",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "goods-receipts-filters__label",
                                                        children: "Mandal"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                        id: "po-beneficiary-mandal",
                                                        value: poMandalFilter,
                                                        onChange: setPoMandalFilter,
                                                        options: poMandalSelectOptions,
                                                        placeholder: "All mandals"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "goods-receipts-filters__field",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "goods-receipts-filters__label",
                                                        children: "Village"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                        id: "po-beneficiary-village",
                                                        value: poVillageFilter,
                                                        onChange: setPoVillageFilter,
                                                        options: poVillageSelectOptions,
                                                        placeholder: "All villages"
                                                    })
                                                ]
                                            }),
                                            poZoneGroupSelectOptions.length > 1 && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "goods-receipts-filters__field",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "goods-receipts-filters__label",
                                                        children: "Group"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                        id: "po-beneficiary-zone-group",
                                                        value: poZoneGroupFilter,
                                                        onChange: setPoZoneGroupFilter,
                                                        options: poZoneGroupSelectOptions,
                                                        placeholder: "All groups"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                        className: "text-muted",
                                        style: {
                                            margin: "0 0 0.4rem",
                                            fontSize: "0.85rem"
                                        },
                                        children: [
                                            "Showing ",
                                            visiblePoBeneficiaries.length,
                                            " of ",
                                            eligibleApplications.length,
                                            " eligible beneficiaries",
                                            notInitiatedApplications.length > 0 && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                style: {
                                                    color: "#d97706",
                                                    marginLeft: "0.5rem",
                                                    fontWeight: 500
                                                },
                                                children: [
                                                    "\xb7 ",
                                                    notInitiatedApplications.length,
                                                    " blocked (not initiated)"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "toolbar-row",
                                        style: {
                                            marginTop: 0,
                                            marginBottom: "0.5rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                type: "button",
                                                className: "btn btn--sm btn--tg-secondary",
                                                onClick: ()=>setPoApplicationIds((prev)=>[
                                                            ...new Set([
                                                                ...prev,
                                                                ...visiblePoBeneficiaryIds
                                                            ])
                                                        ]),
                                                disabled: visiblePoBeneficiaries.length === 0,
                                                children: poVillageFilter !== "all" ? "Select village beneficiaries" : "Select all visible"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                type: "button",
                                                className: "btn btn--sm btn--tg-secondary",
                                                onClick: ()=>setPoApplicationIds((prev)=>prev.filter((id)=>!visiblePoBeneficiaries.some((a)=>a.id === id))),
                                                disabled: visiblePoBeneficiaries.length === 0,
                                                children: "Clear visible"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                type: "button",
                                                className: "btn btn--sm btn--tg-secondary",
                                                onClick: ()=>setPoApplicationIds([]),
                                                disabled: poApplicationIds.length === 0,
                                                children: "Clear all selected"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "text-muted",
                                                style: {
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: "0.4rem",
                                                    marginLeft: "0.25rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: poShowSelectedOnly,
                                                        onChange: (e)=>setPoShowSelectedOnly(e.target.checked)
                                                    }),
                                                    "Show only selected"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                        className: "text-muted",
                                        style: {
                                            margin: "0 0 0.5rem",
                                            fontSize: "0.84rem"
                                        },
                                        children: [
                                            "Selected: ",
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                children: poApplicationIds.length
                                            }),
                                            poSelectedBeneficiaryNames.length ? ` (${poSelectedBeneficiaryNames.slice(0, 3).join(", ")}${poSelectedBeneficiaryNames.length > 3 ? "..." : ""})` : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "issue-po-beneficiary-table-wrap",
                                        role: "group",
                                        "aria-label": "Select beneficiaries",
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                            className: "data-table issue-po-beneficiary-table",
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                style: {
                                                                    width: "2.5rem"
                                                                },
                                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                    type: "checkbox",
                                                                    "aria-label": "Select all visible beneficiaries",
                                                                    checked: poAllVisibleSelected,
                                                                    onChange: (e)=>e.target.checked ? setPoApplicationIds((prev)=>[
                                                                                ...new Set([
                                                                                    ...prev,
                                                                                    ...visiblePoBeneficiaryIds
                                                                                ])
                                                                            ]) : setPoApplicationIds((prev)=>prev.filter((id)=>!visiblePoBeneficiaryIds.includes(id)))
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                children: "Application ID"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                children: "Beneficiary name"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                children: "District"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                children: "Mandal"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                children: "Village"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                children: "Subcontractor"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                                    children: visiblePoBeneficiaries.map((a)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        checked: poApplicationIds.includes(a.id),
                                                                        onChange: ()=>setPoApplicationIds((prev)=>prev.includes(a.id) ? prev.filter((id)=>id !== a.id) : [
                                                                                    ...prev,
                                                                                    a.id
                                                                                ])
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    className: "mono",
                                                                    children: a.mobile.applicationId
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    children: a.mobile.beneficiaryName
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    children: a.district
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    children: a.mandal
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    children: a.village
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    children: subcontractorNameById.get(a.subcontractor.subcontractorMasterId || "") || "\u2014"
                                                                })
                                                            ]
                                                        }, a.id))
                                                })
                                            ]
                                        })
                                    }),
                                    visiblePoBeneficiaries.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "text-muted",
                                        style: {
                                            marginTop: "0.45rem"
                                        },
                                        children: "No beneficiaries match these filters."
                                    }) : null,
                                    notInitiatedApplications.length > 0 && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "po-not-initiated-banner",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "po-not-initiated-banner__header",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "po-not-initiated-banner__icon",
                                                        children: "\u26A0\uFE0F"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("strong", {
                                                        children: [
                                                            notInitiatedApplications.length,
                                                            " beneficiar",
                                                            notInitiatedApplications.length !== 1 ? "ies" : "y",
                                                            " blocked \u2014 Project Initiation required"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("a", {
                                                        href: "/project-initiation",
                                                        className: "po-not-initiated-banner__link",
                                                        children: "Go to Project Initiation \u2192"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                className: "po-not-initiated-banner__desc",
                                                children: [
                                                    "These beneficiaries have a subcontractor assigned but no planned start date set. Set a start date in ",
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                        children: "Planning \u2192 Project Initiation"
                                                    }),
                                                    " before generating their PO."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                className: "po-not-initiated-banner__list",
                                                children: notInitiatedApplications.map((a)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "po-not-initiated-banner__chip",
                                                        children: a.mobile.beneficiaryName || a.mobile.applicationId
                                                    }, a.id))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                                className: "issue-po-flow__section",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "inv-outward-issue__label",
                                        children: "Step 2 \u2014 Milestone and PO setup"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "inv-outward-issue__grid",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full issue-po-milestone-stack",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Milestone"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                        id: "po-milestone-template",
                                                        value: poMilestoneTemplateId,
                                                        onChange: setPoMilestoneTemplateId,
                                                        options: poMilestoneSelectOptions,
                                                        placeholder: poApplicationIds.length > 0 && !poBlockedMilestonesLoading && milestoneTemplates.length > 0 && poMilestoneSelectOptions.length <= 1 ? "No milestones left for selection" : "Select\u2026"
                                                    }),
                                                    poApplicationIds.length > 0 && poBlockedMilestonesLoading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                        className: "inv-outward-issue__hint issue-po-milestone-stack__hint",
                                                        children: "Checking which phases still allow a PO for the selected beneficiaries\u2026"
                                                    }) : null,
                                                    poApplicationIds.length > 0 && !poBlockedMilestonesLoading && poBlockedFullPos.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                        className: "issue-po-blocked-summary",
                                                        role: "region",
                                                        "aria-label": "Milestone phases already covered by a full purchase order",
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                                className: "issue-po-blocked-summary__lead",
                                                                children: [
                                                                    "These phases are hidden above \u2014 materials are already covered by a",
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                                        children: "full"
                                                                    }),
                                                                    " PO for the listed beneficiary. PO number(s):"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                                                                className: "issue-po-blocked-summary__milestones",
                                                                children: poBlockedFullPos.map((block)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                                                        className: "issue-po-blocked-summary__milestone",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                                className: "issue-po-blocked-summary__milestone-title",
                                                                                children: block.milestoneTitle
                                                                            }),
                                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                                                                                className: "issue-po-blocked-summary__lines",
                                                                                children: block.lines.map((line)=>{
                                                                                    const app = appById.get(line.applicationId);
                                                                                    const name = (app?.mobile.beneficiaryName ?? "").trim() || "Beneficiary";
                                                                                    const appNo = (app?.mobile.applicationId ?? "").trim() || line.applicationId;
                                                                                    const pos = line.poNumbers.filter(Boolean);
                                                                                    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                                                className: "issue-po-blocked-summary__name",
                                                                                                children: name
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                                                className: "issue-po-blocked-summary__app mono",
                                                                                                children: appNo
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                                                className: "issue-po-blocked-summary__po mono",
                                                                                                children: pos.length ? pos.join(", ") : "\u2014"
                                                                                            })
                                                                                        ]
                                                                                    }, `${block.milestoneTemplateId}-${line.applicationId}`);
                                                                                })
                                                                            })
                                                                        ]
                                                                    }, block.milestoneTemplateId))
                                                            })
                                                        ]
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--r1",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "PO mode"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                        id: "po-selection-mode",
                                                        value: poSelectionMode,
                                                        onChange: (v)=>setPoSelectionMode(v === "partial" ? "partial" : "full"),
                                                        options: poModeSelectOptions,
                                                        placeholder: "Select mode\u2026"
                                                    })
                                                ]
                                            }),
                                            poSelectionMode === "partial" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                        className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                className: "inv-outward-issue__label",
                                                                children: "Step 3 \u2014 Select resources"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                className: "milestone-timeline-check-grid",
                                                                role: "group",
                                                                "aria-label": "Select resources for PO",
                                                                children: poLinkedResources.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                                        className: "milestone-timeline-check",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                type: "checkbox",
                                                                                checked: poSelectedResourceIds.includes(r.id),
                                                                                onChange: ()=>setPoSelectedResourceIds((prev)=>prev.includes(r.id) ? prev.filter((id)=>id !== r.id) : [
                                                                                            ...prev,
                                                                                            r.id
                                                                                        ])
                                                                            }),
                                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                                className: "milestone-timeline-check__text milestone-timeline-check__text--single",
                                                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                                    className: "milestone-timeline-check__title",
                                                                                    children: r.title
                                                                                })
                                                                            })
                                                                        ]
                                                                    }, r.id))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                        className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                className: "inv-outward-issue__label",
                                                                children: "Step 3 \u2014 Select specific items (optional)"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                className: "milestone-timeline-check-grid",
                                                                role: "group",
                                                                "aria-label": "Select resource items for PO",
                                                                children: poLinkedResources.filter((r)=>poSelectedResourceIds.includes(r.id)).flatMap((r)=>r.items.map((item)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                                            className: "milestone-timeline-check",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                    type: "checkbox",
                                                                                    checked: poSelectedResourceItemIds.includes(item.id),
                                                                                    onChange: ()=>setPoSelectedResourceItemIds((prev)=>prev.includes(item.id) ? prev.filter((id)=>id !== item.id) : [
                                                                                                ...prev,
                                                                                                item.id
                                                                                            ])
                                                                                }),
                                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                                                    className: "milestone-timeline-check__text",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                                            className: "milestone-timeline-check__title",
                                                                                            children: item.label
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                                                            className: "milestone-timeline-check__meta",
                                                                                            children: [
                                                                                                item.quantity,
                                                                                                " ",
                                                                                                item.unit
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }, item.id)))
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                                className: "issue-po-flow__section",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "inv-outward-issue__label",
                                        children: "Step 3 \u2014 PO preview items"
                                    }),
                                    poApplicationIds.length > 0 && poMilestoneTemplateId.trim() && !poRemainingQtyLoading && Object.keys(poRemainingQtyByItemId).length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "inv-outward-issue__hint",
                                        style: {
                                            marginTop: "0.35rem",
                                            marginBottom: "0.65rem"
                                        },
                                        children: "Quantities default to what you can still PO for the selected beneficiaries (master plan minus quantities already on earlier POs for this milestone)."
                                    }) : null,
                                    poPreviewWithQty.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "text-muted",
                                        children: "Select beneficiaries/milestone and mode to preview PO rows."
                                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        style: {
                                            overflowX: "auto"
                                        },
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                            className: "data-table",
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                children: "Resource"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                children: "Item"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                children: "Item master code"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                children: "HSN/SAC"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                title: "Quantity from the milestone / standard resource master plan (before earlier POs).",
                                                                children: "Planned qty"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                title: "Defaults to remaining qty after earlier POs for this milestone; edit if you need less on this PO.",
                                                                children: "Qty (editable)"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                children: "Unit"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                children: "Rate (\u20B9)"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                children: "Line (\u20B9)"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                                children: "Status"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                                    children: poPreviewWithQty.map((it)=>{
                                                        const rem = poRemainingQtyByItemId[it.itemId];
                                                        const plannedQty = it.qty;
                                                        const qtyLineNoRemaining = !poRemainingQtyLoading && rem !== undefined && rem <= 0;
                                                        const qtyAlreadyOnEarlierPos = !poRemainingQtyLoading && rem !== undefined ? Math.max(0, Math.round((plannedQty - rem) * 10000) / 10000) : 0;
                                                        const partialEarlierPo = !qtyLineNoRemaining && rem !== undefined && rem > 0 && qtyAlreadyOnEarlierPos > 0.0000001;
                                                        const qtyHint = !poRemainingQtyLoading && rem !== undefined ? `Master planned ${$466faaf7f5001d36$var$formatQtyInputDisplay(plannedQty)} ${it.unit} \xb7 Remaining you can PO now: ${$466faaf7f5001d36$var$formatQtyInputDisplay(rem)} ${it.unit}` : undefined;
                                                        return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                            className: qtyLineNoRemaining ? "issue-po-preview-row--qty-exhausted" : undefined,
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    children: it.resourceTitle
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    children: it.itemLabel
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    className: "mono",
                                                                    children: it.catalogStandardItemId || "\u2014 missing mapping \u2014"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    className: "mono",
                                                                    children: it.hsnCode?.trim() || "\u2014"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    className: "mono",
                                                                    children: $466faaf7f5001d36$var$formatQtyInputDisplay(plannedQty)
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                        type: "text",
                                                                        inputMode: "decimal",
                                                                        className: "form-control",
                                                                        style: {
                                                                            maxWidth: "7rem"
                                                                        },
                                                                        value: it.qtyInputValue,
                                                                        disabled: qtyLineNoRemaining,
                                                                        title: qtyHint,
                                                                        onChange: (e)=>setPoQtyOverrides((prev)=>({
                                                                                    ...prev,
                                                                                    [it.itemId]: (0, $50736abadf17d9d0$export$73a62fdf13118eb6)(e.target.value)
                                                                                }))
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    children: it.unit
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    className: "mono",
                                                                    children: $466faaf7f5001d36$var$fmtInrAmount(it.rate ?? 0)
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    className: "mono",
                                                                    children: $466faaf7f5001d36$var$fmtInrAmount(it.lineAmount)
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                                    className: "issue-po-preview-status",
                                                                    children: qtyLineNoRemaining ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                        className: "issue-po-preview-status__done",
                                                                        children: "Already PO generated"
                                                                    }) : partialEarlierPo ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                                        className: "issue-po-preview-status__partial",
                                                                        children: [
                                                                            $466faaf7f5001d36$var$formatQtyInputDisplay(qtyAlreadyOnEarlierPos),
                                                                            " qty PO generated"
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                        className: "text-muted",
                                                                        children: "\u2014"
                                                                    })
                                                                })
                                                            ]
                                                        }, `${it.resourceId}-${it.itemId}`);
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            poApplicationIds.length > 1 && !poSubcontractorValidation.ok ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "inv-outward-issue__hint",
                                children: "Selected beneficiaries must have the same subcontractor."
                            }) : null,
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "inv-outward-issue__actions",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--primary btn--tg btn--lg",
                                        disabled: poGenerating || !poCanGenerate.ok,
                                        onClick: ()=>openPoShipToModal(),
                                        children: poGenerating ? "Generating\u2026" : "Generate PO"
                                    }),
                                    !poCanGenerate.ok ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "text-muted",
                                        children: poCanGenerate.reason
                                    }) : null
                                ]
                            })
                        ]
                    })
                ]
            }) : null,
            isPoSection && canUsePo && poViewMode === "register" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                style: {
                    marginBottom: "1.25rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "po-analytics-header",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                className: "form-section-title",
                                style: {
                                    marginTop: 0,
                                    marginBottom: 0
                                },
                                children: "PO analytics"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--sm btn--tg-secondary",
                                onClick: ()=>void loadPoAnalytics(),
                                disabled: poAnalyticsLoading,
                                children: poAnalyticsLoading ? "Refreshing\u2026" : "Refresh"
                            })
                        ]
                    }),
                    poAnalyticsError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        style: {
                            color: "var(--dash-danger, #b91c1c)"
                        },
                        children: poAnalyticsError
                    }) : null,
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "kpi-grid kpi-grid--cols-4",
                        style: {
                            marginBottom: "1rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "kpi-card kpi-card--pastel",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "kpi-card__label",
                                        children: "Total POs generated"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "kpi-card__value",
                                        children: poAnalyticsData?.totals.totalPo ?? "\u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "kpi-card kpi-card--pastel",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "kpi-card__label",
                                        children: "Total beneficiaries"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "kpi-card__value",
                                        children: poAnalyticsData != null ? poAnalyticsData.totals.totalEligibleBeneficiaries : "\u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "kpi-card kpi-card--pastel",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "kpi-card__label",
                                        children: "Beneficiaries \u2014 complete PO"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "kpi-card__value",
                                        children: poAnalyticsData?.totals.beneficiariesWithFullPo ?? "\u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "kpi-card kpi-card--pastel",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "kpi-card__label",
                                        children: "Beneficiaries \u2014 partial PO"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "kpi-card__value",
                                        children: poAnalyticsData?.totals.beneficiariesWithPartialPo ?? "\u2014"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        children: "PO breakdown by milestone"
                    }),
                    poAnalyticsLoading && !poAnalyticsData ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "Loading\u2026"
                    }) : !poAnalyticsData || poAnalyticsData.byMilestone.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "No data."
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        style: {
                            overflowX: "auto",
                            marginBottom: "1rem"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                            className: "data-table",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Milestone"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "POs"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Full"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Partial"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Beneficiaries"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Items"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                    children: poAnalyticsData.byMilestone.map((m)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: m.milestoneTitle
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: m.poCount
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: m.fullCount
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: m.partialCount
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: m.uniqueBeneficiaries
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: m.itemCount
                                                })
                                            ]
                                        }, m.milestoneTemplateId || m.milestoneTitle))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        children: "PO breakdown by subcontractor"
                    }),
                    poAnalyticsLoading && !poAnalyticsData ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "Loading\u2026"
                    }) : !poAnalyticsData || poAnalyticsData.bySubcontractor.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "No data."
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        style: {
                            overflowX: "auto",
                            marginBottom: "1rem"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                            className: "data-table",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Subcontractor"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "POs"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Full"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Partial"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Beneficiaries"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Items"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                    children: poAnalyticsData.bySubcontractor.map((s)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: s.subcontractorFirmName
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: s.poCount
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: s.fullCount
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: s.partialCount
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: s.uniqueBeneficiaries
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: s.itemCount
                                                })
                                            ]
                                        }, s.subcontractorMasterId || s.subcontractorFirmName))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        style: {
                            marginTop: "1rem"
                        },
                        children: "Generated PO register"
                    }),
                    poRowsLoading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "Loading\u2026"
                    }) : poRowsError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        style: {
                            color: "var(--dash-danger, #b91c1c)"
                        },
                        children: poRowsError
                    }) : poRows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "No PO records yet."
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        style: {
                            overflowX: "auto"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                            className: "data-table",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "PO number"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Subcontractor"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Milestone"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Beneficiaries"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Mode"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "When"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                style: {
                                                    width: "14rem"
                                                },
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                    children: poRows.map((row)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            onClick: ()=>setSelectedPoId((prev)=>prev === row.id ? "" : row.id),
                                            style: {
                                                cursor: "pointer",
                                                background: selectedPoId === row.id ? "var(--dash-row-selected, #eff6ff)" : undefined
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "mono",
                                                    children: row.poNumber
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: row.subcontractorFirmName
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: row.milestoneTitle
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: row.beneficiaryCount
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    style: {
                                                        textTransform: "capitalize"
                                                    },
                                                    children: row.selectionMode
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "text-muted",
                                                    children: $466faaf7f5001d36$var$formatWhen(row.createdAt)
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                    onClick: (e)=>e.stopPropagation(),
                                                    style: {
                                                        cursor: "default"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "btn btn--tg-secondary btn--sm",
                                                            disabled: poPdfDownloadingId === row.id || poCancellingId === row.id,
                                                            "aria-label": `Download PDF for ${row.poNumber}`,
                                                            onClick: ()=>void handleDownloadPoPdfRow(row),
                                                            children: poPdfDownloadingId === row.id ? "PDF\u2026" : "Download PDF"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "btn btn--danger btn--sm",
                                                            style: {
                                                                marginLeft: "0.35rem"
                                                            },
                                                            disabled: poPdfDownloadingId === row.id || poCancellingId === row.id,
                                                            "aria-label": `Cancel ${row.poNumber}`,
                                                            onClick: ()=>void handleCancelPoRow(row),
                                                            children: poCancellingId === row.id ? "Cancelling\u2026" : "Cancel"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, row.id))
                                })
                            ]
                        })
                    }),
                    selectedPoId ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                className: "form-section-title",
                                style: {
                                    marginTop: "1rem"
                                },
                                children: "PO items"
                            }),
                            poItemsLoading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                children: "Loading PO items\u2026"
                            }) : selectedPoItems.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                children: "No items for selected PO."
                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                style: {
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                    className: "data-table",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Beneficiary"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Resource item"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Mapped item"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "HSN/SAC"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Qty"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Unit"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Rate (\u20B9)"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Line (\u20B9)"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                            children: selectedPoItems.map((it)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                    className: "table-name",
                                                                    children: it.beneficiaryName ?? "\u2014"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                    className: "text-muted mono",
                                                                    style: {
                                                                        fontSize: "0.85em"
                                                                    },
                                                                    children: it.beneficiaryMobileApplicationId ?? it.applicationId
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                    children: it.resourceItemLabel
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                    className: "text-muted",
                                                                    style: {
                                                                        fontSize: "0.85em"
                                                                    },
                                                                    children: it.standardResourceTitle
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                    children: it.catalogStandardItemId || "\u2014"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                    className: "text-muted mono",
                                                                    style: {
                                                                        fontSize: "0.85em"
                                                                    },
                                                                    children: it.catalogStandardItemId
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "mono",
                                                            children: it.hsnCode?.trim() || "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: it.plannedQty
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: it.resourceItemUnit
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "mono",
                                                            children: $466faaf7f5001d36$var$fmtInrAmount(it.resourceItemRate ?? 0)
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "mono",
                                                            children: $466faaf7f5001d36$var$fmtInrAmount(Math.round(it.plannedQty * (it.resourceItemRate ?? 0) * 100) / 100)
                                                        })
                                                    ]
                                                }, it.id))
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null
                ]
            }) : null,
            isIssueSection && issueViewMode === "generate" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                style: {
                    marginBottom: "1.25rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "section-lead section-lead--tight text-muted",
                        style: {
                            marginTop: 0
                        },
                        children: [
                            "Create beneficiary-wise material issue rows. Dispatch stock later in",
                            " ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/inventory/outward",
                                children: "Inventory outward"
                            }),
                            ".",
                            canUsePo ? " Choose manual entry (beneficiary and milestone) or create rows directly from an existing PO." : " Pick beneficiary and milestone-linked resources below."
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        children: "Generate issue rows"
                    }),
                    canUsePo ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("fieldset", {
                        className: "issue-source-fieldset",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("legend", {
                                className: "issue-source-fieldset__legend",
                                children: "How to create issue rows"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "issue-source-radios",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "issue-source-radio-row",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                type: "radio",
                                                name: "issueGenerateSource",
                                                checked: issueGenerateSubMode === "manual",
                                                onChange: ()=>setIssueGenerateSubMode("manual")
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                className: "issue-source-radio-row__text",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "issue-source-radio-row__title",
                                                        children: "Manual \u2014 beneficiary and milestone"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "issue-source-radio-row__desc",
                                                        children: "Select one beneficiary, milestone, and resources (current flow)."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "issue-source-radio-row",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                type: "radio",
                                                name: "issueGenerateSource",
                                                checked: issueGenerateSubMode === "fromPo",
                                                onChange: ()=>setIssueGenerateSubMode("fromPo")
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                className: "issue-source-radio-row__text",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "issue-source-radio-row__title",
                                                        children: "Direct from PO"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "issue-source-radio-row__desc",
                                                        children: "Load beneficiaries, items, and quantities from an existing purchase order."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    issueGenerateSubMode === "fromPo" && canUsePo ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                style: {
                                    marginTop: "-0.35rem",
                                    marginBottom: "0.75rem",
                                    fontSize: "0.88rem"
                                },
                                children: "Select a PO with remaining issue balance. Choose full balance or enter partial quantities per line, then create issue rows. Outward dispatch is limited to issued quantity \u2014 PO visibility is based on how much has been issued, not outward completion."
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "inv-outward-issue__grid",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "inv-outward-issue__field inv-outward-issue__field--full",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "inv-outward-issue__label",
                                                children: "Issue mode"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                id: "issue-from-po-mode",
                                                value: issueFromPoMode,
                                                onChange: (v)=>setIssueFromPoMode(v === "partial" ? "partial" : "full"),
                                                options: [
                                                    {
                                                        value: "full",
                                                        label: "Full balance (remaining PO qty)"
                                                    },
                                                    {
                                                        value: "partial",
                                                        label: "Partial qty (per line)"
                                                    }
                                                ],
                                                placeholder: "Select mode\u2026"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "inv-outward-issue__field inv-outward-issue__field--full",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "inv-outward-issue__label",
                                                children: "Purchase order"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                id: "issue-from-po-id",
                                                value: issueFromPoId,
                                                onChange: setIssueFromPoId,
                                                options: issueFromPoSelectOptions,
                                                placeholder: "Select PO\u2026"
                                            })
                                        ]
                                    }),
                                    issueFromPoHeader ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                        className: "inv-outward-issue__field inv-outward-issue__field--full text-muted",
                                        style: {
                                            margin: 0,
                                            fontSize: "0.88rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                className: "mono",
                                                children: issueFromPoHeader.poNumber
                                            }),
                                            " \xb7 ",
                                            issueFromPoHeader.selectionMode === "full" ? "Full PO" : "Partial PO",
                                            " \xb7 ",
                                            issueFromPoHeader.milestoneTitle,
                                            " \xb7 ",
                                            issueFromPoHeader.subcontractorFirmName
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "inv-outward-issue__field inv-outward-issue__field--full",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "inv-outward-issue__label",
                                                children: "Notes (optional)"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                                className: "form-control inv-outward-issue__notes",
                                                value: issueFromPoNotes,
                                                onChange: (e)=>setIssueFromPoNotes(e.target.value),
                                                rows: 2,
                                                placeholder: "Extra note stored on generated issue rows\u2026"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "inv-outward-issue__actions",
                                children: [
                                    issueFromPoHintMessage ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "inv-outward-issue__hint",
                                        style: {
                                            margin: "0 0 0.75rem",
                                            flex: "1 1 100%"
                                        },
                                        children: issueFromPoHintMessage
                                    }) : null,
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--primary btn--tg btn--lg",
                                        disabled: generatingFromPo || !issueFromPoId.trim() || issueFromPoItemsLoading || issueFromPoBalanceLoading || issueFromPoItems.length === 0 || !issueFromPoGenerateState.canGenerate,
                                        onClick: ()=>void handleGenerateIssueFromPo(),
                                        children: generatingFromPo ? "Creating\u2026" : "Create issue rows from PO"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--tg-secondary btn--lg",
                                        disabled: poRowsLoading || openPoIdsForIssueLoading,
                                        onClick: ()=>{
                                            loadPoRows();
                                            loadOpenPoIdsForIssue();
                                        },
                                        children: poRowsLoading || openPoIdsForIssueLoading ? "Refreshing\u2026" : "Refresh PO list"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                className: "form-section-title",
                                style: {
                                    marginTop: "1rem"
                                },
                                children: "PO lines (preview)"
                            }),
                            !issueFromPoId.trim() ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                children: "Select a PO to see beneficiaries, resources, and quantities."
                            }) : issueFromPoItemsLoading || issueFromPoBalanceLoading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                children: "Loading PO lines\u2026"
                            }) : issueFromPoItems.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                children: "No lines on this PO."
                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                style: {
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                    className: "data-table",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Beneficiary"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Item"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Item master"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "HSN/SAC"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "PO Qty"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Already issued"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Yet to issue"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        style: {
                                                            width: "8rem"
                                                        },
                                                        children: "This issue qty"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Unit"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Rate (\u20B9)"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Line (\u20B9)"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                            children: issueFromPoItems.map((it)=>{
                                                const bal = issueFromPoBalanceByItemId.get(it.id);
                                                const poQty = bal?.poQty ?? it.plannedQty;
                                                const alreadyIssued = bal?.alreadyIssued ?? 0;
                                                const yetToIssue = bal?.yetToIssue ?? poQty;
                                                const issueQtyDisplay = issueFromPoMode === "full" ? yetToIssue > 0 ? $466faaf7f5001d36$var$formatQtyInputDisplay(yetToIssue) : "0" : issueFromPoQtyOverrides[it.id] ?? "";
                                                const issueQtyNum = issueFromPoMode === "full" ? yetToIssue : (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(issueQtyDisplay);
                                                return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                    className: "table-name",
                                                                    children: it.beneficiaryName ?? "\u2014"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                    className: "text-muted mono",
                                                                    style: {
                                                                        fontSize: "0.85em"
                                                                    },
                                                                    children: it.beneficiaryMobileApplicationId ?? it.applicationId
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                    children: it.resourceItemLabel
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                    className: "text-muted",
                                                                    style: {
                                                                        fontSize: "0.85em"
                                                                    },
                                                                    children: it.standardResourceTitle
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "mono",
                                                            children: it.catalogStandardItemId || "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "mono",
                                                            children: it.hsnCode?.trim() || "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: $466faaf7f5001d36$var$formatQtyInputDisplay(poQty)
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: $466faaf7f5001d36$var$formatQtyInputDisplay(alreadyIssued)
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: $466faaf7f5001d36$var$formatQtyInputDisplay(yetToIssue)
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: yetToIssue > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                className: "inv-receive-modal__input inv-receive-modal__qty-input",
                                                                type: "text",
                                                                inputMode: "decimal",
                                                                autoComplete: "off",
                                                                value: issueQtyDisplay,
                                                                disabled: issueFromPoMode === "full",
                                                                placeholder: issueFromPoMode === "partial" ? "0" : undefined,
                                                                onChange: (e)=>setIssueFromPoQtyOverrides((prev)=>({
                                                                            ...prev,
                                                                            [it.id]: (0, $50736abadf17d9d0$export$73a62fdf13118eb6)(e.target.value)
                                                                        }))
                                                            }) : "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: it.resourceItemUnit
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "mono",
                                                            children: $466faaf7f5001d36$var$fmtInrAmount(it.resourceItemRate ?? 0)
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "mono",
                                                            children: $466faaf7f5001d36$var$fmtInrAmount(Math.round(issueQtyNum * (it.resourceItemRate ?? 0) * 100) / 100)
                                                        })
                                                    ]
                                                }, it.id);
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                className: "text-muted",
                                style: {
                                    marginTop: "-0.35rem",
                                    marginBottom: "0.75rem",
                                    fontSize: "0.88rem"
                                },
                                children: [
                                    "Step 1: Filter and select beneficiary ",
                                    "->",
                                    " Step 2: Select milestone and mode ",
                                    "->",
                                    " Step 3: Select resources (if needed) ",
                                    "->",
                                    " Step 4: Generate."
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "inv-outward-issue__grid",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "inv-outward-issue__field inv-outward-issue__field--full",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "inv-outward-issue__label",
                                                children: "Step 1 \u2014 Beneficiary filters"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "goods-receipts-filters__grid",
                                                style: {
                                                    marginBottom: "0.5rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                        className: "goods-receipts-filters__field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                className: "goods-receipts-filters__label",
                                                                children: "Search"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                type: "search",
                                                                className: "form-control",
                                                                value: issueBeneficiarySearch,
                                                                onChange: (e)=>setIssueBeneficiarySearch(e.target.value),
                                                                placeholder: "Beneficiary name / application id"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                        className: "goods-receipts-filters__field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                className: "goods-receipts-filters__label",
                                                                children: "District"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                                id: "issue-beneficiary-district",
                                                                value: issueDistrictFilter,
                                                                onChange: setIssueDistrictFilter,
                                                                options: issueDistrictSelectOptions,
                                                                placeholder: "All districts"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                        className: "goods-receipts-filters__field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                className: "goods-receipts-filters__label",
                                                                children: "Mandal"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                                id: "issue-beneficiary-mandal",
                                                                value: issueMandalFilter,
                                                                onChange: setIssueMandalFilter,
                                                                options: issueMandalSelectOptions,
                                                                placeholder: "All mandals"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                        className: "goods-receipts-filters__field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                className: "goods-receipts-filters__label",
                                                                children: "Village"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                                id: "issue-beneficiary-village",
                                                                value: issueVillageFilter,
                                                                onChange: setIssueVillageFilter,
                                                                options: issueVillageSelectOptions,
                                                                placeholder: "All villages"
                                                            })
                                                        ]
                                                    }),
                                                    issueZoneGroupSelectOptions.length > 1 && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                        className: "goods-receipts-filters__field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                className: "goods-receipts-filters__label",
                                                                children: "Group"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                                id: "issue-beneficiary-zone-group",
                                                                value: issueZoneGroupFilter,
                                                                onChange: setIssueZoneGroupFilter,
                                                                options: issueZoneGroupSelectOptions,
                                                                placeholder: "All groups"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                className: "text-muted",
                                                style: {
                                                    margin: "0",
                                                    fontSize: "0.84rem"
                                                },
                                                children: [
                                                    "Showing ",
                                                    filteredIssueBeneficiaries.length,
                                                    " of ",
                                                    eligibleApplications.length,
                                                    " beneficiaries"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "inv-outward-issue__field inv-outward-issue__field--r1",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "inv-outward-issue__label",
                                                children: "Step 1 \u2014 Beneficiary"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                id: "issue-beneficiary-id",
                                                value: applicationId,
                                                onChange: setApplicationId,
                                                options: issueBeneficiarySelectOptions,
                                                placeholder: "Select\u2026"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "inv-outward-issue__field inv-outward-issue__field--r1",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "inv-outward-issue__label",
                                                children: "Step 2 \u2014 Milestone"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                id: "issue-milestone-template",
                                                value: milestoneTemplateId,
                                                onChange: setMilestoneTemplateId,
                                                options: poMilestoneSelectOptions,
                                                placeholder: "Select\u2026"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "inv-outward-issue__field inv-outward-issue__field--r1",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "inv-outward-issue__label",
                                                children: "Step 2 \u2014 Selection mode"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                                id: "issue-selection-mode",
                                                value: selectionMode,
                                                onChange: (v)=>setSelectionMode(v === "selected" ? "selected" : "all"),
                                                options: issueModeSelectOptions,
                                                placeholder: "Select mode\u2026"
                                            })
                                        ]
                                    }),
                                    selectionMode === "selected" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "inv-outward-issue__field inv-outward-issue__field--full",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "inv-outward-issue__label",
                                                children: "Standard resources (linked to milestone)"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                className: "milestone-timeline-check-grid",
                                                role: "group",
                                                "aria-label": "Pick standard resources",
                                                children: linkedResources.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                        className: "milestone-timeline-check",
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                type: "checkbox",
                                                                checked: selectedResourceIds.includes(r.id),
                                                                onChange: ()=>setSelectedResourceIds((prev)=>prev.includes(r.id) ? prev.filter((id)=>id !== r.id) : [
                                                                            ...prev,
                                                                            r.id
                                                                        ])
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                className: "milestone-timeline-check__text milestone-timeline-check__text--single",
                                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                    className: "milestone-timeline-check__title",
                                                                    children: r.title
                                                                })
                                                            })
                                                        ]
                                                    }, r.id))
                                            })
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                        className: "inv-outward-issue__field inv-outward-issue__field--full",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "inv-outward-issue__label",
                                                children: "Notes (optional)"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                                className: "form-control inv-outward-issue__notes",
                                                value: notes,
                                                onChange: (e)=>setNotes(e.target.value),
                                                rows: 2,
                                                placeholder: "Any context for this generated issue set\u2026"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !selectedMilestone ? null : linkedResources.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "inv-outward-issue__hint",
                                children: "This milestone has no linked standard resources in master."
                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "inv-outward-issue__hint",
                                children: selectionMode === "all" ? `Will include all ${linkedResources.length} linked resources for this milestone.` : `${selectedResourceIds.length} resource(s) selected.`
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "inv-outward-issue__actions",
                                children: [
                                    manualIssueGenerateState.showMessage ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "inv-outward-issue__hint",
                                        style: {
                                            margin: "0 0 0.75rem",
                                            flex: "1 1 100%"
                                        },
                                        children: manualIssueGenerateState.message
                                    }) : null,
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--primary btn--tg btn--lg",
                                        disabled: generating || !manualIssueGenerateState.canGenerate || previewItems.length === 0,
                                        onClick: ()=>void handleGenerate(),
                                        children: generating ? "Generating\u2026" : "Generate issue rows"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                className: "form-section-title",
                                style: {
                                    marginTop: "1rem"
                                },
                                children: "Preview from selected resources"
                            }),
                            previewItems.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                children: "Select milestone/resources to preview item rows."
                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                style: {
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                    className: "data-table",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Resource"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Item"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Item master code"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "HSN/SAC"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Qty"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Unit"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Rate (\u20B9)"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Line (\u20B9)"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                        children: "Issue status"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                            children: previewItems.map((it)=>{
                                                const lineState = $466faaf7f5001d36$var$issueLineState(applicationId.trim() && milestoneTemplateId.trim() ? issueRowByKey.get($466faaf7f5001d36$var$issueRowLookupKey(applicationId.trim(), milestoneTemplateId.trim(), it.itemId)) : undefined);
                                                return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: it.resourceTitle
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: it.itemLabel
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "mono",
                                                            children: it.catalogStandardItemId || "\u2014 missing mapping \u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "mono",
                                                            children: it.hsnCode?.trim() || "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: it.qty
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: it.unit
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "mono",
                                                            children: $466faaf7f5001d36$var$fmtInrAmount(it.rate ?? 0)
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            className: "mono",
                                                            children: $466faaf7f5001d36$var$fmtInrAmount(Math.round(it.qty * (it.rate ?? 0) * 100) / 100)
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            children: $466faaf7f5001d36$var$issueLineStateLabel(lineState)
                                                        })
                                                    ]
                                                }, `${it.resourceId}-${it.itemId}`);
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }) : null,
            isIssueSection && issueViewMode === "register" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--gov card--elevated",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "po-analytics-header",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                className: "form-section-title",
                                style: {
                                    marginTop: 0,
                                    marginBottom: 0
                                },
                                children: "Material analytics"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--sm btn--tg-secondary",
                                onClick: ()=>{
                                    loadIssueAnalytics();
                                    if (canUsePo) loadPoAnalytics();
                                },
                                disabled: issueAnalyticsLoading,
                                children: issueAnalyticsLoading ? "Refreshing\u2026" : "Refresh"
                            })
                        ]
                    }),
                    issueAnalyticsError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        style: {
                            color: "var(--dash-danger, #b91c1c)"
                        },
                        children: issueAnalyticsError
                    }) : null,
                    canUsePo ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h4", {
                                className: "form-section-title",
                                style: {
                                    fontSize: "0.95rem"
                                },
                                children: "PO coverage"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "kpi-grid",
                                style: {
                                    marginBottom: "1rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "kpi-card kpi-card--pastel",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                className: "kpi-card__label",
                                                children: "Beneficiaries with PO"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                className: "kpi-card__value",
                                                children: poAnalyticsData?.totals.uniqueBeneficiaries ?? "\u2014"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "kpi-card kpi-card--pastel",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                className: "kpi-card__label",
                                                children: "Full POs"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                className: "kpi-card__value",
                                                children: poAnalyticsData?.totals.fullPo ?? "\u2014"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "kpi-card kpi-card--pastel",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                className: "kpi-card__label",
                                                children: "Partial POs"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                className: "kpi-card__value",
                                                children: poAnalyticsData?.totals.partialPo ?? "\u2014"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h4", {
                        className: "form-section-title",
                        style: {
                            fontSize: "0.95rem"
                        },
                        children: "Material issue status"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "kpi-grid kpi-grid--cols-4",
                        style: {
                            marginBottom: "1rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "kpi-card kpi-card--pastel",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "kpi-card__label",
                                        children: "Beneficiaries (with issue rows)"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "kpi-card__value",
                                        children: issueAnalyticsData?.totals.uniqueBeneficiaries ?? "\u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "kpi-card kpi-card--pastel",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "kpi-card__label",
                                        children: "Issue complete (beneficiary)"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "kpi-card__value",
                                        children: issueAnalyticsData?.totals.beneficiariesCompleted ?? "\u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "kpi-card kpi-card--pastel",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "kpi-card__label",
                                        children: "Issue partial (beneficiary)"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "kpi-card__value",
                                        children: issueAnalyticsData?.totals.beneficiariesPartial ?? "\u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "kpi-card kpi-card--pastel",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "kpi-card__label",
                                        children: "Issue pending (beneficiary)"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "kpi-card__value",
                                        children: issueAnalyticsData?.totals.beneficiariesPending ?? "\u2014"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        children: "Issue breakdown by milestone"
                    }),
                    issueAnalyticsLoading && !issueAnalyticsData ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "Loading\u2026"
                    }) : !issueAnalyticsData || issueAnalyticsData.byMilestone.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "No data."
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "issue-analytics-table-scroll",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                            className: "data-table issue-analytics-breakdown-table",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("colgroup", {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("col", {
                                            className: "issue-analytics-breakdown-table__label"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("col", {
                                            className: "issue-analytics-breakdown-table__metric"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("col", {
                                            className: "issue-analytics-breakdown-table__metric"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("col", {
                                            className: "issue-analytics-breakdown-table__metric"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("col", {
                                            className: "issue-analytics-breakdown-table__metric"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Milestone"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Beneficiaries"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Pending"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Partial"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Completed"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                    children: issueAnalyticsData.byMilestone.map((m)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: m.milestoneTitle
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: m.uniqueBeneficiaries
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: m.pendingRows
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: m.partialRows
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: m.completedRows
                                                })
                                            ]
                                        }, m.milestoneTemplateId || m.milestoneTitle))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        children: "Issue breakdown by subcontractor"
                    }),
                    issueAnalyticsLoading && !issueAnalyticsData ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "Loading\u2026"
                    }) : !issueAnalyticsData || issueAnalyticsData.bySubcontractor.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "No data."
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "issue-analytics-table-scroll",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                            className: "data-table issue-analytics-breakdown-table",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("colgroup", {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("col", {
                                            className: "issue-analytics-breakdown-table__label"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("col", {
                                            className: "issue-analytics-breakdown-table__metric"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("col", {
                                            className: "issue-analytics-breakdown-table__metric"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("col", {
                                            className: "issue-analytics-breakdown-table__metric"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("col", {
                                            className: "issue-analytics-breakdown-table__metric"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Subcontractor"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Beneficiaries"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Pending"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Partial"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Completed"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                    children: issueAnalyticsData.bySubcontractor.map((s)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: s.subcontractorFirmName
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: s.uniqueBeneficiaries
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: s.pendingRows
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: s.partialRows
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: s.completedRows
                                                })
                                            ]
                                        }, s.subcontractorMasterId || s.subcontractorFirmName))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        style: {
                            marginTop: "1rem"
                        },
                        children: "Issue register"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "goods-receipts-filters",
                        style: {
                            marginBottom: "1rem"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "goods-receipts-filters__grid",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "goods-receipts-filters__field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "goods-receipts-filters__label",
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("select", {
                                            className: "form-control",
                                            value: filterStatus,
                                            onChange: (e)=>{
                                                const next = e.target.value;
                                                setFilterStatus(next === "pending" || next === "partial" || next === "completed" ? next : "all");
                                            },
                                            children: $466faaf7f5001d36$var$STATUS_OPTIONS.map((opt)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                    value: opt.id,
                                                    children: opt.label
                                                }, opt.id))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "goods-receipts-filters__field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "goods-receipts-filters__label",
                                            children: "Search"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                            type: "search",
                                            className: "form-control",
                                            value: filterSearch,
                                            onChange: (e)=>setFilterSearch(e.target.value),
                                            placeholder: "Beneficiary, subcontractor, milestone, item..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "goods-receipts-filters__field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "goods-receipts-filters__label",
                                            children: "Sort"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                                            className: "form-control",
                                            value: sortDir,
                                            onChange: (e)=>setSortDir(e.target.value === "asc" ? "asc" : "desc"),
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                    value: "desc",
                                                    children: "Newest first"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                    value: "asc",
                                                    children: "Oldest first"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    loadingRows ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "Loading\u2026"
                    }) : rowsError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        style: {
                            color: "var(--dash-danger, #b91c1c)"
                        },
                        children: rowsError
                    }) : rows.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        children: "No issue rows found."
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        style: {
                            overflowX: "auto"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                            className: "data-table",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Beneficiary"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Subcontractor"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Milestone"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Resource item"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Mapped item"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Rate (\u20B9)"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Planned"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Issued"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Balance"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                children: "Updated"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tbody", {
                                    children: rows.map((row)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                            className: "table-name",
                                                            children: row.beneficiaryName ?? "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                            className: "text-muted mono",
                                                            style: {
                                                                fontSize: "0.85em"
                                                            },
                                                            children: row.beneficiaryMobileApplicationId ?? row.applicationId
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: row.subcontractorFirmName
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: row.milestoneTitle
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                            children: row.resourceItemLabel
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                            className: "text-muted",
                                                            style: {
                                                                fontSize: "0.85em"
                                                            },
                                                            children: row.standardResourceTitle
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                            children: row.catalogStandardItemId || "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                            className: "text-muted mono",
                                                            style: {
                                                                fontSize: "0.85em"
                                                            },
                                                            children: row.catalogStandardItemId
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "mono",
                                                    children: $466faaf7f5001d36$var$fmtInrAmount(row.resourceItemRate ?? 0)
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: row.plannedQty
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: row.issuedQty
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    children: row.balanceQty
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    style: {
                                                        textTransform: "capitalize"
                                                    },
                                                    children: row.status
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    className: "text-muted",
                                                    children: $466faaf7f5001d36$var$formatWhen(row.updatedAt || row.createdAt)
                                                })
                                            ]
                                        }, row.id))
                                })
                            ]
                        })
                    })
                ]
            }) : null
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");





function $1123febe3e5331be$var$rowsFromSettings(s) {
    return s.gstRows.map((r, i)=>({
            id: `gst-${i}-${r.label.replace(/\W+/g, "").slice(0, 8)}`,
            label: r.label,
            rateInput: String(r.ratePercent)
        }));
}
function $1123febe3e5331be$export$99f03fb932d48fd3() {
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const initial = (0, $7UyaH.useMemo)(()=>(0, $b75ffaa91259d13d$export$e9d545cac71d8c31)(), []);
    const [documentTitle, setDocumentTitle] = (0, $7UyaH.useState)(initial.documentTitle);
    const [letterheadTagline, setLetterheadTagline] = (0, $7UyaH.useState)(initial.letterheadTagline);
    const [logoPrimaryUrl, setLogoPrimaryUrl] = (0, $7UyaH.useState)(initial.logoPrimaryUrl);
    const [logoSecondaryUrl, setLogoSecondaryUrl] = (0, $7UyaH.useState)(initial.logoSecondaryUrl);
    const [logoPrimaryHeightPx, setLogoPrimaryHeightPx] = (0, $7UyaH.useState)(initial.logoPrimaryHeightPx);
    const [logoSecondaryHeightPx, setLogoSecondaryHeightPx] = (0, $7UyaH.useState)(initial.logoSecondaryHeightPx);
    const [accentColorHex, setAccentColorHex] = (0, $7UyaH.useState)(initial.accentColorHex);
    const [footerNote, setFooterNote] = (0, $7UyaH.useState)(initial.footerNote);
    const [buyerName, setBuyerName] = (0, $7UyaH.useState)(initial.buyerName);
    const [buyerAddress, setBuyerAddress] = (0, $7UyaH.useState)(initial.buyerAddress);
    const [buyerGstin, setBuyerGstin] = (0, $7UyaH.useState)(initial.buyerGstin);
    const [defaultVendorName, setDefaultVendorName] = (0, $7UyaH.useState)(initial.defaultVendorName);
    const [defaultVendorAddress, setDefaultVendorAddress] = (0, $7UyaH.useState)(initial.defaultVendorAddress);
    const [defaultVendorGstin, setDefaultVendorGstin] = (0, $7UyaH.useState)(initial.defaultVendorGstin);
    const [paymentTerms, setPaymentTerms] = (0, $7UyaH.useState)(initial.paymentTerms);
    const [defaultShipTo, setDefaultShipTo] = (0, $7UyaH.useState)(initial.defaultShipTo);
    const [aggregateQtyDefault, setAggregateQtyDefault] = (0, $7UyaH.useState)(initial.aggregateQtyDefault);
    const [gstRows, setGstRows] = (0, $7UyaH.useState)(()=>$1123febe3e5331be$var$rowsFromSettings(initial));
    const [samplePdfBusy, setSamplePdfBusy] = (0, $7UyaH.useState)(false);
    const [activeTab, setActiveTab] = (0, $7UyaH.useState)("format");
    function handleLogoUpload(e, setter) {
        const file = e.target.files?.[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (ev)=>{
            if (typeof ev.target?.result === "string") setter(ev.target.result);
        };
        reader.readAsDataURL(file);
    }
    function addGstRow() {
        setGstRows((rows)=>[
                ...rows,
                {
                    id: `gst-${Date.now()}`,
                    label: "IGST",
                    rateInput: "18"
                }
            ]);
    }
    function removeGstRow(id) {
        setGstRows((rows)=>rows.filter((r)=>r.id !== id));
    }
    function handleSave() {
        const draft = (0, $b75ffaa91259d13d$export$87070318200d7b82)({
            version: 1,
            documentTitle: documentTitle.trim(),
            letterheadTagline: letterheadTagline.trim(),
            logoPrimaryUrl: logoPrimaryUrl.trim(),
            logoSecondaryUrl: logoSecondaryUrl.trim(),
            logoPrimaryHeightPx: logoPrimaryHeightPx,
            logoSecondaryHeightPx: logoSecondaryHeightPx,
            accentColorHex: accentColorHex.trim(),
            footerNote: footerNote.trim(),
            buyerName: buyerName.trim(),
            buyerAddress: buyerAddress.trim(),
            buyerGstin: buyerGstin.trim(),
            defaultVendorName: defaultVendorName.trim(),
            defaultVendorAddress: defaultVendorAddress.trim(),
            defaultVendorGstin: defaultVendorGstin.trim(),
            paymentTerms: paymentTerms.trim(),
            defaultShipTo: defaultShipTo.trim(),
            aggregateQtyDefault: aggregateQtyDefault,
            gstRows: (0, $b75ffaa91259d13d$export$b2d77326b23e5e14)(gstRows)
        });
        (0, $b75ffaa91259d13d$export$c0bbb72c958e7adc)(draft);
        showToast("PO format saved. Downloads will use these defaults.", "success");
    }
    function handleResetDefaults() {
        const d = (0, $b75ffaa91259d13d$export$c374e061124b6d30)();
        setDocumentTitle(d.documentTitle);
        setLetterheadTagline(d.letterheadTagline);
        setLogoPrimaryUrl(d.logoPrimaryUrl);
        setLogoSecondaryUrl(d.logoSecondaryUrl);
        setLogoPrimaryHeightPx(d.logoPrimaryHeightPx);
        setLogoSecondaryHeightPx(d.logoSecondaryHeightPx);
        setAccentColorHex(d.accentColorHex);
        setFooterNote(d.footerNote);
        setBuyerName(d.buyerName);
        setBuyerAddress(d.buyerAddress);
        setBuyerGstin(d.buyerGstin);
        setDefaultVendorName(d.defaultVendorName);
        setDefaultVendorAddress(d.defaultVendorAddress);
        setDefaultVendorGstin(d.defaultVendorGstin);
        setPaymentTerms(d.paymentTerms);
        setDefaultShipTo(d.defaultShipTo);
        setAggregateQtyDefault(d.aggregateQtyDefault);
        setGstRows($1123febe3e5331be$var$rowsFromSettings(d));
        showToast("Form reset to factory defaults (not saved yet).", "info");
    }
    const samplePreviewInput = (0, $7UyaH.useMemo)(()=>({
            documentTitle: documentTitle.trim(),
            letterheadTagline: letterheadTagline.trim(),
            logoPrimaryUrl: logoPrimaryUrl.trim(),
            logoSecondaryUrl: logoSecondaryUrl.trim(),
            logoPrimaryHeightPx: logoPrimaryHeightPx,
            logoSecondaryHeightPx: logoSecondaryHeightPx,
            accentColorHex: accentColorHex.trim(),
            footerNote: footerNote.trim(),
            buyerName: buyerName.trim(),
            buyerAddress: buyerAddress.trim(),
            buyerGstin: buyerGstin.trim(),
            defaultVendorName: defaultVendorName.trim(),
            defaultVendorAddress: defaultVendorAddress.trim(),
            defaultVendorGstin: defaultVendorGstin.trim(),
            paymentTerms: paymentTerms.trim(),
            defaultShipTo: defaultShipTo.trim(),
            gstRows: (0, $b75ffaa91259d13d$export$b2d77326b23e5e14)(gstRows)
        }), [
        documentTitle,
        letterheadTagline,
        logoPrimaryUrl,
        logoSecondaryUrl,
        logoPrimaryHeightPx,
        logoSecondaryHeightPx,
        accentColorHex,
        footerNote,
        buyerName,
        buyerAddress,
        buyerGstin,
        defaultVendorName,
        defaultVendorAddress,
        defaultVendorGstin,
        paymentTerms,
        defaultShipTo,
        gstRows
    ]);
    const previewHtml = (0, $7UyaH.useMemo)(()=>(0, $386b0bb84b222876$export$73af7d68fa0aa7a6)(samplePreviewInput), [
        samplePreviewInput
    ]);
    const samplePdfDoc = (0, $7UyaH.useMemo)(()=>(0, $386b0bb84b222876$export$bd69534d3059bb5a)(samplePreviewInput), [
        samplePreviewInput
    ]);
    (0, $7UyaH.useEffect)(()=>{
        (0, $b2a79528db62cd8d$export$e6898c6b9b3f226e)([
            logoPrimaryUrl,
            logoSecondaryUrl
        ]);
    }, [
        logoPrimaryUrl,
        logoSecondaryUrl
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "workspace",
        style: {
            display: "flex",
            flexDirection: "column",
            height: "calc(100vh - 4rem)",
            background: "#f1f5f9"
        },
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                style: {
                    width: "100%",
                    padding: "1rem",
                    flex: "0 0 auto",
                    display: "flex",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        gap: "0.25rem",
                        background: "#cbd5e1",
                        padding: "0.3rem",
                        borderRadius: "8px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            className: `btn ${activeTab === "format" ? "btn--primary" : ""}`,
                            style: activeTab === "format" ? {
                                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                minWidth: "140px"
                            } : {
                                background: "transparent",
                                border: "none",
                                color: "#334155",
                                minWidth: "140px",
                                fontWeight: 500
                            },
                            onClick: ()=>setActiveTab("format"),
                            children: "Format Settings"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                            type: "button",
                            className: `btn ${activeTab === "preview" ? "btn--primary" : ""}`,
                            style: activeTab === "preview" ? {
                                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                minWidth: "140px"
                            } : {
                                background: "transparent",
                                border: "none",
                                color: "#334155",
                                minWidth: "140px",
                                fontWeight: 500
                            },
                            onClick: ()=>setActiveTab("preview"),
                            children: "Live Preview"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    flex: 1,
                    overflow: "hidden",
                    gap: "1rem",
                    padding: "0 1rem 1rem 1rem",
                    justifyContent: "center"
                },
                children: [
                    activeTab === "format" && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "card card--gov card--elevated",
                        style: {
                            flex: 1,
                            maxWidth: "1200px",
                            overflowY: "auto",
                            margin: 0,
                            padding: 0,
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                style: {
                                    padding: "1.5rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "section-lead section-lead--tight text-muted",
                                        style: {
                                            marginTop: 0
                                        },
                                        children: "Use the vendor block below for the supplier name, address, and GSTIN shown on every PO and PDF. If vendor name is left blank, the subcontractor firm on that PO is used as the supplier name."
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "inv-outward-issue__grid",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Document title"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control",
                                                        value: documentTitle,
                                                        onChange: (e)=>setDocumentTitle(e.target.value),
                                                        placeholder: "PURCHASE ORDER"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Letterhead tagline (small caps line above title)"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control",
                                                        value: letterheadTagline,
                                                        onChange: (e)=>setLetterheadTagline(e.target.value),
                                                        placeholder: "e.g. Programme / department name"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--r1",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Accent colour (#RRGGBB)"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        type: "color",
                                                        className: "form-control",
                                                        style: {
                                                            maxWidth: "72px",
                                                            height: "38px",
                                                            padding: "4px"
                                                        },
                                                        value: /^#[0-9A-Fa-f]{6}$/.test(accentColorHex.trim()) ? accentColorHex.trim() : "#16365f",
                                                        onChange: (e)=>setAccentColorHex(e.target.value),
                                                        "aria-label": "Accent colour"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--r1",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Accent hex (manual)"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control mono",
                                                        value: accentColorHex,
                                                        onChange: (e)=>setAccentColorHex(e.target.value),
                                                        placeholder: "#16365f"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                style: {
                                                    display: "grid",
                                                    gridTemplateColumns: "1fr 120px",
                                                    gap: "1rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: "0.5rem"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                                className: "inv-outward-issue__field",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                        className: "inv-outward-issue__label",
                                                                        children: "Primary logo (upload image or provide URL)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                        type: "file",
                                                                        accept: "image/*",
                                                                        className: "form-control",
                                                                        style: {
                                                                            padding: "0.4rem 0.6rem"
                                                                        },
                                                                        onChange: (e)=>handleLogoUpload(e, setLogoPrimaryUrl)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                className: "form-control mono",
                                                                value: logoPrimaryUrl,
                                                                onChange: (e)=>setLogoPrimaryUrl(e.target.value),
                                                                placeholder: "Optional \u2014 leave blank for no logo, or paste an https:// URL / base64 data URL"
                                                            })
                                                        ]
                                                    }),
                                                    logoPrimaryUrl && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            border: "1px dashed var(--border)",
                                                            borderRadius: "8px",
                                                            padding: "0.5rem",
                                                            background: "#f8fafc"
                                                        },
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                                                            src: logoPrimaryUrl,
                                                            alt: "Primary preview",
                                                            style: {
                                                                maxHeight: "80px",
                                                                maxWidth: "100%",
                                                                objectFit: "contain"
                                                            }
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--r1",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Primary logo height (px)"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        type: "number",
                                                        min: 28,
                                                        max: 160,
                                                        className: "form-control mono",
                                                        value: Number.isFinite(logoPrimaryHeightPx) ? logoPrimaryHeightPx : "",
                                                        onChange: (e)=>{
                                                            const v = parseInt(e.target.value, 10);
                                                            setLogoPrimaryHeightPx(Number.isFinite(v) ? v : (0, $b75ffaa91259d13d$export$c374e061124b6d30)().logoPrimaryHeightPx);
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                style: {
                                                    display: "grid",
                                                    gridTemplateColumns: "1fr 120px",
                                                    gap: "1rem"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: "0.5rem"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                                className: "inv-outward-issue__field",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                        className: "inv-outward-issue__label",
                                                                        children: "Secondary logo (optional upload or URL)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                        type: "file",
                                                                        accept: "image/*",
                                                                        className: "form-control",
                                                                        style: {
                                                                            padding: "0.4rem 0.6rem"
                                                                        },
                                                                        onChange: (e)=>handleLogoUpload(e, setLogoSecondaryUrl)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                className: "form-control mono",
                                                                value: logoSecondaryUrl,
                                                                onChange: (e)=>setLogoSecondaryUrl(e.target.value),
                                                                placeholder: "/branding/your-company.png or base64..."
                                                            })
                                                        ]
                                                    }),
                                                    logoSecondaryUrl && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            border: "1px dashed var(--border)",
                                                            borderRadius: "8px",
                                                            padding: "0.5rem",
                                                            background: "#f8fafc"
                                                        },
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                                                            src: logoSecondaryUrl,
                                                            alt: "Secondary preview",
                                                            style: {
                                                                maxHeight: "80px",
                                                                maxWidth: "100%",
                                                                objectFit: "contain"
                                                            }
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--r1",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Secondary logo height (px)"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        type: "number",
                                                        min: 28,
                                                        max: 160,
                                                        className: "form-control mono",
                                                        value: Number.isFinite(logoSecondaryHeightPx) ? logoSecondaryHeightPx : "",
                                                        onChange: (e)=>{
                                                            const v = parseInt(e.target.value, 10);
                                                            setLogoSecondaryHeightPx(Number.isFinite(v) ? v : (0, $b75ffaa91259d13d$export$c374e061124b6d30)().logoSecondaryHeightPx);
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                className: "text-muted inv-outward-issue__field inv-outward-issue__field--full",
                                                style: {
                                                    fontSize: "0.86rem",
                                                    margin: "-0.25rem 0 0.35rem"
                                                },
                                                children: "You can either upload an image from your computer directly, or paste an existing URL."
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Footer note (printed under totals)"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                                        className: "form-control",
                                                        rows: 2,
                                                        value: footerNote,
                                                        onChange: (e)=>setFooterNote(e.target.value),
                                                        placeholder: "Optional \u2014 e.g. statutory declaration or office address repeat"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Purchaser / company name"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control",
                                                        value: buyerName,
                                                        onChange: (e)=>setBuyerName(e.target.value)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Purchaser address"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                                        className: "form-control",
                                                        rows: 3,
                                                        value: buyerAddress,
                                                        onChange: (e)=>setBuyerAddress(e.target.value)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--r1",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Purchaser GSTIN"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control mono",
                                                        value: buyerGstin,
                                                        onChange: (e)=>setBuyerGstin(e.target.value.toUpperCase())
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Default vendor / supplier name"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control",
                                                        value: defaultVendorName,
                                                        onChange: (e)=>setDefaultVendorName(e.target.value),
                                                        placeholder: "Leave blank to use the PO subcontractor firm name"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Default vendor address (prefill)"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                                        className: "form-control",
                                                        rows: 2,
                                                        value: defaultVendorAddress,
                                                        onChange: (e)=>setDefaultVendorAddress(e.target.value)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--r1",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Default vendor GSTIN (prefill)"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control mono",
                                                        value: defaultVendorGstin,
                                                        onChange: (e)=>setDefaultVendorGstin(e.target.value.toUpperCase())
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Default ship to / site text"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                                        className: "form-control",
                                                        rows: 2,
                                                        value: defaultShipTo,
                                                        onChange: (e)=>setDefaultShipTo(e.target.value)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Payment & terms"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                                        className: "form-control",
                                                        rows: 3,
                                                        value: paymentTerms,
                                                        onChange: (e)=>setPaymentTerms(e.target.value)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "inv-outward-issue__field inv-outward-issue__field--full",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "inv-outward-issue__label",
                                                        children: "Download panel default"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "0.5rem",
                                                            fontWeight: 400,
                                                            cursor: "pointer"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                type: "checkbox",
                                                                checked: aggregateQtyDefault,
                                                                onChange: (e)=>setAggregateQtyDefault(e.target.checked)
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                children: "Start with aggregated quantities per item when opening PO download"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                style: {
                                    padding: "0 1.5rem 1.5rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                        className: "form-section-title",
                                        children: "Default GST rows"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "text-muted",
                                        style: {
                                            fontSize: "0.88rem",
                                            marginTop: "-0.35rem"
                                        },
                                        children: "Applied on each PO download; tax is computed on taxable value (qty \xd7 rate). You can still change rows before downloading."
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "0.5rem",
                                            marginBottom: "0.75rem"
                                        },
                                        children: gstRows.map((row)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    gap: "0.5rem",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control",
                                                        style: {
                                                            width: "120px"
                                                        },
                                                        value: row.label,
                                                        onChange: (e)=>setGstRows((rs)=>rs.map((r)=>r.id === row.id ? {
                                                                        ...r,
                                                                        label: e.target.value
                                                                    } : r)),
                                                        "aria-label": "GST label"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        className: "form-control mono",
                                                        style: {
                                                            width: "88px"
                                                        },
                                                        value: row.rateInput,
                                                        onChange: (e)=>setGstRows((rs)=>rs.map((r)=>r.id === row.id ? {
                                                                        ...r,
                                                                        rateInput: e.target.value
                                                                    } : r)),
                                                        "aria-label": "GST percent"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "text-muted",
                                                        style: {
                                                            fontSize: "0.85rem"
                                                        },
                                                        children: "%"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "btn btn--secondary btn--sm",
                                                        onClick: ()=>removeGstRow(row.id),
                                                        children: "Remove"
                                                    })
                                                ]
                                            }, row.id))
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "toolbar-row",
                                        style: {
                                            marginBottom: "1rem"
                                        },
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                            type: "button",
                                            className: "btn btn--tg-secondary btn--sm",
                                            onClick: addGstRow,
                                            children: "Add GST row"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                style: {
                                    position: "sticky",
                                    bottom: 0,
                                    background: "#fff",
                                    padding: "1rem 1.5rem",
                                    borderTop: "1px solid var(--border)",
                                    marginTop: "auto",
                                    zIndex: 10
                                },
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "toolbar-row",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                            type: "button",
                                            className: "btn btn--primary btn--tg btn--lg",
                                            onClick: handleSave,
                                            children: "Save PO format"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                            type: "button",
                                            className: "btn btn--tg-secondary btn--lg",
                                            onClick: handleResetDefaults,
                                            children: "Reset"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                            className: "btn btn--tg-secondary btn--lg",
                                            to: "/inventory",
                                            children: "Back"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    activeTab === "preview" && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "card card--gov card--elevated",
                        style: {
                            flex: 1,
                            maxWidth: "1200px",
                            margin: 0,
                            padding: 0,
                            overflowX: "auto",
                            overflowY: "hidden",
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                style: {
                                    padding: "1rem",
                                    borderBottom: "1px solid var(--border)",
                                    background: "#f8fafc",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                                style: {
                                                    margin: 0,
                                                    fontSize: "1rem",
                                                    color: "var(--text)"
                                                },
                                                children: "Live PDF Preview"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                className: "text-muted",
                                                style: {
                                                    margin: "0.2rem 0 0",
                                                    fontSize: "0.85rem"
                                                },
                                                children: "Updates instantly. Uses sample materials."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--primary btn--tg btn--sm",
                                        disabled: samplePdfBusy,
                                        onClick: ()=>{
                                            (async ()=>{
                                                setSamplePdfBusy(true);
                                                try {
                                                    await (0, $b2a79528db62cd8d$export$768a1993afbfc55d)((0, $386b0bb84b222876$export$73af7d68fa0aa7a6)(samplePreviewInput, {
                                                        forPdfCapture: true
                                                    }), "PO_SAMPLE_PREVIEW", {
                                                        annexure: {
                                                            allocations: samplePdfDoc.allocations,
                                                            accentColorHex: samplePdfDoc.accentColorHex,
                                                            footerNote: samplePdfDoc.footerNote
                                                        }
                                                    });
                                                    showToast("Sample PO PDF downloaded.", "success");
                                                } catch (e) {
                                                    showToast(e instanceof Error ? e.message : "Could not create PDF.", "error");
                                                } finally{
                                                    setSamplePdfBusy(false);
                                                }
                                            })();
                                        },
                                        children: samplePdfBusy ? "Creating PDF\u2026" : "Download PDF"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("iframe", {
                                srcDoc: previewHtml,
                                style: {
                                    flex: 1,
                                    width: "100%",
                                    minWidth: "800px",
                                    border: "none",
                                    background: "#cbd5e1"
                                },
                                title: "Live PO Preview"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");




var $7UyaH = parcelRequire("7UyaH");


async function $4944b5f129cdcba5$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
const $4944b5f129cdcba5$var$LEVEL_KEYS = [
    "requestCategory",
    "mainGroup",
    "group",
    "category",
    "subcategory"
];
function $4944b5f129cdcba5$var$appendFilters(u, f) {
    if (f.requestCategory) u.set("requestCategory", f.requestCategory);
    if (f.mainGroup) u.set("mainGroup", f.mainGroup);
    if (f.group) u.set("group", f.group);
    if (f.category) u.set("category", f.category);
    if (f.subcategory) u.set("subcategory", f.subcategory);
}
function $4944b5f129cdcba5$var$toQuery(f) {
    const u = new URLSearchParams();
    $4944b5f129cdcba5$var$appendFilters(u, f);
    const s = u.toString();
    return s ? `?${s}` : "";
}
async function $4944b5f129cdcba5$export$61555c4aebd07c4f(level, filters) {
    const base = `${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/standard-item-master/distinct/${encodeURIComponent(level)}`;
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${base}${$4944b5f129cdcba5$var$toQuery(filters)}`);
    if (!res.ok) throw new Error(await $4944b5f129cdcba5$var$parseError(res));
    const j = await res.json();
    return j.values ?? [];
}
async function $4944b5f129cdcba5$export$e0425f1ebdb25db1(input) {
    const u = new URLSearchParams();
    $4944b5f129cdcba5$var$appendFilters(u, input.filters);
    if (input.q?.trim()) u.set("q", input.q.trim());
    u.set("limit", String(input.limit ?? 80));
    u.set("offset", String(input.offset ?? 0));
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/standard-item-master/items?${u}`);
    if (!res.ok) throw new Error(await $4944b5f129cdcba5$var$parseError(res));
    return res.json();
}
async function $4944b5f129cdcba5$export$a92d09b7573341c3() {
    try {
        const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/standard-item-master/health`);
        if (!res.ok) return false;
        const j = await res.json();
        return Boolean(j.ok);
    } catch  {
        return false;
    }
}




const $d716dad8bdf45e01$var$EMPTY_OPTS = [
    {
        value: "",
        label: "\u2014 All / any \u2014",
        rowKey: "none"
    }
];
function $d716dad8bdf45e01$export$d6d17eff0e317b7f({ resource: resource }) {
    const { addStandardResourceItem: addStandardResourceItem } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const [catalogOk, setCatalogOk] = (0, $7UyaH.useState)(null);
    const [mainGroup, setMainGroup] = (0, $7UyaH.useState)("");
    const [group, setGroup] = (0, $7UyaH.useState)("");
    const [category, setCategory] = (0, $7UyaH.useState)("");
    const [subcategory, setSubcategory] = (0, $7UyaH.useState)("");
    const [searchQ, setSearchQ] = (0, $7UyaH.useState)("");
    const [optMain, setOptMain] = (0, $7UyaH.useState)([]);
    const [optGrp, setOptGrp] = (0, $7UyaH.useState)([]);
    const [optCat, setOptCat] = (0, $7UyaH.useState)([]);
    const [optSub, setOptSub] = (0, $7UyaH.useState)([]);
    const [items, setItems] = (0, $7UyaH.useState)([]);
    const [total, setTotal] = (0, $7UyaH.useState)(0);
    const [offset, setOffset] = (0, $7UyaH.useState)(0);
    const [loading, setLoading] = (0, $7UyaH.useState)(false);
    const [listError, setListError] = (0, $7UyaH.useState)(null);
    const [selected, setSelected] = (0, $7UyaH.useState)(null);
    const [addQty, setAddQty] = (0, $7UyaH.useState)("1");
    const filters = (0, $7UyaH.useMemo)(()=>({
            mainGroup: mainGroup || undefined,
            group: group || undefined,
            category: category || undefined,
            subcategory: subcategory || undefined
        }), [
        mainGroup,
        group,
        category,
        subcategory
    ]);
    /** Item list loads only after user picks a main group (no full-catalog fetch on open). */ const listReady = Boolean(mainGroup.trim());
    const existingCatalogIds = (0, $7UyaH.useMemo)(()=>{
        const s = new Set();
        for (const it of resource.items)if (it.catalogStandardItemId) s.add(it.catalogStandardItemId);
        return s;
    }, [
        resource.items
    ]);
    (0, $7UyaH.useEffect)(()=>{
        let cancelled = false;
        (0, $4944b5f129cdcba5$export$a92d09b7573341c3)().then((ok)=>{
            if (!cancelled) setCatalogOk(ok);
        });
        return ()=>{
            cancelled = true;
        };
    }, []);
    const loadDistinct = (0, $7UyaH.useCallback)(async (level, f, setter)=>{
        try {
            const v = await (0, $4944b5f129cdcba5$export$61555c4aebd07c4f)(level, f);
            setter(v);
        } catch  {
            setter([]);
        }
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        if (!catalogOk) return;
        loadDistinct("mainGroup", {}, setOptMain);
    }, [
        catalogOk,
        loadDistinct
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!catalogOk) return;
        setGroup("");
        setCategory("");
        setSubcategory("");
        if (!mainGroup) {
            setOptGrp([]);
            setOptCat([]);
            setOptSub([]);
            return;
        }
        loadDistinct("group", {
            mainGroup: mainGroup
        }, setOptGrp);
    }, [
        catalogOk,
        mainGroup,
        loadDistinct
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!catalogOk || !mainGroup) return;
        setCategory("");
        setSubcategory("");
        if (!group) {
            setOptCat([]);
            setOptSub([]);
            return;
        }
        loadDistinct("category", {
            mainGroup: mainGroup,
            group: group
        }, setOptCat);
    }, [
        catalogOk,
        mainGroup,
        group,
        loadDistinct
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!catalogOk || !mainGroup || !group) return;
        setSubcategory("");
        if (!category) {
            setOptSub([]);
            return;
        }
        loadDistinct("subcategory", {
            mainGroup: mainGroup,
            group: group,
            category: category
        }, setOptSub);
    }, [
        catalogOk,
        mainGroup,
        group,
        category,
        loadDistinct
    ]);
    const limit = 80;
    const loadItems = (0, $7UyaH.useCallback)(async (nextOffset, append)=>{
        if (!catalogOk || !mainGroup.trim()) {
            if (!append) {
                setItems([]);
                setTotal(0);
                setOffset(0);
                setSelected(null);
            }
            return;
        }
        setLoading(true);
        setListError(null);
        try {
            const res = await (0, $4944b5f129cdcba5$export$e0425f1ebdb25db1)({
                filters: filters,
                q: searchQ.trim() || undefined,
                limit: limit,
                offset: nextOffset
            });
            setTotal(res.total);
            setOffset(nextOffset);
            setItems((prev)=>append ? [
                    ...prev,
                    ...res.items
                ] : res.items);
            if (!append) setSelected(null);
        } catch (e) {
            setListError(e instanceof Error ? e.message : "Could not load catalogue items.");
            if (!append) setItems([]);
        } finally{
            setLoading(false);
        }
    }, [
        catalogOk,
        mainGroup,
        filters,
        searchQ
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!catalogOk) return;
        if (!mainGroup.trim()) {
            setItems([]);
            setTotal(0);
            setOffset(0);
            setListError(null);
            setLoading(false);
            setSelected(null);
            return;
        }
        const t = window.setTimeout(()=>void loadItems(0, false), 280);
        return ()=>window.clearTimeout(t);
    }, [
        catalogOk,
        mainGroup,
        filters,
        searchQ,
        loadItems
    ]);
    const toSelectOpts = (vals)=>[
            ...$d716dad8bdf45e01$var$EMPTY_OPTS,
            ...vals.map((v)=>({
                    value: v,
                    label: v,
                    rowKey: v
                }))
        ];
    if (catalogOk === false || catalogOk === null) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "standard-catalog-picker standard-catalog-picker--offline help-banner help-banner--info",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                children: "Standard item catalogue"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                style: {
                    margin: "0.35rem 0 0"
                },
                children: catalogOk === null ? "Checking catalogue API\u2026" : "Connect the API with MySQL and import `tabStandardItemMaster` to pick items by main group, group, category, and subcategory here."
            })
        ]
    });
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "standard-catalog-picker card card--gov",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "standard-catalog-picker__header",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        children: "Add from standard item catalogue"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "standard-catalog-picker__lead text-muted",
                        children: "Use main group (required), then optional filters and search. Pick a row in the table, set quantity, add to this resource."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "standard-catalog-picker__controls",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field field-inline standard-catalog-picker__filter",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: `sim-main-${resource.id}`,
                                children: "Main group"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                id: `sim-main-${resource.id}`,
                                variant: "dash",
                                value: mainGroup,
                                onChange: (v)=>setMainGroup(v),
                                options: toSelectOpts(optMain),
                                placeholder: "Select main group\u2026"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field field-inline standard-catalog-picker__filter",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: `sim-grp-${resource.id}`,
                                children: "Group"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                id: `sim-grp-${resource.id}`,
                                variant: "dash",
                                value: group,
                                onChange: (v)=>setGroup(v),
                                options: toSelectOpts(optGrp),
                                placeholder: mainGroup ? "\u2014 All \u2014" : "Pick main group first",
                                disabled: !mainGroup
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field field-inline standard-catalog-picker__filter",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: `sim-cat-${resource.id}`,
                                children: "Category"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                id: `sim-cat-${resource.id}`,
                                variant: "dash",
                                value: category,
                                onChange: (v)=>setCategory(v),
                                options: toSelectOpts(optCat),
                                placeholder: group ? "\u2014 All \u2014" : "Pick group first",
                                disabled: !group
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field field-inline standard-catalog-picker__filter",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: `sim-sub-${resource.id}`,
                                children: "Subcategory"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                id: `sim-sub-${resource.id}`,
                                variant: "dash",
                                value: subcategory,
                                onChange: (v)=>setSubcategory(v),
                                options: toSelectOpts(optSub),
                                placeholder: category ? "\u2014 All \u2014" : "Pick category first",
                                disabled: !category
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "field field-inline standard-catalog-picker__search-field",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                htmlFor: `sim-q-${resource.id}`,
                                children: "Search nomenclature / ID / family"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                id: `sim-q-${resource.id}`,
                                value: searchQ,
                                onChange: (e)=>setSearchQ(e.target.value),
                                placeholder: "e.g. AAC or STD-",
                                maxLength: 200
                            })
                        ]
                    })
                ]
            }),
            !listReady ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "standard-catalog-picker__hint",
                role: "status",
                children: [
                    "Choose a ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: "main group"
                    }),
                    " first \u2014 the item table and actions appear here after you do."
                ]
            }) : null,
            listReady ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "standard-catalog-picker__results",
                children: [
                    listError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "standard-catalog-picker__error",
                        role: "alert",
                        children: listError
                    }) : null,
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "standard-catalog-picker__list-scroll",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "standard-catalog-picker__list",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "standard-catalog-picker__list-head",
                                    role: "row",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "standard-catalog-picker__item-name",
                                            role: "columnheader",
                                            children: "Item name"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "standard-catalog-picker__item-uom",
                                            role: "columnheader",
                                            children: "UOM"
                                        })
                                    ]
                                }),
                                loading && items.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "standard-catalog-picker__list-empty",
                                    children: "Loading\u2026"
                                }) : null,
                                !loading && items.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "standard-catalog-picker__list-empty",
                                    children: "No rows \u2014 adjust filters or clear search."
                                }) : null,
                                items.map((row)=>{
                                    const sel = selected?.standardItemId === row.standardItemId;
                                    const dup = existingCatalogIds.has(row.standardItemId);
                                    const displayName = (row.nomenclature || row.standardItemId || "").trim() || "\u2014";
                                    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        role: dup ? undefined : "button",
                                        tabIndex: dup ? undefined : 0,
                                        "aria-label": dup ? `${displayName}, already on resource` : `Select ${displayName}`,
                                        title: dup ? "Already on this resource" : "Select this line",
                                        className: [
                                            "standard-catalog-picker__list-row",
                                            sel ? "standard-catalog-picker__list-row--selected" : "",
                                            dup ? "standard-catalog-picker__list-row--disabled" : "standard-catalog-picker__list-row--clickable"
                                        ].filter(Boolean).join(" "),
                                        onClick: ()=>{
                                            if (!dup) setSelected(row);
                                        },
                                        onKeyDown: (e)=>{
                                            if (dup) return;
                                            if (e.key === "Enter" || e.key === " ") {
                                                e.preventDefault();
                                                setSelected(row);
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                className: "standard-catalog-picker__item-name",
                                                children: [
                                                    displayName,
                                                    dup ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                        className: "text-muted standard-catalog-picker__dup",
                                                        children: " (added)"
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "standard-catalog-picker__item-uom",
                                                children: row.uom ?? "\u2014"
                                            })
                                        ]
                                    }, row.standardItemId);
                                })
                            ]
                        })
                    }),
                    selected ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "standard-catalog-picker__selection",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "standard-catalog-picker__selection-label",
                                children: "Selected"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                className: "standard-catalog-picker__selection-text",
                                children: [
                                    (selected.nomenclature || selected.standardItemId || "").trim() || "\u2014",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                        className: "standard-catalog-picker__selection-uom",
                                        children: [
                                            " ",
                                            "\xb7 ",
                                            selected.uom?.trim() || "\u2014"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                        className: "standard-catalog-picker__selection-id text-muted",
                                        children: [
                                            " ",
                                            "(",
                                            selected.standardItemId,
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "standard-catalog-picker__selection standard-catalog-picker__selection--empty text-muted",
                        children: "Click a row in the list to select a line."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "standard-catalog-picker__actions",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "standard-catalog-picker__actions-start",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--tg-secondary btn--sm",
                                        disabled: loading || offset + items.length >= total,
                                        onClick: ()=>void loadItems(offset + items.length, true),
                                        children: "Load more"
                                    }),
                                    !loading && total > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                        className: "standard-catalog-picker__count text-muted",
                                        children: [
                                            "Showing ",
                                            items.length,
                                            " of ",
                                            total
                                        ]
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "standard-catalog-picker__actions-end",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "standard-catalog-picker__qty",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                htmlFor: `sim-qty-${resource.id}`,
                                                children: "Qty"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                id: `sim-qty-${resource.id}`,
                                                type: "number",
                                                min: 0,
                                                step: 1,
                                                value: addQty,
                                                onChange: (e)=>setAddQty(e.target.value)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--primary btn--tg btn--sm standard-catalog-picker__add-btn",
                                        disabled: !selected || existingCatalogIds.has(selected.standardItemId) || !(selected.nomenclature || selected.standardItemId).trim(),
                                        onClick: ()=>{
                                            if (!selected) return;
                                            const label = (selected.nomenclature || selected.standardItemId).trim();
                                            const unit = (selected.uom || "NOS").trim();
                                            const quantity = Math.max(0, Math.floor(Number(addQty)) || 0);
                                            (async ()=>{
                                                const suggestedHsn = (selected.suggestedHsn4 ?? "").trim().replace(/\s+/g, "").slice(0, 40);
                                                const ok = await addStandardResourceItem(resource.id, {
                                                    label: label,
                                                    quantity: quantity,
                                                    unit: unit,
                                                    hsnCode: suggestedHsn,
                                                    catalogStandardItemId: selected.standardItemId
                                                });
                                                if (ok) setSelected(null);
                                            })();
                                        },
                                        children: "Add to resource"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : null
        ]
    });
}





function $e7aada4415112cec$var$ItemEditorRow({ resourceId: resourceId, item: item }) {
    const { updateStandardResourceItem: updateStandardResourceItem, removeStandardResourceItem: removeStandardResourceItem } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const [label, setLabel] = (0, $7UyaH.useState)(item.label);
    const [quantity, setQuantity] = (0, $7UyaH.useState)(String(item.quantity));
    const [unit, setUnit] = (0, $7UyaH.useState)(item.unit);
    const [rate, setRate] = (0, $7UyaH.useState)(String(item.rate ?? 0));
    const [hsnCode, setHsnCode] = (0, $7UyaH.useState)(item.hsnCode ?? "");
    (0, $7UyaH.useEffect)(()=>{
        setLabel(item.label);
        setQuantity(String(item.quantity));
        setUnit(item.unit);
        setRate(String(item.rate ?? 0));
        setHsnCode(item.hsnCode ?? "");
    }, [
        item.id,
        item.label,
        item.quantity,
        item.unit,
        item.rate,
        item.hsnCode
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "standard-resource-item-row",
        children: [
            item.catalogStandardItemId ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "text-muted section-lead section-lead--tight",
                style: {
                    width: "100%",
                    margin: "0 0 0.35rem"
                },
                children: [
                    "Catalogue ID: ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("code", {
                        children: item.catalogStandardItemId
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                style: {
                    flex: "1 1 10rem",
                    marginBottom: 0
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        className: "sr-only",
                        htmlFor: `sri-label-${item.id}`,
                        children: "Item description"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                        id: `sri-label-${item.id}`,
                        value: label,
                        onChange: (e)=>setLabel(e.target.value),
                        placeholder: "e.g. OPC bags",
                        maxLength: 200
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field standard-resource-item-row__qty",
                style: {
                    marginBottom: 0
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        className: "sr-only",
                        htmlFor: `sri-qty-${item.id}`,
                        children: "Quantity"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                        id: `sri-qty-${item.id}`,
                        type: "number",
                        min: 0,
                        step: 1,
                        value: quantity,
                        onChange: (e)=>setQuantity(e.target.value)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field standard-resource-item-row__qty",
                style: {
                    marginBottom: 0,
                    maxWidth: "7rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        className: "sr-only",
                        htmlFor: `sri-rate-${item.id}`,
                        children: "Rate (\u20B9 per unit)"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                        id: `sri-rate-${item.id}`,
                        type: "text",
                        inputMode: "decimal",
                        value: rate,
                        onChange: (e)=>setRate(e.target.value),
                        placeholder: "0",
                        title: "Unit rate in \u20B9 \u2014 used on PO / issue material when generated"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field standard-resource-item-row__qty",
                style: {
                    marginBottom: 0,
                    maxWidth: "8rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        className: "sr-only",
                        htmlFor: `sri-hsn-${item.id}`,
                        children: "HSN / SAC"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                        id: `sri-hsn-${item.id}`,
                        type: "text",
                        inputMode: "numeric",
                        value: hsnCode,
                        onChange: (e)=>setHsnCode(e.target.value),
                        placeholder: "HSN",
                        maxLength: 40,
                        title: "HSN/SAC \u2014 copied to PO when generated",
                        className: "mono"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                style: {
                    flex: "1 1 6rem",
                    marginBottom: 0
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        className: "sr-only",
                        htmlFor: `sri-unit-${item.id}`,
                        children: "Unit"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                        id: `sri-unit-${item.id}`,
                        value: unit,
                        onChange: (e)=>setUnit(e.target.value),
                        placeholder: "Bag",
                        maxLength: 40
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "standard-resource-item-row__actions",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--primary btn--tg btn--sm",
                        disabled: !label.trim() || !unit.trim(),
                        onClick: ()=>{
                            const parsedRate = Math.max(0, (0, $50736abadf17d9d0$export$9402e78cb00b9e90)(rate));
                            const hsn = hsnCode.trim().replace(/\s+/g, "").slice(0, 40);
                            updateStandardResourceItem(resourceId, item.id, {
                                label: label.trim(),
                                quantity: Math.max(0, Math.floor(Number(quantity)) || 0),
                                unit: unit.trim(),
                                rate: parsedRate,
                                hsnCode: hsn
                            });
                        },
                        children: "Save line"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--link btn--sm",
                        onClick: ()=>{
                            if (window.confirm("Remove this item line?")) removeStandardResourceItem(resourceId, item.id);
                        },
                        children: "Remove"
                    })
                ]
            })
        ]
    });
}
function $e7aada4415112cec$var$StandardResourceSummaryCard({ resource: r, resourceIndex: resourceIndex, isActive: isActive, onOpen: onOpen }) {
    const n = r.items.length;
    const note = r.notes.trim();
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("button", {
        type: "button",
        className: `milestone-master-picker-card${isActive ? " milestone-master-picker-card--active" : ""}`,
        onClick: onOpen,
        "aria-haspopup": "dialog",
        "aria-expanded": isActive,
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "milestone-master-picker-card__content",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__top",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                            className: "milestone-master-picker-card__phase-badge",
                            children: [
                                "Resource ",
                                resourceIndex + 1
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__title",
                        children: r.title
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__stats",
                        "aria-label": "Line count",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                            children: [
                                n,
                                " item line",
                                n === 1 ? "" : "s"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                className: "milestone-master-picker-card__footer",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                    children: isActive ? "Editor open" : "Click card to edit"
                })
            })
        ]
    });
}
function $e7aada4415112cec$var$ResourceEditorForm({ resource: r, index: index, total: total, onDeleted: onDeleted }) {
    const { updateStandardResource: updateStandardResource, removeStandardResource: removeStandardResource, moveStandardResource: moveStandardResource } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const [title, setTitle] = (0, $7UyaH.useState)(r.title);
    const [notes, setNotes] = (0, $7UyaH.useState)(r.notes);
    (0, $7UyaH.useEffect)(()=>{
        setTitle(r.title);
        setNotes(r.notes);
    }, [
        r.id,
        r.title,
        r.notes
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "milestone-master-modal-editor",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "toolbar-row",
                style: {
                    justifyContent: "space-between",
                    alignItems: "flex-start"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "text-muted section-lead section-lead--tight",
                        style: {
                            margin: 0,
                            maxWidth: "36rem"
                        },
                        children: [
                            "Resource ",
                            index + 1,
                            " of ",
                            total,
                            ". Order matches milestone resource pickers. Deleting removes links from milestone templates that reference this resource."
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--tg-secondary btn--sm milestone-row__remove",
                        onClick: ()=>{
                            if (window.confirm(`Delete \u{201C}${r.title}\u{201D}? Milestones that link this resource will lose the link.`)) (async ()=>{
                                const ok = await removeStandardResource(r.id);
                                if (ok) onDeleted?.();
                            })();
                        },
                        children: "Delete resource"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: `sr-title-${r.id}`,
                        children: "Resource name"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                        id: `sr-title-${r.id}`,
                        value: title,
                        onChange: (e)=>setTitle(e.target.value),
                        maxLength: 200
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: `sr-notes-${r.id}`,
                        children: "Notes (optional)"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                        id: `sr-notes-${r.id}`,
                        rows: 2,
                        value: notes,
                        onChange: (e)=>setNotes(e.target.value),
                        maxLength: 2000
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "toolbar-row",
                style: {
                    gap: "0.5rem",
                    flexWrap: "wrap"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--primary btn--tg btn--sm",
                        disabled: !title.trim(),
                        onClick: ()=>void updateStandardResource(r.id, {
                                title: title.trim(),
                                notes: notes
                            }),
                        children: "Save name & notes"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--tg-secondary btn--sm",
                        disabled: index <= 0,
                        onClick: ()=>void moveStandardResource(r.id, "up"),
                        children: "Move up"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--tg-secondary btn--sm",
                        disabled: index >= total - 1,
                        onClick: ()=>void moveStandardResource(r.id, "down"),
                        children: "Move down"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                className: "form-section-title",
                style: {
                    marginTop: "1.15rem"
                },
                children: "Item lines"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "text-muted section-lead section-lead--tight",
                children: [
                    "Add lines only from the standard item catalogue below (MySQL and imported master required). Milestones show these lines when this resource is linked under ",
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                        to: "/milestone-master",
                        children: "Milestone master"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d716dad8bdf45e01$export$d6d17eff0e317b7f), {
                resource: r
            }),
            r.items.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "text-muted section-lead section-lead--tight",
                children: "No item lines yet \u2014 use the catalogue above after choosing a main group."
            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "standard-resource-items",
                children: r.items.map((it)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($e7aada4415112cec$var$ItemEditorRow, {
                        resourceId: r.id,
                        item: it
                    }, it.id))
            })
        ]
    });
}
function $e7aada4415112cec$export$327e887756d28434() {
    const { standardResources: standardResources, addStandardResource: addStandardResource } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const sorted = (0, $7UyaH.useMemo)(()=>(0, $75ee0f08bbd50d82$export$a6798fb462b4557)(standardResources), [
        standardResources
    ]);
    const [createModalOpen, setCreateModalOpen] = (0, $7UyaH.useState)(false);
    const [editModalResourceId, setEditModalResourceId] = (0, $7UyaH.useState)(null);
    const [newTitle, setNewTitle] = (0, $7UyaH.useState)("");
    const [newNotes, setNewNotes] = (0, $7UyaH.useState)("");
    const editModalResource = (0, $7UyaH.useMemo)(()=>editModalResourceId ? sorted.find((x)=>x.id === editModalResourceId) : undefined, [
        editModalResourceId,
        sorted
    ]);
    const editModalIndex = (0, $7UyaH.useMemo)(()=>{
        if (!editModalResource) return -1;
        return sorted.findIndex((r)=>r.id === editModalResource.id);
    }, [
        editModalResource,
        sorted
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (editModalResourceId && !editModalResource) setEditModalResourceId(null);
    }, [
        editModalResourceId,
        editModalResource
    ]);
    const closeCreateModal = (0, $7UyaH.useCallback)(()=>{
        setCreateModalOpen(false);
        setNewTitle("");
        setNewNotes("");
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        if (!createModalOpen && !editModalResourceId) return;
        const onKey = (e)=>{
            if (e.key === "Escape") {
                closeCreateModal();
                setEditModalResourceId(null);
            }
        };
        window.addEventListener("keydown", onKey);
        return ()=>window.removeEventListener("keydown", onKey);
    }, [
        createModalOpen,
        editModalResourceId,
        closeCreateModal
    ]);
    const openCreateModal = ()=>{
        setEditModalResourceId(null);
        setCreateModalOpen(true);
    };
    const openEditModal = (id)=>{
        setCreateModalOpen(false);
        setEditModalResourceId((prev)=>prev === id ? null : id);
    };
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "milestone-master-page",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Standard resources"
                    }
                ],
                title: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem"
                    },
                    children: [
                        "Standard resources master",
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                            className: "milestone-master__catalog-count",
                            children: sorted.length
                        })
                    ]
                }),
                actions: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                    type: "button",
                    className: "btn btn--primary btn--tg btn--sm",
                    onClick: openCreateModal,
                    children: "Add resource"
                })
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("section", {
                className: "milestone-master__catalog",
                "aria-labelledby": "standard-resources-catalog-heading",
                style: {
                    marginTop: "1.75rem"
                },
                children: sorted.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "milestone-master__empty",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                            className: "milestone-master__empty-title",
                            children: "No resources yet"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                            className: "milestone-master__empty-desc",
                            children: [
                                "Create your first category with ",
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                    children: "Add resource"
                                }),
                                ", then open the card to add catalogue item lines."
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                    className: "milestone-master-picker-grid",
                    children: sorted.map((r, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($e7aada4415112cec$var$StandardResourceSummaryCard, {
                            resource: r,
                            resourceIndex: i,
                            isActive: editModalResourceId === r.id,
                            onOpen: ()=>openEditModal(r.id)
                        }, r.id))
                })
            }),
            createModalOpen ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "modal-backdrop",
                role: "presentation",
                onClick: ()=>{
                    closeCreateModal();
                },
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "modal milestone-master-modal standard-resources-master-modal",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "standard-resources-create-title",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "milestone-master-modal__header",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                    id: "standard-resources-create-title",
                                    className: "milestone-master-modal__title",
                                    children: "Add resource"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--tg-secondary btn--sm",
                                    onClick: closeCreateModal,
                                    children: "Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "milestone-master-modal__body",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                            htmlFor: "new-sr-title",
                                            children: "Resource name"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                            id: "new-sr-title",
                                            value: newTitle,
                                            onChange: (e)=>setNewTitle(e.target.value),
                                            placeholder: "e.g. Cement",
                                            maxLength: 200
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "field",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                            htmlFor: "new-sr-notes",
                                            children: "Notes (optional)"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                            id: "new-sr-notes",
                                            rows: 2,
                                            value: newNotes,
                                            onChange: (e)=>setNewNotes(e.target.value),
                                            maxLength: 2000
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                    className: "text-muted section-lead section-lead--tight",
                                    style: {
                                        marginTop: "0.25rem"
                                    },
                                    children: "After you create the resource, open its card to add item lines from the standard catalogue."
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "toolbar-row",
                                    style: {
                                        gap: "0.5rem",
                                        flexWrap: "wrap",
                                        marginTop: "0.75rem"
                                    },
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--primary btn--tg",
                                        disabled: !newTitle.trim(),
                                        onClick: ()=>{
                                            (async ()=>{
                                                const id = await addStandardResource({
                                                    title: newTitle.trim(),
                                                    notes: newNotes.trim()
                                                });
                                                if (!id) return;
                                                closeCreateModal();
                                            })();
                                        },
                                        children: "Add resource"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }) : null,
            editModalResource && editModalIndex >= 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "modal-backdrop",
                role: "presentation",
                onClick: ()=>{
                    setEditModalResourceId(null);
                },
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "modal milestone-master-modal standard-resources-master-modal",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "standard-resources-edit-title",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "milestone-master-modal__header",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                    id: "standard-resources-edit-title",
                                    className: "milestone-master-modal__title",
                                    children: "Edit resource"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--tg-secondary btn--sm",
                                    onClick: ()=>setEditModalResourceId(null),
                                    children: "Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "milestone-master-modal__body",
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($e7aada4415112cec$var$ResourceEditorForm, {
                                resource: editModalResource,
                                index: editModalIndex,
                                total: sorted.length,
                                onDeleted: ()=>setEditModalResourceId(null)
                            }, editModalResource.id)
                        })
                    ]
                })
            }) : null
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");







async function $7547c9f6666296ea$var$parseError(res) {
    const text = await res.text();
    try {
        const j = JSON.parse(text);
        if (j.error) return j.error;
    } catch  {
    /* ignore */ }
    return text || `Request failed (${res.status})`;
}
async function $7547c9f6666296ea$export$c8f5b98b4b31b522() {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/geo/zone-group-categories`);
    if (!res.ok) throw new Error(await $7547c9f6666296ea$var$parseError(res));
    return res.json();
}
async function $7547c9f6666296ea$export$1750e50fa4d0b6bc(input) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/geo/zone-group-categories`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            name: input.name,
            notes: input.notes ?? ""
        })
    });
    if (!res.ok) throw new Error(await $7547c9f6666296ea$var$parseError(res));
    return res.json();
}
async function $7547c9f6666296ea$export$ffbd683d491c4113(id, patch) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/geo/zone-group-categories/${encodeURIComponent(id)}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(patch)
    });
    if (!res.ok) throw new Error(await $7547c9f6666296ea$var$parseError(res));
    return res.json();
}
async function $7547c9f6666296ea$export$51bce094702d1e09(id) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/geo/zone-group-categories/${encodeURIComponent(id)}`, {
        method: "DELETE"
    });
    if (!res.ok && res.status !== 204) throw new Error(await $7547c9f6666296ea$var$parseError(res));
}
async function $7547c9f6666296ea$export$f8043e5beffc2a9a(zoneId) {
    const q = zoneId?.trim() ? `?zoneId=${encodeURIComponent(zoneId.trim())}` : "";
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/geo/zone-groups${q}`);
    if (!res.ok) throw new Error(await $7547c9f6666296ea$var$parseError(res));
    return res.json();
}
async function $7547c9f6666296ea$export$4ef5c9935f0e92d(input) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/geo/zone-groups`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            zoneId: input.zoneId,
            categoryId: input.categoryId,
            name: input.name,
            notes: input.notes ?? ""
        })
    });
    if (!res.ok) throw new Error(await $7547c9f6666296ea$var$parseError(res));
    return res.json();
}
async function $7547c9f6666296ea$export$40748f54f7e4bafb(id, patch) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/geo/zone-groups/${encodeURIComponent(id)}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(patch)
    });
    if (!res.ok) throw new Error(await $7547c9f6666296ea$var$parseError(res));
    return res.json();
}
async function $7547c9f6666296ea$export$8e02f10db65faff9(id) {
    const res = await (0, $ef26d4be1347a164$export$5341712c39afc62d)(`${(0, $3007f8decf026d71$export$4d28219d42798a75)()}/api/geo/zone-groups/${encodeURIComponent(id)}`, {
        method: "DELETE"
    });
    if (!res.ok && res.status !== 204) throw new Error(await $7547c9f6666296ea$var$parseError(res));
}





function $6b3c5d00366b6c37$export$7046b8cf51e1a585(app, zones, groups) {
    const zoneIds = new Set(zones.filter((z)=>(0, $51c57f3e5aa6a385$export$d6b86fbd35e4a8a4)(app, z)).map((z)=>z.id));
    return groups.filter((g)=>zoneIds.has(g.zoneId));
}
function $6b3c5d00366b6c37$export$ecda58998082f6f1(zoneId, groups) {
    return groups.filter((g)=>g.zoneId === zoneId).sort((a, b)=>a.sortOrder - b.sortOrder || a.name.localeCompare(b.name));
}
function $6b3c5d00366b6c37$export$f8e446e009510294(categories, categoryId) {
    return categories.find((c)=>c.id === categoryId)?.name ?? "";
}


function $f8d7d882f697b938$var$districtLabel(geoStore, key) {
    return (0, $65d82a3223f822b8$export$1592aa82ad273940)(geoStore, key);
}
function $f8d7d882f697b938$var$zoneNameById(zones, id) {
    return zones.find((z)=>z.id === id)?.name ?? id;
}
function $f8d7d882f697b938$var$ZoneSummaryCard({ zone: zone, zoneIndex: zoneIndex, isActive: isActive, onOpen: onOpen }) {
    const dCount = zone.districtKeys.length;
    const mCount = zone.mandalRefs.length;
    const vCount = zone.villageRefs.length;
    const stats = [
        dCount ? `${dCount} dist` : "",
        mCount ? `${mCount} mdl` : "",
        vCount ? `${vCount} vil` : ""
    ].filter(Boolean).join(" \xb7 ") || "No geo rules";
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("button", {
        type: "button",
        className: `milestone-master-picker-card${isActive ? " milestone-master-picker-card--active" : ""}`,
        onClick: onOpen,
        "aria-haspopup": "dialog",
        "aria-expanded": isActive,
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "milestone-master-picker-card__content",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__top",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                            className: "milestone-master-picker-card__phase-badge",
                            children: [
                                "Zone ",
                                zoneIndex + 1
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__title",
                        children: zone.name
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__stats",
                        "aria-label": "Coverage stats",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                            children: stats
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                className: "milestone-master-picker-card__footer",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                    children: isActive ? "Editor open" : "Click card to edit"
                })
            })
        ]
    });
}
function $f8d7d882f697b938$var$ZoneEditorCard({ zone: z, index: index, total: total, onDeleted: onDeleted }) {
    const { store: geoStore } = (0, $60dd8507bac67e50$export$5ec0231075ddedf1)();
    const { applications: applications, updateGeoZone: updateGeoZone, removeGeoZone: removeGeoZone } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const [name, setName] = (0, $7UyaH.useState)(z.name);
    const [notes, setNotes] = (0, $7UyaH.useState)(z.notes);
    (0, $7UyaH.useEffect)(()=>{
        setName(z.name);
        setNotes(z.notes);
    }, [
        z.id,
        z.name,
        z.notes
    ]);
    const matchCount = (0, $7UyaH.useMemo)(()=>applications.filter((a)=>(0, $51c57f3e5aa6a385$export$d6b86fbd35e4a8a4)(a, z)).length, [
        applications,
        z
    ]);
    const [mandalDistrict, setMandalDistrict] = (0, $7UyaH.useState)("");
    const [mandalName, setMandalName] = (0, $7UyaH.useState)("");
    const [villageDistrict, setVillageDistrict] = (0, $7UyaH.useState)("");
    const [villageMandal, setVillageMandal] = (0, $7UyaH.useState)("");
    const [villageName, setVillageName] = (0, $7UyaH.useState)("");
    const [scopeType, setScopeType] = (0, $7UyaH.useState)(()=>{
        const d = z.districtKeys.length > 0;
        const m = z.mandalRefs.length > 0;
        const v = z.villageRefs.length > 0;
        if (d && !m && !v) return "district";
        if (!d && m && !v) return "mandal";
        if (!d && !m && v) return "village";
        if (!d && !m && !v) return "district";
        return "mixed";
    });
    (0, $7UyaH.useEffect)(()=>{
        if (!geoStore) return;
        const first = geoStore.tgRegistrationDistricts()[0]?.districtKey ?? "";
        setMandalDistrict((prev)=>prev || first);
        setVillageDistrict((prev)=>prev || first);
    }, [
        geoStore
    ]);
    const mandalsForPick = (0, $7UyaH.useMemo)(()=>geoStore ? geoStore.tgMandalsForDistrict(mandalDistrict) : [], [
        geoStore,
        mandalDistrict
    ]);
    const villagesForPick = (0, $7UyaH.useMemo)(()=>{
        if (!geoStore || !villageMandal.trim()) return [];
        return geoStore.tgVillagesForMandal(villageDistrict, villageMandal);
    }, [
        geoStore,
        villageDistrict,
        villageMandal
    ]);
    const districtPickOptions = (0, $7UyaH.useMemo)(()=>(0, $65d82a3223f822b8$export$ebb9edc449c9191c)(geoStore), [
        geoStore
    ]);
    const mandalPickOptions = (0, $7UyaH.useMemo)(()=>{
        const sorted = (0, $65d82a3223f822b8$export$92a1b4b7233300e5)(geoStore, mandalDistrict);
        return [
            {
                value: "",
                label: "\u2014 Choose mandal \u2014",
                rowKey: "none"
            },
            ...sorted
        ];
    }, [
        geoStore,
        mandalDistrict
    ]);
    const villageDistrictPickOptions = districtPickOptions;
    const villageMandalPickOptions = (0, $7UyaH.useMemo)(()=>{
        const sorted = (0, $65d82a3223f822b8$export$92a1b4b7233300e5)(geoStore, villageDistrict);
        return [
            {
                value: "",
                label: "\u2014 Choose mandal \u2014",
                rowKey: "none"
            },
            ...sorted
        ];
    }, [
        villageDistrict,
        geoStore
    ]);
    const villageNamePickOptions = (0, $7UyaH.useMemo)(()=>{
        const sorted = (0, $65d82a3223f822b8$export$b4f94b88b15ef2d1)(geoStore, villageDistrict, villageMandal);
        return [
            {
                value: "",
                label: "\u2014 Choose village \u2014",
                rowKey: "none"
            },
            ...sorted
        ];
    }, [
        villagesForPick,
        geoStore,
        villageDistrict,
        villageMandal
    ]);
    function toggleDistrict(key) {
        const has = z.districtKeys.includes(key);
        const districtKeys = has ? z.districtKeys.filter((k)=>k !== key) : [
            ...z.districtKeys,
            key
        ];
        updateGeoZone(z.id, {
            districtKeys: districtKeys
        });
    }
    function addMandal() {
        const mn = mandalName.trim();
        if (!mn) return;
        const ref = {
            district: mandalDistrict,
            mandalName: mn
        };
        const k = (0, $51c57f3e5aa6a385$export$727dcd1ed8aa5b17)(ref.district, ref.mandalName);
        if (z.mandalRefs.some((r)=>(0, $51c57f3e5aa6a385$export$727dcd1ed8aa5b17)(r.district, r.mandalName) === k)) return;
        updateGeoZone(z.id, {
            mandalRefs: [
                ...z.mandalRefs,
                ref
            ]
        });
        setMandalName("");
    }
    function removeMandal(ref) {
        updateGeoZone(z.id, {
            mandalRefs: z.mandalRefs.filter((r)=>(0, $51c57f3e5aa6a385$export$727dcd1ed8aa5b17)(r.district, r.mandalName) !== (0, $51c57f3e5aa6a385$export$727dcd1ed8aa5b17)(ref.district, ref.mandalName))
        });
    }
    function addVillage() {
        const mn = villageMandal.trim();
        const vn = villageName.trim();
        if (!mn || !vn) return;
        const ref = {
            district: villageDistrict,
            mandalName: mn,
            villageName: vn
        };
        const k = (0, $51c57f3e5aa6a385$export$19c0af9de87a0272)(ref.district, ref.mandalName, ref.villageName);
        if (z.villageRefs.some((r)=>(0, $51c57f3e5aa6a385$export$19c0af9de87a0272)(r.district, r.mandalName, r.villageName) === k)) return;
        updateGeoZone(z.id, {
            villageRefs: [
                ...z.villageRefs,
                ref
            ]
        });
        setVillageName("");
    }
    function removeVillage(ref) {
        updateGeoZone(z.id, {
            villageRefs: z.villageRefs.filter((r)=>(0, $51c57f3e5aa6a385$export$19c0af9de87a0272)(r.district, r.mandalName, r.villageName) !== (0, $51c57f3e5aa6a385$export$19c0af9de87a0272)(ref.district, ref.mandalName, ref.villageName))
        });
    }
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "milestone-master-modal-editor geo-zones-card",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "toolbar-row",
                style: {
                    justifyContent: "space-between",
                    alignItems: "flex-start"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("h2", {
                        className: "card__title card__title--gov",
                        style: {
                            margin: 0
                        },
                        children: [
                            "Zone ",
                            index + 1,
                            " of ",
                            total
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--tg-secondary btn--sm milestone-row__remove",
                        onClick: ()=>{
                            if (window.confirm(`Delete zone \u{201C}${z.name}\u{201D}?`)) (async ()=>{
                                const ok = await removeGeoZone(z.id);
                                if (ok) onDeleted?.();
                            })();
                        },
                        children: "Delete zone"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: `zone-name-${z.id}`,
                        children: "Zone name"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                        id: `zone-name-${z.id}`,
                        value: name,
                        onChange: (e)=>setName(e.target.value),
                        maxLength: 200
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: `zone-notes-${z.id}`,
                        children: "Notes"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                        id: `zone-notes-${z.id}`,
                        rows: 2,
                        value: notes,
                        onChange: (e)=>setNotes(e.target.value),
                        maxLength: 2000
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                type: "button",
                className: "btn btn--primary btn--tg btn--sm",
                onClick: ()=>void updateGeoZone(z.id, {
                        name: name,
                        notes: notes
                    }),
                children: "Save name & notes"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                className: "geo-zones-match text-muted section-lead section-lead--tight",
                style: {
                    marginTop: "1rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                        children: matchCount
                    }),
                    " applicant file",
                    matchCount === 1 ? "" : "s",
                    " in this console match this zone (by district / mandal / village rules below)."
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                className: "form-section-title",
                style: {
                    marginTop: "1.15rem"
                },
                children: "Coverage type"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "section-lead section-lead--tight text-muted",
                children: 'Choose one level to simplify the rules, or choose "Mixed" to combine multiple levels in a single zone.'
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "field",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                    value: scopeType,
                    onChange: (e)=>setScopeType(e.target.value),
                    className: "form-control",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                            value: "district",
                            children: "Entire districts"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                            value: "mandal",
                            children: "Specific mandals"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                            value: "village",
                            children: "Specific villages"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                            value: "mixed",
                            children: "Mixed (Advanced)"
                        })
                    ]
                })
            }),
            scopeType === "district" || scopeType === "mixed" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        style: {
                            marginTop: "1.15rem"
                        },
                        children: "Entire districts"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "section-lead section-lead--tight text-muted",
                        children: [
                            "Tick districts to include ",
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "all"
                            }),
                            " mandals and villages in the IGRS directory for that district."
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "geo-zones-district-grid",
                        children: districtPickOptions.map((d)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                className: "geo-zones-check",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                        type: "checkbox",
                                        checked: z.districtKeys.includes(d.value),
                                        onChange: ()=>toggleDistrict(d.value)
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        children: d.label
                                    })
                                ]
                            }, d.value))
                    })
                ]
            }) : null,
            scopeType === "mandal" || scopeType === "mixed" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        style: {
                            marginTop: "1.25rem"
                        },
                        children: "Specific mandals"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "section-lead section-lead--tight text-muted",
                        children: "Add mandals when only part of a district belongs to this zone (names from registration directory)."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "geo-zones-add-row",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field-inline",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: `zone-${z.id}-mandal-district`,
                                        children: "District"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                        id: `zone-${z.id}-mandal-district`,
                                        variant: "dash",
                                        value: mandalDistrict,
                                        onChange: (v)=>{
                                            if (v) {
                                                setMandalDistrict(v);
                                                setMandalName("");
                                            }
                                        },
                                        options: districtPickOptions,
                                        placeholder: "District"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field-inline",
                                style: {
                                    flex: "1 1 12rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: `zone-${z.id}-mandal-name`,
                                        children: "Mandal"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                        id: `zone-${z.id}-mandal-name`,
                                        variant: "dash",
                                        value: mandalName,
                                        onChange: setMandalName,
                                        options: mandalPickOptions,
                                        placeholder: "\u2014 Choose mandal \u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--tg-secondary btn--sm",
                                disabled: !mandalName.trim(),
                                onClick: addMandal,
                                children: "Add mandal"
                            })
                        ]
                    }),
                    z.mandalRefs.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                        className: "geo-zones-pill-list",
                        children: z.mandalRefs.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                className: "geo-zones-pill-row",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                children: $f8d7d882f697b938$var$districtLabel(geoStore, r.district)
                                            }),
                                            " \u2014 ",
                                            r.mandalName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--link btn--sm",
                                        onClick: ()=>removeMandal(r),
                                        children: "Remove"
                                    })
                                ]
                            }, (0, $51c57f3e5aa6a385$export$727dcd1ed8aa5b17)(r.district, r.mandalName)))
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted section-lead section-lead--tight",
                        children: "No mandal-level rows yet."
                    })
                ]
            }) : null,
            scopeType === "village" || scopeType === "mixed" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                        className: "form-section-title",
                        style: {
                            marginTop: "1.25rem"
                        },
                        children: "Specific villages"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "section-lead section-lead--tight text-muted",
                        children: "Add individual villages for the finest control."
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "geo-zones-add-row geo-zones-add-row--wrap",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field-inline",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: `zone-${z.id}-village-district`,
                                        children: "District"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                        id: `zone-${z.id}-village-district`,
                                        variant: "dash",
                                        value: villageDistrict,
                                        onChange: (v)=>{
                                            if (v) {
                                                setVillageDistrict(v);
                                                setVillageMandal("");
                                                setVillageName("");
                                            }
                                        },
                                        options: villageDistrictPickOptions,
                                        placeholder: "District"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field-inline",
                                style: {
                                    flex: "1 1 11rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: `zone-${z.id}-village-mandal`,
                                        children: "Mandal"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                        id: `zone-${z.id}-village-mandal`,
                                        variant: "dash",
                                        value: villageMandal,
                                        onChange: (v)=>{
                                            setVillageMandal(v);
                                            setVillageName("");
                                        },
                                        options: villageMandalPickOptions,
                                        placeholder: "\u2014 Choose mandal \u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "field field-inline",
                                style: {
                                    flex: "1 1 12rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                        htmlFor: `zone-${z.id}-village-name`,
                                        children: "Village"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $d5572ca9b91316d6$export$6037a18d4e29dfa9), {
                                        id: `zone-${z.id}-village-name`,
                                        variant: "dash",
                                        value: villageName,
                                        onChange: setVillageName,
                                        options: villageNamePickOptions,
                                        placeholder: "\u2014 Choose village \u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--tg-secondary btn--sm",
                                disabled: !villageMandal.trim() || !villageName.trim(),
                                onClick: addVillage,
                                children: "Add village"
                            })
                        ]
                    }),
                    z.villageRefs.length > 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                        className: "geo-zones-pill-list",
                        children: z.villageRefs.map((r)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                className: "geo-zones-pill-row",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                children: $f8d7d882f697b938$var$districtLabel(geoStore, r.district)
                                            }),
                                            " \u2014 ",
                                            r.mandalName,
                                            " \u2014 ",
                                            r.villageName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                        type: "button",
                                        className: "btn btn--link btn--sm",
                                        onClick: ()=>removeVillage(r),
                                        children: "Remove"
                                    })
                                ]
                            }, (0, $51c57f3e5aa6a385$export$19c0af9de87a0272)(r.district, r.mandalName, r.villageName)))
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted section-lead section-lead--tight",
                        children: "No village-level rows yet."
                    })
                ]
            }) : null
        ]
    });
}
function $f8d7d882f697b938$var$CategorySummaryCard({ category: category, index: index, isActive: isActive, onOpen: onOpen }) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("button", {
        type: "button",
        className: `milestone-master-picker-card${isActive ? " milestone-master-picker-card--active" : ""}`,
        onClick: onOpen,
        "aria-haspopup": "dialog",
        "aria-expanded": isActive,
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "milestone-master-picker-card__content",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__top",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                            className: "milestone-master-picker-card__phase-badge",
                            children: [
                                "Category ",
                                index + 1
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__title",
                        children: category.name
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__stats",
                        "aria-label": "Notes",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                            children: category.notes.trim() ? "Has notes" : "No notes"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                className: "milestone-master-picker-card__footer",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                    children: isActive ? "Editor open" : "Click card to edit"
                })
            })
        ]
    });
}
function $f8d7d882f697b938$var$CategoryEditorCard({ category: category, index: index, total: total, onDeleted: onDeleted, onReload: onReload }) {
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const [name, setName] = (0, $7UyaH.useState)(category.name);
    const [notes, setNotes] = (0, $7UyaH.useState)(category.notes);
    const [saving, setSaving] = (0, $7UyaH.useState)(false);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "milestone-master-modal-editor geo-zones-card",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "toolbar-row",
                style: {
                    justifyContent: "space-between",
                    alignItems: "flex-start"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("h2", {
                        className: "card__title card__title--gov",
                        style: {
                            margin: 0
                        },
                        children: [
                            "Category ",
                            index + 1,
                            " of ",
                            total
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--tg-secondary btn--sm milestone-row__remove",
                        onClick: ()=>{
                            if (window.confirm(`Delete category \u{201C}${category.name}\u{201D}? All zone groups using this category will be removed.`)) (async ()=>{
                                try {
                                    await (0, $7547c9f6666296ea$export$51bce094702d1e09)(category.id);
                                    await onReload();
                                    showToast("Category deleted.", "success");
                                    onDeleted?.();
                                } catch (e) {
                                    showToast(e instanceof Error ? e.message : "Could not delete category.", "error");
                                }
                            })();
                        },
                        children: "Delete category"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: `cat-name-${category.id}`,
                        children: "Category name"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                        id: `cat-name-${category.id}`,
                        value: name,
                        onChange: (e)=>setName(e.target.value),
                        maxLength: 200
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        htmlFor: `cat-notes-${category.id}`,
                        children: "Notes"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                        id: `cat-notes-${category.id}`,
                        rows: 2,
                        value: notes,
                        onChange: (e)=>setNotes(e.target.value),
                        maxLength: 2000
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                type: "button",
                className: "btn btn--primary btn--tg btn--sm",
                disabled: saving || !name.trim(),
                onClick: ()=>{
                    (async ()=>{
                        setSaving(true);
                        try {
                            await (0, $7547c9f6666296ea$export$ffbd683d491c4113)(category.id, {
                                name: name.trim(),
                                notes: notes.trim()
                            });
                            await onReload();
                            showToast("Category updated.", "success");
                        } catch (e) {
                            showToast(e instanceof Error ? e.message : "Update failed.", "error");
                        } finally{
                            setSaving(false);
                        }
                    })();
                },
                children: saving ? "Saving..." : "Save category"
            })
        ]
    });
}
function $f8d7d882f697b938$var$GroupSummaryCard({ group: group, index: index, isActive: isActive, onOpen: onOpen, geoZonesSorted: geoZonesSorted, categories: categories }) {
    const zName = $f8d7d882f697b938$var$zoneNameById(geoZonesSorted, group.zoneId);
    const cName = (0, $6b3c5d00366b6c37$export$f8e446e009510294)(categories, group.categoryId);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("button", {
        type: "button",
        className: `milestone-master-picker-card${isActive ? " milestone-master-picker-card--active" : ""}`,
        onClick: onOpen,
        "aria-haspopup": "dialog",
        "aria-expanded": isActive,
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "milestone-master-picker-card__content",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__top",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                            className: "milestone-master-picker-card__phase-badge",
                            children: [
                                "Group ",
                                index + 1
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "milestone-master-picker-card__title",
                        children: group.name
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                        className: "milestone-master-picker-card__stats",
                        "aria-label": "Zone and Category",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                children: zName
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "milestone-master-picker-card__stat-dot",
                                "aria-hidden": true,
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                children: cName || "No Category"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                className: "milestone-master-picker-card__footer",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                    children: isActive ? "Editor open" : "Click card to edit"
                })
            })
        ]
    });
}
function $f8d7d882f697b938$var$GroupEditorCard({ group: group, index: index, total: total, geoZonesSorted: geoZonesSorted, categories: categories, onDeleted: onDeleted, onReload: onReload }) {
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const [name, setName] = (0, $7UyaH.useState)(group.name);
    const [notes, setNotes] = (0, $7UyaH.useState)(group.notes);
    const [zoneId, setZoneId] = (0, $7UyaH.useState)(group.zoneId);
    const [categoryId, setCategoryId] = (0, $7UyaH.useState)(group.categoryId);
    const [saving, setSaving] = (0, $7UyaH.useState)(false);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "milestone-master-modal-editor geo-zones-card",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "toolbar-row",
                style: {
                    justifyContent: "space-between",
                    alignItems: "flex-start"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("h2", {
                        className: "card__title card__title--gov",
                        style: {
                            margin: 0
                        },
                        children: [
                            "Group ",
                            index + 1,
                            " of ",
                            total
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--tg-secondary btn--sm milestone-row__remove",
                        onClick: ()=>{
                            if (window.confirm(`Delete group \u{201C}${group.name}\u{201D}?`)) (async ()=>{
                                try {
                                    await (0, $7547c9f6666296ea$export$8e02f10db65faff9)(group.id);
                                    await onReload();
                                    showToast("Group deleted.", "success");
                                    onDeleted?.();
                                } catch (e) {
                                    showToast(e instanceof Error ? e.message : "Could not delete group.", "error");
                                }
                            })();
                        },
                        children: "Delete group"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        children: "Zone"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("select", {
                        className: "form-control",
                        value: zoneId,
                        onChange: (e)=>setZoneId(e.target.value),
                        children: geoZonesSorted.map((z)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                value: z.id,
                                children: z.name
                            }, z.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        children: "Category"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("select", {
                        className: "form-control",
                        value: categoryId,
                        onChange: (e)=>setCategoryId(e.target.value),
                        children: categories.map((c)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                value: c.id,
                                children: c.name
                            }, c.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        children: "Group name"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                        className: "form-control",
                        value: name,
                        onChange: (e)=>setName(e.target.value),
                        maxLength: 200
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "field",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                        children: "Notes"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                        className: "form-control",
                        rows: 2,
                        value: notes,
                        onChange: (e)=>setNotes(e.target.value),
                        maxLength: 2000
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                type: "button",
                className: "btn btn--primary btn--tg btn--sm",
                disabled: saving || !name.trim() || !zoneId || !categoryId,
                onClick: ()=>{
                    (async ()=>{
                        setSaving(true);
                        try {
                            await (0, $7547c9f6666296ea$export$40748f54f7e4bafb)(group.id, {
                                name: name.trim(),
                                notes: notes.trim(),
                                zoneId: zoneId,
                                categoryId: categoryId
                            });
                            await onReload();
                            showToast("Group updated.", "success");
                        } catch (e) {
                            showToast(e instanceof Error ? e.message : "Update failed.", "error");
                        } finally{
                            setSaving(false);
                        }
                    })();
                },
                children: saving ? "Saving..." : "Save group"
            })
        ]
    });
}
function $f8d7d882f697b938$export$b9246bfe63eb410f() {
    const { geoZones: geoZones, addGeoZone: addGeoZone } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const sortedZones = (0, $7UyaH.useMemo)(()=>[
            ...geoZones
        ].sort((a, b)=>a.sortOrder - b.sortOrder), [
        geoZones
    ]);
    const [activeTab, setActiveTab] = (0, $7UyaH.useState)("zones");
    // Zone State
    const [createName, setCreateName] = (0, $7UyaH.useState)("");
    const [createNotes, setCreateNotes] = (0, $7UyaH.useState)("");
    const [createModalOpen, setCreateModalOpen] = (0, $7UyaH.useState)(false);
    const [editModalZoneId, setEditModalZoneId] = (0, $7UyaH.useState)(null);
    // Category State
    const [catName, setCatName] = (0, $7UyaH.useState)("");
    const [catNotes, setCatNotes] = (0, $7UyaH.useState)("");
    const [createCatModalOpen, setCreateCatModalOpen] = (0, $7UyaH.useState)(false);
    const [editModalCatId, setEditModalCatId] = (0, $7UyaH.useState)(null);
    // Group State
    const [groupName, setGroupName] = (0, $7UyaH.useState)("");
    const [groupNotes, setGroupNotes] = (0, $7UyaH.useState)("");
    const [groupZoneId, setGroupZoneId] = (0, $7UyaH.useState)("");
    const [groupCatId, setGroupCatId] = (0, $7UyaH.useState)("");
    const [createGroupModalOpen, setCreateGroupModalOpen] = (0, $7UyaH.useState)(false);
    const [editModalGroupId, setEditModalGroupId] = (0, $7UyaH.useState)(null);
    const [categories, setCategories] = (0, $7UyaH.useState)([]);
    const [zoneGroupsAll, setZoneGroupsAll] = (0, $7UyaH.useState)([]);
    const [zoneGroupsMysqlReady, setZoneGroupsMysqlReady] = (0, $7UyaH.useState)(false);
    const { showToast: showToast } = (0, $62ce12c72c1ea784$export$a407b657d3044108)();
    const sortedGroups = (0, $7UyaH.useMemo)(()=>[
            ...zoneGroupsAll
        ].sort((a, b)=>{
            const za = $f8d7d882f697b938$var$zoneNameById(sortedZones, a.zoneId).localeCompare($f8d7d882f697b938$var$zoneNameById(sortedZones, b.zoneId));
            if (za !== 0) return za;
            return a.name.localeCompare(b.name);
        }), [
        zoneGroupsAll,
        sortedZones
    ]);
    const editModalZone = (0, $7UyaH.useMemo)(()=>sortedZones.find((x)=>x.id === editModalZoneId), [
        editModalZoneId,
        sortedZones
    ]);
    const editModalIndex = editModalZone ? sortedZones.findIndex((z)=>z.id === editModalZone.id) : -1;
    const editModalCat = (0, $7UyaH.useMemo)(()=>categories.find((x)=>x.id === editModalCatId), [
        editModalCatId,
        categories
    ]);
    const editModalCatIndex = editModalCat ? categories.findIndex((z)=>z.id === editModalCat.id) : -1;
    const editModalGroup = (0, $7UyaH.useMemo)(()=>sortedGroups.find((x)=>x.id === editModalGroupId), [
        editModalGroupId,
        sortedGroups
    ]);
    const editModalGroupIndex = editModalGroup ? sortedGroups.findIndex((z)=>z.id === editModalGroup.id) : -1;
    const closeCreateModal = (0, $7UyaH.useCallback)(()=>{
        setCreateModalOpen(false);
        setCreateName("");
        setCreateNotes("");
        setCreateCatModalOpen(false);
        setCatName("");
        setCatNotes("");
        setCreateGroupModalOpen(false);
        setGroupName("");
        setGroupNotes("");
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        const onKey = (e)=>{
            if (e.key === "Escape") {
                closeCreateModal();
                setEditModalZoneId(null);
                setEditModalCatId(null);
                setEditModalGroupId(null);
            }
        };
        window.addEventListener("keydown", onKey);
        return ()=>window.removeEventListener("keydown", onKey);
    }, [
        closeCreateModal
    ]);
    const openCreateModal = ()=>{
        closeCreateModal();
        setEditModalZoneId(null);
        setEditModalCatId(null);
        setEditModalGroupId(null);
        if (activeTab === "zones") setCreateModalOpen(true);
        if (activeTab === "categories") setCreateCatModalOpen(true);
        if (activeTab === "groups") {
            setGroupZoneId(sortedZones[0]?.id || "");
            setGroupCatId(categories[0]?.id || "");
            setCreateGroupModalOpen(true);
        }
    };
    const openEditModal = (type, id)=>{
        closeCreateModal();
        setEditModalZoneId(type === "zone" && editModalZoneId !== id ? id : null);
        setEditModalCatId(type === "category" && editModalCatId !== id ? id : null);
        setEditModalGroupId(type === "group" && editModalGroupId !== id ? id : null);
    };
    const reloadZoneGroupSetup = (0, $7UyaH.useCallback)(async ()=>{
        try {
            const [cats, grps] = await Promise.all([
                (0, $7547c9f6666296ea$export$c8f5b98b4b31b522)(),
                (0, $7547c9f6666296ea$export$f8043e5beffc2a9a)()
            ]);
            setCategories(cats);
            setZoneGroupsAll(grps);
            setZoneGroupsMysqlReady(true);
        } catch (e) {
            const msg = e instanceof Error ? e.message : String(e);
            setZoneGroupsMysqlReady(false);
            setCategories([]);
            setZoneGroupsAll([]);
            if (!/MySQL|503|not configured|MariaDB/i.test(msg)) console.warn("[zones] zone group setup:", msg);
        }
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        reloadZoneGroupSetup();
    }, [
        reloadZoneGroupSetup
    ]);
    const tabBtn = (id, label)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
            type: "button",
            role: "tab",
            "aria-selected": activeTab === id,
            className: `zones-page-tab ${activeTab === id ? "zones-page-tab--active" : ""}`,
            onClick: ()=>setActiveTab(id),
            children: label
        }, id);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Zones"
                    }
                ],
                title: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem"
                    },
                    children: [
                        "Zones master",
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                            className: "milestone-master__catalog-count",
                            children: activeTab === "zones" ? sortedZones.length : activeTab === "categories" ? categories.length : sortedGroups.length
                        })
                    ]
                }),
                actions: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                    type: "button",
                    className: "btn btn--primary btn--tg btn--sm",
                    onClick: openCreateModal,
                    children: activeTab === "zones" ? "Add zone" : activeTab === "categories" ? "Add category" : "Add group"
                })
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "zones-page-shell",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "zones-page-tabs-row",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "zones-page-tabs-wrap",
                            role: "tablist",
                            "aria-label": "Zones setup steps",
                            children: [
                                tabBtn("zones", "Zone"),
                                tabBtn("categories", "Category"),
                                tabBtn("groups", "Group")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "zones-page-panel",
                        children: [
                            activeTab === "zones" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("section", {
                                        className: "milestone-master__catalog",
                                        style: {
                                            marginTop: "1.75rem"
                                        },
                                        children: sortedZones.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "milestone-master__empty",
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                    className: "milestone-master__empty-title",
                                                    children: "No zones yet"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                    className: "milestone-master__empty-desc",
                                                    children: [
                                                        "Create your first zone with ",
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                            children: "Add zone"
                                                        }),
                                                        " to define geography."
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                            className: "milestone-master-picker-grid",
                                            children: sortedZones.map((z, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($f8d7d882f697b938$var$ZoneSummaryCard, {
                                                    zone: z,
                                                    zoneIndex: i,
                                                    isActive: editModalZoneId === z.id,
                                                    onOpen: ()=>openEditModal("zone", z.id)
                                                }, z.id))
                                        })
                                    }),
                                    createModalOpen ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "modal-backdrop",
                                        role: "presentation",
                                        onClick: closeCreateModal,
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "modal milestone-master-modal",
                                            role: "dialog",
                                            "aria-modal": "true",
                                            onClick: (e)=>e.stopPropagation(),
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                    className: "milestone-master-modal__header",
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                                            className: "milestone-master-modal__title",
                                                            children: "Add zone"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "btn btn--tg-secondary btn--sm",
                                                            onClick: closeCreateModal,
                                                            children: "Close"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                    className: "milestone-master-modal__body",
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                            className: "field",
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                                    htmlFor: "new-zone-name",
                                                                    children: "Zone name"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                    id: "new-zone-name",
                                                                    value: createName,
                                                                    onChange: (e)=>setCreateName(e.target.value),
                                                                    placeholder: "e.g. North Telangana cluster",
                                                                    maxLength: 200
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                            className: "field",
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                                    htmlFor: "new-zone-notes",
                                                                    children: "Notes (optional)"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                                                    id: "new-zone-notes",
                                                                    rows: 2,
                                                                    value: createNotes,
                                                                    onChange: (e)=>setCreateNotes(e.target.value),
                                                                    maxLength: 2000
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                            className: "toolbar-row",
                                                            style: {
                                                                gap: "0.5rem",
                                                                marginTop: "0.75rem"
                                                            },
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "btn btn--primary btn--tg",
                                                                disabled: !createName.trim(),
                                                                onClick: ()=>{
                                                                    (async ()=>{
                                                                        const id = await addGeoZone({
                                                                            name: createName.trim(),
                                                                            notes: createNotes.trim()
                                                                        });
                                                                        if (!id) return;
                                                                        closeCreateModal();
                                                                    })();
                                                                },
                                                                children: "Create zone"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }) : null,
                                    editModalZone && editModalIndex >= 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "modal-backdrop",
                                        role: "presentation",
                                        onClick: ()=>setEditModalZoneId(null),
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "modal milestone-master-modal",
                                            style: {
                                                maxWidth: "48rem"
                                            },
                                            role: "dialog",
                                            "aria-modal": "true",
                                            onClick: (e)=>e.stopPropagation(),
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                    className: "milestone-master-modal__header",
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                                            className: "milestone-master-modal__title",
                                                            children: "Edit zone"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "btn btn--tg-secondary btn--sm",
                                                            onClick: ()=>setEditModalZoneId(null),
                                                            children: "Close"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                    className: "milestone-master-modal__body",
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($f8d7d882f697b938$var$ZoneEditorCard, {
                                                        zone: editModalZone,
                                                        index: editModalIndex,
                                                        total: sortedZones.length,
                                                        onDeleted: ()=>setEditModalZoneId(null)
                                                    }, editModalZone.id)
                                                })
                                            ]
                                        })
                                    }) : null
                                ]
                            }) : null,
                            activeTab === "categories" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("section", {
                                        className: "milestone-master__catalog",
                                        style: {
                                            marginTop: "1.75rem"
                                        },
                                        children: !zoneGroupsMysqlReady ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                            className: "milestone-master__empty",
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                children: "MySQL is not configured."
                                            })
                                        }) : categories.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "milestone-master__empty",
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                    className: "milestone-master__empty-title",
                                                    children: "No categories yet"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                    className: "milestone-master__empty-desc",
                                                    children: [
                                                        "Create your first category with ",
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                            children: "Add category"
                                                        }),
                                                        "."
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                            className: "milestone-master-picker-grid",
                                            children: categories.map((c, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($f8d7d882f697b938$var$CategorySummaryCard, {
                                                    category: c,
                                                    index: i,
                                                    isActive: editModalCatId === c.id,
                                                    onOpen: ()=>openEditModal("category", c.id)
                                                }, c.id))
                                        })
                                    }),
                                    createCatModalOpen ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "modal-backdrop",
                                        role: "presentation",
                                        onClick: closeCreateModal,
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "modal milestone-master-modal",
                                            role: "dialog",
                                            "aria-modal": "true",
                                            onClick: (e)=>e.stopPropagation(),
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                    className: "milestone-master-modal__header",
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                                            className: "milestone-master-modal__title",
                                                            children: "Add category"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "btn btn--tg-secondary btn--sm",
                                                            onClick: closeCreateModal,
                                                            children: "Close"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                    className: "milestone-master-modal__body",
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                            className: "field",
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                                    children: "Category name"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                    className: "form-control",
                                                                    value: catName,
                                                                    onChange: (e)=>setCatName(e.target.value),
                                                                    maxLength: 200
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                            className: "field",
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                                    children: "Notes (optional)"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                                                    className: "form-control",
                                                                    rows: 2,
                                                                    value: catNotes,
                                                                    onChange: (e)=>setCatNotes(e.target.value),
                                                                    maxLength: 2000
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                            className: "toolbar-row",
                                                            style: {
                                                                gap: "0.5rem",
                                                                marginTop: "0.75rem"
                                                            },
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "btn btn--primary btn--tg",
                                                                disabled: !catName.trim(),
                                                                onClick: ()=>{
                                                                    (async ()=>{
                                                                        try {
                                                                            await (0, $7547c9f6666296ea$export$1750e50fa4d0b6bc)({
                                                                                name: catName.trim(),
                                                                                notes: catNotes.trim()
                                                                            });
                                                                            await reloadZoneGroupSetup();
                                                                            showToast("Category created.", "success");
                                                                            closeCreateModal();
                                                                        } catch (e) {
                                                                            showToast(e instanceof Error ? e.message : "Creation failed.", "error");
                                                                        }
                                                                    })();
                                                                },
                                                                children: "Create category"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }) : null,
                                    editModalCat && editModalCatIndex >= 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "modal-backdrop",
                                        role: "presentation",
                                        onClick: ()=>setEditModalCatId(null),
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "modal milestone-master-modal",
                                            style: {
                                                maxWidth: "32rem"
                                            },
                                            role: "dialog",
                                            "aria-modal": "true",
                                            onClick: (e)=>e.stopPropagation(),
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                    className: "milestone-master-modal__header",
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                                            className: "milestone-master-modal__title",
                                                            children: "Edit category"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "btn btn--tg-secondary btn--sm",
                                                            onClick: ()=>setEditModalCatId(null),
                                                            children: "Close"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                    className: "milestone-master-modal__body",
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($f8d7d882f697b938$var$CategoryEditorCard, {
                                                        category: editModalCat,
                                                        index: editModalCatIndex,
                                                        total: categories.length,
                                                        onDeleted: ()=>setEditModalCatId(null),
                                                        onReload: reloadZoneGroupSetup
                                                    }, editModalCat.id)
                                                })
                                            ]
                                        })
                                    }) : null
                                ]
                            }) : null,
                            activeTab === "groups" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("section", {
                                        className: "milestone-master__catalog",
                                        style: {
                                            marginTop: "1.75rem"
                                        },
                                        children: !zoneGroupsMysqlReady ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                            className: "milestone-master__empty",
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                children: "MySQL is not configured."
                                            })
                                        }) : sortedGroups.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "milestone-master__empty",
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                    className: "milestone-master__empty-title",
                                                    children: "No groups yet"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                    className: "milestone-master__empty-desc",
                                                    children: [
                                                        "Create your first group with ",
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                            children: "Add group"
                                                        }),
                                                        "."
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                            className: "milestone-master-picker-grid",
                                            children: sortedGroups.map((g, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($f8d7d882f697b938$var$GroupSummaryCard, {
                                                    group: g,
                                                    index: i,
                                                    isActive: editModalGroupId === g.id,
                                                    onOpen: ()=>openEditModal("group", g.id),
                                                    geoZonesSorted: sortedZones,
                                                    categories: categories
                                                }, g.id))
                                        })
                                    }),
                                    createGroupModalOpen ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "modal-backdrop",
                                        role: "presentation",
                                        onClick: closeCreateModal,
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "modal milestone-master-modal",
                                            role: "dialog",
                                            "aria-modal": "true",
                                            onClick: (e)=>e.stopPropagation(),
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                    className: "milestone-master-modal__header",
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                                            className: "milestone-master-modal__title",
                                                            children: "Add group"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "btn btn--tg-secondary btn--sm",
                                                            onClick: closeCreateModal,
                                                            children: "Close"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                    className: "milestone-master-modal__body",
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                            className: "field",
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                                    children: "Zone"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("select", {
                                                                    className: "form-control",
                                                                    value: groupZoneId,
                                                                    onChange: (e)=>setGroupZoneId(e.target.value),
                                                                    children: sortedZones.map((z)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                                            value: z.id,
                                                                            children: z.name
                                                                        }, z.id))
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                            className: "field",
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                                    children: "Category"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("select", {
                                                                    className: "form-control",
                                                                    value: groupCatId,
                                                                    onChange: (e)=>setGroupCatId(e.target.value),
                                                                    children: categories.map((c)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                                            value: c.id,
                                                                            children: c.name
                                                                        }, c.id))
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                            className: "field",
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                                    children: "Group name"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                    className: "form-control",
                                                                    value: groupName,
                                                                    onChange: (e)=>setGroupName(e.target.value),
                                                                    maxLength: 200
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                            className: "field",
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                                    children: "Notes (optional)"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                                                    className: "form-control",
                                                                    rows: 2,
                                                                    value: groupNotes,
                                                                    onChange: (e)=>setGroupNotes(e.target.value),
                                                                    maxLength: 2000
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                            className: "toolbar-row",
                                                            style: {
                                                                gap: "0.5rem",
                                                                marginTop: "0.75rem"
                                                            },
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "btn btn--primary btn--tg",
                                                                disabled: !groupName.trim() || !groupZoneId || !groupCatId,
                                                                onClick: ()=>{
                                                                    (async ()=>{
                                                                        try {
                                                                            await (0, $7547c9f6666296ea$export$4ef5c9935f0e92d)({
                                                                                name: groupName.trim(),
                                                                                notes: groupNotes.trim(),
                                                                                zoneId: groupZoneId,
                                                                                categoryId: groupCatId
                                                                            });
                                                                            await reloadZoneGroupSetup();
                                                                            showToast("Group created.", "success");
                                                                            closeCreateModal();
                                                                        } catch (e) {
                                                                            showToast(e instanceof Error ? e.message : "Creation failed.", "error");
                                                                        }
                                                                    })();
                                                                },
                                                                children: "Create group"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }) : null,
                                    editModalGroup && editModalGroupIndex >= 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "modal-backdrop",
                                        role: "presentation",
                                        onClick: ()=>setEditModalGroupId(null),
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "modal milestone-master-modal",
                                            style: {
                                                maxWidth: "32rem"
                                            },
                                            role: "dialog",
                                            "aria-modal": "true",
                                            onClick: (e)=>e.stopPropagation(),
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                    className: "milestone-master-modal__header",
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                                            className: "milestone-master-modal__title",
                                                            children: "Edit group"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "btn btn--tg-secondary btn--sm",
                                                            onClick: ()=>setEditModalGroupId(null),
                                                            children: "Close"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                    className: "milestone-master-modal__body",
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($f8d7d882f697b938$var$GroupEditorCard, {
                                                        group: editModalGroup,
                                                        index: editModalGroupIndex,
                                                        total: sortedGroups.length,
                                                        onDeleted: ()=>setEditModalGroupId(null),
                                                        onReload: reloadZoneGroupSetup,
                                                        geoZonesSorted: sortedZones,
                                                        categories: categories
                                                    }, editModalGroup.id)
                                                })
                                            ]
                                        })
                                    }) : null
                                ]
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");





function $744e572ad2352a6c$var$norm(s) {
    return (0, $aa684f3df92b98e8$export$61bc427a5262ca9c)(s ?? "");
}
function $744e572ad2352a6c$var$buildTree(districts, leads, apps) {
    return districts.map((d)=>({
            id: d.districtKey,
            name: d.registrationDistrictName,
            mandals: d.mandals.map((m)=>({
                    id: `${d.districtKey}__${m.mandalName}`,
                    name: m.mandalName,
                    villages: m.villages.map((v)=>{
                        const vn = $744e572ad2352a6c$var$norm(v.name);
                        const mn = $744e572ad2352a6c$var$norm(m.mandalName);
                        const dk = d.districtKey.toLowerCase();
                        const here = apps.filter((a)=>$744e572ad2352a6c$var$norm(a.village) === vn && $744e572ad2352a6c$var$norm(a.mandal) === mn && String(a.district).toLowerCase() === dk);
                        return {
                            id: `${d.districtKey}__${m.mandalName}__${v.name}`,
                            name: v.name,
                            counts: {
                                leads: leads.filter((l)=>$744e572ad2352a6c$var$norm(l.village) === vn && $744e572ad2352a6c$var$norm(l.mandal) === mn && (l.district ?? "").toLowerCase().replace(/\s+/g, "_") === dk).length,
                                applicants: here.length,
                                beneficiaries: here.filter((a)=>a.status === "subcontractor_linked").length
                            }
                        };
                    })
                }))
        }));
}
function $744e572ad2352a6c$var$sumCounts(items) {
    return items.reduce((a, x)=>({
            leads: a.leads + x.counts.leads,
            applicants: a.applicants + x.counts.applicants,
            beneficiaries: a.beneficiaries + x.counts.beneficiaries
        }), {
        leads: 0,
        applicants: 0,
        beneficiaries: 0
    });
}
// ─── CSS (ONLY for the org-chart connector lines) ─────────────────────────────
const $744e572ad2352a6c$var$CONNECTOR_CSS = `
/* row that holds all sibling nodes */
.oct-row {
  display: inline-flex;
  align-items: flex-start;
}

/* wrapper for each node inside a row */
.oct-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 12px;
}

/*
  Connector bar above each node.
  Negative margin extends it into the gap between columns so
  adjacent border-tops meet seamlessly.
*/
.oct-conn {
  display: flex;
  align-items: stretch;       /* lets oct-vl fill full height */
  height: 30px;
  width: calc(100% + 24px);   /* 24px = 2 \xd7 12px column padding */
  margin: 0 -12px;
}

/* left half of horizontal bar */
.oct-hl { flex: 1; border-top: 2px solid #475569; }

/* vertical drop from the bar down to the node */
.oct-vl { width: 2px; background: #475569; flex-shrink: 0; }

/* right half of horizontal bar */
.oct-hr { flex: 1; border-top: 2px solid #475569; }

/* first child: no left bar */
.oct-col:first-child .oct-hl { border-top: none; }

/* last child: no right bar */
.oct-col:last-child  .oct-hr { border-top: none; }

/* single child: no bars at all, just the vertical drop */
.oct-col:only-child  .oct-hl,
.oct-col:only-child  .oct-hr { border-top: none; }

/* short stem going DOWN from a parent node before the children row */
.oct-stem {
  width: 2px;
  height: 28px;
  background: #475569;
  margin: 0 auto;
  display: block;
}
`;
const $744e572ad2352a6c$var$LEVEL_STYLE = {
    state: {
        border: "#1e3a5f",
        bg: "#1e3a5f",
        activeBg: "#1e3a5f",
        nameColor: "#fff",
        iconBg: "#2e4f7f"
    },
    district: {
        border: "#2563eb",
        bg: "#ffffff",
        activeBg: "#dbeafe",
        nameColor: "#1e3a8a",
        iconBg: "#eff6ff"
    },
    mandal: {
        border: "#7c3aed",
        bg: "#ffffff",
        activeBg: "#ede9fe",
        nameColor: "#4c1d95",
        iconBg: "#f5f3ff"
    },
    village: {
        border: "#16a34a",
        bg: "#f0fdf4",
        activeBg: "#dcfce7",
        nameColor: "#14532d",
        iconBg: "#dcfce7"
    }
};
function $744e572ad2352a6c$var$NodeBox({ name: name, icon: icon, sub: sub, counts: counts, level: level, active: active, onClick: onClick }) {
    const ls = $744e572ad2352a6c$var$LEVEL_STYLE[level];
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        onClick: onClick,
        role: onClick ? "button" : undefined,
        tabIndex: onClick ? 0 : undefined,
        onKeyDown: onClick ? (e)=>e.key === "Enter" && onClick() : undefined,
        style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 5,
            padding: "10px 12px",
            border: `2px solid ${ls.border}`,
            borderRadius: 10,
            background: active ? ls.activeBg : ls.bg,
            cursor: onClick ? "pointer" : "default",
            minWidth: level === "state" ? 140 : 110,
            maxWidth: 160,
            textAlign: "center",
            boxShadow: active ? `0 0 0 3px ${ls.border}44, 0 4px 12px rgba(0,0,0,.12)` : "0 1px 4px rgba(0,0,0,.08)",
            userSelect: "none",
            transition: "background .15s, box-shadow .15s",
            position: "relative"
        },
        children: [
            active && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                style: {
                    position: "absolute",
                    top: -8,
                    right: -8,
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    background: ls.border,
                    border: "2px solid #fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 9,
                    color: "#fff",
                    fontWeight: 900
                },
                children: "\u2713"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                style: {
                    width: 34,
                    height: 34,
                    borderRadius: 8,
                    background: ls.iconBg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: level === "state" ? "1.3rem" : "1.1rem",
                    border: level === "state" ? "1px solid #2e4f7f" : `1px solid ${ls.border}44`
                },
                children: icon
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                style: {
                    fontSize: level === "state" ? "0.875rem" : "0.78rem",
                    fontWeight: 700,
                    color: ls.nameColor,
                    lineHeight: 1.3,
                    wordBreak: "break-word"
                },
                children: name
            }),
            sub && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                style: {
                    fontSize: "0.68rem",
                    color: "#94a3b8",
                    marginTop: -2
                },
                children: sub
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                    width: "100%",
                    marginTop: 2
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($744e572ad2352a6c$var$CountRow, {
                        label: "Leads",
                        value: counts.leads,
                        color: "#1d4ed8"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($744e572ad2352a6c$var$CountRow, {
                        label: "Applicants",
                        value: counts.applicants,
                        color: "#6d28d9"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($744e572ad2352a6c$var$CountRow, {
                        label: "Beneficiaries",
                        value: counts.beneficiaries,
                        color: "#15803d"
                    })
                ]
            })
        ]
    });
}
function $744e572ad2352a6c$var$CountRow({ label: label, value: value, color: color }) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "2px 7px",
            borderRadius: 5,
            background: color,
            fontSize: "0.68rem",
            fontWeight: 600,
            color: "#fff"
        },
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                children: label
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                style: {
                    fontWeight: 800
                },
                children: value
            })
        ]
    });
}
// ─── org-chart row with connector lines ───────────────────────────────────────
function $744e572ad2352a6c$var$OrgRow({ items: items, selectedId: selectedId, renderNode: renderNode }) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
        className: "oct-row",
        children: items.map((item)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "oct-col",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "oct-conn",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "oct-hl"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "oct-vl"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "oct-hr"
                            })
                        ]
                    }),
                    renderNode(item, item.id === selectedId)
                ]
            }, item.id))
    });
}
function $744e572ad2352a6c$export$f41897b6ceff8290() {
    const { store: store, loading: geoLoading } = (0, $60dd8507bac67e50$export$5ec0231075ddedf1)();
    const { applications: applications } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const [leads, setLeads] = (0, $7UyaH.useState)([]);
    const [leadsLoading, setLoading] = (0, $7UyaH.useState)(true);
    const [selDistrict, setSelDist] = (0, $7UyaH.useState)(null);
    const [selMandal, setSelMandal] = (0, $7UyaH.useState)(null);
    const [search, setSearch] = (0, $7UyaH.useState)("");
    const [addLeadTarget, setAddLeadTarget] = (0, $7UyaH.useState)(null);
    function reloadLeads() {
        (0, $4e56623d4da7ea32$export$c20290562992eebc)().then(setLeads).catch(()=>setLeads([]));
    }
    (0, $7UyaH.useEffect)(()=>{
        (0, $4e56623d4da7ea32$export$c20290562992eebc)().then(setLeads).catch(()=>setLeads([])).finally(()=>setLoading(false));
    }, []);
    const allDistricts = (0, $7UyaH.useMemo)(()=>store ? store.tgRegistrationDistricts() : [], [
        store
    ]);
    const tree = (0, $7UyaH.useMemo)(()=>$744e572ad2352a6c$var$buildTree(allDistricts, leads, applications), [
        allDistricts,
        leads,
        applications
    ]);
    const visibleTree = (0, $7UyaH.useMemo)(()=>{
        const q = search.trim().toLowerCase();
        if (!q) return tree;
        const result = [];
        for (const d of tree){
            // district name matches → include whole district
            if (d.name.toLowerCase().includes(q)) {
                result.push(d);
                continue;
            }
            // check mandals
            const matchedMandals = [];
            for (const m of d.mandals)if (m.name.toLowerCase().includes(q)) // mandal name matches → include whole mandal
            matchedMandals.push(m);
            else {
                // check villages inside this mandal
                const matchedVillages = m.villages.filter((v)=>v.name.toLowerCase().includes(q));
                if (matchedVillages.length > 0) matchedMandals.push({
                    ...m,
                    villages: matchedVillages
                });
            }
            if (matchedMandals.length > 0) result.push({
                ...d,
                mandals: matchedMandals
            });
        }
        return result;
    }, [
        tree,
        search
    ]);
    const stateCounts = (0, $7UyaH.useMemo)(()=>({
            leads: leads.length,
            applicants: applications.length,
            beneficiaries: applications.filter((a)=>a.status === "subcontractor_linked").length
        }), [
        leads,
        applications
    ]);
    function handleSearch(val) {
        setSearch(val);
        const q = val.trim().toLowerCase();
        if (!q) {
            setSelDist(null);
            setSelMandal(null);
            return;
        }
        for (const d of tree){
            // district name hit — just show districts row, no auto-expand
            if (d.name.toLowerCase().includes(q)) {
                setSelDist(null);
                setSelMandal(null);
                return;
            }
            for (const m of d.mandals){
                // mandal name hit — auto-expand district so mandals row appears
                if (m.name.toLowerCase().includes(q)) {
                    setSelDist(d);
                    setSelMandal(null);
                    return;
                }
                // village name hit — auto-expand district AND mandal so villages row appears
                const vHit = m.villages.some((v)=>v.name.toLowerCase().includes(q));
                if (vHit) {
                    setSelDist(d);
                    setSelMandal(m);
                    return;
                }
            }
        }
        setSelDist(null);
        setSelMandal(null);
    }
    function clickDistrict(d) {
        if (selDistrict?.id === d.id) {
            setSelDist(null);
            setSelMandal(null);
        } else {
            setSelDist(d);
            setSelMandal(null);
        }
    }
    function clickMandal(m) {
        if (selMandal?.id === m.id) setSelMandal(null);
        else setSelMandal(m);
    }
    if (geoLoading || leadsLoading) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
        style: {
            padding: "4rem",
            textAlign: "center",
            color: "#94a3b8"
        },
        children: "Loading\u2026"
    });
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("style", {
                children: $744e572ad2352a6c$var$CONNECTOR_CSS
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                style: {
                    padding: "2rem 0 4rem",
                    overflowX: "auto"
                },
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    style: {
                        display: "inline-block",
                        minWidth: "100%",
                        textAlign: "center",
                        padding: "0 2rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            style: {
                                marginBottom: "2rem",
                                textAlign: "left"
                            },
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h1", {
                                    style: {
                                        fontSize: "1.15rem",
                                        fontWeight: 700,
                                        margin: "0 0 .25rem",
                                        color: "#1e293b"
                                    },
                                    children: "Area-wise Tree View"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                    style: {
                                        fontSize: ".8rem",
                                        color: "#64748b",
                                        margin: "0 0 .75rem"
                                    },
                                    children: "Click a district to see its mandals \xb7 click a mandal to see its villages"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                    type: "search",
                                    placeholder: "\uD83D\uDD0D  Search district, mandal or village\u2026",
                                    value: search,
                                    onChange: (e)=>handleSearch(e.target.value),
                                    style: {
                                        padding: "0.4rem 0.8rem",
                                        border: "1.5px solid #cbd5e1",
                                        borderRadius: "7px",
                                        fontSize: "0.875rem",
                                        width: "240px",
                                        outline: "none",
                                        background: "#fff",
                                        color: "#1e293b"
                                    }
                                }),
                                search && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                    style: {
                                        marginLeft: "0.5rem",
                                        fontSize: "0.8rem",
                                        color: "#64748b"
                                    },
                                    children: [
                                        visibleTree.length,
                                        " district",
                                        visibleTree.length !== 1 ? "s" : "",
                                        " found"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "center",
                                textAlign: "left"
                            },
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($744e572ad2352a6c$var$NodeBox, {
                                name: "Telangana",
                                icon: "\uD83C\uDFDB\uFE0F",
                                sub: `${visibleTree.length} of ${tree.length} Districts`,
                                counts: stateCounts,
                                level: "state"
                            })
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "oct-stem"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($744e572ad2352a6c$var$OrgRow, {
                            items: visibleTree,
                            selectedId: selDistrict?.id,
                            renderNode: (d, active)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($744e572ad2352a6c$var$NodeBox, {
                                    name: d.name,
                                    icon: active ? "\uD83D\uDCC2" : "\uD83D\uDCC1",
                                    sub: `${d.mandals.length} Mandals`,
                                    counts: $744e572ad2352a6c$var$sumCounts(d.mandals.flatMap((m)=>m.villages)),
                                    level: "district",
                                    active: active,
                                    onClick: ()=>clickDistrict(d)
                                })
                        }),
                        selDistrict && (()=>{
                            const filteredDist = visibleTree.find((d)=>d.id === selDistrict.id) ?? selDistrict;
                            if (filteredDist.mandals.length === 0) return null;
                            return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "oct-stem"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        style: {
                                            fontSize: ".7rem",
                                            fontWeight: 700,
                                            letterSpacing: ".06em",
                                            textTransform: "uppercase",
                                            color: "#94a3b8",
                                            textAlign: "center",
                                            marginBottom: 6
                                        },
                                        children: filteredDist.name
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($744e572ad2352a6c$var$OrgRow, {
                                        items: filteredDist.mandals,
                                        selectedId: selMandal?.id,
                                        renderNode: (m, active)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($744e572ad2352a6c$var$NodeBox, {
                                                name: m.name,
                                                icon: active ? "\uD83D\uDCC2" : "\uD83D\uDCC1",
                                                sub: `${m.villages.length} Villages`,
                                                counts: $744e572ad2352a6c$var$sumCounts(m.villages),
                                                level: "mandal",
                                                active: active,
                                                onClick: ()=>clickMandal(m)
                                            })
                                    })
                                ]
                            });
                        })(),
                        selDistrict && selMandal && (()=>{
                            const filteredDist = visibleTree.find((d)=>d.id === selDistrict.id) ?? selDistrict;
                            const filteredMandal = filteredDist.mandals.find((m)=>m.id === selMandal.id) ?? selMandal;
                            if (filteredMandal.villages.length === 0) return null;
                            return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        className: "oct-stem"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        style: {
                                            fontSize: ".7rem",
                                            fontWeight: 700,
                                            letterSpacing: ".06em",
                                            textTransform: "uppercase",
                                            color: "#94a3b8",
                                            textAlign: "center",
                                            marginBottom: 6
                                        },
                                        children: filteredMandal.name
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($744e572ad2352a6c$var$OrgRow, {
                                        items: filteredMandal.villages,
                                        renderNode: (v)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                style: {
                                                    position: "relative",
                                                    display: "inline-block"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($744e572ad2352a6c$var$NodeBox, {
                                                        name: v.name,
                                                        icon: "\uD83C\uDFD8\uFE0F",
                                                        counts: v.counts,
                                                        level: "village"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                        type: "button",
                                                        title: "Add Lead for this village",
                                                        onClick: ()=>setAddLeadTarget({
                                                                district: selDistrict.name,
                                                                mandal: selMandal.name,
                                                                village: v.name
                                                            }),
                                                        style: {
                                                            position: "absolute",
                                                            bottom: -12,
                                                            left: "50%",
                                                            transform: "translateX(-50%)",
                                                            width: 26,
                                                            height: 26,
                                                            borderRadius: "50%",
                                                            background: "#16a34a",
                                                            border: "2px solid #fff",
                                                            color: "#fff",
                                                            fontSize: "1rem",
                                                            fontWeight: 900,
                                                            cursor: "pointer",
                                                            lineHeight: 1,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)"
                                                        },
                                                        children: "+"
                                                    })
                                                ]
                                            })
                                    })
                                ]
                            });
                        })()
                    ]
                })
            }),
            addLeadTarget && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $31cf9fc3a9a2985f$export$50304b75f82eebea), {
                target: addLeadTarget,
                onClose: ()=>setAddLeadTarget(null),
                onSaved: reloadLeads
            })
        ]
    });
}











var $7UyaH = parcelRequire("7UyaH");


function $b3aaef19adfaf342$export$a2a65280bd8fb0e1(apps) {
    const totalReceived = apps.length;
    let pendingValidation = 0;
    let onHold = 0;
    let readyForIcici = 0;
    let readyForMou = 0;
    let awaitingSubcontractor = 0;
    let subcontractorLinked = 0;
    let seedingPendingBeforeIcici = 0;
    let billsPendingSeedingReverify = 0;
    let workmanOrNameIssues = 0;
    for (const a of apps){
        if (a.status === "on_hold") onHold++;
        else if (a.status === "pending_validation") pendingValidation++;
        else if (a.status === "ready_for_icici") readyForIcici++;
        else if (a.status === "ready_for_mou") readyForMou++;
        else if (a.status === "icici_recorded") awaitingSubcontractor++;
        else if (a.status === "subcontractor_linked") subcontractorLinked++;
        const v = a.validations;
        const coreOk = v.nameMatchAcrossSources === true && v.aadhaarVerified === true && v.bankAccountVerified === true && (0, $3655432918d5e89d$export$563fe0138d49a54b)(v.workmanCardAcceptable);
        if (coreOk && !v.aadhaarSeedingConfirmed && a.holdReasons.length === 0) seedingPendingBeforeIcici++;
        const pendingBills = a.workDoneBills.filter((b)=>!b.seedingReVerified).length;
        billsPendingSeedingReverify += pendingBills;
        if (v.nameMatchAcrossSources === false || v.workmanCardAcceptable === false) workmanOrNameIssues++;
    }
    return {
        totalReceived: totalReceived,
        pendingValidation: pendingValidation,
        onHold: onHold,
        readyForIcici: readyForIcici,
        readyForMou: readyForMou,
        awaitingSubcontractor: awaitingSubcontractor,
        subcontractorLinked: subcontractorLinked,
        seedingPendingBeforeIcici: seedingPendingBeforeIcici,
        billsPendingSeedingReverify: billsPendingSeedingReverify,
        workmanOrNameIssues: workmanOrNameIssues
    };
}


var $0a4e257af3ea3a0f$exports = {};
$0a4e257af3ea3a0f$exports = $parcel$resolve("35mrC");


/** District map artwork (PNG with dark surround — CSS screen blend knocks black into the sunburst) */ const $5c6cdf719da5c9ab$var$telanganaMapSrc = new URL($0a4e257af3ea3a0f$exports).href;
/** Pastel badge + darker building glyph (reference “secretariat” style tiles) */ const $5c6cdf719da5c9ab$var$ICON_STYLES = [
    {
        soft: "#d1f4ea",
        dark: "#0f766e"
    },
    {
        soft: "#dbeafe",
        dark: "#1d4ed8"
    },
    {
        soft: "#fce7f3",
        dark: "#be185d"
    },
    {
        soft: "#fef3c7",
        dark: "#b45309"
    }
];
function $5c6cdf719da5c9ab$var$formatIn(n) {
    return new Intl.NumberFormat("en-IN").format(n);
}
function $5c6cdf719da5c9ab$var$MetricIcon({ soft: soft, dark: dark }) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        className: "dash-key-metrics__icon-badge",
        style: {
            background: soft
        },
        "aria-hidden": true,
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("svg", {
            className: "dash-key-metrics__icon-svg",
            viewBox: "0 0 24 24",
            width: "20",
            height: "20",
            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                fill: dark,
                d: "M12 3L4 8v12h4v-7h8v7h4V8l-8-5zm0 2.2l5.5 3.4V8H6.5V8.6L12 5.2zM9 13h2v2H9v-2zm4 0h2v2h-2v-2z"
            })
        })
    });
}
function $5c6cdf719da5c9ab$export$5f0ece31c46bf56f({ applications: applications }) {
    const k = (0, $7UyaH.useMemo)(()=>(0, $b3aaef19adfaf342$export$a2a65280bd8fb0e1)(applications), [
        applications
    ]);
    const [totalLeads, setTotalLeads] = (0, $7UyaH.useState)(null);
    (0, $7UyaH.useEffect)(()=>{
        let cancelled = false;
        (0, $4e56623d4da7ea32$export$c20290562992eebc)().then((rows)=>{
            if (!cancelled) setTotalLeads(rows.length);
        }).catch(()=>{
            if (!cancelled) setTotalLeads(0);
        });
        return ()=>{
            cancelled = true;
        };
    }, []);
    const items = (0, $7UyaH.useMemo)(()=>[
            {
                value: totalLeads === null ? "\u2014" : $5c6cdf719da5c9ab$var$formatIn(totalLeads),
                label: "Total Leads",
                icon: $5c6cdf719da5c9ab$var$ICON_STYLES[0]
            },
            {
                value: $5c6cdf719da5c9ab$var$formatIn(k.totalReceived),
                label: "Total Applicants",
                icon: $5c6cdf719da5c9ab$var$ICON_STYLES[1]
            },
            {
                value: $5c6cdf719da5c9ab$var$formatIn(k.pendingValidation),
                label: "HO Verification Pending",
                icon: $5c6cdf719da5c9ab$var$ICON_STYLES[2]
            },
            {
                value: $5c6cdf719da5c9ab$var$formatIn(k.subcontractorLinked),
                label: "Subcontractor linked",
                icon: $5c6cdf719da5c9ab$var$ICON_STYLES[3]
            }
        ], [
        k,
        totalLeads
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
        className: "dash-key-metrics",
        "aria-labelledby": "dash-key-metrics-heading",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "dash-key-metrics__bg",
                "aria-hidden": true,
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "dash-key-metrics__sunburst"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "dash-key-metrics__rays"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                        src: $5c6cdf719da5c9ab$var$telanganaMapSrc,
                        alt: "",
                        className: "dash-key-metrics__map dash-key-metrics__map--state-png",
                        decoding: "async"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "dash-key-metrics__inner",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "dash-key-metrics__ribbon-badge",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                            id: "dash-key-metrics-heading",
                            className: "dash-key-metrics__ribbon",
                            children: "Our key metrics"
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("ul", {
                        className: "dash-key-metrics__grid",
                        children: items.map((row)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("li", {
                                className: "dash-key-metrics__card",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c6cdf719da5c9ab$var$MetricIcon, {
                                        soft: row.icon.soft,
                                        dark: row.icon.dark
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "dash-key-metrics__value",
                                        children: row.value
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "dash-key-metrics__label",
                                        children: row.label
                                    })
                                ]
                            }, row.label))
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");


var $3b195aeddb255eb8$exports = {};
$3b195aeddb255eb8$exports = JSON.parse("[{\"title\":\"Adilabad\",\"d\":\"M780 414L801 381L791 357L789 333L816 319L842 305L840 277L842 251L816 243L809 243L800 235L795 207L771 197L749 197L727 185L697 183L673 179L649 185L623 177L609 153L583 143L579 173L607 184L609 201L589 227L561 237L579 259L567 307L577 286L575 277L573 293L582 322L575 322L575 327L559 328L535 337L523 377L544 387L551 385L577 403L599 431L629 439L639 413L663 413L697 391L723 381L755 391z\"},{\"title\":\"Kumuram Bheem\",\"d\":\"M837 286L851 282L865 289L878 288L891 293L906 301L923 311L932 324L947 321L942 306L955 292L959 277L953 258L967 258L971 271L985 268L985 280L1002 276L1017 286L1031 292L1048 306L1062 301L1065 288L1078 288L1092 299L1102 284L1121 273L1137 273L1150 267L1168 264L1185 278L1196 294L1209 302L1223 308L1238 318L1243 333L1250 352L1246 369L1245 383L1233 403L1232 423L1239 437L1225 443L1211 440L1198 440L1182 447L1170 434L1156 433L1142 427L1129 428L1121 413L1107 403L1089 401L1075 393L1062 391L1068 407L1077 421L1065 424L1053 428L1041 433L1026 427L1005 423L991 417L993 429L1011 439L1015 452L987 446L987 462L971 458L958 449L961 477L948 486L930 473L918 471L906 461L895 450L879 438L875 426L855 419L842 409L819 393L803 396L803 379L812 367L798 363L786 353L793 338L811 329L827 314L849 312L838 299z\"},{\"title\":\"Nirmal\",\"d\":\"M407 388L424 377L443 371L458 383L470 396L479 410L492 406L504 407L517 415L532 406L531 392L534 380L550 385L564 400L579 405L586 420L601 426L616 436L630 439L643 429L641 418L654 417L667 420L669 408L683 399L697 388L710 385L723 386L738 381L753 392L766 401L780 419L788 408L801 397L818 393L839 408L827 426L816 438L814 455L820 470L834 460L840 476L824 492L801 481L786 488L770 498L756 500L738 493L723 505L709 516L696 507L682 517L669 527L656 519L641 522L627 509L614 508L600 515L587 521L572 526L571 511L558 502L544 506L529 509L518 521L504 525L487 532L474 552L457 556L444 563L431 565L418 555L413 543L400 545L401 529L388 528L390 515L378 513L367 502L367 485L380 483L384 466L400 470L394 453L403 437L404 423L408 406L422 400z\"},{\"title\":\"Mancherial\",\"d\":\"M840 407L853 411L866 421L872 435L891 440L898 458L913 461L926 471L941 478L954 479L962 467L958 451L986 465L986 446L1007 450L1003 434L989 419L1011 421L1030 426L1042 434L1061 425L1076 425L1069 409L1061 392L1079 394L1092 398L1104 398L1119 410L1128 422L1141 425L1154 435L1167 431L1173 445L1187 441L1201 437L1213 440L1227 441L1219 454L1206 462L1208 485L1222 489L1234 491L1239 519L1240 540L1242 559L1227 571L1213 575L1200 564L1188 561L1190 577L1197 591L1186 606L1186 619L1171 628L1156 631L1143 632L1128 635L1114 617L1096 608L1074 594L1063 586L1047 577L1029 568L1013 564L1001 574L984 579L968 576L951 559L934 558L920 545L906 531L901 518L893 504L887 487L873 481L852 478L840 476L834 459L819 465L814 452L813 439L828 427z\"},{\"title\":\"Nizamabad\",\"d\":\"M376 629L384 611L391 597L398 584L412 576L427 574L439 569L452 556L465 552L477 548L481 532L497 529L511 522L524 516L536 508L550 503L564 506L570 519L584 522L600 516L613 508L628 507L635 520L648 523L660 518L672 527L668 542L674 554L676 570L680 583L681 599L690 612L704 616L716 622L704 631L692 635L692 650L708 669L698 686L684 689L680 702L669 722L656 728L643 716L631 716L619 712L612 724L599 720L585 720L565 724L561 712L549 708L535 704L524 716L491 705L475 711L469 732L452 724L440 710L421 708L406 703L390 704L377 705L364 704L360 690L356 678L357 664L352 650L355 632L364 620z\"},{\"title\":\"Jagital\",\"d\":\"M691 508L696 508L703 512L712 516L720 511L725 501L734 494L740 492L751 498L760 502L775 493L782 488L787 488L792 481L799 480L808 484L816 490L823 494L831 486L834 481L837 477L846 475L854 478L864 477L871 480L879 484L887 488L893 494L895 502L895 511L900 517L901 523L902 529L910 535L917 543L923 548L929 556L935 561L946 561L954 562L961 567L965 574L977 580L975 588L968 590L962 596L961 604L953 606L944 609L938 605L932 606L923 604L917 617L911 615L909 623L903 624L908 639L901 640L898 646L893 640L891 646L884 642L881 636L878 645L877 652L871 646L865 644L863 635L855 636L853 645L850 653L846 661L848 668L854 676L847 675L839 674L833 675L831 681L825 677L822 679L811 666L803 669L795 665L789 662L782 660L774 656L763 653L755 653L747 653L739 650L731 654L721 652L718 645L715 638L712 632L716 625L713 616L706 614L695 618L689 612L682 611L681 604L682 598L686 592L681 587L679 580L678 573L676 566L674 557L671 549L667 543L670 534L673 528L680 526L680 519L686 514z\"},{\"title\":\"Peddapalli\",\"d\":\"M911 623L914 617L919 616L922 610L924 603L932 606L939 606L943 609L946 608L952 604L958 606L962 600L964 593L970 589L976 587L978 579L986 582L994 581L1002 576L1006 569L1014 565L1024 566L1034 569L1041 575L1047 578L1054 583L1057 589L1063 593L1073 592L1080 597L1089 602L1094 608L1101 612L1110 615L1116 619L1120 626L1125 633L1133 637L1140 635L1148 633L1157 633L1164 633L1171 627L1180 625L1186 621L1186 627L1192 635L1193 642L1188 649L1184 656L1178 662L1176 667L1175 674L1176 679L1171 681L1162 680L1154 679L1147 685L1142 693L1141 701L1134 706L1126 715L1120 714L1115 715L1110 712L1103 719L1097 717L1094 723L1096 726L1093 730L1085 737L1078 740L1072 744L1066 746L1060 746L1052 751L1046 750L1039 744L1030 739L1023 739L1015 737L1008 733L1006 727L1000 728L994 723L987 718L980 715L974 714L967 719L961 723L955 727L949 722L948 714L947 708L947 705L946 702L947 694L946 692L947 688L950 685L951 680L942 675L941 668L932 663L932 646L929 645L926 647L923 650L920 648L914 641L907 640L907 631L904 625z\"},{\"title\":\"Kamareddy\",\"d\":\"M348 679L349 684L356 682L364 696L364 705L368 706L373 705L378 708L397 703L410 703L416 708L423 710L438 709L452 718L452 727L470 732L475 723L474 715L480 709L488 704L502 709L508 709L514 712L521 715L525 715L529 709L534 706L540 704L550 710L564 712L563 719L565 723L569 725L572 725L579 723L593 720L606 722L613 723L619 718L621 714L626 714L628 716L628 716L631 714L643 717L652 732L661 729L665 724L670 719L678 731L679 743L686 750L675 751L672 757L680 772L675 783L670 795L685 803L683 808L688 815L686 828L687 833L684 836L678 834L672 831L667 839L660 835L654 848L657 853L652 855L647 855L645 855L642 855L639 849L636 842L630 844L628 850L624 852L614 856L608 849L606 839L600 838L596 837L595 831L593 828L586 826L583 839L577 841L572 846L566 846L558 844L554 838L549 832L548 821L536 821L530 835L528 843L530 848L532 860L533 866L527 870L521 873L518 878L508 876L505 868L501 870L499 877L497 876L493 874L480 870L476 869L470 869L466 863L452 860L437 857L435 862L431 866L425 864L428 859L433 860L435 857L437 853L439 850L437 845L431 846L426 843L420 843L420 840L423 838L421 833L422 833L422 829L417 830L412 831L407 827L405 823L400 825L391 828L386 827L381 825L379 825L376 825L372 826L370 830L362 823L357 825L359 818L356 814L353 814L352 805L346 802L338 801L332 795L327 792L321 792L319 782L314 785L310 784L305 783L300 796L298 793L292 790L285 793L282 790L283 786L289 784L285 773L274 770L269 765L273 756L276 751L282 748L282 742L275 737L271 729L279 727L287 729L299 726L281 717L290 717L292 711L302 714L298 708L295 704L297 701L300 699L296 696L297 693L298 690L300 686L307 684L312 684L315 688L318 684L323 686L323 692L329 690L343 681z\"},{\"title\":\"Rajanna Sircilla\",\"d\":\"M670 719L676 711L682 701L684 694L691 686L698 686L702 675L708 670L698 660L692 653L693 648L698 645L698 639L694 632L714 631L714 637L718 644L721 652L736 654L742 650L748 653L755 654L763 656L762 650L770 655L778 658L784 662L790 663L796 667L803 670L810 667L822 680L831 681L836 674L844 676L839 684L843 691L840 700L852 707L854 720L856 729L848 734L854 740L861 744L866 747L860 753L869 757L864 765L863 772L868 775L864 782L857 784L854 792L856 800L849 805L839 805L828 804L819 805L815 811L808 809L801 812L791 805L782 805L768 801L764 810L760 818L753 820L750 813L743 813L737 813L730 809L721 806L715 802L709 807L696 807L690 817L683 812L682 806L683 799L677 796L670 794L671 788L676 781L680 774L679 764L674 758L674 752L680 751L686 748L680 743L677 737L678 728z\"},{\"title\":\"Karimnagar\",\"d\":\"M926 841L920 836L917 833L918 827L910 822L903 820L903 811L909 809L909 804L912 799L907 797L904 791L892 791L884 789L887 782L882 777L882 769L876 770L868 773L865 772L864 766L869 760L865 756L862 752L866 747L862 744L857 745L855 741L851 736L851 730L855 728L855 721L853 715L852 711L850 707L846 705L842 702L841 694L841 688L841 679L847 676L854 677L852 668L846 662L851 653L854 645L854 639L862 634L865 644L871 646L877 650L879 644L882 637L887 643L893 643L899 645L901 639L908 640L915 641L921 649L930 645L932 653L932 662L941 669L941 675L951 679L949 688L947 695L945 701L947 707L948 715L949 721L955 728L963 724L968 717L974 715L981 716L987 718L993 721L999 726L1006 729L1013 735L1019 739L1027 741L1033 739L1040 744L1048 751L1055 748L1062 745L1069 745L1075 743L1085 737L1091 740L1090 747L1089 755L1091 765L1088 771L1089 781L1082 785L1085 793L1085 800L1079 799L1077 805L1073 812L1065 811L1059 814L1051 816L1044 824L1050 830L1043 832L1043 841L1036 843L1028 843L1025 837L1018 839L1015 846L1007 844L1001 850L992 847L981 853L974 849L973 844L959 839L955 833L944 835L944 842L933 838z\"},{\"title\":\"Jayashankar\",\"d\":\"M1083 800L1090 803L1098 800L1105 801L1110 795L1121 804L1135 796L1137 802L1140 808L1145 816L1151 825L1152 831L1158 835L1175 835L1181 843L1195 843L1196 835L1196 829L1202 824L1200 813L1199 806L1205 798L1212 791L1212 785L1218 781L1224 782L1232 783L1236 777L1238 769L1236 763L1242 757L1246 750L1256 751L1265 747L1273 746L1282 748L1290 750L1298 749L1303 755L1309 753L1322 762L1330 765L1346 750L1347 741L1348 733L1346 720L1354 704L1349 687L1359 676L1366 672L1396 668L1397 661L1389 653L1385 639L1378 627L1365 613L1358 615L1350 621L1341 623L1335 623L1327 625L1320 621L1314 624L1301 628L1295 622L1281 620L1273 613L1270 608L1262 607L1258 600L1253 593L1246 587L1239 585L1233 582L1228 578L1234 570L1228 571L1221 575L1212 577L1205 573L1202 565L1196 559L1190 562L1188 573L1191 580L1197 587L1196 594L1190 598L1185 607L1188 615L1183 622L1187 629L1192 636L1193 642L1188 649L1183 658L1178 662L1177 677L1168 679L1161 678L1154 678L1148 684L1142 691L1141 699L1134 706L1128 715L1121 715L1114 714L1108 713L1102 719L1096 717L1095 725L1092 731L1085 736L1091 742L1089 749L1089 757L1090 764L1089 770L1089 781L1083 785z\"},{\"title\":\"Sangareddy\",\"d\":\"M300 797L303 784L311 784L319 782L320 791L326 791L333 795L338 802L346 802L352 804L352 812L358 815L360 821L353 824L366 823L369 829L375 826L381 824L387 827L394 827L401 824L407 824L408 830L422 830L424 838L418 841L428 844L436 844L439 851L434 857L428 859L426 864L420 868L417 877L403 876L403 885L408 895L401 900L395 908L390 913L390 922L384 922L382 928L380 935L389 935L394 944L400 944L404 936L406 930L412 926L419 930L425 935L432 933L438 937L437 943L435 949L443 950L450 949L456 951L462 949L463 943L469 942L475 954L479 947L480 939L487 935L493 943L490 958L499 960L500 968L500 976L507 984L513 979L515 971L521 969L519 979L521 986L527 986L534 988L541 986L539 993L543 999L541 1005L547 1008L554 1010L553 1016L555 1022L554 1030L562 1027L568 1030L577 1031L584 1034L592 1026L590 1020L590 1014L586 1008L594 1008L602 1006L605 1012L611 1022L619 1026L621 1019L627 1013L635 1014L641 1021L634 1027L630 1035L624 1037L617 1034L613 1047L618 1056L610 1059L617 1067L611 1072L613 1079L604 1079L607 1086L600 1091L600 1096L595 1102L584 1101L587 1108L580 1109L582 1120L577 1126L577 1132L571 1131L557 1134L551 1130L548 1124L544 1117L545 1110L537 1109L533 1118L525 1118L519 1116L519 1110L513 1108L507 1110L500 1107L493 1104L490 1098L484 1101L487 1107L481 1113L489 1121L481 1124L475 1116L469 1118L463 1114L463 1107L457 1102L453 1111L446 1111L448 1103L449 1096L447 1090L436 1090L435 1083L432 1076L425 1073L419 1072L411 1072L411 1064L407 1057L401 1059L393 1053L385 1054L378 1053L372 1053L361 1056L367 1059L371 1065L367 1071L366 1081L360 1084L351 1091L345 1095L337 1094L337 1104L328 1099L320 1096L315 1090L307 1093L310 1084L302 1087L299 1080L292 1082L284 1085L279 1079L272 1075L268 1084L261 1088L259 1078L250 1072L242 1073L238 1065L242 1053L241 1044L243 1033L242 1026L252 1021L260 1018L266 1014L273 1011L281 1009L288 1007L288 999L281 999L275 992L267 992L265 984L270 979L271 973L282 972L285 966L288 958L295 953L300 952L294 948L296 940L308 942L308 930L314 925L312 919L321 923L323 917L320 910L314 906L306 902L298 901L293 894L283 892L280 883L283 878L290 873L298 870L301 863L299 856L300 845L293 841L290 834L286 827L289 821L296 816L291 808L293 800z\"},{\"title\":\"Medak\",\"d\":\"M401 877L416 878L420 868L423 866L427 866L432 865L438 857L448 860L455 862L463 862L466 864L467 864L468 866L468 868L474 869L480 871L488 875L497 878L500 876L500 871L503 869L506 869L508 876L516 878L522 873L531 868L532 858L531 848L528 846L527 842L531 830L534 823L544 819L548 821L549 827L552 837L558 843L565 846L573 847L576 841L583 839L585 826L593 827L595 831L595 834L603 838L608 848L610 852L614 854L625 853L629 847L634 841L639 849L639 855L645 856L650 854L656 852L654 846L661 836L667 839L671 832L679 833L686 835L688 834L692 837L692 842L687 841L681 848L681 854L678 859L681 861L684 861L691 863L691 866L689 869L687 874L688 878L695 880L693 887L692 893L690 893L687 892L684 889L681 896L678 905L673 907L677 914L673 923L677 930L672 933L674 936L679 940L672 947L672 953L681 952L685 954L684 959L683 972L669 971L670 977L665 983L668 989L665 992L667 1000L669 1006L663 1019L658 1025L657 1028L651 1029L647 1027L644 1025L641 1022L639 1017L632 1014L625 1013L621 1022L619 1025L614 1026L610 1019L605 1010L598 1007L594 1009L589 1007L587 1014L590 1017L589 1021L591 1026L588 1030L587 1034L581 1035L577 1033L575 1030L567 1030L563 1028L559 1029L556 1031L552 1031L553 1025L556 1022L554 1018L556 1013L554 1010L549 1010L541 1008L543 999L540 998L541 991L542 985L533 989L527 988L520 985L521 969L515 971L515 979L509 983L501 980L499 973L499 966L498 960L491 958L493 943L487 935L480 939L479 945L475 954L469 945L462 945L458 952L452 951L445 949L436 949L434 946L437 942L438 937L434 938L434 935L431 932L429 936L423 935L417 931L415 931L415 927L409 927L405 933L401 942L399 946L394 944L390 938L390 936L383 935L379 935L380 932L381 929L386 922L392 921L390 913L400 902L407 897L403 885z\"},{\"title\":\"Siddipet\",\"d\":\"M685 823L687 817L691 817L695 807L700 807L708 807L712 806L715 803L720 806L726 809L730 811L734 814L738 814L742 813L747 813L750 814L749 820L755 820L761 816L763 810L765 805L767 801L772 804L777 804L782 804L788 805L792 806L796 807L799 810L802 813L808 810L814 811L819 807L826 804L833 804L841 805L846 806L852 805L855 801L854 795L855 792L853 789L856 786L860 785L865 781L868 776L870 771L873 769L882 768L882 773L888 780L884 787L885 790L890 791L896 791L900 791L904 789L905 793L906 798L909 798L911 801L907 803L908 806L908 810L904 811L903 815L903 819L906 821L910 820L913 823L918 826L916 832L920 834L920 838L928 842L934 838L943 842L943 837L955 834L957 838L965 841L975 845L974 850L979 853L973 856L975 860L972 865L971 869L972 873L969 877L970 880L969 885L965 888L963 894L963 903L959 902L954 906L951 909L945 908L935 906L930 909L926 909L921 909L915 915L916 919L913 926L909 928L906 933L901 939L909 945L905 946L896 957L882 957L879 961L874 956L868 955L862 961L859 965L856 970L853 964L847 963L840 964L835 957L828 958L825 959L826 963L826 969L822 969L818 969L818 972L811 974L807 975L807 984L807 988L807 993L805 1001L802 1006L797 1005L792 1008L787 1010L790 1014L786 1015L786 1023L782 1022L777 1021L772 1020L776 1024L771 1027L768 1031L763 1031L758 1031L753 1038L748 1038L745 1033L741 1031L734 1030L731 1026L724 1027L720 1034L714 1037L707 1036L705 1033L701 1029L698 1026L690 1027L690 1031L685 1031L682 1029L675 1027L668 1025L663 1031L658 1031L659 1026L662 1019L662 1016L670 1007L667 1003L665 997L667 988L665 984L668 981L669 977L667 973L668 969L674 971L679 972L683 973L684 970L684 966L683 961L685 956L685 953L682 952L678 952L672 954L671 950L672 946L680 941L677 938L673 937L673 934L677 931L677 928L672 925L675 920L677 916L676 912L674 907L677 906L679 901L680 897L682 893L683 890L688 894L692 893L692 889L695 884L695 879L688 879L687 875L689 871L691 866L691 863L688 861L684 862L679 861L679 858L681 853L682 848L688 842L692 840L692 836L688 833L687 826z\"},{\"title\":\"Hanumakonda\",\"d\":\"M1038 953L1038 942L1033 940L1027 948L1022 946L1017 943L1013 946L1006 940L1001 938L997 935L995 930L989 928L983 926L980 926L967 924L967 915L964 911L951 911L954 906L958 902L962 903L962 898L962 894L965 889L968 885L970 881L971 878L968 877L971 874L972 869L974 863L975 859L974 856L978 853L982 853L985 851L989 848L992 846L998 847L1000 850L1003 847L1006 844L1011 843L1014 846L1019 840L1026 839L1028 843L1032 844L1036 843L1040 842L1043 838L1044 833L1049 831L1048 827L1045 824L1047 820L1051 816L1056 815L1061 815L1064 810L1070 812L1073 812L1076 809L1077 805L1080 800L1083 800L1087 802L1090 803L1094 801L1099 800L1103 801L1110 797L1115 800L1119 804L1126 804L1131 801L1137 795L1140 797L1138 800L1137 805L1140 808L1145 812L1146 819L1149 821L1152 826L1148 827L1152 830L1154 833L1158 835L1163 836L1169 835L1176 835L1176 840L1181 844L1186 844L1192 843L1196 842L1201 847L1197 850L1186 860L1183 873L1175 874L1176 885L1173 888L1168 884L1164 885L1163 891L1157 894L1157 898L1152 902L1148 905L1142 906L1137 905L1131 903L1129 899L1127 894L1124 891L1121 890L1117 889L1114 893L1111 890L1108 890L1104 892L1101 894L1098 892L1097 896L1096 901L1094 907L1095 911L1091 911L1090 915L1086 917L1087 922L1085 929L1087 932L1080 934L1081 937L1085 940L1090 945L1095 947L1095 951L1099 954L1103 957L1106 958L1106 963L1105 966L1108 969L1107 975L1103 977L1097 977L1095 972L1093 975L1091 980L1084 982L1083 987L1080 991L1065 987L1064 978L1056 978L1056 972L1056 968L1062 962L1060 959L1055 958L1054 949L1049 949L1044 956z\"},{\"title\":\"Mulugu\",\"d\":\"M1193 830L1203 823L1199 808L1209 794L1210 786L1217 781L1225 783L1234 783L1238 768L1239 759L1246 751L1256 752L1269 746L1282 748L1291 749L1299 749L1302 756L1309 753L1322 763L1328 765L1345 749L1344 743L1346 721L1354 705L1349 686L1356 679L1366 672L1397 668L1401 662L1410 661L1418 661L1425 661L1432 657L1440 654L1449 653L1462 656L1466 663L1472 670L1487 680L1498 685L1503 695L1512 697L1513 706L1521 715L1532 722L1538 725L1536 733L1544 740L1552 742L1544 748L1550 757L1552 766L1556 775L1560 783L1562 791L1568 798L1574 800L1574 808L1566 810L1553 816L1552 826L1553 834L1562 838L1558 844L1551 847L1552 854L1551 863L1540 853L1529 862L1528 855L1529 847L1522 843L1516 851L1509 849L1505 856L1512 857L1510 864L1503 862L1497 873L1481 864L1473 866L1457 850L1447 852L1439 884L1432 883L1412 874L1396 889L1394 900L1384 906L1373 906L1360 898L1354 900L1348 896L1341 900L1316 885L1305 874L1297 875L1290 878L1282 870L1274 863L1265 859L1268 866L1259 874L1249 864L1241 869L1233 873L1225 871L1214 872L1210 865L1204 869L1198 867L1185 869L1186 861L1200 847L1195 841L1197 836z\"},{\"title\":\"Medchal-Malkajgiri\",\"d\":\"M610 1059L617 1057L616 1052L613 1047L619 1035L624 1036L629 1036L631 1032L635 1028L638 1025L642 1022L644 1027L648 1028L654 1027L658 1028L663 1031L668 1025L675 1026L681 1030L689 1031L689 1028L694 1026L698 1027L703 1031L706 1034L711 1036L715 1037L719 1035L722 1029L724 1026L734 1027L740 1030L743 1033L748 1036L748 1040L745 1044L745 1049L740 1050L735 1056L740 1061L735 1066L736 1071L734 1074L736 1077L741 1080L738 1085L740 1089L742 1093L746 1096L744 1104L744 1112L746 1117L753 1116L760 1117L764 1121L761 1125L761 1129L765 1132L763 1137L761 1140L758 1143L754 1147L755 1152L750 1148L747 1144L742 1147L737 1143L732 1143L730 1148L728 1153L722 1153L718 1151L710 1151L703 1150L694 1150L694 1161L683 1160L681 1156L678 1157L673 1156L670 1154L666 1153L669 1151L672 1149L672 1145L669 1143L676 1140L671 1140L673 1136L677 1135L679 1131L683 1129L676 1128L672 1128L671 1131L668 1133L665 1133L662 1130L665 1126L667 1122L665 1119L667 1115L667 1111L663 1111L659 1112L659 1116L655 1117L647 1115L647 1119L647 1123L647 1126L651 1128L647 1130L643 1128L641 1124L634 1123L631 1123L624 1124L619 1124L616 1119L613 1116L607 1115L608 1108L612 1105L611 1100L609 1097L600 1097L600 1091L603 1088L607 1085L603 1081L605 1077L612 1080L613 1075L613 1070L615 1067L617 1063L613 1061z\"},{\"title\":\"Yadadri Bhuvanagiri\",\"d\":\"M734 1057L740 1051L744 1050L744 1045L749 1038L752 1038L757 1032L767 1032L775 1025L773 1020L778 1021L783 1023L786 1023L787 1016L791 1014L788 1010L791 1009L796 1005L803 1005L807 995L808 988L806 983L812 981L816 983L819 983L823 980L827 983L833 986L839 990L845 989L851 987L854 986L856 989L858 993L860 997L859 1001L859 1006L861 1009L865 1014L869 1018L872 1021L875 1019L878 1015L882 1015L885 1016L889 1017L892 1020L894 1023L895 1027L897 1031L900 1034L904 1036L911 1037L911 1041L913 1047L916 1052L921 1055L921 1060L921 1064L921 1068L926 1074L931 1071L932 1066L936 1066L942 1056L947 1060L944 1067L950 1073L951 1080L958 1080L963 1082L969 1074L974 1077L976 1083L983 1084L983 1088L987 1089L989 1094L997 1096L1004 1097L1010 1100L1008 1103L1003 1104L1005 1111L1012 1116L1019 1121L1025 1129L1029 1133L1029 1139L1025 1141L1024 1145L1024 1149L1028 1154L1033 1157L1038 1162L1042 1166L1041 1169L1035 1167L1022 1167L1016 1166L1012 1167L1008 1169L1003 1167L998 1164L991 1161L977 1162L964 1162L955 1162L954 1165L953 1170L961 1174L959 1178L952 1176L949 1178L946 1180L945 1188L941 1198L934 1196L931 1201L927 1203L923 1201L919 1196L921 1192L917 1191L914 1193L906 1193L904 1198L901 1206L895 1205L889 1203L885 1201L881 1202L877 1199L873 1199L867 1198L861 1197L857 1193L849 1192L850 1200L851 1206L850 1213L850 1219L844 1223L845 1229L849 1232L852 1236L855 1240L855 1244L850 1252L847 1252L843 1251L839 1252L841 1257L838 1261L834 1264L832 1267L828 1267L823 1268L820 1274L820 1277L817 1282L817 1285L812 1285L809 1279L801 1277L797 1275L793 1271L787 1266L787 1260L792 1262L794 1259L790 1256L781 1252L774 1248L770 1242L772 1239L776 1239L774 1234L772 1230L769 1229L764 1218L770 1220L774 1222L778 1224L781 1223L781 1220L786 1219L786 1212L782 1209L777 1207L772 1207L767 1204L761 1199L761 1192L757 1188L760 1185L764 1183L762 1176L763 1171L753 1174L744 1171L745 1165L747 1161L752 1164L753 1158L755 1153L755 1146L759 1144L762 1141L764 1134L761 1129L764 1122L763 1119L760 1116L756 1116L747 1117L742 1114L743 1108L743 1104L744 1100L746 1095L741 1091L738 1086L740 1083L740 1078L735 1077L734 1073L736 1068L737 1065L740 1061z\"},{\"title\":\"Jangaon\",\"d\":\"M835 957L840 963L854 964L856 971L859 963L863 959L868 955L874 957L879 961L883 957L889 956L896 957L900 952L904 946L908 945L900 939L905 934L909 929L913 925L916 919L914 915L920 909L926 909L935 906L941 908L950 909L949 911L968 915L967 924L982 926L991 929L997 933L1002 939L1008 942L1014 946L1016 943L1020 946L1027 948L1034 940L1039 943L1038 953L1043 956L1047 952L1049 949L1053 949L1054 954L1056 957L1061 960L1059 964L1056 969L1055 976L1060 978L1065 978L1065 989L1064 999L1061 1005L1055 1003L1051 1007L1055 1008L1059 1012L1061 1015L1059 1019L1055 1019L1051 1022L1055 1025L1056 1029L1051 1036L1055 1040L1067 1041L1068 1045L1068 1050L1074 1053L1077 1050L1077 1054L1084 1058L1083 1062L1080 1066L1074 1065L1071 1067L1064 1069L1065 1078L1074 1086L1072 1089L1076 1095L1069 1100L1066 1108L1058 1106L1052 1100L1044 1099L1040 1100L1031 1098L1029 1102L1024 1106L1012 1100L1008 1100L1003 1096L989 1095L986 1088L983 1087L983 1084L977 1083L975 1078L969 1073L963 1081L957 1080L952 1080L950 1074L944 1068L947 1064L947 1060L942 1055L939 1060L936 1065L933 1065L931 1071L927 1074L922 1071L921 1067L921 1061L922 1057L918 1053L915 1048L911 1045L911 1038L906 1037L899 1033L895 1029L895 1024L892 1021L887 1017L881 1016L876 1017L874 1021L864 1013L860 1008L857 1004L859 999L859 995L856 991L852 985L847 988L840 990L834 986L828 985L823 980L818 982L812 981L807 982L807 975L810 975L818 972L818 969L825 970L825 964L825 960L829 957z\"},{\"title\":\"Warangal\",\"d\":\"M1080 933L1087 934L1087 922L1090 914L1095 907L1097 894L1103 893L1111 889L1119 889L1125 891L1127 898L1133 904L1141 906L1148 904L1157 898L1159 890L1166 883L1173 888L1175 882L1176 874L1183 872L1189 868L1200 869L1211 866L1216 871L1230 871L1238 871L1243 866L1249 862L1258 873L1268 866L1263 859L1274 861L1261 880L1256 893L1253 900L1254 909L1250 915L1254 918L1252 923L1259 940L1254 949L1250 961L1239 960L1239 970L1232 968L1230 977L1225 986L1223 980L1215 980L1208 982L1211 989L1214 995L1221 996L1219 1004L1215 1011L1207 1010L1200 1014L1202 1018L1194 1018L1185 1020L1187 1027L1177 1022L1169 1025L1160 1030L1147 1025L1143 1031L1139 1031L1135 1030L1131 1038L1131 1044L1124 1044L1121 1052L1111 1056L1104 1055L1096 1051L1089 1057L1078 1056L1078 1048L1072 1052L1067 1050L1066 1040L1057 1040L1051 1034L1055 1028L1052 1022L1059 1018L1059 1012L1051 1006L1057 1004L1063 1000L1065 988L1079 990L1083 981L1091 979L1096 971L1102 976L1108 970L1105 964L1106 957L1099 954L1095 946L1083 940z\"},{\"title\":\"Mahabubabad\",\"d\":\"M1064 1070L1073 1064L1082 1065L1084 1056L1097 1052L1110 1056L1120 1056L1124 1044L1130 1045L1134 1031L1143 1031L1146 1025L1156 1026L1168 1024L1186 1026L1193 1019L1201 1018L1202 1009L1213 1010L1222 997L1212 994L1208 982L1221 979L1222 985L1228 978L1231 970L1238 968L1239 960L1249 960L1254 947L1260 940L1252 925L1254 918L1252 912L1253 899L1256 888L1259 880L1273 863L1279 869L1286 873L1292 877L1304 873L1310 879L1322 889L1341 899L1347 895L1355 900L1360 897L1370 906L1384 907L1386 914L1378 922L1365 922L1365 936L1370 945L1371 958L1367 965L1364 977L1358 981L1359 994L1362 1004L1354 1012L1362 1022L1358 1042L1341 1046L1341 1059L1346 1062L1339 1082L1348 1092L1341 1102L1344 1115L1336 1112L1339 1128L1328 1127L1323 1137L1321 1151L1315 1147L1308 1153L1302 1155L1301 1162L1289 1159L1280 1165L1268 1162L1256 1155L1254 1144L1248 1142L1233 1149L1230 1157L1220 1154L1216 1160L1210 1162L1207 1172L1197 1172L1185 1172L1176 1175L1177 1163L1170 1156L1174 1149L1172 1143L1165 1143L1163 1137L1160 1129L1154 1134L1147 1132L1140 1124L1132 1119L1122 1117L1122 1107L1114 1108L1108 1106L1100 1106L1096 1094L1094 1103L1088 1102L1084 1104L1081 1101L1074 1093L1073 1085L1065 1079z\"},{\"title\":\"Bhadradri Kothagudem\",\"d\":\"M1671 991L1684 989L1693 993L1687 1002L1693 1011L1693 1018L1682 1011L1685 1020L1686 1024L1680 1025L1675 1019L1665 1019L1670 1012L1666 1007L1655 1006L1648 1001L1643 994L1632 1000L1621 1006L1612 1009L1615 1023L1616 1031L1616 1040L1620 1044L1613 1053L1606 1054L1599 1051L1594 1055L1598 1064L1604 1073L1611 1073L1616 1068L1637 1067L1644 1081L1657 1092L1662 1105L1688 1119L1700 1107L1716 1111L1725 1120L1731 1126L1741 1130L1747 1132L1755 1145L1776 1152L1785 1164L1777 1173L1767 1182L1745 1181L1731 1180L1726 1189L1732 1204L1726 1213L1710 1216L1694 1215L1686 1217L1680 1218L1668 1228L1655 1229L1644 1224L1633 1217L1623 1220L1615 1217L1604 1210L1605 1199L1605 1189L1604 1165L1598 1154L1596 1163L1589 1163L1579 1172L1572 1170L1567 1181L1558 1177L1550 1181L1542 1182L1533 1189L1525 1186L1517 1180L1516 1178L1509 1178L1498 1166L1486 1171L1481 1174L1461 1177L1458 1170L1458 1164L1458 1157L1446 1155L1433 1154L1428 1151L1424 1148L1425 1140L1415 1131L1423 1120L1430 1123L1444 1102L1423 1096L1408 1107L1404 1101L1400 1102L1397 1104L1392 1105L1402 1090L1406 1082L1396 1080L1376 1074L1367 1078L1362 1084L1356 1087L1351 1079L1348 1084L1339 1082L1346 1064L1340 1054L1341 1046L1351 1044L1358 1041L1361 1022L1355 1012L1360 1005L1359 992L1359 982L1364 973L1371 958L1371 943L1365 936L1365 923L1377 922L1386 914L1383 908L1393 899L1395 890L1411 874L1428 883L1436 882L1439 875L1449 854L1457 848L1471 866L1480 863L1495 872L1504 860L1510 861L1513 855L1506 854L1507 848L1517 850L1522 843L1529 847L1527 856L1528 862L1541 853L1550 862L1553 856L1551 848L1564 838L1580 836L1585 830L1584 811L1592 811L1604 813L1605 824L1596 824L1601 839L1604 849L1611 851L1615 850L1624 845L1637 837L1645 835L1646 846L1638 858L1637 871L1644 890L1649 911L1651 928L1657 937L1654 955L1659 973L1660 985z\"},{\"title\":\"Khammam\",\"d\":\"M1178 1176L1191 1171L1208 1172L1211 1163L1218 1155L1228 1157L1233 1148L1249 1143L1256 1156L1272 1164L1281 1165L1289 1160L1300 1162L1305 1152L1315 1147L1320 1153L1322 1141L1328 1126L1339 1128L1336 1112L1342 1115L1341 1102L1349 1091L1339 1083L1348 1085L1351 1078L1356 1086L1366 1083L1373 1074L1389 1077L1405 1082L1405 1088L1399 1094L1396 1102L1403 1102L1407 1108L1419 1096L1432 1100L1445 1102L1436 1113L1431 1123L1423 1121L1415 1129L1425 1141L1425 1150L1431 1156L1446 1156L1459 1154L1457 1164L1456 1170L1460 1176L1479 1172L1485 1174L1498 1166L1508 1178L1514 1176L1533 1190L1539 1183L1546 1181L1553 1181L1558 1177L1565 1182L1570 1171L1580 1170L1588 1163L1595 1163L1596 1155L1603 1164L1604 1170L1605 1181L1604 1189L1606 1196L1602 1206L1609 1212L1617 1216L1625 1216L1625 1228L1626 1242L1609 1240L1609 1251L1606 1260L1605 1271L1606 1279L1596 1288L1581 1282L1572 1280L1557 1275L1540 1272L1531 1276L1522 1277L1515 1273L1523 1264L1514 1259L1512 1252L1506 1254L1497 1246L1489 1244L1481 1250L1471 1256L1463 1256L1458 1265L1460 1277L1453 1283L1444 1285L1443 1292L1432 1291L1430 1280L1423 1274L1423 1267L1416 1272L1413 1278L1416 1287L1421 1295L1414 1301L1404 1313L1419 1317L1438 1322L1453 1332L1455 1320L1467 1323L1470 1317L1486 1328L1498 1337L1491 1343L1496 1351L1484 1356L1484 1371L1490 1377L1503 1385L1496 1387L1486 1396L1471 1394L1454 1392L1450 1386L1443 1386L1444 1377L1428 1369L1428 1363L1410 1360L1420 1365L1419 1372L1410 1377L1407 1370L1402 1360L1394 1360L1394 1353L1386 1348L1399 1340L1383 1336L1382 1324L1379 1314L1372 1312L1372 1301L1364 1306L1356 1303L1348 1298L1340 1298L1336 1289L1332 1295L1324 1299L1316 1304L1308 1307L1296 1309L1296 1315L1282 1317L1282 1300L1273 1295L1272 1284L1265 1279L1258 1274L1252 1267L1241 1254L1233 1250L1225 1250L1218 1242L1209 1234L1210 1222L1218 1218L1217 1209L1217 1202L1205 1198L1194 1193L1187 1194L1183 1184z\"},{\"title\":\"Hyderabad\",\"d\":\"M626 1167L631 1169L634 1167L638 1170L638 1174L642 1173L642 1170L645 1171L644 1175L646 1176L644 1179L641 1180L643 1185L648 1187L649 1181L655 1178L658 1176L662 1177L662 1171L669 1172L668 1168L666 1167L664 1168L662 1167L664 1164L667 1163L668 1161L667 1158L665 1158L664 1155L666 1152L669 1151L671 1150L671 1147L671 1145L669 1144L672 1143L674 1141L672 1140L670 1139L671 1137L672 1135L675 1136L677 1135L679 1131L681 1130L683 1130L679 1129L677 1130L676 1128L672 1128L672 1132L669 1132L668 1134L665 1133L663 1131L663 1129L665 1127L667 1124L666 1120L665 1118L666 1115L666 1111L662 1112L660 1112L659 1116L656 1118L653 1117L650 1116L647 1115L647 1120L647 1122L649 1124L648 1126L652 1127L652 1129L646 1130L643 1127L640 1124L637 1123L633 1123L630 1124L628 1124L623 1123L622 1126L623 1128L621 1129L619 1131L621 1133L622 1136L622 1139L618 1143L617 1147L619 1148L620 1151L619 1153L616 1153L615 1156L619 1157L622 1157L625 1157L630 1158L635 1157L636 1159L635 1161L633 1164L632 1165L629 1164z\"},{\"title\":\"Vikarabad\",\"d\":\"M243 1193L237 1189L243 1174L243 1165L242 1155L257 1158L267 1158L273 1152L274 1144L267 1136L273 1127L285 1129L293 1131L293 1122L304 1128L308 1115L317 1114L325 1103L335 1112L336 1103L338 1095L347 1093L357 1085L365 1080L366 1070L371 1062L361 1056L373 1054L379 1054L390 1054L400 1059L408 1060L410 1068L420 1072L434 1078L438 1089L448 1093L448 1102L451 1109L458 1102L464 1106L464 1114L470 1116L477 1116L480 1123L489 1126L489 1138L482 1140L477 1148L471 1155L467 1164L462 1171L467 1178L472 1179L481 1186L480 1195L485 1206L483 1214L480 1224L478 1236L469 1238L463 1248L457 1255L456 1262L444 1265L440 1273L429 1280L434 1288L441 1294L452 1300L460 1309L456 1318L464 1324L465 1331L465 1340L458 1344L453 1352L456 1358L451 1365L438 1344L428 1336L420 1334L417 1326L420 1319L415 1313L410 1322L403 1322L393 1318L394 1310L387 1306L377 1305L366 1302L367 1296L374 1287L369 1281L361 1280L352 1284L346 1288L338 1292L331 1291L325 1292L320 1296L314 1302L324 1302L319 1308L312 1309L312 1318L306 1324L299 1330L301 1338L292 1342L286 1341L280 1340L276 1331L270 1330L272 1324L260 1322L249 1320L254 1312L253 1304L262 1299L260 1289L255 1277L247 1267L244 1258L234 1258L226 1252L213 1250L211 1243L204 1238L209 1225L217 1223L223 1217L214 1215L226 1207L233 1199z\"},{\"title\":\"Rangareddy\",\"d\":\"M483 1211L483 1205L479 1193L479 1186L472 1179L464 1173L471 1159L481 1140L489 1140L489 1130L488 1122L482 1115L486 1107L484 1100L492 1096L494 1103L502 1106L508 1110L516 1109L520 1117L531 1119L537 1112L546 1109L544 1119L547 1126L554 1131L564 1133L575 1131L581 1120L580 1109L587 1107L583 1100L594 1103L600 1095L608 1096L611 1103L606 1111L612 1113L619 1120L622 1126L621 1133L618 1145L619 1151L616 1158L620 1158L626 1157L631 1159L636 1158L634 1162L632 1165L629 1164L626 1166L628 1169L631 1169L634 1167L637 1169L638 1170L639 1174L641 1173L642 1170L644 1170L645 1174L646 1176L645 1179L641 1180L642 1184L646 1187L649 1188L649 1182L652 1180L656 1178L662 1177L662 1172L668 1172L668 1169L665 1169L663 1167L663 1165L666 1163L668 1160L663 1157L665 1154L669 1155L672 1159L675 1159L676 1155L680 1156L684 1161L691 1160L694 1160L696 1153L706 1148L718 1152L729 1150L736 1142L749 1146L754 1150L752 1163L743 1167L749 1172L763 1172L764 1183L757 1186L760 1197L775 1207L787 1211L785 1219L779 1224L765 1219L773 1229L773 1239L771 1246L794 1259L785 1263L797 1275L795 1287L784 1292L771 1289L776 1295L789 1299L778 1303L776 1313L764 1311L755 1313L742 1315L739 1328L752 1333L757 1339L751 1345L752 1356L760 1361L767 1352L771 1361L774 1367L780 1373L777 1381L777 1394L761 1393L756 1403L748 1402L740 1404L739 1397L728 1397L722 1396L729 1389L733 1379L728 1371L723 1385L715 1393L707 1389L698 1385L685 1377L669 1375L655 1377L650 1383L649 1395L636 1391L627 1385L618 1389L611 1387L603 1385L595 1387L594 1377L592 1363L586 1353L580 1335L572 1335L572 1321L564 1318L557 1318L553 1326L546 1323L533 1313L532 1305L525 1299L517 1300L513 1306L505 1305L503 1311L495 1306L488 1302L478 1300L471 1299L464 1306L463 1312L456 1304L446 1299L436 1292L432 1282L439 1272L448 1264L458 1261L460 1251L467 1240L478 1238L480 1225z\"},{\"title\":\"Nalgonda\",\"d\":\"M1043 1165L1042 1170L1035 1167L1019 1167L1008 1169L995 1162L955 1161L953 1167L960 1173L958 1179L951 1176L945 1184L940 1199L933 1196L929 1202L920 1198L920 1191L914 1193L906 1193L901 1207L883 1201L866 1197L852 1191L851 1202L849 1213L847 1220L845 1229L852 1236L855 1243L848 1254L840 1251L840 1261L831 1266L822 1269L819 1280L815 1286L808 1281L797 1276L796 1287L783 1290L772 1288L776 1293L788 1297L781 1302L776 1312L764 1311L764 1317L752 1314L742 1316L738 1328L745 1329L758 1338L751 1345L751 1357L759 1360L767 1352L772 1359L772 1366L779 1372L779 1382L778 1389L774 1399L771 1405L764 1405L762 1420L754 1424L744 1432L745 1444L727 1442L732 1451L740 1459L746 1470L731 1481L727 1474L724 1486L714 1485L707 1492L721 1492L732 1491L745 1487L755 1489L772 1493L779 1498L788 1491L801 1484L807 1485L822 1483L828 1492L840 1503L855 1507L868 1513L881 1522L894 1524L900 1532L911 1538L921 1546L928 1553L942 1560L943 1548L944 1533L945 1524L953 1521L945 1511L948 1496L957 1491L960 1482L969 1477L979 1477L992 1473L1003 1475L1018 1476L1029 1472L1035 1460L1046 1454L1058 1451L1070 1453L1080 1449L1088 1443L1097 1436L1109 1442L1117 1434L1126 1428L1138 1416L1127 1408L1130 1396L1126 1378L1124 1365L1117 1352L1112 1340L1104 1330L1106 1311L1100 1304L1099 1292L1098 1284L1096 1270L1087 1254L1076 1239L1069 1228L1068 1217L1065 1205L1059 1199L1054 1183L1051 1173z\"},{\"title\":\"Suryapet\",\"d\":\"M1012 1100L1026 1106L1031 1097L1052 1099L1059 1106L1065 1107L1075 1096L1083 1105L1090 1103L1096 1105L1095 1092L1100 1106L1107 1105L1113 1111L1121 1107L1121 1116L1131 1121L1136 1123L1139 1126L1146 1132L1152 1132L1159 1130L1163 1135L1164 1142L1169 1143L1175 1148L1172 1152L1169 1156L1176 1163L1176 1174L1179 1176L1179 1181L1186 1189L1191 1196L1194 1192L1205 1199L1217 1203L1217 1210L1217 1217L1211 1220L1209 1230L1214 1236L1225 1251L1236 1249L1253 1268L1262 1276L1267 1280L1272 1284L1272 1293L1282 1300L1280 1304L1281 1313L1282 1318L1278 1323L1275 1336L1265 1340L1261 1352L1266 1360L1276 1362L1278 1371L1289 1375L1288 1380L1286 1389L1281 1394L1282 1402L1277 1411L1272 1419L1260 1420L1254 1432L1247 1448L1229 1453L1216 1449L1211 1429L1201 1423L1191 1427L1186 1427L1180 1423L1171 1414L1165 1416L1160 1415L1154 1429L1140 1428L1133 1427L1139 1416L1127 1412L1128 1405L1130 1390L1126 1381L1126 1366L1118 1358L1116 1345L1107 1338L1105 1324L1106 1309L1100 1301L1098 1289L1099 1282L1096 1278L1095 1268L1088 1258L1084 1247L1074 1238L1070 1229L1069 1218L1067 1206L1058 1200L1054 1183L1050 1172L1043 1166L1037 1161L1028 1153L1025 1147L1027 1140L1030 1134L1028 1129L1020 1125L1008 1111L1005 1108L1003 1104L1007 1104z\"},{\"title\":\"Naryanpet\",\"d\":\"M249 1320L255 1323L272 1325L268 1330L272 1334L276 1331L281 1337L281 1341L284 1343L289 1340L293 1341L300 1338L300 1333L303 1328L304 1324L309 1324L313 1317L312 1310L320 1307L323 1302L315 1303L317 1298L320 1296L326 1291L330 1291L336 1295L343 1294L348 1289L352 1289L354 1285L363 1279L371 1280L374 1285L373 1292L371 1296L367 1295L367 1300L366 1305L364 1309L366 1315L362 1321L362 1326L354 1328L357 1332L358 1338L357 1346L354 1353L356 1358L353 1363L359 1373L355 1378L358 1386L355 1389L345 1386L334 1388L331 1400L341 1403L356 1404L363 1415L359 1422L367 1423L366 1428L369 1440L379 1450L378 1456L374 1457L376 1469L375 1475L372 1477L361 1476L362 1484L367 1491L366 1497L362 1501L355 1501L361 1504L366 1505L365 1513L363 1517L358 1514L355 1518L359 1525L356 1529L358 1536L355 1542L353 1537L349 1530L346 1528L343 1538L344 1542L338 1542L332 1546L325 1547L325 1552L328 1557L327 1560L322 1560L318 1558L309 1560L304 1564L296 1564L289 1567L280 1563L273 1558L271 1553L257 1551L253 1553L245 1551L239 1553L231 1559L220 1555L214 1552L207 1552L198 1551L196 1547L187 1546L175 1541L170 1535L165 1525L157 1516L157 1512L162 1512L168 1512L175 1513L180 1509L181 1503L187 1504L193 1507L202 1505L208 1506L209 1500L214 1496L221 1494L227 1494L229 1487L220 1482L217 1478L219 1474L227 1475L233 1472L238 1469L247 1467L248 1464L250 1461L242 1456L249 1449L250 1442L242 1447L235 1448L231 1446L227 1441L230 1436L237 1433L240 1430L246 1431L249 1419L245 1418L241 1417L237 1420L232 1418L231 1414L235 1405L240 1398L236 1394L235 1388L242 1389L249 1389L250 1383L246 1380L244 1373L246 1364L243 1349L243 1340L243 1336L250 1335L248 1331L248 1324z\"},{\"title\":\"Mahabubnagar\",\"d\":\"M468 1491L462 1480L470 1475L464 1466L466 1455L477 1452L487 1455L500 1463L512 1466L512 1454L523 1444L515 1438L524 1420L528 1413L534 1413L534 1419L544 1420L551 1408L563 1414L580 1428L588 1431L597 1428L603 1423L608 1403L602 1396L601 1389L594 1386L595 1378L589 1374L592 1362L581 1352L580 1336L570 1334L572 1322L567 1319L557 1319L554 1328L549 1328L545 1322L540 1319L533 1315L535 1308L530 1302L517 1300L516 1306L509 1306L509 1311L499 1312L494 1305L485 1304L471 1299L464 1305L466 1311L461 1311L455 1320L466 1324L463 1330L466 1341L459 1345L453 1348L453 1353L457 1356L453 1364L449 1364L444 1356L436 1342L426 1333L420 1334L416 1332L419 1322L418 1316L414 1315L412 1322L408 1324L401 1320L392 1316L396 1312L386 1308L370 1306L364 1306L366 1313L360 1321L363 1324L355 1326L357 1329L358 1335L358 1343L356 1352L356 1358L352 1363L359 1372L354 1379L358 1386L354 1389L346 1386L334 1387L332 1400L343 1403L358 1406L363 1415L359 1423L367 1424L368 1434L373 1446L379 1451L375 1457L375 1463L377 1473L372 1477L361 1477L364 1487L367 1492L365 1500L356 1502L365 1506L364 1516L357 1516L358 1523L357 1529L363 1534L372 1532L378 1533L381 1540L391 1540L403 1532L407 1530L409 1526L420 1522L425 1526L429 1525L431 1518L435 1509L443 1507L448 1506L453 1502L456 1496L461 1489z\"},{\"title\":\"Nagarkurnool\",\"d\":\"M527 1412L533 1412L535 1423L542 1421L553 1409L572 1420L586 1431L598 1429L602 1408L607 1398L599 1387L616 1390L626 1385L632 1389L643 1391L652 1384L658 1374L675 1377L689 1383L705 1387L713 1391L727 1374L732 1387L724 1397L739 1401L752 1401L763 1393L774 1394L772 1405L764 1405L762 1421L750 1427L745 1443L725 1441L736 1456L746 1472L732 1484L728 1474L726 1485L716 1483L708 1495L720 1490L733 1490L753 1489L773 1493L781 1496L804 1483L824 1484L829 1494L836 1500L857 1508L873 1518L893 1522L901 1532L915 1540L927 1552L948 1562L954 1568L950 1592L949 1608L936 1618L925 1618L911 1613L903 1611L894 1612L879 1608L869 1608L856 1616L839 1619L822 1630L826 1639L828 1651L824 1665L817 1667L810 1648L801 1642L793 1644L798 1666L792 1675L780 1688L767 1696L754 1700L734 1691L719 1668L700 1667L683 1685L674 1683L651 1675L621 1676L611 1685L594 1689L588 1699L573 1695L559 1699L547 1699L549 1691L537 1686L535 1677L537 1667L545 1663L546 1651L552 1635L544 1624L542 1618L543 1609L550 1602L539 1599L531 1601L525 1587L535 1580L549 1575L561 1585L569 1571L580 1570L587 1559L584 1545L576 1541L564 1540L560 1534L549 1540L542 1540L541 1525L532 1523L518 1520L503 1509L505 1491L509 1474L513 1453L523 1443L515 1436L520 1426L525 1416z\"},{\"title\":\"Wanaparthy\",\"d\":\"M359 1534L367 1534L372 1531L377 1532L384 1541L395 1535L407 1530L406 1525L420 1522L426 1525L431 1521L435 1511L441 1506L447 1505L448 1502L455 1501L456 1497L460 1495L463 1489L469 1490L466 1485L461 1481L464 1476L469 1475L467 1468L462 1465L463 1460L466 1456L469 1456L479 1452L488 1455L493 1461L502 1464L509 1466L510 1470L508 1477L507 1482L504 1493L502 1505L502 1508L509 1512L521 1521L529 1522L541 1524L542 1539L553 1541L560 1535L563 1541L573 1542L582 1544L585 1547L586 1558L581 1564L579 1570L570 1571L566 1570L563 1587L549 1582L547 1575L541 1575L535 1578L530 1582L524 1589L531 1600L535 1600L551 1602L549 1609L543 1608L540 1612L542 1616L541 1621L545 1624L545 1631L551 1634L548 1642L546 1648L543 1659L546 1662L537 1666L537 1671L531 1671L533 1675L533 1679L540 1675L542 1680L538 1682L542 1683L538 1686L545 1688L548 1692L546 1697L553 1700L559 1699L565 1699L563 1714L558 1713L551 1723L525 1722L520 1716L519 1706L512 1700L494 1695L478 1686L475 1680L472 1676L467 1672L460 1666L453 1669L447 1664L439 1654L436 1648L434 1636L434 1626L428 1621L420 1614L416 1608L404 1602L399 1599L381 1588L372 1582L359 1572L353 1569L343 1567L338 1565L335 1562L331 1558L328 1558L328 1554L325 1553L324 1547L331 1548L344 1542L343 1538L346 1528L353 1533L354 1544L356 1540L360 1540z\"},{\"title\":\"Jogulamba Gadwal\",\"d\":\"M422 1614L432 1623L433 1636L439 1651L455 1668L464 1667L476 1677L488 1690L509 1701L520 1710L526 1722L551 1723L561 1713L563 1724L555 1734L536 1740L532 1751L531 1759L514 1760L514 1766L499 1768L489 1761L483 1754L479 1747L478 1738L470 1742L466 1757L453 1752L440 1751L427 1747L415 1741L409 1749L400 1750L388 1752L369 1750L357 1748L347 1747L335 1752L322 1750L307 1738L298 1739L287 1736L265 1731L269 1713L267 1697L268 1687L258 1684L252 1675L263 1655L257 1652L257 1633L261 1622L264 1612L258 1612L259 1600L265 1591L275 1593L283 1582L289 1579L295 1584L299 1576L296 1565L305 1560L315 1556L322 1556L331 1558L338 1563L347 1565L355 1569L365 1578L377 1584L389 1591L398 1599L413 1606z\"}]");


/** Image map titles on https://www.telangana.gov.in/about/districts/ → app district keys */ const $4bc5886b67e0c8cf$var$TITLE_TO_KEY = {
    Adilabad: "adilabad",
    "Kumuram Bheem": "komaram_bheem_asifabad",
    Nirmal: "nirmal",
    Mancherial: "mancherial",
    Nizamabad: "nizamabad",
    Jagital: "jagtial",
    Peddapalli: "peddapalli",
    Kamareddy: "kamareddy",
    "Rajanna Sircilla": "rajanna_sircilla",
    Karimnagar: "karimnagar",
    Jayashankar: "jayashankar_bhupalpally",
    Sangareddy: "sangareddy",
    Medak: "medak",
    Siddipet: "siddipet",
    Hanumakonda: "hanumakonda",
    Mulugu: "mulugu",
    "Medchal-Malkajgiri": "medchal_malkajgiri",
    "Yadadri Bhuvanagiri": "yadadri_bhuvanagiri",
    Jangaon: "jangaon",
    Warangal: "warangal",
    Mahabubabad: "mahabubabad",
    "Bhadradri Kothagudem": "bhadradri_kothagudem",
    Khammam: "khammam",
    Hyderabad: "hyderabad",
    Vikarabad: "vikarabad",
    Rangareddy: "rangareddy",
    Nalgonda: "nalgonda",
    Suryapet: "suryapet",
    Naryanpet: "narayanpet",
    Mahabubnagar: "mahbubnagar",
    Nagarkurnool: "nagarkurnool",
    Wanaparthy: "wanaparthy",
    "Jogulamba Gadwal": "jogulamba_gadwal"
};
const $4bc5886b67e0c8cf$export$8e9c23854d0b9047 = 1879;
const $4bc5886b67e0c8cf$export$55da85ab9139dcf3 = 1897;
const $4bc5886b67e0c8cf$export$5f32a4a97ebcad64 = (0, (/*@__PURE__*/$parcel$interopDefault($3b195aeddb255eb8$exports))).map((h)=>{
    const key = $4bc5886b67e0c8cf$var$TITLE_TO_KEY[h.title];
    return key ? {
        title: h.title,
        d: h.d,
        key: key
    } : null;
}).filter((x)=>x !== null);
const $4bc5886b67e0c8cf$export$457d25dc584f8ad0 = [
    "#dbeafe",
    "#fce7f3",
    "#d1fae5",
    "#fef3c7",
    "#e9d5ff",
    "#fed7aa",
    "#cffafe",
    "#fecaca",
    "#ddd6fe",
    "#a7f3d0",
    "#fde68a",
    "#bfdbfe",
    "#fbcfe8",
    "#bbf7d0",
    "#fde047",
    "#e0e7ff",
    "#fecdd3",
    "#99f6e4",
    "#fcd34d",
    "#c4b5fd",
    "#86efac",
    "#fdba74",
    "#bae6fd",
    "#f9a8d4",
    "#a5f3fc",
    "#fca5a5",
    "#c7d2fe",
    "#fde047",
    "#6ee7b7",
    "#fdba74",
    "#93c5fd",
    "#f0abfc",
    "#5eead4"
];
const $4bc5886b67e0c8cf$export$8bd24f3106bc8d52 = [
    "#ffffff",
    "#f8fafc",
    "#f1f5f9",
    "#e8eef4",
    "#e2e8f0",
    "#dbeafe",
    "#ede9fe",
    "#fce7f3",
    "#d1fae5",
    "#fef3c7",
    "#cffafe",
    "#fecaca",
    "#ddd6fe",
    "#bbf7d0",
    "#fde68a"
];



const $ec5d2c981391d238$export$94e7442ac4938ea2 = {
    "Rangareddy": [
        {
            "title": "Abdullapurmet",
            "d": "M267 462L268 463L269 463L270 463L271 463L271 463L273 463L273 463L273 463L273 464L273 464L273 464L273 465L273 465L273 465L273 466L273 466L273 467L273 467L273 467L272 468L272 468L271 468L271 469L270 469L270 469L270 469L270 469L270 469L270 469L270 469L269 469L269 469L268 469L266 469L265 469L265 470L265 470L265 471L265 471L264 472L264 473L264 474L264 475L263 477L263 478L263 478L262 479L263 479L264 480L265 480L267 481L268 480L268 480L269 480L270 479L269 479L269 478L271 478L272 478L272 478L272 478L273 478L273 478L273 478L273 478L274 478L274 478L274 479L274 479L274 479L278 479L279 480L279 482L279 482L280 482L282 481L282 481L282 481L283 481L283 480L284 480L284 480L285 479L287 479L287 478L288 477L288 477L289 476L290 477L290 476L291 476L291 476L293 477L294 476L294 476L294 476L295 475L295 475L295 474L295 474L295 474L294 473L294 473L294 473L293 472L293 472L293 471L293 471L293 471L294 471L294 471L294 471L294 471L294 471L294 471L294 471L295 470L296 470L296 470L296 470L296 469L296 468L296 468L295 467L295 466L295 465L295 465L295 465L295 465L295 465L294 465L294 465L292 466L292 466L292 465L292 466L292 466L292 466L291 466L291 466L290 465L290 465L289 465L288 464L288 464L288 464L288 464L288 463L288 463L288 462L288 462L289 461L291 462L291 462L291 461L291 461L292 460L292 458L292 457L292 457L292 456L292 456L291 456L291 456L290 455L290 454L290 454L289 453L289 453L288 453L287 454L287 454L287 454L286 454L285 453L285 453L285 453L285 453L284 452L284 452L283 453L282 453L282 455L282 455L282 456L282 456L280 457L280 457L278 456L278 456L277 456L277 456L276 456L276 456L276 456L276 456L275 456L275 456L273 455L273 455L273 455L272 455L270 455L269 455L269 455L268 455L267 455L267 456L267 456L267 456L267 457L267 457L267 458L267 458L267 458L267 458L267 459L267 459L267 460L268 460L268 460L268 461L267 462z"
        },
        {
            "title": "Amangal",
            "d": "M273 540L273 539L272 539L272 539L272 539L272 539L270 539L270 539L270 539L270 539L270 540L270 540L269 541L269 541L267 541L266 540L264 540L264 540L263 540L263 539L263 539L262 538L262 538L262 538L261 537L260 537L260 537L259 535L257 535L257 535L256 535L256 536L254 537L253 537L252 537L251 537L251 537L252 539L252 539L252 540L253 540L251 544L251 544L251 545L250 545L250 546L250 546L251 546L251 546L250 546L250 546L250 547L250 548L250 550L250 552L250 553L251 553L253 552L253 552L254 552L255 553L256 554L257 554L258 553L258 552L259 553L260 553L260 553L261 553L261 554L262 554L262 554L262 554L263 554L263 555L264 555L264 555L266 556L266 556L266 556L267 557L268 558L271 557L271 557L272 556L271 555L272 554L271 553L272 553L272 551L273 550L273 550L273 549L272 549L270 548L269 548L268 548L267 548L267 548L266 548L266 547L265 546L266 546L268 546L270 545L270 545L270 545L270 544L270 544L271 544L271 544L271 544L272 544L273 544L273 544L273 544L273 543L273 543L273 543L273 543L274 541L274 541L274 541L274 541L274 540L274 540L273 540L273 540z"
        },
        {
            "title": "Balapur",
            "d": "M261 464L260 464L260 464L260 464L259 464L259 463L259 463L258 463L258 463L258 463L257 463L257 463L256 463L256 463L256 463L256 464L257 465L256 464L254 464L254 465L254 466L254 467L254 467L253 467L253 466L252 466L252 467L252 467L251 467L251 467L251 467L251 467L251 467L250 467L250 467L250 467L249 468L249 468L249 468L249 468L248 469L248 469L248 470L248 471L248 471L246 471L246 470L245 470L244 470L242 470L242 470L242 471L241 472L242 473L243 475L242 475L241 475L241 474L241 473L241 473L241 474L240 474L240 474L241 475L241 475L241 475L240 476L240 476L239 476L238 478L238 478L239 478L241 478L241 479L241 479L240 480L240 479L240 480L239 480L239 480L239 480L239 480L239 480L238 480L238 480L238 480L238 480L238 480L238 481L239 481L239 481L240 481L242 482L243 482L244 482L245 482L245 482L246 481L246 481L247 481L247 481L248 481L248 481L250 482L251 482L251 482L253 482L254 482L254 481L255 480L256 480L256 480L257 481L257 480L257 480L258 480L258 480L259 480L259 479L259 479L260 479L261 479L263 479L262 479L263 478L263 478L263 477L264 475L264 474L264 473L264 472L265 471L265 471L265 470L265 470L265 469L263 468L262 468L262 468L262 468L261 468L260 467L259 466L259 466L259 466L259 466L258 466L258 465L258 465L258 465L258 466L258 466L258 466L258 466L258 465L258 465L258 465L258 464L261 465L261 464z"
        },
        {
            "title": "Chevella",
            "d": "M201 456L200 456L200 456L200 456L200 455L200 455L199 454L199 454L198 454L197 453L197 453L196 453L196 452L196 451L196 450L195 450L195 450L194 450L193 450L193 450L192 450L192 450L192 451L192 451L192 452L191 452L191 453L191 454L190 454L190 454L191 454L191 454L191 455L192 455L192 455L192 456L192 456L192 457L191 456L191 457L191 457L190 457L190 457L190 457L189 457L189 457L188 457L187 457L187 457L187 457L187 458L187 458L186 458L185 458L185 458L184 458L185 458L185 457L184 457L184 456L184 456L184 455L183 454L183 454L181 454L181 454L180 453L180 454L180 454L179 454L179 454L179 454L178 454L177 454L177 454L176 454L176 453L176 454L176 454L176 454L176 454L176 455L175 456L174 457L174 457L175 458L175 458L174 458L174 458L174 458L174 460L173 460L173 460L173 461L173 461L172 462L172 462L171 463L171 463L171 464L172 465L172 465L172 465L173 467L173 467L173 467L174 467L175 467L175 468L176 469L176 469L177 469L177 470L178 470L178 470L178 471L178 472L177 473L177 473L178 474L178 474L178 475L178 475L178 475L179 476L179 476L179 476L179 477L180 477L180 478L180 478L180 478L179 478L179 478L179 479L180 479L180 479L180 479L180 479L180 479L180 480L180 480L180 480L180 481L180 481L181 481L182 481L182 480L182 480L182 479L183 478L185 478L185 478L187 477L188 476L190 476L191 477L191 478L191 478L192 479L192 479L192 479L192 479L193 479L194 479L194 479L194 480L195 480L195 480L195 480L196 480L196 479L197 479L197 479L197 479L198 479L199 478L199 478L199 479L200 479L200 479L200 479L200 479L201 479L201 479L201 479L202 479L203 479L203 479L203 478L202 478L202 477L202 476L202 475L202 475L203 474L203 474L203 474L203 474L203 473L202 473L202 471L202 471L202 470L202 470L201 469L202 468L202 468L203 468L204 467L204 467L206 467L206 466L206 466L206 465L206 464L207 463L207 463L207 463L207 462L207 462L207 462L207 461L207 461L207 461L207 461L206 461L203 460L203 460L201 459L201 459L201 458L201 458L201 458L200 458L200 457L201 456z"
        },
        {
            "title": "Chowdergudem",
            "d": "M168 498L168 499L169 500L169 500L168 502L168 503L167 503L167 503L166 503L166 503L165 503L165 503L165 503L163 503L163 504L163 503L162 503L162 504L161 505L161 506L161 506L161 507L161 507L161 508L160 507L159 508L159 508L159 508L159 508L159 508L159 508L159 508L158 508L158 509L158 509L157 509L157 509L157 509L157 510L157 511L157 511L157 512L157 512L158 512L158 512L158 512L158 512L158 512L158 513L158 513L158 513L158 513L158 513L158 514L158 514L158 514L158 515L158 515L158 515L158 515L158 515L159 516L159 516L159 516L159 516L159 516L159 516L159 516L159 516L160 517L160 517L161 517L161 517L161 517L161 518L161 518L162 519L163 518L164 518L164 518L165 518L166 519L166 520L166 520L166 520L167 520L167 521L168 521L168 521L168 522L168 522L169 522L169 523L169 523L169 524L169 524L171 524L172 523L171 522L171 521L171 521L172 521L171 521L172 521L172 520L174 519L174 518L174 518L174 518L174 517L174 514L174 514L174 513L173 513L173 513L173 512L173 512L173 512L174 511L173 511L173 510L172 510L172 509L172 509L172 508L172 508L172 508L172 507L172 507L173 505L173 504L172 504L172 502L171 502L171 502L172 502L171 502L172 502L172 501L172 500L172 500L172 500L173 500L173 500L173 500L175 499L175 500L176 499L176 499L176 499L176 498L176 498L176 497L176 497L176 497L175 497L175 497L175 496L174 496L173 496L173 495L172 495L172 495L172 495L172 495L172 495L171 495L171 495L171 495L170 495L170 496L169 498L169 498L168 498z"
        },
        {
            "title": "Farooqnagar",
            "d": "M200 501L200 501L199 501L199 501L198 502L199 503L199 503L199 504L199 505L199 506L199 506L196 505L196 505L196 505L195 505L194 504L193 504L192 504L192 503L190 503L189 503L189 503L188 504L188 504L188 504L187 505L186 506L185 507L185 507L185 508L185 508L185 509L185 509L185 509L185 511L185 511L185 512L184 512L183 512L182 512L182 511L182 512L181 513L181 514L181 514L181 514L181 516L181 516L181 516L181 516L182 516L183 516L182 518L182 519L181 520L181 520L181 521L182 521L183 521L184 522L184 522L184 523L184 524L185 524L186 524L186 524L187 524L187 524L189 524L190 524L189 524L189 522L190 522L191 522L192 523L192 519L193 519L196 519L196 519L197 519L197 520L197 520L197 520L198 520L198 520L198 520L198 521L199 521L200 522L200 523L200 523L200 524L199 525L199 526L200 526L200 526L201 527L202 529L202 529L203 529L204 529L204 529L204 529L204 530L204 530L205 531L205 531L206 532L208 531L208 530L209 528L209 527L211 528L212 528L213 527L214 528L214 525L215 523L214 522L214 522L214 522L213 522L211 521L211 520L210 519L211 518L212 517L212 517L213 517L213 518L214 518L215 518L215 518L216 518L217 519L217 519L218 519L218 518L218 517L218 516L218 516L218 516L218 516L219 516L219 515L220 514L221 513L222 513L222 513L222 512L221 511L221 511L220 511L219 511L218 510L216 510L216 509L216 508L216 508L215 508L215 508L215 508L214 508L214 508L214 508L213 507L212 507L211 507L211 506L211 505L209 504L209 503L208 503L208 503L207 503L207 503L207 503L207 503L207 503L207 504L206 504L206 504L206 504L206 503L205 503L206 502L205 502L205 502L205 502L204 502L203 502L200 501z"
        },
        {
            "title": "Gandipet",
            "d": "M237 451L237 451L236 451L236 450L235 450L235 450L234 450L234 450L233 450L233 449L233 450L232 450L232 450L232 450L232 450L232 451L231 450L230 450L230 450L230 450L229 450L229 451L229 451L227 450L225 449L225 448L225 448L225 448L223 447L221 447L221 447L219 446L218 447L218 447L218 447L217 447L217 447L217 447L216 447L215 447L215 447L215 447L215 448L215 448L216 448L216 449L216 450L217 450L217 450L217 450L217 450L217 450L217 451L218 451L218 451L218 453L218 453L218 454L218 455L217 455L217 454L217 454L216 454L216 453L216 453L215 453L215 453L215 454L215 454L214 454L213 453L213 453L212 453L212 452L211 452L211 452L210 452L210 452L210 452L210 453L210 453L209 453L209 453L209 453L209 453L209 453L208 452L208 452L208 452L208 453L209 453L209 453L210 453L210 453L210 453L211 453L211 453L212 454L213 454L213 454L213 455L212 456L213 456L213 456L213 456L213 456L213 455L214 455L214 455L215 456L215 456L216 456L217 457L218 457L218 458L218 459L218 459L218 459L217 459L217 460L218 460L218 460L218 460L219 461L219 461L219 461L219 461L219 461L219 460L219 460L219 460L220 459L220 459L220 459L221 459L221 459L220 459L220 458L221 458L221 458L221 458L221 459L221 459L221 459L221 459L221 460L221 460L221 460L221 460L221 461L222 462L222 461L222 461L223 461L223 461L223 461L223 460L222 460L222 460L223 459L223 459L223 458L223 458L224 458L224 458L223 458L223 457L224 458L224 457L224 457L225 458L224 459L225 459L225 459L226 459L226 460L226 460L227 460L228 461L228 461L228 462L227 462L227 462L227 463L227 463L227 463L228 463L229 463L229 463L229 463L229 463L229 464L230 464L230 464L230 464L230 464L231 464L231 464L231 464L231 464L232 464L232 464L232 464L232 464L232 464L232 465L232 465L234 465L235 465L235 465L235 465L236 465L236 464L236 463L236 463L236 462L237 461L238 460L238 460L238 459L238 459L238 459L238 459L238 459L238 459L239 458L239 458L239 458L240 458L240 458L240 458L240 458L239 458L239 458L238 457L238 457L238 458L237 457L237 458L237 458L237 458L236 458L236 458L235 458L234 457L234 457L234 457L234 456L234 455L235 456L236 456L236 456L236 455L236 455L236 454L235 454L235 454L235 454L235 454L235 454L235 453L235 453L235 453L235 452L236 452L236 452L236 451L237 451z"
        },
        {
            "title": "Hayathnagar",
            "d": "M265 469L266 469L268 469L269 469L269 469L270 469L270 469L270 469L270 469L270 469L270 469L270 469L271 469L271 468L272 468L272 468L273 467L273 467L273 467L273 466L273 466L273 465L273 465L273 465L273 464L273 464L273 464L273 463L273 463L273 463L271 463L271 463L270 463L269 463L268 463L267 462L267 462L266 462L265 462L265 463L265 464L265 464L264 463L264 463L264 463L263 463L263 463L262 463L262 463L261 463L260 462L260 463L261 464L261 465L258 464L258 465L258 465L258 465L258 466L258 466L258 466L258 466L258 465L258 465L258 465L258 466L259 466L259 466L259 466L259 466L260 467L261 468L262 468L262 468L262 468L263 468L265 469z"
        },
        {
            "title": "Ibrahimpatnam",
            "d": "M305 486L305 483L304 482L302 481L301 480L300 480L299 480L298 479L298 480L297 479L295 477L294 476L294 476L293 477L291 476L291 476L290 476L290 477L289 476L288 477L288 477L287 478L287 479L285 479L284 480L284 480L283 480L283 481L282 481L282 481L282 481L280 482L279 482L279 482L279 480L278 479L274 479L274 479L274 479L274 478L274 478L273 478L273 478L273 478L273 478L272 478L272 478L272 478L271 478L269 478L269 479L270 479L269 480L268 480L268 480L267 481L265 480L264 480L263 479L261 479L260 479L259 479L259 479L259 480L258 480L258 480L257 480L257 480L257 481L256 481L256 481L256 482L256 482L255 483L256 483L256 483L257 483L257 483L257 483L258 483L258 483L259 483L259 483L259 483L259 483L259 485L259 485L259 486L258 486L258 488L257 489L257 489L257 490L257 490L256 492L258 493L259 494L261 494L261 495L261 495L261 495L262 495L263 495L263 495L263 495L263 495L264 495L264 495L264 495L265 496L266 496L266 496L267 497L267 497L267 497L266 497L266 497L266 497L266 498L266 498L266 498L267 498L268 499L269 499L271 501L272 502L273 502L274 502L275 502L276 501L276 501L278 501L278 500L278 500L278 500L278 499L279 498L279 497L280 497L280 497L280 497L279 496L279 495L280 493L282 493L282 493L282 493L283 492L284 491L284 490L284 490L284 488L286 488L286 489L286 489L286 489L286 489L286 490L286 490L287 490L287 490L290 491L290 491L291 491L291 490L291 490L292 490L292 489L292 489L293 489L293 489L294 489L294 489L294 489L295 488L296 488L297 488L297 487L296 486L296 485L297 486L299 487L300 487L302 488L303 488L303 488L303 487L303 486L304 486L305 486L305 486z"
        },
        {
            "title": "Kadthal",
            "d": "M262 525L262 524L261 524L261 524L259 524L258 524L258 524L258 523L257 523L256 523L255 522L255 522L255 521L254 521L254 521L253 520L253 520L252 520L251 519L251 519L251 519L251 519L251 520L251 520L250 521L250 521L249 522L249 522L249 522L249 522L249 523L248 523L248 523L247 524L247 524L247 524L247 524L247 524L246 524L245 524L246 523L246 523L245 523L245 522L244 522L243 521L243 521L241 520L241 520L239 519L238 519L238 520L238 520L236 524L236 524L236 525L236 526L236 526L236 527L237 527L236 528L236 528L236 528L236 528L236 528L237 528L238 528L240 528L240 529L240 529L242 530L243 531L244 531L244 532L243 533L243 534L243 534L243 535L243 535L248 536L249 536L250 537L251 537L252 537L253 537L254 537L256 536L256 535L257 535L257 535L259 535L260 537L260 537L261 537L262 538L262 538L262 538L263 539L263 539L263 540L264 540L264 540L266 540L267 541L269 541L269 541L270 540L270 540L270 539L270 539L270 539L270 539L272 539L272 539L272 539L272 539L273 539L273 540L273 540L273 539L274 538L274 538L276 539L276 538L276 538L277 538L277 538L278 538L278 538L279 538L279 537L279 536L279 535L280 532L280 532L279 531L277 530L278 529L278 529L277 529L276 529L275 529L274 529L271 528L267 530L264 529L264 528L264 528L263 526L262 525z"
        },
        {
            "title": "Kandukur",
            "d": "M256 492L256 493L255 492L255 492L254 492L254 491L253 491L252 491L252 492L252 492L252 492L249 493L249 494L249 496L249 497L250 497L251 500L251 502L251 503L250 503L250 503L249 503L249 504L249 504L248 504L246 503L245 503L245 503L245 505L245 506L245 506L245 506L244 506L244 506L244 506L244 506L242 506L242 506L242 506L242 506L243 503L244 503L244 503L243 503L242 503L241 503L240 503L239 503L239 503L239 503L237 504L237 504L237 504L237 504L237 505L237 505L237 505L236 505L236 505L237 506L237 506L237 507L237 508L236 508L235 509L235 509L235 509L235 511L235 511L234 511L234 512L234 512L233 512L233 513L233 513L232 514L232 515L232 517L232 517L233 517L233 518L235 518L235 518L236 519L236 519L238 519L239 519L241 520L241 520L243 521L243 521L244 522L245 522L245 523L246 523L246 523L245 524L246 524L247 524L247 524L247 524L247 524L247 524L248 523L248 523L249 523L249 522L249 522L249 522L249 522L250 521L250 521L251 520L251 520L251 519L251 519L251 519L251 519L252 520L253 520L253 520L254 521L254 521L255 521L255 522L255 522L256 523L257 523L258 523L258 524L258 524L259 524L261 524L261 524L262 524L262 525L263 524L263 523L263 523L263 523L262 522L261 519L261 519L260 519L261 519L260 519L260 519L260 519L260 518L260 518L260 518L260 518L260 517L260 516L260 515L262 515L264 515L264 515L265 515L265 515L267 516L267 515L267 515L267 514L268 514L268 513L268 513L268 512L267 512L267 511L267 510L267 510L268 510L268 509L268 510L269 509L269 507L269 506L270 506L270 505L270 505L270 505L270 503L271 502L271 501L269 499L268 499L267 498L266 498L266 498L266 498L266 497L266 497L266 497L267 497L267 497L267 497L266 496L266 496L265 496L264 495L264 495L264 495L263 495L263 495L263 495L263 495L262 495L261 495L261 495L261 495L261 494L259 494L258 493L256 492z"
        },
        {
            "title": "Keshampeta",
            "d": "M230 514L229 514L228 514L227 513L227 513L227 513L226 513L225 514L225 514L225 514L225 514L223 514L222 513L222 513L222 513L222 513L221 513L220 514L219 515L219 516L218 516L218 516L218 516L218 516L218 517L218 518L218 519L217 519L217 519L216 518L215 518L215 518L214 518L213 518L213 517L212 517L212 517L211 518L210 519L211 520L211 521L213 522L214 522L214 522L214 522L215 523L214 525L214 528L215 529L215 531L214 532L214 533L215 535L217 535L219 535L219 535L219 536L219 538L219 538L219 538L219 539L219 539L219 539L219 541L219 541L219 542L219 542L221 543L222 544L222 544L222 545L222 545L222 546L222 546L222 546L223 547L224 547L224 547L225 547L225 546L225 545L226 543L226 542L227 542L227 542L228 542L229 542L230 543L232 542L232 541L232 540L234 541L235 538L232 536L231 536L231 535L231 534L231 534L231 534L231 534L231 533L231 533L231 533L231 532L232 531L232 531L233 532L233 532L233 532L233 532L233 531L234 532L234 531L234 531L234 531L235 531L235 531L235 530L235 530L236 530L236 530L236 529L236 529L236 529L236 529L236 529L236 528L236 528L236 528L236 528L237 527L236 527L236 526L236 526L236 525L236 524L236 524L238 520L238 520L238 519L236 519L236 519L235 518L235 518L233 518L233 517L232 517L232 517L232 517L231 517L231 517L231 517L231 516L231 516L230 516L230 515L230 515L230 515L230 514z"
        },
        {
            "title": "Kondurg",
            "d": "M186 506L186 506L186 506L186 505L185 505L185 504L185 503L184 503L184 502L183 502L183 502L183 502L183 502L183 501L183 501L183 500L183 499L184 499L184 498L185 498L185 498L185 498L186 497L186 497L185 497L185 496L185 496L185 495L185 493L185 493L183 492L184 491L184 491L184 491L184 491L184 490L183 489L182 489L182 488L182 489L182 489L181 489L180 489L179 489L178 489L178 488L177 488L177 489L177 490L177 491L177 492L177 492L175 492L174 492L174 492L173 492L172 492L172 494L172 494L172 495L172 495L172 495L172 495L172 495L172 495L173 495L173 496L174 496L175 496L175 497L175 497L176 497L176 497L176 497L176 498L176 498L176 499L176 499L176 499L175 500L175 499L173 500L173 500L173 500L172 500L172 500L172 500L172 501L172 502L171 502L172 502L171 502L171 502L172 502L172 504L173 504L173 505L172 507L172 507L172 508L172 508L172 508L172 509L172 509L172 510L173 510L173 511L174 511L173 512L173 512L173 512L173 513L173 513L174 513L174 514L174 514L174 517L174 518L174 518L174 518L175 519L175 519L176 519L176 519L176 519L176 520L177 520L178 520L179 521L179 521L179 521L180 520L181 520L181 520L181 520L182 519L182 518L183 516L182 516L181 516L181 516L181 516L181 516L181 514L181 514L181 514L181 513L182 512L182 511L182 512L183 512L184 512L185 512L185 511L185 511L185 509L185 509L185 509L185 508L185 508L185 507L185 507L186 506z"
        },
        {
            "title": "Kothur",
            "d": "M230 514L231 515L231 514L231 513L230 513L230 512L230 511L230 510L230 510L229 510L228 510L228 510L226 510L226 510L225 510L225 510L226 510L227 510L228 510L228 509L227 509L228 507L228 507L228 507L226 507L226 506L226 506L227 505L227 505L227 505L227 505L226 505L226 505L225 504L225 504L225 504L225 502L225 501L225 500L224 500L224 499L224 499L224 499L224 499L222 499L221 500L220 502L220 502L220 503L219 504L219 504L219 505L220 505L220 505L219 505L218 505L218 505L217 505L217 506L217 506L217 506L217 506L217 507L217 507L217 507L216 508L216 508L216 509L216 510L218 510L219 511L220 511L221 511L221 511L222 512L222 513L222 513L222 513L223 514L225 514L225 514L225 514L225 514L226 513L227 513L227 513L227 513L228 514L229 514L230 514zM220 496L219 496L219 496L219 494L220 493L220 491L220 491L219 491L219 491L219 490L218 490L218 490L218 489L218 489L218 488L218 488L217 488L218 488L218 487L218 487L218 487L218 486L218 486L217 486L218 486L218 485L218 485L218 485L218 485L218 484L218 484L216 483L214 482L213 482L213 483L214 483L214 483L213 484L213 485L213 485L213 485L213 486L213 486L212 487L211 487L211 487L210 487L210 487L208 487L207 487L207 487L206 487L206 486L205 487L205 489L205 490L205 489L206 489L206 489L206 489L207 489L207 489L207 489L207 489L207 488L207 488L207 488L207 488L207 488L207 487L207 487L207 488L208 488L208 487L208 487L208 487L208 488L208 490L208 490L208 491L208 491L208 491L208 491L208 491L208 491L208 491L208 491L207 491L207 491L207 491L207 492L207 492L207 492L207 492L206 492L206 492L205 492L205 492L204 492L204 493L204 493L205 493L205 493L206 494L207 494L207 495L208 495L211 496L212 496L212 496L212 496L212 496L213 496L213 496L214 497L215 497L215 497L216 498L217 498L217 498L218 498L220 498L220 498L220 496z"
        },
        {
            "title": "Madgul",
            "d": "M285 533L284 534L284 534L284 534L283 533L283 534L282 533L281 532L280 532L279 535L279 536L279 537L279 538L278 538L278 538L277 538L277 538L276 538L276 538L276 539L274 538L274 538L273 539L273 540L273 540L273 540L274 540L274 540L274 541L274 541L274 541L274 541L273 543L273 543L273 543L273 543L273 544L273 544L273 544L272 544L271 544L271 544L271 544L270 544L270 544L270 545L270 545L270 545L268 546L266 546L265 546L266 547L266 548L267 548L267 548L268 548L269 548L270 548L272 549L273 549L273 550L273 550L272 551L272 553L271 553L272 554L271 555L272 556L271 557L271 557L271 558L271 558L271 559L272 560L274 560L274 561L274 561L274 561L276 561L276 561L278 558L279 555L279 553L280 551L280 551L280 552L281 552L281 552L281 553L282 555L282 555L282 555L282 556L282 558L282 559L281 559L280 560L279 560L278 560L278 561L278 562L278 563L278 563L279 563L279 562L279 562L279 563L280 563L280 563L281 563L281 562L281 563L281 562L282 562L282 562L283 562L284 563L284 563L284 563L284 563L284 564L284 565L284 565L284 565L284 566L285 566L286 565L286 564L287 565L288 565L289 565L289 565L289 565L289 564L290 564L291 565L292 564L292 564L292 564L292 563L292 563L292 563L293 562L293 561L293 561L293 561L294 560L294 560L295 561L296 561L297 562L300 562L300 561L300 561L300 561L301 559L301 559L300 558L300 558L300 558L300 556L301 555L301 555L301 555L302 554L302 553L302 552L301 552L300 551L300 550L300 550L298 549L298 548L298 548L298 548L298 547L299 546L299 546L299 545L299 545L298 545L298 545L298 544L297 543L296 544L295 544L294 546L294 547L293 548L293 547L292 547L291 546L290 546L289 545L290 543L290 541L290 540L290 539L291 539L292 538L292 538L293 538L293 537L293 537L292 537L292 537L292 536L291 536L291 536L291 536L291 536L290 535L289 535L287 535L287 534L286 535L287 533L285 533z"
        },
        {
            "title": "Maheswaram",
            "d": "M256 492L257 490L257 490L257 489L257 489L258 488L258 486L259 486L259 485L259 485L259 483L259 483L259 483L259 483L258 483L258 483L257 483L257 483L257 483L256 483L256 483L255 483L256 482L256 482L256 481L256 481L257 481L256 480L256 480L255 480L254 481L254 482L253 482L251 482L251 482L250 482L248 481L248 481L247 481L247 481L246 481L246 481L245 482L245 482L244 482L243 482L242 482L242 482L242 483L242 483L242 484L242 484L242 485L242 485L242 486L242 486L242 487L241 488L241 489L240 490L240 489L239 489L238 489L237 488L236 488L235 488L234 488L232 488L232 488L232 489L231 489L229 489L228 489L228 489L228 488L228 488L227 488L227 488L227 489L226 492L225 493L226 493L224 493L224 493L224 493L223 493L224 493L223 494L222 495L222 496L221 496L221 496L220 496L220 496L220 496L220 498L220 498L220 499L221 499L222 499L224 499L224 499L224 499L224 499L224 500L225 500L225 501L225 502L225 504L225 504L225 504L226 505L226 505L227 505L227 505L227 505L227 505L226 506L226 506L226 507L228 507L228 507L228 507L227 509L228 509L228 510L227 510L226 510L225 510L225 510L226 510L226 510L228 510L228 510L229 510L230 510L230 510L230 511L230 512L230 513L231 513L231 514L231 515L230 514L230 515L230 515L230 515L230 516L231 516L231 516L231 517L231 517L231 517L232 517L232 517L232 517L232 517L232 515L232 514L233 513L233 513L233 512L234 512L234 512L234 511L235 511L235 511L235 509L235 509L235 509L236 508L237 508L237 507L237 506L237 506L236 505L236 505L237 505L237 505L237 505L237 504L237 504L237 504L237 504L239 503L239 503L239 503L240 503L241 503L242 503L243 503L244 503L244 503L243 503L242 506L242 506L242 506L242 506L244 506L244 506L244 506L244 506L245 506L245 506L245 506L245 505L245 503L245 503L246 503L248 504L249 504L249 504L249 503L250 503L250 503L251 503L251 502L251 500L250 497L249 497L249 496L249 494L249 493L252 492L252 492L252 492L252 491L253 491L254 491L254 492L255 492L255 492L256 493L256 492z"
        },
        {
            "title": "Manchal",
            "d": "M309 510L309 510L309 510L308 509L308 509L308 508L307 507L307 507L306 507L305 506L305 506L305 504L306 504L307 504L308 505L308 503L307 503L305 502L303 500L302 500L302 499L301 499L300 499L300 499L300 499L300 498L300 498L299 498L299 498L299 497L299 497L298 496L298 495L298 495L299 494L300 495L300 495L301 494L300 493L299 492L299 491L299 490L299 490L299 490L298 490L298 490L298 489L297 488L296 488L295 488L294 489L294 489L294 489L293 489L293 489L292 489L292 489L292 490L291 490L291 490L291 491L290 491L290 491L287 490L287 490L286 490L286 490L286 489L286 489L286 489L286 489L286 488L284 488L284 490L284 490L284 491L283 492L282 493L282 493L282 493L280 493L279 495L279 496L280 497L280 497L280 497L279 497L279 498L278 499L278 500L278 500L279 500L280 500L281 500L283 500L283 501L283 501L283 501L284 502L284 502L284 502L286 502L286 502L287 502L286 502L286 503L287 504L287 505L288 505L286 508L285 509L285 509L285 510L285 510L286 511L286 511L287 513L287 513L287 513L288 514L289 515L291 515L293 516L293 515L294 515L294 515L295 515L299 515L298 517L297 519L297 519L297 519L297 520L297 520L298 520L298 520L299 520L299 520L299 520L300 520L300 520L301 521L302 521L303 521L303 521L303 521L303 522L305 521L305 521L305 521L305 519L303 519L302 518L302 516L304 517L306 517L308 516L308 516L308 516L308 516L308 516L308 516L308 515L308 515L308 513L309 512L309 510z"
        },
        {
            "title": "Moinabad",
            "d": "M232 465L232 464L232 464L232 464L232 464L232 464L231 464L231 464L231 464L231 464L230 464L230 464L230 464L230 464L229 464L229 463L229 463L229 463L229 463L228 463L227 463L227 463L227 463L227 462L227 462L228 462L228 461L228 461L227 460L226 460L226 460L226 459L225 459L225 459L224 459L225 458L224 457L224 457L224 458L223 457L223 458L224 458L224 458L223 458L223 458L223 459L223 459L222 460L222 460L223 460L223 461L223 461L223 461L222 461L222 461L222 462L221 461L221 460L221 460L221 460L221 460L221 459L221 459L221 459L221 459L221 458L221 458L221 458L220 458L220 459L221 459L221 459L220 459L220 459L220 459L219 460L219 460L219 460L219 461L219 461L219 461L219 461L219 461L218 460L218 460L218 460L217 460L217 459L218 459L218 459L218 459L218 458L218 457L217 457L216 456L215 456L215 456L214 455L214 455L213 455L213 456L213 456L213 456L213 456L212 456L213 455L213 454L213 454L212 454L211 453L211 453L210 453L210 453L210 453L209 453L209 453L208 453L208 452L208 452L208 452L208 453L207 453L207 453L206 453L206 453L206 453L206 453L205 454L205 454L205 454L205 455L205 455L203 456L202 456L202 456L202 456L201 456L200 457L200 458L201 458L201 458L201 458L201 459L201 459L203 460L203 460L206 461L207 461L207 461L207 461L207 461L207 462L207 462L207 462L207 463L207 463L207 463L206 464L206 465L206 466L206 466L206 467L204 467L204 467L203 468L202 468L202 468L201 469L202 470L202 470L202 471L202 471L202 473L203 473L203 474L203 474L203 474L203 474L202 475L202 475L202 476L202 477L202 478L203 478L203 479L203 479L203 479L204 479L204 479L204 479L204 479L205 479L206 478L207 478L208 478L209 478L209 478L210 478L210 478L210 478L211 479L211 479L211 479L211 479L211 478L212 478L212 478L213 478L213 477L213 478L214 477L214 477L215 477L215 477L216 477L216 476L216 476L216 476L217 476L217 476L218 475L218 475L219 474L219 474L220 474L220 474L220 474L221 474L221 474L221 474L221 474L221 475L222 474L222 474L222 474L222 474L223 474L223 473L223 474L224 473L225 474L225 474L225 475L225 475L226 475L226 475L226 475L226 474L226 474L225 473L226 473L226 473L227 473L227 473L227 473L227 472L228 473L228 472L228 471L228 471L228 472L229 472L229 472L229 472L229 473L230 472L230 473L230 473L230 473L230 473L230 472L229 471L229 470L230 471L230 470L230 469L231 470L231 469L232 469L232 470L232 470L232 470L232 470L232 469L232 469L232 469L232 469L232 469L232 469L232 468L232 468L231 468L231 467L232 467L232 467L232 467L232 467L232 466L232 466L232 465L232 465z"
        },
        {
            "title": "Nandigama",
            "d": "M220 498L218 498L217 498L217 498L216 498L215 497L215 497L214 497L213 496L213 496L212 496L212 496L212 496L212 496L211 496L208 495L207 495L207 494L206 494L205 493L205 493L204 493L204 493L204 492L205 492L205 492L206 492L206 492L207 492L207 492L207 492L207 492L207 491L207 491L207 491L208 491L208 491L208 491L208 491L208 491L208 491L208 491L208 491L208 490L208 490L208 488L208 487L208 487L208 487L208 488L207 488L207 487L207 487L207 488L207 488L207 488L207 488L207 488L207 489L207 489L207 489L207 489L206 489L206 489L206 489L205 489L205 490L205 490L205 491L205 491L204 491L203 491L203 492L202 492L200 492L200 492L200 492L199 492L198 493L198 494L197 496L197 496L197 496L197 496L198 497L198 497L198 497L199 497L199 497L199 497L201 498L201 498L200 498L200 498L200 498L200 498L200 499L200 500L199 500L200 501L200 501L203 502L204 502L205 502L205 502L205 502L206 502L205 503L206 503L206 504L206 504L206 504L207 504L207 503L207 503L207 503L207 503L207 503L208 503L208 503L209 503L209 504L211 505L211 506L211 507L212 507L213 507L214 508L214 508L214 508L215 508L215 508L215 508L216 508L216 508L216 508L217 507L217 507L217 507L217 506L217 506L217 506L217 506L217 505L218 505L218 505L219 505L220 505L220 505L219 505L219 504L219 504L220 503L220 502L220 502L221 500L222 499L221 499L220 499L220 498z"
        },
        {
            "title": "Rajendranagar",
            "d": "M246 464L246 464L246 464L246 464L246 465L246 465L246 465L246 465L245 465L245 465L245 465L245 465L245 466L244 465L244 465L244 465L244 464L244 464L243 463L243 463L242 463L242 463L242 463L241 463L241 463L240 463L240 463L239 462L239 462L240 461L240 461L240 461L241 462L241 462L241 461L242 461L242 460L243 459L243 458L243 458L243 458L242 458L242 458L242 458L241 458L240 458L240 458L240 458L240 458L239 458L239 458L239 458L238 459L238 459L238 459L238 459L238 459L238 459L238 460L238 460L237 461L236 462L236 463L236 463L236 464L236 465L235 465L235 465L235 465L234 465L232 465L232 465L232 465L232 466L232 467L232 466L232 468L234 469L235 470L236 470L236 471L236 472L236 472L240 472L240 473L240 473L240 473L241 473L241 473L241 473L241 473L241 474L241 475L242 475L243 475L242 473L241 472L242 471L242 470L242 470L244 470L245 470L246 470L246 469L245 469L245 469L245 469L245 468L245 468L245 468L245 468L245 468L246 468L246 467L246 467L246 468L246 468L246 468L246 468L246 467L247 467L247 467L247 467L247 467L247 467L247 466L246 466L246 466L246 465L247 464L247 464L246 464z"
        },
        {
            "title": "Serilingampalle",
            "d": "M233 433L233 433L232 432L232 432L229 432L228 431L228 432L228 432L228 432L227 432L227 433L227 434L227 434L227 434L226 435L226 435L226 434L225 434L224 434L223 434L223 434L222 433L222 434L222 434L222 433L222 433L222 434L222 434L222 434L223 435L223 435L223 435L223 435L223 435L223 435L223 436L223 436L221 437L221 437L220 437L220 438L220 438L220 439L220 439L220 442L220 442L219 443L219 443L219 445L219 445L218 445L218 446L218 447L217 446L216 446L215 447L216 447L217 447L217 447L217 447L218 447L218 447L218 447L219 446L221 447L221 447L223 447L225 448L225 448L225 448L225 449L227 450L229 451L229 451L229 450L230 450L230 450L230 450L231 450L232 451L232 450L232 450L232 450L232 450L233 450L233 449L233 450L234 450L234 450L235 450L235 450L236 450L236 451L237 451L237 451L237 450L237 449L237 448L237 448L237 447L236 447L236 446L237 446L238 446L238 446L238 445L238 444L237 444L236 443L235 442L235 442L235 442L234 441L234 440L233 439L232 439L232 439L232 440L231 440L231 439L231 439L232 437L232 437L231 437L231 437L232 437L232 437L233 436L233 436L233 435L233 435L233 434L233 434L233 433z"
        },
        {
            "title": "Shabad",
            "d": "M203 479L202 479L201 479L201 479L201 479L200 479L200 479L200 479L200 479L199 479L199 478L199 478L198 479L197 479L197 479L197 479L196 479L196 480L195 480L195 480L195 480L194 480L194 479L194 479L193 479L192 479L192 479L192 479L192 479L191 478L191 478L191 477L190 476L188 476L187 477L185 478L185 478L183 478L182 479L182 480L182 480L182 481L181 481L180 481L180 481L179 481L179 481L179 481L179 483L179 484L179 484L179 485L178 485L178 486L178 486L178 487L178 488L178 488L177 488L178 488L178 489L179 489L180 489L181 489L182 489L182 489L182 488L182 489L183 489L184 490L184 491L184 491L184 491L184 491L183 492L185 493L185 493L185 495L185 496L185 496L185 497L186 497L186 497L185 498L185 498L185 498L184 498L184 499L183 499L183 500L183 501L183 501L183 502L183 502L183 502L183 502L184 502L184 503L185 503L185 504L185 505L186 505L186 506L186 506L186 506L187 505L188 504L188 504L188 504L189 503L189 503L190 503L192 503L192 504L193 504L194 504L195 505L196 505L196 505L196 505L199 506L199 506L199 505L199 504L199 503L199 503L198 502L199 501L199 501L200 501L200 501L200 501L199 500L200 500L200 499L200 498L200 498L200 498L200 498L201 498L201 498L199 497L199 497L199 497L198 497L198 497L198 497L197 496L197 496L197 496L197 496L198 494L198 493L199 492L200 492L200 492L200 492L202 492L203 492L203 491L204 491L205 491L205 491L205 490L205 490L205 489L205 487L206 486L206 487L207 487L207 487L208 487L210 487L210 487L211 487L211 487L212 487L213 486L213 486L213 485L213 485L212 485L211 484L210 484L210 484L210 483L210 483L209 483L209 483L209 482L209 481L209 480L208 479L209 479L209 479L210 479L210 478L210 478L210 478L209 478L209 478L208 478L207 478L206 478L205 479L204 479L204 479L204 479L204 479L203 479L203 479z"
        },
        {
            "title": "Shamshabad",
            "d": "M241 473L241 473L241 473L241 473L240 473L240 473L240 473L240 472L236 472L236 472L236 471L236 470L235 470L234 469L232 468L232 466L232 467L232 466L232 466L232 467L232 467L232 467L232 467L231 467L231 468L232 468L232 468L232 469L232 469L232 469L232 469L232 469L232 469L232 470L232 470L232 470L232 470L232 469L231 469L231 470L230 469L230 470L230 471L229 470L229 471L230 472L230 473L230 473L230 473L230 473L230 472L229 473L229 472L229 472L229 472L228 472L228 471L228 471L228 472L228 473L227 472L227 473L227 473L227 473L226 473L226 473L225 473L226 474L226 474L226 475L226 475L226 475L225 475L225 475L225 474L225 474L224 473L223 474L223 473L223 474L222 474L222 474L222 474L222 474L221 475L221 474L221 474L221 474L221 474L220 474L220 474L220 474L219 474L219 474L218 475L218 475L217 476L217 476L216 476L216 476L216 476L216 477L215 477L215 477L214 477L214 477L213 478L213 477L213 478L212 478L212 478L211 478L211 479L211 479L211 479L211 479L210 478L210 478L210 478L210 479L209 479L209 479L208 479L209 480L209 481L209 482L209 483L209 483L210 483L210 483L210 484L210 484L211 484L212 485L213 485L213 485L213 484L214 483L214 483L213 483L213 482L214 482L216 483L218 484L218 484L218 485L218 485L218 485L218 485L218 486L217 486L218 486L218 486L218 487L218 487L218 487L218 488L217 488L218 488L218 488L218 489L218 489L218 490L218 490L219 490L219 491L219 491L220 491L220 491L220 493L219 494L219 496L219 496L220 496L220 496L220 496L221 496L221 496L222 496L222 495L223 494L224 493L223 493L224 493L224 493L224 493L226 493L225 493L226 492L227 489L227 488L227 488L228 488L228 488L228 489L228 489L229 489L231 489L232 489L232 488L232 488L234 488L235 488L236 488L237 488L238 489L239 489L240 489L240 490L241 489L241 488L242 487L242 486L242 486L242 485L242 485L242 484L242 484L242 483L242 483L242 482L242 482L240 481L239 481L239 481L238 481L238 480L238 480L238 480L238 480L238 480L239 480L239 480L239 480L239 480L239 480L240 480L240 479L240 480L241 479L241 479L241 478L239 478L238 478L238 478L239 476L240 476L240 476L241 475L241 475L241 475L240 474L240 474L241 474L241 473L241 473z"
        },
        {
            "title": "Shankarpalle",
            "d": "M193 437L193 436L192 436L191 437L191 437L191 437L190 438L189 437L189 436L189 436L188 436L188 436L188 436L186 435L186 435L186 435L185 435L185 435L184 432L183 431L182 433L182 433L181 433L180 433L180 434L181 434L182 434L181 435L181 436L181 436L181 437L180 437L179 437L179 439L179 439L179 439L180 440L180 440L180 440L180 440L181 440L181 440L181 442L181 442L182 442L182 442L182 442L182 442L182 442L181 443L181 443L181 444L182 444L182 444L182 444L182 445L182 445L182 446L182 446L182 446L183 447L182 447L182 448L182 449L182 449L182 450L182 450L181 450L181 450L180 450L180 450L179 450L179 450L179 451L178 452L178 452L177 453L176 453L176 454L177 454L177 454L178 454L179 454L179 454L179 454L180 454L180 454L180 453L181 454L181 454L183 454L183 454L184 455L184 456L184 456L184 457L185 457L185 458L184 458L185 458L185 458L186 458L187 458L187 458L187 457L187 457L187 457L188 457L189 457L189 457L190 457L190 457L190 457L191 457L191 457L191 456L192 457L192 456L192 456L192 455L192 455L191 455L191 454L191 454L190 454L190 454L191 454L191 453L191 452L192 452L192 451L192 451L192 450L192 450L193 450L193 450L194 450L195 450L195 450L196 450L196 451L196 452L196 453L197 453L197 453L198 454L199 454L199 454L200 455L200 455L200 456L200 456L200 456L201 456L202 456L202 456L202 456L203 456L205 455L205 455L205 454L205 454L205 454L206 453L206 453L206 453L206 453L207 453L207 453L208 453L208 452L208 452L208 452L209 453L209 453L209 453L209 453L209 453L210 453L210 453L210 452L210 452L210 452L211 452L211 452L212 452L212 453L213 453L213 453L214 454L215 454L215 454L215 453L215 453L216 453L216 453L216 454L217 454L217 454L217 455L218 455L218 454L218 453L218 453L218 451L218 451L217 451L217 450L217 450L217 450L217 450L217 450L216 450L216 449L216 448L215 448L215 448L215 447L215 447L215 447L214 447L213 447L212 447L212 448L211 447L209 447L209 447L209 447L208 446L208 446L208 445L207 446L207 446L206 444L206 444L207 443L207 443L206 443L206 442L205 443L205 442L205 440L205 439L206 438L206 438L206 438L206 437L206 437L205 437L205 437L204 437L204 437L203 437L202 437L202 437L203 438L203 438L203 438L202 439L202 439L201 440L200 440L200 440L200 440L199 440L199 441L199 441L198 441L197 441L195 440L195 438L194 437L193 437z"
        },
        {
            "title": "Talakondapally",
            "d": "M251 537L250 537L249 536L248 536L243 535L243 535L243 534L243 534L243 533L244 532L244 531L243 531L242 530L240 529L240 529L240 528L238 528L237 528L236 528L236 528L236 529L236 529L236 529L236 529L236 529L236 530L236 530L235 530L235 530L235 531L235 531L234 531L234 531L234 531L234 532L233 531L233 532L233 532L233 532L233 532L232 531L232 531L231 532L231 533L231 533L231 533L231 534L231 534L231 534L231 534L231 535L231 536L232 536L235 538L234 541L232 540L232 541L232 542L230 543L229 542L228 542L227 542L227 542L226 542L226 543L225 545L225 546L225 547L224 547L224 547L223 548L223 548L223 549L223 551L223 551L222 551L223 552L224 552L224 553L224 554L224 555L224 556L224 556L224 556L224 556L224 557L225 557L225 558L226 558L227 558L226 558L226 557L227 557L228 557L228 557L228 557L229 557L229 557L230 557L231 557L231 558L232 558L232 559L232 559L233 559L233 559L233 559L234 558L234 558L235 557L235 557L237 556L238 557L238 557L239 558L239 558L240 559L241 560L244 560L245 560L246 560L247 560L247 560L247 560L247 560L247 560L247 559L247 558L247 556L248 555L248 554L248 553L249 553L249 553L249 553L249 553L250 553L250 552L250 550L250 548L250 547L250 546L250 546L251 546L251 546L250 546L250 546L250 545L251 545L251 544L251 544L253 540L252 540L252 539L252 539L251 537L251 537z"
        },
        {
            "title": "Yacharam",
            "d": "M303 522L303 521L303 521L303 521L302 521L301 521L300 520L300 520L299 520L299 520L299 520L298 520L298 520L297 520L297 520L297 519L297 519L297 519L298 517L299 515L295 515L294 515L294 515L293 515L293 516L291 515L289 515L288 514L287 513L287 513L287 513L286 511L286 511L285 510L285 510L285 509L285 509L286 508L288 505L287 505L287 504L286 503L286 502L287 502L286 502L286 502L284 502L284 502L284 502L283 501L283 501L283 501L283 500L281 500L280 500L279 500L278 500L278 500L278 501L276 501L276 501L275 502L274 502L273 502L272 502L271 501L271 502L270 503L270 505L270 505L270 505L270 506L269 506L269 507L269 509L268 510L268 509L268 510L267 510L267 510L267 511L267 512L268 512L268 513L268 513L268 514L267 514L267 515L267 515L267 516L265 515L265 515L264 515L264 515L262 515L260 515L260 516L260 517L260 518L260 518L260 518L260 518L260 519L260 519L260 519L261 519L260 519L261 519L261 519L262 522L263 523L263 523L263 523L263 524L262 525L263 526L264 528L264 528L264 529L267 530L271 528L274 529L275 529L276 529L277 529L278 529L278 529L277 530L279 531L280 532L280 532L281 532L282 533L283 534L283 533L284 534L284 534L284 534L285 533L284 533L285 533L285 532L285 532L286 531L286 529L285 528L286 527L286 527L287 528L288 528L289 527L290 527L291 527L294 528L295 528L295 527L295 527L295 527L295 526L295 525L296 526L296 526L297 526L298 526L298 525L298 526L298 526L298 526L298 526L300 526L300 526L301 524L301 523L302 522L302 522L303 522L303 522z"
        },
        {
            "title": "Saroornagar",
            "d": "M267 459L266 460L264 460L262 459L262 459L262 459L262 458L261 458L261 458L260 458L260 458L259 458L259 457L258 458L258 458L258 458L258 458L258 458L258 458L258 458L258 458L258 458L257 458L257 458L258 457L258 457L258 456L257 457L257 457L257 457L257 457L256 457L256 457L255 456L255 456L255 456L255 457L255 459L256 459L256 459L256 459L257 460L256 461L256 461L255 461L254 462L254 462L254 463L255 463L256 463L257 463L257 463L258 463L258 463L258 463L259 463L259 463L259 464L260 464L260 464L260 464L261 464L260 463L260 462L261 463L262 463L262 463L263 463L263 463L264 463L264 463L264 463L265 464L265 464L265 463L265 462L266 462L267 462L267 462L268 461L268 460L268 460L267 460L267 459z"
        }
    ],
    "Nagarkurnool": [
        {
            "title": "Achampet",
            "d": "M345 618L344 618L342 616L341 615L339 615L338 614L335 613L332 610L331 610L329 609L329 609L328 609L327 608L324 607L324 607L322 605L321 605L321 603L320 602L320 602L320 600L319 600L319 600L317 600L316 600L315 600L314 601L313 601L312 601L310 600L310 600L308 601L307 601L307 601L303 604L302 605L302 606L301 606L300 606L299 606L298 604L297 605L296 606L296 607L295 607L295 608L294 608L293 609L293 609L293 609L291 609L291 609L290 609L289 608L288 608L288 608L288 610L288 611L288 611L288 612L288 613L289 613L289 613L289 614L290 614L291 614L292 614L293 614L291 615L291 615L291 615L291 615L289 615L288 615L288 615L287 616L287 616L287 616L286 616L286 616L286 616L285 616L284 616L284 616L284 615L284 615L284 614L284 613L283 613L283 613L283 613L282 613L281 613L281 614L281 615L281 615L281 615L281 617L281 617L280 617L280 617L279 617L278 616L278 616L277 616L277 616L277 616L277 616L276 616L276 616L276 615L276 615L275 616L275 616L274 615L273 615L273 615L273 616L273 617L273 617L273 618L274 619L274 619L272 619L270 619L270 620L270 620L270 620L269 620L269 620L268 620L267 620L267 620L267 620L266 620L266 620L265 622L265 622L265 622L265 623L265 624L266 624L266 625L267 626L269 626L270 626L271 627L272 628L271 629L273 629L273 630L274 630L274 631L274 632L274 632L274 632L273 632L273 632L273 632L273 633L273 633L272 634L272 634L273 634L273 635L275 636L275 637L276 637L277 637L278 637L278 638L278 638L280 638L280 639L280 639L281 638L281 638L281 637L281 636L282 636L282 636L281 635L281 635L280 635L281 634L282 633L282 634L283 635L283 635L283 636L284 636L285 637L284 636L284 635L285 634L284 633L284 632L283 632L283 631L286 630L286 630L288 629L288 629L288 628L290 626L290 627L291 628L292 627L292 627L293 630L294 630L296 630L296 629L298 629L299 627L302 627L302 626L302 625L302 625L303 625L303 625L303 625L303 625L304 625L304 624L306 623L306 623L307 624L307 624L308 623L308 623L310 624L311 625L312 625L313 625L313 624L312 623L312 622L311 621L311 620L311 619L311 619L311 618L312 617L313 616L314 616L316 616L316 616L317 616L317 616L317 616L318 616L319 616L319 617L319 617L319 617L319 617L319 618L319 619L319 619L320 619L320 619L320 619L321 619L322 619L322 619L322 618L322 618L322 618L322 617L322 617L323 616L323 617L323 616L323 615L325 616L330 617L330 618L330 619L331 619L331 620L331 620L333 622L334 622L336 622L337 622L337 623L337 623L338 623L338 624L338 624L338 624L339 624L340 625L341 627L341 627L342 627L343 627L343 626L343 626L344 625L344 625L344 624L344 623L344 623L344 622L345 621L345 619L345 619L345 618z"
        },
        {
            "title": "Amrabad",
            "d": "M277 683L278 685L279 686L280 688L281 688L283 689L283 690L284 690L286 691L287 691L288 691L289 692L289 693L290 693L292 692L293 692L294 692L295 692L296 691L297 691L298 691L299 690L299 690L300 688L301 688L301 687L303 687L303 686L304 685L305 684L305 684L307 682L307 681L307 680L307 679L307 677L307 676L307 675L307 674L306 672L306 670L306 670L306 670L307 669L308 669L310 669L311 669L312 670L312 670L313 670L313 671L313 672L313 674L314 676L315 677L315 679L315 680L315 680L316 680L317 679L318 678L320 678L320 677L321 677L321 674L321 672L321 671L321 671L320 670L320 669L319 668L319 666L318 665L318 664L318 663L318 663L319 662L320 662L322 661L323 660L324 660L325 660L327 659L329 658L329 658L330 659L330 659L331 659L331 658L332 658L333 656L334 655L335 655L336 654L336 653L337 653L338 653L338 653L337 652L337 652L337 651L337 651L338 650L337 648L337 648L337 648L336 648L335 648L334 648L334 648L333 650L333 650L332 649L332 648L331 648L330 649L330 649L328 648L327 648L326 648L325 648L325 648L324 648L324 648L323 648L323 648L323 648L323 648L323 648L323 648L323 648L323 648L323 648L323 648L323 647L322 646L322 646L322 645L322 644L322 644L322 643L322 643L322 643L322 642L322 642L323 641L323 640L323 640L323 640L323 639L323 639L323 639L323 639L323 638L324 637L323 637L323 637L323 636L323 636L323 636L324 636L324 636L324 636L324 634L324 634L322 630L323 629L323 628L323 627L323 627L323 627L324 626L324 626L325 627L326 627L327 627L327 627L327 627L326 627L326 626L325 626L325 626L324 626L323 625L321 625L320 625L319 624L319 624L319 624L319 624L318 625L318 625L318 626L317 625L317 626L317 626L317 626L316 626L316 626L315 626L315 626L315 626L314 625L314 625L313 625L313 625L312 625L311 625L310 624L308 623L308 623L307 624L307 624L306 623L306 623L304 624L304 625L303 625L303 625L303 625L303 625L302 625L302 625L302 626L302 627L299 627L298 629L296 629L296 630L294 630L293 630L292 627L292 627L291 628L290 627L290 626L288 628L288 629L288 629L286 630L286 630L283 631L283 632L284 632L284 633L285 634L284 635L284 636L285 637L284 636L283 636L283 635L283 635L282 634L282 633L281 634L280 635L281 635L281 635L282 636L282 636L281 636L281 637L281 638L281 638L280 639L280 639L280 638L278 638L278 638L277 639L276 640L275 640L276 641L276 642L275 643L275 643L275 644L275 644L275 644L275 644L276 644L276 644L278 645L280 646L280 647L279 648L278 650L276 653L276 653L275 654L275 654L275 656L274 656L273 655L273 654L271 655L271 655L270 656L270 656L270 654L269 652L268 650L267 649L267 648L266 647L265 646L264 647L263 647L262 647L263 647L262 648L263 649L263 649L263 649L265 650L266 650L266 651L266 652L264 655L264 656L263 656L263 658L262 659L261 660L260 660L259 660L257 660L255 661L255 661L254 660L254 660L253 659L252 659L252 659L251 657L251 657L251 657L249 657L248 657L249 657L249 658L249 659L250 659L251 659L251 661L251 661L252 662L253 662L254 662L255 662L256 663L258 664L259 664L259 664L259 665L260 665L260 665L261 665L261 665L262 666L264 667L264 667L265 668L265 668L266 669L266 669L266 670L266 670L266 671L267 672L268 672L268 672L269 672L270 672L271 672L272 673L273 672L273 672L274 672L275 673L275 673L275 673L276 674L276 674L277 675L277 676L277 677L278 678L277 680L277 681L277 682L277 682L277 683z"
        },
        {
            "title": "Balmoor",
            "d": "M266 620L265 620L265 620L263 619L263 619L262 619L261 619L261 619L260 619L259 619L259 619L258 620L257 621L256 620L256 620L256 620L256 619L255 619L255 619L254 618L255 618L254 618L254 618L254 618L253 618L253 617L253 617L253 616L252 616L252 616L251 616L251 617L251 617L251 617L251 617L251 617L251 618L252 618L252 620L253 620L253 620L253 620L252 622L251 622L250 622L250 622L250 623L250 623L251 624L251 624L252 624L252 623L253 624L253 624L253 624L253 625L253 625L253 627L254 628L253 628L253 628L253 628L253 629L253 629L254 630L254 631L255 632L255 632L255 632L255 633L255 633L255 634L255 634L254 635L255 636L254 636L254 636L254 636L254 636L254 636L255 637L255 638L254 639L254 639L254 639L254 639L255 639L255 639L254 639L255 640L255 640L255 641L255 641L255 641L255 641L256 641L255 641L256 642L255 642L256 643L256 643L256 643L256 644L257 644L258 644L258 645L259 646L260 647L261 650L262 650L263 649L263 649L263 649L262 648L263 647L262 647L263 647L264 647L265 646L266 647L267 648L267 649L268 650L269 652L270 654L270 656L270 656L271 655L271 655L273 654L273 655L274 656L275 656L275 654L275 654L276 653L276 653L278 650L279 648L280 647L280 646L278 645L276 644L276 644L275 644L275 644L275 644L275 644L275 643L275 643L276 642L276 641L275 640L276 640L277 639L278 638L278 638L278 638L278 637L277 637L276 637L275 637L275 636L273 635L273 634L272 634L272 634L273 633L273 633L273 632L273 632L273 632L274 632L274 632L274 632L274 631L274 630L273 630L273 629L271 629L272 628L271 627L270 626L269 626L267 626L266 625L266 624L265 624L265 623L265 622L265 622L265 622L266 620z"
        },
        {
            "title": "Bijinapalle",
            "d": "M213 592L210 592L209 592L209 592L209 591L209 591L209 590L209 590L208 590L207 589L207 589L207 589L206 588L206 588L205 587L204 587L204 586L203 586L201 586L201 585L201 589L201 589L201 589L201 590L201 590L201 590L201 591L200 591L201 591L200 591L200 591L200 591L200 591L200 592L199 592L199 592L198 592L198 592L197 591L197 590L195 591L195 591L194 591L194 590L192 590L192 590L191 589L190 588L190 589L189 590L189 590L189 591L189 591L188 593L188 594L188 594L188 595L188 595L188 597L188 597L187 598L187 600L187 601L186 601L186 602L186 602L186 605L185 605L185 607L186 607L185 609L188 612L189 612L193 615L194 615L195 615L197 616L197 616L199 616L200 616L200 617L201 617L201 617L201 617L201 621L202 620L203 620L204 620L206 619L206 619L207 619L207 618L207 618L206 615L206 615L206 615L206 615L206 614L207 614L207 614L207 614L207 614L207 614L207 613L207 613L207 612L207 612L207 611L207 611L207 610L207 610L207 610L207 610L207 610L208 610L208 609L209 608L210 608L211 607L212 608L212 607L212 607L212 606L213 605L213 605L213 606L214 606L214 605L214 604L214 604L214 603L215 602L215 601L214 601L215 600L214 600L214 600L214 600L214 599L213 599L214 598L213 598L213 598L213 597L213 597L213 596L213 596L213 595L213 594L213 594L213 592z"
        },
        {
            "title": "Charakonda",
            "d": "M279 563L279 563L279 564L279 565L280 565L280 566L279 566L279 566L278 566L278 566L278 567L277 567L277 567L276 568L276 568L276 569L276 569L276 570L276 570L277 571L276 572L275 573L274 571L273 571L272 571L270 572L269 573L268 573L268 574L268 576L267 576L267 576L267 576L266 576L266 576L265 576L265 577L265 577L265 577L265 579L264 579L264 579L264 580L265 580L266 581L266 582L266 582L266 583L266 584L267 584L267 584L267 584L268 584L268 585L269 585L269 585L270 584L271 584L271 584L272 584L274 583L275 583L276 583L276 583L277 583L279 582L279 582L279 582L279 582L280 582L286 583L287 583L286 582L286 580L286 578L286 578L286 578L286 578L287 578L287 577L287 577L288 577L288 577L288 577L288 576L288 576L289 576L289 576L289 576L289 576L290 575L290 575L291 574L291 574L291 573L292 573L292 573L292 573L293 573L294 573L294 573L294 573L294 572L294 571L294 571L295 569L295 569L295 569L295 568L294 567L295 566L294 566L294 566L295 565L295 566L296 566L296 566L297 566L297 566L298 566L299 565L299 564L300 563L300 561L300 561L300 562L297 562L296 561L295 561L294 560L294 560L293 561L293 561L293 561L293 562L292 563L292 563L292 563L292 564L292 564L292 564L291 565L290 564L289 564L289 565L289 565L289 565L288 565L287 565L286 564L286 565L285 566L284 566L284 565L284 565L284 565L284 564L284 563L284 563L284 563L284 563L283 562L282 562L282 562L281 562L281 563L281 562L281 563L280 563L280 563L279 563L279 562L279 562L279 563z"
        },
        {
            "title": "Kodair",
            "d": "M200 649L202 650L202 649L203 650L203 650L204 650L204 650L204 650L205 650L204 650L205 651L204 652L205 652L205 652L204 653L203 653L202 653L201 653L201 653L200 654L200 655L201 655L201 656L201 656L201 656L201 657L201 657L201 657L201 657L200 658L201 658L201 658L201 659L202 659L202 662L202 663L204 664L205 664L205 664L205 665L205 665L204 666L204 667L204 667L204 668L204 668L206 668L206 668L206 667L206 668L206 667L207 668L207 667L208 668L208 667L208 667L208 666L208 666L208 666L208 665L209 665L209 665L210 665L210 664L211 663L211 662L211 661L212 661L212 661L213 661L213 662L214 662L214 662L214 662L214 662L215 663L215 663L215 663L215 663L215 663L215 663L215 663L216 663L216 663L216 663L216 662L217 661L217 661L217 661L218 661L218 660L218 660L218 660L218 660L218 660L218 659L219 658L218 658L219 657L218 657L219 657L218 657L218 657L217 657L217 657L217 657L216 657L216 657L215 656L215 656L215 656L215 656L214 656L214 656L214 655L214 655L214 655L214 655L215 654L215 654L216 654L216 654L217 654L217 654L217 654L217 653L217 653L217 653L217 652L217 652L217 652L217 651L217 651L218 651L219 651L219 650L219 650L219 650L219 649L221 649L221 649L222 650L222 648L222 647L222 647L222 647L222 647L223 647L223 646L223 646L223 645L224 645L224 645L224 645L225 645L225 644L225 644L225 644L224 643L225 642L225 642L225 642L224 642L224 642L224 642L224 642L223 642L222 641L221 641L221 641L221 640L220 640L219 640L219 640L219 640L218 640L218 639L218 639L218 639L218 638L217 638L217 638L217 638L217 637L216 637L214 637L214 637L212 636L212 636L211 636L211 637L211 637L211 637L211 638L211 639L211 639L211 640L211 641L211 641L210 642L210 642L210 644L210 644L210 645L211 645L211 645L211 646L211 646L211 647L211 647L211 647L210 647L210 647L210 647L209 647L209 647L208 647L207 647L207 647L206 647L206 647L206 647L205 647L205 646L205 646L204 645L204 645L203 644L202 645L202 645L201 645L201 646L201 646L201 646L201 647L201 648L201 648L201 648L201 648L200 648L200 649L201 649L200 649z"
        },
        {
            "title": "Kollapur",
            "d": "M221 688L221 687L221 687L222 687L222 687L223 686L224 686L224 686L225 685L227 686L228 686L229 685L229 685L230 684L231 683L232 682L233 682L234 681L235 681L237 681L239 681L239 681L240 682L241 681L244 681L245 682L247 682L248 683L250 684L251 684L254 685L256 685L257 686L258 687L259 687L260 686L261 686L262 685L263 684L264 684L264 683L265 683L266 682L266 681L267 680L268 680L269 679L270 679L271 679L272 679L274 680L275 681L275 682L277 683L277 682L277 682L277 681L277 680L278 678L277 677L277 676L277 675L276 674L276 674L275 673L275 673L275 673L274 672L273 672L273 672L272 673L271 672L270 672L269 672L268 672L268 672L267 672L266 671L266 670L266 670L266 669L266 669L265 668L265 668L264 667L264 667L262 666L261 665L261 665L260 665L260 665L259 665L259 664L259 664L258 664L256 663L255 662L254 662L253 662L252 662L251 661L251 661L251 659L250 659L249 659L249 658L249 657L248 657L248 657L245 657L244 657L244 657L243 658L241 658L241 659L241 659L240 659L240 659L240 659L239 658L238 659L238 659L237 660L237 661L237 661L236 660L235 660L234 660L233 660L233 660L233 660L233 660L233 661L233 661L233 662L233 663L232 664L228 663L227 664L227 664L227 664L226 664L225 664L224 664L223 664L223 664L223 665L223 665L223 665L222 665L221 665L221 665L220 665L219 665L218 666L218 666L218 666L218 666L218 666L217 667L216 666L215 666L215 666L215 666L215 665L215 663L215 663L214 662L214 662L214 662L214 662L213 662L213 661L212 661L212 661L211 661L211 662L211 663L210 664L210 665L209 665L209 665L208 665L208 666L208 666L208 666L208 667L208 667L208 668L207 667L207 668L206 667L206 668L206 667L206 668L206 668L204 668L203 669L205 670L205 671L205 671L206 672L206 672L206 673L206 673L206 674L207 674L207 675L207 675L207 677L206 678L208 679L208 679L209 679L209 679L210 679L210 679L211 679L211 679L211 679L213 680L213 680L213 680L212 680L213 681L212 682L213 682L213 683L214 683L214 683L214 683L215 683L215 683L216 684L217 684L218 685L218 685L218 685L218 685L218 685L219 687L220 688L220 688L221 688z"
        },
        {
            "title": "Kalwakurthy",
            "d": "M265 576L265 575L265 575L266 574L266 574L266 573L265 573L265 573L264 573L263 573L262 574L262 574L262 575L262 575L261 576L261 576L260 577L260 577L260 577L259 577L259 578L258 578L257 579L257 579L257 579L256 579L255 578L255 578L254 578L253 577L253 577L252 575L252 575L252 575L251 574L252 573L251 573L251 572L252 572L252 571L251 571L250 570L248 570L247 570L246 569L245 569L245 568L244 570L244 570L243 571L243 571L243 572L242 572L242 572L242 572L241 572L241 572L240 572L240 572L240 572L240 573L239 575L239 575L239 576L239 576L239 576L239 577L235 578L235 578L236 580L235 580L235 580L235 580L235 580L235 580L235 580L235 581L235 581L235 580L234 580L233 580L231 580L230 581L229 583L229 583L229 584L230 585L231 586L232 588L232 588L234 590L234 590L235 593L236 594L236 594L236 594L236 594L237 595L237 595L237 596L238 595L239 595L239 596L241 596L242 597L242 597L242 599L243 601L243 601L244 602L244 604L245 605L246 605L247 607L247 607L247 610L247 610L247 611L248 611L249 611L250 611L250 610L250 610L250 609L250 609L250 609L250 608L250 607L250 607L250 607L250 606L250 605L250 604L250 604L250 604L250 604L250 603L250 603L249 603L248 602L248 602L249 599L249 599L250 597L252 599L253 599L254 599L255 598L255 597L254 597L254 597L254 597L254 597L255 597L255 595L256 595L258 595L258 595L259 595L259 595L260 594L261 591L261 589L261 589L261 589L261 588L261 587L260 586L259 586L259 585L259 585L259 583L260 583L261 582L261 582L263 582L263 581L263 581L263 581L263 581L264 580L264 579L264 579L265 579L265 577L265 577L265 577L265 576z"
        },
        {
            "title": "Padara",
            "d": "M345 618L345 619L345 619L345 621L344 622L344 623L344 623L344 624L344 625L344 625L343 626L343 626L343 627L342 627L341 627L341 627L340 625L339 624L338 624L338 624L338 624L338 623L337 623L337 623L337 622L336 622L334 622L333 622L331 620L331 620L331 619L330 619L330 618L330 617L325 616L323 615L323 616L323 617L323 616L322 617L322 617L322 618L322 618L322 618L322 619L322 619L321 619L320 619L320 619L320 619L319 619L319 619L319 618L319 617L319 617L319 617L319 617L319 616L318 616L317 616L317 616L317 616L316 616L316 616L314 616L313 616L312 617L311 618L311 619L311 619L311 620L311 621L312 622L312 623L313 624L313 625L313 625L314 625L314 625L315 626L315 626L315 626L316 626L316 626L317 626L317 626L317 626L317 625L318 626L318 625L318 625L319 624L319 624L319 624L319 624L320 625L321 625L323 625L324 626L325 626L325 626L326 626L326 627L327 627L327 627L327 627L326 627L325 627L324 626L324 626L323 627L323 627L323 627L323 628L323 629L322 630L324 634L324 634L324 636L324 636L324 636L323 636L323 636L323 636L323 637L323 637L324 637L323 638L323 639L323 639L323 639L323 639L323 640L323 640L323 640L323 641L322 642L322 642L322 643L322 643L322 643L322 644L322 644L322 645L322 646L322 646L323 647L323 648L323 648L323 648L323 648L323 648L323 648L323 648L323 648L323 648L323 648L324 648L324 648L325 648L325 648L326 648L327 648L328 648L330 649L330 649L331 648L332 648L332 649L333 650L333 650L334 648L334 648L335 648L336 648L337 648L337 648L337 648L338 650L337 651L337 651L337 652L337 652L338 653L338 653L339 653L341 654L343 654L346 656L346 656L347 655L348 655L349 656L350 656L350 657L351 657L351 656L352 656L352 656L353 655L354 655L354 655L355 655L356 657L357 657L357 658L359 658L360 659L360 659L361 659L363 659L365 658L366 658L367 657L369 657L369 657L370 656L371 655L371 655L371 653L371 651L371 650L371 649L371 648L372 647L372 646L372 646L372 645L372 644L372 642L372 641L373 640L373 638L373 638L373 637L371 636L371 636L370 635L369 634L369 634L368 633L367 633L366 633L366 633L365 632L364 632L363 632L363 632L362 631L362 631L362 630L362 630L361 630L360 630L360 629L359 628L359 627L360 627L359 626L359 626L359 626L358 627L357 627L357 626L356 625L355 625L354 625L354 624L353 624L353 623L353 623L352 622L350 623L349 622L348 621L347 620L346 619L346 618L345 618z"
        },
        {
            "title": "Peddakothapalle",
            "d": "M232 630L231 629L231 629L230 629L230 629L230 629L228 629L227 629L226 629L225 629L225 629L225 630L225 630L225 630L225 631L224 631L225 631L224 631L224 631L224 631L224 631L224 631L224 632L224 633L223 633L223 633L223 633L222 633L221 633L221 633L219 632L219 633L219 633L219 634L218 634L218 634L217 634L217 634L217 635L217 636L217 636L217 636L217 636L217 636L217 636L217 636L217 636L217 637L217 638L217 638L217 638L218 638L218 639L218 639L218 639L218 640L219 640L219 640L219 640L220 640L221 640L221 641L221 641L222 641L223 642L224 642L224 642L224 642L224 642L225 642L225 642L225 642L224 643L225 644L225 644L225 644L225 645L224 645L224 645L224 645L223 645L223 646L223 646L223 647L222 647L222 647L222 647L222 647L222 648L222 650L221 649L221 649L219 649L219 650L219 650L219 650L219 651L218 651L217 651L217 651L217 652L217 652L217 652L217 653L217 653L217 653L217 654L217 654L217 654L216 654L216 654L215 654L215 654L214 655L214 655L214 655L214 655L214 656L214 656L215 656L215 656L215 656L215 656L216 657L216 657L217 657L217 657L217 657L218 657L218 657L219 657L218 657L219 657L218 658L219 658L218 659L218 660L218 660L218 660L218 660L218 660L218 661L217 661L217 661L217 661L216 662L216 663L216 663L216 663L215 663L215 663L215 663L215 663L215 663L215 663L215 665L215 666L215 666L215 666L216 666L217 667L218 666L218 666L218 666L218 666L218 666L219 665L220 665L221 665L221 665L222 665L223 665L223 665L223 665L223 664L223 664L224 664L225 664L226 664L227 664L227 664L227 664L228 663L232 664L233 663L233 662L233 661L233 661L233 660L233 660L233 660L233 660L234 660L235 660L236 660L237 661L237 661L237 660L238 659L238 659L239 658L240 659L240 659L240 659L241 659L241 659L241 658L243 658L244 657L244 657L242 655L242 655L242 655L243 654L242 654L242 653L242 653L242 653L241 653L241 652L240 652L240 652L240 652L240 651L240 650L240 650L239 648L239 648L240 647L240 647L240 647L240 646L240 646L240 645L241 645L240 645L240 644L240 644L240 643L240 643L240 642L239 642L239 642L239 642L239 642L238 640L237 639L237 639L237 638L237 637L237 637L237 636L237 636L237 635L235 634L234 634L233 633L233 633L233 633L233 633L232 632L231 632L232 631L232 631L232 630L232 630z"
        },
        {
            "title": "Pentlavelli",
            "d": "M197 680L197 680L197 680L197 680L198 681L198 681L197 682L197 682L197 682L197 683L197 683L197 683L198 683L198 683L198 683L198 683L199 683L199 683L199 683L200 683L200 684L201 684L201 684L200 684L200 684L200 685L201 685L201 686L201 686L200 686L200 686L199 686L199 686L198 686L198 686L200 687L201 687L201 687L201 687L202 687L202 688L202 688L202 688L203 688L203 689L203 689L203 689L203 689L204 689L204 690L203 690L203 690L203 691L203 691L202 691L202 692L203 692L204 692L204 692L204 692L205 693L205 693L205 693L205 693L205 693L206 693L206 693L206 693L206 692L206 692L206 692L205 692L206 692L206 692L207 692L208 692L209 692L210 692L209 692L209 691L210 689L211 689L211 689L212 689L213 689L217 692L218 692L219 692L219 692L220 691L221 690L221 690L220 689L221 688L220 688L220 688L219 687L218 685L218 685L218 685L218 685L218 685L217 684L216 684L215 683L215 683L214 683L214 683L214 683L213 683L213 682L212 682L213 681L212 680L213 680L213 680L213 680L211 679L211 679L211 679L210 679L210 679L209 679L209 679L208 679L208 679L206 678L207 677L207 675L207 675L207 674L206 674L206 673L206 673L206 672L206 672L205 671L205 671L205 670L203 669L203 670L202 671L202 671L202 673L202 674L201 675L201 675L201 675L202 676L203 677L202 677L202 677L202 677L201 677L200 678L200 678L200 678L200 678L199 679L199 679L199 680L199 680L199 680L198 680L198 680L197 680z"
        },
        {
            "title": "Tadoor",
            "d": "M222 577L221 576L221 575L221 575L221 575L220 575L219 575L218 575L218 575L218 575L218 576L218 577L220 578L219 578L219 578L219 579L219 579L219 578L218 578L218 578L217 578L217 578L217 578L216 579L216 580L217 581L217 581L218 581L217 583L218 584L217 586L217 586L217 586L217 587L217 588L217 590L217 591L216 591L216 591L215 591L213 591L213 592L213 592L213 594L213 594L213 595L213 596L213 596L213 597L213 597L213 598L213 598L214 598L213 599L214 599L214 600L214 600L214 600L215 600L214 601L215 601L215 602L214 603L214 604L214 604L214 605L214 605L215 605L215 605L215 605L215 605L215 605L216 606L216 606L216 606L216 606L216 606L216 606L216 606L217 607L217 607L217 607L217 607L218 607L218 607L218 607L218 606L219 605L220 605L221 605L222 604L223 604L223 604L223 604L223 604L223 604L224 604L224 605L225 605L225 605L225 605L225 605L225 605L225 605L225 605L225 606L225 606L225 607L225 608L225 608L226 608L226 608L228 608L228 608L230 608L230 609L231 609L231 609L231 608L232 607L232 606L232 606L233 604L233 603L233 602L234 602L235 602L236 603L238 605L240 605L242 605L243 605L243 604L244 604L244 604L244 604L244 602L243 601L243 601L242 599L242 597L242 597L241 596L239 596L239 595L238 595L237 596L237 595L237 595L236 594L236 594L236 594L236 594L235 593L234 590L234 590L232 588L232 588L231 586L230 585L229 584L229 583L228 582L228 582L227 582L227 581L225 580L225 580L224 581L224 581L223 581L223 580L223 580L223 579L222 579L222 579L222 579L222 578L222 577z"
        },
        {
            "title": "Telkapalle",
            "d": "M244 604L244 604L244 604L243 604L243 605L242 605L240 605L238 605L239 606L239 607L239 607L239 609L238 609L238 609L237 608L237 609L237 608L237 609L237 609L236 609L234 609L234 610L234 610L234 610L233 610L232 610L232 611L232 612L232 613L232 613L232 613L233 615L233 615L233 615L233 616L233 616L233 616L233 616L232 617L231 617L231 618L230 618L228 619L228 619L227 619L227 619L226 619L226 620L226 620L226 620L226 621L226 621L226 622L226 622L226 622L226 622L226 622L226 622L226 622L227 623L227 623L229 623L230 624L230 624L231 624L232 625L232 625L233 625L233 625L233 626L232 627L232 628L232 628L232 628L232 629L232 629L232 630L232 630L232 630L232 631L232 631L231 632L232 632L233 633L233 633L233 633L233 633L234 634L235 634L237 635L237 636L237 636L237 637L237 637L237 638L237 639L237 639L238 640L239 642L239 642L239 642L239 642L240 642L240 643L240 643L240 644L240 643L241 643L242 643L242 643L242 642L242 642L243 642L243 640L243 640L243 639L243 639L245 639L245 639L246 638L247 637L246 637L247 637L247 636L248 635L248 634L249 634L249 634L249 632L249 631L249 630L249 629L250 630L251 630L251 630L252 629L253 629L253 629L253 629L253 629L253 628L253 628L253 628L254 628L253 627L253 625L253 625L253 624L253 624L253 624L252 623L252 624L251 624L251 624L250 623L250 623L250 622L250 622L251 622L252 622L253 620L253 620L253 620L252 620L252 618L251 618L251 617L251 617L251 617L251 617L251 617L251 616L251 616L251 615L251 615L250 615L251 613L251 613L251 612L251 612L250 612L250 611L250 610L250 610L250 611L249 611L248 611L247 611L247 610L247 610L247 607L247 607L246 605L245 605L244 604z"
        },
        {
            "title": "Thimmajipeta",
            "d": "M218 575L218 574L215 572L213 571L213 571L213 571L212 569L211 568L210 568L209 567L209 567L209 567L208 566L207 566L207 566L207 566L207 566L207 566L206 566L206 566L206 567L205 568L204 568L204 569L204 570L203 571L203 571L202 572L200 572L200 572L199 571L199 570L199 568L199 568L199 567L199 567L198 567L197 568L197 568L197 568L196 568L195 569L195 570L195 571L194 572L194 573L194 573L193 574L193 575L192 576L192 576L192 576L192 576L192 576L192 577L192 577L191 579L192 579L194 581L194 581L194 581L194 582L193 582L192 584L191 584L190 585L190 586L190 587L190 587L190 587L190 588L190 588L191 589L192 590L192 590L194 590L194 591L195 591L195 591L197 590L197 591L198 592L198 592L199 592L199 592L200 592L200 591L200 591L200 591L200 591L201 591L200 591L201 591L201 590L201 590L201 590L201 589L201 589L201 589L201 585L201 586L203 586L204 586L204 587L205 587L206 588L206 588L207 589L207 589L207 589L208 590L209 590L209 590L209 591L209 591L209 592L209 592L210 592L213 592L213 592L213 591L215 591L216 591L216 591L217 591L217 590L217 588L217 587L217 586L217 586L217 586L218 584L217 583L218 581L217 581L217 581L216 580L216 579L217 578L217 578L217 578L218 578L218 578L219 578L219 579L219 579L219 578L219 578L220 578L218 577L218 576L218 575z"
        },
        {
            "title": "Uppunuthala",
            "d": "M298 604L297 604L297 603L295 603L295 603L294 602L290 602L289 602L288 602L288 601L287 602L286 602L285 602L283 602L282 602L281 601L281 602L282 602L281 602L281 603L281 603L281 603L280 602L280 602L280 602L279 602L279 602L279 603L279 603L278 603L277 603L277 603L277 603L277 603L277 603L276 603L276 603L276 603L276 603L276 603L276 602L275 602L275 602L275 603L274 603L274 604L274 604L273 604L273 604L272 604L272 604L272 604L272 604L272 604L271 604L271 604L271 605L271 606L270 606L271 606L271 605L270 604L270 605L269 605L267 604L266 604L265 605L265 605L264 605L264 606L263 607L263 608L262 608L261 608L259 608L258 608L257 608L256 608L255 608L254 608L254 608L253 608L252 607L250 607L250 607L250 608L250 609L250 609L250 609L250 610L250 611L250 612L251 612L251 612L251 613L251 613L250 615L251 615L251 615L251 616L251 616L252 616L252 616L253 616L253 617L253 617L253 618L254 618L254 618L254 618L255 618L254 618L255 619L255 619L256 619L256 620L256 620L256 620L257 621L258 620L259 619L259 619L260 619L261 619L261 619L262 619L263 619L263 619L265 620L265 620L266 620L266 620L267 620L267 620L267 620L268 620L269 620L269 620L270 620L270 620L270 620L270 619L272 619L274 619L274 619L273 618L273 617L273 617L273 616L273 615L273 615L274 615L275 616L275 616L276 615L276 615L276 616L276 616L277 616L277 616L277 616L277 616L278 616L278 616L279 617L280 617L280 617L281 617L281 617L281 615L281 615L281 615L281 614L281 613L282 613L283 613L283 613L283 613L284 613L284 614L284 615L284 615L284 616L284 616L285 616L286 616L286 616L286 616L287 616L287 616L287 616L288 615L288 615L289 615L291 615L291 615L291 615L291 615L293 614L292 614L291 614L290 614L289 614L289 613L289 613L288 613L288 612L288 611L288 611L288 610L288 608L288 608L289 608L290 609L291 609L291 609L293 609L293 609L293 609L294 608L295 608L295 607L296 607L296 606L297 605L298 604z"
        },
        {
            "title": "Urkonda",
            "d": "M247 560L247 560L247 560L247 560L247 560L246 560L245 560L244 560L241 560L240 559L239 558L239 558L238 557L238 557L237 556L235 557L235 557L234 558L234 558L233 559L233 559L233 559L232 559L232 559L232 558L231 558L231 557L230 557L229 557L229 557L228 557L228 557L228 557L227 557L226 557L226 558L227 558L227 559L227 561L229 562L229 562L230 563L230 563L230 565L230 565L230 566L229 567L229 568L228 569L227 571L227 572L228 573L228 574L227 574L227 576L227 576L225 575L225 575L224 576L223 576L222 576L222 576L222 576L222 577L222 577L222 578L222 579L222 579L222 579L223 579L223 580L223 580L223 581L224 581L224 581L225 580L225 580L227 581L227 582L228 582L228 582L229 583L229 583L230 581L231 580L233 580L234 580L235 580L235 581L235 581L235 580L235 580L235 580L235 580L235 580L235 580L236 580L235 578L235 578L239 577L239 576L239 576L239 576L239 575L239 575L240 573L240 572L240 572L240 572L241 572L241 572L242 572L242 572L242 572L243 572L243 571L243 571L244 570L244 570L245 568L246 568L246 568L246 567L246 566L246 566L246 566L246 566L246 566L246 564L248 565L250 565L250 564L250 564L251 563L251 563L250 563L250 562L248 561L247 560z"
        },
        {
            "title": "Vangoor",
            "d": "M279 582L277 583L276 583L276 583L275 583L274 583L272 584L271 584L271 584L270 584L269 585L269 585L268 585L268 584L267 584L267 584L267 584L266 584L266 583L266 582L266 582L266 581L265 580L264 580L263 581L263 581L263 581L263 581L263 582L261 582L261 582L260 583L259 583L259 585L259 585L259 586L260 586L261 587L261 588L261 589L261 589L261 589L261 591L260 594L259 595L259 595L258 595L258 595L256 595L255 595L255 597L254 597L254 597L254 597L254 597L255 597L255 598L254 599L253 599L252 599L250 597L249 599L249 599L248 602L248 602L249 603L250 603L250 603L250 604L250 604L250 604L250 604L250 605L250 606L250 607L250 607L252 607L253 608L254 608L254 608L255 608L256 608L257 608L258 608L259 608L261 608L262 608L263 608L263 607L264 606L264 605L265 605L265 605L266 604L267 604L269 605L270 605L270 604L271 604L272 603L273 602L274 602L274 601L274 601L274 601L274 600L274 599L275 600L275 600L275 600L276 600L276 600L276 600L276 600L277 600L277 600L277 600L278 600L278 601L278 601L278 601L278 601L278 601L278 601L279 601L279 600L279 600L279 599L279 599L278 599L279 599L279 598L279 598L279 598L279 598L279 598L279 598L279 597L279 597L279 597L280 597L279 597L279 596L279 596L279 596L279 596L279 596L279 596L279 596L279 596L279 596L278 596L278 596L278 596L278 596L278 596L278 596L278 596L278 596L278 596L278 596L278 596L279 595L279 595L279 595L279 596L279 596L279 596L279 596L280 596L280 596L280 596L280 596L280 597L280 597L280 597L280 597L280 597L280 597L281 598L280 598L280 598L280 598L281 599L281 599L281 599L281 599L281 599L281 599L281 599L281 599L281 599L281 599L281 599L281 599L282 599L283 598L284 597L285 597L285 597L286 596L287 595L287 595L286 593L286 592L285 591L285 590L285 590L284 589L284 589L284 588L281 586L281 584L279 582z"
        },
        {
            "title": "Veldanda",
            "d": "M279 563L278 563L278 563L278 562L278 561L278 560L279 560L280 560L281 559L282 559L282 558L282 556L282 555L282 555L282 555L281 553L281 552L281 552L280 552L280 551L280 551L279 553L279 555L278 558L276 561L276 561L274 561L274 561L274 561L274 560L272 560L271 559L271 558L271 558L271 557L268 558L267 557L266 556L266 556L266 556L264 555L264 555L263 555L263 554L262 554L262 554L262 554L261 554L261 553L260 553L260 553L259 553L258 552L258 553L257 554L256 554L255 553L254 552L253 552L253 552L251 553L250 553L249 553L249 553L249 553L249 553L248 553L248 554L248 555L247 556L247 558L247 559L247 560L248 561L250 562L250 563L251 563L251 563L250 564L250 564L250 565L248 565L246 564L246 566L246 566L246 566L246 566L246 566L246 567L246 568L246 568L245 568L245 569L246 569L247 570L248 570L250 570L251 571L252 571L252 572L251 572L251 573L252 573L251 574L252 575L252 575L252 575L253 577L253 577L254 578L255 578L255 578L256 579L257 579L257 579L257 579L258 578L259 578L259 577L260 577L260 577L260 577L261 576L261 576L262 575L262 575L262 574L262 574L263 573L264 573L265 573L265 573L266 573L266 574L266 574L265 575L265 575L265 576L266 576L266 576L267 576L267 576L267 576L268 576L268 574L268 573L269 573L270 572L272 571L273 571L274 571L275 573L276 572L277 571L276 570L276 570L276 569L276 569L276 568L276 568L277 567L277 567L278 567L278 566L278 566L279 566L279 566L280 566L280 565L279 565L279 564L279 563L279 563z"
        },
        {
            "title": "Lingal",
            "d": "M253 629L253 629L253 629L252 629L251 630L251 630L250 630L249 629L249 630L249 631L249 632L249 634L249 634L248 634L248 635L247 636L247 637L246 637L247 637L246 638L245 639L245 639L243 639L243 639L243 640L243 640L243 642L242 642L242 642L242 643L242 643L241 643L240 643L240 644L240 644L240 645L241 645L240 645L240 646L240 646L240 647L240 647L240 647L239 648L239 648L240 650L240 650L240 651L240 652L240 652L240 652L241 652L241 653L242 653L242 653L242 653L242 654L243 654L242 655L242 655L242 655L244 657L245 657L248 657L248 657L249 657L251 657L251 657L251 657L252 659L252 659L253 659L254 660L254 660L255 661L255 661L257 660L259 660L260 660L261 660L262 659L263 658L263 656L264 656L264 655L266 652L266 651L266 650L265 650L263 649L262 650L261 650L260 647L259 646L258 645L258 644L257 644L256 644L256 643L256 643L256 643L255 642L256 642L255 641L256 641L255 641L255 641L255 641L255 641L255 640L255 640L254 639L255 639L255 639L254 639L254 639L254 639L254 639L255 638L255 637L254 636L254 636L254 636L254 636L254 636L255 636L254 635L255 634L255 634L255 633L255 633L255 632L255 632L255 632L254 631L254 630L253 629z"
        },
        {
            "title": "Nagar_Kurnool",
            "d": "M238 605L236 603L235 602L234 602L233 602L233 603L233 604L232 606L232 606L232 607L231 608L231 609L231 609L230 609L230 608L228 608L228 608L226 608L226 608L225 608L225 608L225 607L225 606L225 606L225 605L225 605L225 605L225 605L225 605L225 605L225 605L224 605L224 604L223 604L223 604L223 604L223 604L223 604L222 604L221 605L220 605L219 605L218 606L218 607L218 607L218 607L217 607L217 607L217 607L217 607L216 606L216 606L216 606L216 606L216 606L216 606L216 606L215 605L215 605L215 605L215 605L215 605L214 605L214 605L214 606L213 606L213 605L213 605L212 606L212 607L212 607L212 608L211 607L210 608L209 608L208 609L208 610L207 610L207 610L207 610L207 610L207 610L207 611L207 611L207 612L207 612L207 613L207 613L207 614L207 614L207 614L207 614L207 614L206 614L206 615L206 615L206 615L206 615L207 618L207 618L207 619L206 619L206 619L204 620L203 620L202 620L201 621L201 622L201 624L204 623L205 623L206 623L207 623L207 623L208 622L210 622L210 622L210 624L210 626L210 626L211 626L211 626L212 626L213 627L213 627L213 627L213 626L214 626L214 625L214 624L214 623L214 623L215 623L215 623L215 624L215 624L215 624L215 625L215 625L215 624L215 624L215 625L215 625L215 625L215 625L216 625L217 625L218 625L218 625L219 626L220 627L220 627L220 629L220 629L220 629L220 629L220 631L220 631L220 631L220 632L220 632L220 632L219 632L221 633L221 633L222 633L223 633L223 633L223 633L224 633L224 632L224 631L224 631L224 631L224 631L224 631L225 631L224 631L225 631L225 630L225 630L225 630L225 629L225 629L226 629L227 629L228 629L230 629L230 629L230 629L231 629L231 629L232 630L232 630L232 629L232 629L232 628L232 628L232 628L232 627L233 626L233 625L233 625L232 625L232 625L231 624L230 624L230 624L229 623L227 623L227 623L226 622L226 622L226 622L226 622L226 622L226 622L226 622L226 621L226 621L226 620L226 620L226 620L226 619L227 619L227 619L228 619L228 619L230 618L231 618L231 617L232 617L233 616L233 616L233 616L233 616L233 615L233 615L233 615L232 613L232 613L232 613L232 612L232 611L232 610L233 610L234 610L234 610L234 610L234 609L236 609L237 609L237 609L237 608L237 609L237 608L238 609L238 609L239 609L239 607L239 607L239 606L238 605z"
        }
    ],
    "Nalgonda": [
        {
            "title": "Adavidevulapally",
            "d": "M422 571L422 571L420 571L421 572L419 572L415 573L416 572L415 572L412 570L413 572L412 574L409 575L408 576L407 578L406 579L406 579L406 579L406 579L407 581L408 581L408 582L408 584L406 583L403 585L402 585L404 587L404 587L405 587L406 589L407 590L407 590L408 590L409 589L411 588L412 588L413 588L415 588L415 588L416 587L417 586L418 586L419 586L419 586L422 587L423 587L424 587L425 587L426 586L429 584L430 584L432 582L431 582L431 581L430 580L427 579L426 579L426 579L425 579L425 578L425 578L425 579L424 579L424 579L424 578L424 578L424 578L424 578L424 578L424 577L424 577L423 577L423 577L423 576L423 576L423 576L423 573L423 573L422 573L422 573L423 573L423 573L422 573L422 573L422 572L424 572L424 571L423 571L422 571L422 571z"
        },
        {
            "title": "Anumula_Haliya",
            "d": "M384 539L384 539L384 539L383 539L382 539L382 539L381 538L380 538L380 538L380 538L379 539L378 539L377 538L377 539L377 539L377 539L376 538L376 538L376 537L376 537L376 537L376 537L375 537L375 538L375 538L375 539L376 539L376 539L376 539L376 539L376 539L376 540L375 540L375 540L374 541L374 541L374 541L373 541L373 542L373 542L373 542L372 543L372 543L372 543L371 546L371 546L370 546L369 548L369 548L369 548L369 548L368 548L368 549L367 549L367 549L367 550L367 550L367 550L367 552L368 552L368 552L369 552L369 552L370 552L371 553L372 553L372 554L374 554L376 555L376 554L377 554L378 555L378 555L379 556L379 556L380 557L380 558L380 558L379 558L379 559L379 559L379 560L378 561L378 562L378 562L378 562L379 563L378 564L379 564L380 564L380 564L380 564L380 564L381 564L382 564L383 564L384 564L385 564L385 564L385 564L385 565L385 565L385 566L385 567L385 569L385 569L385 569L384 569L384 570L385 570L385 570L386 569L386 569L386 569L386 569L386 569L387 569L387 568L387 568L388 568L389 568L389 568L389 568L389 568L390 568L391 568L391 568L392 568L393 568L393 567L394 567L394 567L395 567L395 567L395 568L396 568L396 568L397 568L397 568L398 568L398 569L398 570L398 570L398 570L398 570L399 569L399 567L399 567L399 566L400 565L400 565L400 564L399 563L398 562L397 562L396 561L397 561L396 561L396 561L396 560L395 560L394 560L393 559L393 557L393 556L393 556L393 555L393 555L393 555L392 555L392 554L391 554L391 554L391 553L391 550L391 548L390 548L390 548L389 548L389 548L389 548L388 548L388 547L387 547L387 547L387 546L387 546L387 545L387 545L387 545L386 544L386 543L384 543L384 540L384 539L384 539z"
        },
        {
            "title": "Chandampet",
            "d": "M325 588L323 587L323 587L322 587L322 587L322 587L321 587L321 587L320 587L320 587L320 587L320 586L320 586L320 586L319 586L320 585L319 585L319 585L319 585L319 584L319 584L319 584L318 584L317 584L317 584L317 584L316 584L316 584L316 583L316 584L315 584L315 584L315 585L314 585L314 585L314 586L314 586L314 586L314 586L314 587L314 587L314 587L313 587L313 588L313 588L312 588L312 588L312 589L312 590L312 590L312 591L312 591L312 591L312 591L312 591L311 591L311 592L310 592L310 593L310 593L309 594L309 595L308 595L308 595L308 595L308 596L308 596L308 597L308 597L308 597L308 597L308 598L308 599L308 599L308 600L308 600L308 601L310 600L310 600L312 601L313 601L314 601L315 600L316 600L317 600L319 600L319 600L320 600L320 602L320 602L321 603L321 605L322 605L324 607L324 607L327 608L328 609L329 609L329 609L331 610L332 610L335 613L338 614L339 615L341 615L342 616L344 618L345 618L346 618L346 619L347 620L348 621L349 622L350 623L352 622L353 623L353 623L353 624L354 624L354 625L355 625L356 625L357 626L357 627L358 627L359 626L359 626L359 626L360 627L359 627L359 628L360 629L360 630L361 630L362 630L362 630L362 631L362 631L363 632L363 632L364 632L365 632L366 633L366 633L367 633L368 633L369 634L369 634L369 633L369 633L369 632L369 632L369 631L369 630L369 629L369 625L369 621L364 619L362 618L361 614L362 612L363 609L363 605L362 607L359 607L358 607L358 607L356 607L356 607L355 607L355 607L354 605L354 605L352 607L351 608L349 613L348 613L347 614L346 612L343 606L340 606L339 605L339 603L342 603L341 600L340 600L339 600L338 601L337 600L336 599L335 599L334 598L333 598L333 597L330 597L327 597L327 596L327 596L326 596L326 596L326 596L326 595L326 595L326 594L325 594L325 593L325 593L325 592L325 592L325 591L325 590L325 590L325 589L325 589L325 589L325 588L325 588z"
        },
        {
            "title": "Chandur",
            "d": "M331 512L330 513L330 514L330 515L330 516L330 516L330 517L330 518L329 518L328 517L328 518L328 520L328 520L327 522L328 522L329 522L330 523L330 523L329 523L329 524L329 525L329 525L328 526L328 526L328 526L328 527L328 527L328 527L328 528L328 529L328 529L329 529L329 529L329 529L329 529L330 530L331 530L331 529L332 529L332 529L332 529L333 530L333 530L334 532L336 533L336 533L336 534L337 534L337 534L337 535L337 535L337 535L337 535L337 536L337 536L337 536L337 536L338 536L338 537L338 537L338 537L338 538L338 538L336 538L337 539L336 539L336 539L336 540L336 540L336 540L336 540L337 540L337 541L337 541L337 541L340 541L340 541L340 540L340 540L340 539L340 539L341 539L341 538L341 538L341 538L341 537L341 537L341 537L342 536L342 536L342 536L343 536L343 535L344 536L346 536L346 536L346 536L347 535L348 535L349 535L349 533L349 532L350 529L350 529L350 528L350 528L351 529L351 527L351 527L352 527L352 526L352 525L352 525L352 525L352 525L351 524L352 524L351 523L349 523L348 523L347 523L348 522L348 522L348 521L348 519L347 519L347 519L347 519L347 518L346 518L347 517L346 517L345 517L345 516L345 516L345 516L344 516L345 515L345 515L345 515L345 515L345 514L343 513L342 513L341 514L340 515L338 514L338 514L337 514L336 513L336 513L335 513L335 513L334 513L333 512L331 512z"
        },
        {
            "title": "Chinthapally",
            "d": "M295 528L294 528L291 527L290 527L289 527L288 528L287 528L286 527L286 527L285 528L286 529L286 531L285 532L285 532L285 533L284 533L285 533L287 533L286 535L287 534L287 535L289 535L290 535L291 536L291 536L291 536L291 536L292 536L292 537L292 537L293 537L293 537L293 538L292 538L292 538L291 539L290 539L290 540L290 541L290 543L289 545L290 546L291 546L292 547L293 547L293 548L294 547L294 546L295 544L296 544L297 543L298 544L298 545L298 545L299 545L299 545L299 546L299 546L298 547L298 548L298 548L298 548L298 549L300 550L300 550L300 551L301 552L302 552L302 553L302 554L301 555L301 555L301 555L300 556L300 558L300 558L300 558L301 559L301 559L300 561L300 561L300 563L299 564L299 565L298 566L298 567L299 567L300 567L301 567L301 567L301 567L302 567L302 567L302 566L302 565L302 565L303 565L303 565L303 565L303 565L304 565L304 565L305 565L306 565L306 565L306 565L307 565L307 565L309 566L309 565L309 564L309 564L309 564L310 562L311 563L312 563L313 563L314 563L315 564L316 563L317 563L317 563L317 563L317 563L318 563L318 563L318 562L318 562L318 562L319 563L319 563L320 563L320 564L320 564L320 564L321 564L321 564L321 564L321 564L322 564L321 564L321 564L321 562L322 561L322 560L322 559L322 559L322 559L322 558L322 558L322 558L322 557L322 557L321 557L321 556L320 556L320 556L320 556L320 555L321 554L320 554L321 554L321 553L321 552L321 551L321 551L321 551L321 551L321 551L319 550L318 550L318 550L318 550L318 550L318 549L318 549L317 549L318 549L316 549L314 548L313 547L311 547L311 546L311 546L311 546L311 545L311 545L310 545L310 543L310 543L310 543L310 543L311 540L311 540L311 540L311 540L311 539L311 538L311 537L310 537L310 537L309 537L309 537L308 537L305 535L305 535L305 535L305 535L304 535L304 534L304 534L304 534L302 533L302 533L301 532L299 531L296 530L296 530L296 528L295 528z"
        },
        {
            "title": "Chityal",
            "d": "M334 474L333 474L332 474L332 474L332 475L332 476L332 477L332 478L332 478L332 479L332 480L332 480L332 482L332 483L331 483L331 485L331 485L331 486L331 486L331 486L330 486L329 488L329 489L329 489L329 489L329 490L330 490L331 491L331 491L331 492L331 492L332 492L332 493L332 493L332 492L333 492L333 491L334 491L334 491L335 491L335 492L335 493L335 493L335 493L336 493L337 493L338 492L339 491L339 491L339 491L339 491L340 492L340 493L340 494L340 494L340 494L340 494L340 495L341 495L342 496L341 497L341 497L341 498L342 498L342 499L343 499L343 500L343 500L343 500L343 500L343 501L343 501L344 501L343 502L344 502L344 502L345 501L345 501L345 500L346 500L346 499L347 498L347 498L348 498L348 498L348 498L348 497L349 497L350 497L350 497L352 498L352 498L354 498L355 498L355 498L355 498L356 496L357 495L357 494L358 494L358 492L359 492L360 491L360 491L360 490L360 490L361 489L361 488L361 488L361 487L362 486L362 486L362 486L362 486L363 486L363 486L363 485L364 485L364 484L365 482L365 481L365 480L365 480L365 480L365 480L365 479L364 479L364 479L363 479L363 479L363 479L363 479L363 479L363 479L362 478L362 478L362 478L362 478L362 478L361 478L361 477L360 476L360 476L360 476L362 474L361 475L361 475L360 474L358 475L358 475L358 475L357 475L357 475L357 475L356 475L355 475L355 475L355 475L354 477L354 478L353 479L353 479L353 479L353 480L353 481L352 481L351 480L350 480L350 480L348 479L347 479L347 479L347 478L346 478L347 478L346 478L346 479L345 479L345 479L344 478L344 478L343 478L343 478L342 477L338 477L336 476L336 476L335 475L334 474z"
        },
        {
            "title": "Damaracherla",
            "d": "M446 558L445 558L445 558L445 558L444 557L444 558L443 557L443 558L442 558L442 558L441 557L441 558L440 558L440 558L439 558L439 558L439 558L439 558L439 558L438 557L438 558L438 557L437 558L437 558L437 558L436 558L436 558L436 558L436 558L435 558L434 557L434 557L433 557L432 557L432 557L432 557L432 556L431 556L431 556L431 556L431 556L430 556L427 557L427 557L427 556L426 555L426 555L426 555L426 555L426 556L426 556L426 556L426 556L426 556L426 556L426 557L426 557L426 557L426 558L426 558L427 558L427 558L427 559L427 559L427 559L427 560L428 560L428 560L428 560L428 560L428 560L428 561L428 561L429 561L429 562L429 565L427 565L427 565L425 565L422 566L422 566L422 567L422 568L423 568L423 569L422 570L422 571L422 570L422 571L422 571L422 571L422 571L422 571L422 571L423 571L424 571L424 572L422 572L422 573L422 573L423 573L423 573L422 573L422 573L423 573L423 573L423 576L423 576L423 576L423 577L423 577L424 577L424 577L424 578L424 578L424 578L424 578L424 578L424 579L424 579L425 579L425 578L425 578L425 579L426 579L426 579L427 579L430 580L431 581L431 582L432 582L433 580L434 580L434 580L435 580L436 580L437 581L437 581L438 582L439 582L440 582L442 581L443 580L443 579L444 578L445 578L445 577L446 577L448 576L448 576L449 576L449 576L449 575L451 572L447 571L447 570L446 570L446 570L446 570L446 569L446 568L446 568L447 565L447 564L447 562L446 558z"
        },
        {
            "title": "Devarakonda",
            "d": "M321 564L321 564L321 564L320 564L320 564L320 564L320 563L319 563L319 563L318 562L318 562L318 562L318 563L318 563L317 563L317 563L317 563L317 563L316 563L315 564L314 563L313 563L312 563L311 563L310 562L309 564L309 564L309 564L309 565L309 566L307 565L307 565L306 565L306 565L306 565L305 565L304 565L304 565L303 565L303 565L303 565L303 565L302 565L302 565L302 566L302 567L302 567L301 567L301 567L301 567L300 567L299 567L298 567L298 566L297 566L297 566L296 566L296 566L295 566L295 565L294 566L294 566L295 566L294 567L295 568L295 569L295 569L295 569L294 571L294 571L295 571L296 571L296 572L298 573L297 573L297 574L297 575L297 575L297 577L297 578L297 578L297 578L298 578L299 578L299 578L299 579L299 579L300 579L300 579L300 580L301 580L301 580L301 580L302 581L302 582L303 582L305 582L307 582L306 582L307 583L307 584L308 584L308 585L308 586L308 586L308 586L308 588L308 589L308 589L308 590L308 591L308 591L308 591L309 591L309 591L309 591L310 591L311 591L311 591L312 591L312 591L312 591L312 591L312 591L312 590L312 590L312 589L312 588L312 588L313 588L313 588L313 587L314 587L314 587L314 587L314 586L314 586L314 586L314 586L314 585L314 585L315 585L315 584L315 584L316 584L316 583L316 584L316 584L317 584L317 584L317 584L318 584L319 584L319 584L319 584L319 585L319 585L319 585L320 585L319 586L320 586L320 586L320 586L320 587L320 587L320 587L321 587L321 587L322 587L322 587L322 587L323 587L323 587L325 588L325 588L325 588L326 588L328 588L328 588L328 587L328 588L328 587L329 585L329 583L329 583L329 582L328 583L327 583L327 583L327 583L327 583L327 582L327 582L327 582L327 582L326 582L326 582L326 582L326 581L326 581L326 581L325 581L325 581L325 581L325 580L325 580L325 580L325 580L325 580L324 577L324 577L324 577L324 577L324 576L324 576L324 576L325 576L325 576L325 576L325 576L325 576L325 575L325 575L325 575L326 574L323 571L323 571L323 570L322 570L322 570L322 570L321 569L321 569L320 568L320 568L320 568L321 567L321 566L321 564z"
        },
        {
            "title": "Gundlapally",
            "d": "M311 591L311 591L310 591L309 591L309 591L309 591L308 591L308 591L308 591L308 590L308 589L308 589L308 588L308 586L308 586L308 586L308 585L308 584L307 584L307 583L306 582L307 582L305 582L303 582L302 582L302 581L301 580L301 580L301 580L300 580L300 579L300 579L299 579L299 579L299 578L299 578L298 578L297 578L297 578L297 578L297 577L297 575L297 575L297 574L297 573L298 573L296 572L296 571L295 571L294 571L294 572L294 573L294 573L294 573L293 573L292 573L292 573L292 573L291 573L291 574L291 574L290 575L290 575L289 576L289 576L289 576L289 576L288 576L288 576L288 577L288 577L288 577L287 577L287 577L287 578L286 578L286 578L286 578L286 578L286 580L286 582L287 583L286 583L280 582L279 582L279 582L279 582L279 582L281 584L281 586L284 588L284 589L284 589L285 590L285 590L285 591L286 592L286 593L287 595L287 595L286 596L285 597L285 597L284 597L283 598L282 599L281 599L281 599L281 599L281 599L281 599L281 599L281 599L281 599L281 599L281 599L281 599L281 599L280 598L280 598L280 598L281 598L280 597L280 597L280 597L280 597L280 597L280 597L280 596L280 596L280 596L280 596L279 596L279 596L279 596L279 596L279 595L279 595L279 595L278 596L278 596L278 596L278 596L278 596L278 596L278 596L278 596L278 596L278 596L278 596L279 596L279 596L279 596L279 596L279 596L279 596L279 596L279 596L279 596L279 597L280 597L279 597L279 597L279 597L279 598L279 598L279 598L279 598L279 598L279 598L279 599L278 599L279 599L279 599L279 600L279 600L279 601L278 601L278 601L278 601L278 601L278 601L278 601L278 600L277 600L277 600L277 600L276 600L276 600L276 600L276 600L275 600L275 600L275 600L274 599L274 600L274 601L274 601L274 601L274 602L273 602L272 603L271 604L270 604L271 605L271 606L270 606L271 606L271 605L271 604L271 604L272 604L272 604L272 604L272 604L272 604L273 604L273 604L274 604L274 604L274 603L275 603L275 602L275 602L276 602L276 603L276 603L276 603L276 603L276 603L277 603L277 603L277 603L277 603L277 603L278 603L279 603L279 603L279 602L279 602L280 602L280 602L280 602L281 603L281 603L281 603L281 602L282 602L281 602L281 601L282 602L283 602L285 602L286 602L287 602L288 601L288 602L289 602L290 602L294 602L295 603L295 603L297 603L297 604L298 604L299 606L300 606L301 606L302 606L302 605L303 604L307 601L307 601L308 601L308 600L308 600L308 599L308 599L308 598L308 597L308 597L308 597L308 597L308 596L308 596L308 595L308 595L308 595L309 595L309 594L310 593L310 593L310 592L311 592L311 591z"
        },
        {
            "title": "Gurrampode",
            "d": "M370 546L370 546L369 546L369 545L369 544L369 543L369 543L368 543L367 542L366 542L366 541L367 539L367 537L367 537L366 537L365 536L365 535L365 534L365 534L365 534L362 534L361 534L361 534L360 534L360 534L359 534L359 534L358 534L358 534L356 535L356 535L353 534L353 534L351 534L350 534L349 533L349 535L348 535L347 535L346 536L346 536L346 536L344 536L343 535L343 536L343 537L342 540L342 541L343 541L343 541L343 541L343 542L342 542L342 542L342 542L341 542L341 543L341 543L340 545L339 546L339 547L338 548L337 549L337 550L337 550L337 550L337 550L337 551L337 553L338 553L337 555L337 555L336 556L336 556L336 556L335 559L335 559L335 559L335 559L335 560L335 560L335 562L335 562L335 562L334 564L336 564L336 565L336 566L336 567L336 570L336 570L336 570L337 570L338 570L338 570L339 569L340 569L340 569L341 568L341 568L341 568L342 568L342 567L343 566L343 566L343 566L343 566L343 566L344 566L344 566L344 566L344 565L344 565L344 564L344 564L344 564L344 563L344 562L344 562L345 561L345 561L345 560L345 560L346 560L346 560L346 560L346 559L346 559L346 559L347 558L347 557L349 559L350 559L351 558L352 558L352 558L353 558L353 558L353 558L353 558L353 558L353 558L353 557L353 557L353 557L354 557L355 557L355 557L355 557L355 557L355 557L357 557L357 557L359 557L359 557L359 556L359 556L359 556L360 557L361 557L361 557L363 557L362 558L362 558L362 558L362 558L362 558L362 558L362 558L362 558L362 559L363 559L363 559L363 559L363 559L363 559L363 559L363 559L364 559L364 558L365 558L366 557L366 557L366 557L367 557L367 557L368 557L368 556L368 556L368 556L368 556L368 555L368 554L368 553L369 553L369 552L368 552L368 552L367 552L367 550L367 550L367 550L367 549L367 549L368 549L368 548L369 548L369 548L369 548L369 548L370 546z"
        },
        {
            "title": "Kanagal",
            "d": "M393 532L391 532L389 531L388 531L388 531L388 531L388 531L388 531L388 531L387 529L387 529L387 528L387 527L387 527L387 527L387 527L386 527L386 527L385 527L385 527L385 528L385 528L385 528L385 528L385 529L385 529L385 529L385 529L385 530L386 530L385 531L385 531L385 531L385 532L385 532L384 532L383 532L382 531L382 531L382 531L381 530L381 530L381 530L381 530L380 530L380 530L379 530L379 530L379 529L380 528L380 528L379 528L379 528L379 528L379 528L379 528L379 527L379 527L378 526L378 525L378 524L377 522L375 521L375 522L375 522L374 522L374 522L373 522L373 522L373 522L373 522L372 523L371 523L371 523L371 523L371 523L371 522L370 522L370 522L369 522L369 522L368 521L368 521L368 520L367 519L366 518L366 518L365 518L365 519L364 518L362 518L362 518L362 518L362 519L361 520L361 521L360 521L360 521L359 522L359 522L359 522L359 522L359 522L358 522L358 523L357 523L356 523L356 523L355 523L354 522L354 522L354 522L353 522L353 522L353 522L353 522L352 523L352 524L351 524L352 525L352 525L352 525L352 525L352 526L352 527L351 527L351 527L351 529L350 528L350 528L350 529L350 529L349 532L349 533L350 534L351 534L353 534L353 534L356 535L356 535L358 534L358 534L359 534L359 534L360 534L360 534L361 534L361 534L362 534L365 534L365 534L365 534L365 535L365 536L366 537L367 537L367 537L367 539L366 541L366 542L367 542L368 543L369 543L369 543L369 544L369 545L369 546L370 546L370 546L371 546L371 546L372 543L372 543L372 543L373 542L373 542L373 542L373 541L374 541L374 541L374 541L375 540L375 540L376 540L376 539L376 539L376 539L376 539L376 539L375 539L375 538L375 538L375 537L376 537L376 537L376 537L376 537L376 538L376 538L377 539L377 539L377 539L377 538L378 539L379 539L380 538L380 538L380 538L381 538L382 539L382 539L383 539L384 539L384 539L384 539L384 539L384 539L385 537L385 537L386 537L388 536L392 537L392 536L392 536L392 534L392 534L393 532L393 532L393 532z"
        },
        {
            "title": "Kattangur",
            "d": "M398 487L398 487L398 486L398 486L398 486L398 486L398 485L396 484L396 483L396 483L395 483L395 483L394 483L394 482L394 482L394 481L394 481L395 480L395 480L395 480L393 479L391 478L391 478L391 478L391 478L390 477L390 477L390 476L389 476L389 476L388 475L387 475L386 474L386 474L386 474L386 474L386 473L385 473L384 474L384 474L384 475L383 475L383 476L383 476L383 476L383 476L382 477L382 477L383 478L383 478L383 478L384 479L384 479L384 480L384 480L384 480L384 480L383 481L383 482L383 482L382 482L382 482L382 482L381 482L381 482L381 482L381 482L380 481L380 482L379 481L379 482L379 482L379 482L378 482L378 482L378 483L378 483L378 483L378 483L377 483L377 483L377 485L377 485L377 486L377 486L377 487L377 487L378 487L378 487L378 488L378 489L378 489L378 490L377 491L376 492L376 492L376 492L376 493L376 494L376 495L376 496L376 496L376 496L376 496L376 498L376 499L376 499L376 499L376 500L376 500L377 501L377 501L377 501L378 502L379 502L380 503L380 503L380 501L380 499L380 499L381 498L382 498L383 498L384 498L384 499L385 499L385 499L385 499L385 500L385 500L386 500L386 500L386 500L386 500L386 500L387 500L388 500L388 500L389 500L389 501L390 501L390 501L390 501L390 502L389 502L390 502L390 502L389 503L390 503L390 503L390 503L390 503L391 503L391 504L392 504L392 504L392 504L392 504L392 503L392 503L392 503L393 503L393 503L394 503L394 503L394 503L394 503L394 503L394 503L394 503L394 502L395 502L395 502L395 501L396 501L397 501L398 499L398 498L398 498L398 497L398 497L398 496L398 496L399 496L399 496L399 495L400 494L400 494L400 494L399 494L399 494L399 494L399 493L399 493L399 492L399 492L399 492L399 491L399 491L399 490L399 490L399 490L399 490L399 489L399 489L399 489L399 488L399 489L398 488L399 488L398 488L398 487L398 487z"
        },
        {
            "title": "Kethepally",
            "d": "M434 511L434 510L434 510L433 509L433 508L432 506L431 504L429 502L429 500L428 499L427 498L425 495L423 493L422 491L422 490L422 490L423 488L422 487L422 485L422 482L421 482L421 481L421 481L421 480L420 481L420 481L420 482L420 482L419 482L419 483L418 483L418 483L418 483L417 483L417 484L417 483L416 484L416 484L415 483L415 484L415 485L415 485L414 486L414 486L414 487L414 490L413 490L413 491L413 492L413 493L411 493L411 492L411 492L411 492L409 491L409 493L409 494L408 497L407 498L407 498L407 498L407 498L408 498L408 498L409 498L410 498L412 498L411 500L411 501L411 501L412 501L413 502L413 502L413 502L413 502L413 502L413 502L413 502L413 503L414 503L414 504L414 504L414 504L415 504L415 504L415 504L416 504L416 504L416 504L416 505L417 505L417 505L417 506L417 506L417 506L417 506L417 506L417 506L417 507L417 507L417 507L417 507L417 507L417 507L418 508L418 508L418 508L419 508L419 509L419 509L420 509L421 509L421 509L421 509L422 509L422 509L423 509L423 508L423 508L423 508L424 508L424 508L424 508L424 508L424 508L425 508L425 507L426 508L426 507L427 507L427 507L427 507L427 508L427 508L427 508L427 509L427 509L427 510L427 510L427 510L427 510L429 510L431 511L432 511L433 511L433 511L434 511z"
        },
        {
            "title": "Kondamallapally",
            "d": "M338 570L337 570L336 570L336 570L336 570L336 567L336 566L336 565L336 564L334 564L333 564L333 564L332 565L332 565L332 565L332 565L331 566L331 567L331 567L331 567L330 567L329 567L327 566L326 566L326 565L326 564L326 564L325 564L324 564L323 564L322 565L322 564L321 564L321 564L321 566L321 567L320 568L320 568L320 568L321 569L321 569L322 570L322 570L322 570L323 570L323 571L323 571L326 574L325 575L325 575L325 575L325 576L325 576L325 576L325 576L325 576L324 576L324 576L324 576L324 577L324 577L324 577L324 577L325 580L325 580L325 580L325 580L325 580L325 581L325 581L325 581L326 581L326 581L326 581L326 582L326 582L326 582L327 582L327 582L327 582L327 582L327 583L327 583L327 583L327 583L328 583L329 582L329 583L329 583L332 583L332 583L332 583L333 583L333 584L335 586L335 586L336 586L335 585L337 585L337 585L339 585L340 587L340 586L340 587L341 587L342 587L343 587L343 587L343 586L344 585L344 585L344 584L344 584L344 584L344 583L344 583L344 583L345 583L345 583L345 583L344 582L344 582L344 582L343 581L342 581L342 581L342 581L342 580L341 580L341 580L341 580L341 579L341 579L342 579L342 579L342 578L341 578L341 578L341 578L341 578L341 577L341 577L341 577L341 577L341 577L341 577L340 577L340 577L340 576L341 576L341 576L341 576L341 576L340 576L341 575L341 574L341 574L340 574L340 574L340 574L339 573L339 572L339 572L339 572L338 572L338 571L338 570z"
        },
        {
            "title": "Madugulapally",
            "d": "M427 510L427 510L427 510L427 509L427 509L427 508L427 508L427 508L427 507L427 507L427 507L426 507L426 508L425 507L425 508L424 508L424 508L424 508L424 508L424 508L423 508L423 508L423 508L423 509L422 509L422 509L421 509L421 509L421 509L420 509L419 509L419 510L419 510L419 510L419 510L418 511L418 511L417 511L417 512L416 514L416 514L416 514L415 515L415 515L415 515L414 515L413 516L413 516L413 516L413 517L413 518L413 518L413 518L413 518L413 518L413 519L413 519L412 520L413 520L412 520L412 520L412 520L412 520L410 520L410 521L410 521L411 522L410 522L410 523L410 523L409 523L409 523L407 523L407 523L407 523L406 523L406 523L405 523L405 524L405 524L404 524L403 525L403 525L403 525L403 526L402 527L402 527L401 527L400 527L400 528L399 527L399 528L399 528L398 528L398 529L398 528L398 529L398 529L397 529L397 529L397 529L396 530L395 529L395 529L395 529L394 529L393 529L393 530L393 529L393 530L393 530L393 530L393 531L393 531L393 532L393 532L393 532L392 534L392 534L393 534L393 534L394 534L395 535L396 535L396 536L397 536L397 536L397 537L398 538L398 538L398 538L400 538L400 539L400 539L401 540L401 540L401 540L402 539L403 538L404 538L405 538L405 537L405 537L405 537L405 536L405 535L405 534L405 534L406 535L407 535L408 535L408 536L409 537L409 538L409 538L409 538L409 539L409 539L410 539L410 539L410 540L410 540L410 541L411 541L411 541L411 541L412 541L412 541L412 541L412 540L412 541L412 540L413 540L413 540L413 540L413 540L413 540L414 539L414 539L414 539L414 539L414 539L415 539L415 539L415 539L415 539L415 539L415 540L415 540L415 540L414 540L414 541L414 541L414 541L414 541L413 541L413 541L413 542L413 542L413 542L413 542L413 543L413 543L413 542L413 542L413 542L414 542L414 541L414 541L415 541L416 540L416 540L417 540L417 540L418 539L418 539L418 539L418 540L419 540L419 540L419 539L419 539L419 539L419 539L420 538L420 538L420 538L420 538L420 537L420 537L420 537L420 537L419 537L419 537L419 537L419 537L419 537L418 536L418 536L418 536L417 536L417 536L416 536L416 536L416 536L416 536L416 535L417 535L417 535L417 534L417 534L417 533L417 533L417 533L417 533L417 533L418 533L418 532L418 532L418 532L418 532L418 532L419 532L419 532L419 532L419 532L419 532L419 531L419 530L419 531L420 531L420 531L420 531L420 531L420 531L420 532L421 532L422 532L422 532L422 532L423 532L423 531L424 530L424 530L424 529L424 529L424 529L424 528L424 527L424 526L424 525L424 525L424 525L424 525L424 524L423 524L422 523L423 521L423 521L423 520L423 520L424 519L424 519L424 519L424 519L424 519L424 519L425 519L426 518L427 520L427 520L428 520L429 520L429 520L429 520L429 520L429 520L429 519L428 519L428 518L428 518L428 517L428 517L428 517L427 517L428 516L427 516L426 516L426 516L425 516L425 515L425 515L425 515L425 514L425 514L424 514L425 514L424 514L425 513L425 513L425 513L425 513L425 513L425 513L426 513L426 512L427 512L427 512L428 511L427 511L427 511L427 510z"
        },
        {
            "title": "Marriguda",
            "d": "M312 511L312 511L311 511L310 511L309 510L309 512L308 513L308 515L308 515L308 516L308 516L308 516L308 516L308 516L308 516L306 517L304 517L302 516L302 518L303 519L305 519L305 521L305 521L305 521L303 522L303 522L302 522L302 522L301 523L301 524L300 526L300 526L298 526L298 526L298 526L298 526L298 525L298 526L297 526L296 526L296 526L295 525L295 526L295 527L295 527L295 527L295 528L296 528L296 530L296 530L299 531L301 532L302 533L302 533L304 534L304 534L304 534L304 535L305 535L305 535L305 535L305 535L308 537L309 537L309 537L310 537L310 537L311 537L311 538L312 538L314 538L314 538L315 538L315 538L315 538L316 537L316 537L316 537L316 536L316 536L316 535L317 535L318 535L320 535L320 535L320 535L320 534L321 534L321 534L321 534L321 534L322 534L322 533L322 533L322 533L323 533L323 533L325 532L325 532L326 532L327 533L327 533L328 531L327 530L328 529L328 528L328 527L328 527L328 527L328 526L328 526L328 526L329 525L329 525L329 524L329 523L330 523L330 523L329 522L328 522L327 522L327 522L326 522L325 522L324 522L324 522L324 522L323 522L323 521L323 520L323 519L323 519L321 519L321 520L320 520L320 521L320 521L319 522L319 522L320 522L320 522L320 522L319 522L319 522L319 523L318 523L318 522L318 522L317 523L317 523L317 523L318 523L318 523L317 524L317 524L317 525L315 525L315 525L314 525L314 525L314 525L314 524L314 524L313 524L313 524L312 524L312 524L312 524L312 524L311 524L311 524L311 524L311 524L311 523L312 522L311 521L310 519L311 519L312 519L312 519L312 519L313 520L313 519L313 519L314 519L314 519L314 518L313 518L313 518L313 517L313 516L313 515L312 511z"
        },
        {
            "title": "Miryalaguda",
            "d": "M437 529L437 529L437 529L437 529L436 529L436 529L435 528L433 527L433 526L433 526L432 526L433 525L433 525L433 525L433 524L432 524L432 524L433 524L433 523L432 524L432 524L432 524L431 524L432 524L432 524L432 524L431 524L431 523L431 523L431 523L431 523L430 523L430 523L429 522L429 523L429 523L429 523L429 523L429 523L429 524L429 525L428 525L428 526L428 526L428 527L428 527L428 528L428 528L428 528L428 529L427 529L427 529L427 529L427 530L427 530L427 530L427 530L427 530L427 530L427 530L427 530L428 531L428 531L429 531L429 531L429 531L429 531L430 531L430 531L430 532L429 532L429 533L430 533L430 533L430 534L429 534L429 534L430 534L430 535L430 537L430 537L430 537L430 537L430 538L430 538L430 539L430 539L430 539L429 541L429 541L429 541L428 541L428 541L428 541L428 541L428 541L427 541L427 542L427 542L426 542L426 542L426 542L426 542L426 542L425 542L425 542L424 542L422 542L422 542L422 541L422 541L422 541L421 540L422 540L421 540L421 539L421 539L421 539L421 539L421 538L420 538L420 537L420 538L420 538L420 538L420 538L419 539L419 539L419 539L419 539L419 540L419 540L419 540L419 540L419 541L419 541L419 541L420 542L420 542L420 542L419 543L419 543L419 543L419 543L418 543L418 543L418 543L418 544L418 544L418 544L418 544L418 545L418 545L418 545L418 545L418 545L418 546L418 546L417 546L417 547L417 547L416 547L416 547L416 548L416 549L416 549L415 551L415 551L415 551L415 552L415 552L415 552L415 553L416 553L416 553L415 553L416 554L416 554L415 554L415 554L415 554L416 554L416 555L417 555L417 556L418 556L418 556L417 557L418 557L417 557L417 557L417 558L417 558L417 558L417 558L418 559L418 559L418 559L419 559L419 559L419 559L420 559L421 559L421 559L421 559L422 559L422 559L422 559L423 559L423 559L423 559L423 559L423 558L423 558L423 558L424 558L424 558L424 559L425 559L425 560L424 560L424 560L424 560L424 560L424 561L424 562L424 562L424 562L424 562L424 563L424 563L425 563L425 564L425 564L427 564L427 565L429 565L429 562L429 561L428 561L428 561L428 560L428 560L428 560L428 560L428 560L427 560L427 559L427 559L427 559L427 558L427 558L426 558L426 558L426 557L426 557L426 557L426 556L426 556L426 556L426 556L426 556L426 556L426 555L426 555L426 555L426 555L427 556L427 557L427 557L430 556L431 556L431 556L431 556L431 556L432 556L432 557L432 557L432 557L433 557L434 557L434 557L435 558L436 558L436 558L436 558L436 558L437 558L437 558L437 558L438 557L438 558L438 557L439 558L439 558L439 558L439 558L439 558L440 558L440 558L441 558L441 557L442 558L442 558L443 558L443 557L444 558L444 557L445 558L445 558L445 558L446 558L445 556L445 554L446 552L446 551L445 550L445 549L443 548L442 547L441 542L440 541L439 539L438 538L437 537L437 536L437 536L437 533L437 529z"
        },
        {
            "title": "Munugode",
            "d": "M327 504L329 504L330 505L331 505L331 506L332 506L332 507L332 507L330 509L330 510L330 511L330 512L331 512L333 512L334 513L335 513L335 513L336 513L336 513L337 514L338 514L338 514L340 515L341 514L342 513L343 513L345 514L345 515L345 515L345 515L345 515L344 516L345 516L345 516L345 516L345 517L346 517L347 517L346 518L347 518L347 519L347 519L347 519L348 519L348 521L348 522L348 522L347 523L348 523L349 523L351 523L352 524L352 523L353 522L353 522L353 522L353 522L354 522L354 521L355 519L355 518L355 518L355 518L355 518L355 518L355 517L355 517L355 517L355 517L355 517L355 516L355 515L355 514L355 514L355 513L356 513L357 512L358 513L358 512L358 512L358 512L358 512L358 511L358 511L357 511L357 511L357 511L357 511L356 511L356 511L355 511L355 510L356 509L356 509L356 508L357 508L357 508L358 508L359 507L359 507L359 507L360 506L360 506L359 505L360 505L360 504L360 503L360 503L361 502L360 502L359 501L359 501L358 501L357 500L357 500L357 499L356 499L356 498L355 498L355 498L355 498L354 498L352 498L352 498L350 497L350 497L349 497L348 497L348 498L348 498L348 498L347 498L347 498L346 499L346 500L345 500L345 501L345 501L344 502L344 502L343 502L344 501L343 501L343 501L343 500L343 500L343 500L343 500L343 499L342 499L342 498L341 498L341 497L341 497L342 496L341 495L340 495L340 494L340 494L340 494L340 494L340 493L340 492L339 491L339 491L339 491L339 491L338 492L337 493L336 493L335 493L335 493L335 493L335 492L335 491L334 491L334 491L333 491L333 492L332 492L332 493L332 493L332 493L332 493L332 494L332 494L332 494L332 494L332 494L334 495L334 495L334 495L334 496L334 496L333 497L333 498L332 498L331 500L331 501L331 501L329 500L328 500L327 500L327 500L327 500L327 501L327 501L328 502L327 502L327 502L327 503L327 503L327 504z"
        },
        {
            "title": "Nakrekal",
            "d": "M406 485L404 485L404 484L403 484L402 484L402 484L403 484L403 483L402 483L403 483L402 483L401 484L400 486L400 486L400 486L399 486L399 486L399 487L399 487L398 487L398 487L398 488L399 488L398 488L399 489L399 488L399 489L399 489L399 489L399 490L399 490L399 490L399 490L399 491L399 491L399 492L399 492L399 492L399 493L399 493L399 494L399 494L399 494L400 494L400 494L400 494L399 495L399 496L399 496L398 496L398 496L398 497L398 497L398 498L398 498L398 499L397 501L396 501L395 501L396 502L398 502L398 502L398 502L399 503L398 503L399 503L399 504L399 504L399 504L399 505L399 505L399 505L401 505L401 506L402 506L403 506L403 506L403 507L403 508L403 508L403 510L404 510L405 510L406 510L407 511L407 510L407 510L407 510L407 509L408 509L408 509L408 509L408 509L408 509L408 509L409 508L409 508L409 508L409 508L409 508L410 508L410 507L410 507L411 507L411 507L411 507L411 507L412 507L412 508L413 508L413 508L413 508L413 508L414 507L414 507L414 507L414 507L415 506L415 506L415 506L416 506L416 506L416 506L417 506L417 506L417 506L417 506L417 505L417 505L416 505L416 504L416 504L416 504L415 504L415 504L415 504L414 504L414 504L414 504L414 503L413 503L413 502L413 502L413 502L413 502L413 502L413 502L413 502L412 501L411 501L411 501L411 500L412 498L410 498L409 498L408 498L408 498L407 498L407 498L407 498L407 498L408 497L409 494L409 493L409 491L411 492L411 492L411 492L411 493L413 493L413 492L413 491L413 490L414 490L414 487L414 486L414 486L415 485L415 485L415 484L415 483L416 484L416 484L417 483L417 484L417 483L418 483L418 483L418 483L419 483L419 482L420 482L420 482L420 481L420 481L421 480L420 480L420 480L420 480L419 479L418 479L417 480L416 479L416 479L414 478L414 478L414 478L413 478L413 478L413 479L413 479L413 479L413 479L411 479L410 479L410 479L411 480L411 480L411 480L411 480L411 481L411 481L410 482L410 482L410 482L410 482L410 483L410 483L409 482L409 483L409 483L409 483L408 483L408 484L408 484L408 484L407 484L407 484L407 485L407 485L407 485L407 485L407 485L406 485L406 485z"
        },
        {
            "title": "Nalgonda",
            "d": "M395 501L395 502L395 502L394 502L394 503L394 503L394 503L394 503L394 503L394 503L394 503L393 503L393 503L392 503L392 503L392 503L392 504L392 504L392 504L392 504L391 504L391 503L390 503L390 503L390 503L390 503L389 503L390 502L390 502L389 502L390 502L390 501L390 501L390 501L389 501L389 500L388 500L388 500L387 500L386 500L386 500L386 500L386 500L386 500L385 500L385 500L385 499L385 499L385 499L384 499L384 498L383 498L382 498L381 498L380 499L380 499L380 501L380 503L380 503L379 502L378 502L377 501L377 501L377 501L376 500L376 500L376 499L376 499L376 499L375 499L375 499L375 499L374 499L374 500L374 501L374 501L372 499L371 499L370 499L370 499L370 499L367 499L366 499L365 498L364 500L363 501L363 502L362 503L362 503L362 503L361 503L360 503L360 503L360 504L360 505L359 505L360 506L360 506L359 507L359 507L359 507L358 508L357 508L357 508L356 508L356 509L356 509L355 510L355 511L356 511L356 511L357 511L357 511L357 511L357 511L358 511L358 511L358 512L358 512L358 512L358 512L358 513L357 512L356 513L355 513L355 514L355 514L355 515L355 516L355 517L355 517L355 517L355 517L355 517L355 518L355 518L355 518L355 518L355 518L355 519L354 521L354 522L354 522L354 522L355 523L356 523L356 523L357 523L358 523L358 522L359 522L359 522L359 522L359 522L359 522L360 521L360 521L361 521L361 520L362 519L362 518L362 518L362 518L364 518L365 519L365 518L366 518L366 518L367 519L368 520L368 521L368 521L369 522L369 522L370 522L370 522L371 522L371 523L371 523L371 523L371 523L372 523L373 522L373 522L373 522L373 522L374 522L374 522L375 522L375 522L375 521L377 522L378 524L378 525L378 526L379 527L379 527L379 528L379 528L379 528L379 528L379 528L380 528L380 528L379 529L379 530L379 530L380 530L380 530L381 530L381 530L381 530L381 530L382 531L382 531L382 531L383 532L384 532L385 532L385 532L385 531L385 531L385 531L386 530L385 530L385 529L385 529L385 529L385 529L385 528L385 528L385 528L385 528L385 527L385 527L386 527L386 527L387 527L387 527L387 527L387 527L387 528L387 529L387 529L388 531L388 531L388 531L388 531L388 531L388 531L389 531L391 532L393 532L393 531L393 531L393 530L393 530L393 530L393 530L393 529L392 529L392 529L392 528L392 527L392 526L391 526L391 525L391 524L391 524L391 523L392 522L391 521L391 521L391 521L390 521L390 521L388 521L388 520L387 520L387 520L387 520L386 519L385 519L386 518L386 518L386 517L386 517L386 516L387 516L386 516L386 515L386 515L387 515L387 515L388 515L388 515L388 515L389 515L389 515L390 513L390 512L390 512L391 512L392 512L392 511L392 510L392 509L392 509L393 509L393 509L393 509L393 509L393 509L394 509L394 509L394 509L394 508L395 508L396 508L397 507L398 506L399 505L399 505L399 505L399 504L399 504L399 504L399 503L398 503L399 503L398 502L398 502L398 502L396 502L395 501z"
        },
        {
            "title": "Nampally",
            "d": "M343 536L342 536L342 536L342 536L341 537L341 537L341 537L341 538L341 538L341 538L341 539L340 539L340 539L340 540L340 540L340 541L340 541L337 541L337 541L337 541L337 540L336 540L336 540L336 540L336 540L336 539L336 539L337 539L336 538L338 538L338 538L338 537L338 537L338 537L338 536L337 536L337 536L337 536L337 536L337 535L337 535L337 535L337 535L337 534L337 534L336 534L336 533L336 533L334 532L333 530L333 530L332 529L332 529L332 529L331 529L331 530L330 530L329 529L329 529L329 529L329 529L328 529L328 529L327 530L328 531L327 533L327 533L326 532L325 532L325 532L323 533L323 533L322 533L322 533L322 533L322 534L321 534L321 534L321 534L321 534L320 534L320 535L320 535L320 535L318 535L317 535L316 535L316 536L316 536L316 537L316 537L316 537L315 538L315 538L315 538L314 538L314 538L312 538L311 538L311 539L311 540L311 540L311 540L311 540L310 543L310 543L310 543L310 543L310 545L311 545L311 545L311 546L311 546L311 546L311 547L313 547L314 548L316 549L318 549L317 549L318 549L318 549L318 550L318 550L318 550L318 550L319 550L321 551L321 551L321 551L321 551L321 551L321 552L321 553L321 554L320 554L321 554L320 555L320 556L320 556L320 556L321 556L321 557L322 557L322 557L322 558L322 558L322 558L322 559L322 559L322 559L322 560L322 561L321 562L321 564L321 564L322 564L321 564L322 564L322 565L323 564L324 564L325 564L326 564L326 564L326 565L326 566L327 566L329 567L330 567L331 567L331 567L331 567L331 566L332 565L332 565L332 565L332 565L333 564L333 564L334 564L335 562L335 562L335 562L335 560L335 560L335 559L335 559L335 559L335 559L336 556L336 556L336 556L337 555L337 555L338 553L337 553L337 551L337 550L337 550L337 550L337 550L337 549L338 548L339 547L339 546L340 545L341 543L341 543L341 542L342 542L342 542L342 542L343 542L343 541L343 541L343 541L342 541L342 540L343 537L343 536z"
        },
        {
            "title": "Narketpally",
            "d": "M386 461L385 462L384 462L382 461L380 461L379 461L377 462L377 462L376 462L376 461L375 462L375 462L375 463L375 464L375 465L375 465L376 465L376 466L377 466L377 466L377 467L378 467L378 467L377 467L377 468L377 469L377 469L375 468L374 468L374 468L374 468L373 469L372 469L372 470L372 471L372 472L371 473L371 474L370 477L369 477L369 478L369 477L368 477L368 477L366 476L366 476L366 476L366 476L366 476L366 477L366 478L366 479L365 479L365 480L365 480L365 480L365 481L365 482L364 484L364 485L363 485L363 486L363 486L362 486L362 486L362 486L362 486L361 487L361 488L361 488L361 489L360 490L360 490L360 491L360 491L359 492L358 492L358 494L357 494L357 495L356 496L355 498L356 498L356 499L357 499L357 500L357 500L358 501L359 501L359 501L360 502L361 502L360 503L361 503L362 503L362 503L362 503L363 502L363 501L364 500L365 498L366 499L367 499L370 499L370 499L370 499L371 499L372 499L374 501L374 501L374 500L374 499L375 499L375 499L375 499L376 499L376 498L376 496L376 496L376 496L376 496L376 495L376 494L376 493L376 492L376 492L376 492L377 491L378 490L378 489L378 489L378 488L378 487L378 487L377 487L377 487L377 486L377 486L377 485L377 485L377 483L377 483L378 483L378 483L378 483L378 483L378 482L378 482L379 482L379 482L379 482L379 481L380 482L380 481L381 482L381 482L381 482L381 482L382 482L382 482L382 482L383 482L383 482L383 481L384 480L384 480L384 480L384 480L384 479L384 479L383 478L383 478L383 478L382 477L382 477L383 476L383 476L383 476L383 476L383 475L384 475L384 474L384 474L385 473L384 473L385 472L384 472L384 471L383 471L384 470L384 469L384 469L385 467L385 467L385 467L385 467L385 466L385 465L386 464L386 463L386 462L386 462L386 461z"
        },
        {
            "title": "Neredugommu",
            "d": "M343 587L342 587L341 587L340 587L340 586L340 587L339 585L337 585L337 585L335 585L336 586L335 586L335 586L333 584L333 583L332 583L332 583L332 583L329 583L329 585L328 587L328 588L328 587L328 588L328 588L326 588L325 588L325 588L325 588L325 588L325 589L325 589L325 589L325 590L325 590L325 591L325 592L325 592L325 593L325 593L325 594L326 594L326 595L326 595L326 596L326 596L326 596L327 596L327 596L327 597L330 597L333 597L333 598L334 598L335 599L336 599L337 600L338 601L339 600L340 600L341 600L342 603L339 603L339 605L340 606L343 606L346 612L347 614L348 613L349 613L351 608L352 607L354 605L353 605L353 605L353 605L351 604L349 604L345 603L346 601L348 601L348 600L350 600L349 600L350 600L350 601L351 600L351 601L351 601L351 601L351 600L352 600L352 600L352 600L352 600L353 600L353 599L353 599L353 599L353 599L353 599L353 599L353 598L354 597L354 596L354 596L354 596L354 596L354 596L353 595L353 596L352 595L352 595L351 594L349 594L348 594L348 594L348 594L348 594L348 594L348 594L347 593L346 592L345 592L344 591L344 591L344 591L344 591L344 591L344 591L344 590L344 590L344 590L343 588L343 587z"
        },
        {
            "title": "Nidamanoor",
            "d": "M401 540L401 540L401 540L400 539L400 539L400 538L398 538L398 538L398 538L397 537L397 536L397 536L396 536L396 535L395 535L394 534L393 534L393 534L392 534L392 536L392 536L392 537L388 536L386 537L385 537L385 537L384 539L384 539L384 539L384 539L384 540L384 543L386 543L386 544L387 545L387 545L387 545L387 546L387 546L387 547L387 547L388 547L388 548L389 548L389 548L389 548L390 548L390 548L391 548L391 550L391 553L391 554L391 554L392 554L392 555L393 555L393 555L393 555L393 556L393 556L393 557L393 559L394 560L395 560L396 560L396 561L396 561L397 561L396 561L397 562L398 562L399 563L400 564L400 565L400 565L399 566L399 567L399 567L399 569L398 570L398 570L399 571L399 571L399 571L399 571L400 570L400 570L400 570L400 570L400 570L400 570L401 570L402 570L403 570L403 570L403 570L404 570L404 570L404 569L404 569L405 569L405 569L405 568L407 569L407 569L408 569L409 570L409 570L409 570L410 570L410 570L411 570L411 570L412 570L412 569L412 569L412 568L411 568L411 567L412 567L411 567L412 566L411 566L411 566L410 565L411 565L411 565L410 564L410 563L410 563L410 563L411 562L411 561L411 561L411 560L411 559L411 559L412 559L412 558L412 557L412 556L412 556L412 555L411 555L411 555L411 555L410 554L410 553L410 552L409 552L408 552L408 552L408 552L408 551L408 551L408 551L408 550L408 550L407 550L406 549L406 549L405 548L405 548L405 548L404 548L404 548L403 548L403 548L402 548L402 548L401 548L401 548L400 548L400 548L399 547L399 546L400 545L400 545L401 545L401 545L402 544L402 544L403 543L403 543L402 543L402 543L402 542L402 541L402 541L401 541L401 540z"
        },
        {
            "title": "Peda Adisharla Palli",
            "d": "M360 573L355 572L355 572L355 572L355 571L355 572L354 571L354 571L353 571L353 571L353 571L353 571L352 571L352 571L352 571L351 571L351 569L351 569L350 568L350 568L350 568L350 568L350 568L349 568L349 568L347 568L347 568L348 569L347 569L347 569L347 570L347 570L347 570L346 570L346 571L345 571L344 570L344 571L344 571L343 572L343 572L343 572L343 572L342 573L342 572L342 573L342 573L341 573L342 573L342 573L341 573L341 574L340 573L340 574L340 574L340 574L341 574L341 574L341 575L340 576L341 576L341 576L341 576L341 576L340 576L340 577L340 577L341 577L341 577L341 577L341 577L341 577L341 577L341 578L341 578L341 578L341 578L342 578L342 579L342 579L341 579L341 579L341 580L341 580L341 580L342 580L342 581L342 581L342 581L343 581L344 582L344 582L344 582L345 583L345 583L345 583L344 583L344 583L344 583L344 584L344 584L344 584L344 585L344 585L343 586L343 587L343 587L343 588L344 590L344 590L344 590L344 591L344 591L344 591L344 591L344 591L344 591L345 592L346 592L347 593L348 594L348 594L348 594L348 594L348 594L348 594L349 594L351 594L352 595L352 595L353 596L353 595L354 596L354 596L354 596L354 596L354 596L354 597L353 598L353 599L353 599L353 599L353 599L353 599L353 599L353 600L352 600L352 600L352 600L352 600L351 600L351 601L351 601L351 601L351 600L350 601L350 600L349 600L350 600L348 600L348 601L346 601L345 603L349 604L351 604L353 605L353 605L353 605L354 605L354 605L355 607L355 607L356 607L356 607L358 607L358 607L359 607L362 607L363 605L363 609L362 612L361 614L362 618L364 619L369 621L369 618L370 618L371 617L373 616L373 616L371 614L371 613L370 613L370 612L370 611L370 611L370 609L370 609L371 608L372 606L372 605L373 605L374 604L375 604L375 603L376 603L376 602L376 602L376 601L376 600L376 599L377 598L377 598L378 598L379 598L379 598L381 599L382 599L383 599L384 598L384 598L385 597L386 596L386 596L386 595L386 595L386 595L386 595L386 594L386 594L386 594L386 594L386 593L385 593L385 593L385 592L385 592L384 592L384 592L384 592L384 592L384 591L384 591L384 591L383 591L383 590L382 589L382 588L381 588L380 588L380 588L380 587L380 587L380 587L381 587L381 587L381 586L381 586L381 586L381 586L381 586L381 586L381 586L381 586L381 586L381 586L381 585L381 585L381 586L381 585L378 583L377 583L376 583L376 585L374 586L371 584L371 585L370 585L371 584L371 584L370 584L370 584L370 585L368 584L368 585L368 586L367 585L366 585L366 585L366 585L365 586L364 588L364 589L366 589L366 590L365 590L365 590L364 590L364 590L363 589L363 589L361 589L360 589L360 589L359 589L359 588L359 589L359 589L358 588L358 587L358 587L358 587L358 586L358 586L358 586L358 585L359 585L359 585L361 585L361 585L361 584L361 584L361 584L360 584L360 584L359 585L359 585L358 585L358 584L358 584L358 584L357 584L357 584L356 583L357 582L358 580L358 580L359 580L359 580L360 579L360 578L361 578L361 578L361 577L361 577L360 576L360 575L360 574L360 574L360 573z"
        },
        {
            "title": "Peddavoora",
            "d": "M379 564L378 564L379 563L378 562L378 562L378 562L378 561L379 560L379 559L379 559L379 558L380 558L380 558L380 557L379 556L379 556L378 555L378 555L377 554L376 554L376 555L374 554L372 554L372 553L371 553L370 552L369 552L369 552L369 553L368 553L368 554L368 555L368 556L368 556L368 556L368 556L368 557L367 557L367 557L366 557L366 557L366 557L365 558L364 558L364 559L364 559L364 560L364 560L363 560L364 559L363 560L363 561L363 562L362 564L362 564L362 565L362 565L362 566L362 567L362 567L362 567L362 567L362 567L362 570L362 570L362 571L361 572L360 573L360 573L360 574L360 574L360 575L360 576L361 577L361 577L361 578L361 578L360 578L360 579L359 580L359 580L358 580L358 580L357 582L356 583L357 584L357 584L358 584L358 584L358 584L358 585L359 585L359 585L360 584L360 584L361 584L361 584L361 584L361 585L361 585L359 585L359 585L358 585L358 586L358 586L358 586L358 587L358 587L358 587L358 588L359 589L359 589L359 588L359 589L360 589L360 589L361 589L363 589L363 589L364 590L364 590L365 590L365 590L366 590L366 589L364 589L364 588L365 586L366 585L366 585L366 585L367 585L368 586L368 585L368 584L370 585L370 584L370 584L371 584L371 584L370 585L371 585L371 584L374 586L376 585L376 583L377 583L378 583L381 585L381 586L381 585L381 585L381 586L381 586L381 586L381 586L381 586L381 586L381 586L381 586L381 586L381 586L381 587L381 587L380 587L380 587L380 587L380 588L380 588L381 588L382 588L382 589L383 590L383 591L384 591L384 591L384 591L384 592L384 592L384 592L384 592L385 592L385 592L385 593L385 593L386 593L386 594L386 594L386 594L386 594L386 595L386 595L386 595L386 595L386 596L387 596L389 596L390 595L391 595L391 595L392 594L393 595L393 595L394 595L394 594L392 590L393 588L391 589L389 590L387 589L387 587L383 585L383 584L384 583L385 580L384 577L384 577L384 577L385 576L385 576L385 575L385 574L385 574L385 574L385 573L385 573L385 573L382 572L382 572L382 572L381 572L381 571L380 571L379 572L379 571L379 571L379 570L379 570L379 570L380 569L380 568L380 568L380 568L380 567L379 567L379 567L379 567L378 567L378 567L378 566L378 565L378 565L379 564L379 564z"
        },
        {
            "title": "Shaligouraram",
            "d": "M406 485L406 485L407 485L407 485L407 485L407 485L407 485L407 484L407 484L408 484L408 484L408 484L408 483L409 483L409 483L409 483L409 482L410 483L410 483L410 482L410 482L410 482L410 482L411 481L411 481L411 480L411 480L411 480L411 480L410 479L410 479L411 479L413 479L413 479L413 479L413 479L413 478L413 478L414 478L414 478L414 478L416 479L416 479L417 480L418 479L419 479L418 478L417 477L417 476L417 474L416 473L416 470L415 469L415 468L414 466L412 465L412 464L408 464L405 464L402 464L398 464L397 464L396 464L395 463L394 463L393 462L391 461L389 461L386 461L386 461L386 462L386 462L386 463L386 464L385 465L385 466L385 467L385 467L385 467L385 467L384 469L384 469L384 470L383 471L384 471L384 472L385 472L384 473L385 473L386 473L386 474L386 474L386 474L386 474L387 475L388 475L389 476L389 476L390 476L390 477L390 477L391 478L391 478L391 478L391 478L393 479L395 480L395 480L395 480L394 481L394 481L394 482L394 482L394 483L395 483L395 483L396 483L396 483L396 484L398 485L398 486L398 486L398 486L398 486L398 487L398 487L399 487L399 487L399 486L399 486L400 486L400 486L400 486L401 484L402 483L403 483L402 483L403 483L403 484L402 484L402 484L403 484L404 484L404 485L406 485z"
        },
        {
            "title": "Tipparthy",
            "d": "M417 506L417 506L417 506L416 506L416 506L416 506L415 506L415 506L415 506L414 507L414 507L414 507L414 507L413 508L413 508L413 508L413 508L412 508L412 507L411 507L411 507L411 507L411 507L410 507L410 507L410 508L409 508L409 508L409 508L409 508L409 508L408 509L408 509L408 509L408 509L408 509L408 509L407 509L407 510L407 510L407 510L407 511L406 510L405 510L404 510L403 510L403 508L403 508L403 507L403 506L403 506L402 506L401 506L401 505L399 505L399 505L399 505L398 506L397 507L396 508L395 508L394 508L394 509L394 509L394 509L393 509L393 509L393 509L393 509L393 509L392 509L392 509L392 510L392 511L392 512L391 512L390 512L390 512L390 513L389 515L389 515L388 515L388 515L388 515L387 515L387 515L386 515L386 515L386 516L387 516L386 516L386 517L386 517L386 518L386 518L385 519L386 519L387 520L387 520L387 520L388 520L388 521L390 521L390 521L391 521L391 521L391 521L392 522L391 523L391 524L391 524L391 525L391 526L392 526L392 527L392 528L392 529L392 529L393 529L393 530L393 530L393 529L393 530L393 529L394 529L395 529L395 529L395 529L396 530L397 529L397 529L397 529L398 529L398 529L398 528L398 529L398 528L399 528L399 528L399 527L400 528L400 527L401 527L402 527L402 527L403 526L403 525L403 525L403 525L404 524L405 524L405 524L405 523L406 523L406 523L407 523L407 523L407 523L409 523L409 523L410 523L410 523L410 522L411 522L410 521L410 521L410 520L412 520L412 520L412 520L412 520L413 520L412 520L413 519L413 519L413 518L413 518L413 518L413 518L413 518L413 517L413 516L413 516L413 516L414 515L415 515L415 515L415 515L416 514L416 514L416 514L417 512L417 511L418 511L418 511L419 510L419 510L419 510L419 510L419 509L419 509L419 508L418 508L418 508L418 508L417 507L417 507L417 507L417 507L417 507L417 507L417 506L417 506L417 506L417 506L417 506z"
        },
        {
            "title": "Tirumalagiri_Sagar",
            "d": "M398 570L398 570L398 570L398 570L398 569L398 568L397 568L397 568L396 568L396 568L395 568L395 567L395 567L394 567L394 567L393 567L393 568L392 568L391 568L391 568L390 568L389 568L389 568L389 568L389 568L388 568L387 568L387 568L387 569L386 569L386 569L386 569L386 569L386 569L385 570L385 570L384 570L384 569L385 569L385 569L385 569L385 567L385 566L385 565L385 565L385 564L385 564L385 564L384 564L383 564L382 564L381 564L380 564L380 564L380 564L380 564L379 564L379 564L378 565L378 565L378 566L378 567L378 567L379 567L379 567L379 567L380 567L380 568L380 568L380 568L380 569L379 570L379 570L379 570L379 571L379 571L379 572L380 571L381 571L381 572L382 572L382 572L382 572L385 573L385 573L385 573L385 574L385 574L385 574L385 575L385 576L385 576L384 577L384 577L384 577L385 580L384 583L383 584L383 585L387 587L387 589L389 590L391 589L393 588L392 590L394 594L394 595L393 595L393 595L392 594L391 595L391 595L392 595L392 595L393 596L394 596L397 595L398 595L400 596L404 596L405 595L406 594L407 594L407 592L407 590L407 590L406 589L405 587L404 587L404 587L402 585L403 585L406 583L408 584L408 582L408 581L407 581L406 579L406 579L406 579L406 579L407 578L408 576L409 575L412 574L413 572L412 570L412 570L412 570L411 570L411 570L410 570L410 570L409 570L409 570L409 570L408 569L407 569L407 569L405 568L405 569L405 569L404 569L404 569L404 570L404 570L403 570L403 570L403 570L402 570L401 570L400 570L400 570L400 570L400 570L400 570L400 570L399 571L399 571L399 571L399 571L398 570L398 570z"
        },
        {
            "title": "Tripuraram",
            "d": "M419 540L418 540L418 539L418 539L418 539L417 540L417 540L416 540L416 540L415 541L414 541L414 541L414 542L413 542L413 542L413 542L413 543L413 543L413 542L413 542L413 542L413 542L413 541L413 541L414 541L414 541L414 541L414 541L414 540L415 540L415 540L415 540L415 539L415 539L415 539L415 539L415 539L414 539L414 539L414 539L414 539L414 539L413 540L413 540L413 540L413 540L413 540L412 540L412 541L412 540L412 541L412 541L412 541L411 541L411 541L411 541L410 541L410 540L410 540L410 539L410 539L409 539L409 539L409 538L409 538L409 538L409 537L408 536L408 535L407 535L406 535L405 534L405 534L405 535L405 536L405 537L405 537L405 537L405 538L404 538L403 538L402 539L401 540L401 541L402 541L402 541L402 542L402 543L402 543L403 543L403 543L402 544L402 544L401 545L401 545L400 545L400 545L399 546L399 547L400 548L400 548L401 548L401 548L402 548L402 548L403 548L403 548L404 548L404 548L405 548L405 548L405 548L406 549L406 549L407 550L408 550L408 550L408 551L408 551L408 551L408 552L408 552L408 552L409 552L410 552L410 553L410 554L411 555L411 555L411 555L412 555L412 556L412 556L412 557L412 558L412 559L411 559L411 559L411 560L411 561L411 561L411 562L410 563L410 563L410 563L410 564L411 565L411 565L410 565L411 566L411 566L412 566L411 567L412 567L411 567L411 568L412 568L412 569L412 569L412 570L412 570L412 570L415 572L416 572L415 573L419 572L421 572L420 571L422 571L422 571L422 571L422 571L422 571L422 571L422 570L422 571L422 570L423 569L423 568L422 568L422 567L422 566L422 566L425 565L427 565L427 565L427 564L425 564L425 564L425 563L424 563L424 563L424 562L424 562L424 562L424 562L424 561L424 560L424 560L424 560L424 560L425 560L425 559L424 559L424 558L424 558L423 558L423 558L423 558L423 559L423 559L423 559L423 559L422 559L422 559L422 559L421 559L421 559L421 559L420 559L419 559L419 559L419 559L418 559L418 559L418 559L417 558L417 558L417 558L417 558L417 557L417 557L418 557L417 557L418 556L418 556L417 556L417 555L416 555L416 554L415 554L415 554L415 554L416 554L416 554L415 553L416 553L416 553L415 553L415 552L415 552L415 552L415 551L415 551L415 551L416 549L416 549L416 548L416 547L416 547L417 547L417 547L417 546L418 546L418 546L418 545L418 545L418 545L418 545L418 545L418 544L418 544L418 544L418 544L418 543L418 543L418 543L419 543L419 543L419 543L419 543L420 542L420 542L420 542L419 541L419 541L419 541L419 540L419 540L419 540z"
        },
        {
            "title": "Vemulapally",
            "d": "M434 511L433 511L433 511L432 511L431 511L429 510L427 510L427 510L427 511L427 511L428 511L427 512L427 512L426 512L426 513L425 513L425 513L425 513L425 513L425 513L425 513L424 514L425 514L424 514L425 514L425 514L425 515L425 515L425 515L425 516L426 516L426 516L427 516L428 516L427 517L428 517L428 517L428 517L428 518L428 518L428 519L429 519L429 520L429 520L429 520L429 520L429 520L428 520L427 520L427 520L426 518L425 519L424 519L424 519L424 519L424 519L424 519L424 519L423 520L423 520L423 521L423 521L422 523L423 524L424 524L424 525L424 525L424 525L424 525L424 526L424 527L424 528L424 529L424 529L424 529L424 530L424 530L423 531L423 532L422 532L422 532L422 532L421 532L420 532L420 531L420 531L420 531L420 531L420 531L419 531L419 530L419 531L419 532L419 532L419 532L419 532L419 532L418 532L418 532L418 532L418 532L418 532L418 533L417 533L417 533L417 533L417 533L417 533L417 534L417 534L417 535L417 535L416 535L416 536L416 536L416 536L416 536L417 536L417 536L418 536L418 536L418 536L419 537L419 537L419 537L419 537L419 537L420 537L420 537L420 537L420 537L420 538L421 538L421 539L421 539L421 539L421 539L421 540L422 540L421 540L422 541L422 541L422 541L422 542L422 542L424 542L425 542L425 542L426 542L426 542L426 542L426 542L426 542L427 542L427 542L427 541L428 541L428 541L428 541L428 541L428 541L429 541L429 541L429 541L430 539L430 539L430 539L430 538L430 538L430 537L430 537L430 537L430 537L430 535L430 534L429 534L429 534L430 534L430 533L430 533L429 533L429 532L430 532L430 531L430 531L429 531L429 531L429 531L429 531L428 531L428 531L427 530L427 530L427 530L427 530L427 530L427 530L427 530L427 530L427 529L427 529L427 529L428 529L428 528L428 528L428 528L428 527L428 527L428 526L428 526L428 525L429 525L429 524L429 523L429 523L429 523L429 523L429 523L429 522L430 523L430 523L431 523L431 523L431 523L431 523L431 524L432 524L432 524L432 524L431 524L432 524L432 524L432 524L433 523L433 524L432 524L432 524L433 524L433 525L433 525L433 525L432 526L433 526L433 526L433 527L435 528L436 529L436 529L437 529L437 529L437 529L437 529L437 528L437 528L437 526L437 525L436 524L435 521L434 518L435 517L435 516L435 515L434 514L434 513L434 512L434 511z"
        },
        {
            "title": "Gattuppal",
            "d": "M327 504L327 504L326 505L325 506L324 507L323 507L323 506L322 506L321 506L321 506L321 507L321 507L321 507L320 507L319 509L319 510L319 510L319 511L319 511L318 511L318 513L318 514L317 515L317 515L316 515L315 515L315 513L315 513L315 512L312 511L313 515L313 516L313 517L313 518L313 518L314 518L314 519L314 519L313 519L313 519L313 520L312 519L312 519L312 519L311 519L310 519L311 521L312 522L311 523L311 524L311 524L311 524L311 524L312 524L312 524L312 524L312 524L313 524L313 524L314 524L314 524L314 525L314 525L314 525L315 525L315 525L317 525L317 524L317 524L318 523L318 523L317 523L317 523L317 523L318 522L318 522L318 523L319 523L319 522L319 522L320 522L320 522L320 522L319 522L319 522L320 521L320 521L320 520L321 520L321 519L323 519L323 519L323 520L323 521L323 522L324 522L324 522L324 522L325 522L326 522L327 522L327 522L328 520L328 520L328 518L328 517L329 518L330 518L330 517L330 516L330 516L330 515L330 514L330 513L331 512L330 512L330 511L330 510L330 509L332 507L332 507L332 506L331 506L331 505L330 505L329 504L327 504z"
        },
        {
            "title": "Gudipalli",
            "d": "M360 573L360 573L361 572L362 571L362 570L362 570L362 567L362 567L362 567L362 567L362 567L362 566L362 565L362 565L362 564L362 564L363 562L363 561L363 560L364 559L363 560L364 560L364 560L364 559L364 559L363 559L363 559L363 559L363 559L363 559L363 559L363 559L362 559L362 558L362 558L362 558L362 558L362 558L362 558L362 558L362 558L363 557L361 557L361 557L360 557L359 556L359 556L359 556L359 557L359 557L357 557L357 557L355 557L355 557L355 557L355 557L355 557L354 557L353 557L353 557L353 557L353 558L353 558L353 558L353 558L353 558L353 558L352 558L352 558L351 558L350 559L349 559L347 557L347 558L346 559L346 559L346 559L346 560L346 560L346 560L345 560L345 560L345 561L345 561L344 562L344 562L344 563L344 564L344 564L344 564L344 565L344 565L344 566L344 566L344 566L343 566L343 566L343 566L343 566L343 566L342 567L342 568L341 568L341 568L341 568L340 569L340 569L339 569L338 570L338 570L338 571L338 572L339 572L339 572L339 572L339 573L340 574L340 573L341 574L341 573L342 573L342 573L341 573L342 573L342 573L342 572L342 573L343 572L343 572L343 572L343 572L344 571L344 571L344 570L345 571L346 571L346 570L347 570L347 570L347 570L347 569L347 569L348 569L347 568L347 568L349 568L349 568L350 568L350 568L350 568L350 568L350 568L351 569L351 569L351 571L352 571L352 571L352 571L353 571L353 571L353 571L353 571L354 571L354 571L355 572L355 571L355 572L355 572L355 572L360 573z"
        }
    ],
    "Yadadri Bhuvanagiri": [
        {
            "title": "Addagudur",
            "d": "M396 440L396 440L396 440L395 441L395 441L395 442L394 442L393 442L393 443L392 444L392 445L391 445L392 445L391 446L392 446L392 446L392 446L392 446L393 447L393 447L393 447L393 447L393 447L393 448L393 448L393 448L393 448L392 449L392 450L391 450L390 449L389 449L389 449L389 449L389 450L389 453L388 453L388 454L387 454L387 455L387 455L387 458L387 459L387 460L386 461L386 461L389 461L391 461L393 462L394 463L395 463L396 464L397 464L398 464L402 464L405 464L408 464L412 464L411 464L410 462L409 461L408 460L408 460L406 459L406 459L405 458L404 456L404 455L404 454L405 454L405 453L406 453L406 452L406 451L406 449L405 449L403 445L401 444L400 443L398 442L398 441L396 440z"
        },
        {
            "title": "Alair",
            "d": "M344 398L344 398L343 399L343 399L343 400L343 401L342 401L341 400L341 399L340 399L340 399L340 399L339 398L339 399L339 400L339 400L339 400L339 400L338 400L337 400L337 400L337 400L336 401L335 400L335 401L335 402L335 403L335 403L335 404L335 404L335 404L336 405L336 405L337 406L338 407L339 408L339 408L339 408L339 409L339 409L339 409L339 411L339 412L339 413L340 414L340 415L339 415L341 416L341 416L342 416L343 416L343 417L342 417L342 418L342 418L342 418L343 419L343 418L343 418L343 418L343 418L344 418L344 419L345 419L346 419L346 418L346 418L346 418L347 417L347 418L347 418L348 418L348 418L348 418L348 418L349 419L349 419L349 419L349 420L349 420L349 421L349 423L350 423L352 422L352 422L353 422L356 422L356 422L356 422L358 422L358 422L358 422L359 424L359 424L359 424L360 425L360 425L361 424L362 425L363 425L363 425L364 425L364 424L364 424L364 423L363 423L363 422L362 422L362 421L362 421L361 420L362 419L362 418L362 417L362 416L362 416L362 416L361 415L360 415L360 413L360 413L359 413L359 412L358 412L358 411L358 410L358 408L358 408L357 407L357 408L357 408L356 408L354 407L353 407L353 406L353 406L353 406L353 406L352 406L353 405L353 405L352 405L352 405L351 404L351 403L351 402L351 402L351 402L350 401L350 401L350 400L350 400L349 400L349 400L348 399L348 399L348 399L348 399L348 399L347 399L346 398L345 398L344 398z"
        },
        {
            "title": "Athmakur (M)",
            "d": "M374 442L375 441L375 439L375 438L375 438L375 438L376 436L376 436L376 436L377 436L376 434L376 434L376 433L376 432L376 432L375 432L374 431L374 431L374 431L374 432L373 433L373 433L372 433L371 433L371 434L371 434L370 434L370 434L370 435L369 435L369 435L369 434L369 433L368 433L368 433L367 432L367 432L367 432L366 432L366 432L365 432L365 432L365 432L365 432L364 433L364 434L363 434L362 433L362 433L361 433L359 432L358 432L357 432L356 432L356 431L354 432L354 432L353 433L353 433L352 434L353 434L353 435L354 436L354 437L354 437L354 440L354 440L354 440L354 441L354 441L353 441L351 442L349 442L349 444L349 446L350 446L350 446L351 446L351 446L352 446L353 446L355 446L355 446L355 447L355 447L357 448L357 449L357 449L358 450L357 450L357 450L357 450L356 451L356 452L356 452L356 452L356 453L356 455L356 455L357 455L358 455L358 454L358 454L358 453L360 454L360 454L360 455L361 455L361 454L361 454L362 454L363 453L363 454L363 454L363 454L364 454L365 454L365 454L365 455L366 454L367 453L367 453L368 453L368 453L369 453L369 451L370 451L371 449L372 447L372 446L372 446L374 446L374 445L374 444L374 442z"
        },
        {
            "title": "B.Pochampally",
            "d": "M316 456L316 456L316 456L315 455L315 455L315 454L314 454L314 453L313 452L311 451L312 450L312 447L313 446L313 446L312 446L312 446L311 448L310 449L310 450L310 450L309 451L309 451L308 451L308 451L307 451L306 451L304 452L304 452L304 452L304 452L301 452L301 452L300 453L298 453L298 454L295 456L295 456L293 456L292 456L292 457L292 457L292 458L292 460L291 461L291 461L291 462L291 462L289 461L288 462L288 462L288 463L288 463L288 464L288 464L288 464L288 464L289 465L290 465L290 465L291 466L291 466L292 466L292 466L292 466L292 465L292 466L292 466L294 465L294 465L295 465L295 465L295 465L295 465L295 465L295 466L295 467L296 468L296 468L296 469L296 470L296 470L297 470L297 470L298 469L298 469L298 470L299 470L302 471L303 471L303 471L304 471L306 471L307 472L308 472L308 473L307 473L307 473L308 473L308 473L308 474L308 474L309 474L309 474L310 474L310 474L310 473L311 473L311 473L312 473L312 473L313 473L314 473L314 472L315 470L315 470L315 469L315 467L314 466L314 466L314 466L315 465L316 464L316 464L317 463L317 463L318 463L319 462L320 463L320 462L320 462L321 462L321 462L321 462L321 461L321 461L321 460L321 460L321 459L321 459L321 458L319 459L319 459L318 458L318 457L317 456L316 456z"
        },
        {
            "title": "Bhongiri",
            "d": "M340 430L338 431L336 431L334 430L334 428L333 428L332 428L332 428L331 428L331 428L331 428L331 427L331 425L330 425L330 425L329 424L328 424L327 425L327 424L326 424L325 424L325 424L325 424L325 423L324 423L323 423L322 423L321 423L320 423L320 422L320 422L319 422L319 422L318 421L317 421L316 422L315 422L314 421L314 421L314 421L314 421L313 420L312 420L311 422L311 423L312 423L312 423L311 424L310 424L309 424L308 424L308 424L308 425L307 425L307 426L307 426L307 427L308 427L307 429L308 429L308 429L309 430L309 430L309 431L309 431L309 431L309 431L308 433L307 432L307 432L307 432L307 432L307 432L305 432L305 431L305 432L305 432L305 433L305 433L305 433L305 433L305 433L306 433L306 433L306 434L307 434L308 435L308 435L308 435L309 436L309 437L310 437L309 437L309 437L308 437L309 438L309 439L308 439L309 439L310 441L310 442L310 442L310 442L311 442L311 443L311 443L312 443L312 442L313 441L314 441L314 440L315 441L316 441L316 441L318 441L318 442L317 442L317 443L317 444L317 444L317 444L317 444L317 444L318 445L319 445L320 445L319 445L320 446L320 446L321 446L321 447L322 447L321 449L321 449L320 449L320 449L319 449L317 449L318 448L317 448L317 447L316 448L316 448L316 448L316 448L316 449L316 450L316 450L316 451L317 451L317 452L317 452L317 453L317 454L317 455L317 455L316 456L317 456L318 457L318 458L319 459L319 459L321 458L322 457L323 457L323 457L324 457L324 457L324 457L324 457L324 457L325 457L324 457L324 455L324 455L325 454L326 454L326 454L326 454L326 454L327 452L327 451L328 451L328 450L329 449L329 449L329 447L329 445L330 444L330 443L332 443L333 443L334 443L334 443L334 443L335 443L336 444L337 443L337 443L337 442L338 442L339 441L339 441L340 441L340 440L341 440L341 439L341 439L342 439L343 438L344 436L344 435L344 435L344 434L344 434L344 434L344 434L344 434L343 434L341 432L341 432L341 431L341 431L340 431L340 430L340 430z"
        },
        {
            "title": "Bibinagar",
            "d": "M305 433L304 433L304 433L304 433L303 432L302 431L302 431L301 431L300 431L300 432L300 433L300 433L299 434L298 435L297 434L297 434L296 433L295 433L295 433L294 433L294 433L293 433L293 433L291 432L290 433L290 433L289 432L289 432L288 432L289 433L288 433L288 434L288 434L288 435L288 436L288 438L288 438L288 439L288 439L288 440L289 441L290 441L290 441L291 441L294 441L295 441L295 441L295 442L296 442L296 443L296 444L295 445L295 446L296 448L296 449L296 449L296 450L295 451L295 451L296 451L295 452L295 452L295 452L294 453L293 453L293 453L293 454L292 454L292 455L292 455L292 455L292 455L292 455L292 456L293 456L295 456L295 456L298 454L298 453L300 453L301 452L301 452L304 452L304 452L304 452L304 452L306 451L307 451L308 451L308 451L309 451L309 451L310 450L310 450L310 449L311 448L312 446L312 446L313 446L313 446L312 447L312 450L311 451L313 452L314 453L314 454L315 454L315 455L315 455L316 456L316 456L316 456L317 455L317 455L317 454L317 453L317 452L317 452L317 451L316 451L316 450L316 450L316 449L316 448L316 448L316 448L316 448L317 447L317 448L318 448L317 449L319 449L320 449L320 449L321 449L321 449L322 447L321 447L321 446L320 446L320 446L319 445L320 445L319 445L318 445L317 444L317 444L317 444L317 444L317 444L317 443L317 442L318 442L318 441L316 441L316 441L315 441L314 440L314 441L313 441L312 442L312 443L311 443L311 443L311 442L310 442L310 442L310 442L310 441L309 439L308 439L309 439L309 438L308 437L309 437L309 437L310 437L309 437L309 436L308 435L308 435L308 435L307 434L306 434L306 433L306 433L305 433L305 433L305 433L305 433L305 433z"
        },
        {
            "title": "Bommalaramaram",
            "d": "M292 407L291 407L291 408L290 409L289 410L289 410L288 411L289 412L286 412L287 413L286 414L284 415L284 415L285 415L285 415L286 417L287 417L287 417L287 417L287 417L287 417L286 417L286 418L285 420L285 420L285 420L285 420L285 421L285 421L285 421L284 422L284 423L284 423L285 424L285 424L286 425L287 426L287 426L286 427L286 427L286 428L286 428L286 428L286 429L287 429L287 430L287 430L287 431L288 431L288 431L288 432L289 432L289 432L290 433L290 433L291 432L293 433L293 433L294 433L294 433L295 433L295 433L296 433L297 434L297 434L298 435L299 434L300 433L300 433L300 432L300 431L301 431L302 431L302 431L303 432L304 433L304 433L304 433L305 433L305 432L305 432L305 431L305 432L307 432L307 432L307 432L307 432L307 432L308 433L309 431L309 431L309 431L309 431L309 430L309 430L308 429L308 429L307 429L308 427L307 427L307 426L307 426L307 425L308 425L308 424L308 424L308 423L308 422L308 422L309 421L308 421L307 420L306 420L306 420L306 420L305 420L303 419L303 419L303 418L303 418L302 417L301 416L300 416L300 416L300 416L299 416L298 416L297 416L297 416L297 416L296 416L296 416L296 416L296 416L296 415L296 414L295 413L295 413L295 413L295 412L295 412L295 412L295 412L295 411L295 411L294 411L294 410L294 410L293 410L293 409L293 408L293 408L292 407z"
        },
        {
            "title": "Choutuppal",
            "d": "M320 463L319 462L318 463L317 463L317 463L316 464L316 464L315 465L314 466L314 466L314 466L315 467L315 469L315 470L315 470L314 472L314 473L313 473L312 473L312 473L311 473L311 473L310 473L310 474L310 474L309 474L309 474L308 474L308 474L308 473L308 473L307 473L307 473L308 473L308 472L307 472L306 471L304 471L303 471L303 471L302 471L299 470L298 470L298 469L298 469L297 470L297 470L296 470L296 470L295 470L294 471L294 471L294 471L294 471L294 471L294 471L294 471L293 471L293 471L293 471L293 472L293 472L294 473L294 473L294 473L295 474L295 474L295 474L295 475L295 475L294 476L294 476L295 477L297 479L298 480L298 479L299 480L300 480L301 480L302 481L304 482L305 483L305 486L306 487L306 487L307 488L308 488L308 488L308 488L309 489L309 489L309 488L310 489L310 489L311 489L311 489L312 488L313 488L313 487L314 487L313 486L314 486L314 486L315 486L316 486L316 485L316 485L317 486L317 486L318 486L319 486L319 487L320 487L321 487L321 486L322 486L322 486L323 487L323 487L323 486L325 487L326 488L327 488L328 488L329 489L329 488L330 486L331 486L331 486L331 486L331 485L331 485L331 483L332 483L332 482L332 480L332 480L332 479L332 478L332 478L332 477L332 476L332 475L332 474L332 474L333 474L334 474L334 473L334 471L335 470L335 469L334 469L334 469L334 468L333 468L333 468L330 467L330 467L329 466L328 465L328 465L327 465L326 465L325 465L325 465L325 465L324 465L324 465L324 465L324 465L324 464L323 464L323 464L321 463L321 463L320 463z"
        },
        {
            "title": "Gundala",
            "d": "M372 419L373 418L373 418L372 417L372 417L371 416L370 415L370 416L368 420L367 420L367 420L366 421L366 421L366 422L366 422L364 423L364 424L364 424L364 425L363 425L363 425L363 426L362 426L361 427L361 427L361 427L361 427L361 427L362 428L362 428L363 427L364 428L364 428L364 428L364 428L364 427L364 427L364 427L364 427L365 427L365 428L365 429L365 429L365 430L365 430L365 430L366 430L367 430L367 430L367 431L367 432L367 432L368 433L368 433L369 433L369 434L369 435L369 435L370 435L370 434L370 434L371 434L371 434L371 433L372 433L373 433L373 433L374 432L374 431L374 431L374 431L375 432L376 432L376 432L376 433L376 434L376 434L377 436L376 436L376 436L376 436L375 438L375 438L375 438L375 439L375 441L374 442L375 441L375 441L376 441L376 441L377 441L378 442L378 442L379 442L379 440L380 438L381 437L382 438L382 438L383 439L384 440L383 441L383 442L383 442L385 443L386 444L387 445L388 445L389 445L390 446L391 445L392 445L392 444L393 443L393 442L394 442L395 442L395 441L395 441L396 440L396 440L396 440L397 439L397 438L396 438L396 438L396 437L396 437L396 437L397 437L398 436L399 435L398 435L395 433L395 433L394 433L394 433L393 433L393 433L392 433L392 433L390 433L389 432L389 432L389 432L389 431L389 430L389 430L389 430L387 429L388 429L388 428L387 428L386 427L386 428L385 427L385 427L385 427L384 426L384 426L384 426L384 425L384 425L384 425L383 424L382 423L381 424L381 424L380 425L379 427L378 427L377 426L374 426L374 425L374 423L374 423L373 423L372 422L372 421L371 421L372 420L372 420L372 419L372 419z"
        },
        {
            "title": "Motakondur",
            "d": "M342 420L341 422L341 423L341 423L341 423L341 424L341 425L341 425L341 425L341 425L341 425L341 425L340 427L340 428L340 429L340 429L340 429L340 429L340 429L340 429L340 429L340 429L340 429L339 430L340 429L340 430L340 430L340 430L340 430L340 430L340 430L340 431L341 431L341 431L341 432L341 432L343 434L344 434L344 434L344 434L344 434L344 434L344 435L344 435L344 436L343 438L342 439L341 439L341 439L341 440L342 441L343 442L343 442L344 443L345 444L345 445L346 445L347 445L347 445L347 445L349 446L349 446L349 444L349 442L351 442L353 441L354 441L354 441L354 440L354 440L354 440L354 437L354 437L354 436L353 435L353 434L352 434L353 433L353 433L354 432L354 432L356 431L356 432L357 432L358 432L359 432L361 433L362 433L362 433L363 434L364 434L364 433L365 432L365 432L365 432L365 432L366 432L366 432L367 432L367 432L367 431L367 430L367 430L366 430L365 430L365 430L365 430L365 429L365 429L365 428L365 427L364 427L364 427L364 427L364 427L364 428L364 428L364 428L364 428L363 427L362 428L362 428L361 427L361 427L361 427L361 427L361 427L362 426L363 426L363 425L362 425L361 424L360 425L360 425L359 424L359 424L359 424L358 422L358 422L358 422L356 422L356 422L356 422L353 422L352 422L352 422L350 423L349 423L349 421L349 420L349 420L349 419L349 419L349 419L348 418L348 418L348 418L348 418L347 418L347 418L347 417L346 418L346 418L346 418L346 419L345 419L344 419L344 418L343 418L343 418L343 418L343 418L343 419L342 418L342 419L342 420L342 420z"
        },
        {
            "title": "Mothkur",
            "d": "M391 445L390 446L389 445L388 445L387 445L386 444L385 443L383 442L383 442L383 441L384 440L383 439L382 438L382 438L381 437L380 438L379 440L379 442L378 442L378 442L377 441L376 441L376 441L375 441L375 441L374 442L374 444L374 445L374 446L372 446L372 446L372 447L371 449L370 451L369 451L369 453L368 453L368 453L367 453L367 453L366 454L365 455L366 455L369 457L369 457L370 457L371 458L371 458L371 458L371 458L371 458L372 459L372 459L372 459L373 459L374 459L374 459L374 460L375 461L375 461L376 461L376 462L377 462L377 462L379 461L380 461L382 461L384 462L385 462L386 461L386 461L386 461L387 460L387 459L387 458L387 455L387 455L387 454L388 454L388 453L389 453L389 450L389 449L389 449L389 449L390 449L391 450L392 450L392 449L393 448L393 448L393 448L393 448L393 447L393 447L393 447L393 447L393 447L392 446L392 446L392 446L392 446L391 446L392 445L391 445z"
        },
        {
            "title": "Narayanapoor",
            "d": "M305 486L305 486L304 486L303 486L303 487L303 488L303 488L302 488L300 487L299 487L297 486L296 485L296 486L297 487L297 488L298 489L298 490L298 490L299 490L299 490L299 490L299 491L299 492L300 493L301 494L300 495L300 495L299 494L298 495L298 495L298 496L299 497L299 497L299 498L299 498L300 498L300 498L300 499L300 499L300 499L301 499L302 499L302 500L303 500L305 502L307 503L308 503L308 505L307 504L306 504L305 504L305 506L305 506L306 507L307 507L307 507L308 508L308 509L308 509L309 510L309 510L309 510L310 511L311 511L312 511L312 511L315 512L315 513L315 513L315 515L316 515L317 515L317 515L318 514L318 513L318 511L319 511L319 511L319 510L319 510L319 509L320 507L321 507L321 507L321 507L321 506L321 506L322 506L323 506L323 507L324 507L325 506L326 505L327 504L327 504L327 503L327 503L327 502L327 502L328 502L327 501L327 501L327 500L327 500L327 500L328 500L329 500L331 501L331 501L331 500L332 498L333 498L333 497L334 496L334 496L334 495L334 495L334 495L332 494L332 494L332 494L332 494L332 494L332 493L332 493L332 493L332 493L332 493L332 492L331 492L331 492L331 491L331 491L330 490L329 490L329 489L329 489L329 489L328 488L327 488L326 488L325 487L323 486L323 487L323 487L322 486L322 486L321 486L321 487L320 487L319 487L319 486L318 486L317 486L317 486L316 485L316 485L316 486L315 486L314 486L314 486L313 486L314 487L313 487L313 488L312 488L311 489L311 489L310 489L310 489L309 488L309 489L309 489L308 488L308 488L308 488L307 488L306 487L306 487L305 486z"
        },
        {
            "title": "Rajapeta",
            "d": "M339 398L339 397L337 396L337 396L337 396L337 395L337 395L337 394L336 394L336 393L336 393L336 392L336 392L337 390L336 389L335 387L336 387L335 386L335 386L334 385L334 385L333 385L333 386L330 386L330 387L328 387L328 387L327 386L327 386L326 385L324 384L321 383L320 383L320 384L319 384L320 384L319 384L319 384L319 384L318 383L318 383L317 383L316 383L315 383L315 383L315 383L315 383L315 385L315 386L315 387L315 387L315 387L314 390L314 391L314 392L314 392L313 393L314 394L314 394L315 395L316 395L316 397L315 399L314 400L314 401L315 402L319 404L319 405L319 404L319 405L320 405L318 408L318 408L318 409L318 409L319 409L319 410L320 410L321 410L321 410L322 411L322 410L322 409L323 409L323 408L324 408L324 407L325 407L326 407L327 407L328 407L329 407L330 406L331 406L331 407L332 406L333 406L335 406L335 404L335 404L335 403L335 403L335 402L335 401L335 400L336 401L337 400L337 400L337 400L338 400L339 400L339 400L339 400L339 400L339 399L339 398z"
        },
        {
            "title": "Ramannapet",
            "d": "M376 461L375 461L375 461L374 460L374 459L374 459L373 459L372 459L372 460L371 460L369 461L369 461L368 462L367 462L367 462L365 462L365 463L364 464L363 464L362 464L359 464L358 464L358 463L357 463L356 462L354 461L353 461L351 461L350 462L348 462L348 462L348 462L347 462L345 461L345 460L345 460L344 460L343 461L343 461L343 462L343 462L342 465L342 466L343 466L342 467L342 467L342 467L342 468L342 468L342 468L342 469L340 469L340 469L339 469L338 469L338 469L336 469L335 469L335 470L334 471L334 473L334 474L335 475L336 476L336 476L338 477L342 477L343 478L343 478L344 478L344 478L345 479L345 479L346 479L346 478L347 478L346 478L347 478L347 479L347 479L348 479L350 480L350 480L351 480L352 481L353 481L353 480L353 479L353 479L353 479L354 478L354 477L355 475L355 475L355 475L356 475L357 475L357 475L357 475L358 475L358 475L358 475L360 474L361 475L361 475L362 474L360 476L360 476L360 476L361 477L361 478L362 478L362 478L362 478L362 478L362 478L363 479L363 479L363 479L363 479L363 479L363 479L364 479L364 479L365 479L365 480L365 480L365 479L366 479L366 478L366 477L366 476L366 476L366 476L366 476L366 476L368 477L368 477L369 477L369 478L369 477L370 477L371 474L371 473L372 472L372 471L372 470L372 469L373 469L374 468L374 468L374 468L375 468L377 469L377 469L377 468L377 467L378 467L378 467L377 467L377 466L377 466L376 466L376 465L375 465L375 465L375 464L375 463L375 462L375 462L376 461z"
        },
        {
            "title": "Turkapalle_M",
            "d": "M319 409L318 409L318 409L318 408L318 408L320 405L319 405L319 404L319 405L319 404L315 402L314 401L314 400L315 399L316 397L316 395L315 395L314 394L314 394L313 393L312 393L312 393L310 393L310 393L310 393L310 393L309 394L308 395L308 395L307 395L307 395L307 396L307 397L308 397L306 398L306 398L306 400L306 401L306 401L305 401L304 400L303 400L302 400L302 400L300 400L301 400L301 400L301 401L301 401L302 402L301 402L300 402L300 403L300 403L298 404L298 404L298 404L296 404L296 404L296 404L296 404L296 404L294 404L293 406L292 407L293 408L293 408L293 409L293 410L294 410L294 410L294 411L295 411L295 411L295 412L295 412L295 412L295 412L295 413L295 413L295 413L296 414L296 415L296 416L296 416L296 416L296 416L297 416L297 416L297 416L298 416L299 416L300 416L300 416L300 416L301 416L302 417L303 418L303 418L303 419L303 419L305 420L306 420L306 420L306 420L307 420L308 421L309 421L308 422L308 422L308 423L308 424L309 424L310 424L311 424L312 423L312 423L311 423L311 422L312 420L312 419L312 419L312 419L312 419L312 419L311 418L311 417L311 416L313 416L315 417L316 417L316 417L318 417L318 416L318 416L318 415L318 415L318 413L318 412L318 410L319 409z"
        },
        {
            "title": "Valigonda",
            "d": "M349 446L349 446L347 445L347 445L347 445L346 445L345 445L345 444L344 443L343 442L343 442L342 441L341 440L340 440L340 441L339 441L339 441L338 442L337 442L337 443L337 443L336 444L335 443L334 443L334 443L334 443L333 443L332 443L330 443L330 444L329 445L329 447L329 449L329 449L328 450L328 451L327 451L327 452L326 454L326 454L326 454L326 454L325 454L324 455L324 455L324 457L325 457L324 457L324 457L324 457L324 457L324 457L323 457L323 457L322 457L321 458L321 459L321 459L321 460L321 460L321 461L321 461L321 462L321 462L321 462L320 462L320 462L320 463L321 463L321 463L323 464L323 464L324 464L324 465L324 465L324 465L324 465L325 465L325 465L325 465L326 465L327 465L328 465L328 465L329 466L330 467L330 467L333 468L333 468L334 468L334 469L334 469L335 469L336 469L338 469L338 469L339 469L340 469L340 469L342 469L342 468L342 468L342 468L342 467L342 467L342 467L343 466L342 466L342 465L343 462L343 462L343 461L343 461L344 460L345 460L345 460L345 461L347 462L348 462L348 462L348 462L350 462L351 461L353 461L354 461L356 462L357 463L358 463L358 464L359 464L362 464L363 464L364 464L365 463L365 462L367 462L367 462L368 462L369 461L369 461L371 460L372 460L372 459L372 459L372 459L371 458L371 458L371 458L371 458L371 458L370 457L369 457L369 457L366 455L365 455L365 454L365 454L364 454L363 454L363 454L363 454L363 453L362 454L361 454L361 454L361 455L360 455L360 454L360 454L358 453L358 454L358 454L358 455L357 455L356 455L356 455L356 453L356 452L356 452L356 452L356 451L357 450L357 450L357 450L358 450L357 449L357 449L357 448L355 447L355 447L355 446L355 446L353 446L352 446L351 446L351 446L350 446L350 446L349 446z"
        },
        {
            "title": "Yadagirigutta",
            "d": "M342 420L342 420L342 419L342 418L342 418L342 418L342 417L343 417L343 416L342 416L341 416L341 416L339 415L340 415L340 414L339 413L339 412L339 411L339 409L339 409L339 409L339 408L339 408L339 408L338 407L337 406L336 405L336 405L335 404L335 404L335 406L333 406L332 406L331 407L331 406L330 406L329 407L328 407L327 407L326 407L325 407L324 407L324 408L323 408L323 409L322 409L322 410L322 411L321 410L321 410L320 410L319 410L319 409L318 410L318 412L318 413L318 415L318 415L318 416L318 416L318 417L316 417L316 417L315 417L313 416L311 416L311 417L311 418L312 419L312 419L312 419L312 419L312 419L312 420L313 420L314 421L314 421L314 421L314 421L315 422L316 422L317 421L318 421L319 422L319 422L320 422L320 422L320 423L321 423L322 423L323 423L324 423L325 423L325 424L325 424L325 424L326 424L327 424L327 425L328 424L329 424L330 425L330 425L331 425L331 427L331 428L331 428L331 428L332 428L332 428L333 428L334 428L334 430L336 431L338 431L340 430L340 430L340 430L340 430L340 430L340 429L339 430L340 429L340 429L340 429L340 429L340 429L340 429L340 429L340 429L340 429L340 428L340 427L341 425L341 425L341 425L341 425L341 425L341 425L341 424L341 423L341 423L341 423L341 422L342 420z"
        }
    ],
    "Mahabubnagar": [
        {
            "title": "Addakal",
            "d": "M169 595L168 594L167 594L165 595L165 594L164 594L164 594L164 594L163 594L163 594L163 594L161 596L161 597L161 597L161 597L161 596L160 595L159 595L159 595L159 594L159 594L159 593L158 593L158 593L158 593L157 593L156 593L156 593L155 592L155 592L154 594L153 596L153 596L152 595L152 595L152 595L152 595L151 595L151 595L150 595L148 595L148 595L147 595L146 595L146 595L145 596L145 597L145 597L145 598L145 598L145 598L146 598L145 599L146 599L147 600L148 601L149 602L151 602L150 603L150 603L150 604L150 604L150 605L150 605L151 606L151 606L151 606L151 607L150 608L150 609L150 609L150 610L150 611L150 611L150 612L149 612L149 612L149 612L149 612L148 612L148 613L148 613L147 614L146 614L146 614L145 616L145 616L147 616L148 615L150 615L150 615L150 615L151 615L151 615L151 616L152 616L152 616L154 617L154 616L155 616L155 615L155 615L155 614L155 614L155 613L156 613L156 613L156 613L156 612L157 612L157 611L157 610L157 610L158 609L158 609L159 608L162 608L162 608L162 608L162 607L163 607L163 607L162 607L163 607L163 606L164 607L165 606L166 606L166 606L165 606L166 605L166 605L165 604L166 604L167 604L167 604L167 603L168 602L169 601L171 602L171 602L171 602L170 599L168 597L169 596L169 595z"
        },
        {
            "title": "Balanagar",
            "d": "M214 528L213 527L212 528L211 528L209 527L209 528L208 530L208 531L206 532L205 531L205 531L204 530L204 530L204 529L204 529L204 529L203 529L202 529L202 529L201 527L200 526L200 526L199 526L199 525L200 524L200 523L200 523L200 522L199 521L198 521L198 520L198 520L198 520L197 520L197 520L197 520L197 519L196 519L196 519L193 519L192 519L192 523L191 522L190 522L189 522L189 524L190 524L189 524L187 524L187 524L186 524L186 524L185 524L184 524L184 525L184 527L184 528L184 528L184 528L184 529L183 529L184 530L184 531L185 532L185 533L186 533L188 533L189 533L190 533L190 533L190 534L190 534L190 534L191 535L192 534L192 535L193 534L195 535L199 537L200 537L200 538L201 539L201 538L202 539L202 538L202 538L202 538L202 538L202 538L202 537L202 537L202 536L203 536L203 536L204 537L205 537L205 537L208 538L208 537L208 538L208 540L208 542L208 543L209 544L209 544L210 545L211 546L212 547L213 548L214 548L214 547L214 547L214 547L215 546L216 544L216 543L217 543L219 542L219 542L219 541L219 541L219 539L219 539L219 539L219 538L219 538L219 538L219 536L219 535L219 535L217 535L215 535L214 533L214 532L215 531L215 529L214 528z"
        },
        {
            "title": "Bhoothpur",
            "d": "M184 566L183 567L182 567L181 568L180 568L179 568L179 568L178 568L178 567L178 567L178 566L177 566L176 566L176 566L175 566L175 567L174 568L174 568L174 568L173 569L173 570L172 570L172 570L172 570L171 570L170 571L170 571L170 571L169 572L169 572L169 572L170 570L170 570L170 570L169 570L169 570L167 570L166 570L166 571L166 571L166 571L166 573L165 572L164 572L164 573L164 575L165 576L165 577L165 578L165 578L167 578L167 579L167 579L167 579L167 579L167 580L167 579L167 580L166 580L166 580L166 581L166 581L166 581L166 581L167 582L167 582L168 583L168 583L169 583L169 583L169 583L169 582L169 581L170 581L170 580L170 580L171 581L171 581L172 581L172 581L172 581L172 582L172 582L173 582L173 582L174 583L174 585L174 585L175 585L176 585L177 585L178 585L178 585L178 585L179 586L180 586L180 587L180 587L181 588L184 589L185 590L185 590L185 590L187 590L187 590L188 590L188 591L188 591L188 591L188 591L188 591L189 591L189 591L189 590L189 590L190 589L190 588L190 588L190 587L190 587L190 587L190 586L190 585L191 584L192 584L193 582L194 582L194 581L194 581L194 581L192 579L191 579L192 577L192 577L192 576L192 576L191 576L190 575L190 575L188 574L187 573L187 573L187 572L186 571L186 571L187 569L187 569L187 569L187 569L186 568L186 567L184 566z"
        },
        {
            "title": "Chinna Chinta Kunta",
            "d": "M136 597L136 595L136 595L136 593L137 592L136 590L135 588L135 588L135 587L135 586L134 586L134 586L132 586L132 586L132 587L132 588L132 588L132 589L133 589L133 590L133 591L133 591L133 592L133 593L133 593L132 593L132 594L132 594L131 595L131 595L129 595L128 595L128 595L127 595L127 594L127 595L126 595L126 595L126 595L126 595L126 595L126 596L126 596L126 596L126 596L127 597L126 597L126 597L127 597L127 598L127 598L127 599L127 599L127 599L127 600L127 600L128 600L128 600L129 601L129 602L129 602L129 602L129 605L128 605L127 605L127 605L126 605L125 605L124 605L124 606L125 606L126 607L127 607L127 607L127 607L127 607L127 607L127 607L128 607L128 607L128 607L128 607L128 607L128 607L128 608L128 608L128 609L128 609L127 611L127 611L127 612L126 612L125 611L125 611L125 611L124 611L124 612L124 612L124 612L123 613L124 614L124 614L124 614L125 615L125 615L124 615L125 616L126 616L126 616L126 616L126 616L126 616L125 616L125 616L125 616L125 617L124 617L124 617L124 617L124 617L124 618L125 618L125 619L125 619L125 620L125 620L125 620L125 620L126 620L126 620L126 620L127 620L127 619L127 619L128 619L128 620L128 620L129 619L129 619L129 619L129 619L130 618L131 618L131 619L132 619L132 619L133 619L133 619L133 620L133 621L133 621L134 622L134 623L134 623L134 624L134 625L134 625L134 625L135 625L135 626L135 626L137 627L137 627L138 627L138 627L138 627L138 626L138 626L138 624L138 624L138 624L139 624L138 623L138 622L139 622L139 621L139 621L140 621L140 621L140 621L140 621L141 621L141 621L141 621L141 621L141 620L141 620L142 620L142 620L142 619L144 618L145 618L145 618L145 617L145 616L145 616L145 616L146 614L146 614L146 614L146 614L145 614L144 614L144 614L144 614L143 614L143 615L142 615L142 614L142 614L142 614L142 614L142 614L142 613L141 613L141 613L141 613L140 613L140 613L139 613L139 613L139 613L138 613L138 613L138 613L138 614L138 614L138 614L138 614L138 614L138 614L138 614L138 614L137 614L137 614L135 610L134 607L134 606L134 605L135 604L136 603L136 602L136 601L136 600L136 599L136 597z"
        },
        {
            "title": "Devarkadra",
            "d": "M155 581L154 581L152 582L152 582L150 581L150 581L146 580L146 580L146 580L146 580L146 580L146 580L146 580L146 579L146 579L145 579L145 579L146 579L144 577L144 577L144 575L144 575L143 574L143 574L143 574L143 574L142 573L142 573L141 572L140 571L141 569L142 568L140 567L138 567L135 566L135 565L135 565L134 566L134 566L133 567L133 567L133 568L132 568L132 569L132 569L132 569L132 570L131 571L130 572L130 573L129 574L130 575L130 577L130 578L130 578L131 580L132 580L132 581L133 582L135 583L135 584L135 586L135 586L135 587L135 588L135 588L136 590L137 592L136 593L136 595L136 595L136 597L137 597L137 597L138 596L140 597L140 598L140 598L140 598L140 599L140 599L141 599L141 598L142 598L143 598L143 598L144 598L144 599L144 599L144 599L144 599L144 599L144 599L145 599L146 599L145 599L146 598L145 598L145 598L145 598L145 597L145 597L145 596L146 595L146 595L147 595L148 595L148 595L150 595L150 593L151 590L154 590L154 590L154 589L154 588L155 587L156 586L156 586L156 585L156 585L156 584L155 581z"
        },
        {
            "title": "Gandeed",
            "d": "M130 520L130 520L130 521L129 521L129 522L129 523L129 523L129 523L130 524L129 525L129 525L129 525L129 525L128 526L128 526L128 527L128 528L127 528L127 528L127 528L128 528L128 528L128 528L128 528L128 528L128 528L128 528L128 529L128 529L128 529L128 529L127 529L126 529L126 529L125 529L125 530L125 530L124 529L124 529L124 530L126 531L126 531L126 531L126 532L126 532L126 532L126 534L126 534L127 535L127 535L127 535L126 536L126 536L126 536L126 536L126 537L126 538L126 539L126 539L126 540L126 540L126 540L125 540L125 540L126 541L126 541L127 541L127 541L127 541L127 541L127 541L128 541L128 541L128 541L128 541L128 542L129 542L129 542L129 542L130 542L130 542L130 542L130 542L130 542L130 541L130 541L131 541L131 541L134 541L134 541L134 542L135 542L135 541L138 538L138 539L139 539L139 540L140 540L140 540L141 539L143 539L143 537L143 537L142 536L143 535L142 534L142 533L141 532L140 531L140 531L140 531L140 530L140 530L140 530L140 529L140 530L140 529L140 529L140 529L140 529L141 530L141 530L142 530L142 529L144 529L144 527L144 527L144 527L144 527L144 527L144 526L143 526L144 526L144 526L143 526L143 527L143 527L142 526L142 526L142 526L142 526L142 526L141 526L141 526L141 526L141 525L141 525L142 524L142 523L141 523L141 523L140 523L140 523L140 523L139 522L139 522L138 522L137 521L136 522L135 521L135 521L134 521L134 521L133 521L133 521L133 521L133 521L133 521L133 521L132 520L132 520L131 520L130 520z"
        },
        {
            "title": "Koilkonda",
            "d": "M134 541L134 541L131 541L131 541L130 541L130 541L130 542L130 542L130 542L130 542L130 542L129 542L129 542L129 542L128 542L128 541L128 541L128 541L128 541L127 541L127 541L127 541L127 541L127 541L126 541L126 541L125 540L125 540L125 541L124 542L125 543L125 544L125 544L125 544L124 545L124 545L124 546L125 547L125 547L125 547L125 548L126 548L126 548L126 548L126 549L126 549L126 550L126 550L126 550L126 550L126 550L126 551L125 551L125 552L124 553L125 553L125 555L126 555L126 556L125 557L123 556L122 556L122 556L122 556L122 556L121 555L120 557L119 556L119 556L119 556L118 555L118 555L118 556L117 556L116 556L115 556L116 557L115 558L115 558L115 559L115 559L115 561L115 561L116 562L117 562L119 563L122 563L123 562L124 563L125 563L125 563L126 564L126 564L126 565L127 565L127 566L128 567L128 568L128 568L128 568L127 569L127 569L127 569L127 570L127 570L126 571L128 571L129 571L129 571L129 571L129 572L129 572L129 572L130 572L131 571L132 570L132 569L132 569L132 569L132 568L133 568L133 567L133 567L134 566L134 566L135 565L135 565L135 566L138 567L140 567L142 568L145 569L145 569L146 570L148 570L148 569L148 569L148 569L148 568L148 568L149 568L150 565L150 565L150 564L150 563L150 563L150 563L152 563L152 563L153 563L153 563L154 562L154 561L153 561L153 561L153 561L152 560L151 558L151 558L150 556L150 555L149 553L146 553L145 553L143 553L142 553L142 553L142 553L142 552L141 552L140 551L138 552L138 552L137 552L137 551L136 551L135 551L134 551L134 551L134 551L134 551L133 552L133 552L129 550L129 550L130 550L130 549L130 548L131 549L131 548L131 548L131 547L131 546L130 545L130 545L131 545L132 544L132 544L133 543L134 541z"
        },
        {
            "title": "Hanwada",
            "d": "M139 540L139 539L138 539L138 538L135 541L135 542L134 542L134 541L133 543L132 544L132 544L131 545L130 545L130 545L131 546L131 547L131 548L131 548L131 549L130 548L130 549L130 550L129 550L129 550L133 552L133 552L134 551L134 551L134 551L134 551L135 551L136 551L137 551L137 552L138 552L138 552L140 551L141 552L142 552L142 553L142 553L142 553L143 553L145 553L146 553L149 553L150 555L150 556L151 558L151 558L152 560L153 561L153 561L153 561L154 561L154 561L155 561L156 561L157 561L157 561L157 560L158 560L159 560L159 560L160 560L159 561L160 561L160 562L160 563L161 563L161 563L163 563L163 563L163 562L164 562L164 561L165 561L165 561L165 560L165 560L164 559L163 559L163 558L165 556L165 556L165 555L166 555L167 554L167 552L167 551L166 550L166 549L167 549L167 549L166 548L167 548L167 548L165 547L165 547L163 546L163 545L162 543L161 543L158 545L158 546L158 546L158 546L157 546L157 547L156 547L156 547L156 547L156 547L155 546L154 546L155 545L155 545L155 545L155 544L154 544L154 544L153 544L153 545L152 545L151 545L151 544L150 545L150 544L150 545L150 545L149 545L149 545L148 545L148 545L148 545L147 546L146 546L146 546L147 545L147 544L147 544L147 544L147 543L146 544L146 544L146 544L146 544L146 545L146 545L145 545L145 545L144 545L144 545L144 545L143 545L143 544L143 545L143 545L139 543L139 542L139 540z"
        },
        {
            "title": "Jadcherla",
            "d": "M222 551L223 551L223 551L223 549L223 548L223 548L224 547L223 547L222 546L222 546L222 546L222 545L222 545L222 544L222 544L221 543L219 542L217 543L216 543L216 544L215 546L214 547L214 547L214 547L214 548L213 548L212 547L211 546L210 545L209 544L209 544L208 545L208 545L207 546L207 548L206 549L206 549L206 549L205 549L205 549L204 549L204 548L203 548L201 548L201 548L201 548L201 548L200 549L199 550L199 550L197 550L195 550L193 551L193 550L193 549L193 548L191 548L191 547L190 547L190 547L189 547L188 547L187 547L185 546L185 546L185 547L184 547L184 548L184 548L183 548L183 548L182 548L182 548L182 548L182 548L181 548L181 548L181 548L181 548L180 548L180 548L180 548L180 548L179 548L178 548L178 548L178 549L179 550L180 551L178 552L178 552L178 552L178 553L178 554L177 554L176 557L176 557L177 557L178 558L180 559L182 560L183 560L183 561L183 562L184 563L184 563L184 564L184 566L186 567L186 568L187 569L187 569L187 569L187 569L186 571L186 571L187 572L187 573L187 573L188 574L190 575L190 575L191 576L192 576L192 576L192 576L192 576L193 575L193 574L194 573L194 573L194 572L195 571L195 570L195 569L196 568L197 568L197 568L197 568L198 567L199 567L199 567L199 568L199 568L199 570L199 571L200 572L200 572L202 572L203 571L203 571L204 570L204 569L204 568L205 568L206 567L206 566L206 566L206 566L206 565L206 564L206 563L205 563L205 563L205 563L205 562L205 561L206 561L206 561L206 561L206 560L207 560L207 560L208 560L208 560L208 560L208 559L208 558L208 557L207 557L207 557L207 557L207 556L206 556L206 556L206 556L207 556L207 556L207 555L207 555L207 554L207 554L208 554L211 554L211 553L213 552L213 552L214 553L215 553L216 553L217 553L219 554L219 553L220 552L220 552L221 552L222 552L222 551z"
        },
        {
            "title": "Mahabubnagar_Urban",
            "d": "M169 555L169 557L169 557L168 558L168 558L168 558L168 558L167 558L167 557L166 557L166 557L166 556L165 556L165 555L165 556L165 556L163 558L163 559L164 559L165 560L165 560L165 561L165 561L164 561L164 562L163 562L163 563L163 563L161 563L161 563L160 563L160 563L159 563L159 564L159 564L160 565L161 566L161 566L161 567L161 567L162 568L163 569L163 569L163 569L165 569L165 570L166 570L166 571L166 571L166 571L166 570L167 570L169 570L169 570L170 570L170 570L170 570L169 572L169 572L169 572L170 571L170 571L170 571L171 570L172 570L172 570L172 570L173 570L173 569L174 568L174 568L174 568L175 567L175 566L176 566L176 566L177 566L178 566L178 567L178 567L178 568L179 568L179 568L180 568L181 568L182 567L183 567L184 566L184 564L184 563L184 563L183 562L183 561L183 560L182 560L180 559L178 558L177 557L176 557L174 558L172 556L172 556L171 556L170 556L169 555z"
        },
        {
            "title": "Midjil",
            "d": "M222 551L222 552L221 552L220 552L220 552L219 553L219 554L217 553L216 553L215 553L214 553L213 552L213 552L211 553L211 554L208 554L207 554L207 554L207 555L207 555L207 556L207 556L206 556L206 556L206 556L207 556L207 557L207 557L207 557L208 557L208 558L208 559L208 560L208 560L208 560L207 560L207 560L206 560L206 561L206 561L206 561L205 561L205 562L205 563L205 563L205 563L206 563L206 564L206 565L206 566L206 566L206 566L206 566L207 566L207 566L207 566L207 566L207 566L208 566L209 567L209 567L209 567L210 568L211 568L212 569L213 571L213 571L213 571L215 572L218 574L218 575L218 575L218 575L219 575L220 575L221 575L221 575L221 575L221 576L222 577L222 577L222 576L222 576L222 576L223 576L224 576L225 575L225 575L227 576L227 576L227 574L228 574L228 573L227 572L227 571L228 569L229 568L229 567L230 566L230 565L230 565L230 563L230 563L229 562L229 562L227 561L227 559L227 558L226 558L225 558L225 557L224 557L224 556L224 556L224 556L224 556L224 555L224 554L224 553L224 552L223 552L222 551z"
        },
        {
            "title": "Moosapet",
            "d": "M167 582L166 582L166 582L162 582L162 582L157 580L155 581L156 584L156 585L156 585L156 586L156 586L155 587L154 588L154 589L154 590L154 590L151 590L150 593L150 595L151 595L151 595L152 595L152 595L152 595L152 595L153 596L153 596L154 594L155 592L155 592L156 593L156 593L157 593L158 593L158 593L158 593L159 593L159 594L159 594L159 595L159 595L160 595L161 596L161 597L161 597L161 597L161 596L163 594L163 594L163 594L164 594L164 594L164 594L165 594L165 595L167 594L168 594L169 595L169 595L170 595L170 595L170 595L170 595L171 595L171 595L172 595L172 595L171 594L171 594L171 594L171 593L171 593L170 593L170 593L170 592L170 592L171 592L171 592L171 592L171 592L171 592L171 591L171 591L170 591L170 591L170 591L169 591L169 591L169 591L169 591L169 591L169 590L168 591L168 590L169 590L169 590L168 589L168 588L169 588L169 588L169 588L169 587L170 587L170 587L170 587L170 586L170 586L170 586L170 586L170 586L170 585L170 586L170 586L170 586L170 586L170 587L171 587L171 587L171 587L172 587L172 587L173 586L174 585L174 585L174 583L173 582L173 582L172 582L172 582L172 581L172 581L172 581L171 581L171 581L170 580L170 580L170 581L169 581L169 582L169 583L169 583L169 583L168 583L168 583L167 582z"
        },
        {
            "title": "Nawabpet",
            "d": "M181 520L181 520L180 520L179 521L179 521L179 521L178 520L177 520L176 520L176 519L176 519L176 519L175 519L175 519L174 518L174 518L174 518L174 519L172 520L172 521L171 521L172 521L171 521L171 521L171 522L172 523L171 524L169 524L169 524L169 524L169 525L169 525L168 526L168 527L168 527L167 527L167 527L167 527L167 528L170 529L171 529L171 529L171 530L171 530L170 530L170 532L170 532L170 533L171 533L171 535L171 535L171 536L171 536L171 537L170 537L170 538L169 538L168 538L168 538L166 540L166 540L166 541L166 541L166 541L165 542L165 542L166 542L166 543L167 543L168 543L169 544L170 544L170 544L170 544L170 545L170 545L170 545L171 545L170 545L170 546L170 546L171 546L171 546L171 547L171 547L170 547L170 547L169 547L169 548L168 548L167 548L166 548L167 549L167 549L166 549L166 550L167 551L167 552L167 554L167 554L168 554L168 555L169 555L170 556L171 556L172 556L172 556L174 558L176 557L176 557L177 554L178 554L178 553L178 552L178 552L178 552L180 551L179 550L178 549L178 548L178 548L179 548L180 548L180 548L180 548L180 548L181 548L181 548L181 548L181 548L182 548L182 548L182 548L182 548L183 548L183 548L184 548L184 548L184 547L185 547L185 546L185 546L187 547L188 547L188 546L188 545L188 545L188 544L189 544L189 543L188 543L188 542L186 542L186 542L186 542L185 542L185 542L185 542L185 542L185 542L185 541L185 541L185 541L185 541L185 541L184 541L184 540L184 540L184 540L183 539L183 539L182 539L182 538L183 538L183 538L182 538L182 538L182 538L182 537L182 537L182 537L182 536L182 535L183 535L184 534L184 534L184 533L184 533L184 533L184 532L185 532L184 531L184 530L183 529L184 529L184 528L184 528L184 528L184 527L184 525L184 524L184 523L184 522L184 522L183 521L182 521L181 521L181 520z"
        },
        {
            "title": "Rajapur",
            "d": "M209 544L208 543L208 542L208 540L208 538L208 537L208 538L205 537L205 537L204 537L203 536L203 536L202 536L202 537L202 537L202 538L202 538L202 538L202 538L202 538L202 539L201 538L201 539L200 538L200 537L199 537L195 535L193 534L192 535L192 534L191 535L190 534L190 534L190 534L190 533L190 533L189 533L188 533L186 533L185 533L185 532L184 532L184 533L184 533L184 533L184 534L184 534L183 535L182 535L182 536L182 537L182 537L182 537L182 538L182 538L182 538L183 538L183 538L182 538L182 539L183 539L183 539L184 540L184 540L184 540L184 541L185 541L185 541L185 541L185 541L185 541L185 542L185 542L185 542L185 542L185 542L186 542L186 542L186 542L188 542L188 543L189 543L189 544L188 544L188 545L188 545L188 546L188 547L189 547L190 547L190 547L191 547L191 548L193 548L193 549L193 550L193 551L195 550L197 550L199 550L199 550L200 549L201 548L201 548L201 548L201 548L203 548L204 548L204 549L205 549L205 549L206 549L206 549L206 549L207 548L207 546L208 545L208 545L209 544z"
        },
        {
            "title": "Mahabubnagar_Rural",
            "d": "M160 563L160 562L160 561L159 561L160 560L159 560L159 560L158 560L157 560L157 561L157 561L156 561L155 561L154 561L154 561L153 561L154 561L154 562L153 563L153 563L152 563L152 563L150 563L150 563L150 563L150 564L150 565L150 565L149 568L148 568L148 568L148 569L148 569L148 569L148 570L146 570L145 569L145 569L142 568L141 569L140 571L141 572L142 573L142 573L143 574L143 574L143 574L143 574L144 575L144 575L144 577L144 577L146 579L145 579L145 579L146 579L146 579L146 580L146 580L146 580L146 580L146 580L146 580L146 580L150 581L150 581L152 582L152 582L154 581L155 581L157 580L162 582L162 582L166 582L166 582L167 582L167 582L166 581L166 581L166 581L166 581L166 580L166 580L167 580L167 579L167 580L167 579L167 579L167 579L167 579L167 578L165 578L165 578L165 577L165 576L164 575L164 573L164 572L165 572L166 573L166 571L166 571L166 571L166 570L165 570L165 569L163 569L163 569L163 569L162 568L161 567L161 567L161 566L161 566L160 565L159 564L159 564L159 563L160 563L160 563zM165 555L165 556L166 556L166 557L166 557L167 557L167 558L168 558L168 558L168 558L168 558L169 557L169 557L169 555L168 555L168 554L167 554L167 554L166 555L165 555zM167 548L168 548L169 548L169 547L170 547L170 547L171 547L171 547L171 546L171 546L170 546L170 546L170 545L171 545L170 545L170 545L170 545L170 544L170 544L170 544L169 544L168 543L167 543L167 543L167 544L167 545L167 545L167 545L166 545L166 546L165 547L165 547L165 547L165 547L165 547L165 547L167 548L167 548z"
        },
        {
            "title": "Mohammadabad",
            "d": "M139 540L139 542L139 543L143 545L143 545L143 544L143 545L144 545L144 545L144 545L145 545L145 545L146 545L146 545L146 544L146 544L146 544L146 544L147 543L147 544L147 544L147 544L147 545L146 546L146 546L147 546L148 545L148 545L148 545L149 545L149 545L150 545L150 545L150 544L150 545L151 544L151 545L152 545L153 545L153 544L154 544L154 544L155 544L155 545L155 545L155 545L154 546L155 546L156 547L156 547L156 547L156 547L157 547L157 546L158 546L158 546L158 546L158 545L161 543L161 541L159 539L159 537L157 536L156 535L154 533L152 533L150 533L151 530L151 529L151 528L152 528L152 528L152 527L151 525L151 525L150 525L149 526L149 527L149 528L149 528L148 528L148 529L148 529L148 529L148 529L147 529L147 529L147 529L146 529L146 529L146 529L146 529L145 528L145 528L145 528L145 527L145 527L145 527L145 527L144 527L144 527L144 527L144 527L144 527L144 529L142 529L142 530L141 530L141 530L140 529L140 529L140 529L140 529L140 530L140 529L140 530L140 530L140 530L140 531L140 531L140 531L141 532L142 533L142 534L143 535L142 536L143 537L143 537L143 539L141 539L140 540L140 540L139 540z"
        },
        {
            "title": "Koukuntla",
            "d": "M146 599L145 599L144 599L144 599L144 599L144 599L144 599L144 599L144 598L143 598L143 598L142 598L141 598L141 599L140 599L140 599L140 598L140 598L140 598L140 597L138 596L137 597L137 597L136 597L136 599L136 600L136 601L136 602L136 603L135 604L134 605L134 606L134 607L135 610L137 614L137 614L138 614L138 614L138 614L138 614L138 614L138 614L138 614L138 614L138 613L138 613L138 613L139 613L139 613L139 613L140 613L140 613L141 613L141 613L141 613L142 613L142 614L142 614L142 614L142 614L142 614L142 615L143 615L143 614L144 614L144 614L144 614L145 614L146 614L146 614L146 614L147 614L148 613L148 613L148 612L149 612L149 612L149 612L149 612L150 612L150 611L150 611L150 610L150 609L150 609L150 608L151 607L151 606L151 606L151 606L150 605L150 605L150 604L150 604L150 603L150 603L151 602L149 602L148 601L147 600L146 599z"
        }
    ],
    "Adilabad": [
        {
            "title": "Adilabad Rural",
            "d": "M272 53L272 53L272 53L271 53L269 52L269 52L269 51L269 51L268 51L268 51L268 51L267 51L267 51L267 51L267 51L266 51L266 50L266 50L266 51L265 51L264 51L264 51L264 50L263 51L263 50L263 49L262 49L261 49L261 50L261 52L259 52L259 52L259 52L259 53L258 54L258 55L256 55L256 56L256 56L256 56L256 56L256 56L256 57L256 57L256 56L255 56L255 56L254 56L255 56L254 57L254 56L254 57L253 57L253 57L253 58L254 58L254 58L254 58L254 59L254 59L255 59L255 58L255 58L256 58L256 58L257 57L257 58L257 58L257 58L257 58L257 58L257 58L258 58L258 58L258 58L258 59L258 59L258 59L259 59L259 59L259 60L260 59L260 59L260 59L261 59L261 59L260 59L260 58L261 58L261 58L261 58L262 58L262 58L262 58L262 58L262 58L262 58L263 58L263 58L263 58L263 59L264 58L264 58L264 58L264 58L264 58L264 57L265 57L265 57L265 57L265 57L265 57L265 57L265 57L266 57L266 57L268 58L268 59L268 59L268 59L268 59L268 60L268 61L268 62L268 63L268 63L268 63L268 63L268 63L268 65L268 65L268 66L268 66L267 66L267 66L266 67L265 67L265 67L264 69L264 69L264 70L265 71L265 71L264 71L264 72L264 72L264 73L263 73L264 75L262 77L262 78L261 78L262 79L262 80L262 80L263 80L263 80L265 81L267 81L267 82L267 82L267 82L268 82L269 82L270 81L271 81L275 83L275 83L277 84L278 84L278 82L279 82L281 81L282 80L282 80L283 81L283 82L284 82L286 83L287 85L287 85L289 85L289 85L290 86L291 86L292 86L293 85L294 86L296 86L297 86L298 84L298 82L299 80L299 80L299 79L299 79L299 78L299 76L299 76L299 75L299 75L299 75L299 75L298 75L298 74L298 74L298 74L298 74L297 74L297 73L297 73L296 73L295 72L295 72L294 72L294 72L293 73L290 72L290 73L290 73L289 73L289 72L289 72L288 73L286 72L284 73L284 73L283 72L283 72L282 71L281 71L280 70L279 70L280 69L280 68L280 68L280 67L280 67L279 66L279 66L279 66L279 66L279 64L279 62L279 61L279 61L280 60L279 60L279 59L279 59L279 59L278 59L278 59L278 58L278 59L277 59L277 59L276 59L276 59L275 59L275 58L275 58L275 57L275 56L275 54L275 54L275 54L274 54L274 54L273 54L272 53z"
        },
        {
            "title": "Adilabad Urban",
            "d": "M266 67L267 66L267 66L268 66L268 66L268 65L268 65L268 63L268 63L268 63L268 63L268 63L268 62L268 61L268 60L268 59L268 59L268 59L268 59L268 58L266 57L266 57L265 57L265 57L265 57L265 57L265 57L265 57L265 57L264 57L264 58L264 58L264 58L264 58L264 58L263 59L263 58L263 58L263 58L262 58L262 58L262 58L262 58L262 58L262 58L261 58L261 58L261 58L260 58L260 59L261 59L261 59L260 59L260 59L261 59L261 60L261 60L261 60L261 60L262 61L262 62L263 62L263 63L263 63L263 63L264 64L265 65L265 65L265 65L265 66L265 67L266 67z"
        },
        {
            "title": "Bazarhathnoor",
            "d": "M249 83L248 83L248 84L248 84L247 84L245 83L245 84L244 84L243 84L243 84L243 84L242 84L242 83L241 83L240 82L239 81L239 81L239 81L238 80L239 79L239 79L239 78L239 78L239 77L239 77L239 77L237 77L236 77L236 77L235 78L234 77L233 77L232 77L232 77L231 77L231 77L230 77L230 78L229 78L227 77L226 77L226 76L226 76L226 77L226 77L226 78L226 78L225 79L225 79L225 79L225 80L222 80L222 79L222 80L221 81L222 82L223 83L223 83L224 83L224 84L225 84L224 85L224 85L224 86L224 87L225 87L225 87L225 88L225 88L225 90L225 91L227 94L226 97L226 98L226 98L225 99L224 99L225 99L226 101L228 101L228 101L229 101L229 101L229 101L230 102L230 102L231 102L231 102L231 102L232 102L232 102L232 102L232 103L233 102L233 104L233 104L233 104L234 104L234 103L235 104L236 105L235 107L239 107L239 108L239 108L241 109L242 109L242 109L243 108L245 106L245 106L245 105L246 105L246 104L246 104L246 102L246 101L246 101L247 100L248 99L248 99L248 99L248 98L248 97L249 96L250 94L250 95L252 95L254 95L254 95L254 90L254 90L252 90L249 90L251 84L250 84L250 84L250 84L249 84L249 83L249 83z"
        },
        {
            "title": "Bheempoor",
            "d": "M257 40L257 40L256 40L256 38L255 36L254 36L254 36L253 36L252 36L252 37L251 37L249 37L247 36L246 36L245 35L244 34L243 33L241 32L241 31L240 31L240 30L240 29L240 29L240 29L240 28L240 27L240 26L240 25L240 25L239 25L239 25L239 25L238 25L238 25L236 24L235 25L233 24L232 24L232 24L231 24L231 23L231 22L230 22L231 22L232 21L232 21L232 20L232 19L232 19L231 19L230 18L229 19L228 19L228 20L227 21L227 24L226 25L226 26L225 28L225 28L224 29L224 30L225 31L226 31L227 32L227 32L228 31L229 31L230 31L232 32L232 32L232 36L234 36L234 37L235 37L236 38L236 38L236 40L236 40L237 42L237 43L236 44L236 44L235 47L234 49L236 49L237 49L239 50L239 50L240 50L241 50L243 51L243 51L244 51L245 50L246 50L247 50L248 50L248 50L248 50L248 50L248 50L249 50L249 50L249 50L249 49L250 49L250 49L250 49L251 49L251 49L251 49L251 49L251 49L251 49L251 49L251 49L252 50L253 50L253 50L253 50L254 50L254 50L254 50L254 50L254 50L254 50L255 50L255 51L255 51L256 50L256 50L256 50L256 50L257 50L258 50L257 50L257 50L257 48L257 48L257 48L257 47L258 47L258 47L258 47L258 46L258 46L257 46L257 46L257 45L257 45L257 44L256 43L256 43L256 43L256 42L256 41L257 41L257 40L257 40L257 40z"
        },
        {
            "title": "Boath",
            "d": "M208 106L207 106L206 105L205 105L207 108L205 113L205 114L204 114L204 114L204 116L204 116L204 116L205 118L205 119L206 119L206 119L207 120L207 120L207 121L207 121L207 122L207 121L208 121L208 122L208 123L209 123L210 123L211 123L211 123L212 123L214 123L216 125L216 125L216 126L216 126L217 126L217 127L217 128L217 128L217 129L217 129L218 130L218 131L222 129L224 130L226 129L227 130L228 130L228 128L230 128L231 127L231 126L231 126L233 124L233 123L234 124L236 124L236 124L236 124L236 123L236 122L236 122L236 121L237 121L237 120L237 120L239 119L239 119L239 118L239 118L239 118L239 118L240 118L240 118L240 117L240 117L240 116L240 116L240 115L239 114L239 112L239 111L240 110L240 109L241 109L239 108L239 108L239 107L235 107L236 105L235 104L234 103L234 104L233 104L232 106L232 107L232 108L231 109L231 109L231 109L231 109L231 110L231 110L231 110L232 110L232 110L232 110L232 110L231 111L231 112L231 112L231 112L231 112L231 112L230 112L230 112L230 112L229 112L229 112L229 111L228 111L228 111L228 111L228 111L227 110L229 108L229 108L228 109L227 109L226 109L225 110L224 110L224 110L220 111L220 111L219 112L216 110L212 110L212 108L208 106z"
        },
        {
            "title": "Gadiguda",
            "d": "M316 64L315 64L315 64L314 64L313 64L313 65L313 65L313 66L312 66L312 65L312 65L311 65L310 65L309 65L308 65L308 63L307 63L306 63L305 62L305 62L304 62L302 61L303 62L303 66L304 66L304 66L304 66L304 66L304 67L304 67L304 67L304 68L304 68L305 68L305 69L305 69L305 69L305 70L306 70L306 70L306 72L307 72L306 73L306 73L305 74L305 73L304 73L304 73L304 74L303 74L303 75L305 76L305 76L305 77L305 77L305 78L305 78L305 79L308 80L308 82L312 84L312 84L314 84L315 85L318 85L317 86L318 87L319 86L321 87L321 86L323 86L323 86L324 86L325 84L323 82L325 82L326 83L327 83L327 81L327 80L327 79L330 81L330 81L331 81L332 81L332 81L334 79L334 79L336 78L335 76L335 76L333 75L333 74L333 73L333 71L333 71L334 69L334 68L334 67L333 66L333 65L332 64L332 64L331 64L331 64L330 64L329 64L327 64L327 64L327 63L327 63L326 63L326 62L326 63L325 63L325 62L324 62L324 63L323 63L323 63L322 63L322 64L322 64L322 65L322 65L321 65L321 64L320 65L319 64L317 64L316 64L316 64z"
        },
        {
            "title": "Gudihathnur",
            "d": "M263 73L263 73L261 73L259 73L258 72L258 74L257 75L257 75L257 75L257 75L256 75L256 74L256 75L255 75L255 76L255 76L255 75L254 75L254 75L254 76L254 77L254 78L254 79L254 79L254 79L254 79L254 80L254 80L254 80L254 80L254 80L254 81L254 81L253 82L253 82L253 82L253 83L253 84L251 84L249 90L252 90L254 90L254 90L254 95L256 96L256 96L258 96L258 96L258 96L258 97L260 97L261 97L261 97L262 97L262 98L262 98L262 98L261 98L261 99L260 99L261 99L260 101L261 100L262 100L263 100L263 101L263 101L263 101L264 101L264 101L264 101L266 101L266 100L267 100L268 100L267 99L266 99L267 98L267 97L267 96L267 96L269 96L270 91L271 91L270 91L271 90L270 90L270 90L270 90L270 89L270 89L271 89L270 89L270 89L270 89L270 88L270 88L271 88L270 88L270 87L270 88L270 87L271 86L271 86L271 85L271 85L271 84L271 83L271 83L271 83L270 81L269 82L268 82L267 82L267 82L267 82L267 81L265 81L263 80L263 80L262 80L262 80L262 79L261 78L262 78L262 77L264 75L263 73z"
        },
        {
            "title": "Ichoda",
            "d": "M254 95L254 95L252 95L250 95L250 94L249 96L248 97L248 98L248 99L248 99L248 99L247 100L246 101L246 101L246 102L246 104L246 104L246 105L245 105L245 106L245 106L243 108L244 112L247 112L246 113L246 114L247 114L247 114L247 115L247 115L248 115L248 115L249 115L250 115L250 115L251 115L251 115L251 116L251 116L251 117L252 117L252 117L252 118L252 119L253 119L253 119L253 119L253 119L254 119L254 119L254 119L254 119L253 120L253 120L253 120L253 120L253 121L254 122L255 122L255 122L255 122L256 123L255 124L255 126L256 126L258 126L261 127L261 127L260 128L260 128L260 128L261 128L262 128L263 128L263 129L265 130L266 130L267 131L267 131L268 131L268 130L268 130L268 130L267 129L269 128L271 127L272 125L272 125L272 125L271 125L271 125L270 125L270 125L270 125L269 125L269 125L269 124L268 123L268 121L265 120L264 120L264 120L264 120L264 119L263 119L263 120L263 120L263 118L265 116L266 114L266 114L266 113L266 112L266 111L266 110L266 110L266 110L266 108L266 107L266 106L266 107L267 106L269 106L268 104L267 104L267 104L267 104L267 104L267 103L265 104L264 104L264 105L264 105L263 106L262 105L260 105L260 104L260 104L260 103L260 103L259 103L259 102L259 101L260 101L261 99L260 99L261 99L261 98L262 98L262 98L262 98L262 97L261 97L261 97L260 97L258 97L258 96L258 96L258 96L256 96L256 96L254 95z"
        },
        {
            "title": "Inderavelly",
            "d": "M302 80L301 80L299 80L299 80L298 82L298 84L297 86L296 86L294 86L293 85L292 86L291 86L290 86L289 85L289 85L287 85L287 85L286 83L284 82L283 82L283 81L282 80L282 80L281 81L279 82L278 82L278 84L277 84L275 83L275 83L271 81L270 81L271 83L271 83L271 83L271 84L271 85L271 85L271 86L271 86L270 87L270 88L270 87L270 88L271 88L270 88L270 88L270 89L270 89L270 89L271 89L270 89L270 89L270 90L270 90L270 90L271 90L270 91L271 91L270 91L269 96L270 97L271 98L271 98L272 98L273 98L273 98L273 99L274 99L274 99L274 100L274 101L274 102L274 102L274 102L274 104L274 104L274 105L275 105L276 105L278 104L279 103L279 103L280 103L280 103L280 104L282 105L281 105L279 106L278 107L278 107L278 108L278 110L284 112L285 112L285 111L285 111L286 109L286 109L287 106L287 106L287 105L287 104L287 103L287 100L287 99L288 98L288 97L288 96L288 97L289 97L289 97L290 97L290 96L290 96L291 92L291 92L291 92L290 90L292 89L294 91L296 91L297 91L297 92L301 91L301 89L301 88L301 88L300 87L302 85L302 84L302 83L302 80z"
        },
        {
            "title": "Jainad",
            "d": "M293 45L292 44L292 44L292 43L292 42L291 41L288 41L286 40L284 39L282 38L279 38L278 38L278 37L278 38L278 38L278 38L278 38L277 39L277 38L277 39L277 39L277 39L277 39L277 40L277 40L277 40L278 41L278 41L278 41L278 42L278 43L278 44L278 44L278 44L276 44L276 45L275 45L275 45L275 47L275 47L277 47L277 49L277 49L277 50L276 50L275 50L275 50L275 50L274 50L273 50L273 53L272 53L272 53L273 54L274 54L274 54L275 54L275 54L275 54L275 56L275 57L275 58L275 58L275 59L276 59L276 59L277 59L277 59L278 59L278 58L278 59L278 59L279 59L279 59L279 59L279 60L280 60L280 60L280 60L280 60L280 60L281 60L281 60L281 59L281 59L281 58L283 58L283 59L283 60L284 61L284 61L284 61L284 61L284 61L286 61L286 61L287 62L287 62L288 62L289 62L289 61L289 58L290 59L291 59L292 57L292 57L292 56L293 56L293 56L293 55L293 54L293 53L293 52L293 52L292 51L292 50L293 50L293 50L293 50L293 50L293 50L294 50L294 49L294 48L294 48L294 48L294 48L294 47L294 47L294 47L294 47L293 47L293 47L293 47L293 46L292 46L292 46L293 46L293 46L293 46L293 45z"
        },
        {
            "title": "Narnoor",
            "d": "M330 81L330 81L327 79L327 80L327 81L327 83L326 83L325 82L323 82L325 84L324 86L323 86L323 86L321 86L321 87L319 86L318 87L317 86L318 85L315 85L314 84L312 84L312 84L308 82L308 80L305 79L305 78L304 79L304 79L304 79L304 78L303 78L303 78L303 79L303 79L303 79L302 80L302 83L302 84L302 85L300 87L301 88L301 88L301 89L301 91L302 92L303 92L303 94L303 97L304 97L305 98L305 97L306 98L308 99L308 99L308 100L309 104L311 104L312 105L312 105L314 105L315 104L315 104L315 104L315 104L315 101L316 101L317 100L319 101L320 101L321 100L322 99L322 99L323 98L324 96L324 95L324 95L326 94L327 93L327 93L329 96L329 97L332 95L336 93L336 93L335 93L334 92L333 91L332 91L331 92L331 91L330 90L331 87L332 86L330 84L329 83L329 83L330 83L330 83L330 82L330 81z"
        },
        {
            "title": "Neradigonda",
            "d": "M243 108L242 109L242 109L241 109L240 109L240 110L239 111L239 112L239 114L240 115L240 116L240 116L240 117L240 117L240 118L240 118L239 118L239 118L239 118L239 118L239 119L239 119L237 120L237 120L237 121L236 121L236 122L236 122L236 123L236 124L236 124L236 124L234 124L233 123L233 124L231 126L231 126L231 127L230 128L228 128L228 130L227 130L226 129L224 130L222 129L218 131L219 131L219 131L219 131L221 131L221 131L221 131L221 131L222 131L223 131L223 131L224 131L225 132L225 132L225 133L225 134L225 134L226 135L225 136L226 136L226 136L226 137L226 138L227 138L227 139L227 139L227 139L228 140L229 140L230 141L231 141L231 141L232 141L233 141L233 142L234 142L234 142L234 142L235 142L235 142L235 142L236 142L236 142L237 143L237 145L237 145L238 146L238 145L239 146L239 146L239 146L240 146L240 146L241 146L241 146L242 146L242 146L242 147L243 147L243 147L244 147L244 147L245 147L245 147L246 147L247 146L247 146L247 145L248 146L249 146L249 145L250 145L250 145L250 144L251 144L250 143L250 142L250 141L250 138L250 137L253 137L253 137L255 138L259 140L259 140L260 138L261 138L260 135L261 133L262 133L265 132L266 130L265 130L263 129L263 128L262 128L261 128L260 128L260 128L260 128L261 127L261 127L258 126L256 126L255 126L255 124L256 123L255 122L255 122L255 122L254 122L253 121L253 120L253 120L253 120L253 120L254 119L254 119L254 119L254 119L253 119L253 119L253 119L253 119L252 119L252 118L252 117L252 117L251 117L251 116L251 116L251 115L251 115L250 115L250 115L249 115L248 115L248 115L247 115L247 115L247 114L247 114L246 114L246 113L247 112L244 112L243 108z"
        },
        {
            "title": "Sirikonda",
            "d": "M286 109L285 111L285 111L285 112L284 112L278 110L278 108L278 107L278 107L279 106L281 105L282 105L280 104L280 103L280 103L279 103L279 103L278 104L276 105L275 105L274 105L274 104L274 104L274 102L274 102L274 102L274 101L274 100L274 99L274 99L273 99L273 98L273 98L272 98L271 98L271 98L270 97L269 96L267 96L267 96L267 97L267 98L266 99L267 99L268 100L267 100L266 100L266 101L264 101L264 101L264 101L263 101L263 101L263 101L263 100L262 100L261 100L260 101L259 101L259 102L259 103L260 103L260 103L260 104L260 104L260 105L262 105L263 106L264 105L264 105L264 104L265 104L267 103L267 104L267 104L267 104L267 104L268 104L269 106L267 106L266 107L266 106L266 107L266 108L266 110L266 110L266 110L266 111L266 112L266 113L266 114L266 114L265 116L263 118L263 120L263 120L263 119L264 119L264 120L264 120L264 120L265 120L268 121L268 123L269 124L269 125L269 125L270 125L270 125L270 125L271 125L271 125L272 125L272 125L272 125L273 125L273 124L273 125L273 125L274 125L274 125L274 124L277 124L277 124L278 124L280 125L280 125L281 125L282 126L282 126L282 126L283 125L284 124L286 123L286 123L286 123L288 123L289 123L289 122L289 120L289 120L289 117L289 113L289 110L289 110L288 109L286 109z"
        },
        {
            "title": "Talamadugu",
            "d": "M233 54L233 54L232 54L230 54L229 55L229 55L229 55L228 57L228 57L226 57L226 58L226 58L224 58L222 57L222 58L221 60L221 60L220 60L220 62L221 62L221 62L221 63L222 63L223 64L223 64L224 65L224 65L224 65L225 66L225 68L225 70L226 71L227 72L226 72L227 73L226 76L226 76L226 76L226 76L226 77L227 77L229 78L230 78L230 77L231 77L231 77L232 77L232 77L233 77L234 77L235 78L236 77L236 77L237 77L239 77L239 77L239 77L239 78L239 78L239 79L239 79L238 80L239 81L239 81L239 81L240 82L241 83L242 83L242 84L243 84L243 84L243 84L244 84L245 84L245 83L247 84L248 84L248 84L248 83L249 83L249 82L250 80L250 80L250 80L250 79L250 79L251 78L251 77L252 78L252 78L253 78L254 78L254 77L254 76L254 75L254 75L255 75L255 76L255 76L255 75L256 75L256 74L256 75L257 75L257 75L257 75L257 75L258 74L258 72L258 72L258 71L257 71L257 70L257 70L257 70L257 69L256 69L256 68L256 67L256 67L256 66L255 66L255 66L254 65L254 65L254 64L254 64L254 63L254 62L254 62L255 61L255 61L255 60L255 60L254 60L253 61L253 61L252 61L252 61L252 61L252 62L251 62L251 62L250 62L250 62L249 62L249 59L249 59L250 59L250 59L249 59L249 59L249 60L248 61L248 60L245 60L243 59L242 58L242 58L242 58L242 57L242 56L242 56L241 56L241 56L240 55L239 55L239 55L239 55L238 55L238 55L237 55L237 54L236 54L235 53L234 53L233 54L233 54z"
        },
        {
            "title": "Tamsi",
            "d": "M234 49L234 49L233 49L233 50L233 50L233 51L233 51L232 52L233 53L233 53L233 54L233 54L234 53L235 53L236 54L237 54L237 55L238 55L238 55L239 55L239 55L239 55L240 55L241 56L241 56L242 56L242 56L242 57L242 58L242 58L242 58L243 59L245 60L248 60L248 61L249 60L249 59L249 59L250 59L250 59L249 59L249 59L249 62L250 62L250 62L251 62L251 62L252 62L252 61L252 61L252 61L253 61L253 61L254 60L255 60L255 60L255 61L255 61L254 62L254 62L254 63L254 64L254 64L254 65L254 65L255 66L255 66L256 66L256 67L256 67L256 68L257 68L257 68L256 68L257 68L257 67L257 67L257 67L257 66L257 66L257 66L257 66L257 66L257 65L257 65L257 65L258 65L258 63L258 63L258 63L258 62L258 61L258 60L259 59L259 59L258 59L258 59L258 59L258 58L258 58L258 58L257 58L257 58L257 58L257 58L257 58L257 58L257 57L256 58L256 58L255 58L255 58L255 59L254 59L254 59L254 58L254 58L254 58L253 58L253 57L253 57L254 57L254 56L254 57L255 56L254 56L255 56L255 56L256 56L256 57L256 57L256 56L256 56L256 56L256 56L256 56L256 55L258 55L258 54L259 53L259 52L259 52L259 52L261 52L261 50L261 49L261 49L260 48L260 48L259 48L259 48L259 48L258 47L258 47L258 47L257 47L257 48L257 48L257 48L257 50L257 50L258 50L257 50L256 50L256 50L256 50L256 50L255 51L255 51L255 50L254 50L254 50L254 50L254 50L254 50L254 50L253 50L253 50L253 50L252 50L251 49L251 49L251 49L251 49L251 49L251 49L251 49L251 49L250 49L250 49L250 49L249 49L249 50L249 50L249 50L248 50L248 50L248 50L248 50L248 50L247 50L246 50L245 50L244 51L243 51L243 51L241 50L240 50L239 50L239 50L237 49L236 49L234 49z"
        },
        {
            "title": "Utnur",
            "d": "M301 91L297 92L297 91L296 91L294 91L292 89L290 90L291 92L291 92L291 92L290 96L290 96L290 97L289 97L289 97L288 97L288 96L288 97L288 98L287 99L287 100L287 103L287 104L287 105L287 106L287 106L286 109L286 109L288 109L289 110L289 110L289 113L289 117L289 120L289 120L289 122L289 123L290 123L290 124L290 124L291 124L293 124L295 124L294 126L296 128L300 129L301 133L302 134L303 134L305 136L306 138L306 139L306 140L307 141L307 140L307 140L309 139L309 138L309 138L310 137L310 136L310 135L311 134L314 134L314 134L314 133L315 133L314 132L315 131L316 130L317 130L317 126L318 124L317 122L319 122L321 120L320 118L319 118L319 119L319 119L319 119L319 119L318 119L318 119L317 118L315 116L314 116L313 116L313 115L313 115L313 115L313 115L313 112L313 112L311 112L310 112L309 111L309 111L307 110L307 109L307 109L307 109L308 110L309 110L310 110L311 108L311 108L311 107L311 107L311 107L312 106L312 105L311 104L309 104L308 100L308 99L308 99L306 98L305 97L305 98L304 97L303 97L303 94L303 92L302 92L301 91z"
        },
        {
            "title": "Mavala",
            "d": "M254 78L253 78L252 78L252 78L251 77L251 78L250 79L250 79L250 80L250 80L250 80L249 82L249 83L249 83L249 84L250 84L250 84L250 84L251 84L253 84L253 83L253 82L253 82L253 82L254 81L254 81L254 80L254 80L254 80L254 80L254 80L254 79L254 79L254 79L254 79L254 78zM260 59L260 59L260 59L259 60L259 59L258 60L258 61L258 62L258 63L258 63L258 63L258 65L257 65L257 65L257 65L257 66L257 66L257 66L257 66L257 66L257 67L257 67L257 67L257 68L256 68L257 68L257 68L256 68L256 69L257 69L257 70L257 70L257 70L257 71L258 71L258 72L258 72L259 73L261 73L263 73L263 73L264 73L264 72L264 72L264 71L265 71L265 71L264 70L264 69L264 69L265 67L265 67L266 67L265 67L265 66L265 65L265 65L265 65L264 64L263 63L263 63L263 63L263 62L262 62L262 61L261 60L261 60L261 60L261 60L261 59L260 59L260 59z"
        },
        {
            "title": "Sathnala",
            "d": "M289 62L288 62L287 62L287 62L286 61L286 61L284 61L284 61L284 61L284 61L284 61L283 60L283 59L283 58L281 58L281 59L281 59L281 60L281 60L280 60L280 60L280 60L280 60L280 60L279 61L279 61L279 62L279 64L279 66L279 66L279 66L279 66L280 67L280 67L280 68L280 68L280 69L279 70L280 70L281 71L282 71L283 72L283 72L284 73L284 73L286 72L288 73L289 72L289 72L289 73L290 73L290 73L290 72L293 73L294 72L294 72L295 72L295 72L296 73L297 73L297 73L297 74L298 74L298 74L298 74L298 74L298 75L299 75L299 75L299 75L299 75L299 76L299 76L299 78L299 79L299 79L299 80L301 80L302 80L303 79L303 79L303 79L303 78L303 78L304 78L304 79L304 79L304 79L305 78L305 78L305 77L305 77L305 76L305 76L303 75L303 74L304 74L304 73L304 73L305 73L305 74L306 73L306 73L307 72L306 72L306 70L306 70L305 70L305 69L305 69L305 69L305 68L304 68L304 68L304 67L304 67L304 67L304 66L304 66L304 66L304 66L303 66L303 65L303 65L302 65L302 64L301 63L300 62L300 62L300 61L298 62L296 61L296 61L296 62L296 63L295 63L295 64L294 64L294 64L293 64L292 63L292 62L292 62L292 62L292 61L292 61L290 61L289 62z"
        },
        {
            "title": "Bhoraj",
            "d": "M278 37L277 37L277 36L276 36L275 36L275 36L274 36L273 36L272 36L271 37L271 37L270 36L269 36L268 35L267 35L266 35L265 36L265 36L263 36L262 36L261 36L261 36L261 37L260 37L260 37L260 39L260 39L260 40L260 40L258 40L258 40L257 40L257 40L257 40L257 41L256 41L256 42L256 43L256 43L256 43L257 44L257 45L257 45L257 46L257 46L258 46L258 46L258 47L258 47L258 47L258 47L258 47L259 48L259 48L259 48L260 48L260 48L261 49L261 49L262 49L263 49L263 50L263 51L264 50L264 51L264 51L265 51L266 51L266 50L266 50L266 51L267 51L267 51L267 51L267 51L268 51L268 51L268 51L269 51L269 51L269 52L269 52L271 53L272 53L272 53L272 53L272 53L273 53L273 50L274 50L275 50L275 50L275 50L276 50L277 50L277 49L277 49L277 47L275 47L275 47L275 45L275 45L276 45L276 44L278 44L278 44L278 44L278 43L278 42L278 41L278 41L278 41L277 40L277 40L277 40L277 39L277 39L277 39L277 39L277 38L277 39L278 38L278 38L278 38L278 38L278 37z"
        },
        {
            "title": "Sonala",
            "d": "M233 104L233 104L233 104L233 102L232 103L232 102L232 102L232 102L231 102L231 102L231 102L230 102L230 102L229 101L229 101L229 101L228 101L228 101L226 101L225 99L224 99L223 99L221 98L221 98L220 98L220 99L219 99L219 100L219 100L218 101L217 101L217 102L216 102L215 102L215 103L214 102L214 102L213 102L212 102L211 103L210 103L209 104L209 105L209 106L208 106L208 106L212 108L212 110L216 110L219 112L220 111L220 111L224 110L224 110L225 110L226 109L227 109L228 109L229 108L229 108L227 110L228 111L228 111L228 111L228 111L229 111L229 112L229 112L230 112L230 112L230 112L231 112L231 112L231 112L231 112L231 112L231 111L232 110L232 110L232 110L232 110L231 110L231 110L231 110L231 109L231 109L231 109L231 109L232 108L232 107L232 106L233 104z"
        },
        {
            "title": "Bela",
            "d": "M316 64L317 61L317 60L317 59L317 59L317 59L317 57L317 57L316 56L316 54L316 53L316 53L316 52L316 51L315 51L315 49L315 48L314 47L314 46L313 47L312 47L312 48L312 48L311 46L311 46L310 46L309 47L308 47L307 47L307 46L307 46L307 46L307 45L306 44L306 44L304 43L304 43L303 43L302 44L301 44L301 44L300 44L299 43L299 43L298 43L297 43L296 43L296 43L295 45L295 45L294 45L293 45L293 46L293 46L293 46L292 46L292 46L293 46L293 47L293 47L293 47L294 47L294 47L294 47L294 47L294 48L294 48L294 48L294 48L294 49L294 50L293 50L293 50L293 50L293 50L293 50L292 50L292 51L293 52L293 52L293 53L293 54L293 55L293 56L293 56L292 56L292 57L292 57L291 59L290 59L289 58L289 61L289 62L290 61L292 61L292 61L292 62L292 62L292 62L292 63L293 64L294 64L294 64L295 64L295 63L296 63L296 62L296 61L296 61L298 62L300 61L300 62L300 62L301 63L302 64L302 65L303 65L303 65L303 66L303 62L302 61L304 62L305 62L305 62L306 63L307 63L308 63L308 65L309 65L310 65L311 65L312 65L312 65L312 66L313 66L313 65L313 65L313 64L314 64L315 64L315 64L316 64z"
        }
    ],
    "Jogulamba Gadwal": [
        {
            "title": "Aiza",
            "d": "M125 690L124 691L124 690L123 690L123 690L123 690L122 690L122 690L122 690L122 689L122 689L122 689L121 689L121 688L122 688L122 688L121 688L121 687L121 687L121 686L121 686L121 685L120 685L120 685L119 684L119 684L119 684L119 684L119 684L118 684L118 684L118 684L118 684L118 685L118 685L118 685L118 685L117 685L117 686L116 686L116 685L115 685L115 685L115 685L114 685L114 684L113 684L114 682L114 682L114 681L113 681L113 680L113 680L113 679L113 678L113 678L113 679L112 679L111 680L111 680L110 680L110 681L110 680L110 680L109 680L110 680L109 681L109 681L109 681L109 681L108 681L108 680L107 680L106 680L105 680L104 680L104 681L104 681L104 681L104 682L104 682L104 682L104 683L104 683L104 683L104 683L104 685L104 686L103 686L103 687L102 689L102 689L101 689L100 689L100 689L100 690L99 690L99 691L98 691L98 691L98 692L98 692L97 692L97 692L97 692L95 693L95 693L94 693L94 693L93 693L93 693L93 693L92 694L92 694L92 694L90 694L88 694L87 695L87 695L85 696L85 696L85 696L85 696L86 697L86 697L87 697L86 701L85 704L86 704L86 705L88 705L89 705L90 705L91 706L94 706L95 706L97 706L97 706L98 707L99 707L100 707L101 706L102 706L103 707L104 708L106 710L107 711L108 709L108 709L108 709L109 706L109 705L110 705L110 705L111 705L111 705L111 705L111 705L112 705L112 704L112 704L112 704L113 704L113 704L113 704L113 703L114 702L114 702L114 701L115 701L116 701L117 701L118 701L119 700L119 697L119 697L120 696L120 696L124 697L124 697L125 697L125 697L125 697L128 698L128 696L129 696L129 695L129 695L129 695L130 694L130 694L130 694L131 693L131 693L131 693L132 691L132 691L131 691L128 690L127 690L126 690L125 690L125 690z"
        },
        {
            "title": "Alampur",
            "d": "M209 698L208 699L208 700L207 701L206 702L204 703L202 703L197 703L195 703L194 702L193 702L192 702L192 701L191 698L191 697L190 695L190 695L189 694L186 692L185 692L181 691L180 693L180 694L180 694L179 694L179 694L179 695L179 695L178 696L179 696L179 697L178 697L178 697L178 697L177 697L177 698L177 700L178 700L178 701L178 701L178 701L178 701L179 701L179 703L179 703L179 703L178 703L178 704L178 704L178 704L177 706L177 707L177 707L176 708L177 708L176 709L177 709L177 709L177 709L177 711L177 713L177 714L177 714L179 714L179 715L178 715L178 716L178 716L177 717L178 717L178 718L179 718L178 719L179 719L179 719L181 720L180 721L183 721L183 721L185 721L185 721L185 721L186 721L186 721L187 721L188 721L189 721L189 721L189 721L189 720L188 719L188 719L188 719L189 718L189 718L190 718L191 718L192 718L193 719L195 718L196 718L196 718L196 716L196 716L196 715L198 713L198 712L198 712L198 712L196 710L197 709L198 709L199 708L200 708L201 708L204 707L205 707L207 706L208 705L209 704L209 704L209 701L209 699L209 698z"
        },
        {
            "title": "Dharoor",
            "d": "M124 636L123 635L121 635L120 634L118 634L117 634L116 633L116 633L115 632L115 632L115 632L115 632L115 631L114 630L112 630L112 630L112 630L111 631L111 630L111 631L110 631L108 630L107 630L105 631L104 631L102 632L101 633L100 633L99 633L99 634L99 634L99 634L99 635L99 636L100 637L100 637L100 639L100 639L100 640L100 640L100 641L100 641L100 641L101 642L101 642L101 643L102 644L102 644L103 644L103 645L104 645L104 645L104 645L104 646L104 646L104 646L104 647L104 647L104 647L104 647L104 647L103 648L103 649L103 649L103 649L102 649L102 650L102 650L102 650L102 651L102 651L102 651L102 651L103 651L103 651L103 652L103 652L102 652L103 653L103 653L103 654L103 654L103 655L103 655L102 655L102 655L103 655L105 656L105 656L106 655L106 655L107 656L107 656L107 658L107 658L107 658L107 659L107 659L107 659L107 659L107 661L108 661L108 661L108 662L108 662L109 663L109 663L109 662L109 662L110 663L111 663L111 663L111 664L112 663L112 662L112 660L113 659L113 659L113 659L113 658L114 657L114 657L114 657L115 657L116 658L116 657L117 657L117 657L117 656L117 656L118 656L118 656L118 656L118 656L119 656L119 656L119 656L119 656L120 656L121 656L121 655L121 655L121 655L121 655L121 654L121 654L122 654L122 654L122 654L122 653L122 653L122 653L122 652L122 651L122 651L122 651L122 650L122 650L122 649L123 649L123 649L123 648L123 648L123 648L123 647L123 645L124 644L125 644L125 644L126 644L125 643L125 643L125 643L125 643L125 642L125 642L125 642L125 641L125 640L125 640L126 639L127 637L126 637L125 637L124 636L124 636L124 636z"
        },
        {
            "title": "Gadwal",
            "d": "M155 658L154 657L151 655L150 654L150 654L146 651L145 651L141 648L140 647L140 647L139 646L137 644L137 644L137 644L137 644L136 643L135 643L134 642L133 641L131 640L130 639L129 639L127 638L127 637L126 639L125 640L125 640L125 641L125 642L125 642L125 642L125 643L125 643L125 643L125 643L126 644L125 644L125 644L124 644L123 645L123 647L123 648L123 648L123 648L123 649L123 649L122 649L122 650L122 650L122 651L122 651L122 651L122 652L122 653L122 653L122 653L122 654L122 654L122 654L121 654L121 654L121 655L121 655L121 655L121 655L121 656L121 656L121 656L121 657L122 657L122 658L123 658L123 658L123 658L123 659L123 659L123 659L123 660L123 660L122 660L122 661L122 663L122 663L122 663L122 663L123 663L123 663L123 663L124 664L124 664L124 664L124 664L125 664L125 664L125 664L126 664L126 663L126 663L126 663L127 662L127 661L128 662L129 662L130 662L130 662L131 662L131 662L132 663L132 663L132 663L132 663L132 664L133 664L133 665L132 666L132 666L132 666L132 666L132 666L132 667L132 667L132 667L132 668L132 668L132 668L132 669L132 669L132 670L132 671L132 672L131 672L131 672L132 673L132 673L132 675L132 676L132 677L135 677L135 678L136 677L136 675L136 675L136 675L136 675L134 674L135 673L136 672L136 672L136 672L136 671L136 671L136 671L137 671L137 670L137 670L137 669L139 669L139 669L140 669L140 669L140 669L140 668L140 668L140 668L140 668L141 668L141 668L141 668L141 667L141 668L142 668L142 668L142 668L143 668L143 668L143 668L143 668L144 668L144 668L144 668L145 668L145 668L145 668L145 668L146 667L146 667L146 667L146 667L146 667L146 666L147 667L147 666L147 666L147 666L147 666L147 666L147 666L148 666L148 665L148 665L148 665L149 665L149 665L149 665L149 665L149 665L150 665L150 664L151 663L151 663L152 662L152 662L152 661L152 661L152 661L152 661L152 661L153 661L154 662L154 662L155 662L155 662L155 662L156 663L156 662L156 660L155 659L155 658z"
        },
        {
            "title": "Ghattu",
            "d": "M102 655L102 655L101 655L101 655L101 655L101 656L101 656L99 657L98 658L98 659L98 659L98 659L98 660L98 660L98 661L98 661L97 662L94 663L94 663L94 663L93 664L93 664L93 665L92 665L90 666L89 667L89 667L89 667L89 667L89 669L89 669L89 670L88 670L88 670L87 670L87 670L86 670L86 670L86 670L86 670L86 670L86 670L85 670L85 671L84 671L84 672L85 672L85 672L85 673L86 673L86 673L85 673L84 673L83 677L82 677L83 677L83 677L85 678L85 678L84 681L83 681L83 682L83 682L83 683L83 683L83 683L83 684L83 684L83 684L83 685L82 685L83 686L83 686L83 687L83 687L83 687L83 687L84 688L84 688L84 689L84 690L86 690L85 692L85 694L85 695L85 695L85 696L85 696L85 696L87 695L87 695L88 694L90 694L92 694L92 694L92 694L93 693L93 693L93 693L94 693L94 693L95 693L95 693L97 692L97 692L97 692L98 692L98 692L98 691L98 691L99 691L99 690L100 690L100 689L100 689L101 689L102 689L102 689L103 687L103 686L104 686L104 685L104 683L104 683L104 683L104 683L104 682L104 682L104 682L104 681L104 681L104 681L104 680L105 680L106 680L106 678L106 677L106 676L106 675L106 674L107 674L107 674L108 674L108 673L108 673L107 672L106 671L106 671L106 671L106 670L107 669L107 668L106 668L106 668L106 667L106 667L106 667L106 667L107 666L107 666L107 665L107 665L107 664L107 664L107 664L107 663L108 662L108 662L108 661L108 661L107 661L107 659L107 659L107 659L107 659L107 658L107 658L107 658L107 656L107 656L106 655L106 655L105 656L105 656L103 655L102 655z"
        },
        {
            "title": "Itikyal",
            "d": "M145 668L144 668L144 668L144 668L143 668L143 668L143 668L143 668L142 668L142 668L142 668L141 668L141 667L141 668L141 668L141 668L140 668L140 668L140 668L140 668L140 669L140 669L140 669L139 669L139 669L137 669L137 670L137 670L137 671L136 671L136 671L136 671L136 672L136 672L136 672L135 673L134 674L136 675L136 675L136 675L136 675L136 677L135 678L135 677L132 677L131 678L130 679L130 680L130 681L130 683L127 682L126 682L125 682L125 683L125 683L125 683L125 684L125 684L125 686L126 686L126 687L125 688L125 690L125 690L125 690L125 690L126 690L127 690L128 690L131 691L132 691L132 691L134 691L135 691L135 691L135 691L136 690L136 690L136 690L138 690L139 690L139 690L140 689L141 690L143 690L144 690L144 690L144 690L144 690L146 691L146 693L146 694L147 694L148 695L149 695L149 696L149 696L151 696L152 694L152 693L154 692L154 691L155 689L154 689L153 688L155 686L153 686L153 686L152 686L151 686L149 686L149 685L147 684L147 684L146 684L146 684L146 683L146 683L146 683L146 682L146 682L146 682L146 682L147 679L147 679L149 679L149 678L149 677L149 677L149 677L149 676L149 676L149 675L149 674L148 673L146 673L146 673L145 673L144 673L143 673L142 672L143 672L143 671L143 671L143 671L144 671L145 670L145 670L145 669L145 668z"
        },
        {
            "title": "Kaloor_Thimmandoddi",
            "d": "M100 641L100 641L99 642L98 641L98 642L97 641L97 640L96 640L95 640L95 640L94 640L94 640L93 641L93 641L92 641L91 642L91 644L91 645L90 646L90 646L90 645L89 645L89 645L89 644L89 644L88 644L87 644L87 644L86 644L86 644L85 644L85 644L85 646L85 646L84 647L84 647L83 647L83 648L83 648L83 650L83 652L83 652L85 652L86 652L86 652L87 652L87 653L86 653L86 654L84 653L84 653L84 654L84 655L84 657L84 657L83 658L83 659L82 660L82 662L82 662L81 663L82 664L82 664L82 664L82 666L82 666L82 666L82 668L82 668L82 671L82 671L83 671L83 671L84 671L84 671L84 671L84 671L84 672L84 671L85 671L85 670L86 670L86 670L86 670L86 670L86 670L86 670L87 670L87 670L88 670L88 670L89 670L89 669L89 669L89 667L89 667L89 667L89 667L90 666L92 665L93 665L93 664L93 664L94 663L94 663L94 663L97 662L98 661L98 661L98 660L98 660L98 659L98 659L98 659L98 658L99 657L101 656L101 656L101 655L101 655L101 655L102 655L102 655L102 655L103 655L103 655L103 654L103 654L103 653L103 653L102 652L103 652L103 652L103 651L103 651L102 651L102 651L102 651L102 651L102 650L102 650L102 650L102 649L103 649L103 649L103 649L103 648L104 647L104 647L104 647L104 647L104 647L104 646L104 646L104 646L104 645L104 645L104 645L103 645L103 644L102 644L102 644L101 643L101 642L101 642L100 641z"
        },
        {
            "title": "Maldakal",
            "d": "M121 656L120 656L119 656L119 656L119 656L119 656L118 656L118 656L118 656L118 656L117 656L117 656L117 657L117 657L116 657L116 658L115 657L114 657L114 657L114 657L113 658L113 659L113 659L113 659L112 660L112 662L112 663L111 664L111 663L111 663L110 663L109 662L109 662L109 663L109 663L108 662L107 663L107 664L107 664L107 664L107 665L107 665L107 666L107 666L106 667L106 667L106 667L106 667L106 668L106 668L107 668L107 669L106 670L106 671L106 671L106 671L107 672L108 673L108 673L108 674L107 674L107 674L106 674L106 675L106 676L106 677L106 678L106 680L107 680L108 680L108 681L109 681L109 681L109 681L109 681L110 680L109 680L110 680L110 680L110 681L110 680L111 680L111 680L112 679L113 679L113 678L113 678L113 679L113 680L113 680L113 681L114 681L114 682L114 682L113 684L114 684L114 685L115 685L115 685L115 685L116 685L116 686L117 686L117 685L118 685L118 685L118 685L118 685L118 684L118 684L118 684L118 684L119 684L119 684L119 684L119 684L119 684L120 685L120 685L121 685L121 686L121 686L121 687L121 687L121 688L122 688L122 688L121 688L121 689L122 689L122 689L122 689L122 690L122 690L122 690L123 690L123 690L123 690L124 690L124 691L125 690L125 690L125 690L125 688L126 687L126 686L125 686L125 684L125 684L125 683L125 683L125 683L125 682L126 682L127 682L130 683L130 681L130 680L130 679L131 678L132 677L132 676L132 675L132 673L132 673L131 672L131 672L132 672L132 671L132 670L132 669L132 669L132 668L132 668L132 668L132 667L132 667L132 667L132 666L132 666L132 666L132 666L132 666L133 665L133 664L132 664L132 663L132 663L132 663L132 663L131 662L131 662L130 662L130 662L129 662L128 662L127 661L127 662L126 663L126 663L126 663L126 664L125 664L125 664L125 664L124 664L124 664L124 664L124 664L123 663L123 663L123 663L122 663L122 663L122 663L122 663L122 661L122 660L123 660L123 660L123 659L123 659L123 659L123 658L123 658L123 658L122 658L122 657L121 657L121 656L121 656L121 656z"
        },
        {
            "title": "Manopad",
            "d": "M172 684L172 683L169 681L168 680L167 679L166 678L164 678L164 679L162 684L162 684L162 685L161 685L161 685L160 685L160 686L159 687L159 687L159 688L159 688L159 688L159 688L159 689L158 689L157 689L155 689L154 691L154 692L152 693L152 694L151 696L149 696L149 698L150 698L152 699L151 701L151 702L151 703L149 703L149 703L148 703L148 703L147 703L145 702L145 704L145 704L145 704L145 706L145 706L145 706L145 707L145 709L145 709L145 710L146 709L147 709L148 709L150 710L153 711L155 713L156 712L156 709L156 707L157 706L157 705L159 705L160 705L160 705L161 705L161 705L162 705L162 706L162 706L165 706L165 706L167 706L167 704L167 703L167 702L165 701L164 701L164 701L164 701L163 701L164 700L164 700L165 698L165 697L164 697L164 696L165 694L166 695L167 694L167 694L167 692L167 692L167 692L166 691L166 690L166 690L167 690L167 690L167 690L168 690L168 690L168 689L168 689L169 689L169 689L169 689L169 689L169 688L170 688L170 687L170 687L170 687L171 686L171 685L172 685L172 685L172 684L172 685L172 684z"
        },
        {
            "title": "Rajoli",
            "d": "M145 711L143 710L142 710L142 708L142 706L139 706L137 705L137 704L136 704L136 705L135 705L135 704L134 704L133 704L133 704L132 704L131 703L130 703L130 703L130 703L130 701L129 701L129 701L127 702L126 703L125 702L124 702L120 701L120 701L119 700L119 700L118 701L117 701L116 701L115 701L114 701L114 702L114 702L113 703L113 704L113 704L113 704L112 704L112 704L112 704L112 705L111 705L111 705L111 705L111 705L110 705L110 705L109 705L109 706L108 709L108 709L108 709L107 711L108 711L110 712L111 712L112 712L113 712L113 712L115 712L115 712L116 712L117 712L118 711L118 710L120 710L120 710L122 711L123 711L123 712L125 712L126 712L127 712L127 712L128 712L128 712L130 713L130 714L130 714L132 714L134 714L135 714L137 713L140 712L140 713L141 713L142 713L142 713L143 712L144 711L145 711z"
        },
        {
            "title": "Undavelly",
            "d": "M149 698L149 699L148 698L147 701L147 703L148 703L148 703L149 703L149 703L151 703L151 702L151 701L152 699L150 698L149 698zM177 689L176 688L174 687L174 685L172 684L172 685L172 684L172 685L172 685L171 685L171 686L170 687L170 687L170 687L170 688L169 688L169 689L169 689L169 689L169 689L168 689L168 689L168 690L168 690L167 690L167 690L167 690L166 690L166 690L166 691L167 692L167 692L167 692L167 694L167 694L166 695L165 694L164 696L164 697L165 697L165 698L164 700L164 700L163 701L164 701L164 701L164 701L165 701L167 702L167 703L167 704L167 706L165 706L165 706L162 706L162 706L162 705L161 705L161 705L160 705L160 705L159 705L157 705L157 706L156 707L156 709L156 712L155 713L157 713L158 713L161 713L161 713L163 713L163 713L164 715L166 716L167 716L168 717L168 716L168 716L169 715L169 714L171 710L171 710L171 710L171 710L172 710L172 709L172 709L174 710L174 715L176 715L176 716L177 717L178 716L178 716L178 715L179 715L179 714L177 714L177 714L177 713L177 711L177 709L177 709L177 709L176 709L177 708L176 708L177 707L177 707L177 706L178 704L178 704L178 704L178 703L179 703L179 703L179 703L179 701L178 701L178 701L178 701L178 701L178 700L177 700L177 698L177 697L178 697L178 697L178 697L179 697L179 696L178 696L179 695L179 695L179 694L179 694L180 694L180 694L180 693L181 691L179 690L177 690L177 689z"
        },
        {
            "title": "Waddepally",
            "d": "M149 696L149 696L149 695L148 695L147 694L146 694L146 693L146 691L144 690L144 690L144 690L144 690L143 690L141 690L140 689L139 690L139 690L138 690L136 690L136 690L136 690L135 691L135 691L135 691L134 691L132 691L132 691L132 691L131 693L131 693L131 693L130 694L130 694L130 694L129 695L129 695L129 695L129 696L128 696L128 698L125 697L125 697L125 697L124 697L124 697L120 696L120 696L119 697L119 697L119 700L119 700L120 701L120 701L124 702L125 702L126 703L127 702L129 701L129 701L130 701L130 703L130 703L130 703L131 703L132 704L133 704L133 704L134 704L135 704L135 705L136 705L136 704L137 704L137 705L139 706L142 706L142 708L142 710L143 710L145 711L145 710L145 709L145 709L145 707L145 706L145 706L145 706L145 704L145 704L145 704L145 702L147 703L147 701L148 698L149 699L149 698L149 696z"
        },
        {
            "title": "Yerravalli",
            "d": "M156 663L155 662L155 662L155 662L154 662L154 662L153 661L152 661L152 661L152 661L152 661L152 661L152 662L152 662L151 663L151 663L150 664L150 665L149 665L149 665L149 665L149 665L149 665L148 665L148 665L148 665L148 666L147 666L147 666L147 666L147 666L147 666L147 666L147 667L146 666L146 667L146 667L146 667L146 667L146 667L145 668L145 668L145 668L145 668L145 669L145 670L145 670L144 671L143 671L143 671L143 671L143 672L142 672L143 673L144 673L145 673L146 673L146 673L148 673L149 674L149 675L149 676L149 676L149 677L149 677L149 677L149 678L149 679L147 679L147 679L146 682L146 682L146 682L146 682L146 683L146 683L146 683L146 684L146 684L147 684L147 684L149 685L149 686L151 686L152 686L153 686L153 686L155 686L153 688L154 689L155 689L157 689L158 689L159 689L159 688L159 688L159 688L159 688L159 687L159 687L160 686L160 685L161 685L161 685L162 685L162 684L162 684L164 679L164 678L163 676L162 675L159 674L158 672L158 671L157 670L157 669L157 668L157 666L156 665L156 663z"
        }
    ],
    "Siddipet": [
        {
            "title": "Akkannapet",
            "d": "M383 336L382 336L382 336L381 336L380 335L380 335L379 335L379 335L378 335L378 335L377 335L377 335L377 335L377 335L377 334L377 334L376 334L376 334L375 334L375 335L375 335L374 335L374 335L374 336L372 336L372 336L372 336L372 335L372 335L372 335L371 335L371 334L371 334L370 334L369 334L369 334L369 334L369 334L368 334L368 334L368 334L368 334L368 334L367 334L367 334L367 335L367 335L367 336L366 336L366 337L366 336L366 336L366 335L366 334L366 333L366 333L366 333L365 332L365 332L365 332L365 332L365 332L365 332L365 332L365 332L365 332L364 332L364 332L364 332L364 332L364 332L364 332L363 332L363 332L363 332L363 332L362 332L362 332L362 332L361 332L360 332L360 332L359 333L359 333L359 333L359 333L358 333L358 334L358 334L358 334L358 334L358 334L357 335L357 335L357 335L357 335L357 336L357 336L358 337L358 338L358 338L358 338L358 338L357 339L356 339L356 339L355 339L355 341L354 341L353 343L354 343L354 343L354 344L355 344L355 346L355 346L355 347L355 348L355 348L355 348L356 349L356 349L357 349L357 350L357 350L361 350L362 352L362 352L363 352L363 352L364 352L365 352L366 352L367 352L368 350L368 351L368 351L368 351L368 351L369 351L369 351L369 351L369 351L371 351L375 352L375 352L375 352L378 349L378 349L378 349L378 349L379 350L380 350L380 349L380 348L380 346L380 345L380 344L381 344L381 344L381 344L382 343L383 341L383 340L383 340L383 339L382 339L384 337L384 336L383 336z"
        },
        {
            "title": "Bejjanki",
            "d": "M356 301L355 301L355 301L354 301L354 301L354 301L353 301L353 301L352 301L352 301L352 301L352 301L351 301L351 301L350 301L350 301L350 301L349 301L347 300L348 299L348 298L348 298L348 298L348 298L349 297L349 297L349 297L349 296L349 296L349 296L348 295L348 295L348 295L347 295L347 295L347 294L347 293L347 292L347 291L347 291L347 291L347 291L347 291L347 291L347 291L346 291L346 292L345 291L345 291L345 291L345 291L345 291L345 292L343 291L343 292L343 292L343 292L343 292L342 292L342 292L342 293L342 293L341 294L341 294L341 294L341 294L341 294L341 295L340 297L339 297L338 297L338 298L336 298L336 299L336 299L336 300L335 300L335 300L335 301L336 301L336 301L335 303L335 303L335 304L335 305L336 305L335 306L335 306L334 306L334 307L333 307L332 307L332 307L332 307L332 307L332 307L331 307L330 307L330 307L330 307L330 308L330 308L330 309L330 309L330 309L329 309L330 315L330 315L332 315L332 314L332 314L332 314L334 314L335 315L336 315L337 316L338 316L338 316L338 316L339 316L339 316L339 315L339 315L340 315L340 314L340 314L340 313L342 312L344 311L345 311L345 311L345 311L345 312L345 312L345 312L345 313L344 313L344 313L344 313L344 314L344 314L344 314L344 314L344 315L344 315L344 315L344 315L344 315L344 316L344 316L344 316L344 316L345 316L344 316L345 317L345 317L345 317L345 317L345 317L346 318L346 318L346 318L346 317L347 317L347 317L347 317L348 317L348 317L348 317L348 317L349 317L349 316L349 316L349 316L349 316L350 316L350 315L350 315L350 315L351 314L351 313L351 312L351 311L350 311L350 310L350 310L350 309L351 308L352 307L353 306L354 306L354 305L355 304L355 304L356 304L357 304L357 303L357 302L357 302L357 302L356 301L356 301L356 301z"
        },
        {
            "title": "Cherial",
            "d": "M343 347L341 346L341 347L341 347L341 347L341 348L341 348L341 348L341 348L340 348L340 348L339 349L339 349L339 350L339 349L339 350L338 349L338 349L337 349L336 349L336 348L335 348L335 348L335 348L334 348L335 347L335 346L334 346L334 346L333 345L333 345L332 344L331 344L331 344L331 344L331 344L330 345L330 345L329 347L329 347L329 347L329 347L329 347L329 348L329 348L329 348L329 349L329 349L329 349L328 350L328 351L327 351L326 350L326 351L326 350L325 351L325 351L325 351L324 352L324 353L324 353L324 353L324 354L325 354L325 354L325 353L326 354L326 354L326 354L326 356L326 356L326 356L326 356L325 356L325 356L325 356L325 356L324 357L324 357L324 357L323 358L323 358L323 359L323 359L323 359L324 359L325 360L325 360L325 360L325 360L326 360L326 360L326 359L326 359L326 359L326 359L326 359L327 359L327 358L327 358L327 358L327 357L327 357L327 356L327 356L328 355L328 356L329 357L329 357L329 357L329 357L329 358L328 359L329 360L328 360L328 360L328 360L328 360L327 360L327 360L326 361L326 361L326 361L326 361L326 362L326 362L326 363L326 363L325 364L324 364L323 365L323 366L323 366L323 366L323 366L323 366L322 366L322 367L322 367L322 368L321 368L321 368L321 368L320 369L320 370L320 371L320 371L320 371L320 371L320 372L317 371L317 371L317 372L316 372L316 372L315 372L315 373L315 373L315 373L315 373L315 373L315 374L315 376L316 376L316 377L317 378L317 379L317 380L318 379L319 379L320 378L321 378L322 378L323 378L323 378L323 378L322 377L323 377L323 376L322 376L322 376L323 376L323 375L323 375L323 375L323 375L323 375L323 374L323 374L322 374L323 374L323 374L324 373L324 373L324 373L325 372L325 372L325 372L326 372L326 372L327 372L327 373L327 373L327 374L328 375L328 375L329 375L329 375L329 375L331 375L333 375L333 375L334 375L335 376L335 377L335 378L335 378L335 378L335 379L336 378L336 378L336 377L337 376L337 375L338 374L338 374L338 374L338 374L339 373L339 373L339 372L340 372L340 372L340 372L339 372L339 371L339 370L340 370L340 369L340 368L340 368L341 367L341 367L341 367L341 367L341 366L341 366L341 366L341 365L341 364L341 364L341 364L342 363L341 363L341 363L340 363L340 363L340 363L339 363L339 363L338 363L338 363L339 362L339 362L339 362L339 362L339 361L338 361L339 360L338 360L338 360L339 359L340 360L341 361L341 360L342 360L343 359L343 359L343 359L343 358L343 358L343 358L343 356L343 356L344 356L345 357L346 357L348 358L348 358L348 357L347 357L347 357L347 356L346 355L346 354L345 353L344 354L344 354L343 353L343 353L343 353L343 352L344 350L343 350L343 350L343 349L343 349L343 349L343 349L343 349L343 348L342 348L343 348L343 348L343 348L343 348L343 348L343 348L343 347L343 347L343 347L342 347L343 347z"
        },
        {
            "title": "Chinnakodur",
            "d": "M330 307L330 307L329 306L329 307L329 307L329 306L329 306L328 306L328 307L328 306L328 307L328 307L327 307L327 306L326 306L326 306L325 306L325 306L324 306L324 306L324 306L323 306L323 307L322 307L322 307L321 307L320 308L320 308L319 309L318 308L317 309L316 308L316 309L314 310L313 309L312 309L312 310L312 310L313 310L313 311L313 311L313 312L313 313L313 313L313 313L312 313L312 313L312 313L312 313L312 314L312 314L312 314L311 315L311 315L311 315L311 316L311 316L311 316L311 316L311 316L311 317L311 317L311 318L310 318L309 319L309 319L309 320L309 321L309 322L309 322L308 323L309 323L308 324L308 324L309 325L309 325L309 326L309 326L309 326L310 325L310 325L310 325L310 325L310 325L311 325L311 325L312 325L312 325L312 324L312 324L313 324L313 324L313 324L313 324L314 324L314 324L316 325L316 325L316 325L316 325L316 325L316 325L316 326L317 326L317 326L317 326L318 327L318 327L318 327L318 328L319 328L319 328L320 328L320 328L320 328L320 328L320 328L320 327L321 327L321 327L321 327L321 327L321 327L323 327L323 328L323 328L323 328L323 328L323 329L324 329L324 329L324 329L325 329L325 331L326 331L326 331L326 331L327 331L327 331L327 330L328 330L328 330L328 330L328 330L329 330L329 331L329 330L329 330L329 330L329 330L330 330L330 331L330 331L332 330L333 330L334 330L335 329L334 328L335 328L335 328L335 328L336 328L336 328L336 328L336 328L337 328L337 327L338 326L338 326L339 325L339 324L339 324L339 324L339 323L340 323L340 322L340 322L340 322L340 322L340 322L341 321L340 321L339 320L339 320L339 320L339 320L339 320L339 319L339 318L339 318L339 318L339 318L339 317L339 316L338 316L338 316L338 316L337 316L336 315L335 315L334 314L332 314L332 314L332 314L332 315L330 315L330 315L329 309L330 309L330 309L330 309L330 308L330 308L330 307L330 307L330 307z"
        },
        {
            "title": "Dubbak",
            "d": "M268 321L268 322L268 322L269 322L269 323L269 323L269 323L269 322L270 321L271 321L271 321L271 321L270 321L269 321L269 321L269 321L269 321L268 321L268 321zM292 313L292 313L292 312L292 312L292 312L293 312L293 312L292 311L292 311L292 310L291 310L291 310L291 309L290 310L289 309L288 310L288 310L288 310L287 310L287 310L285 310L284 309L284 309L284 309L284 308L284 308L284 309L283 308L283 308L283 308L283 308L282 308L281 307L280 307L280 307L280 306L279 306L279 306L278 306L278 306L277 306L276 307L276 307L275 307L274 307L273 307L272 307L271 307L271 307L270 307L270 307L268 310L268 310L268 311L267 311L267 311L266 311L266 311L266 312L265 314L265 314L266 314L266 315L266 316L266 317L266 317L267 318L268 318L268 318L269 318L270 318L271 319L271 319L271 319L271 319L272 319L272 320L272 319L272 320L272 319L273 320L273 320L275 320L275 321L275 321L276 322L277 322L277 322L277 323L277 323L277 323L277 323L277 324L276 324L277 324L276 324L276 325L276 325L276 325L276 325L276 325L276 325L276 326L276 326L277 326L277 327L277 327L277 327L277 327L277 327L278 328L279 328L279 328L280 328L280 329L280 329L281 329L282 330L283 330L284 330L284 330L284 329L285 329L285 329L285 328L286 328L286 327L286 328L287 328L288 328L289 328L290 328L290 328L290 329L289 329L289 330L289 330L289 331L290 332L290 332L291 332L293 333L294 332L294 332L294 331L294 331L295 328L295 327L294 327L295 327L296 326L297 326L297 325L297 323L297 323L297 323L297 322L296 322L296 322L296 322L295 322L295 321L292 320L292 320L292 320L292 320L291 319L291 319L291 319L291 318L291 318L291 317L291 316L292 316L291 315L291 314L291 314L292 313L292 313L292 313z"
        },
        {
            "title": "Gajwel",
            "d": "M293 361L293 361L293 361L293 360L292 359L292 359L291 358L291 358L291 358L291 358L290 357L290 356L290 356L289 354L289 354L288 354L288 354L288 355L287 354L287 354L286 355L286 355L286 354L286 354L285 356L285 357L284 357L284 357L284 357L284 358L283 357L283 359L282 360L282 361L282 360L281 361L281 361L281 362L280 364L280 365L279 366L279 366L279 367L279 367L279 368L279 368L281 369L281 369L281 370L278 370L277 370L277 370L276 373L275 373L275 373L275 373L275 374L274 374L273 374L272 374L271 372L271 372L270 372L270 372L270 373L270 374L270 374L270 375L270 375L270 375L270 375L269 375L269 375L269 375L269 377L269 377L269 378L268 379L268 378L268 379L268 379L269 379L269 379L269 378L270 379L270 379L270 379L271 380L272 380L272 380L273 379L274 379L275 379L275 379L275 380L275 380L275 380L277 381L278 381L279 382L279 382L279 383L280 383L280 383L280 383L281 384L281 384L281 384L282 385L284 385L285 385L287 384L289 385L290 385L290 384L290 384L291 384L290 384L290 384L291 383L292 383L293 384L294 384L294 383L295 383L296 383L295 382L296 382L296 382L296 380L296 380L297 380L297 380L297 380L297 380L297 379L297 379L297 379L297 379L297 378L297 378L297 378L297 378L297 377L297 377L297 377L297 377L297 377L297 377L297 376L297 377L296 376L296 375L296 375L296 375L297 375L298 375L298 375L298 375L298 375L299 375L299 374L300 374L301 374L301 374L301 372L302 372L300 371L300 371L300 371L299 370L299 370L299 370L298 370L298 370L296 369L295 369L295 369L295 369L295 369L295 368L295 368L295 368L295 368L295 367L295 367L294 367L294 367L294 367L294 366L294 366L294 366L294 365L293 365L293 365L293 365L293 365L293 364L293 364L293 364L293 363L293 363L293 363L293 362L293 362L292 362L292 361L293 361z"
        },
        {
            "title": "Koheda",
            "d": "M364 323L363 322L363 322L363 322L362 321L362 320L362 320L362 320L362 320L361 319L361 319L361 319L361 319L362 317L362 317L362 316L362 316L362 316L362 316L361 316L361 316L361 316L360 316L360 315L360 315L360 315L360 315L359 315L359 315L359 314L358 314L358 314L358 314L357 314L357 314L356 314L356 314L356 314L356 314L356 314L356 314L356 313L355 313L355 313L355 312L355 312L355 312L355 311L355 311L355 311L355 310L356 310L356 310L356 309L356 309L357 309L357 309L358 309L358 309L358 309L358 309L358 308L358 308L358 308L358 308L358 308L358 308L357 307L357 307L357 307L357 306L358 306L358 306L359 306L359 305L359 305L359 304L359 304L358 304L358 304L357 304L356 304L355 304L355 304L354 305L354 306L353 306L352 307L351 308L350 309L350 310L350 310L350 311L351 311L351 312L351 313L351 314L350 315L350 315L350 315L350 316L349 316L349 316L349 316L349 316L349 317L348 317L348 317L348 317L348 317L347 317L347 317L347 317L346 317L346 318L346 318L346 318L345 317L345 317L345 317L345 317L345 317L344 316L345 316L344 316L344 316L344 316L344 316L344 315L344 315L344 315L344 315L344 315L344 314L344 314L344 314L344 314L344 313L344 313L344 313L345 313L345 312L345 312L345 312L345 311L345 311L345 311L344 311L342 312L340 313L340 314L340 314L340 315L339 315L339 315L339 316L339 316L339 317L339 318L339 318L339 318L339 318L339 319L339 320L339 320L339 320L339 320L339 320L340 321L341 321L340 322L340 322L340 322L340 322L340 322L340 323L339 323L339 324L339 324L339 324L339 325L338 326L338 326L339 328L340 328L340 328L341 328L342 328L343 329L342 329L342 329L343 331L343 333L341 334L341 334L343 335L345 336L345 336L345 336L346 336L347 336L348 336L348 336L349 336L349 336L350 336L351 336L351 337L351 336L351 336L351 336L351 336L351 336L352 336L353 336L354 336L355 337L355 337L356 337L356 337L358 338L358 337L357 336L357 336L357 335L357 335L357 335L357 335L358 334L358 334L358 334L358 334L358 334L358 333L359 333L359 333L359 333L359 333L360 332L360 332L360 331L360 331L360 331L360 331L360 330L360 330L360 330L360 330L360 330L360 330L360 329L360 329L360 329L360 328L360 327L361 327L361 327L361 327L361 326L362 326L362 326L363 326L363 326L363 325L363 325L363 325L364 324L364 324L364 324L364 323L364 323L364 323z"
        },
        {
            "title": "Komuravelli",
            "d": "M324 353L323 354L323 354L322 356L321 357L321 357L321 356L321 356L320 357L319 357L319 357L318 356L318 356L317 356L317 356L317 355L317 356L317 356L317 356L317 357L317 356L316 357L316 357L316 357L316 358L315 359L315 359L315 359L315 361L315 362L314 362L314 362L314 362L314 362L314 362L314 363L313 363L313 364L313 364L312 364L312 364L312 364L312 364L312 365L313 365L312 366L311 366L311 367L310 368L310 368L308 368L308 369L309 371L310 371L311 372L312 372L313 373L313 373L314 373L315 373L315 373L315 373L315 373L315 372L316 372L316 372L317 372L317 371L317 371L320 372L320 371L320 371L320 371L320 371L320 370L320 369L321 368L321 368L321 368L322 368L322 367L322 367L322 366L323 366L323 366L323 366L323 366L323 366L323 365L324 364L325 364L326 363L326 363L326 362L326 362L326 361L326 361L326 361L326 361L327 360L327 360L328 360L328 360L328 360L328 360L329 360L328 359L329 358L329 357L329 357L329 357L329 357L328 356L328 355L327 356L327 356L327 357L327 357L327 358L327 358L327 358L327 359L326 359L326 359L326 359L326 359L326 359L326 360L326 360L325 360L325 360L325 360L325 360L324 359L323 359L323 359L323 359L323 358L323 358L324 357L324 357L324 357L325 356L325 356L325 356L325 356L326 356L326 356L326 356L326 356L326 354L326 354L326 354L325 353L325 354L325 354L324 354L324 353z"
        },
        {
            "title": "Husnabad",
            "d": "M387 328L385 327L385 325L385 325L385 325L383 324L381 324L379 323L378 323L378 323L378 322L377 321L377 320L377 320L375 320L375 320L375 320L374 320L374 320L374 320L373 320L373 320L372 321L372 323L372 323L372 323L372 323L371 323L371 323L371 323L370 323L370 323L370 323L369 323L369 322L368 322L368 322L368 322L368 322L368 321L368 321L367 321L367 321L367 321L367 322L367 321L367 322L366 322L366 322L366 323L365 323L365 323L365 323L365 323L364 323L364 323L364 323L364 324L364 324L364 324L363 325L363 325L363 325L363 326L363 326L362 326L362 326L361 326L361 327L361 327L361 327L360 327L360 328L360 329L360 329L360 329L360 330L360 330L360 330L360 330L360 330L360 330L360 331L360 331L360 331L360 331L360 332L361 332L362 332L362 332L362 332L363 332L363 332L363 332L363 332L364 332L364 332L364 332L364 332L364 332L364 332L365 332L365 332L365 332L365 332L365 332L365 332L365 332L365 332L365 332L366 333L366 333L366 333L366 334L366 335L366 336L366 336L366 337L366 336L367 336L367 335L367 335L367 334L367 334L368 334L368 334L368 334L368 334L368 334L369 334L369 334L369 334L369 334L370 334L371 334L371 334L371 335L372 335L372 335L372 335L372 336L372 336L372 336L374 336L374 335L374 335L375 335L375 335L375 334L376 334L376 334L377 334L377 334L377 335L377 335L377 335L377 335L378 335L378 335L379 335L379 335L380 335L380 335L381 336L382 336L382 336L383 336L384 333L384 333L385 333L385 332L385 332L385 331L385 331L385 330L387 328z"
        },
        {
            "title": "Jagdevpur",
            "d": "M309 371L309 371L308 372L308 373L309 374L308 374L308 375L308 375L308 375L308 375L308 376L307 376L307 376L307 376L307 377L306 377L306 377L306 377L306 376L306 375L304 375L304 375L302 375L302 374L301 375L301 376L300 377L300 377L299 378L299 378L299 378L299 378L298 378L298 378L298 378L298 378L298 378L298 378L298 378L297 377L297 377L297 377L297 377L297 377L297 377L297 378L297 378L297 378L297 378L297 379L297 379L297 379L297 379L297 380L297 380L297 380L297 380L296 380L296 380L296 382L296 382L295 382L296 383L296 383L297 384L296 384L296 385L297 386L297 386L297 386L297 386L298 386L298 386L298 387L298 387L298 388L299 388L298 388L298 389L297 389L297 391L297 391L298 391L298 392L298 392L298 393L298 393L298 394L298 394L298 395L298 395L299 394L300 395L301 396L301 395L302 396L302 396L302 396L302 397L301 397L301 396L301 396L300 396L300 396L300 396L300 396L299 396L299 396L298 397L298 397L297 397L297 397L297 397L297 397L298 398L299 398L299 399L299 399L299 399L299 399L300 399L300 400L302 400L302 400L303 400L304 400L305 401L306 401L306 401L306 400L306 398L306 398L308 397L307 397L307 396L307 395L307 395L308 395L308 395L309 394L310 393L310 393L310 393L310 393L312 393L312 393L313 393L314 392L314 392L314 391L314 390L315 387L315 387L315 387L315 386L315 385L315 383L315 383L315 383L315 383L315 383L315 382L315 382L315 380L316 380L317 380L317 380L317 379L317 378L316 377L316 376L315 376L315 374L315 373L315 373L314 373L313 373L313 373L312 372L311 372L310 371L309 371z"
        },
        {
            "title": "Kondapak",
            "d": "M313 364L313 363L314 363L314 362L314 362L314 362L314 362L314 362L315 362L315 361L315 359L315 359L315 359L316 358L316 357L316 357L316 357L317 356L317 357L317 356L317 356L317 356L317 355L317 356L317 356L318 356L318 356L319 357L319 357L320 357L321 356L321 356L321 357L321 357L322 356L323 354L323 354L324 353L324 353L324 353L324 352L325 351L325 351L325 351L326 350L326 351L326 350L327 351L328 351L328 350L329 349L329 349L329 349L329 348L329 348L329 348L329 347L329 347L329 347L329 347L329 347L330 345L330 345L330 344L330 344L330 344L329 344L329 344L329 344L328 343L327 343L326 342L327 342L327 341L326 341L325 341L325 341L325 342L325 342L325 343L323 342L322 342L322 343L321 344L320 344L319 343L317 343L317 343L316 343L315 343L314 343L313 343L311 343L309 342L309 342L309 340L309 340L309 340L309 340L308 340L308 340L308 340L308 340L307 342L307 342L307 342L305 342L305 344L304 345L304 345L304 346L305 347L305 347L305 348L304 350L304 350L303 351L303 351L302 351L301 351L300 350L300 351L299 351L298 352L300 352L303 353L303 356L303 356L304 357L304 357L305 358L306 359L306 359L306 359L307 360L308 361L308 362L309 362L310 363L310 363L311 363L312 363L312 363L312 364L313 363L313 364z"
        },
        {
            "title": "Maddur",
            "d": "M348 358L348 358L346 357L345 357L344 356L343 356L343 356L343 358L343 358L343 358L343 359L343 359L343 359L342 360L341 360L341 361L340 360L339 359L338 360L338 360L339 360L338 361L339 361L339 362L339 362L339 362L339 362L338 363L338 363L339 363L339 363L340 363L340 363L340 363L341 363L341 363L342 363L341 364L341 364L341 364L341 365L341 366L341 366L341 366L341 367L341 367L341 367L341 367L340 368L340 368L340 369L340 370L339 370L339 371L339 372L340 372L340 372L340 372L341 372L341 372L342 372L343 372L343 373L344 374L344 374L345 374L345 374L345 374L346 373L346 373L346 373L347 373L348 372L349 372L349 372L349 372L350 372L351 372L351 373L352 372L352 373L353 372L353 371L354 370L354 369L355 369L355 368L356 368L356 368L357 368L357 367L357 367L356 367L356 367L356 367L354 366L354 365L354 364L355 364L355 363L356 363L356 362L357 362L357 362L357 361L356 361L356 360L355 360L355 359L355 359L355 359L355 359L355 359L355 358L355 357L355 357L355 357L355 357L353 357L351 356L351 357L351 357L351 357L351 357L351 357L351 357L350 356L348 357L348 358z"
        },
        {
            "title": "Markook",
            "d": "M300 400L300 399L299 399L299 399L299 399L299 399L299 398L298 398L297 397L297 397L297 397L297 397L298 397L298 397L299 396L299 396L300 396L300 396L300 396L300 396L301 396L301 396L301 397L302 397L302 396L302 396L302 396L301 395L301 396L300 395L299 394L298 395L298 395L298 394L298 394L298 393L298 393L298 392L298 392L298 391L297 391L297 391L297 389L298 389L298 388L299 388L298 388L298 387L298 387L298 386L298 386L297 386L297 386L297 386L297 386L296 385L296 384L297 384L296 383L296 383L295 383L294 383L294 384L293 384L292 383L291 383L290 384L290 384L291 384L290 384L290 384L290 385L289 385L287 384L285 385L284 385L282 385L281 384L281 385L281 385L282 386L282 386L282 387L282 389L282 391L284 392L284 393L286 392L286 392L287 392L288 392L288 392L288 393L288 395L287 397L288 398L289 398L291 399L291 400L291 400L291 400L292 401L292 401L290 402L290 403L289 403L289 404L289 405L289 405L289 405L289 406L290 407L291 407L292 407L293 406L294 404L296 404L296 404L296 404L296 404L296 404L298 404L298 404L298 404L300 403L300 403L300 402L301 402L302 402L301 401L301 401L301 400L301 400L300 400z"
        },
        {
            "title": "Mirdoddi",
            "d": "M293 333L291 332L290 332L290 332L289 331L289 330L289 330L289 329L290 329L290 328L290 328L289 328L288 328L287 328L286 328L286 327L286 328L285 328L285 329L285 329L284 329L284 330L284 330L283 330L282 330L281 329L280 331L279 332L277 334L277 334L277 334L277 334L277 334L277 335L277 335L277 335L278 335L278 337L277 338L277 338L276 338L276 338L276 339L276 340L276 341L276 341L276 341L275 343L277 346L277 348L277 349L278 351L279 351L280 350L280 349L283 349L283 349L283 349L283 348L283 347L283 346L284 347L284 347L285 346L287 346L287 346L286 345L286 344L286 344L287 343L287 343L287 343L287 343L289 342L289 341L291 341L290 340L290 340L290 338L290 338L290 337L290 337L291 337L291 336L291 336L292 334L293 333z"
        },
        {
            "title": "Mulug",
            "d": "M289 405L289 405L289 405L289 404L289 403L290 403L290 402L292 401L292 401L291 400L291 400L291 400L291 399L289 398L288 398L287 397L288 395L288 393L288 392L288 392L287 392L286 392L286 392L284 393L284 392L282 391L281 391L281 391L280 392L279 392L279 393L277 393L276 393L276 393L276 393L276 393L274 393L274 393L272 393L271 392L270 393L269 393L269 394L268 394L268 394L268 394L267 394L267 394L267 395L267 395L266 395L266 395L265 395L265 395L264 394L264 394L262 393L260 393L259 394L259 393L258 394L258 393L256 396L256 397L256 397L256 397L255 397L255 398L255 398L255 398L255 399L253 402L253 403L253 404L254 403L255 404L255 404L256 402L257 401L257 401L257 401L257 401L257 401L258 402L258 402L259 402L259 402L260 402L260 402L261 403L263 403L263 403L263 403L263 403L263 403L263 404L264 404L265 404L265 404L266 404L266 404L266 403L266 402L266 402L267 402L267 402L268 402L268 402L268 402L269 402L269 402L270 402L270 402L270 402L270 403L271 404L272 404L273 405L273 406L274 406L276 407L276 406L277 406L278 406L279 405L279 404L279 404L280 402L280 402L282 402L282 402L283 402L285 402L284 403L284 404L286 404L287 404L289 405L289 405z"
        },
        {
            "title": "Nangnoor",
            "d": "M358 338L356 337L356 337L355 337L355 337L354 336L353 336L352 336L351 336L351 336L351 336L351 336L351 336L351 337L351 336L350 336L349 336L349 336L348 336L348 336L347 336L346 336L345 336L345 336L345 336L343 335L341 334L341 334L343 333L343 331L342 329L342 329L343 329L342 328L341 328L340 328L340 328L339 328L338 326L337 327L337 328L336 328L336 328L336 328L336 328L335 328L335 328L335 328L334 328L335 329L334 330L333 330L332 330L330 331L330 331L330 330L329 330L329 330L329 330L329 330L329 331L329 330L328 330L328 330L328 330L328 330L327 330L327 331L327 331L326 331L326 331L326 331L325 331L325 332L325 332L324 332L324 333L324 333L324 334L324 335L323 336L323 336L323 336L324 336L324 336L324 336L324 336L324 336L324 336L325 337L326 337L326 337L325 338L326 338L325 339L325 340L325 340L325 340L325 341L325 341L325 341L326 341L327 341L327 342L326 342L327 343L328 343L329 344L329 344L329 344L330 344L330 344L330 344L330 345L331 344L331 344L331 344L331 344L332 344L333 345L333 345L334 346L334 346L335 346L335 347L334 348L335 348L335 348L335 348L336 348L336 349L337 349L338 349L338 349L339 350L339 349L339 350L339 349L339 349L340 348L340 348L341 348L341 348L341 348L341 348L341 347L341 347L341 347L341 346L343 347L343 346L343 346L344 345L346 345L346 346L346 347L347 347L347 347L347 347L347 347L347 347L347 347L348 347L348 348L348 348L349 348L350 347L350 347L352 346L354 347L355 346L355 346L355 344L354 344L354 343L354 343L353 343L354 341L355 341L355 339L356 339L356 339L357 339L358 338L358 338L358 338L358 338z"
        },
        {
            "title": "Raipole",
            "d": "M286 354L284 353L283 353L282 352L282 352L282 353L281 353L281 354L280 354L280 354L279 355L279 355L278 355L278 355L277 355L277 356L277 356L276 356L275 357L275 357L274 357L274 357L273 357L273 358L272 358L273 360L272 361L272 362L272 362L272 362L271 362L271 362L270 362L270 362L270 362L268 362L268 363L267 364L267 364L266 366L266 367L265 367L265 369L264 370L265 370L265 371L265 371L264 371L264 372L265 373L266 373L267 373L267 373L267 373L267 374L267 374L267 374L266 375L266 375L265 375L264 374L264 374L264 375L264 376L264 377L264 377L264 378L266 378L267 378L268 378L268 379L269 378L269 377L269 377L269 375L269 375L269 375L270 375L270 375L270 375L270 375L270 374L270 374L270 373L270 372L270 372L271 372L271 372L272 374L273 372L275 370L276 370L277 370L277 370L278 370L281 370L281 369L281 369L279 368L279 368L279 367L279 367L279 366L279 366L280 365L280 364L281 362L281 361L281 361L282 360L282 361L282 360L283 359L283 357L284 358L284 357L284 357L284 357L285 357L285 356L286 354L286 354z"
        },
        {
            "title": "Siddipet_Rural",
            "d": "M309 319L307 319L306 319L304 318L304 318L304 317L304 316L303 316L303 316L302 316L302 316L301 316L299 315L299 316L299 315L299 316L298 316L298 316L297 316L297 315L296 313L296 312L296 312L296 312L295 313L294 313L294 313L292 313L292 313L292 313L292 313L291 314L291 314L291 315L292 316L291 316L291 317L291 318L291 318L291 319L291 319L291 319L292 320L292 320L292 320L292 320L295 321L295 322L296 322L296 322L296 322L297 322L297 323L297 323L297 323L297 325L297 326L296 326L295 327L294 327L295 327L295 328L294 331L294 331L294 332L295 332L295 333L296 333L296 333L295 335L295 336L295 337L295 337L296 337L296 338L296 338L297 339L298 339L298 339L298 338L299 338L299 338L300 338L300 339L300 340L302 339L302 339L302 337L302 336L302 336L302 336L303 335L303 334L304 333L304 333L304 331L304 331L305 331L306 330L306 330L307 330L307 329L307 328L307 327L308 327L308 327L309 326L309 326L309 326L309 325L309 325L308 324L308 324L309 323L308 323L309 322L309 322L309 321L309 320L309 319z"
        },
        {
            "title": "Siddipet_Urban",
            "d": "M325 331L325 329L324 329L324 329L324 329L323 329L323 328L323 328L323 328L323 328L323 327L321 327L321 327L321 327L321 327L321 327L320 327L320 328L320 328L320 328L320 328L320 328L319 328L319 328L318 328L318 327L318 327L318 327L317 326L317 326L317 326L316 326L316 325L316 325L316 325L316 325L316 325L316 325L314 324L314 324L313 324L313 324L313 324L313 324L312 324L312 324L312 325L312 325L311 325L311 325L310 325L310 325L310 325L310 325L310 325L309 326L309 326L309 326L309 326L309 326L308 327L308 327L307 327L307 328L307 329L307 330L306 330L306 330L305 331L304 331L304 331L304 333L304 333L303 334L303 335L302 336L302 336L302 336L302 337L302 339L302 339L300 340L300 340L300 340L302 340L303 340L304 341L305 342L307 342L307 342L307 342L308 340L308 340L308 340L308 340L309 340L309 340L309 340L309 340L309 342L309 342L311 343L313 343L314 343L315 343L316 343L317 343L317 343L319 343L320 344L321 344L322 343L322 342L323 342L325 343L325 342L325 342L325 341L325 341L325 340L325 340L325 340L325 339L326 338L325 338L326 337L326 337L325 337L324 336L324 336L324 336L324 336L324 336L324 336L323 336L323 336L323 336L324 335L324 334L324 333L324 333L324 332L325 332L325 332L325 331z"
        },
        {
            "title": "Thoguta",
            "d": "M300 340L300 339L300 338L299 338L299 338L298 338L298 339L298 339L297 339L296 338L296 338L296 337L295 337L295 337L295 336L295 335L296 333L296 333L295 333L295 332L294 332L294 332L293 333L292 334L291 336L291 336L291 337L290 337L290 337L290 338L290 338L290 340L290 340L291 341L289 341L289 342L287 343L287 343L287 343L287 343L286 344L286 344L286 345L287 346L287 346L285 346L284 347L284 347L283 346L283 347L283 348L283 349L283 349L283 349L280 349L280 350L279 351L278 351L278 351L278 352L278 354L278 355L278 355L279 355L279 355L280 354L280 354L281 354L281 353L282 353L282 352L282 352L283 353L284 353L286 354L286 355L286 355L287 354L287 354L288 355L288 354L288 354L289 354L289 354L290 356L290 356L290 357L291 358L291 358L291 358L291 358L292 359L292 359L293 360L293 361L293 361L293 361L293 361L294 361L296 361L297 361L297 361L297 361L297 361L298 361L298 361L298 360L298 360L299 360L300 360L300 360L301 359L302 359L302 359L302 358L303 357L304 357L303 356L303 356L303 353L300 352L298 352L299 351L300 351L300 350L301 351L302 351L303 351L303 351L304 350L304 350L305 348L305 347L305 347L304 346L304 345L304 345L305 344L305 342L304 341L303 340L302 340L300 340L300 340L300 340z"
        },
        {
            "title": "Wargal",
            "d": "M264 377L263 379L262 378L261 378L260 378L259 378L258 377L258 378L257 379L258 380L258 381L257 382L257 382L257 383L256 383L257 385L256 387L256 388L256 388L256 390L257 392L257 392L257 392L257 393L258 393L258 393L258 394L259 393L259 394L260 393L262 393L264 394L264 394L265 395L265 395L266 395L266 395L267 395L267 395L267 394L267 394L268 394L268 394L268 394L269 394L269 393L270 393L271 392L272 393L274 393L274 393L276 393L276 393L276 393L276 393L277 393L279 393L279 392L280 392L281 391L281 391L282 391L282 389L282 387L282 386L282 386L281 385L281 385L281 384L281 384L281 384L280 383L280 383L280 383L279 383L279 382L279 382L278 381L277 381L275 380L275 380L275 380L275 379L275 379L274 379L273 379L272 380L272 380L271 380L270 379L270 379L270 379L269 378L269 379L269 379L268 379L268 379L268 378L267 378L266 378L264 378L264 377z"
        },
        {
            "title": "Doultabad",
            "d": "M264 374L264 374L265 375L266 375L266 375L267 374L267 374L267 374L267 373L267 373L267 373L266 373L265 373L264 372L264 372L264 374zM277 370L276 370L275 370L273 372L272 374L273 374L274 374L275 374L275 373L275 373L275 373L276 373L277 370zM268 344L266 344L266 344L266 344L265 343L265 343L265 343L264 343L264 342L264 342L264 343L264 344L263 346L262 349L262 350L260 349L260 351L260 351L260 352L260 352L261 353L261 353L261 354L261 355L260 356L260 357L260 357L260 358L260 358L260 358L260 358L260 358L261 359L261 360L261 360L261 361L260 361L260 361L260 361L260 361L260 361L260 361L259 361L259 362L259 363L259 363L259 363L260 363L260 363L261 363L261 364L262 364L262 365L262 365L261 365L261 365L260 366L260 366L260 366L259 367L259 367L259 368L259 368L259 369L259 369L259 370L259 370L261 370L261 370L261 370L261 369L261 369L262 370L263 369L263 370L264 370L265 369L265 367L266 367L266 366L267 364L267 364L268 363L268 362L270 362L270 362L270 362L271 362L271 362L272 362L272 362L272 362L272 361L273 360L272 358L273 358L273 357L274 357L274 357L275 357L275 357L276 356L277 356L277 356L277 355L278 355L278 354L278 352L278 351L278 351L277 349L277 348L277 346L275 343L274 343L273 344L272 344L269 344L269 344L269 345L268 344L268 344z"
        },
        {
            "title": "Narayanraopet",
            "d": "M309 319L309 319L310 318L311 318L311 317L311 317L311 316L311 316L311 316L311 316L311 316L311 315L311 315L311 315L312 314L312 314L312 314L312 313L312 313L312 313L312 313L313 313L313 313L313 313L313 312L313 311L313 311L313 310L312 310L312 310L312 309L313 309L313 308L312 308L310 307L310 307L310 307L309 307L309 307L309 307L308 306L308 307L308 307L307 306L307 307L306 306L306 306L305 306L304 306L304 306L304 306L304 306L304 306L303 306L303 306L303 306L303 306L303 306L302 306L301 306L301 305L300 305L300 305L299 305L299 305L299 305L299 306L298 307L298 308L298 309L298 310L297 310L297 310L296 312L296 312L296 312L296 313L297 315L297 316L298 316L298 316L299 316L299 315L299 316L299 315L301 316L302 316L302 316L303 316L303 316L304 316L304 317L304 318L304 318L306 319L307 319L309 319z"
        },
        {
            "title": "Dhoolumitta",
            "d": "M357 361L358 360L358 360L359 359L359 359L359 358L360 357L361 357L360 354L362 352L361 350L357 350L357 350L357 349L356 349L356 349L355 348L355 348L355 348L355 347L355 346L354 347L352 346L350 347L350 347L349 348L348 348L348 348L348 347L347 347L347 347L347 347L347 347L347 347L347 347L346 347L346 346L346 345L344 345L343 346L343 346L343 347L342 347L343 347L343 347L343 347L343 348L343 348L343 348L343 348L343 348L343 348L342 348L343 348L343 349L343 349L343 349L343 349L343 349L343 350L343 350L344 350L343 352L343 353L343 353L343 353L344 354L344 354L345 353L346 354L346 355L347 356L347 357L347 357L348 357L348 358L348 357L350 356L351 357L351 357L351 357L351 357L351 357L351 357L351 356L353 357L355 357L355 357L355 357L355 357L355 358L355 359L355 359L355 359L355 359L355 359L355 360L356 360L356 361L357 361z"
        },
        {
            "title": "Akbarpet-bhoompally",
            "d": "M281 329L280 329L280 329L280 328L279 328L279 328L278 328L277 327L277 327L277 327L277 327L277 327L277 326L276 326L276 326L276 325L276 325L276 325L276 325L276 325L276 325L276 324L277 324L276 324L277 324L277 323L277 323L277 323L277 323L277 322L277 322L276 322L275 321L275 321L275 320L273 320L273 320L272 319L272 320L272 319L272 320L272 319L271 319L271 319L271 319L271 319L270 318L269 318L268 318L268 318L267 318L266 317L266 317L266 317L266 318L266 318L267 319L267 319L268 320L268 320L268 321L269 321L269 321L269 321L269 321L270 321L271 321L271 321L271 321L270 321L269 322L269 323L269 323L269 323L269 322L268 322L268 322L268 321L268 322L267 322L266 322L264 325L264 325L264 327L263 328L263 329L262 329L262 330L263 330L265 331L266 331L267 331L267 331L267 331L268 331L268 332L268 332L268 332L267 333L267 333L267 333L267 333L267 334L267 334L266 335L266 335L266 335L266 337L266 337L266 338L267 338L268 338L269 338L269 339L269 339L269 339L269 340L269 340L269 341L268 343L268 344L268 344L269 345L269 344L269 344L272 344L273 344L274 343L275 343L276 341L276 341L276 341L276 340L276 339L276 338L276 338L277 338L277 338L278 337L278 335L277 335L277 335L277 335L277 334L277 334L277 334L277 334L277 334L279 332L280 331L281 329z"
        },
        {
            "title": "Kukunoorpally",
            "d": "M313 364L313 363L312 364L312 363L312 363L311 363L310 363L310 363L309 362L308 362L308 361L307 360L306 359L306 359L306 359L305 358L304 357L304 357L303 357L302 358L302 359L302 359L301 359L300 360L300 360L299 360L298 360L298 360L298 361L298 361L297 361L297 361L297 361L297 361L296 361L294 361L293 361L293 361L292 361L292 362L293 362L293 362L293 363L293 363L293 363L293 364L293 364L293 364L293 365L293 365L293 365L293 365L294 365L294 366L294 366L294 366L294 367L294 367L294 367L295 367L295 367L295 368L295 368L295 368L295 368L295 369L295 369L295 369L295 369L296 369L298 370L298 370L299 370L299 370L299 370L300 371L300 371L300 371L302 372L301 372L301 374L301 374L300 374L299 374L299 375L298 375L298 375L298 375L298 375L297 375L296 375L296 375L296 375L296 376L297 377L297 376L297 377L297 377L297 377L297 377L297 377L298 378L298 378L298 378L298 378L298 378L298 378L298 378L299 378L299 378L299 378L299 378L300 377L300 377L301 376L301 375L302 374L302 375L304 375L304 375L306 375L306 376L306 377L306 377L306 377L307 377L307 376L307 376L307 376L308 376L308 375L308 375L308 375L308 375L308 374L309 374L308 373L308 372L309 371L309 371L308 369L308 368L310 368L310 368L311 367L311 366L312 366L313 365L312 365L312 364L312 364L312 364L312 364L313 364L313 364z"
        }
    ],
    "Medak": [
        {
            "title": "Alladurg",
            "d": "M168 349L167 349L167 349L166 349L167 349L167 349L166 349L166 348L165 347L164 347L164 347L164 347L164 347L162 346L162 346L161 346L161 346L159 345L159 346L157 346L157 346L156 348L156 348L156 348L154 349L153 350L154 353L154 354L155 354L157 355L157 357L157 357L156 357L156 357L156 359L155 359L156 360L157 361L159 361L159 361L159 360L160 360L160 360L160 360L160 360L160 361L160 361L160 362L161 362L161 362L162 362L162 362L162 362L162 362L162 363L162 363L162 364L162 364L162 364L162 364L162 365L161 365L161 365L160 365L161 366L161 367L161 367L162 367L162 367L163 367L163 367L164 367L164 368L165 368L165 367L166 367L167 367L167 367L167 368L168 368L169 368L169 368L169 368L169 368L169 368L170 368L170 368L170 368L171 368L171 368L172 367L172 367L172 367L172 366L172 366L172 366L172 365L172 365L172 364L172 364L172 363L173 362L173 362L173 362L172 361L170 361L171 360L170 360L168 360L167 360L168 357L168 355L168 356L169 356L169 355L169 355L170 354L170 354L170 353L171 353L171 353L171 353L171 352L171 352L171 352L171 352L171 352L171 352L171 352L172 352L172 352L172 351L171 351L171 351L170 351L170 351L169 351L168 350L168 349L168 349L168 349z"
        },
        {
            "title": "Havelighanpur",
            "d": "M208 312L208 312L206 312L204 313L203 313L203 313L202 313L201 318L201 318L201 318L201 318L201 318L201 319L200 321L200 323L200 323L200 323L200 323L200 323L201 323L201 323L201 324L202 324L202 324L202 325L202 325L202 325L202 326L202 326L202 327L202 327L202 328L202 328L202 328L201 328L202 330L202 332L202 332L201 332L201 332L200 333L199 334L198 334L198 334L199 335L200 335L201 335L202 336L205 337L206 337L206 337L207 338L207 339L207 339L207 339L209 340L210 340L210 339L211 339L211 338L211 338L212 338L212 338L212 338L212 338L212 338L212 338L213 338L213 338L213 338L213 338L213 338L213 338L214 338L214 338L214 338L214 337L215 337L215 337L215 337L215 337L215 337L215 337L215 337L216 336L217 336L218 337L218 336L218 336L219 336L219 335L221 334L221 334L221 334L223 333L224 332L224 332L226 332L231 331L229 329L230 328L230 327L230 326L224 324L224 324L224 324L223 323L223 322L223 321L223 320L223 320L222 320L222 320L220 321L218 323L219 323L218 323L216 324L214 322L213 322L212 322L212 322L212 321L211 320L211 320L211 320L209 317L208 312z"
        },
        {
            "title": "Kowdipally",
            "d": "M189 365L190 365L190 365L191 365L191 366L193 366L193 366L193 366L193 366L194 366L195 366L195 366L196 367L197 366L198 367L199 367L198 366L199 366L199 367L200 368L200 369L199 369L199 371L199 371L199 371L200 371L200 371L200 372L200 372L198 372L198 373L198 373L198 373L198 373L198 374L197 375L197 375L196 375L196 375L197 376L198 376L199 377L199 377L199 377L201 377L201 377L201 378L202 377L202 378L202 378L203 377L203 377L203 377L206 376L207 378L207 379L207 380L207 381L207 381L206 382L206 382L206 382L207 384L208 384L208 384L209 384L210 385L210 385L211 385L212 384L212 381L213 381L213 381L213 381L213 381L214 380L215 379L215 379L216 379L216 379L217 379L217 378L217 378L217 378L217 378L217 378L218 378L219 378L219 378L220 378L221 377L220 377L221 376L221 376L221 376L221 376L221 376L221 375L221 375L219 375L218 373L218 373L218 373L215 372L213 371L214 369L216 367L216 367L215 366L215 364L215 364L215 364L215 363L217 362L216 361L216 361L215 362L212 363L211 363L211 363L210 361L210 361L207 361L207 361L206 362L206 362L204 363L204 363L204 363L204 363L203 363L202 362L202 362L201 361L201 361L201 360L201 360L200 360L199 360L199 360L199 361L199 361L198 362L197 362L197 360L196 360L195 361L194 361L194 360L193 359L193 360L192 361L192 361L192 363L191 363L191 363L191 363L190 364L190 364L189 365L189 365z"
        },
        {
            "title": "Kulcharam",
            "d": "M218 353L217 353L214 353L213 352L212 349L211 347L210 346L210 346L210 345L210 345L210 345L210 346L209 346L209 346L209 346L208 346L207 346L207 346L207 347L207 347L207 347L207 348L206 348L206 348L205 349L204 350L204 350L204 350L204 350L203 350L202 350L202 349L201 349L200 349L199 350L198 351L196 354L196 355L195 355L195 355L193 354L192 354L191 353L190 352L190 353L189 354L189 354L188 354L188 353L187 353L186 354L185 354L185 354L184 355L184 356L184 357L183 358L182 359L181 359L181 359L181 360L182 361L182 361L183 362L183 362L184 362L185 365L185 365L186 365L189 365L189 365L190 364L190 364L191 363L191 363L191 363L192 363L192 361L192 361L193 360L193 359L194 360L194 361L195 361L196 360L197 360L197 362L198 362L199 361L199 361L199 360L199 360L200 360L201 360L201 360L201 361L201 361L202 362L202 362L203 363L204 363L204 363L204 363L204 363L206 362L206 362L207 361L207 361L210 361L210 361L211 363L211 363L212 363L215 362L216 361L216 361L217 362L217 361L217 361L219 358L220 357L219 357L219 356L219 356L219 355L219 355L218 354L218 353z"
        },
        {
            "title": "Medak",
            "d": "M233 335L233 335L232 335L232 335L232 335L232 335L231 335L231 334L231 334L232 334L232 334L232 334L232 333L232 333L231 332L231 331L231 331L226 332L224 332L224 332L223 333L221 334L221 334L221 334L219 335L219 336L218 336L218 336L218 337L217 336L216 336L215 337L215 337L215 337L215 337L215 337L215 337L215 337L214 337L214 338L214 338L214 338L213 338L213 338L213 338L213 338L213 338L213 338L212 338L212 338L212 338L212 338L212 338L212 338L211 338L211 338L211 339L210 339L210 340L209 340L207 339L207 339L207 340L207 341L207 342L207 342L207 343L207 343L206 345L206 346L207 347L207 347L207 347L207 346L207 346L208 346L209 346L209 346L209 346L210 346L210 345L210 345L210 345L210 346L210 346L211 347L212 349L213 352L214 353L217 353L218 353L218 351L221 352L222 352L223 352L223 352L225 351L226 351L226 351L227 350L227 349L228 349L228 348L228 348L228 347L227 347L227 347L227 346L227 346L227 346L226 346L226 346L226 346L226 345L226 345L227 345L227 343L228 343L231 340L231 339L232 337L232 337L232 336L230 336L231 335L231 335L232 335L232 335L232 335L232 335L232 335L233 335L233 335z"
        },
        {
            "title": "Narsapur",
            "d": "M220 378L219 378L219 378L218 378L217 378L217 378L217 378L217 378L217 378L217 379L216 379L216 379L215 379L215 379L214 380L213 381L213 381L213 381L213 381L212 381L212 384L211 385L210 385L210 385L209 384L208 384L208 384L207 384L206 382L206 382L206 382L207 381L207 381L207 380L207 379L207 378L206 376L203 377L203 377L203 377L202 378L202 378L201 379L202 380L204 381L204 381L202 380L201 380L199 380L199 380L199 380L198 381L199 381L198 381L198 382L198 383L198 383L198 384L199 384L199 385L199 385L200 385L201 385L201 385L201 385L201 384L202 384L203 384L204 383L205 384L204 385L204 386L204 386L204 386L204 387L204 387L204 387L204 387L204 387L204 389L204 389L205 389L205 389L205 390L205 390L205 390L205 391L204 391L204 394L204 394L205 394L206 393L207 393L207 393L207 394L207 394L207 394L207 395L207 394L207 394L208 394L208 394L208 394L209 394L209 394L210 394L211 395L210 396L209 397L210 397L209 397L210 398L210 398L210 398L210 398L210 398L211 398L211 398L211 398L211 399L211 399L210 399L210 400L210 400L209 400L210 401L209 403L209 403L210 403L211 402L212 402L212 402L213 402L213 402L213 401L214 402L214 402L215 402L215 403L215 402L216 402L216 403L216 403L216 403L217 402L217 403L218 403L219 403L219 403L219 403L219 404L219 404L220 404L220 404L221 404L222 404L222 404L222 405L222 405L222 406L222 406L222 406L223 407L223 407L223 407L224 408L224 408L224 407L225 406L225 405L225 405L225 405L225 405L225 404L224 404L225 401L225 401L225 401L224 401L225 400L224 400L225 399L225 398L225 398L225 398L225 397L225 397L225 397L225 396L224 396L223 396L223 396L223 395L223 394L223 394L223 394L224 394L224 394L224 393L224 393L224 393L224 393L224 392L224 392L224 391L224 391L224 390L224 389L224 389L223 389L223 388L224 388L224 387L224 387L224 387L225 386L226 386L226 386L226 386L226 385L226 385L226 384L225 384L225 383L224 383L224 383L223 383L223 382L223 382L222 382L222 382L222 382L222 382L222 381L222 381L222 380L221 380L221 380L220 379L221 379L221 379L220 378z"
        },
        {
            "title": "Narsingi",
            "d": "M249 345L249 345L248 343L248 342L248 341L248 341L249 340L250 338L250 337L250 337L251 337L250 337L248 337L247 336L247 336L246 335L244 334L243 334L240 333L240 334L239 334L239 335L239 335L239 335L239 336L238 336L238 336L238 336L237 336L237 337L237 337L238 338L238 338L239 339L239 339L238 340L239 340L238 340L238 340L239 341L238 343L239 344L239 344L239 344L239 344L238 344L238 345L238 345L239 345L239 345L239 345L239 345L239 345L240 345L240 345L240 345L240 345L240 345L240 345L240 346L240 346L240 346L241 346L241 346L241 346L241 346L242 345L242 345L243 345L243 345L244 345L244 347L245 348L245 349L245 350L244 351L245 351L245 351L247 351L247 351L247 351L249 349L250 349L250 349L251 350L251 349L251 349L251 349L251 349L251 349L250 348L250 348L250 348L250 347L249 345z"
        },
        {
            "title": "Nizampet",
            "d": "M266 318L266 319L266 319L266 319L266 319L265 319L265 319L264 319L264 319L263 319L263 319L263 318L263 318L262 318L262 318L262 318L262 318L261 318L261 317L261 317L261 318L260 317L260 318L260 318L260 318L260 318L260 318L260 317L259 317L259 318L259 318L258 321L257 320L257 320L257 320L257 320L257 320L257 320L257 320L255 319L254 321L254 322L253 323L253 323L252 324L252 325L252 325L253 325L253 326L253 326L254 326L254 327L253 327L252 327L253 327L253 327L253 328L254 328L254 329L254 329L256 330L256 330L256 332L255 332L255 333L254 334L254 335L255 336L255 337L256 337L256 337L257 337L258 338L257 338L258 338L258 338L258 339L258 339L260 340L261 340L263 339L262 340L263 340L263 340L265 339L266 338L266 338L266 338L266 337L266 337L266 335L266 335L266 335L267 334L267 334L267 333L267 333L267 333L267 333L268 332L268 332L268 332L268 331L267 331L267 331L267 331L266 331L265 331L263 330L262 330L262 329L263 329L263 328L264 327L264 325L264 325L266 322L267 322L268 322L268 321L268 321L268 320L268 320L267 319L267 319L266 318z"
        },
        {
            "title": "Papannapet",
            "d": "M175 330L174 330L173 329L173 330L173 331L173 331L172 331L172 331L172 332L172 332L172 333L172 333L172 333L172 334L172 335L172 336L173 336L173 337L173 337L173 337L172 337L172 338L172 338L172 339L172 339L172 339L173 339L174 339L174 339L175 339L176 340L177 341L177 341L178 341L178 341L177 343L177 344L178 345L179 345L180 346L180 346L181 346L181 347L182 347L182 347L181 347L181 347L181 348L181 348L181 348L180 349L182 349L183 350L183 350L184 350L184 350L184 350L184 350L184 349L185 349L185 349L186 348L186 348L187 348L188 350L188 350L188 350L188 351L187 351L187 351L186 351L186 352L187 352L186 353L187 353L187 353L188 353L188 354L189 354L189 354L190 353L190 352L191 353L192 354L193 354L195 355L195 355L196 355L196 354L198 351L199 350L200 349L201 349L202 349L202 350L203 350L204 350L204 350L204 350L204 350L205 349L206 348L206 348L207 348L207 347L207 347L207 347L206 346L206 345L207 343L207 343L207 342L207 342L207 341L207 340L207 339L207 339L207 338L206 337L206 337L205 337L202 336L201 335L200 335L199 335L198 334L198 334L197 334L197 334L197 336L196 337L195 337L195 336L194 336L193 336L192 336L191 336L191 336L191 336L191 335L191 334L191 333L191 333L190 332L190 332L189 333L189 333L189 334L189 336L188 336L188 337L188 337L187 337L187 336L186 335L183 335L182 334L180 333L179 333L179 332L178 332L176 332L176 332L176 332L176 331L175 331L175 331L174 330L175 330z"
        },
        {
            "title": "Ramayampet",
            "d": "M252 327L252 327L251 328L250 327L250 327L250 328L249 328L249 328L248 328L247 328L246 328L245 327L245 326L246 325L246 324L245 322L245 322L244 321L244 322L243 322L243 322L243 322L243 322L242 323L242 325L242 325L241 325L241 326L241 326L240 327L240 327L239 327L239 327L238 327L238 327L237 327L236 327L236 328L236 327L234 326L233 324L233 323L233 323L233 322L232 320L232 320L232 320L229 319L229 319L228 319L228 318L228 318L228 318L228 317L228 317L228 317L228 316L227 315L225 315L224 314L223 320L223 320L223 320L223 320L223 321L223 322L223 323L224 324L224 324L224 324L230 326L230 327L230 328L229 329L231 331L231 331L231 332L232 333L232 333L232 334L232 334L232 334L231 334L231 334L231 335L232 335L232 335L232 335L232 335L233 335L233 335L233 335L233 335L234 336L235 336L235 336L236 336L237 337L237 337L237 336L238 336L238 336L238 336L239 336L239 335L239 335L239 335L239 334L240 334L240 333L243 334L244 334L246 335L247 336L247 336L248 337L250 337L251 337L250 337L250 337L250 338L249 340L248 341L248 341L248 342L248 343L249 345L249 345L250 345L250 345L251 345L252 345L255 344L256 342L256 341L257 341L257 341L258 341L258 341L258 340L258 339L258 339L258 338L258 338L257 338L258 338L257 337L256 337L256 337L255 337L255 336L254 335L254 334L255 333L255 332L256 332L256 330L256 330L254 329L254 329L254 328L253 328L253 327L253 327L252 327z"
        },
        {
            "title": "Regode",
            "d": "M156 348L156 347L155 347L156 347L156 346L155 346L155 346L155 346L155 346L154 347L154 347L154 347L153 347L153 347L152 347L152 347L152 347L152 347L151 348L151 348L151 348L151 347L150 345L150 344L150 344L150 344L149 345L148 345L148 345L147 346L146 347L144 349L143 350L143 350L143 350L143 351L143 353L143 355L142 355L141 355L140 355L140 356L139 356L139 357L139 358L139 358L139 358L139 358L138 359L138 360L138 360L141 361L142 360L142 361L143 364L144 364L144 365L144 365L144 365L145 365L146 365L147 365L147 364L148 361L148 360L149 359L150 358L150 357L150 357L151 357L151 357L152 357L152 357L152 357L153 357L153 358L152 358L153 358L152 359L153 359L155 359L155 359L155 359L156 359L156 357L156 357L157 357L157 357L157 355L155 354L154 354L154 353L153 350L154 349L156 348z"
        },
        {
            "title": "Shankarampet_A",
            "d": "M163 327L162 327L162 327L162 329L162 329L162 329L161 330L161 330L161 331L160 330L160 331L159 331L159 331L159 331L158 331L158 331L158 331L158 332L158 332L158 332L157 333L157 334L157 334L157 335L157 335L156 335L155 335L154 336L154 336L152 335L152 335L152 335L151 335L149 335L148 335L148 336L148 336L148 337L148 337L148 339L149 341L149 341L149 342L149 342L150 343L150 344L150 344L150 344L150 344L150 345L151 347L151 348L151 348L151 348L152 347L152 347L152 347L152 347L153 347L153 347L154 347L154 347L154 347L155 346L155 346L155 346L155 346L156 346L156 347L155 347L156 347L156 348L156 348L156 348L157 346L157 346L159 346L159 345L161 346L161 346L162 346L162 346L164 347L164 347L164 347L164 347L165 347L166 348L166 349L167 349L167 349L166 349L167 349L167 349L168 349L169 348L169 348L170 346L169 345L169 345L169 344L169 344L169 342L170 341L169 340L169 339L169 339L169 339L168 339L168 339L168 339L168 339L168 339L168 339L168 338L168 338L168 339L167 338L167 338L167 338L167 337L168 337L168 337L168 337L168 337L169 336L169 336L171 337L172 337L172 337L172 338L172 338L172 338L172 337L173 337L173 337L173 337L173 336L172 336L172 335L172 334L172 333L172 333L172 333L172 332L172 332L172 331L172 331L173 331L173 331L173 330L173 329L173 329L172 329L172 329L172 329L172 329L171 329L170 330L169 329L166 328L166 328L165 328L164 327L163 327z"
        },
        {
            "title": "Shivampet",
            "d": "M244 371L244 371L244 371L244 371L244 372L244 372L244 372L244 372L243 372L243 372L243 372L243 372L243 372L242 372L242 372L242 371L241 370L241 370L240 371L239 371L239 371L239 371L239 371L238 373L237 374L236 374L236 374L236 374L236 375L236 375L235 376L236 377L236 377L236 377L235 377L235 377L235 376L235 376L235 375L235 374L234 373L234 373L232 373L231 373L230 372L229 372L228 372L227 372L226 373L225 373L225 374L225 375L224 375L224 376L224 376L221 374L221 374L221 375L221 375L221 376L221 376L221 376L221 376L221 376L220 377L221 377L220 378L221 379L221 379L220 379L221 380L221 380L222 380L222 381L222 381L222 382L222 382L222 382L222 382L223 382L223 382L223 383L224 383L224 383L225 383L225 384L226 384L226 385L226 385L226 386L226 386L226 386L225 386L224 387L224 387L224 387L224 388L223 388L223 389L224 389L224 389L224 390L224 391L224 391L224 392L224 392L224 393L224 393L224 393L224 393L224 393L226 394L227 394L227 393L229 393L229 393L230 393L230 393L231 394L231 394L231 394L231 394L231 395L231 395L231 395L231 395L231 395L231 396L231 396L231 396L232 396L232 397L233 398L233 399L233 400L235 401L235 401L237 401L237 400L237 400L238 399L238 399L238 398L238 398L239 397L239 396L239 396L240 395L241 396L242 396L244 397L244 396L244 396L244 396L245 395L245 395L245 395L245 394L245 393L244 393L243 392L242 391L242 391L241 390L241 390L241 389L241 389L241 388L242 388L242 388L242 388L242 387L242 387L242 387L242 386L242 386L243 385L243 385L243 385L243 384L243 384L242 384L242 384L242 384L243 384L244 384L244 384L244 384L244 384L244 384L245 384L245 384L245 383L245 383L245 382L245 381L244 381L244 380L244 380L243 380L243 380L242 380L242 379L242 379L243 378L242 378L243 378L243 377L243 377L243 377L243 376L243 376L243 376L243 376L243 376L243 376L243 376L242 376L242 376L242 375L243 375L243 374L243 374L244 372L244 371z"
        },
        {
            "title": "Tekmal",
            "d": "M172 338L172 338L172 338L172 337L172 337L171 337L169 336L169 336L168 337L168 337L168 337L168 337L167 337L167 338L167 338L167 338L168 339L168 338L168 338L168 339L168 339L168 339L168 339L168 339L168 339L169 339L169 339L169 339L169 340L170 341L169 342L169 344L169 344L169 345L169 345L170 346L169 348L169 348L168 349L168 349L168 349L168 350L169 351L170 351L170 351L171 351L171 351L172 351L172 352L172 352L171 352L171 352L171 352L171 352L171 352L171 352L171 352L171 353L171 353L171 353L170 353L170 354L170 354L169 355L169 355L169 356L168 356L168 355L168 357L167 360L168 360L170 360L171 360L170 361L172 361L173 362L173 362L173 362L172 363L172 364L172 364L172 365L172 365L173 365L173 365L175 365L175 366L176 366L176 368L177 369L177 369L177 369L178 368L178 368L179 367L179 367L179 367L179 365L179 364L179 364L179 363L179 363L179 363L180 363L180 363L180 363L181 362L181 362L181 362L182 362L182 362L182 362L182 362L182 362L182 361L182 361L182 361L182 361L181 360L181 359L181 359L182 359L183 358L184 357L184 356L184 355L185 354L185 354L186 354L187 353L187 353L186 353L187 352L186 352L186 351L187 351L187 351L188 351L188 350L188 350L188 350L187 348L186 348L186 348L185 349L185 349L184 349L184 350L184 350L184 350L184 350L183 350L183 350L182 349L180 349L181 348L181 348L181 348L181 347L181 347L182 347L182 347L181 347L181 346L180 346L180 346L179 345L178 345L177 344L177 343L178 341L178 341L177 341L177 341L176 340L175 339L174 339L174 339L173 339L172 339L172 339L172 339L172 338L172 338z"
        },
        {
            "title": "Yeldurthy",
            "d": "M237 366L236 365L235 365L235 364L234 364L232 363L232 363L233 363L233 362L234 362L234 362L234 361L234 361L233 360L233 360L233 359L233 358L232 358L232 356L231 356L232 355L231 355L231 355L230 354L228 355L228 355L228 355L226 351L225 351L223 352L223 352L222 352L221 352L218 351L218 353L218 354L219 355L219 355L219 356L219 356L219 357L220 357L219 358L217 361L217 361L217 362L215 363L215 364L215 364L215 364L215 366L216 367L216 367L214 369L213 371L215 372L218 373L218 373L218 373L219 375L221 375L221 374L221 374L224 376L224 376L224 375L225 375L225 374L225 373L226 373L227 372L228 372L229 372L230 372L231 373L232 373L234 373L234 373L235 374L235 375L235 376L235 376L235 377L235 377L236 377L236 377L236 377L235 376L236 375L236 375L236 374L236 374L236 374L237 374L238 373L239 371L239 371L239 371L239 371L240 371L241 370L241 370L242 369L241 368L241 368L241 368L241 368L240 368L240 366L239 366L239 367L238 366L237 366z"
        },
        {
            "title": "Toopran",
            "d": "M259 367L258 367L257 367L257 366L256 367L255 368L254 368L252 368L251 368L250 368L250 369L250 369L250 370L249 370L249 370L249 370L249 370L249 370L247 369L247 371L246 371L245 370L245 370L244 371L244 371L244 372L243 374L243 374L243 375L242 375L242 376L242 376L243 376L243 376L243 376L243 376L243 376L243 376L243 376L243 377L243 377L243 377L243 378L242 378L243 378L242 379L242 379L242 380L243 380L243 380L244 380L244 380L244 381L245 381L246 381L246 381L246 381L247 381L247 381L248 382L249 382L249 384L250 385L250 385L249 386L250 386L250 386L251 387L252 387L252 387L253 387L253 387L253 387L254 388L254 388L254 388L255 388L255 388L255 388L255 387L255 387L255 386L255 386L255 385L255 385L255 385L255 384L257 385L256 383L257 383L257 382L257 382L258 381L258 380L257 379L258 378L258 377L259 378L260 378L261 378L262 378L263 379L264 377L264 377L264 376L264 375L264 374L264 372L264 372L264 371L265 371L265 371L265 370L264 370L263 370L263 369L262 370L261 369L261 369L261 370L261 370L261 370L259 370L259 370L259 369L259 369L259 368L259 368L259 367L259 367z"
        },
        {
            "title": "Manoharabad",
            "d": "M257 385L255 384L255 385L255 385L255 385L255 386L255 386L255 387L255 387L255 388L255 388L255 388L254 388L254 388L254 388L253 387L253 387L253 387L252 387L252 387L251 387L250 386L250 386L249 386L250 385L250 385L249 384L249 382L248 382L247 381L247 381L246 381L246 381L246 381L245 381L245 382L245 383L245 383L245 384L245 384L244 384L244 384L244 384L244 384L244 384L243 384L242 384L242 384L242 384L243 384L243 384L243 385L243 385L243 385L242 386L242 386L242 387L242 387L242 387L242 388L242 388L242 388L241 388L241 389L241 389L241 390L241 390L242 391L242 391L243 392L244 393L245 393L245 394L245 395L245 395L245 395L244 396L244 396L244 396L244 396L245 398L245 398L245 398L246 399L245 399L245 400L247 400L247 400L247 401L247 401L247 401L247 402L248 402L248 402L249 402L249 402L251 402L253 402L255 399L255 398L255 398L255 398L255 397L256 397L256 397L256 397L256 396L258 393L258 393L257 393L257 392L257 392L257 392L256 390L256 388L256 388L256 387L257 385z"
        },
        {
            "title": "Chilipched",
            "d": "M189 365L186 365L185 365L185 365L184 366L184 367L184 370L184 371L184 371L184 371L186 372L186 372L187 372L187 373L188 375L187 377L187 378L188 379L188 379L188 380L188 380L188 381L189 381L189 381L190 381L190 382L191 382L191 383L191 383L191 383L191 382L191 382L192 381L193 381L194 380L194 379L194 378L194 377L195 377L195 377L195 377L196 377L196 378L196 378L196 378L196 379L196 379L196 380L196 380L196 380L196 380L196 381L196 382L196 382L196 383L196 384L197 384L197 384L198 384L198 384L198 384L198 384L198 383L198 383L198 382L198 381L199 381L198 381L199 380L199 380L199 380L201 380L202 380L204 381L204 381L202 380L201 379L202 378L202 378L202 378L202 377L201 378L201 377L201 377L199 377L199 377L199 377L198 376L197 376L196 375L196 375L197 375L197 375L198 374L198 373L198 373L198 373L198 373L198 372L200 372L200 372L200 371L200 371L199 371L199 371L199 371L199 369L200 369L200 368L199 367L199 366L198 366L199 367L198 367L197 366L196 367L195 366L195 366L194 366L193 366L193 366L193 366L193 366L191 366L191 365L190 365L190 365L189 365z"
        },
        {
            "title": "Shankarampet_R",
            "d": "M233 335L233 335L232 335L232 335L232 335L232 335L232 335L231 335L231 335L230 336L232 336L232 337L232 337L231 339L231 340L228 343L227 343L227 345L226 345L226 345L226 346L226 346L226 346L227 346L227 346L227 346L227 347L227 347L228 347L228 348L228 348L228 349L227 349L227 350L226 351L226 351L228 355L228 355L228 355L230 354L231 355L231 355L232 355L231 356L232 356L232 358L233 358L233 359L233 360L233 360L234 361L234 361L234 362L234 362L233 362L233 363L232 363L232 363L234 364L235 364L235 365L236 365L237 366L238 363L238 363L238 363L238 363L238 362L238 362L239 362L240 361L242 360L242 361L244 360L244 360L244 360L244 358L244 358L245 357L244 357L244 355L244 355L244 354L243 352L243 351L244 351L244 351L244 351L245 350L245 349L245 348L244 347L244 345L243 345L243 345L242 345L242 345L241 346L241 346L241 346L241 346L240 346L240 346L240 346L240 345L240 345L240 345L240 345L240 345L240 345L239 345L239 345L239 345L239 345L239 345L238 345L238 345L238 344L239 344L239 344L239 344L239 344L238 343L239 341L238 340L238 340L239 340L238 340L239 339L239 339L238 338L238 338L237 337L236 336L235 336L235 336L234 336L233 335L233 335L233 335z"
        },
        {
            "title": "Chegunta",
            "d": "M268 344L268 343L269 341L269 340L269 340L269 339L269 339L269 339L269 338L268 338L267 338L266 338L266 338L266 338L265 339L263 340L263 340L262 340L263 339L261 340L260 340L258 339L258 340L258 341L258 341L257 341L257 341L256 341L256 342L255 344L252 345L251 345L250 345L250 345L249 345L250 347L250 348L250 348L250 348L251 349L251 349L251 349L251 349L251 349L251 350L250 349L250 349L249 349L247 351L247 351L247 351L245 351L245 351L244 351L244 351L244 351L243 351L243 352L244 354L244 355L244 355L244 357L245 357L244 358L244 358L246 359L247 359L247 359L247 359L247 359L248 359L248 359L250 360L251 360L251 360L252 361L252 361L252 361L252 362L252 362L253 363L253 363L253 364L254 364L255 364L256 364L256 363L256 363L256 363L257 362L258 362L259 363L259 363L259 363L259 364L259 364L259 364L259 365L259 365L260 365L260 366L260 366L261 365L261 365L262 365L262 365L262 364L261 364L261 363L260 363L260 363L259 363L259 363L259 363L259 362L259 361L260 361L260 361L260 361L260 361L260 361L260 361L261 361L261 360L261 360L261 359L260 358L260 358L260 358L260 358L260 358L260 357L260 357L260 356L261 355L261 354L261 353L261 353L260 352L260 352L260 351L260 351L260 349L262 350L262 349L263 346L264 344L264 343L264 342L264 342L264 343L265 343L265 343L265 343L266 344L266 344L266 344L268 344z"
        },
        {
            "title": "Masaipet",
            "d": "M260 366L260 365L259 365L259 365L259 364L259 364L259 364L259 363L259 363L259 363L258 362L257 362L256 363L256 363L256 363L256 364L255 364L254 364L253 364L253 363L253 363L252 362L252 362L252 361L252 361L252 361L251 360L251 360L250 360L248 359L248 359L247 359L247 359L247 359L247 359L246 359L244 358L244 360L244 360L244 360L242 361L242 360L240 361L239 362L238 362L238 362L238 363L238 363L238 363L238 363L237 366L238 366L239 367L239 366L240 366L240 368L241 368L241 368L241 368L241 368L242 369L241 370L242 371L242 372L242 372L243 372L243 372L243 372L243 372L243 372L244 372L244 372L244 372L244 372L244 371L244 371L244 371L244 371L244 371L245 370L245 370L246 371L247 371L247 369L249 370L249 370L249 370L249 370L249 370L250 370L250 369L250 369L250 368L251 368L252 368L254 368L255 368L256 367L257 366L257 367L258 367L259 367L260 366L260 366z"
        }
    ],
    "Bhadradri Kothagudem": [
        {
            "title": "Allapalli",
            "d": "M609 359L606 361L597 367L593 364L595 361L599 354L600 354L600 354L600 352L599 351L599 351L599 351L598 351L598 351L597 351L597 351L597 351L596 351L595 351L595 351L594 350L594 349L592 349L592 349L592 349L593 348L593 347L593 346L593 347L592 347L592 347L592 347L591 347L591 347L591 347L591 348L591 348L591 349L590 349L590 349L590 349L589 349L589 349L588 348L590 346L590 345L590 345L590 344L589 344L589 344L589 344L589 344L589 345L588 345L588 346L587 346L587 346L587 346L586 346L585 346L585 346L585 346L584 347L584 347L584 347L583 347L583 347L583 348L581 347L581 347L580 347L580 346L580 346L580 346L578 346L577 346L577 346L577 345L577 345L577 345L576 344L577 344L577 344L577 344L576 343L575 342L574 343L574 343L575 344L575 345L574 346L574 347L572 350L573 352L572 352L571 353L570 360L567 363L568 364L572 366L576 369L576 370L575 373L572 374L571 375L572 376L573 378L573 378L572 379L573 379L574 379L575 380L575 383L576 388L579 393L580 394L581 393L582 394L583 394L583 394L583 395L584 394L585 394L585 394L585 394L586 394L587 394L588 392L588 393L588 393L589 394L590 390L590 390L590 388L590 387L590 387L593 384L594 384L596 384L596 383L597 382L597 382L597 379L599 378L600 377L601 375L603 374L604 374L605 374L606 374L606 374L607 373L608 372L610 371L611 370L610 374L614 374L614 374L615 374L615 373L617 371L615 370L613 368L613 368L613 368L613 368L612 366L610 364L610 362L610 362L610 361L609 360L609 360L609 359L609 359z"
        },
        {
            "title": "Annapureddipalle",
            "d": "M642 459L640 457L639 455L637 453L636 452L636 452L635 452L635 453L632 455L627 455L626 456L624 456L622 456L620 455L616 455L616 455L614 458L614 458L616 461L617 461L615 461L614 462L614 462L613 463L613 464L612 465L612 465L612 465L612 465L611 465L611 465L611 465L611 465L611 466L611 466L611 466L611 466L607 467L608 469L608 469L609 471L612 473L612 473L615 475L616 475L617 474L617 473L618 474L618 473L618 473L618 473L618 473L618 472L618 472L619 472L620 471L622 471L623 472L624 471L625 469L629 472L629 472L629 471L630 471L631 469L631 468L631 467L631 466L634 467L635 467L636 466L639 463L642 463L642 460L642 459z"
        },
        {
            "title": "Aswapuram",
            "d": "M647 394L644 390L644 389L644 389L645 388L646 386L647 385L647 384L647 382L647 381L646 378L646 377L648 373L648 372L648 365L648 364L647 365L647 365L647 365L643 365L643 365L643 365L642 366L642 370L643 371L641 370L640 370L639 369L638 370L637 370L635 370L634 369L634 370L633 370L633 369L632 370L630 370L630 370L628 370L628 370L627 370L626 371L625 372L625 373L622 373L623 372L622 372L622 372L620 372L619 372L617 371L615 373L615 374L616 377L618 380L620 382L621 384L623 386L623 388L622 390L622 391L621 393L620 397L619 396L619 398L619 400L619 401L620 403L620 403L622 404L623 405L624 405L625 405L626 405L629 396L630 396L631 396L633 397L635 397L637 397L639 397L641 398L641 398L642 396L642 396L644 395L645 395L646 395L647 394z"
        },
        {
            "title": "Aswaraopeta",
            "d": "M676 486L679 487L680 487L680 487L681 487L682 487L683 486L686 486L687 486L688 486L688 486L688 486L689 485L690 485L691 485L692 485L693 485L695 485L696 483L697 483L697 482L697 482L697 481L698 481L697 480L696 478L696 478L696 476L696 476L696 476L696 475L696 474L696 474L697 472L697 471L698 470L698 469L698 469L700 468L701 468L701 468L703 469L704 469L704 469L705 469L705 469L706 469L706 469L706 469L706 469L707 469L707 468L707 468L708 468L709 469L710 469L711 469L712 470L712 470L712 470L713 469L713 469L714 468L715 468L715 467L716 466L716 466L717 465L717 465L718 464L718 463L718 462L719 462L719 462L719 461L719 461L718 459L716 458L714 458L713 458L713 457L711 457L710 457L709 456L709 456L708 455L708 455L707 455L706 454L706 453L705 452L705 451L704 450L704 449L703 449L702 450L702 450L701 449L698 448L697 448L696 447L696 446L695 445L695 445L693 442L693 442L692 442L691 442L690 441L689 440L689 440L686 439L686 439L685 439L681 445L681 445L679 444L678 444L678 443L674 442L674 441L672 441L669 440L669 440L669 441L669 443L669 445L669 446L668 449L667 451L667 452L667 454L667 455L667 455L667 456L669 457L670 458L670 460L670 460L672 462L673 463L674 463L674 463L675 463L676 464L676 464L678 464L678 464L679 464L679 465L680 465L680 465L680 465L681 465L681 466L681 466L681 468L681 468L681 468L681 468L681 469L681 469L681 469L681 469L681 469L680 470L680 470L679 469L678 470L678 471L678 471L677 471L677 472L676 472L676 472L676 473L676 473L676 474L675 474L674 474L673 475L673 476L672 477L672 477L672 477L672 478L672 478L674 478L674 478L675 479L675 478L675 479L674 481L674 482L676 486L676 486z"
        },
        {
            "title": "Bhadrachalam",
            "d": "M651 414L652 413L652 412L652 412L651 411L652 408L651 407L651 407L650 407L650 407L650 407L649 407L649 407L649 407L649 407L649 407L648 407L647 407L646 408L646 409L646 409L646 410L646 411L647 412L648 413L649 413L651 414z"
        },
        {
            "title": "Burgampadu",
            "d": "M649 397L647 395L647 394L646 395L645 395L644 395L642 396L642 396L641 398L641 398L639 397L637 397L635 397L633 397L631 396L630 396L629 396L626 405L625 406L625 406L624 406L624 407L624 407L624 409L623 410L623 414L622 415L623 415L623 414L624 415L625 416L626 417L627 417L627 417L629 417L629 417L630 418L631 418L632 420L633 420L633 420L634 420L635 420L635 419L635 419L636 420L637 420L639 421L640 421L642 422L642 421L643 421L643 421L643 421L642 419L642 418L642 417L642 417L642 416L643 416L644 415L645 415L647 415L648 416L648 416L649 415L649 415L650 415L651 414L649 413L648 413L647 412L646 411L646 410L646 409L646 409L646 408L647 407L648 407L649 406L649 405L649 403L649 400L649 399L649 397z"
        },
        {
            "title": "Chandrugonda",
            "d": "M607 449L607 450L605 450L604 450L604 448L602 447L601 446L600 447L600 446L600 446L600 446L599 446L599 446L599 447L599 449L599 450L599 450L598 449L597 449L596 449L596 449L596 451L596 453L596 454L595 457L595 457L595 460L593 461L593 466L593 468L596 468L596 467L601 465L601 464L605 469L605 470L608 469L608 469L607 467L611 466L611 466L611 466L611 466L611 465L611 465L611 465L611 465L612 465L612 465L612 465L612 465L613 464L613 463L614 462L614 462L615 461L617 461L616 461L614 458L614 458L616 455L616 455L616 453L614 452L614 453L614 453L612 451L607 449z"
        },
        {
            "title": "Cherla",
            "d": "M664 360L664 356L664 355L663 352L662 348L662 347L661 346L661 346L661 345L662 345L661 344L661 342L660 341L660 340L659 339L658 338L658 338L658 337L659 337L659 333L659 331L659 330L659 330L660 330L660 329L661 329L661 328L662 327L663 326L663 322L660 322L659 323L659 324L657 325L657 325L654 327L652 328L650 329L647 329L645 329L645 328L644 327L644 324L643 323L643 322L643 321L643 320L643 320L642 318L642 317L643 317L645 317L645 317L646 317L645 317L646 316L645 315L645 313L645 313L644 312L642 312L641 312L640 311L640 311L639 311L638 312L637 314L638 316L638 319L638 319L637 320L636 320L636 321L636 321L635 322L635 322L634 323L633 323L632 323L631 323L629 324L629 323L628 323L628 324L627 325L625 326L624 327L623 327L623 327L623 328L623 328L623 328L624 328L624 328L624 328L624 329L624 329L624 329L624 330L624 330L624 330L624 330L624 329L623 329L623 329L623 329L623 330L623 330L623 331L623 331L623 331L623 331L624 330L624 330L624 331L624 331L624 332L624 332L624 333L624 333L624 333L624 333L623 334L626 337L627 339L627 340L627 342L628 342L628 343L629 344L635 350L638 352L639 353L642 354L643 355L645 358L647 360L647 362L648 364L649 363L650 362L652 362L656 361L664 360z"
        },
        {
            "title": "Chunchupally",
            "d": "M602 436L604 435L603 435L604 435L604 434L605 432L604 431L601 430L601 430L599 434L599 434L599 435L599 435L599 435L599 436L600 436L600 436L600 435L600 435L600 435L601 435L601 435L601 435L602 436zM618 438L617 436L615 434L612 429L613 428L613 428L612 428L612 427L612 428L612 428L611 429L611 429L611 430L611 430L610 430L609 431L608 431L608 431L608 432L608 432L606 433L606 433L606 433L605 434L607 435L607 437L608 438L608 438L610 442L607 443L607 444L607 445L607 448L607 449L612 451L614 453L614 453L614 452L616 453L616 455L620 455L622 456L624 456L623 454L623 451L623 448L623 446L619 447L618 438z"
        },
        {
            "title": "Dammapeta",
            "d": "M669 440L667 433L665 432L664 431L663 430L661 428L661 428L661 427L661 428L659 432L660 433L660 435L660 436L659 438L660 449L660 451L660 452L658 453L653 451L653 452L653 453L653 453L653 455L652 455L652 457L652 457L652 457L651 458L650 459L650 460L649 461L649 462L648 463L647 464L645 463L645 463L645 467L645 469L646 469L645 474L645 476L645 476L645 476L646 478L646 478L646 479L645 481L645 481L645 482L644 483L644 484L645 484L645 484L645 484L646 484L646 484L646 484L647 485L647 485L648 485L649 486L649 486L649 486L650 486L651 487L653 486L653 487L653 487L654 487L654 487L655 486L656 487L657 487L658 487L658 488L658 488L659 488L660 489L661 489L661 490L661 490L661 490L662 490L662 490L662 490L662 490L664 491L664 491L664 491L666 492L667 492L668 491L668 491L668 491L669 491L670 491L672 492L672 491L672 491L673 491L673 490L674 490L675 489L676 487L676 486L676 486L676 486L676 486L674 482L674 481L675 479L675 478L675 479L674 478L674 478L672 478L672 478L672 477L672 477L672 477L673 476L673 475L674 474L675 474L676 474L676 473L676 473L676 472L676 472L677 472L677 471L678 471L678 471L678 470L679 469L680 470L680 470L681 469L681 469L681 469L681 469L681 469L681 468L681 468L681 468L681 468L681 466L681 466L681 465L680 465L680 465L680 465L679 465L679 464L678 464L678 464L676 464L676 464L675 463L674 463L674 463L673 463L672 462L670 460L670 460L670 458L669 457L667 456L667 455L667 455L667 454L667 452L667 451L668 449L669 446L669 445L669 443L669 441L669 440L669 440z"
        },
        {
            "title": "Dummugudem",
            "d": "M649 397L650 397L650 397L650 397L650 396L650 396L651 396L651 396L651 396L652 396L652 395L653 396L653 396L653 395L653 394L654 394L654 394L654 394L655 393L658 394L659 391L659 391L660 391L660 391L661 391L661 390L661 390L662 391L662 390L662 390L662 390L663 391L663 391L663 392L664 394L665 395L665 395L669 396L670 395L671 395L672 396L672 396L672 396L673 396L673 397L672 397L673 397L673 397L673 398L673 398L673 398L673 398L674 399L674 399L674 399L673 399L670 400L672 401L673 401L674 401L674 401L675 401L675 401L676 401L676 401L677 401L676 402L676 403L678 404L679 404L679 403L679 403L680 402L680 401L679 402L679 402L678 401L677 400L678 399L678 399L678 399L677 399L677 399L677 399L678 398L679 399L679 399L680 400L680 401L681 401L681 400L681 398L681 398L679 395L679 394L679 393L681 393L680 391L681 391L682 391L682 391L682 389L681 388L680 388L680 388L679 388L679 389L679 389L678 389L678 389L674 390L673 389L672 389L671 389L669 388L668 387L668 387L668 386L668 385L667 384L667 382L667 382L667 380L666 379L666 378L666 375L666 374L666 373L666 372L666 371L666 370L666 369L666 367L666 366L666 365L666 364L665 363L664 360L656 361L652 362L650 362L649 363L648 364L648 365L648 372L648 373L646 377L646 378L647 381L647 382L647 384L647 385L646 386L645 388L644 389L644 389L644 390L647 394L647 395L649 397z"
        },
        {
            "title": "Gundala",
            "d": "M575 342L574 342L574 342L573 342L568 340L566 339L566 338L566 338L559 344L559 346L558 350L556 351L555 352L554 353L554 354L555 356L555 357L553 358L552 359L550 359L548 360L547 359L546 361L546 361L546 363L546 365L546 366L548 368L548 373L548 374L548 375L547 376L547 378L546 382L545 383L543 385L544 386L544 386L544 387L544 388L544 388L544 389L543 390L544 391L545 390L546 390L546 390L547 390L548 390L550 390L550 389L555 389L558 389L567 395L570 394L570 395L570 395L570 395L571 397L571 398L571 398L572 398L574 397L576 396L577 395L578 393L579 393L579 393L576 388L575 383L575 380L574 379L573 379L572 379L573 378L573 378L572 376L571 375L572 374L575 373L576 370L576 369L572 366L568 364L567 363L570 360L571 353L572 352L573 352L572 350L574 347L574 346L575 345L575 344L574 343L574 343L574 342L574 342L575 342L575 342z"
        },
        {
            "title": "Julurupad",
            "d": "M596 449L595 448L594 447L595 447L595 446L595 446L595 446L595 445L596 445L596 445L595 445L595 445L595 445L594 445L594 445L593 444L593 444L593 444L593 443L593 443L593 442L593 442L593 442L592 442L592 441L592 441L592 441L592 441L591 440L591 440L591 440L591 440L590 439L589 438L584 437L582 437L579 437L575 443L573 446L570 445L567 449L567 449L571 454L571 458L574 460L574 460L576 460L580 460L580 460L580 460L584 459L585 460L585 460L584 464L584 465L584 466L584 466L584 466L585 469L585 469L585 470L593 468L593 466L593 461L595 460L595 457L595 457L596 454L596 453L596 451L596 449z"
        },
        {
            "title": "Karakagudem",
            "d": "M601 338L600 338L598 337L597 336L595 335L594 334L594 334L594 334L593 334L592 334L592 335L592 335L590 336L589 334L589 334L589 334L588 333L587 332L587 332L587 331L586 330L585 330L585 329L584 328L584 328L584 328L585 328L585 327L584 327L584 327L582 328L582 328L580 329L581 330L580 333L579 336L577 338L577 339L577 339L577 340L577 340L577 341L577 342L577 342L577 343L577 343L576 341L575 342L575 342L574 342L574 342L574 343L575 342L576 343L577 344L577 344L577 344L576 344L577 345L577 345L577 345L577 346L577 346L578 346L580 346L580 346L580 346L580 347L581 347L581 347L583 348L583 347L583 347L584 347L584 347L584 347L585 346L585 346L585 346L586 346L587 346L587 346L587 346L588 346L588 345L589 345L589 344L589 344L589 344L589 344L590 344L590 345L590 345L590 346L588 348L589 349L589 349L590 349L590 349L590 349L591 349L591 348L591 348L591 347L591 347L591 347L592 347L592 347L592 347L593 347L593 346L593 347L593 348L592 349L592 349L592 349L594 349L594 350L595 351L595 351L596 351L597 351L597 351L597 351L598 351L598 351L599 351L599 351L599 351L600 352L600 354L600 354L599 354L595 361L593 364L597 367L606 361L609 359L609 359L608 358L608 359L608 359L607 358L607 358L607 357L606 356L607 356L607 355L608 353L607 352L607 352L607 351L607 350L607 350L607 350L607 349L606 349L607 348L607 348L607 347L607 346L607 346L605 343L605 343L605 342L605 342L605 341L605 341L604 341L604 340L603 340L602 339L601 339L601 338L601 338z"
        },
        {
            "title": "Kothagudem",
            "d": "M609 431L609 430L609 430L609 430L608 429L608 429L608 429L608 430L608 430L607 430L607 430L607 429L605 429L605 428L605 429L604 428L604 429L604 428L604 428L602 427L601 430L601 430L601 430L601 430L604 431L605 432L604 434L604 435L603 435L604 435L602 436L603 438L607 437L607 435L605 434L606 433L606 433L606 433L608 432L608 432L608 431L608 431L609 431z"
        },
        {
            "title": "Laxmidevipally",
            "d": "M612 428L611 427L610 425L610 421L611 419L612 416L611 415L611 414L610 414L608 411L608 407L609 407L609 407L609 407L609 407L609 407L610 407L610 407L610 407L610 406L610 406L610 405L609 404L610 404L608 403L608 403L608 403L607 402L605 402L605 402L605 402L605 402L605 401L605 401L604 401L605 395L604 393L605 388L603 388L599 386L596 384L594 384L593 384L590 387L590 387L590 388L590 390L590 390L589 394L589 394L590 395L590 396L594 400L598 405L599 407L600 407L600 407L601 407L600 407L601 408L603 411L602 413L602 414L600 417L601 419L602 420L604 422L604 422L601 422L599 421L599 422L599 422L599 422L599 422L598 423L598 423L599 423L599 424L599 424L598 424L598 424L598 424L597 425L597 426L597 426L598 426L597 426L597 427L597 427L596 426L595 427L595 427L595 427L594 427L594 427L593 427L593 427L592 427L592 427L592 427L589 425L587 424L586 429L590 430L591 430L591 431L594 432L596 430L599 430L601 430L601 430L602 427L604 428L604 428L604 429L604 428L605 429L605 428L605 429L607 429L607 430L607 430L608 430L608 430L608 429L608 429L608 429L609 430L609 430L609 430L609 431L610 430L611 430L611 430L611 429L611 429L612 428L612 428z"
        },
        {
            "title": "Manuguru",
            "d": "M648 364L647 362L647 360L645 358L643 355L642 354L639 353L638 352L635 350L629 344L627 346L626 346L626 346L626 346L626 345L626 345L625 345L625 346L625 346L625 346L625 346L624 347L624 348L624 348L624 348L623 348L623 349L623 349L623 350L623 351L623 352L621 351L621 354L620 354L620 356L619 356L618 357L618 357L619 358L619 359L617 361L617 361L616 362L615 362L615 362L614 362L614 363L613 364L612 365L612 366L613 368L613 368L613 368L613 368L615 370L617 371L619 372L620 372L622 372L622 372L623 372L622 373L625 373L625 372L626 371L627 370L628 370L628 370L630 370L630 370L632 370L633 369L633 370L634 370L634 369L635 370L637 370L638 370L639 369L640 370L641 370L643 371L642 370L642 366L643 365L643 365L643 365L647 365L647 365L647 365L648 364z"
        },
        {
            "title": "Mulakalapally",
            "d": "M645 425L644 425L644 425L641 427L642 428L641 428L639 428L636 428L635 429L635 429L634 430L634 427L634 426L633 425L632 425L632 424L631 423L630 424L630 424L630 425L631 425L631 426L630 426L630 426L629 426L629 426L629 425L629 425L628 424L627 424L626 423L625 422L624 422L621 427L621 426L620 426L620 427L620 428L619 430L618 435L618 436L618 438L619 447L623 446L623 448L623 451L623 454L624 456L626 456L627 455L632 455L635 453L635 452L636 452L636 452L637 453L639 455L640 457L642 459L643 461L643 462L644 463L645 463L645 463L645 463L647 464L648 463L649 462L649 461L650 460L650 459L651 458L652 457L652 457L652 457L652 455L653 455L653 453L653 453L653 452L653 451L658 453L660 452L660 451L660 449L659 438L660 436L660 435L660 433L659 432L661 428L661 427L660 425L659 423L659 423L658 423L654 423L651 423L649 423L649 423L648 424L648 425L647 426L647 426L646 425L645 425z"
        },
        {
            "title": "Palvancha",
            "d": "M615 374L614 374L614 374L610 374L611 370L610 371L608 372L607 373L606 374L606 374L605 374L604 374L603 374L601 375L600 377L599 378L597 379L597 382L597 382L596 383L596 384L599 386L603 388L605 388L604 393L605 395L604 401L605 401L605 401L605 402L605 402L605 402L605 402L607 402L608 403L608 403L608 403L610 404L609 404L610 405L610 406L610 406L610 407L610 407L610 407L609 407L609 407L609 407L609 407L609 407L608 407L608 411L610 414L611 414L611 415L612 416L611 419L610 421L610 425L611 427L612 428L612 427L612 428L613 428L613 428L612 429L615 434L617 436L618 438L618 436L618 435L619 430L620 428L620 427L620 426L621 426L621 427L624 422L625 422L626 423L627 424L628 424L629 425L629 425L629 426L629 426L630 426L630 426L631 426L631 425L630 425L630 424L630 424L631 423L632 424L632 425L633 425L634 426L634 427L634 430L635 429L635 429L636 428L639 428L641 428L642 428L641 427L644 425L644 425L645 425L645 425L644 424L643 423L643 422L643 421L643 421L643 421L642 421L642 422L640 421L639 421L637 420L636 420L635 419L635 419L635 420L634 420L633 420L633 420L632 420L631 418L630 418L629 417L629 417L627 417L627 417L626 417L625 416L624 415L623 414L623 415L622 415L623 414L623 410L624 409L624 407L624 407L624 406L625 406L625 406L626 405L625 405L624 405L623 405L622 404L620 403L620 403L619 401L619 400L619 398L619 396L620 397L621 393L622 391L622 390L623 388L623 386L621 384L620 382L618 380L616 377L615 374z"
        },
        {
            "title": "Pinapaka",
            "d": "M619 329L617 330L617 330L615 332L614 334L613 333L613 333L612 333L613 332L613 331L614 331L614 331L613 330L613 330L614 328L614 327L614 327L614 326L613 325L612 325L612 325L612 325L611 325L611 325L611 325L611 326L610 326L610 327L610 327L610 327L610 328L609 329L608 329L607 328L606 328L606 328L606 328L605 329L605 330L605 330L606 331L607 331L607 330L608 331L607 333L604 333L604 332L603 332L603 332L604 333L604 333L603 334L603 334L602 336L602 337L602 337L601 338L601 338L601 338L601 338L601 339L602 339L603 340L604 340L604 341L605 341L605 341L605 342L605 342L605 343L605 343L607 346L607 346L607 347L607 348L607 348L606 349L607 349L607 350L607 350L607 350L607 351L607 352L607 352L608 353L607 355L607 356L606 356L607 357L607 358L607 358L608 359L608 359L608 358L609 359L609 359L609 359L609 360L609 360L610 361L610 362L610 362L610 364L612 366L612 365L613 364L614 363L614 362L615 362L615 362L616 362L617 361L617 361L619 359L619 358L618 357L618 357L619 356L620 356L620 354L621 354L621 351L623 352L623 351L623 350L623 349L623 349L623 348L624 348L624 348L624 348L624 347L625 346L625 346L625 346L625 346L625 345L626 345L626 345L626 346L626 346L626 346L627 346L629 344L628 343L628 342L627 342L627 340L627 339L626 337L623 334L620 330L619 329z"
        },
        {
            "title": "Sujathanagar",
            "d": "M601 430L599 430L596 430L594 432L591 431L589 432L588 433L586 434L583 435L582 437L584 437L589 438L590 439L591 440L591 440L591 440L591 440L592 441L592 441L592 441L592 441L592 442L593 442L593 442L593 442L593 443L593 443L593 444L593 444L593 444L594 445L594 445L595 445L595 445L595 445L596 445L596 445L595 445L595 446L595 446L595 446L595 447L594 447L595 448L596 449L596 449L597 449L598 449L599 450L599 450L599 449L599 447L599 446L599 446L600 446L600 446L600 446L600 447L601 446L602 447L604 448L604 450L605 450L607 450L607 449L607 448L607 445L607 444L607 443L610 442L608 438L608 438L607 437L603 438L602 436L601 435L601 435L601 435L600 435L600 435L600 435L600 436L600 436L599 436L599 435L599 435L599 435L599 434L599 434L601 430L601 430z"
        },
        {
            "title": "Tekulapalle",
            "d": "M591 431L591 430L590 430L586 429L587 424L589 425L592 427L592 427L592 427L593 427L593 427L594 427L594 427L595 427L595 427L595 427L596 426L597 427L597 427L597 426L598 426L597 426L597 426L597 425L598 424L598 424L598 424L599 424L599 424L599 423L598 423L598 423L599 422L599 422L599 422L599 422L599 421L601 422L604 422L604 422L602 420L601 419L600 417L602 414L602 413L603 411L601 408L600 407L601 407L600 407L600 407L599 407L598 405L594 400L590 396L590 395L589 394L589 394L588 393L588 393L588 392L587 394L586 394L585 394L585 394L585 394L584 394L583 395L583 394L583 394L582 394L581 393L580 394L579 393L579 393L578 393L577 395L576 396L574 397L572 398L572 398L572 399L564 410L565 411L566 412L569 413L571 419L566 428L567 433L569 434L573 436L573 436L577 437L579 437L582 437L583 435L586 434L588 433L589 432L591 431z"
        },
        {
            "title": "Yellandu",
            "d": "M572 398L571 398L571 398L571 397L570 395L570 395L570 395L570 394L567 395L558 389L555 389L550 389L550 390L548 390L547 390L546 390L546 390L545 390L544 391L544 392L544 393L544 394L544 394L545 395L543 397L543 397L543 398L541 398L543 402L545 403L545 405L544 406L544 409L544 410L543 411L542 411L540 412L540 412L540 411L539 412L539 411L539 411L538 411L538 412L538 412L538 412L538 412L538 412L538 413L537 413L537 412L537 412L537 412L536 412L536 412L536 412L536 414L536 415L536 416L536 417L536 417L536 418L536 419L538 419L539 419L538 420L537 423L537 424L536 425L536 426L535 428L535 428L537 428L540 430L540 427L541 428L542 430L542 431L542 431L542 431L543 431L543 430L543 430L543 429L543 429L544 429L544 429L544 429L545 429L545 429L545 429L545 429L546 429L546 429L546 428L546 428L546 428L546 428L546 428L546 428L546 428L546 428L546 427L546 427L546 427L547 427L547 427L548 427L548 427L548 427L548 427L548 427L548 427L548 427L548 427L548 426L549 426L549 426L549 426L549 425L549 425L549 425L549 425L549 425L550 425L550 425L550 425L551 425L552 425L556 426L558 427L559 427L559 427L559 428L560 428L561 428L561 428L563 428L563 429L563 431L561 432L559 437L560 437L562 437L562 438L564 439L568 435L569 435L569 434L567 433L566 428L571 419L569 413L566 412L565 411L564 410L572 399L572 398L572 398z"
        }
    ],
    "Medchal Malkajgiri": [
        {
            "title": "Alwal",
            "d": "M262 428L262 428L261 429L261 429L259 429L258 429L258 429L258 429L256 427L256 427L255 427L254 427L255 428L254 428L255 429L254 431L253 431L253 431L252 432L252 432L251 432L251 433L251 433L251 433L251 435L250 436L251 437L251 437L251 438L251 438L251 438L251 439L252 439L252 439L252 438L252 438L253 438L253 438L253 439L253 439L253 439L253 439L253 438L254 439L254 438L254 438L254 438L254 438L254 438L255 437L256 437L256 437L256 437L257 437L257 437L257 437L257 437L257 437L257 436L257 435L256 435L256 435L256 435L256 435L256 435L256 434L256 434L257 434L258 435L258 434L258 434L258 435L259 436L259 436L260 436L260 436L260 436L260 436L260 436L261 436L261 436L261 436L261 436L261 436L261 436L261 436L262 436L262 435L263 434L263 434L263 433L263 433L263 432L264 432L264 432L265 432L265 431L265 431L265 431L266 429L266 429L265 428L265 428L264 429L262 428z"
        },
        {
            "title": "Bachupally",
            "d": "M236 428L236 428L235 428L235 428L234 427L233 426L231 427L231 426L231 426L231 426L230 427L230 428L230 428L229 428L229 429L228 429L229 430L229 430L228 431L229 432L232 432L232 432L233 433L233 433L235 434L235 434L235 433L236 434L236 434L236 434L236 434L237 433L236 431L236 431L236 429L236 428L236 428z"
        },
        {
            "title": "Balanagar",
            "d": "M250 436L250 437L250 437L249 436L248 436L248 437L248 437L247 438L247 438L246 438L246 438L246 439L246 439L244 438L244 439L244 440L244 442L244 442L244 442L243 442L243 441L243 441L243 441L243 441L243 441L243 441L243 442L242 441L242 442L242 442L242 442L242 442L242 442L242 442L241 442L241 442L241 442L241 442L241 442L241 442L240 442L239 442L239 444L240 444L241 444L241 443L242 443L243 443L243 443L245 444L245 445L245 445L246 445L246 445L246 445L246 446L247 446L248 446L248 446L248 446L248 446L249 446L249 446L249 446L250 446L250 446L250 446L250 446L250 446L249 445L248 445L248 444L248 444L248 444L247 443L248 440L250 440L250 440L250 440L250 440L251 441L251 441L252 441L252 440L253 440L253 440L253 440L253 439L253 439L253 438L253 438L252 438L252 438L252 439L252 439L251 439L251 438L251 438L251 438L251 437L251 437L250 436z"
        },
        {
            "title": "Dundigal Gandimaisamma",
            "d": "M253 425L252 425L252 426L251 426L251 426L250 427L250 427L249 427L249 427L249 427L249 427L248 427L248 427L246 426L244 425L244 423L244 423L244 422L244 422L245 421L244 421L243 421L243 421L244 420L244 419L245 418L245 418L245 417L245 417L245 417L245 416L244 416L244 416L244 415L244 415L243 415L243 415L243 415L242 415L242 414L242 413L242 413L242 412L241 412L241 412L241 414L240 412L240 412L240 412L239 412L239 413L239 413L240 413L240 413L239 413L239 413L239 413L239 413L239 414L239 414L239 414L239 413L238 413L238 413L238 413L238 412L238 412L238 412L239 412L239 412L239 412L239 412L239 412L239 411L239 411L239 412L238 412L238 412L238 412L237 412L237 412L236 412L235 412L235 412L235 412L235 413L235 413L236 413L236 414L236 415L235 415L235 415L235 415L234 415L233 415L233 416L233 416L233 416L233 416L234 417L235 417L235 418L235 419L234 419L234 419L234 420L234 420L234 421L233 422L232 423L230 424L230 424L231 424L231 424L230 424L230 424L230 424L230 425L230 425L230 425L230 425L230 425L230 425L230 425L230 425L231 425L231 426L231 426L231 426L231 426L231 427L233 426L234 427L235 428L235 428L236 428L236 428L236 428L237 428L238 428L239 427L240 425L240 425L241 426L242 426L242 426L243 427L244 427L244 429L244 430L245 430L247 430L247 430L248 431L249 431L249 431L250 431L250 431L251 431L252 430L252 430L252 431L253 431L253 431L254 431L255 429L254 428L255 428L254 427L254 427L254 427L253 426L253 426L253 425L253 425z"
        },
        {
            "title": "Ghatkesar",
            "d": "M288 439L287 439L286 438L285 438L284 438L284 439L284 439L284 439L283 440L282 440L282 441L281 441L280 441L280 442L279 443L279 443L279 443L278 443L278 443L277 442L276 442L276 443L276 443L276 443L276 443L277 444L277 444L277 444L277 444L276 444L275 444L274 444L273 445L273 446L274 446L273 447L273 448L273 448L273 449L273 449L273 450L273 451L273 451L274 452L274 452L274 452L274 452L274 453L273 454L273 455L275 456L275 456L276 456L276 456L276 456L276 456L277 456L277 456L278 456L278 456L280 457L280 457L282 456L282 456L282 455L282 455L282 453L283 453L284 452L284 452L285 453L285 453L285 453L285 453L286 454L287 454L287 454L287 454L288 453L289 453L289 453L290 454L290 454L290 455L291 456L291 456L292 456L292 456L292 455L292 455L292 455L292 455L292 455L292 454L293 454L293 453L293 453L294 453L295 452L295 452L295 452L296 451L295 451L295 451L296 450L296 449L296 449L296 448L295 446L295 445L296 444L296 443L296 442L295 442L295 441L295 441L294 441L291 441L290 441L290 441L289 441L288 440L288 439L288 439z"
        },
        {
            "title": "Kapra",
            "d": "M269 428L268 428L268 428L267 428L266 428L263 427L263 427L262 428L264 429L265 428L265 428L266 429L266 429L265 431L265 431L265 431L265 432L264 432L264 432L263 432L263 433L263 433L263 434L263 434L262 435L262 436L261 436L261 436L261 436L261 436L261 436L261 436L261 436L260 436L260 438L260 438L262 439L262 439L263 440L263 440L264 440L264 441L264 441L265 442L265 442L266 442L266 442L267 441L268 442L269 442L269 443L268 443L268 444L268 444L269 445L270 444L270 444L270 444L271 444L272 445L272 444L272 442L274 440L273 439L273 439L272 439L271 439L270 439L270 439L270 440L269 440L268 439L268 438L268 437L268 435L267 434L267 434L267 434L267 434L267 433L267 433L267 433L267 433L268 432L268 432L268 432L268 431L269 430L269 430L269 430L269 429L269 429L269 428L269 428z"
        },
        {
            "title": "Keesara",
            "d": "M284 422L284 422L283 423L283 423L283 422L282 422L282 422L281 423L279 423L279 422L278 423L277 424L277 424L277 424L276 424L275 424L275 424L275 424L275 424L275 424L274 424L273 424L273 424L272 424L272 424L271 424L271 425L271 425L270 425L269 426L268 426L268 426L269 427L269 428L269 428L269 429L269 429L269 430L269 430L269 430L268 431L268 432L268 432L268 432L267 433L267 433L267 433L267 433L267 434L267 434L267 434L267 434L268 435L268 437L268 438L268 439L269 440L270 440L270 439L270 439L271 439L272 439L273 439L273 439L274 440L272 442L272 444L273 444L274 444L274 444L275 444L276 444L277 444L277 444L277 444L277 444L276 443L276 443L276 443L276 443L276 442L277 442L278 443L278 443L279 443L279 443L279 443L280 442L280 441L281 441L282 441L282 440L283 440L284 439L284 439L284 439L284 438L285 438L286 438L287 439L288 439L288 438L288 438L288 436L288 435L288 434L288 434L288 433L289 433L288 432L289 432L288 432L288 431L288 431L287 431L287 430L287 430L287 429L286 429L286 428L286 428L286 428L286 427L286 427L287 426L287 426L286 425L285 424L285 424L284 423L284 423L284 422z"
        },
        {
            "title": "Kukatpally",
            "d": "M244 438L244 438L244 437L243 437L243 435L243 434L242 434L241 434L241 434L239 433L239 433L239 433L239 433L239 434L238 434L237 434L236 434L235 433L235 434L235 434L233 433L233 434L233 434L233 435L233 435L233 436L233 436L232 437L232 437L231 437L231 437L232 437L232 437L231 439L231 439L231 440L232 440L232 439L232 439L233 439L234 440L234 441L235 442L235 442L235 442L236 443L237 444L238 444L238 443L239 444L239 442L240 442L241 442L241 442L241 442L241 442L241 442L241 442L242 442L242 442L242 442L242 442L242 442L242 442L242 441L243 442L243 441L243 441L243 441L243 441L243 441L243 441L243 442L244 442L244 442L244 442L244 440L244 439L244 438z"
        },
        {
            "title": "Malkajgiri",
            "d": "M260 436L260 436L260 436L260 436L260 436L259 436L259 436L258 435L258 434L258 434L258 435L257 434L256 434L256 434L256 435L256 435L256 435L256 435L256 435L257 435L257 436L257 437L257 437L257 437L257 437L257 437L256 437L256 437L256 437L255 437L254 438L254 438L254 438L254 438L254 438L254 438L255 439L256 438L256 439L256 440L256 440L255 441L255 441L255 442L256 443L256 444L255 445L254 446L254 447L254 447L255 448L255 448L258 448L258 446L258 446L259 446L260 446L260 447L261 447L262 446L263 446L263 447L263 447L263 446L263 446L263 443L263 441L263 440L263 440L262 439L262 439L260 438L260 438L260 436z"
        },
        {
            "title": "Medchal",
            "d": "M253 402L251 402L249 402L249 402L248 402L248 402L247 402L247 401L247 401L247 401L247 400L247 400L245 400L245 400L245 401L245 401L245 401L244 402L244 402L243 402L243 402L242 403L242 405L241 405L241 406L241 406L240 406L240 406L240 406L240 406L239 406L239 406L239 406L238 406L237 405L237 405L236 405L236 406L236 407L235 407L235 408L235 408L235 408L235 409L235 409L234 411L234 411L234 411L235 411L235 412L235 412L235 412L236 412L237 412L237 412L238 412L238 412L238 412L239 412L239 411L239 411L239 412L239 412L239 412L239 412L239 412L238 412L238 412L238 412L238 413L238 413L238 413L239 413L239 414L239 414L239 414L239 413L239 413L239 413L239 413L240 413L240 413L239 413L239 413L239 412L240 412L240 412L240 412L241 414L241 412L241 412L242 412L242 413L242 413L242 414L242 415L243 415L243 415L243 415L244 415L244 415L244 416L244 416L245 416L245 417L245 417L245 417L245 418L245 418L244 419L244 420L243 421L243 421L244 421L245 421L244 422L244 422L244 423L244 423L244 425L246 426L248 427L248 427L249 427L249 427L249 427L249 427L250 427L250 427L251 426L251 426L252 426L252 425L253 425L252 425L253 424L253 421L254 420L254 420L256 421L257 421L258 421L258 421L259 421L259 421L260 421L260 421L261 419L262 417L261 416L262 416L261 416L262 414L263 413L263 412L263 411L264 411L264 410L264 409L262 407L262 407L262 406L262 406L262 406L262 405L262 404L263 403L263 403L263 403L261 403L260 402L260 402L259 402L259 402L258 402L258 402L257 401L257 401L257 401L257 401L257 401L256 402L255 404L255 404L254 403L253 404L253 403L253 402z"
        },
        {
            "title": "Medipally",
            "d": "M274 444L274 444L273 444L272 444L272 445L271 444L270 444L270 444L270 444L269 445L268 444L267 445L267 446L266 447L265 448L265 448L265 448L264 449L264 450L265 452L265 452L266 452L266 452L267 453L267 453L267 453L267 453L268 454L268 455L268 455L269 455L269 455L270 455L272 455L273 455L273 455L273 455L273 454L274 453L274 452L274 452L274 452L274 452L273 451L273 451L273 450L273 449L273 449L273 448L273 448L273 447L274 446L273 446L273 445L274 444z"
        },
        {
            "title": "Quthbullapur",
            "d": "M253 431L253 431L252 431L252 430L252 430L251 431L250 431L250 431L249 431L249 431L248 431L247 430L247 430L245 430L244 430L244 429L244 427L243 427L242 426L242 426L241 426L240 425L240 425L239 427L238 428L237 428L236 428L236 428L236 428L236 429L236 431L236 431L237 433L236 434L236 434L236 434L236 434L235 433L236 434L237 434L238 434L239 434L239 433L239 433L239 433L239 433L241 434L241 434L242 434L243 434L243 435L243 437L244 437L244 438L244 438L246 439L246 439L246 438L246 438L247 438L247 438L248 437L248 437L248 436L249 436L250 437L250 437L250 436L251 435L251 433L251 433L251 433L251 432L252 432L252 432L253 431L253 431z"
        },
        {
            "title": "Shamirpet",
            "d": "M273 406L273 405L272 404L271 404L270 403L270 402L270 402L270 402L269 402L269 402L268 402L268 402L268 402L267 402L267 402L266 402L266 402L266 403L266 404L266 404L265 404L265 404L264 404L263 404L263 403L263 403L263 403L262 404L262 405L262 406L262 406L262 406L262 407L262 407L264 409L264 410L264 411L263 411L263 412L263 413L262 414L261 416L262 416L261 416L262 417L261 419L260 421L260 421L259 421L259 421L258 421L258 421L257 421L256 421L254 420L254 420L253 421L253 424L252 425L253 425L253 425L253 426L253 426L254 427L254 427L254 427L255 427L256 427L256 427L258 429L258 429L258 429L259 429L261 429L261 429L262 428L262 428L263 427L263 427L266 428L267 428L268 428L268 428L269 428L269 427L268 426L268 426L269 426L270 425L271 425L271 425L271 424L272 424L272 424L273 424L273 424L274 424L275 424L275 424L275 424L275 424L275 424L276 424L277 424L277 424L277 424L278 423L279 422L279 421L279 420L279 419L279 419L278 419L278 419L278 417L277 416L277 416L277 415L277 416L276 416L276 416L275 416L275 417L275 417L275 417L275 417L274 417L274 416L274 417L273 417L273 417L272 416L272 416L272 416L271 416L271 417L271 416L272 416L272 415L272 415L272 415L273 415L273 414L273 414L272 414L272 414L272 414L272 414L272 414L272 414L273 413L273 413L274 412L274 411L275 410L275 410L275 410L274 409L274 409L273 409L272 408L272 407L273 406L273 406z"
        },
        {
            "title": "Uppal",
            "d": "M268 444L268 444L268 443L269 443L269 442L268 442L267 441L266 442L266 442L265 442L265 442L264 441L264 441L264 440L263 440L263 441L263 443L263 446L263 446L263 447L263 447L262 447L261 447L261 447L261 447L261 448L261 448L261 448L260 448L260 449L260 449L259 449L258 449L258 449L258 449L258 450L258 450L257 450L258 451L259 451L259 452L259 452L259 452L259 452L258 452L257 452L257 452L257 452L257 453L257 453L257 452L258 453L258 453L258 453L258 454L257 455L256 456L256 456L256 457L256 457L257 457L257 457L257 457L257 457L258 456L258 457L258 457L257 458L257 458L258 458L258 458L258 458L258 458L258 458L258 458L258 458L258 458L258 458L259 457L259 458L260 458L260 458L261 458L261 458L262 458L262 459L262 459L262 459L264 460L266 460L267 459L267 459L267 458L267 458L267 458L267 458L267 457L267 457L267 456L267 456L267 456L267 455L268 455L268 455L268 454L267 453L267 453L267 453L267 453L266 452L266 452L265 452L265 452L264 450L264 449L265 448L265 448L265 448L266 447L267 446L267 445L268 444z"
        },
        {
            "title": "Muduchinthalaphally",
            "d": "M279 422L279 423L281 423L282 422L282 422L283 422L283 423L283 423L284 422L284 422L285 421L285 421L285 421L285 420L285 420L285 420L285 420L286 418L286 417L287 417L287 417L287 417L287 417L287 417L286 417L285 415L285 415L284 415L284 415L286 414L287 413L286 412L289 412L288 411L289 410L289 410L290 409L291 408L291 407L290 407L289 406L289 405L289 405L287 404L286 404L284 404L284 403L285 402L283 402L282 402L282 402L280 402L280 402L279 404L279 404L279 405L278 406L277 406L276 406L276 407L274 406L273 406L273 406L272 407L272 408L273 409L274 409L274 409L275 410L275 410L275 410L274 411L274 412L273 413L273 413L272 414L272 414L272 414L272 414L272 414L272 414L273 414L273 414L273 415L272 415L272 415L272 415L272 416L271 416L271 417L271 416L272 416L272 416L272 416L273 417L273 417L274 417L274 416L274 417L275 417L275 417L275 417L275 417L275 416L276 416L276 416L277 416L277 415L277 416L277 416L278 417L278 419L278 419L279 419L279 419L279 420L279 421L279 422z"
        }
    ],
    "Wanaparthy": [
        {
            "title": "Amarchintha",
            "d": "M125 620L125 620L125 621L125 621L125 622L125 622L125 622L124 622L124 622L124 622L124 622L124 623L124 623L124 623L124 624L123 624L122 624L123 623L123 622L123 621L123 620L122 619L122 619L121 617L121 617L120 617L119 619L119 619L118 621L119 621L119 622L119 622L119 623L118 623L118 623L117 623L117 623L116 623L115 624L114 624L114 625L113 625L114 625L111 625L111 626L111 626L111 627L111 627L111 627L111 628L111 628L111 628L112 628L112 629L112 629L112 630L112 630L112 630L114 630L115 631L115 632L115 632L115 632L115 632L116 633L116 633L117 634L118 634L120 634L121 635L123 635L124 636L124 634L124 634L124 634L124 633L124 633L125 632L125 631L126 631L126 631L126 631L127 631L127 631L127 631L128 631L128 632L128 632L129 632L129 632L129 632L129 633L129 633L129 633L129 633L129 633L129 633L129 634L130 634L131 634L131 634L131 634L132 634L132 634L132 633L131 632L132 631L131 631L131 631L132 630L132 630L133 630L133 630L133 630L133 630L134 630L133 629L134 627L134 627L134 627L134 626L134 626L134 626L135 626L135 625L135 625L134 625L134 625L134 625L134 624L134 623L134 623L134 622L133 621L133 621L133 620L133 619L133 619L132 619L132 619L131 619L131 618L130 618L129 619L129 619L129 619L129 619L128 620L128 620L128 619L127 619L127 619L127 620L126 620L126 620L126 620L125 620L125 620z"
        },
        {
            "title": "Atmakur",
            "d": "M138 627L138 627L137 627L137 627L135 626L135 626L135 625L135 625L135 626L134 626L134 626L134 626L134 627L134 627L134 627L133 629L134 630L133 630L133 630L133 630L133 630L132 630L132 630L131 631L131 631L132 631L131 632L132 633L132 634L132 634L131 634L131 634L131 634L130 634L129 634L129 633L129 633L129 633L129 633L129 633L129 633L129 632L129 632L129 632L128 632L128 632L128 631L127 631L127 631L127 631L126 631L126 631L126 631L125 631L125 632L124 633L124 633L124 634L124 634L124 634L124 636L124 636L124 636L125 637L126 637L127 637L127 638L129 639L130 639L131 640L133 641L134 642L135 643L136 643L137 644L137 644L137 644L137 644L139 646L140 647L140 647L141 648L145 651L146 651L150 654L150 654L151 655L154 657L155 658L155 658L155 657L154 655L153 652L153 651L152 649L151 647L151 646L150 645L149 643L149 642L148 641L148 641L147 640L147 640L146 639L145 637L144 637L144 636L142 636L142 636L141 635L141 635L142 633L142 632L141 632L141 631L141 631L141 631L140 631L140 631L140 630L140 631L140 630L140 629L139 629L139 629L139 629L139 629L139 628L139 628L139 628L138 628L138 628L138 627z"
        },
        {
            "title": "Chinnambavi",
            "d": "M210 692L209 692L208 692L207 692L206 692L206 692L205 692L206 692L206 692L206 692L206 693L206 693L206 693L205 693L205 693L205 693L205 693L205 693L204 692L204 692L204 692L203 692L202 692L202 691L203 691L203 691L203 690L203 690L204 690L204 689L203 689L203 689L203 689L203 689L203 688L202 688L202 688L202 688L202 687L201 687L201 687L201 687L200 687L198 686L198 686L199 686L199 686L200 686L200 686L201 686L201 686L201 685L200 685L200 684L200 684L201 684L201 684L200 684L200 683L199 683L199 683L199 683L198 683L198 683L198 683L198 683L197 683L197 683L197 683L197 682L197 682L197 682L198 681L198 681L197 680L197 680L197 680L197 680L196 679L196 679L195 679L195 678L195 678L195 678L192 676L192 676L192 676L192 676L191 677L190 677L190 677L190 677L189 677L189 677L189 677L187 677L187 677L187 677L186 677L186 677L186 676L185 676L184 676L183 676L182 675L181 675L181 675L181 675L180 677L179 677L179 678L179 678L179 679L179 681L179 681L179 682L178 683L179 684L179 686L178 687L177 688L177 689L177 690L179 690L181 691L185 692L186 692L189 694L190 695L190 695L191 697L191 698L192 701L192 702L193 702L194 702L195 703L197 703L202 703L204 703L206 702L207 701L208 700L208 699L209 698L209 697L210 696L210 695L210 693L210 692z"
        },
        {
            "title": "Ghanpur",
            "d": "M189 591L189 591L188 591L188 591L188 591L188 591L188 591L188 590L187 590L187 590L185 590L185 590L185 590L184 589L181 588L180 587L180 587L180 586L179 586L178 585L178 585L178 585L177 585L176 585L175 585L174 585L173 586L172 587L172 587L171 587L171 587L171 587L170 587L170 586L170 586L170 586L170 586L170 585L170 586L170 586L170 586L170 586L170 586L170 587L170 587L170 587L169 587L169 588L169 588L169 588L168 588L168 589L169 590L169 590L168 590L168 591L169 590L169 591L169 591L169 591L169 591L169 591L170 591L170 591L170 591L171 591L171 591L171 592L171 592L171 592L171 592L171 592L170 592L170 592L170 593L170 593L171 593L171 593L171 594L171 594L171 594L172 595L172 595L171 595L171 595L170 595L170 595L170 595L170 595L169 595L169 595L169 596L168 597L170 599L171 602L171 602L171 602L169 601L168 602L167 603L167 604L167 604L166 604L165 604L166 605L166 605L165 606L166 606L166 606L165 606L166 606L166 607L167 607L167 607L167 607L168 607L168 607L168 607L168 607L168 607L168 607L168 607L170 608L170 608L170 609L170 609L171 609L171 609L171 609L172 609L173 610L173 610L173 610L173 611L174 610L174 611L174 610L175 609L175 609L176 609L176 608L177 608L179 609L179 609L180 607L179 603L179 603L180 603L181 604L182 605L183 605L185 607L185 607L185 605L186 605L186 602L186 602L186 601L187 601L187 600L187 598L188 597L188 597L188 595L188 595L188 594L188 594L188 593L189 591L189 591z"
        },
        {
            "title": "Gopalpet",
            "d": "M201 621L201 617L201 617L201 617L200 617L200 616L199 616L197 616L197 616L195 615L194 615L193 615L189 612L189 613L189 613L189 613L190 615L190 615L190 615L190 616L190 616L189 617L189 617L189 617L189 617L189 617L188 617L188 617L188 617L188 617L188 617L188 618L187 618L187 618L187 618L187 618L187 618L187 618L187 620L187 621L186 621L186 622L186 622L185 623L185 623L185 624L185 624L185 624L185 624L184 624L184 624L183 624L183 624L182 627L182 627L182 628L183 628L183 628L184 629L185 629L185 629L186 629L186 629L186 630L186 630L186 631L186 632L185 632L185 632L185 633L185 633L185 633L185 634L185 635L187 636L187 636L188 636L189 636L190 637L190 637L190 637L190 635L191 635L192 635L193 635L194 635L194 635L196 635L198 636L198 636L199 634L199 633L199 632L200 630L200 628L200 625L201 625L201 625L201 625L201 625L201 624L201 624L201 622L201 621z"
        },
        {
            "title": "Kothakota",
            "d": "M166 630L166 630L166 630L165 630L165 630L165 629L164 629L164 629L164 628L164 628L164 627L164 627L165 625L165 625L165 624L165 624L165 624L165 624L165 624L165 623L165 623L164 622L164 622L164 622L164 621L165 620L163 621L163 621L160 619L160 619L159 616L159 616L159 616L158 616L158 616L158 616L157 616L157 616L157 616L156 616L155 617L155 617L155 617L154 617L154 617L154 617L154 617L152 616L152 616L152 616L152 617L151 617L152 617L152 617L152 617L152 618L152 618L152 618L152 619L152 619L152 619L152 619L152 619L152 619L152 619L153 620L153 619L154 619L154 619L154 620L154 620L154 620L154 621L154 621L154 622L154 622L154 622L154 622L154 623L154 623L154 623L154 623L154 624L154 624L154 624L154 624L154 624L154 625L155 625L155 625L155 625L156 625L155 625L155 625L155 626L155 626L155 626L155 627L155 627L153 628L153 629L152 630L152 630L150 630L150 630L149 631L149 631L149 632L149 632L149 633L149 634L150 634L150 634L150 635L150 635L150 635L149 636L149 636L149 636L149 637L149 637L148 638L148 638L148 638L148 638L149 639L149 639L148 639L149 640L148 640L148 640L148 641L148 641L149 642L149 643L150 645L151 646L151 647L152 649L153 651L153 652L154 652L155 651L156 650L156 650L156 649L157 649L157 649L157 649L157 649L157 649L157 649L159 649L160 650L161 650L161 650L162 650L162 650L162 650L162 650L163 650L163 649L163 649L163 649L163 649L163 649L163 648L164 648L164 647L164 647L164 647L165 647L165 647L166 647L166 646L166 645L165 644L165 644L162 643L160 642L160 641L160 641L160 639L161 638L161 638L161 638L161 638L162 638L162 638L162 638L162 638L162 638L162 638L162 637L162 638L163 638L163 637L163 637L163 637L164 637L164 637L164 637L164 637L164 636L165 636L165 636L165 636L165 636L165 636L165 635L165 635L166 635L166 635L166 635L167 635L167 635L167 635L166 633L166 633L166 632L166 632L166 632L166 632L166 631L167 631L166 630L166 630L166 630L166 630z"
        },
        {
            "title": "Madanapur",
            "d": "M152 616L151 616L151 615L151 615L150 615L150 615L150 615L148 615L147 616L145 616L145 616L145 617L145 618L145 618L144 618L142 619L142 620L142 620L141 620L141 620L141 621L141 621L141 621L141 621L140 621L140 621L140 621L140 621L139 621L139 621L139 622L138 622L138 623L139 624L138 624L138 624L138 624L138 626L138 626L138 627L138 627L138 628L138 628L139 628L139 628L139 628L139 629L139 629L139 629L139 629L140 629L140 630L140 631L140 630L140 631L140 631L141 631L141 631L141 631L141 632L142 632L142 633L141 635L141 635L142 636L142 636L144 636L144 637L145 637L146 639L147 640L147 640L148 641L148 640L148 640L149 640L148 639L149 639L149 639L148 638L148 638L148 638L148 638L149 637L149 637L149 636L149 636L149 636L150 635L150 635L150 635L150 634L150 634L149 634L149 633L149 632L149 632L149 631L149 631L150 630L150 630L152 630L152 630L153 629L153 628L155 627L155 627L155 626L155 626L155 626L155 625L155 625L156 625L155 625L155 625L155 625L154 625L154 624L154 624L154 624L154 624L154 624L154 623L154 623L154 623L154 623L154 622L154 622L154 622L154 622L154 621L154 621L154 620L154 620L154 620L154 619L154 619L153 619L153 620L152 619L152 619L152 619L152 619L152 619L152 619L152 619L152 618L152 618L152 618L152 617L152 617L152 617L151 617L152 617L152 616L152 616z"
        },
        {
            "title": "Pangal",
            "d": "M198 636L196 635L194 635L194 635L193 635L192 635L191 635L190 635L190 637L189 639L188 640L187 640L187 640L186 640L185 639L184 640L183 641L182 641L182 642L182 643L181 644L180 645L180 646L180 646L180 647L180 647L179 648L179 648L179 648L179 648L178 648L178 647L177 647L176 647L176 646L176 646L176 646L175 646L175 645L174 645L174 646L174 646L172 648L172 648L172 648L173 649L174 650L175 650L175 651L176 652L176 652L177 653L177 653L177 653L177 653L177 654L177 654L177 655L178 654L182 657L183 657L182 658L182 658L182 659L181 661L182 661L183 661L183 661L184 662L185 663L186 662L187 661L187 661L188 661L188 661L188 661L190 662L193 663L193 663L193 663L194 662L194 662L195 662L197 663L198 663L201 664L201 663L202 663L202 663L202 662L202 659L201 659L201 658L201 658L200 658L201 657L201 657L201 657L201 657L201 656L201 656L201 656L201 655L200 655L200 654L201 653L201 653L202 653L203 653L204 653L205 652L205 652L204 652L205 651L204 650L205 650L204 650L204 650L204 650L203 650L203 650L202 649L202 650L200 649L199 649L198 650L198 650L197 650L197 650L196 648L195 645L195 645L194 645L195 642L196 641L197 641L198 641L199 640L199 640L199 639L200 638L199 638L199 638L199 638L199 638L198 637L198 636z"
        },
        {
            "title": "Pebbair",
            "d": "M169 649L169 649L169 649L169 650L168 649L169 649L169 649L169 649L169 649L168 649L169 649L168 648L168 648L167 648L167 648L167 648L167 648L167 647L166 647L166 647L166 647L166 647L165 647L165 647L164 647L164 647L164 647L164 648L163 648L163 649L163 649L163 649L163 649L163 649L163 650L162 650L162 650L162 650L162 650L161 650L161 650L160 650L159 649L157 649L157 649L157 649L157 649L157 649L157 649L156 649L156 650L156 650L155 651L154 652L153 652L154 655L155 657L155 658L155 658L155 659L156 660L156 662L156 663L156 665L157 666L157 668L157 669L157 670L158 671L158 672L159 674L162 675L163 676L164 678L166 678L167 679L168 680L169 681L172 683L172 684L174 685L174 687L176 688L177 689L177 688L178 687L179 686L179 684L178 683L179 682L179 681L179 681L179 679L179 678L179 678L179 677L179 677L178 676L178 676L177 676L176 676L176 675L176 675L175 675L175 675L174 675L173 674L174 673L175 672L176 671L174 670L174 670L174 670L174 669L174 669L174 669L173 669L173 668L173 668L172 667L172 667L171 668L171 668L170 667L170 667L170 667L170 668L169 667L169 667L169 667L169 667L169 667L168 668L169 668L169 668L168 668L168 668L168 668L168 668L168 668L167 667L167 667L167 667L166 667L166 666L166 666L166 665L167 665L167 665L167 665L167 664L167 664L167 664L167 663L167 663L167 663L167 662L168 661L168 661L168 661L169 661L169 660L169 660L169 660L169 660L169 659L169 659L169 659L169 658L169 658L169 657L170 656L169 655L170 655L170 655L170 655L170 654L169 654L169 654L169 653L169 654L169 653L169 653L169 653L169 653L169 652L169 652L169 652L169 651L169 651L169 651L169 650L169 650L169 650L169 650L169 650L169 649L169 649z"
        },
        {
            "title": "Peddamandaddi",
            "d": "M189 612L188 612L185 609L186 607L185 607L185 607L183 605L182 605L181 604L180 603L179 603L179 603L180 607L179 609L179 609L177 608L176 608L176 609L175 609L175 609L174 610L174 611L174 610L173 611L173 610L173 610L173 610L172 609L171 609L171 609L171 609L170 609L170 609L170 608L170 608L168 607L168 607L168 607L168 607L168 607L168 607L168 607L167 607L167 607L167 607L166 607L166 606L165 606L164 607L163 606L163 607L162 607L163 607L163 607L162 607L162 608L162 608L162 608L159 608L158 609L158 609L157 610L157 610L157 611L157 612L156 612L156 613L156 613L156 613L155 613L155 614L155 614L155 615L155 615L155 616L154 616L154 617L154 617L154 617L154 617L155 617L155 617L155 617L156 616L157 616L157 616L157 616L158 616L158 616L158 616L159 616L159 616L159 616L160 619L160 619L163 621L163 621L165 620L164 621L164 622L164 622L164 622L165 623L165 623L165 624L165 624L165 624L165 624L165 624L165 625L165 625L164 627L164 627L164 628L164 628L164 629L164 629L165 629L165 630L165 630L166 630L166 630L166 630L168 630L170 630L171 630L172 629L173 628L173 628L173 627L173 627L173 627L173 626L173 624L174 623L174 623L174 623L175 622L176 621L176 621L176 621L177 621L177 621L177 621L177 621L177 621L177 621L178 621L179 622L180 622L180 622L180 621L180 620L181 619L181 619L181 619L181 619L182 619L182 619L182 619L182 619L182 619L182 619L182 619L182 619L182 618L183 618L183 618L183 618L183 618L183 618L183 617L183 617L183 617L183 617L183 617L183 617L183 617L183 617L183 617L183 617L183 618L184 617L184 617L184 617L184 617L184 617L184 617L184 617L184 617L184 617L184 617L184 617L184 617L184 616L184 616L185 617L185 617L185 617L186 617L186 616L186 617L186 616L186 617L186 616L186 616L187 616L187 615L187 615L187 615L187 615L187 614L187 614L188 614L189 613L189 613L189 613L189 612z"
        },
        {
            "title": "Revally",
            "d": "M219 632L220 632L220 632L220 632L220 631L220 631L220 631L220 629L220 629L220 629L220 629L220 627L220 627L219 626L218 625L218 625L217 625L216 625L215 625L215 625L215 625L215 625L215 624L215 624L215 625L215 625L215 624L215 624L215 624L215 623L215 623L214 623L214 623L214 624L214 625L214 626L213 626L213 627L213 627L213 627L212 626L211 626L211 626L210 626L210 626L210 624L210 622L210 622L208 622L207 623L207 623L206 623L205 623L204 623L201 624L201 624L201 625L201 625L201 625L201 625L200 625L200 628L200 630L199 632L199 633L199 633L200 633L201 632L202 631L203 628L204 627L206 629L207 629L207 629L207 630L207 630L207 630L208 630L207 630L207 631L208 631L208 632L208 633L208 633L208 633L209 633L211 633L211 634L211 635L211 636L212 636L212 636L214 637L214 637L216 637L217 637L217 636L217 636L217 636L217 636L217 636L217 636L217 636L217 636L217 635L217 634L217 634L218 634L218 634L219 634L219 633L219 633L219 632z"
        },
        {
            "title": "Srirangapur",
            "d": "M172 648L171 648L171 648L171 648L170 648L170 648L170 648L170 649L170 649L170 649L169 649L169 649L169 649L169 649L169 650L169 650L169 650L169 650L169 650L169 651L169 651L169 651L169 652L169 652L169 652L169 653L169 653L169 653L169 653L169 654L169 653L169 654L169 654L170 654L170 655L170 655L170 655L169 655L170 656L169 657L169 658L169 658L169 659L169 659L169 659L169 660L169 660L169 660L169 660L169 661L168 661L168 661L168 661L167 662L167 663L167 663L167 663L167 664L167 664L167 664L167 665L167 665L167 665L166 665L166 666L166 666L166 667L167 667L167 667L167 667L168 668L168 668L168 668L168 668L168 668L169 668L169 668L168 668L169 667L169 667L169 667L169 667L169 667L170 668L170 667L170 667L170 667L171 668L171 668L172 667L172 667L173 668L173 668L173 669L174 669L174 669L174 669L174 670L174 670L174 670L176 671L176 670L176 668L177 667L176 667L177 666L177 666L177 666L177 665L178 664L178 663L179 662L180 661L180 662L181 661L181 661L182 659L182 658L182 658L183 657L182 657L178 654L177 655L177 654L177 654L177 653L177 653L177 653L177 653L176 652L176 652L175 651L175 650L174 650L173 649L172 648L172 648L172 648z"
        },
        {
            "title": "Wanaparthy",
            "d": "M190 637L190 637L190 637L189 636L188 636L187 636L187 636L185 635L185 634L185 633L185 633L185 633L185 632L185 632L186 632L186 631L186 630L186 630L186 629L186 629L185 629L185 629L184 629L183 628L183 628L182 628L182 627L182 627L183 624L183 624L184 624L184 624L185 624L185 624L185 624L185 624L185 623L185 623L186 622L186 622L186 621L187 621L187 620L187 618L187 618L187 618L187 618L187 618L187 618L188 618L188 617L188 617L188 617L188 617L188 617L189 617L189 617L189 617L189 617L189 617L190 616L190 616L190 615L190 615L190 615L189 613L188 614L187 614L187 614L187 615L187 615L187 615L187 615L187 616L186 616L186 616L186 617L186 616L186 617L186 616L186 617L185 617L185 617L185 617L184 616L184 616L184 617L184 617L184 617L184 617L184 617L184 617L184 617L184 617L184 617L184 617L184 617L184 617L183 618L183 617L183 617L183 617L183 617L183 617L183 617L183 617L183 617L183 617L183 617L183 618L183 618L183 618L183 618L183 618L182 618L182 619L182 619L182 619L182 619L182 619L182 619L182 619L182 619L181 619L181 619L181 619L181 619L180 620L180 621L180 622L180 622L179 622L178 621L177 621L177 621L177 621L177 621L177 621L177 621L176 621L176 621L176 621L175 622L174 623L174 623L174 623L173 624L173 626L173 627L173 627L173 627L173 628L173 628L172 629L171 630L170 630L168 630L166 630L166 630L166 630L166 630L167 631L166 631L166 632L166 632L166 632L166 632L166 633L166 633L167 635L167 635L167 635L166 635L166 635L166 635L165 635L165 635L165 636L165 636L165 636L165 636L165 636L164 636L164 637L164 637L164 637L164 637L163 637L163 637L163 637L163 638L162 638L162 637L162 638L162 638L162 638L162 638L162 638L162 638L161 638L161 638L161 638L161 638L160 639L160 641L160 641L160 642L162 643L165 644L165 644L166 645L166 646L166 647L165 647L166 647L166 647L166 647L166 647L167 647L167 648L167 648L167 648L167 648L168 648L168 648L169 649L168 649L169 649L169 649L169 649L169 649L168 649L169 650L169 649L169 649L169 649L169 649L169 649L170 649L170 649L170 649L170 648L170 648L170 648L171 648L171 648L171 648L172 648L174 646L174 646L174 645L175 645L175 646L176 646L176 646L176 646L176 647L177 647L178 647L178 648L179 648L179 648L179 648L179 648L180 647L180 647L180 646L180 646L180 645L181 644L182 643L182 642L182 641L183 641L184 640L185 639L186 640L187 640L187 640L188 640L189 639L190 637z"
        },
        {
            "title": "Weepangandla",
            "d": "M202 663L202 663L201 663L201 664L198 663L197 663L195 662L194 662L194 662L193 663L193 663L193 663L190 662L188 661L188 661L188 661L187 661L187 661L186 662L185 663L184 662L183 661L183 661L182 661L181 661L181 661L180 662L180 661L179 662L178 663L178 664L177 665L177 666L177 666L177 666L176 667L177 667L176 668L176 670L176 671L175 672L174 673L173 674L174 675L175 675L175 675L176 675L176 675L176 676L177 676L178 676L178 676L179 677L179 677L180 677L181 675L181 675L181 675L182 675L183 676L184 676L185 676L186 676L186 677L186 677L187 677L187 677L187 677L189 677L189 677L189 677L190 677L190 677L190 677L191 677L192 676L192 676L192 676L192 676L195 678L195 678L195 678L195 679L196 679L196 679L197 680L198 680L198 680L199 680L199 680L199 680L199 679L199 679L200 678L200 678L200 678L200 678L201 677L202 677L202 677L202 677L203 677L202 676L201 675L201 675L201 675L202 674L202 673L202 671L202 671L203 670L203 669L204 668L204 668L204 667L204 667L204 666L205 665L205 665L205 664L205 664L204 664L202 663z"
        },
        {
            "title": "Yedula",
            "d": "M212 636L211 636L211 635L211 634L211 633L209 633L208 633L208 633L208 633L208 632L208 631L207 631L207 630L208 630L207 630L207 630L207 630L207 629L207 629L206 629L204 627L203 628L202 631L201 632L200 633L199 633L199 633L199 634L198 636L198 636L198 637L199 638L199 638L199 638L199 638L200 638L199 639L199 640L199 640L198 641L197 641L196 641L195 642L194 645L195 645L195 645L196 648L197 650L197 650L198 650L198 650L199 649L200 649L201 649L200 649L200 648L201 648L201 648L201 648L201 648L201 647L201 646L201 646L201 646L201 645L202 645L202 645L203 644L204 645L204 645L205 646L205 646L205 647L206 647L206 647L206 647L207 647L207 647L208 647L209 647L209 647L210 647L210 647L210 647L211 647L211 647L211 647L211 646L211 646L211 645L211 645L210 645L210 644L210 644L210 642L210 642L211 641L211 641L211 640L211 639L211 639L211 638L211 637L211 637L211 637L211 636L212 636z"
        }
    ],
    "Hyderabad": [
        {
            "title": "Amberpet",
            "d": "M257 453L255 453L255 452L255 452L254 452L254 452L254 452L254 454L254 455L252 455L253 456L251 457L251 457L251 457L251 458L252 458L253 458L254 458L254 458L254 457L255 456L255 456L255 456L256 457L256 456L256 456L257 455L258 454L258 453L258 453L258 453L257 452L257 453L257 453z"
        },
        {
            "title": "Ammerpet",
            "d": "M247 446L246 446L246 445L246 445L246 445L245 445L245 445L245 444L243 443L243 443L242 443L242 444L242 444L243 444L244 445L244 445L244 445L244 446L244 446L244 447L244 447L245 447L245 447L245 446L246 446L246 447L246 448L246 447L247 447L247 446z"
        },
        {
            "title": "Asifnagar",
            "d": "M247 453L246 451L246 451L245 451L243 452L243 452L243 453L242 453L241 453L241 455L241 455L241 456L242 456L242 458L242 458L243 457L243 457L245 459L245 460L245 460L246 459L246 459L246 457L246 456L246 456L246 454L246 454L247 454L247 453L247 453z"
        },
        {
            "title": "Bahadurpura",
            "d": "M246 459L245 460L245 460L245 459L243 457L243 457L242 458L242 458L243 458L243 458L243 458L243 459L242 460L242 461L241 461L241 462L241 462L240 461L240 461L240 461L239 462L239 462L240 463L240 463L241 463L241 463L242 463L242 463L242 463L243 463L243 463L244 464L244 464L244 465L244 465L244 465L245 466L245 465L245 465L245 465L245 465L246 465L246 465L246 465L246 465L246 464L246 464L246 464L246 464L246 464L246 464L246 463L247 463L247 463L247 463L247 464L247 464L248 464L248 463L249 462L249 461L249 461L248 461L248 460L249 460L249 459L249 458L250 458L248 458L248 458L247 458L247 458L246 459z"
        },
        {
            "title": "Bandlaguda",
            "d": "M253 461L252 461L251 462L251 462L250 461L250 461L249 462L249 462L248 463L248 464L247 464L247 464L247 463L247 463L247 463L246 463L246 464L246 464L246 464L247 464L247 464L246 465L246 466L246 466L247 466L247 467L247 467L247 467L247 467L247 467L246 467L246 468L246 468L246 468L246 468L246 467L246 467L246 468L245 468L245 468L245 468L245 468L245 468L245 469L245 469L245 469L246 469L246 470L245 470L246 470L246 471L248 471L248 471L248 470L248 469L248 469L249 468L249 468L249 468L249 468L250 467L250 467L250 467L251 467L251 467L251 467L251 467L251 467L252 467L252 467L252 466L253 466L253 467L254 467L254 467L254 466L254 465L254 464L256 464L257 465L256 464L256 463L256 463L256 463L255 463L254 463L254 462L254 461L253 462L253 461z"
        },
        {
            "title": "Charminar",
            "d": "M253 458L252 458L251 458L251 457L250 457L250 458L250 458L249 458L249 459L249 460L248 460L248 461L249 461L249 461L249 462L249 462L250 461L250 461L251 462L251 462L252 461L253 461L252 461L253 461L253 460L253 460L253 459L253 459L253 458z"
        },
        {
            "title": "Golkonda",
            "d": "M241 455L240 455L240 455L240 454L239 454L239 453L238 453L238 454L237 454L237 454L236 454L236 455L236 455L236 456L236 456L235 456L234 455L234 456L234 457L234 457L234 457L235 458L236 458L236 458L237 458L237 458L237 458L237 457L238 458L238 457L238 457L239 458L239 458L240 458L240 458L240 458L241 458L242 458L242 456L241 456L241 455z"
        },
        {
            "title": "Himayatnagar",
            "d": "M254 452L254 452L253 452L253 452L252 452L252 452L252 452L252 450L250 449L250 449L250 449L249 449L249 450L249 450L249 450L249 451L249 452L249 453L249 453L250 453L250 453L250 453L250 453L251 453L251 453L251 453L251 452L251 453L251 453L251 454L251 454L251 455L251 455L252 455L252 455L254 455L254 454L254 452z"
        },
        {
            "title": "Khairatabad",
            "d": "M247 446L247 447L246 447L246 448L246 447L246 446L245 446L245 447L245 447L244 447L244 447L244 446L244 446L244 445L244 445L244 445L243 444L242 444L242 444L242 443L241 443L241 444L240 444L239 444L238 443L238 444L238 445L238 446L238 445L239 446L240 446L242 447L242 447L242 447L242 448L242 448L242 448L243 448L244 448L244 448L245 449L245 449L245 449L245 450L246 450L246 450L245 450L245 451L246 451L246 451L247 453L248 452L248 452L249 452L249 451L249 450L249 450L249 450L249 449L250 448L249 448L249 447L248 446L248 446L248 446L247 446z"
        },
        {
            "title": "Maredpally",
            "d": "M263 447L263 446L262 446L261 447L260 447L260 446L259 446L258 446L258 446L258 448L255 448L255 448L254 447L254 447L254 446L255 445L256 444L256 443L255 442L255 441L255 441L255 442L254 442L254 442L254 442L253 442L252 444L252 445L253 446L253 446L253 447L253 447L253 448L252 448L253 448L253 449L254 449L254 449L254 449L255 449L257 449L258 449L258 449L259 449L260 449L260 449L260 448L261 448L261 448L261 448L261 447L261 447L261 447L262 447L263 447z"
        },
        {
            "title": "Musheerabad",
            "d": "M252 448L252 448L252 448L252 448L251 448L251 448L251 448L251 447L251 447L251 448L250 447L250 447L250 447L249 447L249 448L250 448L249 449L250 449L250 449L250 449L252 450L252 452L252 452L252 452L253 452L253 452L254 452L254 452L254 452L254 452L255 452L255 452L255 453L257 453L257 452L257 452L257 452L258 452L259 452L259 452L259 452L259 452L259 451L258 451L257 450L258 450L258 450L258 449L258 449L257 449L255 449L254 449L254 449L254 449L253 449L253 448L252 448z"
        },
        {
            "title": "Nampally",
            "d": "M252 455L252 455L251 455L251 455L251 454L251 454L251 453L251 453L251 452L251 453L251 453L251 453L250 453L250 453L250 453L250 453L249 453L249 453L249 452L248 452L248 452L247 453L247 453L247 454L246 454L246 454L246 456L246 456L246 457L246 459L246 459L247 458L247 458L248 458L248 458L250 458L250 458L250 457L251 457L251 457L251 457L253 456L252 455z"
        },
        {
            "title": "Saidabad",
            "d": "M254 462L254 462L255 461L256 461L256 461L257 460L256 459L256 459L256 459L255 459L255 457L255 456L254 457L254 458L254 458L253 458L253 459L253 459L253 460L253 460L253 461L252 461L253 461L253 462L254 461L254 462z"
        },
        {
            "title": "Secunderabad",
            "d": "M252 448L253 448L253 447L253 447L253 446L253 446L252 445L249 445L250 446L250 446L250 446L250 446L250 446L249 446L249 446L249 446L248 446L248 446L249 447L250 447L250 447L250 447L251 448L251 447L251 447L251 448L251 448L251 448L252 448L252 448L252 448L252 448z"
        },
        {
            "title": "Shaikpet",
            "d": "M245 451L245 450L246 450L246 450L245 450L245 449L245 449L245 449L244 448L244 448L243 448L242 448L242 448L242 448L242 447L242 447L242 447L240 446L239 446L238 445L238 446L238 446L237 446L236 446L236 447L237 447L237 448L237 448L237 449L237 450L237 451L236 451L236 452L236 452L235 452L235 453L235 453L235 453L235 454L235 454L235 454L235 454L235 454L236 454L237 454L237 454L238 454L238 453L239 453L239 454L240 454L240 455L240 455L241 455L241 455L241 453L242 453L243 453L243 452L243 452L245 451z"
        },
        {
            "title": "Tirumalgiri",
            "d": "M255 441L255 441L256 440L256 440L256 439L256 438L255 439L254 438L254 438L254 439L253 438L253 439L253 439L253 439L253 440L253 440L253 440L252 440L252 441L251 441L251 441L250 440L250 440L250 440L250 440L248 440L247 443L248 444L248 444L248 444L248 445L249 445L252 445L252 444L253 442L254 442L254 442L254 442L255 442L255 441L255 441z"
        }
    ],
    "Suryapet": [
        {
            "title": "Ananthagiri",
            "d": "M496 504L495 503L495 503L494 502L494 502L494 502L493 502L492 501L492 503L492 503L492 503L492 503L492 503L492 504L493 504L492 504L492 504L492 504L491 504L491 504L491 504L491 504L491 504L491 504L490 505L490 505L490 505L489 505L489 505L489 505L489 505L489 505L489 505L489 506L489 506L489 505L488 506L488 505L488 505L488 505L488 505L487 506L487 506L487 506L487 507L487 508L487 508L487 509L488 509L489 510L489 510L489 510L489 511L489 511L488 512L488 512L488 512L488 513L488 513L488 514L488 515L488 515L488 516L488 516L488 516L488 517L489 517L489 517L488 518L488 518L487 519L486 518L485 518L485 518L485 519L486 520L486 520L487 520L488 521L488 522L489 521L490 521L491 520L491 520L491 519L491 518L491 518L492 518L493 519L493 519L493 519L494 520L494 520L494 520L494 520L494 520L495 520L495 520L496 521L496 521L496 521L497 521L497 521L497 521L497 521L497 521L498 521L498 521L498 521L498 521L499 521L499 521L499 521L499 521L500 521L501 521L501 521L501 521L501 521L501 521L502 520L502 520L503 521L503 521L503 521L503 520L503 520L503 520L503 521L503 521L504 522L504 524L505 524L505 524L506 525L506 525L507 525L507 525L507 525L508 525L508 525L508 526L509 526L508 526L509 526L509 527L509 527L510 527L510 527L511 527L511 527L511 527L511 526L511 526L511 525L511 525L511 525L510 525L511 524L511 524L511 523L511 523L511 523L511 523L511 523L511 522L511 522L511 522L510 522L510 522L510 522L509 522L509 522L509 522L509 522L509 521L508 521L508 521L508 521L508 521L507 520L507 520L507 520L507 519L507 519L508 518L508 517L508 517L508 516L508 516L508 516L507 515L507 515L507 515L507 515L506 515L505 515L505 514L505 514L504 514L505 514L505 514L504 514L504 513L504 513L504 512L504 512L503 512L503 512L502 512L501 511L501 511L501 511L500 511L500 510L500 510L500 510L499 509L499 509L499 508L498 507L498 507L498 507L498 507L498 507L497 506L497 506L497 506L497 506L496 505L496 505L496 505L496 505L496 504z"
        },
        {
            "title": "Atmakur_S",
            "d": "M470 472L469 472L469 472L469 472L468 472L468 472L468 472L468 472L468 472L467 472L467 471L467 471L467 471L466 471L466 471L466 470L466 470L465 470L465 469L464 470L464 471L464 471L464 471L463 471L463 471L463 471L463 471L463 472L463 472L463 472L463 472L463 473L461 472L461 472L461 472L461 472L460 472L459 472L458 472L458 472L458 472L458 472L457 472L455 472L455 471L454 471L454 471L453 471L452 471L452 471L452 471L451 471L451 471L451 471L451 471L451 471L450 471L450 470L449 470L449 471L448 471L448 471L448 471L447 471L446 471L446 471L446 471L445 471L445 472L445 472L444 473L444 474L444 475L443 475L442 475L441 474L440 474L440 473L440 473L440 473L440 473L440 473L440 472L440 472L440 472L439 472L439 472L439 472L439 472L439 472L439 471L438 472L438 472L438 472L437 472L437 472L437 471L437 471L437 471L437 471L437 471L436 470L436 470L436 470L436 470L435 471L434 472L434 473L434 473L434 473L434 475L434 476L434 477L434 478L435 478L435 478L435 479L435 479L435 480L436 479L436 479L437 480L438 480L439 480L440 480L440 481L440 482L440 482L440 483L440 483L439 484L440 484L440 485L440 485L440 486L440 486L440 487L440 487L441 488L442 488L442 489L442 489L442 490L442 490L445 489L445 489L445 489L446 489L446 489L447 490L447 489L448 489L448 489L449 489L449 489L449 489L452 489L453 489L453 490L454 490L455 491L456 491L457 491L459 490L460 488L460 488L461 487L461 487L461 487L461 487L461 487L461 487L462 487L462 487L462 486L462 486L463 486L463 486L463 486L463 486L463 486L463 486L463 486L463 486L464 486L464 486L464 486L464 485L464 485L463 485L463 485L463 483L463 483L463 483L463 482L463 482L464 482L464 482L464 481L464 481L464 480L464 480L464 480L464 480L463 480L463 479L463 479L463 479L463 478L464 478L464 478L464 478L464 478L465 478L465 478L464 479L465 479L465 480L465 480L465 480L466 480L466 480L466 480L466 480L466 480L467 480L467 480L467 480L467 480L468 479L468 479L468 479L469 478L469 477L469 477L469 477L469 477L469 477L469 477L468 476L468 476L469 476L469 475L469 475L469 475L469 474L469 474L470 474L470 473L471 473L470 473L470 472L470 472z"
        },
        {
            "title": "Chilkur",
            "d": "M489 524L488 524L488 525L487 525L486 525L486 525L485 525L482 523L481 523L479 523L479 524L478 524L478 523L478 523L477 522L476 521L475 520L474 520L474 520L474 520L473 520L471 521L469 522L469 523L469 523L469 524L469 524L469 524L468 524L468 526L468 527L467 528L467 528L467 528L467 529L466 530L466 531L466 532L466 532L466 532L466 532L467 533L467 533L467 533L468 533L468 533L468 533L468 533L469 533L469 533L469 533L470 533L470 532L473 533L473 533L474 533L474 533L475 532L476 532L476 532L476 532L477 532L477 531L480 531L480 531L480 531L481 532L481 531L481 532L482 532L482 532L482 532L482 532L482 532L482 532L481 532L481 532L481 533L481 534L481 534L481 535L480 535L481 536L481 535L481 536L481 536L481 536L481 536L483 537L483 537L483 539L484 540L486 540L486 540L487 539L488 539L488 539L488 538L488 539L488 538L489 538L489 538L489 538L489 538L489 537L489 537L489 537L489 537L490 536L489 536L489 535L489 533L489 532L489 532L489 531L488 530L488 529L488 529L489 529L489 528L490 528L490 527L490 527L490 527L489 525L489 524z"
        },
        {
            "title": "Chinthala palem",
            "d": "M483 583L483 584L485 587L486 587L486 587L490 587L492 587L493 587L493 586L494 586L495 585L497 582L499 579L499 578L499 577L500 576L501 575L501 574L502 574L503 574L504 574L505 574L506 573L506 573L506 572L507 571L509 569L510 568L510 566L510 566L510 564L510 564L511 563L512 561L512 561L512 559L512 557L513 556L513 555L513 555L512 555L512 555L511 554L509 553L509 553L509 553L509 552L509 550L507 551L507 552L506 552L505 554L504 554L502 556L502 556L501 559L500 559L500 559L500 558L499 558L498 557L497 558L497 558L496 559L496 559L496 559L496 560L496 560L495 561L495 561L495 562L495 562L494 562L494 562L494 564L494 564L493 565L493 566L491 567L492 568L492 568L492 568L491 569L492 571L491 571L490 571L489 572L489 573L489 573L488 573L487 575L486 576L485 577L484 579L483 583L483 583z"
        },
        {
            "title": "Chivvemla",
            "d": "M456 491L455 491L454 490L453 490L453 489L452 489L449 489L449 489L449 489L448 489L448 489L447 489L447 490L446 489L446 489L445 489L445 489L445 489L442 490L442 490L442 489L442 489L442 488L441 488L440 487L440 487L438 490L437 491L437 491L439 491L438 492L437 492L438 493L438 493L437 493L437 493L437 494L438 494L437 494L437 495L438 495L438 496L438 496L438 496L438 496L438 496L438 496L439 497L440 496L440 496L440 496L441 496L441 497L441 497L442 497L442 497L442 497L442 497L442 497L442 497L442 497L443 497L443 497L443 498L443 498L444 498L444 498L443 498L443 499L444 499L444 499L444 499L445 499L445 500L445 500L444 501L444 501L443 504L443 504L443 504L444 504L443 504L443 505L443 505L443 505L444 505L444 506L444 506L444 506L444 506L444 506L446 507L446 508L446 508L446 509L446 509L446 509L446 509L446 509L446 510L446 510L446 510L447 510L447 510L447 511L447 511L447 511L447 511L448 511L448 511L448 512L448 510L449 511L449 511L449 511L450 511L450 510L451 510L451 511L451 510L452 510L452 510L452 509L452 509L453 509L453 509L453 509L453 509L453 509L454 508L454 508L455 508L455 508L455 508L456 509L456 509L456 509L456 509L456 509L457 510L457 510L457 511L458 511L458 511L458 511L458 511L459 511L459 511L459 512L460 512L460 513L460 513L460 513L460 513L460 513L461 513L461 513L461 513L462 513L462 512L462 511L463 509L463 509L463 508L463 508L462 507L462 507L461 507L459 506L459 505L458 505L458 505L458 505L457 504L457 504L457 504L456 504L456 503L456 503L456 503L456 502L456 501L456 501L456 501L457 501L458 501L458 501L458 501L459 500L459 500L459 500L459 499L460 498L461 497L461 496L461 495L462 494L461 494L461 494L461 493L461 493L460 493L460 493L459 493L459 493L459 493L458 493L458 493L458 493L458 493L458 493L456 493L456 492L456 492L456 492L456 491z"
        },
        {
            "title": "Garidepalli",
            "d": "M463 526L461 526L460 526L459 525L457 524L456 524L455 526L454 526L454 526L453 527L452 527L452 527L452 528L452 528L452 529L452 530L451 531L451 531L451 531L451 531L452 532L452 532L452 532L452 532L452 532L452 532L453 533L452 533L452 533L452 534L452 534L452 535L452 536L452 536L452 536L452 536L452 536L452 536L452 536L452 537L451 537L452 538L452 538L452 538L452 539L452 539L452 540L452 540L452 541L453 541L453 542L453 542L453 542L453 544L453 544L452 545L452 545L453 545L454 545L454 545L455 546L456 547L455 548L455 549L456 549L455 551L455 552L455 553L455 553L455 553L454 553L454 554L454 555L454 555L454 556L455 556L455 556L455 557L456 557L456 557L456 557L457 558L457 558L457 558L458 558L458 558L458 558L458 558L458 558L459 559L459 559L460 559L460 559L461 560L461 559L462 557L462 557L462 557L462 557L462 556L462 555L463 555L463 554L463 554L463 554L463 553L464 554L465 554L466 554L466 553L466 553L466 553L466 553L466 553L466 553L466 552L466 552L467 551L467 552L468 550L467 550L466 550L466 550L466 549L466 549L465 549L465 549L465 549L465 549L464 548L464 548L463 548L463 548L463 548L463 548L463 547L461 547L462 547L462 547L463 546L463 545L463 545L463 545L463 545L464 545L464 545L464 545L464 545L464 545L464 545L464 545L465 545L466 545L466 545L466 546L466 546L466 546L467 546L467 546L468 545L468 545L469 544L469 543L470 543L470 543L470 542L471 542L471 542L471 541L471 542L471 542L471 543L471 543L472 543L473 544L474 544L476 542L475 542L475 541L475 541L474 540L474 540L474 540L474 540L474 540L474 540L473 539L473 539L472 539L472 539L472 539L472 538L472 538L472 538L473 538L473 537L473 537L473 537L473 536L473 536L473 536L473 535L472 535L473 533L473 533L473 533L470 532L470 533L469 533L469 533L469 533L468 533L468 533L468 533L468 533L467 533L467 533L467 533L466 532L466 532L466 532L466 532L466 531L466 530L467 529L467 528L465 527L465 527L463 527L463 526L463 526L463 526z"
        },
        {
            "title": "Kodad",
            "d": "M511 527L511 527L511 527L510 527L510 527L509 527L509 527L509 526L508 526L509 526L508 526L508 525L508 525L507 525L507 525L507 525L506 525L506 525L505 524L505 524L504 524L504 522L503 521L503 521L503 520L503 520L503 520L503 521L503 521L503 521L502 520L502 520L501 521L501 521L501 521L501 521L501 521L500 521L499 521L499 521L499 521L499 521L498 521L498 521L498 521L498 521L497 521L497 521L497 521L497 521L497 521L496 521L496 521L496 521L495 520L495 520L494 520L494 520L494 520L494 520L494 520L493 519L493 519L493 519L492 518L491 518L491 518L491 519L491 520L491 520L490 521L489 521L489 522L490 522L490 523L490 523L489 524L489 525L490 527L490 527L490 527L490 528L489 528L489 529L488 529L488 529L488 530L489 531L489 532L489 532L489 533L489 535L489 536L490 536L489 537L489 537L489 537L489 537L489 538L489 538L489 538L489 538L488 538L488 539L488 538L488 539L488 539L487 539L486 540L487 540L487 541L487 542L487 542L488 543L490 544L490 544L491 544L491 544L491 544L491 544L491 544L492 544L492 543L493 544L493 544L493 544L493 544L494 544L494 544L494 544L495 544L495 544L496 544L497 545L497 545L497 545L497 544L497 544L498 542L498 542L498 542L499 542L499 542L500 543L500 543L500 543L500 543L500 543L500 543L501 544L501 544L501 544L502 545L502 543L503 543L504 539L504 538L504 538L505 538L506 538L507 538L508 538L508 536L509 535L509 535L509 535L509 534L509 533L509 533L510 531L511 530L511 530L510 529L511 527z"
        },
        {
            "title": "Huzur nagar",
            "d": "M486 540L486 540L484 540L483 539L483 537L483 537L481 536L481 536L481 536L481 536L481 535L481 536L480 535L481 535L481 534L481 534L481 533L481 532L481 532L482 532L482 532L482 532L482 532L482 532L482 532L481 532L481 531L481 532L480 531L480 531L480 531L477 531L477 532L476 532L476 532L476 532L475 532L474 533L474 533L473 533L473 533L472 535L473 535L473 536L473 536L473 536L473 537L473 537L473 537L473 538L472 538L472 538L472 538L472 539L472 539L472 539L473 539L473 539L474 540L474 540L474 540L474 540L474 540L474 540L475 541L475 541L475 542L476 542L474 544L473 544L472 543L471 543L471 543L471 542L471 542L471 541L471 542L471 542L470 542L470 543L470 543L469 543L469 544L468 545L468 545L467 546L467 546L466 546L466 546L466 546L466 545L466 545L465 545L464 545L464 545L464 545L464 545L464 545L464 545L464 545L463 545L463 545L463 545L463 545L463 546L462 547L462 547L461 547L463 547L463 548L463 548L463 548L463 548L464 548L464 548L465 549L465 549L465 549L465 549L466 549L466 549L466 550L466 550L467 550L468 550L467 552L467 551L466 552L466 552L466 553L466 553L466 553L466 553L468 554L468 554L468 554L468 554L468 554L469 554L469 555L470 555L470 556L470 556L470 556L471 556L471 556L471 556L472 557L472 556L473 555L474 554L475 554L475 553L476 553L476 552L477 552L477 552L477 552L478 551L479 551L479 551L479 551L480 551L481 550L481 550L481 550L482 549L482 548L483 548L483 548L483 548L483 548L483 548L483 549L483 549L484 549L484 549L484 549L484 549L484 549L485 549L486 549L486 549L487 550L487 550L488 550L488 550L489 551L489 550L489 550L489 550L489 550L490 550L490 550L490 550L490 549L491 549L490 549L490 548L490 548L490 548L490 548L490 548L490 548L489 547L489 547L489 547L489 547L489 547L488 547L488 547L487 546L486 546L486 546L486 546L485 546L486 546L487 546L487 545L487 545L487 545L486 545L487 544L487 544L487 542L487 542L487 541L487 540L486 540z"
        },
        {
            "title": "Jajireddigudem",
            "d": "M424 458L423 458L423 458L421 459L421 460L420 460L420 461L420 462L419 462L418 462L418 462L417 462L417 462L415 462L415 463L414 463L414 462L414 463L413 464L412 465L414 466L415 468L415 469L416 470L416 473L417 474L417 476L417 475L418 475L419 475L420 474L421 475L421 476L421 476L423 475L424 476L424 475L424 476L424 476L425 477L425 478L425 478L425 478L427 479L427 479L427 479L428 479L428 478L429 478L429 478L429 479L430 479L430 479L430 479L430 479L431 478L431 478L431 478L431 478L431 477L431 477L432 478L432 478L432 478L432 478L432 478L433 478L433 478L433 478L433 478L433 478L434 478L434 477L434 476L434 475L434 473L434 473L434 473L434 472L435 471L436 470L436 470L436 470L436 470L437 471L437 471L437 471L437 471L437 471L437 472L437 472L438 472L438 472L438 472L439 471L439 472L439 472L439 472L439 472L440 472L440 471L440 471L440 470L440 470L441 470L441 470L440 469L441 469L440 469L441 469L440 468L440 468L440 468L440 468L440 468L441 468L441 467L441 467L441 466L441 467L441 466L440 466L440 466L440 466L440 466L440 466L440 465L440 465L440 465L440 465L440 465L440 465L440 465L439 464L439 464L439 464L438 464L438 464L437 464L436 465L436 466L435 465L435 465L435 465L434 465L433 465L431 464L431 464L431 464L431 464L431 464L430 464L430 464L430 464L430 464L429 464L429 464L428 464L428 463L427 463L427 462L427 461L427 461L427 461L426 461L426 461L426 461L426 461L424 460L424 459L424 459L424 459L424 459L424 458z"
        },
        {
            "title": "Maddirala",
            "d": "M462 450L461 449L461 449L460 448L459 449L459 450L458 450L458 450L457 450L457 450L456 450L455 450L455 449L454 448L454 448L454 447L454 447L453 447L453 447L452 447L452 447L452 447L452 446L452 446L452 445L452 445L451 445L450 445L450 445L450 445L450 445L448 444L447 444L446 443L446 443L445 443L445 443L444 443L444 443L443 443L443 443L443 444L443 444L442 444L442 444L441 444L441 444L441 445L441 445L441 446L441 447L441 448L441 448L441 448L441 449L441 449L441 450L441 450L441 450L442 451L442 451L442 451L442 451L442 452L443 452L443 452L444 452L444 453L443 453L443 454L443 455L442 455L442 455L442 455L442 456L441 457L441 459L441 459L440 460L442 460L442 460L444 460L444 461L444 461L444 461L445 461L446 460L446 460L446 460L447 460L448 461L448 461L449 461L450 462L450 462L451 462L451 462L451 462L453 463L453 463L453 462L453 462L453 461L453 461L453 461L453 460L453 460L453 460L453 460L453 460L453 460L454 460L454 460L454 459L454 460L454 459L455 459L455 459L455 459L455 459L456 459L456 459L456 459L456 459L456 459L457 459L457 459L457 459L457 459L458 459L458 459L458 459L459 460L459 460L459 461L459 461L461 461L462 461L462 462L462 462L463 461L463 461L463 461L464 460L464 460L464 460L464 460L464 460L465 459L465 459L465 458L465 458L465 458L465 458L466 458L466 458L466 458L466 458L466 458L467 458L467 457L467 457L468 457L468 457L468 457L468 457L468 456L468 456L468 456L467 456L467 455L467 455L467 455L467 455L466 455L466 455L466 455L466 455L465 455L464 454L464 454L464 455L463 455L463 455L463 454L463 454L462 454L462 453L462 452L462 450L462 450L462 450z"
        },
        {
            "title": "Mattampalli",
            "d": "M491 567L491 567L491 567L489 565L487 566L486 563L486 563L486 560L485 559L483 557L483 557L483 557L483 557L483 556L482 556L482 556L482 556L482 554L482 554L482 554L481 554L480 554L479 554L479 554L479 553L478 552L478 551L477 552L477 552L477 552L476 552L476 553L475 553L475 554L474 554L473 555L472 556L472 557L471 556L471 556L471 556L470 556L470 556L470 556L470 555L469 555L469 554L468 554L468 554L468 554L468 554L468 554L466 553L466 553L466 553L466 553L466 553L466 554L465 554L464 554L463 553L463 554L463 554L463 554L463 555L462 555L462 556L462 557L462 557L462 557L462 557L461 559L461 560L461 560L462 560L462 560L462 560L462 561L462 561L462 561L463 562L464 563L464 563L464 564L464 564L464 564L464 564L464 564L464 564L464 564L465 564L466 566L466 566L465 568L465 568L465 568L466 568L466 569L466 569L465 570L466 571L466 571L467 572L467 573L467 574L470 576L470 577L470 577L471 577L471 577L472 577L474 576L475 575L476 575L477 575L479 576L481 576L481 577L482 578L482 579L482 580L482 580L482 582L483 583L483 583L484 579L485 577L486 576L487 575L488 573L489 573L489 573L489 572L490 571L491 571L492 571L491 569L492 568L492 568L492 568L491 567z"
        },
        {
            "title": "Mellachervu",
            "d": "M502 545L501 544L501 544L501 544L500 543L500 543L500 543L500 543L500 543L500 543L499 542L499 542L498 542L498 542L498 542L497 544L497 544L497 545L497 545L497 545L496 544L495 544L495 544L494 544L494 544L494 544L493 544L493 544L493 544L493 544L492 543L492 544L491 544L491 544L491 544L491 544L491 544L490 544L490 544L488 543L487 542L487 544L487 544L486 545L487 545L487 545L487 545L487 546L486 546L485 546L486 546L486 546L486 546L487 546L488 547L488 547L489 547L489 547L489 547L489 547L489 547L490 548L490 548L490 548L490 548L490 548L490 548L490 549L491 549L490 549L490 550L490 550L490 550L489 550L489 550L489 550L489 550L489 551L488 550L488 550L487 550L487 550L486 549L486 549L485 549L484 549L484 549L484 549L484 549L484 549L483 549L483 549L483 548L483 548L483 548L483 548L483 548L482 548L482 549L481 550L481 550L481 550L480 551L479 551L479 551L479 551L478 551L478 552L479 553L479 554L479 554L480 554L481 554L482 554L482 554L482 554L482 556L482 556L482 556L483 556L483 557L483 557L483 557L483 557L485 559L486 560L486 563L486 563L487 566L489 565L491 567L491 567L491 567L493 566L493 565L494 564L494 564L494 562L494 562L495 562L495 562L495 561L495 561L496 560L496 560L496 559L496 559L496 559L497 558L497 558L498 557L499 558L500 558L500 559L500 559L501 559L502 556L502 556L504 554L505 554L506 552L507 552L507 551L509 550L508 549L506 550L504 549L504 549L502 548L502 548L501 548L501 547L501 546L502 545L502 545L502 545z"
        },
        {
            "title": "Mothey",
            "d": "M480 478L480 478L480 478L480 478L480 478L480 478L480 479L479 479L478 478L478 478L477 477L476 477L475 476L475 476L474 476L474 476L474 476L474 477L473 477L473 477L473 477L473 477L472 476L471 475L471 475L471 475L471 474L471 473L471 473L470 473L470 474L469 474L469 474L469 475L469 475L469 475L469 476L468 476L468 476L469 477L469 477L469 477L469 477L469 477L469 477L469 478L468 479L468 479L468 479L467 480L467 480L467 480L467 480L466 480L466 480L466 480L466 480L466 480L465 480L465 480L465 480L465 479L464 479L465 478L465 478L464 478L464 478L464 478L464 478L463 478L463 479L463 479L463 479L463 480L464 480L464 480L464 480L464 480L464 481L464 481L464 482L464 482L463 482L463 482L463 483L463 483L463 483L463 485L463 485L464 485L464 485L464 486L464 486L464 486L463 486L463 486L463 486L463 486L463 486L463 486L463 486L463 486L462 486L462 486L462 487L462 487L461 487L461 487L461 487L461 487L461 487L461 487L460 488L460 488L459 490L457 491L456 491L456 492L456 492L456 492L456 493L458 493L458 493L458 493L458 493L458 493L459 493L459 493L459 493L460 493L460 493L461 493L461 493L461 494L461 494L462 494L461 495L461 496L461 497L460 498L459 499L459 500L459 500L459 500L458 501L458 501L458 501L457 501L456 501L456 501L456 501L456 502L456 503L456 503L456 503L456 504L457 504L457 504L457 504L458 505L458 505L458 505L459 505L459 506L461 507L462 507L462 507L462 506L464 506L465 503L465 502L465 502L466 501L466 500L467 500L467 498L468 496L468 496L469 496L469 496L472 496L475 495L476 496L476 495L476 495L477 495L477 495L477 495L477 495L478 495L479 495L479 494L481 494L481 494L481 494L481 494L481 494L481 493L481 492L481 492L481 492L481 491L481 491L481 490L482 490L482 489L482 488L482 488L482 488L482 488L482 488L482 488L481 488L481 488L482 488L482 487L482 487L482 487L482 487L483 487L483 487L484 487L485 487L484 486L484 486L484 484L484 483L484 483L485 483L485 482L485 482L485 482L485 481L485 481L485 481L485 480L485 480L485 480L484 480L484 480L483 479L483 479L483 480L483 480L482 479L482 479L482 479L482 479L482 479L482 479L482 479L482 479L482 479L482 479L481 479L481 479L481 479L480 478z"
        },
        {
            "title": "Munagala",
            "d": "M472 496L469 496L469 496L468 496L468 496L467 498L467 500L466 500L466 501L465 502L465 502L465 503L464 506L462 506L462 507L463 508L463 508L463 509L463 509L462 511L462 512L462 513L461 513L461 513L461 513L460 513L460 513L459 512L459 514L459 515L458 515L458 515L457 515L456 514L456 514L455 514L454 514L453 514L453 515L453 515L453 516L454 516L454 516L455 517L457 517L458 517L459 518L460 519L460 519L460 519L460 519L461 519L461 519L461 519L461 520L462 519L463 519L463 518L463 518L463 517L463 516L463 516L463 515L463 515L464 515L466 515L467 516L468 517L468 518L469 518L469 518L469 519L470 519L470 520L470 520L470 521L468 523L467 523L465 523L465 523L464 524L464 524L464 524L463 524L463 524L463 525L463 526L463 526L463 526L463 526L463 527L465 527L465 527L467 528L467 528L467 528L468 527L468 526L468 524L469 524L469 524L469 524L469 523L469 523L469 522L471 521L473 520L474 520L474 520L474 520L475 520L476 521L477 522L478 523L478 523L478 524L479 524L479 523L481 523L482 523L485 525L486 525L486 525L487 525L488 525L488 524L489 524L490 523L490 523L490 522L489 522L489 521L490 521L489 521L488 522L488 521L487 520L486 520L486 520L485 519L485 518L484 518L484 517L484 517L480 517L477 516L474 516L474 515L474 514L474 514L473 513L472 511L472 510L472 509L472 508L473 508L474 508L474 508L474 508L475 507L475 507L475 506L475 506L475 506L475 505L475 505L474 505L474 505L474 505L474 505L474 503L474 502L475 502L475 502L476 502L477 502L477 502L477 500L475 500L474 500L473 500L471 500L470 500L470 499L470 499L471 497L472 496z"
        },
        {
            "title": "Nadigudem",
            "d": "M492 501L492 501L492 501L492 501L491 501L491 501L491 501L491 501L491 501L491 501L491 501L491 501L489 501L489 501L489 501L488 501L487 501L487 501L487 501L487 499L486 498L485 497L484 497L484 497L484 496L484 496L483 495L483 495L483 494L482 494L482 494L482 494L481 494L481 494L479 494L479 495L478 495L477 495L477 495L477 495L477 495L476 495L476 495L476 496L475 495L472 496L471 497L470 499L470 499L470 500L471 500L473 500L474 500L475 500L477 500L477 502L477 502L476 502L475 502L475 502L474 502L474 503L474 505L474 505L474 505L474 505L475 505L475 505L475 506L475 506L475 506L475 507L475 507L474 508L474 508L474 508L473 508L472 508L472 509L472 510L472 511L473 513L474 514L474 514L474 515L474 516L477 516L480 517L484 517L484 517L484 518L485 518L485 518L486 518L487 519L488 518L488 518L489 517L489 517L488 517L488 516L488 516L488 516L488 515L488 515L488 514L488 513L488 513L488 512L488 512L488 512L489 511L489 511L489 510L489 510L489 510L488 509L487 509L487 508L487 508L487 507L487 506L487 506L487 506L488 505L488 505L488 505L488 505L488 506L489 505L489 506L489 506L489 505L489 505L489 505L489 505L489 505L489 505L490 505L490 505L490 505L491 504L491 504L491 504L491 504L491 504L491 504L492 504L492 504L492 504L493 504L492 504L492 503L492 503L492 503L492 503L492 503L492 501z"
        },
        {
            "title": "Nagaram",
            "d": "M425 448L424 448L424 448L424 448L424 448L423 448L423 448L423 448L422 448L422 449L421 448L421 449L421 449L421 448L421 447L421 447L421 447L421 447L421 447L421 447L421 446L420 447L419 446L418 445L417 445L415 446L414 446L413 445L412 445L411 445L410 445L410 445L410 445L410 445L409 445L409 445L409 446L408 446L408 446L408 446L408 445L407 445L407 446L407 446L407 447L406 448L405 449L406 449L406 451L406 452L406 453L405 453L405 454L404 454L404 455L404 456L405 458L406 459L406 459L408 460L408 460L409 461L410 462L411 464L412 464L412 465L413 464L414 463L414 462L414 463L415 463L415 462L417 462L417 462L418 462L418 462L419 462L420 462L420 461L420 460L421 460L421 459L423 458L423 458L424 458L424 458L425 458L425 459L425 459L425 459L426 459L426 459L427 458L427 458L428 458L428 458L428 458L428 457L429 457L429 457L430 457L430 457L430 457L430 457L430 457L430 457L430 456L430 456L430 455L430 455L430 454L430 454L429 453L430 453L429 453L429 453L429 453L429 452L429 452L428 452L428 452L428 452L428 451L428 451L428 451L427 451L427 450L427 450L427 450L427 450L426 449L426 449L426 449L426 449L425 449L425 448L425 448z"
        },
        {
            "title": "Nereducherla",
            "d": "M451 531L450 531L450 531L449 530L449 530L448 529L447 529L446 529L446 528L446 528L446 529L445 529L445 529L443 528L443 528L442 528L441 527L440 526L440 526L440 526L439 526L439 527L439 527L439 527L438 527L438 527L438 527L438 528L437 528L437 528L437 529L437 533L437 536L437 536L437 537L438 538L439 539L440 541L441 542L442 547L443 548L445 549L445 550L446 551L446 552L447 552L448 552L448 552L450 553L450 552L451 552L451 552L451 552L451 552L452 552L453 552L453 553L454 553L454 553L455 553L455 553L455 553L455 552L455 551L456 549L455 549L455 548L456 547L455 546L454 545L454 545L453 545L452 545L452 545L453 544L453 544L453 542L453 542L453 542L453 541L452 541L452 540L452 540L452 539L452 539L452 538L452 538L452 538L451 537L452 537L452 536L452 536L452 536L452 536L452 536L452 536L452 536L452 535L452 534L452 534L452 533L452 533L453 533L452 532L452 532L452 532L452 532L452 532L452 532L451 531L451 531L451 531L451 531z"
        },
        {
            "title": "Noothankal",
            "d": "M464 460L464 460L464 460L464 460L463 461L463 461L463 461L462 462L462 462L462 461L461 461L459 461L459 461L459 460L459 460L458 459L458 459L458 459L457 459L457 459L457 459L457 459L456 459L456 459L456 459L456 459L456 459L455 459L455 459L455 459L455 459L454 459L454 460L454 459L454 460L454 460L453 460L453 460L453 460L453 460L453 460L453 460L453 461L453 461L453 461L453 462L453 462L453 463L453 463L451 462L451 462L451 462L450 462L450 462L449 461L448 461L448 461L447 460L446 460L446 460L446 460L445 461L444 461L444 461L445 461L444 461L444 462L444 462L444 462L444 462L444 462L443 462L443 462L443 463L443 463L442 463L442 463L441 463L441 463L441 464L441 464L441 464L441 464L441 464L441 464L441 465L440 465L440 465L440 465L440 466L440 466L440 466L440 466L440 466L441 466L441 467L441 466L441 467L441 467L441 468L440 468L440 468L440 468L440 468L440 468L441 469L440 469L441 469L440 469L441 470L441 470L440 470L440 470L440 471L440 471L440 472L439 472L439 472L440 472L440 472L440 472L440 473L440 473L440 473L440 473L440 473L440 474L441 474L442 475L443 475L444 475L444 474L444 473L445 472L445 472L445 471L446 471L446 471L446 471L447 471L448 471L448 471L448 471L449 471L449 470L450 470L450 471L451 471L451 471L451 471L451 471L451 471L452 471L452 471L452 471L453 471L454 471L454 471L455 471L455 472L457 472L458 472L458 472L458 472L458 472L459 472L460 472L461 472L461 472L461 472L461 472L463 473L463 472L463 472L463 472L463 472L463 471L463 471L463 471L463 471L464 471L464 471L464 471L464 470L465 469L465 470L466 470L466 470L466 471L466 471L467 471L467 471L467 471L467 472L468 472L468 472L468 472L468 472L468 472L469 472L469 472L469 472L470 472L469 471L469 472L469 471L468 470L468 470L468 470L468 470L469 469L469 468L469 468L469 468L468 468L468 468L467 468L467 468L467 467L467 466L467 466L467 465L467 463L467 463L467 462L466 462L465 461L465 461L464 460z"
        },
        {
            "title": "Palakeedu",
            "d": "M454 553L454 553L453 553L453 552L452 552L451 552L451 552L451 552L451 552L450 552L450 553L448 552L448 552L447 552L446 552L445 554L445 556L446 558L447 562L447 564L447 565L446 568L446 568L446 569L446 570L446 570L446 570L447 570L447 571L451 572L449 575L449 576L449 576L448 576L450 577L451 577L452 577L453 577L454 577L455 577L455 577L456 576L456 575L457 574L458 573L458 572L459 572L462 571L463 570L464 570L465 570L466 569L466 569L466 568L465 568L465 568L465 568L466 566L466 566L465 564L464 564L464 564L464 564L464 564L464 564L464 564L464 564L464 563L464 563L463 562L462 561L462 561L462 561L462 560L462 560L462 560L461 560L461 560L460 559L460 559L459 559L459 559L458 558L458 558L458 558L458 558L458 558L457 558L457 558L457 558L456 557L456 557L456 557L455 557L455 556L455 556L454 556L454 555L454 555L454 554L454 553z"
        },
        {
            "title": "Penpahad",
            "d": "M460 513L460 513L460 513L460 513L460 512L459 512L459 511L459 511L458 511L458 511L458 511L458 511L457 511L457 510L457 510L456 509L456 509L456 509L456 509L456 509L455 508L455 508L455 508L454 508L454 508L453 509L453 509L453 509L453 509L453 509L452 509L452 509L452 510L452 510L451 510L451 511L451 510L450 510L450 511L449 511L449 511L449 511L448 510L448 512L448 511L448 511L447 511L447 511L447 511L447 511L447 510L447 510L446 510L446 510L445 510L445 510L445 510L444 510L444 510L444 510L444 512L443 512L443 512L443 512L442 512L442 513L441 513L441 513L441 513L441 513L440 513L440 513L440 513L439 513L438 513L438 513L438 513L438 513L438 513L438 513L437 513L437 513L436 512L435 512L435 512L435 512L434 512L434 513L434 514L435 515L435 516L435 517L434 518L435 521L436 524L437 525L437 526L437 528L438 528L438 527L438 527L438 527L439 527L439 527L439 527L439 526L440 526L440 526L440 526L441 527L442 528L443 528L443 528L445 529L445 529L446 529L446 528L446 528L446 529L447 529L448 529L449 530L449 530L450 531L450 531L451 531L452 530L452 529L452 528L452 528L452 527L452 527L453 527L454 526L454 526L455 526L456 524L457 524L459 525L460 526L461 526L463 526L463 526L463 525L463 524L463 524L464 524L464 524L464 524L465 523L465 523L467 523L468 523L470 521L470 520L470 520L470 519L469 519L469 518L469 518L468 518L468 517L467 516L466 515L464 515L463 515L463 515L463 516L463 516L463 517L463 518L463 518L463 519L462 519L461 520L461 519L461 519L461 519L460 519L460 519L460 519L460 519L459 518L458 517L457 517L455 517L454 516L454 516L453 516L453 515L453 515L453 514L454 514L455 514L456 514L456 514L457 515L458 515L458 515L459 515L459 514L459 512L460 513z"
        },
        {
            "title": "Suryapet",
            "d": "M434 478L433 478L433 478L433 478L433 478L433 478L432 478L432 478L432 478L432 478L432 478L431 477L431 477L431 478L431 478L431 478L431 478L430 479L430 479L430 479L430 479L429 479L429 478L429 478L428 478L428 479L427 479L427 479L427 479L425 478L425 478L425 478L425 477L424 476L424 476L424 475L424 476L423 475L421 476L421 476L421 475L420 474L419 475L418 475L417 475L417 476L417 477L418 478L419 479L420 480L420 480L420 480L421 480L421 481L421 481L421 482L422 482L422 485L422 487L423 488L422 490L422 490L422 491L423 493L425 495L427 498L428 499L429 500L429 502L431 504L432 506L433 508L433 509L434 510L434 510L434 511L434 512L435 512L435 512L435 512L436 512L437 513L437 513L438 513L438 513L438 513L438 513L438 513L438 513L439 513L440 513L440 513L440 513L441 513L441 513L441 513L441 513L442 513L442 512L443 512L443 512L443 512L444 512L444 510L444 510L444 510L445 510L445 510L445 510L446 510L446 510L446 509L446 509L446 509L446 509L446 509L446 508L446 508L446 507L444 506L444 506L444 506L444 506L444 506L444 505L443 505L443 505L443 505L443 504L444 504L443 504L443 504L443 504L444 501L444 501L445 500L445 500L445 499L444 499L444 499L444 499L443 499L443 498L444 498L444 498L443 498L443 498L443 497L443 497L442 497L442 497L442 497L442 497L442 497L442 497L442 497L441 497L441 497L441 496L440 496L440 496L440 496L439 497L438 496L438 496L438 496L438 496L438 496L438 496L438 495L437 495L437 494L438 494L437 494L437 493L437 493L438 493L438 493L437 492L438 492L439 491L437 491L437 491L438 490L440 487L440 486L440 486L440 485L440 485L440 484L439 484L440 483L440 483L440 482L440 482L440 481L440 480L439 480L438 480L437 480L436 479L436 479L435 480L435 479L435 479L435 478L435 478L434 478z"
        },
        {
            "title": "Thungathurthy",
            "d": "M440 439L440 439L440 438L439 438L439 438L438 438L437 438L436 438L436 438L436 437L436 437L435 436L435 435L435 435L435 435L435 433L434 433L434 433L434 433L434 433L434 432L434 432L434 432L434 433L434 433L434 433L434 434L434 434L434 435L434 436L434 437L435 438L433 437L433 437L432 437L432 437L432 437L432 436L431 437L430 437L431 438L431 438L431 438L431 439L431 439L431 439L431 440L431 440L431 440L431 441L431 441L431 441L431 442L431 442L431 442L431 442L431 442L431 443L431 443L431 443L431 443L432 444L432 444L432 444L431 444L430 445L430 445L430 445L429 444L428 443L427 444L427 444L427 444L427 445L426 445L426 445L425 447L425 447L425 448L425 448L425 449L426 449L426 449L426 449L426 449L427 450L427 450L427 450L427 450L427 451L428 451L428 451L428 451L428 452L428 452L428 452L429 452L429 452L429 453L429 453L429 453L430 453L429 453L430 454L430 454L430 455L430 455L430 456L430 456L430 457L430 457L430 457L430 457L430 457L430 457L429 457L429 457L428 457L428 458L428 458L428 458L427 458L427 458L426 459L426 459L425 459L425 459L425 459L425 458L424 458L424 458L424 459L424 459L424 459L424 459L424 460L426 461L426 461L426 461L426 461L427 461L427 461L427 461L427 462L427 463L428 463L428 464L429 464L429 464L430 464L430 464L430 464L430 464L431 464L431 464L431 464L431 464L431 464L433 465L434 465L435 465L435 465L435 465L436 466L436 465L437 464L438 464L438 464L439 464L439 464L439 464L440 465L440 465L440 465L440 465L440 465L441 465L441 464L441 464L441 464L441 464L441 464L441 464L441 463L441 463L442 463L442 463L443 463L443 463L443 462L443 462L444 462L444 462L444 462L444 462L444 462L444 461L445 461L444 461L444 461L444 461L444 461L444 460L442 460L442 460L440 460L441 459L441 459L441 457L442 456L442 455L442 455L442 455L443 455L443 454L443 453L444 453L444 452L443 452L443 452L442 452L442 451L442 451L442 451L442 451L441 450L441 450L441 450L441 449L441 449L441 448L441 448L441 448L441 447L441 446L441 445L441 445L441 444L441 444L442 444L442 444L443 444L443 444L443 443L443 443L444 443L444 443L445 443L445 442L445 440L445 440L445 440L445 439L445 439L445 438L444 439L444 439L444 439L443 439L442 440L440 439z"
        },
        {
            "title": "Tirumalagiri",
            "d": "M430 437L430 437L430 438L429 438L429 438L429 438L429 437L429 437L429 437L428 437L428 437L428 437L428 436L428 436L428 436L428 436L427 436L428 435L427 435L427 435L427 435L427 434L427 434L427 433L426 433L426 433L426 433L425 433L424 434L423 436L423 437L423 437L423 437L423 437L423 437L422 438L422 439L422 439L421 439L420 438L420 438L419 438L419 438L419 438L419 438L419 438L418 438L417 436L414 435L414 435L412 435L412 435L412 435L412 435L412 435L411 435L411 435L410 435L407 434L407 436L406 437L406 437L405 437L405 438L404 437L404 437L403 437L403 437L400 435L400 435L399 435L398 436L397 437L396 437L396 437L396 437L396 438L396 438L397 438L397 439L396 440L398 441L398 442L400 443L401 444L403 445L405 449L406 448L407 447L407 446L407 446L407 445L408 445L408 446L408 446L408 446L409 446L409 445L409 445L410 445L410 445L410 445L410 445L411 445L412 445L413 445L414 446L415 446L417 445L418 445L419 446L420 447L421 446L421 447L421 447L421 447L421 447L421 447L421 447L421 448L421 449L421 449L421 448L422 449L422 448L423 448L423 448L423 448L424 448L424 448L424 448L424 448L425 448L425 447L425 447L426 445L426 445L427 445L427 444L427 444L427 444L428 443L429 444L430 445L430 445L430 445L431 444L432 444L432 444L432 444L431 443L431 443L431 443L431 443L431 442L431 442L431 442L431 442L431 442L431 441L431 441L431 441L431 440L431 440L431 440L431 439L431 439L431 439L431 438L431 438L431 438L430 437z"
        }
    ],
    "Sangareddy": [
        {
            "title": "Andole",
            "d": "M185 365L184 362L183 362L183 362L182 361L182 361L182 361L182 362L182 362L182 362L182 362L182 362L181 362L181 362L181 362L180 363L180 363L180 363L179 363L179 363L179 363L179 364L179 364L179 365L179 367L179 367L179 367L178 368L178 368L177 369L177 369L177 369L176 368L176 366L175 366L175 365L173 365L173 365L172 365L172 366L172 366L172 366L172 367L172 367L172 367L171 368L171 368L170 368L170 368L170 368L169 368L169 368L169 368L169 368L169 368L168 368L167 368L167 368L167 369L167 369L168 370L168 370L167 371L168 371L167 373L167 373L166 373L165 373L165 373L164 373L164 374L164 375L163 375L164 376L163 376L163 377L163 377L163 377L162 377L162 378L162 379L162 379L162 379L162 380L162 380L162 380L163 381L165 381L165 382L165 383L165 384L167 385L167 385L168 385L168 384L168 384L169 384L169 384L170 383L170 383L170 383L171 383L171 384L174 384L174 384L175 383L175 383L175 383L176 383L177 383L178 383L178 384L177 384L178 385L177 387L177 387L177 387L177 387L177 387L176 387L175 388L175 388L175 388L176 390L177 390L177 390L178 390L178 389L178 389L179 389L179 389L180 388L180 388L181 388L181 388L181 388L181 388L182 388L183 388L183 388L183 388L183 388L183 388L185 388L185 388L186 389L186 389L186 389L186 389L187 389L189 390L189 390L190 390L191 389L191 388L190 388L190 386L189 386L190 385L191 384L191 383L190 382L190 381L189 381L189 381L188 381L188 380L188 380L188 379L188 379L187 378L187 377L188 375L187 373L187 372L186 372L186 372L184 371L184 371L184 371L184 370L184 367L184 366L185 365z"
        },
        {
            "title": "Kohir",
            "d": "M104 425L104 427L104 427L105 427L105 427L105 427L105 427L106 428L106 428L107 427L107 428L107 428L107 428L107 428L108 428L108 428L108 428L108 428L108 429L108 429L109 429L110 429L110 429L111 429L111 429L111 429L112 430L114 429L114 430L115 429L115 430L116 431L116 431L116 431L117 432L117 432L117 432L117 432L118 432L118 432L119 432L119 432L119 430L119 429L120 429L121 429L121 429L122 429L122 430L123 429L123 429L123 429L123 429L124 429L124 429L124 429L124 428L125 428L125 428L126 427L126 427L126 427L127 426L128 426L128 425L129 425L129 425L129 425L131 423L131 423L131 423L131 423L131 421L131 420L132 419L132 419L133 419L133 417L134 416L133 414L131 414L131 414L131 414L131 414L130 414L130 413L129 413L129 412L129 412L129 412L130 412L130 412L130 412L130 412L130 412L130 412L130 412L130 412L131 412L131 412L131 412L132 412L132 412L133 412L133 412L134 412L134 412L135 411L135 411L135 411L135 410L136 409L134 409L134 407L134 407L134 407L134 406L134 406L133 406L133 405L133 404L134 403L133 402L133 402L132 403L132 403L131 403L131 402L131 402L130 401L130 401L130 401L129 403L128 405L128 405L128 406L127 406L127 406L127 406L127 405L126 405L126 404L126 402L126 402L126 401L126 401L126 399L125 398L125 398L124 398L123 399L123 400L123 401L122 402L122 403L121 403L121 404L121 404L120 404L119 404L119 404L119 404L118 405L118 406L118 407L117 407L118 407L117 407L117 408L117 408L117 408L117 409L117 409L116 409L116 410L115 410L112 410L112 410L112 411L111 412L111 413L111 414L111 415L111 416L111 417L109 419L109 419L109 419L109 420L108 420L108 420L108 421L108 421L107 421L107 422L107 422L106 423L106 423L106 424L106 424L105 425L105 425L105 425L104 425z"
        },
        {
            "title": "Gummadidala",
            "d": "M244 396L244 397L242 396L241 396L240 395L239 396L239 396L239 397L238 398L238 398L238 399L238 399L237 400L237 400L237 401L235 401L235 401L233 400L233 399L233 398L232 397L232 396L231 396L231 396L231 396L231 395L231 395L231 395L231 395L231 395L231 394L231 394L231 394L231 394L230 393L230 393L229 393L229 393L227 393L227 394L226 394L224 393L224 393L224 393L224 393L224 394L224 394L223 394L223 394L223 394L223 395L223 396L223 396L224 396L225 396L225 397L225 397L225 397L225 398L225 398L225 398L225 399L224 400L225 400L224 401L225 401L225 401L225 401L224 404L225 404L225 405L225 405L225 405L225 405L225 406L226 406L227 406L226 408L227 408L227 408L228 409L229 409L230 410L230 410L230 410L230 410L231 410L231 411L231 411L231 411L231 412L231 412L230 412L230 413L230 413L230 414L230 414L231 414L231 415L231 415L231 415L232 415L232 415L232 415L232 415L233 416L233 416L233 415L234 415L235 415L235 415L235 415L236 415L236 414L236 413L235 413L235 413L235 412L235 412L235 412L235 411L234 411L234 411L234 411L235 409L235 409L235 408L235 408L235 408L235 407L236 407L236 406L236 405L237 405L237 405L238 406L239 406L239 406L239 406L240 406L240 406L240 406L240 406L241 406L241 406L241 405L242 405L242 403L243 402L243 402L244 402L244 402L245 401L245 401L245 401L245 400L245 400L245 399L246 399L245 398L245 398L245 398L244 396L244 396z"
        },
        {
            "title": "Hathnoora",
            "d": "M198 384L198 384L198 384L198 384L197 384L197 384L196 384L196 383L196 382L196 382L196 381L196 380L196 380L196 380L196 380L196 379L196 379L196 378L196 378L196 378L196 377L195 377L195 377L195 377L194 377L194 378L194 379L194 380L193 381L192 381L191 382L191 382L191 383L191 383L191 383L191 382L190 382L191 383L191 384L190 385L189 386L190 386L190 388L191 388L191 389L190 390L190 392L189 394L189 394L189 394L189 394L189 395L190 395L193 394L193 394L193 394L193 394L194 394L193 395L193 395L193 396L193 396L193 397L193 397L193 398L194 398L194 398L195 398L195 397L196 397L196 397L196 398L197 399L197 400L197 400L195 402L195 402L194 402L195 404L194 405L195 405L196 405L196 406L196 406L196 407L196 408L196 408L196 408L197 409L196 409L196 410L196 410L197 409L198 409L198 410L198 411L198 411L198 411L200 411L200 412L200 412L200 412L201 412L201 412L201 411L202 411L202 411L203 410L205 408L205 408L205 408L205 408L206 408L206 408L206 408L206 408L207 410L207 411L209 411L210 411L210 411L211 411L211 411L212 410L213 410L213 410L213 410L214 410L214 410L215 410L216 410L216 409L216 409L216 409L217 409L217 408L217 408L218 408L218 408L219 408L220 407L219 409L219 409L220 409L219 410L219 410L220 410L221 410L221 410L221 410L222 410L222 410L222 410L222 409L222 409L223 409L224 408L224 408L223 407L223 407L223 407L222 406L222 406L222 406L222 405L222 405L222 404L222 404L221 404L220 404L220 404L219 404L219 404L219 403L219 403L219 403L218 403L217 403L217 402L216 403L216 403L216 403L216 402L215 402L215 403L215 402L214 402L214 402L213 401L213 402L213 402L212 402L212 402L211 402L210 403L209 403L209 403L210 401L209 400L210 400L210 400L210 399L211 399L211 399L211 398L211 398L211 398L210 398L210 398L210 398L210 398L210 398L209 397L210 397L209 397L210 396L211 395L210 394L209 394L209 394L208 394L208 394L208 394L207 394L207 394L207 395L207 394L207 394L207 394L207 393L207 393L206 393L205 394L204 394L204 394L204 391L205 391L205 390L205 390L205 390L205 389L205 389L204 389L204 389L204 387L204 387L204 387L204 387L204 387L204 386L204 386L204 386L204 385L205 384L204 383L203 384L202 384L201 384L201 385L201 385L201 385L200 385L199 385L199 385L199 384L198 384z"
        },
        {
            "title": "Jharasangam",
            "d": "M137 388L136 388L135 387L134 388L134 388L133 388L133 388L132 388L132 388L132 388L132 388L132 388L132 387L132 387L133 387L133 386L132 385L132 384L132 384L132 382L133 381L132 380L132 380L132 380L131 380L132 380L131 380L131 380L131 381L131 381L130 381L129 382L128 382L128 382L127 381L126 381L125 380L125 378L125 377L125 377L124 377L124 378L123 378L123 378L123 378L123 379L123 378L123 379L122 379L122 379L120 379L120 379L118 379L118 379L118 379L118 380L117 381L117 382L117 382L117 382L116 383L116 383L115 383L115 382L115 383L114 383L113 383L113 383L112 383L111 383L111 383L110 383L110 383L110 384L110 385L109 385L109 387L109 387L109 387L109 388L109 389L109 389L109 390L109 390L109 391L109 391L109 391L108 391L109 392L110 392L111 393L111 393L111 393L112 393L112 394L112 394L112 394L112 394L112 394L112 395L112 395L112 395L113 395L113 395L113 395L113 395L113 395L113 396L113 396L113 396L113 396L113 396L113 397L113 397L113 397L114 397L114 398L114 398L114 398L114 399L114 399L114 399L114 399L115 400L116 401L117 401L117 401L117 401L117 402L118 402L118 402L121 401L123 398L124 398L125 398L125 398L126 399L126 401L126 401L126 402L126 402L126 404L126 405L127 405L127 406L127 406L127 406L128 406L128 405L128 405L129 403L130 401L130 401L130 401L131 402L131 402L131 403L132 403L132 403L133 402L133 402L133 401L133 400L134 400L135 400L135 400L136 400L136 396L136 396L136 397L136 396L137 396L137 396L137 396L138 395L137 395L137 395L137 394L137 394L138 393L138 392L138 392L138 392L139 392L138 392L138 391L137 391L137 391L137 391L137 391L137 390L137 389L137 388z"
        },
        {
            "title": "Kalher",
            "d": "M155 320L155 320L155 320L156 320L155 319L155 319L156 319L156 319L157 319L157 319L157 319L156 318L156 318L156 317L156 317L156 317L156 316L156 316L156 315L157 315L156 315L156 315L156 315L155 315L155 315L155 315L154 315L154 315L153 316L153 316L153 315L152 315L151 315L151 315L150 315L150 315L150 314L150 314L150 314L150 313L150 313L150 313L149 312L148 312L148 313L147 313L147 313L147 313L146 312L145 313L145 313L144 313L144 313L144 313L144 314L144 314L145 314L144 314L143 314L141 314L141 313L140 313L139 312L139 312L139 312L138 313L138 313L138 313L137 313L137 313L137 313L136 313L136 313L136 314L136 314L136 315L136 315L135 315L135 316L135 316L135 316L135 316L135 316L135 316L135 316L134 319L134 319L134 320L136 320L137 321L138 323L139 325L140 325L141 325L142 324L143 323L143 324L143 324L143 324L143 325L144 325L144 325L145 326L146 326L147 327L147 327L147 327L148 327L148 327L148 327L148 326L149 326L149 326L149 326L149 326L149 325L149 325L149 325L149 324L150 324L150 324L150 323L150 323L150 323L150 322L150 321L150 321L150 321L150 320L150 320L150 320L151 320L152 321L152 320L153 321L154 321L155 321L155 321L155 321L155 320z"
        },
        {
            "title": "Kandi",
            "d": "M210 411L209 411L207 411L207 410L206 408L206 408L206 408L206 408L205 408L205 408L205 408L205 408L203 410L202 411L202 411L201 411L201 412L201 412L200 412L200 412L200 412L200 411L198 411L198 411L198 412L198 413L198 413L198 414L198 415L197 415L196 417L196 417L195 417L194 417L193 417L192 417L190 416L189 416L188 416L188 417L187 417L187 417L187 417L186 419L186 420L186 421L186 422L186 423L186 424L186 425L185 425L183 425L182 425L182 424L181 424L180 424L180 424L180 425L180 427L180 429L180 429L181 429L181 429L183 429L183 430L183 431L184 432L185 435L185 435L186 435L186 435L186 435L188 436L188 436L188 436L189 436L189 436L189 437L190 438L191 437L191 437L191 437L192 436L193 436L193 437L194 436L194 435L194 435L195 434L195 434L196 434L198 432L198 432L198 432L198 431L198 431L198 430L198 430L198 430L198 429L198 429L198 429L199 428L199 428L199 427L198 427L197 427L196 426L195 426L195 426L195 426L195 425L195 423L195 422L196 420L197 420L197 420L198 420L198 420L199 420L200 417L201 418L202 418L202 417L205 417L205 417L206 417L207 417L207 417L207 417L207 416L208 415L208 415L208 415L209 414L209 414L209 414L210 413L210 413L210 411z"
        },
        {
            "title": "Kondapur",
            "d": "M179 416L179 416L179 415L178 415L178 416L178 416L177 416L177 416L177 416L177 417L176 417L176 417L175 417L175 418L174 418L174 418L173 419L172 420L172 419L171 418L169 417L169 417L169 418L167 419L167 419L167 419L167 419L166 419L167 420L166 420L166 420L165 420L165 421L164 421L164 421L163 422L163 422L163 422L162 422L162 422L162 422L161 422L161 423L161 423L160 424L160 424L160 424L160 425L160 425L161 425L161 426L160 427L161 428L162 428L163 428L164 428L165 429L165 430L166 430L166 430L166 430L166 430L166 431L167 431L166 431L167 431L166 432L165 433L165 433L165 434L165 435L165 436L165 437L167 437L167 437L168 436L168 436L168 436L168 435L169 434L169 434L169 433L169 433L169 434L170 434L170 434L171 435L172 435L171 436L172 436L171 436L171 436L171 437L171 437L171 437L171 439L171 439L172 439L173 439L173 439L173 439L173 439L174 440L174 440L174 440L174 440L175 440L176 440L176 439L177 439L177 439L177 440L177 440L177 441L177 441L177 442L177 442L178 442L178 442L178 442L178 443L178 443L180 443L181 443L181 443L182 442L182 442L182 442L182 442L182 442L181 442L181 442L181 440L181 440L180 440L180 440L180 440L180 440L179 439L179 439L179 439L179 437L180 437L181 437L181 436L181 436L181 435L182 434L181 434L180 434L180 433L181 433L182 433L182 433L183 431L183 430L183 429L181 429L181 429L180 429L180 429L180 427L180 425L180 424L180 424L180 423L181 423L181 422L181 421L182 421L182 421L183 421L183 419L183 419L182 418L182 417L182 417L182 416L180 416L180 416L179 416z"
        },
        {
            "title": "Manoor",
            "d": "M143 353L142 353L140 353L139 353L139 353L139 352L138 352L139 351L139 351L139 351L139 350L139 350L138 350L136 351L135 350L135 350L134 350L132 349L132 349L131 349L131 348L130 348L130 347L130 347L130 346L130 345L130 345L130 345L131 343L131 343L131 343L131 342L131 342L131 342L132 342L132 342L132 342L132 341L132 341L132 340L131 340L130 340L130 340L129 340L128 340L127 341L126 342L125 341L125 342L124 342L124 342L124 342L125 342L125 343L125 343L125 344L125 345L126 345L126 345L126 346L125 346L125 346L125 346L125 347L124 347L124 347L123 347L122 347L121 348L120 349L120 349L119 350L119 350L119 350L118 349L117 349L117 349L117 349L117 349L116 349L115 349L115 349L114 350L114 351L115 352L115 352L115 353L114 354L114 356L114 356L115 356L115 357L116 356L117 356L119 356L120 355L122 355L124 356L124 356L124 356L124 357L124 358L124 358L124 358L121 360L121 360L121 361L121 361L123 362L124 363L124 363L125 362L125 362L125 361L126 360L127 359L128 359L128 359L129 360L129 361L129 362L129 362L130 363L130 363L130 363L132 363L132 363L133 362L133 361L134 360L135 360L135 360L135 360L135 361L136 362L137 365L138 366L137 367L138 367L138 367L138 368L138 368L139 368L140 368L140 368L141 368L142 368L142 368L143 368L143 369L143 369L143 368L143 368L143 368L143 367L144 366L144 366L144 365L144 365L144 364L143 364L142 361L142 360L141 361L138 360L138 360L138 359L139 358L139 358L139 358L139 358L139 357L139 356L140 356L140 355L141 355L142 355L143 355L143 353z"
        },
        {
            "title": "Mogudampally",
            "d": "M84 398L83 398L82 398L82 399L81 399L81 399L81 399L81 400L81 400L81 400L81 401L81 401L81 402L81 403L81 404L80 405L80 405L80 407L80 407L80 408L80 409L80 409L81 410L81 410L80 412L80 414L79 414L79 415L79 415L79 416L79 417L79 417L79 418L79 418L80 419L81 419L81 419L82 419L83 420L83 420L83 420L84 420L84 421L84 421L85 421L86 421L87 421L87 422L88 423L88 423L88 423L88 423L88 425L88 425L88 425L89 426L91 424L91 423L92 421L93 420L94 420L95 421L96 422L96 424L97 424L97 424L98 424L98 424L99 424L99 423L100 423L102 423L103 423L103 422L104 422L104 422L104 422L104 421L104 421L103 421L103 420L103 420L103 420L103 420L102 420L101 419L101 419L100 418L99 418L99 417L99 416L99 415L99 414L98 414L98 414L97 414L97 413L97 412L96 410L96 410L97 410L96 409L96 409L96 408L96 408L96 407L95 406L95 405L95 404L95 404L94 404L93 403L93 403L92 402L92 402L91 401L91 401L90 400L90 400L90 400L90 400L88 400L88 401L88 402L88 402L87 403L87 403L86 403L86 402L86 402L85 402L85 401L85 401L85 401L84 400L84 400L84 399L84 399L84 398L84 398z"
        },
        {
            "title": "Munipally",
            "d": "M157 381L157 381L157 380L157 380L157 380L157 380L156 380L155 379L154 379L153 379L152 379L152 379L152 380L152 381L152 381L151 382L151 381L151 382L151 382L151 383L151 383L149 384L149 384L149 384L148 384L146 385L146 384L146 385L146 386L145 386L145 386L144 386L143 386L141 386L141 385L140 387L140 387L140 388L140 388L139 388L137 388L137 389L137 390L137 391L137 391L137 391L137 391L138 391L138 392L139 392L138 392L138 392L138 392L138 393L137 394L137 394L137 395L137 395L138 395L137 396L137 396L137 396L136 396L136 397L136 396L136 396L136 400L135 400L135 400L134 400L133 400L133 401L133 402L134 403L133 404L133 405L133 406L134 406L134 406L134 407L134 407L134 407L134 409L136 409L135 410L136 410L136 410L136 411L136 411L137 411L138 412L138 412L138 412L139 412L139 412L141 412L141 412L141 412L142 411L142 411L142 412L143 412L143 412L143 412L144 412L145 413L145 413L146 414L146 414L146 414L147 414L147 415L147 415L147 415L147 415L147 415L148 415L148 415L148 415L148 414L149 414L148 413L148 412L147 412L147 411L147 411L147 410L147 410L147 409L147 409L148 409L150 409L150 408L150 408L150 407L150 406L151 405L152 405L152 405L153 405L154 404L154 404L154 404L154 403L154 403L154 403L154 403L155 403L155 403L155 403L156 403L156 403L156 402L156 401L155 401L155 400L155 400L155 400L154 400L154 400L153 400L153 399L153 399L153 399L152 399L152 398L154 398L154 397L154 397L155 397L155 397L155 397L157 396L157 396L157 397L158 397L158 396L158 396L158 395L158 395L158 394L158 394L159 392L159 392L160 392L160 392L159 391L159 391L159 391L158 390L158 390L158 389L158 389L157 388L157 388L156 388L156 388L155 388L155 388L155 388L155 387L155 387L156 386L156 386L156 384L156 383L156 383L156 381L157 381L157 380L157 381z"
        },
        {
            "title": "Nagalgidda",
            "d": "M113 326L112 325L112 326L110 326L106 326L107 329L107 329L106 330L106 331L106 332L105 332L104 333L104 333L104 333L103 333L102 333L101 333L101 334L100 334L100 335L99 335L99 336L98 336L98 337L98 337L98 337L98 338L98 338L98 340L99 341L99 341L100 341L102 341L103 341L103 341L103 342L104 344L104 345L104 345L105 345L105 345L106 345L106 344L107 344L107 344L107 344L107 345L107 345L109 346L109 346L109 346L110 347L111 348L112 348L113 348L114 347L114 347L114 347L115 348L115 348L115 349L116 349L117 349L117 349L117 349L117 349L118 349L119 350L119 350L119 350L120 349L120 349L121 348L122 347L123 347L124 347L124 347L125 347L125 346L125 346L125 346L126 346L126 345L126 345L125 345L125 344L125 343L125 343L125 342L124 342L123 342L123 341L123 341L123 341L122 340L122 340L121 340L121 340L120 339L120 338L121 337L120 337L119 337L119 337L118 337L118 336L117 336L117 336L117 335L117 335L116 335L116 334L116 334L116 334L116 333L117 331L117 331L118 330L118 330L118 330L118 329L117 329L118 329L116 328L116 329L116 329L115 328L115 328L115 328L114 327L113 326L113 326z"
        },
        {
            "title": "Narayankhed",
            "d": "M148 336L147 336L147 336L147 336L145 336L144 336L144 336L142 335L142 335L142 335L142 335L141 335L141 335L141 334L141 333L142 333L142 333L143 333L142 333L142 332L142 332L142 332L141 331L141 330L141 330L140 329L139 328L138 328L136 329L136 329L133 330L132 329L131 329L130 329L129 330L127 329L127 329L127 329L126 328L125 329L124 329L123 329L123 329L122 330L122 330L122 330L121 330L121 330L120 330L120 330L120 330L119 330L119 330L118 330L118 330L118 330L117 331L117 331L116 333L116 334L116 334L116 334L116 335L117 335L117 335L117 336L117 336L118 336L118 337L119 337L119 337L120 337L121 337L120 338L120 339L121 340L121 340L122 340L122 340L123 341L123 341L123 341L123 342L124 342L124 342L124 342L125 342L125 341L126 342L127 341L128 340L129 340L130 340L130 340L131 340L132 340L132 341L132 341L132 342L132 342L132 342L131 342L131 342L131 342L131 343L131 343L131 343L130 345L130 345L130 345L130 346L130 347L130 347L130 348L131 348L131 349L132 349L132 349L134 350L135 350L135 350L136 351L138 350L139 350L139 350L139 351L139 351L139 351L138 352L139 352L139 353L139 353L140 353L142 353L143 353L143 351L143 350L143 350L143 350L144 349L146 347L147 346L148 345L148 345L149 345L150 344L150 344L150 344L150 344L150 343L149 342L149 342L149 341L149 341L148 339L148 337L148 337L148 336L148 336zM139 336L140 336L140 336L140 335L140 336L140 336L140 337L140 337L138 337L139 337L139 337L139 337L139 336L139 336z"
        },
        {
            "title": "Nyalkal",
            "d": "M114 356L113 355L113 355L113 355L112 355L112 354L112 354L111 354L111 354L111 353L110 354L110 354L111 354L111 355L111 355L111 356L110 356L109 357L109 359L109 360L109 361L109 362L109 364L107 363L106 363L105 363L104 363L103 363L103 363L103 365L103 365L103 365L104 366L105 367L106 368L105 369L105 369L103 368L103 368L102 369L102 369L102 368L101 369L101 369L101 370L101 370L101 371L100 372L100 373L100 374L100 374L99 375L98 378L97 378L97 377L97 376L96 376L96 376L96 376L94 376L94 376L94 377L94 377L94 378L94 379L93 379L93 379L92 379L92 380L91 380L91 381L91 382L90 383L90 383L90 384L90 384L91 384L91 384L91 384L92 384L92 385L93 384L93 384L93 385L94 385L94 385L94 385L94 385L95 385L95 385L95 385L96 385L95 386L96 386L96 386L97 387L97 387L98 387L99 388L100 387L100 387L100 388L100 388L100 390L100 390L100 390L100 391L100 391L100 391L100 391L101 391L101 391L101 391L101 391L101 391L101 391L102 391L102 391L102 391L102 391L102 391L103 391L103 391L104 391L104 391L104 391L105 391L105 391L106 391L106 391L107 391L107 391L107 391L108 391L108 391L109 391L109 391L109 391L109 390L109 390L109 389L109 389L109 388L109 387L109 387L109 387L109 385L110 385L110 384L110 383L110 383L111 383L111 383L112 383L113 383L113 383L114 383L115 383L115 382L115 383L116 383L116 383L117 382L117 382L117 382L117 381L118 380L118 379L118 379L118 379L120 379L120 379L122 379L122 379L123 379L123 378L123 379L123 378L123 378L123 378L124 378L124 377L124 376L123 376L123 375L121 375L120 375L120 374L120 374L120 373L120 373L119 373L118 372L117 372L117 372L117 372L117 370L118 370L118 370L119 370L120 369L120 369L121 369L121 369L121 369L121 367L121 367L121 367L121 367L121 367L122 367L122 367L122 366L122 366L122 366L123 366L123 366L123 365L123 365L123 365L123 365L123 364L123 364L123 364L123 363L123 363L124 363L124 363L124 363L124 363L124 363L124 363L124 363L124 363L124 363L123 362L121 361L121 361L121 360L121 360L124 358L124 358L124 358L124 357L124 356L124 356L124 356L122 355L120 355L119 356L117 356L116 356L115 357L115 356L114 356L114 356z"
        },
        {
            "title": "Patancheruvu",
            "d": "M219 422L219 421L219 421L218 420L217 419L217 419L217 418L218 417L217 417L215 417L215 417L215 417L215 417L215 417L214 417L214 417L215 417L215 417L215 416L215 416L215 416L215 416L215 415L215 415L215 415L215 415L216 415L216 415L216 415L216 414L216 414L215 414L214 413L214 413L214 413L214 413L213 413L213 414L213 414L212 414L212 414L212 414L211 414L211 414L211 414L210 414L210 414L209 414L209 414L209 414L208 415L208 415L208 415L207 416L207 417L207 417L207 417L206 417L205 417L205 417L202 417L202 418L201 418L200 417L199 420L198 420L198 420L197 420L197 420L196 420L195 422L195 423L195 425L195 426L195 426L195 426L196 426L197 427L198 427L199 427L199 428L199 428L198 429L198 429L198 429L198 430L198 430L198 430L198 431L198 431L198 432L198 432L198 432L196 434L195 434L195 434L194 435L194 435L194 436L193 437L194 437L195 438L195 440L197 441L198 441L199 441L199 441L199 440L200 440L200 440L200 440L201 440L202 439L202 439L203 438L203 438L203 438L202 437L202 437L203 437L204 437L204 437L205 437L205 437L206 437L206 437L206 438L206 438L206 438L206 438L207 438L208 437L209 437L210 437L211 437L212 437L213 436L213 435L213 435L213 434L214 434L214 432L214 432L215 432L215 431L216 432L217 432L217 433L217 433L217 432L218 432L218 431L218 431L218 431L218 431L218 430L219 430L218 429L218 429L218 429L218 429L218 428L217 428L217 427L217 426L217 426L217 426L217 426L218 426L218 425L219 425L219 425L219 425L219 424L219 424L219 423L219 422L219 422L219 422z"
        },
        {
            "title": "Pulkal",
            "d": "M182 388L181 388L181 388L181 388L181 388L180 388L180 388L179 389L179 389L178 389L178 389L178 390L177 390L177 390L176 390L175 388L175 388L175 388L176 387L177 387L177 387L177 387L177 387L177 387L178 385L177 384L178 384L178 383L177 383L176 383L175 383L175 383L175 383L174 384L174 384L171 384L171 383L170 383L170 383L170 383L169 384L169 384L168 384L168 384L168 385L167 385L167 385L165 384L165 383L165 382L165 381L163 381L162 380L162 381L162 381L161 381L161 381L160 381L159 381L158 380L158 380L157 381L157 380L157 381L156 381L156 383L156 383L156 384L156 386L156 386L155 387L155 387L155 388L155 388L155 388L156 388L156 388L157 388L157 388L158 389L158 389L158 390L158 390L159 391L159 391L159 391L160 392L160 392L161 394L161 395L161 396L161 397L163 398L163 398L164 398L165 397L165 397L166 397L166 397L168 396L168 396L169 396L170 397L170 397L170 397L171 398L170 400L170 400L171 400L172 401L172 401L176 402L176 402L177 402L177 403L177 403L177 404L177 405L177 405L177 405L179 406L179 406L180 407L181 407L181 407L181 407L183 405L183 405L182 404L182 404L182 404L182 404L182 404L182 404L182 404L182 404L182 404L182 404L182 403L182 403L182 402L182 402L182 402L183 401L183 401L183 401L184 401L184 400L183 399L182 398L182 397L182 397L181 397L179 396L177 395L177 393L177 392L178 392L179 392L179 391L181 389L181 389L182 388z"
        },
        {
            "title": "Raikode",
            "d": "M143 369L143 369L143 368L142 368L142 368L141 368L140 368L140 368L139 368L138 368L138 368L138 367L138 367L137 367L138 366L137 365L136 362L135 361L135 360L135 360L135 360L134 360L133 361L133 362L132 363L132 363L130 363L130 363L130 363L129 362L129 362L129 361L129 360L128 359L128 359L127 359L126 360L125 361L125 362L125 362L124 363L124 363L124 363L124 363L124 363L124 363L124 363L124 363L124 363L124 363L123 363L123 363L123 364L123 364L123 364L123 365L123 365L123 365L123 365L123 366L123 366L122 366L122 366L122 366L122 367L122 367L121 367L121 367L121 367L121 367L121 367L121 369L121 369L121 369L120 369L120 369L119 370L118 370L118 370L117 370L117 372L117 372L117 372L118 372L119 373L120 373L120 373L120 374L120 374L120 375L121 375L123 375L123 376L124 376L124 377L125 377L125 377L125 378L125 380L126 381L127 381L128 382L128 382L129 382L130 381L131 381L131 381L131 380L131 380L132 380L131 380L132 380L132 380L132 380L133 381L132 382L132 384L132 384L132 385L133 386L133 387L132 387L132 387L132 388L132 388L132 388L132 388L132 388L133 388L133 388L134 388L134 388L135 387L136 388L137 388L139 388L140 388L140 388L140 387L140 387L141 385L141 386L143 386L144 386L145 386L145 386L146 386L146 385L146 384L146 385L148 384L149 384L149 384L149 384L151 383L151 383L151 382L151 382L151 381L151 382L152 381L152 381L152 380L152 379L152 379L152 378L150 378L149 377L149 377L149 376L149 375L149 374L149 373L149 372L149 372L149 371L149 371L149 371L149 370L149 370L149 369L148 369L147 369L147 369L147 369L147 370L147 370L146 372L146 372L145 372L144 371L144 370L143 369L143 369z"
        },
        {
            "title": "Ramachandrapuram",
            "d": "M222 433L222 432L221 431L219 430L218 430L218 431L218 431L218 431L218 431L218 432L217 432L217 433L217 433L217 432L216 432L215 431L215 432L214 432L214 432L214 434L213 434L213 435L213 435L213 436L212 437L211 437L210 437L209 437L208 437L207 438L206 438L206 438L205 439L205 440L205 442L205 443L206 442L206 443L207 443L207 443L206 444L206 444L207 446L207 446L208 445L208 446L208 446L209 447L209 447L209 447L211 447L212 448L212 447L213 447L214 447L215 447L215 447L215 447L216 446L217 446L218 447L218 446L218 445L219 445L219 445L219 443L219 443L220 442L220 442L220 439L220 439L220 438L220 438L220 437L221 437L221 437L223 436L223 436L223 435L223 435L223 435L223 435L223 435L223 435L222 434L222 434L222 434L222 433L222 433L222 434L222 434L222 433z"
        },
        {
            "title": "Sadasivpet",
            "d": "M179 406L177 405L177 405L177 405L177 404L177 403L177 403L177 402L176 402L176 402L172 401L172 401L171 400L170 400L170 400L171 398L170 397L170 397L170 397L169 396L168 396L168 396L166 397L166 397L165 397L165 397L164 398L163 398L163 398L161 397L161 396L161 395L161 394L160 392L160 392L160 392L159 392L159 392L158 394L158 394L158 395L158 395L158 396L158 396L158 397L157 397L157 396L157 396L155 397L155 397L155 397L154 397L154 397L154 398L152 398L152 399L153 399L153 399L153 399L153 400L154 400L154 400L155 400L155 400L155 400L155 401L156 401L156 402L156 403L156 403L155 403L155 403L155 403L154 403L154 403L154 403L154 403L154 404L154 404L154 404L153 405L152 405L152 405L151 405L150 406L150 407L150 408L150 408L150 409L148 409L147 409L147 409L147 410L147 410L147 411L147 411L147 412L148 412L148 413L149 414L149 414L149 414L149 414L149 414L149 415L151 416L150 416L150 417L149 417L149 417L149 417L150 418L150 418L150 419L150 419L150 419L150 419L150 419L150 420L150 420L150 420L150 420L151 420L152 420L153 420L154 420L154 420L155 420L156 421L157 421L157 421L158 421L158 421L159 423L159 423L160 423L160 423L160 423L160 424L160 424L160 424L161 423L161 423L161 422L162 422L162 422L162 422L163 422L163 422L163 422L164 421L164 421L165 421L165 420L166 420L166 420L167 420L166 419L167 419L167 419L167 419L167 419L169 418L169 417L169 417L171 418L172 419L172 420L173 419L174 418L174 418L175 418L175 417L176 417L176 417L177 417L177 416L177 416L177 416L178 416L178 416L178 415L179 415L179 416L179 416L178 415L178 414L178 414L178 414L178 413L178 413L178 413L178 412L178 412L178 411L178 411L178 411L179 411L179 410L179 410L180 409L180 408L179 407L179 407L179 407L179 407L179 407L179 407L179 406L179 406L179 406z"
        },
        {
            "title": "Sangareddy",
            "d": "M196 408L195 409L195 409L194 409L193 409L193 409L193 408L193 407L193 407L192 406L192 406L192 406L191 406L191 408L191 409L191 409L190 409L186 408L184 408L184 408L184 408L183 407L183 406L183 405L183 405L183 405L183 405L183 405L183 405L181 407L181 407L181 407L180 407L179 406L179 406L179 406L179 406L179 407L179 407L179 407L179 407L179 407L179 407L180 408L180 409L179 410L179 410L179 411L178 411L178 411L178 411L178 412L178 412L178 413L178 413L178 413L178 414L178 414L178 414L178 415L179 416L180 416L180 416L182 416L182 417L182 417L182 418L183 419L183 419L183 421L182 421L182 421L181 421L181 422L181 423L180 423L180 424L181 424L182 424L182 425L183 425L185 425L186 425L186 424L186 423L186 422L186 421L186 420L186 419L187 417L187 417L187 417L188 417L188 416L189 416L190 416L192 417L193 417L194 417L195 417L196 417L196 417L197 415L198 415L198 414L198 413L198 413L198 412L198 411L198 411L198 410L198 409L197 409L196 410L196 410L196 409L197 409L196 408L196 408L196 408z"
        },
        {
            "title": "Sirgapoor",
            "d": "M135 315L135 315L135 315L134 315L133 313L133 312L133 312L131 312L131 312L130 312L130 312L130 312L129 312L129 313L128 313L128 314L128 314L128 314L128 315L127 315L126 315L126 315L125 316L126 316L126 316L126 317L125 317L125 317L124 317L124 318L124 319L125 321L124 321L124 321L124 321L124 321L123 322L122 322L122 322L122 321L122 321L122 320L121 320L121 320L121 319L120 319L120 319L120 318L120 317L117 316L117 316L117 317L116 317L115 319L115 321L115 321L114 321L114 322L114 322L114 323L114 324L114 324L113 324L113 325L113 325L113 326L113 326L114 327L115 328L115 328L115 328L116 329L116 329L116 328L118 329L117 329L118 329L118 330L119 330L119 330L120 330L120 330L120 330L121 330L121 330L122 330L122 330L122 330L123 329L123 329L124 329L125 329L126 328L127 329L127 329L127 329L129 330L130 329L131 329L132 329L133 330L136 329L136 329L138 328L139 328L138 327L139 325L138 323L137 321L136 320L134 320L134 319L134 319L135 316L135 316L135 316L135 316L135 316L135 316L135 316L135 315z"
        },
        {
            "title": "Vatpally",
            "d": "M155 359L155 359L155 359L153 359L152 359L153 358L152 358L153 358L153 357L152 357L152 357L152 357L151 357L151 357L150 357L150 357L150 358L149 359L148 360L148 361L147 364L147 365L146 365L145 365L144 365L144 365L144 366L144 366L143 367L143 368L143 368L143 368L143 369L143 369L144 370L144 371L145 372L146 372L146 372L147 370L147 370L147 369L147 369L147 369L148 369L149 369L149 370L149 370L149 371L149 371L149 371L149 372L149 372L149 373L149 374L149 375L149 376L149 377L149 377L150 378L152 378L152 379L153 379L154 379L155 379L156 380L157 380L157 380L157 380L157 380L157 381L157 381L158 380L158 380L159 381L160 381L161 381L161 381L162 381L162 381L162 380L162 380L162 380L162 379L162 379L162 379L162 378L162 377L163 377L163 377L163 377L163 376L164 376L163 375L164 375L164 374L164 373L165 373L165 373L166 373L167 373L167 373L168 371L167 371L168 370L168 370L167 369L167 369L167 368L167 368L167 367L167 367L166 367L165 367L165 368L164 368L164 367L163 367L163 367L162 367L162 367L161 367L161 367L161 366L160 365L161 365L161 365L162 365L162 364L162 364L162 364L162 364L162 363L162 363L162 362L162 362L162 362L162 362L161 362L161 362L160 362L160 361L160 361L160 360L160 360L160 360L160 360L159 360L159 361L159 361L157 361L156 360L155 359z"
        },
        {
            "title": "Zahirabad",
            "d": "M104 422L104 424L104 425L104 425L105 425L105 425L105 425L106 424L106 424L106 423L106 423L107 422L107 422L107 421L108 421L108 421L108 420L108 420L109 420L109 419L109 419L109 419L111 417L111 416L111 415L111 414L111 413L111 412L112 411L112 410L112 410L115 410L116 410L116 409L117 409L117 409L117 408L117 408L117 408L117 407L118 407L117 407L118 407L118 406L118 405L119 404L119 404L119 404L120 404L121 404L121 404L121 403L122 403L122 402L123 401L123 400L123 399L124 398L123 398L121 401L118 402L118 402L117 402L117 401L117 401L117 401L116 401L115 400L114 399L114 399L114 399L114 399L114 398L114 398L114 398L114 397L113 397L113 397L113 397L113 396L113 396L113 396L113 396L113 396L113 395L113 395L113 395L113 395L113 395L112 395L112 395L112 395L112 394L112 394L112 394L112 394L112 394L112 393L111 393L111 393L111 393L110 392L109 392L108 391L108 391L107 391L107 391L107 391L106 391L106 391L105 391L105 391L104 391L104 391L104 391L103 391L103 391L102 391L102 391L102 391L102 391L102 391L101 391L101 391L101 391L101 391L101 391L101 391L100 391L100 391L100 391L100 391L100 390L100 390L99 390L99 391L99 391L99 391L98 392L98 392L98 392L97 392L97 392L97 392L97 393L96 393L96 394L96 394L96 393L95 394L95 394L94 394L94 393L94 394L94 394L93 394L93 394L93 394L92 394L92 394L92 394L91 395L91 395L91 395L91 395L90 395L90 395L90 396L90 395L89 396L89 395L88 396L88 397L87 397L86 397L86 397L86 397L86 397L86 397L86 397L86 397L85 398L85 398L85 397L85 397L84 398L84 398L84 399L84 399L84 400L84 400L85 401L85 401L85 401L85 402L86 402L86 402L86 403L87 403L87 403L88 402L88 402L88 401L88 400L90 400L90 400L90 400L90 400L91 401L91 401L92 402L92 402L93 403L93 403L94 404L95 404L95 404L95 405L95 406L96 407L96 408L96 408L96 409L96 409L97 410L96 410L96 410L97 412L97 413L97 414L98 414L98 414L99 414L99 415L99 416L99 417L99 418L100 418L101 419L101 419L102 420L103 420L103 420L103 420L103 420L103 421L104 421L104 421L104 422L104 422L104 422z"
        },
        {
            "title": "Ameenpur",
            "d": "M229 430L229 430L228 430L228 430L228 429L228 429L227 429L225 427L226 427L226 426L226 426L226 426L226 425L226 424L226 423L226 423L225 422L225 422L226 421L225 421L226 421L225 421L225 421L224 421L223 422L223 422L223 422L222 422L223 422L222 422L222 422L222 422L222 422L221 421L221 421L221 422L221 422L220 421L220 421L220 421L220 422L220 422L220 422L220 422L219 422L219 422L219 422L219 422L219 422L219 423L219 424L219 424L219 425L219 425L219 425L218 425L218 426L217 426L217 426L217 426L217 426L217 427L217 428L218 428L218 429L218 429L218 429L218 429L219 430L221 431L222 432L222 433L223 434L223 434L224 434L225 434L226 434L226 435L226 435L227 434L227 434L227 434L227 433L227 432L228 432L228 432L228 432L228 431L229 430z"
        },
        {
            "title": "Jinnaram",
            "d": "M233 416L232 415L232 415L232 415L232 415L231 415L231 415L231 415L231 414L230 414L230 414L230 413L230 413L230 412L231 412L231 412L231 411L231 411L231 411L231 410L230 410L230 410L230 410L230 410L229 409L228 409L227 408L227 408L226 408L227 406L226 406L225 406L224 407L224 408L224 408L224 408L223 409L222 409L222 409L222 410L222 410L222 410L221 410L221 410L221 410L220 410L219 410L219 410L220 409L219 409L219 409L220 407L219 408L218 408L218 408L217 408L217 408L217 409L216 409L216 409L216 409L216 410L215 410L214 410L214 410L213 410L213 410L213 410L212 410L211 411L211 411L210 411L210 411L210 413L210 413L209 414L209 414L209 414L209 414L209 414L210 414L210 414L211 414L211 414L211 414L212 414L212 414L212 414L213 414L213 414L213 413L214 413L214 413L214 413L214 413L215 414L216 414L216 414L216 415L216 415L216 415L215 415L215 415L215 415L215 415L215 416L215 416L215 416L215 416L215 417L215 417L214 417L214 417L215 417L215 417L215 417L215 417L215 417L217 417L218 417L217 418L217 419L217 419L218 420L219 421L219 421L219 422L219 422L219 422L220 422L220 422L220 422L220 422L220 421L220 421L220 421L221 422L221 422L221 421L221 421L222 422L222 422L222 422L222 422L223 422L222 422L223 422L223 422L223 422L224 421L225 421L225 421L226 421L225 421L226 421L225 422L225 422L226 423L226 423L226 424L226 425L226 426L226 426L226 426L226 427L225 427L227 429L228 429L228 429L228 430L228 430L229 430L229 430L229 430L228 429L229 429L229 428L230 428L230 428L230 427L231 426L231 426L231 426L231 426L231 425L230 425L230 425L230 425L230 425L230 425L230 425L230 425L230 425L230 424L230 424L230 424L231 424L231 424L230 424L230 424L232 423L233 422L234 421L234 420L234 420L234 419L234 419L235 419L235 418L235 417L234 417L233 416L233 416L233 416z"
        },
        {
            "title": "Chowtakur",
            "d": "M183 405L183 405L183 405L183 405L183 405L183 405L183 406L183 407L184 408L184 408L184 408L186 408L190 409L191 409L191 409L191 408L191 406L192 406L192 406L192 406L193 407L193 407L193 408L193 409L193 409L194 409L195 409L195 409L196 408L196 407L196 406L196 406L196 405L195 405L194 405L195 404L194 402L195 402L195 402L197 400L197 400L197 399L196 398L196 397L196 397L195 397L195 398L194 398L194 398L193 398L193 397L193 397L193 396L193 396L193 395L193 395L194 394L193 394L193 394L193 394L193 394L190 395L189 395L189 394L189 394L189 394L189 394L190 392L190 390L189 390L189 390L187 389L186 389L186 389L186 389L186 389L185 388L185 388L183 388L183 388L183 388L183 388L183 388L182 388L181 389L181 389L179 391L179 392L178 392L177 392L177 393L177 395L179 396L181 397L182 397L182 397L182 398L183 399L184 400L184 401L183 401L183 401L183 401L182 402L182 402L182 402L182 403L182 403L182 404L182 404L182 404L182 404L182 404L182 404L182 404L182 404L182 404L182 404L183 405L183 405z"
        },
        {
            "title": "Nizampet",
            "d": "M139 336L139 336L139 337L139 337L139 337L138 337L140 337L140 337L140 336L140 336L140 335L140 336L140 336L139 336zM155 320L155 321L155 321L155 321L154 321L153 321L152 320L152 321L151 320L150 320L150 320L150 320L150 321L150 321L150 321L150 322L150 323L150 323L150 323L150 324L150 324L149 324L149 325L149 325L149 325L149 326L149 326L149 326L149 326L148 326L148 327L148 327L148 327L147 327L147 327L147 327L146 326L145 326L144 325L144 325L143 325L143 324L143 324L143 324L143 323L142 324L141 325L140 325L139 325L138 327L139 328L140 329L141 330L141 330L141 331L142 332L142 332L142 332L142 333L143 333L142 333L142 333L141 333L141 334L141 335L141 335L142 335L142 335L142 335L142 335L144 336L144 336L145 336L147 336L147 336L147 336L148 336L148 335L149 335L151 335L152 335L152 335L152 335L154 336L154 336L155 335L156 335L157 335L157 335L157 334L157 334L157 333L158 332L158 332L158 332L158 331L158 331L158 331L158 331L158 331L158 331L158 331L157 331L156 331L156 332L155 332L155 332L155 332L155 332L155 332L155 332L156 332L156 331L156 331L156 331L156 331L156 330L156 331L157 330L157 330L157 330L157 329L157 330L157 330L158 330L158 330L158 330L158 330L158 330L158 329L158 329L158 328L159 328L159 328L159 328L159 328L159 328L160 328L160 328L160 328L160 328L160 328L160 328L160 329L161 329L161 328L161 327L163 325L163 325L163 324L163 323L163 323L163 323L163 322L162 321L161 321L161 321L161 322L161 322L160 322L160 322L160 322L160 322L160 322L160 322L160 322L160 322L159 322L159 322L159 321L159 321L159 321L158 321L158 321L157 321L157 321L156 320L156 320L156 321L156 320L155 320z"
        },
        {
            "title": "Kangti",
            "d": "M107 299L106 300L106 301L106 301L105 302L104 302L104 302L103 303L102 305L102 305L102 306L103 306L103 307L104 307L103 308L104 308L104 308L104 309L103 310L103 312L102 312L101 312L101 312L101 313L101 313L101 313L101 313L102 314L102 314L102 315L102 316L102 317L103 318L103 319L104 319L104 320L105 320L105 320L106 320L106 320L106 324L106 325L106 326L106 326L106 326L110 326L112 326L112 325L113 326L113 325L113 325L113 324L114 324L114 324L114 323L114 322L114 322L114 321L115 321L115 321L115 319L116 317L117 317L117 316L117 316L120 317L120 318L120 319L120 319L121 319L121 320L121 320L122 320L122 321L122 321L122 322L122 322L123 322L124 321L124 321L124 321L124 321L125 321L124 319L124 318L124 317L125 317L125 317L126 317L126 316L126 316L125 316L126 315L126 315L127 315L128 315L128 314L128 314L128 314L128 313L129 313L129 312L130 312L130 311L131 311L130 310L131 309L130 309L130 309L130 309L129 309L129 307L128 307L128 307L128 307L128 306L128 305L128 305L128 304L127 303L126 303L125 303L124 303L124 303L124 302L124 302L124 302L122 302L122 302L121 302L120 301L120 299L119 299L119 299L118 299L117 298L117 298L116 298L116 298L116 298L116 298L115 298L115 298L114 298L114 298L114 298L112 298L112 298L111 298L111 299L110 299L109 299L108 299L108 299L108 299L107 299L107 299z"
        }
    ],
    "Nizamabad": [
        {
            "title": "Armoor",
            "d": "M232 208L231 207L230 207L230 207L229 207L229 207L228 207L227 207L227 206L227 205L227 205L227 205L227 205L227 204L227 204L227 203L226 203L226 202L226 202L225 201L225 199L225 199L225 199L225 198L225 198L225 198L225 198L224 198L223 198L224 197L224 196L224 196L224 195L224 195L224 194L224 194L224 194L224 194L224 193L224 193L223 192L223 192L223 191L224 191L224 191L223 191L224 191L224 190L224 190L224 190L224 189L223 189L223 189L223 189L223 189L223 189L222 189L222 189L222 189L222 189L222 189L222 189L222 189L222 189L222 189L222 188L221 189L220 188L220 188L220 188L220 188L220 187L219 187L218 190L218 190L217 190L216 192L216 192L215 192L215 192L214 193L214 193L213 193L213 194L212 195L212 195L213 196L213 196L213 196L213 196L213 196L214 197L214 197L214 197L214 198L214 198L213 198L214 199L215 200L215 200L215 200L215 201L215 201L215 202L214 203L214 203L214 204L213 204L213 205L213 206L213 206L213 206L213 207L212 208L212 208L212 208L211 209L211 209L211 209L211 209L211 209L212 211L212 211L211 211L211 212L211 212L212 212L212 213L211 213L211 213L212 214L211 214L212 215L212 215L212 215L213 216L214 216L214 217L215 218L215 218L215 218L215 219L215 220L215 220L215 220L215 221L216 221L216 221L216 220L217 221L217 220L217 219L217 219L217 219L218 219L218 219L218 219L218 219L218 219L219 219L219 218L219 218L219 218L219 218L219 218L220 218L220 218L222 218L222 217L223 217L223 216L223 216L224 215L224 215L225 215L225 216L226 216L226 217L226 218L227 218L227 219L228 219L229 219L229 219L229 219L229 219L230 219L230 219L230 219L231 218L231 217L232 217L232 217L232 216L231 215L231 215L230 215L230 215L230 214L230 213L231 213L231 212L231 211L232 211L232 210L232 210L232 210L232 210L232 210L233 210L233 210L232 208L232 208z"
        },
        {
            "title": "Balkonda",
            "d": "M229 182L229 182L228 183L228 183L228 182L228 182L228 182L228 182L228 182L227 183L225 183L222 184L221 185L220 185L220 185L219 186L220 186L219 187L220 187L220 188L220 188L220 188L220 188L221 189L222 188L222 189L222 189L222 189L222 189L222 189L222 189L222 189L222 189L222 189L223 189L223 189L223 189L223 189L223 189L224 189L224 190L224 190L224 190L224 191L223 191L224 191L224 191L223 191L223 192L223 192L224 193L224 193L224 194L224 194L224 194L224 194L224 195L224 195L224 196L224 196L224 197L223 198L224 198L225 198L225 198L225 198L225 198L225 199L225 199L225 199L225 201L226 202L226 202L226 203L227 203L227 204L227 204L227 205L227 205L227 205L227 205L227 206L227 207L228 207L229 207L229 207L230 207L230 207L231 207L232 208L232 207L233 206L233 206L233 205L233 204L233 203L234 203L235 203L235 204L236 204L237 204L237 204L238 204L238 205L238 205L238 205L238 205L239 205L239 205L239 204L239 204L239 204L239 204L239 204L239 203L240 203L240 202L240 202L240 202L240 202L240 202L239 201L240 199L240 199L240 199L240 199L239 198L239 198L239 198L238 197L237 197L237 197L236 198L235 197L235 198L234 198L234 197L234 196L234 196L234 195L233 195L232 195L232 195L232 195L232 195L232 195L232 195L232 194L233 194L233 194L233 193L233 193L233 193L233 193L232 193L232 192L232 192L232 192L231 192L231 192L231 192L231 191L231 191L231 189L231 188L231 187L231 187L231 187L231 186L230 186L230 185L230 185L231 185L230 185L230 185L230 185L230 185L229 185L230 184L229 184L229 183L229 183L229 183L229 182z"
        },
        {
            "title": "Bheemgal",
            "d": "M270 232L269 232L268 231L267 232L266 231L265 231L265 231L264 231L263 230L262 230L262 229L261 229L261 228L261 228L261 228L261 228L261 228L260 227L260 226L261 226L260 226L260 226L259 225L258 225L258 225L258 224L258 224L257 221L257 221L257 221L256 221L255 221L253 220L252 219L252 219L251 220L251 220L250 219L250 220L249 219L247 220L246 220L245 222L245 224L244 224L244 224L244 224L244 225L244 225L243 225L244 225L245 226L245 227L244 227L244 228L242 227L240 227L240 227L239 227L239 227L239 227L239 226L239 226L239 226L239 226L239 226L239 226L239 225L239 225L238 225L238 225L237 224L237 224L237 225L236 225L235 225L235 225L235 226L235 226L235 226L234 229L233 229L233 229L233 229L233 229L233 230L233 230L233 231L233 232L233 232L234 233L234 233L235 233L236 234L236 234L236 234L236 234L238 234L238 234L238 234L239 234L239 235L240 235L240 236L240 237L240 237L240 237L240 237L240 238L240 238L240 238L240 238L240 238L240 238L240 238L242 239L242 239L242 240L242 241L242 241L242 241L244 242L245 242L246 242L246 242L246 242L246 242L246 242L246 242L247 242L247 242L247 242L248 242L248 242L248 243L248 243L249 243L249 242L249 242L250 242L250 242L250 242L250 242L250 242L250 242L251 242L251 242L251 242L251 241L252 241L252 242L252 241L253 241L254 242L255 242L257 242L258 242L259 242L259 242L260 242L260 242L260 242L261 242L262 242L262 243L263 243L263 242L263 241L264 242L265 241L265 241L265 241L266 241L266 241L267 242L268 239L268 239L269 239L269 239L269 238L270 237L271 237L271 238L272 237L272 235L270 232z"
        },
        {
            "title": "Bodhan",
            "d": "M165 227L165 226L164 224L164 224L162 222L162 221L162 221L162 221L161 221L160 221L161 220L161 219L160 219L160 219L161 218L160 218L159 218L159 218L157 217L156 217L156 218L156 218L155 218L153 218L153 216L154 216L154 215L154 215L154 213L154 213L155 212L155 212L155 212L155 211L155 211L155 211L155 210L155 210L154 210L153 210L152 210L152 208L152 208L152 208L151 208L151 208L150 208L150 208L148 209L148 209L148 209L148 210L148 210L148 210L147 212L146 213L146 214L146 215L145 216L145 217L144 218L144 218L143 220L144 221L144 221L145 221L145 221L145 221L145 222L145 222L146 223L146 223L146 223L146 223L147 223L147 224L147 224L147 225L148 225L149 225L149 225L149 225L150 225L150 225L150 225L151 225L151 226L151 227L151 227L151 228L151 228L151 228L150 229L150 229L150 229L150 229L150 229L149 230L150 231L149 231L149 231L149 232L149 233L149 234L152 234L152 234L151 235L152 236L151 236L150 236L150 236L148 235L148 235L148 235L148 237L147 237L147 237L147 237L147 237L147 237L147 237L147 237L144 237L144 238L145 238L147 240L147 240L147 241L148 241L149 241L150 241L150 240L151 240L152 240L154 240L153 241L154 241L154 242L155 242L155 242L156 243L155 243L156 243L156 244L156 244L156 244L156 244L156 245L156 245L156 245L157 245L157 245L158 245L158 245L158 245L158 245L158 245L158 246L158 246L158 246L158 248L158 249L159 249L160 249L160 248L161 248L161 248L161 247L162 247L162 247L163 247L163 247L163 246L163 244L163 244L163 244L164 243L165 243L165 242L165 242L165 242L165 242L165 242L166 242L166 242L167 242L167 240L167 238L167 238L167 237L167 235L166 235L165 235L164 234L164 234L164 234L163 234L163 233L163 233L162 232L162 232L162 232L162 232L163 232L163 232L164 232L164 232L164 232L164 232L164 232L164 232L164 232L164 232L165 232L164 231L164 232L164 231L164 231L163 231L163 231L163 231L163 231L163 230L162 230L162 230L161 230L161 230L160 229L160 229L159 228L160 228L160 228L160 228L160 228L160 229L160 229L161 228L161 228L161 227L161 227L161 227L161 227L160 226L160 226L161 226L161 226L161 226L162 226L162 226L162 226L162 226L163 227L164 227L164 227L165 228L165 228L165 227L165 227z"
        },
        {
            "title": "Dharpally",
            "d": "M234 233L233 234L233 234L233 234L232 234L230 233L229 233L229 233L229 233L228 233L228 234L228 235L228 235L228 236L228 237L228 237L228 238L227 238L227 238L226 238L226 238L226 238L225 238L225 239L224 240L223 241L223 241L223 241L223 241L223 242L222 242L222 242L222 243L222 244L220 244L220 243L219 243L219 243L219 244L219 244L219 244L219 244L219 244L218 245L218 246L219 246L219 247L219 247L219 247L219 247L220 248L220 247L220 247L220 246L220 246L220 246L221 246L221 246L221 246L221 246L221 246L221 246L221 246L222 245L222 245L222 245L222 245L222 245L222 245L222 245L222 246L222 246L223 246L224 247L224 247L225 247L225 247L225 248L226 247L226 248L226 248L226 248L227 248L227 248L227 248L228 248L228 248L229 248L229 248L229 249L229 249L229 249L229 250L229 251L229 253L229 254L229 254L229 255L229 255L228 257L228 257L228 258L228 258L228 258L229 261L231 261L231 262L231 262L231 263L232 264L231 264L231 265L231 266L231 266L231 267L231 268L231 269L231 269L231 270L231 270L232 270L233 271L236 270L237 269L239 268L238 268L239 266L239 266L239 265L239 263L239 263L239 262L239 262L239 262L239 261L239 261L240 260L240 260L240 260L240 260L240 260L240 260L240 259L240 259L240 259L240 258L239 258L240 257L240 256L239 256L239 256L239 256L238 255L239 254L239 254L238 253L239 253L239 252L239 252L239 251L240 250L239 250L239 249L238 249L238 249L238 248L238 247L238 247L237 246L238 246L239 245L240 244L241 243L241 243L241 243L241 242L241 242L241 242L242 241L242 241L242 241L242 240L242 239L242 239L240 238L240 238L240 238L240 238L240 238L240 238L240 238L240 237L240 237L240 237L240 237L240 236L240 235L239 235L239 234L238 234L238 234L238 234L236 234L236 234L236 234L236 234L235 233L234 233z"
        },
        {
            "title": "Dichpally",
            "d": "M228 234L227 234L227 234L227 234L227 234L226 234L226 234L225 233L224 232L224 232L224 233L224 233L223 233L223 233L223 233L222 234L222 234L221 235L221 236L221 236L221 236L220 237L219 237L218 237L217 236L217 236L217 236L217 236L216 236L216 236L215 236L214 235L214 236L214 235L213 235L213 234L213 234L211 234L209 234L207 233L207 233L206 234L206 234L205 234L204 234L203 234L203 234L203 234L202 233L202 233L202 233L201 233L201 233L200 232L200 233L200 233L200 234L198 234L198 234L197 233L197 235L197 236L197 237L196 238L197 239L197 239L197 240L198 240L197 241L200 243L199 244L200 244L200 244L200 244L200 245L200 245L200 244L201 245L201 245L201 245L201 245L201 245L201 245L201 247L202 247L202 248L201 250L202 251L203 251L203 251L203 252L205 252L206 252L206 251L206 251L206 251L207 251L207 251L208 250L208 250L208 250L209 250L209 250L210 250L210 250L210 249L211 250L211 250L211 250L212 250L213 251L214 252L215 252L216 252L217 254L217 254L217 254L218 254L218 254L218 254L218 253L219 253L219 253L219 253L219 253L220 253L220 252L220 252L220 252L220 251L220 250L220 250L221 250L221 249L222 248L222 248L222 248L221 249L221 248L220 248L220 248L219 247L219 247L219 247L219 247L219 246L218 246L218 245L219 244L219 244L219 244L219 244L219 244L219 243L219 243L220 243L220 244L222 244L222 243L222 242L222 242L223 242L223 241L223 241L223 241L223 241L224 240L225 239L225 238L226 238L226 238L226 238L227 238L227 238L228 238L228 237L228 237L228 236L228 235L228 235L228 234z"
        },
        {
            "title": "Indalwai",
            "d": "M231 270L231 269L231 269L231 268L231 267L231 266L231 266L231 265L231 264L232 264L231 263L231 262L231 262L231 261L229 261L228 258L228 258L228 258L228 257L228 257L229 255L229 255L229 254L229 254L229 253L229 251L229 250L229 249L229 249L229 249L229 248L229 248L228 248L228 248L227 248L227 248L227 248L226 248L226 248L226 248L226 247L225 248L225 247L225 247L224 247L224 247L223 246L222 246L222 246L222 245L222 245L222 245L222 245L222 245L222 245L222 245L221 246L221 246L221 246L221 246L221 246L221 246L221 246L220 246L220 246L220 246L220 247L220 247L220 248L220 248L221 248L221 249L222 248L222 248L222 248L221 249L221 250L220 250L220 250L220 251L220 252L220 252L220 252L220 253L219 253L219 253L219 253L219 253L218 253L218 254L218 254L218 254L217 254L217 254L217 254L216 252L215 252L214 252L213 251L212 250L211 250L211 250L211 250L210 249L210 250L210 250L209 250L209 250L208 250L208 250L208 250L207 251L207 251L206 251L206 251L206 251L206 252L205 252L203 252L203 252L204 252L203 253L204 253L202 255L203 255L202 256L201 257L201 258L200 258L201 259L202 260L202 260L203 261L203 261L203 262L203 262L204 262L204 262L205 261L205 261L205 261L206 261L206 261L206 261L206 262L207 262L207 262L208 263L210 264L210 265L210 265L210 264L211 264L211 264L212 264L212 264L212 265L212 265L213 265L214 265L214 265L214 265L215 265L216 267L215 268L216 268L215 268L216 269L216 270L216 270L217 271L218 271L218 270L218 270L219 270L219 270L219 271L219 271L219 271L219 271L220 271L220 271L220 271L220 271L221 270L222 270L224 270L224 270L224 270L225 270L225 269L230 269L230 269L230 269L231 270z"
        },
        {
            "title": "Jakranpally",
            "d": "M229 219L229 219L229 219L228 219L227 219L227 218L226 218L226 217L226 216L225 216L225 215L224 215L224 215L223 216L223 216L223 217L222 217L222 218L220 218L220 218L219 218L219 218L219 218L219 218L219 218L219 219L218 219L218 219L218 219L218 219L218 219L217 219L217 219L217 219L217 220L217 221L216 220L216 221L216 221L215 221L215 220L215 220L215 220L215 219L215 218L215 218L215 218L214 217L214 216L213 216L212 215L212 215L212 215L211 215L211 215L211 215L211 215L211 216L210 216L211 216L210 217L210 217L210 218L210 220L209 221L208 222L209 222L208 222L208 223L209 224L210 225L210 225L211 226L211 227L211 227L211 227L210 228L210 229L210 230L210 230L210 230L209 230L210 231L208 232L208 232L207 232L207 232L207 233L207 233L207 233L207 233L207 233L209 234L211 234L213 234L213 234L213 235L214 235L214 236L214 235L215 236L216 236L216 236L217 236L217 236L217 236L217 236L218 237L219 237L220 237L221 236L221 236L221 236L221 235L222 234L222 234L223 233L223 233L223 233L224 233L224 233L224 232L224 232L225 233L226 234L226 234L227 234L227 234L227 234L227 234L228 234L228 233L229 233L229 233L229 233L230 233L232 234L233 234L233 234L233 234L234 233L234 233L233 232L233 232L233 231L233 230L233 230L233 229L232 229L231 229L231 229L231 229L230 229L230 228L230 228L230 226L230 226L230 225L231 224L230 224L230 223L230 223L229 223L229 223L229 221L229 219z"
        },
        {
            "title": "Pothangal",
            "d": "M143 236L143 235L143 234L141 233L141 233L141 233L140 233L139 233L138 233L137 233L137 233L137 233L137 233L137 233L137 233L136 233L136 233L136 233L136 234L135 235L135 236L134 236L132 236L130 236L130 236L130 236L130 236L130 237L130 237L131 238L131 239L132 240L132 240L132 241L132 241L132 243L132 243L132 244L133 245L133 246L132 246L132 247L132 248L131 248L131 249L131 250L130 250L131 251L132 251L132 251L133 252L133 252L134 254L134 255L135 257L135 258L134 259L134 261L136 261L136 261L136 260L136 260L136 260L136 260L136 260L137 260L138 260L138 260L138 259L138 259L139 259L139 259L139 259L140 259L140 258L140 257L141 257L141 257L140 257L140 256L140 256L140 256L140 256L140 256L141 255L141 255L141 254L141 254L141 254L141 254L142 254L142 253L142 253L141 252L141 252L141 252L139 252L139 251L139 250L139 250L139 250L140 250L141 250L140 249L140 247L140 247L140 247L139 246L139 245L139 244L140 244L140 244L140 244L140 244L141 244L141 243L141 243L141 243L141 242L140 242L140 242L140 242L140 241L140 241L140 241L139 240L139 240L140 240L141 239L141 239L141 239L142 238L142 237L141 237L141 236L142 236L143 236z"
        },
        {
            "title": "Makloor",
            "d": "M198 209L198 209L196 209L196 208L196 208L196 208L195 208L195 207L195 207L195 207L196 206L196 205L196 205L194 205L193 205L193 204L191 204L191 203L190 203L189 203L189 203L188 203L187 202L187 202L187 202L186 202L186 202L185 201L185 202L185 201L185 202L185 202L184 203L184 204L185 204L185 204L184 204L184 204L184 204L184 205L184 205L184 205L184 206L184 207L184 207L184 207L184 207L184 207L185 207L185 208L185 208L185 209L186 209L186 209L187 210L187 210L187 211L187 211L187 212L187 212L187 212L187 213L187 213L188 213L188 213L188 214L189 214L189 214L189 215L189 215L189 217L189 217L190 217L190 217L190 217L190 218L191 219L191 219L191 220L192 221L192 222L192 223L192 223L192 223L192 223L193 223L193 223L193 224L193 224L194 224L194 225L195 225L195 226L195 226L195 226L195 227L195 227L195 228L195 228L196 228L196 228L196 228L196 228L196 228L197 228L197 229L198 229L198 229L198 230L199 230L199 231L199 231L200 231L200 231L200 232L200 232L201 232L201 232L201 233L201 233L202 233L202 233L202 233L203 234L203 234L203 234L204 234L205 234L206 234L206 234L207 233L207 233L207 233L207 233L207 233L207 233L207 232L207 232L208 232L208 232L210 231L209 230L210 230L210 230L210 230L210 229L210 228L211 227L211 227L211 227L211 226L210 225L210 225L209 224L208 223L208 222L209 222L208 222L209 221L208 221L208 220L208 220L208 220L208 220L208 219L207 219L206 219L205 219L205 219L205 219L205 218L204 218L204 218L203 218L203 217L202 217L201 217L201 217L200 216L199 215L199 215L198 214L198 213L198 213L198 212L198 212L198 211L198 210L198 210L198 209L198 209z"
        },
        {
            "title": "Mendora",
            "d": "M242 176L241 176L240 176L240 176L240 176L239 176L239 177L238 177L238 177L237 177L235 178L233 179L233 179L233 179L232 179L232 179L232 180L232 181L231 182L232 183L232 183L232 183L232 184L232 184L234 185L234 185L234 186L233 186L233 186L233 186L233 187L233 187L233 187L233 187L233 188L233 188L234 188L234 188L234 188L234 188L234 189L235 189L234 189L234 189L235 189L235 189L235 189L236 189L236 189L236 189L236 188L236 188L237 188L237 188L237 188L237 188L238 188L238 189L238 189L238 190L239 190L239 190L239 190L240 190L240 190L240 190L240 190L240 190L240 190L240 190L241 190L241 190L241 190L241 191L241 191L242 191L242 191L242 191L242 191L242 191L242 191L243 191L243 191L243 191L243 192L244 192L244 191L244 191L244 191L245 192L245 192L246 192L246 192L246 192L246 192L247 192L249 192L249 192L249 191L248 191L247 190L247 189L247 189L248 188L249 186L250 185L249 184L247 183L246 182L245 182L245 181L244 179L243 177L243 177L242 176L242 176z"
        },
        {
            "title": "Morthad",
            "d": "M246 196L246 195L246 195L246 195L245 195L245 195L245 195L244 195L244 196L243 196L243 196L243 196L243 196L242 196L242 197L241 197L241 197L241 198L240 198L240 199L240 199L240 199L240 199L239 201L240 202L240 202L240 202L240 202L240 202L242 203L242 203L242 203L242 204L242 205L242 205L242 206L241 206L241 206L241 207L241 207L240 207L240 207L240 207L240 207L240 207L240 207L240 208L240 208L240 208L240 208L240 209L240 209L241 209L242 209L243 210L245 210L245 210L245 210L245 210L245 211L245 211L244 212L244 213L243 213L243 214L243 215L244 215L244 215L245 215L246 215L246 215L246 215L247 216L250 215L251 215L251 217L252 219L252 219L252 219L252 219L253 217L254 217L255 216L255 213L256 213L256 213L256 212L256 212L256 212L257 213L258 213L258 213L258 213L258 213L258 213L258 213L258 212L258 212L258 211L258 211L257 211L257 211L257 211L257 210L257 210L256 210L256 210L256 210L256 210L256 209L256 209L257 209L257 209L257 209L257 208L257 208L257 207L256 207L255 207L256 206L256 206L255 205L256 204L256 204L256 204L256 203L256 203L256 203L256 203L256 202L256 202L256 201L256 201L256 201L256 201L255 200L255 200L255 200L255 199L255 198L255 198L255 197L256 197L256 197L256 197L255 197L255 196L255 196L255 196L254 196L254 195L254 196L254 196L254 196L252 196L252 196L252 197L252 197L251 197L251 197L251 197L250 198L249 198L249 199L248 199L248 199L248 199L247 199L246 199L246 197L246 196z"
        },
        {
            "title": "Mugpal",
            "d": "M193 235L193 235L193 235L192 236L192 237L192 237L192 238L191 238L191 237L191 237L191 237L191 237L191 237L190 237L189 238L189 238L189 238L189 238L189 238L189 239L189 239L188 238L188 240L188 241L188 242L188 242L188 243L186 244L186 244L185 244L185 244L185 244L183 247L183 247L182 247L182 246L181 246L181 246L180 246L181 247L181 247L182 247L182 249L181 249L181 250L182 251L182 252L182 253L182 254L182 254L182 255L182 255L182 255L181 255L180 257L180 258L180 258L180 258L180 259L180 259L180 260L180 260L179 260L179 260L179 261L179 261L180 262L179 262L179 262L180 263L180 263L180 264L180 264L181 264L181 263L182 262L183 263L183 262L184 261L186 261L186 261L187 262L187 262L187 262L188 262L188 262L188 262L189 262L189 262L190 263L190 263L190 263L190 264L191 264L191 264L192 264L193 264L193 264L193 264L194 264L194 264L195 265L195 265L196 265L196 265L196 266L198 266L199 266L200 266L201 265L201 265L201 264L202 264L202 263L203 262L203 262L203 261L203 261L202 260L202 260L201 259L200 258L201 258L201 257L202 256L203 255L202 255L204 253L203 253L204 252L203 252L203 252L203 251L203 251L202 251L201 250L202 248L202 247L201 247L201 245L201 245L201 245L201 245L201 245L201 245L200 244L200 245L200 245L200 244L200 244L200 244L199 244L200 243L197 241L198 240L197 240L197 239L197 239L196 238L197 237L197 236L196 236L194 235L194 235L193 235z"
        },
        {
            "title": "Mupkal",
            "d": "M231 182L230 182L231 181L230 182L229 182L229 183L229 183L229 183L229 184L230 184L229 185L230 185L230 185L230 185L230 185L231 185L230 185L230 185L230 186L231 186L231 187L231 187L231 187L231 188L231 189L231 191L231 191L231 192L231 192L231 192L232 192L232 192L232 192L232 193L233 193L233 193L233 193L233 193L233 194L233 194L232 194L232 195L232 195L232 195L232 195L232 195L232 195L233 195L234 195L234 196L234 196L234 197L234 198L235 198L235 197L236 198L237 197L237 197L238 197L239 198L239 198L239 198L240 199L240 199L240 199L240 198L241 198L241 197L241 197L242 197L242 196L243 196L243 196L243 196L243 196L244 196L244 195L245 195L245 195L245 195L246 195L246 195L246 195L246 196L247 195L249 194L249 193L249 193L249 192L249 192L247 192L246 192L246 192L246 192L246 192L245 192L245 192L244 191L244 191L244 191L244 192L243 192L243 191L243 191L243 191L242 191L242 191L242 191L242 191L242 191L242 191L241 191L241 191L241 190L241 190L241 190L240 190L240 190L240 190L240 190L240 190L240 190L240 190L239 190L239 190L239 190L238 190L238 189L238 189L238 188L237 188L237 188L237 188L237 188L236 188L236 188L236 189L236 189L236 189L235 189L235 189L235 189L234 189L234 189L235 189L234 189L234 188L234 188L234 188L234 188L233 188L233 188L233 187L233 187L233 187L233 187L233 186L233 186L233 186L234 186L234 185L234 185L232 184L232 184L232 183L232 183L232 183L231 182z"
        },
        {
            "title": "Nandipet",
            "d": "M213 193L212 193L212 193L212 193L212 192L211 193L211 193L210 193L210 193L209 193L208 193L208 193L207 193L207 194L207 194L206 194L206 195L205 195L205 195L205 194L205 194L204 194L204 194L204 194L204 194L204 194L204 194L204 193L204 193L203 193L203 193L203 193L203 193L203 193L202 193L202 192L202 192L202 192L201 192L200 191L200 190L199 190L199 189L199 189L199 189L199 189L200 188L200 188L199 188L200 188L200 188L200 186L199 186L199 186L199 185L199 185L199 185L198 182L197 183L197 183L196 183L194 183L193 183L192 184L191 185L190 186L190 186L189 186L189 187L189 187L189 188L189 188L188 188L188 188L188 189L187 190L187 190L187 190L187 190L187 190L189 191L188 191L188 191L188 192L188 192L188 193L188 193L188 195L188 195L188 195L187 196L187 196L188 196L188 197L188 197L187 198L187 198L186 198L186 198L187 199L187 199L186 200L186 200L186 200L185 201L185 201L185 202L185 201L186 202L186 202L187 202L187 202L187 202L188 203L189 203L189 203L190 203L191 203L191 204L193 204L193 205L194 205L196 205L196 205L196 206L195 207L195 207L195 207L195 208L196 208L196 208L196 208L196 209L198 209L198 209L198 209L198 209L198 209L200 209L200 209L200 209L203 209L203 209L203 209L204 209L204 209L204 209L205 207L205 205L204 205L204 205L203 204L203 204L203 203L203 202L203 201L204 201L205 201L205 200L206 199L207 198L207 198L208 198L208 198L209 199L209 199L210 199L211 200L211 200L211 199L211 199L212 199L212 199L213 199L213 198L214 198L214 198L214 197L214 197L214 197L213 196L213 196L213 196L213 196L213 196L212 195L212 195L213 194L213 193zM220 180L221 179L221 179L221 178L220 177L218 176L217 176L216 179L215 180L215 181L215 183L215 184L214 184L215 184L214 184L214 184L215 185L215 185L215 185L215 187L215 187L214 189L214 189L214 189L215 189L217 190L218 190L218 190L219 187L220 186L219 186L220 185L220 185L220 184L220 182L220 181L220 180z"
        },
        {
            "title": "Navipet",
            "d": "M189 186L187 186L186 186L184 186L184 186L183 186L183 186L183 187L182 188L181 192L181 195L181 197L181 197L180 197L180 197L179 197L178 197L178 196L177 196L176 196L173 197L171 197L169 198L168 199L167 201L166 202L166 202L166 202L166 203L166 204L166 205L166 205L165 205L165 206L165 206L166 207L166 208L166 208L166 208L166 209L166 209L166 209L167 210L167 210L168 210L168 210L169 210L169 210L169 211L168 213L170 213L170 213L171 214L172 214L172 214L172 214L172 215L173 215L173 214L174 214L174 215L174 216L173 216L173 216L172 216L172 217L173 217L174 217L174 217L174 217L174 217L175 220L175 220L175 221L175 221L174 222L174 222L175 222L176 223L178 224L178 223L178 223L178 222L179 222L179 221L179 220L180 220L182 221L183 221L182 222L183 222L184 222L184 222L184 222L184 222L184 222L185 222L185 221L185 221L185 221L185 221L185 222L186 222L186 222L186 221L186 220L186 220L186 220L185 220L185 220L185 220L185 220L183 220L183 219L183 219L184 218L185 217L185 217L185 217L185 217L185 216L185 216L185 215L185 215L185 214L186 213L186 212L186 212L186 212L187 212L187 212L187 212L187 212L187 211L187 211L187 210L187 210L186 209L186 209L185 209L185 208L185 208L185 207L184 207L184 207L184 207L184 207L184 207L184 206L184 205L184 205L184 205L184 204L184 204L184 204L185 204L185 204L184 204L184 203L185 202L185 202L185 201L185 201L186 200L186 200L186 200L187 199L187 199L186 198L186 198L187 198L187 198L188 197L188 197L188 196L187 196L187 196L188 195L188 195L188 195L188 193L188 193L188 192L188 192L188 191L188 191L189 191L187 190L187 190L187 190L187 190L187 190L188 189L188 188L188 188L189 188L189 188L189 187L189 187L189 186z"
        },
        {
            "title": "Nizamabad Rural",
            "d": "M201 233L201 232L201 232L200 232L200 232L200 231L200 231L199 231L199 231L199 230L198 230L198 229L198 229L197 229L197 228L196 228L196 228L196 228L196 228L196 228L195 228L194 229L194 230L194 231L194 231L194 231L194 231L194 231L194 231L194 231L193 231L194 231L193 232L193 233L193 233L193 234L193 234L193 234L193 235L194 235L194 235L196 236L197 236L197 235L197 233L198 234L198 234L200 234L200 233L200 233L200 232L201 233zM187 212L187 212L186 212L186 212L186 212L186 213L185 214L185 215L185 215L185 216L185 216L185 217L185 217L185 217L185 217L184 218L183 219L183 219L183 220L185 220L185 220L185 220L185 220L186 220L186 220L186 220L186 221L186 222L186 222L185 222L185 221L185 221L185 221L185 221L185 222L184 222L184 222L184 222L184 222L184 222L183 222L182 222L183 221L182 221L180 220L179 220L179 221L179 222L178 222L178 223L178 223L178 224L178 224L179 225L180 225L181 225L181 225L181 225L181 226L181 227L181 227L180 228L180 228L179 228L179 228L179 228L179 229L179 229L179 229L179 231L179 232L179 233L179 234L179 235L179 235L179 236L178 237L178 237L178 238L177 239L177 240L177 241L173 240L172 240L172 240L172 240L172 240L172 241L171 240L171 241L172 241L172 242L172 243L172 244L172 244L173 245L173 247L174 248L175 251L176 250L176 250L176 250L176 249L176 249L176 248L177 248L177 248L177 248L179 246L180 246L180 246L181 246L181 246L182 246L182 247L183 247L183 247L185 244L185 244L185 244L186 244L186 244L188 243L188 242L188 242L188 241L188 240L188 238L186 238L186 238L186 238L186 237L186 237L185 237L183 237L182 236L182 236L181 235L182 235L183 235L183 234L183 233L183 232L182 231L183 230L183 229L184 229L184 229L185 229L186 229L186 229L186 229L187 229L188 229L188 229L189 229L189 229L189 229L190 229L190 229L190 229L190 228L191 228L191 227L192 227L193 227L194 228L194 228L195 228L195 227L195 227L195 226L195 226L195 226L195 225L194 225L194 224L193 224L193 224L193 223L193 223L192 223L192 223L192 223L192 223L192 222L192 221L191 220L191 219L191 219L190 218L190 217L190 217L190 217L189 217L189 217L189 215L189 215L189 214L189 214L188 214L188 213L188 213L187 213L187 213L187 212z"
        },
        {
            "title": "Nizamabad South",
            "d": "M194 230L193 231L193 231L193 231L193 231L193 231L192 231L192 231L192 230L191 230L191 229L191 229L191 228L191 228L190 228L190 229L190 229L190 229L189 229L189 229L189 229L188 229L188 229L187 229L186 229L186 229L186 229L186 229L186 229L186 230L186 231L186 231L185 231L185 231L185 231L184 231L183 232L183 233L183 234L183 235L182 235L181 235L182 236L182 236L183 237L185 237L186 237L186 237L186 238L186 238L186 238L188 238L189 239L189 239L189 238L189 238L189 238L189 238L189 238L190 237L191 237L191 237L191 237L191 237L191 237L191 238L192 238L192 237L192 237L192 236L193 235L193 235L193 235L193 234L193 234L193 234L193 233L193 233L193 232L194 231L193 231L194 231L194 231L194 231L194 231L194 231L194 231L194 231L194 230z"
        },
        {
            "title": "Renjal",
            "d": "M165 205L165 206L163 206L160 205L159 205L157 206L156 206L156 206L155 207L153 207L152 208L152 208L152 208L152 208L152 210L153 210L154 210L155 210L155 210L155 211L155 211L155 211L155 212L155 212L155 212L154 213L154 213L154 215L154 215L154 216L153 216L153 218L155 218L156 218L156 218L156 217L157 217L159 218L159 218L160 218L161 218L160 219L160 219L161 219L161 220L160 221L161 221L162 221L162 221L162 221L162 222L164 224L164 224L165 226L165 227L166 227L166 226L167 226L167 226L167 225L167 225L166 225L166 224L166 224L166 224L166 224L166 224L166 224L167 223L167 223L167 223L167 223L167 223L167 223L167 223L167 223L168 223L168 223L168 223L168 223L169 223L169 223L169 224L170 224L169 224L170 224L170 225L171 225L172 225L173 225L173 225L173 225L173 225L174 225L174 225L174 225L175 225L175 224L175 222L174 222L174 222L175 221L175 221L175 220L175 220L174 217L174 217L174 217L174 217L173 217L172 217L172 216L173 216L173 216L174 216L174 215L174 214L173 214L173 215L172 215L172 214L172 214L172 214L171 214L170 213L170 213L168 213L169 211L169 210L169 210L168 210L168 210L167 210L167 210L166 209L166 209L166 209L166 208L166 208L166 208L166 207L165 206L165 206L165 205z"
        },
        {
            "title": "Rudrur",
            "d": "M159 249L158 249L158 248L158 246L158 246L158 246L158 245L158 245L158 245L158 245L158 245L157 245L157 245L156 245L156 245L156 245L156 244L156 244L156 244L156 244L156 243L155 243L156 243L155 242L155 242L154 242L154 241L153 241L154 240L152 240L151 240L150 240L150 241L149 241L148 241L147 241L147 242L147 243L146 244L146 244L148 245L150 246L150 248L147 248L147 249L147 250L147 250L147 250L147 250L148 250L148 251L149 252L149 252L149 253L149 253L150 253L150 253L150 253L151 253L151 253L151 253L151 254L152 254L152 255L151 255L151 256L152 256L152 256L152 256L152 256L152 256L152 256L153 256L154 258L154 257L154 256L154 255L154 253L157 251L157 251L157 251L157 251L158 251L158 251L158 250L159 249z"
        },
        {
            "title": "Sirikonda",
            "d": "M262 243L262 242L261 242L260 242L260 242L260 242L259 242L259 242L258 242L257 242L255 242L254 242L253 241L252 241L252 242L252 241L251 241L251 242L251 242L251 242L250 242L250 242L250 242L250 242L250 242L250 242L249 242L249 242L249 243L248 243L248 243L248 242L248 242L247 242L247 242L247 242L246 242L246 242L246 242L246 242L246 242L246 242L245 242L244 242L242 241L241 242L241 242L241 242L241 243L241 243L241 243L240 244L239 245L238 246L237 246L238 247L238 247L238 248L238 249L238 249L239 249L239 250L240 250L239 251L239 252L239 252L239 253L238 253L239 254L239 254L238 255L239 256L239 256L239 256L240 256L240 257L239 258L240 258L240 259L240 259L240 259L240 260L240 260L240 260L240 260L240 260L240 260L239 261L239 261L239 262L239 262L239 262L239 263L239 263L239 265L239 266L241 266L242 267L243 267L244 267L245 267L246 267L247 267L250 270L251 272L251 272L251 273L252 274L252 274L254 274L254 274L254 274L255 273L256 272L257 272L257 271L258 271L258 271L258 270L258 270L258 269L259 269L259 269L260 269L260 268L259 266L257 265L257 265L258 264L258 262L258 262L260 257L262 258L262 257L262 257L265 259L265 258L266 257L267 256L267 256L268 255L268 255L271 255L272 255L272 255L274 249L274 248L274 248L276 248L273 246L273 246L272 245L272 245L271 245L270 245L269 245L267 246L264 246L264 245L264 244L263 244L262 243z"
        },
        {
            "title": "Vailpur",
            "d": "M252 219L252 219L252 219L251 217L251 215L250 215L247 216L246 215L246 215L246 215L245 215L244 215L244 215L243 215L243 214L243 213L244 213L244 212L245 211L245 211L245 210L245 210L245 210L245 210L243 210L242 209L241 209L240 209L240 209L240 208L240 208L240 208L240 208L240 207L240 207L240 207L240 207L240 207L240 207L241 207L241 207L241 206L241 206L242 206L242 205L242 205L242 204L242 203L242 203L242 203L240 202L240 203L239 203L239 204L239 204L239 204L239 204L239 204L239 205L239 205L238 205L238 205L238 205L238 205L238 204L237 204L237 204L236 204L235 204L235 203L234 203L233 203L233 204L233 205L233 206L233 206L232 207L232 208L232 208L233 210L233 210L232 210L232 210L232 210L232 210L232 210L232 211L231 211L231 212L231 213L230 213L230 214L230 215L230 215L231 215L231 215L232 216L232 217L232 217L231 217L231 218L230 219L230 219L230 219L229 219L229 219L229 221L229 223L229 223L230 223L230 223L230 224L231 224L230 225L230 226L230 226L230 228L230 228L230 229L231 229L231 229L231 229L232 229L233 229L233 229L233 229L233 229L234 229L235 226L235 226L235 226L235 225L235 225L236 225L237 225L237 224L237 224L238 225L238 225L239 225L239 225L239 226L239 226L239 226L239 226L239 226L239 226L239 227L239 227L239 227L240 227L240 227L242 227L244 228L244 227L245 227L245 226L244 225L243 225L244 225L244 225L244 224L244 224L244 224L245 224L245 222L246 220L247 220L249 219L250 220L250 219L251 220L251 220L252 219L252 219z"
        },
        {
            "title": "Varni",
            "d": "M160 249L159 249L158 250L158 251L158 251L157 251L157 251L157 251L157 251L154 253L154 255L154 256L154 257L154 258L153 256L152 256L152 256L152 256L152 256L152 256L152 256L151 256L151 255L152 255L152 254L151 254L151 253L151 253L151 253L150 253L150 253L150 253L149 253L149 254L149 255L149 255L148 256L148 257L148 258L148 258L149 260L149 261L150 261L151 260L154 262L155 262L156 262L157 263L158 263L159 263L160 263L163 263L165 264L168 266L169 267L169 268L169 268L169 268L170 269L169 270L169 271L171 271L172 272L174 273L175 273L176 273L177 273L177 273L178 273L177 272L178 271L178 271L178 270L178 270L179 270L179 270L179 269L179 267L179 266L179 266L179 265L180 265L180 265L180 264L180 264L180 263L180 263L180 263L179 262L178 262L175 261L174 260L173 259L169 257L168 256L168 255L167 255L166 255L165 254L163 252L163 252L163 252L163 251L162 250L161 250L161 249L160 249z"
        },
        {
            "title": "Yedapally",
            "d": "M171 240L172 241L172 240L172 240L172 240L172 240L173 240L177 241L177 240L177 239L178 238L178 237L178 237L179 236L179 235L179 235L179 234L179 233L179 232L179 231L179 229L179 229L179 229L179 228L179 228L179 228L180 228L180 228L181 227L181 227L181 226L181 225L181 225L181 225L180 225L179 225L178 224L178 224L176 223L175 222L175 224L175 225L174 225L174 225L174 225L173 225L173 225L173 225L173 225L172 225L171 225L170 225L170 224L169 224L170 224L169 224L169 223L169 223L168 223L168 223L168 223L168 223L167 223L167 223L167 223L167 223L167 223L167 223L167 223L167 223L166 224L166 224L166 224L166 224L166 224L166 224L166 225L167 225L167 225L167 226L167 226L166 226L166 227L165 227L165 227L165 228L165 228L164 227L164 227L163 227L162 226L162 226L162 226L162 226L161 226L161 226L161 226L160 226L160 226L161 227L161 227L161 227L161 227L161 228L161 228L160 229L160 229L160 228L160 228L160 228L160 228L159 228L160 229L160 229L161 230L161 230L162 230L162 230L163 230L163 231L163 231L163 231L163 231L164 231L164 231L164 232L164 231L165 232L164 232L164 232L164 232L164 232L164 232L164 232L164 232L164 232L163 232L163 232L162 232L162 232L162 232L162 232L163 233L163 233L163 234L164 234L164 234L164 234L165 235L166 235L167 235L167 237L167 238L167 238L168 238L168 238L169 238L170 238L170 238L170 238L170 239L171 239L171 240L171 240L171 240L171 240L171 240z"
        },
        {
            "title": "Yergatla",
            "d": "M258 182L257 182L257 182L256 182L255 182L254 183L253 184L252 184L252 184L251 184L250 185L250 185L249 186L248 188L247 189L247 189L247 190L248 191L249 191L249 192L249 193L249 193L249 194L247 195L246 196L246 197L246 199L247 199L248 199L248 199L248 199L249 199L249 198L250 198L251 197L251 197L251 197L252 197L252 197L252 196L252 196L254 196L254 196L254 196L254 195L254 196L255 196L255 196L255 196L255 197L256 197L256 197L257 195L258 194L258 194L260 194L260 192L260 192L260 192L260 192L260 190L260 190L260 190L261 190L261 189L261 189L261 189L261 189L261 188L261 187L261 187L261 187L261 187L262 187L263 187L263 187L263 186L263 186L261 186L261 185L261 185L260 184L260 184L259 184L259 183L258 182z"
        },
        {
            "title": "Kammarpally",
            "d": "M265 258L265 259L262 257L262 257L262 258L260 257L258 262L258 262L258 264L257 265L257 265L259 266L260 268L261 268L262 264L265 261L265 258zM270 237L269 238L269 239L269 239L268 239L268 239L267 242L266 241L266 241L265 241L265 241L265 241L264 242L263 241L263 242L263 243L262 243L263 244L264 244L264 245L264 246L267 246L269 245L270 245L271 245L272 245L272 245L273 246L271 243L269 240L270 237zM263 204L263 203L263 202L263 202L263 202L263 201L263 201L263 201L263 200L263 200L263 198L263 198L263 197L263 196L262 196L262 196L261 195L260 195L260 194L258 194L258 194L257 195L256 197L256 197L255 197L255 198L255 198L255 199L255 200L255 200L255 200L256 201L256 201L256 201L256 201L256 202L256 202L256 203L256 203L256 203L256 203L256 204L256 204L256 204L255 205L256 206L256 206L255 207L256 207L257 207L257 208L257 208L257 209L257 209L257 209L256 209L256 209L256 210L256 210L256 210L256 210L257 210L257 210L257 211L257 211L257 211L258 211L258 211L258 212L258 212L258 213L258 213L258 213L258 213L258 213L258 213L257 213L256 212L256 212L256 212L256 213L256 213L255 213L255 216L254 217L253 217L252 219L252 219L253 220L255 221L256 221L257 221L257 221L257 221L258 224L258 224L258 225L258 225L259 225L260 226L260 226L261 226L260 226L260 227L261 228L261 228L261 228L261 228L261 228L261 229L262 229L262 230L263 230L264 231L265 231L265 231L266 231L267 232L268 231L269 232L270 232L276 231L278 231L278 231L278 231L279 231L279 231L279 231L279 230L279 229L279 228L279 227L279 226L279 225L278 225L277 224L276 224L276 224L276 224L276 224L276 224L275 224L275 224L275 224L270 225L270 225L269 224L269 224L268 222L266 222L265 222L265 221L265 220L265 219L265 219L265 217L266 217L266 216L266 215L267 214L266 214L266 214L266 213L265 213L265 213L265 212L266 212L265 211L265 211L265 209L265 209L264 209L264 209L263 208L264 207L264 206L264 206L263 205L263 204L263 204L263 204z"
        },
        {
            "title": "Mosra",
            "d": "M180 257L181 255L182 255L182 255L182 255L182 254L182 254L182 253L182 252L182 251L181 250L181 249L182 249L182 247L181 247L181 247L180 246L180 246L179 246L177 248L177 248L177 248L176 248L176 249L176 249L176 250L176 250L176 250L175 251L174 248L173 247L173 245L172 244L172 244L172 243L172 242L172 241L171 241L171 240L171 240L171 240L171 240L171 240L171 239L170 239L170 238L170 238L170 238L169 238L168 238L168 238L167 238L167 240L167 242L166 242L166 242L165 242L165 242L165 242L165 242L165 242L165 243L164 243L163 244L163 244L163 244L163 246L164 247L165 247L165 247L165 247L166 247L167 247L167 247L167 247L168 247L168 247L168 247L168 248L168 248L168 248L168 248L168 249L168 249L168 249L169 249L169 249L169 249L169 250L169 249L169 250L169 250L169 250L169 250L170 250L170 250L170 251L170 251L170 251L171 252L171 252L172 252L172 252L174 253L175 252L176 254L176 255L177 256L177 256L178 256L178 256L178 257L178 257L179 257L179 257L180 257z"
        },
        {
            "title": "Chandur",
            "d": "M180 263L179 262L179 262L180 262L179 261L179 261L179 260L179 260L180 260L180 260L180 259L180 259L180 258L180 258L180 258L180 257L179 257L179 257L178 257L178 257L178 256L178 256L177 256L177 256L176 255L176 254L175 252L174 253L172 252L172 252L171 252L171 252L170 251L170 251L170 251L170 250L170 250L169 250L169 250L169 250L169 250L169 249L169 250L169 249L169 249L169 249L168 249L168 249L168 249L168 248L168 248L168 248L168 248L168 247L168 247L168 247L167 247L167 247L167 247L166 247L165 247L165 247L165 247L164 247L163 246L163 247L163 247L162 247L162 247L161 247L161 248L161 248L160 248L160 249L161 249L161 250L162 250L163 251L163 252L163 252L163 252L165 254L166 255L167 255L168 255L168 256L169 257L173 259L174 260L175 261L178 262L179 262L180 263L180 263z"
        },
        {
            "title": "Aloor",
            "d": "M213 198L213 199L212 199L212 199L211 199L211 199L211 200L211 200L210 199L209 199L209 199L208 198L208 198L207 198L207 198L206 199L205 200L205 201L204 201L203 201L203 202L203 203L203 204L203 204L204 205L204 205L205 205L205 207L204 209L204 209L204 209L203 209L203 209L203 209L200 209L200 209L200 209L198 209L198 209L198 209L198 209L198 209L198 210L198 210L198 211L198 212L198 212L198 213L198 213L198 214L199 215L199 215L200 216L201 217L201 217L202 217L203 217L203 218L204 218L204 218L205 218L205 219L205 219L205 219L206 219L207 219L208 219L208 220L208 220L208 220L208 220L208 221L209 221L210 220L210 218L210 217L210 217L211 216L210 216L211 216L211 215L211 215L211 215L211 215L212 215L211 214L212 214L211 213L211 213L212 213L212 212L211 212L211 212L211 211L212 211L212 211L211 209L211 209L211 209L211 209L211 209L212 208L212 208L212 208L213 207L213 206L213 206L213 206L213 205L213 204L214 204L214 203L214 203L215 202L215 201L215 201L215 200L215 200L215 200L214 199L213 198z"
        },
        {
            "title": "Donkeshwar",
            "d": "M218 176L216 174L215 174L214 174L214 174L214 174L214 174L213 175L212 175L211 175L209 176L206 177L206 177L204 176L203 176L203 176L202 177L201 178L201 180L199 182L198 182L199 185L199 185L199 185L199 186L199 186L200 186L200 188L200 188L199 188L200 188L200 188L199 189L199 189L199 189L199 189L199 190L200 190L200 191L201 192L202 192L202 192L202 192L202 193L203 193L203 193L203 193L203 193L203 193L204 193L204 193L204 194L204 194L204 194L204 194L204 194L204 194L205 194L205 194L205 195L205 195L206 195L206 194L207 194L207 194L207 193L208 193L208 193L209 193L210 193L210 193L211 193L211 193L212 192L212 193L212 193L212 193L213 193L214 193L214 193L215 192L215 192L216 192L216 192L217 190L215 189L214 189L214 189L214 189L215 187L215 187L215 185L215 185L215 185L214 184L214 184L215 184L214 184L215 184L215 183L215 181L215 180L216 179L217 176L218 176z"
        },
        {
            "title": "Saloora",
            "d": "M144 237L147 237L147 237L147 237L147 237L147 237L147 237L147 237L148 237L148 235L148 235L148 235L150 236L150 236L151 236L152 236L151 235L152 234L152 234L149 234L149 233L149 232L149 231L149 231L150 231L149 230L150 229L150 229L150 229L150 229L150 229L151 228L151 228L151 228L151 227L151 227L151 226L151 225L150 225L150 225L150 225L149 225L149 225L149 225L148 225L147 225L147 224L147 224L147 223L146 223L146 223L146 223L146 223L145 222L145 222L145 221L145 221L145 221L144 221L144 221L143 220L143 221L142 222L142 222L142 224L142 225L141 226L140 226L140 227L140 227L140 228L140 227L139 228L139 228L140 229L139 229L139 229L139 230L137 229L137 229L136 229L137 227L136 227L136 226L136 226L136 226L135 225L135 226L134 226L134 227L133 227L133 227L133 228L133 229L133 229L133 230L132 230L132 230L132 231L131 231L131 231L130 232L130 232L130 233L130 233L130 233L130 233L131 233L130 234L130 234L130 234L130 235L130 236L132 236L134 236L135 236L135 235L136 234L136 233L136 233L136 233L137 233L137 233L137 233L137 233L137 233L137 233L138 233L139 233L140 233L141 233L141 233L141 233L143 234L143 235L143 236L143 236L144 236L144 237L144 237z"
        },
        {
            "title": "Kotagiri",
            "d": "M143 236L142 236L141 236L141 237L142 237L142 238L141 239L141 239L141 239L140 240L139 240L139 240L140 241L140 241L140 241L140 242L140 242L140 242L141 242L141 243L141 243L141 243L141 244L140 244L140 244L140 244L140 244L139 244L139 245L139 246L140 247L140 247L140 247L140 249L141 250L140 250L139 250L139 250L139 250L139 251L139 252L141 252L141 252L141 252L142 253L142 253L142 254L141 254L141 254L141 254L141 254L141 255L141 255L140 256L140 256L140 256L140 256L140 256L140 257L141 257L141 257L140 257L140 258L140 259L139 259L139 259L139 259L138 259L138 259L138 260L138 260L137 260L136 260L136 260L136 260L136 260L136 260L137 261L138 261L138 261L138 261L138 261L139 262L139 262L139 262L139 262L140 261L141 261L141 261L141 261L142 261L142 261L144 261L144 261L144 261L144 261L144 261L145 261L145 261L146 261L146 261L146 261L147 260L149 260L148 258L148 258L148 257L148 256L149 255L149 255L149 254L149 253L149 253L149 252L149 252L148 251L148 250L147 250L147 250L147 250L147 250L147 249L147 248L150 248L150 246L148 245L146 244L146 244L147 243L147 242L147 241L147 240L147 240L145 238L144 238L144 237L144 237L144 236L143 236L143 236z"
        },
        {
            "title": "Nizamabad North",
            "d": "M195 228L194 228L194 228L193 227L192 227L191 227L191 228L191 228L191 229L191 229L191 230L192 230L192 231L192 231L193 231L193 231L193 231L193 231L193 231L194 230L194 229L195 228L195 228zM186 229L185 229L184 229L184 229L183 229L183 230L182 231L183 232L184 231L185 231L185 231L185 231L186 231L186 231L186 230L186 229L186 229L186 229z"
        }
    ],
    "Kumurambheem Asifabad": [
        {
            "title": "Asifabad",
            "d": "M402 110L402 110L401 111L401 111L400 112L400 112L400 112L400 113L400 113L400 113L399 113L399 113L398 113L396 112L397 112L396 112L396 112L396 112L396 111L396 111L396 110L396 110L396 110L395 110L395 110L395 110L395 110L394 110L394 109L393 110L393 110L393 110L393 110L392 110L392 111L392 112L393 112L392 112L391 111L391 111L390 110L390 110L389 110L389 110L389 110L389 109L389 109L389 109L388 108L387 107L387 107L387 106L387 105L387 105L387 105L386 105L386 105L385 105L384 104L383 104L382 103L381 103L380 103L380 103L380 103L379 103L379 103L378 102L377 102L377 102L376 102L376 101L375 101L374 101L374 102L373 102L373 103L373 103L373 105L373 105L373 106L373 106L372 106L373 106L373 107L372 107L372 107L372 108L372 108L372 109L371 110L371 110L371 110L370 110L370 111L370 111L369 112L370 112L370 112L371 113L371 114L372 115L372 115L373 115L371 115L370 115L370 115L369 116L369 115L368 115L367 115L367 116L366 116L366 116L366 116L366 116L366 116L366 116L366 116L366 116L365 116L365 116L365 117L365 116L365 116L364 116L364 116L364 115L365 116L365 115L365 115L365 115L365 115L365 115L365 115L365 115L364 115L364 114L364 114L364 114L364 114L363 114L363 115L363 115L362 115L361 114L362 114L362 114L361 114L361 114L361 114L361 114L360 114L360 114L360 114L360 114L360 113L360 114L360 114L360 115L360 115L360 115L360 116L359 115L356 116L355 116L351 116L351 116L350 116L349 116L350 117L350 118L350 118L350 119L351 119L351 119L352 120L353 119L353 119L353 120L353 120L353 121L353 121L352 121L352 122L353 122L353 122L353 123L353 123L354 124L354 125L354 125L355 124L356 125L358 124L359 123L359 123L359 124L360 124L360 124L360 125L360 126L360 126L361 127L361 127L362 127L362 127L362 128L363 128L363 128L364 128L364 128L364 127L365 127L365 126L367 125L367 124L370 125L370 125L370 126L370 126L372 127L372 128L373 128L373 128L373 129L374 129L376 129L376 129L377 130L377 130L377 130L377 130L378 129L378 129L378 129L379 130L380 130L380 130L380 129L380 129L381 129L381 129L381 129L381 129L381 129L381 129L382 129L382 129L382 129L382 130L382 130L382 130L384 130L384 130L384 131L384 131L384 131L384 131L385 131L385 131L385 131L385 131L385 132L385 132L387 131L387 132L387 132L387 131L388 131L388 131L389 131L389 131L390 131L390 131L390 131L390 132L392 133L392 134L392 134L393 135L394 135L394 135L396 135L398 135L399 135L399 135L399 134L399 134L400 134L400 134L400 133L400 133L400 132L400 131L400 131L400 130L400 129L400 129L400 129L400 128L399 128L399 128L399 128L399 128L399 127L399 128L398 127L398 127L398 126L398 126L398 125L399 125L399 125L398 125L399 124L399 124L398 124L398 124L398 124L398 124L398 124L398 124L398 123L398 123L398 123L397 123L397 123L397 123L397 122L397 122L397 122L397 122L398 121L398 121L398 121L399 121L399 121L399 121L400 121L400 121L401 121L401 121L401 121L401 121L401 121L402 121L402 121L402 120L401 120L401 119L401 119L401 119L401 118L401 118L401 118L402 118L402 117L403 117L403 117L402 116L402 116L402 116L402 116L402 116L403 116L402 116L402 116L402 115L402 115L402 115L402 115L402 115L402 114L403 114L403 114L404 113L404 113L404 113L404 113L404 112L404 112L404 112L404 112L404 112L404 111L404 112L404 112L403 112L403 111L402 110L402 110L402 110z"
        },
        {
            "title": "Bejjur",
            "d": "M498 117L497 117L496 117L494 117L494 117L494 116L493 116L492 116L491 116L489 116L488 116L487 115L487 113L487 112L487 112L486 110L486 110L486 107L486 107L485 106L486 105L485 105L485 104L482 104L481 105L480 104L478 105L477 104L476 103L475 103L473 103L473 102L472 103L472 104L471 105L471 105L471 107L470 107L470 107L470 108L471 108L470 109L469 109L469 109L468 109L466 108L465 107L466 106L462 106L462 106L462 106L462 106L459 106L459 107L459 107L459 107L459 109L458 109L458 109L457 112L457 112L458 113L459 113L460 114L460 114L461 115L462 116L463 116L465 117L465 117L466 116L466 117L466 117L466 118L467 119L467 119L467 120L467 120L467 121L468 121L470 121L471 120L473 120L473 120L473 121L473 121L472 123L473 125L473 125L473 126L473 127L474 127L474 129L475 129L476 129L478 129L480 131L484 132L485 132L487 133L487 133L489 130L490 131L494 132L495 130L495 129L496 129L497 128L497 127L498 127L497 125L496 122L496 122L496 121L497 120L497 119L498 118L498 117z"
        },
        {
            "title": "Chintalamanepally",
            "d": "M498 117L498 116L498 115L498 114L498 114L499 113L499 113L500 112L500 112L499 111L499 110L499 110L499 110L499 108L499 108L498 107L498 106L496 103L495 103L495 102L495 101L495 100L495 100L494 99L494 98L493 98L492 97L492 97L490 94L489 94L488 93L487 93L486 93L484 93L484 92L482 92L481 91L481 91L479 89L478 89L478 88L478 87L476 87L476 86L475 85L475 84L475 83L474 83L474 82L474 81L472 82L472 82L471 83L470 83L470 84L469 84L467 84L467 84L468 84L469 86L469 87L469 87L468 87L468 87L468 88L468 89L468 90L468 90L467 93L466 93L465 94L465 94L465 94L464 95L464 96L464 97L465 98L466 99L466 99L466 101L466 101L465 100L464 100L463 100L462 100L462 101L461 101L459 100L458 100L457 101L456 101L453 101L453 102L453 104L453 105L452 105L451 106L451 106L451 106L451 107L451 110L451 112L450 113L451 113L451 113L452 113L452 113L453 114L453 113L454 113L455 113L455 113L456 113L456 112L457 112L457 112L457 112L458 109L458 109L459 109L459 107L459 107L459 107L459 106L462 106L462 106L462 106L462 106L466 106L465 107L466 108L468 109L469 109L469 109L470 109L471 108L470 108L470 107L470 107L471 107L471 105L471 105L472 104L472 103L473 102L473 103L475 103L476 103L477 104L478 105L480 104L481 105L482 104L485 104L485 105L486 105L485 106L486 107L486 107L486 110L486 110L487 112L487 112L487 113L487 115L488 116L489 116L491 116L492 116L493 116L494 116L494 117L494 117L496 117L497 117L498 117z"
        },
        {
            "title": "Dahegaon",
            "d": "M448 126L448 126L446 126L445 126L444 126L444 127L444 127L444 127L443 127L443 127L442 127L442 127L441 127L440 127L440 127L439 127L439 128L438 128L438 128L437 128L436 128L436 127L436 127L436 127L436 126L436 126L436 126L435 126L435 126L434 126L434 126L434 126L434 126L434 126L434 125L434 125L434 124L433 124L431 124L432 124L432 125L432 125L432 125L432 125L431 126L431 127L431 127L431 127L430 127L430 127L430 128L430 128L430 128L430 128L430 128L430 129L430 129L429 129L430 129L430 129L430 129L430 129L430 129L431 130L431 130L431 130L432 130L432 130L432 130L431 131L431 131L431 131L431 132L430 133L430 133L430 133L430 133L430 134L430 134L430 134L430 134L430 134L431 134L431 134L431 134L431 134L432 134L432 134L433 134L434 133L434 133L434 133L435 133L435 133L435 133L435 132L436 132L436 132L436 132L436 132L436 132L437 131L438 132L439 132L439 131L439 131L439 131L439 131L439 131L440 131L440 132L441 132L441 133L441 133L441 133L441 134L441 134L441 135L442 135L442 135L442 135L442 135L443 135L443 135L443 134L443 134L443 134L444 134L444 134L445 135L445 135L445 135L445 136L445 136L445 137L446 137L447 138L447 138L446 140L446 140L446 141L447 141L448 141L448 140L448 140L449 140L449 140L449 140L450 141L450 141L450 142L450 142L450 143L450 143L450 143L450 143L450 144L450 144L450 143L450 143L450 143L450 144L449 144L449 144L449 145L450 145L450 145L450 145L450 145L452 144L452 144L452 145L453 145L453 145L453 145L454 144L454 144L454 144L454 144L455 144L455 144L455 144L455 143L456 143L456 144L457 144L457 145L458 145L458 146L458 146L458 146L459 146L459 147L459 147L459 147L460 147L460 147L461 147L461 147L461 148L461 148L461 148L461 148L461 148L461 148L462 148L462 148L462 148L463 148L463 148L463 148L463 148L463 148L463 148L464 148L464 148L464 148L464 147L464 147L464 147L465 147L465 147L465 147L466 146L466 147L468 148L467 150L467 151L468 151L468 151L468 152L471 154L473 152L474 152L475 152L476 152L476 151L476 151L476 150L476 150L479 151L479 150L480 149L482 149L483 150L484 151L484 151L485 151L486 152L486 151L487 151L487 151L488 152L489 151L490 151L490 151L491 151L492 153L494 151L494 150L494 150L494 149L494 148L492 145L491 144L491 143L490 143L489 143L488 143L488 143L488 144L488 145L488 145L487 145L486 144L485 143L484 142L484 142L485 142L485 141L484 140L483 140L481 139L481 139L481 138L481 138L482 136L482 136L482 136L481 136L481 136L479 137L478 137L478 138L477 138L476 138L476 139L475 139L475 140L475 141L474 141L474 141L474 141L474 141L474 140L474 139L473 139L472 139L471 138L470 138L470 137L469 137L469 137L469 138L468 138L468 138L467 138L466 138L464 136L464 135L464 135L463 134L462 133L462 132L461 132L460 132L459 132L459 132L458 132L458 132L457 131L457 131L456 131L455 132L455 132L454 132L454 131L453 131L453 130L452 129L451 128L449 126L448 126z"
        },
        {
            "title": "Jainoor",
            "d": "M343 106L344 105L343 105L343 104L342 104L342 103L342 102L342 101L342 101L343 100L343 100L344 99L343 99L343 98L341 97L341 96L340 96L340 96L339 95L339 95L340 95L339 95L339 94L338 94L336 93L332 95L329 97L329 96L327 93L327 93L326 94L324 95L324 95L324 96L323 98L322 99L322 99L321 100L320 101L319 101L317 100L316 101L315 101L315 104L315 104L315 104L315 104L314 105L312 105L312 105L312 106L311 107L311 107L311 107L311 108L311 108L310 110L309 110L308 110L307 109L307 109L307 109L307 110L309 111L309 111L310 112L311 112L313 112L313 112L313 115L313 115L313 115L313 115L313 116L314 116L315 116L317 118L318 119L318 119L319 119L319 119L319 119L319 119L319 118L320 118L321 120L322 120L324 121L325 122L325 121L326 120L326 120L326 119L327 118L322 117L323 114L323 114L325 115L327 114L328 114L328 115L329 116L330 116L330 117L331 117L331 117L331 117L331 117L332 116L332 116L332 116L333 114L332 114L333 113L332 113L333 111L333 111L333 111L334 111L334 110L335 110L336 110L336 110L337 111L338 111L339 109L340 109L340 108L340 108L340 107L341 107L342 106L342 105L343 105L343 106z"
        },
        {
            "title": "Kagaznagar",
            "d": "M415 90L415 89L414 89L413 88L412 88L412 87L411 86L409 86L409 87L409 87L409 87L409 87L408 87L406 86L406 86L405 87L405 88L404 90L404 91L403 94L402 95L402 95L401 96L402 97L402 98L403 98L404 99L404 99L404 100L404 100L404 100L404 100L404 100L404 100L404 101L405 101L405 100L405 100L405 101L405 101L405 101L405 101L405 101L406 100L406 100L406 100L406 100L407 100L407 100L408 101L408 101L408 101L409 101L409 102L409 102L409 103L408 103L408 104L407 105L407 105L406 105L405 103L405 103L403 103L403 103L403 104L403 104L404 105L404 105L404 105L404 105L404 105L404 105L404 106L404 107L403 107L403 107L402 108L402 108L402 108L402 108L402 109L402 110L402 110L402 110L402 110L403 111L403 112L404 112L404 112L404 111L404 112L404 112L404 112L404 112L404 112L404 113L404 113L404 113L404 113L403 114L403 114L402 114L402 115L402 115L402 115L402 115L402 115L402 116L402 116L403 116L402 116L402 116L402 116L402 116L402 116L403 117L403 117L402 117L402 118L401 118L401 118L402 118L402 118L403 118L403 119L404 119L404 119L404 119L405 119L406 119L406 119L406 119L406 119L407 119L408 119L408 119L408 120L408 121L408 121L408 122L409 122L409 122L409 121L409 121L409 121L410 121L410 121L411 123L411 123L411 123L411 123L410 125L410 125L410 125L411 125L411 126L412 126L412 126L412 125L413 125L413 126L414 126L414 125L414 125L414 125L415 125L415 125L416 125L417 124L417 124L418 124L418 124L419 124L419 124L419 124L419 124L419 123L420 123L421 123L422 122L423 122L423 122L424 123L424 124L424 124L424 124L423 126L423 127L423 128L423 129L423 129L423 129L424 129L424 129L424 129L424 129L424 129L424 130L425 130L425 129L426 130L428 130L428 130L428 129L429 129L429 129L429 129L429 130L429 130L430 130L430 130L430 131L429 131L429 132L429 132L429 132L429 133L429 133L430 134L430 133L430 133L430 133L430 133L431 132L431 131L431 131L431 131L432 130L432 130L432 130L431 130L431 130L431 130L430 129L430 129L430 129L430 129L430 129L429 129L430 129L430 129L430 128L430 128L430 128L430 128L430 128L430 127L430 127L431 127L431 127L431 127L431 126L432 125L432 125L432 125L432 125L432 124L431 124L433 124L434 124L434 125L434 125L434 126L434 126L434 126L434 126L434 126L435 126L435 126L436 126L436 126L436 126L436 127L436 127L436 127L436 128L437 128L438 128L438 128L439 128L439 127L440 127L440 127L441 127L442 127L442 127L443 127L443 127L444 127L444 127L444 127L444 126L445 126L446 126L448 126L448 126L448 125L448 125L448 125L448 125L448 125L448 124L448 123L449 123L449 123L449 122L448 120L448 120L448 119L448 119L449 119L452 121L453 121L453 121L453 121L453 121L454 120L454 120L454 120L456 120L457 120L458 120L458 120L458 121L458 121L458 122L459 122L459 122L462 117L462 116L461 115L460 114L460 114L459 113L458 113L457 112L457 112L456 112L456 113L455 113L455 113L454 113L453 113L453 114L452 113L452 113L451 113L451 113L450 113L449 113L449 112L448 112L446 111L445 111L444 111L442 111L442 110L442 110L442 109L442 107L441 107L441 107L441 107L439 107L438 107L436 107L436 107L436 108L436 108L436 108L436 109L436 109L435 109L435 109L435 109L435 109L435 109L435 109L434 109L433 109L432 109L432 109L431 109L431 108L430 107L430 107L429 108L429 108L428 107L428 108L428 108L428 109L428 109L428 110L427 112L427 112L427 112L425 112L425 112L424 113L422 114L422 114L422 114L421 114L421 114L421 114L421 114L420 114L420 112L419 108L419 107L418 103L418 102L418 102L418 101L418 102L417 101L416 100L415 100L414 100L415 99L415 98L415 97L415 97L415 96L415 95L414 95L414 95L414 95L414 93L414 93L414 92L414 93L414 92L414 92L414 91L415 90L415 90z"
        },
        {
            "title": "Kerameri",
            "d": "M375 98L375 98L374 98L373 98L372 99L372 99L371 99L369 99L368 98L367 97L367 96L367 95L366 94L366 94L365 94L365 93L364 92L363 92L362 92L362 92L362 91L362 91L361 90L360 90L360 90L359 90L359 89L358 88L357 88L357 88L356 87L356 86L352 86L352 86L351 86L351 85L350 85L347 84L346 84L344 85L341 85L340 85L340 83L337 81L337 82L336 82L336 83L336 83L335 83L332 83L332 83L331 83L330 83L330 83L329 83L329 83L330 84L332 86L331 87L330 90L331 91L331 92L332 91L333 91L334 92L335 93L336 93L336 93L338 94L339 94L339 95L340 95L339 95L339 95L340 96L340 96L341 96L341 97L343 98L343 99L344 99L343 100L343 100L342 101L342 101L342 102L342 103L342 104L343 104L343 105L344 105L343 106L344 106L345 106L346 106L346 106L346 106L346 107L347 109L347 109L348 110L348 112L349 112L349 112L349 113L349 115L349 116L350 116L351 116L351 116L355 116L356 116L359 115L360 116L360 115L360 115L360 115L360 114L360 114L360 113L360 114L360 114L360 114L360 114L361 114L361 114L361 114L361 114L362 114L362 114L361 114L362 115L363 115L363 115L363 114L364 114L364 114L364 114L364 114L364 115L365 115L365 115L365 115L365 115L365 115L365 115L365 115L365 116L364 115L364 116L364 116L365 116L365 116L365 117L365 116L365 116L366 116L366 116L366 116L366 116L366 116L366 116L366 116L366 116L367 116L367 115L368 115L369 115L369 116L370 115L370 115L371 115L373 115L372 115L372 115L371 114L371 113L370 112L370 112L369 112L370 111L370 111L370 110L371 110L371 110L371 110L372 109L372 108L372 108L372 107L372 107L373 107L373 106L372 106L373 106L373 106L373 105L373 105L373 103L373 103L373 102L374 102L374 101L375 101L376 101L376 100L376 100L375 98z"
        },
        {
            "title": "Kouthala",
            "d": "M474 81L473 81L473 80L472 80L472 79L471 79L470 79L467 76L466 75L465 75L464 75L463 74L462 74L461 74L460 75L457 78L457 78L456 78L455 78L454 79L453 78L452 79L451 79L450 79L450 79L448 79L444 80L444 81L444 82L444 82L444 82L444 82L444 82L444 82L444 83L445 83L445 83L446 83L448 84L448 84L448 85L447 85L448 86L448 86L449 87L449 87L448 87L448 88L448 88L448 88L448 88L448 88L448 88L448 88L448 89L448 89L448 89L449 89L449 89L449 89L449 89L449 89L449 89L449 89L450 88L450 88L450 88L450 89L451 89L451 90L451 90L451 90L452 91L452 92L452 92L452 92L452 92L452 93L453 93L454 95L454 95L454 96L454 96L455 97L455 97L455 98L454 99L454 99L454 99L453 100L453 101L453 101L453 101L456 101L457 101L458 100L459 100L461 101L462 101L462 100L463 100L464 100L465 100L466 101L466 101L466 99L466 99L465 98L464 97L464 96L464 95L465 94L465 94L465 94L466 93L467 93L468 90L468 90L468 89L468 88L468 87L468 87L469 87L469 87L469 86L468 84L467 84L467 84L469 84L470 84L470 83L471 83L472 82L472 82L474 81z"
        },
        {
            "title": "Lingapur",
            "d": "M354 125L354 125L354 124L353 123L353 123L353 122L353 122L352 122L352 121L353 121L353 121L353 120L353 120L353 119L353 119L352 120L351 119L351 119L351 120L352 120L352 120L352 120L352 120L352 121L350 120L350 120L349 121L348 121L346 121L346 122L345 123L345 124L344 125L344 125L343 126L342 127L341 128L341 128L340 128L339 129L339 130L338 128L336 128L335 127L335 127L334 127L333 127L332 127L332 126L331 126L330 126L330 127L329 128L329 127L328 128L328 129L327 130L326 131L326 131L327 132L330 134L330 134L330 134L331 134L332 134L332 135L333 135L334 136L334 136L335 137L336 137L337 137L337 137L336 139L342 141L342 141L342 141L343 142L343 142L344 143L344 143L345 142L346 142L346 142L349 143L351 142L352 142L353 141L354 141L354 140L354 140L354 140L355 140L355 140L355 140L357 138L358 136L357 136L354 134L353 132L353 132L352 131L352 131L353 130L353 129L353 128L353 128L353 128L354 128L354 128L354 127L354 126L354 125L354 125z"
        },
        {
            "title": "Penchikalpet",
            "d": "M494 132L490 131L489 130L487 133L487 133L485 132L484 132L480 131L478 129L476 129L475 129L474 129L474 127L473 127L473 126L473 125L473 125L472 123L473 121L473 121L473 120L473 120L471 120L470 121L468 121L467 121L467 120L467 120L467 119L467 119L466 118L466 117L466 117L466 116L465 117L465 117L463 116L462 116L462 117L459 122L459 122L458 122L458 121L458 121L458 120L458 120L457 120L456 120L454 120L454 120L454 120L453 121L453 121L453 121L453 121L452 121L449 119L448 119L448 119L448 120L448 120L449 122L449 123L449 123L448 123L448 124L448 125L448 125L448 125L448 125L448 125L448 126L449 126L451 128L452 129L453 130L453 131L454 131L454 132L455 132L455 132L456 131L457 131L457 131L458 132L458 132L459 132L459 132L460 132L461 132L462 132L462 133L463 134L464 135L464 135L464 136L466 138L467 138L468 138L468 138L469 138L469 137L469 137L470 137L470 138L471 138L472 139L473 139L474 139L474 140L474 141L474 141L474 141L474 141L475 141L475 140L475 139L476 139L476 138L477 138L478 138L478 137L479 137L481 136L481 136L482 136L482 136L482 136L481 138L481 138L481 139L481 139L483 140L484 140L485 141L485 142L484 142L484 142L485 143L486 144L487 145L488 145L488 145L488 144L488 143L488 143L489 143L490 143L491 143L491 142L491 140L491 137L492 136L493 134L494 132z"
        },
        {
            "title": "Rebbena",
            "d": "M423 129L423 129L423 129L423 128L423 127L423 126L424 124L424 124L424 124L424 123L423 122L423 122L422 122L421 123L420 123L419 123L419 124L419 124L419 124L419 124L418 124L418 124L417 124L417 124L416 125L415 125L415 125L414 125L414 125L414 125L414 126L413 126L413 125L412 125L412 126L412 126L411 126L411 125L410 125L410 125L410 125L411 123L411 123L411 123L411 123L410 121L410 121L409 121L409 121L409 121L409 122L409 122L408 122L408 121L408 121L408 120L408 119L408 119L407 119L406 119L406 119L406 119L406 119L405 119L404 119L404 119L404 119L403 119L403 118L402 118L402 118L401 118L401 118L401 119L401 119L401 119L401 120L402 120L402 121L402 121L401 121L401 121L401 121L401 121L401 121L400 121L400 121L399 121L399 121L399 121L398 121L398 121L398 121L397 122L397 122L397 122L397 122L397 123L397 123L397 123L398 123L398 123L398 123L398 124L398 124L398 124L398 124L398 124L398 124L399 124L399 124L398 125L399 125L399 125L398 125L398 126L398 126L398 127L398 127L399 128L399 127L399 128L399 128L399 128L399 128L400 128L400 129L400 129L400 129L400 130L400 131L400 131L400 132L400 133L400 133L400 134L400 134L399 134L399 134L399 135L399 135L398 135L396 135L394 135L394 135L393 135L392 137L392 138L393 139L393 140L394 140L395 140L397 141L397 141L397 141L397 141L398 142L399 142L399 143L400 143L400 143L401 143L401 142L402 143L403 143L404 143L404 143L405 143L406 143L407 143L409 144L410 145L411 146L413 147L415 148L415 148L416 147L416 147L417 148L417 148L417 148L418 147L418 147L418 146L418 146L418 146L418 146L418 146L417 146L417 146L417 145L418 145L417 145L418 145L418 145L418 145L418 145L418 145L419 145L419 145L419 146L419 146L419 146L420 146L420 146L420 146L420 146L420 146L420 146L420 146L421 146L421 145L420 145L420 145L420 145L420 144L420 144L420 144L420 144L420 144L421 144L421 144L422 144L422 144L422 144L422 144L423 144L423 144L423 144L423 144L424 144L424 143L424 143L424 144L425 144L425 144L426 144L426 144L426 144L426 144L426 145L426 145L427 145L427 145L427 144L427 145L427 145L428 145L428 145L428 144L429 145L429 145L429 144L429 144L429 143L429 142L429 142L429 142L429 141L428 141L428 141L428 141L428 141L428 140L427 140L427 140L427 140L427 139L426 139L426 139L426 139L426 139L426 139L426 139L426 138L426 138L426 138L426 137L426 137L426 136L425 136L425 136L425 135L425 135L425 135L425 135L425 134L425 134L424 134L423 133L423 133L422 133L422 132L423 131L423 131L423 130L423 130L423 130L423 129z"
        },
        {
            "title": "Sirpur_T",
            "d": "M415 90L415 90L414 91L414 92L414 92L414 93L414 92L414 93L414 93L414 95L414 95L414 95L415 95L415 96L415 97L415 97L415 98L415 99L414 100L415 100L416 100L417 101L418 102L418 101L418 102L418 102L418 103L419 107L419 108L420 112L420 114L421 114L421 114L421 114L421 114L422 114L422 114L422 114L424 113L425 112L425 112L427 112L427 112L427 112L428 110L428 109L428 109L428 108L428 108L428 107L429 108L429 108L430 107L430 107L431 108L431 109L432 109L432 109L433 109L434 109L435 109L435 109L435 109L435 109L435 109L435 109L436 109L436 109L436 108L436 108L436 108L436 107L436 107L438 107L439 107L441 107L441 107L441 107L442 107L442 109L442 110L442 110L442 111L444 111L445 111L446 111L448 112L449 112L449 113L450 113L451 112L451 110L451 107L451 106L451 106L451 106L452 105L453 105L453 104L453 102L453 101L453 101L453 101L453 100L454 99L454 99L454 99L455 98L455 97L455 97L454 96L454 96L454 95L454 95L453 93L452 93L452 92L452 92L452 92L452 92L452 91L451 90L451 90L451 90L451 89L450 89L450 88L450 88L450 88L449 89L449 89L449 89L449 89L449 89L449 89L449 89L448 89L448 89L448 89L448 88L448 88L448 88L448 88L448 88L448 88L448 88L448 87L449 87L449 87L448 86L448 86L447 85L448 85L448 84L448 84L446 83L445 83L445 83L444 83L444 82L444 82L444 82L444 82L444 82L444 82L444 81L444 80L443 80L442 80L441 81L440 83L440 83L440 85L439 86L439 87L439 88L438 90L438 91L438 91L437 92L437 92L435 91L432 89L430 89L430 88L429 87L429 86L429 85L429 84L429 83L428 83L428 83L426 84L425 85L425 86L425 87L425 89L425 89L424 89L424 89L422 91L422 91L422 92L421 92L421 92L421 91L419 92L417 93L417 92L416 91L415 90z"
        },
        {
            "title": "Sirpur_U",
            "d": "M343 106L343 105L342 105L342 106L341 107L340 107L340 108L340 108L340 109L339 109L338 111L337 111L336 110L336 110L335 110L334 110L334 111L333 111L333 111L333 111L332 113L333 113L332 114L333 114L332 116L332 116L332 116L331 117L331 117L331 117L331 117L330 117L330 116L329 116L328 115L328 114L327 114L325 115L323 114L323 114L322 117L327 118L326 119L326 120L326 120L325 121L325 122L324 121L322 120L321 120L319 122L317 122L318 124L317 126L317 130L318 129L319 130L320 131L321 131L321 130L321 130L322 130L322 129L322 128L326 131L326 131L327 130L328 129L328 128L329 127L329 128L330 127L330 126L331 126L332 126L332 127L333 127L334 127L335 127L335 127L336 128L338 128L339 130L339 129L340 128L341 128L341 128L342 127L343 126L344 125L344 125L345 124L345 123L346 122L346 121L348 121L349 121L350 120L350 120L352 121L352 120L352 120L352 120L352 120L351 120L351 119L350 119L350 118L350 118L350 117L349 116L349 115L349 113L349 112L349 112L348 112L348 110L347 109L347 109L346 107L346 106L346 106L346 106L345 106L344 106L343 106z"
        },
        {
            "title": "Tiryani",
            "d": "M393 135L392 134L392 134L392 133L390 132L390 131L390 131L390 131L389 131L389 131L388 131L388 131L387 131L387 132L387 132L387 131L385 132L385 132L385 131L385 131L385 131L385 131L384 131L384 131L384 131L384 131L384 130L384 130L382 130L382 130L382 130L382 129L382 129L382 129L381 129L381 129L381 129L381 129L381 129L381 129L380 129L380 129L380 130L380 130L379 130L378 129L378 129L378 129L377 130L377 130L377 130L377 130L376 129L376 129L374 129L373 129L373 128L373 128L372 128L372 127L370 126L370 126L370 125L370 125L367 124L367 125L365 126L365 127L364 127L364 128L364 128L363 128L363 128L362 128L362 127L362 127L361 127L361 127L360 126L360 126L360 125L360 124L360 124L359 124L359 123L359 123L358 124L356 125L355 124L354 125L354 125L354 126L354 127L354 128L354 128L353 128L353 128L353 128L353 129L353 130L352 131L352 131L353 132L353 132L354 134L357 136L358 136L357 138L355 140L355 140L355 140L354 140L354 140L354 140L354 141L353 141L352 142L351 142L349 143L346 142L346 143L346 143L346 143L345 144L345 144L345 144L345 144L345 145L345 145L345 145L345 146L345 147L345 147L345 148L352 150L352 153L357 158L359 159L361 159L361 159L362 159L362 161L363 161L363 161L364 162L364 162L366 163L367 163L368 164L370 165L373 166L373 167L373 168L373 168L374 168L374 168L375 170L375 169L376 168L376 168L376 167L376 167L376 167L378 166L379 165L380 165L381 165L381 165L381 166L381 163L381 161L381 159L381 159L381 159L381 159L382 158L380 156L380 154L380 155L380 154L380 154L381 154L382 155L386 158L386 158L387 159L388 159L389 160L391 161L391 160L391 159L391 158L391 157L391 157L392 157L392 156L391 156L392 155L392 155L392 154L392 154L391 153L391 153L391 152L391 152L391 152L391 151L392 152L392 151L392 152L392 152L392 151L392 151L394 152L394 152L396 152L396 153L396 153L397 153L397 153L398 153L397 153L398 153L398 153L398 154L400 154L400 155L400 155L401 155L402 155L403 156L404 154L404 154L403 152L403 152L403 152L403 151L402 151L402 150L401 149L400 149L398 147L398 147L398 148L397 148L396 148L395 148L395 148L395 148L395 147L395 147L395 146L395 146L395 145L395 145L395 145L396 144L395 144L396 143L394 143L393 143L392 143L392 143L392 142L393 141L393 141L393 140L393 140L393 139L392 138L392 137L393 135z"
        },
        {
            "title": "Wankidi",
            "d": "M406 86L405 86L405 85L406 85L405 85L405 84L404 83L404 83L403 83L403 82L402 82L401 82L400 80L400 80L400 80L400 79L399 79L399 79L398 79L397 79L396 79L396 79L395 80L393 79L392 79L392 81L391 81L391 80L391 80L391 79L390 76L387 76L386 76L385 75L381 72L381 72L380 72L379 74L379 74L380 76L380 76L381 76L381 76L381 79L381 79L380 81L379 83L379 83L379 84L379 84L379 85L379 86L379 86L378 89L378 89L376 89L375 90L374 91L374 91L374 93L373 93L373 93L373 93L373 94L374 95L374 95L375 95L375 96L376 97L376 98L376 98L375 98L375 98L376 100L376 100L376 101L376 102L377 102L377 102L378 102L379 103L379 103L380 103L380 103L380 103L381 103L382 103L383 104L384 104L385 105L386 105L386 105L387 105L387 105L387 105L387 106L387 107L387 107L388 108L389 109L389 109L389 109L389 110L389 110L389 110L390 110L390 110L391 111L391 111L392 112L393 112L392 112L392 111L392 110L393 110L393 110L393 110L393 110L394 109L394 110L395 110L395 110L395 110L395 110L396 110L396 110L396 110L396 111L396 111L396 112L396 112L396 112L397 112L396 112L398 113L399 113L399 113L400 113L400 113L400 113L400 112L400 112L400 112L401 111L401 111L402 110L402 110L402 110L402 109L402 108L402 108L402 108L402 108L403 107L403 107L404 107L404 106L404 105L404 105L404 105L404 105L404 105L404 105L403 104L403 104L403 103L403 103L405 103L405 103L406 105L407 105L407 105L408 104L408 103L409 103L409 102L409 102L409 101L408 101L408 101L408 101L407 100L407 100L406 100L406 100L406 100L406 100L405 101L405 101L405 101L405 101L405 101L405 100L405 100L405 101L404 101L404 100L404 100L404 100L404 100L404 100L404 100L404 99L404 99L403 98L402 98L402 97L401 96L402 95L402 95L403 94L404 91L404 90L405 88L405 87L406 86z"
        }
    ],
    "Hanumakonda": [
        {
            "title": "Atmakur",
            "d": "M471 336L472 335L472 335L472 332L471 331L470 331L470 331L469 331L470 332L469 333L469 334L468 334L468 334L468 334L468 334L468 334L468 334L467 334L467 334L467 334L467 334L466 334L466 334L466 334L466 334L466 334L466 334L465 333L465 333L465 333L464 334L464 334L464 334L464 334L463 334L463 335L463 335L463 335L463 335L462 336L462 336L462 336L462 335L462 336L461 336L461 336L461 336L461 336L461 336L460 336L460 335L460 335L460 334L460 334L459 334L459 335L458 334L458 335L458 335L458 335L457 335L457 335L457 335L457 334L456 334L457 334L456 334L456 334L456 334L455 334L455 334L455 334L454 334L454 335L454 335L454 335L454 334L453 334L453 334L452 334L452 333L452 333L452 333L452 333L452 333L452 333L452 333L452 332L451 332L450 332L450 332L450 332L449 332L449 332L449 333L449 333L449 333L449 333L449 334L449 334L449 335L449 335L450 336L450 336L450 336L450 336L450 336L451 335L451 336L451 336L452 336L452 336L452 337L452 338L453 338L453 338L453 338L453 338L453 338L453 338L453 338L454 338L453 341L453 343L451 344L451 344L450 344L450 344L450 345L450 345L450 345L450 345L450 346L451 348L451 349L451 349L451 349L451 349L451 349L450 350L450 350L450 350L451 350L451 351L451 351L451 351L453 351L453 352L453 352L453 352L454 352L454 352L454 352L454 352L454 352L455 351L455 352L455 352L456 351L457 351L458 350L458 350L458 350L458 349L458 349L459 349L459 349L459 349L459 349L459 349L459 349L459 349L459 349L460 349L460 348L460 348L460 348L460 347L460 346L460 346L461 346L461 345L462 345L462 345L462 344L462 343L463 343L463 343L463 342L464 342L465 342L465 343L465 343L465 343L465 343L465 343L466 344L466 343L467 344L468 344L468 343L468 343L468 342L468 342L468 341L468 341L468 341L468 341L467 341L468 341L468 341L468 341L468 340L468 340L468 340L468 340L468 340L468 339L468 339L468 339L468 339L468 338L468 338L469 338L471 338L471 336z"
        },
        {
            "title": "Bheemadevarapalli",
            "d": "M401 325L400 325L400 325L399 325L399 324L399 324L399 324L398 324L398 325L398 325L397 325L397 326L396 326L396 327L396 327L396 327L395 327L395 326L394 326L394 326L393 326L392 326L392 326L392 326L391 326L391 326L391 326L391 326L391 326L390 326L390 327L390 327L390 327L390 327L390 327L390 327L389 327L389 327L389 327L389 327L389 327L389 328L388 328L387 328L385 330L385 331L385 331L385 332L385 332L385 333L384 333L384 333L383 336L384 336L384 337L382 339L383 339L383 340L383 340L383 341L382 343L381 344L381 344L381 344L380 344L380 345L380 346L380 348L380 349L380 350L380 350L381 350L381 351L382 351L383 350L383 351L384 350L384 350L384 350L385 349L385 349L385 349L385 348L385 348L386 348L386 348L386 347L387 347L387 347L387 347L388 347L388 347L388 347L389 347L389 347L389 347L389 347L390 347L390 348L391 348L391 347L392 347L392 347L391 347L392 344L392 343L392 343L392 343L393 342L393 342L393 342L393 342L395 342L396 342L396 342L396 342L396 342L397 342L397 342L397 343L398 342L399 343L399 343L400 343L401 342L402 341L402 341L402 341L403 341L403 341L402 340L403 339L403 339L403 338L403 338L403 338L403 338L403 337L404 336L404 336L404 336L404 336L404 335L405 335L405 335L405 334L403 334L403 334L402 334L402 334L402 334L402 334L402 334L402 334L402 333L402 333L402 332L401 332L401 332L402 332L401 332L401 332L401 331L401 331L400 331L400 331L400 331L399 331L399 330L399 330L399 330L399 329L399 329L399 329L399 329L400 329L399 328L400 328L400 328L400 328L400 327L401 326L401 326L401 326L401 325z"
        },
        {
            "title": "Damera",
            "d": "M446 328L445 328L445 328L445 328L444 328L443 328L443 327L443 327L442 327L442 327L442 328L441 328L441 328L441 329L441 329L440 329L440 329L441 329L439 330L438 330L438 330L438 330L437 331L436 331L436 332L436 332L436 332L437 332L437 333L437 333L437 333L437 334L437 334L437 334L438 335L438 335L438 335L438 335L438 336L438 337L438 338L438 338L438 340L439 340L440 341L440 342L440 342L440 342L440 343L440 344L441 345L442 345L443 345L443 345L444 345L444 344L445 345L446 345L446 345L447 345L447 346L447 346L448 346L448 346L448 346L448 347L448 347L448 348L448 349L448 349L449 349L449 349L449 350L449 350L449 350L449 350L449 350L449 350L449 350L449 350L450 350L450 350L450 350L451 349L451 349L451 349L451 349L451 349L451 348L450 346L450 345L450 345L450 345L450 345L450 344L450 344L451 344L451 344L453 343L453 341L454 338L453 338L453 338L453 338L453 338L453 338L453 338L453 338L452 338L452 337L452 336L452 336L451 336L451 336L451 335L450 336L450 336L450 336L450 336L450 336L449 335L449 335L449 334L449 334L449 333L449 333L449 333L449 333L449 332L449 332L449 332L449 331L449 331L448 331L448 331L448 331L448 331L448 331L448 330L447 330L447 330L446 330L446 330L446 330L446 330L446 330L446 329L446 329L446 329L446 329L446 328z"
        },
        {
            "title": "Dharmasagar",
            "d": "M417 370L418 369L418 369L418 368L418 368L418 367L418 366L417 366L417 365L416 366L415 365L415 366L414 366L414 366L412 367L411 367L411 367L411 367L411 368L411 369L411 369L411 370L411 370L411 371L411 372L413 373L413 373L413 372L414 372L414 372L414 372L415 370L416 370L417 370L417 370L417 370zM418 350L419 348L419 348L417 346L417 345L417 345L417 344L416 344L416 344L415 344L415 344L414 345L414 345L414 346L413 346L413 346L413 347L413 347L412 346L411 346L410 345L409 345L409 345L408 344L408 344L409 344L409 344L409 344L410 344L410 343L410 343L410 343L410 343L410 343L410 342L410 342L410 342L410 341L410 341L410 341L410 340L410 340L409 340L409 340L409 340L409 340L409 340L408 341L408 341L407 341L407 342L406 342L406 343L405 343L405 343L405 343L405 343L405 343L404 344L399 346L399 346L399 347L398 348L397 348L398 349L397 349L397 349L397 349L397 349L397 349L397 350L397 350L397 350L397 350L397 350L397 350L396 350L396 350L396 350L396 350L396 350L396 350L396 350L395 350L395 350L395 352L395 352L394 352L394 352L394 352L394 353L394 353L394 353L394 353L394 353L394 354L395 354L395 354L395 355L396 355L397 355L397 355L398 355L399 356L398 357L398 358L398 358L397 358L397 359L397 360L396 360L396 361L396 361L396 361L396 361L395 361L395 361L395 362L395 362L394 362L394 363L394 363L394 363L395 364L395 365L396 365L396 365L397 366L398 366L398 367L398 367L399 367L399 367L400 368L401 368L401 368L402 367L402 367L402 367L402 368L402 368L403 368L403 368L403 368L403 369L404 368L405 369L405 369L406 369L406 369L406 369L407 368L407 368L408 367L408 367L409 366L409 366L409 365L408 364L408 362L408 361L408 361L409 360L409 360L409 359L409 359L410 358L411 357L411 356L411 356L412 354L412 354L412 354L412 354L412 354L412 354L412 353L413 353L413 352L413 351L413 351L413 349L413 349L414 349L414 350L416 350L417 350L417 350L418 350L418 350z"
        },
        {
            "title": "Elkathurthi",
            "d": "M412 324L411 324L411 324L411 324L411 324L411 324L410 324L410 324L410 324L409 324L409 324L409 324L408 324L407 324L407 324L407 323L406 322L406 322L406 322L406 322L406 322L406 322L405 322L405 322L405 322L405 323L404 323L404 323L404 323L403 323L403 323L403 323L402 323L402 325L402 325L401 325L401 325L401 326L401 326L401 326L400 327L400 328L400 328L400 328L399 328L400 329L399 329L399 329L399 329L399 329L399 330L399 330L399 330L399 331L400 331L400 331L400 331L401 331L401 331L401 332L401 332L402 332L401 332L401 332L402 332L402 333L402 333L402 334L402 334L402 334L402 334L402 334L402 334L403 334L403 334L405 334L405 335L405 335L404 335L404 336L404 336L404 336L404 336L403 337L403 338L403 338L403 338L403 338L403 339L403 339L402 340L403 341L403 341L402 341L402 341L402 341L401 342L400 343L399 343L399 344L399 346L404 344L405 343L405 343L405 343L405 343L405 343L406 343L406 342L407 342L407 341L408 341L408 341L409 340L409 340L409 340L409 340L409 340L410 340L410 340L410 340L410 340L411 340L411 338L412 338L412 337L412 337L412 337L413 337L412 336L413 336L413 336L413 335L413 335L413 335L413 335L413 334L413 333L414 333L414 333L414 332L415 332L415 332L415 332L415 332L416 333L416 333L417 334L417 334L417 334L417 334L419 335L420 335L420 334L420 334L421 334L421 333L422 334L422 334L422 334L423 334L423 334L423 334L423 334L423 334L424 334L424 334L424 334L424 334L424 334L424 334L425 334L425 334L425 334L426 334L426 334L426 334L426 334L426 334L426 334L427 334L428 334L428 334L428 334L429 333L429 331L430 331L430 331L430 331L430 330L429 329L429 329L428 329L428 329L428 328L428 328L427 328L427 328L427 328L426 328L425 328L425 328L425 328L425 328L425 329L424 329L424 329L424 329L424 329L422 329L421 329L421 329L420 328L420 328L420 328L420 328L419 328L419 328L419 327L419 326L419 325L418 325L418 325L418 325L417 325L417 325L417 324L416 324L416 324L415 324L415 324L414 324L414 324L414 324L413 324L413 324L412 324L412 324z"
        },
        {
            "title": "Hanumakonda",
            "d": "M436 345L435 345L434 345L434 345L434 345L432 344L432 344L431 344L430 344L430 343L430 343L430 343L430 343L430 343L430 343L429 343L429 343L428 343L427 342L427 342L427 343L427 343L427 344L426 344L426 345L426 346L426 346L426 347L426 347L426 347L426 347L426 347L426 347L425 347L425 347L424 347L424 348L424 348L423 349L422 349L422 349L421 349L421 349L421 349L420 349L420 350L421 350L420 350L421 350L421 351L421 351L421 351L421 351L421 351L421 353L422 353L422 353L423 353L423 354L423 354L423 354L424 354L426 353L427 354L428 354L428 354L429 354L429 354L430 353L430 353L432 354L432 353L432 354L432 354L434 354L434 354L434 354L434 353L434 353L434 353L434 352L434 352L434 352L435 351L435 349L435 348L435 348L436 347L435 346L435 345L436 345L436 345z"
        },
        {
            "title": "Hasanparthy",
            "d": "M436 327L436 327L436 327L435 327L435 327L435 327L435 327L435 327L435 327L433 327L433 327L433 327L433 327L433 327L432 328L432 328L432 329L432 330L433 330L433 331L433 331L433 331L433 331L432 331L432 331L431 330L431 331L431 331L431 331L430 331L430 331L430 331L430 331L430 331L430 330L430 330L430 330L430 331L430 331L429 331L429 333L428 334L428 334L428 334L427 334L426 334L426 334L426 334L426 334L426 334L426 334L425 334L425 334L425 334L424 334L424 334L424 334L424 334L424 334L424 334L423 334L423 334L423 334L423 334L423 334L422 334L422 334L422 334L421 333L421 334L420 334L420 334L420 335L419 335L417 334L417 334L417 334L417 334L416 333L416 333L415 332L415 332L415 332L415 332L414 332L414 333L414 333L413 333L413 334L413 335L413 335L413 335L413 335L413 336L413 336L412 336L413 337L412 337L412 337L412 337L412 338L411 338L411 340L410 340L410 340L410 340L410 340L410 340L410 341L410 341L410 341L410 342L410 342L410 342L410 343L410 343L410 343L410 343L410 343L410 344L409 344L409 344L409 344L408 344L408 344L409 345L409 345L410 345L411 346L412 346L413 347L413 347L413 346L413 346L414 346L414 345L414 345L415 344L415 344L416 344L416 344L417 344L417 345L417 345L417 346L419 348L419 348L418 350L418 351L419 351L420 351L420 352L421 352L421 353L421 351L421 351L421 351L421 351L421 351L421 350L420 350L421 350L420 350L420 349L421 349L421 349L421 349L422 349L422 349L423 349L424 348L424 348L424 347L425 347L425 347L426 347L426 347L426 347L426 347L426 347L426 347L426 346L426 346L426 345L426 344L427 344L427 343L427 343L427 342L427 342L428 343L429 343L429 343L430 343L430 343L430 343L430 343L430 343L430 343L430 344L431 344L432 344L432 344L434 345L434 345L434 345L435 345L436 345L436 345L436 345L436 346L436 346L437 346L438 346L439 346L439 345L440 345L440 344L440 343L440 342L440 342L440 342L440 341L439 340L438 340L438 338L438 338L438 337L438 336L438 335L438 335L438 335L438 335L437 334L437 334L437 334L437 333L437 333L437 333L437 332L436 332L436 332L436 332L436 331L437 331L438 330L438 330L438 330L439 330L441 329L440 329L440 329L439 328L439 328L439 328L439 328L439 327L439 328L438 328L437 327L437 327L437 327L436 327L436 327z"
        },
        {
            "title": "Inavolu",
            "d": "M428 363L428 363L427 362L427 362L427 362L426 361L426 362L426 362L425 362L425 362L425 362L425 362L425 362L423 361L423 362L423 363L422 363L421 364L421 364L421 364L420 364L420 365L419 365L418 365L418 365L417 365L417 366L418 366L418 367L418 368L418 368L418 369L418 369L417 370L417 371L417 372L418 373L418 374L418 374L418 374L418 374L420 374L420 374L420 375L420 375L421 375L420 376L419 376L418 379L418 381L418 382L418 383L418 382L419 382L422 383L422 384L421 385L422 386L421 386L422 387L422 387L422 387L422 387L423 387L423 387L423 387L424 387L424 387L425 388L426 388L427 388L428 388L428 388L428 388L429 387L429 387L429 386L429 387L429 386L429 385L429 384L430 384L430 384L430 384L430 384L431 384L432 383L432 383L433 383L433 381L434 380L435 382L436 382L436 382L436 382L437 382L438 382L438 382L439 381L439 381L439 381L439 381L439 380L439 380L439 380L439 378L438 377L438 376L438 376L439 375L439 375L439 374L439 374L439 374L439 374L439 374L437 373L437 373L436 372L435 372L435 371L434 371L435 370L435 369L434 369L433 369L431 367L430 366L429 366L429 365L429 365L429 364L428 364L428 363z"
        },
        {
            "title": "Kamalapur",
            "d": "M433 307L431 306L431 306L431 306L431 306L430 306L430 306L429 305L429 305L428 306L428 306L428 307L428 307L428 308L428 309L426 310L426 311L424 311L424 310L424 310L423 310L423 310L423 310L423 310L422 310L422 310L422 310L422 310L422 311L421 310L421 311L421 311L421 311L421 312L421 312L420 312L419 312L419 312L418 312L417 312L417 312L417 313L417 313L416 312L416 313L416 313L416 313L415 313L415 314L415 315L415 315L415 315L414 315L414 315L414 316L415 317L415 317L415 317L416 318L416 318L416 318L416 318L415 319L415 319L415 320L414 320L414 320L414 320L413 320L413 320L414 321L413 321L413 322L413 322L413 322L413 323L412 324L412 324L413 324L413 324L414 324L414 324L414 324L415 324L415 324L416 324L416 324L417 324L417 325L417 325L418 325L418 325L418 325L419 325L419 326L419 327L419 328L419 328L420 328L420 328L420 328L420 328L421 329L421 329L422 329L424 329L424 329L424 329L424 329L425 329L425 328L425 328L425 328L425 328L426 328L427 328L427 328L427 328L428 328L428 328L428 329L428 329L429 329L429 329L430 330L430 331L430 331L430 330L430 330L430 330L430 331L430 331L430 331L430 331L430 331L431 331L431 331L431 331L431 330L432 331L432 331L433 331L433 331L433 331L433 331L433 330L432 330L432 329L432 328L432 328L433 327L433 327L433 327L433 327L433 327L435 327L435 327L435 327L435 327L435 327L435 327L436 327L436 327L436 327L436 327L436 326L437 326L437 324L437 325L437 324L436 324L437 323L437 322L437 322L437 322L437 321L438 320L438 320L438 320L439 320L439 320L437 319L438 319L437 318L437 318L436 318L436 317L436 316L436 315L436 315L436 314L436 314L436 314L435 314L435 314L435 313L435 312L435 312L434 312L434 311L434 311L434 311L434 311L434 311L434 310L434 310L433 310L433 309L433 309L433 309L433 309L433 309L433 308L433 308L433 307z"
        },
        {
            "title": "Khaazipet",
            "d": "M418 350L418 350L417 350L417 350L416 350L414 350L414 349L413 349L413 349L413 351L413 351L413 352L413 353L412 353L412 354L412 354L412 354L412 354L412 354L412 354L411 356L411 356L411 357L410 358L409 359L409 359L409 360L409 360L408 361L408 361L408 362L408 364L409 365L409 366L411 367L411 367L411 367L412 367L414 366L414 366L415 366L415 365L416 366L417 365L418 365L418 365L419 365L420 365L420 364L421 364L421 364L421 364L422 363L423 363L423 362L423 361L425 362L425 362L425 362L425 362L425 362L426 362L426 362L426 361L427 362L427 362L427 362L428 363L428 363L429 363L429 363L429 363L430 363L431 364L431 363L431 363L431 363L431 363L431 362L430 362L431 362L430 361L431 361L431 360L431 360L431 359L431 359L431 358L431 358L431 358L431 357L430 357L431 356L431 356L431 356L432 356L432 355L432 356L433 355L433 355L433 355L433 355L433 355L433 355L433 355L433 354L433 354L433 354L433 354L433 354L434 354L432 354L432 354L432 353L432 354L430 353L430 353L429 354L429 354L428 354L428 354L427 354L426 353L424 354L423 354L423 354L423 354L423 353L422 353L422 353L421 353L421 352L420 352L420 351L419 351L418 351L418 350z"
        },
        {
            "title": "Parkal",
            "d": "M445 308L445 308L445 308L445 309L444 309L444 309L444 310L444 310L444 311L444 311L444 311L445 311L445 311L445 311L446 311L446 312L446 311L446 312L447 311L447 311L448 311L447 313L447 314L447 315L447 315L447 315L448 315L447 315L448 315L448 315L448 315L448 316L448 316L448 316L448 316L449 316L449 316L449 316L448 317L448 317L448 318L448 318L448 318L448 319L448 319L448 320L447 320L447 320L447 320L446 320L445 321L445 321L445 321L445 321L445 321L445 321L445 321L444 321L444 322L444 322L444 322L444 323L444 323L445 323L445 323L446 324L446 324L446 324L447 325L446 326L449 327L449 327L450 327L451 328L452 327L453 328L454 328L454 327L454 325L455 325L455 325L455 325L456 325L456 325L456 325L456 325L456 325L456 325L456 325L456 324L456 323L456 323L456 322L456 322L456 322L456 322L455 321L456 321L455 321L456 320L457 320L457 320L457 319L457 319L457 318L457 318L456 318L456 318L457 318L457 317L457 317L457 318L458 317L458 317L458 317L458 317L458 317L458 316L458 316L458 316L457 316L457 316L457 316L457 316L457 316L457 316L457 315L457 315L456 315L457 314L456 314L456 314L455 314L455 313L455 312L455 312L455 311L455 310L455 310L455 310L454 310L454 310L454 310L454 310L453 310L453 309L452 309L452 309L452 308L452 308L452 308L452 308L452 308L452 308L452 307L452 307L452 307L453 307L453 306L453 305L453 304L453 304L452 304L452 303L452 303L451 305L451 305L450 305L451 305L450 305L450 306L450 306L450 306L450 306L449 306L449 306L449 307L448 307L448 307L448 307L447 307L447 307L447 308L446 308L446 308L445 308z"
        },
        {
            "title": "Shayampet",
            "d": "M476 324L475 324L471 325L469 324L469 323L469 323L468 323L468 322L468 322L468 322L468 321L468 321L467 321L465 321L464 321L463 321L462 321L461 321L461 321L461 321L461 321L461 321L461 321L460 321L460 321L460 321L460 320L459 320L458 319L458 319L458 319L458 319L458 319L458 318L457 318L457 319L457 319L457 320L457 320L456 320L455 321L456 321L455 321L456 322L456 322L456 322L456 322L456 323L456 323L456 324L456 325L456 325L456 325L456 325L456 325L456 325L456 325L455 325L455 325L455 325L454 325L454 327L454 328L453 328L452 327L451 328L450 327L449 327L449 327L446 326L446 327L446 328L446 328L446 329L446 329L446 329L446 329L446 330L446 330L446 330L446 330L446 330L447 330L447 330L448 330L448 331L448 331L448 331L448 331L448 331L449 331L449 331L449 332L449 332L450 332L450 332L450 332L451 332L452 332L452 333L452 333L452 333L452 333L452 333L452 333L452 333L452 334L453 334L453 334L454 334L454 335L454 335L454 335L454 334L455 334L455 334L455 334L456 334L456 334L456 334L457 334L456 334L457 334L457 335L457 335L457 335L458 335L458 335L458 335L458 334L459 335L459 334L460 334L460 334L460 335L460 335L460 336L461 336L461 336L461 336L461 336L461 336L462 336L462 335L462 336L462 336L462 336L463 335L463 335L463 335L463 335L463 334L464 334L464 334L464 334L464 334L465 333L465 333L465 333L466 334L466 334L466 334L466 334L466 334L466 334L467 334L467 334L467 334L467 334L468 334L468 334L468 334L468 334L468 334L468 334L469 334L469 333L470 332L469 331L470 331L470 331L471 331L472 332L475 330L476 329L478 326L476 324L476 324z"
        },
        {
            "title": "Velair",
            "d": "M399 343L399 343L398 342L397 343L397 342L397 342L396 342L396 342L396 342L396 342L395 342L393 342L393 342L393 342L393 342L392 343L392 343L392 343L392 344L391 347L392 347L392 347L391 347L391 348L390 348L390 347L389 347L389 347L389 347L389 347L388 347L388 347L388 347L387 347L387 347L387 347L386 347L386 348L386 348L385 348L385 348L385 349L385 349L385 349L384 350L384 350L384 350L383 351L383 350L382 351L381 351L381 350L380 350L380 350L379 350L378 349L378 349L378 349L378 349L375 352L375 352L375 352L375 353L376 353L380 354L380 354L381 354L381 354L382 355L382 355L381 357L381 358L381 359L382 359L383 359L384 359L384 359L384 359L385 359L386 359L386 359L387 360L387 360L388 360L388 360L388 360L389 360L392 361L393 362L394 363L394 362L395 362L395 362L395 361L395 361L396 361L396 361L396 361L396 361L396 360L397 360L397 359L397 358L398 358L398 358L398 357L399 356L398 355L397 355L397 355L396 355L395 355L395 354L395 354L394 354L394 353L394 353L394 353L394 353L394 353L394 352L394 352L394 352L395 352L395 352L395 350L395 350L396 350L396 350L396 350L396 350L396 350L396 350L396 350L397 350L397 350L397 350L397 350L397 350L397 350L397 349L397 349L397 349L397 349L397 349L398 349L397 348L398 348L399 347L399 346L399 346L399 344L399 343z"
        },
        {
            "title": "Nadikuda",
            "d": "M445 308L445 308L445 307L445 307L445 307L444 307L444 307L444 307L444 307L443 306L443 306L443 306L443 306L443 306L443 305L443 305L443 305L442 305L442 305L442 305L441 304L441 304L440 305L439 305L439 305L439 306L439 306L439 306L438 306L438 306L438 306L437 306L436 306L436 306L436 306L436 306L435 306L435 306L435 306L435 306L435 306L434 306L434 306L434 306L434 307L434 307L433 307L433 308L433 308L433 309L433 309L433 309L433 309L433 309L433 310L434 310L434 310L434 311L434 311L434 311L434 311L434 311L434 312L435 312L435 312L435 313L435 314L435 314L436 314L436 314L436 314L436 315L436 315L436 316L436 317L436 318L437 318L437 318L438 319L437 319L439 320L439 320L438 320L438 320L438 320L437 321L437 322L437 322L437 322L437 323L436 324L437 324L437 325L437 324L437 326L436 326L436 327L436 327L436 327L437 327L437 327L437 327L438 328L439 328L439 327L439 328L439 328L439 328L439 328L440 329L440 329L440 329L441 329L441 329L441 328L441 328L442 328L442 327L442 327L443 327L443 327L443 328L444 328L445 328L445 328L445 328L446 328L446 328L446 327L446 326L447 325L446 324L446 324L446 324L445 323L445 323L444 323L444 323L444 322L444 322L444 322L444 321L445 321L445 321L445 321L445 321L445 321L445 321L445 321L446 320L447 320L447 320L447 320L448 320L448 319L448 319L448 318L448 318L448 318L448 317L448 317L449 316L449 316L449 316L448 316L448 316L448 316L448 316L448 315L448 315L448 315L447 315L448 315L447 315L447 315L447 315L447 314L447 313L448 311L447 311L447 311L446 312L446 311L446 312L446 311L445 311L445 311L445 311L444 311L444 311L444 311L444 310L444 310L444 309L444 309L445 309L445 308L445 308L445 308z"
        }
    ],
    "Jangaon": [
        {
            "title": "Bachannapet",
            "d": "M352 373L352 372L351 373L351 372L350 372L349 372L349 372L349 372L348 372L347 373L346 373L346 373L346 373L345 374L345 374L345 374L344 374L344 374L343 373L343 372L342 372L341 372L341 372L340 372L340 372L340 372L339 372L339 373L339 373L338 374L338 374L338 374L338 374L337 375L337 376L336 377L336 378L336 378L335 379L335 378L335 378L335 378L335 377L335 376L334 375L333 375L333 375L331 375L329 375L329 375L329 375L328 375L328 375L327 374L327 373L327 373L327 372L326 372L326 372L325 372L325 372L325 372L324 373L324 373L324 373L323 374L323 374L322 374L323 374L323 374L323 375L323 375L323 375L323 375L323 375L323 376L322 376L322 376L323 376L323 377L322 377L323 378L323 378L323 378L322 378L321 378L320 378L319 379L318 379L317 380L317 380L316 380L315 380L315 382L315 382L315 383L315 383L315 383L315 383L316 383L317 383L318 383L318 383L319 384L319 384L319 384L320 384L319 384L320 384L320 383L321 383L324 384L326 385L327 386L327 386L328 387L328 387L330 387L330 386L333 386L333 385L334 385L334 385L335 386L335 386L336 387L335 387L336 389L337 390L336 392L336 392L336 393L336 393L336 394L337 394L337 395L337 395L337 396L337 396L337 396L339 397L339 398L340 399L340 399L340 399L341 399L341 400L342 401L343 401L343 400L343 399L343 399L344 398L344 398L344 398L344 398L344 397L345 397L345 396L346 395L347 394L347 394L348 392L348 392L348 391L348 391L349 390L349 390L350 389L350 388L350 387L350 387L350 387L350 387L350 387L350 386L349 386L349 386L349 385L348 384L349 384L350 382L351 382L351 380L351 380L351 380L352 380L352 381L352 381L353 381L353 380L354 379L354 378L353 377L352 377L352 376L352 376L352 376L352 376L352 376L352 376L353 375L353 375L353 375L353 375L353 374L353 374L353 374L353 374L353 374L353 374L353 373L352 373L352 373L352 373L352 373z"
        },
        {
            "title": "Chilpur",
            "d": "M394 363L393 362L392 361L389 360L388 360L388 360L388 360L387 360L387 360L386 359L386 359L385 359L384 359L384 359L384 359L383 359L382 359L381 359L381 358L381 357L382 355L382 355L381 354L381 354L380 354L380 354L376 353L375 353L374 353L373 355L374 355L373 356L373 356L372 357L371 357L371 357L370 358L371 359L371 359L371 359L372 359L372 359L372 359L373 360L372 360L372 360L373 360L373 360L374 361L374 361L374 361L375 362L376 363L375 363L375 364L376 365L375 367L376 368L375 370L375 370L376 370L378 369L379 369L381 369L382 370L382 370L382 370L382 370L383 371L384 371L385 372L385 372L386 372L388 373L388 373L388 373L388 375L389 375L390 375L392 376L393 377L394 374L394 374L395 374L395 374L396 372L396 372L397 372L398 372L398 372L398 372L399 372L400 372L401 372L401 372L401 372L402 372L402 372L403 373L403 373L403 372L404 372L405 372L405 372L406 372L407 373L408 373L408 373L409 372L410 372L410 372L410 372L411 372L411 371L411 370L411 370L411 369L411 369L411 368L411 367L409 366L409 366L408 367L408 367L407 368L407 368L406 369L406 369L406 369L405 369L405 369L404 368L403 369L403 368L403 368L403 368L402 368L402 368L402 367L402 367L402 367L401 368L401 368L400 368L399 367L399 367L398 367L398 367L398 366L397 366L396 365L396 365L395 365L395 364L394 363L394 363L394 363z"
        },
        {
            "title": "Devaruppula",
            "d": "M402 424L402 423L402 422L402 421L402 421L402 421L402 420L401 420L398 420L399 419L399 419L399 418L400 417L399 417L399 416L398 413L396 412L395 412L394 412L394 412L394 412L393 412L393 412L393 412L394 411L394 410L395 407L394 407L393 406L392 407L392 407L392 407L391 407L389 407L389 407L389 407L389 407L389 407L389 407L388 409L388 409L388 410L388 410L389 410L389 410L389 411L387 410L387 410L386 410L386 410L385 409L385 409L384 409L384 408L383 409L383 409L383 410L383 410L383 411L384 411L384 411L384 412L384 413L383 414L382 415L381 417L381 417L380 418L380 418L380 418L380 418L380 418L379 419L378 419L378 419L378 419L377 419L377 419L376 419L376 419L375 419L374 419L374 419L374 419L373 419L373 419L372 419L372 419L372 420L372 420L371 421L372 421L372 422L373 423L374 423L374 423L374 425L374 426L377 426L378 427L379 427L380 425L381 424L381 424L382 423L383 424L384 425L384 425L384 425L384 426L384 426L384 426L385 427L385 427L385 427L386 428L386 427L387 428L388 428L388 429L387 429L389 430L389 430L389 430L389 431L389 432L389 432L389 432L390 433L392 433L392 433L393 433L393 433L394 433L394 433L395 433L395 433L398 435L399 435L400 435L400 435L400 435L400 434L400 434L400 434L400 434L400 433L400 433L400 433L401 433L401 433L401 432L401 432L401 431L400 431L400 430L400 429L400 428L400 428L400 427L400 427L400 427L401 426L402 424L402 424z"
        },
        {
            "title": "Ghanpur (Stn)",
            "d": "M407 373L406 372L405 372L405 372L404 372L403 372L403 373L403 373L402 372L402 372L401 372L401 372L401 372L400 372L399 372L398 372L398 372L398 372L397 372L396 372L396 372L395 374L395 374L394 374L394 374L393 377L392 376L390 375L389 375L388 375L388 373L388 373L388 373L386 372L385 372L385 372L384 371L383 371L382 370L382 370L382 370L382 370L381 369L379 369L378 369L376 370L375 370L375 370L378 375L379 376L381 378L385 382L386 383L387 383L388 384L390 385L390 385L391 385L391 385L392 385L393 384L393 383L394 382L394 383L395 383L395 383L396 385L397 385L397 385L397 385L398 385L398 386L398 387L397 388L396 389L396 389L395 389L395 390L394 390L394 390L394 391L394 391L393 391L393 391L392 392L392 392L393 392L393 392L393 393L393 393L393 393L394 394L393 395L394 397L394 397L394 398L393 399L394 399L394 399L395 399L396 399L398 399L399 399L399 399L400 399L400 398L400 398L401 397L402 395L402 396L403 396L404 395L404 394L405 393L405 393L406 391L406 391L406 390L405 388L404 387L403 387L404 385L404 384L405 384L406 384L406 384L406 384L406 383L407 383L406 382L406 382L406 381L406 380L406 380L405 379L405 379L404 378L404 378L404 377L404 377L404 377L405 377L406 377L406 377L407 375L407 374L407 374L407 374L407 373z"
        },
        {
            "title": "Jangoan",
            "d": "M367 380L363 379L361 378L361 378L360 378L359 378L358 378L358 380L358 380L357 380L355 381L355 382L354 382L353 381L353 382L352 381L352 381L352 381L352 380L351 380L351 380L351 380L351 382L350 382L349 384L348 384L349 385L349 386L349 386L350 386L350 387L350 387L350 387L350 387L350 387L350 388L350 389L349 390L349 390L348 391L348 391L348 392L348 392L347 394L347 394L346 395L345 396L345 397L344 397L344 398L344 398L344 398L345 398L346 398L347 399L348 399L348 399L348 399L348 399L348 399L349 400L349 400L350 400L350 400L350 401L350 401L351 402L351 402L351 402L351 403L351 404L352 405L352 405L353 405L353 405L352 406L353 406L353 406L353 406L353 406L353 407L354 407L356 408L357 408L357 408L357 407L358 408L358 407L358 407L359 405L360 403L361 403L361 403L362 403L363 403L364 403L364 402L364 402L365 401L365 401L365 400L365 400L366 399L366 399L366 398L368 398L368 399L369 399L369 399L369 399L370 400L370 399L371 400L371 398L371 397L371 397L371 396L370 396L370 396L370 396L370 395L370 395L370 394L369 393L369 392L368 392L368 391L367 391L366 391L366 390L367 389L368 388L366 385L367 385L367 385L367 384L368 382L369 381L368 380L367 380L367 380z"
        },
        {
            "title": "Lingalaghanpur",
            "d": "M371 400L370 399L370 400L369 399L369 399L369 399L368 399L368 398L366 398L366 399L366 399L365 400L365 400L365 401L365 401L364 402L364 402L364 403L363 403L362 403L361 403L361 403L360 403L359 405L358 407L358 407L358 408L358 408L358 410L358 411L358 412L359 412L359 413L360 413L360 413L360 415L361 415L362 416L362 416L362 416L362 417L362 418L362 419L361 420L362 421L362 421L362 422L363 422L363 423L364 423L364 424L364 423L366 422L366 422L366 421L366 421L367 420L367 420L368 420L370 416L370 415L371 416L372 417L372 417L373 418L373 418L372 419L373 419L373 419L374 419L374 419L374 419L375 419L376 419L376 419L377 419L377 419L378 419L378 419L378 419L379 419L380 418L380 418L380 418L380 418L380 418L381 417L381 417L382 415L383 414L384 413L384 412L384 411L384 411L383 411L383 410L383 410L383 409L383 409L384 408L384 409L385 409L385 409L386 410L386 410L387 410L387 410L389 411L389 410L389 410L388 410L388 410L388 409L388 409L389 407L389 407L389 407L389 407L388 407L388 406L388 405L388 405L388 405L388 405L387 404L387 404L386 404L385 403L385 404L383 403L383 403L382 401L382 401L381 401L379 400L378 401L378 401L377 401L377 402L375 403L375 403L375 403L374 402L374 402L373 401L371 400z"
        },
        {
            "title": "Narmetta",
            "d": "M375 367L374 366L373 366L373 366L373 366L372 365L371 365L371 366L370 366L370 366L370 366L370 367L369 367L369 367L369 367L369 368L369 368L369 368L369 368L368 367L367 367L365 365L364 365L364 366L364 366L364 366L364 365L363 365L363 366L362 366L362 366L361 365L360 365L360 365L359 364L358 364L356 362L356 363L355 363L355 364L354 364L354 365L354 366L356 367L356 367L356 367L357 367L357 367L357 368L356 368L356 368L355 368L355 369L354 369L354 370L353 371L353 372L352 373L352 373L352 373L352 373L353 373L353 374L353 374L353 374L353 374L353 374L353 374L353 375L353 375L353 375L353 375L352 376L352 376L352 376L352 376L352 376L352 376L352 377L353 377L354 378L354 379L353 380L353 381L352 381L352 381L353 382L353 381L354 382L355 382L355 381L357 380L358 380L358 380L358 378L359 378L360 378L361 378L361 378L363 379L367 380L367 379L368 378L368 377L368 376L369 375L370 376L370 376L370 376L371 376L371 376L373 378L374 378L374 378L375 378L375 377L376 377L377 377L378 376L378 376L379 376L378 375L375 370L376 368L375 367z"
        },
        {
            "title": "Palakurthy",
            "d": "M416 402L416 402L412 403L411 401L410 401L410 401L409 400L409 400L409 400L409 399L409 399L409 398L409 398L409 398L409 397L409 397L407 396L408 395L408 394L408 394L405 393L405 393L404 394L404 395L403 396L402 396L402 395L401 397L400 398L400 398L400 399L399 399L399 399L398 399L396 399L395 399L394 399L394 399L394 400L394 400L394 400L394 401L394 401L394 401L394 402L394 402L395 402L395 402L395 402L395 402L395 402L395 403L394 404L394 405L394 405L394 406L394 406L394 407L395 407L394 410L394 411L393 412L393 412L393 412L394 412L394 412L394 412L395 412L396 412L398 413L399 416L399 417L400 417L399 418L399 419L399 419L398 420L401 420L402 420L402 421L402 421L402 421L402 422L402 423L402 424L403 424L405 424L405 424L405 424L405 424L405 424L407 424L408 424L408 425L408 425L408 425L407 427L408 427L409 427L409 427L410 427L412 427L412 427L412 426L414 426L414 426L414 426L415 425L415 425L415 425L416 424L416 423L417 423L417 423L417 422L418 421L418 421L419 421L419 421L420 422L420 422L421 422L421 422L421 422L422 422L423 421L424 421L424 421L424 421L424 421L425 420L425 419L425 417L425 416L426 415L425 415L423 414L423 414L423 413L423 413L423 413L423 413L423 412L423 411L422 410L421 409L421 410L420 410L419 410L419 409L417 409L417 409L417 409L417 408L417 408L416 407L416 407L416 407L417 404L417 404L417 403L417 403L416 402z"
        },
        {
            "title": "Ragunathpally",
            "d": "M379 376L378 376L378 376L377 377L376 377L375 377L375 378L374 378L374 378L373 378L371 376L371 376L370 376L370 376L370 376L369 375L368 376L368 377L368 378L367 379L367 380L367 380L368 380L369 381L368 382L367 384L367 385L367 385L366 385L368 388L367 389L366 390L366 391L367 391L368 391L368 392L369 392L369 393L370 394L370 395L370 395L370 396L370 396L370 396L371 396L371 397L371 397L371 398L371 400L373 401L374 402L374 402L375 403L375 403L375 403L377 402L377 401L378 401L378 401L379 400L381 401L382 401L382 401L383 403L383 403L385 404L385 403L386 404L387 404L387 404L388 405L388 405L388 405L388 405L388 406L388 407L389 407L389 407L389 407L391 407L392 407L392 407L392 407L393 406L394 407L394 406L394 406L394 405L394 405L394 404L395 403L395 402L395 402L395 402L395 402L395 402L394 402L394 402L394 401L394 401L394 401L394 400L394 400L394 400L394 399L393 399L394 398L394 397L394 397L393 395L394 394L393 393L393 393L393 393L393 392L393 392L392 392L392 392L393 391L393 391L394 391L394 391L394 390L394 390L395 390L395 389L396 389L396 389L397 388L398 387L398 386L398 385L397 385L397 385L397 385L396 385L395 383L395 383L394 383L394 382L393 383L393 384L392 385L391 385L391 385L390 385L390 385L388 384L387 383L386 383L385 382L381 378L379 376z"
        },
        {
            "title": "Tharigoppula",
            "d": "M375 352L371 351L369 351L369 351L369 351L369 351L368 351L368 351L368 351L368 351L368 350L367 352L366 352L365 352L364 352L363 352L363 352L362 352L362 352L360 354L361 357L360 357L359 358L359 359L359 359L358 360L358 360L357 361L357 362L357 362L356 362L358 364L359 364L360 365L360 365L361 365L362 366L362 366L363 366L363 365L364 365L364 366L364 366L364 366L364 365L365 365L367 367L368 367L369 368L369 368L369 368L369 368L369 367L369 367L369 367L370 367L370 366L370 366L370 366L371 366L371 365L372 365L373 366L373 366L373 366L374 366L375 367L376 365L375 364L375 363L376 363L375 362L374 361L374 361L374 361L373 360L373 360L372 360L372 360L373 360L372 359L372 359L372 359L371 359L371 359L371 359L370 358L371 357L371 357L372 357L373 356L373 356L374 355L373 355L374 353L375 353L375 352z"
        },
        {
            "title": "Zaffergadh",
            "d": "M422 387L421 386L422 386L421 385L422 384L422 383L419 382L418 382L418 383L418 382L418 381L418 379L419 376L420 376L421 375L420 375L420 375L420 374L420 374L418 374L418 374L418 374L418 374L418 373L417 372L417 371L417 370L417 370L417 370L416 370L415 370L414 372L414 372L414 372L413 372L413 373L413 373L411 372L410 372L410 372L410 372L409 372L408 373L408 373L407 373L407 374L407 374L407 374L407 375L406 377L406 377L405 377L404 377L404 377L404 377L404 378L404 378L405 379L405 379L406 380L406 380L406 381L406 382L406 382L407 383L406 383L406 384L406 384L406 384L405 384L404 384L404 385L403 387L404 387L405 388L406 390L406 391L406 391L405 393L408 394L408 394L408 395L407 396L409 397L409 397L409 398L409 398L409 398L409 399L409 399L409 400L409 400L409 400L410 401L410 401L411 401L412 403L416 402L416 402L416 401L417 401L417 401L418 400L419 400L419 400L420 398L419 398L418 396L417 396L417 395L416 395L417 394L417 393L420 395L420 394L421 392L421 391L422 390L421 390L422 390L421 388L422 387L422 387z"
        },
        {
            "title": "Kodakandla",
            "d": "M421 422L421 422L420 422L420 422L419 421L419 421L418 421L418 421L417 422L417 423L417 423L416 423L416 424L415 425L415 425L415 425L414 426L414 426L414 426L412 426L412 427L412 427L410 427L409 427L409 427L408 427L407 427L408 425L408 425L408 425L408 424L407 424L405 424L405 424L405 424L405 424L405 424L403 424L402 424L402 424L401 426L400 427L400 427L400 427L400 428L400 428L400 429L400 430L400 431L401 431L401 432L401 432L401 433L401 433L400 433L400 433L400 433L400 434L400 434L400 434L400 434L400 435L400 435L403 437L403 437L404 437L404 437L405 438L405 437L406 437L406 437L407 436L407 434L410 435L411 435L411 435L412 435L412 435L412 435L412 435L412 435L414 435L414 435L417 436L418 438L419 438L419 438L419 438L419 438L419 438L420 438L420 438L421 439L422 439L422 439L422 438L423 437L423 437L423 437L423 437L423 437L423 436L424 434L425 433L426 433L426 433L425 432L425 432L425 432L425 430L425 430L425 429L424 429L424 429L424 428L423 428L423 428L423 428L422 427L421 426L421 426L421 426L421 425L421 425L422 424L421 423L421 423L421 423L421 422zM425 420L426 421L427 421L428 421L428 421L429 419L429 419L429 417L429 417L427 416L426 415L426 414L426 413L426 413L425 414L425 415L426 415L425 416L425 417L425 419L425 420z"
        }
    ],
    "Kamareddy": [
        {
            "title": "Banswada",
            "d": "M169 271L166 270L166 273L161 272L160 272L157 273L156 273L157 273L156 274L156 274L156 274L156 275L155 275L155 275L154 275L154 275L154 275L154 276L154 276L154 276L154 277L154 277L154 277L152 277L152 277L151 277L151 277L151 277L151 277L150 277L150 279L150 279L150 279L150 279L150 279L150 279L150 279L150 279L150 279L150 279L150 278L150 278L150 278L150 277L149 277L149 277L149 277L149 278L149 277L149 277L149 277L149 277L148 277L148 276L148 276L147 276L148 276L147 275L146 275L146 275L146 275L146 276L146 276L146 276L147 277L147 277L147 278L147 278L147 279L147 280L147 280L147 280L147 280L147 280L147 281L147 281L147 282L147 283L147 284L149 285L149 286L151 287L151 287L152 289L152 289L152 291L153 292L153 292L154 292L156 293L157 293L159 293L159 293L160 294L160 293L161 292L161 291L161 289L162 289L161 289L161 288L160 288L160 287L160 284L160 284L162 283L162 283L163 282L164 283L165 283L165 282L166 281L168 281L169 281L169 280L170 280L170 280L170 280L171 280L171 280L171 280L171 280L171 280L171 280L171 280L171 280L172 281L172 280L172 280L172 280L172 279L172 278L173 278L173 278L174 278L175 277L176 277L176 277L178 277L179 276L178 276L178 275L177 274L177 274L177 273L177 273L176 273L175 273L174 273L172 272L171 271L169 271z"
        },
        {
            "title": "Bhiknoor",
            "d": "M249 312L249 312L248 312L248 312L248 312L248 312L247 313L247 313L247 313L246 313L246 313L246 312L246 313L246 312L245 313L245 313L245 313L244 314L244 314L244 314L244 314L243 314L243 313L243 313L243 312L242 312L242 311L242 310L242 310L241 310L241 310L241 310L240 310L240 310L240 310L240 310L240 309L240 309L240 309L240 308L240 308L240 308L240 308L240 308L240 307L240 307L240 306L240 305L239 306L239 305L239 305L240 305L240 304L240 304L240 304L240 303L240 303L240 303L239 302L239 302L238 302L237 302L237 302L235 301L235 301L235 302L235 302L234 302L234 303L234 303L233 303L233 303L233 303L234 304L235 305L234 306L234 307L234 307L234 308L233 309L233 310L234 310L234 310L233 311L233 312L232 313L232 313L232 313L231 313L231 313L231 313L231 313L230 313L230 313L230 313L229 313L229 313L229 313L229 313L229 314L227 315L228 316L228 317L228 317L228 317L228 318L228 318L228 318L228 319L229 319L229 319L232 320L232 320L232 320L233 322L233 323L233 323L233 324L234 326L236 327L236 328L236 327L237 327L238 327L238 327L239 327L239 327L240 327L240 327L241 326L241 326L241 325L242 325L242 325L242 323L243 322L243 322L243 322L243 322L244 322L244 321L245 322L245 322L246 324L246 325L245 326L245 327L246 328L247 328L248 328L249 328L249 328L250 328L250 327L250 327L251 328L252 327L252 327L253 327L254 327L254 326L253 326L253 326L253 325L252 325L252 325L252 324L253 323L253 323L254 322L254 321L255 319L254 318L254 318L254 318L254 318L253 318L253 317L253 317L253 317L253 316L253 316L252 316L252 315L251 315L251 315L251 315L251 315L251 315L251 314L251 314L251 314L251 314L250 314L250 314L250 313L250 313L250 313L250 313L250 313L250 313L249 312z"
        },
        {
            "title": "Bibipet",
            "d": "M259 302L259 302L259 302L259 302L259 302L259 302L259 302L258 302L258 302L258 303L258 303L257 303L257 303L257 303L257 304L257 304L257 304L257 304L257 305L257 305L257 305L257 305L257 306L257 307L256 307L256 307L256 306L254 307L253 306L252 306L252 306L251 307L251 308L252 308L252 308L252 308L253 309L252 309L252 309L252 310L252 311L251 311L251 310L251 310L250 311L250 311L250 311L250 311L250 311L250 312L249 312L249 312L249 312L249 312L250 313L250 313L250 313L250 313L250 313L250 313L250 314L250 314L251 314L251 314L251 314L251 314L251 315L251 315L251 315L251 315L251 315L252 315L252 316L253 316L253 316L253 317L253 317L253 317L253 318L254 318L254 318L254 318L254 318L255 319L257 320L257 320L257 320L257 320L257 320L257 320L257 320L258 321L259 318L259 318L259 317L260 317L260 318L260 318L260 318L260 318L260 318L260 317L261 318L261 317L261 317L261 318L262 318L262 318L262 318L262 318L263 318L263 318L263 319L263 319L264 319L264 319L265 319L265 319L266 319L266 319L266 319L266 319L266 318L266 318L266 317L266 317L266 317L266 317L266 316L266 315L266 314L265 314L265 314L266 312L266 311L266 311L266 311L266 310L265 310L265 310L265 309L265 309L264 306L264 306L264 306L265 306L266 306L266 306L265 305L265 304L263 303L263 303L263 303L262 302L262 302L262 302L262 302L261 303L261 303L261 302L260 303L260 302L259 302z"
        },
        {
            "title": "Gandhari",
            "d": "M196 266L196 265L196 265L195 265L195 265L194 264L194 264L193 264L193 264L193 264L192 264L191 264L191 264L190 264L190 263L190 263L190 263L189 262L189 262L188 262L188 262L188 262L187 262L187 262L187 262L186 261L186 261L184 261L183 262L183 263L182 262L181 263L181 264L180 264L180 264L180 264L180 265L180 265L179 265L179 266L179 266L179 267L179 269L179 270L179 270L178 270L178 270L178 271L178 271L177 272L178 273L177 273L177 274L177 274L178 275L178 276L179 276L178 277L176 277L176 277L175 277L174 278L173 278L173 278L172 278L172 279L172 280L172 280L172 280L172 281L171 280L171 280L171 280L171 280L171 280L171 280L171 280L171 280L170 280L170 280L170 280L169 280L169 281L168 281L166 281L165 282L165 283L164 283L163 282L162 283L162 283L160 284L160 284L160 287L160 288L161 288L163 289L163 289L163 289L164 289L165 288L165 289L165 289L165 289L165 289L167 290L167 289L168 290L169 289L170 289L171 293L173 293L177 293L178 291L179 290L179 289L179 288L180 287L181 287L182 287L182 287L182 287L183 287L183 287L183 287L183 287L182 288L183 288L183 288L183 289L183 290L183 291L184 291L184 292L184 292L184 292L185 293L185 293L185 293L186 294L186 294L187 294L187 293L188 294L188 294L188 293L189 293L189 293L190 293L192 294L192 294L192 294L192 294L192 294L192 295L192 295L193 295L193 294L193 294L193 294L193 294L194 294L194 294L195 294L195 294L195 294L196 294L196 293L197 292L198 292L199 292L199 292L201 292L201 292L201 291L203 291L203 290L202 290L201 289L201 289L199 288L199 288L198 287L198 286L198 285L199 284L199 284L199 284L200 284L200 283L200 283L201 283L201 283L201 281L202 280L202 280L202 280L202 279L202 279L202 278L202 277L202 277L202 276L202 275L202 274L202 274L202 274L201 273L202 273L201 272L202 272L201 271L201 271L200 271L198 270L198 270L197 270L196 271L196 270L196 270L196 270L196 268L196 267L196 267L196 266z"
        },
        {
            "title": "Jukkal",
            "d": "M104 270L103 271L102 271L102 271L101 272L101 271L100 271L100 271L99 271L98 270L97 270L97 270L96 270L96 270L96 271L96 271L96 272L96 273L97 273L97 274L100 275L100 275L100 275L100 276L100 277L99 280L98 280L98 280L97 280L97 280L97 281L97 281L95 283L95 284L94 285L94 285L94 287L95 288L96 288L97 289L100 290L101 291L102 292L102 294L101 294L99 295L99 296L99 297L99 297L100 298L101 298L101 298L102 297L102 296L102 296L103 296L103 297L104 298L107 298L107 296L108 295L108 294L109 295L109 295L110 295L110 295L110 295L110 295L111 295L112 295L112 295L113 294L114 294L114 294L115 294L116 293L117 293L117 293L117 292L118 292L118 292L118 292L118 291L119 292L119 293L118 293L118 294L118 294L118 295L119 295L119 294L120 295L121 295L122 294L124 294L124 294L124 294L124 294L125 293L126 291L126 291L126 291L126 291L126 291L126 290L126 290L126 290L126 290L125 290L125 290L125 290L125 290L125 290L125 290L125 289L125 289L124 289L124 289L124 288L124 288L125 288L125 288L125 288L124 287L124 287L124 287L124 287L124 286L123 286L124 286L124 286L124 286L124 286L124 286L123 285L123 285L123 285L123 284L122 284L122 284L121 284L120 284L119 283L119 283L119 283L119 283L118 282L118 282L117 282L117 282L118 281L117 281L117 281L117 281L116 281L114 280L114 280L114 280L114 280L114 279L115 279L115 279L115 279L115 278L115 278L115 277L114 277L114 277L114 277L114 276L113 276L112 275L112 276L111 276L111 276L110 276L108 276L108 276L107 276L106 276L106 275L106 274L107 273L107 271L107 271L106 271L105 270L104 270z"
        },
        {
            "title": "Kamareddy",
            "d": "M241 283L241 283L239 282L239 282L239 283L239 283L239 283L239 284L239 284L239 284L238 284L238 285L238 284L238 285L238 284L237 285L237 285L237 285L237 285L236 284L236 284L236 284L236 283L235 283L235 283L235 283L235 283L235 282L235 282L234 282L234 283L234 283L234 282L233 282L233 283L233 283L233 283L233 283L232 284L232 284L231 283L230 282L230 282L230 282L230 282L229 282L229 281L229 282L228 282L227 282L228 283L227 284L228 284L228 284L228 284L228 285L228 285L229 285L229 285L229 286L229 286L229 286L229 286L229 286L228 286L228 286L228 286L227 286L227 285L227 285L227 285L226 285L226 285L226 286L226 286L226 286L225 286L225 286L225 286L225 287L225 287L224 287L224 287L224 287L223 287L221 288L221 289L220 289L221 289L220 289L220 290L220 291L221 291L221 291L220 292L220 292L221 292L221 292L221 294L222 294L221 294L222 295L222 295L222 295L222 295L222 296L222 296L222 296L223 297L223 297L223 297L223 298L224 298L223 298L224 299L223 299L223 299L223 300L222 300L222 300L222 300L223 301L222 301L222 301L222 301L222 302L222 302L222 303L222 303L222 305L222 305L223 305L224 304L225 304L226 303L226 303L226 303L227 303L228 303L229 303L230 303L230 303L231 303L232 304L233 304L233 304L233 303L233 303L233 303L234 303L234 303L234 302L235 302L235 302L235 301L235 301L235 300L235 299L236 299L236 298L236 298L236 298L237 298L237 298L238 298L238 298L239 298L240 298L240 298L240 298L240 298L241 298L241 298L241 298L241 297L242 298L242 298L242 298L242 298L242 298L243 297L243 297L243 298L244 297L243 297L242 296L239 296L238 295L238 295L237 295L237 295L238 294L237 293L237 292L237 292L237 291L237 291L237 291L237 291L237 291L237 291L237 290L237 290L237 290L238 289L239 289L239 289L240 288L240 288L240 287L240 287L239 286L239 286L239 286L239 285L240 285L241 283z"
        },
        {
            "title": "Lingampet",
            "d": "M203 291L201 291L201 292L201 292L199 292L199 292L198 292L197 292L196 293L196 294L195 294L195 294L195 294L194 294L194 294L193 294L193 294L193 294L193 294L193 295L192 295L192 295L192 294L192 294L192 294L192 294L192 294L190 293L189 293L189 293L188 293L188 294L188 294L187 293L187 294L186 294L186 294L185 293L185 293L185 293L184 292L184 292L184 292L184 291L183 291L183 290L183 289L183 288L183 288L182 288L183 287L183 287L183 287L183 287L182 287L182 287L182 287L181 287L180 287L179 288L179 289L179 290L178 291L177 293L177 293L178 294L178 295L179 297L179 298L178 299L179 299L179 302L179 303L179 303L180 303L180 304L180 304L181 304L181 305L182 305L182 305L182 305L183 306L184 305L187 305L186 307L187 308L187 309L187 311L188 311L188 314L188 314L188 315L189 318L190 321L190 322L191 325L192 326L192 326L193 326L193 326L195 325L196 323L197 322L197 320L197 320L197 320L197 320L197 320L197 320L196 320L196 320L197 320L197 319L197 319L197 319L196 319L196 319L197 319L197 319L197 319L197 319L198 320L198 321L198 321L199 321L200 321L201 319L201 318L201 318L201 318L201 318L201 318L202 313L203 313L203 313L204 313L206 312L208 312L208 312L207 307L206 305L204 303L204 302L204 302L204 301L205 300L206 300L206 299L206 299L206 299L206 299L206 298L205 298L205 298L204 297L203 297L204 296L204 296L204 296L204 296L204 295L204 294L203 292L203 291L203 291z"
        },
        {
            "title": "Machareddy",
            "d": "M254 300L254 300L254 300L254 300L255 300L255 300L255 300L257 300L257 300L257 300L257 300L257 300L257 300L257 300L258 300L258 301L259 301L259 301L259 301L259 301L259 301L259 301L259 300L259 300L259 300L259 300L259 299L260 299L260 299L260 299L261 299L261 299L262 298L261 296L262 296L262 296L262 295L262 293L262 293L263 293L264 292L263 290L263 290L263 289L263 288L262 288L262 287L260 286L260 284L261 283L261 282L263 283L264 283L264 283L265 283L265 283L265 283L266 283L266 282L266 282L264 280L264 280L263 279L262 278L262 278L262 277L264 276L264 276L264 276L263 276L263 275L263 275L263 274L262 272L261 270L260 269L259 269L259 269L258 269L258 270L258 270L258 271L258 271L257 271L257 272L256 272L255 273L254 274L254 275L254 275L253 275L253 275L253 276L253 277L253 278L253 278L252 278L252 279L252 281L252 282L252 282L252 282L252 283L252 283L251 283L251 284L251 285L250 285L250 285L248 287L247 289L247 290L247 291L248 291L248 292L248 293L248 294L248 294L248 294L249 295L250 296L251 295L251 296L251 296L251 296L252 296L253 295L253 295L253 296L254 296L254 297L254 297L254 297L253 298L253 299L253 299L254 300L254 300z"
        },
        {
            "title": "Madnur",
            "d": "M120 254L118 255L118 255L118 255L117 256L117 256L116 255L116 255L116 254L115 254L115 254L116 254L116 252L116 252L116 251L114 251L113 253L113 253L112 253L112 252L113 252L112 252L111 252L110 252L109 252L108 252L107 252L107 254L107 254L107 255L106 255L106 256L106 256L106 256L107 256L107 256L108 256L108 256L108 256L108 257L108 257L108 257L107 258L107 258L106 258L105 259L105 260L107 261L107 261L108 261L108 262L109 263L108 264L108 265L107 265L106 264L106 263L105 263L104 263L103 264L103 265L103 266L102 266L101 266L101 266L101 266L99 266L99 266L99 266L99 267L99 268L102 267L102 268L103 268L105 268L105 269L105 269L105 270L105 270L105 270L105 270L104 270L105 270L106 271L107 271L107 271L107 273L106 274L106 275L106 276L107 276L108 276L108 276L110 276L111 276L111 276L112 276L112 275L113 276L114 276L114 277L114 277L114 277L115 277L115 278L115 278L115 279L115 279L115 279L114 279L114 280L114 280L114 280L114 280L116 281L116 280L116 280L116 279L116 279L117 279L117 278L117 278L118 278L118 278L119 277L119 277L119 277L119 276L119 276L119 275L119 273L119 273L120 273L120 273L120 273L121 273L121 273L122 273L122 273L122 273L123 273L123 273L123 273L123 273L123 273L124 273L124 273L124 273L125 272L126 272L126 272L127 270L127 270L127 270L127 270L128 269L128 269L128 268L127 268L126 268L126 268L125 268L125 268L124 267L124 266L124 266L124 266L122 266L121 266L121 266L120 266L120 265L120 263L119 263L119 263L119 263L118 263L118 263L118 263L118 262L117 262L117 262L117 262L117 262L117 262L117 261L115 260L116 260L116 259L116 259L119 259L119 258L119 257L120 255L120 254L120 254L120 254z"
        },
        {
            "title": "Nagi_Reddypet",
            "d": "M200 321L199 321L198 321L198 321L198 320L197 319L197 319L197 319L197 319L196 319L196 319L197 319L197 319L197 319L197 320L196 320L196 320L197 320L197 320L197 320L197 320L197 320L197 320L197 322L196 323L195 325L193 326L193 326L192 326L192 326L191 325L190 322L190 321L189 318L188 315L188 314L188 314L184 316L183 316L183 316L183 317L183 317L183 317L183 318L183 318L183 319L183 319L183 319L183 320L183 320L183 320L183 320L183 320L183 320L183 321L183 321L183 321L183 321L182 321L181 322L181 323L181 324L181 324L180 325L180 325L180 324L180 324L180 324L179 324L179 324L178 324L178 324L178 323L178 323L177 323L177 322L177 322L176 322L176 323L176 323L176 323L176 323L176 324L176 324L176 324L176 325L176 325L176 326L176 327L175 327L175 328L175 329L175 330L175 330L174 330L175 331L175 331L176 331L176 332L176 332L176 332L178 332L179 332L179 333L180 333L182 334L183 335L186 335L187 336L187 337L188 337L188 337L188 336L189 336L189 334L189 333L189 333L190 332L190 332L191 333L191 333L191 334L191 335L191 336L191 336L191 336L192 336L193 336L194 336L195 336L195 337L196 337L197 336L197 334L197 334L198 334L198 334L198 334L199 334L200 333L201 332L201 332L202 332L202 332L202 330L201 328L202 328L202 328L202 328L202 327L202 327L202 326L202 326L202 325L202 325L202 325L202 324L202 324L201 324L201 323L201 323L200 323L200 323L200 323L200 323L200 323L200 321z"
        },
        {
            "title": "Nasurullabad",
            "d": "M149 260L147 260L146 261L146 261L146 262L146 262L145 263L146 266L146 266L146 266L146 266L146 266L146 266L146 267L146 267L146 267L147 267L146 268L145 269L145 269L145 270L144 270L144 271L144 271L143 272L143 273L145 273L145 273L146 272L146 271L146 271L148 272L148 272L149 272L150 272L150 272L150 273L149 274L150 274L150 274L150 274L150 274L150 274L151 274L151 274L151 274L151 274L151 275L151 275L151 275L150 275L150 275L151 275L151 276L150 276L150 276L150 277L151 277L151 277L151 277L151 277L152 277L152 277L154 277L154 277L154 277L154 276L154 276L154 276L154 275L154 275L154 275L155 275L155 275L156 275L156 274L156 274L156 274L157 273L156 273L157 273L160 272L161 272L166 273L166 270L169 271L169 270L170 269L169 268L169 268L169 268L169 267L168 266L165 264L163 263L160 263L159 263L158 263L157 263L156 262L155 262L154 262L151 260L150 261L149 261L149 260z"
        },
        {
            "title": "Nizamsagar",
            "d": "M156 302L155 301L155 301L155 301L154 301L153 300L153 300L153 298L153 298L153 297L152 296L152 295L151 295L151 296L151 296L150 296L150 296L150 298L150 298L150 299L150 299L150 299L150 300L150 301L149 301L149 302L149 303L150 303L150 304L150 304L150 305L150 305L150 305L150 305L150 305L150 306L150 306L150 306L151 306L150 307L150 307L150 307L148 309L148 310L148 310L148 311L148 311L147 312L147 313L147 313L148 313L148 312L149 312L150 313L150 313L150 313L150 314L150 314L150 314L150 315L150 315L151 315L151 315L152 315L153 315L153 316L153 316L154 315L154 315L155 315L155 315L155 315L156 315L156 315L156 315L157 315L156 315L156 316L156 316L156 317L156 317L156 317L156 318L156 318L157 319L157 319L157 319L156 319L156 319L155 319L155 319L156 320L155 320L155 320L155 320L156 320L156 321L156 320L156 320L157 321L157 321L158 321L158 321L159 321L159 321L159 321L159 322L159 322L160 322L160 322L160 322L160 322L160 322L160 322L160 322L160 322L161 322L161 322L161 321L161 321L162 321L163 322L163 323L163 323L163 323L163 324L163 325L163 325L161 327L161 328L161 329L160 329L160 328L160 328L160 328L160 328L160 328L160 328L159 328L159 328L159 328L159 328L159 328L158 328L158 329L158 329L158 330L158 330L158 330L158 330L158 330L157 330L157 330L157 329L157 330L157 330L157 330L156 331L156 330L156 331L156 331L156 331L156 331L156 332L155 332L155 332L155 332L155 332L155 332L155 332L156 332L156 331L157 331L158 331L158 331L158 331L158 331L158 331L159 331L159 331L159 331L160 331L160 330L161 331L161 330L161 330L162 329L162 329L162 329L162 327L162 327L163 327L163 326L165 326L165 325L165 326L166 325L167 325L168 326L168 326L169 326L170 325L170 325L170 325L170 325L171 325L171 325L171 325L171 325L171 325L171 326L171 325L172 325L172 325L173 326L174 326L175 325L175 325L175 325L174 325L173 325L173 325L173 324L173 323L173 323L173 323L174 323L174 322L174 322L173 322L173 322L173 322L173 321L173 320L173 320L173 320L173 320L172 320L172 321L171 321L171 320L171 320L171 320L172 319L172 319L173 320L173 320L173 319L173 318L172 318L172 318L173 318L173 318L173 317L172 318L172 318L172 317L172 317L172 317L171 317L171 317L171 317L171 317L171 317L171 317L171 317L171 316L171 316L171 316L171 316L170 316L170 316L170 317L170 317L170 315L167 311L168 310L168 309L168 308L168 308L168 308L167 308L168 308L167 307L167 308L165 310L165 310L165 310L166 308L165 307L165 307L165 307L164 307L163 307L162 307L162 307L162 306L162 306L161 304L161 304L160 304L159 303L158 303L156 302z"
        },
        {
            "title": "Pedda Kodapgal",
            "d": "M139 291L138 291L137 291L136 291L135 292L134 291L133 292L133 293L132 294L132 294L132 294L132 294L132 295L132 295L131 295L131 295L130 295L129 296L129 295L127 295L127 294L129 294L128 292L128 292L128 292L128 292L128 292L128 292L128 292L128 292L127 292L127 291L127 291L127 291L127 290L127 289L126 290L126 289L127 288L127 287L128 287L129 287L129 285L129 285L129 285L128 284L128 285L127 285L127 285L127 285L127 285L126 285L126 286L126 286L125 286L125 286L125 287L125 288L125 288L125 288L124 288L124 288L124 289L124 289L125 289L125 289L125 290L125 290L125 290L125 290L125 290L125 290L126 290L126 290L126 290L126 290L126 291L126 291L126 291L126 291L126 291L125 293L124 294L124 294L124 294L124 294L122 294L121 295L120 295L119 294L119 295L118 295L118 294L118 294L118 293L119 293L119 292L118 291L118 292L118 292L118 292L117 292L117 293L117 293L116 293L115 294L114 294L114 294L113 294L112 295L112 295L111 295L110 295L110 295L110 295L110 295L109 295L109 295L108 294L108 295L107 296L107 298L108 299L108 299L108 299L107 299L107 299L107 299L108 299L108 299L108 299L109 299L110 299L111 299L111 298L112 298L112 298L114 298L114 298L114 298L115 298L115 298L116 298L116 298L116 298L116 298L117 298L117 298L118 299L119 299L119 299L120 299L120 301L121 302L122 302L122 302L124 302L124 302L124 302L124 303L124 303L125 303L126 303L127 303L128 304L128 305L128 305L130 305L131 306L131 306L131 306L133 306L135 307L135 307L136 307L136 306L136 305L135 304L135 304L134 303L134 302L135 301L135 301L135 301L136 300L136 300L136 300L137 300L137 298L137 298L137 298L137 298L136 297L137 297L137 296L138 296L138 296L138 296L139 295L139 294L139 293L139 293L138 292L139 291z"
        },
        {
            "title": "Rajampet",
            "d": "M233 303L233 304L233 304L232 304L231 303L230 303L230 303L229 303L228 303L227 303L226 303L226 303L226 303L225 304L224 304L223 305L222 305L222 305L222 306L222 306L222 306L221 306L220 306L219 306L219 306L219 306L218 307L218 308L217 307L216 307L216 306L215 306L215 306L215 307L214 307L214 307L214 308L213 308L213 308L212 309L212 312L208 312L209 317L211 320L211 320L211 320L212 321L212 322L212 322L213 322L214 322L216 324L218 323L219 323L218 323L220 321L222 320L222 320L223 320L223 320L223 320L224 314L225 315L227 315L229 314L229 313L229 313L229 313L229 313L230 313L230 313L230 313L231 313L231 313L231 313L231 313L232 313L232 313L232 313L233 312L233 311L234 310L234 310L233 310L233 309L234 308L234 307L234 307L234 306L235 305L234 304L233 303z"
        },
        {
            "title": "Ramareddy",
            "d": "M254 274L254 274L254 274L252 274L252 274L251 273L251 272L251 272L250 270L247 267L246 267L245 267L244 267L243 267L242 267L241 266L239 266L239 266L238 268L239 268L237 269L236 270L233 271L232 270L231 270L231 270L230 269L230 269L230 269L225 269L225 270L224 270L224 270L224 270L224 272L224 272L224 273L224 274L225 274L225 274L225 274L225 274L225 274L225 275L225 275L225 275L225 276L225 276L225 277L225 277L225 277L224 278L224 278L224 279L224 280L224 280L224 281L225 281L225 281L225 282L225 282L225 282L225 282L225 282L225 282L225 282L226 282L226 283L226 283L226 283L227 283L227 283L227 283L227 283L227 283L227 282L227 282L227 282L227 282L227 282L227 282L227 282L227 282L227 282L227 282L228 282L229 282L229 281L229 282L230 282L230 282L230 282L230 282L231 283L232 284L232 284L233 283L233 283L233 283L233 283L233 282L234 282L234 283L234 283L234 282L235 282L235 282L235 283L235 283L235 283L235 283L236 283L236 284L236 284L236 284L237 285L237 285L237 285L237 285L238 284L238 285L238 284L238 285L238 284L239 284L239 284L239 284L239 283L239 283L239 283L239 282L239 282L241 283L241 283L242 283L242 283L245 282L246 282L247 283L248 283L250 284L250 285L251 285L251 284L251 283L252 283L252 283L252 282L252 282L252 282L252 281L252 279L252 278L253 278L253 278L253 277L253 276L253 275L253 275L254 275L254 275L254 274z"
        },
        {
            "title": "Sadashivnagar",
            "d": "M224 270L222 270L221 270L220 271L220 271L220 271L220 271L219 271L219 271L219 271L219 271L219 270L219 270L218 270L218 270L218 271L217 271L216 270L216 270L216 269L215 268L216 268L215 268L216 267L215 265L214 265L214 265L214 265L213 265L212 265L212 265L212 264L212 264L211 264L211 264L210 264L210 265L210 265L210 264L208 263L207 262L207 262L206 262L206 261L206 261L206 261L205 261L205 261L205 261L204 262L204 262L203 262L203 262L203 262L202 263L202 264L201 264L201 265L201 265L200 266L199 266L198 266L196 266L196 267L196 267L196 268L196 270L196 270L196 270L196 271L197 270L198 270L198 270L200 271L201 271L201 271L202 272L201 272L202 273L201 273L202 274L202 274L202 274L202 275L202 276L202 277L202 277L202 278L202 279L202 279L202 280L202 280L202 280L201 281L201 283L201 283L201 283L201 283L201 283L201 283L202 284L202 284L203 283L204 283L205 283L205 283L205 283L206 283L206 284L206 285L206 285L207 285L208 285L208 285L209 285L209 286L210 285L210 285L211 285L211 285L212 285L212 285L212 284L213 284L213 283L214 283L214 283L214 283L214 283L216 283L216 284L216 284L216 284L216 285L216 285L216 285L216 286L216 286L217 286L217 287L217 287L217 287L217 287L218 287L218 287L219 288L219 288L219 288L220 288L220 288L220 288L220 288L220 288L220 288L221 288L221 288L223 287L224 287L224 287L224 287L225 287L225 287L225 286L225 286L225 286L226 286L226 286L226 286L226 285L226 285L227 285L227 285L227 285L227 286L228 286L228 286L228 286L229 286L229 286L229 286L229 286L229 286L229 285L229 285L228 285L228 285L228 284L228 284L228 284L227 284L228 283L227 282L227 282L227 282L227 282L227 282L227 282L227 282L227 282L227 282L227 282L227 283L227 283L227 283L227 283L227 283L226 283L226 283L226 283L226 282L225 282L225 282L225 282L225 282L225 282L225 282L225 282L225 281L225 281L224 281L224 280L224 280L224 279L224 278L224 278L225 277L225 277L225 277L225 276L225 276L225 275L225 275L225 275L225 274L225 274L225 274L225 274L225 274L224 274L224 273L224 272L224 272L224 270z"
        },
        {
            "title": "Tadwai",
            "d": "M221 288L221 288L220 288L220 288L220 288L220 288L220 288L220 288L219 288L219 288L219 288L218 287L218 287L217 287L217 287L217 287L217 287L217 286L216 286L216 286L216 285L216 285L216 285L216 284L216 284L216 284L216 283L214 283L214 283L214 283L214 283L213 283L213 284L212 284L212 285L212 285L211 285L211 285L210 285L210 285L209 286L209 285L208 285L208 285L207 285L206 285L206 285L206 284L206 283L205 283L205 283L205 283L204 283L203 283L202 284L202 284L201 283L201 283L201 283L201 283L201 283L201 283L201 283L200 283L200 283L200 284L199 284L199 284L199 284L198 285L198 286L198 287L199 288L199 288L201 289L201 289L202 290L203 290L203 291L203 291L203 292L204 294L204 295L204 296L204 296L204 296L204 296L203 297L204 297L205 298L205 298L206 298L206 299L206 299L206 299L206 299L206 300L205 300L204 301L204 302L204 302L204 303L206 305L207 307L208 312L212 312L212 309L213 308L213 308L214 308L214 307L214 307L215 307L215 306L215 306L216 306L216 307L217 307L218 308L218 307L219 306L219 306L219 306L220 306L221 306L222 306L222 306L222 306L222 305L222 305L222 305L222 303L222 303L222 302L222 302L222 301L222 301L222 301L223 301L222 300L222 300L222 300L223 300L223 299L223 299L224 299L223 298L224 298L223 298L223 297L223 297L223 297L222 296L222 296L222 296L222 295L222 295L222 295L222 295L221 294L222 294L221 294L221 292L221 292L220 292L220 292L221 291L221 291L220 291L220 290L220 289L221 289L220 289L221 289L221 288z"
        },
        {
            "title": "Yellareddy",
            "d": "M188 314L188 311L187 311L187 309L187 308L186 307L187 305L184 305L183 306L182 305L182 305L182 305L181 305L181 304L180 304L180 304L180 303L179 303L179 303L179 302L179 299L178 299L179 298L179 297L178 295L178 294L177 293L177 293L173 293L171 293L170 294L169 294L169 296L167 298L167 298L168 299L168 299L168 300L168 300L169 300L169 301L169 301L170 301L170 301L170 302L170 302L171 303L171 303L171 304L171 304L170 304L170 304L170 304L169 305L169 305L169 305L168 305L168 305L168 305L167 305L167 305L167 305L167 305L166 305L166 306L166 306L166 307L165 307L166 308L165 310L165 310L165 310L167 308L167 307L168 308L167 308L168 308L168 308L168 308L168 309L168 310L167 311L170 315L170 317L170 317L170 316L170 316L171 316L171 316L171 316L171 316L171 317L171 317L171 317L171 317L171 317L171 317L171 317L172 317L172 317L172 317L172 318L172 318L173 317L173 318L173 318L172 318L172 318L173 318L173 319L173 320L173 320L172 319L172 319L171 320L171 320L171 320L171 321L172 321L172 320L173 320L173 320L173 320L173 320L173 321L173 322L173 322L173 322L174 322L174 322L174 323L173 323L173 323L173 323L173 324L173 325L173 325L174 325L175 325L175 325L175 325L174 326L173 326L172 325L172 325L171 325L171 326L171 325L171 325L171 325L171 325L171 325L170 325L170 325L170 325L170 325L169 326L168 326L168 326L167 325L166 325L165 326L165 325L165 326L163 326L163 327L164 327L165 328L166 328L166 328L169 329L170 330L171 329L172 329L172 329L172 329L172 329L173 329L173 329L174 330L175 330L175 330L175 329L175 328L175 327L176 327L176 326L176 325L176 325L176 324L176 324L176 324L176 323L176 323L176 323L176 323L176 322L177 322L177 322L177 323L178 323L178 323L178 324L178 324L179 324L179 324L180 324L180 324L180 324L180 325L180 325L181 324L181 324L181 323L181 322L182 321L183 321L183 321L183 321L183 321L183 320L183 320L183 320L183 320L183 320L183 320L183 319L183 319L183 319L183 318L183 318L183 317L183 317L183 317L183 316L183 316L184 316L188 314z"
        },
        {
            "title": "Domakonda",
            "d": "M243 298L243 297L243 297L242 298L242 298L242 298L242 298L242 298L241 297L241 298L241 298L241 298L240 298L240 298L240 298L240 298L239 298L238 298L238 298L237 298L237 298L236 298L236 298L236 298L236 299L235 299L235 300L235 301L235 301L235 301L237 302L237 302L238 302L239 302L239 302L240 303L240 303L240 303L240 304L240 304L240 304L240 305L239 305L239 305L239 306L240 305L240 306L240 307L240 307L240 308L240 308L240 308L240 308L240 308L240 309L240 309L240 309L240 310L240 310L240 310L240 310L241 310L241 310L241 310L242 310L242 310L242 311L242 312L243 312L243 313L243 313L243 314L244 314L244 314L244 314L244 314L245 313L245 313L245 313L246 312L246 313L246 312L246 313L246 313L247 313L247 313L247 313L248 312L248 312L248 312L248 312L249 312L249 312L249 312L249 312L249 312L250 312L250 311L250 311L250 311L250 311L250 311L251 310L251 310L251 311L252 311L252 310L252 309L252 309L253 309L252 308L252 308L252 308L251 308L251 307L252 306L252 306L253 306L254 307L256 306L256 307L256 307L257 307L257 306L257 305L257 305L257 305L257 305L257 304L257 304L257 304L257 304L257 303L257 303L257 303L258 303L258 303L258 302L258 302L259 302L259 302L259 302L259 302L259 302L259 302L259 302L259 301L259 301L259 301L258 301L258 300L257 300L257 300L257 300L257 300L257 300L257 300L257 300L255 300L255 300L255 300L254 300L254 300L254 300L254 300L252 302L252 302L251 303L251 303L251 304L251 304L250 304L250 304L250 303L248 303L248 303L247 302L247 302L246 302L246 302L245 301L244 301L243 300L243 300L244 299L244 298L243 298z"
        },
        {
            "title": "Pitlam",
            "d": "M147 284L145 282L145 283L144 285L144 285L144 286L144 286L144 287L144 287L143 288L143 288L143 289L143 291L141 291L141 291L140 290L140 290L139 290L139 291L138 292L139 293L139 293L139 294L139 295L138 296L138 296L138 296L137 296L137 297L136 297L137 298L137 298L137 298L137 298L137 300L136 300L136 300L136 300L135 301L135 301L135 301L134 302L134 303L135 304L135 304L136 305L136 306L136 307L135 307L135 307L133 306L131 306L131 306L131 306L130 305L128 305L128 306L128 307L128 307L128 307L129 307L129 309L130 309L130 309L130 309L131 309L130 310L131 311L130 311L130 312L129 312L130 312L130 312L130 312L131 312L131 312L133 312L133 312L133 313L134 315L135 315L135 315L135 315L136 315L136 315L136 314L136 314L136 313L136 313L137 313L137 313L137 313L138 313L138 313L138 313L139 312L139 312L139 312L140 313L141 313L141 314L143 314L144 314L145 314L144 314L144 314L144 313L144 313L144 313L145 313L145 313L146 312L147 313L147 313L147 312L148 311L148 311L148 310L148 310L148 309L150 307L150 307L150 307L151 306L150 306L150 306L150 306L150 305L150 305L150 305L150 305L150 305L150 304L150 304L150 303L149 303L149 302L149 301L150 301L150 300L150 299L150 299L150 299L150 298L150 298L150 296L150 296L151 296L151 296L151 295L152 295L152 296L153 297L153 298L153 298L153 300L153 300L154 301L155 301L155 301L155 301L156 302L155 301L155 300L155 298L155 297L155 295L154 293L153 292L153 292L152 291L152 289L152 289L151 287L151 287L149 286L149 285L147 284z"
        },
        {
            "title": "Bichkunda",
            "d": "M134 265L133 265L132 264L132 264L132 264L131 263L131 263L131 263L131 263L130 263L130 263L130 263L129 264L130 264L130 264L130 264L130 265L129 265L129 265L129 265L129 265L129 265L130 265L130 266L130 266L130 266L130 266L130 266L130 266L130 266L130 266L130 266L130 267L130 267L129 267L129 267L129 266L129 266L129 267L128 267L127 267L127 267L126 267L126 267L125 268L125 268L126 268L126 268L127 268L128 268L128 269L128 269L127 270L127 270L127 270L127 270L126 272L126 272L125 272L124 273L124 273L124 273L123 273L123 273L123 273L123 273L123 273L122 273L122 273L122 273L121 273L121 273L120 273L120 273L120 273L119 273L119 273L119 275L119 276L119 276L119 277L119 277L119 277L118 278L118 278L117 278L117 278L117 279L116 279L116 279L116 280L116 280L116 281L117 281L117 281L117 281L118 281L117 282L117 282L118 282L118 282L119 283L119 283L119 283L119 283L120 284L121 284L122 284L122 284L123 284L123 285L123 285L123 285L124 286L124 286L124 286L124 286L124 286L123 286L124 286L124 287L124 287L124 287L124 287L125 288L125 287L125 286L125 286L126 286L126 286L126 285L127 285L127 285L127 285L127 285L128 285L128 284L129 285L129 285L129 285L129 287L128 287L127 287L127 288L126 289L126 290L127 289L127 290L127 291L127 291L127 291L127 292L128 292L128 292L128 292L128 292L128 292L128 292L128 292L128 292L129 294L127 294L127 295L129 295L129 296L130 295L131 295L131 295L132 295L132 295L132 294L132 294L132 294L132 294L133 293L133 292L134 291L135 292L136 291L137 291L138 291L139 291L139 290L140 290L140 290L141 291L141 291L143 291L143 289L143 288L143 288L144 287L144 287L144 286L144 286L144 285L144 285L145 283L145 282L144 280L142 279L142 279L140 278L139 276L139 275L137 273L137 272L137 271L136 270L136 270L135 269L135 268L134 267L134 266L134 265z"
        },
        {
            "title": "Birkoor",
            "d": "M146 261L146 261L146 261L145 261L145 261L144 261L144 261L144 261L144 261L144 261L142 261L142 261L141 261L141 261L141 261L140 261L139 262L139 262L139 262L139 262L138 261L138 261L138 261L138 261L137 261L136 260L136 261L136 261L134 261L134 262L134 263L134 264L134 265L134 266L134 267L135 268L135 269L136 270L136 270L137 271L137 272L137 273L139 275L139 276L140 278L142 279L142 279L144 280L145 282L147 284L147 283L147 282L147 281L147 281L147 280L147 280L147 280L147 280L147 280L147 279L147 278L147 278L147 277L147 277L146 276L146 276L146 276L146 275L146 275L146 275L147 275L148 276L147 276L148 276L148 276L148 277L149 277L149 277L149 277L149 277L149 278L149 277L149 277L149 277L150 277L150 278L150 278L150 278L150 279L150 279L150 279L150 279L150 279L150 279L150 279L150 279L150 279L150 279L150 277L151 277L150 277L150 276L150 276L151 276L151 275L150 275L150 275L151 275L151 275L151 275L151 274L151 274L151 274L151 274L150 274L150 274L150 274L150 274L150 274L149 274L150 273L150 272L150 272L149 272L148 272L148 272L146 271L146 271L146 272L145 273L145 273L143 273L143 272L144 271L144 271L144 270L145 270L145 269L145 269L146 268L147 267L146 267L146 267L146 267L146 266L146 266L146 266L146 266L146 266L146 266L145 263L146 262L146 262L146 261L146 261z"
        },
        {
            "title": "Dongli",
            "d": "M125 268L126 267L126 267L127 267L127 267L128 267L129 267L129 266L129 266L129 267L129 267L130 267L130 267L130 266L130 266L130 266L130 266L130 266L130 266L130 266L130 266L130 266L130 265L129 265L129 265L129 265L129 265L129 265L130 265L130 264L130 264L130 264L129 264L130 263L130 263L130 263L131 263L131 263L131 263L131 263L132 264L132 264L132 264L133 265L134 265L134 264L134 263L134 262L134 261L134 259L135 258L135 257L134 255L134 254L133 252L133 252L132 251L132 251L131 251L129 252L128 252L127 252L126 251L125 252L124 252L123 253L122 253L122 253L121 253L121 253L120 254L120 254L120 254L120 254L120 255L119 257L119 258L119 259L116 259L116 259L116 260L115 260L117 261L117 262L117 262L117 262L117 262L117 262L118 262L118 263L118 263L118 263L119 263L119 263L119 263L120 263L120 265L120 266L121 266L121 266L122 266L124 266L124 266L124 266L124 267L125 268z"
        },
        {
            "title": "Palwancha",
            "d": "M250 285L250 284L248 283L247 283L246 282L245 282L242 283L242 283L241 283L240 285L239 285L239 286L239 286L239 286L240 287L240 287L240 288L240 288L239 289L239 289L238 289L237 290L237 290L237 290L237 291L237 291L237 291L237 291L237 291L237 291L237 292L237 292L237 293L238 294L237 295L237 295L238 295L238 295L239 296L242 296L243 297L244 297L243 298L244 298L244 299L243 300L243 300L244 301L245 301L246 302L246 302L247 302L247 302L248 303L248 303L250 303L250 304L250 304L251 304L251 304L251 303L251 303L252 302L252 302L254 300L254 300L253 299L253 299L253 298L254 297L254 297L254 297L254 296L253 296L253 295L253 295L252 296L251 296L251 296L251 296L251 295L250 296L249 295L248 294L248 294L248 294L248 293L248 292L248 291L247 291L247 290L247 289L248 287L250 285L250 285z"
        },
        {
            "title": "Mohammadnagar",
            "d": "M165 307L166 307L166 306L166 306L166 305L167 305L167 305L167 305L167 305L168 305L168 305L168 305L169 305L169 305L169 305L170 304L170 304L170 304L171 304L171 304L171 303L171 303L170 302L170 302L170 301L170 301L169 301L169 301L169 300L168 300L168 300L168 299L168 299L167 298L167 298L169 296L169 294L170 294L171 293L170 289L169 289L168 290L167 289L167 290L165 289L165 289L165 289L165 289L165 288L164 289L163 289L163 289L163 289L161 288L161 289L162 289L161 289L161 291L161 292L160 293L160 294L159 293L159 293L157 293L156 293L154 292L153 292L154 293L155 295L155 297L155 298L155 300L155 301L156 302L158 303L159 303L160 304L161 304L161 304L162 306L162 306L162 307L162 307L163 307L164 307L165 307L165 307L165 307z"
        }
    ],
    "Vikarabad": [
        {
            "title": "Bantwaram",
            "d": "M107 443L107 442L108 443L108 442L109 443L109 443L110 443L110 443L111 443L112 443L112 444L113 444L113 444L113 445L113 445L112 445L113 446L113 446L113 447L114 447L114 448L114 448L114 448L114 448L114 448L115 449L115 449L115 449L115 450L116 450L116 450L116 450L116 451L116 452L116 452L116 452L117 453L117 453L118 453L118 453L118 453L119 453L119 453L120 453L120 453L120 453L121 453L122 453L122 453L122 453L121 453L121 454L121 454L122 454L122 454L122 454L124 454L124 452L124 452L124 451L125 451L125 451L125 450L126 450L126 450L126 450L126 450L126 450L125 449L124 448L125 447L125 447L126 447L126 447L126 446L127 447L127 447L128 447L128 447L128 446L128 445L128 445L128 444L128 444L128 444L128 443L129 443L129 443L130 443L130 443L130 443L131 442L131 442L131 443L131 443L132 443L132 443L132 442L132 442L132 442L132 442L132 442L133 441L133 441L132 440L132 440L131 439L131 439L130 439L129 439L129 439L129 439L129 439L129 440L128 439L128 439L127 440L126 440L126 440L126 441L126 441L125 441L125 441L125 442L125 442L125 441L125 441L125 441L125 441L124 441L124 441L124 441L124 441L124 441L124 441L124 441L123 441L124 441L123 441L124 441L123 440L123 440L122 440L121 440L121 439L121 439L120 439L120 439L119 439L119 439L119 438L119 438L119 438L117 437L116 437L114 437L114 437L113 436L113 436L113 435L113 434L114 433L114 432L113 433L112 434L112 434L112 435L112 436L112 437L112 437L111 437L111 438L108 438L107 438L107 438L106 439L107 439L107 440L107 443z"
        },
        {
            "title": "Basheerabad",
            "d": "M79 472L78 472L78 472L77 474L76 474L76 474L75 475L74 475L74 476L74 477L74 478L72 478L72 477L72 477L71 478L71 478L70 479L67 480L67 481L68 482L68 482L69 482L71 482L71 482L71 483L71 483L70 483L70 483L70 484L69 484L69 485L69 485L69 485L69 485L68 485L68 485L67 485L67 485L66 485L66 485L66 486L65 486L65 487L66 487L65 488L65 489L65 489L65 490L64 491L64 491L64 491L64 491L64 491L65 491L64 492L65 492L66 492L67 493L66 495L68 495L68 495L71 496L71 496L71 497L73 498L74 498L76 499L76 499L77 499L77 499L78 499L78 499L79 499L79 500L80 500L80 500L81 500L81 500L81 500L83 498L83 498L83 498L84 497L84 496L84 496L84 496L83 496L83 496L83 495L82 495L83 494L83 494L83 493L83 492L83 492L83 491L83 490L83 489L85 489L85 488L85 488L86 488L86 489L87 489L87 489L87 489L87 489L87 489L88 489L88 489L88 489L88 489L89 489L89 489L90 489L90 489L90 490L90 490L91 490L91 490L92 490L92 490L92 490L92 490L92 489L92 488L92 488L92 488L92 488L92 488L92 487L92 487L92 486L93 486L93 486L93 484L93 483L92 483L91 483L91 482L91 481L91 481L91 481L91 480L91 480L91 479L90 479L90 479L90 479L91 477L91 476L91 476L91 476L92 476L92 476L92 475L92 475L91 475L91 474L90 473L90 473L89 474L88 473L87 473L87 473L86 473L85 473L84 473L83 474L83 474L83 474L82 474L82 473L82 473L82 473L82 473L82 473L80 473L79 472L79 472z"
        },
        {
            "title": "Bommaraspeta",
            "d": "M130 506L130 506L130 506L130 506L130 505L130 505L130 504L130 503L131 501L131 501L132 501L132 501L132 501L132 500L132 500L132 500L132 499L132 499L132 499L132 498L132 498L131 498L131 498L131 498L131 497L131 497L132 496L133 495L133 495L133 495L134 494L134 493L134 493L134 492L134 491L134 491L134 490L134 489L133 489L133 489L132 488L132 488L132 487L131 486L131 485L131 484L131 484L133 484L133 483L135 482L135 482L135 481L135 481L135 480L135 480L134 480L133 479L132 479L132 479L132 479L132 480L132 480L132 480L132 480L132 481L131 481L131 481L130 481L130 481L130 482L129 481L129 481L129 481L129 481L129 481L128 481L128 480L128 480L127 480L127 480L127 480L126 480L126 481L125 482L125 482L125 483L125 483L126 484L126 484L126 485L126 486L127 486L127 486L127 486L126 487L126 489L125 488L125 488L124 487L124 487L124 486L124 486L125 485L125 484L123 484L123 484L123 484L122 484L122 484L121 484L121 484L121 484L120 484L120 484L120 484L120 485L119 485L119 485L119 485L120 486L119 486L120 487L119 488L119 488L119 488L119 488L119 488L120 489L120 489L120 489L120 490L120 489L120 489L119 489L118 489L117 489L117 489L117 489L116 489L116 489L116 488L115 488L115 488L114 488L114 488L113 488L112 488L111 488L111 488L111 489L110 490L109 490L108 490L106 491L106 491L106 492L106 492L106 492L107 493L108 495L108 495L108 495L108 496L108 496L109 496L109 496L110 497L110 497L110 497L111 497L111 497L111 498L111 498L111 499L111 499L111 500L112 500L112 500L112 500L112 500L112 501L114 501L114 501L115 500L115 500L116 500L116 500L117 500L118 500L119 501L120 501L120 500L121 500L121 500L121 500L121 500L122 501L122 502L124 502L124 502L126 503L127 503L127 506L127 506L128 506L128 506L129 506L130 506z"
        },
        {
            "title": "Dharoor",
            "d": "M136 455L136 455L135 455L135 456L134 455L134 455L133 455L133 455L133 455L133 455L132 455L132 455L132 455L132 455L132 455L131 456L131 456L131 456L130 456L130 456L130 456L129 456L130 457L129 457L129 458L129 458L129 458L129 458L129 458L129 457L129 457L129 457L128 457L126 457L126 457L125 457L125 456L124 455L123 455L123 454L122 454L122 458L121 458L120 458L120 458L120 458L121 459L121 460L122 460L122 461L122 461L122 462L122 462L122 462L122 463L122 463L122 464L122 464L123 464L123 464L123 464L123 464L123 464L124 464L125 465L125 465L124 465L124 465L124 466L124 466L124 466L123 467L123 467L123 467L123 467L123 468L123 468L124 469L124 470L123 470L123 470L124 471L124 471L124 471L124 471L126 471L128 471L128 470L128 471L127 472L126 474L127 475L128 475L128 475L129 475L129 475L128 477L128 477L128 478L128 478L128 479L128 479L127 480L128 480L128 480L128 481L129 481L129 481L129 481L129 481L129 481L130 482L130 481L130 481L131 481L131 481L132 481L132 480L132 480L132 480L132 480L132 479L132 479L132 479L133 479L134 480L135 480L135 480L135 481L135 481L135 482L135 482L135 482L135 483L136 483L137 483L137 484L138 484L139 484L140 483L140 483L141 483L141 483L141 483L142 482L144 482L144 481L142 480L142 480L142 480L142 480L143 478L143 478L142 478L142 478L142 477L142 476L142 476L142 476L143 476L143 476L143 475L143 475L143 474L144 473L144 473L144 472L144 472L143 472L143 472L143 472L143 471L143 471L143 471L143 471L143 469L144 469L144 469L145 469L146 469L145 467L145 467L145 464L146 464L146 464L146 464L146 463L146 462L147 462L146 460L146 460L145 460L144 460L144 459L144 459L143 459L142 459L142 459L142 459L142 459L141 459L140 458L140 458L140 458L140 458L140 457L139 457L139 456L139 456L138 455L138 455L137 455L137 455L137 455L137 455L136 455L136 455z"
        },
        {
            "title": "Doma",
            "d": "M134 494L133 495L133 495L133 495L132 496L131 497L131 497L131 498L131 498L131 498L132 498L132 498L132 499L132 499L132 499L132 500L132 500L132 500L132 501L132 501L132 501L131 501L131 501L130 503L130 504L130 505L130 505L130 506L130 506L130 506L130 506L129 507L129 507L129 508L128 509L128 509L129 509L129 510L130 509L131 510L131 510L132 510L132 510L132 510L132 511L132 512L133 512L134 512L134 512L133 513L133 514L133 515L132 517L132 517L131 517L132 516L131 516L131 517L130 516L130 517L130 518L130 520L130 520L130 520L131 520L132 520L132 520L133 521L133 521L133 521L133 521L133 521L133 521L134 521L134 521L135 521L135 521L136 521L136 520L136 520L136 519L136 519L136 519L137 518L137 517L138 517L138 517L138 517L138 517L138 517L138 516L139 516L139 516L139 515L139 514L139 513L140 513L141 513L141 512L141 512L141 512L141 512L143 512L143 512L143 512L144 513L144 513L145 513L146 513L147 513L147 513L147 513L147 513L147 513L147 513L148 512L148 512L148 512L148 512L149 511L148 511L149 511L149 511L150 511L150 510L150 510L150 510L151 510L151 510L152 508L152 508L152 508L153 507L153 506L153 506L153 506L153 507L154 506L154 506L154 506L154 506L154 506L154 506L154 506L155 506L155 505L155 505L155 504L155 504L155 503L155 503L155 503L156 503L156 502L156 502L156 502L156 502L155 502L155 501L155 501L155 500L154 500L154 500L154 500L154 500L153 500L153 499L153 499L153 499L153 498L153 498L153 498L153 498L152 498L151 498L150 498L150 498L150 498L149 498L149 498L147 498L147 497L147 497L147 497L147 496L147 495L146 496L146 496L146 496L145 496L145 496L145 496L145 496L145 495L145 495L144 495L144 494L143 495L143 495L142 497L142 497L140 497L140 497L139 497L138 496L136 495L135 495L134 494z"
        },
        {
            "title": "Doulthabad",
            "d": "M104 513L104 513L104 513L103 513L103 514L103 513L102 513L102 513L101 512L101 512L101 510L102 510L101 509L100 509L99 508L99 508L98 507L97 508L97 508L97 508L97 509L96 508L96 508L96 508L96 509L95 509L95 509L95 510L95 509L94 509L92 509L92 509L92 510L92 510L92 511L92 511L92 512L92 513L92 514L92 514L92 514L91 514L90 513L90 513L90 513L89 513L89 513L88 512L88 512L88 512L87 511L86 511L86 512L86 512L86 512L86 514L86 515L86 516L87 517L87 518L86 518L86 518L85 518L85 518L85 518L84 519L84 519L83 520L83 520L83 521L83 521L83 524L83 524L83 525L82 526L82 527L82 527L83 527L83 527L85 528L85 528L86 528L86 528L87 528L87 528L89 528L90 528L90 529L90 529L89 530L89 531L89 531L90 532L91 531L92 531L92 531L92 531L92 531L92 532L94 534L94 534L94 534L94 534L94 535L95 536L95 536L96 536L96 536L97 535L97 535L98 535L98 536L99 536L99 536L99 535L100 535L101 534L101 534L102 534L102 534L102 534L102 533L102 532L102 531L102 531L102 531L103 531L103 530L103 529L103 528L105 529L105 528L106 528L106 528L106 528L106 528L107 527L107 525L107 525L107 525L107 525L107 524L107 524L107 523L107 522L108 522L108 522L109 522L110 521L111 521L110 521L111 520L111 520L112 519L112 518L111 518L111 518L111 518L110 518L110 519L110 519L109 519L109 519L109 519L108 519L108 519L108 519L109 518L109 518L109 517L109 517L109 517L109 517L109 517L109 517L109 516L109 517L109 517L108 517L108 517L107 517L107 516L106 516L106 516L105 516L105 515L105 515L105 515L105 515L104 515L104 515L104 514L104 514L104 513L104 513z"
        },
        {
            "title": "Kodangal",
            "d": "M92 490L91 490L91 490L90 490L90 490L90 489L90 489L89 489L89 489L88 489L88 489L88 489L88 489L87 489L87 489L87 489L87 489L87 489L86 489L86 488L85 488L85 488L85 489L83 489L83 490L83 491L83 492L83 492L83 493L83 494L83 494L82 495L83 495L83 496L83 496L84 496L84 496L84 496L84 497L83 498L83 498L83 498L81 500L81 500L81 501L80 501L81 502L80 503L81 503L81 504L81 504L83 505L83 505L83 506L83 506L83 506L83 507L83 507L84 509L84 509L84 510L85 510L85 510L85 511L84 511L84 511L86 512L86 511L87 511L88 512L88 512L88 512L89 513L89 513L90 513L90 513L90 513L91 514L92 514L92 514L92 514L92 513L92 512L92 511L92 511L92 510L92 510L92 509L92 509L94 509L95 509L95 510L95 509L95 509L96 509L96 508L96 508L96 508L97 509L97 508L97 508L97 508L98 507L99 508L99 508L100 509L101 509L102 510L101 510L101 512L101 512L102 513L102 513L103 513L103 514L103 513L104 513L104 513L104 513L105 513L106 512L106 510L106 510L106 510L106 509L108 509L108 509L108 509L109 509L111 509L111 509L111 509L112 508L112 508L112 508L113 508L113 508L114 508L114 508L115 509L116 509L117 509L117 510L118 510L121 510L122 510L122 510L122 509L122 508L122 508L123 507L123 506L122 505L121 505L120 505L120 505L119 505L119 505L118 505L117 505L116 505L116 505L116 505L115 504L114 504L114 503L113 503L113 502L113 502L113 502L112 501L112 501L112 500L112 500L112 500L112 500L111 500L111 499L111 499L111 498L111 498L111 497L111 497L110 497L110 497L110 497L109 496L109 496L108 496L108 496L108 495L108 495L108 495L107 493L106 493L106 493L106 493L105 493L105 493L105 493L104 494L104 493L103 494L103 493L103 493L103 493L103 493L102 493L101 493L101 494L100 496L100 496L99 497L98 496L97 496L97 496L95 495L95 495L95 495L94 493L94 492L93 491L93 491L92 490z"
        },
        {
            "title": "Kotepally",
            "d": "M138 438L137 438L137 439L137 440L136 440L136 440L135 440L135 440L135 440L135 440L134 440L134 440L134 440L134 441L133 441L133 441L133 441L132 442L132 442L132 442L132 442L132 442L132 443L132 443L131 443L131 443L131 442L131 442L130 443L130 443L130 443L129 443L129 443L128 443L128 444L128 444L128 444L128 445L128 445L128 446L128 447L128 447L127 447L127 447L126 446L126 447L126 447L125 447L125 447L124 448L125 449L126 450L126 450L126 450L126 450L126 450L125 450L125 451L125 451L124 451L124 452L124 452L124 454L122 454L122 454L122 454L121 454L121 454L121 453L122 453L122 453L122 453L121 453L120 453L120 453L120 453L119 453L119 453L118 453L118 453L118 453L117 454L117 454L117 453L117 453L117 454L117 454L116 454L116 454L116 454L116 454L115 454L115 455L115 455L116 456L116 456L116 456L116 457L117 457L118 458L118 458L118 458L119 457L119 457L120 458L120 458L120 458L121 458L122 458L122 454L123 454L123 455L124 455L125 456L125 457L126 457L126 457L128 457L129 457L129 457L129 457L129 458L129 458L129 458L129 458L129 458L129 457L130 457L129 456L130 456L130 456L130 456L131 456L131 456L131 456L132 455L132 455L132 455L132 455L132 455L133 455L133 455L133 455L133 455L134 455L134 455L135 456L135 455L136 455L136 455L136 455L136 453L135 453L135 453L135 453L135 453L136 453L136 452L136 452L136 452L136 452L136 452L136 452L137 451L137 451L138 450L138 450L138 450L139 451L140 451L140 451L141 451L142 452L143 452L144 452L144 452L145 452L144 451L144 451L145 450L144 449L144 449L145 449L146 448L146 447L146 446L145 446L146 444L146 444L146 444L145 444L144 443L144 443L144 443L143 442L142 441L142 441L141 441L141 440L140 440L140 440L139 439L139 439L139 439L138 439L138 438z"
        },
        {
            "title": "Kulkacharla",
            "d": "M157 512L157 511L157 511L157 510L157 509L157 509L157 509L158 509L158 509L158 508L159 508L159 508L159 508L159 508L159 508L159 508L159 508L159 507L159 506L159 506L158 506L158 505L158 505L158 505L158 505L158 503L158 503L158 503L158 503L157 502L157 502L156 502L156 502L156 502L156 502L156 503L155 503L155 503L155 503L155 504L155 504L155 505L155 505L155 506L154 506L154 506L154 506L154 506L154 506L154 506L154 506L153 507L153 506L153 506L153 506L153 507L152 508L152 508L152 508L151 510L151 510L150 510L150 510L150 510L150 511L149 511L149 511L148 511L149 511L148 512L148 512L148 512L148 512L147 513L147 513L147 513L147 513L147 513L147 513L146 513L145 513L144 513L144 513L143 512L143 512L143 512L141 512L141 512L141 512L141 512L141 513L140 513L139 513L139 514L139 515L139 516L139 516L138 516L138 517L138 517L138 517L138 517L138 517L137 517L137 518L136 519L136 519L136 519L136 520L136 520L136 521L135 521L136 522L137 521L138 522L139 522L139 522L140 523L140 523L140 523L141 523L141 523L142 523L142 524L141 525L141 525L141 526L141 526L141 526L142 526L142 526L142 526L142 526L142 526L143 527L143 527L143 526L144 526L144 526L143 526L144 526L144 527L144 527L144 527L144 527L144 527L144 527L144 527L144 527L144 527L145 527L145 527L145 527L145 527L145 528L145 528L145 528L146 529L146 529L146 529L146 529L147 529L147 529L147 529L148 529L148 529L148 529L148 529L148 528L149 528L149 528L149 527L149 526L150 525L151 525L151 525L152 527L152 528L152 528L151 528L151 529L151 530L150 533L152 533L154 533L156 535L156 532L157 532L158 529L158 529L158 528L160 527L160 526L160 526L161 526L161 526L160 526L160 525L160 522L160 522L160 522L160 521L160 522L160 521L159 521L160 520L160 519L160 518L160 518L157 517L157 517L156 516L156 516L156 515L155 515L156 515L156 514L156 513L157 512L157 512L157 512z"
        },
        {
            "title": "Marpalle",
            "d": "M119 438L119 438L119 438L119 439L119 439L120 439L120 439L121 439L121 439L121 440L122 440L123 440L123 440L124 441L123 441L124 441L123 441L124 441L124 441L124 441L124 441L124 441L124 441L124 441L125 441L125 441L125 441L125 441L125 442L125 442L125 441L125 441L126 441L126 441L126 440L126 440L127 440L128 439L128 439L129 440L129 439L129 439L129 439L129 439L130 439L131 439L131 439L132 440L132 440L133 441L133 441L133 441L133 441L134 441L134 440L134 440L134 440L135 440L135 440L135 440L135 440L136 440L136 440L137 440L137 439L137 438L138 438L138 438L138 437L138 436L138 436L138 436L139 436L138 436L139 436L139 435L139 435L139 435L139 434L139 434L139 433L139 433L139 433L139 433L139 431L140 432L141 432L142 432L142 433L142 434L142 435L142 435L142 435L142 435L143 435L144 435L144 435L145 435L145 435L145 434L145 434L145 434L145 433L146 432L146 432L146 432L146 432L147 432L148 432L148 432L149 431L150 429L149 429L149 428L148 428L147 427L147 428L147 427L146 426L146 426L145 426L145 425L144 425L144 424L144 424L144 423L145 422L147 422L148 423L148 423L149 423L149 421L149 421L150 420L150 420L150 420L150 419L150 419L150 419L150 419L150 419L150 418L150 418L149 417L149 417L149 417L150 417L150 416L151 416L149 415L149 414L149 414L149 414L149 414L149 414L148 414L148 415L148 415L148 415L147 415L147 415L147 415L147 415L147 415L147 414L146 414L146 414L146 414L145 413L145 413L144 412L143 412L143 412L143 412L142 412L142 411L142 411L141 412L141 412L141 412L139 412L139 412L138 412L138 412L138 412L137 411L136 411L136 411L136 410L136 410L135 410L135 411L135 411L135 411L134 412L134 412L133 412L133 412L132 412L132 412L131 412L131 412L131 412L130 412L130 412L130 412L130 412L130 412L130 412L130 412L130 412L129 412L129 412L129 412L129 413L130 413L130 414L131 414L131 414L131 414L131 414L133 414L134 416L133 417L133 419L132 419L132 419L131 420L131 421L131 423L131 423L131 423L131 423L129 425L129 425L129 425L128 425L128 426L127 426L126 427L126 427L126 427L125 428L125 428L124 428L124 429L124 429L124 429L123 429L123 429L123 429L123 429L122 430L122 429L121 429L121 429L120 429L119 429L119 430L119 432L119 431L119 432L119 432L120 434L120 434L119 435L119 436L119 438L119 438L119 438z"
        },
        {
            "title": "Mominpet",
            "d": "M160 424L160 424L160 423L160 423L160 423L159 423L159 423L158 421L158 421L157 421L157 421L156 421L155 420L154 420L154 420L153 420L152 420L151 420L150 420L150 420L150 420L150 420L150 419L150 420L150 420L150 420L149 421L149 421L149 423L148 423L148 423L147 422L145 422L144 423L144 424L144 424L144 425L145 425L145 426L146 426L146 426L147 427L147 428L147 427L148 428L149 428L149 429L150 429L149 431L148 432L148 432L147 432L146 432L146 432L146 432L146 432L145 433L145 434L145 434L145 434L145 435L145 435L144 435L144 435L143 435L142 435L142 435L142 435L142 435L142 434L142 433L142 432L141 432L140 432L139 431L139 433L139 433L139 433L139 433L139 434L139 434L139 435L139 435L139 435L139 436L138 436L139 436L138 436L138 436L138 436L138 437L138 438L138 438L138 439L139 439L139 439L139 439L140 440L140 440L141 440L141 441L142 441L142 441L143 442L144 443L144 443L144 443L145 444L146 444L146 444L146 444L147 444L147 444L148 444L149 444L150 444L150 443L151 443L151 442L152 442L152 441L153 441L153 441L153 440L153 440L154 440L155 440L156 440L157 441L157 440L157 440L157 440L158 440L158 439L159 440L160 440L160 440L161 440L161 440L162 440L163 440L163 440L163 440L164 440L164 440L164 440L164 440L165 440L165 440L166 440L166 441L167 442L167 441L168 442L169 441L169 441L170 441L171 441L171 441L171 441L172 442L172 442L173 442L174 441L174 441L174 441L174 440L174 440L174 440L174 440L173 439L173 439L173 439L173 439L172 439L171 439L171 439L171 437L171 437L171 437L171 436L171 436L172 436L171 436L172 435L171 435L170 434L170 434L169 434L169 433L169 433L169 434L169 434L168 435L168 436L168 436L168 436L167 437L167 437L165 437L165 436L165 435L165 434L165 433L165 433L166 432L167 431L166 431L167 431L166 431L166 430L166 430L166 430L166 430L165 430L165 429L164 428L163 428L162 428L161 428L160 427L161 426L161 425L160 425L160 425L160 424L160 424z"
        },
        {
            "title": "Nawabpet",
            "d": "M174 440L174 441L174 441L174 441L173 442L172 442L172 442L171 441L171 441L171 441L170 441L169 441L169 441L168 442L167 441L167 442L166 441L166 440L165 440L165 440L164 440L164 440L164 440L164 440L163 440L163 440L163 440L162 440L161 440L161 440L160 440L160 440L159 440L158 439L158 440L157 440L157 440L157 440L157 441L156 440L155 440L154 440L153 440L153 440L153 441L153 441L152 441L152 442L151 442L151 443L151 443L152 444L152 444L152 444L152 445L153 445L154 446L154 446L154 446L154 446L154 446L153 447L152 448L152 450L152 451L152 451L153 452L153 452L153 452L153 452L153 452L154 453L156 453L157 452L157 451L156 451L156 451L157 450L157 450L158 449L159 450L160 451L160 451L161 451L162 452L162 452L163 453L162 453L162 453L161 453L161 454L161 454L161 454L160 455L159 455L159 455L160 456L160 456L161 456L161 456L161 456L161 456L161 456L161 456L161 456L161 456L161 456L162 456L162 456L162 456L162 456L162 456L162 456L162 456L162 455L163 456L162 456L162 456L162 456L163 456L163 456L163 456L163 456L163 456L163 456L163 456L163 456L163 457L163 457L163 457L163 457L163 456L163 456L163 456L163 456L163 456L163 456L163 456L163 456L163 456L163 456L163 457L164 457L164 457L164 457L164 457L164 457L164 457L166 456L166 457L166 457L166 457L166 457L166 457L167 458L167 457L167 456L168 456L169 456L169 456L169 456L170 456L170 456L170 456L170 456L171 455L172 455L172 455L172 456L172 456L173 457L174 457L175 456L176 455L176 454L176 454L176 454L176 454L176 453L177 453L178 452L178 452L179 451L179 450L179 450L180 450L180 450L181 450L181 450L182 450L182 450L182 449L182 449L182 448L182 447L183 447L182 446L182 446L182 446L182 445L182 445L182 444L182 444L182 444L181 444L181 443L180 443L178 443L178 443L178 442L178 442L178 442L177 442L177 442L177 441L177 441L177 440L177 440L177 439L177 439L176 439L176 440L175 440L174 440z"
        },
        {
            "title": "Pargi",
            "d": "M153 479L153 479L153 479L152 479L151 477L151 476L150 476L150 476L149 477L149 478L148 478L148 478L148 478L147 478L147 478L147 478L146 479L146 479L146 479L145 480L145 480L144 481L144 481L144 482L142 482L141 483L141 483L141 483L140 483L140 483L139 484L138 484L137 484L137 483L136 483L135 483L135 482L135 482L135 482L135 482L133 483L133 484L131 484L131 484L131 485L131 486L132 487L132 488L132 488L133 489L133 489L134 489L134 490L134 491L134 491L134 492L134 493L134 493L134 494L135 495L136 495L138 496L139 497L140 497L140 497L142 497L142 497L143 495L143 495L144 494L144 495L145 495L145 495L145 496L145 496L145 496L145 496L146 496L146 496L146 496L147 495L147 496L147 497L147 497L147 497L147 498L149 498L149 498L150 498L150 498L150 498L151 498L152 498L153 498L153 498L153 498L153 498L153 499L153 499L153 499L153 500L154 500L154 500L154 500L154 500L155 500L155 501L155 501L155 502L156 502L156 502L156 502L157 502L157 502L158 503L158 503L158 503L158 503L158 505L158 505L158 505L158 505L158 506L159 506L159 506L159 507L159 508L160 507L161 508L161 507L161 507L161 506L161 506L161 505L162 504L162 503L163 503L163 504L163 503L165 503L165 503L165 503L166 503L166 503L167 503L167 503L168 503L168 502L169 500L169 500L168 499L168 498L168 498L168 497L168 497L168 496L168 496L167 496L167 496L167 496L167 496L167 495L167 494L165 493L164 493L163 493L162 493L162 493L161 493L161 492L160 492L160 492L159 492L159 492L159 492L158 492L159 492L159 492L159 491L160 491L161 490L161 490L162 490L162 490L162 490L163 490L163 489L163 489L164 489L164 489L164 489L164 488L164 488L163 488L163 486L163 486L163 485L162 485L162 485L162 484L161 484L161 484L160 484L160 485L160 485L160 485L159 485L159 484L159 484L158 484L158 484L158 483L158 483L158 483L158 483L158 483L157 482L157 482L157 483L156 483L156 483L155 483L155 483L155 482L154 482L154 482L154 482L154 482L153 481L153 480L153 480L153 479z"
        },
        {
            "title": "Peddemul",
            "d": "M94 450L96 451L97 451L99 451L100 450L101 450L101 451L101 453L99 455L100 456L100 458L100 458L100 459L100 460L100 461L102 461L101 462L101 463L101 462L101 463L102 464L102 464L102 464L102 465L103 465L102 466L102 466L102 466L102 466L103 467L103 468L103 469L104 469L104 468L105 468L105 468L107 468L107 469L107 469L107 470L108 471L108 471L108 471L107 472L109 473L109 473L109 474L111 475L111 474L112 474L112 474L112 474L112 474L113 474L113 474L113 474L113 474L114 474L114 474L114 474L114 474L115 474L115 474L116 473L116 473L116 473L118 472L119 472L119 472L119 472L120 472L121 472L121 471L122 471L123 471L123 471L124 471L124 471L123 470L123 470L124 470L124 469L123 468L123 468L123 467L123 467L123 467L123 467L124 466L124 466L124 466L124 465L124 465L125 465L125 465L124 464L123 464L123 464L123 464L123 464L123 464L122 464L122 464L122 463L122 463L122 462L122 462L122 462L122 461L122 461L122 460L121 460L121 459L120 458L120 458L120 458L119 457L119 457L118 458L118 458L118 458L117 457L116 457L116 456L116 456L116 456L115 455L115 455L115 454L116 454L116 454L116 454L116 454L117 454L117 454L117 453L117 453L117 454L117 454L118 453L118 453L118 453L118 453L118 453L117 453L117 453L116 452L116 452L116 452L116 451L116 450L116 450L116 450L115 450L115 449L115 449L115 449L114 448L114 448L114 448L114 448L114 448L114 447L113 447L113 446L113 446L112 445L113 445L113 445L113 444L113 444L112 444L112 443L111 443L110 443L110 443L109 443L109 443L108 442L108 443L107 442L107 443L106 443L105 443L104 443L104 443L103 442L102 442L102 441L101 441L100 441L100 443L100 445L98 444L97 444L96 444L94 443L93 443L90 445L90 447L90 448L92 449L93 449L94 449L94 449L94 450z"
        },
        {
            "title": "Pudur",
            "d": "M172 465L172 465L170 465L170 465L170 466L170 465L170 465L169 466L169 466L169 466L168 465L168 465L167 465L165 465L165 464L165 464L165 464L165 464L164 465L164 465L163 466L163 466L162 466L162 466L162 467L162 467L162 468L163 468L163 468L163 469L162 469L162 470L162 471L162 471L162 472L161 473L161 473L162 476L162 477L163 478L163 478L162 478L161 477L160 477L160 476L159 476L159 476L158 477L158 478L158 478L153 479L153 480L153 480L153 481L154 482L154 482L154 482L154 482L155 482L155 483L155 483L156 483L156 483L157 483L157 482L157 482L158 483L158 483L158 483L158 483L158 483L158 484L158 484L159 484L159 484L159 485L160 485L160 485L160 485L160 484L161 484L161 484L162 484L162 485L162 485L163 485L163 486L163 486L163 488L164 488L164 488L164 489L164 489L164 489L163 489L163 489L163 490L162 490L162 490L162 490L161 490L161 490L160 491L159 491L159 492L159 492L158 492L159 492L159 492L159 492L160 492L160 492L161 492L161 493L162 493L162 493L163 493L164 493L165 493L167 494L167 495L167 496L167 496L167 496L167 496L168 496L168 496L168 497L168 497L168 498L168 498L169 498L169 498L170 496L170 495L171 495L171 495L171 495L172 495L172 495L172 494L172 494L172 492L173 492L174 492L174 492L175 492L177 492L177 492L177 491L177 490L177 489L177 488L178 488L178 488L178 487L178 486L178 486L178 485L179 485L179 484L179 484L179 483L179 481L179 481L179 481L180 481L180 480L180 480L180 480L180 479L180 479L180 479L180 479L180 479L179 479L179 478L179 478L180 478L180 478L180 478L180 477L179 477L179 476L179 476L179 476L178 475L178 475L178 475L178 474L178 474L177 473L177 473L178 472L178 471L178 470L178 470L177 470L177 469L176 469L176 469L175 468L175 467L174 467L173 467L173 467L173 467L172 465L172 465L172 465z"
        },
        {
            "title": "Tandur",
            "d": "M115 474L114 474L114 474L114 474L114 474L113 474L113 474L113 474L113 474L112 474L112 474L112 474L112 474L111 474L111 475L109 474L109 473L109 473L107 472L108 471L108 471L108 471L107 470L107 469L107 469L107 468L105 468L105 468L104 468L104 469L103 469L103 468L103 467L102 466L102 466L102 466L102 466L103 465L102 465L102 464L102 464L102 464L101 463L101 462L101 463L101 462L102 461L100 461L100 460L100 459L100 458L100 458L100 456L99 455L101 453L101 451L101 450L100 450L99 451L97 451L96 451L94 450L92 451L92 452L91 452L91 453L92 453L92 453L92 453L92 453L92 454L93 454L93 454L93 455L92 455L92 455L91 456L91 456L90 457L89 457L89 457L89 457L88 457L88 458L87 458L86 457L85 457L85 457L85 458L85 458L84 458L84 457L84 457L83 457L83 456L83 456L84 456L83 456L84 455L82 455L81 455L80 455L80 455L79 455L80 456L79 456L79 457L79 457L79 458L80 458L80 459L80 459L80 460L80 462L80 462L80 462L80 462L79 462L79 464L79 464L79 464L79 464L79 466L79 466L79 466L78 466L78 467L78 467L78 467L78 467L78 467L77 467L77 468L77 468L77 469L80 469L80 470L80 471L80 471L80 471L79 471L79 472L79 472L79 472L80 473L82 473L82 473L82 473L82 473L82 473L82 474L83 474L83 474L83 474L84 473L85 473L86 473L87 473L87 473L88 473L89 474L90 473L90 473L91 474L91 475L92 475L92 475L92 476L92 476L91 476L91 476L91 476L91 477L90 479L90 479L90 479L91 479L91 480L91 480L91 481L91 481L91 481L91 482L91 483L92 483L93 483L93 483L94 483L96 483L96 483L96 483L96 482L96 481L96 480L96 479L96 479L96 479L96 478L97 478L97 478L98 478L99 479L100 479L100 479L101 480L101 480L101 480L101 480L101 479L102 479L102 479L102 478L103 478L104 478L104 476L106 476L108 476L108 476L109 477L109 477L110 477L110 477L111 476L111 476L111 476L111 476L111 477L111 477L112 477L112 478L113 478L113 479L114 479L114 479L114 479L115 478L115 478L116 477L116 476L117 476L116 475L116 474L116 474L116 474L115 474L115 474z"
        },
        {
            "title": "Vikarabad",
            "d": "M174 457L173 457L172 456L172 456L172 455L172 455L171 455L170 456L170 456L170 456L170 456L169 456L169 456L169 456L168 456L167 456L167 457L167 458L166 457L166 457L166 457L166 457L166 457L166 456L164 457L164 457L164 457L164 457L164 457L164 457L163 457L163 456L163 456L163 456L163 456L163 456L163 456L163 456L163 456L163 456L163 456L163 457L163 457L163 457L163 457L163 456L163 456L163 456L163 456L163 456L163 456L163 456L163 456L162 456L162 456L162 456L163 456L162 455L162 456L162 456L162 456L162 456L162 456L162 456L162 456L161 456L161 456L161 456L161 456L161 456L161 456L161 456L161 456L161 456L160 456L160 456L159 455L159 455L160 455L161 454L161 454L161 454L161 453L162 453L162 453L163 453L162 452L162 452L161 451L160 451L160 451L159 450L158 449L157 450L157 450L156 451L156 451L157 451L157 452L156 453L154 453L153 452L153 452L153 452L153 452L153 452L152 451L152 451L152 450L152 448L153 447L154 446L154 446L154 446L154 446L154 446L153 445L152 445L152 444L152 444L152 444L151 443L151 443L150 443L150 444L149 444L148 444L147 444L147 444L146 444L145 446L146 446L146 447L146 448L145 449L144 449L144 449L145 450L144 451L144 451L145 452L144 452L144 452L143 452L142 452L141 451L140 451L140 451L139 451L138 450L138 450L138 450L137 451L137 451L136 452L136 452L136 452L136 452L136 452L136 452L136 453L135 453L135 453L135 453L135 453L136 453L136 455L136 455L136 455L137 455L137 455L137 455L137 455L138 455L138 455L139 456L139 456L139 457L140 457L140 458L140 458L140 458L140 458L141 459L142 459L142 459L142 459L142 459L143 459L144 459L144 459L144 460L145 460L146 460L146 460L147 462L146 462L146 463L146 464L146 464L146 464L145 464L145 467L145 467L146 469L145 469L144 469L144 469L143 469L143 471L143 471L143 471L143 471L143 472L143 472L143 472L144 472L144 472L144 473L144 473L143 474L143 475L143 475L143 476L143 476L142 476L142 476L142 476L142 477L142 478L142 478L143 478L143 478L142 480L142 480L142 480L142 480L144 481L144 481L145 480L145 480L146 479L146 479L146 479L147 478L147 478L147 478L148 478L148 478L148 478L149 478L149 477L150 476L150 476L151 476L151 477L152 479L153 479L153 479L153 479L158 478L158 478L158 477L159 476L159 476L160 476L160 477L161 477L162 478L163 478L163 478L162 477L162 476L161 473L161 473L162 472L162 471L162 471L162 470L162 469L163 469L163 468L163 468L162 468L162 467L162 467L162 466L162 466L163 466L163 466L164 465L164 465L165 464L165 464L165 464L165 464L165 465L167 465L168 465L168 465L169 466L169 466L169 466L170 465L170 465L170 466L170 465L170 465L172 465L172 465L171 464L171 463L171 463L172 462L172 462L173 461L173 461L173 460L173 460L174 460L174 458L174 458L174 458L175 458L175 458L174 457L174 457z"
        },
        {
            "title": "Yelal",
            "d": "M127 480L128 479L128 479L128 478L128 478L128 477L128 477L129 475L129 475L128 475L128 475L127 475L126 474L127 472L128 471L128 470L128 471L126 471L124 471L124 471L124 471L123 471L123 471L122 471L121 471L121 472L120 472L119 472L119 472L119 472L118 472L116 473L116 473L116 473L115 474L115 474L115 474L116 474L116 474L116 474L116 475L117 476L116 476L116 477L115 478L115 478L114 479L114 479L114 479L113 479L113 478L112 478L112 477L111 477L111 477L111 476L111 476L111 476L111 476L110 477L110 477L109 477L109 477L108 476L108 476L106 476L104 476L104 478L103 478L102 478L102 479L102 479L101 479L101 480L101 480L101 480L101 480L100 479L100 479L99 479L98 478L97 478L97 478L96 478L96 479L96 479L96 479L96 480L96 481L96 482L96 483L96 483L96 483L94 483L93 483L93 483L93 484L93 486L93 486L92 486L92 487L92 487L92 488L92 488L92 488L92 488L92 488L92 489L92 490L92 490L92 490L92 490L93 491L93 491L94 492L94 493L95 495L95 495L95 495L97 496L97 496L98 496L99 497L100 496L100 496L101 494L101 493L102 493L103 493L103 493L103 493L103 493L103 494L104 493L104 494L105 493L105 493L105 493L106 493L106 493L106 493L107 493L106 492L106 492L106 492L106 491L106 491L108 490L109 490L110 490L111 489L111 488L111 488L112 488L113 488L114 488L114 488L115 488L115 488L116 488L116 489L116 489L117 489L117 489L117 489L118 489L119 489L120 489L120 489L120 490L120 489L120 489L120 489L119 488L119 488L119 488L119 488L119 488L120 487L119 486L120 486L119 485L119 485L119 485L120 485L120 484L120 484L120 484L121 484L121 484L121 484L122 484L122 484L123 484L123 484L123 484L125 484L125 485L124 486L124 486L124 487L124 487L125 488L125 488L126 489L126 487L127 486L127 486L127 486L126 486L126 485L126 484L126 484L125 483L125 483L125 482L125 482L126 481L126 480L127 480L127 480L127 480z"
        },
        {
            "title": "Chowdapur",
            "d": "M169 524L169 523L169 523L169 522L168 522L168 522L168 521L168 521L167 521L167 520L166 520L166 520L166 520L166 519L165 518L164 518L164 518L163 518L162 519L161 518L161 518L161 517L161 517L161 517L160 517L160 517L159 516L159 516L159 516L159 516L159 516L159 516L159 516L159 516L158 515L158 515L158 515L158 515L158 515L158 514L158 514L158 514L158 513L158 513L158 513L158 513L158 513L158 512L158 512L158 512L158 512L158 512L157 512L157 512L157 512L157 512L156 513L156 514L156 515L155 515L156 515L156 516L156 516L157 517L157 517L160 518L160 518L160 519L160 520L159 521L160 521L160 522L160 521L160 522L160 522L160 522L160 525L160 526L161 526L161 526L160 526L160 526L160 527L158 528L158 529L158 529L157 532L156 532L156 535L157 536L159 537L159 539L161 541L161 543L162 543L163 545L163 546L165 547L165 547L165 547L165 547L165 547L166 546L166 545L167 545L167 545L167 545L167 544L167 543L167 543L166 543L166 542L165 542L165 542L166 541L166 541L166 541L166 540L166 540L168 538L168 538L169 538L170 538L170 537L171 537L171 536L171 536L171 535L171 535L171 533L170 533L170 532L170 532L170 530L171 530L171 530L171 529L171 529L170 529L167 528L167 527L167 527L167 527L168 527L168 527L168 526L169 525L169 525L169 524L169 524z"
        },
        {
            "title": "Dudyal",
            "d": "M130 506L129 506L128 506L128 506L127 506L127 506L127 503L126 503L124 502L124 502L122 502L122 501L121 500L121 500L121 500L121 500L120 500L120 501L119 501L118 500L117 500L116 500L116 500L115 500L115 500L114 501L114 501L112 501L112 501L113 502L113 502L113 502L113 503L114 503L114 504L115 504L116 505L116 505L116 505L117 505L118 505L119 505L119 505L120 505L120 505L121 505L122 505L123 506L123 507L122 508L122 508L122 509L122 510L122 510L121 510L118 510L117 510L117 509L116 509L115 509L114 508L114 508L113 508L113 508L112 508L112 508L112 508L111 509L111 509L111 509L109 509L108 509L108 509L108 509L106 509L106 510L106 510L106 510L106 512L105 513L104 513L104 513L104 514L104 514L104 515L104 515L105 515L105 515L105 515L105 515L105 516L106 516L106 516L107 516L107 517L108 517L108 517L109 517L109 517L109 516L109 517L109 517L109 517L109 517L109 517L109 517L110 517L110 517L110 517L110 516L110 516L111 516L111 516L111 516L111 516L111 516L112 516L112 515L112 515L113 514L113 514L114 514L115 514L116 515L117 516L117 516L117 516L118 516L118 516L118 516L119 516L120 515L120 515L120 515L120 515L120 515L121 515L121 515L121 514L122 513L124 513L124 513L125 514L125 514L125 514L125 515L125 515L126 515L127 515L127 515L128 515L128 515L128 516L128 515L128 516L128 516L128 516L129 516L129 516L129 516L129 516L129 516L130 516L130 516L130 516L131 517L131 516L132 516L131 517L132 517L132 517L133 515L133 514L133 513L134 512L134 512L133 512L132 512L132 511L132 510L132 510L132 510L131 510L131 510L130 509L129 510L129 509L128 509L128 509L129 508L129 507L129 507L130 506z"
        }
    ],
    "Nirmal": [
        {
            "title": "Basar",
            "d": "M181 192L181 191L181 191L180 191L180 191L180 191L180 191L180 191L180 191L180 191L180 191L180 191L180 191L180 191L180 191L179 191L179 191L179 191L179 191L179 191L179 191L178 190L178 190L178 190L177 190L177 190L176 190L175 190L174 189L174 189L174 189L173 189L172 189L172 189L171 188L171 188L170 188L170 188L169 188L169 187L169 187L169 187L168 187L168 187L167 187L166 186L165 186L165 186L164 186L164 187L163 186L162 187L162 187L162 187L162 187L162 186L161 184L160 184L160 184L160 184L159 184L159 184L158 184L158 184L158 184L158 185L157 185L157 186L157 185L157 186L156 186L156 186L156 186L156 186L156 186L156 187L156 187L156 187L156 187L156 187L156 187L156 187L156 187L156 187L156 187L156 187L155 187L155 188L155 188L155 189L154 189L154 189L154 191L156 192L156 192L156 193L156 193L156 193L156 195L157 196L158 196L159 196L159 197L159 198L160 198L160 199L160 199L160 199L162 199L163 200L163 200L164 201L164 201L164 202L166 202L166 202L167 201L168 199L169 198L171 197L173 197L176 196L177 196L178 196L178 197L179 197L180 197L180 197L181 197L181 197L181 195L181 192z"
        },
        {
            "title": "Bhainsa",
            "d": "M180 144L180 144L180 144L179 144L178 143L177 143L176 143L175 143L176 140L176 140L176 138L174 138L172 138L172 139L171 140L171 141L171 142L171 142L170 142L170 143L170 144L170 144L170 145L170 145L170 145L171 146L171 146L171 146L172 146L172 147L171 149L169 148L167 148L167 148L164 148L164 148L163 147L163 146L163 146L163 146L162 145L162 146L161 145L161 146L160 148L160 148L160 149L160 149L160 149L160 149L159 150L159 151L159 151L159 151L159 151L159 151L159 152L159 152L159 153L158 154L158 155L158 156L158 157L158 158L158 158L158 159L157 159L156 159L156 159L156 159L156 159L155 160L156 160L156 161L156 161L156 162L155 163L156 165L156 166L156 166L157 166L157 167L158 167L160 167L160 167L162 167L162 166L162 167L162 166L162 167L163 166L163 167L163 168L163 168L165 168L167 169L169 169L169 168L169 167L170 168L170 168L170 168L170 167L170 167L170 167L171 167L171 168L171 168L171 168L171 168L172 168L171 169L171 169L170 170L172 170L174 170L175 170L176 170L176 169L176 169L177 166L177 164L178 164L178 164L179 164L180 164L181 165L182 164L182 164L182 164L182 163L184 162L184 162L185 162L187 162L187 162L187 162L187 161L187 159L188 159L188 160L188 160L188 160L189 160L189 160L189 160L190 160L190 159L190 158L190 158L190 158L189 157L189 157L189 156L189 155L187 155L186 154L185 154L185 152L185 152L184 152L181 151L181 151L180 149L179 148L179 148L179 147L180 146L180 146L180 144z"
        },
        {
            "title": "Dasturabad",
            "d": "M320 158L319 158L317 157L315 156L314 155L313 157L312 158L312 159L312 159L312 159L312 160L311 160L312 161L312 162L312 162L312 162L312 162L312 163L311 163L311 163L311 163L311 163L314 166L316 167L319 169L323 172L324 172L325 172L325 172L326 172L326 171L326 170L327 169L328 168L330 166L331 165L330 164L330 164L330 164L330 163L330 163L330 162L329 160L329 160L329 160L329 159L328 158L328 158L327 158L327 158L327 158L327 158L327 158L327 158L325 158L325 158L326 159L326 159L326 160L325 160L324 160L323 162L321 160L320 158z"
        },
        {
            "title": "Dilawarpur",
            "d": "M224 155L224 155L224 153L224 153L223 153L222 152L222 151L222 151L222 151L221 150L221 152L220 153L219 154L218 155L217 156L216 156L216 155L215 155L215 155L215 155L215 155L214 155L214 155L214 155L214 153L214 153L214 153L213 153L213 153L213 153L212 153L211 152L211 152L210 153L209 154L208 156L208 156L208 157L208 157L209 157L208 157L208 158L208 158L208 159L208 160L208 160L208 161L208 162L209 162L209 162L208 162L208 163L208 163L207 163L207 163L207 163L207 164L206 166L206 166L206 166L206 167L206 167L205 167L206 167L205 168L205 168L205 169L205 169L205 170L205 170L205 171L206 171L205 172L205 172L206 172L207 172L207 173L208 173L208 173L209 173L210 173L210 173L211 173L212 173L213 174L214 174L214 174L214 174L214 174L214 174L215 174L216 174L218 176L220 177L221 178L221 179L221 179L220 180L223 180L225 179L226 179L226 178L226 178L226 178L226 178L227 178L227 178L227 177L227 176L227 176L227 176L227 176L227 176L227 176L225 174L224 173L225 172L225 171L226 171L225 171L225 170L225 169L225 169L225 169L224 169L223 169L223 168L223 168L222 167L223 167L223 166L223 165L223 165L223 164L223 164L224 163L223 163L223 163L223 163L223 162L223 162L222 161L222 161L222 161L222 160L222 160L222 159L222 159L223 159L223 159L223 158L224 158L224 158L224 158L224 157L224 157L224 156L224 155z"
        },
        {
            "title": "Khanapur",
            "d": "M290 171L290 171L290 170L290 170L290 169L290 169L290 169L290 169L289 168L290 167L289 167L289 167L289 167L290 167L289 167L289 167L290 166L290 166L290 166L290 166L290 165L290 165L290 165L290 164L290 163L290 161L293 162L293 162L293 162L293 162L294 161L295 160L295 159L296 159L296 157L298 155L298 155L299 155L299 155L298 154L296 153L296 152L294 151L294 151L293 151L293 151L292 150L292 150L292 150L291 149L290 148L290 148L290 148L290 147L289 147L289 147L289 146L288 146L287 146L287 146L286 147L286 149L284 151L284 152L283 153L283 154L283 154L282 154L283 154L283 154L283 157L283 158L283 158L283 159L282 159L282 160L282 160L282 160L281 160L280 160L280 159L279 159L278 159L277 159L277 160L277 160L277 161L277 161L277 163L276 162L275 161L275 161L274 161L274 161L273 161L274 161L272 163L272 165L272 166L272 166L272 166L273 167L274 170L275 171L276 175L276 176L276 178L276 179L276 180L276 181L277 181L279 181L279 181L280 181L283 177L284 175L284 175L286 173L288 172L289 171L290 171zM273 161L273 158L271 158L271 157L271 155L272 155L273 155L273 154L273 154L274 155L274 155L275 155L275 155L275 155L276 151L276 151L276 150L276 150L276 149L276 149L274 147L274 146L274 146L273 145L273 144L273 144L272 142L266 146L265 146L263 146L261 147L259 147L259 148L260 149L260 150L261 153L261 153L262 154L263 154L264 154L266 155L269 159L273 161z"
        },
        {
            "title": "Kaddampeddur",
            "d": "M317 130L316 130L315 131L314 132L315 133L314 133L314 134L314 134L311 134L310 135L310 136L310 137L309 138L309 138L309 139L307 140L307 140L307 141L306 140L306 139L306 138L305 136L303 134L302 134L301 133L300 129L296 128L294 126L294 126L293 128L293 129L293 129L293 130L292 130L292 130L292 130L292 131L292 131L291 132L291 133L292 133L292 134L291 135L291 136L291 137L291 137L291 137L291 137L291 139L291 141L291 143L291 143L291 144L290 144L290 145L289 146L289 146L289 146L289 146L289 147L289 147L290 147L290 148L290 148L290 148L291 149L292 150L292 150L292 150L293 151L293 151L294 151L294 151L296 152L296 153L298 154L299 155L299 155L298 155L298 155L296 157L296 159L295 159L295 160L294 161L293 162L293 162L293 162L293 162L290 161L290 163L290 164L290 165L290 165L290 165L290 166L290 166L290 166L290 166L289 167L289 167L290 167L289 167L289 167L289 167L290 167L289 168L290 169L290 169L290 169L290 169L290 170L290 170L290 171L290 171L290 171L291 172L291 172L292 173L293 173L294 174L296 174L298 175L298 175L299 175L299 175L299 175L299 175L300 175L301 174L303 172L305 171L305 171L306 170L306 170L307 169L307 169L309 170L309 169L310 169L310 169L311 167L312 166L313 166L313 166L314 166L311 163L311 163L311 163L311 163L312 163L312 162L312 162L312 162L312 162L312 161L311 160L312 160L312 159L312 159L312 159L312 158L313 157L314 155L315 156L317 157L319 158L320 158L320 156L321 156L320 154L320 152L320 151L320 151L320 151L320 150L319 150L319 150L319 150L319 150L319 150L319 150L321 149L321 149L321 149L323 147L324 146L326 146L326 145L326 145L326 144L326 143L327 142L327 142L328 142L328 141L329 140L329 140L329 140L329 138L332 134L331 134L330 134L330 134L330 134L327 132L326 131L322 128L322 129L322 130L321 130L321 130L321 131L320 131L319 130L318 129L317 130z"
        },
        {
            "title": "Kubeer",
            "d": "M185 135L185 135L183 134L182 134L182 133L182 132L182 131L183 130L183 130L183 129L182 129L181 129L179 128L178 128L178 126L178 126L178 126L178 125L177 124L176 124L176 124L175 123L174 123L173 122L173 122L173 121L172 121L172 120L172 120L170 119L170 119L170 118L170 118L170 118L167 117L167 116L166 117L166 117L166 118L165 118L165 118L164 118L163 119L162 120L161 121L161 121L160 121L159 120L159 120L158 120L158 121L158 121L156 122L155 123L155 123L153 123L153 124L154 125L154 126L154 126L154 126L157 127L157 127L158 127L159 127L160 127L160 128L160 128L160 129L160 129L160 131L159 131L158 131L158 131L158 130L156 130L155 131L155 132L155 131L154 133L154 133L154 134L154 134L154 134L154 135L154 135L154 136L154 136L153 137L153 138L152 138L152 139L152 140L152 140L152 141L151 141L151 142L150 143L151 143L152 144L153 144L152 144L152 145L152 145L152 145L152 146L152 146L152 146L151 146L151 146L151 148L151 149L153 149L154 149L154 148L156 148L156 149L156 149L157 149L157 150L158 150L159 151L159 151L159 150L160 149L160 149L160 149L160 149L160 148L160 148L161 146L161 145L162 146L162 145L163 146L163 146L163 146L163 147L164 148L164 148L167 148L167 148L169 148L171 149L172 147L172 146L171 146L171 146L171 146L170 145L170 145L170 145L170 144L170 144L170 143L170 142L171 142L171 142L171 141L171 140L172 139L172 138L174 138L176 138L176 140L176 140L175 143L176 143L177 143L178 143L179 144L180 144L180 144L180 144L180 144L181 144L181 143L181 143L181 143L182 143L182 142L182 141L182 140L182 140L182 140L183 140L183 139L183 138L184 136L184 136L184 136L185 135z"
        },
        {
            "title": "Kuntala",
            "d": "M185 135L184 136L184 136L184 136L183 138L183 139L183 140L182 140L182 140L182 140L182 141L182 142L182 143L181 143L181 143L181 143L181 144L180 144L180 144L180 146L180 146L179 147L179 148L179 148L180 149L181 151L181 151L184 152L185 152L185 152L185 154L186 154L187 155L189 155L189 156L189 157L189 157L190 158L190 158L190 158L190 159L190 160L191 160L191 161L191 161L191 161L192 159L192 159L192 159L193 158L193 158L193 158L193 156L193 156L194 155L194 155L194 153L194 153L194 153L195 152L195 151L196 150L197 151L197 150L199 150L199 150L201 150L201 148L201 148L201 147L199 146L198 146L198 146L197 145L197 143L196 143L196 143L197 142L196 142L197 140L197 140L197 140L198 139L199 139L199 138L200 137L199 136L198 136L198 135L197 134L195 133L195 133L194 134L194 134L193 134L193 134L191 134L190 135L190 135L189 134L189 133L189 132L187 133L187 133L186 133L186 133L186 133L185 134L185 135z"
        },
        {
            "title": "Laxmanchanda",
            "d": "M258 182L259 181L259 181L260 181L260 180L261 180L261 179L261 179L260 179L260 179L260 178L260 178L260 178L259 177L259 176L258 175L258 174L258 173L256 173L256 172L255 172L254 172L253 173L253 173L253 173L253 172L254 172L253 172L253 171L253 171L253 170L254 170L254 168L254 167L253 167L253 167L253 166L254 165L254 165L254 165L255 165L255 164L255 164L255 164L256 162L256 161L255 159L256 158L256 157L256 157L256 157L256 157L255 158L255 158L255 159L254 159L254 160L254 160L254 160L253 160L253 161L252 161L252 162L252 162L250 162L250 161L249 161L249 161L248 162L247 162L246 162L246 161L245 161L244 161L244 161L243 160L243 161L244 161L243 161L242 161L241 163L241 163L240 163L240 164L240 164L240 164L240 164L241 165L241 164L241 165L242 166L242 166L242 166L242 167L242 168L242 168L243 169L243 170L242 169L242 170L242 170L242 170L242 171L242 171L242 172L242 172L242 173L242 173L242 174L243 174L243 174L243 174L243 175L243 175L243 175L242 175L242 175L242 176L242 176L242 176L242 176L242 176L243 177L243 177L244 179L245 181L245 182L246 182L247 183L249 184L250 185L250 185L251 184L252 184L252 184L253 184L254 183L255 182L256 182L257 182L257 182L258 182z"
        },
        {
            "title": "Lokeshwaram",
            "d": "M205 172L205 172L204 172L204 172L203 171L203 170L203 169L202 169L201 169L201 169L201 168L202 167L202 167L202 166L202 166L201 166L201 166L200 165L200 165L201 164L200 164L200 164L200 164L200 164L200 164L200 164L200 164L200 162L200 162L200 161L200 161L200 161L199 162L197 163L197 163L196 163L196 163L196 163L194 162L192 161L192 161L190 162L188 162L188 162L187 162L187 162L187 162L185 162L184 162L184 162L182 163L182 164L182 164L182 164L181 165L180 164L179 164L178 164L178 164L177 164L177 166L176 169L176 169L176 170L176 170L176 170L177 170L177 170L178 170L178 171L179 172L180 172L181 173L181 173L181 173L182 172L182 173L183 173L183 174L182 174L182 176L182 177L181 177L181 178L180 179L180 181L179 181L179 182L179 182L178 183L178 183L177 183L177 183L177 184L177 184L177 184L177 184L177 184L177 185L177 185L177 186L179 187L179 187L179 187L179 187L180 187L181 187L182 188L182 188L182 188L183 187L183 186L183 186L184 186L184 186L186 186L187 186L189 186L190 186L190 186L191 185L192 184L193 183L194 183L196 183L197 183L197 183L198 182L199 182L201 180L201 178L202 177L203 176L203 176L204 176L206 177L206 177L209 176L211 175L212 175L213 175L214 174L214 174L214 174L214 174L214 174L214 174L213 174L212 173L211 173L210 173L210 173L209 173L208 173L208 173L207 173L207 172L206 172L205 172z"
        },
        {
            "title": "Mamda",
            "d": "M259 147L258 146L256 146L254 145L255 143L256 142L257 142L258 142L259 140L255 138L253 137L253 137L250 137L250 138L250 141L250 142L250 143L251 144L250 144L250 145L250 145L249 145L249 146L248 146L247 145L247 146L247 146L246 147L245 147L245 147L244 147L244 147L243 147L243 147L242 147L243 148L243 149L243 150L243 151L243 151L244 151L244 152L244 152L244 152L244 152L244 152L244 152L244 153L244 154L244 154L243 155L243 155L243 155L243 155L243 156L242 156L242 156L243 156L243 156L243 157L243 157L243 157L243 157L244 157L244 158L244 158L244 158L244 158L243 159L242 159L242 159L242 160L243 160L244 161L244 161L245 161L246 161L246 162L247 162L248 162L249 161L249 161L250 161L250 162L252 162L252 162L252 161L253 161L253 160L254 160L254 160L254 160L254 159L255 159L255 158L255 158L256 157L256 157L256 157L256 157L256 158L255 159L256 161L256 162L255 164L255 164L255 164L255 165L254 165L254 165L254 165L253 166L253 167L253 167L254 167L254 168L254 170L253 170L253 171L253 171L253 172L254 172L253 172L253 173L253 173L253 173L254 172L255 172L256 172L256 173L258 173L258 174L258 175L259 176L259 177L260 178L260 178L260 178L260 179L260 179L261 179L261 179L261 180L260 180L260 181L259 181L259 181L258 182L259 183L259 184L260 184L260 184L261 185L261 185L261 186L263 186L263 186L265 186L265 186L265 186L265 184L266 182L266 181L267 180L268 179L270 177L271 177L272 177L272 178L274 180L275 180L276 181L276 180L276 179L276 178L276 176L276 175L275 171L274 170L273 167L272 166L272 166L272 166L272 165L272 163L274 161L273 161L273 161L269 159L266 155L264 154L263 154L262 154L261 153L261 153L260 150L260 149L259 148L259 147z"
        },
        {
            "title": "Mudhole",
            "d": "M176 170L175 170L174 170L172 170L170 170L171 169L171 169L172 168L171 168L171 168L171 168L171 168L171 167L170 167L170 167L170 167L170 168L170 168L170 168L169 167L169 168L169 169L167 169L165 168L163 168L163 168L163 167L163 166L162 167L162 166L162 167L162 166L162 167L160 167L160 167L158 167L157 167L157 167L157 168L157 168L158 168L158 169L158 170L158 170L158 170L158 171L159 171L159 171L159 171L159 172L158 172L158 172L158 173L158 173L158 173L157 173L157 174L157 175L157 175L157 175L157 176L157 176L157 176L157 176L157 176L157 176L157 177L156 177L155 176L154 177L156 178L155 181L155 181L155 181L154 183L154 185L154 185L154 185L154 185L154 185L154 185L154 185L155 185L155 185L155 185L155 185L155 185L155 186L155 186L155 186L155 186L155 186L155 186L155 186L156 186L156 186L156 186L156 186L157 186L157 185L157 186L157 185L158 185L158 184L158 184L158 184L159 184L159 184L160 184L160 184L160 184L161 184L162 186L162 187L162 187L162 187L162 187L163 186L164 187L164 186L165 186L165 186L166 186L167 187L168 187L168 187L169 187L169 187L169 187L169 188L170 188L170 188L171 188L171 188L172 189L172 189L173 189L174 189L174 189L174 189L175 190L176 190L177 190L177 190L178 190L178 190L178 190L179 191L179 191L179 191L179 191L179 191L179 191L180 191L180 191L180 191L180 191L180 191L180 191L180 191L180 191L180 191L180 191L180 191L180 191L181 191L181 191L181 192L182 188L182 188L182 188L181 187L180 187L179 187L179 187L179 187L179 187L177 186L177 185L177 185L177 184L177 184L177 184L177 184L177 184L177 183L177 183L178 183L178 183L179 182L179 182L179 181L180 181L180 179L181 178L181 177L182 177L182 176L182 174L183 174L183 173L182 173L182 172L181 173L181 173L181 173L180 172L179 172L178 171L178 170L177 170L177 170L176 170L176 170L176 170z"
        },
        {
            "title": "Narsapur_G",
            "d": "M211 152L211 152L211 151L211 151L211 151L210 151L210 151L210 150L209 150L209 150L209 150L208 150L208 149L208 149L206 149L206 149L205 149L205 149L205 149L205 149L205 148L204 148L204 148L204 148L204 148L204 147L205 147L205 147L205 147L205 147L205 145L205 145L206 145L206 145L206 145L206 144L205 144L206 144L206 144L205 143L207 143L207 143L208 143L210 144L211 143L210 143L210 143L210 143L209 142L210 141L211 141L209 141L209 140L209 140L209 139L207 139L207 139L207 139L207 140L206 140L205 139L205 138L206 137L205 136L204 135L203 136L202 135L201 136L201 136L200 136L200 137L199 138L199 139L198 139L197 140L197 140L197 140L196 142L197 142L196 143L196 143L197 143L197 145L198 146L198 146L199 146L201 147L201 148L201 148L201 150L199 150L199 150L197 150L197 151L196 150L195 151L195 152L194 153L194 153L194 153L194 155L194 155L193 156L193 156L193 158L193 158L193 158L192 159L192 159L192 159L191 161L191 161L191 161L191 160L190 160L189 160L189 160L189 160L188 160L188 160L188 160L188 159L187 159L187 161L187 162L188 162L188 162L190 162L192 161L192 161L194 162L196 163L196 163L196 163L197 163L197 163L199 162L200 161L200 161L200 161L200 162L200 162L200 164L200 164L200 164L200 164L200 164L200 164L200 164L201 164L200 165L200 165L201 166L201 166L202 166L202 166L202 167L202 167L201 168L201 169L201 169L202 169L203 169L203 170L203 171L204 172L204 172L205 172L205 172L205 172L206 171L205 171L205 170L205 170L205 169L205 169L205 168L205 168L206 167L205 167L206 167L206 167L206 166L206 166L206 166L207 164L207 163L207 163L207 163L208 163L208 163L208 162L209 162L209 162L208 162L208 161L208 160L208 160L208 159L208 158L208 158L208 157L209 157L208 157L208 157L208 156L208 156L209 154L210 153L211 152z"
        },
        {
            "title": "Nirmal",
            "d": "M233 165L233 164L234 164L234 164L235 162L235 162L235 162L235 162L235 162L235 161L235 161L235 161L235 161L235 161L235 160L236 159L235 159L235 159L235 158L235 158L235 157L235 156L235 156L235 156L235 156L234 156L234 155L234 155L234 154L233 153L233 154L233 154L232 155L231 154L230 154L230 154L229 154L228 155L228 156L228 157L228 157L227 158L227 158L227 159L227 160L228 160L228 159L229 160L229 160L229 160L229 160L229 160L230 161L231 162L231 162L230 162L230 163L230 163L230 163L230 163L230 164L230 164L230 164L230 164L230 165L230 165L230 166L231 166L231 166L231 166L232 166L232 165L233 165L233 165L233 165z"
        },
        {
            "title": "Nirmal Rural",
            "d": "M230 166L230 165L230 165L230 164L230 164L230 164L230 164L230 163L230 163L230 163L230 163L230 162L231 162L231 162L230 161L229 160L229 160L229 160L229 160L229 160L228 159L228 160L227 160L227 159L227 158L227 158L228 157L228 157L228 156L228 155L229 154L230 154L230 153L229 152L229 152L227 154L227 154L227 154L227 154L227 154L227 154L227 154L226 153L226 154L226 154L226 154L226 154L226 154L226 153L225 154L225 154L225 154L225 154L225 154L225 154L225 155L225 155L224 155L224 155L224 155L224 155L224 155L224 156L224 157L224 157L224 158L224 158L224 158L223 158L223 159L223 159L222 159L222 159L222 160L222 160L222 161L222 161L222 161L223 162L223 162L223 163L223 163L223 163L224 163L223 164L223 164L223 165L223 165L223 166L223 167L222 167L223 168L223 168L223 169L224 169L225 169L225 169L225 169L225 170L225 171L226 171L227 172L227 171L227 171L228 171L229 171L229 171L229 171L230 171L230 170L231 170L231 170L231 169L232 170L232 169L232 169L232 169L231 168L231 168L230 168L230 167L230 167L230 166zM237 145L237 146L236 146L236 145L235 145L235 144L234 146L234 146L233 147L233 147L232 148L232 149L232 149L231 149L231 149L231 150L231 150L232 151L232 150L233 150L234 151L235 151L236 150L236 150L237 150L236 152L234 152L233 153L234 154L234 155L234 155L234 156L235 156L235 156L235 156L235 156L235 157L235 158L235 158L235 159L235 159L236 159L235 160L235 161L235 161L235 161L235 161L235 161L235 162L235 162L235 162L235 162L235 162L234 164L234 164L233 164L233 165L234 165L234 165L235 166L236 167L236 167L237 168L237 169L239 169L239 169L241 169L242 168L242 168L242 167L242 166L242 166L242 166L241 165L241 164L241 165L240 164L240 164L240 164L240 164L240 163L241 163L241 163L242 161L243 161L244 161L243 161L243 160L242 160L242 159L242 159L243 159L244 158L244 158L244 158L244 158L244 157L243 157L243 157L243 157L243 157L243 156L243 156L242 156L242 156L243 156L243 155L243 155L243 155L243 155L244 154L244 154L244 153L244 152L244 152L244 152L244 152L244 152L244 152L244 151L243 151L243 151L243 150L243 149L243 148L242 147L242 146L242 146L241 146L241 146L240 146L240 146L239 146L239 146L239 146L238 145L238 146L237 145L237 145z"
        },
        {
            "title": "Pembi",
            "d": "M294 126L295 124L293 124L291 124L290 124L290 124L290 123L289 123L288 123L286 123L286 123L286 123L284 124L283 125L282 126L282 126L282 126L281 125L280 125L280 125L278 124L277 124L277 124L274 124L274 125L274 125L273 125L273 125L273 124L273 125L272 125L271 127L269 128L267 129L268 130L268 130L268 130L268 131L267 131L267 131L266 130L265 132L262 133L261 133L260 135L261 138L260 138L259 140L259 140L258 142L257 142L256 142L255 143L254 145L256 146L258 146L259 147L261 147L263 146L265 146L266 146L272 142L273 144L273 144L273 145L274 146L274 146L274 147L276 149L276 149L276 150L276 150L276 151L276 151L275 155L275 155L275 155L274 155L274 155L273 154L273 154L273 155L272 155L271 155L271 157L271 158L273 158L273 161L273 161L274 161L274 161L275 161L275 161L276 162L277 163L277 161L277 161L277 160L277 160L277 159L278 159L279 159L280 159L280 160L281 160L282 160L282 160L282 160L282 159L283 159L283 158L283 158L283 157L283 154L283 154L282 154L283 154L283 154L283 153L284 152L284 151L286 149L286 147L287 146L287 146L288 146L289 146L289 146L289 146L289 146L290 145L290 144L291 144L291 143L291 143L291 141L291 139L291 137L291 137L291 137L291 137L291 136L291 135L292 134L292 133L291 133L291 132L292 131L292 131L292 130L292 130L292 130L293 130L293 129L293 129L293 128L294 126L294 126z"
        },
        {
            "title": "Sarangapur",
            "d": "M218 131L218 130L217 129L217 129L217 128L217 128L217 127L217 126L216 126L216 126L216 125L216 125L214 123L212 123L211 123L211 123L210 123L209 123L208 123L208 122L208 121L207 121L207 122L208 122L208 122L206 125L206 126L206 127L206 127L205 128L205 128L205 128L205 129L205 130L205 131L205 131L205 132L205 133L205 134L205 134L204 135L205 136L206 137L205 138L205 139L206 140L207 140L207 139L207 139L207 139L209 139L209 140L209 140L209 141L211 141L210 141L209 142L210 143L210 143L210 143L211 143L210 144L208 143L207 143L207 143L205 143L206 144L206 144L205 144L206 144L206 145L206 145L206 145L205 145L205 145L205 147L205 147L205 147L205 147L204 147L204 148L204 148L204 148L204 148L205 148L205 149L205 149L205 149L205 149L206 149L206 149L208 149L208 149L208 150L209 150L209 150L209 150L210 150L210 151L210 151L211 151L211 151L211 151L211 152L211 152L211 152L212 153L213 153L213 153L213 153L214 153L214 153L214 153L214 155L214 155L214 155L215 155L215 155L215 155L215 155L216 155L216 156L217 156L218 155L219 154L220 153L221 152L221 150L222 151L222 151L222 151L222 152L223 153L224 153L224 153L224 155L224 155L224 155L224 155L224 155L224 155L225 155L225 155L225 154L225 154L225 154L225 154L225 154L225 154L226 153L226 154L226 154L226 154L226 154L226 154L226 153L227 154L227 154L227 154L227 154L227 154L227 154L227 154L229 152L229 152L230 153L230 154L230 154L231 154L232 155L233 154L233 154L233 153L234 152L236 152L237 150L236 150L236 150L235 151L234 151L233 150L232 150L232 151L231 150L231 150L231 149L231 149L232 149L232 149L232 148L233 147L233 147L234 146L234 146L235 144L235 145L236 145L236 146L237 146L237 145L237 143L236 142L236 142L235 142L235 142L235 142L234 142L234 142L234 142L233 142L233 141L232 141L231 141L231 141L230 141L229 140L228 140L227 139L227 139L227 139L227 138L226 138L226 137L226 136L226 136L225 136L226 135L225 134L225 134L225 133L225 132L225 132L224 131L223 131L223 131L222 131L221 131L221 131L221 131L221 131L219 131L219 131L219 131L218 131z"
        },
        {
            "title": "Soan",
            "d": "M242 168L241 169L239 169L239 169L237 169L237 168L236 167L236 167L235 166L234 165L234 165L233 165L233 165L233 165L232 165L232 166L231 166L231 166L231 166L230 166L230 167L230 167L230 168L231 168L231 168L232 169L232 169L232 169L232 170L231 169L231 170L231 170L230 170L230 171L229 171L229 171L229 171L228 171L227 171L227 171L227 172L226 171L225 171L225 172L224 173L225 174L227 176L227 176L227 176L227 176L227 176L227 176L227 177L227 178L227 178L226 178L226 178L226 178L226 178L226 179L225 179L223 180L220 180L220 181L220 182L220 184L220 185L221 185L222 184L225 183L227 183L228 182L228 182L228 182L228 182L228 182L228 183L228 183L229 182L229 182L230 182L231 181L230 182L231 182L232 181L232 180L232 179L232 179L233 179L233 179L233 179L235 178L237 177L238 177L238 177L239 177L239 176L240 176L240 176L240 176L241 176L242 176L242 176L242 176L242 176L242 175L242 175L243 175L243 175L243 175L243 174L243 174L243 174L242 174L242 173L242 173L242 172L242 172L242 171L242 171L242 170L242 170L242 170L242 169L243 170L243 169L242 168z"
        },
        {
            "title": "Tanoor",
            "d": "M159 151L158 150L157 150L157 149L156 149L156 149L156 148L154 148L154 149L153 149L151 149L150 150L150 151L149 151L148 151L148 152L149 152L149 153L149 155L150 155L150 156L150 157L150 157L150 158L150 159L151 159L151 160L151 160L150 160L149 160L148 160L148 160L147 160L147 160L147 160L147 159L147 159L147 159L146 158L146 158L145 157L145 157L144 157L144 157L144 157L143 158L143 159L143 159L143 159L143 161L143 162L142 162L142 162L142 162L142 163L142 163L142 164L142 165L142 166L142 166L141 166L141 166L140 165L140 166L138 165L137 164L136 165L137 166L136 167L136 169L136 169L136 170L136 170L136 171L137 171L137 171L137 172L137 174L138 174L138 175L138 176L138 176L137 177L137 178L140 180L140 179L140 178L142 178L146 179L145 180L145 182L145 182L145 183L145 184L145 184L147 185L148 184L149 184L151 184L151 185L150 187L150 188L150 188L149 190L149 191L150 192L151 192L152 192L153 192L154 192L154 191L154 191L154 189L154 189L155 189L155 188L155 188L155 187L156 187L156 187L156 187L156 187L156 187L156 187L156 187L156 187L156 187L156 187L156 187L156 186L156 186L156 186L156 186L155 186L155 186L155 186L155 186L155 186L155 186L155 186L155 185L155 185L155 185L155 185L155 185L154 185L154 185L154 185L154 185L154 185L154 185L154 185L154 183L155 181L155 181L155 181L156 178L154 177L155 176L156 177L157 177L157 176L157 176L157 176L157 176L157 176L157 176L157 175L157 175L157 175L157 174L157 173L158 173L158 173L158 173L158 172L158 172L159 172L159 171L159 171L159 171L158 171L158 170L158 170L158 170L158 169L158 168L157 168L157 168L157 167L157 167L157 166L156 166L156 166L156 165L155 163L156 162L156 161L156 161L156 160L155 160L156 159L156 159L156 159L156 159L157 159L158 159L158 158L158 158L158 157L158 156L158 155L158 154L159 153L159 152L159 152L159 151L159 151L159 151L159 151z"
        }
    ],
    "Mahabubabad": [
        {
            "title": "Bayyaram",
            "d": "M541 398L540 395L540 395L540 395L539 396L538 399L535 399L532 401L530 402L530 403L525 401L518 400L519 396L514 397L514 397L514 403L512 406L514 407L515 408L516 409L517 411L516 412L515 412L515 412L514 413L514 413L513 414L512 414L513 416L512 416L513 416L512 417L512 419L511 419L511 422L512 423L512 423L514 423L515 424L515 424L516 425L516 425L516 426L515 426L515 427L515 429L515 429L517 430L517 431L518 431L518 430L518 430L518 430L519 429L519 429L520 428L520 428L520 428L520 428L521 428L521 427L521 427L521 426L522 425L522 425L522 425L522 425L522 425L522 424L522 424L523 424L522 423L523 423L523 423L522 423L522 422L522 422L523 422L523 422L523 422L524 422L524 422L524 423L524 423L524 423L524 422L524 422L524 422L525 422L525 422L526 422L526 423L526 423L526 423L525 423L525 424L525 424L525 424L526 424L526 424L526 424L526 424L526 424L526 424L526 424L526 425L525 425L525 425L525 425L525 426L524 426L524 426L524 426L523 425L523 425L523 425L523 425L523 426L523 427L522 427L522 427L523 428L523 428L523 429L523 428L523 428L523 429L523 429L523 430L523 430L524 430L523 431L523 431L524 432L523 432L523 433L524 433L523 433L523 433L524 434L524 433L524 434L525 432L525 432L525 432L525 432L525 432L525 432L525 431L526 431L526 431L526 431L526 432L526 431L526 431L526 431L526 430L527 430L527 430L527 429L527 429L527 429L527 429L527 429L528 429L528 429L528 429L528 429L529 429L529 428L530 428L530 429L530 429L530 429L530 429L531 429L532 429L533 429L533 429L534 429L534 429L534 428L534 428L535 428L536 426L536 425L537 424L537 423L538 420L539 419L538 419L536 419L536 418L536 417L536 417L536 416L536 415L536 414L536 412L536 412L536 412L537 412L537 412L537 412L537 413L538 413L538 412L538 412L538 412L538 412L538 412L538 411L539 411L539 411L539 412L540 411L540 412L540 412L542 411L543 411L544 410L544 409L544 406L545 405L545 403L543 402L541 398z"
        },
        {
            "title": "Chinnagudur",
            "d": "M484 432L483 431L483 431L482 431L482 431L479 429L478 430L478 429L478 429L477 429L477 429L477 429L477 429L477 429L477 429L476 432L477 433L478 434L478 434L478 435L478 436L478 437L478 437L477 438L477 438L477 439L477 440L477 440L477 440L478 441L478 441L479 441L479 441L480 441L480 442L481 442L482 442L482 442L482 443L483 443L482 443L482 444L482 444L482 445L481 445L481 445L482 445L482 445L482 445L482 445L482 445L482 446L482 446L483 446L483 446L484 446L485 446L486 447L486 447L486 447L486 447L486 446L487 446L487 446L487 445L487 445L487 446L488 446L488 447L489 447L489 446L489 446L489 445L490 445L490 444L490 444L491 444L491 443L491 443L490 441L491 438L490 438L490 438L489 438L488 438L488 437L487 436L487 436L487 435L486 435L486 435L485 434L485 434L485 434L485 433L485 432L484 432z"
        },
        {
            "title": "Danthalapalle",
            "d": "M463 430L462 430L462 430L462 429L462 430L461 429L461 429L461 430L460 430L460 430L460 430L459 430L459 430L459 430L459 430L458 430L458 430L457 431L457 431L456 432L456 433L455 433L455 433L455 433L455 433L455 435L454 435L454 435L453 435L453 435L453 435L453 435L452 435L452 435L452 435L452 435L451 435L450 434L449 435L449 435L449 435L449 436L447 436L447 436L446 436L446 436L445 437L445 437L445 438L445 438L445 438L445 438L444 438L444 439L445 438L445 439L445 439L445 440L445 440L445 440L445 442L445 443L445 443L446 443L446 443L447 444L448 444L450 445L450 445L450 445L450 445L451 445L452 445L452 445L452 446L452 446L452 447L452 447L452 447L453 447L453 447L454 447L454 447L454 448L454 448L455 449L455 450L456 450L457 450L457 450L458 450L458 450L459 450L459 449L460 448L461 449L461 449L462 450L463 449L463 449L464 448L464 448L465 447L465 447L465 446L465 446L465 446L465 445L465 445L465 445L465 445L465 445L465 444L465 444L466 444L466 444L466 443L466 442L466 442L466 440L466 439L464 439L464 439L464 439L464 438L464 438L463 438L462 438L462 438L462 438L461 438L460 437L461 436L461 435L461 435L461 434L461 434L461 433L462 433L462 433L463 433L463 432L463 432L463 432L463 432L463 431L463 431L463 431L463 430z"
        },
        {
            "title": "Dornakal",
            "d": "M530 448L529 446L527 446L525 447L523 447L523 447L523 447L522 446L523 443L523 441L523 441L522 441L522 441L519 439L517 438L517 439L516 439L515 440L516 441L516 445L516 445L516 445L514 445L514 445L513 445L513 445L513 445L512 445L511 445L511 445L511 445L510 445L510 444L510 444L510 444L510 444L510 445L510 445L511 445L511 445L511 446L510 447L510 447L510 448L509 448L507 448L507 449L507 451L507 451L508 453L508 454L509 454L510 454L510 455L510 456L510 456L510 456L510 458L509 458L509 458L509 459L509 460L510 460L510 460L510 460L510 460L509 461L508 461L509 461L508 462L508 463L509 463L509 464L510 464L510 464L510 464L511 464L511 464L511 464L511 464L513 463L513 463L514 464L514 463L514 463L513 463L514 462L514 462L514 461L514 461L514 461L515 461L515 461L516 462L517 462L518 462L518 462L518 462L518 463L520 462L520 461L520 460L520 460L520 460L520 460L520 460L520 460L521 460L521 460L521 459L521 459L521 459L521 458L521 458L521 458L521 458L522 458L522 458L522 458L522 459L522 459L523 459L523 459L523 458L523 457L524 457L525 456L525 456L528 459L528 458L528 458L528 457L528 457L528 455L529 454L528 452L528 451L529 449L530 448z"
        },
        {
            "title": "Gangaram",
            "d": "M554 353L553 352L551 352L550 352L550 352L550 352L549 352L549 352L549 352L549 352L549 352L548 352L547 351L544 349L544 349L543 349L543 349L542 349L540 348L539 348L539 348L537 350L537 350L537 349L536 349L536 350L536 350L536 350L535 350L535 350L536 351L535 351L536 351L536 351L536 351L536 352L536 352L536 352L536 352L536 352L536 352L536 353L534 352L532 352L531 352L530 352L529 353L528 353L525 354L523 354L522 355L522 357L523 357L527 357L530 357L539 358L539 363L537 361L536 362L533 362L533 363L534 365L534 365L535 365L535 365L536 365L536 364L537 365L537 367L537 368L534 368L534 373L530 373L528 372L525 373L524 372L523 380L525 383L525 383L525 382L528 382L528 382L528 382L528 383L528 384L528 385L525 388L524 391L527 391L527 394L522 394L523 395L519 396L518 400L525 401L530 403L530 402L532 401L535 399L538 399L539 396L540 395L540 395L540 395L541 398L543 398L543 397L543 397L545 395L544 394L544 394L544 393L544 392L544 391L543 390L544 389L544 388L544 388L544 387L544 386L544 386L543 385L545 383L546 382L547 378L547 376L548 375L548 374L548 373L548 368L546 366L546 365L546 363L546 361L546 361L547 359L548 360L550 359L552 359L553 358L555 357L555 356L554 354L554 353z"
        },
        {
            "title": "Garla",
            "d": "M535 428L534 428L534 428L534 429L534 429L533 429L533 429L532 429L531 429L530 429L530 429L530 429L530 429L530 428L529 428L529 429L528 429L528 429L528 429L528 429L527 429L527 429L527 429L527 429L527 429L527 430L527 430L526 430L526 431L526 431L526 431L526 432L526 431L526 431L526 431L525 431L525 432L525 432L525 432L525 432L525 432L525 432L524 434L524 433L524 434L523 433L523 433L524 433L523 433L523 432L524 432L523 431L523 431L524 430L523 430L523 430L523 429L523 429L523 428L523 428L523 429L523 428L523 428L522 427L522 427L523 427L523 426L523 425L523 425L523 425L523 425L524 426L524 426L524 426L525 426L525 425L525 425L525 425L526 425L526 424L526 424L526 424L526 424L526 424L526 424L526 424L525 424L525 424L525 424L525 423L526 423L526 423L526 423L526 422L525 422L525 422L524 422L524 422L524 422L524 423L524 423L524 423L524 422L524 422L523 422L523 422L523 422L522 422L522 422L522 423L523 423L523 423L522 423L523 424L522 424L522 424L522 425L522 425L522 425L522 425L522 425L521 426L521 427L521 427L521 428L520 428L520 428L520 428L520 428L519 429L519 429L518 430L518 430L518 430L518 431L517 431L517 431L518 432L517 432L517 433L516 435L517 437L517 437L517 438L517 438L519 439L522 441L522 441L523 441L523 441L523 443L522 446L523 447L523 447L523 447L525 447L527 446L529 446L530 448L531 447L531 448L531 448L534 449L534 449L535 448L535 448L534 446L534 445L534 444L534 444L534 443L534 441L534 442L534 442L535 442L535 442L535 443L535 443L535 443L536 443L536 443L536 443L536 443L536 443L538 442L537 442L537 440L537 439L536 438L536 437L537 435L539 433L539 433L538 432L538 432L538 432L536 430L535 430L535 428L535 428z"
        },
        {
            "title": "Gudur",
            "d": "M524 391L522 391L522 390L520 387L516 383L515 382L515 382L514 382L508 382L508 382L507 381L506 380L506 380L506 380L505 380L505 380L505 379L504 379L504 378L504 378L504 377L504 377L503 377L503 376L503 376L503 376L503 375L502 376L502 375L502 374L502 374L502 374L501 375L501 375L501 374L500 374L500 374L500 374L500 374L500 373L500 373L500 374L499 375L499 376L496 375L495 375L495 375L495 375L494 375L494 376L494 376L494 376L494 377L494 378L494 379L493 379L493 380L493 380L493 380L493 380L493 380L492 379L492 379L492 379L491 379L491 380L491 380L491 382L490 382L490 383L490 383L490 383L489 384L489 384L489 385L488 386L488 386L488 387L487 387L487 386L487 386L487 385L487 384L487 384L487 384L486 384L485 384L484 384L484 384L483 384L481 385L481 386L482 387L482 388L482 389L482 390L482 390L484 391L485 391L486 391L486 391L486 391L486 391L487 391L487 391L488 392L488 392L488 392L488 392L488 394L488 395L488 395L488 395L489 396L490 397L491 397L492 397L493 398L493 399L494 399L494 400L494 400L494 401L494 401L493 402L495 403L496 403L497 404L498 404L499 404L501 404L502 403L502 404L502 404L502 404L502 404L503 404L503 404L505 405L505 405L506 405L506 404L506 405L508 405L509 405L509 404L509 405L512 406L512 406L514 403L514 397L514 397L519 396L523 395L522 394L527 394L527 391L524 391z"
        },
        {
            "title": "Kesamudram",
            "d": "M502 404L502 404L502 403L501 404L499 404L498 404L497 404L496 403L495 403L493 402L494 401L494 401L494 400L494 400L494 399L493 399L493 398L492 397L491 397L490 397L489 396L488 395L488 395L488 395L488 394L488 392L488 392L488 392L488 392L487 391L487 391L486 391L486 391L486 393L486 393L486 394L485 394L485 395L485 396L485 397L484 397L483 397L483 397L483 398L482 398L482 398L481 398L481 398L481 397L480 397L480 397L480 397L480 397L480 397L479 397L479 398L478 398L478 398L478 399L478 399L478 399L479 399L479 400L477 400L477 400L477 400L475 400L475 400L475 401L474 401L474 401L473 401L473 401L472 402L472 401L472 402L472 402L472 404L473 404L473 404L473 405L473 406L474 406L474 406L475 406L475 407L476 407L477 407L478 408L479 409L479 409L479 411L479 411L477 412L477 412L477 413L477 413L477 413L477 413L477 413L477 413L477 413L477 414L477 414L477 414L477 414L477 414L477 415L478 415L477 416L477 416L478 416L478 416L478 416L478 417L478 417L478 416L480 417L480 417L480 417L482 416L483 416L483 416L484 416L485 417L486 418L486 419L488 420L488 421L488 421L489 420L490 419L490 419L490 418L491 418L491 417L494 418L494 417L495 417L495 417L495 417L495 417L495 417L496 415L494 414L495 414L493 410L495 410L497 410L499 410L499 409L500 409L500 408L501 405L502 404L502 404z"
        },
        {
            "title": "Kothaguda",
            "d": "M521 338L521 338L521 338L520 338L519 338L518 338L517 339L516 340L515 340L515 340L515 339L515 339L514 338L511 336L509 333L509 333L509 333L508 334L506 336L505 338L503 342L502 342L502 344L502 346L500 349L500 349L500 353L500 354L499 355L499 356L500 357L500 358L499 359L499 360L499 360L500 361L501 363L502 365L502 366L503 367L502 367L502 367L500 369L500 370L500 371L500 371L500 371L500 373L500 373L500 374L500 374L500 374L500 374L501 374L501 375L501 375L502 374L502 374L502 374L502 375L502 376L503 375L503 376L503 376L503 376L503 377L504 377L504 377L504 378L504 378L504 379L505 379L505 380L505 380L506 380L506 380L506 380L507 381L508 382L508 382L514 382L515 382L515 382L516 383L520 387L522 390L522 391L524 391L525 388L528 385L528 384L528 383L528 382L528 382L528 382L525 382L525 383L525 383L523 380L524 372L525 373L528 372L530 373L534 373L534 368L537 368L537 367L537 365L536 364L536 365L535 365L535 365L534 365L534 365L533 363L533 362L536 362L537 361L539 363L539 358L530 357L527 357L523 357L522 357L522 355L523 354L525 354L528 353L529 353L530 352L531 352L532 352L534 352L536 353L536 352L536 352L536 352L536 352L536 352L536 352L536 351L536 351L536 351L535 351L536 351L535 350L535 350L536 350L536 350L536 350L536 349L535 349L535 348L531 346L527 344L526 343L525 343L523 340L521 338z"
        },
        {
            "title": "Kuravi",
            "d": "M510 444L510 445L511 445L511 445L511 445L512 445L513 445L513 445L513 445L514 445L514 445L516 445L516 445L516 445L516 441L515 440L516 439L517 439L517 438L517 438L517 437L517 437L516 435L517 433L517 432L518 432L517 431L517 431L517 430L515 429L515 429L515 427L515 426L516 426L516 425L516 425L515 424L515 424L514 423L512 423L512 423L512 423L509 425L509 426L509 426L508 427L506 425L505 426L505 426L504 427L504 427L504 428L504 428L503 428L503 429L503 429L502 429L502 429L502 429L502 429L501 429L500 429L500 429L499 429L499 429L498 430L498 430L498 433L499 433L498 433L498 433L499 433L499 434L499 434L499 435L499 435L499 435L499 436L499 436L498 437L497 437L497 438L497 437L494 436L493 435L494 434L495 431L495 431L495 431L495 430L494 430L493 430L492 429L490 429L489 429L487 427L486 429L485 431L485 431L485 432L484 432L484 432L485 432L485 433L485 434L485 434L485 434L486 435L486 435L487 435L487 436L487 436L488 437L488 438L489 438L490 438L490 438L491 438L490 441L491 443L491 443L491 444L493 444L493 444L495 444L495 445L495 445L496 445L496 445L497 440L500 442L500 442L500 442L501 442L501 443L501 443L502 444L502 443L503 443L503 443L503 443L503 443L503 443L503 443L505 443L505 442L505 442L505 442L505 442L505 442L506 441L506 441L506 442L506 442L506 442L507 442L507 442L507 442L507 442L507 442L508 443L509 443L509 443L509 443L509 443L509 444L510 444L510 444z"
        },
        {
            "title": "Mahabubabad",
            "d": "M493 435L494 436L497 437L497 438L497 437L498 437L499 436L499 436L499 435L499 435L499 435L499 434L499 434L499 433L498 433L498 433L499 433L498 433L498 430L498 430L499 429L499 429L500 429L500 429L501 429L502 429L502 429L502 429L502 429L503 429L503 429L503 428L504 428L504 428L504 427L504 427L505 426L505 426L506 425L508 427L509 426L509 426L509 425L512 423L512 423L511 422L511 419L512 419L512 417L513 416L512 416L513 416L512 414L513 414L514 413L514 413L515 412L515 412L516 412L517 411L516 409L515 408L514 407L512 406L512 406L509 405L509 404L509 405L508 405L506 405L506 404L506 405L505 405L505 405L503 404L503 404L502 404L502 404L502 404L502 404L501 405L500 408L500 409L499 409L499 410L497 410L495 410L493 410L495 414L494 414L496 415L495 417L495 417L495 417L495 417L495 417L494 417L494 418L491 417L491 418L490 418L490 419L490 419L489 420L488 421L488 421L487 421L486 421L486 422L485 423L484 423L484 426L484 426L483 427L480 427L477 426L477 425L477 425L477 425L477 425L476 424L476 425L476 425L475 426L475 426L475 426L475 426L475 426L475 427L475 427L475 427L475 427L475 427L475 427L476 428L477 429L477 429L477 429L477 429L477 429L478 429L478 429L478 430L479 429L482 431L482 431L483 431L483 431L484 432L484 432L485 432L485 431L485 431L486 429L487 427L489 429L490 429L492 429L493 430L494 430L495 430L495 431L495 431L495 431L494 434L493 435z"
        },
        {
            "title": "Maripeda",
            "d": "M491 443L491 444L490 444L490 444L490 445L489 445L489 446L489 446L489 447L488 447L488 446L487 446L487 445L487 445L487 446L487 446L486 446L486 447L486 447L486 447L486 447L485 446L484 446L483 446L483 446L482 446L482 446L482 445L482 445L482 445L482 445L482 445L481 445L481 445L482 445L482 444L482 444L482 443L483 443L482 443L482 442L482 442L481 442L480 442L480 441L479 441L479 441L478 441L478 441L477 440L477 440L477 440L476 441L476 441L475 441L476 443L476 443L476 443L476 444L476 444L476 444L476 444L476 444L476 444L476 444L476 445L476 445L476 445L476 445L475 446L475 446L476 446L475 447L475 449L474 449L473 449L472 448L472 448L472 448L472 448L472 447L471 447L471 447L471 447L470 446L470 446L470 446L469 446L468 446L468 446L468 446L468 447L467 447L466 448L465 449L465 449L465 449L465 448L465 448L464 448L464 448L463 449L463 449L462 450L462 450L462 450L462 452L462 453L462 454L463 454L463 454L463 455L463 455L464 455L464 454L464 454L465 455L466 455L466 455L466 455L466 455L467 455L467 455L467 455L467 455L467 456L468 456L468 456L468 456L468 457L468 457L468 457L468 457L467 457L467 457L467 458L466 458L466 458L466 458L466 458L466 458L465 458L465 458L465 458L465 458L465 459L465 459L464 460L464 460L465 461L465 461L466 462L467 462L467 463L467 463L467 465L467 466L467 466L467 467L467 468L467 468L468 468L468 468L469 468L469 468L469 468L469 468L469 468L469 468L470 468L470 468L470 467L470 467L470 467L470 467L470 467L472 466L473 466L473 466L474 466L475 467L476 467L476 467L476 467L476 466L476 466L477 466L478 467L478 466L479 467L479 466L480 467L481 467L481 466L481 466L481 466L481 465L481 465L481 464L482 464L482 464L482 464L481 464L481 463L481 463L481 463L482 463L482 462L482 462L482 463L483 463L483 463L483 463L483 463L484 463L484 463L484 463L484 462L484 461L484 461L484 461L485 461L485 460L485 459L485 459L485 459L487 460L489 460L489 460L489 461L490 461L490 461L490 461L490 460L491 459L491 458L491 458L491 457L491 456L494 456L496 455L496 454L497 454L498 454L498 452L498 452L498 451L498 451L498 450L498 449L498 449L496 448L496 448L496 445L496 445L495 445L495 445L495 444L493 444L493 444L491 444L491 443z"
        },
        {
            "title": "Narsimhulapet",
            "d": "M477 429L476 428L475 427L475 428L475 428L474 429L474 428L474 429L473 429L473 429L473 429L473 429L473 429L473 429L473 429L473 429L473 429L472 429L472 430L472 430L472 430L472 430L472 430L473 430L473 431L473 431L473 431L472 431L472 430L471 429L470 429L469 429L469 429L468 429L467 429L466 429L466 430L466 430L465 429L465 429L464 429L463 428L463 429L463 429L463 429L463 429L463 430L463 431L463 431L463 431L463 432L463 432L463 432L463 432L463 433L462 433L462 433L461 433L461 434L461 434L461 435L461 435L461 436L460 437L461 438L462 438L462 438L462 438L463 438L464 438L464 438L464 439L464 439L464 439L466 439L466 440L466 442L466 442L466 443L466 444L466 444L465 444L465 444L465 445L465 445L465 445L465 445L465 445L465 446L465 446L465 446L465 447L465 447L464 448L465 448L465 448L465 449L465 449L465 449L466 448L467 447L468 447L468 446L468 446L468 446L469 446L470 446L470 446L470 446L471 447L471 447L471 447L472 447L472 448L472 448L472 448L472 448L473 449L474 449L475 449L475 447L476 446L475 446L475 446L476 445L476 445L476 445L476 445L476 444L476 444L476 444L476 444L476 444L476 444L476 444L476 443L476 443L476 443L475 441L476 441L476 441L477 440L477 440L477 440L477 440L477 440L477 439L477 438L477 438L478 437L478 437L478 436L478 435L478 434L478 434L477 433L476 432L477 429L477 429z"
        },
        {
            "title": "Nellikudur",
            "d": "M456 409L456 409L455 409L455 409L455 409L454 409L455 410L455 412L454 414L454 414L455 414L455 415L455 416L455 416L455 417L455 417L455 418L455 420L455 420L456 422L456 422L457 422L457 423L457 424L458 424L458 424L458 424L458 425L458 425L457 425L457 425L457 426L457 426L457 427L457 428L457 428L457 429L457 430L457 430L458 430L458 430L459 430L459 430L459 430L459 430L460 430L460 430L460 430L461 430L461 429L461 429L462 430L462 429L462 430L462 430L463 430L463 429L463 429L463 429L463 429L463 428L464 429L465 429L465 429L466 430L466 430L466 429L467 429L468 429L469 429L469 429L470 429L471 429L472 430L472 431L473 431L473 431L473 431L473 430L472 430L472 430L472 430L472 430L472 430L472 429L473 429L473 429L473 429L473 429L473 429L473 429L473 429L473 429L473 429L474 429L474 428L474 429L475 428L475 428L475 427L475 427L475 427L475 427L475 427L475 427L475 426L475 426L475 426L475 426L475 426L476 425L476 425L476 424L477 425L477 425L477 425L477 425L477 426L480 427L483 427L484 426L484 426L484 423L485 423L486 422L486 421L487 421L488 421L488 420L486 419L486 418L485 417L484 416L483 416L483 416L482 416L480 417L480 417L480 417L479 418L479 418L479 418L478 419L477 420L477 421L477 421L477 421L477 421L476 421L475 420L474 420L473 420L473 420L473 419L473 419L472 419L472 419L473 418L473 416L473 416L473 416L473 415L473 413L472 413L472 413L471 413L470 413L469 413L469 413L468 413L467 414L466 415L466 415L466 415L464 414L463 414L462 415L462 415L461 415L462 414L461 410L460 410L459 410L459 410L459 409L458 409L457 409L456 409z"
        },
        {
            "title": "Peddavangara",
            "d": "M440 439L441 438L442 437L441 437L441 437L441 437L441 436L440 436L440 436L440 435L439 435L439 435L439 434L439 434L439 434L439 434L439 433L439 433L439 433L439 433L440 433L440 433L440 432L440 432L440 430L440 429L441 429L441 429L441 429L441 429L440 428L441 427L440 427L440 427L440 426L441 426L441 426L441 426L441 425L440 425L440 425L440 425L439 425L438 425L438 425L438 425L438 425L438 424L438 424L438 424L438 424L438 423L437 423L436 423L435 422L434 422L434 421L433 421L434 420L434 420L433 420L433 420L433 419L433 419L433 419L433 419L433 418L433 418L433 418L432 417L432 417L432 417L431 417L431 417L430 417L429 417L429 417L429 419L429 419L428 421L428 421L427 421L426 421L425 420L424 421L424 421L424 421L424 421L423 421L422 422L421 422L421 422L421 423L421 423L421 423L422 424L421 425L421 425L421 426L421 426L421 426L422 427L423 428L423 428L423 428L424 428L424 429L424 429L425 429L425 430L425 430L425 432L425 432L425 432L426 433L426 433L426 433L426 433L427 433L427 434L427 434L427 435L427 435L427 435L428 435L427 436L428 436L428 436L428 436L428 436L428 437L428 437L428 437L429 437L429 437L429 437L429 438L429 438L429 438L430 438L430 437L430 437L431 437L432 436L432 437L432 437L432 437L433 437L433 437L435 438L434 437L434 436L434 435L434 434L434 434L434 433L434 433L434 433L434 432L434 432L434 432L434 433L434 433L434 433L434 433L435 433L435 435L435 435L435 435L435 436L436 437L436 437L436 438L436 438L437 438L438 438L439 438L439 438L440 438L440 439L440 439z"
        },
        {
            "title": "Thorrur",
            "d": "M454 406L454 406L454 406L453 406L453 406L453 406L453 406L453 406L453 406L452 406L452 406L451 406L450 406L451 406L450 407L450 407L449 408L449 409L449 410L448 412L447 412L446 411L446 412L445 413L445 414L444 416L443 416L443 416L443 416L443 416L443 416L443 416L443 416L442 417L442 417L442 417L442 417L442 417L441 416L441 416L440 416L439 416L438 416L438 416L437 415L436 414L435 415L434 415L434 415L433 415L432 416L432 417L432 417L432 417L433 418L433 418L433 418L433 419L433 419L433 419L433 419L433 420L433 420L434 420L434 420L433 421L434 421L434 422L435 422L436 423L437 423L438 423L438 424L438 424L438 424L438 424L438 425L438 425L438 425L438 425L439 425L440 425L440 425L440 425L441 425L441 426L441 426L441 426L440 426L440 427L440 427L441 427L440 428L441 429L441 429L441 429L441 429L440 429L440 430L440 432L440 432L440 433L440 433L439 433L439 433L439 433L439 433L439 434L439 434L439 434L439 434L439 435L439 435L440 435L440 436L440 436L441 436L441 437L441 437L441 437L442 437L441 438L440 439L442 440L443 439L444 439L444 439L444 439L444 438L445 438L445 438L445 438L445 438L445 437L445 437L446 436L446 436L447 436L447 436L449 436L449 435L449 435L449 435L450 434L451 435L452 435L452 435L452 435L452 435L453 435L453 435L453 435L453 435L454 435L454 435L455 435L455 433L455 433L455 433L455 433L456 433L456 432L457 431L457 431L458 430L457 430L457 430L457 429L457 428L457 428L457 427L457 426L457 426L457 425L457 425L458 425L458 425L458 424L458 424L458 424L457 424L457 423L457 422L456 422L456 422L455 420L455 420L455 418L455 417L455 417L455 416L455 416L455 415L455 414L454 414L454 414L455 412L455 410L454 409L455 409L455 409L455 409L456 409L456 409L456 409L456 408L456 408L456 407L456 407L455 407L454 406z"
        },
        {
            "title": "Seerole",
            "d": "M510 444L510 444L509 444L509 443L509 443L509 443L509 443L508 443L507 442L507 442L507 442L507 442L507 442L506 442L506 442L506 442L506 441L506 441L505 442L505 442L505 442L505 442L505 442L505 443L503 443L503 443L503 443L503 443L503 443L503 443L502 443L502 444L501 443L501 443L501 442L500 442L500 442L500 442L497 440L496 445L496 448L496 448L498 449L498 449L498 450L498 451L498 451L498 452L498 452L498 454L499 455L500 455L500 458L501 459L501 460L502 460L503 460L503 461L504 462L504 462L505 462L505 462L505 463L506 463L507 463L508 463L508 462L509 461L508 461L509 461L510 460L510 460L510 460L510 460L509 460L509 459L509 458L509 458L510 458L510 456L510 456L510 456L510 455L510 454L509 454L508 454L508 453L507 451L507 451L507 449L507 448L509 448L510 448L510 447L510 447L511 446L511 445L511 445L510 445L510 445L510 444L510 444L510 444L510 444z"
        },
        {
            "title": "Inugurthy",
            "d": "M472 404L472 404L472 404L472 404L471 403L471 403L469 403L468 402L468 402L466 402L465 403L465 403L464 404L463 404L463 404L461 405L460 405L459 405L458 405L457 404L456 404L456 404L456 403L455 403L455 403L455 404L455 404L454 405L454 406L455 407L456 407L456 407L456 408L456 408L456 409L456 409L457 409L458 409L459 409L459 410L459 410L460 410L461 410L462 414L461 415L462 415L462 415L463 414L464 414L466 415L466 415L466 415L467 414L468 413L469 413L469 413L470 413L471 413L472 413L472 413L473 413L473 415L473 416L473 416L473 416L473 418L472 419L472 419L473 419L473 419L473 420L473 420L474 420L475 420L476 421L477 421L477 421L477 421L477 421L477 420L478 419L479 418L479 418L479 418L480 417L480 417L480 417L480 417L480 417L478 416L478 417L478 417L478 416L478 416L478 416L477 416L477 416L478 415L477 415L477 414L477 414L477 414L477 414L477 414L477 413L477 413L477 413L477 413L477 413L477 413L477 413L477 412L477 412L479 411L479 411L479 409L479 409L478 408L477 407L476 407L475 407L475 406L474 406L474 406L473 406L473 405L473 404L473 404L472 404z"
        }
    ],
    "Jagtial": [
        {
            "title": "Beerpur",
            "d": "M342 165L341 165L340 165L339 165L338 165L338 165L336 165L334 164L333 164L332 165L331 165L330 166L328 168L327 169L326 170L326 171L326 172L325 172L325 172L324 172L323 172L319 169L319 169L319 169L320 176L328 176L328 176L331 179L332 181L335 180L335 181L335 181L337 182L336 183L341 185L341 184L342 181L342 179L341 177L342 174L342 173L342 173L342 171L342 170L341 169L341 168L341 168L341 168L341 168L341 168L341 168L341 167L342 167L342 166L342 166L342 166L343 166L342 166L342 166L342 165z"
        },
        {
            "title": "Buggaram",
            "d": "M359 204L359 203L360 203L359 202L359 202L360 201L359 201L359 200L359 200L360 199L357 198L354 197L354 196L352 196L350 197L350 197L350 197L349 197L350 196L350 194L350 194L351 194L350 193L348 192L346 193L346 194L346 194L345 194L345 194L345 194L345 194L344 195L344 195L344 195L344 195L344 195L342 195L341 195L341 195L341 195L340 196L340 198L340 199L341 200L342 200L342 200L342 201L342 201L342 201L342 201L342 201L342 202L343 202L343 202L342 202L342 202L342 203L343 203L342 203L342 203L342 204L341 205L342 205L342 205L342 205L341 206L341 207L341 207L341 207L341 207L342 208L341 208L342 208L342 208L343 209L344 209L344 209L344 209L344 209L344 209L344 208L345 207L345 206L345 206L346 206L346 206L346 206L347 206L347 206L348 206L348 206L349 206L351 206L351 206L351 206L352 206L352 206L352 206L352 205L352 205L352 205L352 205L353 205L353 204L353 204L353 204L353 204L354 204L354 204L354 204L355 204L356 205L357 205L357 205L358 205L358 205L358 205L358 204L358 204L359 204L359 204L359 204z"
        },
        {
            "title": "Dharmapuri",
            "d": "M353 175L353 173L352 172L351 171L350 170L345 167L345 167L344 166L343 165L342 165L342 166L342 166L343 166L342 166L342 166L342 166L342 167L341 167L341 168L341 168L341 168L341 168L341 168L341 168L341 169L342 170L342 171L342 173L342 173L342 174L341 177L342 179L342 181L341 184L341 185L341 185L340 186L340 186L341 190L341 191L337 192L338 193L337 193L340 196L341 195L341 195L341 195L342 195L344 195L344 195L344 195L344 195L344 195L345 194L345 194L345 194L345 194L346 194L346 194L346 193L348 192L350 193L351 194L350 194L350 194L350 196L349 197L350 197L350 197L350 197L352 196L354 196L354 197L357 198L360 199L361 199L362 199L362 199L362 199L363 199L364 199L364 198L364 197L364 197L365 196L364 195L362 194L361 192L359 190L357 188L356 187L356 186L356 186L356 184L356 183L354 181L354 180L354 179L354 177L354 176L353 175z"
        },
        {
            "title": "Gollapalli",
            "d": "M359 204L359 204L359 204L358 204L358 204L358 205L358 205L358 205L357 205L357 205L356 205L355 204L354 204L354 204L354 204L353 204L353 204L353 204L353 204L353 205L352 205L352 205L352 205L352 205L352 206L352 206L352 206L351 206L351 206L351 206L349 206L348 206L348 206L347 206L347 206L346 206L346 206L346 206L345 206L345 206L345 207L344 208L344 209L344 209L344 209L344 209L344 209L343 209L342 208L342 208L341 208L342 208L341 207L341 207L340 207L340 208L340 208L340 208L339 208L339 208L339 208L339 208L339 208L338 209L338 210L338 210L338 210L338 210L338 210L338 210L338 211L338 211L338 211L339 211L339 211L339 212L339 212L339 212L339 212L338 212L338 213L337 213L338 213L338 213L338 214L338 214L338 214L338 214L338 215L338 215L338 215L337 215L337 216L337 216L337 216L337 217L337 217L337 217L337 217L335 218L335 218L332 219L332 220L331 220L333 222L334 222L335 222L335 222L335 221L336 221L336 221L337 221L338 220L338 220L339 219L339 218L339 219L340 219L340 221L342 222L342 221L343 222L343 222L343 222L344 222L344 221L344 221L344 221L344 221L344 221L345 221L345 220L345 219L345 219L346 220L346 220L346 220L347 220L347 220L347 220L348 220L349 218L349 218L349 218L349 219L349 219L349 219L349 219L349 219L350 219L350 220L350 220L350 220L350 220L350 221L351 222L351 222L352 222L352 222L352 222L352 222L353 222L353 222L353 222L353 222L354 222L354 222L354 222L354 222L355 221L355 220L355 220L355 220L356 220L357 220L357 221L359 222L359 222L362 221L362 221L361 221L361 221L361 221L361 221L362 221L362 220L362 220L362 220L362 220L362 220L362 220L362 220L361 220L361 220L361 219L361 219L361 219L361 219L361 219L362 219L362 219L362 218L361 218L361 218L361 218L361 217L361 217L361 217L361 217L360 217L360 217L360 217L360 217L360 217L359 217L359 217L359 216L360 216L360 216L361 216L361 215L361 215L361 215L362 215L362 215L363 215L363 215L364 214L364 214L364 214L364 214L364 213L364 213L364 213L364 212L363 212L363 212L362 212L360 212L360 211L360 211L360 210L360 210L360 210L361 209L361 209L361 208L361 208L361 208L361 207L361 207L361 207L362 207L362 207L362 207L361 207L361 206L362 206L362 206L362 206L362 205L362 205L362 205L362 204L362 204L361 205L361 205L361 204L361 204L360 204L360 204L360 204L359 204z"
        },
        {
            "title": "Kodimial",
            "d": "M335 237L335 237L335 237L335 238L335 238L335 238L334 238L334 238L334 238L333 238L330 238L328 237L328 237L327 236L324 234L324 233L324 233L324 233L324 233L324 233L323 232L322 232L318 232L316 233L314 233L314 233L311 233L310 233L307 234L307 234L307 235L308 237L307 238L303 241L303 242L307 245L307 245L309 245L313 247L313 247L315 248L318 247L320 250L321 251L322 251L322 251L322 251L322 251L322 251L322 252L322 252L322 252L322 251L323 252L323 252L323 252L323 252L323 252L322 252L323 252L323 252L323 252L323 253L323 253L323 253L323 253L323 253L324 252L324 252L324 252L324 251L326 252L326 253L327 252L328 251L328 251L328 251L328 251L328 250L328 250L328 250L328 250L330 250L331 250L331 250L331 250L331 251L332 251L331 251L333 251L333 251L333 251L334 251L334 251L334 252L335 252L335 252L336 251L336 251L336 251L336 250L336 250L336 250L336 250L335 250L335 250L335 249L335 249L335 248L334 248L334 248L334 248L334 248L334 247L334 247L334 247L333 247L333 246L333 246L333 246L333 246L333 245L333 245L333 245L333 245L333 245L333 244L334 243L334 242L335 241L335 240L335 240L335 240L335 240L335 240L335 240L335 239L335 239L335 239L335 239L336 239L336 239L336 238L336 238L336 238L336 238L336 238L336 237L336 237L336 237L336 237L335 237z"
        },
        {
            "title": "Ibrahimpatnam",
            "d": "M280 195L280 195L279 195L280 194L280 193L280 192L280 192L280 192L279 191L279 189L279 189L280 189L280 189L280 189L280 189L280 189L281 187L281 187L281 187L281 187L281 186L281 186L281 186L281 186L280 186L280 186L280 185L280 185L279 185L279 185L279 185L279 185L279 185L279 185L279 184L278 184L279 184L279 183L278 183L278 183L277 183L276 183L276 182L277 181L277 181L277 181L276 181L275 180L274 180L272 178L272 177L271 177L270 177L268 179L267 180L266 181L266 182L265 184L265 186L265 186L265 186L263 186L263 187L263 187L262 187L261 187L261 187L261 187L261 187L261 188L261 189L261 189L261 189L261 189L261 190L260 190L260 190L260 190L260 192L260 192L260 192L260 192L260 194L260 195L261 195L262 196L262 196L263 196L263 197L263 198L263 198L263 200L263 200L263 201L263 201L263 201L263 202L263 202L263 202L263 203L263 204L263 204L264 204L265 204L265 204L266 204L267 203L266 202L266 201L266 201L267 201L267 201L267 201L268 201L268 202L268 202L268 202L268 202L268 202L268 202L269 203L269 203L269 203L269 203L269 203L269 202L269 202L269 202L269 202L270 201L270 201L270 201L270 202L270 202L270 201L270 201L270 202L271 202L271 202L271 202L271 202L271 202L271 202L271 203L271 203L271 203L271 203L271 204L271 204L271 204L271 203L271 203L272 203L271 203L271 202L271 202L271 201L271 201L271 201L271 200L271 200L271 200L271 200L271 199L271 199L271 199L271 199L271 199L271 199L271 198L271 198L272 198L272 198L272 198L272 198L273 197L274 197L274 197L274 197L274 197L274 197L275 197L275 197L275 198L276 198L277 198L277 198L277 199L278 199L278 199L278 199L278 199L278 199L279 198L279 197L280 197L280 196L280 195z"
        },
        {
            "title": "Jagityal_Rural",
            "d": "M340 196L337 193L338 193L337 192L337 192L335 194L335 194L334 194L334 194L335 197L335 197L335 197L335 198L335 199L335 199L336 200L336 200L336 201L335 201L335 202L335 202L334 201L334 201L332 200L332 200L331 200L331 200L331 201L331 202L331 202L331 202L331 202L330 203L330 203L330 203L330 203L329 203L329 204L329 204L329 204L329 204L328 204L328 204L328 204L327 203L327 204L327 203L327 203L326 203L326 203L326 203L326 203L325 203L325 203L325 203L324 203L325 203L325 202L325 202L324 202L323 202L323 202L323 202L323 202L323 202L322 202L322 202L322 202L322 202L322 202L322 202L322 203L321 203L321 203L321 204L321 205L321 205L320 206L320 207L319 207L319 207L318 206L318 207L317 206L316 206L315 206L314 205L314 205L314 205L314 205L314 205L313 205L313 205L313 205L313 205L313 205L312 205L312 205L312 205L312 205L312 206L312 205L312 206L312 206L312 206L312 206L312 207L312 207L312 207L312 209L312 209L311 209L311 209L311 210L311 210L311 210L311 211L311 211L311 212L311 213L311 213L311 213L311 213L311 214L312 214L312 214L312 214L312 214L312 215L312 215L312 215L312 215L312 216L313 216L313 216L314 216L314 216L314 217L313 219L313 219L314 220L315 220L315 220L315 220L315 220L315 220L316 220L316 221L316 221L317 221L317 222L317 222L318 222L319 222L319 223L319 222L319 222L319 222L319 222L319 222L319 222L320 222L320 222L320 221L320 221L320 221L320 221L320 221L321 220L321 220L321 220L321 220L321 219L321 219L321 219L321 219L321 218L321 218L320 217L320 217L319 217L319 217L318 217L318 217L318 217L318 217L317 217L317 217L317 217L316 216L316 216L316 216L316 216L317 214L317 214L317 214L317 214L317 214L318 214L319 213L319 213L319 212L320 211L321 211L322 211L322 211L322 211L322 211L322 211L322 211L322 211L322 211L322 211L322 211L323 211L323 211L324 211L324 211L324 210L325 210L325 210L325 209L325 209L325 209L325 209L325 208L325 208L326 208L326 208L326 208L326 207L326 207L326 207L326 207L326 207L326 207L326 207L327 207L327 207L327 207L327 206L327 206L327 206L327 206L328 205L328 205L328 205L329 204L329 204L329 205L329 205L329 206L329 206L329 206L329 207L329 207L329 207L329 207L329 208L329 208L329 208L329 208L329 208L329 209L328 209L328 209L328 209L328 209L328 210L328 210L328 210L328 212L327 212L327 213L327 213L327 213L327 213L327 213L328 212L329 212L330 212L330 212L330 212L332 213L331 214L331 214L330 215L330 215L329 215L329 215L328 216L328 216L328 216L328 216L328 216L328 216L328 216L327 217L327 217L326 217L326 217L326 217L325 217L325 217L325 218L325 218L325 219L325 219L325 220L325 220L324 221L324 221L324 222L324 222L324 222L324 222L324 223L324 223L324 223L324 223L324 223L325 224L328 224L328 223L329 222L331 223L331 222L330 221L332 220L331 220L332 220L332 219L335 218L335 218L337 217L337 217L337 217L337 217L337 216L337 216L337 216L337 215L338 215L338 215L338 215L338 214L338 214L338 214L338 214L338 213L338 213L337 213L338 213L338 212L339 212L339 212L339 212L339 212L339 211L339 211L338 211L338 211L338 211L338 210L338 210L338 210L338 210L338 210L338 210L338 209L339 208L339 208L339 208L339 208L339 208L340 208L340 208L340 208L340 207L341 207L341 207L341 207L341 207L341 207L341 206L342 205L342 205L342 205L341 205L342 204L342 203L342 203L343 203L342 203L342 202L342 202L343 202L343 202L342 202L342 201L342 201L342 201L342 201L342 201L342 200L342 200L341 200L340 199L340 198L340 196z"
        },
        {
            "title": "Jagtial",
            "d": "M324 221L325 220L325 220L325 219L325 219L325 218L325 218L325 217L325 217L326 217L326 217L326 217L327 217L327 217L328 216L328 216L328 216L328 216L328 216L328 216L328 216L329 215L329 215L330 215L330 215L331 214L331 214L332 213L330 212L330 212L330 212L329 212L328 212L327 213L327 213L327 213L327 213L327 213L327 212L328 212L328 210L328 210L328 210L328 209L328 209L328 209L328 209L329 209L329 208L329 208L329 208L329 208L329 208L329 207L329 207L329 207L329 207L329 206L329 206L329 206L329 205L329 205L329 204L329 204L328 205L328 205L328 205L327 206L327 206L327 206L327 206L327 207L327 207L327 207L326 207L326 207L326 207L326 207L326 207L326 207L326 207L326 208L326 208L326 208L325 208L325 208L325 209L325 209L325 209L325 209L325 210L325 210L324 210L324 211L324 211L323 211L323 211L322 211L322 211L322 211L322 211L322 211L322 211L322 211L322 211L322 211L322 211L321 211L320 211L319 212L319 213L319 213L318 214L317 214L317 214L317 214L317 214L317 214L316 216L316 216L316 216L316 216L317 217L317 217L317 217L318 217L318 217L318 217L318 217L319 217L319 217L320 217L320 217L321 218L321 218L321 219L321 219L321 219L321 219L321 219L322 220L322 220L323 220L324 220L324 221L324 221L324 221L324 221z"
        },
        {
            "title": "Kathlapur",
            "d": "M297 215L296 216L296 216L295 216L295 216L295 216L295 216L294 216L293 215L293 215L292 215L292 215L292 215L291 216L291 216L291 215L290 215L290 215L290 214L290 214L289 214L289 214L286 213L285 214L285 214L285 215L285 215L285 215L284 215L284 215L284 215L284 216L284 216L284 216L284 216L284 217L284 217L284 217L284 217L284 218L283 218L283 218L283 217L283 217L283 217L282 217L281 217L281 217L280 217L280 217L280 217L280 217L280 218L279 219L279 219L279 220L279 220L278 221L278 222L279 222L279 222L279 222L279 222L279 223L279 223L278 224L278 224L278 225L279 225L279 226L279 227L279 228L279 229L279 230L279 231L279 231L279 231L278 231L278 232L278 233L278 234L278 234L279 234L279 234L279 234L279 234L280 237L280 238L281 240L281 240L282 241L282 241L286 240L287 241L287 241L288 240L288 240L288 240L288 239L288 239L289 239L290 239L290 239L290 240L291 240L291 240L291 240L292 241L294 241L294 241L295 241L295 241L297 241L299 242L298 241L299 241L299 240L299 238L296 235L296 235L296 234L296 234L297 234L297 233L297 233L297 231L297 231L297 230L297 229L297 229L296 229L296 229L296 229L296 229L295 228L295 228L294 228L295 228L295 227L295 227L295 227L295 226L295 226L295 225L295 225L295 225L295 225L296 225L296 224L296 224L296 224L295 224L295 223L294 223L294 223L295 222L295 221L294 221L295 221L294 221L294 220L294 220L295 220L295 220L295 220L296 221L296 221L296 221L297 221L297 221L298 221L298 221L299 221L299 220L299 220L298 220L298 220L298 220L298 219L298 219L298 219L298 218L298 218L298 218L298 218L298 218L298 217L298 217L298 217L298 217L299 217L298 217L298 216L298 216L298 216L298 215L297 215z"
        },
        {
            "title": "Korutla",
            "d": "M301 195L300 195L300 196L300 196L300 196L299 197L299 197L299 197L299 197L299 197L299 198L298 197L298 198L298 198L298 198L298 198L298 198L298 198L297 198L297 198L297 198L297 198L297 198L297 198L296 198L296 197L296 198L295 198L295 198L295 198L294 197L294 197L294 197L294 197L294 196L294 196L294 196L294 196L294 196L294 196L294 195L294 195L294 195L293 195L293 195L293 194L293 194L292 194L292 194L292 194L292 194L292 194L292 194L291 195L291 195L291 196L291 196L291 197L291 197L291 197L290 197L289 197L289 198L289 197L289 198L289 198L289 198L289 198L288 198L288 198L287 198L286 198L285 198L284 199L285 199L284 200L284 200L284 201L284 202L284 202L284 202L285 202L285 202L285 202L285 203L285 203L285 203L285 203L285 204L285 205L285 205L286 205L286 205L286 206L286 206L286 207L286 207L286 207L286 207L286 208L286 208L286 209L286 209L286 210L286 210L286 210L286 211L286 212L286 212L286 213L285 213L285 214L285 214L286 213L289 214L289 214L290 214L290 214L290 215L290 215L291 215L291 216L291 216L292 215L292 215L292 215L293 215L293 215L294 216L295 216L295 216L295 216L295 216L296 216L296 216L297 215L297 215L297 214L298 214L298 214L298 214L299 213L299 213L299 213L299 213L299 213L300 213L300 213L300 213L300 213L300 213L301 213L301 213L301 212L301 213L301 212L302 212L302 212L303 212L303 212L303 213L303 213L303 213L303 213L303 213L303 212L303 212L304 211L304 211L304 210L304 210L305 210L305 209L305 209L306 209L306 209L305 209L305 208L305 208L305 208L305 208L304 208L304 208L304 208L304 207L304 207L305 206L305 206L305 205L305 205L305 204L305 204L305 204L305 203L306 203L306 203L306 203L307 203L307 203L307 202L307 202L307 202L307 202L307 202L307 201L307 201L307 201L307 201L306 201L306 201L306 201L306 200L305 200L304 200L305 198L304 198L304 197L304 197L304 197L304 197L303 196L303 196L303 196L303 196L303 196L303 196L302 196L301 196L301 195L302 195L301 195L301 195L301 195L301 195L301 195L301 195z"
        },
        {
            "title": "Mallapur",
            "d": "M301 195L300 195L300 195L299 195L298 194L298 194L298 194L296 194L296 194L296 193L295 193L295 192L295 191L295 191L295 191L295 191L295 190L294 190L294 190L295 189L296 188L297 188L297 188L297 188L298 188L298 189L299 189L299 189L299 189L300 190L301 190L301 189L302 188L302 188L302 188L303 187L304 186L305 186L305 185L305 183L305 182L305 179L305 178L305 178L306 177L308 176L308 175L308 175L308 174L307 174L306 174L305 173L305 173L305 172L304 172L305 171L303 172L301 174L300 175L299 175L299 175L299 175L299 175L298 175L298 175L296 174L294 174L293 173L292 173L291 172L291 172L290 171L290 171L289 171L288 172L286 173L284 175L284 175L283 177L280 181L279 181L279 181L277 181L277 181L277 181L276 182L276 183L277 183L278 183L278 183L279 183L279 184L278 184L279 184L279 185L279 185L279 185L279 185L279 185L279 185L280 185L280 185L280 186L280 186L281 186L281 186L281 186L281 186L281 187L281 187L281 187L281 187L280 189L280 189L280 189L280 189L280 189L279 189L279 189L279 191L280 192L280 192L280 192L280 193L280 194L279 195L280 195L280 195L281 196L281 196L282 196L282 197L282 197L282 197L282 197L282 197L282 198L282 198L283 198L283 198L284 199L285 198L286 198L287 198L288 198L288 198L289 198L289 198L289 198L289 198L289 197L289 198L289 197L290 197L291 197L291 197L291 197L291 196L291 196L291 195L291 195L292 194L292 194L292 194L292 194L292 194L292 194L293 194L293 194L293 195L293 195L294 195L294 195L294 195L294 196L294 196L294 196L294 196L294 196L294 196L294 197L294 197L294 197L294 197L295 198L295 198L295 198L296 198L296 197L296 198L297 198L297 198L297 198L297 198L297 198L297 198L298 198L298 198L298 198L298 198L298 198L298 198L298 197L299 198L299 197L299 197L299 197L299 197L299 197L300 196L300 196L300 196L300 195L301 195z"
        },
        {
            "title": "Mallial",
            "d": "M340 221L340 219L339 219L339 218L339 219L338 220L338 220L337 221L336 221L336 221L335 221L335 222L335 222L334 222L333 222L331 220L332 220L330 221L331 222L331 223L329 222L328 223L328 224L325 224L324 223L324 223L324 223L324 223L324 223L324 222L324 222L324 222L324 222L324 221L324 221L324 221L324 221L324 221L324 220L323 220L322 220L322 220L321 219L321 219L321 220L321 220L321 220L321 220L320 221L320 221L320 221L320 221L320 221L320 222L320 222L319 222L319 222L319 222L319 222L319 222L319 222L319 223L319 222L318 222L317 222L317 222L317 221L316 221L316 221L316 220L315 220L315 220L315 220L315 220L315 220L314 220L313 219L313 219L313 220L313 220L313 220L313 220L312 221L312 222L312 222L311 224L311 225L311 225L311 225L311 225L311 225L311 226L311 226L311 226L311 226L312 226L312 226L311 227L311 227L312 227L312 227L312 227L312 227L312 228L312 228L313 228L312 229L314 233L314 233L316 233L318 232L322 232L323 232L324 233L324 233L324 233L324 233L324 233L324 234L327 236L328 237L328 237L330 238L333 238L334 238L334 238L334 238L335 238L335 238L335 238L335 237L335 237L335 237L335 236L335 236L335 236L335 236L336 236L336 236L336 236L336 235L336 235L336 235L336 235L337 234L337 234L337 234L337 234L337 234L337 234L338 234L339 233L339 233L339 232L339 232L339 231L339 230L339 230L340 228L340 226L340 226L340 225L339 225L339 225L339 225L340 225L340 224L340 224L340 224L340 223L340 223L340 223L340 223L340 223L340 223L340 223L340 222L340 222L340 221z"
        },
        {
            "title": "Bheemaram",
            "d": "M311 225L310 225L310 224L310 225L310 225L310 225L310 224L309 224L309 224L309 224L309 224L309 224L308 224L308 224L308 224L308 224L308 224L308 223L307 223L307 222L307 222L307 222L307 221L307 221L307 220L307 219L307 219L307 219L307 219L307 219L306 218L306 218L306 218L306 218L306 218L306 218L305 217L305 217L305 218L305 218L305 218L305 218L305 218L305 218L304 219L304 219L304 219L304 219L304 220L304 220L303 221L303 221L303 221L302 221L302 221L302 221L302 221L301 222L301 222L301 222L301 222L301 222L301 222L301 222L300 221L300 221L300 221L300 221L299 221L299 220L299 221L298 221L298 221L297 221L297 221L296 221L296 221L296 221L295 220L295 220L295 220L294 220L294 220L294 221L295 221L294 221L295 221L295 222L294 223L294 223L295 223L295 224L296 224L296 224L296 224L296 225L295 225L295 225L295 225L295 225L295 226L295 226L295 227L295 227L295 227L295 228L294 228L295 228L295 228L296 229L296 229L296 229L296 229L297 229L297 229L297 230L297 231L297 231L297 233L297 233L297 234L296 234L296 234L296 235L296 235L299 238L299 240L299 241L303 242L303 241L307 238L308 237L307 235L307 234L307 234L310 233L311 233L314 233L314 233L314 233L312 229L313 228L312 228L312 228L312 227L312 227L312 227L312 227L311 227L311 227L312 226L312 226L311 226L311 226L311 226L311 226L311 225L311 225L311 225z"
        },
        {
            "title": "Metpalli",
            "d": "M284 199L283 198L283 198L282 198L282 198L282 197L282 197L282 197L282 197L282 197L282 196L281 196L281 196L280 195L280 196L280 197L279 197L279 198L278 199L278 199L278 199L278 199L278 199L277 199L277 198L277 198L276 198L275 198L275 197L275 197L274 197L274 197L274 197L274 197L274 197L273 197L272 198L272 198L272 198L272 198L271 198L271 198L271 199L271 199L271 199L271 199L271 199L271 199L271 200L271 200L271 200L271 200L271 201L271 201L271 201L271 202L271 202L271 203L272 203L271 203L271 203L271 204L271 204L271 204L271 203L271 203L271 203L271 203L271 202L271 202L271 202L271 202L271 202L271 202L270 202L270 201L270 201L270 202L270 202L270 201L270 201L270 201L269 202L269 202L269 202L269 202L269 203L269 203L269 203L269 203L269 203L268 202L268 202L268 202L268 202L268 202L268 202L268 201L267 201L267 201L267 201L266 201L266 201L266 202L267 203L266 204L265 204L265 204L264 204L263 204L263 204L263 204L263 204L263 205L264 206L264 206L264 207L263 208L264 209L264 209L265 209L265 209L265 211L265 211L266 212L265 212L265 213L265 213L266 213L266 214L266 214L267 214L266 215L266 216L266 217L265 217L265 219L265 219L265 220L265 221L265 222L266 222L268 222L269 224L269 224L270 225L270 225L275 224L275 224L275 224L276 224L276 224L276 224L276 224L276 224L277 224L278 225L278 224L278 224L279 223L279 223L279 222L279 222L279 222L279 222L278 222L278 221L279 220L279 220L279 219L279 219L280 218L280 217L280 217L280 217L280 217L281 217L281 217L282 217L283 217L283 217L283 217L283 218L283 218L284 218L284 217L284 217L284 217L284 217L284 216L284 216L284 216L284 216L284 215L284 215L284 215L285 215L285 215L285 215L285 214L285 214L285 214L285 213L286 213L286 212L286 212L286 211L286 210L286 210L286 210L286 209L286 209L286 208L286 208L286 207L286 207L286 207L286 207L286 206L286 206L286 205L286 205L285 205L285 205L285 204L285 203L285 203L285 203L285 203L285 202L285 202L285 202L284 202L284 202L284 202L284 201L284 200L284 200L285 199L284 199z"
        },
        {
            "title": "Pegadapalli",
            "d": "M359 222L359 222L357 221L357 220L356 220L355 220L355 220L355 220L355 221L354 222L354 222L354 222L354 222L353 222L353 222L353 222L353 222L352 222L352 222L352 222L352 222L351 222L351 222L350 221L350 220L350 220L350 220L350 220L350 219L349 219L349 219L349 219L349 219L349 219L349 218L349 218L349 218L348 220L347 220L347 220L347 220L346 220L346 220L346 220L345 219L345 219L345 220L345 221L344 221L344 221L344 221L344 221L344 221L344 222L343 222L343 222L343 222L342 221L342 222L340 221L340 222L340 222L340 223L340 223L340 223L340 223L340 223L340 223L340 223L340 224L340 224L340 224L340 225L339 225L339 225L339 225L340 225L340 226L340 226L340 228L339 230L339 230L339 231L339 232L339 232L339 233L340 234L341 234L341 235L341 236L341 236L341 236L341 237L341 237L341 237L341 238L341 238L341 238L341 238L341 238L342 237L342 238L342 238L342 238L342 238L342 238L343 238L344 238L344 238L344 239L344 239L344 240L344 240L344 240L344 240L344 240L344 240L346 241L346 239L346 239L346 239L346 239L346 238L346 238L346 238L346 238L346 237L347 237L347 237L347 236L347 236L347 236L347 235L347 235L347 235L347 235L347 235L348 235L348 235L348 235L348 235L348 235L348 235L348 235L348 236L349 235L348 236L349 236L348 237L349 237L349 237L350 237L350 237L350 238L350 237L350 238L350 238L351 238L351 238L351 238L352 238L352 237L352 237L352 237L352 237L352 237L352 237L352 237L353 237L353 237L353 237L353 237L353 237L353 237L353 237L354 237L354 237L353 238L354 238L353 238L354 238L354 238L354 238L354 238L354 238L354 238L354 238L355 238L355 238L355 238L355 238L355 238L355 238L355 237L355 237L355 237L355 236L355 236L355 236L355 236L355 236L355 235L356 236L356 236L356 236L356 236L356 236L356 236L356 236L357 237L357 236L357 236L357 236L357 236L357 236L357 236L358 236L358 236L359 236L359 236L359 236L358 236L359 235L358 235L358 235L358 235L358 232L358 231L357 231L357 231L357 231L357 230L357 230L357 230L357 230L357 229L357 229L357 229L358 229L358 229L358 229L358 229L358 229L358 229L358 229L358 229L358 229L359 229L359 229L359 229L359 228L359 228L359 228L359 228L359 228L360 228L359 228L360 227L360 227L360 226L360 226L361 226L360 226L360 225L360 225L360 225L360 225L360 225L360 224L359 224L359 222z"
        },
        {
            "title": "Raikal",
            "d": "M319 169L316 167L314 166L313 166L313 166L312 166L311 167L310 169L310 169L309 169L309 170L307 169L307 169L306 170L306 170L305 171L305 171L304 172L305 172L305 173L305 173L306 174L307 174L308 174L308 175L308 175L308 176L306 177L305 178L305 178L305 179L305 182L305 183L305 185L305 186L304 186L303 187L302 188L302 188L302 188L301 189L301 190L300 190L299 189L299 189L299 189L298 189L298 188L297 188L297 188L297 188L296 188L295 189L294 190L294 190L295 190L295 191L295 191L295 191L295 191L295 192L295 193L296 193L296 194L296 194L298 194L298 194L298 194L299 195L300 195L300 195L301 195L301 195L301 195L301 195L301 195L301 195L302 195L301 195L301 196L302 196L303 196L303 196L303 196L303 196L303 196L303 196L304 197L304 197L304 197L304 197L304 198L305 198L304 200L305 200L306 200L306 201L306 201L306 201L307 201L307 201L307 201L307 201L307 201L307 201L308 201L307 201L308 201L308 201L308 201L308 200L308 200L308 200L308 200L308 199L309 199L309 199L310 198L310 197L310 198L311 198L311 198L311 198L311 198L312 198L312 198L312 198L313 198L313 198L313 198L313 198L313 198L313 199L313 199L313 199L313 199L314 200L314 199L314 200L314 200L314 201L314 201L314 201L314 201L315 202L315 202L314 202L314 202L314 202L315 203L315 203L314 204L314 204L314 205L314 205L314 205L314 205L314 205L315 206L316 206L317 206L318 207L318 206L319 207L319 207L320 207L320 206L321 205L321 205L321 204L321 203L321 203L322 203L322 202L322 202L322 202L322 202L322 202L322 202L323 202L323 202L323 201L322 201L321 200L321 199L321 199L321 199L321 199L321 196L322 194L322 191L320 190L322 185L323 184L325 181L328 176L320 176L319 169L319 169L319 169z"
        },
        {
            "title": "Sarangapur",
            "d": "M341 185L336 183L337 182L335 181L335 181L335 180L332 181L331 179L328 176L328 176L325 181L323 184L322 185L320 190L322 191L322 194L321 196L321 199L321 199L321 199L321 199L321 200L322 201L323 201L323 202L323 202L323 202L323 202L324 202L325 202L325 202L325 203L324 203L325 203L325 203L325 203L326 203L326 203L326 203L326 203L327 203L327 203L327 204L327 203L328 204L328 204L328 204L329 204L329 204L329 204L329 204L329 203L330 203L330 203L330 203L330 203L331 202L331 202L331 202L331 202L331 201L331 200L331 200L332 200L332 200L334 201L334 201L335 202L335 202L335 201L336 201L336 200L336 200L335 199L335 199L335 198L335 197L335 197L335 197L334 194L334 194L335 194L335 194L337 192L337 192L341 191L341 190L340 186L340 186L341 185L341 185z"
        },
        {
            "title": "Velgatur",
            "d": "M366 198L365 197L365 196L364 197L364 197L364 198L364 199L363 199L362 199L362 199L362 199L361 199L360 199L359 200L359 200L359 201L360 201L359 202L359 202L360 203L359 203L359 204L360 204L360 204L360 204L361 204L361 204L361 205L361 205L362 204L362 204L362 205L362 205L362 205L362 206L362 206L362 206L361 206L361 207L362 207L362 207L362 207L361 207L361 207L361 207L361 208L361 208L361 208L361 209L361 209L360 210L360 210L360 210L360 211L360 211L360 212L362 212L363 212L363 212L364 212L364 212L364 212L364 212L364 211L364 211L364 211L365 211L365 211L366 210L366 209L366 209L367 209L367 209L367 209L368 210L368 210L368 210L368 210L368 210L368 210L368 211L368 211L369 211L370 211L370 211L370 212L372 212L371 213L371 213L371 214L372 215L372 215L372 215L373 215L373 214L373 215L373 214L373 215L373 214L374 215L374 214L374 214L374 215L374 215L375 215L375 215L375 215L376 215L376 215L376 215L376 215L377 215L377 214L377 214L378 214L378 214L379 214L379 214L379 213L379 213L379 213L380 213L380 213L380 213L381 213L382 214L384 214L384 214L385 214L386 213L387 213L387 212L387 211L387 210L385 209L384 209L383 208L382 207L380 204L379 204L379 203L378 203L376 202L373 202L370 201L369 201L368 200L366 198z"
        },
        {
            "title": "Endapalli",
            "d": "M387 210L387 211L387 212L387 213L386 213L385 214L384 214L384 214L382 214L381 213L380 213L380 213L380 213L379 213L379 213L379 213L379 214L379 214L378 214L378 214L377 214L377 214L377 215L376 215L376 215L376 215L376 215L375 215L375 215L375 215L374 215L374 215L374 214L374 214L374 215L373 214L373 215L373 214L373 215L373 214L373 215L372 215L372 215L372 215L371 214L371 213L371 213L372 212L370 212L370 211L370 211L369 211L368 211L368 211L368 210L368 210L368 210L368 210L368 210L368 210L367 209L367 209L367 209L366 209L366 209L366 210L365 211L365 211L364 211L364 211L364 211L364 212L364 212L364 212L364 212L364 213L364 213L364 213L364 214L364 214L364 214L364 214L363 215L363 215L362 215L362 215L361 215L361 215L361 215L361 216L360 216L360 216L359 216L359 217L359 217L360 217L360 217L360 217L360 217L360 217L361 217L361 217L361 217L361 217L361 218L361 218L361 218L362 218L362 219L362 219L361 219L361 219L361 219L361 219L361 219L361 220L361 220L362 220L362 220L362 220L362 220L362 220L362 220L362 220L362 221L361 221L361 221L361 221L361 221L362 221L362 221L359 222L359 224L360 224L360 225L360 225L360 225L360 225L360 225L360 226L361 226L362 226L363 224L365 220L368 221L370 222L371 222L372 222L372 222L373 223L373 223L374 223L374 223L374 223L374 222L374 223L374 222L375 222L375 222L375 222L375 222L375 222L375 222L376 222L376 221L376 221L376 221L376 221L376 221L377 221L379 222L379 221L379 221L379 221L379 221L380 221L380 221L380 221L380 221L380 221L382 222L382 222L382 222L385 223L387 222L387 222L386 220L386 220L386 219L386 218L386 218L386 218L386 217L386 217L386 217L387 217L387 216L387 215L388 215L388 212L389 211L389 210L387 210z"
        },
        {
            "title": "Medipalle",
            "d": "M311 225L311 225L311 225L311 224L312 222L312 222L312 221L313 220L313 220L313 220L313 220L313 219L314 217L314 216L314 216L313 216L313 216L312 216L312 215L312 215L312 215L312 215L312 214L312 214L312 214L312 214L311 214L311 213L311 213L311 213L311 213L311 212L311 211L311 211L311 210L311 210L311 210L311 209L311 209L312 209L312 209L312 207L312 207L312 207L312 206L312 206L312 206L312 206L312 205L312 206L312 205L312 205L312 205L312 205L313 205L313 205L313 205L313 205L313 205L314 205L314 204L314 204L315 203L315 203L314 202L314 202L314 202L315 202L315 202L314 201L314 201L314 201L314 201L314 200L314 200L314 199L314 200L313 199L313 199L313 199L313 199L313 198L313 198L313 198L313 198L313 198L312 198L312 198L312 198L311 198L311 198L311 198L311 198L310 198L310 197L310 198L309 199L309 199L308 199L308 200L308 200L308 200L308 200L308 201L308 201L308 201L307 201L308 201L307 201L307 201L307 201L307 201L307 201L307 201L307 201L307 201L307 201L307 202L307 202L307 202L307 202L307 202L307 203L307 203L306 203L306 203L306 203L305 203L305 204L305 204L305 204L305 205L305 205L305 206L305 206L304 207L304 207L304 208L304 208L304 208L305 208L305 208L305 208L305 208L305 209L306 209L306 209L305 209L305 209L305 210L304 210L304 210L304 211L304 211L303 212L303 212L303 213L303 213L303 213L303 213L303 213L303 212L303 212L302 212L302 212L301 212L301 213L301 212L301 213L301 213L300 213L300 213L300 213L300 213L300 213L299 213L299 213L299 213L299 213L299 213L298 214L298 214L298 214L297 214L297 215L297 215L298 215L298 216L298 216L298 216L298 217L299 217L298 217L298 217L298 217L298 217L298 218L298 218L298 218L298 218L298 218L298 219L298 219L298 219L298 220L298 220L298 220L299 220L299 220L299 221L300 221L300 221L300 221L300 221L301 222L301 222L301 222L301 222L301 222L301 222L301 222L302 221L302 221L302 221L302 221L303 221L303 221L303 221L304 220L304 220L304 219L304 219L304 219L304 219L305 218L305 218L305 218L305 218L305 218L305 218L305 217L305 217L306 218L306 218L306 218L306 218L306 218L306 218L307 219L307 219L307 219L307 219L307 219L307 220L307 221L307 221L307 222L307 222L307 222L307 223L308 223L308 224L308 224L308 224L308 224L308 224L309 224L309 224L309 224L309 224L309 224L310 224L310 225L310 225L310 225L310 224L310 225L311 225z"
        }
    ],
    "Mancherial": [
        {
            "title": "Bellampalle",
            "d": "M411 165L411 165L412 166L414 168L416 169L417 169L417 169L418 169L418 169L418 170L419 171L419 171L418 172L418 173L418 175L417 175L417 175L416 176L416 176L417 176L419 176L419 176L421 179L423 180L424 181L425 181L424 182L424 182L424 183L425 183L425 182L428 179L429 177L429 175L429 174L429 174L430 173L430 172L431 172L431 172L431 172L432 172L432 171L432 171L436 172L436 172L435 171L434 170L434 169L434 167L434 166L434 165L433 164L433 164L432 163L430 163L430 162L430 162L430 161L430 161L430 161L430 161L430 161L429 160L428 159L424 158L423 158L423 156L423 155L422 156L421 156L420 156L420 156L420 157L420 157L420 158L419 159L419 159L419 159L418 159L419 160L419 160L419 160L419 161L419 161L419 161L418 161L417 161L417 161L417 161L417 161L417 161L416 161L416 161L416 161L416 161L416 161L416 160L416 160L415 160L414 160L414 159L414 158L413 158L411 156L412 156L411 155L411 155L409 156L409 157L408 158L408 158L408 160L412 164L411 165z"
        },
        {
            "title": "Bheemaram",
            "d": "M447 189L446 189L445 189L445 189L444 189L444 189L444 189L444 189L444 189L443 189L443 189L444 188L443 188L443 188L443 188L442 188L442 189L442 189L442 189L441 189L440 189L439 189L438 189L437 190L435 191L435 192L435 193L435 193L436 194L436 195L436 196L437 198L438 199L440 199L441 199L441 199L441 200L441 201L441 201L441 202L441 204L440 204L439 204L440 205L441 206L441 207L441 207L441 208L441 208L442 209L442 209L443 210L444 210L445 211L445 211L446 213L446 213L447 214L447 214L448 215L449 215L450 216L452 220L453 219L454 218L454 218L455 218L457 217L457 217L458 217L458 216L459 216L459 214L459 214L457 212L458 212L458 211L456 211L456 210L455 209L455 209L454 208L455 207L455 206L455 206L455 206L455 206L454 205L455 204L454 204L455 204L455 201L455 199L455 198L456 197L456 196L456 196L456 196L454 197L454 197L453 197L452 198L452 198L450 195L450 195L450 195L450 195L450 194L450 193L450 192L450 191L449 190L447 189z"
        },
        {
            "title": "Bheemini",
            "d": "M430 134L429 133L429 133L429 132L429 132L429 132L429 131L430 131L430 130L430 130L429 130L429 130L429 129L429 129L429 129L428 129L428 130L428 130L426 130L425 129L425 130L424 130L424 129L424 129L424 129L424 129L424 129L423 129L423 130L423 130L423 130L423 131L423 131L422 132L422 133L423 133L423 133L424 134L425 134L425 134L425 135L425 135L425 135L425 135L425 136L425 136L426 136L426 137L426 137L426 138L426 138L426 138L426 139L426 139L426 139L426 139L426 139L426 139L427 139L427 140L427 140L427 140L428 140L428 141L428 141L428 141L428 141L429 141L429 142L429 142L429 142L429 143L429 144L429 144L429 145L429 145L429 145L429 145L429 145L429 146L429 146L429 146L429 146L429 146L429 146L429 147L429 147L430 148L431 148L431 149L431 149L431 149L431 149L431 149L431 149L432 150L432 150L432 150L431 151L431 151L431 151L431 151L431 151L431 151L431 152L431 152L431 152L432 152L432 152L432 153L431 153L431 154L431 154L431 154L432 155L433 155L433 154L433 154L434 153L434 154L434 153L434 153L434 154L435 154L435 153L435 154L435 153L436 153L436 153L436 153L436 152L436 152L436 152L437 152L437 151L437 151L437 151L437 151L437 151L438 150L438 150L438 150L438 150L438 150L438 149L438 149L439 149L439 149L439 149L439 149L439 148L439 149L440 149L441 149L441 149L441 149L441 149L441 149L441 149L441 149L441 150L441 150L441 151L441 151L441 152L441 152L442 152L441 152L441 153L440 153L440 155L440 155L440 155L441 155L441 155L441 155L442 155L442 155L443 155L443 155L443 155L443 155L444 155L444 155L444 154L444 154L444 154L444 153L444 153L444 152L444 152L445 151L445 151L445 151L445 151L445 151L445 151L445 150L446 150L446 150L446 150L446 150L446 150L446 150L447 150L447 150L447 150L447 150L447 150L447 150L447 150L448 150L448 149L448 149L448 149L448 149L448 149L448 149L448 149L448 149L448 149L449 148L448 148L448 149L448 149L448 148L448 147L448 147L447 147L446 147L446 147L446 147L446 147L446 147L446 147L446 147L445 147L445 147L445 147L445 147L445 147L445 148L445 148L445 148L445 148L445 148L445 148L445 148L445 148L445 148L444 148L444 147L444 147L444 147L444 147L444 147L443 146L443 146L443 146L443 146L443 147L442 146L442 147L442 147L442 147L442 147L442 147L442 147L441 147L441 147L441 147L441 146L441 145L441 144L441 144L442 144L443 143L444 143L444 143L444 143L444 143L445 143L445 143L445 142L445 142L445 142L445 142L445 143L445 143L445 144L445 145L445 146L445 146L446 146L446 146L446 146L446 145L446 145L447 145L447 145L447 145L447 145L448 145L448 145L448 145L448 145L449 145L449 145L449 144L449 144L450 144L450 143L450 143L450 143L450 144L450 144L450 143L450 143L450 143L450 143L450 142L450 142L450 141L450 141L449 140L449 140L449 140L448 140L448 140L448 141L447 141L446 141L446 140L446 140L447 138L447 138L446 137L445 137L445 136L445 136L445 135L445 135L445 135L444 134L444 134L443 134L443 134L443 134L443 135L443 135L442 135L442 135L442 135L442 135L441 135L441 134L441 134L441 133L441 133L441 133L441 132L440 132L440 131L439 131L439 131L439 131L439 131L439 131L439 132L438 132L437 131L436 132L436 132L436 132L436 132L436 132L435 132L435 133L435 133L435 133L434 133L434 133L434 133L433 134L432 134L432 134L431 134L431 134L431 134L431 134L430 134L430 134L430 134L430 134L430 134z"
        },
        {
            "title": "Chennur",
            "d": "M457 186L456 186L454 186L454 186L452 187L451 187L450 187L448 188L448 189L447 189L449 190L450 191L450 192L450 193L450 194L450 195L450 195L450 195L450 195L452 198L452 198L453 197L454 197L454 197L456 196L456 196L456 196L456 197L455 198L455 199L455 201L455 204L454 204L455 204L454 205L455 206L455 206L455 206L455 206L455 207L454 208L455 209L455 209L456 210L456 211L458 211L458 212L457 212L459 214L459 214L459 216L458 216L458 217L457 217L457 217L455 218L454 218L454 218L453 219L452 220L453 220L453 221L455 221L457 225L456 225L455 225L454 226L454 227L454 227L454 230L456 233L456 233L457 234L459 234L461 234L462 234L465 233L466 232L470 230L472 229L473 228L473 228L473 227L473 226L473 224L473 222L473 222L473 221L474 220L475 218L476 217L477 217L477 216L478 215L478 215L478 214L476 212L475 210L475 209L474 208L474 207L474 205L475 203L475 203L476 202L476 202L477 202L477 202L477 201L477 201L477 201L476 201L476 200L476 200L476 200L476 199L476 199L475 199L476 197L474 197L473 196L473 196L472 195L471 194L469 194L468 195L468 195L466 195L466 195L466 194L465 193L464 191L462 190L462 190L462 189L461 188L460 188L457 186z"
        },
        {
            "title": "Dandepalle",
            "d": "M375 170L374 168L374 168L373 168L373 168L373 167L373 166L370 165L368 164L367 163L366 163L364 162L364 162L363 161L363 161L362 161L362 161L361 161L360 162L359 162L359 163L359 163L359 164L359 164L358 165L358 165L357 165L357 166L357 166L356 167L355 168L355 169L355 169L355 169L356 170L356 170L357 170L357 170L356 170L356 171L356 172L356 172L356 172L356 173L355 173L355 173L354 173L354 174L354 174L354 174L353 175L354 176L354 177L354 179L354 180L354 181L356 183L356 184L356 186L356 186L356 187L357 188L359 190L361 192L362 194L364 195L365 196L365 197L366 198L367 198L367 198L367 197L367 196L367 196L367 196L368 195L368 195L368 195L368 195L369 196L369 196L369 196L370 196L370 196L370 196L370 196L370 195L370 195L370 195L371 195L371 194L370 194L370 194L370 194L371 193L370 193L371 193L370 192L370 192L370 192L369 192L369 192L369 192L368 191L369 191L369 191L368 191L368 190L367 190L366 190L366 190L366 190L366 189L366 189L366 189L366 189L367 188L367 188L367 188L367 187L367 187L367 187L367 187L367 187L368 187L368 187L368 187L368 187L368 187L369 187L369 186L369 186L369 186L370 186L370 186L371 186L371 186L371 186L371 186L371 186L371 186L372 186L372 186L372 186L372 186L373 186L373 185L373 185L373 185L373 185L373 185L373 185L373 184L373 184L373 184L373 184L374 183L374 183L375 182L375 182L375 182L375 181L375 181L375 181L376 181L376 181L376 180L375 180L375 179L374 179L374 177L374 175L374 175L374 174L374 173L374 173L375 172L375 170L375 170z"
        },
        {
            "title": "Hajipur",
            "d": "M403 179L403 179L403 179L402 179L401 179L400 178L401 177L400 175L399 175L399 176L400 177L400 179L397 179L396 181L395 180L394 179L394 179L393 178L391 177L391 178L390 178L390 178L390 178L390 178L389 179L389 179L388 180L388 180L388 180L388 181L387 182L386 183L386 184L386 184L387 185L387 187L386 188L385 189L385 189L385 190L384 191L384 192L384 192L384 193L384 193L383 193L384 193L383 193L383 193L383 194L383 194L383 194L383 194L383 194L383 194L383 195L383 195L383 195L383 195L383 195L383 195L384 195L384 196L384 196L383 196L383 197L384 197L384 197L384 198L384 198L384 198L384 198L383 198L383 198L383 199L383 199L383 199L384 200L384 201L384 201L384 201L384 201L384 201L387 202L386 202L387 202L387 202L386 202L386 203L386 204L385 204L385 204L385 204L384 204L384 205L384 205L384 205L384 205L383 207L382 207L383 208L384 209L385 209L387 210L389 210L391 211L393 211L394 210L396 210L396 210L397 209L398 208L399 206L399 205L400 204L401 204L403 204L404 204L406 204L407 204L407 202L408 202L408 202L408 202L407 202L408 202L408 202L408 202L408 201L408 201L407 201L407 201L407 200L408 199L408 199L408 199L408 199L408 198L407 198L407 198L407 197L407 197L407 197L407 197L407 196L407 196L406 195L405 195L405 194L405 193L406 191L406 190L407 189L407 188L408 188L408 188L408 187L408 187L407 185L407 184L405 182L404 180L403 179z"
        },
        {
            "title": "Jaipur",
            "d": "M435 193L432 196L430 197L429 197L429 197L429 196L429 196L429 196L429 196L429 196L428 196L428 196L428 196L426 197L425 198L424 198L424 197L424 198L423 199L423 199L423 199L424 200L424 201L422 206L422 207L422 208L423 208L423 208L422 209L422 210L422 210L421 211L421 212L421 212L421 213L420 214L421 215L421 215L422 216L422 216L423 216L425 216L426 216L427 217L428 217L429 217L430 218L432 219L433 220L434 221L435 222L436 224L437 224L439 225L441 226L441 226L442 226L443 226L444 227L444 227L444 227L446 231L447 232L447 233L448 234L449 235L451 236L452 236L452 236L453 235L453 234L455 234L455 233L456 233L456 233L454 230L454 227L454 227L454 226L455 225L456 225L457 225L455 221L453 221L453 220L452 220L450 216L449 215L448 215L447 214L447 214L446 213L446 213L445 211L445 211L444 210L443 210L442 209L442 209L441 208L441 208L441 207L441 207L441 206L440 205L439 204L440 204L441 204L441 202L441 201L441 201L441 200L441 199L441 199L440 199L438 199L437 198L436 196L436 195L436 194L435 193L435 193z"
        },
        {
            "title": "Jannaram",
            "d": "M346 142L346 142L345 142L344 143L344 143L343 142L343 142L342 141L342 141L342 141L336 139L337 137L337 137L336 137L335 137L334 136L334 136L333 135L332 135L332 134L329 138L329 140L329 140L329 140L328 141L328 142L327 142L327 142L326 143L326 144L326 145L326 145L326 146L324 146L323 147L321 149L321 149L321 149L319 150L319 150L319 150L319 150L319 150L319 150L320 150L320 151L320 151L320 151L320 152L320 154L321 156L320 156L320 158L321 160L323 162L324 160L325 160L326 160L326 159L326 159L325 158L325 158L327 158L327 158L327 158L327 158L327 158L327 158L328 158L328 158L329 159L329 160L329 160L329 160L330 162L330 163L330 163L330 164L330 164L330 164L331 165L332 165L333 164L334 164L336 165L338 165L338 165L339 165L340 165L341 165L342 165L343 165L344 166L345 167L345 167L350 170L351 171L352 172L353 173L353 175L354 174L354 174L354 174L354 173L355 173L355 173L356 173L356 172L356 172L356 172L356 171L356 170L357 170L357 170L356 170L356 170L355 169L355 169L355 169L355 168L356 167L357 166L357 166L357 165L358 165L358 165L359 164L359 164L359 163L359 163L359 162L360 162L361 161L362 161L362 161L362 159L361 159L361 159L359 159L357 158L352 153L352 150L345 148L345 147L345 147L345 146L345 145L345 145L345 145L345 144L345 144L345 144L345 144L346 143L346 143L346 143L346 142z"
        },
        {
            "title": "Kannepalli",
            "d": "M449 145L449 145L448 145L448 145L448 145L448 145L447 145L447 145L447 145L447 145L446 145L446 145L446 146L446 146L446 146L445 146L445 146L445 145L445 144L445 143L445 143L445 142L445 142L445 142L445 142L445 143L445 143L444 143L444 143L444 143L444 143L443 143L442 144L441 144L441 144L441 145L441 146L441 147L441 147L441 147L442 147L442 147L442 147L442 147L442 147L442 147L442 146L443 147L443 146L443 146L443 146L443 146L444 147L444 147L444 147L444 147L444 147L444 148L445 148L445 148L445 148L445 148L445 148L445 148L445 148L445 148L445 148L445 147L445 147L445 147L445 147L445 147L446 147L446 147L446 147L446 147L446 147L446 147L446 147L447 147L448 147L448 147L448 148L448 149L448 149L448 148L449 148L448 149L448 149L448 149L448 149L448 149L448 149L448 149L448 149L448 149L448 150L447 150L447 150L447 150L447 150L447 150L447 150L447 150L446 150L446 150L446 150L446 150L446 150L446 150L445 150L445 151L445 151L445 151L445 151L445 151L445 151L444 152L444 152L444 153L444 153L444 154L444 154L444 154L444 155L444 155L443 155L443 155L443 155L443 155L442 155L442 155L441 155L441 155L441 155L440 155L440 155L440 155L440 153L441 153L441 152L442 152L441 152L441 152L441 151L441 151L441 150L441 150L441 149L441 149L441 149L441 149L441 149L441 149L441 149L440 149L439 149L439 148L439 149L439 149L439 149L439 149L438 149L438 149L438 150L438 150L438 150L438 150L438 150L437 151L437 151L437 151L437 151L437 151L437 152L436 152L436 152L436 152L436 153L436 153L436 153L435 153L435 154L435 153L435 154L434 154L434 153L434 153L434 154L434 153L433 154L433 154L433 155L432 155L432 156L432 156L431 156L431 156L431 156L431 156L430 156L430 156L429 158L429 158L428 159L428 159L429 160L430 161L430 161L430 161L430 161L430 161L430 162L430 162L430 163L432 163L433 164L433 164L434 164L434 164L434 163L435 163L435 163L436 163L436 163L438 164L438 164L439 164L439 164L440 164L440 164L440 164L440 164L441 163L441 162L441 163L441 162L442 163L442 163L442 163L442 164L442 164L443 165L443 165L443 165L444 165L444 165L445 164L445 164L446 164L446 164L447 163L447 163L448 163L449 161L449 161L449 161L449 161L450 161L450 160L450 160L451 160L451 159L450 159L451 159L451 158L451 158L451 158L451 158L451 157L452 158L453 158L454 157L454 156L454 155L454 155L454 155L455 155L455 155L456 155L456 155L456 155L456 156L457 156L457 155L457 155L457 154L457 153L458 152L459 152L460 152L460 152L461 153L462 152L462 152L463 153L463 152L463 151L465 151L465 152L465 153L465 153L465 154L466 154L466 154L469 155L471 154L468 152L468 151L468 151L467 151L467 150L468 148L466 147L466 146L465 147L465 147L465 147L464 147L464 147L464 147L464 148L464 148L464 148L463 148L463 148L463 148L463 148L463 148L463 148L462 148L462 148L462 148L461 148L461 148L461 148L461 148L461 148L461 148L461 147L461 147L460 147L460 147L459 147L459 147L459 147L459 146L458 146L458 146L458 146L458 145L457 145L457 144L456 144L456 143L455 143L455 144L455 144L455 144L454 144L454 144L454 144L454 144L453 145L453 145L453 145L452 145L452 144L452 144L450 145L450 145L450 145L450 145L449 145z"
        },
        {
            "title": "Kasipet",
            "d": "M403 156L402 155L401 155L400 155L400 155L400 154L398 154L398 153L398 153L397 153L398 153L397 153L397 153L396 153L396 153L396 152L394 152L394 152L392 151L392 151L392 152L392 152L392 151L392 152L391 151L391 152L391 152L391 152L391 153L391 153L392 154L392 154L392 155L392 155L391 156L392 156L392 157L391 157L391 157L391 158L391 159L391 160L391 161L389 160L388 159L387 159L386 158L386 158L382 155L381 154L380 154L380 154L380 155L380 154L380 156L382 158L381 159L381 159L381 159L381 159L381 161L381 163L381 166L381 165L381 165L380 165L379 165L378 166L376 167L376 167L376 167L376 168L376 168L375 169L375 170L375 170L375 172L374 173L374 173L374 174L374 175L374 175L374 177L374 179L375 179L375 180L376 180L376 181L377 180L377 179L377 180L378 180L379 180L379 180L380 181L380 181L381 182L381 182L381 182L381 181L381 180L382 179L383 179L384 178L385 178L385 178L386 178L387 178L387 178L390 178L391 178L391 177L393 178L394 179L394 179L395 180L396 181L397 179L400 179L400 177L399 176L399 175L400 175L401 177L400 178L401 179L402 179L403 179L403 179L403 179L404 180L405 180L406 178L409 179L411 180L413 182L413 182L413 181L413 180L413 180L414 180L414 179L414 179L414 179L415 179L415 178L415 177L416 176L416 176L417 175L417 175L418 175L418 173L418 172L419 171L419 171L418 170L418 169L418 169L417 169L417 169L416 169L414 168L412 166L411 165L411 165L410 164L410 164L410 164L410 164L409 164L409 163L408 163L408 162L407 161L406 160L404 157L404 156L403 156z"
        },
        {
            "title": "Luxettipet",
            "d": "M390 178L387 178L387 178L386 178L385 178L385 178L384 178L383 179L382 179L381 180L381 181L381 182L381 182L381 182L380 181L380 181L379 180L379 180L378 180L377 180L377 179L377 180L376 181L376 181L375 181L375 181L375 181L375 182L375 182L375 182L374 183L374 183L373 184L373 184L373 184L373 184L373 185L373 185L373 185L373 185L373 185L373 185L373 186L372 186L372 186L372 186L372 186L371 186L371 186L371 186L371 186L371 186L371 186L370 186L370 186L369 186L369 186L369 186L369 187L368 187L368 187L368 187L368 187L368 187L367 187L367 187L367 187L367 187L367 187L367 188L367 188L367 188L366 189L366 189L366 189L366 189L366 190L366 190L366 190L367 190L368 190L368 191L369 191L369 191L368 191L369 192L369 192L369 192L370 192L370 192L370 192L371 193L370 193L371 193L370 194L370 194L370 194L371 194L371 195L370 195L370 195L370 195L370 196L370 196L370 196L370 196L369 196L369 196L369 196L368 195L368 195L368 195L368 195L367 196L367 196L367 196L367 197L367 198L367 198L366 198L368 200L369 201L370 201L373 202L376 202L378 203L379 203L379 204L380 204L382 207L383 207L384 205L384 205L384 205L384 205L384 204L385 204L385 204L385 204L386 204L386 203L386 202L387 202L387 202L386 202L387 202L384 201L384 201L384 201L384 201L384 201L384 200L383 199L383 199L383 199L383 198L383 198L384 198L384 198L384 198L384 198L384 197L384 197L383 197L383 196L384 196L384 196L384 195L383 195L383 195L383 195L383 195L383 195L383 195L383 194L383 194L383 194L383 194L383 194L383 194L383 193L383 193L384 193L383 193L384 193L384 193L384 192L384 192L384 191L385 190L385 189L385 189L386 188L387 187L387 185L386 184L386 184L386 183L387 182L388 181L388 180L388 180L388 180L389 179L389 179L390 178L390 178L390 178L390 178z"
        },
        {
            "title": "Mancherial",
            "d": "M418 195L417 195L416 195L415 195L415 194L415 194L415 194L414 194L413 194L412 194L412 194L412 194L412 194L411 195L411 195L411 195L411 195L411 195L411 195L410 195L410 195L409 195L409 195L408 196L407 196L407 197L407 197L407 197L407 197L407 198L407 198L408 198L408 199L408 199L408 199L408 199L407 200L407 201L407 201L408 201L408 201L408 202L408 202L408 202L407 202L408 202L408 202L408 202L407 202L407 204L409 205L412 207L412 207L412 207L413 206L413 206L413 205L413 205L413 205L414 205L414 204L414 203L414 203L414 203L414 203L415 203L415 202L415 202L415 202L415 202L415 202L415 202L416 201L416 201L417 200L417 200L417 200L417 200L417 199L417 199L417 199L417 199L417 198L417 198L417 198L418 198L418 198L418 197L418 197L418 197L418 197L418 197L418 197L418 196L418 196L418 196L418 196L418 196L419 196L418 195L418 195z"
        },
        {
            "title": "Mandamarri",
            "d": "M425 182L425 183L424 183L424 182L424 182L425 181L424 181L423 180L421 179L419 176L419 176L417 176L416 176L415 177L415 178L415 179L414 179L414 179L414 179L414 180L413 180L413 180L413 181L413 182L413 182L411 180L409 179L406 178L405 180L404 180L403 179L404 180L405 182L407 184L407 185L408 187L408 187L408 188L408 188L407 188L407 189L406 190L406 191L405 193L405 194L405 195L406 195L407 196L407 196L408 196L409 195L409 195L410 195L410 195L411 195L411 195L411 195L411 195L411 195L411 195L412 194L412 194L412 194L412 194L413 194L414 194L415 194L415 194L415 194L415 195L416 195L417 195L418 195L418 194L419 194L420 194L422 195L425 198L426 197L428 196L428 196L428 196L429 196L429 196L429 196L429 196L429 196L429 197L429 197L430 197L432 196L435 193L435 192L435 191L435 190L436 189L435 189L436 189L436 188L436 188L436 188L436 188L435 187L435 187L435 187L435 186L435 185L435 185L435 185L434 186L433 186L434 186L434 187L433 187L433 187L433 187L433 187L433 187L433 187L433 187L432 187L432 188L432 188L432 188L432 188L431 188L431 188L430 188L430 187L430 187L429 185L429 185L428 184L427 184L426 183L425 182z"
        },
        {
            "title": "Naspur",
            "d": "M425 198L422 195L420 194L419 194L418 194L418 195L418 195L419 196L418 196L418 196L418 196L418 196L418 196L418 197L418 197L418 197L418 197L418 197L418 197L418 198L418 198L417 198L417 198L417 198L417 199L417 199L417 199L417 199L417 200L417 200L417 200L417 200L416 201L416 201L415 202L415 202L415 202L415 202L415 202L415 202L415 203L414 203L414 203L414 203L414 203L414 204L414 205L413 205L413 205L413 205L413 206L413 206L412 207L413 208L416 209L417 211L419 212L420 214L421 213L421 212L421 212L421 211L422 210L422 210L422 209L423 208L423 208L422 208L422 207L422 206L424 201L424 200L423 199L423 199L423 199L424 198L424 197L424 198L425 198z"
        },
        {
            "title": "Nennel",
            "d": "M457 170L456 170L456 169L457 168L456 167L455 166L455 166L455 166L454 165L455 165L455 165L455 165L455 164L455 164L455 164L455 164L455 164L456 163L456 163L457 162L457 162L458 162L459 162L459 162L459 161L459 161L459 161L458 161L459 161L459 160L458 160L459 160L458 160L458 159L458 159L458 159L458 159L458 159L458 159L457 158L457 158L457 158L457 159L457 159L456 159L456 159L455 159L455 159L453 158L453 158L452 158L451 157L451 158L451 158L451 158L451 158L451 159L450 159L451 159L451 160L450 160L450 160L450 161L449 161L449 161L449 161L449 161L448 163L447 163L447 163L446 164L446 164L445 164L445 164L444 165L444 165L443 165L443 165L443 165L442 164L442 164L442 163L442 163L442 163L441 162L441 163L441 162L441 163L440 164L440 164L440 164L440 164L439 164L439 164L438 164L438 164L436 163L436 163L435 163L435 163L434 163L434 164L434 164L433 164L434 165L434 166L434 167L434 169L434 170L435 171L436 172L436 172L432 171L432 171L432 172L431 172L431 172L431 172L430 172L430 173L429 174L429 174L429 175L429 177L428 179L425 182L426 183L427 184L428 184L429 185L429 185L430 187L430 187L430 188L431 188L431 188L432 188L432 188L432 188L432 188L432 187L433 187L433 187L433 187L433 187L433 187L433 187L433 187L434 187L434 186L433 186L434 186L435 185L435 185L435 185L435 186L435 187L435 187L435 187L436 188L436 188L436 188L436 188L436 189L435 189L436 189L435 190L435 191L437 190L438 189L439 189L440 189L441 189L442 189L442 189L442 189L442 188L443 188L443 188L443 188L444 188L443 189L443 189L444 189L444 189L444 189L444 189L444 189L445 189L445 189L446 189L447 189L448 189L448 188L450 187L451 187L452 187L454 186L454 186L456 186L457 186L455 184L455 183L453 183L452 182L452 182L452 181L452 181L452 181L453 180L453 180L453 180L454 178L454 178L455 178L455 177L455 177L455 177L456 177L457 177L458 177L457 175L457 175L456 174L454 173L454 173L454 172L456 171L457 170z"
        },
        {
            "title": "Tandur",
            "d": "M429 145L428 144L428 145L428 145L427 145L427 145L427 144L427 145L427 145L426 145L426 145L426 144L426 144L426 144L426 144L425 144L425 144L424 144L424 143L424 143L424 144L423 144L423 144L423 144L423 144L422 144L422 144L422 144L422 144L421 144L421 144L420 144L420 144L420 144L420 144L420 144L420 145L420 145L420 145L421 145L421 146L420 146L420 146L420 146L420 146L420 146L420 146L420 146L419 146L419 146L419 146L419 145L419 145L418 145L418 145L418 145L418 145L418 145L417 145L418 145L417 145L417 146L417 146L418 146L418 146L418 146L418 146L418 146L418 147L418 147L417 148L417 148L417 148L416 147L416 147L415 148L415 148L413 147L411 146L410 145L409 144L407 143L406 143L405 143L404 143L404 143L403 143L402 143L401 142L401 143L400 143L400 143L399 143L399 142L398 142L397 141L397 141L397 141L397 141L395 140L394 140L393 140L393 140L393 141L393 141L392 142L392 143L392 143L393 143L394 143L396 143L395 144L396 144L395 145L395 145L395 145L395 146L395 146L395 147L395 147L395 148L395 148L395 148L396 148L397 148L398 148L398 147L398 147L400 149L401 149L402 150L402 151L403 151L403 152L403 152L403 152L404 154L404 154L403 156L404 156L404 157L406 160L407 161L408 162L408 163L409 163L409 164L410 164L410 164L410 164L410 164L411 165L412 164L408 160L408 158L408 158L409 157L409 156L411 155L411 155L412 156L411 156L413 158L414 158L414 159L414 160L415 160L416 160L416 160L416 161L416 161L416 161L416 161L416 161L417 161L417 161L417 161L417 161L417 161L418 161L419 161L419 161L419 161L419 160L419 160L419 160L418 159L419 159L419 159L419 159L420 158L420 157L420 157L420 156L420 156L421 156L422 156L423 155L423 156L423 158L424 158L428 159L428 159L429 158L429 158L430 156L430 156L431 156L431 156L431 156L431 156L432 156L432 156L432 155L433 155L432 155L431 154L431 154L431 154L431 153L432 153L432 152L432 152L431 152L431 152L431 152L431 151L431 151L431 151L431 151L431 151L431 151L432 150L432 150L432 150L431 149L431 149L431 149L431 149L431 149L431 149L431 148L430 148L429 147L429 147L429 146L429 146L429 146L429 146L429 146L429 146L429 145L429 145L429 145L429 145z"
        },
        {
            "title": "Vemanpalle",
            "d": "M484 173L483 173L482 173L482 172L481 172L480 168L480 166L480 163L480 161L480 161L480 159L481 159L482 158L490 154L492 153L491 151L490 151L490 151L489 151L488 152L487 151L487 151L486 151L486 152L485 151L484 151L484 151L483 150L482 149L480 149L479 150L479 151L476 150L476 150L476 151L476 151L476 152L475 152L474 152L473 152L471 154L469 155L466 154L466 154L465 154L465 153L465 153L465 152L465 151L463 151L463 152L463 153L462 152L462 152L461 153L460 152L460 152L459 152L458 152L457 153L457 154L457 155L457 155L457 156L456 156L456 155L456 155L456 155L455 155L455 155L454 155L454 155L454 155L454 156L454 157L453 158L453 158L455 159L455 159L456 159L456 159L457 159L457 159L457 158L457 158L457 158L458 159L458 159L458 159L458 159L458 159L458 159L458 160L459 160L458 160L459 160L459 161L458 161L459 161L459 161L459 161L459 162L459 162L458 162L457 162L457 162L456 163L456 163L455 164L455 164L455 164L455 164L455 164L455 165L455 165L455 165L454 165L455 166L455 166L455 166L456 167L457 168L456 169L456 170L457 170L457 171L458 171L459 171L459 171L459 170L460 170L461 170L461 170L461 170L462 170L463 170L467 170L467 170L467 170L468 170L468 169L468 169L468 170L468 170L468 170L467 171L467 171L467 171L467 172L467 172L467 172L467 172L467 172L468 173L468 173L468 174L468 174L468 174L468 174L468 175L468 175L468 175L469 176L470 177L470 177L473 176L473 176L473 176L473 176L474 177L474 177L474 177L474 179L475 180L475 180L475 181L475 181L476 181L477 180L477 180L478 180L479 180L479 180L480 180L480 179L480 179L481 180L481 179L481 179L482 178L482 177L482 176L483 174L483 174L483 174L484 173z"
        },
        {
            "title": "Kotapalle",
            "d": "M489 210L489 208L490 208L491 207L492 207L494 206L495 205L495 204L496 204L496 203L497 202L496 201L496 199L495 197L496 194L496 193L496 191L496 190L496 188L494 185L494 181L493 180L493 177L493 175L493 174L493 173L493 172L492 172L492 172L491 171L491 171L490 171L489 171L488 172L487 172L486 172L484 173L483 174L483 174L483 174L482 176L482 177L482 178L481 179L481 179L481 180L480 179L480 179L480 180L479 180L479 180L478 180L477 180L477 180L476 181L475 181L475 181L475 180L475 180L474 179L474 177L474 177L474 177L473 176L473 176L473 176L473 176L470 177L470 177L469 176L468 175L468 175L468 175L468 174L468 174L468 174L468 174L468 173L468 173L467 172L467 172L467 172L467 172L467 172L467 171L467 171L467 171L468 170L468 170L468 170L468 169L468 169L468 170L467 170L467 170L467 170L463 170L462 170L461 170L461 170L461 170L460 170L459 170L459 171L459 171L458 171L457 171L457 170L456 171L454 172L454 173L454 173L456 174L457 175L457 175L458 177L457 177L456 177L455 177L455 177L455 177L455 178L454 178L454 178L453 180L453 180L453 180L452 181L452 181L452 181L452 182L452 182L453 183L455 183L455 184L457 186L460 188L461 188L462 189L462 190L462 190L464 191L465 193L466 194L466 195L466 195L468 195L468 195L469 194L471 194L472 195L473 196L473 196L474 197L476 197L475 199L476 199L476 199L476 200L476 200L476 200L476 201L477 201L477 201L477 201L477 202L478 202L478 202L479 203L479 203L480 204L480 206L481 208L481 208L482 209L483 209L484 209L485 209L487 209L487 209L488 209L488 210L489 210z"
        }
    ],
    "Jayashankar Bhupalpally": [
        {
            "title": "Bhupalpally",
            "d": "M487 262L487 262L486 262L485 262L484 263L483 263L482 265L482 266L483 266L483 267L484 268L484 268L486 270L486 271L486 271L486 271L487 271L487 271L487 271L487 271L487 272L487 272L487 272L488 272L488 272L488 273L488 272L488 272L488 272L489 273L489 274L489 275L489 277L489 277L489 278L488 279L487 278L485 277L484 277L484 277L484 276L484 275L483 268L481 269L477 271L477 271L477 271L476 271L476 270L475 270L475 270L474 270L474 270L473 270L473 270L472 271L471 270L471 270L471 270L470 271L470 271L470 272L470 272L470 272L471 273L471 274L471 274L472 276L472 276L472 276L472 277L473 278L473 278L473 278L473 278L473 278L472 280L472 281L471 281L471 281L471 280L471 280L471 279L471 280L471 280L470 280L470 278L469 278L469 278L468 277L468 277L466 277L465 277L464 275L463 273L463 273L459 274L457 276L457 276L459 277L459 277L459 279L460 279L460 280L460 280L460 280L460 280L461 281L461 281L461 281L462 282L463 282L463 282L464 282L464 283L464 283L464 283L464 283L465 283L465 283L465 283L465 284L465 284L466 284L466 284L466 284L466 284L466 284L468 285L468 285L468 285L468 286L468 286L468 286L467 287L467 288L466 289L464 291L464 292L464 293L465 294L466 294L466 295L467 295L469 295L472 294L472 294L472 294L472 294L472 294L472 294L473 293L473 292L475 290L474 290L474 289L474 289L473 289L473 289L473 288L473 288L473 288L472 287L472 287L472 287L471 287L471 287L471 287L471 287L472 285L473 284L474 284L475 284L475 284L475 284L476 284L477 284L479 284L479 284L479 283L480 281L482 280L482 280L483 280L484 280L484 280L485 281L485 281L484 282L484 283L485 284L485 286L485 286L485 287L486 287L487 287L487 287L487 287L487 288L488 289L489 291L490 291L490 292L493 292L493 291L494 290L494 290L494 289L494 289L496 288L497 287L497 286L497 285L497 285L501 285L502 285L505 284L506 283L506 283L507 283L509 283L510 283L511 283L511 283L512 284L513 284L515 285L516 285L518 284L519 284L519 284L519 284L519 284L520 285L521 286L521 287L521 287L524 286L525 284L526 282L527 282L527 282L527 281L527 281L527 281L527 280L527 280L527 280L527 280L527 279L527 279L526 279L526 279L525 278L524 277L522 276L520 278L519 278L517 278L516 279L515 281L515 284L515 284L514 284L513 283L512 282L510 282L508 282L507 282L507 281L507 280L507 278L508 276L508 277L508 277L509 278L511 278L513 278L514 278L515 278L516 277L517 276L519 274L520 273L521 273L521 273L521 272L521 272L518 271L517 271L517 271L517 271L516 271L516 271L516 270L516 270L515 270L514 270L512 269L511 269L511 269L512 268L512 269L512 269L513 268L513 268L513 268L513 268L513 267L513 267L514 267L514 266L514 266L514 266L514 266L514 265L515 265L515 265L515 264L515 264L516 264L516 264L516 264L516 263L517 262L514 263L513 263L511 263L509 263L509 264L508 266L508 267L507 267L506 267L503 267L500 269L499 269L498 269L498 269L498 268L497 268L496 269L496 268L495 267L495 267L495 267L495 266L494 265L494 265L491 264L490 263L488 263L487 262z"
        },
        {
            "title": "Chityal",
            "d": "M463 273L462 273L461 272L457 269L450 267L449 267L448 268L448 269L446 269L445 269L445 271L445 272L444 272L444 273L444 273L444 273L444 273L444 273L445 274L445 274L445 274L445 274L445 274L446 274L446 274L446 274L447 275L450 276L449 277L448 277L447 279L447 279L447 280L447 280L447 281L448 282L447 283L447 283L446 284L447 284L447 284L447 285L447 286L447 286L447 287L447 287L447 287L447 287L446 287L446 287L445 288L444 288L445 288L446 288L446 288L445 289L445 290L445 290L445 290L444 290L444 290L444 291L443 291L443 291L443 291L443 292L443 292L444 292L444 293L445 294L445 294L446 294L445 295L445 295L446 295L446 295L446 295L447 296L447 296L447 296L447 296L448 297L448 297L447 298L447 298L448 298L448 298L448 298L449 299L449 300L449 300L450 301L452 303L452 302L452 302L452 302L453 302L454 302L454 302L455 301L455 301L455 301L455 301L456 301L456 301L456 301L456 301L457 301L457 301L457 301L457 301L459 301L459 300L459 300L459 300L459 300L460 299L459 299L460 298L460 298L460 298L460 297L461 295L460 295L461 294L462 294L462 293L465 294L464 293L464 292L464 291L466 289L467 288L467 287L468 286L468 286L468 286L468 285L468 285L468 285L466 284L466 284L466 284L466 284L466 284L465 284L465 284L465 283L465 283L465 283L464 283L464 283L464 283L464 283L464 282L463 282L463 282L462 282L461 281L461 281L461 281L460 280L460 280L460 280L460 280L460 279L459 279L459 277L459 277L457 276L457 276L459 274L463 273z"
        },
        {
            "title": "Ghanapur_Mulug",
            "d": "M493 292L490 292L490 291L489 291L488 289L487 288L487 287L487 287L487 287L486 287L485 287L485 286L485 286L485 284L484 283L484 282L485 281L485 281L484 280L484 280L483 280L482 280L482 280L480 281L479 283L479 284L479 284L477 284L476 284L475 284L475 284L475 284L474 284L473 284L472 285L471 287L471 287L471 287L471 287L472 287L472 287L472 287L473 288L473 288L473 288L473 289L473 289L474 289L474 289L474 290L475 290L473 292L473 293L472 294L472 294L472 294L472 294L472 294L470 298L471 299L472 299L472 301L473 301L473 301L474 301L475 301L476 300L476 301L476 301L476 301L476 301L476 301L476 303L476 304L476 305L476 305L477 305L477 305L478 306L479 306L479 306L480 306L480 306L480 306L480 306L480 306L480 306L480 306L480 306L480 306L480 305L481 304L481 304L481 303L482 303L482 303L482 303L482 303L483 302L483 303L483 303L484 302L484 302L483 302L483 302L483 302L483 301L483 301L483 300L483 300L483 300L483 300L484 299L485 299L484 298L485 298L485 298L485 297L486 298L486 298L486 298L487 298L487 299L488 298L488 299L488 299L488 298L488 298L489 298L489 299L489 299L490 299L490 299L491 299L492 299L492 299L492 299L492 299L492 299L492 299L492 299L492 299L493 298L493 297L493 297L494 294L494 294L494 294L494 293L494 293L494 292L494 292L494 292L494 292L494 292L493 292z"
        },
        {
            "title": "Kataram",
            "d": "M506 243L508 240L506 240L506 240L503 240L503 240L502 238L501 237L501 236L500 236L500 236L500 234L501 234L500 234L500 233L500 233L499 232L499 233L496 232L494 232L492 233L491 234L491 234L491 233L490 233L490 232L491 232L491 228L490 227L489 225L489 224L488 224L487 223L486 223L485 224L484 224L484 226L484 228L481 226L478 224L476 221L474 222L474 223L475 224L474 224L473 224L473 226L473 227L473 228L473 228L472 229L472 230L473 232L473 233L474 234L474 235L475 236L475 237L475 238L475 239L474 240L474 241L474 241L474 241L475 241L475 241L476 241L476 241L477 242L478 242L478 242L479 242L479 244L479 245L479 245L479 246L479 246L479 247L480 247L480 247L481 248L483 250L483 250L483 250L484 248L485 248L486 249L488 249L488 249L488 249L488 250L489 250L488 251L488 251L488 251L488 251L488 251L488 251L488 252L489 254L489 255L489 255L490 256L489 258L488 260L487 262L488 263L490 263L491 264L492 260L494 256L495 253L495 253L495 253L496 253L495 253L495 253L496 252L496 252L496 252L497 252L497 252L497 252L498 252L498 252L499 252L499 252L499 252L499 251L500 251L500 251L500 251L500 251L500 250L500 250L500 250L500 250L500 250L500 250L501 250L502 250L502 250L503 249L503 249L503 248L503 248L503 248L504 247L504 247L505 244L506 243z"
        },
        {
            "title": "Mahadevpur",
            "d": "M489 210L488 210L488 209L487 209L487 209L485 209L484 209L483 209L482 209L481 208L481 208L480 206L480 204L479 203L479 203L478 202L478 202L477 202L477 202L476 202L476 202L475 203L475 203L474 205L474 207L474 208L475 209L475 210L476 212L478 214L478 215L478 215L477 216L477 217L476 217L475 218L474 220L473 221L473 222L473 222L473 224L474 224L475 224L474 223L474 222L476 221L478 224L481 226L484 228L484 226L484 224L485 224L486 223L487 223L488 224L489 224L489 225L490 227L491 228L491 232L490 232L490 233L491 233L491 234L491 234L492 233L494 232L496 232L499 233L499 232L500 233L500 233L500 234L501 234L500 234L500 236L500 236L501 236L501 237L502 238L503 240L503 240L506 240L506 240L508 240L506 243L507 243L507 243L510 242L512 243L519 237L521 236L521 235L521 235L521 235L520 234L519 233L519 232L519 232L518 231L517 230L516 230L515 230L515 229L514 229L514 228L513 227L513 227L512 227L512 227L511 227L511 226L510 226L509 224L509 224L509 223L509 222L509 222L508 222L507 222L507 222L507 221L507 221L505 220L504 219L502 220L501 219L501 219L498 219L497 219L496 218L495 217L495 216L493 215L491 214L490 212L489 210L489 210z"
        },
        {
            "title": "Malharrao",
            "d": "M487 262L488 260L489 258L490 256L489 255L489 255L489 254L488 252L488 251L488 251L488 251L488 251L488 251L488 251L489 250L488 250L488 249L488 249L488 249L486 249L485 248L484 248L483 250L483 250L483 250L481 248L480 247L480 247L479 247L479 246L479 246L479 245L479 245L479 244L479 242L478 242L478 242L477 242L476 241L476 241L475 241L475 241L474 241L474 241L474 241L474 240L472 243L471 244L470 247L468 251L468 252L468 253L468 253L467 254L465 254L460 253L459 253L458 253L457 254L456 255L455 256L455 257L454 261L454 262L453 263L452 264L452 264L451 266L450 267L457 269L461 272L462 273L463 273L463 273L464 275L465 277L466 277L468 277L468 277L469 278L469 278L470 278L470 280L471 280L471 280L471 279L471 280L471 280L471 281L471 281L472 281L472 280L473 278L473 278L473 278L473 278L473 278L472 277L472 276L472 276L472 276L471 274L471 274L471 273L470 272L470 272L470 272L470 271L470 271L471 270L471 270L471 270L472 271L473 270L473 270L474 270L474 270L475 270L475 270L476 270L476 271L477 271L477 271L477 271L481 269L483 268L484 275L484 276L484 277L484 277L485 277L487 278L488 279L489 278L489 277L489 277L489 275L489 274L489 273L488 272L488 272L488 272L488 273L488 272L488 272L487 272L487 272L487 272L487 271L487 271L487 271L487 271L486 271L486 271L486 271L486 270L484 268L484 268L483 267L483 266L482 266L482 265L483 263L484 263L485 262L486 262L487 262L487 262z"
        },
        {
            "title": "Mogullapally",
            "d": "M443 291L442 290L441 289L441 288L440 288L440 288L439 288L439 288L439 288L438 288L438 288L438 288L437 288L437 288L437 287L437 287L437 287L437 287L437 287L437 287L436 287L436 287L435 288L435 288L434 288L434 288L434 288L434 288L434 289L433 289L433 289L433 289L433 289L432 289L432 290L433 290L432 290L433 290L433 291L433 292L432 293L432 294L432 294L432 294L432 295L432 296L432 296L432 297L432 297L432 298L431 298L431 298L431 298L430 298L430 300L430 300L430 301L430 301L430 302L430 302L430 302L430 302L431 302L431 302L431 303L431 304L430 306L431 306L431 306L431 306L431 306L433 307L434 307L434 307L434 306L434 306L434 306L435 306L435 306L435 306L435 306L435 306L436 306L436 306L436 306L436 306L437 306L438 306L438 306L438 306L439 306L439 306L439 306L439 305L439 305L440 305L441 304L441 304L442 305L442 305L442 305L443 305L443 305L443 305L443 306L443 306L443 306L443 306L443 306L444 307L444 307L444 307L444 307L445 307L445 307L445 307L445 308L445 308L446 308L446 308L447 308L447 307L447 307L448 307L448 307L448 307L449 307L449 306L449 306L450 306L450 306L450 306L450 306L450 305L451 305L450 305L451 305L451 305L452 303L452 303L452 303L451 303L452 303L450 301L449 300L449 300L449 299L448 298L448 298L448 298L447 298L447 298L448 297L448 297L447 296L447 296L447 296L447 296L446 295L446 295L446 295L445 295L445 295L446 294L445 294L445 294L444 293L444 292L443 292L443 292L443 291L443 291z"
        },
        {
            "title": "MahaMutharam",
            "d": "M519 237L512 243L510 242L507 243L507 243L506 243L505 244L504 247L504 247L503 248L503 248L503 248L503 249L503 249L502 250L502 250L501 250L500 250L500 250L500 250L500 250L500 250L500 250L500 251L500 251L500 251L500 251L499 251L499 252L499 252L499 252L498 252L498 252L497 252L497 252L497 252L496 252L496 252L496 252L495 253L495 253L496 253L495 253L495 253L495 253L494 256L492 260L491 264L494 265L494 265L495 266L495 267L495 267L495 267L496 268L496 269L497 268L498 268L498 269L498 269L499 269L500 269L503 267L506 267L507 267L508 267L508 266L509 264L509 263L511 263L513 263L514 263L517 262L516 263L516 264L516 264L516 264L515 264L515 264L515 265L515 265L514 265L514 266L514 266L514 266L514 266L514 267L513 267L513 267L513 268L513 268L513 268L513 268L512 269L512 269L512 268L511 269L511 269L512 269L514 270L515 270L516 270L516 270L516 271L516 271L517 271L517 271L517 271L518 271L521 272L521 272L521 273L521 273L520 273L519 274L517 276L516 277L515 278L514 278L513 278L511 278L509 278L508 277L508 277L508 276L507 278L507 280L507 281L507 282L508 282L510 282L512 282L513 283L514 284L515 284L515 284L515 281L516 279L517 278L519 278L520 278L522 276L524 277L525 278L526 279L526 279L527 279L527 279L527 280L527 280L527 280L527 280L527 281L527 281L527 281L527 282L527 282L526 282L525 284L524 286L524 286L524 287L524 287L524 288L525 288L525 287L525 287L526 288L526 289L526 289L526 289L527 289L527 289L527 289L528 290L528 289L528 290L529 290L528 291L529 291L529 291L529 291L529 291L531 292L538 285L538 284L538 282L539 280L539 278L539 274L539 271L542 265L541 262L540 257L541 256L543 254L547 251L537 247L536 248L533 248L533 249L531 249L527 246L525 241L523 237L520 237L519 237z"
        },
        {
            "title": "Palimela",
            "d": "M559 249L559 249L557 246L557 245L556 242L556 241L555 239L554 239L554 237L553 236L553 235L552 233L550 230L549 229L549 228L548 228L548 228L547 228L547 228L546 228L546 229L544 230L544 230L543 230L543 230L542 230L542 230L541 231L540 231L540 231L540 230L539 230L538 230L537 230L537 231L537 231L535 233L535 233L535 234L535 234L535 235L534 235L532 234L532 234L531 233L530 232L530 231L530 231L529 231L528 231L528 231L528 232L527 232L526 233L526 232L525 233L524 233L524 233L523 234L523 234L523 235L522 235L521 235L521 234L520 234L521 235L521 235L521 235L521 236L519 237L520 237L523 237L525 241L527 246L531 249L533 249L533 248L536 248L537 247L547 251L549 251L553 250L557 250L557 250L557 250L557 250L558 250L558 250L558 250L558 250L559 249z"
        },
        {
            "title": "Regonda",
            "d": "M479 317L479 317L479 316L479 316L479 313L479 313L478 312L478 310L478 309L478 308L478 309L478 308L478 308L478 309L478 309L478 309L478 309L479 308L479 307L479 307L479 307L479 307L480 307L480 307L480 306L479 306L479 306L478 306L477 305L477 305L476 305L476 305L476 304L476 303L476 301L476 301L476 301L476 301L476 301L476 300L475 301L474 301L473 301L473 301L472 301L472 299L471 299L470 298L472 294L472 294L469 295L467 295L466 295L466 294L465 294L462 293L462 294L461 294L460 295L461 295L460 297L460 298L460 298L460 298L459 299L460 299L459 300L459 300L459 300L459 300L459 301L457 301L457 301L457 301L457 301L456 301L456 301L456 301L456 301L455 301L455 301L455 301L455 301L454 302L454 302L453 302L452 302L452 302L452 302L452 303L451 303L452 303L452 303L452 304L453 304L453 304L453 305L453 306L453 307L452 307L452 307L452 307L452 308L452 308L452 308L452 308L452 308L452 308L452 309L452 309L453 309L453 310L454 310L454 310L454 310L454 310L455 310L455 310L455 310L455 311L455 311L456 311L456 311L456 311L456 310L456 310L457 310L457 309L457 309L457 309L458 309L458 309L458 309L458 309L458 309L458 309L458 309L459 309L460 309L460 308L460 308L461 309L461 309L461 309L462 309L462 309L462 310L462 311L462 311L462 311L463 311L463 311L463 311L463 312L464 312L465 313L465 313L465 313L465 313L465 313L465 313L465 313L466 313L466 313L466 313L467 313L468 313L469 313L471 313L471 313L473 313L473 314L473 314L474 315L477 316L478 315L478 316L479 317z"
        },
        {
            "title": "Tekumatla",
            "d": "M445 269L444 270L443 269L442 269L441 268L441 268L441 269L441 269L441 269L440 270L439 270L438 270L438 271L438 271L437 270L436 270L436 270L436 270L435 270L435 271L435 271L435 272L435 272L435 273L435 273L435 274L434 275L434 275L434 275L434 275L433 277L432 277L432 277L432 278L432 278L431 278L432 279L431 279L432 279L431 279L431 279L431 279L432 280L432 279L432 279L432 280L432 280L433 280L433 280L433 280L433 280L433 280L433 281L433 281L433 282L433 282L433 282L433 282L433 282L433 283L432 284L432 284L432 284L433 284L433 284L433 284L433 285L432 287L432 287L432 287L432 288L432 288L432 288L432 288L433 288L432 289L432 289L432 289L432 289L433 289L433 289L433 289L433 289L434 289L434 288L434 288L434 288L434 288L435 288L435 288L436 287L436 287L437 287L437 287L437 287L437 287L437 287L437 287L437 288L437 288L438 288L438 288L438 288L439 288L439 288L439 288L440 288L440 288L441 288L441 289L442 290L443 291L443 291L444 291L444 290L444 290L445 290L445 290L445 290L445 289L446 288L446 288L445 288L444 288L445 288L446 287L446 287L447 287L447 287L447 287L447 287L447 286L447 286L447 285L447 284L447 284L446 284L447 283L447 283L448 282L447 281L447 280L447 280L447 279L447 279L448 277L449 277L450 276L447 275L446 274L446 274L446 274L445 274L445 274L445 274L445 274L445 274L444 273L444 273L444 273L444 273L444 273L444 272L445 272L445 271L445 269z"
        },
        {
            "title": "Kothapallygori",
            "d": "M479 317L478 316L478 315L477 316L474 315L473 314L473 314L473 313L471 313L471 313L469 313L468 313L467 313L466 313L466 313L466 313L465 313L465 313L465 313L465 313L465 313L465 313L465 313L464 312L463 312L463 311L463 311L463 311L462 311L462 311L462 311L462 310L462 309L462 309L461 309L461 309L461 309L460 308L460 308L460 309L459 309L458 309L458 309L458 309L458 309L458 309L458 309L458 309L457 309L457 309L457 309L457 310L456 310L456 310L456 311L456 311L456 311L455 311L455 311L455 312L455 312L455 313L455 314L456 314L456 314L457 314L456 315L457 315L457 315L457 316L457 316L457 316L457 316L457 316L457 316L458 316L458 316L458 316L458 317L458 317L458 317L458 317L458 317L457 318L457 317L457 317L457 318L456 318L456 318L457 318L457 318L458 318L458 319L458 319L458 319L458 319L458 319L459 320L460 320L460 321L460 321L460 321L461 321L461 321L461 321L461 321L461 321L461 321L462 321L463 321L464 321L465 321L467 321L468 321L468 321L468 322L468 322L468 322L468 323L469 323L469 323L469 324L471 325L475 324L476 324L477 322L475 319L478 318L479 317z"
        }
    ],
    "Rajanna Sircilla": [
        {
            "title": "Boinpalli",
            "d": "M331 251L332 251L331 251L331 250L331 250L331 250L330 250L328 250L328 250L328 250L328 250L328 251L328 251L328 251L328 251L327 252L326 253L326 252L324 251L324 252L324 252L324 252L323 253L323 253L323 253L323 253L323 253L322 253L322 253L322 254L322 254L322 255L322 255L322 255L321 255L321 255L321 255L321 256L321 257L321 257L321 258L320 258L320 258L321 259L321 259L321 259L321 259L322 260L322 261L321 261L321 261L321 261L321 262L321 263L321 264L321 265L321 265L320 265L320 265L320 265L320 265L320 265L320 267L320 267L320 267L321 267L320 267L320 268L320 268L320 268L321 268L322 268L323 269L323 269L324 269L323 269L323 270L323 271L323 271L323 272L323 272L323 272L324 273L323 273L324 274L324 274L323 275L323 275L323 275L323 275L324 277L324 278L324 279L324 279L324 281L324 281L325 281L327 281L328 282L330 282L332 283L332 283L333 283L335 282L337 282L337 281L337 280L336 280L336 280L336 279L336 278L336 278L336 278L335 278L335 278L334 278L334 278L334 277L333 277L333 276L333 276L333 276L333 276L334 276L334 276L334 275L334 275L334 275L334 275L334 275L334 274L334 275L334 274L336 274L336 274L336 274L337 274L337 274L336 274L336 273L336 272L336 272L336 272L336 272L336 271L336 270L336 270L336 269L335 269L335 268L335 268L335 268L335 267L335 267L335 266L335 265L335 265L335 265L333 264L333 263L332 262L331 262L331 262L331 262L330 262L330 261L330 260L331 260L331 259L332 258L331 258L331 258L331 257L331 257L331 257L331 257L331 257L331 256L330 255L330 255L330 255L330 254L330 253L331 252L331 252L331 251L331 251z"
        },
        {
            "title": "Chendurthi",
            "d": "M303 242L299 241L298 241L299 242L297 241L295 241L295 241L294 241L294 241L294 242L294 245L292 247L292 248L286 248L282 248L280 248L279 249L279 249L278 249L277 249L276 248L274 248L276 250L277 251L279 252L282 252L286 255L287 257L287 257L287 257L287 256L289 256L290 256L290 257L291 259L291 259L293 260L293 260L293 260L293 260L294 261L294 261L294 261L295 261L295 261L295 261L295 261L296 261L296 261L298 261L298 262L300 262L300 262L301 263L301 263L301 263L301 263L301 263L302 263L302 263L302 262L303 262L303 262L303 262L303 262L304 263L304 262L304 262L304 261L304 261L303 260L303 260L303 260L303 260L303 259L303 259L302 258L303 257L303 257L303 258L303 258L304 259L304 259L305 259L305 260L306 260L306 260L306 260L306 260L307 260L307 261L307 261L307 261L308 261L308 261L308 261L308 260L308 259L308 258L308 257L309 257L309 256L310 255L310 255L310 254L310 254L310 254L311 254L310 253L310 253L310 253L310 253L310 252L310 251L310 251L310 250L310 250L313 247L313 247L309 245L307 245L307 245L303 242z"
        },
        {
            "title": "Gambhiraopet",
            "d": "M279 295L279 295L279 295L279 295L279 295L279 295L279 295L279 295L279 295L279 294L279 294L279 294L279 294L279 293L279 293L278 293L278 293L277 294L276 294L276 293L275 293L275 293L275 293L275 293L275 292L275 292L275 292L274 291L274 291L274 291L274 291L274 291L274 290L274 290L273 289L272 289L272 289L272 289L272 288L272 288L272 288L272 288L272 288L272 287L272 287L272 287L272 287L273 287L273 287L273 285L273 285L273 285L273 284L273 284L273 284L273 284L273 283L272 282L272 282L271 282L271 281L270 281L266 279L265 277L264 276L264 276L264 276L262 277L262 278L262 278L263 279L264 280L264 280L266 282L266 282L266 283L265 283L265 283L265 283L264 283L264 283L263 283L261 282L261 283L260 284L260 286L262 287L262 288L263 288L263 289L263 290L263 290L264 292L263 293L262 293L262 293L262 295L262 296L262 296L261 296L262 298L261 299L261 299L260 299L260 299L260 299L259 299L259 300L259 300L259 300L259 300L259 301L259 301L259 301L259 301L259 301L259 301L259 301L259 301L259 302L260 302L260 303L261 302L261 303L261 303L262 302L262 302L262 302L262 302L263 303L263 303L263 303L265 304L265 305L266 306L266 306L265 306L264 306L264 306L264 306L265 309L265 309L265 310L265 310L266 310L266 311L266 311L267 311L267 311L268 311L268 310L268 310L270 307L270 307L271 307L271 307L272 307L273 307L274 307L275 307L276 307L276 307L277 306L278 306L278 305L278 304L278 304L278 304L278 303L277 303L276 302L277 299L277 298L277 298L277 298L277 297L278 296L278 296L278 296L278 296L278 296L278 296L278 295L279 295L279 295L279 295L279 295z"
        },
        {
            "title": "Illanthakunta",
            "d": "M341 281L338 281L337 282L335 282L333 283L332 283L332 283L330 282L328 282L327 284L326 285L326 286L325 287L325 287L324 288L323 287L321 288L321 288L320 288L320 288L320 288L320 288L319 288L318 285L318 285L318 285L317 287L317 288L316 293L316 294L316 294L317 295L317 295L317 296L316 296L314 298L315 298L315 298L315 298L315 299L316 299L316 300L316 300L316 300L316 301L316 301L315 302L314 302L313 301L312 302L312 302L311 302L311 303L311 303L311 303L311 304L310 304L310 304L309 304L309 304L309 304L309 304L308 305L308 306L308 306L308 306L309 307L309 307L309 307L310 307L310 307L310 307L312 308L313 308L313 309L314 310L316 309L316 308L317 309L318 308L319 309L320 308L320 308L321 307L322 307L322 307L323 307L323 306L324 306L324 306L324 306L325 306L325 306L326 306L326 306L327 306L327 307L328 307L328 307L328 306L328 307L328 306L329 306L329 306L329 307L329 307L329 306L330 307L330 307L331 307L332 307L332 307L332 307L332 307L332 307L333 307L334 307L334 306L335 306L335 306L336 305L335 305L335 304L335 303L335 303L336 301L336 301L335 301L335 300L335 300L336 300L336 299L336 299L336 298L338 298L338 297L339 297L340 297L341 295L341 294L341 294L341 294L341 294L341 294L340 293L340 293L340 293L339 293L339 292L340 291L340 290L340 289L341 288L342 287L342 287L341 286L341 286L340 285L340 285L339 285L339 285L339 285L339 284L339 284L339 284L339 283L340 283L341 282L341 281z"
        },
        {
            "title": "Konaraopet",
            "d": "M301 263L300 262L300 262L298 262L298 261L296 261L296 261L295 261L295 261L295 261L295 261L294 261L294 261L294 261L293 260L293 260L293 260L293 260L291 259L291 259L290 257L290 256L289 256L287 256L287 257L287 257L287 257L286 255L282 252L279 252L277 251L276 250L274 248L274 248L274 249L272 255L272 255L272 256L273 256L273 256L274 257L274 257L275 257L277 258L275 261L276 263L278 265L280 265L280 265L282 269L282 270L282 270L285 273L285 273L287 272L288 272L290 274L290 274L290 274L291 275L292 277L292 277L293 277L295 278L295 278L296 277L296 278L298 278L299 278L299 278L300 279L303 280L303 280L303 280L303 280L303 280L304 279L304 278L304 278L304 277L305 276L305 276L306 276L306 275L307 275L307 275L307 274L307 274L308 273L308 272L307 272L307 272L306 272L307 271L307 271L307 270L307 270L307 269L307 269L307 269L307 269L308 268L307 267L307 267L306 267L306 267L306 267L305 267L305 267L305 267L305 267L304 267L304 267L304 267L304 267L304 268L303 268L302 267L302 267L302 267L302 266L301 266L301 266L301 265L301 265L301 265L301 264L301 264L301 264L301 264L301 263L301 263L301 263z"
        },
        {
            "title": "Mustabad",
            "d": "M295 289L294 289L293 288L291 288L290 288L290 288L288 288L286 288L286 288L285 288L284 289L282 290L282 290L282 290L282 291L282 291L282 290L282 290L283 291L283 291L283 291L283 291L283 291L283 291L283 292L283 292L283 293L284 293L283 294L283 295L282 295L281 295L280 295L279 295L279 295L279 295L279 295L278 295L278 296L278 296L278 296L278 296L278 296L278 296L277 297L277 298L277 298L277 298L277 299L276 302L277 303L278 303L278 304L278 304L278 304L278 305L278 306L278 306L279 306L279 306L280 306L280 307L280 307L281 307L282 308L283 308L283 308L283 308L283 308L284 309L284 308L284 308L284 309L284 309L284 309L285 310L287 310L287 310L288 310L288 310L288 310L289 309L290 310L291 309L291 310L291 310L292 310L292 311L292 311L293 312L293 312L292 312L292 312L292 312L292 313L292 313L292 313L294 313L294 313L295 313L296 312L297 310L297 310L298 310L298 309L298 308L298 307L299 306L299 305L299 305L299 305L299 304L299 304L299 303L299 302L299 302L299 302L299 302L299 301L299 301L299 301L299 301L299 301L299 301L299 300L299 300L299 300L299 300L300 299L299 298L299 298L299 297L299 298L299 297L299 297L299 297L298 297L298 297L298 296L298 296L298 296L297 295L297 295L294 293L294 293L293 293L293 292L293 292L293 291L293 291L293 291L293 291L293 290L294 290L294 290L294 290L295 290L295 289L295 289L295 289L295 289L295 289L295 289L295 289z"
        },
        {
            "title": "Rudrangi",
            "d": "M294 241L292 241L291 240L291 240L291 240L290 240L290 239L290 239L289 239L288 239L288 239L288 240L288 240L288 240L287 241L287 241L286 240L282 241L282 241L281 240L281 240L280 238L280 237L279 234L279 234L279 234L279 234L278 234L278 234L278 233L278 232L278 231L278 231L278 231L276 231L270 232L272 235L272 237L271 238L271 237L270 237L269 240L271 243L273 246L273 246L276 248L277 249L278 249L279 249L279 249L280 248L282 248L286 248L292 248L292 247L294 245L294 242L294 241z"
        },
        {
            "title": "Sircilla",
            "d": "M312 279L311 278L310 277L309 277L309 277L308 277L308 277L307 277L307 276L307 276L307 276L307 276L307 275L306 275L306 276L305 276L305 276L304 277L304 278L304 278L304 279L303 280L303 280L303 280L303 280L303 280L300 279L299 278L299 278L298 278L296 278L296 277L295 278L295 279L295 281L296 281L298 282L297 284L296 288L296 289L298 289L299 289L299 289L300 288L304 286L305 285L308 285L308 285L310 283L311 282L313 280L313 280L312 279L312 279z"
        },
        {
            "title": "Thangallapalli",
            "d": "M324 281L323 281L322 280L320 280L319 280L318 279L316 279L316 279L315 279L313 280L311 282L310 283L308 285L308 285L305 285L304 286L300 288L299 289L299 289L298 289L296 289L295 289L295 289L295 289L295 289L295 289L295 289L295 289L295 290L294 290L294 290L294 290L293 290L293 291L293 291L293 291L293 291L293 292L293 292L293 293L294 293L294 293L297 295L297 295L298 296L298 296L298 296L298 297L298 297L299 297L299 297L299 297L299 298L299 297L299 298L299 298L300 299L299 300L299 300L299 300L299 300L299 301L299 301L299 301L299 301L299 301L299 301L299 302L299 302L299 302L299 302L299 303L299 304L299 304L299 305L299 305L299 305L300 305L300 305L301 305L301 306L302 306L303 306L303 306L303 306L303 306L303 306L304 306L304 306L304 306L304 306L304 306L305 306L306 306L306 306L307 307L307 306L308 307L308 307L308 306L308 306L308 306L308 305L309 304L309 304L309 304L309 304L310 304L310 304L311 304L311 303L311 303L311 303L311 302L312 302L312 302L313 301L314 302L315 302L316 301L316 301L316 300L316 300L316 300L316 299L315 299L315 298L315 298L315 298L314 298L316 296L317 296L317 295L317 295L316 294L316 294L316 293L317 288L317 287L318 285L318 285L318 285L319 288L320 288L320 288L320 288L320 288L321 288L321 288L323 287L324 288L325 287L325 287L326 286L326 285L327 284L328 282L327 281L325 281L324 281L324 281z"
        },
        {
            "title": "Veernapalli",
            "d": "M272 255L272 255L271 255L268 255L268 255L267 256L267 256L266 257L265 258L265 261L262 264L261 268L260 268L260 269L261 270L262 272L263 274L263 275L264 274L269 273L269 273L269 273L274 273L274 272L275 271L275 272L277 272L281 272L281 271L282 270L282 270L282 269L280 265L280 265L278 265L276 263L275 261L277 258L275 257L274 257L274 257L273 256L273 256L272 256L272 255L272 255z"
        },
        {
            "title": "Vemulawada",
            "d": "M320 258L320 258L320 257L320 257L320 257L319 257L319 257L318 256L318 256L318 257L317 257L317 257L317 258L317 258L317 258L317 259L317 259L317 259L317 259L317 260L317 261L317 261L317 262L316 262L315 262L315 262L314 261L314 261L314 261L314 261L313 263L312 264L312 264L311 264L311 266L310 267L311 267L312 268L312 268L312 268L312 268L312 269L312 269L312 270L311 269L311 269L310 269L310 268L310 268L310 268L310 268L309 268L309 268L308 268L308 268L308 268L308 268L308 268L308 268L307 269L307 269L307 269L307 269L307 270L307 270L307 271L307 271L306 272L307 272L307 272L308 272L308 273L307 274L307 274L307 275L307 275L307 276L307 276L307 276L307 276L307 277L308 277L308 277L309 277L309 277L310 277L311 278L312 279L313 277L313 277L313 277L313 277L313 277L313 277L314 277L314 276L314 276L315 276L315 276L315 275L315 276L316 276L316 275L316 275L316 275L316 275L316 275L317 275L317 275L318 275L318 275L318 275L319 275L319 275L320 275L320 275L320 275L321 274L321 274L321 274L321 275L322 275L322 275L322 275L322 275L323 275L323 275L323 275L323 275L323 275L324 274L324 274L323 273L324 273L323 272L323 272L323 272L323 271L323 271L323 270L323 269L324 269L323 269L323 269L322 268L321 268L320 268L320 268L320 268L320 267L321 267L320 267L320 267L320 267L320 265L320 265L320 265L320 265L320 265L321 265L321 265L321 264L321 263L321 262L321 261L321 261L321 261L322 261L322 260L321 259L321 259L321 259L321 259L320 258L320 258z"
        },
        {
            "title": "Vemulawada Rural",
            "d": "M323 275L323 275L322 275L322 275L322 275L322 275L321 275L321 274L321 274L321 274L320 275L320 275L320 275L319 275L319 275L318 275L318 275L318 275L317 275L317 275L316 275L316 275L316 275L316 275L316 275L316 276L315 276L315 275L315 276L315 276L314 276L314 276L314 277L313 277L313 277L313 277L313 277L313 277L313 277L312 279L312 279L313 280L313 280L315 279L316 279L316 279L318 279L319 280L320 280L322 280L323 281L324 281L324 279L324 279L324 278L324 277L323 275zM323 253L323 253L323 252L323 252L323 252L322 252L323 252L323 252L323 252L323 252L323 252L322 251L322 252L322 252L322 252L322 251L322 251L322 251L322 251L322 251L321 251L320 250L318 247L315 248L313 247L310 250L310 250L310 251L310 251L310 252L310 253L310 253L310 253L310 253L311 254L310 254L310 254L310 254L310 255L310 255L309 256L309 257L308 257L308 258L308 259L308 260L308 261L308 261L308 261L307 261L307 261L307 261L307 260L306 260L306 260L306 260L306 260L305 260L305 259L304 259L304 259L303 258L303 258L303 257L303 257L302 258L303 259L303 259L303 260L303 260L303 260L303 260L304 261L304 261L304 262L304 262L304 263L303 262L303 262L303 262L303 262L302 262L302 263L302 263L301 263L301 263L301 263L301 263L301 263L301 263L301 263L301 264L301 264L301 264L301 264L301 265L301 265L301 265L301 266L301 266L302 266L302 267L302 267L302 267L303 268L304 268L304 267L304 267L304 267L304 267L305 267L305 267L305 267L305 267L306 267L306 267L306 267L307 267L307 267L308 268L308 268L308 268L308 268L308 268L308 268L309 268L309 268L310 268L310 268L310 268L310 268L310 269L311 269L311 269L312 270L312 269L312 269L312 268L312 268L312 268L312 268L311 267L310 267L311 266L311 264L312 264L312 264L313 263L314 261L314 261L314 261L314 261L315 262L315 262L316 262L317 262L317 261L317 261L317 260L317 259L317 259L317 259L317 259L317 258L317 258L317 258L317 257L317 257L318 257L318 256L318 256L319 257L319 257L320 257L320 257L320 257L320 258L320 258L321 258L321 257L321 257L321 256L321 255L321 255L321 255L322 255L322 255L322 255L322 254L322 254L322 253L322 253L323 253L323 253z"
        },
        {
            "title": "Yellareddypet",
            "d": "M295 278L295 278L293 277L292 277L292 277L291 275L290 274L290 274L290 274L288 272L287 272L285 273L285 273L282 270L281 271L281 272L277 272L275 272L275 271L274 272L274 273L269 273L269 273L269 273L264 274L263 275L263 275L263 276L264 276L264 276L264 276L265 277L266 279L270 281L271 281L271 282L272 282L272 282L273 283L273 284L273 284L273 284L273 284L273 285L273 285L273 285L273 287L273 287L272 287L272 287L272 287L272 287L272 288L272 288L272 288L272 288L272 288L272 289L272 289L272 289L273 289L274 290L274 290L274 291L274 291L274 291L274 291L274 291L275 292L275 292L275 292L275 293L275 293L275 293L275 293L276 293L276 294L277 294L278 293L278 293L279 293L279 293L279 294L279 294L279 294L279 294L279 295L279 295L279 295L279 295L279 295L279 295L279 295L279 295L279 295L280 295L281 295L282 295L283 295L283 294L284 293L283 293L283 292L283 292L283 291L283 291L283 291L283 291L283 291L283 291L282 290L282 290L282 291L282 291L282 290L282 290L282 290L284 289L285 288L286 288L286 288L288 288L290 288L290 288L291 288L293 288L294 289L295 289L296 289L296 288L297 284L298 282L296 281L295 281L295 279L295 278z"
        }
    ],
    "Khammam": [
        {
            "title": "Bonakal",
            "d": "M550 505L550 505L550 505L549 504L548 504L547 504L547 506L546 506L546 507L546 507L545 507L544 507L544 507L544 507L543 507L543 507L542 507L542 507L542 508L542 508L542 508L542 508L542 508L542 509L542 509L541 511L542 511L542 511L541 511L541 512L541 511L541 511L541 511L540 512L540 512L540 512L539 513L539 513L539 514L539 514L539 514L539 514L539 514L538 514L537 516L537 516L537 516L537 516L536 516L536 516L536 516L536 516L536 516L536 516L535 516L535 517L535 517L536 518L536 518L535 518L535 518L535 518L535 518L535 518L534 519L534 519L534 520L534 520L534 521L535 521L535 522L536 522L537 523L538 523L538 522L538 521L539 522L539 522L540 523L541 523L541 524L541 524L542 524L543 524L543 524L545 525L545 525L545 524L546 524L547 523L548 523L548 523L550 525L549 527L549 528L549 528L550 528L552 529L552 531L551 532L552 532L553 533L554 533L554 533L556 533L556 534L557 534L557 533L557 533L557 532L557 531L557 530L557 529L557 528L557 528L557 527L558 527L558 527L558 526L558 526L557 525L558 524L559 522L559 522L559 522L559 522L559 521L559 520L559 519L559 519L560 518L560 518L560 518L560 517L560 516L560 516L560 515L561 516L561 515L562 515L562 514L561 514L561 514L561 513L561 512L561 512L560 512L560 512L560 512L559 511L559 511L558 511L558 511L558 511L558 512L558 512L558 512L558 512L558 512L558 513L558 513L558 513L558 513L557 513L557 514L557 514L556 514L556 515L555 514L555 514L555 514L555 513L555 513L554 513L554 513L555 512L555 511L555 510L555 510L555 510L555 509L555 509L553 509L553 510L553 510L552 510L553 510L553 510L553 510L553 511L553 511L553 511L553 511L553 511L553 512L553 512L552 512L552 512L553 513L552 513L552 513L552 513L552 512L552 512L552 512L551 512L551 512L551 512L551 512L550 511L550 511L549 511L550 510L550 509L550 509L550 509L550 509L550 509L551 509L551 509L551 508L551 508L552 508L552 507L552 507L552 507L551 506L551 506L551 505L550 505z"
        },
        {
            "title": "Chintakani",
            "d": "M539 484L538 484L538 484L538 483L538 483L538 484L537 483L536 486L535 486L535 486L535 487L534 487L535 488L535 489L535 489L534 489L534 489L534 489L534 490L533 490L533 491L533 491L533 491L532 491L532 491L532 491L531 491L531 491L530 491L530 491L530 491L530 491L530 491L529 491L529 492L529 492L529 492L529 493L529 493L529 493L528 493L528 493L528 493L528 493L528 495L527 498L527 499L528 502L529 505L529 505L529 506L530 508L530 508L529 509L527 512L527 513L527 513L527 514L527 515L528 516L528 517L529 518L529 519L529 520L529 522L529 523L529 523L529 522L529 521L530 521L531 521L531 521L532 520L532 520L533 519L533 518L533 518L533 517L533 517L535 517L535 518L535 518L535 518L535 518L536 518L536 518L535 517L535 517L535 516L536 516L536 516L536 516L536 516L536 516L536 516L537 516L537 516L537 516L537 516L538 514L539 514L539 514L539 514L539 514L539 514L539 513L539 513L540 512L540 512L540 512L541 511L541 511L541 511L541 512L541 511L542 511L542 511L541 511L542 509L542 509L542 508L542 508L542 508L542 508L542 508L542 507L542 507L543 507L543 507L544 507L544 507L544 507L545 507L546 507L546 507L546 506L547 506L547 504L548 504L549 504L550 505L550 505L550 505L551 504L551 503L552 503L552 502L551 502L550 500L550 500L549 499L549 499L549 499L549 499L549 499L549 499L549 498L548 498L548 497L548 497L548 497L547 497L547 497L547 497L547 497L547 497L546 497L545 497L544 497L544 497L543 497L543 496L542 496L541 496L541 495L541 495L541 494L541 492L541 492L541 491L541 491L541 491L541 491L541 491L541 490L541 490L541 490L541 490L541 490L540 490L540 489L541 489L541 489L541 488L541 488L541 488L540 488L540 487L540 487L540 487L540 487L540 487L540 487L540 486L540 486L540 485L539 485L539 485L539 484z"
        },
        {
            "title": "Enkoor",
            "d": "M567 449L564 450L561 451L560 450L560 448L560 449L559 450L558 453L558 454L556 457L555 460L555 461L555 461L556 461L556 462L558 463L558 463L559 463L559 463L559 463L559 462L559 463L559 463L559 464L560 464L560 464L560 464L561 464L561 465L561 465L562 465L562 465L562 465L562 465L562 465L561 466L562 466L562 467L562 468L563 469L563 469L563 469L563 470L563 471L564 471L564 471L564 471L564 471L564 472L565 472L565 472L566 472L566 472L566 472L566 473L566 473L566 473L566 474L566 474L565 474L565 475L565 476L565 476L565 476L565 477L564 477L564 478L564 478L564 479L564 479L565 480L565 480L565 480L566 480L566 480L566 480L566 480L566 479L567 480L567 479L567 479L567 478L568 478L568 478L568 478L568 478L569 478L569 477L568 477L569 477L569 477L568 476L568 475L568 475L568 475L569 475L569 475L569 475L569 475L569 475L570 475L570 475L571 475L571 475L571 473L572 474L572 474L572 473L572 473L572 474L574 472L574 471L576 472L576 472L577 473L578 473L578 473L580 472L580 473L580 472L581 472L584 470L584 470L584 470L585 470L585 470L585 469L585 469L584 466L584 466L584 466L584 465L584 464L585 460L585 460L584 459L580 460L580 460L580 460L576 460L574 460L574 460L571 458L571 454L567 449z"
        },
        {
            "title": "Kalluru",
            "d": "M570 508L570 509L570 509L570 511L570 512L571 513L571 514L572 514L572 515L573 515L573 515L573 516L573 517L574 518L575 518L575 518L576 518L577 519L578 519L579 517L579 516L580 515L582 515L583 514L583 514L585 513L585 511L586 510L584 509L585 507L586 505L586 505L586 503L588 504L589 504L590 503L590 503L591 503L591 503L592 502L592 502L593 501L593 502L594 502L595 501L596 500L597 499L597 498L600 499L600 499L600 500L601 500L601 501L602 501L602 501L602 501L603 500L603 500L603 499L603 498L603 498L602 498L602 498L602 497L602 498L601 497L602 497L602 496L602 495L602 495L602 495L603 495L603 495L603 494L603 494L603 494L603 494L603 494L603 494L604 492L603 492L603 491L602 491L602 491L602 490L602 489L603 488L603 487L602 487L601 487L600 487L600 486L600 486L600 480L600 479L601 479L601 479L601 480L601 480L601 480L601 480L602 480L602 480L602 480L602 480L603 480L603 480L603 480L604 480L603 480L604 480L604 480L604 480L604 480L604 481L604 481L605 481L605 481L605 480L605 480L606 480L606 480L606 480L606 480L606 481L606 481L605 482L606 482L606 482L606 482L606 482L606 482L606 481L606 481L607 481L607 481L607 481L608 481L608 481L608 481L607 480L606 475L607 477L612 473L609 471L608 469L605 470L605 469L601 464L601 465L596 467L596 468L593 468L585 470L585 470L584 470L584 470L584 470L581 472L580 472L580 473L579 476L579 477L579 477L580 478L581 479L582 480L582 480L582 481L583 479L586 480L584 483L584 485L584 485L585 485L585 484L585 484L586 485L586 486L586 486L586 486L586 486L586 487L586 488L586 488L587 488L587 488L587 490L585 492L585 492L585 492L585 492L584 492L582 494L582 495L581 495L581 495L581 495L581 496L580 497L580 497L580 498L580 498L579 498L579 498L579 498L579 499L579 499L579 499L579 499L579 499L579 500L579 500L579 500L579 501L579 501L579 501L579 502L579 502L579 502L579 502L580 502L580 503L580 503L580 504L580 504L580 505L580 505L580 505L580 505L579 505L579 505L579 505L578 504L578 505L578 505L578 505L578 505L577 505L577 505L577 505L576 506L576 506L576 506L576 506L576 506L575 507L575 508L575 508L574 509L574 508L574 509L573 509L573 509L572 509L571 509L571 508L570 508z"
        },
        {
            "title": "Kamepally",
            "d": "M560 448L560 446L557 445L556 445L555 445L554 444L554 443L552 443L552 443L550 443L549 442L549 442L548 442L547 442L547 443L547 443L547 443L547 443L547 444L547 444L547 444L547 444L547 444L547 444L547 444L546 445L546 445L546 445L546 445L545 445L545 446L545 445L544 446L544 445L544 445L544 444L542 444L542 443L541 443L541 443L541 443L540 443L541 443L541 444L540 444L540 444L540 444L540 444L540 444L540 444L539 444L539 445L539 445L538 446L538 446L537 446L537 447L537 447L537 448L537 447L536 448L536 447L536 448L536 448L535 448L535 448L535 448L535 448L535 448L534 449L534 449L531 448L531 448L531 447L530 448L529 449L528 451L528 452L529 454L528 455L528 457L528 457L528 457L529 456L529 456L530 455L532 455L533 455L533 456L534 458L534 459L535 459L535 459L536 459L536 460L537 460L537 461L537 460L537 461L538 460L538 460L538 460L538 460L539 460L539 460L540 461L541 461L542 461L543 461L543 461L545 462L548 462L549 462L550 462L553 462L554 462L554 462L555 462L555 461L555 461L555 460L556 457L558 454L558 453L559 450L560 449L560 448z"
        },
        {
            "title": "Khammam_Rural",
            "d": "M528 459L525 456L525 456L524 457L523 457L523 458L523 459L523 459L522 459L522 459L522 458L522 458L522 458L521 458L521 458L521 458L521 458L521 459L521 459L521 459L521 460L521 460L520 460L520 460L520 460L520 460L520 460L520 460L520 461L520 462L518 463L518 462L518 462L518 462L517 462L516 462L515 461L515 461L514 461L514 461L514 461L514 462L514 462L513 463L514 463L514 463L514 464L513 463L513 463L511 464L511 464L511 464L511 465L510 467L510 467L510 467L510 467L510 467L510 468L510 470L510 470L510 471L510 471L510 471L510 471L510 471L510 471L509 471L509 472L509 472L509 472L509 472L509 472L509 472L509 472L509 473L509 473L509 473L509 473L509 474L509 474L509 474L509 474L509 475L509 475L509 475L509 475L509 475L509 476L508 476L507 476L507 476L507 476L507 476L507 476L507 476L506 476L506 476L506 476L505 476L505 476L505 476L505 476L504 476L504 476L504 477L504 477L504 477L504 477L504 478L505 478L505 478L505 478L505 478L504 480L506 481L506 481L506 481L506 481L507 481L507 481L507 481L507 481L506 482L507 483L507 483L507 483L506 485L507 485L507 486L508 487L508 487L509 487L510 488L511 488L512 488L512 488L514 489L514 489L515 489L516 489L516 489L516 489L517 489L518 489L518 489L518 489L519 489L519 490L519 490L519 490L520 490L520 490L520 490L521 491L521 491L521 491L521 492L521 492L521 492L521 492L521 491L522 492L523 492L523 492L523 492L524 492L524 492L524 493L524 493L524 493L524 493L524 494L525 494L525 493L525 493L525 493L525 493L526 493L526 493L526 493L526 493L526 492L527 492L527 492L527 492L527 493L527 492L528 492L527 491L526 490L525 488L523 486L523 486L522 485L522 485L521 484L521 484L522 483L523 478L523 475L524 473L524 472L523 471L523 471L523 470L523 470L524 470L524 471L524 471L524 471L525 471L525 471L525 471L525 471L526 471L526 471L527 471L527 471L527 471L528 471L528 470L528 470L528 470L529 469L530 468L530 468L530 468L530 468L530 467L530 467L530 467L529 463L529 462L529 462L529 461L529 460L528 460L528 459z"
        },
        {
            "title": "Khammam_Urban",
            "d": "M537 483L535 481L536 479L535 479L535 479L535 478L535 478L534 477L533 477L533 476L533 476L533 476L533 476L532 475L533 475L533 475L533 475L533 475L533 475L532 475L533 473L532 473L532 473L532 472L532 473L532 472L532 472L531 472L531 472L531 472L529 470L529 470L528 470L528 470L528 470L528 471L527 471L527 471L527 471L526 471L526 471L525 471L525 471L525 471L525 471L524 471L524 471L524 471L524 470L523 470L523 470L523 471L523 471L524 472L524 473L523 475L523 478L522 483L521 484L521 484L522 485L522 485L523 486L523 486L525 488L526 490L527 491L528 492L528 493L528 493L528 493L528 493L529 493L529 493L529 493L529 492L529 492L529 492L529 491L530 491L530 491L530 491L530 491L530 491L531 491L531 491L532 491L532 491L532 491L533 491L533 491L533 491L533 490L534 490L534 489L534 489L534 489L535 489L535 489L535 488L534 487L535 487L535 486L535 486L536 486L537 483z"
        },
        {
            "title": "Konijerla",
            "d": "M552 502L552 502L552 502L553 502L553 502L553 501L554 502L554 502L554 502L555 502L555 502L555 502L555 501L555 501L555 501L555 500L556 499L556 498L556 498L556 498L556 498L557 498L557 498L557 497L557 497L557 497L558 497L558 497L558 497L558 497L558 496L557 494L557 493L557 493L557 493L557 494L556 494L556 493L556 494L556 494L556 494L555 493L554 493L554 492L554 492L554 491L554 490L553 490L552 490L552 489L551 489L551 489L551 488L552 487L552 487L552 487L552 486L552 486L552 486L553 486L553 486L553 486L553 486L553 486L553 486L553 486L555 486L556 486L556 487L556 487L555 488L557 489L557 489L559 490L561 490L561 490L561 491L561 491L564 490L563 489L564 489L564 488L564 488L564 488L564 487L564 486L564 486L564 486L565 485L564 485L565 484L565 484L565 484L565 484L565 483L564 482L564 482L565 481L565 480L564 480L565 480L565 480L564 479L564 479L564 478L564 478L564 477L565 477L565 476L565 476L565 476L565 475L565 474L566 474L566 474L566 473L566 473L566 473L566 472L566 472L566 472L565 472L565 472L564 472L564 471L564 471L564 471L564 471L563 471L563 470L563 469L563 469L563 469L562 468L562 467L562 466L561 466L562 465L562 465L562 465L562 465L562 465L561 465L561 465L561 464L560 464L560 464L560 464L559 464L559 463L559 463L559 462L559 463L559 463L559 463L558 463L558 463L558 463L557 464L557 467L555 469L552 470L550 474L547 475L546 477L546 477L546 477L546 477L546 477L546 477L545 477L545 477L545 478L542 477L541 478L541 478L541 478L541 478L541 478L541 479L540 479L540 479L540 479L541 479L541 480L541 481L541 483L540 483L540 483L539 483L539 483L539 483L539 483L539 483L539 484L539 484L539 484L539 485L539 485L540 485L540 486L540 486L540 487L540 487L540 487L540 487L540 487L540 487L540 488L541 488L541 488L541 488L541 489L541 489L540 489L540 490L541 490L541 490L541 490L541 490L541 490L541 491L541 491L541 491L541 491L541 491L541 492L541 492L541 494L541 495L541 495L541 496L542 496L543 496L543 497L544 497L544 497L545 497L546 497L547 497L547 497L547 497L547 497L547 497L548 497L548 497L548 497L548 498L549 498L549 499L549 499L549 499L549 499L549 499L549 499L550 500L550 500L551 502L552 502z"
        },
        {
            "title": "Kusumanchi",
            "d": "M504 476L503 476L502 476L501 476L500 476L500 476L500 476L499 476L499 476L498 475L497 477L497 477L497 478L496 476L496 476L496 476L496 475L496 475L495 475L495 475L495 474L495 474L494 474L494 474L493 474L493 474L493 474L492 474L492 474L492 475L492 474L491 474L491 474L491 474L491 475L491 475L491 475L491 475L490 475L490 475L490 475L490 475L490 475L490 474L489 474L489 474L488 474L488 473L487 473L487 474L487 474L486 475L486 475L486 475L486 475L485 475L485 475L485 475L485 475L485 475L483 475L482 474L482 474L482 474L481 474L482 475L481 475L481 476L481 476L481 476L481 477L482 477L482 477L481 477L481 477L481 477L480 478L481 479L481 479L481 479L482 479L482 479L482 479L482 479L482 479L482 479L482 479L482 479L482 479L482 479L483 480L483 480L483 479L483 479L484 480L484 480L485 480L485 480L485 480L485 481L485 481L485 481L485 482L485 482L485 482L485 483L484 483L484 483L484 484L484 486L484 486L485 487L484 487L483 487L483 487L482 487L482 487L482 487L482 487L482 488L481 488L481 488L482 488L482 488L482 488L482 488L482 488L482 488L482 489L482 490L481 490L481 491L481 491L481 492L481 492L481 492L481 493L481 494L481 494L481 494L481 494L482 494L482 494L482 494L483 494L483 495L483 495L484 496L484 496L484 497L484 497L485 497L486 498L487 499L487 501L487 501L487 501L488 501L489 501L489 501L489 501L491 501L491 501L491 501L491 501L491 501L491 501L491 501L491 501L492 501L492 501L492 501L492 501L493 502L494 502L494 502L494 502L495 503L495 503L496 504L497 503L498 501L498 501L498 500L497 500L497 500L497 499L497 499L497 498L497 498L497 498L497 498L497 498L497 496L497 496L497 495L498 495L498 495L498 494L498 494L498 494L498 494L498 494L499 494L499 493L500 494L501 494L501 494L502 493L502 493L502 492L502 492L502 492L502 491L502 491L503 491L503 491L503 491L504 491L504 491L504 491L504 491L504 491L504 491L504 491L505 491L505 491L505 491L505 491L506 491L506 491L506 491L506 491L507 491L507 490L507 491L508 491L508 490L507 490L507 490L508 489L508 488L508 488L508 488L508 488L508 488L508 487L508 487L508 487L507 486L507 485L506 485L507 483L507 483L507 483L506 482L507 481L507 481L507 481L507 481L506 481L506 481L506 481L506 481L504 480L505 478L505 478L505 478L505 478L504 478L504 477L504 477L504 477L504 477L504 476z"
        },
        {
            "title": "Madhira",
            "d": "M565 512L565 512L564 512L564 512L564 513L563 514L563 514L562 515L562 515L561 515L561 516L560 515L560 516L560 516L560 517L560 518L560 518L560 518L559 519L559 519L559 520L559 521L559 522L559 522L559 522L559 522L558 524L557 525L558 526L558 526L558 527L558 527L557 527L557 528L557 528L557 529L557 530L557 531L557 532L557 533L557 533L557 534L556 534L556 533L554 533L554 533L553 533L553 534L553 534L553 537L553 538L553 539L553 539L554 539L554 539L554 540L555 541L555 541L555 542L554 545L554 545L554 545L555 545L556 546L556 546L557 545L557 546L558 546L558 547L557 548L557 548L558 548L560 549L561 549L562 549L562 550L563 550L563 551L563 551L563 552L563 552L563 552L564 552L564 552L564 552L563 553L563 554L563 555L564 556L564 556L565 556L565 555L565 555L565 554L565 554L565 555L566 554L566 554L566 554L567 553L568 553L568 553L568 552L568 550L566 550L565 550L564 550L564 550L564 550L564 549L564 549L564 549L564 548L564 548L564 548L564 548L564 548L564 547L564 548L565 548L566 548L567 549L569 550L569 550L571 550L572 551L572 551L572 552L573 552L573 552L573 552L573 552L573 552L573 552L573 552L573 552L573 552L574 552L574 551L575 551L575 549L575 549L574 549L574 548L573 548L573 547L573 547L572 547L572 547L572 547L572 545L573 544L573 544L573 543L573 542L573 542L573 542L573 542L572 542L572 541L573 541L573 541L573 540L573 539L574 540L575 540L575 540L575 539L575 538L576 538L576 538L576 538L577 537L577 537L578 536L578 537L578 536L579 536L579 535L577 533L575 532L574 532L572 531L568 531L566 530L564 529L562 529L561 529L561 528L562 528L562 528L562 527L563 527L563 526L564 525L565 524L565 524L565 523L565 523L566 523L567 522L568 522L568 521L568 520L568 519L567 519L567 519L567 518L567 517L567 516L567 516L567 516L567 515L566 515L566 515L566 515L566 515L566 514L566 514L565 513L565 512L565 512L565 512z"
        },
        {
            "title": "Mudigonda",
            "d": "M528 492L527 492L527 493L527 492L527 492L527 492L526 492L526 493L526 493L526 493L526 493L525 493L525 493L525 493L525 493L525 494L524 494L524 493L524 493L524 493L524 493L524 492L524 492L523 492L523 492L523 492L522 492L521 491L521 492L521 492L521 492L521 492L521 491L521 491L521 491L520 490L520 490L520 490L519 490L519 490L519 490L519 489L518 489L518 489L518 489L517 489L516 489L516 489L516 489L515 489L514 489L514 489L512 488L512 488L511 488L510 488L509 487L508 487L508 487L508 488L508 488L508 488L508 488L508 488L508 489L507 490L507 490L508 490L508 491L507 491L507 490L507 491L506 491L506 491L506 491L506 491L505 491L505 491L505 491L505 491L504 491L504 491L504 491L504 491L504 491L504 491L504 491L503 491L503 491L503 491L502 491L502 491L502 492L502 492L502 492L502 493L502 493L501 494L501 494L501 494L501 494L502 494L502 494L502 494L503 494L503 494L503 495L503 495L503 495L503 495L504 495L504 496L504 496L505 496L505 497L505 497L506 497L506 497L506 497L507 497L507 497L507 497L508 498L508 498L509 498L509 498L509 498L510 499L510 499L510 499L511 499L512 499L512 499L513 499L513 499L513 499L514 499L514 499L514 499L514 499L514 500L515 500L515 500L515 499L516 500L516 499L516 499L517 501L517 501L518 501L517 503L517 503L516 504L516 505L516 506L518 506L518 507L518 507L518 507L519 507L519 508L519 509L519 509L519 509L519 510L518 510L519 510L518 511L519 512L518 512L518 513L518 513L518 514L517 514L518 514L517 514L518 515L518 515L518 515L518 515L518 515L518 515L518 516L518 516L519 516L519 516L519 517L519 518L519 518L519 518L519 519L519 519L519 519L518 519L518 520L518 520L518 521L517 521L517 521L517 521L517 522L517 522L517 522L516 522L516 523L516 523L517 524L516 525L516 525L517 526L517 526L518 526L519 526L519 526L519 526L520 526L521 526L521 526L521 526L521 526L522 525L523 526L523 526L524 526L524 526L525 525L525 524L526 523L526 523L527 523L527 523L528 523L529 523L529 523L529 523L529 522L529 520L529 519L529 518L528 517L528 516L527 515L527 514L527 513L527 513L527 512L529 509L530 508L530 508L529 506L529 505L529 505L528 502L527 499L527 498L528 495L528 493L528 492z"
        },
        {
            "title": "Nelakondapally",
            "d": "M510 529L511 529L513 529L515 529L515 530L516 530L516 528L516 527L517 526L517 526L516 525L516 525L517 524L516 523L516 523L516 522L517 522L517 522L517 522L517 521L517 521L517 521L518 521L518 520L518 520L518 519L519 519L519 519L519 519L519 518L519 518L519 518L519 517L519 516L519 516L518 516L518 516L518 515L518 515L518 515L518 515L518 515L518 515L517 514L518 514L517 514L518 514L518 513L518 513L518 512L519 512L518 511L519 510L518 510L519 510L519 509L519 509L519 509L519 508L519 507L518 507L518 507L518 507L518 506L516 506L516 505L516 504L517 503L517 503L518 501L517 501L517 501L516 499L516 499L516 500L515 499L515 500L515 500L514 500L514 499L514 499L514 499L514 499L513 499L513 499L513 499L512 499L512 499L511 499L510 499L510 499L510 499L509 498L509 498L509 498L508 498L508 498L507 497L507 497L507 497L506 497L506 497L506 497L505 497L505 497L505 496L504 496L504 496L504 495L503 495L503 495L503 495L503 495L503 494L503 494L502 494L502 494L502 494L501 494L501 494L501 494L501 494L501 494L500 494L499 493L499 494L498 494L498 494L498 494L498 494L498 494L498 495L498 495L497 495L497 496L497 496L497 498L497 498L497 498L497 498L497 498L497 499L497 499L497 500L497 500L498 500L498 501L498 501L497 503L496 504L496 505L496 505L496 505L496 505L497 506L497 506L497 506L497 506L498 507L498 507L498 507L498 507L498 507L499 508L499 509L499 509L500 510L500 510L500 510L500 511L501 511L501 511L501 511L502 512L503 512L503 512L504 512L504 512L504 513L504 513L504 514L505 514L505 514L504 514L505 514L505 514L505 515L506 515L507 515L507 515L507 515L507 515L508 516L508 516L508 516L508 517L508 517L508 518L507 519L507 519L507 520L507 520L507 520L508 521L508 521L508 521L508 521L509 521L509 522L509 522L509 522L509 522L510 522L510 522L510 522L511 522L511 522L511 522L511 523L511 523L511 523L511 523L511 523L511 524L511 524L510 525L511 525L511 525L511 525L511 526L511 526L511 527L510 529z"
        },
        {
            "title": "Penuballi",
            "d": "M602 501L603 502L603 502L603 502L604 502L604 502L605 502L606 502L607 503L608 503L607 504L609 505L610 506L611 506L612 507L613 507L614 507L614 507L615 505L614 504L613 503L612 503L612 503L613 502L612 502L613 502L613 502L614 502L614 502L614 502L615 502L615 501L615 501L615 501L616 501L616 500L617 500L618 499L618 499L618 499L618 499L619 499L619 499L620 499L620 499L620 499L620 499L621 499L621 499L621 499L620 499L620 498L620 498L620 498L620 497L619 496L619 496L619 495L620 494L620 493L622 492L622 493L622 492L623 492L623 492L623 492L625 492L627 494L626 493L627 490L626 490L626 488L627 483L627 483L627 483L626 482L627 482L628 481L628 480L628 479L628 479L629 478L629 473L629 472L625 469L624 471L623 472L622 471L620 471L619 472L618 472L618 472L618 473L618 473L618 473L618 473L618 474L617 473L617 474L616 475L615 475L612 473L612 473L607 477L606 475L607 480L608 481L608 481L608 481L607 481L607 481L607 481L606 481L606 481L606 482L606 482L606 482L606 482L606 482L605 482L606 481L606 481L606 480L606 480L606 480L606 480L605 480L605 480L605 481L605 481L604 481L604 481L604 480L604 480L604 480L604 480L603 480L604 480L603 480L603 480L603 480L602 480L602 480L602 480L602 480L601 480L601 480L601 480L601 480L601 479L601 479L600 479L600 480L600 486L600 486L600 487L601 487L602 487L603 487L603 488L602 489L602 490L602 491L602 491L603 491L603 492L604 492L603 494L603 494L603 494L603 494L603 494L603 494L603 495L603 495L602 495L602 495L602 495L602 496L602 497L601 497L602 498L602 497L602 498L602 498L603 498L603 498L603 499L603 500L603 500L602 501L602 501L602 501z"
        },
        {
            "title": "Raghunadhapalem",
            "d": "M555 461L555 462L554 462L554 462L553 462L550 462L549 462L548 462L545 462L543 461L543 461L542 461L541 461L540 461L539 460L539 460L538 460L538 460L538 460L538 460L537 461L537 460L537 461L537 460L536 460L536 459L535 459L535 459L534 459L534 458L533 456L533 455L532 455L530 455L529 456L529 456L528 457L528 457L528 458L528 458L528 459L528 460L529 460L529 461L529 462L529 462L529 463L530 467L530 467L530 467L530 468L530 468L530 468L530 468L529 469L528 470L529 470L529 470L531 472L531 472L531 472L532 472L532 472L532 473L532 472L532 473L532 473L533 473L532 475L533 475L533 475L533 475L533 475L533 475L532 475L533 476L533 476L533 476L533 476L533 477L534 477L535 478L535 478L535 479L535 479L536 479L535 481L537 483L538 484L538 483L538 483L538 484L538 484L539 484L539 484L539 484L539 483L539 483L539 483L539 483L539 483L540 483L540 483L541 483L541 481L541 480L541 479L540 479L540 479L540 479L541 479L541 478L541 478L541 478L541 478L541 478L542 477L545 478L545 477L545 477L546 477L546 477L546 477L546 477L546 477L546 477L547 475L550 474L552 470L555 469L557 467L557 464L558 463L558 463L556 462L556 461L555 461z"
        },
        {
            "title": "Sathupally",
            "d": "M645 463L645 463L644 463L643 462L643 461L642 459L642 460L642 463L639 463L636 466L635 467L634 467L631 466L631 467L631 468L631 469L630 471L629 471L629 472L629 472L629 473L629 478L628 479L628 479L628 480L628 481L627 482L626 482L627 483L627 483L627 483L626 488L626 490L627 490L626 493L627 494L628 494L629 495L630 496L631 496L632 496L632 496L633 496L633 497L634 497L634 498L635 498L635 498L636 498L637 499L638 499L639 500L640 500L640 501L640 502L641 502L642 503L642 504L643 504L644 504L644 504L644 504L645 504L645 504L645 504L645 504L645 503L645 503L646 502L647 501L647 501L647 501L646 499L647 498L647 497L647 497L647 497L648 497L649 497L651 498L652 498L653 498L654 497L654 497L654 497L654 496L654 496L654 495L654 493L654 493L654 492L654 492L653 492L653 492L653 491L653 490L653 490L653 490L653 489L653 488L653 488L653 487L653 487L653 487L653 487L653 486L651 487L650 486L649 486L649 486L649 486L648 485L647 485L647 485L646 484L646 484L646 484L645 484L645 484L645 484L644 484L644 483L645 482L645 481L645 481L646 479L646 478L646 478L645 476L645 476L645 476L645 474L646 469L645 469L645 467L645 463z"
        },
        {
            "title": "Singareni",
            "d": "M569 434L569 435L568 435L564 439L562 438L562 437L560 437L559 437L561 432L563 431L563 429L563 428L561 428L561 428L560 428L559 428L559 427L559 427L558 427L556 426L552 425L551 425L550 425L550 425L550 425L549 425L549 425L549 425L549 425L549 425L549 426L549 426L549 426L548 426L548 427L548 427L548 427L548 427L548 427L548 427L548 427L548 427L547 427L547 427L546 427L546 427L546 427L546 428L546 428L546 428L546 428L546 428L546 428L546 428L546 428L546 429L546 429L545 429L545 429L545 429L545 429L544 429L544 429L544 429L543 429L543 429L543 430L543 430L543 431L542 431L542 431L542 431L542 430L541 428L540 427L540 430L537 428L535 428L535 430L536 430L538 432L538 432L538 432L539 433L539 433L537 435L536 437L536 438L537 439L537 440L537 442L538 442L536 443L536 443L536 443L536 443L536 443L535 443L535 443L535 443L535 442L535 442L534 442L534 442L534 441L534 443L534 444L534 444L534 445L534 446L535 448L535 448L535 448L535 448L536 448L536 448L536 447L536 448L537 447L537 448L537 447L537 447L537 446L538 446L538 446L539 445L539 445L539 444L540 444L540 444L540 444L540 444L540 444L540 444L541 444L541 443L540 443L541 443L541 443L541 443L542 443L542 444L544 444L544 445L544 445L544 446L545 445L545 446L545 445L546 445L546 445L546 445L546 445L547 444L547 444L547 444L547 444L547 444L547 444L547 444L547 443L547 443L547 443L547 443L547 442L548 442L549 442L549 442L550 443L552 443L552 443L554 443L554 444L555 445L556 445L557 445L560 446L560 448L560 450L561 451L564 450L567 449L567 449L570 445L573 446L575 443L579 437L577 437L573 436L573 436L569 434z"
        },
        {
            "title": "Thallada",
            "d": "M580 473L580 472L578 473L578 473L577 473L576 472L576 472L574 471L574 472L572 474L572 473L572 473L572 474L572 474L571 473L571 475L571 475L570 475L570 475L569 475L569 475L569 475L569 475L569 475L568 475L568 475L568 475L568 476L569 477L569 477L568 477L569 477L569 478L568 478L568 478L568 478L568 478L567 478L567 479L567 479L567 480L566 479L566 480L566 480L566 480L566 480L565 480L565 480L565 480L565 480L564 480L565 480L565 481L564 482L564 482L565 483L565 484L565 484L565 484L565 484L564 485L565 485L564 486L564 486L564 486L564 487L564 488L564 488L564 488L564 489L563 489L564 489L564 490L564 490L564 490L564 491L564 491L564 492L564 492L564 492L564 493L565 493L566 493L566 493L566 493L567 493L567 494L567 494L567 494L567 494L567 494L567 495L567 495L568 495L569 496L570 496L570 496L571 497L571 496L571 496L572 497L572 497L572 497L573 497L573 497L573 497L573 497L574 497L573 498L573 499L573 499L573 499L573 499L573 500L572 500L572 500L572 500L572 500L571 500L571 500L571 500L571 501L570 500L569 500L568 501L569 501L569 502L569 502L569 503L569 503L570 503L570 504L570 504L570 504L570 505L571 505L571 506L571 506L571 506L571 506L571 507L571 507L571 507L571 507L571 508L571 508L570 508L571 508L571 508L571 508L571 508L571 509L572 509L573 509L573 509L574 509L574 508L574 509L575 508L575 508L575 507L576 506L576 506L576 506L576 506L576 506L577 505L577 505L577 505L578 505L578 505L578 505L578 505L578 504L579 505L579 505L579 505L580 505L580 505L580 505L580 505L580 504L580 504L580 503L580 503L580 502L579 502L579 502L579 502L579 502L579 501L579 501L579 501L579 500L579 500L579 500L579 499L579 499L579 499L579 499L579 499L579 498L579 498L579 498L580 498L580 498L580 497L580 497L581 496L581 495L581 495L581 495L582 495L582 494L584 492L585 492L585 492L585 492L585 492L587 490L587 488L587 488L586 488L586 488L586 487L586 486L586 486L586 486L586 486L586 485L585 484L585 484L585 485L584 485L584 485L584 483L586 480L583 479L582 481L582 480L582 480L581 479L580 478L579 477L579 477L579 476L580 473z"
        },
        {
            "title": "Tirumalayapalem",
            "d": "M498 454L497 454L496 454L496 455L494 456L491 456L491 457L491 458L491 458L491 459L490 460L490 461L490 461L490 461L489 461L489 460L489 460L487 460L485 459L485 459L485 459L485 460L485 461L484 461L484 461L484 461L484 462L484 463L484 463L484 463L483 463L483 463L483 463L483 463L482 463L482 462L482 462L482 463L481 463L481 463L481 463L481 464L482 464L482 464L482 464L481 464L481 465L481 465L481 466L481 466L481 466L481 467L480 467L479 466L479 467L478 466L478 467L477 466L476 466L476 466L476 467L476 467L476 467L475 467L474 466L473 466L473 466L472 466L470 467L470 467L470 467L470 467L470 467L470 468L470 468L469 468L469 468L469 468L469 468L469 469L468 470L468 470L468 470L468 470L469 471L469 472L469 471L470 472L470 472L470 473L471 473L471 473L471 474L471 475L471 475L471 475L472 476L473 477L473 477L473 477L473 477L474 477L474 476L474 476L474 476L475 476L475 476L476 477L477 477L478 478L478 478L479 479L480 479L480 478L480 478L480 478L480 478L480 478L480 478L481 477L481 477L481 477L482 477L482 477L481 477L481 476L481 476L481 476L481 475L482 475L481 474L482 474L482 474L482 474L483 475L485 475L485 475L485 475L485 475L485 475L486 475L486 475L486 475L486 475L487 474L487 474L487 473L488 473L488 474L489 474L489 474L490 474L490 475L490 475L490 475L490 475L490 475L491 475L491 475L491 475L491 475L491 474L491 474L491 474L492 474L492 475L492 474L492 474L493 474L493 474L493 474L494 474L494 474L495 474L495 474L495 475L495 475L496 475L496 475L496 476L496 476L496 476L497 478L497 477L497 477L498 475L499 476L499 476L500 476L500 476L500 476L501 476L502 476L503 476L504 476L504 476L505 476L505 476L505 476L505 476L506 476L506 476L506 476L507 476L507 476L507 476L507 476L507 476L507 476L508 476L509 476L509 475L509 475L509 475L509 475L509 475L509 474L509 474L509 474L509 474L509 473L509 473L509 473L509 473L509 472L509 472L509 472L509 472L509 472L509 472L509 472L509 471L510 471L510 471L510 471L510 471L510 471L510 471L510 470L510 470L510 468L510 467L510 467L510 467L510 467L510 467L511 465L511 464L511 464L510 464L510 464L510 464L509 464L509 463L508 463L507 463L506 463L505 463L505 462L505 462L504 462L504 462L503 461L503 460L502 460L501 460L501 459L500 458L500 455L499 455L498 454z"
        },
        {
            "title": "Vemsoor",
            "d": "M627 494L625 492L623 492L623 492L623 492L622 492L622 493L622 492L620 493L620 494L619 495L619 496L619 496L620 497L620 498L620 498L620 498L620 499L621 499L621 499L621 499L620 499L620 499L620 499L620 499L619 499L619 499L618 499L618 499L618 499L618 499L617 500L616 500L616 501L615 501L615 501L615 501L615 502L614 502L614 502L614 502L613 502L613 502L612 502L613 502L612 503L612 503L613 503L614 504L615 505L614 507L614 507L613 507L612 507L612 508L611 508L611 509L610 509L610 509L609 512L609 512L610 513L611 513L612 513L612 512L612 513L613 513L613 512L613 512L614 512L614 512L615 512L615 512L616 512L616 511L617 511L616 511L616 511L616 510L617 511L617 510L618 511L619 510L623 511L623 511L624 511L625 511L626 512L626 512L628 513L630 513L631 513L631 513L633 514L634 515L635 515L638 515L639 516L641 517L641 518L642 517L643 516L643 516L644 515L644 515L645 514L645 513L646 513L646 512L646 512L646 512L645 511L645 511L645 511L645 509L646 508L646 508L646 507L646 506L646 505L645 504L645 504L644 504L644 504L644 504L643 504L642 504L642 503L641 502L640 502L640 501L640 500L639 500L638 499L637 499L636 498L635 498L635 498L634 498L634 497L633 497L633 496L632 496L632 496L631 496L630 496L629 495L628 494L627 494z"
        },
        {
            "title": "Wyra",
            "d": "M563 489L564 490L561 491L561 491L561 490L561 490L559 490L557 489L557 489L555 488L556 487L556 487L556 486L555 486L553 486L553 486L553 486L553 486L553 486L553 486L553 486L552 486L552 486L552 486L552 487L552 487L552 487L551 488L551 489L551 489L552 489L552 490L553 490L554 490L554 491L554 492L554 492L554 493L555 493L556 494L556 494L556 494L556 493L556 494L557 494L557 493L557 493L557 493L557 494L558 496L558 497L558 497L558 497L558 497L557 497L557 497L557 497L557 498L557 498L556 498L556 498L556 498L556 498L556 499L555 500L555 501L555 501L555 501L555 502L555 502L555 502L554 502L554 502L554 502L553 501L553 502L553 502L552 502L552 502L552 502L552 503L551 503L551 504L550 505L551 505L551 506L551 506L552 507L552 507L552 507L552 508L551 508L551 508L551 509L551 509L550 509L550 509L550 509L550 509L550 509L550 510L549 511L550 511L550 511L551 512L551 512L551 512L551 512L552 512L552 512L552 512L552 513L552 513L552 513L553 513L552 512L552 512L553 512L553 512L553 511L553 511L553 511L553 511L553 511L553 510L553 510L553 510L552 510L553 510L553 510L553 509L555 509L555 509L555 510L555 510L555 510L555 511L555 512L554 513L554 513L555 513L555 513L555 514L555 514L555 514L556 515L556 514L557 514L557 514L557 513L558 513L558 513L558 513L558 513L558 512L558 512L558 512L558 512L558 512L558 511L558 511L558 511L559 511L559 511L560 512L560 512L560 512L561 512L561 512L561 513L561 514L561 514L562 514L562 515L562 515L563 514L563 514L564 513L564 512L564 512L565 512L565 512L566 511L566 511L567 510L567 510L568 510L568 510L568 509L568 509L569 509L569 509L569 509L569 508L570 509L570 508L571 508L571 508L571 508L571 508L570 508L571 508L571 508L571 507L571 507L571 507L571 507L571 506L571 506L571 506L571 506L571 505L570 505L570 504L570 504L570 504L570 503L569 503L569 503L569 502L569 502L569 501L568 501L569 500L570 500L571 501L571 500L571 500L571 500L572 500L572 500L572 500L572 500L573 500L573 499L573 499L573 499L573 499L573 498L574 497L573 497L573 497L573 497L573 497L572 497L572 497L572 497L571 496L571 496L571 497L570 496L570 496L569 496L568 495L567 495L567 495L567 494L567 494L567 494L567 494L567 494L567 493L566 493L566 493L566 493L565 493L564 493L564 492L564 492L564 492L564 491L564 491L564 490L564 490L564 490L564 489L563 489z"
        },
        {
            "title": "Yerrupalem",
            "d": "M579 535L579 536L578 536L578 537L578 536L577 537L577 537L576 538L576 538L576 538L575 538L575 539L575 540L575 540L574 540L573 539L573 540L573 541L573 541L572 541L572 542L573 542L573 542L573 542L573 542L573 543L573 544L573 544L572 545L572 547L572 547L572 547L573 547L573 547L573 548L574 548L574 549L575 549L575 549L575 551L574 551L574 552L573 552L573 552L573 552L573 552L573 552L573 552L573 552L573 552L573 552L573 553L574 553L574 554L575 554L576 555L577 555L577 555L577 555L578 555L578 556L578 558L578 558L578 560L580 560L581 560L582 561L583 562L583 562L585 563L587 563L588 563L591 563L592 563L593 563L594 564L595 564L596 564L597 562L597 562L598 562L598 562L598 562L599 561L599 561L599 561L599 561L600 561L600 560L601 560L602 560L602 560L602 560L602 560L602 560L602 560L601 559L600 559L600 559L600 559L599 558L599 558L598 557L598 557L598 557L597 556L597 556L597 555L596 554L596 554L595 554L594 554L594 553L594 552L595 551L595 551L595 550L596 549L596 549L595 548L595 547L595 547L596 546L597 545L598 545L599 545L599 545L600 544L600 544L599 542L600 542L599 542L599 542L598 541L598 541L598 541L599 540L600 539L601 538L601 538L600 538L600 538L600 538L600 537L599 537L599 538L599 538L599 537L599 537L599 537L598 537L598 537L598 537L597 536L597 536L597 536L597 536L597 535L597 535L597 535L596 535L596 535L596 535L595 534L593 533L592 532L589 531L589 531L589 531L588 533L588 533L588 533L588 533L585 532L585 532L583 532L583 533L583 534L583 536L583 536L583 537L582 536L581 536L580 536L580 535L579 535z"
        }
    ],
    "Warangal": [
        {
            "title": "Chennaraopet",
            "d": "M469 367L469 367L469 367L468 367L467 367L467 368L467 369L466 370L465 371L465 371L466 372L466 372L467 374L467 374L467 375L469 375L469 375L472 375L472 374L473 373L473 372L474 372L476 372L476 373L476 373L476 374L476 374L476 375L476 376L475 377L475 378L475 379L474 381L474 381L474 381L474 381L473 382L473 383L473 383L473 383L473 384L473 385L473 385L473 386L473 387L473 387L474 386L474 386L474 386L475 387L476 386L476 386L476 386L477 386L477 386L478 385L478 385L479 384L479 384L480 385L480 385L480 385L480 385L481 385L481 385L483 384L484 384L484 384L485 384L486 384L487 384L487 384L487 384L487 385L487 386L487 386L487 387L488 387L488 386L488 386L489 385L489 384L489 384L490 383L490 383L490 383L490 382L491 382L491 380L491 380L491 379L492 379L491 379L491 379L491 378L490 378L490 378L490 378L490 378L490 378L489 378L489 378L489 378L488 378L487 378L486 377L486 377L486 377L486 376L485 376L485 376L485 376L484 376L484 375L483 375L483 374L483 374L483 374L483 373L483 373L483 372L483 372L482 372L482 372L482 372L481 372L481 372L481 372L480 372L481 371L480 371L480 371L480 369L479 369L479 369L477 368L477 367L477 367L477 368L476 370L475 369L474 369L474 369L474 368L473 368L472 368L471 368L470 368L469 367L469 367z"
        },
        {
            "title": "Duggondi",
            "d": "M471 338L469 338L468 338L468 338L468 339L468 339L468 339L468 339L468 340L468 340L468 340L468 340L468 340L468 341L468 341L468 341L467 341L468 341L468 341L468 341L468 341L468 342L468 342L468 343L468 343L468 344L467 344L466 343L466 344L465 343L465 343L465 343L465 343L465 343L465 342L464 342L463 342L463 343L463 343L462 343L462 344L462 345L462 345L461 345L461 346L460 346L460 346L460 347L460 348L460 348L460 348L460 348L461 348L461 348L461 348L461 348L462 348L461 349L462 349L462 349L462 349L462 349L462 350L462 350L463 350L463 350L463 351L463 351L464 352L464 353L464 353L464 353L464 353L464 354L464 354L464 355L464 355L464 355L464 356L464 356L465 357L465 357L465 357L466 357L466 358L466 358L466 358L466 358L466 358L466 358L466 358L466 358L466 359L466 359L466 359L467 359L467 359L467 359L467 360L467 361L467 362L466 362L465 363L464 363L464 363L465 365L467 367L468 367L469 367L469 367L469 367L469 367L469 366L469 366L469 365L469 364L470 363L470 363L471 363L471 363L471 363L471 363L471 363L471 362L471 362L471 362L471 362L471 362L471 362L470 362L470 362L470 361L470 361L470 361L470 360L470 360L470 360L471 360L471 360L472 360L472 360L472 360L472 360L472 361L472 361L473 360L473 360L473 361L474 361L474 361L474 361L474 361L474 360L475 360L475 360L475 360L475 359L476 359L477 359L478 359L478 359L478 359L479 358L480 358L480 358L480 357L480 357L480 357L480 357L479 357L479 357L478 357L478 357L478 357L478 356L477 356L477 356L477 356L477 355L476 355L477 354L477 353L477 352L477 352L477 353L478 352L478 352L478 352L478 351L478 350L478 350L478 349L478 349L479 348L478 347L477 347L477 346L477 346L477 346L477 346L474 345L474 344L474 343L474 343L474 342L474 342L474 342L474 342L474 342L473 342L473 341L473 341L473 341L473 341L472 341L472 341L472 341L471 341L471 340L471 340L471 340L470 340L470 340L470 340L471 339L471 338z"
        },
        {
            "title": "Geesugonda",
            "d": "M450 350L450 350L450 350L449 350L449 350L449 350L449 350L449 350L449 350L449 350L449 350L449 349L449 349L448 349L448 349L448 348L448 347L448 347L447 347L447 347L447 347L446 347L446 347L446 347L446 347L446 347L446 347L446 347L446 347L446 347L446 348L445 347L445 348L446 348L445 348L445 348L445 349L445 349L444 349L444 350L443 350L442 349L442 349L442 350L442 350L442 351L443 351L443 351L443 351L443 353L443 353L443 353L442 354L442 354L441 354L440 354L440 355L439 355L439 355L439 355L440 356L440 356L441 357L441 357L442 357L443 357L443 357L443 357L443 357L444 357L444 357L444 357L444 357L444 357L444 357L444 358L444 358L443 358L443 358L443 358L443 358L443 359L442 359L443 359L443 359L443 359L443 359L443 359L443 360L443 360L443 360L444 360L444 361L444 361L444 360L445 361L445 361L445 361L445 362L445 362L445 364L445 364L445 364L446 365L446 365L447 365L447 365L447 365L447 365L447 367L447 368L448 368L448 368L448 368L449 368L449 368L449 368L449 368L449 368L450 369L450 369L450 369L451 369L451 369L452 369L453 368L453 368L453 368L453 368L453 367L454 367L454 367L454 366L454 366L454 365L454 365L454 364L455 364L455 364L455 364L455 364L455 364L455 364L456 363L456 363L456 363L456 363L456 363L456 362L456 362L456 361L456 361L456 361L457 361L457 361L457 361L458 361L459 361L460 362L461 363L461 363L464 363L464 363L465 363L466 362L467 362L467 361L467 360L467 359L467 359L467 359L466 359L466 359L466 359L466 358L466 358L466 358L466 358L466 358L466 358L466 358L466 358L466 357L465 357L465 357L465 357L464 356L464 356L464 355L464 355L464 355L464 354L464 354L464 353L464 353L464 353L464 353L464 352L463 351L463 351L463 350L463 350L462 350L462 350L462 349L462 349L462 349L462 349L461 349L462 348L461 348L461 348L461 348L461 348L460 348L460 348L460 348L460 348L460 349L459 349L459 349L459 349L459 349L459 349L459 349L459 349L459 349L458 349L458 349L458 350L458 350L458 350L457 351L456 351L455 352L455 352L455 351L454 352L454 352L454 352L454 352L454 352L453 352L453 352L453 352L453 351L451 351L451 351L451 351L451 350L450 350L450 350L450 350z"
        },
        {
            "title": "Khanapur",
            "d": "M500 373L500 371L500 371L500 371L500 370L500 369L502 367L502 367L503 367L502 366L502 365L501 363L500 361L499 360L499 360L499 359L500 358L500 357L499 356L499 355L500 354L500 353L500 349L500 349L499 349L498 349L495 348L495 349L493 350L493 350L490 350L491 351L490 352L491 353L491 354L492 354L491 355L491 356L493 358L492 358L492 359L492 359L492 360L491 360L491 361L491 361L490 361L490 362L491 362L491 362L490 362L490 363L490 363L490 362L490 362L490 363L489 363L489 363L489 363L489 363L489 363L489 364L489 364L489 364L489 364L488 364L488 365L488 365L488 365L488 365L488 365L489 365L489 365L489 365L489 366L489 366L488 367L488 367L487 367L486 367L486 368L486 369L485 369L485 369L485 369L485 369L485 370L484 370L484 370L484 370L483 370L483 371L483 371L483 371L483 372L483 372L483 372L483 373L483 373L483 374L483 374L483 374L483 375L484 375L484 376L485 376L485 376L485 376L486 376L486 377L486 377L486 377L487 378L488 378L489 378L489 378L489 378L490 378L490 378L490 378L490 378L490 378L491 378L491 379L491 379L492 379L492 379L492 379L493 380L493 380L493 380L493 380L493 380L493 379L494 379L494 378L494 377L494 376L494 376L494 376L494 375L495 375L495 375L495 375L496 375L499 376L499 375L500 374L500 373z"
        },
        {
            "title": "Khila Warangal",
            "d": "M439 355L439 356L439 356L438 356L439 356L439 356L438 356L438 356L438 356L437 356L435 356L435 356L435 356L435 355L435 355L435 355L434 355L434 354L434 354L434 354L434 354L434 354L434 354L433 354L433 354L433 354L433 354L433 354L433 355L433 355L433 355L433 355L433 355L433 355L433 355L432 356L432 355L432 356L431 356L431 356L431 356L430 357L431 357L431 358L431 358L431 358L431 359L431 359L431 360L431 360L431 361L430 361L431 362L430 362L431 362L431 363L431 363L431 363L431 363L431 364L430 363L429 363L429 363L429 363L428 363L428 364L429 364L429 365L429 365L429 366L430 366L431 367L433 369L434 369L435 369L435 370L434 371L435 371L435 372L436 372L437 373L437 373L439 374L439 374L439 374L439 373L439 373L440 373L440 373L440 373L440 373L440 373L440 372L440 372L441 371L440 371L440 370L440 370L440 370L441 370L441 370L442 369L442 369L443 368L443 368L444 368L444 368L444 367L444 366L444 366L444 365L444 365L445 364L445 364L445 364L445 362L445 362L445 361L445 361L445 361L444 360L444 361L444 361L444 360L443 360L443 360L443 360L443 359L443 359L443 359L443 359L443 359L442 359L443 359L443 358L443 358L443 358L443 358L444 358L444 358L444 357L444 357L444 357L444 357L444 357L444 357L443 357L443 357L443 357L443 357L442 357L441 357L441 357L440 356L440 356L439 355z"
        },
        {
            "title": "Nallabelli",
            "d": "M509 333L508 332L508 332L508 332L507 332L505 332L505 332L507 335L502 338L501 336L498 333L498 333L497 334L497 334L496 336L496 336L495 336L495 336L494 337L491 337L490 337L484 337L484 337L482 336L483 335L479 336L479 335L478 335L478 335L476 335L476 335L476 335L474 335L472 335L472 335L471 336L471 338L471 339L470 340L470 340L470 340L471 340L471 340L471 340L471 341L472 341L472 341L472 341L473 341L473 341L473 341L473 341L473 342L474 342L474 342L474 342L474 342L474 342L474 343L474 343L474 344L474 345L477 346L477 346L477 346L477 346L477 347L478 347L479 348L481 349L481 349L481 349L481 350L481 350L481 350L481 350L482 350L482 351L483 351L484 352L484 353L484 353L485 353L485 353L485 353L485 353L485 352L485 352L485 352L485 352L485 351L485 351L485 351L485 350L485 350L486 350L486 351L486 351L488 350L489 350L489 350L490 350L493 350L493 350L495 349L495 348L498 349L499 349L500 349L502 346L502 344L502 342L503 342L505 338L506 336L508 334L509 333L509 333z"
        },
        {
            "title": "Narsampet",
            "d": "M490 350L489 350L489 350L488 350L486 351L486 351L486 350L485 350L485 350L485 351L485 351L485 351L485 352L485 352L485 352L485 352L485 353L485 353L485 353L485 353L484 353L484 353L484 352L483 351L482 351L482 350L481 350L481 350L481 350L481 350L481 349L481 349L481 349L479 348L478 349L478 349L478 350L478 350L478 351L478 352L478 352L478 352L477 353L477 352L477 352L477 353L477 354L476 355L477 355L477 356L477 356L477 356L478 356L478 357L478 357L478 357L479 357L479 357L480 357L480 357L480 357L480 357L480 358L480 358L479 358L478 359L478 359L478 359L477 359L476 359L475 359L475 360L475 360L475 360L474 360L474 361L474 361L474 361L474 361L473 361L473 360L473 360L472 361L472 361L472 360L472 360L472 360L472 360L471 360L471 360L470 360L470 360L470 360L470 361L470 361L470 361L470 362L470 362L471 362L471 362L471 362L471 362L471 362L471 362L471 363L471 363L471 363L471 363L471 363L470 363L470 363L469 364L469 365L469 366L469 366L469 367L469 367L469 367L470 368L471 368L472 368L473 368L474 368L474 369L474 369L475 369L476 370L477 368L477 367L477 367L477 368L479 369L479 369L480 369L480 371L480 371L481 371L480 372L481 372L481 372L481 372L482 372L482 372L482 372L483 372L483 372L483 371L483 371L483 371L483 370L484 370L484 370L484 370L485 370L485 369L485 369L485 369L485 369L486 369L486 368L486 367L487 367L488 367L488 367L489 366L489 366L489 365L489 365L489 365L488 365L488 365L488 365L488 365L488 365L488 364L489 364L489 364L489 364L489 364L489 363L489 363L489 363L489 363L489 363L490 363L490 362L490 362L490 363L490 363L490 362L491 362L491 362L490 362L490 361L491 361L491 361L491 360L492 360L492 359L492 359L492 358L493 358L491 356L491 355L492 354L491 354L491 353L490 352L491 351L490 350z"
        },
        {
            "title": "Nekkonda",
            "d": "M481 385L481 385L480 385L480 385L480 385L480 385L479 384L479 384L478 385L478 385L477 386L477 386L476 386L476 386L476 386L475 387L474 386L474 386L474 386L473 387L473 387L473 386L473 385L473 385L473 384L473 383L473 383L473 383L473 382L474 381L474 381L474 381L474 381L475 379L475 378L475 377L476 376L476 375L476 374L476 374L476 373L476 373L476 372L474 372L473 372L473 373L472 374L472 375L469 375L469 375L467 375L467 374L467 374L466 372L465 373L464 373L464 373L463 374L462 374L462 375L462 375L462 375L463 375L463 375L463 376L464 376L463 377L463 377L462 378L461 378L460 379L461 379L461 379L462 379L462 379L462 380L462 380L462 380L462 380L463 381L463 381L463 381L463 382L464 382L463 383L463 384L463 384L464 385L465 385L465 385L466 385L465 385L465 386L465 387L465 387L465 388L465 388L465 389L465 390L465 390L465 391L465 391L465 392L465 393L465 393L465 393L465 393L463 393L463 393L463 394L462 396L462 397L462 398L462 398L461 399L460 400L460 401L460 401L460 402L460 403L461 402L462 402L462 402L463 402L463 403L463 404L464 404L465 403L465 403L466 402L468 402L468 402L469 403L471 403L471 403L472 404L472 404L472 404L472 404L472 402L472 402L472 401L472 402L473 401L473 401L474 401L474 401L475 401L475 400L475 400L477 400L477 400L477 400L479 400L479 399L478 399L478 399L478 399L478 398L478 398L479 398L479 397L480 397L480 397L480 397L480 397L480 397L481 397L481 398L481 398L482 398L482 398L483 398L483 397L483 397L484 397L485 397L485 396L485 395L485 394L486 394L486 393L486 393L486 391L486 391L486 391L486 391L486 391L485 391L484 391L482 390L482 390L482 389L482 388L482 387L481 386L481 385z"
        },
        {
            "title": "Parvathagiri",
            "d": "M460 379L459 379L459 378L459 378L458 379L458 379L458 379L458 379L457 380L457 380L457 380L457 380L457 381L456 380L456 381L456 381L456 381L456 381L456 381L454 381L454 381L454 381L453 381L453 380L453 380L451 381L450 381L450 381L450 381L449 381L449 382L448 382L448 382L448 382L448 382L447 382L446 381L445 382L445 382L444 382L444 382L443 382L443 382L443 382L443 384L443 384L444 385L444 385L445 385L445 385L445 386L446 386L446 386L446 386L446 387L446 387L446 387L445 388L446 388L445 389L445 389L445 390L445 390L446 390L446 391L446 391L446 391L446 391L446 392L446 393L446 393L447 393L448 393L448 394L449 394L449 394L449 394L450 395L450 396L451 396L452 396L451 397L451 398L451 399L451 399L451 399L451 399L451 399L450 400L450 400L450 400L449 402L449 402L448 404L448 404L448 404L449 405L450 405L450 405L450 406L451 406L452 406L452 406L453 406L453 406L453 406L453 406L453 406L453 406L454 406L454 406L454 406L454 405L455 404L455 404L455 403L455 403L456 403L456 404L456 404L457 404L458 405L459 405L460 405L461 405L463 404L463 404L463 403L463 402L462 402L462 402L461 402L460 403L460 402L460 401L460 401L460 400L461 399L462 398L462 398L462 397L462 396L463 394L463 393L463 393L465 393L465 393L465 393L465 393L465 392L465 391L465 391L465 390L465 390L465 389L465 388L465 388L465 387L465 387L465 386L465 385L466 385L465 385L465 385L464 385L463 384L463 384L463 383L464 382L463 382L463 381L463 381L463 381L462 380L462 380L462 380L462 380L462 379L462 379L461 379L461 379L460 379z"
        },
        {
            "title": "Raiparthy",
            "d": "M446 393L446 393L445 392L445 392L445 392L444 393L444 393L443 393L443 394L443 394L442 395L442 395L442 396L443 396L443 396L443 396L443 397L443 398L443 398L443 399L442 399L442 399L442 399L441 399L441 399L441 399L440 399L440 399L439 398L439 398L437 398L437 397L437 397L437 398L433 397L433 397L433 397L433 396L433 396L432 396L430 397L430 398L429 398L429 399L427 399L425 398L424 399L424 400L425 400L425 401L425 401L424 403L423 403L424 404L423 403L423 404L422 403L422 403L421 403L421 403L421 403L421 403L421 402L421 402L420 401L419 400L419 400L418 400L417 401L417 401L416 401L416 402L417 403L417 403L417 404L417 404L416 407L416 407L416 407L417 408L417 408L417 409L417 409L417 409L419 409L419 410L420 410L421 410L421 409L422 410L423 411L423 412L423 413L423 413L423 413L423 413L423 414L423 414L425 415L425 414L426 413L426 413L426 414L426 415L427 416L429 417L430 417L431 417L431 417L432 417L432 416L433 415L434 415L434 415L435 415L436 414L437 415L438 416L438 416L439 416L440 416L441 416L441 416L442 417L442 417L442 417L442 417L442 417L443 416L443 416L443 416L443 416L443 416L443 416L443 416L444 416L445 414L445 413L446 412L446 411L447 412L448 412L449 410L449 409L449 408L450 407L450 407L451 406L450 406L450 405L450 405L449 405L448 404L448 404L448 404L449 402L449 402L450 400L450 400L450 400L451 399L451 399L451 399L451 399L451 399L451 398L451 397L452 396L451 396L450 396L450 395L449 394L449 394L449 394L448 394L448 393L447 393L446 393L446 393z"
        },
        {
            "title": "Sangem",
            "d": "M464 363L461 363L461 363L460 362L459 361L458 361L457 361L457 361L457 361L456 361L456 361L456 361L456 362L456 362L456 363L456 363L456 363L456 363L456 363L455 364L455 364L455 364L455 364L455 364L455 364L454 364L454 365L454 365L454 366L454 366L454 367L454 367L453 367L453 368L453 368L453 368L453 368L452 369L451 369L451 369L450 369L450 369L450 369L449 368L449 368L449 368L449 368L449 368L448 368L448 368L448 368L447 368L447 367L447 365L447 365L447 365L447 365L446 365L446 365L445 364L445 364L445 364L444 365L444 365L444 366L444 366L444 367L444 368L444 368L443 368L443 368L442 369L442 369L441 370L441 370L440 370L440 370L440 370L440 371L441 371L440 372L440 372L440 373L440 373L441 373L441 373L441 373L441 373L441 373L442 373L443 374L443 374L443 374L443 376L443 376L443 376L442 376L442 377L442 378L442 378L442 378L442 378L442 379L441 379L442 379L441 380L442 380L442 381L442 382L443 382L443 382L443 382L444 382L444 382L445 382L445 382L446 381L447 382L448 382L448 382L448 382L448 382L449 382L449 381L450 381L450 381L450 381L451 381L453 380L453 380L453 381L454 381L454 381L454 381L456 381L456 381L456 381L456 381L456 381L456 380L457 381L457 380L457 380L457 380L457 380L458 379L458 379L458 379L458 379L459 378L459 378L459 379L460 379L461 378L462 378L463 377L463 377L464 376L463 376L463 375L463 375L462 375L462 375L462 375L462 374L463 374L464 373L464 373L465 373L466 372L466 372L465 371L465 371L466 370L467 369L467 368L467 367L465 365L464 363z"
        },
        {
            "title": "Warangal",
            "d": "M448 347L448 346L448 346L448 346L447 346L447 346L447 345L446 345L446 345L445 345L444 344L444 345L443 345L443 345L442 345L441 345L440 344L440 345L439 345L439 346L438 346L437 346L436 346L436 346L436 345L436 345L436 345L436 345L435 345L435 346L436 347L435 348L435 348L435 349L435 351L434 352L434 352L434 352L434 353L434 353L434 353L434 354L434 354L434 354L434 354L434 355L435 355L435 355L435 355L435 356L435 356L435 356L437 356L438 356L438 356L438 356L439 356L439 356L438 356L439 356L439 356L439 355L439 355L439 355L440 355L440 354L441 354L442 354L442 354L443 353L443 353L443 353L443 351L443 351L443 351L442 351L442 350L442 350L442 349L442 349L443 350L444 350L444 349L445 349L445 349L445 348L445 348L446 348L445 348L445 347L446 348L446 347L446 347L446 347L446 347L446 347L446 347L446 347L446 347L446 347L447 347L447 347L447 347L448 347z"
        },
        {
            "title": "Wardhannapet",
            "d": "M443 382L442 382L442 381L442 380L441 380L442 379L441 379L442 379L442 378L442 378L442 378L442 378L442 377L442 376L443 376L443 376L443 376L443 374L443 374L443 374L442 373L441 373L441 373L441 373L441 373L441 373L440 373L440 373L440 373L440 373L439 373L439 373L439 374L439 374L439 374L439 374L439 374L439 374L439 374L439 375L439 375L438 376L438 376L438 377L439 378L439 380L439 380L439 380L439 381L439 381L439 381L439 381L438 382L438 382L437 382L436 382L436 382L436 382L435 382L434 380L433 381L433 383L432 383L432 383L431 384L430 384L430 384L430 384L430 384L429 384L429 385L429 386L429 387L429 386L429 387L429 387L428 388L428 388L428 388L427 388L426 388L425 388L424 387L424 387L423 387L423 387L423 387L422 387L422 387L422 387L422 387L422 387L421 388L422 390L421 390L422 390L421 391L421 392L420 394L420 395L417 393L417 394L416 395L417 395L417 396L418 396L419 398L420 398L419 400L420 401L421 402L421 402L421 403L421 403L421 403L421 403L422 403L422 403L423 404L423 403L424 404L423 403L424 403L425 401L425 401L425 400L424 400L424 399L425 398L427 399L429 399L429 398L430 398L430 397L432 396L433 396L433 396L433 397L433 397L433 397L437 398L437 397L437 397L437 398L439 398L439 398L440 399L440 399L441 399L441 399L441 399L442 399L442 399L442 399L443 399L443 398L443 398L443 397L443 396L443 396L443 396L442 396L442 395L442 395L443 394L443 394L443 393L444 393L444 393L445 392L445 392L445 392L446 393L446 393L446 392L446 391L446 391L446 391L446 391L446 390L445 390L445 390L445 389L445 389L446 388L445 388L446 387L446 387L446 387L446 386L446 386L446 386L445 386L445 385L445 385L444 385L444 385L443 384L443 384L443 382z"
        }
    ],
    "Karimnagar": [
        {
            "title": "Chigurumamidi",
            "d": "M380 307L378 306L377 306L376 305L375 305L375 305L375 305L374 305L373 306L372 305L372 305L371 304L371 304L371 304L371 304L371 304L371 304L371 303L371 303L370 303L370 303L370 303L370 302L370 302L370 302L369 302L369 301L369 301L369 301L369 301L369 302L368 302L367 302L367 302L367 302L367 302L366 302L366 302L365 302L365 302L364 302L364 303L364 303L364 303L363 303L362 302L361 303L359 304L359 304L359 305L359 305L359 306L358 306L358 306L357 306L357 307L357 307L357 307L358 308L358 308L358 308L358 308L358 308L358 308L358 309L358 309L358 309L358 309L357 309L357 309L356 309L356 309L356 310L356 310L355 310L355 311L355 311L355 311L355 312L355 312L355 312L355 313L355 313L356 313L356 314L356 314L356 314L356 314L356 314L356 314L357 314L357 314L358 314L358 314L358 314L359 314L359 315L359 315L360 315L360 315L360 315L360 315L360 316L361 316L361 316L361 316L362 316L362 316L362 316L362 316L362 317L362 317L361 319L361 319L361 319L361 319L362 320L362 320L362 320L362 320L362 321L363 322L363 322L363 322L364 323L365 323L365 323L365 323L365 323L366 323L366 322L366 322L367 322L367 321L367 322L367 321L367 321L367 321L368 321L368 321L368 322L368 322L368 322L368 322L369 322L369 323L370 323L370 323L370 323L371 323L371 323L371 323L372 323L372 323L372 323L372 323L372 321L373 320L373 320L374 320L374 320L374 320L375 320L375 320L375 320L377 320L378 319L378 319L378 318L378 318L379 318L379 317L379 317L379 317L379 317L380 316L380 316L380 316L379 315L379 315L379 314L379 314L379 314L379 314L379 314L379 313L379 313L379 313L379 313L379 312L379 312L379 311L379 310L379 310L379 309L379 309L379 309L380 308L380 307z"
        },
        {
            "title": "Choppadandi",
            "d": "M359 236L359 236L358 236L358 236L357 236L357 236L357 236L357 236L357 236L357 236L357 237L356 236L357 237L356 237L357 237L357 237L357 237L357 238L357 238L357 238L357 238L356 238L357 238L356 239L356 239L356 240L356 240L356 240L356 240L356 241L356 242L356 242L356 242L356 243L356 244L356 244L356 244L356 244L357 244L357 244L357 245L357 245L357 245L357 245L357 246L358 246L358 246L358 246L359 247L360 247L360 247L360 247L359 248L358 248L356 249L356 249L355 249L355 249L355 249L355 250L355 251L355 251L355 251L356 252L355 253L355 254L354 255L354 256L354 257L354 257L354 257L354 257L355 257L355 258L355 259L355 260L356 260L357 261L358 261L358 261L359 260L359 259L360 260L362 261L363 261L364 262L365 261L365 261L365 260L365 260L365 260L367 261L367 260L368 260L368 260L368 259L368 259L368 259L369 259L369 258L369 258L369 258L369 258L370 258L370 258L370 258L370 258L370 259L371 259L371 259L371 259L372 259L373 259L374 259L374 258L375 257L375 257L375 257L376 254L376 253L376 253L375 253L374 253L374 253L374 253L372 251L372 249L372 248L371 248L371 248L370 247L370 247L370 247L369 246L369 246L368 246L368 245L368 245L368 244L368 243L368 243L368 242L368 242L368 242L368 242L368 241L368 241L368 241L368 240L368 240L368 240L368 239L368 239L368 239L368 239L368 238L368 238L368 238L368 238L368 238L368 238L367 238L367 238L367 238L366 238L366 239L366 239L366 239L366 239L366 239L366 239L365 239L365 239L365 239L364 240L364 240L363 239L362 239L362 239L362 239L362 239L362 238L361 237L361 237L360 236L360 236L360 236L359 236z"
        },
        {
            "title": "Ellandakunta",
            "d": "M432 287L432 287L432 287L431 287L430 287L430 287L430 287L430 287L429 287L429 287L428 287L427 286L426 286L426 286L426 286L426 286L426 286L425 287L425 287L425 287L425 287L424 287L424 288L424 289L424 290L424 290L424 291L424 291L423 292L423 293L423 294L423 294L423 294L422 294L422 294L422 295L422 294L422 295L422 295L421 296L421 296L420 297L420 297L420 297L420 297L420 298L420 298L420 299L420 299L420 299L420 300L419 302L419 302L418 302L418 302L418 302L417 302L417 302L417 302L417 303L417 303L417 303L416 303L416 303L417 303L417 303L417 303L417 303L418 303L419 304L420 305L420 305L420 306L420 306L420 306L420 307L419 308L419 308L419 309L419 310L419 311L419 312L420 312L421 312L421 312L421 311L421 311L421 311L421 310L422 311L422 310L422 310L422 310L422 310L423 310L423 310L423 310L423 310L424 310L424 310L424 311L426 311L426 310L428 309L428 308L428 307L428 307L428 306L428 306L429 305L429 305L430 306L430 306L431 304L431 303L431 302L431 302L430 302L430 302L430 302L430 302L430 301L430 301L430 300L430 300L430 298L431 298L431 298L431 298L432 298L432 297L432 297L432 296L432 296L432 295L432 294L432 294L432 294L432 293L433 292L433 291L433 290L432 290L433 290L432 290L432 289L432 289L432 289L432 289L433 288L432 288L432 288L432 288L432 288L432 287z"
        },
        {
            "title": "Gangadhara",
            "d": "M336 278L336 279L336 278L337 278L337 277L338 277L338 277L339 276L339 276L339 276L339 276L339 276L339 276L339 275L339 275L339 275L338 275L338 275L338 275L338 274L337 274L337 274L337 274L336 274L336 274L336 274L334 274L334 275L334 274L334 275L334 275L334 275L334 275L334 275L334 276L334 276L333 276L333 276L333 276L333 276L333 277L334 277L334 278L334 278L335 278L335 278L336 278L336 278L336 278zM351 238L351 238L351 238L350 238L350 238L350 237L350 238L350 237L350 237L349 237L349 237L348 237L349 236L348 236L349 235L348 236L348 235L348 235L348 235L348 235L348 235L348 235L348 235L347 235L347 235L347 235L347 235L347 235L347 236L347 236L347 236L347 237L347 237L346 237L346 238L346 238L346 238L346 238L346 239L346 239L346 239L346 239L346 241L346 241L347 241L347 241L348 241L348 241L348 241L348 241L348 242L349 242L349 243L349 243L349 243L349 243L350 243L350 243L351 242L351 241L351 240L352 239L352 239L352 239L352 238L351 238zM344 240L344 240L344 240L344 240L344 239L344 239L344 238L344 238L343 238L342 238L342 238L342 238L342 238L342 238L342 237L341 238L341 238L341 238L341 238L341 238L341 237L341 237L341 237L341 236L341 236L341 236L341 235L341 234L340 234L339 233L339 233L338 234L337 234L337 234L337 234L337 234L337 234L337 234L336 235L336 235L336 235L336 235L336 236L336 236L336 236L335 236L335 236L335 236L335 236L335 237L336 237L336 237L336 237L336 237L336 238L336 238L336 238L336 238L336 238L336 239L336 239L335 239L335 239L335 239L335 239L335 240L335 240L335 240L335 240L335 240L335 240L335 241L334 242L334 243L333 244L333 245L333 245L333 245L333 245L333 245L333 246L333 246L333 246L333 246L333 247L334 247L334 247L334 247L334 248L334 248L334 248L334 248L335 248L335 249L335 249L335 250L335 250L336 250L336 250L336 250L336 250L336 251L336 251L336 251L335 252L335 252L334 252L334 251L334 251L333 251L333 251L333 251L331 251L331 251L331 252L331 252L330 253L330 254L330 255L330 255L330 255L331 256L331 257L331 257L331 257L331 257L331 257L331 258L331 258L332 258L331 259L331 260L330 260L330 261L330 262L331 262L331 262L331 262L332 262L333 263L333 264L335 265L335 265L335 265L335 266L335 267L335 267L335 268L335 268L335 268L335 269L336 269L336 269L336 269L337 269L338 269L338 269L338 269L339 269L339 268L339 268L339 267L340 268L340 268L341 268L341 269L341 269L341 268L342 268L342 268L342 268L343 268L343 268L343 268L343 267L344 266L344 265L344 265L344 265L344 264L344 263L344 262L344 262L343 262L342 261L342 261L342 261L342 261L341 261L342 259L342 259L342 258L342 257L342 257L343 256L343 256L343 256L344 254L344 253L344 253L343 253L343 253L343 252L343 252L343 252L343 251L343 251L343 251L343 251L343 250L343 250L343 250L344 249L345 249L345 249L345 249L345 249L345 249L345 249L345 249L345 248L345 248L345 247L345 247L345 246L345 245L345 245L345 245L345 244L345 244L345 244L345 244L344 244L345 244L344 243L345 243L344 243L344 243L344 242L344 242L344 242L344 242L344 241L344 240z"
        },
        {
            "title": "Ganneruvaram",
            "d": "M356 301L356 299L357 298L357 297L357 297L357 297L357 297L357 297L356 296L356 296L355 296L355 296L355 296L355 296L355 296L354 296L355 295L355 293L355 293L356 292L356 292L356 292L356 292L356 293L356 293L356 292L356 292L357 292L357 292L357 291L357 292L357 291L357 291L358 291L358 291L358 291L358 291L358 291L358 290L358 290L357 290L357 290L358 289L358 289L358 289L359 289L360 289L360 290L360 290L360 290L360 290L361 290L362 290L362 290L363 290L363 289L363 289L363 289L364 289L364 289L363 288L363 286L363 286L363 285L362 285L361 284L359 284L358 283L359 283L359 282L358 282L357 282L356 281L354 280L352 280L351 278L351 277L351 277L349 278L347 278L346 279L344 281L343 281L341 281L341 282L340 283L339 283L339 284L339 284L339 284L339 285L339 285L339 285L340 285L340 285L341 286L341 286L342 287L342 287L341 288L340 289L340 290L340 291L339 292L339 293L340 293L340 293L340 293L341 294L341 294L341 294L341 294L341 294L342 293L342 293L342 292L342 292L343 292L343 292L343 292L343 292L343 291L345 292L345 291L345 291L345 291L345 291L345 291L346 292L346 291L347 291L347 291L347 291L347 291L347 291L347 291L347 291L347 292L347 293L347 294L347 295L347 295L348 295L348 295L348 295L349 296L349 296L349 296L349 297L349 297L349 297L348 298L348 298L348 298L348 298L348 299L347 300L349 301L350 301L350 301L350 301L351 301L351 301L352 301L352 301L352 301L352 301L353 301L353 301L354 301L354 301L354 301L355 301L355 301L356 301z"
        },
        {
            "title": "Huzurabad",
            "d": "M405 302L404 302L404 302L404 302L404 302L403 302L403 302L403 303L403 303L403 303L403 303L403 303L403 303L402 303L402 303L402 303L402 304L402 304L402 304L402 304L402 305L402 305L402 305L402 306L402 306L402 306L401 306L401 306L401 306L401 307L398 306L398 306L397 306L397 306L397 306L396 306L396 306L396 307L396 307L395 308L395 309L394 310L394 311L394 311L394 311L393 311L393 312L393 312L393 312L394 312L394 312L394 312L394 312L395 312L395 312L395 312L395 312L395 313L397 313L398 313L399 314L399 314L399 314L399 314L399 314L399 315L399 315L399 316L398 318L399 319L399 319L399 320L399 320L399 320L399 321L398 321L398 322L398 322L398 322L398 323L398 323L399 324L399 324L399 324L399 324L399 325L400 325L400 325L401 325L401 325L402 325L402 325L402 323L403 323L403 323L403 323L404 323L404 323L404 323L405 323L405 322L405 322L405 322L406 322L406 322L406 322L406 322L406 322L406 322L407 323L407 324L407 324L408 324L409 324L409 324L409 324L410 324L410 324L410 324L411 324L411 324L411 324L411 324L411 324L412 324L413 323L413 322L413 322L413 322L413 321L414 321L413 320L413 320L414 320L414 320L414 320L415 320L415 319L415 319L416 318L416 318L416 318L416 318L415 317L415 317L415 317L414 316L414 315L414 315L415 315L415 315L415 315L415 314L415 313L416 313L416 313L416 313L416 312L417 313L417 313L417 312L417 312L417 312L417 311L417 310L416 310L415 309L415 309L415 309L415 308L415 308L414 308L414 307L414 306L414 306L414 306L414 306L414 306L414 306L413 305L413 305L412 305L412 305L411 305L411 305L411 305L410 305L410 305L409 305L408 305L408 305L408 305L407 304L407 304L407 304L407 304L407 304L407 304L406 303L406 303L406 303L406 303L406 303L405 302L405 302L405 302L405 302z"
        },
        {
            "title": "Jammikunta",
            "d": "M432 287L432 287L432 287L433 285L433 284L433 284L433 284L432 284L432 284L432 284L433 283L433 282L433 282L433 282L433 282L433 282L433 281L433 281L433 280L433 280L433 280L433 280L433 280L432 280L432 280L432 279L432 279L432 280L431 279L431 279L431 279L432 279L431 279L432 279L431 278L429 280L429 280L427 282L426 282L425 283L423 283L423 283L422 283L421 283L421 283L419 284L418 284L417 285L416 285L416 285L415 285L415 286L414 286L414 287L414 288L413 288L413 289L413 289L414 289L414 289L413 290L413 290L413 290L412 290L412 290L411 290L411 291L411 291L411 291L410 292L410 292L410 293L410 293L410 293L412 294L411 294L412 295L412 295L412 295L412 295L412 295L413 296L413 296L413 296L413 296L413 296L413 296L413 297L413 297L412 297L412 297L412 298L411 297L411 298L411 298L411 298L410 298L410 298L410 298L410 298L409 298L409 298L408 298L408 298L408 298L408 298L407 298L407 298L407 298L407 298L407 298L407 298L407 298L406 298L406 298L406 299L406 299L406 299L405 300L406 300L405 301L405 301L405 301L405 301L405 302L405 302L405 302L405 302L405 302L406 303L406 303L406 303L406 303L406 303L407 304L407 304L407 304L407 304L407 304L407 304L408 305L408 305L408 305L409 305L410 305L410 305L411 305L411 305L411 305L412 305L412 305L413 305L413 305L414 306L414 306L414 306L414 306L414 306L414 306L414 307L414 308L415 308L415 308L415 309L415 309L415 309L416 310L417 310L417 311L417 312L417 312L418 312L419 312L419 312L419 311L419 310L419 309L419 308L419 308L420 307L420 306L420 306L420 306L420 305L420 305L419 304L418 303L417 303L417 303L417 303L417 303L416 303L416 303L417 303L417 303L417 303L417 302L417 302L417 302L418 302L418 302L418 302L419 302L419 302L420 300L420 299L420 299L420 299L420 298L420 298L420 297L420 297L420 297L420 297L421 296L421 296L422 295L422 295L422 294L422 295L422 294L422 294L423 294L423 294L423 294L423 293L423 292L424 291L424 291L424 290L424 290L424 289L424 288L424 287L425 287L425 287L425 287L425 287L426 286L426 286L426 286L426 286L426 286L427 286L428 287L429 287L429 287L430 287L430 287L430 287L430 287L431 287L432 287L432 287L432 287z"
        },
        {
            "title": "Karimnagar",
            "d": "M359 272L358 272L357 272L357 271L356 271L356 271L356 272L356 272L356 272L355 272L355 272L355 272L355 272L354 272L354 272L354 272L354 272L354 271L354 272L354 272L354 272L354 274L354 275L355 275L353 276L352 277L352 277L352 277L352 277L351 277L351 277L351 277L351 278L352 280L354 280L356 281L357 282L358 282L358 282L359 281L361 281L362 279L363 278L363 278L363 278L363 277L363 277L363 276L363 276L362 276L362 276L362 275L362 275L362 275L362 275L362 275L362 275L362 274L362 274L362 274L362 273L362 273L362 273L361 273L361 273L361 273L361 273L361 273L360 273L360 273L360 272L359 272L359 272z"
        },
        {
            "title": "Karimnagar_Rural",
            "d": "M374 259L373 259L372 259L371 259L371 259L371 259L370 259L370 258L370 258L370 258L370 258L369 258L369 258L369 258L369 258L369 259L368 259L368 259L368 259L368 260L368 260L367 260L367 261L365 260L365 260L365 260L365 261L365 261L364 262L363 261L362 261L360 260L359 259L359 260L358 261L358 261L358 261L358 262L358 262L358 263L358 263L358 263L358 263L358 264L358 264L357 265L357 266L357 266L357 267L358 267L357 268L357 268L357 269L357 269L357 270L358 270L359 271L359 271L359 272L359 272L359 272L360 272L360 273L360 273L361 273L361 273L361 273L361 273L361 273L362 273L362 273L362 273L362 274L362 274L362 274L362 275L362 275L362 275L362 275L362 275L362 275L362 276L362 276L363 276L363 276L363 277L363 277L363 278L363 278L363 278L364 278L364 277L367 277L369 276L374 275L377 274L376 273L376 273L376 273L375 272L375 272L375 272L375 272L375 271L375 271L375 271L375 271L375 270L375 270L375 269L375 268L374 268L374 268L375 267L375 267L375 267L374 267L374 266L374 266L374 265L374 265L375 264L374 264L375 264L374 264L374 263L373 262L373 262L373 261L374 261L374 260L374 260L374 260L374 260L374 259L374 259L374 259z"
        },
        {
            "title": "Kothapally",
            "d": "M357 266L357 266L356 266L356 266L356 266L356 265L355 264L355 264L355 264L354 264L354 264L354 263L352 262L351 262L351 262L351 262L351 262L350 262L350 263L350 263L350 263L350 263L349 264L349 264L349 264L350 264L349 265L349 265L349 265L349 265L349 266L349 266L349 266L349 266L349 266L349 267L349 267L349 267L349 267L349 268L349 268L348 268L348 269L348 269L347 269L347 270L347 270L347 270L346 270L345 269L345 269L344 268L343 268L343 268L343 268L342 268L342 268L342 268L341 268L341 269L341 269L341 268L340 268L340 268L339 267L339 268L339 268L339 269L338 269L338 269L338 269L337 269L336 269L336 269L336 269L336 270L336 270L336 271L336 272L336 272L336 272L336 272L336 273L336 274L337 274L337 274L338 274L338 275L338 275L338 275L339 275L339 275L339 275L339 276L339 276L339 276L339 276L339 276L339 276L338 277L338 277L337 277L337 278L336 278L336 279L336 278L336 279L336 280L336 280L337 280L337 281L337 282L338 281L341 281L343 281L344 281L346 279L347 278L349 278L351 277L351 277L351 278L351 277L351 277L351 277L352 277L352 277L352 277L352 277L353 276L355 275L354 275L354 274L354 272L354 272L354 272L354 271L354 272L354 272L354 272L354 272L355 272L355 272L355 272L355 272L356 272L356 272L356 272L356 271L356 271L357 271L357 272L358 272L359 272L359 272L359 271L359 271L358 270L357 270L357 269L357 269L357 268L357 268L358 267L357 267L357 266L357 266z"
        },
        {
            "title": "Manakondur",
            "d": "M396 273L395 272L394 272L392 270L390 269L388 268L386 268L385 268L384 268L383 268L382 270L380 272L378 273L378 273L377 274L374 275L369 276L367 277L364 277L364 278L364 278L364 278L365 278L365 279L364 279L364 279L364 279L364 280L364 280L364 280L364 280L364 280L365 281L364 282L364 282L364 282L364 282L364 282L364 282L364 283L364 283L364 283L364 283L364 283L364 284L364 284L364 284L364 284L365 284L365 284L366 284L366 283L367 283L367 283L367 284L367 285L367 285L368 285L368 286L369 287L370 286L371 286L371 286L371 286L372 286L372 286L372 286L372 287L372 287L373 287L373 287L373 288L373 288L373 290L373 291L374 291L374 292L375 293L376 293L376 294L376 294L376 294L376 294L376 295L376 295L379 295L381 296L381 297L381 296L381 297L382 297L382 296L382 295L383 296L383 295L383 295L383 294L383 294L383 294L383 294L384 294L384 294L384 294L384 294L385 294L385 294L385 294L385 293L385 293L385 293L386 292L386 292L385 291L385 291L385 291L386 290L386 290L387 288L388 288L388 289L389 289L389 288L389 288L390 288L390 288L390 287L391 288L391 286L391 286L391 286L391 286L391 284L392 284L391 284L392 283L391 283L392 282L392 282L392 280L392 280L391 279L391 279L391 279L391 278L391 278L392 277L392 276L392 276L392 276L392 276L392 276L392 276L393 276L393 276L393 276L393 276L393 276L394 276L394 276L394 276L394 276L394 276L394 276L394 276L395 276L395 276L395 276L395 276L395 276L395 275L395 275L395 275L395 275L395 275L395 275L395 275L395 274L396 274L395 274L396 273z"
        },
        {
            "title": "Ramadugu",
            "d": "M356 236L356 236L356 236L356 236L356 236L356 236L356 236L355 235L355 236L355 236L355 236L355 236L355 236L355 237L355 237L355 237L355 238L355 238L355 238L355 238L355 238L355 238L354 238L354 238L354 238L354 238L354 238L354 238L354 238L353 238L354 238L353 238L354 237L354 237L353 237L353 237L353 237L353 237L353 237L353 237L353 237L352 237L352 237L352 237L352 237L352 237L352 237L352 237L352 238L351 238L352 238L352 239L352 239L352 239L351 240L351 241L351 242L350 243L350 243L349 243L349 243L349 243L349 243L349 242L348 242L348 241L348 241L348 241L348 241L347 241L347 241L346 241L346 241L344 240L344 240L344 240L344 241L344 242L344 242L344 242L344 242L344 243L344 243L345 243L344 243L345 244L344 244L345 244L345 244L345 244L345 244L345 245L345 245L345 245L345 246L345 247L345 247L345 248L345 248L345 249L345 249L345 249L345 249L345 249L345 249L345 249L344 249L343 250L343 250L343 250L343 251L343 251L343 251L343 251L343 252L343 252L343 252L343 253L343 253L344 253L344 253L344 254L343 256L343 256L343 256L342 257L342 257L342 258L342 259L342 259L341 261L342 261L342 261L342 261L342 261L343 262L344 262L344 262L344 263L344 264L344 265L344 265L344 265L344 266L343 267L343 268L344 268L345 269L345 269L346 270L347 270L347 270L347 270L347 269L348 269L348 269L348 268L349 268L349 268L349 267L349 267L349 267L349 267L349 266L349 266L349 266L349 266L349 266L349 265L349 265L349 265L349 265L350 264L349 264L349 264L349 264L350 263L350 263L350 263L350 263L350 262L351 262L351 262L351 262L351 262L352 262L354 263L354 264L354 264L355 264L355 264L355 264L356 265L356 266L356 266L356 266L357 266L357 266L357 265L358 264L358 264L358 263L358 263L358 263L358 263L358 262L358 262L358 261L358 261L357 261L356 260L355 260L355 259L355 258L355 257L354 257L354 257L354 257L354 257L354 256L354 255L355 254L355 253L356 252L355 251L355 251L355 251L355 250L355 249L355 249L355 249L356 249L356 249L358 248L359 248L360 247L360 247L360 247L359 247L358 246L358 246L358 246L357 246L357 245L357 245L357 245L357 245L357 244L357 244L356 244L356 244L356 244L356 244L356 243L356 242L356 242L356 242L356 241L356 240L356 240L356 240L356 240L356 239L356 239L357 238L356 238L357 238L357 238L357 238L357 238L357 237L357 237L357 237L356 237L357 237L356 236z"
        },
        {
            "title": "Shankarapatnam",
            "d": "M404 302L404 302L404 302L404 302L403 302L403 301L403 301L403 301L403 301L403 301L402 301L402 300L402 300L402 300L402 300L402 300L402 300L401 299L400 299L401 297L401 296L401 296L401 296L401 296L401 295L402 295L402 295L402 294L402 294L402 294L403 293L403 293L403 292L403 292L403 292L403 291L402 291L402 291L402 291L402 291L402 291L402 290L400 290L399 290L399 290L398 289L398 289L397 289L397 289L397 289L396 288L396 289L396 289L396 289L395 289L395 289L395 289L394 289L392 288L392 288L391 288L391 288L391 288L391 288L390 287L390 288L390 288L389 288L389 288L389 289L388 289L388 288L387 288L386 290L386 290L385 291L385 291L385 291L386 292L386 292L385 293L385 293L385 293L385 294L385 294L385 294L384 294L384 294L384 294L384 294L383 294L383 294L383 294L383 294L383 295L383 295L383 296L382 295L382 296L382 297L381 297L381 296L381 297L381 296L381 297L381 297L381 298L381 298L381 299L380 299L380 299L380 300L380 300L380 300L380 302L381 302L382 302L382 302L382 303L382 304L382 305L381 305L382 306L382 306L383 306L384 306L384 306L385 306L385 306L386 306L386 306L388 307L389 306L389 306L389 306L390 307L391 307L391 307L392 307L392 307L392 308L392 308L392 308L392 308L393 308L393 308L393 308L393 309L393 309L394 309L393 310L393 311L393 312L393 312L393 312L393 311L394 311L394 311L394 311L394 310L395 309L395 308L396 307L396 307L396 306L396 306L397 306L397 306L397 306L398 306L398 306L401 307L401 306L401 306L401 306L402 306L402 306L402 306L402 305L402 305L402 305L402 304L402 304L402 304L402 304L402 303L402 303L402 303L403 303L403 303L403 303L403 303L403 303L403 303L403 302L403 302L404 302L404 302L404 302z"
        },
        {
            "title": "Thimmapur",
            "d": "M381 296L379 295L376 295L376 295L376 294L376 294L376 294L376 294L376 293L375 293L374 292L374 291L373 291L373 290L373 288L373 288L373 287L373 287L372 287L372 287L372 286L372 286L372 286L371 286L371 286L371 286L370 286L369 287L368 286L368 285L367 285L367 285L367 284L367 283L367 283L366 283L366 284L365 284L365 284L364 284L364 284L364 284L364 284L364 283L364 283L364 283L364 283L364 283L364 282L364 282L364 282L364 282L364 282L364 282L365 281L364 280L364 280L364 280L364 280L364 280L364 279L364 279L364 279L365 279L365 278L364 278L364 278L364 278L363 278L362 279L361 281L359 281L358 282L358 282L359 282L359 283L358 283L359 284L361 284L362 285L363 285L363 286L363 286L363 288L364 289L364 289L363 289L363 289L363 289L363 290L362 290L362 290L361 290L360 290L360 290L360 290L360 290L360 289L359 289L358 289L358 289L358 289L357 290L357 290L358 290L358 290L358 291L358 291L358 291L358 291L358 291L357 291L357 291L357 292L357 291L357 292L357 292L356 292L356 292L356 293L356 293L356 292L356 292L356 292L356 292L355 293L355 293L355 295L354 296L355 296L355 296L355 296L355 296L355 296L356 296L356 296L357 297L357 297L357 297L357 297L357 297L357 298L356 299L356 301L356 301L356 301L357 302L357 302L357 302L357 303L357 304L358 304L358 304L359 304L361 303L362 302L363 303L364 303L364 303L364 303L364 302L365 302L365 302L366 302L366 302L367 302L367 302L367 302L367 302L368 302L369 302L369 301L369 301L369 301L369 301L369 302L370 302L370 302L370 302L370 303L370 303L370 303L371 303L371 303L371 304L371 304L371 304L371 304L371 304L371 304L372 305L372 305L373 306L374 305L375 305L375 305L375 305L376 305L377 306L378 306L380 307L380 305L381 305L382 305L382 304L382 303L382 302L382 302L381 302L380 302L380 300L380 300L380 300L380 299L380 299L381 299L381 298L381 298L381 297L381 297L381 296z"
        },
        {
            "title": "V Saidapur",
            "d": "M381 305L380 305L380 307L380 308L379 309L379 309L379 309L379 310L379 310L379 311L379 312L379 312L379 313L379 313L379 313L379 313L379 314L379 314L379 314L379 314L379 314L379 315L379 315L380 316L380 316L380 316L379 317L379 317L379 317L379 317L379 318L378 318L378 318L378 319L378 319L377 320L377 320L377 321L378 322L378 323L378 323L379 323L381 324L383 324L385 325L385 325L385 325L385 327L387 328L388 328L389 328L389 327L389 327L389 327L389 327L389 327L390 327L390 327L390 327L390 327L390 327L390 327L390 326L391 326L391 326L391 326L391 326L391 326L392 326L392 326L392 326L393 326L394 326L394 326L395 326L395 327L396 327L396 327L396 327L396 326L397 326L397 325L398 325L398 325L398 324L399 324L399 324L399 324L399 324L398 323L398 323L398 322L398 322L398 322L398 321L399 321L399 320L399 320L399 320L399 319L399 319L398 318L399 316L399 315L399 315L399 314L399 314L399 314L399 314L399 314L398 313L397 313L395 313L395 312L395 312L395 312L395 312L394 312L394 312L394 312L394 312L393 312L393 312L393 312L393 312L393 312L393 311L393 310L394 309L393 309L393 309L393 308L393 308L393 308L392 308L392 308L392 308L392 308L392 307L392 307L391 307L391 307L390 307L389 306L389 306L389 306L388 307L386 306L386 306L385 306L385 306L384 306L384 306L383 306L382 306L382 306L381 305z"
        },
        {
            "title": "Veenavanka",
            "d": "M398 275L396 273L395 274L396 274L395 274L395 275L395 275L395 275L395 275L395 275L395 275L395 275L395 276L395 276L395 276L395 276L395 276L394 276L394 276L394 276L394 276L394 276L394 276L394 276L393 276L393 276L393 276L393 276L393 276L392 276L392 276L392 276L392 276L392 276L392 276L392 277L391 278L391 278L391 279L391 279L391 279L392 280L392 280L392 282L392 282L391 283L392 283L391 284L392 284L391 284L391 286L391 286L391 286L391 286L391 288L391 288L391 288L391 288L392 288L392 288L394 289L395 289L395 289L395 289L396 289L396 289L396 289L396 288L397 289L397 289L397 289L398 289L398 289L399 290L399 290L400 290L402 290L402 291L402 291L402 291L402 291L402 291L403 291L403 292L403 292L403 292L403 293L403 293L402 294L402 294L402 294L402 295L402 295L401 295L401 296L401 296L401 296L401 296L401 297L400 299L401 299L402 300L402 300L402 300L402 300L402 300L402 300L402 301L403 301L403 301L403 301L403 301L403 301L403 302L404 302L404 302L404 302L404 302L404 302L405 302L405 302L405 301L405 301L405 301L405 301L406 300L405 300L406 299L406 299L406 299L406 298L406 298L407 298L407 298L407 298L407 298L407 298L407 298L407 298L408 298L408 298L408 298L408 298L409 298L409 298L410 298L410 298L410 298L410 298L411 298L411 298L411 298L411 297L412 298L412 297L412 297L413 297L413 297L413 296L413 296L413 296L413 296L413 296L413 296L412 295L412 295L412 295L412 295L412 295L411 294L412 294L410 293L410 293L410 293L410 292L410 292L411 291L411 291L411 291L411 290L412 290L412 290L413 290L413 290L413 290L414 289L414 289L413 289L413 289L413 288L414 288L414 287L414 286L415 286L415 285L416 285L414 284L413 283L411 281L410 280L408 279L407 279L405 278L403 278L402 277L400 276L399 276L398 275z"
        }
    ],
    "Narayanpet": [
        {
            "title": "Damargidda",
            "d": "M81 555L82 555L82 555L85 557L85 556L87 555L88 554L88 554L90 555L91 555L91 555L93 555L95 556L95 558L97 560L97 560L98 560L99 559L99 559L99 559L100 559L100 558L102 558L102 558L103 557L103 557L103 557L103 556L103 555L102 555L100 554L100 553L99 554L98 552L98 551L98 550L97 550L97 550L97 549L97 549L98 548L98 548L98 548L99 548L99 548L99 547L99 547L99 547L100 547L100 547L100 547L101 546L101 546L100 545L99 544L99 544L98 544L98 544L98 543L97 542L97 542L97 541L97 541L97 541L97 541L97 540L97 540L97 539L97 539L96 539L96 539L96 539L96 538L96 538L97 538L97 535L97 535L96 536L96 536L95 536L95 536L94 535L94 534L94 534L94 534L94 534L92 532L92 531L92 531L92 531L92 531L91 531L90 532L89 531L89 531L89 530L90 529L90 529L90 528L89 528L87 528L87 528L86 528L86 528L85 528L85 528L83 527L83 527L82 527L82 527L82 526L82 526L81 526L80 527L81 527L81 528L81 528L81 528L80 528L80 529L81 529L81 529L81 530L80 531L81 531L81 533L81 533L81 534L80 533L79 533L79 534L78 534L79 534L79 535L79 536L79 536L79 537L79 537L79 538L79 539L79 539L79 541L79 541L79 542L80 544L80 545L80 546L79 546L79 547L79 548L79 548L79 549L79 549L80 550L79 551L80 551L80 551L80 552L80 552L80 553L81 553L81 553L82 555L81 555z"
        },
        {
            "title": "Dhanwada",
            "d": "M130 572L129 572L129 572L129 572L129 571L129 571L129 571L128 571L126 571L127 570L127 570L127 569L127 569L127 569L128 568L128 568L128 568L128 567L127 566L127 565L126 565L126 564L126 564L125 563L125 563L124 563L123 562L122 563L119 563L117 562L116 562L115 565L115 566L116 568L113 572L113 573L114 572L112 576L111 579L111 579L111 580L110 580L110 580L110 580L109 580L109 580L109 580L108 580L108 580L107 580L106 580L105 580L105 580L104 581L103 581L103 581L102 581L101 581L101 581L101 581L101 582L102 582L102 582L103 582L104 583L104 584L104 584L104 584L105 584L108 584L108 584L108 585L107 586L105 588L104 589L104 589L105 589L108 590L108 591L108 591L109 591L110 592L110 593L111 594L112 593L112 592L112 592L112 592L112 591L112 591L113 591L113 590L113 590L113 590L113 589L114 589L114 589L114 589L114 588L114 588L115 588L115 588L115 588L115 588L115 588L115 587L116 587L116 587L117 587L117 587L117 585L118 585L118 584L119 583L120 582L120 582L117 581L118 581L118 580L118 580L119 580L120 580L122 580L123 579L124 579L124 579L126 579L127 578L127 578L127 578L128 578L129 578L130 578L130 578L130 577L130 575L129 574L130 573L130 572z"
        },
        {
            "title": "Kosgi",
            "d": "M130 516L130 516L130 516L129 516L129 516L129 516L129 516L129 516L128 516L128 516L128 516L128 515L128 516L128 515L128 515L127 515L127 515L126 515L125 515L125 515L125 514L125 514L125 514L124 513L124 513L122 513L121 514L121 515L121 515L120 515L120 515L120 515L120 515L120 515L119 516L118 516L118 516L118 516L117 516L117 516L117 516L116 515L115 514L114 514L113 514L113 514L112 515L112 515L112 516L111 516L111 516L111 516L111 516L111 516L110 516L110 516L110 517L110 517L110 517L109 517L109 517L109 517L109 518L109 518L108 519L108 519L108 519L109 519L109 519L109 519L110 519L110 519L110 518L111 518L111 518L111 518L112 518L112 519L111 520L111 520L110 521L111 521L110 521L109 522L108 522L108 522L107 522L107 523L107 524L107 524L107 525L107 525L107 525L107 525L107 527L106 528L107 528L109 528L110 529L110 529L111 529L112 529L112 529L112 529L113 529L113 530L113 530L113 530L115 530L115 530L115 530L116 529L116 529L117 529L117 529L117 529L118 528L118 528L119 529L119 529L120 529L121 529L121 529L121 528L121 528L121 527L122 527L123 527L123 526L124 526L124 526L125 526L125 527L126 528L126 529L127 529L128 529L128 529L128 529L128 529L128 528L128 528L128 528L128 528L128 528L128 528L128 528L127 528L127 528L127 528L128 528L128 527L128 526L128 526L129 525L129 525L129 525L129 525L130 524L129 523L129 523L129 523L129 522L129 521L130 521L130 520L130 520L130 520L130 520L130 518L130 517L130 516z"
        },
        {
            "title": "Maddur",
            "d": "M113 530L113 530L113 530L113 529L112 529L112 529L112 529L111 529L110 529L110 529L109 528L107 528L106 528L106 528L106 528L106 528L105 528L105 529L103 528L103 529L103 530L103 531L102 531L102 531L102 531L102 532L102 533L102 534L102 534L102 534L101 534L101 534L100 535L99 535L99 536L99 536L98 536L98 535L97 535L97 538L96 538L96 538L96 539L96 539L96 539L97 539L97 539L97 540L97 540L97 541L97 541L97 541L97 541L97 542L97 542L98 543L98 544L98 544L99 544L99 544L100 545L101 546L101 546L100 547L100 547L100 547L99 547L99 547L99 547L99 548L99 548L98 548L98 548L98 548L97 549L97 549L97 550L97 550L98 550L98 551L98 552L99 554L100 553L100 554L102 555L103 555L103 556L103 557L103 557L104 557L105 557L105 557L106 556L106 556L107 556L107 555L107 555L107 555L107 555L108 555L108 555L109 555L109 555L109 554L109 554L109 555L109 554L110 554L110 554L110 555L110 554L110 555L111 555L111 554L111 554L111 554L111 554L111 553L111 553L111 553L112 552L112 552L112 552L112 552L112 552L112 552L112 552L112 552L112 551L111 551L111 551L111 551L111 551L111 551L110 550L110 550L110 550L109 549L109 547L109 547L109 547L110 546L110 545L111 546L112 545L113 545L114 544L114 544L115 544L116 543L117 543L116 541L115 539L115 537L114 537L113 536L113 536L112 535L111 533L111 533L112 533L112 532L112 532L112 532L112 531L112 531L112 530L113 530z"
        },
        {
            "title": "Maganoor",
            "d": "M63 607L63 607L63 608L64 610L64 610L64 611L65 611L65 612L65 612L65 612L66 611L66 611L67 611L68 611L68 613L68 613L68 615L68 615L70 616L70 617L71 617L72 619L72 619L73 619L73 619L74 619L74 619L74 619L77 620L77 620L77 620L77 621L77 621L77 621L77 621L76 622L76 622L76 624L76 624L76 624L76 624L76 625L76 625L76 625L76 625L76 626L78 626L79 626L80 626L81 626L81 626L83 625L84 626L85 626L87 627L87 627L88 627L88 627L88 626L89 625L89 624L90 624L90 624L89 623L89 623L89 623L88 622L88 622L88 622L88 622L88 622L88 621L88 622L89 622L89 622L89 621L89 621L89 621L89 620L88 620L88 620L87 620L87 620L87 620L86 620L86 619L86 619L86 619L86 618L86 618L86 618L86 618L85 618L85 618L85 618L84 617L85 616L85 615L85 614L86 612L85 612L85 612L84 612L81 611L81 611L81 611L80 611L79 611L78 611L78 610L77 610L77 610L77 610L77 610L77 610L77 609L77 609L77 609L77 609L77 608L78 608L78 608L78 608L78 608L78 608L78 608L78 608L78 608L77 608L77 608L76 608L76 608L77 607L77 607L78 606L79 606L78 606L78 606L78 605L78 605L78 606L77 605L78 605L78 604L78 604L77 604L77 604L78 604L79 603L79 603L79 603L79 603L80 603L79 603L80 602L80 601L80 601L80 600L80 600L80 600L81 598L81 597L81 597L81 597L81 596L81 596L81 595L81 595L80 595L79 594L78 594L77 594L78 593L78 593L78 593L78 592L78 592L79 592L78 591L79 591L75 590L73 592L73 593L73 593L72 593L71 593L70 593L69 593L69 593L69 593L68 593L68 593L68 593L67 593L67 594L68 594L68 595L68 595L68 595L69 596L69 596L70 596L70 597L70 597L71 597L71 597L71 597L71 597L71 598L71 601L71 601L71 601L71 602L70 602L69 601L68 601L67 602L67 602L65 602L65 603L64 603L64 604L63 605L63 605L63 607z"
        },
        {
            "title": "Makthal",
            "d": "M111 594L110 593L110 592L109 591L108 591L108 591L108 590L105 589L104 589L104 590L102 591L102 591L100 592L99 593L99 594L99 594L99 594L98 594L98 595L98 596L98 596L97 597L97 597L97 598L96 598L95 597L95 597L94 598L93 598L93 598L91 597L91 597L91 596L91 596L91 595L91 594L91 594L91 594L90 593L88 593L87 593L87 593L87 593L87 593L87 594L86 593L84 593L83 593L82 593L82 593L82 593L82 591L81 591L80 590L80 591L79 591L79 591L79 591L78 591L79 592L78 592L78 592L78 593L78 593L78 593L77 594L78 594L79 594L80 595L81 595L81 595L81 596L81 596L81 597L81 597L81 597L81 598L80 600L80 600L80 600L80 601L80 601L80 602L79 603L80 603L79 603L79 603L79 603L79 603L78 604L77 604L77 604L78 604L78 604L78 605L77 605L78 606L78 605L78 605L78 606L78 606L79 606L78 606L77 607L77 607L76 608L76 608L77 608L77 608L78 608L78 608L78 608L78 608L78 608L78 608L78 608L78 608L77 608L77 609L77 609L77 609L77 609L77 610L77 610L77 610L77 610L77 610L78 610L78 611L79 611L80 611L81 611L81 611L81 611L84 612L85 612L85 612L86 612L85 614L85 615L85 616L84 617L85 618L85 618L85 618L86 618L86 618L86 618L86 618L86 619L86 619L86 619L86 620L87 620L87 620L87 620L88 620L88 620L89 620L89 621L89 621L89 621L89 622L89 622L88 622L88 621L88 622L88 622L88 622L88 622L88 622L89 623L89 623L89 623L90 624L90 624L89 624L89 625L88 626L88 627L89 627L89 628L90 629L90 629L91 630L92 630L92 630L93 631L94 632L94 632L95 632L96 633L97 633L100 633L100 633L100 633L101 633L102 632L104 631L105 631L107 630L108 630L110 631L111 631L111 630L111 631L112 630L112 629L112 629L112 628L111 628L111 628L111 628L111 627L111 627L111 627L111 626L111 626L111 625L114 625L113 625L112 624L111 624L111 624L110 624L109 624L109 623L109 623L109 622L109 621L109 620L108 620L108 620L108 620L107 620L106 620L106 620L105 620L105 620L105 621L104 621L104 621L104 621L103 621L102 621L102 622L101 622L100 621L99 621L99 620L99 620L98 620L98 619L98 618L98 618L98 617L99 617L100 617L100 616L100 616L101 616L102 616L103 616L103 616L104 616L104 616L103 615L103 615L104 615L104 615L103 613L103 613L103 613L103 612L103 612L103 612L103 610L103 609L103 608L103 607L103 607L104 607L105 607L105 607L105 606L105 605L105 605L105 605L105 604L105 604L105 603L106 602L106 602L106 602L107 600L107 599L108 599L110 598L110 598L111 597L111 596L111 595L111 594L111 594z"
        },
        {
            "title": "Marikal",
            "d": "M130 578L129 578L128 578L127 578L127 578L127 578L126 579L124 579L124 579L123 579L122 580L120 580L119 580L118 580L118 580L118 581L117 581L120 582L120 582L119 583L118 584L118 585L117 585L117 587L117 587L116 587L116 587L115 587L115 588L115 588L115 588L115 588L115 588L114 588L114 588L114 589L114 589L114 589L113 589L113 590L113 590L113 590L113 591L112 591L112 591L112 592L112 592L112 592L112 593L111 594L111 594L111 595L111 596L112 596L112 596L112 596L112 596L112 597L113 597L112 597L112 597L112 597L112 597L112 597L113 597L113 598L113 598L113 598L113 598L114 599L114 599L114 600L114 600L114 600L115 600L116 601L116 600L117 600L118 600L118 600L120 601L121 602L122 602L121 604L123 605L124 605L124 605L125 605L126 605L127 605L127 605L128 605L129 605L129 602L129 602L129 602L129 601L128 600L128 600L127 600L127 600L127 599L127 599L127 599L127 598L127 598L127 597L126 597L126 597L127 597L126 596L126 596L126 596L126 596L126 595L126 595L126 595L126 595L126 595L127 595L127 594L127 595L128 595L128 595L129 595L131 595L131 595L132 594L132 594L132 593L133 593L133 593L133 592L133 591L133 591L133 590L133 589L132 589L132 588L132 588L132 587L132 586L132 586L134 586L134 586L135 586L135 586L135 584L135 583L133 582L132 581L132 580L131 580L130 578z"
        },
        {
            "title": "Narayanpet",
            "d": "M81 555L81 555L81 556L82 556L81 556L81 557L80 557L79 557L78 556L78 556L76 556L76 555L75 556L75 558L76 558L76 559L76 560L76 561L75 562L75 563L74 564L74 564L74 565L74 565L74 565L74 565L73 566L73 566L73 566L74 566L74 567L74 567L73 567L73 567L73 568L73 568L74 568L74 568L74 568L75 569L75 569L75 569L75 568L76 568L76 568L76 568L76 567L76 567L77 567L77 567L77 567L78 567L78 568L79 568L79 568L79 568L79 567L80 568L80 567L80 568L81 568L81 568L81 568L82 567L82 567L82 566L83 567L83 567L83 567L83 567L83 567L84 568L85 567L85 567L85 566L86 566L87 566L88 566L88 566L88 567L89 566L89 567L89 568L89 569L88 569L88 570L89 570L90 569L90 570L91 571L92 571L92 571L93 571L93 570L94 570L95 570L96 569L96 569L97 568L97 568L99 569L99 569L99 569L99 570L98 570L98 571L97 571L98 572L97 573L98 574L98 574L98 574L100 575L101 574L101 573L101 572L101 572L102 572L102 572L102 572L102 572L102 572L103 573L103 573L103 574L103 574L102 575L103 575L103 577L103 577L103 577L103 578L103 578L103 578L104 579L104 579L104 579L105 580L106 580L107 580L108 580L108 580L109 580L109 580L109 580L110 580L110 580L110 580L111 580L111 579L111 579L112 576L114 572L113 573L113 572L116 568L115 566L115 565L116 562L115 561L115 561L115 559L115 558L114 559L113 559L112 558L111 556L111 555L111 554L111 555L110 555L110 554L110 555L110 554L110 554L109 554L109 555L109 554L109 554L109 555L109 555L108 555L108 555L107 555L107 555L107 555L107 555L107 556L106 556L106 556L105 557L105 557L104 557L103 557L103 557L102 558L102 558L100 558L100 559L99 559L99 559L99 559L98 560L97 560L97 560L95 558L95 556L93 555L91 555L91 555L90 555L88 554L88 554L87 555L85 556L85 557L82 555L82 555L81 555z"
        },
        {
            "title": "Narva",
            "d": "M124 605L124 605L123 605L121 604L122 602L121 602L120 601L118 600L118 600L117 600L116 600L116 601L115 600L114 600L114 600L114 600L114 599L114 599L113 598L113 598L113 598L113 598L113 597L112 597L112 597L112 597L112 597L112 597L113 597L112 597L112 596L112 596L112 596L112 596L111 596L111 597L110 598L110 598L108 599L107 599L107 600L106 602L106 602L106 602L105 603L105 604L105 604L105 605L105 605L105 605L105 606L105 607L105 607L104 607L103 607L103 607L103 608L103 609L103 610L103 612L103 612L103 612L103 613L103 613L103 613L104 615L104 615L103 615L103 615L104 616L104 616L103 616L103 616L102 616L101 616L100 616L100 616L100 617L99 617L98 617L98 618L98 618L98 619L98 620L99 620L99 620L99 621L100 621L101 622L102 622L102 621L103 621L104 621L104 621L104 621L105 621L105 620L105 620L106 620L106 620L107 620L108 620L108 620L108 620L109 620L109 621L109 622L109 623L109 623L109 624L110 624L111 624L111 624L112 624L113 625L114 625L114 624L115 624L116 623L117 623L117 623L118 623L118 623L119 623L119 622L119 622L119 621L118 621L119 619L119 619L120 617L121 617L121 617L122 619L122 619L123 620L123 621L123 622L123 623L122 624L123 624L124 624L124 623L124 623L124 623L124 622L124 622L124 622L124 622L125 622L125 622L125 622L125 621L125 621L125 620L125 620L125 620L125 620L125 619L125 619L125 618L124 618L124 617L124 617L124 617L124 617L125 617L125 616L125 616L125 616L126 616L126 616L126 616L126 616L126 616L125 616L124 615L125 615L125 615L124 614L124 614L124 614L123 613L124 612L124 612L124 612L124 611L125 611L125 611L125 611L126 612L127 612L127 611L127 611L128 609L128 609L128 608L128 608L128 607L128 607L128 607L128 607L128 607L128 607L127 607L127 607L127 607L127 607L127 607L127 607L126 607L125 606L124 606L124 605z"
        },
        {
            "title": "Utkoor",
            "d": "M105 580L104 579L104 579L104 579L103 578L103 578L103 578L103 577L103 577L103 577L103 575L102 575L103 574L103 574L103 573L103 573L102 572L102 572L102 572L102 572L102 572L101 572L101 572L101 573L101 574L100 575L98 574L98 574L98 574L97 573L98 572L97 571L98 571L98 570L99 570L99 569L99 569L99 569L97 568L97 568L96 569L96 569L95 570L94 570L93 570L93 571L92 571L92 571L91 571L90 570L90 569L89 570L88 570L88 569L89 569L89 568L89 567L89 566L88 567L88 566L88 566L87 566L86 566L85 566L85 567L85 567L84 568L83 567L83 567L83 567L83 567L83 567L82 566L82 567L82 567L81 568L81 569L81 569L81 570L81 570L80 570L80 570L80 572L80 572L80 573L80 573L80 574L80 574L79 575L78 574L77 574L77 574L76 575L76 575L76 575L76 576L75 576L74 576L73 576L72 576L72 578L73 578L74 578L74 579L74 579L75 580L75 580L75 580L74 581L74 581L75 581L75 581L76 581L76 581L77 581L77 580L78 580L78 580L78 579L79 579L79 579L79 579L81 579L81 579L81 580L81 580L81 580L81 580L80 581L80 581L80 582L80 582L79 582L79 583L78 584L78 584L77 585L78 585L78 586L78 586L80 586L80 587L80 587L80 588L80 588L79 588L79 588L79 589L79 589L79 589L79 591L78 591L79 591L79 591L79 591L80 591L80 590L81 591L82 591L82 593L82 593L82 593L83 593L84 593L86 593L87 594L87 593L87 593L87 593L87 593L88 593L90 593L91 594L91 594L91 594L91 595L91 596L91 596L91 597L91 597L93 598L93 598L94 598L95 597L95 597L96 598L97 598L97 597L97 597L98 596L98 596L98 595L98 594L99 594L99 594L99 594L99 593L100 592L102 591L102 591L104 590L104 589L104 589L105 588L107 586L108 585L108 584L108 584L105 584L104 584L104 584L104 584L104 583L103 582L102 582L102 582L101 582L101 581L101 581L101 581L102 581L103 581L103 581L104 581L105 580L105 580z"
        },
        {
            "title": "Krishna",
            "d": "M63 607L61 607L61 607L60 606L59 607L59 607L59 607L58 607L56 607L56 607L56 607L55 607L54 606L51 605L51 607L51 608L50 608L50 609L48 609L45 609L44 609L43 609L43 608L42 609L41 609L41 609L41 609L41 610L41 610L41 610L42 611L43 611L44 612L45 613L45 614L46 615L46 616L48 618L48 618L48 619L49 621L50 621L51 621L52 622L54 623L55 623L57 623L58 623L58 624L59 625L60 625L60 625L62 625L64 625L64 625L65 625L66 626L68 627L69 628L71 628L71 628L73 628L73 627L74 626L75 626L76 626L76 625L76 625L76 625L76 625L76 624L76 624L76 624L76 624L76 622L76 622L77 621L77 621L77 621L77 621L77 620L77 620L77 620L74 619L74 619L74 619L73 619L73 619L72 619L72 619L71 617L70 617L70 616L68 615L68 615L68 613L68 613L68 611L67 611L66 611L66 611L65 612L65 612L65 612L65 611L64 611L64 610L64 610L63 608L63 607L63 607z"
        },
        {
            "title": "Gundmal",
            "d": "M126 529L126 528L125 527L125 526L124 526L124 526L123 526L123 527L122 527L121 527L121 528L121 528L121 529L121 529L120 529L119 529L119 529L118 528L118 528L117 529L117 529L117 529L116 529L116 529L115 530L115 530L115 530L113 530L112 530L112 531L112 531L112 532L112 532L112 532L112 533L111 533L111 533L112 535L113 536L113 536L114 537L115 537L115 539L116 541L117 543L116 543L117 543L119 544L119 545L120 546L120 547L120 547L121 548L122 548L121 548L122 548L123 548L123 548L124 548L124 547L124 547L124 547L125 547L125 547L125 547L124 546L124 545L124 545L125 544L125 544L125 544L125 543L124 542L125 541L125 540L126 540L126 540L126 540L126 539L126 539L126 538L126 537L126 536L126 536L126 536L126 536L127 535L127 535L127 535L126 534L126 534L126 532L126 532L126 532L126 531L126 531L126 531L124 530L124 529L124 529L125 530L125 530L125 529L126 529L126 529z"
        },
        {
            "title": "Kothapalle",
            "d": "M111 554L111 555L111 556L112 558L113 559L114 559L115 558L115 559L115 559L115 558L115 558L116 557L115 556L116 556L117 556L118 556L118 555L118 555L119 556L119 556L119 556L120 557L121 555L122 556L122 556L122 556L122 556L123 556L125 557L126 556L126 555L125 555L125 553L124 553L125 552L125 551L126 551L126 550L126 550L126 550L126 550L126 550L126 549L126 549L126 548L126 548L126 548L125 548L125 547L124 547L124 547L124 547L124 548L123 548L123 548L122 548L121 548L122 548L121 548L120 547L120 547L120 546L119 545L119 544L117 543L116 543L115 544L114 544L114 544L113 545L112 545L111 546L110 545L110 546L109 547L109 547L109 547L109 549L110 550L110 550L110 550L111 551L111 551L111 551L111 551L111 551L112 551L112 552L112 552L112 552L112 552L112 552L112 552L112 552L112 552L111 553L111 553L111 553L111 554L111 554L111 554L111 554z"
        }
    ],
    "Peddapalli": [
        {
            "title": "Dharmaram",
            "d": "M387 222L387 222L385 223L382 222L382 222L382 222L380 221L380 221L380 221L380 221L380 221L379 221L379 221L379 221L379 221L379 222L377 221L376 221L376 221L376 221L376 221L376 221L376 222L375 222L375 222L375 222L375 222L375 222L375 222L374 222L374 223L374 222L374 223L374 223L374 223L373 223L373 223L372 222L372 222L371 222L370 222L368 221L365 220L363 224L362 226L361 226L360 226L360 226L360 227L360 227L359 228L360 228L359 228L359 228L359 228L359 228L359 228L359 229L359 229L359 229L358 229L358 229L358 229L358 229L358 229L358 229L358 229L358 229L358 229L357 229L357 229L357 229L357 230L357 230L357 230L357 230L357 231L357 231L357 231L358 231L358 232L358 235L358 235L358 235L359 235L358 236L359 236L359 236L360 236L360 236L360 236L361 237L361 237L362 238L362 239L362 239L362 239L362 239L363 239L364 240L364 240L365 239L365 239L365 239L366 239L366 239L366 239L366 239L366 239L366 239L366 238L367 238L367 238L367 238L368 238L368 238L368 238L368 238L368 238L368 238L368 239L368 239L368 239L368 239L368 240L368 240L368 240L368 241L368 241L368 241L368 242L368 242L368 242L368 242L368 243L368 243L368 244L368 245L368 244L369 244L369 244L369 243L370 243L370 243L370 243L370 242L371 242L371 242L371 242L371 242L371 242L371 242L372 242L372 242L372 242L372 242L372 241L373 241L373 241L373 241L373 240L373 240L373 240L373 240L373 240L373 239L373 239L373 239L373 239L372 239L373 238L372 238L373 238L372 238L373 238L373 238L373 237L373 237L373 237L373 237L374 236L374 237L374 237L374 237L374 237L374 237L374 237L374 237L375 237L374 237L375 238L375 238L375 238L375 238L377 239L377 239L377 239L377 239L378 239L379 239L380 239L380 237L380 237L380 236L380 236L380 236L380 235L380 234L380 234L380 234L380 234L380 233L381 233L381 233L382 233L382 233L383 233L385 234L386 235L386 235L387 235L387 235L388 235L389 235L389 235L390 233L389 233L390 233L390 232L390 231L389 231L389 231L390 231L390 230L390 230L390 230L390 231L391 231L391 231L391 231L391 231L391 231L392 231L392 230L392 230L393 231L394 231L394 230L393 230L393 230L392 229L392 227L391 226L391 226L391 225L392 225L391 225L391 225L391 224L391 223L391 223L391 223L391 223L391 223L391 222L390 222L390 222L390 222L390 222L389 222L389 222L389 222L389 222L387 223L387 223L387 222L387 222z"
        },
        {
            "title": "Eligaid",
            "d": "M389 246L389 246L389 246L389 246L388 246L388 246L387 247L387 247L387 247L387 247L387 247L385 247L385 246L385 246L385 246L384 246L384 246L384 246L384 246L383 246L383 246L382 247L382 246L382 246L382 246L382 246L382 246L382 246L381 246L381 246L380 246L380 246L380 246L380 247L379 247L379 248L379 248L379 248L379 248L379 249L379 249L379 249L379 249L379 249L379 249L379 250L379 250L379 251L377 252L376 253L376 253L376 254L375 257L375 257L375 257L374 258L374 259L374 259L374 259L374 260L374 260L374 260L375 260L375 261L376 261L377 261L377 261L377 261L377 261L378 261L378 261L378 261L378 262L378 263L378 263L378 263L378 263L378 263L379 263L379 263L379 264L379 263L380 264L380 263L380 263L380 263L380 263L380 263L380 263L380 263L381 262L381 262L381 262L382 263L382 263L382 263L382 263L383 263L383 263L383 262L384 262L384 262L384 262L384 261L384 261L384 260L384 260L384 260L385 259L385 259L385 259L385 258L386 258L386 258L386 258L386 257L386 257L386 257L387 257L387 257L388 257L388 257L388 257L388 257L389 257L389 257L390 257L390 257L390 257L390 257L391 255L391 255L391 255L390 255L390 254L390 254L390 253L390 253L389 253L389 253L389 252L389 252L388 252L388 251L388 252L388 251L388 251L389 250L389 250L389 250L389 249L389 249L389 249L389 249L389 248L389 248L389 249L390 249L390 248L390 248L390 248L390 248L391 248L391 248L391 248L391 248L391 248L391 248L391 248L391 248L391 247L391 247L391 246L390 246L389 246z"
        },
        {
            "title": "Julapalli",
            "d": "M389 235L388 235L387 235L387 235L386 235L386 235L385 234L383 233L382 233L382 233L381 233L381 233L380 233L380 234L380 234L380 234L380 234L380 235L380 236L380 236L380 236L380 237L380 237L380 239L379 239L378 239L377 239L377 239L377 239L377 239L375 238L375 238L375 238L375 238L374 237L375 237L374 237L374 237L374 237L374 237L374 237L374 237L374 237L374 236L373 237L373 237L373 237L373 237L373 238L373 238L372 238L373 238L372 238L373 238L372 239L373 239L373 239L373 239L373 239L373 240L373 240L373 240L373 240L373 240L373 241L373 241L373 241L372 241L372 242L372 242L372 242L372 242L371 242L371 242L371 242L371 242L371 242L371 242L370 242L370 243L370 243L370 243L369 243L369 244L369 244L368 244L368 245L368 245L368 246L369 246L369 246L370 247L370 247L370 247L371 248L371 248L372 248L372 249L372 251L374 253L374 253L374 253L375 253L376 253L377 252L379 251L379 250L379 250L379 249L379 249L379 249L379 249L379 249L379 249L379 248L379 248L379 248L379 248L379 247L380 247L380 246L380 246L380 246L381 246L381 246L382 246L382 246L382 246L382 246L382 246L382 246L382 247L383 246L383 246L384 246L384 246L384 246L384 246L385 246L385 246L385 246L385 247L387 247L387 247L387 247L387 247L387 247L388 246L388 246L389 246L389 246L389 246L389 246L390 245L390 244L390 244L390 244L390 243L390 243L390 243L390 243L390 243L390 242L390 242L390 241L390 241L390 241L391 239L391 238L391 238L391 238L392 237L391 236L390 236L390 236L390 236L389 235L389 235z"
        },
        {
            "title": "Kamanpur",
            "d": "M427 234L427 234L426 235L426 235L425 235L425 235L425 235L424 235L424 235L424 235L424 235L424 235L423 234L423 235L423 235L423 235L423 234L422 234L422 234L423 234L423 234L422 234L422 234L422 234L422 234L422 234L422 234L422 233L422 233L422 232L423 231L422 231L422 230L422 230L422 230L422 229L422 229L422 229L421 229L422 228L421 228L421 228L421 227L421 227L421 228L421 228L421 228L421 228L421 229L420 229L420 230L420 230L420 231L419 231L419 231L419 231L419 231L419 232L419 232L419 233L418 233L417 232L417 232L416 232L416 232L416 232L415 232L415 232L415 232L414 231L414 232L414 232L414 232L414 232L414 233L413 233L413 234L413 234L412 235L412 236L412 236L412 236L413 236L413 236L413 237L413 237L413 237L413 238L413 238L413 238L413 239L413 239L413 239L415 240L416 240L416 240L416 240L417 240L417 240L417 241L416 241L416 243L416 244L417 247L419 247L419 248L420 247L420 247L420 246L421 244L422 242L421 241L421 241L421 241L422 239L423 239L424 239L425 239L426 240L427 240L427 241L428 240L428 240L428 240L428 240L428 240L429 240L429 239L429 239L429 239L428 237L428 237L429 236L429 234L429 234L428 234L427 234z"
        },
        {
            "title": "Manthani",
            "d": "M456 233L455 233L455 234L453 234L453 235L452 236L452 236L451 236L449 235L448 234L447 233L447 232L446 231L444 227L444 227L444 227L443 226L442 226L441 226L441 226L439 225L437 224L437 225L437 225L436 226L436 226L436 226L436 226L436 227L435 227L435 227L434 228L434 228L433 229L433 231L433 231L433 232L433 233L433 235L432 234L432 235L431 236L432 238L432 239L432 239L432 239L432 239L432 239L432 239L433 240L433 239L433 239L433 239L434 239L434 239L434 239L434 239L435 239L435 239L436 239L435 239L435 239L435 239L435 240L435 240L435 240L435 241L435 241L435 241L436 241L436 241L437 241L437 241L437 241L437 241L437 241L438 241L438 241L438 241L438 241L439 241L438 242L438 242L438 244L438 244L438 244L438 244L438 245L438 245L438 246L438 247L437 248L439 248L439 248L439 249L440 249L440 250L440 251L441 251L442 251L442 251L443 251L443 250L444 250L444 250L444 250L444 250L445 250L445 250L445 251L445 253L445 252L445 251L446 249L447 249L448 248L450 250L451 251L451 252L452 251L452 251L452 251L453 251L453 251L454 252L454 252L454 251L454 251L455 251L455 252L455 252L454 253L455 253L454 253L455 253L455 253L456 255L457 254L458 253L459 253L460 253L465 254L467 254L468 253L468 253L468 252L468 251L470 247L471 244L472 243L474 240L475 239L475 238L475 237L475 236L474 235L474 234L473 233L473 232L472 230L472 229L470 230L466 232L465 233L462 234L461 234L459 234L457 234L456 233z"
        },
        {
            "title": "Mutharam_Manthani",
            "d": "M456 255L455 253L455 253L454 253L455 253L454 253L455 252L455 252L455 251L454 251L454 251L454 252L454 252L453 251L453 251L452 251L452 251L452 251L451 252L451 251L450 250L448 248L447 249L446 249L445 251L445 252L445 253L444 253L442 256L440 253L436 253L436 253L436 253L435 252L435 252L435 252L435 252L435 252L435 252L434 251L434 251L434 251L434 251L434 251L433 250L432 251L432 252L433 252L432 253L432 253L431 253L430 253L430 253L430 254L431 255L431 255L431 254L431 254L431 254L431 255L431 255L431 255L432 256L433 256L433 257L433 257L434 257L434 257L434 257L435 259L435 259L434 259L434 260L433 260L433 260L433 260L433 260L433 260L433 260L433 260L433 260L433 261L432 262L431 262L432 262L432 263L434 264L435 264L435 265L435 266L434 266L433 267L433 267L433 268L434 267L434 268L434 268L434 268L435 269L435 270L436 270L436 270L436 270L436 270L437 270L438 271L438 271L438 270L439 270L440 270L441 269L441 269L441 269L441 268L441 268L442 269L443 269L444 270L445 269L446 269L448 269L448 268L449 267L450 267L451 266L452 264L452 264L453 263L454 262L454 261L455 257L455 256L456 255z"
        },
        {
            "title": "Odela",
            "d": "M410 260L410 260L409 260L409 260L408 259L407 259L407 259L407 259L406 260L406 260L405 260L405 260L405 260L405 260L405 260L404 260L404 259L404 260L403 260L403 259L402 260L402 260L402 260L401 261L403 262L403 262L403 262L403 262L403 262L403 262L404 262L403 263L403 264L403 265L402 267L402 268L402 269L402 270L401 270L401 272L400 272L400 272L400 272L400 272L400 273L400 273L400 273L399 273L399 273L399 273L399 274L399 274L399 274L399 274L399 274L399 274L399 275L399 275L399 275L399 275L398 275L399 276L400 276L402 277L403 278L405 278L407 279L408 279L410 280L411 281L413 283L414 284L416 285L416 285L417 285L418 284L419 284L421 283L421 283L422 283L423 283L423 283L425 283L426 282L427 282L429 280L428 279L427 279L427 278L427 278L427 278L426 278L426 278L426 278L426 277L426 278L425 277L424 278L424 278L424 278L424 278L424 277L424 277L424 277L423 277L423 276L422 276L422 275L422 275L422 275L422 275L421 275L421 275L421 275L420 275L420 274L420 274L419 274L418 274L418 274L418 273L418 273L418 273L418 273L417 272L417 272L417 272L417 271L418 271L417 271L417 270L417 270L417 270L417 270L416 270L416 269L416 269L416 269L416 268L416 268L416 268L416 267L416 267L416 267L416 267L415 267L415 267L414 266L414 266L413 266L412 266L411 265L411 265L411 265L411 264L412 264L412 264L412 263L412 263L412 262L411 262L411 262L411 262L411 262L411 262L411 261L411 261L411 261L410 261L410 260z"
        },
        {
            "title": "Palakurthy",
            "d": "M387 222L387 222L387 223L387 223L389 222L389 222L389 222L389 222L390 222L390 222L390 222L390 222L391 222L391 223L391 223L391 223L391 223L391 223L391 224L391 225L391 225L392 225L391 225L391 226L391 226L392 227L392 229L393 230L393 230L394 230L395 230L395 230L396 230L397 230L398 231L398 231L399 231L400 231L400 231L401 230L402 230L403 230L403 230L404 231L404 231L405 230L405 231L404 232L404 232L404 232L405 233L404 233L405 233L405 233L407 234L407 234L410 234L410 234L412 236L412 235L413 234L413 234L413 233L414 233L414 232L414 232L414 232L414 232L414 231L415 232L415 232L415 232L416 232L416 232L416 232L417 232L417 232L418 233L419 233L419 232L419 232L419 231L419 231L419 231L419 231L420 231L420 230L420 230L420 229L421 229L421 228L421 228L421 228L421 228L421 227L420 226L419 226L419 226L419 226L419 227L418 228L417 228L417 228L417 228L417 229L417 228L417 229L417 229L417 229L416 229L415 229L413 228L412 228L412 228L411 228L409 226L406 224L406 223L407 223L405 222L405 222L401 221L399 221L395 220L393 219L393 218L392 218L390 217L390 217L390 215L390 214L390 214L390 214L391 213L391 213L391 211L389 210L389 211L388 212L388 215L387 215L387 216L387 217L386 217L386 217L386 217L386 218L386 218L386 218L386 219L386 220L386 220L387 222z"
        },
        {
            "title": "Peddapalli",
            "d": "M412 236L410 234L410 234L407 234L407 234L405 233L405 233L404 233L405 233L404 232L404 232L404 232L405 231L405 230L404 231L404 231L403 230L403 230L402 230L401 230L400 231L400 231L399 231L398 231L398 231L397 230L396 230L395 230L395 230L394 230L394 231L393 231L392 230L392 230L392 231L391 231L391 231L391 231L391 231L391 231L390 231L390 230L390 230L390 230L390 231L389 231L389 231L390 231L390 232L390 233L389 233L390 233L389 235L389 235L389 235L390 236L390 236L390 236L391 236L392 237L391 238L391 238L391 238L391 239L390 241L390 241L390 241L390 242L390 242L390 243L390 243L390 243L390 243L390 243L390 244L390 244L390 244L390 245L389 246L390 246L391 246L392 247L392 247L392 247L392 247L393 247L394 247L394 247L394 247L394 247L394 247L394 248L394 248L394 248L394 249L394 250L394 250L394 250L395 251L396 251L397 252L397 252L397 253L397 253L397 254L397 254L397 255L397 255L397 256L397 256L397 256L397 256L398 256L398 256L398 256L398 257L398 257L399 257L399 257L399 257L399 257L399 258L399 257L399 257L399 257L400 257L400 256L401 256L401 256L402 256L402 257L402 257L402 257L402 257L402 257L402 258L403 258L403 258L403 258L403 258L403 259L403 259L403 259L403 259L403 260L404 260L404 259L404 260L405 260L405 260L405 260L405 260L405 260L406 260L406 260L407 259L407 259L407 259L408 259L409 260L409 260L410 260L410 260L410 260L410 260L410 260L410 260L410 259L410 259L410 259L410 258L410 258L410 258L411 258L411 257L411 257L412 257L412 257L413 257L413 258L414 256L414 256L414 256L414 256L415 256L415 256L416 254L415 254L416 253L416 253L417 253L417 252L417 252L417 252L417 252L417 251L418 251L418 250L418 250L419 248L419 247L417 247L416 244L416 243L416 241L417 241L417 240L417 240L416 240L416 240L416 240L415 240L413 239L413 239L413 239L413 238L413 238L413 238L413 237L413 237L413 237L413 236L413 236L412 236L412 236L412 236z"
        },
        {
            "title": "Ramagiri",
            "d": "M437 224L436 224L435 222L434 221L433 220L432 219L430 218L429 217L428 217L428 218L428 218L427 220L427 222L426 224L424 224L424 227L426 227L425 229L425 229L425 229L425 229L425 229L425 229L425 229L425 230L425 231L425 231L425 231L425 231L425 231L425 231L425 231L426 232L427 233L427 234L428 234L429 234L429 234L429 236L428 237L428 237L429 239L429 239L429 239L429 240L428 240L428 240L428 240L428 240L428 240L427 241L427 240L426 240L425 239L424 239L423 239L422 239L421 241L421 241L421 241L422 242L421 244L420 246L420 247L424 252L423 253L424 254L425 254L427 256L429 258L431 258L432 258L435 259L435 259L434 257L434 257L434 257L433 257L433 257L433 256L432 256L431 255L431 255L431 255L431 254L431 254L431 254L431 255L431 255L430 254L430 253L430 253L431 253L432 253L432 253L433 252L432 252L432 251L433 250L434 251L434 251L434 251L434 251L434 251L435 252L435 252L435 252L435 252L435 252L435 252L436 253L436 253L436 253L440 253L442 256L444 253L445 253L445 251L445 250L445 250L444 250L444 250L444 250L444 250L443 250L443 251L442 251L442 251L441 251L440 251L440 250L440 249L439 249L439 248L439 248L437 248L438 247L438 246L438 245L438 245L438 244L438 244L438 244L438 244L438 242L438 242L439 241L438 241L438 241L438 241L438 241L437 241L437 241L437 241L437 241L437 241L436 241L436 241L435 241L435 241L435 241L435 240L435 240L435 240L435 239L435 239L435 239L436 239L435 239L435 239L434 239L434 239L434 239L434 239L433 239L433 239L433 239L433 240L432 239L432 239L432 239L432 239L432 239L432 239L432 238L431 236L432 235L432 234L433 235L433 233L433 232L433 231L433 231L433 229L434 228L434 228L435 227L435 227L436 227L436 226L436 226L436 226L436 226L437 225L437 225L437 224z"
        },
        {
            "title": "Ramagundam",
            "d": "M420 214L419 212L417 211L416 209L413 208L412 209L412 210L412 210L412 211L412 211L412 212L412 212L412 213L412 213L412 214L412 214L411 214L410 215L409 216L409 216L406 219L406 219L409 219L409 220L409 220L410 220L410 220L410 220L411 220L411 220L411 221L411 221L411 222L411 222L411 222L410 222L410 223L411 224L409 225L409 226L411 228L412 228L412 228L413 228L415 229L416 229L417 229L417 229L417 229L417 228L417 229L417 228L417 228L417 228L418 228L419 227L419 226L419 226L419 226L420 226L421 227L421 227L421 228L421 228L422 228L421 229L422 229L422 229L422 229L422 230L422 230L422 230L422 231L423 231L422 232L422 233L422 233L422 234L422 234L422 234L422 234L422 234L422 234L423 234L423 234L422 234L422 234L423 234L423 235L423 235L423 235L423 234L424 235L424 235L424 235L424 235L424 235L425 235L425 235L425 235L426 235L426 235L427 234L427 234L427 233L426 232L425 231L425 231L425 231L425 231L425 231L425 231L425 231L425 230L425 229L425 229L425 229L425 229L425 229L425 229L425 229L426 227L424 227L424 224L426 224L427 222L427 220L428 218L428 218L428 217L427 217L426 216L425 216L423 216L422 216L422 216L421 215L421 215L420 214z"
        },
        {
            "title": "Srirampur",
            "d": "M435 259L432 258L431 258L429 258L427 256L425 254L424 254L423 253L424 252L420 247L420 247L419 248L418 250L418 250L418 251L417 251L417 252L417 252L417 252L417 252L417 253L416 253L416 253L415 254L416 254L415 256L415 256L414 256L414 256L414 256L414 256L413 258L413 257L412 257L412 257L411 257L411 257L411 258L410 258L410 258L410 258L410 259L410 259L410 259L410 260L410 260L410 260L410 260L410 260L410 261L411 261L411 261L411 261L411 262L411 262L411 262L411 262L411 262L412 262L412 263L412 263L412 264L412 264L411 264L411 265L411 265L411 265L412 266L413 266L414 266L414 266L415 267L415 267L416 267L416 267L416 267L416 267L416 268L416 268L416 268L416 269L416 269L416 269L416 270L417 270L417 270L417 270L417 270L417 271L418 271L417 271L417 272L417 272L417 272L418 273L418 273L418 273L418 273L418 274L418 274L419 274L420 274L420 274L420 275L421 275L421 275L421 275L422 275L422 275L422 275L422 275L422 276L423 276L423 277L424 277L424 277L424 277L424 278L424 278L424 278L424 278L425 277L426 278L426 277L426 278L426 278L426 278L427 278L427 278L427 278L427 279L428 279L429 280L429 280L431 278L432 278L432 278L432 277L432 277L433 277L434 275L434 275L434 275L434 275L435 274L435 273L435 273L435 272L435 272L435 271L435 271L435 270L436 270L436 270L435 270L435 269L434 268L434 268L434 268L434 267L433 268L433 267L433 267L434 266L435 266L435 265L435 264L434 264L432 263L432 262L431 262L432 262L433 261L433 260L433 260L433 260L433 260L433 260L433 260L433 260L433 260L434 260L434 259L435 259z"
        },
        {
            "title": "Sultanabad",
            "d": "M403 259L403 259L403 259L403 259L403 258L403 258L403 258L403 258L402 258L402 257L402 257L402 257L402 257L402 257L402 256L401 256L401 256L400 256L400 257L399 257L399 257L399 257L399 258L399 257L399 257L399 257L399 257L398 257L398 257L398 256L398 256L398 256L397 256L397 256L397 256L397 256L397 255L397 255L397 254L397 254L397 253L397 253L397 252L397 252L396 251L395 251L394 250L394 250L394 250L394 249L394 248L394 248L394 248L394 247L394 247L394 247L394 247L394 247L393 247L392 247L392 247L392 247L392 247L391 246L391 247L391 247L391 248L391 248L391 248L391 248L391 248L391 248L391 248L391 248L390 248L390 248L390 248L390 248L390 249L389 249L389 248L389 248L389 249L389 249L389 249L389 249L389 250L389 250L389 250L388 251L388 251L388 252L388 251L388 252L389 252L389 252L389 253L389 253L390 253L390 253L390 254L390 254L390 255L391 255L391 255L391 255L390 257L390 257L390 257L390 257L389 257L389 257L388 257L388 257L388 257L388 257L387 257L387 257L386 257L386 257L386 257L386 258L386 258L386 258L385 258L385 259L385 259L385 259L384 260L384 260L384 260L384 261L384 261L384 262L384 262L384 262L383 262L383 263L383 263L382 263L382 263L382 263L382 263L381 262L381 262L381 262L380 263L380 263L380 263L380 263L380 263L380 263L380 263L380 264L379 263L379 264L379 263L379 263L378 263L378 263L378 263L378 263L378 263L378 262L378 261L378 261L378 261L377 261L377 261L377 261L377 261L376 261L375 261L375 260L374 260L374 260L374 260L374 260L374 261L373 261L373 262L373 262L374 263L374 264L375 264L374 264L375 264L374 265L374 265L374 266L374 266L374 267L375 267L375 267L375 267L374 268L374 268L375 268L375 269L375 270L375 270L375 271L375 271L375 271L375 271L375 272L375 272L375 272L375 272L376 273L376 273L376 273L377 274L378 273L378 273L380 272L382 270L383 268L384 268L385 268L386 268L388 268L390 269L392 270L394 272L395 272L396 273L398 275L399 275L399 275L399 275L399 275L399 274L399 274L399 274L399 274L399 274L399 274L399 273L399 273L399 273L400 273L400 273L400 273L400 272L400 272L400 272L400 272L401 272L401 270L402 270L402 269L402 268L402 267L403 265L403 264L403 263L404 262L403 262L403 262L403 262L403 262L403 262L403 262L401 261L402 260L402 260L402 260L403 259z"
        },
        {
            "title": "Anthergaon",
            "d": "M409 226L409 225L411 224L410 223L410 222L411 222L411 222L411 222L411 221L411 221L411 220L411 220L410 220L410 220L410 220L409 220L409 220L409 219L406 219L406 219L409 216L409 216L410 215L411 214L412 214L412 214L412 213L412 213L412 212L412 212L412 211L412 211L412 210L412 210L412 209L413 208L412 207L412 207L412 207L409 205L407 204L406 204L404 204L403 204L401 204L400 204L399 205L399 206L398 208L397 209L396 210L396 210L394 210L393 211L391 211L391 213L391 213L390 214L390 214L390 214L390 215L390 217L390 217L392 218L393 218L393 219L395 220L399 221L401 221L405 222L405 222L407 223L406 223L406 224L409 226z"
        }
    ],
    "Mulugu": [
        {
            "title": "Eturnagaram",
            "d": "M579 294L578 293L577 292L577 290L577 290L577 289L578 287L578 286L579 283L579 281L578 277L578 276L577 274L575 273L573 272L573 273L573 275L573 277L573 278L572 278L572 278L572 279L570 279L570 279L569 279L569 280L567 280L564 279L563 279L563 277L559 277L556 282L552 282L549 285L550 288L552 288L552 288L549 290L549 290L548 290L547 291L547 291L546 292L547 293L548 296L550 299L553 298L554 297L554 298L556 301L557 304L558 306L558 307L559 308L559 309L566 310L568 311L570 312L570 312L571 311L573 311L573 310L573 310L573 309L573 308L574 308L574 309L576 306L576 306L577 304L578 303L579 303L580 302L580 302L581 301L583 300L582 298L579 294z"
        },
        {
            "title": "Govindaraopet",
            "d": "M525 337L526 337L527 337L529 338L530 335L533 331L533 330L535 327L531 326L529 326L529 325L530 325L530 324L529 324L529 323L529 323L530 323L530 323L532 323L535 324L538 324L542 323L544 323L545 322L545 321L545 319L545 317L545 317L546 316L546 315L546 315L543 314L542 311L542 311L543 310L543 310L542 309L542 310L539 309L538 308L537 307L536 307L536 307L535 307L535 307L534 307L534 308L534 308L534 309L533 310L531 308L532 304L535 303L533 302L532 301L528 302L526 303L525 303L522 303L521 304L519 304L517 304L514 304L511 304L509 305L507 305L507 305L507 306L506 307L506 309L507 311L508 312L508 312L508 312L508 312L508 312L509 313L510 313L510 314L512 314L510 314L510 314L510 314L510 314L510 315L509 315L509 315L508 315L508 315L507 315L507 315L506 315L505 314L505 314L505 314L505 314L505 315L505 315L505 316L501 315L501 316L501 317L501 318L502 318L502 318L503 318L503 319L504 319L506 321L507 321L508 322L508 322L508 322L509 323L509 323L509 323L510 324L511 325L513 325L513 325L514 325L514 325L519 325L520 325L521 326L521 326L522 327L523 328L524 331L524 334L525 336L525 337z"
        },
        {
            "title": "Kannaigudem",
            "d": "M573 272L572 272L569 272L568 272L567 271L565 270L564 269L564 267L564 264L564 262L564 261L565 259L567 255L567 254L568 253L567 252L567 250L566 249L566 249L565 248L565 247L564 247L563 247L562 248L561 249L560 249L560 249L559 249L558 250L558 250L558 250L558 250L557 250L557 250L557 250L557 250L553 250L549 251L547 251L543 254L541 256L540 257L541 262L542 265L539 271L539 274L539 278L539 280L538 282L538 284L540 284L540 284L541 284L540 284L539 286L542 287L542 288L541 290L541 290L543 290L546 291L546 292L547 291L547 291L548 290L549 290L549 290L552 288L552 288L550 288L549 285L552 282L556 282L559 277L563 277L563 279L564 279L567 280L569 280L569 279L570 279L570 279L572 279L572 278L572 278L573 278L573 277L573 275L573 273L573 272z"
        },
        {
            "title": "Mangapet",
            "d": "M619 329L613 322L611 320L607 316L602 312L599 310L596 308L587 303L584 301L583 300L581 301L580 302L580 302L579 303L578 303L577 304L576 306L576 306L574 309L574 308L573 308L573 309L573 310L573 310L573 311L571 311L570 312L570 312L570 312L569 313L569 316L572 317L572 320L572 321L574 321L574 323L574 324L574 324L574 326L578 328L579 328L580 329L580 329L582 328L582 328L584 327L584 327L585 327L585 328L584 328L584 328L584 328L585 329L585 330L586 330L587 331L587 332L587 332L588 333L589 334L589 334L589 334L590 336L592 335L592 335L592 334L593 334L594 334L594 334L594 334L595 335L597 336L598 337L600 338L601 338L601 338L601 338L602 337L602 337L602 336L603 334L603 334L604 333L604 333L603 332L603 332L604 332L604 333L607 333L608 331L607 330L607 331L606 331L605 330L605 330L605 329L606 328L606 328L606 328L607 328L608 329L609 329L610 328L610 327L610 327L610 327L610 326L611 326L611 325L611 325L611 325L612 325L612 325L612 325L613 325L614 326L614 327L614 327L614 328L613 330L613 330L614 331L614 331L613 331L613 332L612 333L613 333L613 333L614 334L615 332L617 330L617 330L619 329z"
        },
        {
            "title": "Mulug",
            "d": "M505 314L504 314L503 314L502 313L502 313L502 313L500 312L498 311L498 312L497 312L496 313L495 312L495 311L494 311L493 310L493 309L493 309L492 310L491 312L491 312L490 312L489 312L488 313L487 314L487 314L486 316L486 316L486 316L485 316L485 316L484 316L482 317L482 317L480 317L479 317L479 317L478 318L475 319L477 322L476 324L476 324L477 324L478 325L478 325L478 325L479 326L479 329L480 329L482 328L482 328L483 328L483 327L483 327L484 326L487 325L487 325L488 326L488 326L489 326L489 326L489 327L490 328L491 329L492 330L492 330L492 330L492 331L492 332L492 332L493 333L494 334L495 336L495 336L495 336L496 336L496 336L497 334L497 334L498 333L498 333L501 336L502 338L507 335L505 332L505 332L507 332L508 332L508 332L508 332L509 333L509 333L511 336L514 338L515 339L515 339L515 340L515 340L516 340L517 339L518 338L519 338L520 338L521 338L521 338L521 338L523 338L523 337L525 337L525 337L525 336L524 334L524 331L523 328L522 327L521 326L521 326L520 325L519 325L514 325L514 325L513 325L513 325L511 325L510 324L509 323L509 323L509 323L508 322L508 322L508 322L507 321L506 321L504 319L503 319L503 318L502 318L502 318L501 318L501 317L501 316L501 315L505 316L505 315L505 315L505 314L505 314z"
        },
        {
            "title": "Tadvai (Sammakka Sarakka)",
            "d": "M546 292L546 291L543 290L541 290L541 290L542 288L542 287L539 286L540 284L541 284L540 284L540 284L538 284L538 285L531 292L529 291L529 291L529 291L529 291L528 291L529 290L528 290L528 289L528 290L527 289L527 289L527 289L526 289L526 289L526 289L526 288L525 287L525 287L525 288L524 288L524 287L524 287L524 286L524 286L521 287L521 287L521 286L520 287L521 289L520 290L520 291L520 292L519 293L521 295L523 298L524 299L525 300L525 300L525 300L526 299L527 299L528 299L529 299L532 301L533 302L535 303L532 304L531 308L533 310L534 309L534 308L534 308L534 307L535 307L535 307L536 307L536 307L537 307L538 308L539 309L542 310L542 309L543 310L543 310L542 311L542 311L543 314L546 315L546 315L546 316L545 317L545 317L545 319L545 321L545 322L544 323L542 323L538 324L535 324L532 323L530 323L530 323L529 323L529 323L529 324L530 324L530 325L529 325L529 326L531 326L535 327L533 330L533 331L530 335L529 338L527 337L526 337L525 337L525 337L523 337L523 338L521 338L523 340L525 343L526 343L527 344L531 346L535 348L535 349L536 349L537 349L537 350L537 350L539 348L539 348L540 348L542 349L543 349L543 349L544 349L544 349L547 351L548 352L549 352L549 352L549 352L549 352L549 352L550 352L550 352L550 352L551 352L553 352L554 353L555 352L556 351L558 350L559 346L559 344L566 338L566 338L566 339L568 340L573 342L574 342L574 342L575 342L576 341L577 343L577 343L577 342L577 342L577 341L577 340L577 340L577 339L577 339L577 338L579 336L580 333L581 330L580 329L580 329L579 328L578 328L574 326L574 324L574 324L574 323L574 321L572 321L572 320L572 317L569 316L569 313L570 312L570 312L568 311L566 310L559 309L559 308L558 307L558 306L557 304L556 301L554 298L554 297L553 298L550 299L548 296L547 293L546 292z"
        },
        {
            "title": "Venkatapur",
            "d": "M521 286L520 285L519 284L519 284L519 284L519 284L518 284L516 285L515 285L513 284L512 284L511 283L511 283L510 283L509 283L507 283L506 283L506 283L505 284L502 285L501 285L497 285L497 285L497 286L497 287L496 288L494 289L494 289L494 290L494 290L493 291L493 292L494 292L494 292L494 292L494 292L494 292L494 293L494 293L494 294L494 294L494 294L493 297L493 297L493 298L492 299L492 299L492 299L492 299L492 299L492 299L492 299L492 299L491 299L490 299L490 299L489 299L489 299L489 298L488 298L488 298L488 299L488 299L488 298L487 299L487 298L486 298L486 298L486 298L485 297L485 298L485 298L484 298L485 299L484 299L483 300L483 300L483 300L483 300L483 301L483 301L483 302L483 302L483 302L484 302L484 302L483 303L483 303L483 302L482 303L482 303L482 303L482 303L481 303L481 304L481 304L480 305L480 306L480 306L480 306L480 306L480 306L480 306L480 306L480 306L480 306L480 307L480 307L479 307L479 307L479 307L479 307L479 308L478 309L478 309L478 309L478 309L478 308L478 308L478 309L478 308L478 309L478 310L478 312L479 313L479 313L479 316L479 316L479 317L480 317L482 317L482 317L484 316L485 316L485 316L486 316L486 316L486 316L487 314L487 314L488 313L489 312L490 312L491 312L491 312L492 310L493 309L493 309L493 310L494 311L495 311L495 312L496 313L497 312L498 312L498 311L500 312L502 313L502 313L502 313L503 314L504 314L505 314L505 314L505 314L506 315L507 315L507 315L508 315L508 315L509 315L509 315L510 315L510 314L510 314L510 314L510 314L512 314L510 314L510 313L509 313L508 312L508 312L508 312L508 312L508 312L507 311L506 309L506 307L507 306L507 305L507 305L509 305L511 304L514 304L517 304L519 304L521 304L522 303L525 303L526 303L528 302L532 301L529 299L528 299L527 299L526 299L525 300L525 300L525 300L524 299L523 298L521 295L519 293L520 292L520 291L520 290L521 289L520 287L521 286z"
        },
        {
            "title": "Venkatapuram",
            "d": "M628 323L626 323L625 323L624 323L623 322L623 321L623 314L623 314L628 312L630 310L631 310L633 309L633 309L633 308L633 307L632 307L632 307L631 307L630 306L630 304L629 303L628 302L628 302L627 302L627 302L627 302L627 301L627 301L627 300L626 300L626 299L625 299L625 299L625 298L625 295L625 295L624 294L624 293L623 293L623 291L622 289L622 288L622 288L622 287L622 287L621 286L621 285L621 284L622 284L623 283L623 282L623 281L622 281L621 281L621 281L620 282L617 280L617 279L617 279L617 277L617 277L618 276L618 276L617 276L616 275L615 275L615 275L615 275L615 275L610 279L608 280L605 280L603 281L603 281L601 282L600 283L597 283L596 284L594 285L593 285L594 286L593 287L593 288L593 288L592 287L592 287L591 288L590 288L589 289L589 288L589 288L589 287L589 287L589 287L589 286L589 286L589 286L588 286L588 286L588 286L587 286L586 288L582 291L582 292L581 292L581 293L579 293L579 294L582 298L583 300L584 301L587 303L596 308L599 310L602 312L607 316L611 320L613 322L619 329L620 330L623 334L624 333L624 333L624 333L624 333L624 332L624 332L624 331L624 331L624 330L624 330L623 331L623 331L623 331L623 331L623 330L623 330L623 329L623 329L623 329L624 329L624 330L624 330L624 330L624 330L624 329L624 329L624 329L624 328L624 328L624 328L623 328L623 328L623 328L623 327L623 327L624 327L625 326L627 325L628 324L628 323z"
        },
        {
            "title": "Wazeed",
            "d": "M615 275L615 273L614 273L613 272L612 272L611 271L610 270L610 270L610 270L609 269L608 267L608 267L607 266L607 265L607 265L608 264L608 264L608 264L607 263L607 262L607 262L606 262L606 262L605 262L605 261L604 261L604 261L604 261L603 259L603 259L603 259L602 258L602 258L601 257L601 257L599 256L596 255L596 254L595 253L594 252L592 251L591 251L590 251L590 250L590 249L589 248L588 247L588 247L588 247L588 246L587 245L585 245L584 244L583 243L581 243L581 244L580 244L579 244L579 244L578 244L578 243L577 243L577 243L577 244L575 244L575 245L574 245L574 246L573 246L572 246L572 246L571 246L571 246L571 247L570 247L569 247L569 247L567 247L567 248L567 248L567 248L566 249L566 249L567 250L567 252L568 253L567 254L567 255L565 259L564 261L564 262L564 264L564 267L564 269L565 270L567 271L568 272L569 272L572 272L573 272L575 273L577 274L578 276L578 277L579 281L579 283L578 286L578 287L577 289L577 290L577 290L577 292L578 293L579 294L579 293L581 293L581 292L582 292L582 291L586 288L587 286L588 286L588 286L588 286L589 286L589 286L589 286L589 287L589 287L589 287L589 288L589 288L589 289L590 288L591 288L592 287L592 287L593 288L593 288L593 287L594 286L593 285L594 285L596 284L597 283L600 283L601 282L603 281L603 281L605 280L608 280L610 279L615 275L615 275z"
        },
        {
            "title": "Mallampally",
            "d": "M472 332L472 335L472 335L471 336L472 335L472 335L474 335L476 335L476 335L476 335L478 335L478 335L479 335L479 336L483 335L482 336L484 337L484 337L490 337L491 337L494 337L495 336L495 336L494 334L493 333L492 332L492 332L492 331L492 330L492 330L492 330L491 329L490 328L489 327L489 326L489 326L488 326L488 326L487 325L487 325L484 326L483 327L483 327L483 328L482 328L482 328L480 329L479 329L479 326L478 325L478 325L478 325L477 324L476 324L478 326L476 329L475 330L472 332z"
        }
    ]
};


/** Canonical hotspot bundle keys in `telanganaMandalHotspots.ts` per district slug. */ const $140f024760b747e8$var$MANDAL_HOTSPOT_KEY_BY_DISTRICT = {
    adilabad: "Adilabad",
    bhadradri_kothagudem: "Bhadradri Kothagudem",
    hanumakonda: "Hanumakonda",
    hyderabad: "Hyderabad",
    jagtial: "Jagtial",
    jangaon: "Jangaon",
    jayashankar_bhupalpally: "Jayashankar Bhupalpally",
    jogulamba_gadwal: "Jogulamba Gadwal",
    kamareddy: "Kamareddy",
    karimnagar: "Karimnagar",
    khammam: "Khammam",
    komaram_bheem_asifabad: "Kumurambheem Asifabad",
    mahabubabad: "Mahabubabad",
    mahbubnagar: "Mahabubnagar",
    mancherial: "Mancherial",
    medak: "Medak",
    medchal_malkajgiri: "Medchal Malkajgiri",
    mulugu: "Mulugu",
    nagarkurnool: "Nagarkurnool",
    nalgonda: "Nalgonda",
    narayanpet: "Narayanpet",
    nirmal: "Nirmal",
    nizamabad: "Nizamabad",
    peddapalli: "Peddapalli",
    rajanna_sircilla: "Rajanna Sircilla",
    rangareddy: "Rangareddy",
    sangareddy: "Sangareddy",
    siddipet: "Siddipet",
    suryapet: "Suryapet",
    vikarabad: "Vikarabad",
    wanaparthy: "Wanaparthy",
    warangal: "Warangal",
    yadadri_bhuvanagiri: "Yadadri Bhuvanagiri"
};
function $140f024760b747e8$export$3831cb67e26bab53(districtKey) {
    const bundleKey = $140f024760b747e8$var$MANDAL_HOTSPOT_KEY_BY_DISTRICT[districtKey];
    const rows = bundleKey ? (0, $ec5d2c981391d238$export$94e7442ac4938ea2)[bundleKey] : null;
    return rows && rows.length > 0 ? rows : null;
}
function $140f024760b747e8$export$a10efc13226e24f(districtKey) {
    return $140f024760b747e8$export$3831cb67e26bab53(districtKey)?.length ?? 0;
}
function $140f024760b747e8$export$65b97ac488b58d55(d) {
    const nums = [];
    const re = /[-+]?(?:\d*\.\d+|\d+)/g;
    let m;
    while((m = re.exec(d)) !== null)nums.push(Number(m[0]));
    if (nums.length < 4) return null;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    for(let i = 0; i + 1 < nums.length; i += 2){
        const x = nums[i];
        const y = nums[i + 1];
        if (x < minX) minX = x;
        if (x > maxX) maxX = x;
        if (y < minY) minY = y;
        if (y > maxY) maxY = y;
    }
    if (!Number.isFinite(minX)) return null;
    return {
        minX: minX,
        minY: minY,
        maxX: maxX,
        maxY: maxY
    };
}
function $140f024760b747e8$export$ba68f750b870c31f(d) {
    const b = $140f024760b747e8$export$65b97ac488b58d55(d);
    if (!b) return null;
    return {
        x: (b.minX + b.maxX) / 2,
        y: (b.minY + b.maxY) / 2
    };
}
function $140f024760b747e8$export$7c66c19fa454f37c(title, maxCharsPerLine = 14) {
    const t = title.trim();
    if (!t) return [];
    if (t.length <= maxCharsPerLine) return [
        t
    ];
    const words = t.split(/\s+/).filter(Boolean);
    if (words.length >= 2) {
        const mid = Math.ceil(words.length / 2);
        const a = words.slice(0, mid).join(" ");
        const b = words.slice(mid).join(" ");
        if (a.length <= maxCharsPerLine && b.length <= maxCharsPerLine) return [
            a,
            b
        ];
    }
    if (t.length <= maxCharsPerLine + 6) return [
        t
    ];
    const breakAt = t.lastIndexOf(" ", maxCharsPerLine);
    if (breakAt > 5) return [
        t.slice(0, breakAt),
        t.slice(breakAt + 1)
    ];
    const half = Math.ceil(t.length / 2);
    return [
        t.slice(0, half),
        t.slice(half)
    ];
}
function $140f024760b747e8$var$abbreviateMandalTitle(title, maxChars) {
    if (maxChars < 4) return "";
    const t = title.trim();
    if (t.length <= maxChars) return t;
    if (maxChars >= 7) return `${t.slice(0, maxChars - 1)}\u{2026}`;
    return t.slice(0, maxChars);
}
const $140f024760b747e8$var$CHAR_WIDTH_EM = 0.52;
const $140f024760b747e8$var$LINE_HEIGHT_EM = 1.12;
function $140f024760b747e8$var$textFitsBox(lines, fontSize, boxW, boxH) {
    const maxLen = Math.max(...lines.map((l)=>l.length), 1);
    const textW = maxLen * fontSize * $140f024760b747e8$var$CHAR_WIDTH_EM;
    const textH = lines.length * fontSize * $140f024760b747e8$var$LINE_HEIGHT_EM;
    return textW <= boxW * 0.82 && textH <= boxH * 0.78;
}
function $140f024760b747e8$export$8771cff0a3f2cd53(title, boxW, boxH, opts = {}) {
    const maxFontCap = opts.maxFontSize ?? 9;
    const minFont = opts.minFontSize ?? 2.5;
    if (boxW < 14 || boxH < 10 || Math.min(boxW, boxH) < 8) return {
        lines: [],
        fontSize: 0,
        hide: true
    };
    const fitW = boxW * 0.88;
    const fitH = boxH * 0.86;
    const maxChars = Math.max(3, Math.floor(fitW / ($140f024760b747e8$var$CHAR_WIDTH_EM * 4.2)));
    let lines = $140f024760b747e8$export$7c66c19fa454f37c(title, maxChars);
    const boxMaxFromSize = Math.min(fitW, fitH) * 0.26;
    const maxFont = Math.min(maxFontCap, boxMaxFromSize);
    let fontSize = Math.min(fitH * 0.3, fitW / (Math.max(...lines.map((l)=>l.length), 1) * $140f024760b747e8$var$CHAR_WIDTH_EM + 0.55), fitH / (lines.length * $140f024760b747e8$var$LINE_HEIGHT_EM + 0.3), maxFont);
    fontSize = Math.max(minFont, fontSize);
    while(fontSize > minFont && !$140f024760b747e8$var$textFitsBox(lines, fontSize, fitW, fitH))fontSize -= 0.2;
    if (!$140f024760b747e8$var$textFitsBox(lines, fontSize, fitW, fitH)) {
        const short = $140f024760b747e8$var$abbreviateMandalTitle(title, Math.max(3, Math.floor(fitW / (fontSize * $140f024760b747e8$var$CHAR_WIDTH_EM + 0.2))));
        if (short) lines = [
            short
        ];
        while(fontSize > minFont && !$140f024760b747e8$var$textFitsBox(lines, fontSize, fitW, fitH))fontSize -= 0.2;
    }
    if (!$140f024760b747e8$var$textFitsBox(lines, fontSize, fitW, fitH) || fontSize < minFont + 0.05) return {
        lines: [],
        fontSize: 0,
        hide: true
    };
    return {
        lines: lines,
        fontSize: fontSize,
        hide: false
    };
}
function $140f024760b747e8$export$d3e9e1e54fec1c36(districtKey, pad = 14) {
    const mandals = $140f024760b747e8$export$3831cb67e26bab53(districtKey);
    if (!mandals?.length) return null;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    for (const row of mandals){
        const b = $140f024760b747e8$export$65b97ac488b58d55(row.d);
        if (!b) continue;
        if (b.minX < minX) minX = b.minX;
        if (b.minY < minY) minY = b.minY;
        if (b.maxX > maxX) maxX = b.maxX;
        if (b.maxY > maxY) maxY = b.maxY;
    }
    if (!Number.isFinite(minX)) return null;
    const w = maxX - minX + pad * 2;
    const h = maxY - minY + pad * 2;
    return `${minX - pad} ${minY - pad} ${w} ${h}`;
}
function $140f024760b747e8$export$930ac6ffed12de94() {
    for (const d of (0, $72c1e8625e9e63b5$export$c213a939d88ef2f8)){
        if (!$140f024760b747e8$export$3831cb67e26bab53(d.key)) throw new Error(`Missing mandal hotspots for district: ${d.key}`);
    }
}



function $9b6bb3ee4d9c26ed$var$aggregateByDistrict(apps) {
    const applicants = new Map();
    const beneficiaries = new Map();
    for (const d of (0, $72c1e8625e9e63b5$export$c213a939d88ef2f8)){
        applicants.set(d.key, 0);
        beneficiaries.set(d.key, 0);
    }
    for (const a of apps){
        const dk = (0, $72c1e8625e9e63b5$export$768d2fc1615cd5ac)(a.district);
        if (!dk) continue;
        applicants.set(dk, (applicants.get(dk) ?? 0) + 1);
        if (a.status === "subcontractor_linked") beneficiaries.set(dk, (beneficiaries.get(dk) ?? 0) + 1);
    }
    return {
        applicants: applicants,
        beneficiaries: beneficiaries
    };
}
function $9b6bb3ee4d9c26ed$var$labelForKey(key) {
    return (0, $72c1e8625e9e63b5$export$c213a939d88ef2f8).find((d)=>d.key === key)?.label ?? key;
}
function $9b6bb3ee4d9c26ed$var$labelLinesForKey(key) {
    const meta = (0, $72c1e8625e9e63b5$export$c213a939d88ef2f8).find((d)=>d.key === key);
    if (meta && meta.lines.length > 1) return [
        ...meta.lines
    ];
    return [
        $9b6bb3ee4d9c26ed$var$labelForKey(key)
    ];
}
function $9b6bb3ee4d9c26ed$export$1725e0d0fbb66142({ applications: applications, className: className }) {
    const { store: geoStore, loading: geoLoading, error: geoError } = (0, $60dd8507bac67e50$export$5ec0231075ddedf1)();
    const [active, setActive] = (0, $7UyaH.useState)(null);
    const [drilledDistrict, setDrilledDistrict] = (0, $7UyaH.useState)(null);
    const [pointerClient, setPointerClient] = (0, $7UyaH.useState)(null);
    const frameRef = (0, $7UyaH.useRef)(null);
    const { applicants: applicants, beneficiaries: beneficiaries } = (0, $7UyaH.useMemo)(()=>$9b6bb3ee4d9c26ed$var$aggregateByDistrict(applications), [
        applications
    ]);
    const activeMeta = active ? (0, $72c1e8625e9e63b5$export$c213a939d88ef2f8).find((d)=>d.key === active) : null;
    const aCount = active ? applicants.get(active) ?? 0 : 0;
    const bCount = active ? beneficiaries.get(active) ?? 0 : 0;
    const statewide = (0, $7UyaH.useMemo)(()=>{
        let totalApplicants = 0;
        let totalBeneficiaries = 0;
        for (const d of (0, $72c1e8625e9e63b5$export$c213a939d88ef2f8)){
            const a = applicants.get(d.key) ?? 0;
            const b = beneficiaries.get(d.key) ?? 0;
            totalApplicants += a;
            totalBeneficiaries += b;
        }
        return {
            totalApplicants: totalApplicants,
            totalBeneficiaries: totalBeneficiaries
        };
    }, [
        applicants,
        beneficiaries
    ]);
    const directoryTotals = (0, $7UyaH.useMemo)(()=>geoStore ? geoStore.tgDirectoryAggregateCounts() : null, [
        geoStore
    ]);
    const activeDirectory = (0, $7UyaH.useMemo)(()=>active && geoStore ? geoStore.tgDirectoryCountsForDistrict(active) : null, [
        active,
        geoStore
    ]);
    const tooltipPosition = (0, $7UyaH.useMemo)(()=>{
        if (!pointerClient || !frameRef.current) return null;
        const r = frameRef.current.getBoundingClientRect();
        const pad = 12;
        const tw = 252;
        const th = 210;
        let left = pointerClient.x - r.left + pad;
        let top = pointerClient.y - r.top + pad;
        left = Math.max(8, Math.min(left, r.width - tw - 8));
        top = Math.max(8, Math.min(top, r.height - th - 8));
        return {
            left: left,
            top: top
        };
    }, [
        pointerClient,
        active
    ]);
    const sectionClass = [
        "dash-corp-map",
        className
    ].filter(Boolean).join(" ");
    const fillByIndex = (0, $7UyaH.useMemo)(()=>{
        const m = new Map();
        (0, $4bc5886b67e0c8cf$export$5f32a4a97ebcad64).forEach((row, i)=>{
            m.set(row.key, (0, $4bc5886b67e0c8cf$export$457d25dc584f8ad0)[i % (0, $4bc5886b67e0c8cf$export$457d25dc584f8ad0).length]);
        });
        return m;
    }, []);
    const drilledMeta = drilledDistrict ? (0, $72c1e8625e9e63b5$export$c213a939d88ef2f8).find((d)=>d.key === drilledDistrict) : null;
    const mandalsForDrill = (0, $7UyaH.useMemo)(()=>drilledDistrict ? (0, $140f024760b747e8$export$3831cb67e26bab53)(drilledDistrict) : null, [
        drilledDistrict
    ]);
    const isMandalView = Boolean(drilledDistrict && mandalsForDrill && mandalsForDrill.length > 0);
    const mandalViewBox = (0, $7UyaH.useMemo)(()=>drilledDistrict ? (0, $140f024760b747e8$export$d3e9e1e54fec1c36)(drilledDistrict) : null, [
        drilledDistrict
    ]);
    const svgViewBox = isMandalView && mandalViewBox ? mandalViewBox : `0 0 ${0, $4bc5886b67e0c8cf$export$8e9c23854d0b9047} ${0, $4bc5886b67e0c8cf$export$55da85ab9139dcf3}`;
    const viewBoxParts = (0, $7UyaH.useMemo)(()=>{
        const [x, y, w, h] = svgViewBox.split(/\s+/).map(Number);
        return {
            x: x,
            y: y,
            w: w,
            h: h
        };
    }, [
        svgViewBox
    ]);
    /** Match state-map border weight when zoomed to mandal viewBox. */ const mapStrokeScale = viewBoxParts.w / (0, $4bc5886b67e0c8cf$export$8e9c23854d0b9047);
    const pathStrokeWidth = 1.15 * mapStrokeScale;
    const pathStrokeWidthActive = 2.75 * mapStrokeScale;
    const mandalLabelMaxFont = viewBoxParts.w * (13 / (0, $4bc5886b67e0c8cf$export$8e9c23854d0b9047));
    const mandalLabelMinFont = Math.max(1.8, viewBoxParts.w * (5 / (0, $4bc5886b67e0c8cf$export$8e9c23854d0b9047)));
    const [labelCenters, setLabelCenters] = (0, $7UyaH.useState)({});
    const [mandalLabelCenters, setMandalLabelCenters] = (0, $7UyaH.useState)([]);
    (0, $7UyaH.useLayoutEffect)(()=>{
        const root = frameRef.current;
        if (!root) return;
        const svg = root.querySelector("svg");
        if (!svg) return;
        if (isMandalView) {
            const nodes = svg.querySelectorAll("[data-mandal-label-id]");
            const next = [];
            nodes.forEach((el)=>{
                const title = el.getAttribute("data-mandal-title")?.trim() ?? "";
                const index = Number(el.getAttribute("data-mandal-label-id"));
                if (!title || Number.isNaN(index)) return;
                const b = el.getBBox();
                next.push({
                    title: title,
                    index: index,
                    x: b.x + b.width / 2,
                    y: b.y + b.height / 2,
                    width: b.width,
                    height: b.height
                });
            });
            setMandalLabelCenters(next);
            return;
        }
        setMandalLabelCenters([]);
        const next = {};
        for (const row of (0, $4bc5886b67e0c8cf$export$5f32a4a97ebcad64)){
            const el = svg.querySelector(`#tg-path-${row.key}`);
            if (!el) continue;
            const b = el.getBBox();
            next[row.key] = {
                x: b.x + b.width / 2,
                y: b.y + b.height / 2
            };
        }
        setLabelCenters(next);
    }, [
        isMandalView,
        drilledDistrict,
        svgViewBox,
        mandalsForDrill
    ]);
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
        className: sectionClass,
        "aria-labelledby": "dash-corp-map-heading",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "dash-corp-map__head",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h1", {
                        id: "dash-corp-map-heading",
                        className: "dash-corp-map__title",
                        children: drilledMeta ? `Telangana \u{2014} ${drilledMeta.label} (mandal view)` : "Telangana \u2014 district view"
                    }),
                    drilledMeta ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        className: "dash-corp-map__subtitle text-muted",
                        children: [
                            mandalsForDrill?.length ?? 0,
                            " mandals with names \u2014 hover a subdivision for details."
                        ]
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "dash-corp-map__subtitle text-muted",
                        children: "Click a district to zoom in and show mandal boundaries."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "dash-corp-map__layout",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("figure", {
                        className: "dash-corp-map__figure",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            ref: frameRef,
                            className: "dash-corp-map__frame dash-corp-map__frame--geo",
                            onMouseLeave: ()=>{
                                setActive(null);
                                setPointerClient(null);
                            },
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "dash-corp-map__geo-clip",
                                    style: {
                                        position: 'relative'
                                    },
                                    children: [
                                        drilledDistrict && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                            className: "btn btn--sm",
                                            style: {
                                                position: 'absolute',
                                                top: 16,
                                                left: 16,
                                                zIndex: 10,
                                                background: 'var(--surface-solid)',
                                                color: 'var(--text)',
                                                border: '1px solid var(--border-strong)',
                                                borderRadius: 4,
                                                padding: '6px 12px',
                                                cursor: 'pointer',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            },
                                            onClick: ()=>{
                                                setDrilledDistrict(null);
                                                setActive(null);
                                            },
                                            children: "\u2190 Back to State View"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("svg", {
                                            className: "dash-corp-map__geo",
                                            viewBox: svgViewBox,
                                            role: "img",
                                            "aria-label": isMandalView ? `Telangana ${drilledMeta?.label ?? ""} mandal map` : "Telangana district map with selectable boundaries",
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("rect", {
                                                    className: "tg-geo-backdrop",
                                                    x: viewBoxParts.x,
                                                    y: viewBoxParts.y,
                                                    width: viewBoxParts.w,
                                                    height: viewBoxParts.h
                                                }),
                                                !isMandalView ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("g", {
                                                    className: "tg-geo-districts",
                                                    children: (0, $4bc5886b67e0c8cf$export$5f32a4a97ebcad64).map((row)=>{
                                                        const isOn = active === row.key;
                                                        const fill = fillByIndex.get(row.key) ?? "#e2e8f0";
                                                        const ac = applicants.get(row.key) ?? 0;
                                                        const bc = beneficiaries.get(row.key) ?? 0;
                                                        return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                                                            id: `tg-path-${row.key}`,
                                                            d: row.d,
                                                            className: isOn ? "tg-geo-path tg-geo-path--active" : "tg-geo-path",
                                                            fill: fill,
                                                            fillOpacity: 1,
                                                            stroke: "var(--tg-map-stroke, #1e293b)",
                                                            strokeWidth: isOn ? pathStrokeWidthActive : pathStrokeWidth,
                                                            strokeLinejoin: "round",
                                                            tabIndex: 0,
                                                            role: "button",
                                                            "aria-label": `${row.title}. ${ac} applicants, ${bc} beneficiaries with subcontractor linked.`,
                                                            onMouseEnter: (e)=>{
                                                                setActive(row.key);
                                                                setPointerClient({
                                                                    x: e.clientX,
                                                                    y: e.clientY
                                                                });
                                                            },
                                                            onClick: ()=>{
                                                                setDrilledDistrict(row.key);
                                                                setActive(null);
                                                                setPointerClient(null);
                                                            },
                                                            onFocus: ()=>{
                                                                setActive(row.key);
                                                                const fr = frameRef.current?.getBoundingClientRect();
                                                                if (fr) setPointerClient({
                                                                    x: fr.left + fr.width * 0.42,
                                                                    y: fr.top + fr.height * 0.38
                                                                });
                                                            },
                                                            onBlur: (e)=>{
                                                                const next = e.relatedTarget;
                                                                if (frameRef.current && next && frameRef.current.contains(next)) return;
                                                                setActive(null);
                                                                setPointerClient(null);
                                                            },
                                                            onKeyDown: (e)=>{
                                                                if (e.key === "Enter" || e.key === " ") {
                                                                    e.preventDefault();
                                                                    setActive(row.key);
                                                                }
                                                                if (e.key === "Escape") {
                                                                    setActive(null);
                                                                    setPointerClient(null);
                                                                }
                                                            },
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("title", {
                                                                children: row.title
                                                            })
                                                        }, row.key);
                                                    })
                                                }) : null,
                                                isMandalView ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("defs", {
                                                    children: mandalsForDrill.map((m, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("clipPath", {
                                                            id: `tg-mandal-clip-${i}`,
                                                            clipPathUnits: "userSpaceOnUse",
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                                                                d: m.d
                                                            })
                                                        }, `clip-${i}`))
                                                }) : null,
                                                isMandalView ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("g", {
                                                    className: "tg-geo-mandals",
                                                    children: mandalsForDrill.map((m, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("path", {
                                                            id: `tg-mandal-path-${i}`,
                                                            "data-mandal-label-id": i,
                                                            "data-mandal-title": m.title,
                                                            d: m.d,
                                                            className: "tg-geo-path tg-geo-path--mandal",
                                                            fill: (0, $4bc5886b67e0c8cf$export$457d25dc584f8ad0)[i % (0, $4bc5886b67e0c8cf$export$457d25dc584f8ad0).length],
                                                            fillOpacity: 1,
                                                            stroke: "var(--tg-map-stroke, #1e293b)",
                                                            strokeWidth: pathStrokeWidth,
                                                            strokeLinejoin: "round",
                                                            style: {
                                                                outline: "none"
                                                            },
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("title", {
                                                                children: m.title
                                                            })
                                                        }, `${m.title}-${i}`))
                                                }) : null,
                                                isMandalView ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("g", {
                                                    className: "tg-geo-labels tg-geo-labels--mandals",
                                                    pointerEvents: "none",
                                                    "aria-hidden": "true",
                                                    children: mandalLabelCenters.map((row)=>{
                                                        const layout = (0, $140f024760b747e8$export$8771cff0a3f2cd53)(row.title, row.width, row.height, {
                                                            maxFontSize: mandalLabelMaxFont,
                                                            minFontSize: mandalLabelMinFont
                                                        });
                                                        if (layout.hide || !layout.lines.length) return null;
                                                        const { lines: lines, fontSize: fontSize } = layout;
                                                        const lineGap = fontSize * 1.12;
                                                        const startY = row.y - (lines.length - 1) * lineGap / 2;
                                                        const labelStroke = Math.max(0.08, fontSize * 0.1);
                                                        return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("text", {
                                                            x: row.x,
                                                            y: startY,
                                                            textAnchor: "middle",
                                                            dominantBaseline: "middle",
                                                            fontSize: fontSize,
                                                            clipPath: `url(#tg-mandal-clip-${row.index})`,
                                                            className: "tg-geo-label tg-geo-label--mandal",
                                                            strokeWidth: labelStroke,
                                                            children: lines.map((line, li)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tspan", {
                                                                    x: row.x,
                                                                    dy: li === 0 ? 0 : lineGap,
                                                                    children: line
                                                                }, li))
                                                        }, `${row.index}-${row.title}`);
                                                    })
                                                }) : null,
                                                !isMandalView ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("g", {
                                                    className: "tg-geo-labels",
                                                    pointerEvents: "none",
                                                    "aria-hidden": "true",
                                                    children: (0, $4bc5886b67e0c8cf$export$5f32a4a97ebcad64).map((row)=>{
                                                        const c = labelCenters[row.key];
                                                        if (!c) return null;
                                                        const lines = $9b6bb3ee4d9c26ed$var$labelLinesForKey(row.key);
                                                        const long = lines.some((l)=>l.length > 14) || lines.length > 1;
                                                        const fontSize = long ? 19 : 24;
                                                        const lineGap = fontSize * 1.05;
                                                        const startY = c.y - (lines.length - 1) * lineGap / 2;
                                                        return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("text", {
                                                            x: c.x,
                                                            y: startY,
                                                            textAnchor: "middle",
                                                            fontSize: fontSize,
                                                            className: "tg-geo-label",
                                                            children: lines.map((line, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tspan", {
                                                                    x: c.x,
                                                                    dy: i === 0 ? 0 : lineGap,
                                                                    children: line
                                                                }, i))
                                                        }, row.key);
                                                    })
                                                }) : null
                                            ]
                                        })
                                    ]
                                }),
                                active && activeMeta && tooltipPosition ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "dash-corp-map__map-tooltip",
                                    style: {
                                        left: tooltipPosition.left,
                                        top: tooltipPosition.top
                                    },
                                    role: "tooltip",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                            className: "dash-corp-map__map-tooltip__eyebrow",
                                            children: "District"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                            className: "dash-corp-map__map-tooltip__title",
                                            children: activeMeta.label
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("dl", {
                                            className: "dash-corp-map__map-tooltip__stats",
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                                            children: "Applicants"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                                            children: aCount
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                                            children: "Beneficiaries"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                                            children: bCount
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                            className: "dash-corp-map__map-tooltip__hint text-muted",
                                            children: [
                                                "Beneficiaries = ",
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                    children: "Subcontractor linked"
                                                }),
                                                " in this district."
                                            ]
                                        })
                                    ]
                                }) : null
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("aside", {
                        className: "dash-corp-map__aside",
                        "aria-label": "Map context and figures",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "dash-corp-map__side-card",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "dash-corp-map__side-eyebrow",
                                        children: "Statewide snapshot"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "dash-corp-map__side-lead",
                                        children: "Counts across all beneficiary files in this console."
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("dl", {
                                        className: "dash-corp-map__side-stats",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                                        children: "Total applicants"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                                        children: statewide.totalApplicants
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                                        children: "Total beneficiaries"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                                        children: statewide.totalBeneficiaries
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "dash-corp-map__side-card",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "dash-corp-map__side-eyebrow",
                                        children: "Registration directory"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("dl", {
                                        className: "dash-corp-map__side-stats dash-corp-map__side-stats--compact",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                                        children: "Districts"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                                        children: geoLoading || directoryTotals == null ? "\u2014" : directoryTotals.districts.toLocaleString("en-IN")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                                        children: "Mandals"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                                        children: geoLoading || directoryTotals == null ? "\u2014" : directoryTotals.mandals.toLocaleString("en-IN")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                                        children: "Villages"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                                        children: geoLoading || directoryTotals == null ? "\u2014" : directoryTotals.villages.toLocaleString("en-IN")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !geoLoading && !geoStore && geoError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                        className: "text-muted",
                                        style: {
                                            margin: "0.5rem 0 0",
                                            fontSize: "0.8125rem",
                                            lineHeight: 1.45
                                        },
                                        children: [
                                            "Directory did not load (",
                                            geoError,
                                            "). Ensure the API is running and MySQL geo tables are seeded; the client will retry on refresh."
                                        ]
                                    }) : null,
                                    !geoLoading && geoStore && directoryTotals && directoryTotals.districts === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                        className: "text-muted",
                                        style: {
                                            margin: "0.5rem 0 0",
                                            fontSize: "0.8125rem",
                                            lineHeight: 1.45
                                        },
                                        children: [
                                            "Registration payload had no districts. Check ",
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("code", {
                                                children: "/api/geo/directory"
                                            }),
                                            " response shape."
                                        ]
                                    }) : null
                                ]
                            }),
                            active && activeMeta ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "dash-corp-map__side-card dash-corp-map__side-card--district",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "dash-corp-map__side-eyebrow",
                                        children: "Selected district"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "dash-corp-map__side-title",
                                        children: activeMeta.label
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("dl", {
                                        className: "dash-corp-map__side-stats dash-corp-map__side-stats--compact",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                                        children: "Applicants"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                                        children: aCount
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                                        children: "Linked beneficiaries"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                                        children: bCount
                                                    })
                                                ]
                                            }),
                                            activeDirectory ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                                                children: "Mandals (dir.)"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                                                children: activeDirectory.mandals
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dt", {
                                                                children: "Villages (dir.)"
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("dd", {
                                                                children: activeDirectory.villages.toLocaleString()
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                        to: `/reports?district=${active}`,
                                        className: "btn btn--primary btn--tg btn--sm dash-corp-map__side-link",
                                        children: "Open reports for this district"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "dash-corp-map__side-card dash-corp-map__side-card--muted",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "dash-corp-map__side-eyebrow",
                                        children: "District focus"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "dash-corp-map__side-placeholder",
                                        children: "Hover or focus a district on the map to see its counts and a quick link to mandal-level area reports."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




function $f910d6c337e921c0$export$fe82a520fc33e5f4() {
    const { applications: applications } = (0, $5f16f4b9f1d6ad44$export$9973955de2bf96cf)();
    const k = (0, $b3aaef19adfaf342$export$a2a65280bd8fb0e1)(applications);
    const total = Math.max(k.totalReceived, 1);
    const pct = (n)=>Math.round(n / total * 100);
    const stages = [
        {
            key: "hold",
            label: "On hold",
            count: k.onHold
        },
        {
            key: "pend",
            label: "HO verification pending",
            count: k.pendingValidation
        },
        {
            key: "ready",
            label: "Ready for ICICI",
            count: k.readyForIcici
        },
        {
            key: "mou",
            label: "Ready for MOU",
            count: k.readyForMou
        },
        {
            key: "bank",
            label: "Awaiting subcontractor",
            count: k.awaitingSubcontractor
        },
        {
            key: "done",
            label: "Subcontractor linked",
            count: k.subcontractorLinked
        }
    ];
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "dashboard-corp",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $9b6bb3ee4d9c26ed$export$1725e0d0fbb66142), {
                applications: applications,
                className: "dash-corp-map--first"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $5c6cdf719da5c9ab$export$5f0ece31c46bf56f), {
                applications: applications
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                className: "dash-corp-executive",
                "aria-label": "Portfolio and process summary",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "dash-corp-panel dash-corp-panel--primary",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("header", {
                                className: "dash-corp-panel__head",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                            className: "dash-corp-eyebrow",
                                            children: "Applicant volume"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                            className: "dash-corp-stat-xl",
                                            "aria-live": "polite",
                                            children: k.totalReceived
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                            className: "dash-corp-panel__lede",
                                            children: "Total dossiers currently in the demonstration applicant list."
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "dash-corp-bar-label",
                                children: "Distribution by processing stage"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "dash-corp-bar",
                                role: "img",
                                "aria-label": "Case distribution by stage",
                                children: stages.map((row)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: `dash-corp-bar__seg dash-corp-bar__seg--${row.key}`,
                                        style: {
                                            width: `${pct(row.count)}%`
                                        },
                                        title: row.label
                                    }, row.key))
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "dash-corp-legend",
                                role: "list",
                                children: stages.map((row)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "dash-corp-legend__row",
                                        role: "listitem",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: `dash-corp-legend__swatch dash-corp-legend__swatch--${row.key}`
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "dash-corp-legend__label",
                                                children: row.label
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                className: "dash-corp-legend__count",
                                                children: row.count
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                className: "dash-corp-legend__pct",
                                                children: [
                                                    pct(row.count),
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }, row.key))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("aside", {
                        className: "dash-corp-panel dash-corp-panel--side",
                        "aria-label": "Standard operating sequence",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                className: "dash-corp-panel__title",
                                children: "Standard workflow"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "dash-corp-panel__intro",
                                children: "End-to-end responsibility from field capture through HO validation and subcontractor registration."
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("ol", {
                                className: "dash-corp-process",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                        children: "Field intake via mobile application."
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                        children: "HO verification of identity, bank, and workman documentation; holds where required."
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                        children: "Aadhaar seeding confirmation prior to ICICI and MOU capture."
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                        children: "Work-done bills with seeding re-verification at site."
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("li", {
                                        children: "Subcontractor firm linkage to close the file."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                to: "/applications",
                                className: "btn btn--corp btn--corp-outline dash-corp-panel__cta",
                                children: "View applicants"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                className: "dash-corp-quickstart",
                "aria-label": "Getting started",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "dash-corp-section-title",
                        children: "Getting started"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "dash-corp-quickstart__grid",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "dash-corp-quickstart__card",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "dash-corp-quickstart__step",
                                        children: "01"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                        className: "dash-corp-quickstart__text",
                                        children: [
                                            "Open ",
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$a6c7ac8248d6e38a), {
                                                to: "/applications",
                                                children: "Applicants"
                                            }),
                                            " from the main menu."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "dash-corp-quickstart__card",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "dash-corp-quickstart__step",
                                        children: "02"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                        className: "dash-corp-quickstart__text",
                                        children: [
                                            "Select ",
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                children: "Open"
                                            }),
                                            " on any row to open the workspace."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "dash-corp-quickstart__card",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "dash-corp-quickstart__step",
                                        children: "03"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                        className: "dash-corp-quickstart__text",
                                        children: "Use the left navigation to complete each section in order."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


const $72d3cfc7db17b6c0$var$PLANNING_HOME = [
    {
        key: "milestone_templates",
        to: "/milestone-master"
    },
    {
        key: "construction_timeline",
        to: "/construction-timeline-master"
    },
    {
        key: "standard_resources",
        to: "/standard-resources-master"
    }
];
const $72d3cfc7db17b6c0$var$INVENTORY_HOME = [
    {
        key: "inventory_issue_po",
        to: "/inventory/po-register"
    },
    {
        key: "inventory_issue_material",
        to: "/inventory/issue-material"
    },
    {
        key: "inventory_inward",
        to: "/inventory/inward"
    },
    {
        key: "inventory_goods_receipts",
        to: "/inventory/goods-receipts"
    },
    {
        key: "inventory_store_stocks",
        to: "/inventory/store-stocks"
    },
    {
        key: "inventory_outward",
        to: "/inventory/outward"
    },
    {
        key: "inventory_stores_yards",
        to: "/inventory/stores-yards"
    }
];
function $72d3cfc7db17b6c0$export$4407be066f39cd0d() {
    const { can: can } = (0, $a4dc0d923ddf5b19$export$1d39dc5b47e56ff0)();
    if (can("applications")) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $f910d6c337e921c0$export$fe82a520fc33e5f4), {});
    if ((0, $4aabdb75dcf6b773$export$8f84a4e698ab11e9)(can)) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
        to: "/applications",
        replace: true
    });
    if (can("leads")) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
        to: "/leads",
        replace: true
    });
    if (can("leads_import")) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
        to: "/leads?import=1",
        replace: true
    });
    if (can("reports")) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
        to: "/reports",
        replace: true
    });
    if (can("subcontractor_masters")) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
        to: "/subcontractor-onboarding",
        replace: true
    });
    if (can("agents")) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
        to: "/agent-master",
        replace: true
    });
    if (can("geo_directory") || can("geo_directory_admin")) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
        to: "/geo-directory",
        replace: true
    });
    for (const { key: key, to: to } of $72d3cfc7db17b6c0$var$PLANNING_HOME){
        if (can(key)) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
            to: to,
            replace: true
        });
    }
    if (can("geo_zones")) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
        to: "/zones",
        replace: true
    });
    if (can("bills_inward")) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
        to: "/bills/inward",
        replace: true
    });
    if (can("bills_outward")) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
        to: "/bills/outward",
        replace: true
    });
    for (const { key: key, to: to } of $72d3cfc7db17b6c0$var$INVENTORY_HOME){
        if (can(key)) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
            to: to,
            replace: true
        });
    }
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "workspace",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    }
                ],
                title: "No module access"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "tab-intro",
                children: "Your admin account has no permissions assigned. Ask a superadmin to grant access."
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");


/** Paths that require `console_users` or superadmin — not plain admins without that permission. */ const $57b42a3e6e8b8575$var$CONSOLE_USERS_MANAGE_PATHS = new Set([
    "/console-users"
]);
function $57b42a3e6e8b8575$var$mayAccessConsoleUsersPage(u) {
    return u.role === "superadmin" || u.permissions.includes("console_users");
}
function $57b42a3e6e8b8575$export$6e95aaf58f3677d2(from, signedInUser) {
    const trimmed = typeof from === "string" ? from.trim() : "";
    const candidate = trimmed && trimmed !== "/login" ? trimmed : "/";
    if (!$57b42a3e6e8b8575$var$mayAccessConsoleUsersPage(signedInUser) && $57b42a3e6e8b8575$var$CONSOLE_USERS_MANAGE_PATHS.has(candidate)) return "/";
    return candidate;
}




const $b6e19307d5ae08e2$var$indirammaLogoSrc = new URL($a870d17c128907f8$exports).href;
var $ec1bae4fd6e4e43d$exports = {};
$ec1bae4fd6e4e43d$exports = $parcel$resolve("kAIR8");


const $b6e19307d5ae08e2$var$telanganaLogoSrc = new URL($ec1bae4fd6e4e43d$exports).href;
var $fed977d30d115437$exports = {};
$fed977d30d115437$exports = $parcel$resolve("c5sf6");


const $b6e19307d5ae08e2$var$telanganaRisingLogoSrc = new URL($fed977d30d115437$exports).href;
var $68ccf20f6c2f0167$exports = {};
$68ccf20f6c2f0167$exports = $parcel$resolve("c7y0Q");


const $b6e19307d5ae08e2$var$indirammaBannerSrc = new URL($68ccf20f6c2f0167$exports).href;
function $b6e19307d5ae08e2$export$f14c0e3f98d164c0() {
    const { authRequired: authRequired, user: user, login: login } = (0, $a4dc0d923ddf5b19$export$1d39dc5b47e56ff0)();
    const navigate = (0, $265aeae2597a9f58$export$9770f232ac06a008)();
    const location = (0, $265aeae2597a9f58$export$45d76561a5302f2b)();
    const from = location.state?.from ?? "/";
    const [email, setEmail] = (0, $7UyaH.useState)("");
    const [password, setPassword] = (0, $7UyaH.useState)("");
    const [err, setErr] = (0, $7UyaH.useState)(null);
    const [busy, setBusy] = (0, $7UyaH.useState)(false);
    if (!authRequired) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
        to: "/",
        replace: true
    });
    if (user) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
        to: (0, $57b42a3e6e8b8575$export$6e95aaf58f3677d2)(from === "/login" ? "/" : from, user),
        replace: true
    });
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "portal-login",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("a", {
                href: "#portal-main",
                className: "skip-link",
                children: "Skip to main content"
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "portal-login__hero",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "portal-login__hero-media",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                                src: $b6e19307d5ae08e2$var$indirammaBannerSrc,
                                alt: "",
                                className: "portal-login__hero-img",
                                width: 1600,
                                height: 900,
                                loading: "eager",
                                decoding: "async"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "portal-login__hero-scrim"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("header", {
                        className: "portal-login__header portal-login__header--over-hero",
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "portal-login__header-inner",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "portal-login__header-left",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                                        src: $b6e19307d5ae08e2$var$indirammaLogoSrc,
                                        alt: "Indiramma Indlu \u2014 Government of Telangana, Chief Minister\u2019s Office",
                                        className: "portal-login__indiramma-logo"
                                    })
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "portal-login__header-right",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                                            src: $b6e19307d5ae08e2$var$telanganaLogoSrc,
                                            alt: "Government of Telangana \u2014 state emblem",
                                            className: "portal-login__telangana-emblem",
                                            width: 64,
                                            height: 64
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                                            src: $b6e19307d5ae08e2$var$telanganaRisingLogoSrc,
                                            alt: "Telangana Rising \u2014 CURE \xb7 PURE \xb7 RARE",
                                            className: "portal-login__telangana-rising",
                                            width: 120,
                                            height: 120
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("main", {
                        className: "portal-login__hero-inner",
                        id: "portal-main",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "portal-login__hero-copy",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h1", {
                                    className: "visually-hidden",
                                    children: "Indiramma Indlu \u2014 Head Office console"
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "portal-login__hero-aside",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    className: "portal-login__shell",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("section", {
                                        className: "portal-login__panel",
                                        "aria-labelledby": "portal-panel-title",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                className: "portal-login__panel-head",
                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                                    id: "portal-panel-title",
                                                    className: "portal-login__panel-title",
                                                    children: "Sign in"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "portal-login__panel-body",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("form", {
                                                        className: "portal-login__form",
                                                        onSubmit: (e)=>{
                                                            e.preventDefault();
                                                            setErr(null);
                                                            setBusy(true);
                                                            (async ()=>{
                                                                try {
                                                                    const signedIn = await login(email.trim(), password);
                                                                    navigate((0, $57b42a3e6e8b8575$export$6e95aaf58f3677d2)(from === "/login" ? "/" : from, signedIn), {
                                                                        replace: true
                                                                    });
                                                                } catch (ex) {
                                                                    setErr(ex instanceof Error ? ex.message : String(ex));
                                                                } finally{
                                                                    setBusy(false);
                                                                }
                                                            })();
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                                className: "portal-login__field",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                                        htmlFor: "login-email",
                                                                        className: "portal-login__label",
                                                                        children: "Work email"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                        id: "login-email",
                                                                        className: "portal-login__input",
                                                                        type: "email",
                                                                        autoComplete: "username",
                                                                        value: email,
                                                                        onChange: (e)=>setEmail(e.target.value),
                                                                        required: true,
                                                                        placeholder: "name@government.example"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                                className: "portal-login__field",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                                        htmlFor: "login-password",
                                                                        className: "portal-login__label",
                                                                        children: "Password"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                        id: "login-password",
                                                                        className: "portal-login__input",
                                                                        type: "password",
                                                                        autoComplete: "current-password",
                                                                        value: password,
                                                                        onChange: (e)=>setPassword(e.target.value),
                                                                        required: true,
                                                                        placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022"
                                                                    })
                                                                ]
                                                            }),
                                                            err ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                                className: "portal-login__error",
                                                                role: "alert",
                                                                children: err
                                                            }) : null,
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                                type: "submit",
                                                                className: "portal-login__search-btn",
                                                                disabled: busy,
                                                                children: busy ? "Signing in\u2026" : "Sign in"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                        className: "portal-login__hint",
                                                        children: [
                                                            "Trouble signing in? Contact your programme ",
                                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                                children: "superadmin"
                                                            }),
                                                            " or IT support."
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("blockquote", {
                        className: "portal-login__quote-card",
                        lang: "te",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "portal-login__quote-card__mark portal-login__quote-card__mark--open",
                                "aria-hidden": "true",
                                children: "\u201C"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "portal-login__quote-card__lines",
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "portal-login__quote-card__row",
                                            children: "\u0C05\u0C30\u0C4D\u0C39\u0C41\u0C32\u0C48\u0C28 \u0C15\u0C41\u0C1F\u0C41\u0C02\u0C2C\u0C3E\u0C32\u0C15\u0C41 \u0C38\u0C4A\u0C02\u0C24 \u0C38\u0C4D\u0C25\u0C32\u0C3E\u0C32\u0C4D\u0C32\u0C4B"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "portal-login__quote-card__row",
                                            children: "\u0C38\u0C4A\u0C02\u0C24\u0C02\u0C17\u0C3E \u0C15\u0C4A\u0C24\u0C4D\u0C24 \u0C07\u0C32\u0C4D\u0C32\u0C41 \u0C28\u0C3F\u0C30\u0C4D\u0C2E\u0C3F\u0C02\u0C1A\u0C41\u0C15\u0C41\u0C28\u0C47\u0C02\u0C26\u0C41\u0C15\u0C41 \u0C06\u0C30\u0C4D\u0C25\u0C3F\u0C15"
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            className: "portal-login__quote-card__row",
                                            children: "\u0C38\u0C39\u0C3E\u0C2F\u0C02 \u0C05\u0C02\u0C26\u0C3F\u0C02\u0C1A\u0C21\u0C02"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "portal-login__quote-card__mark portal-login__quote-card__mark--close",
                                "aria-hidden": "true",
                                children: "\u201D"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $33fc696864f4cd4a$export$942d66ac691266d5), {
                variant: "portal"
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");


// Compress image to base64 (max 1024px, 70% quality)
function $08347d735f65d2c6$var$compressImageToBase64(file, maxWidth = 1024, maxHeight = 1024, quality = 0.7) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event)=>{
            const img = new Image();
            img.src = event.target?.result;
            img.onload = ()=>{
                let width = img.width;
                let height = img.height;
                if (width > maxWidth || height > maxHeight) {
                    if (width > height) {
                        height = Math.round(height * maxWidth / width);
                        width = maxWidth;
                    } else {
                        width = Math.round(width * maxHeight / height);
                        height = maxHeight;
                    }
                }
                const canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext("2d");
                if (!ctx) return reject(new Error("Could not get canvas context"));
                ctx.drawImage(img, 0, 0, width, height);
                resolve(canvas.toDataURL("image/jpeg", quality));
            };
            img.onerror = (error)=>reject(error);
        };
        reader.onerror = (error)=>reject(error);
    });
}
function $08347d735f65d2c6$var$readVideoAsBase64(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = ()=>resolve(reader.result);
        reader.onerror = (e)=>reject(e);
    });
}
const $08347d735f65d2c6$var$MAX_VIDEO_BYTES = 26214400; // 25 MB
function $08347d735f65d2c6$var$getDistanceMeters(lat1, lon1, lat2, lon2) {
    const R = 6371e3; // metres
    const phi1 = lat1 * Math.PI / 180;
    const phi2 = lat2 * Math.PI / 180;
    const deltaPhi = (lat2 - lat1) * Math.PI / 180;
    const deltaLambda = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) + Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}
function $08347d735f65d2c6$var$StatusBadge({ status: status }) {
    let color = "#6b7280";
    let bg = "#f3f4f6";
    if (status === "Approved") {
        color = "#15803d";
        bg = "#dcfce7";
    } else if (status === "Submitted") {
        color = "#0369a1";
        bg = "#e0f2fe";
    } else if (status === "Rejected") {
        color = "#b91c1c";
        bg = "#fee2e2";
    } else if (status === "Hold") {
        color = "#b45309";
        bg = "#fef3c7";
    }
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
        style: {
            fontSize: "0.75rem",
            fontWeight: 600,
            padding: "0.2rem 0.5rem",
            borderRadius: "9999px",
            backgroundColor: bg,
            color: color
        },
        children: status
    });
}
function $08347d735f65d2c6$var$PhotoSlot({ label: label, required: required, preview: preview, inputId: inputId, inputRef: inputRef, onSelect: onSelect, onClear: onClear }) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        style: {
            flex: "1 1 0",
            minWidth: 0
        },
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                style: {
                    fontSize: "0.78rem",
                    fontWeight: 600,
                    marginBottom: "0.4rem",
                    color: "#374151"
                },
                children: [
                    label,
                    " ",
                    required ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        style: {
                            color: "#b91c1c"
                        },
                        children: "*"
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        style: {
                            color: "#6b7280",
                            fontWeight: 400
                        },
                        children: "(opt.)"
                    })
                ]
            }),
            !preview ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                style: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                        type: "file",
                        accept: "image/*",
                        id: inputId,
                        ref: inputRef,
                        onChange: (e)=>{
                            const f = e.target.files?.[0];
                            if (f) onSelect(f);
                        },
                        style: {
                            opacity: 0,
                            position: "absolute",
                            inset: 0,
                            width: "100%",
                            height: "100%",
                            cursor: "pointer"
                        }
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                        htmlFor: inputId,
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "2px dashed #d1d5db",
                            borderRadius: "0.5rem",
                            padding: "1rem 0.25rem",
                            cursor: "pointer",
                            background: "#f9fafb",
                            color: "#6b7280",
                            fontSize: "0.75rem",
                            pointerEvents: "none"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                style: {
                                    fontSize: "1.4rem",
                                    marginBottom: "0.2rem"
                                },
                                children: "\uD83D\uDCF7"
                            }),
                            "Add photo"
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                        src: preview,
                        alt: label,
                        style: {
                            width: "100%",
                            aspectRatio: "4/3",
                            objectFit: "cover",
                            borderRadius: "0.375rem",
                            border: "1px solid #d1d5db",
                            display: "block"
                        }
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        onClick: onClear,
                        style: {
                            marginTop: "0.3rem",
                            width: "100%",
                            fontSize: "0.72rem",
                            padding: "0.3rem",
                            background: "#fee2e2",
                            color: "#b91c1c",
                            border: "none",
                            borderRadius: "0.25rem",
                            cursor: "pointer"
                        },
                        children: "Retake"
                    })
                ]
            })
        ]
    });
}
function $08347d735f65d2c6$export$874ded8664bb04c() {
    const { token: token } = (0, $265aeae2597a9f58$export$99eaa27ddbbb95ef)();
    const [data, setData] = (0, $7UyaH.useState)(null);
    const [error, setError] = (0, $7UyaH.useState)(null);
    const [loading, setLoading] = (0, $7UyaH.useState)(true);
    const [selectedBen, setSelectedBen] = (0, $7UyaH.useState)(null);
    // Start date step
    const [startDateInput, setStartDateInput] = (0, $7UyaH.useState)("");
    const [savingStartDate, setSavingStartDate] = (0, $7UyaH.useState)(false);
    // Photo + video step (only shown after start date saved)
    const [photo1File, setPhoto1File] = (0, $7UyaH.useState)(null);
    const [photo2File, setPhoto2File] = (0, $7UyaH.useState)(null);
    const [photo3File, setPhoto3File] = (0, $7UyaH.useState)(null);
    const [photo1Preview, setPhoto1Preview] = (0, $7UyaH.useState)(null);
    const [photo2Preview, setPhoto2Preview] = (0, $7UyaH.useState)(null);
    const [photo3Preview, setPhoto3Preview] = (0, $7UyaH.useState)(null);
    const photo1Ref = (0, $7UyaH.useRef)(null);
    const photo2Ref = (0, $7UyaH.useRef)(null);
    const photo3Ref = (0, $7UyaH.useRef)(null);
    const [videoFile, setVideoFile] = (0, $7UyaH.useState)(null);
    const [videoPreviewUrl, setVideoPreviewUrl] = (0, $7UyaH.useState)(null);
    const [videoError, setVideoError] = (0, $7UyaH.useState)(null);
    const videoInputRef = (0, $7UyaH.useRef)(null);
    const [submitting, setSubmitting] = (0, $7UyaH.useState)(false);
    (0, $7UyaH.useEffect)(()=>{
        if (!token) {
            setError("Invalid access link.");
            setLoading(false);
            return;
        }
        (0, $63ae46da6580a2c7$export$e8ee2447241c4638)(token).then((d)=>{
            setData(d);
            setLoading(false);
        }).catch((e)=>{
            setError(e instanceof Error ? e.message : "Failed to load portal data");
            setLoading(false);
        });
    }, [
        token
    ]);
    const clearPhotoState = ()=>{
        setPhoto1File(null);
        setPhoto1Preview(null);
        if (photo1Ref.current) photo1Ref.current.value = "";
        setPhoto2File(null);
        setPhoto2Preview(null);
        if (photo2Ref.current) photo2Ref.current.value = "";
        setPhoto3File(null);
        setPhoto3Preview(null);
        if (photo3Ref.current) photo3Ref.current.value = "";
        setVideoFile(null);
        setVideoPreviewUrl(null);
        setVideoError(null);
        if (videoInputRef.current) videoInputRef.current.value = "";
    };
    const clearAll = ()=>{
        setStartDateInput("");
        clearPhotoState();
    };
    const refreshBen = async (applicationId)=>{
        if (!token) return null;
        const newData = await (0, $63ae46da6580a2c7$export$e8ee2447241c4638)(token);
        setData(newData);
        return newData.beneficiaries.find((b)=>b.applicationId === applicationId) ?? null;
    };
    // Step 1: Save start date (immutable once saved)
    const handleSaveStartDate = async ()=>{
        if (!token || !selectedBen || !selectedBen.activePhaseId || !startDateInput) return;
        setSavingStartDate(true);
        try {
            await (0, $63ae46da6580a2c7$export$c58350d01b43b8b8)(token, selectedBen.applicationId, selectedBen.activePhaseId, startDateInput);
            const updated = await refreshBen(selectedBen.applicationId);
            setSelectedBen(updated);
        } catch (err) {
            alert(err instanceof Error ? err.message : "Failed to save start date");
        } finally{
            setSavingStartDate(false);
        }
    };
    // Step 2: Submit photos + video
    const handleSubmitPhase = async ()=>{
        if (!token || !selectedBen || !selectedBen.activePhaseId) return;
        if (!photo1File || !photo2File || !photo3File) {
            alert("Please add all 3 required photos.");
            return;
        }
        setSubmitting(true);
        // Geofencing validation
        try {
            const position = await new Promise((resolve, reject)=>{
                navigator.geolocation.getCurrentPosition(resolve, reject, {
                    enableHighAccuracy: true,
                    timeout: 15000
                });
            });
            if (selectedBen.plotLatitude && selectedBen.plotLongitude) {
                const dist = $08347d735f65d2c6$var$getDistanceMeters(position.coords.latitude, position.coords.longitude, selectedBen.plotLatitude, selectedBen.plotLongitude);
                if (dist > 50) {
                    alert(`You are ${Math.round(dist)}m away from the plot location. You must be within 50m to submit progress photos.`);
                    setSubmitting(false);
                    return;
                }
            }
        } catch (err) {
            setSubmitting(false);
            alert("Failed to get your location. Geotagging is required to upload progress.");
            return;
        }
        try {
            const [b1, b2, b3] = await Promise.all([
                $08347d735f65d2c6$var$compressImageToBase64(photo1File),
                $08347d735f65d2c6$var$compressImageToBase64(photo2File),
                $08347d735f65d2c6$var$compressImageToBase64(photo3File)
            ]);
            let videoBase64;
            if (videoFile) videoBase64 = await $08347d735f65d2c6$var$readVideoAsBase64(videoFile);
            await (0, $63ae46da6580a2c7$export$f75a17bdf31e16db)(token, selectedBen.applicationId, selectedBen.activePhaseId, b1, {
                photoData2: b2,
                photoData3: b3,
                videoData: videoBase64
            });
            const updated = await refreshBen(selectedBen.applicationId);
            setSelectedBen(updated);
            clearPhotoState();
            alert("Progress submitted successfully!");
        } catch (err) {
            alert(err instanceof Error ? err.message : "Failed to submit progress");
        } finally{
            setSubmitting(false);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            backgroundColor: "#f3f4f6"
        },
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
            style: {
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                fontSize: "1.2rem",
                color: "#4b5563"
            },
            children: [
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                    className: "spinner spinner--md"
                }),
                " Loading\u2026"
            ]
        })
    });
    if (error || !data) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            padding: "1rem",
            backgroundColor: "#f3f4f6"
        },
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
            className: "card card--elevated",
            style: {
                textAlign: "center",
                maxWidth: "400px"
            },
            children: [
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                    style: {
                        color: "#b91c1c",
                        marginBottom: "1rem"
                    },
                    children: "Access Error"
                }),
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                    children: error || "Unable to load data."
                }),
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                    style: {
                        marginTop: "1rem",
                        fontSize: "0.85rem",
                        color: "#6b7280"
                    },
                    children: "Please request a new link from the Housing Office."
                })
            ]
        })
    });
    // ── Beneficiary Detail View ──────────────────────────────────────────────
    if (selectedBen) return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        style: {
            height: "100vh",
            overflowY: "auto",
            backgroundColor: "#f3f4f6",
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("header", {
                style: {
                    backgroundColor: "var(--corp-blue)",
                    color: "white",
                    padding: "1rem",
                    position: "sticky",
                    top: 0,
                    zIndex: 10
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        className: "btn btn--link",
                        style: {
                            color: "white",
                            padding: 0,
                            marginBottom: "0.5rem",
                            display: "flex",
                            alignItems: "center",
                            gap: "0.25rem"
                        },
                        onClick: ()=>{
                            setSelectedBen(null);
                            clearAll();
                        },
                        children: "\u2190 Back to list"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h1", {
                        style: {
                            fontSize: "1.25rem",
                            margin: 0
                        },
                        children: selectedBen.beneficiaryName
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                        style: {
                            margin: 0,
                            opacity: 0.9,
                            fontSize: "0.85rem"
                        },
                        children: [
                            selectedBen.village,
                            ", ",
                            selectedBen.mandal
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("main", {
                style: {
                    padding: "1rem",
                    paddingBottom: "6rem",
                    flex: 1
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                        className: "form-section-title",
                        style: {
                            marginTop: 0
                        },
                        children: "Construction Timeline"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "1rem",
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                style: {
                                    position: "absolute",
                                    left: "1.25rem",
                                    top: "1rem",
                                    bottom: "1rem",
                                    width: "2px",
                                    backgroundColor: "#e5e7eb",
                                    zIndex: 0
                                }
                            }),
                            selectedBen.timeline.map((phase)=>{
                                const isActive = phase.id === selectedBen.activePhaseId;
                                const isPast = [
                                    "Approved",
                                    "Submitted",
                                    "Hold"
                                ].includes(phase.status);
                                const isLocked = !isActive && !isPast;
                                let iconBg = "#e5e7eb";
                                let iconColor = "#9ca3af";
                                if (phase.status === "Approved") {
                                    iconBg = "#15803d";
                                    iconColor = "white";
                                } else if (phase.status === "Submitted") {
                                    iconBg = "#0369a1";
                                    iconColor = "white";
                                } else if (isActive) {
                                    iconBg = "var(--corp-blue)";
                                    iconColor = "white";
                                }
                                // The saved start date for this phase
                                const savedStartDate = phase.actualStartDate;
                                const startDateLocked = Boolean(savedStartDate);
                                return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        gap: "1rem",
                                        position: "relative",
                                        zIndex: 1,
                                        opacity: isLocked ? 0.55 : 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                            style: {
                                                width: "2.5rem",
                                                height: "2.5rem",
                                                borderRadius: "50%",
                                                backgroundColor: iconBg,
                                                color: iconColor,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontWeight: "bold",
                                                flexShrink: 0,
                                                border: "2px solid white",
                                                boxShadow: "0 1px 2px rgba(0,0,0,0.1)"
                                            },
                                            children: phase.status === "Approved" ? "\u2713" : phase.sortOrder
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                            className: "card card--flush",
                                            style: {
                                                flex: 1,
                                                padding: "1rem"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "flex-start",
                                                        marginBottom: "0.5rem"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                                            style: {
                                                                margin: 0,
                                                                fontSize: "1.05rem"
                                                            },
                                                            children: phase.title
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($08347d735f65d2c6$var$StatusBadge, {
                                                            status: phase.status
                                                        })
                                                    ]
                                                }),
                                                phase.submittedAt && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                    style: {
                                                        margin: "0 0 0.25rem",
                                                        fontSize: "0.8rem",
                                                        color: "#6b7280"
                                                    },
                                                    children: [
                                                        "Submitted: ",
                                                        new Date(phase.submittedAt).toLocaleDateString()
                                                    ]
                                                }),
                                                savedStartDate && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                    style: {
                                                        margin: "0 0 0.25rem",
                                                        fontSize: "0.8rem",
                                                        color: "#374151"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                            style: {
                                                                fontWeight: 600
                                                            },
                                                            children: "Work started:"
                                                        }),
                                                        " ",
                                                        savedStartDate
                                                    ]
                                                }),
                                                isActive && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                    style: {
                                                        marginTop: "1rem",
                                                        paddingTop: "1rem",
                                                        borderTop: "1px solid #e5e7eb"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                            style: {
                                                                marginBottom: "1.25rem",
                                                                padding: "0.85rem",
                                                                background: startDateLocked ? "#f0fdf4" : "#fffbeb",
                                                                borderRadius: "0.5rem",
                                                                border: `1px solid ${startDateLocked ? "#86efac" : "#fcd34d"}`
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                                    style: {
                                                                        fontSize: "0.82rem",
                                                                        fontWeight: 700,
                                                                        marginBottom: "0.5rem",
                                                                        color: startDateLocked ? "#15803d" : "#92400e"
                                                                    },
                                                                    children: startDateLocked ? "\u2705 Step 1 \u2014 Work start date saved" : "Step 1 \u2014 Enter actual start date"
                                                                }),
                                                                startDateLocked ? /* Read-only locked display */ /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: "0.5rem"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                                            style: {
                                                                                fontSize: "1rem",
                                                                                fontWeight: 700,
                                                                                color: "#15803d"
                                                                            },
                                                                            children: [
                                                                                "\uD83D\uDCC5 ",
                                                                                savedStartDate
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                            style: {
                                                                                fontSize: "0.75rem",
                                                                                color: "#6b7280"
                                                                            },
                                                                            children: "(cannot be changed)"
                                                                        })
                                                                    ]
                                                                }) : /* Editable date input + Save button */ /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                                            style: {
                                                                                fontSize: "0.78rem",
                                                                                color: "#78350f",
                                                                                marginBottom: "0.5rem"
                                                                            },
                                                                            children: "Enter the date when work on this phase actually started. Once saved it cannot be edited."
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                                            style: {
                                                                                display: "flex",
                                                                                gap: "0.5rem",
                                                                                alignItems: "flex-end",
                                                                                flexWrap: "wrap"
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                                    style: {
                                                                                        flex: 1,
                                                                                        minWidth: "10rem"
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                        type: "date",
                                                                                        className: "form-control",
                                                                                        value: startDateInput,
                                                                                        max: new Date().toISOString().slice(0, 10),
                                                                                        onChange: (e)=>setStartDateInput(e.target.value),
                                                                                        style: {
                                                                                            width: "100%"
                                                                                        }
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                                                    type: "button",
                                                                                    className: "btn btn--primary btn--tg",
                                                                                    disabled: !startDateInput || savingStartDate,
                                                                                    onClick: ()=>void handleSaveStartDate(),
                                                                                    style: {
                                                                                        whiteSpace: "nowrap"
                                                                                    },
                                                                                    children: savingStartDate ? "Saving\u2026" : "Save Start Date"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        startDateLocked && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                            style: {
                                                                padding: "0.85rem",
                                                                background: "#f0f9ff",
                                                                borderRadius: "0.5rem",
                                                                border: "1px solid #bae6fd"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                                    style: {
                                                                        fontSize: "0.82rem",
                                                                        fontWeight: 700,
                                                                        marginBottom: "0.75rem",
                                                                        color: "#0369a1"
                                                                    },
                                                                    children: "Step 2 \u2014 Add 3 site photos and submit"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        gap: "0.5rem",
                                                                        marginBottom: "1rem"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($08347d735f65d2c6$var$PhotoSlot, {
                                                                            label: "Photo 1",
                                                                            required: true,
                                                                            inputId: "photo-1",
                                                                            inputRef: photo1Ref,
                                                                            preview: photo1Preview,
                                                                            onSelect: (f)=>{
                                                                                setPhoto1File(f);
                                                                                setPhoto1Preview(URL.createObjectURL(f));
                                                                            },
                                                                            onClear: ()=>{
                                                                                setPhoto1File(null);
                                                                                setPhoto1Preview(null);
                                                                                if (photo1Ref.current) photo1Ref.current.value = "";
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($08347d735f65d2c6$var$PhotoSlot, {
                                                                            label: "Photo 2",
                                                                            required: true,
                                                                            inputId: "photo-2",
                                                                            inputRef: photo2Ref,
                                                                            preview: photo2Preview,
                                                                            onSelect: (f)=>{
                                                                                setPhoto2File(f);
                                                                                setPhoto2Preview(URL.createObjectURL(f));
                                                                            },
                                                                            onClear: ()=>{
                                                                                setPhoto2File(null);
                                                                                setPhoto2Preview(null);
                                                                                if (photo2Ref.current) photo2Ref.current.value = "";
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($08347d735f65d2c6$var$PhotoSlot, {
                                                                            label: "Photo 3",
                                                                            required: true,
                                                                            inputId: "photo-3",
                                                                            inputRef: photo3Ref,
                                                                            preview: photo3Preview,
                                                                            onSelect: (f)=>{
                                                                                setPhoto3File(f);
                                                                                setPhoto3Preview(URL.createObjectURL(f));
                                                                            },
                                                                            onClear: ()=>{
                                                                                setPhoto3File(null);
                                                                                setPhoto3Preview(null);
                                                                                if (photo3Ref.current) photo3Ref.current.value = "";
                                                                            }
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                                    style: {
                                                                        marginBottom: "1rem"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                                            style: {
                                                                                fontSize: "0.8rem",
                                                                                fontWeight: 600,
                                                                                marginBottom: "0.35rem",
                                                                                color: "#374151"
                                                                            },
                                                                            children: [
                                                                                "Video ",
                                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                                    style: {
                                                                                        color: "#6b7280",
                                                                                        fontWeight: 400
                                                                                    },
                                                                                    children: "(optional \xb7 max 25 MB)"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        videoError && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                                            style: {
                                                                                color: "#b91c1c",
                                                                                fontSize: "0.78rem",
                                                                                marginBottom: "0.4rem"
                                                                            },
                                                                            children: videoError
                                                                        }),
                                                                        !videoPreviewUrl ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                                            style: {
                                                                                position: "relative"
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                                    type: "file",
                                                                                    accept: "video/*",
                                                                                    id: "video-capture",
                                                                                    ref: videoInputRef,
                                                                                    onChange: (e)=>{
                                                                                        setVideoError(null);
                                                                                        const f = e.target.files?.[0];
                                                                                        if (!f) return;
                                                                                        if (f.size > $08347d735f65d2c6$var$MAX_VIDEO_BYTES) {
                                                                                            setVideoError("Video too large (max 25 MB). Trim and try again.");
                                                                                            if (videoInputRef.current) videoInputRef.current.value = "";
                                                                                            return;
                                                                                        }
                                                                                        setVideoFile(f);
                                                                                        setVideoPreviewUrl(URL.createObjectURL(f));
                                                                                    },
                                                                                    style: {
                                                                                        opacity: 0,
                                                                                        position: "absolute",
                                                                                        inset: 0,
                                                                                        width: "100%",
                                                                                        height: "100%",
                                                                                        cursor: "pointer"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                                                                    htmlFor: "video-capture",
                                                                                    style: {
                                                                                        display: "flex",
                                                                                        flexDirection: "column",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",
                                                                                        border: "2px dashed #d1d5db",
                                                                                        borderRadius: "0.5rem",
                                                                                        padding: "0.85rem 0.5rem",
                                                                                        cursor: "pointer",
                                                                                        background: "#f9fafb",
                                                                                        color: "#6b7280",
                                                                                        fontSize: "0.8rem",
                                                                                        pointerEvents: "none"
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                                            style: {
                                                                                                fontSize: "1.4rem",
                                                                                                marginBottom: "0.2rem"
                                                                                            },
                                                                                            children: "\uD83C\uDFA5"
                                                                                        }),
                                                                                        "Tap to add video"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("video", {
                                                                                    src: videoPreviewUrl,
                                                                                    controls: true,
                                                                                    style: {
                                                                                        width: "100%",
                                                                                        borderRadius: "0.375rem",
                                                                                        border: "1px solid #d1d5db",
                                                                                        maxHeight: "180px"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                                                    type: "button",
                                                                                    onClick: ()=>{
                                                                                        setVideoFile(null);
                                                                                        setVideoPreviewUrl(null);
                                                                                        setVideoError(null);
                                                                                        if (videoInputRef.current) videoInputRef.current.value = "";
                                                                                    },
                                                                                    style: {
                                                                                        marginTop: "0.3rem",
                                                                                        width: "100%",
                                                                                        fontSize: "0.75rem",
                                                                                        padding: "0.3rem",
                                                                                        background: "#fee2e2",
                                                                                        color: "#b91c1c",
                                                                                        border: "none",
                                                                                        borderRadius: "0.25rem",
                                                                                        cursor: "pointer"
                                                                                    },
                                                                                    children: "Remove video"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                                    type: "button",
                                                                    className: "btn btn--primary btn--tg",
                                                                    style: {
                                                                        width: "100%"
                                                                    },
                                                                    disabled: submitting || !photo1File || !photo2File || !photo3File,
                                                                    onClick: ()=>void handleSubmitPhase(),
                                                                    children: submitting ? "Uploading\u2026" : "Submit Progress"
                                                                }),
                                                                (!photo1File || !photo2File || !photo3File) && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                                    style: {
                                                                        fontSize: "0.76rem",
                                                                        color: "#6b7280",
                                                                        marginTop: "0.4rem",
                                                                        textAlign: "center"
                                                                    },
                                                                    children: "Add all 3 photos to enable submit."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, phase.id);
                            }),
                            !selectedBen.activePhaseId && selectedBen.timeline.every((p)=>p.status === "Approved") && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "alert alert--success",
                                style: {
                                    marginTop: "1rem"
                                },
                                children: "All phases for this beneficiary have been completed and approved. \uD83C\uDF89"
                            })
                        ]
                    })
                ]
            })
        ]
    });
    // ── Beneficiary List View ────────────────────────────────────────────────
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        style: {
            height: "100vh",
            overflowY: "auto",
            backgroundColor: "#f3f4f6"
        },
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("header", {
                style: {
                    backgroundColor: "var(--corp-blue)",
                    color: "white",
                    padding: "1.25rem 1rem",
                    position: "sticky",
                    top: 0,
                    zIndex: 10
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h1", {
                        style: {
                            fontSize: "1.25rem",
                            margin: 0,
                            marginBottom: "0.25rem"
                        },
                        children: "Subcontractor Portal"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        style: {
                            margin: 0,
                            opacity: 0.9,
                            fontSize: "0.9rem"
                        },
                        children: data.subcontractorName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("main", {
                style: {
                    padding: "1rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("h2", {
                        className: "form-section-title",
                        style: {
                            marginTop: 0
                        },
                        children: [
                            "Assigned Beneficiaries (",
                            data.beneficiaries.length,
                            ")"
                        ]
                    }),
                    data.beneficiaries.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "card card--flush",
                        style: {
                            padding: "2rem",
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                            className: "text-muted",
                            children: "No beneficiaries assigned yet."
                        })
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.75rem"
                        },
                        children: data.beneficiaries.map((ben)=>{
                            const activePhase = ben.timeline.find((p)=>p.id === ben.activePhaseId);
                            const activePhaseTitle = activePhase ? activePhase.title : "All Completed / Pending Approval";
                            const totalPhases = ben.timeline.length;
                            const completedPhases = ben.timeline.filter((p)=>p.status === "Approved").length;
                            const progressPct = totalPhases > 0 ? Math.round(completedPhases / totalPhases * 100) : 0;
                            return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("button", {
                                className: "card card--elevated",
                                style: {
                                    display: "block",
                                    width: "100%",
                                    textAlign: "left",
                                    padding: "1rem",
                                    border: "none",
                                    background: "white",
                                    cursor: "pointer"
                                },
                                onClick: ()=>setSelectedBen(ben),
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "flex-start",
                                            marginBottom: "0.5rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                                style: {
                                                    margin: 0,
                                                    fontSize: "1.1rem",
                                                    color: "#111827"
                                                },
                                                children: ben.beneficiaryName
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                style: {
                                                    fontSize: "0.8rem",
                                                    fontWeight: 600,
                                                    color: "var(--corp-blue)"
                                                },
                                                children: [
                                                    progressPct,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                        style: {
                                            margin: "0 0 0.5rem 0",
                                            fontSize: "0.85rem",
                                            color: "#4b5563"
                                        },
                                        children: [
                                            "\uD83D\uDCCD ",
                                            ben.village,
                                            ", ",
                                            ben.mandal
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        style: {
                                            backgroundColor: "#f3f4f6",
                                            padding: "0.5rem",
                                            borderRadius: "0.25rem",
                                            display: "inline-block",
                                            fontSize: "0.8rem",
                                            color: "#374151"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                children: "Next:"
                                            }),
                                            " ",
                                            activePhaseTitle
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        style: {
                                            width: "100%",
                                            height: "4px",
                                            backgroundColor: "#e5e7eb",
                                            borderRadius: "2px",
                                            marginTop: "0.75rem",
                                            overflow: "hidden"
                                        },
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                            style: {
                                                height: "100%",
                                                width: `${progressPct}%`,
                                                backgroundColor: "var(--corp-blue)",
                                                transition: "width 0.3s ease"
                                            }
                                        })
                                    })
                                ]
                            }, ben.applicationId);
                        })
                    })
                ]
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");


function $474b63e98d1f9bbd$var$statusBadgeClass(status) {
    switch(status){
        case "Submitted":
            return "tl-review-modal__badge tl-review-modal__badge--submitted";
        case "Approved":
            return "tl-review-modal__badge tl-review-modal__badge--approved";
        case "Rejected":
            return "tl-review-modal__badge tl-review-modal__badge--rejected";
        case "Hold":
            return "tl-review-modal__badge tl-review-modal__badge--hold";
        default:
            return "tl-review-modal__badge";
    }
}
function $474b63e98d1f9bbd$var$statusBadgeLabel(status) {
    switch(status){
        case "Submitted":
            return "Pending review";
        default:
            return status;
    }
}
function $474b63e98d1f9bbd$export$c79e55f9a3e7ee32() {
    const [records, setRecords] = (0, $7UyaH.useState)([]);
    const [loading, setLoading] = (0, $7UyaH.useState)(true);
    const [error, setError] = (0, $7UyaH.useState)(null);
    const [filterStatus, setFilterStatus] = (0, $7UyaH.useState)("Submitted");
    // Modal state for viewing photo and taking action
    const [selectedRecord, setSelectedRecord] = (0, $7UyaH.useState)(null);
    const [actionNotes, setActionNotes] = (0, $7UyaH.useState)("");
    const [submittingAction, setSubmittingAction] = (0, $7UyaH.useState)(false);
    const [activePhotoIdx, setActivePhotoIdx] = (0, $7UyaH.useState)(0);
    const closeModal = (0, $7UyaH.useCallback)(()=>{
        setSelectedRecord(null);
        setActionNotes("");
        setActivePhotoIdx(0);
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        setActivePhotoIdx(0);
    }, [
        selectedRecord?.id
    ]);
    (0, $7UyaH.useEffect)(()=>{
        if (!selectedRecord) return;
        const onKey = (e)=>{
            if (e.key === "Escape") closeModal();
        };
        window.addEventListener("keydown", onKey);
        return ()=>window.removeEventListener("keydown", onKey);
    }, [
        selectedRecord,
        closeModal
    ]);
    const loadData = async ()=>{
        setLoading(true);
        setError(null);
        try {
            const data = await (0, $63ae46da6580a2c7$export$f02b737d3e61a2d5)(filterStatus);
            setRecords(data);
        } catch (err) {
            setError(err instanceof Error ? err.message : "Failed to load timeline approvals.");
        } finally{
            setLoading(false);
        }
    };
    (0, $7UyaH.useEffect)(()=>{
        loadData();
    }, [
        filterStatus
    ]);
    const handleAction = async (status)=>{
        if (!selectedRecord) return;
        setSubmittingAction(true);
        try {
            await (0, $63ae46da6580a2c7$export$ec8b69963c5a7eb2)(selectedRecord.id, status, actionNotes.trim() || undefined);
            // Remove or update from local list
            if (filterStatus === status) setRecords(records.map((r)=>r.id === selectedRecord.id ? {
                    ...r,
                    status: status,
                    status_notes: actionNotes
                } : r));
            else setRecords(records.filter((r)=>r.id !== selectedRecord.id));
            closeModal();
        } catch (err) {
            alert(err instanceof Error ? err.message : "Failed to update status.");
        } finally{
            setSubmittingAction(false);
        }
    };
    const modalPhotos = (0, $7UyaH.useMemo)(()=>{
        if (!selectedRecord) return [];
        return [
            selectedRecord.photo_data,
            selectedRecord.photo_data_2,
            selectedRecord.photo_data_3
        ].filter(Boolean);
    }, [
        selectedRecord
    ]);
    const mainPhotoSrc = modalPhotos[activePhotoIdx] ?? modalPhotos[0];
    const notesReadOnly = selectedRecord?.status === "Approved" || selectedRecord?.status === "Rejected";
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                breadcrumb: [
                    {
                        label: "Home",
                        to: "/"
                    },
                    {
                        label: "Timeline Approvals"
                    }
                ],
                title: "Timeline Approvals",
                subtitle: "Review construction progress photos submitted by subcontractors from the field."
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "toolbar-row",
                style: {
                    marginTop: 0,
                    marginBottom: "1rem"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            gap: "0.5rem"
                        },
                        children: [
                            "Submitted",
                            "Approved",
                            "Rejected",
                            "Hold"
                        ].map((s)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                className: `btn btn--sm ${filterStatus === s ? "btn--primary btn--tg" : "btn--tg-secondary"}`,
                                onClick: ()=>setFilterStatus(s),
                                children: s === "Submitted" ? "Pending Review" : s
                            }, s))
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        className: "btn btn--sm btn--tg-secondary",
                        onClick: ()=>loadData(),
                        disabled: loading,
                        children: "\u21BB Refresh"
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "alert alert--danger",
                style: {
                    marginBottom: "1rem"
                },
                children: error
            }),
            loading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                style: {
                    padding: "2rem",
                    textAlign: "center",
                    color: "#6b7280"
                },
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                        className: "spinner spinner--md",
                        style: {
                            marginRight: "0.5rem"
                        }
                    }),
                    " Loading approvals..."
                ]
            }) : records.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "card card--elevated",
                style: {
                    padding: "3rem",
                    textAlign: "center",
                    color: "#6b7280"
                },
                children: [
                    "No ",
                    filterStatus === "Submitted" ? "pending" : filterStatus.toLowerCase(),
                    " approvals found."
                ]
            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                style: {
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                    gap: "1rem"
                },
                children: records.map((record)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "card card--elevated",
                        style: {
                            padding: 0,
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                style: {
                                    height: "200px",
                                    backgroundColor: "#e5e7eb",
                                    backgroundImage: `url(${record.photo_data})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    cursor: "pointer"
                                },
                                onClick: ()=>{
                                    setSelectedRecord(record);
                                    setActionNotes(record.status_notes || "");
                                },
                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                    style: {
                                        padding: "0.5rem",
                                        background: "linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, transparent 100%)",
                                        color: "white"
                                    },
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                                        style: {
                                            margin: 0,
                                            fontSize: "1rem",
                                            textShadow: "0 1px 2px rgba(0,0,0,0.5)"
                                        },
                                        children: record.phase_title
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                style: {
                                    padding: "1rem",
                                    flex: 1,
                                    display: "flex",
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h4", {
                                        style: {
                                            margin: "0 0 0.25rem 0",
                                            fontSize: "1.05rem"
                                        },
                                        children: record.beneficiary_name
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                        style: {
                                            margin: "0 0 0.5rem 0",
                                            fontSize: "0.85rem",
                                            color: "#4b5563"
                                        },
                                        children: [
                                            record.village,
                                            ", ",
                                            record.mandal
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                        style: {
                                            margin: "0 0 1rem 0",
                                            fontSize: "0.8rem",
                                            color: "#6b7280"
                                        },
                                        children: [
                                            "By: ",
                                            record.subcontractor_name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                        style: {
                                            marginTop: "auto"
                                        },
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                            className: "btn btn--tg btn--sm",
                                            style: {
                                                width: "100%"
                                            },
                                            onClick: ()=>{
                                                setSelectedRecord(record);
                                                setActionNotes(record.status_notes || "");
                                            },
                                            children: filterStatus === "Submitted" || filterStatus === "Hold" ? "Review & Act" : "View Details"
                                        })
                                    })
                                ]
                            })
                        ]
                    }, record.id))
            }),
            selectedRecord && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "modal-backdrop",
                style: {
                    background: "rgba(15, 23, 42, 0.72)",
                    zIndex: 1000
                },
                onClick: closeModal,
                role: "presentation",
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "tl-review-modal",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "tl-review-modal-title",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("header", {
                            className: "tl-review-modal__header",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                    className: "tl-review-modal__title-block",
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h2", {
                                            id: "tl-review-modal-title",
                                            className: "tl-review-modal__title",
                                            children: selectedRecord.phase_title
                                        }),
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                            className: "tl-review-modal__meta-line",
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                    className: $474b63e98d1f9bbd$var$statusBadgeClass(selectedRecord.status),
                                                    children: $474b63e98d1f9bbd$var$statusBadgeLabel(selectedRecord.status)
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                    className: "tl-review-modal__meta-sep",
                                                    "aria-hidden": true,
                                                    children: "\xb7"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                    children: [
                                                        "Submitted ",
                                                        new Date(selectedRecord.created_at).toLocaleString()
                                                    ]
                                                }),
                                                selectedRecord.actual_start_date ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                            className: "tl-review-modal__meta-sep",
                                                            "aria-hidden": true,
                                                            children: "\xb7"
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                            children: [
                                                                "Site start ",
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                                                    children: selectedRecord.actual_start_date
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--link tl-review-modal__close",
                                    onClick: closeModal,
                                    children: "Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "tl-review-modal__body",
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "tl-review-modal__grid",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "tl-review-modal__media",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                className: "tl-review-modal__hero",
                                                children: mainPhotoSrc ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                                                    src: mainPhotoSrc,
                                                    alt: `Phase photo ${activePhotoIdx + 1}`
                                                }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                    style: {
                                                        color: "#94a3b8",
                                                        fontSize: "0.9rem",
                                                        padding: "2rem"
                                                    },
                                                    children: "No photo attached"
                                                })
                                            }),
                                            modalPhotos.length > 1 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                className: "tl-review-modal__thumbs",
                                                role: "tablist",
                                                "aria-label": "Photos",
                                                children: modalPhotos.map((src, i)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                                        type: "button",
                                                        role: "tab",
                                                        "aria-selected": i === activePhotoIdx,
                                                        "aria-label": `Photo ${i + 1}`,
                                                        className: "tl-review-modal__thumb" + (i === activePhotoIdx ? " tl-review-modal__thumb--active" : ""),
                                                        onClick: ()=>setActivePhotoIdx(i),
                                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("img", {
                                                            src: src,
                                                            alt: ""
                                                        })
                                                    }, i))
                                            }) : null,
                                            selectedRecord.video_data ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("video", {
                                                className: "tl-review-modal__video",
                                                src: selectedRecord.video_data,
                                                controls: true,
                                                playsInline: true
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                        className: "tl-review-modal__side",
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "tl-review-modal__info-card",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                        className: "tl-review-modal__info-label",
                                                        children: "Beneficiary"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                        className: "tl-review-modal__info-name",
                                                        children: selectedRecord.beneficiary_name
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                        className: "tl-review-modal__info-line",
                                                        children: [
                                                            selectedRecord.village,
                                                            ", ",
                                                            selectedRecord.mandal,
                                                            selectedRecord.district ? ` \xb7 ${selectedRecord.district}` : ""
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                                        className: "tl-review-modal__info-mono",
                                                        children: [
                                                            "App ID: ",
                                                            selectedRecord.application_id
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "tl-review-modal__info-card",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                        className: "tl-review-modal__info-label",
                                                        children: "Subcontractor"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                        className: "tl-review-modal__info-name",
                                                        children: selectedRecord.subcontractor_name
                                                    })
                                                ]
                                            }),
                                            notesReadOnly ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "tl-review-modal__info-card",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                        className: "tl-review-modal__info-label",
                                                        children: "Reviewer notes"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                                        className: "tl-review-modal__info-line",
                                                        style: {
                                                            whiteSpace: "pre-wrap",
                                                            margin: 0
                                                        },
                                                        children: selectedRecord.status_notes?.trim() ? selectedRecord.status_notes : "\u2014"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                                className: "tl-review-modal__notes tl-review-modal__info-card",
                                                children: [
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                                        className: "tl-review-modal__info-label",
                                                        htmlFor: "review-notes",
                                                        children: "Reviewer notes (optional)"
                                                    }),
                                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                                        id: "review-notes",
                                                        className: "input",
                                                        rows: 4,
                                                        value: actionNotes,
                                                        onChange: (e)=>setActionNotes(e.target.value),
                                                        placeholder: "Notes for the subcontractor or internal records\u2026"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        (selectedRecord.status === "Submitted" || selectedRecord.status === "Hold") && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("footer", {
                            className: "tl-review-modal__footer",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--danger",
                                    onClick: ()=>void handleAction("Rejected"),
                                    disabled: submittingAction,
                                    children: "Reject"
                                }),
                                selectedRecord.status === "Submitted" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--secondary",
                                    style: {
                                        backgroundColor: "#fef3c7",
                                        borderColor: "#f59e0b",
                                        color: "#b45309"
                                    },
                                    onClick: ()=>void handleAction("Hold"),
                                    disabled: submittingAction,
                                    children: "Hold"
                                }) : null,
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--primary btn--tg",
                                    style: {
                                        backgroundColor: "#15803d",
                                        borderColor: "#15803d"
                                    },
                                    onClick: ()=>void handleAction("Approved"),
                                    disabled: submittingAction,
                                    children: "Approve phase"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}




var $7UyaH = parcelRequire("7UyaH");



// ── helpers ──────────────────────────────────────────────────────────────────
/** Title-case every word: "nagarkurnool" → "Nagarkurnool" */ function $bdc1e5336e5049d6$var$titleCase(s) {
    return s.replace(/\b\w/g, (c)=>c.toUpperCase());
}
function $bdc1e5336e5049d6$var$fmtDate(d) {
    if (!d) return "\u2014";
    return new Date(d + "T00:00:00").toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric"
    });
}
function $bdc1e5336e5049d6$var$addDays(dateStr, days) {
    const d = new Date(dateStr + "T00:00:00");
    d.setDate(d.getDate() + days);
    return d.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric"
    });
}
// ── Schedule card ─────────────────────────────────────────────────────────────
function $bdc1e5336e5049d6$var$ScheduleCard({ schedule: schedule, onEdit: onEdit, onDelete: onDelete, onView: onView }) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "pi-card",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "pi-card__top",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "pi-card__info",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "pi-card__name",
                                children: schedule.name
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                className: "pi-card__date",
                                children: [
                                    "\uD83D\uDCC5 Planned start: ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                        children: $bdc1e5336e5049d6$var$fmtDate(schedule.plannedStartDate)
                                    })
                                ]
                            }),
                            schedule.notes && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "pi-card__notes",
                                children: schedule.notes
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "pi-card__count",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                className: "pi-card__count-num",
                                children: schedule.applicationCount
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                className: "pi-card__count-label",
                                children: [
                                    "beneficiar",
                                    schedule.applicationCount !== 1 ? "ies" : "y"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "pi-card__actions",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--secondary btn--sm",
                        onClick: ()=>onView(schedule.id),
                        children: "View"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--secondary btn--sm",
                        onClick: ()=>onEdit(schedule),
                        children: "Edit"
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "btn btn--secondary btn--sm",
                        style: {
                            color: "#dc2626"
                        },
                        onClick: ()=>onDelete(schedule.id),
                        children: "Delete"
                    })
                ]
            })
        ]
    });
}
// ── Detail drawer ──────────────────────────────────────────────────────────────
function $bdc1e5336e5049d6$var$ScheduleDetailDrawer({ detail: detail, onClose: onClose }) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "pi-drawer",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                className: "pi-drawer__header",
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                className: "pi-drawer__title",
                                children: detail.name
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "pi-drawer__subtitle",
                                children: [
                                    "Planned start: ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                        children: $bdc1e5336e5049d6$var$fmtDate(detail.plannedStartDate)
                                    }),
                                    "\xa0\xb7\xa0",
                                    detail.applicationCount,
                                    " beneficiar",
                                    detail.applicationCount !== 1 ? "ies" : "y"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                        type: "button",
                        className: "pi-drawer__close",
                        onClick: onClose,
                        children: "\u2715"
                    })
                ]
            }),
            detail.notes && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "pi-drawer__notes",
                children: detail.notes
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "table-wrap",
                style: {
                    marginTop: "0.75rem"
                },
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                    className: "data-table",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                        children: "Beneficiary"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                        children: "District"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                        children: "Mandal"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                        children: "Village"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                        children: "Status"
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                        children: "Start Date"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tbody", {
                            children: [
                                detail.applications.map((a)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                style: {
                                                    fontWeight: 500
                                                },
                                                children: a.beneficiaryName || "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                className: "text-muted",
                                                children: $bdc1e5336e5049d6$var$titleCase(a.district)
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                className: "text-muted",
                                                children: $bdc1e5336e5049d6$var$titleCase(a.mandal)
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                className: "text-muted",
                                                children: $bdc1e5336e5049d6$var$titleCase(a.village)
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                    className: "badge badge--pending",
                                                    style: {
                                                        fontSize: "0.7rem"
                                                    },
                                                    children: a.status?.replace(/_/g, " ")
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                children: $bdc1e5336e5049d6$var$fmtDate(a.plannedStartDate)
                                            })
                                        ]
                                    }, a.applicationId)),
                                detail.applications.length === 0 && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                        colSpan: 6,
                                        style: {
                                            textAlign: "center",
                                            color: "#94a3b8",
                                            padding: "1rem"
                                        },
                                        children: "No beneficiaries assigned yet"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function $bdc1e5336e5049d6$var$ScheduleForm({ mode: mode, initial: initial, onSaved: onSaved, onCancel: onCancel }) {
    const [name, setName] = (0, $7UyaH.useState)(initial?.name ?? "");
    const [plannedStartDate, setPlannedStartDate] = (0, $7UyaH.useState)(initial?.plannedStartDate ?? "");
    const [notes, setNotes] = (0, $7UyaH.useState)(initial?.notes ?? "");
    const [saving, setSaving] = (0, $7UyaH.useState)(false);
    const [error, setError] = (0, $7UyaH.useState)(null);
    // Zone groups
    const [zoneGroups, setZoneGroups] = (0, $7UyaH.useState)([]);
    const [zoneGroupId, setZoneGroupId] = (0, $7UyaH.useState)("");
    // Beneficiary picker state
    const [districtFilter, setDistrictFilter] = (0, $7UyaH.useState)("");
    const [mandalFilter, setMandalFilter] = (0, $7UyaH.useState)("");
    const [villageFilter, setVillageFilter] = (0, $7UyaH.useState)("");
    const [searchFilter, setSearchFilter] = (0, $7UyaH.useState)("");
    const [pickerRows, setPickerRows] = (0, $7UyaH.useState)([]);
    const [selectedIds, setSelectedIds] = (0, $7UyaH.useState)(new Set());
    const [pickerLoading, setPickerLoading] = (0, $7UyaH.useState)(false);
    const [pickerError, setPickerError] = (0, $7UyaH.useState)(null);
    const searchTimeout = (0, $7UyaH.useRef)(null);
    // Load zone groups on mount
    (0, $7UyaH.useEffect)(()=>{
        (0, $0bced91eb1ccba4a$export$a75cb04423263638)().then(setZoneGroups).catch(()=>{});
    }, []);
    // Pre-select existing apps when editing
    (0, $7UyaH.useEffect)(()=>{
        if (mode === "edit" && initial?.id) (0, $0bced91eb1ccba4a$export$261b8e6880688d3)(initial.id).then((detail)=>setSelectedIds(new Set(detail.applications.map((a)=>a.applicationId)))).catch(()=>{});
    }, [
        mode,
        initial?.id
    ]);
    // Load picker rows on filter change (debounced)
    (0, $7UyaH.useEffect)(()=>{
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(()=>{
            setPickerLoading(true);
            setPickerError(null);
            (0, $0bced91eb1ccba4a$export$af307dd512f8bb7c)({
                district: districtFilter,
                mandal: mandalFilter,
                village: villageFilter,
                search: searchFilter,
                zoneGroupId: zoneGroupId,
                limit: 500
            }).then(setPickerRows).catch((e)=>setPickerError(e instanceof Error ? e.message : "Failed to load")).finally(()=>setPickerLoading(false));
        }, 300);
    }, [
        districtFilter,
        mandalFilter,
        villageFilter,
        searchFilter,
        zoneGroupId
    ]);
    // When a zone group is selected, auto-select ALL beneficiaries in it
    (0, $7UyaH.useEffect)(()=>{
        if (zoneGroupId && pickerRows.length > 0 && !pickerLoading) setSelectedIds(new Set(pickerRows.map((r)=>r.applicationId)));
    }, [
        zoneGroupId,
        pickerRows,
        pickerLoading
    ]);
    function handleZoneGroupChange(id) {
        setZoneGroupId(id);
        setDistrictFilter("");
        setMandalFilter("");
        setVillageFilter("");
        setSearchFilter("");
        if (!id) setSelectedIds(new Set());
    }
    function toggleAll() {
        if (selectedIds.size === pickerRows.length && pickerRows.length > 0) setSelectedIds(new Set());
        else setSelectedIds(new Set(pickerRows.map((r)=>r.applicationId)));
    }
    function toggle(id) {
        setSelectedIds((prev)=>{
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    }
    // Group zone groups by category for the dropdown
    const zoneGroupsByCategory = zoneGroups.reduce((acc, g)=>{
        const cat = g.categoryName || "General";
        (acc[cat] ??= []).push(g);
        return acc;
    }, {});
    async function handleSubmit(e) {
        e.preventDefault();
        setError(null);
        if (!name.trim()) {
            setError("Schedule name is required");
            return;
        }
        if (!plannedStartDate) {
            setError("Planned start date is required");
            return;
        }
        setSaving(true);
        try {
            const ids = [
                ...selectedIds
            ];
            if (mode === "create") await (0, $0bced91eb1ccba4a$export$5eb11898ebc0a721)({
                name: name,
                plannedStartDate: plannedStartDate,
                notes: notes,
                applicationIds: ids
            });
            else if (initial?.id) await (0, $0bced91eb1ccba4a$export$4bb12da671ea38f9)(initial.id, {
                name: name,
                plannedStartDate: plannedStartDate,
                notes: notes,
                applicationIds: ids
            });
            onSaved();
        } catch (err) {
            setError(err instanceof Error ? err.message : "Save failed");
        } finally{
            setSaving(false);
        }
    }
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("form", {
        className: "pi-form",
        onSubmit: (e)=>void handleSubmit(e),
        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
            className: "pi-form__grid",
            children: [
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "pi-form__details",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                            className: "pi-form__section-title",
                            children: mode === "create" ? "New Project Schedule" : "Edit Schedule"
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "pi-form__field",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "pi-form__label",
                                    children: [
                                        "Schedule name ",
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                    className: "pi-form__input",
                                    value: name,
                                    onChange: (e)=>setName(e.target.value),
                                    placeholder: "e.g. Nizamabad \u2014 Batch A"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "pi-form__field",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("label", {
                                    className: "pi-form__label",
                                    children: [
                                        "Planned start date ",
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                    type: "date",
                                    className: "pi-form__input",
                                    value: plannedStartDate,
                                    onChange: (e)=>setPlannedStartDate(e.target.value)
                                }),
                                plannedStartDate && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                    className: "pi-form__hint",
                                    children: [
                                        "\u2705 Becomes ",
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                            children: "Day 1"
                                        }),
                                        " of the work progress timeline for all selected beneficiaries."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "pi-form__field",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("label", {
                                    className: "pi-form__label",
                                    children: "Notes"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("textarea", {
                                    className: "pi-form__input",
                                    rows: 3,
                                    value: notes,
                                    onChange: (e)=>setNotes(e.target.value),
                                    placeholder: "Optional remarks about this schedule batch"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "pi-form__selected-badge",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "pi-form__selected-count",
                                    children: selectedIds.size
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                    children: [
                                        "beneficiar",
                                        selectedIds.size !== 1 ? "ies" : "y",
                                        " selected"
                                    ]
                                })
                            ]
                        }),
                        error && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                            className: "pi-form__error",
                            children: error
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "pi-form__actions",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "submit",
                                    className: "btn btn--primary",
                                    disabled: saving,
                                    children: saving ? "Saving\u2026" : mode === "create" ? "Create Schedule" : "Save Changes"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "btn btn--secondary",
                                    onClick: onCancel,
                                    disabled: saving,
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                    className: "pi-form__picker",
                    children: [
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                            className: "pi-form__section-title",
                            children: "Select Beneficiaries"
                        }),
                        zoneGroups.length > 0 && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "pi-picker__zone-row",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                    className: "pi-picker__zone-label",
                                    children: "\uD83D\uDCCD Select by group"
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("select", {
                                    className: "pi-picker__zone-select",
                                    value: zoneGroupId,
                                    onChange: (e)=>handleZoneGroupChange(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                            value: "",
                                            children: "\u2014 Pick a zone group \u2014"
                                        }),
                                        Object.entries(zoneGroupsByCategory).map(([cat, groups])=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("optgroup", {
                                                label: cat,
                                                children: groups.map((g)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("option", {
                                                        value: g.id,
                                                        children: g.name
                                                    }, g.id))
                                            }, cat))
                                    ]
                                }),
                                zoneGroupId && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                    type: "button",
                                    className: "pi-picker__zone-clear",
                                    onClick: ()=>handleZoneGroupChange(""),
                                    children: "\u2715 Clear"
                                })
                            ]
                        }),
                        !zoneGroupId && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                            className: "pi-picker__filters",
                            children: [
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $0377fbce5921ee00$export$b3eb1a6c17723c14), {
                                    idPrefix: "pi-picker",
                                    district: districtFilter,
                                    mandal: mandalFilter,
                                    village: villageFilter,
                                    onDistrictChange: (d)=>{
                                        setDistrictFilter(d);
                                        setMandalFilter("");
                                        setVillageFilter("");
                                    },
                                    onMandalChange: (m)=>{
                                        setMandalFilter(m);
                                        setVillageFilter("");
                                    },
                                    onVillageChange: setVillageFilter
                                }),
                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                    placeholder: "Search name\u2026",
                                    value: searchFilter,
                                    onChange: (e)=>setSearchFilter(e.target.value),
                                    style: {
                                        flex: "1 1 8rem"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                            className: "pi-picker__table-wrap",
                            children: pickerLoading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                style: {
                                    padding: "1rem"
                                },
                                children: "Loading\u2026"
                            }) : pickerError ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                style: {
                                    color: "#dc2626",
                                    padding: "1rem"
                                },
                                children: pickerError
                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("table", {
                                className: "data-table data-table--compact",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    style: {
                                                        width: "2.5rem"
                                                    },
                                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: pickerRows.length > 0 && selectedIds.size === pickerRows.length,
                                                        onChange: toggleAll
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Beneficiary"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "District / Mandal"
                                                }),
                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("th", {
                                                    children: "Current Start"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tbody", {
                                        children: [
                                            pickerRows.map((row)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("tr", {
                                                    className: selectedIds.has(row.applicationId) ? "pi-picker__row--selected" : "",
                                                    onClick: ()=>toggle(row.applicationId),
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            onClick: (e)=>e.stopPropagation(),
                                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("input", {
                                                                type: "checkbox",
                                                                checked: selectedIds.has(row.applicationId),
                                                                onChange: ()=>toggle(row.applicationId)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                    style: {
                                                                        fontWeight: 500
                                                                    },
                                                                    children: row.beneficiaryName || "\u2014"
                                                                }),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                    className: "text-muted",
                                                                    style: {
                                                                        fontSize: "0.75rem"
                                                                    },
                                                                    children: row.village
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("td", {
                                                            className: "text-muted",
                                                            style: {
                                                                fontSize: "0.8125rem"
                                                            },
                                                            children: [
                                                                $bdc1e5336e5049d6$var$titleCase(row.district),
                                                                /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("br", {}),
                                                                $bdc1e5336e5049d6$var$titleCase(row.mandal)
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                            style: {
                                                                fontSize: "0.8125rem"
                                                            },
                                                            children: row.plannedStartDate ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("span", {
                                                                children: [
                                                                    $bdc1e5336e5049d6$var$fmtDate(row.plannedStartDate),
                                                                    row.initiationName && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                                                                        className: "text-muted",
                                                                        style: {
                                                                            fontSize: "0.7rem"
                                                                        },
                                                                        children: row.initiationName
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                                                className: "text-muted",
                                                                children: "Not set"
                                                            })
                                                        })
                                                    ]
                                                }, row.applicationId)),
                                            pickerRows.length === 0 && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("td", {
                                                    colSpan: 4,
                                                    style: {
                                                        textAlign: "center",
                                                        color: "#94a3b8",
                                                        padding: "1.5rem"
                                                    },
                                                    children: "No beneficiaries found \u2014 adjust filters above"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function $bdc1e5336e5049d6$export$ea0e02cbe9a70640() {
    const [schedules, setSchedules] = (0, $7UyaH.useState)([]);
    const [loading, setLoading] = (0, $7UyaH.useState)(true);
    const [error, setError] = (0, $7UyaH.useState)(null);
    const [mode, setMode] = (0, $7UyaH.useState)("list");
    const [editTarget, setEditTarget] = (0, $7UyaH.useState)(null);
    const [detailData, setDetailData] = (0, $7UyaH.useState)(null);
    const [detailLoading, setDetailLoading] = (0, $7UyaH.useState)(false);
    async function loadSchedules() {
        setLoading(true);
        setError(null);
        try {
            setSchedules(await (0, $0bced91eb1ccba4a$export$dae64cbfe8074895)());
        } catch (e) {
            setError(e instanceof Error ? e.message : "Failed to load");
        } finally{
            setLoading(false);
        }
    }
    (0, $7UyaH.useEffect)(()=>{
        loadSchedules();
    }, []);
    async function handleDelete(id) {
        if (!confirm("Delete this schedule? The planned start date will be cleared from all assigned beneficiaries.")) return;
        try {
            await (0, $0bced91eb1ccba4a$export$515673d2f21522f0)(id);
            await loadSchedules();
        } catch (e) {
            alert(e instanceof Error ? e.message : "Delete failed");
        }
    }
    async function handleView(id) {
        setDetailLoading(true);
        setMode("detail");
        try {
            setDetailData(await (0, $0bced91eb1ccba4a$export$261b8e6880688d3)(id));
        } catch  {
            setDetailData(null);
            setMode("list");
        } finally{
            setDetailLoading(false);
        }
    }
    function handleEdit(s) {
        setEditTarget(s);
        setMode("edit");
    }
    async function handleSaved() {
        setMode("list");
        setEditTarget(null);
        await loadSchedules();
    }
    // ── KPIs ──
    const totalBeneficiaries = schedules.reduce((s, c)=>s + c.applicationCount, 0);
    const upcoming = schedules.filter((s)=>s.plannedStartDate >= new Date().toISOString().slice(0, 10));
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        className: "page",
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $59972e6b0bfdceeb$export$53f1cd6809577fc5), {
                title: "Project Initiation",
                subtitle: "Set planned start dates for beneficiary groups to anchor the work progress timeline",
                actions: mode === "list" ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                    type: "button",
                    className: "btn btn--primary",
                    onClick: ()=>setMode("create"),
                    children: "+ New Schedule"
                }) : undefined
            }),
            (mode === "create" || mode === "edit") && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($bdc1e5336e5049d6$var$ScheduleForm, {
                mode: mode === "create" ? "create" : "edit",
                initial: editTarget,
                onSaved: ()=>void handleSaved(),
                onCancel: ()=>{
                    setMode("list");
                    setEditTarget(null);
                }
            }),
            mode === "detail" && (detailLoading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                className: "text-muted",
                style: {
                    padding: "1.5rem"
                },
                children: "Loading detail\u2026"
            }) : detailData ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($bdc1e5336e5049d6$var$ScheduleDetailDrawer, {
                detail: detailData,
                onClose: ()=>{
                    setMode("list");
                    setDetailData(null);
                }
            }) : null),
            mode === "list" && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $64174c7064b10992$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "po-reg__kpis",
                        style: {
                            marginBottom: "1.5rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "po-reg__kpi",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "po-reg__kpi-num",
                                        children: schedules.length
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "po-reg__kpi-label",
                                        children: "Schedules"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "po-reg__kpi",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "po-reg__kpi-num",
                                        style: {
                                            color: "#0891b2"
                                        },
                                        children: totalBeneficiaries
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "po-reg__kpi-label",
                                        children: "Beneficiaries"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "po-reg__kpi",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "po-reg__kpi-num",
                                        style: {
                                            color: "#16a34a"
                                        },
                                        children: upcoming.length
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "po-reg__kpi-label",
                                        children: "Upcoming"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                                className: "po-reg__kpi",
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "po-reg__kpi-num",
                                        style: {
                                            color: "#7c3aed"
                                        },
                                        children: schedules.length - upcoming.length
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("span", {
                                        className: "po-reg__kpi-label",
                                        children: "Past / Active"
                                    })
                                ]
                            })
                        ]
                    }),
                    loading ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                        className: "text-muted",
                        style: {
                            padding: "1.5rem"
                        },
                        children: "Loading schedules\u2026"
                    }) : error ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "card card--elevated",
                        style: {
                            padding: "1.25rem",
                            color: "#dc2626"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "Could not load schedules:"
                            }),
                            " ",
                            error
                        ]
                    }) : schedules.length === 0 ? /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "card card--elevated",
                        style: {
                            padding: "2rem",
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                style: {
                                    fontSize: "2.5rem",
                                    marginBottom: "0.5rem"
                                },
                                children: "\uD83D\uDCCB"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                style: {
                                    fontWeight: 600,
                                    marginBottom: "0.25rem"
                                },
                                children: "No schedules yet"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("p", {
                                className: "text-muted",
                                style: {
                                    marginBottom: "1rem"
                                },
                                children: "Create a schedule to assign a planned start date to a group of beneficiaries. The timeline's day count will start from that date."
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("button", {
                                type: "button",
                                className: "btn btn--primary",
                                onClick: ()=>setMode("create"),
                                children: "+ Create first schedule"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                        className: "pi-list",
                        children: schedules.map((s)=>/*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($bdc1e5336e5049d6$var$ScheduleCard, {
                                schedule: s,
                                onEdit: handleEdit,
                                onDelete: (id)=>void handleDelete(id),
                                onView: (id)=>void handleView(id)
                            }, s.id))
                    }),
                    schedules.length > 0 && /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
                        className: "pi-info-box",
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("strong", {
                                children: "\uD83D\uDCC5 How the start date feeds the timeline"
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("p", {
                                children: [
                                    "Once a beneficiary is assigned a ",
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("em", {
                                        children: "planned start date"
                                    }),
                                    ", their Work Progress tab shows phase calendar dates calculated from that anchor. For example, if the start date is ",
                                    $bdc1e5336e5049d6$var$fmtDate(schedules[0]?.plannedStartDate),
                                    " and Phase 1 takes 30 days, Phase 1 is expected to finish by ",
                                    $bdc1e5336e5049d6$var$addDays(schedules[0]?.plannedStartDate ?? new Date().toISOString().slice(0, 10), 30),
                                    "."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



function $5c121a02b943fe91$var$P({ permission: permission, requireAll: requireAll, alsoRequireAll: alsoRequireAll, children: children }) {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $a5f9fb9114046d54$export$c33ee7084643513d), {
        permission: permission,
        requireAll: requireAll,
        alsoRequireAll: alsoRequireAll,
        children: children
    });
}
function $5c121a02b943fe91$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $265aeae2597a9f58$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                path: "/login",
                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $b6e19307d5ae08e2$export$f14c0e3f98d164c0), {})
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                path: "/subcontractor-portal/:token",
                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $08347d735f65d2c6$export$874ded8664bb04c), {})
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $9e9075b70c8a1b9b$export$8ef2ed426dede42d), {}),
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                    element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $f822f2d8933a1325$export$9f3b4d129470fdc3), {}),
                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $6349e701cda54027$export$c84671f46d6a1ca), {}),
                        children: [
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                index: true,
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $72d3cfc7db17b6c0$export$4407be066f39cd0d), {})
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "reports",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "reports",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $48e2a2c54694d2c7$export$1fdf307dd6b0ec16), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "reports/area",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "reports",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $de2781d7b399f7c5$export$8e46eca1ce0566f2), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "geo-tree",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: [
                                        "geo_tree",
                                        "reports"
                                    ],
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $744e572ad2352a6c$export$f41897b6ceff8290), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "leads/import",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
                                    to: "/leads?import=1",
                                    replace: true
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "leads",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: [
                                        "leads",
                                        "leads_import"
                                    ],
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $39c80d2c861a73f3$export$4492245542fbc3ce), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "applications",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: (0, $4aabdb75dcf6b773$export$1499c2a217c417d1),
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $5a2b4fba16b254e8$export$73c91b53927e421e), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "timeline-approvals",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: (0, $4aabdb75dcf6b773$export$1499c2a217c417d1),
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $474b63e98d1f9bbd$export$c79e55f9a3e7ee32), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "project-initiation",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: (0, $4aabdb75dcf6b773$export$1499c2a217c417d1),
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $bdc1e5336e5049d6$export$ea0e02cbe9a70640), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "milestone-master",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "milestone_templates",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $bafe695bf914f48e$export$314de3aac775b4cc), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "construction-timeline-master",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "construction_timeline",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $f6cf58a0c1aaa9dd$export$f1aea5cae31542d), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "standard-resources-master",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "standard_resources",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e7aada4415112cec$export$327e887756d28434), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "zones",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "geo_zones",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $f8d7d882f697b938$export$b9246bfe63eb410f), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "geo-directory",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: [
                                        "geo_directory",
                                        "geo_directory_admin"
                                    ],
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $3bed883fcd09d43d$export$fa5ac397bae91bf1), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "milestones",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: [
                                        "applications",
                                        "milestone_templates"
                                    ],
                                    requireAll: true,
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $25689008152b31ee$export$f10ed0ec243a688c), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "subcontractor-onboarding",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "subcontractor_masters",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $f63bbf83ceaa0aac$export$62128d46d85dab2f), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "engineer-onboarding",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "engineer_masters",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $ad328e6d26f1f2b9$export$54edeae681eb7b81), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "agent-master",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "agents",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $4e24c9f8770af11a$export$f8513ed6e739adcd), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "subcontractor-to-beneficiary",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: (0, $4aabdb75dcf6b773$export$1499c2a217c417d1),
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $8a6ae70d07a85836$export$58495764dc65e71f), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "engineer-to-beneficiary",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: (0, $4aabdb75dcf6b773$export$1499c2a217c417d1),
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
                                        to: "/subcontractor-to-beneficiary",
                                        replace: true
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "inventory/po-register",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "inventory_issue_po",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $466faaf7f5001d36$export$ea440fc09d663f6f), {
                                        section: "po"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "inventory/po-format",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "inventory_issue_po",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $1123febe3e5331be$export$99f03fb932d48fd3), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "inventory/issue-material",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "inventory_issue_material",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $466faaf7f5001d36$export$ea440fc09d663f6f), {
                                        section: "issue"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "inventory/inward",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "inventory_inward",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $cf08e8e171c31603$export$ddf50f3f40e659f0), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "inventory/goods-receipts",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "inventory_goods_receipts",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $91f48421ad887d8b$export$f0310cffb7081843), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "inventory/store-stocks",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "inventory_store_stocks",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $ffd8d70d6d40ad58$export$b3c652e15547d534), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "inventory/store-audit",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "inventory_store_stocks",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $6628e38dabcd836c$export$90d1add2989dbab8), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "inventory/outward",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: [
                                        "inventory_outward",
                                        "inventory_issue_material"
                                    ],
                                    requireAll: true,
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $c37c630ddc5233f9$export$1b0fbbf48a13b5ef), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "inventory/stores-yards",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "inventory_stores_yards",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $f22caf1cf81c9c4c$export$f9f9e4986c335ce2), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "bills/inward",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "bills_inward",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $a78dc66b5570f421$export$7edcbc4514f9bffd), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "bills/inward/format",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "bills_inward",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $772f7392f7d83c73$export$1469c8e425f39bb8), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "bills/labour-suppliers",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "bills_inward",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $fd48466b252a00d6$export$f9444343c6dbd5e3), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "bills/outward",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "bills_outward",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $9e17c29da680e410$export$ad75aefabe253746), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "subcontractor-to-beneficiary/:id",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: (0, $4aabdb75dcf6b773$export$1499c2a217c417d1),
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $9cd5f4ec856deb63$export$9fc6857dde1a395), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "console-users",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "console_users",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $9771d1fd83e2b1ce$export$bd7d5434d15e712e), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "audit-log",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: "audit_log",
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $7e7ddf1c90cc8b31$export$a99ba50f5b455b98), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "applications/:id",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                    permission: (0, $4aabdb75dcf6b773$export$1499c2a217c417d1),
                                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $c32045b0952ded9f$export$e4eeea04c135882f), {})
                                }),
                                children: [
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
                                            to: "overview",
                                            replace: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                        path: "overview",
                                        element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                            permission: [
                                                "applications",
                                                "dossier_tab_overview"
                                            ],
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $fa46e63be9c20beb$export$6f4392fd3b9b5804), {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                        path: "beneficiary",
                                        element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                            permission: [
                                                "applications",
                                                "dossier_tab_beneficiary"
                                            ],
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $4155f5d8f4fed208$export$ea21143fc08cf080), {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                        path: "validation",
                                        element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                            permission: [
                                                "applications",
                                                "dossier_tab_validation"
                                            ],
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e8008bc9950c8a77$export$e2083a0aff1d7813), {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                        path: "banking",
                                        element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                            permission: [
                                                "applications",
                                                "dossier_tab_banking"
                                            ],
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $abc550f721019dc4$export$a354b9e186a39f3b), {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                        path: "subcontractor",
                                        element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                            permission: [
                                                "applications",
                                                "dossier_tab_subcontractor"
                                            ],
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $7c02e20ae23ac506$export$abca29eec3bdbd9d), {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                        path: "engineer",
                                        element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                            permission: [
                                                "applications",
                                                "dossier_tab_engineer"
                                            ],
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $1b3404e28c16b77d$export$80471bd65e30ac2f), {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                        path: "milestones",
                                        element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                            permission: [
                                                "applications",
                                                "dossier_tab_milestones"
                                            ],
                                            alsoRequireAll: [
                                                "milestone_templates"
                                            ],
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $3ac7a48441ad9014$export$c9202ba29b1b038c), {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                        path: "bills",
                                        element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                            permission: [
                                                "applications",
                                                "dossier_tab_bills"
                                            ],
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $29954f24db05ed49$export$128d59be05bb2760), {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                        path: "work-progress",
                                        element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                            permission: [
                                                "applications",
                                                "dossier_tab_work_progress"
                                            ],
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $c7240461df7259b1$export$d395bb482f7c143f), {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                        path: "po-register",
                                        element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)($5c121a02b943fe91$var$P, {
                                            permission: [
                                                "applications",
                                                "dossier_tab_po_register"
                                            ],
                                            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $96c75e513c969897$export$9bb4affacc3a134e), {})
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$e7b0ac011bb776c6), {
                                path: "*",
                                element: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $265aeae2597a9f58$export$444b3ab0cb9aec40), {
                                    to: "/",
                                    replace: true
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}






var $7UyaH = parcelRequire("7UyaH");
// Track active requests
let $60d62de4439ab90f$var$activeRequests = 0;
let $60d62de4439ab90f$var$timeoutId = null;
const $60d62de4439ab90f$var$originalFetch = window.fetch;
window.fetch = async (...args)=>{
    $60d62de4439ab90f$var$activeRequests++;
    window.dispatchEvent(new CustomEvent("globalLoadingChange", {
        detail: $60d62de4439ab90f$var$activeRequests > 0
    }));
    try {
        const response = await $60d62de4439ab90f$var$originalFetch(...args);
        return response;
    } finally{
        $60d62de4439ab90f$var$activeRequests = Math.max(0, $60d62de4439ab90f$var$activeRequests - 1);
        window.dispatchEvent(new CustomEvent("globalLoadingChange", {
            detail: $60d62de4439ab90f$var$activeRequests > 0
        }));
    }
};
const $60d62de4439ab90f$export$3a4e070ae82595fc = ()=>{
    const [isLoading, setIsLoading] = (0, $7UyaH.useState)(false);
    const [showOverlay, setShowOverlay] = (0, $7UyaH.useState)(false);
    (0, $7UyaH.useEffect)(()=>{
        const handleLoadingChange = (e)=>{
            setIsLoading(e.detail);
        };
        window.addEventListener("globalLoadingChange", handleLoadingChange);
        return ()=>{
            window.removeEventListener("globalLoadingChange", handleLoadingChange);
        };
    }, []);
    (0, $7UyaH.useEffect)(()=>{
        if (isLoading) // Show overlay only if loading takes more than 300ms to avoid flashing
        $60d62de4439ab90f$var$timeoutId = setTimeout(()=>{
            setShowOverlay(true);
        }, 300);
        else {
            if ($60d62de4439ab90f$var$timeoutId) clearTimeout($60d62de4439ab90f$var$timeoutId);
            setShowOverlay(false);
        }
        return ()=>{
            if ($60d62de4439ab90f$var$timeoutId) clearTimeout($60d62de4439ab90f$var$timeoutId);
        };
    }, [
        isLoading
    ]);
    if (!showOverlay) return null;
    return /*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)("div", {
        style: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 99999,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            backdropFilter: "blur(2px)"
        },
        children: [
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("div", {
                className: "spinner",
                style: {
                    width: "3rem",
                    height: "3rem",
                    borderWidth: "4px",
                    borderColor: "rgba(0,0,0,0.1)",
                    borderTopColor: "var(--tg-primary, #0056b3)"
                }
            }),
            /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)("h3", {
                style: {
                    marginTop: "1rem",
                    color: "var(--tg-primary, #0056b3)",
                    fontWeight: 600
                },
                children: "Loading, please wait..."
            })
        ]
    });
};


const $d7ff3ee147cb4273$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($8878dcfc7f5ecb45$exports))).createRoot(document.getElementById("root"));
$d7ff3ee147cb4273$var$root.render(/*#__PURE__*/ (0, $64174c7064b10992$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($7UyaH))).StrictMode, {
    children: [
        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $60d62de4439ab90f$export$3a4e070ae82595fc), {}),
        /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $e651fdaba0d48e3d$export$9ba4e89fdfa1fc54), {
            future: {
                v7_startTransition: true,
                v7_relativeSplatPath: true
            },
            children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $62ce12c72c1ea784$export$f5d03d415824e0e), {
                children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $a4dc0d923ddf5b19$export$87091915187a1a85), {
                    children: /*#__PURE__*/ (0, $64174c7064b10992$exports.jsx)((0, $5c121a02b943fe91$export$2e2bcd8739ae039), {})
                })
            })
        })
    ]
}));


//# sourceMappingURL=client.693a1234.js.map
